/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 446);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["jQuery"] = __webpack_require__(282);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [];

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	styleElement.type = "text/css";
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	linkElement.rel = "stylesheet";
	insertStyleElement(options, linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(28);
module.exports = angular;


/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_stylesheets_application_scss__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_stylesheets_application_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_stylesheets_application_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__editor_components_common_htmlcompiler_directive_coffee__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__editor_components_common_htmlcompiler_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__editor_components_common_htmlcompiler_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editor_components_common_main_coffee__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editor_components_common_main_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__editor_components_common_main_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editor_api_email_coffee__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editor_api_email_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__editor_api_email_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editor_api_font_coffee__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editor_api_font_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__editor_api_font_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__editor_api_page_coffee__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__editor_api_page_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__editor_api_page_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__editor_api_section__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__editor_api_section___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__editor_api_section__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__editor_api_template__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__editor_api_template___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__editor_api_template__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__editor_api_widget_coffee__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__editor_api_widget_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__editor_api_widget_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__editor_api_sectionemail_coffee__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__editor_api_sectionemail_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__editor_api_sectionemail_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__editor_api_webform_coffee__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__editor_api_webform_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__editor_api_webform_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__editor_api_sectionwebform_coffee__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__editor_api_sectionwebform_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__editor_api_sectionwebform_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__editor_api_lesson__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__editor_api_lesson___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__editor_api_lesson__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__editor_api_sectionLesson__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__editor_api_sectionLesson___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__editor_api_sectionLesson__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__editor_api_main__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__editor_api_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__editor_api_main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__editor_services_editorNamespace_coffee__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__editor_services_editorNamespace_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__editor_services_editorNamespace_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__editor_services_layout_editor_animations_coffee__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__editor_services_layout_editor_animations_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__editor_services_layout_editor_animations_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__editor_services_layout_editor_blockDragDrop__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__editor_services_layout_editor_blockDragDrop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__editor_services_layout_editor_blockDragDrop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__editor_services_layout_editor_blockDragScroll_coffee__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__editor_services_layout_editor_blockDragScroll_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__editor_services_layout_editor_blockDragScroll_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__editor_services_layout_editor_blockDropOverlays__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__editor_services_layout_editor_blockDropOverlays___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__editor_services_layout_editor_blockDropOverlays__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__editor_services_layout_editor_blockEditDialog__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__editor_services_layout_editor_blockEditDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__editor_services_layout_editor_blockEditDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__editor_services_layout_editor_blockOverlays_coffee__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__editor_services_layout_editor_blockOverlays_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__editor_services_layout_editor_blockOverlays_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__editor_services_layout_editor_blocksBuilder_coffee__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__editor_services_layout_editor_blocksBuilder_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__editor_services_layout_editor_blocksBuilder_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__editor_services_layout_editor_editorDragPanel__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__editor_services_layout_editor_editorDragPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__editor_services_layout_editor_editorDragPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__editor_services_layout_editor_insertBlockMenu__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__editor_services_layout_editor_insertBlockMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__editor_services_layout_editor_insertBlockMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__editor_services_layout_editor_insertSpace_coffee__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__editor_services_layout_editor_insertSpace_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__editor_services_layout_editor_insertSpace_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__editor_services_layout_editor_layoutEditor__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__editor_services_layout_editor_layoutEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__editor_services_layout_editor_layoutEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__editor_services_layout_editor_sectionDragDrop__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__editor_services_layout_editor_sectionDragDrop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__editor_services_layout_editor_sectionDragDrop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__editor_services_layout_editor_timemachine_timeActs_js__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__editor_services_layout_editor_timemachine_timeActs_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__editor_services_layout_editor_timemachine_timeActs_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__editor_services_layout_editor_timemachine_timemachine_js__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__editor_services_layout_editor_timemachine_timemachine_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__editor_services_layout_editor_timemachine_timemachine_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__editor_services_layout_editor_tutorials_coffee__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__editor_services_layout_editor_tutorials_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__editor_services_layout_editor_tutorials_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__editor_editor_nav_sections_sections_service__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__editor_editor_nav_sections_sections_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__editor_editor_nav_sections_sections_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__editor_services_main_coffee__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__editor_services_main_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__editor_services_main_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__editor_modules_settings_alignment_align_directive_coffee__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__editor_modules_settings_alignment_align_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__editor_modules_settings_alignment_align_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__editor_modules_settings_hover_hover_directive_coffee__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__editor_modules_settings_hover_hover_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__editor_modules_settings_hover_hover_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__editor_modules_settings_bgfields_bgFields_directive_coffee__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__editor_modules_settings_bgfields_bgFields_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__editor_modules_settings_bgfields_bgFields_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__editor_modules_settings_border_border_directive_coffee__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__editor_modules_settings_border_border_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__editor_modules_settings_border_border_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__editor_modules_settings_buttonActions_buttonActions_directive__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__editor_modules_settings_buttonActions_buttonActions_directive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__editor_modules_settings_buttonActions_buttonActions_directive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__editor_modules_settings_card_card_directive_coffee__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__editor_modules_settings_card_card_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__editor_modules_settings_card_card_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__editor_modules_settings_color_color_directive_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__editor_modules_settings_color_color_directive_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__editor_modules_settings_color_color_directive_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__editor_modules_settings_color_jquery_colorpicker_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__editor_modules_settings_color_jquery_colorpicker_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__editor_modules_settings_color_jquery_colorpicker_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__editor_modules_settings_color_main_coffee__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__editor_modules_settings_color_main_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__editor_modules_settings_color_main_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__editor_modules_settings_color_minicolors_directive_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__editor_modules_settings_color_minicolors_directive_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__editor_modules_settings_color_minicolors_directive_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__editor_modules_settings_colors_colors_directive_coffee__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__editor_modules_settings_colors_colors_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__editor_modules_settings_colors_colors_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__editor_modules_settings_form_form_directive_coffee__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__editor_modules_settings_form_form_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__editor_modules_settings_form_form_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__editor_modules_settings_formfields_formfields_directive_coffee__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__editor_modules_settings_formfields_formfields_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__editor_modules_settings_formfields_formfields_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__editor_modules_settings_facebookComment_facebookComment_directive__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__editor_modules_settings_facebookComment_facebookComment_directive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__editor_modules_settings_facebookComment_facebookComment_directive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__editor_modules_settings_subscribeForm_subscribeForm_directive__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__editor_modules_settings_subscribeForm_subscribeForm_directive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__editor_modules_settings_subscribeForm_subscribeForm_directive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__editor_modules_settings_subscribeFormfields_subscribeFormfields_directive_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__editor_modules_settings_subscribeFormfields_subscribeFormfields_directive_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__editor_modules_settings_subscribeFormfields_subscribeFormfields_directive_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__editor_modules_settings_galleryfields_galleryfields_directive_coffee__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__editor_modules_settings_galleryfields_galleryfields_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__editor_modules_settings_galleryfields_galleryfields_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__editor_modules_settings_gradient_gradient_directive_coffee__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__editor_modules_settings_gradient_gradient_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__editor_modules_settings_gradient_gradient_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__editor_modules_settings_height_height_directive_coffee__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__editor_modules_settings_height_height_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__editor_modules_settings_height_height_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__editor_modules_settings_image_image_directive_coffee__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__editor_modules_settings_image_image_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__editor_modules_settings_image_image_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__editor_modules_settings_link_link_directive_coffee__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__editor_modules_settings_link_link_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__editor_modules_settings_link_link_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__editor_modules_settings_listfields_listfields_directive_coffee__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__editor_modules_settings_listfields_listfields_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__editor_modules_settings_listfields_listfields_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__editor_modules_settings_map_map_directive_coffee__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__editor_modules_settings_map_map_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__editor_modules_settings_map_map_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__editor_modules_settings_modalWysiwyg_modalWysiwyg_directive_coffee__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__editor_modules_settings_modalWysiwyg_modalWysiwyg_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__editor_modules_settings_modalWysiwyg_modalWysiwyg_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__editor_modules_settings_navigationfields_navigationfields_directive__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__editor_modules_settings_navigationfields_navigationfields_directive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__editor_modules_settings_navigationfields_navigationfields_directive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__editor_modules_settings_news_news_directive_coffee__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__editor_modules_settings_news_news_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__editor_modules_settings_news_news_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__editor_modules_settings_padding_padding_directive_coffee__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__editor_modules_settings_padding_padding_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__editor_modules_settings_padding_padding_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__editor_modules_settings_margin_margin_directive__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__editor_modules_settings_margin_margin_directive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__editor_modules_settings_margin_margin_directive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__editor_modules_settings_shadow_shadow_directive__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__editor_modules_settings_shadow_shadow_directive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__editor_modules_settings_shadow_shadow_directive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__editor_modules_settings_photo_library_photo_library_controller__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__editor_modules_settings_photo_library_photo_library_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__editor_modules_settings_photo_library_photo_library_controller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__editor_modules_settings_photo_library_photo_library_directive__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__editor_modules_settings_photo_library_photo_library_directive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__editor_modules_settings_photo_library_photo_library_directive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__editor_modules_settings_productfields_productfields_directive__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__editor_modules_settings_productfields_productfields_directive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__editor_modules_settings_productfields_productfields_directive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__editor_modules_settings_radius_radius_directive_coffee__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__editor_modules_settings_radius_radius_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__editor_modules_settings_radius_radius_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__editor_modules_settings_reviewfields_reviewsfields_directive_coffee__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__editor_modules_settings_reviewfields_reviewsfields_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__editor_modules_settings_reviewfields_reviewsfields_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__editor_modules_settings_siteBgSettings_sitebgsettings_directive_coffee__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__editor_modules_settings_siteBgSettings_sitebgsettings_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__editor_modules_settings_siteBgSettings_sitebgsettings_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__editor_modules_settings_size_size_directive_coffee__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__editor_modules_settings_size_size_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__editor_modules_settings_size_size_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__editor_modules_settings_sizeSelect_sizeSelect_directive_coffee__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__editor_modules_settings_sizeSelect_sizeSelect_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__editor_modules_settings_sizeSelect_sizeSelect_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__editor_modules_settings_sliderfields_sliderfields_directive_coffee__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__editor_modules_settings_sliderfields_sliderfields_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__editor_modules_settings_sliderfields_sliderfields_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__editor_modules_settings_sliderSize_sliderSize_directive_coffee__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__editor_modules_settings_sliderSize_sliderSize_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__editor_modules_settings_sliderSize_sliderSize_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__editor_modules_settings_socialfields_socialfields_directive_coffee__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__editor_modules_settings_socialfields_socialfields_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__editor_modules_settings_socialfields_socialfields_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__editor_modules_settings_tablefields_tablefields_directive_coffee__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__editor_modules_settings_tablefields_tablefields_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__editor_modules_settings_tablefields_tablefields_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__editor_modules_settings_timer_timer_directive__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__editor_modules_settings_timer_timer_directive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74__editor_modules_settings_timer_timer_directive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__editor_modules_settings_uploader_uploader_directive__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__editor_modules_settings_uploader_uploader_directive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75__editor_modules_settings_uploader_uploader_directive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__editor_modules_settings_valignment_valign_directive_coffee__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__editor_modules_settings_valignment_valign_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76__editor_modules_settings_valignment_valign_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__editor_modules_settings_width_width_directive_coffee__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__editor_modules_settings_width_width_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77__editor_modules_settings_width_width_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__editor_modules_settings_icon_icon_directive__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__editor_modules_settings_icon_icon_directive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78__editor_modules_settings_icon_icon_directive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__editor_modules_settings_main_coffee__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__editor_modules_settings_main_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79__editor_modules_settings_main_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__editor_editorLibrary__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__editor_editorLibrary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80__editor_editorLibrary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__editor_editor_controller__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__editor_editor_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81__editor_editor_controller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__editor_editorEmail_controller_coffee__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__editor_editorEmail_controller_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82__editor_editorEmail_controller_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__editor_editorForm_controller_coffee__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__editor_editorForm_controller_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83__editor_editorForm_controller_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__editor_editorLesson_controller__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__editor_editorLesson_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84__editor_editorLesson_controller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__editor_editorPanel_controller_coffee__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__editor_editorPanel_controller_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85__editor_editorPanel_controller_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__editor_editor_nav_editorNav_controller__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__editor_editor_nav_editorNav_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86__editor_editor_nav_editorNav_controller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__editor_editor_nav_sections_sections_controller__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__editor_editor_nav_sections_sections_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87__editor_editor_nav_sections_sections_controller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__editor_pageSettings_controller_coffee__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__editor_pageSettings_controller_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88__editor_pageSettings_controller_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__editor_blockEditDialog_controller__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__editor_blockEditDialog_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89__editor_blockEditDialog_controller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__editor_font_settings_fontSettings_controller_coffee__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__editor_font_settings_fontSettings_controller_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90__editor_font_settings_fontSettings_controller_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__editor_alertEditDialog_controller_coffee__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__editor_alertEditDialog_controller_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91__editor_alertEditDialog_controller_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__editor_email_settings_create_controller_coffee__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__editor_email_settings_create_controller_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92__editor_email_settings_create_controller_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__editor_email_settings_edit_controller_coffee__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__editor_email_settings_edit_controller_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_93__editor_email_settings_edit_controller_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__editor_section_settings_create_controller_coffee__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__editor_section_settings_create_controller_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_94__editor_section_settings_create_controller_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__editor_section_settings_edit_controller_coffee__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__editor_section_settings_edit_controller_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_95__editor_section_settings_edit_controller_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__editor_modules_settings_navigationfields_link_create_controller__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__editor_modules_settings_navigationfields_link_create_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_96__editor_modules_settings_navigationfields_link_create_controller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__editor_modules_settings_navigationfields_link_update_controller__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__editor_modules_settings_navigationfields_link_update_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_97__editor_modules_settings_navigationfields_link_update_controller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__editor_section_settings_create_favorite_controller__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__editor_section_settings_create_favorite_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_98__editor_section_settings_create_favorite_controller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__editor_main_coffee__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__editor_main_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_99__editor_main_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__editor_section_initializers_bgSlideShow_bgSlideShow_initializer_coffee__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__editor_section_initializers_bgSlideShow_bgSlideShow_initializer_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_100__editor_section_initializers_bgSlideShow_bgSlideShow_initializer_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__editor_section_initializers_contentAnimate_contentAnimate_initializer_coffee__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__editor_section_initializers_contentAnimate_contentAnimate_initializer_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_101__editor_section_initializers_contentAnimate_contentAnimate_initializer_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__editor_section_initializers_parallax_parallax_initializer_coffee__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__editor_section_initializers_parallax_parallax_initializer_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_102__editor_section_initializers_parallax_parallax_initializer_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__editor_widget_initializers_contentEditable_contentEditable_initializer__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__editor_widget_initializers_contentEditable_contentEditable_initializer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_103__editor_widget_initializers_contentEditable_contentEditable_initializer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__editor_widget_initializers_map_map_initializer_coffee__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__editor_widget_initializers_map_map_initializer_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_104__editor_widget_initializers_map_map_initializer_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__editor_widget_initializers_buttonActions_buttonActions_initializer__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__editor_widget_initializers_buttonActions_buttonActions_initializer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_105__editor_widget_initializers_buttonActions_buttonActions_initializer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__editor_widget_initializers_image_image_initializer__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__editor_widget_initializers_image_image_initializer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_106__editor_widget_initializers_image_image_initializer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__editor_widget_initializers_slider_slider_initializer_js__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__editor_widget_initializers_slider_slider_initializer_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_107__editor_widget_initializers_slider_slider_initializer_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__editor_widget_initializers_spacer_spacer_initializer_coffee__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__editor_widget_initializers_spacer_spacer_initializer_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_108__editor_widget_initializers_spacer_spacer_initializer_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__editor_widget_initializers_timer_timer_initializer__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__editor_widget_initializers_timer_timer_initializer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_109__editor_widget_initializers_timer_timer_initializer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__editor_widget_initializers_form_form_initializer_coffee__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__editor_widget_initializers_form_form_initializer_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_110__editor_widget_initializers_form_form_initializer_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__editor_widget_initializers_subscribe_form_subscribeForm_initializer_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__editor_widget_initializers_subscribe_form_subscribeForm_initializer_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_111__editor_widget_initializers_subscribe_form_subscribeForm_initializer_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__editor_widget_initializers_wysiwyg_wysiwyg_initializer__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__editor_widget_initializers_wysiwyg_wysiwyg_initializer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_112__editor_widget_initializers_wysiwyg_wysiwyg_initializer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__editor_widget_initializers_wysiwyg_ckeditor_js__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__editor_widget_initializers_wysiwyg_ckeditor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_113__editor_widget_initializers_wysiwyg_ckeditor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__editor_widget_initializers_wysiwyg_ckeditor_lang_en_au_coffee__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__editor_widget_initializers_wysiwyg_ckeditor_lang_en_au_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_114__editor_widget_initializers_wysiwyg_ckeditor_lang_en_au_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__editor_widget_initializers_wysiwyg_ckeditor_lang_en_coffee__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__editor_widget_initializers_wysiwyg_ckeditor_lang_en_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_115__editor_widget_initializers_wysiwyg_ckeditor_lang_en_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__editor_widget_initializers_wysiwyg_ckeditor_lang_ru_coffee__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__editor_widget_initializers_wysiwyg_ckeditor_lang_ru_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_116__editor_widget_initializers_wysiwyg_ckeditor_lang_ru_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__editor_widget_initializers_wysiwyg_ckeditor_lang_bg_coffee__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__editor_widget_initializers_wysiwyg_ckeditor_lang_bg_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_117__editor_widget_initializers_wysiwyg_ckeditor_lang_bg_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__editor_widget_initializers_wysiwyg_ckeditor_lang_es_coffee__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__editor_widget_initializers_wysiwyg_ckeditor_lang_es_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_118__editor_widget_initializers_wysiwyg_ckeditor_lang_es_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__editor_widget_initializers_wysiwyg_ckeditor_lang_ja_coffee__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__editor_widget_initializers_wysiwyg_ckeditor_lang_ja_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_119__editor_widget_initializers_wysiwyg_ckeditor_lang_ja_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__editor_widget_initializers_wysiwyg_ckeditor_lang_it_coffee__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__editor_widget_initializers_wysiwyg_ckeditor_lang_it_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_120__editor_widget_initializers_wysiwyg_ckeditor_lang_it_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__editor_widget_initializers_wysiwyg_ckeditor_lang_ro_coffee__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__editor_widget_initializers_wysiwyg_ckeditor_lang_ro_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_121__editor_widget_initializers_wysiwyg_ckeditor_lang_ro_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__editor_widget_initializers_wysiwyg_ckeditor_lang_th_coffee__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__editor_widget_initializers_wysiwyg_ckeditor_lang_th_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_122__editor_widget_initializers_wysiwyg_ckeditor_lang_th_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__editor_widget_initializers_wysiwyg_ckeditor_lang_vn_coffee__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__editor_widget_initializers_wysiwyg_ckeditor_lang_vn_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_123__editor_widget_initializers_wysiwyg_ckeditor_lang_vn_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__editor_widget_initializers_wysiwyg_ckeditor_styles_coffee__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__editor_widget_initializers_wysiwyg_ckeditor_styles_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_124__editor_widget_initializers_wysiwyg_ckeditor_styles_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__editor_widget_initializers_wysiwyg_ckeditor_ckeditor_config_coffee__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__editor_widget_initializers_wysiwyg_ckeditor_ckeditor_config_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_125__editor_widget_initializers_wysiwyg_ckeditor_ckeditor_config_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__editor_widget_initializers_wysiwyg_ckeditor_plugins_alignment_plugin_js__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__editor_widget_initializers_wysiwyg_ckeditor_plugins_alignment_plugin_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_126__editor_widget_initializers_wysiwyg_ckeditor_plugins_alignment_plugin_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__editor_widget_initializers_wysiwyg_ckeditor_plugins_blocksettings_plugin_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__editor_widget_initializers_wysiwyg_ckeditor_plugins_blocksettings_plugin_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_127__editor_widget_initializers_wysiwyg_ckeditor_plugins_blocksettings_plugin_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__editor_widget_initializers_wysiwyg_ckeditor_plugins_colortext_plugin_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__editor_widget_initializers_wysiwyg_ckeditor_plugins_colortext_plugin_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_128__editor_widget_initializers_wysiwyg_ckeditor_plugins_colortext_plugin_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__editor_widget_initializers_wysiwyg_ckeditor_plugins_confighelper_plugin_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__editor_widget_initializers_wysiwyg_ckeditor_plugins_confighelper_plugin_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_129__editor_widget_initializers_wysiwyg_ckeditor_plugins_confighelper_plugin_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__editor_widget_initializers_wysiwyg_ckeditor_plugins_customlink_plugin_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__editor_widget_initializers_wysiwyg_ckeditor_plugins_customlink_plugin_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_130__editor_widget_initializers_wysiwyg_ckeditor_plugins_customlink_plugin_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontfamily_plugin_js__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontfamily_plugin_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_131__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontfamily_plugin_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontsize_plugin_js__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontsize_plugin_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_132__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontsize_plugin_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_plugin_js__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_plugin_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_133__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_plugin_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__editor_widget_initializers_wysiwyg_ckeditor_plugins_justify_plugin_js__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__editor_widget_initializers_wysiwyg_ckeditor_plugins_justify_plugin_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_134__editor_widget_initializers_wysiwyg_ckeditor_plugins_justify_plugin_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__editor_widget_initializers_wysiwyg_ckeditor_plugins_lineheight_plugin_js__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__editor_widget_initializers_wysiwyg_ckeditor_plugins_lineheight_plugin_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_135__editor_widget_initializers_wysiwyg_ckeditor_plugins_lineheight_plugin_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_plugin_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_plugin_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_136__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_plugin_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__editor_widget_initializers_wysiwyg_ckeditor_plugins_link_dialogs_anchor_js__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__editor_widget_initializers_wysiwyg_ckeditor_plugins_link_dialogs_anchor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_137__editor_widget_initializers_wysiwyg_ckeditor_plugins_link_dialogs_anchor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__editor_widget_initializers_wysiwyg_ckeditor_plugins_link_dialogs_link_js__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__editor_widget_initializers_wysiwyg_ckeditor_plugins_link_dialogs_link_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_138__editor_widget_initializers_wysiwyg_ckeditor_plugins_link_dialogs_link_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__editor_widget_initializers_wysiwyg_ckeditor_plugins_panelbutton_plugin_js__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__editor_widget_initializers_wysiwyg_ckeditor_plugins_panelbutton_plugin_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_139__editor_widget_initializers_wysiwyg_ckeditor_plugins_panelbutton_plugin_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__editor_widget_initializers_wysiwyg_ckeditor_plugins_justify_lang_en_js__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__editor_widget_initializers_wysiwyg_ckeditor_plugins_justify_lang_en_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_140__editor_widget_initializers_wysiwyg_ckeditor_plugins_justify_lang_en_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__editor_widget_initializers_wysiwyg_ckeditor_plugins_justify_lang_es_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__editor_widget_initializers_wysiwyg_ckeditor_plugins_justify_lang_es_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_141__editor_widget_initializers_wysiwyg_ckeditor_plugins_justify_lang_es_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__editor_widget_initializers_wysiwyg_ckeditor_plugins_justify_lang_ja_js__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__editor_widget_initializers_wysiwyg_ckeditor_plugins_justify_lang_ja_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_142__editor_widget_initializers_wysiwyg_ckeditor_plugins_justify_lang_ja_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__editor_widget_initializers_wysiwyg_ckeditor_plugins_justify_lang_ru_js__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__editor_widget_initializers_wysiwyg_ckeditor_plugins_justify_lang_ru_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_143__editor_widget_initializers_wysiwyg_ckeditor_plugins_justify_lang_ru_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontsize_lang_en_js__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontsize_lang_en_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_144__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontsize_lang_en_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontsize_lang_es_js__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontsize_lang_es_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_145__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontsize_lang_es_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontsize_lang_ja_js__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontsize_lang_ja_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_146__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontsize_lang_ja_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontsize_lang_ru_js__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontsize_lang_ru_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_147__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontsize_lang_ru_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__editor_widget_initializers_wysiwyg_ckeditor_plugins_lineheight_lang_en_js__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__editor_widget_initializers_wysiwyg_ckeditor_plugins_lineheight_lang_en_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_148__editor_widget_initializers_wysiwyg_ckeditor_plugins_lineheight_lang_en_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__editor_widget_initializers_wysiwyg_ckeditor_plugins_lineheight_lang_es_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__editor_widget_initializers_wysiwyg_ckeditor_plugins_lineheight_lang_es_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_149__editor_widget_initializers_wysiwyg_ckeditor_plugins_lineheight_lang_es_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__editor_widget_initializers_wysiwyg_ckeditor_plugins_lineheight_lang_ja_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__editor_widget_initializers_wysiwyg_ckeditor_plugins_lineheight_lang_ja_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_150__editor_widget_initializers_wysiwyg_ckeditor_plugins_lineheight_lang_ja_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__editor_widget_initializers_wysiwyg_ckeditor_plugins_lineheight_lang_fr_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__editor_widget_initializers_wysiwyg_ckeditor_plugins_lineheight_lang_fr_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_151__editor_widget_initializers_wysiwyg_ckeditor_plugins_lineheight_lang_fr_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__editor_widget_initializers_wysiwyg_ckeditor_plugins_lineheight_lang_LANG_js__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__editor_widget_initializers_wysiwyg_ckeditor_plugins_lineheight_lang_LANG_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_152__editor_widget_initializers_wysiwyg_ckeditor_plugins_lineheight_lang_LANG_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontfamily_lang_bg_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontfamily_lang_bg_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_153__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontfamily_lang_bg_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontfamily_lang_es_js__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontfamily_lang_es_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_154__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontfamily_lang_es_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontfamily_lang_it_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontfamily_lang_it_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_155__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontfamily_lang_it_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontfamily_lang_ja_js__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontfamily_lang_ja_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_156__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontfamily_lang_ja_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontfamily_lang_ro_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontfamily_lang_ro_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_157__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontfamily_lang_ro_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontfamily_lang_th_js__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontfamily_lang_th_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_158__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontfamily_lang_th_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontfamily_lang_vn_js__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontfamily_lang_vn_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_159__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontfamily_lang_vn_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontfamily_lang_en_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontfamily_lang_en_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_160__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontfamily_lang_en_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontfamily_lang_ru_js__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontfamily_lang_ru_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_161__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontfamily_lang_ru_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162__editor_widget_initializers_wysiwyg_ckeditor_plugins_colortext_lang_bg_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162__editor_widget_initializers_wysiwyg_ckeditor_plugins_colortext_lang_bg_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_162__editor_widget_initializers_wysiwyg_ckeditor_plugins_colortext_lang_bg_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163__editor_widget_initializers_wysiwyg_ckeditor_plugins_colortext_lang_es_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163__editor_widget_initializers_wysiwyg_ckeditor_plugins_colortext_lang_es_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_163__editor_widget_initializers_wysiwyg_ckeditor_plugins_colortext_lang_es_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_164__editor_widget_initializers_wysiwyg_ckeditor_plugins_colortext_lang_it_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_164__editor_widget_initializers_wysiwyg_ckeditor_plugins_colortext_lang_it_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_164__editor_widget_initializers_wysiwyg_ckeditor_plugins_colortext_lang_it_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_165__editor_widget_initializers_wysiwyg_ckeditor_plugins_colortext_lang_ja_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_165__editor_widget_initializers_wysiwyg_ckeditor_plugins_colortext_lang_ja_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_165__editor_widget_initializers_wysiwyg_ckeditor_plugins_colortext_lang_ja_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_166__editor_widget_initializers_wysiwyg_ckeditor_plugins_colortext_lang_ro_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_166__editor_widget_initializers_wysiwyg_ckeditor_plugins_colortext_lang_ro_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_166__editor_widget_initializers_wysiwyg_ckeditor_plugins_colortext_lang_ro_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_167__editor_widget_initializers_wysiwyg_ckeditor_plugins_colortext_lang_th_js__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_167__editor_widget_initializers_wysiwyg_ckeditor_plugins_colortext_lang_th_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_167__editor_widget_initializers_wysiwyg_ckeditor_plugins_colortext_lang_th_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_168__editor_widget_initializers_wysiwyg_ckeditor_plugins_colortext_lang_vn_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_168__editor_widget_initializers_wysiwyg_ckeditor_plugins_colortext_lang_vn_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_168__editor_widget_initializers_wysiwyg_ckeditor_plugins_colortext_lang_vn_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_169__editor_widget_initializers_wysiwyg_ckeditor_plugins_colortext_lang_ru_js__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_169__editor_widget_initializers_wysiwyg_ckeditor_plugins_colortext_lang_ru_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_169__editor_widget_initializers_wysiwyg_ckeditor_plugins_colortext_lang_ru_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_170__editor_widget_initializers_wysiwyg_ckeditor_plugins_colortext_lang_en_js__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_170__editor_widget_initializers_wysiwyg_ckeditor_plugins_colortext_lang_en_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_170__editor_widget_initializers_wysiwyg_ckeditor_plugins_colortext_lang_en_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_171__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_lang_LANG_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_171__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_lang_LANG_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_171__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_lang_LANG_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_172__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_lang_en_js__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_172__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_lang_en_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_172__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_lang_en_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_173__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_lang_bg_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_173__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_lang_bg_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_173__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_lang_bg_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_174__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_lang_es_js__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_174__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_lang_es_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_174__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_lang_es_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_175__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_lang_it_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_175__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_lang_it_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_175__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_lang_it_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_176__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_lang_ja_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_176__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_lang_ja_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_176__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_lang_ja_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_177__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_lang_ro_js__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_177__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_lang_ro_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_177__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_lang_ro_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_178__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_lang_th_js__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_178__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_lang_th_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_178__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_lang_th_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_179__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_lang_vn_js__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_179__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_lang_vn_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_179__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_lang_vn_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_180__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_lang_ru_js__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_180__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_lang_ru_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_180__editor_widget_initializers_wysiwyg_ckeditor_plugins_fontweight_lang_ru_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_181__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_lang_bg_js__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_181__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_lang_bg_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_181__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_lang_bg_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_182__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_lang_it_js__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_182__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_lang_it_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_182__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_lang_it_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_183__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_lang_ja_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_183__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_lang_ja_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_183__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_lang_ja_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_184__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_lang_ro_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_184__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_lang_ro_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_184__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_lang_ro_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_185__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_lang_th_js__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_185__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_lang_th_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_185__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_lang_th_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_186__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_lang_vn_js__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_186__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_lang_vn_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_186__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_lang_vn_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_187__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_lang_en_js__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_187__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_lang_en_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_187__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_lang_en_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_188__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_lang_es_js__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_188__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_lang_es_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_188__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_lang_es_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_189__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_lang_fr_js__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_189__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_lang_fr_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_189__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_lang_fr_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_190__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_lang_LANG_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_190__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_lang_LANG_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_190__editor_widget_initializers_wysiwyg_ckeditor_plugins_variable_lang_LANG_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_191__common_libs_jquery_pickmeup_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_191__common_libs_jquery_pickmeup_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_191__common_libs_jquery_pickmeup_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_192__common_libs_angular_file_upload_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_192__common_libs_angular_file_upload_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_192__common_libs_angular_file_upload_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_193__common_modules_ngLocale_module_coffee__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_193__common_modules_ngLocale_module_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_193__common_modules_ngLocale_module_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_194__app_main_siter_module__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_194__app_main_siter_module___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_194__app_main_siter_module__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_195__site_site_service_coffee__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_195__site_site_service_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_195__site_site_service_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_196__site_lesson_service__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_196__site_lesson_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_196__site_lesson_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_197__site_set_template_templates_service_coffee__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_197__site_set_template_templates_service_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_197__site_set_template_templates_service_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_198__profile_user_service_coffee__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_198__profile_user_service_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_198__profile_user_service_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_199__public_login_login_service_coffee__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_199__public_login_login_service_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_199__public_login_login_service_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_200__common_services_errorsInterceptor_service_coffee__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_200__common_services_errorsInterceptor_service_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_200__common_services_errorsInterceptor_service_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_201__common_services_cache_service_coffee__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_201__common_services_cache_service_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_201__common_services_cache_service_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_202__common_services_state_service_coffee__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_202__common_services_state_service_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_202__common_services_state_service_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_203__common_services_translit_service_coffee__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_203__common_services_translit_service_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_203__common_services_translit_service_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_204__common_services_translit2_service_coffee__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_204__common_services_translit2_service_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_204__common_services_translit2_service_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_205__common_services_intercom_service_coffee__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_205__common_services_intercom_service_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_205__common_services_intercom_service_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_206__common_services_translationLoader_service_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_206__common_services_translationLoader_service_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_206__common_services_translationLoader_service_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_207__common_services_widgetsSortHelper_service_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_207__common_services_widgetsSortHelper_service_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_207__common_services_widgetsSortHelper_service_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_208__common_services_modals_service_coffee__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_208__common_services_modals_service_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_208__common_services_modals_service_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_209__editor_email_section_settings_create_controller_coffee__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_209__editor_email_section_settings_create_controller_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_209__editor_email_section_settings_create_controller_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_210__editor_email_section_settings_edit_controller_coffee__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_210__editor_email_section_settings_edit_controller_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_210__editor_email_section_settings_edit_controller_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_211__email_new_email_controller_coffee__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_211__email_new_email_controller_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_211__email_new_email_controller_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_212__email_edit_email_controller_coffee__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_212__email_edit_email_controller_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_212__email_edit_email_controller_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_213__site_edit_template_controller_coffee__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_213__site_edit_template_controller_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_213__site_edit_template_controller_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_214__site_new_template_controller_coffee__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_214__site_new_template_controller_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_214__site_new_template_controller_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_215__site_site_settings_site_settings_controller_coffee__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_215__site_site_settings_site_settings_controller_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_215__site_site_settings_site_settings_controller_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_216__webform_html_of_form_controller_coffee__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_216__webform_html_of_form_controller_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_216__webform_html_of_form_controller_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_217__webform_new_webform_controller_coffee__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_217__webform_new_webform_controller_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_217__webform_new_webform_controller_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_218__webform_edit_webform_controller_coffee__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_218__webform_edit_webform_controller_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_218__webform_edit_webform_controller_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_219__lesson_newLesson_controller__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_219__lesson_newLesson_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_219__lesson_newLesson_controller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_220__lesson_editLesson_controller__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_220__lesson_editLesson_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_220__lesson_editLesson_controller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_221__lesson_newLessonSection_controller__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_221__lesson_newLessonSection_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_221__lesson_newLessonSection_controller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_222__site_site_controller_coffee__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_222__site_site_controller_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_222__site_site_controller_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_223__site_email_controller_coffee__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_223__site_email_controller_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_223__site_email_controller_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_224__site_form_controller_coffee__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_224__site_form_controller_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_224__site_form_controller_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_225__site_lesson_controller__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_225__site_lesson_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_225__site_lesson_controller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_226__common_controllers_tutorial_controller_coffee__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_226__common_controllers_tutorial_controller_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_226__common_controllers_tutorial_controller_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_227__common_controllers_preview_controller_coffee__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_227__common_controllers_preview_controller_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_227__common_controllers_preview_controller_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_228__common_directives_access_coffee__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_228__common_directives_access_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_228__common_directives_access_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_229__common_directives_autofocus_coffee__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_229__common_directives_autofocus_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_229__common_directives_autofocus_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_230__common_directives_errsrc_coffee__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_230__common_directives_errsrc_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_230__common_directives_errsrc_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_231__common_directives_iframeonload_coffee__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_231__common_directives_iframeonload_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_231__common_directives_iframeonload_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_232__common_directives_imageonload_coffee__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_232__common_directives_imageonload_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_232__common_directives_imageonload_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_233__common_directives_resize_coffee__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_233__common_directives_resize_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_233__common_directives_resize_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_234__common_directives_scroll_fix_directive_coffee__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_234__common_directives_scroll_fix_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_234__common_directives_scroll_fix_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_235__common_directives_select_directive_coffee__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_235__common_directives_select_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_235__common_directives_select_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_236__common_directives_submit_on_coffee__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_236__common_directives_submit_on_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_236__common_directives_submit_on_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_237__common_directives_tabs_directive_coffee__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_237__common_directives_tabs_directive_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_237__common_directives_tabs_directive_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_238__common_directives_tooltips_coffee__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_238__common_directives_tooltips_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_238__common_directives_tooltips_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_239__common_directives_perfect_scrollbar_coffee__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_239__common_directives_perfect_scrollbar_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_239__common_directives_perfect_scrollbar_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_240__common_modules_rangeSlider_module_coffee__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_240__common_modules_rangeSlider_module_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_240__common_modules_rangeSlider_module_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_241__dashboard_dashboard_controller_coffee__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_241__dashboard_dashboard_controller_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_241__dashboard_dashboard_controller_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_242__dashboard_dashboardWebforms_controller_coffee__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_242__dashboard_dashboardWebforms_controller_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_242__dashboard_dashboardWebforms_controller_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_243__dashboard_dashboardLessons_controller__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_243__dashboard_dashboardLessons_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_243__dashboard_dashboardLessons_controller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_244__dashboard_dashboardLessonSections_controller__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_244__dashboard_dashboardLessonSections_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_244__dashboard_dashboardLessonSections_controller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_245__dashboard_images_edit_image_controller_coffee__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_245__dashboard_images_edit_image_controller_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_245__dashboard_images_edit_image_controller_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_246__dashboard_images_new_image_controller_coffee__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_246__dashboard_images_new_image_controller_coffee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_246__dashboard_images_new_image_controller_coffee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_247__app_main_siter_config__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_247__app_main_siter_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_247__app_main_siter_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_248__app_main_siter_run__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_248__app_main_siter_run___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_248__app_main_siter_run__);

/* injects from baggage-loader */



/*
 * Import styles
 */



/*
 * Import common directives [editor.directives]
 */



/*
 * Import API [api]
 */













/*
 * Import services [services]
 */
















 // services.editorNavSections


/*
 * Import module settings directives [modulesSettings]
 */
















































/*
 * Import main controllers
 */






 // editorNavigation.controller
 // editorNavigationSections.controller

 // editor.modulesSettings.controller
 // editor.fontSettings.controller
 // alert.controller
 // create.email.controller
 // edit.email.controller
 // create.section.controller
 // edit.link.controller
 // create.link.controller
 // update.link.controller


/**
 * Editor
 * ['api', 'services', 'modulesSettings', ...controllers]
 */


/*
 * Import section initializers
 */




/*
 * Import widget initializers
 */











/*
 * Import CkEditor
 */















































































/*
 * Import common libs && modules
 */




/**
 * Main module [siter.io]
 */


/*
 * Import api services for siter.io
 */




/*
 * Import services for siter.io
 */











/*
 * Import service modals && controllers for him
 */


// Email Section modal controllers


// Email modal controllers


// Template modal controllers


// SiteSettings modal controllers

// WebForm modal controllers



// Lesson modal controllers


// Lesson Section modal controllers


/*
 * Import controllers for siter.io
 */







/*
 * Import directives for siter.io
 */














/*
 * Import dashboard controllers
 */







/**
 * Configure && Run
 */



/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angular_ui_router__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angular_ui_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_angular_ui_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angular_ui_bootstrap__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angular_ui_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_angular_ui_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angular_growl_siter__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angular_growl_siter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_angular_growl_siter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__node_modules_angular_growl_siter_build_angular_growl_min_css__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__node_modules_angular_growl_siter_build_angular_growl_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__node_modules_angular_growl_siter_build_angular_growl_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angular_ui_notification__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angular_ui_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_angular_ui_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__node_modules_angular_ui_notification_dist_angular_ui_notification_min_css__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__node_modules_angular_ui_notification_dist_angular_ui_notification_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__node_modules_angular_ui_notification_dist_angular_ui_notification_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_angular_ui_tree__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_angular_ui_tree___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_angular_ui_tree__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_angular_busy__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_angular_busy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_angular_busy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_angular_cookies__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_angular_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_angular_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_restangular__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_restangular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_restangular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_angular_contenteditable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_angular_contenteditable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_angular_contenteditable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_angular_animate__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_angular_animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_angular_animate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_angular_translate__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_angular_translate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_angular_translate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_angular_translate_loader_url__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_angular_translate_loader_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_angular_translate_loader_url__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_angular_dynamic_locale__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_angular_dynamic_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_angular_dynamic_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_angular_translate_storage_local__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_angular_translate_storage_local___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_angular_translate_storage_local__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_angular_translate_loader_static_files__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_angular_translate_loader_static_files___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_angular_translate_loader_static_files__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__node_modules_perfect_scrollbar_dist_css_perfect_scrollbar_css__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__node_modules_perfect_scrollbar_dist_css_perfect_scrollbar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__node_modules_perfect_scrollbar_dist_css_perfect_scrollbar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__node_modules_perfect_scrollbar_dist_js_perfect_scrollbar_jquery_js__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__node_modules_perfect_scrollbar_dist_js_perfect_scrollbar_jquery_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__node_modules_perfect_scrollbar_dist_js_perfect_scrollbar_jquery_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__node_modules_perfect_scrollbar_dist_js_perfect_scrollbar_js__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__node_modules_perfect_scrollbar_dist_js_perfect_scrollbar_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__node_modules_perfect_scrollbar_dist_js_perfect_scrollbar_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_swiper__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lightbox2__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lightbox2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_lightbox2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_responsive_nav__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_responsive_nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_responsive_nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_jquery_ui__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_jquery_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_jquery_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_jquery_datetimepicker__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_jquery_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_jquery_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_flipclock__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_flipclock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_flipclock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__node_modules_flipclock_compiled_flipclock_css__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__node_modules_flipclock_compiled_flipclock_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__node_modules_flipclock_compiled_flipclock_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_ng_tags_input__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_ng_tags_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_ng_tags_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__node_modules_ng_tags_input_build_ng_tags_input_css__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__node_modules_ng_tags_input_build_ng_tags_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__node_modules_ng_tags_input_build_ng_tags_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_ng_infinite_scroll__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_ng_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_ng_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_angular_ivh_treeview__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_angular_ivh_treeview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_angular_ivh_treeview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__node_modules_angular_ivh_treeview_dist_ivh_treeview_css__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__node_modules_angular_ivh_treeview_dist_ivh_treeview_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__node_modules_angular_ivh_treeview_dist_ivh_treeview_css__);

/* injects from baggage-loader */



// angular modules

global.vex = __webpack_require__(443);






















// common




















/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 8 */
/***/ (function(module, exports) {

/**
 * @license AngularJS v1.4.1
 * (c) 2010-2015 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular, undefined) {'use strict';

/* jshint ignore:start */
var noop        = angular.noop;
var extend      = angular.extend;
var jqLite      = angular.element;
var forEach     = angular.forEach;
var isArray     = angular.isArray;
var isString    = angular.isString;
var isObject    = angular.isObject;
var isUndefined = angular.isUndefined;
var isDefined   = angular.isDefined;
var isFunction  = angular.isFunction;
var isElement   = angular.isElement;

var ELEMENT_NODE = 1;
var COMMENT_NODE = 8;

var NG_ANIMATE_CLASSNAME = 'ng-animate';
var NG_ANIMATE_CHILDREN_DATA = '$$ngAnimateChildren';

var isPromiseLike = function(p) {
  return p && p.then ? true : false;
}

function assertArg(arg, name, reason) {
  if (!arg) {
    throw ngMinErr('areq', "Argument '{0}' is {1}", (name || '?'), (reason || "required"));
  }
  return arg;
}

function mergeClasses(a,b) {
  if (!a && !b) return '';
  if (!a) return b;
  if (!b) return a;
  if (isArray(a)) a = a.join(' ');
  if (isArray(b)) b = b.join(' ');
  return a + ' ' + b;
}

function packageStyles(options) {
  var styles = {};
  if (options && (options.to || options.from)) {
    styles.to = options.to;
    styles.from = options.from;
  }
  return styles;
}

function pendClasses(classes, fix, isPrefix) {
  var className = '';
  classes = isArray(classes)
      ? classes
      : classes && isString(classes) && classes.length
          ? classes.split(/\s+/)
          : [];
  forEach(classes, function(klass, i) {
    if (klass && klass.length > 0) {
      className += (i > 0) ? ' ' : '';
      className += isPrefix ? fix + klass
                            : klass + fix;
    }
  });
  return className;
}

function removeFromArray(arr, val) {
  var index = arr.indexOf(val);
  if (val >= 0) {
    arr.splice(index, 1);
  }
}

function stripCommentsFromElement(element) {
  if (element instanceof jqLite) {
    switch (element.length) {
      case 0:
        return [];
        break;

      case 1:
        // there is no point of stripping anything if the element
        // is the only element within the jqLite wrapper.
        // (it's important that we retain the element instance.)
        if (element[0].nodeType === ELEMENT_NODE) {
          return element;
        }
        break;

      default:
        return jqLite(extractElementNode(element));
        break;
    }
  }

  if (element.nodeType === ELEMENT_NODE) {
    return jqLite(element);
  }
}

function extractElementNode(element) {
  if (!element[0]) return element;
  for (var i = 0; i < element.length; i++) {
    var elm = element[i];
    if (elm.nodeType == ELEMENT_NODE) {
      return elm;
    }
  }
}

function $$addClass($$jqLite, element, className) {
  forEach(element, function(elm) {
    $$jqLite.addClass(elm, className);
  });
}

function $$removeClass($$jqLite, element, className) {
  forEach(element, function(elm) {
    $$jqLite.removeClass(elm, className);
  });
}

function applyAnimationClassesFactory($$jqLite) {
  return function(element, options) {
    if (options.addClass) {
      $$addClass($$jqLite, element, options.addClass);
      options.addClass = null;
    }
    if (options.removeClass) {
      $$removeClass($$jqLite, element, options.removeClass);
      options.removeClass = null;
    }
  }
}

function prepareAnimationOptions(options) {
  options = options || {};
  if (!options.$$prepared) {
    var domOperation = options.domOperation || noop;
    options.domOperation = function() {
      options.$$domOperationFired = true;
      domOperation();
      domOperation = noop;
    };
    options.$$prepared = true;
  }
  return options;
}

function applyAnimationStyles(element, options) {
  applyAnimationFromStyles(element, options);
  applyAnimationToStyles(element, options);
}

function applyAnimationFromStyles(element, options) {
  if (options.from) {
    element.css(options.from);
    options.from = null;
  }
}

function applyAnimationToStyles(element, options) {
  if (options.to) {
    element.css(options.to);
    options.to = null;
  }
}

function mergeAnimationOptions(element, target, newOptions) {
  var toAdd = (target.addClass || '') + ' ' + (newOptions.addClass || '');
  var toRemove = (target.removeClass || '') + ' ' + (newOptions.removeClass || '');
  var classes = resolveElementClasses(element.attr('class'), toAdd, toRemove);

  extend(target, newOptions);

  if (classes.addClass) {
    target.addClass = classes.addClass;
  } else {
    target.addClass = null;
  }

  if (classes.removeClass) {
    target.removeClass = classes.removeClass;
  } else {
    target.removeClass = null;
  }

  return target;
}

function resolveElementClasses(existing, toAdd, toRemove) {
  var ADD_CLASS = 1;
  var REMOVE_CLASS = -1;

  var flags = {};
  existing = splitClassesToLookup(existing);

  toAdd = splitClassesToLookup(toAdd);
  forEach(toAdd, function(value, key) {
    flags[key] = ADD_CLASS;
  });

  toRemove = splitClassesToLookup(toRemove);
  forEach(toRemove, function(value, key) {
    flags[key] = flags[key] === ADD_CLASS ? null : REMOVE_CLASS;
  });

  var classes = {
    addClass: '',
    removeClass: ''
  };

  forEach(flags, function(val, klass) {
    var prop, allow;
    if (val === ADD_CLASS) {
      prop = 'addClass';
      allow = !existing[klass];
    } else if (val === REMOVE_CLASS) {
      prop = 'removeClass';
      allow = existing[klass];
    }
    if (allow) {
      if (classes[prop].length) {
        classes[prop] += ' ';
      }
      classes[prop] += klass;
    }
  });

  function splitClassesToLookup(classes) {
    if (isString(classes)) {
      classes = classes.split(' ');
    }

    var obj = {};
    forEach(classes, function(klass) {
      // sometimes the split leaves empty string values
      // incase extra spaces were applied to the options
      if (klass.length) {
        obj[klass] = true;
      }
    });
    return obj;
  }

  return classes;
}

function getDomNode(element) {
  return (element instanceof angular.element) ? element[0] : element;
}

var $$rAFSchedulerFactory = ['$$rAF', function($$rAF) {
  var tickQueue = [];
  var cancelFn;

  function scheduler(tasks) {
    // we make a copy since RAFScheduler mutates the state
    // of the passed in array variable and this would be difficult
    // to track down on the outside code
    tickQueue.push([].concat(tasks));
    nextTick();
  }

  /* waitUntilQuiet does two things:
   * 1. It will run the FINAL `fn` value only when an uncancelled RAF has passed through
   * 2. It will delay the next wave of tasks from running until the quiet `fn` has run.
   *
   * The motivation here is that animation code can request more time from the scheduler
   * before the next wave runs. This allows for certain DOM properties such as classes to
   * be resolved in time for the next animation to run.
   */
  scheduler.waitUntilQuiet = function(fn) {
    if (cancelFn) cancelFn();

    cancelFn = $$rAF(function() {
      cancelFn = null;
      fn();
      nextTick();
    });
  };

  return scheduler;

  function nextTick() {
    if (!tickQueue.length) return;

    var updatedQueue = [];
    for (var i = 0; i < tickQueue.length; i++) {
      var innerQueue = tickQueue[i];
      runNextTask(innerQueue);
      if (innerQueue.length) {
        updatedQueue.push(innerQueue);
      }
    }
    tickQueue = updatedQueue;

    if (!cancelFn) {
      $$rAF(function() {
        if (!cancelFn) nextTick();
      });
    }
  }

  function runNextTask(tasks) {
    var nextTask = tasks.shift();
    nextTask();
  }
}];

var $$AnimateChildrenDirective = [function() {
  return function(scope, element, attrs) {
    var val = attrs.ngAnimateChildren;
    if (angular.isString(val) && val.length === 0) { //empty attribute
      element.data(NG_ANIMATE_CHILDREN_DATA, true);
    } else {
      attrs.$observe('ngAnimateChildren', function(value) {
        value = value === 'on' || value === 'true';
        element.data(NG_ANIMATE_CHILDREN_DATA, value);
      });
    }
  };
}];

/**
 * @ngdoc service
 * @name $animateCss
 * @kind object
 *
 * @description
 * The `$animateCss` service is a useful utility to trigger customized CSS-based transitions/keyframes
 * from a JavaScript-based animation or directly from a directive. The purpose of `$animateCss` is NOT
 * to side-step how `$animate` and ngAnimate work, but the goal is to allow pre-existing animations or
 * directives to create more complex animations that can be purely driven using CSS code.
 *
 * Note that only browsers that support CSS transitions and/or keyframe animations are capable of
 * rendering animations triggered via `$animateCss` (bad news for IE9 and lower).
 *
 * ## Usage
 * Once again, `$animateCss` is designed to be used inside of a registered JavaScript animation that
 * is powered by ngAnimate. It is possible to use `$animateCss` directly inside of a directive, however,
 * any automatic control over cancelling animations and/or preventing animations from being run on
 * child elements will not be handled by Angular. For this to work as expected, please use `$animate` to
 * trigger the animation and then setup a JavaScript animation that injects `$animateCss` to trigger
 * the CSS animation.
 *
 * The example below shows how we can create a folding animation on an element using `ng-if`:
 *
 * ```html
 * <!-- notice the `fold-animation` CSS class -->
 * <div ng-if="onOff" class="fold-animation">
 *   This element will go BOOM
 * </div>
 * <button ng-click="onOff=true">Fold In</button>
 * ```
 *
 * Now we create the **JavaScript animation** that will trigger the CSS transition:
 *
 * ```js
 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element, doneFn) {
 *       var height = element[0].offsetHeight;
 *       return $animateCss(element, {
 *         from: { height:'0px' },
 *         to: { height:height + 'px' },
 *         duration: 1 // one second
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * ## More Advanced Uses
 *
 * `$animateCss` is the underlying code that ngAnimate uses to power **CSS-based animations** behind the scenes. Therefore CSS hooks
 * like `.ng-EVENT`, `.ng-EVENT-active`, `.ng-EVENT-stagger` are all features that can be triggered using `$animateCss` via JavaScript code.
 *
 * This also means that just about any combination of adding classes, removing classes, setting styles, dynamically setting a keyframe animation,
 * applying a hardcoded duration or delay value, changing the animation easing or applying a stagger animation are all options that work with
 * `$animateCss`. The service itself is smart enough to figure out the combination of options and examine the element styling properties in order
 * to provide a working animation that will run in CSS.
 *
 * The example below showcases a more advanced version of the `.fold-animation` from the example above:
 *
 * ```js
 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element, doneFn) {
 *       var height = element[0].offsetHeight;
 *       return $animateCss(element, {
 *         addClass: 'red large-text pulse-twice',
 *         easing: 'ease-out',
 *         from: { height:'0px' },
 *         to: { height:height + 'px' },
 *         duration: 1 // one second
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * Since we're adding/removing CSS classes then the CSS transition will also pick those up:
 *
 * ```css
 * /&#42; since a hardcoded duration value of 1 was provided in the JavaScript animation code,
 * the CSS classes below will be transitioned despite them being defined as regular CSS classes &#42;/
 * .red { background:red; }
 * .large-text { font-size:20px; }
 *
 * /&#42; we can also use a keyframe animation and $animateCss will make it work alongside the transition &#42;/
 * .pulse-twice {
 *   animation: 0.5s pulse linear 2;
 *   -webkit-animation: 0.5s pulse linear 2;
 * }
 *
 * @keyframes pulse {
 *   from { transform: scale(0.5); }
 *   to { transform: scale(1.5); }
 * }
 *
 * @-webkit-keyframes pulse {
 *   from { -webkit-transform: scale(0.5); }
 *   to { -webkit-transform: scale(1.5); }
 * }
 * ```
 *
 * Given this complex combination of CSS classes, styles and options, `$animateCss` will figure everything out and make the animation happen.
 *
 * ## How the Options are handled
 *
 * `$animateCss` is very versatile and intelligent when it comes to figuring out what configurations to apply to the element to ensure the animation
 * works with the options provided. Say for example we were adding a class that contained a keyframe value and we wanted to also animate some inline
 * styles using the `from` and `to` properties.
 *
 * ```js
 * var animator = $animateCss(element, {
 *   from: { background:'red' },
 *   to: { background:'blue' }
 * });
 * animator.start();
 * ```
 *
 * ```css
 * .rotating-animation {
 *   animation:0.5s rotate linear;
 *   -webkit-animation:0.5s rotate linear;
 * }
 *
 * @keyframes rotate {
 *   from { transform: rotate(0deg); }
 *   to { transform: rotate(360deg); }
 * }
 *
 * @-webkit-keyframes rotate {
 *   from { -webkit-transform: rotate(0deg); }
 *   to { -webkit-transform: rotate(360deg); }
 * }
 * ```
 *
 * The missing pieces here are that we do not have a transition set (within the CSS code nor within the `$animateCss` options) and the duration of the animation is
 * going to be detected from what the keyframe styles on the CSS class are. In this event, `$animateCss` will automatically create an inline transition
 * style matching the duration detected from the keyframe style (which is present in the CSS class that is being added) and then prepare both the transition
 * and keyframe animations to run in parallel on the element. Then when the animation is underway the provided `from` and `to` CSS styles will be applied
 * and spread across the transition and keyframe animation.
 *
 * ## What is returned
 *
 * `$animateCss` works in two stages: a preparation phase and an animation phase. Therefore when `$animateCss` is first called it will NOT actually
 * start the animation. All that is going on here is that the element is being prepared for the animation (which means that the generated CSS classes are
 * added and removed on the element). Once `$animateCss` is called it will return an object with the following properties:
 *
 * ```js
 * var animator = $animateCss(element, { ... });
 * ```
 *
 * Now what do the contents of our `animator` variable look like:
 *
 * ```js
 * {
 *   // starts the animation
 *   start: Function,
 *
 *   // ends (aborts) the animation
 *   end: Function
 * }
 * ```
 *
 * To actually start the animation we need to run `animation.start()` which will then return a promise that we can hook into to detect when the animation ends.
 * If we choose not to run the animation then we MUST run `animation.end()` to perform a cleanup on the element (since some CSS classes and stlyes may have been
 * applied to the element during the preparation phase). Note that all other properties such as duration, delay, transitions and keyframes are just properties
 * and that changing them will not reconfigure the parameters of the animation.
 *
 * ### runner.done() vs runner.then()
 * It is documented that `animation.start()` will return a promise object and this is true, however, there is also an additional method available on the
 * runner called `.done(callbackFn)`. The done method works the same as `.finally(callbackFn)`, however, it does **not trigger a digest to occur**.
 * Therefore, for performance reasons, it's always best to use `runner.done(callback)` instead of `runner.then()`, `runner.catch()` or `runner.finally()`
 * unless you really need a digest to kick off afterwards.
 *
 * Keep in mind that, to make this easier, ngAnimate has tweaked the JS animations API to recognize when a runner instance is returned from $animateCss
 * (so there is no need to call `runner.done(doneFn)` inside of your JavaScript animation code).
 * Check the {@link ngAnimate.$animateCss#usage animation code above} to see how this works.
 *
 * @param {DOMElement} element the element that will be animated
 * @param {object} options the animation-related options that will be applied during the animation
 *
 * * `event` - The DOM event (e.g. enter, leave, move). When used, a generated CSS class of `ng-EVENT` and `ng-EVENT-active` will be applied
 * to the element during the animation. Multiple events can be provided when spaces are used as a separator. (Note that this will not perform any DOM operation.)
 * * `easing` - The CSS easing value that will be applied to the transition or keyframe animation (or both).
 * * `transition` - The raw CSS transition style that will be used (e.g. `1s linear all`).
 * * `keyframe` - The raw CSS keyframe animation style that will be used (e.g. `1s my_animation linear`).
 * * `from` - The starting CSS styles (a key/value object) that will be applied at the start of the animation.
 * * `to` - The ending CSS styles (a key/value object) that will be applied across the animation via a CSS transition.
 * * `addClass` - A space separated list of CSS classes that will be added to the element and spread across the animation.
 * * `removeClass` - A space separated list of CSS classes that will be removed from the element and spread across the animation.
 * * `duration` - A number value representing the total duration of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `0`
 * is provided then the animation will be skipped entirely.
 * * `delay` - A number value representing the total delay of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `true` is
 * used then whatever delay value is detected from the CSS classes will be mirrored on the elements styles (e.g. by setting delay true then the style value
 * of the element will be `transition-delay: DETECTED_VALUE`). Using `true` is useful when you want the CSS classes and inline styles to all share the same
 * CSS delay value.
 * * `stagger` - A numeric time value representing the delay between successively animated elements
 * ({@link ngAnimate#css-staggering-animations Click here to learn how CSS-based staggering works in ngAnimate.})
 * * `staggerIndex` - The numeric index representing the stagger item (e.g. a value of 5 is equal to the sixth item in the stagger; therefore when a
 * `stagger` option value of `0.1` is used then there will be a stagger delay of `600ms`)
 * `applyClassesEarly` - Whether or not the classes being added or removed will be used when detecting the animation. This is set by `$animate` when enter/leave/move animations are fired to ensure that the CSS classes are resolved in time. (Note that this will prevent any transitions from occuring on the classes being added and removed.)
 *
 * @return {object} an object with start and end methods and details about the animation.
 *
 * * `start` - The method to start the animation. This will return a `Promise` when called.
 * * `end` - This method will cancel the animation and remove all applied CSS classes and styles.
 */

// Detect proper transitionend/animationend event names.
var CSS_PREFIX = '', TRANSITION_PROP, TRANSITIONEND_EVENT, ANIMATION_PROP, ANIMATIONEND_EVENT;

// If unprefixed events are not supported but webkit-prefixed are, use the latter.
// Otherwise, just use W3C names, browsers not supporting them at all will just ignore them.
// Note: Chrome implements `window.onwebkitanimationend` and doesn't implement `window.onanimationend`
// but at the same time dispatches the `animationend` event and not `webkitAnimationEnd`.
// Register both events in case `window.onanimationend` is not supported because of that,
// do the same for `transitionend` as Safari is likely to exhibit similar behavior.
// Also, the only modern browser that uses vendor prefixes for transitions/keyframes is webkit
// therefore there is no reason to test anymore for other vendor prefixes:
// http://caniuse.com/#search=transition
if (window.ontransitionend === undefined && window.onwebkittransitionend !== undefined) {
  CSS_PREFIX = '-webkit-';
  TRANSITION_PROP = 'WebkitTransition';
  TRANSITIONEND_EVENT = 'webkitTransitionEnd transitionend';
} else {
  TRANSITION_PROP = 'transition';
  TRANSITIONEND_EVENT = 'transitionend';
}

if (window.onanimationend === undefined && window.onwebkitanimationend !== undefined) {
  CSS_PREFIX = '-webkit-';
  ANIMATION_PROP = 'WebkitAnimation';
  ANIMATIONEND_EVENT = 'webkitAnimationEnd animationend';
} else {
  ANIMATION_PROP = 'animation';
  ANIMATIONEND_EVENT = 'animationend';
}

var DURATION_KEY = 'Duration';
var PROPERTY_KEY = 'Property';
var DELAY_KEY = 'Delay';
var TIMING_KEY = 'TimingFunction';
var ANIMATION_ITERATION_COUNT_KEY = 'IterationCount';
var ANIMATION_PLAYSTATE_KEY = 'PlayState';
var ELAPSED_TIME_MAX_DECIMAL_PLACES = 3;
var CLOSING_TIME_BUFFER = 1.5;
var ONE_SECOND = 1000;
var BASE_TEN = 10;

var SAFE_FAST_FORWARD_DURATION_VALUE = 9999;

var ANIMATION_DELAY_PROP = ANIMATION_PROP + DELAY_KEY;
var ANIMATION_DURATION_PROP = ANIMATION_PROP + DURATION_KEY;

var TRANSITION_DELAY_PROP = TRANSITION_PROP + DELAY_KEY;
var TRANSITION_DURATION_PROP = TRANSITION_PROP + DURATION_KEY;

var DETECT_CSS_PROPERTIES = {
  transitionDuration:      TRANSITION_DURATION_PROP,
  transitionDelay:         TRANSITION_DELAY_PROP,
  transitionProperty:      TRANSITION_PROP + PROPERTY_KEY,
  animationDuration:       ANIMATION_DURATION_PROP,
  animationDelay:          ANIMATION_DELAY_PROP,
  animationIterationCount: ANIMATION_PROP + ANIMATION_ITERATION_COUNT_KEY
};

var DETECT_STAGGER_CSS_PROPERTIES = {
  transitionDuration:      TRANSITION_DURATION_PROP,
  transitionDelay:         TRANSITION_DELAY_PROP,
  animationDuration:       ANIMATION_DURATION_PROP,
  animationDelay:          ANIMATION_DELAY_PROP
};

function computeCssStyles($window, element, properties) {
  var styles = Object.create(null);
  var detectedStyles = $window.getComputedStyle(element) || {};
  forEach(properties, function(formalStyleName, actualStyleName) {
    var val = detectedStyles[formalStyleName];
    if (val) {
      var c = val.charAt(0);

      // only numerical-based values have a negative sign or digit as the first value
      if (c === '-' || c === '+' || c >= 0) {
        val = parseMaxTime(val);
      }

      // by setting this to null in the event that the delay is not set or is set directly as 0
      // then we can still allow for zegative values to be used later on and not mistake this
      // value for being greater than any other negative value.
      if (val === 0) {
        val = null;
      }
      styles[actualStyleName] = val;
    }
  });

  return styles;
}

function parseMaxTime(str) {
  var maxValue = 0;
  var values = str.split(/\s*,\s*/);
  forEach(values, function(value) {
    // it's always safe to consider only second values and omit `ms` values since
    // getComputedStyle will always handle the conversion for us
    if (value.charAt(value.length - 1) == 's') {
      value = value.substring(0, value.length - 1);
    }
    value = parseFloat(value) || 0;
    maxValue = maxValue ? Math.max(value, maxValue) : value;
  });
  return maxValue;
}

function truthyTimingValue(val) {
  return val === 0 || val != null;
}

function getCssTransitionDurationStyle(duration, applyOnlyDuration) {
  var style = TRANSITION_PROP;
  var value = duration + 's';
  if (applyOnlyDuration) {
    style += DURATION_KEY;
  } else {
    value += ' linear all';
  }
  return [style, value];
}

function getCssKeyframeDurationStyle(duration) {
  return [ANIMATION_DURATION_PROP, duration + 's'];
}

function getCssDelayStyle(delay, isKeyframeAnimation) {
  var prop = isKeyframeAnimation ? ANIMATION_DELAY_PROP : TRANSITION_DELAY_PROP;
  return [prop, delay + 's'];
}

function blockTransitions(node, duration) {
  // we use a negative delay value since it performs blocking
  // yet it doesn't kill any existing transitions running on the
  // same element which makes this safe for class-based animations
  var value = duration ? '-' + duration + 's' : '';
  applyInlineStyle(node, [TRANSITION_DELAY_PROP, value]);
  return [TRANSITION_DELAY_PROP, value];
}

function blockKeyframeAnimations(node, applyBlock) {
  var value = applyBlock ? 'paused' : '';
  var key = ANIMATION_PROP + ANIMATION_PLAYSTATE_KEY;
  applyInlineStyle(node, [key, value]);
  return [key, value];
}

function applyInlineStyle(node, styleTuple) {
  var prop = styleTuple[0];
  var value = styleTuple[1];
  node.style[prop] = value;
}

function createLocalCacheLookup() {
  var cache = Object.create(null);
  return {
    flush: function() {
      cache = Object.create(null);
    },

    count: function(key) {
      var entry = cache[key];
      return entry ? entry.total : 0;
    },

    get: function(key) {
      var entry = cache[key];
      return entry && entry.value;
    },

    put: function(key, value) {
      if (!cache[key]) {
        cache[key] = { total: 1, value: value };
      } else {
        cache[key].total++;
      }
    }
  };
}

var $AnimateCssProvider = ['$animateProvider', function($animateProvider) {
  var gcsLookup = createLocalCacheLookup();
  var gcsStaggerLookup = createLocalCacheLookup();

  this.$get = ['$window', '$$jqLite', '$$AnimateRunner', '$timeout',
               '$document', '$sniffer', '$$rAFScheduler',
       function($window,   $$jqLite,   $$AnimateRunner,   $timeout,
                $document,   $sniffer,   $$rAFScheduler) {

    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);

    var parentCounter = 0;
    function gcsHashFn(node, extraClasses) {
      var KEY = "$$ngAnimateParentKey";
      var parentNode = node.parentNode;
      var parentID = parentNode[KEY] || (parentNode[KEY] = ++parentCounter);
      return parentID + '-' + node.getAttribute('class') + '-' + extraClasses;
    }

    function computeCachedCssStyles(node, className, cacheKey, properties) {
      var timings = gcsLookup.get(cacheKey);

      if (!timings) {
        timings = computeCssStyles($window, node, properties);
        if (timings.animationIterationCount === 'infinite') {
          timings.animationIterationCount = 1;
        }
      }

      // we keep putting this in multiple times even though the value and the cacheKey are the same
      // because we're keeping an interal tally of how many duplicate animations are detected.
      gcsLookup.put(cacheKey, timings);
      return timings;
    }

    function computeCachedCssStaggerStyles(node, className, cacheKey, properties) {
      var stagger;

      // if we have one or more existing matches of matching elements
      // containing the same parent + CSS styles (which is how cacheKey works)
      // then staggering is possible
      if (gcsLookup.count(cacheKey) > 0) {
        stagger = gcsStaggerLookup.get(cacheKey);

        if (!stagger) {
          var staggerClassName = pendClasses(className, '-stagger');

          $$jqLite.addClass(node, staggerClassName);

          stagger = computeCssStyles($window, node, properties);

          // force the conversion of a null value to zero incase not set
          stagger.animationDuration = Math.max(stagger.animationDuration, 0);
          stagger.transitionDuration = Math.max(stagger.transitionDuration, 0);

          $$jqLite.removeClass(node, staggerClassName);

          gcsStaggerLookup.put(cacheKey, stagger);
        }
      }

      return stagger || {};
    }

    var bod = getDomNode($document).body;
    var rafWaitQueue = [];
    function waitUntilQuiet(callback) {
      rafWaitQueue.push(callback);
      $$rAFScheduler.waitUntilQuiet(function() {
        gcsLookup.flush();
        gcsStaggerLookup.flush();

        //the line below will force the browser to perform a repaint so
        //that all the animated elements within the animation frame will
        //be properly updated and drawn on screen. This is required to
        //ensure that the preparation animation is properly flushed so that
        //the active state picks up from there. DO NOT REMOVE THIS LINE.
        //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
        //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
        //WILL TAKE YEARS AWAY FROM YOUR LIFE.
        var width = bod.offsetWidth + 1;

        // we use a for loop to ensure that if the queue is changed
        // during this looping then it will consider new requests
        for (var i = 0; i < rafWaitQueue.length; i++) {
          rafWaitQueue[i](width);
        }
        rafWaitQueue.length = 0;
      });
    }

    return init;

    function computeTimings(node, className, cacheKey) {
      var timings = computeCachedCssStyles(node, className, cacheKey, DETECT_CSS_PROPERTIES);
      var aD = timings.animationDelay;
      var tD = timings.transitionDelay;
      timings.maxDelay = aD && tD
          ? Math.max(aD, tD)
          : (aD || tD);
      timings.maxDuration = Math.max(
          timings.animationDuration * timings.animationIterationCount,
          timings.transitionDuration);

      return timings;
    }

    function init(element, options) {
      var node = getDomNode(element);
      options = prepareAnimationOptions(options);

      var temporaryStyles = [];
      var classes = element.attr('class');
      var styles = packageStyles(options);
      var animationClosed;
      var animationPaused;
      var animationCompleted;
      var runner;
      var runnerHost;
      var maxDelay;
      var maxDelayTime;
      var maxDuration;
      var maxDurationTime;

      if (options.duration === 0 || (!$sniffer.animations && !$sniffer.transitions)) {
        return closeAndReturnNoopAnimator();
      }

      var method = options.event && isArray(options.event)
            ? options.event.join(' ')
            : options.event;

      var isStructural = method && options.structural;
      var structuralClassName = '';
      var addRemoveClassName = '';

      if (isStructural) {
        structuralClassName = pendClasses(method, 'ng-', true);
      } else if (method) {
        structuralClassName = method;
      }

      if (options.addClass) {
        addRemoveClassName += pendClasses(options.addClass, '-add');
      }

      if (options.removeClass) {
        if (addRemoveClassName.length) {
          addRemoveClassName += ' ';
        }
        addRemoveClassName += pendClasses(options.removeClass, '-remove');
      }

      // there may be a situation where a structural animation is combined together
      // with CSS classes that need to resolve before the animation is computed.
      // However this means that there is no explicit CSS code to block the animation
      // from happening (by setting 0s none in the class name). If this is the case
      // we need to apply the classes before the first rAF so we know to continue if
      // there actually is a detected transition or keyframe animation
      if (options.applyClassesEarly && addRemoveClassName.length) {
        applyAnimationClasses(element, options);
        addRemoveClassName = '';
      }

      var setupClasses = [structuralClassName, addRemoveClassName].join(' ').trim();
      var fullClassName = classes + ' ' + setupClasses;
      var activeClasses = pendClasses(setupClasses, '-active');
      var hasToStyles = styles.to && Object.keys(styles.to).length > 0;

      // there is no way we can trigger an animation since no styles and
      // no classes are being applied which would then trigger a transition
      if (!hasToStyles && !setupClasses) {
        return closeAndReturnNoopAnimator();
      }

      var cacheKey, stagger;
      if (options.stagger > 0) {
        var staggerVal = parseFloat(options.stagger);
        stagger = {
          transitionDelay: staggerVal,
          animationDelay: staggerVal,
          transitionDuration: 0,
          animationDuration: 0
        };
      } else {
        cacheKey = gcsHashFn(node, fullClassName);
        stagger = computeCachedCssStaggerStyles(node, setupClasses, cacheKey, DETECT_STAGGER_CSS_PROPERTIES);
      }

      $$jqLite.addClass(element, setupClasses);

      var applyOnlyDuration;

      if (options.transitionStyle) {
        var transitionStyle = [TRANSITION_PROP, options.transitionStyle];
        applyInlineStyle(node, transitionStyle);
        temporaryStyles.push(transitionStyle);
      }

      if (options.duration >= 0) {
        applyOnlyDuration = node.style[TRANSITION_PROP].length > 0;
        var durationStyle = getCssTransitionDurationStyle(options.duration, applyOnlyDuration);

        // we set the duration so that it will be picked up by getComputedStyle later
        applyInlineStyle(node, durationStyle);
        temporaryStyles.push(durationStyle);
      }

      if (options.keyframeStyle) {
        var keyframeStyle = [ANIMATION_PROP, options.keyframeStyle];
        applyInlineStyle(node, keyframeStyle);
        temporaryStyles.push(keyframeStyle);
      }

      var itemIndex = stagger
          ? options.staggerIndex >= 0
              ? options.staggerIndex
              : gcsLookup.count(cacheKey)
          : 0;

      var isFirst = itemIndex === 0;

      // this is a pre-emptive way of forcing the setup classes to be added and applied INSTANTLY
      // without causing any combination of transitions to kick in. By adding a negative delay value
      // it forces the setup class' transition to end immediately. We later then remove the negative
      // transition delay to allow for the transition to naturally do it's thing. The beauty here is
      // that if there is no transition defined then nothing will happen and this will also allow
      // other transitions to be stacked on top of each other without any chopping them out.
      if (isFirst) {
        blockTransitions(node, SAFE_FAST_FORWARD_DURATION_VALUE);
      }

      var timings = computeTimings(node, fullClassName, cacheKey);
      var relativeDelay = timings.maxDelay;
      maxDelay = Math.max(relativeDelay, 0);
      maxDuration = timings.maxDuration;

      var flags = {};
      flags.hasTransitions          = timings.transitionDuration > 0;
      flags.hasAnimations           = timings.animationDuration > 0;
      flags.hasTransitionAll        = flags.hasTransitions && timings.transitionProperty == 'all';
      flags.applyTransitionDuration = hasToStyles && (
                                        (flags.hasTransitions && !flags.hasTransitionAll)
                                         || (flags.hasAnimations && !flags.hasTransitions));
      flags.applyAnimationDuration  = options.duration && flags.hasAnimations;
      flags.applyTransitionDelay    = truthyTimingValue(options.delay) && (flags.applyTransitionDuration || flags.hasTransitions);
      flags.applyAnimationDelay     = truthyTimingValue(options.delay) && flags.hasAnimations;
      flags.recalculateTimingStyles = addRemoveClassName.length > 0;

      if (flags.applyTransitionDuration || flags.applyAnimationDuration) {
        maxDuration = options.duration ? parseFloat(options.duration) : maxDuration;

        if (flags.applyTransitionDuration) {
          flags.hasTransitions = true;
          timings.transitionDuration = maxDuration;
          applyOnlyDuration = node.style[TRANSITION_PROP + PROPERTY_KEY].length > 0;
          temporaryStyles.push(getCssTransitionDurationStyle(maxDuration, applyOnlyDuration));
        }

        if (flags.applyAnimationDuration) {
          flags.hasAnimations = true;
          timings.animationDuration = maxDuration;
          temporaryStyles.push(getCssKeyframeDurationStyle(maxDuration));
        }
      }

      if (maxDuration === 0 && !flags.recalculateTimingStyles) {
        return closeAndReturnNoopAnimator();
      }

      // we need to recalculate the delay value since we used a pre-emptive negative
      // delay value and the delay value is required for the final event checking. This
      // property will ensure that this will happen after the RAF phase has passed.
      if (options.duration == null && timings.transitionDuration > 0) {
        flags.recalculateTimingStyles = flags.recalculateTimingStyles || isFirst;
      }

      maxDelayTime = maxDelay * ONE_SECOND;
      maxDurationTime = maxDuration * ONE_SECOND;
      if (!options.skipBlocking) {
        flags.blockTransition = timings.transitionDuration > 0;
        flags.blockKeyframeAnimation = timings.animationDuration > 0 &&
                                       stagger.animationDelay > 0 &&
                                       stagger.animationDuration === 0;
      }

      applyAnimationFromStyles(element, options);
      if (!flags.blockTransition) {
        blockTransitions(node, false);
      }

      applyBlocking(maxDuration);

      // TODO(matsko): for 1.5 change this code to have an animator object for better debugging
      return {
        $$willAnimate: true,
        end: endFn,
        start: function() {
          if (animationClosed) return;

          runnerHost = {
            end: endFn,
            cancel: cancelFn,
            resume: null, //this will be set during the start() phase
            pause: null
          };

          runner = new $$AnimateRunner(runnerHost);

          waitUntilQuiet(start);

          // we don't have access to pause/resume the animation
          // since it hasn't run yet. AnimateRunner will therefore
          // set noop functions for resume and pause and they will
          // later be overridden once the animation is triggered
          return runner;
        }
      };

      function endFn() {
        close();
      }

      function cancelFn() {
        close(true);
      }

      function close(rejected) { // jshint ignore:line
        // if the promise has been called already then we shouldn't close
        // the animation again
        if (animationClosed || (animationCompleted && animationPaused)) return;
        animationClosed = true;
        animationPaused = false;

        $$jqLite.removeClass(element, setupClasses);
        $$jqLite.removeClass(element, activeClasses);

        blockKeyframeAnimations(node, false);
        blockTransitions(node, false);

        forEach(temporaryStyles, function(entry) {
          // There is only one way to remove inline style properties entirely from elements.
          // By using `removeProperty` this works, but we need to convert camel-cased CSS
          // styles down to hyphenated values.
          node.style[entry[0]] = '';
        });

        applyAnimationClasses(element, options);
        applyAnimationStyles(element, options);

        // the reason why we have this option is to allow a synchronous closing callback
        // that is fired as SOON as the animation ends (when the CSS is removed) or if
        // the animation never takes off at all. A good example is a leave animation since
        // the element must be removed just after the animation is over or else the element
        // will appear on screen for one animation frame causing an overbearing flicker.
        if (options.onDone) {
          options.onDone();
        }

        // if the preparation function fails then the promise is not setup
        if (runner) {
          runner.complete(!rejected);
        }
      }

      function applyBlocking(duration) {
        if (flags.blockTransition) {
          blockTransitions(node, duration);
        }

        if (flags.blockKeyframeAnimation) {
          blockKeyframeAnimations(node, !!duration);
        }
      }

      function closeAndReturnNoopAnimator() {
        runner = new $$AnimateRunner({
          end: endFn,
          cancel: cancelFn
        });

        close();

        return {
          $$willAnimate: false,
          start: function() {
            return runner;
          },
          end: endFn
        };
      }

      function start() {
        if (animationClosed) return;

        var startTime, events = [];

        // even though we only pause keyframe animations here the pause flag
        // will still happen when transitions are used. Only the transition will
        // not be paused since that is not possible. If the animation ends when
        // paused then it will not complete until unpaused or cancelled.
        var playPause = function(playAnimation) {
          if (!animationCompleted) {
            animationPaused = !playAnimation;
            if (timings.animationDuration) {
              var value = blockKeyframeAnimations(node, animationPaused);
              animationPaused
                  ? temporaryStyles.push(value)
                  : removeFromArray(temporaryStyles, value);
            }
          } else if (animationPaused && playAnimation) {
            animationPaused = false;
            close();
          }
        };

        // checking the stagger duration prevents an accidently cascade of the CSS delay style
        // being inherited from the parent. If the transition duration is zero then we can safely
        // rely that the delay value is an intential stagger delay style.
        var maxStagger = itemIndex > 0
                         && ((timings.transitionDuration && stagger.transitionDuration === 0) ||
                            (timings.animationDuration && stagger.animationDuration === 0))
                         && Math.max(stagger.animationDelay, stagger.transitionDelay);
        if (maxStagger) {
          $timeout(triggerAnimationStart,
                   Math.floor(maxStagger * itemIndex * ONE_SECOND),
                   false);
        } else {
          triggerAnimationStart();
        }

        // this will decorate the existing promise runner with pause/resume methods
        runnerHost.resume = function() {
          playPause(true);
        };

        runnerHost.pause = function() {
          playPause(false);
        };

        function triggerAnimationStart() {
          // just incase a stagger animation kicks in when the animation
          // itself was cancelled entirely
          if (animationClosed) return;

          applyBlocking(false);

          forEach(temporaryStyles, function(entry) {
            var key = entry[0];
            var value = entry[1];
            node.style[key] = value;
          });

          applyAnimationClasses(element, options);
          $$jqLite.addClass(element, activeClasses);

          if (flags.recalculateTimingStyles) {
            fullClassName = node.className + ' ' + setupClasses;
            cacheKey = gcsHashFn(node, fullClassName);

            timings = computeTimings(node, fullClassName, cacheKey);
            relativeDelay = timings.maxDelay;
            maxDelay = Math.max(relativeDelay, 0);
            maxDuration = timings.maxDuration;

            if (maxDuration === 0) {
              close();
              return;
            }

            flags.hasTransitions = timings.transitionDuration > 0;
            flags.hasAnimations = timings.animationDuration > 0;
          }

          if (flags.applyTransitionDelay || flags.applyAnimationDelay) {
            relativeDelay = typeof options.delay !== "boolean" && truthyTimingValue(options.delay)
                  ? parseFloat(options.delay)
                  : relativeDelay;

            maxDelay = Math.max(relativeDelay, 0);

            var delayStyle;
            if (flags.applyTransitionDelay) {
              timings.transitionDelay = relativeDelay;
              delayStyle = getCssDelayStyle(relativeDelay);
              temporaryStyles.push(delayStyle);
              node.style[delayStyle[0]] = delayStyle[1];
            }

            if (flags.applyAnimationDelay) {
              timings.animationDelay = relativeDelay;
              delayStyle = getCssDelayStyle(relativeDelay, true);
              temporaryStyles.push(delayStyle);
              node.style[delayStyle[0]] = delayStyle[1];
            }
          }

          maxDelayTime = maxDelay * ONE_SECOND;
          maxDurationTime = maxDuration * ONE_SECOND;

          if (options.easing) {
            var easeProp, easeVal = options.easing;
            if (flags.hasTransitions) {
              easeProp = TRANSITION_PROP + TIMING_KEY;
              temporaryStyles.push([easeProp, easeVal]);
              node.style[easeProp] = easeVal;
            }
            if (flags.hasAnimations) {
              easeProp = ANIMATION_PROP + TIMING_KEY;
              temporaryStyles.push([easeProp, easeVal]);
              node.style[easeProp] = easeVal;
            }
          }

          if (timings.transitionDuration) {
            events.push(TRANSITIONEND_EVENT);
          }

          if (timings.animationDuration) {
            events.push(ANIMATIONEND_EVENT);
          }

          startTime = Date.now();
          element.on(events.join(' '), onAnimationProgress);
          $timeout(onAnimationExpired, maxDelayTime + CLOSING_TIME_BUFFER * maxDurationTime);

          applyAnimationToStyles(element, options);
        }

        function onAnimationExpired() {
          // although an expired animation is a failed animation, getting to
          // this outcome is very easy if the CSS code screws up. Therefore we
          // should still continue normally as if the animation completed correctly.
          close();
        }

        function onAnimationProgress(event) {
          event.stopPropagation();
          var ev = event.originalEvent || event;
          var timeStamp = ev.$manualTimeStamp || ev.timeStamp || Date.now();

          /* Firefox (or possibly just Gecko) likes to not round values up
           * when a ms measurement is used for the animation */
          var elapsedTime = parseFloat(ev.elapsedTime.toFixed(ELAPSED_TIME_MAX_DECIMAL_PLACES));

          /* $manualTimeStamp is a mocked timeStamp value which is set
           * within browserTrigger(). This is only here so that tests can
           * mock animations properly. Real events fallback to event.timeStamp,
           * or, if they don't, then a timeStamp is automatically created for them.
           * We're checking to see if the timeStamp surpasses the expected delay,
           * but we're using elapsedTime instead of the timeStamp on the 2nd
           * pre-condition since animations sometimes close off early */
          if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
            // we set this flag to ensure that if the transition is paused then, when resumed,
            // the animation will automatically close itself since transitions cannot be paused.
            animationCompleted = true;
            close();
          }
        }
      }
    }
  }];
}];

var $$AnimateCssDriverProvider = ['$$animationProvider', function($$animationProvider) {
  $$animationProvider.drivers.push('$$animateCssDriver');

  var NG_ANIMATE_SHIM_CLASS_NAME = 'ng-animate-shim';
  var NG_ANIMATE_ANCHOR_CLASS_NAME = 'ng-anchor';

  var NG_OUT_ANCHOR_CLASS_NAME = 'ng-anchor-out';
  var NG_IN_ANCHOR_CLASS_NAME = 'ng-anchor-in';

  this.$get = ['$animateCss', '$rootScope', '$$AnimateRunner', '$rootElement', '$document', '$sniffer',
       function($animateCss,   $rootScope,   $$AnimateRunner,   $rootElement,   $document,   $sniffer) {

    // only browsers that support these properties can render animations
    if (!$sniffer.animations && !$sniffer.transitions) return noop;

    var bodyNode = getDomNode($document).body;
    var rootNode = getDomNode($rootElement);

    var rootBodyElement = jqLite(bodyNode.parentNode === rootNode ? bodyNode : rootNode);

    return function initDriverFn(animationDetails) {
      return animationDetails.from && animationDetails.to
          ? prepareFromToAnchorAnimation(animationDetails.from,
                                         animationDetails.to,
                                         animationDetails.classes,
                                         animationDetails.anchors)
          : prepareRegularAnimation(animationDetails);
    };

    function filterCssClasses(classes) {
      //remove all the `ng-` stuff
      return classes.replace(/\bng-\S+\b/g, '');
    }

    function getUniqueValues(a, b) {
      if (isString(a)) a = a.split(' ');
      if (isString(b)) b = b.split(' ');
      return a.filter(function(val) {
        return b.indexOf(val) === -1;
      }).join(' ');
    }

    function prepareAnchoredAnimation(classes, outAnchor, inAnchor) {
      var clone = jqLite(getDomNode(outAnchor).cloneNode(true));
      var startingClasses = filterCssClasses(getClassVal(clone));

      outAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
      inAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);

      clone.addClass(NG_ANIMATE_ANCHOR_CLASS_NAME);

      rootBodyElement.append(clone);

      var animatorIn, animatorOut = prepareOutAnimation();

      // the user may not end up using the `out` animation and
      // only making use of the `in` animation or vice-versa.
      // In either case we should allow this and not assume the
      // animation is over unless both animations are not used.
      if (!animatorOut) {
        animatorIn = prepareInAnimation();
        if (!animatorIn) {
          return end();
        }
      }

      var startingAnimator = animatorOut || animatorIn;

      return {
        start: function() {
          var runner;

          var currentAnimation = startingAnimator.start();
          currentAnimation.done(function() {
            currentAnimation = null;
            if (!animatorIn) {
              animatorIn = prepareInAnimation();
              if (animatorIn) {
                currentAnimation = animatorIn.start();
                currentAnimation.done(function() {
                  currentAnimation = null;
                  end();
                  runner.complete();
                });
                return currentAnimation;
              }
            }
            // in the event that there is no `in` animation
            end();
            runner.complete();
          });

          runner = new $$AnimateRunner({
            end: endFn,
            cancel: endFn
          });

          return runner;

          function endFn() {
            if (currentAnimation) {
              currentAnimation.end();
            }
          }
        }
      };

      function calculateAnchorStyles(anchor) {
        var styles = {};

        var coords = getDomNode(anchor).getBoundingClientRect();

        // we iterate directly since safari messes up and doesn't return
        // all the keys for the coods object when iterated
        forEach(['width','height','top','left'], function(key) {
          var value = coords[key];
          switch (key) {
            case 'top':
              value += bodyNode.scrollTop;
              break;
            case 'left':
              value += bodyNode.scrollLeft;
              break;
          }
          styles[key] = Math.floor(value) + 'px';
        });
        return styles;
      }

      function prepareOutAnimation() {
        var animator = $animateCss(clone, {
          addClass: NG_OUT_ANCHOR_CLASS_NAME,
          delay: true,
          from: calculateAnchorStyles(outAnchor)
        });

        // read the comment within `prepareRegularAnimation` to understand
        // why this check is necessary
        return animator.$$willAnimate ? animator : null;
      }

      function getClassVal(element) {
        return element.attr('class') || '';
      }

      function prepareInAnimation() {
        var endingClasses = filterCssClasses(getClassVal(inAnchor));
        var toAdd = getUniqueValues(endingClasses, startingClasses);
        var toRemove = getUniqueValues(startingClasses, endingClasses);

        var animator = $animateCss(clone, {
          to: calculateAnchorStyles(inAnchor),
          addClass: NG_IN_ANCHOR_CLASS_NAME + ' ' + toAdd,
          removeClass: NG_OUT_ANCHOR_CLASS_NAME + ' ' + toRemove,
          delay: true
        });

        // read the comment within `prepareRegularAnimation` to understand
        // why this check is necessary
        return animator.$$willAnimate ? animator : null;
      }

      function end() {
        clone.remove();
        outAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
        inAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
      }
    }

    function prepareFromToAnchorAnimation(from, to, classes, anchors) {
      var fromAnimation = prepareRegularAnimation(from);
      var toAnimation = prepareRegularAnimation(to);

      var anchorAnimations = [];
      forEach(anchors, function(anchor) {
        var outElement = anchor['out'];
        var inElement = anchor['in'];
        var animator = prepareAnchoredAnimation(classes, outElement, inElement);
        if (animator) {
          anchorAnimations.push(animator);
        }
      });

      // no point in doing anything when there are no elements to animate
      if (!fromAnimation && !toAnimation && anchorAnimations.length === 0) return;

      return {
        start: function() {
          var animationRunners = [];

          if (fromAnimation) {
            animationRunners.push(fromAnimation.start());
          }

          if (toAnimation) {
            animationRunners.push(toAnimation.start());
          }

          forEach(anchorAnimations, function(animation) {
            animationRunners.push(animation.start());
          });

          var runner = new $$AnimateRunner({
            end: endFn,
            cancel: endFn // CSS-driven animations cannot be cancelled, only ended
          });

          $$AnimateRunner.all(animationRunners, function(status) {
            runner.complete(status);
          });

          return runner;

          function endFn() {
            forEach(animationRunners, function(runner) {
              runner.end();
            });
          }
        }
      };
    }

    function prepareRegularAnimation(animationDetails) {
      var element = animationDetails.element;
      var options = animationDetails.options || {};

      if (animationDetails.structural) {
        // structural animations ensure that the CSS classes are always applied
        // before the detection starts.
        options.structural = options.applyClassesEarly = true;

        // we special case the leave animation since we want to ensure that
        // the element is removed as soon as the animation is over. Otherwise
        // a flicker might appear or the element may not be removed at all
        options.event = animationDetails.event;
        if (options.event === 'leave') {
          options.onDone = options.domOperation;
        }
      } else {
        options.event = null;
      }

      var animator = $animateCss(element, options);

      // the driver lookup code inside of $$animation attempts to spawn a
      // driver one by one until a driver returns a.$$willAnimate animator object.
      // $animateCss will always return an object, however, it will pass in
      // a flag as a hint as to whether an animation was detected or not
      return animator.$$willAnimate ? animator : null;
    }
  }];
}];

// TODO(matsko): use caching here to speed things up for detection
// TODO(matsko): add documentation
//  by the time...

var $$AnimateJsProvider = ['$animateProvider', function($animateProvider) {
  this.$get = ['$injector', '$$AnimateRunner', '$$rAFMutex', '$$jqLite',
       function($injector,   $$AnimateRunner,   $$rAFMutex,   $$jqLite) {

    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
         // $animateJs(element, 'enter');
    return function(element, event, classes, options) {
      // the `classes` argument is optional and if it is not used
      // then the classes will be resolved from the element's className
      // property as well as options.addClass/options.removeClass.
      if (arguments.length === 3 && isObject(classes)) {
        options = classes;
        classes = null;
      }

      options = prepareAnimationOptions(options);
      if (!classes) {
        classes = element.attr('class') || '';
        if (options.addClass) {
          classes += ' ' + options.addClass;
        }
        if (options.removeClass) {
          classes += ' ' + options.removeClass;
        }
      }

      var classesToAdd = options.addClass;
      var classesToRemove = options.removeClass;

      // the lookupAnimations function returns a series of animation objects that are
      // matched up with one or more of the CSS classes. These animation objects are
      // defined via the module.animation factory function. If nothing is detected then
      // we don't return anything which then makes $animation query the next driver.
      var animations = lookupAnimations(classes);
      var before, after;
      if (animations.length) {
        var afterFn, beforeFn;
        if (event == 'leave') {
          beforeFn = 'leave';
          afterFn = 'afterLeave'; // TODO(matsko): get rid of this
        } else {
          beforeFn = 'before' + event.charAt(0).toUpperCase() + event.substr(1);
          afterFn = event;
        }

        if (event !== 'enter' && event !== 'move') {
          before = packageAnimations(element, event, options, animations, beforeFn);
        }
        after  = packageAnimations(element, event, options, animations, afterFn);
      }

      // no matching animations
      if (!before && !after) return;

      function applyOptions() {
        options.domOperation();
        applyAnimationClasses(element, options);
      }

      return {
        start: function() {
          var closeActiveAnimations;
          var chain = [];

          if (before) {
            chain.push(function(fn) {
              closeActiveAnimations = before(fn);
            });
          }

          if (chain.length) {
            chain.push(function(fn) {
              applyOptions();
              fn(true);
            });
          } else {
            applyOptions();
          }

          if (after) {
            chain.push(function(fn) {
              closeActiveAnimations = after(fn);
            });
          }

          var animationClosed = false;
          var runner = new $$AnimateRunner({
            end: function() {
              endAnimations();
            },
            cancel: function() {
              endAnimations(true);
            }
          });

          $$AnimateRunner.chain(chain, onComplete);
          return runner;

          function onComplete(success) {
            animationClosed = true;
            applyOptions();
            applyAnimationStyles(element, options);
            runner.complete(success);
          }

          function endAnimations(cancelled) {
            if (!animationClosed) {
              (closeActiveAnimations || noop)(cancelled);
              onComplete(cancelled);
            }
          }
        }
      };

      function executeAnimationFn(fn, element, event, options, onDone) {
        var args;
        switch (event) {
          case 'animate':
            args = [element, options.from, options.to, onDone];
            break;

          case 'setClass':
            args = [element, classesToAdd, classesToRemove, onDone];
            break;

          case 'addClass':
            args = [element, classesToAdd, onDone];
            break;

          case 'removeClass':
            args = [element, classesToRemove, onDone];
            break;

          default:
            args = [element, onDone];
            break;
        }

        args.push(options);

        var value = fn.apply(fn, args);
        if (value) {
          if (isFunction(value.start)) {
            value = value.start();
          }

          if (value instanceof $$AnimateRunner) {
            value.done(onDone);
          } else if (isFunction(value)) {
            // optional onEnd / onCancel callback
            return value;
          }
        }

        return noop;
      }

      function groupEventedAnimations(element, event, options, animations, fnName) {
        var operations = [];
        forEach(animations, function(ani) {
          var animation = ani[fnName];
          if (!animation) return;

          // note that all of these animations will run in parallel
          operations.push(function() {
            var runner;
            var endProgressCb;

            var resolved = false;
            var onAnimationComplete = function(rejected) {
              if (!resolved) {
                resolved = true;
                (endProgressCb || noop)(rejected);
                runner.complete(!rejected);
              }
            };

            runner = new $$AnimateRunner({
              end: function() {
                onAnimationComplete();
              },
              cancel: function() {
                onAnimationComplete(true);
              }
            });

            endProgressCb = executeAnimationFn(animation, element, event, options, function(result) {
              var cancelled = result === false;
              onAnimationComplete(cancelled);
            });

            return runner;
          });
        });

        return operations;
      }

      function packageAnimations(element, event, options, animations, fnName) {
        var operations = groupEventedAnimations(element, event, options, animations, fnName);
        if (operations.length === 0) {
          var a,b;
          if (fnName === 'beforeSetClass') {
            a = groupEventedAnimations(element, 'removeClass', options, animations, 'beforeRemoveClass');
            b = groupEventedAnimations(element, 'addClass', options, animations, 'beforeAddClass');
          } else if (fnName === 'setClass') {
            a = groupEventedAnimations(element, 'removeClass', options, animations, 'removeClass');
            b = groupEventedAnimations(element, 'addClass', options, animations, 'addClass');
          }

          if (a) {
            operations = operations.concat(a);
          }
          if (b) {
            operations = operations.concat(b);
          }
        }

        if (operations.length === 0) return;

        // TODO(matsko): add documentation
        return function startAnimation(callback) {
          var runners = [];
          if (operations.length) {
            forEach(operations, function(animateFn) {
              runners.push(animateFn());
            });
          }

          runners.length ? $$AnimateRunner.all(runners, callback) : callback();

          return function endFn(reject) {
            forEach(runners, function(runner) {
              reject ? runner.cancel() : runner.end();
            });
          };
        };
      }
    };

    function lookupAnimations(classes) {
      classes = isArray(classes) ? classes : classes.split(' ');
      var matches = [], flagMap = {};
      for (var i=0; i < classes.length; i++) {
        var klass = classes[i],
            animationFactory = $animateProvider.$$registeredAnimations[klass];
        if (animationFactory && !flagMap[klass]) {
          matches.push($injector.get(animationFactory));
          flagMap[klass] = true;
        }
      }
      return matches;
    }
  }];
}];

var $$AnimateJsDriverProvider = ['$$animationProvider', function($$animationProvider) {
  $$animationProvider.drivers.push('$$animateJsDriver');
  this.$get = ['$$animateJs', '$$AnimateRunner', function($$animateJs, $$AnimateRunner) {
    return function initDriverFn(animationDetails) {
      if (animationDetails.from && animationDetails.to) {
        var fromAnimation = prepareAnimation(animationDetails.from);
        var toAnimation = prepareAnimation(animationDetails.to);
        if (!fromAnimation && !toAnimation) return;

        return {
          start: function() {
            var animationRunners = [];

            if (fromAnimation) {
              animationRunners.push(fromAnimation.start());
            }

            if (toAnimation) {
              animationRunners.push(toAnimation.start());
            }

            $$AnimateRunner.all(animationRunners, done);

            var runner = new $$AnimateRunner({
              end: endFnFactory(),
              cancel: endFnFactory()
            });

            return runner;

            function endFnFactory() {
              return function() {
                forEach(animationRunners, function(runner) {
                  // at this point we cannot cancel animations for groups just yet. 1.5+
                  runner.end();
                });
              };
            }

            function done(status) {
              runner.complete(status);
            }
          }
        };
      } else {
        return prepareAnimation(animationDetails);
      }
    };

    function prepareAnimation(animationDetails) {
      // TODO(matsko): make sure to check for grouped animations and delegate down to normal animations
      var element = animationDetails.element;
      var event = animationDetails.event;
      var options = animationDetails.options;
      var classes = animationDetails.classes;
      return $$animateJs(element, event, classes, options);
    }
  }];
}];

var NG_ANIMATE_ATTR_NAME = 'data-ng-animate';
var NG_ANIMATE_PIN_DATA = '$ngAnimatePin';
var $$AnimateQueueProvider = ['$animateProvider', function($animateProvider) {
  var PRE_DIGEST_STATE = 1;
  var RUNNING_STATE = 2;

  var rules = this.rules = {
    skip: [],
    cancel: [],
    join: []
  };

  function isAllowed(ruleType, element, currentAnimation, previousAnimation) {
    return rules[ruleType].some(function(fn) {
      return fn(element, currentAnimation, previousAnimation);
    });
  }

  function hasAnimationClasses(options, and) {
    options = options || {};
    var a = (options.addClass || '').length > 0;
    var b = (options.removeClass || '').length > 0;
    return and ? a && b : a || b;
  }

  rules.join.push(function(element, newAnimation, currentAnimation) {
    // if the new animation is class-based then we can just tack that on
    return !newAnimation.structural && hasAnimationClasses(newAnimation.options);
  });

  rules.skip.push(function(element, newAnimation, currentAnimation) {
    // there is no need to animate anything if no classes are being added and
    // there is no structural animation that will be triggered
    return !newAnimation.structural && !hasAnimationClasses(newAnimation.options);
  });

  rules.skip.push(function(element, newAnimation, currentAnimation) {
    // why should we trigger a new structural animation if the element will
    // be removed from the DOM anyway?
    return currentAnimation.event == 'leave' && newAnimation.structural;
  });

  rules.skip.push(function(element, newAnimation, currentAnimation) {
    // if there is a current animation then skip the class-based animation
    return currentAnimation.structural && !newAnimation.structural;
  });

  rules.cancel.push(function(element, newAnimation, currentAnimation) {
    // there can never be two structural animations running at the same time
    return currentAnimation.structural && newAnimation.structural;
  });

  rules.cancel.push(function(element, newAnimation, currentAnimation) {
    // if the previous animation is already running, but the new animation will
    // be triggered, but the new animation is structural
    return currentAnimation.state === RUNNING_STATE && newAnimation.structural;
  });

  rules.cancel.push(function(element, newAnimation, currentAnimation) {
    var nO = newAnimation.options;
    var cO = currentAnimation.options;

    // if the exact same CSS class is added/removed then it's safe to cancel it
    return (nO.addClass && nO.addClass === cO.removeClass) || (nO.removeClass && nO.removeClass === cO.addClass);
  });

  this.$get = ['$$rAF', '$rootScope', '$rootElement', '$document', '$$HashMap',
               '$$animation', '$$AnimateRunner', '$templateRequest', '$$jqLite',
       function($$rAF,   $rootScope,   $rootElement,   $document,   $$HashMap,
                $$animation,   $$AnimateRunner,   $templateRequest,   $$jqLite) {

    var activeAnimationsLookup = new $$HashMap();
    var disabledElementsLookup = new $$HashMap();

    var animationsEnabled = null;

    // Wait until all directive and route-related templates are downloaded and
    // compiled. The $templateRequest.totalPendingRequests variable keeps track of
    // all of the remote templates being currently downloaded. If there are no
    // templates currently downloading then the watcher will still fire anyway.
    var deregisterWatch = $rootScope.$watch(
      function() { return $templateRequest.totalPendingRequests === 0; },
      function(isEmpty) {
        if (!isEmpty) return;
        deregisterWatch();

        // Now that all templates have been downloaded, $animate will wait until
        // the post digest queue is empty before enabling animations. By having two
        // calls to $postDigest calls we can ensure that the flag is enabled at the
        // very end of the post digest queue. Since all of the animations in $animate
        // use $postDigest, it's important that the code below executes at the end.
        // This basically means that the page is fully downloaded and compiled before
        // any animations are triggered.
        $rootScope.$$postDigest(function() {
          $rootScope.$$postDigest(function() {
            // we check for null directly in the event that the application already called
            // .enabled() with whatever arguments that it provided it with
            if (animationsEnabled === null) {
              animationsEnabled = true;
            }
          });
        });
      }
    );

    var bodyElement = jqLite($document[0].body);

    var callbackRegistry = {};

    // remember that the classNameFilter is set during the provider/config
    // stage therefore we can optimize here and setup a helper function
    var classNameFilter = $animateProvider.classNameFilter();
    var isAnimatableClassName = !classNameFilter
              ? function() { return true; }
              : function(className) {
                return classNameFilter.test(className);
              };

    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);

    function normalizeAnimationOptions(element, options) {
      return mergeAnimationOptions(element, options, {});
    }

    function findCallbacks(element, event) {
      var targetNode = getDomNode(element);

      var matches = [];
      var entries = callbackRegistry[event];
      if (entries) {
        forEach(entries, function(entry) {
          if (entry.node.contains(targetNode)) {
            matches.push(entry.callback);
          }
        });
      }

      return matches;
    }

    function triggerCallback(event, element, phase, data) {
      $$rAF(function() {
        forEach(findCallbacks(element, event), function(callback) {
          callback(element, phase, data);
        });
      });
    }

    return {
      on: function(event, container, callback) {
        var node = extractElementNode(container);
        callbackRegistry[event] = callbackRegistry[event] || [];
        callbackRegistry[event].push({
          node: node,
          callback: callback
        });
      },

      off: function(event, container, callback) {
        var entries = callbackRegistry[event];
        if (!entries) return;

        callbackRegistry[event] = arguments.length === 1
            ? null
            : filterFromRegistry(entries, container, callback);

        function filterFromRegistry(list, matchContainer, matchCallback) {
          var containerNode = extractElementNode(matchContainer);
          return list.filter(function(entry) {
            var isMatch = entry.node === containerNode &&
                            (!matchCallback || entry.callback === matchCallback);
            return !isMatch;
          });
        }
      },

      pin: function(element, parentElement) {
        assertArg(isElement(element), 'element', 'not an element');
        assertArg(isElement(parentElement), 'parentElement', 'not an element');
        element.data(NG_ANIMATE_PIN_DATA, parentElement);
      },

      push: function(element, event, options, domOperation) {
        options = options || {};
        options.domOperation = domOperation;
        return queueAnimation(element, event, options);
      },

      // this method has four signatures:
      //  () - global getter
      //  (bool) - global setter
      //  (element) - element getter
      //  (element, bool) - element setter<F37>
      enabled: function(element, bool) {
        var argCount = arguments.length;

        if (argCount === 0) {
          // () - Global getter
          bool = !!animationsEnabled;
        } else {
          var hasElement = isElement(element);

          if (!hasElement) {
            // (bool) - Global setter
            bool = animationsEnabled = !!element;
          } else {
            var node = getDomNode(element);
            var recordExists = disabledElementsLookup.get(node);

            if (argCount === 1) {
              // (element) - Element getter
              bool = !recordExists;
            } else {
              // (element, bool) - Element setter
              bool = !!bool;
              if (!bool) {
                disabledElementsLookup.put(node, true);
              } else if (recordExists) {
                disabledElementsLookup.remove(node);
              }
            }
          }
        }

        return bool;
      }
    };

    function queueAnimation(element, event, options) {
      var node, parent;
      element = stripCommentsFromElement(element);
      if (element) {
        node = getDomNode(element);
        parent = element.parent();
      }

      options = prepareAnimationOptions(options);

      // we create a fake runner with a working promise.
      // These methods will become available after the digest has passed
      var runner = new $$AnimateRunner();

      // there are situations where a directive issues an animation for
      // a jqLite wrapper that contains only comment nodes... If this
      // happens then there is no way we can perform an animation
      if (!node) {
        close();
        return runner;
      }

      if (isArray(options.addClass)) {
        options.addClass = options.addClass.join(' ');
      }

      if (isArray(options.removeClass)) {
        options.removeClass = options.removeClass.join(' ');
      }

      if (options.from && !isObject(options.from)) {
        options.from = null;
      }

      if (options.to && !isObject(options.to)) {
        options.to = null;
      }

      var className = [node.className, options.addClass, options.removeClass].join(' ');
      if (!isAnimatableClassName(className)) {
        close();
        return runner;
      }

      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;

      // this is a hard disable of all animations for the application or on
      // the element itself, therefore  there is no need to continue further
      // past this point if not enabled
      var skipAnimations = !animationsEnabled || disabledElementsLookup.get(node);
      var existingAnimation = (!skipAnimations && activeAnimationsLookup.get(node)) || {};
      var hasExistingAnimation = !!existingAnimation.state;

      // there is no point in traversing the same collection of parent ancestors if a followup
      // animation will be run on the same element that already did all that checking work
      if (!skipAnimations && (!hasExistingAnimation || existingAnimation.state != PRE_DIGEST_STATE)) {
        skipAnimations = !areAnimationsAllowed(element, parent, event);
      }

      if (skipAnimations) {
        close();
        return runner;
      }

      if (isStructural) {
        closeChildAnimations(element);
      }

      var newAnimation = {
        structural: isStructural,
        element: element,
        event: event,
        close: close,
        options: options,
        runner: runner
      };

      if (hasExistingAnimation) {
        var skipAnimationFlag = isAllowed('skip', element, newAnimation, existingAnimation);
        if (skipAnimationFlag) {
          if (existingAnimation.state === RUNNING_STATE) {
            close();
            return runner;
          } else {
            mergeAnimationOptions(element, existingAnimation.options, options);
            return existingAnimation.runner;
          }
        }

        var cancelAnimationFlag = isAllowed('cancel', element, newAnimation, existingAnimation);
        if (cancelAnimationFlag) {
          if (existingAnimation.state === RUNNING_STATE) {
            // this will end the animation right away and it is safe
            // to do so since the animation is already running and the
            // runner callback code will run in async
            existingAnimation.runner.end();
          } else if (existingAnimation.structural) {
            // this means that the animation is queued into a digest, but
            // hasn't started yet. Therefore it is safe to run the close
            // method which will call the runner methods in async.
            existingAnimation.close();
          } else {
            // this will merge the existing animation options into this new follow-up animation
            mergeAnimationOptions(element, newAnimation.options, existingAnimation.options);
          }
        } else {
          // a joined animation means that this animation will take over the existing one
          // so an example would involve a leave animation taking over an enter. Then when
          // the postDigest kicks in the enter will be ignored.
          var joinAnimationFlag = isAllowed('join', element, newAnimation, existingAnimation);
          if (joinAnimationFlag) {
            if (existingAnimation.state === RUNNING_STATE) {
              normalizeAnimationOptions(element, options);
            } else {
              event = newAnimation.event = existingAnimation.event;
              options = mergeAnimationOptions(element, existingAnimation.options, newAnimation.options);
              return runner;
            }
          }
        }
      } else {
        // normalization in this case means that it removes redundant CSS classes that
        // already exist (addClass) or do not exist (removeClass) on the element
        normalizeAnimationOptions(element, options);
      }

      // when the options are merged and cleaned up we may end up not having to do
      // an animation at all, therefore we should check this before issuing a post
      // digest callback. Structural animations will always run no matter what.
      var isValidAnimation = newAnimation.structural;
      if (!isValidAnimation) {
        // animate (from/to) can be quickly checked first, otherwise we check if any classes are present
        isValidAnimation = (newAnimation.event === 'animate' && Object.keys(newAnimation.options.to || {}).length > 0)
                            || hasAnimationClasses(newAnimation.options);
      }

      if (!isValidAnimation) {
        close();
        clearElementAnimationState(element);
        return runner;
      }

      if (isStructural) {
        closeParentClassBasedAnimations(parent);
      }

      // the counter keeps track of cancelled animations
      var counter = (existingAnimation.counter || 0) + 1;
      newAnimation.counter = counter;

      markElementAnimationState(element, PRE_DIGEST_STATE, newAnimation);

      $rootScope.$$postDigest(function() {
        var animationDetails = activeAnimationsLookup.get(node);
        var animationCancelled = !animationDetails;
        animationDetails = animationDetails || {};

        // if addClass/removeClass is called before something like enter then the
        // registered parent element may not be present. The code below will ensure
        // that a final value for parent element is obtained
        var parentElement = element.parent() || [];

        // animate/structural/class-based animations all have requirements. Otherwise there
        // is no point in performing an animation. The parent node must also be set.
        var isValidAnimation = parentElement.length > 0
                                && (animationDetails.event === 'animate'
                                    || animationDetails.structural
                                    || hasAnimationClasses(animationDetails.options));

        // this means that the previous animation was cancelled
        // even if the follow-up animation is the same event
        if (animationCancelled || animationDetails.counter !== counter || !isValidAnimation) {
          // if another animation did not take over then we need
          // to make sure that the domOperation and options are
          // handled accordingly
          if (animationCancelled) {
            applyAnimationClasses(element, options);
            applyAnimationStyles(element, options);
          }

          // if the event changed from something like enter to leave then we do
          // it, otherwise if it's the same then the end result will be the same too
          if (animationCancelled || (isStructural && animationDetails.event !== event)) {
            options.domOperation();
            runner.end();
          }

          // in the event that the element animation was not cancelled or a follow-up animation
          // isn't allowed to animate from here then we need to clear the state of the element
          // so that any future animations won't read the expired animation data.
          if (!isValidAnimation) {
            clearElementAnimationState(element);
          }

          return;
        }

        // this combined multiple class to addClass / removeClass into a setClass event
        // so long as a structural event did not take over the animation
        event = !animationDetails.structural && hasAnimationClasses(animationDetails.options, true)
            ? 'setClass'
            : animationDetails.event;

        if (animationDetails.structural) {
          closeParentClassBasedAnimations(parentElement);
        }

        markElementAnimationState(element, RUNNING_STATE);
        var realRunner = $$animation(element, event, animationDetails.options);
        realRunner.done(function(status) {
          close(!status);
          var animationDetails = activeAnimationsLookup.get(node);
          if (animationDetails && animationDetails.counter === counter) {
            clearElementAnimationState(getDomNode(element));
          }
          notifyProgress(runner, event, 'close', {});
        });

        // this will update the runner's flow-control events based on
        // the `realRunner` object.
        runner.setHost(realRunner);
        notifyProgress(runner, event, 'start', {});
      });

      return runner;

      function notifyProgress(runner, event, phase, data) {
        triggerCallback(event, element, phase, data);
        runner.progress(event, phase, data);
      }

      function close(reject) { // jshint ignore:line
        applyAnimationClasses(element, options);
        applyAnimationStyles(element, options);
        options.domOperation();
        runner.complete(!reject);
      }
    }

    function closeChildAnimations(element) {
      var node = getDomNode(element);
      var children = node.querySelectorAll('[' + NG_ANIMATE_ATTR_NAME + ']');
      forEach(children, function(child) {
        var state = parseInt(child.getAttribute(NG_ANIMATE_ATTR_NAME));
        var animationDetails = activeAnimationsLookup.get(child);
        switch (state) {
          case RUNNING_STATE:
            animationDetails.runner.end();
            /* falls through */
          case PRE_DIGEST_STATE:
            if (animationDetails) {
              activeAnimationsLookup.remove(child);
            }
            break;
        }
      });
    }

    function clearElementAnimationState(element) {
      var node = getDomNode(element);
      node.removeAttribute(NG_ANIMATE_ATTR_NAME);
      activeAnimationsLookup.remove(node);
    }

    function isMatchingElement(nodeOrElmA, nodeOrElmB) {
      return getDomNode(nodeOrElmA) === getDomNode(nodeOrElmB);
    }

    function closeParentClassBasedAnimations(startingElement) {
      var parentNode = getDomNode(startingElement);
      do {
        if (!parentNode || parentNode.nodeType !== ELEMENT_NODE) break;

        var animationDetails = activeAnimationsLookup.get(parentNode);
        if (animationDetails) {
          examineParentAnimation(parentNode, animationDetails);
        }

        parentNode = parentNode.parentNode;
      } while (true);

      // since animations are detected from CSS classes, we need to flush all parent
      // class-based animations so that the parent classes are all present for child
      // animations to properly function (otherwise any CSS selectors may not work)
      function examineParentAnimation(node, animationDetails) {
        // enter/leave/move always have priority
        if (animationDetails.structural || !hasAnimationClasses(animationDetails.options)) return;

        if (animationDetails.state === RUNNING_STATE) {
          animationDetails.runner.end();
        }
        clearElementAnimationState(node);
      }
    }

    function areAnimationsAllowed(element, parentElement, event) {
      var bodyElementDetected = false;
      var rootElementDetected = false;
      var parentAnimationDetected = false;
      var animateChildren;

      var parentHost = element.data(NG_ANIMATE_PIN_DATA);
      if (parentHost) {
        parentElement = parentHost;
      }

      while (parentElement && parentElement.length) {
        if (!rootElementDetected) {
          // angular doesn't want to attempt to animate elements outside of the application
          // therefore we need to ensure that the rootElement is an ancestor of the current element
          rootElementDetected = isMatchingElement(parentElement, $rootElement);
        }

        var parentNode = parentElement[0];
        if (parentNode.nodeType !== ELEMENT_NODE) {
          // no point in inspecting the #document element
          break;
        }

        var details = activeAnimationsLookup.get(parentNode) || {};
        // either an enter, leave or move animation will commence
        // therefore we can't allow any animations to take place
        // but if a parent animation is class-based then that's ok
        if (!parentAnimationDetected) {
          parentAnimationDetected = details.structural || disabledElementsLookup.get(parentNode);
        }

        if (isUndefined(animateChildren) || animateChildren === true) {
          var value = parentElement.data(NG_ANIMATE_CHILDREN_DATA);
          if (isDefined(value)) {
            animateChildren = value;
          }
        }

        // there is no need to continue traversing at this point
        if (parentAnimationDetected && animateChildren === false) break;

        if (!rootElementDetected) {
          // angular doesn't want to attempt to animate elements outside of the application
          // therefore we need to ensure that the rootElement is an ancestor of the current element
          rootElementDetected = isMatchingElement(parentElement, $rootElement);
          if (!rootElementDetected) {
            parentHost = parentElement.data(NG_ANIMATE_PIN_DATA);
            if (parentHost) {
              parentElement = parentHost;
            }
          }
        }

        if (!bodyElementDetected) {
          // we also need to ensure that the element is or will be apart of the body element
          // otherwise it is pointless to even issue an animation to be rendered
          bodyElementDetected = isMatchingElement(parentElement, bodyElement);
        }

        parentElement = parentElement.parent();
      }

      var allowAnimation = !parentAnimationDetected || animateChildren;
      return allowAnimation && rootElementDetected && bodyElementDetected;
    }

    function markElementAnimationState(element, state, details) {
      details = details || {};
      details.state = state;

      var node = getDomNode(element);
      node.setAttribute(NG_ANIMATE_ATTR_NAME, state);

      var oldValue = activeAnimationsLookup.get(node);
      var newValue = oldValue
          ? extend(oldValue, details)
          : details;
      activeAnimationsLookup.put(node, newValue);
    }
  }];
}];

var $$rAFMutexFactory = ['$$rAF', function($$rAF) {
  return function() {
    var passed = false;
    $$rAF(function() {
      passed = true;
    });
    return function(fn) {
      passed ? fn() : $$rAF(fn);
    };
  };
}];

var $$AnimateRunnerFactory = ['$q', '$$rAFMutex', function($q, $$rAFMutex) {
  var INITIAL_STATE = 0;
  var DONE_PENDING_STATE = 1;
  var DONE_COMPLETE_STATE = 2;

  AnimateRunner.chain = function(chain, callback) {
    var index = 0;

    next();
    function next() {
      if (index === chain.length) {
        callback(true);
        return;
      }

      chain[index](function(response) {
        if (response === false) {
          callback(false);
          return;
        }
        index++;
        next();
      });
    }
  };

  AnimateRunner.all = function(runners, callback) {
    var count = 0;
    var status = true;
    forEach(runners, function(runner) {
      runner.done(onProgress);
    });

    function onProgress(response) {
      status = status && response;
      if (++count === runners.length) {
        callback(status);
      }
    }
  };

  function AnimateRunner(host) {
    this.setHost(host);

    this._doneCallbacks = [];
    this._runInAnimationFrame = $$rAFMutex();
    this._state = 0;
  }

  AnimateRunner.prototype = {
    setHost: function(host) {
      this.host = host || {};
    },

    done: function(fn) {
      if (this._state === DONE_COMPLETE_STATE) {
        fn();
      } else {
        this._doneCallbacks.push(fn);
      }
    },

    progress: noop,

    getPromise: function() {
      if (!this.promise) {
        var self = this;
        this.promise = $q(function(resolve, reject) {
          self.done(function(status) {
            status === false ? reject() : resolve();
          });
        });
      }
      return this.promise;
    },

    then: function(resolveHandler, rejectHandler) {
      return this.getPromise().then(resolveHandler, rejectHandler);
    },

    'catch': function(handler) {
      return this.getPromise()['catch'](handler);
    },

    'finally': function(handler) {
      return this.getPromise()['finally'](handler);
    },

    pause: function() {
      if (this.host.pause) {
        this.host.pause();
      }
    },

    resume: function() {
      if (this.host.resume) {
        this.host.resume();
      }
    },

    end: function() {
      if (this.host.end) {
        this.host.end();
      }
      this._resolve(true);
    },

    cancel: function() {
      if (this.host.cancel) {
        this.host.cancel();
      }
      this._resolve(false);
    },

    complete: function(response) {
      var self = this;
      if (self._state === INITIAL_STATE) {
        self._state = DONE_PENDING_STATE;
        self._runInAnimationFrame(function() {
          self._resolve(response);
        });
      }
    },

    _resolve: function(response) {
      if (this._state !== DONE_COMPLETE_STATE) {
        forEach(this._doneCallbacks, function(fn) {
          fn(response);
        });
        this._doneCallbacks.length = 0;
        this._state = DONE_COMPLETE_STATE;
      }
    }
  };

  return AnimateRunner;
}];

var $$AnimationProvider = ['$animateProvider', function($animateProvider) {
  var NG_ANIMATE_REF_ATTR = 'ng-animate-ref';

  var drivers = this.drivers = [];

  var RUNNER_STORAGE_KEY = '$$animationRunner';

  function setRunner(element, runner) {
    element.data(RUNNER_STORAGE_KEY, runner);
  }

  function removeRunner(element) {
    element.removeData(RUNNER_STORAGE_KEY);
  }

  function getRunner(element) {
    return element.data(RUNNER_STORAGE_KEY);
  }

  this.$get = ['$$jqLite', '$rootScope', '$injector', '$$AnimateRunner', '$$rAFScheduler',
       function($$jqLite,   $rootScope,   $injector,   $$AnimateRunner,   $$rAFScheduler) {

    var animationQueue = [];
    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);

    var totalPendingClassBasedAnimations = 0;
    var totalActiveClassBasedAnimations = 0;
    var classBasedAnimationsQueue = [];

    // TODO(matsko): document the signature in a better way
    return function(element, event, options) {
      options = prepareAnimationOptions(options);
      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;

      // there is no animation at the current moment, however
      // these runner methods will get later updated with the
      // methods leading into the driver's end/cancel methods
      // for now they just stop the animation from starting
      var runner = new $$AnimateRunner({
        end: function() { close(); },
        cancel: function() { close(true); }
      });

      if (!drivers.length) {
        close();
        return runner;
      }

      setRunner(element, runner);

      var classes = mergeClasses(element.attr('class'), mergeClasses(options.addClass, options.removeClass));
      var tempClasses = options.tempClasses;
      if (tempClasses) {
        classes += ' ' + tempClasses;
        options.tempClasses = null;
      }

      var classBasedIndex;
      if (!isStructural) {
        classBasedIndex = totalPendingClassBasedAnimations;
        totalPendingClassBasedAnimations += 1;
      }

      animationQueue.push({
        // this data is used by the postDigest code and passed into
        // the driver step function
        element: element,
        classes: classes,
        event: event,
        classBasedIndex: classBasedIndex,
        structural: isStructural,
        options: options,
        beforeStart: beforeStart,
        close: close
      });

      element.on('$destroy', handleDestroyedElement);

      // we only want there to be one function called within the post digest
      // block. This way we can group animations for all the animations that
      // were apart of the same postDigest flush call.
      if (animationQueue.length > 1) return runner;

      $rootScope.$$postDigest(function() {
        totalActiveClassBasedAnimations = totalPendingClassBasedAnimations;
        totalPendingClassBasedAnimations = 0;
        classBasedAnimationsQueue.length = 0;

        var animations = [];
        forEach(animationQueue, function(entry) {
          // the element was destroyed early on which removed the runner
          // form its storage. This means we can't animate this element
          // at all and it already has been closed due to destruction.
          if (getRunner(entry.element)) {
            animations.push(entry);
          }
        });

        // now any future animations will be in another postDigest
        animationQueue.length = 0;

        forEach(groupAnimations(animations), function(animationEntry) {
          if (animationEntry.structural) {
            triggerAnimationStart();
          } else {
            classBasedAnimationsQueue.push({
              node: getDomNode(animationEntry.element),
              fn: triggerAnimationStart
            });

            if (animationEntry.classBasedIndex === totalActiveClassBasedAnimations - 1) {
              // we need to sort each of the animations in order of parent to child
              // relationships. This ensures that the child classes are applied at the
              // right time.
              classBasedAnimationsQueue = classBasedAnimationsQueue.sort(function(a,b) {
                return b.node.contains(a.node);
              }).map(function(entry) {
                return entry.fn;
              });

              $$rAFScheduler(classBasedAnimationsQueue);
            }
          }

          function triggerAnimationStart() {
            // it's important that we apply the `ng-animate` CSS class and the
            // temporary classes before we do any driver invoking since these
            // CSS classes may be required for proper CSS detection.
            animationEntry.beforeStart();

            var startAnimationFn, closeFn = animationEntry.close;

            // in the event that the element was removed before the digest runs or
            // during the RAF sequencing then we should not trigger the animation.
            var targetElement = animationEntry.anchors
                ? (animationEntry.from.element || animationEntry.to.element)
                : animationEntry.element;

            if (getRunner(targetElement)) {
              var operation = invokeFirstDriver(animationEntry);
              if (operation) {
                startAnimationFn = operation.start;
              }
            }

            if (!startAnimationFn) {
              closeFn();
            } else {
              var animationRunner = startAnimationFn();
              animationRunner.done(function(status) {
                closeFn(!status);
              });
              updateAnimationRunners(animationEntry, animationRunner);
            }
          }
        });
      });

      return runner;

      // TODO(matsko): change to reference nodes
      function getAnchorNodes(node) {
        var SELECTOR = '[' + NG_ANIMATE_REF_ATTR + ']';
        var items = node.hasAttribute(NG_ANIMATE_REF_ATTR)
              ? [node]
              : node.querySelectorAll(SELECTOR);
        var anchors = [];
        forEach(items, function(node) {
          var attr = node.getAttribute(NG_ANIMATE_REF_ATTR);
          if (attr && attr.length) {
            anchors.push(node);
          }
        });
        return anchors;
      }

      function groupAnimations(animations) {
        var preparedAnimations = [];
        var refLookup = {};
        forEach(animations, function(animation, index) {
          var element = animation.element;
          var node = getDomNode(element);
          var event = animation.event;
          var enterOrMove = ['enter', 'move'].indexOf(event) >= 0;
          var anchorNodes = animation.structural ? getAnchorNodes(node) : [];

          if (anchorNodes.length) {
            var direction = enterOrMove ? 'to' : 'from';

            forEach(anchorNodes, function(anchor) {
              var key = anchor.getAttribute(NG_ANIMATE_REF_ATTR);
              refLookup[key] = refLookup[key] || {};
              refLookup[key][direction] = {
                animationID: index,
                element: jqLite(anchor)
              };
            });
          } else {
            preparedAnimations.push(animation);
          }
        });

        var usedIndicesLookup = {};
        var anchorGroups = {};
        forEach(refLookup, function(operations, key) {
          var from = operations.from;
          var to = operations.to;

          if (!from || !to) {
            // only one of these is set therefore we can't have an
            // anchor animation since all three pieces are required
            var index = from ? from.animationID : to.animationID;
            var indexKey = index.toString();
            if (!usedIndicesLookup[indexKey]) {
              usedIndicesLookup[indexKey] = true;
              preparedAnimations.push(animations[index]);
            }
            return;
          }

          var fromAnimation = animations[from.animationID];
          var toAnimation = animations[to.animationID];
          var lookupKey = from.animationID.toString();
          if (!anchorGroups[lookupKey]) {
            var group = anchorGroups[lookupKey] = {
              structural: true,
              beforeStart: function() {
                fromAnimation.beforeStart();
                toAnimation.beforeStart();
              },
              close: function() {
                fromAnimation.close();
                toAnimation.close();
              },
              classes: cssClassesIntersection(fromAnimation.classes, toAnimation.classes),
              from: fromAnimation,
              to: toAnimation,
              anchors: [] // TODO(matsko): change to reference nodes
            };

            // the anchor animations require that the from and to elements both have at least
            // one shared CSS class which effictively marries the two elements together to use
            // the same animation driver and to properly sequence the anchor animation.
            if (group.classes.length) {
              preparedAnimations.push(group);
            } else {
              preparedAnimations.push(fromAnimation);
              preparedAnimations.push(toAnimation);
            }
          }

          anchorGroups[lookupKey].anchors.push({
            'out': from.element, 'in': to.element
          });
        });

        return preparedAnimations;
      }

      function cssClassesIntersection(a,b) {
        a = a.split(' ');
        b = b.split(' ');
        var matches = [];

        for (var i = 0; i < a.length; i++) {
          var aa = a[i];
          if (aa.substring(0,3) === 'ng-') continue;

          for (var j = 0; j < b.length; j++) {
            if (aa === b[j]) {
              matches.push(aa);
              break;
            }
          }
        }

        return matches.join(' ');
      }

      function invokeFirstDriver(animationDetails) {
        // we loop in reverse order since the more general drivers (like CSS and JS)
        // may attempt more elements, but custom drivers are more particular
        for (var i = drivers.length - 1; i >= 0; i--) {
          var driverName = drivers[i];
          if (!$injector.has(driverName)) continue; // TODO(matsko): remove this check

          var factory = $injector.get(driverName);
          var driver = factory(animationDetails);
          if (driver) {
            return driver;
          }
        }
      }

      function beforeStart() {
        element.addClass(NG_ANIMATE_CLASSNAME);
        if (tempClasses) {
          $$jqLite.addClass(element, tempClasses);
        }
      }

      function updateAnimationRunners(animation, newRunner) {
        if (animation.from && animation.to) {
          update(animation.from.element);
          update(animation.to.element);
        } else {
          update(animation.element);
        }

        function update(element) {
          getRunner(element).setHost(newRunner);
        }
      }

      function handleDestroyedElement() {
        var runner = getRunner(element);
        if (runner && (event !== 'leave' || !options.$$domOperationFired)) {
          runner.end();
        }
      }

      function close(rejected) { // jshint ignore:line
        element.off('$destroy', handleDestroyedElement);
        removeRunner(element);

        applyAnimationClasses(element, options);
        applyAnimationStyles(element, options);
        options.domOperation();

        if (tempClasses) {
          $$jqLite.removeClass(element, tempClasses);
        }

        element.removeClass(NG_ANIMATE_CLASSNAME);
        runner.complete(!rejected);
      }
    };
  }];
}];

/* global angularAnimateModule: true,

   $$rAFMutexFactory,
   $$rAFSchedulerFactory,
   $$AnimateChildrenDirective,
   $$AnimateRunnerFactory,
   $$AnimateQueueProvider,
   $$AnimationProvider,
   $AnimateCssProvider,
   $$AnimateCssDriverProvider,
   $$AnimateJsProvider,
   $$AnimateJsDriverProvider,
*/

/**
 * @ngdoc module
 * @name ngAnimate
 * @description
 *
 * The `ngAnimate` module provides support for CSS-based animations (keyframes and transitions) as well as JavaScript-based animations via
 * callback hooks. Animations are not enabled by default, however, by including `ngAnimate` then the animation hooks are enabled for an Angular app.
 *
 * <div doc-module-components="ngAnimate"></div>
 *
 * # Usage
 * Simply put, there are two ways to make use of animations when ngAnimate is used: by using **CSS** and **JavaScript**. The former works purely based
 * using CSS (by using matching CSS selectors/styles) and the latter triggers animations that are registered via `module.animation()`. For
 * both CSS and JS animations the sole requirement is to have a matching `CSS class` that exists both in the registered animation and within
 * the HTML element that the animation will be triggered on.
 *
 * ## Directive Support
 * The following directives are "animation aware":
 *
 * | Directive                                                                                                | Supported Animations                                                     |
 * |----------------------------------------------------------------------------------------------------------|--------------------------------------------------------------------------|
 * | {@link ng.directive:ngRepeat#animations ngRepeat}                                                        | enter, leave and move                                                    |
 * | {@link ngRoute.directive:ngView#animations ngView}                                                       | enter and leave                                                          |
 * | {@link ng.directive:ngInclude#animations ngInclude}                                                      | enter and leave                                                          |
 * | {@link ng.directive:ngSwitch#animations ngSwitch}                                                        | enter and leave                                                          |
 * | {@link ng.directive:ngIf#animations ngIf}                                                                | enter and leave                                                          |
 * | {@link ng.directive:ngClass#animations ngClass}                                                          | add and remove (the CSS class(es) present)                               |
 * | {@link ng.directive:ngShow#animations ngShow} & {@link ng.directive:ngHide#animations ngHide}            | add and remove (the ng-hide class value)                                 |
 * | {@link ng.directive:form#animation-hooks form} & {@link ng.directive:ngModel#animation-hooks ngModel}    | add and remove (dirty, pristine, valid, invalid & all other validations) |
 * | {@link module:ngMessages#animations ngMessages}                                                          | add and remove (ng-active & ng-inactive)                                 |
 * | {@link module:ngMessages#animations ngMessage}                                                           | enter and leave                                                          |
 *
 * (More information can be found by visiting each the documentation associated with each directive.)
 *
 * ## CSS-based Animations
 *
 * CSS-based animations with ngAnimate are unique since they require no JavaScript code at all. By using a CSS class that we reference between our HTML
 * and CSS code we can create an animation that will be picked up by Angular when an the underlying directive performs an operation.
 *
 * The example below shows how an `enter` animation can be made possible on a element using `ng-if`:
 *
 * ```html
 * <div ng-if="bool" class="fade">
 *    Fade me in out
 * </div>
 * <button ng-click="bool=true">Fade In!</button>
 * <button ng-click="bool=false">Fade Out!</button>
 * ```
 *
 * Notice the CSS class **fade**? We can now create the CSS transition code that references this class:
 *
 * ```css
 * /&#42; The starting CSS styles for the enter animation &#42;/
 * .fade.ng-enter {
 *   transition:0.5s linear all;
 *   opacity:0;
 * }
 *
 * /&#42; The finishing CSS styles for the enter animation &#42;/
 * .fade.ng-enter.ng-enter-active {
 *   opacity:1;
 * }
 * ```
 *
 * The key thing to remember here is that, depending on the animation event (which each of the directives above trigger depending on what's going on) two
 * generated CSS classes will be applied to the element; in the example above we have `.ng-enter` and `.ng-enter-active`. For CSS transitions, the transition
 * code **must** be defined within the starting CSS class (in this case `.ng-enter`). The destination class is what the transition will animate towards.
 *
 * If for example we wanted to create animations for `leave` and `move` (ngRepeat triggers move) then we can do so using the same CSS naming conventions:
 *
 * ```css
 * /&#42; now the element will fade out before it is removed from the DOM &#42;/
 * .fade.ng-leave {
 *   transition:0.5s linear all;
 *   opacity:1;
 * }
 * .fade.ng-leave.ng-leave-active {
 *   opacity:0;
 * }
 * ```
 *
 * We can also make use of **CSS Keyframes** by referencing the keyframe animation within the starting CSS class:
 *
 * ```css
 * /&#42; there is no need to define anything inside of the destination
 * CSS class since the keyframe will take charge of the animation &#42;/
 * .fade.ng-leave {
 *   animation: my_fade_animation 0.5s linear;
 *   -webkit-animation: my_fade_animation 0.5s linear;
 * }
 *
 * @keyframes my_fade_animation {
 *   from { opacity:1; }
 *   to { opacity:0; }
 * }
 *
 * @-webkit-keyframes my_fade_animation {
 *   from { opacity:1; }
 *   to { opacity:0; }
 * }
 * ```
 *
 * Feel free also mix transitions and keyframes together as well as any other CSS classes on the same element.
 *
 * ### CSS Class-based Animations
 *
 * Class-based animations (animations that are triggered via `ngClass`, `ngShow`, `ngHide` and some other directives) have a slightly different
 * naming convention. Class-based animations are basic enough that a standard transition or keyframe can be referenced on the class being added
 * and removed.
 *
 * For example if we wanted to do a CSS animation for `ngHide` then we place an animation on the `.ng-hide` CSS class:
 *
 * ```html
 * <div ng-show="bool" class="fade">
 *   Show and hide me
 * </div>
 * <button ng-click="bool=true">Toggle</button>
 *
 * <style>
 * .fade.ng-hide {
 *   transition:0.5s linear all;
 *   opacity:0;
 * }
 * </style>
 * ```
 *
 * All that is going on here with ngShow/ngHide behind the scenes is the `.ng-hide` class is added/removed (when the hidden state is valid). Since
 * ngShow and ngHide are animation aware then we can match up a transition and ngAnimate handles the rest.
 *
 * In addition the addition and removal of the CSS class, ngAnimate also provides two helper methods that we can use to further decorate the animation
 * with CSS styles.
 *
 * ```html
 * <div ng-class="{on:onOff}" class="highlight">
 *   Highlight this box
 * </div>
 * <button ng-click="onOff=!onOff">Toggle</button>
 *
 * <style>
 * .highlight {
 *   transition:0.5s linear all;
 * }
 * .highlight.on-add {
 *   background:white;
 * }
 * .highlight.on {
 *   background:yellow;
 * }
 * .highlight.on-remove {
 *   background:black;
 * }
 * </style>
 * ```
 *
 * We can also make use of CSS keyframes by placing them within the CSS classes.
 *
 *
 * ### CSS Staggering Animations
 * A Staggering animation is a collection of animations that are issued with a slight delay in between each successive operation resulting in a
 * curtain-like effect. The ngAnimate module (versions >=1.2) supports staggering animations and the stagger effect can be
 * performed by creating a **ng-EVENT-stagger** CSS class and attaching that class to the base CSS class used for
 * the animation. The style property expected within the stagger class can either be a **transition-delay** or an
 * **animation-delay** property (or both if your animation contains both transitions and keyframe animations).
 *
 * ```css
 * .my-animation.ng-enter {
 *   /&#42; standard transition code &#42;/
 *   transition: 1s linear all;
 *   opacity:0;
 * }
 * .my-animation.ng-enter-stagger {
 *   /&#42; this will have a 100ms delay between each successive leave animation &#42;/
 *   transition-delay: 0.1s;
 *
 *   /&#42; in case the stagger doesn't work then the duration value
 *    must be set to 0 to avoid an accidental CSS inheritance &#42;/
 *   transition-duration: 0s;
 * }
 * .my-animation.ng-enter.ng-enter-active {
 *   /&#42; standard transition styles &#42;/
 *   opacity:1;
 * }
 * ```
 *
 * Staggering animations work by default in ngRepeat (so long as the CSS class is defined). Outside of ngRepeat, to use staggering animations
 * on your own, they can be triggered by firing multiple calls to the same event on $animate. However, the restrictions surrounding this
 * are that each of the elements must have the same CSS className value as well as the same parent element. A stagger operation
 * will also be reset if one or more animation frames have passed since the multiple calls to `$animate` were fired.
 *
 * The following code will issue the **ng-leave-stagger** event on the element provided:
 *
 * ```js
 * var kids = parent.children();
 *
 * $animate.leave(kids[0]); //stagger index=0
 * $animate.leave(kids[1]); //stagger index=1
 * $animate.leave(kids[2]); //stagger index=2
 * $animate.leave(kids[3]); //stagger index=3
 * $animate.leave(kids[4]); //stagger index=4
 *
 * window.requestAnimationFrame(function() {
 *   //stagger has reset itself
 *   $animate.leave(kids[5]); //stagger index=0
 *   $animate.leave(kids[6]); //stagger index=1
 *
 *   $scope.$digest();
 * });
 * ```
 *
 * Stagger animations are currently only supported within CSS-defined animations.
 *
 * ### The `ng-animate` CSS class
 *
 * When ngAnimate is animating an element it will apply the `ng-animate` CSS class to the element for the duration of the animation.
 * This is a temporary CSS class and it will be removed once the animation is over (for both JavaScript and CSS-based animations).
 *
 * Therefore, animations can be applied to an element using this temporary class directly via CSS.
 *
 * ```css
 * .zipper.ng-animate {
 *   transition:0.5s linear all;
 * }
 * .zipper.ng-enter {
 *   opacity:0;
 * }
 * .zipper.ng-enter.ng-enter-active {
 *   opacity:1;
 * }
 * .zipper.ng-leave {
 *   opacity:1;
 * }
 * .zipper.ng-leave.ng-leave-active {
 *   opacity:0;
 * }
 * ```
 *
 * (Note that the `ng-animate` CSS class is reserved and it cannot be applied on an element directly since ngAnimate will always remove
 * the CSS class once an animation has completed.)
 *
 *
 * ## JavaScript-based Animations
 *
 * ngAnimate also allows for animations to be consumed by JavaScript code. The approach is similar to CSS-based animations (where there is a shared
 * CSS class that is referenced in our HTML code) but in addition we need to register the JavaScript animation on the module. By making use of the
 * `module.animation()` module function we can register the ainmation.
 *
 * Let's see an example of a enter/leave animation using `ngRepeat`:
 *
 * ```html
 * <div ng-repeat="item in items" class="slide">
 *   {{ item }}
 * </div>
 * ```
 *
 * See the **slide** CSS class? Let's use that class to define an animation that we'll structure in our module code by using `module.animation`:
 *
 * ```js
 * myModule.animation('.slide', [function() {
 *   return {
 *     // make note that other events (like addClass/removeClass)
 *     // have different function input parameters
 *     enter: function(element, doneFn) {
 *       jQuery(element).fadeIn(1000, doneFn);
 *
 *       // remember to call doneFn so that angular
 *       // knows that the animation has concluded
 *     },
 *
 *     move: function(element, doneFn) {
 *       jQuery(element).fadeIn(1000, doneFn);
 *     },
 *
 *     leave: function(element, doneFn) {
 *       jQuery(element).fadeOut(1000, doneFn);
 *     }
 *   }
 * }]
 * ```
 *
 * The nice thing about JS-based animations is that we can inject other services and make use of advanced animation libraries such as
 * greensock.js and velocity.js.
 *
 * If our animation code class-based (meaning that something like `ngClass`, `ngHide` and `ngShow` triggers it) then we can still define
 * our animations inside of the same registered animation, however, the function input arguments are a bit different:
 *
 * ```html
 * <div ng-class="color" class="colorful">
 *   this box is moody
 * </div>
 * <button ng-click="color='red'">Change to red</button>
 * <button ng-click="color='blue'">Change to blue</button>
 * <button ng-click="color='green'">Change to green</button>
 * ```
 *
 * ```js
 * myModule.animation('.colorful', [function() {
 *   return {
 *     addClass: function(element, className, doneFn) {
 *       // do some cool animation and call the doneFn
 *     },
 *     removeClass: function(element, className, doneFn) {
 *       // do some cool animation and call the doneFn
 *     },
 *     setClass: function(element, addedClass, removedClass, doneFn) {
 *       // do some cool animation and call the doneFn
 *     }
 *   }
 * }]
 * ```
 *
 * ## CSS + JS Animations Together
 *
 * AngularJS 1.4 and higher has taken steps to make the amalgamation of CSS and JS animations more flexible. However, unlike earlier versions of Angular,
 * defining CSS and JS animations to work off of the same CSS class will not work anymore. Therefore example below will only result in **JS animations taking
 * charge of the animation**:
 *
 * ```html
 * <div ng-if="bool" class="slide">
 *   Slide in and out
 * </div>
 * ```
 *
 * ```js
 * myModule.animation('.slide', [function() {
 *   return {
 *     enter: function(element, doneFn) {
 *       jQuery(element).slideIn(1000, doneFn);
 *     }
 *   }
 * }]
 * ```
 *
 * ```css
 * .slide.ng-enter {
 *   transition:0.5s linear all;
 *   transform:translateY(-100px);
 * }
 * .slide.ng-enter.ng-enter-active {
 *   transform:translateY(0);
 * }
 * ```
 *
 * Does this mean that CSS and JS animations cannot be used together? Do JS-based animations always have higher priority? We can suppliment for the
 * lack of CSS animations by making use of the `$animateCss` service to trigger our own tweaked-out, CSS-based animations directly from
 * our own JS-based animation code:
 *
 * ```js
 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element, doneFn) {
*        // this will trigger `.slide.ng-enter` and `.slide.ng-enter-active`.
 *       var runner = $animateCss(element, {
 *         event: 'enter',
 *         structural: true
 *       }).start();
*        runner.done(doneFn);
 *     }
 *   }
 * }]
 * ```
 *
 * The nice thing here is that we can save bandwidth by sticking to our CSS-based animation code and we don't need to rely on a 3rd-party animation framework.
 *
 * The `$animateCss` service is very powerful since we can feed in all kinds of extra properties that will be evaluated and fed into a CSS transition or
 * keyframe animation. For example if we wanted to animate the height of an element while adding and removing classes then we can do so by providing that
 * data into `$animateCss` directly:
 *
 * ```js
 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element, doneFn) {
 *       var runner = $animateCss(element, {
 *         event: 'enter',
 *         addClass: 'maroon-setting',
 *         from: { height:0 },
 *         to: { height: 200 }
 *       }).start();
 *
 *       runner.done(doneFn);
 *     }
 *   }
 * }]
 * ```
 *
 * Now we can fill in the rest via our transition CSS code:
 *
 * ```css
 * /&#42; the transition tells ngAnimate to make the animation happen &#42;/
 * .slide.ng-enter { transition:0.5s linear all; }
 *
 * /&#42; this extra CSS class will be absorbed into the transition
 * since the $animateCss code is adding the class &#42;/
 * .maroon-setting { background:red; }
 * ```
 *
 * And `$animateCss` will figure out the rest. Just make sure to have the `done()` callback fire the `doneFn` function to signal when the animation is over.
 *
 * To learn more about what's possible be sure to visit the {@link ngAnimate.$animateCss $animateCss service}.
 *
 * ## Animation Anchoring (via `ng-animate-ref`)
 *
 * ngAnimate in AngularJS 1.4 comes packed with the ability to cross-animate elements between
 * structural areas of an application (like views) by pairing up elements using an attribute
 * called `ng-animate-ref`.
 *
 * Let's say for example we have two views that are managed by `ng-view` and we want to show
 * that there is a relationship between two components situated in within these views. By using the
 * `ng-animate-ref` attribute we can identify that the two components are paired together and we
 * can then attach an animation, which is triggered when the view changes.
 *
 * Say for example we have the following template code:
 *
 * ```html
 * <!-- index.html -->
 * <div ng-view class="view-animation">
 * </div>
 *
 * <!-- home.html -->
 * <a href="#/banner-page">
 *   <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
 * </a>
 *
 * <!-- banner-page.html -->
 * <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
 * ```
 *
 * Now, when the view changes (once the link is clicked), ngAnimate will examine the
 * HTML contents to see if there is a match reference between any components in the view
 * that is leaving and the view that is entering. It will scan both the view which is being
 * removed (leave) and inserted (enter) to see if there are any paired DOM elements that
 * contain a matching ref value.
 *
 * The two images match since they share the same ref value. ngAnimate will now create a
 * transport element (which is a clone of the first image element) and it will then attempt
 * to animate to the position of the second image element in the next view. For the animation to
 * work a special CSS class called `ng-anchor` will be added to the transported element.
 *
 * We can now attach a transition onto the `.banner.ng-anchor` CSS class and then
 * ngAnimate will handle the entire transition for us as well as the addition and removal of
 * any changes of CSS classes between the elements:
 *
 * ```css
 * .banner.ng-anchor {
 *   /&#42; this animation will last for 1 second since there are
 *          two phases to the animation (an `in` and an `out` phase) &#42;/
 *   transition:0.5s linear all;
 * }
 * ```
 *
 * We also **must** include animations for the views that are being entered and removed
 * (otherwise anchoring wouldn't be possible since the new view would be inserted right away).
 *
 * ```css
 * .view-animation.ng-enter, .view-animation.ng-leave {
 *   transition:0.5s linear all;
 *   position:fixed;
 *   left:0;
 *   top:0;
 *   width:100%;
 * }
 * .view-animation.ng-enter {
 *   transform:translateX(100%);
 * }
 * .view-animation.ng-leave,
 * .view-animation.ng-enter.ng-enter-active {
 *   transform:translateX(0%);
 * }
 * .view-animation.ng-leave.ng-leave-active {
 *   transform:translateX(-100%);
 * }
 * ```
 *
 * Now we can jump back to the anchor animation. When the animation happens, there are two stages that occur:
 * an `out` and an `in` stage. The `out` stage happens first and that is when the element is animated away
 * from its origin. Once that animation is over then the `in` stage occurs which animates the
 * element to its destination. The reason why there are two animations is to give enough time
 * for the enter animation on the new element to be ready.
 *
 * The example above sets up a transition for both the in and out phases, but we can also target the out or
 * in phases directly via `ng-anchor-out` and `ng-anchor-in`.
 *
 * ```css
 * .banner.ng-anchor-out {
 *   transition: 0.5s linear all;
 *
 *   /&#42; the scale will be applied during the out animation,
 *          but will be animated away when the in animation runs &#42;/
 *   transform: scale(1.2);
 * }
 *
 * .banner.ng-anchor-in {
 *   transition: 1s linear all;
 * }
 * ```
 *
 *
 *
 *
 * ### Anchoring Demo
 *
  <example module="anchoringExample"
           name="anchoringExample"
           id="anchoringExample"
           deps="angular-animate.js;angular-route.js"
           animations="true">
    <file name="index.html">
      <a href="#/">Home</a>
      <hr />
      <div class="view-container">
        <div ng-view class="view"></div>
      </div>
    </file>
    <file name="script.js">
      angular.module('anchoringExample', ['ngAnimate', 'ngRoute'])
        .config(['$routeProvider', function($routeProvider) {
          $routeProvider.when('/', {
            templateUrl: 'home.html',
            controller: 'HomeController as home'
          });
          $routeProvider.when('/profile/:id', {
            templateUrl: 'profile.html',
            controller: 'ProfileController as profile'
          });
        }])
        .run(['$rootScope', function($rootScope) {
          $rootScope.records = [
            { id:1, title: "Miss Beulah Roob" },
            { id:2, title: "Trent Morissette" },
            { id:3, title: "Miss Ava Pouros" },
            { id:4, title: "Rod Pouros" },
            { id:5, title: "Abdul Rice" },
            { id:6, title: "Laurie Rutherford Sr." },
            { id:7, title: "Nakia McLaughlin" },
            { id:8, title: "Jordon Blanda DVM" },
            { id:9, title: "Rhoda Hand" },
            { id:10, title: "Alexandrea Sauer" }
          ];
        }])
        .controller('HomeController', [function() {
          //empty
        }])
        .controller('ProfileController', ['$rootScope', '$routeParams', function($rootScope, $routeParams) {
          var index = parseInt($routeParams.id, 10);
          var record = $rootScope.records[index - 1];

          this.title = record.title;
          this.id = record.id;
        }]);
    </file>
    <file name="home.html">
      <h2>Welcome to the home page</h1>
      <p>Please click on an element</p>
      <a class="record"
         ng-href="#/profile/{{ record.id }}"
         ng-animate-ref="{{ record.id }}"
         ng-repeat="record in records">
        {{ record.title }}
      </a>
    </file>
    <file name="profile.html">
      <div class="profile record" ng-animate-ref="{{ profile.id }}">
        {{ profile.title }}
      </div>
    </file>
    <file name="animations.css">
      .record {
        display:block;
        font-size:20px;
      }
      .profile {
        background:black;
        color:white;
        font-size:100px;
      }
      .view-container {
        position:relative;
      }
      .view-container > .view.ng-animate {
        position:absolute;
        top:0;
        left:0;
        width:100%;
        min-height:500px;
      }
      .view.ng-enter, .view.ng-leave,
      .record.ng-anchor {
        transition:0.5s linear all;
      }
      .view.ng-enter {
        transform:translateX(100%);
      }
      .view.ng-enter.ng-enter-active, .view.ng-leave {
        transform:translateX(0%);
      }
      .view.ng-leave.ng-leave-active {
        transform:translateX(-100%);
      }
      .record.ng-anchor-out {
        background:red;
      }
    </file>
  </example>
 *
 * ### How is the element transported?
 *
 * When an anchor animation occurs, ngAnimate will clone the starting element and position it exactly where the starting
 * element is located on screen via absolute positioning. The cloned element will be placed inside of the root element
 * of the application (where ng-app was defined) and all of the CSS classes of the starting element will be applied. The
 * element will then animate into the `out` and `in` animations and will eventually reach the coordinates and match
 * the dimensions of the destination element. During the entire animation a CSS class of `.ng-animate-shim` will be applied
 * to both the starting and destination elements in order to hide them from being visible (the CSS styling for the class
 * is: `visibility:hidden`). Once the anchor reaches its destination then it will be removed and the destination element
 * will become visible since the shim class will be removed.
 *
 * ### How is the morphing handled?
 *
 * CSS Anchoring relies on transitions and keyframes and the internal code is intelligent enough to figure out
 * what CSS classes differ between the starting element and the destination element. These different CSS classes
 * will be added/removed on the anchor element and a transition will be applied (the transition that is provided
 * in the anchor class). Long story short, ngAnimate will figure out what classes to add and remove which will
 * make the transition of the element as smooth and automatic as possible. Be sure to use simple CSS classes that
 * do not rely on DOM nesting structure so that the anchor element appears the same as the starting element (since
 * the cloned element is placed inside of root element which is likely close to the body element).
 *
 * Note that if the root element is on the `<html>` element then the cloned node will be placed inside of body.
 *
 *
 * ## Using $animate in your directive code
 *
 * So far we've explored how to feed in animations into an Angular application, but how do we trigger animations within our own directives in our application?
 * By injecting the `$animate` service into our directive code, we can trigger structural and class-based hooks which can then be consumed by animations. Let's
 * imagine we have a greeting box that shows and hides itself when the data changes
 *
 * ```html
 * <greeting-box active="onOrOff">Hi there</greeting-box>
 * ```
 *
 * ```js
 * ngModule.directive('greetingBox', ['$animate', function($animate) {
 *   return function(scope, element, attrs) {
 *     attrs.$observe('active', function(value) {
 *       value ? $animate.addClass(element, 'on') ? $animate.removeClass(element, 'on');
 *     });
 *   });
 * }]);
 * ```
 *
 * Now the `on` CSS class is added and removed on the greeting box component. Now if we add a CSS class on top of the greeting box element
 * in our HTML code then we can trigger a CSS or JS animation to happen.
 *
 * ```css
 * /&#42; normally we would create a CSS class to reference on the element &#42;/
 * [greeting-box].on { transition:0.5s linear all; background:green; color:white; }
 * ```
 *
 * The `$animate` service contains a variety of other methods like `enter`, `leave`, `animate` and `setClass`. To learn more about what's
 * possible be sure to visit the {@link ng.$animate $animate service API page}.
 *
 *
 * ### Preventing Collisions With Third Party Libraries
 *
 * Some third-party frameworks place animation duration defaults across many element or className
 * selectors in order to make their code small and reuseable. This can lead to issues with ngAnimate, which
 * is expecting actual animations on these elements and has to wait for their completion.
 *
 * You can prevent this unwanted behavior by using a prefix on all your animation classes:
 *
 * ```css
 * /&#42; prefixed with animate- &#42;/
 * .animate-fade-add.animate-fade-add-active {
 *   transition:1s linear all;
 *   opacity:0;
 * }
 * ```
 *
 * You then configure `$animate` to enforce this prefix:
 *
 * ```js
 * $animateProvider.classNameFilter(/animate-/);
 * ```
 *
 * This also may provide your application with a speed boost since only specific elements containing CSS class prefix
 * will be evaluated for animation when any DOM changes occur in the application.
 *
 * ## Callbacks and Promises
 *
 * When `$animate` is called it returns a promise that can be used to capture when the animation has ended. Therefore if we were to trigger
 * an animation (within our directive code) then we can continue performing directive and scope related activities after the animation has
 * ended by chaining onto the returned promise that animation method returns.
 *
 * ```js
 * // somewhere within the depths of the directive
 * $animate.enter(element, parent).then(function() {
 *   //the animation has completed
 * });
 * ```
 *
 * (Note that earlier versions of Angular prior to v1.4 required the promise code to be wrapped using `$scope.$apply(...)`. This is not the case
 * anymore.)
 *
 * In addition to the animation promise, we can also make use of animation-related callbacks within our directives and controller code by registering
 * an event listener using the `$animate` service. Let's say for example that an animation was triggered on our view
 * routing controller to hook into that:
 *
 * ```js
 * ngModule.controller('HomePageController', ['$animate', function($animate) {
 *   $animate.on('enter', ngViewElement, function(element) {
 *     // the animation for this route has completed
 *   }]);
 * }])
 * ```
 *
 * (Note that you will need to trigger a digest within the callback to get angular to notice any scope-related changes.)
 */

/**
 * @ngdoc service
 * @name $animate
 * @kind object
 *
 * @description
 * The ngAnimate `$animate` service documentation is the same for the core `$animate` service.
 *
 * Click here {@link ng.$animate $animate to learn more about animations with `$animate`}.
 */
angular.module('ngAnimate', [])
  .directive('ngAnimateChildren', $$AnimateChildrenDirective)

  .factory('$$rAFMutex', $$rAFMutexFactory)
  .factory('$$rAFScheduler', $$rAFSchedulerFactory)

  .factory('$$AnimateRunner', $$AnimateRunnerFactory)

  .provider('$$animateQueue', $$AnimateQueueProvider)
  .provider('$$animation', $$AnimationProvider)

  .provider('$animateCss', $AnimateCssProvider)
  .provider('$$animateCssDriver', $$AnimateCssDriverProvider)

  .provider('$$animateJs', $$AnimateJsProvider)
  .provider('$$animateJsDriver', $$AnimateJsDriverProvider);


})(window, window.angular);


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(8);
module.exports = 'ngAnimate';


/***/ }),
/* 10 */
/***/ (function(module, exports) {

angular.module('cgBusy',[]);

//loosely modeled after angular-promise-tracker
angular.module('cgBusy').factory('_cgBusyTrackerFactory',['$timeout','$q',function($timeout,$q){

    return function(){

        var tracker = {};
        tracker.promises = [];
        tracker.delayPromise = null;
        tracker.durationPromise = null;
        tracker.delayJustFinished = false;

        tracker.reset = function(options){
            tracker.minDuration = options.minDuration;

            tracker.promises = [];
            angular.forEach(options.promises,function(p){
                if (!p || p.$cgBusyFulfilled) {
                    return;
                }
                addPromiseLikeThing(p);
            });

            if (tracker.promises.length === 0) {
                //if we have no promises then dont do the delay or duration stuff
                return;
            }

            tracker.delayJustFinished = false;
            if (options.delay) {
                tracker.delayPromise = $timeout(function(){
                    tracker.delayPromise = null;
                    tracker.delayJustFinished = true;
                },parseInt(options.delay,10));
            }
            if (options.minDuration) {
                tracker.durationPromise = $timeout(function(){
                    tracker.durationPromise = null;
                },parseInt(options.minDuration,10) + (options.delay ? parseInt(options.delay,10) : 0));
            }            
        };

        tracker.isPromise = function(promiseThing){
            var then = promiseThing && (promiseThing.then || promiseThing.$then ||
                (promiseThing.$promise && promiseThing.$promise.then));

            return typeof then !== 'undefined';            
        };

        tracker.callThen = function(promiseThing,success,error){
            var promise;
            if (promiseThing.then || promiseThing.$then){
                promise = promiseThing;
            } else if (promiseThing.$promise){
                promise = promiseThing.$promise;
            } else if (promiseThing.denodeify){
                promise = $q.when(promiseThing);
            }
                       
            var then = (promise.then || promise.$then);

            then.call(promise,success,error);
        };

        var addPromiseLikeThing = function(promise){

            if (!tracker.isPromise(promise)) {
                throw new Error('cgBusy expects a promise (or something that has a .promise or .$promise');
            }

            if (tracker.promises.indexOf(promise) !== -1){
                return;
            }
            tracker.promises.push(promise);

            tracker.callThen(promise, function(){
                promise.$cgBusyFulfilled = true;
                if (tracker.promises.indexOf(promise) === -1) {
                    return;
                }
                tracker.promises.splice(tracker.promises.indexOf(promise),1);
            },function(){
                promise.$cgBusyFulfilled = true;
                if (tracker.promises.indexOf(promise) === -1) {
                    return;
                }
                tracker.promises.splice(tracker.promises.indexOf(promise),1);
            });
        };

        tracker.active = function(){
            if (tracker.delayPromise){
                return false;
            }

            if (!tracker.delayJustFinished){
                if (tracker.durationPromise){
                    return true;
                }
                return tracker.promises.length > 0;
            } else {
                //if both delay and min duration are set, 
                //we don't want to initiate the min duration if the 
                //promise finished before the delay was complete
                tracker.delayJustFinished = false;
                if (tracker.promises.length === 0) {
                    tracker.durationPromise = null;
                }
                return tracker.promises.length > 0;
            }
        };

        return tracker;

    };
}]);

angular.module('cgBusy').value('cgBusyDefaults',{});

angular.module('cgBusy').directive('cgBusy',['$compile','$templateCache','cgBusyDefaults','$http','_cgBusyTrackerFactory',
    function($compile,$templateCache,cgBusyDefaults,$http,_cgBusyTrackerFactory){
        return {
            restrict: 'A',
            link: function(scope, element, attrs, fn) {

                //Apply position:relative to parent element if necessary
                var position = element.css('position');
                if (position === 'static' || position === '' || typeof position === 'undefined'){
                    element.css('position','relative');
                }

                var templateElement;
                var backdropElement;
                var currentTemplate;
                var templateScope;
                var backdrop;
                var tracker = _cgBusyTrackerFactory();

                var defaults = {
                    templateUrl: 'angular-busy.html',
                    delay:0,
                    minDuration:0,
                    backdrop: true,
                    message:'Please Wait...',
                    wrapperClass: 'cg-busy cg-busy-animation'
                };

                angular.extend(defaults,cgBusyDefaults);

                scope.$watchCollection(attrs.cgBusy,function(options){

                    if (!options) {
                        options = {promise:null};
                    }

                    if (angular.isString(options)) {
                        throw new Error('Invalid value for cg-busy. cgBusy no longer accepts string ids to represent promises/trackers.');
                    }

                    //is it an array (of promises) or one promise
                    if (angular.isArray(options) || tracker.isPromise(options)) {
                        options = {promise:options};
                    }

                    options = angular.extend(angular.copy(defaults),options);

                    if (!options.templateUrl){
                        options.templateUrl = defaults.templateUrl;
                    }

                    if (!angular.isArray(options.promise)){
                        options.promise = [options.promise];
                    }

                    // options.promise = angular.isArray(options.promise) ? options.promise : [options.promise];
                    // options.message = options.message ? options.message : 'Please Wait...';
                    // options.template = options.template ? options.template : cgBusyTemplateName;
                    // options.minDuration = options.minDuration ? options.minDuration : 0;
                    // options.delay = options.delay ? options.delay : 0;

                    if (!templateScope) {
                        templateScope = scope.$new();
                    }

                    templateScope.$message = options.message;

                    if (!angular.equals(tracker.promises,options.promise)) {
                        tracker.reset({
                            promises:options.promise,
                            delay:options.delay,
                            minDuration: options.minDuration
                        });
                    }

                    templateScope.$cgBusyIsActive = function() {
                        return tracker.active();
                    };


                    if (!templateElement || currentTemplate !== options.templateUrl || backdrop !== options.backdrop) {

                        if (templateElement) {
                            templateElement.remove();
                        }
                        if (backdropElement){
                            backdropElement.remove();
                        }

                        currentTemplate = options.templateUrl;
                        backdrop = options.backdrop;

                        $http.get(currentTemplate,{cache: $templateCache}).then(function(indicatorTemplate){

                            options.backdrop = typeof options.backdrop === 'undefined' ? true : options.backdrop;

                            if (options.backdrop){
                                var backdrop = '<div class="cg-busy cg-busy-backdrop cg-busy-backdrop-animation ng-hide" ng-show="$cgBusyIsActive()"></div>';
                                backdropElement = $compile(backdrop)(templateScope);
                                element.append(backdropElement);
                            }

                            var template = '<div class="'+options.wrapperClass+' ng-hide" ng-show="$cgBusyIsActive()">' + indicatorTemplate.data + '</div>';
                            templateElement = $compile(template)(templateScope);

                            angular.element(templateElement.children()[0])
                                .css('position','absolute')
                                .css('top',0)
                                .css('left',0)
                                .css('right',0)
                                .css('bottom',0);
                            element.append(templateElement);

                        }, function(data){
                            throw new Error('Template specified for cgBusy ('+options.templateUrl+') could not be loaded. ' + data);
                        });
                    }

                },true);
            }
        };
    }
]);


angular.module('cgBusy').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('angular-busy.html',
    "<div class=\"cg-busy-default-wrapper\">\n" +
    "\n" +
    "   <div class=\"cg-busy-default-sign\">\n" +
    "\n" +
    "      <div class=\"cg-busy-default-spinner\">\n" +
    "         <div class=\"bar1\"></div>\n" +
    "         <div class=\"bar2\"></div>\n" +
    "         <div class=\"bar3\"></div>\n" +
    "         <div class=\"bar4\"></div>\n" +
    "         <div class=\"bar5\"></div>\n" +
    "         <div class=\"bar6\"></div>\n" +
    "         <div class=\"bar7\"></div>\n" +
    "         <div class=\"bar8\"></div>\n" +
    "         <div class=\"bar9\"></div>\n" +
    "         <div class=\"bar10\"></div>\n" +
    "         <div class=\"bar11\"></div>\n" +
    "         <div class=\"bar12\"></div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"cg-busy-default-text\">{{$message}}</div>\n" +
    "\n" +
    "   </div>\n" +
    "\n" +
    "</div>"
  );

}]);


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(10);
module.exports = 'cgBusy';

/***/ }),
/* 12 */
/***/ (function(module, exports) {

/**
 * @see http://docs.angularjs.org/guide/concepts
 * @see http://docs.angularjs.org/api/ng.directive:ngModel.NgModelController
 * @see https://github.com/angular/angular.js/issues/528#issuecomment-7573166
 */

angular.module('contenteditable', [])
  .directive('contenteditable', ['$timeout', function($timeout) { return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, element, attrs, ngModel) {
      // don't do anything unless this is actually bound to a model
      if (!ngModel) {
        return
      }

      // options
      var opts = {}
      angular.forEach([
        'stripBr',
        'noLineBreaks',
        'selectNonEditable',
        'moveCaretToEndOnChange',
        'stripTags'
      ], function(opt) {
        var o = attrs[opt]
        opts[opt] = o && o !== 'false'
      })

      // view -> model
      element.bind('input', function(e) {
        scope.$apply(function() {
          var html, html2, rerender
          html = element.html()
          rerender = false
          if (opts.stripBr) {
            html = html.replace(/<br>$/, '')
          }
          if (opts.noLineBreaks) {
            html2 = html.replace(/<div>/g, '').replace(/<br>/g, '').replace(/<\/div>/g, '')
            if (html2 !== html) {
              rerender = true
              html = html2
            }
          }
          if (opts.stripTags) {
            rerender = true
            html = html.replace(/<\S[^><]*>/g, '')
          }
          ngModel.$setViewValue(html)
          if (rerender) {
            ngModel.$render()
          }
          if (html === '') {
            // the cursor disappears if the contents is empty
            // so we need to refocus
            $timeout(function(){
              element[0].blur()
              element[0].focus()
            })
          }
        })
      })

      // model -> view
      var oldRender = ngModel.$render
      ngModel.$render = function() {
        var el, el2, range, sel
        if (!!oldRender) {
          oldRender()
        }
        var html = ngModel.$viewValue || ''
        if (opts.stripTags) {
          html = html.replace(/<\S[^><]*>/g, '')
        }

        element.html(html)
        if (opts.moveCaretToEndOnChange) {
          el = element[0]
          range = document.createRange()
          sel = window.getSelection()
          if (el.childNodes.length > 0) {
            el2 = el.childNodes[el.childNodes.length - 1]
            range.setStartAfter(el2)
          } else {
            range.setStartAfter(el)
          }
          range.collapse(true)
          sel.removeAllRanges()
          sel.addRange(range)
        }
      }
      if (opts.selectNonEditable) {
        element.bind('click', function(e) {
          var range, sel, target
          target = e.toElement
          if (target !== this && angular.element(target).attr('contenteditable') === 'false') {
            range = document.createRange()
            sel = window.getSelection()
            range.setStartBefore(target)
            range.setEndAfter(target)
            sel.removeAllRanges()
            sel.addRange(range)
          }
        })
      }
    }
  }}]);


/***/ }),
/* 13 */
/***/ (function(module, exports) {

/**
 * @license AngularJS v1.4.0
 * (c) 2010-2015 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular, undefined) {'use strict';

/**
 * @ngdoc module
 * @name ngCookies
 * @description
 *
 * # ngCookies
 *
 * The `ngCookies` module provides a convenient wrapper for reading and writing browser cookies.
 *
 *
 * <div doc-module-components="ngCookies"></div>
 *
 * See {@link ngCookies.$cookies `$cookies`} and
 * {@link ngCookies.$cookieStore `$cookieStore`} for usage.
 */


angular.module('ngCookies', ['ng']).
  /**
   * @ngdoc provider
   * @name $cookiesProvider
   * @description
   * Use `$cookiesProvider` to change the default behavior of the {@link ngCookies.$cookies $cookies} service.
   * */
   provider('$cookies', [function $CookiesProvider() {
    /**
     * @ngdoc property
     * @name $cookiesProvider#defaults
     * @description
     *
     * Object containing default options to pass when setting cookies.
     *
     * The object may have following properties:
     *
     * - **path** - `{string}` - The cookie will be available only for this path and its
     *   sub-paths. By default, this would be the URL that appears in your base tag.
     * - **domain** - `{string}` - The cookie will be available only for this domain and
     *   its sub-domains. For obvious security reasons the user agent will not accept the
     *   cookie if the current domain is not a sub domain or equals to the requested domain.
     * - **expires** - `{string|Date}` - String of the form "Wdy, DD Mon YYYY HH:MM:SS GMT"
     *   or a Date object indicating the exact date/time this cookie will expire.
     * - **secure** - `{boolean}` - The cookie will be available only in secured connection.
     *
     * Note: by default the address that appears in your <base> tag will be used as path.
     * This is import so that cookies will be visible for all routes in case html5mode is enabled
     *
     **/
    var defaults = this.defaults = {};

    function calcOptions(options) {
      return options ? angular.extend({}, defaults, options) : defaults;
    }

    /**
     * @ngdoc service
     * @name $cookies
     *
     * @description
     * Provides read/write access to browser's cookies.
     *
     * BREAKING CHANGE: `$cookies` no longer exposes properties that represent the
     * current browser cookie values. Now you must use the get/put/remove/etc. methods
     * as described below.
     *
     * Requires the {@link ngCookies `ngCookies`} module to be installed.
     *
     * @example
     *
     * ```js
     * angular.module('cookiesExample', ['ngCookies'])
     *   .controller('ExampleController', ['$cookies', function($cookies) {
     *     // Retrieving a cookie
     *     var favoriteCookie = $cookies.get('myFavorite');
     *     // Setting a cookie
     *     $cookies.put('myFavorite', 'oatmeal');
     *   }]);
     * ```
     */
    this.$get = ['$$cookieReader', '$$cookieWriter', function($$cookieReader, $$cookieWriter) {
      return {
        /**
         * @ngdoc method
         * @name $cookies#get
         *
         * @description
         * Returns the value of given cookie key
         *
         * @param {string} key Id to use for lookup.
         * @returns {string} Raw cookie value.
         */
        get: function(key) {
          return $$cookieReader()[key];
        },

        /**
         * @ngdoc method
         * @name $cookies#getObject
         *
         * @description
         * Returns the deserialized value of given cookie key
         *
         * @param {string} key Id to use for lookup.
         * @returns {Object} Deserialized cookie value.
         */
        getObject: function(key) {
          var value = this.get(key);
          return value ? angular.fromJson(value) : value;
        },

        /**
         * @ngdoc method
         * @name $cookies#getAll
         *
         * @description
         * Returns a key value object with all the cookies
         *
         * @returns {Object} All cookies
         */
        getAll: function() {
          return $$cookieReader();
        },

        /**
         * @ngdoc method
         * @name $cookies#put
         *
         * @description
         * Sets a value for given cookie key
         *
         * @param {string} key Id for the `value`.
         * @param {string} value Raw value to be stored.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */
        put: function(key, value, options) {
          $$cookieWriter(key, value, calcOptions(options));
        },

        /**
         * @ngdoc method
         * @name $cookies#putObject
         *
         * @description
         * Serializes and sets a value for given cookie key
         *
         * @param {string} key Id for the `value`.
         * @param {Object} value Value to be stored.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */
        putObject: function(key, value, options) {
          this.put(key, angular.toJson(value), options);
        },

        /**
         * @ngdoc method
         * @name $cookies#remove
         *
         * @description
         * Remove given cookie
         *
         * @param {string} key Id of the key-value pair to delete.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */
        remove: function(key, options) {
          $$cookieWriter(key, undefined, calcOptions(options));
        }
      };
    }];
  }]);

angular.module('ngCookies').
/**
 * @ngdoc service
 * @name $cookieStore
 * @deprecated
 * @requires $cookies
 *
 * @description
 * Provides a key-value (string-object) storage, that is backed by session cookies.
 * Objects put or retrieved from this storage are automatically serialized or
 * deserialized by angular's toJson/fromJson.
 *
 * Requires the {@link ngCookies `ngCookies`} module to be installed.
 *
 * <div class="alert alert-danger">
 * **Note:** The $cookieStore service is deprecated.
 * Please use the {@link ngCookies.$cookies `$cookies`} service instead.
 * </div>
 *
 * @example
 *
 * ```js
 * angular.module('cookieStoreExample', ['ngCookies'])
 *   .controller('ExampleController', ['$cookieStore', function($cookieStore) {
 *     // Put cookie
 *     $cookieStore.put('myFavorite','oatmeal');
 *     // Get cookie
 *     var favoriteCookie = $cookieStore.get('myFavorite');
 *     // Removing a cookie
 *     $cookieStore.remove('myFavorite');
 *   }]);
 * ```
 */
 factory('$cookieStore', ['$cookies', function($cookies) {

    return {
      /**
       * @ngdoc method
       * @name $cookieStore#get
       *
       * @description
       * Returns the value of given cookie key
       *
       * @param {string} key Id to use for lookup.
       * @returns {Object} Deserialized cookie value, undefined if the cookie does not exist.
       */
      get: function(key) {
        return $cookies.getObject(key);
      },

      /**
       * @ngdoc method
       * @name $cookieStore#put
       *
       * @description
       * Sets a value for given cookie key
       *
       * @param {string} key Id for the `value`.
       * @param {Object} value Value to be stored.
       */
      put: function(key, value) {
        $cookies.putObject(key, value);
      },

      /**
       * @ngdoc method
       * @name $cookieStore#remove
       *
       * @description
       * Remove given cookie
       *
       * @param {string} key Id of the key-value pair to delete.
       */
      remove: function(key) {
        $cookies.remove(key);
      }
    };

  }]);

/**
 * @name $$cookieWriter
 * @requires $document
 *
 * @description
 * This is a private service for writing cookies
 *
 * @param {string} name Cookie name
 * @param {string=} value Cookie value (if undefined, cookie will be deleted)
 * @param {Object=} options Object with options that need to be stored for the cookie.
 */
function $$CookieWriter($document, $log, $browser) {
  var cookiePath = $browser.baseHref();
  var rawDocument = $document[0];

  function buildCookieString(name, value, options) {
    var path, expires;
    options = options || {};
    expires = options.expires;
    path = angular.isDefined(options.path) ? options.path : cookiePath;
    if (value === undefined) {
      expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
      value = '';
    }
    if (angular.isString(expires)) {
      expires = new Date(expires);
    }

    var str = encodeURIComponent(name) + '=' + encodeURIComponent(value);
    str += path ? ';path=' + path : '';
    str += options.domain ? ';domain=' + options.domain : '';
    str += expires ? ';expires=' + expires.toUTCString() : '';
    str += options.secure ? ';secure' : '';

    // per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum:
    // - 300 cookies
    // - 20 cookies per unique domain
    // - 4096 bytes per cookie
    var cookieLength = str.length + 1;
    if (cookieLength > 4096) {
      $log.warn("Cookie '" + name +
        "' possibly not set or overflowed because it was too large (" +
        cookieLength + " > 4096 bytes)!");
    }

    return str;
  }

  return function(name, value, options) {
    rawDocument.cookie = buildCookieString(name, value, options);
  };
}

$$CookieWriter.$inject = ['$document', '$log', '$browser'];

angular.module('ngCookies').provider('$$cookieWriter', function $$CookieWriterProvider() {
  this.$get = $$CookieWriter;
});


})(window, window.angular);


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(13);
module.exports = 'ngCookies';


/***/ }),
/* 15 */
/***/ (function(module, exports) {

(function(window) {
'use strict';
angular.module('tmh.dynamicLocale', []).config(['$provide', function ($provide) {
  function makeStateful($delegate) {
    $delegate.$stateful = true;
    return $delegate;
  }

  $provide.decorator('dateFilter', ['$delegate', makeStateful]);
  $provide.decorator('numberFilter', ['$delegate', makeStateful]);
  $provide.decorator('currencyFilter', ['$delegate', makeStateful]);

}])
.constant('tmhDynamicLocale.STORAGE_KEY', 'tmhDynamicLocale.locale')
.provider('tmhDynamicLocale', ['tmhDynamicLocale.STORAGE_KEY', function(STORAGE_KEY) {

  var defaultLocale,
    localeLocationPattern = 'angular/i18n/angular-locale_{{locale}}.js',
    storageFactory = 'tmhDynamicLocaleStorageCache',
    storage,
    storageKey = STORAGE_KEY,
    promiseCache = {},
    activeLocale;

  /**
   * Loads a script asynchronously
   *
   * @param {string} url The url for the script
   @ @param {function) callback A function to be called once the script is loaded
   */
  function loadScript(url, callback, errorCallback, $timeout) {
    var script = document.createElement('script'),
      body = document.getElementsByTagName('body')[0],
      removed = false;

    script.type = 'text/javascript';
    if (script.readyState) { // IE
      script.onreadystatechange = function () {
        if (script.readyState === 'complete' ||
            script.readyState === 'loaded') {
          script.onreadystatechange = null;
          $timeout(
            function () {
              if (removed) return;
              removed = true;
              body.removeChild(script);
              callback();
            }, 30, false);
        }
      };
    } else { // Others
      script.onload = function () {
        if (removed) return;
        removed = true;
        body.removeChild(script);
        callback();
      };
      script.onerror = function () {
        if (removed) return;
        removed = true;
        body.removeChild(script);
        errorCallback();
      };
    }
    script.src = url;
    script.async = false;
    body.appendChild(script);
  }

  /**
   * Loads a locale and replaces the properties from the current locale with the new locale information
   *
   * @param localeUrl The path to the new locale
   * @param $locale The locale at the curent scope
   */
  function loadLocale(localeUrl, $locale, localeId, $rootScope, $q, localeCache, $timeout) {

    function overrideValues(oldObject, newObject) {
      if (activeLocale !== localeId) {
        return;
      }
      angular.forEach(oldObject, function(value, key) {
        if (!newObject[key]) {
          delete oldObject[key];
        } else if (angular.isArray(newObject[key])) {
          oldObject[key].length = newObject[key].length;
        }
      });
      angular.forEach(newObject, function(value, key) {
        if (angular.isArray(newObject[key]) || angular.isObject(newObject[key])) {
          if (!oldObject[key]) {
            oldObject[key] = angular.isArray(newObject[key]) ? [] : {};
          }
          overrideValues(oldObject[key], newObject[key]);
        } else {
          oldObject[key] = newObject[key];
        }
      });
    }


    if (promiseCache[localeId]) return promiseCache[localeId];

    var cachedLocale,
      deferred = $q.defer();
    if (localeId === activeLocale) {
      deferred.resolve($locale);
    } else if ((cachedLocale = localeCache.get(localeId))) {
      activeLocale = localeId;
      $rootScope.$evalAsync(function() {
        overrideValues($locale, cachedLocale);
        $rootScope.$broadcast('$localeChangeSuccess', localeId, $locale);
        storage.put(storageKey, localeId);
        deferred.resolve($locale);
      });
    } else {
      activeLocale = localeId;
      promiseCache[localeId] = deferred.promise;
      loadScript(localeUrl, function () {
        // Create a new injector with the new locale
        var localInjector = angular.injector(['ngLocale']),
          externalLocale = localInjector.get('$locale');

        overrideValues($locale, externalLocale);
        localeCache.put(localeId, externalLocale);
        delete promiseCache[localeId];

        $rootScope.$apply(function () {
          $rootScope.$broadcast('$localeChangeSuccess', localeId, $locale);
          storage.put(storageKey, localeId);
          deferred.resolve($locale);
        });
      }, function () {
        delete promiseCache[localeId];

        $rootScope.$apply(function () {
          if (activeLocale === localeId) activeLocale = $locale.id;
          $rootScope.$broadcast('$localeChangeError', localeId);
          deferred.reject(localeId);
        });
      }, $timeout);
    }
    return deferred.promise;
  }

  this.localeLocationPattern = function(value) {
    if (value) {
      localeLocationPattern = value;
      return this;
    } else {
      return localeLocationPattern;
    }
  };

  this.useStorage = function(storageName) {
    storageFactory = storageName;
  };

  this.useCookieStorage = function() {
    this.useStorage('$cookieStore');
  };

  this.defaultLocale = function (value) {
    defaultLocale = value;
  };

  this.storageKey = function (value) {
    if (value) {
      storageKey = value;
      return this;
    } else {
      return storageKey;
    }
  };

  this.$get = ['$rootScope', '$injector', '$interpolate', '$locale', '$q', 'tmhDynamicLocaleCache', '$timeout', function($rootScope, $injector, interpolate, locale, $q, tmhDynamicLocaleCache, $timeout) {
    var localeLocation = interpolate(localeLocationPattern);

    storage = $injector.get(storageFactory);
    $rootScope.$evalAsync(function () {
      var initialLocale;
      if ((initialLocale = (storage.get(storageKey) || defaultLocale))) {
        loadLocale(localeLocation({locale: initialLocale}), locale, initialLocale, $rootScope, $q, tmhDynamicLocaleCache, $timeout);
      }
    });
    return {
      /**
       * @ngdoc method
       * @description
       * @param {string=} value Sets the locale to the new locale. Changing the locale will trigger
       *    a background task that will retrieve the new locale and configure the current $locale
       *    instance with the information from the new locale
       */
      set: function(value) {
        return loadLocale(localeLocation({locale: value}), locale, value, $rootScope, $q, tmhDynamicLocaleCache, $timeout);
      },
      /**
       * @ngdoc method
       * @description Returns the configured locale
       */
      get: function() {
        return activeLocale;
      }
    };
  }];
}]).provider('tmhDynamicLocaleCache', function() {
  this.$get = ['$cacheFactory', function($cacheFactory) {
    return $cacheFactory('tmh.dynamicLocales');
  }];
}).provider('tmhDynamicLocaleStorageCache', function() {
  this.$get = ['$cacheFactory', function($cacheFactory) {
    return $cacheFactory('tmh.dynamicLocales.store');
  }];
}).run(['tmhDynamicLocale', angular.noop]);
}(window));


/***/ }),
/* 16 */
/***/ (function(module, exports) {

/**
 * angular-growl - v0.4.0 - 2013-11-19
 * https://github.com/marcorinck/angular-growl
 * Copyright (c) 2013 Marco Rinck; Licensed MIT
 */
angular.module('angular-growl', []);
angular.module('angular-growl').directive('growl', [
  '$rootScope',
  function ($rootScope) {
    'use strict';
    return {
      restrict: 'A',
      template: '<div class="growl">' + '\t<div class="growl-item alert" ng-repeat="message in messages" ng-class="computeClasses(message)">' + '\t\t<button type="button" class="close" ng-click="deleteMessage(message)">&times;</button>' + '       <div ng-switch="message.enableHtml">' + '           <div ng-switch-when="true" ng-bind-html="message.text"></div>' + '           <div ng-switch-default ng-bind="message.text"></div>' + '       </div>' + '\t</div>' + '</div>',
      replace: false,
      scope: true,
      controller: [
        '$scope',
        '$timeout',
        'growl',
        function ($scope, $timeout, growl) {
          var onlyUnique = growl.onlyUnique();
          $scope.messages = [];
          function addMessage(message) {
            $scope.messages.push(message);
            if (message.ttl && message.ttl !== -1) {
              $timeout(function () {
                $scope.deleteMessage(message);
              }, message.ttl);
            }
          }
          $rootScope.$on('growlMessage', function (event, message) {
            var found;
            if (onlyUnique) {
              angular.forEach($scope.messages, function (msg) {
                if (message.text === msg.text && message.severity === msg.severity) {
                  found = true;
                }
              });
              if (!found) {
                addMessage(message);
              }
            } else {
              addMessage(message);
            }
          });
          $scope.deleteMessage = function (message) {
            var index = $scope.messages.indexOf(message);
            if (index > -1) {
              $scope.messages.splice(index, 1);
            }
          };
          $scope.computeClasses = function (message) {
            return {
              'alert-success': message.severity === 'success',
              'alert-error': message.severity === 'error',
              'alert-danger': message.severity === 'error',
              'alert-info': message.severity === 'info',
              'alert-warning': message.severity === 'warn'
            };
          };
        }
      ]
    };
  }
]);
angular.module('angular-growl').provider('growl', function () {
  'use strict';
  var _ttl = null, _enableHtml = false, _messagesKey = 'messages', _messageTextKey = 'text', _messageSeverityKey = 'severity', _onlyUniqueMessages = true;
  this.globalTimeToLive = function (ttl) {
    _ttl = ttl;
  };
  this.globalEnableHtml = function (enableHtml) {
    _enableHtml = enableHtml;
  };
  this.messagesKey = function (messagesKey) {
    _messagesKey = messagesKey;
  };
  this.messageTextKey = function (messageTextKey) {
    _messageTextKey = messageTextKey;
  };
  this.messageSeverityKey = function (messageSeverityKey) {
    _messageSeverityKey = messageSeverityKey;
  };
  this.onlyUniqueMessages = function (onlyUniqueMessages) {
    _onlyUniqueMessages = onlyUniqueMessages;
  };
  this.serverMessagesInterceptor = [
    '$q',
    'growl',
    function ($q, growl) {
      function checkResponse(response) {
        if (response.data[_messagesKey] && response.data[_messagesKey].length > 0) {
          growl.addServerMessages(response.data[_messagesKey]);
        }
      }
      function success(response) {
        checkResponse(response);
        return response;
      }
      function error(response) {
        checkResponse(response);
        return $q.reject(response);
      }
      return function (promise) {
        return promise.then(success, error);
      };
    }
  ];
  this.$get = [
    '$rootScope',
    '$filter',
    function ($rootScope, $filter) {
      var translate;
      try {
        translate = $filter('translate');
      } catch (e) {
      }
      function broadcastMessage(message) {
        if (translate) {
          message.text = translate(message.text);
        }
        $rootScope.$broadcast('growlMessage', message);
      }
      function sendMessage(text, config, severity) {
        var _config = config || {}, message;
        message = {
          text: text,
          severity: severity,
          ttl: _config.ttl || _ttl,
          enableHtml: _config.enableHtml || _enableHtml
        };
        broadcastMessage(message);
      }
      function addWarnMessage(text, config) {
        sendMessage(text, config, 'warn');
      }
      function addErrorMessage(text, config) {
        sendMessage(text, config, 'error');
      }
      function addInfoMessage(text, config) {
        sendMessage(text, config, 'info');
      }
      function addSuccessMessage(text, config) {
        sendMessage(text, config, 'success');
      }
      function addServerMessages(messages) {
        var i, message, severity, length;
        length = messages.length;
        for (i = 0; i < length; i++) {
          message = messages[i];
          if (message[_messageTextKey] && message[_messageSeverityKey]) {
            switch (message[_messageSeverityKey]) {
            case 'warn':
              severity = 'warn';
              break;
            case 'success':
              severity = 'success';
              break;
            case 'info':
              severity = 'info';
              break;
            case 'error':
              severity = 'error';
              break;
            }
            sendMessage(message[_messageTextKey], undefined, severity);
          }
        }
      }
      function onlyUnique() {
        return _onlyUniqueMessages;
      }
      return {
        addWarnMessage: addWarnMessage,
        addErrorMessage: addErrorMessage,
        addInfoMessage: addInfoMessage,
        addSuccessMessage: addSuccessMessage,
        addServerMessages: addServerMessages,
        onlyUnique: onlyUnique
      };
    }
  ];
});

/***/ }),
/* 17 */
/***/ (function(module, exports) {


/**
 * The iVantage Treeview module
 *
 * @package ivh.treeview
 */

angular.module('ivh.treeview', []);


/**
 * Supports non-default interpolation symbols
 *
 * @package ivh.treeview
 * @copyright 2016 iVantage Health Analytics, Inc.
 */

angular.module('ivh.treeview').constant('ivhTreeviewInterpolateEndSymbol', '}}');



/**
 * Supports non-default interpolation symbols
 *
 * @package ivh.treeview
 * @copyright 2016 iVantage Health Analytics, Inc.
 */

angular.module('ivh.treeview').constant('ivhTreeviewInterpolateStartSymbol', '{{');



/**
 * Selection management logic for treeviews with checkboxes
 *
 * @private
 * @package ivh.treeview
 * @copyright 2014 iVantage Health Analytics, Inc.
 */

angular.module('ivh.treeview').directive('ivhTreeviewCheckboxHelper', [function() {
  'use strict';
  return {
    restrict: 'A',
    scope: {
      node: '=ivhTreeviewCheckboxHelper'
    },
    require: '^ivhTreeview',
    link: function(scope, element, attrs, trvw) {
      var node = scope.node
        , opts = trvw.opts()
        , indeterminateAttr = opts.indeterminateAttribute
        , selectedAttr = opts.selectedAttribute;

      // Set initial selected state of this checkbox
      scope.isSelected = node[selectedAttr];

      // Local access to the parent controller
      scope.trvw = trvw;

      // Enforce consistent behavior across browsers by making indeterminate
      // checkboxes become checked when clicked/selected using spacebar
      scope.resolveIndeterminateClick = function() {

        //intermediate state is not handled when CheckBoxes state propagation is disabled
        if (opts.disableCheckboxSelectionPropagation) {
          return;
        }

        if(node[indeterminateAttr]) {
          trvw.select(node, true);
        }
      };

      // Update the checkbox when the node's selected status changes
      scope.$watch('node.' + selectedAttr, function(newVal, oldVal) {
        scope.isSelected = newVal;
      });

      if (!opts.disableCheckboxSelectionPropagation) {
        // Update the checkbox when the node's indeterminate status changes
        scope.$watch('node.' + indeterminateAttr, function(newVal, oldVal) {
          element.find('input').prop('indeterminate', newVal);
        });
      }
    },
    template: [
      '<input type="checkbox"',
        'class="ivh-treeview-checkbox"',
        'ng-model="isSelected"',
        'ng-click="resolveIndeterminateClick()"',
        'ng-change="trvw.select(node, isSelected)" />'
    ].join('\n')
  };
}]);



/**
 * Wrapper for a checkbox directive
 *
 * Basically exists so folks creeting custom node templates don't need to attach
 * their node to this directive explicitly - i.e. keeps consistent interface
 * with the twistie and toggle directives.
 *
 * @package ivh.treeview
 * @copyright 2014 iVantage Health Analytics, Inc.
 */

angular.module('ivh.treeview').directive('ivhTreeviewCheckbox', [function() {
  'use strict';
  return {
    restrict: 'AE',
    require: '^ivhTreeview',
    template: '<span ivh-treeview-checkbox-helper="node"></span>'
  };
}]);


/**
 * The recursive step, output child nodes for the scope node
 *
 * @package ivh.treeview
 * @copyright 2014 iVantage Health Analytics, Inc.
 */

angular.module('ivh.treeview').directive('ivhTreeviewChildren', function() {
  'use strict';
  return {
    restrict: 'AE',
    require: '^ivhTreeviewNode',
    template: [
      '<ul ng-if="getChildren().length" class="ivh-treeview">',
        '<li ng-repeat="child in getChildren()"',
            'ng-hide="trvw.hasFilter() && !trvw.isVisible(child)"',
            'class="ivh-treeview-node"',
            'ng-class="{\'ivh-treeview-node-collapsed\': !trvw.isExpanded(child) && !trvw.isLeaf(child)}"',
            'ivh-treeview-node="child"',
            'ivh-treeview-depth="childDepth">',
        '</li>',
      '</ul>'
    ].join('\n')
  };
});


/**
 * Treeview tree node directive
 *
 * @private
 * @package ivh.treeview
 * @copyright 2014 iVantage Health Analytics, Inc.
 */

angular.module('ivh.treeview').directive('ivhTreeviewNode', ['ivhTreeviewCompiler', function(ivhTreeviewCompiler) {
  'use strict';
  return {
    restrict: 'A',
    scope: {
      node: '=ivhTreeviewNode',
      depth: '=ivhTreeviewDepth'
    },
    require: '^ivhTreeview',
    compile: function(tElement) {
      return ivhTreeviewCompiler
        .compile(tElement, function(scope, element, attrs, trvw) {
          var node = scope.node;

          var getChildren = scope.getChildren = function() {
            return trvw.children(node);
          };

          scope.trvw = trvw;
          scope.childDepth = scope.depth + 1;

          // Expand/collapse the node as dictated by the expandToDepth property.
          // Note that we will respect the expanded state of this node if it has
          // been expanded by e.g. `ivhTreeviewMgr.expandTo` but not yet
          // rendered.
          if(!trvw.isExpanded(node)) {
            trvw.expand(node, trvw.isInitiallyExpanded(scope.depth));
          }

          /**
           * @todo Provide a way to opt out of this
           */
          scope.$watch(function() {
            return getChildren().length > 0;
          }, function(newVal) {
            if(newVal) {
              element.removeClass('ivh-treeview-node-leaf');
            } else {
              element.addClass('ivh-treeview-node-leaf');
            }
          });
        });
    }
  };
}]);



/**
 * Toggle logic for treeview nodes
 *
 * Handles expand/collapse on click. Does nothing for leaf nodes.
 *
 * @private
 * @package ivh.treeview
 * @copyright 2014 iVantage Health Analytics, Inc.
 */

angular.module('ivh.treeview').directive('ivhTreeviewToggle', [function() {
  'use strict';
  return {
    restrict: 'A',
    require: '^ivhTreeview',
    link: function(scope, element, attrs, trvw) {
      var node = scope.node;

      element.addClass('ivh-treeview-toggle');

      element.bind('click', function() {
        if(!trvw.isLeaf(node)) {
          scope.$apply(function() {
            trvw.toggleExpanded(node);
            trvw.onToggle(node);
          });
        }
      });
    }
  };
}]);


/**
 * Treeview twistie directive
 *
 * @private
 * @package ivh.treeview
 * @copyright 2014 iVantage Health Analytics, Inc.
 */

angular.module('ivh.treeview').directive('ivhTreeviewTwistie', ['$compile', 'ivhTreeviewOptions', function($compile, ivhTreeviewOptions) {
  'use strict';

  var globalOpts = ivhTreeviewOptions();

  return {
    restrict: 'A',
    require: '^ivhTreeview',
    template: [
      '<span class="ivh-treeview-twistie">',
        '<span class="ivh-treeview-twistie-collapsed">',
          globalOpts.twistieCollapsedTpl,
        '</span>',
        '<span class="ivh-treeview-twistie-expanded">',
          globalOpts.twistieExpandedTpl,
        '</span>',
        '<span class="ivh-treeview-twistie-leaf">',
          globalOpts.twistieLeafTpl,
        '</span>',
      '</span>'
    ].join('\n'),
    link: function(scope, element, attrs, trvw) {

      if(!trvw.hasLocalTwistieTpls) {
        return;
      }

      var opts = trvw.opts()
        , $twistieContainers = element
          .children().eq(0) // Template root
          .children(); // The twistie spans

      angular.forEach([
        // Should be in the same order as elements in template
        'twistieCollapsedTpl',
        'twistieExpandedTpl',
        'twistieLeafTpl'
      ], function(tplKey, ix) {
        var tpl = opts[tplKey]
          , tplGlobal = globalOpts[tplKey];

        // Do nothing if we don't have a new template
        if(!tpl || tpl === tplGlobal) {
          return;
        }

        // Super gross, the template must actually be an html string, we won't
        // try too hard to enforce this, just don't shoot yourself in the foot
        // too badly and everything will be alright.
        if(tpl.substr(0, 1) !== '<' || tpl.substr(-1, 1) !== '>') {
          tpl = '<span>' + tpl + '</span>';
        }

        var $el = $compile(tpl)(scope)
          , $container = $twistieContainers.eq(ix);

        // Clean out global template and append the new one
        $container.html('').append($el);
      });

    }
  };
}]);


/**
 * The `ivh-treeview` directive
 *
 * A filterable tree view with checkbox support.
 *
 * Example:
 *
 * ```
 * <div
 *   ivh-treeview="myHierarchicalData">
 *   ivh-treeview-filter="myFilterText">
 * </div>
 * ```
 *
 * @package ivh.treeview
 * @copyright 2014 iVantage Health Analytics, Inc.
 */

angular.module('ivh.treeview').directive('ivhTreeview', ['ivhTreeviewMgr', function(ivhTreeviewMgr) {
  'use strict';
  return {
    restrict: 'A',
    transclude: true,
    scope: {
      // The tree data store
      root: '=ivhTreeview',

      // Specific config options
      childrenAttribute: '=ivhTreeviewChildrenAttribute',
      defaultSelectedState: '=ivhTreeviewDefaultSelectedState',
      disableCheckboxSelectionPropagation: '=ivhTreeviewDisableCheckboxSelectionPropagation',
      expandToDepth: '=ivhTreeviewExpandToDepth',
      idAttribute: '=ivhTreeviewIdAttribute',
      indeterminateAttribute: '=ivhTreeviewIndeterminateAttribute',
      expandedAttribute: '=ivhTreeviewExpandedAttribute',
      labelAttribute: '=ivhTreeviewLabelAttribute',
      nodeTpl: '=ivhTreeviewNodeTpl',
      selectedAttribute: '=ivhTreeviewSelectedAttribute',
      onCbChange: '&ivhTreeviewOnCbChange',
      onToggle: '&ivhTreeviewOnToggle',
      twistieCollapsedTpl: '=ivhTreeviewTwistieCollapsedTpl',
      twistieExpandedTpl: '=ivhTreeviewTwistieExpandedTpl',
      twistieLeafTpl: '=ivhTreeviewTwistieLeafTpl',
      useCheckboxes: '=ivhTreeviewUseCheckboxes',
      validate: '=ivhTreeviewValidate',
      visibleAttribute: '=ivhTreeviewVisibleAttribute',

      // Generic options object
      userOptions: '=ivhTreeviewOptions',

      // The filter
      filter: '=ivhTreeviewFilter'
    },
    controllerAs: 'trvw',
    controller: ['$scope', '$element', '$attrs', '$transclude', 'ivhTreeviewOptions', 'filterFilter', function($scope, $element, $attrs, $transclude, ivhTreeviewOptions, filterFilter) {
      var ng = angular
        , trvw = this;

      // Merge any locally set options with those registered with hte
      // ivhTreeviewOptions provider
      var localOpts = ng.extend({}, ivhTreeviewOptions(), $scope.userOptions);

      // Two-way bound attributes (=) can be copied over directly if they're
      // non-empty
      ng.forEach([
        'childrenAttribute',
        'defaultSelectedState',
        'disableCheckboxSelectionPropagation',
        'expandToDepth',
        'idAttribute',
        'indeterminateAttribute',
        'expandedAttribute',
        'labelAttribute',
        'nodeTpl',
        'selectedAttribute',
        'twistieCollapsedTpl',
        'twistieExpandedTpl',
        'twistieLeafTpl',
        'useCheckboxes',
        'validate',
        'visibleAttribute'
      ], function(attr) {
        if(ng.isDefined($scope[attr])) {
          localOpts[attr] = $scope[attr];
        }
      });

      // Attrs with the `&` prefix will yield a defined scope entity even if
      // no value is specified. We must check to make sure the attribute string
      // is non-empty before copying over the scope value.
      var normedAttr = function(attrKey) {
        return 'ivhTreeview' +
          attrKey.charAt(0).toUpperCase() +
          attrKey.slice(1);
      };

      ng.forEach([
        'onCbChange',
        'onToggle'
      ], function(attr) {
        if($attrs[normedAttr(attr)]) {
          localOpts[attr] = $scope[attr];
        }
      });

      // Treat the transcluded content (if there is any) as our node template
      var transcludedScope;
      $transclude(function(clone, scope) {
        var transcludedNodeTpl = '';
        angular.forEach(clone, function(c) {
          transcludedNodeTpl += (c.innerHTML || '').trim();
        });
        if(transcludedNodeTpl.length) {
          transcludedScope = scope;
          localOpts.nodeTpl = transcludedNodeTpl;
        }
      });

      /**
       * Get the merged global and local options
       *
       * @return {Object} the merged options
       */
      trvw.opts = function() {
        return localOpts;
      };

      // If we didn't provide twistie templates we'll be doing a fair bit of
      // extra checks for no reason. Let's just inform down stream directives
      // whether or not they need to worry about twistie non-global templates.
      var userOpts = $scope.userOptions || {};

      /**
       * Whether or not we have local twistie templates
       *
       * @private
       */
      trvw.hasLocalTwistieTpls = !!(
        userOpts.twistieCollapsedTpl ||
        userOpts.twistieExpandedTpl ||
        userOpts.twistieLeafTpl ||
        $scope.twistieCollapsedTpl ||
        $scope.twistieExpandedTpl ||
        $scope.twistieLeafTpl);

      /**
       * Get the child nodes for `node`
       *
       * Abstracts away the need to know the actual label attribute in
       * templates.
       *
       * @param {Object} node a tree node
       * @return {Array} the child nodes
       */
      trvw.children = function(node) {
        var children = node[localOpts.childrenAttribute];
        return ng.isArray(children) ? children : [];
      };

      /**
       * Get the label for `node`
       *
       * Abstracts away the need to know the actual label attribute in
       * templates.
       *
       * @param {Object} node A tree node
       * @return {String} The node label
       */
      trvw.label = function(node) {
        return node[localOpts.labelAttribute];
      };

      /**
       * Returns `true` if this treeview has a filter
       *
       * @return {Boolean} Whether on not we have a filter
       * @private
       */
      trvw.hasFilter = function() {
        return ng.isDefined($scope.filter);
      };

      /**
       * Get the treeview filter
       *
       * @return {String} The filter string
       * @private
       */
      trvw.getFilter = function() {
        return $scope.filter || '';
      };

      /**
       * Returns `true` if current filter should hide `node`, false otherwise
       *
       * @todo Note that for object and function filters each node gets hit with
       * `isVisible` N-times where N is its depth in the tree. We may be able to
       * optimize `isVisible` in this case by:
       *
       * - On first call to `isVisible` in a given digest cycle walk the tree to
       *   build a flat array of nodes.
       * - Run the array of nodes through the filter.
       * - Build a map (`id`/$scopeId --> true) for the nodes that survive the
       *   filter
       * - On subsequent calls to `isVisible` just lookup the node id in our
       *   map.
       * - Clean the map with a $timeout (?)
       *
       * In theory the result of a call to `isVisible` could change during a
       * digest cycle as scope variables are updated... I think calls would
       * happen bottom up (i.e. from "leaf" to "root") so that might not
       * actually be an issue. Need to investigate if this ends up feeling for
       * large/deep trees.
       *
       * @param {Object} node A tree node
       * @return {Boolean} Whether or not `node` is filtered out
       */
      trvw.isVisible = function(node) {
        var filter = trvw.getFilter();

        // Quick shortcut
        if(!filter || filterFilter([node], filter).length) {
          return true;
        }

        // If we have an object or function filter we have to check children
        // separately
        if(typeof filter === 'object' || typeof filter === 'function') {
          var children = trvw.children(node);
          // If any child is visible then so is this node
          for(var ix = children.length; ix--;) {
            if(trvw.isVisible(children[ix])) {
              return true;
            }
          }
        }

        return false;
      };

      /**
       * Returns `true` if we should use checkboxes, false otherwise
       *
       * @return {Boolean} Whether or not to use checkboxes
       */
      trvw.useCheckboxes = function() {
        return localOpts.useCheckboxes;
      };

      /**
       * Select or deselect `node`
       *
       * Updates parent and child nodes appropriately, `isSelected` defaults to
       * `true`.
       *
       * @param {Object} node The node to select or deselect
       * @param {Boolean} isSelected Defaults to `true`
       */
      trvw.select = function(node, isSelected) {
        ivhTreeviewMgr.select($scope.root, node, localOpts, isSelected);
        trvw.onCbChange(node, isSelected);
      };

      /**
       * Get the selected state of `node`
       *
       * @param {Object} node The node to get the selected state of
       * @return {Boolean} `true` if `node` is selected
       */
      trvw.isSelected = function(node) {
        return node[localOpts.selectedAttribute];
      };

      /**
       * Toggle the selected state of `node`
       *
       * Updates parent and child node selected states appropriately.
       *
       * @param {Object} node The node to update
       */
      trvw.toggleSelected = function(node) {
        var isSelected = !node[localOpts.selectedAttribute];
        trvw.select(node, isSelected);
      };

      /**
       * Expand or collapse a given node
       *
       * `isExpanded` is optional and defaults to `true`.
       *
       * @param {Object} node The node to expand/collapse
       * @param {Boolean} isExpanded Whether to expand (`true`) or collapse
       */
      trvw.expand = function(node, isExpanded) {
        ivhTreeviewMgr.expand($scope.root, node, localOpts, isExpanded);
      };

      /**
       * Get the expanded state of a given node
       *
       * @param {Object} node The node to check the expanded state of
       * @return {Boolean}
       */
      trvw.isExpanded = function(node) {
        return node[localOpts.expandedAttribute];
      };

      /**
       * Toggle the expanded state of a given node
       *
       * @param {Object} node The node to toggle
       */
      trvw.toggleExpanded = function(node) {
        trvw.expand(node, !trvw.isExpanded(node));
      };

      /**
       * Whether or not nodes at `depth` should be expanded by default
       *
       * Use -1 to fully expand the tree by default.
       *
       * @param {Integer} depth The depth to expand to
       * @return {Boolean} Whether or not nodes at `depth` should be expanded
       * @private
       */
      trvw.isInitiallyExpanded = function(depth) {
        var expandTo = localOpts.expandToDepth === -1 ?
          Infinity : localOpts.expandToDepth;
        return depth < expandTo;
      };

      /**
       * Returns `true` if `node` is a leaf node
       *
       * @param {Object} node The node to check
       * @return {Boolean} `true` if `node` is a leaf
       */
      trvw.isLeaf = function(node) {
        return trvw.children(node).length === 0;
      };

      /**
       * Get the tree node template
       *
       * @return {String} The node template
       * @private
       */
      trvw.getNodeTpl = function() {
        return localOpts.nodeTpl;
      };

      /**
       * Get the root of the tree
       *
       * Mostly a helper for custom templates
       *
       * @return {Object|Array} The tree root
       * @private
       */
      trvw.root = function() {
        return $scope.root;
      };

      /**
       * Call the registered toggle handler
       *
       * Handler will get a reference to `node` and the root of the tree.
       *
       * @param {Object} node Tree node to pass to the handler
       * @private
       */
      trvw.onToggle = function(node) {
        if(localOpts.onToggle) {
          var locals = {
            ivhNode: node,
            ivhIsExpanded: trvw.isExpanded(node),
            ivhTree: $scope.root
          };
          localOpts.onToggle(locals);
        }
      };

      /**
       * Call the registered selection change handler
       *
       * Handler will get a reference to `node`, the new selected state of
       * `node, and the root of the tree.
       *
       * @param {Object} node Tree node to pass to the handler
       * @param {Boolean} isSelected Selected state for `node`
       * @private
       */
      trvw.onCbChange = function(node, isSelected) {
        if(localOpts.onCbChange) {
          var locals = {
            ivhNode: node,
            ivhIsSelected: isSelected,
            ivhTree: $scope.root
          };
          localOpts.onCbChange(locals);
        }
      };
    }],
    link: function(scope, element, attrs) {
      var opts = scope.trvw.opts();

      // Allow opt-in validate on startup
      if(opts.validate) {
        ivhTreeviewMgr.validate(scope.root, opts);
      }
    },
    template: [
      '<ul class="ivh-treeview">',
        '<li ng-repeat="child in root | ivhTreeviewAsArray"',
            'ng-hide="trvw.hasFilter() && !trvw.isVisible(child)"',
            'class="ivh-treeview-node"',
            'ng-class="{\'ivh-treeview-node-collapsed\': !trvw.isExpanded(child) && !trvw.isLeaf(child)}"',
            'ivh-treeview-node="child"',
            'ivh-treeview-depth="0">',
        '</li>',
      '</ul>'
    ].join('\n')
  };
}]);


angular.module('ivh.treeview').filter('ivhTreeviewAsArray', function() {
  'use strict';
  return function(arr) {
    if(!angular.isArray(arr) && angular.isObject(arr)) {
      return [arr];
    }
    return arr;
  };
});


/**
 * Breadth first searching for treeview data stores
 *
 * @package ivh.treeview
 * @copyright 2014 iVantage Health Analytics, Inc.
 */

angular.module('ivh.treeview').factory('ivhTreeviewBfs', ['ivhTreeviewOptions', function(ivhTreeviewOptions) {
  'use strict';

  var ng = angular;

  /**
   * Breadth first search of `tree`
   *
   * `opts` is optional and may override settings from `ivhTreeviewOptions.options`.
   * The callback `cb` will be invoked on each node in the tree as we traverse,
   * if it returns `false` traversal of that branch will not continue. The
   * callback is given the current node as the first parameter and the node
   * ancestors, from closest to farthest, as an array in the second parameter.
   *
   * @param {Array|Object} tree The tree data
   * @param {Object} opts [optional] Settings overrides
   * @param {Function} cb [optional] Callback to run against each node
   */
  return function(tree, opts, cb) {
    if(arguments.length === 2 && ng.isFunction(opts)) {
      cb = opts;
      opts = {};
    }
    opts = angular.extend({}, ivhTreeviewOptions(), opts);
    cb = cb || ng.noop;

    var queue = []
      , childAttr = opts.childrenAttribute
      , next, node, parents, ix, numChildren;

    if(ng.isArray(tree)) {
      ng.forEach(tree, function(n) {
        // node and parents
        queue.push([n, []]);
      });
      next = queue.shift();
    } else {
      // node and parents
      next = [tree, []];
    }

    while(next) {
      node = next[0];
      parents = next[1];
      // cb might return `undefined` so we have to actually check for equality
      // against `false`
      if(cb(node, parents) !== false) {
        if(node[childAttr] && ng.isArray(node[childAttr])) {
          numChildren = node[childAttr].length;
          for(ix = 0; ix < numChildren; ix++) {
            queue.push([node[childAttr][ix], [node].concat(parents)]);
          }
        }
      }
      next = queue.shift();
    }
  };
}]);


/**
 * Compile helper for treeview nodes
 *
 * Defers compilation until after linking parents. Otherwise our treeview
 * compilation process would recurse indefinitely.
 *
 * Thanks to http://stackoverflow.com/questions/14430655/recursion-in-angular-directives
 *
 * @private
 * @package ivh.treeview
 * @copyright 2014 iVantage Health Analytics, Inc.
 */

angular.module('ivh.treeview').factory('ivhTreeviewCompiler', ['$compile', function($compile) {
  'use strict';
  return {
    /**
     * Manually compiles the element, fixing the recursion loop.
     * @param {Object} element The angular element or template
     * @param {Function} link [optional] A post-link function, or an object with function(s) registered via pre and post properties.
     * @returns An object containing the linking functions.
     */
    compile: function(element, link) {
      // Normalize the link parameter
      if(angular.isFunction(link)) {
        link = { post: link };
      }

      var compiledContents;
      return {
        pre: (link && link.pre) ? link.pre : null,
        /**
         * Compiles and re-adds the contents
         */
        post: function(scope, element, attrs, trvw) {
          // Compile our template
          if(!compiledContents) {
            compiledContents = $compile(trvw.getNodeTpl());
          }
          // Add the compiled template
          compiledContents(scope, function(clone) {
            element.append(clone);
          });

          // Call the post-linking function, if any
          if(link && link.post) {
            link.post.apply(null, arguments);
          }
        }
      };
    }
  };
}]);


/**
 * Manager for treeview data stores
 *
 * Used to assist treeview operations, e.g. selecting or validating a tree-like
 * collection.
 *
 * @package ivh.treeview
 * @copyright 2014 iVantage Health Analytics, Inc.
 */

angular.module('ivh.treeview')
  .factory('ivhTreeviewMgr', ['ivhTreeviewOptions', 'ivhTreeviewBfs', function(ivhTreeviewOptions, ivhTreeviewBfs) {
    'use strict';

    var ng = angular
      , options = ivhTreeviewOptions()
      , exports = {};

    // The make* methods and validateParent need to be bound to an options
    // object
    var makeDeselected = function(node) {
      node[this.selectedAttribute] = false;
      node[this.indeterminateAttribute] = false;
    };

    var makeSelected = function(node) {
      node[this.selectedAttribute] = true;
      node[this.indeterminateAttribute] = false;
    };

    var validateParent = function(node) {
      var children = node[this.childrenAttribute]
        , selectedAttr = this.selectedAttribute
        , indeterminateAttr = this.indeterminateAttribute
        , numSelected = 0
        , numIndeterminate = 0;
      ng.forEach(children, function(n, ix) {
        if(n[selectedAttr]) {
          numSelected++;
        } else {
          if(n[indeterminateAttr]) {
            numIndeterminate++;
          }
        }
      });

      if(0 === numSelected && 0 === numIndeterminate) {
        node[selectedAttr] = false;
        node[indeterminateAttr] = false;
      } else if(numSelected === children.length) {
        node[selectedAttr] = true;
        node[indeterminateAttr] = false;
      } else {
        node[selectedAttr] = false;
        node[indeterminateAttr] = true;
      }
    };

    var findNode = function(tree, node, opts, cb) {
      var useId = isId(node)
        , proceed = true
        , idAttr = opts.idAttribute;

      // Our return values
      var foundNode = null
        , foundParents = [];

      ivhTreeviewBfs(tree, opts, function(n, p) {
        var isNode = proceed && (useId ?
          node === n[idAttr] :
          node === n);

        if(isNode) {
          // I've been looking for you all my life
          proceed = false;
          foundNode = n;
          foundParents = p;
        }

        return proceed;
      });

      return cb(foundNode, foundParents);
    };

    var isId = function(val) {
      return ng.isString(val) || ng.isNumber(val);
    };

    /**
     * Select (or deselect) a tree node
     *
     * This method will update the rest of the tree to account for your change.
     *
     * You may alternatively pass an id as `node`, in which case the tree will
     * be searched for your item.
     *
     * @param {Object|Array} tree The tree data
     * @param {Object|String} node The node (or id) to (de)select
     * @param {Object} opts [optional] Options to override default options with
     * @param {Boolean} isSelected [optional] Whether or not to select `node`, defaults to `true`
     * @return {Object} Returns the ivhTreeviewMgr instance for chaining
     */
    exports.select = function(tree, node, opts, isSelected) {
      if(arguments.length > 2) {
        if(typeof opts === 'boolean') {
          isSelected = opts;
          opts = {};
        }
      }
      opts = ng.extend({}, options, opts);
      isSelected = ng.isDefined(isSelected) ? isSelected : true;

      var useId = isId(node)
        , proceed = true
        , idAttr = opts.idAttribute;

      ivhTreeviewBfs(tree, opts, function(n, p) {
        var isNode = proceed && (useId ?
          node === n[idAttr] :
          node === n);

        if(isNode) {
          // I've been looking for you all my life
          proceed = false;

          var cb = isSelected ?
            makeSelected.bind(opts) :
            makeDeselected.bind(opts);

          if (opts.disableCheckboxSelectionPropagation) {
            cb(n);
          } else {
            ivhTreeviewBfs(n, opts, cb);
            ng.forEach(p, validateParent.bind(opts));
          }
        }

        return proceed;
      });

      return exports;
    };

    /**
     * Select all nodes in a tree
     *
     * `opts` will default to an empty object, `isSelected` defaults to `true`.
     *
     * @param {Object|Array} tree The tree data
     * @param {Object} opts [optional] Default options overrides
     * @param {Boolean} isSelected [optional] Whether or not to select items
     * @return {Object} Returns the ivhTreeviewMgr instance for chaining
     */
    exports.selectAll = function(tree, opts, isSelected) {
      if(arguments.length > 1) {
        if(typeof opts === 'boolean') {
          isSelected = opts;
          opts = {};
        }
      }

      opts = ng.extend({}, options, opts);
      isSelected = ng.isDefined(isSelected) ? isSelected : true;

      var selectedAttr = opts.selectedAttribute
        , indeterminateAttr = opts.indeterminateAttribute;

      ivhTreeviewBfs(tree, opts, function(node) {
        node[selectedAttr] = isSelected;
        node[indeterminateAttr] = false;
      });

      return exports;
    };

    /**
     * Select or deselect each of the passed items
     *
     * Eventually it would be nice if this did something more intelligent than
     * just calling `select` on each item in the array...
     *
     * @param {Object|Array} tree The tree data
     * @param {Array} nodes The array of nodes or node ids
     * @param {Object} opts [optional] Default options overrides
     * @param {Boolean} isSelected [optional] Whether or not to select items
     * @return {Object} Returns the ivhTreeviewMgr instance for chaining
     */
    exports.selectEach = function(tree, nodes, opts, isSelected) {
      /**
       * @todo Surely we can do something better than this...
       */
      ng.forEach(nodes, function(node) {
        exports.select(tree, node, opts, isSelected);
      });
      return exports;
    };

    /**
     * Deselect a tree node
     *
     * Delegates to `ivhTreeviewMgr.select` with `isSelected` set to `false`.
     *
     * @param {Object|Array} tree The tree data
     * @param {Object|String} node The node (or id) to (de)select
     * @param {Object} opts [optional] Options to override default options with
     * @return {Object} Returns the ivhTreeviewMgr instance for chaining
     */
    exports.deselect = function(tree, node, opts) {
      return exports.select(tree, node, opts, false);
    };

    /**
     * Deselect all nodes in a tree
     *
     * Delegates to `ivhTreeviewMgr.selectAll` with `isSelected` set to `false`.
     *
     * @param {Object|Array} tree The tree data
     * @param {Object} opts [optional] Default options overrides
     * @return {Object} Returns the ivhTreeviewMgr instance for chaining
     */
    exports.deselectAll = function(tree, opts) {
      return exports.selectAll(tree, opts, false);
    };

    /**
     * Deselect each of the passed items
     *
     * Delegates to `ivhTreeviewMgr.selectEach` with `isSelected` set to
     * `false`.
     *
     * @param {Object|Array} tree The tree data
     * @param {Array} nodes The array of nodes or node ids
     * @param {Object} opts [optional] Default options overrides
     * @return {Object} Returns the ivhTreeviewMgr instance for chaining
     */
    exports.deselectEach = function(tree, nodes, opts) {
      return exports.selectEach(tree, nodes, opts, false);
    };

    /**
     * Validate tree for parent/child selection consistency
     *
     * Assumes `bias` as default selected state. The first element with
     * `node.select !== bias` will be assumed correct. For example, if `bias` is
     * `true` (the default) we'll traverse the tree until we come to an
     * unselected node at which point we stop and deselect each of that node's
     * children (and their children, etc.).
     *
     * Indeterminate states will also be resolved.
     *
     * @param {Object|Array} tree The tree data
     * @param {Object} opts [optional] Options to override default options with
     * @param {Boolean} bias [optional] Default selected state
     * @return {Object} Returns the ivhTreeviewMgr instance for chaining
     */
    exports.validate = function(tree, opts, bias) {
      if(!tree) {
        // Guard against uninitialized trees
        return exports;
      }

      if(arguments.length > 1) {
        if(typeof opts === 'boolean') {
          bias = opts;
          opts = {};
        }
      }
      opts = ng.extend({}, options, opts);
      bias = ng.isDefined(bias) ? bias : opts.defaultSelectedState;

      var selectedAttr = opts.selectedAttribute
        , indeterminateAttr = opts.indeterminateAttribute;

      ivhTreeviewBfs(tree, opts, function(node, parents) {
        if(ng.isDefined(node[selectedAttr]) && node[selectedAttr] !== bias) {
          exports.select(tree, node, opts, !bias);
          return false;
        } else {
          node[selectedAttr] = bias;
          node[indeterminateAttr] = false;
        }
      });

      return exports;
    };

    /**
     * Expand/collapse a given tree node
     *
     * `node` may be either an actual tree node object or a node id.
     *
     * `opts` may override any of the defaults set by `ivhTreeviewOptions`.
     *
     * @param {Object|Array} tree The tree data
     * @param {Object|String} node The node (or id) to expand/collapse
     * @param {Object} opts [optional] Options to override default options with
     * @param {Boolean} isExpanded [optional] Whether or not to expand `node`, defaults to `true`
     * @return {Object} Returns the ivhTreeviewMgr instance for chaining
     */
    exports.expand = function(tree, node, opts, isExpanded) {
      if(arguments.length > 2) {
        if(typeof opts === 'boolean') {
          isExpanded = opts;
          opts = {};
        }
      }
      opts = ng.extend({}, options, opts);
      isExpanded = ng.isDefined(isExpanded) ? isExpanded : true;

      var useId = isId(node)
        , expandedAttr = opts.expandedAttribute;

      if(!useId) {
        // No need to do any searching if we already have the node in hand
        node[expandedAttr] = isExpanded;
        return exports;
      }

      return findNode(tree, node, opts, function(n, p) {
        n[expandedAttr] = isExpanded;
        return exports;
      });
    };

    /**
     * Expand/collapse a given tree node and its children
     *
     * `node` may be either an actual tree node object or a node id. You may
     * leave off `node` entirely to expand/collapse the entire tree, however, if
     * you specify a value for `opts` or `isExpanded` you must provide a value
     * for `node`.
     *
     * `opts` may override any of the defaults set by `ivhTreeviewOptions`.
     *
     * @param {Object|Array} tree The tree data
     * @param {Object|String} node [optional*] The node (or id) to expand/collapse recursively
     * @param {Object} opts [optional] Options to override default options with
     * @param {Boolean} isExpanded [optional] Whether or not to expand `node`, defaults to `true`
     * @return {Object} Returns the ivhTreeviewMgr instance for chaining
     */
    exports.expandRecursive = function(tree, node, opts, isExpanded) {
      if(arguments.length > 2) {
        if(typeof opts === 'boolean') {
          isExpanded = opts;
          opts = {};
        }
      }
      node = ng.isDefined(node) ? node : tree;
      opts = ng.extend({}, options, opts);
      isExpanded = ng.isDefined(isExpanded) ? isExpanded : true;

      var useId = isId(node)
        , expandedAttr = opts.expandedAttribute
        , branch;

      // If we have an ID first resolve it to an actual node in the tree
      if(useId) {
        findNode(tree, node, opts, function(n, p) {
          branch = n;
        });
      } else {
        branch = node;
      }

      if(branch) {
        ivhTreeviewBfs(branch, opts, function(n, p) {
          n[expandedAttr] = isExpanded;
        });
      }

      return exports;
    };

    /**
     * Collapse a given tree node
     *
     * Delegates to `exports.expand` with `isExpanded` set to `false`.
     *
     * @param {Object|Array} tree The tree data
     * @param {Object|String} node The node (or id) to collapse
     * @param {Object} opts [optional] Options to override default options with
     * @return {Object} Returns the ivhTreeviewMgr instance for chaining
     */
    exports.collapse = function(tree, node, opts) {
      return exports.expand(tree, node, opts, false);
    };

    /**
     * Collapse a given tree node and its children
     *
     * Delegates to `exports.expandRecursive` with `isExpanded` set to `false`.
     *
     * @param {Object|Array} tree The tree data
     * @param {Object|String} node The node (or id) to expand/collapse recursively
     * @param {Object} opts [optional] Options to override default options with
     * @return {Object} Returns the ivhTreeviewMgr instance for chaining
     */
    exports.collapseRecursive = function(tree, node, opts, isExpanded) {
      return exports.expandRecursive(tree, node, opts, false);
    };

    /**
     * Expand[/collapse] all parents of a given node, i.e. "reveal" the node
     *
     * @param {Object|Array} tree The tree data
     * @param {Object|String} node The node (or id) to expand to
     * @param {Object} opts [optional] Options to override default options with
     * @param {Boolean} isExpanded [optional] Whether or not to expand parent nodes
     * @return {Object} Returns the ivhTreeviewMgr instance for chaining
     */
    exports.expandTo = function(tree, node, opts, isExpanded) {
      if(arguments.length > 2) {
        if(typeof opts === 'boolean') {
          isExpanded = opts;
          opts = {};
        }
      }
      opts = ng.extend({}, options, opts);
      isExpanded = ng.isDefined(isExpanded) ? isExpanded : true;

      var expandedAttr = opts.expandedAttribute;

      var expandCollapseNode = function(n) {
        n[expandedAttr] = isExpanded;
      };

      // Even if wer were given the actual node and not its ID we must still
      // traverse the tree to find that node's parents.
      return findNode(tree, node, opts, function(n, p) {
        ng.forEach(p, expandCollapseNode);
        return exports;
      });
    };

    /**
     * Collapse all parents of a give node
     *
     * Delegates to `exports.expandTo` with `isExpanded` set to `false`.
     *
     * @param {Object|Array} tree The tree data
     * @param {Object|String} node The node (or id) to expand to
     * @param {Object} opts [optional] Options to override default options with
     * @return {Object} Returns the ivhTreeviewMgr instance for chaining
     */
    exports.collapseParents = function(tree, node, opts) {
      return exports.expandTo(tree, node, opts, false);
    };

    return exports;
  }
]);


/**
 * Global options for ivhTreeview
 *
 * @package ivh.treeview
 * @copyright 2014 iVantage Health Analytics, Inc.
 */

angular.module('ivh.treeview').provider('ivhTreeviewOptions', [
    'ivhTreeviewInterpolateStartSymbol', 'ivhTreeviewInterpolateEndSymbol',
    function(ivhTreeviewInterpolateStartSymbol, ivhTreeviewInterpolateEndSymbol) {
  'use strict';

  var symbolStart = ivhTreeviewInterpolateStartSymbol
    , symbolEnd = ivhTreeviewInterpolateEndSymbol;

  var options = {
    /**
     * ID attribute
     *
     * For selecting nodes by identifier rather than reference
     */
    idAttribute: 'id',

    /**
     * Collection item attribute to use for labels
     */
    labelAttribute: 'label',

    /**
     * Collection item attribute to use for child nodes
     */
    childrenAttribute: 'children',

    /**
     * Collection item attribute to use for selected state
     */
    selectedAttribute: 'selected',

    /**
     * Controls whether branches are initially expanded or collapsed
     *
     * A value of `0` means the tree will be entirely collapsd (the default
     * state) otherwise branches will be expanded up to the specified depth. Use
     * `-1` to have the tree entirely expanded.
     */
    expandToDepth: 0,

    /**
     * Whether or not to use checkboxes
     *
     * If `false` the markup to support checkboxes is not included in the
     * directive.
     */
    useCheckboxes: true,

    /**
     * If set to true the checkboxes are independent on each other (no state
     * propagation to children and revalidation of parents' states).
     * If you set to true, you should set also `validate` property to `false`
     * and avoid explicit calling of `ivhTreeviewMgr.validate()`.
     */
    disableCheckboxSelectionPropagation: false,

    /**
     * Whether or not directive should validate treestore on startup
     */
    validate: true,

    /**
     * Collection item attribute to track intermediate states
     */
    indeterminateAttribute: '__ivhTreeviewIndeterminate',

    /**
     * Collection item attribute to track expanded status
     */
    expandedAttribute: '__ivhTreeviewExpanded',

    /**
     * Default selected state when validating
     */
    defaultSelectedState: true,

    /**
     * Template for expanded twisties
     */
    twistieExpandedTpl: '(-)',

    /**
     * Template for collapsed twisties
     */
    twistieCollapsedTpl: '(+)',

    /**
     * Template for leaf twisties (i.e. no children)
     */
    twistieLeafTpl: 'o',

    /**
     * Template for tree nodes
     */
    nodeTpl: [
      '<div class="ivh-treeview-node-content" title="{{trvw.label(node)}}">',
        '<span ivh-treeview-toggle>',
          '<span class="ivh-treeview-twistie-wrapper" ivh-treeview-twistie></span>',
        '</span>',
        '<span class="ivh-treeview-checkbox-wrapper" ng-if="trvw.useCheckboxes()"',
            'ivh-treeview-checkbox>',
        '</span>',
        '<span class="ivh-treeview-node-label" ivh-treeview-toggle>',
          '{{trvw.label(node)}}',
        '</span>',
        '<div ivh-treeview-children></div>',
      '</div>'
    ].join('\n')
    .replace(new RegExp('{{', 'g'), symbolStart)
    .replace(new RegExp('}}', 'g'), symbolEnd)
  };

  /**
   * Update global options
   *
   * @param {Object} opts options object to override defaults with
   */
  this.set = function(opts) {
    angular.extend(options, opts);
  };

  this.$get = function() {
    /**
     * Get a copy of the global options
     *
     * @return {Object} The options object
     */
    return function() {
      return angular.copy(options);
    };
  };
}]);


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * angular-translate - v2.8.1 - 2015-10-01
 * 
 * Copyright (c) 2015 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (true) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
      return (factory());
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {

angular.module('pascalprecht.translate')
/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateStaticFilesLoader
 * @requires $q
 * @requires $http
 *
 * @description
 * Creates a loading function for a typical static file url pattern:
 * "lang-en_US.json", "lang-de_DE.json", etc. Using this builder,
 * the response of these urls must be an object of key-value pairs.
 *
 * @param {object} options Options object, which gets prefix, suffix and key.
 */
.factory('$translateStaticFilesLoader', $translateStaticFilesLoader);

function $translateStaticFilesLoader($q, $http) {

  'use strict';

  return function (options) {

    if (!options || (!angular.isArray(options.files) && (!angular.isString(options.prefix) || !angular.isString(options.suffix)))) {
      throw new Error('Couldn\'t load static files, no files and prefix or suffix specified!');
    }

    if (!options.files) {
      options.files = [{
        prefix: options.prefix,
        suffix: options.suffix
      }];
    }

    var load = function (file) {
      if (!file || (!angular.isString(file.prefix) || !angular.isString(file.suffix))) {
        throw new Error('Couldn\'t load static file, no prefix or suffix specified!');
      }

      return $http(angular.extend({
        url: [
          file.prefix,
          options.key,
          file.suffix
        ].join(''),
        method: 'GET',
        params: ''
      }, options.$http))
        .then(function(result) {
          return result.data;
        }, function () {
          return $q.reject(options.key);
        });
    };

    var deferred = $q.defer(),
        promises = [],
        length = options.files.length;

    for (var i = 0; i < length; i++) {
      promises.push(load({
        prefix: options.files[i].prefix,
        key: options.key,
        suffix: options.files[i].suffix
      }));
    }

    $q.all(promises)
      .then(function (data) {
        var length = data.length,
            mergedData = {};

        for (var i = 0; i < length; i++) {
          for (var key in data[i]) {
            mergedData[key] = data[i][key];
          }
        }

        deferred.resolve(mergedData);
      }, function (data) {
        deferred.reject(data);
      });

    return deferred.promise;
  };
}
$translateStaticFilesLoader.$inject = ['$q', '$http'];

$translateStaticFilesLoader.displayName = '$translateStaticFilesLoader';
return 'pascalprecht.translate';

}));


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * angular-translate - v2.15.2 - 2017-06-22
 * 
 * Copyright (c) 2017 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (true) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
      return (factory());
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {

$translateUrlLoader.$inject = ['$q', '$http'];
angular.module('pascalprecht.translate')
/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateUrlLoader
 * @requires $q
 * @requires $http
 *
 * @description
 * Creates a loading function for a typical dynamic url pattern:
 * "locale.php?lang=en_US", "locale.php?lang=de_DE", "locale.php?language=nl_NL" etc.
 * Prefixing the specified url, the current requested, language id will be applied
 * with "?{queryParameter}={key}".
 * Using this service, the response of these urls must be an object of
 * key-value pairs.
 *
 * @param {object} options Options object, which gets the url, key and
 * optional queryParameter ('lang' is used by default).
 */
.factory('$translateUrlLoader', $translateUrlLoader);

function $translateUrlLoader($q, $http) {

  'use strict';

  return function (options) {

    if (!options || !options.url) {
      throw new Error('Couldn\'t use urlLoader since no url is given!');
    }

    var requestParams = {};

    requestParams[options.queryParameter || 'lang'] = options.key;

    return $http(angular.extend({
      url: options.url,
      params: requestParams,
      method: 'GET'
    }, options.$http))
      .then(function(result) {
        return result.data;
      }, function () {
        return $q.reject(options.key);
      });
  };
}

$translateUrlLoader.displayName = '$translateUrlLoader';
return 'pascalprecht.translate';

}));


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * angular-translate - v2.8.1 - 2015-10-01
 * 
 * Copyright (c) 2015 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (true) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
      return (factory());
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {

angular.module('pascalprecht.translate')

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateLocalStorage
 * @requires $window
 * @requires $translateCookieStorage
 *
 * @description
 * Abstraction layer for localStorage. This service is used when telling angular-translate
 * to use localStorage as storage.
 *
 */
.factory('$translateLocalStorage', $translateLocalStorageFactory);

function $translateLocalStorageFactory($window, $translateCookieStorage) {

  'use strict';

  // Setup adapter
  var localStorageAdapter = (function(){
    var langKey;
    return {
      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translateLocalStorage#get
       * @methodOf pascalprecht.translate.$translateLocalStorage
       *
       * @description
       * Returns an item from localStorage by given name.
       *
       * @param {string} name Item name
       * @return {string} Value of item name
       */
      get: function (name) {
        if(!langKey) {
          langKey = $window.localStorage.getItem(name);
        }

        return langKey;
      },
      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translateLocalStorage#set
       * @methodOf pascalprecht.translate.$translateLocalStorage
       *
       * @description
       * Sets an item in localStorage by given name.
       *
       * @deprecated use #put
       *
       * @param {string} name Item name
       * @param {string} value Item value
       */
      set: function (name, value) {
        langKey=value;
        $window.localStorage.setItem(name, value);
      },
      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translateLocalStorage#put
       * @methodOf pascalprecht.translate.$translateLocalStorage
       *
       * @description
       * Sets an item in localStorage by given name.
       *
       * @param {string} name Item name
       * @param {string} value Item value
       */
      put: function (name, value) {
        langKey=value;
        $window.localStorage.setItem(name, value);
      }
    };
  }());

  var hasLocalStorageSupport = 'localStorage' in $window;
  if (hasLocalStorageSupport) {
    var testKey = 'pascalprecht.translate.storageTest';
    try {
      // this check have to be wrapped within a try/catch because on
      // a SecurityError: Dom Exception 18 on iOS
      if ($window.localStorage !== null) {
        $window.localStorage.setItem(testKey, 'foo');
        $window.localStorage.removeItem(testKey);
        hasLocalStorageSupport = true;
      } else {
        hasLocalStorageSupport = false;
      }
    } catch (e){
      hasLocalStorageSupport = false;
    }
  }
  var $translateLocalStorage = hasLocalStorageSupport ? localStorageAdapter : $translateCookieStorage;
  return $translateLocalStorage;
}
$translateLocalStorageFactory.$inject = ['$window', '$translateCookieStorage'];

$translateLocalStorageFactory.displayName = '$translateLocalStorageFactory';
return 'pascalprecht.translate';

}));


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * angular-translate - v2.8.1 - 2015-10-01
 * 
 * Copyright (c) 2015 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (true) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
      return (factory());
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {

/**
 * @ngdoc overview
 * @name pascalprecht.translate
 *
 * @description
 * The main module which holds everything together.
 */
angular.module('pascalprecht.translate', ['ng'])
  .run(runTranslate);

function runTranslate($translate) {

  'use strict';

  var key = $translate.storageKey(),
    storage = $translate.storage();

  var fallbackFromIncorrectStorageValue = function () {
    var preferred = $translate.preferredLanguage();
    if (angular.isString(preferred)) {
      $translate.use(preferred);
      // $translate.use() will also remember the language.
      // So, we don't need to call storage.put() here.
    } else {
      storage.put(key, $translate.use());
    }
  };

  fallbackFromIncorrectStorageValue.displayName = 'fallbackFromIncorrectStorageValue';

  if (storage) {
    if (!storage.get(key)) {
      fallbackFromIncorrectStorageValue();
    } else {
      $translate.use(storage.get(key))['catch'](fallbackFromIncorrectStorageValue);
    }
  } else if (angular.isString($translate.preferredLanguage())) {
    $translate.use($translate.preferredLanguage());
  }
}
runTranslate.$inject = ['$translate'];

runTranslate.displayName = 'runTranslate';

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateSanitizationProvider
 *
 * @description
 *
 * Configurations for $translateSanitization
 */
angular.module('pascalprecht.translate').provider('$translateSanitization', $translateSanitizationProvider);

function $translateSanitizationProvider () {

  'use strict';

  var $sanitize,
      currentStrategy = null, // TODO change to either 'sanitize', 'escape' or ['sanitize', 'escapeParameters'] in 3.0.
      hasConfiguredStrategy = false,
      hasShownNoStrategyConfiguredWarning = false,
      strategies;

  /**
   * Definition of a sanitization strategy function
   * @callback StrategyFunction
   * @param {string|object} value - value to be sanitized (either a string or an interpolated value map)
   * @param {string} mode - either 'text' for a string (translation) or 'params' for the interpolated params
   * @return {string|object}
   */

  /**
   * @ngdoc property
   * @name strategies
   * @propertyOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Following strategies are built-in:
   * <dl>
   *   <dt>sanitize</dt>
   *   <dd>Sanitizes HTML in the translation text using $sanitize</dd>
   *   <dt>escape</dt>
   *   <dd>Escapes HTML in the translation</dd>
   *   <dt>sanitizeParameters</dt>
   *   <dd>Sanitizes HTML in the values of the interpolation parameters using $sanitize</dd>
   *   <dt>escapeParameters</dt>
   *   <dd>Escapes HTML in the values of the interpolation parameters</dd>
   *   <dt>escaped</dt>
   *   <dd>Support legacy strategy name 'escaped' for backwards compatibility (will be removed in 3.0)</dd>
   * </dl>
   *
   */

  strategies = {
    sanitize: function (value, mode) {
      if (mode === 'text') {
        value = htmlSanitizeValue(value);
      }
      return value;
    },
    escape: function (value, mode) {
      if (mode === 'text') {
        value = htmlEscapeValue(value);
      }
      return value;
    },
    sanitizeParameters: function (value, mode) {
      if (mode === 'params') {
        value = mapInterpolationParameters(value, htmlSanitizeValue);
      }
      return value;
    },
    escapeParameters: function (value, mode) {
      if (mode === 'params') {
        value = mapInterpolationParameters(value, htmlEscapeValue);
      }
      return value;
    }
  };
  // Support legacy strategy name 'escaped' for backwards compatibility.
  // TODO should be removed in 3.0
  strategies.escaped = strategies.escapeParameters;

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateSanitizationProvider#addStrategy
   * @methodOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Adds a sanitization strategy to the list of known strategies.
   *
   * @param {string} strategyName - unique key for a strategy
   * @param {StrategyFunction} strategyFunction - strategy function
   * @returns {object} this
   */
  this.addStrategy = function (strategyName, strategyFunction) {
    strategies[strategyName] = strategyFunction;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateSanitizationProvider#removeStrategy
   * @methodOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Removes a sanitization strategy from the list of known strategies.
   *
   * @param {string} strategyName - unique key for a strategy
   * @returns {object} this
   */
  this.removeStrategy = function (strategyName) {
    delete strategies[strategyName];
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateSanitizationProvider#useStrategy
   * @methodOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
   *
   * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
   * @returns {object} this
   */
  this.useStrategy = function (strategy) {
    hasConfiguredStrategy = true;
    currentStrategy = strategy;
    return this;
  };

  /**
   * @ngdoc object
   * @name pascalprecht.translate.$translateSanitization
   * @requires $injector
   * @requires $log
   *
   * @description
   * Sanitizes interpolation parameters and translated texts.
   *
   */
  this.$get = ['$injector', '$log', function ($injector, $log) {

    var cachedStrategyMap = {};

    var applyStrategies = function (value, mode, selectedStrategies) {
      angular.forEach(selectedStrategies, function (selectedStrategy) {
        if (angular.isFunction(selectedStrategy)) {
          value = selectedStrategy(value, mode);
        } else if (angular.isFunction(strategies[selectedStrategy])) {
          value = strategies[selectedStrategy](value, mode);
        } else if (angular.isString(strategies[selectedStrategy])) {
          if (!cachedStrategyMap[strategies[selectedStrategy]]) {
            try {
              cachedStrategyMap[strategies[selectedStrategy]] = $injector.get(strategies[selectedStrategy]);
            } catch (e) {
              cachedStrategyMap[strategies[selectedStrategy]] = function() {};
              throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
            }
          }
          value = cachedStrategyMap[strategies[selectedStrategy]](value, mode);
        } else {
          throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
        }
      });
      return value;
    };

    // TODO: should be removed in 3.0
    var showNoStrategyConfiguredWarning = function () {
      if (!hasConfiguredStrategy && !hasShownNoStrategyConfiguredWarning) {
        $log.warn('pascalprecht.translate.$translateSanitization: No sanitization strategy has been configured. This can have serious security implications. See http://angular-translate.github.io/docs/#/guide/19_security for details.');
        hasShownNoStrategyConfiguredWarning = true;
      }
    };

    if ($injector.has('$sanitize')) {
      $sanitize = $injector.get('$sanitize');
    }

    return {
      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translateSanitization#useStrategy
       * @methodOf pascalprecht.translate.$translateSanitization
       *
       * @description
       * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
       *
       * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
       */
      useStrategy: (function (self) {
        return function (strategy) {
          self.useStrategy(strategy);
        };
      })(this),

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translateSanitization#sanitize
       * @methodOf pascalprecht.translate.$translateSanitization
       *
       * @description
       * Sanitizes a value.
       *
       * @param {string|object} value The value which should be sanitized.
       * @param {string} mode The current sanitization mode, either 'params' or 'text'.
       * @param {string|StrategyFunction|array} [strategy] Optional custom strategy which should be used instead of the currently selected strategy.
       * @returns {string|object} sanitized value
       */
      sanitize: function (value, mode, strategy) {
        if (!currentStrategy) {
          showNoStrategyConfiguredWarning();
        }

        if (arguments.length < 3) {
          strategy = currentStrategy;
        }

        if (!strategy) {
          return value;
        }

        var selectedStrategies = angular.isArray(strategy) ? strategy : [strategy];
        return applyStrategies(value, mode, selectedStrategies);
      }
    };
  }];

  var htmlEscapeValue = function (value) {
    var element = angular.element('<div></div>');
    element.text(value); // not chainable, see #1044
    return element.html();
  };

  var htmlSanitizeValue = function (value) {
    if (!$sanitize) {
      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sanitize service. Either include the ngSanitize module (https://docs.angularjs.org/api/ngSanitize) or use a sanitization strategy which does not depend on $sanitize, such as \'escape\'.');
    }
    return $sanitize(value);
  };

  var mapInterpolationParameters = function (value, iteratee) {
    if (angular.isObject(value)) {
      var result = angular.isArray(value) ? [] : {};

      angular.forEach(value, function (propertyValue, propertyKey) {
        result[propertyKey] = mapInterpolationParameters(propertyValue, iteratee);
      });

      return result;
    } else if (angular.isNumber(value)) {
      return value;
    } else {
      return iteratee(value);
    }
  };
}

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateProvider
 * @description
 *
 * $translateProvider allows developers to register translation-tables, asynchronous loaders
 * and similar to configure translation behavior directly inside of a module.
 *
 */
angular.module('pascalprecht.translate')
.constant('pascalprechtTranslateOverrider', {})
.provider('$translate', $translate);

function $translate($STORAGE_KEY, $windowProvider, $translateSanitizationProvider, pascalprechtTranslateOverrider) {

  'use strict';

  var $translationTable = {},
      $preferredLanguage,
      $availableLanguageKeys = [],
      $languageKeyAliases,
      $fallbackLanguage,
      $fallbackWasString,
      $uses,
      $nextLang,
      $storageFactory,
      $storageKey = $STORAGE_KEY,
      $storagePrefix,
      $missingTranslationHandlerFactory,
      $interpolationFactory,
      $interpolatorFactories = [],
      $loaderFactory,
      $cloakClassName = 'translate-cloak',
      $loaderOptions,
      $notFoundIndicatorLeft,
      $notFoundIndicatorRight,
      $postCompilingEnabled = false,
      $forceAsyncReloadEnabled = false,
      $nestedObjectDelimeter = '.',
      $isReady = false,
      loaderCache,
      directivePriority = 0,
      statefulFilter = true,
      uniformLanguageTagResolver = 'default',
      languageTagResolver = {
        'default': function (tag) {
          return (tag || '').split('-').join('_');
        },
        java: function (tag) {
          var temp = (tag || '').split('-').join('_');
          var parts = temp.split('_');
          return parts.length > 1 ? (parts[0].toLowerCase() + '_' + parts[1].toUpperCase()) : temp;
        },
        bcp47: function (tag) {
          var temp = (tag || '').split('_').join('-');
          var parts = temp.split('-');
          return parts.length > 1 ? (parts[0].toLowerCase() + '-' + parts[1].toUpperCase()) : temp;
        }
      };

  var version = '2.8.1';

  // tries to determine the browsers language
  var getFirstBrowserLanguage = function () {

    // internal purpose only
    if (angular.isFunction(pascalprechtTranslateOverrider.getLocale)) {
      return pascalprechtTranslateOverrider.getLocale();
    }

    var nav = $windowProvider.$get().navigator,
        browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
        i,
        language;

    // support for HTML 5.1 "navigator.languages"
    if (angular.isArray(nav.languages)) {
      for (i = 0; i < nav.languages.length; i++) {
        language = nav.languages[i];
        if (language && language.length) {
          return language;
        }
      }
    }

    // support for other well known properties in browsers
    for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
      language = nav[browserLanguagePropertyKeys[i]];
      if (language && language.length) {
        return language;
      }
    }

    return null;
  };
  getFirstBrowserLanguage.displayName = 'angular-translate/service: getFirstBrowserLanguage';

  // tries to determine the browsers locale
  var getLocale = function () {
    var locale = getFirstBrowserLanguage() || '';
    if (languageTagResolver[uniformLanguageTagResolver]) {
      locale = languageTagResolver[uniformLanguageTagResolver](locale);
    }
    return locale;
  };
  getLocale.displayName = 'angular-translate/service: getLocale';

  /**
   * @name indexOf
   * @private
   *
   * @description
   * indexOf polyfill. Kinda sorta.
   *
   * @param {array} array Array to search in.
   * @param {string} searchElement Element to search for.
   *
   * @returns {int} Index of search element.
   */
  var indexOf = function(array, searchElement) {
    for (var i = 0, len = array.length; i < len; i++) {
      if (array[i] === searchElement) {
        return i;
      }
    }
    return -1;
  };

  /**
   * @name trim
   * @private
   *
   * @description
   * trim polyfill
   *
   * @returns {string} The string stripped of whitespace from both ends
   */
  var trim = function() {
    return this.toString().replace(/^\s+|\s+$/g, '');
  };

  var negotiateLocale = function (preferred) {

    var avail = [],
        locale = angular.lowercase(preferred),
        i = 0,
        n = $availableLanguageKeys.length;

    for (; i < n; i++) {
      avail.push(angular.lowercase($availableLanguageKeys[i]));
    }

    if (indexOf(avail, locale) > -1) {
      return preferred;
    }

    if ($languageKeyAliases) {
      var alias;
      for (var langKeyAlias in $languageKeyAliases) {
        var hasWildcardKey = false;
        var hasExactKey = Object.prototype.hasOwnProperty.call($languageKeyAliases, langKeyAlias) &&
          angular.lowercase(langKeyAlias) === angular.lowercase(preferred);

        if (langKeyAlias.slice(-1) === '*') {
          hasWildcardKey = langKeyAlias.slice(0, -1) === preferred.slice(0, langKeyAlias.length-1);
        }
        if (hasExactKey || hasWildcardKey) {
          alias = $languageKeyAliases[langKeyAlias];
          if (indexOf(avail, angular.lowercase(alias)) > -1) {
            return alias;
          }
        }
      }
    }

    if (preferred) {
      var parts = preferred.split('_');

      if (parts.length > 1 && indexOf(avail, angular.lowercase(parts[0])) > -1) {
        return parts[0];
      }
    }

    // If everything fails, just return the preferred, unchanged.
    return preferred;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#translations
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Registers a new translation table for specific language key.
   *
   * To register a translation table for specific language, pass a defined language
   * key as first parameter.
   *
   * <pre>
   *  // register translation table for language: 'de_DE'
   *  $translateProvider.translations('de_DE', {
   *    'GREETING': 'Hallo Welt!'
   *  });
   *
   *  // register another one
   *  $translateProvider.translations('en_US', {
   *    'GREETING': 'Hello world!'
   *  });
   * </pre>
   *
   * When registering multiple translation tables for for the same language key,
   * the actual translation table gets extended. This allows you to define module
   * specific translation which only get added, once a specific module is loaded in
   * your app.
   *
   * Invoking this method with no arguments returns the translation table which was
   * registered with no language key. Invoking it with a language key returns the
   * related translation table.
   *
   * @param {string} key A language key.
   * @param {object} translationTable A plain old JavaScript object that represents a translation table.
   *
   */
  var translations = function (langKey, translationTable) {

    if (!langKey && !translationTable) {
      return $translationTable;
    }

    if (langKey && !translationTable) {
      if (angular.isString(langKey)) {
        return $translationTable[langKey];
      }
    } else {
      if (!angular.isObject($translationTable[langKey])) {
        $translationTable[langKey] = {};
      }
      angular.extend($translationTable[langKey], flatObject(translationTable));
    }
    return this;
  };

  this.translations = translations;

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#cloakClassName
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   *
   * Let's you change the class name for `translate-cloak` directive.
   * Default class name is `translate-cloak`.
   *
   * @param {string} name translate-cloak class name
   */
  this.cloakClassName = function (name) {
    if (!name) {
      return $cloakClassName;
    }
    $cloakClassName = name;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#nestedObjectDelimeter
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   *
   * Let's you change the delimiter for namespaced translations.
   * Default delimiter is `.`.
   *
   * @param {string} delimiter namespace separator
   */
  this.nestedObjectDelimeter = function (delimiter) {
    if (!delimiter) {
      return $nestedObjectDelimeter;
    }
    $nestedObjectDelimeter = delimiter;
    return this;
  };

  /**
   * @name flatObject
   * @private
   *
   * @description
   * Flats an object. This function is used to flatten given translation data with
   * namespaces, so they are later accessible via dot notation.
   */
  var flatObject = function (data, path, result, prevKey) {
    var key, keyWithPath, keyWithShortPath, val;

    if (!path) {
      path = [];
    }
    if (!result) {
      result = {};
    }
    for (key in data) {
      if (!Object.prototype.hasOwnProperty.call(data, key)) {
        continue;
      }
      val = data[key];
      if (angular.isObject(val)) {
        flatObject(val, path.concat(key), result, key);
      } else {
        keyWithPath = path.length ? ('' + path.join($nestedObjectDelimeter) + $nestedObjectDelimeter + key) : key;
        if(path.length && key === prevKey){
          // Create shortcut path (foo.bar == foo.bar.bar)
          keyWithShortPath = '' + path.join($nestedObjectDelimeter);
          // Link it to original path
          result[keyWithShortPath] = '@:' + keyWithPath;
        }
        result[keyWithPath] = val;
      }
    }
    return result;
  };
  flatObject.displayName = 'flatObject';

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#addInterpolation
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Adds interpolation services to angular-translate, so it can manage them.
   *
   * @param {object} factory Interpolation service factory
   */
  this.addInterpolation = function (factory) {
    $interpolatorFactories.push(factory);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useMessageFormatInterpolation
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use interpolation functionality of messageformat.js.
   * This is useful when having high level pluralization and gender selection.
   */
  this.useMessageFormatInterpolation = function () {
    return this.useInterpolation('$translateMessageFormatInterpolation');
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useInterpolation
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate which interpolation style to use as default, application-wide.
   * Simply pass a factory/service name. The interpolation service has to implement
   * the correct interface.
   *
   * @param {string} factory Interpolation service name.
   */
  this.useInterpolation = function (factory) {
    $interpolationFactory = factory;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useSanitizeStrategy
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Simply sets a sanitation strategy type.
   *
   * @param {string} value Strategy type.
   */
  this.useSanitizeValueStrategy = function (value) {
    $translateSanitizationProvider.useStrategy(value);
    return this;
  };

 /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#preferredLanguage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells the module which of the registered translation tables to use for translation
   * at initial startup by passing a language key. Similar to `$translateProvider#use`
   * only that it says which language to **prefer**.
   *
   * @param {string} langKey A language key.
   */
  this.preferredLanguage = function(langKey) {
    if (langKey) {
      setupPreferredLanguage(langKey);
      return this;
    }
    return $preferredLanguage;
  };
  var setupPreferredLanguage = function (langKey) {
    if (langKey) {
      $preferredLanguage = langKey;
    }
    return $preferredLanguage;
  };
  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicator
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets an indicator which is used when a translation isn't found. E.g. when
   * setting the indicator as 'X' and one tries to translate a translation id
   * called `NOT_FOUND`, this will result in `X NOT_FOUND X`.
   *
   * Internally this methods sets a left indicator and a right indicator using
   * `$translateProvider.translationNotFoundIndicatorLeft()` and
   * `$translateProvider.translationNotFoundIndicatorRight()`.
   *
   * **Note**: These methods automatically add a whitespace between the indicators
   * and the translation id.
   *
   * @param {string} indicator An indicator, could be any string.
   */
  this.translationNotFoundIndicator = function (indicator) {
    this.translationNotFoundIndicatorLeft(indicator);
    this.translationNotFoundIndicatorRight(indicator);
    return this;
  };

  /**
   * ngdoc function
   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets an indicator which is used when a translation isn't found left to the
   * translation id.
   *
   * @param {string} indicator An indicator.
   */
  this.translationNotFoundIndicatorLeft = function (indicator) {
    if (!indicator) {
      return $notFoundIndicatorLeft;
    }
    $notFoundIndicatorLeft = indicator;
    return this;
  };

  /**
   * ngdoc function
   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets an indicator which is used when a translation isn't found right to the
   * translation id.
   *
   * @param {string} indicator An indicator.
   */
  this.translationNotFoundIndicatorRight = function (indicator) {
    if (!indicator) {
      return $notFoundIndicatorRight;
    }
    $notFoundIndicatorRight = indicator;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#fallbackLanguage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells the module which of the registered translation tables to use when missing translations
   * at initial startup by passing a language key. Similar to `$translateProvider#use`
   * only that it says which language to **fallback**.
   *
   * @param {string||array} langKey A language key.
   *
   */
  this.fallbackLanguage = function (langKey) {
    fallbackStack(langKey);
    return this;
  };

  var fallbackStack = function (langKey) {
    if (langKey) {
      if (angular.isString(langKey)) {
        $fallbackWasString = true;
        $fallbackLanguage = [ langKey ];
      } else if (angular.isArray(langKey)) {
        $fallbackWasString = false;
        $fallbackLanguage = langKey;
      }
      if (angular.isString($preferredLanguage)  && indexOf($fallbackLanguage, $preferredLanguage) < 0) {
        $fallbackLanguage.push($preferredLanguage);
      }

      return this;
    } else {
      if ($fallbackWasString) {
        return $fallbackLanguage[0];
      } else {
        return $fallbackLanguage;
      }
    }
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#use
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Set which translation table to use for translation by given language key. When
   * trying to 'use' a language which isn't provided, it'll throw an error.
   *
   * You actually don't have to use this method since `$translateProvider#preferredLanguage`
   * does the job too.
   *
   * @param {string} langKey A language key.
   */
  this.use = function (langKey) {
    if (langKey) {
      if (!$translationTable[langKey] && (!$loaderFactory)) {
        // only throw an error, when not loading translation data asynchronously
        throw new Error('$translateProvider couldn\'t find translationTable for langKey: \'' + langKey + '\'');
      }
      $uses = langKey;
      return this;
    }
    return $uses;
  };

 /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#storageKey
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells the module which key must represent the choosed language by a user in the storage.
   *
   * @param {string} key A key for the storage.
   */
  var storageKey = function(key) {
    if (!key) {
      if ($storagePrefix) {
        return $storagePrefix + $storageKey;
      }
      return $storageKey;
    }
    $storageKey = key;
    return this;
  };

  this.storageKey = storageKey;

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useUrlLoader
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateUrlLoader` extension service as loader.
   *
   * @param {string} url Url
   * @param {Object=} options Optional configuration object
   */
  this.useUrlLoader = function (url, options) {
    return this.useLoader('$translateUrlLoader', angular.extend({ url: url }, options));
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useStaticFilesLoader
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateStaticFilesLoader` extension service as loader.
   *
   * @param {Object=} options Optional configuration object
   */
  this.useStaticFilesLoader = function (options) {
    return this.useLoader('$translateStaticFilesLoader', options);
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useLoader
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use any other service as loader.
   *
   * @param {string} loaderFactory Factory name to use
   * @param {Object=} options Optional configuration object
   */
  this.useLoader = function (loaderFactory, options) {
    $loaderFactory = loaderFactory;
    $loaderOptions = options || {};
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useLocalStorage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateLocalStorage` service as storage layer.
   *
   */
  this.useLocalStorage = function () {
    return this.useStorage('$translateLocalStorage');
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useCookieStorage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateCookieStorage` service as storage layer.
   */
  this.useCookieStorage = function () {
    return this.useStorage('$translateCookieStorage');
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useStorage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use custom service as storage layer.
   */
  this.useStorage = function (storageFactory) {
    $storageFactory = storageFactory;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#storagePrefix
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets prefix for storage key.
   *
   * @param {string} prefix Storage key prefix
   */
  this.storagePrefix = function (prefix) {
    if (!prefix) {
      return prefix;
    }
    $storagePrefix = prefix;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandlerLog
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use built-in log handler when trying to translate
   * a translation Id which doesn't exist.
   *
   * This is actually a shortcut method for `useMissingTranslationHandler()`.
   *
   */
  this.useMissingTranslationHandlerLog = function () {
    return this.useMissingTranslationHandler('$translateMissingTranslationHandlerLog');
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandler
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Expects a factory name which later gets instantiated with `$injector`.
   * This method can be used to tell angular-translate to use a custom
   * missingTranslationHandler. Just build a factory which returns a function
   * and expects a translation id as argument.
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.useMissingTranslationHandler('customHandler');
   *  });
   *
   *  app.factory('customHandler', function (dep1, dep2) {
   *    return function (translationId) {
   *      // something with translationId and dep1 and dep2
   *    };
   *  });
   * </pre>
   *
   * @param {string} factory Factory name
   */
  this.useMissingTranslationHandler = function (factory) {
    $missingTranslationHandlerFactory = factory;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#usePostCompiling
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * If post compiling is enabled, all translated values will be processed
   * again with AngularJS' $compile.
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.usePostCompiling(true);
   *  });
   * </pre>
   *
   * @param {string} factory Factory name
   */
  this.usePostCompiling = function (value) {
    $postCompilingEnabled = !(!value);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#forceAsyncReload
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * If force async reload is enabled, async loader will always be called
   * even if $translationTable already contains the language key, adding
   * possible new entries to the $translationTable.
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.forceAsyncReload(true);
   *  });
   * </pre>
   *
   * @param {boolean} value - valid values are true or false
   */
  this.forceAsyncReload = function (value) {
    $forceAsyncReloadEnabled = !(!value);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#uniformLanguageTag
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate which language tag should be used as a result when determining
   * the current browser language.
   *
   * This setting must be set before invoking {@link pascalprecht.translate.$translateProvider#methods_determinePreferredLanguage determinePreferredLanguage()}.
   *
   * <pre>
   * $translateProvider
   *   .uniformLanguageTag('bcp47')
   *   .determinePreferredLanguage()
   * </pre>
   *
   * The resolver currently supports:
   * * default
   *     (traditionally: hyphens will be converted into underscores, i.e. en-US => en_US)
   *     en-US => en_US
   *     en_US => en_US
   *     en-us => en_us
   * * java
   *     like default, but the second part will be always in uppercase
   *     en-US => en_US
   *     en_US => en_US
   *     en-us => en_US
   * * BCP 47 (RFC 4646 & 4647)
   *     en-US => en-US
   *     en_US => en-US
   *     en-us => en-US
   *
   * See also:
   * * http://en.wikipedia.org/wiki/IETF_language_tag
   * * http://www.w3.org/International/core/langtags/
   * * http://tools.ietf.org/html/bcp47
   *
   * @param {string|object} options - options (or standard)
   * @param {string} options.standard - valid values are 'default', 'bcp47', 'java'
   */
  this.uniformLanguageTag = function (options) {

    if (!options) {
      options = {};
    } else if (angular.isString(options)) {
      options = {
        standard: options
      };
    }

    uniformLanguageTagResolver = options.standard;

    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#determinePreferredLanguage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to try to determine on its own which language key
   * to set as preferred language. When `fn` is given, angular-translate uses it
   * to determine a language key, otherwise it uses the built-in `getLocale()`
   * method.
   *
   * The `getLocale()` returns a language key in the format `[lang]_[country]` or
   * `[lang]` depending on what the browser provides.
   *
   * Use this method at your own risk, since not all browsers return a valid
   * locale (see {@link pascalprecht.translate.$translateProvider#methods_uniformLanguageTag uniformLanguageTag()}).
   *
   * @param {Function=} fn Function to determine a browser's locale
   */
  this.determinePreferredLanguage = function (fn) {

    var locale = (fn && angular.isFunction(fn)) ? fn() : getLocale();

    if (!$availableLanguageKeys.length) {
      $preferredLanguage = locale;
    } else {
      $preferredLanguage = negotiateLocale(locale);
    }

    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#registerAvailableLanguageKeys
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Registers a set of language keys the app will work with. Use this method in
   * combination with
   * {@link pascalprecht.translate.$translateProvider#determinePreferredLanguage determinePreferredLanguage}.
   * When available languages keys are registered, angular-translate
   * tries to find the best fitting language key depending on the browsers locale,
   * considering your language key convention.
   *
   * @param {object} languageKeys Array of language keys the your app will use
   * @param {object=} aliases Alias map.
   */
  this.registerAvailableLanguageKeys = function (languageKeys, aliases) {
    if (languageKeys) {
      $availableLanguageKeys = languageKeys;
      if (aliases) {
        $languageKeyAliases = aliases;
      }
      return this;
    }
    return $availableLanguageKeys;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useLoaderCache
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Registers a cache for internal $http based loaders.
   * {@link pascalprecht.translate.$translationCache $translationCache}.
   * When false the cache will be disabled (default). When true or undefined
   * the cache will be a default (see $cacheFactory). When an object it will
   * be treat as a cache object itself: the usage is $http({cache: cache})
   *
   * @param {object} cache boolean, string or cache-object
   */
  this.useLoaderCache = function (cache) {
    if (cache === false) {
      // disable cache
      loaderCache = undefined;
    } else if (cache === true) {
      // enable cache using AJS defaults
      loaderCache = true;
    } else if (typeof(cache) === 'undefined') {
      // enable cache using default
      loaderCache = '$translationCache';
    } else if (cache) {
      // enable cache using given one (see $cacheFactory)
      loaderCache = cache;
    }
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#directivePriority
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets the default priority of the translate directive. The standard value is `0`.
   * Calling this function without an argument will return the current value.
   *
   * @param {number} priority for the translate-directive
   */
  this.directivePriority = function (priority) {
    if (priority === undefined) {
      // getter
      return directivePriority;
    } else {
      // setter with chaining
      directivePriority = priority;
      return this;
    }
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#statefulFilter
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Since AngularJS 1.3, filters which are not stateless (depending at the scope)
   * have to explicit define this behavior.
   * Sets whether the translate filter should be stateful or stateless. The standard value is `true`
   * meaning being stateful.
   * Calling this function without an argument will return the current value.
   *
   * @param {boolean} state - defines the state of the filter
   */
  this.statefulFilter = function (state) {
    if (state === undefined) {
      // getter
      return statefulFilter;
    } else {
      // setter with chaining
      statefulFilter = state;
      return this;
    }
  };

  /**
   * @ngdoc object
   * @name pascalprecht.translate.$translate
   * @requires $interpolate
   * @requires $log
   * @requires $rootScope
   * @requires $q
   *
   * @description
   * The `$translate` service is the actual core of angular-translate. It expects a translation id
   * and optional interpolate parameters to translate contents.
   *
   * <pre>
   *  $translate('HEADLINE_TEXT').then(function (translation) {
   *    $scope.translatedText = translation;
   *  });
   * </pre>
   *
   * @param {string|array} translationId A token which represents a translation id
   *                                     This can be optionally an array of translation ids which
   *                                     results that the function returns an object where each key
   *                                     is the translation id and the value the translation.
   * @param {object=} interpolateParams An object hash for dynamic values
   * @param {string} interpolationId The id of the interpolation to use
   * @returns {object} promise
   */
  this.$get = [
    '$log',
    '$injector',
    '$rootScope',
    '$q',
    function ($log, $injector, $rootScope, $q) {

      var Storage,
          defaultInterpolator = $injector.get($interpolationFactory || '$translateDefaultInterpolation'),
          pendingLoader = false,
          interpolatorHashMap = {},
          langPromises = {},
          fallbackIndex,
          startFallbackIteration;

      var $translate = function (translationId, interpolateParams, interpolationId, defaultTranslationText) {

        // Duck detection: If the first argument is an array, a bunch of translations was requested.
        // The result is an object.
        if (angular.isArray(translationId)) {
          // Inspired by Q.allSettled by Kris Kowal
          // https://github.com/kriskowal/q/blob/b0fa72980717dc202ffc3cbf03b936e10ebbb9d7/q.js#L1553-1563
          // This transforms all promises regardless resolved or rejected
          var translateAll = function (translationIds) {
            var results = {}; // storing the actual results
            var promises = []; // promises to wait for
            // Wraps the promise a) being always resolved and b) storing the link id->value
            var translate = function (translationId) {
              var deferred = $q.defer();
              var regardless = function (value) {
                results[translationId] = value;
                deferred.resolve([translationId, value]);
              };
              // we don't care whether the promise was resolved or rejected; just store the values
              $translate(translationId, interpolateParams, interpolationId, defaultTranslationText).then(regardless, regardless);
              return deferred.promise;
            };
            for (var i = 0, c = translationIds.length; i < c; i++) {
              promises.push(translate(translationIds[i]));
            }
            // wait for all (including storing to results)
            return $q.all(promises).then(function () {
              // return the results
              return results;
            });
          };
          return translateAll(translationId);
        }

        var deferred = $q.defer();

        // trim off any whitespace
        if (translationId) {
          translationId = trim.apply(translationId);
        }

        var promiseToWaitFor = (function () {
          var promise = $preferredLanguage ?
            langPromises[$preferredLanguage] :
            langPromises[$uses];

          fallbackIndex = 0;

          if ($storageFactory && !promise) {
            // looks like there's no pending promise for $preferredLanguage or
            // $uses. Maybe there's one pending for a language that comes from
            // storage.
            var langKey = Storage.get($storageKey);
            promise = langPromises[langKey];

            if ($fallbackLanguage && $fallbackLanguage.length) {
                var index = indexOf($fallbackLanguage, langKey);
                // maybe the language from storage is also defined as fallback language
                // we increase the fallback language index to not search in that language
                // as fallback, since it's probably the first used language
                // in that case the index starts after the first element
                fallbackIndex = (index === 0) ? 1 : 0;

                // but we can make sure to ALWAYS fallback to preferred language at least
                if (indexOf($fallbackLanguage, $preferredLanguage) < 0) {
                  $fallbackLanguage.push($preferredLanguage);
                }
            }
          }
          return promise;
        }());

        if (!promiseToWaitFor) {
          // no promise to wait for? okay. Then there's no loader registered
          // nor is a one pending for language that comes from storage.
          // We can just translate.
          determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText).then(deferred.resolve, deferred.reject);
        } else {
          var promiseResolved = function () {
            determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText).then(deferred.resolve, deferred.reject);
          };
          promiseResolved.displayName = 'promiseResolved';

          promiseToWaitFor['finally'](promiseResolved, deferred.reject);
        }
        return deferred.promise;
      };

      /**
       * @name applyNotFoundIndicators
       * @private
       *
       * @description
       * Applies not fount indicators to given translation id, if needed.
       * This function gets only executed, if a translation id doesn't exist,
       * which is why a translation id is expected as argument.
       *
       * @param {string} translationId Translation id.
       * @returns {string} Same as given translation id but applied with not found
       * indicators.
       */
      var applyNotFoundIndicators = function (translationId) {
        // applying notFoundIndicators
        if ($notFoundIndicatorLeft) {
          translationId = [$notFoundIndicatorLeft, translationId].join(' ');
        }
        if ($notFoundIndicatorRight) {
          translationId = [translationId, $notFoundIndicatorRight].join(' ');
        }
        return translationId;
      };

      /**
       * @name useLanguage
       * @private
       *
       * @description
       * Makes actual use of a language by setting a given language key as used
       * language and informs registered interpolators to also use the given
       * key as locale.
       *
       * @param {key} Locale key.
       */
      var useLanguage = function (key) {
        $uses = key;

        // make sure to store new language key before triggering success event
        if ($storageFactory) {
          Storage.put($translate.storageKey(), $uses);
        }

        $rootScope.$emit('$translateChangeSuccess', {language: key});

        // inform default interpolator
        defaultInterpolator.setLocale($uses);

        var eachInterpolator = function (interpolator, id) {
          interpolatorHashMap[id].setLocale($uses);
        };
        eachInterpolator.displayName = 'eachInterpolatorLocaleSetter';

        // inform all others too!
        angular.forEach(interpolatorHashMap, eachInterpolator);
        $rootScope.$emit('$translateChangeEnd', {language: key});
      };

      /**
       * @name loadAsync
       * @private
       *
       * @description
       * Kicks of registered async loader using `$injector` and applies existing
       * loader options. When resolved, it updates translation tables accordingly
       * or rejects with given language key.
       *
       * @param {string} key Language key.
       * @return {Promise} A promise.
       */
      var loadAsync = function (key) {
        if (!key) {
          throw 'No language key specified for loading.';
        }

        var deferred = $q.defer();

        $rootScope.$emit('$translateLoadingStart', {language: key});
        pendingLoader = true;

        var cache = loaderCache;
        if (typeof(cache) === 'string') {
          // getting on-demand instance of loader
          cache = $injector.get(cache);
        }

        var loaderOptions = angular.extend({}, $loaderOptions, {
          key: key,
          $http: angular.extend({}, {
            cache: cache
          }, $loaderOptions.$http)
        });

        var onLoaderSuccess = function (data) {
          var translationTable = {};
          $rootScope.$emit('$translateLoadingSuccess', {language: key});

          if (angular.isArray(data)) {
            angular.forEach(data, function (table) {
              angular.extend(translationTable, flatObject(table));
            });
          } else {
            angular.extend(translationTable, flatObject(data));
          }
          pendingLoader = false;
          deferred.resolve({
            key: key,
            table: translationTable
          });
          $rootScope.$emit('$translateLoadingEnd', {language: key});
        };
        onLoaderSuccess.displayName = 'onLoaderSuccess';

        var onLoaderError = function (key) {
          $rootScope.$emit('$translateLoadingError', {language: key});
          deferred.reject(key);
          $rootScope.$emit('$translateLoadingEnd', {language: key});
        };
        onLoaderError.displayName = 'onLoaderError';

        $injector.get($loaderFactory)(loaderOptions)
          .then(onLoaderSuccess, onLoaderError);

        return deferred.promise;
      };

      if ($storageFactory) {
        Storage = $injector.get($storageFactory);

        if (!Storage.get || !Storage.put) {
          throw new Error('Couldn\'t use storage \'' + $storageFactory + '\', missing get() or put() method!');
        }
      }

      // if we have additional interpolations that were added via
      // $translateProvider.addInterpolation(), we have to map'em
      if ($interpolatorFactories.length) {
        var eachInterpolationFactory = function (interpolatorFactory) {
          var interpolator = $injector.get(interpolatorFactory);
          // setting initial locale for each interpolation service
          interpolator.setLocale($preferredLanguage || $uses);
          // make'em recognizable through id
          interpolatorHashMap[interpolator.getInterpolationIdentifier()] = interpolator;
        };
        eachInterpolationFactory.displayName = 'interpolationFactoryAdder';

        angular.forEach($interpolatorFactories, eachInterpolationFactory);
      }

      /**
       * @name getTranslationTable
       * @private
       *
       * @description
       * Returns a promise that resolves to the translation table
       * or is rejected if an error occurred.
       *
       * @param langKey
       * @returns {Q.promise}
       */
      var getTranslationTable = function (langKey) {
        var deferred = $q.defer();
        if (Object.prototype.hasOwnProperty.call($translationTable, langKey)) {
          deferred.resolve($translationTable[langKey]);
        } else if (langPromises[langKey]) {
          var onResolve = function (data) {
            translations(data.key, data.table);
            deferred.resolve(data.table);
          };
          onResolve.displayName = 'translationTableResolver';
          langPromises[langKey].then(onResolve, deferred.reject);
        } else {
          deferred.reject();
        }
        return deferred.promise;
      };

      /**
       * @name getFallbackTranslation
       * @private
       *
       * @description
       * Returns a promise that will resolve to the translation
       * or be rejected if no translation was found for the language.
       * This function is currently only used for fallback language translation.
       *
       * @param langKey The language to translate to.
       * @param translationId
       * @param interpolateParams
       * @param Interpolator
       * @returns {Q.promise}
       */
      var getFallbackTranslation = function (langKey, translationId, interpolateParams, Interpolator) {
        var deferred = $q.defer();

        var onResolve = function (translationTable) {
          if (Object.prototype.hasOwnProperty.call(translationTable, translationId)) {
            Interpolator.setLocale(langKey);
            var translation = translationTable[translationId];
            if (translation.substr(0, 2) === '@:') {
              getFallbackTranslation(langKey, translation.substr(2), interpolateParams, Interpolator)
                .then(deferred.resolve, deferred.reject);
            } else {
              deferred.resolve(Interpolator.interpolate(translationTable[translationId], interpolateParams));
            }
            Interpolator.setLocale($uses);
          } else {
            deferred.reject();
          }
        };
        onResolve.displayName = 'fallbackTranslationResolver';

        getTranslationTable(langKey).then(onResolve, deferred.reject);

        return deferred.promise;
      };

      /**
       * @name getFallbackTranslationInstant
       * @private
       *
       * @description
       * Returns a translation
       * This function is currently only used for fallback language translation.
       *
       * @param langKey The language to translate to.
       * @param translationId
       * @param interpolateParams
       * @param Interpolator
       * @returns {string} translation
       */
      var getFallbackTranslationInstant = function (langKey, translationId, interpolateParams, Interpolator) {
        var result, translationTable = $translationTable[langKey];

        if (translationTable && Object.prototype.hasOwnProperty.call(translationTable, translationId)) {
          Interpolator.setLocale(langKey);
          result = Interpolator.interpolate(translationTable[translationId], interpolateParams);
          if (result.substr(0, 2) === '@:') {
            return getFallbackTranslationInstant(langKey, result.substr(2), interpolateParams, Interpolator);
          }
          Interpolator.setLocale($uses);
        }

        return result;
      };


      /**
       * @name translateByHandler
       * @private
       *
       * Translate by missing translation handler.
       *
       * @param translationId
       * @returns translation created by $missingTranslationHandler or translationId is $missingTranslationHandler is
       * absent
       */
      var translateByHandler = function (translationId, interpolateParams) {
        // If we have a handler factory - we might also call it here to determine if it provides
        // a default text for a translationid that can't be found anywhere in our tables
        if ($missingTranslationHandlerFactory) {
          var resultString = $injector.get($missingTranslationHandlerFactory)(translationId, $uses, interpolateParams);
          if (resultString !== undefined) {
            return resultString;
          } else {
            return translationId;
          }
        } else {
          return translationId;
        }
      };

      /**
       * @name resolveForFallbackLanguage
       * @private
       *
       * Recursive helper function for fallbackTranslation that will sequentially look
       * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
       *
       * @param fallbackLanguageIndex
       * @param translationId
       * @param interpolateParams
       * @param Interpolator
       * @returns {Q.promise} Promise that will resolve to the translation.
       */
      var resolveForFallbackLanguage = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, defaultTranslationText) {
        var deferred = $q.defer();

        if (fallbackLanguageIndex < $fallbackLanguage.length) {
          var langKey = $fallbackLanguage[fallbackLanguageIndex];
          getFallbackTranslation(langKey, translationId, interpolateParams, Interpolator).then(
            deferred.resolve,
            function () {
              // Look in the next fallback language for a translation.
              // It delays the resolving by passing another promise to resolve.
              resolveForFallbackLanguage(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator, defaultTranslationText).then(deferred.resolve);
            }
          );
        } else {
          // No translation found in any fallback language
          // if a default translation text is set in the directive, then return this as a result
          if (defaultTranslationText) {
            deferred.resolve(defaultTranslationText);
          } else {
            // if no default translation is set and an error handler is defined, send it to the handler
            // and then return the result
            deferred.resolve(translateByHandler(translationId, interpolateParams));
          }
        }
        return deferred.promise;
      };

      /**
       * @name resolveForFallbackLanguageInstant
       * @private
       *
       * Recursive helper function for fallbackTranslation that will sequentially look
       * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
       *
       * @param fallbackLanguageIndex
       * @param translationId
       * @param interpolateParams
       * @param Interpolator
       * @returns {string} translation
       */
      var resolveForFallbackLanguageInstant = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator) {
        var result;

        if (fallbackLanguageIndex < $fallbackLanguage.length) {
          var langKey = $fallbackLanguage[fallbackLanguageIndex];
          result = getFallbackTranslationInstant(langKey, translationId, interpolateParams, Interpolator);
          if (!result) {
            result = resolveForFallbackLanguageInstant(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator);
          }
        }
        return result;
      };

      /**
       * Translates with the usage of the fallback languages.
       *
       * @param translationId
       * @param interpolateParams
       * @param Interpolator
       * @returns {Q.promise} Promise, that resolves to the translation.
       */
      var fallbackTranslation = function (translationId, interpolateParams, Interpolator, defaultTranslationText) {
        // Start with the fallbackLanguage with index 0
        return resolveForFallbackLanguage((startFallbackIteration>0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, defaultTranslationText);
      };

      /**
       * Translates with the usage of the fallback languages.
       *
       * @param translationId
       * @param interpolateParams
       * @param Interpolator
       * @returns {String} translation
       */
      var fallbackTranslationInstant = function (translationId, interpolateParams, Interpolator) {
        // Start with the fallbackLanguage with index 0
        return resolveForFallbackLanguageInstant((startFallbackIteration>0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator);
      };

      var determineTranslation = function (translationId, interpolateParams, interpolationId, defaultTranslationText) {

        var deferred = $q.defer();

        var table = $uses ? $translationTable[$uses] : $translationTable,
            Interpolator = (interpolationId) ? interpolatorHashMap[interpolationId] : defaultInterpolator;

        // if the translation id exists, we can just interpolate it
        if (table && Object.prototype.hasOwnProperty.call(table, translationId)) {
          var translation = table[translationId];

          // If using link, rerun $translate with linked translationId and return it
          if (translation.substr(0, 2) === '@:') {

            $translate(translation.substr(2), interpolateParams, interpolationId, defaultTranslationText)
              .then(deferred.resolve, deferred.reject);
          } else {
            deferred.resolve(Interpolator.interpolate(translation, interpolateParams));
          }
        } else {
          var missingTranslationHandlerTranslation;
          // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
          if ($missingTranslationHandlerFactory && !pendingLoader) {
            missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams);
          }

          // since we couldn't translate the inital requested translation id,
          // we try it now with one or more fallback languages, if fallback language(s) is
          // configured.
          if ($uses && $fallbackLanguage && $fallbackLanguage.length) {
            fallbackTranslation(translationId, interpolateParams, Interpolator, defaultTranslationText)
                .then(function (translation) {
                  deferred.resolve(translation);
                }, function (_translationId) {
                  deferred.reject(applyNotFoundIndicators(_translationId));
                });
          } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
            // looks like the requested translation id doesn't exists.
            // Now, if there is a registered handler for missing translations and no
            // asyncLoader is pending, we execute the handler
            if (defaultTranslationText) {
              deferred.resolve(defaultTranslationText);
              } else {
                deferred.resolve(missingTranslationHandlerTranslation);
              }
          } else {
            if (defaultTranslationText) {
              deferred.resolve(defaultTranslationText);
            } else {
              deferred.reject(applyNotFoundIndicators(translationId));
            }
          }
        }
        return deferred.promise;
      };

      var determineTranslationInstant = function (translationId, interpolateParams, interpolationId) {

        var result, table = $uses ? $translationTable[$uses] : $translationTable,
            Interpolator = defaultInterpolator;

        // if the interpolation id exists use custom interpolator
        if (interpolatorHashMap && Object.prototype.hasOwnProperty.call(interpolatorHashMap, interpolationId)) {
          Interpolator = interpolatorHashMap[interpolationId];
        }

        // if the translation id exists, we can just interpolate it
        if (table && Object.prototype.hasOwnProperty.call(table, translationId)) {
          var translation = table[translationId];

          // If using link, rerun $translate with linked translationId and return it
          if (translation.substr(0, 2) === '@:') {
            result = determineTranslationInstant(translation.substr(2), interpolateParams, interpolationId);
          } else {
            result = Interpolator.interpolate(translation, interpolateParams);
          }
        } else {
          var missingTranslationHandlerTranslation;
          // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
          if ($missingTranslationHandlerFactory && !pendingLoader) {
            missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams);
          }

          // since we couldn't translate the inital requested translation id,
          // we try it now with one or more fallback languages, if fallback language(s) is
          // configured.
          if ($uses && $fallbackLanguage && $fallbackLanguage.length) {
            fallbackIndex = 0;
            result = fallbackTranslationInstant(translationId, interpolateParams, Interpolator);
          } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
            // looks like the requested translation id doesn't exists.
            // Now, if there is a registered handler for missing translations and no
            // asyncLoader is pending, we execute the handler
            result = missingTranslationHandlerTranslation;
          } else {
            result = applyNotFoundIndicators(translationId);
          }
        }

        return result;
      };

      var clearNextLangAndPromise = function(key) {
        if ($nextLang === key) {
          $nextLang = undefined;
        }
        langPromises[key] = undefined;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#preferredLanguage
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Returns the language key for the preferred language.
       *
       * @param {string} langKey language String or Array to be used as preferredLanguage (changing at runtime)
       *
       * @return {string} preferred language key
       */
      $translate.preferredLanguage = function (langKey) {
        if(langKey) {
          setupPreferredLanguage(langKey);
        }
        return $preferredLanguage;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#cloakClassName
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Returns the configured class name for `translate-cloak` directive.
       *
       * @return {string} cloakClassName
       */
      $translate.cloakClassName = function () {
        return $cloakClassName;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#nestedObjectDelimeter
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Returns the configured delimiter for nested namespaces.
       *
       * @return {string} nestedObjectDelimeter
       */
      $translate.nestedObjectDelimeter = function () {
        return $nestedObjectDelimeter;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#fallbackLanguage
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Returns the language key for the fallback languages or sets a new fallback stack.
       *
       * @param {string=} langKey language String or Array of fallback languages to be used (to change stack at runtime)
       *
       * @return {string||array} fallback language key
       */
      $translate.fallbackLanguage = function (langKey) {
        if (langKey !== undefined && langKey !== null) {
          fallbackStack(langKey);

          // as we might have an async loader initiated and a new translation language might have been defined
          // we need to add the promise to the stack also. So - iterate.
          if ($loaderFactory) {
            if ($fallbackLanguage && $fallbackLanguage.length) {
              for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
                if (!langPromises[$fallbackLanguage[i]]) {
                  langPromises[$fallbackLanguage[i]] = loadAsync($fallbackLanguage[i]);
                }
              }
            }
          }
          $translate.use($translate.use());
        }
        if ($fallbackWasString) {
          return $fallbackLanguage[0];
        } else {
          return $fallbackLanguage;
        }

      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#useFallbackLanguage
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Sets the first key of the fallback language stack to be used for translation.
       * Therefore all languages in the fallback array BEFORE this key will be skipped!
       *
       * @param {string=} langKey Contains the langKey the iteration shall start with. Set to false if you want to
       * get back to the whole stack
       */
      $translate.useFallbackLanguage = function (langKey) {
        if (langKey !== undefined && langKey !== null) {
          if (!langKey) {
            startFallbackIteration = 0;
          } else {
            var langKeyPosition = indexOf($fallbackLanguage, langKey);
            if (langKeyPosition > -1) {
              startFallbackIteration = langKeyPosition;
            }
          }

        }

      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#proposedLanguage
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Returns the language key of language that is currently loaded asynchronously.
       *
       * @return {string} language key
       */
      $translate.proposedLanguage = function () {
        return $nextLang;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#storage
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Returns registered storage.
       *
       * @return {object} Storage
       */
      $translate.storage = function () {
        return Storage;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#use
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Tells angular-translate which language to use by given language key. This method is
       * used to change language at runtime. It also takes care of storing the language
       * key in a configured store to let your app remember the choosed language.
       *
       * When trying to 'use' a language which isn't available it tries to load it
       * asynchronously with registered loaders.
       *
       * Returns promise object with loaded language file data or string of the currently used language.
       *
       * If no or a falsy key is given it returns the currently used language key.
       * The returned string will be ```undefined``` if setting up $translate hasn't finished.
       * @example
       * $translate.use("en_US").then(function(data){
       *   $scope.text = $translate("HELLO");
       * });
       *
       * @param {string} [key] Language key
       * @return {object|string} Promise with loaded language data or the language key if a falsy param was given.
       */
      $translate.use = function (key) {
        if (!key) {
          return $uses;
        }

        var deferred = $q.defer();

        $rootScope.$emit('$translateChangeStart', {language: key});

        // Try to get the aliased language key
        var aliasedKey = negotiateLocale(key);
        if (aliasedKey) {
          key = aliasedKey;
        }

        // if there isn't a translation table for the language we've requested,
        // we load it asynchronously
        if (($forceAsyncReloadEnabled || !$translationTable[key]) && $loaderFactory && !langPromises[key]) {
          $nextLang = key;
          langPromises[key] = loadAsync(key).then(function (translation) {
            translations(translation.key, translation.table);
            deferred.resolve(translation.key);
            if ($nextLang === key) {
              useLanguage(translation.key);
            }
            return translation;
          }, function (key) {
            $rootScope.$emit('$translateChangeError', {language: key});
            deferred.reject(key);
            $rootScope.$emit('$translateChangeEnd', {language: key});
            return $q.reject(key);
          });
          langPromises[key]['finally'](function () {
            clearNextLangAndPromise(key);
          });
        } else if ($nextLang === key && langPromises[key]) {
          // we are already loading this asynchronously
          // resolve our new deferred when the old langPromise is resolved
          langPromises[key].then(function (translation) {
            deferred.resolve(translation.key);
            return translation;
          }, function (key) {
            deferred.reject(key);
            return $q.reject(key);
          });
        } else {
          deferred.resolve(key);
          useLanguage(key);
        }

        return deferred.promise;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#storageKey
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Returns the key for the storage.
       *
       * @return {string} storage key
       */
      $translate.storageKey = function () {
        return storageKey();
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#isPostCompilingEnabled
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Returns whether post compiling is enabled or not
       *
       * @return {bool} storage key
       */
      $translate.isPostCompilingEnabled = function () {
        return $postCompilingEnabled;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#isForceAsyncReloadEnabled
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Returns whether force async reload is enabled or not
       *
       * @return {boolean} forceAsyncReload value
       */
      $translate.isForceAsyncReloadEnabled = function () {
        return $forceAsyncReloadEnabled;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#refresh
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Refreshes a translation table pointed by the given langKey. If langKey is not specified,
       * the module will drop all existent translation tables and load new version of those which
       * are currently in use.
       *
       * Refresh means that the module will drop target translation table and try to load it again.
       *
       * In case there are no loaders registered the refresh() method will throw an Error.
       *
       * If the module is able to refresh translation tables refresh() method will broadcast
       * $translateRefreshStart and $translateRefreshEnd events.
       *
       * @example
       * // this will drop all currently existent translation tables and reload those which are
       * // currently in use
       * $translate.refresh();
       * // this will refresh a translation table for the en_US language
       * $translate.refresh('en_US');
       *
       * @param {string} langKey A language key of the table, which has to be refreshed
       *
       * @return {promise} Promise, which will be resolved in case a translation tables refreshing
       * process is finished successfully, and reject if not.
       */
      $translate.refresh = function (langKey) {
        if (!$loaderFactory) {
          throw new Error('Couldn\'t refresh translation table, no loader registered!');
        }

        var deferred = $q.defer();

        function resolve() {
          deferred.resolve();
          $rootScope.$emit('$translateRefreshEnd', {language: langKey});
        }

        function reject() {
          deferred.reject();
          $rootScope.$emit('$translateRefreshEnd', {language: langKey});
        }

        $rootScope.$emit('$translateRefreshStart', {language: langKey});

        if (!langKey) {
          // if there's no language key specified we refresh ALL THE THINGS!
          var tables = [], loadingKeys = {};

          // reload registered fallback languages
          if ($fallbackLanguage && $fallbackLanguage.length) {
            for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
              tables.push(loadAsync($fallbackLanguage[i]));
              loadingKeys[$fallbackLanguage[i]] = true;
            }
          }

          // reload currently used language
          if ($uses && !loadingKeys[$uses]) {
            tables.push(loadAsync($uses));
          }

          var allTranslationsLoaded = function (tableData) {
            $translationTable = {};
            angular.forEach(tableData, function (data) {
              translations(data.key, data.table);
            });
            if ($uses) {
              useLanguage($uses);
            }
            resolve();
          };
          allTranslationsLoaded.displayName = 'refreshPostProcessor';

          $q.all(tables).then(allTranslationsLoaded, reject);

        } else if ($translationTable[langKey]) {

          var oneTranslationsLoaded = function (data) {
            translations(data.key, data.table);
            if (langKey === $uses) {
              useLanguage($uses);
            }
            resolve();
          };
          oneTranslationsLoaded.displayName = 'refreshPostProcessor';

          loadAsync(langKey).then(oneTranslationsLoaded, reject);

        } else {
          reject();
        }
        return deferred.promise;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#instant
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Returns a translation instantly from the internal state of loaded translation. All rules
       * regarding the current language, the preferred language of even fallback languages will be
       * used except any promise handling. If a language was not found, an asynchronous loading
       * will be invoked in the background.
       *
       * @param {string|array} translationId A token which represents a translation id
       *                                     This can be optionally an array of translation ids which
       *                                     results that the function's promise returns an object where
       *                                     each key is the translation id and the value the translation.
       * @param {object} interpolateParams Params
       * @param {string} interpolationId The id of the interpolation to use
       *
       * @return {string|object} translation
       */
      $translate.instant = function (translationId, interpolateParams, interpolationId) {

        // Detect undefined and null values to shorten the execution and prevent exceptions
        if (translationId === null || angular.isUndefined(translationId)) {
          return translationId;
        }

        // Duck detection: If the first argument is an array, a bunch of translations was requested.
        // The result is an object.
        if (angular.isArray(translationId)) {
          var results = {};
          for (var i = 0, c = translationId.length; i < c; i++) {
            results[translationId[i]] = $translate.instant(translationId[i], interpolateParams, interpolationId);
          }
          return results;
        }

        // We discarded unacceptable values. So we just need to verify if translationId is empty String
        if (angular.isString(translationId) && translationId.length < 1) {
          return translationId;
        }

        // trim off any whitespace
        if (translationId) {
          translationId = trim.apply(translationId);
        }

        var result, possibleLangKeys = [];
        if ($preferredLanguage) {
          possibleLangKeys.push($preferredLanguage);
        }
        if ($uses) {
          possibleLangKeys.push($uses);
        }
        if ($fallbackLanguage && $fallbackLanguage.length) {
          possibleLangKeys = possibleLangKeys.concat($fallbackLanguage);
        }
        for (var j = 0, d = possibleLangKeys.length; j < d; j++) {
          var possibleLangKey = possibleLangKeys[j];
          if ($translationTable[possibleLangKey]) {
            if (typeof $translationTable[possibleLangKey][translationId] !== 'undefined') {
              result = determineTranslationInstant(translationId, interpolateParams, interpolationId);
            } else if ($notFoundIndicatorLeft || $notFoundIndicatorRight) {
              result = applyNotFoundIndicators(translationId);
            }
          }
          if (typeof result !== 'undefined') {
            break;
          }
        }

        if (!result && result !== '') {
          // Return translation of default interpolator if not found anything.
          result = defaultInterpolator.interpolate(translationId, interpolateParams);
          if ($missingTranslationHandlerFactory && !pendingLoader) {
            result = translateByHandler(translationId, interpolateParams);
          }
        }

        return result;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#versionInfo
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Returns the current version information for the angular-translate library
       *
       * @return {string} angular-translate version
       */
      $translate.versionInfo = function () {
        return version;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#loaderCache
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Returns the defined loaderCache.
       *
       * @return {boolean|string|object} current value of loaderCache
       */
      $translate.loaderCache = function () {
        return loaderCache;
      };

      // internal purpose only
      $translate.directivePriority = function () {
        return directivePriority;
      };

      // internal purpose only
      $translate.statefulFilter = function () {
        return statefulFilter;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#isReady
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Returns whether the service is "ready" to translate (i.e. loading 1st language).
       *
       * See also {@link pascalprecht.translate.$translate#methods_onReady onReady()}.
       *
       * @return {boolean} current value of ready
       */
      $translate.isReady = function () {
        return $isReady;
      };

      var $onReadyDeferred = $q.defer();
      $onReadyDeferred.promise.then(function () {
        $isReady = true;
      });

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translate#onReady
       * @methodOf pascalprecht.translate.$translate
       *
       * @description
       * Returns whether the service is "ready" to translate (i.e. loading 1st language).
       *
       * See also {@link pascalprecht.translate.$translate#methods_isReady isReady()}.
       *
       * @param {Function=} fn Function to invoke when service is ready
       * @return {object} Promise resolved when service is ready
       */
      $translate.onReady = function (fn) {
        var deferred = $q.defer();
        if (angular.isFunction(fn)) {
          deferred.promise.then(fn);
        }
        if ($isReady) {
          deferred.resolve();
        } else {
          $onReadyDeferred.promise.then(deferred.resolve);
        }
        return deferred.promise;
      };

      // Whenever $translateReady is being fired, this will ensure the state of $isReady
      var globalOnReadyListener = $rootScope.$on('$translateReady', function () {
        $onReadyDeferred.resolve();
        globalOnReadyListener(); // one time only
        globalOnReadyListener = null;
      });
      var globalOnChangeListener = $rootScope.$on('$translateChangeEnd', function () {
        $onReadyDeferred.resolve();
        globalOnChangeListener(); // one time only
        globalOnChangeListener = null;
      });

      if ($loaderFactory) {

        // If at least one async loader is defined and there are no
        // (default) translations available we should try to load them.
        if (angular.equals($translationTable, {})) {
          if ($translate.use()) {
            $translate.use($translate.use());
          }
        }

        // Also, if there are any fallback language registered, we start
        // loading them asynchronously as soon as we can.
        if ($fallbackLanguage && $fallbackLanguage.length) {
          var processAsyncResult = function (translation) {
            translations(translation.key, translation.table);
            $rootScope.$emit('$translateChangeEnd', { language: translation.key });
            return translation;
          };
          for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
            var fallbackLanguageId = $fallbackLanguage[i];
            if ($forceAsyncReloadEnabled || !$translationTable[fallbackLanguageId]) {
              langPromises[fallbackLanguageId] = loadAsync(fallbackLanguageId).then(processAsyncResult);
            }
          }
        }
      } else {
        $rootScope.$emit('$translateReady', { language: $translate.use() });
      }

      return $translate;
    }
  ];
}
$translate.$inject = ['$STORAGE_KEY', '$windowProvider', '$translateSanitizationProvider', 'pascalprechtTranslateOverrider'];

$translate.displayName = 'displayName';

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateDefaultInterpolation
 * @requires $interpolate
 *
 * @description
 * Uses angular's `$interpolate` services to interpolate strings against some values.
 *
 * Be aware to configure a proper sanitization strategy.
 *
 * See also:
 * * {@link pascalprecht.translate.$translateSanitization}
 *
 * @return {object} $translateDefaultInterpolation Interpolator service
 */
angular.module('pascalprecht.translate').factory('$translateDefaultInterpolation', $translateDefaultInterpolation);

function $translateDefaultInterpolation ($interpolate, $translateSanitization) {

  'use strict';

  var $translateInterpolator = {},
      $locale,
      $identifier = 'default';

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateDefaultInterpolation#setLocale
   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
   *
   * @description
   * Sets current locale (this is currently not use in this interpolation).
   *
   * @param {string} locale Language key or locale.
   */
  $translateInterpolator.setLocale = function (locale) {
    $locale = locale;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateDefaultInterpolation#getInterpolationIdentifier
   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
   *
   * @description
   * Returns an identifier for this interpolation service.
   *
   * @returns {string} $identifier
   */
  $translateInterpolator.getInterpolationIdentifier = function () {
    return $identifier;
  };

  /**
   * @deprecated will be removed in 3.0
   * @see {@link pascalprecht.translate.$translateSanitization}
   */
  $translateInterpolator.useSanitizeValueStrategy = function (value) {
    $translateSanitization.useStrategy(value);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateDefaultInterpolation#interpolate
   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
   *
   * @description
   * Interpolates given string agains given interpolate params using angulars
   * `$interpolate` service.
   *
   * @returns {string} interpolated string.
   */
  $translateInterpolator.interpolate = function (string, interpolationParams) {
    interpolationParams = interpolationParams || {};
    interpolationParams = $translateSanitization.sanitize(interpolationParams, 'params');

    var interpolatedText = $interpolate(string)(interpolationParams);
    interpolatedText = $translateSanitization.sanitize(interpolatedText, 'text');

    return interpolatedText;
  };

  return $translateInterpolator;
}
$translateDefaultInterpolation.$inject = ['$interpolate', '$translateSanitization'];

$translateDefaultInterpolation.displayName = '$translateDefaultInterpolation';

angular.module('pascalprecht.translate').constant('$STORAGE_KEY', 'NG_TRANSLATE_LANG_KEY');

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translate
 * @requires $compile
 * @requires $filter
 * @requires $interpolate
 * @restrict A
 *
 * @description
 * Translates given translation id either through attribute or DOM content.
 * Internally it uses `translate` filter to translate translation id. It possible to
 * pass an optional `translate-values` object literal as string into translation id.
 *
 * @param {string=} translate Translation id which could be either string or interpolated string.
 * @param {string=} translate-values Values to pass into translation id. Can be passed as object literal string or interpolated object.
 * @param {string=} translate-attr-ATTR translate Translation id and put it into ATTR attribute.
 * @param {string=} translate-default will be used unless translation was successful
 * @param {boolean=} translate-compile (default true if present) defines locally activation of {@link pascalprecht.translate.$translateProvider#methods_usePostCompiling}
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div ng-controller="TranslateCtrl">

        <pre translate="TRANSLATION_ID"></pre>
        <pre translate>TRANSLATION_ID</pre>
        <pre translate translate-attr-title="TRANSLATION_ID"></pre>
        <pre translate="{{translationId}}"></pre>
        <pre translate>{{translationId}}</pre>
        <pre translate="WITH_VALUES" translate-values="{value: 5}"></pre>
        <pre translate translate-values="{value: 5}">WITH_VALUES</pre>
        <pre translate="WITH_VALUES" translate-values="{{values}}"></pre>
        <pre translate translate-values="{{values}}">WITH_VALUES</pre>
        <pre translate translate-attr-title="WITH_VALUES" translate-values="{{values}}"></pre>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en',{
          'TRANSLATION_ID': 'Hello there!',
          'WITH_VALUES': 'The following value is dynamic: {{value}}'
        }).preferredLanguage('en');

      });

      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
        $scope.translationId = 'TRANSLATION_ID';

        $scope.values = {
          value: 78
        };
      });
    </file>
    <file name="scenario.js">
      it('should translate', function () {
        inject(function ($rootScope, $compile) {
          $rootScope.translationId = 'TRANSLATION_ID';

          element = $compile('<p translate="TRANSLATION_ID"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate="{{translationId}}"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate>TRANSLATION_ID</p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate>{{translationId}}</p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate translate-attr-title="TRANSLATION_ID"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.attr('title')).toBe('Hello there!');
        });
      });
    </file>
   </example>
 */
.directive('translate', translateDirective);
function translateDirective($translate, $q, $interpolate, $compile, $parse, $rootScope) {

  'use strict';

  /**
   * @name trim
   * @private
   *
   * @description
   * trim polyfill
   *
   * @returns {string} The string stripped of whitespace from both ends
   */
  var trim = function() {
    return this.toString().replace(/^\s+|\s+$/g, '');
  };

  return {
    restrict: 'AE',
    scope: true,
    priority: $translate.directivePriority(),
    compile: function (tElement, tAttr) {

      var translateValuesExist = (tAttr.translateValues) ?
        tAttr.translateValues : undefined;

      var translateInterpolation = (tAttr.translateInterpolation) ?
        tAttr.translateInterpolation : undefined;

      var translateValueExist = tElement[0].outerHTML.match(/translate-value-+/i);

      var interpolateRegExp = '^(.*)(' + $interpolate.startSymbol() + '.*' + $interpolate.endSymbol() + ')(.*)',
          watcherRegExp = '^(.*)' + $interpolate.startSymbol() + '(.*)' + $interpolate.endSymbol() + '(.*)';

      return function linkFn(scope, iElement, iAttr) {

        scope.interpolateParams = {};
        scope.preText = '';
        scope.postText = '';
        scope.translateNamespace = getTranslateNamespace(scope);
        var translationIds = {};

        var initInterpolationParams = function (interpolateParams, iAttr, tAttr) {
          // initial setup
          if (iAttr.translateValues) {
            angular.extend(interpolateParams, $parse(iAttr.translateValues)(scope.$parent));
          }
          // initially fetch all attributes if existing and fill the params
          if (translateValueExist) {
            for (var attr in tAttr) {
              if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
                var attributeName = angular.lowercase(attr.substr(14, 1)) + attr.substr(15);
                interpolateParams[attributeName] = tAttr[attr];
              }
            }
          }
        };

        // Ensures any change of the attribute "translate" containing the id will
        // be re-stored to the scope's "translationId".
        // If the attribute has no content, the element's text value (white spaces trimmed off) will be used.
        var observeElementTranslation = function (translationId) {

          // Remove any old watcher
          if (angular.isFunction(observeElementTranslation._unwatchOld)) {
            observeElementTranslation._unwatchOld();
            observeElementTranslation._unwatchOld = undefined;
          }

          if (angular.equals(translationId , '') || !angular.isDefined(translationId)) {
            var iElementText = trim.apply(iElement.text());

            // Resolve translation id by inner html if required
            var interpolateMatches = iElementText.match(interpolateRegExp);
            // Interpolate translation id if required
            if (angular.isArray(interpolateMatches)) {
              scope.preText = interpolateMatches[1];
              scope.postText = interpolateMatches[3];
              translationIds.translate = $interpolate(interpolateMatches[2])(scope.$parent);
              var watcherMatches = iElementText.match(watcherRegExp);
              if (angular.isArray(watcherMatches) && watcherMatches[2] && watcherMatches[2].length) {
                observeElementTranslation._unwatchOld = scope.$watch(watcherMatches[2], function (newValue) {
                  translationIds.translate = newValue;
                  updateTranslations();
                });
              }
            } else {
              translationIds.translate = iElementText;
            }
          } else {
            translationIds.translate = translationId;
          }
          updateTranslations();
        };

        var observeAttributeTranslation = function (translateAttr) {
          iAttr.$observe(translateAttr, function (translationId) {
            translationIds[translateAttr] = translationId;
            updateTranslations();
          });
        };

        // initial setup with values
        initInterpolationParams(scope.interpolateParams, iAttr, tAttr);

        var firstAttributeChangedEvent = true;
        iAttr.$observe('translate', function (translationId) {
          if (typeof translationId === 'undefined') {
            // case of element "<translate>xyz</translate>"
            observeElementTranslation('');
          } else {
            // case of regular attribute
            if (translationId !== '' || !firstAttributeChangedEvent) {
              translationIds.translate = translationId;
              updateTranslations();
            }
          }
          firstAttributeChangedEvent = false;
        });

        for (var translateAttr in iAttr) {
          if (iAttr.hasOwnProperty(translateAttr) && translateAttr.substr(0, 13) === 'translateAttr') {
            observeAttributeTranslation(translateAttr);
          }
        }

        iAttr.$observe('translateDefault', function (value) {
          scope.defaultText = value;
        });

        if (translateValuesExist) {
          iAttr.$observe('translateValues', function (interpolateParams) {
            if (interpolateParams) {
              scope.$parent.$watch(function () {
                angular.extend(scope.interpolateParams, $parse(interpolateParams)(scope.$parent));
              });
            }
          });
        }

        if (translateValueExist) {
          var observeValueAttribute = function (attrName) {
            iAttr.$observe(attrName, function (value) {
              var attributeName = angular.lowercase(attrName.substr(14, 1)) + attrName.substr(15);
              scope.interpolateParams[attributeName] = value;
            });
          };
          for (var attr in iAttr) {
            if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
              observeValueAttribute(attr);
            }
          }
        }

        // Master update function
        var updateTranslations = function () {
          for (var key in translationIds) {

            if (translationIds.hasOwnProperty(key) && translationIds[key] !== undefined) {
              updateTranslation(key, translationIds[key], scope, scope.interpolateParams, scope.defaultText, scope.translateNamespace);
            }
          }
        };

        // Put translation processing function outside loop
        var updateTranslation = function(translateAttr, translationId, scope, interpolateParams, defaultTranslationText, translateNamespace) {
          if (translationId) {
            // if translation id starts with '.' and translateNamespace given, prepend namespace
            if (translateNamespace && translationId.charAt(0) === '.') {
              translationId = translateNamespace + translationId;
            }

            $translate(translationId, interpolateParams, translateInterpolation, defaultTranslationText)
              .then(function (translation) {
                applyTranslation(translation, scope, true, translateAttr);
              }, function (translationId) {
                applyTranslation(translationId, scope, false, translateAttr);
              });
          } else {
            // as an empty string cannot be translated, we can solve this using successful=false
            applyTranslation(translationId, scope, false, translateAttr);
          }
        };

        var applyTranslation = function (value, scope, successful, translateAttr) {
          if (translateAttr === 'translate') {
            // default translate into innerHTML
            if (!successful && typeof scope.defaultText !== 'undefined') {
              value = scope.defaultText;
            }
            iElement.empty().append(scope.preText + value + scope.postText);
            var globallyEnabled = $translate.isPostCompilingEnabled();
            var locallyDefined = typeof tAttr.translateCompile !== 'undefined';
            var locallyEnabled = locallyDefined && tAttr.translateCompile !== 'false';
            if ((globallyEnabled && !locallyDefined) || locallyEnabled) {
              $compile(iElement.contents())(scope);
            }
          } else {
            // translate attribute
            if (!successful && typeof scope.defaultText !== 'undefined') {
              value = scope.defaultText;
            }
            var attributeName = iAttr.$attr[translateAttr];
            if (attributeName.substr(0, 5) === 'data-') {
              // ensure html5 data prefix is stripped
              attributeName = attributeName.substr(5);
            }
            attributeName = attributeName.substr(15);
            iElement.attr(attributeName, value);
          }
        };

        if (translateValuesExist || translateValueExist || iAttr.translateDefault) {
          scope.$watch('interpolateParams', updateTranslations, true);
        }

        // Ensures the text will be refreshed after the current language was changed
        // w/ $translate.use(...)
        var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);

        // ensure translation will be looked up at least one
        if (iElement.text().length) {
          if (iAttr.translate) {
            observeElementTranslation(iAttr.translate);
          } else {
            observeElementTranslation('');
          }
        } else if (iAttr.translate) {
          // ensure attribute will be not skipped
          observeElementTranslation(iAttr.translate);
        }
        updateTranslations();
        scope.$on('$destroy', unbind);
      };
    }
  };
}
translateDirective.$inject = ['$translate', '$q', '$interpolate', '$compile', '$parse', '$rootScope'];

/**
 * Returns the scope's namespace.
 * @private
 * @param scope
 * @returns {string}
 */
function getTranslateNamespace(scope) {
  'use strict';
  if (scope.translateNamespace) {
    return scope.translateNamespace;
  }
  if (scope.$parent) {
    return getTranslateNamespace(scope.$parent);
  }
}

translateDirective.displayName = 'translateDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translateCloak
 * @requires $rootScope
 * @requires $translate
 * @restrict A
 *
 * $description
 * Adds a `translate-cloak` class name to the given element where this directive
 * is applied initially and removes it, once a loader has finished loading.
 *
 * This directive can be used to prevent initial flickering when loading translation
 * data asynchronously.
 *
 * The class name is defined in
 * {@link pascalprecht.translate.$translateProvider#cloakClassName $translate.cloakClassName()}.
 *
 * @param {string=} translate-cloak If a translationId is provided, it will be used for showing
 *                                  or hiding the cloak. Basically it relies on the translation
 *                                  resolve.
 */
.directive('translateCloak', translateCloakDirective);

function translateCloakDirective($translate) {

  'use strict';

  return {
    compile: function (tElement) {
      var applyCloak = function () {
        tElement.addClass($translate.cloakClassName());
      },
      removeCloak = function () {
        tElement.removeClass($translate.cloakClassName());
      };
      $translate.onReady(function () {
        removeCloak();
      });
      applyCloak();

      return function linkFn(scope, iElement, iAttr) {
        // Register a watcher for the defined translation allowing a fine tuned cloak
        if (iAttr.translateCloak && iAttr.translateCloak.length) {
          iAttr.$observe('translateCloak', function (translationId) {
            $translate(translationId).then(removeCloak, applyCloak);
          });
        }
      };
    }
  };
}
translateCloakDirective.$inject = ['$translate'];

translateCloakDirective.displayName = 'translateCloakDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translateNamespace
 * @restrict A
 *
 * @description
 * Translates given translation id either through attribute or DOM content.
 * Internally it uses `translate` filter to translate translation id. It possible to
 * pass an optional `translate-values` object literal as string into translation id.
 *
 * @param {string=} translate namespace name which could be either string or interpolated string.
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div translate-namespace="CONTENT">

        <div>
            <h1 translate>.HEADERS.TITLE</h1>
            <h1 translate>.HEADERS.WELCOME</h1>
        </div>

        <div translate-namespace=".HEADERS">
            <h1 translate>.TITLE</h1>
            <h1 translate>.WELCOME</h1>
        </div>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en',{
          'TRANSLATION_ID': 'Hello there!',
          'CONTENT': {
            'HEADERS': {
                TITLE: 'Title'
            }
          },
          'CONTENT.HEADERS.WELCOME': 'Welcome'
        }).preferredLanguage('en');

      });

    </file>
   </example>
 */
.directive('translateNamespace', translateNamespaceDirective);

function translateNamespaceDirective() {

  'use strict';

  return {
    restrict: 'A',
    scope: true,
    compile: function () {
      return {
        pre: function (scope, iElement, iAttrs) {
          scope.translateNamespace = getTranslateNamespace(scope);

          if (scope.translateNamespace && iAttrs.translateNamespace.charAt(0) === '.') {
            scope.translateNamespace += iAttrs.translateNamespace;
          } else {
            scope.translateNamespace = iAttrs.translateNamespace;
          }
        }
      };
    }
  };
}

/**
 * Returns the scope's namespace.
 * @private
 * @param scope
 * @returns {string}
 */
function getTranslateNamespace(scope) {
  'use strict';
  if (scope.translateNamespace) {
    return scope.translateNamespace;
  }
  if (scope.$parent) {
    return getTranslateNamespace(scope.$parent);
  }
}

translateNamespaceDirective.displayName = 'translateNamespaceDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc filter
 * @name pascalprecht.translate.filter:translate
 * @requires $parse
 * @requires pascalprecht.translate.$translate
 * @function
 *
 * @description
 * Uses `$translate` service to translate contents. Accepts interpolate parameters
 * to pass dynamized values though translation.
 *
 * @param {string} translationId A translation id to be translated.
 * @param {*=} interpolateParams Optional object literal (as hash or string) to pass values into translation.
 *
 * @returns {string} Translated text.
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div ng-controller="TranslateCtrl">

        <pre>{{ 'TRANSLATION_ID' | translate }}</pre>
        <pre>{{ translationId | translate }}</pre>
        <pre>{{ 'WITH_VALUES' | translate:'{value: 5}' }}</pre>
        <pre>{{ 'WITH_VALUES' | translate:values }}</pre>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en', {
          'TRANSLATION_ID': 'Hello there!',
          'WITH_VALUES': 'The following value is dynamic: {{value}}'
        });
        $translateProvider.preferredLanguage('en');

      });

      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
        $scope.translationId = 'TRANSLATION_ID';

        $scope.values = {
          value: 78
        };
      });
    </file>
   </example>
 */
.filter('translate', translateFilterFactory);

function translateFilterFactory($parse, $translate) {

  'use strict';

  var translateFilter = function (translationId, interpolateParams, interpolation) {

    if (!angular.isObject(interpolateParams)) {
      interpolateParams = $parse(interpolateParams)(this);
    }

    return $translate.instant(translationId, interpolateParams, interpolation);
  };

  if ($translate.statefulFilter()) {
    translateFilter.$stateful = true;
  }

  return translateFilter;
}
translateFilterFactory.$inject = ['$parse', '$translate'];

translateFilterFactory.displayName = 'translateFilterFactory';

angular.module('pascalprecht.translate')

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translationCache
 * @requires $cacheFactory
 *
 * @description
 * The first time a translation table is used, it is loaded in the translation cache for quick retrieval. You
 * can load translation tables directly into the cache by consuming the
 * `$translationCache` service directly.
 *
 * @return {object} $cacheFactory object.
 */
  .factory('$translationCache', $translationCache);

function $translationCache($cacheFactory) {

  'use strict';

  return $cacheFactory('translations');
}
$translationCache.$inject = ['$cacheFactory'];

$translationCache.displayName = '$translationCache';
return 'pascalprecht.translate';

}));


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(23);
module.exports = 'ui.bootstrap';


/***/ }),
/* 23 */
/***/ (function(module, exports) {

/*
 * angular-ui-bootstrap
 * http://angular-ui.github.io/bootstrap/

 * Version: 0.13.4 - 2015-09-03
 * License: MIT
 */
angular.module("ui.bootstrap", ["ui.bootstrap.tpls", "ui.bootstrap.collapse","ui.bootstrap.accordion","ui.bootstrap.alert","ui.bootstrap.bindHtml","ui.bootstrap.buttons","ui.bootstrap.carousel","ui.bootstrap.dateparser","ui.bootstrap.position","ui.bootstrap.datepicker","ui.bootstrap.dropdown","ui.bootstrap.modal","ui.bootstrap.pagination","ui.bootstrap.tooltip","ui.bootstrap.popover","ui.bootstrap.progressbar","ui.bootstrap.rating","ui.bootstrap.tabs","ui.bootstrap.timepicker","ui.bootstrap.transition","ui.bootstrap.typeahead"]);
angular.module("ui.bootstrap.tpls", ["template/accordion/accordion-group.html","template/accordion/accordion.html","template/alert/alert.html","template/carousel/carousel.html","template/carousel/slide.html","template/datepicker/datepicker.html","template/datepicker/day.html","template/datepicker/month.html","template/datepicker/popup.html","template/datepicker/year.html","template/modal/backdrop.html","template/modal/window.html","template/pagination/pager.html","template/pagination/pagination.html","template/tooltip/tooltip-html-popup.html","template/tooltip/tooltip-html-unsafe-popup.html","template/tooltip/tooltip-popup.html","template/tooltip/tooltip-template-popup.html","template/popover/popover-html.html","template/popover/popover-template.html","template/popover/popover.html","template/progressbar/bar.html","template/progressbar/progress.html","template/progressbar/progressbar.html","template/rating/rating.html","template/tabs/tab.html","template/tabs/tabset.html","template/timepicker/timepicker.html","template/typeahead/typeahead-match.html","template/typeahead/typeahead-popup.html"]);
angular.module('ui.bootstrap.collapse', [])

  .directive('collapse', ['$animate', function($animate) {
    return {
      link: function(scope, element, attrs) {
        function expand() {
          element.removeClass('collapse')
            .addClass('collapsing')
            .attr('aria-expanded', true)
            .attr('aria-hidden', false);

          $animate.addClass(element, 'in', {
            to: { height: element[0].scrollHeight + 'px' }
          }).then(expandDone);
        }

        function expandDone() {
          element.removeClass('collapsing');
          element.css({height: 'auto'});
        }

        function collapse() {
          if (!element.hasClass('collapse') && !element.hasClass('in')) {
            return collapseDone();
          }

          element
            // IMPORTANT: The height must be set before adding "collapsing" class.
            // Otherwise, the browser attempts to animate from height 0 (in
            // collapsing class) to the given height here.
            .css({height: element[0].scrollHeight + 'px'})
            // initially all panel collapse have the collapse class, this removal
            // prevents the animation from jumping to collapsed state
            .removeClass('collapse')
            .addClass('collapsing')
            .attr('aria-expanded', false)
            .attr('aria-hidden', true);

          $animate.removeClass(element, 'in', {
            to: {height: '0'}
          }).then(collapseDone);
        }

        function collapseDone() {
          element.css({height: '0'}); // Required so that collapse works when animation is disabled
          element.removeClass('collapsing');
          element.addClass('collapse');
        }

        scope.$watch(attrs.collapse, function(shouldCollapse) {
          if (shouldCollapse) {
            collapse();
          } else {
            expand();
          }
        });
      }
    };
  }]);

angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse'])

.constant('accordionConfig', {
  closeOthers: true
})

.controller('AccordionController', ['$scope', '$attrs', 'accordionConfig', function($scope, $attrs, accordionConfig) {
  // This array keeps track of the accordion groups
  this.groups = [];

  // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
  this.closeOthers = function(openGroup) {
    var closeOthers = angular.isDefined($attrs.closeOthers) ?
      $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
    if (closeOthers) {
      angular.forEach(this.groups, function(group) {
        if (group !== openGroup) {
          group.isOpen = false;
        }
      });
    }
  };

  // This is called from the accordion-group directive to add itself to the accordion
  this.addGroup = function(groupScope) {
    var that = this;
    this.groups.push(groupScope);

    groupScope.$on('$destroy', function(event) {
      that.removeGroup(groupScope);
    });
  };

  // This is called from the accordion-group directive when to remove itself
  this.removeGroup = function(group) {
    var index = this.groups.indexOf(group);
    if (index !== -1) {
      this.groups.splice(index, 1);
    }
  };

}])

// The accordion directive simply sets up the directive controller
// and adds an accordion CSS class to itself element.
.directive('accordion', function() {
  return {
    restrict: 'EA',
    controller: 'AccordionController',
    controllerAs: 'accordion',
    transclude: true,
    replace: false,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'template/accordion/accordion.html';
    }
  };
})

// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
.directive('accordionGroup', function() {
  return {
    require: '^accordion',         // We need this directive to be inside an accordion
    restrict: 'EA',
    transclude: true,              // It transcludes the contents of the directive into the template
    replace: true,                // The element containing the directive will be replaced with the template
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'template/accordion/accordion-group.html';
    },
    scope: {
      heading: '@',               // Interpolate the heading attribute onto this scope
      isOpen: '=?',
      isDisabled: '=?'
    },
    controller: function() {
      this.setHeading = function(element) {
        this.heading = element;
      };
    },
    link: function(scope, element, attrs, accordionCtrl) {
      accordionCtrl.addGroup(scope);

      scope.openClass = attrs.openClass || 'panel-open';
      scope.panelClass = attrs.panelClass;
      scope.$watch('isOpen', function(value) {
        element.toggleClass(scope.openClass, value);
        if (value) {
          accordionCtrl.closeOthers(scope);
        }
      });

      scope.toggleOpen = function($event) {
        if (!scope.isDisabled) {
          if (!$event || $event.which === 32) {
            scope.isOpen = !scope.isOpen;
          }
        }
      };
    }
  };
})

// Use accordion-heading below an accordion-group to provide a heading containing HTML
// <accordion-group>
//   <accordion-heading>Heading containing HTML - <img src="..."></accordion-heading>
// </accordion-group>
.directive('accordionHeading', function() {
  return {
    restrict: 'EA',
    transclude: true,   // Grab the contents to be used as the heading
    template: '',       // In effect remove this element!
    replace: true,
    require: '^accordionGroup',
    link: function(scope, element, attr, accordionGroupCtrl, transclude) {
      // Pass the heading to the accordion-group controller
      // so that it can be transcluded into the right place in the template
      // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
      accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
    }
  };
})

// Use in the accordion-group template to indicate where you want the heading to be transcluded
// You must provide the property on the accordion-group controller that will hold the transcluded element
// <div class="accordion-group">
//   <div class="accordion-heading" ><a ... accordion-transclude="heading">...</a></div>
//   ...
// </div>
.directive('accordionTransclude', function() {
  return {
    require: '^accordionGroup',
    link: function(scope, element, attr, controller) {
      scope.$watch(function() { return controller[attr.accordionTransclude]; }, function(heading) {
        if (heading) {
          element.find('span').html('');
          element.find('span').append(heading);
        }
      });
    }
  };
})

;

angular.module('ui.bootstrap.alert', [])

.controller('AlertController', ['$scope', '$attrs', function($scope, $attrs) {
  $scope.closeable = !!$attrs.close;
  this.close = $scope.close;
}])

.directive('alert', function() {
  return {
    controller: 'AlertController',
    controllerAs: 'alert',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'template/alert/alert.html';
    },
    transclude: true,
    replace: true,
    scope: {
      type: '@',
      close: '&'
    }
  };
})

.directive('dismissOnTimeout', ['$timeout', function($timeout) {
  return {
    require: 'alert',
    link: function(scope, element, attrs, alertCtrl) {
      $timeout(function() {
        alertCtrl.close();
      }, parseInt(attrs.dismissOnTimeout, 10));
    }
  };
}]);

angular.module('ui.bootstrap.bindHtml', [])

  .value('$bindHtmlUnsafeSuppressDeprecated', false)

  .directive('bindHtmlUnsafe', ['$log', '$bindHtmlUnsafeSuppressDeprecated', function ($log, $bindHtmlUnsafeSuppressDeprecated) {
    return function (scope, element, attr) {
      if (!$bindHtmlUnsafeSuppressDeprecated) {
        $log.warn('bindHtmlUnsafe is now deprecated. Use ngBindHtml instead');
      }
      element.addClass('ng-binding').data('$binding', attr.bindHtmlUnsafe);
      scope.$watch(attr.bindHtmlUnsafe, function bindHtmlUnsafeWatchAction(value) {
        element.html(value || '');
      });
    };
  }]);
angular.module('ui.bootstrap.buttons', [])

.constant('buttonConfig', {
  activeClass: 'active',
  toggleEvent: 'click'
})

.controller('ButtonsController', ['buttonConfig', function(buttonConfig) {
  this.activeClass = buttonConfig.activeClass || 'active';
  this.toggleEvent = buttonConfig.toggleEvent || 'click';
}])

.directive('btnRadio', function() {
  return {
    require: ['btnRadio', 'ngModel'],
    controller: 'ButtonsController',
    controllerAs: 'buttons',
    link: function(scope, element, attrs, ctrls) {
      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      element.find('input').css({display: 'none'});

      //model -> UI
      ngModelCtrl.$render = function() {
        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.btnRadio)));
      };

      //ui->model
      element.bind(buttonsCtrl.toggleEvent, function() {
        if (attrs.disabled) {
          return;
        }

        var isActive = element.hasClass(buttonsCtrl.activeClass);

        if (!isActive || angular.isDefined(attrs.uncheckable)) {
          scope.$apply(function() {
            ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.btnRadio));
            ngModelCtrl.$render();
          });
        }
      });
    }
  };
})

.directive('btnCheckbox', ['$document', function($document) {
  return {
    require: ['btnCheckbox', 'ngModel'],
    controller: 'ButtonsController',
    controllerAs: 'button',
    link: function(scope, element, attrs, ctrls) {
      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      element.find('input').css({display: 'none'});

      function getTrueValue() {
        return getCheckboxValue(attrs.btnCheckboxTrue, true);
      }

      function getFalseValue() {
        return getCheckboxValue(attrs.btnCheckboxFalse, false);
      }

      function getCheckboxValue(attributeValue, defaultValue) {
        var val = scope.$eval(attributeValue);
        return angular.isDefined(val) ? val : defaultValue;
      }

      //model -> UI
      ngModelCtrl.$render = function() {
        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
      };

      //ui->model
      element.bind(buttonsCtrl.toggleEvent, function() {
        if (attrs.disabled) {
          return;
        }

        scope.$apply(function() {
          ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
          ngModelCtrl.$render();
        });
      });

      //accessibility
      element.on('keypress', function(e) {
        if (attrs.disabled || e.which !== 32 || $document[0].activeElement !== element[0]) {
          return;
        }

        scope.$apply(function() {
          ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
          ngModelCtrl.$render();
        });
      });
    }
  };
}]);

/**
* @ngdoc overview
* @name ui.bootstrap.carousel
*
* @description
* AngularJS version of an image carousel.
*
*/
angular.module('ui.bootstrap.carousel', [])
.controller('CarouselController', ['$scope', '$element', '$interval', '$animate', function ($scope, $element, $interval, $animate) {
  var self = this,
    slides = self.slides = $scope.slides = [],
    NEW_ANIMATE = angular.version.minor >= 4,
    NO_TRANSITION = 'uib-noTransition',
    SLIDE_DIRECTION = 'uib-slideDirection',
    currentIndex = -1,
    currentInterval, isPlaying;
  self.currentSlide = null;

  var destroyed = false;
  /* direction: "prev" or "next" */
  self.select = $scope.select = function(nextSlide, direction) {
    var nextIndex = $scope.indexOfSlide(nextSlide);
    //Decide direction if it's not given
    if (direction === undefined) {
      direction = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';
    }
    //Prevent this user-triggered transition from occurring if there is already one in progress
    if (nextSlide && nextSlide !== self.currentSlide && !$scope.$currentTransition) {
      goNext(nextSlide, nextIndex, direction);
    }
  };

  function goNext(slide, index, direction) {
    // Scope has been destroyed, stop here.
    if (destroyed) { return; }

    angular.extend(slide, {direction: direction, active: true});
    angular.extend(self.currentSlide || {}, {direction: direction, active: false});
    if ($animate.enabled() && !$scope.noTransition && !$scope.$currentTransition &&
      slide.$element && self.slides.length > 1) {
      slide.$element.data(SLIDE_DIRECTION, slide.direction);
      if (self.currentSlide && self.currentSlide.$element) {
        self.currentSlide.$element.data(SLIDE_DIRECTION, slide.direction);
      }

      $scope.$currentTransition = true;
      if (NEW_ANIMATE) {
        $animate.on('addClass', slide.$element, function (element, phase) {
          if (phase === 'close') {
            $scope.$currentTransition = null;
            $animate.off('addClass', element);
          }
        });
      } else {
        slide.$element.one('$animate:close', function closeFn() {
          $scope.$currentTransition = null;
        });
      }
    }

    self.currentSlide = slide;
    currentIndex = index;

    //every time you change slides, reset the timer
    restartTimer();
  }

  $scope.$on('$destroy', function () {
    destroyed = true;
  });

  function getSlideByIndex(index) {
    if (angular.isUndefined(slides[index].index)) {
      return slides[index];
    }
    var i, len = slides.length;
    for (i = 0; i < slides.length; ++i) {
      if (slides[i].index == index) {
        return slides[i];
      }
    }
  }

  self.getCurrentIndex = function() {
    if (self.currentSlide && angular.isDefined(self.currentSlide.index)) {
      return +self.currentSlide.index;
    }
    return currentIndex;
  };

  /* Allow outside people to call indexOf on slides array */
  $scope.indexOfSlide = function(slide) {
    return angular.isDefined(slide.index) ? +slide.index : slides.indexOf(slide);
  };

  $scope.next = function() {
    var newIndex = (self.getCurrentIndex() + 1) % slides.length;

    if (newIndex === 0 && $scope.noWrap()) {
      $scope.pause();
      return;
    }

    return self.select(getSlideByIndex(newIndex), 'next');
  };

  $scope.prev = function() {
    var newIndex = self.getCurrentIndex() - 1 < 0 ? slides.length - 1 : self.getCurrentIndex() - 1;

    if ($scope.noWrap() && newIndex === slides.length - 1){
      $scope.pause();
      return;
    }

    return self.select(getSlideByIndex(newIndex), 'prev');
  };

  $scope.isActive = function(slide) {
     return self.currentSlide === slide;
  };

  $scope.$watch('interval', restartTimer);
  $scope.$on('$destroy', resetTimer);

  function restartTimer() {
    resetTimer();
    var interval = +$scope.interval;
    if (!isNaN(interval) && interval > 0) {
      currentInterval = $interval(timerFn, interval);
    }
  }

  function resetTimer() {
    if (currentInterval) {
      $interval.cancel(currentInterval);
      currentInterval = null;
    }
  }

  function timerFn() {
    var interval = +$scope.interval;
    if (isPlaying && !isNaN(interval) && interval > 0 && slides.length) {
      $scope.next();
    } else {
      $scope.pause();
    }
  }

  $scope.play = function() {
    if (!isPlaying) {
      isPlaying = true;
      restartTimer();
    }
  };
  $scope.pause = function() {
    if (!$scope.noPause) {
      isPlaying = false;
      resetTimer();
    }
  };

  self.addSlide = function(slide, element) {
    slide.$element = element;
    slides.push(slide);
    //if this is the first slide or the slide is set to active, select it
    if(slides.length === 1 || slide.active) {
      self.select(slides[slides.length-1]);
      if (slides.length == 1) {
        $scope.play();
      }
    } else {
      slide.active = false;
    }
  };

  self.removeSlide = function(slide) {
    if (angular.isDefined(slide.index)) {
      slides.sort(function(a, b) {
        return +a.index > +b.index;
      });
    }
    //get the index of the slide inside the carousel
    var index = slides.indexOf(slide);
    slides.splice(index, 1);
    if (slides.length > 0 && slide.active) {
      if (index >= slides.length) {
        self.select(slides[index-1]);
      } else {
        self.select(slides[index]);
      }
    } else if (currentIndex > index) {
      currentIndex--;
    }
    
    //clean the currentSlide when no more slide
    if (slides.length === 0) {
      self.currentSlide = null;
    }
  };

  $scope.$watch('noTransition', function(noTransition) {
    $element.data(NO_TRANSITION, noTransition);
  });

}])

/**
 * @ngdoc directive
 * @name ui.bootstrap.carousel.directive:carousel
 * @restrict EA
 *
 * @description
 * Carousel is the outer container for a set of image 'slides' to showcase.
 *
 * @param {number=} interval The time, in milliseconds, that it will take the carousel to go to the next slide.
 * @param {boolean=} noTransition Whether to disable transitions on the carousel.
 * @param {boolean=} noPause Whether to disable pausing on the carousel (by default, the carousel interval pauses on hover).
 *
 * @example
<example module="ui.bootstrap">
  <file name="index.html">
    <carousel>
      <slide>
        <img src="http://placekitten.com/150/150" style="margin:auto;">
        <div class="carousel-caption">
          <p>Beautiful!</p>
        </div>
      </slide>
      <slide>
        <img src="http://placekitten.com/100/150" style="margin:auto;">
        <div class="carousel-caption">
          <p>D'aww!</p>
        </div>
      </slide>
    </carousel>
  </file>
  <file name="demo.css">
    .carousel-indicators {
      top: auto;
      bottom: 15px;
    }
  </file>
</example>
 */
.directive('carousel', [function() {
  return {
    restrict: 'EA',
    transclude: true,
    replace: true,
    controller: 'CarouselController',
    controllerAs: 'carousel',
    require: 'carousel',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'template/carousel/carousel.html';
    },
    scope: {
      interval: '=',
      noTransition: '=',
      noPause: '=',
      noWrap: '&'
    }
  };
}])

/**
 * @ngdoc directive
 * @name ui.bootstrap.carousel.directive:slide
 * @restrict EA
 *
 * @description
 * Creates a slide inside a {@link ui.bootstrap.carousel.directive:carousel carousel}.  Must be placed as a child of a carousel element.
 *
 * @param {boolean=} active Model binding, whether or not this slide is currently active.
 * @param {number=} index The index of the slide. The slides will be sorted by this parameter.
 *
 * @example
<example module="ui.bootstrap">
  <file name="index.html">
<div ng-controller="CarouselDemoCtrl">
  <carousel>
    <slide ng-repeat="slide in slides" active="slide.active" index="$index">
      <img ng-src="{{slide.image}}" style="margin:auto;">
      <div class="carousel-caption">
        <h4>Slide {{$index}}</h4>
        <p>{{slide.text}}</p>
      </div>
    </slide>
  </carousel>
  Interval, in milliseconds: <input type="number" ng-model="myInterval">
  <br />Enter a negative number to stop the interval.
</div>
  </file>
  <file name="script.js">
function CarouselDemoCtrl($scope) {
  $scope.myInterval = 5000;
}
  </file>
  <file name="demo.css">
    .carousel-indicators {
      top: auto;
      bottom: 15px;
    }
  </file>
</example>
*/

.directive('slide', function() {
  return {
    require: '^carousel',
    restrict: 'EA',
    transclude: true,
    replace: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'template/carousel/slide.html';
    },
    scope: {
      active: '=?',
      actual: '=?',
      index: '=?'
    },
    link: function (scope, element, attrs, carouselCtrl) {
      carouselCtrl.addSlide(scope, element);
      //when the scope is destroyed then remove the slide from the current slides array
      scope.$on('$destroy', function() {
        carouselCtrl.removeSlide(scope);
      });

      scope.$watch('active', function(active) {
        if (active) {
          carouselCtrl.select(scope);
        }
      });
    }
  };
})

.animation('.item', [
         '$injector', '$animate',
function ($injector, $animate) {
  var NO_TRANSITION = 'uib-noTransition',
    SLIDE_DIRECTION = 'uib-slideDirection',
    $animateCss = null;

  if ($injector.has('$animateCss')) {
    $animateCss = $injector.get('$animateCss');
  }

  function removeClass(element, className, callback) {
    element.removeClass(className);
    if (callback) {
      callback();
    }
  }

  return {
    beforeAddClass: function (element, className, done) {
      // Due to transclusion, noTransition property is on parent's scope
      if (className == 'active' && element.parent() &&
          !element.parent().data(NO_TRANSITION)) {
        var stopped = false;
        var direction = element.data(SLIDE_DIRECTION);
        var directionClass = direction == 'next' ? 'left' : 'right';
        var removeClassFn = removeClass.bind(this, element,
          directionClass + ' ' + direction, done);
        element.addClass(direction);

        if ($animateCss) {
          $animateCss(element, {addClass: directionClass})
            .start()
            .done(removeClassFn);
        } else {
          $animate.addClass(element, directionClass).then(function () {
            if (!stopped) {
              removeClassFn();
            }
            done();
          });
        }

        return function () {
          stopped = true;
        };
      }
      done();
    },
    beforeRemoveClass: function (element, className, done) {
      // Due to transclusion, noTransition property is on parent's scope
      if (className === 'active' && element.parent() &&
          !element.parent().data(NO_TRANSITION)) {
        var stopped = false;
        var direction = element.data(SLIDE_DIRECTION);
        var directionClass = direction == 'next' ? 'left' : 'right';
        var removeClassFn = removeClass.bind(this, element, directionClass, done);

        if ($animateCss) {
          $animateCss(element, {addClass: directionClass})
            .start()
            .done(removeClassFn);
        } else {
          $animate.addClass(element, directionClass).then(function () {
            if (!stopped) {
              removeClassFn();
            }
            done();
          });
        }
        return function () {
          stopped = true;
        };
      }
      done();
    }
  };

}])


;

angular.module('ui.bootstrap.dateparser', [])

.service('dateParser', ['$log', '$locale', 'orderByFilter', function($log, $locale, orderByFilter) {
  // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
  var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;

  this.parsers = {};

  var formatCodeToRegex = {
    'yyyy': {
      regex: '\\d{4}',
      apply: function(value) { this.year = +value; }
    },
    'yy': {
      regex: '\\d{2}',
      apply: function(value) { this.year = +value + 2000; }
    },
    'y': {
      regex: '\\d{1,4}',
      apply: function(value) { this.year = +value; }
    },
    'MMMM': {
      regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
      apply: function(value) { this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value); }
    },
    'MMM': {
      regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
      apply: function(value) { this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value); }
    },
    'MM': {
      regex: '0[1-9]|1[0-2]',
      apply: function(value) { this.month = value - 1; }
    },
    'M': {
      regex: '[1-9]|1[0-2]',
      apply: function(value) { this.month = value - 1; }
    },
    'dd': {
      regex: '[0-2][0-9]{1}|3[0-1]{1}',
      apply: function(value) { this.date = +value; }
    },
    'd': {
      regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
      apply: function(value) { this.date = +value; }
    },
    'EEEE': {
      regex: $locale.DATETIME_FORMATS.DAY.join('|')
    },
    'EEE': {
      regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|')
    },
    'HH': {
      regex: '(?:0|1)[0-9]|2[0-3]',
      apply: function(value) { this.hours = +value; }
    },
    'hh': {
      regex: '0[0-9]|1[0-2]',
      apply: function(value) { this.hours = +value; }
    },
    'H': {
      regex: '1?[0-9]|2[0-3]',
      apply: function(value) { this.hours = +value; }
    },
    'h': {
      regex: '[0-9]|1[0-2]',
      apply: function(value) { this.hours = +value; }
    },
    'mm': {
      regex: '[0-5][0-9]',
      apply: function(value) { this.minutes = +value; }
    },
    'm': {
      regex: '[0-9]|[1-5][0-9]',
      apply: function(value) { this.minutes = +value; }
    },
    'sss': {
      regex: '[0-9][0-9][0-9]',
      apply: function(value) { this.milliseconds = +value; }
    },
    'ss': {
      regex: '[0-5][0-9]',
      apply: function(value) { this.seconds = +value; }
    },
    's': {
      regex: '[0-9]|[1-5][0-9]',
      apply: function(value) { this.seconds = +value; }
    },
    'a': {
      regex: $locale.DATETIME_FORMATS.AMPMS.join('|'),
      apply: function(value) {
        if (this.hours === 12) {
          this.hours = 0;
        }

        if (value === 'PM') {
          this.hours += 12;
        }
      }
    }
  };

  function createParser(format) {
    var map = [], regex = format.split('');

    angular.forEach(formatCodeToRegex, function(data, code) {
      var index = format.indexOf(code);

      if (index > -1) {
        format = format.split('');

        regex[index] = '(' + data.regex + ')';
        format[index] = '$'; // Custom symbol to define consumed part of format
        for (var i = index + 1, n = index + code.length; i < n; i++) {
          regex[i] = '';
          format[i] = '$';
        }
        format = format.join('');

        map.push({ index: index, apply: data.apply });
      }
    });

    return {
      regex: new RegExp('^' + regex.join('') + '$'),
      map: orderByFilter(map, 'index')
    };
  }

  this.parse = function(input, format, baseDate) {
    if (!angular.isString(input) || !format) {
      return input;
    }

    format = $locale.DATETIME_FORMATS[format] || format;
    format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');

    if (!this.parsers[format]) {
      this.parsers[format] = createParser(format);
    }

    var parser = this.parsers[format],
        regex = parser.regex,
        map = parser.map,
        results = input.match(regex);

    if (results && results.length) {
      var fields, dt;
      if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
        fields = {
          year: baseDate.getFullYear(),
          month: baseDate.getMonth(),
          date: baseDate.getDate(),
          hours: baseDate.getHours(),
          minutes: baseDate.getMinutes(),
          seconds: baseDate.getSeconds(),
          milliseconds: baseDate.getMilliseconds()
        };
      } else {
        if (baseDate) {
          $log.warn('dateparser:', 'baseDate is not a valid date');
        }
        fields = { year: 1900, month: 0, date: 1, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
      }

      for (var i = 1, n = results.length; i < n; i++) {
        var mapper = map[i-1];
        if (mapper.apply) {
          mapper.apply.call(fields, results[i]);
        }
      }

      if (isValid(fields.year, fields.month, fields.date)) {
        dt = new Date(fields.year, fields.month, fields.date,
          fields.hours, fields.minutes, fields.seconds,
          fields.milliseconds || 0);
      }

      return dt;
    }
  };

  // Check if date is valid for specific month (and year for February).
  // Month: 0 = Jan, 1 = Feb, etc
  function isValid(year, month, date) {
    if (date < 1) {
      return false;
    }

    if (month === 1 && date > 28) {
      return date === 29 && ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0);
    }

    if (month === 3 || month === 5 || month === 8 || month === 10) {
      return date < 31;
    }

    return true;
  }
}]);

angular.module('ui.bootstrap.position', [])

/**
 * A set of utility methods that can be use to retrieve position of DOM elements.
 * It is meant to be used where we need to absolute-position DOM elements in
 * relation to other, existing elements (this is the case for tooltips, popovers,
 * typeahead suggestions etc.).
 */
  .factory('$position', ['$document', '$window', function($document, $window) {
    function getStyle(el, cssprop) {
      if (el.currentStyle) { //IE
        return el.currentStyle[cssprop];
      } else if ($window.getComputedStyle) {
        return $window.getComputedStyle(el)[cssprop];
      }
      // finally try and get inline style
      return el.style[cssprop];
    }

    /**
     * Checks if a given element is statically positioned
     * @param element - raw DOM element
     */
    function isStaticPositioned(element) {
      return (getStyle(element, 'position') || 'static' ) === 'static';
    }

    /**
     * returns the closest, non-statically positioned parentOffset of a given element
     * @param element
     */
    var parentOffsetEl = function(element) {
      var docDomEl = $document[0];
      var offsetParent = element.offsetParent || docDomEl;
      while (offsetParent && offsetParent !== docDomEl && isStaticPositioned(offsetParent) ) {
        offsetParent = offsetParent.offsetParent;
      }
      return offsetParent || docDomEl;
    };

    return {
      /**
       * Provides read-only equivalent of jQuery's position function:
       * http://api.jquery.com/position/
       */
      position: function(element) {
        var elBCR = this.offset(element);
        var offsetParentBCR = { top: 0, left: 0 };
        var offsetParentEl = parentOffsetEl(element[0]);
        if (offsetParentEl != $document[0]) {
          offsetParentBCR = this.offset(angular.element(offsetParentEl));
          offsetParentBCR.top += offsetParentEl.clientTop - offsetParentEl.scrollTop;
          offsetParentBCR.left += offsetParentEl.clientLeft - offsetParentEl.scrollLeft;
        }

        var boundingClientRect = element[0].getBoundingClientRect();
        return {
          width: boundingClientRect.width || element.prop('offsetWidth'),
          height: boundingClientRect.height || element.prop('offsetHeight'),
          top: elBCR.top - offsetParentBCR.top,
          left: elBCR.left - offsetParentBCR.left
        };
      },

      /**
       * Provides read-only equivalent of jQuery's offset function:
       * http://api.jquery.com/offset/
       */
      offset: function(element) {
        var boundingClientRect = element[0].getBoundingClientRect();
        return {
          width: boundingClientRect.width || element.prop('offsetWidth'),
          height: boundingClientRect.height || element.prop('offsetHeight'),
          top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
          left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
        };
      },

      /**
       * Provides coordinates for the targetEl in relation to hostEl
       */
      positionElements: function(hostEl, targetEl, positionStr, appendToBody) {
        var positionStrParts = positionStr.split('-');
        var pos0 = positionStrParts[0], pos1 = positionStrParts[1] || 'center';

        var hostElPos,
          targetElWidth,
          targetElHeight,
          targetElPos;

        hostElPos = appendToBody ? this.offset(hostEl) : this.position(hostEl);

        targetElWidth = targetEl.prop('offsetWidth');
        targetElHeight = targetEl.prop('offsetHeight');

        var shiftWidth = {
          center: function() {
            return hostElPos.left + hostElPos.width / 2 - targetElWidth / 2;
          },
          left: function() {
            return hostElPos.left;
          },
          right: function() {
            return hostElPos.left + hostElPos.width;
          }
        };

        var shiftHeight = {
          center: function() {
            return hostElPos.top + hostElPos.height / 2 - targetElHeight / 2;
          },
          top: function() {
            return hostElPos.top;
          },
          bottom: function() {
            return hostElPos.top + hostElPos.height;
          }
        };

        switch (pos0) {
          case 'right':
            targetElPos = {
              top: shiftHeight[pos1](),
              left: shiftWidth[pos0]()
            };
            break;
          case 'left':
            targetElPos = {
              top: shiftHeight[pos1](),
              left: hostElPos.left - targetElWidth
            };
            break;
          case 'bottom':
            targetElPos = {
              top: shiftHeight[pos0](),
              left: shiftWidth[pos1]()
            };
            break;
          default:
            targetElPos = {
              top: hostElPos.top - targetElHeight,
              left: shiftWidth[pos1]()
            };
            break;
        }

        return targetElPos;
      }
    };
  }]);

angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.position'])

.value('$datepickerSuppressError', false)

.constant('datepickerConfig', {
  formatDay: 'dd',
  formatMonth: 'MMMM',
  formatYear: 'yyyy',
  formatDayHeader: 'EEE',
  formatDayTitle: 'MMMM yyyy',
  formatMonthTitle: 'yyyy',
  datepickerMode: 'day',
  minMode: 'day',
  maxMode: 'year',
  showWeeks: true,
  startingDay: 0,
  yearRange: 20,
  minDate: null,
  maxDate: null,
  shortcutPropagation: false
})

.controller('DatepickerController', ['$scope', '$attrs', '$parse', '$interpolate', '$log', 'dateFilter', 'datepickerConfig', '$datepickerSuppressError', function($scope, $attrs, $parse, $interpolate, $log, dateFilter, datepickerConfig, $datepickerSuppressError) {
  var self = this,
      ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl;

  // Modes chain
  this.modes = ['day', 'month', 'year'];

  // Configuration attributes
  angular.forEach(['formatDay', 'formatMonth', 'formatYear', 'formatDayHeader', 'formatDayTitle', 'formatMonthTitle',
                   'showWeeks', 'startingDay', 'yearRange', 'shortcutPropagation'], function(key, index) {
    self[key] = angular.isDefined($attrs[key]) ? (index < 6 ? $interpolate($attrs[key])($scope.$parent) : $scope.$parent.$eval($attrs[key])) : datepickerConfig[key];
  });

  // Watchable date attributes
  angular.forEach(['minDate', 'maxDate'], function(key) {
    if ($attrs[key]) {
      $scope.$parent.$watch($parse($attrs[key]), function(value) {
        self[key] = value ? new Date(value) : null;
        self.refreshView();
      });
    } else {
      self[key] = datepickerConfig[key] ? new Date(datepickerConfig[key]) : null;
    }
  });

  angular.forEach(['minMode', 'maxMode'], function(key) {
    if ($attrs[key]) {
      $scope.$parent.$watch($parse($attrs[key]), function(value) {
        self[key] = angular.isDefined(value) ? value : $attrs[key];
        $scope[key] = self[key];
        if ((key == 'minMode' && self.modes.indexOf($scope.datepickerMode) < self.modes.indexOf(self[key])) || (key == 'maxMode' && self.modes.indexOf($scope.datepickerMode) > self.modes.indexOf(self[key]))) {
          $scope.datepickerMode = self[key];
        }
      });
    } else {
      self[key] = datepickerConfig[key] || null;
      $scope[key] = self[key];
    }
  });

  $scope.datepickerMode = $scope.datepickerMode || datepickerConfig.datepickerMode;
  $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);

  if (angular.isDefined($attrs.initDate)) {
    this.activeDate = $scope.$parent.$eval($attrs.initDate) || new Date();
    $scope.$parent.$watch($attrs.initDate, function(initDate) {
      if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
        self.activeDate = initDate;
        self.refreshView();
      }
    });
  } else {
    this.activeDate = new Date();
  }

  $scope.isActive = function(dateObject) {
    if (self.compare(dateObject.date, self.activeDate) === 0) {
      $scope.activeDateId = dateObject.uid;
      return true;
    }
    return false;
  };

  this.init = function(ngModelCtrl_) {
    ngModelCtrl = ngModelCtrl_;

    ngModelCtrl.$render = function() {
      self.render();
    };
  };

  this.render = function() {
    if (ngModelCtrl.$viewValue) {
      var date = new Date(ngModelCtrl.$viewValue),
          isValid = !isNaN(date);

      if (isValid) {
        this.activeDate = date;
      } else if (!$datepickerSuppressError) {
        $log.error('Datepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
      }
    }
    this.refreshView();
  };

  this.refreshView = function() {
    if (this.element) {
      this._refreshView();

      var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
      ngModelCtrl.$setValidity('dateDisabled', !date || (this.element && !this.isDisabled(date)));
    }
  };

  this.createDateObject = function(date, format) {
    var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
    return {
      date: date,
      label: dateFilter(date, format),
      selected: model && this.compare(date, model) === 0,
      disabled: this.isDisabled(date),
      current: this.compare(date, new Date()) === 0,
      customClass: this.customClass(date)
    };
  };

  this.isDisabled = function(date) {
    return ((this.minDate && this.compare(date, this.minDate) < 0) || (this.maxDate && this.compare(date, this.maxDate) > 0) || ($attrs.dateDisabled && $scope.dateDisabled({date: date, mode: $scope.datepickerMode})));
  };

  this.customClass = function(date) {
    return $scope.customClass({date: date, mode: $scope.datepickerMode});
  };

  // Split array into smaller arrays
  this.split = function(arr, size) {
    var arrays = [];
    while (arr.length > 0) {
      arrays.push(arr.splice(0, size));
    }
    return arrays;
  };

  // Fix a hard-reprodusible bug with timezones
  // The bug depends on OS, browser, current timezone and current date
  // i.e.
  // var date = new Date(2014, 0, 1);
  // console.log(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours());
  // can result in "2013 11 31 23" because of the bug.
  this.fixTimeZone = function(date) {
    var hours = date.getHours();
    date.setHours(hours === 23 ? hours + 2 : 0);
  };

  $scope.select = function(date) {
    if ($scope.datepickerMode === self.minMode) {
      var dt = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : new Date(0, 0, 0, 0, 0, 0, 0);
      dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
      ngModelCtrl.$setViewValue(dt);
      ngModelCtrl.$render();
    } else {
      self.activeDate = date;
      $scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) - 1];
    }
  };

  $scope.move = function(direction) {
    var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
        month = self.activeDate.getMonth() + direction * (self.step.months || 0);
    self.activeDate.setFullYear(year, month, 1);
    self.refreshView();
  };

  $scope.toggleMode = function(direction) {
    direction = direction || 1;

    if (($scope.datepickerMode === self.maxMode && direction === 1) || ($scope.datepickerMode === self.minMode && direction === -1)) {
      return;
    }

    $scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) + direction];
  };

  // Key event mapper
  $scope.keys = { 13: 'enter', 32: 'space', 33: 'pageup', 34: 'pagedown', 35: 'end', 36: 'home', 37: 'left', 38: 'up', 39: 'right', 40: 'down' };

  var focusElement = function() {
    self.element[0].focus();
  };

  // Listen for focus requests from popup directive
  $scope.$on('datepicker.focus', focusElement);

  $scope.keydown = function(evt) {
    var key = $scope.keys[evt.which];

    if (!key || evt.shiftKey || evt.altKey) {
      return;
    }

    evt.preventDefault();
    if (!self.shortcutPropagation) {
      evt.stopPropagation();
    }

    if (key === 'enter' || key === 'space') {
      if (self.isDisabled(self.activeDate)) {
        return; // do nothing
      }
      $scope.select(self.activeDate);
      focusElement();
    } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
      $scope.toggleMode(key === 'up' ? 1 : -1);
      focusElement();
    } else {
      self.handleKeyDown(key, evt);
      self.refreshView();
    }
  };
}])

.directive('datepicker', function() {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'template/datepicker/datepicker.html';
    },
    scope: {
      datepickerMode: '=?',
      dateDisabled: '&',
      customClass: '&',
      shortcutPropagation: '&?'
    },
    require: ['datepicker', '^ngModel'],
    controller: 'DatepickerController',
    controllerAs: 'datepicker',
    link: function(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      datepickerCtrl.init(ngModelCtrl);
    }
  };
})

.directive('daypicker', ['dateFilter', function(dateFilter) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'template/datepicker/day.html',
    require: '^datepicker',
    link: function(scope, element, attrs, ctrl) {
      scope.showWeeks = ctrl.showWeeks;

      ctrl.step = { months: 1 };
      ctrl.element = element;

      var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      function getDaysInMonth(year, month) {
        return ((month === 1) && (year % 4 === 0) && ((year % 100 !== 0) || (year % 400 === 0))) ? 29 : DAYS_IN_MONTH[month];
      }

      function getDates(startDate, n) {
        var dates = new Array(n), current = new Date(startDate), i = 0, date;
        while (i < n) {
          date = new Date(current);
          ctrl.fixTimeZone(date);
          dates[i++] = date;
          current.setDate(current.getDate() + 1);
        }
        return dates;
      }

      ctrl._refreshView = function() {
        var year = ctrl.activeDate.getFullYear(),
          month = ctrl.activeDate.getMonth(),
          firstDayOfMonth = new Date(year, month, 1),
          difference = ctrl.startingDay - firstDayOfMonth.getDay(),
          numDisplayedFromPreviousMonth = (difference > 0) ? 7 - difference : - difference,
          firstDate = new Date(firstDayOfMonth);

        if (numDisplayedFromPreviousMonth > 0) {
          firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
        }

        // 42 is the number of days on a six-month calendar
        var days = getDates(firstDate, 42);
        for (var i = 0; i < 42; i ++) {
          days[i] = angular.extend(ctrl.createDateObject(days[i], ctrl.formatDay), {
            secondary: days[i].getMonth() !== month,
            uid: scope.uniqueId + '-' + i
          });
        }

        scope.labels = new Array(7);
        for (var j = 0; j < 7; j++) {
          scope.labels[j] = {
            abbr: dateFilter(days[j].date, ctrl.formatDayHeader),
            full: dateFilter(days[j].date, 'EEEE')
          };
        }

        scope.title = dateFilter(ctrl.activeDate, ctrl.formatDayTitle);
        scope.rows = ctrl.split(days, 7);

        if (scope.showWeeks) {
          scope.weekNumbers = [];
          var thursdayIndex = (4 + 7 - ctrl.startingDay) % 7,
              numWeeks = scope.rows.length;
          for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
            scope.weekNumbers.push(
              getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));
          }
        }
      };

      ctrl.compare = function(date1, date2) {
        return (new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate()));
      };

      function getISO8601WeekNumber(date) {
        var checkDate = new Date(date);
        checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
        var time = checkDate.getTime();
        checkDate.setMonth(0); // Compare with Jan 1
        checkDate.setDate(1);
        return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
      }

      ctrl.handleKeyDown = function(key, evt) {
        var date = ctrl.activeDate.getDate();

        if (key === 'left') {
          date = date - 1;   // up
        } else if (key === 'up') {
          date = date - 7;   // down
        } else if (key === 'right') {
          date = date + 1;   // down
        } else if (key === 'down') {
          date = date + 7;
        } else if (key === 'pageup' || key === 'pagedown') {
          var month = ctrl.activeDate.getMonth() + (key === 'pageup' ? - 1 : 1);
          ctrl.activeDate.setMonth(month, 1);
          date = Math.min(getDaysInMonth(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth()), date);
        } else if (key === 'home') {
          date = 1;
        } else if (key === 'end') {
          date = getDaysInMonth(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth());
        }
        ctrl.activeDate.setDate(date);
      };

      ctrl.refreshView();
    }
  };
}])

.directive('monthpicker', ['dateFilter', function(dateFilter) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'template/datepicker/month.html',
    require: '^datepicker',
    link: function(scope, element, attrs, ctrl) {
      ctrl.step = { years: 1 };
      ctrl.element = element;

      ctrl._refreshView = function() {
        var months = new Array(12),
            year = ctrl.activeDate.getFullYear(),
            date;

        for (var i = 0; i < 12; i++) {
          date = new Date(year, i, 1);
          ctrl.fixTimeZone(date);
          months[i] = angular.extend(ctrl.createDateObject(date, ctrl.formatMonth), {
            uid: scope.uniqueId + '-' + i
          });
        }

        scope.title = dateFilter(ctrl.activeDate, ctrl.formatMonthTitle);
        scope.rows = ctrl.split(months, 3);
      };

      ctrl.compare = function(date1, date2) {
        return new Date(date1.getFullYear(), date1.getMonth()) - new Date(date2.getFullYear(), date2.getMonth());
      };

      ctrl.handleKeyDown = function(key, evt) {
        var date = ctrl.activeDate.getMonth();

        if (key === 'left') {
          date = date - 1;   // up
        } else if (key === 'up') {
          date = date - 3;   // down
        } else if (key === 'right') {
          date = date + 1;   // down
        } else if (key === 'down') {
          date = date + 3;
        } else if (key === 'pageup' || key === 'pagedown') {
          var year = ctrl.activeDate.getFullYear() + (key === 'pageup' ? - 1 : 1);
          ctrl.activeDate.setFullYear(year);
        } else if (key === 'home') {
          date = 0;
        } else if (key === 'end') {
          date = 11;
        }
        ctrl.activeDate.setMonth(date);
      };

      ctrl.refreshView();
    }
  };
}])

.directive('yearpicker', ['dateFilter', function(dateFilter) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'template/datepicker/year.html',
    require: '^datepicker',
    link: function(scope, element, attrs, ctrl) {
      var range = ctrl.yearRange;

      ctrl.step = { years: range };
      ctrl.element = element;

      function getStartingYear( year ) {
        return parseInt((year - 1) / range, 10) * range + 1;
      }

      ctrl._refreshView = function() {
        var years = new Array(range), date;

        for (var i = 0, start = getStartingYear(ctrl.activeDate.getFullYear()); i < range; i++) {
          date = new Date(start + i, 0, 1);
          ctrl.fixTimeZone(date);
          years[i] = angular.extend(ctrl.createDateObject(date, ctrl.formatYear), {
            uid: scope.uniqueId + '-' + i
          });
        }

        scope.title = [years[0].label, years[range - 1].label].join(' - ');
        scope.rows = ctrl.split(years, 5);
      };

      ctrl.compare = function(date1, date2) {
        return date1.getFullYear() - date2.getFullYear();
      };

      ctrl.handleKeyDown = function(key, evt) {
        var date = ctrl.activeDate.getFullYear();

        if (key === 'left') {
          date = date - 1;   // up
        } else if (key === 'up') {
          date = date - 5;   // down
        } else if (key === 'right') {
          date = date + 1;   // down
        } else if (key === 'down') {
          date = date + 5;
        } else if (key === 'pageup' || key === 'pagedown') {
          date += (key === 'pageup' ? - 1 : 1) * ctrl.step.years;
        } else if (key === 'home') {
          date = getStartingYear(ctrl.activeDate.getFullYear());
        } else if (key === 'end') {
          date = getStartingYear(ctrl.activeDate.getFullYear()) + range - 1;
        }
        ctrl.activeDate.setFullYear(date);
      };

      ctrl.refreshView();
    }
  };
}])

.constant('datepickerPopupConfig', {
  datepickerPopup: 'yyyy-MM-dd',
  datepickerPopupTemplateUrl: 'template/datepicker/popup.html',
  datepickerTemplateUrl: 'template/datepicker/datepicker.html',
  html5Types: {
    date: 'yyyy-MM-dd',
    'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
    'month': 'yyyy-MM'
  },
  currentText: 'Today',
  clearText: 'Clear',
  closeText: 'Done',
  closeOnDateSelection: true,
  appendToBody: false,
  showButtonBar: true,
  onOpenFocus: true
})

.directive('datepickerPopup', ['$compile', '$parse', '$document', '$rootScope', '$position', 'dateFilter', 'dateParser', 'datepickerPopupConfig', '$timeout',
function($compile, $parse, $document, $rootScope, $position, dateFilter, dateParser, datepickerPopupConfig, $timeout) {
  return {
    restrict: 'EA',
    require: 'ngModel',
    scope: {
      isOpen: '=?',
      currentText: '@',
      clearText: '@',
      closeText: '@',
      dateDisabled: '&',
      customClass: '&'
    },
    link: function(scope, element, attrs, ngModel) {
      var dateFormat,
          closeOnDateSelection = angular.isDefined(attrs.closeOnDateSelection) ? scope.$parent.$eval(attrs.closeOnDateSelection) : datepickerPopupConfig.closeOnDateSelection,
          appendToBody = angular.isDefined(attrs.datepickerAppendToBody) ? scope.$parent.$eval(attrs.datepickerAppendToBody) : datepickerPopupConfig.appendToBody,
          onOpenFocus = angular.isDefined(attrs.onOpenFocus) ? scope.$parent.$eval(attrs.onOpenFocus) : datepickerPopupConfig.onOpenFocus,
          datepickerPopupTemplateUrl = angular.isDefined(attrs.datepickerPopupTemplateUrl) ? attrs.datepickerPopupTemplateUrl : datepickerPopupConfig.datepickerPopupTemplateUrl,
          datepickerTemplateUrl = angular.isDefined(attrs.datepickerTemplateUrl) ? attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl,
          cache = {};

      scope.showButtonBar = angular.isDefined(attrs.showButtonBar) ? scope.$parent.$eval(attrs.showButtonBar) : datepickerPopupConfig.showButtonBar;

      scope.getText = function(key) {
        return scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
      };

      scope.isDisabled = function(date) {
        if (date === 'today') {
          date = new Date();
        }

        return ((scope.watchData.minDate && scope.compare(date, cache.minDate) < 0) ||
          (scope.watchData.maxDate && scope.compare(date, cache.maxDate) > 0));
      };

      scope.compare = function(date1, date2) {
        return (new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate()));
      };

      var isHtml5DateInput = false;
      if (datepickerPopupConfig.html5Types[attrs.type]) {
        dateFormat = datepickerPopupConfig.html5Types[attrs.type];
        isHtml5DateInput = true;
      } else {
        dateFormat = attrs.datepickerPopup || datepickerPopupConfig.datepickerPopup;
        attrs.$observe('datepickerPopup', function(value, oldValue) {
            var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
            // Invalidate the $modelValue to ensure that formatters re-run
            // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
            if (newDateFormat !== dateFormat) {
              dateFormat = newDateFormat;
              ngModel.$modelValue = null;

              if (!dateFormat) {
                throw new Error('datepickerPopup must have a date format specified.');
              }
            }
        });
      }

      if (!dateFormat) {
        throw new Error('datepickerPopup must have a date format specified.');
      }

      if (isHtml5DateInput && attrs.datepickerPopup) {
        throw new Error('HTML5 date input types do not support custom formats.');
      }

      // popup element used to display calendar
      var popupEl = angular.element('<div datepicker-popup-wrap><div datepicker></div></div>');
      popupEl.attr({
        'ng-model': 'date',
        'ng-change': 'dateSelection(date)',
        'template-url': datepickerPopupTemplateUrl
      });

      function cameltoDash(string) {
        return string.replace(/([A-Z])/g, function($1) { return '-' + $1.toLowerCase(); });
      }

      // datepicker element
      var datepickerEl = angular.element(popupEl.children()[0]);
      datepickerEl.attr('template-url', datepickerTemplateUrl);

      if (isHtml5DateInput) {
        if (attrs.type === 'month') {
          datepickerEl.attr('datepicker-mode', '"month"');
          datepickerEl.attr('min-mode', 'month');
        }
      }

      if (attrs.datepickerOptions) {
        var options = scope.$parent.$eval(attrs.datepickerOptions);
        if (options && options.initDate) {
          scope.initDate = options.initDate;
          datepickerEl.attr('init-date', 'initDate');
          delete options.initDate;
        }
        angular.forEach(options, function(value, option) {
          datepickerEl.attr( cameltoDash(option), value );
        });
      }

      scope.watchData = {};
      angular.forEach(['minMode', 'maxMode', 'minDate', 'maxDate', 'datepickerMode', 'initDate', 'shortcutPropagation'], function(key) {
        if (attrs[key]) {
          var getAttribute = $parse(attrs[key]);
          scope.$parent.$watch(getAttribute, function(value) {
            scope.watchData[key] = value;
            if (key === 'minDate' || key === 'maxDate') {
              cache[key] = new Date(value);
            }
          });
          datepickerEl.attr(cameltoDash(key), 'watchData.' + key);

          // Propagate changes from datepicker to outside
          if (key === 'datepickerMode') {
            var setAttribute = getAttribute.assign;
            scope.$watch('watchData.' + key, function(value, oldvalue) {
              if (angular.isFunction(setAttribute) && value !== oldvalue) {
                setAttribute(scope.$parent, value);
              }
            });
          }
        }
      });
      if (attrs.dateDisabled) {
        datepickerEl.attr('date-disabled', 'dateDisabled({ date: date, mode: mode })');
      }

      if (attrs.showWeeks) {
        datepickerEl.attr('show-weeks', attrs.showWeeks);
      }

      if (attrs.customClass) {
        datepickerEl.attr('custom-class', 'customClass({ date: date, mode: mode })');
      }

      function parseDate(viewValue) {
        if (angular.isNumber(viewValue)) {
          // presumably timestamp to date object
          viewValue = new Date(viewValue);
        }

        if (!viewValue) {
          return null;
        } else if (angular.isDate(viewValue) && !isNaN(viewValue)) {
          return viewValue;
        } else if (angular.isString(viewValue)) {
          var date = dateParser.parse(viewValue, dateFormat, scope.date);
          if (isNaN(date)) {
            return undefined;
          } else {
            return date;
          }
        } else {
          return undefined;
        }
      }

      function validator(modelValue, viewValue) {
        var value = modelValue || viewValue;

        if (!attrs.ngRequired && !value) {
          return true;
        }

        if (angular.isNumber(value)) {
          value = new Date(value);
        }
        if (!value) {
          return true;
        } else if (angular.isDate(value) && !isNaN(value)) {
          return true;
        } else if (angular.isString(value)) {
          var date = dateParser.parse(value, dateFormat);
          return !isNaN(date);
        } else {
          return false;
        }
      }

      if (!isHtml5DateInput) {
        // Internal API to maintain the correct ng-invalid-[key] class
        ngModel.$$parserName = 'date';
        ngModel.$validators.date = validator;
        ngModel.$parsers.unshift(parseDate);
        ngModel.$formatters.push(function(value) {
          scope.date = value;
          return ngModel.$isEmpty(value) ? value : dateFilter(value, dateFormat);
        });
      } else {
        ngModel.$formatters.push(function(value) {
          scope.date = value;
          return value;
        });
      }

      // Inner change
      scope.dateSelection = function(dt) {
        if (angular.isDefined(dt)) {
          scope.date = dt;
        }
        var date = scope.date ? dateFilter(scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
        element.val(date);
        ngModel.$setViewValue(date);

        if (closeOnDateSelection) {
          scope.isOpen = false;
          element[0].focus();
        }
      };

      // Detect changes in the view from the text box
      ngModel.$viewChangeListeners.push(function() {
        scope.date = dateParser.parse(ngModel.$viewValue, dateFormat, scope.date);
      });

      var documentClickBind = function(event) {
        if (scope.isOpen && !(element[0].contains(event.target) || popupEl[0].contains(event.target))) {
          scope.$apply(function() {
            scope.isOpen = false;
          });
        }
      };

      var inputKeydownBind = function(evt) {
        if (evt.which === 27 && scope.isOpen) {
          evt.preventDefault();
          evt.stopPropagation();
          scope.$apply(function() {
            scope.isOpen = false;
          });
          element[0].focus();
        } else if (evt.which === 40 && !scope.isOpen) {
          evt.preventDefault();
          evt.stopPropagation();
          scope.$apply(function() {
            scope.isOpen = true;
          });
        }
      };
      element.bind('keydown', inputKeydownBind);

      scope.keydown = function(evt) {
        if (evt.which === 27) {
          scope.isOpen = false;
          element[0].focus();
        }
      };

      scope.$watch('isOpen', function(value) {
        if (value) {
          scope.position = appendToBody ? $position.offset(element) : $position.position(element);
          scope.position.top = scope.position.top + element.prop('offsetHeight');

          $timeout(function() {
            if (onOpenFocus) {
              scope.$broadcast('datepicker.focus');
            }
            $document.bind('click', documentClickBind);
          }, 0, false);
        } else {
          $document.unbind('click', documentClickBind);
        }
      });

      scope.select = function(date) {
        if (date === 'today') {
          var today = new Date();
          if (angular.isDate(scope.date)) {
            date = new Date(scope.date);
            date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
          } else {
            date = new Date(today.setHours(0, 0, 0, 0));
          }
        }
        scope.dateSelection(date);
      };

      scope.close = function() {
        scope.isOpen = false;
        element[0].focus();
      };

      var $popup = $compile(popupEl)(scope);
      // Prevent jQuery cache memory leak (template is now redundant after linking)
      popupEl.remove();

      if (appendToBody) {
        $document.find('body').append($popup);
      } else {
        element.after($popup);
      }

      scope.$on('$destroy', function() {
        if (scope.isOpen === true) {
          if (!$rootScope.$$phase) {
            scope.$apply(function() {
              scope.isOpen = false;
            });
          }
        }

        $popup.remove();
        element.unbind('keydown', inputKeydownBind);
        $document.unbind('click', documentClickBind);
      });
    }
  };
}])

.directive('datepickerPopupWrap', function() {
  return {
    restrict:'EA',
    replace: true,
    transclude: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'template/datepicker/popup.html';
    }
  };
});

angular.module('ui.bootstrap.dropdown', ['ui.bootstrap.position'])

.constant('dropdownConfig', {
  openClass: 'open'
})

.service('dropdownService', ['$document', '$rootScope', function($document, $rootScope) {
  var openScope = null;

  this.open = function(dropdownScope) {
    if (!openScope) {
      $document.bind('click', closeDropdown);
      $document.bind('keydown', keybindFilter);
    }

    if (openScope && openScope !== dropdownScope) {
      openScope.isOpen = false;
    }

    openScope = dropdownScope;
  };

  this.close = function(dropdownScope) {
    if (openScope === dropdownScope) {
      openScope = null;
      $document.unbind('click', closeDropdown);
      $document.unbind('keydown', keybindFilter);
    }
  };

  var closeDropdown = function(evt) {
    // This method may still be called during the same mouse event that
    // unbound this event handler. So check openScope before proceeding.
    if (!openScope) { return; }

    if (evt && openScope.getAutoClose() === 'disabled')  { return ; }

    var toggleElement = openScope.getToggleElement();
    if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
      return;
    }

    var dropdownElement = openScope.getDropdownElement();
    if (evt && openScope.getAutoClose() === 'outsideClick' &&
      dropdownElement && dropdownElement[0].contains(evt.target)) {
      return;
    }

    openScope.isOpen = false;

    if (!$rootScope.$$phase) {
      openScope.$apply();
    }
  };

  var keybindFilter = function(evt) {
    if (evt.which === 27) {
      openScope.focusToggleElement();
      closeDropdown();
    } else if (openScope.isKeynavEnabled() && /(38|40)/.test(evt.which) && openScope.isOpen) {
      evt.preventDefault();
      evt.stopPropagation();
      openScope.focusDropdownEntry(evt.which);
    }
  };
}])

.controller('DropdownController', ['$scope', '$attrs', '$parse', 'dropdownConfig', 'dropdownService', '$animate', '$position', '$document', '$compile', '$templateRequest', function($scope, $attrs, $parse, dropdownConfig, dropdownService, $animate, $position, $document, $compile, $templateRequest) {
  var self = this,
    scope = $scope.$new(), // create a child scope so we are not polluting original one
    templateScope,
    openClass = dropdownConfig.openClass,
    getIsOpen,
    setIsOpen = angular.noop,
    toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
    appendToBody = false,
    keynavEnabled = false,
    selectedOption = null,
    body = $document.find('body');

  this.init = function(element) {
    self.$element = element;

    if ($attrs.isOpen) {
      getIsOpen = $parse($attrs.isOpen);
      setIsOpen = getIsOpen.assign;

      $scope.$watch(getIsOpen, function(value) {
        scope.isOpen = !!value;
      });
    }

    appendToBody = angular.isDefined($attrs.dropdownAppendToBody);
    keynavEnabled = angular.isDefined($attrs.keyboardNav);

    if (appendToBody && self.dropdownMenu) {
      body.append(self.dropdownMenu);
      body.addClass('dropdown');
      element.on('$destroy', function handleDestroyEvent() {
        self.dropdownMenu.remove();
      });
    }
  };

  this.toggle = function(open) {
    return scope.isOpen = arguments.length ? !!open : !scope.isOpen;
  };

  // Allow other directives to watch status
  this.isOpen = function() {
    return scope.isOpen;
  };

  scope.getToggleElement = function() {
    return self.toggleElement;
  };

  scope.getAutoClose = function() {
    return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
  };

  scope.getElement = function() {
    return self.$element;
  };

  scope.isKeynavEnabled = function() {
    return keynavEnabled;
  };

  scope.focusDropdownEntry = function(keyCode) {
    var elems = self.dropdownMenu ? //If append to body is used.
      (angular.element(self.dropdownMenu).find('a')) :
      (angular.element(self.$element).find('ul').eq(0).find('a'));

    switch (keyCode) {
      case (40): {
        if (!angular.isNumber(self.selectedOption)) {
          self.selectedOption = 0;
        } else {
          self.selectedOption = (self.selectedOption === elems.length -1 ?
            self.selectedOption :
            self.selectedOption + 1);
        }
        break;
      }
      case (38): {
        if (!angular.isNumber(self.selectedOption)) {
          self.selectedOption = elems.length - 1;
        } else {
          self.selectedOption = self.selectedOption === 0 ?
            0 : self.selectedOption - 1;
        }
        break;
      }
    }
    elems[self.selectedOption].focus();
  };

  scope.getDropdownElement = function() {
    return self.dropdownMenu;
  };

  scope.focusToggleElement = function() {
    if (self.toggleElement) {
      self.toggleElement[0].focus();
    }
  };

  scope.$watch('isOpen', function(isOpen, wasOpen) {
    if (appendToBody && self.dropdownMenu) {
      var pos = $position.positionElements(self.$element, self.dropdownMenu, 'bottom-left', true);
      var css = {
        top: pos.top + 'px',
        display: isOpen ? 'block' : 'none'
      };

      var rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
      if (!rightalign) {
        css.left = pos.left + 'px';
        css.right = 'auto';
      } else {
        css.left = 'auto';
        css.right = (window.innerWidth - (pos.left + self.$element.prop('offsetWidth'))) + 'px';
      }

      self.dropdownMenu.css(css);
    }

    var openContainer = appendToBody ? body : self.$element;

    $animate[isOpen ? 'addClass' : 'removeClass'](openContainer, openClass).then(function() {
      if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
        toggleInvoker($scope, { open: !!isOpen });
      }
    });

    if (isOpen) {
      if (self.dropdownMenuTemplateUrl) {
        $templateRequest(self.dropdownMenuTemplateUrl).then(function(tplContent) {
          templateScope = scope.$new();
          $compile(tplContent.trim())(templateScope, function(dropdownElement) {
            var newEl = dropdownElement;
            self.dropdownMenu.replaceWith(newEl);
            self.dropdownMenu = newEl;
          });
        });
      }

      scope.focusToggleElement();
      dropdownService.open(scope);
    } else {
      if (self.dropdownMenuTemplateUrl) {
        if (templateScope) {
          templateScope.$destroy();
        }
        var newEl = angular.element('<ul class="dropdown-menu"></ul>');
        self.dropdownMenu.replaceWith(newEl);
        self.dropdownMenu = newEl;
      }

      dropdownService.close(scope);
      self.selectedOption = null;
    }

    if (angular.isFunction(setIsOpen)) {
      setIsOpen($scope, isOpen);
    }
  });

  $scope.$on('$locationChangeSuccess', function() {
    if (scope.getAutoClose() !== 'disabled') {
      scope.isOpen = false;
    }
  });

  var offDestroy = $scope.$on('$destroy', function() {
    scope.$destroy();
  });
  scope.$on('$destroy', offDestroy);
}])

.directive('dropdown', function() {
  return {
    controller: 'DropdownController',
    link: function(scope, element, attrs, dropdownCtrl) {
      dropdownCtrl.init( element );
      element.addClass('dropdown');
    }
  };
})

.directive('dropdownMenu', function() {
  return {
    restrict: 'AC',
    require: '?^dropdown',
    link: function(scope, element, attrs, dropdownCtrl) {
      if (!dropdownCtrl) {
        return;
      }
      var tplUrl = attrs.templateUrl;
      if (tplUrl) {
        dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
      }
      if (!dropdownCtrl.dropdownMenu) {
        dropdownCtrl.dropdownMenu = element;
      }
    }
  };
})

.directive('keyboardNav', function() {
  return {
    restrict: 'A',
    require: '?^dropdown',
    link: function (scope, element, attrs, dropdownCtrl) {

      element.bind('keydown', function(e) {
        if ([38, 40].indexOf(e.which) !== -1) {
          e.preventDefault();
          e.stopPropagation();

          var elems = dropdownCtrl.dropdownMenu.find('a');

          switch (e.which) {
            case (40): { // Down
              if (!angular.isNumber(dropdownCtrl.selectedOption)) {
                dropdownCtrl.selectedOption = 0;
              } else {
                dropdownCtrl.selectedOption = dropdownCtrl.selectedOption === elems.length -1 ?
                  dropdownCtrl.selectedOption : dropdownCtrl.selectedOption + 1;
              }
              break;
            }
            case (38): { // Up
              if (!angular.isNumber(dropdownCtrl.selectedOption)) {
                dropdownCtrl.selectedOption = elems.length - 1;
              } else {
                dropdownCtrl.selectedOption = dropdownCtrl.selectedOption === 0 ?
                  0 : dropdownCtrl.selectedOption - 1;
              }
              break;
            }
          }
          elems[dropdownCtrl.selectedOption].focus();
        }
      });
    }
  };
})

.directive('dropdownToggle', function() {
  return {
    require: '?^dropdown',
    link: function(scope, element, attrs, dropdownCtrl) {
      if (!dropdownCtrl) {
        return;
      }

      element.addClass('dropdown-toggle');

      dropdownCtrl.toggleElement = element;

      var toggleDropdown = function(event) {
        event.preventDefault();

        if (!element.hasClass('disabled') && !attrs.disabled) {
          scope.$apply(function() {
            dropdownCtrl.toggle();
          });
        }
      };

      element.bind('click', toggleDropdown);

      // WAI-ARIA
      element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
      scope.$watch(dropdownCtrl.isOpen, function( isOpen ) {
        element.attr('aria-expanded', !!isOpen);
      });

      scope.$on('$destroy', function() {
        element.unbind('click', toggleDropdown);
      });
    }
  };
});

angular.module('ui.bootstrap.modal', [])

/**
 * A helper, internal data structure that acts as a map but also allows getting / removing
 * elements in the LIFO order
 */
  .factory('$$stackedMap', function() {
    return {
      createNew: function() {
        var stack = [];

        return {
          add: function(key, value) {
            stack.push({
              key: key,
              value: value
            });
          },
          get: function(key) {
            for (var i = 0; i < stack.length; i++) {
              if (key == stack[i].key) {
                return stack[i];
              }
            }
          },
          keys: function() {
            var keys = [];
            for (var i = 0; i < stack.length; i++) {
              keys.push(stack[i].key);
            }
            return keys;
          },
          top: function() {
            return stack[stack.length - 1];
          },
          remove: function(key) {
            var idx = -1;
            for (var i = 0; i < stack.length; i++) {
              if (key == stack[i].key) {
                idx = i;
                break;
              }
            }
            return stack.splice(idx, 1)[0];
          },
          removeTop: function() {
            return stack.splice(stack.length - 1, 1)[0];
          },
          length: function() {
            return stack.length;
          }
        };
      }
    };
  })

/**
 * A helper, internal data structure that stores all references attached to key
 */
  .factory('$$multiMap', function() {
    return {
      createNew: function() {
        var map = {};

        return {
          entries: function() {
            return Object.keys(map).map(function(key) {
              return {
                key: key,
                value: map[key]
              };
            });
          },
          get: function(key) {
            return map[key];
          },
          hasKey: function(key) {
            return !!map[key];
          },
          keys: function() {
            return Object.keys(map);
          },
          put: function(key, value) {
            if (!map[key]) {
              map[key] = [];
            }

            map[key].push(value);
          },
          remove: function(key, value) {
            var values = map[key];

            if (!values) {
              return;
            }

            var idx = values.indexOf(value);

            if (idx !== -1) {
              values.splice(idx, 1);
            }

            if (!values.length) {
              delete map[key];
            }
          }
        };
      }
    };
  })

/**
 * A helper directive for the $modal service. It creates a backdrop element.
 */
  .directive('modalBackdrop', [
           '$animate', '$injector', '$modalStack',
  function($animate ,  $injector,   $modalStack) {
    var $animateCss = null;

    if ($injector.has('$animateCss')) {
      $animateCss = $injector.get('$animateCss');
    }

    return {
      restrict: 'EA',
      replace: true,
      templateUrl: 'template/modal/backdrop.html',
      compile: function(tElement, tAttrs) {
        tElement.addClass(tAttrs.backdropClass);
        return linkFn;
      }
    };

    function linkFn(scope, element, attrs) {
      if (attrs.modalInClass) {
        if ($animateCss) {
          $animateCss(element, {
            addClass: attrs.modalInClass
          }).start();
        } else {
          $animate.addClass(element, attrs.modalInClass);
        }

        scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
          var done = setIsAsync();
          if ($animateCss) {
            $animateCss(element, {
              removeClass: attrs.modalInClass
            }).start().then(done);
          } else {
            $animate.removeClass(element, attrs.modalInClass).then(done);
          }
        });
      }
    }
  }])

  .directive('modalWindow', [
           '$modalStack', '$q', '$animate', '$injector',
  function($modalStack ,  $q ,  $animate,   $injector) {
    var $animateCss = null;

    if ($injector.has('$animateCss')) {
      $animateCss = $injector.get('$animateCss');
    }

    return {
      restrict: 'EA',
      scope: {
        index: '@'
      },
      replace: true,
      transclude: true,
      templateUrl: function(tElement, tAttrs) {
        return tAttrs.templateUrl || 'template/modal/window.html';
      },
      link: function(scope, element, attrs) {
        element.addClass(attrs.windowClass || '');
        scope.size = attrs.size;

        scope.close = function(evt) {
          var modal = $modalStack.getTop();
          if (modal && modal.value.backdrop && modal.value.backdrop !== 'static' && (evt.target === evt.currentTarget)) {
            evt.preventDefault();
            evt.stopPropagation();
            $modalStack.dismiss(modal.key, 'backdrop click');
          }
        };

        // This property is only added to the scope for the purpose of detecting when this directive is rendered.
        // We can detect that by using this property in the template associated with this directive and then use
        // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
        scope.$isRendered = true;

        // Deferred object that will be resolved when this modal is render.
        var modalRenderDeferObj = $q.defer();
        // Observe function will be called on next digest cycle after compilation, ensuring that the DOM is ready.
        // In order to use this way of finding whether DOM is ready, we need to observe a scope property used in modal's template.
        attrs.$observe('modalRender', function(value) {
          if (value == 'true') {
            modalRenderDeferObj.resolve();
          }
        });

        modalRenderDeferObj.promise.then(function() {
          var animationPromise = null;

          if (attrs.modalInClass) {
            if ($animateCss) {
              animationPromise = $animateCss(element, {
                addClass: attrs.modalInClass
              }).start();
            } else {
              animationPromise = $animate.addClass(element, attrs.modalInClass);
            }

            scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
              var done = setIsAsync();
              if ($animateCss) {
                $animateCss(element, {
                  removeClass: attrs.modalInClass
                }).start().then(done);
              } else {
                $animate.removeClass(element, attrs.modalInClass).then(done);
              }
            });
          }


          $q.when(animationPromise).then(function() {
            var inputsWithAutofocus = element[0].querySelectorAll('[autofocus]');
            /**
             * Auto-focusing of a freshly-opened modal element causes any child elements
             * with the autofocus attribute to lose focus. This is an issue on touch
             * based devices which will show and then hide the onscreen keyboard.
             * Attempts to refocus the autofocus element via JavaScript will not reopen
             * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
             * the modal element if the modal does not contain an autofocus element.
             */
            if (inputsWithAutofocus.length) {
              inputsWithAutofocus[0].focus();
            } else {
              element[0].focus();
            }
          });

          // Notify {@link $modalStack} that modal is rendered.
          var modal = $modalStack.getTop();
          if (modal) {
            $modalStack.modalRendered(modal.key);
          }
        });
      }
    };
  }])

  .directive('modalAnimationClass', [
    function () {
      return {
        compile: function(tElement, tAttrs) {
          if (tAttrs.modalAnimation) {
            tElement.addClass(tAttrs.modalAnimationClass);
          }
        }
      };
    }])

  .directive('modalTransclude', function() {
    return {
      link: function($scope, $element, $attrs, controller, $transclude) {
        $transclude($scope.$parent, function(clone) {
          $element.empty();
          $element.append(clone);
        });
      }
    };
  })

  .factory('$modalStack', [
             '$animate', '$timeout', '$document', '$compile', '$rootScope',
             '$q',
             '$injector',
             '$$multiMap',
             '$$stackedMap',
    function($animate ,  $timeout ,  $document ,  $compile ,  $rootScope ,
              $q,
              $injector,
              $$multiMap,
              $$stackedMap) {
      var $animateCss = null;

      if ($injector.has('$animateCss')) {
        $animateCss = $injector.get('$animateCss');
      }

      var OPENED_MODAL_CLASS = 'modal-open';

      var backdropDomEl, backdropScope;
      var openedWindows = $$stackedMap.createNew();
      var openedClasses = $$multiMap.createNew();
      var $modalStack = {
        NOW_CLOSING_EVENT: 'modal.stack.now-closing'
      };

      //Modal focus behavior
      var focusableElementList;
      var focusIndex = 0;
      var tababbleSelector = 'a[href], area[href], input:not([disabled]), ' +
        'button:not([disabled]),select:not([disabled]), textarea:not([disabled]), ' +
        'iframe, object, embed, *[tabindex], *[contenteditable=true]';

      function backdropIndex() {
        var topBackdropIndex = -1;
        var opened = openedWindows.keys();
        for (var i = 0; i < opened.length; i++) {
          if (openedWindows.get(opened[i]).value.backdrop) {
            topBackdropIndex = i;
          }
        }
        return topBackdropIndex;
      }

      $rootScope.$watch(backdropIndex, function(newBackdropIndex) {
        if (backdropScope) {
          backdropScope.index = newBackdropIndex;
        }
      });

      function removeModalWindow(modalInstance, elementToReceiveFocus) {
        var body = $document.find('body').eq(0);
        var modalWindow = openedWindows.get(modalInstance).value;

        //clean up the stack
        openedWindows.remove(modalInstance);

        removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function() {
          var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
          openedClasses.remove(modalBodyClass, modalInstance);
          body.toggleClass(modalBodyClass, openedClasses.hasKey(modalBodyClass));
        });
        checkRemoveBackdrop();

        //move focus to specified element if available, or else to body
        if (elementToReceiveFocus && elementToReceiveFocus.focus) {
          elementToReceiveFocus.focus();
        } else {
          body.focus();
        }
      }

      function checkRemoveBackdrop() {
          //remove backdrop if no longer needed
          if (backdropDomEl && backdropIndex() == -1) {
            var backdropScopeRef = backdropScope;
            removeAfterAnimate(backdropDomEl, backdropScope, function() {
              backdropScopeRef = null;
            });
            backdropDomEl = undefined;
            backdropScope = undefined;
          }
      }

      function removeAfterAnimate(domEl, scope, done) {
        var asyncDeferred;
        var asyncPromise = null;
        var setIsAsync = function() {
          if (!asyncDeferred) {
            asyncDeferred = $q.defer();
            asyncPromise = asyncDeferred.promise;
          }

          return function asyncDone() {
            asyncDeferred.resolve();
          };
        };
        scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);

        // Note that it's intentional that asyncPromise might be null.
        // That's when setIsAsync has not been called during the
        // NOW_CLOSING_EVENT broadcast.
        return $q.when(asyncPromise).then(afterAnimating);

        function afterAnimating() {
          if (afterAnimating.done) {
            return;
          }
          afterAnimating.done = true;

          if ($animateCss) {
            $animateCss(domEl, {
              event: 'leave'
            }).start().then(function() {
              domEl.remove();
            });
          } else {
            $animate.leave(domEl);
          }
          scope.$destroy();
          if (done) {
            done();
          }
        }
      }

      $document.bind('keydown', function(evt) {
        if (evt.isDefaultPrevented()) {
          return evt;
        }

        var modal = openedWindows.top();
        if (modal && modal.value.keyboard) {
          switch (evt.which){
            case 27: {
              evt.preventDefault();
              $rootScope.$apply(function() {
                $modalStack.dismiss(modal.key, 'escape key press');
              });
              break;
            }
            case 9: {
              $modalStack.loadFocusElementList(modal);
              var focusChanged = false;
              if (evt.shiftKey) {
                if ($modalStack.isFocusInFirstItem(evt)) {
                  focusChanged = $modalStack.focusLastFocusableElement();
                }
              } else {
                if ($modalStack.isFocusInLastItem(evt)) {
                  focusChanged = $modalStack.focusFirstFocusableElement();
                }
              }

              if (focusChanged) {
                evt.preventDefault();
                evt.stopPropagation();
              }
              break;
            }
          }
        }
      });

      $modalStack.open = function(modalInstance, modal) {
        var modalOpener = $document[0].activeElement,
          modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;

        openedWindows.add(modalInstance, {
          deferred: modal.deferred,
          renderDeferred: modal.renderDeferred,
          modalScope: modal.scope,
          backdrop: modal.backdrop,
          keyboard: modal.keyboard,
          openedClass: modal.openedClass
        });

        openedClasses.put(modalBodyClass, modalInstance);

        var body = $document.find('body').eq(0),
            currBackdropIndex = backdropIndex();

        if (currBackdropIndex >= 0 && !backdropDomEl) {
          backdropScope = $rootScope.$new(true);
          backdropScope.index = currBackdropIndex;
          var angularBackgroundDomEl = angular.element('<div modal-backdrop="modal-backdrop"></div>');
          angularBackgroundDomEl.attr('backdrop-class', modal.backdropClass);
          if (modal.animation) {
            angularBackgroundDomEl.attr('modal-animation', 'true');
          }
          backdropDomEl = $compile(angularBackgroundDomEl)(backdropScope);
          body.append(backdropDomEl);
        }

        var angularDomEl = angular.element('<div modal-window="modal-window"></div>');
        angularDomEl.attr({
          'template-url': modal.windowTemplateUrl,
          'window-class': modal.windowClass,
          'size': modal.size,
          'index': openedWindows.length() - 1,
          'animate': 'animate'
        }).html(modal.content);
        if (modal.animation) {
          angularDomEl.attr('modal-animation', 'true');
        }

        var modalDomEl = $compile(angularDomEl)(modal.scope);
        openedWindows.top().value.modalDomEl = modalDomEl;
        openedWindows.top().value.modalOpener = modalOpener;
        body.append(modalDomEl);
        body.addClass(modalBodyClass);

        $modalStack.clearFocusListCache();
      };

      function broadcastClosing(modalWindow, resultOrReason, closing) {
          return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
      }

      $modalStack.close = function(modalInstance, result) {
        var modalWindow = openedWindows.get(modalInstance);
        if (modalWindow && broadcastClosing(modalWindow, result, true)) {
          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
          modalWindow.value.deferred.resolve(result);
          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
          return true;
        }
        return !modalWindow;
      };

      $modalStack.dismiss = function(modalInstance, reason) {
        var modalWindow = openedWindows.get(modalInstance);
        if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
          modalWindow.value.deferred.reject(reason);
          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
          return true;
        }
        return !modalWindow;
      };

      $modalStack.dismissAll = function(reason) {
        var topModal = this.getTop();
        while (topModal && this.dismiss(topModal.key, reason)) {
          topModal = this.getTop();
        }
      };

      $modalStack.getTop = function() {
        return openedWindows.top();
      };

      $modalStack.modalRendered = function(modalInstance) {
        var modalWindow = openedWindows.get(modalInstance);
        if (modalWindow) {
          modalWindow.value.renderDeferred.resolve();
        }
      };

      $modalStack.focusFirstFocusableElement = function() {
        if (focusableElementList.length > 0) {
          focusableElementList[0].focus();
          return true;
        }
        return false;
      };
      $modalStack.focusLastFocusableElement = function() {
        if (focusableElementList.length > 0) {
          focusableElementList[focusableElementList.length - 1].focus();
          return true;
        }
        return false;
      };

      $modalStack.isFocusInFirstItem = function(evt) {
        if (focusableElementList.length > 0) {
          return (evt.target || evt.srcElement) == focusableElementList[0];
        }
        return false;
      };

      $modalStack.isFocusInLastItem = function(evt) {
        if (focusableElementList.length > 0) {
          return (evt.target || evt.srcElement) == focusableElementList[focusableElementList.length - 1];
        }
        return false;
      };

      $modalStack.clearFocusListCache = function() {
        focusableElementList = [];
        focusIndex = 0;
      };

      $modalStack.loadFocusElementList = function(modalWindow) {
        if (focusableElementList === undefined || !focusableElementList.length0) {
          if (modalWindow) {
            var modalDomE1 = modalWindow.value.modalDomEl;
            if (modalDomE1 && modalDomE1.length) {
              focusableElementList = modalDomE1[0].querySelectorAll(tababbleSelector);
            }
          }
        }
      };

      return $modalStack;
    }])

  .provider('$modal', function() {
    var $modalProvider = {
      options: {
        animation: true,
        backdrop: true, //can also be false or 'static'
        keyboard: true
      },
      $get: ['$injector', '$rootScope', '$q', '$templateRequest', '$controller', '$modalStack',
        function ($injector, $rootScope, $q, $templateRequest, $controller, $modalStack) {
          var $modal = {};

          function getTemplatePromise(options) {
            return options.template ? $q.when(options.template) :
              $templateRequest(angular.isFunction(options.templateUrl) ? (options.templateUrl)() : options.templateUrl);
          }

          function getResolvePromises(resolves) {
            var promisesArr = [];
            angular.forEach(resolves, function(value) {
              if (angular.isFunction(value) || angular.isArray(value)) {
                promisesArr.push($q.when($injector.invoke(value)));
              } else if (angular.isString(value)) {
                promisesArr.push($q.when($injector.get(value)));
              } else {
                promisesArr.push($q.when(value));
              }
            });
            return promisesArr;
          }

          var promiseChain = null;
          $modal.getPromiseChain = function() {
            return promiseChain;
          };

          $modal.open = function (modalOptions) {

            var modalResultDeferred = $q.defer();
            var modalOpenedDeferred = $q.defer();
            var modalRenderDeferred = $q.defer();

            //prepare an instance of a modal to be injected into controllers and returned to a caller
            var modalInstance = {
              result: modalResultDeferred.promise,
              opened: modalOpenedDeferred.promise,
              rendered: modalRenderDeferred.promise,
              close: function (result) {
                return $modalStack.close(modalInstance, result);
              },
              dismiss: function (reason) {
                return $modalStack.dismiss(modalInstance, reason);
              }
            };

            //merge and clean up options
            modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
            modalOptions.resolve = modalOptions.resolve || {};

            //verify options
            if (!modalOptions.template && !modalOptions.templateUrl) {
              throw new Error('One of template or templateUrl options is required.');
            }

            var templateAndResolvePromise =
              $q.all([getTemplatePromise(modalOptions)].concat(getResolvePromises(modalOptions.resolve)));

            // Wait for the resolution of the existing promise chain.
            // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
            // Then add to $modalStack and resolve opened.
            // Finally clean up the chain variable if no subsequent modal has overwritten it.
            var samePromise;
            samePromise = promiseChain = $q.all([promiseChain])
              .then(function() { return templateAndResolvePromise; }, function() { return templateAndResolvePromise; })
              .then(function resolveSuccess(tplAndVars) {

                var modalScope = (modalOptions.scope || $rootScope).$new();
                modalScope.$close = modalInstance.close;
                modalScope.$dismiss = modalInstance.dismiss;

                modalScope.$on('$destroy', function() {
                  if (!modalScope.$$uibDestructionScheduled) {
                    modalScope.$dismiss('$uibUnscheduledDestruction');
                  }
                });

                var ctrlInstance, ctrlLocals = {};
                var resolveIter = 1;

                //controllers
                if (modalOptions.controller) {
                  ctrlLocals.$scope = modalScope;
                  ctrlLocals.$modalInstance = modalInstance;
                  angular.forEach(modalOptions.resolve, function(value, key) {
                    ctrlLocals[key] = tplAndVars[resolveIter++];
                  });

                  ctrlInstance = $controller(modalOptions.controller, ctrlLocals);
                  if (modalOptions.controllerAs) {
                    if (modalOptions.bindToController) {
                      angular.extend(ctrlInstance, modalScope);
                    }

                    modalScope[modalOptions.controllerAs] = ctrlInstance;
                  }
                }

                $modalStack.open(modalInstance, {
                  scope: modalScope,
                  deferred: modalResultDeferred,
                  renderDeferred: modalRenderDeferred,
                  content: tplAndVars[0],
                  animation: modalOptions.animation,
                  backdrop: modalOptions.backdrop,
                  keyboard: modalOptions.keyboard,
                  backdropClass: modalOptions.backdropClass,
                  windowClass: modalOptions.windowClass,
                  windowTemplateUrl: modalOptions.windowTemplateUrl,
                  size: modalOptions.size,
                  openedClass: modalOptions.openedClass
                });
                modalOpenedDeferred.resolve(true);

            }, function resolveError(reason) {
              modalOpenedDeferred.reject(reason);
              modalResultDeferred.reject(reason);
            })
            .finally(function() {
              if (promiseChain === samePromise) {
                promiseChain = null;
              }
            });

            return modalInstance;
          };

          return $modal;
        }]
    };

    return $modalProvider;
  });

angular.module('ui.bootstrap.pagination', [])
.controller('PaginationController', ['$scope', '$attrs', '$parse', function($scope, $attrs, $parse) {
  var self = this,
      ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
      setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;

  this.init = function(ngModelCtrl_, config) {
    ngModelCtrl = ngModelCtrl_;
    this.config = config;

    ngModelCtrl.$render = function() {
      self.render();
    };

    if ($attrs.itemsPerPage) {
      $scope.$parent.$watch($parse($attrs.itemsPerPage), function(value) {
        self.itemsPerPage = parseInt(value, 10);
        $scope.totalPages = self.calculateTotalPages();
      });
    } else {
      this.itemsPerPage = config.itemsPerPage;
    }

    $scope.$watch('totalItems', function() {
      $scope.totalPages = self.calculateTotalPages();
    });

    $scope.$watch('totalPages', function(value) {
      setNumPages($scope.$parent, value); // Readonly variable

      if ( $scope.page > value ) {
        $scope.selectPage(value);
      } else {
        ngModelCtrl.$render();
      }
    });
  };

  this.calculateTotalPages = function() {
    var totalPages = this.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / this.itemsPerPage);
    return Math.max(totalPages || 0, 1);
  };

  this.render = function() {
    $scope.page = parseInt(ngModelCtrl.$viewValue, 10) || 1;
  };

  $scope.selectPage = function(page, evt) {
    if (evt) {
      evt.preventDefault();
    }

    var clickAllowed = !$scope.ngDisabled || !evt;
    if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
      if (evt && evt.target) {
        evt.target.blur();
      }
      ngModelCtrl.$setViewValue(page);
      ngModelCtrl.$render();
    }
  };

  $scope.getText = function(key) {
    return $scope[key + 'Text'] || self.config[key + 'Text'];
  };

  $scope.noPrevious = function() {
    return $scope.page === 1;
  };

  $scope.noNext = function() {
    return $scope.page === $scope.totalPages;
  };
}])

.constant('paginationConfig', {
  itemsPerPage: 10,
  boundaryLinks: false,
  directionLinks: true,
  firstText: 'First',
  previousText: 'Previous',
  nextText: 'Next',
  lastText: 'Last',
  rotate: true
})

.directive('pagination', ['$parse', 'paginationConfig', function($parse, paginationConfig) {
  return {
    restrict: 'EA',
    scope: {
      totalItems: '=',
      firstText: '@',
      previousText: '@',
      nextText: '@',
      lastText: '@',
      ngDisabled:'='
    },
    require: ['pagination', '?ngModel'],
    controller: 'PaginationController',
    controllerAs: 'pagination',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'template/pagination/pagination.html';
    },
    replace: true,
    link: function(scope, element, attrs, ctrls) {
      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      if (!ngModelCtrl) {
         return; // do nothing if no ng-model
      }

      // Setup configuration parameters
      var maxSize = angular.isDefined(attrs.maxSize) ? scope.$parent.$eval(attrs.maxSize) : paginationConfig.maxSize,
          rotate = angular.isDefined(attrs.rotate) ? scope.$parent.$eval(attrs.rotate) : paginationConfig.rotate;
      scope.boundaryLinks = angular.isDefined(attrs.boundaryLinks) ? scope.$parent.$eval(attrs.boundaryLinks) : paginationConfig.boundaryLinks;
      scope.directionLinks = angular.isDefined(attrs.directionLinks) ? scope.$parent.$eval(attrs.directionLinks) : paginationConfig.directionLinks;

      paginationCtrl.init(ngModelCtrl, paginationConfig);

      if (attrs.maxSize) {
        scope.$parent.$watch($parse(attrs.maxSize), function(value) {
          maxSize = parseInt(value, 10);
          paginationCtrl.render();
        });
      }

      // Create page object used in template
      function makePage(number, text, isActive) {
        return {
          number: number,
          text: text,
          active: isActive
        };
      }

      function getPages(currentPage, totalPages) {
        var pages = [];

        // Default page limits
        var startPage = 1, endPage = totalPages;
        var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;

        // recompute if maxSize
        if (isMaxSized) {
          if (rotate) {
            // Current page is displayed in the middle of the visible ones
            startPage = Math.max(currentPage - Math.floor(maxSize/2), 1);
            endPage   = startPage + maxSize - 1;

            // Adjust if limit is exceeded
            if (endPage > totalPages) {
              endPage   = totalPages;
              startPage = endPage - maxSize + 1;
            }
          } else {
            // Visible pages are paginated with maxSize
            startPage = ((Math.ceil(currentPage / maxSize) - 1) * maxSize) + 1;

            // Adjust last page if limit is exceeded
            endPage = Math.min(startPage + maxSize - 1, totalPages);
          }
        }

        // Add page number links
        for (var number = startPage; number <= endPage; number++) {
          var page = makePage(number, number, number === currentPage);
          pages.push(page);
        }

        // Add links to move between page sets
        if (isMaxSized && ! rotate) {
          if (startPage > 1) {
            var previousPageSet = makePage(startPage - 1, '...', false);
            pages.unshift(previousPageSet);
          }

          if (endPage < totalPages) {
            var nextPageSet = makePage(endPage + 1, '...', false);
            pages.push(nextPageSet);
          }
        }

        return pages;
      }

      var originalRender = paginationCtrl.render;
      paginationCtrl.render = function() {
        originalRender();
        if (scope.page > 0 && scope.page <= scope.totalPages) {
          scope.pages = getPages(scope.page, scope.totalPages);
        }
      };
    }
  };
}])

.constant('pagerConfig', {
  itemsPerPage: 10,
  previousText: '« Previous',
  nextText: 'Next »',
  align: true
})

.directive('pager', ['pagerConfig', function(pagerConfig) {
  return {
    restrict: 'EA',
    scope: {
      totalItems: '=',
      previousText: '@',
      nextText: '@',
      ngDisabled: '='
    },
    require: ['pager', '?ngModel'],
    controller: 'PaginationController',
    controllerAs: 'pagination',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'template/pagination/pager.html';
    },
    replace: true,
    link: function(scope, element, attrs, ctrls) {
      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      if (!ngModelCtrl) {
         return; // do nothing if no ng-model
      }

      scope.align = angular.isDefined(attrs.align) ? scope.$parent.$eval(attrs.align) : pagerConfig.align;
      paginationCtrl.init(ngModelCtrl, pagerConfig);
    }
  };
}]);

/**
 * The following features are still outstanding: animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, html tooltips, and selector delegation.
 */
angular.module('ui.bootstrap.tooltip', ['ui.bootstrap.position', 'ui.bootstrap.bindHtml'])

/**
 * The $tooltip service creates tooltip- and popover-like directives as well as
 * houses global options for them.
 */
.provider('$tooltip', function() {
  // The default options tooltip and popover.
  var defaultOptions = {
    placement: 'top',
    animation: true,
    popupDelay: 0,
    useContentExp: false
  };

  // Default hide triggers for each show trigger
  var triggerMap = {
    'mouseenter': 'mouseleave',
    'click': 'click',
    'focus': 'blur',
    'none': ''
  };

  // The options specified to the provider globally.
  var globalOptions = {};

  /**
   * `options({})` allows global configuration of all tooltips in the
   * application.
   *
   *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
   *     // place tooltips left instead of top by default
   *     $tooltipProvider.options( { placement: 'left' } );
   *   });
   */
	this.options = function(value) {
		angular.extend(globalOptions, value);
	};

  /**
   * This allows you to extend the set of trigger mappings available. E.g.:
   *
   *   $tooltipProvider.setTriggers( 'openTrigger': 'closeTrigger' );
   */
  this.setTriggers = function setTriggers(triggers) {
    angular.extend(triggerMap, triggers);
  };

  /**
   * This is a helper function for translating camel-case to snake-case.
   */
  function snake_case(name) {
    var regexp = /[A-Z]/g;
    var separator = '-';
    return name.replace(regexp, function(letter, pos) {
      return (pos ? separator : '') + letter.toLowerCase();
    });
  }

  /**
   * Returns the actual instance of the $tooltip service.
   * TODO support multiple triggers
   */
  this.$get = ['$window', '$compile', '$timeout', '$document', '$position', '$interpolate', '$rootScope', '$parse', function($window, $compile, $timeout, $document, $position, $interpolate, $rootScope, $parse) {
    return function $tooltip(type, prefix, defaultTriggerShow, options) {
      options = angular.extend({}, defaultOptions, globalOptions, options);

      /**
       * Returns an object of show and hide triggers.
       *
       * If a trigger is supplied,
       * it is used to show the tooltip; otherwise, it will use the `trigger`
       * option passed to the `$tooltipProvider.options` method; else it will
       * default to the trigger supplied to this directive factory.
       *
       * The hide trigger is based on the show trigger. If the `trigger` option
       * was passed to the `$tooltipProvider.options` method, it will use the
       * mapped trigger from `triggerMap` or the passed trigger if the map is
       * undefined; otherwise, it uses the `triggerMap` value of the show
       * trigger; else it will just use the show trigger.
       */
      function getTriggers(trigger) {
        var show = (trigger || options.trigger || defaultTriggerShow).split(' ');
        var hide = show.map(function(trigger) {
          return triggerMap[trigger] || trigger;
        });
        return {
          show: show,
          hide: hide
        };
      }

      var directiveName = snake_case(type);

      var startSym = $interpolate.startSymbol();
      var endSym = $interpolate.endSymbol();
      var template =
        '<div '+ directiveName +'-popup '+
          'title="'+startSym+'title'+endSym+'" '+
          (options.useContentExp ?
            'content-exp="contentExp()" ' :
            'content="'+startSym+'content'+endSym+'" ') +
          'placement="'+startSym+'placement'+endSym+'" '+
          'popup-class="'+startSym+'popupClass'+endSym+'" '+
          'animation="animation" '+
          'is-open="isOpen"'+
          'origin-scope="origScope" '+
          '>'+
        '</div>';

      return {
        restrict: 'EA',
        compile: function(tElem, tAttrs) {
          var tooltipLinker = $compile( template );

          return function link(scope, element, attrs, tooltipCtrl) {
            var tooltip;
            var tooltipLinkedScope;
            var transitionTimeout;
            var popupTimeout;
            var positionTimeout;
            var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
            var triggers = getTriggers(undefined);
            var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
            var ttScope = scope.$new(true);
            var repositionScheduled = false;
            var isOpenExp = angular.isDefined(attrs[prefix + 'IsOpen']) ? $parse(attrs[prefix + 'IsOpen']) : false;

            var positionTooltip = function() {
              if (!tooltip) { return; }

              if (!positionTimeout) {
                positionTimeout = $timeout(function() {
                  // Reset the positioning and box size for correct width and height values.
                  tooltip.css({ top: 0, left: 0, width: 'auto', height: 'auto' });

                  var ttBox = $position.position(tooltip);
                  var ttCss = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
                  ttCss.top += 'px';
                  ttCss.left += 'px';

                  ttCss.width = ttBox.width + 'px';
                  ttCss.height = ttBox.height + 'px';

                  // Now set the calculated positioning and size.
                  tooltip.css(ttCss);

                  positionTimeout = null;

                }, 0, false);
              }
            };

            // Set up the correct scope to allow transclusion later
            ttScope.origScope = scope;

            // By default, the tooltip is not open.
            // TODO add ability to start tooltip opened
            ttScope.isOpen = false;

            function toggleTooltipBind() {
              if (!ttScope.isOpen) {
                showTooltipBind();
              } else {
                hideTooltipBind();
              }
            }

            // Show the tooltip with delay if specified, otherwise show it immediately
            function showTooltipBind() {
              if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
                return;
              }

              prepareTooltip();

              if (ttScope.popupDelay) {
                // Do nothing if the tooltip was already scheduled to pop-up.
                // This happens if show is triggered multiple times before any hide is triggered.
                if (!popupTimeout) {
                  popupTimeout = $timeout(show, ttScope.popupDelay, false);
                }
              } else {
                show();
              }
            }

            function hideTooltipBind () {
              hide();
              if (!$rootScope.$$phase) {
                $rootScope.$digest();
              }
            }

            // Show the tooltip popup element.
            function show() {
              popupTimeout = null;

              // If there is a pending remove transition, we must cancel it, lest the
              // tooltip be mysteriously removed.
              if (transitionTimeout) {
                $timeout.cancel(transitionTimeout);
                transitionTimeout = null;
              }

              // Don't show empty tooltips.
              if (!(options.useContentExp ? ttScope.contentExp() : ttScope.content)) {
                return angular.noop;
              }

              createTooltip();

              // And show the tooltip.
              ttScope.isOpen = true;
              if (isOpenExp) {
                isOpenExp.assign(ttScope.origScope, ttScope.isOpen);
              }

              if (!$rootScope.$$phase) {
                ttScope.$apply(); // digest required as $apply is not called
              }

              tooltip.css({ display: 'block' });

              positionTooltip();
            }

            // Hide the tooltip popup element.
            function hide() {
              // First things first: we don't show it anymore.
              ttScope.isOpen = false;
              if (isOpenExp) {
                isOpenExp.assign(ttScope.origScope, ttScope.isOpen);
              }

              //if tooltip is going to be shown after delay, we must cancel this
              $timeout.cancel(popupTimeout);
              popupTimeout = null;

              $timeout.cancel(positionTimeout);
              positionTimeout = null;

              // And now we remove it from the DOM. However, if we have animation, we
              // need to wait for it to expire beforehand.
              // FIXME: this is a placeholder for a port of the transitions library.
              if (ttScope.animation) {
                if (!transitionTimeout) {
                  transitionTimeout = $timeout(removeTooltip, 500);
                }
              } else {
                removeTooltip();
              }
            }

            function createTooltip() {
              // There can only be one tooltip element per directive shown at once.
              if (tooltip) {
                removeTooltip();
              }
              tooltipLinkedScope = ttScope.$new();
              tooltip = tooltipLinker(tooltipLinkedScope, function(tooltip) {
                if (appendToBody) {
                  $document.find('body').append(tooltip);
                } else {
                  element.after(tooltip);
                }
              });

              if (options.useContentExp) {
                tooltipLinkedScope.$watch('contentExp()', function(val) {
                  if (!val && ttScope.isOpen) {
                    hide();
                  }
                });

                tooltipLinkedScope.$watch(function() {
                  if (!repositionScheduled) {
                    repositionScheduled = true;
                    tooltipLinkedScope.$$postDigest(function() {
                      repositionScheduled = false;
                      if (ttScope.isOpen) {
                        positionTooltip();
                      }
                    });
                  }
                });

              }
            }

            function removeTooltip() {
              transitionTimeout = null;
              if (tooltip) {
                tooltip.remove();
                tooltip = null;
              }
              if (tooltipLinkedScope) {
                tooltipLinkedScope.$destroy();
                tooltipLinkedScope = null;
              }
            }

            function prepareTooltip() {
              prepPopupClass();
              prepPlacement();
              prepPopupDelay();
            }

            ttScope.contentExp = function() {
              return scope.$eval(attrs[type]);
            };

            /**
             * Observe the relevant attributes.
             */
            if (!options.useContentExp) {
              attrs.$observe(type, function(val) {
                ttScope.content = val;

                if (!val && ttScope.isOpen) {
                  hide();
                } else {
                  positionTooltip();
                }
              });
            }

            attrs.$observe('disabled', function(val) {
              if (popupTimeout && val) {
                $timeout.cancel(popupTimeout);
                popupTimeout = null;
              }

              if (val && ttScope.isOpen) {
                hide();
              }
            });

            attrs.$observe(prefix + 'Title', function(val) {
              ttScope.title = val;
              positionTooltip();
            });

            attrs.$observe(prefix + 'Placement', function() {
              if (ttScope.isOpen) {
                prepPlacement();
                positionTooltip();
              }
            });

            if (isOpenExp) {
              scope.$watch(isOpenExp, function(val) {
                if (val !== ttScope.isOpen) {
                  toggleTooltipBind();
                }
              });
            }

            function prepPopupClass() {
              ttScope.popupClass = attrs[prefix + 'Class'];
            }

            function prepPlacement() {
              var val = attrs[prefix + 'Placement'];
              ttScope.placement = angular.isDefined(val) ? val : options.placement;
            }

            function prepPopupDelay() {
              var val = attrs[prefix + 'PopupDelay'];
              var delay = parseInt(val, 10);
              ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
            }

            var unregisterTriggers = function() {
              triggers.show.forEach(function(trigger) {
                element.unbind(trigger, showTooltipBind);
              });
              triggers.hide.forEach(function(trigger) {
                element.unbind(trigger, hideTooltipBind);
              });
            };

            function prepTriggers() {
              var val = attrs[prefix + 'Trigger'];
              unregisterTriggers();

              triggers = getTriggers(val);

              if (triggers.show !== 'none') {
                triggers.show.forEach(function(trigger, idx) {
                  // Using raw addEventListener due to jqLite/jQuery bug - #4060
                  if (trigger === triggers.hide[idx]) {
                    element[0].addEventListener(trigger, toggleTooltipBind);
                  } else if (trigger) {
                    element[0].addEventListener(trigger, showTooltipBind);
                    element[0].addEventListener(triggers.hide[idx], hideTooltipBind);
                  }
                });
              }
            }
            prepTriggers();

            var animation = scope.$eval(attrs[prefix + 'Animation']);
            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;

            var appendToBodyVal = scope.$eval(attrs[prefix + 'AppendToBody']);
            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;

            // if a tooltip is attached to <body> we need to remove it on
            // location change as its parent scope will probably not be destroyed
            // by the change.
            if (appendToBody) {
              scope.$on('$locationChangeSuccess', function closeTooltipOnLocationChangeSuccess() {
                if (ttScope.isOpen) {
                  hide();
                }
              });
            }

            // Make sure tooltip is destroyed and removed.
            scope.$on('$destroy', function onDestroyTooltip() {
              $timeout.cancel(transitionTimeout);
              $timeout.cancel(popupTimeout);
              $timeout.cancel(positionTimeout);
              unregisterTriggers();
              removeTooltip();
              ttScope = null;
            });
          };
        }
      };
    };
  }];
})

// This is mostly ngInclude code but with a custom scope
.directive('tooltipTemplateTransclude', [
         '$animate', '$sce', '$compile', '$templateRequest',
function ($animate ,  $sce ,  $compile ,  $templateRequest) {
  return {
    link: function(scope, elem, attrs) {
      var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);

      var changeCounter = 0,
        currentScope,
        previousElement,
        currentElement;

      var cleanupLastIncludeContent = function() {
        if (previousElement) {
          previousElement.remove();
          previousElement = null;
        }
        if (currentScope) {
          currentScope.$destroy();
          currentScope = null;
        }
        if (currentElement) {
          $animate.leave(currentElement).then(function() {
            previousElement = null;
          });
          previousElement = currentElement;
          currentElement = null;
        }
      };

      scope.$watch($sce.parseAsResourceUrl(attrs.tooltipTemplateTransclude), function(src) {
        var thisChangeId = ++changeCounter;

        if (src) {
          //set the 2nd param to true to ignore the template request error so that the inner
          //contents and scope can be cleaned up.
          $templateRequest(src, true).then(function(response) {
            if (thisChangeId !== changeCounter) { return; }
            var newScope = origScope.$new();
            var template = response;

            var clone = $compile(template)(newScope, function(clone) {
              cleanupLastIncludeContent();
              $animate.enter(clone, elem);
            });

            currentScope = newScope;
            currentElement = clone;

            currentScope.$emit('$includeContentLoaded', src);
          }, function() {
            if (thisChangeId === changeCounter) {
              cleanupLastIncludeContent();
              scope.$emit('$includeContentError', src);
            }
          });
          scope.$emit('$includeContentRequested', src);
        } else {
          cleanupLastIncludeContent();
        }
      });

      scope.$on('$destroy', cleanupLastIncludeContent);
    }
  };
}])

/**
 * Note that it's intentional that these classes are *not* applied through $animate.
 * They must not be animated as they're expected to be present on the tooltip on
 * initialization.
 */
.directive('tooltipClasses', function() {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      if (scope.placement) {
        element.addClass(scope.placement);
      }
      if (scope.popupClass) {
        element.addClass(scope.popupClass);
      }
      if (scope.animation()) {
        element.addClass(attrs.tooltipAnimationClass);
      }
    }
  };
})

.directive('tooltipPopup', function() {
  return {
    restrict: 'EA',
    replace: true,
    scope: { content: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
    templateUrl: 'template/tooltip/tooltip-popup.html'
  };
})

.directive('tooltip', [ '$tooltip', function($tooltip) {
  return $tooltip('tooltip', 'tooltip', 'mouseenter');
}])

.directive('tooltipTemplatePopup', function() {
  return {
    restrict: 'EA',
    replace: true,
    scope: { contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&',
      originScope: '&' },
    templateUrl: 'template/tooltip/tooltip-template-popup.html'
  };
})

.directive('tooltipTemplate', ['$tooltip', function($tooltip) {
  return $tooltip('tooltipTemplate', 'tooltip', 'mouseenter', {
    useContentExp: true
  });
}])

.directive('tooltipHtmlPopup', function() {
  return {
    restrict: 'EA',
    replace: true,
    scope: { contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
    templateUrl: 'template/tooltip/tooltip-html-popup.html'
  };
})

.directive('tooltipHtml', ['$tooltip', function($tooltip) {
  return $tooltip('tooltipHtml', 'tooltip', 'mouseenter', {
    useContentExp: true
  });
}])

/*
Deprecated
*/
.directive('tooltipHtmlUnsafePopup', function() {
  return {
    restrict: 'EA',
    replace: true,
    scope: { content: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
    templateUrl: 'template/tooltip/tooltip-html-unsafe-popup.html'
  };
})

.value('tooltipHtmlUnsafeSuppressDeprecated', false)
.directive('tooltipHtmlUnsafe', [
          '$tooltip', 'tooltipHtmlUnsafeSuppressDeprecated', '$log',
function($tooltip ,  tooltipHtmlUnsafeSuppressDeprecated ,  $log) {
  if (!tooltipHtmlUnsafeSuppressDeprecated) {
    $log.warn('tooltip-html-unsafe is now deprecated. Use tooltip-html or tooltip-template instead.');
  }
  return $tooltip('tooltipHtmlUnsafe', 'tooltip', 'mouseenter');
}]);

/**
 * The following features are still outstanding: popup delay, animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, and selector delegatation.
 */
angular.module( 'ui.bootstrap.popover', ['ui.bootstrap.tooltip'])

.directive('popoverTemplatePopup', function() {
  return {
    restrict: 'EA',
    replace: true,
    scope: { title: '@', contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&',
      originScope: '&' },
    templateUrl: 'template/popover/popover-template.html'
  };
})

.directive('popoverTemplate', ['$tooltip', function($tooltip) {
  return $tooltip('popoverTemplate', 'popover', 'click', {
    useContentExp: true
  });
}])

.directive('popoverHtmlPopup', function() {
  return {
    restrict: 'EA',
    replace: true,
    scope: { contentExp: '&', title: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
    templateUrl: 'template/popover/popover-html.html'
  };
})

.directive('popoverHtml', ['$tooltip', function($tooltip) {
  return $tooltip( 'popoverHtml', 'popover', 'click', {
    useContentExp: true
  });
}])

.directive('popoverPopup', function() {
  return {
    restrict: 'EA',
    replace: true,
    scope: { title: '@', content: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
    templateUrl: 'template/popover/popover.html'
  };
})

.directive('popover', ['$tooltip', function($tooltip) {
  return $tooltip( 'popover', 'popover', 'click' );
}]);

angular.module('ui.bootstrap.progressbar', [])

.constant('progressConfig', {
  animate: true,
  max: 100
})

.value('$progressSuppressWarning', false)

.controller('ProgressController', ['$scope', '$attrs', 'progressConfig', function($scope, $attrs, progressConfig) {
  var self = this,
      animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;

  this.bars = [];
  $scope.max = angular.isDefined($scope.max) ? $scope.max : progressConfig.max;

  this.addBar = function(bar, element) {
    if (!animate) {
      element.css({'transition': 'none'});
    }

    this.bars.push(bar);

    bar.max = $scope.max;

    bar.$watch('value', function(value) {
      bar.recalculatePercentage();
    });

    bar.recalculatePercentage = function() {
      bar.percent = +(100 * bar.value / bar.max).toFixed(2);

      var totalPercentage = self.bars.reduce(function(total, bar) {
        return total + bar.percent;
      }, 0);

      if (totalPercentage > 100) {
        bar.percent -= totalPercentage - 100;
      }
    };

    bar.$on('$destroy', function() {
      element = null;
      self.removeBar(bar);
    });
  };

  this.removeBar = function(bar) {
      this.bars.splice(this.bars.indexOf(bar), 1);
  };

  $scope.$watch('max', function(max) {
    self.bars.forEach(function(bar) {
      bar.max = $scope.max;
      bar.recalculatePercentage();
    });
  });
}])

.directive('uibProgress', function() {
  return {
    restrict: 'EA',
    replace: true,
    transclude: true,
    controller: 'ProgressController',
    require: 'uibProgress',
    scope: {
      max: '=?'
    },
    templateUrl: 'template/progressbar/progress.html'
  };
})

.directive('progress', ['$log', '$progressSuppressWarning', function($log, $progressSuppressWarning) {
  return {
    restrict: 'EA',
    replace: true,
    transclude: true,
    controller: 'ProgressController',
    require: 'progress',
    scope: {
      max: '=?'
    },
    templateUrl: 'template/progressbar/progress.html',
    link: function() {
      if ($progressSuppressWarning) {
        $log.warn('progress is now deprecated. Use uib-progress instead');
      }
    }
  };
}])

.directive('uibBar', function() {
  return {
    restrict: 'EA',
    replace: true,
    transclude: true,
    require: '^uibProgress',
    scope: {
      value: '=',
      type: '@'
    },
    templateUrl: 'template/progressbar/bar.html',
    link: function(scope, element, attrs, progressCtrl) {
      progressCtrl.addBar(scope, element);
    }
  };
})

.directive('bar', ['$log', '$progressSuppressWarning', function($log, $progressSuppressWarning) {
  return {
    restrict: 'EA',
    replace: true,
    transclude: true,
    require: '^progress',
    scope: {
      value: '=',
      type: '@'
    },
    templateUrl: 'template/progressbar/bar.html',
    link: function(scope, element, attrs, progressCtrl) {
      if ($progressSuppressWarning) {
        $log.warn('bar is now deprecated. Use uib-bar instead');
      }
      progressCtrl.addBar(scope, element);
    }
  };
}])

.directive('progressbar', function() {
  return {
    restrict: 'EA',
    replace: true,
    transclude: true,
    controller: 'ProgressController',
    scope: {
      value: '=',
      max: '=?',
      type: '@'
    },
    templateUrl: 'template/progressbar/progressbar.html',
    link: function(scope, element, attrs, progressCtrl) {
      progressCtrl.addBar(scope, angular.element(element.children()[0]));
    }
  };
});

angular.module('ui.bootstrap.rating', [])

.constant('ratingConfig', {
  max: 5,
  stateOn: null,
  stateOff: null,
  titles : ['one', 'two', 'three', 'four', 'five']
})

.controller('RatingController', ['$scope', '$attrs', 'ratingConfig', function($scope, $attrs, ratingConfig) {
  var ngModelCtrl  = { $setViewValue: angular.noop };

  this.init = function(ngModelCtrl_) {
    ngModelCtrl = ngModelCtrl_;
    ngModelCtrl.$render = this.render;

    ngModelCtrl.$formatters.push(function(value) {
      if (angular.isNumber(value) && value << 0 !== value) {
        value = Math.round(value);
      }
      return value;
    });

    this.stateOn = angular.isDefined($attrs.stateOn) ? $scope.$parent.$eval($attrs.stateOn) : ratingConfig.stateOn;
    this.stateOff = angular.isDefined($attrs.stateOff) ? $scope.$parent.$eval($attrs.stateOff) : ratingConfig.stateOff;
    var tmpTitles = angular.isDefined($attrs.titles)  ? $scope.$parent.$eval($attrs.titles) : ratingConfig.titles ;    
    this.titles = angular.isArray(tmpTitles) && tmpTitles.length > 0 ?
      tmpTitles : ratingConfig.titles;
    
    var ratingStates = angular.isDefined($attrs.ratingStates) ?
      $scope.$parent.$eval($attrs.ratingStates) :
      new Array(angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : ratingConfig.max);
    $scope.range = this.buildTemplateObjects(ratingStates);
  };

  this.buildTemplateObjects = function(states) {
    for (var i = 0, n = states.length; i < n; i++) {
      states[i] = angular.extend({ index: i }, { stateOn: this.stateOn, stateOff: this.stateOff, title: this.getTitle(i) }, states[i]);
    }
    return states;
  };
  
  this.getTitle = function(index) {
    if (index >= this.titles.length) {
      return index + 1;
    } else {
      return this.titles[index];
    }
  };
  
  $scope.rate = function(value) {
    if (!$scope.readonly && value >= 0 && value <= $scope.range.length) {
      ngModelCtrl.$setViewValue(ngModelCtrl.$viewValue === value ? 0 : value);
      ngModelCtrl.$render();
    }
  };

  $scope.enter = function(value) {
    if (!$scope.readonly) {
      $scope.value = value;
    }
    $scope.onHover({value: value});
  };

  $scope.reset = function() {
    $scope.value = ngModelCtrl.$viewValue;
    $scope.onLeave();
  };

  $scope.onKeydown = function(evt) {
    if (/(37|38|39|40)/.test(evt.which)) {
      evt.preventDefault();
      evt.stopPropagation();
      $scope.rate($scope.value + (evt.which === 38 || evt.which === 39 ? 1 : -1));
    }
  };

  this.render = function() {
    $scope.value = ngModelCtrl.$viewValue;
  };
}])

.directive('rating', function() {
  return {
    restrict: 'EA',
    require: ['rating', 'ngModel'],
    scope: {
      readonly: '=?',
      onHover: '&',
      onLeave: '&'
    },
    controller: 'RatingController',
    templateUrl: 'template/rating/rating.html',
    replace: true,
    link: function(scope, element, attrs, ctrls) {
      var ratingCtrl = ctrls[0], ngModelCtrl = ctrls[1];
      ratingCtrl.init( ngModelCtrl );
    }
  };
});


/**
 * @ngdoc overview
 * @name ui.bootstrap.tabs
 *
 * @description
 * AngularJS version of the tabs directive.
 */

angular.module('ui.bootstrap.tabs', [])

.controller('TabsetController', ['$scope', function TabsetCtrl($scope) {
  var ctrl = this,
      tabs = ctrl.tabs = $scope.tabs = [];

  ctrl.select = function(selectedTab) {
    angular.forEach(tabs, function(tab) {
      if (tab.active && tab !== selectedTab) {
        tab.active = false;
        tab.onDeselect();
        selectedTab.selectCalled = false;
      }
    });
    selectedTab.active = true;
    // only call select if it has not already been called
    if (!selectedTab.selectCalled) {
      selectedTab.onSelect();
      selectedTab.selectCalled = true;
    }
  };

  ctrl.addTab = function addTab(tab) {
    tabs.push(tab);
    // we can't run the select function on the first tab
    // since that would select it twice
    if (tabs.length === 1 && tab.active !== false) {
      tab.active = true;
    } else if (tab.active) {
      ctrl.select(tab);
    } else {
      tab.active = false;
    }
  };

  ctrl.removeTab = function removeTab(tab) {
    var index = tabs.indexOf(tab);
    //Select a new tab if the tab to be removed is selected and not destroyed
    if (tab.active && tabs.length > 1 && !destroyed) {
      //If this is the last tab, select the previous tab. else, the next tab.
      var newActiveIndex = index == tabs.length - 1 ? index - 1 : index + 1;
      ctrl.select(tabs[newActiveIndex]);
    }
    tabs.splice(index, 1);
  };

  var destroyed;
  $scope.$on('$destroy', function() {
    destroyed = true;
  });
}])

/**
 * @ngdoc directive
 * @name ui.bootstrap.tabs.directive:tabset
 * @restrict EA
 *
 * @description
 * Tabset is the outer container for the tabs directive
 *
 * @param {boolean=} vertical Whether or not to use vertical styling for the tabs.
 * @param {boolean=} justified Whether or not to use justified styling for the tabs.
 *
 * @example
<example module="ui.bootstrap">
  <file name="index.html">
    <tabset>
      <tab heading="Tab 1"><b>First</b> Content!</tab>
      <tab heading="Tab 2"><i>Second</i> Content!</tab>
    </tabset>
    <hr />
    <tabset vertical="true">
      <tab heading="Vertical Tab 1"><b>First</b> Vertical Content!</tab>
      <tab heading="Vertical Tab 2"><i>Second</i> Vertical Content!</tab>
    </tabset>
    <tabset justified="true">
      <tab heading="Justified Tab 1"><b>First</b> Justified Content!</tab>
      <tab heading="Justified Tab 2"><i>Second</i> Justified Content!</tab>
    </tabset>
  </file>
</example>
 */
.directive('tabset', function() {
  return {
    restrict: 'EA',
    transclude: true,
    replace: true,
    scope: {
      type: '@'
    },
    controller: 'TabsetController',
    templateUrl: 'template/tabs/tabset.html',
    link: function(scope, element, attrs) {
      scope.vertical = angular.isDefined(attrs.vertical) ? scope.$parent.$eval(attrs.vertical) : false;
      scope.justified = angular.isDefined(attrs.justified) ? scope.$parent.$eval(attrs.justified) : false;
    }
  };
})

/**
 * @ngdoc directive
 * @name ui.bootstrap.tabs.directive:tab
 * @restrict EA
 *
 * @param {string=} heading The visible heading, or title, of the tab. Set HTML headings with {@link ui.bootstrap.tabs.directive:tabHeading tabHeading}.
 * @param {string=} select An expression to evaluate when the tab is selected.
 * @param {boolean=} active A binding, telling whether or not this tab is selected.
 * @param {boolean=} disabled A binding, telling whether or not this tab is disabled.
 *
 * @description
 * Creates a tab with a heading and content. Must be placed within a {@link ui.bootstrap.tabs.directive:tabset tabset}.
 *
 * @example
<example module="ui.bootstrap">
  <file name="index.html">
    <div ng-controller="TabsDemoCtrl">
      <button class="btn btn-small" ng-click="items[0].active = true">
        Select item 1, using active binding
      </button>
      <button class="btn btn-small" ng-click="items[1].disabled = !items[1].disabled">
        Enable/disable item 2, using disabled binding
      </button>
      <br />
      <tabset>
        <tab heading="Tab 1">First Tab</tab>
        <tab select="alertMe()">
          <tab-heading><i class="icon-bell"></i> Alert me!</tab-heading>
          Second Tab, with alert callback and html heading!
        </tab>
        <tab ng-repeat="item in items"
          heading="{{item.title}}"
          disabled="item.disabled"
          active="item.active">
          {{item.content}}
        </tab>
      </tabset>
    </div>
  </file>
  <file name="script.js">
    function TabsDemoCtrl($scope) {
      $scope.items = [
        { title:"Dynamic Title 1", content:"Dynamic Item 0" },
        { title:"Dynamic Title 2", content:"Dynamic Item 1", disabled: true }
      ];

      $scope.alertMe = function() {
        setTimeout(function() {
          alert("You've selected the alert tab!");
        });
      };
    };
  </file>
</example>
 */

/**
 * @ngdoc directive
 * @name ui.bootstrap.tabs.directive:tabHeading
 * @restrict EA
 *
 * @description
 * Creates an HTML heading for a {@link ui.bootstrap.tabs.directive:tab tab}. Must be placed as a child of a tab element.
 *
 * @example
<example module="ui.bootstrap">
  <file name="index.html">
    <tabset>
      <tab>
        <tab-heading><b>HTML</b> in my titles?!</tab-heading>
        And some content, too!
      </tab>
      <tab>
        <tab-heading><i class="icon-heart"></i> Icon heading?!?</tab-heading>
        That's right.
      </tab>
    </tabset>
  </file>
</example>
 */
.directive('tab', ['$parse', '$log', function($parse, $log) {
  return {
    require: '^tabset',
    restrict: 'EA',
    replace: true,
    templateUrl: 'template/tabs/tab.html',
    transclude: true,
    scope: {
      active: '=?',
      heading: '@',
      onSelect: '&select', //This callback is called in contentHeadingTransclude
                          //once it inserts the tab's content into the dom
      onDeselect: '&deselect'
    },
    controller: function() {
      //Empty controller so other directives can require being 'under' a tab
    },
    link: function(scope, elm, attrs, tabsetCtrl, transclude) {
      scope.$watch('active', function(active) {
        if (active) {
          tabsetCtrl.select(scope);
        }
      });

      scope.disabled = false;
      if (attrs.disable) {
        scope.$parent.$watch($parse(attrs.disable), function(value) {
          scope.disabled = !! value;
        });
      }

      // Deprecation support of "disabled" parameter
      // fix(tab): IE9 disabled attr renders grey text on enabled tab #2677
      // This code is duplicated from the lines above to make it easy to remove once
      // the feature has been completely deprecated
      if (attrs.disabled) {
        $log.warn('Use of "disabled" attribute has been deprecated, please use "disable"');
        scope.$parent.$watch($parse(attrs.disabled), function(value) {
          scope.disabled = !! value;
        });
      }

      scope.select = function() {
        if (!scope.disabled) {
          scope.active = true;
        }
      };

      tabsetCtrl.addTab(scope);
      scope.$on('$destroy', function() {
        tabsetCtrl.removeTab(scope);
      });

      //We need to transclude later, once the content container is ready.
      //when this link happens, we're inside a tab heading.
      scope.$transcludeFn = transclude;
    }
  };
}])

.directive('tabHeadingTransclude', function() {
  return {
    restrict: 'A',
    require: '^tab',
    link: function(scope, elm, attrs, tabCtrl) {
      scope.$watch('headingElement', function updateHeadingElement(heading) {
        if (heading) {
          elm.html('');
          elm.append(heading);
        }
      });
    }
  };
})

.directive('tabContentTransclude', function() {
  return {
    restrict: 'A',
    require: '^tabset',
    link: function(scope, elm, attrs) {
      var tab = scope.$eval(attrs.tabContentTransclude);

      //Now our tab is ready to be transcluded: both the tab heading area
      //and the tab content area are loaded.  Transclude 'em both.
      tab.$transcludeFn(tab.$parent, function(contents) {
        angular.forEach(contents, function(node) {
          if (isTabHeading(node)) {
            //Let tabHeadingTransclude know.
            tab.headingElement = node;
          } else {
            elm.append(node);
          }
        });
      });
    }
  };

  function isTabHeading(node) {
    return node.tagName && (
      node.hasAttribute('tab-heading') ||
      node.hasAttribute('data-tab-heading') ||
      node.hasAttribute('x-tab-heading') ||
      node.tagName.toLowerCase() === 'tab-heading' ||
      node.tagName.toLowerCase() === 'data-tab-heading' ||
      node.tagName.toLowerCase() === 'x-tab-heading'
    );
  }
});

angular.module('ui.bootstrap.timepicker', [])

.constant('timepickerConfig', {
  hourStep: 1,
  minuteStep: 1,
  showMeridian: true,
  meridians: null,
  readonlyInput: false,
  mousewheel: true,
  arrowkeys: true,
  showSpinners: true
})

.controller('TimepickerController', ['$scope', '$attrs', '$parse', '$log', '$locale', 'timepickerConfig', function($scope, $attrs, $parse, $log, $locale, timepickerConfig) {
  var selected = new Date(),
      ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
      meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS;

  this.init = function(ngModelCtrl_, inputs) {
    ngModelCtrl = ngModelCtrl_;
    ngModelCtrl.$render = this.render;

    ngModelCtrl.$formatters.unshift(function(modelValue) {
      return modelValue ? new Date(modelValue) : null;
    });

    var hoursInputEl = inputs.eq(0),
        minutesInputEl = inputs.eq(1);

    var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;
    if (mousewheel) {
      this.setupMousewheelEvents(hoursInputEl, minutesInputEl);
    }

    var arrowkeys = angular.isDefined($attrs.arrowkeys) ? $scope.$parent.$eval($attrs.arrowkeys) : timepickerConfig.arrowkeys;
    if (arrowkeys) {
      this.setupArrowkeyEvents(hoursInputEl, minutesInputEl);
    }

    $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
    this.setupInputEvents(hoursInputEl, minutesInputEl);
  };

  var hourStep = timepickerConfig.hourStep;
  if ($attrs.hourStep) {
    $scope.$parent.$watch($parse($attrs.hourStep), function(value) {
      hourStep = parseInt(value, 10);
    });
  }

  var minuteStep = timepickerConfig.minuteStep;
  if ($attrs.minuteStep) {
    $scope.$parent.$watch($parse($attrs.minuteStep), function(value) {
      minuteStep = parseInt(value, 10);
    });
  }

  var min;
  $scope.$parent.$watch($parse($attrs.min), function(value) {
    var dt = new Date(value);
    min = isNaN(dt) ? undefined : dt;
  });

  var max;
  $scope.$parent.$watch($parse($attrs.max), function(value) {
    var dt = new Date(value);
    max = isNaN(dt) ? undefined : dt;
  });

  $scope.noIncrementHours = function() {
    var incrementedSelected = addMinutes(selected, hourStep * 60);
    return incrementedSelected > max ||
      (incrementedSelected < selected && incrementedSelected < min);
  };

  $scope.noDecrementHours = function() {
    var decrementedSelected = addMinutes(selected, -hourStep * 60);
    return decrementedSelected < min ||
      (decrementedSelected > selected && decrementedSelected > max);
  };

  $scope.noIncrementMinutes = function() {
    var incrementedSelected = addMinutes(selected, minuteStep);
    return incrementedSelected > max ||
      (incrementedSelected < selected && incrementedSelected < min);
  };

  $scope.noDecrementMinutes = function() {
    var decrementedSelected = addMinutes(selected, -minuteStep);
    return decrementedSelected < min ||
      (decrementedSelected > selected && decrementedSelected > max);
  };

  $scope.noToggleMeridian = function() {
    if (selected.getHours() < 13) {
      return addMinutes(selected, 12 * 60) > max;
    } else {
      return addMinutes(selected, -12 * 60) < min;
    }
  };

  // 12H / 24H mode
  $scope.showMeridian = timepickerConfig.showMeridian;
  if ($attrs.showMeridian) {
    $scope.$parent.$watch($parse($attrs.showMeridian), function(value) {
      $scope.showMeridian = !!value;

      if (ngModelCtrl.$error.time) {
        // Evaluate from template
        var hours = getHoursFromTemplate(), minutes = getMinutesFromTemplate();
        if (angular.isDefined(hours) && angular.isDefined(minutes)) {
          selected.setHours(hours);
          refresh();
        }
      } else {
        updateTemplate();
      }
    });
  }

  // Get $scope.hours in 24H mode if valid
  function getHoursFromTemplate() {
    var hours = parseInt($scope.hours, 10);
    var valid = $scope.showMeridian ? (hours > 0 && hours < 13) : (hours >= 0 && hours < 24);
    if (!valid) {
      return undefined;
    }

    if ($scope.showMeridian) {
      if (hours === 12) {
        hours = 0;
      }
      if ($scope.meridian === meridians[1]) {
        hours = hours + 12;
      }
    }
    return hours;
  }

  function getMinutesFromTemplate() {
    var minutes = parseInt($scope.minutes, 10);
    return (minutes >= 0 && minutes < 60) ? minutes : undefined;
  }

  function pad(value) {
    return (angular.isDefined(value) && value.toString().length < 2) ? '0' + value : value.toString();
  }

  // Respond on mousewheel spin
  this.setupMousewheelEvents = function(hoursInputEl, minutesInputEl) {
    var isScrollingUp = function(e) {
      if (e.originalEvent) {
        e = e.originalEvent;
      }
      //pick correct delta variable depending on event
      var delta = (e.wheelDelta) ? e.wheelDelta : -e.deltaY;
      return (e.detail || delta > 0);
    };

    hoursInputEl.bind('mousewheel wheel', function(e) {
      $scope.$apply(isScrollingUp(e) ? $scope.incrementHours() : $scope.decrementHours());
      e.preventDefault();
    });

    minutesInputEl.bind('mousewheel wheel', function(e) {
      $scope.$apply(isScrollingUp(e) ? $scope.incrementMinutes() : $scope.decrementMinutes());
      e.preventDefault();
    });

  };

  // Respond on up/down arrowkeys
  this.setupArrowkeyEvents = function(hoursInputEl, minutesInputEl) {
    hoursInputEl.bind('keydown', function(e) {
      if (e.which === 38) { // up
        e.preventDefault();
        $scope.incrementHours();
        $scope.$apply();
      } else if (e.which === 40) { // down
        e.preventDefault();
        $scope.decrementHours();
        $scope.$apply();
      }
    });

    minutesInputEl.bind('keydown', function(e) {
      if (e.which === 38) { // up
        e.preventDefault();
        $scope.incrementMinutes();
        $scope.$apply();
      } else if (e.which === 40) { // down
        e.preventDefault();
        $scope.decrementMinutes();
        $scope.$apply();
      }
    });
  };

  this.setupInputEvents = function(hoursInputEl, minutesInputEl) {
    if ($scope.readonlyInput) {
      $scope.updateHours = angular.noop;
      $scope.updateMinutes = angular.noop;
      return;
    }

    var invalidate = function(invalidHours, invalidMinutes) {
      ngModelCtrl.$setViewValue(null);
      ngModelCtrl.$setValidity('time', false);
      if (angular.isDefined(invalidHours)) {
        $scope.invalidHours = invalidHours;
      }
      if (angular.isDefined(invalidMinutes)) {
        $scope.invalidMinutes = invalidMinutes;
      }
    };

    $scope.updateHours = function() {
      var hours = getHoursFromTemplate(),
        minutes = getMinutesFromTemplate();

      if (angular.isDefined(hours) && angular.isDefined(minutes)) {
        selected.setHours(hours);
        if (selected < min || selected > max) {
          invalidate(true);
        } else {
          refresh('h');
        }
      } else {
        invalidate(true);
      }
    };

    hoursInputEl.bind('blur', function(e) {
      if (!$scope.invalidHours && $scope.hours < 10) {
        $scope.$apply(function() {
          $scope.hours = pad($scope.hours);
        });
      }
    });

    $scope.updateMinutes = function() {
      var minutes = getMinutesFromTemplate(),
        hours = getHoursFromTemplate();

      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
        selected.setMinutes(minutes);
        if (selected < min || selected > max) {
          invalidate(undefined, true);
        } else {
          refresh('m');
        }
      } else {
        invalidate(undefined, true);
      }
    };

    minutesInputEl.bind('blur', function(e) {
      if (!$scope.invalidMinutes && $scope.minutes < 10) {
        $scope.$apply(function() {
          $scope.minutes = pad($scope.minutes);
        });
      }
    });

  };

  this.render = function() {
    var date = ngModelCtrl.$viewValue;

    if (isNaN(date)) {
      ngModelCtrl.$setValidity('time', false);
      $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
    } else {
      if (date) {
        selected = date;
      }

      if (selected < min || selected > max) {
        ngModelCtrl.$setValidity('time', false);
        $scope.invalidHours = true;
        $scope.invalidMinutes = true;
      } else {
        makeValid();
      }
      updateTemplate();
    }
  };

  // Call internally when we know that model is valid.
  function refresh(keyboardChange) {
    makeValid();
    ngModelCtrl.$setViewValue(new Date(selected));
    updateTemplate(keyboardChange);
  }

  function makeValid() {
    ngModelCtrl.$setValidity('time', true);
    $scope.invalidHours = false;
    $scope.invalidMinutes = false;
  }

  function updateTemplate(keyboardChange) {
    var hours = selected.getHours(), minutes = selected.getMinutes();

    if ($scope.showMeridian) {
      hours = (hours === 0 || hours === 12) ? 12 : hours % 12; // Convert 24 to 12 hour system
    }

    $scope.hours = keyboardChange === 'h' ? hours : pad(hours);
    if (keyboardChange !== 'm') {
      $scope.minutes = pad(minutes);
    }
    $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
  }

  function addMinutes(date, minutes) {
    var dt = new Date(date.getTime() + minutes * 60000);
    var newDate = new Date(date);
    newDate.setHours(dt.getHours(), dt.getMinutes());
    return newDate;
  }

  function addMinutesToSelected(minutes) {
    selected = addMinutes(selected, minutes);
    refresh();
  }

  $scope.showSpinners = angular.isDefined($attrs.showSpinners) ?
    $scope.$parent.$eval($attrs.showSpinners) : timepickerConfig.showSpinners;

  $scope.incrementHours = function() {
    if (!$scope.noIncrementHours()) {
      addMinutesToSelected(hourStep * 60);
    }
  };

  $scope.decrementHours = function() {
    if (!$scope.noDecrementHours()) {
      addMinutesToSelected(-hourStep * 60);
    }
  };

  $scope.incrementMinutes = function() {
    if (!$scope.noIncrementMinutes()) {
      addMinutesToSelected(minuteStep);
    }
  };

  $scope.decrementMinutes = function() {
    if (!$scope.noDecrementMinutes()) {
      addMinutesToSelected(-minuteStep);
    }
  };

  $scope.toggleMeridian = function() {
    if (!$scope.noToggleMeridian()) {
      addMinutesToSelected(12 * 60 * (selected.getHours() < 12 ? 1 : -1));
    }
  };
}])

.directive('timepicker', function() {
  return {
    restrict: 'EA',
    require: ['timepicker', '?^ngModel'],
    controller:'TimepickerController',
    controllerAs: 'timepicker',
    replace: true,
    scope: {},
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'template/timepicker/timepicker.html';
    },
    link: function(scope, element, attrs, ctrls) {
      var timepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      if (ngModelCtrl) {
        timepickerCtrl.init(ngModelCtrl, element.find('input'));
      }
    }
  };
});

angular.module('ui.bootstrap.transition', [])

.value('$transitionSuppressDeprecated', false)
/**
 * $transition service provides a consistent interface to trigger CSS 3 transitions and to be informed when they complete.
 * @param  {DOMElement} element  The DOMElement that will be animated.
 * @param  {string|object|function} trigger  The thing that will cause the transition to start:
 *   - As a string, it represents the css class to be added to the element.
 *   - As an object, it represents a hash of style attributes to be applied to the element.
 *   - As a function, it represents a function to be called that will cause the transition to occur.
 * @return {Promise}  A promise that is resolved when the transition finishes.
 */
.factory('$transition', [
        '$q', '$timeout', '$rootScope', '$log', '$transitionSuppressDeprecated',
function($q ,  $timeout ,  $rootScope ,  $log ,  $transitionSuppressDeprecated) {

  if (!$transitionSuppressDeprecated) {
    $log.warn('$transition is now deprecated. Use $animate from ngAnimate instead.');
  }

  var $transition = function(element, trigger, options) {
    options = options || {};
    var deferred = $q.defer();
    var endEventName = $transition[options.animation ? 'animationEndEventName' : 'transitionEndEventName'];

    var transitionEndHandler = function(event) {
      $rootScope.$apply(function() {
        element.unbind(endEventName, transitionEndHandler);
        deferred.resolve(element);
      });
    };

    if (endEventName) {
      element.bind(endEventName, transitionEndHandler);
    }

    // Wrap in a timeout to allow the browser time to update the DOM before the transition is to occur
    $timeout(function() {
      if ( angular.isString(trigger) ) {
        element.addClass(trigger);
      } else if ( angular.isFunction(trigger) ) {
        trigger(element);
      } else if ( angular.isObject(trigger) ) {
        element.css(trigger);
      }
      //If browser does not support transitions, instantly resolve
      if ( !endEventName ) {
        deferred.resolve(element);
      }
    });

    // Add our custom cancel function to the promise that is returned
    // We can call this if we are about to run a new transition, which we know will prevent this transition from ending,
    // i.e. it will therefore never raise a transitionEnd event for that transition
    deferred.promise.cancel = function() {
      if ( endEventName ) {
        element.unbind(endEventName, transitionEndHandler);
      }
      deferred.reject('Transition cancelled');
    };

    return deferred.promise;
  };

  // Work out the name of the transitionEnd event
  var transElement = document.createElement('trans');
  var transitionEndEventNames = {
    'WebkitTransition': 'webkitTransitionEnd',
    'MozTransition': 'transitionend',
    'OTransition': 'oTransitionEnd',
    'transition': 'transitionend'
  };
  var animationEndEventNames = {
    'WebkitTransition': 'webkitAnimationEnd',
    'MozTransition': 'animationend',
    'OTransition': 'oAnimationEnd',
    'transition': 'animationend'
  };
  function findEndEventName(endEventNames) {
    for (var name in endEventNames){
      if (transElement.style[name] !== undefined) {
        return endEventNames[name];
      }
    }
  }
  $transition.transitionEndEventName = findEndEventName(transitionEndEventNames);
  $transition.animationEndEventName = findEndEventName(animationEndEventNames);
  return $transition;
}]);

angular.module('ui.bootstrap.typeahead', ['ui.bootstrap.position'])

/**
 * A helper service that can parse typeahead's syntax (string provided by users)
 * Extracted to a separate service for ease of unit testing
 */
  .factory('typeaheadParser', ['$parse', function($parse) {

  //                      00000111000000000000022200000000000000003333333333333330000000000044000
  var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;

  return {
    parse: function(input) {
      var match = input.match(TYPEAHEAD_REGEXP);
      if (!match) {
        throw new Error(
          'Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' +
            ' but got "' + input + '".');
      }

      return {
        itemName:match[3],
        source:$parse(match[4]),
        viewMapper:$parse(match[2] || match[1]),
        modelMapper:$parse(match[1])
      };
    }
  };
}])

  .directive('typeahead', ['$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', '$position', 'typeaheadParser',
    function($compile, $parse, $q, $timeout, $document, $window, $rootScope, $position, typeaheadParser) {
    var HOT_KEYS = [9, 13, 27, 38, 40];
    var eventDebounceTime = 200;

    return {
      require: ['ngModel', '^?ngModelOptions'],
      link: function(originalScope, element, attrs, ctrls) {
        var modelCtrl = ctrls[0];
        var ngModelOptions = ctrls[1];
        //SUPPORTED ATTRIBUTES (OPTIONS)

        //minimal no of characters that needs to be entered before typeahead kicks-in
        var minLength = originalScope.$eval(attrs.typeaheadMinLength);
        if (!minLength && minLength !== 0) {
          minLength = 1;
        }

        //minimal wait time after last character typed before typeahead kicks-in
        var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;

        //should it restrict model values to the ones selected from the popup only?
        var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;

        //binding to a variable that indicates if matches are being retrieved asynchronously
        var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;

        //a callback executed when a match is selected
        var onSelectCallback = $parse(attrs.typeaheadOnSelect);

        //should it select highlighted popup value when losing focus?
        var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;

        //binding to a variable that indicates if there were no results after the query is completed
        var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;

        var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;

        var appendToBody =  attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;

        var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;

        //If input matches an item of the list exactly, select it automatically
        var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;

        //INTERNAL VARIABLES

        //model setter executed upon match selection
        var parsedModel = $parse(attrs.ngModel);
        var invokeModelSetter = $parse(attrs.ngModel + '($$$p)');
        var $setModelValue = function(scope, newValue) {
          if (angular.isFunction(parsedModel(originalScope)) &&
            ngModelOptions && ngModelOptions.$options && ngModelOptions.$options.getterSetter) {
            return invokeModelSetter(scope, {$$$p: newValue});
          } else {
            return parsedModel.assign(scope, newValue);
          }
        };

        //expressions used by typeahead
        var parserResult = typeaheadParser.parse(attrs.typeahead);

        var hasFocus;

        //Used to avoid bug in iOS webview where iOS keyboard does not fire
        //mousedown & mouseup events
        //Issue #3699
        var selected;

        //create a child scope for the typeahead directive so we are not polluting original scope
        //with typeahead-specific data (matches, query etc.)
        var scope = originalScope.$new();
        var offDestroy = originalScope.$on('$destroy', function() {
			    scope.$destroy();
        });
        scope.$on('$destroy', offDestroy);

        // WAI-ARIA
        var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
        element.attr({
          'aria-autocomplete': 'list',
          'aria-expanded': false,
          'aria-owns': popupId
        });

        //pop-up element used to display matches
        var popUpEl = angular.element('<div typeahead-popup></div>');
        popUpEl.attr({
          id: popupId,
          matches: 'matches',
          active: 'activeIdx',
          select: 'select(activeIdx)',
          'move-in-progress': 'moveInProgress',
          query: 'query',
          position: 'position'
        });
        //custom item template
        if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
          popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
        }

        if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) {
          popUpEl.attr('popup-template-url', attrs.typeaheadPopupTemplateUrl);
        }

        var resetMatches = function() {
          scope.matches = [];
          scope.activeIdx = -1;
          element.attr('aria-expanded', false);
        };

        var getMatchId = function(index) {
          return popupId + '-option-' + index;
        };

        // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
        // This attribute is added or removed automatically when the `activeIdx` changes.
        scope.$watch('activeIdx', function(index) {
          if (index < 0) {
            element.removeAttr('aria-activedescendant');
          } else {
            element.attr('aria-activedescendant', getMatchId(index));
          }
        });

        var inputIsExactMatch = function(inputValue, index) {
          if (scope.matches.length > index && inputValue) {
            return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
          }

          return false;
        };

        var getMatchesAsync = function(inputValue) {
          var locals = {$viewValue: inputValue};
          isLoadingSetter(originalScope, true);
          isNoResultsSetter(originalScope, false);
          $q.when(parserResult.source(originalScope, locals)).then(function(matches) {
            //it might happen that several async queries were in progress if a user were typing fast
            //but we are interested only in responses that correspond to the current view value
            var onCurrentRequest = (inputValue === modelCtrl.$viewValue);
            if (onCurrentRequest && hasFocus) {
              if (matches && matches.length > 0) {

                scope.activeIdx = focusFirst ? 0 : -1;
                isNoResultsSetter(originalScope, false);
                scope.matches.length = 0;

                //transform labels
                for (var i = 0; i < matches.length; i++) {
                  locals[parserResult.itemName] = matches[i];
                  scope.matches.push({
                    id: getMatchId(i),
                    label: parserResult.viewMapper(scope, locals),
                    model: matches[i]
                  });
                }

                scope.query = inputValue;
                //position pop-up with matches - we need to re-calculate its position each time we are opening a window
                //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
                //due to other elements being rendered
                recalculatePosition();

                element.attr('aria-expanded', true);

                //Select the single remaining option if user input matches
                if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) {
                  scope.select(0);
                }
              } else {
                resetMatches();
                isNoResultsSetter(originalScope, true);
              }
            }
            if (onCurrentRequest) {
              isLoadingSetter(originalScope, false);
            }
          }, function() {
            resetMatches();
            isLoadingSetter(originalScope, false);
            isNoResultsSetter(originalScope, true);
          });
        };

        // bind events only if appendToBody params exist - performance feature
        if (appendToBody) {
          angular.element($window).bind('resize', fireRecalculating);
          $document.find('body').bind('scroll', fireRecalculating);
        }

        // Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
        var timeoutEventPromise;

        // Default progress type
        scope.moveInProgress = false;

        function fireRecalculating() {
          if (!scope.moveInProgress) {
            scope.moveInProgress = true;
            scope.$digest();
          }

          // Cancel previous timeout
          if (timeoutEventPromise) {
            $timeout.cancel(timeoutEventPromise);
          }

          // Debounced executing recalculate after events fired
          timeoutEventPromise = $timeout(function() {
            // if popup is visible
            if (scope.matches.length) {
              recalculatePosition();
            }

            scope.moveInProgress = false;
            scope.$digest();
          }, eventDebounceTime);
        }

        // recalculate actual position and set new values to scope
        // after digest loop is popup in right position
        function recalculatePosition() {
          scope.position = appendToBody ? $position.offset(element) : $position.position(element);
          scope.position.top += element.prop('offsetHeight');
        }

        resetMatches();

        //we need to propagate user's query so we can higlight matches
        scope.query = undefined;

        //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
        var timeoutPromise;

        var scheduleSearchWithTimeout = function(inputValue) {
          timeoutPromise = $timeout(function() {
            getMatchesAsync(inputValue);
          }, waitTime);
        };

        var cancelPreviousTimeout = function() {
          if (timeoutPromise) {
            $timeout.cancel(timeoutPromise);
          }
        };

        //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
        //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
        modelCtrl.$parsers.unshift(function(inputValue) {
          hasFocus = true;

          if (minLength === 0 || inputValue && inputValue.length >= minLength) {
            if (waitTime > 0) {
              cancelPreviousTimeout();
              scheduleSearchWithTimeout(inputValue);
            } else {
              getMatchesAsync(inputValue);
            }
          } else {
            isLoadingSetter(originalScope, false);
            cancelPreviousTimeout();
            resetMatches();
          }

          if (isEditable) {
            return inputValue;
          } else {
            if (!inputValue) {
              // Reset in case user had typed something previously.
              modelCtrl.$setValidity('editable', true);
              return null;
            } else {
              modelCtrl.$setValidity('editable', false);
              return undefined;
            }
          }
        });

        modelCtrl.$formatters.push(function(modelValue) {
          var candidateViewValue, emptyViewValue;
          var locals = {};

          // The validity may be set to false via $parsers (see above) if
          // the model is restricted to selected values. If the model
          // is set manually it is considered to be valid.
          if (!isEditable) {
            modelCtrl.$setValidity('editable', true);
          }

          if (inputFormatter) {
            locals.$model = modelValue;
            return inputFormatter(originalScope, locals);
          } else {
            //it might happen that we don't have enough info to properly render input value
            //we need to check for this situation and simply return model value if we can't apply custom formatting
            locals[parserResult.itemName] = modelValue;
            candidateViewValue = parserResult.viewMapper(originalScope, locals);
            locals[parserResult.itemName] = undefined;
            emptyViewValue = parserResult.viewMapper(originalScope, locals);

            return candidateViewValue!== emptyViewValue ? candidateViewValue : modelValue;
          }
        });

        scope.select = function(activeIdx) {
          //called from within the $digest() cycle
          var locals = {};
          var model, item;

          selected = true;
          locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
          model = parserResult.modelMapper(originalScope, locals);
          $setModelValue(originalScope, model);
          modelCtrl.$setValidity('editable', true);
          modelCtrl.$setValidity('parse', true);

          onSelectCallback(originalScope, {
            $item: item,
            $model: model,
            $label: parserResult.viewMapper(originalScope, locals)
          });

          resetMatches();

          //return focus to the input element if a match was selected via a mouse click event
          // use timeout to avoid $rootScope:inprog error
          if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) {
            $timeout(function() { element[0].focus(); }, 0, false);
          }
        };

        //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
        element.bind('keydown', function(evt) {
          //typeahead is open and an "interesting" key was pressed
          if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
            return;
          }

          // if there's nothing selected (i.e. focusFirst) and enter or tab is hit, clear the results
          if (scope.activeIdx === -1 && (evt.which === 9 || evt.which === 13)) {
            resetMatches();
            scope.$digest();
            return;
          }

          evt.preventDefault();

          if (evt.which === 40) {
            scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
            scope.$digest();

          } else if (evt.which === 38) {
            scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
            scope.$digest();

          } else if (evt.which === 13 || evt.which === 9) {
            scope.$apply(function () {
              scope.select(scope.activeIdx);
            });

          } else if (evt.which === 27) {
            evt.stopPropagation();

            resetMatches();
            scope.$digest();
          }
        });

        element.bind('blur', function() {
          if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
            selected = true;
            scope.$apply(function() {
              scope.select(scope.activeIdx);
            });
          }
          hasFocus = false;
          selected = false;
        });

        // Keep reference to click handler to unbind it.
        var dismissClickHandler = function(evt) {
          // Issue #3973
          // Firefox treats right click as a click on document
          if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
            resetMatches();
            if (!$rootScope.$$phase) {
              scope.$digest();
            }
          }
        };

        $document.bind('click', dismissClickHandler);

        originalScope.$on('$destroy', function() {
          $document.unbind('click', dismissClickHandler);
          if (appendToBody) {
            $popup.remove();
          }
          // Prevent jQuery cache memory leak
          popUpEl.remove();
        });

        var $popup = $compile(popUpEl)(scope);

        if (appendToBody) {
          $document.find('body').append($popup);
        } else {
          element.after($popup);
        }
      }
    };

  }])

  .directive('typeaheadPopup', function() {
    return {
      restrict: 'EA',
      scope: {
        matches: '=',
        query: '=',
        active: '=',
        position: '&',
        moveInProgress: '=',
        select: '&'
      },
      replace: true,
      templateUrl: function(element, attrs) {
        return attrs.popupTemplateUrl || 'template/typeahead/typeahead-popup.html';
      },
      link: function(scope, element, attrs) {
        scope.templateUrl = attrs.templateUrl;

        scope.isOpen = function() {
          return scope.matches.length > 0;
        };

        scope.isActive = function(matchIdx) {
          return scope.active == matchIdx;
        };

        scope.selectActive = function(matchIdx) {
          scope.active = matchIdx;
        };

        scope.selectMatch = function(activeIdx) {
          scope.select({activeIdx:activeIdx});
        };
      }
    };
  })

  .directive('typeaheadMatch', ['$templateRequest', '$compile', '$parse', function($templateRequest, $compile, $parse) {
    return {
      restrict: 'EA',
      scope: {
        index: '=',
        match: '=',
        query: '='
      },
      link:function(scope, element, attrs) {
        var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'template/typeahead/typeahead-match.html';
        $templateRequest(tplUrl).then(function(tplContent) {
          $compile(tplContent.trim())(scope, function(clonedElement) {
            element.replaceWith(clonedElement);
          });
        });
      }
    };
  }])

  .filter('typeaheadHighlight', ['$sce', '$injector', '$log', function($sce, $injector, $log) {
    var isSanitizePresent;
    isSanitizePresent = $injector.has('$sanitize');

    function escapeRegexp(queryToEscape) {
      // Regex: capture the whole query string and replace it with the string that will be used to match
      // the results, for example if the capture is "a" the result will be \a
      return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
    }

    function containsHtml(matchItem) {
      return /<.*>/g.test(matchItem);
    }

    return function(matchItem, query) {
      if (!isSanitizePresent && containsHtml(matchItem)) {
        $log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger
      }
      matchItem = query? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
      if (!isSanitizePresent) {
        matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
      }
      return matchItem;
    };
  }]);

angular.module("template/accordion/accordion-group.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/accordion/accordion-group.html",
    "<div class=\"panel {{panelClass || 'panel-default'}}\">\n" +
    "  <div class=\"panel-heading\" ng-keypress=\"toggleOpen($event)\">\n" +
    "    <h4 class=\"panel-title\">\n" +
    "      <a href tabindex=\"0\" class=\"accordion-toggle\" ng-click=\"toggleOpen()\" accordion-transclude=\"heading\"><span ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" +
    "    </h4>\n" +
    "  </div>\n" +
    "  <div class=\"panel-collapse collapse\" collapse=\"!isOpen\">\n" +
    "	  <div class=\"panel-body\" ng-transclude></div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("template/accordion/accordion.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/accordion/accordion.html",
    "<div class=\"panel-group\" ng-transclude></div>");
}]);

angular.module("template/alert/alert.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/alert/alert.html",
    "<div class=\"alert\" ng-class=\"['alert-' + (type || 'warning'), closeable ? 'alert-dismissible' : null]\" role=\"alert\">\n" +
    "    <button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close($event)\">\n" +
    "        <span aria-hidden=\"true\">&times;</span>\n" +
    "        <span class=\"sr-only\">Close</span>\n" +
    "    </button>\n" +
    "    <div ng-transclude></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("template/carousel/carousel.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/carousel/carousel.html",
    "<div ng-mouseenter=\"pause()\" ng-mouseleave=\"play()\" class=\"carousel\" ng-swipe-right=\"prev()\" ng-swipe-left=\"next()\">\n" +
    "    <ol class=\"carousel-indicators\" ng-show=\"slides.length > 1\">\n" +
    "        <li ng-repeat=\"slide in slides | orderBy:indexOfSlide track by $index\" ng-class=\"{active: isActive(slide)}\" ng-click=\"select(slide)\"></li>\n" +
    "    </ol>\n" +
    "    <div class=\"carousel-inner\" ng-transclude></div>\n" +
    "    <a class=\"left carousel-control\" ng-click=\"prev()\" ng-show=\"slides.length > 1\"><span class=\"glyphicon glyphicon-chevron-left\"></span></a>\n" +
    "    <a class=\"right carousel-control\" ng-click=\"next()\" ng-show=\"slides.length > 1\"><span class=\"glyphicon glyphicon-chevron-right\"></span></a>\n" +
    "</div>\n" +
    "");
}]);

angular.module("template/carousel/slide.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/carousel/slide.html",
    "<div ng-class=\"{\n" +
    "    'active': active\n" +
    "  }\" class=\"item text-center\" ng-transclude></div>\n" +
    "");
}]);

angular.module("template/datepicker/datepicker.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/datepicker/datepicker.html",
    "<div ng-switch=\"datepickerMode\" role=\"application\" ng-keydown=\"keydown($event)\">\n" +
    "  <daypicker ng-switch-when=\"day\" tabindex=\"0\"></daypicker>\n" +
    "  <monthpicker ng-switch-when=\"month\" tabindex=\"0\"></monthpicker>\n" +
    "  <yearpicker ng-switch-when=\"year\" tabindex=\"0\"></yearpicker>\n" +
    "</div>");
}]);

angular.module("template/datepicker/day.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/datepicker/day.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
    "      <th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
    "    </tr>\n" +
    "    <tr>\n" +
    "      <th ng-if=\"showWeeks\" class=\"text-center\"></th>\n" +
    "      <th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
    "      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" +
    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{::dt.uid}}\" ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default btn-sm\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"::{'text-muted': dt.secondary, 'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("template/datepicker/month.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/datepicker/month.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
    "      <th><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{::dt.uid}}\" ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("template/datepicker/popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/datepicker/popup.html",
    "<ul class=\"dropdown-menu\" ng-if=\"isOpen\" style=\"display: block\" ng-style=\"{top: position.top+'px', left: position.left+'px'}\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" +
    "	<li ng-transclude></li>\n" +
    "	<li ng-if=\"showButtonBar\" style=\"padding:10px 9px 2px\">\n" +
    "		<span class=\"btn-group pull-left\">\n" +
    "			<button type=\"button\" class=\"btn btn-sm btn-info\" ng-click=\"select('today')\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" +
    "			<button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"select(null)\">{{ getText('clear') }}</button>\n" +
    "		</span>\n" +
    "		<button type=\"button\" class=\"btn btn-sm btn-success pull-right\" ng-click=\"close()\">{{ getText('close') }}</button>\n" +
    "	</li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("template/datepicker/year.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/datepicker/year.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
    "      <th colspan=\"3\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{::dt.uid}}\">\n" +
    "        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("template/modal/backdrop.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/modal/backdrop.html",
    "<div class=\"modal-backdrop\"\n" +
    "     modal-animation-class=\"fade\"\n" +
    "     modal-in-class=\"in\"\n" +
    "     ng-style=\"{'z-index': 1040 + (index && 1 || 0) + index*10}\"\n" +
    "></div>\n" +
    "");
}]);

angular.module("template/modal/window.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/modal/window.html",
    "<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\"\n" +
    "    modal-animation-class=\"fade\"\n" +
    "    modal-in-class=\"in\"\n" +
    "	ng-style=\"{'z-index': 1050 + index*10, display: 'block'}\" ng-click=\"close($event)\">\n" +
    "    <div class=\"modal-dialog\" ng-class=\"size ? 'modal-' + size : ''\"><div class=\"modal-content\" modal-transclude></div></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("template/pagination/pager.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/pagination/pager.html",
    "<ul class=\"pager\">\n" +
    "  <li ng-class=\"{disabled: noPrevious()||ngDisabled, previous: align}\"><a href ng-click=\"selectPage(page - 1, $event)\">{{::getText('previous')}}</a></li>\n" +
    "  <li ng-class=\"{disabled: noNext()||ngDisabled, next: align}\"><a href ng-click=\"selectPage(page + 1, $event)\">{{::getText('next')}}</a></li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("template/pagination/pagination.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/pagination/pagination.html",
    "<ul class=\"pagination\">\n" +
    "  <li ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-first\"><a href ng-click=\"selectPage(1, $event)\">{{::getText('first')}}</a></li>\n" +
    "  <li ng-if=\"::directionLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-prev\"><a href ng-click=\"selectPage(page - 1, $event)\">{{::getText('previous')}}</a></li>\n" +
    "  <li ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=\"pagination-page\"><a href ng-click=\"selectPage(page.number, $event)\">{{page.text}}</a></li>\n" +
    "  <li ng-if=\"::directionLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-next\"><a href ng-click=\"selectPage(page + 1, $event)\">{{::getText('next')}}</a></li>\n" +
    "  <li ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-last\"><a href ng-click=\"selectPage(totalPages, $event)\">{{::getText('last')}}</a></li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("template/tooltip/tooltip-html-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/tooltip/tooltip-html-popup.html",
    "<div class=\"tooltip\"\n" +
    "  tooltip-animation-class=\"fade\"\n" +
    "  tooltip-classes\n" +
    "  ng-class=\"{ in: isOpen() }\">\n" +
    "  <div class=\"tooltip-arrow\"></div>\n" +
    "  <div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("template/tooltip/tooltip-html-unsafe-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/tooltip/tooltip-html-unsafe-popup.html",
    "<div class=\"tooltip\"\n" +
    "  tooltip-animation-class=\"fade\"\n" +
    "  tooltip-classes\n" +
    "  ng-class=\"{ in: isOpen() }\">\n" +
    "  <div class=\"tooltip-arrow\"></div>\n" +
    "  <div class=\"tooltip-inner\" bind-html-unsafe=\"content\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("template/tooltip/tooltip-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/tooltip/tooltip-popup.html",
    "<div class=\"tooltip\"\n" +
    "  tooltip-animation-class=\"fade\"\n" +
    "  tooltip-classes\n" +
    "  ng-class=\"{ in: isOpen() }\">\n" +
    "  <div class=\"tooltip-arrow\"></div>\n" +
    "  <div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("template/tooltip/tooltip-template-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/tooltip/tooltip-template-popup.html",
    "<div class=\"tooltip\"\n" +
    "  tooltip-animation-class=\"fade\"\n" +
    "  tooltip-classes\n" +
    "  ng-class=\"{ in: isOpen() }\">\n" +
    "  <div class=\"tooltip-arrow\"></div>\n" +
    "  <div class=\"tooltip-inner\"\n" +
    "    tooltip-template-transclude=\"contentExp()\"\n" +
    "    tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("template/popover/popover-html.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/popover/popover-html.html",
    "<div class=\"popover\"\n" +
    "  tooltip-animation-class=\"fade\"\n" +
    "  tooltip-classes\n" +
    "  ng-class=\"{ in: isOpen() }\">\n" +
    "  <div class=\"arrow\"></div>\n" +
    "\n" +
    "  <div class=\"popover-inner\">\n" +
    "      <h3 class=\"popover-title\" ng-bind=\"title\" ng-if=\"title\"></h3>\n" +
    "      <div class=\"popover-content\" ng-bind-html=\"contentExp()\"></div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("template/popover/popover-template.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/popover/popover-template.html",
    "<div class=\"popover\"\n" +
    "  tooltip-animation-class=\"fade\"\n" +
    "  tooltip-classes\n" +
    "  ng-class=\"{ in: isOpen() }\">\n" +
    "  <div class=\"arrow\"></div>\n" +
    "\n" +
    "  <div class=\"popover-inner\">\n" +
    "      <h3 class=\"popover-title\" ng-bind=\"title\" ng-if=\"title\"></h3>\n" +
    "      <div class=\"popover-content\"\n" +
    "        tooltip-template-transclude=\"contentExp()\"\n" +
    "        tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("template/popover/popover.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/popover/popover.html",
    "<div class=\"popover\"\n" +
    "  tooltip-animation-class=\"fade\"\n" +
    "  tooltip-classes\n" +
    "  ng-class=\"{ in: isOpen() }\">\n" +
    "  <div class=\"arrow\"></div>\n" +
    "\n" +
    "  <div class=\"popover-inner\">\n" +
    "      <h3 class=\"popover-title\" ng-bind=\"title\" ng-if=\"title\"></h3>\n" +
    "      <div class=\"popover-content\" ng-bind=\"content\"></div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("template/progressbar/bar.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/progressbar/bar.html",
    "<div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" style=\"min-width: 0;\" ng-transclude></div>\n" +
    "");
}]);

angular.module("template/progressbar/progress.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/progressbar/progress.html",
    "<div class=\"progress\" ng-transclude></div>");
}]);

angular.module("template/progressbar/progressbar.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/progressbar/progressbar.html",
    "<div class=\"progress\">\n" +
    "  <div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" style=\"min-width: 0;\" ng-transclude></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("template/rating/rating.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/rating/rating.html",
    "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\">\n" +
    "    <span ng-repeat-start=\"r in range track by $index\" class=\"sr-only\">({{ $index < value ? '*' : ' ' }})</span>\n" +
    "    <i ng-repeat-end ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"glyphicon\" ng-class=\"$index < value && (r.stateOn || 'glyphicon-star') || (r.stateOff || 'glyphicon-star-empty')\" ng-attr-title=\"{{r.title}}\" ></i>\n" +
    "</span>\n" +
    "");
}]);

angular.module("template/tabs/tab.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/tabs/tab.html",
    "<li ng-class=\"{active: active, disabled: disabled}\">\n" +
    "  <a href ng-click=\"select()\" tab-heading-transclude>{{heading}}</a>\n" +
    "</li>\n" +
    "");
}]);

angular.module("template/tabs/tabset.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/tabs/tabset.html",
    "<div>\n" +
    "  <ul class=\"nav nav-{{type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul>\n" +
    "  <div class=\"tab-content\">\n" +
    "    <div class=\"tab-pane\" \n" +
    "         ng-repeat=\"tab in tabs\" \n" +
    "         ng-class=\"{active: tab.active}\"\n" +
    "         tab-content-transclude=\"tab\">\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("template/timepicker/timepicker.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/timepicker/timepicker.html",
    "<table>\n" +
    "  <tbody>\n" +
    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
    "      <td><a ng-click=\"incrementHours()\" ng-class=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
    "      <td>&nbsp;</td>\n" +
    "      <td><a ng-click=\"incrementMinutes()\" ng-class=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
    "      <td ng-show=\"showMeridian\"></td>\n" +
    "    </tr>\n" +
    "    <tr>\n" +
    "      <td class=\"form-group\" ng-class=\"{'has-error': invalidHours}\">\n" +
    "        <input style=\"width:50px;\" type=\"text\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\">\n" +
    "      </td>\n" +
    "      <td>:</td>\n" +
    "      <td class=\"form-group\" ng-class=\"{'has-error': invalidMinutes}\">\n" +
    "        <input style=\"width:50px;\" type=\"text\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\">\n" +
    "      </td>\n" +
    "      <td ng-show=\"showMeridian\"><button type=\"button\" ng-class=\"{disabled: noToggleMeridian()}\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\">{{meridian}}</button></td>\n" +
    "    </tr>\n" +
    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
    "      <td><a ng-click=\"decrementHours()\" ng-class=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
    "      <td>&nbsp;</td>\n" +
    "      <td><a ng-click=\"decrementMinutes()\" ng-class=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
    "      <td ng-show=\"showMeridian\"></td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("template/typeahead/typeahead-match.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/typeahead/typeahead-match.html",
    "<a href tabindex=\"-1\" ng-bind-html=\"match.label | typeaheadHighlight:query\"></a>\n" +
    "");
}]);

angular.module("template/typeahead/typeahead-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/typeahead/typeahead-popup.html",
    "<ul class=\"dropdown-menu\" ng-show=\"isOpen() && !moveInProgress\" ng-style=\"{top: position().top+'px', left: position().left+'px'}\" style=\"display: block;\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\">\n" +
    "    <li ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index)\" role=\"option\" id=\"{{::match.id}}\">\n" +
    "        <div typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div>\n" +
    "    </li>\n" +
    "</ul>\n" +
    "");
}]);
!angular.$$csp() && angular.element(document).find('head').prepend('<style type="text/css">.ng-animate.item:not(.left):not(.right){-webkit-transition:0s ease-in-out left;transition:0s ease-in-out left}</style>');

/***/ }),
/* 24 */
/***/ (function(module, exports) {

/**
 * angular-ui-notification - Angular.js service providing simple notifications using Bootstrap 3 styles with css transitions for animating
 * @author Alex_Crack
 * @version v0.0.14
 * @link https://github.com/alexcrack/angular-ui-notification
 * @license MIT
 */
angular.module("ui-notification",[]),angular.module("ui-notification").provider("Notification",function(){this.options={delay:5e3,startTop:10,startRight:10,verticalSpacing:10,horizontalSpacing:10,positionX:"right",positionY:"top",replaceMessage:!1,templateUrl:"angular-ui-notification.html"},this.setOptions=function(t){if(!angular.isObject(t))throw new Error("Options should be an object!");this.options=angular.extend({},this.options,t)},this.$get=["$timeout","$http","$compile","$templateCache","$rootScope","$injector","$sce","$q","$window",function(t,e,i,n,o,s,a,r,l){var p=this.options,c=p.startTop,u=p.startRight,d=p.verticalSpacing,m=p.horizontalSpacing,g=p.delay,f=[],h=!1,v=function(s,v){var y=r.defer();return"object"!=typeof s&&(s={message:s}),s.scope=s.scope?s.scope:o,s.template=s.templateUrl?s.templateUrl:p.templateUrl,s.delay=angular.isUndefined(s.delay)?g:s.delay,s.type=v?v:"",s.positionY=s.positionY?s.positionY:p.positionY,s.positionX=s.positionX?s.positionX:p.positionX,s.replaceMessage=s.replaceMessage?s.replaceMessage:p.replaceMessage,e.get(s.template,{cache:n}).success(function(e){var n=s.scope.$new();n.message=a.trustAsHtml(s.message),n.title=a.trustAsHtml(s.title),n.t=s.type.substr(0,1),n.delay=s.delay;var o=function(){for(var t=0,e=0,i=c,n=u,o=[],a=f.length-1;a>=0;a--){var r=f[a];if(s.replaceMessage&&a<f.length-1)r.addClass("killed");else{var l=parseInt(r[0].offsetHeight),p=parseInt(r[0].offsetWidth),g=o[r._positionY+r._positionX];h+l>window.innerHeight&&(g=c,e++,t=0);var h=i=g?0===t?g:g+d:c,v=n+e*(m+p);r.css(r._positionY,h+"px"),"center"==r._positionX?r.css("left",parseInt(window.innerWidth/2-p/2)+"px"):r.css(r._positionX,v+"px"),o[r._positionY+r._positionX]=h+l,t++}}},r=i(e)(n);r._positionY=s.positionY,r._positionX=s.positionX,r.addClass(s.type),r.bind("webkitTransitionEnd oTransitionEnd otransitionend transitionend msTransitionEnd click",function(t){t=t.originalEvent||t,("click"===t.type||"opacity"===t.propertyName&&t.elapsedTime>=1)&&(r.remove(),f.splice(f.indexOf(r),1),o())}),angular.isNumber(s.delay)&&t(function(){r.addClass("killed")},s.delay),angular.element(document.getElementsByTagName("body")).append(r);var p=-(parseInt(r[0].offsetHeight)+50);r.css(r._positionY,p+"px"),f.push(r),n._templateElement=r,n.kill=function(e){e?(f.splice(f.indexOf(n._templateElement),1),n._templateElement.remove(),t(o)):n._templateElement.addClass("killed")},t(o),h||(angular.element(l).bind("resize",function(){t(o)}),h=!0),y.resolve(n)}).error(function(t){throw new Error("Template ("+s.template+") could not be loaded. "+t)}),y.promise};return v.primary=function(t){return this(t,"primary")},v.error=function(t){return this(t,"error")},v.success=function(t){return this(t,"success")},v.info=function(t){return this(t,"info")},v.warning=function(t){return this(t,"warning")},v.clearAll=function(){angular.forEach(f,function(t){t.addClass("killed")})},v}]}),angular.module("ui-notification").run(["$templateCache",function(t){t.put("angular-ui-notification.html",'<div class="ui-notification"><h3 ng-show="title" ng-bind-html="title"></h3><div class="message" ng-bind-html="message"></div></div>')}]);

/***/ }),
/* 25 */
/***/ (function(module, exports) {

/**
 * State-based routing for AngularJS
 * @version v0.2.18
 * @link http://angular-ui.github.com/
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */

/* commonjs package manager support (eg componentjs) */
if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports){
  module.exports = 'ui.router';
}

(function (window, angular, undefined) {
/*jshint globalstrict:true*/
/*global angular:false*/
'use strict';

var isDefined = angular.isDefined,
    isFunction = angular.isFunction,
    isString = angular.isString,
    isObject = angular.isObject,
    isArray = angular.isArray,
    forEach = angular.forEach,
    extend = angular.extend,
    copy = angular.copy,
    toJson = angular.toJson;

function inherit(parent, extra) {
  return extend(new (extend(function() {}, { prototype: parent }))(), extra);
}

function merge(dst) {
  forEach(arguments, function(obj) {
    if (obj !== dst) {
      forEach(obj, function(value, key) {
        if (!dst.hasOwnProperty(key)) dst[key] = value;
      });
    }
  });
  return dst;
}

/**
 * Finds the common ancestor path between two states.
 *
 * @param {Object} first The first state.
 * @param {Object} second The second state.
 * @return {Array} Returns an array of state names in descending order, not including the root.
 */
function ancestors(first, second) {
  var path = [];

  for (var n in first.path) {
    if (first.path[n] !== second.path[n]) break;
    path.push(first.path[n]);
  }
  return path;
}

/**
 * IE8-safe wrapper for `Object.keys()`.
 *
 * @param {Object} object A JavaScript object.
 * @return {Array} Returns the keys of the object as an array.
 */
function objectKeys(object) {
  if (Object.keys) {
    return Object.keys(object);
  }
  var result = [];

  forEach(object, function(val, key) {
    result.push(key);
  });
  return result;
}

/**
 * IE8-safe wrapper for `Array.prototype.indexOf()`.
 *
 * @param {Array} array A JavaScript array.
 * @param {*} value A value to search the array for.
 * @return {Number} Returns the array index value of `value`, or `-1` if not present.
 */
function indexOf(array, value) {
  if (Array.prototype.indexOf) {
    return array.indexOf(value, Number(arguments[2]) || 0);
  }
  var len = array.length >>> 0, from = Number(arguments[2]) || 0;
  from = (from < 0) ? Math.ceil(from) : Math.floor(from);

  if (from < 0) from += len;

  for (; from < len; from++) {
    if (from in array && array[from] === value) return from;
  }
  return -1;
}

/**
 * Merges a set of parameters with all parameters inherited between the common parents of the
 * current state and a given destination state.
 *
 * @param {Object} currentParams The value of the current state parameters ($stateParams).
 * @param {Object} newParams The set of parameters which will be composited with inherited params.
 * @param {Object} $current Internal definition of object representing the current state.
 * @param {Object} $to Internal definition of object representing state to transition to.
 */
function inheritParams(currentParams, newParams, $current, $to) {
  var parents = ancestors($current, $to), parentParams, inherited = {}, inheritList = [];

  for (var i in parents) {
    if (!parents[i] || !parents[i].params) continue;
    parentParams = objectKeys(parents[i].params);
    if (!parentParams.length) continue;

    for (var j in parentParams) {
      if (indexOf(inheritList, parentParams[j]) >= 0) continue;
      inheritList.push(parentParams[j]);
      inherited[parentParams[j]] = currentParams[parentParams[j]];
    }
  }
  return extend({}, inherited, newParams);
}

/**
 * Performs a non-strict comparison of the subset of two objects, defined by a list of keys.
 *
 * @param {Object} a The first object.
 * @param {Object} b The second object.
 * @param {Array} keys The list of keys within each object to compare. If the list is empty or not specified,
 *                     it defaults to the list of keys in `a`.
 * @return {Boolean} Returns `true` if the keys match, otherwise `false`.
 */
function equalForKeys(a, b, keys) {
  if (!keys) {
    keys = [];
    for (var n in a) keys.push(n); // Used instead of Object.keys() for IE8 compatibility
  }

  for (var i=0; i<keys.length; i++) {
    var k = keys[i];
    if (a[k] != b[k]) return false; // Not '===', values aren't necessarily normalized
  }
  return true;
}

/**
 * Returns the subset of an object, based on a list of keys.
 *
 * @param {Array} keys
 * @param {Object} values
 * @return {Boolean} Returns a subset of `values`.
 */
function filterByKeys(keys, values) {
  var filtered = {};

  forEach(keys, function (name) {
    filtered[name] = values[name];
  });
  return filtered;
}

// like _.indexBy
// when you know that your index values will be unique, or you want last-one-in to win
function indexBy(array, propName) {
  var result = {};
  forEach(array, function(item) {
    result[item[propName]] = item;
  });
  return result;
}

// extracted from underscore.js
// Return a copy of the object only containing the whitelisted properties.
function pick(obj) {
  var copy = {};
  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
  forEach(keys, function(key) {
    if (key in obj) copy[key] = obj[key];
  });
  return copy;
}

// extracted from underscore.js
// Return a copy of the object omitting the blacklisted properties.
function omit(obj) {
  var copy = {};
  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
  for (var key in obj) {
    if (indexOf(keys, key) == -1) copy[key] = obj[key];
  }
  return copy;
}

function pluck(collection, key) {
  var result = isArray(collection) ? [] : {};

  forEach(collection, function(val, i) {
    result[i] = isFunction(key) ? key(val) : val[key];
  });
  return result;
}

function filter(collection, callback) {
  var array = isArray(collection);
  var result = array ? [] : {};
  forEach(collection, function(val, i) {
    if (callback(val, i)) {
      result[array ? result.length : i] = val;
    }
  });
  return result;
}

function map(collection, callback) {
  var result = isArray(collection) ? [] : {};

  forEach(collection, function(val, i) {
    result[i] = callback(val, i);
  });
  return result;
}

/**
 * @ngdoc overview
 * @name ui.router.util
 *
 * @description
 * # ui.router.util sub-module
 *
 * This module is a dependency of other sub-modules. Do not include this module as a dependency
 * in your angular app (use {@link ui.router} module instead).
 *
 */
angular.module('ui.router.util', ['ng']);

/**
 * @ngdoc overview
 * @name ui.router.router
 * 
 * @requires ui.router.util
 *
 * @description
 * # ui.router.router sub-module
 *
 * This module is a dependency of other sub-modules. Do not include this module as a dependency
 * in your angular app (use {@link ui.router} module instead).
 */
angular.module('ui.router.router', ['ui.router.util']);

/**
 * @ngdoc overview
 * @name ui.router.state
 * 
 * @requires ui.router.router
 * @requires ui.router.util
 *
 * @description
 * # ui.router.state sub-module
 *
 * This module is a dependency of the main ui.router module. Do not include this module as a dependency
 * in your angular app (use {@link ui.router} module instead).
 * 
 */
angular.module('ui.router.state', ['ui.router.router', 'ui.router.util']);

/**
 * @ngdoc overview
 * @name ui.router
 *
 * @requires ui.router.state
 *
 * @description
 * # ui.router
 * 
 * ## The main module for ui.router 
 * There are several sub-modules included with the ui.router module, however only this module is needed
 * as a dependency within your angular app. The other modules are for organization purposes. 
 *
 * The modules are:
 * * ui.router - the main "umbrella" module
 * * ui.router.router - 
 * 
 * *You'll need to include **only** this module as the dependency within your angular app.*
 * 
 * <pre>
 * <!doctype html>
 * <html ng-app="myApp">
 * <head>
 *   <script src="js/angular.js"></script>
 *   <!-- Include the ui-router script -->
 *   <script src="js/angular-ui-router.min.js"></script>
 *   <script>
 *     // ...and add 'ui.router' as a dependency
 *     var myApp = angular.module('myApp', ['ui.router']);
 *   </script>
 * </head>
 * <body>
 * </body>
 * </html>
 * </pre>
 */
angular.module('ui.router', ['ui.router.state']);

angular.module('ui.router.compat', ['ui.router']);

/**
 * @ngdoc object
 * @name ui.router.util.$resolve
 *
 * @requires $q
 * @requires $injector
 *
 * @description
 * Manages resolution of (acyclic) graphs of promises.
 */
$Resolve.$inject = ['$q', '$injector'];
function $Resolve(  $q,    $injector) {
  
  var VISIT_IN_PROGRESS = 1,
      VISIT_DONE = 2,
      NOTHING = {},
      NO_DEPENDENCIES = [],
      NO_LOCALS = NOTHING,
      NO_PARENT = extend($q.when(NOTHING), { $$promises: NOTHING, $$values: NOTHING });
  

  /**
   * @ngdoc function
   * @name ui.router.util.$resolve#study
   * @methodOf ui.router.util.$resolve
   *
   * @description
   * Studies a set of invocables that are likely to be used multiple times.
   * <pre>
   * $resolve.study(invocables)(locals, parent, self)
   * </pre>
   * is equivalent to
   * <pre>
   * $resolve.resolve(invocables, locals, parent, self)
   * </pre>
   * but the former is more efficient (in fact `resolve` just calls `study` 
   * internally).
   *
   * @param {object} invocables Invocable objects
   * @return {function} a function to pass in locals, parent and self
   */
  this.study = function (invocables) {
    if (!isObject(invocables)) throw new Error("'invocables' must be an object");
    var invocableKeys = objectKeys(invocables || {});
    
    // Perform a topological sort of invocables to build an ordered plan
    var plan = [], cycle = [], visited = {};
    function visit(value, key) {
      if (visited[key] === VISIT_DONE) return;
      
      cycle.push(key);
      if (visited[key] === VISIT_IN_PROGRESS) {
        cycle.splice(0, indexOf(cycle, key));
        throw new Error("Cyclic dependency: " + cycle.join(" -> "));
      }
      visited[key] = VISIT_IN_PROGRESS;
      
      if (isString(value)) {
        plan.push(key, [ function() { return $injector.get(value); }], NO_DEPENDENCIES);
      } else {
        var params = $injector.annotate(value);
        forEach(params, function (param) {
          if (param !== key && invocables.hasOwnProperty(param)) visit(invocables[param], param);
        });
        plan.push(key, value, params);
      }
      
      cycle.pop();
      visited[key] = VISIT_DONE;
    }
    forEach(invocables, visit);
    invocables = cycle = visited = null; // plan is all that's required
    
    function isResolve(value) {
      return isObject(value) && value.then && value.$$promises;
    }
    
    return function (locals, parent, self) {
      if (isResolve(locals) && self === undefined) {
        self = parent; parent = locals; locals = null;
      }
      if (!locals) locals = NO_LOCALS;
      else if (!isObject(locals)) {
        throw new Error("'locals' must be an object");
      }       
      if (!parent) parent = NO_PARENT;
      else if (!isResolve(parent)) {
        throw new Error("'parent' must be a promise returned by $resolve.resolve()");
      }
      
      // To complete the overall resolution, we have to wait for the parent
      // promise and for the promise for each invokable in our plan.
      var resolution = $q.defer(),
          result = resolution.promise,
          promises = result.$$promises = {},
          values = extend({}, locals),
          wait = 1 + plan.length/3,
          merged = false;
          
      function done() {
        // Merge parent values we haven't got yet and publish our own $$values
        if (!--wait) {
          if (!merged) merge(values, parent.$$values); 
          result.$$values = values;
          result.$$promises = result.$$promises || true; // keep for isResolve()
          delete result.$$inheritedValues;
          resolution.resolve(values);
        }
      }
      
      function fail(reason) {
        result.$$failure = reason;
        resolution.reject(reason);
      }

      // Short-circuit if parent has already failed
      if (isDefined(parent.$$failure)) {
        fail(parent.$$failure);
        return result;
      }
      
      if (parent.$$inheritedValues) {
        merge(values, omit(parent.$$inheritedValues, invocableKeys));
      }

      // Merge parent values if the parent has already resolved, or merge
      // parent promises and wait if the parent resolve is still in progress.
      extend(promises, parent.$$promises);
      if (parent.$$values) {
        merged = merge(values, omit(parent.$$values, invocableKeys));
        result.$$inheritedValues = omit(parent.$$values, invocableKeys);
        done();
      } else {
        if (parent.$$inheritedValues) {
          result.$$inheritedValues = omit(parent.$$inheritedValues, invocableKeys);
        }        
        parent.then(done, fail);
      }
      
      // Process each invocable in the plan, but ignore any where a local of the same name exists.
      for (var i=0, ii=plan.length; i<ii; i+=3) {
        if (locals.hasOwnProperty(plan[i])) done();
        else invoke(plan[i], plan[i+1], plan[i+2]);
      }
      
      function invoke(key, invocable, params) {
        // Create a deferred for this invocation. Failures will propagate to the resolution as well.
        var invocation = $q.defer(), waitParams = 0;
        function onfailure(reason) {
          invocation.reject(reason);
          fail(reason);
        }
        // Wait for any parameter that we have a promise for (either from parent or from this
        // resolve; in that case study() will have made sure it's ordered before us in the plan).
        forEach(params, function (dep) {
          if (promises.hasOwnProperty(dep) && !locals.hasOwnProperty(dep)) {
            waitParams++;
            promises[dep].then(function (result) {
              values[dep] = result;
              if (!(--waitParams)) proceed();
            }, onfailure);
          }
        });
        if (!waitParams) proceed();
        function proceed() {
          if (isDefined(result.$$failure)) return;
          try {
            invocation.resolve($injector.invoke(invocable, self, values));
            invocation.promise.then(function (result) {
              values[key] = result;
              done();
            }, onfailure);
          } catch (e) {
            onfailure(e);
          }
        }
        // Publish promise synchronously; invocations further down in the plan may depend on it.
        promises[key] = invocation.promise;
      }
      
      return result;
    };
  };
  
  /**
   * @ngdoc function
   * @name ui.router.util.$resolve#resolve
   * @methodOf ui.router.util.$resolve
   *
   * @description
   * Resolves a set of invocables. An invocable is a function to be invoked via 
   * `$injector.invoke()`, and can have an arbitrary number of dependencies. 
   * An invocable can either return a value directly,
   * or a `$q` promise. If a promise is returned it will be resolved and the 
   * resulting value will be used instead. Dependencies of invocables are resolved 
   * (in this order of precedence)
   *
   * - from the specified `locals`
   * - from another invocable that is part of this `$resolve` call
   * - from an invocable that is inherited from a `parent` call to `$resolve` 
   *   (or recursively
   * - from any ancestor `$resolve` of that parent).
   *
   * The return value of `$resolve` is a promise for an object that contains 
   * (in this order of precedence)
   *
   * - any `locals` (if specified)
   * - the resolved return values of all injectables
   * - any values inherited from a `parent` call to `$resolve` (if specified)
   *
   * The promise will resolve after the `parent` promise (if any) and all promises 
   * returned by injectables have been resolved. If any invocable 
   * (or `$injector.invoke`) throws an exception, or if a promise returned by an 
   * invocable is rejected, the `$resolve` promise is immediately rejected with the 
   * same error. A rejection of a `parent` promise (if specified) will likewise be 
   * propagated immediately. Once the `$resolve` promise has been rejected, no 
   * further invocables will be called.
   * 
   * Cyclic dependencies between invocables are not permitted and will cause `$resolve`
   * to throw an error. As a special case, an injectable can depend on a parameter 
   * with the same name as the injectable, which will be fulfilled from the `parent` 
   * injectable of the same name. This allows inherited values to be decorated. 
   * Note that in this case any other injectable in the same `$resolve` with the same
   * dependency would see the decorated value, not the inherited value.
   *
   * Note that missing dependencies -- unlike cyclic dependencies -- will cause an 
   * (asynchronous) rejection of the `$resolve` promise rather than a (synchronous) 
   * exception.
   *
   * Invocables are invoked eagerly as soon as all dependencies are available. 
   * This is true even for dependencies inherited from a `parent` call to `$resolve`.
   *
   * As a special case, an invocable can be a string, in which case it is taken to 
   * be a service name to be passed to `$injector.get()`. This is supported primarily 
   * for backwards-compatibility with the `resolve` property of `$routeProvider` 
   * routes.
   *
   * @param {object} invocables functions to invoke or 
   * `$injector` services to fetch.
   * @param {object} locals  values to make available to the injectables
   * @param {object} parent  a promise returned by another call to `$resolve`.
   * @param {object} self  the `this` for the invoked methods
   * @return {object} Promise for an object that contains the resolved return value
   * of all invocables, as well as any inherited and local values.
   */
  this.resolve = function (invocables, locals, parent, self) {
    return this.study(invocables)(locals, parent, self);
  };
}

angular.module('ui.router.util').service('$resolve', $Resolve);


/**
 * @ngdoc object
 * @name ui.router.util.$templateFactory
 *
 * @requires $http
 * @requires $templateCache
 * @requires $injector
 *
 * @description
 * Service. Manages loading of templates.
 */
$TemplateFactory.$inject = ['$http', '$templateCache', '$injector'];
function $TemplateFactory(  $http,   $templateCache,   $injector) {

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromConfig
   * @methodOf ui.router.util.$templateFactory
   *
   * @description
   * Creates a template from a configuration object. 
   *
   * @param {object} config Configuration object for which to load a template. 
   * The following properties are search in the specified order, and the first one 
   * that is defined is used to create the template:
   *
   * @param {string|object} config.template html string template or function to 
   * load via {@link ui.router.util.$templateFactory#fromString fromString}.
   * @param {string|object} config.templateUrl url to load or a function returning 
   * the url to load via {@link ui.router.util.$templateFactory#fromUrl fromUrl}.
   * @param {Function} config.templateProvider function to invoke via 
   * {@link ui.router.util.$templateFactory#fromProvider fromProvider}.
   * @param {object} params  Parameters to pass to the template function.
   * @param {object} locals Locals to pass to `invoke` if the template is loaded 
   * via a `templateProvider`. Defaults to `{ params: params }`.
   *
   * @return {string|object}  The template html as a string, or a promise for 
   * that string,or `null` if no template is configured.
   */
  this.fromConfig = function (config, params, locals) {
    return (
      isDefined(config.template) ? this.fromString(config.template, params) :
      isDefined(config.templateUrl) ? this.fromUrl(config.templateUrl, params) :
      isDefined(config.templateProvider) ? this.fromProvider(config.templateProvider, params, locals) :
      null
    );
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromString
   * @methodOf ui.router.util.$templateFactory
   *
   * @description
   * Creates a template from a string or a function returning a string.
   *
   * @param {string|object} template html template as a string or function that 
   * returns an html template as a string.
   * @param {object} params Parameters to pass to the template function.
   *
   * @return {string|object} The template html as a string, or a promise for that 
   * string.
   */
  this.fromString = function (template, params) {
    return isFunction(template) ? template(params) : template;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromUrl
   * @methodOf ui.router.util.$templateFactory
   * 
   * @description
   * Loads a template from the a URL via `$http` and `$templateCache`.
   *
   * @param {string|Function} url url of the template to load, or a function 
   * that returns a url.
   * @param {Object} params Parameters to pass to the url function.
   * @return {string|Promise.<string>} The template html as a string, or a promise 
   * for that string.
   */
  this.fromUrl = function (url, params) {
    if (isFunction(url)) url = url(params);
    if (url == null) return null;
    else return $http
        .get(url, { cache: $templateCache, headers: { Accept: 'text/html' }})
        .then(function(response) { return response.data; });
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromProvider
   * @methodOf ui.router.util.$templateFactory
   *
   * @description
   * Creates a template by invoking an injectable provider function.
   *
   * @param {Function} provider Function to invoke via `$injector.invoke`
   * @param {Object} params Parameters for the template.
   * @param {Object} locals Locals to pass to `invoke`. Defaults to 
   * `{ params: params }`.
   * @return {string|Promise.<string>} The template html as a string, or a promise 
   * for that string.
   */
  this.fromProvider = function (provider, params, locals) {
    return $injector.invoke(provider, null, locals || { params: params });
  };
}

angular.module('ui.router.util').service('$templateFactory', $TemplateFactory);

var $$UMFP; // reference to $UrlMatcherFactoryProvider

/**
 * @ngdoc object
 * @name ui.router.util.type:UrlMatcher
 *
 * @description
 * Matches URLs against patterns and extracts named parameters from the path or the search
 * part of the URL. A URL pattern consists of a path pattern, optionally followed by '?' and a list
 * of search parameters. Multiple search parameter names are separated by '&'. Search parameters
 * do not influence whether or not a URL is matched, but their values are passed through into
 * the matched parameters returned by {@link ui.router.util.type:UrlMatcher#methods_exec exec}.
 *
 * Path parameter placeholders can be specified using simple colon/catch-all syntax or curly brace
 * syntax, which optionally allows a regular expression for the parameter to be specified:
 *
 * * `':'` name - colon placeholder
 * * `'*'` name - catch-all placeholder
 * * `'{' name '}'` - curly placeholder
 * * `'{' name ':' regexp|type '}'` - curly placeholder with regexp or type name. Should the
 *   regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
 *
 * Parameter names may contain only word characters (latin letters, digits, and underscore) and
 * must be unique within the pattern (across both path and search parameters). For colon
 * placeholders or curly placeholders without an explicit regexp, a path parameter matches any
 * number of characters other than '/'. For catch-all placeholders the path parameter matches
 * any number of characters.
 *
 * Examples:
 *
 * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
 *   trailing slashes, and patterns have to match the entire path, not just a prefix.
 * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
 *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
 * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
 * * `'/user/{id:[^/]*}'` - Same as the previous example.
 * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
 *   parameter consists of 1 to 8 hex digits.
 * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
 *   path into the parameter 'path'.
 * * `'/files/*path'` - ditto.
 * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
 *   in the built-in  `date` Type matches `2014-11-12`) and provides a Date object in $stateParams.start
 *
 * @param {string} pattern  The pattern to compile into a matcher.
 * @param {Object} config  A configuration object hash:
 * @param {Object=} parentMatcher Used to concatenate the pattern/config onto
 *   an existing UrlMatcher
 *
 * * `caseInsensitive` - `true` if URL matching should be case insensitive, otherwise `false`, the default value (for backward compatibility) is `false`.
 * * `strict` - `false` if matching against a URL with a trailing slash should be treated as equivalent to a URL without a trailing slash, the default value is `true`.
 *
 * @property {string} prefix  A static prefix of this pattern. The matcher guarantees that any
 *   URL matching this matcher (i.e. any string for which {@link ui.router.util.type:UrlMatcher#methods_exec exec()} returns
 *   non-null) will start with this prefix.
 *
 * @property {string} source  The pattern that was passed into the constructor
 *
 * @property {string} sourcePath  The path portion of the source property
 *
 * @property {string} sourceSearch  The search portion of the source property
 *
 * @property {string} regex  The constructed regex that will be used to match against the url when
 *   it is time to determine which url will match.
 *
 * @returns {Object}  New `UrlMatcher` object
 */
function UrlMatcher(pattern, config, parentMatcher) {
  config = extend({ params: {} }, isObject(config) ? config : {});

  // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
  //   '*' name
  //   ':' name
  //   '{' name '}'
  //   '{' name ':' regexp '}'
  // The regular expression is somewhat complicated due to the need to allow curly braces
  // inside the regular expression. The placeholder regexp breaks down as follows:
  //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
  //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
  //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
  //    [^{}\\]+                       - anything other than curly braces or backslash
  //    \\.                            - a backslash escape
  //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
  var placeholder       = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
      searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
      compiled = '^', last = 0, m,
      segments = this.segments = [],
      parentParams = parentMatcher ? parentMatcher.params : {},
      params = this.params = parentMatcher ? parentMatcher.params.$$new() : new $$UMFP.ParamSet(),
      paramNames = [];

  function addParameter(id, type, config, location) {
    paramNames.push(id);
    if (parentParams[id]) return parentParams[id];
    if (!/^\w+([-.]+\w+)*(?:\[\])?$/.test(id)) throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
    if (params[id]) throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
    params[id] = new $$UMFP.Param(id, type, config, location);
    return params[id];
  }

  function quoteRegExp(string, pattern, squash, optional) {
    var surroundPattern = ['',''], result = string.replace(/[\\\[\]\^$*+?.()|{}]/g, "\\$&");
    if (!pattern) return result;
    switch(squash) {
      case false: surroundPattern = ['(', ')' + (optional ? "?" : "")]; break;
      case true:
        result = result.replace(/\/$/, '');
        surroundPattern = ['(?:\/(', ')|\/)?'];
      break;
      default:    surroundPattern = ['(' + squash + "|", ')?']; break;
    }
    return result + surroundPattern[0] + pattern + surroundPattern[1];
  }

  this.source = pattern;

  // Split into static segments separated by path parameter placeholders.
  // The number of segments is always 1 more than the number of parameters.
  function matchDetails(m, isSearch) {
    var id, regexp, segment, type, cfg, arrayMode;
    id          = m[2] || m[3]; // IE[78] returns '' for unmatched groups instead of null
    cfg         = config.params[id];
    segment     = pattern.substring(last, m.index);
    regexp      = isSearch ? m[4] : m[4] || (m[1] == '*' ? '.*' : null);

    if (regexp) {
      type      = $$UMFP.type(regexp) || inherit($$UMFP.type("string"), { pattern: new RegExp(regexp, config.caseInsensitive ? 'i' : undefined) });
    }

    return {
      id: id, regexp: regexp, segment: segment, type: type, cfg: cfg
    };
  }

  var p, param, segment;
  while ((m = placeholder.exec(pattern))) {
    p = matchDetails(m, false);
    if (p.segment.indexOf('?') >= 0) break; // we're into the search part

    param = addParameter(p.id, p.type, p.cfg, "path");
    compiled += quoteRegExp(p.segment, param.type.pattern.source, param.squash, param.isOptional);
    segments.push(p.segment);
    last = placeholder.lastIndex;
  }
  segment = pattern.substring(last);

  // Find any search parameter names and remove them from the last segment
  var i = segment.indexOf('?');

  if (i >= 0) {
    var search = this.sourceSearch = segment.substring(i);
    segment = segment.substring(0, i);
    this.sourcePath = pattern.substring(0, last + i);

    if (search.length > 0) {
      last = 0;
      while ((m = searchPlaceholder.exec(search))) {
        p = matchDetails(m, true);
        param = addParameter(p.id, p.type, p.cfg, "search");
        last = placeholder.lastIndex;
        // check if ?&
      }
    }
  } else {
    this.sourcePath = pattern;
    this.sourceSearch = '';
  }

  compiled += quoteRegExp(segment) + (config.strict === false ? '\/?' : '') + '$';
  segments.push(segment);

  this.regexp = new RegExp(compiled, config.caseInsensitive ? 'i' : undefined);
  this.prefix = segments[0];
  this.$$paramNames = paramNames;
}

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#concat
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Returns a new matcher for a pattern constructed by appending the path part and adding the
 * search parameters of the specified pattern to this pattern. The current pattern is not
 * modified. This can be understood as creating a pattern for URLs that are relative to (or
 * suffixes of) the current pattern.
 *
 * @example
 * The following two matchers are equivalent:
 * <pre>
 * new UrlMatcher('/user/{id}?q').concat('/details?date');
 * new UrlMatcher('/user/{id}/details?q&date');
 * </pre>
 *
 * @param {string} pattern  The pattern to append.
 * @param {Object} config  An object hash of the configuration for the matcher.
 * @returns {UrlMatcher}  A matcher for the concatenated pattern.
 */
UrlMatcher.prototype.concat = function (pattern, config) {
  // Because order of search parameters is irrelevant, we can add our own search
  // parameters to the end of the new pattern. Parse the new pattern by itself
  // and then join the bits together, but it's much easier to do this on a string level.
  var defaultConfig = {
    caseInsensitive: $$UMFP.caseInsensitive(),
    strict: $$UMFP.strictMode(),
    squash: $$UMFP.defaultSquashPolicy()
  };
  return new UrlMatcher(this.sourcePath + pattern + this.sourceSearch, extend(defaultConfig, config), this);
};

UrlMatcher.prototype.toString = function () {
  return this.source;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#exec
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Tests the specified path against this matcher, and returns an object containing the captured
 * parameter values, or null if the path does not match. The returned object contains the values
 * of any search parameters that are mentioned in the pattern, but their value may be null if
 * they are not present in `searchParams`. This means that search parameters are always treated
 * as optional.
 *
 * @example
 * <pre>
 * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
 *   x: '1', q: 'hello'
 * });
 * // returns { id: 'bob', q: 'hello', r: null }
 * </pre>
 *
 * @param {string} path  The URL path to match, e.g. `$location.path()`.
 * @param {Object} searchParams  URL search parameters, e.g. `$location.search()`.
 * @returns {Object}  The captured parameter values.
 */
UrlMatcher.prototype.exec = function (path, searchParams) {
  var m = this.regexp.exec(path);
  if (!m) return null;
  searchParams = searchParams || {};

  var paramNames = this.parameters(), nTotal = paramNames.length,
    nPath = this.segments.length - 1,
    values = {}, i, j, cfg, paramName;

  if (nPath !== m.length - 1) throw new Error("Unbalanced capture group in route '" + this.source + "'");

  function decodePathArray(string) {
    function reverseString(str) { return str.split("").reverse().join(""); }
    function unquoteDashes(str) { return str.replace(/\\-/g, "-"); }

    var split = reverseString(string).split(/-(?!\\)/);
    var allReversed = map(split, reverseString);
    return map(allReversed, unquoteDashes).reverse();
  }

  var param, paramVal;
  for (i = 0; i < nPath; i++) {
    paramName = paramNames[i];
    param = this.params[paramName];
    paramVal = m[i+1];
    // if the param value matches a pre-replace pair, replace the value before decoding.
    for (j = 0; j < param.replace.length; j++) {
      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
    }
    if (paramVal && param.array === true) paramVal = decodePathArray(paramVal);
    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
    values[paramName] = param.value(paramVal);
  }
  for (/**/; i < nTotal; i++) {
    paramName = paramNames[i];
    values[paramName] = this.params[paramName].value(searchParams[paramName]);
    param = this.params[paramName];
    paramVal = searchParams[paramName];
    for (j = 0; j < param.replace.length; j++) {
      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
    }
    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
    values[paramName] = param.value(paramVal);
  }

  return values;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#parameters
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Returns the names of all path and search parameters of this pattern in an unspecified order.
 *
 * @returns {Array.<string>}  An array of parameter names. Must be treated as read-only. If the
 *    pattern has no parameters, an empty array is returned.
 */
UrlMatcher.prototype.parameters = function (param) {
  if (!isDefined(param)) return this.$$paramNames;
  return this.params[param] || null;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#validates
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Checks an object hash of parameters to validate their correctness according to the parameter
 * types of this `UrlMatcher`.
 *
 * @param {Object} params The object hash of parameters to validate.
 * @returns {boolean} Returns `true` if `params` validates, otherwise `false`.
 */
UrlMatcher.prototype.validates = function (params) {
  return this.params.$$validates(params);
};

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#format
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Creates a URL that matches this pattern by substituting the specified values
 * for the path and search parameters. Null values for path parameters are
 * treated as empty strings.
 *
 * @example
 * <pre>
 * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
 * // returns '/user/bob?q=yes'
 * </pre>
 *
 * @param {Object} values  the values to substitute for the parameters in this pattern.
 * @returns {string}  the formatted URL (path and optionally search part).
 */
UrlMatcher.prototype.format = function (values) {
  values = values || {};
  var segments = this.segments, params = this.parameters(), paramset = this.params;
  if (!this.validates(values)) return null;

  var i, search = false, nPath = segments.length - 1, nTotal = params.length, result = segments[0];

  function encodeDashes(str) { // Replace dashes with encoded "\-"
    return encodeURIComponent(str).replace(/-/g, function(c) { return '%5C%' + c.charCodeAt(0).toString(16).toUpperCase(); });
  }

  for (i = 0; i < nTotal; i++) {
    var isPathParam = i < nPath;
    var name = params[i], param = paramset[name], value = param.value(values[name]);
    var isDefaultValue = param.isOptional && param.type.equals(param.value(), value);
    var squash = isDefaultValue ? param.squash : false;
    var encoded = param.type.encode(value);

    if (isPathParam) {
      var nextSegment = segments[i + 1];
      var isFinalPathParam = i + 1 === nPath;

      if (squash === false) {
        if (encoded != null) {
          if (isArray(encoded)) {
            result += map(encoded, encodeDashes).join("-");
          } else {
            result += encodeURIComponent(encoded);
          }
        }
        result += nextSegment;
      } else if (squash === true) {
        var capture = result.match(/\/$/) ? /\/?(.*)/ : /(.*)/;
        result += nextSegment.match(capture)[1];
      } else if (isString(squash)) {
        result += squash + nextSegment;
      }

      if (isFinalPathParam && param.squash === true && result.slice(-1) === '/') result = result.slice(0, -1);
    } else {
      if (encoded == null || (isDefaultValue && squash !== false)) continue;
      if (!isArray(encoded)) encoded = [ encoded ];
      if (encoded.length === 0) continue;
      encoded = map(encoded, encodeURIComponent).join('&' + name + '=');
      result += (search ? '&' : '?') + (name + '=' + encoded);
      search = true;
    }
  }

  return result;
};

/**
 * @ngdoc object
 * @name ui.router.util.type:Type
 *
 * @description
 * Implements an interface to define custom parameter types that can be decoded from and encoded to
 * string parameters matched in a URL. Used by {@link ui.router.util.type:UrlMatcher `UrlMatcher`}
 * objects when matching or formatting URLs, or comparing or validating parameter values.
 *
 * See {@link ui.router.util.$urlMatcherFactory#methods_type `$urlMatcherFactory#type()`} for more
 * information on registering custom types.
 *
 * @param {Object} config  A configuration object which contains the custom type definition.  The object's
 *        properties will override the default methods and/or pattern in `Type`'s public interface.
 * @example
 * <pre>
 * {
 *   decode: function(val) { return parseInt(val, 10); },
 *   encode: function(val) { return val && val.toString(); },
 *   equals: function(a, b) { return this.is(a) && a === b; },
 *   is: function(val) { return angular.isNumber(val) isFinite(val) && val % 1 === 0; },
 *   pattern: /\d+/
 * }
 * </pre>
 *
 * @property {RegExp} pattern The regular expression pattern used to match values of this type when
 *           coming from a substring of a URL.
 *
 * @returns {Object}  Returns a new `Type` object.
 */
function Type(config) {
  extend(this, config);
}

/**
 * @ngdoc function
 * @name ui.router.util.type:Type#is
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Detects whether a value is of a particular type. Accepts a native (decoded) value
 * and determines whether it matches the current `Type` object.
 *
 * @param {*} val  The value to check.
 * @param {string} key  Optional. If the type check is happening in the context of a specific
 *        {@link ui.router.util.type:UrlMatcher `UrlMatcher`} object, this is the name of the
 *        parameter in which `val` is stored. Can be used for meta-programming of `Type` objects.
 * @returns {Boolean}  Returns `true` if the value matches the type, otherwise `false`.
 */
Type.prototype.is = function(val, key) {
  return true;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:Type#encode
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Encodes a custom/native type value to a string that can be embedded in a URL. Note that the
 * return value does *not* need to be URL-safe (i.e. passed through `encodeURIComponent()`), it
 * only needs to be a representation of `val` that has been coerced to a string.
 *
 * @param {*} val  The value to encode.
 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
 *        meta-programming of `Type` objects.
 * @returns {string}  Returns a string representation of `val` that can be encoded in a URL.
 */
Type.prototype.encode = function(val, key) {
  return val;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:Type#decode
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Converts a parameter value (from URL string or transition param) to a custom/native value.
 *
 * @param {string} val  The URL parameter value to decode.
 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
 *        meta-programming of `Type` objects.
 * @returns {*}  Returns a custom representation of the URL parameter value.
 */
Type.prototype.decode = function(val, key) {
  return val;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:Type#equals
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Determines whether two decoded values are equivalent.
 *
 * @param {*} a  A value to compare against.
 * @param {*} b  A value to compare against.
 * @returns {Boolean}  Returns `true` if the values are equivalent/equal, otherwise `false`.
 */
Type.prototype.equals = function(a, b) {
  return a == b;
};

Type.prototype.$subPattern = function() {
  var sub = this.pattern.toString();
  return sub.substr(1, sub.length - 2);
};

Type.prototype.pattern = /.*/;

Type.prototype.toString = function() { return "{Type:" + this.name + "}"; };

/** Given an encoded string, or a decoded object, returns a decoded object */
Type.prototype.$normalize = function(val) {
  return this.is(val) ? val : this.decode(val);
};

/*
 * Wraps an existing custom Type as an array of Type, depending on 'mode'.
 * e.g.:
 * - urlmatcher pattern "/path?{queryParam[]:int}"
 * - url: "/path?queryParam=1&queryParam=2
 * - $stateParams.queryParam will be [1, 2]
 * if `mode` is "auto", then
 * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
 * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
 */
Type.prototype.$asArray = function(mode, isSearch) {
  if (!mode) return this;
  if (mode === "auto" && !isSearch) throw new Error("'auto' array mode is for query parameters only");

  function ArrayType(type, mode) {
    function bindTo(type, callbackName) {
      return function() {
        return type[callbackName].apply(type, arguments);
      };
    }

    // Wrap non-array value as array
    function arrayWrap(val) { return isArray(val) ? val : (isDefined(val) ? [ val ] : []); }
    // Unwrap array value for "auto" mode. Return undefined for empty array.
    function arrayUnwrap(val) {
      switch(val.length) {
        case 0: return undefined;
        case 1: return mode === "auto" ? val[0] : val;
        default: return val;
      }
    }
    function falsey(val) { return !val; }

    // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
    function arrayHandler(callback, allTruthyMode) {
      return function handleArray(val) {
        if (isArray(val) && val.length === 0) return val;
        val = arrayWrap(val);
        var result = map(val, callback);
        if (allTruthyMode === true)
          return filter(result, falsey).length === 0;
        return arrayUnwrap(result);
      };
    }

    // Wraps type (.equals) functions to operate on each value of an array
    function arrayEqualsHandler(callback) {
      return function handleArray(val1, val2) {
        var left = arrayWrap(val1), right = arrayWrap(val2);
        if (left.length !== right.length) return false;
        for (var i = 0; i < left.length; i++) {
          if (!callback(left[i], right[i])) return false;
        }
        return true;
      };
    }

    this.encode = arrayHandler(bindTo(type, 'encode'));
    this.decode = arrayHandler(bindTo(type, 'decode'));
    this.is     = arrayHandler(bindTo(type, 'is'), true);
    this.equals = arrayEqualsHandler(bindTo(type, 'equals'));
    this.pattern = type.pattern;
    this.$normalize = arrayHandler(bindTo(type, '$normalize'));
    this.name = type.name;
    this.$arrayMode = mode;
  }

  return new ArrayType(this, mode);
};



/**
 * @ngdoc object
 * @name ui.router.util.$urlMatcherFactory
 *
 * @description
 * Factory for {@link ui.router.util.type:UrlMatcher `UrlMatcher`} instances. The factory
 * is also available to providers under the name `$urlMatcherFactoryProvider`.
 */
function $UrlMatcherFactory() {
  $$UMFP = this;

  var isCaseInsensitive = false, isStrictMode = true, defaultSquashPolicy = false;

  // Use tildes to pre-encode slashes.
  // If the slashes are simply URLEncoded, the browser can choose to pre-decode them,
  // and bidirectional encoding/decoding fails.
  // Tilde was chosen because it's not a RFC 3986 section 2.2 Reserved Character
  function valToString(val) { return val != null ? val.toString().replace(/~/g, "~~").replace(/\//g, "~2F") : val; }
  function valFromString(val) { return val != null ? val.toString().replace(/~2F/g, "/").replace(/~~/g, "~") : val; }

  var $types = {}, enqueue = true, typeQueue = [], injector, defaultTypes = {
    "string": {
      encode: valToString,
      decode: valFromString,
      // TODO: in 1.0, make string .is() return false if value is undefined/null by default.
      // In 0.2.x, string params are optional by default for backwards compat
      is: function(val) { return val == null || !isDefined(val) || typeof val === "string"; },
      pattern: /[^/]*/
    },
    "int": {
      encode: valToString,
      decode: function(val) { return parseInt(val, 10); },
      is: function(val) { return isDefined(val) && this.decode(val.toString()) === val; },
      pattern: /\d+/
    },
    "bool": {
      encode: function(val) { return val ? 1 : 0; },
      decode: function(val) { return parseInt(val, 10) !== 0; },
      is: function(val) { return val === true || val === false; },
      pattern: /0|1/
    },
    "date": {
      encode: function (val) {
        if (!this.is(val))
          return undefined;
        return [ val.getFullYear(),
          ('0' + (val.getMonth() + 1)).slice(-2),
          ('0' + val.getDate()).slice(-2)
        ].join("-");
      },
      decode: function (val) {
        if (this.is(val)) return val;
        var match = this.capture.exec(val);
        return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
      },
      is: function(val) { return val instanceof Date && !isNaN(val.valueOf()); },
      equals: function (a, b) { return this.is(a) && this.is(b) && a.toISOString() === b.toISOString(); },
      pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
      capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/
    },
    "json": {
      encode: angular.toJson,
      decode: angular.fromJson,
      is: angular.isObject,
      equals: angular.equals,
      pattern: /[^/]*/
    },
    "any": { // does not encode/decode
      encode: angular.identity,
      decode: angular.identity,
      equals: angular.equals,
      pattern: /.*/
    }
  };

  function getDefaultConfig() {
    return {
      strict: isStrictMode,
      caseInsensitive: isCaseInsensitive
    };
  }

  function isInjectable(value) {
    return (isFunction(value) || (isArray(value) && isFunction(value[value.length - 1])));
  }

  /**
   * [Internal] Get the default value of a parameter, which may be an injectable function.
   */
  $UrlMatcherFactory.$$getDefaultValue = function(config) {
    if (!isInjectable(config.value)) return config.value;
    if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
    return injector.invoke(config.value);
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#caseInsensitive
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Defines whether URL matching should be case sensitive (the default behavior), or not.
   *
   * @param {boolean} value `false` to match URL in a case sensitive manner; otherwise `true`;
   * @returns {boolean} the current value of caseInsensitive
   */
  this.caseInsensitive = function(value) {
    if (isDefined(value))
      isCaseInsensitive = value;
    return isCaseInsensitive;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#strictMode
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Defines whether URLs should match trailing slashes, or not (the default behavior).
   *
   * @param {boolean=} value `false` to match trailing slashes in URLs, otherwise `true`.
   * @returns {boolean} the current value of strictMode
   */
  this.strictMode = function(value) {
    if (isDefined(value))
      isStrictMode = value;
    return isStrictMode;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#defaultSquashPolicy
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Sets the default behavior when generating or matching URLs with default parameter values.
   *
   * @param {string} value A string that defines the default parameter URL squashing behavior.
   *    `nosquash`: When generating an href with a default parameter value, do not squash the parameter value from the URL
   *    `slash`: When generating an href with a default parameter value, squash (remove) the parameter value, and, if the
   *             parameter is surrounded by slashes, squash (remove) one slash from the URL
   *    any other string, e.g. "~": When generating an href with a default parameter value, squash (remove)
   *             the parameter value from the URL and replace it with this string.
   */
  this.defaultSquashPolicy = function(value) {
    if (!isDefined(value)) return defaultSquashPolicy;
    if (value !== true && value !== false && !isString(value))
      throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
    defaultSquashPolicy = value;
    return value;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#compile
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Creates a {@link ui.router.util.type:UrlMatcher `UrlMatcher`} for the specified pattern.
   *
   * @param {string} pattern  The URL pattern.
   * @param {Object} config  The config object hash.
   * @returns {UrlMatcher}  The UrlMatcher.
   */
  this.compile = function (pattern, config) {
    return new UrlMatcher(pattern, extend(getDefaultConfig(), config));
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#isMatcher
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Returns true if the specified object is a `UrlMatcher`, or false otherwise.
   *
   * @param {Object} object  The object to perform the type check against.
   * @returns {Boolean}  Returns `true` if the object matches the `UrlMatcher` interface, by
   *          implementing all the same methods.
   */
  this.isMatcher = function (o) {
    if (!isObject(o)) return false;
    var result = true;

    forEach(UrlMatcher.prototype, function(val, name) {
      if (isFunction(val)) {
        result = result && (isDefined(o[name]) && isFunction(o[name]));
      }
    });
    return result;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#type
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Registers a custom {@link ui.router.util.type:Type `Type`} object that can be used to
   * generate URLs with typed parameters.
   *
   * @param {string} name  The type name.
   * @param {Object|Function} definition   The type definition. See
   *        {@link ui.router.util.type:Type `Type`} for information on the values accepted.
   * @param {Object|Function} definitionFn (optional) A function that is injected before the app
   *        runtime starts.  The result of this function is merged into the existing `definition`.
   *        See {@link ui.router.util.type:Type `Type`} for information on the values accepted.
   *
   * @returns {Object}  Returns `$urlMatcherFactoryProvider`.
   *
   * @example
   * This is a simple example of a custom type that encodes and decodes items from an
   * array, using the array index as the URL-encoded value:
   *
   * <pre>
   * var list = ['John', 'Paul', 'George', 'Ringo'];
   *
   * $urlMatcherFactoryProvider.type('listItem', {
   *   encode: function(item) {
   *     // Represent the list item in the URL using its corresponding index
   *     return list.indexOf(item);
   *   },
   *   decode: function(item) {
   *     // Look up the list item by index
   *     return list[parseInt(item, 10)];
   *   },
   *   is: function(item) {
   *     // Ensure the item is valid by checking to see that it appears
   *     // in the list
   *     return list.indexOf(item) > -1;
   *   }
   * });
   *
   * $stateProvider.state('list', {
   *   url: "/list/{item:listItem}",
   *   controller: function($scope, $stateParams) {
   *     console.log($stateParams.item);
   *   }
   * });
   *
   * // ...
   *
   * // Changes URL to '/list/3', logs "Ringo" to the console
   * $state.go('list', { item: "Ringo" });
   * </pre>
   *
   * This is a more complex example of a type that relies on dependency injection to
   * interact with services, and uses the parameter name from the URL to infer how to
   * handle encoding and decoding parameter values:
   *
   * <pre>
   * // Defines a custom type that gets a value from a service,
   * // where each service gets different types of values from
   * // a backend API:
   * $urlMatcherFactoryProvider.type('dbObject', {}, function(Users, Posts) {
   *
   *   // Matches up services to URL parameter names
   *   var services = {
   *     user: Users,
   *     post: Posts
   *   };
   *
   *   return {
   *     encode: function(object) {
   *       // Represent the object in the URL using its unique ID
   *       return object.id;
   *     },
   *     decode: function(value, key) {
   *       // Look up the object by ID, using the parameter
   *       // name (key) to call the correct service
   *       return services[key].findById(value);
   *     },
   *     is: function(object, key) {
   *       // Check that object is a valid dbObject
   *       return angular.isObject(object) && object.id && services[key];
   *     }
   *     equals: function(a, b) {
   *       // Check the equality of decoded objects by comparing
   *       // their unique IDs
   *       return a.id === b.id;
   *     }
   *   };
   * });
   *
   * // In a config() block, you can then attach URLs with
   * // type-annotated parameters:
   * $stateProvider.state('users', {
   *   url: "/users",
   *   // ...
   * }).state('users.item', {
   *   url: "/{user:dbObject}",
   *   controller: function($scope, $stateParams) {
   *     // $stateParams.user will now be an object returned from
   *     // the Users service
   *   },
   *   // ...
   * });
   * </pre>
   */
  this.type = function (name, definition, definitionFn) {
    if (!isDefined(definition)) return $types[name];
    if ($types.hasOwnProperty(name)) throw new Error("A type named '" + name + "' has already been defined.");

    $types[name] = new Type(extend({ name: name }, definition));
    if (definitionFn) {
      typeQueue.push({ name: name, def: definitionFn });
      if (!enqueue) flushTypeQueue();
    }
    return this;
  };

  // `flushTypeQueue()` waits until `$urlMatcherFactory` is injected before invoking the queued `definitionFn`s
  function flushTypeQueue() {
    while(typeQueue.length) {
      var type = typeQueue.shift();
      if (type.pattern) throw new Error("You cannot override a type's .pattern at runtime.");
      angular.extend($types[type.name], injector.invoke(type.def));
    }
  }

  // Register default types. Store them in the prototype of $types.
  forEach(defaultTypes, function(type, name) { $types[name] = new Type(extend({name: name}, type)); });
  $types = inherit($types, {});

  /* No need to document $get, since it returns this */
  this.$get = ['$injector', function ($injector) {
    injector = $injector;
    enqueue = false;
    flushTypeQueue();

    forEach(defaultTypes, function(type, name) {
      if (!$types[name]) $types[name] = new Type(type);
    });
    return this;
  }];

  this.Param = function Param(id, type, config, location) {
    var self = this;
    config = unwrapShorthand(config);
    type = getType(config, type, location);
    var arrayMode = getArrayMode();
    type = arrayMode ? type.$asArray(arrayMode, location === "search") : type;
    if (type.name === "string" && !arrayMode && location === "path" && config.value === undefined)
      config.value = ""; // for 0.2.x; in 0.3.0+ do not automatically default to ""
    var isOptional = config.value !== undefined;
    var squash = getSquashPolicy(config, isOptional);
    var replace = getReplace(config, arrayMode, isOptional, squash);

    function unwrapShorthand(config) {
      var keys = isObject(config) ? objectKeys(config) : [];
      var isShorthand = indexOf(keys, "value") === -1 && indexOf(keys, "type") === -1 &&
                        indexOf(keys, "squash") === -1 && indexOf(keys, "array") === -1;
      if (isShorthand) config = { value: config };
      config.$$fn = isInjectable(config.value) ? config.value : function () { return config.value; };
      return config;
    }

    function getType(config, urlType, location) {
      if (config.type && urlType) throw new Error("Param '"+id+"' has two type configurations.");
      if (urlType) return urlType;
      if (!config.type) return (location === "config" ? $types.any : $types.string);

      if (angular.isString(config.type))
        return $types[config.type];
      if (config.type instanceof Type)
        return config.type;
      return new Type(config.type);
    }

    // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
    function getArrayMode() {
      var arrayDefaults = { array: (location === "search" ? "auto" : false) };
      var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
      return extend(arrayDefaults, arrayParamNomenclature, config).array;
    }

    /**
     * returns false, true, or the squash value to indicate the "default parameter url squash policy".
     */
    function getSquashPolicy(config, isOptional) {
      var squash = config.squash;
      if (!isOptional || squash === false) return false;
      if (!isDefined(squash) || squash == null) return defaultSquashPolicy;
      if (squash === true || isString(squash)) return squash;
      throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
    }

    function getReplace(config, arrayMode, isOptional, squash) {
      var replace, configuredKeys, defaultPolicy = [
        { from: "",   to: (isOptional || arrayMode ? undefined : "") },
        { from: null, to: (isOptional || arrayMode ? undefined : "") }
      ];
      replace = isArray(config.replace) ? config.replace : [];
      if (isString(squash))
        replace.push({ from: squash, to: undefined });
      configuredKeys = map(replace, function(item) { return item.from; } );
      return filter(defaultPolicy, function(item) { return indexOf(configuredKeys, item.from) === -1; }).concat(replace);
    }

    /**
     * [Internal] Get the default value of a parameter, which may be an injectable function.
     */
    function $$getDefaultValue() {
      if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
      var defaultValue = injector.invoke(config.$$fn);
      if (defaultValue !== null && defaultValue !== undefined && !self.type.is(defaultValue))
        throw new Error("Default value (" + defaultValue + ") for parameter '" + self.id + "' is not an instance of Type (" + self.type.name + ")");
      return defaultValue;
    }

    /**
     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
     * default value, which may be the result of an injectable function.
     */
    function $value(value) {
      function hasReplaceVal(val) { return function(obj) { return obj.from === val; }; }
      function $replace(value) {
        var replacement = map(filter(self.replace, hasReplaceVal(value)), function(obj) { return obj.to; });
        return replacement.length ? replacement[0] : value;
      }
      value = $replace(value);
      return !isDefined(value) ? $$getDefaultValue() : self.type.$normalize(value);
    }

    function toString() { return "{Param:" + id + " " + type + " squash: '" + squash + "' optional: " + isOptional + "}"; }

    extend(this, {
      id: id,
      type: type,
      location: location,
      array: arrayMode,
      squash: squash,
      replace: replace,
      isOptional: isOptional,
      value: $value,
      dynamic: undefined,
      config: config,
      toString: toString
    });
  };

  function ParamSet(params) {
    extend(this, params || {});
  }

  ParamSet.prototype = {
    $$new: function() {
      return inherit(this, extend(new ParamSet(), { $$parent: this}));
    },
    $$keys: function () {
      var keys = [], chain = [], parent = this,
        ignore = objectKeys(ParamSet.prototype);
      while (parent) { chain.push(parent); parent = parent.$$parent; }
      chain.reverse();
      forEach(chain, function(paramset) {
        forEach(objectKeys(paramset), function(key) {
            if (indexOf(keys, key) === -1 && indexOf(ignore, key) === -1) keys.push(key);
        });
      });
      return keys;
    },
    $$values: function(paramValues) {
      var values = {}, self = this;
      forEach(self.$$keys(), function(key) {
        values[key] = self[key].value(paramValues && paramValues[key]);
      });
      return values;
    },
    $$equals: function(paramValues1, paramValues2) {
      var equal = true, self = this;
      forEach(self.$$keys(), function(key) {
        var left = paramValues1 && paramValues1[key], right = paramValues2 && paramValues2[key];
        if (!self[key].type.equals(left, right)) equal = false;
      });
      return equal;
    },
    $$validates: function $$validate(paramValues) {
      var keys = this.$$keys(), i, param, rawVal, normalized, encoded;
      for (i = 0; i < keys.length; i++) {
        param = this[keys[i]];
        rawVal = paramValues[keys[i]];
        if ((rawVal === undefined || rawVal === null) && param.isOptional)
          break; // There was no parameter value, but the param is optional
        normalized = param.type.$normalize(rawVal);
        if (!param.type.is(normalized))
          return false; // The value was not of the correct Type, and could not be decoded to the correct Type
        encoded = param.type.encode(normalized);
        if (angular.isString(encoded) && !param.type.pattern.exec(encoded))
          return false; // The value was of the correct type, but when encoded, did not match the Type's regexp
      }
      return true;
    },
    $$parent: undefined
  };

  this.ParamSet = ParamSet;
}

// Register as a provider so it's available to other providers
angular.module('ui.router.util').provider('$urlMatcherFactory', $UrlMatcherFactory);
angular.module('ui.router.util').run(['$urlMatcherFactory', function($urlMatcherFactory) { }]);

/**
 * @ngdoc object
 * @name ui.router.router.$urlRouterProvider
 *
 * @requires ui.router.util.$urlMatcherFactoryProvider
 * @requires $locationProvider
 *
 * @description
 * `$urlRouterProvider` has the responsibility of watching `$location`. 
 * When `$location` changes it runs through a list of rules one by one until a 
 * match is found. `$urlRouterProvider` is used behind the scenes anytime you specify 
 * a url in a state configuration. All urls are compiled into a UrlMatcher object.
 *
 * There are several methods on `$urlRouterProvider` that make it useful to use directly
 * in your module config.
 */
$UrlRouterProvider.$inject = ['$locationProvider', '$urlMatcherFactoryProvider'];
function $UrlRouterProvider(   $locationProvider,   $urlMatcherFactory) {
  var rules = [], otherwise = null, interceptDeferred = false, listener;

  // Returns a string that is a prefix of all strings matching the RegExp
  function regExpPrefix(re) {
    var prefix = /^\^((?:\\[^a-zA-Z0-9]|[^\\\[\]\^$*+?.()|{}]+)*)/.exec(re.source);
    return (prefix != null) ? prefix[1].replace(/\\(.)/g, "$1") : '';
  }

  // Interpolates matched values into a String.replace()-style pattern
  function interpolate(pattern, match) {
    return pattern.replace(/\$(\$|\d{1,2})/, function (m, what) {
      return match[what === '$' ? 0 : Number(what)];
    });
  }

  /**
   * @ngdoc function
   * @name ui.router.router.$urlRouterProvider#rule
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Defines rules that are used by `$urlRouterProvider` to find matches for
   * specific URLs.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *   // Here's an example of how you might allow case insensitive urls
   *   $urlRouterProvider.rule(function ($injector, $location) {
   *     var path = $location.path(),
   *         normalized = path.toLowerCase();
   *
   *     if (path !== normalized) {
   *       return normalized;
   *     }
   *   });
   * });
   * </pre>
   *
   * @param {function} rule Handler function that takes `$injector` and `$location`
   * services as arguments. You can use them to return a valid path as a string.
   *
   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
   */
  this.rule = function (rule) {
    if (!isFunction(rule)) throw new Error("'rule' must be a function");
    rules.push(rule);
    return this;
  };

  /**
   * @ngdoc object
   * @name ui.router.router.$urlRouterProvider#otherwise
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Defines a path that is used when an invalid route is requested.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *   // if the path doesn't match any of the urls you configured
   *   // otherwise will take care of routing the user to the
   *   // specified url
   *   $urlRouterProvider.otherwise('/index');
   *
   *   // Example of using function rule as param
   *   $urlRouterProvider.otherwise(function ($injector, $location) {
   *     return '/a/valid/url';
   *   });
   * });
   * </pre>
   *
   * @param {string|function} rule The url path you want to redirect to or a function 
   * rule that returns the url path. The function version is passed two params: 
   * `$injector` and `$location` services, and must return a url string.
   *
   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
   */
  this.otherwise = function (rule) {
    if (isString(rule)) {
      var redirect = rule;
      rule = function () { return redirect; };
    }
    else if (!isFunction(rule)) throw new Error("'rule' must be a function");
    otherwise = rule;
    return this;
  };


  function handleIfMatch($injector, handler, match) {
    if (!match) return false;
    var result = $injector.invoke(handler, handler, { $match: match });
    return isDefined(result) ? result : true;
  }

  /**
   * @ngdoc function
   * @name ui.router.router.$urlRouterProvider#when
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Registers a handler for a given url matching. 
   * 
   * If the handler is a string, it is
   * treated as a redirect, and is interpolated according to the syntax of match
   * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
   *
   * If the handler is a function, it is injectable. It gets invoked if `$location`
   * matches. You have the option of inject the match object as `$match`.
   *
   * The handler can return
   *
   * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
   *   will continue trying to find another one that matches.
   * - **string** which is treated as a redirect and passed to `$location.url()`
   * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
   *     if ($state.$current.navigable !== state ||
   *         !equalForKeys($match, $stateParams) {
   *      $state.transitionTo(state, $match, false);
   *     }
   *   });
   * });
   * </pre>
   *
   * @param {string|object} what The incoming path that you want to redirect.
   * @param {string|function} handler The path you want to redirect your user to.
   */
  this.when = function (what, handler) {
    var redirect, handlerIsString = isString(handler);
    if (isString(what)) what = $urlMatcherFactory.compile(what);

    if (!handlerIsString && !isFunction(handler) && !isArray(handler))
      throw new Error("invalid 'handler' in when()");

    var strategies = {
      matcher: function (what, handler) {
        if (handlerIsString) {
          redirect = $urlMatcherFactory.compile(handler);
          handler = ['$match', function ($match) { return redirect.format($match); }];
        }
        return extend(function ($injector, $location) {
          return handleIfMatch($injector, handler, what.exec($location.path(), $location.search()));
        }, {
          prefix: isString(what.prefix) ? what.prefix : ''
        });
      },
      regex: function (what, handler) {
        if (what.global || what.sticky) throw new Error("when() RegExp must not be global or sticky");

        if (handlerIsString) {
          redirect = handler;
          handler = ['$match', function ($match) { return interpolate(redirect, $match); }];
        }
        return extend(function ($injector, $location) {
          return handleIfMatch($injector, handler, what.exec($location.path()));
        }, {
          prefix: regExpPrefix(what)
        });
      }
    };

    var check = { matcher: $urlMatcherFactory.isMatcher(what), regex: what instanceof RegExp };

    for (var n in check) {
      if (check[n]) return this.rule(strategies[n](what, handler));
    }

    throw new Error("invalid 'what' in when()");
  };

  /**
   * @ngdoc function
   * @name ui.router.router.$urlRouterProvider#deferIntercept
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Disables (or enables) deferring location change interception.
   *
   * If you wish to customize the behavior of syncing the URL (for example, if you wish to
   * defer a transition but maintain the current URL), call this method at configuration time.
   * Then, at run time, call `$urlRouter.listen()` after you have configured your own
   * `$locationChangeSuccess` event handler.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *
   *   // Prevent $urlRouter from automatically intercepting URL changes;
   *   // this allows you to configure custom behavior in between
   *   // location changes and route synchronization:
   *   $urlRouterProvider.deferIntercept();
   *
   * }).run(function ($rootScope, $urlRouter, UserService) {
   *
   *   $rootScope.$on('$locationChangeSuccess', function(e) {
   *     // UserService is an example service for managing user state
   *     if (UserService.isLoggedIn()) return;
   *
   *     // Prevent $urlRouter's default handler from firing
   *     e.preventDefault();
   *
   *     UserService.handleLogin().then(function() {
   *       // Once the user has logged in, sync the current URL
   *       // to the router:
   *       $urlRouter.sync();
   *     });
   *   });
   *
   *   // Configures $urlRouter's listener *after* your custom listener
   *   $urlRouter.listen();
   * });
   * </pre>
   *
   * @param {boolean} defer Indicates whether to defer location change interception. Passing
            no parameter is equivalent to `true`.
   */
  this.deferIntercept = function (defer) {
    if (defer === undefined) defer = true;
    interceptDeferred = defer;
  };

  /**
   * @ngdoc object
   * @name ui.router.router.$urlRouter
   *
   * @requires $location
   * @requires $rootScope
   * @requires $injector
   * @requires $browser
   *
   * @description
   *
   */
  this.$get = $get;
  $get.$inject = ['$location', '$rootScope', '$injector', '$browser', '$sniffer'];
  function $get(   $location,   $rootScope,   $injector,   $browser,   $sniffer) {

    var baseHref = $browser.baseHref(), location = $location.url(), lastPushedUrl;

    function appendBasePath(url, isHtml5, absolute) {
      if (baseHref === '/') return url;
      if (isHtml5) return baseHref.slice(0, -1) + url;
      if (absolute) return baseHref.slice(1) + url;
      return url;
    }

    // TODO: Optimize groups of rules with non-empty prefix into some sort of decision tree
    function update(evt) {
      if (evt && evt.defaultPrevented) return;
      var ignoreUpdate = lastPushedUrl && $location.url() === lastPushedUrl;
      lastPushedUrl = undefined;
      // TODO: Re-implement this in 1.0 for https://github.com/angular-ui/ui-router/issues/1573
      //if (ignoreUpdate) return true;

      function check(rule) {
        var handled = rule($injector, $location);

        if (!handled) return false;
        if (isString(handled)) $location.replace().url(handled);
        return true;
      }
      var n = rules.length, i;

      for (i = 0; i < n; i++) {
        if (check(rules[i])) return;
      }
      // always check otherwise last to allow dynamic updates to the set of rules
      if (otherwise) check(otherwise);
    }

    function listen() {
      listener = listener || $rootScope.$on('$locationChangeSuccess', update);
      return listener;
    }

    if (!interceptDeferred) listen();

    return {
      /**
       * @ngdoc function
       * @name ui.router.router.$urlRouter#sync
       * @methodOf ui.router.router.$urlRouter
       *
       * @description
       * Triggers an update; the same update that happens when the address bar url changes, aka `$locationChangeSuccess`.
       * This method is useful when you need to use `preventDefault()` on the `$locationChangeSuccess` event,
       * perform some custom logic (route protection, auth, config, redirection, etc) and then finally proceed
       * with the transition by calling `$urlRouter.sync()`.
       *
       * @example
       * <pre>
       * angular.module('app', ['ui.router'])
       *   .run(function($rootScope, $urlRouter) {
       *     $rootScope.$on('$locationChangeSuccess', function(evt) {
       *       // Halt state change from even starting
       *       evt.preventDefault();
       *       // Perform custom logic
       *       var meetsRequirement = ...
       *       // Continue with the update and state transition if logic allows
       *       if (meetsRequirement) $urlRouter.sync();
       *     });
       * });
       * </pre>
       */
      sync: function() {
        update();
      },

      listen: function() {
        return listen();
      },

      update: function(read) {
        if (read) {
          location = $location.url();
          return;
        }
        if ($location.url() === location) return;

        $location.url(location);
        $location.replace();
      },

      push: function(urlMatcher, params, options) {
         var url = urlMatcher.format(params || {});

        // Handle the special hash param, if needed
        if (url !== null && params && params['#']) {
            url += '#' + params['#'];
        }

        $location.url(url);
        lastPushedUrl = options && options.$$avoidResync ? $location.url() : undefined;
        if (options && options.replace) $location.replace();
      },

      /**
       * @ngdoc function
       * @name ui.router.router.$urlRouter#href
       * @methodOf ui.router.router.$urlRouter
       *
       * @description
       * A URL generation method that returns the compiled URL for a given
       * {@link ui.router.util.type:UrlMatcher `UrlMatcher`}, populated with the provided parameters.
       *
       * @example
       * <pre>
       * $bob = $urlRouter.href(new UrlMatcher("/about/:person"), {
       *   person: "bob"
       * });
       * // $bob == "/about/bob";
       * </pre>
       *
       * @param {UrlMatcher} urlMatcher The `UrlMatcher` object which is used as the template of the URL to generate.
       * @param {object=} params An object of parameter values to fill the matcher's required parameters.
       * @param {object=} options Options object. The options are:
       *
       * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
       *
       * @returns {string} Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
       */
      href: function(urlMatcher, params, options) {
        if (!urlMatcher.validates(params)) return null;

        var isHtml5 = $locationProvider.html5Mode();
        if (angular.isObject(isHtml5)) {
          isHtml5 = isHtml5.enabled;
        }

        isHtml5 = isHtml5 && $sniffer.history;
        
        var url = urlMatcher.format(params);
        options = options || {};

        if (!isHtml5 && url !== null) {
          url = "#" + $locationProvider.hashPrefix() + url;
        }

        // Handle special hash param, if needed
        if (url !== null && params && params['#']) {
          url += '#' + params['#'];
        }

        url = appendBasePath(url, isHtml5, options.absolute);

        if (!options.absolute || !url) {
          return url;
        }

        var slash = (!isHtml5 && url ? '/' : ''), port = $location.port();
        port = (port === 80 || port === 443 ? '' : ':' + port);

        return [$location.protocol(), '://', $location.host(), port, slash, url].join('');
      }
    };
  }
}

angular.module('ui.router.router').provider('$urlRouter', $UrlRouterProvider);

/**
 * @ngdoc object
 * @name ui.router.state.$stateProvider
 *
 * @requires ui.router.router.$urlRouterProvider
 * @requires ui.router.util.$urlMatcherFactoryProvider
 *
 * @description
 * The new `$stateProvider` works similar to Angular's v1 router, but it focuses purely
 * on state.
 *
 * A state corresponds to a "place" in the application in terms of the overall UI and
 * navigation. A state describes (via the controller / template / view properties) what
 * the UI looks like and does at that place.
 *
 * States often have things in common, and the primary way of factoring out these
 * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
 * nested states.
 *
 * The `$stateProvider` provides interfaces to declare these states for your app.
 */
$StateProvider.$inject = ['$urlRouterProvider', '$urlMatcherFactoryProvider'];
function $StateProvider(   $urlRouterProvider,   $urlMatcherFactory) {

  var root, states = {}, $state, queue = {}, abstractKey = 'abstract';

  // Builds state properties from definition passed to registerState()
  var stateBuilder = {

    // Derive parent state from a hierarchical name only if 'parent' is not explicitly defined.
    // state.children = [];
    // if (parent) parent.children.push(state);
    parent: function(state) {
      if (isDefined(state.parent) && state.parent) return findState(state.parent);
      // regex matches any valid composite state name
      // would match "contact.list" but not "contacts"
      var compositeName = /^(.+)\.[^.]+$/.exec(state.name);
      return compositeName ? findState(compositeName[1]) : root;
    },

    // inherit 'data' from parent and override by own values (if any)
    data: function(state) {
      if (state.parent && state.parent.data) {
        state.data = state.self.data = inherit(state.parent.data, state.data);
      }
      return state.data;
    },

    // Build a URLMatcher if necessary, either via a relative or absolute URL
    url: function(state) {
      var url = state.url, config = { params: state.params || {} };

      if (isString(url)) {
        if (url.charAt(0) == '^') return $urlMatcherFactory.compile(url.substring(1), config);
        return (state.parent.navigable || root).url.concat(url, config);
      }

      if (!url || $urlMatcherFactory.isMatcher(url)) return url;
      throw new Error("Invalid url '" + url + "' in state '" + state + "'");
    },

    // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
    navigable: function(state) {
      return state.url ? state : (state.parent ? state.parent.navigable : null);
    },

    // Own parameters for this state. state.url.params is already built at this point. Create and add non-url params
    ownParams: function(state) {
      var params = state.url && state.url.params || new $$UMFP.ParamSet();
      forEach(state.params || {}, function(config, id) {
        if (!params[id]) params[id] = new $$UMFP.Param(id, null, config, "config");
      });
      return params;
    },

    // Derive parameters for this state and ensure they're a super-set of parent's parameters
    params: function(state) {
      var ownParams = pick(state.ownParams, state.ownParams.$$keys());
      return state.parent && state.parent.params ? extend(state.parent.params.$$new(), ownParams) : new $$UMFP.ParamSet();
    },

    // If there is no explicit multi-view configuration, make one up so we don't have
    // to handle both cases in the view directive later. Note that having an explicit
    // 'views' property will mean the default unnamed view properties are ignored. This
    // is also a good time to resolve view names to absolute names, so everything is a
    // straight lookup at link time.
    views: function(state) {
      var views = {};

      forEach(isDefined(state.views) ? state.views : { '': state }, function (view, name) {
        if (name.indexOf('@') < 0) name += '@' + state.parent.name;
        views[name] = view;
      });
      return views;
    },

    // Keep a full path from the root down to this state as this is needed for state activation.
    path: function(state) {
      return state.parent ? state.parent.path.concat(state) : []; // exclude root from path
    },

    // Speed up $state.contains() as it's used a lot
    includes: function(state) {
      var includes = state.parent ? extend({}, state.parent.includes) : {};
      includes[state.name] = true;
      return includes;
    },

    $delegates: {}
  };

  function isRelative(stateName) {
    return stateName.indexOf(".") === 0 || stateName.indexOf("^") === 0;
  }

  function findState(stateOrName, base) {
    if (!stateOrName) return undefined;

    var isStr = isString(stateOrName),
        name  = isStr ? stateOrName : stateOrName.name,
        path  = isRelative(name);

    if (path) {
      if (!base) throw new Error("No reference point given for path '"  + name + "'");
      base = findState(base);
      
      var rel = name.split("."), i = 0, pathLength = rel.length, current = base;

      for (; i < pathLength; i++) {
        if (rel[i] === "" && i === 0) {
          current = base;
          continue;
        }
        if (rel[i] === "^") {
          if (!current.parent) throw new Error("Path '" + name + "' not valid for state '" + base.name + "'");
          current = current.parent;
          continue;
        }
        break;
      }
      rel = rel.slice(i).join(".");
      name = current.name + (current.name && rel ? "." : "") + rel;
    }
    var state = states[name];

    if (state && (isStr || (!isStr && (state === stateOrName || state.self === stateOrName)))) {
      return state;
    }
    return undefined;
  }

  function queueState(parentName, state) {
    if (!queue[parentName]) {
      queue[parentName] = [];
    }
    queue[parentName].push(state);
  }

  function flushQueuedChildren(parentName) {
    var queued = queue[parentName] || [];
    while(queued.length) {
      registerState(queued.shift());
    }
  }

  function registerState(state) {
    // Wrap a new object around the state so we can store our private details easily.
    state = inherit(state, {
      self: state,
      resolve: state.resolve || {},
      toString: function() { return this.name; }
    });

    var name = state.name;
    if (!isString(name) || name.indexOf('@') >= 0) throw new Error("State must have a valid name");
    if (states.hasOwnProperty(name)) throw new Error("State '" + name + "' is already defined");

    // Get parent name
    var parentName = (name.indexOf('.') !== -1) ? name.substring(0, name.lastIndexOf('.'))
        : (isString(state.parent)) ? state.parent
        : (isObject(state.parent) && isString(state.parent.name)) ? state.parent.name
        : '';

    // If parent is not registered yet, add state to queue and register later
    if (parentName && !states[parentName]) {
      return queueState(parentName, state.self);
    }

    for (var key in stateBuilder) {
      if (isFunction(stateBuilder[key])) state[key] = stateBuilder[key](state, stateBuilder.$delegates[key]);
    }
    states[name] = state;

    // Register the state in the global state list and with $urlRouter if necessary.
    if (!state[abstractKey] && state.url) {
      $urlRouterProvider.when(state.url, ['$match', '$stateParams', function ($match, $stateParams) {
        if ($state.$current.navigable != state || !equalForKeys($match, $stateParams)) {
          $state.transitionTo(state, $match, { inherit: true, location: false });
        }
      }]);
    }

    // Register any queued children
    flushQueuedChildren(name);

    return state;
  }

  // Checks text to see if it looks like a glob.
  function isGlob (text) {
    return text.indexOf('*') > -1;
  }

  // Returns true if glob matches current $state name.
  function doesStateMatchGlob (glob) {
    var globSegments = glob.split('.'),
        segments = $state.$current.name.split('.');

    //match single stars
    for (var i = 0, l = globSegments.length; i < l; i++) {
      if (globSegments[i] === '*') {
        segments[i] = '*';
      }
    }

    //match greedy starts
    if (globSegments[0] === '**') {
       segments = segments.slice(indexOf(segments, globSegments[1]));
       segments.unshift('**');
    }
    //match greedy ends
    if (globSegments[globSegments.length - 1] === '**') {
       segments.splice(indexOf(segments, globSegments[globSegments.length - 2]) + 1, Number.MAX_VALUE);
       segments.push('**');
    }

    if (globSegments.length != segments.length) {
      return false;
    }

    return segments.join('') === globSegments.join('');
  }


  // Implicit root state that is always active
  root = registerState({
    name: '',
    url: '^',
    views: null,
    'abstract': true
  });
  root.navigable = null;


  /**
   * @ngdoc function
   * @name ui.router.state.$stateProvider#decorator
   * @methodOf ui.router.state.$stateProvider
   *
   * @description
   * Allows you to extend (carefully) or override (at your own peril) the 
   * `stateBuilder` object used internally by `$stateProvider`. This can be used 
   * to add custom functionality to ui-router, for example inferring templateUrl 
   * based on the state name.
   *
   * When passing only a name, it returns the current (original or decorated) builder
   * function that matches `name`.
   *
   * The builder functions that can be decorated are listed below. Though not all
   * necessarily have a good use case for decoration, that is up to you to decide.
   *
   * In addition, users can attach custom decorators, which will generate new 
   * properties within the state's internal definition. There is currently no clear 
   * use-case for this beyond accessing internal states (i.e. $state.$current), 
   * however, expect this to become increasingly relevant as we introduce additional 
   * meta-programming features.
   *
   * **Warning**: Decorators should not be interdependent because the order of 
   * execution of the builder functions in non-deterministic. Builder functions 
   * should only be dependent on the state definition object and super function.
   *
   *
   * Existing builder functions and current return values:
   *
   * - **parent** `{object}` - returns the parent state object.
   * - **data** `{object}` - returns state data, including any inherited data that is not
   *   overridden by own values (if any).
   * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
   *   or `null`.
   * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is 
   *   navigable).
   * - **params** `{object}` - returns an array of state params that are ensured to 
   *   be a super-set of parent's params.
   * - **views** `{object}` - returns a views object where each key is an absolute view 
   *   name (i.e. "viewName@stateName") and each value is the config object 
   *   (template, controller) for the view. Even when you don't use the views object 
   *   explicitly on a state config, one is still created for you internally.
   *   So by decorating this builder function you have access to decorating template 
   *   and controller properties.
   * - **ownParams** `{object}` - returns an array of params that belong to the state, 
   *   not including any params defined by ancestor states.
   * - **path** `{string}` - returns the full path from the root down to this state. 
   *   Needed for state activation.
   * - **includes** `{object}` - returns an object that includes every state that 
   *   would pass a `$state.includes()` test.
   *
   * @example
   * <pre>
   * // Override the internal 'views' builder with a function that takes the state
   * // definition, and a reference to the internal function being overridden:
   * $stateProvider.decorator('views', function (state, parent) {
   *   var result = {},
   *       views = parent(state);
   *
   *   angular.forEach(views, function (config, name) {
   *     var autoName = (state.name + '.' + name).replace('.', '/');
   *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
   *     result[name] = config;
   *   });
   *   return result;
   * });
   *
   * $stateProvider.state('home', {
   *   views: {
   *     'contact.list': { controller: 'ListController' },
   *     'contact.item': { controller: 'ItemController' }
   *   }
   * });
   *
   * // ...
   *
   * $state.go('home');
   * // Auto-populates list and item views with /partials/home/contact/list.html,
   * // and /partials/home/contact/item.html, respectively.
   * </pre>
   *
   * @param {string} name The name of the builder function to decorate. 
   * @param {object} func A function that is responsible for decorating the original 
   * builder function. The function receives two parameters:
   *
   *   - `{object}` - state - The state config object.
   *   - `{object}` - super - The original builder function.
   *
   * @return {object} $stateProvider - $stateProvider instance
   */
  this.decorator = decorator;
  function decorator(name, func) {
    /*jshint validthis: true */
    if (isString(name) && !isDefined(func)) {
      return stateBuilder[name];
    }
    if (!isFunction(func) || !isString(name)) {
      return this;
    }
    if (stateBuilder[name] && !stateBuilder.$delegates[name]) {
      stateBuilder.$delegates[name] = stateBuilder[name];
    }
    stateBuilder[name] = func;
    return this;
  }

  /**
   * @ngdoc function
   * @name ui.router.state.$stateProvider#state
   * @methodOf ui.router.state.$stateProvider
   *
   * @description
   * Registers a state configuration under a given state name. The stateConfig object
   * has the following acceptable properties.
   *
   * @param {string} name A unique state name, e.g. "home", "about", "contacts".
   * To create a parent/child state use a dot, e.g. "about.sales", "home.newest".
   * @param {object} stateConfig State configuration object.
   * @param {string|function=} stateConfig.template
   * <a id='template'></a>
   *   html template as a string or a function that returns
   *   an html template as a string which should be used by the uiView directives. This property 
   *   takes precedence over templateUrl.
   *   
   *   If `template` is a function, it will be called with the following parameters:
   *
   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by
   *     applying the current state
   *
   * <pre>template:
   *   "<h1>inline template definition</h1>" +
   *   "<div ui-view></div>"</pre>
   * <pre>template: function(params) {
   *       return "<h1>generated template</h1>"; }</pre>
   * </div>
   *
   * @param {string|function=} stateConfig.templateUrl
   * <a id='templateUrl'></a>
   *
   *   path or function that returns a path to an html
   *   template that should be used by uiView.
   *   
   *   If `templateUrl` is a function, it will be called with the following parameters:
   *
   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by 
   *     applying the current state
   *
   * <pre>templateUrl: "home.html"</pre>
   * <pre>templateUrl: function(params) {
   *     return myTemplates[params.pageId]; }</pre>
   *
   * @param {function=} stateConfig.templateProvider
   * <a id='templateProvider'></a>
   *    Provider function that returns HTML content string.
   * <pre> templateProvider:
   *       function(MyTemplateService, params) {
   *         return MyTemplateService.getTemplate(params.pageId);
   *       }</pre>
   *
   * @param {string|function=} stateConfig.controller
   * <a id='controller'></a>
   *
   *  Controller fn that should be associated with newly
   *   related scope or the name of a registered controller if passed as a string.
   *   Optionally, the ControllerAs may be declared here.
   * <pre>controller: "MyRegisteredController"</pre>
   * <pre>controller:
   *     "MyRegisteredController as fooCtrl"}</pre>
   * <pre>controller: function($scope, MyService) {
   *     $scope.data = MyService.getData(); }</pre>
   *
   * @param {function=} stateConfig.controllerProvider
   * <a id='controllerProvider'></a>
   *
   * Injectable provider function that returns the actual controller or string.
   * <pre>controllerProvider:
   *   function(MyResolveData) {
   *     if (MyResolveData.foo)
   *       return "FooCtrl"
   *     else if (MyResolveData.bar)
   *       return "BarCtrl";
   *     else return function($scope) {
   *       $scope.baz = "Qux";
   *     }
   *   }</pre>
   *
   * @param {string=} stateConfig.controllerAs
   * <a id='controllerAs'></a>
   * 
   * A controller alias name. If present the controller will be
   *   published to scope under the controllerAs name.
   * <pre>controllerAs: "myCtrl"</pre>
   *
   * @param {string|object=} stateConfig.parent
   * <a id='parent'></a>
   * Optionally specifies the parent state of this state.
   *
   * <pre>parent: 'parentState'</pre>
   * <pre>parent: parentState // JS variable</pre>
   *
   * @param {object=} stateConfig.resolve
   * <a id='resolve'></a>
   *
   * An optional map&lt;string, function&gt; of dependencies which
   *   should be injected into the controller. If any of these dependencies are promises, 
   *   the router will wait for them all to be resolved before the controller is instantiated.
   *   If all the promises are resolved successfully, the $stateChangeSuccess event is fired
   *   and the values of the resolved promises are injected into any controllers that reference them.
   *   If any  of the promises are rejected the $stateChangeError event is fired.
   *
   *   The map object is:
   *   
   *   - key - {string}: name of dependency to be injected into controller
   *   - factory - {string|function}: If string then it is alias for service. Otherwise if function, 
   *     it is injected and return value it treated as dependency. If result is a promise, it is 
   *     resolved before its value is injected into controller.
   *
   * <pre>resolve: {
   *     myResolve1:
   *       function($http, $stateParams) {
   *         return $http.get("/api/foos/"+stateParams.fooID);
   *       }
   *     }</pre>
   *
   * @param {string=} stateConfig.url
   * <a id='url'></a>
   *
   *   A url fragment with optional parameters. When a state is navigated or
   *   transitioned to, the `$stateParams` service will be populated with any 
   *   parameters that were passed.
   *
   *   (See {@link ui.router.util.type:UrlMatcher UrlMatcher} `UrlMatcher`} for
   *   more details on acceptable patterns )
   *
   * examples:
   * <pre>url: "/home"
   * url: "/users/:userid"
   * url: "/books/{bookid:[a-zA-Z_-]}"
   * url: "/books/{categoryid:int}"
   * url: "/books/{publishername:string}/{categoryid:int}"
   * url: "/messages?before&after"
   * url: "/messages?{before:date}&{after:date}"
   * url: "/messages/:mailboxid?{before:date}&{after:date}"
   * </pre>
   *
   * @param {object=} stateConfig.views
   * <a id='views'></a>
   * an optional map&lt;string, object&gt; which defined multiple views, or targets views
   * manually/explicitly.
   *
   * Examples:
   *
   * Targets three named `ui-view`s in the parent state's template
   * <pre>views: {
   *     header: {
   *       controller: "headerCtrl",
   *       templateUrl: "header.html"
   *     }, body: {
   *       controller: "bodyCtrl",
   *       templateUrl: "body.html"
   *     }, footer: {
   *       controller: "footCtrl",
   *       templateUrl: "footer.html"
   *     }
   *   }</pre>
   *
   * Targets named `ui-view="header"` from grandparent state 'top''s template, and named `ui-view="body" from parent state's template.
   * <pre>views: {
   *     'header@top': {
   *       controller: "msgHeaderCtrl",
   *       templateUrl: "msgHeader.html"
   *     }, 'body': {
   *       controller: "messagesCtrl",
   *       templateUrl: "messages.html"
   *     }
   *   }</pre>
   *
   * @param {boolean=} [stateConfig.abstract=false]
   * <a id='abstract'></a>
   * An abstract state will never be directly activated,
   *   but can provide inherited properties to its common children states.
   * <pre>abstract: true</pre>
   *
   * @param {function=} stateConfig.onEnter
   * <a id='onEnter'></a>
   *
   * Callback function for when a state is entered. Good way
   *   to trigger an action or dispatch an event, such as opening a dialog.
   * If minifying your scripts, make sure to explicitly annotate this function,
   * because it won't be automatically annotated by your build tools.
   *
   * <pre>onEnter: function(MyService, $stateParams) {
   *     MyService.foo($stateParams.myParam);
   * }</pre>
   *
   * @param {function=} stateConfig.onExit
   * <a id='onExit'></a>
   *
   * Callback function for when a state is exited. Good way to
   *   trigger an action or dispatch an event, such as opening a dialog.
   * If minifying your scripts, make sure to explicitly annotate this function,
   * because it won't be automatically annotated by your build tools.
   *
   * <pre>onExit: function(MyService, $stateParams) {
   *     MyService.cleanup($stateParams.myParam);
   * }</pre>
   *
   * @param {boolean=} [stateConfig.reloadOnSearch=true]
   * <a id='reloadOnSearch'></a>
   *
   * If `false`, will not retrigger the same state
   *   just because a search/query parameter has changed (via $location.search() or $location.hash()). 
   *   Useful for when you'd like to modify $location.search() without triggering a reload.
   * <pre>reloadOnSearch: false</pre>
   *
   * @param {object=} stateConfig.data
   * <a id='data'></a>
   *
   * Arbitrary data object, useful for custom configuration.  The parent state's `data` is
   *   prototypally inherited.  In other words, adding a data property to a state adds it to
   *   the entire subtree via prototypal inheritance.
   *
   * <pre>data: {
   *     requiredRole: 'foo'
   * } </pre>
   *
   * @param {object=} stateConfig.params
   * <a id='params'></a>
   *
   * A map which optionally configures parameters declared in the `url`, or
   *   defines additional non-url parameters.  For each parameter being
   *   configured, add a configuration object keyed to the name of the parameter.
   *
   *   Each parameter configuration object may contain the following properties:
   *
   *   - ** value ** - {object|function=}: specifies the default value for this
   *     parameter.  This implicitly sets this parameter as optional.
   *
   *     When UI-Router routes to a state and no value is
   *     specified for this parameter in the URL or transition, the
   *     default value will be used instead.  If `value` is a function,
   *     it will be injected and invoked, and the return value used.
   *
   *     *Note*: `undefined` is treated as "no default value" while `null`
   *     is treated as "the default value is `null`".
   *
   *     *Shorthand*: If you only need to configure the default value of the
   *     parameter, you may use a shorthand syntax.   In the **`params`**
   *     map, instead mapping the param name to a full parameter configuration
   *     object, simply set map it to the default parameter value, e.g.:
   *
   * <pre>// define a parameter's default value
   * params: {
   *     param1: { value: "defaultValue" }
   * }
   * // shorthand default values
   * params: {
   *     param1: "defaultValue",
   *     param2: "param2Default"
   * }</pre>
   *
   *   - ** array ** - {boolean=}: *(default: false)* If true, the param value will be
   *     treated as an array of values.  If you specified a Type, the value will be
   *     treated as an array of the specified Type.  Note: query parameter values
   *     default to a special `"auto"` mode.
   *
   *     For query parameters in `"auto"` mode, if multiple  values for a single parameter
   *     are present in the URL (e.g.: `/foo?bar=1&bar=2&bar=3`) then the values
   *     are mapped to an array (e.g.: `{ foo: [ '1', '2', '3' ] }`).  However, if
   *     only one value is present (e.g.: `/foo?bar=1`) then the value is treated as single
   *     value (e.g.: `{ foo: '1' }`).
   *
   * <pre>params: {
   *     param1: { array: true }
   * }</pre>
   *
   *   - ** squash ** - {bool|string=}: `squash` configures how a default parameter value is represented in the URL when
   *     the current parameter value is the same as the default value. If `squash` is not set, it uses the
   *     configured default squash policy.
   *     (See {@link ui.router.util.$urlMatcherFactory#methods_defaultSquashPolicy `defaultSquashPolicy()`})
   *
   *   There are three squash settings:
   *
   *     - false: The parameter's default value is not squashed.  It is encoded and included in the URL
   *     - true: The parameter's default value is omitted from the URL.  If the parameter is preceeded and followed
   *       by slashes in the state's `url` declaration, then one of those slashes are omitted.
   *       This can allow for cleaner looking URLs.
   *     - `"<arbitrary string>"`: The parameter's default value is replaced with an arbitrary placeholder of  your choice.
   *
   * <pre>params: {
   *     param1: {
   *       value: "defaultId",
   *       squash: true
   * } }
   * // squash "defaultValue" to "~"
   * params: {
   *     param1: {
   *       value: "defaultValue",
   *       squash: "~"
   * } }
   * </pre>
   *
   *
   * @example
   * <pre>
   * // Some state name examples
   *
   * // stateName can be a single top-level name (must be unique).
   * $stateProvider.state("home", {});
   *
   * // Or it can be a nested state name. This state is a child of the
   * // above "home" state.
   * $stateProvider.state("home.newest", {});
   *
   * // Nest states as deeply as needed.
   * $stateProvider.state("home.newest.abc.xyz.inception", {});
   *
   * // state() returns $stateProvider, so you can chain state declarations.
   * $stateProvider
   *   .state("home", {})
   *   .state("about", {})
   *   .state("contacts", {});
   * </pre>
   *
   */
  this.state = state;
  function state(name, definition) {
    /*jshint validthis: true */
    if (isObject(name)) definition = name;
    else definition.name = name;
    registerState(definition);
    return this;
  }

  /**
   * @ngdoc object
   * @name ui.router.state.$state
   *
   * @requires $rootScope
   * @requires $q
   * @requires ui.router.state.$view
   * @requires $injector
   * @requires ui.router.util.$resolve
   * @requires ui.router.state.$stateParams
   * @requires ui.router.router.$urlRouter
   *
   * @property {object} params A param object, e.g. {sectionId: section.id)}, that 
   * you'd like to test against the current active state.
   * @property {object} current A reference to the state's config object. However 
   * you passed it in. Useful for accessing custom data.
   * @property {object} transition Currently pending transition. A promise that'll 
   * resolve or reject.
   *
   * @description
   * `$state` service is responsible for representing states as well as transitioning
   * between them. It also provides interfaces to ask for current state or even states
   * you're coming from.
   */
  this.$get = $get;
  $get.$inject = ['$rootScope', '$q', '$view', '$injector', '$resolve', '$stateParams', '$urlRouter', '$location', '$urlMatcherFactory'];
  function $get(   $rootScope,   $q,   $view,   $injector,   $resolve,   $stateParams,   $urlRouter,   $location,   $urlMatcherFactory) {

    var TransitionSuperseded = $q.reject(new Error('transition superseded'));
    var TransitionPrevented = $q.reject(new Error('transition prevented'));
    var TransitionAborted = $q.reject(new Error('transition aborted'));
    var TransitionFailed = $q.reject(new Error('transition failed'));

    // Handles the case where a state which is the target of a transition is not found, and the user
    // can optionally retry or defer the transition
    function handleRedirect(redirect, state, params, options) {
      /**
       * @ngdoc event
       * @name ui.router.state.$state#$stateNotFound
       * @eventOf ui.router.state.$state
       * @eventType broadcast on root scope
       * @description
       * Fired when a requested state **cannot be found** using the provided state name during transition.
       * The event is broadcast allowing any handlers a single chance to deal with the error (usually by
       * lazy-loading the unfound state). A special `unfoundState` object is passed to the listener handler,
       * you can see its three properties in the example. You can use `event.preventDefault()` to abort the
       * transition and the promise returned from `go` will be rejected with a `'transition aborted'` value.
       *
       * @param {Object} event Event object.
       * @param {Object} unfoundState Unfound State information. Contains: `to, toParams, options` properties.
       * @param {State} fromState Current state object.
       * @param {Object} fromParams Current state params.
       *
       * @example
       *
       * <pre>
       * // somewhere, assume lazy.state has not been defined
       * $state.go("lazy.state", {a:1, b:2}, {inherit:false});
       *
       * // somewhere else
       * $scope.$on('$stateNotFound',
       * function(event, unfoundState, fromState, fromParams){
       *     console.log(unfoundState.to); // "lazy.state"
       *     console.log(unfoundState.toParams); // {a:1, b:2}
       *     console.log(unfoundState.options); // {inherit:false} + default options
       * })
       * </pre>
       */
      var evt = $rootScope.$broadcast('$stateNotFound', redirect, state, params);

      if (evt.defaultPrevented) {
        $urlRouter.update();
        return TransitionAborted;
      }

      if (!evt.retry) {
        return null;
      }

      // Allow the handler to return a promise to defer state lookup retry
      if (options.$retry) {
        $urlRouter.update();
        return TransitionFailed;
      }
      var retryTransition = $state.transition = $q.when(evt.retry);

      retryTransition.then(function() {
        if (retryTransition !== $state.transition) return TransitionSuperseded;
        redirect.options.$retry = true;
        return $state.transitionTo(redirect.to, redirect.toParams, redirect.options);
      }, function() {
        return TransitionAborted;
      });
      $urlRouter.update();

      return retryTransition;
    }

    root.locals = { resolve: null, globals: { $stateParams: {} } };

    $state = {
      params: {},
      current: root.self,
      $current: root,
      transition: null
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#reload
     * @methodOf ui.router.state.$state
     *
     * @description
     * A method that force reloads the current state. All resolves are re-resolved,
     * controllers reinstantiated, and events re-fired.
     *
     * @example
     * <pre>
     * var app angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.reload = function(){
     *     $state.reload();
     *   }
     * });
     * </pre>
     *
     * `reload()` is just an alias for:
     * <pre>
     * $state.transitionTo($state.current, $stateParams, { 
     *   reload: true, inherit: false, notify: true
     * });
     * </pre>
     *
     * @param {string=|object=} state - A state name or a state object, which is the root of the resolves to be re-resolved.
     * @example
     * <pre>
     * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item' 
     * //and current state is 'contacts.detail.item'
     * var app angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.reload = function(){
     *     //will reload 'contact.detail' and 'contact.detail.item' states
     *     $state.reload('contact.detail');
     *   }
     * });
     * </pre>
     *
     * `reload()` is just an alias for:
     * <pre>
     * $state.transitionTo($state.current, $stateParams, { 
     *   reload: true, inherit: false, notify: true
     * });
     * </pre>

     * @returns {promise} A promise representing the state of the new transition. See
     * {@link ui.router.state.$state#methods_go $state.go}.
     */
    $state.reload = function reload(state) {
      return $state.transitionTo($state.current, $stateParams, { reload: state || true, inherit: false, notify: true});
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#go
     * @methodOf ui.router.state.$state
     *
     * @description
     * Convenience method for transitioning to a new state. `$state.go` calls 
     * `$state.transitionTo` internally but automatically sets options to 
     * `{ location: true, inherit: true, relative: $state.$current, notify: true }`. 
     * This allows you to easily use an absolute or relative to path and specify 
     * only the parameters you'd like to update (while letting unspecified parameters 
     * inherit from the currently active ancestor states).
     *
     * @example
     * <pre>
     * var app = angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.changeState = function () {
     *     $state.go('contact.detail');
     *   };
     * });
     * </pre>
     * <img src='../ngdoc_assets/StateGoExamples.png'/>
     *
     * @param {string} to Absolute state name or relative state path. Some examples:
     *
     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
     * - `$state.go('^')` - will go to a parent state
     * - `$state.go('^.sibling')` - will go to a sibling state
     * - `$state.go('.child.grandchild')` - will go to grandchild state
     *
     * @param {object=} params A map of the parameters that will be sent to the state, 
     * will populate $stateParams. Any parameters that are not specified will be inherited from currently 
     * defined parameters. Only parameters specified in the state definition can be overridden, new 
     * parameters will be ignored. This allows, for example, going to a sibling state that shares parameters
     * specified in a parent state. Parameter inheritance only works between common ancestor states, I.e.
     * transitioning to a sibling will get you the parameters for all parents, transitioning to a child
     * will get you all current parameters, etc.
     * @param {object=} options Options object. The options are:
     *
     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
     *    defines which state to be relative from.
     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
     * - **`reload`** (v0.2.5) - {boolean=false|string|object}, If `true` will force transition even if no state or params
     *    have changed.  It will reload the resolves and views of the current state and parent states.
     *    If `reload` is a string (or state object), the state object is fetched (by name, or object reference); and \
     *    the transition reloads the resolves and views for that matched state, and all its children states.
     *
     * @returns {promise} A promise representing the state of the new transition.
     *
     * Possible success values:
     *
     * - $state.current
     *
     * <br/>Possible rejection values:
     *
     * - 'transition superseded' - when a newer transition has been started after this one
     * - 'transition prevented' - when `event.preventDefault()` has been called in a `$stateChangeStart` listener
     * - 'transition aborted' - when `event.preventDefault()` has been called in a `$stateNotFound` listener or
     *   when a `$stateNotFound` `event.retry` promise errors.
     * - 'transition failed' - when a state has been unsuccessfully found after 2 tries.
     * - *resolve error* - when an error has occurred with a `resolve`
     *
     */
    $state.go = function go(to, params, options) {
      return $state.transitionTo(to, params, extend({ inherit: true, relative: $state.$current }, options));
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#transitionTo
     * @methodOf ui.router.state.$state
     *
     * @description
     * Low-level method for transitioning to a new state. {@link ui.router.state.$state#methods_go $state.go}
     * uses `transitionTo` internally. `$state.go` is recommended in most situations.
     *
     * @example
     * <pre>
     * var app = angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.changeState = function () {
     *     $state.transitionTo('contact.detail');
     *   };
     * });
     * </pre>
     *
     * @param {string} to State name.
     * @param {object=} toParams A map of the parameters that will be sent to the state,
     * will populate $stateParams.
     * @param {object=} options Options object. The options are:
     *
     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
     * - **`inherit`** - {boolean=false}, If `true` will inherit url parameters from current url.
     * - **`relative`** - {object=}, When transitioning with relative path (e.g '^'), 
     *    defines which state to be relative from.
     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
     * - **`reload`** (v0.2.5) - {boolean=false|string=|object=}, If `true` will force transition even if the state or params 
     *    have not changed, aka a reload of the same state. It differs from reloadOnSearch because you'd
     *    use this when you want to force a reload when *everything* is the same, including search params.
     *    if String, then will reload the state with the name given in reload, and any children.
     *    if Object, then a stateObj is expected, will reload the state found in stateObj, and any children.
     *
     * @returns {promise} A promise representing the state of the new transition. See
     * {@link ui.router.state.$state#methods_go $state.go}.
     */
    $state.transitionTo = function transitionTo(to, toParams, options) {
      toParams = toParams || {};
      options = extend({
        location: true, inherit: false, relative: null, notify: true, reload: false, $retry: false
      }, options || {});

      var from = $state.$current, fromParams = $state.params, fromPath = from.path;
      var evt, toState = findState(to, options.relative);

      // Store the hash param for later (since it will be stripped out by various methods)
      var hash = toParams['#'];

      if (!isDefined(toState)) {
        var redirect = { to: to, toParams: toParams, options: options };
        var redirectResult = handleRedirect(redirect, from.self, fromParams, options);

        if (redirectResult) {
          return redirectResult;
        }

        // Always retry once if the $stateNotFound was not prevented
        // (handles either redirect changed or state lazy-definition)
        to = redirect.to;
        toParams = redirect.toParams;
        options = redirect.options;
        toState = findState(to, options.relative);

        if (!isDefined(toState)) {
          if (!options.relative) throw new Error("No such state '" + to + "'");
          throw new Error("Could not resolve '" + to + "' from state '" + options.relative + "'");
        }
      }
      if (toState[abstractKey]) throw new Error("Cannot transition to abstract state '" + to + "'");
      if (options.inherit) toParams = inheritParams($stateParams, toParams || {}, $state.$current, toState);
      if (!toState.params.$$validates(toParams)) return TransitionFailed;

      toParams = toState.params.$$values(toParams);
      to = toState;

      var toPath = to.path;

      // Starting from the root of the path, keep all levels that haven't changed
      var keep = 0, state = toPath[keep], locals = root.locals, toLocals = [];

      if (!options.reload) {
        while (state && state === fromPath[keep] && state.ownParams.$$equals(toParams, fromParams)) {
          locals = toLocals[keep] = state.locals;
          keep++;
          state = toPath[keep];
        }
      } else if (isString(options.reload) || isObject(options.reload)) {
        if (isObject(options.reload) && !options.reload.name) {
          throw new Error('Invalid reload state object');
        }
        
        var reloadState = options.reload === true ? fromPath[0] : findState(options.reload);
        if (options.reload && !reloadState) {
          throw new Error("No such reload state '" + (isString(options.reload) ? options.reload : options.reload.name) + "'");
        }

        while (state && state === fromPath[keep] && state !== reloadState) {
          locals = toLocals[keep] = state.locals;
          keep++;
          state = toPath[keep];
        }
      }

      // If we're going to the same state and all locals are kept, we've got nothing to do.
      // But clear 'transition', as we still want to cancel any other pending transitions.
      // TODO: We may not want to bump 'transition' if we're called from a location change
      // that we've initiated ourselves, because we might accidentally abort a legitimate
      // transition initiated from code?
      if (shouldSkipReload(to, toParams, from, fromParams, locals, options)) {
        if (hash) toParams['#'] = hash;
        $state.params = toParams;
        copy($state.params, $stateParams);
        copy(filterByKeys(to.params.$$keys(), $stateParams), to.locals.globals.$stateParams);
        if (options.location && to.navigable && to.navigable.url) {
          $urlRouter.push(to.navigable.url, toParams, {
            $$avoidResync: true, replace: options.location === 'replace'
          });
          $urlRouter.update(true);
        }
        $state.transition = null;
        return $q.when($state.current);
      }

      // Filter parameters before we pass them to event handlers etc.
      toParams = filterByKeys(to.params.$$keys(), toParams || {});
      
      // Re-add the saved hash before we start returning things or broadcasting $stateChangeStart
      if (hash) toParams['#'] = hash;
      
      // Broadcast start event and cancel the transition if requested
      if (options.notify) {
        /**
         * @ngdoc event
         * @name ui.router.state.$state#$stateChangeStart
         * @eventOf ui.router.state.$state
         * @eventType broadcast on root scope
         * @description
         * Fired when the state transition **begins**. You can use `event.preventDefault()`
         * to prevent the transition from happening and then the transition promise will be
         * rejected with a `'transition prevented'` value.
         *
         * @param {Object} event Event object.
         * @param {State} toState The state being transitioned to.
         * @param {Object} toParams The params supplied to the `toState`.
         * @param {State} fromState The current state, pre-transition.
         * @param {Object} fromParams The params supplied to the `fromState`.
         *
         * @example
         *
         * <pre>
         * $rootScope.$on('$stateChangeStart',
         * function(event, toState, toParams, fromState, fromParams){
         *     event.preventDefault();
         *     // transitionTo() promise will be rejected with
         *     // a 'transition prevented' error
         * })
         * </pre>
         */
        if ($rootScope.$broadcast('$stateChangeStart', to.self, toParams, from.self, fromParams, options).defaultPrevented) {
          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
          //Don't update and resync url if there's been a new transition started. see issue #2238, #600
          if ($state.transition == null) $urlRouter.update();
          return TransitionPrevented;
        }
      }

      // Resolve locals for the remaining states, but don't update any global state just
      // yet -- if anything fails to resolve the current state needs to remain untouched.
      // We also set up an inheritance chain for the locals here. This allows the view directive
      // to quickly look up the correct definition for each view in the current state. Even
      // though we create the locals object itself outside resolveState(), it is initially
      // empty and gets filled asynchronously. We need to keep track of the promise for the
      // (fully resolved) current locals, and pass this down the chain.
      var resolved = $q.when(locals);

      for (var l = keep; l < toPath.length; l++, state = toPath[l]) {
        locals = toLocals[l] = inherit(locals);
        resolved = resolveState(state, toParams, state === to, resolved, locals, options);
      }

      // Once everything is resolved, we are ready to perform the actual transition
      // and return a promise for the new state. We also keep track of what the
      // current promise is, so that we can detect overlapping transitions and
      // keep only the outcome of the last transition.
      var transition = $state.transition = resolved.then(function () {
        var l, entering, exiting;

        if ($state.transition !== transition) return TransitionSuperseded;

        // Exit 'from' states not kept
        for (l = fromPath.length - 1; l >= keep; l--) {
          exiting = fromPath[l];
          if (exiting.self.onExit) {
            $injector.invoke(exiting.self.onExit, exiting.self, exiting.locals.globals);
          }
          exiting.locals = null;
        }

        // Enter 'to' states not kept
        for (l = keep; l < toPath.length; l++) {
          entering = toPath[l];
          entering.locals = toLocals[l];
          if (entering.self.onEnter) {
            $injector.invoke(entering.self.onEnter, entering.self, entering.locals.globals);
          }
        }

        // Run it again, to catch any transitions in callbacks
        if ($state.transition !== transition) return TransitionSuperseded;

        // Update globals in $state
        $state.$current = to;
        $state.current = to.self;
        $state.params = toParams;
        copy($state.params, $stateParams);
        $state.transition = null;

        if (options.location && to.navigable) {
          $urlRouter.push(to.navigable.url, to.navigable.locals.globals.$stateParams, {
            $$avoidResync: true, replace: options.location === 'replace'
          });
        }

        if (options.notify) {
        /**
         * @ngdoc event
         * @name ui.router.state.$state#$stateChangeSuccess
         * @eventOf ui.router.state.$state
         * @eventType broadcast on root scope
         * @description
         * Fired once the state transition is **complete**.
         *
         * @param {Object} event Event object.
         * @param {State} toState The state being transitioned to.
         * @param {Object} toParams The params supplied to the `toState`.
         * @param {State} fromState The current state, pre-transition.
         * @param {Object} fromParams The params supplied to the `fromState`.
         */
          $rootScope.$broadcast('$stateChangeSuccess', to.self, toParams, from.self, fromParams);
        }
        $urlRouter.update(true);

        return $state.current;
      }, function (error) {
        if ($state.transition !== transition) return TransitionSuperseded;

        $state.transition = null;
        /**
         * @ngdoc event
         * @name ui.router.state.$state#$stateChangeError
         * @eventOf ui.router.state.$state
         * @eventType broadcast on root scope
         * @description
         * Fired when an **error occurs** during transition. It's important to note that if you
         * have any errors in your resolve functions (javascript errors, non-existent services, etc)
         * they will not throw traditionally. You must listen for this $stateChangeError event to
         * catch **ALL** errors.
         *
         * @param {Object} event Event object.
         * @param {State} toState The state being transitioned to.
         * @param {Object} toParams The params supplied to the `toState`.
         * @param {State} fromState The current state, pre-transition.
         * @param {Object} fromParams The params supplied to the `fromState`.
         * @param {Error} error The resolve error object.
         */
        evt = $rootScope.$broadcast('$stateChangeError', to.self, toParams, from.self, fromParams, error);

        if (!evt.defaultPrevented) {
            $urlRouter.update();
        }

        return $q.reject(error);
      });

      return transition;
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#is
     * @methodOf ui.router.state.$state
     *
     * @description
     * Similar to {@link ui.router.state.$state#methods_includes $state.includes},
     * but only checks for the full state name. If params is supplied then it will be
     * tested for strict equality against the current active params object, so all params
     * must match with none missing and no extras.
     *
     * @example
     * <pre>
     * $state.$current.name = 'contacts.details.item';
     *
     * // absolute name
     * $state.is('contact.details.item'); // returns true
     * $state.is(contactDetailItemStateObject); // returns true
     *
     * // relative name (. and ^), typically from a template
     * // E.g. from the 'contacts.details' template
     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
     * </pre>
     *
     * @param {string|object} stateOrName The state name (absolute or relative) or state object you'd like to check.
     * @param {object=} params A param object, e.g. `{sectionId: section.id}`, that you'd like
     * to test against the current active state.
     * @param {object=} options An options object.  The options are:
     *
     * - **`relative`** - {string|object} -  If `stateOrName` is a relative state name and `options.relative` is set, .is will
     * test relative to `options.relative` state (or name).
     *
     * @returns {boolean} Returns true if it is the state.
     */
    $state.is = function is(stateOrName, params, options) {
      options = extend({ relative: $state.$current }, options || {});
      var state = findState(stateOrName, options.relative);

      if (!isDefined(state)) { return undefined; }
      if ($state.$current !== state) { return false; }
      return params ? equalForKeys(state.params.$$values(params), $stateParams) : true;
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#includes
     * @methodOf ui.router.state.$state
     *
     * @description
     * A method to determine if the current active state is equal to or is the child of the
     * state stateName. If any params are passed then they will be tested for a match as well.
     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
     *
     * @example
     * Partial and relative names
     * <pre>
     * $state.$current.name = 'contacts.details.item';
     *
     * // Using partial names
     * $state.includes("contacts"); // returns true
     * $state.includes("contacts.details"); // returns true
     * $state.includes("contacts.details.item"); // returns true
     * $state.includes("contacts.list"); // returns false
     * $state.includes("about"); // returns false
     *
     * // Using relative names (. and ^), typically from a template
     * // E.g. from the 'contacts.details' template
     * <div ng-class="{highlighted: $state.includes('.item')}">Item</div>
     * </pre>
     *
     * Basic globbing patterns
     * <pre>
     * $state.$current.name = 'contacts.details.item.url';
     *
     * $state.includes("*.details.*.*"); // returns true
     * $state.includes("*.details.**"); // returns true
     * $state.includes("**.item.**"); // returns true
     * $state.includes("*.details.item.url"); // returns true
     * $state.includes("*.details.*.url"); // returns true
     * $state.includes("*.details.*"); // returns false
     * $state.includes("item.**"); // returns false
     * </pre>
     *
     * @param {string} stateOrName A partial name, relative name, or glob pattern
     * to be searched for within the current state name.
     * @param {object=} params A param object, e.g. `{sectionId: section.id}`,
     * that you'd like to test against the current active state.
     * @param {object=} options An options object.  The options are:
     *
     * - **`relative`** - {string|object=} -  If `stateOrName` is a relative state reference and `options.relative` is set,
     * .includes will test relative to `options.relative` state (or name).
     *
     * @returns {boolean} Returns true if it does include the state
     */
    $state.includes = function includes(stateOrName, params, options) {
      options = extend({ relative: $state.$current }, options || {});
      if (isString(stateOrName) && isGlob(stateOrName)) {
        if (!doesStateMatchGlob(stateOrName)) {
          return false;
        }
        stateOrName = $state.$current.name;
      }

      var state = findState(stateOrName, options.relative);
      if (!isDefined(state)) { return undefined; }
      if (!isDefined($state.$current.includes[state.name])) { return false; }
      return params ? equalForKeys(state.params.$$values(params), $stateParams, objectKeys(params)) : true;
    };


    /**
     * @ngdoc function
     * @name ui.router.state.$state#href
     * @methodOf ui.router.state.$state
     *
     * @description
     * A url generation method that returns the compiled url for the given state populated with the given params.
     *
     * @example
     * <pre>
     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
     * </pre>
     *
     * @param {string|object} stateOrName The state name or state object you'd like to generate a url from.
     * @param {object=} params An object of parameter values to fill the state's required parameters.
     * @param {object=} options Options object. The options are:
     *
     * - **`lossy`** - {boolean=true} -  If true, and if there is no url associated with the state provided in the
     *    first parameter, then the constructed href url will be built from the first navigable ancestor (aka
     *    ancestor with a valid url).
     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
     *    defines which state to be relative from.
     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
     * 
     * @returns {string} compiled state url
     */
    $state.href = function href(stateOrName, params, options) {
      options = extend({
        lossy:    true,
        inherit:  true,
        absolute: false,
        relative: $state.$current
      }, options || {});

      var state = findState(stateOrName, options.relative);

      if (!isDefined(state)) return null;
      if (options.inherit) params = inheritParams($stateParams, params || {}, $state.$current, state);
      
      var nav = (state && options.lossy) ? state.navigable : state;

      if (!nav || nav.url === undefined || nav.url === null) {
        return null;
      }
      return $urlRouter.href(nav.url, filterByKeys(state.params.$$keys().concat('#'), params || {}), {
        absolute: options.absolute
      });
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#get
     * @methodOf ui.router.state.$state
     *
     * @description
     * Returns the state configuration object for any specific state or all states.
     *
     * @param {string|object=} stateOrName (absolute or relative) If provided, will only get the config for
     * the requested state. If not provided, returns an array of ALL state configs.
     * @param {string|object=} context When stateOrName is a relative state reference, the state will be retrieved relative to context.
     * @returns {Object|Array} State configuration object or array of all objects.
     */
    $state.get = function (stateOrName, context) {
      if (arguments.length === 0) return map(objectKeys(states), function(name) { return states[name].self; });
      var state = findState(stateOrName, context || $state.$current);
      return (state && state.self) ? state.self : null;
    };

    function resolveState(state, params, paramsAreFiltered, inherited, dst, options) {
      // Make a restricted $stateParams with only the parameters that apply to this state if
      // necessary. In addition to being available to the controller and onEnter/onExit callbacks,
      // we also need $stateParams to be available for any $injector calls we make during the
      // dependency resolution process.
      var $stateParams = (paramsAreFiltered) ? params : filterByKeys(state.params.$$keys(), params);
      var locals = { $stateParams: $stateParams };

      // Resolve 'global' dependencies for the state, i.e. those not specific to a view.
      // We're also including $stateParams in this; that way the parameters are restricted
      // to the set that should be visible to the state, and are independent of when we update
      // the global $state and $stateParams values.
      dst.resolve = $resolve.resolve(state.resolve, locals, dst.resolve, state);
      var promises = [dst.resolve.then(function (globals) {
        dst.globals = globals;
      })];
      if (inherited) promises.push(inherited);

      function resolveViews() {
        var viewsPromises = [];

        // Resolve template and dependencies for all views.
        forEach(state.views, function (view, name) {
          var injectables = (view.resolve && view.resolve !== state.resolve ? view.resolve : {});
          injectables.$template = [ function () {
            return $view.load(name, { view: view, locals: dst.globals, params: $stateParams, notify: options.notify }) || '';
          }];

          viewsPromises.push($resolve.resolve(injectables, dst.globals, dst.resolve, state).then(function (result) {
            // References to the controller (only instantiated at link time)
            if (isFunction(view.controllerProvider) || isArray(view.controllerProvider)) {
              var injectLocals = angular.extend({}, injectables, dst.globals);
              result.$$controller = $injector.invoke(view.controllerProvider, null, injectLocals);
            } else {
              result.$$controller = view.controller;
            }
            // Provide access to the state itself for internal use
            result.$$state = state;
            result.$$controllerAs = view.controllerAs;
            dst[name] = result;
          }));
        });

        return $q.all(viewsPromises).then(function(){
          return dst.globals;
        });
      }

      // Wait for all the promises and then return the activation object
      return $q.all(promises).then(resolveViews).then(function (values) {
        return dst;
      });
    }

    return $state;
  }

  function shouldSkipReload(to, toParams, from, fromParams, locals, options) {
    // Return true if there are no differences in non-search (path/object) params, false if there are differences
    function nonSearchParamsEqual(fromAndToState, fromParams, toParams) {
      // Identify whether all the parameters that differ between `fromParams` and `toParams` were search params.
      function notSearchParam(key) {
        return fromAndToState.params[key].location != "search";
      }
      var nonQueryParamKeys = fromAndToState.params.$$keys().filter(notSearchParam);
      var nonQueryParams = pick.apply({}, [fromAndToState.params].concat(nonQueryParamKeys));
      var nonQueryParamSet = new $$UMFP.ParamSet(nonQueryParams);
      return nonQueryParamSet.$$equals(fromParams, toParams);
    }

    // If reload was not explicitly requested
    // and we're transitioning to the same state we're already in
    // and    the locals didn't change
    //     or they changed in a way that doesn't merit reloading
    //        (reloadOnParams:false, or reloadOnSearch.false and only search params changed)
    // Then return true.
    if (!options.reload && to === from &&
      (locals === from.locals || (to.self.reloadOnSearch === false && nonSearchParamsEqual(from, fromParams, toParams)))) {
      return true;
    }
  }
}

angular.module('ui.router.state')
  .factory('$stateParams', function () { return {}; })
  .provider('$state', $StateProvider);


$ViewProvider.$inject = [];
function $ViewProvider() {

  this.$get = $get;
  /**
   * @ngdoc object
   * @name ui.router.state.$view
   *
   * @requires ui.router.util.$templateFactory
   * @requires $rootScope
   *
   * @description
   *
   */
  $get.$inject = ['$rootScope', '$templateFactory'];
  function $get(   $rootScope,   $templateFactory) {
    return {
      // $view.load('full.viewName', { template: ..., controller: ..., resolve: ..., async: false, params: ... })
      /**
       * @ngdoc function
       * @name ui.router.state.$view#load
       * @methodOf ui.router.state.$view
       *
       * @description
       *
       * @param {string} name name
       * @param {object} options option object.
       */
      load: function load(name, options) {
        var result, defaults = {
          template: null, controller: null, view: null, locals: null, notify: true, async: true, params: {}
        };
        options = extend(defaults, options);

        if (options.view) {
          result = $templateFactory.fromConfig(options.view, options.params, options.locals);
        }
        return result;
      }
    };
  }
}

angular.module('ui.router.state').provider('$view', $ViewProvider);

/**
 * @ngdoc object
 * @name ui.router.state.$uiViewScrollProvider
 *
 * @description
 * Provider that returns the {@link ui.router.state.$uiViewScroll} service function.
 */
function $ViewScrollProvider() {

  var useAnchorScroll = false;

  /**
   * @ngdoc function
   * @name ui.router.state.$uiViewScrollProvider#useAnchorScroll
   * @methodOf ui.router.state.$uiViewScrollProvider
   *
   * @description
   * Reverts back to using the core [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll) service for
   * scrolling based on the url anchor.
   */
  this.useAnchorScroll = function () {
    useAnchorScroll = true;
  };

  /**
   * @ngdoc object
   * @name ui.router.state.$uiViewScroll
   *
   * @requires $anchorScroll
   * @requires $timeout
   *
   * @description
   * When called with a jqLite element, it scrolls the element into view (after a
   * `$timeout` so the DOM has time to refresh).
   *
   * If you prefer to rely on `$anchorScroll` to scroll the view to the anchor,
   * this can be enabled by calling {@link ui.router.state.$uiViewScrollProvider#methods_useAnchorScroll `$uiViewScrollProvider.useAnchorScroll()`}.
   */
  this.$get = ['$anchorScroll', '$timeout', function ($anchorScroll, $timeout) {
    if (useAnchorScroll) {
      return $anchorScroll;
    }

    return function ($element) {
      return $timeout(function () {
        $element[0].scrollIntoView();
      }, 0, false);
    };
  }];
}

angular.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);

var ngMajorVer = angular.version.major;
var ngMinorVer = angular.version.minor;
/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-view
 *
 * @requires ui.router.state.$state
 * @requires $compile
 * @requires $controller
 * @requires $injector
 * @requires ui.router.state.$uiViewScroll
 * @requires $document
 *
 * @restrict ECA
 *
 * @description
 * The ui-view directive tells $state where to place your templates.
 *
 * @param {string=} name A view name. The name should be unique amongst the other views in the
 * same state. You can have views of the same name that live in different states.
 *
 * @param {string=} autoscroll It allows you to set the scroll behavior of the browser window
 * when a view is populated. By default, $anchorScroll is overridden by ui-router's custom scroll
 * service, {@link ui.router.state.$uiViewScroll}. This custom service let's you
 * scroll ui-view elements into view when they are populated during a state activation.
 *
 * @param {string=} noanimation If truthy, the non-animated renderer will be selected (no animations
 * will be applied to the ui-view)
 *
 * *Note: To revert back to old [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll)
 * functionality, call `$uiViewScrollProvider.useAnchorScroll()`.*
 *
 * @param {string=} onload Expression to evaluate whenever the view updates.
 * 
 * @example
 * A view can be unnamed or named. 
 * <pre>
 * <!-- Unnamed -->
 * <div ui-view></div> 
 * 
 * <!-- Named -->
 * <div ui-view="viewName"></div>
 * </pre>
 *
 * You can only have one unnamed view within any template (or root html). If you are only using a 
 * single view and it is unnamed then you can populate it like so:
 * <pre>
 * <div ui-view></div> 
 * $stateProvider.state("home", {
 *   template: "<h1>HELLO!</h1>"
 * })
 * </pre>
 * 
 * The above is a convenient shortcut equivalent to specifying your view explicitly with the {@link ui.router.state.$stateProvider#views `views`}
 * config property, by name, in this case an empty name:
 * <pre>
 * $stateProvider.state("home", {
 *   views: {
 *     "": {
 *       template: "<h1>HELLO!</h1>"
 *     }
 *   }    
 * })
 * </pre>
 * 
 * But typically you'll only use the views property if you name your view or have more than one view 
 * in the same template. There's not really a compelling reason to name a view if its the only one, 
 * but you could if you wanted, like so:
 * <pre>
 * <div ui-view="main"></div>
 * </pre> 
 * <pre>
 * $stateProvider.state("home", {
 *   views: {
 *     "main": {
 *       template: "<h1>HELLO!</h1>"
 *     }
 *   }    
 * })
 * </pre>
 * 
 * Really though, you'll use views to set up multiple views:
 * <pre>
 * <div ui-view></div>
 * <div ui-view="chart"></div> 
 * <div ui-view="data"></div> 
 * </pre>
 * 
 * <pre>
 * $stateProvider.state("home", {
 *   views: {
 *     "": {
 *       template: "<h1>HELLO!</h1>"
 *     },
 *     "chart": {
 *       template: "<chart_thing/>"
 *     },
 *     "data": {
 *       template: "<data_thing/>"
 *     }
 *   }    
 * })
 * </pre>
 *
 * Examples for `autoscroll`:
 *
 * <pre>
 * <!-- If autoscroll present with no expression,
 *      then scroll ui-view into view -->
 * <ui-view autoscroll/>
 *
 * <!-- If autoscroll present with valid expression,
 *      then scroll ui-view into view if expression evaluates to true -->
 * <ui-view autoscroll='true'/>
 * <ui-view autoscroll='false'/>
 * <ui-view autoscroll='scopeVariable'/>
 * </pre>
 */
$ViewDirective.$inject = ['$state', '$injector', '$uiViewScroll', '$interpolate'];
function $ViewDirective(   $state,   $injector,   $uiViewScroll,   $interpolate) {

  function getService() {
    return ($injector.has) ? function(service) {
      return $injector.has(service) ? $injector.get(service) : null;
    } : function(service) {
      try {
        return $injector.get(service);
      } catch (e) {
        return null;
      }
    };
  }

  var service = getService(),
      $animator = service('$animator'),
      $animate = service('$animate');

  // Returns a set of DOM manipulation functions based on which Angular version
  // it should use
  function getRenderer(attrs, scope) {
    var statics = {
      enter: function (element, target, cb) { target.after(element); cb(); },
      leave: function (element, cb) { element.remove(); cb(); }
    };

    if (!!attrs.noanimation) return statics;

    function animEnabled(element) {
      if (ngMajorVer === 1 && ngMinorVer >= 4) return !!$animate.enabled(element);
      if (ngMajorVer === 1 && ngMinorVer >= 2) return !!$animate.enabled();
      return (!!$animator);
    }

    // ng 1.2+
    if ($animate) {
      return {
        enter: function(element, target, cb) {
          if (!animEnabled(element)) {
            statics.enter(element, target, cb);
          } else if (angular.version.minor > 2) {
            $animate.enter(element, null, target).then(cb);
          } else {
            $animate.enter(element, null, target, cb);
          }
        },
        leave: function(element, cb) {
          if (!animEnabled(element)) {
            statics.leave(element, cb);
          } else if (angular.version.minor > 2) {
            $animate.leave(element).then(cb);
          } else {
            $animate.leave(element, cb);
          }
        }
      };
    }

    // ng 1.1.5
    if ($animator) {
      var animate = $animator && $animator(scope, attrs);

      return {
        enter: function(element, target, cb) {animate.enter(element, null, target); cb(); },
        leave: function(element, cb) { animate.leave(element); cb(); }
      };
    }

    return statics;
  }

  var directive = {
    restrict: 'ECA',
    terminal: true,
    priority: 400,
    transclude: 'element',
    compile: function (tElement, tAttrs, $transclude) {
      return function (scope, $element, attrs) {
        var previousEl, currentEl, currentScope, latestLocals,
            onloadExp     = attrs.onload || '',
            autoScrollExp = attrs.autoscroll,
            renderer      = getRenderer(attrs, scope);

        scope.$on('$stateChangeSuccess', function() {
          updateView(false);
        });

        updateView(true);

        function cleanupLastView() {
          var _previousEl = previousEl;
          var _currentScope = currentScope;

          if (_currentScope) {
            _currentScope._willBeDestroyed = true;
          }

          function cleanOld() {
            if (_previousEl) {
              _previousEl.remove();
            }

            if (_currentScope) {
              _currentScope.$destroy();
            }
          }

          if (currentEl) {
            renderer.leave(currentEl, function() {
              cleanOld();
              previousEl = null;
            });

            previousEl = currentEl;
          } else {
            cleanOld();
            previousEl = null;
          }

          currentEl = null;
          currentScope = null;
        }

        function updateView(firstTime) {
          var newScope,
              name            = getUiViewName(scope, attrs, $element, $interpolate),
              previousLocals  = name && $state.$current && $state.$current.locals[name];

          if (!firstTime && previousLocals === latestLocals || scope._willBeDestroyed) return; // nothing to do
          newScope = scope.$new();
          latestLocals = $state.$current.locals[name];

          /**
           * @ngdoc event
           * @name ui.router.state.directive:ui-view#$viewContentLoading
           * @eventOf ui.router.state.directive:ui-view
           * @eventType emits on ui-view directive scope
           * @description
           *
           * Fired once the view **begins loading**, *before* the DOM is rendered.
           *
           * @param {Object} event Event object.
           * @param {string} viewName Name of the view.
           */
          newScope.$emit('$viewContentLoading', name);

          var clone = $transclude(newScope, function(clone) {
            renderer.enter(clone, $element, function onUiViewEnter() {
              if(currentScope) {
                currentScope.$emit('$viewContentAnimationEnded');
              }

              if (angular.isDefined(autoScrollExp) && !autoScrollExp || scope.$eval(autoScrollExp)) {
                $uiViewScroll(clone);
              }
            });
            cleanupLastView();
          });

          currentEl = clone;
          currentScope = newScope;
          /**
           * @ngdoc event
           * @name ui.router.state.directive:ui-view#$viewContentLoaded
           * @eventOf ui.router.state.directive:ui-view
           * @eventType emits on ui-view directive scope
           * @description
           * Fired once the view is **loaded**, *after* the DOM is rendered.
           *
           * @param {Object} event Event object.
           * @param {string} viewName Name of the view.
           */
          currentScope.$emit('$viewContentLoaded', name);
          currentScope.$eval(onloadExp);
        }
      };
    }
  };

  return directive;
}

$ViewDirectiveFill.$inject = ['$compile', '$controller', '$state', '$interpolate'];
function $ViewDirectiveFill (  $compile,   $controller,   $state,   $interpolate) {
  return {
    restrict: 'ECA',
    priority: -400,
    compile: function (tElement) {
      var initial = tElement.html();
      return function (scope, $element, attrs) {
        var current = $state.$current,
            name = getUiViewName(scope, attrs, $element, $interpolate),
            locals  = current && current.locals[name];

        if (! locals) {
          return;
        }

        $element.data('$uiView', { name: name, state: locals.$$state });
        $element.html(locals.$template ? locals.$template : initial);

        var link = $compile($element.contents());

        if (locals.$$controller) {
          locals.$scope = scope;
          locals.$element = $element;
          var controller = $controller(locals.$$controller, locals);
          if (locals.$$controllerAs) {
            scope[locals.$$controllerAs] = controller;
          }
          $element.data('$ngControllerController', controller);
          $element.children().data('$ngControllerController', controller);
        }

        link(scope);
      };
    }
  };
}

/**
 * Shared ui-view code for both directives:
 * Given scope, element, and its attributes, return the view's name
 */
function getUiViewName(scope, attrs, element, $interpolate) {
  var name = $interpolate(attrs.uiView || attrs.name || '')(scope);
  var inherited = element.inheritedData('$uiView');
  return name.indexOf('@') >= 0 ?  name :  (name + '@' + (inherited ? inherited.state.name : ''));
}

angular.module('ui.router.state').directive('uiView', $ViewDirective);
angular.module('ui.router.state').directive('uiView', $ViewDirectiveFill);

function parseStateRef(ref, current) {
  var preparsed = ref.match(/^\s*({[^}]*})\s*$/), parsed;
  if (preparsed) ref = current + '(' + preparsed[1] + ')';
  parsed = ref.replace(/\n/g, " ").match(/^([^(]+?)\s*(\((.*)\))?$/);
  if (!parsed || parsed.length !== 4) throw new Error("Invalid state ref '" + ref + "'");
  return { state: parsed[1], paramExpr: parsed[3] || null };
}

function stateContext(el) {
  var stateData = el.parent().inheritedData('$uiView');

  if (stateData && stateData.state && stateData.state.name) {
    return stateData.state;
  }
}

function getTypeInfo(el) {
  // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
  var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
  var isForm = el[0].nodeName === "FORM";

  return {
    attr: isForm ? "action" : (isSvg ? 'xlink:href' : 'href'),
    isAnchor: el.prop("tagName").toUpperCase() === "A",
    clickable: !isForm
  };
}

function clickHook(el, $state, $timeout, type, current) {
  return function(e) {
    var button = e.which || e.button, target = current();

    if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || el.attr('target'))) {
      // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
      var transition = $timeout(function() {
        $state.go(target.state, target.params, target.options);
      });
      e.preventDefault();

      // if the state has no URL, ignore one preventDefault from the <a> directive.
      var ignorePreventDefaultCount = type.isAnchor && !target.href ? 1: 0;

      e.preventDefault = function() {
        if (ignorePreventDefaultCount-- <= 0) $timeout.cancel(transition);
      };
    }
  };
}

function defaultOpts(el, $state) {
  return { relative: stateContext(el) || $state.$current, inherit: true };
}

/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-sref
 *
 * @requires ui.router.state.$state
 * @requires $timeout
 *
 * @restrict A
 *
 * @description
 * A directive that binds a link (`<a>` tag) to a state. If the state has an associated
 * URL, the directive will automatically generate & update the `href` attribute via
 * the {@link ui.router.state.$state#methods_href $state.href()} method. Clicking
 * the link will trigger a state transition with optional parameters.
 *
 * Also middle-clicking, right-clicking, and ctrl-clicking on the link will be
 * handled natively by the browser.
 *
 * You can also use relative state paths within ui-sref, just like the relative
 * paths passed to `$state.go()`. You just need to be aware that the path is relative
 * to the state that the link lives in, in other words the state that loaded the
 * template containing the link.
 *
 * You can specify options to pass to {@link ui.router.state.$state#go $state.go()}
 * using the `ui-sref-opts` attribute. Options are restricted to `location`, `inherit`,
 * and `reload`.
 *
 * @example
 * Here's an example of how you'd use ui-sref and how it would compile. If you have the
 * following template:
 * <pre>
 * <a ui-sref="home">Home</a> | <a ui-sref="about">About</a> | <a ui-sref="{page: 2}">Next page</a>
 *
 * <ul>
 *     <li ng-repeat="contact in contacts">
 *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
 *     </li>
 * </ul>
 * </pre>
 *
 * Then the compiled html would be (assuming Html5Mode is off and current state is contacts):
 * <pre>
 * <a href="#/home" ui-sref="home">Home</a> | <a href="#/about" ui-sref="about">About</a> | <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
 *
 * <ul>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
 *     </li>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
 *     </li>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
 *     </li>
 * </ul>
 *
 * <a ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
 * </pre>
 *
 * @param {string} ui-sref 'stateName' can be any valid absolute or relative state
 * @param {Object} ui-sref-opts options to pass to {@link ui.router.state.$state#go $state.go()}
 */
$StateRefDirective.$inject = ['$state', '$timeout'];
function $StateRefDirective($state, $timeout) {
  return {
    restrict: 'A',
    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
    link: function(scope, element, attrs, uiSrefActive) {
      var ref    = parseStateRef(attrs.uiSref, $state.current.name);
      var def    = { state: ref.state, href: null, params: null };
      var type   = getTypeInfo(element);
      var active = uiSrefActive[1] || uiSrefActive[0];

      def.options = extend(defaultOpts(element, $state), attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {});

      var update = function(val) {
        if (val) def.params = angular.copy(val);
        def.href = $state.href(ref.state, def.params, def.options);

        if (active) active.$$addStateInfo(ref.state, def.params);
        if (def.href !== null) attrs.$set(type.attr, def.href);
      };

      if (ref.paramExpr) {
        scope.$watch(ref.paramExpr, function(val) { if (val !== def.params) update(val); }, true);
        def.params = angular.copy(scope.$eval(ref.paramExpr));
      }
      update();

      if (!type.clickable) return;
      element.bind("click", clickHook(element, $state, $timeout, type, function() { return def; }));
    }
  };
}

/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-state
 *
 * @requires ui.router.state.uiSref
 *
 * @restrict A
 *
 * @description
 * Much like ui-sref, but will accept named $scope properties to evaluate for a state definition,
 * params and override options.
 *
 * @param {string} ui-state 'stateName' can be any valid absolute or relative state
 * @param {Object} ui-state-params params to pass to {@link ui.router.state.$state#href $state.href()}
 * @param {Object} ui-state-opts options to pass to {@link ui.router.state.$state#go $state.go()}
 */
$StateRefDynamicDirective.$inject = ['$state', '$timeout'];
function $StateRefDynamicDirective($state, $timeout) {
  return {
    restrict: 'A',
    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
    link: function(scope, element, attrs, uiSrefActive) {
      var type   = getTypeInfo(element);
      var active = uiSrefActive[1] || uiSrefActive[0];
      var group  = [attrs.uiState, attrs.uiStateParams || null, attrs.uiStateOpts || null];
      var watch  = '[' + group.map(function(val) { return val || 'null'; }).join(', ') + ']';
      var def    = { state: null, params: null, options: null, href: null };

      function runStateRefLink (group) {
        def.state = group[0]; def.params = group[1]; def.options = group[2];
        def.href = $state.href(def.state, def.params, def.options);

        if (active) active.$$addStateInfo(def.state, def.params);
        if (def.href) attrs.$set(type.attr, def.href);
      }

      scope.$watch(watch, runStateRefLink, true);
      runStateRefLink(scope.$eval(watch));

      if (!type.clickable) return;
      element.bind("click", clickHook(element, $state, $timeout, type, function() { return def; }));
    }
  };
}


/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-sref-active
 *
 * @requires ui.router.state.$state
 * @requires ui.router.state.$stateParams
 * @requires $interpolate
 *
 * @restrict A
 *
 * @description
 * A directive working alongside ui-sref to add classes to an element when the
 * related ui-sref directive's state is active, and removing them when it is inactive.
 * The primary use-case is to simplify the special appearance of navigation menus
 * relying on `ui-sref`, by having the "active" state's menu button appear different,
 * distinguishing it from the inactive menu items.
 *
 * ui-sref-active can live on the same element as ui-sref or on a parent element. The first
 * ui-sref-active found at the same level or above the ui-sref will be used.
 *
 * Will activate when the ui-sref's target state or any child state is active. If you
 * need to activate only when the ui-sref target state is active and *not* any of
 * it's children, then you will use
 * {@link ui.router.state.directive:ui-sref-active-eq ui-sref-active-eq}
 *
 * @example
 * Given the following template:
 * <pre>
 * <ul>
 *   <li ui-sref-active="active" class="item">
 *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
 *   </li>
 * </ul>
 * </pre>
 *
 *
 * When the app state is "app.user" (or any children states), and contains the state parameter "user" with value "bilbobaggins",
 * the resulting HTML will appear as (note the 'active' class):
 * <pre>
 * <ul>
 *   <li ui-sref-active="active" class="item active">
 *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
 *   </li>
 * </ul>
 * </pre>
 *
 * The class name is interpolated **once** during the directives link time (any further changes to the
 * interpolated value are ignored).
 *
 * Multiple classes may be specified in a space-separated format:
 * <pre>
 * <ul>
 *   <li ui-sref-active='class1 class2 class3'>
 *     <a ui-sref="app.user">link</a>
 *   </li>
 * </ul>
 * </pre>
 *
 * It is also possible to pass ui-sref-active an expression that evaluates
 * to an object hash, whose keys represent active class names and whose
 * values represent the respective state names/globs.
 * ui-sref-active will match if the current active state **includes** any of
 * the specified state names/globs, even the abstract ones.
 *
 * @Example
 * Given the following template, with "admin" being an abstract state:
 * <pre>
 * <div ui-sref-active="{'active': 'admin.*'}">
 *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
 * </div>
 * </pre>
 *
 * When the current state is "admin.roles" the "active" class will be applied
 * to both the <div> and <a> elements. It is important to note that the state
 * names/globs passed to ui-sref-active shadow the state provided by ui-sref.
 */

/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-sref-active-eq
 *
 * @requires ui.router.state.$state
 * @requires ui.router.state.$stateParams
 * @requires $interpolate
 *
 * @restrict A
 *
 * @description
 * The same as {@link ui.router.state.directive:ui-sref-active ui-sref-active} but will only activate
 * when the exact target state used in the `ui-sref` is active; no child states.
 *
 */
$StateRefActiveDirective.$inject = ['$state', '$stateParams', '$interpolate'];
function $StateRefActiveDirective($state, $stateParams, $interpolate) {
  return  {
    restrict: "A",
    controller: ['$scope', '$element', '$attrs', '$timeout', function ($scope, $element, $attrs, $timeout) {
      var states = [], activeClasses = {}, activeEqClass, uiSrefActive;

      // There probably isn't much point in $observing this
      // uiSrefActive and uiSrefActiveEq share the same directive object with some
      // slight difference in logic routing
      activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);

      try {
        uiSrefActive = $scope.$eval($attrs.uiSrefActive);
      } catch (e) {
        // Do nothing. uiSrefActive is not a valid expression.
        // Fall back to using $interpolate below
      }
      uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
      if (isObject(uiSrefActive)) {
        forEach(uiSrefActive, function(stateOrName, activeClass) {
          if (isString(stateOrName)) {
            var ref = parseStateRef(stateOrName, $state.current.name);
            addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
          }
        });
      }

      // Allow uiSref to communicate with uiSrefActive[Equals]
      this.$$addStateInfo = function (newState, newParams) {
        // we already got an explicit state provided by ui-sref-active, so we
        // shadow the one that comes from ui-sref
        if (isObject(uiSrefActive) && states.length > 0) {
          return;
        }
        addState(newState, newParams, uiSrefActive);
        update();
      };

      $scope.$on('$stateChangeSuccess', update);

      function addState(stateName, stateParams, activeClass) {
        var state = $state.get(stateName, stateContext($element));
        var stateHash = createStateHash(stateName, stateParams);

        states.push({
          state: state || { name: stateName },
          params: stateParams,
          hash: stateHash
        });

        activeClasses[stateHash] = activeClass;
      }

      /**
       * @param {string} state
       * @param {Object|string} [params]
       * @return {string}
       */
      function createStateHash(state, params) {
        if (!isString(state)) {
          throw new Error('state should be a string');
        }
        if (isObject(params)) {
          return state + toJson(params);
        }
        params = $scope.$eval(params);
        if (isObject(params)) {
          return state + toJson(params);
        }
        return state;
      }

      // Update route state
      function update() {
        for (var i = 0; i < states.length; i++) {
          if (anyMatch(states[i].state, states[i].params)) {
            addClass($element, activeClasses[states[i].hash]);
          } else {
            removeClass($element, activeClasses[states[i].hash]);
          }

          if (exactMatch(states[i].state, states[i].params)) {
            addClass($element, activeEqClass);
          } else {
            removeClass($element, activeEqClass);
          }
        }
      }

      function addClass(el, className) { $timeout(function () { el.addClass(className); }); }
      function removeClass(el, className) { el.removeClass(className); }
      function anyMatch(state, params) { return $state.includes(state.name, params); }
      function exactMatch(state, params) { return $state.is(state.name, params); }

      update();
    }]
  };
}

angular.module('ui.router.state')
  .directive('uiSref', $StateRefDirective)
  .directive('uiSrefActive', $StateRefActiveDirective)
  .directive('uiSrefActiveEq', $StateRefActiveDirective)
  .directive('uiState', $StateRefDynamicDirective);

/**
 * @ngdoc filter
 * @name ui.router.state.filter:isState
 *
 * @requires ui.router.state.$state
 *
 * @description
 * Translates to {@link ui.router.state.$state#methods_is $state.is("stateName")}.
 */
$IsStateFilter.$inject = ['$state'];
function $IsStateFilter($state) {
  var isFilter = function (state, params) {
    return $state.is(state, params);
  };
  isFilter.$stateful = true;
  return isFilter;
}

/**
 * @ngdoc filter
 * @name ui.router.state.filter:includedByState
 *
 * @requires ui.router.state.$state
 *
 * @description
 * Translates to {@link ui.router.state.$state#methods_includes $state.includes('fullOrPartialStateName')}.
 */
$IncludedByStateFilter.$inject = ['$state'];
function $IncludedByStateFilter($state) {
  var includesFilter = function (state, params, options) {
    return $state.includes(state, params, options);
  };
  includesFilter.$stateful = true;
  return  includesFilter;
}

angular.module('ui.router.state')
  .filter('isState', $IsStateFilter)
  .filter('includedByState', $IncludedByStateFilter);
})(window, window.angular);

/***/ }),
/* 26 */
/***/ (function(module, exports) {

/**
 * @license Angular UI Tree v2.22.6
 * (c) 2010-2017. https://github.com/angular-ui-tree/angular-ui-tree
 * License: MIT
 */
(function () {
  'use strict';

  angular.module('ui.tree', [])
    .constant('treeConfig', {
      treeClass: 'angular-ui-tree',
      emptyTreeClass: 'angular-ui-tree-empty',
      dropzoneClass: 'angular-ui-tree-dropzone',
      hiddenClass: 'angular-ui-tree-hidden',
      nodesClass: 'angular-ui-tree-nodes',
      nodeClass: 'angular-ui-tree-node',
      handleClass: 'angular-ui-tree-handle',
      placeholderClass: 'angular-ui-tree-placeholder',
      dragClass: 'angular-ui-tree-drag',
      dragThreshold: 3,
      defaultCollapsed: false,
      appendChildOnHover: true
    });

})();

(function () {
  'use strict';

  angular.module('ui.tree')

    .controller('TreeHandleController', ['$scope', '$element',
      function ($scope, $element) {
        this.scope = $scope;

        $scope.$element = $element;
        $scope.$nodeScope = null;
        $scope.$type = 'uiTreeHandle';

      }
    ]);
})();

(function () {
  'use strict';

  angular.module('ui.tree')
    .controller('TreeNodeController', ['$scope', '$element',
      function ($scope, $element) {
        this.scope = $scope;

        $scope.$element = $element;
        $scope.$modelValue = null; // Model value for node;
        $scope.$parentNodeScope = null; // uiTreeNode Scope of parent node;
        $scope.$childNodesScope = null; // uiTreeNodes Scope of child nodes.
        $scope.$parentNodesScope = null; // uiTreeNodes Scope of parent nodes.
        $scope.$treeScope = null; // uiTree scope
        $scope.$handleScope = null; // it's handle scope
        $scope.$type = 'uiTreeNode';
        $scope.$$allowNodeDrop = false;
        $scope.collapsed = false;
        $scope.expandOnHover = false;

        //Called by uiTreeNode Directive on load.
        $scope.init = function (controllersArr) {
          var treeNodesCtrl = controllersArr[0];
          $scope.$treeScope = controllersArr[1] ? controllersArr[1].scope : null;

          //Find the scope of it's parent node.
          $scope.$parentNodeScope = treeNodesCtrl.scope.$nodeScope;

          //modelValue for current node.
          $scope.$modelValue = treeNodesCtrl.scope.$modelValue[$scope.$index];
          $scope.$parentNodesScope = treeNodesCtrl.scope;

          //Init sub nodes.
          treeNodesCtrl.scope.initSubNode($scope);

          $element.on('$destroy', function () {

            //Destroy sub nodes.
            treeNodesCtrl.scope.destroySubNode($scope);
          });
        };

        //Return the index of child node in parent node (nodesScope).
        $scope.index = function () {
          return $scope.$parentNodesScope.$modelValue.indexOf($scope.$modelValue);
        };

        $scope.dragEnabled = function () {
          return !($scope.$treeScope && !$scope.$treeScope.dragEnabled);
        };

        $scope.isSibling = function (targetNode) {
          return $scope.$parentNodesScope == targetNode.$parentNodesScope;
        };

        $scope.isChild = function (targetNode) {
          var nodes = $scope.childNodes();
          return nodes && nodes.indexOf(targetNode) > -1;
        };

        //TODO(jcarter): This method is on uiTreeHelper already.
        $scope.prev = function () {
          var index = $scope.index();
          if (index > 0) {
            return $scope.siblings()[index - 1];
          }
          return null;
        };

        //Calls childNodes on parent.
        $scope.siblings = function () {
          return $scope.$parentNodesScope.childNodes();
        };

        $scope.childNodesCount = function () {
          return $scope.childNodes() ? $scope.childNodes().length : 0;
        };

        $scope.hasChild = function () {
          return $scope.childNodesCount() > 0;
        };

        $scope.childNodes = function () {
          return $scope.$childNodesScope && $scope.$childNodesScope.$modelValue ?
            $scope.$childNodesScope.childNodes() :
            null;
        };

        $scope.accept = function (sourceNode, destIndex) {
          return $scope.$childNodesScope &&
            $scope.$childNodesScope.$modelValue &&
            $scope.$childNodesScope.accept(sourceNode, destIndex);
        };

        $scope.remove = function () {
          return $scope.$parentNodesScope.removeNode($scope);
        };

        $scope.toggle = function () {
          $scope.collapsed = !$scope.collapsed;
          $scope.$treeScope.$callbacks.toggle($scope.collapsed, $scope);
        };

        $scope.collapse = function () {
          $scope.collapsed = true;
        };

        $scope.expand = function () {
          $scope.collapsed = false;
        };

        $scope.depth = function () {
          var parentNode = $scope.$parentNodeScope;
          if (parentNode) {
            return parentNode.depth() + 1;
          }
          return 1;
        };

        /**
        * Returns the depth of the deepest subtree under this node
        * @param scope a TreeNodesController scope object
        * @returns Depth of all nodes *beneath* this node. If scope belongs to a leaf node, the
        *   result is 0 (it has no subtree).
        */
        function countSubTreeDepth(scope) {
          if (!scope) {
            return 0;
          }
          var thisLevelDepth = 0,
              childNodes = scope.childNodes(),
              childNode,
              childDepth,
              i;
          if (!childNodes || childNodes.length === 0) {
            return 0;
          }
          for (i = childNodes.length - 1; i >= 0 ; i--) {
            childNode = childNodes[i],
            childDepth = 1 + countSubTreeDepth(childNode);
            thisLevelDepth = Math.max(thisLevelDepth, childDepth);
          }
          return thisLevelDepth;
        }

        $scope.maxSubDepth = function () {
          return $scope.$childNodesScope ? countSubTreeDepth($scope.$childNodesScope) : 0;
        };
      }
    ]);
})();

(function () {
  'use strict';

  angular.module('ui.tree')

    .controller('TreeNodesController', ['$scope', '$element', '$timeout',
      function ($scope, $element, $timeout) {
        this.scope = $scope;

        $scope.$element = $element;
        $scope.$modelValue = null;
        $scope.$nodeScope = null; // the scope of node which the nodes belongs to
        $scope.$treeScope = null;
        $scope.$type = 'uiTreeNodes';
        $scope.$nodesMap = {};

        $scope.nodropEnabled = false;
        $scope.maxDepth = 0;
        $scope.cloneEnabled = false;

        $scope.initSubNode = function (subNode) {
          if (!subNode.$modelValue) {
            return null;
          }
          $scope.$nodesMap[subNode.$modelValue.$$hashKey] = subNode;
        };

        $scope.destroySubNode = function (subNode) {
          if (!subNode.$modelValue) {
            return null;
          }
          $scope.$nodesMap[subNode.$modelValue.$$hashKey] = null;
        };

        $scope.accept = function (sourceNode, destIndex) {
          return $scope.$treeScope.$callbacks.accept(sourceNode, $scope, destIndex);
        };

        $scope.beforeDrag = function (sourceNode) {
          return $scope.$treeScope.$callbacks.beforeDrag(sourceNode);
        };

        $scope.isParent = function (node) {
          return node.$parentNodesScope == $scope;
        };

        $scope.hasChild = function () {
          return $scope.$modelValue.length > 0;
        };

        //Called in apply method of UiTreeHelper.dragInfo.
        $scope.removeNode = function (node) {
          var index = $scope.$modelValue.indexOf(node.$modelValue);
          if (index > -1) {
            $timeout(function () {
              $scope.$modelValue.splice(index, 1)[0];
            });
            return $scope.$treeScope.$callbacks.removed(node);
          }
          return null;
        };

        //Called in apply method of UiTreeHelper.dragInfo.
        $scope.insertNode = function (index, nodeData) {
          $timeout(function () {
            $scope.$modelValue.splice(index, 0, nodeData);
          });
        };

        $scope.childNodes = function () {
          var i, nodes = [];
          if ($scope.$modelValue) {
            for (i = 0; i < $scope.$modelValue.length; i++) {
              nodes.push($scope.$nodesMap[$scope.$modelValue[i].$$hashKey]);
            }
          }
          return nodes;
        };

        $scope.depth = function () {
          if ($scope.$nodeScope) {
            return $scope.$nodeScope.depth();
          }
          return 0; // if it has no $nodeScope, it's root
        };

        // check if depth limit has reached
        $scope.outOfDepth = function (sourceNode) {
          var maxDepth = $scope.maxDepth || $scope.$treeScope.maxDepth;
          if (maxDepth > 0) {
            return $scope.depth() + sourceNode.maxSubDepth() + 1 > maxDepth;
          }
          return false;
        };

      }
    ]);
})();

(function () {
  'use strict';

  angular.module('ui.tree')

    .controller('TreeController', ['$scope', '$element',
      function ($scope, $element) {
        this.scope = $scope;

        $scope.$element = $element;
        $scope.$nodesScope = null; // root nodes
        $scope.$type = 'uiTree';
        $scope.$emptyElm = null;
        $scope.$dropzoneElm = null;
        $scope.$callbacks = null;

        $scope.dragEnabled = true;
        $scope.emptyPlaceholderEnabled = true;
        $scope.maxDepth = 0;
        $scope.dragDelay = 0;
        $scope.cloneEnabled = false;
        $scope.nodropEnabled = false;
        $scope.dropzoneEnabled = false;

        // Check if it's a empty tree
        $scope.isEmpty = function () {
          return ($scope.$nodesScope && $scope.$nodesScope.$modelValue
          && $scope.$nodesScope.$modelValue.length === 0);
        };

        // add placeholder to empty tree
        $scope.place = function (placeElm) {
          $scope.$nodesScope.$element.append(placeElm);
          $scope.$emptyElm.remove();
        };

        this.resetEmptyElement = function () {
          if ((!$scope.$nodesScope.$modelValue || $scope.$nodesScope.$modelValue.length === 0) &&
            $scope.emptyPlaceholderEnabled) {
            $element.append($scope.$emptyElm);
          } else {
            $scope.$emptyElm.remove();
          }
        };

        this.resetDropzoneElement = function () {
          if ((!$scope.$nodesScope.$modelValue || $scope.$nodesScope.$modelValue.length !== 0) &&
            $scope.dropzoneEnabled) {
            $element.append($scope.$dropzoneElm);
          } else {
            $scope.$dropzoneElm.remove();
          }
        };

        $scope.resetEmptyElement = this.resetEmptyElement;
        $scope.resetDropzoneElement = this.resetDropzoneElement;
      }
    ]);
})();

(function () {
  'use strict';

  angular.module('ui.tree')
    .directive('uiTree', ['treeConfig', '$window',
      function (treeConfig, $window) {
        return {
          restrict: 'A',
          scope: true,
          controller: 'TreeController',
          link: function (scope, element, attrs, ctrl) {
            var callbacks = {
              accept: null,
              beforeDrag: null
            },
            config = {},
            tdElm,
            $trElm,
            emptyElmColspan;

            //Adding configured class to uiTree.
            angular.extend(config, treeConfig);

            if (config.treeClass) {
              element.addClass(config.treeClass);
            }

            //Determining if uiTree is on a table.
            if (element.prop('tagName').toLowerCase() === 'table') {
              scope.$emptyElm = angular.element($window.document.createElement('tr'));
              $trElm = element.find('tr');
              
              //If we can find a tr, then we can use its td children as the empty element colspan.
              if ($trElm.length > 0) {
                emptyElmColspan = angular.element($trElm).children().length;
              } else {
                
                //If not, by setting a huge colspan we make sure it takes full width.
                //TODO(jcarter): Check for negative side effects.
                emptyElmColspan = 1000000;
              }
              tdElm = angular.element($window.document.createElement('td'))
                .attr('colspan', emptyElmColspan);
              scope.$emptyElm.append(tdElm);
            } else {
              scope.$emptyElm = angular.element($window.document.createElement('div'));
              scope.$dropzoneElm = angular.element($window.document.createElement('div'));
            }

            if (config.emptyTreeClass) {
              scope.$emptyElm.addClass(config.emptyTreeClass);
            }
            if (config.dropzoneClass) {
              scope.$dropzoneElm.addClass(config.dropzoneClass);
            }

            scope.$watch('$nodesScope.$modelValue.length', function (val) {
              if (!angular.isNumber(val)) {
                return;
              }

              ctrl.resetEmptyElement();
              ctrl.resetDropzoneElement();
            }, true);

            scope.$watch(attrs.dragEnabled, function (val) {
              if ((typeof val) == 'boolean') {
                scope.dragEnabled = val;
              }
            });

            scope.$watch(attrs.emptyPlaceholderEnabled, function (val) {
              if ((typeof val) == 'boolean') {
                scope.emptyPlaceholderEnabled = val;
                ctrl.resetEmptyElement();
              }
            });

            scope.$watch(attrs.nodropEnabled, function (val) {
              if ((typeof val) == 'boolean') {
                scope.nodropEnabled = val;
              }
            });

            scope.$watch(attrs.dropzoneEnabled, function (val) {
              if ((typeof val) == 'boolean') {
                scope.dropzoneEnabled = val;
                ctrl.resetDropzoneElement();
              }
            });

            scope.$watch(attrs.cloneEnabled, function (val) {
              if ((typeof val) == 'boolean') {
                scope.cloneEnabled = val;
              }
            });

            scope.$watch(attrs.maxDepth, function (val) {
              if ((typeof val) == 'number') {
                scope.maxDepth = val;
              }
            });

            scope.$watch(attrs.dragDelay, function (val) {
              if ((typeof val) == 'number') {
                scope.dragDelay = val;
              }
            });

            /**
             * Callback checks if the destination node can accept the dragged node.
             * By default, ui-tree will check that 'data-nodrop-enabled' is not set for the
             * destination ui-tree-nodes, and that the 'max-depth' attribute will not be exceeded
             * if it is set on the ui-tree or ui-tree-nodes.
             * This callback can be overridden, but callers must manually enforce nodrop and max-depth
             * themselves if they need those to be enforced.
             * @param sourceNodeScope Scope of the ui-tree-node being dragged
             * @param destNodesScope Scope of the ui-tree-nodes where the node is hovering
             * @param destIndex Index in the destination nodes array where the source node will drop
             * @returns {boolean} True if the node is permitted to be dropped here
             */
            callbacks.accept = function (sourceNodeScope, destNodesScope, destIndex) {
              return !(destNodesScope.nodropEnabled || destNodesScope.$treeScope.nodropEnabled || destNodesScope.outOfDepth(sourceNodeScope));
            };

            callbacks.beforeDrag = function (sourceNodeScope) {
              return true;
            };

            callbacks.expandTimeoutStart = function()
            {

            };

            callbacks.expandTimeoutCancel = function()
            {

            };

            callbacks.expandTimeoutEnd = function()
            {

            };

            callbacks.removed = function (node) {

            };

            /**
             * Callback is fired when a node is successfully dropped in a new location
             * @param event
             */
            callbacks.dropped = function (event) {

            };

            /**
             * Callback is fired each time the user starts dragging a node
             * @param event
             */
            callbacks.dragStart = function (event) {

            };

            /**
             * Callback is fired each time a dragged node is moved with the mouse/touch.
             * @param event
             */
            callbacks.dragMove = function (event) {

            };

            /**
             * Callback is fired when the tree exits drag mode. If the user dropped a node, the drop may have been
             * accepted or reverted.
             * @param event
             */
            callbacks.dragStop = function (event) {

            };

            /**
             * Callback is fired when a user drops a node (but prior to processing the drop action)
             * beforeDrop can return a Promise, truthy, or falsy (returning nothing is falsy).
             * If it returns falsy, or a resolve Promise, the node move is accepted
             * If it returns truthy, or a rejected Promise, the node move is reverted
             * @param event
             * @returns {Boolean|Promise} Truthy (or rejected Promise) to cancel node move; falsy (or resolved promise)
             */
            callbacks.beforeDrop = function (event) {

            };

            /**
             * Callback is fired when a user toggles node (but after processing the toggle action)
             * @param sourceNodeScope
             * @param collapsed
             */
            callbacks.toggle = function (collapsed, sourceNodeScope) {

            };

            scope.$watch(attrs.uiTree, function (newVal, oldVal) {
              angular.forEach(newVal, function (value, key) {
                if (callbacks[key]) {
                  if (typeof value === 'function') {
                    callbacks[key] = value;
                  }
                }
              });

              scope.$callbacks = callbacks;
            }, true);


          }
        };
      }
    ]);
})();

(function () {
  'use strict';

  angular.module('ui.tree')
    .directive('uiTreeHandle', ['treeConfig',
      function (treeConfig) {
        return {
          require: '^uiTreeNode',
          restrict: 'A',
          scope: true,
          controller: 'TreeHandleController',
          link: function (scope, element, attrs, treeNodeCtrl) {
            var config = {};
            angular.extend(config, treeConfig);
            if (config.handleClass) {
              element.addClass(config.handleClass);
            }
            // connect with the tree node.
            if (scope != treeNodeCtrl.scope) {
              scope.$nodeScope = treeNodeCtrl.scope;
              treeNodeCtrl.scope.$handleScope = scope;
            }
          }
        };
      }
    ]);
})();

(function () {
  'use strict';

  angular.module('ui.tree')

    .directive('uiTreeNode', ['treeConfig', 'UiTreeHelper', '$window', '$document', '$timeout', '$q',
      function (treeConfig, UiTreeHelper, $window, $document, $timeout, $q) {
        return {
          require: ['^uiTreeNodes', '^uiTree'],
          restrict: 'A',
          controller: 'TreeNodeController',
          link: function (scope, element, attrs, controllersArr) {
            var config = {},
              hasTouch = 'ontouchstart' in window,
              firstMoving,
              dragInfo,
              pos,
              placeElm,
              hiddenPlaceElm,
              dragElm,
              scrollContainerElm,
              unhover,
              treeScope = null,
              elements, // As a parameter for callbacks
              dragDelaying = true,
              dragStarted = false,
              dragTimer = null,
              body = document.body,
              html = document.documentElement,
              document_height,
              document_width,
              dragStart,
              tagName,
              dragMove,
              dragEnd,
              dragStartEvent,
              dragMoveEvent,
              dragEndEvent,
              dragCancelEvent,
              dragDelay,
              bindDragStartEvents,
              bindDragMoveEvents,
              unbindDragMoveEvents,
              keydownHandler,
              isHandleChild,
              el,
              isUiTreeRoot,
              treeOfOrigin;

            //Adding configured class to ui-tree-node.
            angular.extend(config, treeConfig);

            if (config.nodeClass) {
              element.addClass(config.nodeClass);
            }

            //Call init function in nodeCtrl, sets parent node and sets up sub nodes.
            scope.init(controllersArr);

            scope.collapsed = !!UiTreeHelper.getNodeAttribute(scope, 'collapsed') || treeConfig.defaultCollapsed;
            scope.expandOnHover = !!UiTreeHelper.getNodeAttribute(scope, 'expandOnHover');
            scope.scrollContainer = UiTreeHelper.getNodeAttribute(scope, 'scrollContainer') || attrs.scrollContainer || null;
            scope.sourceOnly = scope.nodropEnabled || scope.$treeScope.nodropEnabled;

            scope.$watch(attrs.collapsed, function (val) {
              if ((typeof val) == 'boolean') {
                scope.collapsed = val;
              }
            });

            //Watches to trigger behavior based on actions and settings.
            scope.$watch('collapsed', function (val) {
              UiTreeHelper.setNodeAttribute(scope, 'collapsed', val);
              attrs.$set('collapsed', val);
            });

            scope.$watch(attrs.expandOnHover, function(val) {
              if ((typeof val) === 'boolean' || (typeof val) === 'number') {
                scope.expandOnHover = val;
              }
            });

            scope.$watch('expandOnHover', function (val) {
              UiTreeHelper.setNodeAttribute(scope, 'expandOnHover', val);
              attrs.$set('expandOnHover', val);
            });

            attrs.$observe('scrollContainer', function(val) {
              if ((typeof val) === 'string') {
                scope.scrollContainer = val;
              }
            });

            scope.$watch('scrollContainer', function(val) {
              UiTreeHelper.setNodeAttribute(scope, 'scrollContainer', val);
              attrs.$set('scrollContainer', val);
              scrollContainerElm = document.querySelector(val);
            });

            scope.$on('angular-ui-tree:collapse-all', function () {
              scope.collapsed = true;
            });

            scope.$on('angular-ui-tree:expand-all', function () {
              scope.collapsed = false;
            });

            /**
             * Called when the user has grabbed a node and started dragging it.
             *
             * @param {MouseEvent} e event that is triggered by DOM.
             * @return undefined?
             */
            dragStart = function (e) {

              //Disable right click.
              if (!hasTouch && (e.button === 2 || e.which === 3)) {
                return;
              }

              //Event has already fired in other scope.
              if (e.uiTreeDragging || (e.originalEvent && e.originalEvent.uiTreeDragging)) {
                return;
              }

              //The node being dragged.
              var eventElm = angular.element(e.target),
                isHandleChild,
                cloneElm,
                eventElmTagName,
                tagName,
                eventObj,
                tdElm,
                hStyle,
                isTreeNode,
                isTreeNodeHandle;

              //If the target element is a child element of a ui-tree-handle,
              // use the containing handle element as target element.
              isHandleChild = UiTreeHelper.treeNodeHandlerContainerOfElement(eventElm);
              if (isHandleChild) {
                eventElm = angular.element(isHandleChild);
              }

              cloneElm = element.clone();
              isTreeNode = UiTreeHelper.elementIsTreeNode(eventElm);
              isTreeNodeHandle = UiTreeHelper.elementIsTreeNodeHandle(eventElm);

              //If we are not triggering mousedown on our uiTree or any of it's parts, return.
              if (!isTreeNode && !isTreeNodeHandle) {
                return;
              }

              //If we are not triggering mousedown on our uiTree or any of it's parts, return.
              if (isTreeNode && UiTreeHelper.elementContainsTreeNodeHandler(eventElm)) {
                return;
              }

              //Dragging not allowed on inputs or buttons.
              eventElmTagName = eventElm.prop('tagName').toLowerCase();
              if (eventElmTagName == 'input' ||
                  eventElmTagName == 'textarea' ||
                  eventElmTagName == 'button' ||
                  eventElmTagName == 'select') {
                return;
              }

              //Check if it or it's parents has a 'data-nodrag' attribute
              el = angular.element(e.target);
              isUiTreeRoot = el[0].attributes['ui-tree'];
              while (el && el[0] && el[0] !== element && !isUiTreeRoot) {

                //Checking that I can access attributes.
                if (el[0].attributes) {
                  isUiTreeRoot = el[0].attributes['ui-tree'];
                }

                //If the node mark as `nodrag`, DONOT drag it.
                if (UiTreeHelper.nodrag(el)) {
                  return;
                }
                el = el.parent();
              }

              //If users beforeDrag calback returns falsey, do not initiate.
              if (!scope.beforeDrag(scope)) {
                return;
              }

              //Set property checked at start of function to prevent running logic again.
              e.uiTreeDragging = true;
              if (e.originalEvent) {
                e.originalEvent.uiTreeDragging = true;
              }
              e.preventDefault();

              //Get original event if TouchEvent.
              eventObj = UiTreeHelper.eventObj(e);

              //Set boolean used to specify beginning of move.
              firstMoving = true;

              //Setting drag info properties and methods in scope of node being moved.
              dragInfo = UiTreeHelper.dragInfo(scope);

              //Setting original tree to adjust horizontal behavior in drag move.
              treeOfOrigin = dragInfo.source.$treeScope.$id;

              //Determine tage name of element ui-tree-node is on.
              tagName = element.prop('tagName');

              if (tagName.toLowerCase() === 'tr') {

                //Create a new table column as placeholder.
                placeElm = angular.element($window.document.createElement(tagName));

                //Create a column placeholder and set colspan to whole row length.
                tdElm = angular.element($window.document.createElement('td'))
                    .addClass(config.placeholderClass)
                    .attr('colspan', element[0].children.length);
                placeElm.append(tdElm);
              } else {

                //If not a table just duplicate element and add placeholder class.
                placeElm = angular.element($window.document.createElement(tagName))
                    .addClass(config.placeholderClass);
              }

              //Create a hidden placeholder and add class from config.
              hiddenPlaceElm = angular.element($window.document.createElement(tagName));
              if (config.hiddenClass) {
                hiddenPlaceElm.addClass(config.hiddenClass);
              }

              //Getting starting position of element being moved.
              pos = UiTreeHelper.positionStarted(eventObj, element);
              placeElm.css('height', element.prop('offsetHeight') + 'px');

              //Creating drag element to represent node.
              dragElm = angular.element($window.document.createElement(scope.$parentNodesScope.$element.prop('tagName')))
                  .addClass(scope.$parentNodesScope.$element.attr('class')).addClass(config.dragClass);
              dragElm.css('width', UiTreeHelper.width(element) + 'px');
              dragElm.css('z-index', 9999);

              //Prevents cursor to change rapidly in Opera 12.16 and IE when dragging an element.
              hStyle = (element[0].querySelector('.angular-ui-tree-handle') || element[0]).currentStyle;
              if (hStyle) {
                document.body.setAttribute('ui-tree-cursor', $document.find('body').css('cursor') || '');
                $document.find('body').css({'cursor': hStyle.cursor + '!important'});
              }

              //If tree is sourceOnly (noDragDrop) don't show placeholder when moving about it.
              if (scope.sourceOnly) {
                placeElm.css('display', 'none');
              }

              //Insert placeholder.
              element.after(placeElm);
              element.after(hiddenPlaceElm);
              if (dragInfo.isClone() && scope.sourceOnly) {
                dragElm.append(cloneElm);
              } else {
                dragElm.append(element);
              }

              //Create drag element.
              $document.find('body').append(dragElm);

              //Set drag elements position on screen.
              dragElm.css({
                'left': eventObj.pageX - pos.offsetX + 'px',
                'top': eventObj.pageY - pos.offsetY + 'px'
              });
              elements = {
                placeholder: placeElm,
                dragging: dragElm
              };

              //Create all drag/move bindings.
              bindDragMoveEvents();

              //Fire dragStart callback.
              scope.$apply(function () {
                scope.$treeScope.$callbacks.dragStart(dragInfo.eventArgs(elements, pos));
              });

              //Get bounds of document.
              document_height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
              document_width = Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
            };

            dragMove = function (e) {
              var eventObj = UiTreeHelper.eventObj(e),
                prev,
                next,
                leftElmPos,
                topElmPos,
                top_scroll,
                bottom_scroll,
                scrollContainerElmRect,
                target,
                targetX,
                targetY,
                displayElm,
                targetNode,
                targetElm,
                isEmpty,
                scrollDownBy,
                scrollUpBy,
                targetOffset,
                targetBefore,
                moveWithinTree,
                targetBeforeBuffer,
                targetHeight,
                targetChildElm,
                targetChildHeight,
                isDropzone;

              //If check ensures that drag element was created.
              if (dragElm) {
                e.preventDefault();

                //Deselect anything (text, etc.) that was selected when move began.
                if ($window.getSelection) {
                  $window.getSelection().removeAllRanges();
                } else if ($window.document.selection) {
                  $window.document.selection.empty();
                }

                //Get top left positioning of element being moved.
                leftElmPos = eventObj.pageX - pos.offsetX;
                topElmPos = eventObj.pageY - pos.offsetY;

                //dragElm can't leave the screen on the left.
                if (leftElmPos < 0) {
                  leftElmPos = 0;
                }

                //dragElm can't leave the screen on the top.
                if (topElmPos < 0) {
                  topElmPos = 0;
                }

                //dragElm can't leave the screen on the bottom.
                if ((topElmPos + 10) > document_height) {
                  topElmPos = document_height - 10;
                }

                //dragElm can't leave the screen on the right.
                if ((leftElmPos + 10) > document_width) {
                  leftElmPos = document_width - 10;
                }

                //Updating element being moved css.
                dragElm.css({
                  'left': leftElmPos + 'px',
                  'top': topElmPos + 'px'
                });

                if (scrollContainerElm) {
                  //Getting position to top and bottom of container element.
                  scrollContainerElmRect = scrollContainerElm.getBoundingClientRect();
                  top_scroll = scrollContainerElm.scrollTop;
                  bottom_scroll = top_scroll + scrollContainerElm.clientHeight;

                  //To scroll down if cursor y-position is greater than the bottom position of the container vertical scroll
                  if (scrollContainerElmRect.bottom < eventObj.clientY && bottom_scroll < scrollContainerElm.scrollHeight) {
                    scrollDownBy = Math.min(scrollContainerElm.scrollHeight - bottom_scroll, 10);
                    scrollContainerElm.scrollTop += scrollDownBy;
                  }

                  //To scroll top if cursor y-position is less than the top position of the container vertical scroll
                  if (scrollContainerElmRect.top > eventObj.clientY && top_scroll > 0) {
                    scrollUpBy = Math.min(top_scroll, 10);
                    scrollContainerElm.scrollTop -= scrollUpBy;
                  }
                } else {
                  //Getting position to top and bottom of page.
                  top_scroll = window.pageYOffset || $window.document.documentElement.scrollTop;
                  bottom_scroll = top_scroll + (window.innerHeight || $window.document.clientHeight || $window.document.clientHeight);

                  //To scroll down if cursor y-position is greater than the bottom position of the window vertical scroll
                  if (bottom_scroll < eventObj.pageY && bottom_scroll < document_height) {
                    scrollDownBy = Math.min(document_height - bottom_scroll, 10);
                    window.scrollBy(0, scrollDownBy);
                  }

                  //To scroll top if cursor y-position is less than the top position of the window vertical scroll
                  if (top_scroll > eventObj.pageY) {
                    scrollUpBy = Math.min(top_scroll, 10);
                    window.scrollBy(0, -scrollUpBy);
                  }
                }

                //Calling service to update position coordinates based on move.
                UiTreeHelper.positionMoved(e, pos, firstMoving);
                if (firstMoving) {
                  firstMoving = false;
                  return;
                }

                //Setting X point for elementFromPoint.
                targetX = eventObj.pageX - ($window.pageXOffset ||
                    $window.document.body.scrollLeft ||
                    $window.document.documentElement.scrollLeft) -
                    ($window.document.documentElement.clientLeft || 0);

                targetY = eventObj.pageY - ($window.pageYOffset ||
                    $window.document.body.scrollTop ||
                    $window.document.documentElement.scrollTop) -
                    ($window.document.documentElement.clientTop || 0);

                //Select the drag target. Because IE does not support CSS 'pointer-events: none', it will always
                // pick the drag element itself as the target. To prevent this, we hide the drag element while
                // selecting the target.
                if (angular.isFunction(dragElm.hide)) {
                  dragElm.hide();
                } else {
                  displayElm = dragElm[0].style.display;
                  dragElm[0].style.display = 'none';
                }

                //When using elementFromPoint() inside an iframe, you have to call
                // elementFromPoint() twice to make sure IE8 returns the correct value
                //MDN: The elementFromPoint() method of the Document interface returns the topmost element at the specified coordinates.
                $window.document.elementFromPoint(targetX, targetY);

                //Set target element (element in specified x/y coordinates).
                targetElm = angular.element($window.document.elementFromPoint(targetX, targetY));

                //If the target element is a child element of a ui-tree-handle,
                // use the containing handle element as target element
                isHandleChild = UiTreeHelper.treeNodeHandlerContainerOfElement(targetElm);
                if (isHandleChild) {
                  targetElm = angular.element(isHandleChild);
                }

                if (angular.isFunction(dragElm.show)) {
                  dragElm.show();
                } else {
                  dragElm[0].style.display = displayElm;
                }

                //Assigning scope to target you are moving draggable over.
                if (UiTreeHelper.elementIsTree(targetElm)) {
                  targetNode = targetElm.controller('uiTree').scope;
                } else if (UiTreeHelper.elementIsTreeNodeHandle(targetElm)) {
                  targetNode = targetElm.controller('uiTreeHandle').scope;
                } else if (UiTreeHelper.elementIsTreeNode(targetElm)) {
                  targetNode = targetElm.controller('uiTreeNode').scope;
                } else if (UiTreeHelper.elementIsTreeNodes(targetElm)) {
                  targetNode = targetElm.controller('uiTreeNodes').scope;
                } else if (UiTreeHelper.elementIsPlaceholder(targetElm)) {
                  targetNode = targetElm.controller('uiTreeNodes').scope;
                } else if (UiTreeHelper.elementIsDropzone(targetElm)) {
                  targetNode = targetElm.controller('uiTree').scope;
                  isDropzone = true;
                } else if (targetElm.controller('uiTreeNode')) {
                  //Is a child element of a node.
                  targetNode = targetElm.controller('uiTreeNode').scope;
                }

                moveWithinTree =  (targetNode && targetNode.$treeScope && targetNode.$treeScope.$id && targetNode.$treeScope.$id === treeOfOrigin);

                /* (jcarter) Notes to developers:
                 *  pos.dirAx is either 0 or 1
                 *  1 means horizontal movement is happening
                 *  0 means vertical movement is happening
                 */

                // Move nodes up and down in nesting level.
                if (moveWithinTree && pos.dirAx) {

                  // increase horizontal level if previous sibling exists and is not collapsed
                  // example 1.1.1 becomes 1.2
                  if (pos.distX > 0) {
                    prev = dragInfo.prev();
                    if (prev && !prev.collapsed
                      && prev.accept(scope, prev.childNodesCount())) {
                      prev.$childNodesScope.$element.append(placeElm);
                      dragInfo.moveTo(prev.$childNodesScope, prev.childNodes(), prev.childNodesCount());
                    }
                  }

                  // decrease horizontal level
                  // example 1.2 become 1.1.1
                  if (pos.distX < 0) {
                    // we can't decrease a level if an item preceeds the current one
                    next = dragInfo.next();
                    if (!next) {
                      target = dragInfo.parentNode(); // As a sibling of it's parent node
                      if (target
                        && target.$parentNodesScope.accept(scope, target.index() + 1)) {
                        target.$element.after(placeElm);
                        dragInfo.moveTo(target.$parentNodesScope, target.siblings(), target.index() + 1);
                      }
                    }
                  }
                } else { //Either in origin tree and moving horizontally OR you are moving within a new tree.

                  //Check it's new position.
                  isEmpty = false;

                  //Exit if target is not a uiTree or child of one.
                  if (!targetNode) {
                    return;
                  }

                  //Show the placeholder if it was hidden for nodrop-enabled and this is a new tree
                  if (targetNode.$treeScope && !targetNode.$parent.nodropEnabled && !targetNode.$treeScope.nodropEnabled) {
                    placeElm.css('display', '');
                  }

                  //Set whether target tree is empty or not.
                  if (targetNode.$type === 'uiTree' && targetNode.dragEnabled) {
                    isEmpty = targetNode.isEmpty();
                  }

                  //If target is a handle set new target to handle's node.
                  if (targetNode.$type === 'uiTreeHandle') {
                    targetNode = targetNode.$nodeScope;
                  }

                  //Check if it is a uiTreeNode or it's an empty tree or it's a dropzone.
                  if (targetNode.$type !== 'uiTreeNode' && !isEmpty && !isDropzone) {

                    // Allow node to return to its original position if no longer hovering over target
                    if (config.appendChildOnHover) {
                      next = dragInfo.next();
                      if (!next && unhover) {
                        target = dragInfo.parentNode();
                        target.$element.after(placeElm);
                        dragInfo.moveTo(target.$parentNodesScope, target.siblings(), target.index() + 1);
                        unhover = false;
                      }
                    }
                    return;
                  }

                  //If placeholder move from empty tree, reset it.
                  if (treeScope && placeElm.parent()[0] != treeScope.$element[0]) {
                    treeScope.resetEmptyElement();
                    treeScope.resetDropzoneElement();
                    treeScope = null;
                  }

                  //It's an empty tree
                  if (isEmpty) {
                    treeScope = targetNode;
                    if (targetNode.$nodesScope.accept(scope, 0)) {
                      dragInfo.moveTo(targetNode.$nodesScope, targetNode.$nodesScope.childNodes(), 0);
                    }
                  //It's a dropzone
                  } else if (isDropzone) {
                    treeScope = targetNode;
                    if (targetNode.$nodesScope.accept(scope, targetNode.$nodesScope.childNodes().length)) {
                      dragInfo.moveTo(targetNode.$nodesScope, targetNode.$nodesScope.childNodes(), targetNode.$nodesScope.childNodes().length);
                    }
                  //Not empty and drag enabled.
                  } else if (targetNode.dragEnabled()) {

                      //Setting/Resetting data for exanding on hover.
                      if (angular.isDefined(scope.expandTimeoutOn) && scope.expandTimeoutOn !== targetNode.id) {
                        $timeout.cancel(scope.expandTimeout);
                        delete scope.expandTimeout;
                        delete scope.expandTimeoutOn;

                        scope.$callbacks.expandTimeoutCancel();
                      }

                      //Determining if expansion is needed.
                      if (targetNode.collapsed) {
                        if (scope.expandOnHover === true || (angular.isNumber(scope.expandOnHover) && scope.expandOnHover === 0)) {
                          targetNode.collapsed = false;
                          targetNode.$treeScope.$callbacks.toggle(false, targetNode);
                        } else if (scope.expandOnHover !== false && angular.isNumber(scope.expandOnHover) && scope.expandOnHover > 0) {

                          //Triggering expansion.
                          if (angular.isUndefined(scope.expandTimeoutOn)) {
                            scope.expandTimeoutOn = targetNode.$id;

                            scope.$callbacks.expandTimeoutStart();
                            scope.expandTimeout = $timeout(function()
                            {
                              scope.$callbacks.expandTimeoutEnd();
                              targetNode.collapsed = false;
                              targetNode.$treeScope.$callbacks.toggle(false, targetNode);
                            }, scope.expandOnHover);
                          }
                        }
                      }

                    //Get the element of ui-tree-node
                    targetElm = targetNode.$element;
                    targetOffset = UiTreeHelper.offset(targetElm);
                    targetHeight = UiTreeHelper.height(targetElm);
                    targetChildElm = targetNode.$childNodesScope ? targetNode.$childNodesScope.$element : null;
                    targetChildHeight = targetChildElm ? UiTreeHelper.height(targetChildElm) : 0;
                    targetHeight -= targetChildHeight;
                    targetBeforeBuffer = config.appendChildOnHover ? targetHeight * 0.25 : UiTreeHelper.height(targetElm) / 2;
                    targetBefore = eventObj.pageY < (targetOffset.top + targetBeforeBuffer);

                    if (targetNode.$parentNodesScope.accept(scope, targetNode.index())) {
                      if (targetBefore) {
                        targetElm[0].parentNode.insertBefore(placeElm[0], targetElm[0]);
                        dragInfo.moveTo(targetNode.$parentNodesScope, targetNode.siblings(), targetNode.index());
                      } else {
                        // Try to append as a child if dragged upwards onto targetNode
                        if (config.appendChildOnHover && targetNode.accept(scope, targetNode.childNodesCount())) {
                          targetNode.$childNodesScope.$element.prepend(placeElm);
                          dragInfo.moveTo(targetNode.$childNodesScope, targetNode.childNodes(), 0);
                          unhover = true;
                        } else {
                          targetElm.after(placeElm);
                          dragInfo.moveTo(targetNode.$parentNodesScope, targetNode.siblings(), targetNode.index() + 1);
                        }
                      }

                    //We have to check if it can add the dragging node as a child.
                    } else if (!targetBefore && targetNode.accept(scope, targetNode.childNodesCount())) {
                      targetNode.$childNodesScope.$element.append(placeElm);
                      dragInfo.moveTo(targetNode.$childNodesScope, targetNode.childNodes(), targetNode.childNodesCount());
                    }
                  }
                }

                //Triggering dragMove callback.
                scope.$apply(function () {
                  scope.$treeScope.$callbacks.dragMove(dragInfo.eventArgs(elements, pos));
                });
              }
            };

            dragEnd = function (e) {

              var dragEventArgs = dragInfo.eventArgs(elements, pos);

              e.preventDefault();

              //TODO(jcarter): Is dragStart need to be unbound?
              unbindDragMoveEvents();

              //This cancel the collapse/expand login running.
              $timeout.cancel(scope.expandTimeout);

              scope.$treeScope.$apply(function () {
                $q.when(scope.$treeScope.$callbacks.beforeDrop(dragEventArgs))

                     //Promise resolved (or callback didn't return false)
                    .then(function (allowDrop) {
                      if (allowDrop !== false && scope.$$allowNodeDrop) {
                        //Node drop accepted.
                        dragInfo.apply();

                        //Fire the dropped callback only if the move was successful.
                        scope.$treeScope.$callbacks.dropped(dragEventArgs);
                      } else {
                        //Drop canceled - revert the node to its original position.
                        bindDragStartEvents();
                      }
                    })

                    //Promise rejected - revert the node to its original position.
                    .catch(function () {
                      bindDragStartEvents();
                    })
                    .finally(function () {

                      //Replace placeholder with newly dropped element.
                      hiddenPlaceElm.replaceWith(scope.$element);
                      placeElm.remove();

                      //Remove drag element if still in DOM.
                      if (dragElm) {
                        dragElm.remove();
                        dragElm = null;
                      }

                      //Fire dragStope callback.
                      scope.$treeScope.$callbacks.dragStop(dragEventArgs);
                      scope.$$allowNodeDrop = false;
                      dragInfo = null;

                      //Restore cursor in Opera 12.16 and IE
                      var oldCur = document.body.getAttribute('ui-tree-cursor');
                      if (oldCur !== null) {
                        $document.find('body').css({'cursor': oldCur});
                        document.body.removeAttribute('ui-tree-cursor');
                      }
                    });
              });
            };

            dragStartEvent = function (e) {
              if (scope.dragEnabled()) {
                dragStart(e);
              }
            };

            dragMoveEvent = function (e) {
              dragMove(e);
            };

            dragEndEvent = function (e) {
              scope.$$allowNodeDrop = true;
              dragEnd(e);
            };

            dragCancelEvent = function (e) {
              dragEnd(e);
            };

            dragDelay = (function () {
              var to;

              return {
                exec: function (fn, ms) {
                  if (!ms) {
                    ms = 0;
                  }
                  this.cancel();
                  to = $timeout(fn, ms);
                },
                cancel: function () {
                  $timeout.cancel(to);
                }
              };
            })();

            keydownHandler = function (e) {
              if (e.keyCode === 27) {
                dragEndEvent(e);
              }
            };

            /**
             * Binds the mouse/touch events to enable drag start for this node.
             */
            //This is outside of bindDragMoveEvents because of the potential for a delay setting.
            bindDragStartEvents = function () {
              element.bind('touchstart mousedown', function (e) {
                //Don't call drag delay if no delay was specified.
                if (scope.dragDelay > 0) {
                  dragDelay.exec(function () {
                    dragStartEvent(e);
                  }, scope.dragDelay);
                } else {
                  dragStartEvent(e);
                }
              });
              element.bind('touchend touchcancel mouseup', function () {
                if (scope.dragDelay > 0) {
                  dragDelay.cancel();
                }
              });
            };
            bindDragStartEvents();

            /**
             * Binds mouse/touch events that handle moving/dropping this dragged node
             */
            bindDragMoveEvents = function () {
              angular.element($document).bind('touchend', dragEndEvent);
              angular.element($document).bind('touchcancel', dragEndEvent);
              angular.element($document).bind('touchmove', dragMoveEvent);
              angular.element($document).bind('mouseup', dragEndEvent);
              angular.element($document).bind('mousemove', dragMoveEvent);
              angular.element($document).bind('mouseleave', dragCancelEvent);
              angular.element($document).bind('keydown', keydownHandler);
            };

            /**
             * Unbinds mouse/touch events that handle moving/dropping this dragged node.
             */
            unbindDragMoveEvents = function () {
              angular.element($document).unbind('touchend', dragEndEvent);
              angular.element($document).unbind('touchcancel', dragEndEvent);
              angular.element($document).unbind('touchmove', dragMoveEvent);
              angular.element($document).unbind('mouseup', dragEndEvent);
              angular.element($document).unbind('mousemove', dragMoveEvent);
              angular.element($document).unbind('mouseleave', dragCancelEvent);
              angular.element($document).unbind('keydown', keydownHandler);
            };
          }
        };
      }
    ]);
})();

(function () {
  'use strict';

  angular.module('ui.tree')
    .directive('uiTreeNodes', ['treeConfig', '$window',
      function (treeConfig) {
        return {
          require: ['ngModel', '?^uiTreeNode', '^uiTree'],
          restrict: 'A',
          scope: true,
          controller: 'TreeNodesController',
          link: function (scope, element, attrs, controllersArr) {

            var config = {},
                ngModel = controllersArr[0],
                treeNodeCtrl = controllersArr[1],
                treeCtrl = controllersArr[2];

            angular.extend(config, treeConfig);
            if (config.nodesClass) {
              element.addClass(config.nodesClass);
            }

            if (treeNodeCtrl) {
              treeNodeCtrl.scope.$childNodesScope = scope;
              scope.$nodeScope = treeNodeCtrl.scope;
            } else {
              // find the root nodes if there is no parent node and have a parent ui-tree
              treeCtrl.scope.$nodesScope = scope;
            }
            scope.$treeScope = treeCtrl.scope;

            if (ngModel) {
              ngModel.$render = function () {
                scope.$modelValue = ngModel.$modelValue;
              };
            }

            scope.$watch(function () {
              return attrs.maxDepth;
            }, function (val) {
              if ((typeof val) == 'number') {
                scope.maxDepth = val;
              }
            });

            scope.$watch(function () {
              return attrs.nodropEnabled;
            }, function (newVal) {
              if ((typeof newVal) != 'undefined') {
                scope.nodropEnabled = true;
              }
            }, true);

          }
        };
      }
    ]);
})();

(function () {
  'use strict';

  angular.module('ui.tree')

  /**
   * @ngdoc service
   * @name ui.tree.service:UiTreeHelper
   * @requires ng.$document
   * @requires ng.$window
   *
   * @description
   * angular-ui-tree.
   */
    .factory('UiTreeHelper', ['$document', '$window', 'treeConfig',
      function ($document, $window, treeConfig) {
        return {

          /**
           * A hashtable used to storage data of nodes
           * @type {Object}
           */
          nodesData: {},

          setNodeAttribute: function (scope, attrName, val) {
            if (!scope.$modelValue) {
              return null;
            }
            var data = this.nodesData[scope.$modelValue.$$hashKey];
            if (!data) {
              data = {};
              this.nodesData[scope.$modelValue.$$hashKey] = data;
            }
            data[attrName] = val;
          },

          getNodeAttribute: function (scope, attrName) {
            if (!scope.$modelValue) {
              return null;
            }
            var data = this.nodesData[scope.$modelValue.$$hashKey];
            if (data) {
              return data[attrName];
            }
            return null;
          },

          /**
           * @ngdoc method
           * @methodOf ui.tree.service:$nodrag
           * @param  {Object} targetElm angular element
           * @return {Bool} check if the node can be dragged.
           */
          nodrag: function (targetElm) {
            if (typeof targetElm.attr('data-nodrag') != 'undefined') {
              return targetElm.attr('data-nodrag') !== 'false';
            }
            return false;
          },

          /**
           * Get the event object for touches.
           * 
           * @param  {MouseEvent|TouchEvent} e MouseEvent or TouchEvent that kicked off dragX method.
           * @return {MouseEvent|TouchEvent} Object returned as original event object.
           */
          eventObj: function (e) {
            var obj = e;
            if (e.targetTouches !== undefined) {
              //Set obj equal to the first Touch object in the TouchList.
              obj = e.targetTouches.item(0);
            //Logic to set obj to original TouchEvent.
            } else if (e.originalEvent !== undefined && e.originalEvent.targetTouches !== undefined) {
              obj = e.originalEvent.targetTouches.item(0);
            }
            return obj;
          },

          /**
           * Generate object used to store data about node being moved.
           * 
           * {angular.$scope} node Scope of the node that is being moved.
           */
          dragInfo: function (node) {
            return {
              source: node,
              sourceInfo: {
                cloneModel: node.$treeScope.cloneEnabled === true ? angular.copy(node.$modelValue) : undefined,
                nodeScope: node,
                index: node.index(),
                nodesScope: node.$parentNodesScope
              },
              index: node.index(),

              //Slice(0) just duplicates an array.
              siblings: node.siblings().slice(0),
              parent: node.$parentNodesScope,

              //Reset parent to source parent.
              resetParent: function() {
                this.parent = node.$parentNodesScope;
              },

              //Move the node to a new position, determining where the node will be inserted to when dropped happens here.
              moveTo: function (parent, siblings, index) {
                this.parent = parent;

                //Duplicate siblings array.
                this.siblings = siblings.slice(0);

                //If source node is in the target nodes
                var i = this.siblings.indexOf(this.source);
                if (i > -1) {
                  this.siblings.splice(i, 1);
                  if (this.source.index() < index) {
                    index--;
                  }
                }

                this.siblings.splice(index, 0, this.source);
                this.index = index;
              },

              //Get parent nodes nodeScope.
              parentNode: function () {
                return this.parent.$nodeScope;
              },

              //Get previous sibling node.
              prev: function () {
                if (this.index > 0) {
                  return this.siblings[this.index - 1];
                }

                return null;
              },

              //Get next sibling node.
              next: function () {
                if (this.index < this.siblings.length - 1) {
                  return this.siblings[this.index + 1];
                }

                return null;
              },

              //Return what cloneEnabled is set to on uiTree.
              isClone: function () {
                return this.source.$treeScope.cloneEnabled === true;
              },

              //Returns a copy of node passed in.
              clonedNode: function (node) {
                return angular.copy(node);
              },

              //Returns true if parent or index have changed (move happened within any uiTree).
              isDirty: function () {
                return this.source.$parentNodesScope != this.parent ||
                  this.source.index() != this.index;
              },

              //Return whether node has a new parent (set on moveTo method).
              isForeign: function () {
                return this.source.$treeScope !== this.parent.$treeScope;
              },

              //Sets arguments passed to user callbacks.
              eventArgs: function (elements, pos) {
                return {
                  source: this.sourceInfo,
                  dest: {
                    index: this.index,
                    nodesScope: this.parent
                  },
                  elements: elements,
                  pos: pos
                };
              },

              //Method that actually manipulates the node being moved.
              apply: function () {

                var nodeData = this.source.$modelValue;

                //Nodrop enabled on tree or parent
                if (this.parent.nodropEnabled || this.parent.$treeScope.nodropEnabled) {
                  return;
                }

                //Node was dropped in the same place - do nothing.
                if (!this.isDirty()) {
                  return;
                }

                //CloneEnabled and cross-tree so copy and do not remove from source.
                if (this.isClone() && this.isForeign()) {
                  this.parent.insertNode(this.index, this.sourceInfo.cloneModel);
                //Any other case, remove and reinsert.
                } else {
                  this.source.remove();
                  this.parent.insertNode(this.index, nodeData);
                }
              }
            };
          },

          /**
           * @ngdoc method
           * @name ui.tree#height
           * @methodOf ui.tree.service:UiTreeHelper
           *
           * @description
           * Get the height of an element.
           *
           * @param {Object} element Angular element.
           * @returns {String} Height
           */
          height: function (element) {
            return element.prop('scrollHeight');
          },

          /**
           * @ngdoc method
           * @name ui.tree#width
           * @methodOf ui.tree.service:UiTreeHelper
           *
           * @description
           * Get the width of an element.
           *
           * @param {Object} element Angular element.
           * @returns {String} Width
           */
          width: function (element) {
            return element.prop('scrollWidth');
          },

          /**
           * @ngdoc method
           * @name ui.tree#offset
           * @methodOf ui.nestedSortable.service:UiTreeHelper
           *
           * @description
           * Get the offset values of an element.
           *
           * @param {Object} element Angular element.
           * @returns {Object} Object with properties width, height, top and left
           */
          offset: function (element) {
            var boundingClientRect = element[0].getBoundingClientRect();

            return {
              width: element.prop('offsetWidth'),
              height: element.prop('offsetHeight'),
              top: boundingClientRect.top + ($window.pageYOffset || $document[0].body.scrollTop || $document[0].documentElement.scrollTop),
              left: boundingClientRect.left + ($window.pageXOffset || $document[0].body.scrollLeft || $document[0].documentElement.scrollLeft)
            };
          },

          /**
           * @ngdoc method
           * @name ui.tree#positionStarted
           * @methodOf ui.tree.service:UiTreeHelper
           *
           * @description
           * Get the start position of the target element according to the provided event properties.
           *
           * @param {Object} e Event
           * @param {Object} target Target element
           * @returns {Object} Object with properties offsetX, offsetY, startX, startY, nowX and dirX.
           */
          positionStarted: function (e, target) {
            var pos = {},
            pageX = e.pageX,
            pageY = e.pageY;

            //Check to set correct data for TouchEvents
            if (e.originalEvent && e.originalEvent.touches && (e.originalEvent.touches.length > 0)) {
              pageX = e.originalEvent.touches[0].pageX;
              pageY = e.originalEvent.touches[0].pageY;
            }
            pos.offsetX = pageX - this.offset(target).left;
            pos.offsetY = pageY - this.offset(target).top;
            pos.startX = pos.lastX = pageX;
            pos.startY = pos.lastY = pageY;
            pos.nowX = pos.nowY = pos.distX = pos.distY = pos.dirAx = 0;
            pos.dirX = pos.dirY = pos.lastDirX = pos.lastDirY = pos.distAxX = pos.distAxY = 0;
            return pos;
          },

          positionMoved: function (e, pos, firstMoving) {

            var pageX = e.pageX,
            pageY = e.pageY,
            newAx;

            //If there are multiple touch points, choose one to use as X and Y.
            if (e.originalEvent && e.originalEvent.touches && (e.originalEvent.touches.length > 0)) {
              pageX = e.originalEvent.touches[0].pageX;
              pageY = e.originalEvent.touches[0].pageY;
            }

            //Mouse position last event.
            pos.lastX = pos.nowX;
            pos.lastY = pos.nowY;

            //Mouse position this event.
            pos.nowX = pageX;
            pos.nowY = pageY;

            //Distance mouse moved between events.          
            pos.distX = pos.nowX - pos.lastX;
            pos.distY = pos.nowY - pos.lastY;

            //Direction mouse was moving.           
            pos.lastDirX = pos.dirX;
            pos.lastDirY = pos.dirY;

            //Direction mouse is now moving (on both axis).          
            pos.dirX = pos.distX === 0 ? 0 : pos.distX > 0 ? 1 : -1;
            pos.dirY = pos.distY === 0 ? 0 : pos.distY > 0 ? 1 : -1;

            //Axis mouse is now moving on.         
            newAx = Math.abs(pos.distX) > Math.abs(pos.distY) ? 1 : 0;

            //Do nothing on first move.
            if (firstMoving) {
              pos.dirAx = newAx;
              pos.moving = true;
              return;
            }

            //Calc distance moved on this axis (and direction).          
            if (pos.dirAx !== newAx) {
              pos.distAxX = 0;
              pos.distAxY = 0;
            } else {
              pos.distAxX += Math.abs(pos.distX);
              if (pos.dirX !== 0 && pos.dirX !== pos.lastDirX) {
                pos.distAxX = 0;
              }
              pos.distAxY += Math.abs(pos.distY);
              if (pos.dirY !== 0 && pos.dirY !== pos.lastDirY) {
                pos.distAxY = 0;
              }
            }
            pos.dirAx = newAx;
          },

          elementIsTreeNode: function (element) {
            return typeof element.attr('ui-tree-node') !== 'undefined';
          },

          elementIsTreeNodeHandle: function (element) {
            return typeof element.attr('ui-tree-handle') !== 'undefined';
          },
          elementIsTree: function (element) {
            return typeof element.attr('ui-tree') !== 'undefined';
          },
          elementIsTreeNodes: function (element) {
            return typeof element.attr('ui-tree-nodes') !== 'undefined';
          },
          elementIsPlaceholder: function (element) {
            return element.hasClass(treeConfig.placeholderClass);
          },
          elementIsDropzone: function (element) {
            return element.hasClass(treeConfig.dropzoneClass);
          },
          elementContainsTreeNodeHandler: function (element) {
            return element[0].querySelectorAll('[ui-tree-handle]').length >= 1;
          },
          treeNodeHandlerContainerOfElement: function (element) {
            return findFirstParentElementWithAttribute('ui-tree-handle', element[0]);
          }
        };
      }
    ]);

  // TODO: optimize this loop
  //(Jcarter): Suggest adding a parent element property on uiTree, then all these bubble
  // to <html> can trigger to stop when they reach the parent.
  function findFirstParentElementWithAttribute(attributeName, childObj) {
    //Undefined if the mouse leaves the browser window
    if (childObj === undefined) {
      return null;
    }
    var testObj = childObj.parentNode,
    count = 1,
    //Check for setAttribute due to exception thrown by Firefox when a node is dragged outside the browser window
    res = (typeof testObj.setAttribute === 'function' && testObj.hasAttribute(attributeName)) ? testObj : null;
    while (testObj && typeof testObj.setAttribute === 'function' && !testObj.hasAttribute(attributeName)) {
      testObj = testObj.parentNode;
      res = testObj;
      //Stop once we reach top of page.
      if (testObj === document.documentElement) {
        res = null;
        break;
      }
      count++;
    }
    return res;
  }

})();

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(26);
module.exports = 'ui.tree';


/***/ }),
/* 28 */
/***/ (function(module, exports) {

/**
 * @license AngularJS v1.4.1
 * (c) 2010-2015 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, document, undefined) {'use strict';

/**
 * @description
 *
 * This object provides a utility for producing rich Error messages within
 * Angular. It can be called as follows:
 *
 * var exampleMinErr = minErr('example');
 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
 *
 * The above creates an instance of minErr in the example namespace. The
 * resulting error will have a namespaced error code of example.one.  The
 * resulting error will replace {0} with the value of foo, and {1} with the
 * value of bar. The object is not restricted in the number of arguments it can
 * take.
 *
 * If fewer arguments are specified than necessary for interpolation, the extra
 * interpolation markers will be preserved in the final string.
 *
 * Since data will be parsed statically during a build step, some restrictions
 * are applied with respect to how minErr instances are created and called.
 * Instances should have names of the form namespaceMinErr for a minErr created
 * using minErr('namespace') . Error codes, namespaces and template strings
 * should all be static strings, not variables or general expressions.
 *
 * @param {string} module The namespace to use for the new minErr instance.
 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
 *   error from returned function, for cases when a particular type of error is useful.
 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
 */

function minErr(module, ErrorConstructor) {
  ErrorConstructor = ErrorConstructor || Error;
  return function() {
    var SKIP_INDEXES = 2;

    var templateArgs = arguments,
      code = templateArgs[0],
      message = '[' + (module ? module + ':' : '') + code + '] ',
      template = templateArgs[1],
      paramPrefix, i;

    message += template.replace(/\{\d+\}/g, function(match) {
      var index = +match.slice(1, -1),
        shiftedIndex = index + SKIP_INDEXES;

      if (shiftedIndex < templateArgs.length) {
        return toDebugString(templateArgs[shiftedIndex]);
      }

      return match;
    });

    message += '\nhttp://errors.angularjs.org/1.4.1/' +
      (module ? module + '/' : '') + code;

    for (i = SKIP_INDEXES, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
      message += paramPrefix + 'p' + (i - SKIP_INDEXES) + '=' +
        encodeURIComponent(toDebugString(templateArgs[i]));
    }

    return new ErrorConstructor(message);
  };
}

/* We need to tell jshint what variables are being exported */
/* global angular: true,
  msie: true,
  jqLite: true,
  jQuery: true,
  slice: true,
  splice: true,
  push: true,
  toString: true,
  ngMinErr: true,
  angularModule: true,
  uid: true,
  REGEX_STRING_REGEXP: true,
  VALIDITY_STATE_PROPERTY: true,

  lowercase: true,
  uppercase: true,
  manualLowercase: true,
  manualUppercase: true,
  nodeName_: true,
  isArrayLike: true,
  forEach: true,
  forEachSorted: true,
  reverseParams: true,
  nextUid: true,
  setHashKey: true,
  extend: true,
  toInt: true,
  inherit: true,
  merge: true,
  noop: true,
  identity: true,
  valueFn: true,
  isUndefined: true,
  isDefined: true,
  isObject: true,
  isBlankObject: true,
  isString: true,
  isNumber: true,
  isDate: true,
  isArray: true,
  isFunction: true,
  isRegExp: true,
  isWindow: true,
  isScope: true,
  isFile: true,
  isFormData: true,
  isBlob: true,
  isBoolean: true,
  isPromiseLike: true,
  trim: true,
  escapeForRegexp: true,
  isElement: true,
  makeMap: true,
  includes: true,
  arrayRemove: true,
  copy: true,
  shallowCopy: true,
  equals: true,
  csp: true,
  jq: true,
  concat: true,
  sliceArgs: true,
  bind: true,
  toJsonReplacer: true,
  toJson: true,
  fromJson: true,
  convertTimezoneToLocal: true,
  timezoneToOffset: true,
  startingTag: true,
  tryDecodeURIComponent: true,
  parseKeyValue: true,
  toKeyValue: true,
  encodeUriSegment: true,
  encodeUriQuery: true,
  angularInit: true,
  bootstrap: true,
  getTestability: true,
  snake_case: true,
  bindJQuery: true,
  assertArg: true,
  assertArgFn: true,
  assertNotHasOwnProperty: true,
  getter: true,
  getBlockNodes: true,
  hasOwnProperty: true,
  createMap: true,

  NODE_TYPE_ELEMENT: true,
  NODE_TYPE_ATTRIBUTE: true,
  NODE_TYPE_TEXT: true,
  NODE_TYPE_COMMENT: true,
  NODE_TYPE_DOCUMENT: true,
  NODE_TYPE_DOCUMENT_FRAGMENT: true,
*/

////////////////////////////////////

/**
 * @ngdoc module
 * @name ng
 * @module ng
 * @description
 *
 * # ng (core module)
 * The ng module is loaded by default when an AngularJS application is started. The module itself
 * contains the essential components for an AngularJS application to function. The table below
 * lists a high level breakdown of each of the services/factories, filters, directives and testing
 * components available within this core module.
 *
 * <div doc-module-components="ng"></div>
 */

var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;

// The name of a form control's ValidityState property.
// This is used so that it's possible for internal tests to create mock ValidityStates.
var VALIDITY_STATE_PROPERTY = 'validity';

/**
 * @ngdoc function
 * @name angular.lowercase
 * @module ng
 * @kind function
 *
 * @description Converts the specified string to lowercase.
 * @param {string} string String to be converted to lowercase.
 * @returns {string} Lowercased string.
 */
var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};
var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * @ngdoc function
 * @name angular.uppercase
 * @module ng
 * @kind function
 *
 * @description Converts the specified string to uppercase.
 * @param {string} string String to be converted to uppercase.
 * @returns {string} Uppercased string.
 */
var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};


var manualLowercase = function(s) {
  /* jshint bitwise: false */
  return isString(s)
      ? s.replace(/[A-Z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) | 32);})
      : s;
};
var manualUppercase = function(s) {
  /* jshint bitwise: false */
  return isString(s)
      ? s.replace(/[a-z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) & ~32);})
      : s;
};


// String#toLowerCase and String#toUpperCase don't produce correct results in browsers with Turkish
// locale, for this reason we need to detect this case and redefine lowercase/uppercase methods
// with correct but slower alternatives.
if ('i' !== 'I'.toLowerCase()) {
  lowercase = manualLowercase;
  uppercase = manualUppercase;
}


var
    msie,             // holds major version number for IE, or NaN if UA is not IE.
    jqLite,           // delay binding since jQuery could be loaded after us.
    jQuery,           // delay binding
    slice             = [].slice,
    splice            = [].splice,
    push              = [].push,
    toString          = Object.prototype.toString,
    getPrototypeOf    = Object.getPrototypeOf,
    ngMinErr          = minErr('ng'),

    /** @name angular */
    angular           = window.angular || (window.angular = {}),
    angularModule,
    uid               = 0;

/**
 * documentMode is an IE-only property
 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
 */
msie = document.documentMode;


/**
 * @private
 * @param {*} obj
 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
 *                   String ...)
 */
function isArrayLike(obj) {
  if (obj == null || isWindow(obj)) {
    return false;
  }

  // Support: iOS 8.2 (not reproducible in simulator)
  // "length" in obj used to prevent JIT error (gh-11508)
  var length = "length" in Object(obj) && obj.length;

  if (obj.nodeType === NODE_TYPE_ELEMENT && length) {
    return true;
  }

  return isString(obj) || isArray(obj) || length === 0 ||
         typeof length === 'number' && length > 0 && (length - 1) in obj;
}

/**
 * @ngdoc function
 * @name angular.forEach
 * @module ng
 * @kind function
 *
 * @description
 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
 * is the value of an object property or an array element, `key` is the object property key or
 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
 *
 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
 * using the `hasOwnProperty` method.
 *
 * Unlike ES262's
 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
 * Providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
 * return the value provided.
 *
   ```js
     var values = {name: 'misko', gender: 'male'};
     var log = [];
     angular.forEach(values, function(value, key) {
       this.push(key + ': ' + value);
     }, log);
     expect(log).toEqual(['name: misko', 'gender: male']);
   ```
 *
 * @param {Object|Array} obj Object to iterate over.
 * @param {Function} iterator Iterator function.
 * @param {Object=} context Object to become context (`this`) for the iterator function.
 * @returns {Object|Array} Reference to `obj`.
 */

function forEach(obj, iterator, context) {
  var key, length;
  if (obj) {
    if (isFunction(obj)) {
      for (key in obj) {
        // Need to check if hasOwnProperty exists,
        // as on IE8 the result of querySelectorAll is an object without a hasOwnProperty function
        if (key != 'prototype' && key != 'length' && key != 'name' && (!obj.hasOwnProperty || obj.hasOwnProperty(key))) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    } else if (isArray(obj) || isArrayLike(obj)) {
      var isPrimitive = typeof obj !== 'object';
      for (key = 0, length = obj.length; key < length; key++) {
        if (isPrimitive || key in obj) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    } else if (obj.forEach && obj.forEach !== forEach) {
        obj.forEach(iterator, context, obj);
    } else if (isBlankObject(obj)) {
      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
      for (key in obj) {
        iterator.call(context, obj[key], key, obj);
      }
    } else if (typeof obj.hasOwnProperty === 'function') {
      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
      for (key in obj) {
        if (obj.hasOwnProperty(key)) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    } else {
      // Slow path for objects which do not have a method `hasOwnProperty`
      for (key in obj) {
        if (hasOwnProperty.call(obj, key)) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    }
  }
  return obj;
}

function forEachSorted(obj, iterator, context) {
  var keys = Object.keys(obj).sort();
  for (var i = 0; i < keys.length; i++) {
    iterator.call(context, obj[keys[i]], keys[i]);
  }
  return keys;
}


/**
 * when using forEach the params are value, key, but it is often useful to have key, value.
 * @param {function(string, *)} iteratorFn
 * @returns {function(*, string)}
 */
function reverseParams(iteratorFn) {
  return function(value, key) { iteratorFn(key, value); };
}

/**
 * A consistent way of creating unique IDs in angular.
 *
 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
 * we hit number precision issues in JavaScript.
 *
 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
 *
 * @returns {number} an unique alpha-numeric string
 */
function nextUid() {
  return ++uid;
}


/**
 * Set or clear the hashkey for an object.
 * @param obj object
 * @param h the hashkey (!truthy to delete the hashkey)
 */
function setHashKey(obj, h) {
  if (h) {
    obj.$$hashKey = h;
  } else {
    delete obj.$$hashKey;
  }
}


function baseExtend(dst, objs, deep) {
  var h = dst.$$hashKey;

  for (var i = 0, ii = objs.length; i < ii; ++i) {
    var obj = objs[i];
    if (!isObject(obj) && !isFunction(obj)) continue;
    var keys = Object.keys(obj);
    for (var j = 0, jj = keys.length; j < jj; j++) {
      var key = keys[j];
      var src = obj[key];

      if (deep && isObject(src)) {
        if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
        baseExtend(dst[key], [src], true);
      } else {
        dst[key] = src;
      }
    }
  }

  setHashKey(dst, h);
  return dst;
}

/**
 * @ngdoc function
 * @name angular.extend
 * @module ng
 * @kind function
 *
 * @description
 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
 *
 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
 * {@link angular.merge} for this.
 *
 * @param {Object} dst Destination object.
 * @param {...Object} src Source object(s).
 * @returns {Object} Reference to `dst`.
 */
function extend(dst) {
  return baseExtend(dst, slice.call(arguments, 1), false);
}


/**
* @ngdoc function
* @name angular.merge
* @module ng
* @kind function
*
* @description
* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
*
* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
* objects, performing a deep copy.
*
* @param {Object} dst Destination object.
* @param {...Object} src Source object(s).
* @returns {Object} Reference to `dst`.
*/
function merge(dst) {
  return baseExtend(dst, slice.call(arguments, 1), true);
}



function toInt(str) {
  return parseInt(str, 10);
}


function inherit(parent, extra) {
  return extend(Object.create(parent), extra);
}

/**
 * @ngdoc function
 * @name angular.noop
 * @module ng
 * @kind function
 *
 * @description
 * A function that performs no operations. This function can be useful when writing code in the
 * functional style.
   ```js
     function foo(callback) {
       var result = calculateResult();
       (callback || angular.noop)(result);
     }
   ```
 */
function noop() {}
noop.$inject = [];


/**
 * @ngdoc function
 * @name angular.identity
 * @module ng
 * @kind function
 *
 * @description
 * A function that returns its first argument. This function is useful when writing code in the
 * functional style.
 *
   ```js
     function transformer(transformationFn, value) {
       return (transformationFn || angular.identity)(value);
     };
   ```
  * @param {*} value to be returned.
  * @returns {*} the value passed in.
 */
function identity($) {return $;}
identity.$inject = [];


function valueFn(value) {return function() {return value;};}

/**
 * @ngdoc function
 * @name angular.isUndefined
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is undefined.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is undefined.
 */
function isUndefined(value) {return typeof value === 'undefined';}


/**
 * @ngdoc function
 * @name angular.isDefined
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is defined.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is defined.
 */
function isDefined(value) {return typeof value !== 'undefined';}


/**
 * @ngdoc function
 * @name angular.isObject
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
 * considered to be objects. Note that JavaScript arrays are objects.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Object` but not `null`.
 */
function isObject(value) {
  // http://jsperf.com/isobject4
  return value !== null && typeof value === 'object';
}


/**
 * Determine if a value is an object with a null prototype
 *
 * @returns {boolean} True if `value` is an `Object` with a null prototype
 */
function isBlankObject(value) {
  return value !== null && typeof value === 'object' && !getPrototypeOf(value);
}


/**
 * @ngdoc function
 * @name angular.isString
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `String`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `String`.
 */
function isString(value) {return typeof value === 'string';}


/**
 * @ngdoc function
 * @name angular.isNumber
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `Number`.
 *
 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
 *
 * If you wish to exclude these then you can use the native
 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
 * method.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Number`.
 */
function isNumber(value) {return typeof value === 'number';}


/**
 * @ngdoc function
 * @name angular.isDate
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a value is a date.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Date`.
 */
function isDate(value) {
  return toString.call(value) === '[object Date]';
}


/**
 * @ngdoc function
 * @name angular.isArray
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is an `Array`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Array`.
 */
var isArray = Array.isArray;

/**
 * @ngdoc function
 * @name angular.isFunction
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `Function`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Function`.
 */
function isFunction(value) {return typeof value === 'function';}


/**
 * Determines if a value is a regular expression object.
 *
 * @private
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `RegExp`.
 */
function isRegExp(value) {
  return toString.call(value) === '[object RegExp]';
}


/**
 * Checks if `obj` is a window object.
 *
 * @private
 * @param {*} obj Object to check
 * @returns {boolean} True if `obj` is a window obj.
 */
function isWindow(obj) {
  return obj && obj.window === obj;
}


function isScope(obj) {
  return obj && obj.$evalAsync && obj.$watch;
}


function isFile(obj) {
  return toString.call(obj) === '[object File]';
}


function isFormData(obj) {
  return toString.call(obj) === '[object FormData]';
}


function isBlob(obj) {
  return toString.call(obj) === '[object Blob]';
}


function isBoolean(value) {
  return typeof value === 'boolean';
}


function isPromiseLike(obj) {
  return obj && isFunction(obj.then);
}


var TYPED_ARRAY_REGEXP = /^\[object (Uint8(Clamped)?)|(Uint16)|(Uint32)|(Int8)|(Int16)|(Int32)|(Float(32)|(64))Array\]$/;
function isTypedArray(value) {
  return TYPED_ARRAY_REGEXP.test(toString.call(value));
}


var trim = function(value) {
  return isString(value) ? value.trim() : value;
};

// Copied from:
// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
// Prereq: s is a string.
var escapeForRegexp = function(s) {
  return s.replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, '\\$1').
           replace(/\x08/g, '\\x08');
};


/**
 * @ngdoc function
 * @name angular.isElement
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a DOM element (or wrapped jQuery element).
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
 */
function isElement(node) {
  return !!(node &&
    (node.nodeName  // we are a direct element
    || (node.prop && node.attr && node.find)));  // we have an on and find method part of jQuery API
}

/**
 * @param str 'key1,key2,...'
 * @returns {object} in the form of {key1:true, key2:true, ...}
 */
function makeMap(str) {
  var obj = {}, items = str.split(","), i;
  for (i = 0; i < items.length; i++) {
    obj[items[i]] = true;
  }
  return obj;
}


function nodeName_(element) {
  return lowercase(element.nodeName || (element[0] && element[0].nodeName));
}

function includes(array, obj) {
  return Array.prototype.indexOf.call(array, obj) != -1;
}

function arrayRemove(array, value) {
  var index = array.indexOf(value);
  if (index >= 0) {
    array.splice(index, 1);
  }
  return index;
}

/**
 * @ngdoc function
 * @name angular.copy
 * @module ng
 * @kind function
 *
 * @description
 * Creates a deep copy of `source`, which should be an object or an array.
 *
 * * If no destination is supplied, a copy of the object or array is created.
 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
 *   are deleted and then all elements/properties from the source are copied to it.
 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
 * * If `source` is identical to 'destination' an exception will be thrown.
 *
 * @param {*} source The source that will be used to make a copy.
 *                   Can be any type, including primitives, `null`, and `undefined`.
 * @param {(Object|Array)=} destination Destination into which the source is copied. If
 *     provided, must be of the same type as `source`.
 * @returns {*} The copy or updated `destination`, if `destination` was specified.
 *
 * @example
 <example module="copyExample">
 <file name="index.html">
 <div ng-controller="ExampleController">
 <form novalidate class="simple-form">
 Name: <input type="text" ng-model="user.name" /><br />
 E-mail: <input type="email" ng-model="user.email" /><br />
 Gender: <input type="radio" ng-model="user.gender" value="male" />male
 <input type="radio" ng-model="user.gender" value="female" />female<br />
 <button ng-click="reset()">RESET</button>
 <button ng-click="update(user)">SAVE</button>
 </form>
 <pre>form = {{user | json}}</pre>
 <pre>master = {{master | json}}</pre>
 </div>

 <script>
  angular.module('copyExample', [])
    .controller('ExampleController', ['$scope', function($scope) {
      $scope.master= {};

      $scope.update = function(user) {
        // Example with 1 argument
        $scope.master= angular.copy(user);
      };

      $scope.reset = function() {
        // Example with 2 arguments
        angular.copy($scope.master, $scope.user);
      };

      $scope.reset();
    }]);
 </script>
 </file>
 </example>
 */
function copy(source, destination, stackSource, stackDest) {
  if (isWindow(source) || isScope(source)) {
    throw ngMinErr('cpws',
      "Can't copy! Making copies of Window or Scope instances is not supported.");
  }
  if (isTypedArray(destination)) {
    throw ngMinErr('cpta',
      "Can't copy! TypedArray destination cannot be mutated.");
  }

  if (!destination) {
    destination = source;
    if (isObject(source)) {
      var index;
      if (stackSource && (index = stackSource.indexOf(source)) !== -1) {
        return stackDest[index];
      }

      // TypedArray, Date and RegExp have specific copy functionality and must be
      // pushed onto the stack before returning.
      // Array and other objects create the base object and recurse to copy child
      // objects. The array/object will be pushed onto the stack when recursed.
      if (isArray(source)) {
        return copy(source, [], stackSource, stackDest);
      } else if (isTypedArray(source)) {
        destination = new source.constructor(source);
      } else if (isDate(source)) {
        destination = new Date(source.getTime());
      } else if (isRegExp(source)) {
        destination = new RegExp(source.source, source.toString().match(/[^\/]*$/)[0]);
        destination.lastIndex = source.lastIndex;
      } else {
        var emptyObject = Object.create(getPrototypeOf(source));
        return copy(source, emptyObject, stackSource, stackDest);
      }

      if (stackDest) {
        stackSource.push(source);
        stackDest.push(destination);
      }
    }
  } else {
    if (source === destination) throw ngMinErr('cpi',
      "Can't copy! Source and destination are identical.");

    stackSource = stackSource || [];
    stackDest = stackDest || [];

    if (isObject(source)) {
      stackSource.push(source);
      stackDest.push(destination);
    }

    var result, key;
    if (isArray(source)) {
      destination.length = 0;
      for (var i = 0; i < source.length; i++) {
        destination.push(copy(source[i], null, stackSource, stackDest));
      }
    } else {
      var h = destination.$$hashKey;
      if (isArray(destination)) {
        destination.length = 0;
      } else {
        forEach(destination, function(value, key) {
          delete destination[key];
        });
      }
      if (isBlankObject(source)) {
        // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
        for (key in source) {
          destination[key] = copy(source[key], null, stackSource, stackDest);
        }
      } else if (source && typeof source.hasOwnProperty === 'function') {
        // Slow path, which must rely on hasOwnProperty
        for (key in source) {
          if (source.hasOwnProperty(key)) {
            destination[key] = copy(source[key], null, stackSource, stackDest);
          }
        }
      } else {
        // Slowest path --- hasOwnProperty can't be called as a method
        for (key in source) {
          if (hasOwnProperty.call(source, key)) {
            destination[key] = copy(source[key], null, stackSource, stackDest);
          }
        }
      }
      setHashKey(destination,h);
    }
  }
  return destination;
}

/**
 * Creates a shallow copy of an object, an array or a primitive.
 *
 * Assumes that there are no proto properties for objects.
 */
function shallowCopy(src, dst) {
  if (isArray(src)) {
    dst = dst || [];

    for (var i = 0, ii = src.length; i < ii; i++) {
      dst[i] = src[i];
    }
  } else if (isObject(src)) {
    dst = dst || {};

    for (var key in src) {
      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
        dst[key] = src[key];
      }
    }
  }

  return dst || src;
}


/**
 * @ngdoc function
 * @name angular.equals
 * @module ng
 * @kind function
 *
 * @description
 * Determines if two objects or two values are equivalent. Supports value types, regular
 * expressions, arrays and objects.
 *
 * Two objects or values are considered equivalent if at least one of the following is true:
 *
 * * Both objects or values pass `===` comparison.
 * * Both objects or values are of the same type and all of their properties are equal by
 *   comparing them with `angular.equals`.
 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
 * * Both values represent the same regular expression (In JavaScript,
 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
 *   representation matches).
 *
 * During a property comparison, properties of `function` type and properties with names
 * that begin with `$` are ignored.
 *
 * Scope and DOMWindow objects are being compared only by identify (`===`).
 *
 * @param {*} o1 Object or value to compare.
 * @param {*} o2 Object or value to compare.
 * @returns {boolean} True if arguments are equal.
 */
function equals(o1, o2) {
  if (o1 === o2) return true;
  if (o1 === null || o2 === null) return false;
  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
  if (t1 == t2) {
    if (t1 == 'object') {
      if (isArray(o1)) {
        if (!isArray(o2)) return false;
        if ((length = o1.length) == o2.length) {
          for (key = 0; key < length; key++) {
            if (!equals(o1[key], o2[key])) return false;
          }
          return true;
        }
      } else if (isDate(o1)) {
        if (!isDate(o2)) return false;
        return equals(o1.getTime(), o2.getTime());
      } else if (isRegExp(o1)) {
        return isRegExp(o2) ? o1.toString() == o2.toString() : false;
      } else {
        if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
          isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
        keySet = createMap();
        for (key in o1) {
          if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
          if (!equals(o1[key], o2[key])) return false;
          keySet[key] = true;
        }
        for (key in o2) {
          if (!(key in keySet) &&
              key.charAt(0) !== '$' &&
              o2[key] !== undefined &&
              !isFunction(o2[key])) return false;
        }
        return true;
      }
    }
  }
  return false;
}

var csp = function() {
  if (isDefined(csp.isActive_)) return csp.isActive_;

  var active = !!(document.querySelector('[ng-csp]') ||
                  document.querySelector('[data-ng-csp]'));

  if (!active) {
    try {
      /* jshint -W031, -W054 */
      new Function('');
      /* jshint +W031, +W054 */
    } catch (e) {
      active = true;
    }
  }

  return (csp.isActive_ = active);
};

/**
 * @ngdoc directive
 * @module ng
 * @name ngJq
 *
 * @element ANY
 * @param {string=} ngJq the name of the library available under `window`
 * to be used for angular.element
 * @description
 * Use this directive to force the angular.element library.  This should be
 * used to force either jqLite by leaving ng-jq blank or setting the name of
 * the jquery variable under window (eg. jQuery).
 *
 * Since angular looks for this directive when it is loaded (doesn't wait for the
 * DOMContentLoaded event), it must be placed on an element that comes before the script
 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
 * others ignored.
 *
 * @example
 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
 ```html
 <!doctype html>
 <html ng-app ng-jq>
 ...
 ...
 </html>
 ```
 * @example
 * This example shows how to use a jQuery based library of a different name.
 * The library name must be available at the top most 'window'.
 ```html
 <!doctype html>
 <html ng-app ng-jq="jQueryLib">
 ...
 ...
 </html>
 ```
 */
var jq = function() {
  if (isDefined(jq.name_)) return jq.name_;
  var el;
  var i, ii = ngAttrPrefixes.length, prefix, name;
  for (i = 0; i < ii; ++i) {
    prefix = ngAttrPrefixes[i];
    if (el = document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]')) {
      name = el.getAttribute(prefix + 'jq');
      break;
    }
  }

  return (jq.name_ = name);
};

function concat(array1, array2, index) {
  return array1.concat(slice.call(array2, index));
}

function sliceArgs(args, startIndex) {
  return slice.call(args, startIndex || 0);
}


/* jshint -W101 */
/**
 * @ngdoc function
 * @name angular.bind
 * @module ng
 * @kind function
 *
 * @description
 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
 *
 * @param {Object} self Context which `fn` should be evaluated in.
 * @param {function()} fn Function to be bound.
 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
 */
/* jshint +W101 */
function bind(self, fn) {
  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
  if (isFunction(fn) && !(fn instanceof RegExp)) {
    return curryArgs.length
      ? function() {
          return arguments.length
            ? fn.apply(self, concat(curryArgs, arguments, 0))
            : fn.apply(self, curryArgs);
        }
      : function() {
          return arguments.length
            ? fn.apply(self, arguments)
            : fn.call(self);
        };
  } else {
    // in IE, native methods are not functions so they cannot be bound (note: they don't need to be)
    return fn;
  }
}


function toJsonReplacer(key, value) {
  var val = value;

  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
    val = undefined;
  } else if (isWindow(value)) {
    val = '$WINDOW';
  } else if (value &&  document === value) {
    val = '$DOCUMENT';
  } else if (isScope(value)) {
    val = '$SCOPE';
  }

  return val;
}


/**
 * @ngdoc function
 * @name angular.toJson
 * @module ng
 * @kind function
 *
 * @description
 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
 * stripped since angular uses this notation internally.
 *
 * @param {Object|Array|Date|string|number} obj Input to be serialized into JSON.
 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
 *    If set to an integer, the JSON output will contain that many spaces per indentation.
 * @returns {string|undefined} JSON-ified string representing `obj`.
 */
function toJson(obj, pretty) {
  if (typeof obj === 'undefined') return undefined;
  if (!isNumber(pretty)) {
    pretty = pretty ? 2 : null;
  }
  return JSON.stringify(obj, toJsonReplacer, pretty);
}


/**
 * @ngdoc function
 * @name angular.fromJson
 * @module ng
 * @kind function
 *
 * @description
 * Deserializes a JSON string.
 *
 * @param {string} json JSON string to deserialize.
 * @returns {Object|Array|string|number} Deserialized JSON string.
 */
function fromJson(json) {
  return isString(json)
      ? JSON.parse(json)
      : json;
}


function timezoneToOffset(timezone, fallback) {
  var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
  return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
}


function addDateMinutes(date, minutes) {
  date = new Date(date.getTime());
  date.setMinutes(date.getMinutes() + minutes);
  return date;
}


function convertTimezoneToLocal(date, timezone, reverse) {
  reverse = reverse ? -1 : 1;
  var timezoneOffset = timezoneToOffset(timezone, date.getTimezoneOffset());
  return addDateMinutes(date, reverse * (timezoneOffset - date.getTimezoneOffset()));
}


/**
 * @returns {string} Returns the string representation of the element.
 */
function startingTag(element) {
  element = jqLite(element).clone();
  try {
    // turns out IE does not let you set .html() on elements which
    // are not allowed to have children. So we just ignore it.
    element.empty();
  } catch (e) {}
  var elemHtml = jqLite('<div>').append(element).html();
  try {
    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
        elemHtml.
          match(/^(<[^>]+>)/)[1].
          replace(/^<([\w\-]+)/, function(match, nodeName) { return '<' + lowercase(nodeName); });
  } catch (e) {
    return lowercase(elemHtml);
  }

}


/////////////////////////////////////////////////

/**
 * Tries to decode the URI component without throwing an exception.
 *
 * @private
 * @param str value potential URI component to check.
 * @returns {boolean} True if `value` can be decoded
 * with the decodeURIComponent function.
 */
function tryDecodeURIComponent(value) {
  try {
    return decodeURIComponent(value);
  } catch (e) {
    // Ignore any invalid uri component
  }
}


/**
 * Parses an escaped url query string into key-value pairs.
 * @returns {Object.<string,boolean|Array>}
 */
function parseKeyValue(/**string*/keyValue) {
  var obj = {}, key_value, key;
  forEach((keyValue || "").split('&'), function(keyValue) {
    if (keyValue) {
      key_value = keyValue.replace(/\+/g,'%20').split('=');
      key = tryDecodeURIComponent(key_value[0]);
      if (isDefined(key)) {
        var val = isDefined(key_value[1]) ? tryDecodeURIComponent(key_value[1]) : true;
        if (!hasOwnProperty.call(obj, key)) {
          obj[key] = val;
        } else if (isArray(obj[key])) {
          obj[key].push(val);
        } else {
          obj[key] = [obj[key],val];
        }
      }
    }
  });
  return obj;
}

function toKeyValue(obj) {
  var parts = [];
  forEach(obj, function(value, key) {
    if (isArray(value)) {
      forEach(value, function(arrayValue) {
        parts.push(encodeUriQuery(key, true) +
                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
      });
    } else {
    parts.push(encodeUriQuery(key, true) +
               (value === true ? '' : '=' + encodeUriQuery(value, true)));
    }
  });
  return parts.length ? parts.join('&') : '';
}


/**
 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
 * segments:
 *    segment       = *pchar
 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
 *    pct-encoded   = "%" HEXDIG HEXDIG
 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
 *                     / "*" / "+" / "," / ";" / "="
 */
function encodeUriSegment(val) {
  return encodeUriQuery(val, true).
             replace(/%26/gi, '&').
             replace(/%3D/gi, '=').
             replace(/%2B/gi, '+');
}


/**
 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
 * encoded per http://tools.ietf.org/html/rfc3986:
 *    query       = *( pchar / "/" / "?" )
 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
 *    pct-encoded   = "%" HEXDIG HEXDIG
 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
 *                     / "*" / "+" / "," / ";" / "="
 */
function encodeUriQuery(val, pctEncodeSpaces) {
  return encodeURIComponent(val).
             replace(/%40/gi, '@').
             replace(/%3A/gi, ':').
             replace(/%24/g, '$').
             replace(/%2C/gi, ',').
             replace(/%3B/gi, ';').
             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
}

var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];

function getNgAttribute(element, ngAttr) {
  var attr, i, ii = ngAttrPrefixes.length;
  for (i = 0; i < ii; ++i) {
    attr = ngAttrPrefixes[i] + ngAttr;
    if (isString(attr = element.getAttribute(attr))) {
      return attr;
    }
  }
  return null;
}

/**
 * @ngdoc directive
 * @name ngApp
 * @module ng
 *
 * @element ANY
 * @param {angular.Module} ngApp an optional application
 *   {@link angular.module module} name to load.
 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
 *   tracking down the root of these bugs.
 *
 * @description
 *
 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
 * designates the **root element** of the application and is typically placed near the root element
 * of the page - e.g. on the `<body>` or `<html>` tags.
 *
 * Only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
 * found in the document will be used to define the root element to auto-bootstrap as an
 * application. To run multiple applications in an HTML document you must manually bootstrap them using
 * {@link angular.bootstrap} instead. AngularJS applications cannot be nested within each other.
 *
 * You can specify an **AngularJS module** to be used as the root module for the application.  This
 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
 * should contain the application code needed or have dependencies on other modules that will
 * contain the code. See {@link angular.module} for more information.
 *
 * In the example below if the `ngApp` directive were not placed on the `html` element then the
 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
 * would not be resolved to `3`.
 *
 * `ngApp` is the easiest, and most common way to bootstrap an application.
 *
 <example module="ngAppDemo">
   <file name="index.html">
   <div ng-controller="ngAppDemoController">
     I can add: {{a}} + {{b}} =  {{ a+b }}
   </div>
   </file>
   <file name="script.js">
   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
     $scope.a = 1;
     $scope.b = 2;
   });
   </file>
 </example>
 *
 * Using `ngStrictDi`, you would see something like this:
 *
 <example ng-app-included="true">
   <file name="index.html">
   <div ng-app="ngAppStrictDemo" ng-strict-di>
       <div ng-controller="GoodController1">
           I can add: {{a}} + {{b}} =  {{ a+b }}

           <p>This renders because the controller does not fail to
              instantiate, by using explicit annotation style (see
              script.js for details)
           </p>
       </div>

       <div ng-controller="GoodController2">
           Name: <input ng-model="name"><br />
           Hello, {{name}}!

           <p>This renders because the controller does not fail to
              instantiate, by using explicit annotation style
              (see script.js for details)
           </p>
       </div>

       <div ng-controller="BadController">
           I can add: {{a}} + {{b}} =  {{ a+b }}

           <p>The controller could not be instantiated, due to relying
              on automatic function annotations (which are disabled in
              strict mode). As such, the content of this section is not
              interpolated, and there should be an error in your web console.
           </p>
       </div>
   </div>
   </file>
   <file name="script.js">
   angular.module('ngAppStrictDemo', [])
     // BadController will fail to instantiate, due to relying on automatic function annotation,
     // rather than an explicit annotation
     .controller('BadController', function($scope) {
       $scope.a = 1;
       $scope.b = 2;
     })
     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
     // due to using explicit annotations using the array style and $inject property, respectively.
     .controller('GoodController1', ['$scope', function($scope) {
       $scope.a = 1;
       $scope.b = 2;
     }])
     .controller('GoodController2', GoodController2);
     function GoodController2($scope) {
       $scope.name = "World";
     }
     GoodController2.$inject = ['$scope'];
   </file>
   <file name="style.css">
   div[ng-controller] {
       margin-bottom: 1em;
       -webkit-border-radius: 4px;
       border-radius: 4px;
       border: 1px solid;
       padding: .5em;
   }
   div[ng-controller^=Good] {
       border-color: #d6e9c6;
       background-color: #dff0d8;
       color: #3c763d;
   }
   div[ng-controller^=Bad] {
       border-color: #ebccd1;
       background-color: #f2dede;
       color: #a94442;
       margin-bottom: 0;
   }
   </file>
 </example>
 */
function angularInit(element, bootstrap) {
  var appElement,
      module,
      config = {};

  // The element `element` has priority over any other element
  forEach(ngAttrPrefixes, function(prefix) {
    var name = prefix + 'app';

    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
      appElement = element;
      module = element.getAttribute(name);
    }
  });
  forEach(ngAttrPrefixes, function(prefix) {
    var name = prefix + 'app';
    var candidate;

    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
      appElement = candidate;
      module = candidate.getAttribute(name);
    }
  });
  if (appElement) {
    config.strictDi = getNgAttribute(appElement, "strict-di") !== null;
    bootstrap(appElement, module ? [module] : [], config);
  }
}

/**
 * @ngdoc function
 * @name angular.bootstrap
 * @module ng
 * @description
 * Use this function to manually start up angular application.
 *
 * See: {@link guide/bootstrap Bootstrap}
 *
 * Note that Protractor based end-to-end tests cannot use this function to bootstrap manually.
 * They must use {@link ng.directive:ngApp ngApp}.
 *
 * Angular will detect if it has been loaded into the browser more than once and only allow the
 * first loaded script to be bootstrapped and will report a warning to the browser console for
 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
 * multiple instances of Angular try to work on the DOM.
 *
 * ```html
 * <!doctype html>
 * <html>
 * <body>
 * <div ng-controller="WelcomeController">
 *   {{greeting}}
 * </div>
 *
 * <script src="angular.js"></script>
 * <script>
 *   var app = angular.module('demo', [])
 *   .controller('WelcomeController', function($scope) {
 *       $scope.greeting = 'Welcome!';
 *   });
 *   angular.bootstrap(document, ['demo']);
 * </script>
 * </body>
 * </html>
 * ```
 *
 * @param {DOMElement} element DOM element which is the root of angular application.
 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
 *     Each item in the array should be the name of a predefined module or a (DI annotated)
 *     function that will be invoked by the injector as a `config` block.
 *     See: {@link angular.module modules}
 * @param {Object=} config an object for defining configuration options for the application. The
 *     following keys are supported:
 *
 * * `strictDi` - disable automatic function annotation for the application. This is meant to
 *   assist in finding bugs which break minified code. Defaults to `false`.
 *
 * @returns {auto.$injector} Returns the newly created injector for this app.
 */
function bootstrap(element, modules, config) {
  if (!isObject(config)) config = {};
  var defaultConfig = {
    strictDi: false
  };
  config = extend(defaultConfig, config);
  var doBootstrap = function() {
    element = jqLite(element);

    if (element.injector()) {
      var tag = (element[0] === document) ? 'document' : startingTag(element);
      //Encode angle brackets to prevent input from being sanitized to empty string #8683
      throw ngMinErr(
          'btstrpd',
          "App Already Bootstrapped with this Element '{0}'",
          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
    }

    modules = modules || [];
    modules.unshift(['$provide', function($provide) {
      $provide.value('$rootElement', element);
    }]);

    if (config.debugInfoEnabled) {
      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
      modules.push(['$compileProvider', function($compileProvider) {
        $compileProvider.debugInfoEnabled(true);
      }]);
    }

    modules.unshift('ng');
    var injector = createInjector(modules, config.strictDi);
    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
       function bootstrapApply(scope, element, compile, injector) {
        scope.$apply(function() {
          element.data('$injector', injector);
          compile(element)(scope);
        });
      }]
    );
    return injector;
  };

  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;

  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
    config.debugInfoEnabled = true;
    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
  }

  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
    return doBootstrap();
  }

  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
  angular.resumeBootstrap = function(extraModules) {
    forEach(extraModules, function(module) {
      modules.push(module);
    });
    return doBootstrap();
  };

  if (isFunction(angular.resumeDeferredBootstrap)) {
    angular.resumeDeferredBootstrap();
  }
}

/**
 * @ngdoc function
 * @name angular.reloadWithDebugInfo
 * @module ng
 * @description
 * Use this function to reload the current application with debug information turned on.
 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
 *
 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
 */
function reloadWithDebugInfo() {
  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
  window.location.reload();
}

/**
 * @name angular.getTestability
 * @module ng
 * @description
 * Get the testability service for the instance of Angular on the given
 * element.
 * @param {DOMElement} element DOM element which is the root of angular application.
 */
function getTestability(rootElement) {
  var injector = angular.element(rootElement).injector();
  if (!injector) {
    throw ngMinErr('test',
      'no injector found for element argument to getTestability');
  }
  return injector.get('$$testability');
}

var SNAKE_CASE_REGEXP = /[A-Z]/g;
function snake_case(name, separator) {
  separator = separator || '_';
  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
    return (pos ? separator : '') + letter.toLowerCase();
  });
}

var bindJQueryFired = false;
var skipDestroyOnNextJQueryCleanData;
function bindJQuery() {
  var originalCleanData;

  if (bindJQueryFired) {
    return;
  }

  // bind to jQuery if present;
  var jqName = jq();
  jQuery = window.jQuery; // use default jQuery.
  if (isDefined(jqName)) { // `ngJq` present
    jQuery = jqName === null ? undefined : window[jqName]; // if empty; use jqLite. if not empty, use jQuery specified by `ngJq`.
  }

  // Use jQuery if it exists with proper functionality, otherwise default to us.
  // Angular 1.2+ requires jQuery 1.7+ for on()/off() support.
  // Angular 1.3+ technically requires at least jQuery 2.1+ but it may work with older
  // versions. It will not work for sure with jQuery <1.7, though.
  if (jQuery && jQuery.fn.on) {
    jqLite = jQuery;
    extend(jQuery.fn, {
      scope: JQLitePrototype.scope,
      isolateScope: JQLitePrototype.isolateScope,
      controller: JQLitePrototype.controller,
      injector: JQLitePrototype.injector,
      inheritedData: JQLitePrototype.inheritedData
    });

    // All nodes removed from the DOM via various jQuery APIs like .remove()
    // are passed through jQuery.cleanData. Monkey-patch this method to fire
    // the $destroy event on all removed nodes.
    originalCleanData = jQuery.cleanData;
    jQuery.cleanData = function(elems) {
      var events;
      if (!skipDestroyOnNextJQueryCleanData) {
        for (var i = 0, elem; (elem = elems[i]) != null; i++) {
          events = jQuery._data(elem, "events");
          if (events && events.$destroy) {
            jQuery(elem).triggerHandler('$destroy');
          }
        }
      } else {
        skipDestroyOnNextJQueryCleanData = false;
      }
      originalCleanData(elems);
    };
  } else {
    jqLite = JQLite;
  }

  angular.element = jqLite;

  // Prevent double-proxying.
  bindJQueryFired = true;
}

/**
 * throw error if the argument is falsy.
 */
function assertArg(arg, name, reason) {
  if (!arg) {
    throw ngMinErr('areq', "Argument '{0}' is {1}", (name || '?'), (reason || "required"));
  }
  return arg;
}

function assertArgFn(arg, name, acceptArrayAnnotation) {
  if (acceptArrayAnnotation && isArray(arg)) {
      arg = arg[arg.length - 1];
  }

  assertArg(isFunction(arg), name, 'not a function, got ' +
      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
  return arg;
}

/**
 * throw error if the name given is hasOwnProperty
 * @param  {String} name    the name to test
 * @param  {String} context the context in which the name is used, such as module or directive
 */
function assertNotHasOwnProperty(name, context) {
  if (name === 'hasOwnProperty') {
    throw ngMinErr('badname', "hasOwnProperty is not a valid {0} name", context);
  }
}

/**
 * Return the value accessible from the object by path. Any undefined traversals are ignored
 * @param {Object} obj starting object
 * @param {String} path path to traverse
 * @param {boolean} [bindFnToScope=true]
 * @returns {Object} value as accessible by path
 */
//TODO(misko): this function needs to be removed
function getter(obj, path, bindFnToScope) {
  if (!path) return obj;
  var keys = path.split('.');
  var key;
  var lastInstance = obj;
  var len = keys.length;

  for (var i = 0; i < len; i++) {
    key = keys[i];
    if (obj) {
      obj = (lastInstance = obj)[key];
    }
  }
  if (!bindFnToScope && isFunction(obj)) {
    return bind(lastInstance, obj);
  }
  return obj;
}

/**
 * Return the DOM siblings between the first and last node in the given array.
 * @param {Array} array like object
 * @returns {jqLite} jqLite collection containing the nodes
 */
function getBlockNodes(nodes) {
  // TODO(perf): just check if all items in `nodes` are siblings and if they are return the original
  //             collection, otherwise update the original collection.
  var node = nodes[0];
  var endNode = nodes[nodes.length - 1];
  var blockNodes = [node];

  do {
    node = node.nextSibling;
    if (!node) break;
    blockNodes.push(node);
  } while (node !== endNode);

  return jqLite(blockNodes);
}


/**
 * Creates a new object without a prototype. This object is useful for lookup without having to
 * guard against prototypically inherited properties via hasOwnProperty.
 *
 * Related micro-benchmarks:
 * - http://jsperf.com/object-create2
 * - http://jsperf.com/proto-map-lookup/2
 * - http://jsperf.com/for-in-vs-object-keys2
 *
 * @returns {Object}
 */
function createMap() {
  return Object.create(null);
}

var NODE_TYPE_ELEMENT = 1;
var NODE_TYPE_ATTRIBUTE = 2;
var NODE_TYPE_TEXT = 3;
var NODE_TYPE_COMMENT = 8;
var NODE_TYPE_DOCUMENT = 9;
var NODE_TYPE_DOCUMENT_FRAGMENT = 11;

/**
 * @ngdoc type
 * @name angular.Module
 * @module ng
 * @description
 *
 * Interface for configuring angular {@link angular.module modules}.
 */

function setupModuleLoader(window) {

  var $injectorMinErr = minErr('$injector');
  var ngMinErr = minErr('ng');

  function ensure(obj, name, factory) {
    return obj[name] || (obj[name] = factory());
  }

  var angular = ensure(window, 'angular', Object);

  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
  angular.$$minErr = angular.$$minErr || minErr;

  return ensure(angular, 'module', function() {
    /** @type {Object.<string, angular.Module>} */
    var modules = {};

    /**
     * @ngdoc function
     * @name angular.module
     * @module ng
     * @description
     *
     * The `angular.module` is a global place for creating, registering and retrieving Angular
     * modules.
     * All modules (angular core or 3rd party) that should be available to an application must be
     * registered using this mechanism.
     *
     * When passed two or more arguments, a new module is created.  If passed only one argument, an
     * existing module (the name passed as the first argument to `module`) is retrieved.
     *
     *
     * # Module
     *
     * A module is a collection of services, directives, controllers, filters, and configuration information.
     * `angular.module` is used to configure the {@link auto.$injector $injector}.
     *
     * ```js
     * // Create a new module
     * var myModule = angular.module('myModule', []);
     *
     * // register a new service
     * myModule.value('appName', 'MyCoolApp');
     *
     * // configure existing services inside initialization blocks.
     * myModule.config(['$locationProvider', function($locationProvider) {
     *   // Configure existing providers
     *   $locationProvider.hashPrefix('!');
     * }]);
     * ```
     *
     * Then you can create an injector and load your modules like this:
     *
     * ```js
     * var injector = angular.injector(['ng', 'myModule'])
     * ```
     *
     * However it's more likely that you'll just use
     * {@link ng.directive:ngApp ngApp} or
     * {@link angular.bootstrap} to simplify this process for you.
     *
     * @param {!string} name The name of the module to create or retrieve.
     * @param {!Array.<string>=} requires If specified then new module is being created. If
     *        unspecified then the module is being retrieved for further configuration.
     * @param {Function=} configFn Optional configuration function for the module. Same as
     *        {@link angular.Module#config Module#config()}.
     * @returns {module} new module with the {@link angular.Module} api.
     */
    return function module(name, requires, configFn) {
      var assertNotHasOwnProperty = function(name, context) {
        if (name === 'hasOwnProperty') {
          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
        }
      };

      assertNotHasOwnProperty(name, 'module');
      if (requires && modules.hasOwnProperty(name)) {
        modules[name] = null;
      }
      return ensure(modules, name, function() {
        if (!requires) {
          throw $injectorMinErr('nomod', "Module '{0}' is not available! You either misspelled " +
             "the module name or forgot to load it. If registering a module ensure that you " +
             "specify the dependencies as the second argument.", name);
        }

        /** @type {!Array.<Array.<*>>} */
        var invokeQueue = [];

        /** @type {!Array.<Function>} */
        var configBlocks = [];

        /** @type {!Array.<Function>} */
        var runBlocks = [];

        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);

        /** @type {angular.Module} */
        var moduleInstance = {
          // Private state
          _invokeQueue: invokeQueue,
          _configBlocks: configBlocks,
          _runBlocks: runBlocks,

          /**
           * @ngdoc property
           * @name angular.Module#requires
           * @module ng
           *
           * @description
           * Holds the list of modules which the injector will load before the current module is
           * loaded.
           */
          requires: requires,

          /**
           * @ngdoc property
           * @name angular.Module#name
           * @module ng
           *
           * @description
           * Name of the module.
           */
          name: name,


          /**
           * @ngdoc method
           * @name angular.Module#provider
           * @module ng
           * @param {string} name service name
           * @param {Function} providerType Construction function for creating new instance of the
           *                                service.
           * @description
           * See {@link auto.$provide#provider $provide.provider()}.
           */
          provider: invokeLaterAndSetModuleName('$provide', 'provider'),

          /**
           * @ngdoc method
           * @name angular.Module#factory
           * @module ng
           * @param {string} name service name
           * @param {Function} providerFunction Function for creating new instance of the service.
           * @description
           * See {@link auto.$provide#factory $provide.factory()}.
           */
          factory: invokeLaterAndSetModuleName('$provide', 'factory'),

          /**
           * @ngdoc method
           * @name angular.Module#service
           * @module ng
           * @param {string} name service name
           * @param {Function} constructor A constructor function that will be instantiated.
           * @description
           * See {@link auto.$provide#service $provide.service()}.
           */
          service: invokeLaterAndSetModuleName('$provide', 'service'),

          /**
           * @ngdoc method
           * @name angular.Module#value
           * @module ng
           * @param {string} name service name
           * @param {*} object Service instance object.
           * @description
           * See {@link auto.$provide#value $provide.value()}.
           */
          value: invokeLater('$provide', 'value'),

          /**
           * @ngdoc method
           * @name angular.Module#constant
           * @module ng
           * @param {string} name constant name
           * @param {*} object Constant value.
           * @description
           * Because the constant are fixed, they get applied before other provide methods.
           * See {@link auto.$provide#constant $provide.constant()}.
           */
          constant: invokeLater('$provide', 'constant', 'unshift'),

           /**
           * @ngdoc method
           * @name angular.Module#decorator
           * @module ng
           * @param {string} The name of the service to decorate.
           * @param {Function} This function will be invoked when the service needs to be
           *                                    instantiated and should return the decorated service instance.
           * @description
           * See {@link auto.$provide#decorator $provide.decorator()}.
           */
          decorator: invokeLaterAndSetModuleName('$provide', 'decorator'),

          /**
           * @ngdoc method
           * @name angular.Module#animation
           * @module ng
           * @param {string} name animation name
           * @param {Function} animationFactory Factory function for creating new instance of an
           *                                    animation.
           * @description
           *
           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
           *
           *
           * Defines an animation hook that can be later used with
           * {@link $animate $animate} service and directives that use this service.
           *
           * ```js
           * module.animation('.animation-name', function($inject1, $inject2) {
           *   return {
           *     eventName : function(element, done) {
           *       //code to run the animation
           *       //once complete, then run done()
           *       return function cancellationFunction(element) {
           *         //code to cancel the animation
           *       }
           *     }
           *   }
           * })
           * ```
           *
           * See {@link ng.$animateProvider#register $animateProvider.register()} and
           * {@link ngAnimate ngAnimate module} for more information.
           */
          animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),

          /**
           * @ngdoc method
           * @name angular.Module#filter
           * @module ng
           * @param {string} name Filter name - this must be a valid angular expression identifier
           * @param {Function} filterFactory Factory function for creating new instance of filter.
           * @description
           * See {@link ng.$filterProvider#register $filterProvider.register()}.
           *
           * <div class="alert alert-warning">
           * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
           * (`myapp_subsection_filterx`).
           * </div>
           */
          filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),

          /**
           * @ngdoc method
           * @name angular.Module#controller
           * @module ng
           * @param {string|Object} name Controller name, or an object map of controllers where the
           *    keys are the names and the values are the constructors.
           * @param {Function} constructor Controller constructor function.
           * @description
           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
           */
          controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),

          /**
           * @ngdoc method
           * @name angular.Module#directive
           * @module ng
           * @param {string|Object} name Directive name, or an object map of directives where the
           *    keys are the names and the values are the factories.
           * @param {Function} directiveFactory Factory function for creating new instance of
           * directives.
           * @description
           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
           */
          directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),

          /**
           * @ngdoc method
           * @name angular.Module#config
           * @module ng
           * @param {Function} configFn Execute this function on module load. Useful for service
           *    configuration.
           * @description
           * Use this method to register work which needs to be performed on module loading.
           * For more about how to configure services, see
           * {@link providers#provider-recipe Provider Recipe}.
           */
          config: config,

          /**
           * @ngdoc method
           * @name angular.Module#run
           * @module ng
           * @param {Function} initializationFn Execute this function after injector creation.
           *    Useful for application initialization.
           * @description
           * Use this method to register work which should be performed when the injector is done
           * loading all modules.
           */
          run: function(block) {
            runBlocks.push(block);
            return this;
          }
        };

        if (configFn) {
          config(configFn);
        }

        return moduleInstance;

        /**
         * @param {string} provider
         * @param {string} method
         * @param {String=} insertMethod
         * @returns {angular.Module}
         */
        function invokeLater(provider, method, insertMethod, queue) {
          if (!queue) queue = invokeQueue;
          return function() {
            queue[insertMethod || 'push']([provider, method, arguments]);
            return moduleInstance;
          };
        }

        /**
         * @param {string} provider
         * @param {string} method
         * @returns {angular.Module}
         */
        function invokeLaterAndSetModuleName(provider, method) {
          return function(recipeName, factoryFunction) {
            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
            invokeQueue.push([provider, method, arguments]);
            return moduleInstance;
          };
        }
      });
    };
  });

}

/* global: toDebugString: true */

function serializeObject(obj) {
  var seen = [];

  return JSON.stringify(obj, function(key, val) {
    val = toJsonReplacer(key, val);
    if (isObject(val)) {

      if (seen.indexOf(val) >= 0) return '<<already seen>>';

      seen.push(val);
    }
    return val;
  });
}

function toDebugString(obj) {
  if (typeof obj === 'function') {
    return obj.toString().replace(/ \{[\s\S]*$/, '');
  } else if (typeof obj === 'undefined') {
    return 'undefined';
  } else if (typeof obj !== 'string') {
    return serializeObject(obj);
  }
  return obj;
}

/* global angularModule: true,
  version: true,

  $LocaleProvider,
  $CompileProvider,

  htmlAnchorDirective,
  inputDirective,
  inputDirective,
  formDirective,
  scriptDirective,
  selectDirective,
  styleDirective,
  optionDirective,
  ngBindDirective,
  ngBindHtmlDirective,
  ngBindTemplateDirective,
  ngClassDirective,
  ngClassEvenDirective,
  ngClassOddDirective,
  ngCspDirective,
  ngCloakDirective,
  ngControllerDirective,
  ngFormDirective,
  ngHideDirective,
  ngIfDirective,
  ngIncludeDirective,
  ngIncludeFillContentDirective,
  ngInitDirective,
  ngNonBindableDirective,
  ngPluralizeDirective,
  ngRepeatDirective,
  ngShowDirective,
  ngStyleDirective,
  ngSwitchDirective,
  ngSwitchWhenDirective,
  ngSwitchDefaultDirective,
  ngOptionsDirective,
  ngTranscludeDirective,
  ngModelDirective,
  ngListDirective,
  ngChangeDirective,
  patternDirective,
  patternDirective,
  requiredDirective,
  requiredDirective,
  minlengthDirective,
  minlengthDirective,
  maxlengthDirective,
  maxlengthDirective,
  ngValueDirective,
  ngModelOptionsDirective,
  ngAttributeAliasDirectives,
  ngEventDirectives,

  $AnchorScrollProvider,
  $AnimateProvider,
  $$CoreAnimateQueueProvider,
  $$CoreAnimateRunnerProvider,
  $BrowserProvider,
  $CacheFactoryProvider,
  $ControllerProvider,
  $DocumentProvider,
  $ExceptionHandlerProvider,
  $FilterProvider,
  $InterpolateProvider,
  $IntervalProvider,
  $$HashMapProvider,
  $HttpProvider,
  $HttpParamSerializerProvider,
  $HttpParamSerializerJQLikeProvider,
  $HttpBackendProvider,
  $LocationProvider,
  $LogProvider,
  $ParseProvider,
  $RootScopeProvider,
  $QProvider,
  $$QProvider,
  $$SanitizeUriProvider,
  $SceProvider,
  $SceDelegateProvider,
  $SnifferProvider,
  $TemplateCacheProvider,
  $TemplateRequestProvider,
  $$TestabilityProvider,
  $TimeoutProvider,
  $$RAFProvider,
  $$AsyncCallbackProvider,
  $WindowProvider,
  $$jqLiteProvider,
  $$CookieReaderProvider
*/


/**
 * @ngdoc object
 * @name angular.version
 * @module ng
 * @description
 * An object that contains information about the current AngularJS version. This object has the
 * following properties:
 *
 * - `full` – `{string}` – Full version string, such as "0.9.18".
 * - `major` – `{number}` – Major version number, such as "0".
 * - `minor` – `{number}` – Minor version number, such as "9".
 * - `dot` – `{number}` – Dot version number, such as "18".
 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
 */
var version = {
  full: '1.4.1',    // all of these placeholder strings will be replaced by grunt's
  major: 1,    // package task
  minor: 4,
  dot: 1,
  codeName: 'hyperionic-illumination'
};


function publishExternalAPI(angular) {
  extend(angular, {
    'bootstrap': bootstrap,
    'copy': copy,
    'extend': extend,
    'merge': merge,
    'equals': equals,
    'element': jqLite,
    'forEach': forEach,
    'injector': createInjector,
    'noop': noop,
    'bind': bind,
    'toJson': toJson,
    'fromJson': fromJson,
    'identity': identity,
    'isUndefined': isUndefined,
    'isDefined': isDefined,
    'isString': isString,
    'isFunction': isFunction,
    'isObject': isObject,
    'isNumber': isNumber,
    'isElement': isElement,
    'isArray': isArray,
    'version': version,
    'isDate': isDate,
    'lowercase': lowercase,
    'uppercase': uppercase,
    'callbacks': {counter: 0},
    'getTestability': getTestability,
    '$$minErr': minErr,
    '$$csp': csp,
    'reloadWithDebugInfo': reloadWithDebugInfo
  });

  angularModule = setupModuleLoader(window);
  try {
    angularModule('ngLocale');
  } catch (e) {
    angularModule('ngLocale', []).provider('$locale', $LocaleProvider);
  }

  angularModule('ng', ['ngLocale'], ['$provide',
    function ngModule($provide) {
      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
      $provide.provider({
        $$sanitizeUri: $$SanitizeUriProvider
      });
      $provide.provider('$compile', $CompileProvider).
        directive({
            a: htmlAnchorDirective,
            input: inputDirective,
            textarea: inputDirective,
            form: formDirective,
            script: scriptDirective,
            select: selectDirective,
            style: styleDirective,
            option: optionDirective,
            ngBind: ngBindDirective,
            ngBindHtml: ngBindHtmlDirective,
            ngBindTemplate: ngBindTemplateDirective,
            ngClass: ngClassDirective,
            ngClassEven: ngClassEvenDirective,
            ngClassOdd: ngClassOddDirective,
            ngCloak: ngCloakDirective,
            ngController: ngControllerDirective,
            ngForm: ngFormDirective,
            ngHide: ngHideDirective,
            ngIf: ngIfDirective,
            ngInclude: ngIncludeDirective,
            ngInit: ngInitDirective,
            ngNonBindable: ngNonBindableDirective,
            ngPluralize: ngPluralizeDirective,
            ngRepeat: ngRepeatDirective,
            ngShow: ngShowDirective,
            ngStyle: ngStyleDirective,
            ngSwitch: ngSwitchDirective,
            ngSwitchWhen: ngSwitchWhenDirective,
            ngSwitchDefault: ngSwitchDefaultDirective,
            ngOptions: ngOptionsDirective,
            ngTransclude: ngTranscludeDirective,
            ngModel: ngModelDirective,
            ngList: ngListDirective,
            ngChange: ngChangeDirective,
            pattern: patternDirective,
            ngPattern: patternDirective,
            required: requiredDirective,
            ngRequired: requiredDirective,
            minlength: minlengthDirective,
            ngMinlength: minlengthDirective,
            maxlength: maxlengthDirective,
            ngMaxlength: maxlengthDirective,
            ngValue: ngValueDirective,
            ngModelOptions: ngModelOptionsDirective
        }).
        directive({
          ngInclude: ngIncludeFillContentDirective
        }).
        directive(ngAttributeAliasDirectives).
        directive(ngEventDirectives);
      $provide.provider({
        $anchorScroll: $AnchorScrollProvider,
        $animate: $AnimateProvider,
        $$animateQueue: $$CoreAnimateQueueProvider,
        $$AnimateRunner: $$CoreAnimateRunnerProvider,
        $browser: $BrowserProvider,
        $cacheFactory: $CacheFactoryProvider,
        $controller: $ControllerProvider,
        $document: $DocumentProvider,
        $exceptionHandler: $ExceptionHandlerProvider,
        $filter: $FilterProvider,
        $interpolate: $InterpolateProvider,
        $interval: $IntervalProvider,
        $http: $HttpProvider,
        $httpParamSerializer: $HttpParamSerializerProvider,
        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
        $httpBackend: $HttpBackendProvider,
        $location: $LocationProvider,
        $log: $LogProvider,
        $parse: $ParseProvider,
        $rootScope: $RootScopeProvider,
        $q: $QProvider,
        $$q: $$QProvider,
        $sce: $SceProvider,
        $sceDelegate: $SceDelegateProvider,
        $sniffer: $SnifferProvider,
        $templateCache: $TemplateCacheProvider,
        $templateRequest: $TemplateRequestProvider,
        $$testability: $$TestabilityProvider,
        $timeout: $TimeoutProvider,
        $window: $WindowProvider,
        $$rAF: $$RAFProvider,
        $$asyncCallback: $$AsyncCallbackProvider,
        $$jqLite: $$jqLiteProvider,
        $$HashMap: $$HashMapProvider,
        $$cookieReader: $$CookieReaderProvider
      });
    }
  ]);
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

/* global JQLitePrototype: true,
  addEventListenerFn: true,
  removeEventListenerFn: true,
  BOOLEAN_ATTR: true,
  ALIASED_ATTR: true,
*/

//////////////////////////////////
//JQLite
//////////////////////////////////

/**
 * @ngdoc function
 * @name angular.element
 * @module ng
 * @kind function
 *
 * @description
 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
 *
 * If jQuery is available, `angular.element` is an alias for the
 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
 * delegates to Angular's built-in subset of jQuery, called "jQuery lite" or "jqLite."
 *
 * <div class="alert alert-success">jqLite is a tiny, API-compatible subset of jQuery that allows
 * Angular to manipulate the DOM in a cross-browser compatible way. **jqLite** implements only the most
 * commonly needed functionality with the goal of having a very small footprint.</div>
 *
 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file.
 *
 * <div class="alert">**Note:** all element references in Angular are always wrapped with jQuery or
 * jqLite; they are never raw DOM references.</div>
 *
 * ## Angular's jqLite
 * jqLite provides only the following jQuery methods:
 *
 * - [`addClass()`](http://api.jquery.com/addClass/)
 * - [`after()`](http://api.jquery.com/after/)
 * - [`append()`](http://api.jquery.com/append/)
 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
 * - [`bind()`](http://api.jquery.com/bind/) - Does not support namespaces, selectors or eventData
 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
 * - [`clone()`](http://api.jquery.com/clone/)
 * - [`contents()`](http://api.jquery.com/contents/)
 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`. As a setter, does not convert numbers to strings or append 'px'.
 * - [`data()`](http://api.jquery.com/data/)
 * - [`detach()`](http://api.jquery.com/detach/)
 * - [`empty()`](http://api.jquery.com/empty/)
 * - [`eq()`](http://api.jquery.com/eq/)
 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
 * - [`hasClass()`](http://api.jquery.com/hasClass/)
 * - [`html()`](http://api.jquery.com/html/)
 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces or selectors
 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
 * - [`prepend()`](http://api.jquery.com/prepend/)
 * - [`prop()`](http://api.jquery.com/prop/)
 * - [`ready()`](http://api.jquery.com/ready/)
 * - [`remove()`](http://api.jquery.com/remove/)
 * - [`removeAttr()`](http://api.jquery.com/removeAttr/)
 * - [`removeClass()`](http://api.jquery.com/removeClass/)
 * - [`removeData()`](http://api.jquery.com/removeData/)
 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
 * - [`text()`](http://api.jquery.com/text/)
 * - [`toggleClass()`](http://api.jquery.com/toggleClass/)
 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers.
 * - [`unbind()`](http://api.jquery.com/unbind/) - Does not support namespaces
 * - [`val()`](http://api.jquery.com/val/)
 * - [`wrap()`](http://api.jquery.com/wrap/)
 *
 * ## jQuery/jqLite Extras
 * Angular also provides the following additional methods and events to both jQuery and jqLite:
 *
 * ### Events
 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
 *    element before it is removed.
 *
 * ### Methods
 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
 *   `'ngModel'`).
 * - `injector()` - retrieves the injector of the current element or its parent.
 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
 *   be enabled.
 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
 *   parent element is reached.
 *
 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
 * @returns {Object} jQuery object.
 */

JQLite.expando = 'ng339';

var jqCache = JQLite.cache = {},
    jqId = 1,
    addEventListenerFn = function(element, type, fn) {
      element.addEventListener(type, fn, false);
    },
    removeEventListenerFn = function(element, type, fn) {
      element.removeEventListener(type, fn, false);
    };

/*
 * !!! This is an undocumented "private" function !!!
 */
JQLite._data = function(node) {
  //jQuery always returns an object on cache miss
  return this.cache[node[this.expando]] || {};
};

function jqNextId() { return ++jqId; }


var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
var MOZ_HACK_REGEXP = /^moz([A-Z])/;
var MOUSE_EVENT_MAP= { mouseleave: "mouseout", mouseenter: "mouseover"};
var jqLiteMinErr = minErr('jqLite');

/**
 * Converts snake_case to camelCase.
 * Also there is special case for Moz prefix starting with upper case letter.
 * @param name Name to normalize
 */
function camelCase(name) {
  return name.
    replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
      return offset ? letter.toUpperCase() : letter;
    }).
    replace(MOZ_HACK_REGEXP, 'Moz$1');
}

var SINGLE_TAG_REGEXP = /^<(\w+)\s*\/?>(?:<\/\1>|)$/;
var HTML_REGEXP = /<|&#?\w+;/;
var TAG_NAME_REGEXP = /<([\w:]+)/;
var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi;

var wrapMap = {
  'option': [1, '<select multiple="multiple">', '</select>'],

  'thead': [1, '<table>', '</table>'],
  'col': [2, '<table><colgroup>', '</colgroup></table>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],
  'td': [3, '<table><tbody><tr>', '</tr></tbody></table>'],
  '_default': [0, "", ""]
};

wrapMap.optgroup = wrapMap.option;
wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function jqLiteIsTextNode(html) {
  return !HTML_REGEXP.test(html);
}

function jqLiteAcceptsData(node) {
  // The window object can accept data but has no nodeType
  // Otherwise we are only interested in elements (1) and documents (9)
  var nodeType = node.nodeType;
  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
}

function jqLiteHasData(node) {
  for (var key in jqCache[node.ng339]) {
    return true;
  }
  return false;
}

function jqLiteBuildFragment(html, context) {
  var tmp, tag, wrap,
      fragment = context.createDocumentFragment(),
      nodes = [], i;

  if (jqLiteIsTextNode(html)) {
    // Convert non-html into a text node
    nodes.push(context.createTextNode(html));
  } else {
    // Convert html into DOM nodes
    tmp = tmp || fragment.appendChild(context.createElement("div"));
    tag = (TAG_NAME_REGEXP.exec(html) || ["", ""])[1].toLowerCase();
    wrap = wrapMap[tag] || wrapMap._default;
    tmp.innerHTML = wrap[1] + html.replace(XHTML_TAG_REGEXP, "<$1></$2>") + wrap[2];

    // Descend through wrappers to the right content
    i = wrap[0];
    while (i--) {
      tmp = tmp.lastChild;
    }

    nodes = concat(nodes, tmp.childNodes);

    tmp = fragment.firstChild;
    tmp.textContent = "";
  }

  // Remove wrapper from fragment
  fragment.textContent = "";
  fragment.innerHTML = ""; // Clear inner HTML
  forEach(nodes, function(node) {
    fragment.appendChild(node);
  });

  return fragment;
}

function jqLiteParseHTML(html, context) {
  context = context || document;
  var parsed;

  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
    return [context.createElement(parsed[1])];
  }

  if ((parsed = jqLiteBuildFragment(html, context))) {
    return parsed.childNodes;
  }

  return [];
}

/////////////////////////////////////////////
function JQLite(element) {
  if (element instanceof JQLite) {
    return element;
  }

  var argIsString;

  if (isString(element)) {
    element = trim(element);
    argIsString = true;
  }
  if (!(this instanceof JQLite)) {
    if (argIsString && element.charAt(0) != '<') {
      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
    }
    return new JQLite(element);
  }

  if (argIsString) {
    jqLiteAddNodes(this, jqLiteParseHTML(element));
  } else {
    jqLiteAddNodes(this, element);
  }
}

function jqLiteClone(element) {
  return element.cloneNode(true);
}

function jqLiteDealoc(element, onlyDescendants) {
  if (!onlyDescendants) jqLiteRemoveData(element);

  if (element.querySelectorAll) {
    var descendants = element.querySelectorAll('*');
    for (var i = 0, l = descendants.length; i < l; i++) {
      jqLiteRemoveData(descendants[i]);
    }
  }
}

function jqLiteOff(element, type, fn, unsupported) {
  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');

  var expandoStore = jqLiteExpandoStore(element);
  var events = expandoStore && expandoStore.events;
  var handle = expandoStore && expandoStore.handle;

  if (!handle) return; //no listeners registered

  if (!type) {
    for (type in events) {
      if (type !== '$destroy') {
        removeEventListenerFn(element, type, handle);
      }
      delete events[type];
    }
  } else {
    forEach(type.split(' '), function(type) {
      if (isDefined(fn)) {
        var listenerFns = events[type];
        arrayRemove(listenerFns || [], fn);
        if (listenerFns && listenerFns.length > 0) {
          return;
        }
      }

      removeEventListenerFn(element, type, handle);
      delete events[type];
    });
  }
}

function jqLiteRemoveData(element, name) {
  var expandoId = element.ng339;
  var expandoStore = expandoId && jqCache[expandoId];

  if (expandoStore) {
    if (name) {
      delete expandoStore.data[name];
      return;
    }

    if (expandoStore.handle) {
      if (expandoStore.events.$destroy) {
        expandoStore.handle({}, '$destroy');
      }
      jqLiteOff(element);
    }
    delete jqCache[expandoId];
    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
  }
}


function jqLiteExpandoStore(element, createIfNecessary) {
  var expandoId = element.ng339,
      expandoStore = expandoId && jqCache[expandoId];

  if (createIfNecessary && !expandoStore) {
    element.ng339 = expandoId = jqNextId();
    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
  }

  return expandoStore;
}


function jqLiteData(element, key, value) {
  if (jqLiteAcceptsData(element)) {

    var isSimpleSetter = isDefined(value);
    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
    var massGetter = !key;
    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
    var data = expandoStore && expandoStore.data;

    if (isSimpleSetter) { // data('key', value)
      data[key] = value;
    } else {
      if (massGetter) {  // data()
        return data;
      } else {
        if (isSimpleGetter) { // data('key')
          // don't force creation of expandoStore if it doesn't exist yet
          return data && data[key];
        } else { // mass-setter: data({key1: val1, key2: val2})
          extend(data, key);
        }
      }
    }
  }
}

function jqLiteHasClass(element, selector) {
  if (!element.getAttribute) return false;
  return ((" " + (element.getAttribute('class') || '') + " ").replace(/[\n\t]/g, " ").
      indexOf(" " + selector + " ") > -1);
}

function jqLiteRemoveClass(element, cssClasses) {
  if (cssClasses && element.setAttribute) {
    forEach(cssClasses.split(' '), function(cssClass) {
      element.setAttribute('class', trim(
          (" " + (element.getAttribute('class') || '') + " ")
          .replace(/[\n\t]/g, " ")
          .replace(" " + trim(cssClass) + " ", " "))
      );
    });
  }
}

function jqLiteAddClass(element, cssClasses) {
  if (cssClasses && element.setAttribute) {
    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
                            .replace(/[\n\t]/g, " ");

    forEach(cssClasses.split(' '), function(cssClass) {
      cssClass = trim(cssClass);
      if (existingClasses.indexOf(' ' + cssClass + ' ') === -1) {
        existingClasses += cssClass + ' ';
      }
    });

    element.setAttribute('class', trim(existingClasses));
  }
}


function jqLiteAddNodes(root, elements) {
  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.

  if (elements) {

    // if a Node (the most common case)
    if (elements.nodeType) {
      root[root.length++] = elements;
    } else {
      var length = elements.length;

      // if an Array or NodeList and not a Window
      if (typeof length === 'number' && elements.window !== elements) {
        if (length) {
          for (var i = 0; i < length; i++) {
            root[root.length++] = elements[i];
          }
        }
      } else {
        root[root.length++] = elements;
      }
    }
  }
}


function jqLiteController(element, name) {
  return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
}

function jqLiteInheritedData(element, name, value) {
  // if element is the document object work with the html element instead
  // this makes $(document).scope() possible
  if (element.nodeType == NODE_TYPE_DOCUMENT) {
    element = element.documentElement;
  }
  var names = isArray(name) ? name : [name];

  while (element) {
    for (var i = 0, ii = names.length; i < ii; i++) {
      if ((value = jqLite.data(element, names[i])) !== undefined) return value;
    }

    // If dealing with a document fragment node with a host element, and no parent, use the host
    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
    // to lookup parent controllers.
    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
  }
}

function jqLiteEmpty(element) {
  jqLiteDealoc(element, true);
  while (element.firstChild) {
    element.removeChild(element.firstChild);
  }
}

function jqLiteRemove(element, keepData) {
  if (!keepData) jqLiteDealoc(element);
  var parent = element.parentNode;
  if (parent) parent.removeChild(element);
}


function jqLiteDocumentLoaded(action, win) {
  win = win || window;
  if (win.document.readyState === 'complete') {
    // Force the action to be run async for consistent behaviour
    // from the action's point of view
    // i.e. it will definitely not be in a $apply
    win.setTimeout(action);
  } else {
    // No need to unbind this handler as load is only ever called once
    jqLite(win).on('load', action);
  }
}

//////////////////////////////////////////
// Functions which are declared directly.
//////////////////////////////////////////
var JQLitePrototype = JQLite.prototype = {
  ready: function(fn) {
    var fired = false;

    function trigger() {
      if (fired) return;
      fired = true;
      fn();
    }

    // check if document is already loaded
    if (document.readyState === 'complete') {
      setTimeout(trigger);
    } else {
      this.on('DOMContentLoaded', trigger); // works for modern browsers and IE9
      // we can not use jqLite since we are not done loading and jQuery could be loaded later.
      // jshint -W064
      JQLite(window).on('load', trigger); // fallback to window.onload for others
      // jshint +W064
    }
  },
  toString: function() {
    var value = [];
    forEach(this, function(e) { value.push('' + e);});
    return '[' + value.join(', ') + ']';
  },

  eq: function(index) {
      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
  },

  length: 0,
  push: push,
  sort: [].sort,
  splice: [].splice
};

//////////////////////////////////////////
// Functions iterating getter/setters.
// these functions return self on setter and
// value on get.
//////////////////////////////////////////
var BOOLEAN_ATTR = {};
forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
  BOOLEAN_ATTR[lowercase(value)] = value;
});
var BOOLEAN_ELEMENTS = {};
forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
  BOOLEAN_ELEMENTS[value] = true;
});
var ALIASED_ATTR = {
  'ngMinlength': 'minlength',
  'ngMaxlength': 'maxlength',
  'ngMin': 'min',
  'ngMax': 'max',
  'ngPattern': 'pattern'
};

function getBooleanAttrName(element, name) {
  // check dom last since we will most likely fail on name
  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];

  // booleanAttr is here twice to minimize DOM access
  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
}

function getAliasedAttrName(element, name) {
  var nodeName = element.nodeName;
  return (nodeName === 'INPUT' || nodeName === 'TEXTAREA') && ALIASED_ATTR[name];
}

forEach({
  data: jqLiteData,
  removeData: jqLiteRemoveData,
  hasData: jqLiteHasData
}, function(fn, name) {
  JQLite[name] = fn;
});

forEach({
  data: jqLiteData,
  inheritedData: jqLiteInheritedData,

  scope: function(element) {
    // Can't use jqLiteData here directly so we stay compatible with jQuery!
    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
  },

  isolateScope: function(element) {
    // Can't use jqLiteData here directly so we stay compatible with jQuery!
    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
  },

  controller: jqLiteController,

  injector: function(element) {
    return jqLiteInheritedData(element, '$injector');
  },

  removeAttr: function(element, name) {
    element.removeAttribute(name);
  },

  hasClass: jqLiteHasClass,

  css: function(element, name, value) {
    name = camelCase(name);

    if (isDefined(value)) {
      element.style[name] = value;
    } else {
      return element.style[name];
    }
  },

  attr: function(element, name, value) {
    var nodeType = element.nodeType;
    if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT) {
      return;
    }
    var lowercasedName = lowercase(name);
    if (BOOLEAN_ATTR[lowercasedName]) {
      if (isDefined(value)) {
        if (!!value) {
          element[name] = true;
          element.setAttribute(name, lowercasedName);
        } else {
          element[name] = false;
          element.removeAttribute(lowercasedName);
        }
      } else {
        return (element[name] ||
                 (element.attributes.getNamedItem(name) || noop).specified)
               ? lowercasedName
               : undefined;
      }
    } else if (isDefined(value)) {
      element.setAttribute(name, value);
    } else if (element.getAttribute) {
      // the extra argument "2" is to get the right thing for a.href in IE, see jQuery code
      // some elements (e.g. Document) don't have get attribute, so return undefined
      var ret = element.getAttribute(name, 2);
      // normalize non-existing attributes to undefined (as jQuery)
      return ret === null ? undefined : ret;
    }
  },

  prop: function(element, name, value) {
    if (isDefined(value)) {
      element[name] = value;
    } else {
      return element[name];
    }
  },

  text: (function() {
    getText.$dv = '';
    return getText;

    function getText(element, value) {
      if (isUndefined(value)) {
        var nodeType = element.nodeType;
        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
      }
      element.textContent = value;
    }
  })(),

  val: function(element, value) {
    if (isUndefined(value)) {
      if (element.multiple && nodeName_(element) === 'select') {
        var result = [];
        forEach(element.options, function(option) {
          if (option.selected) {
            result.push(option.value || option.text);
          }
        });
        return result.length === 0 ? null : result;
      }
      return element.value;
    }
    element.value = value;
  },

  html: function(element, value) {
    if (isUndefined(value)) {
      return element.innerHTML;
    }
    jqLiteDealoc(element, true);
    element.innerHTML = value;
  },

  empty: jqLiteEmpty
}, function(fn, name) {
  /**
   * Properties: writes return selection, reads return first value
   */
  JQLite.prototype[name] = function(arg1, arg2) {
    var i, key;
    var nodeCount = this.length;

    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
    // in a way that survives minification.
    // jqLiteEmpty takes no arguments but is a setter.
    if (fn !== jqLiteEmpty &&
        (((fn.length == 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2) === undefined)) {
      if (isObject(arg1)) {

        // we are a write, but the object properties are the key/values
        for (i = 0; i < nodeCount; i++) {
          if (fn === jqLiteData) {
            // data() takes the whole object in jQuery
            fn(this[i], arg1);
          } else {
            for (key in arg1) {
              fn(this[i], key, arg1[key]);
            }
          }
        }
        // return self for chaining
        return this;
      } else {
        // we are a read, so read the first child.
        // TODO: do we still need this?
        var value = fn.$dv;
        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
        var jj = (value === undefined) ? Math.min(nodeCount, 1) : nodeCount;
        for (var j = 0; j < jj; j++) {
          var nodeValue = fn(this[j], arg1, arg2);
          value = value ? value + nodeValue : nodeValue;
        }
        return value;
      }
    } else {
      // we are a write, so apply to all children
      for (i = 0; i < nodeCount; i++) {
        fn(this[i], arg1, arg2);
      }
      // return self for chaining
      return this;
    }
  };
});

function createEventHandler(element, events) {
  var eventHandler = function(event, type) {
    // jQuery specific api
    event.isDefaultPrevented = function() {
      return event.defaultPrevented;
    };

    var eventFns = events[type || event.type];
    var eventFnsLength = eventFns ? eventFns.length : 0;

    if (!eventFnsLength) return;

    if (isUndefined(event.immediatePropagationStopped)) {
      var originalStopImmediatePropagation = event.stopImmediatePropagation;
      event.stopImmediatePropagation = function() {
        event.immediatePropagationStopped = true;

        if (event.stopPropagation) {
          event.stopPropagation();
        }

        if (originalStopImmediatePropagation) {
          originalStopImmediatePropagation.call(event);
        }
      };
    }

    event.isImmediatePropagationStopped = function() {
      return event.immediatePropagationStopped === true;
    };

    // Copy event handlers in case event handlers array is modified during execution.
    if ((eventFnsLength > 1)) {
      eventFns = shallowCopy(eventFns);
    }

    for (var i = 0; i < eventFnsLength; i++) {
      if (!event.isImmediatePropagationStopped()) {
        eventFns[i].call(element, event);
      }
    }
  };

  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
  //       events on `element`
  eventHandler.elem = element;
  return eventHandler;
}

//////////////////////////////////////////
// Functions iterating traversal.
// These functions chain results into a single
// selector.
//////////////////////////////////////////
forEach({
  removeData: jqLiteRemoveData,

  on: function jqLiteOn(element, type, fn, unsupported) {
    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');

    // Do not add event handlers to non-elements because they will not be cleaned up.
    if (!jqLiteAcceptsData(element)) {
      return;
    }

    var expandoStore = jqLiteExpandoStore(element, true);
    var events = expandoStore.events;
    var handle = expandoStore.handle;

    if (!handle) {
      handle = expandoStore.handle = createEventHandler(element, events);
    }

    // http://jsperf.com/string-indexof-vs-split
    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
    var i = types.length;

    while (i--) {
      type = types[i];
      var eventFns = events[type];

      if (!eventFns) {
        events[type] = [];

        if (type === 'mouseenter' || type === 'mouseleave') {
          // Refer to jQuery's implementation of mouseenter & mouseleave
          // Read about mouseenter and mouseleave:
          // http://www.quirksmode.org/js/events_mouse.html#link8

          jqLiteOn(element, MOUSE_EVENT_MAP[type], function(event) {
            var target = this, related = event.relatedTarget;
            // For mousenter/leave call the handler if related is outside the target.
            // NB: No relatedTarget if the mouse left/entered the browser window
            if (!related || (related !== target && !target.contains(related))) {
              handle(event, type);
            }
          });

        } else {
          if (type !== '$destroy') {
            addEventListenerFn(element, type, handle);
          }
        }
        eventFns = events[type];
      }
      eventFns.push(fn);
    }
  },

  off: jqLiteOff,

  one: function(element, type, fn) {
    element = jqLite(element);

    //add the listener twice so that when it is called
    //you can remove the original function and still be
    //able to call element.off(ev, fn) normally
    element.on(type, function onFn() {
      element.off(type, fn);
      element.off(type, onFn);
    });
    element.on(type, fn);
  },

  replaceWith: function(element, replaceNode) {
    var index, parent = element.parentNode;
    jqLiteDealoc(element);
    forEach(new JQLite(replaceNode), function(node) {
      if (index) {
        parent.insertBefore(node, index.nextSibling);
      } else {
        parent.replaceChild(node, element);
      }
      index = node;
    });
  },

  children: function(element) {
    var children = [];
    forEach(element.childNodes, function(element) {
      if (element.nodeType === NODE_TYPE_ELEMENT) {
        children.push(element);
      }
    });
    return children;
  },

  contents: function(element) {
    return element.contentDocument || element.childNodes || [];
  },

  append: function(element, node) {
    var nodeType = element.nodeType;
    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;

    node = new JQLite(node);

    for (var i = 0, ii = node.length; i < ii; i++) {
      var child = node[i];
      element.appendChild(child);
    }
  },

  prepend: function(element, node) {
    if (element.nodeType === NODE_TYPE_ELEMENT) {
      var index = element.firstChild;
      forEach(new JQLite(node), function(child) {
        element.insertBefore(child, index);
      });
    }
  },

  wrap: function(element, wrapNode) {
    wrapNode = jqLite(wrapNode).eq(0).clone()[0];
    var parent = element.parentNode;
    if (parent) {
      parent.replaceChild(wrapNode, element);
    }
    wrapNode.appendChild(element);
  },

  remove: jqLiteRemove,

  detach: function(element) {
    jqLiteRemove(element, true);
  },

  after: function(element, newElement) {
    var index = element, parent = element.parentNode;
    newElement = new JQLite(newElement);

    for (var i = 0, ii = newElement.length; i < ii; i++) {
      var node = newElement[i];
      parent.insertBefore(node, index.nextSibling);
      index = node;
    }
  },

  addClass: jqLiteAddClass,
  removeClass: jqLiteRemoveClass,

  toggleClass: function(element, selector, condition) {
    if (selector) {
      forEach(selector.split(' '), function(className) {
        var classCondition = condition;
        if (isUndefined(classCondition)) {
          classCondition = !jqLiteHasClass(element, className);
        }
        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
      });
    }
  },

  parent: function(element) {
    var parent = element.parentNode;
    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
  },

  next: function(element) {
    return element.nextElementSibling;
  },

  find: function(element, selector) {
    if (element.getElementsByTagName) {
      return element.getElementsByTagName(selector);
    } else {
      return [];
    }
  },

  clone: jqLiteClone,

  triggerHandler: function(element, event, extraParameters) {

    var dummyEvent, eventFnsCopy, handlerArgs;
    var eventName = event.type || event;
    var expandoStore = jqLiteExpandoStore(element);
    var events = expandoStore && expandoStore.events;
    var eventFns = events && events[eventName];

    if (eventFns) {
      // Create a dummy event to pass to the handlers
      dummyEvent = {
        preventDefault: function() { this.defaultPrevented = true; },
        isDefaultPrevented: function() { return this.defaultPrevented === true; },
        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
        stopPropagation: noop,
        type: eventName,
        target: element
      };

      // If a custom event was provided then extend our dummy event with it
      if (event.type) {
        dummyEvent = extend(dummyEvent, event);
      }

      // Copy event handlers in case event handlers array is modified during execution.
      eventFnsCopy = shallowCopy(eventFns);
      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];

      forEach(eventFnsCopy, function(fn) {
        if (!dummyEvent.isImmediatePropagationStopped()) {
          fn.apply(element, handlerArgs);
        }
      });
    }
  }
}, function(fn, name) {
  /**
   * chaining functions
   */
  JQLite.prototype[name] = function(arg1, arg2, arg3) {
    var value;

    for (var i = 0, ii = this.length; i < ii; i++) {
      if (isUndefined(value)) {
        value = fn(this[i], arg1, arg2, arg3);
        if (isDefined(value)) {
          // any function which returns a value needs to be wrapped
          value = jqLite(value);
        }
      } else {
        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
      }
    }
    return isDefined(value) ? value : this;
  };

  // bind legacy bind/unbind to on/off
  JQLite.prototype.bind = JQLite.prototype.on;
  JQLite.prototype.unbind = JQLite.prototype.off;
});


// Provider for private $$jqLite service
function $$jqLiteProvider() {
  this.$get = function $$jqLite() {
    return extend(JQLite, {
      hasClass: function(node, classes) {
        if (node.attr) node = node[0];
        return jqLiteHasClass(node, classes);
      },
      addClass: function(node, classes) {
        if (node.attr) node = node[0];
        return jqLiteAddClass(node, classes);
      },
      removeClass: function(node, classes) {
        if (node.attr) node = node[0];
        return jqLiteRemoveClass(node, classes);
      }
    });
  };
}

/**
 * Computes a hash of an 'obj'.
 * Hash of a:
 *  string is string
 *  number is number as string
 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
 *         that is also assigned to the $$hashKey property of the object.
 *
 * @param obj
 * @returns {string} hash string such that the same input will have the same hash string.
 *         The resulting string key is in 'type:hashKey' format.
 */
function hashKey(obj, nextUidFn) {
  var key = obj && obj.$$hashKey;

  if (key) {
    if (typeof key === 'function') {
      key = obj.$$hashKey();
    }
    return key;
  }

  var objType = typeof obj;
  if (objType == 'function' || (objType == 'object' && obj !== null)) {
    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
  } else {
    key = objType + ':' + obj;
  }

  return key;
}

/**
 * HashMap which can use objects as keys
 */
function HashMap(array, isolatedUid) {
  if (isolatedUid) {
    var uid = 0;
    this.nextUid = function() {
      return ++uid;
    };
  }
  forEach(array, this.put, this);
}
HashMap.prototype = {
  /**
   * Store key value pair
   * @param key key to store can be any type
   * @param value value to store can be any type
   */
  put: function(key, value) {
    this[hashKey(key, this.nextUid)] = value;
  },

  /**
   * @param key
   * @returns {Object} the value for the key
   */
  get: function(key) {
    return this[hashKey(key, this.nextUid)];
  },

  /**
   * Remove the key/value pair
   * @param key
   */
  remove: function(key) {
    var value = this[key = hashKey(key, this.nextUid)];
    delete this[key];
    return value;
  }
};

var $$HashMapProvider = [function() {
  this.$get = [function() {
    return HashMap;
  }];
}];

/**
 * @ngdoc function
 * @module ng
 * @name angular.injector
 * @kind function
 *
 * @description
 * Creates an injector object that can be used for retrieving services as well as for
 * dependency injection (see {@link guide/di dependency injection}).
 *
 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
 *     {@link angular.module}. The `ng` module must be explicitly added.
 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
 *     disallows argument name annotation inference.
 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
 *
 * @example
 * Typical usage
 * ```js
 *   // create an injector
 *   var $injector = angular.injector(['ng']);
 *
 *   // use the injector to kick off your application
 *   // use the type inference to auto inject arguments, or use implicit injection
 *   $injector.invoke(function($rootScope, $compile, $document) {
 *     $compile($document)($rootScope);
 *     $rootScope.$digest();
 *   });
 * ```
 *
 * Sometimes you want to get access to the injector of a currently running Angular app
 * from outside Angular. Perhaps, you want to inject and compile some markup after the
 * application has been bootstrapped. You can do this using the extra `injector()` added
 * to JQuery/jqLite elements. See {@link angular.element}.
 *
 * *This is fairly rare but could be the case if a third party library is injecting the
 * markup.*
 *
 * In the following example a new block of HTML containing a `ng-controller`
 * directive is added to the end of the document body by JQuery. We then compile and link
 * it into the current AngularJS scope.
 *
 * ```js
 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
 * $(document.body).append($div);
 *
 * angular.element(document).injector().invoke(function($compile) {
 *   var scope = angular.element($div).scope();
 *   $compile($div)(scope);
 * });
 * ```
 */


/**
 * @ngdoc module
 * @name auto
 * @description
 *
 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
 */

var FN_ARGS = /^function\s*[^\(]*\(\s*([^\)]*)\)/m;
var FN_ARG_SPLIT = /,/;
var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
var $injectorMinErr = minErr('$injector');

function anonFn(fn) {
  // For anonymous functions, showing at the very least the function signature can help in
  // debugging.
  var fnText = fn.toString().replace(STRIP_COMMENTS, ''),
      args = fnText.match(FN_ARGS);
  if (args) {
    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
  }
  return 'fn';
}

function annotate(fn, strictDi, name) {
  var $inject,
      fnText,
      argDecl,
      last;

  if (typeof fn === 'function') {
    if (!($inject = fn.$inject)) {
      $inject = [];
      if (fn.length) {
        if (strictDi) {
          if (!isString(name) || !name) {
            name = fn.name || anonFn(fn);
          }
          throw $injectorMinErr('strictdi',
            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
        }
        fnText = fn.toString().replace(STRIP_COMMENTS, '');
        argDecl = fnText.match(FN_ARGS);
        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
          arg.replace(FN_ARG, function(all, underscore, name) {
            $inject.push(name);
          });
        });
      }
      fn.$inject = $inject;
    }
  } else if (isArray(fn)) {
    last = fn.length - 1;
    assertArgFn(fn[last], 'fn');
    $inject = fn.slice(0, last);
  } else {
    assertArgFn(fn, 'fn', true);
  }
  return $inject;
}

///////////////////////////////////////

/**
 * @ngdoc service
 * @name $injector
 *
 * @description
 *
 * `$injector` is used to retrieve object instances as defined by
 * {@link auto.$provide provider}, instantiate types, invoke methods,
 * and load modules.
 *
 * The following always holds true:
 *
 * ```js
 *   var $injector = angular.injector();
 *   expect($injector.get('$injector')).toBe($injector);
 *   expect($injector.invoke(function($injector) {
 *     return $injector;
 *   })).toBe($injector);
 * ```
 *
 * # Injection Function Annotation
 *
 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
 * following are all valid ways of annotating function with injection arguments and are equivalent.
 *
 * ```js
 *   // inferred (only works if code not minified/obfuscated)
 *   $injector.invoke(function(serviceA){});
 *
 *   // annotated
 *   function explicit(serviceA) {};
 *   explicit.$inject = ['serviceA'];
 *   $injector.invoke(explicit);
 *
 *   // inline
 *   $injector.invoke(['serviceA', function(serviceA){}]);
 * ```
 *
 * ## Inference
 *
 * In JavaScript calling `toString()` on a function returns the function definition. The definition
 * can then be parsed and the function arguments can be extracted. This method of discovering
 * annotations is disallowed when the injector is in strict mode.
 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
 * argument names.
 *
 * ## `$inject` Annotation
 * By adding an `$inject` property onto a function the injection parameters can be specified.
 *
 * ## Inline
 * As an array of injection names, where the last item in the array is the function to call.
 */

/**
 * @ngdoc method
 * @name $injector#get
 *
 * @description
 * Return an instance of the service.
 *
 * @param {string} name The name of the instance to retrieve.
 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
 * @return {*} The instance.
 */

/**
 * @ngdoc method
 * @name $injector#invoke
 *
 * @description
 * Invoke the method and supply the method arguments from the `$injector`.
 *
 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
 *   injected according to the {@link guide/di $inject Annotation} rules.
 * @param {Object=} self The `this` for the invoked method.
 * @param {Object=} locals Optional object. If preset then any argument names are read from this
 *                         object first, before the `$injector` is consulted.
 * @returns {*} the value returned by the invoked `fn` function.
 */

/**
 * @ngdoc method
 * @name $injector#has
 *
 * @description
 * Allows the user to query if the particular service exists.
 *
 * @param {string} name Name of the service to query.
 * @returns {boolean} `true` if injector has given service.
 */

/**
 * @ngdoc method
 * @name $injector#instantiate
 * @description
 * Create a new instance of JS type. The method takes a constructor function, invokes the new
 * operator, and supplies all of the arguments to the constructor function as specified by the
 * constructor annotation.
 *
 * @param {Function} Type Annotated constructor function.
 * @param {Object=} locals Optional object. If preset then any argument names are read from this
 * object first, before the `$injector` is consulted.
 * @returns {Object} new instance of `Type`.
 */

/**
 * @ngdoc method
 * @name $injector#annotate
 *
 * @description
 * Returns an array of service names which the function is requesting for injection. This API is
 * used by the injector to determine which services need to be injected into the function when the
 * function is invoked. There are three ways in which the function can be annotated with the needed
 * dependencies.
 *
 * # Argument names
 *
 * The simplest form is to extract the dependencies from the arguments of the function. This is done
 * by converting the function into a string using `toString()` method and extracting the argument
 * names.
 * ```js
 *   // Given
 *   function MyController($scope, $route) {
 *     // ...
 *   }
 *
 *   // Then
 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
 * ```
 *
 * You can disallow this method by using strict injection mode.
 *
 * This method does not work with code minification / obfuscation. For this reason the following
 * annotation strategies are supported.
 *
 * # The `$inject` property
 *
 * If a function has an `$inject` property and its value is an array of strings, then the strings
 * represent names of services to be injected into the function.
 * ```js
 *   // Given
 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
 *     // ...
 *   }
 *   // Define function dependencies
 *   MyController['$inject'] = ['$scope', '$route'];
 *
 *   // Then
 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
 * ```
 *
 * # The array notation
 *
 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
 * is very inconvenient. In these situations using the array notation to specify the dependencies in
 * a way that survives minification is a better choice:
 *
 * ```js
 *   // We wish to write this (not minification / obfuscation safe)
 *   injector.invoke(function($compile, $rootScope) {
 *     // ...
 *   });
 *
 *   // We are forced to write break inlining
 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
 *     // ...
 *   };
 *   tmpFn.$inject = ['$compile', '$rootScope'];
 *   injector.invoke(tmpFn);
 *
 *   // To better support inline function the inline annotation is supported
 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
 *     // ...
 *   }]);
 *
 *   // Therefore
 *   expect(injector.annotate(
 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
 *    ).toEqual(['$compile', '$rootScope']);
 * ```
 *
 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
 * be retrieved as described above.
 *
 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
 *
 * @returns {Array.<string>} The names of the services which the function requires.
 */




/**
 * @ngdoc service
 * @name $provide
 *
 * @description
 *
 * The {@link auto.$provide $provide} service has a number of methods for registering components
 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
 * {@link angular.Module}.
 *
 * An Angular **service** is a singleton object created by a **service factory**.  These **service
 * factories** are functions which, in turn, are created by a **service provider**.
 * The **service providers** are constructor functions. When instantiated they must contain a
 * property called `$get`, which holds the **service factory** function.
 *
 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
 * function to get the instance of the **service**.
 *
 * Often services have no configuration options and there is no need to add methods to the service
 * provider.  The provider will be no more than a constructor function with a `$get` property. For
 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
 * services without specifying a provider.
 *
 * * {@link auto.$provide#provider provider(provider)} - registers a **service provider** with the
 *     {@link auto.$injector $injector}
 * * {@link auto.$provide#constant constant(obj)} - registers a value/object that can be accessed by
 *     providers and services.
 * * {@link auto.$provide#value value(obj)} - registers a value/object that can only be accessed by
 *     services, not providers.
 * * {@link auto.$provide#factory factory(fn)} - registers a service **factory function**, `fn`,
 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
 *     given factory function.
 * * {@link auto.$provide#service service(class)} - registers a **constructor function**, `class`
 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
 *      a new object using the given constructor function.
 *
 * See the individual methods for more information and examples.
 */

/**
 * @ngdoc method
 * @name $provide#provider
 * @description
 *
 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
 * are constructor functions, whose instances are responsible for "providing" a factory for a
 * service.
 *
 * Service provider names start with the name of the service they provide followed by `Provider`.
 * For example, the {@link ng.$log $log} service has a provider called
 * {@link ng.$logProvider $logProvider}.
 *
 * Service provider objects can have additional methods which allow configuration of the provider
 * and its service. Importantly, you can configure what kind of service is created by the `$get`
 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
 * method {@link ng.$logProvider#debugEnabled debugEnabled}
 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
 * console or not.
 *
 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
                        'Provider'` key.
 * @param {(Object|function())} provider If the provider is:
 *
 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
 *   - `Constructor`: a new instance of the provider will be created using
 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
 *
 * @returns {Object} registered provider instance

 * @example
 *
 * The following example shows how to create a simple event tracking service and register it using
 * {@link auto.$provide#provider $provide.provider()}.
 *
 * ```js
 *  // Define the eventTracker provider
 *  function EventTrackerProvider() {
 *    var trackingUrl = '/track';
 *
 *    // A provider method for configuring where the tracked events should been saved
 *    this.setTrackingUrl = function(url) {
 *      trackingUrl = url;
 *    };
 *
 *    // The service factory function
 *    this.$get = ['$http', function($http) {
 *      var trackedEvents = {};
 *      return {
 *        // Call this to track an event
 *        event: function(event) {
 *          var count = trackedEvents[event] || 0;
 *          count += 1;
 *          trackedEvents[event] = count;
 *          return count;
 *        },
 *        // Call this to save the tracked events to the trackingUrl
 *        save: function() {
 *          $http.post(trackingUrl, trackedEvents);
 *        }
 *      };
 *    }];
 *  }
 *
 *  describe('eventTracker', function() {
 *    var postSpy;
 *
 *    beforeEach(module(function($provide) {
 *      // Register the eventTracker provider
 *      $provide.provider('eventTracker', EventTrackerProvider);
 *    }));
 *
 *    beforeEach(module(function(eventTrackerProvider) {
 *      // Configure eventTracker provider
 *      eventTrackerProvider.setTrackingUrl('/custom-track');
 *    }));
 *
 *    it('tracks events', inject(function(eventTracker) {
 *      expect(eventTracker.event('login')).toEqual(1);
 *      expect(eventTracker.event('login')).toEqual(2);
 *    }));
 *
 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
 *      postSpy = spyOn($http, 'post');
 *      eventTracker.event('login');
 *      eventTracker.save();
 *      expect(postSpy).toHaveBeenCalled();
 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
 *    }));
 *  });
 * ```
 */

/**
 * @ngdoc method
 * @name $provide#factory
 * @description
 *
 * Register a **service factory**, which will be called to return the service instance.
 * This is short for registering a service where its provider consists of only a `$get` property,
 * which is the given service factory function.
 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
 * configure your service in a provider.
 *
 * @param {string} name The name of the instance.
 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here is an example of registering a service
 * ```js
 *   $provide.factory('ping', ['$http', function($http) {
 *     return function ping() {
 *       return $http.send('/ping');
 *     };
 *   }]);
 * ```
 * You would then inject and use this service like this:
 * ```js
 *   someModule.controller('Ctrl', ['ping', function(ping) {
 *     ping();
 *   }]);
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#service
 * @description
 *
 * Register a **service constructor**, which will be invoked with `new` to create the service
 * instance.
 * This is short for registering a service where its provider's `$get` property is the service
 * constructor function that will be used to instantiate the service instance.
 *
 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
 * as a type/class.
 *
 * @param {string} name The name of the instance.
 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
 *     that will be instantiated.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here is an example of registering a service using
 * {@link auto.$provide#service $provide.service(class)}.
 * ```js
 *   var Ping = function($http) {
 *     this.$http = $http;
 *   };
 *
 *   Ping.$inject = ['$http'];
 *
 *   Ping.prototype.send = function() {
 *     return this.$http.get('/ping');
 *   };
 *   $provide.service('ping', Ping);
 * ```
 * You would then inject and use this service like this:
 * ```js
 *   someModule.controller('Ctrl', ['ping', function(ping) {
 *     ping.send();
 *   }]);
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#value
 * @description
 *
 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
 * number, an array, an object or a function.  This is short for registering a service where its
 * provider's `$get` property is a factory function that takes no arguments and returns the **value
 * service**.
 *
 * Value services are similar to constant services, except that they cannot be injected into a
 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
 * an Angular
 * {@link auto.$provide#decorator decorator}.
 *
 * @param {string} name The name of the instance.
 * @param {*} value The value.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here are some examples of creating value services.
 * ```js
 *   $provide.value('ADMIN_USER', 'admin');
 *
 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
 *
 *   $provide.value('halfOf', function(value) {
 *     return value / 2;
 *   });
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#constant
 * @description
 *
 * Register a **constant service**, such as a string, a number, an array, an object or a function,
 * with the {@link auto.$injector $injector}. Unlike {@link auto.$provide#value value} it can be
 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
 * be overridden by an Angular {@link auto.$provide#decorator decorator}.
 *
 * @param {string} name The name of the constant.
 * @param {*} value The constant value.
 * @returns {Object} registered instance
 *
 * @example
 * Here a some examples of creating constants:
 * ```js
 *   $provide.constant('SHARD_HEIGHT', 306);
 *
 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
 *
 *   $provide.constant('double', function(value) {
 *     return value * 2;
 *   });
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#decorator
 * @description
 *
 * Register a **service decorator** with the {@link auto.$injector $injector}. A service decorator
 * intercepts the creation of a service, allowing it to override or modify the behaviour of the
 * service. The object returned by the decorator may be the original service, or a new service
 * object which replaces or wraps and delegates to the original service.
 *
 * @param {string} name The name of the service to decorate.
 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
 *    instantiated and should return the decorated service instance. The function is called using
 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
 *    Local injection arguments:
 *
 *    * `$delegate` - The original service instance, which can be monkey patched, configured,
 *      decorated or delegated to.
 *
 * @example
 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
 * calls to {@link ng.$log#error $log.warn()}.
 * ```js
 *   $provide.decorator('$log', ['$delegate', function($delegate) {
 *     $delegate.warn = $delegate.error;
 *     return $delegate;
 *   }]);
 * ```
 */


function createInjector(modulesToLoad, strictDi) {
  strictDi = (strictDi === true);
  var INSTANTIATING = {},
      providerSuffix = 'Provider',
      path = [],
      loadedModules = new HashMap([], true),
      providerCache = {
        $provide: {
            provider: supportObject(provider),
            factory: supportObject(factory),
            service: supportObject(service),
            value: supportObject(value),
            constant: supportObject(constant),
            decorator: decorator
          }
      },
      providerInjector = (providerCache.$injector =
          createInternalInjector(providerCache, function(serviceName, caller) {
            if (angular.isString(caller)) {
              path.push(caller);
            }
            throw $injectorMinErr('unpr', "Unknown provider: {0}", path.join(' <- '));
          })),
      instanceCache = {},
      instanceInjector = (instanceCache.$injector =
          createInternalInjector(instanceCache, function(serviceName, caller) {
            var provider = providerInjector.get(serviceName + providerSuffix, caller);
            return instanceInjector.invoke(provider.$get, provider, undefined, serviceName);
          }));


  forEach(loadModules(modulesToLoad), function(fn) { if (fn) instanceInjector.invoke(fn); });

  return instanceInjector;

  ////////////////////////////////////
  // $provider
  ////////////////////////////////////

  function supportObject(delegate) {
    return function(key, value) {
      if (isObject(key)) {
        forEach(key, reverseParams(delegate));
      } else {
        return delegate(key, value);
      }
    };
  }

  function provider(name, provider_) {
    assertNotHasOwnProperty(name, 'service');
    if (isFunction(provider_) || isArray(provider_)) {
      provider_ = providerInjector.instantiate(provider_);
    }
    if (!provider_.$get) {
      throw $injectorMinErr('pget', "Provider '{0}' must define $get factory method.", name);
    }
    return providerCache[name + providerSuffix] = provider_;
  }

  function enforceReturnValue(name, factory) {
    return function enforcedReturnValue() {
      var result = instanceInjector.invoke(factory, this);
      if (isUndefined(result)) {
        throw $injectorMinErr('undef', "Provider '{0}' must return a value from $get factory method.", name);
      }
      return result;
    };
  }

  function factory(name, factoryFn, enforce) {
    return provider(name, {
      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
    });
  }

  function service(name, constructor) {
    return factory(name, ['$injector', function($injector) {
      return $injector.instantiate(constructor);
    }]);
  }

  function value(name, val) { return factory(name, valueFn(val), false); }

  function constant(name, value) {
    assertNotHasOwnProperty(name, 'constant');
    providerCache[name] = value;
    instanceCache[name] = value;
  }

  function decorator(serviceName, decorFn) {
    var origProvider = providerInjector.get(serviceName + providerSuffix),
        orig$get = origProvider.$get;

    origProvider.$get = function() {
      var origInstance = instanceInjector.invoke(orig$get, origProvider);
      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
    };
  }

  ////////////////////////////////////
  // Module Loading
  ////////////////////////////////////
  function loadModules(modulesToLoad) {
    var runBlocks = [], moduleFn;
    forEach(modulesToLoad, function(module) {
      if (loadedModules.get(module)) return;
      loadedModules.put(module, true);

      function runInvokeQueue(queue) {
        var i, ii;
        for (i = 0, ii = queue.length; i < ii; i++) {
          var invokeArgs = queue[i],
              provider = providerInjector.get(invokeArgs[0]);

          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
        }
      }

      try {
        if (isString(module)) {
          moduleFn = angularModule(module);
          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
          runInvokeQueue(moduleFn._invokeQueue);
          runInvokeQueue(moduleFn._configBlocks);
        } else if (isFunction(module)) {
            runBlocks.push(providerInjector.invoke(module));
        } else if (isArray(module)) {
            runBlocks.push(providerInjector.invoke(module));
        } else {
          assertArgFn(module, 'module');
        }
      } catch (e) {
        if (isArray(module)) {
          module = module[module.length - 1];
        }
        if (e.message && e.stack && e.stack.indexOf(e.message) == -1) {
          // Safari & FF's stack traces don't contain error.message content
          // unlike those of Chrome and IE
          // So if stack doesn't contain message, we create a new string that contains both.
          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
          /* jshint -W022 */
          e = e.message + '\n' + e.stack;
        }
        throw $injectorMinErr('modulerr', "Failed to instantiate module {0} due to:\n{1}",
                  module, e.stack || e.message || e);
      }
    });
    return runBlocks;
  }

  ////////////////////////////////////
  // internal Injector
  ////////////////////////////////////

  function createInternalInjector(cache, factory) {

    function getService(serviceName, caller) {
      if (cache.hasOwnProperty(serviceName)) {
        if (cache[serviceName] === INSTANTIATING) {
          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
                    serviceName + ' <- ' + path.join(' <- '));
        }
        return cache[serviceName];
      } else {
        try {
          path.unshift(serviceName);
          cache[serviceName] = INSTANTIATING;
          return cache[serviceName] = factory(serviceName, caller);
        } catch (err) {
          if (cache[serviceName] === INSTANTIATING) {
            delete cache[serviceName];
          }
          throw err;
        } finally {
          path.shift();
        }
      }
    }

    function invoke(fn, self, locals, serviceName) {
      if (typeof locals === 'string') {
        serviceName = locals;
        locals = null;
      }

      var args = [],
          $inject = createInjector.$$annotate(fn, strictDi, serviceName),
          length, i,
          key;

      for (i = 0, length = $inject.length; i < length; i++) {
        key = $inject[i];
        if (typeof key !== 'string') {
          throw $injectorMinErr('itkn',
                  'Incorrect injection token! Expected service name as string, got {0}', key);
        }
        args.push(
          locals && locals.hasOwnProperty(key)
          ? locals[key]
          : getService(key, serviceName)
        );
      }
      if (isArray(fn)) {
        fn = fn[length];
      }

      // http://jsperf.com/angularjs-invoke-apply-vs-switch
      // #5388
      return fn.apply(self, args);
    }

    function instantiate(Type, locals, serviceName) {
      // Check if Type is annotated and use just the given function at n-1 as parameter
      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
      // Object creation: http://jsperf.com/create-constructor/2
      var instance = Object.create((isArray(Type) ? Type[Type.length - 1] : Type).prototype || null);
      var returnedValue = invoke(Type, instance, locals, serviceName);

      return isObject(returnedValue) || isFunction(returnedValue) ? returnedValue : instance;
    }

    return {
      invoke: invoke,
      instantiate: instantiate,
      get: getService,
      annotate: createInjector.$$annotate,
      has: function(name) {
        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
      }
    };
  }
}

createInjector.$$annotate = annotate;

/**
 * @ngdoc provider
 * @name $anchorScrollProvider
 *
 * @description
 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
 * {@link ng.$location#hash $location.hash()} changes.
 */
function $AnchorScrollProvider() {

  var autoScrollingEnabled = true;

  /**
   * @ngdoc method
   * @name $anchorScrollProvider#disableAutoScrolling
   *
   * @description
   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
   * Use this method to disable automatic scrolling.
   *
   * If automatic scrolling is disabled, one must explicitly call
   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
   * current hash.
   */
  this.disableAutoScrolling = function() {
    autoScrollingEnabled = false;
  };

  /**
   * @ngdoc service
   * @name $anchorScroll
   * @kind function
   * @requires $window
   * @requires $location
   * @requires $rootScope
   *
   * @description
   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
   * in the
   * [HTML5 spec](http://dev.w3.org/html5/spec/Overview.html#the-indicated-part-of-the-document).
   *
   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
   * match any anchor whenever it changes. This can be disabled by calling
   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
   *
   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
   * vertical scroll-offset (either fixed or dynamic).
   *
   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
   *                       {@link ng.$location#hash $location.hash()} will be used.
   *
   * @property {(number|function|jqLite)} yOffset
   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
   * positioned elements at the top of the page, such as navbars, headers etc.
   *
   * `yOffset` can be specified in various ways:
   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
   *   a number representing the offset (in pixels).<br /><br />
   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
   *   the top of the page to the element's bottom will be used as offset.<br />
   *   **Note**: The element will be taken into account only as long as its `position` is set to
   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
   *   their height and/or positioning according to the viewport's size.
   *
   * <br />
   * <div class="alert alert-warning">
   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
   * not some child element.
   * </div>
   *
   * @example
     <example module="anchorScrollExample">
       <file name="index.html">
         <div id="scrollArea" ng-controller="ScrollController">
           <a ng-click="gotoBottom()">Go to bottom</a>
           <a id="bottom"></a> You're at the bottom!
         </div>
       </file>
       <file name="script.js">
         angular.module('anchorScrollExample', [])
           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
             function ($scope, $location, $anchorScroll) {
               $scope.gotoBottom = function() {
                 // set the location.hash to the id of
                 // the element you wish to scroll to.
                 $location.hash('bottom');

                 // call $anchorScroll()
                 $anchorScroll();
               };
             }]);
       </file>
       <file name="style.css">
         #scrollArea {
           height: 280px;
           overflow: auto;
         }

         #bottom {
           display: block;
           margin-top: 2000px;
         }
       </file>
     </example>
   *
   * <hr />
   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
   *
   * @example
     <example module="anchorScrollOffsetExample">
       <file name="index.html">
         <div class="fixed-header" ng-controller="headerCtrl">
           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
             Go to anchor {{x}}
           </a>
         </div>
         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
           Anchor {{x}} of 5
         </div>
       </file>
       <file name="script.js">
         angular.module('anchorScrollOffsetExample', [])
           .run(['$anchorScroll', function($anchorScroll) {
             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
           }])
           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
             function ($anchorScroll, $location, $scope) {
               $scope.gotoAnchor = function(x) {
                 var newHash = 'anchor' + x;
                 if ($location.hash() !== newHash) {
                   // set the $location.hash to `newHash` and
                   // $anchorScroll will automatically scroll to it
                   $location.hash('anchor' + x);
                 } else {
                   // call $anchorScroll() explicitly,
                   // since $location.hash hasn't changed
                   $anchorScroll();
                 }
               };
             }
           ]);
       </file>
       <file name="style.css">
         body {
           padding-top: 50px;
         }

         .anchor {
           border: 2px dashed DarkOrchid;
           padding: 10px 10px 200px 10px;
         }

         .fixed-header {
           background-color: rgba(0, 0, 0, 0.2);
           height: 50px;
           position: fixed;
           top: 0; left: 0; right: 0;
         }

         .fixed-header > a {
           display: inline-block;
           margin: 5px 15px;
         }
       </file>
     </example>
   */
  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
    var document = $window.document;

    // Helper function to get first anchor from a NodeList
    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
    //  and working in all supported browsers.)
    function getFirstAnchor(list) {
      var result = null;
      Array.prototype.some.call(list, function(element) {
        if (nodeName_(element) === 'a') {
          result = element;
          return true;
        }
      });
      return result;
    }

    function getYOffset() {

      var offset = scroll.yOffset;

      if (isFunction(offset)) {
        offset = offset();
      } else if (isElement(offset)) {
        var elem = offset[0];
        var style = $window.getComputedStyle(elem);
        if (style.position !== 'fixed') {
          offset = 0;
        } else {
          offset = elem.getBoundingClientRect().bottom;
        }
      } else if (!isNumber(offset)) {
        offset = 0;
      }

      return offset;
    }

    function scrollTo(elem) {
      if (elem) {
        elem.scrollIntoView();

        var offset = getYOffset();

        if (offset) {
          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
          // top of the viewport.
          //
          // IF the number of pixels from the top of `elem` to the end of the page's content is less
          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
          // way down the page.
          //
          // This is often the case for elements near the bottom of the page.
          //
          // In such cases we do not need to scroll the whole `offset` up, just the difference between
          // the top of the element and the offset, which is enough to align the top of `elem` at the
          // desired position.
          var elemTop = elem.getBoundingClientRect().top;
          $window.scrollBy(0, elemTop - offset);
        }
      } else {
        $window.scrollTo(0, 0);
      }
    }

    function scroll(hash) {
      hash = isString(hash) ? hash : $location.hash();
      var elm;

      // empty hash, scroll to the top of the page
      if (!hash) scrollTo(null);

      // element with given id
      else if ((elm = document.getElementById(hash))) scrollTo(elm);

      // first anchor with given name :-D
      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);

      // no element and hash == 'top', scroll to the top of the page
      else if (hash === 'top') scrollTo(null);
    }

    // does not scroll when user clicks on anchor link that is currently on
    // (no url change, no $location.hash() change), browser native does scroll
    if (autoScrollingEnabled) {
      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
        function autoScrollWatchAction(newVal, oldVal) {
          // skip the initial scroll if $location.hash is empty
          if (newVal === oldVal && newVal === '') return;

          jqLiteDocumentLoaded(function() {
            $rootScope.$evalAsync(scroll);
          });
        });
    }

    return scroll;
  }];
}

var $animateMinErr = minErr('$animate');
var ELEMENT_NODE = 1;
var NG_ANIMATE_CLASSNAME = 'ng-animate';

function mergeClasses(a,b) {
  if (!a && !b) return '';
  if (!a) return b;
  if (!b) return a;
  if (isArray(a)) a = a.join(' ');
  if (isArray(b)) b = b.join(' ');
  return a + ' ' + b;
}

function extractElementNode(element) {
  for (var i = 0; i < element.length; i++) {
    var elm = element[i];
    if (elm.nodeType === ELEMENT_NODE) {
      return elm;
    }
  }
}

function splitClasses(classes) {
  if (isString(classes)) {
    classes = classes.split(' ');
  }

  // Use createMap() to prevent class assumptions involving property names in
  // Object.prototype
  var obj = createMap();
  forEach(classes, function(klass) {
    // sometimes the split leaves empty string values
    // incase extra spaces were applied to the options
    if (klass.length) {
      obj[klass] = true;
    }
  });
  return obj;
}

// if any other type of options value besides an Object value is
// passed into the $animate.method() animation then this helper code
// will be run which will ignore it. While this patch is not the
// greatest solution to this, a lot of existing plugins depend on
// $animate to either call the callback (< 1.2) or return a promise
// that can be changed. This helper function ensures that the options
// are wiped clean incase a callback function is provided.
function prepareAnimateOptions(options) {
  return isObject(options)
      ? options
      : {};
}

var $$CoreAnimateRunnerProvider = function() {
  this.$get = ['$q', '$$rAF', function($q, $$rAF) {
    function AnimateRunner() {}
    AnimateRunner.all = noop;
    AnimateRunner.chain = noop;
    AnimateRunner.prototype = {
      end: noop,
      cancel: noop,
      resume: noop,
      pause: noop,
      complete: noop,
      then: function(pass, fail) {
        return $q(function(resolve) {
          $$rAF(function() {
            resolve();
          });
        }).then(pass, fail);
      }
    };
    return AnimateRunner;
  }];
};

// this is prefixed with Core since it conflicts with
// the animateQueueProvider defined in ngAnimate/animateQueue.js
var $$CoreAnimateQueueProvider = function() {
  var postDigestQueue = new HashMap();
  var postDigestElements = [];

  this.$get = ['$$AnimateRunner', '$rootScope',
       function($$AnimateRunner,   $rootScope) {
    return {
      enabled: noop,
      on: noop,
      off: noop,
      pin: noop,

      push: function(element, event, options, domOperation) {
        domOperation        && domOperation();

        options = options || {};
        options.from        && element.css(options.from);
        options.to          && element.css(options.to);

        if (options.addClass || options.removeClass) {
          addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
        }

        return new $$AnimateRunner(); // jshint ignore:line
      }
    };

    function addRemoveClassesPostDigest(element, add, remove) {
      var data = postDigestQueue.get(element);
      var classVal;

      if (!data) {
        postDigestQueue.put(element, data = {});
        postDigestElements.push(element);
      }

      if (add) {
        forEach(add.split(' '), function(className) {
          if (className) {
            data[className] = true;
          }
        });
      }

      if (remove) {
        forEach(remove.split(' '), function(className) {
          if (className) {
            data[className] = false;
          }
        });
      }

      if (postDigestElements.length > 1) return;

      $rootScope.$$postDigest(function() {
        forEach(postDigestElements, function(element) {
          var data = postDigestQueue.get(element);
          if (data) {
            var existing = splitClasses(element.attr('class'));
            var toAdd = '';
            var toRemove = '';
            forEach(data, function(status, className) {
              var hasClass = !!existing[className];
              if (status !== hasClass) {
                if (status) {
                  toAdd += (toAdd.length ? ' ' : '') + className;
                } else {
                  toRemove += (toRemove.length ? ' ' : '') + className;
                }
              }
            });

            forEach(element, function(elm) {
              toAdd    && jqLiteAddClass(elm, toAdd);
              toRemove && jqLiteRemoveClass(elm, toRemove);
            });
            postDigestQueue.remove(element);
          }
        });

        postDigestElements.length = 0;
      });
    }
  }];
};

/**
 * @ngdoc provider
 * @name $animateProvider
 *
 * @description
 * Default implementation of $animate that doesn't perform any animations, instead just
 * synchronously performs DOM updates and resolves the returned runner promise.
 *
 * In order to enable animations the `ngAnimate` module has to be loaded.
 *
 * To see the functional implementation check out `src/ngAnimate/animate.js`.
 */
var $AnimateProvider = ['$provide', function($provide) {
  var provider = this;

  this.$$registeredAnimations = Object.create(null);

   /**
   * @ngdoc method
   * @name $animateProvider#register
   *
   * @description
   * Registers a new injectable animation factory function. The factory function produces the
   * animation object which contains callback functions for each event that is expected to be
   * animated.
   *
   *   * `eventFn`: `function(element, ... , doneFunction, options)`
   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
   *   on the type of animation additional arguments will be injected into the animation function. The
   *   list below explains the function signatures for the different animation methods:
   *
   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
   *   - addClass: function(element, addedClasses, doneFunction, options)
   *   - removeClass: function(element, removedClasses, doneFunction, options)
   *   - enter, leave, move: function(element, doneFunction, options)
   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
   *
   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
   *
   * ```js
   *   return {
   *     //enter, leave, move signature
   *     eventFn : function(element, done, options) {
   *       //code to run the animation
   *       //once complete, then run done()
   *       return function endFunction(wasCancelled) {
   *         //code to cancel the animation
   *       }
   *     }
   *   }
   * ```
   *
   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
   * @param {Function} factory The factory function that will be executed to return the animation
   *                           object.
   */
  this.register = function(name, factory) {
    if (name && name.charAt(0) !== '.') {
      throw $animateMinErr('notcsel', "Expecting class selector starting with '.' got '{0}'.", name);
    }

    var key = name + '-animation';
    provider.$$registeredAnimations[name.substr(1)] = key;
    $provide.factory(key, factory);
  };

  /**
   * @ngdoc method
   * @name $animateProvider#classNameFilter
   *
   * @description
   * Sets and/or returns the CSS class regular expression that is checked when performing
   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
   * When setting the `classNameFilter` value, animations will only be performed on elements
   * that successfully match the filter expression. This in turn can boost performance
   * for low-powered devices as well as applications containing a lot of structural operations.
   * @param {RegExp=} expression The className expression which will be checked against all animations
   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
   */
  this.classNameFilter = function(expression) {
    if (arguments.length === 1) {
      this.$$classNameFilter = (expression instanceof RegExp) ? expression : null;
      if (this.$$classNameFilter) {
        var reservedRegex = new RegExp("(\\s+|\\/)" + NG_ANIMATE_CLASSNAME + "(\\s+|\\/)");
        if (reservedRegex.test(this.$$classNameFilter.toString())) {
          throw $animateMinErr('nongcls','$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);

        }
      }
    }
    return this.$$classNameFilter;
  };

  this.$get = ['$$animateQueue', function($$animateQueue) {
    function domInsert(element, parentElement, afterElement) {
      // if for some reason the previous element was removed
      // from the dom sometime before this code runs then let's
      // just stick to using the parent element as the anchor
      if (afterElement) {
        var afterNode = extractElementNode(afterElement);
        if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
          afterElement = null;
        }
      }
      afterElement ? afterElement.after(element) : parentElement.prepend(element);
    }

    /**
     * @ngdoc service
     * @name $animate
     * @description The $animate service exposes a series of DOM utility methods that provide support
     * for animation hooks. The default behavior is the application of DOM operations, however,
     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
     * to ensure that animation runs with the triggered DOM operation.
     *
     * By default $animate doesn't trigger an animations. This is because the `ngAnimate` module isn't
     * included and only when it is active then the animation hooks that `$animate` triggers will be
     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
     *
     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
     *
     * To learn more about enabling animation support, click here to visit the
     * {@link ngAnimate ngAnimate module page}.
     */
    return {
      // we don't call it directly since non-existant arguments may
      // be interpreted as null within the sub enabled function

      /**
       *
       * @ngdoc method
       * @name $animate#on
       * @kind function
       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
       *    is fired with the following params:
       *
       * ```js
       * $animate.on('enter', container,
       *    function callback(element, phase) {
       *      // cool we detected an enter animation within the container
       *    }
       * );
       * ```
       *
       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
       *     as well as among its children
       * @param {Function} callback the callback function that will be fired when the listener is triggered
       *
       * The arguments present in the callback function are:
       * * `element` - The captured DOM element that the animation was fired on.
       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
       */
      on: $$animateQueue.on,

      /**
       *
       * @ngdoc method
       * @name $animate#off
       * @kind function
       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
       * can be used in three different ways depending on the arguments:
       *
       * ```js
       * // remove all the animation event listeners listening for `enter`
       * $animate.off('enter');
       *
       * // remove all the animation event listeners listening for `enter` on the given element and its children
       * $animate.off('enter', container);
       *
       * // remove the event listener function provided by `listenerFn` that is set
       * // to listen for `enter` on the given `element` as well as its children
       * $animate.off('enter', container, callback);
       * ```
       *
       * @param {string} event the animation event (e.g. enter, leave, move, addClass, removeClass, etc...)
       * @param {DOMElement=} container the container element the event listener was placed on
       * @param {Function=} callback the callback function that was registered as the listener
       */
      off: $$animateQueue.off,

      /**
       * @ngdoc method
       * @name $animate#pin
       * @kind function
       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
       *    outside of the DOM structure of the Angular application. By doing so, any animation triggered via `$animate` can be issued on the
       *    element despite being outside the realm of the application or within another application. Say for example if the application
       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
       *
       *    Note that this feature is only active when the `ngAnimate` module is used.
       *
       * @param {DOMElement} element the external element that will be pinned
       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
       */
      pin: $$animateQueue.pin,

      /**
       *
       * @ngdoc method
       * @name $animate#enabled
       * @kind function
       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
       * function can be called in four ways:
       *
       * ```js
       * // returns true or false
       * $animate.enabled();
       *
       * // changes the enabled state for all animations
       * $animate.enabled(false);
       * $animate.enabled(true);
       *
       * // returns true or false if animations are enabled for an element
       * $animate.enabled(element);
       *
       * // changes the enabled state for an element and its children
       * $animate.enabled(element, true);
       * $animate.enabled(element, false);
       * ```
       *
       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
       * @param {boolean=} enabled whether or not the animations will be enabled for the element
       *
       * @return {boolean} whether or not animations are enabled
       */
      enabled: $$animateQueue.enabled,

      /**
       * @ngdoc method
       * @name $animate#cancel
       * @kind function
       * @description Cancels the provided animation.
       *
       * @param {Promise} animationPromise The animation promise that is returned when an animation is started.
       */
      cancel: function(runner) {
        runner.end && runner.end();
      },

      /**
       *
       * @ngdoc method
       * @name $animate#enter
       * @kind function
       * @description Inserts the element into the DOM either after the `after` element (if provided) or
       *   as the first child within the `parent` element and then triggers an animation.
       *   A promise is returned that will be resolved during the next digest once the animation
       *   has completed.
       *
       * @param {DOMElement} element the element which will be inserted into the DOM
       * @param {DOMElement} parent the parent element which will append the element as
       *   a child (so long as the after element is not present)
       * @param {DOMElement=} after the sibling element after which the element will be appended
       * @param {object=} options an optional collection of options/styles that will be applied to the element
       *
       * @return {Promise} the animation callback promise
       */
      enter: function(element, parent, after, options) {
        parent = parent && jqLite(parent);
        after = after && jqLite(after);
        parent = parent || after.parent();
        domInsert(element, parent, after);
        return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
      },

      /**
       *
       * @ngdoc method
       * @name $animate#move
       * @kind function
       * @description Inserts (moves) the element into its new position in the DOM either after
       *   the `after` element (if provided) or as the first child within the `parent` element
       *   and then triggers an animation. A promise is returned that will be resolved
       *   during the next digest once the animation has completed.
       *
       * @param {DOMElement} element the element which will be moved into the new DOM position
       * @param {DOMElement} parent the parent element which will append the element as
       *   a child (so long as the after element is not present)
       * @param {DOMElement=} after the sibling element after which the element will be appended
       * @param {object=} options an optional collection of options/styles that will be applied to the element
       *
       * @return {Promise} the animation callback promise
       */
      move: function(element, parent, after, options) {
        parent = parent && jqLite(parent);
        after = after && jqLite(after);
        parent = parent || after.parent();
        domInsert(element, parent, after);
        return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
      },

      /**
       * @ngdoc method
       * @name $animate#leave
       * @kind function
       * @description Triggers an animation and then removes the element from the DOM.
       * When the function is called a promise is returned that will be resolved during the next
       * digest once the animation has completed.
       *
       * @param {DOMElement} element the element which will be removed from the DOM
       * @param {object=} options an optional collection of options/styles that will be applied to the element
       *
       * @return {Promise} the animation callback promise
       */
      leave: function(element, options) {
        return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
          element.remove();
        });
      },

      /**
       * @ngdoc method
       * @name $animate#addClass
       * @kind function
       *
       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
       *   animation if element already contains the CSS class or if the class is removed at a later step.
       *   Note that class-based animations are treated differently compared to structural animations
       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
       *   depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element
       *
       * @return {Promise} the animation callback promise
       */
      addClass: function(element, className, options) {
        options = prepareAnimateOptions(options);
        options.addClass = mergeClasses(options.addclass, className);
        return $$animateQueue.push(element, 'addClass', options);
      },

      /**
       * @ngdoc method
       * @name $animate#removeClass
       * @kind function
       *
       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
       *   animation if element does not contain the CSS class or if the class is added at a later step.
       *   Note that class-based animations are treated differently compared to structural animations
       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
       *   depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element
       *
       * @return {Promise} the animation callback promise
       */
      removeClass: function(element, className, options) {
        options = prepareAnimateOptions(options);
        options.removeClass = mergeClasses(options.removeClass, className);
        return $$animateQueue.push(element, 'removeClass', options);
      },

      /**
       * @ngdoc method
       * @name $animate#setClass
       * @kind function
       *
       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
       *    passed. Note that class-based animations are treated differently compared to structural animations
       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
       *    depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element
       *
       * @return {Promise} the animation callback promise
       */
      setClass: function(element, add, remove, options) {
        options = prepareAnimateOptions(options);
        options.addClass = mergeClasses(options.addClass, add);
        options.removeClass = mergeClasses(options.removeClass, remove);
        return $$animateQueue.push(element, 'setClass', options);
      },

      /**
       * @ngdoc method
       * @name $animate#animate
       * @kind function
       *
       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
       * If any detected CSS transition, keyframe or JavaScript matches the provided className value then the animation will take
       * on the provided styles. For example, if a transition animation is set for the given className then the provided from and
       * to styles will be applied alongside the given transition. If a JavaScript animation is detected then the provided styles
       * will be given in as function paramters into the `animate` method (or as apart of the `options` parameter).
       *
       * @param {DOMElement} element the element which the CSS styles will be applied to
       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
       *    (Note that if no animation is detected then this value will not be appplied to the element.)
       * @param {object=} options an optional collection of options/styles that will be applied to the element
       *
       * @return {Promise} the animation callback promise
       */
      animate: function(element, from, to, className, options) {
        options = prepareAnimateOptions(options);
        options.from = options.from ? extend(options.from, from) : from;
        options.to   = options.to   ? extend(options.to, to)     : to;

        className = className || 'ng-inline-animate';
        options.tempClasses = mergeClasses(options.tempClasses, className);
        return $$animateQueue.push(element, 'animate', options);
      }
    };
  }];
}];

function $$AsyncCallbackProvider() {
  this.$get = ['$$rAF', '$timeout', function($$rAF, $timeout) {
    return $$rAF.supported
      ? function(fn) { return $$rAF(fn); }
      : function(fn) {
        return $timeout(fn, 0, false);
      };
  }];
}

/* global stripHash: true */

/**
 * ! This is a private undocumented service !
 *
 * @name $browser
 * @requires $log
 * @description
 * This object has two goals:
 *
 * - hide all the global state in the browser caused by the window object
 * - abstract away all the browser specific features and inconsistencies
 *
 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
 * service, which can be used for convenient testing of the application without the interaction with
 * the real browser apis.
 */
/**
 * @param {object} window The global window object.
 * @param {object} document jQuery wrapped document.
 * @param {object} $log window.console or an object with the same interface.
 * @param {object} $sniffer $sniffer service
 */
function Browser(window, document, $log, $sniffer) {
  var self = this,
      rawDocument = document[0],
      location = window.location,
      history = window.history,
      setTimeout = window.setTimeout,
      clearTimeout = window.clearTimeout,
      pendingDeferIds = {};

  self.isMock = false;

  var outstandingRequestCount = 0;
  var outstandingRequestCallbacks = [];

  // TODO(vojta): remove this temporary api
  self.$$completeOutstandingRequest = completeOutstandingRequest;
  self.$$incOutstandingRequestCount = function() { outstandingRequestCount++; };

  /**
   * Executes the `fn` function(supports currying) and decrements the `outstandingRequestCallbacks`
   * counter. If the counter reaches 0, all the `outstandingRequestCallbacks` are executed.
   */
  function completeOutstandingRequest(fn) {
    try {
      fn.apply(null, sliceArgs(arguments, 1));
    } finally {
      outstandingRequestCount--;
      if (outstandingRequestCount === 0) {
        while (outstandingRequestCallbacks.length) {
          try {
            outstandingRequestCallbacks.pop()();
          } catch (e) {
            $log.error(e);
          }
        }
      }
    }
  }

  function getHash(url) {
    var index = url.indexOf('#');
    return index === -1 ? '' : url.substr(index + 1);
  }

  /**
   * @private
   * Note: this method is used only by scenario runner
   * TODO(vojta): prefix this method with $$ ?
   * @param {function()} callback Function that will be called when no outstanding request
   */
  self.notifyWhenNoOutstandingRequests = function(callback) {
    if (outstandingRequestCount === 0) {
      callback();
    } else {
      outstandingRequestCallbacks.push(callback);
    }
  };

  //////////////////////////////////////////////////////////////
  // URL API
  //////////////////////////////////////////////////////////////

  var cachedState, lastHistoryState,
      lastBrowserUrl = location.href,
      baseElement = document.find('base'),
      reloadLocation = null;

  cacheState();
  lastHistoryState = cachedState;

  /**
   * @name $browser#url
   *
   * @description
   * GETTER:
   * Without any argument, this method just returns current value of location.href.
   *
   * SETTER:
   * With at least one argument, this method sets url to new value.
   * If html5 history api supported, pushState/replaceState is used, otherwise
   * location.href/location.replace is used.
   * Returns its own instance to allow chaining
   *
   * NOTE: this api is intended for use only by the $location service. Please use the
   * {@link ng.$location $location service} to change url.
   *
   * @param {string} url New url (when used as setter)
   * @param {boolean=} replace Should new url replace current history record?
   * @param {object=} state object to use with pushState/replaceState
   */
  self.url = function(url, replace, state) {
    // In modern browsers `history.state` is `null` by default; treating it separately
    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
    if (isUndefined(state)) {
      state = null;
    }

    // Android Browser BFCache causes location, history reference to become stale.
    if (location !== window.location) location = window.location;
    if (history !== window.history) history = window.history;

    // setter
    if (url) {
      var sameState = lastHistoryState === state;

      // Don't change anything if previous and current URLs and states match. This also prevents
      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
      // See https://github.com/angular/angular.js/commit/ffb2701
      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
        return self;
      }
      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
      lastBrowserUrl = url;
      lastHistoryState = state;
      // Don't use history API if only the hash changed
      // due to a bug in IE10/IE11 which leads
      // to not firing a `hashchange` nor `popstate` event
      // in some cases (see #9143).
      if ($sniffer.history && (!sameBase || !sameState)) {
        history[replace ? 'replaceState' : 'pushState'](state, '', url);
        cacheState();
        // Do the assignment again so that those two variables are referentially identical.
        lastHistoryState = cachedState;
      } else {
        if (!sameBase || reloadLocation) {
          reloadLocation = url;
        }
        if (replace) {
          location.replace(url);
        } else if (!sameBase) {
          location.href = url;
        } else {
          location.hash = getHash(url);
        }
      }
      return self;
    // getter
    } else {
      // - reloadLocation is needed as browsers don't allow to read out
      //   the new location.href if a reload happened.
      // - the replacement is a workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=407172
      return reloadLocation || location.href.replace(/%27/g,"'");
    }
  };

  /**
   * @name $browser#state
   *
   * @description
   * This method is a getter.
   *
   * Return history.state or null if history.state is undefined.
   *
   * @returns {object} state
   */
  self.state = function() {
    return cachedState;
  };

  var urlChangeListeners = [],
      urlChangeInit = false;

  function cacheStateAndFireUrlChange() {
    cacheState();
    fireUrlChange();
  }

  function getCurrentState() {
    try {
      return history.state;
    } catch (e) {
      // MSIE can reportedly throw when there is no state (UNCONFIRMED).
    }
  }

  // This variable should be used *only* inside the cacheState function.
  var lastCachedState = null;
  function cacheState() {
    // This should be the only place in $browser where `history.state` is read.
    cachedState = getCurrentState();
    cachedState = isUndefined(cachedState) ? null : cachedState;

    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
    if (equals(cachedState, lastCachedState)) {
      cachedState = lastCachedState;
    }
    lastCachedState = cachedState;
  }

  function fireUrlChange() {
    if (lastBrowserUrl === self.url() && lastHistoryState === cachedState) {
      return;
    }

    lastBrowserUrl = self.url();
    lastHistoryState = cachedState;
    forEach(urlChangeListeners, function(listener) {
      listener(self.url(), cachedState);
    });
  }

  /**
   * @name $browser#onUrlChange
   *
   * @description
   * Register callback function that will be called, when url changes.
   *
   * It's only called when the url is changed from outside of angular:
   * - user types different url into address bar
   * - user clicks on history (forward/back) button
   * - user clicks on a link
   *
   * It's not called when url is changed by $browser.url() method
   *
   * The listener gets called with new url as parameter.
   *
   * NOTE: this api is intended for use only by the $location service. Please use the
   * {@link ng.$location $location service} to monitor url changes in angular apps.
   *
   * @param {function(string)} listener Listener function to be called when url changes.
   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
   */
  self.onUrlChange = function(callback) {
    // TODO(vojta): refactor to use node's syntax for events
    if (!urlChangeInit) {
      // We listen on both (hashchange/popstate) when available, as some browsers (e.g. Opera)
      // don't fire popstate when user change the address bar and don't fire hashchange when url
      // changed by push/replaceState

      // html5 history api - popstate event
      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
      // hashchange event
      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);

      urlChangeInit = true;
    }

    urlChangeListeners.push(callback);
    return callback;
  };

  /**
   * @private
   * Remove popstate and hashchange handler from window.
   *
   * NOTE: this api is intended for use only by $rootScope.
   */
  self.$$applicationDestroyed = function() {
    jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
  };

  /**
   * Checks whether the url has changed outside of Angular.
   * Needs to be exported to be able to check for changes that have been done in sync,
   * as hashchange/popstate events fire in async.
   */
  self.$$checkUrlChange = fireUrlChange;

  //////////////////////////////////////////////////////////////
  // Misc API
  //////////////////////////////////////////////////////////////

  /**
   * @name $browser#baseHref
   *
   * @description
   * Returns current <base href>
   * (always relative - without domain)
   *
   * @returns {string} The current base href
   */
  self.baseHref = function() {
    var href = baseElement.attr('href');
    return href ? href.replace(/^(https?\:)?\/\/[^\/]*/, '') : '';
  };

  /**
   * @name $browser#defer
   * @param {function()} fn A function, who's execution should be deferred.
   * @param {number=} [delay=0] of milliseconds to defer the function execution.
   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
   *
   * @description
   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
   *
   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
   * via `$browser.defer.flush()`.
   *
   */
  self.defer = function(fn, delay) {
    var timeoutId;
    outstandingRequestCount++;
    timeoutId = setTimeout(function() {
      delete pendingDeferIds[timeoutId];
      completeOutstandingRequest(fn);
    }, delay || 0);
    pendingDeferIds[timeoutId] = true;
    return timeoutId;
  };


  /**
   * @name $browser#defer.cancel
   *
   * @description
   * Cancels a deferred task identified with `deferId`.
   *
   * @param {*} deferId Token returned by the `$browser.defer` function.
   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
   *                    canceled.
   */
  self.defer.cancel = function(deferId) {
    if (pendingDeferIds[deferId]) {
      delete pendingDeferIds[deferId];
      clearTimeout(deferId);
      completeOutstandingRequest(noop);
      return true;
    }
    return false;
  };

}

function $BrowserProvider() {
  this.$get = ['$window', '$log', '$sniffer', '$document',
      function($window, $log, $sniffer, $document) {
        return new Browser($window, $document, $log, $sniffer);
      }];
}

/**
 * @ngdoc service
 * @name $cacheFactory
 *
 * @description
 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
 * them.
 *
 * ```js
 *
 *  var cache = $cacheFactory('cacheId');
 *  expect($cacheFactory.get('cacheId')).toBe(cache);
 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
 *
 *  cache.put("key", "value");
 *  cache.put("another key", "another value");
 *
 *  // We've specified no options on creation
 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
 *
 * ```
 *
 *
 * @param {string} cacheId Name or id of the newly created cache.
 * @param {object=} options Options object that specifies the cache behavior. Properties:
 *
 *   - `{number=}` `capacity` — turns the cache into LRU cache.
 *
 * @returns {object} Newly created cache object with the following set of methods:
 *
 * - `{object}` `info()` — Returns id, size, and options of cache.
 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
 *   it.
 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
 * - `{void}` `removeAll()` — Removes all cached values.
 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
 *
 * @example
   <example module="cacheExampleApp">
     <file name="index.html">
       <div ng-controller="CacheController">
         <input ng-model="newCacheKey" placeholder="Key">
         <input ng-model="newCacheValue" placeholder="Value">
         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>

         <p ng-if="keys.length">Cached Values</p>
         <div ng-repeat="key in keys">
           <span ng-bind="key"></span>
           <span>: </span>
           <b ng-bind="cache.get(key)"></b>
         </div>

         <p>Cache Info</p>
         <div ng-repeat="(key, value) in cache.info()">
           <span ng-bind="key"></span>
           <span>: </span>
           <b ng-bind="value"></b>
         </div>
       </div>
     </file>
     <file name="script.js">
       angular.module('cacheExampleApp', []).
         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
           $scope.keys = [];
           $scope.cache = $cacheFactory('cacheId');
           $scope.put = function(key, value) {
             if ($scope.cache.get(key) === undefined) {
               $scope.keys.push(key);
             }
             $scope.cache.put(key, value === undefined ? null : value);
           };
         }]);
     </file>
     <file name="style.css">
       p {
         margin: 10px 0 3px;
       }
     </file>
   </example>
 */
function $CacheFactoryProvider() {

  this.$get = function() {
    var caches = {};

    function cacheFactory(cacheId, options) {
      if (cacheId in caches) {
        throw minErr('$cacheFactory')('iid', "CacheId '{0}' is already taken!", cacheId);
      }

      var size = 0,
          stats = extend({}, options, {id: cacheId}),
          data = {},
          capacity = (options && options.capacity) || Number.MAX_VALUE,
          lruHash = {},
          freshEnd = null,
          staleEnd = null;

      /**
       * @ngdoc type
       * @name $cacheFactory.Cache
       *
       * @description
       * A cache object used to store and retrieve data, primarily used by
       * {@link $http $http} and the {@link ng.directive:script script} directive to cache
       * templates and other data.
       *
       * ```js
       *  angular.module('superCache')
       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
       *      return $cacheFactory('super-cache');
       *    }]);
       * ```
       *
       * Example test:
       *
       * ```js
       *  it('should behave like a cache', inject(function(superCache) {
       *    superCache.put('key', 'value');
       *    superCache.put('another key', 'another value');
       *
       *    expect(superCache.info()).toEqual({
       *      id: 'super-cache',
       *      size: 2
       *    });
       *
       *    superCache.remove('another key');
       *    expect(superCache.get('another key')).toBeUndefined();
       *
       *    superCache.removeAll();
       *    expect(superCache.info()).toEqual({
       *      id: 'super-cache',
       *      size: 0
       *    });
       *  }));
       * ```
       */
      return caches[cacheId] = {

        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#put
         * @kind function
         *
         * @description
         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
         * retrieved later, and incrementing the size of the cache if the key was not already
         * present in the cache. If behaving like an LRU cache, it will also remove stale
         * entries from the set.
         *
         * It will not insert undefined values into the cache.
         *
         * @param {string} key the key under which the cached data is stored.
         * @param {*} value the value to store alongside the key. If it is undefined, the key
         *    will not be stored.
         * @returns {*} the value stored.
         */
        put: function(key, value) {
          if (isUndefined(value)) return;
          if (capacity < Number.MAX_VALUE) {
            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});

            refresh(lruEntry);
          }

          if (!(key in data)) size++;
          data[key] = value;

          if (size > capacity) {
            this.remove(staleEnd.key);
          }

          return value;
        },

        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#get
         * @kind function
         *
         * @description
         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
         *
         * @param {string} key the key of the data to be retrieved
         * @returns {*} the value stored.
         */
        get: function(key) {
          if (capacity < Number.MAX_VALUE) {
            var lruEntry = lruHash[key];

            if (!lruEntry) return;

            refresh(lruEntry);
          }

          return data[key];
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#remove
         * @kind function
         *
         * @description
         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
         *
         * @param {string} key the key of the entry to be removed
         */
        remove: function(key) {
          if (capacity < Number.MAX_VALUE) {
            var lruEntry = lruHash[key];

            if (!lruEntry) return;

            if (lruEntry == freshEnd) freshEnd = lruEntry.p;
            if (lruEntry == staleEnd) staleEnd = lruEntry.n;
            link(lruEntry.n,lruEntry.p);

            delete lruHash[key];
          }

          delete data[key];
          size--;
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#removeAll
         * @kind function
         *
         * @description
         * Clears the cache object of any entries.
         */
        removeAll: function() {
          data = {};
          size = 0;
          lruHash = {};
          freshEnd = staleEnd = null;
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#destroy
         * @kind function
         *
         * @description
         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
         * removing it from the {@link $cacheFactory $cacheFactory} set.
         */
        destroy: function() {
          data = null;
          stats = null;
          lruHash = null;
          delete caches[cacheId];
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#info
         * @kind function
         *
         * @description
         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
         *
         * @returns {object} an object with the following properties:
         *   <ul>
         *     <li>**id**: the id of the cache instance</li>
         *     <li>**size**: the number of entries kept in the cache instance</li>
         *     <li>**...**: any additional properties from the options object when creating the
         *       cache.</li>
         *   </ul>
         */
        info: function() {
          return extend({}, stats, {size: size});
        }
      };


      /**
       * makes the `entry` the freshEnd of the LRU linked list
       */
      function refresh(entry) {
        if (entry != freshEnd) {
          if (!staleEnd) {
            staleEnd = entry;
          } else if (staleEnd == entry) {
            staleEnd = entry.n;
          }

          link(entry.n, entry.p);
          link(entry, freshEnd);
          freshEnd = entry;
          freshEnd.n = null;
        }
      }


      /**
       * bidirectionally links two entries of the LRU linked list
       */
      function link(nextEntry, prevEntry) {
        if (nextEntry != prevEntry) {
          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
        }
      }
    }


  /**
   * @ngdoc method
   * @name $cacheFactory#info
   *
   * @description
   * Get information about all the caches that have been created
   *
   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
   */
    cacheFactory.info = function() {
      var info = {};
      forEach(caches, function(cache, cacheId) {
        info[cacheId] = cache.info();
      });
      return info;
    };


  /**
   * @ngdoc method
   * @name $cacheFactory#get
   *
   * @description
   * Get access to a cache object by the `cacheId` used when it was created.
   *
   * @param {string} cacheId Name or id of a cache to access.
   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
   */
    cacheFactory.get = function(cacheId) {
      return caches[cacheId];
    };


    return cacheFactory;
  };
}

/**
 * @ngdoc service
 * @name $templateCache
 *
 * @description
 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
 * can load templates directly into the cache in a `script` tag, or by consuming the
 * `$templateCache` service directly.
 *
 * Adding via the `script` tag:
 *
 * ```html
 *   <script type="text/ng-template" id="templateId.html">
 *     <p>This is the content of the template</p>
 *   </script>
 * ```
 *
 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (IE,
 * element with ng-app attribute), otherwise the template will be ignored.
 *
 * Adding via the `$templateCache` service:
 *
 * ```js
 * var myApp = angular.module('myApp', []);
 * myApp.run(function($templateCache) {
 *   $templateCache.put('templateId.html', 'This is the content of the template');
 * });
 * ```
 *
 * To retrieve the template later, simply use it in your HTML:
 * ```html
 * <div ng-include=" 'templateId.html' "></div>
 * ```
 *
 * or get it via Javascript:
 * ```js
 * $templateCache.get('templateId.html')
 * ```
 *
 * See {@link ng.$cacheFactory $cacheFactory}.
 *
 */
function $TemplateCacheProvider() {
  this.$get = ['$cacheFactory', function($cacheFactory) {
    return $cacheFactory('templates');
  }];
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
 *
 * DOM-related variables:
 *
 * - "node" - DOM Node
 * - "element" - DOM Element or Node
 * - "$node" or "$element" - jqLite-wrapped node or element
 *
 *
 * Compiler related stuff:
 *
 * - "linkFn" - linking fn of a single directive
 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
 */


/**
 * @ngdoc service
 * @name $compile
 * @kind function
 *
 * @description
 * Compiles an HTML string or DOM into a template and produces a template function, which
 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
 *
 * The compilation is a process of walking the DOM tree and matching DOM elements to
 * {@link ng.$compileProvider#directive directives}.
 *
 * <div class="alert alert-warning">
 * **Note:** This document is an in-depth reference of all directive options.
 * For a gentle introduction to directives with examples of common use cases,
 * see the {@link guide/directive directive guide}.
 * </div>
 *
 * ## Comprehensive Directive API
 *
 * There are many different options for a directive.
 *
 * The difference resides in the return value of the factory function.
 * You can either return a "Directive Definition Object" (see below) that defines the directive properties,
 * or just the `postLink` function (all other properties will have the default values).
 *
 * <div class="alert alert-success">
 * **Best Practice:** It's recommended to use the "directive definition object" form.
 * </div>
 *
 * Here's an example directive declared with a Directive Definition Object:
 *
 * ```js
 *   var myModule = angular.module(...);
 *
 *   myModule.directive('directiveName', function factory(injectables) {
 *     var directiveDefinitionObject = {
 *       priority: 0,
 *       template: '<div></div>', // or // function(tElement, tAttrs) { ... },
 *       // or
 *       // templateUrl: 'directive.html', // or // function(tElement, tAttrs) { ... },
 *       transclude: false,
 *       restrict: 'A',
 *       templateNamespace: 'html',
 *       scope: false,
 *       controller: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
 *       controllerAs: 'stringIdentifier',
 *       bindToController: false,
 *       require: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
 *       compile: function compile(tElement, tAttrs, transclude) {
 *         return {
 *           pre: function preLink(scope, iElement, iAttrs, controller) { ... },
 *           post: function postLink(scope, iElement, iAttrs, controller) { ... }
 *         }
 *         // or
 *         // return function postLink( ... ) { ... }
 *       },
 *       // or
 *       // link: {
 *       //  pre: function preLink(scope, iElement, iAttrs, controller) { ... },
 *       //  post: function postLink(scope, iElement, iAttrs, controller) { ... }
 *       // }
 *       // or
 *       // link: function postLink( ... ) { ... }
 *     };
 *     return directiveDefinitionObject;
 *   });
 * ```
 *
 * <div class="alert alert-warning">
 * **Note:** Any unspecified options will use the default value. You can see the default values below.
 * </div>
 *
 * Therefore the above can be simplified as:
 *
 * ```js
 *   var myModule = angular.module(...);
 *
 *   myModule.directive('directiveName', function factory(injectables) {
 *     var directiveDefinitionObject = {
 *       link: function postLink(scope, iElement, iAttrs) { ... }
 *     };
 *     return directiveDefinitionObject;
 *     // or
 *     // return function postLink(scope, iElement, iAttrs) { ... }
 *   });
 * ```
 *
 *
 *
 * ### Directive Definition Object
 *
 * The directive definition object provides instructions to the {@link ng.$compile
 * compiler}. The attributes are:
 *
 * #### `multiElement`
 * When this property is set to true, the HTML compiler will collect DOM nodes between
 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
 * together as the directive elements. It is recommended that this feature be used on directives
 * which are not strictly behavioural (such as {@link ngClick}), and which
 * do not manipulate or replace child nodes (such as {@link ngInclude}).
 *
 * #### `priority`
 * When there are multiple directives defined on a single DOM element, sometimes it
 * is necessary to specify the order in which the directives are applied. The `priority` is used
 * to sort the directives before their `compile` functions get called. Priority is defined as a
 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
 * are also run in priority order, but post-link functions are run in reverse order. The order
 * of directives with the same priority is undefined. The default priority is `0`.
 *
 * #### `terminal`
 * If set to true then the current `priority` will be the last set of directives
 * which will execute (any directives at the current priority will still execute
 * as the order of execution on same `priority` is undefined). Note that expressions
 * and other directives used in the directive's template will also be excluded from execution.
 *
 * #### `scope`
 * **If set to `true`,** then a new scope will be created for this directive. If multiple directives on the
 * same element request a new scope, only one new scope is created. The new scope rule does not
 * apply for the root of the template since the root of the template always gets a new scope.
 *
 * **If set to `{}` (object hash),** then a new "isolate" scope is created. The 'isolate' scope differs from
 * normal scope in that it does not prototypically inherit from the parent scope. This is useful
 * when creating reusable components, which should not accidentally read or modify data in the
 * parent scope.
 *
 * The 'isolate' scope takes an object hash which defines a set of local scope properties
 * derived from the parent scope. These local properties are useful for aliasing values for
 * templates. Locals definition is a hash of local scope property to its source:
 *
 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
 *   always a string since DOM attributes are strings. If no `attr` name is specified  then the
 *   attribute name is assumed to be the same as the local name.
 *   Given `<widget my-attr="hello {{name}}">` and widget definition
 *   of `scope: { localName:'@myAttr' }`, then widget scope property `localName` will reflect
 *   the interpolated value of `hello {{name}}`. As the `name` attribute changes so will the
 *   `localName` property on the widget scope. The `name` is read from the parent scope (not
 *   component scope).
 *
 * * `=` or `=attr` - set up bi-directional binding between a local scope property and the
 *   parent scope property of name defined via the value of the `attr` attribute. If no `attr`
 *   name is specified then the attribute name is assumed to be the same as the local name.
 *   Given `<widget my-attr="parentModel">` and widget definition of
 *   `scope: { localModel:'=myAttr' }`, then widget scope property `localModel` will reflect the
 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
 *   in `localModel` and any changes in `localModel` will reflect in `parentModel`. If the parent
 *   scope property doesn't exist, it will throw a NON_ASSIGNABLE_MODEL_EXPRESSION exception. You
 *   can avoid this behavior using `=?` or `=?attr` in order to flag the property as optional. If
 *   you want to shallow watch for changes (i.e. $watchCollection instead of $watch) you can use
 *   `=*` or `=*attr` (`=*?` or `=*?attr` if the property is optional).
 *
 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope.
 *   If no `attr` name is specified then the attribute name is assumed to be the same as the
 *   local name. Given `<widget my-attr="count = count + value">` and widget definition of
 *   `scope: { localFn:'&myAttr' }`, then isolate scope property `localFn` will point to
 *   a function wrapper for the `count = count + value` expression. Often it's desirable to
 *   pass data from the isolated scope via an expression to the parent scope, this can be
 *   done by passing a map of local variable names and values into the expression wrapper fn.
 *   For example, if the expression is `increment(amount)` then we can specify the amount value
 *   by calling the `localFn` as `localFn({amount: 22})`.
 *
 *
 * #### `bindToController`
 * When an isolate scope is used for a component (see above), and `controllerAs` is used, `bindToController: true` will
 * allow a component to have its properties bound to the controller, rather than to scope. When the controller
 * is instantiated, the initial values of the isolate scope bindings are already available.
 *
 * #### `controller`
 * Controller constructor function. The controller is instantiated before the
 * pre-linking phase and it is shared with other directives (see
 * `require` attribute). This allows the directives to communicate with each other and augment
 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
 *
 * * `$scope` - Current scope associated with the element
 * * `$element` - Current element
 * * `$attrs` - Current attributes object for the element
 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
 *   `function([scope], cloneLinkingFn, futureParentElement)`.
 *    * `scope`: optional argument to override the scope.
 *    * `cloneLinkingFn`: optional argument to create clones of the original transcluded content.
 *    * `futureParentElement`:
 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
 *          and when the `cloneLinkinFn` is passed,
 *          as those elements need to created and cloned in a special way when they are defined outside their
 *          usual containers (e.g. like `<svg>`).
 *        * See also the `directive.templateNamespace` property.
 *
 *
 * #### `require`
 * Require another directive and inject its controller as the fourth argument to the linking function. The
 * `require` takes a string name (or array of strings) of the directive(s) to pass in. If an array is used, the
 * injected argument will be an array in corresponding order. If no such directive can be
 * found, or if the directive does not have a controller, then an error is raised (unless no link function
 * is specified, in which case error checking is skipped). The name can be prefixed with:
 *
 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
 *   `null` to the `link` fn if not found.
 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
 *   `null` to the `link` fn if not found.
 *
 *
 * #### `controllerAs`
 * Identifier name for a reference to the controller in the directive's scope.
 * This allows the controller to be referenced from the directive template. The directive
 * needs to define a scope for this configuration to be used. Useful in the case when
 * directive is used as component.
 *
 *
 * #### `restrict`
 * String of subset of `EACM` which restricts the directive to a specific directive
 * declaration style. If omitted, the defaults (elements and attributes) are used.
 *
 * * `E` - Element name (default): `<my-directive></my-directive>`
 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
 * * `C` - Class: `<div class="my-directive: exp;"></div>`
 * * `M` - Comment: `<!-- directive: my-directive exp -->`
 *
 *
 * #### `templateNamespace`
 * String representing the document type used by the markup in the template.
 * AngularJS needs this information as those elements need to be created and cloned
 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
 *
 * * `html` - All root nodes in the template are HTML. Root nodes may also be
 *   top-level elements such as `<svg>` or `<math>`.
 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
 *
 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
 *
 * #### `template`
 * HTML markup that may:
 * * Replace the contents of the directive's element (default).
 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
 * * Wrap the contents of the directive's element (if `transclude` is true).
 *
 * Value may be:
 *
 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
 *   function api below) and returns a string value.
 *
 *
 * #### `templateUrl`
 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
 *
 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
 * for later when the template has been resolved.  In the meantime it will continue to compile and link
 * sibling and parent elements as though this element had not contained any directives.
 *
 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
 * case when only one deeply nested directive has `templateUrl`.
 *
 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}
 *
 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
 * a string value representing the url.  In either case, the template URL is passed through {@link
 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
 *
 *
 * #### `replace` ([*DEPRECATED*!], will be removed in next major release - i.e. v2.0)
 * specify what the template should replace. Defaults to `false`.
 *
 * * `true` - the template will replace the directive's element.
 * * `false` - the template will replace the contents of the directive's element.
 *
 * The replacement process migrates all of the attributes / classes from the old element to the new
 * one. See the {@link guide/directive#template-expanding-directive
 * Directives Guide} for an example.
 *
 * There are very few scenarios where element replacement is required for the application function,
 * the main one being reusable custom components that are used within SVG contexts
 * (because SVG doesn't work with custom elements in the DOM tree).
 *
 * #### `transclude`
 * Extract the contents of the element where the directive appears and make it available to the directive.
 * The contents are compiled and provided to the directive as a **transclusion function**. See the
 * {@link $compile#transclusion Transclusion} section below.
 *
 * There are two kinds of transclusion depending upon whether you want to transclude just the contents of the
 * directive's element or the entire element:
 *
 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
 * * `'element'` - transclude the whole of the directive's element including any directives on this
 *   element that defined at a lower priority than this directive. When used, the `template`
 *   property is ignored.
 *
 *
 * #### `compile`
 *
 * ```js
 *   function compile(tElement, tAttrs, transclude) { ... }
 * ```
 *
 * The compile function deals with transforming the template DOM. Since most directives do not do
 * template transformation, it is not used often. The compile function takes the following arguments:
 *
 *   * `tElement` - template element - The element where the directive has been declared. It is
 *     safe to do template transformation on the element and child elements only.
 *
 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
 *     between all directive compile functions.
 *
 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
 *
 * <div class="alert alert-warning">
 * **Note:** The template instance and the link instance may be different objects if the template has
 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
 * should be done in a linking function rather than in a compile function.
 * </div>

 * <div class="alert alert-warning">
 * **Note:** The compile function cannot handle directives that recursively use themselves in their
 * own templates or compile functions. Compiling these directives results in an infinite loop and a
 * stack overflow errors.
 *
 * This can be avoided by manually using $compile in the postLink function to imperatively compile
 * a directive's template instead of relying on automatic template compilation via `template` or
 * `templateUrl` declaration or manual compilation inside the compile function.
 * </div>
 *
 * <div class="alert alert-danger">
 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
 *   to the link function instead.
 * </div>

 * A compile function can have a return value which can be either a function or an object.
 *
 * * returning a (post-link) function - is equivalent to registering the linking function via the
 *   `link` property of the config object when the compile function is empty.
 *
 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
 *   control when a linking function should be called during the linking phase. See info about
 *   pre-linking and post-linking functions below.
 *
 *
 * #### `link`
 * This property is used only if the `compile` property is not defined.
 *
 * ```js
 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
 * ```
 *
 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
 * executed after the template has been cloned. This is where most of the directive logic will be
 * put.
 *
 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
 *
 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
 *     manipulate the children of the element only in `postLink` function since the children have
 *     already been linked.
 *
 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
 *     between all directive linking functions.
 *
 *   * `controller` - the directive's required controller instance(s) - Instances are shared
 *     among all directives, which allows the directives to use the controllers as a communication
 *     channel. The exact value depends on the directive's `require` property:
 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
 *       * `string`: the controller instance
 *       * `array`: array of controller instances
 *
 *     If a required controller cannot be found, and it is optional, the instance is `null`,
 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
 *
 *     Note that you can also require the directive's own controller - it will be made available like
 *     like any other controller.
 *
 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
 *     This is the same as the `$transclude`
 *     parameter of directive controllers, see there for details.
 *     `function([scope], cloneLinkingFn, futureParentElement)`.
 *
 * #### Pre-linking function
 *
 * Executed before the child elements are linked. Not safe to do DOM transformation since the
 * compiler linking function will fail to locate the correct elements for linking.
 *
 * #### Post-linking function
 *
 * Executed after the child elements are linked.
 *
 * Note that child elements that contain `templateUrl` directives will not have been compiled
 * and linked since they are waiting for their template to load asynchronously and their own
 * compilation and linking has been suspended until that occurs.
 *
 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
 * for their async templates to be resolved.
 *
 *
 * ### Transclusion
 *
 * Transclusion is the process of extracting a collection of DOM element from one part of the DOM and
 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
 * scope from where they were taken.
 *
 * Transclusion is used (often with {@link ngTransclude}) to insert the
 * original contents of a directive's element into a specified place in the template of the directive.
 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
 * content has access to the properties on the scope from which it was taken, even if the directive
 * has isolated scope.
 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
 *
 * This makes it possible for the widget to have private state for its template, while the transcluded
 * content has access to its originating scope.
 *
 * <div class="alert alert-warning">
 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
 * Testing Transclusion Directives}.
 * </div>
 *
 * #### Transclusion Functions
 *
 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
 * function** to the directive's `link` function and `controller`. This transclusion function is a special
 * **linking function** that will return the compiled contents linked to a new transclusion scope.
 *
 * <div class="alert alert-info">
 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
 * ngTransclude will deal with it for us.
 * </div>
 *
 * If you want to manually control the insertion and removal of the transcluded content in your directive
 * then you must use this transclude function. When you call a transclude function it returns a a jqLite/JQuery
 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
 *
 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
 * content and the `scope` is the newly created transclusion scope, to which the clone is bound.
 *
 * <div class="alert alert-info">
 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a translude function
 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
 * </div>
 *
 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
 * attach function**:
 *
 * ```js
 * var transcludedContent, transclusionScope;
 *
 * $transclude(function(clone, scope) {
 *   element.append(clone);
 *   transcludedContent = clone;
 *   transclusionScope = scope;
 * });
 * ```
 *
 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
 * associated transclusion scope:
 *
 * ```js
 * transcludedContent.remove();
 * transclusionScope.$destroy();
 * ```
 *
 * <div class="alert alert-info">
 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
 * then you are also responsible for calling `$destroy` on the transclusion scope.
 * </div>
 *
 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
 * automatically destroy their transluded clones as necessary so you do not need to worry about this if
 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
 *
 *
 * #### Transclusion Scopes
 *
 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
 * was taken.
 *
 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
 * like this:
 *
 * ```html
 * <div ng-app>
 *   <div isolate>
 *     <div transclusion>
 *     </div>
 *   </div>
 * </div>
 * ```
 *
 * The `$parent` scope hierarchy will look like this:
 *
 * ```
 * - $rootScope
 *   - isolate
 *     - transclusion
 * ```
 *
 * but the scopes will inherit prototypically from different scopes to their `$parent`.
 *
 * ```
 * - $rootScope
 *   - transclusion
 * - isolate
 * ```
 *
 *
 * ### Attributes
 *
 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
 * `link()` or `compile()` functions. It has a variety of uses.
 *
 * accessing *Normalized attribute names:*
 * Directives like 'ngBind' can be expressed in many ways: 'ng:bind', `data-ng-bind`, or 'x-ng-bind'.
 * the attributes object allows for normalized access to
 *   the attributes.
 *
 * * *Directive inter-communication:* All directives share the same instance of the attributes
 *   object which allows the directives to use the attributes object as inter directive
 *   communication.
 *
 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
 *   allowing other directives to read the interpolated value.
 *
 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
 *   the only way to easily get the actual value because during the linking phase the interpolation
 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
 *
 * ```js
 * function linkingFn(scope, elm, attrs, ctrl) {
 *   // get the attribute value
 *   console.log(attrs.ngModel);
 *
 *   // change the attribute
 *   attrs.$set('ngModel', 'new value');
 *
 *   // observe changes to interpolated attribute
 *   attrs.$observe('ngModel', function(value) {
 *     console.log('ngModel has changed value to ' + value);
 *   });
 * }
 * ```
 *
 * ## Example
 *
 * <div class="alert alert-warning">
 * **Note**: Typically directives are registered with `module.directive`. The example below is
 * to illustrate how `$compile` works.
 * </div>
 *
 <example module="compileExample">
   <file name="index.html">
    <script>
      angular.module('compileExample', [], function($compileProvider) {
        // configure new 'compile' directive by passing a directive
        // factory function. The factory function injects the '$compile'
        $compileProvider.directive('compile', function($compile) {
          // directive factory creates a link function
          return function(scope, element, attrs) {
            scope.$watch(
              function(scope) {
                 // watch the 'compile' expression for changes
                return scope.$eval(attrs.compile);
              },
              function(value) {
                // when the 'compile' expression changes
                // assign it into the current DOM
                element.html(value);

                // compile the new DOM and link it to the current
                // scope.
                // NOTE: we only compile .childNodes so that
                // we don't get into infinite loop compiling ourselves
                $compile(element.contents())(scope);
              }
            );
          };
        });
      })
      .controller('GreeterController', ['$scope', function($scope) {
        $scope.name = 'Angular';
        $scope.html = 'Hello {{name}}';
      }]);
    </script>
    <div ng-controller="GreeterController">
      <input ng-model="name"> <br/>
      <textarea ng-model="html"></textarea> <br/>
      <div compile="html"></div>
    </div>
   </file>
   <file name="protractor.js" type="protractor">
     it('should auto compile', function() {
       var textarea = $('textarea');
       var output = $('div[compile]');
       // The initial state reads 'Hello Angular'.
       expect(output.getText()).toBe('Hello Angular');
       textarea.clear();
       textarea.sendKeys('{{name}}!');
       expect(output.getText()).toBe('Angular!');
     });
   </file>
 </example>

 *
 *
 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
 *
 * <div class="alert alert-danger">
 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
 *   e.g. will not use the right outer scope. Please pass the transclude function as a
 *   `parentBoundTranscludeFn` to the link function instead.
 * </div>
 *
 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
 *                 root element(s), not their children)
 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
 * (a DOM element/tree) to a scope. Where:
 *
 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
 *
 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
 *      * `scope` - is the current scope with which the linking function is working with.
 *
 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
 *  keys may be used to control linking behavior:
 *
 *      * `parentBoundTranscludeFn` - the transclude function made available to
 *        directives; if given, it will be passed through to the link functions of
 *        directives found in `element` during compilation.
 *      * `transcludeControllers` - an object hash with keys that map controller names
 *        to controller instances; if given, it will make the controllers
 *        available to directives.
 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
 *        the cloned elements; only needed for transcludes that are allowed to contain non html
 *        elements (e.g. SVG elements). See also the directive.controller property.
 *
 * Calling the linking function returns the element of the template. It is either the original
 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
 *
 * After linking the view is not updated until after a call to $digest which typically is done by
 * Angular automatically.
 *
 * If you need access to the bound view, there are two ways to do it:
 *
 * - If you are not asking the linking function to clone the template, create the DOM element(s)
 *   before you send them to the compiler and keep this reference around.
 *   ```js
 *     var element = $compile('<p>{{total}}</p>')(scope);
 *   ```
 *
 * - if on the other hand, you need the element to be cloned, the view reference from the original
 *   example would not point to the clone, but rather to the original template that was cloned. In
 *   this case, you can access the clone via the cloneAttachFn:
 *   ```js
 *     var templateElement = angular.element('<p>{{total}}</p>'),
 *         scope = ....;
 *
 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
 *       //attach the clone to DOM document at the right place
 *     });
 *
 *     //now we have reference to the cloned DOM via `clonedElement`
 *   ```
 *
 *
 * For information on how the compiler works, see the
 * {@link guide/compiler Angular HTML Compiler} section of the Developer Guide.
 */

var $compileMinErr = minErr('$compile');

/**
 * @ngdoc provider
 * @name $compileProvider
 *
 * @description
 */
$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
function $CompileProvider($provide, $$sanitizeUriProvider) {
  var hasDirectives = {},
      Suffix = 'Directive',
      COMMENT_DIRECTIVE_REGEXP = /^\s*directive\:\s*([\w\-]+)\s+(.*)$/,
      CLASS_DIRECTIVE_REGEXP = /(([\w\-]+)(?:\:([^;]+))?;?)/,
      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;

  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
  // The assumption is that future DOM event attribute names will begin with
  // 'on' and be composed of only English letters.
  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;

  function parseIsolateBindings(scope, directiveName, isController) {
    var LOCAL_REGEXP = /^\s*([@&]|=(\*?))(\??)\s*(\w*)\s*$/;

    var bindings = {};

    forEach(scope, function(definition, scopeName) {
      var match = definition.match(LOCAL_REGEXP);

      if (!match) {
        throw $compileMinErr('iscp',
            "Invalid {3} for directive '{0}'." +
            " Definition: {... {1}: '{2}' ...}",
            directiveName, scopeName, definition,
            (isController ? "controller bindings definition" :
            "isolate scope definition"));
      }

      bindings[scopeName] = {
        mode: match[1][0],
        collection: match[2] === '*',
        optional: match[3] === '?',
        attrName: match[4] || scopeName
      };
    });

    return bindings;
  }

  function parseDirectiveBindings(directive, directiveName) {
    var bindings = {
      isolateScope: null,
      bindToController: null
    };
    if (isObject(directive.scope)) {
      if (directive.bindToController === true) {
        bindings.bindToController = parseIsolateBindings(directive.scope,
                                                         directiveName, true);
        bindings.isolateScope = {};
      } else {
        bindings.isolateScope = parseIsolateBindings(directive.scope,
                                                     directiveName, false);
      }
    }
    if (isObject(directive.bindToController)) {
      bindings.bindToController =
          parseIsolateBindings(directive.bindToController, directiveName, true);
    }
    if (isObject(bindings.bindToController)) {
      var controller = directive.controller;
      var controllerAs = directive.controllerAs;
      if (!controller) {
        // There is no controller, there may or may not be a controllerAs property
        throw $compileMinErr('noctrl',
              "Cannot bind to controller without directive '{0}'s controller.",
              directiveName);
      } else if (!identifierForController(controller, controllerAs)) {
        // There is a controller, but no identifier or controllerAs property
        throw $compileMinErr('noident',
              "Cannot bind to controller without identifier for directive '{0}'.",
              directiveName);
      }
    }
    return bindings;
  }

  function assertValidDirectiveName(name) {
    var letter = name.charAt(0);
    if (!letter || letter !== lowercase(letter)) {
      throw $compileMinErr('baddir', "Directive name '{0}' is invalid. The first character must be a lowercase letter", name);
    }
    if (name !== name.trim()) {
      throw $compileMinErr('baddir',
            "Directive name '{0}' is invalid. The name should not contain leading or trailing whitespaces",
            name);
    }
  }

  /**
   * @ngdoc method
   * @name $compileProvider#directive
   * @kind function
   *
   * @description
   * Register a new directive with the compiler.
   *
   * @param {string|Object} name Name of the directive in camel-case (i.e. <code>ngBind</code> which
   *    will match as <code>ng-bind</code>), or an object map of directives where the keys are the
   *    names and the values are the factories.
   * @param {Function|Array} directiveFactory An injectable directive factory function. See
   *    {@link guide/directive} for more info.
   * @returns {ng.$compileProvider} Self for chaining.
   */
   this.directive = function registerDirective(name, directiveFactory) {
    assertNotHasOwnProperty(name, 'directive');
    if (isString(name)) {
      assertValidDirectiveName(name);
      assertArg(directiveFactory, 'directiveFactory');
      if (!hasDirectives.hasOwnProperty(name)) {
        hasDirectives[name] = [];
        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
          function($injector, $exceptionHandler) {
            var directives = [];
            forEach(hasDirectives[name], function(directiveFactory, index) {
              try {
                var directive = $injector.invoke(directiveFactory);
                if (isFunction(directive)) {
                  directive = { compile: valueFn(directive) };
                } else if (!directive.compile && directive.link) {
                  directive.compile = valueFn(directive.link);
                }
                directive.priority = directive.priority || 0;
                directive.index = index;
                directive.name = directive.name || name;
                directive.require = directive.require || (directive.controller && directive.name);
                directive.restrict = directive.restrict || 'EA';
                var bindings = directive.$$bindings =
                    parseDirectiveBindings(directive, directive.name);
                if (isObject(bindings.isolateScope)) {
                  directive.$$isolateBindings = bindings.isolateScope;
                }
                directive.$$moduleName = directiveFactory.$$moduleName;
                directives.push(directive);
              } catch (e) {
                $exceptionHandler(e);
              }
            });
            return directives;
          }]);
      }
      hasDirectives[name].push(directiveFactory);
    } else {
      forEach(name, reverseParams(registerDirective));
    }
    return this;
  };


  /**
   * @ngdoc method
   * @name $compileProvider#aHrefSanitizationWhitelist
   * @kind function
   *
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during a[href] sanitization.
   *
   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
   *
   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.aHrefSanitizationWhitelist = function(regexp) {
    if (isDefined(regexp)) {
      $$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);
      return this;
    } else {
      return $$sanitizeUriProvider.aHrefSanitizationWhitelist();
    }
  };


  /**
   * @ngdoc method
   * @name $compileProvider#imgSrcSanitizationWhitelist
   * @kind function
   *
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during img[src] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
   *
   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.imgSrcSanitizationWhitelist = function(regexp) {
    if (isDefined(regexp)) {
      $$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);
      return this;
    } else {
      return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();
    }
  };

  /**
   * @ngdoc method
   * @name  $compileProvider#debugInfoEnabled
   *
   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
   * current debugInfoEnabled state
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   *
   * @kind function
   *
   * @description
   * Call this method to enable/disable various debug runtime information in the compiler such as adding
   * binding information and a reference to the current scope on to DOM elements.
   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
   * * `ng-binding` CSS class
   * * `$binding` data property containing an array of the binding expressions
   *
   * You may want to disable this in production for a significant performance boost. See
   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
   *
   * The default value is true.
   */
  var debugInfoEnabled = true;
  this.debugInfoEnabled = function(enabled) {
    if (isDefined(enabled)) {
      debugInfoEnabled = enabled;
      return this;
    }
    return debugInfoEnabled;
  };

  this.$get = [
            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
            '$controller', '$rootScope', '$document', '$sce', '$animate', '$$sanitizeUri',
    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
             $controller,   $rootScope,   $document,   $sce,   $animate,   $$sanitizeUri) {

    var Attributes = function(element, attributesToCopy) {
      if (attributesToCopy) {
        var keys = Object.keys(attributesToCopy);
        var i, l, key;

        for (i = 0, l = keys.length; i < l; i++) {
          key = keys[i];
          this[key] = attributesToCopy[key];
        }
      } else {
        this.$attr = {};
      }

      this.$$element = element;
    };

    Attributes.prototype = {
      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$normalize
       * @kind function
       *
       * @description
       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
       * `data-`) to its normalized, camelCase form.
       *
       * Also there is special case for Moz prefix starting with upper case letter.
       *
       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
       *
       * @param {string} name Name to normalize
       */
      $normalize: directiveNormalize,


      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$addClass
       * @kind function
       *
       * @description
       * Adds the CSS class value specified by the classVal parameter to the element. If animations
       * are enabled then an animation will be triggered for the class addition.
       *
       * @param {string} classVal The className value that will be added to the element
       */
      $addClass: function(classVal) {
        if (classVal && classVal.length > 0) {
          $animate.addClass(this.$$element, classVal);
        }
      },

      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$removeClass
       * @kind function
       *
       * @description
       * Removes the CSS class value specified by the classVal parameter from the element. If
       * animations are enabled then an animation will be triggered for the class removal.
       *
       * @param {string} classVal The className value that will be removed from the element
       */
      $removeClass: function(classVal) {
        if (classVal && classVal.length > 0) {
          $animate.removeClass(this.$$element, classVal);
        }
      },

      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$updateClass
       * @kind function
       *
       * @description
       * Adds and removes the appropriate CSS class values to the element based on the difference
       * between the new and old CSS class values (specified as newClasses and oldClasses).
       *
       * @param {string} newClasses The current CSS className value
       * @param {string} oldClasses The former CSS className value
       */
      $updateClass: function(newClasses, oldClasses) {
        var toAdd = tokenDifference(newClasses, oldClasses);
        if (toAdd && toAdd.length) {
          $animate.addClass(this.$$element, toAdd);
        }

        var toRemove = tokenDifference(oldClasses, newClasses);
        if (toRemove && toRemove.length) {
          $animate.removeClass(this.$$element, toRemove);
        }
      },

      /**
       * Set a normalized attribute on the element in a way such that all directives
       * can share the attribute. This function properly handles boolean attributes.
       * @param {string} key Normalized key. (ie ngAttribute)
       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
       *     Defaults to true.
       * @param {string=} attrName Optional none normalized name. Defaults to key.
       */
      $set: function(key, value, writeAttr, attrName) {
        // TODO: decide whether or not to throw an error if "class"
        //is set through this function since it may cause $updateClass to
        //become unstable.

        var node = this.$$element[0],
            booleanKey = getBooleanAttrName(node, key),
            aliasedKey = getAliasedAttrName(node, key),
            observer = key,
            nodeName;

        if (booleanKey) {
          this.$$element.prop(key, value);
          attrName = booleanKey;
        } else if (aliasedKey) {
          this[aliasedKey] = value;
          observer = aliasedKey;
        }

        this[key] = value;

        // translate normalized key to actual key
        if (attrName) {
          this.$attr[key] = attrName;
        } else {
          attrName = this.$attr[key];
          if (!attrName) {
            this.$attr[key] = attrName = snake_case(key, '-');
          }
        }

        nodeName = nodeName_(this.$$element);

        if ((nodeName === 'a' && key === 'href') ||
            (nodeName === 'img' && key === 'src')) {
          // sanitize a[href] and img[src] values
          this[key] = value = $$sanitizeUri(value, key === 'src');
        } else if (nodeName === 'img' && key === 'srcset') {
          // sanitize img[srcset] values
          var result = "";

          // first check if there are spaces because it's not the same pattern
          var trimmedSrcset = trim(value);
          //                (   999x   ,|   999w   ,|   ,|,   )
          var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
          var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;

          // split srcset into tuple of uri and descriptor except for the last item
          var rawUris = trimmedSrcset.split(pattern);

          // for each tuples
          var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
          for (var i = 0; i < nbrUrisWith2parts; i++) {
            var innerIdx = i * 2;
            // sanitize the uri
            result += $$sanitizeUri(trim(rawUris[innerIdx]), true);
            // add the descriptor
            result += (" " + trim(rawUris[innerIdx + 1]));
          }

          // split the last item into uri and descriptor
          var lastTuple = trim(rawUris[i * 2]).split(/\s/);

          // sanitize the last uri
          result += $$sanitizeUri(trim(lastTuple[0]), true);

          // and add the last descriptor if any
          if (lastTuple.length === 2) {
            result += (" " + trim(lastTuple[1]));
          }
          this[key] = value = result;
        }

        if (writeAttr !== false) {
          if (value === null || value === undefined) {
            this.$$element.removeAttr(attrName);
          } else {
            this.$$element.attr(attrName, value);
          }
        }

        // fire observers
        var $$observers = this.$$observers;
        $$observers && forEach($$observers[observer], function(fn) {
          try {
            fn(value);
          } catch (e) {
            $exceptionHandler(e);
          }
        });
      },


      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$observe
       * @kind function
       *
       * @description
       * Observes an interpolated attribute.
       *
       * The observer function will be invoked once during the next `$digest` following
       * compilation. The observer is then invoked whenever the interpolated value
       * changes.
       *
       * @param {string} key Normalized key. (ie ngAttribute) .
       * @param {function(interpolatedValue)} fn Function that will be called whenever
                the interpolated value of the attribute changes.
       *        See the {@link guide/directive#text-and-attribute-bindings Directives} guide for more info.
       * @returns {function()} Returns a deregistration function for this observer.
       */
      $observe: function(key, fn) {
        var attrs = this,
            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
            listeners = ($$observers[key] || ($$observers[key] = []));

        listeners.push(fn);
        $rootScope.$evalAsync(function() {
          if (!listeners.$$inter && attrs.hasOwnProperty(key)) {
            // no one registered attribute interpolation function, so lets call it manually
            fn(attrs[key]);
          }
        });

        return function() {
          arrayRemove(listeners, fn);
        };
      }
    };


    function safeAddClass($element, className) {
      try {
        $element.addClass(className);
      } catch (e) {
        // ignore, since it means that we are trying to set class on
        // SVG element, where class name is read-only.
      }
    }


    var startSymbol = $interpolate.startSymbol(),
        endSymbol = $interpolate.endSymbol(),
        denormalizeTemplate = (startSymbol == '{{' || endSymbol  == '}}')
            ? identity
            : function denormalizeTemplate(template) {
              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
        },
        NG_ATTR_BINDING = /^ngAttr[A-Z]/;

    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
      var bindings = $element.data('$binding') || [];

      if (isArray(binding)) {
        bindings = bindings.concat(binding);
      } else {
        bindings.push(binding);
      }

      $element.data('$binding', bindings);
    } : noop;

    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
      safeAddClass($element, 'ng-binding');
    } : noop;

    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
      $element.data(dataName, scope);
    } : noop;

    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
    } : noop;

    return compile;

    //================================

    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
                        previousCompileContext) {
      if (!($compileNodes instanceof jqLite)) {
        // jquery always rewraps, whereas we need to preserve the original selector so that we can
        // modify it.
        $compileNodes = jqLite($compileNodes);
      }
      // We can not compile top level text elements since text nodes can be merged and we will
      // not be able to attach scope data to them, so we will wrap them in <span>
      forEach($compileNodes, function(node, index) {
        if (node.nodeType == NODE_TYPE_TEXT && node.nodeValue.match(/\S+/) /* non-empty */ ) {
          $compileNodes[index] = jqLite(node).wrap('<span></span>').parent()[0];
        }
      });
      var compositeLinkFn =
              compileNodes($compileNodes, transcludeFn, $compileNodes,
                           maxPriority, ignoreDirective, previousCompileContext);
      compile.$$addScopeClass($compileNodes);
      var namespace = null;
      return function publicLinkFn(scope, cloneConnectFn, options) {
        assertArg(scope, 'scope');

        options = options || {};
        var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
          transcludeControllers = options.transcludeControllers,
          futureParentElement = options.futureParentElement;

        // When `parentBoundTranscludeFn` is passed, it is a
        // `controllersBoundTransclude` function (it was previously passed
        // as `transclude` to directive.link) so we must unwrap it to get
        // its `boundTranscludeFn`
        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
          parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
        }

        if (!namespace) {
          namespace = detectNamespaceForChildElements(futureParentElement);
        }
        var $linkNode;
        if (namespace !== 'html') {
          // When using a directive with replace:true and templateUrl the $compileNodes
          // (or a child element inside of them)
          // might change, so we need to recreate the namespace adapted compileNodes
          // for call to the link function.
          // Note: This will already clone the nodes...
          $linkNode = jqLite(
            wrapTemplate(namespace, jqLite('<div>').append($compileNodes).html())
          );
        } else if (cloneConnectFn) {
          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
          // and sometimes changes the structure of the DOM.
          $linkNode = JQLitePrototype.clone.call($compileNodes);
        } else {
          $linkNode = $compileNodes;
        }

        if (transcludeControllers) {
          for (var controllerName in transcludeControllers) {
            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
          }
        }

        compile.$$addScopeInfo($linkNode, scope);

        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
        return $linkNode;
      };
    }

    function detectNamespaceForChildElements(parentElement) {
      // TODO: Make this detect MathML as well...
      var node = parentElement && parentElement[0];
      if (!node) {
        return 'html';
      } else {
        return nodeName_(node) !== 'foreignobject' && node.toString().match(/SVG/) ? 'svg' : 'html';
      }
    }

    /**
     * Compile function matches each node in nodeList against the directives. Once all directives
     * for a particular node are collected their compile functions are executed. The compile
     * functions return values - the linking functions - are combined into a composite linking
     * function, which is the a linking function for the node.
     *
     * @param {NodeList} nodeList an array of nodes or NodeList to compile
     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
     *        scope argument is auto-generated to the new child of the transcluded parent scope.
     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
     *        the rootElement must be set the jqLite collection of the compile root. This is
     *        needed so that the jqLite collection items can be replaced with widgets.
     * @param {number=} maxPriority Max directive priority.
     * @returns {Function} A composite linking function of all of the matched directives or null.
     */
    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
                            previousCompileContext) {
      var linkFns = [],
          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;

      for (var i = 0; i < nodeList.length; i++) {
        attrs = new Attributes();

        // we must always refer to nodeList[i] since the nodes can be replaced underneath us.
        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
                                        ignoreDirective);

        nodeLinkFn = (directives.length)
            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
                                      null, [], [], previousCompileContext)
            : null;

        if (nodeLinkFn && nodeLinkFn.scope) {
          compile.$$addScopeClass(attrs.$$element);
        }

        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
                      !(childNodes = nodeList[i].childNodes) ||
                      !childNodes.length)
            ? null
            : compileNodes(childNodes,
                 nodeLinkFn ? (
                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
                     && nodeLinkFn.transclude) : transcludeFn);

        if (nodeLinkFn || childLinkFn) {
          linkFns.push(i, nodeLinkFn, childLinkFn);
          linkFnFound = true;
          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
        }

        //use the previous context only for the first element in the virtual group
        previousCompileContext = null;
      }

      // return a linking function if we have found anything, null otherwise
      return linkFnFound ? compositeLinkFn : null;

      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
        var stableNodeList;


        if (nodeLinkFnFound) {
          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
          // offsets don't get screwed up
          var nodeListLength = nodeList.length;
          stableNodeList = new Array(nodeListLength);

          // create a sparse array by only copying the elements which have a linkFn
          for (i = 0; i < linkFns.length; i+=3) {
            idx = linkFns[i];
            stableNodeList[idx] = nodeList[idx];
          }
        } else {
          stableNodeList = nodeList;
        }

        for (i = 0, ii = linkFns.length; i < ii;) {
          node = stableNodeList[linkFns[i++]];
          nodeLinkFn = linkFns[i++];
          childLinkFn = linkFns[i++];

          if (nodeLinkFn) {
            if (nodeLinkFn.scope) {
              childScope = scope.$new();
              compile.$$addScopeInfo(jqLite(node), childScope);
              var destroyBindings = nodeLinkFn.$$destroyBindings;
              if (destroyBindings) {
                nodeLinkFn.$$destroyBindings = null;
                childScope.$on('$destroyed', destroyBindings);
              }
            } else {
              childScope = scope;
            }

            if (nodeLinkFn.transcludeOnThisElement) {
              childBoundTranscludeFn = createBoundTranscludeFn(
                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn);

            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
              childBoundTranscludeFn = parentBoundTranscludeFn;

            } else if (!parentBoundTranscludeFn && transcludeFn) {
              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);

            } else {
              childBoundTranscludeFn = null;
            }

            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn,
                       nodeLinkFn);

          } else if (childLinkFn) {
            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
          }
        }
      }
    }

    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {

      var boundTranscludeFn = function(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {

        if (!transcludedScope) {
          transcludedScope = scope.$new(false, containingScope);
          transcludedScope.$$transcluded = true;
        }

        return transcludeFn(transcludedScope, cloneFn, {
          parentBoundTranscludeFn: previousBoundTranscludeFn,
          transcludeControllers: controllers,
          futureParentElement: futureParentElement
        });
      };

      return boundTranscludeFn;
    }

    /**
     * Looks for directives on the given node and adds them to the directive collection which is
     * sorted.
     *
     * @param node Node to search.
     * @param directives An array to which the directives are added to. This array is sorted before
     *        the function returns.
     * @param attrs The shared attrs object which is used to populate the normalized attributes.
     * @param {number=} maxPriority Max directive priority.
     */
    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
      var nodeType = node.nodeType,
          attrsMap = attrs.$attr,
          match,
          className;

      switch (nodeType) {
        case NODE_TYPE_ELEMENT: /* Element */
          // use the node name: <directive>
          addDirective(directives,
              directiveNormalize(nodeName_(node)), 'E', maxPriority, ignoreDirective);

          // iterate over the attributes
          for (var attr, name, nName, ngAttrName, value, isNgAttr, nAttrs = node.attributes,
                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
            var attrStartName = false;
            var attrEndName = false;

            attr = nAttrs[j];
            name = attr.name;
            value = trim(attr.value);

            // support ngAttr attribute binding
            ngAttrName = directiveNormalize(name);
            if (isNgAttr = NG_ATTR_BINDING.test(ngAttrName)) {
              name = name.replace(PREFIX_REGEXP, '')
                .substr(8).replace(/_(.)/g, function(match, letter) {
                  return letter.toUpperCase();
                });
            }

            var directiveNName = ngAttrName.replace(/(Start|End)$/, '');
            if (directiveIsMultiElement(directiveNName)) {
              if (ngAttrName === directiveNName + 'Start') {
                attrStartName = name;
                attrEndName = name.substr(0, name.length - 5) + 'end';
                name = name.substr(0, name.length - 6);
              }
            }

            nName = directiveNormalize(name.toLowerCase());
            attrsMap[nName] = name;
            if (isNgAttr || !attrs.hasOwnProperty(nName)) {
                attrs[nName] = value;
                if (getBooleanAttrName(node, nName)) {
                  attrs[nName] = true; // presence means true
                }
            }
            addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
            addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
                          attrEndName);
          }

          // use class as directive
          className = node.className;
          if (isObject(className)) {
              // Maybe SVGAnimatedString
              className = className.animVal;
          }
          if (isString(className) && className !== '') {
            while (match = CLASS_DIRECTIVE_REGEXP.exec(className)) {
              nName = directiveNormalize(match[2]);
              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
                attrs[nName] = trim(match[3]);
              }
              className = className.substr(match.index + match[0].length);
            }
          }
          break;
        case NODE_TYPE_TEXT: /* Text Node */
          if (msie === 11) {
            // Workaround for #11781
            while (node.parentNode && node.nextSibling && node.nextSibling.nodeType === NODE_TYPE_TEXT) {
              node.nodeValue = node.nodeValue + node.nextSibling.nodeValue;
              node.parentNode.removeChild(node.nextSibling);
            }
          }
          addTextInterpolateDirective(directives, node.nodeValue);
          break;
        case NODE_TYPE_COMMENT: /* Comment */
          try {
            match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
            if (match) {
              nName = directiveNormalize(match[1]);
              if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
                attrs[nName] = trim(match[2]);
              }
            }
          } catch (e) {
            // turns out that under some circumstances IE9 throws errors when one attempts to read
            // comment's node value.
            // Just ignore it and continue. (Can't seem to reproduce in test case.)
          }
          break;
      }

      directives.sort(byPriority);
      return directives;
    }

    /**
     * Given a node with an directive-start it collects all of the siblings until it finds
     * directive-end.
     * @param node
     * @param attrStart
     * @param attrEnd
     * @returns {*}
     */
    function groupScan(node, attrStart, attrEnd) {
      var nodes = [];
      var depth = 0;
      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
        do {
          if (!node) {
            throw $compileMinErr('uterdir',
                      "Unterminated attribute, found '{0}' but no matching '{1}' found.",
                      attrStart, attrEnd);
          }
          if (node.nodeType == NODE_TYPE_ELEMENT) {
            if (node.hasAttribute(attrStart)) depth++;
            if (node.hasAttribute(attrEnd)) depth--;
          }
          nodes.push(node);
          node = node.nextSibling;
        } while (depth > 0);
      } else {
        nodes.push(node);
      }

      return jqLite(nodes);
    }

    /**
     * Wrapper for linking function which converts normal linking function into a grouped
     * linking function.
     * @param linkFn
     * @param attrStart
     * @param attrEnd
     * @returns {Function}
     */
    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
      return function(scope, element, attrs, controllers, transcludeFn) {
        element = groupScan(element[0], attrStart, attrEnd);
        return linkFn(scope, element, attrs, controllers, transcludeFn);
      };
    }

    /**
     * Once the directives have been collected, their compile functions are executed. This method
     * is responsible for inlining directive templates as well as terminating the application
     * of the directives if the terminal directive has been reached.
     *
     * @param {Array} directives Array of collected directives to execute their compile function.
     *        this needs to be pre-sorted by priority order.
     * @param {Node} compileNode The raw DOM node to apply the compile functions to
     * @param {Object} templateAttrs The shared attribute function
     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
     *                                                  scope argument is auto-generated to the new
     *                                                  child of the transcluded parent scope.
     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
     *                              argument has the root jqLite array so that we can replace nodes
     *                              on it.
     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
     *                                           compiling the transclusion.
     * @param {Array.<Function>} preLinkFns
     * @param {Array.<Function>} postLinkFns
     * @param {Object} previousCompileContext Context used for previous compilation of the current
     *                                        node
     * @returns {Function} linkFn
     */
    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
                                   previousCompileContext) {
      previousCompileContext = previousCompileContext || {};

      var terminalPriority = -Number.MAX_VALUE,
          newScopeDirective,
          controllerDirectives = previousCompileContext.controllerDirectives,
          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
          templateDirective = previousCompileContext.templateDirective,
          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
          hasTranscludeDirective = false,
          hasTemplate = false,
          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
          $compileNode = templateAttrs.$$element = jqLite(compileNode),
          directive,
          directiveName,
          $template,
          replaceDirective = originalReplaceDirective,
          childTranscludeFn = transcludeFn,
          linkFn,
          directiveValue;

      // executes all directives on the current element
      for (var i = 0, ii = directives.length; i < ii; i++) {
        directive = directives[i];
        var attrStart = directive.$$start;
        var attrEnd = directive.$$end;

        // collect multiblock sections
        if (attrStart) {
          $compileNode = groupScan(compileNode, attrStart, attrEnd);
        }
        $template = undefined;

        if (terminalPriority > directive.priority) {
          break; // prevent further processing of directives
        }

        if (directiveValue = directive.scope) {

          // skip the check for directives with async templates, we'll check the derived sync
          // directive when the template arrives
          if (!directive.templateUrl) {
            if (isObject(directiveValue)) {
              // This directive is trying to add an isolated scope.
              // Check that there is no scope of any kind already
              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
                                directive, $compileNode);
              newIsolateScopeDirective = directive;
            } else {
              // This directive is trying to add a child scope.
              // Check that there is no isolated scope already
              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
                                $compileNode);
            }
          }

          newScopeDirective = newScopeDirective || directive;
        }

        directiveName = directive.name;

        if (!directive.templateUrl && directive.controller) {
          directiveValue = directive.controller;
          controllerDirectives = controllerDirectives || createMap();
          assertNoDuplicate("'" + directiveName + "' controller",
              controllerDirectives[directiveName], directive, $compileNode);
          controllerDirectives[directiveName] = directive;
        }

        if (directiveValue = directive.transclude) {
          hasTranscludeDirective = true;

          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
          // This option should only be used by directives that know how to safely handle element transclusion,
          // where the transcluded nodes are added or replaced after linking.
          if (!directive.$$tlb) {
            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
            nonTlbTranscludeDirective = directive;
          }

          if (directiveValue == 'element') {
            hasElementTranscludeDirective = true;
            terminalPriority = directive.priority;
            $template = $compileNode;
            $compileNode = templateAttrs.$$element =
                jqLite(document.createComment(' ' + directiveName + ': ' +
                                              templateAttrs[directiveName] + ' '));
            compileNode = $compileNode[0];
            replaceWith(jqCollection, sliceArgs($template), compileNode);

            childTranscludeFn = compile($template, transcludeFn, terminalPriority,
                                        replaceDirective && replaceDirective.name, {
                                          // Don't pass in:
                                          // - controllerDirectives - otherwise we'll create duplicates controllers
                                          // - newIsolateScopeDirective or templateDirective - combining templates with
                                          //   element transclusion doesn't make sense.
                                          //
                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
                                          // on the same element more than once.
                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
                                        });
          } else {
            $template = jqLite(jqLiteClone(compileNode)).contents();
            $compileNode.empty(); // clear contents
            childTranscludeFn = compile($template, transcludeFn);
          }
        }

        if (directive.template) {
          hasTemplate = true;
          assertNoDuplicate('template', templateDirective, directive, $compileNode);
          templateDirective = directive;

          directiveValue = (isFunction(directive.template))
              ? directive.template($compileNode, templateAttrs)
              : directive.template;

          directiveValue = denormalizeTemplate(directiveValue);

          if (directive.replace) {
            replaceDirective = directive;
            if (jqLiteIsTextNode(directiveValue)) {
              $template = [];
            } else {
              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
            }
            compileNode = $template[0];

            if ($template.length != 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
              throw $compileMinErr('tplrt',
                  "Template for directive '{0}' must have exactly one root element. {1}",
                  directiveName, '');
            }

            replaceWith(jqCollection, $compileNode, compileNode);

            var newTemplateAttrs = {$attr: {}};

            // combine directives from the original node and from the template:
            // - take the array of directives for this element
            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
            // - collect directives from the template and sort them by priority
            // - combine directives as: processed + template + unprocessed
            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));

            if (newIsolateScopeDirective) {
              markDirectivesAsIsolate(templateDirectives);
            }
            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);

            ii = directives.length;
          } else {
            $compileNode.html(directiveValue);
          }
        }

        if (directive.templateUrl) {
          hasTemplate = true;
          assertNoDuplicate('template', templateDirective, directive, $compileNode);
          templateDirective = directive;

          if (directive.replace) {
            replaceDirective = directive;
          }

          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
                controllerDirectives: controllerDirectives,
                newIsolateScopeDirective: newIsolateScopeDirective,
                templateDirective: templateDirective,
                nonTlbTranscludeDirective: nonTlbTranscludeDirective
              });
          ii = directives.length;
        } else if (directive.compile) {
          try {
            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
            if (isFunction(linkFn)) {
              addLinkFns(null, linkFn, attrStart, attrEnd);
            } else if (linkFn) {
              addLinkFns(linkFn.pre, linkFn.post, attrStart, attrEnd);
            }
          } catch (e) {
            $exceptionHandler(e, startingTag($compileNode));
          }
        }

        if (directive.terminal) {
          nodeLinkFn.terminal = true;
          terminalPriority = Math.max(terminalPriority, directive.priority);
        }

      }

      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
      nodeLinkFn.templateOnThisElement = hasTemplate;
      nodeLinkFn.transclude = childTranscludeFn;

      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;

      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
      return nodeLinkFn;

      ////////////////////

      function addLinkFns(pre, post, attrStart, attrEnd) {
        if (pre) {
          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
          pre.require = directive.require;
          pre.directiveName = directiveName;
          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
          }
          preLinkFns.push(pre);
        }
        if (post) {
          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
          post.require = directive.require;
          post.directiveName = directiveName;
          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
            post = cloneAndAnnotateFn(post, {isolateScope: true});
          }
          postLinkFns.push(post);
        }
      }


      function getControllers(directiveName, require, $element, elementControllers) {
        var value;

        if (isString(require)) {
          var match = require.match(REQUIRE_PREFIX_REGEXP);
          var name = require.substring(match[0].length);
          var inheritType = match[1] || match[3];
          var optional = match[2] === '?';

          //If only parents then start at the parent element
          if (inheritType === '^^') {
            $element = $element.parent();
          //Otherwise attempt getting the controller from elementControllers in case
          //the element is transcluded (and has no data) and to avoid .data if possible
          } else {
            value = elementControllers && elementControllers[name];
            value = value && value.instance;
          }

          if (!value) {
            var dataName = '$' + name + 'Controller';
            value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
          }

          if (!value && !optional) {
            throw $compileMinErr('ctreq',
                "Controller '{0}', required by directive '{1}', can't be found!",
                name, directiveName);
          }
        } else if (isArray(require)) {
          value = [];
          for (var i = 0, ii = require.length; i < ii; i++) {
            value[i] = getControllers(directiveName, require[i], $element, elementControllers);
          }
        }

        return value || null;
      }

      function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope) {
        var elementControllers = createMap();
        for (var controllerKey in controllerDirectives) {
          var directive = controllerDirectives[controllerKey];
          var locals = {
            $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
            $element: $element,
            $attrs: attrs,
            $transclude: transcludeFn
          };

          var controller = directive.controller;
          if (controller == '@') {
            controller = attrs[directive.name];
          }

          var controllerInstance = $controller(controller, locals, true, directive.controllerAs);

          // For directives with element transclusion the element is a comment,
          // but jQuery .data doesn't support attaching data to comment nodes as it's hard to
          // clean up (http://bugs.jquery.com/ticket/8335).
          // Instead, we save the controllers for the element in a local hash and attach to .data
          // later, once we have the actual element.
          elementControllers[directive.name] = controllerInstance;
          if (!hasElementTranscludeDirective) {
            $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
          }
        }
        return elementControllers;
      }

      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn,
                          thisLinkFn) {
        var i, ii, linkFn, controller, isolateScope, elementControllers, transcludeFn, $element,
            attrs;

        if (compileNode === linkNode) {
          attrs = templateAttrs;
          $element = templateAttrs.$$element;
        } else {
          $element = jqLite(linkNode);
          attrs = new Attributes($element, templateAttrs);
        }

        if (newIsolateScopeDirective) {
          isolateScope = scope.$new(true);
        }

        if (boundTranscludeFn) {
          // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
          // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
          transcludeFn = controllersBoundTransclude;
          transcludeFn.$$boundTransclude = boundTranscludeFn;
        }

        if (controllerDirectives) {
          elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope);
        }

        if (newIsolateScopeDirective) {
          // Initialize isolate scope bindings for new isolate scope directive.
          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
              templateDirective === newIsolateScopeDirective.$$originalDirective)));
          compile.$$addScopeClass($element, true);
          isolateScope.$$isolateBindings =
              newIsolateScopeDirective.$$isolateBindings;
          initializeDirectiveBindings(scope, attrs, isolateScope,
                                      isolateScope.$$isolateBindings,
                                      newIsolateScopeDirective, isolateScope);
        }
        if (elementControllers) {
          // Initialize bindToController bindings for new/isolate scopes
          var scopeDirective = newIsolateScopeDirective || newScopeDirective;
          var bindings;
          var controllerForBindings;
          if (scopeDirective && elementControllers[scopeDirective.name]) {
            bindings = scopeDirective.$$bindings.bindToController;
            controller = elementControllers[scopeDirective.name];

            if (controller && controller.identifier && bindings) {
              controllerForBindings = controller;
              thisLinkFn.$$destroyBindings =
                  initializeDirectiveBindings(scope, attrs, controller.instance,
                                              bindings, scopeDirective);
            }
          }
          for (i in elementControllers) {
            controller = elementControllers[i];
            var controllerResult = controller();

            if (controllerResult !== controller.instance) {
              // If the controller constructor has a return value, overwrite the instance
              // from setupControllers and update the element data
              controller.instance = controllerResult;
              $element.data('$' + i + 'Controller', controllerResult);
              if (controller === controllerForBindings) {
                // Remove and re-install bindToController bindings
                thisLinkFn.$$destroyBindings();
                thisLinkFn.$$destroyBindings =
                  initializeDirectiveBindings(scope, attrs, controllerResult, bindings, scopeDirective);
              }
            }
          }
        }

        // PRELINKING
        for (i = 0, ii = preLinkFns.length; i < ii; i++) {
          linkFn = preLinkFns[i];
          invokeLinkFn(linkFn,
              linkFn.isolateScope ? isolateScope : scope,
              $element,
              attrs,
              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
              transcludeFn
          );
        }

        // RECURSION
        // We only pass the isolate scope, if the isolate directive has a template,
        // otherwise the child elements do not belong to the isolate directive.
        var scopeToChild = scope;
        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
          scopeToChild = isolateScope;
        }
        childLinkFn && childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);

        // POSTLINKING
        for (i = postLinkFns.length - 1; i >= 0; i--) {
          linkFn = postLinkFns[i];
          invokeLinkFn(linkFn,
              linkFn.isolateScope ? isolateScope : scope,
              $element,
              attrs,
              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
              transcludeFn
          );
        }

        // This is the function that is injected as `$transclude`.
        // Note: all arguments are optional!
        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement) {
          var transcludeControllers;

          // No scope passed in:
          if (!isScope(scope)) {
            futureParentElement = cloneAttachFn;
            cloneAttachFn = scope;
            scope = undefined;
          }

          if (hasElementTranscludeDirective) {
            transcludeControllers = elementControllers;
          }
          if (!futureParentElement) {
            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
          }
          return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
        }
      }
    }

    function markDirectivesAsIsolate(directives) {
      // mark all directives as needing isolate scope.
      for (var j = 0, jj = directives.length; j < jj; j++) {
        directives[j] = inherit(directives[j], {$$isolateScope: true});
      }
    }

    /**
     * looks up the directive and decorates it with exception handling and proper parameters. We
     * call this the boundDirective.
     *
     * @param {string} name name of the directive to look up.
     * @param {string} location The directive must be found in specific format.
     *   String containing any of theses characters:
     *
     *   * `E`: element name
     *   * `A': attribute
     *   * `C`: class
     *   * `M`: comment
     * @returns {boolean} true if directive was added.
     */
    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
                          endAttrName) {
      if (name === ignoreDirective) return null;
      var match = null;
      if (hasDirectives.hasOwnProperty(name)) {
        for (var directive, directives = $injector.get(name + Suffix),
            i = 0, ii = directives.length; i < ii; i++) {
          try {
            directive = directives[i];
            if ((maxPriority === undefined || maxPriority > directive.priority) &&
                 directive.restrict.indexOf(location) != -1) {
              if (startAttrName) {
                directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
              }
              tDirectives.push(directive);
              match = directive;
            }
          } catch (e) { $exceptionHandler(e); }
        }
      }
      return match;
    }


    /**
     * looks up the directive and returns true if it is a multi-element directive,
     * and therefore requires DOM nodes between -start and -end markers to be grouped
     * together.
     *
     * @param {string} name name of the directive to look up.
     * @returns true if directive was registered as multi-element.
     */
    function directiveIsMultiElement(name) {
      if (hasDirectives.hasOwnProperty(name)) {
        for (var directive, directives = $injector.get(name + Suffix),
            i = 0, ii = directives.length; i < ii; i++) {
          directive = directives[i];
          if (directive.multiElement) {
            return true;
          }
        }
      }
      return false;
    }

    /**
     * When the element is replaced with HTML template then the new attributes
     * on the template need to be merged with the existing attributes in the DOM.
     * The desired effect is to have both of the attributes present.
     *
     * @param {object} dst destination attributes (original DOM)
     * @param {object} src source attributes (from the directive template)
     */
    function mergeTemplateAttributes(dst, src) {
      var srcAttr = src.$attr,
          dstAttr = dst.$attr,
          $element = dst.$$element;

      // reapply the old attributes to the new element
      forEach(dst, function(value, key) {
        if (key.charAt(0) != '$') {
          if (src[key] && src[key] !== value) {
            value += (key === 'style' ? ';' : ' ') + src[key];
          }
          dst.$set(key, value, true, srcAttr[key]);
        }
      });

      // copy the new attributes on the old attrs object
      forEach(src, function(value, key) {
        if (key == 'class') {
          safeAddClass($element, value);
          dst['class'] = (dst['class'] ? dst['class'] + ' ' : '') + value;
        } else if (key == 'style') {
          $element.attr('style', $element.attr('style') + ';' + value);
          dst['style'] = (dst['style'] ? dst['style'] + ';' : '') + value;
          // `dst` will never contain hasOwnProperty as DOM parser won't let it.
          // You will get an "InvalidCharacterError: DOM Exception 5" error if you
          // have an attribute like "has-own-property" or "data-has-own-property", etc.
        } else if (key.charAt(0) != '$' && !dst.hasOwnProperty(key)) {
          dst[key] = value;
          dstAttr[key] = srcAttr[key];
        }
      });
    }


    function compileTemplateUrl(directives, $compileNode, tAttrs,
        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
      var linkQueue = [],
          afterTemplateNodeLinkFn,
          afterTemplateChildLinkFn,
          beforeTemplateCompileNode = $compileNode[0],
          origAsyncDirective = directives.shift(),
          derivedSyncDirective = inherit(origAsyncDirective, {
            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
          }),
          templateUrl = (isFunction(origAsyncDirective.templateUrl))
              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
              : origAsyncDirective.templateUrl,
          templateNamespace = origAsyncDirective.templateNamespace;

      $compileNode.empty();

      $templateRequest($sce.getTrustedResourceUrl(templateUrl))
        .then(function(content) {
          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;

          content = denormalizeTemplate(content);

          if (origAsyncDirective.replace) {
            if (jqLiteIsTextNode(content)) {
              $template = [];
            } else {
              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
            }
            compileNode = $template[0];

            if ($template.length != 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
              throw $compileMinErr('tplrt',
                  "Template for directive '{0}' must have exactly one root element. {1}",
                  origAsyncDirective.name, templateUrl);
            }

            tempTemplateAttrs = {$attr: {}};
            replaceWith($rootElement, $compileNode, compileNode);
            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);

            if (isObject(origAsyncDirective.scope)) {
              markDirectivesAsIsolate(templateDirectives);
            }
            directives = templateDirectives.concat(directives);
            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
          } else {
            compileNode = beforeTemplateCompileNode;
            $compileNode.html(content);
          }

          directives.unshift(derivedSyncDirective);

          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
              previousCompileContext);
          forEach($rootElement, function(node, i) {
            if (node == compileNode) {
              $rootElement[i] = $compileNode[0];
            }
          });
          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);

          while (linkQueue.length) {
            var scope = linkQueue.shift(),
                beforeTemplateLinkNode = linkQueue.shift(),
                linkRootElement = linkQueue.shift(),
                boundTranscludeFn = linkQueue.shift(),
                linkNode = $compileNode[0];

            if (scope.$$destroyed) continue;

            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
              var oldClasses = beforeTemplateLinkNode.className;

              if (!(previousCompileContext.hasElementTranscludeDirective &&
                  origAsyncDirective.replace)) {
                // it was cloned therefore we have to clone as well.
                linkNode = jqLiteClone(compileNode);
              }
              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);

              // Copy in CSS classes from original node
              safeAddClass(jqLite(linkNode), oldClasses);
            }
            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
            } else {
              childBoundTranscludeFn = boundTranscludeFn;
            }
            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
              childBoundTranscludeFn, afterTemplateNodeLinkFn);
          }
          linkQueue = null;
        });

      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
        var childBoundTranscludeFn = boundTranscludeFn;
        if (scope.$$destroyed) return;
        if (linkQueue) {
          linkQueue.push(scope,
                         node,
                         rootElement,
                         childBoundTranscludeFn);
        } else {
          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
          }
          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn,
                                  afterTemplateNodeLinkFn);
        }
      };
    }


    /**
     * Sorting function for bound directives.
     */
    function byPriority(a, b) {
      var diff = b.priority - a.priority;
      if (diff !== 0) return diff;
      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
      return a.index - b.index;
    }

    function assertNoDuplicate(what, previousDirective, directive, element) {

      function wrapModuleNameIfDefined(moduleName) {
        return moduleName ?
          (' (module: ' + moduleName + ')') :
          '';
      }

      if (previousDirective) {
        throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',
            previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
            directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
      }
    }


    function addTextInterpolateDirective(directives, text) {
      var interpolateFn = $interpolate(text, true);
      if (interpolateFn) {
        directives.push({
          priority: 0,
          compile: function textInterpolateCompileFn(templateNode) {
            var templateNodeParent = templateNode.parent(),
                hasCompileParent = !!templateNodeParent.length;

            // When transcluding a template that has bindings in the root
            // we don't have a parent and thus need to add the class during linking fn.
            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);

            return function textInterpolateLinkFn(scope, node) {
              var parent = node.parent();
              if (!hasCompileParent) compile.$$addBindingClass(parent);
              compile.$$addBindingInfo(parent, interpolateFn.expressions);
              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
                node[0].nodeValue = value;
              });
            };
          }
        });
      }
    }


    function wrapTemplate(type, template) {
      type = lowercase(type || 'html');
      switch (type) {
      case 'svg':
      case 'math':
        var wrapper = document.createElement('div');
        wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
        return wrapper.childNodes[0].childNodes;
      default:
        return template;
      }
    }


    function getTrustedContext(node, attrNormalizedName) {
      if (attrNormalizedName == "srcdoc") {
        return $sce.HTML;
      }
      var tag = nodeName_(node);
      // maction[xlink:href] can source SVG.  It's not limited to <maction>.
      if (attrNormalizedName == "xlinkHref" ||
          (tag == "form" && attrNormalizedName == "action") ||
          (tag != "img" && (attrNormalizedName == "src" ||
                            attrNormalizedName == "ngSrc"))) {
        return $sce.RESOURCE_URL;
      }
    }


    function addAttrInterpolateDirective(node, directives, value, name, allOrNothing) {
      var trustedContext = getTrustedContext(node, name);
      allOrNothing = ALL_OR_NOTHING_ATTRS[name] || allOrNothing;

      var interpolateFn = $interpolate(value, true, trustedContext, allOrNothing);

      // no interpolation found -> ignore
      if (!interpolateFn) return;


      if (name === "multiple" && nodeName_(node) === "select") {
        throw $compileMinErr("selmulti",
            "Binding to the 'multiple' attribute is not supported. Element: {0}",
            startingTag(node));
      }

      directives.push({
        priority: 100,
        compile: function() {
            return {
              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
                var $$observers = (attr.$$observers || (attr.$$observers = {}));

                if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
                  throw $compileMinErr('nodomevents',
                      "Interpolations for HTML DOM event attributes are disallowed.  Please use the " +
                          "ng- versions (such as ng-click instead of onclick) instead.");
                }

                // If the attribute has changed since last $interpolate()ed
                var newValue = attr[name];
                if (newValue !== value) {
                  // we need to interpolate again since the attribute value has been updated
                  // (e.g. by another directive's compile function)
                  // ensure unset/empty values make interpolateFn falsy
                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
                  value = newValue;
                }

                // if attribute was updated so that there is no interpolation going on we don't want to
                // register any observers
                if (!interpolateFn) return;

                // initialize attr object so that it's ready in case we need the value for isolate
                // scope initialization, otherwise the value would not be available from isolate
                // directive's linking fn during linking phase
                attr[name] = interpolateFn(scope);

                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
                (attr.$$observers && attr.$$observers[name].$$scope || scope).
                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
                    //special case for class attribute addition + removal
                    //so that class changes can tap into the animation
                    //hooks provided by the $animate service. Be sure to
                    //skip animations when the first digest occurs (when
                    //both the new and the old values are the same) since
                    //the CSS classes are the non-interpolated values
                    if (name === 'class' && newValue != oldValue) {
                      attr.$updateClass(newValue, oldValue);
                    } else {
                      attr.$set(name, newValue);
                    }
                  });
              }
            };
          }
      });
    }


    /**
     * This is a special jqLite.replaceWith, which can replace items which
     * have no parents, provided that the containing jqLite collection is provided.
     *
     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
     *                               in the root of the tree.
     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
     *                                  the shell, but replace its DOM node reference.
     * @param {Node} newNode The new DOM node.
     */
    function replaceWith($rootElement, elementsToRemove, newNode) {
      var firstElementToRemove = elementsToRemove[0],
          removeCount = elementsToRemove.length,
          parent = firstElementToRemove.parentNode,
          i, ii;

      if ($rootElement) {
        for (i = 0, ii = $rootElement.length; i < ii; i++) {
          if ($rootElement[i] == firstElementToRemove) {
            $rootElement[i++] = newNode;
            for (var j = i, j2 = j + removeCount - 1,
                     jj = $rootElement.length;
                 j < jj; j++, j2++) {
              if (j2 < jj) {
                $rootElement[j] = $rootElement[j2];
              } else {
                delete $rootElement[j];
              }
            }
            $rootElement.length -= removeCount - 1;

            // If the replaced element is also the jQuery .context then replace it
            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
            // http://api.jquery.com/context/
            if ($rootElement.context === firstElementToRemove) {
              $rootElement.context = newNode;
            }
            break;
          }
        }
      }

      if (parent) {
        parent.replaceChild(newNode, firstElementToRemove);
      }

      // TODO(perf): what's this document fragment for? is it needed? can we at least reuse it?
      var fragment = document.createDocumentFragment();
      fragment.appendChild(firstElementToRemove);

      if (jqLite.hasData(firstElementToRemove)) {
        // Copy over user data (that includes Angular's $scope etc.). Don't copy private
        // data here because there's no public interface in jQuery to do that and copying over
        // event listeners (which is the main use of private data) wouldn't work anyway.
        jqLite(newNode).data(jqLite(firstElementToRemove).data());

        // Remove data of the replaced element. We cannot just call .remove()
        // on the element it since that would deallocate scope that is needed
        // for the new node. Instead, remove the data "manually".
        if (!jQuery) {
          delete jqLite.cache[firstElementToRemove[jqLite.expando]];
        } else {
          // jQuery 2.x doesn't expose the data storage. Use jQuery.cleanData to clean up after
          // the replaced element. The cleanData version monkey-patched by Angular would cause
          // the scope to be trashed and we do need the very same scope to work with the new
          // element. However, we cannot just cache the non-patched version and use it here as
          // that would break if another library patches the method after Angular does (one
          // example is jQuery UI). Instead, set a flag indicating scope destroying should be
          // skipped this one time.
          skipDestroyOnNextJQueryCleanData = true;
          jQuery.cleanData([firstElementToRemove]);
        }
      }

      for (var k = 1, kk = elementsToRemove.length; k < kk; k++) {
        var element = elementsToRemove[k];
        jqLite(element).remove(); // must do this way to clean up expando
        fragment.appendChild(element);
        delete elementsToRemove[k];
      }

      elementsToRemove[0] = newNode;
      elementsToRemove.length = 1;
    }


    function cloneAndAnnotateFn(fn, annotation) {
      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
    }


    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
      try {
        linkFn(scope, $element, attrs, controllers, transcludeFn);
      } catch (e) {
        $exceptionHandler(e, startingTag($element));
      }
    }


    // Set up $watches for isolate scope and controller bindings. This process
    // only occurs for isolate scopes and new scopes with controllerAs.
    function initializeDirectiveBindings(scope, attrs, destination, bindings,
                                         directive, newScope) {
      var onNewScopeDestroyed;
      forEach(bindings, function(definition, scopeName) {
        var attrName = definition.attrName,
        optional = definition.optional,
        mode = definition.mode, // @, =, or &
        lastValue,
        parentGet, parentSet, compare;

        if (!hasOwnProperty.call(attrs, attrName)) {
          // In the case of user defined a binding with the same name as a method in Object.prototype but didn't set
          // the corresponding attribute. We need to make sure subsequent code won't access to the prototype function
          attrs[attrName] = undefined;
        }

        switch (mode) {

          case '@':
            if (!attrs[attrName] && !optional) {
              destination[scopeName] = undefined;
            }

            attrs.$observe(attrName, function(value) {
              destination[scopeName] = value;
            });
            attrs.$$observers[attrName].$$scope = scope;
            if (attrs[attrName]) {
              // If the attribute has been provided then we trigger an interpolation to ensure
              // the value is there for use in the link fn
              destination[scopeName] = $interpolate(attrs[attrName])(scope);
            }
            break;

          case '=':
            if (optional && !attrs[attrName]) {
              return;
            }
            parentGet = $parse(attrs[attrName]);

            if (parentGet.literal) {
              compare = equals;
            } else {
              compare = function(a, b) { return a === b || (a !== a && b !== b); };
            }
            parentSet = parentGet.assign || function() {
              // reset the change, or we will throw this exception on every $digest
              lastValue = destination[scopeName] = parentGet(scope);
              throw $compileMinErr('nonassign',
                  "Expression '{0}' used with directive '{1}' is non-assignable!",
                  attrs[attrName], directive.name);
            };
            lastValue = destination[scopeName] = parentGet(scope);
            var parentValueWatch = function parentValueWatch(parentValue) {
              if (!compare(parentValue, destination[scopeName])) {
                // we are out of sync and need to copy
                if (!compare(parentValue, lastValue)) {
                  // parent changed and it has precedence
                  destination[scopeName] = parentValue;
                } else {
                  // if the parent can be assigned then do so
                  parentSet(scope, parentValue = destination[scopeName]);
                }
              }
              return lastValue = parentValue;
            };
            parentValueWatch.$stateful = true;
            var unwatch;
            if (definition.collection) {
              unwatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
            } else {
              unwatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
            }
            onNewScopeDestroyed = (onNewScopeDestroyed || []);
            onNewScopeDestroyed.push(unwatch);
            break;

          case '&':
            parentGet = $parse(attrs[attrName]);

            // Don't assign noop to destination if expression is not valid
            if (parentGet === noop && optional) break;

            destination[scopeName] = function(locals) {
              return parentGet(scope, locals);
            };
            break;
        }
      });
      var destroyBindings = onNewScopeDestroyed ? function destroyBindings() {
        for (var i = 0, ii = onNewScopeDestroyed.length; i < ii; ++i) {
          onNewScopeDestroyed[i]();
        }
      } : noop;
      if (newScope && destroyBindings !== noop) {
        newScope.$on('$destroy', destroyBindings);
        return noop;
      }
      return destroyBindings;
    }
  }];
}

var PREFIX_REGEXP = /^((?:x|data)[\:\-_])/i;
/**
 * Converts all accepted directives format into proper directive name.
 * @param name Name to normalize
 */
function directiveNormalize(name) {
  return camelCase(name.replace(PREFIX_REGEXP, ''));
}

/**
 * @ngdoc type
 * @name $compile.directive.Attributes
 *
 * @description
 * A shared object between directive compile / linking functions which contains normalized DOM
 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
 * needed since all of these are treated as equivalent in Angular:
 *
 * ```
 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
 * ```
 */

/**
 * @ngdoc property
 * @name $compile.directive.Attributes#$attr
 *
 * @description
 * A map of DOM element attribute names to the normalized name. This is
 * needed to do reverse lookup from normalized name back to actual name.
 */


/**
 * @ngdoc method
 * @name $compile.directive.Attributes#$set
 * @kind function
 *
 * @description
 * Set DOM element attribute value.
 *
 *
 * @param {string} name Normalized element attribute name of the property to modify. The name is
 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
 *          property to the original name.
 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
 */



/**
 * Closure compiler type information
 */

function nodesetLinkingFn(
  /* angular.Scope */ scope,
  /* NodeList */ nodeList,
  /* Element */ rootElement,
  /* function(Function) */ boundTranscludeFn
) {}

function directiveLinkingFn(
  /* nodesetLinkingFn */ nodesetLinkingFn,
  /* angular.Scope */ scope,
  /* Node */ node,
  /* Element */ rootElement,
  /* function(Function) */ boundTranscludeFn
) {}

function tokenDifference(str1, str2) {
  var values = '',
      tokens1 = str1.split(/\s+/),
      tokens2 = str2.split(/\s+/);

  outer:
  for (var i = 0; i < tokens1.length; i++) {
    var token = tokens1[i];
    for (var j = 0; j < tokens2.length; j++) {
      if (token == tokens2[j]) continue outer;
    }
    values += (values.length > 0 ? ' ' : '') + token;
  }
  return values;
}

function removeComments(jqNodes) {
  jqNodes = jqLite(jqNodes);
  var i = jqNodes.length;

  if (i <= 1) {
    return jqNodes;
  }

  while (i--) {
    var node = jqNodes[i];
    if (node.nodeType === NODE_TYPE_COMMENT) {
      splice.call(jqNodes, i, 1);
    }
  }
  return jqNodes;
}

var $controllerMinErr = minErr('$controller');


var CNTRL_REG = /^(\S+)(\s+as\s+(\w+))?$/;
function identifierForController(controller, ident) {
  if (ident && isString(ident)) return ident;
  if (isString(controller)) {
    var match = CNTRL_REG.exec(controller);
    if (match) return match[3];
  }
}


/**
 * @ngdoc provider
 * @name $controllerProvider
 * @description
 * The {@link ng.$controller $controller service} is used by Angular to create new
 * controllers.
 *
 * This provider allows controller registration via the
 * {@link ng.$controllerProvider#register register} method.
 */
function $ControllerProvider() {
  var controllers = {},
      globals = false;

  /**
   * @ngdoc method
   * @name $controllerProvider#register
   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
   *    the names and the values are the constructors.
   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
   *    annotations in the array notation).
   */
  this.register = function(name, constructor) {
    assertNotHasOwnProperty(name, 'controller');
    if (isObject(name)) {
      extend(controllers, name);
    } else {
      controllers[name] = constructor;
    }
  };

  /**
   * @ngdoc method
   * @name $controllerProvider#allowGlobals
   * @description If called, allows `$controller` to find controller constructors on `window`
   */
  this.allowGlobals = function() {
    globals = true;
  };


  this.$get = ['$injector', '$window', function($injector, $window) {

    /**
     * @ngdoc service
     * @name $controller
     * @requires $injector
     *
     * @param {Function|string} constructor If called with a function then it's considered to be the
     *    controller constructor function. Otherwise it's considered to be a string which is used
     *    to retrieve the controller constructor using the following steps:
     *
     *    * check if a controller with given name is registered via `$controllerProvider`
     *    * check if evaluating the string on the current scope returns a constructor
     *    * if $controllerProvider#allowGlobals, check `window[constructor]` on the global
     *      `window` object (not recommended)
     *
     *    The string can use the `controller as property` syntax, where the controller instance is published
     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
     *    to work correctly.
     *
     * @param {Object} locals Injection locals for Controller.
     * @return {Object} Instance of given controller.
     *
     * @description
     * `$controller` service is responsible for instantiating controllers.
     *
     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
     */
    return function(expression, locals, later, ident) {
      // PRIVATE API:
      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
      //                     If true, $controller will allocate the object with the correct
      //                     prototype chain, but will not invoke the controller until a returned
      //                     callback is invoked.
      //   param `ident` --- An optional label which overrides the label parsed from the controller
      //                     expression, if any.
      var instance, match, constructor, identifier;
      later = later === true;
      if (ident && isString(ident)) {
        identifier = ident;
      }

      if (isString(expression)) {
        match = expression.match(CNTRL_REG);
        if (!match) {
          throw $controllerMinErr('ctrlfmt',
            "Badly formed controller string '{0}'. " +
            "Must match `__name__ as __id__` or `__name__`.", expression);
        }
        constructor = match[1],
        identifier = identifier || match[3];
        expression = controllers.hasOwnProperty(constructor)
            ? controllers[constructor]
            : getter(locals.$scope, constructor, true) ||
                (globals ? getter($window, constructor, true) : undefined);

        assertArgFn(expression, constructor, true);
      }

      if (later) {
        // Instantiate controller later:
        // This machinery is used to create an instance of the object before calling the
        // controller's constructor itself.
        //
        // This allows properties to be added to the controller before the constructor is
        // invoked. Primarily, this is used for isolate scope bindings in $compile.
        //
        // This feature is not intended for use by applications, and is thus not documented
        // publicly.
        // Object creation: http://jsperf.com/create-constructor/2
        var controllerPrototype = (isArray(expression) ?
          expression[expression.length - 1] : expression).prototype;
        instance = Object.create(controllerPrototype || null);

        if (identifier) {
          addIdentifier(locals, identifier, instance, constructor || expression.name);
        }

        var instantiate;
        return instantiate = extend(function() {
          var result = $injector.invoke(expression, instance, locals, constructor);
          if (result !== instance && (isObject(result) || isFunction(result))) {
            instance = result;
            if (identifier) {
              // If result changed, re-assign controllerAs value to scope.
              addIdentifier(locals, identifier, instance, constructor || expression.name);
            }
          }
          return instance;
        }, {
          instance: instance,
          identifier: identifier
        });
      }

      instance = $injector.instantiate(expression, locals, constructor);

      if (identifier) {
        addIdentifier(locals, identifier, instance, constructor || expression.name);
      }

      return instance;
    };

    function addIdentifier(locals, identifier, instance, name) {
      if (!(locals && isObject(locals.$scope))) {
        throw minErr('$controller')('noscp',
          "Cannot export controller '{0}' as '{1}'! No $scope object provided via `locals`.",
          name, identifier);
      }

      locals.$scope[identifier] = instance;
    }
  }];
}

/**
 * @ngdoc service
 * @name $document
 * @requires $window
 *
 * @description
 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
 *
 * @example
   <example module="documentExample">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <p>$document title: <b ng-bind="title"></b></p>
         <p>window.document title: <b ng-bind="windowTitle"></b></p>
       </div>
     </file>
     <file name="script.js">
       angular.module('documentExample', [])
         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
           $scope.title = $document[0].title;
           $scope.windowTitle = angular.element(window.document)[0].title;
         }]);
     </file>
   </example>
 */
function $DocumentProvider() {
  this.$get = ['$window', function(window) {
    return jqLite(window.document);
  }];
}

/**
 * @ngdoc service
 * @name $exceptionHandler
 * @requires ng.$log
 *
 * @description
 * Any uncaught exception in angular expressions is delegated to this service.
 * The default implementation simply delegates to `$log.error` which logs it into
 * the browser console.
 *
 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
 *
 * ## Example:
 *
 * ```js
 *   angular.module('exceptionOverride', []).factory('$exceptionHandler', function() {
 *     return function(exception, cause) {
 *       exception.message += ' (caused by "' + cause + '")';
 *       throw exception;
 *     };
 *   });
 * ```
 *
 * This example will override the normal action of `$exceptionHandler`, to make angular
 * exceptions fail hard when they happen, instead of just logging to the console.
 *
 * <hr />
 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
 * (unless executed during a digest).
 *
 * If you wish, you can manually delegate exceptions, e.g.
 * `try { ... } catch(e) { $exceptionHandler(e); }`
 *
 * @param {Error} exception Exception associated with the error.
 * @param {string=} cause optional information about the context in which
 *       the error was thrown.
 *
 */
function $ExceptionHandlerProvider() {
  this.$get = ['$log', function($log) {
    return function(exception, cause) {
      $log.error.apply($log, arguments);
    };
  }];
}

var APPLICATION_JSON = 'application/json';
var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
var JSON_START = /^\[|^\{(?!\{)/;
var JSON_ENDS = {
  '[': /]$/,
  '{': /}$/
};
var JSON_PROTECTION_PREFIX = /^\)\]\}',?\n/;

function serializeValue(v) {
  if (isObject(v)) {
    return isDate(v) ? v.toISOString() : toJson(v);
  }
  return v;
}


function $HttpParamSerializerProvider() {
  /**
   * @ngdoc service
   * @name $httpParamSerializer
   * @description
   *
   * Default {@link $http `$http`} params serializer that converts objects to strings
   * according to the following rules:
   *
   * * `{'foo': 'bar'}` results in `foo=bar`
   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D"` (stringified and encoded representation of an object)
   *
   * Note that serializer will sort the request parameters alphabetically.
   * */

  this.$get = function() {
    return function ngParamSerializer(params) {
      if (!params) return '';
      var parts = [];
      forEachSorted(params, function(value, key) {
        if (value === null || isUndefined(value)) return;
        if (isArray(value)) {
          forEach(value, function(v, k) {
            parts.push(encodeUriQuery(key)  + '=' + encodeUriQuery(serializeValue(v)));
          });
        } else {
          parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
        }
      });

      return parts.join('&');
    };
  };
}

function $HttpParamSerializerJQLikeProvider() {
  /**
   * @ngdoc service
   * @name $httpParamSerializerJQLike
   * @description
   *
   * Alternative {@link $http `$http`} params serializer that follows
   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
   * The serializer will also sort the params alphabetically.
   *
   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
   *
   * ```js
   * $http({
   *   url: myUrl,
   *   method: 'GET',
   *   params: myParams,
   *   paramSerializer: '$httpParamSerializerJQLike'
   * });
   * ```
   *
   * It is also possible to set it as the default `paramSerializer` in the
   * {@link $httpProvider#defaults `$httpProvider`}.
   *
   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
   * form data for submission:
   *
   * ```js
   * .controller(function($http, $httpParamSerializerJQLike) {
   *   //...
   *
   *   $http({
   *     url: myUrl,
   *     method: 'POST',
   *     data: $httpParamSerializerJQLike(myData),
   *     headers: {
   *       'Content-Type': 'application/x-www-form-urlencoded'
   *     }
   *   });
   *
   * });
   * ```
   *
   * */
  this.$get = function() {
    return function jQueryLikeParamSerializer(params) {
      if (!params) return '';
      var parts = [];
      serialize(params, '', true);
      return parts.join('&');

      function serialize(toSerialize, prefix, topLevel) {
        if (toSerialize === null || isUndefined(toSerialize)) return;
        if (isArray(toSerialize)) {
          forEach(toSerialize, function(value) {
            serialize(value, prefix + '[]');
          });
        } else if (isObject(toSerialize) && !isDate(toSerialize)) {
          forEachSorted(toSerialize, function(value, key) {
            serialize(value, prefix +
                (topLevel ? '' : '[') +
                key +
                (topLevel ? '' : ']'));
          });
        } else {
          parts.push(encodeUriQuery(prefix) + '=' + encodeUriQuery(serializeValue(toSerialize)));
        }
      }
    };
  };
}

function defaultHttpResponseTransform(data, headers) {
  if (isString(data)) {
    // Strip json vulnerability protection prefix and trim whitespace
    var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();

    if (tempData) {
      var contentType = headers('Content-Type');
      if ((contentType && (contentType.indexOf(APPLICATION_JSON) === 0)) || isJsonLike(tempData)) {
        data = fromJson(tempData);
      }
    }
  }

  return data;
}

function isJsonLike(str) {
    var jsonStart = str.match(JSON_START);
    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
}

/**
 * Parse headers into key value object
 *
 * @param {string} headers Raw headers as a string
 * @returns {Object} Parsed headers as key value object
 */
function parseHeaders(headers) {
  var parsed = createMap(), i;

  function fillInParsed(key, val) {
    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  }

  if (isString(headers)) {
    forEach(headers.split('\n'), function(line) {
      i = line.indexOf(':');
      fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
    });
  } else if (isObject(headers)) {
    forEach(headers, function(headerVal, headerKey) {
      fillInParsed(lowercase(headerKey), trim(headerVal));
    });
  }

  return parsed;
}


/**
 * Returns a function that provides access to parsed headers.
 *
 * Headers are lazy parsed when first requested.
 * @see parseHeaders
 *
 * @param {(string|Object)} headers Headers to provide access to.
 * @returns {function(string=)} Returns a getter function which if called with:
 *
 *   - if called with single an argument returns a single header value or null
 *   - if called with no arguments returns an object containing all headers.
 */
function headersGetter(headers) {
  var headersObj;

  return function(name) {
    if (!headersObj) headersObj =  parseHeaders(headers);

    if (name) {
      var value = headersObj[lowercase(name)];
      if (value === void 0) {
        value = null;
      }
      return value;
    }

    return headersObj;
  };
}


/**
 * Chain all given functions
 *
 * This function is used for both request and response transforming
 *
 * @param {*} data Data to transform.
 * @param {function(string=)} headers HTTP headers getter fn.
 * @param {number} status HTTP status code of the response.
 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
 * @returns {*} Transformed data.
 */
function transformData(data, headers, status, fns) {
  if (isFunction(fns)) {
    return fns(data, headers, status);
  }

  forEach(fns, function(fn) {
    data = fn(data, headers, status);
  });

  return data;
}


function isSuccess(status) {
  return 200 <= status && status < 300;
}


/**
 * @ngdoc provider
 * @name $httpProvider
 * @description
 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
 * */
function $HttpProvider() {
  /**
   * @ngdoc property
   * @name $httpProvider#defaults
   * @description
   *
   * Object containing default values for all {@link ng.$http $http} requests.
   *
   * - **`defaults.cache`** - {Object} - an object built with {@link ng.$cacheFactory `$cacheFactory`}
   * that will provide the cache for all requests who set their `cache` property to `true`.
   * If you set the `default.cache = false` then only requests that specify their own custom
   * cache object will be cached. See {@link $http#caching $http Caching} for more information.
   *
   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
   * Defaults value is `'XSRF-TOKEN'`.
   *
   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
   *
   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
   * setting default headers.
   *     - **`defaults.headers.common`**
   *     - **`defaults.headers.post`**
   *     - **`defaults.headers.put`**
   *     - **`defaults.headers.patch`**
   *
   *
   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
   *  used to the prepare string representation of request parameters (specified as an object).
   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
   *
   **/
  var defaults = this.defaults = {
    // transform incoming response data
    transformResponse: [defaultHttpResponseTransform],

    // transform outgoing request data
    transformRequest: [function(d) {
      return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
    }],

    // default headers
    headers: {
      common: {
        'Accept': 'application/json, text/plain, */*'
      },
      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
    },

    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',

    paramSerializer: '$httpParamSerializer'
  };

  var useApplyAsync = false;
  /**
   * @ngdoc method
   * @name $httpProvider#useApplyAsync
   * @description
   *
   * Configure $http service to combine processing of multiple http responses received at around
   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
   * significant performance improvement for bigger applications that make many HTTP requests
   * concurrently (common during application bootstrap).
   *
   * Defaults to false. If no value is specified, returns the current configured value.
   *
   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
   *    to load and share the same digest cycle.
   *
   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
   *    otherwise, returns the current configured value.
   **/
  this.useApplyAsync = function(value) {
    if (isDefined(value)) {
      useApplyAsync = !!value;
      return this;
    }
    return useApplyAsync;
  };

  /**
   * @ngdoc property
   * @name $httpProvider#interceptors
   * @description
   *
   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
   * pre-processing of request or postprocessing of responses.
   *
   * These service factories are ordered by request, i.e. they are applied in the same order as the
   * array, on request, but reverse order, on response.
   *
   * {@link ng.$http#interceptors Interceptors detailed info}
   **/
  var interceptorFactories = this.interceptors = [];

  this.$get = ['$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector',
      function($httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector) {

    var defaultCache = $cacheFactory('$http');

    /**
     * Make sure that default param serializer is exposed as a function
     */
    defaults.paramSerializer = isString(defaults.paramSerializer) ?
      $injector.get(defaults.paramSerializer) : defaults.paramSerializer;

    /**
     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
     * The reversal is needed so that we can build up the interception chain around the
     * server request.
     */
    var reversedInterceptors = [];

    forEach(interceptorFactories, function(interceptorFactory) {
      reversedInterceptors.unshift(isString(interceptorFactory)
          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
    });

    /**
     * @ngdoc service
     * @kind function
     * @name $http
     * @requires ng.$httpBackend
     * @requires $cacheFactory
     * @requires $rootScope
     * @requires $q
     * @requires $injector
     *
     * @description
     * The `$http` service is a core Angular service that facilitates communication with the remote
     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
     *
     * For unit testing applications that use `$http` service, see
     * {@link ngMock.$httpBackend $httpBackend mock}.
     *
     * For a higher level of abstraction, please check out the {@link ngResource.$resource
     * $resource} service.
     *
     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
     * it is important to familiarize yourself with these APIs and the guarantees they provide.
     *
     *
     * ## General usage
     * The `$http` service is a function which takes a single argument — a configuration object —
     * that is used to generate an HTTP request and returns  a {@link ng.$q promise}
     * with two $http specific methods: `success` and `error`.
     *
     * ```js
     *   // Simple GET request example :
     *   $http.get('/someUrl').
     *     success(function(data, status, headers, config) {
     *       // this callback will be called asynchronously
     *       // when the response is available
     *     }).
     *     error(function(data, status, headers, config) {
     *       // called asynchronously if an error occurs
     *       // or server returns response with an error status.
     *     });
     * ```
     *
     * ```js
     *   // Simple POST request example (passing data) :
     *   $http.post('/someUrl', {msg:'hello word!'}).
     *     success(function(data, status, headers, config) {
     *       // this callback will be called asynchronously
     *       // when the response is available
     *     }).
     *     error(function(data, status, headers, config) {
     *       // called asynchronously if an error occurs
     *       // or server returns response with an error status.
     *     });
     * ```
     *
     *
     * Since the returned value of calling the $http function is a `promise`, you can also use
     * the `then` method to register callbacks, and these callbacks will receive a single argument –
     * an object representing the response. See the API signature and type info below for more
     * details.
     *
     * A response status code between 200 and 299 is considered a success status and
     * will result in the success callback being called. Note that if the response is a redirect,
     * XMLHttpRequest will transparently follow it, meaning that the error callback will not be
     * called for such responses.
     *
     * ## Writing Unit Tests that use $http
     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
     * request using trained responses.
     *
     * ```
     * $httpBackend.expectGET(...);
     * $http.get(...);
     * $httpBackend.flush();
     * ```
     *
     * ## Shortcut methods
     *
     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
     * request data must be passed in for POST/PUT requests.
     *
     * ```js
     *   $http.get('/someUrl').success(successCallback);
     *   $http.post('/someUrl', data).success(successCallback);
     * ```
     *
     * Complete list of shortcut methods:
     *
     * - {@link ng.$http#get $http.get}
     * - {@link ng.$http#head $http.head}
     * - {@link ng.$http#post $http.post}
     * - {@link ng.$http#put $http.put}
     * - {@link ng.$http#delete $http.delete}
     * - {@link ng.$http#jsonp $http.jsonp}
     * - {@link ng.$http#patch $http.patch}
     *
     *
     * ## Setting HTTP Headers
     *
     * The $http service will automatically add certain HTTP headers to all requests. These defaults
     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
     * object, which currently contains this default configuration:
     *
     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
     *   - `Accept: application/json, text/plain, * / *`
     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
     *   - `Content-Type: application/json`
     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
     *   - `Content-Type: application/json`
     *
     * To add or overwrite these defaults, simply add or remove a property from these configuration
     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
     * with the lowercased HTTP method name as the key, e.g.
     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
     *
     * The defaults can also be set at runtime via the `$http.defaults` object in the same
     * fashion. For example:
     *
     * ```
     * module.run(function($http) {
     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w'
     * });
     * ```
     *
     * In addition, you can supply a `headers` property in the config object passed when
     * calling `$http(config)`, which overrides the defaults without changing them globally.
     *
     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
     * Use the `headers` property, setting the desired header to `undefined`. For example:
     *
     * ```js
     * var req = {
     *  method: 'POST',
     *  url: 'http://example.com',
     *  headers: {
     *    'Content-Type': undefined
     *  },
     *  data: { test: 'test' }
     * }
     *
     * $http(req).success(function(){...}).error(function(){...});
     * ```
     *
     * ## Transforming Requests and Responses
     *
     * Both requests and responses can be transformed using transformation functions: `transformRequest`
     * and `transformResponse`. These properties can be a single function that returns
     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
     *
     * ### Default Transformations
     *
     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
     * `defaults.transformResponse` properties. If a request does not provide its own transformations
     * then these will be applied.
     *
     * You can augment or replace the default transformations by modifying these properties by adding to or
     * replacing the array.
     *
     * Angular provides the following default transformations:
     *
     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`):
     *
     * - If the `data` property of the request configuration object contains an object, serialize it
     *   into JSON format.
     *
     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`):
     *
     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
     *  - If JSON response is detected, deserialize it using a JSON parser.
     *
     *
     * ### Overriding the Default Transformations Per Request
     *
     * If you wish override the request/response transformations only for a single request then provide
     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
     * into `$http`.
     *
     * Note that if you provide these properties on the config object the default transformations will be
     * overwritten. If you wish to augment the default transformations then you must include them in your
     * local transformation array.
     *
     * The following code demonstrates adding a new response transformation to be run after the default response
     * transformations have been run.
     *
     * ```js
     * function appendTransform(defaults, transform) {
     *
     *   // We can't guarantee that the default transformation is an array
     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
     *
     *   // Append the new transformation to the defaults
     *   return defaults.concat(transform);
     * }
     *
     * $http({
     *   url: '...',
     *   method: 'GET',
     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
     *     return doTransform(value);
     *   })
     * });
     * ```
     *
     *
     * ## Caching
     *
     * To enable caching, set the request configuration `cache` property to `true` (to use default
     * cache) or to a custom cache object (built with {@link ng.$cacheFactory `$cacheFactory`}).
     * When the cache is enabled, `$http` stores the response from the server in the specified
     * cache. The next time the same request is made, the response is served from the cache without
     * sending a request to the server.
     *
     * Note that even if the response is served from cache, delivery of the data is asynchronous in
     * the same way that real requests are.
     *
     * If there are multiple GET requests for the same URL that should be cached using the same
     * cache, but the cache is not populated yet, only one request to the server will be made and
     * the remaining requests will be fulfilled using the response from the first request.
     *
     * You can change the default cache to a new object (built with
     * {@link ng.$cacheFactory `$cacheFactory`}) by updating the
     * {@link ng.$http#defaults `$http.defaults.cache`} property. All requests who set
     * their `cache` property to `true` will now use this cache object.
     *
     * If you set the default cache to `false` then only requests that specify their own custom
     * cache object will be cached.
     *
     * ## Interceptors
     *
     * Before you start creating interceptors, be sure to understand the
     * {@link ng.$q $q and deferred/promise APIs}.
     *
     * For purposes of global error handling, authentication, or any kind of synchronous or
     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
     * able to intercept requests before they are handed to the server and
     * responses before they are handed over to the application code that
     * initiated these requests. The interceptors leverage the {@link ng.$q
     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
     *
     * The interceptors are service factories that are registered with the `$httpProvider` by
     * adding them to the `$httpProvider.interceptors` array. The factory is called and
     * injected with dependencies (if specified) and returns the interceptor.
     *
     * There are two kinds of interceptors (and two kinds of rejection interceptors):
     *
     *   * `request`: interceptors get called with a http `config` object. The function is free to
     *     modify the `config` object or create a new one. The function needs to return the `config`
     *     object directly, or a promise containing the `config` or a new `config` object.
     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
     *     resolved with a rejection.
     *   * `response`: interceptors get called with http `response` object. The function is free to
     *     modify the `response` object or create a new one. The function needs to return the `response`
     *     object directly, or as a promise containing the `response` or a new `response` object.
     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
     *     resolved with a rejection.
     *
     *
     * ```js
     *   // register the interceptor as a service
     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
     *     return {
     *       // optional method
     *       'request': function(config) {
     *         // do something on success
     *         return config;
     *       },
     *
     *       // optional method
     *      'requestError': function(rejection) {
     *         // do something on error
     *         if (canRecover(rejection)) {
     *           return responseOrNewPromise
     *         }
     *         return $q.reject(rejection);
     *       },
     *
     *
     *
     *       // optional method
     *       'response': function(response) {
     *         // do something on success
     *         return response;
     *       },
     *
     *       // optional method
     *      'responseError': function(rejection) {
     *         // do something on error
     *         if (canRecover(rejection)) {
     *           return responseOrNewPromise
     *         }
     *         return $q.reject(rejection);
     *       }
     *     };
     *   });
     *
     *   $httpProvider.interceptors.push('myHttpInterceptor');
     *
     *
     *   // alternatively, register the interceptor via an anonymous factory
     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
     *     return {
     *      'request': function(config) {
     *          // same as above
     *       },
     *
     *       'response': function(response) {
     *          // same as above
     *       }
     *     };
     *   });
     * ```
     *
     * ## Security Considerations
     *
     * When designing web applications, consider security threats from:
     *
     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
     *
     * Both server and the client must cooperate in order to eliminate these threats. Angular comes
     * pre-configured with strategies that address these issues, but for this to work backend server
     * cooperation is required.
     *
     * ### JSON Vulnerability Protection
     *
     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
     * allows third party website to turn your JSON resource URL into
     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
     * Angular will automatically strip the prefix before processing it as JSON.
     *
     * For example if your server needs to return:
     * ```js
     * ['one','two']
     * ```
     *
     * which is vulnerable to attack, your server can return:
     * ```js
     * )]}',
     * ['one','two']
     * ```
     *
     * Angular will strip the prefix, before processing the JSON.
     *
     *
     * ### Cross Site Request Forgery (XSRF) Protection
     *
     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is a technique by which
     * an unauthorized site can gain your user's private data. Angular provides a mechanism
     * to counter XSRF. When performing XHR requests, the $http service reads a token from a cookie
     * (by default, `XSRF-TOKEN`) and sets it as an HTTP header (`X-XSRF-TOKEN`). Since only
     * JavaScript that runs on your domain could read the cookie, your server can be assured that
     * the XHR came from JavaScript running on your domain. The header will not be set for
     * cross-domain requests.
     *
     * To take advantage of this, your server needs to set a token in a JavaScript readable session
     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
     * server can verify that the cookie matches `X-XSRF-TOKEN` HTTP header, and therefore be sure
     * that only JavaScript running on your domain could have sent the request. The token must be
     * unique for each user and must be verifiable by the server (to prevent the JavaScript from
     * making up its own tokens). We recommend that the token is a digest of your site's
     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
     * for added security.
     *
     * The name of the headers can be specified using the xsrfHeaderName and xsrfCookieName
     * properties of either $httpProvider.defaults at config-time, $http.defaults at run-time,
     * or the per-request config object.
     *
     * In order to prevent collisions in environments where multiple Angular apps share the
     * same domain or subdomain, we recommend that each application uses unique cookie name.
     *
     *
     * @param {object} config Object describing the request to be made and how it should be
     *    processed. The object has following properties:
     *
     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
     *    - **url** – `{string}` – Absolute or relative URL of the resource that is being requested.
     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
     *      with the `paramSerializer` and appended as GET parameters.
     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
     *      HTTP headers to send to the server. If the return value of a function is null, the
     *      header will not be sent. Functions accept a config object as an argument.
     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
     *    - **transformRequest** –
     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
     *      transform function or an array of such functions. The transform function takes the http
     *      request body and headers and returns its transformed (typically serialized) version.
     *      See {@link ng.$http#overriding-the-default-transformations-per-request
     *      Overriding the Default Transformations}
     *    - **transformResponse** –
     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
     *      transform function or an array of such functions. The transform function takes the http
     *      response body, headers and status and returns its transformed (typically deserialized) version.
     *      See {@link ng.$http#overriding-the-default-transformations-per-request
     *      Overriding the Default TransformationjqLiks}
     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
     *      prepare the string representation of request parameters (specified as an object).
     *      If specified as string, it is interpreted as function registered with the
     *      {@link $injector $injector}, which means you can create your own serializer
     *      by registering it as a {@link auto.$provide#service service}.
     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
     *    - **cache** – `{boolean|Cache}` – If true, a default $http cache will be used to cache the
     *      GET request, otherwise if a cache instance built with
     *      {@link ng.$cacheFactory $cacheFactory}, this cache will be used for
     *      caching.
     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
     *      that should abort the request when resolved.
     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
     *      for more information.
     *    - **responseType** - `{string}` - see
     *      [requestType](https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#responseType).
     *
     * @returns {HttpPromise} Returns a {@link ng.$q promise} object with the
     *   standard `then` method and two http specific methods: `success` and `error`. The `then`
     *   method takes two arguments a success and an error callback which will be called with a
     *   response object. The `success` and `error` methods take a single argument - a function that
     *   will be called when the request succeeds or fails respectively. The arguments passed into
     *   these functions are destructured representation of the response object passed into the
     *   `then` method. The response object has these properties:
     *
     *   - **data** – `{string|Object}` – The response body transformed with the transform
     *     functions.
     *   - **status** – `{number}` – HTTP status code of the response.
     *   - **headers** – `{function([headerName])}` – Header getter function.
     *   - **config** – `{Object}` – The configuration object that was used to generate the request.
     *   - **statusText** – `{string}` – HTTP status text of the response.
     *
     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
     *   requests. This is primarily meant to be used for debugging purposes.
     *
     *
     * @example
<example module="httpExample">
<file name="index.html">
  <div ng-controller="FetchController">
    <select ng-model="method" aria-label="Request method">
      <option>GET</option>
      <option>JSONP</option>
    </select>
    <input type="text" ng-model="url" size="80" aria-label="URL" />
    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
    <button id="samplejsonpbtn"
      ng-click="updateModel('JSONP',
                    'https://angularjs.org/greet.php?callback=JSON_CALLBACK&name=Super%20Hero')">
      Sample JSONP
    </button>
    <button id="invalidjsonpbtn"
      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist&callback=JSON_CALLBACK')">
        Invalid JSONP
      </button>
    <pre>http status code: {{status}}</pre>
    <pre>http response data: {{data}}</pre>
  </div>
</file>
<file name="script.js">
  angular.module('httpExample', [])
    .controller('FetchController', ['$scope', '$http', '$templateCache',
      function($scope, $http, $templateCache) {
        $scope.method = 'GET';
        $scope.url = 'http-hello.html';

        $scope.fetch = function() {
          $scope.code = null;
          $scope.response = null;

          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
            success(function(data, status) {
              $scope.status = status;
              $scope.data = data;
            }).
            error(function(data, status) {
              $scope.data = data || "Request failed";
              $scope.status = status;
          });
        };

        $scope.updateModel = function(method, url) {
          $scope.method = method;
          $scope.url = url;
        };
      }]);
</file>
<file name="http-hello.html">
  Hello, $http!
</file>
<file name="protractor.js" type="protractor">
  var status = element(by.binding('status'));
  var data = element(by.binding('data'));
  var fetchBtn = element(by.id('fetchbtn'));
  var sampleGetBtn = element(by.id('samplegetbtn'));
  var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));

  it('should make an xhr GET request', function() {
    sampleGetBtn.click();
    fetchBtn.click();
    expect(status.getText()).toMatch('200');
    expect(data.getText()).toMatch(/Hello, \$http!/);
  });

// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
// it('should make a JSONP request to angularjs.org', function() {
//   sampleJsonpBtn.click();
//   fetchBtn.click();
//   expect(status.getText()).toMatch('200');
//   expect(data.getText()).toMatch(/Super Hero!/);
// });

  it('should make JSONP request to invalid URL and invoke the error handler',
      function() {
    invalidJsonpBtn.click();
    fetchBtn.click();
    expect(status.getText()).toMatch('0');
    expect(data.getText()).toMatch('Request failed');
  });
</file>
</example>
     */
    function $http(requestConfig) {

      if (!angular.isObject(requestConfig)) {
        throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
      }

      var config = extend({
        method: 'get',
        transformRequest: defaults.transformRequest,
        transformResponse: defaults.transformResponse,
        paramSerializer: defaults.paramSerializer
      }, requestConfig);

      config.headers = mergeHeaders(requestConfig);
      config.method = uppercase(config.method);
      config.paramSerializer = isString(config.paramSerializer) ?
        $injector.get(config.paramSerializer) : config.paramSerializer;

      var serverRequest = function(config) {
        var headers = config.headers;
        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);

        // strip content-type if data is undefined
        if (isUndefined(reqData)) {
          forEach(headers, function(value, header) {
            if (lowercase(header) === 'content-type') {
                delete headers[header];
            }
          });
        }

        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
          config.withCredentials = defaults.withCredentials;
        }

        // send request
        return sendReq(config, reqData).then(transformResponse, transformResponse);
      };

      var chain = [serverRequest, undefined];
      var promise = $q.when(config);

      // apply interceptors
      forEach(reversedInterceptors, function(interceptor) {
        if (interceptor.request || interceptor.requestError) {
          chain.unshift(interceptor.request, interceptor.requestError);
        }
        if (interceptor.response || interceptor.responseError) {
          chain.push(interceptor.response, interceptor.responseError);
        }
      });

      while (chain.length) {
        var thenFn = chain.shift();
        var rejectFn = chain.shift();

        promise = promise.then(thenFn, rejectFn);
      }

      promise.success = function(fn) {
        assertArgFn(fn, 'fn');

        promise.then(function(response) {
          fn(response.data, response.status, response.headers, config);
        });
        return promise;
      };

      promise.error = function(fn) {
        assertArgFn(fn, 'fn');

        promise.then(null, function(response) {
          fn(response.data, response.status, response.headers, config);
        });
        return promise;
      };

      return promise;

      function transformResponse(response) {
        // make a copy since the response must be cacheable
        var resp = extend({}, response);
        if (!response.data) {
          resp.data = response.data;
        } else {
          resp.data = transformData(response.data, response.headers, response.status, config.transformResponse);
        }
        return (isSuccess(response.status))
          ? resp
          : $q.reject(resp);
      }

      function executeHeaderFns(headers, config) {
        var headerContent, processedHeaders = {};

        forEach(headers, function(headerFn, header) {
          if (isFunction(headerFn)) {
            headerContent = headerFn(config);
            if (headerContent != null) {
              processedHeaders[header] = headerContent;
            }
          } else {
            processedHeaders[header] = headerFn;
          }
        });

        return processedHeaders;
      }

      function mergeHeaders(config) {
        var defHeaders = defaults.headers,
            reqHeaders = extend({}, config.headers),
            defHeaderName, lowercaseDefHeaderName, reqHeaderName;

        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);

        // using for-in instead of forEach to avoid unecessary iteration after header has been found
        defaultHeadersIteration:
        for (defHeaderName in defHeaders) {
          lowercaseDefHeaderName = lowercase(defHeaderName);

          for (reqHeaderName in reqHeaders) {
            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
              continue defaultHeadersIteration;
            }
          }

          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
        }

        // execute if header value is a function for merged headers
        return executeHeaderFns(reqHeaders, shallowCopy(config));
      }
    }

    $http.pendingRequests = [];

    /**
     * @ngdoc method
     * @name $http#get
     *
     * @description
     * Shortcut method to perform `GET` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {Object=} config Optional configuration object
     * @returns {HttpPromise} Future object
     */

    /**
     * @ngdoc method
     * @name $http#delete
     *
     * @description
     * Shortcut method to perform `DELETE` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {Object=} config Optional configuration object
     * @returns {HttpPromise} Future object
     */

    /**
     * @ngdoc method
     * @name $http#head
     *
     * @description
     * Shortcut method to perform `HEAD` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {Object=} config Optional configuration object
     * @returns {HttpPromise} Future object
     */

    /**
     * @ngdoc method
     * @name $http#jsonp
     *
     * @description
     * Shortcut method to perform `JSONP` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request.
     *                     The name of the callback should be the string `JSON_CALLBACK`.
     * @param {Object=} config Optional configuration object
     * @returns {HttpPromise} Future object
     */
    createShortMethods('get', 'delete', 'head', 'jsonp');

    /**
     * @ngdoc method
     * @name $http#post
     *
     * @description
     * Shortcut method to perform `POST` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {*} data Request content
     * @param {Object=} config Optional configuration object
     * @returns {HttpPromise} Future object
     */

    /**
     * @ngdoc method
     * @name $http#put
     *
     * @description
     * Shortcut method to perform `PUT` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {*} data Request content
     * @param {Object=} config Optional configuration object
     * @returns {HttpPromise} Future object
     */

     /**
      * @ngdoc method
      * @name $http#patch
      *
      * @description
      * Shortcut method to perform `PATCH` request.
      *
      * @param {string} url Relative or absolute URL specifying the destination of the request
      * @param {*} data Request content
      * @param {Object=} config Optional configuration object
      * @returns {HttpPromise} Future object
      */
    createShortMethodsWithData('post', 'put', 'patch');

        /**
         * @ngdoc property
         * @name $http#defaults
         *
         * @description
         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
         * default headers, withCredentials as well as request and response transformations.
         *
         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
         */
    $http.defaults = defaults;


    return $http;


    function createShortMethods(names) {
      forEach(arguments, function(name) {
        $http[name] = function(url, config) {
          return $http(extend({}, config || {}, {
            method: name,
            url: url
          }));
        };
      });
    }


    function createShortMethodsWithData(name) {
      forEach(arguments, function(name) {
        $http[name] = function(url, data, config) {
          return $http(extend({}, config || {}, {
            method: name,
            url: url,
            data: data
          }));
        };
      });
    }


    /**
     * Makes the request.
     *
     * !!! ACCESSES CLOSURE VARS:
     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
     */
    function sendReq(config, reqData) {
      var deferred = $q.defer(),
          promise = deferred.promise,
          cache,
          cachedResp,
          reqHeaders = config.headers,
          url = buildUrl(config.url, config.paramSerializer(config.params));

      $http.pendingRequests.push(config);
      promise.then(removePendingReq, removePendingReq);


      if ((config.cache || defaults.cache) && config.cache !== false &&
          (config.method === 'GET' || config.method === 'JSONP')) {
        cache = isObject(config.cache) ? config.cache
              : isObject(defaults.cache) ? defaults.cache
              : defaultCache;
      }

      if (cache) {
        cachedResp = cache.get(url);
        if (isDefined(cachedResp)) {
          if (isPromiseLike(cachedResp)) {
            // cached request has already been sent, but there is no response yet
            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
          } else {
            // serving from cache
            if (isArray(cachedResp)) {
              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3]);
            } else {
              resolvePromise(cachedResp, 200, {}, 'OK');
            }
          }
        } else {
          // put the promise for the non-transformed response into cache as a placeholder
          cache.put(url, promise);
        }
      }


      // if we won't have the response in cache, set the xsrf headers and
      // send the request to the backend
      if (isUndefined(cachedResp)) {
        var xsrfValue = urlIsSameOrigin(config.url)
            ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
            : undefined;
        if (xsrfValue) {
          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
        }

        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
            config.withCredentials, config.responseType);
      }

      return promise;


      /**
       * Callback registered to $httpBackend():
       *  - caches the response if desired
       *  - resolves the raw $http promise
       *  - calls $apply
       */
      function done(status, response, headersString, statusText) {
        if (cache) {
          if (isSuccess(status)) {
            cache.put(url, [status, response, parseHeaders(headersString), statusText]);
          } else {
            // remove promise from the cache
            cache.remove(url);
          }
        }

        function resolveHttpPromise() {
          resolvePromise(response, status, headersString, statusText);
        }

        if (useApplyAsync) {
          $rootScope.$applyAsync(resolveHttpPromise);
        } else {
          resolveHttpPromise();
          if (!$rootScope.$$phase) $rootScope.$apply();
        }
      }


      /**
       * Resolves the raw $http promise.
       */
      function resolvePromise(response, status, headers, statusText) {
        // normalize internal statuses to 0
        status = Math.max(status, 0);

        (isSuccess(status) ? deferred.resolve : deferred.reject)({
          data: response,
          status: status,
          headers: headersGetter(headers),
          config: config,
          statusText: statusText
        });
      }

      function resolvePromiseWithResult(result) {
        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText);
      }

      function removePendingReq() {
        var idx = $http.pendingRequests.indexOf(config);
        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
      }
    }


    function buildUrl(url, serializedParams) {
      if (serializedParams.length > 0) {
        url += ((url.indexOf('?') == -1) ? '?' : '&') + serializedParams;
      }
      return url;
    }
  }];
}

function createXhr() {
    return new window.XMLHttpRequest();
}

/**
 * @ngdoc service
 * @name $httpBackend
 * @requires $window
 * @requires $document
 *
 * @description
 * HTTP backend used by the {@link ng.$http service} that delegates to
 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
 *
 * You should never need to use this service directly, instead use the higher-level abstractions:
 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
 *
 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
 * $httpBackend} which can be trained with responses.
 */
function $HttpBackendProvider() {
  this.$get = ['$browser', '$window', '$document', function($browser, $window, $document) {
    return createHttpBackend($browser, createXhr, $browser.defer, $window.angular.callbacks, $document[0]);
  }];
}

function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
  // TODO(vojta): fix the signature
  return function(method, url, post, callback, headers, timeout, withCredentials, responseType) {
    $browser.$$incOutstandingRequestCount();
    url = url || $browser.url();

    if (lowercase(method) == 'jsonp') {
      var callbackId = '_' + (callbacks.counter++).toString(36);
      callbacks[callbackId] = function(data) {
        callbacks[callbackId].data = data;
        callbacks[callbackId].called = true;
      };

      var jsonpDone = jsonpReq(url.replace('JSON_CALLBACK', 'angular.callbacks.' + callbackId),
          callbackId, function(status, text) {
        completeRequest(callback, status, callbacks[callbackId].data, "", text);
        callbacks[callbackId] = noop;
      });
    } else {

      var xhr = createXhr();

      xhr.open(method, url, true);
      forEach(headers, function(value, key) {
        if (isDefined(value)) {
            xhr.setRequestHeader(key, value);
        }
      });

      xhr.onload = function requestLoaded() {
        var statusText = xhr.statusText || '';

        // responseText is the old-school way of retrieving response (supported by IE8 & 9)
        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
        var response = ('response' in xhr) ? xhr.response : xhr.responseText;

        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
        var status = xhr.status === 1223 ? 204 : xhr.status;

        // fix status code when it is 0 (0 status is undocumented).
        // Occurs when accessing file resources or on Android 4.1 stock browser
        // while retrieving files from application cache.
        if (status === 0) {
          status = response ? 200 : urlResolve(url).protocol == 'file' ? 404 : 0;
        }

        completeRequest(callback,
            status,
            response,
            xhr.getAllResponseHeaders(),
            statusText);
      };

      var requestError = function() {
        // The response is always empty
        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
        completeRequest(callback, -1, null, null, '');
      };

      xhr.onerror = requestError;
      xhr.onabort = requestError;

      if (withCredentials) {
        xhr.withCredentials = true;
      }

      if (responseType) {
        try {
          xhr.responseType = responseType;
        } catch (e) {
          // WebKit added support for the json responseType value on 09/03/2013
          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
          // known to throw when setting the value "json" as the response type. Other older
          // browsers implementing the responseType
          //
          // The json response type can be ignored if not supported, because JSON payloads are
          // parsed on the client-side regardless.
          if (responseType !== 'json') {
            throw e;
          }
        }
      }

      xhr.send(post);
    }

    if (timeout > 0) {
      var timeoutId = $browserDefer(timeoutRequest, timeout);
    } else if (isPromiseLike(timeout)) {
      timeout.then(timeoutRequest);
    }


    function timeoutRequest() {
      jsonpDone && jsonpDone();
      xhr && xhr.abort();
    }

    function completeRequest(callback, status, response, headersString, statusText) {
      // cancel timeout and subsequent timeout promise resolution
      if (timeoutId !== undefined) {
        $browserDefer.cancel(timeoutId);
      }
      jsonpDone = xhr = null;

      callback(status, response, headersString, statusText);
      $browser.$$completeOutstandingRequest(noop);
    }
  };

  function jsonpReq(url, callbackId, done) {
    // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
    // - fetches local scripts via XHR and evals them
    // - adds and immediately removes script elements from the document
    var script = rawDocument.createElement('script'), callback = null;
    script.type = "text/javascript";
    script.src = url;
    script.async = true;

    callback = function(event) {
      removeEventListenerFn(script, "load", callback);
      removeEventListenerFn(script, "error", callback);
      rawDocument.body.removeChild(script);
      script = null;
      var status = -1;
      var text = "unknown";

      if (event) {
        if (event.type === "load" && !callbacks[callbackId].called) {
          event = { type: "error" };
        }
        text = event.type;
        status = event.type === "error" ? 404 : 200;
      }

      if (done) {
        done(status, text);
      }
    };

    addEventListenerFn(script, "load", callback);
    addEventListenerFn(script, "error", callback);
    rawDocument.body.appendChild(script);
    return callback;
  }
}

var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
$interpolateMinErr.throwNoconcat = function(text) {
  throw $interpolateMinErr('noconcat',
      "Error while interpolating: {0}\nStrict Contextual Escaping disallows " +
      "interpolations that concatenate multiple expressions when a trusted value is " +
      "required.  See http://docs.angularjs.org/api/ng.$sce", text);
};

$interpolateMinErr.interr = function(text, err) {
  return $interpolateMinErr('interr', "Can't interpolate: {0}\n{1}", text, err.toString());
};

/**
 * @ngdoc provider
 * @name $interpolateProvider
 *
 * @description
 *
 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
 *
 * @example
<example module="customInterpolationApp">
<file name="index.html">
<script>
  var customInterpolationApp = angular.module('customInterpolationApp', []);

  customInterpolationApp.config(function($interpolateProvider) {
    $interpolateProvider.startSymbol('//');
    $interpolateProvider.endSymbol('//');
  });


  customInterpolationApp.controller('DemoController', function() {
      this.label = "This binding is brought you by // interpolation symbols.";
  });
</script>
<div ng-app="App" ng-controller="DemoController as demo">
    //demo.label//
</div>
</file>
<file name="protractor.js" type="protractor">
  it('should interpolate binding with custom symbols', function() {
    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
  });
</file>
</example>
 */
function $InterpolateProvider() {
  var startSymbol = '{{';
  var endSymbol = '}}';

  /**
   * @ngdoc method
   * @name $interpolateProvider#startSymbol
   * @description
   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
   *
   * @param {string=} value new value to set the starting symbol to.
   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
   */
  this.startSymbol = function(value) {
    if (value) {
      startSymbol = value;
      return this;
    } else {
      return startSymbol;
    }
  };

  /**
   * @ngdoc method
   * @name $interpolateProvider#endSymbol
   * @description
   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
   *
   * @param {string=} value new value to set the ending symbol to.
   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
   */
  this.endSymbol = function(value) {
    if (value) {
      endSymbol = value;
      return this;
    } else {
      return endSymbol;
    }
  };


  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
    var startSymbolLength = startSymbol.length,
        endSymbolLength = endSymbol.length,
        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');

    function escape(ch) {
      return '\\\\\\' + ch;
    }

    function unescapeText(text) {
      return text.replace(escapedStartRegexp, startSymbol).
        replace(escapedEndRegexp, endSymbol);
    }

    function stringify(value) {
      if (value == null) { // null || undefined
        return '';
      }
      switch (typeof value) {
        case 'string':
          break;
        case 'number':
          value = '' + value;
          break;
        default:
          value = toJson(value);
      }

      return value;
    }

    /**
     * @ngdoc service
     * @name $interpolate
     * @kind function
     *
     * @requires $parse
     * @requires $sce
     *
     * @description
     *
     * Compiles a string with markup into an interpolation function. This service is used by the
     * HTML {@link ng.$compile $compile} service for data binding. See
     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
     * interpolation markup.
     *
     *
     * ```js
     *   var $interpolate = ...; // injected
     *   var exp = $interpolate('Hello {{name | uppercase}}!');
     *   expect(exp({name:'Angular'}).toEqual('Hello ANGULAR!');
     * ```
     *
     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
     * `true`, the interpolation function will return `undefined` unless all embedded expressions
     * evaluate to a value other than `undefined`.
     *
     * ```js
     *   var $interpolate = ...; // injected
     *   var context = {greeting: 'Hello', name: undefined };
     *
     *   // default "forgiving" mode
     *   var exp = $interpolate('{{greeting}} {{name}}!');
     *   expect(exp(context)).toEqual('Hello !');
     *
     *   // "allOrNothing" mode
     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
     *   expect(exp(context)).toBeUndefined();
     *   context.name = 'Angular';
     *   expect(exp(context)).toEqual('Hello Angular!');
     * ```
     *
     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
     *
     * ####Escaped Interpolation
     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
     * or binding.
     *
     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
     * degree, while also enabling code examples to work without relying on the
     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
     *
     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
     * interpolation start/end markers with their escaped counterparts.**
     *
     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
     * output when the $interpolate service processes the text. So, for HTML elements interpolated
     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
     * this is typically useful only when user-data is used in rendering a template from the server, or
     * when otherwise untrusted data is used by a directive.
     *
     * <example>
     *  <file name="index.html">
     *    <div ng-init="username='A user'">
     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
     *        </p>
     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
     *        application, but fails to accomplish their task, because the server has correctly
     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
     *        characters.</p>
     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
     *        from the database by an administrator.</p>
     *    </div>
     *  </file>
     * </example>
     *
     * @param {string} text The text with markup to interpolate.
     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
     *    embedded expression in order to return an interpolation function. Strings with no
     *    embedded expression will return null for the interpolation function.
     * @param {string=} trustedContext when provided, the returned function passes the interpolated
     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
     *    provides Strict Contextual Escaping for details.
     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
     *    unless all embedded expressions evaluate to a value other than `undefined`.
     * @returns {function(context)} an interpolation function which is used to compute the
     *    interpolated string. The function has these parameters:
     *
     * - `context`: evaluation context for all expressions embedded in the interpolated text
     */
    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
      allOrNothing = !!allOrNothing;
      var startIndex,
          endIndex,
          index = 0,
          expressions = [],
          parseFns = [],
          textLength = text.length,
          exp,
          concat = [],
          expressionPositions = [];

      while (index < textLength) {
        if (((startIndex = text.indexOf(startSymbol, index)) != -1) &&
             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) != -1)) {
          if (index !== startIndex) {
            concat.push(unescapeText(text.substring(index, startIndex)));
          }
          exp = text.substring(startIndex + startSymbolLength, endIndex);
          expressions.push(exp);
          parseFns.push($parse(exp, parseStringifyInterceptor));
          index = endIndex + endSymbolLength;
          expressionPositions.push(concat.length);
          concat.push('');
        } else {
          // we did not find an interpolation, so we have to add the remainder to the separators array
          if (index !== textLength) {
            concat.push(unescapeText(text.substring(index)));
          }
          break;
        }
      }

      // Concatenating expressions makes it hard to reason about whether some combination of
      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
      // single expression be used for iframe[src], object[src], etc., we ensure that the value
      // that's used is assigned or constructed by some JS code somewhere that is more testable or
      // make it obvious that you bound the value to some user controlled value.  This helps reduce
      // the load when auditing for XSS issues.
      if (trustedContext && concat.length > 1) {
          $interpolateMinErr.throwNoconcat(text);
      }

      if (!mustHaveExpression || expressions.length) {
        var compute = function(values) {
          for (var i = 0, ii = expressions.length; i < ii; i++) {
            if (allOrNothing && isUndefined(values[i])) return;
            concat[expressionPositions[i]] = values[i];
          }
          return concat.join('');
        };

        var getValue = function(value) {
          return trustedContext ?
            $sce.getTrusted(trustedContext, value) :
            $sce.valueOf(value);
        };

        return extend(function interpolationFn(context) {
            var i = 0;
            var ii = expressions.length;
            var values = new Array(ii);

            try {
              for (; i < ii; i++) {
                values[i] = parseFns[i](context);
              }

              return compute(values);
            } catch (err) {
              $exceptionHandler($interpolateMinErr.interr(text, err));
            }

          }, {
          // all of these properties are undocumented for now
          exp: text, //just for compatibility with regular watchers created via $watch
          expressions: expressions,
          $$watchDelegate: function(scope, listener) {
            var lastValue;
            return scope.$watchGroup(parseFns, function interpolateFnWatcher(values, oldValues) {
              var currValue = compute(values);
              if (isFunction(listener)) {
                listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
              }
              lastValue = currValue;
            });
          }
        });
      }

      function parseStringifyInterceptor(value) {
        try {
          value = getValue(value);
          return allOrNothing && !isDefined(value) ? value : stringify(value);
        } catch (err) {
          $exceptionHandler($interpolateMinErr.interr(text, err));
        }
      }
    }


    /**
     * @ngdoc method
     * @name $interpolate#startSymbol
     * @description
     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
     *
     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
     * the symbol.
     *
     * @returns {string} start symbol.
     */
    $interpolate.startSymbol = function() {
      return startSymbol;
    };


    /**
     * @ngdoc method
     * @name $interpolate#endSymbol
     * @description
     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
     *
     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
     * the symbol.
     *
     * @returns {string} end symbol.
     */
    $interpolate.endSymbol = function() {
      return endSymbol;
    };

    return $interpolate;
  }];
}

function $IntervalProvider() {
  this.$get = ['$rootScope', '$window', '$q', '$$q',
       function($rootScope,   $window,   $q,   $$q) {
    var intervals = {};


     /**
      * @ngdoc service
      * @name $interval
      *
      * @description
      * Angular's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
      * milliseconds.
      *
      * The return value of registering an interval function is a promise. This promise will be
      * notified upon each tick of the interval, and will be resolved after `count` iterations, or
      * run indefinitely if `count` is not defined. The value of the notification will be the
      * number of iterations that have run.
      * To cancel an interval, call `$interval.cancel(promise)`.
      *
      * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
      * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
      * time.
      *
      * <div class="alert alert-warning">
      * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
      * with them.  In particular they are not automatically destroyed when a controller's scope or a
      * directive's element are destroyed.
      * You should take this into consideration and make sure to always cancel the interval at the
      * appropriate moment.  See the example below for more details on how and when to do this.
      * </div>
      *
      * @param {function()} fn A function that should be called repeatedly.
      * @param {number} delay Number of milliseconds between each function call.
      * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
      *   indefinitely.
      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
      * @param {...*=} Pass additional parameters to the executed function.
      * @returns {promise} A promise which will be notified on each iteration.
      *
      * @example
      * <example module="intervalExample">
      * <file name="index.html">
      *   <script>
      *     angular.module('intervalExample', [])
      *       .controller('ExampleController', ['$scope', '$interval',
      *         function($scope, $interval) {
      *           $scope.format = 'M/d/yy h:mm:ss a';
      *           $scope.blood_1 = 100;
      *           $scope.blood_2 = 120;
      *
      *           var stop;
      *           $scope.fight = function() {
      *             // Don't start a new fight if we are already fighting
      *             if ( angular.isDefined(stop) ) return;
      *
      *             stop = $interval(function() {
      *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
      *                 $scope.blood_1 = $scope.blood_1 - 3;
      *                 $scope.blood_2 = $scope.blood_2 - 4;
      *               } else {
      *                 $scope.stopFight();
      *               }
      *             }, 100);
      *           };
      *
      *           $scope.stopFight = function() {
      *             if (angular.isDefined(stop)) {
      *               $interval.cancel(stop);
      *               stop = undefined;
      *             }
      *           };
      *
      *           $scope.resetFight = function() {
      *             $scope.blood_1 = 100;
      *             $scope.blood_2 = 120;
      *           };
      *
      *           $scope.$on('$destroy', function() {
      *             // Make sure that the interval is destroyed too
      *             $scope.stopFight();
      *           });
      *         }])
      *       // Register the 'myCurrentTime' directive factory method.
      *       // We inject $interval and dateFilter service since the factory method is DI.
      *       .directive('myCurrentTime', ['$interval', 'dateFilter',
      *         function($interval, dateFilter) {
      *           // return the directive link function. (compile function not needed)
      *           return function(scope, element, attrs) {
      *             var format,  // date format
      *                 stopTime; // so that we can cancel the time updates
      *
      *             // used to update the UI
      *             function updateTime() {
      *               element.text(dateFilter(new Date(), format));
      *             }
      *
      *             // watch the expression, and update the UI on change.
      *             scope.$watch(attrs.myCurrentTime, function(value) {
      *               format = value;
      *               updateTime();
      *             });
      *
      *             stopTime = $interval(updateTime, 1000);
      *
      *             // listen on DOM destroy (removal) event, and cancel the next UI update
      *             // to prevent updating time after the DOM element was removed.
      *             element.on('$destroy', function() {
      *               $interval.cancel(stopTime);
      *             });
      *           }
      *         }]);
      *   </script>
      *
      *   <div>
      *     <div ng-controller="ExampleController">
      *       <label>Date format: <input ng-model="format"></label> <hr/>
      *       Current time is: <span my-current-time="format"></span>
      *       <hr/>
      *       Blood 1 : <font color='red'>{{blood_1}}</font>
      *       Blood 2 : <font color='red'>{{blood_2}}</font>
      *       <button type="button" data-ng-click="fight()">Fight</button>
      *       <button type="button" data-ng-click="stopFight()">StopFight</button>
      *       <button type="button" data-ng-click="resetFight()">resetFight</button>
      *     </div>
      *   </div>
      *
      * </file>
      * </example>
      */
    function interval(fn, delay, count, invokeApply) {
      var hasParams = arguments.length > 4,
          args = hasParams ? sliceArgs(arguments, 4) : [],
          setInterval = $window.setInterval,
          clearInterval = $window.clearInterval,
          iteration = 0,
          skipApply = (isDefined(invokeApply) && !invokeApply),
          deferred = (skipApply ? $$q : $q).defer(),
          promise = deferred.promise;

      count = isDefined(count) ? count : 0;

      promise.then(null, null, (!hasParams) ? fn : function() {
        fn.apply(null, args);
      });

      promise.$$intervalId = setInterval(function tick() {
        deferred.notify(iteration++);

        if (count > 0 && iteration >= count) {
          deferred.resolve(iteration);
          clearInterval(promise.$$intervalId);
          delete intervals[promise.$$intervalId];
        }

        if (!skipApply) $rootScope.$apply();

      }, delay);

      intervals[promise.$$intervalId] = deferred;

      return promise;
    }


     /**
      * @ngdoc method
      * @name $interval#cancel
      *
      * @description
      * Cancels a task associated with the `promise`.
      *
      * @param {promise} promise returned by the `$interval` function.
      * @returns {boolean} Returns `true` if the task was successfully canceled.
      */
    interval.cancel = function(promise) {
      if (promise && promise.$$intervalId in intervals) {
        intervals[promise.$$intervalId].reject('canceled');
        $window.clearInterval(promise.$$intervalId);
        delete intervals[promise.$$intervalId];
        return true;
      }
      return false;
    };

    return interval;
  }];
}

/**
 * @ngdoc service
 * @name $locale
 *
 * @description
 * $locale service provides localization rules for various Angular components. As of right now the
 * only public api is:
 *
 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
 */
function $LocaleProvider() {
  this.$get = function() {
    return {
      id: 'en-us',

      NUMBER_FORMATS: {
        DECIMAL_SEP: '.',
        GROUP_SEP: ',',
        PATTERNS: [
          { // Decimal Pattern
            minInt: 1,
            minFrac: 0,
            maxFrac: 3,
            posPre: '',
            posSuf: '',
            negPre: '-',
            negSuf: '',
            gSize: 3,
            lgSize: 3
          },{ //Currency Pattern
            minInt: 1,
            minFrac: 2,
            maxFrac: 2,
            posPre: '\u00A4',
            posSuf: '',
            negPre: '(\u00A4',
            negSuf: ')',
            gSize: 3,
            lgSize: 3
          }
        ],
        CURRENCY_SYM: '$'
      },

      DATETIME_FORMATS: {
        MONTH:
            'January,February,March,April,May,June,July,August,September,October,November,December'
            .split(','),
        SHORTMONTH:  'Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec'.split(','),
        DAY: 'Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday'.split(','),
        SHORTDAY: 'Sun,Mon,Tue,Wed,Thu,Fri,Sat'.split(','),
        AMPMS: ['AM','PM'],
        medium: 'MMM d, y h:mm:ss a',
        'short': 'M/d/yy h:mm a',
        fullDate: 'EEEE, MMMM d, y',
        longDate: 'MMMM d, y',
        mediumDate: 'MMM d, y',
        shortDate: 'M/d/yy',
        mediumTime: 'h:mm:ss a',
        shortTime: 'h:mm a',
        ERANAMES: [
          "Before Christ",
          "Anno Domini"
        ],
        ERAS: [
          "BC",
          "AD"
        ]
      },

      pluralCat: function(num) {
        if (num === 1) {
          return 'one';
        }
        return 'other';
      }
    };
  };
}

var PATH_MATCH = /^([^\?#]*)(\?([^#]*))?(#(.*))?$/,
    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
var $locationMinErr = minErr('$location');


/**
 * Encode path using encodeUriSegment, ignoring forward slashes
 *
 * @param {string} path Path to encode
 * @returns {string}
 */
function encodePath(path) {
  var segments = path.split('/'),
      i = segments.length;

  while (i--) {
    segments[i] = encodeUriSegment(segments[i]);
  }

  return segments.join('/');
}

function parseAbsoluteUrl(absoluteUrl, locationObj) {
  var parsedUrl = urlResolve(absoluteUrl);

  locationObj.$$protocol = parsedUrl.protocol;
  locationObj.$$host = parsedUrl.hostname;
  locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
}


function parseAppUrl(relativeUrl, locationObj) {
  var prefixed = (relativeUrl.charAt(0) !== '/');
  if (prefixed) {
    relativeUrl = '/' + relativeUrl;
  }
  var match = urlResolve(relativeUrl);
  locationObj.$$path = decodeURIComponent(prefixed && match.pathname.charAt(0) === '/' ?
      match.pathname.substring(1) : match.pathname);
  locationObj.$$search = parseKeyValue(match.search);
  locationObj.$$hash = decodeURIComponent(match.hash);

  // make sure path starts with '/';
  if (locationObj.$$path && locationObj.$$path.charAt(0) != '/') {
    locationObj.$$path = '/' + locationObj.$$path;
  }
}


/**
 *
 * @param {string} begin
 * @param {string} whole
 * @returns {string} returns text from whole after begin or undefined if it does not begin with
 *                   expected string.
 */
function beginsWith(begin, whole) {
  if (whole.indexOf(begin) === 0) {
    return whole.substr(begin.length);
  }
}


function stripHash(url) {
  var index = url.indexOf('#');
  return index == -1 ? url : url.substr(0, index);
}

function trimEmptyHash(url) {
  return url.replace(/(#.+)|#$/, '$1');
}


function stripFile(url) {
  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
}

/* return the server only (scheme://host:port) */
function serverBase(url) {
  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
}


/**
 * LocationHtml5Url represents an url
 * This object is exposed as $location service when HTML5 mode is enabled and supported
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} basePrefix url path prefix
 */
function LocationHtml5Url(appBase, basePrefix) {
  this.$$html5 = true;
  basePrefix = basePrefix || '';
  var appBaseNoFile = stripFile(appBase);
  parseAbsoluteUrl(appBase, this);


  /**
   * Parse given html5 (regular) url string into properties
   * @param {string} url HTML5 url
   * @private
   */
  this.$$parse = function(url) {
    var pathUrl = beginsWith(appBaseNoFile, url);
    if (!isString(pathUrl)) {
      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
          appBaseNoFile);
    }

    parseAppUrl(pathUrl, this);

    if (!this.$$path) {
      this.$$path = '/';
    }

    this.$$compose();
  };

  /**
   * Compose url and update `absUrl` property
   * @private
   */
  this.$$compose = function() {
    var search = toKeyValue(this.$$search),
        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';

    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
    this.$$absUrl = appBaseNoFile + this.$$url.substr(1); // first char is always '/'
  };

  this.$$parseLinkUrl = function(url, relHref) {
    if (relHref && relHref[0] === '#') {
      // special case for links to hash fragments:
      // keep the old url and only replace the hash fragment
      this.hash(relHref.slice(1));
      return true;
    }
    var appUrl, prevAppUrl;
    var rewrittenUrl;

    if ((appUrl = beginsWith(appBase, url)) !== undefined) {
      prevAppUrl = appUrl;
      if ((appUrl = beginsWith(basePrefix, appUrl)) !== undefined) {
        rewrittenUrl = appBaseNoFile + (beginsWith('/', appUrl) || appUrl);
      } else {
        rewrittenUrl = appBase + prevAppUrl;
      }
    } else if ((appUrl = beginsWith(appBaseNoFile, url)) !== undefined) {
      rewrittenUrl = appBaseNoFile + appUrl;
    } else if (appBaseNoFile == url + '/') {
      rewrittenUrl = appBaseNoFile;
    }
    if (rewrittenUrl) {
      this.$$parse(rewrittenUrl);
    }
    return !!rewrittenUrl;
  };
}


/**
 * LocationHashbangUrl represents url
 * This object is exposed as $location service when developer doesn't opt into html5 mode.
 * It also serves as the base class for html5 mode fallback on legacy browsers.
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} hashPrefix hashbang prefix
 */
function LocationHashbangUrl(appBase, hashPrefix) {
  var appBaseNoFile = stripFile(appBase);

  parseAbsoluteUrl(appBase, this);


  /**
   * Parse given hashbang url into properties
   * @param {string} url Hashbang url
   * @private
   */
  this.$$parse = function(url) {
    var withoutBaseUrl = beginsWith(appBase, url) || beginsWith(appBaseNoFile, url);
    var withoutHashUrl;

    if (withoutBaseUrl.charAt(0) === '#') {

      // The rest of the url starts with a hash so we have
      // got either a hashbang path or a plain hash fragment
      withoutHashUrl = beginsWith(hashPrefix, withoutBaseUrl);
      if (isUndefined(withoutHashUrl)) {
        // There was no hashbang prefix so we just have a hash fragment
        withoutHashUrl = withoutBaseUrl;
      }

    } else {
      // There was no hashbang path nor hash fragment:
      // If we are in HTML5 mode we use what is left as the path;
      // Otherwise we ignore what is left
      withoutHashUrl = this.$$html5 ? withoutBaseUrl : '';
    }

    parseAppUrl(withoutHashUrl, this);

    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);

    this.$$compose();

    /*
     * In Windows, on an anchor node on documents loaded from
     * the filesystem, the browser will return a pathname
     * prefixed with the drive name ('/C:/path') when a
     * pathname without a drive is set:
     *  * a.setAttribute('href', '/foo')
     *   * a.pathname === '/C:/foo' //true
     *
     * Inside of Angular, we're always using pathnames that
     * do not include drive names for routing.
     */
    function removeWindowsDriveName(path, url, base) {
      /*
      Matches paths for file protocol on windows,
      such as /C:/foo/bar, and captures only /foo/bar.
      */
      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;

      var firstPathSegmentMatch;

      //Get the relative path from the input URL.
      if (url.indexOf(base) === 0) {
        url = url.replace(base, '');
      }

      // The input URL intentionally contains a first path segment that ends with a colon.
      if (windowsFilePathExp.exec(url)) {
        return path;
      }

      firstPathSegmentMatch = windowsFilePathExp.exec(path);
      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
    }
  };

  /**
   * Compose hashbang url and update `absUrl` property
   * @private
   */
  this.$$compose = function() {
    var search = toKeyValue(this.$$search),
        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';

    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
    this.$$absUrl = appBase + (this.$$url ? hashPrefix + this.$$url : '');
  };

  this.$$parseLinkUrl = function(url, relHref) {
    if (stripHash(appBase) == stripHash(url)) {
      this.$$parse(url);
      return true;
    }
    return false;
  };
}


/**
 * LocationHashbangUrl represents url
 * This object is exposed as $location service when html5 history api is enabled but the browser
 * does not support it.
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} hashPrefix hashbang prefix
 */
function LocationHashbangInHtml5Url(appBase, hashPrefix) {
  this.$$html5 = true;
  LocationHashbangUrl.apply(this, arguments);

  var appBaseNoFile = stripFile(appBase);

  this.$$parseLinkUrl = function(url, relHref) {
    if (relHref && relHref[0] === '#') {
      // special case for links to hash fragments:
      // keep the old url and only replace the hash fragment
      this.hash(relHref.slice(1));
      return true;
    }

    var rewrittenUrl;
    var appUrl;

    if (appBase == stripHash(url)) {
      rewrittenUrl = url;
    } else if ((appUrl = beginsWith(appBaseNoFile, url))) {
      rewrittenUrl = appBase + hashPrefix + appUrl;
    } else if (appBaseNoFile === url + '/') {
      rewrittenUrl = appBaseNoFile;
    }
    if (rewrittenUrl) {
      this.$$parse(rewrittenUrl);
    }
    return !!rewrittenUrl;
  };

  this.$$compose = function() {
    var search = toKeyValue(this.$$search),
        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';

    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
    // include hashPrefix in $$absUrl when $$url is empty so IE8 & 9 do not reload page because of removal of '#'
    this.$$absUrl = appBase + hashPrefix + this.$$url;
  };

}


var locationPrototype = {

  /**
   * Are we in html5 mode?
   * @private
   */
  $$html5: false,

  /**
   * Has any change been replacing?
   * @private
   */
  $$replace: false,

  /**
   * @ngdoc method
   * @name $location#absUrl
   *
   * @description
   * This method is getter only.
   *
   * Return full url representation with all segments encoded according to rules specified in
   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
   *
   *
   * ```js
   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
   * var absUrl = $location.absUrl();
   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
   * ```
   *
   * @return {string} full url
   */
  absUrl: locationGetter('$$absUrl'),

  /**
   * @ngdoc method
   * @name $location#url
   *
   * @description
   * This method is getter / setter.
   *
   * Return url (e.g. `/path?a=b#hash`) when called without any parameter.
   *
   * Change path, search and hash, when called with parameter and return `$location`.
   *
   *
   * ```js
   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
   * var url = $location.url();
   * // => "/some/path?foo=bar&baz=xoxo"
   * ```
   *
   * @param {string=} url New url without base prefix (e.g. `/path?a=b#hash`)
   * @return {string} url
   */
  url: function(url) {
    if (isUndefined(url)) {
      return this.$$url;
    }

    var match = PATH_MATCH.exec(url);
    if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
    if (match[2] || match[1] || url === '') this.search(match[3] || '');
    this.hash(match[5] || '');

    return this;
  },

  /**
   * @ngdoc method
   * @name $location#protocol
   *
   * @description
   * This method is getter only.
   *
   * Return protocol of current url.
   *
   *
   * ```js
   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
   * var protocol = $location.protocol();
   * // => "http"
   * ```
   *
   * @return {string} protocol of current url
   */
  protocol: locationGetter('$$protocol'),

  /**
   * @ngdoc method
   * @name $location#host
   *
   * @description
   * This method is getter only.
   *
   * Return host of current url.
   *
   * Note: compared to the non-angular version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
   *
   *
   * ```js
   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
   * var host = $location.host();
   * // => "example.com"
   *
   * // given url http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
   * host = $location.host();
   * // => "example.com"
   * host = location.host;
   * // => "example.com:8080"
   * ```
   *
   * @return {string} host of current url.
   */
  host: locationGetter('$$host'),

  /**
   * @ngdoc method
   * @name $location#port
   *
   * @description
   * This method is getter only.
   *
   * Return port of current url.
   *
   *
   * ```js
   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
   * var port = $location.port();
   * // => 80
   * ```
   *
   * @return {Number} port
   */
  port: locationGetter('$$port'),

  /**
   * @ngdoc method
   * @name $location#path
   *
   * @description
   * This method is getter / setter.
   *
   * Return path of current url when called without any parameter.
   *
   * Change path when called with parameter and return `$location`.
   *
   * Note: Path should always begin with forward slash (/), this method will add the forward slash
   * if it is missing.
   *
   *
   * ```js
   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
   * var path = $location.path();
   * // => "/some/path"
   * ```
   *
   * @param {(string|number)=} path New path
   * @return {string} path
   */
  path: locationGetterSetter('$$path', function(path) {
    path = path !== null ? path.toString() : '';
    return path.charAt(0) == '/' ? path : '/' + path;
  }),

  /**
   * @ngdoc method
   * @name $location#search
   *
   * @description
   * This method is getter / setter.
   *
   * Return search part (as object) of current url when called without any parameter.
   *
   * Change search part when called with parameter and return `$location`.
   *
   *
   * ```js
   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
   * var searchObject = $location.search();
   * // => {foo: 'bar', baz: 'xoxo'}
   *
   * // set foo to 'yipee'
   * $location.search('foo', 'yipee');
   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
   * ```
   *
   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
   * hash object.
   *
   * When called with a single argument the method acts as a setter, setting the `search` component
   * of `$location` to the specified value.
   *
   * If the argument is a hash object containing an array of values, these values will be encoded
   * as duplicate search parameters in the url.
   *
   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
   * will override only a single search property.
   *
   * If `paramValue` is an array, it will override the property of the `search` component of
   * `$location` specified via the first argument.
   *
   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
   *
   * If `paramValue` is `true`, the property specified via the first argument will be added with no
   * value nor trailing equal sign.
   *
   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
   * one or more arguments returns `$location` object itself.
   */
  search: function(search, paramValue) {
    switch (arguments.length) {
      case 0:
        return this.$$search;
      case 1:
        if (isString(search) || isNumber(search)) {
          search = search.toString();
          this.$$search = parseKeyValue(search);
        } else if (isObject(search)) {
          search = copy(search, {});
          // remove object undefined or null properties
          forEach(search, function(value, key) {
            if (value == null) delete search[key];
          });

          this.$$search = search;
        } else {
          throw $locationMinErr('isrcharg',
              'The first argument of the `$location#search()` call must be a string or an object.');
        }
        break;
      default:
        if (isUndefined(paramValue) || paramValue === null) {
          delete this.$$search[search];
        } else {
          this.$$search[search] = paramValue;
        }
    }

    this.$$compose();
    return this;
  },

  /**
   * @ngdoc method
   * @name $location#hash
   *
   * @description
   * This method is getter / setter.
   *
   * Return hash fragment when called without any parameter.
   *
   * Change hash fragment when called with parameter and return `$location`.
   *
   *
   * ```js
   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
   * var hash = $location.hash();
   * // => "hashValue"
   * ```
   *
   * @param {(string|number)=} hash New hash fragment
   * @return {string} hash
   */
  hash: locationGetterSetter('$$hash', function(hash) {
    return hash !== null ? hash.toString() : '';
  }),

  /**
   * @ngdoc method
   * @name $location#replace
   *
   * @description
   * If called, all changes to $location during current `$digest` will be replacing current history
   * record, instead of adding new one.
   */
  replace: function() {
    this.$$replace = true;
    return this;
  }
};

forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
  Location.prototype = Object.create(locationPrototype);

  /**
   * @ngdoc method
   * @name $location#state
   *
   * @description
   * This method is getter / setter.
   *
   * Return the history state object when called without any parameter.
   *
   * Change the history state object when called with one parameter and return `$location`.
   * The state object is later passed to `pushState` or `replaceState`.
   *
   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
   * older browsers (like IE9 or Android < 4.0), don't use this method.
   *
   * @param {object=} state State object for pushState or replaceState
   * @return {object} state
   */
  Location.prototype.state = function(state) {
    if (!arguments.length) {
      return this.$$state;
    }

    if (Location !== LocationHtml5Url || !this.$$html5) {
      throw $locationMinErr('nostate', 'History API state support is available only ' +
        'in HTML5 mode and only in browsers supporting HTML5 History API');
    }
    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
    // but we're changing the $$state reference to $browser.state() during the $digest
    // so the modification window is narrow.
    this.$$state = isUndefined(state) ? null : state;

    return this;
  };
});


function locationGetter(property) {
  return function() {
    return this[property];
  };
}


function locationGetterSetter(property, preprocess) {
  return function(value) {
    if (isUndefined(value)) {
      return this[property];
    }

    this[property] = preprocess(value);
    this.$$compose();

    return this;
  };
}


/**
 * @ngdoc service
 * @name $location
 *
 * @requires $rootElement
 *
 * @description
 * The $location service parses the URL in the browser address bar (based on the
 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
 * available to your application. Changes to the URL in the address bar are reflected into
 * $location service and changes to $location are reflected into the browser address bar.
 *
 * **The $location service:**
 *
 * - Exposes the current URL in the browser address bar, so you can
 *   - Watch and observe the URL.
 *   - Change the URL.
 * - Synchronizes the URL with the browser when the user
 *   - Changes the address bar.
 *   - Clicks the back or forward button (or clicks a History link).
 *   - Clicks on a link.
 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
 *
 * For more information see {@link guide/$location Developer Guide: Using $location}
 */

/**
 * @ngdoc provider
 * @name $locationProvider
 * @description
 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
 */
function $LocationProvider() {
  var hashPrefix = '',
      html5Mode = {
        enabled: false,
        requireBase: true,
        rewriteLinks: true
      };

  /**
   * @ngdoc method
   * @name $locationProvider#hashPrefix
   * @description
   * @param {string=} prefix Prefix for hash part (containing path and search)
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   */
  this.hashPrefix = function(prefix) {
    if (isDefined(prefix)) {
      hashPrefix = prefix;
      return this;
    } else {
      return hashPrefix;
    }
  };

  /**
   * @ngdoc method
   * @name $locationProvider#html5Mode
   * @description
   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
   *   properties:
   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
   *     support `pushState`.
   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
   *     See the {@link guide/$location $location guide for more information}
   *   - **rewriteLinks** - `{boolean}` - (default: `true`) When html5Mode is enabled,
   *     enables/disables url rewriting for relative links.
   *
   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
   */
  this.html5Mode = function(mode) {
    if (isBoolean(mode)) {
      html5Mode.enabled = mode;
      return this;
    } else if (isObject(mode)) {

      if (isBoolean(mode.enabled)) {
        html5Mode.enabled = mode.enabled;
      }

      if (isBoolean(mode.requireBase)) {
        html5Mode.requireBase = mode.requireBase;
      }

      if (isBoolean(mode.rewriteLinks)) {
        html5Mode.rewriteLinks = mode.rewriteLinks;
      }

      return this;
    } else {
      return html5Mode;
    }
  };

  /**
   * @ngdoc event
   * @name $location#$locationChangeStart
   * @eventType broadcast on root scope
   * @description
   * Broadcasted before a URL will change.
   *
   * This change can be prevented by calling
   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
   * details about event object. Upon successful change
   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
   *
   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
   * the browser supports the HTML5 History API.
   *
   * @param {Object} angularEvent Synthetic event object.
   * @param {string} newUrl New URL
   * @param {string=} oldUrl URL that was before it was changed.
   * @param {string=} newState New history state object
   * @param {string=} oldState History state object that was before it was changed.
   */

  /**
   * @ngdoc event
   * @name $location#$locationChangeSuccess
   * @eventType broadcast on root scope
   * @description
   * Broadcasted after a URL was changed.
   *
   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
   * the browser supports the HTML5 History API.
   *
   * @param {Object} angularEvent Synthetic event object.
   * @param {string} newUrl New URL
   * @param {string=} oldUrl URL that was before it was changed.
   * @param {string=} newState New history state object
   * @param {string=} oldState History state object that was before it was changed.
   */

  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
      function($rootScope, $browser, $sniffer, $rootElement, $window) {
    var $location,
        LocationMode,
        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
        initialUrl = $browser.url(),
        appBase;

    if (html5Mode.enabled) {
      if (!baseHref && html5Mode.requireBase) {
        throw $locationMinErr('nobase',
          "$location in HTML5 mode requires a <base> tag to be present!");
      }
      appBase = serverBase(initialUrl) + (baseHref || '/');
      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
    } else {
      appBase = stripHash(initialUrl);
      LocationMode = LocationHashbangUrl;
    }
    $location = new LocationMode(appBase, '#' + hashPrefix);
    $location.$$parseLinkUrl(initialUrl, initialUrl);

    $location.$$state = $browser.state();

    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;

    function setBrowserUrlWithFallback(url, replace, state) {
      var oldUrl = $location.url();
      var oldState = $location.$$state;
      try {
        $browser.url(url, replace, state);

        // Make sure $location.state() returns referentially identical (not just deeply equal)
        // state object; this makes possible quick checking if the state changed in the digest
        // loop. Checking deep equality would be too expensive.
        $location.$$state = $browser.state();
      } catch (e) {
        // Restore old values if pushState fails
        $location.url(oldUrl);
        $location.$$state = oldState;

        throw e;
      }
    }

    $rootElement.on('click', function(event) {
      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
      // currently we open nice url link and redirect then

      if (!html5Mode.rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which == 2 || event.button == 2) return;

      var elm = jqLite(event.target);

      // traverse the DOM up to find first A tag
      while (nodeName_(elm[0]) !== 'a') {
        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
      }

      var absHref = elm.prop('href');
      // get the actual href attribute - see
      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
      var relHref = elm.attr('href') || elm.attr('xlink:href');

      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
        // an animation.
        absHref = urlResolve(absHref.animVal).href;
      }

      // Ignore when url is started with javascript: or mailto:
      if (IGNORE_URI_REGEXP.test(absHref)) return;

      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
        if ($location.$$parseLinkUrl(absHref, relHref)) {
          // We do a preventDefault for all urls that are part of the angular application,
          // in html5mode and also without, so that we are able to abort navigation without
          // getting double entries in the location history.
          event.preventDefault();
          // update location manually
          if ($location.absUrl() != $browser.url()) {
            $rootScope.$apply();
            // hack to work around FF6 bug 684208 when scenario runner clicks on links
            $window.angular['ff-684208-preventDefault'] = true;
          }
        }
      }
    });


    // rewrite hashbang url <> html5 url
    if (trimEmptyHash($location.absUrl()) != trimEmptyHash(initialUrl)) {
      $browser.url($location.absUrl(), true);
    }

    var initializing = true;

    // update $location when $browser url changes
    $browser.onUrlChange(function(newUrl, newState) {
      $rootScope.$evalAsync(function() {
        var oldUrl = $location.absUrl();
        var oldState = $location.$$state;
        var defaultPrevented;

        $location.$$parse(newUrl);
        $location.$$state = newState;

        defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
            newState, oldState).defaultPrevented;

        // if the location was changed by a `$locationChangeStart` handler then stop
        // processing this location change
        if ($location.absUrl() !== newUrl) return;

        if (defaultPrevented) {
          $location.$$parse(oldUrl);
          $location.$$state = oldState;
          setBrowserUrlWithFallback(oldUrl, false, oldState);
        } else {
          initializing = false;
          afterLocationChange(oldUrl, oldState);
        }
      });
      if (!$rootScope.$$phase) $rootScope.$digest();
    });

    // update browser
    $rootScope.$watch(function $locationWatch() {
      var oldUrl = trimEmptyHash($browser.url());
      var newUrl = trimEmptyHash($location.absUrl());
      var oldState = $browser.state();
      var currentReplace = $location.$$replace;
      var urlOrStateChanged = oldUrl !== newUrl ||
        ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);

      if (initializing || urlOrStateChanged) {
        initializing = false;

        $rootScope.$evalAsync(function() {
          var newUrl = $location.absUrl();
          var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
              $location.$$state, oldState).defaultPrevented;

          // if the location was changed by a `$locationChangeStart` handler then stop
          // processing this location change
          if ($location.absUrl() !== newUrl) return;

          if (defaultPrevented) {
            $location.$$parse(oldUrl);
            $location.$$state = oldState;
          } else {
            if (urlOrStateChanged) {
              setBrowserUrlWithFallback(newUrl, currentReplace,
                                        oldState === $location.$$state ? null : $location.$$state);
            }
            afterLocationChange(oldUrl, oldState);
          }
        });
      }

      $location.$$replace = false;

      // we don't need to return anything because $evalAsync will make the digest loop dirty when
      // there is a change
    });

    return $location;

    function afterLocationChange(oldUrl, oldState) {
      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
        $location.$$state, oldState);
    }
}];
}

/**
 * @ngdoc service
 * @name $log
 * @requires $window
 *
 * @description
 * Simple service for logging. Default implementation safely writes the message
 * into the browser's console (if present).
 *
 * The main purpose of this service is to simplify debugging and troubleshooting.
 *
 * The default is to log `debug` messages. You can use
 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
 *
 * @example
   <example module="logExample">
     <file name="script.js">
       angular.module('logExample', [])
         .controller('LogController', ['$scope', '$log', function($scope, $log) {
           $scope.$log = $log;
           $scope.message = 'Hello World!';
         }]);
     </file>
     <file name="index.html">
       <div ng-controller="LogController">
         <p>Reload this page with open console, enter text and hit the log button...</p>
         <label>Message:
         <input type="text" ng-model="message" /></label>
         <button ng-click="$log.log(message)">log</button>
         <button ng-click="$log.warn(message)">warn</button>
         <button ng-click="$log.info(message)">info</button>
         <button ng-click="$log.error(message)">error</button>
         <button ng-click="$log.debug(message)">debug</button>
       </div>
     </file>
   </example>
 */

/**
 * @ngdoc provider
 * @name $logProvider
 * @description
 * Use the `$logProvider` to configure how the application logs messages
 */
function $LogProvider() {
  var debug = true,
      self = this;

  /**
   * @ngdoc method
   * @name $logProvider#debugEnabled
   * @description
   * @param {boolean=} flag enable or disable debug level messages
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   */
  this.debugEnabled = function(flag) {
    if (isDefined(flag)) {
      debug = flag;
    return this;
    } else {
      return debug;
    }
  };

  this.$get = ['$window', function($window) {
    return {
      /**
       * @ngdoc method
       * @name $log#log
       *
       * @description
       * Write a log message
       */
      log: consoleLog('log'),

      /**
       * @ngdoc method
       * @name $log#info
       *
       * @description
       * Write an information message
       */
      info: consoleLog('info'),

      /**
       * @ngdoc method
       * @name $log#warn
       *
       * @description
       * Write a warning message
       */
      warn: consoleLog('warn'),

      /**
       * @ngdoc method
       * @name $log#error
       *
       * @description
       * Write an error message
       */
      error: consoleLog('error'),

      /**
       * @ngdoc method
       * @name $log#debug
       *
       * @description
       * Write a debug message
       */
      debug: (function() {
        var fn = consoleLog('debug');

        return function() {
          if (debug) {
            fn.apply(self, arguments);
          }
        };
      }())
    };

    function formatError(arg) {
      if (arg instanceof Error) {
        if (arg.stack) {
          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
              ? 'Error: ' + arg.message + '\n' + arg.stack
              : arg.stack;
        } else if (arg.sourceURL) {
          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
        }
      }
      return arg;
    }

    function consoleLog(type) {
      var console = $window.console || {},
          logFn = console[type] || console.log || noop,
          hasApply = false;

      // Note: reading logFn.apply throws an error in IE11 in IE8 document mode.
      // The reason behind this is that console.log has type "object" in IE8...
      try {
        hasApply = !!logFn.apply;
      } catch (e) {}

      if (hasApply) {
        return function() {
          var args = [];
          forEach(arguments, function(arg) {
            args.push(formatError(arg));
          });
          return logFn.apply(console, args);
        };
      }

      // we are IE which either doesn't have window.console => this is noop and we do nothing,
      // or we are IE where console.log doesn't have apply so we log at least first 2 args
      return function(arg1, arg2) {
        logFn(arg1, arg2 == null ? '' : arg2);
      };
    }
  }];
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

var $parseMinErr = minErr('$parse');

// Sandboxing Angular Expressions
// ------------------------------
// Angular expressions are generally considered safe because these expressions only have direct
// access to `$scope` and locals. However, one can obtain the ability to execute arbitrary JS code by
// obtaining a reference to native JS functions such as the Function constructor.
//
// As an example, consider the following Angular expression:
//
//   {}.toString.constructor('alert("evil JS code")')
//
// This sandboxing technique is not perfect and doesn't aim to be. The goal is to prevent exploits
// against the expression language, but not to prevent exploits that were enabled by exposing
// sensitive JavaScript or browser APIs on Scope. Exposing such objects on a Scope is never a good
// practice and therefore we are not even trying to protect against interaction with an object
// explicitly exposed in this way.
//
// In general, it is not possible to access a Window object from an angular expression unless a
// window or some DOM object that has a reference to window is published onto a Scope.
// Similarly we prevent invocations of function known to be dangerous, as well as assignments to
// native objects.
//
// See https://docs.angularjs.org/guide/security


function ensureSafeMemberName(name, fullExpression) {
  if (name === "__defineGetter__" || name === "__defineSetter__"
      || name === "__lookupGetter__" || name === "__lookupSetter__"
      || name === "__proto__") {
    throw $parseMinErr('isecfld',
        'Attempting to access a disallowed field in Angular expressions! '
        + 'Expression: {0}', fullExpression);
  }
  return name;
}

function ensureSafeObject(obj, fullExpression) {
  // nifty check if obj is Function that is fast and works across iframes and other contexts
  if (obj) {
    if (obj.constructor === obj) {
      throw $parseMinErr('isecfn',
          'Referencing Function in Angular expressions is disallowed! Expression: {0}',
          fullExpression);
    } else if (// isWindow(obj)
        obj.window === obj) {
      throw $parseMinErr('isecwindow',
          'Referencing the Window in Angular expressions is disallowed! Expression: {0}',
          fullExpression);
    } else if (// isElement(obj)
        obj.children && (obj.nodeName || (obj.prop && obj.attr && obj.find))) {
      throw $parseMinErr('isecdom',
          'Referencing DOM nodes in Angular expressions is disallowed! Expression: {0}',
          fullExpression);
    } else if (// block Object so that we can't get hold of dangerous Object.* methods
        obj === Object) {
      throw $parseMinErr('isecobj',
          'Referencing Object in Angular expressions is disallowed! Expression: {0}',
          fullExpression);
    }
  }
  return obj;
}

var CALL = Function.prototype.call;
var APPLY = Function.prototype.apply;
var BIND = Function.prototype.bind;

function ensureSafeFunction(obj, fullExpression) {
  if (obj) {
    if (obj.constructor === obj) {
      throw $parseMinErr('isecfn',
        'Referencing Function in Angular expressions is disallowed! Expression: {0}',
        fullExpression);
    } else if (obj === CALL || obj === APPLY || obj === BIND) {
      throw $parseMinErr('isecff',
        'Referencing call, apply or bind in Angular expressions is disallowed! Expression: {0}',
        fullExpression);
    }
  }
}

var OPERATORS = createMap();
forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) { OPERATORS[operator] = true; });
var ESCAPE = {"n":"\n", "f":"\f", "r":"\r", "t":"\t", "v":"\v", "'":"'", '"':'"'};


/////////////////////////////////////////


/**
 * @constructor
 */
var Lexer = function(options) {
  this.options = options;
};

Lexer.prototype = {
  constructor: Lexer,

  lex: function(text) {
    this.text = text;
    this.index = 0;
    this.tokens = [];

    while (this.index < this.text.length) {
      var ch = this.text.charAt(this.index);
      if (ch === '"' || ch === "'") {
        this.readString(ch);
      } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
        this.readNumber();
      } else if (this.isIdent(ch)) {
        this.readIdent();
      } else if (this.is(ch, '(){}[].,;:?')) {
        this.tokens.push({index: this.index, text: ch});
        this.index++;
      } else if (this.isWhitespace(ch)) {
        this.index++;
      } else {
        var ch2 = ch + this.peek();
        var ch3 = ch2 + this.peek(2);
        var op1 = OPERATORS[ch];
        var op2 = OPERATORS[ch2];
        var op3 = OPERATORS[ch3];
        if (op1 || op2 || op3) {
          var token = op3 ? ch3 : (op2 ? ch2 : ch);
          this.tokens.push({index: this.index, text: token, operator: true});
          this.index += token.length;
        } else {
          this.throwError('Unexpected next character ', this.index, this.index + 1);
        }
      }
    }
    return this.tokens;
  },

  is: function(ch, chars) {
    return chars.indexOf(ch) !== -1;
  },

  peek: function(i) {
    var num = i || 1;
    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
  },

  isNumber: function(ch) {
    return ('0' <= ch && ch <= '9') && typeof ch === "string";
  },

  isWhitespace: function(ch) {
    // IE treats non-breaking space as \u00A0
    return (ch === ' ' || ch === '\r' || ch === '\t' ||
            ch === '\n' || ch === '\v' || ch === '\u00A0');
  },

  isIdent: function(ch) {
    return ('a' <= ch && ch <= 'z' ||
            'A' <= ch && ch <= 'Z' ||
            '_' === ch || ch === '$');
  },

  isExpOperator: function(ch) {
    return (ch === '-' || ch === '+' || this.isNumber(ch));
  },

  throwError: function(error, start, end) {
    end = end || this.index;
    var colStr = (isDefined(start)
            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
            : ' ' + end);
    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
        error, colStr, this.text);
  },

  readNumber: function() {
    var number = '';
    var start = this.index;
    while (this.index < this.text.length) {
      var ch = lowercase(this.text.charAt(this.index));
      if (ch == '.' || this.isNumber(ch)) {
        number += ch;
      } else {
        var peekCh = this.peek();
        if (ch == 'e' && this.isExpOperator(peekCh)) {
          number += ch;
        } else if (this.isExpOperator(ch) &&
            peekCh && this.isNumber(peekCh) &&
            number.charAt(number.length - 1) == 'e') {
          number += ch;
        } else if (this.isExpOperator(ch) &&
            (!peekCh || !this.isNumber(peekCh)) &&
            number.charAt(number.length - 1) == 'e') {
          this.throwError('Invalid exponent');
        } else {
          break;
        }
      }
      this.index++;
    }
    this.tokens.push({
      index: start,
      text: number,
      constant: true,
      value: Number(number)
    });
  },

  readIdent: function() {
    var start = this.index;
    while (this.index < this.text.length) {
      var ch = this.text.charAt(this.index);
      if (!(this.isIdent(ch) || this.isNumber(ch))) {
        break;
      }
      this.index++;
    }
    this.tokens.push({
      index: start,
      text: this.text.slice(start, this.index),
      identifier: true
    });
  },

  readString: function(quote) {
    var start = this.index;
    this.index++;
    var string = '';
    var rawString = quote;
    var escape = false;
    while (this.index < this.text.length) {
      var ch = this.text.charAt(this.index);
      rawString += ch;
      if (escape) {
        if (ch === 'u') {
          var hex = this.text.substring(this.index + 1, this.index + 5);
          if (!hex.match(/[\da-f]{4}/i)) {
            this.throwError('Invalid unicode escape [\\u' + hex + ']');
          }
          this.index += 4;
          string += String.fromCharCode(parseInt(hex, 16));
        } else {
          var rep = ESCAPE[ch];
          string = string + (rep || ch);
        }
        escape = false;
      } else if (ch === '\\') {
        escape = true;
      } else if (ch === quote) {
        this.index++;
        this.tokens.push({
          index: start,
          text: rawString,
          constant: true,
          value: string
        });
        return;
      } else {
        string += ch;
      }
      this.index++;
    }
    this.throwError('Unterminated quote', start);
  }
};

var AST = function(lexer, options) {
  this.lexer = lexer;
  this.options = options;
};

AST.Program = 'Program';
AST.ExpressionStatement = 'ExpressionStatement';
AST.AssignmentExpression = 'AssignmentExpression';
AST.ConditionalExpression = 'ConditionalExpression';
AST.LogicalExpression = 'LogicalExpression';
AST.BinaryExpression = 'BinaryExpression';
AST.UnaryExpression = 'UnaryExpression';
AST.CallExpression = 'CallExpression';
AST.MemberExpression = 'MemberExpression';
AST.Identifier = 'Identifier';
AST.Literal = 'Literal';
AST.ArrayExpression = 'ArrayExpression';
AST.Property = 'Property';
AST.ObjectExpression = 'ObjectExpression';
AST.ThisExpression = 'ThisExpression';

// Internal use only
AST.NGValueParameter = 'NGValueParameter';

AST.prototype = {
  ast: function(text) {
    this.text = text;
    this.tokens = this.lexer.lex(text);

    var value = this.program();

    if (this.tokens.length !== 0) {
      this.throwError('is an unexpected token', this.tokens[0]);
    }

    return value;
  },

  program: function() {
    var body = [];
    while (true) {
      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
        body.push(this.expressionStatement());
      if (!this.expect(';')) {
        return { type: AST.Program, body: body};
      }
    }
  },

  expressionStatement: function() {
    return { type: AST.ExpressionStatement, expression: this.filterChain() };
  },

  filterChain: function() {
    var left = this.expression();
    var token;
    while ((token = this.expect('|'))) {
      left = this.filter(left);
    }
    return left;
  },

  expression: function() {
    return this.assignment();
  },

  assignment: function() {
    var result = this.ternary();
    if (this.expect('=')) {
      result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '='};
    }
    return result;
  },

  ternary: function() {
    var test = this.logicalOR();
    var alternate;
    var consequent;
    if (this.expect('?')) {
      alternate = this.expression();
      if (this.consume(':')) {
        consequent = this.expression();
        return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent};
      }
    }
    return test;
  },

  logicalOR: function() {
    var left = this.logicalAND();
    while (this.expect('||')) {
      left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
    }
    return left;
  },

  logicalAND: function() {
    var left = this.equality();
    while (this.expect('&&')) {
      left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality()};
    }
    return left;
  },

  equality: function() {
    var left = this.relational();
    var token;
    while ((token = this.expect('==','!=','===','!=='))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
    }
    return left;
  },

  relational: function() {
    var left = this.additive();
    var token;
    while ((token = this.expect('<', '>', '<=', '>='))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
    }
    return left;
  },

  additive: function() {
    var left = this.multiplicative();
    var token;
    while ((token = this.expect('+','-'))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
    }
    return left;
  },

  multiplicative: function() {
    var left = this.unary();
    var token;
    while ((token = this.expect('*','/','%'))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
    }
    return left;
  },

  unary: function() {
    var token;
    if ((token = this.expect('+', '-', '!'))) {
      return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
    } else {
      return this.primary();
    }
  },

  primary: function() {
    var primary;
    if (this.expect('(')) {
      primary = this.filterChain();
      this.consume(')');
    } else if (this.expect('[')) {
      primary = this.arrayDeclaration();
    } else if (this.expect('{')) {
      primary = this.object();
    } else if (this.constants.hasOwnProperty(this.peek().text)) {
      primary = copy(this.constants[this.consume().text]);
    } else if (this.peek().identifier) {
      primary = this.identifier();
    } else if (this.peek().constant) {
      primary = this.constant();
    } else {
      this.throwError('not a primary expression', this.peek());
    }

    var next;
    while ((next = this.expect('(', '[', '.'))) {
      if (next.text === '(') {
        primary = {type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
        this.consume(')');
      } else if (next.text === '[') {
        primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
        this.consume(']');
      } else if (next.text === '.') {
        primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
      } else {
        this.throwError('IMPOSSIBLE');
      }
    }
    return primary;
  },

  filter: function(baseExpression) {
    var args = [baseExpression];
    var result = {type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true};

    while (this.expect(':')) {
      args.push(this.expression());
    }

    return result;
  },

  parseArguments: function() {
    var args = [];
    if (this.peekToken().text !== ')') {
      do {
        args.push(this.expression());
      } while (this.expect(','));
    }
    return args;
  },

  identifier: function() {
    var token = this.consume();
    if (!token.identifier) {
      this.throwError('is not a valid identifier', token);
    }
    return { type: AST.Identifier, name: token.text };
  },

  constant: function() {
    // TODO check that it is a constant
    return { type: AST.Literal, value: this.consume().value };
  },

  arrayDeclaration: function() {
    var elements = [];
    if (this.peekToken().text !== ']') {
      do {
        if (this.peek(']')) {
          // Support trailing commas per ES5.1.
          break;
        }
        elements.push(this.expression());
      } while (this.expect(','));
    }
    this.consume(']');

    return { type: AST.ArrayExpression, elements: elements };
  },

  object: function() {
    var properties = [], property;
    if (this.peekToken().text !== '}') {
      do {
        if (this.peek('}')) {
          // Support trailing commas per ES5.1.
          break;
        }
        property = {type: AST.Property, kind: 'init'};
        if (this.peek().constant) {
          property.key = this.constant();
        } else if (this.peek().identifier) {
          property.key = this.identifier();
        } else {
          this.throwError("invalid key", this.peek());
        }
        this.consume(':');
        property.value = this.expression();
        properties.push(property);
      } while (this.expect(','));
    }
    this.consume('}');

    return {type: AST.ObjectExpression, properties: properties };
  },

  throwError: function(msg, token) {
    throw $parseMinErr('syntax',
        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
  },

  consume: function(e1) {
    if (this.tokens.length === 0) {
      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
    }

    var token = this.expect(e1);
    if (!token) {
      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
    }
    return token;
  },

  peekToken: function() {
    if (this.tokens.length === 0) {
      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
    }
    return this.tokens[0];
  },

  peek: function(e1, e2, e3, e4) {
    return this.peekAhead(0, e1, e2, e3, e4);
  },

  peekAhead: function(i, e1, e2, e3, e4) {
    if (this.tokens.length > i) {
      var token = this.tokens[i];
      var t = token.text;
      if (t === e1 || t === e2 || t === e3 || t === e4 ||
          (!e1 && !e2 && !e3 && !e4)) {
        return token;
      }
    }
    return false;
  },

  expect: function(e1, e2, e3, e4) {
    var token = this.peek(e1, e2, e3, e4);
    if (token) {
      this.tokens.shift();
      return token;
    }
    return false;
  },


  /* `undefined` is not a constant, it is an identifier,
   * but using it as an identifier is not supported
   */
  constants: {
    'true': { type: AST.Literal, value: true },
    'false': { type: AST.Literal, value: false },
    'null': { type: AST.Literal, value: null },
    'undefined': {type: AST.Literal, value: undefined },
    'this': {type: AST.ThisExpression }
  }
};

function ifDefined(v, d) {
  return typeof v !== 'undefined' ? v : d;
}

function plusFn(l, r) {
  if (typeof l === 'undefined') return r;
  if (typeof r === 'undefined') return l;
  return l + r;
}

function isStateless($filter, filterName) {
  var fn = $filter(filterName);
  return !fn.$stateful;
}

function findConstantAndWatchExpressions(ast, $filter) {
  var allConstants;
  var argsToWatch;
  switch (ast.type) {
  case AST.Program:
    allConstants = true;
    forEach(ast.body, function(expr) {
      findConstantAndWatchExpressions(expr.expression, $filter);
      allConstants = allConstants && expr.expression.constant;
    });
    ast.constant = allConstants;
    break;
  case AST.Literal:
    ast.constant = true;
    ast.toWatch = [];
    break;
  case AST.UnaryExpression:
    findConstantAndWatchExpressions(ast.argument, $filter);
    ast.constant = ast.argument.constant;
    ast.toWatch = ast.argument.toWatch;
    break;
  case AST.BinaryExpression:
    findConstantAndWatchExpressions(ast.left, $filter);
    findConstantAndWatchExpressions(ast.right, $filter);
    ast.constant = ast.left.constant && ast.right.constant;
    ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
    break;
  case AST.LogicalExpression:
    findConstantAndWatchExpressions(ast.left, $filter);
    findConstantAndWatchExpressions(ast.right, $filter);
    ast.constant = ast.left.constant && ast.right.constant;
    ast.toWatch = ast.constant ? [] : [ast];
    break;
  case AST.ConditionalExpression:
    findConstantAndWatchExpressions(ast.test, $filter);
    findConstantAndWatchExpressions(ast.alternate, $filter);
    findConstantAndWatchExpressions(ast.consequent, $filter);
    ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
    ast.toWatch = ast.constant ? [] : [ast];
    break;
  case AST.Identifier:
    ast.constant = false;
    ast.toWatch = [ast];
    break;
  case AST.MemberExpression:
    findConstantAndWatchExpressions(ast.object, $filter);
    if (ast.computed) {
      findConstantAndWatchExpressions(ast.property, $filter);
    }
    ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
    ast.toWatch = [ast];
    break;
  case AST.CallExpression:
    allConstants = ast.filter ? isStateless($filter, ast.callee.name) : false;
    argsToWatch = [];
    forEach(ast.arguments, function(expr) {
      findConstantAndWatchExpressions(expr, $filter);
      allConstants = allConstants && expr.constant;
      if (!expr.constant) {
        argsToWatch.push.apply(argsToWatch, expr.toWatch);
      }
    });
    ast.constant = allConstants;
    ast.toWatch = ast.filter && isStateless($filter, ast.callee.name) ? argsToWatch : [ast];
    break;
  case AST.AssignmentExpression:
    findConstantAndWatchExpressions(ast.left, $filter);
    findConstantAndWatchExpressions(ast.right, $filter);
    ast.constant = ast.left.constant && ast.right.constant;
    ast.toWatch = [ast];
    break;
  case AST.ArrayExpression:
    allConstants = true;
    argsToWatch = [];
    forEach(ast.elements, function(expr) {
      findConstantAndWatchExpressions(expr, $filter);
      allConstants = allConstants && expr.constant;
      if (!expr.constant) {
        argsToWatch.push.apply(argsToWatch, expr.toWatch);
      }
    });
    ast.constant = allConstants;
    ast.toWatch = argsToWatch;
    break;
  case AST.ObjectExpression:
    allConstants = true;
    argsToWatch = [];
    forEach(ast.properties, function(property) {
      findConstantAndWatchExpressions(property.value, $filter);
      allConstants = allConstants && property.value.constant;
      if (!property.value.constant) {
        argsToWatch.push.apply(argsToWatch, property.value.toWatch);
      }
    });
    ast.constant = allConstants;
    ast.toWatch = argsToWatch;
    break;
  case AST.ThisExpression:
    ast.constant = false;
    ast.toWatch = [];
    break;
  }
}

function getInputs(body) {
  if (body.length != 1) return;
  var lastExpression = body[0].expression;
  var candidate = lastExpression.toWatch;
  if (candidate.length !== 1) return candidate;
  return candidate[0] !== lastExpression ? candidate : undefined;
}

function isAssignable(ast) {
  return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
}

function assignableAST(ast) {
  if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
    return {type: AST.AssignmentExpression, left: ast.body[0].expression, right: {type: AST.NGValueParameter}, operator: '='};
  }
}

function isLiteral(ast) {
  return ast.body.length === 0 ||
      ast.body.length === 1 && (
      ast.body[0].expression.type === AST.Literal ||
      ast.body[0].expression.type === AST.ArrayExpression ||
      ast.body[0].expression.type === AST.ObjectExpression);
}

function isConstant(ast) {
  return ast.constant;
}

function ASTCompiler(astBuilder, $filter) {
  this.astBuilder = astBuilder;
  this.$filter = $filter;
}

ASTCompiler.prototype = {
  compile: function(expression, expensiveChecks) {
    var self = this;
    var ast = this.astBuilder.ast(expression);
    this.state = {
      nextId: 0,
      filters: {},
      expensiveChecks: expensiveChecks,
      fn: {vars: [], body: [], own: {}},
      assign: {vars: [], body: [], own: {}},
      inputs: []
    };
    findConstantAndWatchExpressions(ast, self.$filter);
    var extra = '';
    var assignable;
    this.stage = 'assign';
    if ((assignable = assignableAST(ast))) {
      this.state.computing = 'assign';
      var result = this.nextId();
      this.recurse(assignable, result);
      extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
    }
    var toWatch = getInputs(ast.body);
    self.stage = 'inputs';
    forEach(toWatch, function(watch, key) {
      var fnKey = 'fn' + key;
      self.state[fnKey] = {vars: [], body: [], own: {}};
      self.state.computing = fnKey;
      var intoId = self.nextId();
      self.recurse(watch, intoId);
      self.return_(intoId);
      self.state.inputs.push(fnKey);
      watch.watchId = key;
    });
    this.state.computing = 'fn';
    this.stage = 'main';
    this.recurse(ast);
    var fnString =
      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
      '"' + this.USE + ' ' + this.STRICT + '";\n' +
      this.filterPrefix() +
      'var fn=' + this.generateFunction('fn', 's,l,a,i') +
      extra +
      this.watchFns() +
      'return fn;';

    /* jshint -W054 */
    var fn = (new Function('$filter',
        'ensureSafeMemberName',
        'ensureSafeObject',
        'ensureSafeFunction',
        'ifDefined',
        'plus',
        'text',
        fnString))(
          this.$filter,
          ensureSafeMemberName,
          ensureSafeObject,
          ensureSafeFunction,
          ifDefined,
          plusFn,
          expression);
    /* jshint +W054 */
    this.state = this.stage = undefined;
    fn.literal = isLiteral(ast);
    fn.constant = isConstant(ast);
    return fn;
  },

  USE: 'use',

  STRICT: 'strict',

  watchFns: function() {
    var result = [];
    var fns = this.state.inputs;
    var self = this;
    forEach(fns, function(name) {
      result.push('var ' + name + '=' + self.generateFunction(name, 's'));
    });
    if (fns.length) {
      result.push('fn.inputs=[' + fns.join(',') + '];');
    }
    return result.join('');
  },

  generateFunction: function(name, params) {
    return 'function(' + params + '){' +
        this.varsPrefix(name) +
        this.body(name) +
        '};';
  },

  filterPrefix: function() {
    var parts = [];
    var self = this;
    forEach(this.state.filters, function(id, filter) {
      parts.push(id + '=$filter(' + self.escape(filter) + ')');
    });
    if (parts.length) return 'var ' + parts.join(',') + ';';
    return '';
  },

  varsPrefix: function(section) {
    return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
  },

  body: function(section) {
    return this.state[section].body.join('');
  },

  recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
    var left, right, self = this, args, expression;
    recursionFn = recursionFn || noop;
    if (!skipWatchIdCheck && isDefined(ast.watchId)) {
      intoId = intoId || this.nextId();
      this.if_('i',
        this.lazyAssign(intoId, this.computedMember('i', ast.watchId)),
        this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
      );
      return;
    }
    switch (ast.type) {
    case AST.Program:
      forEach(ast.body, function(expression, pos) {
        self.recurse(expression.expression, undefined, undefined, function(expr) { right = expr; });
        if (pos !== ast.body.length - 1) {
          self.current().body.push(right, ';');
        } else {
          self.return_(right);
        }
      });
      break;
    case AST.Literal:
      expression = this.escape(ast.value);
      this.assign(intoId, expression);
      recursionFn(expression);
      break;
    case AST.UnaryExpression:
      this.recurse(ast.argument, undefined, undefined, function(expr) { right = expr; });
      expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
      this.assign(intoId, expression);
      recursionFn(expression);
      break;
    case AST.BinaryExpression:
      this.recurse(ast.left, undefined, undefined, function(expr) { left = expr; });
      this.recurse(ast.right, undefined, undefined, function(expr) { right = expr; });
      if (ast.operator === '+') {
        expression = this.plus(left, right);
      } else if (ast.operator === '-') {
        expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
      } else {
        expression = '(' + left + ')' + ast.operator + '(' + right + ')';
      }
      this.assign(intoId, expression);
      recursionFn(expression);
      break;
    case AST.LogicalExpression:
      intoId = intoId || this.nextId();
      self.recurse(ast.left, intoId);
      self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
      recursionFn(intoId);
      break;
    case AST.ConditionalExpression:
      intoId = intoId || this.nextId();
      self.recurse(ast.test, intoId);
      self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
      recursionFn(intoId);
      break;
    case AST.Identifier:
      intoId = intoId || this.nextId();
      if (nameId) {
        nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
        nameId.computed = false;
        nameId.name = ast.name;
      }
      ensureSafeMemberName(ast.name);
      self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)),
        function() {
          self.if_(self.stage === 'inputs' || 's', function() {
            if (create && create !== 1) {
              self.if_(
                self.not(self.nonComputedMember('s', ast.name)),
                self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
            }
            self.assign(intoId, self.nonComputedMember('s', ast.name));
          });
        }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name))
        );
      if (self.state.expensiveChecks || isPossiblyDangerousMemberName(ast.name)) {
        self.addEnsureSafeObject(intoId);
      }
      recursionFn(intoId);
      break;
    case AST.MemberExpression:
      left = nameId && (nameId.context = this.nextId()) || this.nextId();
      intoId = intoId || this.nextId();
      self.recurse(ast.object, left, undefined, function() {
        self.if_(self.notNull(left), function() {
          if (ast.computed) {
            right = self.nextId();
            self.recurse(ast.property, right);
            self.addEnsureSafeMemberName(right);
            if (create && create !== 1) {
              self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
            }
            expression = self.ensureSafeObject(self.computedMember(left, right));
            self.assign(intoId, expression);
            if (nameId) {
              nameId.computed = true;
              nameId.name = right;
            }
          } else {
            ensureSafeMemberName(ast.property.name);
            if (create && create !== 1) {
              self.if_(self.not(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
            }
            expression = self.nonComputedMember(left, ast.property.name);
            if (self.state.expensiveChecks || isPossiblyDangerousMemberName(ast.property.name)) {
              expression = self.ensureSafeObject(expression);
            }
            self.assign(intoId, expression);
            if (nameId) {
              nameId.computed = false;
              nameId.name = ast.property.name;
            }
          }
        }, function() {
          self.assign(intoId, 'undefined');
        });
        recursionFn(intoId);
      }, !!create);
      break;
    case AST.CallExpression:
      intoId = intoId || this.nextId();
      if (ast.filter) {
        right = self.filter(ast.callee.name);
        args = [];
        forEach(ast.arguments, function(expr) {
          var argument = self.nextId();
          self.recurse(expr, argument);
          args.push(argument);
        });
        expression = right + '(' + args.join(',') + ')';
        self.assign(intoId, expression);
        recursionFn(intoId);
      } else {
        right = self.nextId();
        left = {};
        args = [];
        self.recurse(ast.callee, right, left, function() {
          self.if_(self.notNull(right), function() {
            self.addEnsureSafeFunction(right);
            forEach(ast.arguments, function(expr) {
              self.recurse(expr, self.nextId(), undefined, function(argument) {
                args.push(self.ensureSafeObject(argument));
              });
            });
            if (left.name) {
              if (!self.state.expensiveChecks) {
                self.addEnsureSafeObject(left.context);
              }
              expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
            } else {
              expression = right + '(' + args.join(',') + ')';
            }
            expression = self.ensureSafeObject(expression);
            self.assign(intoId, expression);
          }, function() {
            self.assign(intoId, 'undefined');
          });
          recursionFn(intoId);
        });
      }
      break;
    case AST.AssignmentExpression:
      right = this.nextId();
      left = {};
      if (!isAssignable(ast.left)) {
        throw $parseMinErr('lval', 'Trying to assing a value to a non l-value');
      }
      this.recurse(ast.left, undefined, left, function() {
        self.if_(self.notNull(left.context), function() {
          self.recurse(ast.right, right);
          self.addEnsureSafeObject(self.member(left.context, left.name, left.computed));
          expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
          self.assign(intoId, expression);
          recursionFn(intoId || expression);
        });
      }, 1);
      break;
    case AST.ArrayExpression:
      args = [];
      forEach(ast.elements, function(expr) {
        self.recurse(expr, self.nextId(), undefined, function(argument) {
          args.push(argument);
        });
      });
      expression = '[' + args.join(',') + ']';
      this.assign(intoId, expression);
      recursionFn(expression);
      break;
    case AST.ObjectExpression:
      args = [];
      forEach(ast.properties, function(property) {
        self.recurse(property.value, self.nextId(), undefined, function(expr) {
          args.push(self.escape(
              property.key.type === AST.Identifier ? property.key.name :
                ('' + property.key.value)) +
              ':' + expr);
        });
      });
      expression = '{' + args.join(',') + '}';
      this.assign(intoId, expression);
      recursionFn(expression);
      break;
    case AST.ThisExpression:
      this.assign(intoId, 's');
      recursionFn('s');
      break;
    case AST.NGValueParameter:
      this.assign(intoId, 'v');
      recursionFn('v');
      break;
    }
  },

  getHasOwnProperty: function(element, property) {
    var key = element + '.' + property;
    var own = this.current().own;
    if (!own.hasOwnProperty(key)) {
      own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
    }
    return own[key];
  },

  assign: function(id, value) {
    if (!id) return;
    this.current().body.push(id, '=', value, ';');
    return id;
  },

  filter: function(filterName) {
    if (!this.state.filters.hasOwnProperty(filterName)) {
      this.state.filters[filterName] = this.nextId(true);
    }
    return this.state.filters[filterName];
  },

  ifDefined: function(id, defaultValue) {
    return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
  },

  plus: function(left, right) {
    return 'plus(' + left + ',' + right + ')';
  },

  return_: function(id) {
    this.current().body.push('return ', id, ';');
  },

  if_: function(test, alternate, consequent) {
    if (test === true) {
      alternate();
    } else {
      var body = this.current().body;
      body.push('if(', test, '){');
      alternate();
      body.push('}');
      if (consequent) {
        body.push('else{');
        consequent();
        body.push('}');
      }
    }
  },

  not: function(expression) {
    return '!(' + expression + ')';
  },

  notNull: function(expression) {
    return expression + '!=null';
  },

  nonComputedMember: function(left, right) {
    return left + '.' + right;
  },

  computedMember: function(left, right) {
    return left + '[' + right + ']';
  },

  member: function(left, right, computed) {
    if (computed) return this.computedMember(left, right);
    return this.nonComputedMember(left, right);
  },

  addEnsureSafeObject: function(item) {
    this.current().body.push(this.ensureSafeObject(item), ';');
  },

  addEnsureSafeMemberName: function(item) {
    this.current().body.push(this.ensureSafeMemberName(item), ';');
  },

  addEnsureSafeFunction: function(item) {
    this.current().body.push(this.ensureSafeFunction(item), ';');
  },

  ensureSafeObject: function(item) {
    return 'ensureSafeObject(' + item + ',text)';
  },

  ensureSafeMemberName: function(item) {
    return 'ensureSafeMemberName(' + item + ',text)';
  },

  ensureSafeFunction: function(item) {
    return 'ensureSafeFunction(' + item + ',text)';
  },

  lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
    var self = this;
    return function() {
      self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
    };
  },

  lazyAssign: function(id, value) {
    var self = this;
    return function() {
      self.assign(id, value);
    };
  },

  stringEscapeRegex: /[^ a-zA-Z0-9]/g,

  stringEscapeFn: function(c) {
    return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
  },

  escape: function(value) {
    if (isString(value)) return "'" + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + "'";
    if (isNumber(value)) return value.toString();
    if (value === true) return 'true';
    if (value === false) return 'false';
    if (value === null) return 'null';
    if (typeof value === 'undefined') return 'undefined';

    throw $parseMinErr('esc', 'IMPOSSIBLE');
  },

  nextId: function(skip, init) {
    var id = 'v' + (this.state.nextId++);
    if (!skip) {
      this.current().vars.push(id + (init ? '=' + init : ''));
    }
    return id;
  },

  current: function() {
    return this.state[this.state.computing];
  }
};


function ASTInterpreter(astBuilder, $filter) {
  this.astBuilder = astBuilder;
  this.$filter = $filter;
}

ASTInterpreter.prototype = {
  compile: function(expression, expensiveChecks) {
    var self = this;
    var ast = this.astBuilder.ast(expression);
    this.expression = expression;
    this.expensiveChecks = expensiveChecks;
    findConstantAndWatchExpressions(ast, self.$filter);
    var assignable;
    var assign;
    if ((assignable = assignableAST(ast))) {
      assign = this.recurse(assignable);
    }
    var toWatch = getInputs(ast.body);
    var inputs;
    if (toWatch) {
      inputs = [];
      forEach(toWatch, function(watch, key) {
        var input = self.recurse(watch);
        watch.input = input;
        inputs.push(input);
        watch.watchId = key;
      });
    }
    var expressions = [];
    forEach(ast.body, function(expression) {
      expressions.push(self.recurse(expression.expression));
    });
    var fn = ast.body.length === 0 ? function() {} :
             ast.body.length === 1 ? expressions[0] :
             function(scope, locals) {
               var lastValue;
               forEach(expressions, function(exp) {
                 lastValue = exp(scope, locals);
               });
               return lastValue;
             };
    if (assign) {
      fn.assign = function(scope, value, locals) {
        return assign(scope, locals, value);
      };
    }
    if (inputs) {
      fn.inputs = inputs;
    }
    fn.literal = isLiteral(ast);
    fn.constant = isConstant(ast);
    return fn;
  },

  recurse: function(ast, context, create) {
    var left, right, self = this, args, expression;
    if (ast.input) {
      return this.inputs(ast.input, ast.watchId);
    }
    switch (ast.type) {
    case AST.Literal:
      return this.value(ast.value, context);
    case AST.UnaryExpression:
      right = this.recurse(ast.argument);
      return this['unary' + ast.operator](right, context);
    case AST.BinaryExpression:
      left = this.recurse(ast.left);
      right = this.recurse(ast.right);
      return this['binary' + ast.operator](left, right, context);
    case AST.LogicalExpression:
      left = this.recurse(ast.left);
      right = this.recurse(ast.right);
      return this['binary' + ast.operator](left, right, context);
    case AST.ConditionalExpression:
      return this['ternary?:'](
        this.recurse(ast.test),
        this.recurse(ast.alternate),
        this.recurse(ast.consequent),
        context
      );
    case AST.Identifier:
      ensureSafeMemberName(ast.name, self.expression);
      return self.identifier(ast.name,
                             self.expensiveChecks || isPossiblyDangerousMemberName(ast.name),
                             context, create, self.expression);
    case AST.MemberExpression:
      left = this.recurse(ast.object, false, !!create);
      if (!ast.computed) {
        ensureSafeMemberName(ast.property.name, self.expression);
        right = ast.property.name;
      }
      if (ast.computed) right = this.recurse(ast.property);
      return ast.computed ?
        this.computedMember(left, right, context, create, self.expression) :
        this.nonComputedMember(left, right, self.expensiveChecks, context, create, self.expression);
    case AST.CallExpression:
      args = [];
      forEach(ast.arguments, function(expr) {
        args.push(self.recurse(expr));
      });
      if (ast.filter) right = this.$filter(ast.callee.name);
      if (!ast.filter) right = this.recurse(ast.callee, true);
      return ast.filter ?
        function(scope, locals, assign, inputs) {
          var values = [];
          for (var i = 0; i < args.length; ++i) {
            values.push(args[i](scope, locals, assign, inputs));
          }
          var value = right.apply(undefined, values, inputs);
          return context ? {context: undefined, name: undefined, value: value} : value;
        } :
        function(scope, locals, assign, inputs) {
          var rhs = right(scope, locals, assign, inputs);
          var value;
          if (rhs.value != null) {
            ensureSafeObject(rhs.context, self.expression);
            ensureSafeFunction(rhs.value, self.expression);
            var values = [];
            for (var i = 0; i < args.length; ++i) {
              values.push(ensureSafeObject(args[i](scope, locals, assign, inputs), self.expression));
            }
            value = ensureSafeObject(rhs.value.apply(rhs.context, values), self.expression);
          }
          return context ? {value: value} : value;
        };
    case AST.AssignmentExpression:
      left = this.recurse(ast.left, true, 1);
      right = this.recurse(ast.right);
      return function(scope, locals, assign, inputs) {
        var lhs = left(scope, locals, assign, inputs);
        var rhs = right(scope, locals, assign, inputs);
        ensureSafeObject(lhs.value, self.expression);
        lhs.context[lhs.name] = rhs;
        return context ? {value: rhs} : rhs;
      };
    case AST.ArrayExpression:
      args = [];
      forEach(ast.elements, function(expr) {
        args.push(self.recurse(expr));
      });
      return function(scope, locals, assign, inputs) {
        var value = [];
        for (var i = 0; i < args.length; ++i) {
          value.push(args[i](scope, locals, assign, inputs));
        }
        return context ? {value: value} : value;
      };
    case AST.ObjectExpression:
      args = [];
      forEach(ast.properties, function(property) {
        args.push({key: property.key.type === AST.Identifier ?
                        property.key.name :
                        ('' + property.key.value),
                   value: self.recurse(property.value)
        });
      });
      return function(scope, locals, assign, inputs) {
        var value = {};
        for (var i = 0; i < args.length; ++i) {
          value[args[i].key] = args[i].value(scope, locals, assign, inputs);
        }
        return context ? {value: value} : value;
      };
    case AST.ThisExpression:
      return function(scope) {
        return context ? {value: scope} : scope;
      };
    case AST.NGValueParameter:
      return function(scope, locals, assign, inputs) {
        return context ? {value: assign} : assign;
      };
    }
  },

  'unary+': function(argument, context) {
    return function(scope, locals, assign, inputs) {
      var arg = argument(scope, locals, assign, inputs);
      if (isDefined(arg)) {
        arg = +arg;
      } else {
        arg = 0;
      }
      return context ? {value: arg} : arg;
    };
  },
  'unary-': function(argument, context) {
    return function(scope, locals, assign, inputs) {
      var arg = argument(scope, locals, assign, inputs);
      if (isDefined(arg)) {
        arg = -arg;
      } else {
        arg = 0;
      }
      return context ? {value: arg} : arg;
    };
  },
  'unary!': function(argument, context) {
    return function(scope, locals, assign, inputs) {
      var arg = !argument(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary+': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      var rhs = right(scope, locals, assign, inputs);
      var arg = plusFn(lhs, rhs);
      return context ? {value: arg} : arg;
    };
  },
  'binary-': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      var rhs = right(scope, locals, assign, inputs);
      var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
      return context ? {value: arg} : arg;
    };
  },
  'binary*': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary/': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary%': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary===': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary!==': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary==': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary!=': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary<': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary>': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary<=': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary>=': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary&&': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary||': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'ternary?:': function(test, alternate, consequent, context) {
    return function(scope, locals, assign, inputs) {
      var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  value: function(value, context) {
    return function() { return context ? {context: undefined, name: undefined, value: value} : value; };
  },
  identifier: function(name, expensiveChecks, context, create, expression) {
    return function(scope, locals, assign, inputs) {
      var base = locals && (name in locals) ? locals : scope;
      if (create && create !== 1 && base && !(base[name])) {
        base[name] = {};
      }
      var value = base ? base[name] : undefined;
      if (expensiveChecks) {
        ensureSafeObject(value, expression);
      }
      if (context) {
        return {context: base, name: name, value: value};
      } else {
        return value;
      }
    };
  },
  computedMember: function(left, right, context, create, expression) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      var rhs;
      var value;
      if (lhs != null) {
        rhs = right(scope, locals, assign, inputs);
        ensureSafeMemberName(rhs, expression);
        if (create && create !== 1 && lhs && !(lhs[rhs])) {
          lhs[rhs] = {};
        }
        value = lhs[rhs];
        ensureSafeObject(value, expression);
      }
      if (context) {
        return {context: lhs, name: rhs, value: value};
      } else {
        return value;
      }
    };
  },
  nonComputedMember: function(left, right, expensiveChecks, context, create, expression) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      if (create && create !== 1 && lhs && !(lhs[right])) {
        lhs[right] = {};
      }
      var value = lhs != null ? lhs[right] : undefined;
      if (expensiveChecks || isPossiblyDangerousMemberName(right)) {
        ensureSafeObject(value, expression);
      }
      if (context) {
        return {context: lhs, name: right, value: value};
      } else {
        return value;
      }
    };
  },
  inputs: function(input, watchId) {
    return function(scope, value, locals, inputs) {
      if (inputs) return inputs[watchId];
      return input(scope, value, locals);
    };
  }
};

/**
 * @constructor
 */
var Parser = function(lexer, $filter, options) {
  this.lexer = lexer;
  this.$filter = $filter;
  this.options = options;
  this.ast = new AST(this.lexer);
  this.astCompiler = options.csp ? new ASTInterpreter(this.ast, $filter) :
                                   new ASTCompiler(this.ast, $filter);
};

Parser.prototype = {
  constructor: Parser,

  parse: function(text) {
    return this.astCompiler.compile(text, this.options.expensiveChecks);
  }
};

//////////////////////////////////////////////////
// Parser helper functions
//////////////////////////////////////////////////

function setter(obj, path, setValue, fullExp) {
  ensureSafeObject(obj, fullExp);

  var element = path.split('.'), key;
  for (var i = 0; element.length > 1; i++) {
    key = ensureSafeMemberName(element.shift(), fullExp);
    var propertyObj = ensureSafeObject(obj[key], fullExp);
    if (!propertyObj) {
      propertyObj = {};
      obj[key] = propertyObj;
    }
    obj = propertyObj;
  }
  key = ensureSafeMemberName(element.shift(), fullExp);
  ensureSafeObject(obj[key], fullExp);
  obj[key] = setValue;
  return setValue;
}

var getterFnCacheDefault = createMap();
var getterFnCacheExpensive = createMap();

function isPossiblyDangerousMemberName(name) {
  return name == 'constructor';
}

var objectValueOf = Object.prototype.valueOf;

function getValueOf(value) {
  return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
}

///////////////////////////////////

/**
 * @ngdoc service
 * @name $parse
 * @kind function
 *
 * @description
 *
 * Converts Angular {@link guide/expression expression} into a function.
 *
 * ```js
 *   var getter = $parse('user.name');
 *   var setter = getter.assign;
 *   var context = {user:{name:'angular'}};
 *   var locals = {user:{name:'local'}};
 *
 *   expect(getter(context)).toEqual('angular');
 *   setter(context, 'newValue');
 *   expect(context.user.name).toEqual('newValue');
 *   expect(getter(context, locals)).toEqual('local');
 * ```
 *
 *
 * @param {string} expression String expression to compile.
 * @returns {function(context, locals)} a function which represents the compiled expression:
 *
 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
 *      are evaluated against (typically a scope object).
 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
 *      `context`.
 *
 *    The returned function also has the following properties:
 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
 *        literal.
 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
 *        constant literals.
 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
 *        set to a function to change its value on the given context.
 *
 */


/**
 * @ngdoc provider
 * @name $parseProvider
 *
 * @description
 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
 *  service.
 */
function $ParseProvider() {
  var cacheDefault = createMap();
  var cacheExpensive = createMap();

  this.$get = ['$filter', '$sniffer', function($filter, $sniffer) {
    var $parseOptions = {
          csp: $sniffer.csp,
          expensiveChecks: false
        },
        $parseOptionsExpensive = {
          csp: $sniffer.csp,
          expensiveChecks: true
        };

    return function $parse(exp, interceptorFn, expensiveChecks) {
      var parsedExpression, oneTime, cacheKey;

      switch (typeof exp) {
        case 'string':
          exp = exp.trim();
          cacheKey = exp;

          var cache = (expensiveChecks ? cacheExpensive : cacheDefault);
          parsedExpression = cache[cacheKey];

          if (!parsedExpression) {
            if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
              oneTime = true;
              exp = exp.substring(2);
            }
            var parseOptions = expensiveChecks ? $parseOptionsExpensive : $parseOptions;
            var lexer = new Lexer(parseOptions);
            var parser = new Parser(lexer, $filter, parseOptions);
            parsedExpression = parser.parse(exp);
            if (parsedExpression.constant) {
              parsedExpression.$$watchDelegate = constantWatchDelegate;
            } else if (oneTime) {
              parsedExpression.$$watchDelegate = parsedExpression.literal ?
                  oneTimeLiteralWatchDelegate : oneTimeWatchDelegate;
            } else if (parsedExpression.inputs) {
              parsedExpression.$$watchDelegate = inputsWatchDelegate;
            }
            cache[cacheKey] = parsedExpression;
          }
          return addInterceptor(parsedExpression, interceptorFn);

        case 'function':
          return addInterceptor(exp, interceptorFn);

        default:
          return noop;
      }
    };

    function expressionInputDirtyCheck(newValue, oldValueOfValue) {

      if (newValue == null || oldValueOfValue == null) { // null/undefined
        return newValue === oldValueOfValue;
      }

      if (typeof newValue === 'object') {

        // attempt to convert the value to a primitive type
        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
        //             be cheaply dirty-checked
        newValue = getValueOf(newValue);

        if (typeof newValue === 'object') {
          // objects/arrays are not supported - deep-watching them would be too expensive
          return false;
        }

        // fall-through to the primitive equality check
      }

      //Primitive or NaN
      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
    }

    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
      var inputExpressions = parsedExpression.inputs;
      var lastResult;

      if (inputExpressions.length === 1) {
        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
        inputExpressions = inputExpressions[0];
        return scope.$watch(function expressionInputWatch(scope) {
          var newInputValue = inputExpressions(scope);
          if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf)) {
            lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
            oldInputValueOf = newInputValue && getValueOf(newInputValue);
          }
          return lastResult;
        }, listener, objectEquality, prettyPrintExpression);
      }

      var oldInputValueOfValues = [];
      var oldInputValues = [];
      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
        oldInputValues[i] = null;
      }

      return scope.$watch(function expressionInputsWatch(scope) {
        var changed = false;

        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
          var newInputValue = inputExpressions[i](scope);
          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i]))) {
            oldInputValues[i] = newInputValue;
            oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
          }
        }

        if (changed) {
          lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
        }

        return lastResult;
      }, listener, objectEquality, prettyPrintExpression);
    }

    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression) {
      var unwatch, lastValue;
      return unwatch = scope.$watch(function oneTimeWatch(scope) {
        return parsedExpression(scope);
      }, function oneTimeListener(value, old, scope) {
        lastValue = value;
        if (isFunction(listener)) {
          listener.apply(this, arguments);
        }
        if (isDefined(value)) {
          scope.$$postDigest(function() {
            if (isDefined(lastValue)) {
              unwatch();
            }
          });
        }
      }, objectEquality);
    }

    function oneTimeLiteralWatchDelegate(scope, listener, objectEquality, parsedExpression) {
      var unwatch, lastValue;
      return unwatch = scope.$watch(function oneTimeWatch(scope) {
        return parsedExpression(scope);
      }, function oneTimeListener(value, old, scope) {
        lastValue = value;
        if (isFunction(listener)) {
          listener.call(this, value, old, scope);
        }
        if (isAllDefined(value)) {
          scope.$$postDigest(function() {
            if (isAllDefined(lastValue)) unwatch();
          });
        }
      }, objectEquality);

      function isAllDefined(value) {
        var allDefined = true;
        forEach(value, function(val) {
          if (!isDefined(val)) allDefined = false;
        });
        return allDefined;
      }
    }

    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
      var unwatch;
      return unwatch = scope.$watch(function constantWatch(scope) {
        return parsedExpression(scope);
      }, function constantListener(value, old, scope) {
        if (isFunction(listener)) {
          listener.apply(this, arguments);
        }
        unwatch();
      }, objectEquality);
    }

    function addInterceptor(parsedExpression, interceptorFn) {
      if (!interceptorFn) return parsedExpression;
      var watchDelegate = parsedExpression.$$watchDelegate;

      var regularWatch =
          watchDelegate !== oneTimeLiteralWatchDelegate &&
          watchDelegate !== oneTimeWatchDelegate;

      var fn = regularWatch ? function regularInterceptedExpression(scope, locals, assign, inputs) {
        var value = parsedExpression(scope, locals, assign, inputs);
        return interceptorFn(value, scope, locals);
      } : function oneTimeInterceptedExpression(scope, locals, assign, inputs) {
        var value = parsedExpression(scope, locals, assign, inputs);
        var result = interceptorFn(value, scope, locals);
        // we only return the interceptor's result if the
        // initial value is defined (for bind-once)
        return isDefined(value) ? result : value;
      };

      // Propagate $$watchDelegates other then inputsWatchDelegate
      if (parsedExpression.$$watchDelegate &&
          parsedExpression.$$watchDelegate !== inputsWatchDelegate) {
        fn.$$watchDelegate = parsedExpression.$$watchDelegate;
      } else if (!interceptorFn.$stateful) {
        // If there is an interceptor, but no watchDelegate then treat the interceptor like
        // we treat filters - it is assumed to be a pure function unless flagged with $stateful
        fn.$$watchDelegate = inputsWatchDelegate;
        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
      }

      return fn;
    }
  }];
}

/**
 * @ngdoc service
 * @name $q
 * @requires $rootScope
 *
 * @description
 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
 * when they are done processing.
 *
 * This is an implementation of promises/deferred objects inspired by
 * [Kris Kowal's Q](https://github.com/kriskowal/q).
 *
 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
 * implementations, and the other which resembles ES6 promises to some degree.
 *
 * # $q constructor
 *
 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
 * function as the first argument. This is similar to the native Promise implementation from ES6 Harmony,
 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 *
 * While the constructor-style use is supported, not all of the supporting methods from ES6 Harmony promises are
 * available yet.
 *
 * It can be used like so:
 *
 * ```js
 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
 *   // are available in the current lexical scope (they could have been injected or passed in).
 *
 *   function asyncGreet(name) {
 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
 *     return $q(function(resolve, reject) {
 *       setTimeout(function() {
 *         if (okToGreet(name)) {
 *           resolve('Hello, ' + name + '!');
 *         } else {
 *           reject('Greeting ' + name + ' is not allowed.');
 *         }
 *       }, 1000);
 *     });
 *   }
 *
 *   var promise = asyncGreet('Robin Hood');
 *   promise.then(function(greeting) {
 *     alert('Success: ' + greeting);
 *   }, function(reason) {
 *     alert('Failed: ' + reason);
 *   });
 * ```
 *
 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
 *
 * However, the more traditional CommonJS-style usage is still available, and documented below.
 *
 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
 * interface for interacting with an object that represents the result of an action that is
 * performed asynchronously, and may or may not be finished at any given point in time.
 *
 * From the perspective of dealing with error handling, deferred and promise APIs are to
 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
 *
 * ```js
 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
 *   // are available in the current lexical scope (they could have been injected or passed in).
 *
 *   function asyncGreet(name) {
 *     var deferred = $q.defer();
 *
 *     setTimeout(function() {
 *       deferred.notify('About to greet ' + name + '.');
 *
 *       if (okToGreet(name)) {
 *         deferred.resolve('Hello, ' + name + '!');
 *       } else {
 *         deferred.reject('Greeting ' + name + ' is not allowed.');
 *       }
 *     }, 1000);
 *
 *     return deferred.promise;
 *   }
 *
 *   var promise = asyncGreet('Robin Hood');
 *   promise.then(function(greeting) {
 *     alert('Success: ' + greeting);
 *   }, function(reason) {
 *     alert('Failed: ' + reason);
 *   }, function(update) {
 *     alert('Got notification: ' + update);
 *   });
 * ```
 *
 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
 * comes in the way of guarantees that promise and deferred APIs make, see
 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
 *
 * Additionally the promise api allows for composition that is very hard to do with the
 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
 * section on serial or parallel joining of promises.
 *
 * # The Deferred API
 *
 * A new instance of deferred is constructed by calling `$q.defer()`.
 *
 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
 * that can be used for signaling the successful or unsuccessful completion, as well as the status
 * of the task.
 *
 * **Methods**
 *
 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
 *   constructed via `$q.reject`, the promise will be rejected instead.
 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
 *   resolving it with a rejection constructed via `$q.reject`.
 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
 *   multiple times before the promise is either resolved or rejected.
 *
 * **Properties**
 *
 * - promise – `{Promise}` – promise object associated with this deferred.
 *
 *
 * # The Promise API
 *
 * A new promise instance is created when a deferred instance is created and can be retrieved by
 * calling `deferred.promise`.
 *
 * The purpose of the promise object is to allow for interested parties to get access to the result
 * of the deferred task when it completes.
 *
 * **Methods**
 *
 * - `then(successCallback, errorCallback, notifyCallback)` – regardless of when the promise was or
 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
 *   as soon as the result is available. The callbacks are called with a single argument: the result
 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
 *   provide a progress indication, before the promise is resolved or rejected.
 *
 *   This method *returns a new promise* which is resolved or rejected via the return value of the
 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
 *   with the value which is resolved in that promise using
 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
 *   resolved or rejected from the notifyCallback method.
 *
 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
 *
 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
 *   but to do so without modifying the final value. This is useful to release resources or do some
 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
 *   more information.
 *
 * # Chaining promises
 *
 * Because calling the `then` method of a promise returns a new derived promise, it is easily
 * possible to create a chain of promises:
 *
 * ```js
 *   promiseB = promiseA.then(function(result) {
 *     return result + 1;
 *   });
 *
 *   // promiseB will be resolved immediately after promiseA is resolved and its value
 *   // will be the result of promiseA incremented by 1
 * ```
 *
 * It is possible to create chains of any length and since a promise can be resolved with another
 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
 * $http's response interceptors.
 *
 *
 * # Differences between Kris Kowal's Q and $q
 *
 *  There are two main differences:
 *
 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
 *   mechanism in angular, which means faster propagation of resolution or rejection into your
 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
 *   all the important functionality needed for common async tasks.
 *
 *  # Testing
 *
 *  ```js
 *    it('should simulate promise', inject(function($q, $rootScope) {
 *      var deferred = $q.defer();
 *      var promise = deferred.promise;
 *      var resolvedValue;
 *
 *      promise.then(function(value) { resolvedValue = value; });
 *      expect(resolvedValue).toBeUndefined();
 *
 *      // Simulate resolving of promise
 *      deferred.resolve(123);
 *      // Note that the 'then' function does not get called synchronously.
 *      // This is because we want the promise API to always be async, whether or not
 *      // it got called synchronously or asynchronously.
 *      expect(resolvedValue).toBeUndefined();
 *
 *      // Propagate promise resolution to 'then' functions using $apply().
 *      $rootScope.$apply();
 *      expect(resolvedValue).toEqual(123);
 *    }));
 *  ```
 *
 * @param {function(function, function)} resolver Function which is responsible for resolving or
 *   rejecting the newly created promise. The first parameter is a function which resolves the
 *   promise, the second parameter is a function which rejects the promise.
 *
 * @returns {Promise} The newly created promise.
 */
function $QProvider() {

  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
    return qFactory(function(callback) {
      $rootScope.$evalAsync(callback);
    }, $exceptionHandler);
  }];
}

function $$QProvider() {
  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
    return qFactory(function(callback) {
      $browser.defer(callback);
    }, $exceptionHandler);
  }];
}

/**
 * Constructs a promise manager.
 *
 * @param {function(function)} nextTick Function for executing functions in the next turn.
 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
 *     debugging purposes.
 * @returns {object} Promise manager.
 */
function qFactory(nextTick, exceptionHandler) {
  var $qMinErr = minErr('$q', TypeError);
  function callOnce(self, resolveFn, rejectFn) {
    var called = false;
    function wrap(fn) {
      return function(value) {
        if (called) return;
        called = true;
        fn.call(self, value);
      };
    }

    return [wrap(resolveFn), wrap(rejectFn)];
  }

  /**
   * @ngdoc method
   * @name ng.$q#defer
   * @kind function
   *
   * @description
   * Creates a `Deferred` object which represents a task which will finish in the future.
   *
   * @returns {Deferred} Returns a new instance of deferred.
   */
  var defer = function() {
    return new Deferred();
  };

  function Promise() {
    this.$$state = { status: 0 };
  }

  Promise.prototype = {
    then: function(onFulfilled, onRejected, progressBack) {
      var result = new Deferred();

      this.$$state.pending = this.$$state.pending || [];
      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);

      return result.promise;
    },

    "catch": function(callback) {
      return this.then(null, callback);
    },

    "finally": function(callback, progressBack) {
      return this.then(function(value) {
        return handleCallback(value, true, callback);
      }, function(error) {
        return handleCallback(error, false, callback);
      }, progressBack);
    }
  };

  //Faster, more basic than angular.bind http://jsperf.com/angular-bind-vs-custom-vs-native
  function simpleBind(context, fn) {
    return function(value) {
      fn.call(context, value);
    };
  }

  function processQueue(state) {
    var fn, deferred, pending;

    pending = state.pending;
    state.processScheduled = false;
    state.pending = undefined;
    for (var i = 0, ii = pending.length; i < ii; ++i) {
      deferred = pending[i][0];
      fn = pending[i][state.status];
      try {
        if (isFunction(fn)) {
          deferred.resolve(fn(state.value));
        } else if (state.status === 1) {
          deferred.resolve(state.value);
        } else {
          deferred.reject(state.value);
        }
      } catch (e) {
        deferred.reject(e);
        exceptionHandler(e);
      }
    }
  }

  function scheduleProcessQueue(state) {
    if (state.processScheduled || !state.pending) return;
    state.processScheduled = true;
    nextTick(function() { processQueue(state); });
  }

  function Deferred() {
    this.promise = new Promise();
    //Necessary to support unbound execution :/
    this.resolve = simpleBind(this, this.resolve);
    this.reject = simpleBind(this, this.reject);
    this.notify = simpleBind(this, this.notify);
  }

  Deferred.prototype = {
    resolve: function(val) {
      if (this.promise.$$state.status) return;
      if (val === this.promise) {
        this.$$reject($qMinErr(
          'qcycle',
          "Expected promise to be resolved with value other than itself '{0}'",
          val));
      } else {
        this.$$resolve(val);
      }

    },

    $$resolve: function(val) {
      var then, fns;

      fns = callOnce(this, this.$$resolve, this.$$reject);
      try {
        if ((isObject(val) || isFunction(val))) then = val && val.then;
        if (isFunction(then)) {
          this.promise.$$state.status = -1;
          then.call(val, fns[0], fns[1], this.notify);
        } else {
          this.promise.$$state.value = val;
          this.promise.$$state.status = 1;
          scheduleProcessQueue(this.promise.$$state);
        }
      } catch (e) {
        fns[1](e);
        exceptionHandler(e);
      }
    },

    reject: function(reason) {
      if (this.promise.$$state.status) return;
      this.$$reject(reason);
    },

    $$reject: function(reason) {
      this.promise.$$state.value = reason;
      this.promise.$$state.status = 2;
      scheduleProcessQueue(this.promise.$$state);
    },

    notify: function(progress) {
      var callbacks = this.promise.$$state.pending;

      if ((this.promise.$$state.status <= 0) && callbacks && callbacks.length) {
        nextTick(function() {
          var callback, result;
          for (var i = 0, ii = callbacks.length; i < ii; i++) {
            result = callbacks[i][0];
            callback = callbacks[i][3];
            try {
              result.notify(isFunction(callback) ? callback(progress) : progress);
            } catch (e) {
              exceptionHandler(e);
            }
          }
        });
      }
    }
  };

  /**
   * @ngdoc method
   * @name $q#reject
   * @kind function
   *
   * @description
   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
   * a promise chain, you don't need to worry about it.
   *
   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
   * a promise error callback and you want to forward the error to the promise derived from the
   * current promise, you have to "rethrow" the error by returning a rejection constructed via
   * `reject`.
   *
   * ```js
   *   promiseB = promiseA.then(function(result) {
   *     // success: do something and resolve promiseB
   *     //          with the old or a new result
   *     return result;
   *   }, function(reason) {
   *     // error: handle the error if possible and
   *     //        resolve promiseB with newPromiseOrValue,
   *     //        otherwise forward the rejection to promiseB
   *     if (canHandle(reason)) {
   *      // handle the error and recover
   *      return newPromiseOrValue;
   *     }
   *     return $q.reject(reason);
   *   });
   * ```
   *
   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
   */
  var reject = function(reason) {
    var result = new Deferred();
    result.reject(reason);
    return result.promise;
  };

  var makePromise = function makePromise(value, resolved) {
    var result = new Deferred();
    if (resolved) {
      result.resolve(value);
    } else {
      result.reject(value);
    }
    return result.promise;
  };

  var handleCallback = function handleCallback(value, isResolved, callback) {
    var callbackOutput = null;
    try {
      if (isFunction(callback)) callbackOutput = callback();
    } catch (e) {
      return makePromise(e, false);
    }
    if (isPromiseLike(callbackOutput)) {
      return callbackOutput.then(function() {
        return makePromise(value, isResolved);
      }, function(error) {
        return makePromise(error, false);
      });
    } else {
      return makePromise(value, isResolved);
    }
  };

  /**
   * @ngdoc method
   * @name $q#when
   * @kind function
   *
   * @description
   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
   * This is useful when you are dealing with an object that might or might not be a promise, or if
   * the promise comes from a source that can't be trusted.
   *
   * @param {*} value Value or a promise
   * @returns {Promise} Returns a promise of the passed value or promise
   */


  var when = function(value, callback, errback, progressBack) {
    var result = new Deferred();
    result.resolve(value);
    return result.promise.then(callback, errback, progressBack);
  };

  /**
   * @ngdoc method
   * @name $q#resolve
   * @kind function
   *
   * @description
   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
   *
   * @param {*} value Value or a promise
   * @returns {Promise} Returns a promise of the passed value or promise
   */
  var resolve = when;

  /**
   * @ngdoc method
   * @name $q#all
   * @kind function
   *
   * @description
   * Combines multiple promises into a single promise that is resolved when all of the input
   * promises are resolved.
   *
   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
   *   with the same rejection value.
   */

  function all(promises) {
    var deferred = new Deferred(),
        counter = 0,
        results = isArray(promises) ? [] : {};

    forEach(promises, function(promise, key) {
      counter++;
      when(promise).then(function(value) {
        if (results.hasOwnProperty(key)) return;
        results[key] = value;
        if (!(--counter)) deferred.resolve(results);
      }, function(reason) {
        if (results.hasOwnProperty(key)) return;
        deferred.reject(reason);
      });
    });

    if (counter === 0) {
      deferred.resolve(results);
    }

    return deferred.promise;
  }

  var $Q = function Q(resolver) {
    if (!isFunction(resolver)) {
      throw $qMinErr('norslvr', "Expected resolverFn, got '{0}'", resolver);
    }

    if (!(this instanceof Q)) {
      // More useful when $Q is the Promise itself.
      return new Q(resolver);
    }

    var deferred = new Deferred();

    function resolveFn(value) {
      deferred.resolve(value);
    }

    function rejectFn(reason) {
      deferred.reject(reason);
    }

    resolver(resolveFn, rejectFn);

    return deferred.promise;
  };

  $Q.defer = defer;
  $Q.reject = reject;
  $Q.when = when;
  $Q.resolve = resolve;
  $Q.all = all;

  return $Q;
}

function $$RAFProvider() { //rAF
  this.$get = ['$window', '$timeout', function($window, $timeout) {
    var requestAnimationFrame = $window.requestAnimationFrame ||
                                $window.webkitRequestAnimationFrame;

    var cancelAnimationFrame = $window.cancelAnimationFrame ||
                               $window.webkitCancelAnimationFrame ||
                               $window.webkitCancelRequestAnimationFrame;

    var rafSupported = !!requestAnimationFrame;
    var rafFn = rafSupported
      ? function(fn) {
          var id = requestAnimationFrame(fn);
          return function() {
            cancelAnimationFrame(id);
          };
        }
      : function(fn) {
          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
          return function() {
            $timeout.cancel(timer);
          };
        };

    queueFn.supported = rafSupported;

    var cancelLastRAF;
    var taskCount = 0;
    var taskQueue = [];
    return queueFn;

    function flush() {
      for (var i = 0; i < taskQueue.length; i++) {
        var task = taskQueue[i];
        if (task) {
          taskQueue[i] = null;
          task();
        }
      }
      taskCount = taskQueue.length = 0;
    }

    function queueFn(asyncFn) {
      var index = taskQueue.length;

      taskCount++;
      taskQueue.push(asyncFn);

      if (index === 0) {
        cancelLastRAF = rafFn(flush);
      }

      return function cancelQueueFn() {
        if (index >= 0) {
          taskQueue[index] = null;
          index = null;

          if (--taskCount === 0 && cancelLastRAF) {
            cancelLastRAF();
            cancelLastRAF = null;
            taskQueue.length = 0;
          }
        }
      };
    }
  }];
}

/**
 * DESIGN NOTES
 *
 * The design decisions behind the scope are heavily favored for speed and memory consumption.
 *
 * The typical use of scope is to watch the expressions, which most of the time return the same
 * value as last time so we optimize the operation.
 *
 * Closures construction is expensive in terms of speed as well as memory:
 *   - No closures, instead use prototypical inheritance for API
 *   - Internal state needs to be stored on scope directly, which means that private state is
 *     exposed as $$____ properties
 *
 * Loop operations are optimized by using while(count--) { ... }
 *   - this means that in order to keep the same order of execution as addition we have to add
 *     items to the array at the beginning (unshift) instead of at the end (push)
 *
 * Child scopes are created and removed often
 *   - Using an array would be slow since inserts in middle are expensive so we use linked list
 *
 * There are few watches then a lot of observers. This is why you don't want the observer to be
 * implemented in the same way as watch. Watch requires return of initialization function which
 * are expensive to construct.
 */


/**
 * @ngdoc provider
 * @name $rootScopeProvider
 * @description
 *
 * Provider for the $rootScope service.
 */

/**
 * @ngdoc method
 * @name $rootScopeProvider#digestTtl
 * @description
 *
 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
 * assuming that the model is unstable.
 *
 * The current default is 10 iterations.
 *
 * In complex applications it's possible that the dependencies between `$watch`s will result in
 * several digest iterations. However if an application needs more than the default 10 digest
 * iterations for its model to stabilize then you should investigate what is causing the model to
 * continuously change during the digest.
 *
 * Increasing the TTL could have performance implications, so you should not change it without
 * proper justification.
 *
 * @param {number} limit The number of digest iterations.
 */


/**
 * @ngdoc service
 * @name $rootScope
 * @description
 *
 * Every application has a single root {@link ng.$rootScope.Scope scope}.
 * All other scopes are descendant scopes of the root scope. Scopes provide separation
 * between the model and the view, via a mechanism for watching the model for changes.
 * They also provide an event emission/broadcast and subscription facility. See the
 * {@link guide/scope developer guide on scopes}.
 */
function $RootScopeProvider() {
  var TTL = 10;
  var $rootScopeMinErr = minErr('$rootScope');
  var lastDirtyWatch = null;
  var applyAsyncId = null;

  this.digestTtl = function(value) {
    if (arguments.length) {
      TTL = value;
    }
    return TTL;
  };

  function createChildScopeClass(parent) {
    function ChildScope() {
      this.$$watchers = this.$$nextSibling =
          this.$$childHead = this.$$childTail = null;
      this.$$listeners = {};
      this.$$listenerCount = {};
      this.$$watchersCount = 0;
      this.$id = nextUid();
      this.$$ChildScope = null;
    }
    ChildScope.prototype = parent;
    return ChildScope;
  }

  this.$get = ['$injector', '$exceptionHandler', '$parse', '$browser',
      function($injector, $exceptionHandler, $parse, $browser) {

    function destroyChildScope($event) {
        $event.currentScope.$$destroyed = true;
    }

    /**
     * @ngdoc type
     * @name $rootScope.Scope
     *
     * @description
     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
     * {@link auto.$injector $injector}. Child scopes are created using the
     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
     * compiled HTML template is executed.)
     *
     * Here is a simple scope snippet to show how you can interact with the scope.
     * ```html
     * <file src="./test/ng/rootScopeSpec.js" tag="docs1" />
     * ```
     *
     * # Inheritance
     * A scope can inherit from a parent scope, as in this example:
     * ```js
         var parent = $rootScope;
         var child = parent.$new();

         parent.salutation = "Hello";
         expect(child.salutation).toEqual('Hello');

         child.salutation = "Welcome";
         expect(child.salutation).toEqual('Welcome');
         expect(parent.salutation).toEqual('Hello');
     * ```
     *
     * When interacting with `Scope` in tests, additional helper methods are available on the
     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
     * details.
     *
     *
     * @param {Object.<string, function()>=} providers Map of service factory which need to be
     *                                       provided for the current scope. Defaults to {@link ng}.
     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
     *                              append/override services provided by `providers`. This is handy
     *                              when unit-testing and having the need to override a default
     *                              service.
     * @returns {Object} Newly created scope.
     *
     */
    function Scope() {
      this.$id = nextUid();
      this.$$phase = this.$parent = this.$$watchers =
                     this.$$nextSibling = this.$$prevSibling =
                     this.$$childHead = this.$$childTail = null;
      this.$root = this;
      this.$$destroyed = false;
      this.$$listeners = {};
      this.$$listenerCount = {};
      this.$$watchersCount = 0;
      this.$$isolateBindings = null;
    }

    /**
     * @ngdoc property
     * @name $rootScope.Scope#$id
     *
     * @description
     * Unique scope ID (monotonically increasing) useful for debugging.
     */

     /**
      * @ngdoc property
      * @name $rootScope.Scope#$parent
      *
      * @description
      * Reference to the parent scope.
      */

      /**
       * @ngdoc property
       * @name $rootScope.Scope#$root
       *
       * @description
       * Reference to the root scope.
       */

    Scope.prototype = {
      constructor: Scope,
      /**
       * @ngdoc method
       * @name $rootScope.Scope#$new
       * @kind function
       *
       * @description
       * Creates a new child {@link ng.$rootScope.Scope scope}.
       *
       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
       *
       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
       * desired for the scope and its child scopes to be permanently detached from the parent and
       * thus stop participating in model change detection and listener notification by invoking.
       *
       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
       *         parent scope. The scope is isolated, as it can not see parent scope properties.
       *         When creating widgets, it is useful for the widget to not accidentally read parent
       *         state.
       *
       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
       *                              of the newly created scope. Defaults to `this` scope if not provided.
       *                              This is used when creating a transclude scope to correctly place it
       *                              in the scope hierarchy while maintaining the correct prototypical
       *                              inheritance.
       *
       * @returns {Object} The newly created child scope.
       *
       */
      $new: function(isolate, parent) {
        var child;

        parent = parent || this;

        if (isolate) {
          child = new Scope();
          child.$root = this.$root;
        } else {
          // Only create a child scope class if somebody asks for one,
          // but cache it to allow the VM to optimize lookups.
          if (!this.$$ChildScope) {
            this.$$ChildScope = createChildScopeClass(this);
          }
          child = new this.$$ChildScope();
        }
        child.$parent = parent;
        child.$$prevSibling = parent.$$childTail;
        if (parent.$$childHead) {
          parent.$$childTail.$$nextSibling = child;
          parent.$$childTail = child;
        } else {
          parent.$$childHead = parent.$$childTail = child;
        }

        // When the new scope is not isolated or we inherit from `this`, and
        // the parent scope is destroyed, the property `$$destroyed` is inherited
        // prototypically. In all other cases, this property needs to be set
        // when the parent scope is destroyed.
        // The listener needs to be added after the parent is set
        if (isolate || parent != this) child.$on('$destroy', destroyChildScope);

        return child;
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$watch
       * @kind function
       *
       * @description
       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
       *
       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
       *   $digest()} and should return the value that will be watched. (Since
       *   {@link ng.$rootScope.Scope#$digest $digest()} reruns when it detects changes the
       *   `watchExpression` can execute multiple times per
       *   {@link ng.$rootScope.Scope#$digest $digest()} and should be idempotent.)
       * - The `listener` is called only when the value from the current `watchExpression` and the
       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
       *   see below). Inequality is determined according to reference inequality,
       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
       *    via the `!==` Javascript operator, unless `objectEquality == true`
       *   (see next point)
       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
       *   according to the {@link angular.equals} function. To save the value of the object for
       *   later comparison, the {@link angular.copy} function is used. This therefore means that
       *   watching complex objects will have adverse memory and performance implications.
       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
       *   iteration limit is 10 to prevent an infinite loop deadlock.
       *
       *
       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
       * you can register a `watchExpression` function with no `listener`. (Since `watchExpression`
       * can execute multiple times per {@link ng.$rootScope.Scope#$digest $digest} cycle when a
       * change is detected, be prepared for multiple calls to your listener.)
       *
       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
       * watcher. In rare cases, this is undesirable because the listener is called when the result
       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
       * listener was called due to initialization.
       *
       *
       *
       * # Example
       * ```js
           // let's assume that scope was dependency injected as the $rootScope
           var scope = $rootScope;
           scope.name = 'misko';
           scope.counter = 0;

           expect(scope.counter).toEqual(0);
           scope.$watch('name', function(newValue, oldValue) {
             scope.counter = scope.counter + 1;
           });
           expect(scope.counter).toEqual(0);

           scope.$digest();
           // the listener is always called during the first $digest loop after it was registered
           expect(scope.counter).toEqual(1);

           scope.$digest();
           // but now it will not be called unless the value changes
           expect(scope.counter).toEqual(1);

           scope.name = 'adam';
           scope.$digest();
           expect(scope.counter).toEqual(2);



           // Using a function as a watchExpression
           var food;
           scope.foodCounter = 0;
           expect(scope.foodCounter).toEqual(0);
           scope.$watch(
             // This function returns the value being watched. It is called for each turn of the $digest loop
             function() { return food; },
             // This is the change listener, called when the value returned from the above function changes
             function(newValue, oldValue) {
               if ( newValue !== oldValue ) {
                 // Only increment the counter if the value changed
                 scope.foodCounter = scope.foodCounter + 1;
               }
             }
           );
           // No digest has been run so the counter will be zero
           expect(scope.foodCounter).toEqual(0);

           // Run the digest but since food has not changed count will still be zero
           scope.$digest();
           expect(scope.foodCounter).toEqual(0);

           // Update food and run digest.  Now the counter will increment
           food = 'cheeseburger';
           scope.$digest();
           expect(scope.foodCounter).toEqual(1);

       * ```
       *
       *
       *
       * @param {(function()|string)} watchExpression Expression that is evaluated on each
       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
       *    a call to the `listener`.
       *
       *    - `string`: Evaluated as {@link guide/expression expression}
       *    - `function(scope)`: called with current `scope` as a parameter.
       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
       *    of `watchExpression` changes.
       *
       *    - `newVal` contains the current value of the `watchExpression`
       *    - `oldVal` contains the previous value of the `watchExpression`
       *    - `scope` refers to the current scope
       * @param {boolean=} objectEquality Compare for object equality using {@link angular.equals} instead of
       *     comparing for reference equality.
       * @returns {function()} Returns a deregistration function for this listener.
       */
      $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
        var get = $parse(watchExp);

        if (get.$$watchDelegate) {
          return get.$$watchDelegate(this, listener, objectEquality, get, watchExp);
        }
        var scope = this,
            array = scope.$$watchers,
            watcher = {
              fn: listener,
              last: initWatchVal,
              get: get,
              exp: prettyPrintExpression || watchExp,
              eq: !!objectEquality
            };

        lastDirtyWatch = null;

        if (!isFunction(listener)) {
          watcher.fn = noop;
        }

        if (!array) {
          array = scope.$$watchers = [];
        }
        // we use unshift since we use a while loop in $digest for speed.
        // the while loop reads in reverse order.
        array.unshift(watcher);
        incrementWatchersCount(this, 1);

        return function deregisterWatch() {
          if (arrayRemove(array, watcher) >= 0) {
            incrementWatchersCount(scope, -1);
          }
          lastDirtyWatch = null;
        };
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$watchGroup
       * @kind function
       *
       * @description
       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
       * If any one expression in the collection changes the `listener` is executed.
       *
       * - The items in the `watchExpressions` array are observed via standard $watch operation and are examined on every
       *   call to $digest() to see if any items changes.
       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
       *
       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
       *
       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
       *    expression in `watchExpressions` changes
       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
       *    those of `watchExpression`
       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
       *    those of `watchExpression`
       *    The `scope` refers to the current scope.
       * @returns {function()} Returns a de-registration function for all listeners.
       */
      $watchGroup: function(watchExpressions, listener) {
        var oldValues = new Array(watchExpressions.length);
        var newValues = new Array(watchExpressions.length);
        var deregisterFns = [];
        var self = this;
        var changeReactionScheduled = false;
        var firstRun = true;

        if (!watchExpressions.length) {
          // No expressions means we call the listener ASAP
          var shouldCall = true;
          self.$evalAsync(function() {
            if (shouldCall) listener(newValues, newValues, self);
          });
          return function deregisterWatchGroup() {
            shouldCall = false;
          };
        }

        if (watchExpressions.length === 1) {
          // Special case size of one
          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
            newValues[0] = value;
            oldValues[0] = oldValue;
            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
          });
        }

        forEach(watchExpressions, function(expr, i) {
          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value, oldValue) {
            newValues[i] = value;
            oldValues[i] = oldValue;
            if (!changeReactionScheduled) {
              changeReactionScheduled = true;
              self.$evalAsync(watchGroupAction);
            }
          });
          deregisterFns.push(unwatchFn);
        });

        function watchGroupAction() {
          changeReactionScheduled = false;

          if (firstRun) {
            firstRun = false;
            listener(newValues, newValues, self);
          } else {
            listener(newValues, oldValues, self);
          }
        }

        return function deregisterWatchGroup() {
          while (deregisterFns.length) {
            deregisterFns.shift()();
          }
        };
      },


      /**
       * @ngdoc method
       * @name $rootScope.Scope#$watchCollection
       * @kind function
       *
       * @description
       * Shallow watches the properties of an object and fires whenever any of the properties change
       * (for arrays, this implies watching the array items; for object maps, this implies watching
       * the properties). If a change is detected, the `listener` callback is fired.
       *
       * - The `obj` collection is observed via standard $watch operation and is examined on every
       *   call to $digest() to see if any items have been added, removed, or moved.
       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
       *   adding, removing, and moving items belonging to an object or array.
       *
       *
       * # Example
       * ```js
          $scope.names = ['igor', 'matias', 'misko', 'james'];
          $scope.dataCount = 4;

          $scope.$watchCollection('names', function(newNames, oldNames) {
            $scope.dataCount = newNames.length;
          });

          expect($scope.dataCount).toEqual(4);
          $scope.$digest();

          //still at 4 ... no changes
          expect($scope.dataCount).toEqual(4);

          $scope.names.pop();
          $scope.$digest();

          //now there's been a change
          expect($scope.dataCount).toEqual(3);
       * ```
       *
       *
       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
       *    expression value should evaluate to an object or an array which is observed on each
       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
       *    collection will trigger a call to the `listener`.
       *
       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
       *    when a change is detected.
       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
       *    - The `oldCollection` object is a copy of the former collection data.
       *      Due to performance considerations, the`oldCollection` value is computed only if the
       *      `listener` function declares two or more arguments.
       *    - The `scope` argument refers to the current scope.
       *
       * @returns {function()} Returns a de-registration function for this listener. When the
       *    de-registration function is executed, the internal watch operation is terminated.
       */
      $watchCollection: function(obj, listener) {
        $watchCollectionInterceptor.$stateful = true;

        var self = this;
        // the current value, updated on each dirty-check run
        var newValue;
        // a shallow copy of the newValue from the last dirty-check run,
        // updated to match newValue during dirty-check run
        var oldValue;
        // a shallow copy of the newValue from when the last change happened
        var veryOldValue;
        // only track veryOldValue if the listener is asking for it
        var trackVeryOldValue = (listener.length > 1);
        var changeDetected = 0;
        var changeDetector = $parse(obj, $watchCollectionInterceptor);
        var internalArray = [];
        var internalObject = {};
        var initRun = true;
        var oldLength = 0;

        function $watchCollectionInterceptor(_value) {
          newValue = _value;
          var newLength, key, bothNaN, newItem, oldItem;

          // If the new value is undefined, then return undefined as the watch may be a one-time watch
          if (isUndefined(newValue)) return;

          if (!isObject(newValue)) { // if primitive
            if (oldValue !== newValue) {
              oldValue = newValue;
              changeDetected++;
            }
          } else if (isArrayLike(newValue)) {
            if (oldValue !== internalArray) {
              // we are transitioning from something which was not an array into array.
              oldValue = internalArray;
              oldLength = oldValue.length = 0;
              changeDetected++;
            }

            newLength = newValue.length;

            if (oldLength !== newLength) {
              // if lengths do not match we need to trigger change notification
              changeDetected++;
              oldValue.length = oldLength = newLength;
            }
            // copy the items to oldValue and look for changes.
            for (var i = 0; i < newLength; i++) {
              oldItem = oldValue[i];
              newItem = newValue[i];

              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
              if (!bothNaN && (oldItem !== newItem)) {
                changeDetected++;
                oldValue[i] = newItem;
              }
            }
          } else {
            if (oldValue !== internalObject) {
              // we are transitioning from something which was not an object into object.
              oldValue = internalObject = {};
              oldLength = 0;
              changeDetected++;
            }
            // copy the items to oldValue and look for changes.
            newLength = 0;
            for (key in newValue) {
              if (newValue.hasOwnProperty(key)) {
                newLength++;
                newItem = newValue[key];
                oldItem = oldValue[key];

                if (key in oldValue) {
                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
                  if (!bothNaN && (oldItem !== newItem)) {
                    changeDetected++;
                    oldValue[key] = newItem;
                  }
                } else {
                  oldLength++;
                  oldValue[key] = newItem;
                  changeDetected++;
                }
              }
            }
            if (oldLength > newLength) {
              // we used to have more keys, need to find them and destroy them.
              changeDetected++;
              for (key in oldValue) {
                if (!newValue.hasOwnProperty(key)) {
                  oldLength--;
                  delete oldValue[key];
                }
              }
            }
          }
          return changeDetected;
        }

        function $watchCollectionAction() {
          if (initRun) {
            initRun = false;
            listener(newValue, newValue, self);
          } else {
            listener(newValue, veryOldValue, self);
          }

          // make a copy for the next time a collection is changed
          if (trackVeryOldValue) {
            if (!isObject(newValue)) {
              //primitive
              veryOldValue = newValue;
            } else if (isArrayLike(newValue)) {
              veryOldValue = new Array(newValue.length);
              for (var i = 0; i < newValue.length; i++) {
                veryOldValue[i] = newValue[i];
              }
            } else { // if object
              veryOldValue = {};
              for (var key in newValue) {
                if (hasOwnProperty.call(newValue, key)) {
                  veryOldValue[key] = newValue[key];
                }
              }
            }
          }
        }

        return this.$watch(changeDetector, $watchCollectionAction);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$digest
       * @kind function
       *
       * @description
       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
       * until no more listeners are firing. This means that it is possible to get into an infinite
       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
       * iterations exceeds 10.
       *
       * Usually, you don't call `$digest()` directly in
       * {@link ng.directive:ngController controllers} or in
       * {@link ng.$compileProvider#directive directives}.
       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
       *
       * If you want to be notified whenever `$digest()` is called,
       * you can register a `watchExpression` function with
       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
       *
       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
       *
       * # Example
       * ```js
           var scope = ...;
           scope.name = 'misko';
           scope.counter = 0;

           expect(scope.counter).toEqual(0);
           scope.$watch('name', function(newValue, oldValue) {
             scope.counter = scope.counter + 1;
           });
           expect(scope.counter).toEqual(0);

           scope.$digest();
           // the listener is always called during the first $digest loop after it was registered
           expect(scope.counter).toEqual(1);

           scope.$digest();
           // but now it will not be called unless the value changes
           expect(scope.counter).toEqual(1);

           scope.name = 'adam';
           scope.$digest();
           expect(scope.counter).toEqual(2);
       * ```
       *
       */
      $digest: function() {
        var watch, value, last,
            watchers,
            length,
            dirty, ttl = TTL,
            next, current, target = this,
            watchLog = [],
            logIdx, logMsg, asyncTask;

        beginPhase('$digest');
        // Check for changes to browser url that happened in sync before the call to $digest
        $browser.$$checkUrlChange();

        if (this === $rootScope && applyAsyncId !== null) {
          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
          $browser.defer.cancel(applyAsyncId);
          flushApplyAsync();
        }

        lastDirtyWatch = null;

        do { // "while dirty" loop
          dirty = false;
          current = target;

          while (asyncQueue.length) {
            try {
              asyncTask = asyncQueue.shift();
              asyncTask.scope.$eval(asyncTask.expression, asyncTask.locals);
            } catch (e) {
              $exceptionHandler(e);
            }
            lastDirtyWatch = null;
          }

          traverseScopesLoop:
          do { // "traverse the scopes" loop
            if ((watchers = current.$$watchers)) {
              // process our watches
              length = watchers.length;
              while (length--) {
                try {
                  watch = watchers[length];
                  // Most common watches are on primitives, in which case we can short
                  // circuit it with === operator, only when === fails do we use .equals
                  if (watch) {
                    if ((value = watch.get(current)) !== (last = watch.last) &&
                        !(watch.eq
                            ? equals(value, last)
                            : (typeof value === 'number' && typeof last === 'number'
                               && isNaN(value) && isNaN(last)))) {
                      dirty = true;
                      lastDirtyWatch = watch;
                      watch.last = watch.eq ? copy(value, null) : value;
                      watch.fn(value, ((last === initWatchVal) ? value : last), current);
                      if (ttl < 5) {
                        logIdx = 4 - ttl;
                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
                        watchLog[logIdx].push({
                          msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
                          newVal: value,
                          oldVal: last
                        });
                      }
                    } else if (watch === lastDirtyWatch) {
                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
                      // have already been tested.
                      dirty = false;
                      break traverseScopesLoop;
                    }
                  }
                } catch (e) {
                  $exceptionHandler(e);
                }
              }
            }

            // Insanity Warning: scope depth-first traversal
            // yes, this code is a bit crazy, but it works and we have tests to prove it!
            // this piece should be kept in sync with the traversal in $broadcast
            if (!(next = ((current.$$watchersCount && current.$$childHead) ||
                (current !== target && current.$$nextSibling)))) {
              while (current !== target && !(next = current.$$nextSibling)) {
                current = current.$parent;
              }
            }
          } while ((current = next));

          // `break traverseScopesLoop;` takes us to here

          if ((dirty || asyncQueue.length) && !(ttl--)) {
            clearPhase();
            throw $rootScopeMinErr('infdig',
                '{0} $digest() iterations reached. Aborting!\n' +
                'Watchers fired in the last 5 iterations: {1}',
                TTL, watchLog);
          }

        } while (dirty || asyncQueue.length);

        clearPhase();

        while (postDigestQueue.length) {
          try {
            postDigestQueue.shift()();
          } catch (e) {
            $exceptionHandler(e);
          }
        }
      },


      /**
       * @ngdoc event
       * @name $rootScope.Scope#$destroy
       * @eventType broadcast on scope being destroyed
       *
       * @description
       * Broadcasted when a scope and its children are being destroyed.
       *
       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
       * clean up DOM bindings before an element is removed from the DOM.
       */

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$destroy
       * @kind function
       *
       * @description
       * Removes the current scope (and all of its children) from the parent scope. Removal implies
       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
       * propagate to the current scope and its children. Removal also implies that the current
       * scope is eligible for garbage collection.
       *
       * The `$destroy()` is usually used by directives such as
       * {@link ng.directive:ngRepeat ngRepeat} for managing the
       * unrolling of the loop.
       *
       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
       * Application code can register a `$destroy` event handler that will give it a chance to
       * perform any necessary cleanup.
       *
       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
       * clean up DOM bindings before an element is removed from the DOM.
       */
      $destroy: function() {
        // We can't destroy a scope that has been already destroyed.
        if (this.$$destroyed) return;
        var parent = this.$parent;

        this.$broadcast('$destroy');
        this.$$destroyed = true;

        if (this === $rootScope) {
          //Remove handlers attached to window when $rootScope is removed
          $browser.$$applicationDestroyed();
        }

        incrementWatchersCount(this, -this.$$watchersCount);
        for (var eventName in this.$$listenerCount) {
          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
        }

        // sever all the references to parent scopes (after this cleanup, the current scope should
        // not be retained by any of our references and should be eligible for garbage collection)
        if (parent && parent.$$childHead == this) parent.$$childHead = this.$$nextSibling;
        if (parent && parent.$$childTail == this) parent.$$childTail = this.$$prevSibling;
        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;

        // Disable listeners, watchers and apply/digest methods
        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
        this.$$listeners = {};

        // All of the code below is bogus code that works around V8's memory leak via optimized code
        // and inline caches.
        //
        // see:
        // - https://code.google.com/p/v8/issues/detail?id=2073#c26
        // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
        // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451

        this.$parent = this.$$nextSibling = this.$$prevSibling = this.$$childHead =
            this.$$childTail = this.$root = this.$$watchers = null;
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$eval
       * @kind function
       *
       * @description
       * Executes the `expression` on the current scope and returns the result. Any exceptions in
       * the expression are propagated (uncaught). This is useful when evaluating Angular
       * expressions.
       *
       * # Example
       * ```js
           var scope = ng.$rootScope.Scope();
           scope.a = 1;
           scope.b = 2;

           expect(scope.$eval('a+b')).toEqual(3);
           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
       * ```
       *
       * @param {(string|function())=} expression An angular expression to be executed.
       *
       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with the current `scope` parameter.
       *
       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
       * @returns {*} The result of evaluating the expression.
       */
      $eval: function(expr, locals) {
        return $parse(expr)(this, locals);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$evalAsync
       * @kind function
       *
       * @description
       * Executes the expression on the current scope at a later point in time.
       *
       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
       * that:
       *
       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
       *     rendering).
       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
       *     `expression` execution.
       *
       * Any exceptions from the execution of the expression are forwarded to the
       * {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
       * will be scheduled. However, it is encouraged to always call code that changes the model
       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
       *
       * @param {(string|function())=} expression An angular expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with the current `scope` parameter.
       *
       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
       */
      $evalAsync: function(expr, locals) {
        // if we are outside of an $digest loop and this is the first time we are scheduling async
        // task also schedule async auto-flush
        if (!$rootScope.$$phase && !asyncQueue.length) {
          $browser.defer(function() {
            if (asyncQueue.length) {
              $rootScope.$digest();
            }
          });
        }

        asyncQueue.push({scope: this, expression: expr, locals: locals});
      },

      $$postDigest: function(fn) {
        postDigestQueue.push(fn);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$apply
       * @kind function
       *
       * @description
       * `$apply()` is used to execute an expression in angular from outside of the angular
       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
       * Because we are calling into the angular framework we need to perform proper scope life
       * cycle of {@link ng.$exceptionHandler exception handling},
       * {@link ng.$rootScope.Scope#$digest executing watches}.
       *
       * ## Life cycle
       *
       * # Pseudo-Code of `$apply()`
       * ```js
           function $apply(expr) {
             try {
               return $eval(expr);
             } catch (e) {
               $exceptionHandler(e);
             } finally {
               $root.$digest();
             }
           }
       * ```
       *
       *
       * Scope's `$apply()` method transitions through the following stages:
       *
       * 1. The {@link guide/expression expression} is executed using the
       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
       * 2. Any exceptions from the execution of the expression are forwarded to the
       *    {@link ng.$exceptionHandler $exceptionHandler} service.
       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
       *
       *
       * @param {(string|function())=} exp An angular expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with current `scope` parameter.
       *
       * @returns {*} The result of evaluating the expression.
       */
      $apply: function(expr) {
        try {
          beginPhase('$apply');
          return this.$eval(expr);
        } catch (e) {
          $exceptionHandler(e);
        } finally {
          clearPhase();
          try {
            $rootScope.$digest();
          } catch (e) {
            $exceptionHandler(e);
            throw e;
          }
        }
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$applyAsync
       * @kind function
       *
       * @description
       * Schedule the invocation of $apply to occur at a later time. The actual time difference
       * varies across browsers, but is typically around ~10 milliseconds.
       *
       * This can be used to queue up multiple expressions which need to be evaluated in the same
       * digest.
       *
       * @param {(string|function())=} exp An angular expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with current `scope` parameter.
       */
      $applyAsync: function(expr) {
        var scope = this;
        expr && applyAsyncQueue.push($applyAsyncExpression);
        scheduleApplyAsync();

        function $applyAsyncExpression() {
          scope.$eval(expr);
        }
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$on
       * @kind function
       *
       * @description
       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
       * discussion of event life cycle.
       *
       * The event listener function format is: `function(event, args...)`. The `event` object
       * passed into the listener has the following attributes:
       *
       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
       *     `$broadcast`-ed.
       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
       *     event propagates through the scope hierarchy, this property is set to null.
       *   - `name` - `{string}`: name of the event.
       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
       *     further event propagation (available only for events that were `$emit`-ed).
       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
       *     to true.
       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
       *
       * @param {string} name Event name to listen on.
       * @param {function(event, ...args)} listener Function to call when the event is emitted.
       * @returns {function()} Returns a deregistration function for this listener.
       */
      $on: function(name, listener) {
        var namedListeners = this.$$listeners[name];
        if (!namedListeners) {
          this.$$listeners[name] = namedListeners = [];
        }
        namedListeners.push(listener);

        var current = this;
        do {
          if (!current.$$listenerCount[name]) {
            current.$$listenerCount[name] = 0;
          }
          current.$$listenerCount[name]++;
        } while ((current = current.$parent));

        var self = this;
        return function() {
          var indexOfListener = namedListeners.indexOf(listener);
          if (indexOfListener !== -1) {
            namedListeners[indexOfListener] = null;
            decrementListenerCount(self, 1, name);
          }
        };
      },


      /**
       * @ngdoc method
       * @name $rootScope.Scope#$emit
       * @kind function
       *
       * @description
       * Dispatches an event `name` upwards through the scope hierarchy notifying the
       * registered {@link ng.$rootScope.Scope#$on} listeners.
       *
       * The event life cycle starts at the scope on which `$emit` was called. All
       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
       * registered listeners along the way. The event will stop propagating if one of the listeners
       * cancels it.
       *
       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * @param {string} name Event name to emit.
       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
       */
      $emit: function(name, args) {
        var empty = [],
            namedListeners,
            scope = this,
            stopPropagation = false,
            event = {
              name: name,
              targetScope: scope,
              stopPropagation: function() {stopPropagation = true;},
              preventDefault: function() {
                event.defaultPrevented = true;
              },
              defaultPrevented: false
            },
            listenerArgs = concat([event], arguments, 1),
            i, length;

        do {
          namedListeners = scope.$$listeners[name] || empty;
          event.currentScope = scope;
          for (i = 0, length = namedListeners.length; i < length; i++) {

            // if listeners were deregistered, defragment the array
            if (!namedListeners[i]) {
              namedListeners.splice(i, 1);
              i--;
              length--;
              continue;
            }
            try {
              //allow all listeners attached to the current scope to run
              namedListeners[i].apply(null, listenerArgs);
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          //if any listener on the current scope stops propagation, prevent bubbling
          if (stopPropagation) {
            event.currentScope = null;
            return event;
          }
          //traverse upwards
          scope = scope.$parent;
        } while (scope);

        event.currentScope = null;

        return event;
      },


      /**
       * @ngdoc method
       * @name $rootScope.Scope#$broadcast
       * @kind function
       *
       * @description
       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
       * registered {@link ng.$rootScope.Scope#$on} listeners.
       *
       * The event life cycle starts at the scope on which `$broadcast` was called. All
       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
       * scope and calls all registered listeners along the way. The event cannot be canceled.
       *
       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * @param {string} name Event name to broadcast.
       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
       */
      $broadcast: function(name, args) {
        var target = this,
            current = target,
            next = target,
            event = {
              name: name,
              targetScope: target,
              preventDefault: function() {
                event.defaultPrevented = true;
              },
              defaultPrevented: false
            };

        if (!target.$$listenerCount[name]) return event;

        var listenerArgs = concat([event], arguments, 1),
            listeners, i, length;

        //down while you can, then up and next sibling or up and next sibling until back at root
        while ((current = next)) {
          event.currentScope = current;
          listeners = current.$$listeners[name] || [];
          for (i = 0, length = listeners.length; i < length; i++) {
            // if listeners were deregistered, defragment the array
            if (!listeners[i]) {
              listeners.splice(i, 1);
              i--;
              length--;
              continue;
            }

            try {
              listeners[i].apply(null, listenerArgs);
            } catch (e) {
              $exceptionHandler(e);
            }
          }

          // Insanity Warning: scope depth-first traversal
          // yes, this code is a bit crazy, but it works and we have tests to prove it!
          // this piece should be kept in sync with the traversal in $digest
          // (though it differs due to having the extra check for $$listenerCount)
          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
              (current !== target && current.$$nextSibling)))) {
            while (current !== target && !(next = current.$$nextSibling)) {
              current = current.$parent;
            }
          }
        }

        event.currentScope = null;
        return event;
      }
    };

    var $rootScope = new Scope();

    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
    var asyncQueue = $rootScope.$$asyncQueue = [];
    var postDigestQueue = $rootScope.$$postDigestQueue = [];
    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];

    return $rootScope;


    function beginPhase(phase) {
      if ($rootScope.$$phase) {
        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
      }

      $rootScope.$$phase = phase;
    }

    function clearPhase() {
      $rootScope.$$phase = null;
    }

    function incrementWatchersCount(current, count) {
      do {
        current.$$watchersCount += count;
      } while ((current = current.$parent));
    }

    function decrementListenerCount(current, count, name) {
      do {
        current.$$listenerCount[name] -= count;

        if (current.$$listenerCount[name] === 0) {
          delete current.$$listenerCount[name];
        }
      } while ((current = current.$parent));
    }

    /**
     * function used as an initial value for watchers.
     * because it's unique we can easily tell it apart from other values
     */
    function initWatchVal() {}

    function flushApplyAsync() {
      while (applyAsyncQueue.length) {
        try {
          applyAsyncQueue.shift()();
        } catch (e) {
          $exceptionHandler(e);
        }
      }
      applyAsyncId = null;
    }

    function scheduleApplyAsync() {
      if (applyAsyncId === null) {
        applyAsyncId = $browser.defer(function() {
          $rootScope.$apply(flushApplyAsync);
        });
      }
    }
  }];
}

/**
 * @description
 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
 */
function $$SanitizeUriProvider() {
  var aHrefSanitizationWhitelist = /^\s*(https?|ftp|mailto|tel|file):/,
    imgSrcSanitizationWhitelist = /^\s*((https?|ftp|file|blob):|data:image\/)/;

  /**
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during a[href] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
   *
   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.aHrefSanitizationWhitelist = function(regexp) {
    if (isDefined(regexp)) {
      aHrefSanitizationWhitelist = regexp;
      return this;
    }
    return aHrefSanitizationWhitelist;
  };


  /**
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during img[src] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
   *
   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.imgSrcSanitizationWhitelist = function(regexp) {
    if (isDefined(regexp)) {
      imgSrcSanitizationWhitelist = regexp;
      return this;
    }
    return imgSrcSanitizationWhitelist;
  };

  this.$get = function() {
    return function sanitizeUri(uri, isImage) {
      var regex = isImage ? imgSrcSanitizationWhitelist : aHrefSanitizationWhitelist;
      var normalizedVal;
      normalizedVal = urlResolve(uri).href;
      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
        return 'unsafe:' + normalizedVal;
      }
      return uri;
    };
  };
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

var $sceMinErr = minErr('$sce');

var SCE_CONTEXTS = {
  HTML: 'html',
  CSS: 'css',
  URL: 'url',
  // RESOURCE_URL is a subtype of URL used in contexts where a privileged resource is sourced from a
  // url.  (e.g. ng-include, script src, templateUrl)
  RESOURCE_URL: 'resourceUrl',
  JS: 'js'
};

// Helper functions follow.

function adjustMatcher(matcher) {
  if (matcher === 'self') {
    return matcher;
  } else if (isString(matcher)) {
    // Strings match exactly except for 2 wildcards - '*' and '**'.
    // '*' matches any character except those from the set ':/.?&'.
    // '**' matches any character (like .* in a RegExp).
    // More than 2 *'s raises an error as it's ill defined.
    if (matcher.indexOf('***') > -1) {
      throw $sceMinErr('iwcard',
          'Illegal sequence *** in string matcher.  String: {0}', matcher);
    }
    matcher = escapeForRegexp(matcher).
                  replace('\\*\\*', '.*').
                  replace('\\*', '[^:/.?&;]*');
    return new RegExp('^' + matcher + '$');
  } else if (isRegExp(matcher)) {
    // The only other type of matcher allowed is a Regexp.
    // Match entire URL / disallow partial matches.
    // Flags are reset (i.e. no global, ignoreCase or multiline)
    return new RegExp('^' + matcher.source + '$');
  } else {
    throw $sceMinErr('imatcher',
        'Matchers may only be "self", string patterns or RegExp objects');
  }
}


function adjustMatchers(matchers) {
  var adjustedMatchers = [];
  if (isDefined(matchers)) {
    forEach(matchers, function(matcher) {
      adjustedMatchers.push(adjustMatcher(matcher));
    });
  }
  return adjustedMatchers;
}


/**
 * @ngdoc service
 * @name $sceDelegate
 * @kind function
 *
 * @description
 *
 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
 * Contextual Escaping (SCE)} services to AngularJS.
 *
 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
 * work because `$sce` delegates to `$sceDelegate` for these operations.
 *
 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
 *
 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
 * can override it completely to change the behavior of `$sce`, the common case would
 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
 * your own whitelists and blacklists for trusting URLs used for loading AngularJS resources such as
 * templates.  Refer {@link ng.$sceDelegateProvider#resourceUrlWhitelist
 * $sceDelegateProvider.resourceUrlWhitelist} and {@link
 * ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
 */

/**
 * @ngdoc provider
 * @name $sceDelegateProvider
 * @description
 *
 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
 * $sceDelegate} service.  This allows one to get/set the whitelists and blacklists used to ensure
 * that the URLs used for sourcing Angular templates are safe.  Refer {@link
 * ng.$sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider.resourceUrlWhitelist} and
 * {@link ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
 *
 * For the general details about this service in Angular, read the main page for {@link ng.$sce
 * Strict Contextual Escaping (SCE)}.
 *
 * **Example**:  Consider the following case. <a name="example"></a>
 *
 * - your app is hosted at url `http://myapp.example.com/`
 * - but some of your templates are hosted on other domains you control such as
 *   `http://srv01.assets.example.com/`,  `http://srv02.assets.example.com/`, etc.
 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
 *
 * Here is what a secure configuration for this scenario might look like:
 *
 * ```
 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
 *    $sceDelegateProvider.resourceUrlWhitelist([
 *      // Allow same origin resource loads.
 *      'self',
 *      // Allow loading from our assets domain.  Notice the difference between * and **.
 *      'http://srv*.assets.example.com/**'
 *    ]);
 *
 *    // The blacklist overrides the whitelist so the open redirect here is blocked.
 *    $sceDelegateProvider.resourceUrlBlacklist([
 *      'http://myapp.example.com/clickThru**'
 *    ]);
 *  });
 * ```
 */

function $SceDelegateProvider() {
  this.SCE_CONTEXTS = SCE_CONTEXTS;

  // Resource URLs can also be trusted by policy.
  var resourceUrlWhitelist = ['self'],
      resourceUrlBlacklist = [];

  /**
   * @ngdoc method
   * @name $sceDelegateProvider#resourceUrlWhitelist
   * @kind function
   *
   * @param {Array=} whitelist When provided, replaces the resourceUrlWhitelist with the value
   *     provided.  This must be an array or null.  A snapshot of this array is used so further
   *     changes to the array are ignored.
   *
   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
   *     allowed in this array.
   *
   *     Note: **an empty whitelist array will block all URLs**!
   *
   * @return {Array} the currently set whitelist array.
   *
   * The **default value** when no whitelist has been explicitly set is `['self']` allowing only
   * same origin resource requests.
   *
   * @description
   * Sets/Gets the whitelist of trusted resource URLs.
   */
  this.resourceUrlWhitelist = function(value) {
    if (arguments.length) {
      resourceUrlWhitelist = adjustMatchers(value);
    }
    return resourceUrlWhitelist;
  };

  /**
   * @ngdoc method
   * @name $sceDelegateProvider#resourceUrlBlacklist
   * @kind function
   *
   * @param {Array=} blacklist When provided, replaces the resourceUrlBlacklist with the value
   *     provided.  This must be an array or null.  A snapshot of this array is used so further
   *     changes to the array are ignored.
   *
   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
   *     allowed in this array.
   *
   *     The typical usage for the blacklist is to **block
   *     [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
   *     these would otherwise be trusted but actually return content from the redirected domain.
   *
   *     Finally, **the blacklist overrides the whitelist** and has the final say.
   *
   * @return {Array} the currently set blacklist array.
   *
   * The **default value** when no whitelist has been explicitly set is the empty array (i.e. there
   * is no blacklist.)
   *
   * @description
   * Sets/Gets the blacklist of trusted resource URLs.
   */

  this.resourceUrlBlacklist = function(value) {
    if (arguments.length) {
      resourceUrlBlacklist = adjustMatchers(value);
    }
    return resourceUrlBlacklist;
  };

  this.$get = ['$injector', function($injector) {

    var htmlSanitizer = function htmlSanitizer(html) {
      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
    };

    if ($injector.has('$sanitize')) {
      htmlSanitizer = $injector.get('$sanitize');
    }


    function matchUrl(matcher, parsedUrl) {
      if (matcher === 'self') {
        return urlIsSameOrigin(parsedUrl);
      } else {
        // definitely a regex.  See adjustMatchers()
        return !!matcher.exec(parsedUrl.href);
      }
    }

    function isResourceUrlAllowedByPolicy(url) {
      var parsedUrl = urlResolve(url.toString());
      var i, n, allowed = false;
      // Ensure that at least one item from the whitelist allows this url.
      for (i = 0, n = resourceUrlWhitelist.length; i < n; i++) {
        if (matchUrl(resourceUrlWhitelist[i], parsedUrl)) {
          allowed = true;
          break;
        }
      }
      if (allowed) {
        // Ensure that no item from the blacklist blocked this url.
        for (i = 0, n = resourceUrlBlacklist.length; i < n; i++) {
          if (matchUrl(resourceUrlBlacklist[i], parsedUrl)) {
            allowed = false;
            break;
          }
        }
      }
      return allowed;
    }

    function generateHolderType(Base) {
      var holderType = function TrustedValueHolderType(trustedValue) {
        this.$$unwrapTrustedValue = function() {
          return trustedValue;
        };
      };
      if (Base) {
        holderType.prototype = new Base();
      }
      holderType.prototype.valueOf = function sceValueOf() {
        return this.$$unwrapTrustedValue();
      };
      holderType.prototype.toString = function sceToString() {
        return this.$$unwrapTrustedValue().toString();
      };
      return holderType;
    }

    var trustedValueHolderBase = generateHolderType(),
        byType = {};

    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.URL] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);

    /**
     * @ngdoc method
     * @name $sceDelegate#trustAs
     *
     * @description
     * Returns an object that is trusted by angular for use in specified strict
     * contextual escaping contexts (such as ng-bind-html, ng-include, any src
     * attribute interpolation, any dom event binding attribute interpolation
     * such as for onclick,  etc.) that uses the provided value.
     * See {@link ng.$sce $sce} for enabling strict contextual escaping.
     *
     * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
     *   resourceUrl, html, js and css.
     * @param {*} value The value that that should be considered trusted/safe.
     * @returns {*} A value that can be used to stand in for the provided `value` in places
     * where Angular expects a $sce.trustAs() return value.
     */
    function trustAs(type, trustedValue) {
      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
      if (!Constructor) {
        throw $sceMinErr('icontext',
            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
            type, trustedValue);
      }
      if (trustedValue === null || trustedValue === undefined || trustedValue === '') {
        return trustedValue;
      }
      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
      // mutable objects, we ensure here that the value passed in is actually a string.
      if (typeof trustedValue !== 'string') {
        throw $sceMinErr('itype',
            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
            type);
      }
      return new Constructor(trustedValue);
    }

    /**
     * @ngdoc method
     * @name $sceDelegate#valueOf
     *
     * @description
     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
     *
     * If the passed parameter is not a value that had been returned by {@link
     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, returns it as-is.
     *
     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
     *      call or anything else.
     * @returns {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
     *     `value` unchanged.
     */
    function valueOf(maybeTrusted) {
      if (maybeTrusted instanceof trustedValueHolderBase) {
        return maybeTrusted.$$unwrapTrustedValue();
      } else {
        return maybeTrusted;
      }
    }

    /**
     * @ngdoc method
     * @name $sceDelegate#getTrusted
     *
     * @description
     * Takes the result of a {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`} call and
     * returns the originally supplied value if the queried context type is a supertype of the
     * created type.  If this condition isn't satisfied, throws an exception.
     *
     * @param {string} type The kind of context in which this value is to be used.
     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
     *     `$sceDelegate.trustAs`} call.
     * @returns {*} The value the was originally provided to {@link ng.$sceDelegate#trustAs
     *     `$sceDelegate.trustAs`} if valid in this context.  Otherwise, throws an exception.
     */
    function getTrusted(type, maybeTrusted) {
      if (maybeTrusted === null || maybeTrusted === undefined || maybeTrusted === '') {
        return maybeTrusted;
      }
      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
      if (constructor && maybeTrusted instanceof constructor) {
        return maybeTrusted.$$unwrapTrustedValue();
      }
      // If we get here, then we may only take one of two actions.
      // 1. sanitize the value for the requested type, or
      // 2. throw an exception.
      if (type === SCE_CONTEXTS.RESOURCE_URL) {
        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
          return maybeTrusted;
        } else {
          throw $sceMinErr('insecurl',
              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
              maybeTrusted.toString());
        }
      } else if (type === SCE_CONTEXTS.HTML) {
        return htmlSanitizer(maybeTrusted);
      }
      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
    }

    return { trustAs: trustAs,
             getTrusted: getTrusted,
             valueOf: valueOf };
  }];
}


/**
 * @ngdoc provider
 * @name $sceProvider
 * @description
 *
 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
 * -   enable/disable Strict Contextual Escaping (SCE) in a module
 * -   override the default implementation with a custom delegate
 *
 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
 */

/* jshint maxlen: false*/

/**
 * @ngdoc service
 * @name $sce
 * @kind function
 *
 * @description
 *
 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
 *
 * # Strict Contextual Escaping
 *
 * Strict Contextual Escaping (SCE) is a mode in which AngularJS requires bindings in certain
 * contexts to result in a value that is marked as safe to use for that context.  One example of
 * such a context is binding arbitrary html controlled by the user via `ng-bind-html`.  We refer
 * to these contexts as privileged or SCE contexts.
 *
 * As of version 1.2, Angular ships with SCE enabled by default.
 *
 * Note:  When enabled (the default), IE<11 in quirks mode is not supported.  In this mode, IE<11 allow
 * one to execute arbitrary javascript by the use of the expression() syntax.  Refer
 * <http://blogs.msdn.com/b/ie/archive/2008/10/16/ending-expressions.aspx> to learn more about them.
 * You can ensure your document is in standards mode and not quirks mode by adding `<!doctype html>`
 * to the top of your HTML document.
 *
 * SCE assists in writing code in way that (a) is secure by default and (b) makes auditing for
 * security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
 *
 * Here's an example of a binding in a privileged context:
 *
 * ```
 * <input ng-model="userHtml" aria-label="User input">
 * <div ng-bind-html="userHtml"></div>
 * ```
 *
 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
 * disabled, this application allows the user to render arbitrary HTML into the DIV.
 * In a more realistic example, one may be rendering user comments, blog articles, etc. via
 * bindings.  (HTML is just one example of a context where rendering user controlled input creates
 * security vulnerabilities.)
 *
 * For the case of HTML, you might use a library, either on the client side, or on the server side,
 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
 *
 * How would you ensure that every place that used these types of bindings was bound to a value that
 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
 * properties/fields and forgot to update the binding to the sanitized value?
 *
 * To be secure by default, you want to ensure that any such bindings are disallowed unless you can
 * determine that something explicitly says it's safe to use a value for binding in that
 * context.  You can then audit your code (a simple grep would do) to ensure that this is only done
 * for those values that you can easily tell are safe - because they were received from your server,
 * sanitized by your library, etc.  You can organize your codebase to help with this - perhaps
 * allowing only the files in a specific directory to do this.  Ensuring that the internal API
 * exposed by that code doesn't markup arbitrary values as safe then becomes a more manageable task.
 *
 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
 * obtain values that will be accepted by SCE / privileged contexts.
 *
 *
 * ## How does it work?
 *
 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
 * $sce.getTrusted(context, value)} rather than to the value directly.  Directives use {@link
 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs the
 * {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals.
 *
 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
 * simplified):
 *
 * ```
 * var ngBindHtmlDirective = ['$sce', function($sce) {
 *   return function(scope, element, attr) {
 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
 *       element.html(value || '');
 *     });
 *   };
 * }];
 * ```
 *
 * ## Impact on loading templates
 *
 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
 * `templateUrl`'s specified by {@link guide/directive directives}.
 *
 * By default, Angular only loads templates from the same domain and protocol as the application
 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
 * protocols, you may either either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist
 * them} or {@link ng.$sce#trustAsResourceUrl wrap it} into a trusted value.
 *
 * *Please note*:
 * The browser's
 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
 * policy apply in addition to this and may further restrict whether the template is successfully
 * loaded.  This means that without the right CORS policy, loading templates from a different domain
 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
 * browsers.
 *
 * ## This feels like too much overhead
 *
 * It's important to remember that SCE only applies to interpolation expressions.
 *
 * If your expressions are constant literals, they're automatically trusted and you don't need to
 * call `$sce.trustAs` on them (remember to include the `ngSanitize` module) (e.g.
 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works.
 *
 * Additionally, `a[href]` and `img[src]` automatically sanitize their URLs and do not pass them
 * through {@link ng.$sce#getTrusted $sce.getTrusted}.  SCE doesn't play a role here.
 *
 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
 * templates in `ng-include` from your application's domain without having to even know about SCE.
 * It blocks loading templates from other domains or loading templates over http from an https
 * served document.  You can change these by setting your own custom {@link
 * ng.$sceDelegateProvider#resourceUrlWhitelist whitelists} and {@link
 * ng.$sceDelegateProvider#resourceUrlBlacklist blacklists} for matching such URLs.
 *
 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
 * application that's secure and can be audited to verify that with much more ease than bolting
 * security onto an application later.
 *
 * <a name="contexts"></a>
 * ## What trusted context types are supported?
 *
 * | Context             | Notes          |
 * |---------------------|----------------|
 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered and the {@link ngSanitize $sanitize} module is present this will sanitize the value instead of throwing an error. |
 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently unused.  Feel free to use it in your own directives. |
 * | `$sce.URL`          | For URLs that are safe to follow as links.  Currently unused (`<a href=` and `<img src=` sanitize their urls and don't constitute an SCE context. |
 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` does and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` are required. |
 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently unused.  Feel free to use it in your own directives. |
 *
 * ## Format of items in {@link ng.$sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist}/{@link ng.$sceDelegateProvider#resourceUrlBlacklist Blacklist} <a name="resourceUrlPatternItem"></a>
 *
 *  Each element in these arrays must be one of the following:
 *
 *  - **'self'**
 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
 *      domain** as the application document using the **same protocol**.
 *  - **String** (except the special value `'self'`)
 *    - The string is matched against the full *normalized / absolute URL* of the resource
 *      being tested (substring matches are not good enough.)
 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
 *      match themselves.
 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and ';'.  It's a useful wildcard for use
 *      in a whitelist.
 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
 *      not appropriate to use in for a scheme, domain, etc. as it would match too much.  (e.g.
 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
 *      http://foo.example.com/templates/**).
 *  - **RegExp** (*see caveat below*)
 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
 *      have good test coverage.).  For instance, the use of `.` in the regex is correct only in a
 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
 *      is highly recommended to use the string patterns and only fall back to regular expressions
 *      if they as a last resort.
 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
 *    - If you are generating your JavaScript from some other templating engine (not
 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
 *      remember to escape your regular expression (and be aware that you might need more than
 *      one level of escaping depending on your templating engine and the way you interpolated
 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
 *      enough before coding your own.  e.g. Ruby has
 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
 *      Closure library's [goog.string.regExpEscape(s)](
 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
 *
 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
 *
 * ## Show me an example using SCE.
 *
 * <example module="mySceApp" deps="angular-sanitize.js">
 * <file name="index.html">
 *   <div ng-controller="AppController as myCtrl">
 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
 *     <b>User comments</b><br>
 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
 *     exploit.
 *     <div class="well">
 *       <div ng-repeat="userComment in myCtrl.userComments">
 *         <b>{{userComment.name}}</b>:
 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
 *         <br>
 *       </div>
 *     </div>
 *   </div>
 * </file>
 *
 * <file name="script.js">
 *   angular.module('mySceApp', ['ngSanitize'])
 *     .controller('AppController', ['$http', '$templateCache', '$sce',
 *       function($http, $templateCache, $sce) {
 *         var self = this;
 *         $http.get("test_data.json", {cache: $templateCache}).success(function(userComments) {
 *           self.userComments = userComments;
 *         });
 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
 *             'sanitization.&quot;">Hover over this text.</span>');
 *       }]);
 * </file>
 *
 * <file name="test_data.json">
 * [
 *   { "name": "Alice",
 *     "htmlComment":
 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
 *   },
 *   { "name": "Bob",
 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
 *   }
 * ]
 * </file>
 *
 * <file name="protractor.js" type="protractor">
 *   describe('SCE doc demo', function() {
 *     it('should sanitize untrusted values', function() {
 *       expect(element.all(by.css('.htmlComment')).first().getInnerHtml())
 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
 *     });
 *
 *     it('should NOT sanitize explicitly trusted values', function() {
 *       expect(element(by.id('explicitlyTrustedHtml')).getInnerHtml()).toBe(
 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
 *           'sanitization.&quot;">Hover over this text.</span>');
 *     });
 *   });
 * </file>
 * </example>
 *
 *
 *
 * ## Can I disable SCE completely?
 *
 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
 * for little coding overhead.  It will be much harder to take an SCE disabled application and
 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
 * for cases where you have a lot of existing code that was written before SCE was introduced and
 * you're migrating them a module at a time.
 *
 * That said, here's how you can completely disable SCE:
 *
 * ```
 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
 *   // Completely disable SCE.  For demonstration purposes only!
 *   // Do not use in new projects.
 *   $sceProvider.enabled(false);
 * });
 * ```
 *
 */
/* jshint maxlen: 100 */

function $SceProvider() {
  var enabled = true;

  /**
   * @ngdoc method
   * @name $sceProvider#enabled
   * @kind function
   *
   * @param {boolean=} value If provided, then enables/disables SCE.
   * @return {boolean} true if SCE is enabled, false otherwise.
   *
   * @description
   * Enables/disables SCE and returns the current value.
   */
  this.enabled = function(value) {
    if (arguments.length) {
      enabled = !!value;
    }
    return enabled;
  };


  /* Design notes on the default implementation for SCE.
   *
   * The API contract for the SCE delegate
   * -------------------------------------
   * The SCE delegate object must provide the following 3 methods:
   *
   * - trustAs(contextEnum, value)
   *     This method is used to tell the SCE service that the provided value is OK to use in the
   *     contexts specified by contextEnum.  It must return an object that will be accepted by
   *     getTrusted() for a compatible contextEnum and return this value.
   *
   * - valueOf(value)
   *     For values that were not produced by trustAs(), return them as is.  For values that were
   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
   *     such a value.
   *
   * - getTrusted(contextEnum, value)
   *     This function should return the a value that is safe to use in the context specified by
   *     contextEnum or throw and exception otherwise.
   *
   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
   * instance, an implementation could maintain a registry of all trusted objects by context.  In
   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
   * return the same object passed in if it was found in the registry under a compatible context or
   * throw an exception otherwise.  An implementation might only wrap values some of the time based
   * on some criteria.  getTrusted() might return a value and not throw an exception for special
   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
   *
   *
   * A note on the inheritance model for SCE contexts
   * ------------------------------------------------
   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
   * is purely an implementation details.
   *
   * The contract is simply this:
   *
   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
   *     will also succeed.
   *
   * Inheritance happens to capture this in a natural way.  In some future, we
   * may not use inheritance anymore.  That is OK because no code outside of
   * sce.js and sceSpecs.js would need to be aware of this detail.
   */

  this.$get = ['$parse', '$sceDelegate', function(
                $parse,   $sceDelegate) {
    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
    // the "expression(javascript expression)" syntax which is insecure.
    if (enabled && msie < 8) {
      throw $sceMinErr('iequirks',
        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
    }

    var sce = shallowCopy(SCE_CONTEXTS);

    /**
     * @ngdoc method
     * @name $sce#isEnabled
     * @kind function
     *
     * @return {Boolean} true if SCE is enabled, false otherwise.  If you want to set the value, you
     * have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
     *
     * @description
     * Returns a boolean indicating if SCE is enabled.
     */
    sce.isEnabled = function() {
      return enabled;
    };
    sce.trustAs = $sceDelegate.trustAs;
    sce.getTrusted = $sceDelegate.getTrusted;
    sce.valueOf = $sceDelegate.valueOf;

    if (!enabled) {
      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
      sce.valueOf = identity;
    }

    /**
     * @ngdoc method
     * @name $sce#parseAs
     *
     * @description
     * Converts Angular {@link guide/expression expression} into a function.  This is like {@link
     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
     * *result*)}
     *
     * @param {string} type The kind of SCE context in which this result will be used.
     * @param {string} expression String expression to compile.
     * @returns {function(context, locals)} a function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
     *      are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
     *      `context`.
     */
    sce.parseAs = function sceParseAs(type, expr) {
      var parsed = $parse(expr);
      if (parsed.literal && parsed.constant) {
        return parsed;
      } else {
        return $parse(expr, function(value) {
          return sce.getTrusted(type, value);
        });
      }
    };

    /**
     * @ngdoc method
     * @name $sce#trustAs
     *
     * @description
     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.  As such,
     * returns an object that is trusted by angular for use in specified strict contextual
     * escaping contexts (such as ng-bind-html, ng-include, any src attribute
     * interpolation, any dom event binding attribute interpolation such as for onclick,  etc.)
     * that uses the provided value.  See * {@link ng.$sce $sce} for enabling strict contextual
     * escaping.
     *
     * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
     *   resourceUrl, html, js and css.
     * @param {*} value The value that that should be considered trusted/safe.
     * @returns {*} A value that can be used to stand in for the provided `value` in places
     * where Angular expects a $sce.trustAs() return value.
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsHtml
     *
     * @description
     * Shorthand method.  `$sce.trustAsHtml(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
     *
     * @param {*} value The value to trustAs.
     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedHtml
     *     $sce.getTrustedHtml(value)} to obtain the original value.  (privileged directives
     *     only accept expressions that are either literal constants or are the
     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsUrl
     *
     * @description
     * Shorthand method.  `$sce.trustAsUrl(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
     *
     * @param {*} value The value to trustAs.
     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedUrl
     *     $sce.getTrustedUrl(value)} to obtain the original value.  (privileged directives
     *     only accept expressions that are either literal constants or are the
     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
     *
     * @param {*} value The value to trustAs.
     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedResourceUrl
     *     $sce.getTrustedResourceUrl(value)} to obtain the original value.  (privileged directives
     *     only accept expressions that are either literal constants or are the return
     *     value of {@link ng.$sce#trustAs $sce.trustAs}.)
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsJs
     *
     * @description
     * Shorthand method.  `$sce.trustAsJs(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
     *
     * @param {*} value The value to trustAs.
     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedJs
     *     $sce.getTrustedJs(value)} to obtain the original value.  (privileged directives
     *     only accept expressions that are either literal constants or are the
     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
     */

    /**
     * @ngdoc method
     * @name $sce#getTrusted
     *
     * @description
     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
     * takes the result of a {@link ng.$sce#trustAs `$sce.trustAs`}() call and returns the
     * originally supplied value if the queried context type is a supertype of the created type.
     * If this condition isn't satisfied, throws an exception.
     *
     * @param {string} type The kind of context in which this value is to be used.
     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs `$sce.trustAs`}
     *                         call.
     * @returns {*} The value the was originally provided to
     *              {@link ng.$sce#trustAs `$sce.trustAs`} if valid in this context.
     *              Otherwise, throws an exception.
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedHtml
     *
     * @description
     * Shorthand method.  `$sce.getTrustedHtml(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @returns {*} The return value of `$sce.getTrusted($sce.HTML, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedCss
     *
     * @description
     * Shorthand method.  `$sce.getTrustedCss(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @returns {*} The return value of `$sce.getTrusted($sce.CSS, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedUrl
     *
     * @description
     * Shorthand method.  `$sce.getTrustedUrl(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @returns {*} The return value of `$sce.getTrusted($sce.URL, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
     *
     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
     * @returns {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedJs
     *
     * @description
     * Shorthand method.  `$sce.getTrustedJs(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @returns {*} The return value of `$sce.getTrusted($sce.JS, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsHtml
     *
     * @description
     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
     *
     * @param {string} expression String expression to compile.
     * @returns {function(context, locals)} a function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
     *      are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
     *      `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsCss
     *
     * @description
     * Shorthand method.  `$sce.parseAsCss(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
     *
     * @param {string} expression String expression to compile.
     * @returns {function(context, locals)} a function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
     *      are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
     *      `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsUrl
     *
     * @description
     * Shorthand method.  `$sce.parseAsUrl(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
     *
     * @param {string} expression String expression to compile.
     * @returns {function(context, locals)} a function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
     *      are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
     *      `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
     *
     * @param {string} expression String expression to compile.
     * @returns {function(context, locals)} a function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
     *      are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
     *      `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsJs
     *
     * @description
     * Shorthand method.  `$sce.parseAsJs(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
     *
     * @param {string} expression String expression to compile.
     * @returns {function(context, locals)} a function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
     *      are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
     *      `context`.
     */

    // Shorthand delegations.
    var parse = sce.parseAs,
        getTrusted = sce.getTrusted,
        trustAs = sce.trustAs;

    forEach(SCE_CONTEXTS, function(enumValue, name) {
      var lName = lowercase(name);
      sce[camelCase("parse_as_" + lName)] = function(expr) {
        return parse(enumValue, expr);
      };
      sce[camelCase("get_trusted_" + lName)] = function(value) {
        return getTrusted(enumValue, value);
      };
      sce[camelCase("trust_as_" + lName)] = function(value) {
        return trustAs(enumValue, value);
      };
    });

    return sce;
  }];
}

/**
 * !!! This is an undocumented "private" service !!!
 *
 * @name $sniffer
 * @requires $window
 * @requires $document
 *
 * @property {boolean} history Does the browser support html5 history api ?
 * @property {boolean} transitions Does the browser support CSS transition events ?
 * @property {boolean} animations Does the browser support CSS animation events ?
 *
 * @description
 * This is very simple implementation of testing browser's features.
 */
function $SnifferProvider() {
  this.$get = ['$window', '$document', function($window, $document) {
    var eventSupport = {},
        android =
          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
        document = $document[0] || {},
        vendorPrefix,
        vendorRegex = /^(Moz|webkit|ms)(?=[A-Z])/,
        bodyStyle = document.body && document.body.style,
        transitions = false,
        animations = false,
        match;

    if (bodyStyle) {
      for (var prop in bodyStyle) {
        if (match = vendorRegex.exec(prop)) {
          vendorPrefix = match[0];
          vendorPrefix = vendorPrefix.substr(0, 1).toUpperCase() + vendorPrefix.substr(1);
          break;
        }
      }

      if (!vendorPrefix) {
        vendorPrefix = ('WebkitOpacity' in bodyStyle) && 'webkit';
      }

      transitions = !!(('transition' in bodyStyle) || (vendorPrefix + 'Transition' in bodyStyle));
      animations  = !!(('animation' in bodyStyle) || (vendorPrefix + 'Animation' in bodyStyle));

      if (android && (!transitions ||  !animations)) {
        transitions = isString(bodyStyle.webkitTransition);
        animations = isString(bodyStyle.webkitAnimation);
      }
    }


    return {
      // Android has history.pushState, but it does not update location correctly
      // so let's not use the history API at all.
      // http://code.google.com/p/android/issues/detail?id=17471
      // https://github.com/angular/angular.js/issues/904

      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
      // so let's not use the history API also
      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
      // jshint -W018
      history: !!($window.history && $window.history.pushState && !(android < 4) && !boxee),
      // jshint +W018
      hasEvent: function(event) {
        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
        // it. In particular the event is not fired when backspace or delete key are pressed or
        // when cut operation is performed.
        // IE10+ implements 'input' event but it erroneously fires under various situations,
        // e.g. when placeholder changes, or a form is focused.
        if (event === 'input' && msie <= 11) return false;

        if (isUndefined(eventSupport[event])) {
          var divElm = document.createElement('div');
          eventSupport[event] = 'on' + event in divElm;
        }

        return eventSupport[event];
      },
      csp: csp(),
      vendorPrefix: vendorPrefix,
      transitions: transitions,
      animations: animations,
      android: android
    };
  }];
}

var $compileMinErr = minErr('$compile');

/**
 * @ngdoc service
 * @name $templateRequest
 *
 * @description
 * The `$templateRequest` service downloads the provided template using `$http` and, upon success,
 * stores the contents inside of `$templateCache`. If the HTTP request fails or the response data
 * of the HTTP request is empty, a `$compile` error will be thrown (the exception can be thwarted
 * by setting the 2nd parameter of the function to true).
 *
 * @param {string} tpl The HTTP request template URL
 * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
 *
 * @return {Promise} a promise for the HTTP response data of the given URL.
 *
 * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
 */
function $TemplateRequestProvider() {
  this.$get = ['$templateCache', '$http', '$q', function($templateCache, $http, $q) {
    function handleRequestFn(tpl, ignoreRequestError) {
      handleRequestFn.totalPendingRequests++;

      var transformResponse = $http.defaults && $http.defaults.transformResponse;

      if (isArray(transformResponse)) {
        transformResponse = transformResponse.filter(function(transformer) {
          return transformer !== defaultHttpResponseTransform;
        });
      } else if (transformResponse === defaultHttpResponseTransform) {
        transformResponse = null;
      }

      var httpOptions = {
        cache: $templateCache,
        transformResponse: transformResponse
      };

      return $http.get(tpl, httpOptions)
        ['finally'](function() {
          handleRequestFn.totalPendingRequests--;
        })
        .then(function(response) {
          $templateCache.put(tpl, response.data);
          return response.data;
        }, handleError);

      function handleError(resp) {
        if (!ignoreRequestError) {
          throw $compileMinErr('tpload', 'Failed to load template: {0} (HTTP status: {1} {2})',
            tpl, resp.status, resp.statusText);
        }
        return $q.reject(resp);
      }
    }

    handleRequestFn.totalPendingRequests = 0;

    return handleRequestFn;
  }];
}

function $$TestabilityProvider() {
  this.$get = ['$rootScope', '$browser', '$location',
       function($rootScope,   $browser,   $location) {

    /**
     * @name $testability
     *
     * @description
     * The private $$testability service provides a collection of methods for use when debugging
     * or by automated test and debugging tools.
     */
    var testability = {};

    /**
     * @name $$testability#findBindings
     *
     * @description
     * Returns an array of elements that are bound (via ng-bind or {{}})
     * to expressions matching the input.
     *
     * @param {Element} element The element root to search from.
     * @param {string} expression The binding expression to match.
     * @param {boolean} opt_exactMatch If true, only returns exact matches
     *     for the expression. Filters and whitespace are ignored.
     */
    testability.findBindings = function(element, expression, opt_exactMatch) {
      var bindings = element.getElementsByClassName('ng-binding');
      var matches = [];
      forEach(bindings, function(binding) {
        var dataBinding = angular.element(binding).data('$binding');
        if (dataBinding) {
          forEach(dataBinding, function(bindingName) {
            if (opt_exactMatch) {
              var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
              if (matcher.test(bindingName)) {
                matches.push(binding);
              }
            } else {
              if (bindingName.indexOf(expression) != -1) {
                matches.push(binding);
              }
            }
          });
        }
      });
      return matches;
    };

    /**
     * @name $$testability#findModels
     *
     * @description
     * Returns an array of elements that are two-way found via ng-model to
     * expressions matching the input.
     *
     * @param {Element} element The element root to search from.
     * @param {string} expression The model expression to match.
     * @param {boolean} opt_exactMatch If true, only returns exact matches
     *     for the expression.
     */
    testability.findModels = function(element, expression, opt_exactMatch) {
      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
      for (var p = 0; p < prefixes.length; ++p) {
        var attributeEquals = opt_exactMatch ? '=' : '*=';
        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
        var elements = element.querySelectorAll(selector);
        if (elements.length) {
          return elements;
        }
      }
    };

    /**
     * @name $$testability#getLocation
     *
     * @description
     * Shortcut for getting the location in a browser agnostic way. Returns
     *     the path, search, and hash. (e.g. /path?a=b#hash)
     */
    testability.getLocation = function() {
      return $location.url();
    };

    /**
     * @name $$testability#setLocation
     *
     * @description
     * Shortcut for navigating to a location without doing a full page reload.
     *
     * @param {string} url The location url (path, search and hash,
     *     e.g. /path?a=b#hash) to go to.
     */
    testability.setLocation = function(url) {
      if (url !== $location.url()) {
        $location.url(url);
        $rootScope.$digest();
      }
    };

    /**
     * @name $$testability#whenStable
     *
     * @description
     * Calls the callback when $timeout and $http requests are completed.
     *
     * @param {function} callback
     */
    testability.whenStable = function(callback) {
      $browser.notifyWhenNoOutstandingRequests(callback);
    };

    return testability;
  }];
}

function $TimeoutProvider() {
  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {

    var deferreds = {};


     /**
      * @ngdoc service
      * @name $timeout
      *
      * @description
      * Angular's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
      * block and delegates any exceptions to
      * {@link ng.$exceptionHandler $exceptionHandler} service.
      *
      * The return value of calling `$timeout` is a promise, which will be resolved when
      * the delay has passed and the timeout function, if provided, is executed.
      *
      * To cancel a timeout request, call `$timeout.cancel(promise)`.
      *
      * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
      * synchronously flush the queue of deferred functions.
      *
      * If you only want a promise that will be resolved after some specified delay
      * then you can call `$timeout` without the `fn` function.
      *
      * @param {function()=} fn A function, whose execution should be delayed.
      * @param {number=} [delay=0] Delay in milliseconds.
      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
      * @param {...*=} Pass additional parameters to the executed function.
      * @returns {Promise} Promise that will be resolved when the timeout is reached. The value this
      *   promise will be resolved with is the return value of the `fn` function.
      *
      */
    function timeout(fn, delay, invokeApply) {
      if (!isFunction(fn)) {
        invokeApply = delay;
        delay = fn;
        fn = noop;
      }

      var args = sliceArgs(arguments, 3),
          skipApply = (isDefined(invokeApply) && !invokeApply),
          deferred = (skipApply ? $$q : $q).defer(),
          promise = deferred.promise,
          timeoutId;

      timeoutId = $browser.defer(function() {
        try {
          deferred.resolve(fn.apply(null, args));
        } catch (e) {
          deferred.reject(e);
          $exceptionHandler(e);
        }
        finally {
          delete deferreds[promise.$$timeoutId];
        }

        if (!skipApply) $rootScope.$apply();
      }, delay);

      promise.$$timeoutId = timeoutId;
      deferreds[timeoutId] = deferred;

      return promise;
    }


     /**
      * @ngdoc method
      * @name $timeout#cancel
      *
      * @description
      * Cancels a task associated with the `promise`. As a result of this, the promise will be
      * resolved with a rejection.
      *
      * @param {Promise=} promise Promise returned by the `$timeout` function.
      * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
      *   canceled.
      */
    timeout.cancel = function(promise) {
      if (promise && promise.$$timeoutId in deferreds) {
        deferreds[promise.$$timeoutId].reject('canceled');
        delete deferreds[promise.$$timeoutId];
        return $browser.defer.cancel(promise.$$timeoutId);
      }
      return false;
    };

    return timeout;
  }];
}

// NOTE:  The usage of window and document instead of $window and $document here is
// deliberate.  This service depends on the specific behavior of anchor nodes created by the
// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
// doesn't know about mocked locations and resolves URLs to the real document - which is
// exactly the behavior needed here.  There is little value is mocking these out for this
// service.
var urlParsingNode = document.createElement("a");
var originUrl = urlResolve(window.location.href);


/**
 *
 * Implementation Notes for non-IE browsers
 * ----------------------------------------
 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
 * URL will be resolved into an absolute URL in the context of the application document.
 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
 * properties are all populated to reflect the normalized URL.  This approach has wide
 * compatibility - Safari 1+, Mozilla 1+, Opera 7+,e etc.  See
 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
 *
 * Implementation Notes for IE
 * ---------------------------
 * IE >= 8 and <= 10 normalizes the URL when assigned to the anchor node similar to the other
 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
 * work around that by performing the parsing in a 2nd step by taking a previously normalized
 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
 * properties such as protocol, hostname, port, etc.
 *
 * IE7 does not normalize the URL when assigned to an anchor node.  (Apparently, it does, if one
 * uses the inner HTML approach to assign the URL as part of an HTML snippet -
 * http://stackoverflow.com/a/472729)  However, setting img[src] does normalize the URL.
 * Unfortunately, setting img[src] to something like "javascript:foo" on IE throws an exception.
 * Since the primary usage for normalizing URLs is to sanitize such URLs, we can't use that
 * method and IE < 8 is unsupported.
 *
 * References:
 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
 *   http://url.spec.whatwg.org/#urlutils
 *   https://github.com/angular/angular.js/pull/2902
 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
 *
 * @kind function
 * @param {string} url The URL to be parsed.
 * @description Normalizes and parses a URL.
 * @returns {object} Returns the normalized URL as a dictionary.
 *
 *   | member name   | Description    |
 *   |---------------|----------------|
 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
 *   | protocol      | The protocol including the trailing colon                              |
 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
 *   | search        | The search params, minus the question mark                             |
 *   | hash          | The hash string, minus the hash symbol
 *   | hostname      | The hostname
 *   | port          | The port, without ":"
 *   | pathname      | The pathname, beginning with "/"
 *
 */
function urlResolve(url) {
  var href = url;

  if (msie) {
    // Normalize before parse.  Refer Implementation Notes on why this is
    // done in two steps on IE.
    urlParsingNode.setAttribute("href", href);
    href = urlParsingNode.href;
  }

  urlParsingNode.setAttribute('href', href);

  // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
  return {
    href: urlParsingNode.href,
    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
    host: urlParsingNode.host,
    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
    hostname: urlParsingNode.hostname,
    port: urlParsingNode.port,
    pathname: (urlParsingNode.pathname.charAt(0) === '/')
      ? urlParsingNode.pathname
      : '/' + urlParsingNode.pathname
  };
}

/**
 * Parse a request URL and determine whether this is a same-origin request as the application document.
 *
 * @param {string|object} requestUrl The url of the request as a string that will be resolved
 * or a parsed URL object.
 * @returns {boolean} Whether the request is for the same origin as the application document.
 */
function urlIsSameOrigin(requestUrl) {
  var parsed = (isString(requestUrl)) ? urlResolve(requestUrl) : requestUrl;
  return (parsed.protocol === originUrl.protocol &&
          parsed.host === originUrl.host);
}

/**
 * @ngdoc service
 * @name $window
 *
 * @description
 * A reference to the browser's `window` object. While `window`
 * is globally available in JavaScript, it causes testability problems, because
 * it is a global variable. In angular we always refer to it through the
 * `$window` service, so it may be overridden, removed or mocked for testing.
 *
 * Expressions, like the one defined for the `ngClick` directive in the example
 * below, are evaluated with respect to the current scope.  Therefore, there is
 * no risk of inadvertently coding in a dependency on a global value in such an
 * expression.
 *
 * @example
   <example module="windowExample">
     <file name="index.html">
       <script>
         angular.module('windowExample', [])
           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
             $scope.greeting = 'Hello, World!';
             $scope.doGreeting = function(greeting) {
               $window.alert(greeting);
             };
           }]);
       </script>
       <div ng-controller="ExampleController">
         <input type="text" ng-model="greeting" aria-label="greeting" />
         <button ng-click="doGreeting(greeting)">ALERT</button>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
      it('should display the greeting in the input box', function() {
       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
       // If we click the button it will block the test runner
       // element(':button').click();
      });
     </file>
   </example>
 */
function $WindowProvider() {
  this.$get = valueFn(window);
}

/**
 * @name $$cookieReader
 * @requires $document
 *
 * @description
 * This is a private service for reading cookies used by $http and ngCookies
 *
 * @return {Object} a key/value map of the current cookies
 */
function $$CookieReader($document) {
  var rawDocument = $document[0] || {};
  var lastCookies = {};
  var lastCookieString = '';

  function safeDecodeURIComponent(str) {
    try {
      return decodeURIComponent(str);
    } catch (e) {
      return str;
    }
  }

  return function() {
    var cookieArray, cookie, i, index, name;
    var currentCookieString = rawDocument.cookie || '';

    if (currentCookieString !== lastCookieString) {
      lastCookieString = currentCookieString;
      cookieArray = lastCookieString.split('; ');
      lastCookies = {};

      for (i = 0; i < cookieArray.length; i++) {
        cookie = cookieArray[i];
        index = cookie.indexOf('=');
        if (index > 0) { //ignore nameless cookies
          name = safeDecodeURIComponent(cookie.substring(0, index));
          // the first value that is seen for a cookie is the most
          // specific one.  values for the same cookie name that
          // follow are for less specific paths.
          if (lastCookies[name] === undefined) {
            lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
          }
        }
      }
    }
    return lastCookies;
  };
}

$$CookieReader.$inject = ['$document'];

function $$CookieReaderProvider() {
  this.$get = $$CookieReader;
}

/* global currencyFilter: true,
 dateFilter: true,
 filterFilter: true,
 jsonFilter: true,
 limitToFilter: true,
 lowercaseFilter: true,
 numberFilter: true,
 orderByFilter: true,
 uppercaseFilter: true,
 */

/**
 * @ngdoc provider
 * @name $filterProvider
 * @description
 *
 * Filters are just functions which transform input to an output. However filters need to be
 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
 * annotated with dependencies and is responsible for creating a filter function.
 *
 * <div class="alert alert-warning">
 * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
 * (`myapp_subsection_filterx`).
 * </div>
 *
 * ```js
 *   // Filter registration
 *   function MyModule($provide, $filterProvider) {
 *     // create a service to demonstrate injection (not always needed)
 *     $provide.value('greet', function(name){
 *       return 'Hello ' + name + '!';
 *     });
 *
 *     // register a filter factory which uses the
 *     // greet service to demonstrate DI.
 *     $filterProvider.register('greet', function(greet){
 *       // return the filter function which uses the greet service
 *       // to generate salutation
 *       return function(text) {
 *         // filters need to be forgiving so check input validity
 *         return text && greet(text) || text;
 *       };
 *     });
 *   }
 * ```
 *
 * The filter function is registered with the `$injector` under the filter name suffix with
 * `Filter`.
 *
 * ```js
 *   it('should be the same instance', inject(
 *     function($filterProvider) {
 *       $filterProvider.register('reverse', function(){
 *         return ...;
 *       });
 *     },
 *     function($filter, reverseFilter) {
 *       expect($filter('reverse')).toBe(reverseFilter);
 *     });
 * ```
 *
 *
 * For more information about how angular filters work, and how to create your own filters, see
 * {@link guide/filter Filters} in the Angular Developer Guide.
 */

/**
 * @ngdoc service
 * @name $filter
 * @kind function
 * @description
 * Filters are used for formatting data displayed to the user.
 *
 * The general syntax in templates is as follows:
 *
 *         {{ expression [| filter_name[:parameter_value] ... ] }}
 *
 * @param {String} name Name of the filter function to retrieve
 * @return {Function} the filter function
 * @example
   <example name="$filter" module="filterExample">
     <file name="index.html">
       <div ng-controller="MainCtrl">
        <h3>{{ originalText }}</h3>
        <h3>{{ filteredText }}</h3>
       </div>
     </file>

     <file name="script.js">
      angular.module('filterExample', [])
      .controller('MainCtrl', function($scope, $filter) {
        $scope.originalText = 'hello';
        $scope.filteredText = $filter('uppercase')($scope.originalText);
      });
     </file>
   </example>
  */
$FilterProvider.$inject = ['$provide'];
function $FilterProvider($provide) {
  var suffix = 'Filter';

  /**
   * @ngdoc method
   * @name $filterProvider#register
   * @param {string|Object} name Name of the filter function, or an object map of filters where
   *    the keys are the filter names and the values are the filter factories.
   *
   *    <div class="alert alert-warning">
   *    **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
   *    (`myapp_subsection_filterx`).
   *    </div>
   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
   *    of the registered filter instances.
   */
  function register(name, factory) {
    if (isObject(name)) {
      var filters = {};
      forEach(name, function(filter, key) {
        filters[key] = register(key, filter);
      });
      return filters;
    } else {
      return $provide.factory(name + suffix, factory);
    }
  }
  this.register = register;

  this.$get = ['$injector', function($injector) {
    return function(name) {
      return $injector.get(name + suffix);
    };
  }];

  ////////////////////////////////////////

  /* global
    currencyFilter: false,
    dateFilter: false,
    filterFilter: false,
    jsonFilter: false,
    limitToFilter: false,
    lowercaseFilter: false,
    numberFilter: false,
    orderByFilter: false,
    uppercaseFilter: false,
  */

  register('currency', currencyFilter);
  register('date', dateFilter);
  register('filter', filterFilter);
  register('json', jsonFilter);
  register('limitTo', limitToFilter);
  register('lowercase', lowercaseFilter);
  register('number', numberFilter);
  register('orderBy', orderByFilter);
  register('uppercase', uppercaseFilter);
}

/**
 * @ngdoc filter
 * @name filter
 * @kind function
 *
 * @description
 * Selects a subset of items from `array` and returns it as a new array.
 *
 * @param {Array} array The source array.
 * @param {string|Object|function()} expression The predicate to be used for selecting items from
 *   `array`.
 *
 *   Can be one of:
 *
 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
 *     objects with string properties in `array` that match this string will be returned. This also
 *     applies to nested object properties.
 *     The predicate can be negated by prefixing the string with `!`.
 *
 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
 *     which have property `name` containing "M" and property `phone` containing "1". A special
 *     property name `$` can be used (as in `{$:"text"}`) to accept a match against any
 *     property of the object or its nested object properties. That's equivalent to the simple
 *     substring match with a `string` as described above. The predicate can be negated by prefixing
 *     the string with `!`.
 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
 *     not containing "M".
 *
 *     Note that a named property will match properties on the same level only, while the special
 *     `$` property will match properties on the same level or deeper. E.g. an array item like
 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
 *     **will** be matched by `{$: 'John'}`.
 *
 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
 *     The function is called for each element of the array, with the element, its index, and
 *     the entire array itself as arguments.
 *
 *     The final result is an array of those elements that the predicate returned true for.
 *
 * @param {function(actual, expected)|true|undefined} comparator Comparator which is used in
 *     determining if the expected value (from the filter expression) and actual value (from
 *     the object in the array) should be considered a match.
 *
 *   Can be one of:
 *
 *   - `function(actual, expected)`:
 *     The function will be given the object value and the predicate value to compare and
 *     should return true if both values should be considered equal.
 *
 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
 *     This is essentially strict comparison of expected and actual.
 *
 *   - `false|undefined`: A short hand for a function which will look for a substring match in case
 *     insensitive way.
 *
 *     Primitive values are converted to strings. Objects are not compared against primitives,
 *     unless they have a custom `toString` method (e.g. `Date` objects).
 *
 * @example
   <example>
     <file name="index.html">
       <div ng-init="friends = [{name:'John', phone:'555-1276'},
                                {name:'Mary', phone:'800-BIG-MARY'},
                                {name:'Mike', phone:'555-4321'},
                                {name:'Adam', phone:'555-5678'},
                                {name:'Julie', phone:'555-8765'},
                                {name:'Juliette', phone:'555-5678'}]"></div>

       <label>Search: <input ng-model="searchText"></label>
       <table id="searchTextResults">
         <tr><th>Name</th><th>Phone</th></tr>
         <tr ng-repeat="friend in friends | filter:searchText">
           <td>{{friend.name}}</td>
           <td>{{friend.phone}}</td>
         </tr>
       </table>
       <hr>
       <label>Any: <input ng-model="search.$"></label> <br>
       <label>Name only <input ng-model="search.name"></label><br>
       <label>Phone only <input ng-model="search.phone"></label><br>
       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
       <table id="searchObjResults">
         <tr><th>Name</th><th>Phone</th></tr>
         <tr ng-repeat="friendObj in friends | filter:search:strict">
           <td>{{friendObj.name}}</td>
           <td>{{friendObj.phone}}</td>
         </tr>
       </table>
     </file>
     <file name="protractor.js" type="protractor">
       var expectFriendNames = function(expectedNames, key) {
         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
           arr.forEach(function(wd, i) {
             expect(wd.getText()).toMatch(expectedNames[i]);
           });
         });
       };

       it('should search across all fields when filtering with a string', function() {
         var searchText = element(by.model('searchText'));
         searchText.clear();
         searchText.sendKeys('m');
         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');

         searchText.clear();
         searchText.sendKeys('76');
         expectFriendNames(['John', 'Julie'], 'friend');
       });

       it('should search in specific fields when filtering with a predicate object', function() {
         var searchAny = element(by.model('search.$'));
         searchAny.clear();
         searchAny.sendKeys('i');
         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
       });
       it('should use a equal comparison when comparator is true', function() {
         var searchName = element(by.model('search.name'));
         var strict = element(by.model('strict'));
         searchName.clear();
         searchName.sendKeys('Julie');
         strict.click();
         expectFriendNames(['Julie'], 'friendObj');
       });
     </file>
   </example>
 */
function filterFilter() {
  return function(array, expression, comparator) {
    if (!isArrayLike(array)) {
      if (array == null) {
        return array;
      } else {
        throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
      }
    }

    var expressionType = getTypeForFilter(expression);
    var predicateFn;
    var matchAgainstAnyProp;

    switch (expressionType) {
      case 'function':
        predicateFn = expression;
        break;
      case 'boolean':
      case 'null':
      case 'number':
      case 'string':
        matchAgainstAnyProp = true;
        //jshint -W086
      case 'object':
        //jshint +W086
        predicateFn = createPredicateFn(expression, comparator, matchAgainstAnyProp);
        break;
      default:
        return array;
    }

    return Array.prototype.filter.call(array, predicateFn);
  };
}

function hasCustomToString(obj) {
  return isFunction(obj.toString) && obj.toString !== Object.prototype.toString;
}

// Helper functions for `filterFilter`
function createPredicateFn(expression, comparator, matchAgainstAnyProp) {
  var shouldMatchPrimitives = isObject(expression) && ('$' in expression);
  var predicateFn;

  if (comparator === true) {
    comparator = equals;
  } else if (!isFunction(comparator)) {
    comparator = function(actual, expected) {
      if (isUndefined(actual)) {
        // No substring matching against `undefined`
        return false;
      }
      if ((actual === null) || (expected === null)) {
        // No substring matching against `null`; only match against `null`
        return actual === expected;
      }
      if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
        // Should not compare primitives against objects, unless they have custom `toString` method
        return false;
      }

      actual = lowercase('' + actual);
      expected = lowercase('' + expected);
      return actual.indexOf(expected) !== -1;
    };
  }

  predicateFn = function(item) {
    if (shouldMatchPrimitives && !isObject(item)) {
      return deepCompare(item, expression.$, comparator, false);
    }
    return deepCompare(item, expression, comparator, matchAgainstAnyProp);
  };

  return predicateFn;
}

function deepCompare(actual, expected, comparator, matchAgainstAnyProp, dontMatchWholeObject) {
  var actualType = getTypeForFilter(actual);
  var expectedType = getTypeForFilter(expected);

  if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
    return !deepCompare(actual, expected.substring(1), comparator, matchAgainstAnyProp);
  } else if (isArray(actual)) {
    // In case `actual` is an array, consider it a match
    // if ANY of it's items matches `expected`
    return actual.some(function(item) {
      return deepCompare(item, expected, comparator, matchAgainstAnyProp);
    });
  }

  switch (actualType) {
    case 'object':
      var key;
      if (matchAgainstAnyProp) {
        for (key in actual) {
          if ((key.charAt(0) !== '$') && deepCompare(actual[key], expected, comparator, true)) {
            return true;
          }
        }
        return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, false);
      } else if (expectedType === 'object') {
        for (key in expected) {
          var expectedVal = expected[key];
          if (isFunction(expectedVal) || isUndefined(expectedVal)) {
            continue;
          }

          var matchAnyProperty = key === '$';
          var actualVal = matchAnyProperty ? actual : actual[key];
          if (!deepCompare(actualVal, expectedVal, comparator, matchAnyProperty, matchAnyProperty)) {
            return false;
          }
        }
        return true;
      } else {
        return comparator(actual, expected);
      }
      break;
    case 'function':
      return false;
    default:
      return comparator(actual, expected);
  }
}

// Used for easily differentiating between `null` and actual `object`
function getTypeForFilter(val) {
  return (val === null) ? 'null' : typeof val;
}

/**
 * @ngdoc filter
 * @name currency
 * @kind function
 *
 * @description
 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
 * symbol for current locale is used.
 *
 * @param {number} amount Input to filter.
 * @param {string=} symbol Currency symbol or identifier to be displayed.
 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
 * @returns {string} Formatted number.
 *
 *
 * @example
   <example module="currencyExample">
     <file name="index.html">
       <script>
         angular.module('currencyExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.amount = 1234.56;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <input type="number" ng-model="amount" aria-label="amount"> <br>
         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span>
         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should init with 1234.56', function() {
         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
       });
       it('should update', function() {
         if (browser.params.browser == 'safari') {
           // Safari does not understand the minus key. See
           // https://github.com/angular/protractor/issues/481
           return;
         }
         element(by.model('amount')).clear();
         element(by.model('amount')).sendKeys('-1234');
         expect(element(by.id('currency-default')).getText()).toBe('($1,234.00)');
         expect(element(by.id('currency-custom')).getText()).toBe('(USD$1,234.00)');
         expect(element(by.id('currency-no-fractions')).getText()).toBe('(USD$1,234)');
       });
     </file>
   </example>
 */
currencyFilter.$inject = ['$locale'];
function currencyFilter($locale) {
  var formats = $locale.NUMBER_FORMATS;
  return function(amount, currencySymbol, fractionSize) {
    if (isUndefined(currencySymbol)) {
      currencySymbol = formats.CURRENCY_SYM;
    }

    if (isUndefined(fractionSize)) {
      fractionSize = formats.PATTERNS[1].maxFrac;
    }

    // if null or undefined pass it through
    return (amount == null)
        ? amount
        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
            replace(/\u00A4/g, currencySymbol);
  };
}

/**
 * @ngdoc filter
 * @name number
 * @kind function
 *
 * @description
 * Formats a number as text.
 *
 * If the input is null or undefined, it will just be returned.
 * If the input is infinite (Infinity/-Infinity) the Infinity symbol '∞' is returned.
 * If the input is not a number an empty string is returned.
 *
 *
 * @param {number|string} number Number to format.
 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
 * If this is not provided then the fraction size is computed from the current locale's number
 * formatting pattern. In the case of the default locale, it will be 3.
 * @returns {string} Number rounded to decimalPlaces and places a “,” after each third digit.
 *
 * @example
   <example module="numberFilterExample">
     <file name="index.html">
       <script>
         angular.module('numberFilterExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.val = 1234.56789;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>Enter number: <input ng-model='val'></label><br>
         Default formatting: <span id='number-default'>{{val | number}}</span><br>
         No fractions: <span>{{val | number:0}}</span><br>
         Negative number: <span>{{-val | number:4}}</span>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should format numbers', function() {
         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
       });

       it('should update', function() {
         element(by.model('val')).clear();
         element(by.model('val')).sendKeys('3374.333');
         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
      });
     </file>
   </example>
 */


numberFilter.$inject = ['$locale'];
function numberFilter($locale) {
  var formats = $locale.NUMBER_FORMATS;
  return function(number, fractionSize) {

    // if null or undefined pass it through
    return (number == null)
        ? number
        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
                       fractionSize);
  };
}

var DECIMAL_SEP = '.';
function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {
  if (isObject(number)) return '';

  var isNegative = number < 0;
  number = Math.abs(number);

  var isInfinity = number === Infinity;
  if (!isInfinity && !isFinite(number)) return '';

  var numStr = number + '',
      formatedText = '',
      hasExponent = false,
      parts = [];

  if (isInfinity) formatedText = '\u221e';

  if (!isInfinity && numStr.indexOf('e') !== -1) {
    var match = numStr.match(/([\d\.]+)e(-?)(\d+)/);
    if (match && match[2] == '-' && match[3] > fractionSize + 1) {
      number = 0;
    } else {
      formatedText = numStr;
      hasExponent = true;
    }
  }

  if (!isInfinity && !hasExponent) {
    var fractionLen = (numStr.split(DECIMAL_SEP)[1] || '').length;

    // determine fractionSize if it is not specified
    if (isUndefined(fractionSize)) {
      fractionSize = Math.min(Math.max(pattern.minFrac, fractionLen), pattern.maxFrac);
    }

    // safely round numbers in JS without hitting imprecisions of floating-point arithmetics
    // inspired by:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/round
    number = +(Math.round(+(number.toString() + 'e' + fractionSize)).toString() + 'e' + -fractionSize);

    var fraction = ('' + number).split(DECIMAL_SEP);
    var whole = fraction[0];
    fraction = fraction[1] || '';

    var i, pos = 0,
        lgroup = pattern.lgSize,
        group = pattern.gSize;

    if (whole.length >= (lgroup + group)) {
      pos = whole.length - lgroup;
      for (i = 0; i < pos; i++) {
        if ((pos - i) % group === 0 && i !== 0) {
          formatedText += groupSep;
        }
        formatedText += whole.charAt(i);
      }
    }

    for (i = pos; i < whole.length; i++) {
      if ((whole.length - i) % lgroup === 0 && i !== 0) {
        formatedText += groupSep;
      }
      formatedText += whole.charAt(i);
    }

    // format fraction part.
    while (fraction.length < fractionSize) {
      fraction += '0';
    }

    if (fractionSize && fractionSize !== "0") formatedText += decimalSep + fraction.substr(0, fractionSize);
  } else {
    if (fractionSize > 0 && number < 1) {
      formatedText = number.toFixed(fractionSize);
      number = parseFloat(formatedText);
    }
  }

  if (number === 0) {
    isNegative = false;
  }

  parts.push(isNegative ? pattern.negPre : pattern.posPre,
             formatedText,
             isNegative ? pattern.negSuf : pattern.posSuf);
  return parts.join('');
}

function padNumber(num, digits, trim) {
  var neg = '';
  if (num < 0) {
    neg =  '-';
    num = -num;
  }
  num = '' + num;
  while (num.length < digits) num = '0' + num;
  if (trim) {
    num = num.substr(num.length - digits);
  }
  return neg + num;
}


function dateGetter(name, size, offset, trim) {
  offset = offset || 0;
  return function(date) {
    var value = date['get' + name]();
    if (offset > 0 || value > -offset) {
      value += offset;
    }
    if (value === 0 && offset == -12) value = 12;
    return padNumber(value, size, trim);
  };
}

function dateStrGetter(name, shortForm) {
  return function(date, formats) {
    var value = date['get' + name]();
    var get = uppercase(shortForm ? ('SHORT' + name) : name);

    return formats[get][value];
  };
}

function timeZoneGetter(date, formats, offset) {
  var zone = -1 * offset;
  var paddedZone = (zone >= 0) ? "+" : "";

  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
                padNumber(Math.abs(zone % 60), 2);

  return paddedZone;
}

function getFirstThursdayOfYear(year) {
    // 0 = index of January
    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
    // 4 = index of Thursday (+1 to account for 1st = 5)
    // 11 = index of *next* Thursday (+1 account for 1st = 12)
    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
}

function getThursdayThisWeek(datetime) {
    return new Date(datetime.getFullYear(), datetime.getMonth(),
      // 4 = index of Thursday
      datetime.getDate() + (4 - datetime.getDay()));
}

function weekGetter(size) {
   return function(date) {
      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
         thisThurs = getThursdayThisWeek(date);

      var diff = +thisThurs - +firstThurs,
         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week

      return padNumber(result, size);
   };
}

function ampmGetter(date, formats) {
  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
}

function eraGetter(date, formats) {
  return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
}

function longEraGetter(date, formats) {
  return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
}

var DATE_FORMATS = {
  yyyy: dateGetter('FullYear', 4),
    yy: dateGetter('FullYear', 2, 0, true),
     y: dateGetter('FullYear', 1),
  MMMM: dateStrGetter('Month'),
   MMM: dateStrGetter('Month', true),
    MM: dateGetter('Month', 2, 1),
     M: dateGetter('Month', 1, 1),
    dd: dateGetter('Date', 2),
     d: dateGetter('Date', 1),
    HH: dateGetter('Hours', 2),
     H: dateGetter('Hours', 1),
    hh: dateGetter('Hours', 2, -12),
     h: dateGetter('Hours', 1, -12),
    mm: dateGetter('Minutes', 2),
     m: dateGetter('Minutes', 1),
    ss: dateGetter('Seconds', 2),
     s: dateGetter('Seconds', 1),
     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
   sss: dateGetter('Milliseconds', 3),
  EEEE: dateStrGetter('Day'),
   EEE: dateStrGetter('Day', true),
     a: ampmGetter,
     Z: timeZoneGetter,
    ww: weekGetter(2),
     w: weekGetter(1),
     G: eraGetter,
     GG: eraGetter,
     GGG: eraGetter,
     GGGG: longEraGetter
};

var DATE_FORMATS_SPLIT = /((?:[^yMdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|d+|H+|h+|m+|s+|a|Z|G+|w+))(.*)/,
    NUMBER_STRING = /^\-?\d+$/;

/**
 * @ngdoc filter
 * @name date
 * @kind function
 *
 * @description
 *   Formats `date` to a string based on the requested `format`.
 *
 *   `format` string can be composed of the following elements:
 *
 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
 *   * `'MMMM'`: Month in year (January-December)
 *   * `'MMM'`: Month in year (Jan-Dec)
 *   * `'MM'`: Month in year, padded (01-12)
 *   * `'M'`: Month in year (1-12)
 *   * `'dd'`: Day in month, padded (01-31)
 *   * `'d'`: Day in month (1-31)
 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
 *   * `'EEE'`: Day in Week, (Sun-Sat)
 *   * `'HH'`: Hour in day, padded (00-23)
 *   * `'H'`: Hour in day (0-23)
 *   * `'hh'`: Hour in AM/PM, padded (01-12)
 *   * `'h'`: Hour in AM/PM, (1-12)
 *   * `'mm'`: Minute in hour, padded (00-59)
 *   * `'m'`: Minute in hour (0-59)
 *   * `'ss'`: Second in minute, padded (00-59)
 *   * `'s'`: Second in minute (0-59)
 *   * `'sss'`: Millisecond in second, padded (000-999)
 *   * `'a'`: AM/PM marker
 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
 *
 *   `format` string can also be one of the following predefined
 *   {@link guide/i18n localizable formats}:
 *
 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
 *     (e.g. Sep 3, 2010 12:05:08 PM)
 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
 *     (e.g. Friday, September 3, 2010)
 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
 *
 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
 *   (e.g. `"h 'o''clock'"`).
 *
 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
 *    specified in the string input, the time is considered to be in the local timezone.
 * @param {string=} format Formatting rules (see Description). If not specified,
 *    `mediumDate` is used.
 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
 *    If not specified, the timezone of the browser will be used.
 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
 *
 * @example
   <example>
     <file name="index.html">
       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
           <span>{{1288323623006 | date:'medium'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
     </file>
     <file name="protractor.js" type="protractor">
       it('should format date', function() {
         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
            toMatch(/2010\-10\-2\d \d{2}:\d{2}:\d{2} (\-|\+)?\d{4}/);
         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
       });
     </file>
   </example>
 */
dateFilter.$inject = ['$locale'];
function dateFilter($locale) {


  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
                     // 1        2       3         4          5          6          7          8  9     10      11
  function jsonStringToDate(string) {
    var match;
    if (match = string.match(R_ISO8601_STR)) {
      var date = new Date(0),
          tzHour = 0,
          tzMin  = 0,
          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
          timeSetter = match[8] ? date.setUTCHours : date.setHours;

      if (match[9]) {
        tzHour = toInt(match[9] + match[10]);
        tzMin = toInt(match[9] + match[11]);
      }
      dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
      var h = toInt(match[4] || 0) - tzHour;
      var m = toInt(match[5] || 0) - tzMin;
      var s = toInt(match[6] || 0);
      var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
      timeSetter.call(date, h, m, s, ms);
      return date;
    }
    return string;
  }


  return function(date, format, timezone) {
    var text = '',
        parts = [],
        fn, match;

    format = format || 'mediumDate';
    format = $locale.DATETIME_FORMATS[format] || format;
    if (isString(date)) {
      date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
    }

    if (isNumber(date)) {
      date = new Date(date);
    }

    if (!isDate(date) || !isFinite(date.getTime())) {
      return date;
    }

    while (format) {
      match = DATE_FORMATS_SPLIT.exec(format);
      if (match) {
        parts = concat(parts, match, 1);
        format = parts.pop();
      } else {
        parts.push(format);
        format = null;
      }
    }

    var dateTimezoneOffset = date.getTimezoneOffset();
    if (timezone) {
      dateTimezoneOffset = timezoneToOffset(timezone, date.getTimezoneOffset());
      date = convertTimezoneToLocal(date, timezone, true);
    }
    forEach(parts, function(value) {
      fn = DATE_FORMATS[value];
      text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
                 : value.replace(/(^'|'$)/g, '').replace(/''/g, "'");
    });

    return text;
  };
}


/**
 * @ngdoc filter
 * @name json
 * @kind function
 *
 * @description
 *   Allows you to convert a JavaScript object into JSON string.
 *
 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
 *   the binding is automatically converted to JSON.
 *
 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
 * @returns {string} JSON string.
 *
 *
 * @example
   <example>
     <file name="index.html">
       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
     </file>
     <file name="protractor.js" type="protractor">
       it('should jsonify filtered objects', function() {
         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n  "name": ?"value"\n}/);
         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n    "name": ?"value"\n}/);
       });
     </file>
   </example>
 *
 */
function jsonFilter() {
  return function(object, spacing) {
    if (isUndefined(spacing)) {
        spacing = 2;
    }
    return toJson(object, spacing);
  };
}


/**
 * @ngdoc filter
 * @name lowercase
 * @kind function
 * @description
 * Converts string to lowercase.
 * @see angular.lowercase
 */
var lowercaseFilter = valueFn(lowercase);


/**
 * @ngdoc filter
 * @name uppercase
 * @kind function
 * @description
 * Converts string to uppercase.
 * @see angular.uppercase
 */
var uppercaseFilter = valueFn(uppercase);

/**
 * @ngdoc filter
 * @name limitTo
 * @kind function
 *
 * @description
 * Creates a new array or string containing only a specified number of elements. The elements
 * are taken from either the beginning or the end of the source array, string or number, as specified by
 * the value and sign (positive or negative) of `limit`. If a number is used as input, it is
 * converted to a string.
 *
 * @param {Array|string|number} input Source array, string or number to be limited.
 * @param {string|number} limit The length of the returned array or string. If the `limit` number
 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
 *     If the number is negative, `limit` number  of items from the end of the source array/string
 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
 *     the input will be returned unchanged.
 * @param {(string|number)=} begin Index at which to begin limitation. As a negative index, `begin`
 *     indicates an offset from the end of `input`. Defaults to `0`.
 * @returns {Array|string} A new sub-array or substring of length `limit` or less if input array
 *     had less than `limit` elements.
 *
 * @example
   <example module="limitToExample">
     <file name="index.html">
       <script>
         angular.module('limitToExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.numbers = [1,2,3,4,5,6,7,8,9];
             $scope.letters = "abcdefghi";
             $scope.longNumber = 2345432342;
             $scope.numLimit = 3;
             $scope.letterLimit = 3;
             $scope.longNumberLimit = 3;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>
            Limit {{numbers}} to:
            <input type="number" step="1" ng-model="numLimit">
         </label>
         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
         <label>
            Limit {{letters}} to:
            <input type="number" step="1" ng-model="letterLimit">
         </label>
         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
         <label>
            Limit {{longNumber}} to:
            <input type="number" step="1" ng-model="longNumberLimit">
         </label>
         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       var numLimitInput = element(by.model('numLimit'));
       var letterLimitInput = element(by.model('letterLimit'));
       var longNumberLimitInput = element(by.model('longNumberLimit'));
       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));

       it('should limit the number array to first three items', function() {
         expect(numLimitInput.getAttribute('value')).toBe('3');
         expect(letterLimitInput.getAttribute('value')).toBe('3');
         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
         expect(limitedLetters.getText()).toEqual('Output letters: abc');
         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
       });

       // There is a bug in safari and protractor that doesn't like the minus key
       // it('should update the output when -3 is entered', function() {
       //   numLimitInput.clear();
       //   numLimitInput.sendKeys('-3');
       //   letterLimitInput.clear();
       //   letterLimitInput.sendKeys('-3');
       //   longNumberLimitInput.clear();
       //   longNumberLimitInput.sendKeys('-3');
       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
       // });

       it('should not exceed the maximum size of input array', function() {
         numLimitInput.clear();
         numLimitInput.sendKeys('100');
         letterLimitInput.clear();
         letterLimitInput.sendKeys('100');
         longNumberLimitInput.clear();
         longNumberLimitInput.sendKeys('100');
         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
       });
     </file>
   </example>
*/
function limitToFilter() {
  return function(input, limit, begin) {
    if (Math.abs(Number(limit)) === Infinity) {
      limit = Number(limit);
    } else {
      limit = toInt(limit);
    }
    if (isNaN(limit)) return input;

    if (isNumber(input)) input = input.toString();
    if (!isArray(input) && !isString(input)) return input;

    begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
    begin = (begin < 0 && begin >= -input.length) ? input.length + begin : begin;

    if (limit >= 0) {
      return input.slice(begin, begin + limit);
    } else {
      if (begin === 0) {
        return input.slice(limit, input.length);
      } else {
        return input.slice(Math.max(0, begin + limit), begin);
      }
    }
  };
}

/**
 * @ngdoc filter
 * @name orderBy
 * @kind function
 *
 * @description
 * Orders a specified `array` by the `expression` predicate. It is ordered alphabetically
 * for strings and numerically for numbers. Note: if you notice numbers are not being sorted
 * as expected, make sure they are actually being saved as numbers and not strings.
 *
 * @param {Array} array The array to sort.
 * @param {function(*)|string|Array.<(function(*)|string)>=} expression A predicate to be
 *    used by the comparator to determine the order of elements.
 *
 *    Can be one of:
 *
 *    - `function`: Getter function. The result of this function will be sorted using the
 *      `<`, `===`, `>` operator.
 *    - `string`: An Angular expression. The result of this expression is used to compare elements
 *      (for example `name` to sort by a property called `name` or `name.substr(0, 3)` to sort by
 *      3 first characters of a property called `name`). The result of a constant expression
 *      is interpreted as a property name to be used in comparisons (for example `"special name"`
 *      to sort object by the value of their `special name` property). An expression can be
 *      optionally prefixed with `+` or `-` to control ascending or descending sort order
 *      (for example, `+name` or `-name`). If no property is provided, (e.g. `'+'`) then the array
 *      element itself is used to compare where sorting.
 *    - `Array`: An array of function or string predicates. The first predicate in the array
 *      is used for sorting, but when two items are equivalent, the next predicate is used.
 *
 *    If the predicate is missing or empty then it defaults to `'+'`.
 *
 * @param {boolean=} reverse Reverse the order of the array.
 * @returns {Array} Sorted copy of the source array.
 *
 *
 * @example
 * The example below demonstrates a simple ngRepeat, where the data is sorted
 * by age in descending order (predicate is set to `'-age'`).
 * `reverse` is not set, which means it defaults to `false`.
   <example module="orderByExample">
     <file name="index.html">
       <script>
         angular.module('orderByExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.friends =
                 [{name:'John', phone:'555-1212', age:10},
                  {name:'Mary', phone:'555-9876', age:19},
                  {name:'Mike', phone:'555-4321', age:21},
                  {name:'Adam', phone:'555-5678', age:35},
                  {name:'Julie', phone:'555-8765', age:29}];
           }]);
       </script>
       <div ng-controller="ExampleController">
         <table class="friend">
           <tr>
             <th>Name</th>
             <th>Phone Number</th>
             <th>Age</th>
           </tr>
           <tr ng-repeat="friend in friends | orderBy:'-age'">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
   </example>
 *
 * The predicate and reverse parameters can be controlled dynamically through scope properties,
 * as shown in the next example.
 * @example
   <example module="orderByExample">
     <file name="index.html">
       <script>
         angular.module('orderByExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.friends =
                 [{name:'John', phone:'555-1212', age:10},
                  {name:'Mary', phone:'555-9876', age:19},
                  {name:'Mike', phone:'555-4321', age:21},
                  {name:'Adam', phone:'555-5678', age:35},
                  {name:'Julie', phone:'555-8765', age:29}];
             $scope.predicate = 'age';
             $scope.reverse = true;
             $scope.order = function(predicate) {
               $scope.reverse = ($scope.predicate === predicate) ? !$scope.reverse : false;
               $scope.predicate = predicate;
             };
           }]);
       </script>
       <style type="text/css">
         .sortorder:after {
           content: '\25b2';
         }
         .sortorder.reverse:after {
           content: '\25bc';
         }
       </style>
       <div ng-controller="ExampleController">
         <pre>Sorting predicate = {{predicate}}; reverse = {{reverse}}</pre>
         <hr/>
         [ <a href="" ng-click="predicate=''">unsorted</a> ]
         <table class="friend">
           <tr>
             <th>
               <a href="" ng-click="order('name')">Name</a>
               <span class="sortorder" ng-show="predicate === 'name'" ng-class="{reverse:reverse}"></span>
             </th>
             <th>
               <a href="" ng-click="order('phone')">Phone Number</a>
               <span class="sortorder" ng-show="predicate === 'phone'" ng-class="{reverse:reverse}"></span>
             </th>
             <th>
               <a href="" ng-click="order('age')">Age</a>
               <span class="sortorder" ng-show="predicate === 'age'" ng-class="{reverse:reverse}"></span>
             </th>
           </tr>
           <tr ng-repeat="friend in friends | orderBy:predicate:reverse">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
   </example>
 *
 * It's also possible to call the orderBy filter manually, by injecting `$filter`, retrieving the
 * filter routine with `$filter('orderBy')`, and calling the returned filter routine with the
 * desired parameters.
 *
 * Example:
 *
 * @example
  <example module="orderByExample">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <table class="friend">
          <tr>
            <th><a href="" ng-click="reverse=false;order('name', false)">Name</a>
              (<a href="" ng-click="order('-name',false)">^</a>)</th>
            <th><a href="" ng-click="reverse=!reverse;order('phone', reverse)">Phone Number</a></th>
            <th><a href="" ng-click="reverse=!reverse;order('age',reverse)">Age</a></th>
          </tr>
          <tr ng-repeat="friend in friends">
            <td>{{friend.name}}</td>
            <td>{{friend.phone}}</td>
            <td>{{friend.age}}</td>
          </tr>
        </table>
      </div>
    </file>

    <file name="script.js">
      angular.module('orderByExample', [])
        .controller('ExampleController', ['$scope', '$filter', function($scope, $filter) {
          var orderBy = $filter('orderBy');
          $scope.friends = [
            { name: 'John',    phone: '555-1212',    age: 10 },
            { name: 'Mary',    phone: '555-9876',    age: 19 },
            { name: 'Mike',    phone: '555-4321',    age: 21 },
            { name: 'Adam',    phone: '555-5678',    age: 35 },
            { name: 'Julie',   phone: '555-8765',    age: 29 }
          ];
          $scope.order = function(predicate, reverse) {
            $scope.friends = orderBy($scope.friends, predicate, reverse);
          };
          $scope.order('-age',false);
        }]);
    </file>
</example>
 */
orderByFilter.$inject = ['$parse'];
function orderByFilter($parse) {
  return function(array, sortPredicate, reverseOrder) {
    if (!(isArrayLike(array))) return array;
    sortPredicate = isArray(sortPredicate) ? sortPredicate : [sortPredicate];
    if (sortPredicate.length === 0) { sortPredicate = ['+']; }
    sortPredicate = sortPredicate.map(function(predicate) {
      var descending = false, get = predicate || identity;
      if (isString(predicate)) {
        if ((predicate.charAt(0) == '+' || predicate.charAt(0) == '-')) {
          descending = predicate.charAt(0) == '-';
          predicate = predicate.substring(1);
        }
        if (predicate === '') {
          // Effectively no predicate was passed so we compare identity
          return reverseComparator(compare, descending);
        }
        get = $parse(predicate);
        if (get.constant) {
          var key = get();
          return reverseComparator(function(a, b) {
            return compare(a[key], b[key]);
          }, descending);
        }
      }
      return reverseComparator(function(a, b) {
        return compare(get(a),get(b));
      }, descending);
    });
    return slice.call(array).sort(reverseComparator(comparator, reverseOrder));

    function comparator(o1, o2) {
      for (var i = 0; i < sortPredicate.length; i++) {
        var comp = sortPredicate[i](o1, o2);
        if (comp !== 0) return comp;
      }
      return 0;
    }
    function reverseComparator(comp, descending) {
      return descending
          ? function(a, b) {return comp(b,a);}
          : comp;
    }

    function isPrimitive(value) {
      switch (typeof value) {
        case 'number': /* falls through */
        case 'boolean': /* falls through */
        case 'string':
          return true;
        default:
          return false;
      }
    }

    function objectToString(value) {
      if (value === null) return 'null';
      if (typeof value.valueOf === 'function') {
        value = value.valueOf();
        if (isPrimitive(value)) return value;
      }
      if (typeof value.toString === 'function') {
        value = value.toString();
        if (isPrimitive(value)) return value;
      }
      return '';
    }

    function compare(v1, v2) {
      var t1 = typeof v1;
      var t2 = typeof v2;
      if (t1 === t2 && t1 === "object") {
        v1 = objectToString(v1);
        v2 = objectToString(v2);
      }
      if (t1 === t2) {
        if (t1 === "string") {
           v1 = v1.toLowerCase();
           v2 = v2.toLowerCase();
        }
        if (v1 === v2) return 0;
        return v1 < v2 ? -1 : 1;
      } else {
        return t1 < t2 ? -1 : 1;
      }
    }
  };
}

function ngDirective(directive) {
  if (isFunction(directive)) {
    directive = {
      link: directive
    };
  }
  directive.restrict = directive.restrict || 'AC';
  return valueFn(directive);
}

/**
 * @ngdoc directive
 * @name a
 * @restrict E
 *
 * @description
 * Modifies the default behavior of the html A tag so that the default action is prevented when
 * the href attribute is empty.
 *
 * This change permits the easy creation of action links with the `ngClick` directive
 * without changing the location or causing page reloads, e.g.:
 * `<a href="" ng-click="list.addItem()">Add Item</a>`
 */
var htmlAnchorDirective = valueFn({
  restrict: 'E',
  compile: function(element, attr) {
    if (!attr.href && !attr.xlinkHref) {
      return function(scope, element) {
        // If the linked element is not an anchor tag anymore, do nothing
        if (element[0].nodeName.toLowerCase() !== 'a') return;

        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
                   'xlink:href' : 'href';
        element.on('click', function(event) {
          // if we have no href url, then don't navigate anywhere.
          if (!element.attr(href)) {
            event.preventDefault();
          }
        });
      };
    }
  }
});

/**
 * @ngdoc directive
 * @name ngHref
 * @restrict A
 * @priority 99
 *
 * @description
 * Using Angular markup like `{{hash}}` in an href attribute will
 * make the link go to the wrong URL if the user clicks it before
 * Angular has a chance to replace the `{{hash}}` markup with its
 * value. Until Angular replaces the markup the link will be broken
 * and will most likely return a 404 error. The `ngHref` directive
 * solves this problem.
 *
 * The wrong way to write it:
 * ```html
 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
 * ```
 *
 * @element A
 * @param {template} ngHref any string which can contain `{{}}` markup.
 *
 * @example
 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
 * in links and their different behaviors:
    <example>
      <file name="index.html">
        <input ng-model="value" /><br />
        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
      </file>
      <file name="protractor.js" type="protractor">
        it('should execute ng-click but not reload when href without value', function() {
          element(by.id('link-1')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click but not reload when href empty string', function() {
          element(by.id('link-2')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click and change url when ng-href specified', function() {
          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);

          element(by.id('link-3')).click();

          // At this point, we navigate away from an Angular page, so we need
          // to use browser.driver to get the base webdriver.

          browser.wait(function() {
            return browser.driver.getCurrentUrl().then(function(url) {
              return url.match(/\/123$/);
            });
          }, 5000, 'page should navigate to /123');
        });

        it('should execute ng-click but not reload when href empty string and name specified', function() {
          element(by.id('link-4')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click but not reload when no href but name specified', function() {
          element(by.id('link-5')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
        });

        it('should only change url when only ng-href', function() {
          element(by.model('value')).clear();
          element(by.model('value')).sendKeys('6');
          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);

          element(by.id('link-6')).click();

          // At this point, we navigate away from an Angular page, so we need
          // to use browser.driver to get the base webdriver.
          browser.wait(function() {
            return browser.driver.getCurrentUrl().then(function(url) {
              return url.match(/\/6$/);
            });
          }, 5000, 'page should navigate to /6');
        });
      </file>
    </example>
 */

/**
 * @ngdoc directive
 * @name ngSrc
 * @restrict A
 * @priority 99
 *
 * @description
 * Using Angular markup like `{{hash}}` in a `src` attribute doesn't
 * work right: The browser will fetch from the URL with the literal
 * text `{{hash}}` until Angular replaces the expression inside
 * `{{hash}}`. The `ngSrc` directive solves this problem.
 *
 * The buggy way to write it:
 * ```html
 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
 * ```
 *
 * @element IMG
 * @param {template} ngSrc any string which can contain `{{}}` markup.
 */

/**
 * @ngdoc directive
 * @name ngSrcset
 * @restrict A
 * @priority 99
 *
 * @description
 * Using Angular markup like `{{hash}}` in a `srcset` attribute doesn't
 * work right: The browser will fetch from the URL with the literal
 * text `{{hash}}` until Angular replaces the expression inside
 * `{{hash}}`. The `ngSrcset` directive solves this problem.
 *
 * The buggy way to write it:
 * ```html
 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
 * ```
 *
 * @element IMG
 * @param {template} ngSrcset any string which can contain `{{}}` markup.
 */

/**
 * @ngdoc directive
 * @name ngDisabled
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * This directive sets the `disabled` attribute on the element if the
 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `disabled`
 * attribute.  The following example would make the button enabled on Chrome/Firefox
 * but not on older IEs:
 *
 * ```html
 * <!-- See below for an example of ng-disabled being used correctly -->
 * <div ng-init="isDisabled = false">
 *  <button disabled="{{isDisabled}}">Disabled</button>
 * </div>
 * ```
 *
 * This is because the HTML specification does not require browsers to preserve the values of
 * boolean attributes such as `disabled` (Their presence means true and their absence means false.)
 * If we put an Angular interpolation expression into such an attribute then the
 * binding information would be lost when the browser removes the attribute.
 *
 * @example
    <example>
      <file name="index.html">
        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
        <button ng-model="button" ng-disabled="checked">Button</button>
      </file>
      <file name="protractor.js" type="protractor">
        it('should toggle button', function() {
          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
          element(by.model('checked')).click();
          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
 *     then the `disabled` attribute will be set on the element
 */


/**
 * @ngdoc directive
 * @name ngChecked
 * @restrict A
 * @priority 100
 *
 * @description
 * The HTML specification does not require browsers to preserve the values of boolean attributes
 * such as checked. (Their presence means true and their absence means false.)
 * If we put an Angular interpolation expression into such an attribute then the
 * binding information would be lost when the browser removes the attribute.
 * The `ngChecked` directive solves this problem for the `checked` attribute.
 * This complementary directive is not removed by the browser and so provides
 * a permanent reliable place to store the binding information.
 * @example
    <example>
      <file name="index.html">
        <label>Check me to check both: <input type="checkbox" ng-model="master"></label><br/>
        <input id="checkSlave" type="checkbox" ng-checked="master" aria-label="Slave input">
      </file>
      <file name="protractor.js" type="protractor">
        it('should check both checkBoxes', function() {
          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeFalsy();
          element(by.model('master')).click();
          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
 *     then special attribute "checked" will be set on the element
 */


/**
 * @ngdoc directive
 * @name ngReadonly
 * @restrict A
 * @priority 100
 *
 * @description
 * The HTML specification does not require browsers to preserve the values of boolean attributes
 * such as readonly. (Their presence means true and their absence means false.)
 * If we put an Angular interpolation expression into such an attribute then the
 * binding information would be lost when the browser removes the attribute.
 * The `ngReadonly` directive solves this problem for the `readonly` attribute.
 * This complementary directive is not removed by the browser and so provides
 * a permanent reliable place to store the binding information.
 * @example
    <example>
      <file name="index.html">
        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
        <input type="text" ng-readonly="checked" value="I'm Angular" aria-label="Readonly field" />
      </file>
      <file name="protractor.js" type="protractor">
        it('should toggle readonly attr', function() {
          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
          element(by.model('checked')).click();
          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
 *     then special attribute "readonly" will be set on the element
 */


/**
 * @ngdoc directive
 * @name ngSelected
 * @restrict A
 * @priority 100
 *
 * @description
 * The HTML specification does not require browsers to preserve the values of boolean attributes
 * such as selected. (Their presence means true and their absence means false.)
 * If we put an Angular interpolation expression into such an attribute then the
 * binding information would be lost when the browser removes the attribute.
 * The `ngSelected` directive solves this problem for the `selected` attribute.
 * This complementary directive is not removed by the browser and so provides
 * a permanent reliable place to store the binding information.
 *
 * @example
    <example>
      <file name="index.html">
        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
        <select aria-label="ngSelected demo">
          <option>Hello!</option>
          <option id="greet" ng-selected="selected">Greetings!</option>
        </select>
      </file>
      <file name="protractor.js" type="protractor">
        it('should select Greetings!', function() {
          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
          element(by.model('selected')).click();
          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element OPTION
 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
 *     then special attribute "selected" will be set on the element
 */

/**
 * @ngdoc directive
 * @name ngOpen
 * @restrict A
 * @priority 100
 *
 * @description
 * The HTML specification does not require browsers to preserve the values of boolean attributes
 * such as open. (Their presence means true and their absence means false.)
 * If we put an Angular interpolation expression into such an attribute then the
 * binding information would be lost when the browser removes the attribute.
 * The `ngOpen` directive solves this problem for the `open` attribute.
 * This complementary directive is not removed by the browser and so provides
 * a permanent reliable place to store the binding information.
 * @example
     <example>
       <file name="index.html">
         <label>Check me check multiple: <input type="checkbox" ng-model="open"></label><br/>
         <details id="details" ng-open="open">
            <summary>Show/Hide me</summary>
         </details>
       </file>
       <file name="protractor.js" type="protractor">
         it('should toggle open', function() {
           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
           element(by.model('open')).click();
           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
         });
       </file>
     </example>
 *
 * @element DETAILS
 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
 *     then special attribute "open" will be set on the element
 */

var ngAttributeAliasDirectives = {};

// boolean attrs are evaluated
forEach(BOOLEAN_ATTR, function(propName, attrName) {
  // binding to multiple is not supported
  if (propName == "multiple") return;

  function defaultLinkFn(scope, element, attr) {
    scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
      attr.$set(attrName, !!value);
    });
  }

  var normalized = directiveNormalize('ng-' + attrName);
  var linkFn = defaultLinkFn;

  if (propName === 'checked') {
    linkFn = function(scope, element, attr) {
      // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
      if (attr.ngModel !== attr[normalized]) {
        defaultLinkFn(scope, element, attr);
      }
    };
  }

  ngAttributeAliasDirectives[normalized] = function() {
    return {
      restrict: 'A',
      priority: 100,
      link: linkFn
    };
  };
});

// aliased input attrs are evaluated
forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
  ngAttributeAliasDirectives[ngAttr] = function() {
    return {
      priority: 100,
      link: function(scope, element, attr) {
        //special case ngPattern when a literal regular expression value
        //is used as the expression (this way we don't have to watch anything).
        if (ngAttr === "ngPattern" && attr.ngPattern.charAt(0) == "/") {
          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
          if (match) {
            attr.$set("ngPattern", new RegExp(match[1], match[2]));
            return;
          }
        }

        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
          attr.$set(ngAttr, value);
        });
      }
    };
  };
});

// ng-src, ng-srcset, ng-href are interpolated
forEach(['src', 'srcset', 'href'], function(attrName) {
  var normalized = directiveNormalize('ng-' + attrName);
  ngAttributeAliasDirectives[normalized] = function() {
    return {
      priority: 99, // it needs to run after the attributes are interpolated
      link: function(scope, element, attr) {
        var propName = attrName,
            name = attrName;

        if (attrName === 'href' &&
            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
          name = 'xlinkHref';
          attr.$attr[name] = 'xlink:href';
          propName = null;
        }

        attr.$observe(normalized, function(value) {
          if (!value) {
            if (attrName === 'href') {
              attr.$set(name, null);
            }
            return;
          }

          attr.$set(name, value);

          // on IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
          // to set the property as well to achieve the desired effect.
          // we use attr[attrName] value since $set can sanitize the url.
          if (msie && propName) element.prop(propName, attr[name]);
        });
      }
    };
  };
});

/* global -nullFormCtrl, -SUBMITTED_CLASS, addSetValidityMethod: true
 */
var nullFormCtrl = {
  $addControl: noop,
  $$renameControl: nullFormRenameControl,
  $removeControl: noop,
  $setValidity: noop,
  $setDirty: noop,
  $setPristine: noop,
  $setSubmitted: noop
},
SUBMITTED_CLASS = 'ng-submitted';

function nullFormRenameControl(control, name) {
  control.$name = name;
}

/**
 * @ngdoc type
 * @name form.FormController
 *
 * @property {boolean} $pristine True if user has not interacted with the form yet.
 * @property {boolean} $dirty True if user has already interacted with the form.
 * @property {boolean} $valid True if all of the containing forms and controls are valid.
 * @property {boolean} $invalid True if at least one containing control or form is invalid.
 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
 *
 * @property {Object} $error Is an object hash, containing references to controls or
 *  forms with failing validators, where:
 *
 *  - keys are validation tokens (error names),
 *  - values are arrays of controls or forms that have a failing validator for given error name.
 *
 *  Built-in validation tokens:
 *
 *  - `email`
 *  - `max`
 *  - `maxlength`
 *  - `min`
 *  - `minlength`
 *  - `number`
 *  - `pattern`
 *  - `required`
 *  - `url`
 *  - `date`
 *  - `datetimelocal`
 *  - `time`
 *  - `week`
 *  - `month`
 *
 * @description
 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
 * such as being valid/invalid or dirty/pristine.
 *
 * Each {@link ng.directive:form form} directive creates an instance
 * of `FormController`.
 *
 */
//asks for $scope to fool the BC controller module
FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
function FormController(element, attrs, $scope, $animate, $interpolate) {
  var form = this,
      controls = [];

  var parentForm = form.$$parentForm = element.parent().controller('form') || nullFormCtrl;

  // init state
  form.$error = {};
  form.$$success = {};
  form.$pending = undefined;
  form.$name = $interpolate(attrs.name || attrs.ngForm || '')($scope);
  form.$dirty = false;
  form.$pristine = true;
  form.$valid = true;
  form.$invalid = false;
  form.$submitted = false;

  parentForm.$addControl(form);

  /**
   * @ngdoc method
   * @name form.FormController#$rollbackViewValue
   *
   * @description
   * Rollback all form controls pending updates to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. This method is typically needed by the reset button of
   * a form that uses `ng-model-options` to pend updates.
   */
  form.$rollbackViewValue = function() {
    forEach(controls, function(control) {
      control.$rollbackViewValue();
    });
  };

  /**
   * @ngdoc method
   * @name form.FormController#$commitViewValue
   *
   * @description
   * Commit all form controls pending updates to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
   * usually handles calling this in response to input events.
   */
  form.$commitViewValue = function() {
    forEach(controls, function(control) {
      control.$commitViewValue();
    });
  };

  /**
   * @ngdoc method
   * @name form.FormController#$addControl
   *
   * @description
   * Register a control with the form.
   *
   * Input elements using ngModelController do this automatically when they are linked.
   */
  form.$addControl = function(control) {
    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
    // and not added to the scope.  Now we throw an error.
    assertNotHasOwnProperty(control.$name, 'input');
    controls.push(control);

    if (control.$name) {
      form[control.$name] = control;
    }
  };

  // Private API: rename a form control
  form.$$renameControl = function(control, newName) {
    var oldName = control.$name;

    if (form[oldName] === control) {
      delete form[oldName];
    }
    form[newName] = control;
    control.$name = newName;
  };

  /**
   * @ngdoc method
   * @name form.FormController#$removeControl
   *
   * @description
   * Deregister a control from the form.
   *
   * Input elements using ngModelController do this automatically when they are destroyed.
   */
  form.$removeControl = function(control) {
    if (control.$name && form[control.$name] === control) {
      delete form[control.$name];
    }
    forEach(form.$pending, function(value, name) {
      form.$setValidity(name, null, control);
    });
    forEach(form.$error, function(value, name) {
      form.$setValidity(name, null, control);
    });
    forEach(form.$$success, function(value, name) {
      form.$setValidity(name, null, control);
    });

    arrayRemove(controls, control);
  };


  /**
   * @ngdoc method
   * @name form.FormController#$setValidity
   *
   * @description
   * Sets the validity of a form control.
   *
   * This method will also propagate to parent forms.
   */
  addSetValidityMethod({
    ctrl: this,
    $element: element,
    set: function(object, property, controller) {
      var list = object[property];
      if (!list) {
        object[property] = [controller];
      } else {
        var index = list.indexOf(controller);
        if (index === -1) {
          list.push(controller);
        }
      }
    },
    unset: function(object, property, controller) {
      var list = object[property];
      if (!list) {
        return;
      }
      arrayRemove(list, controller);
      if (list.length === 0) {
        delete object[property];
      }
    },
    parentForm: parentForm,
    $animate: $animate
  });

  /**
   * @ngdoc method
   * @name form.FormController#$setDirty
   *
   * @description
   * Sets the form to a dirty state.
   *
   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
   * state (ng-dirty class). This method will also propagate to parent forms.
   */
  form.$setDirty = function() {
    $animate.removeClass(element, PRISTINE_CLASS);
    $animate.addClass(element, DIRTY_CLASS);
    form.$dirty = true;
    form.$pristine = false;
    parentForm.$setDirty();
  };

  /**
   * @ngdoc method
   * @name form.FormController#$setPristine
   *
   * @description
   * Sets the form to its pristine state.
   *
   * This method can be called to remove the 'ng-dirty' class and set the form to its pristine
   * state (ng-pristine class). This method will also propagate to all the controls contained
   * in this form.
   *
   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
   * saving or resetting it.
   */
  form.$setPristine = function() {
    $animate.setClass(element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
    form.$dirty = false;
    form.$pristine = true;
    form.$submitted = false;
    forEach(controls, function(control) {
      control.$setPristine();
    });
  };

  /**
   * @ngdoc method
   * @name form.FormController#$setUntouched
   *
   * @description
   * Sets the form to its untouched state.
   *
   * This method can be called to remove the 'ng-touched' class and set the form controls to their
   * untouched state (ng-untouched class).
   *
   * Setting a form controls back to their untouched state is often useful when setting the form
   * back to its pristine state.
   */
  form.$setUntouched = function() {
    forEach(controls, function(control) {
      control.$setUntouched();
    });
  };

  /**
   * @ngdoc method
   * @name form.FormController#$setSubmitted
   *
   * @description
   * Sets the form to its submitted state.
   */
  form.$setSubmitted = function() {
    $animate.addClass(element, SUBMITTED_CLASS);
    form.$submitted = true;
    parentForm.$setSubmitted();
  };
}

/**
 * @ngdoc directive
 * @name ngForm
 * @restrict EAC
 *
 * @description
 * Nestable alias of {@link ng.directive:form `form`} directive. HTML
 * does not allow nesting of form elements. It is useful to nest forms, for example if the validity of a
 * sub-group of controls needs to be determined.
 *
 * Note: the purpose of `ngForm` is to group controls,
 * but not to be a replacement for the `<form>` tag with all of its capabilities
 * (e.g. posting to the server, ...).
 *
 * @param {string=} ngForm|name Name of the form. If specified, the form controller will be published into
 *                       related scope, under this name.
 *
 */

 /**
 * @ngdoc directive
 * @name form
 * @restrict E
 *
 * @description
 * Directive that instantiates
 * {@link form.FormController FormController}.
 *
 * If the `name` attribute is specified, the form controller is published onto the current scope under
 * this name.
 *
 * # Alias: {@link ng.directive:ngForm `ngForm`}
 *
 * In Angular, forms can be nested. This means that the outer form is valid when all of the child
 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
 * Angular provides the {@link ng.directive:ngForm `ngForm`} directive which behaves identically to
 * `<form>` but can be nested.  This allows you to have nested forms, which is very useful when
 * using Angular validation directives in forms that are dynamically generated using the
 * {@link ng.directive:ngRepeat `ngRepeat`} directive. Since you cannot dynamically generate the `name`
 * attribute of input elements using interpolation, you have to wrap each set of repeated inputs in an
 * `ngForm` directive and nest these in an outer `form` element.
 *
 *
 * # CSS classes
 *  - `ng-valid` is set if the form is valid.
 *  - `ng-invalid` is set if the form is invalid.
 *  - `ng-pristine` is set if the form is pristine.
 *  - `ng-dirty` is set if the form is dirty.
 *  - `ng-submitted` is set if the form was submitted.
 *
 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
 *
 *
 * # Submitting a form and preventing the default action
 *
 * Since the role of forms in client-side Angular applications is different than in classical
 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
 * page reload that sends the data to the server. Instead some javascript logic should be triggered
 * to handle the form submission in an application-specific way.
 *
 * For this reason, Angular prevents the default action (form submission to the server) unless the
 * `<form>` element has an `action` attribute specified.
 *
 * You can use one of the following two ways to specify what javascript method should be called when
 * a form is submitted:
 *
 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
 * - {@link ng.directive:ngClick ngClick} directive on the first
  *  button or input field of type submit (input[type=submit])
 *
 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
 * or {@link ng.directive:ngClick ngClick} directives.
 * This is because of the following form submission rules in the HTML specification:
 *
 * - If a form has only one input field then hitting enter in this field triggers form submit
 * (`ngSubmit`)
 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
 * doesn't trigger submit
 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
 *
 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
 * to have access to the updated model.
 *
 * ## Animation Hooks
 *
 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
 * other validations that are performed within the form. Animations in ngForm are similar to how
 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
 * as JS animations.
 *
 * The following example shows a simple way to utilize CSS transitions to style a form element
 * that has been rendered as invalid after it has been validated:
 *
 * <pre>
 * //be sure to include ngAnimate as a module to hook into more
 * //advanced animations
 * .my-form {
 *   transition:0.5s linear all;
 *   background: white;
 * }
 * .my-form.ng-invalid {
 *   background: red;
 *   color:white;
 * }
 * </pre>
 *
 * @example
    <example deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
      <file name="index.html">
       <script>
         angular.module('formExample', [])
           .controller('FormController', ['$scope', function($scope) {
             $scope.userType = 'guest';
           }]);
       </script>
       <style>
        .my-form {
          -webkit-transition:all linear 0.5s;
          transition:all linear 0.5s;
          background: transparent;
        }
        .my-form.ng-invalid {
          background: red;
        }
       </style>
       <form name="myForm" ng-controller="FormController" class="my-form">
         userType: <input name="input" ng-model="userType" required>
         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
         <code>userType = {{userType}}</code><br>
         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
         <code>myForm.$valid = {{myForm.$valid}}</code><br>
         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
        </form>
      </file>
      <file name="protractor.js" type="protractor">
        it('should initialize to model', function() {
          var userType = element(by.binding('userType'));
          var valid = element(by.binding('myForm.input.$valid'));

          expect(userType.getText()).toContain('guest');
          expect(valid.getText()).toContain('true');
        });

        it('should be invalid if empty', function() {
          var userType = element(by.binding('userType'));
          var valid = element(by.binding('myForm.input.$valid'));
          var userInput = element(by.model('userType'));

          userInput.clear();
          userInput.sendKeys('');

          expect(userType.getText()).toEqual('userType =');
          expect(valid.getText()).toContain('false');
        });
      </file>
    </example>
 *
 * @param {string=} name Name of the form. If specified, the form controller will be published into
 *                       related scope, under this name.
 */
var formDirectiveFactory = function(isNgForm) {
  return ['$timeout', function($timeout) {
    var formDirective = {
      name: 'form',
      restrict: isNgForm ? 'EAC' : 'E',
      controller: FormController,
      compile: function ngFormCompile(formElement, attr) {
        // Setup initial state of the control
        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);

        var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);

        return {
          pre: function ngFormPreLink(scope, formElement, attr, controller) {
            // if `action` attr is not present on the form, prevent the default action (submission)
            if (!('action' in attr)) {
              // we can't use jq events because if a form is destroyed during submission the default
              // action is not prevented. see #1238
              //
              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
              // page reload if the form was destroyed by submission of the form via a click handler
              // on a button in the form. Looks like an IE9 specific bug.
              var handleFormSubmission = function(event) {
                scope.$apply(function() {
                  controller.$commitViewValue();
                  controller.$setSubmitted();
                });

                event.preventDefault();
              };

              addEventListenerFn(formElement[0], 'submit', handleFormSubmission);

              // unregister the preventDefault listener so that we don't not leak memory but in a
              // way that will achieve the prevention of the default action.
              formElement.on('$destroy', function() {
                $timeout(function() {
                  removeEventListenerFn(formElement[0], 'submit', handleFormSubmission);
                }, 0, false);
              });
            }

            var parentFormCtrl = controller.$$parentForm;

            if (nameAttr) {
              setter(scope, controller.$name, controller, controller.$name);
              attr.$observe(nameAttr, function(newValue) {
                if (controller.$name === newValue) return;
                setter(scope, controller.$name, undefined, controller.$name);
                parentFormCtrl.$$renameControl(controller, newValue);
                setter(scope, controller.$name, controller, controller.$name);
              });
            }
            formElement.on('$destroy', function() {
              parentFormCtrl.$removeControl(controller);
              if (nameAttr) {
                setter(scope, attr[nameAttr], undefined, controller.$name);
              }
              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
            });
          }
        };
      }
    };

    return formDirective;
  }];
};

var formDirective = formDirectiveFactory();
var ngFormDirective = formDirectiveFactory(true);

/* global VALID_CLASS: false,
  INVALID_CLASS: false,
  PRISTINE_CLASS: false,
  DIRTY_CLASS: false,
  UNTOUCHED_CLASS: false,
  TOUCHED_CLASS: false,
  $ngModelMinErr: false,
*/

// Regex code is obtained from SO: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
var ISO_DATE_REGEXP = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/;
var URL_REGEXP = /^(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?$/;
var EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
var NUMBER_REGEXP = /^\s*(\-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
var DATE_REGEXP = /^(\d{4})-(\d{2})-(\d{2})$/;
var DATETIMELOCAL_REGEXP = /^(\d{4})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
var WEEK_REGEXP = /^(\d{4})-W(\d\d)$/;
var MONTH_REGEXP = /^(\d{4})-(\d\d)$/;
var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;

var inputType = {

  /**
   * @ngdoc input
   * @name input[text]
   *
   * @description
   * Standard HTML text input with angular data binding, inherited by most of the `input` elements.
   *
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Adds `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel value does not match
   *    a RegExp found by evaluating the Angular expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
   *    This parameter is ignored for input[type=password] controls, which will never trim the
   *    input.
   *
   * @example
      <example name="text-input-directive" module="textInputExample">
        <file name="index.html">
         <script>
           angular.module('textInputExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.example = {
                 text: 'guest',
                 word: /^\s*\w*\s*$/
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Single word:
             <input type="text" name="input" ng-model="example.text"
                    ng-pattern="example.word" required ng-trim="false">
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.pattern">
               Single word only!</span>
           </div>
           <tt>text = {{example.text}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('example.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('example.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('guest');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');

            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if multi word', function() {
            input.clear();
            input.sendKeys('hello world');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'text': textInputType,

    /**
     * @ngdoc input
     * @name input[date]
     *
     * @description
     * Input with date validation and transformation. In browsers that do not yet support
     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
     * modern browsers do not yet support this input type, it is important to provide cues to users on the
     * expected input format via a placeholder or label.
     *
     * The model must always be a Date object, otherwise Angular will throw an error.
     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
     *
     * The timezone to be used to read/write the `Date` instance in the model can be defined using
     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
     *
     * @param {string} ngModel Assignable angular expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
     * valid ISO date string (yyyy-MM-dd).
     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
     * a valid ISO date string (yyyy-MM-dd).
     * @param {string=} required Sets `required` validation error key if the value is not entered.
     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
     *    `required` when you want to data-bind to the `required` attribute.
     * @param {string=} ngChange Angular expression to be executed when input changes due to user
     *    interaction with the input element.
     *
     * @example
     <example name="date-input-directive" module="dateInputExample">
     <file name="index.html">
       <script>
          angular.module('dateInputExample', [])
            .controller('DateController', ['$scope', function($scope) {
              $scope.example = {
                value: new Date(2013, 9, 22)
              };
            }]);
       </script>
       <form name="myForm" ng-controller="DateController as dateCtrl">
          <label for="exampleInput">Pick a date in 2013:</label>
          <input type="date" id="exampleInput" name="input" ng-model="example.value"
              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
          <div role="alert">
            <span class="error" ng-show="myForm.input.$error.required">
                Required!</span>
            <span class="error" ng-show="myForm.input.$error.date">
                Not a valid date!</span>
           </div>
           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
       </form>
     </file>
     <file name="protractor.js" type="protractor">
        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
        var valid = element(by.binding('myForm.input.$valid'));
        var input = element(by.model('example.value'));

        // currently protractor/webdriver does not support
        // sending keys to all known HTML5 input controls
        // for various browsers (see https://github.com/angular/protractor/issues/562).
        function setInput(val) {
          // set the value of the element and force validation.
          var scr = "var ipt = document.getElementById('exampleInput'); " +
          "ipt.value = '" + val + "';" +
          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
          browser.executeScript(scr);
        }

        it('should initialize to model', function() {
          expect(value.getText()).toContain('2013-10-22');
          expect(valid.getText()).toContain('myForm.input.$valid = true');
        });

        it('should be invalid if empty', function() {
          setInput('');
          expect(value.getText()).toEqual('value =');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });

        it('should be invalid if over max', function() {
          setInput('2015-01-01');
          expect(value.getText()).toContain('');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });
     </file>
     </example>
     */
  'date': createDateInputType('date', DATE_REGEXP,
         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
         'yyyy-MM-dd'),

   /**
    * @ngdoc input
    * @name input[datetime-local]
    *
    * @description
    * Input with datetime validation and transformation. In browsers that do not yet support
    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
    *
    * The model must always be a Date object, otherwise Angular will throw an error.
    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
    *
    * The timezone to be used to read/write the `Date` instance in the model can be defined using
    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
    *
    * @param {string} ngModel Assignable angular expression to data-bind to.
    * @param {string=} name Property name of the form under which the control is published.
    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
    * valid ISO datetime format (yyyy-MM-ddTHH:mm:ss).
    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
    * a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss).
    * @param {string=} required Sets `required` validation error key if the value is not entered.
    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
    *    `required` when you want to data-bind to the `required` attribute.
    * @param {string=} ngChange Angular expression to be executed when input changes due to user
    *    interaction with the input element.
    *
    * @example
    <example name="datetimelocal-input-directive" module="dateExample">
    <file name="index.html">
      <script>
        angular.module('dateExample', [])
          .controller('DateController', ['$scope', function($scope) {
            $scope.example = {
              value: new Date(2010, 11, 28, 14, 57)
            };
          }]);
      </script>
      <form name="myForm" ng-controller="DateController as dateCtrl">
        <label for="exampleInput">Pick a date between in 2013:</label>
        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.datetimelocal">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
      var valid = element(by.binding('myForm.input.$valid'));
      var input = element(by.model('example.value'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2010-12-28T14:57:00');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-01-01T23:59:00');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
    </file>
    </example>
    */
  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
      'yyyy-MM-ddTHH:mm:ss.sss'),

  /**
   * @ngdoc input
   * @name input[time]
   *
   * @description
   * Input with time validation and transformation. In browsers that do not yet support
   * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
   *
   * The model must always be a Date object, otherwise Angular will throw an error.
   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
   *
   * The timezone to be used to read/write the `Date` instance in the model can be defined using
   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
   * valid ISO time format (HH:mm:ss).
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be a
   * valid ISO time format (HH:mm:ss).
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
   <example name="time-input-directive" module="timeExample">
   <file name="index.html">
     <script>
      angular.module('timeExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(1970, 0, 1, 14, 57, 0)
          };
        }]);
     </script>
     <form name="myForm" ng-controller="DateController as dateCtrl">
        <label for="exampleInput">Pick a between 8am and 5pm:</label>
        <input type="time" id="exampleInput" name="input" ng-model="example.value"
            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.time">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
     </form>
   </file>
   <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
      var valid = element(by.binding('myForm.input.$valid'));
      var input = element(by.model('example.value'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('14:57:00');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('23:59:00');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
   </file>
   </example>
   */
  'time': createDateInputType('time', TIME_REGEXP,
      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
     'HH:mm:ss.sss'),

   /**
    * @ngdoc input
    * @name input[week]
    *
    * @description
    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
    * week format (yyyy-W##), for example: `2013-W02`.
    *
    * The model must always be a Date object, otherwise Angular will throw an error.
    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
    *
    * The timezone to be used to read/write the `Date` instance in the model can be defined using
    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
    *
    * @param {string} ngModel Assignable angular expression to data-bind to.
    * @param {string=} name Property name of the form under which the control is published.
    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
    * valid ISO week format (yyyy-W##).
    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
    * a valid ISO week format (yyyy-W##).
    * @param {string=} required Sets `required` validation error key if the value is not entered.
    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
    *    `required` when you want to data-bind to the `required` attribute.
    * @param {string=} ngChange Angular expression to be executed when input changes due to user
    *    interaction with the input element.
    *
    * @example
    <example name="week-input-directive" module="weekExample">
    <file name="index.html">
      <script>
      angular.module('weekExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(2013, 0, 3)
          };
        }]);
      </script>
      <form name="myForm" ng-controller="DateController as dateCtrl">
        <label>Pick a date between in 2013:
          <input id="exampleInput" type="week" name="input" ng-model="example.value"
                 placeholder="YYYY-W##" min="2012-W32"
                 max="2013-W52" required />
        </label>
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.week">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-Www"'));
      var valid = element(by.binding('myForm.input.$valid'));
      var input = element(by.model('example.value'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2013-W01');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-W01');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
    </file>
    </example>
    */
  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),

  /**
   * @ngdoc input
   * @name input[month]
   *
   * @description
   * Input with month validation and transformation. In browsers that do not yet support
   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
   * month format (yyyy-MM), for example: `2009-01`.
   *
   * The model must always be a Date object, otherwise Angular will throw an error.
   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
   * If the model is not set to the first of the month, the next view to model update will set it
   * to the first of the month.
   *
   * The timezone to be used to read/write the `Date` instance in the model can be defined using
   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be
   * a valid ISO month format (yyyy-MM).
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must
   * be a valid ISO month format (yyyy-MM).
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
   <example name="month-input-directive" module="monthExample">
   <file name="index.html">
     <script>
      angular.module('monthExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(2013, 9, 1)
          };
        }]);
     </script>
     <form name="myForm" ng-controller="DateController as dateCtrl">
       <label for="exampleInput">Pick a month in 2013:</label>
       <input id="exampleInput" type="month" name="input" ng-model="example.value"
          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
       <div role="alert">
         <span class="error" ng-show="myForm.input.$error.required">
            Required!</span>
         <span class="error" ng-show="myForm.input.$error.month">
            Not a valid month!</span>
       </div>
       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
     </form>
   </file>
   <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-MM"'));
      var valid = element(by.binding('myForm.input.$valid'));
      var input = element(by.model('example.value'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2013-10');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-01');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
   </file>
   </example>
   */
  'month': createDateInputType('month', MONTH_REGEXP,
     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
     'yyyy-MM'),

  /**
   * @ngdoc input
   * @name input[number]
   *
   * @description
   * Text input with number validation and transformation. Sets the `number` validation
   * error if not a valid number.
   *
   * <div class="alert alert-warning">
   * The model must always be of type `number` otherwise Angular will throw an error.
   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
   * error docs for more information and an example of how to convert your model if necessary.
   * </div>
   *
   * ## Issues with HTML5 constraint validation
   *
   * In browsers that follow the
   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
   * If a non-number is entered in the input, the browser will report the value as an empty string,
   * which means the view / model values in `ngModel` and subsequently the scope value
   * will also be an empty string.
   *
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel value does not match
   *    a RegExp found by evaluating the Angular expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="number-input-directive" module="numberExample">
        <file name="index.html">
         <script>
           angular.module('numberExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.example = {
                 value: 12
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Number:
             <input type="number" name="input" ng-model="example.value"
                    min="0" max="99" required>
          </label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.number">
               Not valid number!</span>
           </div>
           <tt>value = {{example.value}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var value = element(by.binding('example.value'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('example.value'));

          it('should initialize to model', function() {
            expect(value.getText()).toContain('12');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');
            expect(value.getText()).toEqual('value =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if over max', function() {
            input.clear();
            input.sendKeys('123');
            expect(value.getText()).toEqual('value =');
            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'number': numberInputType,


  /**
   * @ngdoc input
   * @name input[url]
   *
   * @description
   * Text input with URL validation. Sets the `url` validation error key if the content is not a
   * valid URL.
   *
   * <div class="alert alert-warning">
   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
   * the built-in validators (see the {@link guide/forms Forms guide})
   * </div>
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel value does not match
   *    a RegExp found by evaluating the Angular expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="url-input-directive" module="urlExample">
        <file name="index.html">
         <script>
           angular.module('urlExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.url = {
                 text: 'http://google.com'
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>URL:
             <input type="url" name="input" ng-model="url.text" required>
           <label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.url">
               Not valid url!</span>
           </div>
           <tt>text = {{url.text}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('url.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('url.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('http://google.com');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');

            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if not url', function() {
            input.clear();
            input.sendKeys('box');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'url': urlInputType,


  /**
   * @ngdoc input
   * @name input[email]
   *
   * @description
   * Text input with email validation. Sets the `email` validation error key if not a valid email
   * address.
   *
   * <div class="alert alert-warning">
   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
   * used in Chromium. If you need stricter validation (e.g. requiring a top-level domain), you can
   * use `ng-pattern` or modify the built-in validators (see the {@link guide/forms Forms guide})
   * </div>
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel value does not match
   *    a RegExp found by evaluating the Angular expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="email-input-directive" module="emailExample">
        <file name="index.html">
         <script>
           angular.module('emailExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.email = {
                 text: 'me@example.com'
               };
             }]);
         </script>
           <form name="myForm" ng-controller="ExampleController">
             <label>Email:
               <input type="email" name="input" ng-model="email.text" required>
             </label>
             <div role="alert">
               <span class="error" ng-show="myForm.input.$error.required">
                 Required!</span>
               <span class="error" ng-show="myForm.input.$error.email">
                 Not valid email!</span>
             </div>
             <tt>text = {{email.text}}</tt><br/>
             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
           </form>
         </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('email.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('email.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('me@example.com');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');
            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if not email', function() {
            input.clear();
            input.sendKeys('xxx');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'email': emailInputType,


  /**
   * @ngdoc input
   * @name input[radio]
   *
   * @description
   * HTML radio button.
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string} value The value to which the expression should be set when selected.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   * @param {string} ngValue Angular expression which sets the value to which the expression should
   *    be set when selected.
   *
   * @example
      <example name="radio-input-directive" module="radioExample">
        <file name="index.html">
         <script>
           angular.module('radioExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.color = {
                 name: 'blue'
               };
               $scope.specialValue = {
                 "id": "12345",
                 "value": "green"
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>
             <input type="radio" ng-model="color.name" value="red">
             Red
           </label><br/>
           <label>
             <input type="radio" ng-model="color.name" ng-value="specialValue">
             Green
           </label><br/>
           <label>
             <input type="radio" ng-model="color.name" value="blue">
             Blue
           </label><br/>
           <tt>color = {{color.name | json}}</tt><br/>
          </form>
          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
        </file>
        <file name="protractor.js" type="protractor">
          it('should change state', function() {
            var color = element(by.binding('color.name'));

            expect(color.getText()).toContain('blue');

            element.all(by.model('color.name')).get(0).click();

            expect(color.getText()).toContain('red');
          });
        </file>
      </example>
   */
  'radio': radioInputType,


  /**
   * @ngdoc input
   * @name input[checkbox]
   *
   * @description
   * HTML checkbox.
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="checkbox-input-directive" module="checkboxExample">
        <file name="index.html">
         <script>
           angular.module('checkboxExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.checkboxModel = {
                value1 : true,
                value2 : 'YES'
              };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Value1:
             <input type="checkbox" ng-model="checkboxModel.value1">
           </label><br/>
           <label>Value2:
             <input type="checkbox" ng-model="checkboxModel.value2"
                    ng-true-value="'YES'" ng-false-value="'NO'">
            </label><br/>
           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          it('should change state', function() {
            var value1 = element(by.binding('checkboxModel.value1'));
            var value2 = element(by.binding('checkboxModel.value2'));

            expect(value1.getText()).toContain('true');
            expect(value2.getText()).toContain('YES');

            element(by.model('checkboxModel.value1')).click();
            element(by.model('checkboxModel.value2')).click();

            expect(value1.getText()).toContain('false');
            expect(value2.getText()).toContain('NO');
          });
        </file>
      </example>
   */
  'checkbox': checkboxInputType,

  'hidden': noop,
  'button': noop,
  'submit': noop,
  'reset': noop,
  'file': noop
};

function stringBasedInputType(ctrl) {
  ctrl.$formatters.push(function(value) {
    return ctrl.$isEmpty(value) ? value : value.toString();
  });
}

function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
  stringBasedInputType(ctrl);
}

function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  var type = lowercase(element[0].type);

  // In composition mode, users are still inputing intermediate text buffer,
  // hold the listener until composition is done.
  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
  if (!$sniffer.android) {
    var composing = false;

    element.on('compositionstart', function(data) {
      composing = true;
    });

    element.on('compositionend', function() {
      composing = false;
      listener();
    });
  }

  var listener = function(ev) {
    if (timeout) {
      $browser.defer.cancel(timeout);
      timeout = null;
    }
    if (composing) return;
    var value = element.val(),
        event = ev && ev.type;

    // By default we will trim the value
    // If the attribute ng-trim exists we will avoid trimming
    // If input type is 'password', the value is never trimmed
    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
      value = trim(value);
    }

    // If a control is suffering from bad input (due to native validators), browsers discard its
    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
    // control's value is the same empty value twice in a row.
    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
      ctrl.$setViewValue(value, event);
    }
  };

  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
  // input event on backspace, delete or cut
  if ($sniffer.hasEvent('input')) {
    element.on('input', listener);
  } else {
    var timeout;

    var deferListener = function(ev, input, origValue) {
      if (!timeout) {
        timeout = $browser.defer(function() {
          timeout = null;
          if (!input || input.value !== origValue) {
            listener(ev);
          }
        });
      }
    };

    element.on('keydown', function(event) {
      var key = event.keyCode;

      // ignore
      //    command            modifiers                   arrows
      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;

      deferListener(event, this, this.value);
    });

    // if user modifies input value using context menu in IE, we need "paste" and "cut" events to catch it
    if ($sniffer.hasEvent('paste')) {
      element.on('paste cut', deferListener);
    }
  }

  // if user paste into input using mouse on older browser
  // or form autocomplete on newer browser, we need "change" event to catch it
  element.on('change', listener);

  ctrl.$render = function() {
    element.val(ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue);
  };
}

function weekParser(isoWeek, existingDate) {
  if (isDate(isoWeek)) {
    return isoWeek;
  }

  if (isString(isoWeek)) {
    WEEK_REGEXP.lastIndex = 0;
    var parts = WEEK_REGEXP.exec(isoWeek);
    if (parts) {
      var year = +parts[1],
          week = +parts[2],
          hours = 0,
          minutes = 0,
          seconds = 0,
          milliseconds = 0,
          firstThurs = getFirstThursdayOfYear(year),
          addDays = (week - 1) * 7;

      if (existingDate) {
        hours = existingDate.getHours();
        minutes = existingDate.getMinutes();
        seconds = existingDate.getSeconds();
        milliseconds = existingDate.getMilliseconds();
      }

      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
    }
  }

  return NaN;
}

function createDateParser(regexp, mapping) {
  return function(iso, date) {
    var parts, map;

    if (isDate(iso)) {
      return iso;
    }

    if (isString(iso)) {
      // When a date is JSON'ified to wraps itself inside of an extra
      // set of double quotes. This makes the date parsing code unable
      // to match the date string and parse it as a date.
      if (iso.charAt(0) == '"' && iso.charAt(iso.length - 1) == '"') {
        iso = iso.substring(1, iso.length - 1);
      }
      if (ISO_DATE_REGEXP.test(iso)) {
        return new Date(iso);
      }
      regexp.lastIndex = 0;
      parts = regexp.exec(iso);

      if (parts) {
        parts.shift();
        if (date) {
          map = {
            yyyy: date.getFullYear(),
            MM: date.getMonth() + 1,
            dd: date.getDate(),
            HH: date.getHours(),
            mm: date.getMinutes(),
            ss: date.getSeconds(),
            sss: date.getMilliseconds() / 1000
          };
        } else {
          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
        }

        forEach(parts, function(part, index) {
          if (index < mapping.length) {
            map[mapping[index]] = +part;
          }
        });
        return new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
      }
    }

    return NaN;
  };
}

function createDateInputType(type, regexp, parseDate, format) {
  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter) {
    badInputChecker(scope, element, attr, ctrl);
    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
    var timezone = ctrl && ctrl.$options && ctrl.$options.timezone;
    var previousDate;

    ctrl.$$parserName = type;
    ctrl.$parsers.push(function(value) {
      if (ctrl.$isEmpty(value)) return null;
      if (regexp.test(value)) {
        // Note: We cannot read ctrl.$modelValue, as there might be a different
        // parser/formatter in the processing chain so that the model
        // contains some different data format!
        var parsedDate = parseDate(value, previousDate);
        if (timezone) {
          parsedDate = convertTimezoneToLocal(parsedDate, timezone);
        }
        return parsedDate;
      }
      return undefined;
    });

    ctrl.$formatters.push(function(value) {
      if (value && !isDate(value)) {
        throw $ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
      }
      if (isValidDate(value)) {
        previousDate = value;
        if (previousDate && timezone) {
          previousDate = convertTimezoneToLocal(previousDate, timezone, true);
        }
        return $filter('date')(value, format, timezone);
      } else {
        previousDate = null;
        return '';
      }
    });

    if (isDefined(attr.min) || attr.ngMin) {
      var minVal;
      ctrl.$validators.min = function(value) {
        return !isValidDate(value) || isUndefined(minVal) || parseDate(value) >= minVal;
      };
      attr.$observe('min', function(val) {
        minVal = parseObservedDateValue(val);
        ctrl.$validate();
      });
    }

    if (isDefined(attr.max) || attr.ngMax) {
      var maxVal;
      ctrl.$validators.max = function(value) {
        return !isValidDate(value) || isUndefined(maxVal) || parseDate(value) <= maxVal;
      };
      attr.$observe('max', function(val) {
        maxVal = parseObservedDateValue(val);
        ctrl.$validate();
      });
    }

    function isValidDate(value) {
      // Invalid Date: getTime() returns NaN
      return value && !(value.getTime && value.getTime() !== value.getTime());
    }

    function parseObservedDateValue(val) {
      return isDefined(val) ? (isDate(val) ? val : parseDate(val)) : undefined;
    }
  };
}

function badInputChecker(scope, element, attr, ctrl) {
  var node = element[0];
  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
  if (nativeValidation) {
    ctrl.$parsers.push(function(value) {
      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
      // Detect bug in FF35 for input[email] (https://bugzilla.mozilla.org/show_bug.cgi?id=1064430):
      // - also sets validity.badInput (should only be validity.typeMismatch).
      // - see http://www.whatwg.org/specs/web-apps/current-work/multipage/forms.html#e-mail-state-(type=email)
      // - can ignore this case as we can still read out the erroneous email...
      return validity.badInput && !validity.typeMismatch ? undefined : value;
    });
  }
}

function numberInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  badInputChecker(scope, element, attr, ctrl);
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);

  ctrl.$$parserName = 'number';
  ctrl.$parsers.push(function(value) {
    if (ctrl.$isEmpty(value))      return null;
    if (NUMBER_REGEXP.test(value)) return parseFloat(value);
    return undefined;
  });

  ctrl.$formatters.push(function(value) {
    if (!ctrl.$isEmpty(value)) {
      if (!isNumber(value)) {
        throw $ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
      }
      value = value.toString();
    }
    return value;
  });

  if (isDefined(attr.min) || attr.ngMin) {
    var minVal;
    ctrl.$validators.min = function(value) {
      return ctrl.$isEmpty(value) || isUndefined(minVal) || value >= minVal;
    };

    attr.$observe('min', function(val) {
      if (isDefined(val) && !isNumber(val)) {
        val = parseFloat(val, 10);
      }
      minVal = isNumber(val) && !isNaN(val) ? val : undefined;
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    });
  }

  if (isDefined(attr.max) || attr.ngMax) {
    var maxVal;
    ctrl.$validators.max = function(value) {
      return ctrl.$isEmpty(value) || isUndefined(maxVal) || value <= maxVal;
    };

    attr.$observe('max', function(val) {
      if (isDefined(val) && !isNumber(val)) {
        val = parseFloat(val, 10);
      }
      maxVal = isNumber(val) && !isNaN(val) ? val : undefined;
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    });
  }
}

function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  // Note: no badInputChecker here by purpose as `url` is only a validation
  // in browsers, i.e. we can always read out input.value even if it is not valid!
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
  stringBasedInputType(ctrl);

  ctrl.$$parserName = 'url';
  ctrl.$validators.url = function(modelValue, viewValue) {
    var value = modelValue || viewValue;
    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
  };
}

function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  // Note: no badInputChecker here by purpose as `url` is only a validation
  // in browsers, i.e. we can always read out input.value even if it is not valid!
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
  stringBasedInputType(ctrl);

  ctrl.$$parserName = 'email';
  ctrl.$validators.email = function(modelValue, viewValue) {
    var value = modelValue || viewValue;
    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
  };
}

function radioInputType(scope, element, attr, ctrl) {
  // make the name unique, if not defined
  if (isUndefined(attr.name)) {
    element.attr('name', nextUid());
  }

  var listener = function(ev) {
    if (element[0].checked) {
      ctrl.$setViewValue(attr.value, ev && ev.type);
    }
  };

  element.on('click', listener);

  ctrl.$render = function() {
    var value = attr.value;
    element[0].checked = (value == ctrl.$viewValue);
  };

  attr.$observe('value', ctrl.$render);
}

function parseConstantExpr($parse, context, name, expression, fallback) {
  var parseFn;
  if (isDefined(expression)) {
    parseFn = $parse(expression);
    if (!parseFn.constant) {
      throw minErr('ngModel')('constexpr', 'Expected constant expression for `{0}`, but saw ' +
                                   '`{1}`.', name, expression);
    }
    return parseFn(context);
  }
  return fallback;
}

function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);

  var listener = function(ev) {
    ctrl.$setViewValue(element[0].checked, ev && ev.type);
  };

  element.on('click', listener);

  ctrl.$render = function() {
    element[0].checked = ctrl.$viewValue;
  };

  // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
  // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
  // it to a boolean.
  ctrl.$isEmpty = function(value) {
    return value === false;
  };

  ctrl.$formatters.push(function(value) {
    return equals(value, trueValue);
  });

  ctrl.$parsers.push(function(value) {
    return value ? trueValue : falseValue;
  });
}


/**
 * @ngdoc directive
 * @name textarea
 * @restrict E
 *
 * @description
 * HTML textarea element control with angular data-binding. The data-binding and validation
 * properties of this element are exactly the same as those of the
 * {@link ng.directive:input input element}.
 *
 * @param {string} ngModel Assignable angular expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
 *    `required` when you want to data-bind to the `required` attribute.
 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
 *    minlength.
 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
 *    length.
 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel value does not match
 *    a RegExp found by evaluating the Angular expression given in the attribute value.
 *    If the expression evaluates to a RegExp object, then this is used directly.
 *    If the expression evaluates to a string, then it will be converted to a RegExp
 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
 *    `new RegExp('^abc$')`.<br />
 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 *    start at the index of the last search's match, thus not taking the whole input value into
 *    account.
 * @param {string=} ngChange Angular expression to be executed when input changes due to user
 *    interaction with the input element.
 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
 */


/**
 * @ngdoc directive
 * @name input
 * @restrict E
 *
 * @description
 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
 * input state control, and validation.
 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
 *
 * <div class="alert alert-warning">
 * **Note:** Not every feature offered is available for all input types.
 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
 * </div>
 *
 * @param {string} ngModel Assignable angular expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {boolean=} ngRequired Sets `required` attribute if set to true
 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
 *    minlength.
 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
 *    length.
 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel value does not match
 *    a RegExp found by evaluating the Angular expression given in the attribute value.
 *    If the expression evaluates to a RegExp object, then this is used directly.
 *    If the expression evaluates to a string, then it will be converted to a RegExp
 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
 *    `new RegExp('^abc$')`.<br />
 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 *    start at the index of the last search's match, thus not taking the whole input value into
 *    account.
 * @param {string=} ngChange Angular expression to be executed when input changes due to user
 *    interaction with the input element.
 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
 *    This parameter is ignored for input[type=password] controls, which will never trim the
 *    input.
 *
 * @example
    <example name="input-directive" module="inputExample">
      <file name="index.html">
       <script>
          angular.module('inputExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.user = {name: 'guest', last: 'visitor'};
            }]);
       </script>
       <div ng-controller="ExampleController">
         <form name="myForm">
           <label>
              User name:
              <input type="text" name="userName" ng-model="user.name" required>
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.userName.$error.required">
              Required!</span>
           </div>
           <label>
              Last name:
              <input type="text" name="lastName" ng-model="user.last"
              ng-minlength="3" ng-maxlength="10">
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.lastName.$error.minlength">
               Too short!</span>
             <span class="error" ng-show="myForm.lastName.$error.maxlength">
               Too long!</span>
           </div>
         </form>
         <hr>
         <tt>user = {{user}}</tt><br/>
         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
       </div>
      </file>
      <file name="protractor.js" type="protractor">
        var user = element(by.exactBinding('user'));
        var userNameValid = element(by.binding('myForm.userName.$valid'));
        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
        var lastNameError = element(by.binding('myForm.lastName.$error'));
        var formValid = element(by.binding('myForm.$valid'));
        var userNameInput = element(by.model('user.name'));
        var userLastInput = element(by.model('user.last'));

        it('should initialize to model', function() {
          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
          expect(userNameValid.getText()).toContain('true');
          expect(formValid.getText()).toContain('true');
        });

        it('should be invalid if empty when required', function() {
          userNameInput.clear();
          userNameInput.sendKeys('');

          expect(user.getText()).toContain('{"last":"visitor"}');
          expect(userNameValid.getText()).toContain('false');
          expect(formValid.getText()).toContain('false');
        });

        it('should be valid if empty when min length is set', function() {
          userLastInput.clear();
          userLastInput.sendKeys('');

          expect(user.getText()).toContain('{"name":"guest","last":""}');
          expect(lastNameValid.getText()).toContain('true');
          expect(formValid.getText()).toContain('true');
        });

        it('should be invalid if less than required min length', function() {
          userLastInput.clear();
          userLastInput.sendKeys('xx');

          expect(user.getText()).toContain('{"name":"guest"}');
          expect(lastNameValid.getText()).toContain('false');
          expect(lastNameError.getText()).toContain('minlength');
          expect(formValid.getText()).toContain('false');
        });

        it('should be invalid if longer than max length', function() {
          userLastInput.clear();
          userLastInput.sendKeys('some ridiculously long name');

          expect(user.getText()).toContain('{"name":"guest"}');
          expect(lastNameValid.getText()).toContain('false');
          expect(lastNameError.getText()).toContain('maxlength');
          expect(formValid.getText()).toContain('false');
        });
      </file>
    </example>
 */
var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
    function($browser, $sniffer, $filter, $parse) {
  return {
    restrict: 'E',
    require: ['?ngModel'],
    link: {
      pre: function(scope, element, attr, ctrls) {
        if (ctrls[0]) {
          (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
                                                              $browser, $filter, $parse);
        }
      }
    }
  };
}];



var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
/**
 * @ngdoc directive
 * @name ngValue
 *
 * @description
 * Binds the given expression to the value of `<option>` or {@link input[radio] `input[radio]`},
 * so that when the element is selected, the {@link ngModel `ngModel`} of that element is set to
 * the bound value.
 *
 * `ngValue` is useful when dynamically generating lists of radio buttons using
 * {@link ngRepeat `ngRepeat`}, as shown below.
 *
 * Likewise, `ngValue` can be used to generate `<option>` elements for
 * the {@link select `select`} element. In that case however, only strings are supported
 * for the `value `attribute, so the resulting `ngModel` will always be a string.
 * Support for `select` models with non-string values is available via `ngOptions`.
 *
 * @element input
 * @param {string=} ngValue angular expression, whose value will be bound to the `value` attribute
 *   of the `input` element
 *
 * @example
    <example name="ngValue-directive" module="valueExample">
      <file name="index.html">
       <script>
          angular.module('valueExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.names = ['pizza', 'unicorns', 'robots'];
              $scope.my = { favorite: 'unicorns' };
            }]);
       </script>
        <form ng-controller="ExampleController">
          <h2>Which is your favorite?</h2>
            <label ng-repeat="name in names" for="{{name}}">
              {{name}}
              <input type="radio"
                     ng-model="my.favorite"
                     ng-value="name"
                     id="{{name}}"
                     name="favorite">
            </label>
          <div>You chose {{my.favorite}}</div>
        </form>
      </file>
      <file name="protractor.js" type="protractor">
        var favorite = element(by.binding('my.favorite'));

        it('should initialize to model', function() {
          expect(favorite.getText()).toContain('unicorns');
        });
        it('should bind the values to the inputs', function() {
          element.all(by.model('my.favorite')).get(0).click();
          expect(favorite.getText()).toContain('pizza');
        });
      </file>
    </example>
 */
var ngValueDirective = function() {
  return {
    restrict: 'A',
    priority: 100,
    compile: function(tpl, tplAttr) {
      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
        return function ngValueConstantLink(scope, elm, attr) {
          attr.$set('value', scope.$eval(attr.ngValue));
        };
      } else {
        return function ngValueLink(scope, elm, attr) {
          scope.$watch(attr.ngValue, function valueWatchAction(value) {
            attr.$set('value', value);
          });
        };
      }
    }
  };
};

/**
 * @ngdoc directive
 * @name ngBind
 * @restrict AC
 *
 * @description
 * The `ngBind` attribute tells Angular to replace the text content of the specified HTML element
 * with the value of a given expression, and to update the text content when the value of that
 * expression changes.
 *
 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
 * `{{ expression }}` which is similar but less verbose.
 *
 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
 * displayed by the browser in its raw state before Angular compiles it. Since `ngBind` is an
 * element attribute, it makes the bindings invisible to the user while the page is loading.
 *
 * An alternative solution to this problem would be using the
 * {@link ng.directive:ngCloak ngCloak} directive.
 *
 *
 * @element ANY
 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
 *
 * @example
 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
   <example module="bindExample">
     <file name="index.html">
       <script>
         angular.module('bindExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.name = 'Whirled';
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>Enter name: <input type="text" ng-model="name"></label><br>
         Hello <span ng-bind="name"></span>!
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-bind', function() {
         var nameInput = element(by.model('name'));

         expect(element(by.binding('name')).getText()).toBe('Whirled');
         nameInput.clear();
         nameInput.sendKeys('world');
         expect(element(by.binding('name')).getText()).toBe('world');
       });
     </file>
   </example>
 */
var ngBindDirective = ['$compile', function($compile) {
  return {
    restrict: 'AC',
    compile: function ngBindCompile(templateElement) {
      $compile.$$addBindingClass(templateElement);
      return function ngBindLink(scope, element, attr) {
        $compile.$$addBindingInfo(element, attr.ngBind);
        element = element[0];
        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
          element.textContent = value === undefined ? '' : value;
        });
      };
    }
  };
}];


/**
 * @ngdoc directive
 * @name ngBindTemplate
 *
 * @description
 * The `ngBindTemplate` directive specifies that the element
 * text content should be replaced with the interpolation of the template
 * in the `ngBindTemplate` attribute.
 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
 * expressions. This directive is needed since some HTML elements
 * (such as TITLE and OPTION) cannot contain SPAN elements.
 *
 * @element ANY
 * @param {string} ngBindTemplate template of form
 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
 *
 * @example
 * Try it here: enter text in text box and watch the greeting change.
   <example module="bindExample">
     <file name="index.html">
       <script>
         angular.module('bindExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.salutation = 'Hello';
             $scope.name = 'World';
           }]);
       </script>
       <div ng-controller="ExampleController">
        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
        <label>Name: <input type="text" ng-model="name"></label><br>
        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-bind', function() {
         var salutationElem = element(by.binding('salutation'));
         var salutationInput = element(by.model('salutation'));
         var nameInput = element(by.model('name'));

         expect(salutationElem.getText()).toBe('Hello World!');

         salutationInput.clear();
         salutationInput.sendKeys('Greetings');
         nameInput.clear();
         nameInput.sendKeys('user');

         expect(salutationElem.getText()).toBe('Greetings user!');
       });
     </file>
   </example>
 */
var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
  return {
    compile: function ngBindTemplateCompile(templateElement) {
      $compile.$$addBindingClass(templateElement);
      return function ngBindTemplateLink(scope, element, attr) {
        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
        $compile.$$addBindingInfo(element, interpolateFn.expressions);
        element = element[0];
        attr.$observe('ngBindTemplate', function(value) {
          element.textContent = value === undefined ? '' : value;
        });
      };
    }
  };
}];


/**
 * @ngdoc directive
 * @name ngBindHtml
 *
 * @description
 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
 * ngSanitize} in your module's dependencies (not in core Angular). In order to use {@link ngSanitize}
 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
 *
 * You may also bypass sanitization for values you know are safe. To do so, bind to
 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
 *
 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
 * will have an exception (instead of an exploit.)
 *
 * @element ANY
 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
 *
 * @example

   <example module="bindHtmlExample" deps="angular-sanitize.js">
     <file name="index.html">
       <div ng-controller="ExampleController">
        <p ng-bind-html="myHTML"></p>
       </div>
     </file>

     <file name="script.js">
       angular.module('bindHtmlExample', ['ngSanitize'])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.myHTML =
              'I am an <code>HTML</code>string with ' +
              '<a href="#">links!</a> and other <em>stuff</em>';
         }]);
     </file>

     <file name="protractor.js" type="protractor">
       it('should check ng-bind-html', function() {
         expect(element(by.binding('myHTML')).getText()).toBe(
             'I am an HTMLstring with links! and other stuff');
       });
     </file>
   </example>
 */
var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
  return {
    restrict: 'A',
    compile: function ngBindHtmlCompile(tElement, tAttrs) {
      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function getStringValue(value) {
        return (value || '').toString();
      });
      $compile.$$addBindingClass(tElement);

      return function ngBindHtmlLink(scope, element, attr) {
        $compile.$$addBindingInfo(element, attr.ngBindHtml);

        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
          // we re-evaluate the expr because we want a TrustedValueHolderType
          // for $sce, not a string
          element.html($sce.getTrustedHtml(ngBindHtmlGetter(scope)) || '');
        });
      };
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngChange
 *
 * @description
 * Evaluate the given expression when the user changes the input.
 * The expression is evaluated immediately, unlike the JavaScript onchange event
 * which only triggers at the end of a change (usually, when the user leaves the
 * form element or presses the return key).
 *
 * The `ngChange` expression is only evaluated when a change in the input value causes
 * a new value to be committed to the model.
 *
 * It will not be evaluated:
 * * if the value returned from the `$parsers` transformation pipeline has not changed
 * * if the input has continued to be invalid since the model will stay `null`
 * * if the model is changed programmatically and not by a change to the input value
 *
 *
 * Note, this directive requires `ngModel` to be present.
 *
 * @element input
 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
 * in input value.
 *
 * @example
 * <example name="ngChange-directive" module="changeExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('changeExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.counter = 0;
 *           $scope.change = function() {
 *             $scope.counter++;
 *           };
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
 *       <label for="ng-change-example2">Confirmed</label><br />
 *       <tt>debug = {{confirmed}}</tt><br/>
 *       <tt>counter = {{counter}}</tt><br/>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var counter = element(by.binding('counter'));
 *     var debug = element(by.binding('confirmed'));
 *
 *     it('should evaluate the expression if changing from view', function() {
 *       expect(counter.getText()).toContain('0');
 *
 *       element(by.id('ng-change-example1')).click();
 *
 *       expect(counter.getText()).toContain('1');
 *       expect(debug.getText()).toContain('true');
 *     });
 *
 *     it('should not evaluate the expression if changing from model', function() {
 *       element(by.id('ng-change-example2')).click();

 *       expect(counter.getText()).toContain('0');
 *       expect(debug.getText()).toContain('true');
 *     });
 *   </file>
 * </example>
 */
var ngChangeDirective = valueFn({
  restrict: 'A',
  require: 'ngModel',
  link: function(scope, element, attr, ctrl) {
    ctrl.$viewChangeListeners.push(function() {
      scope.$eval(attr.ngChange);
    });
  }
});

function classDirective(name, selector) {
  name = 'ngClass' + name;
  return ['$animate', function($animate) {
    return {
      restrict: 'AC',
      link: function(scope, element, attr) {
        var oldVal;

        scope.$watch(attr[name], ngClassWatchAction, true);

        attr.$observe('class', function(value) {
          ngClassWatchAction(scope.$eval(attr[name]));
        });


        if (name !== 'ngClass') {
          scope.$watch('$index', function($index, old$index) {
            // jshint bitwise: false
            var mod = $index & 1;
            if (mod !== (old$index & 1)) {
              var classes = arrayClasses(scope.$eval(attr[name]));
              mod === selector ?
                addClasses(classes) :
                removeClasses(classes);
            }
          });
        }

        function addClasses(classes) {
          var newClasses = digestClassCounts(classes, 1);
          attr.$addClass(newClasses);
        }

        function removeClasses(classes) {
          var newClasses = digestClassCounts(classes, -1);
          attr.$removeClass(newClasses);
        }

        function digestClassCounts(classes, count) {
          // Use createMap() to prevent class assumptions involving property
          // names in Object.prototype
          var classCounts = element.data('$classCounts') || createMap();
          var classesToUpdate = [];
          forEach(classes, function(className) {
            if (count > 0 || classCounts[className]) {
              classCounts[className] = (classCounts[className] || 0) + count;
              if (classCounts[className] === +(count > 0)) {
                classesToUpdate.push(className);
              }
            }
          });
          element.data('$classCounts', classCounts);
          return classesToUpdate.join(' ');
        }

        function updateClasses(oldClasses, newClasses) {
          var toAdd = arrayDifference(newClasses, oldClasses);
          var toRemove = arrayDifference(oldClasses, newClasses);
          toAdd = digestClassCounts(toAdd, 1);
          toRemove = digestClassCounts(toRemove, -1);
          if (toAdd && toAdd.length) {
            $animate.addClass(element, toAdd);
          }
          if (toRemove && toRemove.length) {
            $animate.removeClass(element, toRemove);
          }
        }

        function ngClassWatchAction(newVal) {
          if (selector === true || scope.$index % 2 === selector) {
            var newClasses = arrayClasses(newVal || []);
            if (!oldVal) {
              addClasses(newClasses);
            } else if (!equals(newVal,oldVal)) {
              var oldClasses = arrayClasses(oldVal);
              updateClasses(oldClasses, newClasses);
            }
          }
          oldVal = shallowCopy(newVal);
        }
      }
    };

    function arrayDifference(tokens1, tokens2) {
      var values = [];

      outer:
      for (var i = 0; i < tokens1.length; i++) {
        var token = tokens1[i];
        for (var j = 0; j < tokens2.length; j++) {
          if (token == tokens2[j]) continue outer;
        }
        values.push(token);
      }
      return values;
    }

    function arrayClasses(classVal) {
      var classes = [];
      if (isArray(classVal)) {
        forEach(classVal, function(v) {
          classes = classes.concat(arrayClasses(v));
        });
        return classes;
      } else if (isString(classVal)) {
        return classVal.split(' ');
      } else if (isObject(classVal)) {
        forEach(classVal, function(v, k) {
          if (v) {
            classes = classes.concat(k.split(' '));
          }
        });
        return classes;
      }
      return classVal;
    }
  }];
}

/**
 * @ngdoc directive
 * @name ngClass
 * @restrict AC
 *
 * @description
 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
 * an expression that represents all classes to be added.
 *
 * The directive operates in three different ways, depending on which of three types the expression
 * evaluates to:
 *
 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
 * names.
 *
 * 2. If the expression evaluates to an object, then for each key-value pair of the
 * object with a truthy value the corresponding key is used as a class name.
 *
 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
 * to give you more control over what CSS classes appear. See the code below for an example of this.
 *
 *
 * The directive won't add duplicate classes if a particular class was already set.
 *
 * When the expression changes, the previously added classes are removed and only then are the
 * new classes added.
 *
 * @animations
 * **add** - happens just before the class is applied to the elements
 *
 * **remove** - happens just before the class is removed from the element
 *
 * @element ANY
 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
 *   of the evaluation can be a string representing space delimited class
 *   names, an array, or a map of class names to boolean values. In the case of a map, the
 *   names of the properties whose values are truthy will be added as css classes to the
 *   element.
 *
 * @example Example that demonstrates basic bindings via ngClass directive.
   <example>
     <file name="index.html">
       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
       <label>
          <input type="checkbox" ng-model="deleted">
          deleted (apply "strike" class)
       </label><br>
       <label>
          <input type="checkbox" ng-model="important">
          important (apply "bold" class)
       </label><br>
       <label>
          <input type="checkbox" ng-model="error">
          error (apply "has-error" class)
       </label>
       <hr>
       <p ng-class="style">Using String Syntax</p>
       <input type="text" ng-model="style"
              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
       <hr>
       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
       <input ng-model="style1"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
       <input ng-model="style2"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
       <input ng-model="style3"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
       <hr>
       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
     </file>
     <file name="style.css">
       .strike {
           text-decoration: line-through;
       }
       .bold {
           font-weight: bold;
       }
       .red {
           color: red;
       }
       .has-error {
           color: red;
           background-color: yellow;
       }
       .orange {
           color: orange;
       }
     </file>
     <file name="protractor.js" type="protractor">
       var ps = element.all(by.css('p'));

       it('should let you toggle the class', function() {

         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);

         element(by.model('important')).click();
         expect(ps.first().getAttribute('class')).toMatch(/bold/);

         element(by.model('error')).click();
         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
       });

       it('should let you toggle string example', function() {
         expect(ps.get(1).getAttribute('class')).toBe('');
         element(by.model('style')).clear();
         element(by.model('style')).sendKeys('red');
         expect(ps.get(1).getAttribute('class')).toBe('red');
       });

       it('array example should have 3 classes', function() {
         expect(ps.get(2).getAttribute('class')).toBe('');
         element(by.model('style1')).sendKeys('bold');
         element(by.model('style2')).sendKeys('strike');
         element(by.model('style3')).sendKeys('red');
         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
       });

       it('array with map example should have 2 classes', function() {
         expect(ps.last().getAttribute('class')).toBe('');
         element(by.model('style4')).sendKeys('bold');
         element(by.model('warning')).click();
         expect(ps.last().getAttribute('class')).toBe('bold orange');
       });
     </file>
   </example>

   ## Animations

   The example below demonstrates how to perform animations using ngClass.

   <example module="ngAnimate" deps="angular-animate.js" animations="true">
     <file name="index.html">
      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
      <br>
      <span class="base-class" ng-class="myVar">Sample Text</span>
     </file>
     <file name="style.css">
       .base-class {
         -webkit-transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
       }

       .base-class.my-class {
         color: red;
         font-size:3em;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class', function() {
         expect(element(by.css('.base-class')).getAttribute('class')).not.
           toMatch(/my-class/);

         element(by.id('setbtn')).click();

         expect(element(by.css('.base-class')).getAttribute('class')).
           toMatch(/my-class/);

         element(by.id('clearbtn')).click();

         expect(element(by.css('.base-class')).getAttribute('class')).not.
           toMatch(/my-class/);
       });
     </file>
   </example>


   ## ngClass and pre-existing CSS3 Transitions/Animations
   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
   to view the step by step details of {@link $animate#addClass $animate.addClass} and
   {@link $animate#removeClass $animate.removeClass}.
 */
var ngClassDirective = classDirective('', true);

/**
 * @ngdoc directive
 * @name ngClassOdd
 * @restrict AC
 *
 * @description
 * The `ngClassOdd` and `ngClassEven` directives work exactly as
 * {@link ng.directive:ngClass ngClass}, except they work in
 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
 *
 * This directive can be applied only within the scope of an
 * {@link ng.directive:ngRepeat ngRepeat}.
 *
 * @element ANY
 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
 *   of the evaluation can be a string representing space delimited class names or an array.
 *
 * @example
   <example>
     <file name="index.html">
        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
          <li ng-repeat="name in names">
           <span ng-class-odd="'odd'" ng-class-even="'even'">
             {{name}}
           </span>
          </li>
        </ol>
     </file>
     <file name="style.css">
       .odd {
         color: red;
       }
       .even {
         color: blue;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class-odd and ng-class-even', function() {
         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
           toMatch(/odd/);
         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
           toMatch(/even/);
       });
     </file>
   </example>
 */
var ngClassOddDirective = classDirective('Odd', 0);

/**
 * @ngdoc directive
 * @name ngClassEven
 * @restrict AC
 *
 * @description
 * The `ngClassOdd` and `ngClassEven` directives work exactly as
 * {@link ng.directive:ngClass ngClass}, except they work in
 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
 *
 * This directive can be applied only within the scope of an
 * {@link ng.directive:ngRepeat ngRepeat}.
 *
 * @element ANY
 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
 *   result of the evaluation can be a string representing space delimited class names or an array.
 *
 * @example
   <example>
     <file name="index.html">
        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
          <li ng-repeat="name in names">
           <span ng-class-odd="'odd'" ng-class-even="'even'">
             {{name}} &nbsp; &nbsp; &nbsp;
           </span>
          </li>
        </ol>
     </file>
     <file name="style.css">
       .odd {
         color: red;
       }
       .even {
         color: blue;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class-odd and ng-class-even', function() {
         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
           toMatch(/odd/);
         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
           toMatch(/even/);
       });
     </file>
   </example>
 */
var ngClassEvenDirective = classDirective('Even', 1);

/**
 * @ngdoc directive
 * @name ngCloak
 * @restrict AC
 *
 * @description
 * The `ngCloak` directive is used to prevent the Angular html template from being briefly
 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
 * directive to avoid the undesirable flicker effect caused by the html template display.
 *
 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
 * of the browser view.
 *
 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
 * `angular.min.js`.
 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
 *
 * ```css
 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
 *   display: none !important;
 * }
 * ```
 *
 * When this css rule is loaded by the browser, all html elements (including their children) that
 * are tagged with the `ngCloak` directive are hidden. When Angular encounters this directive
 * during the compilation of the template it deletes the `ngCloak` element attribute, making
 * the compiled element visible.
 *
 * For the best result, the `angular.js` script must be loaded in the head section of the html
 * document; alternatively, the css rule above must be included in the external stylesheet of the
 * application.
 *
 * @element ANY
 *
 * @example
   <example>
     <file name="index.html">
        <div id="template1" ng-cloak>{{ 'hello' }}</div>
        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should remove the template directive and css class', function() {
         expect($('#template1').getAttribute('ng-cloak')).
           toBeNull();
         expect($('#template2').getAttribute('ng-cloak')).
           toBeNull();
       });
     </file>
   </example>
 *
 */
var ngCloakDirective = ngDirective({
  compile: function(element, attr) {
    attr.$set('ngCloak', undefined);
    element.removeClass('ng-cloak');
  }
});

/**
 * @ngdoc directive
 * @name ngController
 *
 * @description
 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
 * supports the principles behind the Model-View-Controller design pattern.
 *
 * MVC components in angular:
 *
 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
 *   are accessed through bindings.
 * * View — The template (HTML with data bindings) that is rendered into the View.
 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
 *   logic behind the application to decorate the scope with functions and values
 *
 * Note that you can also attach controllers to the DOM by declaring it in a route definition
 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
 * and executed twice.
 *
 * @element ANY
 * @scope
 * @priority 500
 * @param {expression} ngController Name of a constructor function registered with the current
 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
 * that on the current scope evaluates to a constructor function.
 *
 * The controller instance can be published into a scope property by specifying
 * `ng-controller="as propertyName"`.
 *
 * If the current `$controllerProvider` is configured to use globals (via
 * {@link ng.$controllerProvider#allowGlobals `$controllerProvider.allowGlobals()` }), this may
 * also be the name of a globally accessible constructor function (not recommended).
 *
 * @example
 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
 * greeting are methods declared on the controller (see source tab). These methods can
 * easily be called from the angular markup. Any changes to the data are automatically reflected
 * in the View without the need for a manual update.
 *
 * Two different declaration styles are included below:
 *
 * * one binds methods and properties directly onto the controller using `this`:
 * `ng-controller="SettingsController1 as settings"`
 * * one injects `$scope` into the controller:
 * `ng-controller="SettingsController2"`
 *
 * The second option is more common in the Angular community, and is generally used in boilerplates
 * and in this guide. However, there are advantages to binding properties directly to the controller
 * and avoiding scope.
 *
 * * Using `controller as` makes it obvious which controller you are accessing in the template when
 * multiple controllers apply to an element.
 * * If you are writing your controllers as classes you have easier access to the properties and
 * methods, which will appear on the scope, from inside the controller code.
 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
 * inheritance masking primitives.
 *
 * This example demonstrates the `controller as` syntax.
 *
 * <example name="ngControllerAs" module="controllerAsExample">
 *   <file name="index.html">
 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
 *      <button ng-click="settings.greet()">greet</button><br/>
 *      Contact:
 *      <ul>
 *        <li ng-repeat="contact in settings.contacts">
 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
 *             <option>phone</option>
 *             <option>email</option>
 *          </select>
 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
 *          <button ng-click="settings.clearContact(contact)">clear</button>
 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
 *        </li>
 *        <li><button ng-click="settings.addContact()">add</button></li>
 *     </ul>
 *    </div>
 *   </file>
 *   <file name="app.js">
 *    angular.module('controllerAsExample', [])
 *      .controller('SettingsController1', SettingsController1);
 *
 *    function SettingsController1() {
 *      this.name = "John Smith";
 *      this.contacts = [
 *        {type: 'phone', value: '408 555 1212'},
 *        {type: 'email', value: 'john.smith@example.org'} ];
 *    }
 *
 *    SettingsController1.prototype.greet = function() {
 *      alert(this.name);
 *    };
 *
 *    SettingsController1.prototype.addContact = function() {
 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
 *    };
 *
 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
 *     var index = this.contacts.indexOf(contactToRemove);
 *      this.contacts.splice(index, 1);
 *    };
 *
 *    SettingsController1.prototype.clearContact = function(contact) {
 *      contact.type = 'phone';
 *      contact.value = '';
 *    };
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it('should check controller as', function() {
 *       var container = element(by.id('ctrl-as-exmpl'));
 *         expect(container.element(by.model('settings.name'))
 *           .getAttribute('value')).toBe('John Smith');
 *
 *       var firstRepeat =
 *           container.element(by.repeater('contact in settings.contacts').row(0));
 *       var secondRepeat =
 *           container.element(by.repeater('contact in settings.contacts').row(1));
 *
 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('408 555 1212');
 *
 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('john.smith@example.org');
 *
 *       firstRepeat.element(by.buttonText('clear')).click();
 *
 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('');
 *
 *       container.element(by.buttonText('add')).click();
 *
 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
 *           .element(by.model('contact.value'))
 *           .getAttribute('value'))
 *           .toBe('yourname@example.org');
 *     });
 *   </file>
 * </example>
 *
 * This example demonstrates the "attach to `$scope`" style of controller.
 *
 * <example name="ngController" module="controllerExample">
 *  <file name="index.html">
 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
 *     <label>Name: <input type="text" ng-model="name"/></label>
 *     <button ng-click="greet()">greet</button><br/>
 *     Contact:
 *     <ul>
 *       <li ng-repeat="contact in contacts">
 *         <select ng-model="contact.type" id="select_{{$index}}">
 *            <option>phone</option>
 *            <option>email</option>
 *         </select>
 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
 *         <button ng-click="clearContact(contact)">clear</button>
 *         <button ng-click="removeContact(contact)">X</button>
 *       </li>
 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
 *    </ul>
 *   </div>
 *  </file>
 *  <file name="app.js">
 *   angular.module('controllerExample', [])
 *     .controller('SettingsController2', ['$scope', SettingsController2]);
 *
 *   function SettingsController2($scope) {
 *     $scope.name = "John Smith";
 *     $scope.contacts = [
 *       {type:'phone', value:'408 555 1212'},
 *       {type:'email', value:'john.smith@example.org'} ];
 *
 *     $scope.greet = function() {
 *       alert($scope.name);
 *     };
 *
 *     $scope.addContact = function() {
 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
 *     };
 *
 *     $scope.removeContact = function(contactToRemove) {
 *       var index = $scope.contacts.indexOf(contactToRemove);
 *       $scope.contacts.splice(index, 1);
 *     };
 *
 *     $scope.clearContact = function(contact) {
 *       contact.type = 'phone';
 *       contact.value = '';
 *     };
 *   }
 *  </file>
 *  <file name="protractor.js" type="protractor">
 *    it('should check controller', function() {
 *      var container = element(by.id('ctrl-exmpl'));
 *
 *      expect(container.element(by.model('name'))
 *          .getAttribute('value')).toBe('John Smith');
 *
 *      var firstRepeat =
 *          container.element(by.repeater('contact in contacts').row(0));
 *      var secondRepeat =
 *          container.element(by.repeater('contact in contacts').row(1));
 *
 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('408 555 1212');
 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('john.smith@example.org');
 *
 *      firstRepeat.element(by.buttonText('clear')).click();
 *
 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('');
 *
 *      container.element(by.buttonText('add')).click();
 *
 *      expect(container.element(by.repeater('contact in contacts').row(2))
 *          .element(by.model('contact.value'))
 *          .getAttribute('value'))
 *          .toBe('yourname@example.org');
 *    });
 *  </file>
 *</example>

 */
var ngControllerDirective = [function() {
  return {
    restrict: 'A',
    scope: true,
    controller: '@',
    priority: 500
  };
}];

/**
 * @ngdoc directive
 * @name ngCsp
 *
 * @element html
 * @description
 * Enables [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) support.
 *
 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
 *
 * CSP forbids apps to use `eval` or `Function(string)` generated functions (among other things).
 * For Angular to be CSP compatible there are only two things that we need to do differently:
 *
 * - don't use `Function` constructor to generate optimized value getters
 * - don't inject custom stylesheet into the document
 *
 * AngularJS uses `Function(string)` generated functions as a speed optimization. Applying the `ngCsp`
 * directive will cause Angular to use CSP compatibility mode. When this mode is on AngularJS will
 * evaluate all expressions up to 30% slower than in non-CSP mode, but no security violations will
 * be raised.
 *
 * CSP forbids JavaScript to inline stylesheet rules. In non CSP mode Angular automatically
 * includes some CSS rules (e.g. {@link ng.directive:ngCloak ngCloak}).
 * To make those directives work in CSP mode, include the `angular-csp.css` manually.
 *
 * Angular tries to autodetect if CSP is active and automatically turn on the CSP-safe mode. This
 * autodetection however triggers a CSP error to be logged in the console:
 *
 * ```
 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
 * script in the following Content Security Policy directive: "default-src 'self'". Note that
 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
 * ```
 *
 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
 * directive on the root element of the application or on the `angular.js` script tag, whichever
 * appears first in the html document.
 *
 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
 *
 * @example
 * This example shows how to apply the `ngCsp` directive to the `html` tag.
   ```html
     <!doctype html>
     <html ng-app ng-csp>
     ...
     ...
     </html>
   ```
  * @example
      // Note: the suffix `.csp` in the example name triggers
      // csp mode in our http server!
      <example name="example.csp" module="cspExample" ng-csp="true">
        <file name="index.html">
          <div ng-controller="MainController as ctrl">
            <div>
              <button ng-click="ctrl.inc()" id="inc">Increment</button>
              <span id="counter">
                {{ctrl.counter}}
              </span>
            </div>

            <div>
              <button ng-click="ctrl.evil()" id="evil">Evil</button>
              <span id="evilError">
                {{ctrl.evilError}}
              </span>
            </div>
          </div>
        </file>
        <file name="script.js">
           angular.module('cspExample', [])
             .controller('MainController', function() {
                this.counter = 0;
                this.inc = function() {
                  this.counter++;
                };
                this.evil = function() {
                  // jshint evil:true
                  try {
                    eval('1+2');
                  } catch (e) {
                    this.evilError = e.message;
                  }
                };
              });
        </file>
        <file name="protractor.js" type="protractor">
          var util, webdriver;

          var incBtn = element(by.id('inc'));
          var counter = element(by.id('counter'));
          var evilBtn = element(by.id('evil'));
          var evilError = element(by.id('evilError'));

          function getAndClearSevereErrors() {
            return browser.manage().logs().get('browser').then(function(browserLog) {
              return browserLog.filter(function(logEntry) {
                return logEntry.level.value > webdriver.logging.Level.WARNING.value;
              });
            });
          }

          function clearErrors() {
            getAndClearSevereErrors();
          }

          function expectNoErrors() {
            getAndClearSevereErrors().then(function(filteredLog) {
              expect(filteredLog.length).toEqual(0);
              if (filteredLog.length) {
                console.log('browser console errors: ' + util.inspect(filteredLog));
              }
            });
          }

          function expectError(regex) {
            getAndClearSevereErrors().then(function(filteredLog) {
              var found = false;
              filteredLog.forEach(function(log) {
                if (log.message.match(regex)) {
                  found = true;
                }
              });
              if (!found) {
                throw new Error('expected an error that matches ' + regex);
              }
            });
          }

          beforeEach(function() {
            util = require('util');
            webdriver = require('protractor/node_modules/selenium-webdriver');
          });

          // For now, we only test on Chrome,
          // as Safari does not load the page with Protractor's injected scripts,
          // and Firefox webdriver always disables content security policy (#6358)
          if (browser.params.browser !== 'chrome') {
            return;
          }

          it('should not report errors when the page is loaded', function() {
            // clear errors so we are not dependent on previous tests
            clearErrors();
            // Need to reload the page as the page is already loaded when
            // we come here
            browser.driver.getCurrentUrl().then(function(url) {
              browser.get(url);
            });
            expectNoErrors();
          });

          it('should evaluate expressions', function() {
            expect(counter.getText()).toEqual('0');
            incBtn.click();
            expect(counter.getText()).toEqual('1');
            expectNoErrors();
          });

          it('should throw and report an error when using "eval"', function() {
            evilBtn.click();
            expect(evilError.getText()).toMatch(/Content Security Policy/);
            expectError(/Content Security Policy/);
          });
        </file>
      </example>
  */

// ngCsp is not implemented as a proper directive any more, because we need it be processed while we
// bootstrap the system (before $parse is instantiated), for this reason we just have
// the csp.isActive() fn that looks for ng-csp attribute anywhere in the current doc

/**
 * @ngdoc directive
 * @name ngClick
 *
 * @description
 * The ngClick directive allows you to specify custom behavior when
 * an element is clicked.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
 * click. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example>
     <file name="index.html">
      <button ng-click="count = count + 1" ng-init="count=0">
        Increment
      </button>
      <span>
        count: {{count}}
      </span>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-click', function() {
         expect(element(by.binding('count')).getText()).toMatch('0');
         element(by.css('button')).click();
         expect(element(by.binding('count')).getText()).toMatch('1');
       });
     </file>
   </example>
 */
/*
 * A collection of directives that allows creation of custom event handlers that are defined as
 * angular expressions and are compiled and executed within the current scope.
 */
var ngEventDirectives = {};

// For events that might fire synchronously during DOM manipulation
// we need to execute their event handlers asynchronously using $evalAsync,
// so that they are not executed in an inconsistent state.
var forceAsyncEvents = {
  'blur': true,
  'focus': true
};
forEach(
  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
  function(eventName) {
    var directiveName = directiveNormalize('ng-' + eventName);
    ngEventDirectives[directiveName] = ['$parse', '$rootScope', function($parse, $rootScope) {
      return {
        restrict: 'A',
        compile: function($element, attr) {
          // We expose the powerful $event object on the scope that provides access to the Window,
          // etc. that isn't protected by the fast paths in $parse.  We explicitly request better
          // checks at the cost of speed since event handler expressions are not executed as
          // frequently as regular change detection.
          var fn = $parse(attr[directiveName], /* interceptorFn */ null, /* expensiveChecks */ true);
          return function ngEventHandler(scope, element) {
            element.on(eventName, function(event) {
              var callback = function() {
                fn(scope, {$event:event});
              };
              if (forceAsyncEvents[eventName] && $rootScope.$$phase) {
                scope.$evalAsync(callback);
              } else {
                scope.$apply(callback);
              }
            });
          };
        }
      };
    }];
  }
);

/**
 * @ngdoc directive
 * @name ngDblclick
 *
 * @description
 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
 * a dblclick. (The Event object is available as `$event`)
 *
 * @example
   <example>
     <file name="index.html">
      <button ng-dblclick="count = count + 1" ng-init="count=0">
        Increment (on double click)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMousedown
 *
 * @description
 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example>
     <file name="index.html">
      <button ng-mousedown="count = count + 1" ng-init="count=0">
        Increment (on mouse down)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMouseup
 *
 * @description
 * Specify custom behavior on mouseup event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example>
     <file name="index.html">
      <button ng-mouseup="count = count + 1" ng-init="count=0">
        Increment (on mouse up)
      </button>
      count: {{count}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngMouseover
 *
 * @description
 * Specify custom behavior on mouseover event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example>
     <file name="index.html">
      <button ng-mouseover="count = count + 1" ng-init="count=0">
        Increment (when mouse is over)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMouseenter
 *
 * @description
 * Specify custom behavior on mouseenter event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example>
     <file name="index.html">
      <button ng-mouseenter="count = count + 1" ng-init="count=0">
        Increment (when mouse enters)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMouseleave
 *
 * @description
 * Specify custom behavior on mouseleave event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example>
     <file name="index.html">
      <button ng-mouseleave="count = count + 1" ng-init="count=0">
        Increment (when mouse leaves)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMousemove
 *
 * @description
 * Specify custom behavior on mousemove event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example>
     <file name="index.html">
      <button ng-mousemove="count = count + 1" ng-init="count=0">
        Increment (when mouse moves)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngKeydown
 *
 * @description
 * Specify custom behavior on keydown event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example>
     <file name="index.html">
      <input ng-keydown="count = count + 1" ng-init="count=0">
      key down count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngKeyup
 *
 * @description
 * Specify custom behavior on keyup event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example>
     <file name="index.html">
       <p>Typing in the input box below updates the key count</p>
       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}

       <p>Typing in the input box below updates the keycode</p>
       <input ng-keyup="event=$event">
       <p>event keyCode: {{ event.keyCode }}</p>
       <p>event altKey: {{ event.altKey }}</p>
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngKeypress
 *
 * @description
 * Specify custom behavior on keypress event.
 *
 * @element ANY
 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
 * and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example>
     <file name="index.html">
      <input ng-keypress="count = count + 1" ng-init="count=0">
      key press count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngSubmit
 *
 * @description
 * Enables binding angular expressions to onsubmit events.
 *
 * Additionally it prevents the default action (which for form means sending the request to the
 * server and reloading the current page), but only if the form does not contain `action`,
 * `data-action`, or `x-action` attributes.
 *
 * <div class="alert alert-warning">
 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
 * `ngSubmit` handlers together. See the
 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
 * for a detailed discussion of when `ngSubmit` may be triggered.
 * </div>
 *
 * @element form
 * @priority 0
 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
 * ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example module="submitExample">
     <file name="index.html">
      <script>
        angular.module('submitExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.list = [];
            $scope.text = 'hello';
            $scope.submit = function() {
              if ($scope.text) {
                $scope.list.push(this.text);
                $scope.text = '';
              }
            };
          }]);
      </script>
      <form ng-submit="submit()" ng-controller="ExampleController">
        Enter text and hit enter:
        <input type="text" ng-model="text" name="text" />
        <input type="submit" id="submit" value="Submit" />
        <pre>list={{list}}</pre>
      </form>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-submit', function() {
         expect(element(by.binding('list')).getText()).toBe('list=[]');
         element(by.css('#submit')).click();
         expect(element(by.binding('list')).getText()).toContain('hello');
         expect(element(by.model('text')).getAttribute('value')).toBe('');
       });
       it('should ignore empty strings', function() {
         expect(element(by.binding('list')).getText()).toBe('list=[]');
         element(by.css('#submit')).click();
         element(by.css('#submit')).click();
         expect(element(by.binding('list')).getText()).toContain('hello');
        });
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngFocus
 *
 * @description
 * Specify custom behavior on focus event.
 *
 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
 * during an `$apply` to ensure a consistent state.
 *
 * @element window, input, select, textarea, a
 * @priority 0
 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
 * See {@link ng.directive:ngClick ngClick}
 */

/**
 * @ngdoc directive
 * @name ngBlur
 *
 * @description
 * Specify custom behavior on blur event.
 *
 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
 * an element has lost focus.
 *
 * Note: As the `blur` event is executed synchronously also during DOM manipulations
 * (e.g. removing a focussed input),
 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
 * during an `$apply` to ensure a consistent state.
 *
 * @element window, input, select, textarea, a
 * @priority 0
 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
 * See {@link ng.directive:ngClick ngClick}
 */

/**
 * @ngdoc directive
 * @name ngCopy
 *
 * @description
 * Specify custom behavior on copy event.
 *
 * @element window, input, select, textarea, a
 * @priority 0
 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example>
     <file name="index.html">
      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
      copied: {{copied}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngCut
 *
 * @description
 * Specify custom behavior on cut event.
 *
 * @element window, input, select, textarea, a
 * @priority 0
 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example>
     <file name="index.html">
      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
      cut: {{cut}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngPaste
 *
 * @description
 * Specify custom behavior on paste event.
 *
 * @element window, input, select, textarea, a
 * @priority 0
 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example>
     <file name="index.html">
      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
      pasted: {{paste}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngIf
 * @restrict A
 *
 * @description
 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
 * {expression}. If the expression assigned to `ngIf` evaluates to a false
 * value then the element is removed from the DOM, otherwise a clone of the
 * element is reinserted into the DOM.
 *
 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
 * element in the DOM rather than changing its visibility via the `display` css property.  A common
 * case when this difference is significant is when using css selectors that rely on an element's
 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
 *
 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
 * is created when the element is restored.  The scope created within `ngIf` inherits from
 * its parent scope using
 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
 * a javascript primitive defined in the parent scope. In this case any modifications made to the
 * variable within the child scope will override (hide) the value in the parent scope.
 *
 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
 * is if an element's class attribute is directly modified after it's compiled, using something like
 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
 * the added class will be lost because the original compiled state is used to regenerate the element.
 *
 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
 * and `leave` effects.
 *
 * @animations
 * enter - happens just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container
 * leave - happens just before the `ngIf` contents are removed from the DOM
 *
 * @element ANY
 * @scope
 * @priority 600
 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
 *     element is added to the DOM tree.
 *
 * @example
  <example module="ngAnimate" deps="angular-animate.js" animations="true">
    <file name="index.html">
      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
      Show when checked:
      <span ng-if="checked" class="animate-if">
        This is removed when the checkbox is unchecked.
      </span>
    </file>
    <file name="animations.css">
      .animate-if {
        background:white;
        border:1px solid black;
        padding:10px;
      }

      .animate-if.ng-enter, .animate-if.ng-leave {
        -webkit-transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
      }

      .animate-if.ng-enter,
      .animate-if.ng-leave.ng-leave-active {
        opacity:0;
      }

      .animate-if.ng-leave,
      .animate-if.ng-enter.ng-enter-active {
        opacity:1;
      }
    </file>
  </example>
 */
var ngIfDirective = ['$animate', function($animate) {
  return {
    multiElement: true,
    transclude: 'element',
    priority: 600,
    terminal: true,
    restrict: 'A',
    $$tlb: true,
    link: function($scope, $element, $attr, ctrl, $transclude) {
        var block, childScope, previousElements;
        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {

          if (value) {
            if (!childScope) {
              $transclude(function(clone, newScope) {
                childScope = newScope;
                clone[clone.length++] = document.createComment(' end ngIf: ' + $attr.ngIf + ' ');
                // Note: We only need the first/last node of the cloned nodes.
                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                // by a directive with templateUrl when its template arrives.
                block = {
                  clone: clone
                };
                $animate.enter(clone, $element.parent(), $element);
              });
            }
          } else {
            if (previousElements) {
              previousElements.remove();
              previousElements = null;
            }
            if (childScope) {
              childScope.$destroy();
              childScope = null;
            }
            if (block) {
              previousElements = getBlockNodes(block.clone);
              $animate.leave(previousElements).then(function() {
                previousElements = null;
              });
              block = null;
            }
          }
        });
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngInclude
 * @restrict ECA
 *
 * @description
 * Fetches, compiles and includes an external HTML fragment.
 *
 * By default, the template URL is restricted to the same domain and protocol as the
 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
 * you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist them} or
 * {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to Angular's {@link
 * ng.$sce Strict Contextual Escaping}.
 *
 * In addition, the browser's
 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
 * policy may further restrict whether the template is successfully loaded.
 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
 * access on some browsers.
 *
 * @animations
 * enter - animation is used to bring new content into the browser.
 * leave - animation is used to animate existing content away.
 *
 * The enter and leave animation occur concurrently.
 *
 * @scope
 * @priority 400
 *
 * @param {string} ngInclude|src angular expression evaluating to URL. If the source is a string constant,
 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
 * @param {string=} onload Expression to evaluate when a new partial is loaded.
 *
 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
 *                  $anchorScroll} to scroll the viewport after the content is loaded.
 *
 *                  - If the attribute is not set, disable scrolling.
 *                  - If the attribute is set without value, enable scrolling.
 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
 *
 * @example
  <example module="includeExample" deps="angular-animate.js" animations="true">
    <file name="index.html">
     <div ng-controller="ExampleController">
       <select ng-model="template" ng-options="t.name for t in templates">
        <option value="">(blank)</option>
       </select>
       url of the template: <code>{{template.url}}</code>
       <hr/>
       <div class="slide-animate-container">
         <div class="slide-animate" ng-include="template.url"></div>
       </div>
     </div>
    </file>
    <file name="script.js">
      angular.module('includeExample', ['ngAnimate'])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.templates =
            [ { name: 'template1.html', url: 'template1.html'},
              { name: 'template2.html', url: 'template2.html'} ];
          $scope.template = $scope.templates[0];
        }]);
     </file>
    <file name="template1.html">
      Content of template1.html
    </file>
    <file name="template2.html">
      Content of template2.html
    </file>
    <file name="animations.css">
      .slide-animate-container {
        position:relative;
        background:white;
        border:1px solid black;
        height:40px;
        overflow:hidden;
      }

      .slide-animate {
        padding:10px;
      }

      .slide-animate.ng-enter, .slide-animate.ng-leave {
        -webkit-transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;

        position:absolute;
        top:0;
        left:0;
        right:0;
        bottom:0;
        display:block;
        padding:10px;
      }

      .slide-animate.ng-enter {
        top:-50px;
      }
      .slide-animate.ng-enter.ng-enter-active {
        top:0;
      }

      .slide-animate.ng-leave {
        top:0;
      }
      .slide-animate.ng-leave.ng-leave-active {
        top:50px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var templateSelect = element(by.model('template'));
      var includeElem = element(by.css('[ng-include]'));

      it('should load template1.html', function() {
        expect(includeElem.getText()).toMatch(/Content of template1.html/);
      });

      it('should load template2.html', function() {
        if (browser.params.browser == 'firefox') {
          // Firefox can't handle using selects
          // See https://github.com/angular/protractor/issues/480
          return;
        }
        templateSelect.click();
        templateSelect.all(by.css('option')).get(2).click();
        expect(includeElem.getText()).toMatch(/Content of template2.html/);
      });

      it('should change to blank', function() {
        if (browser.params.browser == 'firefox') {
          // Firefox can't handle using selects
          return;
        }
        templateSelect.click();
        templateSelect.all(by.css('option')).get(0).click();
        expect(includeElem.isPresent()).toBe(false);
      });
    </file>
  </example>
 */


/**
 * @ngdoc event
 * @name ngInclude#$includeContentRequested
 * @eventType emit on the scope ngInclude was declared in
 * @description
 * Emitted every time the ngInclude content is requested.
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */


/**
 * @ngdoc event
 * @name ngInclude#$includeContentLoaded
 * @eventType emit on the current ngInclude scope
 * @description
 * Emitted every time the ngInclude content is reloaded.
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */


/**
 * @ngdoc event
 * @name ngInclude#$includeContentError
 * @eventType emit on the scope ngInclude was declared in
 * @description
 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */
var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate', '$sce',
                  function($templateRequest,   $anchorScroll,   $animate,   $sce) {
  return {
    restrict: 'ECA',
    priority: 400,
    terminal: true,
    transclude: 'element',
    controller: angular.noop,
    compile: function(element, attr) {
      var srcExp = attr.ngInclude || attr.src,
          onloadExp = attr.onload || '',
          autoScrollExp = attr.autoscroll;

      return function(scope, $element, $attr, ctrl, $transclude) {
        var changeCounter = 0,
            currentScope,
            previousElement,
            currentElement;

        var cleanupLastIncludeContent = function() {
          if (previousElement) {
            previousElement.remove();
            previousElement = null;
          }
          if (currentScope) {
            currentScope.$destroy();
            currentScope = null;
          }
          if (currentElement) {
            $animate.leave(currentElement).then(function() {
              previousElement = null;
            });
            previousElement = currentElement;
            currentElement = null;
          }
        };

        scope.$watch($sce.parseAsResourceUrl(srcExp), function ngIncludeWatchAction(src) {
          var afterAnimation = function() {
            if (isDefined(autoScrollExp) && (!autoScrollExp || scope.$eval(autoScrollExp))) {
              $anchorScroll();
            }
          };
          var thisChangeId = ++changeCounter;

          if (src) {
            //set the 2nd param to true to ignore the template request error so that the inner
            //contents and scope can be cleaned up.
            $templateRequest(src, true).then(function(response) {
              if (thisChangeId !== changeCounter) return;
              var newScope = scope.$new();
              ctrl.template = response;

              // Note: This will also link all children of ng-include that were contained in the original
              // html. If that content contains controllers, ... they could pollute/change the scope.
              // However, using ng-include on an element with additional content does not make sense...
              // Note: We can't remove them in the cloneAttchFn of $transclude as that
              // function is called before linking the content, which would apply child
              // directives to non existing elements.
              var clone = $transclude(newScope, function(clone) {
                cleanupLastIncludeContent();
                $animate.enter(clone, null, $element).then(afterAnimation);
              });

              currentScope = newScope;
              currentElement = clone;

              currentScope.$emit('$includeContentLoaded', src);
              scope.$eval(onloadExp);
            }, function() {
              if (thisChangeId === changeCounter) {
                cleanupLastIncludeContent();
                scope.$emit('$includeContentError', src);
              }
            });
            scope.$emit('$includeContentRequested', src);
          } else {
            cleanupLastIncludeContent();
            ctrl.template = null;
          }
        });
      };
    }
  };
}];

// This directive is called during the $transclude call of the first `ngInclude` directive.
// It will replace and compile the content of the element with the loaded template.
// We need this directive so that the element content is already filled when
// the link function of another directive on the same element as ngInclude
// is called.
var ngIncludeFillContentDirective = ['$compile',
  function($compile) {
    return {
      restrict: 'ECA',
      priority: -400,
      require: 'ngInclude',
      link: function(scope, $element, $attr, ctrl) {
        if (/SVG/.test($element[0].toString())) {
          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
          // support innerHTML, so detect this here and try to generate the contents
          // specially.
          $element.empty();
          $compile(jqLiteBuildFragment(ctrl.template, document).childNodes)(scope,
              function namespaceAdaptedClone(clone) {
            $element.append(clone);
          }, {futureParentElement: $element});
          return;
        }

        $element.html(ctrl.template);
        $compile($element.contents())(scope);
      }
    };
  }];

/**
 * @ngdoc directive
 * @name ngInit
 * @restrict AC
 *
 * @description
 * The `ngInit` directive allows you to evaluate an expression in the
 * current scope.
 *
 * <div class="alert alert-danger">
 * The only appropriate use of `ngInit` is for aliasing special properties of
 * {@link ng.directive:ngRepeat `ngRepeat`}, as seen in the demo below. Besides this case, you
 * should use {@link guide/controller controllers} rather than `ngInit`
 * to initialize values on a scope.
 * </div>
 * <div class="alert alert-warning">
 * **Note**: If you have assignment in `ngInit` along with {@link ng.$filter `$filter`}, make
 * sure you have parenthesis for correct precedence:
 * <pre class="prettyprint">
 * `<div ng-init="test1 = (data | orderBy:'name')"></div>`
 * </pre>
 * </div>
 *
 * @priority 450
 *
 * @element ANY
 * @param {expression} ngInit {@link guide/expression Expression} to eval.
 *
 * @example
   <example module="initExample">
     <file name="index.html">
   <script>
     angular.module('initExample', [])
       .controller('ExampleController', ['$scope', function($scope) {
         $scope.list = [['a', 'b'], ['c', 'd']];
       }]);
   </script>
   <div ng-controller="ExampleController">
     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
       </div>
     </div>
   </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should alias index positions', function() {
         var elements = element.all(by.css('.example-init'));
         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
       });
     </file>
   </example>
 */
var ngInitDirective = ngDirective({
  priority: 450,
  compile: function() {
    return {
      pre: function(scope, element, attrs) {
        scope.$eval(attrs.ngInit);
      }
    };
  }
});

/**
 * @ngdoc directive
 * @name ngList
 *
 * @description
 * Text input that converts between a delimited string and an array of strings. The default
 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
 *
 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
 *   list item is respected. This implies that the user of the directive is responsible for
 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
 *   tab or newline character.
 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
 *   when joining the list items back together) and whitespace around each list item is stripped
 *   before it is added to the model.
 *
 * ### Example with Validation
 *
 * <example name="ngList-directive" module="listExample">
 *   <file name="app.js">
 *      angular.module('listExample', [])
 *        .controller('ExampleController', ['$scope', function($scope) {
 *          $scope.names = ['morpheus', 'neo', 'trinity'];
 *        }]);
 *   </file>
 *   <file name="index.html">
 *    <form name="myForm" ng-controller="ExampleController">
 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
 *      <span role="alert">
 *        <span class="error" ng-show="myForm.namesInput.$error.required">
 *        Required!</span>
 *      </span>
 *      <br>
 *      <tt>names = {{names}}</tt><br/>
 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
 *     </form>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var listInput = element(by.model('names'));
 *     var names = element(by.exactBinding('names'));
 *     var valid = element(by.binding('myForm.namesInput.$valid'));
 *     var error = element(by.css('span.error'));
 *
 *     it('should initialize to model', function() {
 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
 *       expect(valid.getText()).toContain('true');
 *       expect(error.getCssValue('display')).toBe('none');
 *     });
 *
 *     it('should be invalid if empty', function() {
 *       listInput.clear();
 *       listInput.sendKeys('');
 *
 *       expect(names.getText()).toContain('');
 *       expect(valid.getText()).toContain('false');
 *       expect(error.getCssValue('display')).not.toBe('none');
 *     });
 *   </file>
 * </example>
 *
 * ### Example - splitting on whitespace
 * <example name="ngList-directive-newlines">
 *   <file name="index.html">
 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
 *    <pre>{{ list | json }}</pre>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it("should split the text by newlines", function() {
 *       var listInput = element(by.model('list'));
 *       var output = element(by.binding('list | json'));
 *       listInput.sendKeys('abc\ndef\nghi');
 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
 *     });
 *   </file>
 * </example>
 *
 * @element input
 * @param {string=} ngList optional delimiter that should be used to split the value.
 */
var ngListDirective = function() {
  return {
    restrict: 'A',
    priority: 100,
    require: 'ngModel',
    link: function(scope, element, attr, ctrl) {
      // We want to control whitespace trimming so we use this convoluted approach
      // to access the ngList attribute, which doesn't pre-trim the attribute
      var ngList = element.attr(attr.$attr.ngList) || ', ';
      var trimValues = attr.ngTrim !== 'false';
      var separator = trimValues ? trim(ngList) : ngList;

      var parse = function(viewValue) {
        // If the viewValue is invalid (say required but empty) it will be `undefined`
        if (isUndefined(viewValue)) return;

        var list = [];

        if (viewValue) {
          forEach(viewValue.split(separator), function(value) {
            if (value) list.push(trimValues ? trim(value) : value);
          });
        }

        return list;
      };

      ctrl.$parsers.push(parse);
      ctrl.$formatters.push(function(value) {
        if (isArray(value)) {
          return value.join(ngList);
        }

        return undefined;
      });

      // Override the standard $isEmpty because an empty array means the input is empty.
      ctrl.$isEmpty = function(value) {
        return !value || !value.length;
      };
    }
  };
};

/* global VALID_CLASS: true,
  INVALID_CLASS: true,
  PRISTINE_CLASS: true,
  DIRTY_CLASS: true,
  UNTOUCHED_CLASS: true,
  TOUCHED_CLASS: true,
*/

var VALID_CLASS = 'ng-valid',
    INVALID_CLASS = 'ng-invalid',
    PRISTINE_CLASS = 'ng-pristine',
    DIRTY_CLASS = 'ng-dirty',
    UNTOUCHED_CLASS = 'ng-untouched',
    TOUCHED_CLASS = 'ng-touched',
    PENDING_CLASS = 'ng-pending';


var $ngModelMinErr = new minErr('ngModel');

/**
 * @ngdoc type
 * @name ngModel.NgModelController
 *
 * @property {string} $viewValue Actual string value in the view.
 * @property {*} $modelValue The value in the model that the control is bound to.
 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
       the control reads value from the DOM. The functions are called in array order, each passing
       its return value through to the next. The last return value is forwarded to the
       {@link ngModel.NgModelController#$validators `$validators`} collection.

Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
`$viewValue`}.

Returning `undefined` from a parser means a parse error occurred. In that case,
no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
is set to `true`. The parse error is stored in `ngModel.$error.parse`.

 *
 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
       the model value changes. The functions are called in reverse array order, each passing the value through to the
       next. The last return value is used as the actual DOM value.
       Used to format / convert values for display in the control.
 * ```js
 * function formatter(value) {
 *   if (value) {
 *     return value.toUpperCase();
 *   }
 * }
 * ngModel.$formatters.push(formatter);
 * ```
 *
 * @property {Object.<string, function>} $validators A collection of validators that are applied
 *      whenever the model value changes. The key value within the object refers to the name of the
 *      validator while the function refers to the validation operation. The validation operation is
 *      provided with the model value as an argument and must return a true or false value depending
 *      on the response of that validation.
 *
 * ```js
 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
 *   var value = modelValue || viewValue;
 *   return /[0-9]+/.test(value) &&
 *          /[a-z]+/.test(value) &&
 *          /[A-Z]+/.test(value) &&
 *          /\W+/.test(value);
 * };
 * ```
 *
 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
 *      is expected to return a promise when it is run during the model validation process. Once the promise
 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
 *      will only run once all synchronous validators have passed.
 *
 * Please note that if $http is used then it is important that the server returns a success HTTP response code
 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
 *
 * ```js
 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
 *   var value = modelValue || viewValue;
 *
 *   // Lookup user by username
 *   return $http.get('/api/users/' + value).
 *      then(function resolved() {
 *        //username exists, this means validation fails
 *        return $q.reject('exists');
 *      }, function rejected() {
 *        //username does not exist, therefore this validation passes
 *        return true;
 *      });
 * };
 * ```
 *
 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever the
 *     view value has changed. It is called with no arguments, and its return value is ignored.
 *     This can be used in place of additional $watches against the model value.
 *
 * @property {Object} $error An object hash with all failing validator ids as keys.
 * @property {Object} $pending An object hash with all pending validator ids as keys.
 *
 * @property {boolean} $untouched True if control has not lost focus yet.
 * @property {boolean} $touched True if control has lost focus.
 * @property {boolean} $pristine True if user has not interacted with the control yet.
 * @property {boolean} $dirty True if user has already interacted with the control.
 * @property {boolean} $valid True if there is no error.
 * @property {boolean} $invalid True if at least one error on the control.
 * @property {string} $name The name attribute of the control.
 *
 * @description
 *
 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
 * The controller contains services for data-binding, validation, CSS updates, and value formatting
 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
 * listening to DOM events.
 * Such DOM related logic should be provided by other directives which make use of
 * `NgModelController` for data-binding to control elements.
 * Angular provides this DOM logic for most {@link input `input`} elements.
 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
 *
 * @example
 * ### Custom Control Example
 * This example shows how to use `NgModelController` with a custom control to achieve
 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
 * collaborate together to achieve the desired result.
 *
 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
 * contents be edited in place by the user.
 *
 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
 * that content using the `$sce` service.
 *
 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
    <file name="style.css">
      [contenteditable] {
        border: 1px solid black;
        background-color: white;
        min-height: 20px;
      }

      .ng-invalid {
        border: 1px solid red;
      }

    </file>
    <file name="script.js">
      angular.module('customControl', ['ngSanitize']).
        directive('contenteditable', ['$sce', function($sce) {
          return {
            restrict: 'A', // only activate on element attribute
            require: '?ngModel', // get a hold of NgModelController
            link: function(scope, element, attrs, ngModel) {
              if (!ngModel) return; // do nothing if no ng-model

              // Specify how UI should be updated
              ngModel.$render = function() {
                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
              };

              // Listen for change events to enable binding
              element.on('blur keyup change', function() {
                scope.$evalAsync(read);
              });
              read(); // initialize

              // Write data to the model
              function read() {
                var html = element.html();
                // When we clear the content editable the browser leaves a <br> behind
                // If strip-br attribute is provided then we strip this out
                if ( attrs.stripBr && html == '<br>' ) {
                  html = '';
                }
                ngModel.$setViewValue(html);
              }
            }
          };
        }]);
    </file>
    <file name="index.html">
      <form name="myForm">
       <div contenteditable
            name="myWidget" ng-model="userContent"
            strip-br="true"
            required>Change me!</div>
        <span ng-show="myForm.myWidget.$error.required">Required!</span>
       <hr>
       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
    it('should data-bind and become invalid', function() {
      if (browser.params.browser == 'safari' || browser.params.browser == 'firefox') {
        // SafariDriver can't handle contenteditable
        // and Firefox driver can't clear contenteditables very well
        return;
      }
      var contentEditable = element(by.css('[contenteditable]'));
      var content = 'Change me!';

      expect(contentEditable.getText()).toEqual(content);

      contentEditable.clear();
      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
      expect(contentEditable.getText()).toEqual('');
      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
    });
    </file>
 * </example>
 *
 *
 */
var NgModelController = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$rootScope', '$q', '$interpolate',
    function($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $rootScope, $q, $interpolate) {
  this.$viewValue = Number.NaN;
  this.$modelValue = Number.NaN;
  this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
  this.$validators = {};
  this.$asyncValidators = {};
  this.$parsers = [];
  this.$formatters = [];
  this.$viewChangeListeners = [];
  this.$untouched = true;
  this.$touched = false;
  this.$pristine = true;
  this.$dirty = false;
  this.$valid = true;
  this.$invalid = false;
  this.$error = {}; // keep invalid keys here
  this.$$success = {}; // keep valid keys here
  this.$pending = undefined; // keep pending keys here
  this.$name = $interpolate($attr.name || '', false)($scope);


  var parsedNgModel = $parse($attr.ngModel),
      parsedNgModelAssign = parsedNgModel.assign,
      ngModelGet = parsedNgModel,
      ngModelSet = parsedNgModelAssign,
      pendingDebounce = null,
      parserValid,
      ctrl = this;

  this.$$setOptions = function(options) {
    ctrl.$options = options;
    if (options && options.getterSetter) {
      var invokeModelGetter = $parse($attr.ngModel + '()'),
          invokeModelSetter = $parse($attr.ngModel + '($$$p)');

      ngModelGet = function($scope) {
        var modelValue = parsedNgModel($scope);
        if (isFunction(modelValue)) {
          modelValue = invokeModelGetter($scope);
        }
        return modelValue;
      };
      ngModelSet = function($scope, newValue) {
        if (isFunction(parsedNgModel($scope))) {
          invokeModelSetter($scope, {$$$p: ctrl.$modelValue});
        } else {
          parsedNgModelAssign($scope, ctrl.$modelValue);
        }
      };
    } else if (!parsedNgModel.assign) {
      throw $ngModelMinErr('nonassign', "Expression '{0}' is non-assignable. Element: {1}",
          $attr.ngModel, startingTag($element));
    }
  };

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$render
   *
   * @description
   * Called when the view needs to be updated. It is expected that the user of the ng-model
   * directive will implement this method.
   *
   * The `$render()` method is invoked in the following situations:
   *
   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
   *   committed value then `$render()` is called to update the input control.
   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
   *   the `$viewValue` are different from last time.
   *
   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
   * `$modelValue` and `$viewValue` are actually different from their previous value. If `$modelValue`
   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
   * invoked if you only change a property on the objects.
   */
  this.$render = noop;

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$isEmpty
   *
   * @description
   * This is called when we need to determine if the value of an input is empty.
   *
   * For instance, the required directive does this to work out if the input has data or not.
   *
   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
   *
   * You can override this for input directives whose concept of being empty is different from the
   * default. The `checkboxInputType` directive does this because in its case a value of `false`
   * implies empty.
   *
   * @param {*} value The value of the input to check for emptiness.
   * @returns {boolean} True if `value` is "empty".
   */
  this.$isEmpty = function(value) {
    return isUndefined(value) || value === '' || value === null || value !== value;
  };

  var parentForm = $element.inheritedData('$formController') || nullFormCtrl,
      currentValidationRunId = 0;

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setValidity
   *
   * @description
   * Change the validity state, and notify the form.
   *
   * This method can be called within $parsers/$formatters or a custom validation implementation.
   * However, in most cases it should be sufficient to use the `ngModel.$validators` and
   * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
   *
   * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
   *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
   *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
   *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
   *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
   *        class and can be bound to as  `{{someForm.someControl.$error.myError}}` .
   * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
   *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
   *                          Skipped is used by Angular when validators do not run because of parse errors and
   *                          when `$asyncValidators` do not run because any of the `$validators` failed.
   */
  addSetValidityMethod({
    ctrl: this,
    $element: $element,
    set: function(object, property) {
      object[property] = true;
    },
    unset: function(object, property) {
      delete object[property];
    },
    parentForm: parentForm,
    $animate: $animate
  });

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setPristine
   *
   * @description
   * Sets the control to its pristine state.
   *
   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
   * state (`ng-pristine` class). A model is considered to be pristine when the control
   * has not been changed from when first compiled.
   */
  this.$setPristine = function() {
    ctrl.$dirty = false;
    ctrl.$pristine = true;
    $animate.removeClass($element, DIRTY_CLASS);
    $animate.addClass($element, PRISTINE_CLASS);
  };

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setDirty
   *
   * @description
   * Sets the control to its dirty state.
   *
   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
   * from when first compiled.
   */
  this.$setDirty = function() {
    ctrl.$dirty = true;
    ctrl.$pristine = false;
    $animate.removeClass($element, PRISTINE_CLASS);
    $animate.addClass($element, DIRTY_CLASS);
    parentForm.$setDirty();
  };

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setUntouched
   *
   * @description
   * Sets the control to its untouched state.
   *
   * This method can be called to remove the `ng-touched` class and set the control to its
   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
   * by default, however this function can be used to restore that state if the model has
   * already been touched by the user.
   */
  this.$setUntouched = function() {
    ctrl.$touched = false;
    ctrl.$untouched = true;
    $animate.setClass($element, UNTOUCHED_CLASS, TOUCHED_CLASS);
  };

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setTouched
   *
   * @description
   * Sets the control to its touched state.
   *
   * This method can be called to remove the `ng-untouched` class and set the control to its
   * touched state (`ng-touched` class). A model is considered to be touched when the user has
   * first focused the control element and then shifted focus away from the control (blur event).
   */
  this.$setTouched = function() {
    ctrl.$touched = true;
    ctrl.$untouched = false;
    $animate.setClass($element, TOUCHED_CLASS, UNTOUCHED_CLASS);
  };

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$rollbackViewValue
   *
   * @description
   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
   * which may be caused by a pending debounced event or because the input is waiting for a some
   * future event.
   *
   * If you have an input that uses `ng-model-options` to set up debounced events or events such
   * as blur you can have a situation where there is a period when the `$viewValue`
   * is out of synch with the ngModel's `$modelValue`.
   *
   * In this case, you can run into difficulties if you try to update the ngModel's `$modelValue`
   * programmatically before these debounced/future events have resolved/occurred, because Angular's
   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
   *
   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
   * input which may have such events pending. This is important in order to make sure that the
   * input field will be updated with the new model value and any pending operations are cancelled.
   *
   * <example name="ng-model-cancel-update" module="cancel-update-example">
   *   <file name="app.js">
   *     angular.module('cancel-update-example', [])
   *
   *     .controller('CancelUpdateController', ['$scope', function($scope) {
   *       $scope.resetWithCancel = function(e) {
   *         if (e.keyCode == 27) {
   *           $scope.myForm.myInput1.$rollbackViewValue();
   *           $scope.myValue = '';
   *         }
   *       };
   *       $scope.resetWithoutCancel = function(e) {
   *         if (e.keyCode == 27) {
   *           $scope.myValue = '';
   *         }
   *       };
   *     }]);
   *   </file>
   *   <file name="index.html">
   *     <div ng-controller="CancelUpdateController">
   *       <p>Try typing something in each input.  See that the model only updates when you
   *          blur off the input.
   *        </p>
   *        <p>Now see what happens if you start typing then press the Escape key</p>
   *
   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
   *         <p id="inputDescription1">With $rollbackViewValue()</p>
   *         <input name="myInput1" aria-describedby="inputDescription1" ng-model="myValue"
   *                ng-keydown="resetWithCancel($event)"><br/>
   *         myValue: "{{ myValue }}"
   *
   *         <p id="inputDescription2">Without $rollbackViewValue()</p>
   *         <input name="myInput2" aria-describedby="inputDescription2" ng-model="myValue"
   *                ng-keydown="resetWithoutCancel($event)"><br/>
   *         myValue: "{{ myValue }}"
   *       </form>
   *     </div>
   *   </file>
   * </example>
   */
  this.$rollbackViewValue = function() {
    $timeout.cancel(pendingDebounce);
    ctrl.$viewValue = ctrl.$$lastCommittedViewValue;
    ctrl.$render();
  };

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$validate
   *
   * @description
   * Runs each of the registered validators (first synchronous validators and then
   * asynchronous validators).
   * If the validity changes to invalid, the model will be set to `undefined`,
   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
   * If the validity changes to valid, it will set the model to the last available valid
   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
   */
  this.$validate = function() {
    // ignore $validate before model is initialized
    if (isNumber(ctrl.$modelValue) && isNaN(ctrl.$modelValue)) {
      return;
    }

    var viewValue = ctrl.$$lastCommittedViewValue;
    // Note: we use the $$rawModelValue as $modelValue might have been
    // set to undefined during a view -> model update that found validation
    // errors. We can't parse the view here, since that could change
    // the model although neither viewValue nor the model on the scope changed
    var modelValue = ctrl.$$rawModelValue;

    var prevValid = ctrl.$valid;
    var prevModelValue = ctrl.$modelValue;

    var allowInvalid = ctrl.$options && ctrl.$options.allowInvalid;

    ctrl.$$runValidators(modelValue, viewValue, function(allValid) {
      // If there was no change in validity, don't update the model
      // This prevents changing an invalid modelValue to undefined
      if (!allowInvalid && prevValid !== allValid) {
        // Note: Don't check ctrl.$valid here, as we could have
        // external validators (e.g. calculated on the server),
        // that just call $setValidity and need the model value
        // to calculate their validity.
        ctrl.$modelValue = allValid ? modelValue : undefined;

        if (ctrl.$modelValue !== prevModelValue) {
          ctrl.$$writeModelToScope();
        }
      }
    });

  };

  this.$$runValidators = function(modelValue, viewValue, doneCallback) {
    currentValidationRunId++;
    var localValidationRunId = currentValidationRunId;

    // check parser error
    if (!processParseErrors()) {
      validationDone(false);
      return;
    }
    if (!processSyncValidators()) {
      validationDone(false);
      return;
    }
    processAsyncValidators();

    function processParseErrors() {
      var errorKey = ctrl.$$parserName || 'parse';
      if (parserValid === undefined) {
        setValidity(errorKey, null);
      } else {
        if (!parserValid) {
          forEach(ctrl.$validators, function(v, name) {
            setValidity(name, null);
          });
          forEach(ctrl.$asyncValidators, function(v, name) {
            setValidity(name, null);
          });
        }
        // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
        setValidity(errorKey, parserValid);
        return parserValid;
      }
      return true;
    }

    function processSyncValidators() {
      var syncValidatorsValid = true;
      forEach(ctrl.$validators, function(validator, name) {
        var result = validator(modelValue, viewValue);
        syncValidatorsValid = syncValidatorsValid && result;
        setValidity(name, result);
      });
      if (!syncValidatorsValid) {
        forEach(ctrl.$asyncValidators, function(v, name) {
          setValidity(name, null);
        });
        return false;
      }
      return true;
    }

    function processAsyncValidators() {
      var validatorPromises = [];
      var allValid = true;
      forEach(ctrl.$asyncValidators, function(validator, name) {
        var promise = validator(modelValue, viewValue);
        if (!isPromiseLike(promise)) {
          throw $ngModelMinErr("$asyncValidators",
            "Expected asynchronous validator to return a promise but got '{0}' instead.", promise);
        }
        setValidity(name, undefined);
        validatorPromises.push(promise.then(function() {
          setValidity(name, true);
        }, function(error) {
          allValid = false;
          setValidity(name, false);
        }));
      });
      if (!validatorPromises.length) {
        validationDone(true);
      } else {
        $q.all(validatorPromises).then(function() {
          validationDone(allValid);
        }, noop);
      }
    }

    function setValidity(name, isValid) {
      if (localValidationRunId === currentValidationRunId) {
        ctrl.$setValidity(name, isValid);
      }
    }

    function validationDone(allValid) {
      if (localValidationRunId === currentValidationRunId) {

        doneCallback(allValid);
      }
    }
  };

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$commitViewValue
   *
   * @description
   * Commit a pending update to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
   * usually handles calling this in response to input events.
   */
  this.$commitViewValue = function() {
    var viewValue = ctrl.$viewValue;

    $timeout.cancel(pendingDebounce);

    // If the view value has not changed then we should just exit, except in the case where there is
    // a native validator on the element. In this case the validation state may have changed even though
    // the viewValue has stayed empty.
    if (ctrl.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !ctrl.$$hasNativeValidators)) {
      return;
    }
    ctrl.$$lastCommittedViewValue = viewValue;

    // change to dirty
    if (ctrl.$pristine) {
      this.$setDirty();
    }
    this.$$parseAndValidate();
  };

  this.$$parseAndValidate = function() {
    var viewValue = ctrl.$$lastCommittedViewValue;
    var modelValue = viewValue;
    parserValid = isUndefined(modelValue) ? undefined : true;

    if (parserValid) {
      for (var i = 0; i < ctrl.$parsers.length; i++) {
        modelValue = ctrl.$parsers[i](modelValue);
        if (isUndefined(modelValue)) {
          parserValid = false;
          break;
        }
      }
    }
    if (isNumber(ctrl.$modelValue) && isNaN(ctrl.$modelValue)) {
      // ctrl.$modelValue has not been touched yet...
      ctrl.$modelValue = ngModelGet($scope);
    }
    var prevModelValue = ctrl.$modelValue;
    var allowInvalid = ctrl.$options && ctrl.$options.allowInvalid;
    ctrl.$$rawModelValue = modelValue;

    if (allowInvalid) {
      ctrl.$modelValue = modelValue;
      writeToModelIfNeeded();
    }

    // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
    // This can happen if e.g. $setViewValue is called from inside a parser
    ctrl.$$runValidators(modelValue, ctrl.$$lastCommittedViewValue, function(allValid) {
      if (!allowInvalid) {
        // Note: Don't check ctrl.$valid here, as we could have
        // external validators (e.g. calculated on the server),
        // that just call $setValidity and need the model value
        // to calculate their validity.
        ctrl.$modelValue = allValid ? modelValue : undefined;
        writeToModelIfNeeded();
      }
    });

    function writeToModelIfNeeded() {
      if (ctrl.$modelValue !== prevModelValue) {
        ctrl.$$writeModelToScope();
      }
    }
  };

  this.$$writeModelToScope = function() {
    ngModelSet($scope, ctrl.$modelValue);
    forEach(ctrl.$viewChangeListeners, function(listener) {
      try {
        listener();
      } catch (e) {
        $exceptionHandler(e);
      }
    });
  };

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setViewValue
   *
   * @description
   * Update the view value.
   *
   * This method should be called when an input directive want to change the view value; typically,
   * this is done from within a DOM event handler.
   *
   * For example {@link ng.directive:input input} calls it when the value of the input changes and
   * {@link ng.directive:select select} calls it when an option is selected.
   *
   * If the new `value` is an object (rather than a string or a number), we should make a copy of the
   * object before passing it to `$setViewValue`.  This is because `ngModel` does not perform a deep
   * watch of objects, it only looks for a change of identity. If you only change the property of
   * the object then ngModel will not realise that the object has changed and will not invoke the
   * `$parsers` and `$validators` pipelines.
   *
   * For this reason, you should not change properties of the copy once it has been passed to
   * `$setViewValue`. Otherwise you may cause the model value on the scope to change incorrectly.
   *
   * When this method is called, the new `value` will be staged for committing through the `$parsers`
   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
   * value sent directly for processing, finally to be applied to `$modelValue` and then the
   * **expression** specified in the `ng-model` attribute.
   *
   * Lastly, all the registered change listeners, in the `$viewChangeListeners` list, are called.
   *
   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
   * and the `default` trigger is not listed, all those actions will remain pending until one of the
   * `updateOn` events is triggered on the DOM element.
   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
   * directive is used with a custom debounce for this particular event.
   *
   * Note that calling this function does not trigger a `$digest`.
   *
   * @param {string} value Value from the view.
   * @param {string} trigger Event that triggered the update.
   */
  this.$setViewValue = function(value, trigger) {
    ctrl.$viewValue = value;
    if (!ctrl.$options || ctrl.$options.updateOnDefault) {
      ctrl.$$debounceViewValueCommit(trigger);
    }
  };

  this.$$debounceViewValueCommit = function(trigger) {
    var debounceDelay = 0,
        options = ctrl.$options,
        debounce;

    if (options && isDefined(options.debounce)) {
      debounce = options.debounce;
      if (isNumber(debounce)) {
        debounceDelay = debounce;
      } else if (isNumber(debounce[trigger])) {
        debounceDelay = debounce[trigger];
      } else if (isNumber(debounce['default'])) {
        debounceDelay = debounce['default'];
      }
    }

    $timeout.cancel(pendingDebounce);
    if (debounceDelay) {
      pendingDebounce = $timeout(function() {
        ctrl.$commitViewValue();
      }, debounceDelay);
    } else if ($rootScope.$$phase) {
      ctrl.$commitViewValue();
    } else {
      $scope.$apply(function() {
        ctrl.$commitViewValue();
      });
    }
  };

  // model -> value
  // Note: we cannot use a normal scope.$watch as we want to detect the following:
  // 1. scope value is 'a'
  // 2. user enters 'b'
  // 3. ng-change kicks in and reverts scope value to 'a'
  //    -> scope value did not change since the last digest as
  //       ng-change executes in apply phase
  // 4. view should be changed back to 'a'
  $scope.$watch(function ngModelWatch() {
    var modelValue = ngModelGet($scope);

    // if scope model value and ngModel value are out of sync
    // TODO(perf): why not move this to the action fn?
    if (modelValue !== ctrl.$modelValue &&
       // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
       (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
    ) {
      ctrl.$modelValue = ctrl.$$rawModelValue = modelValue;
      parserValid = undefined;

      var formatters = ctrl.$formatters,
          idx = formatters.length;

      var viewValue = modelValue;
      while (idx--) {
        viewValue = formatters[idx](viewValue);
      }
      if (ctrl.$viewValue !== viewValue) {
        ctrl.$viewValue = ctrl.$$lastCommittedViewValue = viewValue;
        ctrl.$render();

        ctrl.$$runValidators(modelValue, viewValue, noop);
      }
    }

    return modelValue;
  });
}];


/**
 * @ngdoc directive
 * @name ngModel
 *
 * @element input
 * @priority 1
 *
 * @description
 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
 * property on the scope using {@link ngModel.NgModelController NgModelController},
 * which is created and exposed by this directive.
 *
 * `ngModel` is responsible for:
 *
 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
 *   require.
 * - Providing validation behavior (i.e. required, number, email, url).
 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`, `ng-untouched`) including animations.
 * - Registering the control with its parent {@link ng.directive:form form}.
 *
 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
 * current scope. If the property doesn't already exist on this scope, it will be created
 * implicitly and added to the scope.
 *
 * For best practices on using `ngModel`, see:
 *
 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
 *
 * For basic examples, how to use `ngModel`, see:
 *
 *  - {@link ng.directive:input input}
 *    - {@link input[text] text}
 *    - {@link input[checkbox] checkbox}
 *    - {@link input[radio] radio}
 *    - {@link input[number] number}
 *    - {@link input[email] email}
 *    - {@link input[url] url}
 *    - {@link input[date] date}
 *    - {@link input[datetime-local] datetime-local}
 *    - {@link input[time] time}
 *    - {@link input[month] month}
 *    - {@link input[week] week}
 *  - {@link ng.directive:select select}
 *  - {@link ng.directive:textarea textarea}
 *
 * # CSS classes
 * The following CSS classes are added and removed on the associated input/select/textarea element
 * depending on the validity of the model.
 *
 *  - `ng-valid`: the model is valid
 *  - `ng-invalid`: the model is invalid
 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
 *  - `ng-pristine`: the control hasn't been interacted with yet
 *  - `ng-dirty`: the control has been interacted with
 *  - `ng-touched`: the control has been blurred
 *  - `ng-untouched`: the control hasn't been blurred
 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
 *
 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
 *
 * ## Animation Hooks
 *
 * Animations within models are triggered when any of the associated CSS classes are added and removed
 * on the input element which is attached to the model. These classes are: `.ng-pristine`, `.ng-dirty`,
 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
 * The animations that are triggered within ngModel are similar to how they work in ngClass and
 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
 *
 * The following example shows a simple way to utilize CSS transitions to style an input element
 * that has been rendered as invalid after it has been validated:
 *
 * <pre>
 * //be sure to include ngAnimate as a module to hook into more
 * //advanced animations
 * .my-input {
 *   transition:0.5s linear all;
 *   background: white;
 * }
 * .my-input.ng-invalid {
 *   background: red;
 *   color:white;
 * }
 * </pre>
 *
 * @example
 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample">
     <file name="index.html">
       <script>
        angular.module('inputExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.val = '1';
          }]);
       </script>
       <style>
         .my-input {
           -webkit-transition:all linear 0.5s;
           transition:all linear 0.5s;
           background: transparent;
         }
         .my-input.ng-invalid {
           color:white;
           background: red;
         }
       </style>
       <p id="inputDescription">
        Update input to see transitions when valid/invalid.
        Integer is a valid value.
       </p>
       <form name="testForm" ng-controller="ExampleController">
         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
                aria-describedby="inputDescription" />
       </form>
     </file>
 * </example>
 *
 * ## Binding to a getter/setter
 *
 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
 * function that returns a representation of the model when called with zero arguments, and sets
 * the internal state of a model when called with an argument. It's sometimes useful to use this
 * for models that have an internal representation that's different from what the model exposes
 * to the view.
 *
 * <div class="alert alert-success">
 * **Best Practice:** It's best to keep getters fast because Angular is likely to call them more
 * frequently than other parts of your code.
 * </div>
 *
 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
 *
 * The following example shows how to use `ngModel` with a getter/setter:
 *
 * @example
 * <example name="ngModel-getter-setter" module="getterSetterExample">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <form name="userForm">
           <label>Name:
             <input type="text" name="userName"
                    ng-model="user.name"
                    ng-model-options="{ getterSetter: true }" />
           </label>
         </form>
         <pre>user.name = <span ng-bind="user.name()"></span></pre>
       </div>
     </file>
     <file name="app.js">
       angular.module('getterSetterExample', [])
         .controller('ExampleController', ['$scope', function($scope) {
           var _name = 'Brian';
           $scope.user = {
             name: function(newName) {
              // Note that newName can be undefined for two reasons:
              // 1. Because it is called as a getter and thus called with no arguments
              // 2. Because the property should actually be set to undefined. This happens e.g. if the
              //    input is invalid
              return arguments.length ? (_name = newName) : _name;
             }
           };
         }]);
     </file>
 * </example>
 */
var ngModelDirective = ['$rootScope', function($rootScope) {
  return {
    restrict: 'A',
    require: ['ngModel', '^?form', '^?ngModelOptions'],
    controller: NgModelController,
    // Prelink needs to run before any input directive
    // so that we can set the NgModelOptions in NgModelController
    // before anyone else uses it.
    priority: 1,
    compile: function ngModelCompile(element) {
      // Setup initial state of the control
      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);

      return {
        pre: function ngModelPreLink(scope, element, attr, ctrls) {
          var modelCtrl = ctrls[0],
              formCtrl = ctrls[1] || nullFormCtrl;

          modelCtrl.$$setOptions(ctrls[2] && ctrls[2].$options);

          // notify others, especially parent forms
          formCtrl.$addControl(modelCtrl);

          attr.$observe('name', function(newValue) {
            if (modelCtrl.$name !== newValue) {
              formCtrl.$$renameControl(modelCtrl, newValue);
            }
          });

          scope.$on('$destroy', function() {
            formCtrl.$removeControl(modelCtrl);
          });
        },
        post: function ngModelPostLink(scope, element, attr, ctrls) {
          var modelCtrl = ctrls[0];
          if (modelCtrl.$options && modelCtrl.$options.updateOn) {
            element.on(modelCtrl.$options.updateOn, function(ev) {
              modelCtrl.$$debounceViewValueCommit(ev && ev.type);
            });
          }

          element.on('blur', function(ev) {
            if (modelCtrl.$touched) return;

            if ($rootScope.$$phase) {
              scope.$evalAsync(modelCtrl.$setTouched);
            } else {
              scope.$apply(modelCtrl.$setTouched);
            }
          });
        }
      };
    }
  };
}];

var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;

/**
 * @ngdoc directive
 * @name ngModelOptions
 *
 * @description
 * Allows tuning how model updates are done. Using `ngModelOptions` you can specify a custom list of
 * events that will trigger a model update and/or a debouncing delay so that the actual update only
 * takes place when a timer expires; this timer will be reset after another change takes place.
 *
 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
 * be different from the value in the actual model. This means that if you update the model you
 * should also invoke {@link ngModel.NgModelController `$rollbackViewValue`} on the relevant input field in
 * order to make sure it is synchronized with the model and that any debounced action is canceled.
 *
 * The easiest way to reference the control's {@link ngModel.NgModelController `$rollbackViewValue`}
 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
 * important because `form` controllers are published to the related scope under the name in their
 * `name` attribute.
 *
 * Any pending changes will take place immediately when an enclosing form is submitted via the
 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
 * to have access to the updated model.
 *
 * `ngModelOptions` has an effect on the element it's declared on and its descendants.
 *
 * @param {Object} ngModelOptions options to apply to the current model. Valid keys are:
 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
 *     events using an space delimited list. There is a special event called `default` that
 *     matches the default events belonging of the control.
 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
 *     custom value for each event. For example:
 *     `ng-model-options="{ updateOn: 'default blur', debounce: { 'default': 500, 'blur': 0 } }"`
 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
 *     not validate correctly instead of the default behavior of setting the model to undefined.
 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
       `ngModel` as getters/setters.
 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
 *     `<input type="date">`, `<input type="time">`, ... . It understands UTC/GMT and the
 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
 *     If not specified, the timezone of the browser will be used.
 *
 * @example

  The following example shows how to override immediate updates. Changes on the inputs within the
  form will update the model only when the control loses focus (blur event). If `escape` key is
  pressed while the input field is focused, the value is reset to the value in the current model.

  <example name="ngModelOptions-directive-blur" module="optionsExample">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <form name="userForm">
          <label>Name:
            <input type="text" name="userName"
                   ng-model="user.name"
                   ng-model-options="{ updateOn: 'blur' }"
                   ng-keyup="cancel($event)" />
          </label><br />
          <label>Other data:
            <input type="text" ng-model="user.data" />
          </label><br />
        </form>
        <pre>user.name = <span ng-bind="user.name"></span></pre>
      </div>
    </file>
    <file name="app.js">
      angular.module('optionsExample', [])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.user = { name: 'say', data: '' };

          $scope.cancel = function(e) {
            if (e.keyCode == 27) {
              $scope.userForm.userName.$rollbackViewValue();
            }
          };
        }]);
    </file>
    <file name="protractor.js" type="protractor">
      var model = element(by.binding('user.name'));
      var input = element(by.model('user.name'));
      var other = element(by.model('user.data'));

      it('should allow custom events', function() {
        input.sendKeys(' hello');
        input.click();
        expect(model.getText()).toEqual('say');
        other.click();
        expect(model.getText()).toEqual('say hello');
      });

      it('should $rollbackViewValue when model changes', function() {
        input.sendKeys(' hello');
        expect(input.getAttribute('value')).toEqual('say hello');
        input.sendKeys(protractor.Key.ESCAPE);
        expect(input.getAttribute('value')).toEqual('say');
        other.click();
        expect(model.getText()).toEqual('say');
      });
    </file>
  </example>

  This one shows how to debounce model changes. Model will be updated only 1 sec after last change.
  If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.

  <example name="ngModelOptions-directive-debounce" module="optionsExample">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <form name="userForm">
          <label>Name:
            <input type="text" name="userName"
                   ng-model="user.name"
                   ng-model-options="{ debounce: 1000 }" />
          </label>
          <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button>
          <br />
        </form>
        <pre>user.name = <span ng-bind="user.name"></span></pre>
      </div>
    </file>
    <file name="app.js">
      angular.module('optionsExample', [])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.user = { name: 'say' };
        }]);
    </file>
  </example>

  This one shows how to bind to getter/setters:

  <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <form name="userForm">
          <label>Name:
            <input type="text" name="userName"
                   ng-model="user.name"
                   ng-model-options="{ getterSetter: true }" />
          </label>
        </form>
        <pre>user.name = <span ng-bind="user.name()"></span></pre>
      </div>
    </file>
    <file name="app.js">
      angular.module('getterSetterExample', [])
        .controller('ExampleController', ['$scope', function($scope) {
          var _name = 'Brian';
          $scope.user = {
            name: function(newName) {
              // Note that newName can be undefined for two reasons:
              // 1. Because it is called as a getter and thus called with no arguments
              // 2. Because the property should actually be set to undefined. This happens e.g. if the
              //    input is invalid
              return arguments.length ? (_name = newName) : _name;
            }
          };
        }]);
    </file>
  </example>
 */
var ngModelOptionsDirective = function() {
  return {
    restrict: 'A',
    controller: ['$scope', '$attrs', function($scope, $attrs) {
      var that = this;
      this.$options = copy($scope.$eval($attrs.ngModelOptions));
      // Allow adding/overriding bound events
      if (this.$options.updateOn !== undefined) {
        this.$options.updateOnDefault = false;
        // extract "default" pseudo-event from list of events that can trigger a model update
        this.$options.updateOn = trim(this.$options.updateOn.replace(DEFAULT_REGEXP, function() {
          that.$options.updateOnDefault = true;
          return ' ';
        }));
      } else {
        this.$options.updateOnDefault = true;
      }
    }]
  };
};



// helper methods
function addSetValidityMethod(context) {
  var ctrl = context.ctrl,
      $element = context.$element,
      classCache = {},
      set = context.set,
      unset = context.unset,
      parentForm = context.parentForm,
      $animate = context.$animate;

  classCache[INVALID_CLASS] = !(classCache[VALID_CLASS] = $element.hasClass(VALID_CLASS));

  ctrl.$setValidity = setValidity;

  function setValidity(validationErrorKey, state, controller) {
    if (state === undefined) {
      createAndSet('$pending', validationErrorKey, controller);
    } else {
      unsetAndCleanup('$pending', validationErrorKey, controller);
    }
    if (!isBoolean(state)) {
      unset(ctrl.$error, validationErrorKey, controller);
      unset(ctrl.$$success, validationErrorKey, controller);
    } else {
      if (state) {
        unset(ctrl.$error, validationErrorKey, controller);
        set(ctrl.$$success, validationErrorKey, controller);
      } else {
        set(ctrl.$error, validationErrorKey, controller);
        unset(ctrl.$$success, validationErrorKey, controller);
      }
    }
    if (ctrl.$pending) {
      cachedToggleClass(PENDING_CLASS, true);
      ctrl.$valid = ctrl.$invalid = undefined;
      toggleValidationCss('', null);
    } else {
      cachedToggleClass(PENDING_CLASS, false);
      ctrl.$valid = isObjectEmpty(ctrl.$error);
      ctrl.$invalid = !ctrl.$valid;
      toggleValidationCss('', ctrl.$valid);
    }

    // re-read the state as the set/unset methods could have
    // combined state in ctrl.$error[validationError] (used for forms),
    // where setting/unsetting only increments/decrements the value,
    // and does not replace it.
    var combinedState;
    if (ctrl.$pending && ctrl.$pending[validationErrorKey]) {
      combinedState = undefined;
    } else if (ctrl.$error[validationErrorKey]) {
      combinedState = false;
    } else if (ctrl.$$success[validationErrorKey]) {
      combinedState = true;
    } else {
      combinedState = null;
    }

    toggleValidationCss(validationErrorKey, combinedState);
    parentForm.$setValidity(validationErrorKey, combinedState, ctrl);
  }

  function createAndSet(name, value, controller) {
    if (!ctrl[name]) {
      ctrl[name] = {};
    }
    set(ctrl[name], value, controller);
  }

  function unsetAndCleanup(name, value, controller) {
    if (ctrl[name]) {
      unset(ctrl[name], value, controller);
    }
    if (isObjectEmpty(ctrl[name])) {
      ctrl[name] = undefined;
    }
  }

  function cachedToggleClass(className, switchValue) {
    if (switchValue && !classCache[className]) {
      $animate.addClass($element, className);
      classCache[className] = true;
    } else if (!switchValue && classCache[className]) {
      $animate.removeClass($element, className);
      classCache[className] = false;
    }
  }

  function toggleValidationCss(validationErrorKey, isValid) {
    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';

    cachedToggleClass(VALID_CLASS + validationErrorKey, isValid === true);
    cachedToggleClass(INVALID_CLASS + validationErrorKey, isValid === false);
  }
}

function isObjectEmpty(obj) {
  if (obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        return false;
      }
    }
  }
  return true;
}

/**
 * @ngdoc directive
 * @name ngNonBindable
 * @restrict AC
 * @priority 1000
 *
 * @description
 * The `ngNonBindable` directive tells Angular not to compile or bind the contents of the current
 * DOM element. This is useful if the element contains what appears to be Angular directives and
 * bindings but which should be ignored by Angular. This could be the case if you have a site that
 * displays snippets of code, for instance.
 *
 * @element ANY
 *
 * @example
 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
 * but the one wrapped in `ngNonBindable` is left alone.
 *
 * @example
    <example>
      <file name="index.html">
        <div>Normal: {{1 + 2}}</div>
        <div ng-non-bindable>Ignored: {{1 + 2}}</div>
      </file>
      <file name="protractor.js" type="protractor">
       it('should check ng-non-bindable', function() {
         expect(element(by.binding('1 + 2')).getText()).toContain('3');
         expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
       });
      </file>
    </example>
 */
var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });

/* global jqLiteRemove */

var ngOptionsMinErr = minErr('ngOptions');

/**
 * @ngdoc directive
 * @name ngOptions
 * @restrict A
 *
 * @description
 *
 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
 * elements for the `<select>` element using the array or object obtained by evaluating the
 * `ngOptions` comprehension expression.
 *
 * In many cases, `ngRepeat` can be used on `<option>` elements instead of `ngOptions` to achieve a
 * similar result. However, `ngOptions` provides some benefits such as reducing memory and
 * increasing speed by not creating a new scope for each repeated instance, as well as providing
 * more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
 * comprehension expression. `ngOptions` should be used when the `<select>` model needs to be bound
 *  to a non-string value. This is because an option element can only be bound to string values at
 * present.
 *
 * When an item in the `<select>` menu is selected, the array element or object property
 * represented by the selected option will be bound to the model identified by the `ngModel`
 * directive.
 *
 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
 * option. See example below for demonstration.
 *
 * ## Complex Models (objects or collections)
 *
 * **Note:** By default, `ngModel` watches the model by reference, not value. This is important when
 * binding any input directive to a model that is an object or a collection.
 *
 * Since this is a common situation for `ngOptions` the directive additionally watches the model using
 * `$watchCollection` when the select has the `multiple` attribute or when there is a `track by` clause in
 * the options expression. This allows ngOptions to trigger a re-rendering of the options even if the actual
 * object/collection has not changed identity but only a property on the object or an item in the collection
 * changes.
 *
 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
 * if the model is an array). This means that changing a property deeper inside the object/collection that the
 * first level will not trigger a re-rendering.
 *
 *
 * ## `select` **`as`**
 *
 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
 *
 *
 * ### `select` **`as`** and **`track by`**
 *
 * <div class="alert alert-warning">
 * Do not use `select` **`as`** and **`track by`** in the same expression. They are not designed to work together.
 * </div>
 *
 * Consider the following example:
 *
 * ```html
 * <select ng-options="item.subItem as item.label for item in values track by item.id" ng-model="selected">
 * ```
 *
 * ```js
 * $scope.values = [{
 *   id: 1,
 *   label: 'aLabel',
 *   subItem: { name: 'aSubItem' }
 * }, {
 *   id: 2,
 *   label: 'bLabel',
 *   subItem: { name: 'bSubItem' }
 * }];
 *
 * $scope.selected = { name: 'aSubItem' };
 * ```
 *
 * With the purpose of preserving the selection, the **`track by`** expression is always applied to the element
 * of the data source (to `item` in this example). To calculate whether an element is selected, we do the
 * following:
 *
 * 1. Apply **`track by`** to the elements in the array. In the example: `[1, 2]`
 * 2. Apply **`track by`** to the already selected value in `ngModel`.
 *    In the example: this is not possible as **`track by`** refers to `item.id`, but the selected
 *    value from `ngModel` is `{name: 'aSubItem'}`, so the **`track by`** expression is applied to
 *    a wrong object, the selected element can't be found, `<select>` is always reset to the "not
 *    selected" option.
 *
 *
 * @param {string} ngModel Assignable angular expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required The control is considered valid only if value is entered.
 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
 *    `required` when you want to data-bind to the `required` attribute.
 * @param {comprehension_expression=} ngOptions in one of the following forms:
 *
 *   * for array data sources:
 *     * `label` **`for`** `value` **`in`** `array`
 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
 *        (for including a filter with `track by`)
 *   * for object data sources:
 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`group by`** `group`
 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`disable when`** `disable`
 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
 *
 * Where:
 *
 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
 *   * `value`: local variable which will refer to each item in the `array` or each property value
 *      of `object` during iteration.
 *   * `key`: local variable which will refer to a property name in `object` during iteration.
 *   * `label`: The result of this expression will be the label for `<option>` element. The
 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
 *      element. If not specified, `select` expression will default to `value`.
 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
 *      DOM element.
 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
 *      element. Return `true` to disable.
 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
 *      even when the options are recreated (e.g. reloaded from the server).
 *
 * @example
    <example module="selectExample">
      <file name="index.html">
        <script>
        angular.module('selectExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.colors = [
              {name:'black', shade:'dark'},
              {name:'white', shade:'light', notAnOption: true},
              {name:'red', shade:'dark'},
              {name:'blue', shade:'dark', notAnOption: true},
              {name:'yellow', shade:'light', notAnOption: false}
            ];
            $scope.myColor = $scope.colors[2]; // red
          }]);
        </script>
        <div ng-controller="ExampleController">
          <ul>
            <li ng-repeat="color in colors">
              <label>Name: <input ng-model="color.name"></label>
              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
            </li>
            <li>
              <button ng-click="colors.push({})">add</button>
            </li>
          </ul>
          <hr/>
          <label>Color (null not allowed):
            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
          </label><br/>
          <label>Color (null allowed):
          <span  class="nullable">
            <select ng-model="myColor" ng-options="color.name for color in colors">
              <option value="">-- choose color --</option>
            </select>
          </span></label><br/>

          <label>Color grouped by shade:
            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
            </select>
          </label><br/>

          <label>Color grouped by shade, with some disabled:
            <select ng-model="myColor"
                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
            </select>
          </label><br/>



          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
          <br/>
          <hr/>
          Currently selected: {{ {selected_color:myColor} }}
          <div style="border:solid 1px black; height:20px"
               ng-style="{'background-color':myColor.name}">
          </div>
        </div>
      </file>
      <file name="protractor.js" type="protractor">
         it('should check ng-options', function() {
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
           element.all(by.model('myColor')).first().click();
           element.all(by.css('select[ng-model="myColor"] option')).first().click();
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
           element(by.css('.nullable select[ng-model="myColor"]')).click();
           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
         });
      </file>
    </example>
 */

// jshint maxlen: false
//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555550000000006666666666666660000000777777777777777000000000000000888888888800000000000000000009999999999
var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
                        // 1: value expression (valueFn)
                        // 2: label expression (displayFn)
                        // 3: group by expression (groupByFn)
                        // 4: disable when expression (disableWhenFn)
                        // 5: array item variable name
                        // 6: object item key variable name
                        // 7: object item value variable name
                        // 8: collection expression
                        // 9: track by expression
// jshint maxlen: 100


var ngOptionsDirective = ['$compile', '$parse', function($compile, $parse) {

  function parseOptionsExpression(optionsExp, selectElement, scope) {

    var match = optionsExp.match(NG_OPTIONS_REGEXP);
    if (!(match)) {
      throw ngOptionsMinErr('iexp',
        "Expected expression in form of " +
        "'_select_ (as _label_)? for (_key_,)?_value_ in _collection_'" +
        " but got '{0}'. Element: {1}",
        optionsExp, startingTag(selectElement));
    }

    // Extract the parts from the ngOptions expression

    // The variable name for the value of the item in the collection
    var valueName = match[5] || match[7];
    // The variable name for the key of the item in the collection
    var keyName = match[6];

    // An expression that generates the viewValue for an option if there is a label expression
    var selectAs = / as /.test(match[0]) && match[1];
    // An expression that is used to track the id of each object in the options collection
    var trackBy = match[9];
    // An expression that generates the viewValue for an option if there is no label expression
    var valueFn = $parse(match[2] ? match[1] : valueName);
    var selectAsFn = selectAs && $parse(selectAs);
    var viewValueFn = selectAsFn || valueFn;
    var trackByFn = trackBy && $parse(trackBy);

    // Get the value by which we are going to track the option
    // if we have a trackFn then use that (passing scope and locals)
    // otherwise just hash the given viewValue
    var getTrackByValueFn = trackBy ?
                              function(value, locals) { return trackByFn(scope, locals); } :
                              function getHashOfValue(value) { return hashKey(value); };
    var getTrackByValue = function(value, key) {
      return getTrackByValueFn(value, getLocals(value, key));
    };

    var displayFn = $parse(match[2] || match[1]);
    var groupByFn = $parse(match[3] || '');
    var disableWhenFn = $parse(match[4] || '');
    var valuesFn = $parse(match[8]);

    var locals = {};
    var getLocals = keyName ? function(value, key) {
      locals[keyName] = key;
      locals[valueName] = value;
      return locals;
    } : function(value) {
      locals[valueName] = value;
      return locals;
    };


    function Option(selectValue, viewValue, label, group, disabled) {
      this.selectValue = selectValue;
      this.viewValue = viewValue;
      this.label = label;
      this.group = group;
      this.disabled = disabled;
    }

    return {
      trackBy: trackBy,
      getTrackByValue: getTrackByValue,
      getWatchables: $parse(valuesFn, function(values) {
        // Create a collection of things that we would like to watch (watchedArray)
        // so that they can all be watched using a single $watchCollection
        // that only runs the handler once if anything changes
        var watchedArray = [];
        values = values || [];

        Object.keys(values).forEach(function getWatchable(key) {
          if (key.charAt(0) === '$') return;
          var locals = getLocals(values[key], key);
          var selectValue = getTrackByValueFn(values[key], locals);
          watchedArray.push(selectValue);

          // Only need to watch the displayFn if there is a specific label expression
          if (match[2] || match[1]) {
            var label = displayFn(scope, locals);
            watchedArray.push(label);
          }

          // Only need to watch the disableWhenFn if there is a specific disable expression
          if (match[4]) {
            var disableWhen = disableWhenFn(scope, locals);
            watchedArray.push(disableWhen);
          }
        });
        return watchedArray;
      }),

      getOptions: function() {

        var optionItems = [];
        var selectValueMap = {};

        // The option values were already computed in the `getWatchables` fn,
        // which must have been called to trigger `getOptions`
        var optionValues = valuesFn(scope) || [];
        var optionValuesKeys;


        if (!keyName && isArrayLike(optionValues)) {
          optionValuesKeys = optionValues;
        } else {
          // if object, extract keys, in enumeration order, unsorted
          optionValuesKeys = [];
          for (var itemKey in optionValues) {
            if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
              optionValuesKeys.push(itemKey);
            }
          }
        }

        var optionValuesLength = optionValuesKeys.length;

        for (var index = 0; index < optionValuesLength; index++) {
          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
          var value = optionValues[key];
          var locals = getLocals(value, key);
          var viewValue = viewValueFn(scope, locals);
          var selectValue = getTrackByValueFn(viewValue, locals);
          var label = displayFn(scope, locals);
          var group = groupByFn(scope, locals);
          var disabled = disableWhenFn(scope, locals);
          var optionItem = new Option(selectValue, viewValue, label, group, disabled);

          optionItems.push(optionItem);
          selectValueMap[selectValue] = optionItem;
        }

        return {
          items: optionItems,
          selectValueMap: selectValueMap,
          getOptionFromViewValue: function(value) {
            return selectValueMap[getTrackByValue(value)];
          },
          getViewValueFromOption: function(option) {
            // If the viewValue could be an object that may be mutated by the application,
            // we need to make a copy and not return the reference to the value on the option.
            return trackBy ? angular.copy(option.viewValue) : option.viewValue;
          }
        };
      }
    };
  }


  // we can't just jqLite('<option>') since jqLite is not smart enough
  // to create it in <select> and IE barfs otherwise.
  var optionTemplate = document.createElement('option'),
      optGroupTemplate = document.createElement('optgroup');

  return {
    restrict: 'A',
    terminal: true,
    require: ['select', '?ngModel'],
    link: function(scope, selectElement, attr, ctrls) {

      // if ngModel is not defined, we don't need to do anything
      var ngModelCtrl = ctrls[1];
      if (!ngModelCtrl) return;

      var selectCtrl = ctrls[0];
      var multiple = attr.multiple;

      // The emptyOption allows the application developer to provide their own custom "empty"
      // option when the viewValue does not match any of the option values.
      var emptyOption;
      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
        if (children[i].value === '') {
          emptyOption = children.eq(i);
          break;
        }
      }

      var providedEmptyOption = !!emptyOption;

      var unknownOption = jqLite(optionTemplate.cloneNode(false));
      unknownOption.val('?');

      var options;
      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);


      var renderEmptyOption = function() {
        if (!providedEmptyOption) {
          selectElement.prepend(emptyOption);
        }
        selectElement.val('');
        emptyOption.prop('selected', true); // needed for IE
        emptyOption.attr('selected', true);
      };

      var removeEmptyOption = function() {
        if (!providedEmptyOption) {
          emptyOption.remove();
        }
      };


      var renderUnknownOption = function() {
        selectElement.prepend(unknownOption);
        selectElement.val('?');
        unknownOption.prop('selected', true); // needed for IE
        unknownOption.attr('selected', true);
      };

      var removeUnknownOption = function() {
        unknownOption.remove();
      };


      // Update the controller methods for multiple selectable options
      if (!multiple) {

        selectCtrl.writeValue = function writeNgOptionsValue(value) {
          var option = options.getOptionFromViewValue(value);

          if (option && !option.disabled) {
            if (selectElement[0].value !== option.selectValue) {
              removeUnknownOption();
              removeEmptyOption();

              selectElement[0].value = option.selectValue;
              option.element.selected = true;
              option.element.setAttribute('selected', 'selected');
            }
          } else {
            if (value === null || providedEmptyOption) {
              removeUnknownOption();
              renderEmptyOption();
            } else {
              removeEmptyOption();
              renderUnknownOption();
            }
          }
        };

        selectCtrl.readValue = function readNgOptionsValue() {

          var selectedOption = options.selectValueMap[selectElement.val()];

          if (selectedOption && !selectedOption.disabled) {
            removeEmptyOption();
            removeUnknownOption();
            return options.getViewValueFromOption(selectedOption);
          }
          return null;
        };

        // If we are using `track by` then we must watch the tracked value on the model
        // since ngModel only watches for object identity change
        if (ngOptions.trackBy) {
          scope.$watch(
            function() { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
            function() { ngModelCtrl.$render(); }
          );
        }

      } else {

        ngModelCtrl.$isEmpty = function(value) {
          return !value || value.length === 0;
        };


        selectCtrl.writeValue = function writeNgOptionsMultiple(value) {
          options.items.forEach(function(option) {
            option.element.selected = false;
          });

          if (value) {
            value.forEach(function(item) {
              var option = options.getOptionFromViewValue(item);
              if (option && !option.disabled) option.element.selected = true;
            });
          }
        };


        selectCtrl.readValue = function readNgOptionsMultiple() {
          var selectedValues = selectElement.val() || [],
              selections = [];

          forEach(selectedValues, function(value) {
            var option = options.selectValueMap[value];
            if (!option.disabled) selections.push(options.getViewValueFromOption(option));
          });

          return selections;
        };

        // If we are using `track by` then we must watch these tracked values on the model
        // since ngModel only watches for object identity change
        if (ngOptions.trackBy) {

          scope.$watchCollection(function() {
            if (isArray(ngModelCtrl.$viewValue)) {
              return ngModelCtrl.$viewValue.map(function(value) {
                return ngOptions.getTrackByValue(value);
              });
            }
          }, function() {
            ngModelCtrl.$render();
          });

        }
      }


      if (providedEmptyOption) {

        // we need to remove it before calling selectElement.empty() because otherwise IE will
        // remove the label from the element. wtf?
        emptyOption.remove();

        // compile the element since there might be bindings in it
        $compile(emptyOption)(scope);

        // remove the class, which is added automatically because we recompile the element and it
        // becomes the compilation root
        emptyOption.removeClass('ng-scope');
      } else {
        emptyOption = jqLite(optionTemplate.cloneNode(false));
      }

      // We need to do this here to ensure that the options object is defined
      // when we first hit it in writeNgOptionsValue
      updateOptions();

      // We will re-render the option elements if the option values or labels change
      scope.$watchCollection(ngOptions.getWatchables, updateOptions);

      // ------------------------------------------------------------------ //


      function updateOptionElement(option, element) {
        option.element = element;
        element.disabled = option.disabled;
        if (option.value !== element.value) element.value = option.selectValue;
        if (option.label !== element.label) {
          element.label = option.label;
          element.textContent = option.label;
        }
      }

      function addOrReuseElement(parent, current, type, templateElement) {
        var element;
        // Check whether we can reuse the next element
        if (current && lowercase(current.nodeName) === type) {
          // The next element is the right type so reuse it
          element = current;
        } else {
          // The next element is not the right type so create a new one
          element = templateElement.cloneNode(false);
          if (!current) {
            // There are no more elements so just append it to the select
            parent.appendChild(element);
          } else {
            // The next element is not a group so insert the new one
            parent.insertBefore(element, current);
          }
        }
        return element;
      }


      function removeExcessElements(current) {
        var next;
        while (current) {
          next = current.nextSibling;
          jqLiteRemove(current);
          current = next;
        }
      }


      function skipEmptyAndUnknownOptions(current) {
        var emptyOption_ = emptyOption && emptyOption[0];
        var unknownOption_ = unknownOption && unknownOption[0];

        if (emptyOption_ || unknownOption_) {
          while (current &&
                (current === emptyOption_ ||
                current === unknownOption_)) {
            current = current.nextSibling;
          }
        }
        return current;
      }


      function updateOptions() {

        var previousValue = options && selectCtrl.readValue();

        options = ngOptions.getOptions();

        var groupMap = {};
        var currentElement = selectElement[0].firstChild;

        // Ensure that the empty option is always there if it was explicitly provided
        if (providedEmptyOption) {
          selectElement.prepend(emptyOption);
        }

        currentElement = skipEmptyAndUnknownOptions(currentElement);

        options.items.forEach(function updateOption(option) {
          var group;
          var groupElement;
          var optionElement;

          if (option.group) {

            // This option is to live in a group
            // See if we have already created this group
            group = groupMap[option.group];

            if (!group) {

              // We have not already created this group
              groupElement = addOrReuseElement(selectElement[0],
                                               currentElement,
                                               'optgroup',
                                               optGroupTemplate);
              // Move to the next element
              currentElement = groupElement.nextSibling;

              // Update the label on the group element
              groupElement.label = option.group;

              // Store it for use later
              group = groupMap[option.group] = {
                groupElement: groupElement,
                currentOptionElement: groupElement.firstChild
              };

            }

            // So now we have a group for this option we add the option to the group
            optionElement = addOrReuseElement(group.groupElement,
                                              group.currentOptionElement,
                                              'option',
                                              optionTemplate);
            updateOptionElement(option, optionElement);
            // Move to the next element
            group.currentOptionElement = optionElement.nextSibling;

          } else {

            // This option is not in a group
            optionElement = addOrReuseElement(selectElement[0],
                                              currentElement,
                                              'option',
                                              optionTemplate);
            updateOptionElement(option, optionElement);
            // Move to the next element
            currentElement = optionElement.nextSibling;
          }
        });


        // Now remove all excess options and group
        Object.keys(groupMap).forEach(function(key) {
          removeExcessElements(groupMap[key].currentOptionElement);
        });
        removeExcessElements(currentElement);

        ngModelCtrl.$render();

        // Check to see if the value has changed due to the update to the options
        if (!ngModelCtrl.$isEmpty(previousValue)) {
          var nextValue = selectCtrl.readValue();
          if (ngOptions.trackBy ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
            ngModelCtrl.$setViewValue(nextValue);
            ngModelCtrl.$render();
          }
        }

      }

    }
  };
}];

/**
 * @ngdoc directive
 * @name ngPluralize
 * @restrict EA
 *
 * @description
 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
 * These rules are bundled with angular.js, but can be overridden
 * (see {@link guide/i18n Angular i18n} dev guide). You configure ngPluralize directive
 * by specifying the mappings between
 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
 * and the strings to be displayed.
 *
 * # Plural categories and explicit number rules
 * There are two
 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
 * in Angular's default en-US locale: "one" and "other".
 *
 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
 * any number that is not 1), an explicit number rule can only match one number. For example, the
 * explicit number rule for "3" matches the number 3. There are examples of plural categories
 * and explicit number rules throughout the rest of this documentation.
 *
 * # Configuring ngPluralize
 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
 * You can also provide an optional attribute, `offset`.
 *
 * The value of the `count` attribute can be either a string or an {@link guide/expression
 * Angular expression}; these are evaluated on the current scope for its bound value.
 *
 * The `when` attribute specifies the mappings between plural categories and the actual
 * string to be displayed. The value of the attribute should be a JSON object.
 *
 * The following example shows how to configure ngPluralize:
 *
 * ```html
 * <ng-pluralize count="personCount"
                 when="{'0': 'Nobody is viewing.',
 *                      'one': '1 person is viewing.',
 *                      'other': '{} people are viewing.'}">
 * </ng-pluralize>
 *```
 *
 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
 * show "a dozen people are viewing".
 *
 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
 * into pluralized strings. In the previous example, Angular will replace `{}` with
 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
 * for <span ng-non-bindable>{{numberExpression}}</span>.
 *
 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
 *
 * # Configuring ngPluralize with offset
 * The `offset` attribute allows further customization of pluralized text, which can result in
 * a better user experience. For example, instead of the message "4 people are viewing this document",
 * you might display "John, Kate and 2 others are viewing this document".
 * The offset attribute allows you to offset a number by any desired value.
 * Let's take a look at an example:
 *
 * ```html
 * <ng-pluralize count="personCount" offset=2
 *               when="{'0': 'Nobody is viewing.',
 *                      '1': '{{person1}} is viewing.',
 *                      '2': '{{person1}} and {{person2}} are viewing.',
 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
 * </ng-pluralize>
 * ```
 *
 * Notice that we are still using two plural categories(one, other), but we added
 * three explicit number rules 0, 1 and 2.
 * When one person, perhaps John, views the document, "John is viewing" will be shown.
 * When three people view the document, no explicit number rule is found, so
 * an offset of 2 is taken off 3, and Angular uses 1 to decide the plural category.
 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
 * is shown.
 *
 * Note that when you specify offsets, you must provide explicit number rules for
 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
 * plural categories "one" and "other".
 *
 * @param {string|expression} count The variable to be bound to.
 * @param {string} when The mapping between plural category to its corresponding strings.
 * @param {number=} offset Offset to deduct from the total number.
 *
 * @example
    <example module="pluralizeExample">
      <file name="index.html">
        <script>
          angular.module('pluralizeExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.person1 = 'Igor';
              $scope.person2 = 'Misko';
              $scope.personCount = 1;
            }]);
        </script>
        <div ng-controller="ExampleController">
          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>

          <!--- Example with simple pluralization rules for en locale --->
          Without Offset:
          <ng-pluralize count="personCount"
                        when="{'0': 'Nobody is viewing.',
                               'one': '1 person is viewing.',
                               'other': '{} people are viewing.'}">
          </ng-pluralize><br>

          <!--- Example with offset --->
          With Offset(2):
          <ng-pluralize count="personCount" offset=2
                        when="{'0': 'Nobody is viewing.',
                               '1': '{{person1}} is viewing.',
                               '2': '{{person1}} and {{person2}} are viewing.',
                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
          </ng-pluralize>
        </div>
      </file>
      <file name="protractor.js" type="protractor">
        it('should show correct pluralized string', function() {
          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
          var withOffset = element.all(by.css('ng-pluralize')).get(1);
          var countInput = element(by.model('personCount'));

          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
          expect(withOffset.getText()).toEqual('Igor is viewing.');

          countInput.clear();
          countInput.sendKeys('0');

          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
          expect(withOffset.getText()).toEqual('Nobody is viewing.');

          countInput.clear();
          countInput.sendKeys('2');

          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');

          countInput.clear();
          countInput.sendKeys('3');

          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');

          countInput.clear();
          countInput.sendKeys('4');

          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
        });
        it('should show data-bound names', function() {
          var withOffset = element.all(by.css('ng-pluralize')).get(1);
          var personCount = element(by.model('personCount'));
          var person1 = element(by.model('person1'));
          var person2 = element(by.model('person2'));
          personCount.clear();
          personCount.sendKeys('4');
          person1.clear();
          person1.sendKeys('Di');
          person2.clear();
          person2.sendKeys('Vojta');
          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
        });
      </file>
    </example>
 */
var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
  var BRACE = /{}/g,
      IS_WHEN = /^when(Minus)?(.+)$/;

  return {
    link: function(scope, element, attr) {
      var numberExp = attr.count,
          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
          offset = attr.offset || 0,
          whens = scope.$eval(whenExp) || {},
          whensExpFns = {},
          startSymbol = $interpolate.startSymbol(),
          endSymbol = $interpolate.endSymbol(),
          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
          watchRemover = angular.noop,
          lastCount;

      forEach(attr, function(expression, attributeName) {
        var tmpMatch = IS_WHEN.exec(attributeName);
        if (tmpMatch) {
          var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
          whens[whenKey] = element.attr(attr.$attr[attributeName]);
        }
      });
      forEach(whens, function(expression, key) {
        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));

      });

      scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
        var count = parseFloat(newVal);
        var countIsNaN = isNaN(count);

        if (!countIsNaN && !(count in whens)) {
          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
          // Otherwise, check it against pluralization rules in $locale service.
          count = $locale.pluralCat(count - offset);
        }

        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
        // In JS `NaN !== NaN`, so we have to exlicitly check.
        if ((count !== lastCount) && !(countIsNaN && isNumber(lastCount) && isNaN(lastCount))) {
          watchRemover();
          var whenExpFn = whensExpFns[count];
          if (isUndefined(whenExpFn)) {
            if (newVal != null) {
              $log.debug("ngPluralize: no rule defined for '" + count + "' in " + whenExp);
            }
            watchRemover = noop;
            updateElementText();
          } else {
            watchRemover = scope.$watch(whenExpFn, updateElementText);
          }
          lastCount = count;
        }
      });

      function updateElementText(newText) {
        element.text(newText || '');
      }
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngRepeat
 *
 * @description
 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
 * instance gets its own scope, where the given loop variable is set to the current collection item,
 * and `$index` is set to the item index or key.
 *
 * Special properties are exposed on the local scope of each template instance, including:
 *
 * | Variable  | Type            | Details                                                                     |
 * |-----------|-----------------|-----------------------------------------------------------------------------|
 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
 *
 * Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
 * This may be useful when, for instance, nesting ngRepeats.
 *
 *
 * # Iterating over object properties
 *
 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
 * syntax:
 *
 * ```js
 * <div ng-repeat="(key, value) in myObj"> ... </div>
 * ```
 *
 * You need to be aware that the JavaScript specification does not define the order of keys
 * returned for an object. (To mitigate this in Angular 1.3 the `ngRepeat` directive
 * used to sort the keys alphabetically.)
 *
 * Version 1.4 removed the alphabetic sorting. We now rely on the order returned by the browser
 * when running `for key in myObj`. It seems that browsers generally follow the strategy of providing
 * keys in the order in which they were defined, although there are exceptions when keys are deleted
 * and reinstated. See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_issues
 *
 * If this is not desired, the recommended workaround is to convert your object into an array
 * that is sorted into the order that you prefer before providing it to `ngRepeat`.  You could
 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
 * or implement a `$watch` on the object yourself.
 *
 *
 * # Tracking and Duplicates
 *
 * When the contents of the collection change, `ngRepeat` makes the corresponding changes to the DOM:
 *
 * * When an item is added, a new instance of the template is added to the DOM.
 * * When an item is removed, its template instance is removed from the DOM.
 * * When items are reordered, their respective templates are reordered in the DOM.
 *
 * By default, `ngRepeat` does not allow duplicate items in arrays. This is because when
 * there are duplicates, it is not possible to maintain a one-to-one mapping between collection
 * items and DOM elements.
 *
 * If you do need to repeat duplicate items, you can substitute the default tracking behavior
 * with your own using the `track by` expression.
 *
 * For example, you may track items by the index of each item in the collection, using the
 * special scope property `$index`:
 * ```html
 *    <div ng-repeat="n in [42, 42, 43, 43] track by $index">
 *      {{n}}
 *    </div>
 * ```
 *
 * You may use arbitrary expressions in `track by`, including references to custom functions
 * on the scope:
 * ```html
 *    <div ng-repeat="n in [42, 42, 43, 43] track by myTrackingFunction(n)">
 *      {{n}}
 *    </div>
 * ```
 *
 * If you are working with objects that have an identifier property, you can track
 * by the identifier instead of the whole object. Should you reload your data later, `ngRepeat`
 * will not have to rebuild the DOM elements for items it has already rendered, even if the
 * JavaScript objects in the collection have been substituted for new ones:
 * ```html
 *    <div ng-repeat="model in collection track by model.id">
 *      {{model.name}}
 *    </div>
 * ```
 *
 * When no `track by` expression is provided, it is equivalent to tracking by the built-in
 * `$id` function, which tracks items by their identity:
 * ```html
 *    <div ng-repeat="obj in collection track by $id(obj)">
 *      {{obj.prop}}
 *    </div>
 * ```
 *
 * <div class="alert alert-warning">
 * **Note:** `track by` must always be the last expression:
 * </div>
 * ```
 * <div ng-repeat="model in collection | orderBy: 'id' as filtered_result track by model.id">
 *     {{model.name}}
 * </div>
 * ```
 *
 * # Special repeat start and end points
 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
 *
 * The example below makes use of this feature:
 * ```html
 *   <header ng-repeat-start="item in items">
 *     Header {{ item }}
 *   </header>
 *   <div class="body">
 *     Body {{ item }}
 *   </div>
 *   <footer ng-repeat-end>
 *     Footer {{ item }}
 *   </footer>
 * ```
 *
 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
 * ```html
 *   <header>
 *     Header A
 *   </header>
 *   <div class="body">
 *     Body A
 *   </div>
 *   <footer>
 *     Footer A
 *   </footer>
 *   <header>
 *     Header B
 *   </header>
 *   <div class="body">
 *     Body B
 *   </div>
 *   <footer>
 *     Footer B
 *   </footer>
 * ```
 *
 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
 *
 * @animations
 * **.enter** - when a new item is added to the list or when an item is revealed after a filter
 *
 * **.leave** - when an item is removed from the list or when an item is filtered out
 *
 * **.move** - when an adjacent item is filtered out causing a reorder or when the item contents are reordered
 *
 * @element ANY
 * @scope
 * @priority 1000
 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
 *   formats are currently supported:
 *
 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
 *     is a scope expression giving the collection to enumerate.
 *
 *     For example: `album in artist.albums`.
 *
 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
 *     and `expression` is the scope expression giving the collection to enumerate.
 *
 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
 *
 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
 *     is specified, ng-repeat associates elements by identity. It is an error to have
 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
 *     mapped to the same DOM element, which is not possible.)
 *
 *     Note that the tracking expression must come last, after any filters, and the alias expression.
 *
 *     For example: `item in items` is equivalent to `item in items track by $id(item)`. This implies that the DOM elements
 *     will be associated by item identity in the array.
 *
 *     For example: `item in items track by $id(item)`. A built in `$id()` function can be used to assign a unique
 *     `$$hashKey` property to each item in the array. This property is then used as a key to associated DOM elements
 *     with the corresponding item in the array by identity. Moving the same object in array would move the DOM
 *     element in the same way in the DOM.
 *
 *     For example: `item in items track by item.id` is a typical pattern when the items come from the database. In this
 *     case the object identity does not matter. Two objects are considered equivalent as long as their `id`
 *     property is same.
 *
 *     For example: `item in items | filter:searchText track by item.id` is a pattern that might be used to apply a filter
 *     to items in conjunction with a tracking expression.
 *
 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
 *     when a filter is active on the repeater, but the filtered result set is empty.
 *
 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
 *     the items have been processed through the filter.
 *
 *     Please note that `as [variable name] is not an operator but rather a part of ngRepeat micro-syntax so it can be used only at the end
 *     (and not as operator, inside an expression).
 *
 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results` .
 *
 * @example
 * This example initializes the scope to a list of names and
 * then uses `ngRepeat` to display every person:
  <example module="ngAnimate" deps="angular-animate.js" animations="true">
    <file name="index.html">
      <div ng-init="friends = [
        {name:'John', age:25, gender:'boy'},
        {name:'Jessie', age:30, gender:'girl'},
        {name:'Johanna', age:28, gender:'girl'},
        {name:'Joy', age:15, gender:'girl'},
        {name:'Mary', age:28, gender:'girl'},
        {name:'Peter', age:95, gender:'boy'},
        {name:'Sebastian', age:50, gender:'boy'},
        {name:'Erika', age:27, gender:'girl'},
        {name:'Patrick', age:40, gender:'boy'},
        {name:'Samantha', age:60, gender:'girl'}
      ]">
        I have {{friends.length}} friends. They are:
        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results">
            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
          </li>
          <li class="animate-repeat" ng-if="results.length == 0">
            <strong>No results found...</strong>
          </li>
        </ul>
      </div>
    </file>
    <file name="animations.css">
      .example-animate-container {
        background:white;
        border:1px solid black;
        list-style:none;
        margin:0;
        padding:0 10px;
      }

      .animate-repeat {
        line-height:40px;
        list-style:none;
        box-sizing:border-box;
      }

      .animate-repeat.ng-move,
      .animate-repeat.ng-enter,
      .animate-repeat.ng-leave {
        -webkit-transition:all linear 0.5s;
        transition:all linear 0.5s;
      }

      .animate-repeat.ng-leave.ng-leave-active,
      .animate-repeat.ng-move,
      .animate-repeat.ng-enter {
        opacity:0;
        max-height:0;
      }

      .animate-repeat.ng-leave,
      .animate-repeat.ng-move.ng-move-active,
      .animate-repeat.ng-enter.ng-enter-active {
        opacity:1;
        max-height:40px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var friends = element.all(by.repeater('friend in friends'));

      it('should render initial data set', function() {
        expect(friends.count()).toBe(10);
        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
        expect(element(by.binding('friends.length')).getText())
            .toMatch("I have 10 friends. They are:");
      });

       it('should update repeater when filter predicate changes', function() {
         expect(friends.count()).toBe(10);

         element(by.model('q')).sendKeys('ma');

         expect(friends.count()).toBe(2);
         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
       });
      </file>
    </example>
 */
var ngRepeatDirective = ['$parse', '$animate', function($parse, $animate) {
  var NG_REMOVED = '$$NG_REMOVED';
  var ngRepeatMinErr = minErr('ngRepeat');

  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
    scope[valueIdentifier] = value;
    if (keyIdentifier) scope[keyIdentifier] = key;
    scope.$index = index;
    scope.$first = (index === 0);
    scope.$last = (index === (arrayLength - 1));
    scope.$middle = !(scope.$first || scope.$last);
    // jshint bitwise: false
    scope.$odd = !(scope.$even = (index&1) === 0);
    // jshint bitwise: true
  };

  var getBlockStart = function(block) {
    return block.clone[0];
  };

  var getBlockEnd = function(block) {
    return block.clone[block.clone.length - 1];
  };


  return {
    restrict: 'A',
    multiElement: true,
    transclude: 'element',
    priority: 1000,
    terminal: true,
    $$tlb: true,
    compile: function ngRepeatCompile($element, $attr) {
      var expression = $attr.ngRepeat;
      var ngRepeatEndComment = document.createComment(' end ngRepeat: ' + expression + ' ');

      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);

      if (!match) {
        throw ngRepeatMinErr('iexp', "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.",
            expression);
      }

      var lhs = match[1];
      var rhs = match[2];
      var aliasAs = match[3];
      var trackByExp = match[4];

      match = lhs.match(/^(?:(\s*[\$\w]+)|\(\s*([\$\w]+)\s*,\s*([\$\w]+)\s*\))$/);

      if (!match) {
        throw ngRepeatMinErr('iidexp', "'_item_' in '_item_ in _collection_' should be an identifier or '(_key_, _value_)' expression, but got '{0}'.",
            lhs);
      }
      var valueIdentifier = match[3] || match[1];
      var keyIdentifier = match[2];

      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
        throw ngRepeatMinErr('badident', "alias '{0}' is invalid --- must be a valid JS identifier which is not a reserved name.",
          aliasAs);
      }

      var trackByExpGetter, trackByIdExpFn, trackByIdArrayFn, trackByIdObjFn;
      var hashFnLocals = {$id: hashKey};

      if (trackByExp) {
        trackByExpGetter = $parse(trackByExp);
      } else {
        trackByIdArrayFn = function(key, value) {
          return hashKey(value);
        };
        trackByIdObjFn = function(key) {
          return key;
        };
      }

      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {

        if (trackByExpGetter) {
          trackByIdExpFn = function(key, value, index) {
            // assign key, value, and $index to the locals so that they can be used in hash functions
            if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
            hashFnLocals[valueIdentifier] = value;
            hashFnLocals.$index = index;
            return trackByExpGetter($scope, hashFnLocals);
          };
        }

        // Store a list of elements from previous run. This is a hash where key is the item from the
        // iterator, and the value is objects with following properties.
        //   - scope: bound scope
        //   - element: previous element.
        //   - index: position
        //
        // We are using no-proto object so that we don't need to guard against inherited props via
        // hasOwnProperty.
        var lastBlockMap = createMap();

        //watch props
        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
          var index, length,
              previousNode = $element[0],     // node that cloned nodes should be inserted after
                                              // initialized to the comment node anchor
              nextNode,
              // Same as lastBlockMap but it has the current state. It will become the
              // lastBlockMap on the next iteration.
              nextBlockMap = createMap(),
              collectionLength,
              key, value, // key/value of iteration
              trackById,
              trackByIdFn,
              collectionKeys,
              block,       // last object information {scope, element, id}
              nextBlockOrder,
              elementsToRemove;

          if (aliasAs) {
            $scope[aliasAs] = collection;
          }

          if (isArrayLike(collection)) {
            collectionKeys = collection;
            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
          } else {
            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
            // if object, extract keys, in enumeration order, unsorted
            collectionKeys = [];
            for (var itemKey in collection) {
              if (collection.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
                collectionKeys.push(itemKey);
              }
            }
          }

          collectionLength = collectionKeys.length;
          nextBlockOrder = new Array(collectionLength);

          // locate existing items
          for (index = 0; index < collectionLength; index++) {
            key = (collection === collectionKeys) ? index : collectionKeys[index];
            value = collection[key];
            trackById = trackByIdFn(key, value, index);
            if (lastBlockMap[trackById]) {
              // found previously seen block
              block = lastBlockMap[trackById];
              delete lastBlockMap[trackById];
              nextBlockMap[trackById] = block;
              nextBlockOrder[index] = block;
            } else if (nextBlockMap[trackById]) {
              // if collision detected. restore lastBlockMap and throw an error
              forEach(nextBlockOrder, function(block) {
                if (block && block.scope) lastBlockMap[block.id] = block;
              });
              throw ngRepeatMinErr('dupes',
                  "Duplicates in a repeater are not allowed. Use 'track by' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}",
                  expression, trackById, value);
            } else {
              // new never before seen block
              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
              nextBlockMap[trackById] = true;
            }
          }

          // remove leftover items
          for (var blockKey in lastBlockMap) {
            block = lastBlockMap[blockKey];
            elementsToRemove = getBlockNodes(block.clone);
            $animate.leave(elementsToRemove);
            if (elementsToRemove[0].parentNode) {
              // if the element was not removed yet because of pending animation, mark it as deleted
              // so that we can ignore it later
              for (index = 0, length = elementsToRemove.length; index < length; index++) {
                elementsToRemove[index][NG_REMOVED] = true;
              }
            }
            block.scope.$destroy();
          }

          // we are not using forEach for perf reasons (trying to avoid #call)
          for (index = 0; index < collectionLength; index++) {
            key = (collection === collectionKeys) ? index : collectionKeys[index];
            value = collection[key];
            block = nextBlockOrder[index];

            if (block.scope) {
              // if we have already seen this object, then we need to reuse the
              // associated scope/element

              nextNode = previousNode;

              // skip nodes that are already pending removal via leave animation
              do {
                nextNode = nextNode.nextSibling;
              } while (nextNode && nextNode[NG_REMOVED]);

              if (getBlockStart(block) != nextNode) {
                // existing item which got moved
                $animate.move(getBlockNodes(block.clone), null, jqLite(previousNode));
              }
              previousNode = getBlockEnd(block);
              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
            } else {
              // new item which we don't know about
              $transclude(function ngRepeatTransclude(clone, scope) {
                block.scope = scope;
                // http://jsperf.com/clone-vs-createcomment
                var endNode = ngRepeatEndComment.cloneNode(false);
                clone[clone.length++] = endNode;

                // TODO(perf): support naked previousNode in `enter` to avoid creation of jqLite wrapper?
                $animate.enter(clone, null, jqLite(previousNode));
                previousNode = endNode;
                // Note: We only need the first/last node of the cloned nodes.
                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                // by a directive with templateUrl when its template arrives.
                block.clone = clone;
                nextBlockMap[block.id] = block;
                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
              });
            }
          }
          lastBlockMap = nextBlockMap;
        });
      };
    }
  };
}];

var NG_HIDE_CLASS = 'ng-hide';
var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
/**
 * @ngdoc directive
 * @name ngShow
 *
 * @description
 * The `ngShow` directive shows or hides the given HTML element based on the expression
 * provided to the `ngShow` attribute. The element is shown or hidden by removing or adding
 * the `.ng-hide` CSS class onto the element. The `.ng-hide` CSS class is predefined
 * in AngularJS and sets the display style to none (using an !important flag).
 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
 *
 * ```html
 * <!-- when $scope.myValue is truthy (element is visible) -->
 * <div ng-show="myValue"></div>
 *
 * <!-- when $scope.myValue is falsy (element is hidden) -->
 * <div ng-show="myValue" class="ng-hide"></div>
 * ```
 *
 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added to the class
 * attribute on the element causing it to become hidden. When truthy, the `.ng-hide` CSS class is removed
 * from the element causing the element not to appear hidden.
 *
 * ## Why is !important used?
 *
 * You may be wondering why !important is used for the `.ng-hide` CSS class. This is because the `.ng-hide` selector
 * can be easily overridden by heavier selectors. For example, something as simple
 * as changing the display style on a HTML list item would make hidden elements appear visible.
 * This also becomes a bigger issue when dealing with CSS frameworks.
 *
 * By using !important, the show and hide behavior will work as expected despite any clash between CSS selector
 * specificity (when !important isn't used with any conflicting styles). If a developer chooses to override the
 * styling to change how to hide an element then it is just a matter of using !important in their own CSS code.
 *
 * ### Overriding `.ng-hide`
 *
 * By default, the `.ng-hide` class will style the element with `display: none!important`. If you wish to change
 * the hide behavior with ngShow/ngHide then this can be achieved by restating the styles for the `.ng-hide`
 * class CSS. Note that the selector that needs to be used is actually `.ng-hide:not(.ng-hide-animate)` to cope
 * with extra animation classes that can be added.
 *
 * ```css
 * .ng-hide:not(.ng-hide-animate) {
 *   /&#42; this is just another form of hiding an element &#42;/
 *   display: block!important;
 *   position: absolute;
 *   top: -9999px;
 *   left: -9999px;
 * }
 * ```
 *
 * By default you don't need to override in CSS anything and the animations will work around the display style.
 *
 * ## A note about animations with `ngShow`
 *
 * Animations in ngShow/ngHide work with the show and hide events that are triggered when the directive expression
 * is true and false. This system works like the animation system present with ngClass except that
 * you must also include the !important flag to override the display property
 * so that you can perform an animation when the element is hidden during the time of the animation.
 *
 * ```css
 * //
 * //a working example can be found at the bottom of this page
 * //
 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
 *   /&#42; this is required as of 1.3x to properly
 *      apply all styling in a show/hide animation &#42;/
 *   transition: 0s linear all;
 * }
 *
 * .my-element.ng-hide-add-active,
 * .my-element.ng-hide-remove-active {
 *   /&#42; the transition is defined in the active class &#42;/
 *   transition: 1s linear all;
 * }
 *
 * .my-element.ng-hide-add { ... }
 * .my-element.ng-hide-add.ng-hide-add-active { ... }
 * .my-element.ng-hide-remove { ... }
 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
 * ```
 *
 * Keep in mind that, as of AngularJS version 1.3.0-beta.11, there is no need to change the display
 * property to block during animation states--ngAnimate will handle the style toggling automatically for you.
 *
 * @animations
 * addClass: `.ng-hide` - happens after the `ngShow` expression evaluates to a truthy value and the just before contents are set to visible
 * removeClass: `.ng-hide` - happens after the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden
 *
 * @element ANY
 * @param {expression} ngShow If the {@link guide/expression expression} is truthy
 *     then the element is shown or hidden respectively.
 *
 * @example
  <example module="ngAnimate" deps="angular-animate.js" animations="true">
    <file name="index.html">
      Click me: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br/>
      <div>
        Show:
        <div class="check-element animate-show" ng-show="checked">
          <span class="glyphicon glyphicon-thumbs-up"></span> I show up when your checkbox is checked.
        </div>
      </div>
      <div>
        Hide:
        <div class="check-element animate-show" ng-hide="checked">
          <span class="glyphicon glyphicon-thumbs-down"></span> I hide when your checkbox is checked.
        </div>
      </div>
    </file>
    <file name="glyphicons.css">
      @import url(../../components/bootstrap-3.1.1/css/bootstrap.css);
    </file>
    <file name="animations.css">
      .animate-show {
        line-height: 20px;
        opacity: 1;
        padding: 10px;
        border: 1px solid black;
        background: white;
      }

      .animate-show.ng-hide-add.ng-hide-add-active,
      .animate-show.ng-hide-remove.ng-hide-remove-active {
        -webkit-transition: all linear 0.5s;
        transition: all linear 0.5s;
      }

      .animate-show.ng-hide {
        line-height: 0;
        opacity: 0;
        padding: 0 10px;
      }

      .check-element {
        padding: 10px;
        border: 1px solid black;
        background: white;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var thumbsUp = element(by.css('span.glyphicon-thumbs-up'));
      var thumbsDown = element(by.css('span.glyphicon-thumbs-down'));

      it('should check ng-show / ng-hide', function() {
        expect(thumbsUp.isDisplayed()).toBeFalsy();
        expect(thumbsDown.isDisplayed()).toBeTruthy();

        element(by.model('checked')).click();

        expect(thumbsUp.isDisplayed()).toBeTruthy();
        expect(thumbsDown.isDisplayed()).toBeFalsy();
      });
    </file>
  </example>
 */
var ngShowDirective = ['$animate', function($animate) {
  return {
    restrict: 'A',
    multiElement: true,
    link: function(scope, element, attr) {
      scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
        // we're adding a temporary, animation-specific class for ng-hide since this way
        // we can control when the element is actually displayed on screen without having
        // to have a global/greedy CSS selector that breaks when other animations are run.
        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
        });
      });
    }
  };
}];


/**
 * @ngdoc directive
 * @name ngHide
 *
 * @description
 * The `ngHide` directive shows or hides the given HTML element based on the expression
 * provided to the `ngHide` attribute. The element is shown or hidden by removing or adding
 * the `ng-hide` CSS class onto the element. The `.ng-hide` CSS class is predefined
 * in AngularJS and sets the display style to none (using an !important flag).
 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
 *
 * ```html
 * <!-- when $scope.myValue is truthy (element is hidden) -->
 * <div ng-hide="myValue" class="ng-hide"></div>
 *
 * <!-- when $scope.myValue is falsy (element is visible) -->
 * <div ng-hide="myValue"></div>
 * ```
 *
 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added to the class
 * attribute on the element causing it to become hidden. When falsy, the `.ng-hide` CSS class is removed
 * from the element causing the element not to appear hidden.
 *
 * ## Why is !important used?
 *
 * You may be wondering why !important is used for the `.ng-hide` CSS class. This is because the `.ng-hide` selector
 * can be easily overridden by heavier selectors. For example, something as simple
 * as changing the display style on a HTML list item would make hidden elements appear visible.
 * This also becomes a bigger issue when dealing with CSS frameworks.
 *
 * By using !important, the show and hide behavior will work as expected despite any clash between CSS selector
 * specificity (when !important isn't used with any conflicting styles). If a developer chooses to override the
 * styling to change how to hide an element then it is just a matter of using !important in their own CSS code.
 *
 * ### Overriding `.ng-hide`
 *
 * By default, the `.ng-hide` class will style the element with `display: none!important`. If you wish to change
 * the hide behavior with ngShow/ngHide then this can be achieved by restating the styles for the `.ng-hide`
 * class in CSS:
 *
 * ```css
 * .ng-hide {
 *   /&#42; this is just another form of hiding an element &#42;/
 *   display: block!important;
 *   position: absolute;
 *   top: -9999px;
 *   left: -9999px;
 * }
 * ```
 *
 * By default you don't need to override in CSS anything and the animations will work around the display style.
 *
 * ## A note about animations with `ngHide`
 *
 * Animations in ngShow/ngHide work with the show and hide events that are triggered when the directive expression
 * is true and false. This system works like the animation system present with ngClass, except that the `.ng-hide`
 * CSS class is added and removed for you instead of your own CSS class.
 *
 * ```css
 * //
 * //a working example can be found at the bottom of this page
 * //
 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
 *   transition: 0.5s linear all;
 * }
 *
 * .my-element.ng-hide-add { ... }
 * .my-element.ng-hide-add.ng-hide-add-active { ... }
 * .my-element.ng-hide-remove { ... }
 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
 * ```
 *
 * Keep in mind that, as of AngularJS version 1.3.0-beta.11, there is no need to change the display
 * property to block during animation states--ngAnimate will handle the style toggling automatically for you.
 *
 * @animations
 * removeClass: `.ng-hide` - happens after the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden
 * addClass: `.ng-hide` - happens after the `ngHide` expression evaluates to a non truthy value and just before the contents are set to visible
 *
 * @element ANY
 * @param {expression} ngHide If the {@link guide/expression expression} is truthy then
 *     the element is shown or hidden respectively.
 *
 * @example
  <example module="ngAnimate" deps="angular-animate.js" animations="true">
    <file name="index.html">
      Click me: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br/>
      <div>
        Show:
        <div class="check-element animate-hide" ng-show="checked">
          <span class="glyphicon glyphicon-thumbs-up"></span> I show up when your checkbox is checked.
        </div>
      </div>
      <div>
        Hide:
        <div class="check-element animate-hide" ng-hide="checked">
          <span class="glyphicon glyphicon-thumbs-down"></span> I hide when your checkbox is checked.
        </div>
      </div>
    </file>
    <file name="glyphicons.css">
      @import url(../../components/bootstrap-3.1.1/css/bootstrap.css);
    </file>
    <file name="animations.css">
      .animate-hide {
        -webkit-transition: all linear 0.5s;
        transition: all linear 0.5s;
        line-height: 20px;
        opacity: 1;
        padding: 10px;
        border: 1px solid black;
        background: white;
      }

      .animate-hide.ng-hide {
        line-height: 0;
        opacity: 0;
        padding: 0 10px;
      }

      .check-element {
        padding: 10px;
        border: 1px solid black;
        background: white;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var thumbsUp = element(by.css('span.glyphicon-thumbs-up'));
      var thumbsDown = element(by.css('span.glyphicon-thumbs-down'));

      it('should check ng-show / ng-hide', function() {
        expect(thumbsUp.isDisplayed()).toBeFalsy();
        expect(thumbsDown.isDisplayed()).toBeTruthy();

        element(by.model('checked')).click();

        expect(thumbsUp.isDisplayed()).toBeTruthy();
        expect(thumbsDown.isDisplayed()).toBeFalsy();
      });
    </file>
  </example>
 */
var ngHideDirective = ['$animate', function($animate) {
  return {
    restrict: 'A',
    multiElement: true,
    link: function(scope, element, attr) {
      scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
        // The comment inside of the ngShowDirective explains why we add and
        // remove a temporary class for the show/hide animation
        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
        });
      });
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngStyle
 * @restrict AC
 *
 * @description
 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
 *
 * @element ANY
 * @param {expression} ngStyle
 *
 * {@link guide/expression Expression} which evals to an
 * object whose keys are CSS style names and values are corresponding values for those CSS
 * keys.
 *
 * Since some CSS style names are not valid keys for an object, they must be quoted.
 * See the 'background-color' style in the example below.
 *
 * @example
   <example>
     <file name="index.html">
        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
        <input type="button" value="clear" ng-click="myStyle={}">
        <br/>
        <span ng-style="myStyle">Sample Text</span>
        <pre>myStyle={{myStyle}}</pre>
     </file>
     <file name="style.css">
       span {
         color: black;
       }
     </file>
     <file name="protractor.js" type="protractor">
       var colorSpan = element(by.css('span'));

       it('should check ng-style', function() {
         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
         element(by.css('input[value=\'set color\']')).click();
         expect(colorSpan.getCssValue('color')).toBe('rgba(255, 0, 0, 1)');
         element(by.css('input[value=clear]')).click();
         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
       });
     </file>
   </example>
 */
var ngStyleDirective = ngDirective(function(scope, element, attr) {
  scope.$watch(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
    if (oldStyles && (newStyles !== oldStyles)) {
      forEach(oldStyles, function(val, style) { element.css(style, '');});
    }
    if (newStyles) element.css(newStyles);
  }, true);
});

/**
 * @ngdoc directive
 * @name ngSwitch
 * @restrict EA
 *
 * @description
 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
 * as specified in the template.
 *
 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
 * matches the value obtained from the evaluated expression. In other words, you define a container element
 * (where you place the directive), place an expression on the **`on="..."` attribute**
 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
 * attribute is displayed.
 *
 * <div class="alert alert-info">
 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
 * as literal string values to match against.
 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
 * value of the expression `$scope.someVal`.
 * </div>

 * @animations
 * enter - happens after the ngSwitch contents change and the matched child element is placed inside the container
 * leave - happens just after the ngSwitch contents change and just before the former contents are removed from the DOM
 *
 * @usage
 *
 * ```
 * <ANY ng-switch="expression">
 *   <ANY ng-switch-when="matchValue1">...</ANY>
 *   <ANY ng-switch-when="matchValue2">...</ANY>
 *   <ANY ng-switch-default>...</ANY>
 * </ANY>
 * ```
 *
 *
 * @scope
 * @priority 1200
 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
 * On child elements add:
 *
 * * `ngSwitchWhen`: the case statement to match against. If match then this
 *   case will be displayed. If the same match appears multiple times, all the
 *   elements will be displayed.
 * * `ngSwitchDefault`: the default case when no other case match. If there
 *   are multiple default cases, all of them will be displayed when no other
 *   case match.
 *
 *
 * @example
  <example module="switchExample" deps="angular-animate.js" animations="true">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <select ng-model="selection" ng-options="item for item in items">
        </select>
        <code>selection={{selection}}</code>
        <hr/>
        <div class="animate-switch-container"
          ng-switch on="selection">
            <div class="animate-switch" ng-switch-when="settings">Settings Div</div>
            <div class="animate-switch" ng-switch-when="home">Home Span</div>
            <div class="animate-switch" ng-switch-default>default</div>
        </div>
      </div>
    </file>
    <file name="script.js">
      angular.module('switchExample', ['ngAnimate'])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.items = ['settings', 'home', 'other'];
          $scope.selection = $scope.items[0];
        }]);
    </file>
    <file name="animations.css">
      .animate-switch-container {
        position:relative;
        background:white;
        border:1px solid black;
        height:40px;
        overflow:hidden;
      }

      .animate-switch {
        padding:10px;
      }

      .animate-switch.ng-animate {
        -webkit-transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;

        position:absolute;
        top:0;
        left:0;
        right:0;
        bottom:0;
      }

      .animate-switch.ng-leave.ng-leave-active,
      .animate-switch.ng-enter {
        top:-50px;
      }
      .animate-switch.ng-leave,
      .animate-switch.ng-enter.ng-enter-active {
        top:0;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var switchElem = element(by.css('[ng-switch]'));
      var select = element(by.model('selection'));

      it('should start in settings', function() {
        expect(switchElem.getText()).toMatch(/Settings Div/);
      });
      it('should change to home', function() {
        select.all(by.css('option')).get(1).click();
        expect(switchElem.getText()).toMatch(/Home Span/);
      });
      it('should select default', function() {
        select.all(by.css('option')).get(2).click();
        expect(switchElem.getText()).toMatch(/default/);
      });
    </file>
  </example>
 */
var ngSwitchDirective = ['$animate', function($animate) {
  return {
    require: 'ngSwitch',

    // asks for $scope to fool the BC controller module
    controller: ['$scope', function ngSwitchController() {
     this.cases = {};
    }],
    link: function(scope, element, attr, ngSwitchController) {
      var watchExpr = attr.ngSwitch || attr.on,
          selectedTranscludes = [],
          selectedElements = [],
          previousLeaveAnimations = [],
          selectedScopes = [];

      var spliceFactory = function(array, index) {
          return function() { array.splice(index, 1); };
      };

      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
        var i, ii;
        for (i = 0, ii = previousLeaveAnimations.length; i < ii; ++i) {
          $animate.cancel(previousLeaveAnimations[i]);
        }
        previousLeaveAnimations.length = 0;

        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
          var selected = getBlockNodes(selectedElements[i].clone);
          selectedScopes[i].$destroy();
          var promise = previousLeaveAnimations[i] = $animate.leave(selected);
          promise.then(spliceFactory(previousLeaveAnimations, i));
        }

        selectedElements.length = 0;
        selectedScopes.length = 0;

        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
          forEach(selectedTranscludes, function(selectedTransclude) {
            selectedTransclude.transclude(function(caseElement, selectedScope) {
              selectedScopes.push(selectedScope);
              var anchor = selectedTransclude.element;
              caseElement[caseElement.length++] = document.createComment(' end ngSwitchWhen: ');
              var block = { clone: caseElement };

              selectedElements.push(block);
              $animate.enter(caseElement, anchor.parent(), anchor);
            });
          });
        }
      });
    }
  };
}];

var ngSwitchWhenDirective = ngDirective({
  transclude: 'element',
  priority: 1200,
  require: '^ngSwitch',
  multiElement: true,
  link: function(scope, element, attrs, ctrl, $transclude) {
    ctrl.cases['!' + attrs.ngSwitchWhen] = (ctrl.cases['!' + attrs.ngSwitchWhen] || []);
    ctrl.cases['!' + attrs.ngSwitchWhen].push({ transclude: $transclude, element: element });
  }
});

var ngSwitchDefaultDirective = ngDirective({
  transclude: 'element',
  priority: 1200,
  require: '^ngSwitch',
  multiElement: true,
  link: function(scope, element, attr, ctrl, $transclude) {
    ctrl.cases['?'] = (ctrl.cases['?'] || []);
    ctrl.cases['?'].push({ transclude: $transclude, element: element });
   }
});

/**
 * @ngdoc directive
 * @name ngTransclude
 * @restrict EAC
 *
 * @description
 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
 *
 * Any existing content of the element that this directive is placed on will be removed before the transcluded content is inserted.
 *
 * @element ANY
 *
 * @example
   <example module="transcludeExample">
     <file name="index.html">
       <script>
         angular.module('transcludeExample', [])
          .directive('pane', function(){
             return {
               restrict: 'E',
               transclude: true,
               scope: { title:'@' },
               template: '<div style="border: 1px solid black;">' +
                           '<div style="background-color: gray">{{title}}</div>' +
                           '<ng-transclude></ng-transclude>' +
                         '</div>'
             };
         })
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.title = 'Lorem Ipsum';
           $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
         }]);
       </script>
       <div ng-controller="ExampleController">
         <input ng-model="title" aria-label="title"> <br/>
         <textarea ng-model="text" aria-label="text"></textarea> <br/>
         <pane title="{{title}}">{{text}}</pane>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
        it('should have transcluded', function() {
          var titleElement = element(by.model('title'));
          titleElement.clear();
          titleElement.sendKeys('TITLE');
          var textElement = element(by.model('text'));
          textElement.clear();
          textElement.sendKeys('TEXT');
          expect(element(by.binding('title')).getText()).toEqual('TITLE');
          expect(element(by.binding('text')).getText()).toEqual('TEXT');
        });
     </file>
   </example>
 *
 */
var ngTranscludeDirective = ngDirective({
  restrict: 'EAC',
  link: function($scope, $element, $attrs, controller, $transclude) {
    if (!$transclude) {
      throw minErr('ngTransclude')('orphan',
       'Illegal use of ngTransclude directive in the template! ' +
       'No parent directive that requires a transclusion found. ' +
       'Element: {0}',
       startingTag($element));
    }

    $transclude(function(clone) {
      $element.empty();
      $element.append(clone);
    });
  }
});

/**
 * @ngdoc directive
 * @name script
 * @restrict E
 *
 * @description
 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
 *
 * @param {string} type Must be set to `'text/ng-template'`.
 * @param {string} id Cache name of the template.
 *
 * @example
  <example>
    <file name="index.html">
      <script type="text/ng-template" id="/tpl.html">
        Content of the template.
      </script>

      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
      <div id="tpl-content" ng-include src="currentTpl"></div>
    </file>
    <file name="protractor.js" type="protractor">
      it('should load template defined inside script tag', function() {
        element(by.css('#tpl-link')).click();
        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
      });
    </file>
  </example>
 */
var scriptDirective = ['$templateCache', function($templateCache) {
  return {
    restrict: 'E',
    terminal: true,
    compile: function(element, attr) {
      if (attr.type == 'text/ng-template') {
        var templateUrl = attr.id,
            text = element[0].text;

        $templateCache.put(templateUrl, text);
      }
    }
  };
}];

var noopNgModelController = { $setViewValue: noop, $render: noop };

/**
 * @ngdoc type
 * @name  select.SelectController
 * @description
 * The controller for the `<select>` directive. This provides support for reading
 * and writing the selected value(s) of the control and also coordinates dynamically
 * added `<option>` elements, perhaps by an `ngRepeat` directive.
 */
var SelectController =
        ['$element', '$scope', '$attrs', function($element, $scope, $attrs) {

  var self = this,
      optionsMap = new HashMap();

  // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
  self.ngModelCtrl = noopNgModelController;

  // The "unknown" option is one that is prepended to the list if the viewValue
  // does not match any of the options. When it is rendered the value of the unknown
  // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
  //
  // We can't just jqLite('<option>') since jqLite is not smart enough
  // to create it in <select> and IE barfs otherwise.
  self.unknownOption = jqLite(document.createElement('option'));
  self.renderUnknownOption = function(val) {
    var unknownVal = '? ' + hashKey(val) + ' ?';
    self.unknownOption.val(unknownVal);
    $element.prepend(self.unknownOption);
    $element.val(unknownVal);
  };

  $scope.$on('$destroy', function() {
    // disable unknown option so that we don't do work when the whole select is being destroyed
    self.renderUnknownOption = noop;
  });

  self.removeUnknownOption = function() {
    if (self.unknownOption.parent()) self.unknownOption.remove();
  };


  // Read the value of the select control, the implementation of this changes depending
  // upon whether the select can have multiple values and whether ngOptions is at work.
  self.readValue = function readSingleValue() {
    self.removeUnknownOption();
    return $element.val();
  };


  // Write the value to the select control, the implementation of this changes depending
  // upon whether the select can have multiple values and whether ngOptions is at work.
  self.writeValue = function writeSingleValue(value) {
    if (self.hasOption(value)) {
      self.removeUnknownOption();
      $element.val(value);
      if (value === '') self.emptyOption.prop('selected', true); // to make IE9 happy
    } else {
      if (value == null && self.emptyOption) {
        self.removeUnknownOption();
        $element.val('');
      } else {
        self.renderUnknownOption(value);
      }
    }
  };


  // Tell the select control that an option, with the given value, has been added
  self.addOption = function(value, element) {
    assertNotHasOwnProperty(value, '"option value"');
    if (value === '') {
      self.emptyOption = element;
    }
    var count = optionsMap.get(value) || 0;
    optionsMap.put(value, count + 1);
  };

  // Tell the select control that an option, with the given value, has been removed
  self.removeOption = function(value) {
    var count = optionsMap.get(value);
    if (count) {
      if (count === 1) {
        optionsMap.remove(value);
        if (value === '') {
          self.emptyOption = undefined;
        }
      } else {
        optionsMap.put(value, count - 1);
      }
    }
  };

  // Check whether the select control has an option matching the given value
  self.hasOption = function(value) {
    return !!optionsMap.get(value);
  };
}];

/**
 * @ngdoc directive
 * @name select
 * @restrict E
 *
 * @description
 * HTML `SELECT` element with angular data-binding.
 *
 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits such as reducing
 * memory and increasing speed by not creating a new scope for each repeated instance, as well as providing
 * more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
 * comprehension expression.
 *
 * When an item in the `<select>` menu is selected, the array element or object property
 * represented by the selected option will be bound to the model identified by the `ngModel`
 * directive.
 *
 * If the viewValue contains a value that doesn't match any of the options then the control
 * will automatically add an "unknown" option, which it then removes when this is resolved.
 *
 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
 * option. See example below for demonstration.
 *
 * <div class="alert alert-info">
 * The value of a `select` directive used without `ngOptions` is always a string.
 * When the model needs to be bound to a non-string value, you must either explictly convert it
 * using a directive (see example below) or use `ngOptions` to specify the set of options.
 * This is because an option element can only be bound to string values at present.
 * </div>
 *
 * ### Example (binding `select` to a non-string value)
 *
 * <example name="select-with-non-string-options" module="nonStringSelect">
 *   <file name="index.html">
 *     <select ng-model="model.id" convert-to-number>
 *       <option value="0">Zero</option>
 *       <option value="1">One</option>
 *       <option value="2">Two</option>
 *     </select>
 *     {{ model }}
 *   </file>
 *   <file name="app.js">
 *     angular.module('nonStringSelect', [])
 *       .run(function($rootScope) {
 *         $rootScope.model = { id: 2 };
 *       })
 *       .directive('convertToNumber', function() {
 *         return {
 *           require: 'ngModel',
 *           link: function(scope, element, attrs, ngModel) {
 *             ngModel.$parsers.push(function(val) {
 *               return parseInt(val, 10);
 *             });
 *             ngModel.$formatters.push(function(val) {
 *               return '' + val;
 *             });
 *           }
 *         };
 *       });
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it('should initialize to model', function() {
 *       var select = element(by.css('select'));
 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
 *     });
 *   </file>
 * </example>
 *
 */
var selectDirective = function() {

  return {
    restrict: 'E',
    require: ['select', '?ngModel'],
    controller: SelectController,
    link: function(scope, element, attr, ctrls) {

      // if ngModel is not defined, we don't need to do anything
      var ngModelCtrl = ctrls[1];
      if (!ngModelCtrl) return;

      var selectCtrl = ctrls[0];

      selectCtrl.ngModelCtrl = ngModelCtrl;

      // We delegate rendering to the `writeValue` method, which can be changed
      // if the select can have multiple selected values or if the options are being
      // generated by `ngOptions`
      ngModelCtrl.$render = function() {
        selectCtrl.writeValue(ngModelCtrl.$viewValue);
      };

      // When the selected item(s) changes we delegate getting the value of the select control
      // to the `readValue` method, which can be changed if the select can have multiple
      // selected values or if the options are being generated by `ngOptions`
      element.on('change', function() {
        scope.$apply(function() {
          ngModelCtrl.$setViewValue(selectCtrl.readValue());
        });
      });

      // If the select allows multiple values then we need to modify how we read and write
      // values from and to the control; also what it means for the value to be empty and
      // we have to add an extra watch since ngModel doesn't work well with arrays - it
      // doesn't trigger rendering if only an item in the array changes.
      if (attr.multiple) {

        // Read value now needs to check each option to see if it is selected
        selectCtrl.readValue = function readMultipleValue() {
          var array = [];
          forEach(element.find('option'), function(option) {
            if (option.selected) {
              array.push(option.value);
            }
          });
          return array;
        };

        // Write value now needs to set the selected property of each matching option
        selectCtrl.writeValue = function writeMultipleValue(value) {
          var items = new HashMap(value);
          forEach(element.find('option'), function(option) {
            option.selected = isDefined(items.get(option.value));
          });
        };

        // we have to do it on each watch since ngModel watches reference, but
        // we need to work of an array, so we need to see if anything was inserted/removed
        var lastView, lastViewRef = NaN;
        scope.$watch(function selectMultipleWatch() {
          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
            lastView = shallowCopy(ngModelCtrl.$viewValue);
            ngModelCtrl.$render();
          }
          lastViewRef = ngModelCtrl.$viewValue;
        });

        // If we are a multiple select then value is now a collection
        // so the meaning of $isEmpty changes
        ngModelCtrl.$isEmpty = function(value) {
          return !value || value.length === 0;
        };

      }
    }
  };
};


// The option directive is purely designed to communicate the existence (or lack of)
// of dynamically created (and destroyed) option elements to their containing select
// directive via its controller.
var optionDirective = ['$interpolate', function($interpolate) {

  function chromeHack(optionElement) {
    // Workaround for https://code.google.com/p/chromium/issues/detail?id=381459
    // Adding an <option selected="selected"> element to a <select required="required"> should
    // automatically select the new element
    if (optionElement[0].hasAttribute('selected')) {
      optionElement[0].selected = true;
    }
  }

  return {
    restrict: 'E',
    priority: 100,
    compile: function(element, attr) {

      // If the value attribute is not defined then we fall back to the
      // text content of the option element, which may be interpolated
      if (isUndefined(attr.value)) {
        var interpolateFn = $interpolate(element.text(), true);
        if (!interpolateFn) {
          attr.$set('value', element.text());
        }
      }

      return function(scope, element, attr) {

        // This is an optimization over using ^^ since we don't want to have to search
        // all the way to the root of the DOM for every single option element
        var selectCtrlName = '$selectController',
            parent = element.parent(),
            selectCtrl = parent.data(selectCtrlName) ||
              parent.parent().data(selectCtrlName); // in case we are in optgroup

        // Only update trigger option updates if this is an option within a `select`
        // that also has `ngModel` attached
        if (selectCtrl && selectCtrl.ngModelCtrl) {

          if (interpolateFn) {
            scope.$watch(interpolateFn, function interpolateWatchAction(newVal, oldVal) {
              attr.$set('value', newVal);
              if (oldVal !== newVal) {
                selectCtrl.removeOption(oldVal);
              }
              selectCtrl.addOption(newVal, element);
              selectCtrl.ngModelCtrl.$render();
              chromeHack(element);
            });
          } else {
            selectCtrl.addOption(attr.value, element);
            selectCtrl.ngModelCtrl.$render();
            chromeHack(element);
          }

          element.on('$destroy', function() {
            selectCtrl.removeOption(attr.value);
            selectCtrl.ngModelCtrl.$render();
          });
        }
      };
    }
  };
}];

var styleDirective = valueFn({
  restrict: 'E',
  terminal: false
});

var requiredDirective = function() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;
      attr.required = true; // force truthy in case we are on non input element

      ctrl.$validators.required = function(modelValue, viewValue) {
        return !attr.required || !ctrl.$isEmpty(viewValue);
      };

      attr.$observe('required', function() {
        ctrl.$validate();
      });
    }
  };
};


var patternDirective = function() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;

      var regexp, patternExp = attr.ngPattern || attr.pattern;
      attr.$observe('pattern', function(regex) {
        if (isString(regex) && regex.length > 0) {
          regex = new RegExp('^' + regex + '$');
        }

        if (regex && !regex.test) {
          throw minErr('ngPattern')('noregexp',
            'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
            regex, startingTag(elm));
        }

        regexp = regex || undefined;
        ctrl.$validate();
      });

      ctrl.$validators.pattern = function(value) {
        return ctrl.$isEmpty(value) || isUndefined(regexp) || regexp.test(value);
      };
    }
  };
};


var maxlengthDirective = function() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;

      var maxlength = -1;
      attr.$observe('maxlength', function(value) {
        var intVal = toInt(value);
        maxlength = isNaN(intVal) ? -1 : intVal;
        ctrl.$validate();
      });
      ctrl.$validators.maxlength = function(modelValue, viewValue) {
        return (maxlength < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlength);
      };
    }
  };
};

var minlengthDirective = function() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;

      var minlength = 0;
      attr.$observe('minlength', function(value) {
        minlength = toInt(value) || 0;
        ctrl.$validate();
      });
      ctrl.$validators.minlength = function(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlength;
      };
    }
  };
};

  if (window.angular.bootstrap) {
    //AngularJS is already loaded, so we can return here...
    console.log('WARNING: Tried to load angular more than once.');
    return;
  }

  //try to bind to jquery now so that one can write jqLite(document).ready()
  //but we will rebind on bootstrap again.
  bindJQuery();

  publishExternalAPI(angular);

  jqLite(document).ready(function() {
    angularInit(document, bootstrap);
  });

})(window, document);

!window.angular.$$csp() && window.angular.element(document).find('head').prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}</style>');

/***/ }),
/* 29 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

/*
 * Configure routes, ect.
 * todo: На данный момент разработка всегда ведется в режиме production,
 * todo: либо настроить разработку в development режиме, либо удалить все условия связанные с ENV === 'development'
 */

angular.module("siter.io").config(["$locationProvider", "$stateProvider", "$urlRouterProvider", "$provide", "growlProvider", "$httpProvider", "RestangularProvider", "NotificationProvider", "$cookiesProvider", "$sceDelegateProvider", "ivhTreeviewOptionsProvider", "$translateProvider", function ($locationProvider, $stateProvider, $urlRouterProvider, $provide, growlProvider, $httpProvider, RestangularProvider, NotificationProvider, $cookiesProvider, $sceDelegateProvider, ivhTreeviewOptionsProvider, $translateProvider) {

  // Set normal url
  $locationProvider.html5Mode(false);

  // Tree library config
  ivhTreeviewOptionsProvider.set({
    useCheckboxes: true,
    defaultSelectedState: false,
    twistieExpandedTpl: '<img src="/constructor/editor/assets/images/openedfolder-icon.png" style="opacity:0.7" />',
    twistieCollapsedTpl: '<img src="/constructor/editor/assets/images/folder-icon.png" />',
    twistieLeafTpl: '',
    labelAttribute: "label"
  });

  // Log function, error function
  window.log = function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    console.log.apply(console, args);
  };
  window.err = function (message) {
    throw new Error(message);
  };

  // Notifications
  NotificationProvider.setOptions({
    delay: 5000,
    startTop: 20,
    startRight: 10,
    verticalSpacing: 20,
    horizontalSpacing: 20,
    positionX: 'left',
    positionY: 'top'
  });

  var devHosts = ["lvh.me:4000", "localhost:8080", "localhost:4000"];

  // set env
  if (document.location.host in devHosts) {
    window.ENV = "development";
  } else {
    window.ENV = "production";
  }

  // Restangular configs
  if (window.ENV === "development") {
    host = "/v1";
  } else {
    host = window.justclick.apiURL;
  }

  // set cookies config
  $cookiesProvider.defaults.path = document.location.href;
  $cookiesProvider.defaults.domain = document.location.host;

  RestangularProvider.setBaseUrl(host);

  if (ENV === "development") {
    $translateProvider.useLoader('TranslationLoader', {
      prefix: '/assets/languages/locale-',
      suffix: '.json'
    });
  } else {
    $translateProvider.useLoader('TranslationLoader', {
      prefix: '/constructor/editor/assets/languages/locale-',
      suffix: '.json'
    });
  }

  $translateProvider.preferredLanguage(window.justclick.locale);
  $translateProvider.registerAvailableLanguageKeys(['ru', 'en', 'es'], { 'ru_*': 'ru', 'en_*': 'en', 'es_*': 'es' });
  $translateProvider.fallbackLanguage('en');
  $translateProvider.useSanitizeValueStrategy('escapeParameters');

  $sceDelegateProvider.resourceUrlWhitelist(['**']);

  // Errors interceptor
  $httpProvider.interceptors.push("errorsInterceptor");

  // Routes
  $stateProvider.state('404', {
    url: '/404',
    templateUrl: './common/templates/404.jade',
    auth: true
  })
  // New site pages
  .state('root', {
    url: '/site',
    templateUrl: './site/site.jade',
    abstract: true,
    auth: true
  }).state('root.site', {
    url: '/:siteId',
    templateUrl: './site/site.jade',
    controller: 'Sites',
    abstract: true,
    auth: true
  }).state('admin', {
    url: '/admin',
    templateUrl: './common/templates/layout.jade',
    abstract: true,
    auth: true
  })
  // Dashboard
  .state('admin.dashboard', {
    url: '/dashboard',
    controller: "Dashboard",
    templateUrl: './dashboard/dashboard.jade'
  }).state('admin.dashboard.templates', {
    url: '/templates',
    templateUrl: './dashboard/list.jade'
  }).state('admin.dashboard.sections', {
    url: '/sections',
    templateUrl: './dashboard/list2.jade'
  }).state('admin.dashboard.images', {
    url: '/images',
    templateUrl: './dashboard/list3.jade'
  }).state('admin.dashboard.emails', {
    url: '/emails',
    templateUrl: './dashboard/list4.jade'
  }).state('admin.dashboard.emailSections', {
    url: '/email_sections',
    templateUrl: './dashboard/list5.jade',
    title: "Секции для писем"
  }).state('admin.dashboard.webForms', {
    url: '/web_forms',
    controller: "DashboardWebForms",
    templateUrl: './dashboard/webFormsList.jade',
    title: "Веб-формы"
  }).state('admin.dashboard.lessons', {
    url: '/lms_pages',
    controller: "DashboardLessons",
    templateUrl: './dashboard/lessonsList.jade',
    title: "Lms"
  }).state('admin.dashboard.lessonSections', {
    url: '/lms_page_sections',
    controller: "DashboardLessonSections",
    templateUrl: './dashboard/lessonSectionsList.jade',
    title: "Секции Lms"
  })
  // site
  .state("site", {
    url: "/sites/:siteId",
    controller: "Sites",
    templateUrl: './editor/editorLayout.jade',
    auth: true
  }).state("site.page", {
    url: "/:pageId",
    templateUrl: "./editor/pageLayout.jade",
    abstract: true,
    auth: true
  }).state("site.page.editor", {
    url: "/editor",
    controller: "EditorCtrl",
    templateUrl: "./editor/editor.jade",
    auth: true
  }).state("site.page.mixer", {
    url: "/mixer",
    controller: "EditorCtrl",
    templateUrl: "./editor/editor.jade",
    auth: true,
    title: "Микшер"
  }).state("lesson.page.mixer", {
    url: "/mixer",
    controller: "EditorLessonCtrl",
    templateUrl: "./editor/editorLesson.jade",
    auth: true,
    title: "Микшер"
  })
  // editor
  .state("editor", {
    url: '/editor',
    templateUrl: './editor/editorLayout.jade',
    abstract: true,
    auth: true
  }).state("editor.section", {
    url: "/:sectionId",
    controller: "EditorCtrl",
    templateUrl: "./editor/editor.jade",
    auth: true
  })
  // Editor email
  .state("email", {
    url: "/emails/:emailId",
    controller: "Emails",
    templateUrl: './editor/editorLayout.jade',
    auth: true
  }).state("email.page", {
    url: "/:pageId",
    templateUrl: "./editor/pageLayout.jade",
    abstract: true,
    auth: true,
    title: "Страница"
  }).state("email.page.editor", {
    url: "/editor",
    controller: "EditorEmailCtrl",
    templateUrl: "./editor/editorEmail.jade",
    auth: true,
    title: "Редактор"
  })
  // Editor form
  .state("form", {
    url: "/web_forms/:formId",
    controller: "Forms",
    templateUrl: './editor/editorLayout.jade',
    auth: true
  }).state("form.page", {
    url: "/:pageId",
    templateUrl: "./editor/pageLayout.jade",
    auth: true,
    abstract: true,
    title: "Страница"
  }).state("form.page.editor", {
    url: "/editor",
    controller: "EditorFormCtrl",
    templateUrl: "./editor/editorForm.jade",
    auth: true,
    title: "Редактор"
  })
  // Editor lessons
  .state("lesson", {
    url: "/lms_pages/:lessonId",
    controller: "Lessons",
    templateUrl: './editor/editorLayout.jade',
    auth: true
  }).state("lesson.page", {
    url: "/:pageId",
    templateUrl: "./editor/pageLayout.jade",
    auth: true,
    abstract: true,
    title: "Страница"
  }).state("lesson.page.editor", {
    url: "/editor",
    controller: "EditorLessonCtrl",
    templateUrl: "./editor/editorLesson.jade",
    auth: true,
    title: "Редактор"
  });

  $urlRouterProvider.otherwise('/');

  // notification timeout
  growlProvider.globalTimeToLive(5000);
}]);

/***/ }),
/* 30 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

/*
 * Module siter.io
 */

angular.module('siter.io', ['ui.bootstrap', 'ui.tree', 'ui-notification', 'ngLocale', 'restangular', 'ui.router', 'cgBusy', 'infinite-scroll', 'angularFileUpload', 'contenteditable', 'angular-growl', 'ngAnimate', 'ngCookies', 'editor', 'ivh.treeview', 'pascalprecht.translate', 'tmh.dynamicLocale', 'ngTagsInput', 'ng']);

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {


/* injects from baggage-loader */

/*
 * Run after loading modules
 */

angular.module("siter.io").run(["$rootScope", "$state", "$timeout", "$stateParams", "$modal", "$window", "$location", "Restangular", "growl", "$locale", "$cookies", "$http", "TplCache", "Auth", "$templateCache", "Intercom", function ($rootScope, $state, $timeout, $stateParams, $modal, $window, $location, Restangular, growl, $locale, $cookies, $http, TplCache, Auth, $templateCache, Intercom) {

  $locale.id = 'ru-ru';

  Auth.check();
  Intercom.init();

  $rootScope.originHost = document.location.origin;
  $rootScope.logout = Auth.logout;
  $rootScope.$on("$stateChangeSuccess", function () {
    $rootScope.title = $state.current.title;
  });
  $rootScope.$on('$stateChangeStart', function (event, next) {
    Auth.isReadyLogged()["catch"](function () {
      if (next.auth) {
        return $location.path('/');
      }
    });
  });

  $rootScope.$on('current:user', function () {
    if ($state.current.name.indexOf('admin.dashboard') === 0 && $rootScope.currentUser.role === 'client') {
      $location.path('/404');
    }
  });

  var token = window.justclick.currentUser.authentication_token;

  Restangular.setDefaultHeaders({ "X-AUTH-TOKEN": token });
  $cookies.put("auth_token", token);

  /**
   * Метод для загрузки всех шаблонов
   * @param requireContext
   * @returns {Array|*}
   */
  var requireAll = function requireAll(requireContext) {
    return requireContext.keys().map(function (val) {
      return { tpl: requireContext(val), name: val };
    });
  };

  var jades = requireAll(__webpack_require__(444));

  jades.map(function (val) {
    $templateCache.put(val.name, val.tpl);
  });
}]);

/***/ }),
/* 32 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

/*
 angular-file-upload v1.1.5
 https://github.com/nervgh/angular-file-upload
*/

var module = angular.module('angularFileUpload', []);

'use strict';

/**
 * Classes
 *
 * FileUploader
 * FileUploader.FileLikeObject
 * FileUploader.FileItem
 * FileUploader.FileDirective
 * FileUploader.FileSelect
 * FileUploader.FileDrop
 * FileUploader.FileOver
 */

module.value('fileUploaderOptions', {
    url: '/',
    alias: 'file',
    headers: {},
    queue: [],
    progress: 0,
    autoUpload: false,
    removeAfterUpload: false,
    method: 'POST',
    filters: [],
    formData: [],
    queueLimit: Number.MAX_VALUE,
    withCredentials: false
}).factory('FileUploader', ['fileUploaderOptions', '$rootScope', '$http', '$window', '$compile', function (fileUploaderOptions, $rootScope, $http, $window, $compile) {
    /**
     * Creates an instance of FileUploader
     * @param {Object} [options]
     * @constructor
     */
    function FileUploader(options) {
        var settings = angular.copy(fileUploaderOptions);
        angular.extend(this, settings, options, {
            isUploading: false,
            _nextIndex: 0,
            _failFilterIndex: -1,
            _directives: { select: [], drop: [], over: [] }
        });

        // add default filters
        this.filters.unshift({ name: 'queueLimit', fn: this._queueLimitFilter });
        this.filters.unshift({ name: 'folder', fn: this._folderFilter });
    }
    /**********************
     * PUBLIC
     **********************/
    /**
     * Checks a support the html5 uploader
     * @returns {Boolean}
     * @readonly
     */
    FileUploader.prototype.isHTML5 = !!($window.File && $window.FormData);
    /**
     * Adds items to the queue
     * @param {File|HTMLInputElement|Object|FileList|Array<Object>} files
     * @param {Object} [options]
     * @param {Array<Function>|String} filters
     */
    FileUploader.prototype.addToQueue = function (files, options, filters) {
        var list = this.isArrayLikeObject(files) ? files : [files];
        var arrayOfFilters = this._getFilters(filters);
        var count = this.queue.length;
        var addedFileItems = [];

        angular.forEach(list, function (some /*{File|HTMLInputElement|Object}*/) {
            var temp = new FileUploader.FileLikeObject(some);

            if (this._isValidFile(temp, arrayOfFilters, options)) {
                var fileItem = new FileUploader.FileItem(this, some, options);
                addedFileItems.push(fileItem);
                this.queue.push(fileItem);
                this._onAfterAddingFile(fileItem);
            } else {
                var filter = this.filters[this._failFilterIndex];
                this._onWhenAddingFileFailed(temp, filter, options);
            }
        }, this);

        if (this.queue.length !== count) {
            this._onAfterAddingAll(addedFileItems);
            this.progress = this._getTotalProgress();
        }

        this._render();
        if (this.autoUpload) this.uploadAll();
    };
    /**
     * Remove items from the queue. Remove last: index = -1
     * @param {FileItem|Number} value
     */
    FileUploader.prototype.removeFromQueue = function (value) {
        var index = this.getIndexOfItem(value);
        var item = this.queue[index];
        if (item.isUploading) item.cancel();
        this.queue.splice(index, 1);
        item._destroy();
        this.progress = this._getTotalProgress();
    };
    /**
     * Clears the queue
     */
    FileUploader.prototype.clearQueue = function () {
        while (this.queue.length) {
            this.queue[0].remove();
        }
        this.progress = 0;
    };
    /**
     * Uploads a item from the queue
     * @param {FileItem|Number} value
     */
    FileUploader.prototype.uploadItem = function (value) {
        var index = this.getIndexOfItem(value);
        var item = this.queue[index];
        var transport = this.isHTML5 ? '_xhrTransport' : '_iframeTransport';

        item._prepareToUploading();
        if (this.isUploading) return;

        this.isUploading = true;
        this[transport](item);
    };
    /**
     * Cancels uploading of item from the queue
     * @param {FileItem|Number} value
     */
    FileUploader.prototype.cancelItem = function (value) {
        var index = this.getIndexOfItem(value);
        var item = this.queue[index];
        var prop = this.isHTML5 ? '_xhr' : '_form';
        if (item && item.isUploading) item[prop].abort();
    };
    /**
     * Uploads all not uploaded items of queue
     */
    FileUploader.prototype.uploadAll = function () {
        var items = this.getNotUploadedItems().filter(function (item) {
            return !item.isUploading;
        });
        if (!items.length) return;

        angular.forEach(items, function (item) {
            item._prepareToUploading();
        });
        items[0].upload();
    };
    /**
     * Cancels all uploads
     */
    FileUploader.prototype.cancelAll = function () {
        var items = this.getNotUploadedItems();
        angular.forEach(items, function (item) {
            item.cancel();
        });
    };
    /**
     * Returns "true" if value an instance of File
     * @param {*} value
     * @returns {Boolean}
     * @private
     */
    FileUploader.prototype.isFile = function (value) {
        var fn = $window.File;
        return fn && value instanceof fn;
    };
    /**
     * Returns "true" if value an instance of FileLikeObject
     * @param {*} value
     * @returns {Boolean}
     * @private
     */
    FileUploader.prototype.isFileLikeObject = function (value) {
        return value instanceof FileUploader.FileLikeObject;
    };
    /**
     * Returns "true" if value is array like object
     * @param {*} value
     * @returns {Boolean}
     */
    FileUploader.prototype.isArrayLikeObject = function (value) {
        return angular.isObject(value) && 'length' in value;
    };
    /**
     * Returns a index of item from the queue
     * @param {Item|Number} value
     * @returns {Number}
     */
    FileUploader.prototype.getIndexOfItem = function (value) {
        return angular.isNumber(value) ? value : this.queue.indexOf(value);
    };
    /**
     * Returns not uploaded items
     * @returns {Array}
     */
    FileUploader.prototype.getNotUploadedItems = function () {
        return this.queue.filter(function (item) {
            return !item.isUploaded;
        });
    };
    /**
     * Returns items ready for upload
     * @returns {Array}
     */
    FileUploader.prototype.getReadyItems = function () {
        return this.queue.filter(function (item) {
            return item.isReady && !item.isUploading;
        }).sort(function (item1, item2) {
            return item1.index - item2.index;
        });
    };
    /**
     * Destroys instance of FileUploader
     */
    FileUploader.prototype.destroy = function () {
        angular.forEach(this._directives, function (key) {
            angular.forEach(this._directives[key], function (object) {
                object.destroy();
            }, this);
        }, this);
    };
    /**
     * Callback
     * @param {Array} fileItems
     */
    FileUploader.prototype.onAfterAddingAll = function (fileItems) {};
    /**
     * Callback
     * @param {FileItem} fileItem
     */
    FileUploader.prototype.onAfterAddingFile = function (fileItem) {};
    /**
     * Callback
     * @param {File|Object} item
     * @param {Object} filter
     * @param {Object} options
     * @private
     */
    FileUploader.prototype.onWhenAddingFileFailed = function (item, filter, options) {};
    /**
     * Callback
     * @param {FileItem} fileItem
     */
    FileUploader.prototype.onBeforeUploadItem = function (fileItem) {};
    /**
     * Callback
     * @param {FileItem} fileItem
     * @param {Number} progress
     */
    FileUploader.prototype.onProgressItem = function (fileItem, progress) {};
    /**
     * Callback
     * @param {Number} progress
     */
    FileUploader.prototype.onProgressAll = function (progress) {};
    /**
     * Callback
     * @param {FileItem} item
     * @param {*} response
     * @param {Number} status
     * @param {Object} headers
     */
    FileUploader.prototype.onSuccessItem = function (item, response, status, headers) {};
    /**
     * Callback
     * @param {FileItem} item
     * @param {*} response
     * @param {Number} status
     * @param {Object} headers
     */
    FileUploader.prototype.onErrorItem = function (item, response, status, headers) {};
    /**
     * Callback
     * @param {FileItem} item
     * @param {*} response
     * @param {Number} status
     * @param {Object} headers
     */
    FileUploader.prototype.onCancelItem = function (item, response, status, headers) {};
    /**
     * Callback
     * @param {FileItem} item
     * @param {*} response
     * @param {Number} status
     * @param {Object} headers
     */
    FileUploader.prototype.onCompleteItem = function (item, response, status, headers) {};
    /**
     * Callback
     */
    FileUploader.prototype.onCompleteAll = function () {};
    /**********************
     * PRIVATE
     **********************/
    /**
     * Returns the total progress
     * @param {Number} [value]
     * @returns {Number}
     * @private
     */
    FileUploader.prototype._getTotalProgress = function (value) {
        if (this.removeAfterUpload) return value || 0;

        var notUploaded = this.getNotUploadedItems().length;
        var uploaded = notUploaded ? this.queue.length - notUploaded : this.queue.length;
        var ratio = 100 / this.queue.length;
        var current = (value || 0) * ratio / 100;

        return Math.round(uploaded * ratio + current);
    };
    /**
     * Returns array of filters
     * @param {Array<Function>|String} filters
     * @returns {Array<Function>}
     * @private
     */
    FileUploader.prototype._getFilters = function (filters) {
        if (angular.isUndefined(filters)) return this.filters;
        if (angular.isArray(filters)) return filters;
        var names = filters.match(/[^\s,]+/g);
        return this.filters.filter(function (filter) {
            return names.indexOf(filter.name) !== -1;
        }, this);
    };
    /**
     * Updates html
     * @private
     */
    FileUploader.prototype._render = function () {
        if (!$rootScope.$$phase) $rootScope.$apply();
    };
    /**
     * Returns "true" if item is a file (not folder)
     * @param {File|FileLikeObject} item
     * @returns {Boolean}
     * @private
     */
    FileUploader.prototype._folderFilter = function (item) {
        return !!(item.size || item.type);
    };
    /**
     * Returns "true" if the limit has not been reached
     * @returns {Boolean}
     * @private
     */
    FileUploader.prototype._queueLimitFilter = function () {
        return this.queue.length < this.queueLimit;
    };
    /**
     * Returns "true" if file pass all filters
     * @param {File|Object} file
     * @param {Array<Function>} filters
     * @param {Object} options
     * @returns {Boolean}
     * @private
     */
    FileUploader.prototype._isValidFile = function (file, filters, options) {
        this._failFilterIndex = -1;
        return !filters.length ? true : filters.every(function (filter) {
            this._failFilterIndex++;
            return filter.fn.call(this, file, options);
        }, this);
    };
    /**
     * Checks whether upload successful
     * @param {Number} status
     * @returns {Boolean}
     * @private
     */
    FileUploader.prototype._isSuccessCode = function (status) {
        return status >= 200 && status < 300 || status === 304;
    };
    /**
     * Transforms the server response
     * @param {*} response
     * @param {Object} headers
     * @returns {*}
     * @private
     */
    FileUploader.prototype._transformResponse = function (response, headers) {
        var headersGetter = this._headersGetter(headers);
        angular.forEach($http.defaults.transformResponse, function (transformFn) {
            response = transformFn(response, headersGetter);
        });
        return response;
    };
    /**
     * Parsed response headers
     * @param headers
     * @returns {Object}
     * @see https://github.com/angular/angular.js/blob/master/src/ng/http.js
     * @private
     */
    FileUploader.prototype._parseHeaders = function (headers) {
        var parsed = {},
            key,
            val,
            i;

        if (!headers) return parsed;

        angular.forEach(headers.split('\n'), function (line) {
            i = line.indexOf(':');
            key = line.slice(0, i).trim().toLowerCase();
            val = line.slice(i + 1).trim();

            if (key) {
                parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
            }
        });

        return parsed;
    };
    /**
     * Returns function that returns headers
     * @param {Object} parsedHeaders
     * @returns {Function}
     * @private
     */
    FileUploader.prototype._headersGetter = function (parsedHeaders) {
        return function (name) {
            if (name) {
                return parsedHeaders[name.toLowerCase()] || null;
            }
            return parsedHeaders;
        };
    };
    /**
     * The XMLHttpRequest transport
     * @param {FileItem} item
     * @private
     */
    FileUploader.prototype._xhrTransport = function (item) {
        var xhr = item._xhr = new XMLHttpRequest();
        var form = new FormData();
        var that = this;

        that._onBeforeUploadItem(item);

        angular.forEach(item.formData, function (obj) {
            angular.forEach(obj, function (value, key) {
                form.append(key, value);
            });
        });

        form.append(item.alias, item._file, item.file.name);

        xhr.upload.onprogress = function (event) {
            var progress = Math.round(event.lengthComputable ? event.loaded * 100 / event.total : 0);
            that._onProgressItem(item, progress);
        };

        xhr.onload = function () {
            var headers = that._parseHeaders(xhr.getAllResponseHeaders());
            var response = that._transformResponse(xhr.response, headers);
            var gist = that._isSuccessCode(xhr.status) ? 'Success' : 'Error';
            var method = '_on' + gist + 'Item';
            that[method](item, response, xhr.status, headers);
            that._onCompleteItem(item, response, xhr.status, headers);
        };

        xhr.onerror = function () {
            var headers = that._parseHeaders(xhr.getAllResponseHeaders());
            var response = that._transformResponse(xhr.response, headers);
            that._onErrorItem(item, response, xhr.status, headers);
            that._onCompleteItem(item, response, xhr.status, headers);
        };

        xhr.onabort = function () {
            var headers = that._parseHeaders(xhr.getAllResponseHeaders());
            var response = that._transformResponse(xhr.response, headers);
            that._onCancelItem(item, response, xhr.status, headers);
            that._onCompleteItem(item, response, xhr.status, headers);
        };

        xhr.open(item.method, item.url, true);

        xhr.withCredentials = item.withCredentials;

        angular.forEach(item.headers, function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.send(form);
        this._render();
    };
    /**
     * The IFrame transport
     * @param {FileItem} item
     * @private
     */
    FileUploader.prototype._iframeTransport = function (item) {
        var form = angular.element('<form style="display: none;" />');
        var iframe = angular.element('<iframe name="iframeTransport' + Date.now() + '">');
        var input = item._input;
        var that = this;

        if (item._form) item._form.replaceWith(input); // remove old form
        item._form = form; // save link to new form

        that._onBeforeUploadItem(item);

        input.prop('name', item.alias);

        angular.forEach(item.formData, function (obj) {
            angular.forEach(obj, function (value, key) {
                var element = angular.element('<input type="hidden" name="' + key + '" />');
                element.val(value);
                form.append(element);
            });
        });

        form.prop({
            action: item.url,
            method: 'POST',
            target: iframe.prop('name'),
            enctype: 'multipart/form-data',
            encoding: 'multipart/form-data' // old IE
        });

        iframe.bind('load', function () {
            try {
                // Fix for legacy IE browsers that loads internal error page
                // when failed WS response received. In consequence iframe
                // content access denied error is thrown becouse trying to
                // access cross domain page. When such thing occurs notifying
                // with empty response object. See more info at:
                // http://stackoverflow.com/questions/151362/access-is-denied-error-on-accessing-iframe-document-object
                // Note that if non standard 4xx or 5xx error code returned
                // from WS then response content can be accessed without error
                // but 'XHR' status becomes 200. In order to avoid confusion
                // returning response via same 'success' event handler.

                // fixed angular.contents() for iframes
                var html = iframe[0].contentDocument.body.innerHTML;
            } catch (e) {}

            var xhr = { response: html, status: 200, dummy: true };
            var headers = {};
            var response = that._transformResponse(xhr.response, headers);

            that._onSuccessItem(item, response, xhr.status, headers);
            that._onCompleteItem(item, response, xhr.status, headers);
        });

        form.abort = function () {
            var xhr = { status: 0, dummy: true };
            var headers = {};
            var response;

            iframe.unbind('load').prop('src', 'javascript:false;');
            form.replaceWith(input);

            that._onCancelItem(item, response, xhr.status, headers);
            that._onCompleteItem(item, response, xhr.status, headers);
        };

        input.after(form);
        form.append(input).append(iframe);

        form[0].submit();
        this._render();
    };
    /**
     * Inner callback
     * @param {File|Object} item
     * @param {Object} filter
     * @param {Object} options
     * @private
     */
    FileUploader.prototype._onWhenAddingFileFailed = function (item, filter, options) {
        this.onWhenAddingFileFailed(item, filter, options);
    };
    /**
     * Inner callback
     * @param {FileItem} item
     */
    FileUploader.prototype._onAfterAddingFile = function (item) {
        this.onAfterAddingFile(item);
    };
    /**
     * Inner callback
     * @param {Array<FileItem>} items
     */
    FileUploader.prototype._onAfterAddingAll = function (items) {
        this.onAfterAddingAll(items);
    };
    /**
     *  Inner callback
     * @param {FileItem} item
     * @private
     */
    FileUploader.prototype._onBeforeUploadItem = function (item) {
        item._onBeforeUpload();
        this.onBeforeUploadItem(item);
    };
    /**
     * Inner callback
     * @param {FileItem} item
     * @param {Number} progress
     * @private
     */
    FileUploader.prototype._onProgressItem = function (item, progress) {
        var total = this._getTotalProgress(progress);
        this.progress = total;
        item._onProgress(progress);
        this.onProgressItem(item, progress);
        this.onProgressAll(total);
        this._render();
    };
    /**
     * Inner callback
     * @param {FileItem} item
     * @param {*} response
     * @param {Number} status
     * @param {Object} headers
     * @private
     */
    FileUploader.prototype._onSuccessItem = function (item, response, status, headers) {
        item._onSuccess(response, status, headers);
        this.onSuccessItem(item, response, status, headers);
    };
    /**
     * Inner callback
     * @param {FileItem} item
     * @param {*} response
     * @param {Number} status
     * @param {Object} headers
     * @private
     */
    FileUploader.prototype._onErrorItem = function (item, response, status, headers) {
        item._onError(response, status, headers);
        this.onErrorItem(item, response, status, headers);
    };
    /**
     * Inner callback
     * @param {FileItem} item
     * @param {*} response
     * @param {Number} status
     * @param {Object} headers
     * @private
     */
    FileUploader.prototype._onCancelItem = function (item, response, status, headers) {
        item._onCancel(response, status, headers);
        this.onCancelItem(item, response, status, headers);
    };
    /**
     * Inner callback
     * @param {FileItem} item
     * @param {*} response
     * @param {Number} status
     * @param {Object} headers
     * @private
     */
    FileUploader.prototype._onCompleteItem = function (item, response, status, headers) {
        item._onComplete(response, status, headers);
        this.onCompleteItem(item, response, status, headers);

        var nextItem = this.getReadyItems()[0];
        this.isUploading = false;

        if (angular.isDefined(nextItem)) {
            nextItem.upload();
            return;
        }

        this.onCompleteAll();
        this.progress = this._getTotalProgress();
        this._render();
    };
    /**********************
     * STATIC
     **********************/
    /**
     * @borrows FileUploader.prototype.isFile
     */
    FileUploader.isFile = FileUploader.prototype.isFile;
    /**
     * @borrows FileUploader.prototype.isFileLikeObject
     */
    FileUploader.isFileLikeObject = FileUploader.prototype.isFileLikeObject;
    /**
     * @borrows FileUploader.prototype.isArrayLikeObject
     */
    FileUploader.isArrayLikeObject = FileUploader.prototype.isArrayLikeObject;
    /**
     * @borrows FileUploader.prototype.isHTML5
     */
    FileUploader.isHTML5 = FileUploader.prototype.isHTML5;
    /**
     * Inherits a target (Class_1) by a source (Class_2)
     * @param {Function} target
     * @param {Function} source
     */
    FileUploader.inherit = function (target, source) {
        target.prototype = Object.create(source.prototype);
        target.prototype.constructor = target;
        target.super_ = source;
    };
    FileUploader.FileLikeObject = FileLikeObject;
    FileUploader.FileItem = FileItem;
    FileUploader.FileDirective = FileDirective;
    FileUploader.FileSelect = FileSelect;
    FileUploader.FileDrop = FileDrop;
    FileUploader.FileOver = FileOver;

    // ---------------------------

    /**
     * Creates an instance of FileLikeObject
     * @param {File|HTMLInputElement|Object} fileOrInput
     * @constructor
     */
    function FileLikeObject(fileOrInput) {
        var isInput = angular.isElement(fileOrInput);
        var fakePathOrObject = isInput ? fileOrInput.value : fileOrInput;
        var postfix = angular.isString(fakePathOrObject) ? 'FakePath' : 'Object';
        var method = '_createFrom' + postfix;
        this[method](fakePathOrObject);
    }

    /**
     * Creates file like object from fake path string
     * @param {String} path
     * @private
     */
    FileLikeObject.prototype._createFromFakePath = function (path) {
        this.lastModifiedDate = null;
        this.size = null;
        this.type = 'like/' + path.slice(path.lastIndexOf('.') + 1).toLowerCase();
        this.name = path.slice(path.lastIndexOf('/') + path.lastIndexOf('\\') + 2);
    };
    /**
     * Creates file like object from object
     * @param {File|FileLikeObject} object
     * @private
     */
    FileLikeObject.prototype._createFromObject = function (object) {
        this.lastModifiedDate = angular.copy(object.lastModifiedDate);
        this.size = object.size;
        this.type = object.type;
        this.name = object.name;
    };

    // ---------------------------

    /**
     * Creates an instance of FileItem
     * @param {FileUploader} uploader
     * @param {File|HTMLInputElement|Object} some
     * @param {Object} options
     * @constructor
     */
    function FileItem(uploader, some, options) {
        var isInput = angular.isElement(some);
        var input = isInput ? angular.element(some) : null;
        var file = !isInput ? some : null;

        angular.extend(this, {
            url: uploader.url,
            alias: uploader.alias,
            headers: angular.copy(uploader.headers),
            formData: angular.copy(uploader.formData),
            removeAfterUpload: uploader.removeAfterUpload,
            withCredentials: uploader.withCredentials,
            method: uploader.method
        }, options, {
            uploader: uploader,
            file: new FileUploader.FileLikeObject(some),
            isReady: false,
            isUploading: false,
            isUploaded: false,
            isSuccess: false,
            isCancel: false,
            isError: false,
            progress: 0,
            index: null,
            _file: file,
            _input: input
        });

        if (input) this._replaceNode(input);
    }
    /**********************
     * PUBLIC
     **********************/
    /**
     * Uploads a FileItem
     */
    FileItem.prototype.upload = function () {
        this.uploader.uploadItem(this);
    };
    /**
     * Cancels uploading of FileItem
     */
    FileItem.prototype.cancel = function () {
        this.uploader.cancelItem(this);
    };
    /**
     * Removes a FileItem
     */
    FileItem.prototype.remove = function () {
        this.uploader.removeFromQueue(this);
    };
    /**
     * Callback
     * @private
     */
    FileItem.prototype.onBeforeUpload = function () {};
    /**
     * Callback
     * @param {Number} progress
     * @private
     */
    FileItem.prototype.onProgress = function (progress) {};
    /**
     * Callback
     * @param {*} response
     * @param {Number} status
     * @param {Object} headers
     */
    FileItem.prototype.onSuccess = function (response, status, headers) {};
    /**
     * Callback
     * @param {*} response
     * @param {Number} status
     * @param {Object} headers
     */
    FileItem.prototype.onError = function (response, status, headers) {};
    /**
     * Callback
     * @param {*} response
     * @param {Number} status
     * @param {Object} headers
     */
    FileItem.prototype.onCancel = function (response, status, headers) {};
    /**
     * Callback
     * @param {*} response
     * @param {Number} status
     * @param {Object} headers
     */
    FileItem.prototype.onComplete = function (response, status, headers) {};
    /**********************
     * PRIVATE
     **********************/
    /**
     * Inner callback
     */
    FileItem.prototype._onBeforeUpload = function () {
        this.isReady = true;
        this.isUploading = true;
        this.isUploaded = false;
        this.isSuccess = false;
        this.isCancel = false;
        this.isError = false;
        this.progress = 0;
        this.onBeforeUpload();
    };
    /**
     * Inner callback
     * @param {Number} progress
     * @private
     */
    FileItem.prototype._onProgress = function (progress) {
        this.progress = progress;
        this.onProgress(progress);
    };
    /**
     * Inner callback
     * @param {*} response
     * @param {Number} status
     * @param {Object} headers
     * @private
     */
    FileItem.prototype._onSuccess = function (response, status, headers) {
        this.isReady = false;
        this.isUploading = false;
        this.isUploaded = true;
        this.isSuccess = true;
        this.isCancel = false;
        this.isError = false;
        this.progress = 100;
        this.index = null;
        this.onSuccess(response, status, headers);
    };
    /**
     * Inner callback
     * @param {*} response
     * @param {Number} status
     * @param {Object} headers
     * @private
     */
    FileItem.prototype._onError = function (response, status, headers) {
        this.isReady = false;
        this.isUploading = false;
        this.isUploaded = true;
        this.isSuccess = false;
        this.isCancel = false;
        this.isError = true;
        this.progress = 0;
        this.index = null;
        this.onError(response, status, headers);
    };
    /**
     * Inner callback
     * @param {*} response
     * @param {Number} status
     * @param {Object} headers
     * @private
     */
    FileItem.prototype._onCancel = function (response, status, headers) {
        this.isReady = false;
        this.isUploading = false;
        this.isUploaded = false;
        this.isSuccess = false;
        this.isCancel = true;
        this.isError = false;
        this.progress = 0;
        this.index = null;
        this.onCancel(response, status, headers);
    };
    /**
     * Inner callback
     * @param {*} response
     * @param {Number} status
     * @param {Object} headers
     * @private
     */
    FileItem.prototype._onComplete = function (response, status, headers) {
        this.onComplete(response, status, headers);
        if (this.removeAfterUpload) this.remove();
    };
    /**
     * Destroys a FileItem
     */
    FileItem.prototype._destroy = function () {
        if (this._input) this._input.remove();
        if (this._form) this._form.remove();
        delete this._form;
        delete this._input;
    };
    /**
     * Prepares to uploading
     * @private
     */
    FileItem.prototype._prepareToUploading = function () {
        this.index = this.index || ++this.uploader._nextIndex;
        this.isReady = true;
    };
    /**
     * Replaces input element on his clone
     * @param {JQLite|jQuery} input
     * @private
     */
    FileItem.prototype._replaceNode = function (input) {
        var clone = $compile(input.clone())(input.scope());
        clone.prop('value', null); // FF fix
        input.css('display', 'none');
        input.after(clone); // remove jquery dependency
    };

    // ---------------------------

    /**
     * Creates instance of {FileDirective} object
     * @param {Object} options
     * @param {Object} options.uploader
     * @param {HTMLElement} options.element
     * @param {Object} options.events
     * @param {String} options.prop
     * @constructor
     */
    function FileDirective(options) {
        angular.extend(this, options);
        this.uploader._directives[this.prop].push(this);
        this._saveLinks();
        this.bind();
    }
    /**
     * Map of events
     * @type {Object}
     */
    FileDirective.prototype.events = {};
    /**
     * Binds events handles
     */
    FileDirective.prototype.bind = function () {
        for (var key in this.events) {
            var prop = this.events[key];
            this.element.bind(key, this[prop]);
        }
    };
    /**
     * Unbinds events handles
     */
    FileDirective.prototype.unbind = function () {
        for (var key in this.events) {
            this.element.unbind(key, this.events[key]);
        }
    };
    /**
     * Destroys directive
     */
    FileDirective.prototype.destroy = function () {
        var index = this.uploader._directives[this.prop].indexOf(this);
        this.uploader._directives[this.prop].splice(index, 1);
        this.unbind();
        // this.element = null;
    };
    /**
     * Saves links to functions
     * @private
     */
    FileDirective.prototype._saveLinks = function () {
        for (var key in this.events) {
            var prop = this.events[key];
            this[prop] = this[prop].bind(this);
        }
    };

    // ---------------------------

    FileUploader.inherit(FileSelect, FileDirective);

    /**
     * Creates instance of {FileSelect} object
     * @param {Object} options
     * @constructor
     */
    function FileSelect(options) {
        FileSelect.super_.apply(this, arguments);

        if (!this.uploader.isHTML5) {
            this.element.removeAttr('multiple');
        }
        this.element.prop('value', null); // FF fix
    }
    /**
     * Map of events
     * @type {Object}
     */
    FileSelect.prototype.events = {
        $destroy: 'destroy',
        change: 'onChange'
    };
    /**
     * Name of property inside uploader._directive object
     * @type {String}
     */
    FileSelect.prototype.prop = 'select';
    /**
     * Returns options
     * @return {Object|undefined}
     */
    FileSelect.prototype.getOptions = function () {};
    /**
     * Returns filters
     * @return {Array<Function>|String|undefined}
     */
    FileSelect.prototype.getFilters = function () {};
    /**
     * If returns "true" then HTMLInputElement will be cleared
     * @returns {Boolean}
     */
    FileSelect.prototype.isEmptyAfterSelection = function () {
        return !!this.element.attr('multiple');
    };
    /**
     * Event handler
     */
    FileSelect.prototype.onChange = function () {
        var files = this.uploader.isHTML5 ? this.element[0].files : this.element[0];
        var options = this.getOptions();
        var filters = this.getFilters();

        if (!this.uploader.isHTML5) this.destroy();
        this.uploader.addToQueue(files, options, filters);
        if (this.isEmptyAfterSelection()) this.element.prop('value', null);
    };

    // ---------------------------

    FileUploader.inherit(FileDrop, FileDirective);

    /**
     * Creates instance of {FileDrop} object
     * @param {Object} options
     * @constructor
     */
    function FileDrop(options) {
        FileDrop.super_.apply(this, arguments);
    }
    /**
     * Map of events
     * @type {Object}
     */
    FileDrop.prototype.events = {
        $destroy: 'destroy',
        drop: 'onDrop',
        dragover: 'onDragOver',
        dragleave: 'onDragLeave'
    };
    /**
     * Name of property inside uploader._directive object
     * @type {String}
     */
    FileDrop.prototype.prop = 'drop';
    /**
     * Returns options
     * @return {Object|undefined}
     */
    FileDrop.prototype.getOptions = function () {};
    /**
     * Returns filters
     * @return {Array<Function>|String|undefined}
     */
    FileDrop.prototype.getFilters = function () {};
    /**
     * Event handler
     */
    FileDrop.prototype.onDrop = function (event) {
        var transfer = this._getTransfer(event);
        if (!transfer) return;
        var options = this.getOptions();
        var filters = this.getFilters();
        this._preventAndStop(event);
        angular.forEach(this.uploader._directives.over, this._removeOverClass, this);
        this.uploader.addToQueue(transfer.files, options, filters);
    };
    /**
     * Event handler
     */
    FileDrop.prototype.onDragOver = function (event) {
        var transfer = this._getTransfer(event);
        if (!this._haveFiles(transfer.types)) return;
        transfer.dropEffect = 'copy';
        this._preventAndStop(event);
        angular.forEach(this.uploader._directives.over, this._addOverClass, this);
    };
    /**
     * Event handler
     */
    FileDrop.prototype.onDragLeave = function (event) {
        if (event.currentTarget !== this.element[0]) return;
        this._preventAndStop(event);
        angular.forEach(this.uploader._directives.over, this._removeOverClass, this);
    };
    /**
     * Helper
     */
    FileDrop.prototype._getTransfer = function (event) {
        return event.dataTransfer ? event.dataTransfer : event.originalEvent.dataTransfer; // jQuery fix;
    };
    /**
     * Helper
     */
    FileDrop.prototype._preventAndStop = function (event) {
        event.preventDefault();
        event.stopPropagation();
    };
    /**
     * Returns "true" if types contains files
     * @param {Object} types
     */
    FileDrop.prototype._haveFiles = function (types) {
        if (!types) return false;
        if (types.indexOf) {
            return types.indexOf('Files') !== -1;
        } else if (types.contains) {
            return types.contains('Files');
        } else {
            return false;
        }
    };
    /**
     * Callback
     */
    FileDrop.prototype._addOverClass = function (item) {
        item.addOverClass();
    };
    /**
     * Callback
     */
    FileDrop.prototype._removeOverClass = function (item) {
        item.removeOverClass();
    };

    // ---------------------------

    FileUploader.inherit(FileOver, FileDirective);

    /**
     * Creates instance of {FileDrop} object
     * @param {Object} options
     * @constructor
     */
    function FileOver(options) {
        FileOver.super_.apply(this, arguments);
    }
    /**
     * Map of events
     * @type {Object}
     */
    FileOver.prototype.events = {
        $destroy: 'destroy'
    };
    /**
     * Name of property inside uploader._directive object
     * @type {String}
     */
    FileOver.prototype.prop = 'over';
    /**
     * Over class
     * @type {string}
     */
    FileOver.prototype.overClass = 'nv-file-over';
    /**
     * Adds over class
     */
    FileOver.prototype.addOverClass = function () {
        this.element.addClass(this.getOverClass());
    };
    /**
     * Removes over class
     */
    FileOver.prototype.removeOverClass = function () {
        this.element.removeClass(this.getOverClass());
    };
    /**
     * Returns over class
     * @returns {String}
     */
    FileOver.prototype.getOverClass = function () {
        return this.overClass;
    };

    return FileUploader;
}]).directive('nvFileSelect', ['$parse', 'FileUploader', function ($parse, FileUploader) {
    return {
        link: function link(scope, element, attributes) {
            var uploader = scope.$eval(attributes.uploader);

            if (!(uploader instanceof FileUploader)) {
                throw new TypeError('"Uploader" must be an instance of FileUploader');
            }

            var object = new FileUploader.FileSelect({
                uploader: uploader,
                element: element
            });

            object.getOptions = $parse(attributes.options).bind(object, scope);
            object.getFilters = function () {
                return attributes.filters;
            };
        }
    };
}]).directive('nvFileDrop', ['$parse', 'FileUploader', function ($parse, FileUploader) {
    return {
        link: function link(scope, element, attributes) {
            var uploader = scope.$eval(attributes.uploader);

            if (!(uploader instanceof FileUploader)) {
                throw new TypeError('"Uploader" must be an instance of FileUploader');
            }

            if (!uploader.isHTML5) return;

            var object = new FileUploader.FileDrop({
                uploader: uploader,
                element: element
            });

            object.getOptions = $parse(attributes.options).bind(object, scope);
            object.getFilters = function () {
                return attributes.filters;
            };
        }
    };
}]).directive('nvFileOver', ['FileUploader', function (FileUploader) {
    return {
        link: function link(scope, element, attributes) {
            var uploader = scope.$eval(attributes.uploader);

            if (!(uploader instanceof FileUploader)) {
                throw new TypeError('"Uploader" must be an instance of FileUploader');
            }

            var object = new FileUploader.FileOver({
                uploader: uploader,
                element: element
            });

            object.getOverClass = function () {
                return attributes.overClass || this.overClass;
            };
        }
    };
}]);

// return module;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* injects from baggage-loader */

/**
 * @package   PickMeUp - jQuery datepicker plugin
 * @author    Nazar Mokrynskyi <nazar@mokrynskyi.com>
 * @author    Stefan Petre <www.eyecon.ro>
 * @copyright Copyright (c) 2013-2015, Nazar Mokrynskyi
 * @copyright Copyright (c) 2008-2009, Stefan Petre
 * @license   MIT License, see license.txt
 */

(function (d) {
  function getMaxDays() {
    var tmpDate = new Date(this.toString()),
        d = 28,
        m = tmpDate.getMonth();
    while (tmpDate.getMonth() == m) {
      ++d;
      tmpDate.setDate(d);
    }
    return d - 1;
  }
  d.addDays = function (n) {
    this.setDate(this.getDate() + n);
  };
  d.addMonths = function (n) {
    var day = this.getDate();
    this.setDate(1);
    this.setMonth(this.getMonth() + n);
    this.setDate(Math.min(day, getMaxDays.apply(this)));
  };
  d.addYears = function (n) {
    var day = this.getDate();
    this.setDate(1);
    this.setFullYear(this.getFullYear() + n);
    this.setDate(Math.min(day, getMaxDays.apply(this)));
  };
  d.getDayOfYear = function () {
    var now = new Date(this.getFullYear(), this.getMonth(), this.getDate(), 0, 0, 0);
    var then = new Date(this.getFullYear(), 0, 0, 0, 0, 0);
    var time = now - then;
    return Math.floor(time / 24 * 60 * 60 * 1000);
  };
})(Date.prototype);

(function (factory) {
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
    // CommonJS
    factory(require('jquery'));
  } else {
    // Browser globals
    factory(jQuery);
  }
})(function ($) {
  var instances_count = 0;
  $.pickmeup = $.extend($.pickmeup || {}, {
    date: new Date(),
    default_date: new Date(),
    flat: false,
    first_day: 1,
    prev: '&#9664;',
    next: '&#9654;',
    mode: 'single',
    select_year: true,
    select_month: true,
    select_day: true,
    view: 'days',
    calendars: 1,
    format: 'd-m-Y',
    position: 'bottom',
    trigger_event: 'click touchstart',
    class_name: '',
    separator: ' - ',
    hide_on_select: false,
    min: null,
    max: null,
    render: function render() {},
    change: function change() {
      return true;
    },
    before_show: function before_show() {
      return true;
    },
    show: function show() {
      return true;
    },
    hide: function hide() {
      return true;
    },
    fill: function fill() {
      return true;
    },
    locale: {
      days: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье'],
      daysShort: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'вс'],
      daysMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
      months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
      months_s: ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'],
      monthsShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек']
      // days   : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      // daysShort  : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      // daysMin    : ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
      // months   : ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      // monthsShort  : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    }
  });
  var views = {
    years: 'pmu-view-years',
    months: 'pmu-view-months',
    days: 'pmu-view-days'
  },
      tpl = {
    wrapper: '<div class="pickmeup arrow arrow_small arrow_white arrow_pickmeup" />',
    head: function head(d) {
      var result = '';
      for (var i = 0; i < 7; ++i) {
        result += '<div>' + d.day[i] + '</div>';
      }
      return '<div class="pmu-instance">' + '<nav>' + '<div class="pmu-prev pmu-button">' + d.prev + '</div>' + '<div class="pmu-month pmu-button" />' + '<div class="pmu-next pmu-button">' + d.next + '</div>' + '</nav>' + '<nav class="pmu-day-of-week">' + result + '</nav>' + '</div>';
    },
    body: function body(elements, container_class_name) {
      var result = '';
      for (var i = 0; i < elements.length; ++i) {
        result += '<div class="' + elements[i].class_name + ' pmu-button">' + elements[i].text + '</div>';
      }
      return '<div class="' + container_class_name + '">' + result + '</div>';
    }
  };
  function fill() {
    var options = $(this).data('pickmeup-options'),
        pickmeup = this.pickmeup,
        current_cal = Math.floor(options.calendars / 2),
        actual_date = options.date,
        current_date = options.current,
        min_date = options.min ? new Date(options.min) : null,
        max_date = options.max ? new Date(options.max) : null,
        local_date,
        header,
        html,
        instance,
        today = new Date().setHours(0, 0, 0, 0).valueOf(),
        shown_date_from,
        shown_date_to,
        tmp_date;
    if (min_date) {
      min_date.setDate(1);
      min_date.addMonths(1);
      min_date.addDays(-1);
    }
    if (max_date) {
      max_date.setDate(1);
      max_date.addMonths(1);
      max_date.addDays(-1);
    }
    /**
     * Remove old content except header navigation
     */
    pickmeup.find('.pmu-instance > :not(nav)').remove();
    /**
     * If several calendars should be shown
     */
    for (var i = 0; i < options.calendars; i++) {
      local_date = new Date(current_date);
      instance = pickmeup.find('.pmu-instance').eq(i);
      if (pickmeup.hasClass('pmu-view-years')) {
        local_date.addYears((i - current_cal) * 12);
        header = local_date.getFullYear() - 6 + ' - ' + (local_date.getFullYear() + 5);
      } else if (pickmeup.hasClass('pmu-view-months')) {
        local_date.addYears(i - current_cal);
        header = local_date.getFullYear();
      } else if (pickmeup.hasClass('pmu-view-days')) {
        local_date.addMonths(i - current_cal);
        header = formatDate(local_date, 'B, Y', options.locale);
      }
      if (!shown_date_to) {
        if (max_date) {
          // If all dates in this month (months in year or years in years block) are after max option - set next month as current
          // in order not to show calendar with all disabled dates
          tmp_date = new Date(local_date);
          if (options.select_day) {
            tmp_date.addMonths(options.calendars - 1);
          } else if (options.select_month) {
            tmp_date.addYears(options.calendars - 1);
          } else {
            tmp_date.addYears((options.calendars - 1) * 12);
          }
          if (tmp_date > max_date) {
            --i;
            current_date.addMonths(-1);
            shown_date_to = undefined;
            continue;
          }
        }
      }
      shown_date_to = new Date(local_date);
      if (!shown_date_from) {
        shown_date_from = new Date(local_date);
        // If all dates in this month are before min option - set next month as current in order not to show calendar with all disabled dates
        shown_date_from.setDate(1);
        shown_date_from.addMonths(1);
        shown_date_from.addDays(-1);
        if (min_date && min_date > shown_date_from) {
          --i;
          current_date.addMonths(1);
          shown_date_from = undefined;
          continue;
        }
      }
      instance.find('.pmu-month').text(header);
      html = '';
      var is_year_selected = function is_year_selected(year) {
        return options.mode == 'range' && year >= new Date(actual_date[0]).getFullYear() && year <= new Date(actual_date[1]).getFullYear() || options.mode == 'multiple' && actual_date.reduce(function (prev, current) {
          prev.push(new Date(current).getFullYear());
          return prev;
        }, []).indexOf(year) !== -1 || new Date(actual_date).getFullYear() == year;
      };
      var is_months_selected = function is_months_selected(year, month) {
        var first_year = new Date(actual_date[0]).getFullYear(),
            lastyear = new Date(actual_date[1]).getFullYear(),
            first_month = new Date(actual_date[0]).getMonth(),
            last_month = new Date(actual_date[1]).getMonth();
        return options.mode == 'range' && year > first_year && year < lastyear || options.mode == 'range' && year == first_year && year < lastyear && month >= first_month || options.mode == 'range' && year > first_year && year == lastyear && month <= last_month || options.mode == 'range' && year == first_year && year == lastyear && month >= first_month && month <= last_month || options.mode == 'multiple' && actual_date.reduce(function (prev, current) {
          current = new Date(current);
          prev.push(current.getFullYear() + '-' + current.getMonth());
          return prev;
        }, []).indexOf(year + '-' + month) !== -1 || new Date(actual_date).getFullYear() == year && new Date(actual_date).getMonth() == month;
      };
      (function () {
        var years = [],
            start_from_year = local_date.getFullYear() - 6,
            min_year = new Date(options.min).getFullYear(),
            max_year = new Date(options.max).getFullYear(),
            year;
        for (var j = 0; j < 12; ++j) {
          year = {
            text: start_from_year + j,
            class_name: []
          };
          if (options.min && year.text < min_year || options.max && year.text > max_year) {
            year.class_name.push('pmu-disabled');
          } else if (is_year_selected(year.text)) {
            year.class_name.push('pmu-selected');
          }
          year.class_name = year.class_name.join(' ');
          years.push(year);
        }
        html += tpl.body(years, 'pmu-years');
      })();
      (function () {
        var months = [],
            current_year = local_date.getFullYear(),
            min_year = new Date(options.min).getFullYear(),
            min_month = new Date(options.min).getMonth(),
            max_year = new Date(options.max).getFullYear(),
            max_month = new Date(options.max).getMonth(),
            month;
        for (var j = 0; j < 12; ++j) {
          month = {
            text: options.locale.monthsShort[j],
            class_name: []
          };
          if (options.min && (current_year < min_year || j < min_month && current_year == min_year) || options.max && (current_year > max_year || j > max_month && current_year >= max_year)) {
            month.class_name.push('pmu-disabled');
          } else if (is_months_selected(current_year, j)) {
            month.class_name.push('pmu-selected');
          }
          month.class_name = month.class_name.join(' ');
          months.push(month);
        }
        html += tpl.body(months, 'pmu-months');
      })();
      (function () {
        var days = [],
            current_month = local_date.getMonth(),
            day;
        // Correct first day in calendar taking into account first day of week (Sunday or Monday)
        (function () {
          local_date.setDate(1);
          var day = (local_date.getDay() - options.first_day) % 7;
          local_date.addDays(-(day + (day < 0 ? 7 : 0)));
        })();
        for (var j = 0; j < 42; ++j) {
          dayParse = local_date.getDate();
          day = {
            text: parseInt(dayParse, 10) < 10 ? '0' + dayParse : dayParse,
            class_name: []
          };
          if (current_month != local_date.getMonth()) {
            day.class_name.push('pmu-not-in-month');
          }
          if (local_date.getDay() == 0) {
            day.class_name.push('pmu-sunday');
          } else if (local_date.getDay() == 6) {
            day.class_name.push('pmu-saturday');
          }
          var from_user = options.render(new Date(local_date)) || {},
              val = local_date.valueOf(),
              disabled = options.min && options.min > local_date || options.max && options.max < local_date;
          if (from_user.disabled || disabled) {
            day.class_name.push('pmu-disabled');
          } else if (from_user.selected || options.date == val || $.inArray(val, options.date) !== -1 || options.mode == 'range' && val >= options.date[0] && val <= options.date[1]) {
            day.class_name.push('pmu-selected');
          }
          if (val == today) {
            day.class_name.push('pmu-today');
          }
          if (from_user.class_name) {
            day.class_name.push(from_user.class_name);
          }
          day.class_name = day.class_name.join(' ');
          days.push(day);
          // Move to next day
          local_date.addDays(1);
        }
        html += tpl.body(days, 'pmu-days');
      })();
      instance.append(html);
    }
    shown_date_from.setDate(1);
    shown_date_to.setDate(1);
    shown_date_to.addMonths(1);
    shown_date_to.addDays(-1);
    pickmeup.find('.pmu-prev').css('visibility', options.min && options.min >= shown_date_from ? 'hidden' : 'visible');
    pickmeup.find('.pmu-next').css('visibility', options.max && options.max <= shown_date_to ? 'hidden' : 'visible');
    options.fill.apply(this);
  }
  function parseDate(date, format, separator, locale) {
    if (date.constructor == Date) {
      return date;
    } else if (!date) {
      return new Date();
    }
    var splitted_date = date.split(separator);
    if (splitted_date.length > 1) {
      splitted_date.forEach(function (element, index, array) {
        array[index] = parseDate($.trim(element), format, separator, locale);
      });
      return splitted_date;
    }
    var months_text = locale.monthsShort.join(')(') + ')(' + locale.months.join(')('),
        separator = new RegExp('[^0-9a-zA-Z(' + months_text + ')]+'),
        parts = date.split(separator),
        against = format.split(separator),
        d,
        m,
        y,
        h,
        min,
        now = new Date();
    for (var i = 0; i < parts.length; i++) {
      switch (against[i]) {
        case 'b':
          m = locale.monthsShort.indexOf(parts[i]);
          break;
        case 'B':
          m = locale.months.indexOf(parts[i]);
          break;
        case 'd':
        case 'e':
          d = parseInt(parts[i], 10);
          break;
        case 'm':
          m = parseInt(parts[i], 10) - 1;
          break;
        case 'Y':
        case 'y':
          y = parseInt(parts[i], 10);
          y += y > 100 ? 0 : y < 29 ? 2000 : 1900;
          break;
        case 'H':
        case 'I':
        case 'k':
        case 'l':
          h = parseInt(parts[i], 10);
          break;
        case 'P':
        case 'p':
          if (/pm/i.test(parts[i]) && h < 12) {
            h += 12;
          } else if (/am/i.test(parts[i]) && h >= 12) {
            h -= 12;
          }
          break;
        case 'M':
          min = parseInt(parts[i], 10);
          break;
      }
    }
    var parsed_date = new Date(y === undefined ? now.getFullYear() : y, m === undefined ? now.getMonth() : m, d === undefined ? now.getDate() : d, h === undefined ? now.getHours() : h, min === undefined ? now.getMinutes() : min, 0);
    if (isNaN(parsed_date * 1)) {
      parsed_date = new Date();
    }
    return parsed_date;
  }
  function formatDate(date, format, locale) {
    var m = date.getMonth();
    var d = date.getDate();
    var y = date.getFullYear();
    var w = date.getDay();
    var s = {};
    var hr = date.getHours();
    var pm = hr >= 12;
    var ir = pm ? hr - 12 : hr;
    var dy = date.getDayOfYear();
    if (ir == 0) {
      ir = 12;
    }
    var min = date.getMinutes();
    var sec = date.getSeconds();
    var parts = format.split(''),
        part;
    for (var i = 0; i < parts.length; i++) {
      part = parts[i];
      switch (part) {
        case 'a':
          part = locale.daysShort[w];
          break;
        case 'A':
          part = locale.days[w];
          break;
        case 'b':
          part = locale.monthsShort[m];
          break;
        case 'B':
          part = locale.months[m];
          break;
        case 'C':
          part = 1 + Math.floor(y / 100);
          break;
        case 'd':
          part = d < 10 ? "0" + d : d;
          break;
        case 'e':
          part = d;
          break;
        case 'H':
          part = hr < 10 ? "0" + hr : hr;
          break;
        case 'I':
          part = ir < 10 ? "0" + ir : ir;
          break;
        case 'j':
          part = dy < 100 ? dy < 10 ? "00" + dy : "0" + dy : dy;
          break;
        case 'k':
          part = hr;
          break;
        case 'l':
          part = ir;
          break;
        case 'm':
          part = m < 9 ? "0" + (1 + m) : 1 + m;
          break;
        case 'M':
          part = min < 10 ? "0" + min : min;
          break;
        case 'p':
        case 'P':
          part = pm ? "PM" : "AM";
          break;
        case 's':
          part = Math.floor(date.getTime() / 1000);
          break;
        case 'S':
          part = sec < 10 ? "0" + sec : sec;
          break;
        case 'u':
          part = w + 1;
          break;
        case 'w':
          part = w;
          break;
        case 'y':
          part = ('' + y).substr(2, 2);
          break;
        case 'Y':
          part = y;
          break;
      }
      parts[i] = part;
    }
    return parts.join('');
  }
  function update_date() {
    var $this = $(this),
        options = $this.data('pickmeup-options'),
        current_date = options.current,
        new_value;
    switch (options.mode) {
      case 'multiple':
        new_value = current_date.setHours(0, 0, 0, 0).valueOf();
        if ($.inArray(new_value, options.date) !== -1) {
          $.each(options.date, function (index, value) {
            if (value == new_value) {
              options.date.splice(index, 1);
              return false;
            }
            return true;
          });
        } else {
          options.date.push(new_value);
        }
        break;
      case 'range':
        if (!options.lastSel) {
          options.date[0] = current_date.setHours(0, 0, 0, 0).valueOf();
        }
        new_value = current_date.setHours(0, 0, 0, 0).valueOf();
        if (new_value <= options.date[0]) {
          options.date[1] = options.date[0];
          options.date[0] = new_value;
        } else {
          options.date[1] = new_value;
        }
        options.lastSel = !options.lastSel;
        break;
      default:
        options.date = current_date.valueOf();
        break;
    }
    var prepared_date = prepareDate(options);
    if ($this.is('input')) {
      $this.val(options.mode == 'single' ? prepared_date[0] : prepared_date[0].join(options.separator));
    }
    options.change.apply(this, prepared_date);
    if (!options.flat && options.hide_on_select && (options.mode != 'range' || !options.lastSel)) {
      options.binded.hide();
      return false;
    }
  }
  function click(e) {
    var el = $(e.target);
    if (!el.hasClass('pmu-button')) {
      el = el.closest('.pmu-button');
    }
    if (el.length) {
      if (el.hasClass('pmu-disabled')) {
        return false;
      }
      var $this = $(this),
          options = $this.data('pickmeup-options'),
          instance = el.parents('.pmu-instance').eq(0),
          root = instance.parent(),
          instance_index = $('.pmu-instance', root).index(instance);
      if (el.parent().is('nav')) {
        if (el.hasClass('pmu-month')) {
          options.current.addMonths(instance_index - Math.floor(options.calendars / 2));
          if (root.hasClass('pmu-view-years')) {
            // Shift back to current date, otherwise with min value specified may jump on few (tens) years forward
            if (options.mode != 'single') {
              options.current = new Date(options.date[options.date.length - 1]);
            } else {
              options.current = new Date(options.date);
            }
            if (options.select_day) {
              root.removeClass('pmu-view-years').addClass('pmu-view-days');
            } else if (options.select_month) {
              root.removeClass('pmu-view-years').addClass('pmu-view-months');
            }
          } else if (root.hasClass('pmu-view-months')) {
            if (options.select_year) {
              root.removeClass('pmu-view-months').addClass('pmu-view-years');
            } else if (options.select_day) {
              root.removeClass('pmu-view-months').addClass('pmu-view-days');
            }
          } else if (root.hasClass('pmu-view-days')) {
            if (options.select_month) {
              root.removeClass('pmu-view-days').addClass('pmu-view-months');
            } else if (options.select_year) {
              root.removeClass('pmu-view-days').addClass('pmu-view-years');
            }
          }
        } else {
          if (el.hasClass('pmu-prev')) {
            options.binded.prev(false);
          } else {
            options.binded.next(false);
          }
        }
      } else if (!el.hasClass('pmu-disabled')) {
        if (root.hasClass('pmu-view-years')) {
          options.current.setFullYear(parseInt(el.text(), 10));
          if (options.select_month) {
            root.removeClass('pmu-view-years').addClass('pmu-view-months');
          } else if (options.select_day) {
            root.removeClass('pmu-view-years').addClass('pmu-view-days');
          } else {
            options.binded.update_date();
          }
        } else if (root.hasClass('pmu-view-months')) {
          options.current.setMonth(instance.find('.pmu-months .pmu-button').index(el));
          options.current.setFullYear(parseInt(instance.find('.pmu-month').text(), 10));
          if (options.select_day) {
            root.removeClass('pmu-view-months').addClass('pmu-view-days');
          } else {
            options.binded.update_date();
          }
          // Move current month to the first place
          options.current.addMonths(Math.floor(options.calendars / 2) - instance_index);
        } else {
          var val = parseInt(el.text(), 10);
          options.current.addMonths(instance_index - Math.floor(options.calendars / 2));
          if (el.hasClass('pmu-not-in-month')) {
            options.current.addMonths(val > 15 ? -1 : 1);
          }
          options.current.setDate(val);
          options.binded.update_date();
        }
      }
      options.binded.fill();
    }
    return false;
  }
  function prepareDate(options) {
    var result;
    if (options.mode == 'single') {
      result = new Date(options.date);
      return [formatDate(result, options.format, options.locale), result];
    } else {
      result = [[], []];
      $.each(options.date, function (nr, val) {
        var date = new Date(val);
        result[0].push(formatDate(date, options.format, options.locale));
        result[1].push(date);
      });
      return result;
    }
  }
  function show(force) {
    var pickmeup = this.pickmeup;
    if (force || !pickmeup.is(':visible')) {
      var $this = $(this),
          options = $this.data('pickmeup-options'),
          pos = $this.offset(),
          viewport = {
        l: document.documentElement.scrollLeft,
        t: document.documentElement.scrollTop,
        w: document.documentElement.clientWidth,
        h: document.documentElement.clientHeight
      },
          top = pos.top,
          left = pos.left;
      options.binded.fill();
      if ($this.is('input')) {
        $this.pickmeup('set_date', parseDate($this.val() ? $this.val() : options.default_date, options.format, options.separator, options.locale)).keydown(function (e) {
          if (e.which == 9) {
            $this.pickmeup('hide');
          }
        });
        options.lastSel = false;
      }
      options.before_show();
      if (options.show() == false) {
        return;
      }
      if (!options.flat) {
        switch (options.position) {
          case 'top':
            top -= pickmeup.outerHeight();
            break;
          case 'left':
            left -= pickmeup.outerWidth();
            break;
          case 'right':
            left += this.offsetWidth;
            break;
          case 'bottom':
            top += this.offsetHeight;
            break;
        }
        if (top + pickmeup.offsetHeight > viewport.t + viewport.h) {
          top = pos.top - pickmeup.offsetHeight;
        }
        if (top < viewport.t) {
          top = pos.top + this.offsetHeight + pickmeup.offsetHeight;
        }
        if (left + pickmeup.offsetWidth > viewport.l + viewport.w) {
          left = pos.left - pickmeup.offsetWidth;
        }
        if (left < viewport.l) {
          left = pos.left + this.offsetWidth;
        }
        pickmeup.css({
          display: 'inline-block',
          top: top + 'px',
          left: left + 'px'
        });
        $(document).on('mousedown' + options.events_namespace + ' touchstart' + options.events_namespace, options.binded.hide).on('resize' + options.events_namespace, [true], options.binded.forced_show);
      }
    }
  }
  function forced_show() {
    show.call(this, true);
  }
  function hide(e) {
    if (!e || !e.target || //Called directly
    e.target != this && //Clicked not on element itself
    !(this.pickmeup.get(0).compareDocumentPosition(e.target) & 16) //And not o its children
    ) {
      var pickmeup = this.pickmeup,
          options = $(this).data('pickmeup-options');
      if (options.hide() != false) {
        pickmeup.hide();
        $(document).off('mousedown touchstart', options.binded.hide).off('resize', options.binded.forced_show);
        options.lastSel = false;
      }
    }
  }
  function update() {
    var options = $(this).data('pickmeup-options');
    $(document).off('mousedown', options.binded.hide).off('resize', options.binded.forced_show);
    options.binded.forced_show();
  }
  function clear() {
    var options = $(this).data('pickmeup-options');
    if (options.mode != 'single') {
      options.date = [];
      options.lastSel = false;
      options.binded.fill();
    }
  }
  function prev(fill) {
    if (typeof fill == 'undefined') {
      fill = true;
    }
    var root = this.pickmeup;
    var options = $(this).data('pickmeup-options');
    if (root.hasClass('pmu-view-years')) {
      options.current.addYears(-12);
    } else if (root.hasClass('pmu-view-months')) {
      options.current.addYears(-1);
    } else if (root.hasClass('pmu-view-days')) {
      options.current.addMonths(-1);
    }
    if (fill) {
      options.binded.fill();
    }
  }
  function next(fill) {
    if (typeof fill == 'undefined') {
      fill = true;
    }
    var root = this.pickmeup;
    var options = $(this).data('pickmeup-options');
    if (root.hasClass('pmu-view-years')) {
      options.current.addYears(12);
    } else if (root.hasClass('pmu-view-months')) {
      options.current.addYears(1);
    } else if (root.hasClass('pmu-view-days')) {
      options.current.addMonths(1);
    }
    if (fill) {
      options.binded.fill();
    }
  }
  function get_date(formatted) {
    var options = $(this).data('pickmeup-options'),
        prepared_date = prepareDate(options);
    if (typeof formatted === 'string') {
      var date = prepared_date[1];
      if (date.constructor == Date) {
        return formatDate(date, formatted, options.locale);
      } else {
        return date.map(function (value) {
          return formatDate(value, formatted, options.locale);
        });
      }
    } else {
      return prepared_date[formatted ? 0 : 1];
    }
  }
  function set_date(date) {
    var $this = $(this),
        options = $this.data('pickmeup-options');
    options.date = date;
    if (typeof options.date === 'string') {
      options.date = parseDate(options.date, options.format, options.separator, options.locale).setHours(0, 0, 0, 0);
    } else if (options.date.constructor == Date) {
      options.date.setHours(0, 0, 0, 0);
    }
    if (!options.date) {
      options.date = new Date();
      options.date.setHours(0, 0, 0, 0);
    }
    if (options.mode != 'single') {
      if (options.date.constructor != Array) {
        options.date = [options.date.valueOf()];
        if (options.mode == 'range') {
          options.date.push(new Date(options.date[0]).setHours(0, 0, 0, 0).valueOf());
        }
      } else {
        for (var i = 0; i < options.date.length; i++) {
          options.date[i] = parseDate(options.date[i], options.format, options.separator, options.locale).setHours(0, 0, 0, 0).valueOf();
        }
        if (options.mode == 'range') {
          options.date[1] = new Date(options.date[1]).setHours(0, 0, 0, 0).valueOf();
        }
      }
    } else {
      if ($this.val() || options.default_date !== false) {
        options.date = options.date.constructor == Array ? options.date[0].valueOf() : options.date.valueOf();
      }
    }
    options.current = new Date(options.mode != 'single' ? options.date[0] : options.date);
    options.binded.fill();
    if ($this.is('input')) {
      var prepared_date = prepareDate(options);
      $this.val(options.mode == 'single' ? options.default_date === false ? $this.val() : prepared_date[0] : prepared_date[0].join(options.separator));
    }
  }
  function destroy() {
    var $this = $(this),
        options = $this.data('pickmeup-options');
    $this.removeData('pickmeup-options');
    $this.off(options.events_namespace);
    $(document).off(options.events_namespace);
    $(this.pickmeup).remove();
  }
  $.fn.pickmeup = function (initial_options) {
    if (typeof initial_options === 'string') {
      var data,
          parameters = Array.prototype.slice.call(arguments, 1);
      switch (initial_options) {
        case 'hide':
        case 'show':
        case 'clear':
        case 'update':
        case 'prev':
        case 'next':
        case 'destroy':
          this.each(function () {
            data = $(this).data('pickmeup-options');
            if (data) {
              data.binded[initial_options]();
            }
          });
          break;
        case 'get_date':
          data = this.data('pickmeup-options');
          if (data) {
            return data.binded.get_date(parameters[0]);
          } else {
            return null;
          }
          break;
        case 'set_date':
          this.each(function () {
            data = $(this).data('pickmeup-options');
            if (data) {
              data.binded[initial_options].apply(this, parameters);
            }
          });
      }
      return this;
    }
    return this.each(function () {
      var $this = $(this);
      if ($this.data('pickmeup-options')) {
        return;
      }
      var i,
          option,
          options = $.extend({}, $.pickmeup, initial_options || {});
      for (i in options) {
        option = $this.data('pmu-' + i);
        if (typeof option !== 'undefined') {
          options[i] = option;
        }
      }
      // 4 conditional statements in order to account all cases
      if (options.view == 'days' && !options.select_day) {
        options.view = 'months';
      }
      if (options.view == 'months' && !options.select_month) {
        options.view = 'years';
      }
      if (options.view == 'years' && !options.select_year) {
        options.view = 'days';
      }
      if (options.view == 'days' && !options.select_day) {
        options.view = 'months';
      }
      options.calendars = Math.max(1, parseInt(options.calendars, 10) || 1);
      options.mode = /single|multiple|range/.test(options.mode) ? options.mode : 'single';
      if (typeof options.min === 'string') {
        options.min = parseDate(options.min, options.format, options.separator, options.locale).setHours(0, 0, 0, 0);
      } else if (options.min && options.min.constructor == Date) {
        options.min.setHours(0, 0, 0, 0);
      }
      if (typeof options.max === 'string') {
        options.max = parseDate(options.max, options.format, options.separator, options.locale).setHours(0, 0, 0, 0);
      } else if (options.max && options.max.constructor == Date) {
        options.max.setHours(0, 0, 0, 0);
      }
      if (!options.select_day) {
        if (options.min) {
          options.min = new Date(options.min);
          options.min.setDate(1);
          options.min = options.min.valueOf();
        }
        if (options.max) {
          options.max = new Date(options.max);
          options.max.setDate(1);
          options.max = options.max.valueOf();
        }
      }
      if (typeof options.date === 'string') {
        options.date = parseDate(options.date, options.format, options.separator, options.locale).setHours(0, 0, 0, 0);
      } else if (options.date.constructor == Date) {
        options.date.setHours(0, 0, 0, 0);
      }
      if (!options.date) {
        options.date = new Date();
        options.date.setHours(0, 0, 0, 0);
      }
      if (options.mode != 'single') {
        if (options.date.constructor != Array) {
          options.date = [options.date.valueOf()];
          if (options.mode == 'range') {
            options.date.push(new Date(options.date[0]).setHours(0, 0, 0, 0).valueOf());
          }
        } else {
          for (i = 0; i < options.date.length; i++) {
            options.date[i] = parseDate(options.date[i], options.format, options.separator, options.locale).setHours(0, 0, 0, 0).valueOf();
          }
          if (options.mode == 'range') {
            options.date[1] = new Date(options.date[1]).setHours(0, 0, 0, 0).valueOf();
          }
        }
        options.current = new Date(options.date[0]);
        // Set days to 1 in order to handle them consistently
        if (!options.select_day) {
          for (i = 0; i < options.date.length; ++i) {
            options.date[i] = new Date(options.date[i]);
            options.date[i].setDate(1);
            options.date[i] = options.date[i].valueOf();
            // Remove duplicates
            if (options.mode != 'range' && options.date.indexOf(options.date[i]) !== i) {
              delete options.date.splice(i, 1);
              --i;
            }
          }
        }
      } else {
        options.date = options.date.valueOf();
        options.current = new Date(options.date);
        if (!options.select_day) {
          options.date = new Date(options.date);
          options.date.setDate(1);
          options.date = options.date.valueOf();
        }
      }
      options.current.setDate(1);
      options.current.setHours(0, 0, 0, 0);

      var cnt,
          pickmeup = $(tpl.wrapper);
      this.pickmeup = pickmeup;
      if (options.class_name) {
        pickmeup.addClass(options.class_name);
      }
      var html = '';
      for (i = 0; i < options.calendars; i++) {
        cnt = options.first_day;
        html += tpl.head({
          prev: options.prev,
          next: options.next,
          day: [options.locale.daysMin[cnt++ % 7], options.locale.daysMin[cnt++ % 7], options.locale.daysMin[cnt++ % 7], options.locale.daysMin[cnt++ % 7], options.locale.daysMin[cnt++ % 7], options.locale.daysMin[cnt++ % 7], options.locale.daysMin[cnt++ % 7]]
        });
      }
      $this.data('pickmeup-options', options);
      for (i in options) {
        if (['render', 'change', 'before_show', 'show', 'hide'].indexOf(i) != -1) {
          options[i] = options[i].bind(this);
        }
      }
      options.binded = {
        fill: fill.bind(this),
        update_date: update_date.bind(this),
        click: click.bind(this),
        show: show.bind(this),
        forced_show: forced_show.bind(this),
        hide: hide.bind(this),
        update: update.bind(this),
        clear: clear.bind(this),
        prev: prev.bind(this),
        next: next.bind(this),
        get_date: get_date.bind(this),
        set_date: set_date.bind(this),
        destroy: destroy.bind(this)
      };
      options.events_namespace = '.pickmeup-' + ++instances_count;
      html += '<div class="pmu-footer ta-right">' + '<button onclick="closeCal()" class="button button_margin button_grayish-blue button_middle-calendar">Отмена</button>' + '<button onclick="applyCalChanges()" class="button button_margin button_green button_middle-calendar">ОК</button>' + '</div>';
      pickmeup.on('click touchstart', options.binded.click).addClass(views[options.view]).append(html).on($.support.selectstart ? 'selectstart' : 'mousedown', function (e) {
        e.preventDefault();
      });
      options.binded.fill();
      if (options.flat) {
        pickmeup.appendTo(this).css({
          position: 'relative',
          display: 'inline-block'
        });
      } else {
        pickmeup.appendTo(document.body);
        // Multiple events support
        var trigger_event = options.trigger_event.split(' ');
        for (i = 0; i < trigger_event.length; ++i) {
          trigger_event[i] += options.events_namespace;
        }
        trigger_event = trigger_event.join(' ');
        $this.on(trigger_event, options.binded.show);
      }
    });
  };
});

/***/ }),
/* 34 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

/**
 * Создан для замены useStaticFilesLoader в siter.config.js.
 * Являяется оберткой, используя тот же самый StaticFilesLoader, с теми же настройками, только через сервис $translateStaticFilesLoader.
 * Объединяет переводы из файтов locale_{lang}.json с переводами из window.justclick.messages
 *
 * @see https://angular-translate.github.io/docs/#/api/pascalprecht.translate.$translateStaticFilesLoader
 */
angular.module('siter.io').factory('TranslationLoader', ["$q", "$translateStaticFilesLoader", function ($q, $translateStaticFilesLoader) {
    return function (options) {
        var deferred = $q.defer();
        var translations = {};

        if (typeof window.justclick.messages !== 'undefined') {
            translations = window.justclick.messages;
        }

        $translateStaticFilesLoader(options).then(function (data) {
            Object.assign(data, translations);

            deferred.resolve(data);
        });

        return deferred.promise;
    };
}]);

/***/ }),
/* 35 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

angular.module('siter.io').factory('WidgetsSortHelper', [function () {
    return {
        sortWidgetsByTypesSortMap: function sortWidgetsByTypesSortMap(widgetsArray, widgetsTypesSortMap) {
            return this.sortByMap(widgetsArray, widgetsTypesSortMap, 'type');
        },

        sortWidgetsByName: function sortWidgetsByName(widgetsArray) {
            widgetsArray.sort(function (a, b) {
                return a.name.localeCompare(b.name) * -1;
            });

            return widgetsArray;
        },

        sortByMap: function sortByMap(objectsArray, mapArray, key) {
            objectsArray.sort(function (a, b) {
                var aKey = a[key];
                var bKey = b[key];

                return mapArray.indexOf(aKey) > mapArray.indexOf(bKey) ? 1 : -1;
            });

            return objectsArray;
        }
    };
}]);

/***/ }),
/* 36 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

angular.module("siter.io").controller("DashboardLessonSections", ["$scope", "$rootScope", "$state", "$timeout", "Site", "Modal", "Template", "$location", "Section", "Widget", "Notification", "Lesson", function ($scope, $rootScope, $state, $timeout, Site, Modal, Template, $location, Section, Widget, Notification, Lesson) {

  if (window.justclick.currentUser.role === "client") {
    $location.path('/404');
  }

  $rootScope.site = {};

  $scope.state = $state;
  $scope.currentState = $state.current.name;
  $scope.tagobject = { tagName: "" };
  $scope.scrollDisabled = false;
  $scope.lessons = [];
  $scope.getHomePagePath = function (pages) {
    if (pages.length === 0) {
      return false;
    }

    var homePage = _.filter(pages, {
      home: true
    });

    return homePage[0].path;
  };

  $scope.lessonSectionsLoading = true;

  Section.getLessonSections().then(function (sections) {
    $scope.lessonSections = sections.sections;
    $scope.lessonSectionsLoading = false;
  });

  $scope.saveSection = function (section) {
    Section.savePublic(section);
  };

  $scope.removeSection = function (section, collection) {
    var findedSection = _.filter(collection, { id: section.id });
    var index = collection.indexOf(findedSection[0]);

    $rootScope.alertDialog({
      title: "Deleting a section",
      text: "Are you sure you want to delete this section?",
      accept_text: "Yes",
      cancel_text: "Cancel",
      accept: function accept() {
        Section.removePublic(section.id).then(function () {
          return collection.splice(index, 1);
        });
      }
    });
  };

  $scope.editSectionModal = Modal.editSectionModal;
  $scope.newLessonSectionModal = Modal.newLessonSectionModal;
}]);

/***/ }),
/* 37 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

angular.module("siter.io").controller("DashboardLessons", ["$scope", "$rootScope", "$state", "$timeout", "Site", "Modal", "Template", "$location", "Section", "Widget", "Notification", "Lesson", function ($scope, $rootScope, $state, $timeout, Site, Modal, Template, $location, Section, Widget, Notification, Lesson) {

  if (window.justclick.currentUser.role === "client") {
    $location.path('/404');
  }

  $rootScope.site = {};

  $scope.state = $state;
  $scope.currentState = $state.current.name;
  $scope.tagobject = { tagName: "" };
  $scope.scrollDisabled = false;
  $scope.lessons = [];
  $scope.getHomePagePath = function (pages) {
    if (pages.length === 0) {
      return false;
    }

    var homePage = _.filter(pages, {
      home: true
    });

    return homePage[0].path;
  };

  $rootScope.refreshLessonTemplates = function () {
    $scope.LessonsLoading = true;
    Template.getLessonTemplates().then(function (lessons) {
      $scope.Lessons = lessons;
      $scope.LessonsCount = lessons.length;
      $scope.LessonsLoading = false;
    });
  };

  var refreshLessonTags = function refreshLessonTags() {
    Template.getLessonUserCategories().then(function (tags) {
      $scope.LessonTemplatesTags = tags;
    });
  };

  $scope.treeLessonOptions = {
    dropped: function dropped(e) {
      $timeout(function () {
        Template.sortLessonCategories($scope.LessonTemplatesTags).then(function (tags) {
          $scope.LessonTemplatesTags = tags;
        });
      });
    }
  };
  $scope.LessonSectionsLoading = true;
  $scope.removeLessonTemplate = function (collection, form) {
    var findedForm = _.filter(collection, { id: form.id });
    var index = collection.indexOf(findedForm[0]);

    $rootScope.alertDialog({
      title: "Deleting a lesson template",
      text: "Are you sure you want to delete this lesson template?",
      accept_text: "Yes",
      cancel_text: "Cancel",
      accept: function accept() {
        Lesson.remove(form.id).then(function () {
          return collection.splice(index, 1);
        });
      }
    });
  };
  $scope.saveLessonTemplate = function (template) {
    Lesson.update(template);
  };

  var listener3 = $rootScope.$on("lesson_form:created", function (e, newLesson, template) {
    if (template === null) {
      template = false;
    }
    if (template) {
      template.childs.push(newLesson);
    } else {
      $scope.Lessons.push(newLesson);
    }
    refreshLessonTags();
  });

  var listener4 = $rootScope.$on("lesson_form:updated", function (e, newLesson, template) {
    if (template === null) {
      template = false;
    }
    refreshLessonTags();
  });

  refreshLessonTags();

  $rootScope.refreshLessonTemplates();
  $scope.$on("$destroy", function () {
    listener3();
    listener4();
  });

  $scope.newLessonTemplate = Modal.newLessonTemplate;
  $scope.editLessonTemplate = Modal.editLessonTemplate;
}]);

/***/ }),
/* 38 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

/*
 * api Lesson service
 */

var moduleLesson = angular.module('api.lesson', []);

moduleLesson.factory('Lesson', ["Restangular", "$rootScope", "$stateParams", "$state", "$modal", "$injector", function (Restangular, $rootScope, $stateParams, $state, $modal, $injector) {
  return {
    _currentSite: Restangular.one('lms_pages', $stateParams.lessonId),
    get: function get(id) {
      if (id) {
        return Restangular.one('lms_pages', id).get();
      } else {
        return Restangular.one('lms_pages', $stateParams.lessonId).get();
      }
    },
    getList: function getList() {
      return Restangular.all('lms_pages').getList();
    },
    update: function update(site) {
      return Restangular.all('lms_pages').one(site.id).customPUT(site);
    },
    updateByRoute: function updateByRoute(site) {
      return Restangular.all('lms_pages').one($stateParams.lessonId).customPUT(site);
    },
    remove: function remove(id) {
      return Restangular.one('lms_pages', id).remove();
    },
    create: function create(site) {
      return Restangular.all('lms_pages').post(site);
    },
    saveIndex: function saveIndex(changes) {
      return Restangular.one('lms_pages', $stateParams.lessonId).all('assets/save').post({
        changes: changes,
        path: $rootScope.currentFile.full_path
      });
    },
    transfer: function transfer(data) {
      return Restangular.one('lms_pages', $stateParams.lessonId).all("transfer").post(data);
    },
    share: function share(site) {
      return Restangular.one('lms_pages', $stateParams.lessonId).all("share").post(site);
    },
    setTemplate: function setTemplate(template_id) {
      return Restangular.all("lms_pages").one($state.params.lessonId).customPUT({
        template_id: template_id
      });
    },
    createTemplate: function createTemplate(templateParams) {
      return Restangular.all("lms_pages").one($state.params.lessonId).all("templates").post(templateParams);
    },
    addSite: function addSite() {
      return $state.go("root.new_site");
    },
    publish: function publish() {
      return Restangular.all("lms_pages").one($state.params.lessonId).all("build").post();
    },
    clone: function clone(site_id) {
      return Restangular.all("lms_pages").one(site_id).all("clone").post();
    },
    goToSite: function goToSite(siteSlug) {
      if ($stateParams.lessonId) {
        if (!$state.includes("public.templates") && !$state.includes("lesson.page.editor")) {
          var newstate = _.extend($state.params, { lessonId: siteSlug });
          return $state.transitionTo($state.current, newstate, { reload: true });
        } else {
          return $state.go('root.site.requests.bystatus', { lessonId: siteSlug, status: "inbox" });
        }
      } else {
        return $state.go('root.site.requests.bystatus', { lessonId: siteSlug, status: "inbox" });
      }
    },
    /**
     * Загрузка кастомных стилей из lms
     */
    getLmsStylesheets: function getLmsStylesheets() {
      var serviceDomain = window.justclick.serviceDomain;

      return Restangular.oneUrl('styles', serviceDomain + '/sites/constructor/stylesheets').get();
    }
  };
}]);

/***/ }),
/* 39 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

angular.module('api', ["api.widget", "api.template", "api.section", "api.page", "api.font", "api.email", "api.sectionemail", "api.webform", "api.sectionwebform", "api.lesson", "api.sectionLesson"]);

/***/ }),
/* 40 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* injects from baggage-loader */

/** Section Api */

var moduleSection = angular.module('api.section', []);

moduleSection.factory('Section', ["$timeout", "ns", "$injector", "$state", "Restangular", "$http", "$templateCache", "$rootScope", function ($timeout, ns, $injector, $state, Restangular, $http, $templateCache, $rootScope) {
  var SectionApi = function () {
    function SectionApi() {
      _classCallCheck(this, SectionApi);
    }

    _createClass(SectionApi, [{
      key: 'createPublic',
      value: function createPublic(params) {
        return Restangular.all('sections').post(params);
      }
    }, {
      key: 'savePublic',
      value: function savePublic(section) {
        var id = section.id + '';

        return Restangular.all('sections').one(id).customPUT(section);
      }
    }, {
      key: 'saveTemplate',
      value: function saveTemplate(section) {
        var id = section.id + '';

        return Restangular.all('sections').one(id).all('create_template').post(section);
      }
    }, {
      key: 'createItem',
      value: function createItem(section, params, isPublic) {
        if (isPublic == null) {
          isPublic = false;
        }

        var id = section.id + "";

        if (isPublic) {
          return Restangular.all("sections").one(id).customPUT(params);
        } else {
          return Restangular.all("sites").one($state.params.siteId).all("pages").one($state.params.pageId).all("sections").one(id).customPUT(params);
        }
      }
    }, {
      key: 'destoyItem',
      value: function destoyItem(section, imageId) {
        var id = section.id;

        return Restangular.all("sections").one(id).all("images").one(imageId).customDELETE();
      }
    }, {
      key: 'create',
      value: function create(id, type) {
        var _$state$params = $state.params,
            siteId = _$state$params.siteId,
            pageId = _$state$params.pageId;

        var requestParams = {
          section_id: id,
          section_type: type
        };

        if (type !== 'default' && !!window.justclick.userSiteId) {
          requestParams['global_site_id'] = window.justclick.userSiteId;
        }

        return Restangular.all('sites').one(siteId).all('pages').one(pageId).all('sections').post(requestParams);
      }
    }, {
      key: 'clone',
      value: function clone(id, type) {
        var _$state$params2 = $state.params,
            siteId = _$state$params2.siteId,
            pageId = _$state$params2.pageId;

        var requestParams = {
          section_id: id,
          section_type: type
        };

        if (type !== 'default' && !!window.justclick.userSiteId) {
          requestParams['global_site_id'] = window.justclick.userSiteId;
        }

        return Restangular.all('sites').one(siteId).all('pages').one(pageId).all('sections/clone').post(requestParams);
      }
    }, {
      key: 'save',
      value: function save(layout) {
        var section = layout.section;

        this.beforeSave(layout);

        section.structure = this.generateJSON(layout.one(ns.wrapperClass));

        var id = layout.section.id + "";
        var isPublic = section.is_template;

        if (isPublic) {
          return this.savePublic(section);
        } else {
          var _$state$params3 = $state.params,
              siteId = _$state$params3.siteId,
              pageId = _$state$params3.pageId;


          return Restangular.all('sites').one(siteId).all('pages').one(pageId).all('sections').one(id).customPUT(section);
        }
      }
    }, {
      key: 'saveAllSectionsAndPublish',
      value: function saveAllSectionsAndPublish(sections) {
        var _$state$params4 = $state.params,
            siteId = _$state$params4.siteId,
            pageId = _$state$params4.pageId;
        var userSiteId = window.justclick.userSiteId;
        var currentSite = $rootScope.currentSite;

        var query = [];
        var putParameters = {
          sections: sections
        };

        if (Editor.option) {
          query.push('mixer=true');
        }

        if (userSiteId) {
          query.push('global_site_id=' + userSiteId);

          putParameters.site = {
            header_enabled: !!currentSite.header_enabled,
            footer_enabled: !!currentSite.footer_enabled
          };
        }

        var getParams = '';
        if (query.length > 0) {
          getParams = '?' + query.join('&');
        }

        return Restangular.all("sites").one(siteId).all("pages").one(pageId).all("sections").all("batch_update" + getParams).customPUT(putParameters);
      }
    }, {
      key: 'getBuildStatus',
      value: function getBuildStatus() {
        var siteId = $state.params.siteId;


        return Restangular.all("sites").one(siteId).one("build_status").get();
      }
    }, {
      key: 'saveAllSectionsAndPublishPreview',
      value: function saveAllSectionsAndPublishPreview(sections) {
        var _$state$params5 = $state.params,
            siteId = _$state$params5.siteId,
            pageId = _$state$params5.pageId;


        return Restangular.all("sites").one(siteId).all("pages").one(pageId).all("sections").all("save_preview").customPUT({
          sections: sections
        });
      }
    }, {
      key: 'saveSettings',
      value: function saveSettings(section) {
        section = angular.copy(section);

        delete section.structure;
        delete section.background_attributes.images_attributes;

        if (section.is_template) {
          return this.savePublic(section);
        } else {
          var _$state$params6 = $state.params,
              siteId = _$state$params6.siteId,
              pageId = _$state$params6.pageId;

          var id = section.id + "";

          return Restangular.all("sites").one(siteId).all("pages").one(pageId).all("sections").one(id).customPUT(section);
        }
      }
    }, {
      key: 'update',
      value: function update(section) {
        var _$state$params7 = $state.params,
            siteId = _$state$params7.siteId,
            pageId = _$state$params7.pageId;

        var id = section.id + "";

        return Restangular.all("sites").one(siteId).all("pages").one(pageId).all("sections").one(id).customPUT(section);
      }
    }, {
      key: 'update_for_mixer',
      value: function update_for_mixer(section) {
        var _$state$params8 = $state.params,
            siteId = _$state$params8.siteId,
            pageId = _$state$params8.pageId;

        var id = section.id + "";

        return Restangular.all("sites").one(siteId).all("pages").one(pageId).all("sections").one(id).all("update_for_mixer").customPUT(section);
      }
    }, {
      key: 'remove',
      value: function remove(id) {
        var _$state$params9 = $state.params,
            siteId = _$state$params9.siteId,
            pageId = _$state$params9.pageId;


        return Restangular.all("sites").one(siteId).all("pages").one(pageId).all("sections").one(id).customPUT({
          removed: true
        });
      }
    }, {
      key: 'removePublic',
      value: function removePublic(id) {
        return Restangular.all("sections").one(id).customDELETE();
      }
    }, {
      key: 'restore',
      value: function restore(id) {
        var _$state$params10 = $state.params,
            siteId = _$state$params10.siteId,
            pageId = _$state$params10.pageId;


        return Restangular.all("sites").one(siteId).all("pages").one(pageId).all("sections").one(id).customPUT({
          removed: false
        });
      }
    }, {
      key: 'removeBg',
      value: function removeBg(section) {
        var id = section.id + "";

        section = angular.copy(section);
        section.remove_background = true;

        if (section.is_template) {
          return Restangular.all("sections").one(id).customPUT(section);
        } else {
          var _$state$params11 = $state.params,
              siteId = _$state$params11.siteId,
              pageId = _$state$params11.pageId;


          return Restangular.all("sites").one(siteId).all("pages").one(pageId).all("sections").one(id).customPUT(section);
        }
      }
    }, {
      key: 'sort',
      value: function sort(sectionsIds) {
        var _$state$params12 = $state.params,
            siteId = _$state$params12.siteId,
            pageId = _$state$params12.pageId;


        return Restangular.all("sites").one(siteId).all("pages").one(pageId).all("sections").all("sort").post({
          sections: sectionsIds
        });
      }
    }, {
      key: 'get',
      value: function get(id) {
        return Restangular.all("sites").one(id).get();
      }
    }, {
      key: 'getHTML',
      value: function getHTML(section) {
        var _$state$params13 = $state.params,
            siteId = _$state$params13.siteId,
            pageId = _$state$params13.pageId;

        var requestData = {};

        if (section.section_type !== 'default' && !!window.justclick.userSiteId) {
          requestData['global_site_id'] = window.justclick.userSiteId;
        }

        return Restangular.all("sites").one(siteId).all("pages").one(pageId).all("sections").customGET(section.id + ".html", requestData);
      }
    }, {
      key: 'getPublicSectionHTML',
      value: function getPublicSectionHTML(id) {
        return Restangular.all("sections").one(id + ".html").get();
      }
    }, {
      key: 'getPublicSectionStylesheet',
      value: function getPublicSectionStylesheet() {
        var id = $state.params.sectionId;

        return Restangular.all("sections").one(id + ".css").get();
      }
    }, {
      key: 'getCollection',
      value: function getCollection(category, colors) {
        return Restangular.one("sections").get({
          tag: category,
          "color[]": colors
        });
      }
    }, {
      key: 'getCategories',
      value: function getCategories(site_id) {
        return Restangular.all("sections").all("tags").getList({
          site_id: site_id
        });
      }
    }, {
      key: 'getSections',
      value: function getSections(for_email) {
        if (for_email == null) {
          for_email = false;
        }
        if (for_email) {
          return Restangular.all("sections").one("all?for_email=true").get();
        } else {
          return Restangular.all("sections").one("all").get();
        }
      }
    }, {
      key: 'getLessonSections',
      value: function getLessonSections() {
        return Restangular.all("sections").one("all?for_lms_page=true").get();
      }
    }, {
      key: 'beforeSave',
      value: function beforeSave(layout) {
        return this.setTextContents(layout);
      }
    }, {
      key: 'setTextContents',
      value: function setTextContents(layout) {
        var Y = $rootScope.Y;

        layout.all([ns.blockTextClass, ns.blockHeadline1Class, ns.blockHeadline2Class, ns.blockHeadline3Class].join(',')).each(function (block) {

          var jBlock = $(block.one(ns.widgetWrapperClass)._node);

          if (jBlock.find("#cke_pastebin").length > 0) {
            jBlock.find("#cke_pastebin").attr("style", "");
            jBlock.find("#cke_pastebin").replaceWith($('<span>' + jBlock.find("#cke_pastebin").html() + '</span>'));
          }

          var content = jBlock.html();

          if (!block.widget) {
            block.widget = { content: "" };
          } else {
            if ($rootScope.widgetsIsMixer != null && $rootScope.widgetsIsMixer[block.widget.id] != null) {
              block.widget.in_mixer_active = $rootScope.widgetsIsMixer[block.widget.id];
            }
            block.widget.content = content;
          }

          // Very strange behaviour, sometimes the widget has property with empty name, and it produces an error while saving a page
          Object.keys(block.widget).forEach(function (k) {
            return k === '' && delete block.widget[k];
          });
        });
      }
    }, {
      key: 'generateJSON',
      value: function generateJSON(block) {
        var _this = this;

        var blocksBuilder = $injector.get("blocksBuilder");
        var result = {};

        if (!block) {
          err("Can't recognize block");
        }

        if (block.hasClass(ns.rowClass.substr(1))) {
          result.cols = [];
          block.get("children").filter(ns.colClass).each(function (block) {
            result.cols.push(_this.generateJSON(block));
          });
        } else if (block.hasClass(ns.colClass.substr(1)) || block.hasClass(ns.wrapperClass.substr(1))) {

          if (block.test("[class*='str-col-']")) {
            result.size = blocksBuilder.getColSize(block);
          }

          var widgets = [];
          var rows = [];

          block.get("children").each(function (block) {
            if (block.test(ns.rowClass)) {
              if (0 !== widgets.length) {
                rows.push({
                  cols: [{
                    size: result.size,
                    widgets: $rootScope.Y.clone(widgets, true)
                  }]
                });
                widgets = [];
              }

              rows.push(_this.generateJSON(block));
            } else if (block.test(ns.blockClass)) {
              block = block.widget;
              if (!block) {
                err("Block has not json");
              }
              widgets.push(block);
            }
          });

          if (0 === rows.length) {
            result.widgets = widgets;
          } else {
            if (0 !== widgets.length && !result.size) {
              err("Col size is invalid: ", result.size);
            }
            if (result.size && widgets.length) {
              rows.push({
                cols: [{
                  size: result.size,
                  widgets: $rootScope.Y.clone(widgets, true)
                }]
              });
            }
            result.rows = rows;
          }
        }

        if (result.rows && 0 === result.rows.length || result.cols && 0 === result.cols.length) {
          delete result.rows;
          delete result.cols;
          result.widgets = [];
          block.get("children").filter(ns.blockClass).each(function (block) {
            result.widgets.push(block.widget);
          });
        }

        return result;
      }
    }]);

    return SectionApi;
  }();

  return new SectionApi();
}]);

/***/ }),
/* 41 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* injects from baggage-loader */

/*
 * api SectionLesson service
 */

var moduleSectionLesson = angular.module('api.sectionLesson', []);

moduleSectionLesson.factory('SectionLesson', ["$timeout", "ns", "$injector", "$state", "Restangular", "$http", "$templateCache", "$rootScope", function ($timeout, ns, $injector, $state, Restangular, $http, $templateCache, $rootScope) {
  var SectionLessonApi = function () {
    function SectionLessonApi() {
      _classCallCheck(this, SectionLessonApi);
    }

    _createClass(SectionLessonApi, [{
      key: 'updateForMixer',
      value: function updateForMixer(section) {
        var _$state$params = $state.params,
            lessonId = _$state$params.lessonId,
            pageId = _$state$params.pageId;

        var id = section.id + "";

        return Restangular.all("lms_pages").one(lessonId).all("pages").one(pageId).all("sections").one(id).all("update_for_mixer").customPUT(section);
      }
    }, {
      key: 'createPublic',
      value: function createPublic(params) {
        return Restangular.all("sections").post(params);
      }
    }, {
      key: 'savePublic',
      value: function savePublic(section) {
        return Restangular.all("sections").one(section.id).customPUT(section);
      }
    }, {
      key: 'createItem',
      value: function createItem(section, params) {
        var isPublic = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        if (isPublic) {
          return Restangular.all("sections").one(section.id).customPUT(params);
        } else {
          var _$state$params2 = $state.params,
              lessonId = _$state$params2.lessonId,
              pageId = _$state$params2.pageId;

          return Restangular.all("lms_pages").one(lessonId).all("pages").one(pageId).all("sections").one(section.id).customPUT(params);
        }
      }
    }, {
      key: 'destoyItem',
      value: function destoyItem(section, imageId) {
        return Restangular.all("sections").one(section.id).all("images").one(imageId).customDELETE();
      }
    }, {
      key: 'create',
      value: function create(id, type) {
        var _$state$params3 = $state.params,
            lessonId = _$state$params3.lessonId,
            pageId = _$state$params3.pageId;

        return Restangular.all("lms_pages").one(lessonId).all("pages").one(pageId).all("sections").post({
          section_id: id,
          section_type: type
        });
      }
    }, {
      key: 'clone',
      value: function clone(id, type) {
        var _$state$params4 = $state.params,
            lessonId = _$state$params4.lessonId,
            pageId = _$state$params4.pageId;

        return Restangular.all("lms_pages").one(lessonId).all("pages").one(pageId).all("sections/clone").post({
          section_id: id,
          section_type: type
        });
      }
    }, {
      key: 'save',
      value: function save(layout) {
        var section = layout.section;

        this.setTextContents(layout);

        section.structure = this.generateJSON(layout.one(ns.wrapperClass));

        if (section.is_template) {
          return this.savePublic(section);
        } else {
          var _$state$params5 = $state.params,
              lessonId = _$state$params5.lessonId,
              pageId = _$state$params5.pageId;

          return Restangular.all("lms_pages").one(lessonId).all("pages").one(pageId).all("sections").one(layout.section.id).customPUT(section);
        }
      }
    }, {
      key: 'saveAllSectionsAndPublish',
      value: function saveAllSectionsAndPublish(sections) {
        var _$state$params6 = $state.params,
            lessonId = _$state$params6.lessonId,
            pageId = _$state$params6.pageId;

        return Restangular.all("lms_pages").one(lessonId).all("pages").one(pageId).all("sections").all("batch_update").customPUT({ sections: sections });
      }
    }, {
      key: 'getBuildStatus',
      value: function getBuildStatus() {
        var lessonId = $state.params.lessonId;

        return Restangular.all("lms_pages").one(lessonId).one("build_status").get();
      }
    }, {
      key: 'saveAllSectionsAndPublishPreview',
      value: function saveAllSectionsAndPublishPreview(sections) {
        var _$state$params7 = $state.params,
            lessonId = _$state$params7.lessonId,
            pageId = _$state$params7.pageId;

        return Restangular.all("lms_pages").one(lessonId).all("pages").one(pageId).all("sections").all("save_preview").customPUT({ sections: sections });
      }
    }, {
      key: 'saveSettings',
      value: function saveSettings(section) {
        section = angular.copy(section);

        delete section.structure;
        delete section.background_attributes.images_attributes;

        if (section.is_template) {
          return this.savePublic(section);
        } else {
          var _$state$params8 = $state.params,
              lessonId = _$state$params8.lessonId,
              pageId = _$state$params8.pageId;

          return Restangular.all("lms_pages").one(lessonId).all("pages").one(pageId).all("sections").one(section.id).customPUT(section);
        }
      }
    }, {
      key: 'remove',
      value: function remove(id) {
        var _$state$params9 = $state.params,
            lessonId = _$state$params9.lessonId,
            pageId = _$state$params9.pageId;

        return Restangular.all("lms_pages").one(lessonId).all("pages").one(pageId).all("sections").one(id).customPUT({ removed: true });
      }
    }, {
      key: 'removePublic',
      value: function removePublic(id) {
        return Restangular.all("sections").one(id).customDELETE();
      }
    }, {
      key: 'restore',
      value: function restore(id) {
        var _$state$params10 = $state.params,
            lessonId = _$state$params10.lessonId,
            pageId = _$state$params10.pageId;

        return Restangular.all("lms_pages").one(lessonId).all("pages").one(pageId).all("sections").one(id).customPUT({ removed: false });
      }
    }, {
      key: 'removeBg',
      value: function removeBg(section) {
        section = angular.copy(section);
        section.remove_background = true;

        if (section.is_template) {
          return Restangular.all("sections").one(section.id).customPUT(section);
        } else {
          var _$state$params11 = $state.params,
              lessonId = _$state$params11.lessonId,
              pageId = _$state$params11.pageId;

          return Restangular.all("lms_pages").one(lessonId).all("pages").one(pageId).all("sections").one(section.id).customPUT(section);
        }
      }
    }, {
      key: 'sort',
      value: function sort(sectionsIds) {
        var _$state$params12 = $state.params,
            lessonId = _$state$params12.lessonId,
            pageId = _$state$params12.pageId;

        return Restangular.all("lms_pages").one(lessonId).all("pages").one(pageId).all("sections").all("sort").post({ sections: sectionsIds });
      }
    }, {
      key: 'get',
      value: function get(id) {
        return Restangular.all("lms_pages").one(id).get();
      }
    }, {
      key: 'getHTML',
      value: function getHTML(section) {
        var _$state$params13 = $state.params,
            lessonId = _$state$params13.lessonId,
            pageId = _$state$params13.pageId;

        return Restangular.all("lms_pages").one(lessonId).all("pages").one(pageId).all("sections").one(section.id + ".html").get();
      }
    }, {
      key: 'getPublicSectionHTML',
      value: function getPublicSectionHTML(id) {
        return Restangular.all("sections").one(id + ".html").get();
      }
    }, {
      key: 'getPublicSectionStylesheet',
      value: function getPublicSectionStylesheet() {
        var id = $state.params.sectionId;
        return Restangular.all("sections").one(id + ".css").get();
      }
    }, {
      key: 'getCollection',
      value: function getCollection(category, colors) {
        return Restangular.one("sections").get({ tag: category, for_lms_page: true, "color[]": colors });
      }

      /**
       * Запрос категорий
       * @param lms_page_id
       * @returns {*}
       */

    }, {
      key: 'getCategories',
      value: function getCategories(lms_page_id) {
        return Restangular.all("sections").all("tags").getList({ lms_page_id: lms_page_id });
      }
    }, {
      key: 'getSections',
      value: function getSections() {
        return Restangular.all("sections").one("all").get();
      }
    }, {
      key: 'getStylesheetsOfForm',
      value: function getStylesheetsOfForm(id) {
        return Restangular.all("lms_pages").one(id).one("source.css").get();
      }

      /**
       * todo: Бесполезный метод, удалить, когда не будет использоваться
       * [Вызывается из layoutEditor]
       * @param layout
       * @returns {*}
       */

    }, {
      key: 'beforeSave',
      value: function beforeSave(layout) {
        return this.setTextContents(layout);
      }
    }, {
      key: 'setTextContents',
      value: function setTextContents(layout) {
        layout.all([ns.blockTextClass, ns.blockHeadline1Class, ns.blockHeadline2Class, ns.blockHeadline3Class].join(',')).each(function (block) {
          // Very strange behaviour, sometimes the widget has property with empty name, and it produces an error while saving a page
          Object.keys(block.widget).forEach(function (k) {
            return k === '' && delete block.widget[k];
          });

          if (!block.widget) {
            return block.widget.content = '';
          } else {
            return block.widget.content = block.one(ns.widgetWrapperClass).getHTML();
          }
        });
      }
    }, {
      key: 'generateJSON',
      value: function generateJSON(block) {
        var _this = this;

        var blocksBuilder = $injector.get("blocksBuilder");
        var result = {};

        if (!block) {
          err("Can't recognize block");
        }

        if (block.hasClass(ns.rowClass.substr(1))) {
          result.cols = [];
          block.get("children").filter(ns.colClass).each(function (block) {
            result.cols.push(_this.generateJSON(block));
          });
        } else if (block.hasClass(ns.colClass.substr(1)) || block.hasClass(ns.wrapperClass.substr(1))) {

          if (block.test("[class*='str-col-']")) {
            result.size = blocksBuilder.getColSize(block);
          }

          var widgets = [];
          var rows = [];

          block.get("children").each(function (block) {
            if (block.test(ns.rowClass)) {
              if (0 !== widgets.length) {
                rows.push({
                  cols: [{
                    size: result.size,
                    widgets: $rootScope.Y.clone(widgets, true)
                  }]
                });
                widgets = [];
              }

              rows.push(_this.generateJSON(block));
            } else if (block.test(ns.blockClass)) {
              block = block.widget;
              if (!block) {
                err("Block has not json");
              }
              widgets.push(block);
            }
          });

          if (0 === rows.length) {
            result.widgets = widgets;
          } else {
            if (0 !== widgets.length && !result.size) {
              err("Col size is invalid: ", result.size);
            }
            if (result.size && widgets.length) {
              rows.push({
                cols: [{
                  size: result.size,
                  widgets: $rootScope.Y.clone(widgets, true)
                }]
              });
            }
            result.rows = rows;
          }
        }

        if (result.rows && 0 === result.rows.length || result.cols && 0 === result.cols.length) {
          delete result.rows;
          delete result.cols;
          result.widgets = [];
          block.get("children").filter(ns.blockClass).each(function (block) {
            return result.widgets.push(block.widget);
          });
        }

        return result;
      }
    }]);

    return SectionLessonApi;
  }();

  return new SectionLessonApi();
}]);

/***/ }),
/* 42 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

/*
 * api Template service
 */

var moduleTemplate = angular.module('api.template', []);

moduleTemplate.factory('Template', ["$timeout", "ns", "$injector", "$state", "Restangular", "$http", "$templateCache", "Section", "Email", function ($timeout, ns, $injector, $state, Restangular, $http, $templateCache, Section, Email) {
  var _$state$params = $state.params,
      pageId = _$state$params.pageId,
      siteId = _$state$params.siteId,
      emailId = _$state$params.emailId,
      formId = _$state$params.formId,
      lessonId = _$state$params.lessonId;


  return {
    getStylesheet: function getStylesheet() {
      switch (Editor.mode) {
        case "site.page.editor":
          return Restangular.all("sites").one($state.params.siteId).all("pages").one($state.params.pageId).customGET("sections.css", {
            global_site_id: window.justclick.userSiteId || ''
          });
        case "email.page.editor":
          return Restangular.all("emails").one($state.params.emailId).all("pages").one($state.params.pageId).customGET("sections.css");
        case "form.page.editor":
          return Restangular.all("web_forms").one($state.params.formId).all("pages").one($state.params.pageId).customGET("sections.css");
        case "lesson.page.editor":
          return Restangular.all("lms_pages").one($state.params.lessonId).all("pages").one($state.params.pageId).customGET("sections.css");
      }
    },
    loadHTML: function loadHTML() {
      switch (Editor.mode) {
        case "editor.section":
          return Section.getPublicSectionHTML($state.params.sectionId);
        case "site.page.editor":
          return Restangular.all("sites").one($state.params.siteId).all("pages").one($state.params.pageId).customGET("sections.html", {
            global_site_id: window.justclick.userSiteId || ''
          });
        case "email.page.editor":
          return Restangular.all("emails").one($state.params.emailId).all("pages").one($state.params.pageId).customGET("sections.html");
        case "form.page.editor":
          return Restangular.all("web_forms").one($state.params.formId).all("pages").one($state.params.pageId).customGET("sections.html");
        case "lesson.page.editor":
          return Restangular.all("lms_pages").one($state.params.lessonId).all("pages").one($state.params.pageId).customGET("sections.html");
      }
    },
    loadJSON: function loadJSON() {
      switch (Editor.mode) {
        case "editor.section":
          return Restangular.all("sections").one($state.params.sectionId).get();
        case "site.page.editor":
          return Restangular.all("sites").one($state.params.siteId).all("pages").one($state.params.pageId).one("sections").get({
            global_site_id: window.justclick.userSiteId || ''
          });
        case "email.page.editor":
          return Restangular.all("emails").one($state.params.emailId).all("pages").one($state.params.pageId).one("sections").get();
        case "form.page.editor":
          return Restangular.all("web_forms").one($state.params.formId).all("pages").one($state.params.pageId).one("sections").get();
        case "lesson.page.editor":
          return Restangular.all("lms_pages").one($state.params.lessonId).all("pages").one($state.params.pageId).one("sections").get();
      }
    },
    getAll: function getAll() {
      return Restangular.one("templates.json").get();
    },
    getEmailTemplates: function getEmailTemplates() {
      return Restangular.one("email_templates.json").get({ fromDashboard: true });
    },
    get: function get(siteSlug) {
      return Restangular.all("templates").one(siteSlug).get();
    },
    getUserCategories: function getUserCategories() {
      return Restangular.all("templates").all("tags?user_tags=1").getList();
    },
    getEmailUserCategories: function getEmailUserCategories() {
      return Restangular.all("email_templates").all("tags?user_tags=1").getList();
    },
    sortEmailCategories: function sortEmailCategories(tags) {
      return Restangular.all("email_templates").all("tags_sort").post({
        tags: tags
      });
    },
    sortCategories: function sortCategories(tags) {
      return Restangular.all("templates").all("tags_sort").post({
        tags: tags
      });
    },
    getWebFormTemplates: function getWebFormTemplates() {
      return Restangular.one("web_forms").get({ fromDashboard: true });
    },
    getWebFormUserCategories: function getWebFormUserCategories() {
      return Restangular.all("web_form_templates").all("tags?user_tags=1").getList();
    },
    sortWebFormCategories: function sortWebFormCategories(tags) {
      return Restangular.all("web_form_templates").all("tags_sort").post({
        tags: tags
      });
    },

    getLessonTemplates: function getLessonTemplates() {
      return Restangular.one("lms_page_templates.json").get({
        from_admin_panel: true
      });
    },
    getLessonUserCategories: function getLessonUserCategories() {
      return Restangular.all("lms_page_templates").all("tags?user_tags=1").getList();
    },
    sortLessonCategories: function sortLessonCategories(tags) {
      return Restangular.all("lms_page_templates").all("tags_sort").post({
        tags: tags
      });
    }
  };
}]);

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* injects from baggage-loader */

/* globals Editor, _ */
/* jshint browser: true */


var indexOf = [].indexOf || function (item) {
  for (var i = 0, l = this.length; i < l; i++) {
    if (i in this && this[i] === item) {
      return i;
    }
  }
  return -1;
};

var moduleModulesSettings = angular.module('editor.modulesSettings.controller', ['services', 'directives.htmlcompiler']);

moduleModulesSettings.controller('blockEditDialogCtrl', ['$scope', '$rootScope', '$state', '$timeout', '$templateCache', '$compile', '$sce', 'ns', 'insertBlockMenu', 'blockEditDialog', 'Section', 'editorDragPanel', 'layoutEditor', 'Tutorials', 'TimeMachine', 'blockDragDrop', '$filter', 'EditorLibrary', function ($scope, $rootScope, $state, $timeout, $templateCache, $compile, $sce, ns, insertBlockMenu, blockEditDialog, Section, editorDragPanel, layoutEditor, Tutorials, TimeMachine, blockDragDrop, $filter, EditorLibrary) {
  window.tplsFolder = './editor/widget_settings';
  window.settingFolder = './editor/modules_settings';
  $scope.widget = undefined;

  var unbindSectionWatcher = void 0;
  var unbindWidgetWatcher = void 0;

  var resetAccordion = function resetAccordion() {
    $scope.accordion = {
      show_text: false,
      show_name: false,
      show_vocation: false,
      show_button: false,
      show_image: false,
      show_price: false,
      show_desc: false,
      show_style: false,
      show_title: false,
      show_form_fields: false,
      show_fast_settings: true,
      show_nav_settings: true,
      show_subscribe_add_categories: true,
      show_subscribe_actions: true,
      show_subscribe_add_ex_categories: false,
      show_subscribe_fast_settings: false,
      show: function show(type) {
        angular.forEach($scope.accordion, function (value, key) {
          if (typeof $scope.accordion[key] !== 'function') {
            $scope.accordion[key] = false;
          }
        });

        this['show_' + type] = true;
        if (!$scope.$$phase) {
          $scope.$apply();
        }
      }
    };
  };
  resetAccordion();

  $scope.setButtonSize = function (style_attributes1, style_attributes2, size) {
    switch (size) {
      case 'small':
        style_attributes1.padding = '11px 48px 11px 48px';
        style_attributes1.fontSize = '16px';
        style_attributes2.padding = '11px 48px 11px 48px';
        style_attributes2.fontSize = '16px';
        break;
      case 'medium':
        style_attributes1.padding = '17px 58px 17px 58px';
        style_attributes1.fontSize = '18px';
        style_attributes2.padding = '17px 58px 17px 58px';
        style_attributes2.fontSize = '18px';
        break;
      case 'big':
        style_attributes1.padding = '21px 67px 21px 67px';
        style_attributes1.fontSize = '22px';
        style_attributes2.padding = '21px 67px 21px 67px';
        style_attributes2.fontSize = '22px';
        break;
    }
  };
  $scope.setDesignTab = function (tab) {
    $scope.currentDesignTab = tab;
  };

  var destroyAccordion = $rootScope.$on('accordion:show', function (e, type) {
    $scope.accordion.show(type);
  });

  $scope.clearDialog = function () {
    $scope.settings = { body: '' };
  };

  var blockIsEditing = function blockIsEditing(e) {
    var currentBlockJson = blockEditDialog.currentBlockJson;

    if (!currentBlockJson) {
      return false;
    }

    var blockId = blockEditDialog.getBlockId(e);

    return blockId === currentBlockJson.id;
  };
  var unbindWatchers = function unbindWatchers() {
    $scope.clearDialog();

    if (!$scope.$$phase) {
      $scope.$apply();
    }
    if (unbindSectionWatcher) {
      unbindSectionWatcher();
    }
    if (unbindWidgetWatcher) {
      unbindWidgetWatcher();
    }
  };

  $scope.$on('$destroy', function () {
    destroyAccordion();
    unbindWatchers();
  });

  var setWidgetValues = function setWidgetValues() {
    unbindWidgetWatcher = $scope.$watch('widget', function (newval) {
      if (!newval) {
        return false;
      }
      return blockEditDialog._onChangeWidget(newval);
    }, true);

    $scope.widget = blockEditDialog.getWidgetSettings();
    var widgetType = $scope.widget.type;
    $scope.getBody(widgetType);
  };
  var setSectionValues = function setSectionValues() {
    unbindSectionWatcher = $scope.$watch('section', function (newval, oldval) {
      if (!newval) {
        return false;
      }
      return blockEditDialog._onChangeSection(newval, oldval);
    }, true);

    $scope.section = blockEditDialog.getSectionSettings();
    $scope.section.colors = _.map($scope.section.colors, function (tag, index) {
      return {
        text: tag,
        id: index
      };
    });

    if (typeof $scope.section.tags === 'string') {
      $scope.section.tags = _.map($scope.section.tags.split(','), function (tag, index) {
        return {
          text: tag,
          id: index
        };
      });
    }

    $scope.getBodySectionSettings();
  };

  var subscribeFormCategorySelected = function subscribeFormCategorySelected(categories, cb) {
    var hasCategories = false;

    if (_.find(categories, 'selected')) {
      hasCategories = true;
    } else {
      for (var i = 0; i < categories.length; i++) {
        if (_.find(categories[i].groups, 'selected')) {
          hasCategories = true;
          break;
        }
      }
    }

    if (!hasCategories) {
      EditorLibrary.createError($rootScope, 'subscribe_form.categories', $filter('translate')('widget.form.groupRequired'));

      var editorNavigationCtrlScope = $('[ng-controller=\'EditorNavigationCtrl\']').scope();
      editorNavigationCtrlScope.editCurrentTab = 'blockSettings';

      $timeout(function () {
        $scope.accordion.show_subscribe_add_categories = true;
      });
      return false;
    } else {
      EditorLibrary.clearError($rootScope, 'subscribe_form.categories');
      return cb();
    }
  };

  var formCategorySelected = function formCategorySelected(categories, cb) {
    var allGroupsSelectFields = [];

    categories.forEach(function (category) {
      return category.groups.forEach(function (group) {
        return allGroupsSelectFields.push(group.selected);
      });
    });

    if (indexOf.call(allGroupsSelectFields, true) < 0 && allGroupsSelectFields.length > 0) {
      $rootScope.alertDialog({
        title: $filter('translate')('alert.form.title'),
        text: $filter('translate')('alert.form.text'),
        accept_text: $filter('translate')('alert.confirm'),
        cancel_text: $filter('translate')('alert.cancel'),
        accept: function accept() {
          return cb();
        }
      });
    } else {
      return cb();
    }
  };
  var checkFormGroups = function checkFormGroups(cb) {
    var _blockEditDialog$curr = blockEditDialog.currentBlock.widget,
        type = _blockEditDialog$curr.type,
        product_selected = _blockEditDialog$curr.product_selected,
        categories = _blockEditDialog$curr.categories,
        form_type = _blockEditDialog$curr.form_type,
        disable_form_settings = _blockEditDialog$curr.disable_form_settings;


    if (type === 'subscribe_form' && !product_selected && !disable_form_settings) {
      return subscribeFormCategorySelected(categories, cb);
    } else if (type === 'form' && form_type === 'subscription') {
      return formCategorySelected(categories, cb);
    } else {
      return cb();
    }
  };
  var formOffertUrlBlank = function formOffertUrlBlank(widget, cb) {
    var field = _.filter(widget.form_fields_attributes, { offert: true })[0];
    var index = widget.form_fields_attributes.indexOf(field);
    var regExpUrl = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;
    var offertUrlValid = regExpUrl.test(field.offert_url);
    var linkTargetIsNone = field.offert && field.exist && field.link_href_target === 'none' && !field.offert_url;

    if (field.offert && field.exist && field.link_href_target === 'blank' && !offertUrlValid || linkTargetIsNone) {
      if (index > -1) {
        $rootScope.alertDialog({
          title: $filter('translate')('alert.form_offert.title'),
          text: $filter('translate')('alert.form_offert.text'),
          accept_text: $filter('translate')('alert.confirm'),
          cancel_text: $filter('translate')('alert.cancel'),
          accept: function accept() {
            widget.form_fields_attributes[index].exist = false;
            cb();
          },
          cancel: function cancel() {}
        });
      }
    } else {
      return cb();
    }
  };
  var checkOffertUrl = function checkOffertUrl(cb) {
    if (blockEditDialog.currentBlock.widget.type === 'form') {
      return formOffertUrlBlank(blockEditDialog.currentBlock.widget, cb);
    } else {
      return cb();
    }
  };

  $rootScope.editSection = function () {
    checkOffertUrl(function () {
      checkFormGroups(function () {
        resetAccordion();

        var section = blockEditDialog.currentBlock.ancestor(ns.sectionClass);
        var e = { target: section };
        var $tools = $('.e__tools');

        $timeout(function () {
          return editorDragPanel._onClickEditSection(e, true, false);
        });
        layoutEditor.save();
        $scope.accordion.show_additional = false;
        blockDragDrop.widgetsCapture();

        $tools.scope().editorNavOpenWidget = false;
        $tools.scope().editorNavOpenWidgetText = false;
        if (!$tools.scope().$$phase) {
          $tools.scope().$apply();
        }
      });
    });
  };
  $scope.setValues = function (e) {
    if (blockIsEditing(e) && $scope.widget) {
      return false;
    }

    unbindWatchers();
    $rootScope.editorNavTab('blockSettings');
    blockEditDialog.setBlock(e);

    var editingBlockType = blockEditDialog.currentBlockType;
    if (editingBlockType === 'widget') {
      setWidgetValues(e);
      $rootScope.widgetIsEditing = true;
    } else {
      setSectionValues(e);
      $rootScope.widgetIsEditing = false;
    }

    $timeout(function () {
      $('#mini-sections').perfectScrollbar('update');
      $(window).resize();
    });
  };
  $scope.getBodySectionSettings = function () {
    var bodyUrl = void 0;

    if (!$scope.section.for_email) {
      bodyUrl = './editor/section_settings/common/body.jade';
    }
    if ($scope.section.for_email) {
      bodyUrl = './editor/section_settings/common/email-body.jade';
    }
    if (Editor.mode === 'form.page.editor') {
      bodyUrl = './editor/section_settings/common/form-body.jade';
    }

    var body = $templateCache.get(bodyUrl);
    $scope.settings = { body: body };
  };
  // Загрузка настроек
  $scope.getBody = function (type) {
    var bodyUrl = window.tplsFolder + '/' + type + '/body.jade';
    var body = $templateCache.get(bodyUrl);

    $scope.settings = { body: body };
  };
  $scope.clearDialog();
}]);

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* injects from baggage-loader */

/* globals Editor, _, log, YUI */
/* jshint browser: true */


var moduleEditor = angular.module('editor.controller', ['api.widget', 'factory.editorLibrary']);

moduleEditor.controller('EditorCtrl', ['$scope', '$rootScope', '$state', '$timeout', 'editorNavSections', 'layoutEditor', 'Widget', 'insertBlockMenu', 'Template', 'ns', 'Site', 'editorDragPanel', 'Section', '$modal', 'State', 'blockOverlays', 'Font', 'TimeMachine', 'Notification', '$filter', 'Parallax', 'SubscribeFormManager', 'ImageInit', 'ButtonActionsManager', 'WidgetsSortHelper', 'EditorLibrary', function ($scope, $rootScope, $state, $timeout, editorNavSections, layoutEditor, Widget, insertBlockMenu, Template, ns, Site, editorDragPanel, Section, $modal, State, blockOverlays, Font, TimeMachine, Notification, $filter, Parallax, SubscribeFormManager, ImageInit, ButtonActionsManager, WidgetsSortHelper, EditorLibrary) {

  var stylesCallback = void 0;

  $scope.templateIsReady = false;
  $rootScope.filter = $filter;
  $rootScope.justclick = window.justclick;
  $rootScope.isSaveDisabled = false;

  var loadStylesOfTemplate = function loadStylesOfTemplate(sectionId) {
    if (sectionId === null || sectionId === undefined) {
      sectionId = false;
    }
    Template.getStylesheet().then(function (response) {
      angular.element('#tplStyles').text(response);
      if (stylesCallback) {
        stylesCallback();
        stylesCallback = undefined;
      }
    });
  };

  var loadStylesOfPublicSection = function loadStylesOfPublicSection() {
    Section.getPublicSectionStylesheet().then(function (response) {
      angular.element('#tplStyles').text(response);
    });
  };

  var loadStyles = function loadStyles(sectionId) {
    if (sectionId === null || sectionId === undefined) {
      sectionId = false;
    }
    if ($state.includes('editor.section')) {
      loadStylesOfPublicSection();
    } else {
      loadStylesOfTemplate(sectionId);
    }
  };

  var setGradient = function setGradient(background_attributes) {
    var color_start = background_attributes.color_start;
    var color_stop = background_attributes.color_stop;
    var gradient_css = 'background-image:-moz-linear-gradient(top, ' + color_start + ', ' + color_stop + '); background-image:-webkit-linear-gradient(top, ' + color_start + ', ' + color_stop + '); background-image:-o-linear-gradient(top, ' + color_start + ', ' + color_stop + '); background-image:-ms-linear-gradient(top, ' + color_start + ', ' + color_stop + ');, background-image:linear-gradient(top, ' + color_start + ', ' + color_stop + '); filter: progid:DXImageTransform.Microsoft.gradient(startColorStr=\'' + color_start + '\', endColorstr=\'' + color_stop + '\');';

    if ($('style#' + $rootScope.currentPage.id).length > 0) {
      $('style#' + $rootScope.currentPage.id).html('#tpl-wrapper:before { ' + gradient_css + ' }');
    } else {
      $('body').append('<style id=\'' + $rootScope.currentPage.id + '\'>#tpl-wrapper:before { ' + gradient_css + ' }</style>');
    }
  };

  var setBgStyles = function setBgStyles() {
    var bodyElement = $('#tpl-wrapper');
    var imageExist = $rootScope.currentPage.background_attributes && $rootScope.currentPage.background_attributes.image_attributes && $rootScope.currentPage.background_attributes.image_attributes.source_url;

    bodyElement.css($rootScope.currentPage.style_attributes);

    if (imageExist) {
      bodyElement.css({
        backgroundImage: 'url(\'' + $rootScope.currentPage.background_attributes.image_attributes.source_url + '\')'
      });
    }

    if ($rootScope.currentPage.background_attributes && $rootScope.currentPage.background_attributes.gradient) {
      setGradient($rootScope.currentPage.background_attributes);
    }

    Parallax.initSection($rootScope.Y.one('#tpl-wrapper'));
  };

  var destroyGetStyles = $rootScope.$on('get:styles', function (data, sectionId, cb) {
    if (cb) {
      stylesCallback = cb;
    }

    loadStyles(sectionId);
  });

  $rootScope.checkIntBlocks = function () {
    if (Editor.mode !== 'site.page.editor') {
      return false;
    }
    $scope.intBlocksExists = false;
    Editor.getSections().forEach(function (section) {
      if (section.interactive) {
        $scope.intBlocksExists = true;
      }
    });

    $rootScope.Y.all('.str-block').each(function (block) {
      if (block.widget && block.widget.interactive) {
        $scope.intBlocksExists = true;
      }
    });
  };

  $rootScope.initWidgets = function () {
    $rootScope.Y.all('.str-section').each(function (sectionNode) {
      sectionNode.all('.str-block').each(function (block) {
        if (block.widget && block.widget.type === 'subscribe_form') {
          SubscribeFormManager.updateOptions(block.widget);
        }
        if (block.widget && block.widget.type === 'image') {
          ImageInit.updateOptions(block.widget);
        }
        if (block.widget && block.widget.type === 'link') {
          ButtonActionsManager.updateOptions(block.widget);
        }
        if (block.widget && block.widget.type === 'button') {
          ButtonActionsManager.updateOptions(block.widget);
        }
        if (block.widget && block.widget.type === 'card') {
          ButtonActionsManager.updateOptions(block.widget);
        }
        if (block.widget && block.widget.type === 'product') {
          block.widget.product_items_attributes.map(function (subWidget, id) {
            if (subWidget.item_type === 'button') {
              ButtonActionsManager.updateOptions(block.widget.product_items_attributes[id]);
            }
          });
        }
      });

      layoutEditor.updateSectionEtag(sectionNode.section);
    });
  };

  var addAdditionalFonts = function addAdditionalFonts() {
    if (Editor.mode === 'editor.section') {
      Editor.Instrumentations.fonts = $rootScope.sections.fonts_attributes;
    }

    if (Editor.mode === 'site.page.editor') {
      Editor.Instrumentations.fonts = $rootScope.site.fonts_attributes;
    }

    $rootScope.$broadcast('fontNames:loaded');
  };

  var destroyFontsNames = $rootScope.$on('fontNames:loaded', function () {
    Font.connectFonts(Editor.Instrumentations.fonts);
  });

  var destroySectionFonts = $rootScope.$on('sectionFonts:loaded', function (e, fonts) {
    Font.connectFonts(fonts);
  });

  var startEditPublicSection = function startEditPublicSection() {
    if (Editor.mode === 'editor.section') {
      var layout = $rootScope.Y.one(ns.sectionClass);

      editorDragPanel._onClickEditSection({
        target: layout
      });
    }
  };

  var removeAutoPlay = function removeAutoPlay(htmlData) {
    if (!htmlData) {
      return '';
    }

    return htmlData.replace(new RegExp('autoplay=1', 'g'), '');
  };

  var preventForm = function preventForm(e) {
    return e.preventDefault();
  };

  var preventFormsSubmit = function preventFormsSubmit() {
    angular.element('body').on('submit', 'form', preventForm);
  };

  var unbindPreventForm = function unbindPreventForm() {
    angular.element('body').off('submit', 'form', preventForm);
  };

  var parseHTML = function parseHTML(selector, htmlString) {
    var contentSectionsHTML = '';

    var codeHTML = '<div class="str-bw_code-html-overlay">' + '<img class="str-bw_code-html-overlay-icon" src="/constructor/editor/assets/images/code-overlay-icon.svg" />' + '<div class="str-bw_code-html-overlay-text">' + $filter('translate')('widget.code.text') + '</div>' + '</div>';
    var fbHTML = '<div class="str-bw_code-html-overlay str-bw_code-html-overlay_fb">' + '<img class="str-bw_code-html-overlay-icon" src="/constructor/editor/assets/images/code-overlay-icon.svg" />' + '<div class="str-bw_code-html-overlay-text">' + $filter('translate')('widget.comments.text') + '</div>' + '</div>';
    var jContent = $('<div/>').html(htmlString).contents();

    jContent.find('.str-bw_code-html').html(codeHTML);
    jContent.find('.strw-fb-comments').html(fbHTML);

    if (selector !== 'section' && jContent.find(selector)[0]) {
      return jContent.find(selector)[0].outerHTML;
    }

    if (selector === 'section') {
      jContent.find('section').each(function (index, section) {
        contentSectionsHTML += section.outerHTML;
      });
      return contentSectionsHTML;
    }
  };

  var setTemplateHTML = function setTemplateHTML(htmlData) {
    if (Editor.mode === 'editor.section') {
      $('#tpl-wrapper').html(htmlData);
      return false;
    }

    htmlData = '<div>' + htmlData + '</div>';

    if (window.justclick.userSiteId) {
      var headerHTML = parseHTML('header', htmlData);
      var footerHTML = parseHTML('footer', htmlData);
      $(headerHTML).insertBefore('.str-drop-backdrop');
      $(footerHTML).insertAfter('.str-drop-backdrop');
    }

    var contentSectionsHTML = parseHTML('section', htmlData);
    $(contentSectionsHTML).insertAfter('.str-drop-backdrop');
    EditorLibrary.removeVisibilityDelay();
  };

  /**
   * Загрузка шаблона
   */
  var afterInstrumentsInitialized = function afterInstrumentsInitialized() {
    preventFormsSubmit();
    Template.loadHTML().then(function (htmlData) {
      htmlData = removeAutoPlay(htmlData);

      try {
        setTemplateHTML(htmlData);
      } catch (_error) {
        log(_error);
      }

      // Передача экземпляра Yui в класс layoutEditor
      layoutEditor.initializer($rootScope.Y);

      Template.loadJSON().then(function (data) {
        if (Editor.mode === 'editor.section' && data.for_email) {
          var newWidgetList = [];
          _.each(Editor.Instrumentations.widgetList, function (widget) {
            var ref = widget.type;
            if (ref === 'image' || ref === 'text' || ref === 'button' || ref === 'spacer' || ref === 'line') {
              newWidgetList.push(widget);
            }
          });
          Editor.Instrumentations.widgetList = newWidgetList;
        }

        $rootScope.contentSections = _.filter(data, {
          section_type: 'default'
        });

        $rootScope.sections = data;
        layoutEditor.setTemplateJSON(data);
        editorDragPanel.initSectionsPanels($rootScope.Y, Editor.mode);
        blockOverlays.init($rootScope.Y);
        addAdditionalFonts();

        $rootScope.toggleCommonSections();
        layoutEditor.sectionInitializers($rootScope.Y);
        $rootScope.checkIntBlocks();
        $rootScope.initWidgets();

        $timeout(function () {
          $scope.templateIsReady = true;
        }, 1000);

        $timeout(function () {
          startEditPublicSection();
        });
      });
    }, function () {
      $rootScope.alertDialog({
        title: $filter('translate')('alert.editor.error'),
        text: $filter('translate')('alert.editor.errorDescription'),
        accept_text: 'OK',
        accept: function accept() {
          var ref;
          if ((ref = window.justclick.currentUser.role) === 'admin' || ref === 'superadmin') {
            document.location.href = '/sites/constructor/admin/#/admin/dashboard/templates';
          } else {
            document.location.href = window.justclick.back_uri;
          }
        }
      });
    });
  };

  /**
   * currentPage
   * @param site
   * @returns {*}
   */
  var currentPage = function currentPage(site) {
    var currentPage = void 0;

    var pageId = $state.params.pageId;
    var parentPagesResult = _.filter(site.pages, {
      path: $state.params.pageId
    })[0];

    if (parentPagesResult) {
      currentPage = parentPagesResult;
    }

    site.pages.forEach(function (page) {
      page.pages.forEach(function (pageChild) {
        if (pageChild.path === pageId) {
          currentPage = pageChild;
        }
      });
    });

    return currentPage;
  };

  window.Editor = {};
  window.Editor = {
    initializer: function initializer() {
      if (window.Editor.mode === 'site.page.mixer') {
        window.Editor.option = 'site.page.mixer';
        window.Editor.mode = 'site.page.editor';
      }

      if (window.Editor.mode === 'site.page.editor') {
        Site.get($state.params.siteId).then(function (siteData) {
          $rootScope.currentSite = siteData;
          $rootScope.currentPage = currentPage(siteData);
          $rootScope.Y.one('#tpl-wrapper').section = $rootScope.currentPage;
          setBgStyles();
          loadStyles();
        }, function () {
          $state.go('404');
        });
      }

      if (window.Editor.mode === 'editor.section') {
        loadStyles();
      }

      window.Editor.Instrumentations.initializer(afterInstrumentsInitialized);
    },
    mode: $state.current.name,
    getSections: function getSections() {
      var sections = [];
      var domSections = $rootScope.Y.all(ns.sectionClass);
      var self = this;

      domSections.each(function (s) {
        // Установим правильную секцию при получении списка секций, если необходимо
        var previousSection = layoutEditor.getRootScopeParameter('previousSection', s.section.id);

        var needChangeSection = !!s.section.removed;
        if (!!previousSection && self.getSectionBackgroundImagesCount(s.section) !== self.getSectionBackgroundImagesCount(previousSection)) {
          needChangeSection = true;
        }

        if (!needChangeSection && !!previousSection && !_.isEqual(previousSection, s.section)) {
          s.section = previousSection;
        }

        sections.push(s.section);
      });

      return sections;
    },
    getEditedSections: function getEditedSections() {
      var sections = [];
      $rootScope.Y.all(ns.sectionClass).each(function (s) {
        if (s.edited) {
          sections.push(s.section);
        }
      });
      return sections;
    },

    getSectionBackgroundImagesCount: function getSectionBackgroundImagesCount(section) {
      if (typeof section.background_attributes === 'undefined') {
        return 0;
      }

      if (typeof section.background_attributes.images_attributes === 'undefined') {
        return 0;
      }

      return section.background_attributes.images_attributes.length;
    },

    destroy: function destroy() {
      layoutEditor.destroy();
    }
  };
  Editor.Instrumentations = {
    initializer: function initializer(cb) {
      var self = this;

      var widgetsTypesSortMap = ['headline_h1', 'headline_h2', 'headline_h3', 'text', 'spacer', 'subscribe_form', 'image', 'video', 'button', 'list', 'timer', 'code', 'navigation', 'link', 'review', 'card', 'product', 'slider', 'gallery', 'table', 'line', 'map', 'social', 'facebook_comment'];

      Widget.getAll().then(function (widgetsData) {
        self.widgetList = widgetsData.widgets;
        self.widgetList = WidgetsSortHelper.sortWidgetsByTypesSortMap(self.widgetList, widgetsTypesSortMap);

        if (!!window.justclick && !!window.justclick.disableWidgets && window.justclick.disableWidgets.length > 0) {
          self.widgetList = self.widgetList.filter(function (widget) {
            return !window.justclick.disableWidgets.includes(widget.type);
          });
        }

        $timeout(function () {
          return cb();
        });
      });
    },
    defaultFonts: Font.defaults,
    widgetList: []
  };

  $rootScope.Editor = Editor;
  window.Editor = Editor;

  var destroyWidgetsFinished = $scope.$on('widgetsFinished', function (newData) {
    return insertBlockMenu.initDD();
  });

  $scope.$on('$destroy', function () {
    unbindPreventForm();
    destroyGetStyles();
    destroyWidgetsFinished();
    Editor.destroy();
    TimeMachine.destroy();
    $rootScope.widgetIsEditing = false;
    $scope.templateIsReady = false;
  });

  if (!$rootScope.Y) {
    YUI().use('node', 'event-valuechange', 'anim', 'dd', 'dd-proxy', 'dd-constrain', 'dd-drop', 'dd-scroll', 'dd-delegate', 'event-hover', 'resize', 'resize-plugin', 'overlay', function (y) {
      $rootScope.Y = y;
      return Editor.initializer();
    });
  } else {
    Editor.initializer();
  }

  $rootScope.toggleCommonSections = function (sections) {
    sections = Editor.getSections();

    var headers = _.filter(sections, { section_type: 'header' });
    var footers = _.filter(sections, { section_type: 'footer' });

    footers = _.filter(footers, function (item) {
      return !item.removed;
    });
    headers = _.filter(headers, function (item) {
      return !item.removed;
    });

    $scope.showFooter = !footers.length;
    $scope.showHeader = !headers.length;
    if (!window.justclick.userSiteId) {
      $scope.showFooter = false;
      $scope.showHeader = false;
    }

    if (!$scope.$$phase) {
      $scope.$apply();
    }
  };

  $scope.viewSite = State.viewSite;
  $scope.saveSection = editorDragPanel.cancelSection;
  $rootScope.openEditorNavPanel = function () {
    $('.etsw-header__title').text($filter('translate')('editor.addElementButton'));
    $scope.editorNavOpen = true;
  };
  $scope.openEditorNav = function () {
    $rootScope.editorNavTab('sections');
    $rootScope.openEditorNavPanel();
  };
  $scope.panelRight = true;
  $scope.togglePanelPosition = function () {
    $scope.panelRight = !$scope.panelRight;
  };

  /**
   * Сохранение сайта
   * @param all
   */
  var publishSite = function publishSite(all) {
    var sections = Editor.getSections();

    layoutEditor.sortSections();
    Section.saveAllSectionsAndPublish(sections).then(function (sectionsData) {
      EditorLibrary.showBuildStatus(Section, $scope, null, 3000, 3000, 3);
      TimeMachine.clear();
      layoutEditor.setTemplateJSON(sectionsData);

      $timeout(function () {
        $rootScope.Y.all(ns.sectionClass).each(function (section) {
          section.edited = false;
        });

        if (layoutEditor.layout) {
          layoutEditor.layout.edited = true;
        }

        $scope.publishing = false;
        $rootScope.defaultFontSetted = false;
        Notification.success({
          message: $filter('translate')('site.saved')
        });
      }, 300);
    }, function () {
      $scope.publishing = false;
      Notification.error({
        message: $filter('translate')('site.error')
      });
    });
  };

  $rootScope.undo = function () {
    $timeout(function () {
      TimeMachine.undo();
    });
  };
  $rootScope.redo = function () {
    $timeout(function () {
      TimeMachine.redo();
    });
  };

  $rootScope.savePreview = function () {
    $scope.loading = true;
    $rootScope.Y.all('.str-section').each(function (section) {
      Section.beforeSave(section);
    });

    if ($rootScope.defaultFontSetted) {
      Site.clearFonts().then(function () {
        Site.update($rootScope.site_fonts).then(function (siteData) {
          $rootScope.site.default_font = siteData.default_font;
          $rootScope.site.h_font = siteData.h_font;
        });
      });
    }

    var sections = Editor.getSections();
    layoutEditor.sortSections();
    Section.saveAllSectionsAndPublishPreview(sections).then(function (response) {
      if (response.status && response.data !== null && response.data !== undefined && response.data.preview_site_id !== null && response.data.preview_site_id !== undefined) {
        $scope.loading = false;
        $rootScope.openPreview(response.data.preview_site_id);
      }
    }, function () {
      $scope.loading = false;
      Notification.error({
        message: $filter('translate')('site.error')
      });
    });
  };

  $rootScope.publishSite = function () {
    $timeout(function () {
      $scope.publishing = true;
      $rootScope.Y.all('.str-section').each(function (section) {
        Section.beforeSave(section);
      });

      if ($rootScope.defaultFontSetted) {
        Site.clearFonts().then(function () {
          Site.update($rootScope.site_fonts).then(function (siteData) {
            $rootScope.site.default_font = siteData.default_font;
            $rootScope.site.h_font = siteData.h_font;

            publishSite(true);
          });
        });
      } else {
        publishSite(false);
      }
    }, 300);
  };

  $scope.sectionSave = function () {
    $scope.sectionSaving = true;
    layoutEditor.publicSectionSave().then(function () {
      $scope.sectionSaving = false;
    });
  };

  $scope.exit = function () {
    $rootScope.alertDialog({
      title: $filter('translate')('alert.editor.exitTitle'),
      text: $filter('translate')('alert.editor.exitDescription'),
      accept_text: $filter('translate')('alert.confirm'),
      cancel_text: $filter('translate')('alert.cancel'),
      accept: function accept() {
        var ref = window.justclick.currentUser.role;
        if (ref === 'admin' || ref === 'superadmin') {
          document.location.href = '/sites/constructor/admin/#/admin/dashboard/templates';
        } else {
          document.location.href = window.justclick.back_uri;
        }
      }
    });
  };
}]);

/***/ }),
/* 45 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

var moduleEditor = angular.module('editorLesson.controller', ['api.widget', 'factory.editorLibrary']);

moduleEditor.controller("EditorLessonCtrl", ["$scope", "$rootScope", "$state", "$timeout", "editorNavSections", "layoutEditor", "Widget", "insertBlockMenu", "Template", "ns", "Lesson", "editorDragPanel", "SectionLesson", "$modal", "State", "blockOverlays", "Font", "TimeMachine", "Notification", "$filter", "Parallax", "WidgetsSortHelper", "EditorLibrary", function ($scope, $rootScope, $state, $timeout, editorNavSections, layoutEditor, Widget, insertBlockMenu, Template, ns, Lesson, editorDragPanel, SectionLesson, $modal, State, blockOverlays, Font, TimeMachine, Notification, $filter, Parallax, WidgetsSortHelper, EditorLibrary) {

  var stylesCallback = undefined;

  $scope.templateIsReady = false;
  $rootScope.filter = $filter;
  $rootScope.justclick = window.justclick;

  /**
   * Template style manipulation
   * @param sectionId
   */
  var loadStylesOfTemplate = function loadStylesOfTemplate() {
    var sectionId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    Template.getStylesheet().then(function (response) {
      angular.element("#tplStyles").text(response);
      if (stylesCallback) {
        stylesCallback();
        stylesCallback = undefined;
      }
    });
  };

  /**
   * loadStylesOfPublicSection
   */
  var loadStylesOfPublicSection = function loadStylesOfPublicSection() {
    SectionLesson.getPublicSectionStylesheet().then(function (response) {
      angular.element("#tplStyles").text(response);
    });
  };

  /**
   * loadStyles
   * @param sectionId
   */
  var loadStyles = function loadStyles() {
    var sectionId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if ($state.includes("editor.section")) {
      loadStylesOfPublicSection();
    } else {
      loadStylesOfTemplate(sectionId);
    }
  };

  /**
   * destroyGetStyles $on "get:styles"
   */
  var destroyGetStyles = $rootScope.$on("get:styles", function (data, sectionId, cb) {
    if (cb) {
      stylesCallback = cb;
    }

    loadStyles(sectionId);
  });

  /**
   * addAdditionalFonts
   */
  var addAdditionalFonts = function addAdditionalFonts() {
    if (Editor.mode === "editor.section") {
      Editor.Instrumentations.fonts = $rootScope.sections.fonts_attributes;
    }
    if (Editor.mode === "lesson.page.editor") {
      Editor.Instrumentations.fonts = $rootScope.site.fonts_attributes.concat(Font.defaultLessonFonts);
    }
    $rootScope.$broadcast("fontNames:loaded");
  };

  /**
   * Auto start edit section
   */
  var startEditPublicSection = function startEditPublicSection() {
    if (Editor.mode === "editor.section") {
      var layout = $rootScope.Y.one(ns.sectionClass);
      return editorDragPanel._onClickEditSection({
        target: layout
      });
    }
  };

  /**
   * Remove auto play on videos
   * @param htmlData
   * @returns {string}
   */
  var removeAutoPlay = function removeAutoPlay(htmlData) {
    if (!htmlData) {
      return "";
    }

    return htmlData.replace(new RegExp("autoplay=1", 'g'), "");
  };

  /**
   * Set event preventDefault
   * @param e
   */
  var preventForm = function preventForm(e) {
    e.preventDefault();
  };

  /**
   * Disable submit forms
   */
  var preventFormsSubmit = function preventFormsSubmit() {
    angular.element("body").on("submit", "form", preventForm);
  };

  /**
   * Enable submit forms
   */
  var unbindPreventForm = function unbindPreventForm() {
    angular.element("body").off("submit", "form", preventForm);
  };

  /**
   * Parse sections html
   * @param selector
   * @param htmlString
   * @returns {*}
   */
  var parseHTML = function parseHTML(selector, htmlString) {
    var codeHTML = "<div class='str-bw_code-html-overlay'>" + "<img class='str-bw_code-html-overlay-icon' src='/constructor/editor/assets/images/code-overlay-icon.svg' />" + ('<div class=\'str-bw_code-html-overlay-text\'>' + $filter('translate')('widget.code.text') + '</div>') + "</div>";

    var contentSectionsHTML = "";
    var jContent = $('<div/>').html(htmlString).contents();

    jContent.find(".str-bw_code-html").html(codeHTML);

    if (selector !== "section" && jContent.find(selector)[0]) {
      return jContent.find(selector)[0].outerHTML;
    }
    if (selector === "section") {
      jContent.find("section").each(function (index, section) {
        return contentSectionsHTML += section.outerHTML;
      });
      return contentSectionsHTML;
    }
  };

  /**
   * Insert sections html to wrapper
   * @param htmlData
   * @returns {boolean}
   */
  var setTemplateHTML = function setTemplateHTML(htmlData) {
    if (Editor.mode === "editor.section") {
      $("#tpl-wrapper").html(htmlData);
      return false;
    }
    htmlData = '<div>' + htmlData + '</div>';

    var headerHTML = parseHTML("header", htmlData);
    var footerHTML = parseHTML("footer", htmlData);
    var contentSectionsHTML = parseHTML("section", htmlData);

    $(headerHTML).insertBefore(".str-drop-backdrop");
    $(footerHTML).insertAfter(".str-drop-backdrop");
    $(contentSectionsHTML).insertAfter(".str-drop-backdrop");
    EditorLibrary.removeVisibilityDelay();
  };

  /**
   * Callback after instruments initialized
   */
  var afterInstrumentsInitialized = function afterInstrumentsInitialized() {
    preventFormsSubmit();
    Template.loadHTML().then(function (htmlData) {
      htmlData = removeAutoPlay(htmlData);

      // try set html to Template from server
      try {
        setTemplateHTML(htmlData);
      } catch (e) {
        log(e);
      }

      // set Y instace to layoutEditor class
      layoutEditor.initializer($rootScope.Y);

      // load json sections and set to YUI DOM objects
      Template.loadJSON().then(function (data) {

        $rootScope.contentSections = _.filter(data, { section_type: "default" });
        $rootScope.sections = data;

        layoutEditor.setTemplateJSON(data);

        editorDragPanel.initSectionsPanels($rootScope.Y, Editor.mode);
        blockOverlays.init($rootScope.Y);
        addAdditionalFonts();
        $rootScope.toggleCommonSections();
        layoutEditor.sectionInitializers($rootScope.Y);
        $rootScope.checkInteractiveBlocks();

        $timeout(function () {
          $scope.templateIsReady = true;
        }, 1000);

        $timeout(function () {
          startEditPublicSection();
        });
      });
    }, function () {
      $rootScope.alertDialog({
        title: $filter("translate")("alert.editor.error"),
        text: $filter("translate")("alert.editor.errorDescription"),
        accept_text: "OK",
        accept: function accept() {
          if (["admin", "superadmin"].includes(window.justclick.currentUser.role)) {
            document.location.href = "/sites/constructor/admin/#/admin/dashboard/templates";
          } else {
            document.location.href = window.justclick.back_uri;
          }
        }
      });
    });
  };

  var pageLmsStyling = function pageLmsStyling() {
    if (!!window.justclick.lms === false) {
      return false;
    }

    var headerHtml = window.justclick.lms.header;
    var footerHtml = window.justclick.lms.footer;

    var $header = angular.element(".e__lesson__header");
    var $footer = angular.element(".e__lesson__footer");

    $header.html(headerHtml);
    $footer.html(footerHtml);

    Lesson.getLmsStylesheets().then(function (response) {
      angular.element("#lmsStyles").html(response);
    });
  };

  /**
   * Create class editor
   */
  var Editor = {
    initializer: function initializer() {
      if (Editor.mode === 'lesson.page.mixer') {
        Editor.option = 'lesson.page.mixer';
        Editor.mode = 'lesson.page.editor';
      }

      // Get json of site and load styles
      if (Editor.mode === "lesson.page.editor") {
        pageLmsStyling();

        Lesson.get($state.params.lessonId).then(function (siteData) {
          $rootScope.currentSite = siteData;
          $rootScope.currentPage = getJsonCurrentPage(siteData);
          $rootScope.Y.one("#tpl-wrapper").section = $rootScope.currentPage;
          setBgStyles();
          loadStyles();
        }, function () {
          $state.go("404");
        });
      }
      if (Editor.mode === "editor.section") {
        loadStyles();
      }
      // init instruments for editor
      Editor.Instrumentations.initializer(afterInstrumentsInitialized);
    },
    mode: $state.current.name,
    getSections: function getSections() {
      var sections = [];
      var domSections = $rootScope.Y.all(ns.sectionClass);

      domSections.each(function (s) {
        // Установим правильную секцию при получении списка секций, если необходимо
        var previousSection = layoutEditor.getRootScopeParameter('previousSection', s.section.id);
        if (!s.section.removed && !!previousSection && !_.isEqual(previousSection, s.section)) {
          s.section = previousSection;
        }

        sections.push(s.section);
      });

      return sections;
    },
    destroy: function destroy() {
      layoutEditor.destroy();
    },
    // Editor instrumentations
    Instrumentations: {
      defaultFonts: Font.defaults,
      widgetList: [],
      approvedWidgetsList: [
      // "product",
      "button",
      // "form",
      "subscribe_form", "image", "line", "link", "spacer", "text", "headline_h1", "headline_h2", "headline_h3", "video", "navigation", "card", "code", "gallery", "slider", "review", "map", "social",
      // "timer",
      "table", "list"]
    }
  };

  /**
   * Editor instrumentations initializer
   * @param cb
   */
  Editor.Instrumentations.initializer = function (cb) {
    var self = Editor.Instrumentations;

    var widgetsTypesSortMap = ['headline_h1', 'headline_h2', 'headline_h3', 'text', 'spacer', 'subscribe_form', 'image', 'video', 'button', 'list', 'timer', 'code', 'navigation', 'link', 'review', 'card', 'product', 'slider', 'gallery', 'table', 'line', 'map', 'social', 'facebook_comment'];

    // Загрузка виджетов, использование только тех виджетов, которые указаны в массиве approvedWidgetsList
    Widget.getAll().then(function (widgetsData) {
      _.each(widgetsData.widgets, function (widget) {
        if (self.approvedWidgetsList.includes(widget.type)) {
          self.widgetList.push(widget);
        }
      });

      self.widgetList = WidgetsSortHelper.sortWidgetsByTypesSortMap(self.widgetList, widgetsTypesSortMap);

      $timeout(function () {
        cb();
      });
    });
  };

  // set Editor globally
  $rootScope.Editor = Editor;
  window.Editor = Editor;

  /**
   * setGradient
   * @param background_attributes
   */
  var setGradient = function setGradient(background_attributes) {
    var color_start = background_attributes.color_start;
    var color_stop = background_attributes.color_stop;
    var gradient_css = 'background-image:-moz-linear-gradient(top, ' + color_start + ', ' + color_stop + ');' + ('background-image:-webkit-linear-gradient(top, ' + color_start + ', ' + color_stop + ');') + ('background-image:-o-linear-gradient(top, ' + color_start + ', ' + color_stop + ');') + ('background-image:-ms-linear-gradient(top, ' + color_start + ', ' + color_stop + ');,') + ('background-image:linear-gradient(top, ' + color_start + ', ' + color_stop + ');') + ('filter: progid:DXImageTransform.Microsoft.gradient(startColorStr=\'' + color_start + '\', endColorstr=\'' + color_stop + '\');"');

    var $style = $('style#' + $rootScope.currentPage.id);

    if ($style.length > 0) {
      $style.html('#tpl-wrapper:before { ' + gradient_css + ' }');
    } else {
      $('body').append('<style id=\'' + $rootScope.currentPage.id + '\'>#tpl-wrapper:before { ' + gradient_css + ' }</style>');
    }
  };

  /**
   * setBgStyles
   */
  var setBgStyles = function setBgStyles() {
    var bodyElement = $("#tpl-wrapper");
    bodyElement.css($rootScope.currentPage.style_attributes);
    var imageExist = $rootScope.currentPage.background_attributes && $rootScope.currentPage.background_attributes.image_attributes && $rootScope.currentPage.background_attributes.image_attributes.source_url;
    if (imageExist) {
      bodyElement.css({
        backgroundImage: "url('" + $rootScope.currentPage.background_attributes.image_attributes.source_url + "')"
      });
    }
    if ($rootScope.currentPage.background_attributes && $rootScope.currentPage.background_attributes.gradient) {
      setGradient($rootScope.currentPage.background_attributes);
    }
    Parallax.initSection($rootScope.Y.one("#tpl-wrapper"));
  };

  /**
   * Get json current page
   * @param site
   * @returns {undefined}
   */
  var getJsonCurrentPage = function getJsonCurrentPage(site) {
    var currentPage = undefined;

    var pageId = $state.params.pageId;
    var parentPagesResult = _.filter(site.pages, { path: $state.params.pageId })[0];

    if (parentPagesResult) {
      currentPage = parentPagesResult;
    }

    site.pages.forEach(function (page) {
      page.pages.forEach(function (pageChild) {
        if (pageChild.path === pageId) {
          currentPage = pageChild;
        }
      });
    });

    return currentPage;
  };

  /**
   * Init drag&drop widgets in widget menu after render
   */
  var destroyWidgetsFinished = $scope.$on("widgetsFinished", function (newData) {
    insertBlockMenu.initDD();
  });

  /**
   * Destroy instances when exit from editor
   */
  $scope.$on("$destroy", function () {
    unbindPreventForm();
    destroyGetStyles();
    destroyWidgetsFinished();
    Editor.destroy();
    TimeMachine.destroy();
    $rootScope.widgetIsEditing = false;
    $scope.templateIsReady = false;
  });

  // Connect and initialize YUI library Y instance, Editor initialize, Instrumentations init
  if (!$rootScope.Y) {
    YUI().use('node', 'event-valuechange', 'anim', 'dd', 'dd-proxy', 'dd-constrain', 'dd-drop', 'dd-scroll', "dd-delegate", "event-hover", "resize", "resize-plugin", "overlay", function (y) {
      $rootScope.Y = y;
      Editor.initializer();
    });
  } else {
    Editor.initializer();
  }

  /**
   * Show or hide drop overlays of footer or header
   * @param sections
   */
  $rootScope.toggleCommonSections = function (sections) {
    sections = Editor.getSections();
    var headers = _.filter(sections, { section_type: "header" });
    var footers = _.filter(sections, { section_type: "footer" });

    $scope.showFooter = !footers.length;
    $scope.showHeader = !headers.length;
    if (!$scope.$$phase) {
      $scope.$apply();
    }
  };

  $scope.viewSite = State.viewSite;
  $scope.saveSection = editorDragPanel.cancelSection;

  $rootScope.openEditorNavPanel = function () {
    $(".etsw-header__title").text($filter('translate')('editor.addElementButton'));
    $scope.editorNavOpen = true;
  };

  $scope.openEditorNav = function () {
    $rootScope.editorNavTab("sections");
    $rootScope.openEditorNavPanel();
  };

  $scope.panelRight = true;
  $scope.togglePanelPosition = function () {
    $scope.panelRight = !$scope.panelRight;
  };

  $rootScope.undo = function () {
    $timeout(function () {
      TimeMachine.undo();
    });
  };
  $rootScope.redo = function () {
    $timeout(function () {
      TimeMachine.redo();
    });
  };

  /**
   * save preview
   */
  $rootScope.savePreview = function () {
    $scope.loading = true;

    var sections = Editor.getSections();
    layoutEditor.sortSections();
    SectionLesson.saveAllSectionsAndPublishPreview(sections).then(function (response) {
      if (response.status && typeof response.data !== "undefined" && response.data !== null && typeof response.data.preview_lms_page_id !== "undefined" && response.data.preview_lms_page_id !== null) {
        $scope.loading = false;
        $rootScope.openPreview(response.data.preview_lms_page_id);
      }
    }, function () {
      $scope.loading = false;
      Notification.error({ message: $filter('translate')('site.error') });
    });
  };

  /**
   * publish site
   */
  $rootScope.publishSite = function () {
    $timeout(function () {
      $scope.publishing = true;

      var sections = Editor.getSections();
      layoutEditor.sortSections();
      SectionLesson.saveAllSectionsAndPublish(sections).then(function (sectionsData) {
        EditorLibrary.showBuildStatus(SectionLesson, $scope, null, 3000, 3000, 3);

        TimeMachine.clear();
        layoutEditor.setTemplateJSON(sectionsData);
        $timeout(function () {
          $scope.publishing = false;
          Notification.success({ message: $filter('translate')('site.saved') });
        });
      }, function () {
        $scope.publishing = false;
        Notification.error({ message: $filter('translate')('site.error') });
      });
    }, 300);
  };

  /**
   * section save
   */
  $scope.sectionSave = function () {
    $scope.sectionSaving = true;
    layoutEditor.publicSectionSave().then(function () {
      $scope.sectionSaving = false;
    });
    return;
  };

  /**
   * Exit from editor
   */
  $scope.exit = function () {
    $rootScope.alertDialog({
      title: $filter("translate")("alert.editor.exitTitle"),
      text: $filter("translate")("alert.editor.exitDescription"),
      accept_text: $filter("translate")("alert.confirm"),
      cancel_text: $filter("translate")("alert.cancel"),
      accept: function accept() {
        if (["admin", "superadmin"].includes(window.justclick.currentUser.role)) {
          $state.go("admin.dashboard.templates");
        } else {
          document.location.href = window.justclick.back_uri;
        }
      }
    });
  };

  $rootScope.checkInteractiveBlocks = function () {
    if (Editor.mode !== 'lesson.page.editor') {
      return false;
    }

    $scope.intBlocksExists = false;
    Editor.getSections().forEach(function (section) {
      if (section.interactive) {
        $scope.intBlocksExists = true;
      }
    });

    $rootScope.Y.all('.str-block').each(function (block) {
      if (block.widget && block.widget.interactive) {
        $scope.intBlocksExists = true;
      }
    });
  };
}]);

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* injects from baggage-loader */



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var moduleEditorLibrary = angular.module('factory.editorLibrary', []);

moduleEditorLibrary.factory('EditorLibrary', ['$interval', 'Notification', '$filter', function ($interval, Notification, $filter) {
  var BUILD_QUEUED = 'queued';
  var BUILD_WORKING = 'working';
  var BUILD_RETRYING = 'retrying';
  var BUILD_COMPLETE = 'complete';
  var BUILD_FAILED = 'failed';
  var BUILD_STOPPED = 'stopped';
  var BUILD_INTERRUPTED = 'interrupted';

  var EditorLibrary = function () {
    function EditorLibrary() {
      _classCallCheck(this, EditorLibrary);

      this.intervalId = null;
    }

    _createClass(EditorLibrary, [{
      key: 'showBuildStatus',
      value: function showBuildStatus(Section, $scope, type, intervalPeriod, intervalStep, maxIntervalCount) {
        var _this = this;

        $scope.buildIsNotFinish = true;
        $scope.buildingType = type;

        if (this.intervalId) {
          this.clearInterval();
        }

        var intervalCount = 0;

        this.intervalId = $interval(function () {
          Section.getBuildStatus().then(function (response) {
            if (response && response.build_status) {
              switch (response.build_status) {
                case BUILD_QUEUED:
                case BUILD_WORKING:
                case BUILD_RETRYING:
                  {
                    break;
                  }
                case BUILD_COMPLETE:
                  {
                    _this.clearInterval();
                    $scope.buildIsNotFinish = false;
                    break;
                  }
                case BUILD_FAILED:
                case BUILD_STOPPED:
                case BUILD_INTERRUPTED:
                  {
                    console.error('Build is failure, status: ' + response.build_status);
                    _this.clearInterval();
                    _this.onBuildFailure($scope);
                    break;
                  }
              }
            }

            // Если период стал слишком большим, то остановим запросы и выведем ошибку
            if (intervalPeriod > intervalStep * 5) {
              _this.clearInterval();
              _this.onBuildFailure($scope);
            }

            // При привышении максимального количества запросов - увеличим период
            if (intervalCount > maxIntervalCount) {
              _this.clearInterval();

              var newIntervalPeriod = intervalPeriod + intervalStep;
              _this.showBuildStatus(Section, $scope, type, newIntervalPeriod, intervalStep, maxIntervalCount);
            }

            intervalCount++;
          }, function () {
            _this.onBuildFailure($scope);
          });
        }, intervalPeriod);
      }
    }, {
      key: 'clearInterval',
      value: function clearInterval() {
        $interval.cancel(this.intervalId);
        this.intervalId = null;
      }
    }, {
      key: 'onBuildFailure',
      value: function onBuildFailure($scope) {
        $scope.buildIsNotFinish = false;
        Notification.error({
          message: $filter('translate')('site.error')
        });
      }
    }, {
      key: 'removeVisibilityDelay',
      value: function removeVisibilityDelay() {
        $('.visibility_delay_enable').each(function (index, item) {
          var $item = $(item);
          $item.removeClass('visibility_delay_enable');
        });
      }

      /**
       * Создадим запись об ошибке в scope
       * @param $scope
       * @param field
       * @param message
       */

    }, {
      key: 'createError',
      value: function createError($scope, field, message) {
        if (!$scope.error) {
          $scope.error = {};
        }

        $scope.error[field] = message;
      }

      /**
       * Удалим ошибку из scope
       * @param $scope
       * @param field
       */

    }, {
      key: 'clearError',
      value: function clearError($scope, field) {
        if ($scope.error && $scope.error[field]) {
          $scope.error[field] = false;
        }
      }
    }]);

    return EditorLibrary;
  }();

  return new EditorLibrary();
}]);

/***/ }),
/* 47 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

var indexOf = [].indexOf || function (item) {
  for (var i = 0, l = this.length; i < l; i++) {
    if (i in this && this[i] === item) return i;
  }
  return -1;
};

var moduleEditorNav = angular.module('editorNavigation.controller', ["api.widget", "services.layoutEditor.sectionDragDrop"]);

moduleEditorNav.controller("EditorNavigationCtrl", ["$scope", "$state", "$timeout", "layoutEditor", "insertSpace", "ns", "sectionDragDrop", "$injector", "Section", "editorNavSections", "Site", "FileUploader", "$cookies", "$rootScope", "editorDragPanel", "Restangular", "Modal", "Template", "$sce", "State", "Page", "TimeMachine", "blockEditDialog", "Notification", "Widget", "Email", "$filter", "$translate", function ($scope, $state, $timeout, layoutEditor, insertSpace, ns, sectionDragDrop, $injector, Section, editorNavSections, Site, FileUploader, $cookies, $rootScope, editorDragPanel, Restangular, Modal, Template, $sce, State, Page, TimeMachine, blockEditDialog, Notification, Widget, Email, $filter, $translate) {

  $scope.currentEditorTab = "";
  $scope.currentNavEditorTab = "";
  $scope.sectionsCollection = [];
  $scope.widthType = "px";
  $scope.editCurrentTab = "blockSettings";
  $scope.openTab = function (tab) {
    $scope.editCurrentTab = tab;
  };
  $scope.togglePagesSettings = function () {
    $scope.popoverOpen = !$scope.popoverOpen;
  };
  $scope.closePagesSettings = function () {
    $scope.popoverOpen = false;
  };
  $scope.closeEditorNav = function () {
    var $tools = $(".e__tools");

    if ($tools.scope().editorNavOpenWidget) {
      $rootScope.editSection();
    } else {
      $tools.scope().editorNavOpenWidget = false;
      $tools.scope().editorNavOpen = false;
      if (!$tools.scope().$$phase) {
        $tools.scope().$apply();
      }
    }
  };
  $scope.jcButtonColors = [{
    color: "#bf7404",
    classes: "g-button orange"
  }, {
    color: "#06bf47",
    classes: "g-button green"
  }, {
    color: "#014b81",
    classes: "g-button blue"
  }, {
    color: "#bd0209",
    classes: "g-button red"
  }, {
    color: "#630461",
    classes: "g-button pink"
  }];
  $scope.setFrameButtonColor = function (color, data) {
    var c, i, len, ref;
    ref = $scope.jcButtonColors;
    for (i = 0, len = ref.length; i < len; i++) {
      c = ref[i];
      c.active = false;
    }
    data.frame_settings.frame_button_color = color.classes;
    color.active = true;
  };
  $scope.offertFieldEnabled = function (orderFields) {
    return _.filter(orderFields, {
      name: "offerta"
    })[0].exist;
  };
  $rootScope.$on("translations:loaded", function () {
    return $scope.add_ad_channels = function () {
      return $scope.ad_channels = [{
        name: "cpc",
        title: "" + $filter('translate')('widget.form.utms.option1')
      }, {
        name: "affiliate",
        title: "" + $filter('translate')('widget.form.utms.option11')
      }, {
        name: "cpl",
        title: "" + $filter('translate')('widget.form.utms.option2')
      }, {
        name: "cps",
        title: "" + $filter('translate')('widget.form.utms.option3')
      }, {
        name: "cpm",
        title: "" + $filter('translate')('widget.form.utms.option4')
      }, {
        name: "social",
        title: "" + $filter('translate')('widget.form.utms.option5')
      }, {
        name: "display",
        title: "" + $filter('translate')('widget.form.utms.option6')
      }, {
        name: "email",
        title: "" + $filter('translate')('widget.form.utms.option7')
      }, {
        name: "mobile",
        title: "" + $filter('translate')('widget.form.utms.option8')
      }, {
        name: "remarketing",
        title: "" + $filter('translate')('widget.form.utms.option9')
      }, {
        name: "other",
        title: "" + $filter('translate')('widget.form.utms.option10')
      }];
    };
  });
  $scope.concatFonts = function () {
    if (Editor.Instrumentations.fonts) {
      return Editor.Instrumentations.fonts.concat(Editor.Instrumentations.defaultFonts);
    }
  };
  $scope.state = $state;
  var updatePreviews = function updatePreviews() {
    var d = new Date();
    $(".etn__preview-favicon__image").each(function () {
      var oldattr = $(this).attr("ng-src");
      if (oldattr) {
        $(this).attr("src", oldattr + "?" + d.getTime());
      }
    });
    $(".etn__preview-image").each(function () {
      var oldattr = $(this).attr("ng-src");
      if (oldattr) {
        $(this).attr("src", oldattr + "?" + d.getTime());
      }
    });
  };

  var applyStyleToTemplate = function applyStyleToTemplate(site) {
    return $rootScope.$broadcast("get:styles");
  };

  $scope.saveSite = function (site, siteSettingsForm) {
    if (siteSettingsForm.$invalid) {
      return false;
    }
    site = angular.copy(site);
    $scope.savingSite = true;
    return Site.update(site).then(function () {
      $scope.savingSite = false;
      applyStyleToTemplate(site);
    }, function () {
      return $scope.savingSite = false;
    });
  };

  var shakeAnimation = function shakeAnimation() {
    $scope.shakeIt = true;
    $timeout(function () {
      $scope.shakeIt = false;
    }, 400);
  };

  $scope.help = function () {
    $rootScope.openVideoTutorial();
  };

  $rootScope.editorNavTab = function (tab, sectionsTag, sectionsTab) {
    if (sectionsTag == null) {
      sectionsTag = void 0;
    }
    if (sectionsTab == null) {
      sectionsTab = false;
    }
    $("#mini-sections").scrollTop(0);
    $scope.currentEditorTab = "";
    $scope.currentNavEditorTab = "";
    if (!$scope.$$phase) {
      $scope.$apply();
    }
    $rootScope.sectionDropTutorial = false;
    if (tab === 'sections') {
      $scope.currentNavEditorTab = 'sections';
      $rootScope.getPublicSections(sectionsTag);
      $rootScope.openEditorNavPanel();
      if (sectionsTab) {
        $rootScope.$broadcast("open:tab", "sections");
      }
      return false;
    }
    if (tab === 'blockSettings') {
      $scope.currentNavEditorTab = 'blockSettings';
      return false;
    }
    $scope.currentNavEditorTab = tab;
  };
  $scope.menuSlideLeft = function () {
    var ref, rightViews;
    rightViews = ['adminSettings', 'templateSettings', 'pagesSettings', 'fontSettings', 'blockSettings', 'faviconSettings', 'seoSettings', 'networkingSettings', 'domainSettings'];
    return ref = $scope.currentNavEditorTab, indexOf.call(rightViews, ref) >= 0;
  };

  var hideSubEditorTab = function hideSubEditorTab(e) {
    if ($scope.currentEditorTab === 'mainSettings') {
      $rootScope.editorNavTab("templateSettings");
    }
  };

  $scope.subEditorTab = function (tab) {
    if ($scope.currentEditorTab === tab) {
      $scope.currentEditorTab = "";
    } else {
      $scope.currentEditorTab = tab;
    }
  };
  $scope.editorAccordion = function (e) {
    var thisElement, thisSection;
    thisElement = angular.element(e.target);
    thisSection = thisElement.siblings('.ms__section');
    if (thisElement.hasClass('ms__title_active')) {
      thisElement.removeClass('ms__title_active');
      thisSection.removeClass('ms__section_active');
      return;
    } else {
      thisElement.addClass('ms__title_active');
      thisSection.addClass('ms__section_active');
      return;
    }
    return returneditorTab;
  };
  $rootScope.$on("translations:loaded", function () {
    $scope.bgOptions = [{
      name: "none",
      name_ru: $filter('translate')('editor.panel.blockSettings.section.background1.size1')
    }, {
      name: "repeat",
      name_ru: $filter('translate')('editor.panel.blockSettings.section.background1.size2')
    }, {
      name: "cover",
      name_ru: $filter('translate')('editor.panel.blockSettings.section.background1.size3')
    }, {
      name: "contain",
      name_ru: $filter('translate')('editor.panel.blockSettings.section.background1.size4')
    }];
    $scope.contentEffects = [{
      name: "none",
      name_ru: $filter('translate')("editor.panel.blockSettings.section.effect1")
    }, {
      name: "top",
      name_ru: $filter('translate')("editor.panel.blockSettings.section.effect2")
    }, {
      name: "left",
      name_ru: $filter('translate')("editor.panel.blockSettings.section.effect3")
    }, {
      name: "right",
      name_ru: $filter('translate')("editor.panel.blockSettings.section.effect4")
    }, {
      name: "bottom",
      name_ru: $filter('translate')("editor.panel.blockSettings.section.effect5")
    }, {
      name: "fade",
      name_ru: $filter('translate')("editor.panel.blockSettings.section.effect6")
    }, {
      name: "zoom",
      name_ru: $filter('translate')("editor.panel.blockSettings.section.effect7")
    }];
    return $scope.getNameContentType = function (type) {
      switch (type) {
        case "none":
          return $scope.contentEffects[0].name_ru;
        case "top":
          return $scope.contentEffects[1].name_ru;
        case "left":
          return $scope.contentEffects[2].name_ru;
        case "right":
          return $scope.contentEffects[3].name_ru;
        case "bottom":
          return $scope.contentEffects[4].name_ru;
        case "fade":
          return $scope.contentEffects[5].name_ru;
        case "zoom":
          return $scope.contentEffects[6].name_ru;
      }
    };
  });
  $scope.setBgOption = function (name, section) {
    switch (name) {
      case "none":
        setSectionBgNoOption(section);
        break;
      case "repeat":
        setSectionBgRepeat(section);
        break;
      case "contain":
        setSectionBgContain(section);
        break;
      case "cover":
        setSectionBgCover(section);
    }
    $scope.saveSection(section);
  };
  $rootScope.$on("translations:loaded", function () {
    return $scope.bgEffects = [{
      name: "none",
      name_ru: $filter('translate')("editor.panel.blockSettings.section.background1.backgroundEffect1")
    }, {
      name: "fixed",
      name_ru: $filter('translate')("editor.panel.blockSettings.section.background1.backgroundEffect2")
    }, {
      name: "parallax",
      name_ru: $filter('translate')("editor.panel.blockSettings.section.background1.backgroundEffect3")
    }];
  });
  $scope.refreshUploader = true;
  $scope.refreshUploaderFunc = function () {
    $scope.refreshUploader = false;
    $timeout(function () {
      $scope.refreshUploader = true;
    }, 100);
  };
  $scope.removeEmailBg = function (section, imageId) {
    Section.destoyItem(section, imageId).then(function () {
      section.background_attributes.images_attributes.splice(0, 1);
      $scope.refreshUploaderFunc();
    });
  };
  $scope.setBgEffect = function (name, section) {
    switch (name) {
      case "none":
        setSectionBgNoEffect(section);
        break;
      case "fixed":
        setSectionBgFixed(section);
        break;
      case "parallax":
        setSectionBgParallax(section);
    }
    $scope.saveSection(section);
  };
  $scope.newsPages = function () {
    if ($rootScope.site) {
      return _.filter($rootScope.site.pages, {
        type: "news"
      });
    }
  };
  $scope.getPageNameById = function (id) {
    var pages;
    pages = _.filter($rootScope.site.pages, {
      id: id
    });
    if (!id || pages.length === 0) {
      return "";
    }
    return pages[0].name;
  };

  var setSectionBgFixed = function setSectionBgFixed(section) {
    section.style_attributes.backgroundAttachment = "fixed";
    section.background_attributes.parallax = false;
  };

  var setSectionBgParallax = function setSectionBgParallax(section) {
    section.style_attributes.backgroundAttachment = "inherit";
    section.background_attributes.parallax = true;
  };

  var setSectionBgNoEffect = function setSectionBgNoEffect(section) {
    section.background_attributes.parallax = false;
    section.style_attributes.backgroundAttachment = "inherit";
  };

  var setSectionBgRepeat = function setSectionBgRepeat(section) {
    section.style_attributes.backgroundRepeat = "repeat";
    section.style_attributes.backgroundSize = "initial";
  };

  var setSectionBgCover = function setSectionBgCover(section) {
    section.style_attributes.backgroundRepeat = "no-repeat";
    section.style_attributes.backgroundSize = "cover";
  };

  var setSectionBgContain = function setSectionBgContain(section) {
    section.style_attributes.backgroundRepeat = "no-repeat";
    section.style_attributes.backgroundSize = "contain";
  };

  var setSectionBgNoOption = function setSectionBgNoOption(section) {
    section.style_attributes.backgroundRepeat = "no-repeat";
    section.style_attributes.backgroundSize = "initial";
  };

  var timeoutId = void 0;

  var saveSection = function saveSection(section) {
    if (timeoutId) {
      clearInterval(timeoutId);
    }

    timeoutId = setTimeout(function () {
      var newsection = angular.copy(blockEditDialog.currentBlock.section);
      var oldSection = angular.copy(blockEditDialog.currentBlock.old_section);

      layoutEditor.updateSectionEtag(newsection);

      newsection.colors = _.map(newsection.colors, function (tag, index) {
        return tag.text;
      });
      newsection.tags = _.map(newsection.tags, function (tag, index) {
        return tag.text;
      });
      newsection.tags = newsection.tags.join(",");

      if (Editor.mode === "editor.section") {
        Section.saveSettings(newsection).then(function (sectionData) {
          section.background_attributes.images_attributes = sectionData.background_attributes.images_attributes;
        });
      }
    }, 100);
  };

  $scope.saveSectionWithoutTimeout = function (section) {
    saveSection(section);
  };

  $scope.saveSection = function (section) {
    $timeout(function () {
      saveSection(section);
    });
  };

  var protocolPresent = function protocolPresent(str) {
    // если задана переменная вида {$activationLink}, то при её замене подставится и протокол
    if (str.match(/^{\$.*}$/)) {
      return true;
    }

    var pattern = void 0;

    pattern = new RegExp(/^(?:https?|ftp):\/\//);
    if (pattern.test(str)) {
      return true;
    }

    pattern = new RegExp(/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9\+.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[.\!\/\\w]*))?)/);
    return pattern.test(str);
  };

  var previusValidateLink = '';

  $rootScope.enableNextPageOption = window.justclick && !!window.justclick.useNextPageUrl;
  $rootScope.validateLink = function (model, key) {
    if (model.link_href_target === "next") {
      model[key] = '#nextPage';
    } else if (model[key] === '#nextPage') {
      model[key] = previusValidateLink;
    }

    var linkIsNotProtocol = !(model[key] === 'http://' || model[key] === 'https://');
    var linkHaveNotProtocol = !protocolPresent(model[key]);

    if (linkHaveNotProtocol && linkIsNotProtocol && (model.link_href_target === "blank" || !model.link_href_target)) {
      model[key] = "https://" + (model[key] || '');
      previusValidateLink = model[key];
    }

    if (model.link_href_target === "none") {
      model[key] = model[key].replace("https://", "");
      model[key] = model[key].replace("http://", "");
      previusValidateLink = model[key];
    }
  };

  $rootScope.validateNumber = function (model, key) {
    if (typeof model[key] !== "number") {
      model[key] = 0;
    }
  };

  $scope.addImageToLibrary = function (image) {
    image = {
      tag: image.tag,
      image_attributes: {
        remote_source_url: image.image_attributes.source_url
      }
    };
    $scope.addingToLibrary = true;
    Widget.createImage(image).then(function () {
      Notification.success({
        message: 'Картинка добавлена в библиотеку'
      });
      $scope.addingToLibrary = false;
    });
  };
}]);

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* injects from baggage-loader */



var moduleEditorNavSections = angular.module('editorNavigationSections.controller', []);

moduleEditorNavSections.controller('EditorNavigationSections', ['$scope', 'editorNavSections', '$rootScope', 'Section', '$timeout', 'SectionEmail', 'SectionLesson', "$filter", function ($scope, editorNavSections, $rootScope, Section, $timeout, SectionEmail, SectionLesson, $filter) {
  $scope.sectionsCollection = [];
  $scope.categories = [];
  $scope.elementsCurrentTab = 'widgets';
  $scope.openTab = function (tab) {
    $scope.elementsCurrentTab = tab;
  };

  var bindDragDrop = function bindDragDrop() {
    $timeout(function () {
      editorNavSections.bindDragSectionsInCollection();
    });
  };
  var destroyDragDrop = function destroyDragDrop() {
    editorNavSections._destroyBindDragSectionsInCollection();
    editorNavSections.destroyDropSections();
  };

  $rootScope.$on('open:tab', function (e, tab) {
    $scope.openTab(tab);
  });

  $scope.getSections = function (cb, categoryName) {
    destroyDragDrop();
    $scope.sectionsCollection = [];

    if (Editor.mode === 'lesson.page.editor') {
      SectionLesson.getCollection(categoryName, $scope.site.colors).then(function (sectionsData) {
        cb(sectionsData.sections);
        bindDragDrop();
      });
    } else if (Editor.mode === 'email.page.editor') {
      SectionEmail.getCollection(categoryName, $scope.site.colors).then(function (sectionsData) {
        cb(sectionsData.sections);
        bindDragDrop();
      });
    } else {
      Section.getCollection(categoryName, $scope.site.colors).then(function (sectionsData) {
        cb(sectionsData.sections);
        if (Editor.mode === 'editor.section') {
          return false;
        }
        bindDragDrop();
      });
    }
  };

  $scope.removeSection = function (index, section, sections) {
    return $rootScope.alertDialog({
      title: $filter('translate')('alert.publicSection.removeTitle'),
      text: $filter('translate')('alert.publicSection.removeDescription'),
      accept_text: $filter('translate')('alert.confirm'),
      cancel_text: $filter('translate')('alert.cancel'),
      accept: function accept() {
        if (index > -1) {
          Section.removePublic(section.id);
          return sections.splice(index, 1);
        }
      }
    });
  };

  var getCategories = function getCategories() {
    if ($rootScope.site) {
      if (Editor.mode === 'site.page.editor') {
        Section.getCategories($rootScope.site.id).then(function (data) {
          $scope.categories = data;
        });
      }
      if (Editor.mode === 'email.page.editor') {
        SectionEmail.getCategories($rootScope.site.id).then(function (data) {
          $scope.categories = data;
        });
      }
      if (Editor.mode === 'lesson.page.editor') {
        SectionLesson.getCategories($rootScope.site.id).then(function (data) {
          $scope.categories = data;
        });
      }
    }
  };

  $scope.editorAccordion = function (e) {
    var thisElement, thisSection;
    thisElement = angular.element(e.target);
    thisSection = thisElement.siblings('.ms__section');
    if (thisElement.hasClass('ms__title_active')) {
      thisElement.removeClass('ms__title_active');
      thisSection.removeClass('ms__section_active');
    } else {
      thisElement.addClass('ms__title_active');
      thisSection.addClass('ms__section_active');
    }
  };

  $scope.getSectionsByCategory = function (category) {
    if (category.sections && category.sections.length > 0) {
      var hasNotUserSections = category.sections.findIndex(function (item) {
        return !!item.is_own_section;
      }) === -1;

      // Если в списке нет пользовательских секций, то не будем перезагружать секции
      if (hasNotUserSections) {
        return false;
      }
    }

    category.sectionsLoading = true;
    $scope.getSections(function (sectionsData) {
      category.sections = sectionsData;
      category.sectionsLoading = false;
    }, category.original_name);
  };

  $rootScope.getPublicSections = function (sectionsTag) {
    if (sectionsTag) {
      $scope.categories.forEach(function (category) {
        if (category.name === sectionsTag) {
          $scope.getSectionsByCategory(category);
        }
      });
      $scope.editorAccordion({
        target: $("[title='" + sectionsTag + "']")
      });
    }
    if ($scope.categories.length === 0) {
      getCategories();
    }
  };
}]);

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* injects from baggage-loader */



var indexOf = [].indexOf || function (item) {
  for (var i = 0, l = this.length; i < l; i++) {
    if (i in this && this[i] === item) {
      return i;
    }
  }
  return -1;
};

var moduleEditormenu = angular.module('services.editorNavSections', ['services.layoutEditor.sectionDragDrop']);

moduleEditormenu.factory('editorNavSections', ['$timeout', 'layoutEditor', 'insertSpace', 'ns', 'sectionDragDrop', '$injector', 'Section', 'blocksBuilder', 'Site', '$rootScope', 'blockOverlays', 'editorDragPanel', 'Animation', 'Template', 'Tutorials', 'MapInit', 'Timer', 'Parallax', 'TimeMachine', 'Notification', 'SectionEmail', 'SectionLesson', '$state', 'FrameForm', function ($timeout, layoutEditor, insertSpace, ns, sectionDragDrop, $injector, Section, blocksBuilder, Site, $rootScope, blockOverlays, editorDragPanel, Animation, Template, Tutorials, MapInit, Timer, Parallax, TimeMachine, Notification, SectionEmail, SectionLesson, $state, FrameForm) {
  var Y = void 0;

  YUI().use('dd', 'dd-constrain', 'dd-drop', 'dd-scroll', function (y) {
    Y = y;
  });

  if ($state.current.name === 'email.page.editor') {
    Section = SectionEmail;
  }

  if ($state.current.name === 'lesson.page.editor') {
    Section = SectionLesson;
  }

  var editorNavSections = {
    availableTags: ['section', 'header', 'footer'],
    /**
     * buildNewSection
     * @param drag
     * @param cloned
     * @returns {*}
     */
    buildNewSection: function buildNewSection(drag, cloned) {
      if (cloned === null || cloned === undefined) {
        cloned = false;
      }

      this.newsection = blocksBuilder.createSection(ns.sectionLoader, this.newSectionType);
      editorDragPanel.cloneSectionDisabled = true;
      this.cloned = cloned;
      this.setContentHTML(drag, this.newsection);

      return this.newsection;
    },
    editorNavSetTab: function editorNavSetTab(tab) {
      $rootScope.editorNavTab(tab);
    },
    setContentHTML: function setContentHTML(drag) {
      var $dragNode = $(drag._node);
      var sectionId = $dragNode.scope().item && $dragNode.scope().item.id || drag.section.id;
      this.createSiteSection(sectionId);
    },
    lockSections: function lockSections() {
      if (this.ddInstances) {
        this.ddInstances.forEach(function (v) {
          v.set('lock', true);
        });
      }
    },
    unlockSections: function unlockSections() {
      if (this.ddInstances) {
        this.ddInstances.forEach(function (v) {
          v.set('lock', false);
        });
      }
    },
    createSiteSection: function createSiteSection(sectionId) {
      var createFunc = Section.create;

      if (this.cloned) {
        createFunc = Section.clone;
      }

      var self = this;

      createFunc(sectionId, this.newSectionType).then(function (sectionData) {
        $rootScope.$broadcast('get:styles', false, function () {
          self.getSiteNewSectionHtml(sectionData);
          self.indexPosition = undefined;
          $rootScope.$broadcast('sectionFonts:loaded', sectionData.fonts_attributes);
          self.newSectionType = undefined;
        });
      }, function (response) {
        self.unlockSections();
        Notification.error('Неизвестная ошибка (' + response.status + ')');
        self.newsection.remove();
      });
    },
    findMapsInNewSection: function findMapsInNewSection(sectionId) {
      return $('[data-section-id=\'' + sectionId + '\']').find('.strw__map');
    },
    findTimersInNewSection: function findTimersInNewSection(sectionId) {
      return $('[data-section-id=\'' + sectionId + '\']').find('.strbw-timer');
    },
    sectionInitializer: function sectionInitializer(sectionData, htmlData, newsection, withCapture) {
      if (withCapture === null || withCapture === undefined) {
        withCapture = true;
      }

      var self = this;
      var newSectionId = sectionData.id;

      newsection.addClass('ls_' + newSectionId);
      newsection.one(ns.wrapperClass).addClass('ls_' + newSectionId + '-wrapper');

      var htmlContent = $(htmlData).find(ns.wrapperClass).html();

      Animation.prepareSlideDown(newsection);
      newsection.one(ns.wrapperClass).set('innerHTML', htmlContent);
      $(newsection._node).find('.frame-form iframe').each(function () {
        $(this)[0].contentWindow.stop();
      });

      FrameForm.updateFrameForms(newsection);
      newsection.setAttribute('data-section-id', newSectionId);
      layoutEditor.setJSONtoSection(sectionData);
      if (newsection.hasClass('str-cloned__section')) {
        newsection.removeClass('str-cloned__section');
        newsection.edited = true;
      }
      var tagname = newsection.get('tagName').toLowerCase();
      if (tagname === 'section') {
        layoutEditor.setHandleSections(newsection);
      }

      editorDragPanel.addPanelSection(newsection);
      editorDragPanel.bindSectionClickable(newsection);
      layoutEditor.singleSectionInitializer(newsection);
      Animation.slideDown(newsection);
      $rootScope.$broadcast('section:created', newsection);

      this.unlockSections();

      $timeout(function () {
        $(window).trigger('resize');
        blockOverlays.addOverlaysToBlocks();

        self.findMapsInNewSection(newSectionId).each(MapInit.initMap);
        self.findTimersInNewSection(newSectionId).each(function (index, element) {
          return Timer.initTimer(index, element);
        });

        editorDragPanel.cloneSectionDisabled = false;
        if (!self.cloning) {
          editorDragPanel.startEditingLayout({
            target: newsection.one(ns.wrapperClass)
          }, layoutEditor);
        } else {
          self.cloning = false;
        }
      }, 300);

      if (withCapture) {
        this.captureCreate(newsection);
      }

      if (!this.cloned) {
        this.clearFonts(newsection);
      }

      this.cloned = false;
    },
    clearFonts: function clearFonts(newSection) {
      if (Editor.mode === 'site.page.editor') {
        if ($rootScope.site.default_font.family || $rootScope.site.h_font.family) {
          $('[data-section-id=\'' + newSection.section.id + '\'] *').filter(function () {
            if ($(this).attr('style')) {
              if ($(this).attr('style').indexOf('font-family') > -1) {
                $(this).css({ fontFamily: '' });
              }
            }
            if ($(this).prop('tagName') === 'FONT') {
              return $(this).removeAttr('face');
            }
          });

          layoutEditor.setFontToJsonWidgets(newSection, {
            'default': $rootScope.site.default_font.family,
            h: $rootScope.site.h_font.family
          });
        }
      }
    },
    captureCreate: function captureCreate(newsection) {
      var sectionHTML = newsection.get('outerHTML');
      var prevSectionId = newsection.previous() && newsection.previous().getData('section-id') || undefined;

      TimeMachine.capture('addSection', newsection.section, sectionHTML, prevSectionId);
    },
    getSiteNewSectionHtml: function getSiteNewSectionHtml(sectionData) {
      var self = this;
      Section.getHTML(sectionData).then(function (htmlData) {
        self.sectionInitializer(sectionData, htmlData, self.newsection);
      });
    },
    destroyDropSections: function destroyDropSections() {
      var sectionlist = Y.all(ns.sectionClass);

      sectionlist.each(function (v) {
        var id = v.get('id');
        var dr = Y.DD.DDM.getDrop('#' + id);
        if (dr) {
          dr.destroy();
        }
      });

      if (this.dropBackdrop) {
        this.dropBackdrop.destroy();
      }

      if (this.dropHeader) {
        this.dropHeader.destroy();
      }

      if (this.dropFooter) {
        this.dropFooter.destroy();
      }
    },
    bindSectionOnDropInTemplate: function bindSectionOnDropInTemplate(v) {
      return new Y.DD.Drop({
        node: v
      });
    },
    bindSectionsOnDropInTemplate: function bindSectionsOnDropInTemplate() {
      var sectionsInWrapper = Y.all(ns.sectionClass);

      sectionsInWrapper.each(this.bindSectionOnDropInTemplate);

      this.dropBackdrop = new Y.DD.Drop({
        node: ns.dropBackdropClass
      });
      this.dropHeader = new Y.DD.Drop({
        node: ns.dropHeaderClass
      });
      this.dropFooter = new Y.DD.Drop({
        node: ns.dropFooterClass
      });

      new Y.DD.Drop({
        node: '#mini-sections'
      });
    },
    _destroyBindDragSectionsInCollection: function _destroyBindDragSectionsInCollection() {
      Y.DD.DDM.detachAll();

      var listMiniSections = Y.all('#mini-sections .etnr-item__link');

      listMiniSections.each(function (v) {
        var id = v.get('id');
        var dd = Y.DD.DDM.getDrag('#' + id);
        var dr = Y.DD.DDM.getDrop('#' + id);
        if (dd) {
          dd.destroy();
        }
        if (dr) {
          dr.destroy();
        }
        if (dd) {
          dd._unprep();
        }
      });
    },
    bindDragSectionsInCollection: function bindDragSectionsInCollection() {
      var self = this;

      insertSpace.init(Y);
      this.ddInstances = [];

      var layoutEditor = $injector.get('layoutEditor');
      var lis = Y.all('#mini-sections .etnr-item__link');

      lis.each(function (v) {
        var dd = new Y.DD.Drag({
          node: v,
          target: {
            padding: '0 0 0 20'
          }
        }).plug(Y.Plugin.DDProxy, {
          moveOnEnd: false
        }).plug(Y.Plugin.DDWinScroll);

        dd.before('drag:start', sectionDragDrop._beforeDragStart, sectionDragDrop);
        dd.on('drag:start', self._onDragStart, sectionDragDrop);
        dd.on('drag:end', self._onDragEnd, self);
        dd.on('drag:drophit', self._onDropHit, self);
        dd.on('drag:over', self._onDragOver, self);

        if (layoutEditor.isTouchEnabled()) {
          v.detach('click', self._onClick, self);
          v.on('click', self._onClick, self);
        } else {
          v.detach('click', Tutorials._sectionDropTutorial, Tutorials);
          v.on('click', Tutorials._sectionDropTutorial, Tutorials);
        }

        self.ddInstances.push(dd);
      });

      this.bindSectionsOnDropInTemplate();
    },
    _onClick: function _onClick(e) {
      this.removeOverClassFromAll();

      if ($rootScope.layoutIsEditing) {
        editorDragPanel.cancelSection();
      }

      this.newSectionType = 'default';
      var newSection = this.buildNewSection(e.target);

      Y.one(ns.dropBackdropClass).insert(newSection, 'after');
      this.bindSectionOnDropInTemplate(newSection);

      $rootScope.toggleCommonSections();
      insertSpace.hide();
    },
    _onDragStart: function _onDragStart(e) {
      sectionDragDrop._onDragStart(e);

      var drag = e.target;
      var originalEl = drag.get('node');
      var clone = drag.get('dragNode');
      var sectionPreviewImage = originalEl.one('img').getAttribute('src');

      clone.setStyles({ backgroundImage: 'url(' + sectionPreviewImage + ')' });
    },
    removeOverClassFromAll: function removeOverClassFromAll() {
      Y.all('.yui3-dd-dropover').removeClass('yui3-dd-dropover');
      Y.all('.yui3-dd-dropover-red').removeClass('yui3-dd-dropover-red');
    },
    headerElementOver: function headerElementOver(sectionType) {
      this.removeOverClassFromAll();

      Y.one(ns.dropHeaderClass).addClass('yui3-dd-dropover');
    },
    footerElementOver: function footerElementOver(sectionType) {
      this.removeOverClassFromAll();

      Y.one(ns.dropFooterClass).addClass('yui3-dd-dropover');
    },
    contentElementOver: function contentElementOver(sectionType) {
      this.removeOverClassFromAll();

      Y.one(ns.dropBackdropClass).addClass('yui3-dd-dropover');
    },
    addOverClassToElements: function addOverClassToElements(sectionType) {
      // const overClass = "yui3-dd-dropover";
      var isHeaderElement = this.activeDropElement.hasClass(ns.dropHeaderClass.substr(1));
      var isFooterElement = this.activeDropElement.hasClass(ns.dropFooterClass.substr(1));
      var isContentElement = this.activeDropElement.hasClass(ns.dropBackdropClass.substr(1));

      if (isHeaderElement) {
        this.headerElementOver(sectionType);
      }
      if (isFooterElement) {
        this.footerElementOver(sectionType);
      }
      if (isContentElement) {
        this.contentElementOver(sectionType);
      }
      if (!isHeaderElement && !isFooterElement && !isContentElement) {
        this.removeOverClassFromAll();
      }
    },
    _onDragOver: function _onDragOver(e) {
      var blockDragDrop = $injector.get('blockDragDrop');

      this.activeDropElement = Y.DD.DDM.activeDrop.get('node');

      var drag = e.drag.get('node');
      var sectionType = $(drag._node).scope().item.section_type;

      this.addOverClassToElements(sectionType);

      if (this.activeDropElement.hasClass(ns.sectionClass.substr(1))) {
        this.nearestEdge = blockDragDrop.getDropInfo(Y);
        insertSpace.alignInsertSpaceRowOrSection(this.nearestEdge, 'section');
      } else {
        insertSpace.hide();
      }
    },
    removeDropBackdrop: function removeDropBackdrop(drop) {
      Y.one(ns.dropBackdropClass).removeClass('no-sections');
      Y.one('.str-drop-backdrop').addClass('ng-hide');
    },
    _onDragEnd: function _onDragEnd(e) {
      Y.one(ns.dropBackdropClass).removeClass('yui3-dd-dropover');
      Y.one(ns.dropHeaderClass).removeClass('yui3-dd-dropover');
      Y.one(ns.dropFooterClass).removeClass('yui3-dd-dropover');

      var drag = e.target;
      var drop = this.activeDropElement;
      var originalEl = drag.get('node');

      originalEl.setStyles({ visibility: 'visible' });

      insertSpace.hide();
      if (drop.hasClass(ns.dropBackdropClass.substr(1))) {
        this.removeDropBackdrop(drop);
      }

      if (this.lock) {
        this.lockSections();
        this.lock = undefined;
      }
    },
    /**
     *
     * @param e
     * @returns {boolean}
     * @private
     */
    _onDropHit: function _onDropHit(e) {
      this.availableTags = ['section', 'header', 'footer'];

      var drop = e.drop.get('node');
      var drag = e.drag.get('node');
      var tplWrapper = Y.one(ns.tplContainer);
      var tagName = drop.get('tagName').toLowerCase();
      var sectionType = $(drag._node).scope().item.section_type;

      this.removeOverClassFromAll();

      if ($rootScope.layoutIsEditing) {
        editorDragPanel.cancelSection();
      }

      if (drop.hasClass(ns.dropBackdropClass.substr(1))) {
        if ($rootScope.isCollectionPage) {
          return false;
        }

        this.newSectionType = 'default';
        var newSection = this.buildNewSection(drag);

        Y.one(ns.dropBackdropClass).insert(newSection, 'after');

        this.bindSectionOnDropInTemplate(newSection);
      }

      if (drop.hasClass(ns.dropHeaderClass.substr(1))) {
        this.newSectionType = 'header';
        var _newSection = this.buildNewSection(drag);

        tplWrapper.prepend(_newSection);

        this.bindSectionOnDropInTemplate(_newSection);
      }

      if (drop.hasClass(ns.dropFooterClass.substr(1))) {
        this.newSectionType = 'footer';
        var _newSection2 = this.buildNewSection(drag);

        tplWrapper.append(_newSection2);

        this.bindSectionOnDropInTemplate(_newSection2);
      }

      if (indexOf.call(this.availableTags, tagName) >= 0) {
        if ($rootScope.isCollectionPage) {
          return false;
        }

        this.newSectionType = 'default';
        var _newSection3 = this.buildNewSection(drag);

        if (this.nearestEdge.quad.y === 'top' && tagName === 'header') {
          return false;
        }
        if (this.nearestEdge.quad.y === 'bottom' && tagName === 'footer') {
          return false;
        }

        switch (this.nearestEdge.quad.y) {
          case 'top':
            this.indexPosition = $(drop._node).index();
            drop.insert(_newSection3, 'before');
            break;
          case 'bottom':
            this.indexPosition = $(drop._node).index() + 1;
            drop.insert(_newSection3, 'after');
            break;
        }

        $timeout(function () {
          Animation.scrollTo($(_newSection3._node));
        });

        this.bindSectionOnDropInTemplate(_newSection3);
      }

      this.lock = !drop.hasClass('etn__tab-container') && drop.hasClass(ns.dropBackdropClass.substr(1)) || drop.hasClass(ns.dropHeaderClass.substr(1)) && sectionType === 'header' ||
      // drop.hasClass(ns.dropHeaderClass.substr(1)) && sectionType === 'header' ||
      indexOf.call(this.availableTags, tagName) >= 0;

      $rootScope.toggleCommonSections();
      insertSpace.hide();
    }
  };
  return editorNavSections;
}]);

/***/ }),
/* 50 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

var buttonActionsModule = angular.module('buttonActions.setting', []);

buttonActionsModule.directive("buttonActions", ["$window", "$timeout", "$compile", "$templateCache", "ns", "blockEditDialog", "Widget", function ($window, $timeout, $compile, $templateCache, ns, blockEditDialog, Widget) {
  return {
    restrict: "A",
    scope: {
      widget: "=ngModel",
      afterChange: '&',
      buttonProperty: '&'
    },
    templateUrl: settingFolder + "/buttonActions/template.jade",
    link: function link(scope, element, attrs, ngModel) {
      scope.button_property = attrs.buttonProperty;
      scope.form_property = attrs.formProperty;
      scope.Editor = angular.copy(window.Editor);
      scope.showModalForm = function (id) {
        if ($(".vex").length > 0) {
          vex.closeAll();
        } else {
          vex.open({
            content: "",
            appendLocation: "[data-block-id='" + scope.widget.id + "']",
            contentClassName: 'vex-form__modal',
            afterOpen: function afterOpen($vexContent) {
              log(id);
              $vexContent.append($("[data-block-id=" + id + "]"));
              $('.link_view-form').addClass("link_view-form_active");
            },
            afterClose: function afterClose(s) {
              $("[data-block-id='" + scope.widget.id + "']").find(ns.widgetWrapperClass).eq(0).append(s.find('.strw-form__hidden'));
              $('.link_view-form').removeClass("link_view-form_active");
            }
          });
        }
        $(".vex").css({
          zIndex: 344
        });
      };
    }
  };
}]);

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* injects from baggage-loader */



var colorDirectiveModule = angular.module('color.setting', []);

colorDirectiveModule.directive('colorSetting', ['$window', '$timeout', '$compile', '$templateCache', function ($window, $timeout, $compile, $templateCache) {
  return {
    restrict: 'A',
    scope: {
      data: '=ngModel',
      afterChange: '&'
    },
    templateUrl: settingFolder + '/color/template.jade',
    link: function link(scope, element, attrs, ngModel) {

      var listener = scope.$watch('colorValue', function (newVal) {
        if (newVal) {
          scope.data = newVal;
        }
      });

      scope.type = attrs.colorSetting;
      scope.options = {
        opacity: true,
        hide: scope.afterChange
      };
      scope.checkOpacity = function () {
        if (attrs.disableOpacity) {
          $('.minicolors-opacity-slider').hide();
          $('.minicolors-panel-input-opacity').hide();
        } else {
          $('.minicolors-opacity-slider').show();
          $('.minicolors-panel-input-opacity').show();
        }
      };

      var rgba2hex = function rgba2hex(rgba) {
        var rgbaStringArray = rgba.match(/[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s]?([\d.]+)[\s+]?/g);

        if (rgbaStringArray === null) {
          return [rgba, 1];
        } else {
          var rgb = rgbaStringArray[0].split(', ');
          var opacity = rgb[3];
          var hexResult = rgb && rgb.length === 4 ? '#' + ('0' + parseInt(rgb[0], 10).toString(16)).slice(-2) + ('0' + parseInt(rgb[1], 10).toString(16)).slice(-2) + ('0' + parseInt(rgb[2], 10).toString(16)).slice(-2) : '';

          return [hexResult, opacity];
        }
      };

      var listener1 = scope.$watch('data', function (newVal, oldVal) {
        if (newVal) {
          $(element).find('.input_color').attr('data-opacity', rgba2hex(newVal)[1]);
          $(element).find('.input_color').removeData('hex');
          $(element).find('[minicolors]').minicolors('value', newVal);
          if (scope.afterChange) {
            scope.afterChange();
          }
        }
      });

      scope.type = attrs.colorSetting;
      scope.$on('$destroy', function () {
        listener();
        listener1();
      });
    }
  };
}]);

/***/ }),
/* 52 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

/*
 * jQuery MiniColors: A tiny color picker built on jQuery
 *
 * Copyright Cory LaViska for A Beautiful Site, LLC. (http://www.abeautifulsite.net/)
 *
 * Licensed under the MIT license: http://opensource.org/licenses/MIT
 *
 */
if (jQuery) (function ($) {

  var minicolors_doc = document;

  // Defaults
  $.minicolors = {
    defaults: {
      CKE: false,
      doc: document,
      animationSpeed: 50,
      animationEasing: 'swing',
      change: null,
      changeDelay: 0,
      control: 'hue',
      dataUris: true,
      defaultValue: '',
      hide: null,
      hideSpeed: 100,
      inline: false,
      letterCase: 'lowercase',
      opacity: false,
      position: 'bottom left',
      show: null,
      showSpeed: 100,
      theme: 'default'
    }
  };

  // Public methods
  $.extend($.fn, {
    minicolors: function minicolors(method, data) {

      switch (method) {

        // Destroy the control
        case 'destroy':
          $(this).each(function () {
            destroy($(this));
          });
          return $(this);

        // Hide the color picker
        case 'hide':
          hide();
          return $(this);

        // Get/set opacity
        case 'opacity':
          // Getter
          if (data === undefined) {
            // Getter
            return $(this).attr('data-opacity');
          } else {
            // Setter
            $(this).each(function () {
              updateFromInput($(this).attr('data-opacity', data));
            });
          }
          return $(this);

        // Get an RGB(A) object based on the current color/opacity
        case 'rgbObject':
          return rgbObject($(this), method === 'rgbaObject');

        // Get an RGB(A) string based on the current color/opacity
        case 'rgbString':
        case 'rgbaString':
          return rgbString($(this), method === 'rgbaString');

        // Get/set settings on the fly
        case 'settings':
          if (data === undefined) {
            return $(this).data('minicolors-settings');
          } else {
            // Setter
            $(this).each(function () {
              var settings = $(this).data('minicolors-settings') || {};
              destroy($(this));
              $(this).minicolors($.extend(true, settings, data));
            });
          }
          return $(this);

        // Show the color picker
        case 'show':
          show($(this).eq(0));
          return $(this);

        // Get/set the hex color value
        case 'value':
          if (data === undefined) {
            // Getter
            return $(this).val();
          } else {
            // Setter
            $(this).each(function () {
              updateFromInput($(this).val(data));
            });
          }
          return $(this);

        // Initializes the control
        default:
          if (method !== 'create') data = method;
          // if (data.doc)
          //   initializer(data.doc);
          // else
          //   initializer(document);
          if (data.CKE) {
            minicolors_doc = data.doc;
            initializer();
          } else {
            minicolors_doc = document;
          }
          $(this).each(function () {
            init($(this), data);
          });
          return $(this);

      }
    }
  });

  // Initialize input elements
  function init(input, settings) {
    var minicolors = $('<div class="minicolors" />'),
        defaults = $.minicolors.defaults,
        minicolorsContent = '<div class="minicolors-panel minicolors-slider-' + settings.control + '">' + '<div id="minicolors-overlay" style="position: fixed;width: 100%;height: 100%;top: 0;left: 0;"></div>' + '<div class="minicolors-inputs">' + '<input id="hex" style="position: relative;" class="input input_nano ms-input_border minicolors-panel-input">' + '<input id="opacity" style="position: relative;" class="input input_nano ms-input_border minicolors-panel-input-opacity">' + '</div>' + '<div class="minicolors-grid minicolors-sprite">' + '<div class="minicolors-grid-inner"></div>' + '<div class="minicolors-picker"></div>' + '</div>' + '<div class="minicolors-slider minicolors-sprite">' + '<div class="minicolors-picker"></div>' + '</div>' + '<div class="minicolors-opacity-slider minicolors-sprite">' + '<div class="minicolors-slider-wrapper">' + '<div class="minicolors-slider-image"></div>' + '<div class="minicolors-slider-color"></div>' + '</div>' + '<div class="minicolors-picker">' + '<div class="minicolors-picker-color"></div>' + '</div>' + '</div>' + '</div>';

    // Do nothing if already initialized
    if (input.data('minicolors-initialized')) return;

    // Handle settings
    settings = $.extend(true, {}, defaults, settings);

    // The wrapper
    minicolors.addClass('minicolors-theme-' + settings.theme).toggleClass('minicolors-with-opacity', settings.opacity).toggleClass('minicolors-no-data-uris', settings.dataUris !== true);

    // Custom positioning
    if (settings.position !== undefined) {
      $.each(settings.position.split(' '), function () {
        minicolors.addClass('minicolors-position-' + this);
      });
    }

    // The input
    input.addClass('minicolors-input').data('minicolors-initialized', false).data('minicolors-settings', settings).prop('size', 7).wrap(minicolors);

    if (input.parents('.etn__tab-container').length > 0 && input.parents('.etn__list').children('.minicolors-panel').index() != 2) {
      input.parents('.etn__tab-container').after(minicolorsContent);
      input.parents('.etn__list').children('.minicolors-panel').addClass('minicolors');
    } else if (input.parents('.etn__tab-container').length == 0) {
      input.after(minicolorsContent);
    }
    // The swatch
    if (!settings.inline) {
      input.after('<span class="minicolors-swatch minicolors-sprite"><span class="minicolors-swatch-color"></span></span>');
      input.next('.minicolors-swatch').on('click', function (event) {
        event.preventDefault();
        input.focus();
      });
    }

    // Prevent text selection in IE
    input.parent().find('.minicolors-panel').on('selectstart', function () {
      return false;
    }).end();

    // Inline controls
    if (settings.inline) input.parent().addClass('minicolors-inline');

    input.data('minicolors-initialized', true);
  }

  // Returns the input back to its original state
  function destroy(input) {

    var minicolors = input.parent();

    // Revert the input element
    input.removeData('minicolors-initialized').removeData('minicolors-settings').removeProp('size').removeClass('minicolors-input');

    // Remove the wrap and destroy whatever remains
    minicolors.before(input).remove();
  }

  // Shows the specified dropdown panel
  function show(input) {
    hide();

    window.currentColorPicker = input;

    if (input.parents('.etn__tab-container').length > 0) {
      var panel = input.parents('.etn__list').find('.minicolors-panel');
    } else {
      var panel = input.parent().find('.minicolors-panel');
    }

    updateFromInput(input, false);

    var minicolors = input.parent(),
        settings = input.data('minicolors-settings');

    // Do nothing if uninitialized, disabled, inline, or already open
    if (!input.data('minicolors-initialized') || input.prop('disabled') || minicolors.hasClass('minicolors-inline') || minicolors.hasClass('minicolors-focus')) return;

    minicolors.addClass('minicolors-focus');
    panel.stop(true, true).fadeIn(settings.showSpeed, function () {
      if (settings.show) settings.show.call(input.get(0));
    });
  }

  // Hides all dropdown panels
  function hide() {
    $('.minicolors-focus').each(function () {
      var minicolors = $(this),
          input = minicolors.find('.minicolors-input'),
          settings = input.data('minicolors-settings');
      if (input.parents('.etn__tab-container').length > 0) {
        var panel = input.parents('.etn__list').find('.minicolors-panel');
      } else {
        var panel = input.parent().find('.minicolors-panel');
      }

      panel.find('.minicolors-panel-input').blur();

      panel.fadeOut(settings.hideSpeed, function () {
        if (settings.hide) settings.hide.call(input.get(0));
        minicolors.removeClass('minicolors-focus');
      });
      window.currentColorPicker = '';
    });
  }

  // Moves the selected picker
  function move(target, event, animate) {
    if (window.currentColorPicker) {
      var input = window.currentColorPicker;
    } else {
      var input = target.parents('.minicolors').find('.minicolors-input');
    }

    var settings = input.data('minicolors-settings'),
        picker = target.find('[class$=-picker]'),
        offsetX = target.offset().left,
        offsetY = target.offset().top,
        x = Math.round(event.pageX - offsetX),
        y = Math.round(event.pageY - offsetY),
        duration = animate ? settings.animationSpeed : 0,
        wx,
        wy,
        r,
        phi;

    // Touch support
    if (event.originalEvent.changedTouches) {
      x = event.originalEvent.changedTouches[0].pageX - offsetX;
      y = event.originalEvent.changedTouches[0].pageY - offsetY;
    }

    // Constrain picker to its container
    if (x < 0) x = 0;
    if (y < 0) y = 0;
    if (x > target.width()) x = target.width();
    if (y > target.height()) y = target.height();

    // Constrain color wheel values to the wheel
    if (target.parent().is('.minicolors-slider-wheel') && picker.parent().is('.minicolors-grid')) {
      wx = 75 - x;
      wy = 75 - y;
      r = Math.sqrt(wx * wx + wy * wy);
      phi = Math.atan2(wy, wx);
      if (phi < 0) phi += Math.PI * 2;
      if (r > 75) {
        r = 75;
        x = 75 - 75 * Math.cos(phi);
        y = 75 - 75 * Math.sin(phi);
      }
      x = Math.round(x);
      y = Math.round(y);
    }

    // Move the picker
    if (target.is('.minicolors-grid')) {
      picker.stop(true).animate({
        top: y + 'px',
        left: x + 'px'
      }, duration, settings.animationEasing, function () {
        updateFromControl(input, target);
      });
    } else {
      picker.stop(true).animate({
        left: x + 'px'
      }, duration, settings.animationEasing, function () {
        updateFromControl(input, target);
      });
    }
  }

  // Sets the input based on the color picker values
  function updateFromControl(input, target) {
    function getCoords(picker, container) {

      var left, top;
      if (!picker.length || !container) return null;
      left = picker.offset().left;
      top = picker.offset().top;

      return {
        x: left - container.offset().left + picker.outerWidth() / 2,
        y: top - container.offset().top + picker.outerHeight() / 2
      };
    }

    var hue,
        saturation,
        brightness,
        x,
        y,
        r,
        phi,
        opacity = input.attr('data-opacity');

    // Helpful references

    // minicolors = input.parent()
    if (input.parents('.etn__tab-container').length > 0) {
      var minicolors = input.parents('.etn__list').find('.minicolors-panel');
    } else {
      var minicolors = input.parent();
    }

    var settings = input.data('minicolors-settings'),
        swatch = input.parent().find('.minicolors-swatch'),


    // Panel objects
    grid = minicolors.find('.minicolors-grid'),
        slider = minicolors.find('.minicolors-slider'),
        opacitySlider = minicolors.find('.minicolors-opacity-slider'),
        panelInput = minicolors.find('.minicolors-panel-input'),
        panelInputOpacity = minicolors.find('.minicolors-panel-input-opacity'),


    // Picker objects
    gridPicker = grid.find('[class$=-picker]'),
        sliderPicker = slider.find('[class$=-picker]'),
        opacityPicker = opacitySlider.find('[class$=-picker]'),
        opacityPickerColor = opacitySlider.find('[class$=-picker-color]'),


    // Picker positions
    gridPos = getCoords(gridPicker, grid),
        sliderPos = getCoords(sliderPicker, slider),
        opacityPos = getCoords(opacityPicker, opacitySlider);

    if (input.data('opacity')) {
      var hex = input.data('hex');
    } else {
      var hex = input.val();
    }

    // Handle opacity
    if (target.is('.minicolors-opacity-slider')) {
      if (settings.opacity) {
        opacity = parseFloat(opacityPos.x / opacitySlider.width()).toFixed(2);
      } else {
        opacity = 1;
      }
      if (settings.opacity) input.data('opacity', opacity);
      opacityPickerColor.css('opacity', opacity);
      if (input.data('opacity')) {
        input.data('hex', convertCase(hex, settings.letterCase)).val(rgbString(input, input.data('opacity')));
      } else {
        input.val(convertCase(hex, settings.letterCase));
      }
      input.attr('data-opacity', opacity);
    }

    // Handle colors

    if (target.is('.minicolors-grid, .minicolors-slider')) {
      // Determine HSB values
      switch (settings.control) {

        case 'wheel':
          // Calculate hue, saturation, and brightness
          x = grid.width() / 2 - gridPos.x;
          y = grid.height() / 2 - gridPos.y;
          r = Math.sqrt(x * x + y * y);
          phi = Math.atan2(y, x);
          if (phi < 0) phi += Math.PI * 2;
          if (r > 75) {
            r = 75;
            gridPos.x = 69 - 75 * Math.cos(phi);
            gridPos.y = 69 - 75 * Math.sin(phi);
          }
          saturation = keepWithin(r / 0.75, 0, 100);
          hue = keepWithin(phi * 180 / Math.PI, 0, 360);
          brightness = keepWithin(100 - Math.floor(sliderPos.y * (100 / slider.height())), 0, 100);
          hex = hsb2hex({
            h: hue,
            s: saturation,
            b: brightness
          });

          // Update UI
          slider.css('backgroundColor', hsb2hex({ h: hue, s: saturation, b: 100 }));
          break;

        case 'saturation':
          // Calculate hue, saturation, and brightness
          hue = keepWithin(parseInt(gridPos.x * (360 / grid.width()), 10), 0, 360);
          saturation = keepWithin(100 - Math.floor(sliderPos.y * (100 / slider.height())), 0, 100);
          brightness = keepWithin(100 - Math.floor(gridPos.y * (100 / grid.height())), 0, 100);
          hex = hsb2hex({
            h: hue,
            s: saturation,
            b: brightness
          });

          // Update UI
          slider.css('backgroundColor', hsb2hex({ h: hue, s: 100, b: brightness }));
          minicolors.find('.minicolors-grid-inner').css('opacity', saturation / 100);
          break;

        case 'brightness':
          // Calculate hue, saturation, and brightness
          hue = keepWithin(parseInt(gridPos.x * (360 / grid.width()), 10), 0, 360);
          saturation = keepWithin(100 - Math.floor(gridPos.y * (100 / grid.height())), 0, 100);
          brightness = keepWithin(100 - Math.floor(sliderPos.y * (100 / slider.height())), 0, 100);
          hex = hsb2hex({
            h: hue,
            s: saturation,
            b: brightness
          });

          // Update UI
          slider.css('backgroundColor', hsb2hex({ h: hue, s: saturation, b: 100 }));
          minicolors.find('.minicolors-grid-inner').css('opacity', 1 - brightness / 100);
          break;

        default:
          // Calculate hue, saturation, and brightness
          hue = keepWithin(360 - parseInt(sliderPos.x * (360 / slider.width()), 10), 0, 360);
          saturation = keepWithin(Math.floor(gridPos.x * (100 / grid.width())), 0, 100);
          brightness = keepWithin(100 - Math.floor(gridPos.y * (100 / grid.height())), 0, 100);
          hex = hsb2hex({
            h: hue,
            s: saturation,
            b: brightness
          });
          // Update UI
          grid.css('backgroundColor', hsb2hex({ h: hue, s: 100, b: 100 }));
          sliderPicker.css('backgroundColor', hsb2hex({ h: hue, s: 100, b: 100 }));
          panelInput.val(hex);
          gridPicker.css('backgroundColor', hex);
          opacityPickerColor.css('backgroundColor', hex);
          opacitySlider.find('.minicolors-slider-color').css('backgroundColor', hex);
          panelInputOpacity.val(opacity);

          break;
      }

      // Adjust case
      if (input.data('opacity')) {
        input.data('hex', convertCase(hex, settings.letterCase)).val(rgbString(input, input.data('opacity')));
      } else {
        input.val(convertCase(hex, settings.letterCase));
      }
    }

    // Set swatch color
    swatch.find('SPAN').css({
      backgroundColor: hex,
      opacity: input.data('opacity')
    });

    // Handle change event
    if (opacity) {
      doChange(input, rgbString(input, opacity), opacity);
    } else {
      doChange(input, hex, opacity);
    }
  }

  // Sets the color picker values from the input
  function updateFromInput(input, preserveInputValue) {
    var hex, hsb, opacity, x, y, r, phi;

    // Helpful references

    if (input.parents('.etn__tab-container').length > 0) {
      var minicolors = input.parents('.etn__list').find('.minicolors-panel'),
          swatch = input.parent().find('.minicolors-swatch'),
          panelInput = minicolors.find('.minicolors-panel-input');
      panelInputOpacity = minicolors.find('.minicolors-panel-input-opacity');
    } else {
      var minicolors = input.parent(),
          swatch = minicolors.find('.minicolors-swatch'),
          panelInput = minicolors.find('.minicolors-panel-input'),
          panelInputOpacity = minicolors.find('.minicolors-panel-input-opacity');
    }

    var settings = input.data('minicolors-settings'),


    // Panel objects
    grid = minicolors.find('.minicolors-grid'),
        slider = minicolors.find('.minicolors-slider'),
        opacitySlider = minicolors.find('.minicolors-opacity-slider'),


    // Picker objects
    gridPicker = grid.find('[class$=-picker]'),
        sliderPicker = slider.find('[class$=-picker]'),
        opacityPickerColor = opacitySlider.find('[class$=-picker-color]'),
        opacityPicker = opacitySlider.find('[class$=-picker]');
    if (!settings) return false;
    // Determine hex/HSB values

    // ilnur kuchaev added
    // if (!settings) return false

    if (settings && settings.opacity) {
      // Get from data-opacity attribute and keep within 0-1 range

      opacity = input.attr('data-opacity') === '' ? 1 : keepWithin(parseFloat(input.attr('data-opacity')).toFixed(2), 0, 1);

      var opacityVal = rgba2hex(input.val())[1];

      if (isNaN(opacity)) {
        if (opacityVal != undefined) {
          opacity = opacityVal;
        } else {
          opacity = 1;
        }
      }
      input.attr('data-opacity', opacity);
      swatch.find('SPAN').css('opacity', opacity);

      // Set opacity picker position
      if (opacitySlider.width() == '0') {
        var opcitySize = 190;
      } else {
        opcitySize = opacitySlider.width();
      }
      x = keepWithin(opcitySize * opacity, 0, opcitySize);

      if (x >= 190) x = 190;

      opacityPicker.css('left', x + 'px');
    }

    if (input.data('hex')) {
      hex = convertCase(parseHex(input.data('hex'), true), settings.letterCase);
    } else {
      hex = convertCase(rgba2hex(input.val())[0], settings.letterCase);
    }
    if (!hex) {
      hex = convertCase(parseHex(settings.defaultValue, true), settings.letterCase);
    }
    hsb = hex2hsb(hex);

    // Update swatch
    swatch.find('SPAN').css('backgroundColor', hex);

    // Determine picker locations
    switch (settings.control) {

      case 'wheel':
        // Set grid position
        r = keepWithin(Math.ceil(hsb.s * 0.75), 0, grid.height() / 2);
        phi = hsb.h * Math.PI / 180;
        x = keepWithin(75 - Math.cos(phi) * r, 0, grid.width());
        y = keepWithin(75 - Math.sin(phi) * r, 0, grid.height());
        gridPicker.css({
          top: y + 'px',
          left: x + 'px'
        });

        // Set slider position
        y = 150 - hsb.b / (100 / grid.height());
        if (hex === '') y = 0;
        sliderPicker.css('top', y + 'px');

        // Update panel color
        slider.css('backgroundColor', hsb2hex({ h: hsb.h, s: hsb.s, b: 100 }));
        break;

      case 'saturation':
        // Set grid position
        x = keepWithin(5 * hsb.h / 12, 0, 150);
        y = keepWithin(grid.height() - Math.ceil(hsb.b / (100 / grid.height())), 0, grid.height());
        gridPicker.css({
          top: y + 'px',
          left: x + 'px'
        });

        // Set slider position
        y = keepWithin(slider.height() - hsb.s * (slider.height() / 100), 0, slider.height());
        sliderPicker.css('top', y + 'px');

        // Update UI
        slider.css('backgroundColor', hsb2hex({ h: hsb.h, s: 100, b: hsb.b }));
        minicolors.find('.minicolors-grid-inner').css('opacity', hsb.s / 100);
        break;

      case 'brightness':
        // Set grid position
        x = keepWithin(5 * hsb.h / 12, 0, 150);
        y = keepWithin(grid.height() - Math.ceil(hsb.s / (100 / grid.height())), 0, grid.height());
        gridPicker.css({
          top: y + 'px',
          left: x + 'px'
        });

        // Set slider position
        y = keepWithin(slider.height() - hsb.b * (slider.height() / 100), 0, slider.height());
        sliderPicker.css('top', y + 'px');

        // Update UI
        slider.css('backgroundColor', hsb2hex({ h: hsb.h, s: hsb.s, b: 100 }));
        minicolors.find('.minicolors-grid-inner').css('opacity', 1 - hsb.b / 100);
        break;

      default:
        // Set grid position
        if (grid.width() == '0') {
          var gridSize = 190;
        } else {
          gridSize = grid.width();
        }
        x = keepWithin(Math.ceil(hsb.s / (100 / gridSize)), 0, gridSize);
        y = keepWithin(gridSize - Math.ceil(hsb.b / (100 / gridSize)), 0, gridSize);

        if (y > 190) y = 190;
        if (x > 190) x = 190;

        gridPicker.css({
          top: y + 'px',
          left: x + 'px'
        });
        // Set slider position
        y = keepWithin(gridSize - hsb.h / (360 / gridSize), 0, gridSize);

        if (y > 190) y = 190;

        sliderPicker.css('left', y + 'px');

        // Update panel color
        grid.css('backgroundColor', hsb2hex({ h: hsb.h, s: 100, b: 100 }));
        sliderPicker.css('backgroundColor', hsb2hex({ h: hsb.h, s: 100, b: 100 }));
        panelInput.val(hex);
        panelInputOpacity.val(opacity);
        gridPicker.css('backgroundColor', hex);
        opacityPickerColor.css('backgroundColor', hex);
        opacitySlider.find('.minicolors-slider-color').css('backgroundColor', hex);
        break;
    }

    if (!preserveInputValue) {
      if (opacity) {
        input.data('hex', hex).val(rgbString(input, opacity));
      } else {
        input.val(hex);
      }
    }

    // Fire change event, but only if minicolors is fully initialized
    if (input.data('minicolors-initialized')) {
      if (opacity) {
        doChange(input, rgbString(input, opacity), opacity);
      } else {
        doChange(input, hex, opacity);
      }
    }
  }

  function updatePanelOpacityInput(input, preserveInputValue) {

    var hex, hsb, opacity, x, y, r, phi, iInput;

    // Helpful references

    if (window.currentColorPicker) {
      iInput = window.currentColorPicker;
    } else {
      iInput = input;
    }
    if (iInput.parents('.etn__tab-container').length > 0) {
      var minicolors = input.parents('.etn__list').find('.minicolors-panel'),
          inputParent = iInput.parents('.minicolors'),
          hiddenInput = inputParent.children('.minicolors-input');
      settings = hiddenInput.data('minicolors-settings'), swatch = iInput.parent().find('.minicolors-swatch'), panelInput = inputParent.find('.minicolors-panel-input'), panelInputOpacity = minicolors.find('.minicolors-panel-input-opacity');
    } else {
      var minicolors = input.parents('.minicolors'),
          hiddenInput = minicolors.children('.minicolors-input');
      settings = hiddenInput.data('minicolors-settings'), swatch = minicolors.find('.minicolors-swatch'), panelInput = minicolors.find('.minicolors-panel-input'), panelInputOpacity = minicolors.find('.minicolors-panel-input-opacity');
    }

    // Panel objects
    var grid = minicolors.find('.minicolors-grid'),
        slider = minicolors.find('.minicolors-slider'),
        opacity = hiddenInput.data('opacity'),
        opacitySlider = minicolors.find('.minicolors-opacity-slider'),


    // Picker objects
    gridPicker = grid.find('[class$=-picker]'),
        sliderPicker = slider.find('[class$=-picker]'),
        opacityPickerColor = opacitySlider.find('[class$=-picker-color]'),
        opacityPicker = opacitySlider.find('[class$=-picker]');

    hex = convertCase(parseHex(input.val(), true), settings.letterCase);
    if (!hex) {
      hex = convertCase(parseHex(settings.defaultValue, true), settings.letterCase);
    }

    hex = hiddenInput.data('hex');
    hsb = hex2hsb(hex);

    if (settings && settings.opacity) {
      // Get from data-opacity attribute and keep within 0-1 range

      opacity = $(input).attr('data-opacity') === '' ? 1 : keepWithin(parseFloat($(input).attr('data-opacity')).toFixed(2), 0, 1);
      var opacityVal = rgba2hex(input.val())[1];

      if (isNaN(opacity)) {
        if (opacityVal != undefined) {
          opacity = opacityVal;
        } else {
          opacity = 1;
        }
      }
      input.attr('data-opacity', opacity);
      swatch.find('SPAN').css('opacity', opacity);

      // Set opacity picker position
      if (opacitySlider.width() == '0') {
        var opcitySize = 190;
      } else {
        opcitySize = opacitySlider.width();
      }
      x = keepWithin(opcitySize * opacity, 0, opcitySize);

      if (x >= 190) x = 190;

      opacityPicker.css('left', x + 'px');
    }

    switch (settings.control) {
      default:
        // Update panel color
        grid.css('backgroundColor', hsb2hex({ h: hsb.h, s: 100, b: 100 }));
        sliderPicker.css('backgroundColor', hsb2hex({ h: hsb.h, s: 100, b: 100 }));
        gridPicker.css('backgroundColor', hex);
        opacityPickerColor.css('backgroundColor', hex);
        opacitySlider.find('.minicolors-slider-color').css('backgroundColor', hex);
        break;
    }
    swatch.find('SPAN').css('backgroundColor', hex);
    if (opacity) {
      hiddenInput.data('hex', hex).val(rgbString(hiddenInput, opacity));
      doChange(hiddenInput, rgbString(hiddenInput, opacity), opacity);
    } else {
      hiddenInput.val(hex);
      doChange(hiddenInput, hex, opacity);
    }
  }

  function updatePanelInput(input, preserveInputValue) {

    var hex, hsb, opacity, x, y, r, phi, iInput;

    // Helpful references

    if (window.currentColorPicker) {
      iInput = window.currentColorPicker;
    } else {
      iInput = input;
    }
    if (iInput.parents('.etn__tab-container').length > 0) {
      var minicolors = input.parents('.etn__list').find('.minicolors-panel'),
          inputParent = iInput.parents('.minicolors'),
          hiddenInput = inputParent.children('.minicolors-input');
      settings = hiddenInput.data('minicolors-settings'), swatch = iInput.parent().find('.minicolors-swatch'), panelInput = inputParent.find('.minicolors-panel-input'), panelInputOpacity = minicolors.find('.minicolors-panel-input-opacity');
    } else {
      var minicolors = input.parents('.minicolors'),
          hiddenInput = minicolors.children('.minicolors-input');
      settings = hiddenInput.data('minicolors-settings'), swatch = minicolors.find('.minicolors-swatch'), panelInput = minicolors.find('.minicolors-panel-input'), panelInputOpacity = minicolors.find('.minicolors-panel-input-opacity');
    }

    // Panel objects
    var grid = minicolors.find('.minicolors-grid'),
        slider = minicolors.find('.minicolors-slider'),
        opacity = hiddenInput.data('opacity'),
        opacitySlider = minicolors.find('.minicolors-opacity-slider'),


    // Picker objects
    gridPicker = grid.find('[class$=-picker]'),
        sliderPicker = slider.find('[class$=-picker]'),
        opacityPickerColor = opacitySlider.find('[class$=-picker-color]'),
        opacityPicker = opacitySlider.find('[class$=-picker]');

    hex = convertCase(parseHex(input.val(), true), settings.letterCase);
    if (!hex) {
      hex = convertCase(parseHex(settings.defaultValue, true), settings.letterCase);
    }
    hsb = hex2hsb(hex);

    switch (settings.control) {
      default:
        // Set grid position
        if (grid.width() == '0') {
          var gridSize = 190;
        } else {
          gridSize = grid.width();
        }
        x = keepWithin(Math.ceil(hsb.s / (100 / gridSize)), 0, gridSize);
        y = keepWithin(gridSize - Math.ceil(hsb.b / (100 / gridSize)), 0, gridSize);

        gridPicker.css({
          top: y + 'px',
          left: x + 'px'
        });
        // Set slider position
        y = keepWithin(gridSize - hsb.h / (360 / gridSize), 0, gridSize);
        sliderPicker.css('left', y + 'px');

        // Update panel color
        grid.css('backgroundColor', hsb2hex({ h: hsb.h, s: 100, b: 100 }));
        sliderPicker.css('backgroundColor', hsb2hex({ h: hsb.h, s: 100, b: 100 }));
        gridPicker.css('backgroundColor', hex);
        opacityPickerColor.css('backgroundColor', hex);
        opacitySlider.find('.minicolors-slider-color').css('backgroundColor', hex);
        break;
    }
    swatch.find('SPAN').css('backgroundColor', hex);
    if (opacity) {
      hiddenInput.data('hex', hex).val(rgbString(hiddenInput, opacity));
      doChange(hiddenInput, rgbString(hiddenInput, opacity), opacity);
    } else {
      hiddenInput.val(hex);
      doChange(hiddenInput, hex, opacity);
    }
  }

  // Runs the change and changeDelay callbacks
  function doChange(input, hex, opacity) {
    var settings = input.data('minicolors-settings'),
        lastChange = input.data('minicolors-lastChange');

    // Only run if it actually changed
    if (!lastChange || lastChange.hex !== hex || lastChange.opacity !== opacity) {

      // Remember last-changed value
      input.data('minicolors-lastChange', {
        hex: hex,
        opacity: opacity
      });

      // Fire change event
      if (settings.change) {
        if (settings.changeDelay) {
          // Call after a delay
          clearTimeout(input.data('minicolors-changeTimeout'));
          input.data('minicolors-changeTimeout', setTimeout(function () {
            settings.change.call(input.get(0), hex, opacity);
          }, settings.changeDelay));
        } else {
          // Call immediately
          settings.change.call(input.get(0), hex, opacity);
        }
      }
      input.trigger('change').trigger('input');
    }
  }

  // Generates an RGB(A) object based on the input's value
  function rgbObject(input) {
    var hex = parseHex($(input).val(), true),
        rgb = hex2rgb(hex),
        opacity = $(input).attr('data-opacity');
    if (!rgb) return null;
    if (opacity !== undefined) $.extend(rgb, { a: parseFloat(opacity) });
    return rgb;
  }

  // Genearates an RGB(A) string based on the input's value
  function rgbString(input, alpha) {
    var hex = parseHex($(input).data('hex'), true),
        rgb = hex2rgb(hex),
        opacity = $(input).attr('data-opacity');
    if (!rgb) return null;
    if (opacity === undefined) opacity = 1;
    if (alpha) {
      return 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + parseFloat(alpha) + ')';
    } else {
      return 'rgb(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ')';
    }
  }

  // Converts to the letter case specified in settings
  function convertCase(string, letterCase) {
    return letterCase === 'uppercase' ? string.toUpperCase() : string && string.toLowerCase();
  }

  // Parses a string and returns a valid hex string when possible
  function parseHex(string, expand) {
    string = string.replace(/[^A-F0-9]/ig, '');
    if (string.length !== 3 && string.length !== 6) return '';
    if (string.length === 3 && expand) {
      string = string[0] + string[0] + string[1] + string[1] + string[2] + string[2];
    }
    return '#' + string;
  }

  // Keeps value within min and max
  function keepWithin(value, min, max) {
    if (value < min) value = min;
    if (value > max) value = max;
    return value;
  }

  // Converts an HSB object to an RGB object
  function hsb2rgb(hsb) {
    var rgb = {};
    var h = Math.round(hsb.h);
    var s = Math.round(hsb.s * 255 / 100);
    var v = Math.round(hsb.b * 255 / 100);
    if (s === 0) {
      rgb.r = rgb.g = rgb.b = v;
    } else {
      var t1 = v;
      var t2 = (255 - s) * v / 255;
      var t3 = (t1 - t2) * (h % 60) / 60;
      if (h === 360) h = 0;
      if (h < 60) {
        rgb.r = t1;rgb.b = t2;rgb.g = t2 + t3;
      } else if (h < 120) {
        rgb.g = t1;rgb.b = t2;rgb.r = t1 - t3;
      } else if (h < 180) {
        rgb.g = t1;rgb.r = t2;rgb.b = t2 + t3;
      } else if (h < 240) {
        rgb.b = t1;rgb.r = t2;rgb.g = t1 - t3;
      } else if (h < 300) {
        rgb.b = t1;rgb.g = t2;rgb.r = t2 + t3;
      } else if (h < 360) {
        rgb.r = t1;rgb.g = t2;rgb.b = t1 - t3;
      } else {
        rgb.r = 0;rgb.g = 0;rgb.b = 0;
      }
    }
    return {
      r: Math.round(rgb.r),
      g: Math.round(rgb.g),
      b: Math.round(rgb.b)
    };
  }

  // Converts an RGB object to a hex string
  function rgb2hex(rgb) {
    var hex = [rgb.r.toString(16), rgb.g.toString(16), rgb.b.toString(16)];
    $.each(hex, function (nr, val) {
      if (val.length === 1) hex[nr] = '0' + val;
    });
    return '#' + hex.join('');
  }

  function rgba2hex(rgba) {
    var rgbaStringArray = rgba.match(/[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s]?([\d.]+)[\s+]?/g);
    if (rgbaStringArray === null) {
      return [rgba, 1];
    } else {
      var rgb = rgbaStringArray[0].split(', ');
      var opacity = rgb[3];

      var hexResult = rgb && rgb.length === 4 ? "#" + ("0" + parseInt(rgb[0], 10).toString(16)).slice(-2) + ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) + ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2) : '';
      return [hexResult, opacity];
    }
  }

  // Converts an HSB object to a hex string
  function hsb2hex(hsb) {
    return rgb2hex(hsb2rgb(hsb));
  }

  // Converts a hex string to an HSB object
  function hex2hsb(hex) {
    var hsb = rgb2hsb(hex2rgb(hex));
    if (hsb.s === 0) hsb.h = 360;
    return hsb;
  }

  // Converts an RGB object to an HSB object
  function rgb2hsb(rgb) {
    var hsb = { h: 0, s: 0, b: 0 };
    var min = Math.min(rgb.r, rgb.g, rgb.b);
    var max = Math.max(rgb.r, rgb.g, rgb.b);
    var delta = max - min;
    hsb.b = max;
    hsb.s = max !== 0 ? 255 * delta / max : 0;
    if (hsb.s !== 0) {
      if (rgb.r === max) {
        hsb.h = (rgb.g - rgb.b) / delta;
      } else if (rgb.g === max) {
        hsb.h = 2 + (rgb.b - rgb.r) / delta;
      } else {
        hsb.h = 4 + (rgb.r - rgb.g) / delta;
      }
    } else {
      hsb.h = -1;
    }
    hsb.h *= 60;
    if (hsb.h < 0) {
      hsb.h += 360;
    }
    hsb.s *= 100 / 255;
    hsb.b *= 100 / 255;
    return hsb;
  }

  // Converts a hex string to an RGB object
  function hex2rgb(hex) {
    hex = parseInt(hex.indexOf('#') > -1 ? hex.substring(1) : hex, 16);
    return {
      r: hex >> 16,
      g: (hex & 0x00FF00) >> 8,
      b: hex & 0x0000FF
    };
  }

  // // Handle events
  function initializer() {

    $(document).on('mouseup.minicolors touchend.minicolors', function () {
      $(minicolors_doc).removeData('minicolors-target');
    });

    $(minicolors_doc)
    // Hide on clicks outside of the control

    .on('mousedown.minicolors touchstart.minicolors', function (event) {
      if (!$(event.target).parents().add(event.target).hasClass('minicolors') || $(event.target).attr("id") == 'minicolors-overlay') {
        hide();
      }
    })
    // Start moving
    .on('mousedown.minicolors touchstart.minicolors', '.minicolors-grid, .minicolors-slider, .minicolors-opacity-slider', function (event) {
      var target = $(this);
      event.preventDefault();
      $(minicolors_doc).data('minicolors-target', target);
      move(target, event, true);
    })

    // Move pickers
    .on('mousemove.minicolors touchmove.minicolors', function (event) {
      var target = $(minicolors_doc).data('minicolors-target');
      if (target) move(target, event);
    })
    // Stop moving
    .on('mouseup.minicolors touchend.minicolors', function () {
      $(minicolors_doc).removeData('minicolors-target');
    })

    // Show panel when swatch is clicked
    .on('mousedown.minicolors touchstart.minicolors', '.minicolors-swatch', function (event) {
      var input = $(this).parent().find('.minicolors-input');
      event.preventDefault();
      show(input);
    })
    // Show on focus
    .on('focus.minicolors', '.minicolors-input', function () {
      var input = $(this);
      if (!input.data('minicolors-initialized')) return;
      show(input);
    })
    // Fix hex on blur
    .on('blur.minicolors', '.minicolors-input', function () {
      var input = $(this),
          settings = input.data('minicolors-settings');
      if (!input.data('minicolors-initialized')) return;

      // Parse Hex
      input.val(parseHex(input.val(), true));

      // Is it blank?
      if (input.val() === '') input.val(parseHex(settings.defaultValue, true));

      // Adjust case
      input.val(convertCase(input.val(), settings.letterCase));
    })
    // Handle keypresses
    .on('keydown.minicolors', '.minicolors-input', function (event) {
      var input = $(this);
      if (!input.data('minicolors-initialized')) return;
      switch (event.keyCode) {
        case 9:
          // tab
          hide();
          break;
        case 13: // enter
        case 27:
          // esc
          hide();
          input.blur();
          break;
      }
    }).on('keyup.minicolors', '.minicolors-panel-input', function (event) {
      var input = $(this);
      updatePanelInput(input, true);
    }).on('keyup.minicolors', '.minicolors-panel-input-opacity', function (event) {
      var input = $(this);
      input.attr("data-opacity", $(this).val());
      updatePanelOpacityInput(input, true);
    })

    // Update on keyup
    .on('keyup.minicolors', '.minicolors-input', function () {
      var input = $(this);
      if (!input.data('minicolors-initialized')) return;
      updateFromInput(input, true);
    })
    // Update on paste
    .on('paste.minicolors', '.minicolors-input', function () {
      var input = $(this);
      if (!input.data('minicolors-initialized')) return;
      setTimeout(function () {
        updateFromInput(input, true);
      }, 1);
    }).on('paste.minicolors', '.minicolors-panel-input', function () {
      var input = $(this);
      setTimeout(function () {
        updatePanelInput(input, true);
      }, 1);
    }).on('paste.minicolors', '.minicolors-panel-input-opacity', function () {
      var input = $(this);
      input.attr("data-opacity", $(this).val());
      setTimeout(function () {
        updatePanelOpacityInput(input, true);
      }, 1);
    });
  }
  initializer();
})(jQuery);

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* injects from baggage-loader */



var moduleMinicolorsDirective = angular.module('minicolors', []);

angular.module('minicolors').provider('minicolors', function () {
  this.defaults = {
    theme: 'bootstrap',
    position: 'top left',
    defaultValue: '',
    animationSpeed: 50,
    animationEasing: 'swing',
    change: null,
    changeDelay: 0,
    control: 'hue',
    hide: null,
    hideSpeed: 100,
    inline: false,
    letterCase: 'lowercase',
    opacity: false,
    show: null,
    showSpeed: 100
  };
  this.$get = function () {
    return this;
  };
});

moduleMinicolorsDirective.directive('minicolors', ['minicolors', '$timeout', function (minicolors, $timeout) {
  return {
    require: '?ngModel',
    restrict: 'A',
    priority: 1,
    link: function link(scope, element, attrs, ngModel) {
      var inititalized = false;

      // gets the settings object
      var getSettings = function getSettings() {
        return angular.extend({}, minicolors.defaults, scope.$eval(attrs.minicolors));
      };

      // what to do if the value changed
      ngModel.$render = function () {
        // we are in digest or apply, and therefore call a timeout function
        $timeout(function () {
          var color = ngModel.$viewValue;
          element.minicolors('value', color);
        }, 100, false);
      };

      // init method
      var initMiniColors = function initMiniColors() {
        if (!ngModel) {
          return;
        }

        var settings = getSettings();
        settings.change = function (hex) {
          // scope.$apply ->
          ngModel.$setViewValue(hex);
        };

        // If we don't destroy the old one it doesn't update properly when the config changes
        element.minicolors('destroy');
        // Create the new minicolors widget
        element.minicolors(settings);

        // are we inititalized yet ?
        // needs to be wrapped in $timeout, to prevent $apply / $digest errors
        // $scope.$apply will be called by $timeout, so we don't have to handle that case
        if (!inititalized) {
          $timeout(function () {
            var color = ngModel.$viewValue;
            element.minicolors('value', color);
          }, 0);

          inititalized = true;
        }
      };

      initMiniColors();

      // initital call
      // Watch for changes to the directives options and then call init method again
      var listener = scope.$watch(getSettings, initMiniColors, true);

      scope.$on('$destroy', function () {
        listener();
      });
    }
  };
}]);

/***/ }),
/* 54 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

var facebookCommentDirective = angular.module('facebookComment.setting', []);

facebookCommentDirective.directive('facebookCommentSetting', ['$window', '$timeout', '$compile', '$templateCache', 'ns', '$rootScope', '$filter', function ($window, $timeout, $compile, $templateCache, ns, $rootScope, $filter) {
    return {
        restrict: 'A',
        scope: {
            data: '=ngModel'
        },
        link: function link(scope, element, attrs, ngModel) {

            var id = attrs.widgetId;
            var widgetElWrapper = angular.element('[data-block-id=' + id + ']').find(ns.widgetWrapperClass);

            // Болванка для работы с настройками виджета FB комментарии
            // console.log({widgetElWrapper});

            scope.accordion = {
                show_form: false,
                show_parent_button: false,
                show_button: false,
                show_action: false
            };

            var listeners = [];

            listeners.push(scope.$watch('data', function (newVal) {
                // console.log({newVal});
            }, true));

            scope.$on('$destroy', function () {
                _.each(listeners, function (listener) {
                    listener();
                });
            });
        }
    };
}]);

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* injects from baggage-loader */



var iconSelectorDirectiveModule = angular.module('iconSelector.setting', []);

iconSelectorDirectiveModule.directive('iconSelectorSetting', ['$window', '$timeout', '$compile', '$templateCache', function ($window, $timeout, $compile, $templateCache) {
    return {
        restrict: 'A',
        scope: { data: '=ngModel' },
        templateUrl: settingFolder + "/icon/template.jade",
        link: function link(scope, element, attrs, ngModel) {
            var $widget = $(element);
            var $input = $widget.find('.icon-selector__input');
            var $panel = $widget.find('.icon-selector__panel');
            var closePopupOnClick = function closePopupOnClick(event) {
                var $targetClick = $(event.target);
                var $parentPanel = $targetClick.closest('.icon-selector__panel');
                var $parentInput = $targetClick.closest('.icon-selector__input');

                if ($panel.hasClass('icon-selector__panel_visible') && $parentPanel.length === 0 && $parentInput.length === 0) {
                    $panel.removeClass('icon-selector__panel_visible');
                }
            };

            $input.on('focus', function () {
                $panel.addClass('icon-selector__panel_visible');
            });

            $(document).on('mousedown', function (event) {
                closePopupOnClick(event);
            });

            scope.search = '';
            scope.icons = [{ cssClass: 'fa fa-500px', title: '500px' }, { cssClass: 'fa fa-address-book', title: 'address-book' }, { cssClass: 'fa fa-address-book-o', title: 'address-book-o' }, { cssClass: 'fa fa-address-card', title: 'address-card' }, { cssClass: 'fa fa-address-card-o', title: 'address-card-o' }, { cssClass: 'fa fa-adjust', title: 'adjust' }, { cssClass: 'fa fa-adn', title: 'adn' }, { cssClass: 'fa fa-align-center', title: 'align-center' }, { cssClass: 'fa fa-align-justify', title: 'align-justify' }, { cssClass: 'fa fa-align-left', title: 'align-left' }, { cssClass: 'fa fa-align-right', title: 'align-right' }, { cssClass: 'fa fa-amazon', title: 'amazon' }, { cssClass: 'fa fa-ambulance', title: 'ambulance' }, { cssClass: 'fa fa-american-sign-language-interpreting', title: 'american-sign-language-interpreting' }, { cssClass: 'fa fa-anchor', title: 'anchor' }, { cssClass: 'fa fa-android', title: 'android' }, { cssClass: 'fa fa-angellist', title: 'angellist' }, { cssClass: 'fa fa-angle-double-down', title: 'angle-double-down' }, { cssClass: 'fa fa-angle-double-left', title: 'angle-double-left' }, { cssClass: 'fa fa-angle-double-right', title: 'angle-double-right' }, { cssClass: 'fa fa-angle-double-up', title: 'angle-double-up' }, { cssClass: 'fa fa-angle-down', title: 'angle-down' }, { cssClass: 'fa fa-angle-left', title: 'angle-left' }, { cssClass: 'fa fa-angle-right', title: 'angle-right' }, { cssClass: 'fa fa-angle-up', title: 'angle-up' }, { cssClass: 'fa fa-apple', title: 'apple' }, { cssClass: 'fa fa-archive', title: 'archive' }, { cssClass: 'fa fa-area-chart', title: 'area-chart' }, { cssClass: 'fa fa-arrow-circle-down', title: 'arrow-circle-down' }, { cssClass: 'fa fa-arrow-circle-left', title: 'arrow-circle-left' }, { cssClass: 'fa fa-arrow-circle-o-down', title: 'arrow-circle-o-down' }, { cssClass: 'fa fa-arrow-circle-o-left', title: 'arrow-circle-o-left' }, { cssClass: 'fa fa-arrow-circle-o-right', title: 'arrow-circle-o-right' }, { cssClass: 'fa fa-arrow-circle-o-up', title: 'arrow-circle-o-up' }, { cssClass: 'fa fa-arrow-circle-right', title: 'arrow-circle-right' }, { cssClass: 'fa fa-arrow-circle-up', title: 'arrow-circle-up' }, { cssClass: 'fa fa-arrow-down', title: 'arrow-down' }, { cssClass: 'fa fa-arrow-left', title: 'arrow-left' }, { cssClass: 'fa fa-arrow-right', title: 'arrow-right' }, { cssClass: 'fa fa-arrow-up', title: 'arrow-up' }, { cssClass: 'fa fa-arrows', title: 'arrows' }, { cssClass: 'fa fa-arrows-alt', title: 'arrows-alt' }, { cssClass: 'fa fa-arrows-h', title: 'arrows-h' }, { cssClass: 'fa fa-arrows-v', title: 'arrows-v' }, { cssClass: 'fa fa-asl-interpreting', title: 'asl-interpreting' }, { cssClass: 'fa fa-assistive-listening-systems', title: 'assistive-listening-systems' }, { cssClass: 'fa fa-asterisk', title: 'asterisk' }, { cssClass: 'fa fa-at', title: 'at' }, { cssClass: 'fa fa-audio-description', title: 'audio-description' }, { cssClass: 'fa fa-automobile', title: 'automobile' }, { cssClass: 'fa fa-backward', title: 'backward' }, { cssClass: 'fa fa-balance-scale', title: 'balance-scale' }, { cssClass: 'fa fa-ban', title: 'ban' }, { cssClass: 'fa fa-bandcamp', title: 'bandcamp' }, { cssClass: 'fa fa-bank', title: 'bank' }, { cssClass: 'fa fa-bar-chart', title: 'bar-chart' }, { cssClass: 'fa fa-bar-chart-o', title: 'bar-chart-o' }, { cssClass: 'fa fa-barcode', title: 'barcode' }, { cssClass: 'fa fa-bars', title: 'bars' }, { cssClass: 'fa fa-bath', title: 'bath' }, { cssClass: 'fa fa-bathtub', title: 'bathtub' }, { cssClass: 'fa fa-battery', title: 'battery' }, { cssClass: 'fa fa-battery-0', title: 'battery-0' }, { cssClass: 'fa fa-battery-1', title: 'battery-1' }, { cssClass: 'fa fa-battery-2', title: 'battery-2' }, { cssClass: 'fa fa-battery-3', title: 'battery-3' }, { cssClass: 'fa fa-battery-4', title: 'battery-4' }, { cssClass: 'fa fa-battery-empty', title: 'battery-empty' }, { cssClass: 'fa fa-battery-full', title: 'battery-full' }, { cssClass: 'fa fa-battery-half', title: 'battery-half' }, { cssClass: 'fa fa-battery-quarter', title: 'battery-quarter' }, { cssClass: 'fa fa-battery-three-quarters', title: 'battery-three-quarters' }, { cssClass: 'fa fa-bed', title: 'bed' }, { cssClass: 'fa fa-beer', title: 'beer' }, { cssClass: 'fa fa-behance', title: 'behance' }, { cssClass: 'fa fa-behance-square', title: 'behance-square' }, { cssClass: 'fa fa-bell', title: 'bell' }, { cssClass: 'fa fa-bell-o', title: 'bell-o' }, { cssClass: 'fa fa-bell-slash', title: 'bell-slash' }, { cssClass: 'fa fa-bell-slash-o', title: 'bell-slash-o' }, { cssClass: 'fa fa-bicycle', title: 'bicycle' }, { cssClass: 'fa fa-binoculars', title: 'binoculars' }, { cssClass: 'fa fa-birthday-cake', title: 'birthday-cake' }, { cssClass: 'fa fa-bitbucket', title: 'bitbucket' }, { cssClass: 'fa fa-bitbucket-square', title: 'bitbucket-square' }, { cssClass: 'fa fa-bitcoin', title: 'bitcoin' }, { cssClass: 'fa fa-black-tie', title: 'black-tie' }, { cssClass: 'fa fa-blind', title: 'blind' }, { cssClass: 'fa fa-bluetooth', title: 'bluetooth' }, { cssClass: 'fa fa-bluetooth-b', title: 'bluetooth-b' }, { cssClass: 'fa fa-bold', title: 'bold' }, { cssClass: 'fa fa-bolt', title: 'bolt' }, { cssClass: 'fa fa-bomb', title: 'bomb' }, { cssClass: 'fa fa-book', title: 'book' }, { cssClass: 'fa fa-bookmark', title: 'bookmark' }, { cssClass: 'fa fa-bookmark-o', title: 'bookmark-o' }, { cssClass: 'fa fa-braille', title: 'braille' }, { cssClass: 'fa fa-briefcase', title: 'briefcase' }, { cssClass: 'fa fa-btc', title: 'btc' }, { cssClass: 'fa fa-bug', title: 'bug' }, { cssClass: 'fa fa-building', title: 'building' }, { cssClass: 'fa fa-building-o', title: 'building-o' }, { cssClass: 'fa fa-bullhorn', title: 'bullhorn' }, { cssClass: 'fa fa-bullseye', title: 'bullseye' }, { cssClass: 'fa fa-bus', title: 'bus' }, { cssClass: 'fa fa-buysellads', title: 'buysellads' }, { cssClass: 'fa fa-cab', title: 'cab' }, { cssClass: 'fa fa-calculator', title: 'calculator' }, { cssClass: 'fa fa-calendar', title: 'calendar' }, { cssClass: 'fa fa-calendar-check-o', title: 'calendar-check-o' }, { cssClass: 'fa fa-calendar-minus-o', title: 'calendar-minus-o' }, { cssClass: 'fa fa-calendar-o', title: 'calendar-o' }, { cssClass: 'fa fa-calendar-plus-o', title: 'calendar-plus-o' }, { cssClass: 'fa fa-calendar-times-o', title: 'calendar-times-o' }, { cssClass: 'fa fa-camera', title: 'camera' }, { cssClass: 'fa fa-camera-retro', title: 'camera-retro' }, { cssClass: 'fa fa-car', title: 'car' }, { cssClass: 'fa fa-caret-down', title: 'caret-down' }, { cssClass: 'fa fa-caret-left', title: 'caret-left' }, { cssClass: 'fa fa-caret-right', title: 'caret-right' }, { cssClass: 'fa fa-caret-square-o-down', title: 'caret-square-o-down' }, { cssClass: 'fa fa-caret-square-o-left', title: 'caret-square-o-left' }, { cssClass: 'fa fa-caret-square-o-right', title: 'caret-square-o-right' }, { cssClass: 'fa fa-caret-square-o-up', title: 'caret-square-o-up' }, { cssClass: 'fa fa-caret-up', title: 'caret-up' }, { cssClass: 'fa fa-cart-arrow-down', title: 'cart-arrow-down' }, { cssClass: 'fa fa-cart-plus', title: 'cart-plus' }, { cssClass: 'fa fa-cc', title: 'cc' }, { cssClass: 'fa fa-cc-amex', title: 'cc-amex' }, { cssClass: 'fa fa-cc-diners-club', title: 'cc-diners-club' }, { cssClass: 'fa fa-cc-discover', title: 'cc-discover' }, { cssClass: 'fa fa-cc-jcb', title: 'cc-jcb' }, { cssClass: 'fa fa-cc-mastercard', title: 'cc-mastercard' }, { cssClass: 'fa fa-cc-paypal', title: 'cc-paypal' }, { cssClass: 'fa fa-cc-stripe', title: 'cc-stripe' }, { cssClass: 'fa fa-cc-visa', title: 'cc-visa' }, { cssClass: 'fa fa-certificate', title: 'certificate' }, { cssClass: 'fa fa-chain', title: 'chain' }, { cssClass: 'fa fa-chain-broken', title: 'chain-broken' }, { cssClass: 'fa fa-check', title: 'check' }, { cssClass: 'fa fa-check-circle', title: 'check-circle' }, { cssClass: 'fa fa-check-circle-o', title: 'check-circle-o' }, { cssClass: 'fa fa-check-square', title: 'check-square' }, { cssClass: 'fa fa-check-square-o', title: 'check-square-o' }, { cssClass: 'fa fa-chevron-circle-down', title: 'chevron-circle-down' }, { cssClass: 'fa fa-chevron-circle-left', title: 'chevron-circle-left' }, { cssClass: 'fa fa-chevron-circle-right', title: 'chevron-circle-right' }, { cssClass: 'fa fa-chevron-circle-up', title: 'chevron-circle-up' }, { cssClass: 'fa fa-chevron-down', title: 'chevron-down' }, { cssClass: 'fa fa-chevron-left', title: 'chevron-left' }, { cssClass: 'fa fa-chevron-right', title: 'chevron-right' }, { cssClass: 'fa fa-chevron-up', title: 'chevron-up' }, { cssClass: 'fa fa-child', title: 'child' }, { cssClass: 'fa fa-chrome', title: 'chrome' }, { cssClass: 'fa fa-circle', title: 'circle' }, { cssClass: 'fa fa-circle-o', title: 'circle-o' }, { cssClass: 'fa fa-circle-o-notch', title: 'circle-o-notch' }, { cssClass: 'fa fa-circle-thin', title: 'circle-thin' }, { cssClass: 'fa fa-clipboard', title: 'clipboard' }, { cssClass: 'fa fa-clock-o', title: 'clock-o' }, { cssClass: 'fa fa-clone', title: 'clone' }, { cssClass: 'fa fa-close', title: 'close' }, { cssClass: 'fa fa-cloud', title: 'cloud' }, { cssClass: 'fa fa-cloud-download', title: 'cloud-download' }, { cssClass: 'fa fa-cloud-upload', title: 'cloud-upload' }, { cssClass: 'fa fa-cny', title: 'cny' }, { cssClass: 'fa fa-code', title: 'code' }, { cssClass: 'fa fa-code-fork', title: 'code-fork' }, { cssClass: 'fa fa-codepen', title: 'codepen' }, { cssClass: 'fa fa-codiepie', title: 'codiepie' }, { cssClass: 'fa fa-coffee', title: 'coffee' }, { cssClass: 'fa fa-cog', title: 'cog' }, { cssClass: 'fa fa-cogs', title: 'cogs' }, { cssClass: 'fa fa-columns', title: 'columns' }, { cssClass: 'fa fa-comment', title: 'comment' }, { cssClass: 'fa fa-comment-o', title: 'comment-o' }, { cssClass: 'fa fa-commenting', title: 'commenting' }, { cssClass: 'fa fa-commenting-o', title: 'commenting-o' }, { cssClass: 'fa fa-comments', title: 'comments' }, { cssClass: 'fa fa-comments-o', title: 'comments-o' }, { cssClass: 'fa fa-compass', title: 'compass' }, { cssClass: 'fa fa-compress', title: 'compress' }, { cssClass: 'fa fa-connectdevelop', title: 'connectdevelop' }, { cssClass: 'fa fa-contao', title: 'contao' }, { cssClass: 'fa fa-copy', title: 'copy' }, { cssClass: 'fa fa-copyright', title: 'copyright' }, { cssClass: 'fa fa-creative-commons', title: 'creative-commons' }, { cssClass: 'fa fa-credit-card', title: 'credit-card' }, { cssClass: 'fa fa-credit-card-alt', title: 'credit-card-alt' }, { cssClass: 'fa fa-crop', title: 'crop' }, { cssClass: 'fa fa-crosshairs', title: 'crosshairs' }, { cssClass: 'fa fa-css3', title: 'css3' }, { cssClass: 'fa fa-cube', title: 'cube' }, { cssClass: 'fa fa-cubes', title: 'cubes' }, { cssClass: 'fa fa-cut', title: 'cut' }, { cssClass: 'fa fa-cutlery', title: 'cutlery' }, { cssClass: 'fa fa-dashboard', title: 'dashboard' }, { cssClass: 'fa fa-dashcube', title: 'dashcube' }, { cssClass: 'fa fa-database', title: 'database' }, { cssClass: 'fa fa-deaf', title: 'deaf' }, { cssClass: 'fa fa-deafness', title: 'deafness' }, { cssClass: 'fa fa-dedent', title: 'dedent' }, { cssClass: 'fa fa-delicious', title: 'delicious' }, { cssClass: 'fa fa-desktop', title: 'desktop' }, { cssClass: 'fa fa-deviantart', title: 'deviantart' }, { cssClass: 'fa fa-diamond', title: 'diamond' }, { cssClass: 'fa fa-digg', title: 'digg' }, { cssClass: 'fa fa-dollar', title: 'dollar' }, { cssClass: 'fa fa-dot-circle-o', title: 'dot-circle-o' }, { cssClass: 'fa fa-download', title: 'download' }, { cssClass: 'fa fa-dribbble', title: 'dribbble' }, { cssClass: 'fa fa-drivers-license', title: 'drivers-license' }, { cssClass: 'fa fa-drivers-license-o', title: 'drivers-license-o' }, { cssClass: 'fa fa-dropbox', title: 'dropbox' }, { cssClass: 'fa fa-drupal', title: 'drupal' }, { cssClass: 'fa fa-edge', title: 'edge' }, { cssClass: 'fa fa-edit', title: 'edit' }, { cssClass: 'fa fa-eercast', title: 'eercast' }, { cssClass: 'fa fa-eject', title: 'eject' }, { cssClass: 'fa fa-ellipsis-h', title: 'ellipsis-h' }, { cssClass: 'fa fa-ellipsis-v', title: 'ellipsis-v' }, { cssClass: 'fa fa-empire', title: 'empire' }, { cssClass: 'fa fa-envelope', title: 'envelope' }, { cssClass: 'fa fa-envelope-o', title: 'envelope-o' }, { cssClass: 'fa fa-envelope-open', title: 'envelope-open' }, { cssClass: 'fa fa-envelope-open-o', title: 'envelope-open-o' }, { cssClass: 'fa fa-envelope-square', title: 'envelope-square' }, { cssClass: 'fa fa-envira', title: 'envira' }, { cssClass: 'fa fa-eraser', title: 'eraser' }, { cssClass: 'fa fa-etsy', title: 'etsy' }, { cssClass: 'fa fa-eur', title: 'eur' }, { cssClass: 'fa fa-euro', title: 'euro' }, { cssClass: 'fa fa-exchange', title: 'exchange' }, { cssClass: 'fa fa-exclamation', title: 'exclamation' }, { cssClass: 'fa fa-exclamation-circle', title: 'exclamation-circle' }, { cssClass: 'fa fa-exclamation-triangle', title: 'exclamation-triangle' }, { cssClass: 'fa fa-expand', title: 'expand' }, { cssClass: 'fa fa-expeditedssl', title: 'expeditedssl' }, { cssClass: 'fa fa-external-link', title: 'external-link' }, { cssClass: 'fa fa-external-link-square', title: 'external-link-square' }, { cssClass: 'fa fa-eye', title: 'eye' }, { cssClass: 'fa fa-eye-slash', title: 'eye-slash' }, { cssClass: 'fa fa-eyedropper', title: 'eyedropper' }, { cssClass: 'fa fa-fa', title: 'fa' }, { cssClass: 'fa fa-facebook', title: 'facebook' }, { cssClass: 'fa fa-facebook-f', title: 'facebook-f' }, { cssClass: 'fa fa-facebook-official', title: 'facebook-official' }, { cssClass: 'fa fa-facebook-square', title: 'facebook-square' }, { cssClass: 'fa fa-fast-backward', title: 'fast-backward' }, { cssClass: 'fa fa-fast-forward', title: 'fast-forward' }, { cssClass: 'fa fa-fax', title: 'fax' }, { cssClass: 'fa fa-feed', title: 'feed' }, { cssClass: 'fa fa-female', title: 'female' }, { cssClass: 'fa fa-fighter-jet', title: 'fighter-jet' }, { cssClass: 'fa fa-file', title: 'file' }, { cssClass: 'fa fa-file-archive-o', title: 'file-archive-o' }, { cssClass: 'fa fa-file-audio-o', title: 'file-audio-o' }, { cssClass: 'fa fa-file-code-o', title: 'file-code-o' }, { cssClass: 'fa fa-file-excel-o', title: 'file-excel-o' }, { cssClass: 'fa fa-file-image-o', title: 'file-image-o' }, { cssClass: 'fa fa-file-movie-o', title: 'file-movie-o' }, { cssClass: 'fa fa-file-o', title: 'file-o' }, { cssClass: 'fa fa-file-pdf-o', title: 'file-pdf-o' }, { cssClass: 'fa fa-file-photo-o', title: 'file-photo-o' }, { cssClass: 'fa fa-file-picture-o', title: 'file-picture-o' }, { cssClass: 'fa fa-file-powerpoint-o', title: 'file-powerpoint-o' }, { cssClass: 'fa fa-file-sound-o', title: 'file-sound-o' }, { cssClass: 'fa fa-file-text', title: 'file-text' }, { cssClass: 'fa fa-file-text-o', title: 'file-text-o' }, { cssClass: 'fa fa-file-video-o', title: 'file-video-o' }, { cssClass: 'fa fa-file-word-o', title: 'file-word-o' }, { cssClass: 'fa fa-file-zip-o', title: 'file-zip-o' }, { cssClass: 'fa fa-files-o', title: 'files-o' }, { cssClass: 'fa fa-film', title: 'film' }, { cssClass: 'fa fa-filter', title: 'filter' }, { cssClass: 'fa fa-fire', title: 'fire' }, { cssClass: 'fa fa-fire-extinguisher', title: 'fire-extinguisher' }, { cssClass: 'fa fa-firefox', title: 'firefox' }, { cssClass: 'fa fa-first-order', title: 'first-order' }, { cssClass: 'fa fa-flag', title: 'flag' }, { cssClass: 'fa fa-flag-checkered', title: 'flag-checkered' }, { cssClass: 'fa fa-flag-o', title: 'flag-o' }, { cssClass: 'fa fa-flash', title: 'flash' }, { cssClass: 'fa fa-flask', title: 'flask' }, { cssClass: 'fa fa-flickr', title: 'flickr' }, { cssClass: 'fa fa-floppy-o', title: 'floppy-o' }, { cssClass: 'fa fa-folder', title: 'folder' }, { cssClass: 'fa fa-folder-o', title: 'folder-o' }, { cssClass: 'fa fa-folder-open', title: 'folder-open' }, { cssClass: 'fa fa-folder-open-o', title: 'folder-open-o' }, { cssClass: 'fa fa-font', title: 'font' }, { cssClass: 'fa fa-font-awesome', title: 'font-awesome' }, { cssClass: 'fa fa-fonticons', title: 'fonticons' }, { cssClass: 'fa fa-fort-awesome', title: 'fort-awesome' }, { cssClass: 'fa fa-forumbee', title: 'forumbee' }, { cssClass: 'fa fa-forward', title: 'forward' }, { cssClass: 'fa fa-foursquare', title: 'foursquare' }, { cssClass: 'fa fa-free-code-camp', title: 'free-code-camp' }, { cssClass: 'fa fa-frown-o', title: 'frown-o' }, { cssClass: 'fa fa-futbol-o', title: 'futbol-o' }, { cssClass: 'fa fa-gamepad', title: 'gamepad' }, { cssClass: 'fa fa-gavel', title: 'gavel' }, { cssClass: 'fa fa-gbp', title: 'gbp' }, { cssClass: 'fa fa-ge', title: 'ge' }, { cssClass: 'fa fa-gear', title: 'gear' }, { cssClass: 'fa fa-gears', title: 'gears' }, { cssClass: 'fa fa-genderless', title: 'genderless' }, { cssClass: 'fa fa-get-pocket', title: 'get-pocket' }, { cssClass: 'fa fa-gg', title: 'gg' }, { cssClass: 'fa fa-gg-circle', title: 'gg-circle' }, { cssClass: 'fa fa-gift', title: 'gift' }, { cssClass: 'fa fa-git', title: 'git' }, { cssClass: 'fa fa-git-square', title: 'git-square' }, { cssClass: 'fa fa-github', title: 'github' }, { cssClass: 'fa fa-github-alt', title: 'github-alt' }, { cssClass: 'fa fa-github-square', title: 'github-square' }, { cssClass: 'fa fa-gitlab', title: 'gitlab' }, { cssClass: 'fa fa-gittip', title: 'gittip' }, { cssClass: 'fa fa-glass', title: 'glass' }, { cssClass: 'fa fa-glide', title: 'glide' }, { cssClass: 'fa fa-glide-g', title: 'glide-g' }, { cssClass: 'fa fa-globe', title: 'globe' }, { cssClass: 'fa fa-google', title: 'google' }, { cssClass: 'fa fa-google-plus', title: 'google-plus' }, { cssClass: 'fa fa-google-plus-circle', title: 'google-plus-circle' }, { cssClass: 'fa fa-google-plus-official', title: 'google-plus-official' }, { cssClass: 'fa fa-google-plus-square', title: 'google-plus-square' }, { cssClass: 'fa fa-google-wallet', title: 'google-wallet' }, { cssClass: 'fa fa-graduation-cap', title: 'graduation-cap' }, { cssClass: 'fa fa-gratipay', title: 'gratipay' }, { cssClass: 'fa fa-grav', title: 'grav' }, { cssClass: 'fa fa-group', title: 'group' }, { cssClass: 'fa fa-h-square', title: 'h-square' }, { cssClass: 'fa fa-hacker-news', title: 'hacker-news' }, { cssClass: 'fa fa-hand-grab-o', title: 'hand-grab-o' }, { cssClass: 'fa fa-hand-lizard-o', title: 'hand-lizard-o' }, { cssClass: 'fa fa-hand-o-down', title: 'hand-o-down' }, { cssClass: 'fa fa-hand-o-left', title: 'hand-o-left' }, { cssClass: 'fa fa-hand-o-right', title: 'hand-o-right' }, { cssClass: 'fa fa-hand-o-up', title: 'hand-o-up' }, { cssClass: 'fa fa-hand-paper-o', title: 'hand-paper-o' }, { cssClass: 'fa fa-hand-peace-o', title: 'hand-peace-o' }, { cssClass: 'fa fa-hand-pointer-o', title: 'hand-pointer-o' }, { cssClass: 'fa fa-hand-rock-o', title: 'hand-rock-o' }, { cssClass: 'fa fa-hand-scissors-o', title: 'hand-scissors-o' }, { cssClass: 'fa fa-hand-spock-o', title: 'hand-spock-o' }, { cssClass: 'fa fa-hand-stop-o', title: 'hand-stop-o' }, { cssClass: 'fa fa-handshake-o', title: 'handshake-o' }, { cssClass: 'fa fa-hard-of-hearing', title: 'hard-of-hearing' }, { cssClass: 'fa fa-hashtag', title: 'hashtag' }, { cssClass: 'fa fa-hdd-o', title: 'hdd-o' }, { cssClass: 'fa fa-header', title: 'header' }, { cssClass: 'fa fa-headphones', title: 'headphones' }, { cssClass: 'fa fa-heart', title: 'heart' }, { cssClass: 'fa fa-heart-o', title: 'heart-o' }, { cssClass: 'fa fa-heartbeat', title: 'heartbeat' }, { cssClass: 'fa fa-history', title: 'history' }, { cssClass: 'fa fa-home', title: 'home' }, { cssClass: 'fa fa-hospital-o', title: 'hospital-o' }, { cssClass: 'fa fa-hotel', title: 'hotel' }, { cssClass: 'fa fa-hourglass', title: 'hourglass' }, { cssClass: 'fa fa-hourglass-1', title: 'hourglass-1' }, { cssClass: 'fa fa-hourglass-2', title: 'hourglass-2' }, { cssClass: 'fa fa-hourglass-3', title: 'hourglass-3' }, { cssClass: 'fa fa-hourglass-end', title: 'hourglass-end' }, { cssClass: 'fa fa-hourglass-half', title: 'hourglass-half' }, { cssClass: 'fa fa-hourglass-o', title: 'hourglass-o' }, { cssClass: 'fa fa-hourglass-start', title: 'hourglass-start' }, { cssClass: 'fa fa-houzz', title: 'houzz' }, { cssClass: 'fa fa-html5', title: 'html5' }, { cssClass: 'fa fa-i-cursor', title: 'i-cursor' }, { cssClass: 'fa fa-id-badge', title: 'id-badge' }, { cssClass: 'fa fa-id-card', title: 'id-card' }, { cssClass: 'fa fa-id-card-o', title: 'id-card-o' }, { cssClass: 'fa fa-ils', title: 'ils' }, { cssClass: 'fa fa-image', title: 'image' }, { cssClass: 'fa fa-imdb', title: 'imdb' }, { cssClass: 'fa fa-inbox', title: 'inbox' }, { cssClass: 'fa fa-indent', title: 'indent' }, { cssClass: 'fa fa-industry', title: 'industry' }, { cssClass: 'fa fa-info', title: 'info' }, { cssClass: 'fa fa-info-circle', title: 'info-circle' }, { cssClass: 'fa fa-inr', title: 'inr' }, { cssClass: 'fa fa-instagram', title: 'instagram' }, { cssClass: 'fa fa-institution', title: 'institution' }, { cssClass: 'fa fa-internet-explorer', title: 'internet-explorer' }, { cssClass: 'fa fa-intersex', title: 'intersex' }, { cssClass: 'fa fa-ioxhost', title: 'ioxhost' }, { cssClass: 'fa fa-italic', title: 'italic' }, { cssClass: 'fa fa-joomla', title: 'joomla' }, { cssClass: 'fa fa-jpy', title: 'jpy' }, { cssClass: 'fa fa-jsfiddle', title: 'jsfiddle' }, { cssClass: 'fa fa-key', title: 'key' }, { cssClass: 'fa fa-keyboard-o', title: 'keyboard-o' }, { cssClass: 'fa fa-krw', title: 'krw' }, { cssClass: 'fa fa-language', title: 'language' }, { cssClass: 'fa fa-laptop', title: 'laptop' }, { cssClass: 'fa fa-lastfm', title: 'lastfm' }, { cssClass: 'fa fa-lastfm-square', title: 'lastfm-square' }, { cssClass: 'fa fa-leaf', title: 'leaf' }, { cssClass: 'fa fa-leanpub', title: 'leanpub' }, { cssClass: 'fa fa-legal', title: 'legal' }, { cssClass: 'fa fa-lemon-o', title: 'lemon-o' }, { cssClass: 'fa fa-level-down', title: 'level-down' }, { cssClass: 'fa fa-level-up', title: 'level-up' }, { cssClass: 'fa fa-life-bouy', title: 'life-bouy' }, { cssClass: 'fa fa-life-buoy', title: 'life-buoy' }, { cssClass: 'fa fa-life-ring', title: 'life-ring' }, { cssClass: 'fa fa-life-saver', title: 'life-saver' }, { cssClass: 'fa fa-lightbulb-o', title: 'lightbulb-o' }, { cssClass: 'fa fa-line-chart', title: 'line-chart' }, { cssClass: 'fa fa-link', title: 'link' }, { cssClass: 'fa fa-linkedin', title: 'linkedin' }, { cssClass: 'fa fa-linkedin-square', title: 'linkedin-square' }, { cssClass: 'fa fa-linode', title: 'linode' }, { cssClass: 'fa fa-linux', title: 'linux' }, { cssClass: 'fa fa-list', title: 'list' }, { cssClass: 'fa fa-list-alt', title: 'list-alt' }, { cssClass: 'fa fa-list-ol', title: 'list-ol' }, { cssClass: 'fa fa-list-ul', title: 'list-ul' }, { cssClass: 'fa fa-location-arrow', title: 'location-arrow' }, { cssClass: 'fa fa-lock', title: 'lock' }, { cssClass: 'fa fa-long-arrow-down', title: 'long-arrow-down' }, { cssClass: 'fa fa-long-arrow-left', title: 'long-arrow-left' }, { cssClass: 'fa fa-long-arrow-right', title: 'long-arrow-right' }, { cssClass: 'fa fa-long-arrow-up', title: 'long-arrow-up' }, { cssClass: 'fa fa-low-vision', title: 'low-vision' }, { cssClass: 'fa fa-magic', title: 'magic' }, { cssClass: 'fa fa-magnet', title: 'magnet' }, { cssClass: 'fa fa-mail-forward', title: 'mail-forward' }, { cssClass: 'fa fa-mail-reply', title: 'mail-reply' }, { cssClass: 'fa fa-mail-reply-all', title: 'mail-reply-all' }, { cssClass: 'fa fa-male', title: 'male' }, { cssClass: 'fa fa-map', title: 'map' }, { cssClass: 'fa fa-map-marker', title: 'map-marker' }, { cssClass: 'fa fa-map-o', title: 'map-o' }, { cssClass: 'fa fa-map-pin', title: 'map-pin' }, { cssClass: 'fa fa-map-signs', title: 'map-signs' }, { cssClass: 'fa fa-mars', title: 'mars' }, { cssClass: 'fa fa-mars-double', title: 'mars-double' }, { cssClass: 'fa fa-mars-stroke', title: 'mars-stroke' }, { cssClass: 'fa fa-mars-stroke-h', title: 'mars-stroke-h' }, { cssClass: 'fa fa-mars-stroke-v', title: 'mars-stroke-v' }, { cssClass: 'fa fa-maxcdn', title: 'maxcdn' }, { cssClass: 'fa fa-meanpath', title: 'meanpath' }, { cssClass: 'fa fa-medium', title: 'medium' }, { cssClass: 'fa fa-medkit', title: 'medkit' }, { cssClass: 'fa fa-meetup', title: 'meetup' }, { cssClass: 'fa fa-meh-o', title: 'meh-o' }, { cssClass: 'fa fa-mercury', title: 'mercury' }, { cssClass: 'fa fa-microchip', title: 'microchip' }, { cssClass: 'fa fa-microphone', title: 'microphone' }, { cssClass: 'fa fa-microphone-slash', title: 'microphone-slash' }, { cssClass: 'fa fa-minus', title: 'minus' }, { cssClass: 'fa fa-minus-circle', title: 'minus-circle' }, { cssClass: 'fa fa-minus-square', title: 'minus-square' }, { cssClass: 'fa fa-minus-square-o', title: 'minus-square-o' }, { cssClass: 'fa fa-mixcloud', title: 'mixcloud' }, { cssClass: 'fa fa-mobile', title: 'mobile' }, { cssClass: 'fa fa-mobile-phone', title: 'mobile-phone' }, { cssClass: 'fa fa-modx', title: 'modx' }, { cssClass: 'fa fa-money', title: 'money' }, { cssClass: 'fa fa-moon-o', title: 'moon-o' }, { cssClass: 'fa fa-mortar-board', title: 'mortar-board' }, { cssClass: 'fa fa-motorcycle', title: 'motorcycle' }, { cssClass: 'fa fa-mouse-pointer', title: 'mouse-pointer' }, { cssClass: 'fa fa-music', title: 'music' }, { cssClass: 'fa fa-navicon', title: 'navicon' }, { cssClass: 'fa fa-neuter', title: 'neuter' }, { cssClass: 'fa fa-newspaper-o', title: 'newspaper-o' }, { cssClass: 'fa fa-object-group', title: 'object-group' }, { cssClass: 'fa fa-object-ungroup', title: 'object-ungroup' }, { cssClass: 'fa fa-odnoklassniki', title: 'odnoklassniki' }, { cssClass: 'fa fa-odnoklassniki-square', title: 'odnoklassniki-square' }, { cssClass: 'fa fa-opencart', title: 'opencart' }, { cssClass: 'fa fa-openid', title: 'openid' }, { cssClass: 'fa fa-opera', title: 'opera' }, { cssClass: 'fa fa-optin-monster', title: 'optin-monster' }, { cssClass: 'fa fa-outdent', title: 'outdent' }, { cssClass: 'fa fa-pagelines', title: 'pagelines' }, { cssClass: 'fa fa-paint-brush', title: 'paint-brush' }, { cssClass: 'fa fa-paper-plane', title: 'paper-plane' }, { cssClass: 'fa fa-paper-plane-o', title: 'paper-plane-o' }, { cssClass: 'fa fa-paperclip', title: 'paperclip' }, { cssClass: 'fa fa-paragraph', title: 'paragraph' }, { cssClass: 'fa fa-paste', title: 'paste' }, { cssClass: 'fa fa-pause', title: 'pause' }, { cssClass: 'fa fa-pause-circle', title: 'pause-circle' }, { cssClass: 'fa fa-pause-circle-o', title: 'pause-circle-o' }, { cssClass: 'fa fa-paw', title: 'paw' }, { cssClass: 'fa fa-paypal', title: 'paypal' }, { cssClass: 'fa fa-pencil', title: 'pencil' }, { cssClass: 'fa fa-pencil-square', title: 'pencil-square' }, { cssClass: 'fa fa-pencil-square-o', title: 'pencil-square-o' }, { cssClass: 'fa fa-percent', title: 'percent' }, { cssClass: 'fa fa-phone', title: 'phone' }, { cssClass: 'fa fa-phone-square', title: 'phone-square' }, { cssClass: 'fa fa-photo', title: 'photo' }, { cssClass: 'fa fa-picture-o', title: 'picture-o' }, { cssClass: 'fa fa-pie-chart', title: 'pie-chart' }, { cssClass: 'fa fa-pied-piper', title: 'pied-piper' }, { cssClass: 'fa fa-pied-piper-alt', title: 'pied-piper-alt' }, { cssClass: 'fa fa-pied-piper-pp', title: 'pied-piper-pp' }, { cssClass: 'fa fa-pinterest', title: 'pinterest' }, { cssClass: 'fa fa-pinterest-p', title: 'pinterest-p' }, { cssClass: 'fa fa-pinterest-square', title: 'pinterest-square' }, { cssClass: 'fa fa-plane', title: 'plane' }, { cssClass: 'fa fa-play', title: 'play' }, { cssClass: 'fa fa-play-circle', title: 'play-circle' }, { cssClass: 'fa fa-play-circle-o', title: 'play-circle-o' }, { cssClass: 'fa fa-plug', title: 'plug' }, { cssClass: 'fa fa-plus', title: 'plus' }, { cssClass: 'fa fa-plus-circle', title: 'plus-circle' }, { cssClass: 'fa fa-plus-square', title: 'plus-square' }, { cssClass: 'fa fa-plus-square-o', title: 'plus-square-o' }, { cssClass: 'fa fa-podcast', title: 'podcast' }, { cssClass: 'fa fa-power-off', title: 'power-off' }, { cssClass: 'fa fa-print', title: 'print' }, { cssClass: 'fa fa-product-hunt', title: 'product-hunt' }, { cssClass: 'fa fa-puzzle-piece', title: 'puzzle-piece' }, { cssClass: 'fa fa-qq', title: 'qq' }, { cssClass: 'fa fa-qrcode', title: 'qrcode' }, { cssClass: 'fa fa-question', title: 'question' }, { cssClass: 'fa fa-question-circle', title: 'question-circle' }, { cssClass: 'fa fa-question-circle-o', title: 'question-circle-o' }, { cssClass: 'fa fa-quora', title: 'quora' }, { cssClass: 'fa fa-quote-left', title: 'quote-left' }, { cssClass: 'fa fa-quote-right', title: 'quote-right' }, { cssClass: 'fa fa-ra', title: 'ra' }, { cssClass: 'fa fa-random', title: 'random' }, { cssClass: 'fa fa-ravelry', title: 'ravelry' }, { cssClass: 'fa fa-rebel', title: 'rebel' }, { cssClass: 'fa fa-recycle', title: 'recycle' }, { cssClass: 'fa fa-reddit', title: 'reddit' }, { cssClass: 'fa fa-reddit-alien', title: 'reddit-alien' }, { cssClass: 'fa fa-reddit-square', title: 'reddit-square' }, { cssClass: 'fa fa-refresh', title: 'refresh' }, { cssClass: 'fa fa-registered', title: 'registered' }, { cssClass: 'fa fa-remove', title: 'remove' }, { cssClass: 'fa fa-renren', title: 'renren' }, { cssClass: 'fa fa-reorder', title: 'reorder' }, { cssClass: 'fa fa-repeat', title: 'repeat' }, { cssClass: 'fa fa-reply', title: 'reply' }, { cssClass: 'fa fa-reply-all', title: 'reply-all' }, { cssClass: 'fa fa-resistance', title: 'resistance' }, { cssClass: 'fa fa-retweet', title: 'retweet' }, { cssClass: 'fa fa-rmb', title: 'rmb' }, { cssClass: 'fa fa-road', title: 'road' }, { cssClass: 'fa fa-rocket', title: 'rocket' }, { cssClass: 'fa fa-rotate-left', title: 'rotate-left' }, { cssClass: 'fa fa-rotate-right', title: 'rotate-right' }, { cssClass: 'fa fa-rouble', title: 'rouble' }, { cssClass: 'fa fa-rss', title: 'rss' }, { cssClass: 'fa fa-rss-square', title: 'rss-square' }, { cssClass: 'fa fa-rub', title: 'rub' }, { cssClass: 'fa fa-ruble', title: 'ruble' }, { cssClass: 'fa fa-rupee', title: 'rupee' }, { cssClass: 'fa fa-s15', title: 's15' }, { cssClass: 'fa fa-safari', title: 'safari' }, { cssClass: 'fa fa-save', title: 'save' }, { cssClass: 'fa fa-scissors', title: 'scissors' }, { cssClass: 'fa fa-scribd', title: 'scribd' }, { cssClass: 'fa fa-search', title: 'search' }, { cssClass: 'fa fa-search-minus', title: 'search-minus' }, { cssClass: 'fa fa-search-plus', title: 'search-plus' }, { cssClass: 'fa fa-sellsy', title: 'sellsy' }, { cssClass: 'fa fa-send', title: 'send' }, { cssClass: 'fa fa-send-o', title: 'send-o' }, { cssClass: 'fa fa-server', title: 'server' }, { cssClass: 'fa fa-share', title: 'share' }, { cssClass: 'fa fa-share-alt', title: 'share-alt' }, { cssClass: 'fa fa-share-alt-square', title: 'share-alt-square' }, { cssClass: 'fa fa-share-square', title: 'share-square' }, { cssClass: 'fa fa-share-square-o', title: 'share-square-o' }, { cssClass: 'fa fa-shekel', title: 'shekel' }, { cssClass: 'fa fa-sheqel', title: 'sheqel' }, { cssClass: 'fa fa-shield', title: 'shield' }, { cssClass: 'fa fa-ship', title: 'ship' }, { cssClass: 'fa fa-shirtsinbulk', title: 'shirtsinbulk' }, { cssClass: 'fa fa-shopping-bag', title: 'shopping-bag' }, { cssClass: 'fa fa-shopping-basket', title: 'shopping-basket' }, { cssClass: 'fa fa-shopping-cart', title: 'shopping-cart' }, { cssClass: 'fa fa-shower', title: 'shower' }, { cssClass: 'fa fa-sign-in', title: 'sign-in' }, { cssClass: 'fa fa-sign-language', title: 'sign-language' }, { cssClass: 'fa fa-sign-out', title: 'sign-out' }, { cssClass: 'fa fa-signal', title: 'signal' }, { cssClass: 'fa fa-signing', title: 'signing' }, { cssClass: 'fa fa-simplybuilt', title: 'simplybuilt' }, { cssClass: 'fa fa-sitemap', title: 'sitemap' }, { cssClass: 'fa fa-skyatlas', title: 'skyatlas' }, { cssClass: 'fa fa-skype', title: 'skype' }, { cssClass: 'fa fa-slack', title: 'slack' }, { cssClass: 'fa fa-sliders', title: 'sliders' }, { cssClass: 'fa fa-slideshare', title: 'slideshare' }, { cssClass: 'fa fa-smile-o', title: 'smile-o' }, { cssClass: 'fa fa-snapchat', title: 'snapchat' }, { cssClass: 'fa fa-snapchat-ghost', title: 'snapchat-ghost' }, { cssClass: 'fa fa-snapchat-square', title: 'snapchat-square' }, { cssClass: 'fa fa-snowflake-o', title: 'snowflake-o' }, { cssClass: 'fa fa-soccer-ball-o', title: 'soccer-ball-o' }, { cssClass: 'fa fa-sort', title: 'sort' }, { cssClass: 'fa fa-sort-alpha-asc', title: 'sort-alpha-asc' }, { cssClass: 'fa fa-sort-alpha-desc', title: 'sort-alpha-desc' }, { cssClass: 'fa fa-sort-amount-asc', title: 'sort-amount-asc' }, { cssClass: 'fa fa-sort-amount-desc', title: 'sort-amount-desc' }, { cssClass: 'fa fa-sort-asc', title: 'sort-asc' }, { cssClass: 'fa fa-sort-desc', title: 'sort-desc' }, { cssClass: 'fa fa-sort-down', title: 'sort-down' }, { cssClass: 'fa fa-sort-numeric-asc', title: 'sort-numeric-asc' }, { cssClass: 'fa fa-sort-numeric-desc', title: 'sort-numeric-desc' }, { cssClass: 'fa fa-sort-up', title: 'sort-up' }, { cssClass: 'fa fa-soundcloud', title: 'soundcloud' }, { cssClass: 'fa fa-space-shuttle', title: 'space-shuttle' }, { cssClass: 'fa fa-spinner', title: 'spinner' }, { cssClass: 'fa fa-spoon', title: 'spoon' }, { cssClass: 'fa fa-spotify', title: 'spotify' }, { cssClass: 'fa fa-square', title: 'square' }, { cssClass: 'fa fa-square-o', title: 'square-o' }, { cssClass: 'fa fa-stack-exchange', title: 'stack-exchange' }, { cssClass: 'fa fa-stack-overflow', title: 'stack-overflow' }, { cssClass: 'fa fa-star', title: 'star' }, { cssClass: 'fa fa-star-half', title: 'star-half' }, { cssClass: 'fa fa-star-half-empty', title: 'star-half-empty' }, { cssClass: 'fa fa-star-half-full', title: 'star-half-full' }, { cssClass: 'fa fa-star-half-o', title: 'star-half-o' }, { cssClass: 'fa fa-star-o', title: 'star-o' }, { cssClass: 'fa fa-steam', title: 'steam' }, { cssClass: 'fa fa-steam-square', title: 'steam-square' }, { cssClass: 'fa fa-step-backward', title: 'step-backward' }, { cssClass: 'fa fa-step-forward', title: 'step-forward' }, { cssClass: 'fa fa-stethoscope', title: 'stethoscope' }, { cssClass: 'fa fa-sticky-note', title: 'sticky-note' }, { cssClass: 'fa fa-sticky-note-o', title: 'sticky-note-o' }, { cssClass: 'fa fa-stop', title: 'stop' }, { cssClass: 'fa fa-stop-circle', title: 'stop-circle' }, { cssClass: 'fa fa-stop-circle-o', title: 'stop-circle-o' }, { cssClass: 'fa fa-street-view', title: 'street-view' }, { cssClass: 'fa fa-strikethrough', title: 'strikethrough' }, { cssClass: 'fa fa-stumbleupon', title: 'stumbleupon' }, { cssClass: 'fa fa-stumbleupon-circle', title: 'stumbleupon-circle' }, { cssClass: 'fa fa-subscript', title: 'subscript' }, { cssClass: 'fa fa-subway', title: 'subway' }, { cssClass: 'fa fa-suitcase', title: 'suitcase' }, { cssClass: 'fa fa-sun-o', title: 'sun-o' }, { cssClass: 'fa fa-superpowers', title: 'superpowers' }, { cssClass: 'fa fa-superscript', title: 'superscript' }, { cssClass: 'fa fa-support', title: 'support' }, { cssClass: 'fa fa-table', title: 'table' }, { cssClass: 'fa fa-tablet', title: 'tablet' }, { cssClass: 'fa fa-tachometer', title: 'tachometer' }, { cssClass: 'fa fa-tag', title: 'tag' }, { cssClass: 'fa fa-tags', title: 'tags' }, { cssClass: 'fa fa-tasks', title: 'tasks' }, { cssClass: 'fa fa-taxi', title: 'taxi' }, { cssClass: 'fa fa-telegram', title: 'telegram' }, { cssClass: 'fa fa-television', title: 'television' }, { cssClass: 'fa fa-tencent-weibo', title: 'tencent-weibo' }, { cssClass: 'fa fa-terminal', title: 'terminal' }, { cssClass: 'fa fa-text-height', title: 'text-height' }, { cssClass: 'fa fa-text-width', title: 'text-width' }, { cssClass: 'fa fa-th', title: 'th' }, { cssClass: 'fa fa-th-large', title: 'th-large' }, { cssClass: 'fa fa-th-list', title: 'th-list' }, { cssClass: 'fa fa-themeisle', title: 'themeisle' }, { cssClass: 'fa fa-thermometer', title: 'thermometer' }, { cssClass: 'fa fa-thermometer-0', title: 'thermometer-0' }, { cssClass: 'fa fa-thermometer-1', title: 'thermometer-1' }, { cssClass: 'fa fa-thermometer-2', title: 'thermometer-2' }, { cssClass: 'fa fa-thermometer-3', title: 'thermometer-3' }, { cssClass: 'fa fa-thermometer-4', title: 'thermometer-4' }, { cssClass: 'fa fa-thermometer-empty', title: 'thermometer-empty' }, { cssClass: 'fa fa-thermometer-full', title: 'thermometer-full' }, { cssClass: 'fa fa-thermometer-half', title: 'thermometer-half' }, { cssClass: 'fa fa-thermometer-quarter', title: 'thermometer-quarter' }, { cssClass: 'fa fa-thermometer-three-quarters', title: 'thermometer-three-quarters' }, { cssClass: 'fa fa-thumb-tack', title: 'thumb-tack' }, { cssClass: 'fa fa-thumbs-down', title: 'thumbs-down' }, { cssClass: 'fa fa-thumbs-o-down', title: 'thumbs-o-down' }, { cssClass: 'fa fa-thumbs-o-up', title: 'thumbs-o-up' }, { cssClass: 'fa fa-thumbs-up', title: 'thumbs-up' }, { cssClass: 'fa fa-ticket', title: 'ticket' }, { cssClass: 'fa fa-times', title: 'times' }, { cssClass: 'fa fa-times-circle', title: 'times-circle' }, { cssClass: 'fa fa-times-circle-o', title: 'times-circle-o' }, { cssClass: 'fa fa-times-rectangle', title: 'times-rectangle' }, { cssClass: 'fa fa-times-rectangle-o', title: 'times-rectangle-o' }, { cssClass: 'fa fa-tint', title: 'tint' }, { cssClass: 'fa fa-toggle-down', title: 'toggle-down' }, { cssClass: 'fa fa-toggle-left', title: 'toggle-left' }, { cssClass: 'fa fa-toggle-off', title: 'toggle-off' }, { cssClass: 'fa fa-toggle-on', title: 'toggle-on' }, { cssClass: 'fa fa-toggle-right', title: 'toggle-right' }, { cssClass: 'fa fa-toggle-up', title: 'toggle-up' }, { cssClass: 'fa fa-trademark', title: 'trademark' }, { cssClass: 'fa fa-train', title: 'train' }, { cssClass: 'fa fa-transgender', title: 'transgender' }, { cssClass: 'fa fa-transgender-alt', title: 'transgender-alt' }, { cssClass: 'fa fa-trash', title: 'trash' }, { cssClass: 'fa fa-trash-o', title: 'trash-o' }, { cssClass: 'fa fa-tree', title: 'tree' }, { cssClass: 'fa fa-trello', title: 'trello' }, { cssClass: 'fa fa-tripadvisor', title: 'tripadvisor' }, { cssClass: 'fa fa-trophy', title: 'trophy' }, { cssClass: 'fa fa-truck', title: 'truck' }, { cssClass: 'fa fa-try', title: 'try' }, { cssClass: 'fa fa-tty', title: 'tty' }, { cssClass: 'fa fa-tumblr', title: 'tumblr' }, { cssClass: 'fa fa-tumblr-square', title: 'tumblr-square' }, { cssClass: 'fa fa-turkish-lira', title: 'turkish-lira' }, { cssClass: 'fa fa-tv', title: 'tv' }, { cssClass: 'fa fa-twitch', title: 'twitch' }, { cssClass: 'fa fa-twitter', title: 'twitter' }, { cssClass: 'fa fa-twitter-square', title: 'twitter-square' }, { cssClass: 'fa fa-umbrella', title: 'umbrella' }, { cssClass: 'fa fa-underline', title: 'underline' }, { cssClass: 'fa fa-undo', title: 'undo' }, { cssClass: 'fa fa-universal-access', title: 'universal-access' }, { cssClass: 'fa fa-university', title: 'university' }, { cssClass: 'fa fa-unlink', title: 'unlink' }, { cssClass: 'fa fa-unlock', title: 'unlock' }, { cssClass: 'fa fa-unlock-alt', title: 'unlock-alt' }, { cssClass: 'fa fa-unsorted', title: 'unsorted' }, { cssClass: 'fa fa-upload', title: 'upload' }, { cssClass: 'fa fa-usb', title: 'usb' }, { cssClass: 'fa fa-usd', title: 'usd' }, { cssClass: 'fa fa-user', title: 'user' }, { cssClass: 'fa fa-user-circle', title: 'user-circle' }, { cssClass: 'fa fa-user-circle-o', title: 'user-circle-o' }, { cssClass: 'fa fa-user-md', title: 'user-md' }, { cssClass: 'fa fa-user-o', title: 'user-o' }, { cssClass: 'fa fa-user-plus', title: 'user-plus' }, { cssClass: 'fa fa-user-secret', title: 'user-secret' }, { cssClass: 'fa fa-user-times', title: 'user-times' }, { cssClass: 'fa fa-users', title: 'users' }, { cssClass: 'fa fa-vcard', title: 'vcard' }, { cssClass: 'fa fa-vcard-o', title: 'vcard-o' }, { cssClass: 'fa fa-venus', title: 'venus' }, { cssClass: 'fa fa-venus-double', title: 'venus-double' }, { cssClass: 'fa fa-venus-mars', title: 'venus-mars' }, { cssClass: 'fa fa-viacoin', title: 'viacoin' }, { cssClass: 'fa fa-viadeo', title: 'viadeo' }, { cssClass: 'fa fa-viadeo-square', title: 'viadeo-square' }, { cssClass: 'fa fa-video-camera', title: 'video-camera' }, { cssClass: 'fa fa-vimeo', title: 'vimeo' }, { cssClass: 'fa fa-vimeo-square', title: 'vimeo-square' }, { cssClass: 'fa fa-vine', title: 'vine' }, { cssClass: 'fa fa-vk', title: 'vk' }, { cssClass: 'fa fa-volume-control-phone', title: 'volume-control-phone' }, { cssClass: 'fa fa-volume-down', title: 'volume-down' }, { cssClass: 'fa fa-volume-off', title: 'volume-off' }, { cssClass: 'fa fa-volume-up', title: 'volume-up' }, { cssClass: 'fa fa-warning', title: 'warning' }, { cssClass: 'fa fa-wechat', title: 'wechat' }, { cssClass: 'fa fa-weibo', title: 'weibo' }, { cssClass: 'fa fa-weixin', title: 'weixin' }, { cssClass: 'fa fa-whatsapp', title: 'whatsapp' }, { cssClass: 'fa fa-wheelchair', title: 'wheelchair' }, { cssClass: 'fa fa-wheelchair-alt', title: 'wheelchair-alt' }, { cssClass: 'fa fa-wifi', title: 'wifi' }, { cssClass: 'fa fa-wikipedia-w', title: 'wikipedia-w' }, { cssClass: 'fa fa-window-close', title: 'window-close' }, { cssClass: 'fa fa-window-close-o', title: 'window-close-o' }, { cssClass: 'fa fa-window-maximize', title: 'window-maximize' }, { cssClass: 'fa fa-window-minimize', title: 'window-minimize' }, { cssClass: 'fa fa-window-restore', title: 'window-restore' }, { cssClass: 'fa fa-windows', title: 'windows' }, { cssClass: 'fa fa-won', title: 'won' }, { cssClass: 'fa fa-wordpress', title: 'wordpress' }, { cssClass: 'fa fa-wpbeginner', title: 'wpbeginner' }, { cssClass: 'fa fa-wpexplorer', title: 'wpexplorer' }, { cssClass: 'fa fa-wpforms', title: 'wpforms' }, { cssClass: 'fa fa-wrench', title: 'wrench' }, { cssClass: 'fa fa-xing', title: 'xing' }, { cssClass: 'fa fa-xing-square', title: 'xing-square' }, { cssClass: 'fa fa-y-combinator', title: 'y-combinator' }, { cssClass: 'fa fa-y-combinator-square', title: 'y-combinator-square' }, { cssClass: 'fa fa-yahoo', title: 'yahoo' }, { cssClass: 'fa fa-yc', title: 'yc' }, { cssClass: 'fa fa-yc-square', title: 'yc-square' }, { cssClass: 'fa fa-yelp', title: 'yelp' }, { cssClass: 'fa fa-yen', title: 'yen' }, { cssClass: 'fa fa-yoast', title: 'yoast' }, { cssClass: 'fa fa-youtube', title: 'youtube' }, { cssClass: 'fa fa-youtube-play', title: 'youtube-play' }, { cssClass: 'fa fa-youtube-square', title: 'youtube-square' }];
            scope.filterIcon = function (title) {
                if (scope.search.length > 1) {
                    return title.indexOf(scope.search) !== -1;
                }

                return true;
            };
            scope.setCurrentIcon = function ($index) {
                scope.selectedIcon = $index;
                scope.icon = scope.icons[$index];
            };

            var listener = scope.$watch('icon', function (newVal) {
                if (newVal && newVal.cssClass) {
                    scope.data = newVal.cssClass;
                }
            });

            scope.$on('$destroy', function () {
                listener();
            });
        }
    };
}]);

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* injects from baggage-loader */



var marginDirectiveModule = angular.module('margin.setting', []);

marginDirectiveModule.directive('marginSetting', ['$window', '$timeout', '$compile', '$templateCache', function ($window, $timeout, $compile, $templateCache) {
  return {
    restrict: 'A',
    scope: {
      data: '=ngModel',
      afterChange: '&'
    },
    templateUrl: settingFolder + '/margin/template.jade',
    link: function link(scope, element, attrs, ngModel) {
      var listener, marginSplit;

      if (!scope.data) {
        scope.data = '0 auto';
      }

      marginSplit = scope.data.split(' ');

      var top = parseInt(marginSplit[0]);
      var right = parseInt(marginSplit[1]);
      var bottom = parseInt(marginSplit[2] || marginSplit[0]);
      var left = parseInt(marginSplit[3] || marginSplit[1]);

      scope.margin = {
        top: isNaN(top) ? '' : top,
        right: isNaN(right) ? '' : right,
        bottom: isNaN(bottom) ? '' : bottom,
        left: isNaN(left) ? '' : left
      };

      listener = scope.$watchCollection('margin', function (newVal) {
        var top = newVal.top !== '' && newVal.top !== null ? newVal.top + '%' : 'auto';
        var right = newVal.right !== '' && newVal.right !== null ? newVal.right + '%' : 'auto';
        var bottom = newVal.bottom !== '' && newVal.bottom !== null ? newVal.bottom + '%' : 'auto';
        var left = newVal.left !== '' && newVal.left !== null ? newVal.left + '%' : 'auto';

        scope.data = top + ' ' + right + ' ' + bottom + ' ' + left;

        if (scope.afterChange) {
          scope.afterChange();
        }
      });

      scope.$on('$destroy', function () {
        listener();
      });
    }
  };
}]);

/***/ }),
/* 57 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

var moduleAlert = angular.module('create.link.controller', []);
moduleAlert.controller('LinkCreateModal', ["$scope", "$state", "$modalInstance", "$stateParams", "parentId", "widget", "$filter", function ($scope, $state, $modalInstance, $stateParams, parentId, widget, $filter) {
  $scope.newlink = {
    click_action: "open_link",
    name: "",
    link_href_target: "blank"
  };

  $scope.create = function (newlink, form) {
    if (form.$invalid) {
      return false;
    }

    if (parentId) {
      newlink.has_parent = true;
      newlink.parent_id = parentId;
    }

    addLinkToCollection(newlink);
    $scope.close();
  };

  $scope.pageSelect = function (path) {
    $scope.newlink.url = "/" + angular.copy(path);
  };

  var addLinkToCollection = function addLinkToCollection(link) {
    console.log({ widget: widget, link: link });

    if (link.has_parent) {
      var list = _.filter(widget.links_attributes, { id: link.parent_id });
      var index = widget.links_attributes.indexOf(list[0]);

      if (index > -1) {
        link.position = widget.links_attributes.length;
        return widget.links_attributes[index].links_attributes.push(link);
      }
    } else {
      link.position = widget.links_attributes.length;
      return widget.links_attributes.push(link);
    }
  };

  $scope.close = function () {
    $modalInstance.dismiss("close");
  };
}]);

/***/ }),
/* 58 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

var moduleAlert = angular.module('update.link.controller', []);

moduleAlert.controller('LinkUpdateModal', ["$scope", "$state", "$rootScope", "$modalInstance", "$stateParams", "link", "widget", function ($scope, $state, $rootScope, $modalInstance, $stateParams, link, widget) {
  $scope.editlink = link;
  $scope.widget = widget;

  $scope.save = function (editlink, form) {
    if (form.$invalid) {
      return false;
    }
    $scope.close();
  };

  $scope.pageSelect = function (path) {
    $scope.editlink.url = "/" + angular.copy(path);
  };

  $scope.deleteLink = function () {
    $scope.editlink._destroy = true;
    $scope.close();
  };

  $scope.linksLength = function () {
    var destroyed = _.filter(widget.links_attributes, {
      _destroy: true
    });
    return widget.links_attributes.length - destroyed.length;
  };

  $scope.close = function () {
    $modalInstance.dismiss("close");
  };
}]);

/***/ }),
/* 59 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

var navigationFieldsDirective = angular.module('navigationfields.setting', []);

navigationFieldsDirective.directive("navigationFieldsSetting", ["$window", "$timeout", "$compile", "$templateCache", "ns", "translitService", "Widget", "blockEditDialog", "$rootScope", "$state", "Modal", function ($window, $timeout, $compile, $templateCache, ns, translitService, Widget, blockEditDialog, $rootScope, $state, Modal) {
  return {
    restrict: "A",
    scope: {
      data: "=ngModel"
    },
    templateUrl: settingFolder + "/navigationfields/template.jade",
    link: function link(scope, element, attrs, ngModel) {
      var id = attrs.widgetId;
      var widgetElWrapper = angular.element("[data-block-id=" + id + "]").find(ns.widgetWrapperClass);

      scope.createLink = Modal.createLink;
      scope.editLink = Modal.editLink;
      scope.treeOptions = {
        dropped: function dropped(e) {
          _.each(scope.data.links_attributes, function (node, index) {
            if (node._destroy) {
              index--;
            }
            node.has_parent = false;
            node.parent_id = null;
            node.position = index;
            _.each(node.links_attributes, function (node2, index2) {
              if (node2._destroy) {
                index--;
              }
              node2.position = index2;
              if (node2.id === e.source.nodeScope.$modelValue.id) {
                node2.parent_id = node.id;
                node2.has_parent = true;
              }
            });
          });
        }
      };
      scope.deleteLink = function (link) {
        link._destroy = true;
      };
      scope.linksLength = function () {
        var destroyed = _.filter(scope.data.links_attributes, {
          _destroy: true
        });
        return scope.data.links_attributes.length - destroyed.length;
      };

      /**
       * Переустановка позиций у ссылок
       * @param newVal
       */
      var reorderLinks = function reorderLinks(newVal) {
        _.each(newVal.links_attributes, function (link, index) {
          link.position = index;
          _.each(link.links_attributes, function (sublink, index) {
            sublink.position = index;
          });
        });
      };

      /**
       * Рендер ссылок
       * @param newVal
       */
      var renderLinks = function renderLinks(newVal) {
        widgetElWrapper.find("ul:first").html("");

        _.each(newVal.links_attributes, function (link) {
          var linkHTML = "";
          var sublinksHTML = "";

          if (!link._destroy) {
            _.each(link.links_attributes, function (sublink) {
              if (!sublink._destroy) {
                sublinksHTML += "<li class='str-nav__li'>" + "<a class='str-nav__a' href='javascript: void(0)'>" + sublink.name + "</a>" + "</li>";
              }
            });

            linkHTML = "<li class='str-nav__li str-nav__li_inline'>" + "<a class='str-nav__a' href='javascript: void(0)'>" + link.name + "</a>" + "<ul class='str-nav__list'>" + sublinksHTML + "</ul>" + "</li>";
          }

          widgetElWrapper.find("ul:first").append(linkHTML);
        });
      };

      /**
       * Установка стилей для ссылок
       * @param newVal
       */
      var setLinksStyle = function setLinksStyle(newVal) {
        widgetElWrapper.find(".str-nav__a").css(newVal);
      };

      var listener1 = scope.$watch("data", function (newVal, oldVal) {
        reorderLinks(newVal);
        renderLinks(newVal);
        setLinksStyle(newVal.link_style);
      }, true);

      scope.$on("$destroy", function () {
        return listener1();
      });
    }
  };
}]);

/***/ }),
/* 60 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

var modulePhotoLibrary = angular.module('photolibrary.controller', []);

modulePhotoLibrary.controller("PhotoLibraryCtrl", ["$scope", "$rootScope", "$timeout", "Widget", "$modalInstance", "widget", "$filter", function ($scope, $rootScope, $timeout, Widget, $modalInstance, widget, $filter) {

  $scope.photolibrary = { currentSettings: 'categories' };
  $scope.widget = widget;

  var getTagsAndImages = function getTagsAndImages() {
    Widget.getImagesTags().then(function (tags) {
      $scope.tags = tags;
      $scope.getImagesByTag($scope.tags[0], void 0);
      $scope.selectedCategory = $scope.tags[0];
    });
  };

  $scope.getImagesByTag = function (tag) {
    $scope.imagesLoading = true;
    Widget.getImagesByTag(tag, void 0).then(function (imagesData) {
      $scope.imagesData = imagesData;
      $scope.imagesLoading = false;
    });
  };

  $scope.chooseImage = function (image) {
    $modalInstance.close(document.location.origin + image.image_attributes.source_url);
  };

  $scope.getWidgetTagName = function (widget) {
    var widgetTag = null;
    if (widget.tag) {
      widgetTag = widget.tag;

      if (widget.type && widget.type === 'list') {
        widgetTag = $filter('translate')('widget.tags.bullets');
      }
    }

    return widgetTag;
  };

  $scope.scrollDisabled = false;
  $scope.getNextImages = function () {
    if ($scope.imagesData.pagination.itemCount <= $scope.imagesData.images.length) {
      return false;
    }
    var lastId = $scope.imagesData.images[$scope.imagesData.images.length - 1].id;
    $scope.scrollDisabled = true;

    Widget.getImagesByTag($scope.selectedCategory, lastId).then(function (imagesData) {
      $scope.imagesData.images = $scope.imagesData.images.concat(imagesData.images);
      $scope.scrollDisabled = imagesData.images.length === 0;
    });
  };

  if (widget.tag) {
    $scope.photolibrary.currentSettings = 'forsite';

    var widgetTag = $scope.getWidgetTagName(widget);
    $scope.getImagesByTag(widgetTag, true);
    Widget.getImagesTags().then(function (tags) {
      $scope.tags = tags;
      $scope.selectedCategory = $scope.tags[0];
    });
  } else {
    getTagsAndImages();
  }
}]);

/***/ }),
/* 61 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

var photolibraryDirective = angular.module('photolibrary.setting', []);

photolibraryDirective.directive("photoLibrary", ["$window", "$timeout", "$compile", "$templateCache", "ns", "translitService", "Modal", "$modal", "Widget", "blockEditDialog", function ($window, $timeout, $compile, $templateCache, ns, translitService, Modal, $modal, Widget, blockEditDialog) {
  return {
    restrict: "A",
    scope: {
      data: "=ngModel",
      afterChange: '&'
    },
    templateUrl: settingFolder + "/photo-library/template.jade",
    link: function link(scope, element, attrs, ngModel) {

      var setToObject = function setToObject(obj, value, path) {
        path = path.split('.');
        var i = 0;
        while (i < path.length - 1) {
          obj = obj[path[i]];
          i++;
        }
        obj[path[i]] = value;
      };

      scope.photoLibraryModal = function () {
        var modalInstance = $modal.open({
          windowTemplateUrl: "./common/templates/window.jade",
          templateUrl: "./editor/modules_settings/photo-library/modal.jade",
          windowClass: "site-settings__modal",
          size: "md",
          controller: "PhotoLibraryCtrl",
          resolve: {
            widget: function widget() {
              return scope.data;
            }
          }
        });

        modalInstance.result.then(function (image_url) {
          var remoteAttr = attrs.accessKey + "." + attrs.remoteKey;
          setToObject(scope.data, image_url, remoteAttr);

          var currentAttr = attrs.accessKey + "." + attrs.currentKey;
          setToObject(scope.data, image_url, currentAttr);

          if (scope.afterChange) {
            scope.afterChange();
          }
        });
      };
    }
  };
}]);

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* injects from baggage-loader */



var productFieldsDirective = angular.module('product.setting', []);

productFieldsDirective.filter('toArray', ['$timeout', function ($timeout) {
  return function (obj) {
    var result = [];
    _.each(obj, function (val, hash) {
      return result.push({
        name: val,
        value: hash
      });
    });
    return result;
  };
}]);

productFieldsDirective.directive('productFieldsSetting', ['$window', '$timeout', '$compile', '$templateCache', 'ns', 'translitService', 'ContentEditable', 'Widget', 'blockEditDialog', 'Slider', '$rootScope', function ($window, $timeout, $compile, $templateCache, ns, translitService, ContentEditable, Widget, blockEditDialog, Slider, $rootScope) {
  return {
    restrict: 'A',
    scope: {
      data: '=ngModel'
    },
    templateUrl: settingFolder + '/productfields/template.jade',
    link: function link(scope, element, attrs, ngModel) {
      var id = attrs.widgetId;
      var widgetElWrapper = angular.element('[data-block-id=' + id + ']').find(ns.widgetWrapperClass);
      var sectionId = blockEditDialog.getSectionId({ id: id });

      scope.product = angular.copy(scope.data);
      scope.Editor = angular.copy(window.Editor);
      scope.productTypes = [{
        item_type: 'image',
        title: 'widget.product.elementType1'
      }, {
        item_type: 'text',
        title: 'widget.product.elementType2'
      }, {
        item_type: 'button',
        title: 'widget.product.elementType3'
      }, {
        item_type: 'list',
        title: 'widget.product.elementType4'
      }];

      var sortProductItems = function sortProductItems() {
        var product_items_ids = [];
        var ref = scope.product.product_items_attributes;

        for (var index = 0, i = 0, len = ref.length; i < len; index = ++i) {
          var product_item = ref[index];

          product_item.position = index;
          if (product_item.id) {
            product_items_ids.push(product_item.id);
          }
        }

        return Widget.sortProductItems(attrs.widgetId, product_items_ids);
      };

      var trimNbsp = function trimNbsp(fields) {
        var field, i, len;
        for (i = 0, len = fields.length; i < len; i++) {
          field = fields[i];
          field.text = field.text.replace(/&nbsp;/gi, '');
        }
        return fields;
      };

      var getNotDestroyedFieldRnd = function getNotDestroyedFieldRnd() {
        var fields;
        fields = [];
        _.each(scope.product.product_items_attributes, function (field, index) {
          if (!field._destroy) {
            return fields.push(index);
          }
        });
        if (fields.length > 0) {
          return fields[fields.length - 1];
        } else {
          return 0;
        }
      };

      var setItemsStyles = function setItemsStyles(newVal) {
        _.each(newVal, function (item) {
          widgetElWrapper.find('.strwcrd-item-' + item.id).find('.strwcrd__image-wrapper').css(item.image_style_attributes);
          widgetElWrapper.find('.strwcrd-item-' + item.id).find('.strwcrd__image-wrapper').css({
            height: item.image_wrapper_height
          });
          widgetElWrapper.find('.strwcrd-item-' + item.id).find('.strwcrd__title').css(item.text_style_attributes);
          widgetElWrapper.find('.strwcrd-item-' + item.id).find('.strwcrd__button').css(item.button_attributes.style_attributes);
          return widgetElWrapper.find('.strwcrd-item-' + item.id).find('.strbw_list-item__caption').css(item.caption_style_attributes);
        });
        return widgetElWrapper.find('.strwcrd').css(scope.data.wrapper_style);
      };

      var renderProduct = function renderProduct() {
        var allHtml = "<div class='strwcrd'>";
        _.each(scope.product.product_items_attributes, function (item, index) {
          var itemHtml = void 0;
          var imageHtml = '';
          var imageWithStretch = '';
          var textHtml = '';
          var buttonHtml = '';
          var listHtml = '';

          if (!item._destroy) {
            if (item.item_type === 'image') {
              imageHtml = "<div class='strwcrd__image-size'><div class='strwcrd__image-wrapper strwcrd__image-no-cover'><img class='strwcrd__image' src='" + item.file_url + "'></div></div>";
              imageWithStretch = "<div class='strwcrd__image-size'><div class='strwcrd__image-wrapper strwcrd__image-no-cover'><div class='strwcrd__image strwcrd__image_cover' style='background-image: url(" + item.file_url + ")'></div></div></div>";
            }
            if (item.item_type === 'text') {
              textHtml = "<span class='strwcrd__title' contenteditable='false' spellcheck='false' data-access='product_items_attributes." + index + ".text'>" + item.text + "</span>";
            }
            if (item.item_type === 'button') {
              buttonHtml = "<a href='" + item.button_attributes.scroll_section_id + "' contenteditable='false' spellcheck='false' data-access='product_items_attributes." + index + ".button_attributes.value' class='link-anchor strwcrd__button'>" + item.button_attributes.value + "</a>";
            }
            if (item.item_type === 'list') {
              listHtml = "<ul class='strbw_list strbw_list-card'>";
              _.each(item.rows_attributes, function (row, rowindex) {
                if (!row._destroy) {
                  listHtml += "<li data-item-id='" + row.id + "' style='background-image:url(" + item.bullet_url + ")'><span class='strbw_list-item__caption' contenteditable='false' data-access='product_items_attributes." + index + ".rows_attributes." + rowindex + ".caption'>" + row.caption + "</span></li>";
                }
              });
              listHtml += "</ul>";
            }
          }
          itemHtml = "<div class='strwcrd-item strwcrd-item-" + item.id + "'> " + imageHtml + " " + textHtml + " " + buttonHtml + " " + listHtml + " </div>";
          allHtml += itemHtml;
        });
        allHtml += "</div>";

        widgetElWrapper.html(allHtml);
        setItemsStyles(scope.product.product_items_attributes);
        ContentEditable.bind(false, true, id);
      };

      scope.treeOptions = {
        dropped: function dropped() {
          $timeout(function () {
            sortProductItems();
            renderProduct();
          });
        }
      };
      scope.currentField = getNotDestroyedFieldRnd();
      scope.setCurrentField = function (index) {
        scope.currentField = void 0;
        $timeout(function () {
          scope.currentField = index;
        });
      };
      scope.add = function () {
        var params = {
          product_items_attributes: [{
            remote_file_url: 'http://api.siter.io/assets/widgets/link/img.jpg',
            item_type: 'text',
            position: scope.product.product_items_attributes.length + 1
          }]
        };
        scope.addingField = true;
        return sortProductItems().then(function () {
          Widget.createItem(sectionId, id, params).then(function (data) {
            var length, newSlide;
            newSlide = data.product_items_attributes[data.product_items_attributes.length - 1];
            scope.product.product_items_attributes.push(newSlide);
            length = scope.product.product_items_attributes.length;
            scope.setCurrentField(data.product_items_attributes.length - 1);
            scope.addingField = false;
            return renderProduct();
          });
          return ContentEditable.bind(false, true, id);
        });
      };

      scope.renderProduct = renderProduct;
      scope.fieldsLength = function (fields) {
        var destroyed;
        destroyed = _.filter(fields, {
          _destroy: true
        });
        return fields.length - destroyed.length;
      };
      scope.remove = function () {
        var index;
        index = scope.product.product_items_attributes.indexOf(scope.product.product_items_attributes[scope.currentField]);
        if (index > -1) {
          Widget.destroyProductItem(scope.product.id, scope.product.product_items_attributes[scope.currentField].id).then(sortProductItems);
          scope.product.product_items_attributes.splice(index, 1);
          scope.currentField = getNotDestroyedFieldRnd();
        }
        return renderProduct();
      };

      var listener1 = scope.$watch('product.product_items_attributes', function (newVal, oldVal) {
        scope.data.product_items_attributes = trimNbsp(newVal);
        setItemsStyles(newVal);
        return ContentEditable.bind(false, true, id);
      }, true);

      var listener2 = scope.$watch('data.wrapper_style', function (newVal, oldVal) {
        scope.data.wrapper_style = scope.product.wrapper_style;
        return widgetElWrapper.find('.strwcrd').css(scope.data.wrapper_style);
      }, true);

      scope.$on('$destroy', function () {
        listener1();
        listener2();
      });
    }
  };
}]);

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* injects from baggage-loader */



var shadowDirectiveModule = angular.module('shadow.setting', []);

shadowDirectiveModule.directive('shadowSetting', ['$window', '$timeout', '$compile', '$templateCache', function ($window, $timeout, $compile, $templateCache) {
  return {
    restrict: 'A',
    scope: {
      data: '=ngModel',
      afterChange: '&'
    },
    templateUrl: settingFolder + '/shadow/template.jade',
    link: function link(scope, element, attrs, ngModel) {
      if (!scope.data) {
        scope.data = '0px 0px 0px 0px rgba(204, 204, 204, 1)';
      }

      var shadowSplit = scope.data.split(' ');
      var rgbaIndex = scope.data.indexOf('rgba');
      var rgbaColor = scope.data.slice(rgbaIndex);

      scope.shadow = {
        offsetX: parseInt(shadowSplit[0]),
        offsetY: parseInt(shadowSplit[1]),
        blur: parseInt(shadowSplit[2]),
        spread: parseInt(shadowSplit[3]),
        color: rgbaColor
      };

      var listener = scope.$watchCollection('shadow', function (newVal) {
        var offsetX = newVal.offsetX || 0;
        var offsetY = newVal.offsetY || 0;
        var blur = newVal.blur || 0;
        var spread = newVal.spread || 0;
        var color = newVal.color || 'rgba(204, 204, 204, 1)';

        scope.data = offsetX + 'px ' + offsetY + 'px ' + blur + 'px ' + spread + 'px ' + color;

        if (scope.afterChange) {
          scope.afterChange();
        }
      });

      scope.$on('$destroy', function () {
        listener();
      });
    }
  };
}]);

/***/ }),
/* 64 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

var subscribeFormDirective = angular.module('subscribeForm.setting', []);

subscribeFormDirective.directive("subscribeFormSetting", ["$window", "$timeout", "$compile", "$templateCache", "ns", "translitService", "$rootScope", "$filter", "SubscribeFormManager", function ($window, $timeout, $compile, $templateCache, ns, translitService, $rootScope, $filter, SubscribeFormManager) {
  return {
    restrict: "A",
    scope: {
      data: "=ngModel"
    },
    link: function link(scope, element, attrs, ngModel) {

      var id = attrs.widgetId;
      var widgetElWrapper = angular.element("[data-block-id=" + id + "]").find(ns.widgetWrapperClass);
      var SUM_FIELD = 'orderData[bill_sum]';

      scope.accordion = {
        show_form: false,
        show_parent_button: false,
        show_button: false,
        show_action: false
      };

      scope.data = SubscribeFormManager.updateOptions(scope.data);

      scope.data.stripe_key = window.justclick.stripePublicKey;
      scope.data.product_currency = window.justclick.currencySymbol;
      scope.data.service_domain = window.justclick.serviceDomain || "";
      scope.data.after_activate_url_placeholder = "https://" + window.location.host + "/subscribe/confirmdone/";
      scope.data.redirect_url_placeholder = "https://" + window.location.host + "/subscribe/done/";

      if (Editor.mode === 'form.page.editor' && !!window.justclick.disableFormSettings) {
        scope.$parent.openTab('blockDesign');
      }

      var findFileldIndexByAttr = function findFileldIndexByAttr(fields, attribute) {
        var field = _.filter(fields, attribute)[0];
        return fields.indexOf(field);
      };

      var setSelectedFirstProduct = function setSelectedFirstProduct(products) {
        var i = void 0,
            index = void 0,
            len = void 0;
        var categoryIndex = 0;
        var results = [];

        var _loop = function _loop() {
          var category = products[index];
          if (index === categoryIndex) {
            if (category.hasOwnProperty("goods")) {
              results.push(function () {
                var j = void 0,
                    len1 = void 0;
                var results1 = [];
                var ref = category.goods;
                for (index = j = 0, len1 = ref.length; j < len1; index = ++j) {
                  var good = ref[index];
                  if (index === 0) {
                    results1.push(good.selected = true);
                  } else {
                    results1.push(void 0);
                  }
                }
                return results1;
              }());
            } else {
              results.push(categoryIndex++);
            }
          } else {
            results.push(void 0);
          }
        };

        for (index = i = 0, len = products.length; i < len; index = ++i) {
          _loop();
        }
        return results;
      };

      var getProductsArray = function getProductsArray(goods) {
        var productsArr = [];
        _.each(goods, function (good) {
          if (good.hasOwnProperty("name") && good.selected) {
            productsArr.push(good);
          }
          if (good.hasOwnProperty("goods") && good.goods.length > 0) {
            return productsArr = productsArr.concat(getProductsArray(good.goods));
          }
        });
        return productsArr;
      };

      var setSelectedOldProducts = function setSelectedOldProducts(oldProducts, products) {
        var i = void 0,
            index = void 0,
            len = void 0;
        var results = [];

        var _loop2 = function _loop2() {
          var product = products[index];
          results.push(function () {
            var j = void 0,
                len1 = void 0;
            var results1 = [];
            for (j = 0, len1 = oldProducts.length; j < len1; j++) {
              var oldProduct = oldProducts[j];
              if (oldProduct.hasOwnProperty("name") && oldProduct.name === product.name && oldProduct.selected) {
                product.selected = true;
              }
              if (oldProduct.hasOwnProperty("goods") && oldProduct.goods.length > 0 && product.hasOwnProperty("goods") && product.goods.length > 0) {
                results1.push(setSelectedOldProducts(oldProduct.goods, product.goods));
              } else {
                results1.push(void 0);
              }
            }
            return results1;
          }());
        };

        for (index = i = 0, len = products.length; i < len; index = ++i) {
          _loop2();
        }
        return results;
      };

      if (scope.data.frame_settings.products && scope.data.frame_settings.products.length === 0) {
        var indexSum = findFileldIndexByAttr(scope.data.form_fields_attributes, { name: SUM_FIELD });
        if (indexSum > -1 && !!window.justclick.currencySymbol && scope.data.form_fields_attributes[indexSum].title.indexOf(',') === -1) {
          scope.data.form_fields_attributes[indexSum].title = scope.data.form_fields_attributes[indexSum].title + ', ' + window.justclick.currencySymbol;
        }
        scope.data.frame_settings.products = angular.copy(window.justclick.groups);
        setSelectedFirstProduct(scope.data.frame_settings.products);
      } else {
        var oldCategories = angular.copy(scope.data.frame_settings.products);
        scope.data.frame_settings.products = angular.copy(window.justclick.groups);
        setSelectedOldProducts(oldCategories, scope.data.frame_settings.products);
      }

      scope.data.selected_products = getProductsArray(scope.data.frame_settings.products);
      scope.data.product_selected = scope.data.submit_action === "make_order";
      scope.data.handleRadioClick = function (productSelected) {
        scope.data.product_selected = productSelected;
      };

      var listeners = [];

      listeners.push(scope.$watch("data.frame_settings.products", function (newVal) {
        scope.data.selected_products = getProductsArray(newVal);
      }, true));

      listeners.push(scope.$watch("data.submit_action", function (newVal) {
        if (newVal === 'make_order') {
          scope.data.form_design = 'vertical';
        }
      }));

      scope.$on("$destroy", function () {
        _.each(listeners, function (listener) {
          listener();
        });
      });
    }
  };
}]);

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* injects from baggage-loader */



var indexOf = [].indexOf || function (item) {
  for (var i = 0, l = this.length; i < l; i++) {
    if (i in this && this[i] === item) {
      return i;
    }
  }
  return -1;
};

var subscribeFormFieldsDirective = angular.module('subscribeFormfields.setting', []);

subscribeFormFieldsDirective.filter('toArray', ['$timeout', function ($timeout) {
  return function (obj) {
    var result;
    result = [];
    _.each(obj, function (val, hash) {
      return result.push({
        name: val,
        value: hash
      });
    });
    return result;
  };
}]);

subscribeFormFieldsDirective.directive('subscribeFormFieldsSetting', ['$window', '$timeout', '$compile', '$templateCache', 'ns', 'translitService', 'ContentEditable', 'Widget', 'blockEditDialog', '$rootScope', '$filter', function ($window, $timeout, $compile, $templateCache, ns, translitService, ContentEditable, Widget, blockEditDialog, $rootScope, $filter) {
  return {
    restrict: 'A',
    scope: {
      data: '=ngModel'
    },
    templateUrl: settingFolder + '/subscribeFormfields/template.jade',
    link: function link(scope, element, attrs, ngModel) {
      var widgetId = attrs.widgetId;

      var widgetElWrapper = angular.element('[data-block-id=' + widgetId + ']').find(ns.widgetWrapperClass);

      var DIGITAL_PRODUCT = 0;
      var PHYSICAL_PRODUCT = 1;
      var FLOATING_PRICE_PRODUCT = 2;
      var NAME_FIELD = 'lead_name';
      var EMAIL_FIELD = 'lead_email';
      var USER_FIELDS = ['lead_phone', 'lead_middle_name', 'lead_last_name', 'lead_city', 'lead_offert', 'orderData[offerta_accept]'];
      var PRODUCT_PRICE_FIELD = 'product_price';
      var SUM_FIELD = 'orderData[bill_sum]';
      var KUPON_FIELD = 'orderData[bill_kupon]';
      var ADDRESS_FIELD = 'orderData[bill_hide_shipping_address]';
      var ADDRESS_FIELDS = ['orderData[bill_billing_country]', 'orderData[bill_billing_address]', 'orderData[bill_billing_address2]', 'orderData[bill_billing_city]', 'orderData[bill_billing_state]', 'orderData[bill_billing_zip]'];
      var DELIVERY_ADDRESS_FIELDS = ['orderData[bill_shipping_name]', 'orderData[bill_shipping_phone]', 'orderData[bill_country]', 'orderData[bill_address]', 'orderData[bill_address2]', 'orderData[bill_city]', 'orderData[bill_region]', 'orderData[bill_postal_code]'];
      var STRIPE_FIELD = 'stripe';
      var CLOUD_PAYMENTS_FIELD = 'cloudpayments';
      var CONTACT_INFO_FIELD = 'contact_info';

      var stripeEnabled = !!window.justclick.isStripeEnabled;
      var cloudpaymentEnabled = !!window.justclick.isCloudPaymentsEnabled;
      var ignoreSelectedProducts = !!window.justclick.ignoreSelectedProducts;
      var disableChangeEmailField = !!window.justclick.disableChangeEmailField;
      var disableChangeStripeField = stripeEnabled && ignoreSelectedProducts;
      var disableChangeCloudpaymentField = cloudpaymentEnabled && ignoreSelectedProducts;

      /**
       * findFieldIndexByAttr
       * @param fields
       * @param attribute
       * @returns {*}
       */
      var findFieldIndexByAttr = function findFieldIndexByAttr(fields, attribute) {
        var field = _.filter(fields, attribute)[0];
        return fields.indexOf(field);
      };

      /**
       * findFieldByAttr
       * @param fields
       * @param attribute
       * @returns {null|*}
       */
      var findFieldByAttr = function findFieldByAttr(fields, attribute) {
        var index = findFieldIndexByAttr(fields, attribute);

        if (index > -1) {
          return fields[index];
        } else {
          return null;
        }
      };

      var fieldExist = function fieldExist(field_) {
        var field, j, len1, ref;
        ref = scope.form.form_fields_attributes;
        for (j = 0, len1 = ref.length; j < len1; j++) {
          field = ref[j];
          if (field_.name === field.name) {
            return true;
          }
        }
        return false;
      };

      var newFieldsAdded = false;
      // todo: Впоследствии удалить, либо преобразовать в отедельный класс
      // Генерация полей для формы, чтобы поддержать обратную совместимость
      // Обновляет массив scope.data.form_fields_attributes
      (function () {
        var genDefaultField = function genDefaultField(type, name, placeholder, title, show, exist, invisible) {
          return {
            checked: true,
            invisible: invisible,
            disable: false,
            exist: exist,
            field_type: type,
            hidden: false,
            link_href_target: 'blank',
            name: name,
            offert: false,
            offert_target_blank: false,
            offert_text: '',
            offert_url: 'http://',
            offert_url_text: '',
            options_countries: '',
            options_created: false,
            options_raw: null,
            options_states_of_usa: '',
            placeholder: placeholder,
            required: true,
            show: show,
            title: title,
            unique: false,
            validation: false,
            value: ''
          };
        };
        var indexAddressField = findFieldIndexByAttr(scope.data.form_fields_attributes, { name: ADDRESS_FIELD });
        var addressField = scope.data.form_fields_attributes[indexAddressField];
        var addressFieldExist = addressField.exist;
        var deliveryFields = [{
          type: 'text',
          name: ADDRESS_FIELDS[2],
          placeholder: $filter('translate')('widget.form.your_apt'),
          title: $filter('translate')('widget.form.address_2'),
          exist: false,
          invisible: false,
          show: true
        }, {
          type: 'text',
          name: DELIVERY_ADDRESS_FIELDS[0],
          placeholder: $filter('translate')('widget.form.lead_name_placeholder'),
          title: $filter('translate')('widget.form.shipping_name'),
          exist: false,
          invisible: true,
          show: false
        }, {
          type: 'text',
          name: DELIVERY_ADDRESS_FIELDS[1],
          placeholder: $filter('translate')('widget.form.lead_phone_placeholder'),
          title: $filter('translate')('widget.form.shipping_phone'),
          exist: false,
          invisible: true,
          show: false
        }, {
          type: 'select',
          name: DELIVERY_ADDRESS_FIELDS[2],
          placeholder: $filter('translate')('widget.form.country'),
          title: $filter('translate')('widget.form.shipping_country'),
          exist: false,
          invisible: true,
          show: false
        }, {
          type: 'text',
          name: DELIVERY_ADDRESS_FIELDS[3],
          placeholder: $filter('translate')('widget.form.your_street'),
          title: $filter('translate')('widget.form.shipping_address_1'),
          exist: false,
          invisible: true,
          show: false
        }, {
          type: 'text',
          name: DELIVERY_ADDRESS_FIELDS[4],
          placeholder: $filter('translate')('widget.form.your_apt'),
          title: $filter('translate')('widget.form.shipping_address_2'),
          exist: false,
          invisible: true,
          show: false
        }, {
          type: 'text',
          name: DELIVERY_ADDRESS_FIELDS[5],
          placeholder: $filter('translate')('widget.form.city_placeholder'),
          title: $filter('translate')('widget.form.shipping_city'),
          exist: false,
          invisible: true,
          show: false
        }, {
          type: 'text',
          name: DELIVERY_ADDRESS_FIELDS[6],
          placeholder: $filter('translate')('widget.form.state_placeholder'),
          title: $filter('translate')('widget.form.shipping_state'),
          exist: false,
          invisible: true,
          show: false
        }, {
          type: 'text',
          name: DELIVERY_ADDRESS_FIELDS[7],
          placeholder: $filter('translate')('widget.form.zip_placeholder'),
          title: $filter('translate')('widget.form.shipping_zip'),
          exist: false,
          invisible: true,
          show: false
        }];

        deliveryFields.map(function (field) {
          var type = field.type,
              name = field.name,
              exist = field.exist,
              show = field.show,
              placeholder = field.placeholder,
              title = field.title,
              invisible = field.invisible;


          if (addressFieldExist && DELIVERY_ADDRESS_FIELDS.includes(name)) {
            show = true;
            exist = true;
          }

          if (findFieldIndexByAttr(scope.data.form_fields_attributes, { name: name }) === -1) {
            var _field = genDefaultField(type, name, placeholder, title, show, exist, invisible);

            scope.data.form_fields_attributes.push(_field);
            newFieldsAdded = true;
          }
        });
      })();

      /**
       * Селект групп
       * todo: Впоследствии оптимизировать код, текущий вариант это прямое преобразование coffee script в js практически без рефакторинга
       * @param type
       * @returns {*[]}
       */
      var setSelectedOldGroups = function setSelectedOldGroups(type) {
        var group = void 0,
            oc = void 0,
            ocgroup = void 0,
            oldcategory = void 0;

        var oldCategories = angular.copy(scope.data[type]);
        scope.data[type] = angular.copy(window.justclick.formCategories);
        var ref = scope.data[type];

        var results = [];
        for (var i = 0, len = ref.length; i < len; i++) {
          oldcategory = ref[i];
          results.push(function () {
            var ref1 = oldcategory.groups;
            var results1 = [];
            for (var j = 0, len1 = ref1.length; j < len1; j++) {
              group = ref1[j];
              results1.push(function () {
                var results2 = [];
                for (var k = 0, len2 = oldCategories.length; k < len2; k++) {
                  oc = oldCategories[k];
                  results2.push(function () {
                    var ref2 = oc.groups;
                    var results3 = [];
                    for (var l = 0, len3 = ref2.length; l < len3; l++) {
                      ocgroup = ref2[l];
                      if (group.name === ocgroup.name && ocgroup.selected) {
                        results3.push(group.selected = true);
                      } else {
                        results3.push(void 0);
                      }
                    }
                    return results3;
                  }());
                }
                return results2;
              }());
            }
            return results1;
          }());
        }
        return results;
      };

      /**
       * Заполним поля с странами данными
       * @param indexCountry
       * @param countries
       */
      var updateCountries = function updateCountries(indexCountry, countries) {
        if (indexCountry > 0) {
          scope.data.form_fields_attributes[indexCountry].options_raw = '';

          for (var i = 0, len = countries.length; i < len; i++) {
            var country = countries[i];
            if (country.title) {
              scope.data.form_fields_attributes[indexCountry].options_raw += '\n' + country.title;
            }
          }

          scope.data.form_fields_attributes[indexCountry].options_countries = JSON.stringify(countries);
        }
      };

      /**
       * Заполним поля с штатами данными
       * @param indexState
       * @param states
       */
      var updateStates = function updateStates(indexState, states) {
        if (indexState > -1) {
          scope.data.form_fields_attributes[indexState].options_states_of_usa = JSON.stringify(states);
        }
      };

      var indexCountry = findFieldIndexByAttr(scope.data.form_fields_attributes, { name: ADDRESS_FIELDS[0] });
      var indexDeliveryCountry = findFieldIndexByAttr(scope.data.form_fields_attributes, { name: DELIVERY_ADDRESS_FIELDS[2] });
      var indexState = findFieldIndexByAttr(scope.data.form_fields_attributes, { name: ADDRESS_FIELDS[4] });
      var indexDeliveryState = findFieldIndexByAttr(scope.data.form_fields_attributes, { name: DELIVERY_ADDRESS_FIELDS[6] });

      updateCountries(indexCountry, window.justclick.countries);
      updateCountries(indexDeliveryCountry, window.justclick.countries);

      updateStates(indexState, window.justclick.statesOfUSA);
      updateStates(indexDeliveryState, window.justclick.statesOfUSA);

      if (scope.data.categories && scope.data.categories.length === 0) {
        scope.data.categories = angular.copy(window.justclick.formCategories);
      } else {
        // Выбор групп для добавления
        setSelectedOldGroups('categories');
      }

      if (scope.data.ex_categories.length === 0) {
        scope.data.ex_categories = angular.copy(window.justclick.formCategories);
      } else {
        // Выбор групп для удаления
        setSelectedOldGroups('ex_categories');
      }

      scope.form = angular.copy(scope.data);

      var getNotDestroyedFieldRnd = function getNotDestroyedFieldRnd() {
        var fields;
        fields = [];
        _.each(scope.form.form_fields_attributes, function (field, index) {
          if (!field._destroy) {
            return fields.push(index);
          }
        });
        if (fields.length > 0) {
          return fields[fields.length - 1];
        } else {
          return 0;
        }
      };

      scope.currentField = getNotDestroyedFieldRnd();
      scope.setCurrentField = function (index) {
        scope.currentField = index;
      };
      scope.treeOptions = {
        dropped: function dropped(e) {
          var fieldsIds = [];

          _.each(scope.form.form_fields_attributes, function (field) {
            if (field.id) {
              return fieldsIds.push(field.id);
            }
          });

          var source = fieldsIds[e.source.index];
          fieldsIds.splice(e.source.index, 1);
          fieldsIds.splice(e.dest.index, 0, source);

          return Widget.sortSubscribeFormFields(attrs.widgetId, fieldsIds);
        }
      };
      scope.inputTypes = [{
        field_type: 'text',
        name: 'Text',
        title: $filter('translate')('widget.form.fieldType1')
      }, {
        field_type: 'number',
        name: 'Number',
        title: $filter('translate')('widget.form.fieldType2')
      }, {
        field_type: 'tel',
        name: 'Phone',
        title: $filter('translate')('widget.form.fieldType3')
      }, {
        field_type: 'email',
        name: 'Email',
        title: $filter('translate')('widget.form.fieldType4')
      }, {
        field_type: 'url',
        name: 'Url',
        title: $filter('translate')('widget.form.fieldType5')
      }, {
        field_type: 'textarea',
        name: 'Text Area',
        title: $filter('translate')('widget.form.fieldType6')
      }, {
        field_type: 'select',
        name: 'Select',
        title: $filter('translate')('widget.form.fieldType7')
      }, {
        field_type: 'checkbox',
        name: 'Checkbox',
        title: $filter('translate')('widget.form.fieldType8')
      }, {
        field_type: 'radio',
        name: 'Radio',
        title: $filter('translate')('widget.form.fieldType9')
      }];
      scope.add = function () {
        scope.form.form_fields_attributes.push({ field_type: 'text' });

        var length = scope.form.form_fields_attributes.length;
        scope.currentField = length - 1;
        scope.setTitleAsType('text');
      };
      scope.fieldsLength = function (fields) {
        var destroyed = _.filter(fields, {
          _destroy: true
        });
        return fields.length - destroyed.length;
      };
      scope.remove = function () {
        scope.form.form_fields_attributes[scope.currentField]._destroy = true;
        scope.currentField = getNotDestroyedFieldRnd();
      };

      var fieldChanged = function fieldChanged(newVal, oldVal, fieldType) {
        var field, index, j, len1;
        for (index = j = 0, len1 = newVal.length; j < len1; index = ++j) {
          field = newVal[index];
          if (oldVal[index] && field[fieldType] !== oldVal[index][fieldType]) {
            return true;
          }
        }
        return false;
      };

      var trimNbsp = function trimNbsp(fields) {
        var field, j, len1;
        for (j = 0, len1 = fields.length; j < len1; j++) {
          field = fields[j];
          field.title = field.title.replace(/&nbsp;/gi, '');
        }
        return fields;
      };

      var updateFieldsByNames = function updateFieldsByNames(fields, fieldsNames, newValues) {
        var field, j, len1, ref, results;
        results = [];
        for (j = 0, len1 = fields.length; j < len1; j++) {
          field = fields[j];
          if (ref = field.name, indexOf.call(fieldsNames, ref) >= 0) {
            results.push(_.extend(fields[findFieldIndexByAttr(fields, {
              name: field.name
            })], newValues));
          } else {
            results.push(void 0);
          }
        }
        return results;
      };

      var updateFieldByName = function updateFieldByName(fields, name, newValues) {
        return _.extend(fields[findFieldIndexByAttr(fields, {
          name: name
        })], newValues);
      };

      var updateTranslations = function updateTranslations(fields) {
        updateFieldByName(fields, KUPON_FIELD, {
          placeholder: $filter('translate')('widget.form.yourCoupon')
        });
        updateFieldByName(fields, USER_FIELDS[1], {
          title: $filter('translate')('widget.form.middleName')
        });
        updateFieldByName(fields, USER_FIELDS[2], {
          title: $filter('translate')('widget.form.lastName')
        });
        updateFieldByName(fields, PRODUCT_PRICE_FIELD, {
          title: $filter('translate')('widget.form.product')
        });
        updateFieldByName(fields, ADDRESS_FIELD, {
          title: $filter('translate')('widget.form.delivery_address')
        });
        updateFieldByName(fields, USER_FIELDS[4], {
          title: $filter('translate')('widget.form.lead_offert_title')
        });
        updateFieldByName(fields, USER_FIELDS[5], {
          title: $filter('translate')('widget.form.offerta_accept_title')
        });
        return updateFieldByName(fields, NAME_FIELD, {
          title: $filter('translate')('widget.form.name')
        });
      };

      // Показ/скрытие поля Оплата картой (Stripe)
      if (stripeEnabled && (scope.form.product_selected || ignoreSelectedProducts)) {
        updateFieldByName(scope.form.form_fields_attributes, STRIPE_FIELD, { show: true });
      } else {
        var indexStripe = findFieldIndexByAttr(scope.data.form_fields_attributes, { name: STRIPE_FIELD });
        if (scope.data.form_fields_attributes[indexStripe].exist === false) {
          updateFieldByName(scope.form.form_fields_attributes, STRIPE_FIELD, { show: false });
        }
      }

      // Показ/скрытие поля Оплата картой (CloudPayments)
      if (cloudpaymentEnabled && (scope.form.product_selected || ignoreSelectedProducts)) {
        updateFieldByName(scope.form.form_fields_attributes, CLOUD_PAYMENTS_FIELD, { show: true });
      } else {
        var indexCloudPayment = findFieldIndexByAttr(scope.data.form_fields_attributes, { name: CLOUD_PAYMENTS_FIELD });
        var cloudPaymentAttributes = scope.data.form_fields_attributes[indexCloudPayment];
        if (cloudPaymentAttributes && cloudPaymentAttributes.exist === false) {
          updateFieldByName(scope.form.form_fields_attributes, CLOUD_PAYMENTS_FIELD, {
            show: false
          });
        }
      }

      var hasFloatingPriceProduct = function hasFloatingPriceProduct(products) {
        var floatingPriceProduct = false;
        _.each(products, function (product) {
          if (product.hasOwnProperty('name') && product.type === FLOATING_PRICE_PRODUCT) {
            floatingPriceProduct = true;
          }
          if (product.hasOwnProperty('goods') && product.goods.length > 0 && !floatingPriceProduct) {
            floatingPriceProduct = hasFloatingPriceProduct(product.goods);
          }
        });
        return floatingPriceProduct;
      };

      var getUpdatedFields = function getUpdatedFields(fields) {
        if (scope.data.product_selected) {
          updateFieldByName(fields, EMAIL_FIELD, { disable: true, exist: true });
          updateFieldByName(fields, USER_FIELDS[3], { show: false, exist: false });
          updateFieldByName(fields, CONTACT_INFO_FIELD, { show: true });
          updateFieldByName(fields, PRODUCT_PRICE_FIELD, { show: true });
          updateFieldByName(fields, KUPON_FIELD, { show: true });
          updateFieldByName(fields, ADDRESS_FIELD, { show: true, hidden: false });
          updateFieldsByNames(fields, ADDRESS_FIELDS, { show: true });
          if (stripeEnabled) {
            updateFieldByName(fields, STRIPE_FIELD, { show: true });
          } else {
            updateFieldByName(fields, STRIPE_FIELD, { show: false, exist: false });
          }
          if (cloudpaymentEnabled) {
            updateFieldByName(fields, CLOUD_PAYMENTS_FIELD, { show: true });
          } else {
            updateFieldByName(fields, CLOUD_PAYMENTS_FIELD, { show: false, exist: false });
          }
        } else {
          updateFieldByName(fields, EMAIL_FIELD, { disable: false });
          updateFieldByName(fields, USER_FIELDS[3], { show: true });
          updateFieldByName(fields, CONTACT_INFO_FIELD, { show: false, exist: false });
          updateFieldByName(fields, PRODUCT_PRICE_FIELD, { show: false, exist: false });
          updateFieldByName(fields, KUPON_FIELD, { show: false, exist: false });
          updateFieldByName(fields, SUM_FIELD, { show: false, exist: false });
          updateFieldByName(fields, ADDRESS_FIELD, { show: false, exist: false });
          updateFieldsByNames(fields, ADDRESS_FIELDS, { show: false, exist: false });
          updateFieldsByNames(fields, DELIVERY_ADDRESS_FIELDS, { show: false, exist: false });
          if (stripeEnabled && ignoreSelectedProducts) {
            updateFieldByName(fields, STRIPE_FIELD, { disable: true, show: true, exist: true });
          } else {
            updateFieldByName(fields, STRIPE_FIELD, { show: false, exist: false });
          }
          if (cloudpaymentEnabled && ignoreSelectedProducts) {
            updateFieldByName(fields, CLOUD_PAYMENTS_FIELD, { disable: true, show: true, exist: true });
          } else {
            updateFieldByName(fields, CLOUD_PAYMENTS_FIELD, { show: false, exist: false });
          }
        }

        if (ignoreSelectedProducts) {
          var kuponField = findFieldByAttr(fields, { name: KUPON_FIELD });
          updateFieldByName(fields, KUPON_FIELD, { show: true, exist: kuponField.exist });
        }

        if (disableChangeEmailField) {
          updateFieldByName(fields, EMAIL_FIELD, { disable: true, show: true, exist: true });
        }

        if (disableChangeStripeField) {
          updateFieldByName(fields, STRIPE_FIELD, { disable: true, show: true, exist: true });
        }

        if (disableChangeCloudpaymentField) {
          updateFieldByName(fields, CLOUD_PAYMENTS_FIELD, { disable: true, show: true, exist: true });
        }

        return fields;
      };

      var removeDeletedAdditionalFields = function removeDeletedAdditionalFields() {
        var needUpdate = 0;
        var defaultFields = [NAME_FIELD, EMAIL_FIELD, PRODUCT_PRICE_FIELD, ADDRESS_FIELD, STRIPE_FIELD, CLOUD_PAYMENTS_FIELD, CONTACT_INFO_FIELD, KUPON_FIELD, SUM_FIELD];
        defaultFields = defaultFields.concat(USER_FIELDS);
        defaultFields = defaultFields.concat(ADDRESS_FIELDS);
        defaultFields = defaultFields.concat(DELIVERY_ADDRESS_FIELDS);

        var formclone = angular.copy(scope.form);
        var ref = formclone.form_fields_attributes;

        for (var j = 0, len1 = ref.length; j < len1; j++) {
          var field = ref[j];
          var ref1 = field.name;
          var notDefaultFields = indexOf.call(defaultFields, ref1) < 0;

          if (notDefaultFields) {
            var needForDestroy = _.filter(window.justclick.additionalFields, {
              name: field.name
            }).length === 0;

            if (needForDestroy) {
              needUpdate++;
              field._destroy = true;
            }
          }
        }

        if (needUpdate > 0) {
          $rootScope.isSaveDisabled = true;

          var sectionId = blockEditDialog.getSectionId({ id: formclone.id });

          return Widget.update(sectionId, formclone).then(function (data) {
            scope.form.form_fields_attributes = getUpdatedFields(data.form_fields_attributes);
            $rootScope.isSaveDisabled = false;
          }).catch(function () {
            $rootScope.isSaveDisabled = false;
          });
        } else {
          return {
            then: function then(cb) {
              return cb();
            }
          };
        }
      };

      var addAdditionalFields = function addAdditionalFields() {
        removeDeletedAdditionalFields().then(function () {
          var fieldsForAddingCount = 0;

          if (window.justclick.additionalFields) {
            _.each(window.justclick.additionalFields, function (field) {
              if (!fieldExist(field)) {
                fieldsForAddingCount++;
                scope.form.form_fields_attributes.push(field);
              }
            });
          }

          if (fieldsForAddingCount > 0 || newFieldsAdded) {
            var sectionId = blockEditDialog.getSectionId({ id: scope.form.id });

            return Widget.update(sectionId, scope.form).then(function (data) {
              scope.form.form_fields_attributes = getUpdatedFields(data.form_fields_attributes);
            });
          }
        });
      };

      var updateFieldsList = function updateFieldsList(newVal, oldVal) {
        if (newVal !== null && newVal !== oldVal) {
          var fields = getUpdatedFields(scope.form.form_fields_attributes);

          formInputsHtmlRender(fields);
        }
      };

      addAdditionalFields();
      updateTranslations(scope.form.form_fields_attributes);

      /**
       * При изменении поля ADDRESS_FIELD покажем/скроем поля DELIVERY_ADDRESS_FIELDS
       * @param newFields
       * @param oldFields
       */
      var toggleDeliveryAddressFields = function toggleDeliveryAddressFields(newFields, oldFields) {
        var indexAddressField = findFieldIndexByAttr(newFields, { name: ADDRESS_FIELD });
        var indexAddressOldFields = findFieldIndexByAttr(oldFields, { name: ADDRESS_FIELD });

        if (indexAddressField > 0 && indexAddressOldFields > 0 && newFields[indexAddressField].exist !== oldFields[indexAddressOldFields].exist) {
          if (newFields[indexAddressField].exist) {
            updateFieldsByNames(newFields, DELIVERY_ADDRESS_FIELDS, { show: true, exist: true });
          } else {
            updateFieldsByNames(newFields, DELIVERY_ADDRESS_FIELDS, { show: false, exist: false });
          }
        }
      };

      // Watchers
      var listeners = [];

      listeners.push(scope.$watch('form', function (newVal) {
        if (!ngModel) {
          return false;
        }
        ngModel.$setViewValue(newVal);
      }));
      listeners.push(scope.$watch('data.button', function (newVal) {
        setButtonStyles(newVal);
      }, true));
      listeners.push(scope.$watch('data.parent_button', function (newVal) {
        setParentButtonStyles(newVal);
      }, true));
      listeners.push(scope.$watch('data.form_style', function (newVal) {
        setFormStyles(newVal);
      }, true));
      listeners.push(scope.$watch('data.form_fields_style_attributes', function (newVal) {
        setFormFieldsStyles(newVal);
      }, true));
      listeners.push(scope.$watch('data.labels_style_attributes', function (newVal) {
        setLabelsStyles(newVal);
      }, true));
      listeners.push(scope.$watch('data.form_link_style_attributes', function (newVal) {
        setLinkStyles(newVal);
      }, true));
      listeners.push(scope.$watch('data.selected_products', function (newVal) {
        if (scope.data.product_selected) {
          var fields = scope.form.form_fields_attributes;

          if (hasFloatingPriceProduct(newVal)) {
            updateFieldByName(fields, SUM_FIELD, { show: true, disable: true, exist: true });
          } else {
            updateFieldByName(fields, SUM_FIELD, { show: false, disable: false, exist: false });
          }
          if (newVal.length > 1) {
            updateFieldByName(fields, PRODUCT_PRICE_FIELD, { disable: true, exist: true });
          } else {
            updateFieldByName(fields, PRODUCT_PRICE_FIELD, { disable: false });
          }

          formInputsHtmlRender(fields);
        }
      }, true));
      listeners.push(scope.$watch('data.as_modal', function (newVal) {
        modalTransform(newVal);
      }));
      listeners.push(scope.$watch('data.form_design', function (newVal) {
        scope.form.form_design = newVal;

        formInputsHtmlRender(scope.form.form_fields_attributes);
      }));
      listeners.push(scope.$watch('data.labels', function (newVal) {
        scope.form.labels = newVal;

        formInputsHtmlRender(scope.form.form_fields_attributes);
      }));
      listeners.push(scope.$watch('form.form_fields_attributes', function (newVal, oldVal) {
        var fields = trimNbsp(newVal);
        var needForChange = fieldChanged(newVal, oldVal, 'placeholder') || fieldChanged(newVal, oldVal, 'options_raw') || fieldChanged(newVal, oldVal, 'exist') || fieldChanged(newVal, oldVal, 'hidden') || fieldChanged(newVal, oldVal, 'offert_text') || fieldChanged(newVal, oldVal, 'offert_url_text') || fieldChanged(newVal, oldVal, 'checked');

        scope.data.form_fields_attributes = fields;

        if (scope.fieldsLength(newVal) !== scope.fieldsLength(oldVal) || needForChange) {
          toggleDeliveryAddressFields(fields, trimNbsp(oldVal));
          formInputsHtmlRender(newVal);
        }
      }, true));
      listeners.push(scope.$watch('data.product_selected', function (newVal, oldVal) {
        updateFieldsList(newVal, oldVal);
      }));

      scope.$on('$destroy', function () {
        return _.each(listeners, function (listener) {
          return listener();
        });
      });
      scope.setTitleAsType = function (type) {
        var finded;
        finded = _.filter(scope.inputTypes, {
          field_type: type
        });
        scope.form.form_fields_attributes[scope.currentField].title = finded[0].title;
        return scope.form.form_fields_attributes[scope.currentField].placeholder = finded[0].title;
      };

      var emptyName = function emptyName(variable) {
        return variable || 'No name';
      };
      var emptyDesc = function emptyDesc(variable) {
        return variable || '';
      };

      var generateUrlInput = function generateUrlInput(field) {
        var required, translit;
        translit = translitService.cyrillToLatin(emptyName(field.placeholder));
        required = field.required ? "required=''" : "";
        return "<input readonly='' " + required + " type='url' name='" + translit + "' class='strwf__input' placeholder='" + emptyDesc(field.placeholder) + "'>";
      };

      var generateEmailInput = function generateEmailInput(field) {
        var required, translit;
        translit = translitService.cyrillToLatin(emptyName(field.placeholder));
        required = field.required ? "required=''" : "";
        return "<input readonly='' " + required + " type='email' name='" + translit + "' class='strwf__input' placeholder='" + emptyName(field.placeholder) + "'>";
      };

      var generateTextInput = function generateTextInput(field) {
        var required, translit;
        translit = translitService.cyrillToLatin(emptyName(field.placeholder));
        required = field.required ? "required=''" : "";
        return "<input readonly='' " + required + " type='text' name='" + translit + "' class='strwf__input' placeholder='" + emptyDesc(field.placeholder) + "'>";
      };

      var generateNumberInput = function generateNumberInput(field) {
        var required, translit;
        translit = translitService.cyrillToLatin(emptyName(field.placeholder));
        required = field.required ? "required=''" : "";
        return "<input readonly='' " + required + " type='number' name='" + translit + "' class='strwf__input' placeholder='" + emptyDesc(field.placeholder) + "'>";
      };

      var generatePhoneInput = function generatePhoneInput(field) {
        var required, translit;
        translit = translitService.cyrillToLatin(emptyName(field.placeholder));
        required = field.required ? "required=''" : "";
        return "<input readonly='' " + required + " type='tel' name='" + translit + "' class='strwf__input' placeholder='" + emptyDesc(field.placeholder) + "'>";
      };

      var generateTextareaInput = function generateTextareaInput(field) {
        var required, translit;
        translit = translitService.cyrillToLatin(emptyName(field.placeholder));
        required = field.required ? "required=''" : "";
        return "<textarea readonly='' " + required + " class='strwf__input strwf__input_textarea' name='" + translit + "' placeholder='" + emptyDesc(field.placeholder) + "'></textarea>";
      };

      var generateSelectInput = function generateSelectInput(field) {
        var options, optionsHtml, required, translit;
        translit = translitService.cyrillToLatin(emptyName(field.placeholder));
        required = field.required ? "required=''" : "";
        if (field.options_raw) {
          options = field.options_raw.split("\n");
          optionsHtml = "";
          _.each(options, function (option) {
            var selected;
            if (option === field.value) {
              selected = "selected=''";
            } else {
              selected = "";
            }
            return optionsHtml += "<option value='" + option + "' " + selected + ">" + option + "</option>";
          });
        }
        return "<select " + required + " class='strwf__input' name='" + translit + "'>" + optionsHtml + "</select>";
      };

      var generateCheckboxInput = function generateCheckboxInput(field, index) {
        var optionsHtml, selected, translit;

        translit = translitService.cyrillToLatin(emptyName(field.placeholder));

        if (field.title === field.value || field.checked) {
          selected = "checked=''";
        } else {
          selected = "";
        }

        optionsHtml = "<div class='strwf__radio-wrapper'><input class='strwf__radio' value='" + field.title + "' id='strwf-1-" + field.id + "' type='checkbox' name='entity[{{field.name}}]' " + selected + "><label contenteditable='false' data-access='form_fields_attributes." + index + ".title' class='strwf__radio-label' for='strwf-1-" + field.id + "'>" + field.title + "</label></div>";
        if (field.offert) {
          optionsHtml = "<div class='strwf__offert-wrapper'><div class='strwf__radio-wrapper'><input class='strwf__radio' value='" + field.title + "' id='strwf-1-" + field.id + "' type='checkbox' name='entity[{{field.name}}]' " + selected + "><label class='strwf__radio-label' for='strwf-1-" + field.id + "'>" + emptyDesc(field.offert_text) + " <a href='#'>" + emptyDesc(field.offert_url_text) + "</a></label></div></div>";
        } else if (field.name === ADDRESS_FIELD) {
          optionsHtml = "<div class='strwf__radio-wrapper'><input class='strwf__radio' value='" + field.title + "' id='strwf-1-" + field.id + "' type='checkbox' name='entity[{{field.name}}]' " + selected + "><label class='strwf__radio-label' for='strwf-1-" + field.id + "'>" + field.placeholder + "</label></div>";
        }
        return optionsHtml;
      };

      var generateRadioInput = function generateRadioInput(field) {
        var options, optionsHtml, translit;
        translit = translitService.cyrillToLatin(emptyName(field.placeholder));
        options = field.options_raw.split("\n");
        optionsHtml = "";
        _.each(options, function (option, index) {
          var selected;
          if (option === field.value) {
            selected = "checked=''";
          } else {
            selected = "";
          }
          return optionsHtml += "<div class='strwf__radio-wrapper'><input class='strwf__radio' value='" + option + "' id='strwfr-" + field.name + "-" + index + "-1' type='radio' name='entity[" + field.name + "]' " + selected + "><label class='strwf__radio-label' for='strwfr-" + field.name + "-" + index + "-1'>" + option + "</label></div>";
        });
        return optionsHtml;
      };

      var generateProductInfo = function generateProductInfo() {
        var optionsHtml = "";
        var selected_products = scope.data.selected_products;

        // Выведем текст по умолчанию, если продукт не установлен

        if (selected_products.length === 0) {
          selected_products = [{
            title: $filter('translate')('modulesSettings.subscribeFormFields.product'),
            priceFormatted: $filter('translate')('modulesSettings.subscribeFormFields.cost')
          }];
        }

        optionsHtml += "<div class='subscribe-form strwf__input-wrapper'>";

        if (selected_products.length === 1) {
          var title = selected_products[0].title;
          var price = selected_products[0].priceFormatted;

          optionsHtml += "<div class='row str-row subscribe-form__products'>" + "<div class='str-col str-col-6'>" + "<div class='subscribe-form__title'>" + title + "</div>" + "</div>" + "<div class='str-col str-col-6' style='text-align: right;'>" + "<div class='subscribe-form__price'>" + price + "</div>" + "</div>" + "</div>";
        } else {
          var ref = selected_products;

          for (var j = 0, len1 = ref.length; j < len1; j++) {
            var product = ref[j];
            var _title = product.title;
            var name = product.name;
            var _price = product.priceFormatted;
            var radioHtml = "<div class='strwf__radio-wrapper'>" + "<input class='strwf__radio' id='product-" + name + "' type='radio' name='products'>" + "<label class='strwf__radio-label' for='product-" + name + "'>" + _title + "</label>" + "</div>";

            optionsHtml += "<div class='row str-row subscribe-form__products'>" + "<div class='str-col str-col-8'>" + radioHtml + "</div>" + "<div class='str-col str-col-4' style='text-align: right;'>" + "<div class='subscribe-form__price'>" + _price + "</div>" + "</div>" + "</div>";
          }
        }
        optionsHtml += "<hr></div>";

        return optionsHtml;
      };

      var generateContactInfo = function generateContactInfo(field, index) {
        var optionsHtml;
        optionsHtml = "<div class='strwf__input-wrapper'><h5 contenteditable='false' data-access='form_fields_attributes." + index + ".title'>" + field.title + "</h5></div>";
        return optionsHtml;
      };

      var setButtonStyles = function setButtonStyles(newVal) {
        var style = void 0;
        var button = widgetElWrapper.find(".strwf_form-button");

        scope.form.button = newVal;
        widgetElWrapper.find(ns.widgetFormButtonWrapperClass).css("text-align", newVal.style["textAlign"]);

        if (newVal.style.textAlign) {
          style = angular.copy(newVal.style);
          delete style.textAlign;
        }

        button.css(style);
        blockEditDialog.updateBtn(button, newVal);
      };

      var setParentButtonStyles = function setParentButtonStyles(newVal) {
        var style = void 0;
        var button = widgetElWrapper.find(".strwf__parent-button");

        scope.form.parent_button = newVal;
        widgetElWrapper.find(ns.widgetFormParentButtonWrapperClass).css("text-align", newVal.style["textAlign"]);
        if (newVal.style.textAlign) {
          style = angular.copy(newVal.style);
          delete style.textAlign;
        }

        button.css(style);
        blockEditDialog.updateBtn(button, newVal);
      };

      var setFormFieldsStyles = function setFormFieldsStyles(newVal) {
        scope.form.form_fields_style_attributes = newVal;
        widgetElWrapper.find(".strwf__input").css(newVal);
      };

      var setLabelsStyles = function setLabelsStyles(newVal) {
        scope.form.labels_style_attributes = newVal;
        widgetElWrapper.find(".strwf__label").css(newVal);

        var offertWrapper = widgetElWrapper.find(".strwf__offert-wrapper");
        if (offertWrapper.length > 0) {
          offertWrapper.css(newVal);
        }
      };
      var setLinkStyles = function setLinkStyles(newVal) {
        scope.form.form_link_style_attributes = newVal;

        var offertWrapper = widgetElWrapper.find(".strwf__offert-wrapper");
        if (offertWrapper.length > 0) {
          offertWrapper.find("a").css(newVal);
        }
      };

      var setFormStyles = function setFormStyles(newVal) {
        widgetElWrapper.find("form").css(newVal);
      };

      var modalTransform = function modalTransform(newVal) {
        var form = widgetElWrapper.find(".strwf__form");
        var button = "<div class='" + ns.widgetFormParentButtonWrapperClass.substr(1) + "'><label type='submit' contenteditable='false' data-access='parent_button.value' class='strwf_button strwf__parent-button'>" + scope.form.parent_button.value + "</label></div>";

        widgetElWrapper.find("" + ns.widgetFormParentButtonWrapperClass).remove();
        if (newVal) {
          form.hide();
          widgetElWrapper.prepend(button);
          setParentButtonStyles(scope.form.parent_button);
          ContentEditable.bind(false, true, widgetId);
        } else {
          widgetElWrapper.find(".subscribe-form__modal-title").remove();
          form.show();
        }
      };

      var getExistFieldsLength = function getExistFieldsLength(fields) {
        return _.filter(fields, {
          exist: false
        }).length;
      };

      var formInputsHtmlRender = function formInputsHtmlRender(fields) {
        var fieldsWithLabelBlock = ['checkbox', 'radio'];
        var fieldsWithOptions = ['checkbox', 'radio', 'select'];
        var formIsHorizontal = scope.form.form_design === 'horizontal';

        var output = '';
        var inlineClasses = '';
        var buttonLabel = '';

        _.each(fields, function (field, index) {
          var ref = field.field_type;

          if (!field.options_created && indexOf.call(fieldsWithOptions, ref) >= 0 && !field.options_raw) {
            field.options_raw = "" + $filter('translate')('modulesSettings.subscribeFormFields.variants');
            field.options_created = true;
          }

          if (!field._destroy && field.exist && !field.hidden) {
            if (formIsHorizontal) {
              var existFieldsLength = getExistFieldsLength(fields);
              inlineClasses = 'strwf__input-inline strwf__input-wrapper_' + (scope.fieldsLength(fields) + 1 - existFieldsLength);
            }

            var ref1 = field.field_type;
            var displayBlock = indexOf.call(fieldsWithLabelBlock, ref1) >= 0 ? 'strwf__label_block' : '';
            var styleForHorizontalCheckbox = 'order: 1; margin-top: .8%; flex: 1 1 100%;';

            output += '<div class="strwf__input-wrapper ' + inlineClasses + '" ' + (formIsHorizontal && field.field_type === 'checkbox' ? 'style="' + styleForHorizontalCheckbox + '"' : '') + '>';

            if (scope.form.labels && !field.offert && field.name !== ADDRESS_FIELD) {
              output += "<label class='strwf__label " + displayBlock + "' contenteditable='false' data-access='form_fields_attributes." + index + ".title'>" + emptyDesc(field.title) + "</label>";
              buttonLabel = formIsHorizontal ? "<div class='strwf__label'>​</div>" : "";
            }

            switch (field.field_type) {
              case 'text':
                output += generateTextInput(field);
                break;
              case 'number':
                output += generateNumberInput(field);
                break;
              case 'textarea':
                output += generateTextareaInput(field);
                break;
              case 'select':
                output += generateSelectInput(field);
                break;
              case 'checkbox':
                output += generateCheckboxInput(field, index);
                break;
              case 'radio':
                output += generateRadioInput(field);
                break;
              case 'tel':
                output += generatePhoneInput(field);
                break;
              case 'email':
                output += generateEmailInput(field);
                break;
              case 'url':
                output += generateUrlInput(field);
            }
            output += "<span id='" + field.nameEn + "' class='error-text'></span></div>";
          }

          if (!field._destroy && field.exist && field.controlling) {
            switch (field.name) {
              case PRODUCT_PRICE_FIELD:
                output += generateProductInfo();
                break;
              case CONTACT_INFO_FIELD:
                output += generateContactInfo(field, index);
                break;
            }
          }
        });

        var button = "<div class='strwf__button-wrapper strwf__form-button__wrapper " + inlineClasses + "'>" + buttonLabel + "<label type='submit' class='strwf_button strwf_form-button' contenteditable='false' data-access='button.value'>" + scope.form.button.value + "</label>" + "</div>";

        if (formIsHorizontal) {
          widgetElWrapper.find("form").css({ display: 'flex', 'flex-wrap': 'wrap' });
        } else {
          widgetElWrapper.find("form").css({ display: 'block' });
        }

        widgetElWrapper.find("form").html('');
        widgetElWrapper.find("form").append(output);
        widgetElWrapper.find("form").append(button);

        setButtonStyles(scope.data.button);
        setFormFieldsStyles(scope.data.form_fields_style_attributes);
        setLabelsStyles(scope.data.labels_style_attributes);
        setLinkStyles(scope.data.form_link_style_attributes);

        ContentEditable.bind(false, true, widgetId);
      };

      updateFieldsList(scope.data.product_selected);
    }
  };
}]);

/***/ }),
/* 66 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

var timerModule = angular.module('timer.setting', []);

timerModule.directive('timerSetting', ['$window', '$timeout', '$compile', '$templateCache', 'Widget', 'FileUploader', '$cookies', 'Restangular', 'Timer', function ($window, $timeout, $compile, $templateCache, Widget, FileUploader, $cookies, Restangular, Timer) {
  return {
    restrict: 'A',
    scope: {
      data: '=ngModel'
    },
    templateUrl: settingFolder + '/timer/template.jade',
    link: function link(scope, element, attrs, ngModel) {
      var secondsToString = function secondsToString(seconds) {
        var numdays = Math.floor(seconds / 86400);
        var numhours = Math.floor(seconds % 86400 / 3600);
        var numminutes = Math.floor(seconds % 86400 % 3600 / 60);
        var numseconds = seconds % 86400 % 3600 % 60;

        return [numdays, numhours, numminutes, numseconds];
      };

      scope.widgetInfo = {
        days: secondsToString(scope.data.seconds)[0],
        hours: secondsToString(scope.data.seconds)[1],
        minutes: secondsToString(scope.data.seconds)[2]
      };

      scope.widgetInfo.start_point = new Date(scope.data.start_point);

      var date = new Date(scope.data.time_end);
      var timend_day = date.getDate();
      var timend_month = date.getMonth() + 1;
      var timend_year = date.getFullYear();
      var timend_hours = date.getHours();
      var timend_minutes = date.getMinutes();

      scope.widgetInfo.hours_end = date;
      scope.widgetInfo.time_end = timend_year + "-" + timend_month + "-" + timend_day;
      scope.play = function () {
        scope.data.is_started = true;
        scope.data.time_end = new Date(scope.widgetInfo.time_end).setHours(new Date(scope.widgetInfo.hours_end).getHours(), new Date(scope.widgetInfo.hours_end).getMinutes(), new Date(scope.widgetInfo.hours_end).getSeconds());
        scope.data.time_end = new Date(scope.data.time_end);
        scope.data.seconds = parseInt(scope.widgetInfo.days) * 24 * 60 * 60 + parseInt(scope.widgetInfo.hours) * 60 * 60 + parseInt(scope.widgetInfo.minutes) * 60;
        scope.data.start_point = new Date(scope.widgetInfo.start_point).getTime();
        return Timer.initTimer(0, $("[data-block-id='" + scope.data.id + "'] .strbw-timer"), scope.data);
      };

      var timerEl = $("[data-block-id='" + scope.data.id + "'] .strbw-timer");
      var hidings = function hidings(newVal) {
        if (!newVal.show_days) {
          timerEl.addClass('strbw-timer_hide-days');
        } else {
          timerEl.removeClass('strbw-timer_hide-days');
        }

        if (!newVal.show_seconds) {
          timerEl.addClass('strbw-timer_hide-seconds');
        } else {
          timerEl.removeClass('strbw-timer_hide-seconds');
        }
      };

      var themes = function themes(newVal) {
        var i = void 0,
            j = void 0;
        for (i = j = 0; j <= 4; i = ++j) {
          timerEl.removeClass("strbw-timer-theme-" + i);
        }

        timerEl.addClass("strbw-timer-theme-" + newVal.theme);
      };

      var updateLabel = function updateLabel($wrapper, selector, text) {
        var $label = $wrapper.find(selector);

        if (text !== undefined && $label.length > 0) {
          $label.text(text);
        }
      };

      var labels = function labels(newVal) {
        updateLabel(timerEl, '.flip-clock-divider.days .flip-clock-label', newVal.days_label);
        updateLabel(timerEl, '.flip-clock-divider.hours .flip-clock-label', newVal.hours_label);
        updateLabel(timerEl, '.flip-clock-divider.minutes .flip-clock-label', newVal.minutes_label);
        updateLabel(timerEl, '.flip-clock-divider.seconds .flip-clock-label', newVal.seconds_label);
      };

      var listener = scope.$watch("data", function (newVal) {
        hidings(newVal);
        themes(newVal);
        labels(newVal);
      }, true);

      scope.$on("$destroy", function () {
        listener();
      });
    }
  };
}]);

/***/ }),
/* 67 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

var uploaderDirectiveModule = angular.module('uploader.setting', []);

uploaderDirectiveModule.directive("uploaderSetting", ["$window", "$timeout", "$compile", "$templateCache", "$state", "$cookies", "FileUploader", "$rootScope", "Restangular", "blockEditDialog", "Section", function ($window, $timeout, $compile, $templateCache, $state, $cookies, FileUploader, $rootScope, Restangular, blockEditDialog, Section) {
  return {
    restrict: "A",
    scope: {
      data: "=ngModel",
      uploadSuccess: '&uploadSuccess'
    },
    templateUrl: settingFolder + "/uploader/template.jade",
    link: function link(scope, element, attrs, ngModel) {
      var method = "PUT";
      var siteId = void 0,
          sectionId = void 0,
          urlUploader = void 0,
          aliasUploader = void 0,
          bgId = void 0,
          object = void 0;

      var widgetId = attrs.widgetId;
      var widgetEl = angular.element("[data-block-id='" + widgetId + "']");

      scope.url = scope.data;

      if ($rootScope.Editor.mode === 'editor.section') {
        siteId = '/';
      } else {
        siteId = '/sites/' + $state.params.siteId + '/pages/' + $state.params.pageId;
      }

      var sectionAttrPreview = attrs.uploaderSettingSectionPreview;
      var emailAttrPreview = attrs.uploaderSettingEmailPreview;

      scope.sectionAttrVideoCover = attrs.uploaderSettingSectionVideoCover;
      scope.backgroundId = attrs.backgroundId;

      if (sectionAttrPreview) {
        sectionId = attrs.sectionId;
        urlUploader = "" + Restangular.configuration.baseUrl + siteId + "/sections/" + sectionId;
        aliasUploader = "preview";
      } else if (emailAttrPreview) {
        sectionId = attrs.sectionId;
        urlUploader = Restangular.configuration.baseUrl + "/emails/" + sectionId;
        aliasUploader = "preview";
      } else if (attrs.uploaderPhotoId) {
        sectionId = blockEditDialog.getSectionId({ id: widgetId });
        urlUploader = Restangular.configuration.baseUrl + "/sections/" + sectionId + "/widgets/" + widgetId;
        aliasUploader = "photos_attributes[0][file]";
      } else if (attrs.uploaderProductItemId) {
        sectionId = blockEditDialog.getSectionId({ id: widgetId });
        urlUploader = Restangular.configuration.baseUrl + "/sections/" + sectionId + "/widgets/" + widgetId;
        aliasUploader = "product_items_attributes[0][" + attrs.imageAttr + "]";
      } else if (attrs.uploaderProductItemIdRow) {
        sectionId = blockEditDialog.getSectionId({ id: widgetId });
        urlUploader = Restangular.configuration.baseUrl + "/products/" + widgetId + "/product_items/" + attrs.uploaderProductItemIdRow;
        aliasUploader = "[" + attrs.imageAttr + "]";
      } else if (attrs.uploaderImageId) {
        sectionId = attrs.sectionId;
        bgId = attrs.backgroundId;
        aliasUploader = "source";
        object = "sections";
        if (attrs.uploaderImageId === "none") {
          urlUploader = Restangular.configuration.baseUrl + "/sections/" + sectionId + "/images";
          method = "POST";
        } else {
          urlUploader = Restangular.configuration.baseUrl + "/sections/" + sectionId + "/images/" + attrs.uploaderImageId;
        }
      } else if (scope.sectionAttrVideoCover) {
        sectionId = attrs.sectionId;
        urlUploader = "" + Restangular.configuration.baseUrl + siteId + "/sections/" + sectionId;
        aliasUploader = "background_attributes[video_cover]";
      } else if (attrs.siteBg) {
        if (Editor.mode === "email.page.editor") {
          urlUploader = Restangular.configuration.baseUrl + "/sites/" + $state.params.emailId + "/pages/" + $rootScope.currentPage.id;
        } else {
          urlUploader = Restangular.configuration.baseUrl + "/sites/" + $state.params.siteId + "/pages/" + $rootScope.currentPage.id;
        }
        aliasUploader = "background_attributes[image_attributes[source]]";
      } else {
        sectionId = blockEditDialog.getSectionId({ id: widgetId });
        urlUploader = Restangular.configuration.baseUrl + "/sections/" + sectionId + "/widgets/" + widgetId;
        aliasUploader = "image_attributes[source]";
      }

      var setSrc = function setSrc(newval) {
        widgetEl.find(".strwimage__image").removeAttr('srcset').attr("src", newval);
      };

      scope.uploader = new FileUploader({
        url: urlUploader,
        autoUpload: true,
        method: method,
        alias: aliasUploader,
        headers: {
          'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
        }
      });

      scope.timestamp = new Date().getTime();

      var opacity = {
        get: function get(rgba) {
          var rgb, rgbaStringArray;
          rgbaStringArray = rgba.match(/[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s]?([\d.]+)[\s+]?/g);
          rgb = rgbaStringArray[0].split(', ');
          return parseInt(rgb[3]);
        },
        set: function set(rgba, opacity) {
          var rgb, rgbaStringArray;
          rgbaStringArray = rgba.match(/[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s]?([\d.]+)[\s+]?/g);
          rgb = rgbaStringArray[0].split(', ');
          return "rgba(" + rgb[0] + ", " + rgb[1] + ", " + rgb[2] + ", " + opacity + ")";
        }
      };

      if (attrs.uploaderPhotoId) {
        scope.uploader.onBeforeUploadItem = function (item) {
          var formData = [{
            "photos_attributes[0][id]": attrs.uploaderPhotoId
          }];
          return Array.prototype.push.apply(item.formData, formData);
        };
      }
      if (attrs.uploaderProductItemId) {
        scope.uploader.onBeforeUploadItem = function (item) {
          var formData = [{
            "product_items_attributes[0][id]": attrs.uploaderProductItemId
          }];
          return Array.prototype.push.apply(item.formData, formData);
        };
      }

      scope.uploader.onAfterAddingFile = function (item) {
        return ["image/jpeg", "image/png", "image/svg", "image/gif"];
      };

      scope.uploader.onSuccessItem = function (fileItem, response, status, headers) {
        var finded = void 0;

        if (sectionAttrPreview || emailAttrPreview) {
          scope.url = response.preview_url;
        } else if (attrs.uploaderPhotoId) {
          finded = _.filter(response.photos_attributes, {
            id: attrs.uploaderPhotoId
          });
          scope.url = finded[0].file_url;
        } else if (attrs.uploaderProductItemId) {
          finded = _.filter(response.product_items_attributes, {
            id: attrs.uploaderProductItemId
          });
          scope.url = finded[0].file_url;
        } else if (attrs.uploaderProductItemIdRow) {
          scope.url = response.bullet_url;
        } else if (attrs.backgroundId) {
          $timeout(function () {
            var section;
            section = $("[ng-model='section.style_attributes.backgroundColor']").scope().$parent.$parent.section;
            if (opacity.get(section.style_attributes.backgroundColor) === 1) {
              return section.style_attributes.backgroundColor = opacity.set(section.style_attributes.backgroundColor, 0);
            }
          });
          if (!scope.data) {
            scope.data = {};
          }
          scope.data.source_url = response.source_url;
          scope.data.url = response.url;
          scope.data.id = response.id;
          scope.url = response;
          if (attrs.fromEmail) {
            attrs.uploaderImageId = response.id;
          }
        } else if (scope.sectionAttrVideoCover) {
          scope.url.background_attributes.video_cover_url = response.background_attributes.video_cover_url;
        } else if (attrs.siteBg) {
          scope.url = response.background_attributes.image_attributes.source_url;
        } else {
          scope.url = response.image_attributes.source_url;
        }

        scope.uploader.clearQueue();
        scope.$apply();

        $(element).find('input[type="file"]').prop('value', null);

        if (scope.uploadSuccess) {
          scope.uploadSuccess();
        }
      };

      var listener1 = scope.$watch("url", function (newval) {
        if (newval) {
          setSrc(newval);
          if (!newval._destroy) {
            return scope.data = newval;
          }
        }
      }, true);

      scope.$on("$destroy", function () {
        return listener1();
      });
    }
  };
}]);

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* injects from baggage-loader */



var indexOf = [].indexOf || function (item) {
  for (var i = 0, l = this.length; i < l; i++) {
    if (i in this && this[i] === item) return i;
  }
  return -1;
};

var moduleAlert = angular.module('create_favorite.section.controller', []);

moduleAlert.controller('CreateFavoriteSectionModal', ['$scope', '$state', '$rootScope', '$modalInstance', 'Restangular', "$stateParams", "Section", "$window", "section", "FileUploader", function ($scope, $state, $rootScope, $modalInstance, Restangular, $stateParams, Section, $window, section, FileUploader) {
  $scope.section = angular.copy(section);
  $scope.previewUrl = '/constructor/editor/assets/images/image-error.svg';

  if (Editor.mode === 'email.page.editor') {
    $scope.section.for_email = true;
  }
  if (Editor.mode === 'lesson.page.editor') {
    $scope.section.for_lms_page = true;
  }

  $scope.close = function () {
    return $modalInstance.dismiss('close');
  };

  $scope.sectionFavoriteUploader = new FileUploader({
    autoUpload: false,
    method: 'PUT',
    alias: 'preview',
    headers: {
      'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
    }
  });

  $scope.sectionFavoriteUploader.onAfterAddingFile = function (item) {
    var types = ['image/jpeg', 'image/png'];

    var ref = void 0;
    if (ref = item.file.type, indexOf.call(types, ref) < 0) {
      alert('The file must be png or jpg');
      return false;
    } else {
      if (URL && typeof URL.createObjectURL === 'function') {
        $scope.previewUrl = URL.createObjectURL(item._file);
      }
    }
  };

  $scope.sectionFavoriteUploader.onSuccessItem = function (fileItem, response, status, headers) {
    $scope.previewUrl = response.preview_url;
    $scope.sectionFavoriteUploader.clearQueue();
  };
  $scope.sectionFavoriteUploader.onErrorItem = function (fileItem, response, status, headers) {};

  $scope.save = function (editSectionForm) {
    if (editSectionForm.$invalid) {
      return false;
    }

    $scope.updating = true;

    Section.saveTemplate($scope.section).then(function (sectionData) {
      if ($scope.sectionFavoriteUploader.queue.length > 0) {
        $scope.sectionFavoriteUploader.queue.forEach(function (item) {
          item.url = Restangular.configuration.baseUrl + ('/sections/' + sectionData.id);
        });
      }

      $scope.sectionFavoriteUploader.uploadAll();
      $scope.close();
      $scope.updating = false;
    }, function () {
      $scope.updating = false;
    });
  };
}]);

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* injects from baggage-loader */



var moduleLayoutDD = angular.module('services.layoutEditor.blockDragDrop', ['services.editorNamespace', 'services.layoutEditor.insertSpace', 'services.layoutEditor.blocksBuilder', 'services.layoutEditor.blockDropOverlays']);

moduleLayoutDD.factory('blockDragDrop', ['$timeout', '$injector', 'insertSpace', 'ns', 'blocksBuilder', 'blockDropOverlays', 'blockDragScroll', 'TimeMachine', '$state', 'Section', 'SectionEmail', 'SectionWebForm', 'SectionLesson', '$rootScope', 'Animation', function ($timeout, $injector, insertSpace, ns, blocksBuilder, blockDropOverlays, blockDragScroll, TimeMachine, $state, Section, SectionEmail, SectionWebForm, SectionLesson, $rootScope, Animation) {
  var Y = void 0;

  if ($state.current.name === 'email.page.editor') {
    Section = SectionEmail;
  }
  if ($state.current.name === 'form.page.editor') {
    Section = SectionWebForm;
  }
  if ($state.current.name === 'lesson.page.editor') {
    Section = SectionLesson;
  }

  var layoutDD = {
    builder: blocksBuilder,
    nearestEdge: {},
    fromBlockMenu: false,
    setEvents: function setEvents(dd, y) {
      Y = y;

      dd.before('drag:start', this._beforeDragStart, this);
      dd.on('drag:start', this._onDragStart, this);
      dd.on('drag:drag', this._onDragDrag, this);
      dd.on('drag:over', this._onDragOver, this);
      dd.on('drag:end', this._onDragEnd, this);
      dd.after('drag:end', this._afterDragEnd, this);
      dd.after('drag:start', this._afterDragStart, this);
      dd.on('drag:afterMouseDown', this._afterMouseDown, this);
      dd.on('drag:mouseup', blockDropOverlays.destroyOverlays, blockDropOverlays);
    },
    isEmptyObject: function isEmptyObject(obj) {
      for (var prop in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, prop)) {
          return false;
        }
      }
      return true;
    },
    _afterMouseDown: function _afterMouseDown(e) {
      this.widgetsPreCapture();
      blockDropOverlays.createOverlays(e);
    },
    widgetsPreCapture: function widgetsPreCapture() {
      var layoutEditor = $injector.get('layoutEditor');
      var sectionJson = angular.copy(layoutEditor.layout.section);
      var sectionHtml = layoutEditor.layout.one(ns.wrapperClass).get('innerHTML');

      this.oldState = {
        html: sectionHtml,
        json: sectionJson
      };
    },
    widgetsCapture: function widgetsCapture() {
      var layoutEditor = $injector.get('layoutEditor');
      var sectionJson = angular.copy(layoutEditor.layout.section);
      var sectionHtml = layoutEditor.layout.one(ns.wrapperClass).get('innerHTML');
      var newState = {
        html: sectionHtml,
        json: sectionJson
      };

      TimeMachine.capture('widgetsChange', {
        oldJson: this.oldState.json,
        newJson: newState.json
      }, {
        oldHtml: this.oldState.html,
        newHtml: newState.html
      });
    },
    _beforeDragStart: function _beforeDragStart() {
      Y.DD.DDM.syncActiveShims();

      var Spacer = $injector.get('Spacer');
      var insertBlockMenu = $injector.get('insertBlockMenu');

      if (insertBlockMenu.isOpen()) {
        insertBlockMenu.hide();
      }

      Spacer.destroy();
    },
    _onDragStart: function _onDragStart(e, fromMenu) {
      if (fromMenu === null || fromMenu === undefined) {
        fromMenu = false;
      }

      this.fromMenu = fromMenu;
      this.dragNode = e.target.get('node');
      this.colDragNode = e.target.get('node').ancestor('> ' + ns.colClass);
      this.clone = e.target.get('dragNode');

      var $dragNode = $('#' + this.dragNode._node._yuid);

      this.widgetFromList = $dragNode.length && $dragNode.scope().block;
      this.nearestSection = false;

      if (!this.widgetFromList) {
        this.colDragNode.addClass('str-col-from');
      }

      this.setVisibility(this.dragNode, 'hidden');

      if (!this.fromMenu) {
        this.clone.setStyles({
          zIndex: 400
        });
      }
    },
    _afterDragStart: function _afterDragStart() {
      Y.DD.DDM.syncActiveShims();
    },
    _onDragDrag: function _onDragDrag(e) {
      blockDragScroll.scroll(e);
    },
    _onDragOver: function _onDragOver() {
      var nearestEdge = this.getDropInfo(Y);
      var dropTarget = nearestEdge.node;
      var activeDropElement = Y.DD.DDM.activeDrop.get('node');
      var notSection = !activeDropElement.hasClass(ns.sectionClass.substr(1));

      if (notSection) {
        if (this.builder.isBlock(dropTarget)) {
          this.nearestEdge = nearestEdge;
          insertSpace.alignInsertSpaceBlock(this.nearestEdge, this.dragNode);
        }
      } else {
        var layoutEditor = $injector.get('layoutEditor');

        if (layoutEditor.layout.section.id !== activeDropElement.section.id) {
          this.nearestSection = activeDropElement;
          this.nearestSection.addClass('str-section_focus');
        } else if (this.nearestSection) {
          this.nearestSection.removeClass('str-section_focus');
          this.nearestSection = false;
        }
      }
    },
    createRow: function createRow(content) {
      Y.Node.create('<div class="row ' + ns.rowClass.replace('.', '') + '"></div>').setContent(content);
    },
    createColumn: function createColumn(size, content) {
      Y.Node.create('<div class="' + ns.colClass.substr(1) + ' str-col-' + size + '"></div>').setContent(content);
    },
    _onDragEnd: function _onDragEnd(e) {
      // Перенос блока в соседнюю секцию (nearestSection)
      if (this.nearestSection && !this.isNewBlock(this.dragNode)) {
        var sectionNode = $rootScope.Y.one('.tpl-wrapper > [data-section-id=' + this.nearestSection.section.id + ']');
        var targetNode = sectionNode.one(ns.wrapperClass);
        var targetCol = targetNode.one(ns.rowClass).one(ns.colClass);

        sectionNode.removeClass('str-section_focus');

        this.setVisibility(this.dragNode, 'visible');
        this.dragNode = Y.DD.DDM.activeDrag.get('node');

        if (targetCol) {
          targetCol.prepend(this.dragNode);
        } else {
          var row = this.createRow(this.createColumn(ns.maxColumns, this.dragNode));
          targetNode.prepend(row);
        }

        this.clean();
        this._afterDragEnd();

        var layoutEditor = $injector.get('layoutEditor');
        var previousSectionRows = sectionNode.section.structure.rows.slice(0);

        Section.beforeSave(sectionNode);
        sectionNode.section.structure = Section.generateJSON(targetNode);
        layoutEditor.setJSONtoSection(sectionNode.section, previousSectionRows);

        this.nearestSection = false;
        return false;
      }

      if (!this.fromMenu) {
        this.clone.setStyles({ zIndex: '' });
      }

      var insertBlockMenu = $injector.get('insertBlockMenu');
      var insertSpace = $injector.get('insertSpace');
      var ref = this.direction;

      this.setDragInstances(e);
      this.setVisibility(this.dragNode, 'visible');

      if ((ref === 'left' || ref === 'right') && !insertSpace.enableForInsert()) {
        this._afterDragEnd();
        return false;
      }

      if (this.targetNode && this.dragNode) {
        if (this.newBlock) {
          insertBlockMenu.lockWidgets();
          this.dragNode = insertBlockMenu.createAndInitBlock(this.dragNode, this.targetNode);

          // Прокрутка до нового виджета
          var $targetToScrol = $(this.dragNode._node);
          $timeout(function () {
            Animation.scrollTo($targetToScrol);
          }, 300);
        } else {
          this.dragNode = Y.DD.DDM.activeDrag.get('node');
          this.setWidgetFloating(this.dragNode, this.targetNode);
        }

        var rowTarget = this.targetNode.ancestor(ns.rowClass);

        if (!rowTarget) {
          return false;
        }

        if (this.targetNode.float) {
          this.builder.insertBlock(this.direction, this.dragNode, this.targetNode);
        } else if (this.builder.isBlock(this.targetNode)) {
          switch (this.direction) {
            case 'top':
              this.insertTop();
              break;
            case 'bottom':
              this.insertBottom();
              break;
            case 'left':
            case 'right':
              this.insertSide(rowTarget);
          }
        }
        this.clean();
      }

      insertBlockMenu.updateWidgetsOnResize();
      insertSpace.hideFull();
    },
    _afterDragEnd: function _afterDragEnd() {
      if (!this.widgetFromList && this.colDragNode) {
        this.colDragNode.removeClass('str-col-from');
      }

      blockDropOverlays.destroyOverlays();

      var layoutEditor = $injector.get('layoutEditor');
      var Spacer = $injector.get('Spacer');

      insertSpace.hide();
      Spacer.init(Y);

      this.builder.initResizers(Y);

      layoutEditor.save();

      this.nearestEdge = false;
      this.isSelf = false;
      this.direction = false;
      this.dragNode = false;
      this.targetNode = false;
      this.widgetsCapture();
    },
    /**
     * _onClick
     * @param e
     * @private
     */
    _onClick: function _onClick(e) {
      this.widgetsPreCapture();

      var block = e.currentTarget;

      var layoutEditor = $injector.get('layoutEditor');
      var $sectionNode = $('.tpl-wrapper > [data-section-id=' + layoutEditor.layout.section.id + ']');
      var sectionNode = $rootScope.Y.one('.tpl-wrapper > [data-section-id=' + layoutEditor.layout.section.id + ']');
      var targetNode = sectionNode.one(ns.wrapperClass);
      var targetCol = targetNode.one(ns.rowClass).one(ns.colClass);
      var insertBlockMenu = $injector.get('insertBlockMenu');

      if (insertBlockMenu.widgetIsLock(block)) {
        return false;
      }

      insertBlockMenu.lockWidgets();
      block = insertBlockMenu.createAndInitBlock(block, targetNode);

      if (targetCol) {
        targetCol.prepend(block);
      } else {
        var row = this.createRow(this.createColumn(ns.maxColumns, block));
        targetNode.prepend(row);
      }

      this.clean();
      this._afterDragEnd();

      var previousSectionRows = sectionNode.section.structure.rows.slice(0);

      Section.beforeSave(sectionNode);
      sectionNode.section.structure = Section.generateJSON(targetNode);
      layoutEditor.setJSONtoSection(sectionNode.section, previousSectionRows);

      this.closeEditorNav();
      Animation.scrollTo($sectionNode);
    },

    closeEditorNav: function closeEditorNav() {
      var $eTools = $('.e__tools');

      if ($eTools.scope().editorNavOpenWidget) {
        $rootScope.editSection();
      } else {
        $eTools.scope().editorNavOpenWidget = false;
        $eTools.scope().editorNavOpen = false;
        if (!$eTools.scope().$$phase) {
          $eTools.scope().$apply();
        }
      }
    },

    setVisibility: function setVisibility(el, visibility) {
      el.setStyles({
        visibility: visibility
      });
    },
    setDragInstances: function setDragInstances() {
      if (this.nearestEdge && this.builder.isBlock(this.nearestEdge.node) && !this.isEmptyObject(this.nearestEdge)) {
        this.targetNode = this.nearestEdge.node;
        this.direction = this.nearestEdge.direction;
        this.isSelf = this.dragNode === this.targetNode;
        this.newBlock = this.isNewBlock(this.dragNode);
        this.firstBlock = insertSpace.firstBlock(this.targetNode);
        this.lastBlock = insertSpace.lastBlock(this.targetNode);
        this.oneCol = this.targetNode.ancestor(ns.rowClass).all(ns.colClass).size() === 1;
        this.distanceForBlock = this.nearestEdge.distance > ns.dragBlockToRowDistance;
      }
    },
    insertTop: function insertTop() {
      if (this.firstBlock && !this.distanceForBlock) {
        this.builder.insertRow(this.direction, this.dragNode, this.targetNode);
      } else {
        this.builder.insertBlock(this.direction, this.dragNode, this.targetNode);
      }
    },
    insertBottom: function insertBottom() {
      if (this.lastBlock && !this.distanceForBlock || this.oneCol) {
        this.builder.insertRow(this.direction, this.dragNode, this.targetNode);
      } else {
        this.builder.insertBlock(this.direction, this.dragNode, this.targetNode);
      }
    },
    getCountWidgetsInCol: function getCountWidgetsInCol(col) {
      return col.all(ns.blockClass).size();
    },
    insertSideOverride: function insertSideOverride(direction, dragNode, targetNode, widgetFromList) {
      this.direction = direction;
      this.dragNode = dragNode;
      this.targetNode = targetNode;
      this.distanceForBlock = true;
      this.widgetFromList = widgetFromList;

      var rowTarget = this.targetNode.ancestor(ns.rowClass);
      this.insertSide(rowTarget);
    },
    insertSide: function insertSide(rowTarget) {
      var widgetsCountInCol = this.getCountWidgetsInCol(this.targetNode.ancestor(ns.colClass));

      if (this.distanceForBlock && widgetsCountInCol > 1 && !this.isSelf) {
        this.builder.insertRowIntoColumn(this.direction, this.dragNode, this.targetNode);
      } else {
        var sumColElementsSize = Y.one(rowTarget).all(ns.colClass).size();

        if (sumColElementsSize < ns.maxColumns && !this.isSelf) {
          this.builder.insertColumn(this.direction, this.dragNode, this.targetNode, this.widgetFromList);
        }
      }
    },
    setWidgetFloating: function setWidgetFloating(dragNode, targetNode) {
      if (dragNode.widget) {
        dragNode.widget.float = targetNode.float;

        if (targetNode.float) {
          dragNode.widget.float_size = 6;
        } else {
          delete dragNode.widget.float_size;
        }
      }
    },
    removeFloating: function removeFloating() {
      var size = blocksBuilder.getColSize(this.dragNode);

      this.dragNode.removeClass('str-col-' + size);
      this.dragNode.removeClass(ns.floatingClass + '-left');
      this.dragNode.removeClass(ns.floatingClass + '-right');
      if (this.dragNode.widget) {
        this.dragNode.widget.float = null;
      }
    },
    clean: function clean() {
      this.builder.removeEmptyColumns();
      this.builder.removeUnnecessaryRows();
      this.builder.removeEmptyColumns();
      this.builder.removeEmptyRows();
      this.builder.removeEmptySections();
      this.builder.setupSizeColumns(false, this.dragNode);
    },
    isNewBlock: function isNewBlock(drag) {
      return drag.hasClass('new-str-block');
    },
    getDropInfo: function getDropInfo(Y) {
      if (Y === null || Y === undefined) {
        Y = false;
      }

      var result = null;
      var activeDropElement = Y.DD.DDM.activeDrop.get('node');

      if (blockDropOverlays.isOverlay(activeDropElement)) {
        activeDropElement = activeDropElement.ancestor(ns.blockClass);
      }

      var isSelf = activeDropElement.getStyle('visibility') === 'hidden';
      var region = activeDropElement.get('region');

      var leftRegion = region.left;
      var topRegion = region.top;
      var k = region.width + parseInt(activeDropElement.getComputedStyle('marginLeft'), 10) + parseInt(activeDropElement.getComputedStyle('marginRight'), 10);
      var l = region.height + parseInt(activeDropElement.getComputedStyle('marginTop'), 10) + parseInt(activeDropElement.getComputedStyle('marginBottom'), 10);
      var mousePos = Y.DD.DDM.activeDrag.mouseXY;

      var q = {
        x: mousePos[0] < leftRegion + k / 2 ? 'left' : 'right',
        y: mousePos[1] < topRegion + l / 2 ? 'top' : 'bottom'
      };

      leftRegion = 'left' === q.x ? mousePos[0] - leftRegion : leftRegion + k - mousePos[0];
      topRegion = 'top' === q.y ? mousePos[1] - topRegion : topRegion + l - mousePos[1];

      l = Math.min(k, l);
      k = 100 * leftRegion / k;

      mousePos = 100 * topRegion / l;
      l = k < mousePos ? q.x : q.y;

      leftRegion = k < mousePos ? leftRegion : topRegion;

      if (!isNaN(leftRegion)) {
        result = {
          node: activeDropElement,
          direction: l,
          distance: leftRegion,
          quad: q,
          region: region,
          isSelf: isSelf
        };
      }

      return result;
    }
  };

  return layoutDD;
}]);

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* injects from baggage-loader */



var indexOf = [].indexOf || function (item) {
  for (var i = 0, l = this.length; i < l; i++) {
    if (i in this && this[i] === item) {
      return i;
    }
  }
  return -1;
};

var moduleBlockDropOverlays = angular.module('services.layoutEditor.blockDropOverlays', ['services.editorNamespace']);

moduleBlockDropOverlays.factory('blockDropOverlays', ['$timeout', '$injector', 'ns', 'blocksBuilder', '$rootScope', 'TimeMachine', function ($timeout, $injector, ns, blocksBuilder, $rootScope, TimeMachine) {
  var Y = void 0;

  var blockDropOverlays = {
    init: function init(y) {
      Y = y;
    },
    widgetsWithoutOverlay: ['spacer'],
    destroyOverlays: function destroyOverlays() {
      var layoutEditor = $injector.get('layoutEditor');

      layoutEditor.layout.all(ns.blockDropOverlay).remove();
    },
    addOverlaysToBlocks: function addOverlaysToBlocks(drag) {
      var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var dragNode = void 0;

      if (event) {
        dragNode = event.currentTarget;
      } else {
        dragNode = drag.target.get('node');
      }

      var self = this;

      if (!blocksBuilder.isFloating(dragNode)) {
        var layoutEditor = $injector.get('layoutEditor');
        var newOverlay = Y.DOM.create('<div class=\'' + ns.blockDropOverlay.substr(1) + '\'></div>');
        var blocks = layoutEditor.layout.all(ns.blockClass);

        blocks.each(function (block) {
          var ref = block.widget.type;
          if (block.widget && indexOf.call(self.widgetsWithoutOverlay, ref) < 0) {
            block.append(newOverlay);
          }
        });

        var ref = dragNode.widget.type;
        if (indexOf.call(self.widgetsWithoutOverlay, ref) < 0) {
          dragNode.append(newOverlay);
        }
      }
    },
    createOverlays: function createOverlays(drag) {
      var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var self = this;

      if (event) {
        this.target = event.currentTarget.one(ns.widgetWrapperClass);
      } else {
        this.target = drag.target.get('node').one(ns.widgetWrapperClass);
      }

      if ($rootScope.widgetIsEditing) {
        return false;
      }

      this.addOverlaysToBlocks(drag, event);

      var layoutEditor = $injector.get('layoutEditor');
      var overlays = layoutEditor.layout.all(ns.blockDropOverlay);

      overlays.each(function (overlay) {
        var block = overlay.ancestor(ns.blockClass);
        var ref = block.widget.type;

        if (block.widget && indexOf.call(self.widgetsWithoutOverlay, ref) < 0) {
          overlay.setAttrs({
            'offsetWidth': block.get('offsetWidth'),
            'offsetHeight': block.get('offsetHeight')
          });
          var drop = new Y.DD.Drop({
            node: overlay
          });
        }
      });
    },
    getTarget: function getTarget(event) {
      return event.currentTarget.one(ns.widgetWrapperClass);
    },
    isOverlay: function isOverlay(element) {
      if (angular.isDefined(element.hasClass)) {
        return element.hasClass(ns.blockDropOverlay.substr(1));
      }
    }
  };
  return blockDropOverlays;
}]);

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* injects from baggage-loader */

/* globals Editor */
/* jshint browser: true */


var moduleDialogEditorBlock = angular.module('services.layoutEditor.blockEditDialog', ['services.editorNamespace']);

moduleDialogEditorBlock.factory('blockEditDialog', ['$timeout', '$injector', 'ns', 'Widget', 'Parallax', 'ContentAnimate', 'bgSlideShow', '$filter', 'Template', function ($timeout, $injector, ns, Widget, Parallax, ContentAnimate, bgSlideShow, $filter, Template) {
  var Y = void 0;

  var blockEditDialog = {
    currentBlock: undefined,
    currentBlockJson: undefined,
    scopeApply: function scopeApply() {
      return $(ns.settingsWindowClass).scope().$apply();
    },
    setYUI: function setYUI(y) {
      Y = y;
    },
    init: function init(y) {
      this.setYUI(y);
    },
    _onChangeWidget: function _onChangeWidget(newVal) {
      var self = this;

      this.currentBlock.one(ns.widgetWrapperClass).setStyles(newVal.style_attributes);
      switch (newVal.type) {
        case 'line':
          this._onLineChange(newVal);
          break;
        case 'button':
          this._onButtonChange(newVal);
          this._onButtonTwoChange(newVal);
          break;
        case 'video':
          this._onVideoChange(newVal, newVal);
          if (newVal.use_button) {
            this._onButtonChange(newVal);
          }
          break;
        case 'review':
          newVal.photos_attributes.forEach(function (photo) {
            if (photo.media_type === 'video') {
              self._onVideoChange(photo, newVal, '[data-slide-id=\'' + photo.id + '\'] .strw-review__video');
            }
          });
          break;
        case 'search':
          this._onSearchChange(newVal);
          break;
        case 'list':
          this._onListChange(newVal);
      }

      this.currentBlock.widget = newVal;
    },
    _onListChange: function _onListChange(newVal) {
      var _this = this;

      var list = this.currentBlock.one('ul.strbw_list');
      var bullets = list.all('li');
      var bulletsCaption = list.all('.strbw_list-item__caption');
      var paddingSplit = newVal.caption_style.padding.split(' ');
      var _newVal$caption_style = newVal.caption_style,
          border = _newVal$caption_style.border,
          color = _newVal$caption_style.color,
          fontFamily = _newVal$caption_style.fontFamily,
          fontSize = _newVal$caption_style.fontSize,
          fontWeight = _newVal$caption_style.fontWeight,
          padding = _newVal$caption_style.padding,
          borderRadius = _newVal$caption_style.borderRadius,
          backgroundColor = _newVal$caption_style.backgroundColor;


      list.setStyles({ backgroundColor: backgroundColor, borderRadius: borderRadius, border: border });
      bulletsCaption.setStyles({ padding: padding, color: color, fontFamily: fontFamily, fontWeight: fontWeight });
      bullets.setStyles({
        fontSize: fontSize,
        borderBottom: border,
        backgroundImage: 'url(' + newVal.image_attributes.source_url + ')',
        backgroundPosition: paddingSplit[3] + ' ' + paddingSplit[0]
      });

      if (newVal.icon) {
        if (newVal.icon.cssClass) {
          if (!list.hasClass('strbw_list_icon')) {
            list.addClass('strbw_list_icon');
          }
        } else {
          if (list.hasClass('strbw_list_icon')) {
            list.removeClass('strbw_list_icon');
          }
        }

        bullets.each(function (block) {
          _this.updateList($(block._node), Object.assign(newVal.icon, {
            top: paddingSplit[0],
            left: paddingSplit[3]
          }));
        });
      }

      var themes = ['none', 'strip', 'frame'];
      themes.map(function (item) {
        if (list.hasClass('strbw_list_' + item)) {
          list.removeClass('strbw_list_' + item);
        }
      });

      if (newVal.theme) {
        list.addClass('strbw_list_' + newVal.theme);
      }
    },
    /**
     * Обновление списка
     * @param $list
     * @param iconAttributes
     */
    updateList: function updateList($list, iconAttributes) {
      var cssClass = iconAttributes.cssClass,
          color = iconAttributes.color,
          backgroundColor = iconAttributes.backgroundColor,
          top = iconAttributes.top,
          left = iconAttributes.left;

      var iconNode = $list.find('.strbw_list__icon');

      // Очистим кнопку от всех элементов
      if (iconNode.length > 0) {
        iconNode.remove();
      }

      // Установка иконки, если она есть
      if (cssClass) {
        var _iconNode = $('<i class="strbw_list__icon ' + cssClass + '"></i>');

        _iconNode.attr('contenteditable', 'false');
        _iconNode.css({ color: color, backgroundColor: backgroundColor, top: top, left: left });
        $list.prepend(_iconNode);
      }
    },
    _onSearchChange: function _onSearchChange(newVal) {
      this.currentBlock.one('.strw__search-icon').setStyles(newVal.icon_style_attributes);
      this.currentBlock.one(ns.widgetSearchInputClass).setStyles(newVal.input_style_attributes);
    },
    /**
     * Изменение параметров кнопки
     * @param newVal
     * @private
     */
    _onButtonChange: function _onButtonChange(newVal) {
      var styles = newVal.button_attributes.style_attributes;
      var button = this.currentBlock.one(ns.widgetButtonClass);

      button.setStyles(styles);
      button.setAttribute('href', '#');
      button.setAttribute('onclick', '');

      this.updateBtn($(button._node), newVal.button_attributes);
    },
    /**
     * Изменение параметров второй кнопки
     * @param newVal
     * @returns {boolean}
     * @private
     */
    _onButtonTwoChange: function _onButtonTwoChange(newVal) {
      var buttonTwo = this.currentBlock.one(ns.widgetButtonTwoClass);
      var styles = newVal.button_two_attributes.style_attributes;

      if (newVal.button_type === 'one') {
        buttonTwo.setStyles({ display: 'none' });
        return false;
      }

      buttonTwo.setStyles({ display: 'inline-block' });
      buttonTwo.setStyles(styles);
      buttonTwo.setAttribute('href', '#');
      buttonTwo.setAttribute('onclick', '');

      this.updateBtn($(buttonTwo._node), newVal.button_two_attributes);
    },
    /**
     * Обновление кнопки
     * @param $button
     * @param buttonAttributes
     */
    updateBtn: function updateBtn($button, buttonAttributes) {
      var icon = buttonAttributes.icon,
          additional_text = buttonAttributes.additional_text;

      var iconNode = $button.find('.strwf_button__icon');
      var additionalTextNode = $button.find('.strwf_button__additional-text');

      // Очистим кнопку от всех элементов
      if (iconNode.length > 0) {
        iconNode.remove();
      }
      if (additionalTextNode.length > 0) {
        additionalTextNode.remove();
      }

      // Установка иконки, если она есть
      if (icon) {
        var _iconNode2 = $('<i class="strwf_button__icon ' + icon + '"></i>');

        _iconNode2.attr('contenteditable', 'false');
        $button.prepend(_iconNode2);
      }

      // Установка доп. текста, если он есть
      if (additional_text && additional_text.title) {
        var title = additional_text.title,
            color = additional_text.color,
            fontSize = additional_text.fontSize,
            fontFamily = additional_text.fontFamily,
            fontWeight = additional_text.fontWeight;

        var _additionalTextNode = $('<span class="strwf_button__additional-text">' + (title || '') + '</span>');

        _additionalTextNode.css({ color: color, fontSize: fontSize, fontFamily: fontFamily, fontWeight: fontWeight });
        _additionalTextNode.attr('contenteditable', 'false');
        $button.append(_additionalTextNode);
      }
    },
    _onLineChange: function _onLineChange(newVal) {
      var styles = {
        'height': newVal.height,
        'background-color': newVal.background_color,
        'color': newVal.background_color,
        'width': newVal.width
      };

      this.currentBlock.all(ns.widgetLineClass).setStyle('text-align', newVal.style_attributes.textAlign);
      this.currentBlock.all(ns.widgetLineContentClass).setStyles(styles);
      this.currentBlock.one(ns.widgetWrapperClass).setStyles({ color: newVal.background_color });
    },
    _onVideoChange: function _onVideoChange(newVal, widget, videoSelector) {
      if (videoSelector === null || videoSelector === undefined) {
        videoSelector = '.strwvideo';
      }

      var self = this;
      var sectionId = this.getSectionId(widget);

      Widget.getVideoHtml(sectionId, newVal.video_url).then(function (video) {
        var srcEq = void 0,
            videoHTMLparse = void 0;

        if (self.currentBlock.one('iframe') && widget.type === 'video') {
          srcEq = self.currentBlock.one('iframe').getAttribute('src') === $(video.html).find('iframe').attr('src');
        }

        if (srcEq) {
          return false;
        }

        if (widget.type === 'review') {
          videoHTMLparse = $('<div>' + video.html + '</div>').find('.strwvideo__iframe').html();
        } else {
          videoHTMLparse = $('<div>' + video.html + '</div>').find('.strwvideo').html();
        }

        self.currentBlock.one(videoSelector).setHTML(videoHTMLparse);
      });

      if (widget.type === 'video') {
        if (newVal.use_button) {
          this.currentBlock.one(videoSelector).setStyles({ display: 'none' });
          this.currentBlock.one(ns.widgetButtonClass).setStyles({ display: 'inline-block' });
        } else {
          this.currentBlock.one(videoSelector).setStyles({ display: 'block' });
          this.currentBlock.one(ns.widgetButtonClass).setStyles({ display: 'none' });
        }
      }
    },
    transformImageToBgUrl: function transformImageToBgUrl(url) {
      return 'url(' + url + ')';
    },
    sectionRemoveStyle: function sectionRemoveStyle(newVal) {
      Y.one('[data-section-id=\'' + newVal.id + '\']').setStyles(newVal.style_attributes);
    },
    sectionSaveTimeout: undefined,
    setGradient: function setGradient(section) {
      var color_start = section.background_attributes.color_start;
      var color_stop = section.background_attributes.color_stop;
      var gradient_css = 'background-image:-moz-linear-gradient(top, ' + color_start + ', ' + color_stop + '); background-image:-webkit-linear-gradient(top, ' + color_start + ', ' + color_stop + '); background-image:-o-linear-gradient(top, ' + color_start + ', ' + color_stop + '); background-image:-ms-linear-gradient(top, ' + color_start + ', ' + color_stop + ');, background-image:linear-gradient(top, ' + color_start + ', ' + color_stop + '); filter: progid:DXImageTransform.Microsoft.gradient(startColorStr=\'' + color_start + '\', endColorstr=\'' + color_stop + '\');';

      if ($('style#' + section.id).length > 0) {
        $('style#' + section.id).html('.ls_' + section.id + ':before { ' + gradient_css + ' }');
      } else {
        $('body').append('<style id=\'' + section.id + '\'>.ls_' + section.id + ':before { ' + gradient_css + ' }</style>');
      }
    },
    removeGradient: function removeGradient(section) {
      if ($('style#' + section.id).length > 0) {
        $('style#' + section.id).html('.ls_' + section.id + ':before { background-image:none; }');
      } else {
        $('body').append('<style id=\'' + section.id + '\'>.ls_' + section.id + ':before { background-image:none; }</style>');
      }
    },
    setEffectStyles: function setEffectStyles(newVal) {
      if (newVal.background_attributes.parallax) {
        Parallax.initSection(this.currentBlock);
      } else {
        Parallax.destroy(this.currentBlock);
      }
      if (newVal.background_attributes.gradient) {
        this.setGradient(newVal);
      } else {
        this.removeGradient(newVal);
      }
    },
    setBackgroundSlider: function setBackgroundSlider(section) {
      var css = 'background-color: ' + section.style_attributes.backgroundColor + '; content: \'\'; z-index: 2; position: absolute; width: 100%; height:100%; top:0; left:0;';
      if ($('style#' + section.id + '-slider').length > 0) {
        $('style#' + section.id + '-slider').html('.ls_' + section.id + ' > .swiper-container:before { ' + css + ' }');
      } else {
        $('body').append('<style id=\'' + section.id + '-slider\'>.ls_' + section.id + ' > .swiper-container:before { ' + css + ' }</style>');
      }
    },
    setBackground: function setBackground(section, old_section) {
      bgSlideShow.destroy(this.currentBlock);

      switch (section.background_attributes.type) {
        case 'image':
          this.currentBlock.all('.section__video-bg').remove();
          var bgImagesLength = section.background_attributes.images_attributes.length;
          if (bgImagesLength === 0) {
            section.style_attributes['backgroundImage'] = 'none';
          }
          if (bgImagesLength === 1) {
            var firstImage = section.background_attributes.images_attributes[0].url;
            section.style_attributes['backgroundImage'] = this.transformImageToBgUrl(firstImage);
          }
          if (bgImagesLength > 1) {
            bgSlideShow.initSection(this.currentBlock, section.style_attributes);
            this.setBackgroundSlider(section);
          }
          break;
        case 'video':
          var coverUrl = section.background_attributes.video_cover_url;
          var mp4Url = section.background_attributes.video_mp4_url;
          var oldmp4Url = old_section.background_attributes.video_mp4_url;
          var newType = section.background_attributes.type;
          var oldType = old_section.background_attributes.type;
          var loaderUrl = '/assets/images/pattern-squares.png';

          if (mp4Url === oldmp4Url && newType === oldType && this.currentBlock.all('.section__video-bg').size() > 0) {
            return false;
          }

          if (!mp4Url) {
            this.currentBlock.all('.section__video-bg').remove();
          } else {
            section.style_attributes['backgroundColor'] = 'rgba(255, 255, 255, 0)';
            this.currentBlock.prepend('<div class=\'section__video-bg\'>' + '<video class=\'section__video-element\' loop=\'\' muted=\'\' autoplay=\'autoplay\' poster=\'' + (coverUrl || loaderUrl) + '\'>' + '<source src=\'' + mp4Url + '\' type=\'video/mp4\'>' + '</video>' + '</div>');
            section.style_attributes['backgroundImage'] = 'none';
          }
      }
    },
    sectionContentCenter: function sectionContentCenter(newVal) {
      if (newVal.style_attributes.minHeight === '100vh') {
        this.currentBlock.one(ns.wrapperClass).addClass('str-wrapper_vertical-center');
      } else {
        this.currentBlock.one(ns.wrapperClass).removeClass('str-wrapper_vertical-center');
      }
    },
    _onChangeSection: function _onChangeSection(newVal, oldVal) {
      if (!angular.equals(newVal, oldVal)) {
        this.currentBlock.old_section = oldVal;
      }

      var layoutEditor = $injector.get('layoutEditor');
      var Slider = $injector.get('Slider');

      newVal = angular.copy(newVal);
      this.setBackground(newVal, oldVal);

      if (newVal.background_attributes.type === 'video') {
        newVal.style_attributes['backgroundImage'] = 'none';
      }

      if (Editor.mode === 'email.page.editor' || Editor.mode === 'form.page.editor') {
        this.currentBlock.setStyles(newVal.wrapper_style_attributes);
        this.changeBgType(newVal);
      }

      this.currentBlock.setStyles(newVal.style_attributes);

      if (newVal.background_attributes.images_attributes.length === 1) {
        this.currentBlock.setStyles({
          backgroundImage: 'url(' + newVal.background_attributes.images_attributes[0].source_url + ')'
        });

        if (!angular.equals(newVal.background_attributes.images_attributes, oldVal.background_attributes.images_attributes)) {
          Template.getStylesheet().then(function (response) {
            angular.element('#tplStyles').text(response);
          });
        }
      }

      this.currentBlock.one(ns.wrapperClass).setStyles(newVal.wrapper_style_attributes);
      Slider.updateSliders();

      this.sectionContentCenter(newVal);
      this.currentBlock.section = newVal;
      this.setEffectStyles(newVal);
      this.currentBlock.section = newVal;
    },
    changeBgType: function changeBgType(newVal) {
      if (newVal.bg_type === 'image') {
        if (newVal.background_attributes.images_attributes.length > 0) {
          newVal.style_attributes['backgroundColor'] = 'rgba(255, 255, 255, 0)';
          newVal.style_attributes['backgroundImage'] = 'url(' + newVal.background_attributes.images_attributes[0].url + ')';
        }
      }

      if (newVal.bg_type === 'color') {
        newVal.style_attributes['backgroundImage'] = 'none';
      }

      newVal.style_attributes['maxWidth'] = newVal.wrapper_style_attributes.maxWidth;
    },
    setPanelTitle: function setPanelTitle(blockJson) {
      var newVal = void 0;

      if (this.currentBlockType === 'section') {
        newVal = $filter('translate')('editor.section') + ' «' + blockJson.title + '»';
        if (Editor.mode === 'form.page.editor') {
          newVal = '' + $filter('translate')('editor.section.panelSettingsLabel');
        }
      }
      if (this.currentBlockType === 'widget') {
        newVal = $filter('translate')('editor.widget') + ' «' + blockJson.name + '»';
      }

      Y.one('.etsw-header__title').setHTML(newVal);
    },
    setBlock: function setBlock(e) {
      this.currentBlock = this.findBlockOrSection(e);
      this.currentBlockJson = this.currentBlock[this.currentBlockType];
    },
    getWidgetSettings: function getWidgetSettings() {
      return this.currentBlock.widget;
    },
    getSectionSettings: function getSectionSettings() {
      return this.currentBlock.section;
    },
    getBlockId: function getBlockId(e) {
      var node = e.target;
      var block = node.ancestor(ns.blockClass);
      var section = node.ancestor(ns.sectionClass) || node;

      if (block) {
        return block.widget.id;
      } else {
        return section.section.id;
      }
    },
    findBlockOrSection: function findBlockOrSection(e) {
      var node = e.target;
      var block = node.ancestor(ns.blockClass);
      var section = node.ancestor(ns.sectionClass) || node;

      if (block) {
        this.currentBlockType = 'widget';
        return block;
      } else {
        this.currentBlockType = 'section';
        return section;
      }
    },
    clearCurrentBlockJson: function clearCurrentBlockJson() {
      this.currentBlockJson = undefined;
    },
    getSectionId: function getSectionId(widget) {
      var sectionEl = Y.one('[data-block-id=\'' + widget.id + '\']').ancestor(ns.sectionClass);
      var sectionId = sectionEl.section.id;

      return sectionId;
    },
    destroy: function destroy() {
      if (this.dd) {
        this.dd.destroy();
      }
      if (this.dd) {
        this.dd._unprep();
      }
    }
  };

  return blockEditDialog;
}]);

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* injects from baggage-loader */



var _this = this;

var indexOf = [].indexOf || function (item) {
  for (var i = 0, l = this.length; i < l; i++) {
    if (i in this && this[i] === item) {
      return i;
    }
  }
  return -1;
};

var moduleEditorDragPanel = angular.module('services.layoutEditor.editorDragPanel', ['services.editorNamespace', 'services.layoutEditor.blockEditDialog']);

moduleEditorDragPanel.factory('editorDragPanel', ['$rootScope', '$timeout', '$injector', 'ns', 'blockEditDialog', 'Section', 'SectionLesson', 'Widget', 'Animation', 'Tutorials', 'TimeMachine', '$interval', '$filter', '$state', 'Modal', function ($rootScope, $timeout, $injector, ns, blockEditDialog, Section, SectionLesson, Widget, Animation, Tutorials, TimeMachine, $interval, $filter, $state, Modal) {
  var Y = void 0;

  var editorDragPanel = {
    self: _this,
    notEditableWidgets: ['spacer'],
    notSettingsWidgets: ['spacer', 'text', 'headline_h1', 'headline_h2', 'headline_h3'],
    cloneSectionDisabled: false,
    initSectionsPanels: function initSectionsPanels(y, mode) {
      Y = y;
      this.addPanelsSections();
      this.bindSectionsClickable();

      if (mode === 'editor.section' || mode === 'editor.email' || $rootScope.isCollectionPage) {
        this.deleteRemoveButton();
      }
    },
    initBlocksPanels: function initBlocksPanels() {
      this.addPanelsBlocks();
    },
    clearDialog: function clearDialog(fromRemove) {
      if (fromRemove === null || fromRemove === undefined) {
        fromRemove = false;
      }

      // const layoutEditor = $injector.get('layoutEditor');
      angular.element('[ng-controller=\'blockEditDialogCtrl\']').scope().clearDialog();

      var currentTab = $('.etsw-header').scope().currentNavEditorTab;

      this.cancelSection();
      $rootScope.layoutIsEditing = false;

      if (currentTab === 'blockSettings' && !fromRemove) {
        $rootScope.editorNavTab('sections');
        $timeout(function () {
          $('#mini-sections').perfectScrollbar('update');
        });
      }
    },
    destroyBlocksPanels: function destroyBlocksPanels() {
      // const layoutEditor = $injector.get('layoutEditor');
      this.clearDialog();

      Y.all(ns.dragPanelClass).remove();
    },
    removeDialog: function removeDialog(e) {
      var self = this;

      $rootScope.alertDialog({
        title: $filter('translate')('alert.block.removeTitle'),
        text: $filter('translate')('alert.block.removeDescription'),
        accept_text: $filter('translate')('alert.confirm'),
        cancel_text: $filter('translate')('alert.cancel'),
        accept: function accept() {
          self._onClickRemove(e);
        }
      });

      $rootScope.$apply();
    },
    setSectionTitle: function setSectionTitle(section, dp) {
      var title = void 0;
      var type = section.section.section_type;

      if (type === 'header' || type === 'footer') {
        var type_ru = type === 'header' ? $filter('translate')('editor.headerPlaceholder.title') : $filter('translate')('editor.footerPlaceholder.title');

        title = type_ru + ' - ' + section.section.title || '';
      } else {
        title = section.section.title || '';
      }

      if (Editor.mode !== 'form.page.editor') {
        dp.one('.etdp__title').set('innerHTML', title.toUpperCase());
      }

      dp.addClass(ns.dragPanelSectionClass.substr(1));
    },
    showEditorNav: function showEditorNav() {
      var $eTools = $('.e__tools');

      $eTools.scope().editorNavOpen = true;
      $eTools.scope().$apply();
    },
    showEditorNavWidget: function showEditorNavWidget() {
      var $eTools = $('.e__tools');

      $eTools.scope().editorNavOpenWidget = true;
      $eTools.scope().$apply();
    },
    turnAdaptor: function turnAdaptor(e, section) {
      var adaptorEl = e.target.hasClass('et__drag-panel') ? e.target : e.target.ancestor('.et__drag-panel');
      var adaptor = adaptorEl.getData('adaptor');

      section.section.adaptation[adaptor] = !section.section.adaptation[adaptor];

      if (section.section.adaptation[adaptor]) {
        adaptorEl.addClass('et__drag-panel_section-settings_adaptive-active');
      } else {
        adaptorEl.removeClass('et__drag-panel_section-settings_adaptive-active');
      }
    },
    /**
     * Панель секции
     * @param widget
     * @param section
     * @returns {Node}
     */
    dragPanelSectionWithEvents: function dragPanelSectionWithEvents(widget, section) {
      if (widget === null || widget === undefined) {
        widget = false;
      }
      if (section === null || section === undefined) {
        section = false;
      }

      var self = this;
      var dp = Y.Node.create(this.dragPanelSectionNode());
      var settingsButton = dp.one('.etdp__button_settings');

      settingsButton.on('click', function (e) {
        $rootScope.editorNavTab('blockSettings');
        self.showEditorNav();
        e.target = e.target.ancestor(ns.sectionClass);
        self._onClickEditSection(e);
      });

      var settingsText = $filter('translate')('editor.section.panelSettingsLabel');
      var editText = $filter('translate')('editor.section.edit');

      dp.one('.et__drag-panel_section-settings-text').append(settingsText);
      dp.one('.et__drag-panel-backdrop').append('<div class="et__drag-panel-backdrop_edit"> ' + '<svg width="16" height="16" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg" class="icon__fill icon__stroke icon__inline inline-wrapper">' + '<g><path d="M19.499 11.477v12h-19v-21h14"/><path d="M12.823 14.029l-4.949 2.121 2.121-4.951 10.678-10.677 2.828 2.828z"/></g>' + '</svg>' + '<div class="et__drag-panel-backdrop_edit-text">' + editText + '</div>' + '</div>');

      if (this.isMixerMode()) {
        if (section.section.interactive) {
          dp.one('.switch').removeClass('hidden');
          dp.one('.switch_drag-panel input')._node.checked = section.section.in_mixer_active;
          dp.one('.switch_drag-panel input').on('change', function () {
            self._onClickMixerToggleSection(this, section.section);
          });

          if (!section.section.in_mixer_active) {
            section.addClass('widget-wrapper_mixer-disabled');
          }
        } else {
          dp.one('.et__drag-panel_section').setStyles({ display: 'none' });
        }
      }

      if (section._node.tagName.toLowerCase() === 'section' && !Editor.option) {
        var cloneButton = Y.Node.create('<div class="etdp__button etdp__button_clone">' + '<svg class="icon__fill icon__stroke icon__inline" width="16" height="16" viewBox="0 0 19 25" xmlns="http://www.w3.org/2000/svg">' + '<path d="M12.007 1.007l-.007-.007h-8v21h14v-21h-6zm-1.007 6.993v8m4-4h-8m7.5 10.057v2.443h-14v-20h3"/>' + '</svg> ' + '</div>');

        cloneButton.on('click', this._onClickCloneSection, this);
        dp.one(ns.dragPanelTable).append(cloneButton);

        // Добавление кнопки FavoriteSection
        var favoriteButton = Y.Node.create(this.dragPanelFavoriteNode);
        favoriteButton.on('click', this._onClickCreateFavoriteSection, this);
        dp.one(ns.dragPanelTable).append(favoriteButton);
      }

      if (Editor.option) {
        dp.one('.etdp__button_drag').remove();
        dp.one('.et__drag-panel_section-settings_adaptive-wrapper').remove();
      }

      if (section.section.for_email) {
        dp.one('.et__drag-panel_section-settings_adaptive-wrapper').remove();
      } else {
        if (!Editor.option) {
          _.map(section.section.adaptation, function (enabled, platform) {
            if (enabled) {
              dp.one('.et__drag-panel_section-settings_adaptive-' + platform).addClass('et__drag-panel_section-settings_adaptive-active');
            }
          });
          dp.all('[data-adaptor]').each(function (button) {
            button.on('click', function (e) {
              self.turnAdaptor(e, section);
            });
          });
        }
      }

      var removeButton = Y.Node.create(this.dragPanelRemoveNode);
      removeButton.on('click', this.removeDialog, this);

      if (!Editor.option) {
        dp.one(ns.dragPanelTable).append(removeButton);
      }

      if (section && section.section) {
        this.setSectionTitle(section, dp);
      }

      if (Editor.mode === 'form.page.editor') {
        dp.one('.et__drag-panel_section-settings_adaptive-wrapper').remove();
        dp.one('.et__drag-panel_section').remove();
        if (!section.section.style_attributes.maxWidth) {
          section.section.wrapper_style_attributes.maxWidth = '500px';
          section.section.style_attributes.padding = '0px 0px 0px 0px';
        }
      }

      if (Editor.mode === 'site.page.editor') {
        var btnPower = dp.one('.etdp__button_power');
        var sectionEl = Y.one('[data-section-id=\'' + section.section.id + '\']');
        var sectionType = section.section.section_type;

        if (sectionType === 'header') {
          btnPower.removeClass('hidden');

          if ($rootScope.currentSite.header_enabled) {
            btnPower.addClass('active');
          } else {
            sectionEl.addClass('str-section_darkened');
          }
        }

        if (sectionType === 'footer') {
          btnPower.removeClass('hidden');
          if ($rootScope.currentSite.footer_enabled) {
            btnPower.addClass('active');
          } else {
            sectionEl.addClass('str-section_darkened');
          }
        }

        btnPower.on('click', function (e) {
          self._onClickEnableSection(e, sectionEl, sectionType);
        });
      }

      return dp;
    },
    /**
     *
     * @param e
     * @param sectionEl
     * @param sectionType
     * @private
     */
    _onClickEnableSection: function _onClickEnableSection(e, sectionEl, sectionType) {
      var isEnabled = void 0;

      if (sectionType === 'header') {
        isEnabled = !$rootScope.currentSite.header_enabled;
        $rootScope.currentSite.header_enabled = isEnabled;
        this._toggleTurn(e, isEnabled, sectionEl);
      }

      if (sectionType === 'footer') {
        isEnabled = !$rootScope.currentSite.footer_enabled;
        $rootScope.currentSite.footer_enabled = isEnabled;
        this._toggleTurn(e, isEnabled, sectionEl);
      }
    },
    /**
     *
     * @param e
     * @param isEnabled
     * @param sectionEl
     * @private
     */
    _toggleTurn: function _toggleTurn(e, isEnabled, sectionEl) {
      var btnPowerEl = e.target.hasClass('etdp__button_power') ? e.target : e.target.ancestor('.etdp__button_power');

      if (isEnabled) {
        btnPowerEl.addClass('active');
        sectionEl.removeClass('str-section_darkened');
      } else {
        btnPowerEl.removeClass('active');
        sectionEl.addClass('str-section_darkened');
      }
    },
    /**
     *
     * @param input
     * @param section
     * @private
     */
    _onClickMixerToggleSection: function _onClickMixerToggleSection(input, section) {
      var layoutEditor = $injector.get('layoutEditor');
      var sectionEl = Y.one('[data-section-id=\'' + section.id + '\']');

      section.in_mixer_active = input._node.checked;

      layoutEditor.updateSectionEtag(angular.copy(section));

      if (Editor.option === 'lesson.page.mixer') {
        SectionLesson.updateForMixer({
          id: section.id,
          in_mixer_active: section.in_mixer_active
        }).then($rootScope.publishSite);
      } else {
        Section.update_for_mixer({
          id: section.id,
          in_mixer_active: section.in_mixer_active
        }).then($rootScope.publishSite);
      }

      if (!section.in_mixer_active) {
        sectionEl.addClass('widget-wrapper_mixer-disabled');
        this.cancelSection();
      } else {
        sectionEl.removeClass('widget-wrapper_mixer-disabled');
      }
    },
    /**
     * Панель виджета
     * @param widget
     * @param section
     * @returns {Node}
     */
    dragPanelWidgetWithEvents: function dragPanelWidgetWithEvents(widget, section) {
      if (widget === null || widget === undefined) {
        widget = false;
      }
      if (section === null || section === undefined) {
        section = false;
      }

      var self = this;
      var dp = Y.Node.create(this.dragPanelNode());

      dp.one('.etdp__title').set('innerHTML', widget.name);
      dp.addClass(ns.dragPanelWidgetClass.substr(1));

      var settingsButton = Y.Node.create(this.dragPanelSettingsNode);
      settingsButton.on('click', function (e) {
        $rootScope.editorNavTab('blockSettings');
        self.showEditorNavWidget();
        e.target = e.target.ancestor(ns.blockClass);
        self._onClickWidgetSettings(e);
      });

      var ref = widget.type;
      if (indexOf.call(this.notSettingsWidgets, ref) < 0) {
        dp.one(ns.dragPanelTable).append(settingsButton);
      }

      if (this.isMixerMode() && widget.interactive) {
        dp.one('.switch').removeClass('hidden');
        dp.one('.switch_drag-panel input')._node.checked = widget.in_mixer_active;
        dp.one('.switch_drag-panel input').on('change', function () {
          self._onClickMixerToggleWidget(this, widget);
        });

        if (!widget.in_mixer_active) {
          Y.one('.str-bw_' + widget.id).addClass('widget-wrapper_mixer-disabled');
        }
      }

      var cloneButton = Y.Node.create('<div class="etdp__button etdp__button_clone">' + '<svg class="icon__fill icon__stroke icon__inline" width="16" height="16" viewBox="0 0 19 25" xmlns="http://www.w3.org/2000/svg">' + '<path d="M12.007 1.007l-.007-.007h-8v21h14v-21h-6zm-1.007 6.993v8m4-4h-8m7.5 10.057v2.443h-14v-20h3"/>' + '</svg> ' + '</div>');
      cloneButton.on('click', this._onClickCloneWidget, this);

      if (!Editor.option) {
        dp.one(ns.dragPanelTable).append(cloneButton);
      }

      var removeButton = Y.Node.create(this.dragPanelRemoveNode);
      removeButton.on('click', this.removeDialog, this);

      if (!Editor.option) {
        dp.one(ns.dragPanelTable).append(removeButton);
      }

      return dp;
    },
    /**
     *
     * @param input
     * @param widget
     * @private
     */
    _onClickMixerToggleWidget: function _onClickMixerToggleWidget(input, widget) {
      var layoutEditor = $injector.get('layoutEditor');
      var widgetEl = Y.one('.str-bw_' + widget.id);

      widget.in_mixer_active = input._node.checked;
      $rootScope.widgetsIsMixer = {};
      $rootScope.widgetsIsMixer[widget.id] = widget.in_mixer_active;

      var sectionId = blockEditDialog.getSectionId({ id: widget.id });

      Widget.updateForMixer(sectionId, {
        id: widget.id,
        in_mixer_active: widget.in_mixer_active
      });

      $timeout(function () {
        var updatedSection = angular.copy(layoutEditor.layout.section);
        layoutEditor.updateSectionEtag(updatedSection);

        $rootScope.publishSite();
      }, 200);

      if (!widget.in_mixer_active) {
        widgetEl.addClass('widget-wrapper_mixer-disabled');
      } else {
        widgetEl.removeClass('widget-wrapper_mixer-disabled');
      }
    },
    /**
     *
     * @param section
     * @returns {boolean}
     */
    bindSectionClickable: function bindSectionClickable(section) {
      var ref = section.section.section_type;

      if ($state.includes('site.collection') && (ref === 'footer' || ref === 'header')) {
        return false;
      }

      var intBlockExists = false;
      section.all('.str-block').each(function (block) {
        if (block.widget && block.widget.interactive) {
          intBlockExists = true;
        }
      });

      if (!section.section.interactive && this.isMixerMode() && !intBlockExists) {
        return false;
      }

      section.detach('click', this._onClickEditSection, this);
      section.on('click', this._onClickEditSection, this);
    },
    bindSectionsClickable: function bindSectionsClickable() {
      Y.all(ns.sectionClass).each(this.bindSectionClickable, this);
    },
    /**
     *
     * @param block
     * @returns {boolean}
     */
    addPanelsBlock: function addPanelsBlock(block) {
      if (!block.widget) {
        return false;
      }
      if (!block.widget.interactive && this.isMixerMode()) {
        return false;
      }

      if (this.isMixerMode()) {
        block.addClass('str-widget__mixer');
      }

      // const layoutEditor = $injector.get('layoutEditor');
      var dragPanel = this.dragPanelWidgetWithEvents(block.widget);

      if (block.one(ns.dragPanelClass)) {
        block.one(ns.dragPanelClass).remove();
      }

      block.prepend(dragPanel);
      block.detach('mouseup', this._onClickWidgetSettings, this);
      block.on('mouseup', this._onClickWidgetSettings, this);
    },
    addPanelsBlocks: function addPanelsBlocks() {
      var layoutEditor = $injector.get('layoutEditor');

      layoutEditor.layout.all(ns.blockClass).each(this.addPanelsBlock, this);
    },
    /**
     *
     * @param e
     * @private
     */
    _onClickCloneWidget: function _onClickCloneWidget(e) {
      var layoutEditor = $injector.get('layoutEditor');
      var insertBlockMenu = $injector.get('insertBlockMenu');
      var blocksBuilder = $injector.get('blocksBuilder');
      var blockDragDrop = $injector.get('blockDragDrop');
      var sectionId = layoutEditor.layout.section.id;
      var widgetId = e.target.ancestor(ns.blockClass).widget.id;
      var widgetMin_size = e.target.ancestor(ns.blockClass).widget.min_size;
      var clone = {};
      var type = e.target.ancestor(ns.blockClass).widget.type;
      var node = blocksBuilder.createBlock(ns.blockLoader, type);
      var dropTarget = e.target.ancestor(ns.blockClass);
      // const dropTargetRow = dropTarget.ancestor(ns.rowClass);

      clone.min_size = widgetMin_size;
      node.widget = {
        min_size: widgetMin_size
      };

      var availColSize = blocksBuilder.getAvailableColSize(e.target.ancestor(ns.rowClass), e.target.ancestor(ns.colClass), false, true);
      if (availColSize >= widgetMin_size) {
        var direction = 'right';
        blockDragDrop.insertSideOverride(direction, node, dropTarget, clone);
      }

      if (availColSize < widgetMin_size) {
        var _direction = 'bottom';
        blocksBuilder.insertRow(_direction, node, dropTarget);
      }

      blockDragDrop.clean();
      insertBlockMenu.updateWidgetsOnResize();
      Widget.clone(sectionId, widgetId).then(function (clone) {
        insertBlockMenu.afterCreateWidget(node, clone, false, type, false);
        layoutEditor.setHandleBlocks(node);
        insertBlockMenu.updateWidgetsOnResize();
      });
    },
    /**
     *
     * @param e
     * @returns {boolean}
     * @private
     */
    _onClickCloneSection: function _onClickCloneSection(e) {
      if (this.cloneSectionDisabled) {
        return false;
      }
      var editorNavSections = $injector.get('editorNavSections');
      editorNavSections.newSectionType = 'default';
      var sectionEl = e.target.ancestor(ns.sectionClass);
      // const sectionId = sectionEl.section.id;
      editorNavSections.cloning = true;
      var newSection = editorNavSections.buildNewSection(e.target.ancestor(ns.sectionClass), true);

      sectionEl.insert(newSection, 'after');
      newSection.addClass('str-cloned__section');
      Animation.scrollTo($(newSection._node));
      editorNavSections.bindSectionOnDropInTemplate(newSection);
    },

    _onClickCreateFavoriteSection: function _onClickCreateFavoriteSection(e) {
      var sectionEl = e.target.ancestor(ns.sectionClass);

      Modal.favoriteSectionSettings(sectionEl.section);
    },

    removeAllSettingsClasses: function removeAllSettingsClasses() {
      Y.all(ns.blockSettingsEditing).removeClass(ns.blockSettingsEditing.substr(1));
    },
    /**
     *
     * @param e
     * @returns {*}
     */
    addActiveSettingsClass: function addActiveSettingsClass(e) {
      var blockEditDialog = $injector.get('blockEditDialog');
      this.removeAllSettingsClasses();
      var block = blockEditDialog.findBlockOrSection(e);
      block.addClass(ns.blockSettingsEditing.substr(1));
      if (Editor.mode === 'editor.email' || Editor.mode === 'form.page.editor') {
        block.addClass(ns.blockSettingsEditing_noshadow);
      }
    },
    /**
     *
     * @param value
     * @returns {jQuery}
     */
    htmlDecode: function htmlDecode(value) {
      return $('<div/>').html(value).text();
    },
    /**
     *
     * @param value
     * @returns {jQuery}
     */
    htmlEncode: function htmlEncode(value) {
      return $('<div/>').text(value).html();
    },
    /**
     *
     * @param e
     * @returns {boolean}
     * @private
     */
    _onClickWidgetSettings: function _onClickWidgetSettings(e) {
      var blockDropOverlays = $injector.get('blockDropOverlays');
      var dragPanel = e.target.ancestor(ns.dragPanelTable);

      if (!blockDropOverlays.target) {
        blockDropOverlays.createOverlays(false, e);
        e.target = blockDropOverlays.getTarget(e);
      } else {
        e.target = blockDropOverlays.target;
      }

      var widgetType = e.target.ancestor(ns.blockClass).widget.type;

      if (indexOf.call(this.notEditableWidgets, widgetType) >= 0) {
        return false;
      }

      var layoutEditor = $injector.get('layoutEditor');
      if (!dragPanel && e.target) {
        var blockDragDrop = $injector.get('blockDragDrop');
        this._onClickSettings(e);
        if (widgetType !== 'text' && widgetType !== 'headline_h1' && widgetType !== 'headline_h2' && widgetType !== 'headline_h3') {
          this.showEditorNavWidget();
        } else {
          var $eTools = $('.e__tools');

          $eTools.scope().editorNavOpenWidgetText = true;
          $eTools.scope().$apply();

          if (CKEDITOR.instances[e.target.ancestor(ns.blockClass).one(ns.widgetWrapperClass)._yuid]) {
            var CKinstance = CKEDITOR.instances[e.target.ancestor(ns.blockClass).one(ns.widgetWrapperClass)._yuid];
            var focusManager = new CKEDITOR.focusManager(CKinstance);
            focusManager.focus();
            e.target.ancestor(ns.blockClass).one(ns.widgetWrapperClass).focus();
          }
        }
        layoutEditor.layout.addClass('et__drag-panel-wrapper_widget-editing');
        blockDropOverlays.target = void 0;
        blockDragDrop.widgetsPreCapture();
      }
    },
    /**
     *
     * @param e
     * @private
     */
    _onClickSettings: function _onClickSettings(e) {
      var insertBlockMenu = $injector.get('insertBlockMenu');

      insertBlockMenu.hide();
      this.addActiveSettingsClass(e);

      var blockEditDialogCtrl = $('[ng-controller="blockEditDialogCtrl"]').scope();
      blockEditDialogCtrl.setValues(e);
      blockEditDialog.setPanelTitle(blockEditDialog.currentBlockJson);

      if (!blockEditDialogCtrl.$$phase) {
        blockEditDialogCtrl.$apply();
      }
    },
    /**
     *
     * @param section
     * @returns {boolean}
     */
    addPanelSection: function addPanelSection(section) {
      var ref = section.section.section_type;
      if ($state.includes('site.collection') && (ref === 'footer' || ref === 'header')) {
        return false;
      }

      var intBlockExists = false;
      section.all('.str-block').each(function (block) {
        if (block.widget && block.widget.interactive) {
          intBlockExists = true;
        }
      });

      if (!section.section.interactive && this.isMixerMode() && !intBlockExists) {
        return false;
      }

      if (this.isMixerMode()) {
        section.addClass('str-section__mixer');
      }

      var dragPanel = this.dragPanelSectionWithEvents(false, section);
      dragPanel.addClass(ns.dragPanelSectionClass.substr(1));
      section.prepend(dragPanel);
    },
    addPanelsSections: function addPanelsSections() {
      Y.all('.tpl-wrapper > ' + ns.sectionClass).each(this.addPanelSection, this);
    },
    /**
     * Событие редактирования секции
     * @param e
     * @param layoutEditor
     */
    startEditingLayout: function startEditingLayout(e, layoutEditor) {
      var layout = e.target.ancestor(ns.sectionClass) || e.target;

      if (layout) {
        layout.one(ns.dragPanelClass).addClass('et__drag-panel-wrapper_editing');
        layout.addClass('section-editing');
        layoutEditor.initEditingLayout(layout);
      }
    },
    /**
     * Обработка события клика по секции
     * @param e
     * @param withCapture
     * @param withSave
     * @returns {boolean}
     * @private
     */
    _onClickEditSection: function _onClickEditSection(e, withCapture, withSave) {
      if (withCapture === null || withCapture === undefined) {
        withCapture = true;
      }
      if (withSave === null || withSave === undefined) {
        withSave = true;
      }
      var self = this;
      var saveSection = $('[ng-controller=\'EditorNavigationCtrl\']').scope().saveSectionWithoutTimeout;
      var currentSection = $('[ng-controller=\'blockEditDialogCtrl\']').scope().section;
      var layoutEditor = $injector.get('layoutEditor');
      var targetSection = e.target.ancestor(ns.sectionClass);
      var targetBlock = e.target.ancestor(ns.blockClass) || e.target.hasClass(ns.blockClass.substr(1));
      var dragPanel = e.target.ancestor(ns.dragPanelTable);

      if (targetBlock) {
        return false;
      }

      if (layoutEditor.layout && withSave && currentSection) {
        saveSection(angular.copy(currentSection));
      }

      if (!layoutEditor.layout && !dragPanel) {
        self.startEditingLayout(e, layoutEditor);
        self._onClickSettings(e);
        return true;
      }

      if (layoutEditor.layout) {
        var editingLayoutId = layoutEditor.layout.section.id;
        var clickedLayoutId = targetSection && targetSection.section.id || e.target.section.id;

        if (editingLayoutId === clickedLayoutId && !dragPanel && !targetBlock) {
          self._onClickSettings(e);
          layoutEditor.layout.removeClass('et__drag-panel-wrapper_widget-editing');
        } else if (!dragPanel) {
          self.cancelSection();
          self.startEditingLayout(e, layoutEditor);
          self._onClickSettings(e);
        }
      }
    },
    cancelSection: function cancelSection() {
      var layoutEditor = $injector.get('layoutEditor');
      var layout = layoutEditor.layout;
      if (!layout) {
        return false;
      }

      layout.one(ns.dragPanelClass).removeClass('et__drag-panel-wrapper_editing');

      var Text = $injector.get('Text');
      Text.destroy();
      if (layout) {
        layout.removeClass('section-editing');
      }

      layoutEditor.cancelEditingLayout(layout);
    },
    saveLayout: function saveLayout() {
      var layoutEditor = $injector.get('layoutEditor');
      layoutEditor.save();
    },
    afterLastWidgetRemove: function afterLastWidgetRemove(widget) {
      var builder = $injector.get('blocksBuilder');
      var insertBlockMenu = $injector.get('insertBlockMenu');
      var widgetLength = widget.ancestor(ns.sectionClass).all(ns.blockClass).size();

      if (widgetLength === 1) {
        var newBlock = insertBlockMenu.createAndInitBlock({}, widget.ancestor(ns.rowClass), 'spacer');
        builder.insertRow('top', newBlock, widget.ancestor(ns.rowClass));
      }
    },
    showDropBackdrop: function showDropBackdrop() {
      Y.one('.str-drop-backdrop').addClass('no-sections');
      Y.one('.str-drop-backdrop').removeClass('ng-hide');
    },
    afterLastSectionRemove: function afterLastSectionRemove() {
      var length = Y.all('section:not(.str-removed)').size();
      if (!length) {
        this.showDropBackdrop();
      }
    },
    /**
     *
     * @param widget
     */
    setSectionSettingsAfterWidgetRemove: function setSectionSettingsAfterWidgetRemove(widget) {
      var e = {};
      e.target = widget.ancestor(ns.sectionClass);

      this._onClickSettings(e);
    },
    captureRemove: function captureRemove(section) {
      var sectionHTML = section.get('outerHTML');
      var prevSectionId = section.previous() && section.previous().getData('section-id') || undefined;

      TimeMachine.capture('removeSection', section.section, sectionHTML, prevSectionId);
    },
    /**
     *
     * @param section
     * @param withCapture
     */
    removeSection: function removeSection(section, withCapture) {
      if (withCapture === null || withCapture === undefined) {
        withCapture = true;
      }

      var self = this;
      // const sectionId = section.section.id;

      section.section.removed = true;
      Animation.slideUp(section);

      if (withCapture) {
        this.captureRemove(section);
      }

      $timeout(function () {
        section.addClass('str-removed');
        section.edited = true;
        $rootScope.toggleCommonSections();
        self.clearDialog(true);
        self.afterLastSectionRemove();
      }, 200);

      $(window).trigger('scroll');
    },
    /**
     *
     * @param widget
     */
    removeWidget: function removeWidget(widget) {
      var insertBlockMenu = $injector.get('insertBlockMenu');
      var layoutEditor = $injector.get('layoutEditor');
      var blockDragDrop = $injector.get('blockDragDrop');

      this.afterLastWidgetRemove(widget);
      this.setSectionSettingsAfterWidgetRemove(widget);

      widget.remove();
      blockDragDrop.clean();
      insertBlockMenu.updateWidgetsOnResize();

      $timeout(function () {
        layoutEditor.save();
      }, 200);

      blockDragDrop.widgetsCapture();
    },
    /**
     *
     * @param e
     * @private
     */
    _onClickRemove: function _onClickRemove(e) {
      var widget = e.target.ancestor(ns.blockClass);
      var blocksBuilder = $injector.get('blocksBuilder');
      var layoutEditor = $injector.get('layoutEditor');
      var self = this;

      if (widget) {
        var col = widget.ancestor(ns.colClass);
        var sectionId = layoutEditor.layout.section.id;
        var widgetJson = widget.widget;

        widgetJson.removed = true;
        Widget.update(sectionId, widgetJson);

        if (col.all(ns.blockClass).size() === 1) {
          // const colSize = blocksBuilder.getColSize(col);
          col.setStyles({
            opacity: 0,
            width: 0
          });
          blocksBuilder.updateColSize(widget.ancestor(ns.colClass), 0);
        }

        $timeout(function () {
          self.removeWidget(widget);
        }, 200);
      } else {
        var section = e.target.ancestor(ns.sectionClass);
        this.removeSection(section);
      }
    },
    _mouseenter: function _mouseenter(e) {
      var target = e.target.ancestor(ns.sectionClass);
      if (target) {
        target.addClass('str-section-hover');
      }
    },
    _mouseleave: function _mouseleave(e) {
      var target = e.target.ancestor(ns.sectionClass);
      if (target) {
        target.removeClass('str-section-hover');
      }
    },
    destroy: function destroy() {
      Y.all(ns.dragPanelClass).remove();
    },
    deleteRemoveButton: function deleteRemoveButton() {
      Y.all('section ' + ns.dragPanelRemoveButton).remove();
    },
    dragPanelSettingsNode: '<div class="etdp__button etdp__button_settings">' + '<svg width="16" height="16" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg" class="icon__fill icon__stroke icon__inline">' + '<g><path d="M19.499 11.477v12h-19v-21h14"/><path d="M12.823 14.029l-4.949 2.121 2.121-4.951 10.678-10.677 2.828 2.828z"/></g>' + '</svg>' + '</div>',
    dragPanelRemoveNode: '<div class="etdp__button etdp__button_remove">' + '<svg class="icon__fill icon__stroke icon__inline" width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">' + '<path d="M3.5 23.5h16v-20h-16zm4-20h8v-3h-8zm-6.5 0h22m-15.5 3.5v12m4-12v12m4-12v12" />' + '</svg>' + '</div>',
    dragPanelFavoriteNode: '<div class="etdp__button etdp__button_favorite">' + '<svg width="16" height="16" class="icon__fill icon__stroke icon__inline" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.867 53.867" enable-background="new 0 0 53.867 53.867">' + '<path d="M26.934 1.318l8.322 16.864 18.611 2.705-13.467 13.126 3.179 18.536-16.645-8.751-16.646 8.751 3.179-18.536-13.467-13.126 18.611-2.705z" stroke="#979797" stroke-width="4" fill="none"></path>' + '</svg>' + '</div>',
    dragPanelSectionNode: function dragPanelSectionNode() {
      return "<div class='et__drag-panel-wrapper'> " + "<div class='et__drag-panel-backdrop'></div> " + "<div class='et__drag-panel et__drag-panel_section-settings'> " + "<div class='etdp__button etdp__button_settings'>" + "<svg class='et__drag-panel_section-settings-icon' width='18' height='18' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>" + "<path d='M20.254 13.5h3.246v-3h-3.247c-.209-.867-.551-2.181-1.003-2.922l2.296-2.295-2.829-2.829-2.297 2.296c-.74-.452-2.053-.793-2.92-1.002v-3.248h-3v3.248c-.867.209-2.181.55-2.921 1.002l-2.297-2.296-2.829 2.829 2.297 2.296c-.452.74-.794 2.054-1.004 2.921h-3.246v3h3.246c.21.867.552 2.181 1.004 2.921l-2.297 2.297 2.829 2.828 2.296-2.297c.741.453 2.055.795 2.922 1.005v3.246h3v-3.246c.867-.21 2.181-.552 2.92-1.004l2.298 2.296 2.828-2.828-2.296-2.297c.452-.74.794-2.054 1.004-2.921zm-3.754-1.5c0 2.486-2.015 4.5-4.5 4.5s-4.5-2.014-4.5-4.5c0-2.485 2.015-4.5 4.5-4.5s4.5 2.015 4.5 4.5z' fill='none' stroke='#FFF'/>" + "</svg> " + "<span class='et__drag-panel_section-settings-text'></span> " + "</div> " + "</div> " + "<div class='et__drag-panel_section-settings_adaptive-wrapper'> " + "<div data-adaptor='desktop' class='et__drag-panel et__drag-panel_section-settings et__drag-panel_section-settings_adaptive-desktop'> " + "<svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' height='18px' width='20px' viewBox='0 0 560 500' enable-background='new 0 0 560 500' xml:space='preserve'> " + "<path fill-rule='evenodd' clip-rule='evenodd' fill='#FFFFFF' d='M471.2,0H88.8C40.2,0,0.6,39.6,0.6,88.2v264.7 c0,48.7,39.6,88.3,88.2,88.3h32.1c-1.6,4.6-2.7,9.5-2.7,14.7c0,24.4,19.7,44.1,44.1,44.1h235.3c24.4,0,44.1-19.7,44.1-44.1 c0-5.2-1.1-10.1-2.7-14.7h32.2c48.6,0,88.2-39.6,88.2-88.3V88.2C559.4,39.6,519.8,0,471.2,0z M500.6,352.9 c0,16.3-13.2,29.5-29.4,29.5H88.8c-16.3,0-29.4-13.2-29.4-29.5V88.2c0-16.2,13.1-29.4,29.4-29.4h382.4c16.2,0,29.4,13.2,29.4,29.4 V352.9z'/> " + "</svg> " + "</div> " + "<div data-adaptor='tablet' class='et__drag-panel et__drag-panel_section-settings et__drag-panel_section-settings_adaptive-tablet'> " + "<svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' height='18px' width='15px' viewBox='0 0 420 500' enable-background='new 0 0 420 500' xml:space='preserve'> " + "<path fill-rule='evenodd' clip-rule='evenodd' fill='#FFFFFF' d='M335,0H85C39.1,0,1.7,37.4,1.7,83.3v333.4 C1.7,462.6,39.1,500,85,500h250c45.9,0,83.3-37.4,83.3-83.3V83.3C418.3,37.4,380.9,0,335,0z M210,458.3c-11.5,0-20.9-9.4-20.9-20.9 c0-11.5,9.4-20.8,20.9-20.8c11.5,0,20.9,9.3,20.9,20.8C230.9,449,221.5,458.3,210,458.3z M362.8,388.9H57.2V83.3 C57.2,68,69.6,55.5,85,55.5h250c15.4,0,27.8,12.5,27.8,27.8V388.9z'/> " + "</svg> " + "</div> " + "<div data-adaptor='mobile' class='et__drag-panel et__drag-panel_section-settings et__drag-panel_section-settings_adaptive-mobile'> " + "<svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' height='18px' width='12px' viewBox='0 0 316 500' enable-background='new 0 0 316 500' xml:space='preserve'> " + "<path fill-rule='evenodd' clip-rule='evenodd' fill='#FFFFFF' d='M250.1,0H65.9C29.6,0,0.1,29.5,0.1,65.8v368.5 c0,36.3,29.5,65.8,65.9,65.8h184.2c36.3,0,65.8-29.5,65.8-65.8V65.8C315.9,29.5,286.4,0,250.1,0z M151.4,460.5 c-18.1,0-32.8-11.8-32.8-26.3c0-14.6,14.7-26.3,32.8-26.3c18.2,0,32.9,11.8,32.9,26.3C184.3,448.8,169.6,460.5,151.4,460.5z M276.5,381.6H39.5V65.8h236.9V381.6z'/> " + "</svg> " + "</div> " + "</div> " + "<div class='etdp__title etdp__title_section'></div> " + "<div class='et__drag-panel et__drag-panel_section'> " + "<div class='et__drag-panel-table clearfix'> " + "<div class='etdp__button etdp__button_power hidden'> " + "<svg width='33px' height='33px' viewBox='0 0 33 33' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'> " + "<title>" + $filter('translate')('editor.section.turnOn') + "</title> " + "<defs></defs> <g id='Page-2-Copy' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'> <g id='85' transform='translate(1.000000, 0.000000)'> " + "<path d='M15,10.9796047 C15,11.5323532 15.4438648,11.9804443 16,11.9804443 L16,11.9804443 C16.5522847,11.9804443 17,11.5254261 17,10.9796047 L17,1.00083963 C17,0.448091163 16.5561352,-1.77635684e-15 16,-1.77635684e-15 L16,-1.77635684e-15 C15.4477153,-1.77635684e-15 15,0.45501823 15,1.00083963 L15,10.9796047 L15,10.9796047 Z' id='Rectangle-509' fill='#ffffff' fill-rule='evenodd'></path> " + "<path d='M0.871869243,21.5794795 C3.89414939,29.8831259 13.075627,34.1645192 21.3792735,31.1422391 C29.6829199,28.119959 33.9643133,18.9384813 30.9420331,10.6348349 C30.7531406,10.115857 30.1792982,9.84826989 29.6603203,10.0371624 C29.1413424,10.2260549 28.8737554,10.7998973 29.0626479,11.3188752 C31.707143,18.5845658 27.9609238,26.6183587 20.6952332,29.2628539 C13.4295425,31.907349 5.39574961,28.1611298 2.75125448,20.8954392 C0.106759355,13.6297485 3.85297851,5.59595561 11.1186692,2.95146048 C11.6376471,2.76256797 11.9052342,2.18872562 11.7163416,1.66974771 C11.5274491,1.15076981 10.9536068,0.883182725 10.4346289,1.07207523 C2.13098242,4.09435538 -2.15041091,13.275833 0.871869243,21.5794795 L0.871869243,21.5794795 L0.871869243,21.5794795 Z M10.4346289,31.1422391 C18.7382753,34.1645192 27.919753,29.8831259 30.9420331,21.5794795 C33.9643133,13.275833 29.6829199,4.09435538 21.3792735,1.07207523 C20.8602956,0.883182725 20.2864532,1.15076981 20.0975607,1.66974771 C19.9086682,2.18872562 20.1762553,2.76256797 20.6952332,2.95146048 C27.9609238,5.59595561 31.707143,13.6297485 29.0626479,20.8954392 C26.4181527,28.1611298 18.3843598,31.907349 11.1186692,29.2628539 C3.85297851,26.6183587 0.106759355,18.5845658 2.75125448,11.3188752 C2.94014699,10.7998973 2.67255991,10.2260549 2.15358201,10.0371624 C1.6346041,9.84826989 1.06076175,10.115857 0.871869243,10.6348349 C-2.15041091,18.9384813 2.13098242,28.119959 10.4346289,31.1422391 L10.4346289,31.1422391 L10.4346289,31.1422391 Z' id='Oval-45' fill='#ffffff' fill-rule='nonzero'></path> " + "</g> </g> " + "</svg> " + "</div> " + "<label for='interactive" + new Date().getTime() + "' class='switch switch_drag-panel hidden'> " + "<input type='checkbox' id='interactive" + new Date().getTime() + "' class='switch-input ng-pristine ng-untouched ng-valid'> " + "<span data-on='' data-off='' class='switch-label'></span>" + "<span class='switch-handle'></span> " + "</label> " + "<div class='etdp__button etdp__button_drag icon-drag'> " + "<svg class='icon__fill icon__stroke icon__inline' width='12' height='12' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>" + "<path d='M6.148 1.003l-.005-.003h-5.143v9h9v-9h-3.857zm13 0l-.005-.003h-5.143v9h9v-9h-3.857zm-13 13l-.005-.003h-5.143v9h9v-9h-3.857zm13 0l-.005-.003h-5.143v9h9v-9h-3.857z'/>" + "</svg> " + "</div> " + "</div> " + "</div> " + "</div>";
    },
    dragPanelNode: function dragPanelNode() {
      return "<div class='et__drag-panel-wrapper'> " + "<div class='et__drag-panel-backdrop'></div> " + "<div class='et__drag-panel'> " + "<div class='et__drag-panel-table clearfix'> " + "<div class='etdp__title'></div> " + "<label for='interactive" + new Date().getTime() + "' class='switch switch_drag-panel hidden'> " + "<input type='checkbox' id='interactive" + new Date().getTime() + "' class='switch-input ng-pristine ng-untouched ng-valid'> " + "<span data-on='' data-off='' class='switch-label'></span>" + "<span class='switch-handle'></span> " + "</label> " + "</div> " + "</div> " + "</div>";
    },

    isMixerMode: function isMixerMode() {
      return ['site.page.mixer', 'lesson.page.mixer'].indexOf(Editor.option) !== -1;
    }
  };

  return editorDragPanel;
}]);

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* injects from baggage-loader */

/*jshint browser: true */


var moduleInsertBlockMenu = angular.module('services.layoutEditor.insertBlockMenu', ['services.editorNamespace', 'services.layoutEditor.blockDragDrop']);

moduleInsertBlockMenu.factory('insertBlockMenu', ['$timeout', '$injector', 'ns', 'editorDragPanel', 'Widget', 'Restangular', 'Spacer', 'Section', 'Slider', 'Animation', 'MapInit', '$rootScope', 'Tutorials', 'Timer', 'FrameForm', 'SubscribeFormManager', '$filter', 'ImageInit', 'ButtonActionsManager', function ($timeout, $injector, ns, editorDragPanel, Widget, Restangular, Spacer, Section, Slider, Animation, MapInit, $rootScope, Tutorials, Timer, FrameForm, SubscribeFormManager, $filter, ImageInit, ButtonActionsManager) {
  var Y = void 0;

  var insertBlockMenu = {
    menu: null,
    point: {},
    ddInstances: [],
    blocksState: [],
    init: function init(y) {
      Y = y;
      this.menu = Y.one('.et-block-list_window');
      this.initDD();
    },
    destroy: function destroy() {
      this.destroyDD();
    },
    initDD: function initDD() {
      var parent = this;
      var blocksMenu = Y.all(ns.menuBlockClass);

      blocksMenu.each(function (v) {
        var dd = new Y.DD.Drag({
          node: v,
          target: {
            padding: '0 0 0 20'
          }
        }).plug(Y.Plugin.DDProxy, {
          moveOnEnd: false
        }).plug(Y.Plugin.DDWinScroll);

        parent.setEvents(dd, Y, v);
        parent.ddInstances.push(dd);
        parent.blocksState.push({
          id: v._yuid,
          lock: false
        });
      });
    },
    lockWidgets: function lockWidgets() {
      if (this.ddInstances) {
        this.ddInstances.forEach(function (v) {
          v.set('lock', true);
        });
      }

      if (this.blocksState.length > 0) {
        this.blocksState.forEach(function (state) {
          state.lock = true;
        });
      }
    },
    unlockWidgets: function unlockWidgets() {
      if (this.ddInstances) {
        this.ddInstances.forEach(function (v) {
          v.set('lock', false);
        });
      }

      if (this.blocksState.length > 0) {
        this.blocksState.forEach(function (state) {
          state.lock = false;
        });
      }
    },
    widgetIsLock: function widgetIsLock(block) {
      var isLock = false;

      if (this.blocksState.length > 0) {
        this.blocksState.every(function (state) {
          if (block._yuid === state.id) {
            isLock = state.lock;
            return false;
          } else {
            return true;
          }
        });
      }

      return isLock;
    },
    destroyDD: function destroyDD() {
      var blocksMenu = Y.all(ns.menuBlockClass);

      blocksMenu.each(function (v) {
        var id = v.get('id');
        var dd = Y.DD.DDM.getDrag('#' + id);

        if (dd) {
          dd.destroy();
        }

        if (dd) {
          dd._unprep();
        }
      });
    },
    show: function show(point) {
      if ($(this.menu._node).scope().widgetMenuShow) {
        return false;
      }

      Y.one(window).on('click', this.customBlur);
      Y.one(window).on('scroll', this._onScroll, this);

      this.point = point;
      $(this.menu._node).scope().widgetMenuShow = true;

      if (!$(this.menu._node).scope().$$phase) {
        $(this.menu._node).scope().$apply();
      }

      return this.position(point, this.menu);
    },
    hide: function hide() {
      Y.one(window).detach('click', this.customBlur);
      Y.one(window).detach('scroll', this._onScroll, this);
      this.hideMenu();
    },
    isOpen: function isOpen() {
      return this.menu.hasClass(ns.blockMenuClassShow);
    },
    _onScroll: function _onScroll() {
      if (this.isOpen()) {
        this.hide();
      }
    },
    updateWidgetsOnResize: function updateWidgetsOnResize() {
      Slider.updateSliders();
      FrameForm.updateFrameForms(this.targetNode);
    },
    isBlockType: function isBlockType(block, type) {
      if (block) {
        return block.hasClass('str-bw_' + type);
      }
    },
    customBlur: function customBlur(e) {
      var target = e.target;
      var notIP = !target.hasClass(ns.insertPointClass);
      var notBlockMenu = !target.ancestor(ns.blockMenuClass);

      if (notIP && notBlockMenu) {
        insertBlockMenu.hide();
      }
    },
    setEvents: function setEvents(dd, Y, blockMenu) {
      var blockDragDrop = $injector.get('blockDragDrop');
      var layoutEditor = $injector.get('layoutEditor');

      dd.before('drag:start', blockDragDrop._beforeDragStart);
      dd.on('drag:start', this._onDragStart, blockDragDrop);
      dd.on('drag:over', blockDragDrop._onDragOver, blockDragDrop);
      dd.on('drag:end', blockDragDrop._onDragEnd, blockDragDrop);
      dd.after('drag:end', this._afterDragEnd, this);

      if (layoutEditor.isTouchEnabled()) {
        blockMenu.detach('click', blockDragDrop._onClick, blockDragDrop);
        blockMenu.on('click', blockDragDrop._onClick, blockDragDrop);
      } else {
        blockMenu.detach('click', Tutorials._sectionDropTutorial, Tutorials);
        blockMenu.on('click', Tutorials._sectionDropTutorial, Tutorials);
      }
    },
    _afterDragEnd: function _afterDragEnd() {},
    _onDragStart: function _onDragStart(e) {
      this.widgetsPreCapture();
      this._onDragStart(e, true);
    },
    getWidgetType: function getWidgetType(block) {
      return $(block._node).scope().block.type;
    },
    newGuid: function newGuid() {
      var s4 = function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
      };
      return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    },
    addAttributes: function addAttributes(node, widget, target, type) {
      node.setAttribute('data-block-id', widget.id);
      node.one(ns.widgetWrapperClass).addClass('str-bw_' + widget.id);
      node.widget = Restangular.stripRestangular(widget);

      if (target && target.float) {
        node.widget.float = target.float;
        node.widget.float_size = 6;
      } else {
        delete node.widget.float;
        delete node.widget.float_size;
      }

      if (target) {
        target.float = undefined;
      }
    },
    hideMenu: function hideMenu() {
      $(this.menu._node).scope().widgetMenuShow = false;
      if (!$(this.menu._node).scope().$$phase) {
        $(this.menu._node).scope().$apply();
      }
    },
    afterCreateWidget: function afterCreateWidget(node, widget, target, type, showSettings) {
      if (showSettings === null || showSettings === undefined) {
        showSettings = true;
      }

      $(node._node).slideUp(0);

      var blockOverlays = $injector.get('blockOverlays');
      var ContentEditable = $injector.get('ContentEditable');
      var insertBlockMenu = $injector.get('insertBlockMenu');

      this.addAttributes(node, widget, target, type);

      editorDragPanel.addPanelsBlock(node);
      var contentHtml = widget.html;

      if (type !== 'text') {
        node.one(ns.widgetWrapperClass).setContent(contentHtml);
        ContentEditable.bind(node, true);
      }

      if (type === 'code') {
        var codeHTML = '<div class="str-bw_code-html-overlay">' + '<img class="str-bw_code-html-overlay-icon" src="/constructor/editor/assets/images/code-overlay-icon.svg" />' + '<div class="str-bw_code-html-overlay-text">' + $filter('translate')('widget.code.text') + '</div>' + '</div>';
        node.one('.str-bw_code-html').setContent(codeHTML);
      }

      if (type === 'facebook_comment') {
        var fbHTML = '<div class="str-bw_code-html-overlay str-bw_code-html-overlay_fb">' + '<img class="str-bw_code-html-overlay-icon" src="/constructor/editor/assets/images/code-overlay-icon.svg" />' + '<div class="str-bw_code-html-overlay-text">' + $filter('translate')('widget.comments.text') + '</div>' + '</div>';
        node.one('.strw-fb-comments').setContent(fbHTML);
      }

      this._onCreatingEnd(node, contentHtml);
      $timeout(function () {
        $(node._node).slideDown(200, function () {
          var blockDragDrop = $injector.get('blockDragDrop');
          blockDragDrop._afterDragEnd();
        });
      });
      $timeout(function () {
        insertBlockMenu.unlockWidgets();
      }, 1000);
      $timeout(function () {
        blockOverlays.addOverlaysToBlocks();
      }, 300);
    },
    createWidgetError: function createWidgetError(node, target, type) {
      var blockDragDrop = $injector.get('blockDragDrop');
      node.remove();
      this._onCreatingEnd(node, '');
      blockDragDrop.clean();
    },
    setBlankContentHtml: function setBlankContentHtml(type, node, target) {
      var self = this;
      var section = target.ancestor(ns.sectionClass).section;
      var insertBlockMenu = $injector.get('insertBlockMenu');

      Widget.create(section.id, type, section.is_template).then(function (widget) {
        self.afterCreateWidget(node, widget, target, type);
      }, function () {
        insertBlockMenu.unlockWidgets();
        self.createWidgetError(node, target, type);
      });
    },
    widgetInitializer: function widgetInitializer(node, contentHtml) {
      if (this.isBlockType(node, 'text')) {
        this.initAsTextBlock(node, contentHtml);
      }
      if (this.isBlockType(node, 'headline_h1')) {
        this.initAsTextBlock(node, contentHtml);
      }
      if (this.isBlockType(node, 'headline_h2')) {
        this.initAsTextBlock(node, contentHtml);
      }
      if (this.isBlockType(node, 'headline_h3')) {
        this.initAsTextBlock(node, contentHtml);
      }
      if (this.isBlockType(node, 'map')) {
        MapInit.initMap(0, $(node._node).find('.strw__map'));
      }

      var sliderWidget = node.one('.' + ns.sliderClass);

      if (sliderWidget) {
        Slider.initSlider(0, sliderWidget._node);
      }
      if (this.isBlockType(node, 'timer')) {
        var timerWidget = node.one('.strbw-timer');
        Timer.initTimer(0, timerWidget._node);
      }
      if (this.isBlockType(node, 'subscribe_form')) {
        SubscribeFormManager.updateOptions(node.widget);
      }
      if (this.isBlockType(node, 'image')) {
        ImageInit.updateOptions(node.widget);
      }
      if (this.isBlockType(node, 'link')) {
        ButtonActionsManager.updateOptions(node.widget);
      }
      if (this.isBlockType(node, 'button')) {
        ButtonActionsManager.updateOptions(node.widget);
      }
      if (this.isBlockType(node, 'card')) {
        ButtonActionsManager.updateOptions(node.widget);
      }
      if (this.isBlockType(node, 'product')) {
        node.widget.product_items_attributes.map(function (widget, id) {
          if (widget.item_type === 'button') {
            ButtonActionsManager.updateOptions(node.widget.product_items_attributes[id]);
          }
        });
      }
    },
    _onCreatingEnd: function _onCreatingEnd(node, contentHtml) {
      var self = this;

      node.one(ns.widgetWrapperClass).setStyles(node.widget.style_attributes);
      Y.one(document).detach('click', this.customBlur);
      Y.one(window).detach('scroll', this._onScroll, this);

      $timeout(function () {
        self.widgetInitializer(node, contentHtml);
      }, 150);
    },
    initAsTextBlock: function initAsTextBlock(block, contentHtml) {
      var Text = $injector.get('Text');
      var blockinner = block.one(ns.widgetWrapperClass);

      Text.editBlockInit(blockinner);
      Text.setData(block, contentHtml);

      if (CKEDITOR.instances[blockinner._yuid]) {
        CKEDITOR.instances[blockinner._yuid].on('change', Text._onChangeText, Text);
      } else {
        console.error('CKEDITOR instance ' + blockinner._yuid + ': Not found!');
      }
    },
    createAndInitBlock: function createAndInitBlock(block, target, manual) {
      if (manual === null || manual === undefined) {
        manual = false;
      }

      var layoutEditor = $injector.get('layoutEditor');
      var blocksBuilder = $injector.get('blocksBuilder');

      var type = void 0;
      if (!manual) {
        type = this.getWidgetType(block);
      } else {
        type = manual;
      }

      var node = blocksBuilder.createBlock(ns.blockLoader, type);

      if ($(block._node).scope() && $(block._node).scope().block) {
        node.widget = {
          min_size: $(block._node).scope().block.min_size
        };
      }

      layoutEditor.setHandleBlocks(node);
      this.setBlankContentHtml(type, node, target);

      return node;
    },
    position: function position(point, element) {
      var elPosX = point.getXY()[0] + 14;
      var elPosY = point.getXY()[1];

      var bottom = $(window).scrollTop() + $(window).height();
      var right = $(window).scrollLeft() + $(window).width();
      var height = $(element._node).height();
      var width = $(element._node).width();
      var overBottom = elPosY + height > bottom;
      var overRight = elPosX + width > right;
      var overTop = elPosY - height - $(window).scrollTop() < 0;
      var overLeft = elPosX - width < 0;

      if (overBottom) {
        elPosY -= height + 5;
        elPosX -= width / 2 - 10;
      } else if (overTop) {
        elPosX += 27;
        elPosY += 30;
      }

      if (overRight) {
        elPosX -= width + 10;
      }

      if (overTop && overRight) {
        elPosX += width / 2 + 50;
      }

      if (overBottom && overRight) {
        elPosX += width / 2 + 50;
      }

      if (overLeft) {
        elPosY += 30;
      }

      if (overLeft && overBottom) {
        elPosX += width / 2 + 17;
      }

      if (overTop && overLeft) {
        elPosY -= 60;
        elPosX += 0;
      }

      if (!overBottom && !overTop && !overRight && !overLeft) {
        elPosX += 25;
        elPosY -= height / 2 - 10;
      }

      return element.setXY([elPosX, elPosY]);
    }
  };
  return insertBlockMenu;
}]);

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* injects from baggage-loader */



var moduleLayoutEditor = angular.module('services.layoutEditor', ['wysiwyg.initializer', 'timer.initializer', 'form.initializer', 'subscribe_form.initializer', 'spacer.initializer', 'slider.initializer', 'parallax.initializer', 'contentAnimate.initializer', 'contentEditable.initializer', 'bgSlideShow.initializer', 'map.initializer', 'button_actions.initializer', 'image.initializer', 'services.editorNamespace', 'services.layoutEditor.insertSpace', 'services.layoutEditor.blockDragDrop', 'services.layoutEditor.blocksBuilder', 'services.layoutEditor.editorDragPanel', 'services.layoutEditor.insertBlockMenu', 'services.layoutEditor.sectionDragDrop', 'services.layoutEditor.blockEditDialog', 'services.layoutEditor.blockDropOverlays', 'services.layoutEditor.blockOverlays', 'services.layoutEditor.blockDragScroll', 'services.layoutEditor.timemachine', 'services.layoutEditor.timemachine.acts']);

moduleLayoutEditor.factory('layoutEditor', ['$timeout', 'Template', 'insertSpace', 'blockDragDrop', 'blockDropOverlays', 'sectionDragDrop', 'ns', 'blocksBuilder', 'editorDragPanel', 'insertBlockMenu', 'blockEditDialog', 'Text', 'Spacer', 'Section', '$state', 'Site', '$window', '$rootScope', 'blockDragScroll', '$injector', 'Notification', 'Slider', 'MapInit', 'ImageInit', 'ContentEditable', 'Parallax', 'ContentAnimate', 'bgSlideShow', 'TimeMachine', 'Timer', 'Email', 'SectionEmail', 'SectionWebForm', 'SectionLesson', 'FrameForm', 'SubscribeFormManager', 'ButtonActionsManager', function ($timeout, Template, insertSpace, blockDragDrop, blockDropOverlays, sectionDragDrop, ns, blocksBuilder, editorDragPanel, insertBlockMenu, blockEditDialog, Text, Spacer, Section, $state, Site, $window, $rootScope, blockDragScroll, $injector, Notification, Slider, MapInit, ImageInit, ContentEditable, Parallax, ContentAnimate, bgSlideShow, TimeMachine, Timer, Email, SectionEmail, SectionWebForm, SectionLesson, FrameForm, SubscribeFormManager, ButtonActionsManager) {
  var Y = void 0;

  if ($state.current.name === 'email.page.editor') {
    Section = SectionEmail;
  }

  if ($state.current.name === 'form.page.editor') {
    Section = SectionWebForm;
  }

  if (['lesson.page.editor', 'lesson.page.mixer'].indexOf($state.current.name) !== -1) {
    Section = SectionLesson;
  }

  var layoutEditor = {
    /**
     * save
     */
    save: function save() {
      var self = this;

      // Действие перед сохранением с использованием текущего layout (# Установка текста перед сохранением)
      Section.beforeSave(self.layout);

      // Обновление текущего layout
      self.layout.section.structure = Section.generateJSON(self.layout.one(ns.wrapperClass));

      // Сохранение json
      self.setJSONtoSection(self.layout.section);
    },

    /**
     * publicSectionSave
     */
    publicSectionSave: function publicSectionSave() {
      var self = this;

      Section.save(this.layout).then(function (section) {
        self.setJSONtoSection(section);
        $rootScope.$broadcast("get:styles", section.id);
        Notification.success({
          message: 'Секция успешно сохранена'
        });
      }, function () {
        Notification.error({
          message: 'Извините, что-то пошло не так'
        });
      });
    },

    /**
     * publicEmailSave
     */
    publicEmailSave: function publicEmailSave() {
      var self = this;

      Email.save(this.layout).then(function (section) {
        self.setJSONtoSection(section);
        $rootScope.$broadcast("get:styles", section.id);
        Notification.success({
          message: 'Письмо успешно сохранено'
        });
      }, function () {
        Notification.error({
          message: 'Извините, что-то пошло не так'
        });
      });
    },

    /**
     * sortSections
     * @returns {boolean}
     */
    sortSections: function sortSections() {
      var ref = Editor.mode;

      var availableEditorModes = ['site.page.editor', 'email.page.editor', 'lesson.page.editor'];

      if (!availableEditorModes.includes(ref)) {
        return false;
      }

      var sectionsIds = [];
      var sectionlist = Y.all(ns.sectionClass + ":not(.str-removed)");

      sectionlist.each(function (s, index) {
        sectionsIds.push(s.section.id);
      });
      Section.sort(sectionsIds);
    },

    createFromCollection: function createFromCollection() {
      Section.create(this.layout).then(function () {});
    },

    /**
     * setTemplateJSON
     * @param data
     * @returns {boolean}
     */
    setTemplateJSON: function setTemplateJSON(data) {
      if (!data) {
        return false;
      }
      if (Array.isArray(data)) {
        this.setJSONtoSections(data);
      } else {
        this.setJSONtoSection(data);
      }
    },

    /**
     * setJSONtoSections
     * @param sections
     */
    setJSONtoSections: function setJSONtoSections(sections) {
      var self = this;
      _.each(sections, function (section) {
        self.setJSONtoSection(section);
      });
    },

    /**
     * setJsonToRows
     * @param rows
     * @param sectionNode
     */
    setJsonToRows: function setJsonToRows(rows, sectionNode) {
      var self = this;
      _.each(rows, function (row) {
        _.each(row.cols, function (col) {
          if (col.rows) {
            self.setJsonToRows(col.rows, sectionNode);
          } else {
            _.each(col.widgets, function (widget) {
              var widgetEl = sectionNode.one("[data-block-id=" + widget.id + "]");

              if (widgetEl) {
                widgetEl.widget = widget;
              }
            });
          }
        });
      });
    },

    /**
     * setJSONtoSection
     * @param section
     */
    setJSONtoSection: function setJSONtoSection(section) {
      var id = section.id;
      var sectionNode = $rootScope.Y.one(".tpl-wrapper > [data-section-id=" + id + "]");

      if (sectionNode) {
        this.updateSectionEtag(section);

        sectionNode.section = section;
        sectionNode.old_section = section;

        this.setJsonToRows(section.structure.rows, sectionNode);
      }
    },

    /**
     * Deep diff between two object, using lodash
     * @param  {Object} object Object compared
     * @param  {Object} base   Object to compare with
     * @return {Object}        Return a new object who represent the diff
     */
    difference: function difference(object, base) {
      function changes(object, base) {
        return _.transform(object, function (result, value, key) {
          if (!_.isEqual(value, base[key])) {
            result[key] = _.isObject(value) && _.isObject(base[key]) ? changes(value, base[key]) : value;
          }
        });
      }

      return changes(object, base);
    },

    /**
     * updateSectionEtag
     * @param section
     */
    updateSectionEtag: function updateSectionEtag(section) {

      var previousSection = this.getRootScopeParameter('previousSection', section.id);

      if (!!previousSection && !_.isEqual(previousSection, section)) {
        var timestamp = Date.now().toString();

        console.log('Section #' + section.id + ' have update - ' + timestamp);

        section.etag = timestamp;

        this.setRootScopeParameter('previousSection', section.id, section);
        this.setRootScopeParameter('sectionVersions', section.id, timestamp);
      }

      if (!!previousSection === false) {
        this.setRootScopeParameter('previousSection', section.id, section);
      }
    },

    /**
     * getRootScopeParameter
     * @param parameter
     * @param id
     * @returns {*}
     */
    getRootScopeParameter: function getRootScopeParameter(parameter, id) {
      if ($rootScope[parameter]) {
        return $rootScope[parameter][id] || null;
      } else {
        return null;
      }
    },


    /**
     * setRootScopeParameter
     * @param parameter
     * @param id
     * @param value
     */
    setRootScopeParameter: function setRootScopeParameter(parameter, id, value) {
      if (!$rootScope[parameter]) {
        $rootScope[parameter] = {};
      }

      $rootScope[parameter][id] = _.cloneDeep(value);
    },


    /**
     * setFontToJsonWidgets
     * @param layout
     * @param fonts
     */
    setFontToJsonWidgets: function setFontToJsonWidgets(layout, fonts) {
      var default_font = fonts["default"] || "Open Sans";
      var default_h_font = fonts.h || "Open Sans";

      layout.all(".str-bw_navigation").each(function (w) {
        w.widget.style_attributes.fontFamily = default_font;
      });
      layout.all(".str-bw_list").each(function (w) {
        w.widget.style_attributes.fontFamily = default_font;
        w.widget.caption_style.fontFamily = default_font;
      });
      layout.all(".str-bw_form").each(function (w) {
        w.widget.form_fields_style_attributes.fontFamily = default_font;
        w.widget.labels_style_attributes.fontFamily = default_font;
        w.widget.button.style.fontFamily = default_font;
      });
      layout.all(".str-bw_card").each(function (w) {
        w.widget.wrapper_style.fontFamily = "";
        w.widget.title_style.fontFamily = default_h_font;
        w.widget.price_style.fontFamily = default_h_font;
        w.widget.description_style.fontFamily = default_font;
        w.widget.button_attributes.style_attributes.fontFamily = default_font;
      });
      layout.all(".str-bw_button").each(function (w) {
        w.widget.button_attributes.style_attributes.fontFamily = default_font;
        w.widget.button_attributes.style_attributes.fontFamily = default_font;
      });
      layout.all(".str-bw_product").each(function (w) {
        var i, len, productItem, ref, results;
        ref = w.widget.product_items_attributes;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          productItem = ref[i];
          productItem.caption_style_attributes.fontFamily = default_font;
          productItem.text_style_attributes.fontFamily = default_font;
          results.push(productItem.button_attributes.style_attributes.fontFamily = default_font);
        }
        return results;
      });
      layout.all(".str-bw_review").each(function (w) {
        w.widget.text_style.fontFamily = default_font;
        w.widget.name_style.fontFamily = default_h_font;
        w.widget.vocation_style.fontFamily = default_h_font;
      });
      layout.all(".str-bw_link").each(function (w) {
        w.widget.button_attributes.style_attributes.fontFamily = default_font;
      });
      layout.all(".str-bw_slider").each(function (w) {
        w.widget.caption_style.fontFamily = default_font;
      });
    },

    /**
     * initDDsections
     */
    initDDsections: function initDDsections() {
      var self = this;
      if (!Editor.option) {
        var sectionlist = Y.all(ns.sectionClass);
        sectionlist.each(function (v, k) {
          var tagname = v.get('tagName').toLowerCase();

          if (tagname === "section") {
            self.setHandleSections(v);
          }
          if (tagname === "footer" || tagname === "header") {
            return new Y.DD.Drop({
              node: v
            });
          }
        });
      }
    },

    /**
     * initDDblocks
     */
    initDDblocks: function initDDblocks() {
      this.destroyDDblocks();

      var self = this;
      var blocklist = this.layout.all(ns.blockClass);

      blocklist.each(function (v, k) {
        self.setHandleBlocks(v);
      });
    },

    /**
     * initDDSingle
     * @param v
     * @returns {*}
     */
    initDDSingle: function initDDSingle(v) {
      var dd = new Y.DD.Drag({
        node: v,
        target: {
          padding: '0 0 0 20'
        }
      }).plug(Y.Plugin.DDProxy, {
        cloneNode: true,
        moveOnEnd: false,
        flyBack: false
      });
      return dd;
    },

    /**
     * setHandleBlocks
     * @param v
     */
    setHandleBlocks: function setHandleBlocks(v) {
      var dd = this.initDDSingle(v);
      var widgetsIsLocked = this.layout.section.lock_widgets && Editor.mode === 'site.page.editor' || Editor.option;

      dd.set('lock', widgetsIsLocked);
      dd.addHandle(ns.dragPanelClass);

      blockDragDrop.setEvents(dd, Y);
    },

    isTouchEnabled: function isTouchEnabled() {
      return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    },

    /**
     * setHandleSections
     * @param v
     */
    setHandleSections: function setHandleSections(v) {
      if (!this.isTouchEnabled()) {
        var dd = this.initDDSingle(v);
        dd.addHandle(ns.dragPanelClass);

        sectionDragDrop.setEvents(dd, Y);
      }
    },

    /**
     * destroyDDblocks
     * @returns {boolean}
     */
    destroyDDblocks: function destroyDDblocks() {
      if (!this.layout) {
        return false;
      }
      var blocklist = this.layout.all(ns.blockClass);
      this.destroyDDSingle(blocklist);
    },

    /**
     * destroyDDsections
     */
    destroyDDsections: function destroyDDsections() {
      var sectionlist = Y.all(ns.sectionClass);
      this.destroyDDSingle(sectionlist);
    },

    /**
     * destroyDDSingle
     * @param list
     * @returns {*}
     */
    destroyDDSingle: function destroyDDSingle(list) {
      return list.each(function (v, k) {
        var dd, dr, id;
        id = v.get('id');
        dd = Y.DD.DDM.getDrag('#' + id);
        dr = Y.DD.DDM.getDrop('#' + id);
        if (dd) {
          dd.destroy();
        }
        if (dr) {
          dr.destroy();
        }
        if (dd) {
          dd._unprep();
        }
      });
    },

    /**
     * clearWidgetsStyle
     * @param sectionId
     */
    clearWidgetsStyle: function clearWidgetsStyle(sectionId) {
      var cssStylesheet = angular.element("#tplStyle").get(0);
      var section = angular.element("[data-section-id='" + sectionId + "']");

      section.find(ns.widgetWrapperClass).removeAttr("style");
    },

    /**
     * templateIsBlank
     * @returns {boolean}
     */
    templateIsBlank: function templateIsBlank() {
      return !Y.one(ns.tplContainer).contains(Y.one(ns.sectionClass));
    },

    /**
     * Инициализация редактирования секции
     * @param layout
     */
    initEditingLayout: function initEditingLayout(layout) {
      layout.edited = true;
      this.layout = layout;
      this.initDDblocks();

      editorDragPanel.initBlocksPanels();
      blocksBuilder.initResizers();
      Text.init(Y);
      Spacer.init(Y);
      $rootScope.layoutIsEditing = true;
      ContentEditable.bind(layout, true);
      Slider.init(Y);
      $rootScope.$apply();
    },

    /**
     * cancelEditingLayout
     */
    cancelEditingLayout: function cancelEditingLayout() {
      editorDragPanel = $injector.get("editorDragPanel");
      ContentEditable.bind(this.layout, false, false);
      this.destroyDDblocks();
      Text.destroy();
      Spacer.destroy();
      this.layout = null;
      editorDragPanel.removeAllSettingsClasses();
      blockEditDialog.clearCurrentBlockJson();
      if (!$rootScope.$$phase) {
        $rootScope.$apply();
      }
    },

    /**
     * widgetInitializers
     * @param Y
     */
    widgetInitializers: function widgetInitializers(Y) {
      Slider.init(Y);
      MapInit.init(Y);
      ContentEditable.init(Y);
      Timer.init(Y);
      FrameForm.init(Y);
      SubscribeFormManager.init(Y);
      ButtonActionsManager.init(Y);
      ImageInit.init(Y);
    },

    /**
     * singleSectionInitializer
     * @param section
     */
    singleSectionInitializer: function singleSectionInitializer(section) {
      Parallax.initSection(section);
      bgSlideShow.initSection(section);
    },

    /**
     * sectionInitializers
     * @param Y
     */
    sectionInitializers: function sectionInitializers(Y) {
      if (Y == null) {
        Y = false;
      }
      Parallax.init(Y);
      bgSlideShow.init(Y);
    },

    /**
     * Инициализация layoutEditor, происходит из базовых контроллеров
     * @param y
     */
    initializer: function initializer(y) {
      if (y === null || y === undefined) {
        y = false;
      }
      if (!Y) {
        Y = y;
      }

      this.widgetInitializers(Y);
      this.initDDsections();
      blocksBuilder.init(Y);
      sectionDragDrop.setYUI(Y);
      insertSpace.init(Y);
      blockEditDialog.init(Y);
      insertBlockMenu.init(Y);
      blockDropOverlays.init(Y);
      blockDragScroll.init(Y);
      TimeMachine.init(Y);

      log('layouts initializer');
    },

    /**
     * destroy
     */
    destroy: function destroy() {
      this.destroyDDsections();
      this.destroyDDblocks();
      if (this.layout) {
        this.cancelEditingLayout();
      }
      editorDragPanel.destroy();
      blockEditDialog.destroy();
      insertBlockMenu.destroy();
      insertSpace.destroy();
      Text.destroy();
      editorDragPanel.removeAllSettingsClasses();
      blockEditDialog.clearCurrentBlockJson();

      log('layoutEditor destroy');
    }
  };

  return layoutEditor;
}]);

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* injects from baggage-loader */



var indexOf = [].indexOf || function (item) {
  for (var i = 0, l = this.length; i < l; i++) {
    if (i in this && this[i] === item) {
      return i;
    }
  }
  return -1;
};

var moduleSectionDD = angular.module('services.layoutEditor.sectionDragDrop', ['services.editorNamespace', 'services.layoutEditor.insertSpace']);

moduleSectionDD.factory('sectionDragDrop', ['$timeout', '$injector', 'ns', 'insertSpace', 'blockDragScroll', 'Animation', 'TimeMachine', function ($timeout, $injector, ns, insertSpace, blockDragScroll, Animation, TimeMachine) {
  var Y = void 0;

  var sectionDD = {
    setYUI: function setYUI(y) {
      Y = y;
    },
    setEvents: function setEvents(dd, y) {
      Y = y;
      dd.before('drag:start', this._beforeDragStart, this);
      dd.on('drag:drophit', this._onDropHit, this);
      dd.on('drag:start', this._onDragStart, this);
      dd.on('drag:drag', this._onDragDrag, this);
      dd.on('drag:end', this._onDragEnd, this);
      dd.on('drag:over', this._onDragOver, this);
      dd.after('drag:end', this._afterDragEnd, this);
    },

    _beforeDragStart: function _beforeDragStart() {
      Y.DD.DDM.syncActiveShims();
    },

    _onDragStart: function _onDragStart(e) {
      var drag, fromMenu, originalEl;

      drag = e.target;
      originalEl = drag.get('node');
      this.clone = drag.get('dragNode');
      fromMenu = originalEl.hasClass('etnr-item__link');

      if (!fromMenu) {
        this.clone.addClass(ns.sectionDraggingClass);
      }

      if (!fromMenu) {
        this.clone.setStyles({
          zIndex: 400
        });
      }

      if (!fromMenu) {
        return originalEl.setStyles({
          display: 'none'
        });
      }
    },

    _onDragDrag: function _onDragDrag(e) {
      e.preventDefault();
      this.clone.setStyles({
        top: e.pageY,
        left: e.pageX
      });
      return blockDragScroll.scroll(e);
    },

    _onDropHit: function _onDropHit(e) {
      var indexPosition = 0;

      // const layoutEditor = $injector.get('layoutEditor');
      var originalEl = e.target.get('node');
      var drop = e.drop.get('node');
      var drag = e.drag.get('node');
      var availableTags = ['header', 'section', 'footer'];
      var tagName = drop.get('tagName').toLowerCase();
      var ref = drop.get('tagName').toLowerCase();

      if (indexOf.call(availableTags, ref) >= 0) {
        if (this.nearestEdge.quad.y === 'top' && tagName === 'header') {
          return false;
        }
        if (this.nearestEdge.quad.y === 'bottom' && tagName === 'footer') {
          return false;
        }

        var previousSectionId = void 0;
        if (originalEl.previous(ns.sectionClass)) {
          previousSectionId = originalEl.previous(ns.sectionClass).getData("section-id");
        } else {
          previousSectionId = "drop-backdrop";
        }

        var originalElId = originalEl.getData("section-id");
        var dropId = drop.getData("section-id");

        switch (this.nearestEdge.quad.y) {
          case 'top':
            TimeMachine.capture("moveSection", originalElId, {
              drop: dropId,
              y: 'before'
            }, previousSectionId);

            drop.insert(drag, 'before');
            indexPosition = $(drop._node).index() - 1;
            break;
          case 'bottom':
            TimeMachine.capture('moveSection', originalElId, {
              drop: dropId,
              y: 'after'
            }, previousSectionId);

            drop.insert(drag, 'after');
            indexPosition = $(drop._node).index() + 1;
            break;
        }
      }
    },

    _onDragEnd: function _onDragEnd(e) {
      var drag = e.target;
      var originalEl = drag.get('node');

      originalEl.setStyles({
        display: 'inherit'
      });

      insertSpace.hide();
      Animation.scrollTo($(originalEl._node));
    },

    _afterDragEnd: function _afterDragEnd() {
      // const layoutEditor = $injector.get('layoutEditor');
    },

    _onDragOver: function _onDragOver() {
      var blockDragDrop = $injector.get('blockDragDrop');
      var activeDropElement = Y.DD.DDM.activeDrop.get('node');

      if (activeDropElement.hasClass(ns.sectionClass.substr(1))) {
        this.nearestEdge = blockDragDrop.getDropInfo(Y);
        insertSpace.alignInsertSpaceRowOrSection(this.nearestEdge, 'section');
      }
    }
  };

  return sectionDD;
}]);

/***/ }),
/* 76 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

var moduleBlockOverlays = angular.module('services.layoutEditor.timemachine.acts', []);

moduleBlockOverlays.factory('TimeActs', ['$state', '$timeout', '$injector', 'ns', 'Section', 'SectionEmail', 'SectionWebForm', 'SectionLesson', '$rootScope', 'Animation', function ($state, $timeout, $injector, ns, Section, SectionEmail, SectionWebForm, SectionLesson, $rootScope, Animation) {
    var Y = void 0;

    if ($state.current.name === 'email.page.editor') {
        Section = SectionEmail;
    }

    if ($state.current.name === 'form.page.editor') {
        Section = SectionWebForm;
    }

    if ($state.current.name === 'lesson.page.editor') {
        Section = SectionLesson;
    }

    var timeacts = {
        init: function init(y) {
            return Y = y;
        },
        addSectionAct: {
            undo: function undo(lastCapture) {
                var editorDragPanel, section;
                section = Y.one("[data-section-id='" + lastCapture.json.id + "']");
                editorDragPanel = $injector.get("editorDragPanel");
                editorDragPanel.removeSection(section, false);
            },
            redo: function redo(lastCapture) {
                var blocksBuilder, editorDragPanel, editorNavSections, html, oldSection, path, sectionId, sectionType, tplWrapper;
                blocksBuilder = $injector.get("blocksBuilder");
                editorNavSections = $injector.get("editorNavSections");
                editorDragPanel = $injector.get("editorDragPanel");
                sectionId = lastCapture.json.id;
                sectionType = lastCapture.json.section_type;
                html = lastCapture.html;
                path = lastCapture.path;
                tplWrapper = Y.one(ns.tplContainer);
                Section.restore(sectionId);
                oldSection = blocksBuilder.createSection(ns.sectionLoader, sectionType);
                switch (sectionType) {
                    case "default":
                        if (path) {
                            Y.one("[data-section-id='" + path + "']").insert(oldSection, "after");
                        } else {
                            Y.one(ns.dropBackdropClass).insert(oldSection, "after");
                        }
                        editorNavSections.removeDropBackdrop();
                        break;
                    case "header":
                        tplWrapper.prepend(oldSection);
                        break;
                    case "footer":
                        tplWrapper.append(oldSection);
                }
                editorNavSections.sectionInitializer(lastCapture.json, html, oldSection, false);
                editorNavSections.bindSectionOnDropInTemplate(oldSection);
                editorDragPanel.cancelSection();
                $rootScope.toggleCommonSections();
            }
        },
        removeSectionAct: {
            undo: function undo(lastCapture) {
                return timeacts.addSectionAct.redo(lastCapture);
            },
            redo: function redo(lastCapture) {
                return timeacts.addSectionAct.undo(lastCapture);
            }
        },
        moveSectionAct: {
            undo: function undo(lastCapture) {
                var originalSection, path, sectionDragDrop;
                sectionDragDrop = $injector.get("sectionDragDrop");
                originalSection = Y.one("[data-section-id=" + lastCapture.json + "]");
                path = Y.one("[data-section-id=" + lastCapture.path + "]");
                path.insert(originalSection, "after");
                sectionDragDrop._afterDragEnd();
                return Animation.scrollTo($(originalSection._node));
            },
            redo: function redo(lastCapture) {
                var drop, originalSection, sectionDragDrop, y;
                sectionDragDrop = $injector.get("sectionDragDrop");
                originalSection = Y.one("[data-section-id=" + lastCapture.json + "]");
                drop = Y.one("[data-section-id=" + lastCapture.html.drop + "]");
                y = lastCapture.html.y;
                drop.insert(originalSection, y);
                sectionDragDrop._afterDragEnd();
                return Animation.scrollTo($(originalSection._node));
            }
        },
        reInitSection: function reInitSection(sectionEl) {
            var blockEditDialog, e, editorDragPanel;
            editorDragPanel = $injector.get("editorDragPanel");
            blockEditDialog = $injector.get("blockEditDialog");
            e = {
                target: sectionEl
            };
            editorDragPanel.cancelSection();
            editorDragPanel._onClickEditSection(e, false);
            return Animation.scrollTo($(sectionEl._node));
        },
        updateSectionAct: {
            undo: function undo(lastCapture) {
                var images, sectionEl, sectionId;
                sectionId = lastCapture.json.oldSection.id;
                sectionEl = Y.one("[data-section-id='" + sectionId + "']");
                images = angular.copy(sectionEl.section.background_attributes.images_attributes);
                sectionEl.section = lastCapture.json.oldSection;
                sectionEl.section.background_attributes.images_attributes = images;
                Section.saveSettings(lastCapture.json.oldSection);
                return timeacts.reInitSection(sectionEl);
            },
            redo: function redo(lastCapture) {
                var images, sectionEl, sectionId;
                sectionId = lastCapture.json.newSection.id;
                sectionEl = Y.one("[data-section-id='" + sectionId + "']");
                images = angular.copy(sectionEl.section.background_attributes.images_attributes);
                sectionEl.section = lastCapture.json.newSection;
                sectionEl.section.background_attributes.images_attributes = images;
                Section.saveSettings(lastCapture.json.newSection);
                return timeacts.reInitSection(sectionEl);
            }
        },
        widgetsChangeAct: {
            undo: function undo(lastCapture) {
                var layoutEditor, sectionEl, sectionElWrapper;
                layoutEditor = $injector.get("layoutEditor");
                sectionEl = Y.one("[data-section-id='" + lastCapture.json.oldJson.id + "']");
                sectionElWrapper = sectionEl.one(ns.wrapperClass);
                sectionElWrapper.all(ns.rowClass).remove();
                sectionElWrapper.setContent(lastCapture.html.oldHtml);
                layoutEditor.setJsonToRows(lastCapture.json.oldJson.structure.rows, sectionEl);
                Section.save(sectionEl);
                return timeacts.reInitSection(sectionEl);
            },
            redo: function redo(lastCapture) {
                var layoutEditor, sectionEl, sectionElWrapper;
                layoutEditor = $injector.get("layoutEditor");
                sectionEl = Y.one("[data-section-id='" + lastCapture.json.newJson.id + "']");
                sectionElWrapper = sectionEl.one(ns.wrapperClass);
                sectionElWrapper.all(ns.rowClass).remove();
                sectionElWrapper.setContent(lastCapture.html.newHtml);
                layoutEditor.setJsonToRows(lastCapture.json.newJson.structure.rows, sectionEl);
                Section.save(sectionEl);
                return timeacts.reInitSection(sectionEl);
            }
        },
        resizeColAct: {
            undo: function undo(lastCapture) {
                var blocksBuilder, leftCol, oldSizes, rightCol, sectionEl, widget, widgetId;
                blocksBuilder = $injector.get("blocksBuilder");
                widgetId = lastCapture.json.widgetId;
                oldSizes = lastCapture.json.oldSizes;
                widget = Y.one("[data-block-id='" + widgetId + "']");
                sectionEl = widget.ancestor(ns.sectionClass);
                Animation.scrollTo($(sectionEl._node));
                leftCol = widget.ancestor(ns.colClass);
                rightCol = leftCol.next();
                blocksBuilder.updateColSize(leftCol, oldSizes[0]);
                blocksBuilder.updateColSize(rightCol, oldSizes[1]);
                return Section.save(sectionEl);
            },
            redo: function redo(lastCapture) {
                var blocksBuilder, leftCol, newSizes, rightCol, sectionEl, widget, widgetId;
                blocksBuilder = $injector.get("blocksBuilder");
                widgetId = lastCapture.json.widgetId;
                newSizes = lastCapture.json.newSizes;
                widget = Y.one("[data-block-id='" + widgetId + "']");
                sectionEl = widget.ancestor(ns.sectionClass);
                Animation.scrollTo($(sectionEl._node));
                leftCol = widget.ancestor(ns.colClass);
                rightCol = leftCol.next();
                blocksBuilder.updateColSize(leftCol, newSizes[0]);
                blocksBuilder.updateColSize(rightCol, newSizes[1]);
                return Section.save(sectionEl);
            }
        }
    };
    return timeacts;
}]);

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* injects from baggage-loader */



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var moduleBlockOverlays = angular.module('services.layoutEditor.timemachine', []);

moduleBlockOverlays.factory('TimeMachine', ['$rootScope', '$timeout', '$injector', 'ns', 'TimeActs', function ($rootScope, $timeout, $injector, ns, TimeActs) {
    var Y = void 0;

    var TimeMachine = function () {
        function TimeMachine() {
            _classCallCheck(this, TimeMachine);

            this.maxStates = 10;
            this.history = [];
            this.forwardHistory = [];
        }

        _createClass(TimeMachine, [{
            key: 'init',
            value: function init(y) {
                var _this = this;

                Y = y;
                TimeActs.init(y);

                $(document).bind('keydown.timemachine', function (e) {
                    _this._keydown(e);
                });
            }
        }, {
            key: 'clear',
            value: function clear() {
                this.history = [];
                this.forwardHistory = [];
                this.setBtnStatus();
            }
        }, {
            key: '_keydown',
            value: function _keydown(e) {
                var textInput = $(e.target).attr('contenteditable');

                if (!textInput) {
                    var ctrlKey = e.ctrlKey || e.metaKey;
                    var historySize = this.history.length;
                    var forwardHistorySize = this.forwardHistory.length;
                    var YKey = e.charCode === 25 || e.keyCode === 89;
                    var Zkey = e.charCode === 25 || e.keyCode === 90;

                    if (ctrlKey && YKey) {
                        e.preventDefault();
                    }

                    if (historySize && ctrlKey && Zkey) {
                        e.preventDefault();
                        this.undo();
                    }

                    if (forwardHistorySize && ctrlKey && YKey) {
                        this.redo();
                    }
                }
            }
        }, {
            key: 'undo',
            value: function undo() {
                var lastCapture = this.history.pop();

                log('undo ' + lastCapture.act);
                this.forwardHistory.push(lastCapture);
                this.setBtnStatus();
                TimeActs[lastCapture.act + 'Act'].undo(lastCapture);
            }
        }, {
            key: 'redo',
            value: function redo() {
                var lastCapture = this.forwardHistory.pop();

                log('redo ' + lastCapture.act);
                this.history.push(lastCapture);
                this.setBtnStatus();
                TimeActs[lastCapture.act + 'Act'].redo(lastCapture);
            }
        }, {
            key: 'capture',
            value: function capture(act, json, html, path) {
                if (this.history.length > this.maxStates) {
                    this.history.shift();
                }
                if (this.forwardHistory.length > 0) {
                    this.forwardHistory = [];
                }

                this.history.push({
                    act: act,
                    json: json,
                    html: html,
                    path: path
                });

                this.setBtnStatus();
            }
        }, {
            key: 'setBtnStatus',
            value: function setBtnStatus() {
                $rootScope.undoActive = this.history.length;
                $rootScope.redoActive = this.forwardHistory.length;
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.history = [];
                this.forwardHistory = [];
                this.setBtnStatus();
                $(document).unbind('keydown.timemachine');
            }
        }]);

        return TimeMachine;
    }();

    return new TimeMachine();
}]);

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* injects from baggage-loader */



var moduleButtonActionsInitializer = angular.module('button_actions.initializer', []);

moduleButtonActionsInitializer.service('ButtonActionsManager', ['$timeout', '$injector', 'ns', '$translate', function ($timeout, $injector, ns, $translate) {
  var Y = void 0;

  return {
    init: function init(y) {
      Y = y;
    },
    updateOptions: function updateOptions(widget) {
      var options = window.justclick;
      var linkHref = widget.button_attributes.link_href;
      var isDefaultValue = linkHref === '' || linkHref === '#' || linkHref === 'http://' || linkHref === 'http://#' || linkHref === null;

      if (options && options.useNextPageUrl && isDefaultValue) {
        widget.button_attributes.link_href_target = 'next';
        widget.button_attributes.link_href = '#nextPage';
      }

      // В случае обычного конструктора писем включим по умолчанию опцию "open_link"
      if (window.Editor.mode === 'email.page.editor' && !options.useNextPageUrl) {
        widget.button_attributes.click_action = 'open_link';
      }

      // Если в конструкторе писем включена внутренняя ссылка, то переключим ее на внешнюю
      if (window.Editor.mode === 'email.page.editor' && widget.button_attributes.link_href_target === 'none') {
        widget.button_attributes.link_href_target = 'blank';
      }
    },
    destroy: function destroy() {}
  };
}]);

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* injects from baggage-loader */



var moduleContentEditable = angular.module('contentEditable.initializer', []);

moduleContentEditable.service('ContentEditable', ['$timeout', '$injector', 'ns', '$rootScope', function ($timeout, $injector, ns, $rootScope) {
  var Y = void 0;

  return {
    init: function init(y) {
      Y = y;
    },
    clearPaste: function clearPaste(e) {
      var newDiv, text;
      e.preventDefault();

      if (e.originalEvent.clipboardData) {
        text = e.originalEvent.clipboardData.getData('text/plain');
      } else {
        text = window.clipboardData.getData('text');
      }

      if (text.length > 0) {
        newDiv = document.createElement("div");
      }

      newDiv.innerHTML = text;
      document.execCommand("insertHTML", false, newDiv.textContent);
      return false;
    },
    setToValue: function setToValue(obj, value, path) {
      var i;
      path = path.split('.');
      i = 0;
      while (i < path.length - 1) {
        obj = obj[path[i]];
        i++;
      }
      obj[path[i]] = value;
    },
    /**
     * Очистка html от лишних блоков
     * @param value
     * @param classesForRemove
     * @returns {*}
     */
    htmlClearClasses: function htmlClearClasses(value) {
      var classesForRemove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      var $value = $('<div/>').html(value);

      if (classesForRemove.length > 0) {
        classesForRemove.map(function (selector) {
          var $elem = $value.find(selector);

          if ($elem.length > 0) {
            $elem.remove();
          }
        });
      }

      return $value.html();
    },
    htmlDecode: function htmlDecode(value) {
      return $('<div/>').html(value).text();
    },
    htmlEncode: function htmlEncode(value) {
      return $('<div/>').text(value).html();
    },
    bind: function bind(layout, value, id) {
      if (id === null || id === undefined) {
        id = false;
      }

      var self = this;

      if (id) {
        layout = Y.one('[data-block-id=\'' + id + '\']');
      }

      layout.all('[contenteditable]').each(function (element) {
        var block = element.ancestor(ns.blockClass);

        if (!block.widget) {
          return false;
        }

        if (block.widget.type === 'text') {
          return false;
        }

        if (block.widget.type !== 'code') {
          $(element._node).unbind('paste', self.clearPaste);
          $(element._node).on('paste', self.clearPaste);
        }

        element.setAttribute('contenteditable', value);

        if (value) {
          element.on('valuechange', function (e) {

            var newVal = e.newVal;

            if (block.widget.type === 'subscribe_form' || block.widget.type === 'list' || block.widget.type === 'button') {
              newVal = self.htmlClearClasses(e.newVal, ['.strwf_button__additional-text', '.strwf_button__icon']);
            }

            if (block.widget.type === 'code') {
              newVal = self.htmlDecode(e.newVal);
            }

            self.setToValue(block.widget, newVal, element.getAttribute('data-access'));
            $rootScope.$apply();
          });
        } else {
          element.detach('valuechange');
        }
      });
    },
    destroy: function destroy() {}
  };
}]);

/***/ }),
/* 80 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

var moduleImageInitializer = angular.module('image.initializer', []);

moduleImageInitializer.service('ImageInit', ["$timeout", "$injector", "ns", "$translate", function ($timeout, $injector, ns, $translate) {
  var Y = undefined;
  var image = {
    init: function init(y) {
      Y = y;
      this.initImages();
    },
    resizers: [],

    updateOptions: function updateOptions(widget) {
      var options = window.justclick;
      var linkHref = widget.image_attributes.link_href;
      var isDefaultValue = linkHref === '' || linkHref === '#' || linkHref === null;

      if (options && options.useNextPageUrl && isDefaultValue) {
        widget.image_attributes.link_href_target = 'next';
        widget.image_attributes.link_href = '#nextPage';
      }
    },

    findImagesForLazyLoad: function findImagesForLazyLoad() {
      this.images = $("img.lazy");
    },
    showImage: function showImage(index, image) {
      var $image = $(image);
      var src = $image.data('src');

      $image.attr('src', src);
    },
    initImages: function initImages() {
      this.findImagesForLazyLoad();
      this.images.each(this.showImage);
    },
    destroy: function destroy() {}
  };
  return image;
}]);

/***/ }),
/* 81 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

var moduleSlider = angular.module('slider.initializer', []);

moduleSlider.service('Slider', ["$timeout", "$injector", "ns", function ($timeout, $injector, ns) {
  'use strict';

  var Y = void 0;

  var slider = {
    init: function init(y) {
      Y = y;

      this.initSliders();
    },
    resizers: [],

    findSliders: function findSliders() {
      var layoutEditor;
      layoutEditor = $injector.get("layoutEditor");
      this.sliders = $(".str-block ." + ns.sliderClass);
    },
    initSlider: function initSlider(index, slider, onSlideChangeStart) {

      if (onSlideChangeStart == null) {
        onSlideChangeStart = false;
      }

      var optionsJson = $(slider).data("slider-settings");

      var defaultOptions = {
        pagination: $(slider).find('.swiper-pagination'),
        paginationClickable: $(slider).find('.swiper-pagination'),
        nextButton: $(slider).find('.swiper-button-next'),
        prevButton: $(slider).find('.swiper-button-prev'),
        simulateTouch: false,
        onSlideChangeStart: onSlideChangeStart
      };

      optionsJson = _.extend(optionsJson, defaultOptions);
      if ($(slider)[0] && $(slider)[0].swiper) {
        $(slider)[0].swiper.destroy(true, true);
      }

      var newSwiperTop = new Swiper($(slider), optionsJson);
      var newSwiperThumbs = void 0;

      if (optionsJson.thumbs) {
        var thumbsContainer = $(slider).parent().find(".gallery-thumbs")[0];
        if (thumbsContainer.swiper) {
          thumbsContainer.swiper.destroy(true, true);
        }

        var thumbsOptions = {
          centeredSlides: true,
          slidesPerView: 'auto',
          touchRatio: 0.2,
          slideToClickedSlide: true
        };

        newSwiperThumbs = new Swiper(thumbsContainer, thumbsOptions);
        newSwiperTop.params.control = newSwiperThumbs;
        newSwiperThumbs.params.control = newSwiperTop;
      }

      return [newSwiperTop, newSwiperThumbs];
    },
    initSliders: function initSliders() {
      this.findSliders();
      this.sliders.each(this.initSlider);
    },

    updateSlider: function updateSlider(slider) {
      if ($(slider._node)[0].swiper) {
        var swiper = $(slider._node)[0].swiper;

        if (swiper.activeIndex !== 0) {
          swiper.slideTo(0, 0);
        }

        swiper.update();
      }
    },
    updateSliders: function updateSliders() {
      Y.all("." + ns.sliderClass).each(this.updateSlider);
    },
    destroy: function destroy() {}
  };

  return slider;
}]);

/***/ }),
/* 82 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

var subscribeFormModule = angular.module('subscribe_form.initializer', []);

subscribeFormModule.service("SubscribeFormManager", ["$timeout", "$injector", "ns", "$filter", function ($timeout, $injector, ns, $filter) {
  'use strict';

  var Y = undefined;

  return {
    init: function init(y) {
      Y = y;
    },
    findFileldIndexByAttr: function findFileldIndexByAttr(fields, attribute) {
      var field = _.filter(fields, attribute)[0];
      return fields.indexOf(field);
    },
    updateOptions: function updateOptions(widget) {
      var options = window.justclick;
      var $widgetElWrapper = $("[data-block-id=\"" + widget.id + "\"]");
      var formAction = options.overrideFormAction !== undefined ? options.overrideFormAction : '/subscribe/process';

      $widgetElWrapper.find('form').attr('action', formAction);

      if (options.ignoreSelectedProducts !== undefined) {
        widget.submit_action = 'make_order';
      }

      widget.disable_form_settings = options.disableFormSettings !== undefined ? options.disableFormSettings : false;

      widget.update_form_settings_url = options.updateFormSettingsUrl !== undefined ? options.updateFormSettingsUrl : '';

      widget.stripe_key = options.stripePublicKey;
      widget.single_opt_in = options.isSingleOptInSubscribe;
      widget.override_form_action = options.overrideFormAction;

      // Обновление поля ADDRESS_FIELD и показ/скрытие полей DELIVERY_ADDRESS_FIELDS
      var ADDRESS_FIELD = 'orderData[bill_hide_shipping_address]';
      var DELIVERY_ADDRESS_FIELDS = ['orderData[bill_shipping_name]', 'orderData[bill_shipping_phone]', 'orderData[bill_country]', 'orderData[bill_address]', 'orderData[bill_address2]', 'orderData[bill_city]', 'orderData[bill_region]', 'orderData[bill_postal_code]'];
      var indexAddressField = this.findFileldIndexByAttr(widget.form_fields_attributes, { name: ADDRESS_FIELD });
      if (indexAddressField > 0) {
        if (widget.form_fields_attributes[indexAddressField].placeholder === '') {
          widget.form_fields_attributes[indexAddressField].placeholder = $filter('translate')('widget.form.DeliveryAddressIsBillingAddress');
          widget.form_fields_attributes[indexAddressField].exist = false;
        }
        if (widget.form_fields_attributes[indexAddressField].checked === undefined) {
          widget.form_fields_attributes[indexAddressField].checked = true;
        }

        DELIVERY_ADDRESS_FIELDS.map(function (field) {
          var $field = $widgetElWrapper.find('form').find('[name="' + field + '"]');

          if ($field.length > 0) {
            var $fieldWrapper = $field.closest('.strwf__input-wrapper');
            var hasInvisibleCssClass = $fieldWrapper.hasClass('strwf__input-wrapper_invisible');

            if (widget.form_fields_attributes[indexAddressField].checked) {
              if (!hasInvisibleCssClass) {
                $fieldWrapper.addClass('strwf__input-wrapper_invisible');
              }
            } else {
              if (hasInvisibleCssClass) {
                $fieldWrapper.removeClass('strwf__input-wrapper_invisible');
              }
            }
          }
        });
      }

      return widget;
    },
    destroy: function destroy() {}
  };
}]);

/***/ }),
/* 83 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

var moduleSlider = angular.module('timer.initializer', []);

moduleSlider.service('Timer', ['$timeout', '$injector', 'ns', '$translate', function ($timeout, $injector, ns, $translate) {
  'use strict';

  var Y = void 0;

  var timer = {
    init: function init(y) {
      Y = y;
      this.initTimers();
    },
    resizers: [],
    findTimers: function findTimers() {
      var layoutEditor = $injector.get('layoutEditor');

      this.timers = $('.str-block .strbw-timer');
    },
    initTimer: function initTimer(index, timer, data) {
      var settings = void 0;

      if (data === null) {
        data = false;
      }

      if (data) {
        settings = angular.copy(data);
      } else {
        settings = $(timer).data('settings');
      }

      var clock = $(timer).FlipClock({
        clockFace: 'DailyCounter',
        autoStart: false,
        language: $translate.use()
      });
      clock.setCountdown(true);

      if (settings.is_started) {
        clock.start();
      }

      if (settings) {
        this.updateLabel(clock.$wrapper, '.flip-clock-divider.days .flip-clock-label', settings.days_label);
        this.updateLabel(clock.$wrapper, '.flip-clock-divider.hours .flip-clock-label', settings.hours_label);
        this.updateLabel(clock.$wrapper, '.flip-clock-divider.minutes .flip-clock-label', settings.minutes_label);
        this.updateLabel(clock.$wrapper, '.flip-clock-divider.seconds .flip-clock-label', settings.seconds_label);
      }

      $(timer).find('a').attr('href', 'javascript: void(0)');
    },
    initTimers: function initTimers() {
      this.findTimers();
      this.timers.each(this.initTimer.bind(this));
    },
    updateLabel: function updateLabel($wrapper, selector, text) {
      var $label = $wrapper.find(selector);
      if (text !== undefined && $label.length > 0) {
        $label.text(text);
      }
    },
    destroy: function destroy() {}
  };

  return timer;
}]);

/***/ }),
/* 84 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

function getAlignment(element, useComputedState) {
  useComputedState = useComputedState === undefined || useComputedState;

  var align;
  if (useComputedState) align = element.getComputedStyle('text-align');else {
    while (!element.hasAttribute || !(element.hasAttribute('align') || element.getStyle('text-align'))) {
      var parent = element.getParent();
      if (!parent) break;
      element = parent;
    }
    align = element.getStyle('text-align') || element.getAttribute('align') || '';
  }

  // // Sometimes computed values doesn't tell.
  // align && ( align = align.replace( /(?:-(?:moz|webkit)-)?(?:start|auto)/i, '' ) );

  // !align && useComputedState && ( align = element.getComputedStyle( 'direction' ) == 'rtl' ? 'right' : 'left' );
  return align;
}

CKEDITOR.plugins.add('alignment', {
  requires: 'richcombo',
  init: function init(editor) {
    var config = editor.config,
        name,
        styles = {},
        values = [],
        names = ['Left/left', 'Center/center', 'Right/right', 'Justify/justify'],
        style = new CKEDITOR.style(config['alignment_style']);

    for (var i = 0; i < names.length; i++) {
      var parts = names[i];
      if (parts) {
        parts = parts.split('/');
        var vars = {},
            name = names[i] = parts[0];
        vars['value'] = values[i] = parts[1] || name;
        styles[name] = new CKEDITOR.style(config['alignment_style'], vars);
        styles[name]._.definition.name = name;
      } else names.splice(i--, 1);
    }

    editor.ui.addRichCombo('alignment', {
      label: 'alignment',
      className: 'cke_alignment',
      title: 'alignment',
      modes: { wysiwyg: 1 },
      editorFocus: 1,
      toolbar: 'alignment,' + 10,
      allowedContent: style,
      requiredContent: style,
      panel: {
        css: [CKEDITOR.skin.getPath('editor')].concat(config.contentsCss),
        multiSelect: false
      },
      init: function init() {
        this.allowedContent = {
          'caption div h1 h2 h3 h4 h5 h6 p pre td th li': {
            propertiesOnly: true,
            styles: this.cssClassName ? null : 'text-align',
            classes: this.cssClassName || null
          }
        };
        if (editor.config.enterMode == CKEDITOR.ENTER_BR) this.allowedContent.div = true;

        for (var i = 0; i < names.length; i++) {
          var parts = names[i];
          if (parts) {
            parts = parts.split('/');
            name = names[i] = parts[0];
            value = values[i] = parts[1] || name;
            this.add(name, styles[name]._.definition.name, value);
          }
        }
      },
      onClick: function onClick(value) {
        editor.focus();
        editor.fire("saveSnapshot");
        var selection = editor.getSelection(),
            enterMode = editor.config.enterMode;

        if (!selection) return;

        var bookmarks = selection.createBookmarks(),
            ranges = selection.getRanges();

        var iterator, block;
        var useComputedState = editor.config.useComputedState;
        useComputedState = useComputedState === undefined || useComputedState;

        for (var i = ranges.length - 1; i >= 0; i--) {
          iterator = ranges[i].createIterator();
          iterator.enlargeBr = enterMode != CKEDITOR.ENTER_BR;

          while (block = iterator.getNextParagraph(enterMode == CKEDITOR.ENTER_P ? 'p' : 'div')) {
            if (block.isReadOnly()) continue;
            getAlignment(block, true);
            block.setStyle('text-align', value);
          }
        }

        editor.focus();
        editor.forceNextSelectionCheck();
        selection.selectBookmarks(bookmarks);
        editor.fire("saveSnapshot");
      },
      onRender: function onRender() {
        editor.on("selectionChange", function (b) {
          var currentValue = this.getValue();
          var elementPath = b.data.path,
              elements = elementPath.elements;
          for (var i = 0, element; i < elements.length; i++) {
            element = elements[i];
            for (var value in styles) {
              if (styles[value].checkElementMatch(element, true, editor)) {
                if (value != currentValue) this.setValue(value);
                return;
              }
            }
          }
          this.setValue("", 'left');
        }, this);
      },
      refresh: function refresh() {
        editor.activeFilter.check(style) || this.setState(CKEDITOR.TRISTATE_DISABLED);
      }
    });
  }
});

CKEDITOR.config.alignment_style = {
  overrides: [{
    element: 'alignment', attributes: { 'value': null }
  }]
};

/***/ }),
/* 85 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.add('blocksettings', {
  requires: 'panelbutton',
  init: function init(editor) {
    var allowed = 'a[!href]',
        required = 'a[href]',
        plugin = CKEDITOR.plugins.link;

    if (CKEDITOR.dialog.isTabEnabled(editor, 'link', 'advanced')) allowed = allowed.replace(']', ',accesskey,charset,dir,id,lang,name,rel,tabindex,title,type]{*}(*)');
    if (CKEDITOR.dialog.isTabEnabled(editor, 'link', 'target')) allowed = allowed.replace(']', ',target,onclick]');

    function getCompiledProtectionFunction(editor) {
      var emailProtection = editor.config.emailProtection || '',
          compiledProtectionFunction;

      // Compile the protection function pattern.
      if (emailProtection && emailProtection != 'encode') {
        compiledProtectionFunction = {};

        emailProtection.replace(/^([^(]+)\(([^)]+)\)$/, function (match, funcName, params) {
          compiledProtectionFunction.name = funcName;
          compiledProtectionFunction.params = [];
          params.replace(/[^,\s]+/g, function (param) {
            compiledProtectionFunction.params.push(param);
          });
        });
      }

      return compiledProtectionFunction;
    }
    this.compiledProtectionFunction = getCompiledProtectionFunction(editor);

    editor.ui.add('blocksettings', CKEDITOR.UI_PANELBUTTON, {
      label: 'blocksettings',
      className: 'cke_blocksettings',
      title: 'blocksettings',
      modes: { wysiwyg: 1 },
      editorFocus: 1,
      toolbar: 'blocksettings,' + 10,
      allowedContent: allowed,
      requiredContent: required,
      panel: {
        css: CKEDITOR.skin.getPath('editor'),
        attributes: { role: 'listbox', 'aria-label': 'lang.panelTitle' }
      },
      onBlock: function onBlock(panel, block) {},
      onOpen: function onOpen() {
        $(".e__tools").scope().editorNavOpenWidget = true;
        $(".e__tools").scope().$apply();
      },
      onClose: function onClose() {}
    });
  },

  afterInit: function afterInit(editor) {}
});

/***/ }),
/* 86 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

/*
Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
For licensing, see LICENSE.md or http://ckeditor.com/license
*/
CKEDITOR.plugins.setLang('colortext', 'bg', {
  auto: 'Automatically',
  bgColorTitle: 'Background color',
  colors: {
    '000': 'Black',
    '800000': 'Maroon',
    '8B4513': 'Leather-brown',
    '2F4F4F': 'Dark slate gray',
    '008080': 'Blue-green',
    '000080': 'Navy blue',
    '4B0082': 'Indigo',
    '696969': 'Dark grey',
    B22222: 'Brick',
    A52A2A: 'Brown',
    DAA520: 'Golden birch',
    '006400': 'Dark green',
    '40E0D0': 'Turquoise',
    '0000CD': 'medium blue',
    '800080': 'Purple',
    '808080': 'Grey',
    F00: 'Red',
    FF8C00: 'Dark orange',
    FFD700: 'Gold',
    '008000': 'Green',
    '0FF': 'Cornflower',
    '00F': 'Blue',
    EE82EE: 'Violet',
    A9A9A9: 'Dim gray',
    FFA07A: 'Light salmon',
    FFA500: 'Orange',
    FFFF00: 'Yellow',
    '00FF00': 'lime',
    AFEEEE: 'Pale blue',
    ADD8E6: 'Svelto blue',
    DDA0DD: 'Plum',
    D3D3D3: 'Light grey',
    FFF0F5: 'Pink-lavender',
    FAEBD7: 'Antique white',
    FFFFE0: 'Light yellow',
    F0FFF0: 'Honeydew',
    F0FFFF: 'azure',
    F0F8FF: 'Pale blue',
    E6E6FA: 'Lavender',
    FFF: 'White'
  },
  more: 'More colors...',
  panelTitle: 'Colors',
  textColorTitle: 'Text color'
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

/*
Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
For licensing, see LICENSE.md or http://ckeditor.com/license
*/
CKEDITOR.plugins.setLang('colortext', 'en', {
  auto: 'Automatically',
  bgColorTitle: 'Background color',
  colors: {
    '000': 'Black',
    '800000': 'Maroon',
    '8B4513': 'Leather-brown',
    '2F4F4F': 'Dark slate gray',
    '008080': 'Blue-green',
    '000080': 'Navy blue',
    '4B0082': 'Indigo',
    '696969': 'Dark grey',
    B22222: 'Brick',
    A52A2A: 'Brown',
    DAA520: 'Golden birch',
    '006400': 'Dark green',
    '40E0D0': 'Turquoise',
    '0000CD': 'medium blue',
    '800080': 'Purple',
    '808080': 'Grey',
    F00: 'Red',
    FF8C00: 'Dark orange',
    FFD700: 'Gold',
    '008000': 'Green',
    '0FF': 'Cornflower',
    '00F': 'Blue',
    EE82EE: 'Violet',
    A9A9A9: 'Dim gray',
    FFA07A: 'Light salmon',
    FFA500: 'Orange',
    FFFF00: 'Yellow',
    '00FF00': 'lime',
    AFEEEE: 'Pale blue',
    ADD8E6: 'Svelto blue',
    DDA0DD: 'Plum',
    D3D3D3: 'Light grey',
    FFF0F5: 'Pink-lavender',
    FAEBD7: 'Antique white',
    FFFFE0: 'Light yellow',
    F0FFF0: 'Honeydew',
    F0FFFF: 'azure',
    F0F8FF: 'Pale blue',
    E6E6FA: 'Lavender',
    FFF: 'White'
  },
  more: 'More colors...',
  panelTitle: 'Colors',
  textColorTitle: 'Text color'
});

/***/ }),
/* 88 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

/*
Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
For licensing, see LICENSE.md or http://ckeditor.com/license
*/
CKEDITOR.plugins.setLang('colortext', 'es', {
  auto: 'Automatically',
  bgColorTitle: 'Background color',
  colors: {
    '000': 'Black',
    '800000': 'Maroon',
    '8B4513': 'Leather-brown',
    '2F4F4F': 'Dark slate gray',
    '008080': 'Blue-green',
    '000080': 'Navy blue',
    '4B0082': 'Indigo',
    '696969': 'Dark grey',
    B22222: 'Brick',
    A52A2A: 'Brown',
    DAA520: 'Golden birch',
    '006400': 'Dark green',
    '40E0D0': 'Turquoise',
    '0000CD': 'medium blue',
    '800080': 'Purple',
    '808080': 'Grey',
    F00: 'Red',
    FF8C00: 'Dark orange',
    FFD700: 'Gold',
    '008000': 'Green',
    '0FF': 'Cornflower',
    '00F': 'Blue',
    EE82EE: 'Violet',
    A9A9A9: 'Dim gray',
    FFA07A: 'Light salmon',
    FFA500: 'Orange',
    FFFF00: 'Yellow',
    '00FF00': 'lime',
    AFEEEE: 'Pale blue',
    ADD8E6: 'Svelto blue',
    DDA0DD: 'Plum',
    D3D3D3: 'Light grey',
    FFF0F5: 'Pink-lavender',
    FAEBD7: 'Antique white',
    FFFFE0: 'Light yellow',
    F0FFF0: 'Honeydew',
    F0FFFF: 'azure',
    F0F8FF: 'Pale blue',
    E6E6FA: 'Lavender',
    FFF: 'White'
  },
  more: 'More colors...',
  panelTitle: 'Colors',
  textColorTitle: 'Text color'
});

/***/ }),
/* 89 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

/*
Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
For licensing, see LICENSE.md or http://ckeditor.com/license
*/
CKEDITOR.plugins.setLang('colortext', 'it', {
  auto: 'Automatically',
  bgColorTitle: 'Background color',
  colors: {
    '000': 'Black',
    '800000': 'Maroon',
    '8B4513': 'Leather-brown',
    '2F4F4F': 'Dark slate gray',
    '008080': 'Blue-green',
    '000080': 'Navy blue',
    '4B0082': 'Indigo',
    '696969': 'Dark grey',
    B22222: 'Brick',
    A52A2A: 'Brown',
    DAA520: 'Golden birch',
    '006400': 'Dark green',
    '40E0D0': 'Turquoise',
    '0000CD': 'medium blue',
    '800080': 'Purple',
    '808080': 'Grey',
    F00: 'Red',
    FF8C00: 'Dark orange',
    FFD700: 'Gold',
    '008000': 'Green',
    '0FF': 'Cornflower',
    '00F': 'Blue',
    EE82EE: 'Violet',
    A9A9A9: 'Dim gray',
    FFA07A: 'Light salmon',
    FFA500: 'Orange',
    FFFF00: 'Yellow',
    '00FF00': 'lime',
    AFEEEE: 'Pale blue',
    ADD8E6: 'Svelto blue',
    DDA0DD: 'Plum',
    D3D3D3: 'Light grey',
    FFF0F5: 'Pink-lavender',
    FAEBD7: 'Antique white',
    FFFFE0: 'Light yellow',
    F0FFF0: 'Honeydew',
    F0FFFF: 'azure',
    F0F8FF: 'Pale blue',
    E6E6FA: 'Lavender',
    FFF: 'White'
  },
  more: 'More colors...',
  panelTitle: 'Colors',
  textColorTitle: 'Text color'
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

/*
Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
For licensing, see LICENSE.md or http://ckeditor.com/license
*/
CKEDITOR.plugins.setLang('colortext', 'ja', {
  auto: '自動的に',
  bgColorTitle: '背景色',
  colors: {
    '000': 'ブラック',
    '800000': 'あずき色',
    '8B4513': 'レザーブラウン',
    '2F4F4F': 'ダークスレートグレー',
    '008080': '青緑色',
    '000080': '紺',
    '4B0082': 'インジゴ',
    '696969': '濃い灰色',
    'B22222': 'レンガ',
    'A52A2A': '褐色',
    'DAA520': 'ゴールデンバーチ',
    '006400': '濃い緑色',
    '40E0D0': 'ターコイズ',
    '0000CD': 'ミディアムブルー',
    '800080': '紫の',
    '808080': 'グレー',
    'F00': '赤',
    'FF8C00': 'ダークオレンジ',
    'FFD700': 'ゴールド',
    '008000': '緑',
    '0FF': 'ヤグルマギク',
    '00F': '青い',
    'EE82EE': 'バイオレット',
    'A9A9A9': '薄暗い灰色',
    'FFA07A': 'ライトサーモン',
    'FFA500': 'オレンジ',
    'FFFF00': '黄',
    '00FF00': 'ライム',
    'AFEEEE': '青白い',
    'ADD8E6': 'スベルトブルー',
    'DDA0DD': '梅',
    'D3D3D3': 'ライトグレー',
    'FFF0F5': 'ピンクラベンダー',
    'FAEBD7': 'アンティークホワイト',
    'FFFFE0': '薄黄色',
    'F0FFF0': '甘露',
    'F0FFFF': '紺碧',
    'F0F8FF': '青白い',
    'E6E6FA': 'ラベンダー',
    'FFF': '白い'
  },
  more: 'より多くの色...',
  panelTitle: '色',
  textColorTitle: 'テキストの色'
});

/***/ }),
/* 91 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

/*
Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
For licensing, see LICENSE.md or http://ckeditor.com/license
*/
CKEDITOR.plugins.setLang('colortext', 'ro', {
  auto: 'Automatically',
  bgColorTitle: 'Background color',
  colors: {
    '000': 'Black',
    '800000': 'Maroon',
    '8B4513': 'Leather-brown',
    '2F4F4F': 'Dark slate gray',
    '008080': 'Blue-green',
    '000080': 'Navy blue',
    '4B0082': 'Indigo',
    '696969': 'Dark grey',
    B22222: 'Brick',
    A52A2A: 'Brown',
    DAA520: 'Golden birch',
    '006400': 'Dark green',
    '40E0D0': 'Turquoise',
    '0000CD': 'medium blue',
    '800080': 'Purple',
    '808080': 'Grey',
    F00: 'Red',
    FF8C00: 'Dark orange',
    FFD700: 'Gold',
    '008000': 'Green',
    '0FF': 'Cornflower',
    '00F': 'Blue',
    EE82EE: 'Violet',
    A9A9A9: 'Dim gray',
    FFA07A: 'Light salmon',
    FFA500: 'Orange',
    FFFF00: 'Yellow',
    '00FF00': 'lime',
    AFEEEE: 'Pale blue',
    ADD8E6: 'Svelto blue',
    DDA0DD: 'Plum',
    D3D3D3: 'Light grey',
    FFF0F5: 'Pink-lavender',
    FAEBD7: 'Antique white',
    FFFFE0: 'Light yellow',
    F0FFF0: 'Honeydew',
    F0FFFF: 'azure',
    F0F8FF: 'Pale blue',
    E6E6FA: 'Lavender',
    FFF: 'White'
  },
  more: 'More colors...',
  panelTitle: 'Colors',
  textColorTitle: 'Text color'
});

/***/ }),
/* 92 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

/*
Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
For licensing, see LICENSE.md or http://ckeditor.com/license
*/
CKEDITOR.plugins.setLang('colortext', 'ru', {
	auto: 'Автоматически',
	bgColorTitle: 'Цвет фона',
	colors: {
		'000': 'Чёрный',
		'800000': 'Бордовый',
		'8B4513': 'Кожано-коричневый',
		'2F4F4F': 'Темный синевато-серый',
		'008080': 'Сине-зелёный',
		'000080': 'Тёмно-синий',
		'4B0082': 'Индиго',
		'696969': 'Тёмно-серый',
		B22222: 'Кирпичный',
		A52A2A: 'Коричневый',
		DAA520: 'Золотисто-берёзовый',
		'006400': 'Темно-зелёный',
		'40E0D0': 'Бирюзовый',
		'0000CD': 'Умеренно синий',
		'800080': 'Пурпурный',
		'808080': 'Серый',
		F00: 'Красный',
		FF8C00: 'Темно-оранжевый',
		FFD700: 'Золотистый',
		'008000': 'Зелёный',
		'0FF': 'Васильковый',
		'00F': 'Синий',
		EE82EE: 'Фиолетовый',
		A9A9A9: 'Тускло-серый',
		FFA07A: 'Светло-лососевый',
		FFA500: 'Оранжевый',
		FFFF00: 'Жёлтый',
		'00FF00': 'Лайма',
		AFEEEE: 'Бледно-синий',
		ADD8E6: 'Свелто-голубой',
		DDA0DD: 'Сливовый',
		D3D3D3: 'Светло-серый',
		FFF0F5: 'Розово-лавандовый',
		FAEBD7: 'Античный белый',
		FFFFE0: 'Светло-жёлтый',
		F0FFF0: 'Медвяной росы',
		F0FFFF: 'Лазурный',
		F0F8FF: 'Бледно-голубой',
		E6E6FA: 'Лавандовый',
		FFF: 'Белый'
	},
	more: 'Ещё цвета...',
	panelTitle: 'Цвета',
	textColorTitle: 'Цвет текста'
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

/*
Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
For licensing, see LICENSE.md or http://ckeditor.com/license
*/
CKEDITOR.plugins.setLang('colortext', 'th', {
  auto: 'Automatically',
  bgColorTitle: 'Background color',
  colors: {
    '000': 'Black',
    '800000': 'Maroon',
    '8B4513': 'Leather-brown',
    '2F4F4F': 'Dark slate gray',
    '008080': 'Blue-green',
    '000080': 'Navy blue',
    '4B0082': 'Indigo',
    '696969': 'Dark grey',
    B22222: 'Brick',
    A52A2A: 'Brown',
    DAA520: 'Golden birch',
    '006400': 'Dark green',
    '40E0D0': 'Turquoise',
    '0000CD': 'medium blue',
    '800080': 'Purple',
    '808080': 'Grey',
    F00: 'Red',
    FF8C00: 'Dark orange',
    FFD700: 'Gold',
    '008000': 'Green',
    '0FF': 'Cornflower',
    '00F': 'Blue',
    EE82EE: 'Violet',
    A9A9A9: 'Dim gray',
    FFA07A: 'Light salmon',
    FFA500: 'Orange',
    FFFF00: 'Yellow',
    '00FF00': 'lime',
    AFEEEE: 'Pale blue',
    ADD8E6: 'Svelto blue',
    DDA0DD: 'Plum',
    D3D3D3: 'Light grey',
    FFF0F5: 'Pink-lavender',
    FAEBD7: 'Antique white',
    FFFFE0: 'Light yellow',
    F0FFF0: 'Honeydew',
    F0FFFF: 'azure',
    F0F8FF: 'Pale blue',
    E6E6FA: 'Lavender',
    FFF: 'White'
  },
  more: 'More colors...',
  panelTitle: 'Colors',
  textColorTitle: 'Text color'
});

/***/ }),
/* 94 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

/*
Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
For licensing, see LICENSE.md or http://ckeditor.com/license
*/
CKEDITOR.plugins.setLang('colortext', 'vn', {
  auto: 'Automatically',
  bgColorTitle: 'Background color',
  colors: {
    '000': 'Black',
    '800000': 'Maroon',
    '8B4513': 'Leather-brown',
    '2F4F4F': 'Dark slate gray',
    '008080': 'Blue-green',
    '000080': 'Navy blue',
    '4B0082': 'Indigo',
    '696969': 'Dark grey',
    B22222: 'Brick',
    A52A2A: 'Brown',
    DAA520: 'Golden birch',
    '006400': 'Dark green',
    '40E0D0': 'Turquoise',
    '0000CD': 'medium blue',
    '800080': 'Purple',
    '808080': 'Grey',
    F00: 'Red',
    FF8C00: 'Dark orange',
    FFD700: 'Gold',
    '008000': 'Green',
    '0FF': 'Cornflower',
    '00F': 'Blue',
    EE82EE: 'Violet',
    A9A9A9: 'Dim gray',
    FFA07A: 'Light salmon',
    FFA500: 'Orange',
    FFFF00: 'Yellow',
    '00FF00': 'lime',
    AFEEEE: 'Pale blue',
    ADD8E6: 'Svelto blue',
    DDA0DD: 'Plum',
    D3D3D3: 'Light grey',
    FFF0F5: 'Pink-lavender',
    FAEBD7: 'Antique white',
    FFFFE0: 'Light yellow',
    F0FFF0: 'Honeydew',
    F0FFFF: 'azure',
    F0F8FF: 'Pale blue',
    E6E6FA: 'Lavender',
    FFF: 'White'
  },
  more: 'More colors...',
  panelTitle: 'Colors',
  textColorTitle: 'Text color'
});

/***/ }),
/* 95 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.add('colortext', {
	requires: 'panelbutton',
	lang: 'af,ar,bg,bn,bs,ca,cs,cy,da,de,el,en,en-au,en-ca,en-gb,eo,es,et,eu,fa,fi,fo,fr,fr-ca,gl,gu,he,hi,hr,hu,id,is,it,ja,ka,km,ko,ku,lt,lv,mk,mn,ms,nb,nl,no,pl,pt,pt-br,ro,ru,si,sk,sl,sq,sr,sr-latn,sv,th,tr,tt,ug,uk,vi,zh,zh-cn', // %REMOVE_LINE_CORE%
	icons: 'bgcolor,textcolor', // %REMOVE_LINE_CORE%
	hidpi: true, // %REMOVE_LINE_CORE%
	init: function init(editor) {

		var config = editor.config,
		    lang = editor.lang.colortext,
		    blockGlobal;

		if (!CKEDITOR.env.hc) {
			addButton('ColorText', 'fore', lang.textColorTitle, 1);
		}

		function addButton(name, type, title, order) {
			var style = new CKEDITOR.style(config['colorText_foreStyle']),
			    colorBoxId = CKEDITOR.tools.getNextId() + '_colorBox';

			editor.ui.add(name, CKEDITOR.UI_PANELBUTTON, {
				label: title,
				title: title,
				className: 'cke_colortext',
				modes: { wysiwyg: 1 },
				editorFocus: 0,
				toolbar: 'colors,' + order,
				allowedContent: style,
				requiredContent: style,

				panel: {
					css: CKEDITOR.skin.getPath('editor'),
					attributes: { role: 'listbox', 'aria-label': lang.panelTitle }
				},

				rgb2rgba: function rgb2rgba(rgb, alpha) {
					if (rgb && rgb.indexOf('a') == -1) {
						return rgb.replace(')', ', ' + alpha + ')').replace('rgb', 'rgba');
					} else return rgb;
				},

				getColor: function getColor() {
					var span = editor.elementPath().contains(isColorSpan);

					return span ? span.getStyle('color') : null;

					function isColorSpan(el) {
						return el.getStyle('color');
					}
				},

				onOpen: function onOpen(panel, block) {
					var color = this.getColor();
					color = this.rgb2rgba(color, 1);
					var rgbaStringArray = color.match(/[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s]?([\d.]+)[\s+]?/g);
					var rgb = rgbaStringArray[0].split(', ');
					var opacity = rgb[3];

					$(blockGlobal.element.$).find('.cke__colortext__input').data("hex", false);
					$(blockGlobal.element.$).find('.cke__colortext__input').val(color);
					$(blockGlobal.element.$).find('.cke__colortext__input').attr("data-opacity", opacity);
					$(blockGlobal.element.$).find('.cke__colortext__input').minicolors('value', color);
				},

				onBlock: function onBlock(panel, block) {
					block.element.addClass('cke_colorblock');
					block.element.getDocument().getBody().setStyle('overflow', 'hidden');
					// editor.removeStyle( new CKEDITOR.style( config[ 'colorText_foreStyle' ], { color: 'inherit' } ) );
					blockGlobal = block;

					$(block.element.$).append('<input type="text" class="cke__colortext__input" data-opacity="1" value="#FFFFFF" />');
					$(block.element.$).children('.cke__colortext__input').minicolors({
						opacity: 1,
						CKE: true,
						doc: block.element.getDocument().$,
						inline: true,
						change: function change(hex, opacity) {
							// new CKEDITOR.style( config[ 'colorText_foreStyle' ], { color: hex } ).apply(editor.document)
							var colorStyle = config['colorText_foreStyle'];

							colorStyle.childRule = type == 'back' ? function (element) {
								// It's better to apply background color as the innermost style. (#3599)
								// Except for "unstylable elements". (#6103)
								return isUnstylable(element);
							} : function (element) {
								// Fore color style must be applied inside links instead of around it. (#4772,#6908)
								return !(element.is('a') || element.getElementsByTag('a').count()) || isUnstylable(element);
							};

							new CKEDITOR.style(config['colorText_foreStyle'], { color: hex }).apply(editor.document);
							new CKEDITOR.style(config['colorTextLink_foreStyle'], { color: hex }).apply(editor.document);
						}
					});
					function isUnstylable(ele) {
						return ele.getAttribute('contentEditable') == 'false' || ele.getAttribute('data-nostyle');
					}
					CKEDITOR.ui.fire('ready', this);
				},

				refresh: function refresh(panel, block) {
					if (!editor.activeFilter.check(style)) this.setState(CKEDITOR.TRISTATE_DISABLED);
				}
			});
		}
	}
});

CKEDITOR.config.colorText_foreStyle = {
	element: 'span',
	styles: { 'color': '#(color)' },
	overrides: [{
		element: 'font', attributes: { 'color': null }
	}]
};
CKEDITOR.config.colorTextLink_foreStyle = {
	element: 'a',
	styles: { 'color': '#(color)' },
	overrides: [{
		element: 'font', attributes: { 'color': null }
	}]
};

/***/ }),
/* 96 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* injects from baggage-loader */

/**
 * @file Configuration helper plugin for CKEditor
 * Copyright (C) 2012 Alfonso Mart�nez de Lizarrondo
 *
 */
(function () {
	"use strict";

	// Check if the browser supports the placeholder attribute on textareas natively.

	var supportsPlaceholder = 'placeholder' in document.createElement('textarea');

	// If the data is "empty" (BR, P) or the placeholder then return an empty string.
	// Otherwise return the original data
	function dataIsEmpty(data) {
		var elements_count = $("<div>" + data + "</div>").find("*").length;

		if (elements_count !== 0) return false;

		data = $("<div>" + data + "</div>").find("p").removeAttr("id").html() || data;
		if (!data) return true;

		if (data.length > 20) return false;

		var value = data.replace(/[\n|\t]*/g, '').toLowerCase();

		if (!value || value == '<br>' || value == '<p>&nbsp;<br></p>' || value == '<p><br></p>' || value == '<p>&nbsp;</p>' || value == '&nbsp;' || value == ' ' || value == '&nbsp;<br>' || value == ' <br>') return true;

		return false;
	}

	function addPlaceholder(ev) {
		var editor = ev.editor;
		var root = editor.editable ? editor.editable() : editor.mode == 'wysiwyg' ? editor.document && editor.document.getBody() : editor.textarea;
		var placeholder = ev.listenerData;
		if (!root) return;

		if (editor.mode == 'wysiwyg') {
			// If the blur is due to a dialog, don't apply the placeholder
			if (CKEDITOR.dialog._.currentTop) return;

			if (!root) return;

			if (dataIsEmpty(root.getHtml())) {
				root.setHtml(placeholder);
				root.addClass('placeholder');
			}
		}

		if (editor.mode == 'source') {
			if (supportsPlaceholder) {
				if (ev.name == 'mode') {
					root.setAttribute('placeholder', placeholder);
				}
				return;
			}

			if (dataIsEmpty(root.getValue())) {
				root.setValue(placeholder);
				root.addClass('placeholder');
			}
		}
	}

	function removePlaceholder(ev) {
		var editor = ev.editor;
		var root = editor.editable ? editor.editable() : editor.mode == 'wysiwyg' ? editor.document && editor.document.getBody() : editor.textarea;
		if (!root) return;

		if (editor.mode == 'wysiwyg') {
			if (!root.hasClass('placeholder')) return;

			root.removeClass('placeholder');
			// fill it properly
			if (CKEDITOR.dtd[root.getName()]['p']) {
				root.setHtml(' ');
				// Set caret in position
				var range = new CKEDITOR.dom.range(editor.document);
				range.moveToElementEditablePosition(root.getFirst(), true);
				editor.getSelection().selectRanges([range]);
			} else {
				root.setHtml(' ');
			}
		}

		if (editor.mode == 'source') {
			if (!root.hasClass('placeholder')) return;

			root.removeClass('placeholder');
			root.setValue('');
		}
	}

	function getLang(element) {
		if (!element) return null;

		return element.getAttribute('lang') || getLang(element.getParent());
	}

	CKEDITOR.plugins.add('confighelper', {
		getPlaceholderCss: function getPlaceholderCss() {
			return '.placeholder{ color: #999; }';
		},

		onLoad: function onLoad() {
			// v4
			if (CKEDITOR.addCss) CKEDITOR.addCss(this.getPlaceholderCss());
		},

		init: function init(editor) {

			// correct focus status after switch mode
			editor.on('mode', function (ev) {
				// Let's update to match reality
				ev.editor.focusManager.hasFocus = false;
				// Now focus it:
			});

			// Placeholder - Start
			// Get the placeholder from the replaced element or from the configuration
			var placeholder = editor.element.getAttribute('placeholder') || editor.config.placeholder;

			if (placeholder) {
				// CSS for WYSIWYG mode
				// v3
				if (editor.addCss) editor.addCss(this.getPlaceholderCss());

				// CSS for textarea mode
				var node = CKEDITOR.document.getHead().append('style');
				node.setAttribute('type', 'text/css');
				var content = 'textarea.placeholder { color: #999; font-style: italic; }';

				if (CKEDITOR.env.ie && CKEDITOR.env.version < 11) node.$.styleSheet.cssText = content;else node.$.innerHTML = content;

				// Watch for the calls to getData to remove the placeholder
				editor.on('getData', function (ev) {
					var element = editor.editable ? editor.editable() : editor.mode == 'wysiwyg' ? editor.document && editor.document.getBody() : editor.textarea;

					if (element && element.hasClass('placeholder')) ev.data.dataValue = '';
				});

				// Watch for setData to remove placeholder class
				editor.on('setData', function (ev) {
					if (CKEDITOR.dialog._.currentTop) return;

					if (editor.mode == 'source' && supportsPlaceholder) return;

					var root = editor.editable ? editor.editable() : editor.mode == 'wysiwyg' ? editor.document && editor.document.getBody() : editor.textarea;

					if (!root) return;

					if (!dataIsEmpty(ev.data.dataValue)) {
						// Remove the class if new data is not empty
						if (root.hasClass('placeholder')) root.removeClass('placeholder');
					} else {
						// if data is empty, set it to the placeholder
						addPlaceholder(ev);
					}
				});

				editor.on('blur', addPlaceholder, null, placeholder);
				editor.on('mode', addPlaceholder, null, placeholder);
				editor.on('contentDom', addPlaceholder, null, placeholder);

				editor.on('focus', removePlaceholder);
				editor.on('beforeModeUnload', removePlaceholder);
			} // Placeholder - End


			// SCAYT lang from element lang:
			var lang = editor.config.contentsLanguage || getLang(editor.element);
			if (lang && !editor.config.scayt_sLang) {
				// Remove the stored language
				if (localStorage) localStorage.removeItem("scayt_0_lang");

				// Convert from HTML5 Lang to spellchecker.net values
				var map = {
					'en': 'en_US',
					'en-us': 'en_US',
					'en-gb': 'en_GB',
					'pt-br': 'pt_BR',
					'da': 'da_DK',
					'da-dk': 'da_DK',
					'nl-nl': 'nl_NL',
					'en-ca': 'en_CA',
					'fi-fi': 'fi_FI',
					'fr': 'fr_FR',
					'fr-fr': 'fr_FR',
					'fr-ca': 'fr_CA',
					'de': 'de_DE',
					'de-de': 'de_DE',
					'el-gr': 'el_GR',
					'it': 'it_IT',
					'it-it': 'it_IT',
					'nb-no': 'nb_NO',
					'pt': 'pt_PT',
					'pt-pt': 'pt_PT',
					'es': 'es_ES',
					'es-es': 'es_ES',
					'sv-se': 'sv_SE'
				};
				editor.config.scayt_sLang = map[lang.toLowerCase()];
			}

			// Parse the config to turn it into a js object
			// format= dialogName:tabName:fieldName
			var parseDefinitionToObject = function parseDefinitionToObject(value) {
				// Allow JSON definitions
				if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object') return value;

				var contents = value.split(';'),
				    tabsToProcess = {},
				    i;

				for (i = 0; i < contents.length; i++) {
					var parts = contents[i].split(':');
					if (parts.length == 3) {
						var dialogName = parts[0],
						    tabName = parts[1],
						    fieldName = parts[2];

						if (!tabsToProcess[dialogName]) tabsToProcess[dialogName] = {};
						if (!tabsToProcess[dialogName][tabName]) tabsToProcess[dialogName][tabName] = [];

						tabsToProcess[dialogName][tabName].push(fieldName);
					}
				}
				return tabsToProcess;
			};

			// Customize dialogs:
			CKEDITOR.on('dialogDefinition', function (ev) {
				if (editor != ev.editor) return;

				var dialogName = ev.data.name,
				    dialogDefinition = ev.data.definition,
				    tabsToProcess,
				    i,
				    name,
				    fields,
				    tab;

				if (dialogName == 'tableProperties') dialogName == 'table';

				// Parse the config to turn it into a js object
				if (!('removeDialogFields' in editor._) && editor.config.removeDialogFields) editor._.removeDialogFields = parseDefinitionToObject(editor.config.removeDialogFields);

				// Remove fields of this dialog.
				if (editor._.removeDialogFields && (tabsToProcess = editor._.removeDialogFields[dialogName])) {
					for (name in tabsToProcess) {
						fields = tabsToProcess[name];
						tab = dialogDefinition.getContents(name);

						for (i = 0; i < fields.length; i++) {
							tab.remove(fields[i]);
						}
					}
				}

				if (!('hideDialogFields' in editor._) && editor.config.hideDialogFields) editor._.hideDialogFields = parseDefinitionToObject(editor.config.hideDialogFields);

				// Remove fields of this dialog.
				if (editor._.hideDialogFields && (tabsToProcess = editor._.hideDialogFields[dialogName])) {
					for (name in tabsToProcess) {
						fields = tabsToProcess[name];
						tab = dialogDefinition.getContents(name);

						for (i = 0; i < fields.length; i++) {
							tab.get(fields[i]).hidden = true;
						}
					}
				}

				// Set default values.
				if (editor.config.dialogFieldsDefaultValues && (tabsToProcess = editor.config.dialogFieldsDefaultValues[dialogName])) {
					for (name in tabsToProcess) {
						fields = tabsToProcess[name];
						tab = dialogDefinition.getContents(name);

						for (var fieldName in fields) {
							var dialogField = tab.get(fieldName);
							if (dialogField) dialogField['default'] = fields[fieldName];
						}
					}
				}
			});
		}
	});
})();

/**
 * Allows to define which dialog fiels must be removed
 * @name CKEDITOR.config.removeDialogFields
 * @type {String}
 * @example
 *	editor.config.removeDialogFields = "image:info:txtBorder;image:info:txtHSpace";
 */

/**
 * Allows to define which dialog fiels must be hidden
 * @name CKEDITOR.config.hideDialogFields
 * @type {String}
 * @example
 *	editor.config.hideDialogFields = "image:info:htmlPreview";
 */

/**
 * Allows to define default values for dialog fields
 * @name CKEDITOR.config.dialogFieldsDefaultValues
 * @type {Object}
 * @example
config.dialogFieldsDefaultValues =
{
	image:
		{
			advanced:
				{
					txtGenClass : 'myClass',
					txtGenTitle : 'Image title'
				}
		}
};
 */

/**
 * Placeholder text for empty editor
 * @name CKEDITOR.config.placeholder
 * @type {String}
 * @example
 *	editor.config.placeholder = "Please, type here...";
 */

/***/ }),
/* 97 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.add('customlink', {
  requires: 'panelbutton',
  init: function init(editor) {
    var allowed = 'a[!href]',
        required = 'a[href]',
        plugin = CKEDITOR.plugins.link;

    if (CKEDITOR.dialog.isTabEnabled(editor, 'link', 'advanced')) allowed = allowed.replace(']', ',accesskey,charset,dir,id,lang,name,rel,tabindex,title,type]{*}(*)');
    if (CKEDITOR.dialog.isTabEnabled(editor, 'link', 'target')) allowed = allowed.replace(']', ',target,onclick]');

    function getCompiledProtectionFunction(editor) {
      var emailProtection = editor.config.emailProtection || '',
          compiledProtectionFunction;

      // Compile the protection function pattern.
      if (emailProtection && emailProtection != 'encode') {
        compiledProtectionFunction = {};

        emailProtection.replace(/^([^(]+)\(([^)]+)\)$/, function (match, funcName, params) {
          compiledProtectionFunction.name = funcName;
          compiledProtectionFunction.params = [];
          params.replace(/[^,\s]+/g, function (param) {
            compiledProtectionFunction.params.push(param);
          });
        });
      }

      return compiledProtectionFunction;
    }
    this.compiledProtectionFunction = getCompiledProtectionFunction(editor);

    editor.ui.add('customlink', CKEDITOR.UI_PANELBUTTON, {
      label: 'customlink',
      className: 'cke_customlink',
      title: 'customlink',
      modes: { wysiwyg: 1 },
      editorFocus: 1,
      toolbar: 'customlink,' + 10,
      allowedContent: allowed,
      requiredContent: required,
      panel: {
        css: CKEDITOR.skin.getPath('editor'),
        attributes: { role: 'listbox', 'aria-label': 'lang.panelTitle' }
      },
      onBlock: function onBlock(panel, block) {
        $(block.element.$).addClass('cke_customlink_body').append('<input type="text" class="input input_nano ms-input_border" id="panel-input-link-value" placeholder="http://your-site.com">' + '<div class="checkbox-wrapper ms-checkbox">' + '<input id="panel-checkobx-link-target" type="checkbox" class="checkbox">' + '<label for="panel-checkobx-link-target" title="Mark a message" class="checkbox-label-wrapper">' + '<div class="checkbox-label checkbox-label_small button_border fl">' + '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 9" class="icon-check">' + '<rect x="2.4" y="3.4" transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)" width="10" height="2" class="icon-check__rect"></rect>' + '<rect x="0.2" y="4.8" transform="matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)" width="6" height="2" class="icon-check__rect"></rect>' + '</svg>' + '</div><span class="label-text">' + editor.config.OpenInNewWindow + '</span>' + '</label>' + '</div>');
      },
      onOpen: function onOpen() {

        var defaultValue,
            self = this,
            inputLink = $('.cke_panel_frame').contents().find('#panel-input-link-value'),
            checkboxTarget = $('.cke_panel_frame').contents().find('#panel-checkobx-link-target'),
            selectedElementTag = editor.getSelection().getStartElement(),
            optionsJustclick = window.justclick;

        // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
        // Поиск ссылки у выделенного элемента
        // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-

        var parents = [],
            parentsTags = [],
            par = [],
            parTags = [];

        parents = selectedElementTag.getParents();
        for (var i = 0; i < parents.length; i++) {
          parentsTags.push(parents[i].$.tagName);
        }
        var indexTag = parentsTags.indexOf('A');

        if (indexTag > -1) {
          selectedElementTag = parents[indexTag];
        } else {
          style = new CKEDITOR.style({ element: 'a', type: CKEDITOR.STYLE_INLINE, attributes: { "data-editing": true } });
          style.apply(editor.document);
          if (selectedElementTag.findOne("[data-editing]") == null) {
            par = selectedElementTag.getParents();
            for (var i = 0; i < par.length; i++) {
              parTags.push(par[i].$.tagName);
            }
            var indexTag = parTags.indexOf('A');
            selectedElementTag = par[indexTag];
          } else selectedElementTag = selectedElementTag.findOne("[data-editing]");
        }

        // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
        // Значение по умолчанию
        // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-

        if (plugin.getSelectedLink(editor) && selectedElementTag) {
          defaultValue = $(selectedElementTag).attr("href");

          if (!defaultValue && optionsJustclick && optionsJustclick.useNextPageUrl) {
            defaultValue = '#nextPage';
          }

          var defaultCheck = selectedElementTag.$.target;
        }

        if (defaultCheck) {
          $(checkboxTarget).prop('checked', true);
        } else {
          $(checkboxTarget).prop('checked', false);
        }

        // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
        // Запись значений в параметры
        // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-

        $(checkboxTarget).unbind('change').on('change', function (e) {
          if ($(this).is(':checked')) {
            selectedElementTag.setAttributes({
              'target': '_blank'
            });
          } else {
            selectedElementTag.setAttributes({
              'target': ''
            });
          }
        });

        $(inputLink).val(defaultValue);

        this.updateSelectedElementTag($(inputLink), selectedElementTag);

        $(inputLink).unbind('keyup').on('keyup', function (e) {
          self.updateSelectedElementTag($(this), selectedElementTag);
        });
      },

      updateSelectedElementTag: function updateSelectedElementTag($inputLink, selectedElementTag) {
        var inputLinkValue = $inputLink.val();

        if (inputLinkValue == 0) {
          selectedElementTag.removeAttributes(['href', 'data-cke-saved-href', 'target', 'id']);
        } else {
          selectedElementTag.setAttributes({
            'href': inputLinkValue,
            'data-cke-saved-href': inputLinkValue
          });
        }
      },

      protocolPresent: function protocolPresent(str) {
        var pattern = new RegExp(/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9\+.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[.\!\/\\w]*))?)/);

        return pattern.test(str);
      },

      onClose: function onClose() {
        var parents = [],
            parentsTags = [],
            indexTag,
            inputLinkValue = $('.cke_show .cke_panel_frame').contents().find('#panel-input-link-value').val();
        selectedElementTag = editor.getSelection().getStartElement();

        parents = selectedElementTag.getParents();
        for (var i = 0; i < parents.length; i++) {
          parentsTags.push(parents[i].$.tagName);
        }
        indexTag = parentsTags.indexOf('A');

        if (indexTag >= 0) {
          selectedElementTag = parents[indexTag];
        } else {
          selectedElementTag = selectedElementTag.getParent();
        }

        if (inputLinkValue == 0) {
          $('.cke_panel_frame').contents().find('#panel-checkobx-link-target').prop('checked', false);
          var style = new CKEDITOR.style({ element: 'a', type: CKEDITOR.STYLE_INLINE, alwaysRemoveElement: 1 });
          editor.removeStyle(style);
        } else {
          var link = selectedElementTag && selectedElementTag.getAttribute('href') || selectedElementTag.data('cke-saved-href') || '';
          var parseLink = plugin.parseLinkAttributes(editor, selectedElementTag);
          var linkAttrs = plugin.getLinkAttributes(editor, parseLink);

          if (parseLink.type === 'url' && !!parseLink.url.protocol === false && this.protocolPresent(link)) {
            $(selectedElementTag.$).attr({ 'href': link, 'data-cke-saved-href': link });
          } else {
            $(selectedElementTag.$).attr({ 'href': linkAttrs.set.href, 'data-cke-saved-href': linkAttrs.set['data-cke-saved-href'] });
          }
        }
        $("[data-editing]").removeAttr("data-editing");
      }
    });
  },

  afterInit: function afterInit(editor) {
    // Empty anchors upcasting to fake objects.
    editor.dataProcessor.dataFilter.addRules({
      elements: {
        a: function a(element) {
          if (!element.attributes.name) return null;

          if (!element.children.length) return editor.createFakeParserElement(element, 'cke_anchor', 'anchor');

          return null;
        }
      }
    });

    var pathFilters = editor._.elementsPath && editor._.elementsPath.filters;
    if (pathFilters) {
      pathFilters.push(function (element, name) {
        if (name == 'a') {
          if (CKEDITOR.plugins.link.tryRestoreFakeAnchor(editor, element) || element.getAttribute('name') && (!element.getAttribute('href') || !element.getChildCount())) return 'anchor';
        }
      });
    }
  }
});

/***/ }),
/* 98 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('fontfamily', 'bg', {
  label: "Font",
  voiceLabel: "Font Family",
  panelTitle: "Font Family"
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('fontfamily', 'en', {
  label: "Font",
  voiceLabel: "Font Family",
  panelTitle: "Font Family"
});

/***/ }),
/* 100 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('fontfamily', 'es', {
  label: "Font",
  voiceLabel: "Font Family",
  panelTitle: "Font Family"
});

/***/ }),
/* 101 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('fontfamily', 'it', {
  label: "Font",
  voiceLabel: "Font Family",
  panelTitle: "Font Family"
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('fontfamily', 'ja', {
  label: 'フォント',
  voiceLabel: 'フォントファミリー',
  panelTitle: 'フォントファミリー'
});

/***/ }),
/* 103 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('fontfamily', 'ro', {
  label: "Font",
  voiceLabel: "Font Family",
  panelTitle: "Font Family"
});

/***/ }),
/* 104 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('fontfamily', 'ru', {
  label: "Шрифт",
  voiceLabel: "Название шрифта",
  panelTitle: "Название шрифта"
});

/***/ }),
/* 105 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('fontfamily', 'th', {
  label: "Font",
  voiceLabel: "Font Family",
  panelTitle: "Font Family"
});

/***/ }),
/* 106 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('fontfamily', 'vn', {
  label: "Font",
  voiceLabel: "Font Family",
  panelTitle: "Font Family"
});

/***/ }),
/* 107 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

/**
 * @license Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or http://ckeditor.com/license
 */

(function () {
  function addCombo(editor, comboName, styleType, lang, entries, defaultLabel, styleDefinition, order) {
    var config = editor.config;
    var style = new CKEDITOR.style(styleDefinition);
    var styles = {};

    editor.ui.addRichCombo(comboName, {
      label: lang.label,
      title: lang.panelTitle,
      toolbar: 'styles,' + order,
      allowedContent: style,
      requiredContent: style,

      panel: {
        css: [CKEDITOR.skin.getPath('editor')].concat(config.contentsCss),
        multiSelect: false,
        attributes: { 'aria-label': lang.panelTitle }
      },

      buildList: function buildList() {
        var rebuildList = CKEDITOR.tools.bind(_buildList, this);
        rebuildList();
      },

      sizes: [],

      init: function init() {
        var rebuildList = CKEDITOR.tools.bind(_buildList, this);
        $(editor).bind('rebuildList', rebuildList);
        this.buildList();
        this.startGroup(lang.panelTitle);
      },

      reBuildStyles: function reBuildStyles() {
        styles = {};
        for (var i = 0; i < fonts.length; i++) {
          var name = fonts[i].family;
          var vars = {};
          vars["family"] = name;
          styles[name] = new CKEDITOR.style(styleDefinition, vars);
          styles[name]._.definition.name = name;
        }
      },

      setWeights: function setWeights(value) {
        var fontfind = _.filter(fonts, { family: value });
        if (fontfind[0].variants.length === 0) {
          this.sizes = ["regular"];
        } else {
          this.sizes = fontfind[0].variants;
        }
        editor.ui.instances.fontweight.buildListFontWeight();
      },

      onClick: function onClick(value) {

        // Create style objects for all fonts.
        this.setWeights(value);
        editor.ui.instances.fontweight.onClick(this.sizes[0]);
        editor.focus();
        editor.fire('saveSnapshot');

        var previousValue = this.getValue();
        var style = styles[value];

        // When applying one style over another, first remove the previous one (#12403).
        // NOTE: This is only a temporary fix. It will be moved to the styles system (#12687).
        if (previousValue && value !== previousValue) {
          var previousStyle = styles[previousValue];
          var range = editor.getSelection().getRanges()[0];

          // If the range is collapsed we can't simply use the editor.removeStyle method
          // because it will remove the entire element and we want to split it instead.
          if (range.collapsed) {
            var path = editor.elementPath(),

            // Find the style element.
            matching = path.contains(function (el) {
              return previousStyle.checkElementRemovable(el);
            });

            if (matching) {
              var startBoundary = range.checkBoundaryOfElement(matching, CKEDITOR.START);
              var endBoundary = range.checkBoundaryOfElement(matching, CKEDITOR.END);
              var node;
              var bm;

              // If we are at both boundaries it means that the element is empty.
              // Remove it but in a way that we won't lose other empty inline elements inside it.
              // Example: <p>x<span style="font-size:48px"><em>[]</em></span>x</p>
              // Result: <p>x<em>[]</em>x</p>
              if (startBoundary && endBoundary) {
                bm = range.createBookmark();
                // Replace the element with its children (TODO element.replaceWithChildren).
                while (node = matching.getFirst()) {
                  node.insertBefore(matching);
                }
                matching.remove();
                range.moveToBookmark(bm);

                // If we are at the boundary of the style element, just move out.
              } else if (startBoundary) {
                range.moveToPosition(matching, CKEDITOR.POSITION_BEFORE_START);
              } else if (endBoundary) {
                range.moveToPosition(matching, CKEDITOR.POSITION_AFTER_END);
              } else {
                // Split the element and clone the elements that were in the path
                // (between the startContainer and the matching element)
                // into the new place.
                range.splitElement(matching);
                range.moveToPosition(matching, CKEDITOR.POSITION_AFTER_END);
                cloneSubtreeIntoRange(range, path.elements.slice(), matching);
              }

              editor.getSelection().selectRanges([range]);
            }
          } else if (typeof previousStyle !== 'undefined') {
            editor.removeStyle(previousStyle);
          }
        }

        editor[previousValue === value ? 'removeStyle' : 'applyStyle'](style);
        editor.fire('saveSnapshot');
      },

      onRender: function onRender() {
        var self = this;
        this.buildList();
        editor.on('selectionChange', function (ev) {
          var currentValue = this.getValue();

          var elementPath = ev.data.path,
              elements = elementPath.elements;

          // For each element into the elements path.
          for (var i = 0, element; i < elements.length; i++) {
            element = elements[i];

            // Check if the element is removable by any of
            // the styles.

            for (var value in styles) {
              if (styles[value].checkElementMatch(element, true, editor)) {
                if (value != currentValue) {
                  this.setValue(value);
                  self.setWeights(value);
                }
                return;
              }
            }
          }

          // If no styles match, just empty it.

          if (window.Editor.mode == "email.page.editor") {
            this.setValue('', defaultLabel);
          } else {
            var globalFont = $(".str-wrapper").css('fontFamily').replace(new RegExp('"', 'g'), "");
            this.setValue(globalFont);
          }
        }, this);
      },

      refresh: function refresh() {
        if (!editor.activeFilter.check(style)) {
          this.setState(CKEDITOR.TRISTATE_DISABLED);
        }
      }
    });
  }

  // Clones the subtree between subtreeStart (exclusive) and the
  // leaf (inclusive) and inserts it into the range.
  //
  // @param range
  // @param {CKEDITOR.dom.element[]} elements Elements path in the standard order: leaf -> root.
  // @param {CKEDITOR.dom.element/null} substreeStart The start of the subtree.
  // If null, then the leaf belongs to the subtree.
  function cloneSubtreeIntoRange(range, elements, subtreeStart) {
    var current = elements.pop();
    if (!current) {
      return;
    }
    // Rewind the elements array up to the subtreeStart and then start the real cloning.
    if (subtreeStart) {
      return cloneSubtreeIntoRange(range, elements, current.equals(subtreeStart) ? null : subtreeStart);
    }

    var clone = current.clone();
    range.insertNode(clone);
    range.moveToPosition(clone, CKEDITOR.POSITION_AFTER_START);

    cloneSubtreeIntoRange(range, elements);
  }

  CKEDITOR.plugins.add('fontfamily', {
    requires: 'richcombo',
    // jscs:disable maximumLineLength
    lang: 'af,ar,bg,bn,bs,ca,cs,cy,da,de,el,en,en-au,en-ca,en-gb,eo,es,et,eu,fa,fi,fo,fr,fr-ca,gl,gu,he,hi,hr,hu,id,is,it,ja,ka,km,ko,ku,lt,lv,mk,mn,ms,nb,nl,no,pl,pt,pt-br,ro,ru,si,sk,sl,sq,sr,sr-latn,sv,th,tr,tt,ug,uk,vi,zh,zh-cn', // %REMOVE_LINE_CORE%
    // jscs:enable maximumLineLength
    init: function init(editor) {
      var config = editor.config;
      addCombo(editor, 'FontFamily', 'family', editor.lang.fontfamily, config.font_names, config.font_defaultLabel, config.font_style, 30);
    }
  });
})();

/**
 * The list of fonts names to be displayed in the Font combo in the toolbar.
 * Entries are separated by semi-colons (`';'`), while it's possible to have more
 * than one font for each entry, in the HTML way (separated by comma).
 *
 * A display name may be optionally defined by prefixing the entries with the
 * name and the slash character. For example, `'Arial/Arial, Helvetica, sans-serif'`
 * will be displayed as `'Arial'` in the list, but will be outputted as
 * `'Arial, Helvetica, sans-serif'`.
 *
 *    config.font_names =
 *      'Arial/Arial, Helvetica, sans-serif;' +
 *      'Times New Roman/Times New Roman, Times, serif;' +
 *      'Verdana';
 *
 *    config.font_names = 'Arial;Times New Roman;Verdana';
 *
 * @cfg {String} [font_names=see source]
 * @member CKEDITOR.config
 */

var buildListHasRunOnce = 0;
var _buildList = function _buildList() {
  fonts = window.Editor.Instrumentations.fonts.concat(window.Editor.Instrumentations.defaultFonts);
  this.reBuildStyles();

  if (buildListHasRunOnce) {
    // Remove the old unordered list from the dom.
    // This is just to cleanup the old list within the iframe
    if (this._.panel) {
      $(this._.panel._.iframe.$).contents().find(".fontfield").parents(".cke_panel_block").find("ul").remove();
    }
    // reset list
    this._.items = {};
    if (this._.list) {
      this._.list._.items = {};
    }
  }

  for (var i = 0; i < fonts.length; i++) {
    var name = fonts[i].family;
    // Add the tag entry to the panel list.
    if (this._.list) {
      this.add(name, "<span class='fontfield listitem'>" + name + "</span>", name);
    }
  }

  if (buildListHasRunOnce) {
    // Force CKEditor to commit the html it generates through this.add
    if (this._.list) {
      this._.committed = 0; // We have to set to false in order to trigger a complete commit()
      this.commit();
    }
  }
  buildListHasRunOnce = 1;
};

/**
 * The text to be displayed in the Font combo is none of the available values
 * matches the current cursor position or text selection.
 *
 *    // If the default site font is Arial, we may making it more explicit to the end user.
 *    config.font_defaultLabel = 'Arial';
 *
 * @cfg {String} [font_defaultLabel='']
 * @member CKEDITOR.config
 */
// CKEDITOR.config.font_defaultLabel = '';

/**
 * The style definition to be used to apply the font in the text.
 *
 *    // This is actually the default value for it.
 *    config.font_style = {
 *      element:    'span',
 *      styles:     { 'font-family': '#(family)' },
 *      overrides:    [ { element: 'font', attributes: { 'face': null } } ]
 *     };
 *
 * @cfg {Object} [font_style=see example]
 * @member CKEDITOR.config
 */
CKEDITOR.config.font_style = {
  element: 'span',
  styles: { 'font-family': '#(family)' },
  overrides: [{
    element: 'font', attributes: { 'face': null }
  }]
};

/***/ }),
/* 108 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('fontsize', 'en', {
    title: 'Font Weight',
    label: "Size",
    voiceLabel: "Font Size",
    panelTitle: "Font Size"
});

/***/ }),
/* 109 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('fontsize', 'es', {
    title: 'Peso de fuente',
    label: "Talla",
    voiceLabel: "Tamaño de fuente",
    panelTitle: "Tamaño de fuente"
});

/***/ }),
/* 110 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('fontsize', 'ja', {
    title: 'フォントの太さ',
    label: 'サイズ',
    voiceLabel: 'フォントサイズ',
    panelTitle: 'フォントサイズ'
});

/***/ }),
/* 111 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('fontsize', 'ru', {
  label: "Размер",
  voiceLabel: "Размер шрифта",
  panelTitle: "Размер шрифта"
});

/***/ }),
/* 112 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

/**
 * @license Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or http://ckeditor.com/license
 */

(function () {
  function addCombo(editor, comboName, styleType, lang, entries, defaultLabel, styleDefinition, order) {
    var config = editor.config,
        style = new CKEDITOR.style(styleDefinition);

    // Gets the list of fonts from the settings.
    var names = entries.split(';'),
        values = [];

    // Create style objects for all fonts.
    var styles = {};
    for (var i = 0; i < names.length; i++) {
      var parts = names[i];

      if (parts) {
        parts = parts.split('/');

        var vars = {},
            name = names[i] = parts[0];

        vars[styleType] = values[i] = parts[1] || name;

        styles[name] = new CKEDITOR.style(styleDefinition, vars);
        styles[name]._.definition.name = name;
      } else {
        names.splice(i--, 1);
      }
    }

    editor.ui.addRichCombo(comboName, {
      label: lang.label,
      title: lang.panelTitle,
      toolbar: 'styles,' + order,
      allowedContent: style,
      requiredContent: style,

      panel: {
        css: [CKEDITOR.skin.getPath('editor')].concat(config.contentsCss),
        multiSelect: false,
        attributes: { 'aria-label': lang.panelTitle }
      },

      init: function init() {
        this.startGroup(lang.panelTitle);

        for (var i = 0; i < names.length; i++) {
          var name = names[i];

          // Add the tag entry to the panel list.
          this.add(name, styles[name].buildPreview(), name);
        }
      },

      onClick: function onClick(value) {
        editor.focus();
        editor.fire('saveSnapshot');
        var previousValue = this.getValue(),
            style = styles[value];

        // When applying one style over another, first remove the previous one (#12403).
        // NOTE: This is only a temporary fix. It will be moved to the styles system (#12687).
        if (previousValue && value != previousValue) {
          var previousStyle = styles[previousValue],
              range = editor.getSelection().getRanges()[0];

          // If the range is collapsed we can't simply use the editor.removeStyle method
          // because it will remove the entire element and we want to split it instead.
          if (range.collapsed) {
            var path = editor.elementPath(),

            // Find the style element.
            matching = path.contains(function (el) {
              return previousStyle.checkElementRemovable(el);
            });

            if (matching) {
              var startBoundary = range.checkBoundaryOfElement(matching, CKEDITOR.START),
                  endBoundary = range.checkBoundaryOfElement(matching, CKEDITOR.END),
                  node,
                  bm;

              // If we are at both boundaries it means that the element is empty.
              // Remove it but in a way that we won't lose other empty inline elements inside it.
              // Example: <p>x<span style="font-size:48px"><em>[]</em></span>x</p>
              // Result: <p>x<em>[]</em>x</p>
              if (startBoundary && endBoundary) {
                bm = range.createBookmark();
                // Replace the element with its children (TODO element.replaceWithChildren).
                while (node = matching.getFirst()) {
                  node.insertBefore(matching);
                }
                matching.remove();
                range.moveToBookmark(bm);

                // If we are at the boundary of the style element, just move out.
              } else if (startBoundary) {
                range.moveToPosition(matching, CKEDITOR.POSITION_BEFORE_START);
              } else if (endBoundary) {
                range.moveToPosition(matching, CKEDITOR.POSITION_AFTER_END);
              } else {
                // Split the element and clone the elements that were in the path
                // (between the startContainer and the matching element)
                // into the new place.
                range.splitElement(matching);
                range.moveToPosition(matching, CKEDITOR.POSITION_AFTER_END);
                cloneSubtreeIntoRange(range, path.elements.slice(), matching);
              }

              editor.getSelection().selectRanges([range]);
            }
          } else {
            editor.removeStyle(previousStyle);
          }
        }

        editor[previousValue == value ? 'removeStyle' : 'applyStyle'](style);

        editor.fire('saveSnapshot');
      },

      onRender: function onRender() {
        editor.on('selectionChange', function (ev) {
          var currentValue = this.getValue();

          var elementPath = ev.data.path,
              elements = elementPath.elements;

          // For each element into the elements path.
          for (var i = 0, element; i < elements.length; i++) {
            element = elements[i];

            // Check if the element is removable by any of
            // the styles.
            for (var value in styles) {
              if (styles[value].checkElementMatch(element, true, editor)) {
                if (value != currentValue) this.setValue(value);
                return;
              }
            }
          }

          // If no styles match, just empty it.
          this.setValue('', defaultLabel);
        }, this);
      },

      refresh: function refresh() {
        if (!editor.activeFilter.check(style)) this.setState(CKEDITOR.TRISTATE_DISABLED);
      }
    });
  }

  // Clones the subtree between subtreeStart (exclusive) and the
  // leaf (inclusive) and inserts it into the range.
  //
  // @param range
  // @param {CKEDITOR.dom.element[]} elements Elements path in the standard order: leaf -> root.
  // @param {CKEDITOR.dom.element/null} substreeStart The start of the subtree.
  // If null, then the leaf belongs to the subtree.
  function cloneSubtreeIntoRange(range, elements, subtreeStart) {
    var current = elements.pop();
    if (!current) {
      return;
    }
    // Rewind the elements array up to the subtreeStart and then start the real cloning.
    if (subtreeStart) {
      return cloneSubtreeIntoRange(range, elements, current.equals(subtreeStart) ? null : subtreeStart);
    }

    var clone = current.clone();
    range.insertNode(clone);
    range.moveToPosition(clone, CKEDITOR.POSITION_AFTER_START);

    cloneSubtreeIntoRange(range, elements);
  }

  CKEDITOR.plugins.add('fontsize', {
    requires: 'richcombo',
    // jscs:disable maximumLineLength
    lang: 'af,ar,bg,bn,bs,ca,cs,cy,da,de,el,en,en-au,en-ca,en-gb,eo,es,et,eu,fa,fi,fo,fr,fr-ca,gl,gu,he,hi,hr,hu,id,is,it,ja,ka,km,ko,ku,lt,lv,mk,mn,ms,nb,nl,no,pl,pt,pt-br,ro,ru,si,sk,sl,sq,sr,sr-latn,sv,th,tr,tt,ug,uk,vi,zh,zh-cn', // %REMOVE_LINE_CORE%
    // jscs:enable maximumLineLength
    init: function init(editor) {
      var config = editor.config;
      addCombo(editor, 'FontSize', 'size', editor.lang.fontsize, config.fontSize_sizes, config.fontSize_defaultLabel, config.fontSize_style, 40);
    }
  });
})();

/**
 * The list of fonts names to be displayed in the Font combo in the toolbar.
 * Entries are separated by semi-colons (`';'`), while it's possible to have more
 * than one font for each entry, in the HTML way (separated by comma).
 *
 * A display name may be optionally defined by prefixing the entries with the
 * name and the slash character. For example, `'Arial/Arial, Helvetica, sans-serif'`
 * will be displayed as `'Arial'` in the list, but will be outputted as
 * `'Arial, Helvetica, sans-serif'`.
 *
 *    config.font_names =
 *      'Arial/Arial, Helvetica, sans-serif;' +
 *      'Times New Roman/Times New Roman, Times, serif;' +
 *      'Verdana';
 *
 *    config.font_names = 'Arial;Times New Roman;Verdana';
 *
 * @cfg {String} [font_names=see source]
 * @member CKEDITOR.config
 */
CKEDITOR.config.font_names = 'Arial/Arial, Helvetica, sans-serif;' + 'Comic Sans MS/Comic Sans MS, cursive;' + 'Courier New/Courier New, Courier, monospace;' + 'Georgia/Georgia, serif;' + 'Lucida Sans Unicode/Lucida Sans Unicode, Lucida Grande, sans-serif;' + 'Tahoma/Tahoma, Geneva, sans-serif;' + 'Times New Roman/Times New Roman, Times, serif;' + 'Trebuchet MS/Trebuchet MS, Helvetica, sans-serif;' + 'Verdana/Verdana, Geneva, sans-serif';

/**
 * The text to be displayed in the Font combo is none of the available values
 * matches the current cursor position or text selection.
 *
 *    // If the default site font is Arial, we may making it more explicit to the end user.
 *    config.font_defaultLabel = 'Arial';
 *
 * @cfg {String} [font_defaultLabel='']
 * @member CKEDITOR.config
 */
// CKEDITOR.config.font_defaultLabel = '';

/**
 * The style definition to be used to apply the font in the text.
 *
 *    // This is actually the default value for it.
 *    config.font_style = {
 *      element:    'span',
 *      styles:     { 'font-family': '#(family)' },
 *      overrides:    [ { element: 'font', attributes: { 'face': null } } ]
 *     };
 *
 * @cfg {Object} [font_style=see example]
 * @member CKEDITOR.config
 */
CKEDITOR.config.font_style = {
  element: 'span',
  styles: { 'font-family': '#(family)' },
  overrides: [{
    element: 'font', attributes: { 'face': null }
  }]
};

/**
 * The list of fonts size to be displayed in the Font Size combo in the
 * toolbar. Entries are separated by semi-colons (`';'`).
 *
 * Any kind of "CSS like" size can be used, like `'12px'`, `'2.3em'`, `'130%'`,
 * `'larger'` or `'x-small'`.
 *
 * A display name may be optionally defined by prefixing the entries with the
 * name and the slash character. For example, `'Bigger Font/14px'` will be
 * displayed as `'Bigger Font'` in the list, but will be outputted as `'14px'`.
 *
 *    config.fontSize_sizes = '16/16px;24/24px;48/48px;';
 *
 *    config.fontSize_sizes = '12px;2.3em;130%;larger;x-small';
 *
 *    config.fontSize_sizes = '12 Pixels/12px;Big/2.3em;30 Percent More/130%;Bigger/larger;Very Small/x-small';
 *
 * @cfg {String} [fontSize_sizes=see source]
 * @member CKEDITOR.config
 */
CKEDITOR.config.fontSize_sizes = '8/8px;9/9px;10/10px;11/11px;12/12px;14/14px;16/16px;18/18px;20/20px;22/22px;24/24px;26/26px;28/28px;36/36px;48/48px;72/72px';

var fontSizes = '';
for (var i = 1; i <= 100; i++) {
  fontSizes += i + '/' + i + 'px;';
}

CKEDITOR.config.fontSize_sizes = fontSizes;

/**
 * The text to be displayed in the Font Size combo is none of the available
 * values matches the current cursor position or text selection.
 *
 *    // If the default site font size is 12px, we may making it more explicit to the end user.
 *    config.fontSize_defaultLabel = '12px';
 *
 * @cfg {String} [fontSize_defaultLabel='']
 * @member CKEDITOR.config
 */
CKEDITOR.config.fontSize_defaultLabel = '';

/**
 * The style definition to be used to apply the font size in the text.
 *
 *    // This is actually the default value for it.
 *    config.fontSize_style = {
 *      element:    'span',
 *      styles:     { 'font-size': '#(size)' },
 *      overrides:    [ { element :'font', attributes: { 'size': null } } ]
 *    };
 *
 * @cfg {Object} [fontSize_style=see example]
 * @member CKEDITOR.config
 */
CKEDITOR.config.fontSize_style = {
  element: 'span',
  styles: { 'font-size': '#(size)' },
  overrides: [{
    element: 'font', attributes: { 'size': null }
  }]
};

/***/ }),
/* 113 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('fontweight', '{LANGUAGE_CODE}', {
    title: '{FONT-WEIGHT}'
});

/***/ }),
/* 114 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('fontweight', 'bg', {
    title: 'Font Weight'
});

/***/ }),
/* 115 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('fontweight', 'en', {
    title: 'Font Weight'
});

/***/ }),
/* 116 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('fontweight', 'es', {
    title: 'Font Weight'
});

/***/ }),
/* 117 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('fontweight', 'it', {
    title: 'Font Weight'
});

/***/ }),
/* 118 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('fontweight', 'ja', {
    title: 'フォントの太さ'
});

/***/ }),
/* 119 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('fontweight', 'ro', {
    title: 'Font Weight'
});

/***/ }),
/* 120 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('fontweight', 'ru', {
    title: 'Толщина'
});

/***/ }),
/* 121 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('fontweight', 'th', {
    title: 'Font Weight'
});

/***/ }),
/* 122 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('fontweight', 'vn', {
    title: 'Font Weight'
});

/***/ }),
/* 123 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

(function () {
  function addCombo(editor, comboName, styleType, lang, entries, defaultLabel, styleDefinition, order) {
    var config = editor.config,
        style = new CKEDITOR.style(styleDefinition);
    var styles = {};

    editor.ui.addRichCombo(comboName, {
      label: editor.lang.fontweight.title,
      title: editor.lang.fontweight.title,
      toolbar: 'styles,' + order,
      allowedContent: style,
      requiredContent: style,
      panel: {
        css: [CKEDITOR.skin.getPath('editor')].concat(config.contentsCss),
        multiSelect: false,
        attributes: { 'aria-label': editor.lang.fontweight.title }
      },

      buildListFontWeight: function buildListFontWeight() {
        this.editor = editor;
        var rebuildListFontWeight = CKEDITOR.tools.bind(_buildListFontWeight, this);
        rebuildListFontWeight();
      },

      init: function init() {
        var rebuildListFontWeight = CKEDITOR.tools.bind(_buildListFontWeight, this);
        $(editor).bind('rebuildListFontWeight', rebuildListFontWeight);
        this.buildListFontWeight();
        this.startGroup(editor.lang.fontweight.title);
      },

      reBuildStyles: function reBuildStyles(sizes) {
        for (var i = 0; i < sizes.length; i++) {
          size = sizes[i];
          var vars = {};
          vars["size"] = size;
          styles[size] = new CKEDITOR.style(styleDefinition, vars);
          styles[size]._.definition.name = size;
        }
      },
      onClick: function onClick(value) {
        // Create style objects for all sizes.
        for (var i = 0; i < sizes.length; i++) {
          size = sizes[i];
          var vars = {};
          vars["size"] = size;
          styles[size] = new CKEDITOR.style(styleDefinition, vars);
          styles[size]._.definition.name = size;
        }
        editor.focus();
        editor.fire('saveSnapshot');
        var style = styles[value];
        editor[this.getValue() == value ? 'removeStyle' : 'applyStyle'](style);
        editor.fire('saveSnapshot');
      },
      onRender: function onRender() {
        editor.on('selectionChange', function (ev) {

          var currentValue = this.getValue();
          var elementPath = ev.data.path,
              elements = elementPath.elements;

          for (var i = 0, element; i < elements.length; i++) {
            element = elements[i];
            for (var value in styles) {
              if (styles[value].checkElementMatch(element, true, editor)) {
                if (value != currentValue) this.setValue(value);
                return;
              }
            }
          }
          this.setValue('', defaultLabel);
        }, this);
      },
      refresh: function refresh() {
        if (!editor.activeFilter.check(style)) this.setState(CKEDITOR.TRISTATE_DISABLED);
      }
    });
  }
  CKEDITOR.plugins.add('fontweight', {
    requires: 'richcombo',
    lang: 'en,fr,es',
    init: function init(editor) {
      var config = editor.config;
      addCombo(editor, 'fontweight', 'size', editor.lang.fontweight.title, config.font_weight, editor.lang.fontweight.title, config.fontWeight_style, 40);
    }
  });
})();

var buildListFontWeightHasRunOnce = 0;
var _buildListFontWeight = function _buildListFontWeight() {

  if (this.editor.ui.instances.FontFamily.sizes.length == 0) sizes = CKEDITOR.config.font_weight;else sizes = this.editor.ui.instances.FontFamily.sizes || CKEDITOR.config.font_weight;

  this.reBuildStyles(sizes);

  if (buildListFontWeightHasRunOnce) {
    // Remove the old unordered list from the dom.
    // This is just to cleanup the old list within the iframe
    if (this._.panel) $(this._.panel._.iframe.$).contents().find(".sizefield").parents(".cke_panel_block").find("ul").remove();
    // reset list
    this._.items = {};
    if (this._.list) this._.list._.items = {};
  }

  for (var i = 0; i < sizes.length; i++) {
    var size = sizes[i];
    // Add the tag entry to the panel list.
    italic = size.indexOf("italic") > -1;
    if (this._.list && !italic) this.add(size, "<span class='sizefield listitem'>" + size + "</span>", size);
  }

  if (buildListFontWeightHasRunOnce) {
    // Force CKEditor to commit the html it generates through this.add
    if (this._.list) {
      this._.committed = 0; // We have to set to false in order to trigger a complete commit()
      this.commit();
    }
  }
  buildListFontWeightHasRunOnce = 1;
};

CKEDITOR.config.font_weight = ['normal', 'bold', 'bolder', 'lighter', '100', '200', '300', '400', '500', '600', '700', '800', '900'];
CKEDITOR.config.fontWeight_style = {
  element: 'span',
  styles: {
    "font-weight": "#(size)"
  },
  overrides: [{
    element: 'font-weight', attributes: { 'size': null }
  }]
};

/***/ }),
/* 124 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

/*
Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
For licensing, see LICENSE.md or http://ckeditor.com/license
*/
CKEDITOR.plugins.setLang('justify', 'en', {
	block: 'Justify',
	center: 'Center',
	left: 'Align Left',
	right: 'Align Right'
});

/***/ }),
/* 125 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

/*
Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
For licensing, see LICENSE.md or http://ckeditor.com/license
*/
CKEDITOR.plugins.setLang('justify', 'es', {
	block: 'Justificar',
	center: 'Centrar',
	left: 'Alinear a la izquierda',
	right: 'Alinear a la derecha'
});

/***/ }),
/* 126 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

/*
Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
For licensing, see LICENSE.md or http://ckeditor.com/license
*/
CKEDITOR.plugins.setLang('justify', 'ja', {
	block: '正当化する',
	center: 'センター',
	left: '左揃え',
	right: '右揃え'
});

/***/ }),
/* 127 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

/*
Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
For licensing, see LICENSE.md or http://ckeditor.com/license
*/
CKEDITOR.plugins.setLang('justify', 'ru', {
	block: 'По ширине',
	center: 'По центру',
	left: 'По левому краю',
	right: 'По правому краю'
});

/***/ }),
/* 128 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

/**
 * @license Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or http://ckeditor.com/license
 */

/**
 * @fileOverview Justify commands.
 */

(function () {
	function getAlignment(element, useComputedState) {
		useComputedState = useComputedState === undefined || useComputedState;

		var align;
		if (useComputedState) align = element.getComputedStyle('text-align');else {
			while (!element.hasAttribute || !(element.hasAttribute('align') || element.getStyle('text-align'))) {
				var parent = element.getParent();
				if (!parent) break;
				element = parent;
			}
			align = element.getStyle('text-align') || element.getAttribute('align') || '';
		}

		// Sometimes computed values doesn't tell.
		align && (align = align.replace(/(?:-(?:moz|webkit)-)?(?:start|auto)/i, ''));

		!align && useComputedState && (align = element.getComputedStyle('direction') == 'rtl' ? 'right' : 'left');

		return align;
	}

	function justifyCommand(editor, name, value) {
		this.editor = editor;
		this.name = name;
		this.value = value;
		this.context = 'p';

		var classes = editor.config.justifyClasses,
		    blockTag = editor.config.enterMode == CKEDITOR.ENTER_P ? 'p' : 'div';

		if (classes) {
			switch (value) {
				case 'left':
					this.cssClassName = classes[0];
					break;
				case 'center':
					this.cssClassName = classes[1];
					break;
				case 'right':
					this.cssClassName = classes[2];
					break;
				case 'justify':
					this.cssClassName = classes[3];
					break;
			}

			this.cssClassRegex = new RegExp('(?:^|\\s+)(?:' + classes.join('|') + ')(?=$|\\s)');
			this.requiredContent = blockTag + '(' + this.cssClassName + ')';
		} else {
			this.requiredContent = blockTag + '{text-align}';
		}

		this.allowedContent = {
			'caption div h1 h2 h3 h4 h5 h6 p pre td th li': {
				// Do not add elements, but only text-align style if element is validated by other rule.
				propertiesOnly: true,
				styles: this.cssClassName ? null : 'text-align',
				classes: this.cssClassName || null
			}
		};

		// In enter mode BR we need to allow here for div, because when non other
		// feature allows div justify is the only plugin that uses it.
		if (editor.config.enterMode == CKEDITOR.ENTER_BR) this.allowedContent.div = true;
	}

	function onDirChanged(e) {
		var editor = e.editor;

		var range = editor.createRange();
		range.setStartBefore(e.data.node);
		range.setEndAfter(e.data.node);

		var walker = new CKEDITOR.dom.walker(range),
		    node;

		while (node = walker.next()) {
			if (node.type == CKEDITOR.NODE_ELEMENT) {
				// A child with the defined dir is to be ignored.
				if (!node.equals(e.data.node) && node.getDirection()) {
					range.setStartAfter(node);
					walker = new CKEDITOR.dom.walker(range);
					continue;
				}

				// Switch the alignment.
				var classes = editor.config.justifyClasses;
				if (classes) {
					// The left align class.
					if (node.hasClass(classes[0])) {
						node.removeClass(classes[0]);
						node.addClass(classes[2]);
					}
					// The right align class.
					else if (node.hasClass(classes[2])) {
							node.removeClass(classes[2]);
							node.addClass(classes[0]);
						}
				}

				// Always switch CSS margins.
				var style = 'text-align';
				var align = node.getStyle(style);

				if (align == 'left') node.setStyle(style, 'right');else if (align == 'right') node.setStyle(style, 'left');
			}
		}
	}

	justifyCommand.prototype = {
		exec: function exec(editor) {
			var selection = editor.getSelection(),
			    enterMode = editor.config.enterMode;

			if (!selection) return;

			var bookmarks = selection.createBookmarks(),
			    ranges = selection.getRanges();

			var cssClassName = this.cssClassName,
			    iterator,
			    block;

			var useComputedState = editor.config.useComputedState;
			useComputedState = useComputedState === undefined || useComputedState;

			for (var i = ranges.length - 1; i >= 0; i--) {
				iterator = ranges[i].createIterator();
				iterator.enlargeBr = enterMode != CKEDITOR.ENTER_BR;

				while (block = iterator.getNextParagraph(enterMode == CKEDITOR.ENTER_P ? 'p' : 'div')) {
					if (block.isReadOnly()) continue;

					block.removeAttribute('align');
					block.removeStyle('text-align');

					// Remove any of the alignment classes from the className.
					var className = cssClassName && (block.$.className = CKEDITOR.tools.ltrim(block.$.className.replace(this.cssClassRegex, '')));

					var apply = this.state == CKEDITOR.TRISTATE_OFF && (!useComputedState || getAlignment(block, true) != this.value);

					if (cssClassName) {
						// Append the desired class name.
						if (apply) block.addClass(cssClassName);else if (!className) block.removeAttribute('class');
					} else if (apply) {
						block.setStyle('text-align', this.value);
					}
				}
			}

			editor.focus();
			editor.forceNextSelectionCheck();
			selection.selectBookmarks(bookmarks);
		},

		refresh: function refresh(editor, path) {
			var firstBlock = path.block || path.blockLimit;

			this.setState(firstBlock.getName() != 'body' && getAlignment(firstBlock, this.editor.config.useComputedState) == this.value ? CKEDITOR.TRISTATE_ON : CKEDITOR.TRISTATE_OFF);
		}
	};

	CKEDITOR.plugins.add('justify', {
		// jscs:disable maximumLineLength
		lang: 'af,ar,bg,bn,bs,ca,cs,cy,da,de,el,en,en-au,en-ca,en-gb,eo,es,et,eu,fa,fi,fo,fr,fr-ca,gl,gu,he,hi,hr,hu,id,is,it,ja,ka,km,ko,ku,lt,lv,mk,mn,ms,nb,nl,no,pl,pt,pt-br,ro,ru,si,sk,sl,sq,sr,sr-latn,sv,th,tr,tt,ug,uk,vi,zh,zh-cn', // %REMOVE_LINE_CORE%
		// jscs:enable maximumLineLength
		// icons: 'justifyblock,justifycenter,justifyleft,justifyright', // %REMOVE_LINE_CORE%
		// hidpi: true, // %REMOVE_LINE_CORE%
		init: function init(editor) {
			if (editor.blockless) return;

			var left = new justifyCommand(editor, 'justifyleft', 'left'),
			    center = new justifyCommand(editor, 'justifycenter', 'center'),
			    right = new justifyCommand(editor, 'justifyright', 'right'),
			    justify = new justifyCommand(editor, 'justifyblock', 'justify');

			editor.addCommand('justifyleft', left);
			editor.addCommand('justifycenter', center);
			editor.addCommand('justifyright', right);
			editor.addCommand('justifyblock', justify);

			if (editor.ui.addButton) {
				editor.ui.addButton('JustifyLeft', {
					label: editor.lang.justify.left,
					command: 'justifyleft',
					toolbar: 'align,10'
				});
				editor.ui.addButton('JustifyCenter', {
					label: editor.lang.justify.center,
					command: 'justifycenter',
					toolbar: 'align,20'
				});
				editor.ui.addButton('JustifyRight', {
					label: editor.lang.justify.right,
					command: 'justifyright',
					toolbar: 'align,30'
				});
				editor.ui.addButton('JustifyBlock', {
					label: editor.lang.justify.block,
					command: 'justifyblock',
					toolbar: 'align,40'
				});
			}

			editor.on('dirChanged', onDirChanged);
		}
	});
})();

/**
 * List of classes to use for aligning the contents. If it's `null`, no classes will be used
 * and instead the corresponding CSS values will be used.
 *
 * The array should contain 4 members, in the following order: left, center, right, justify.
 *
 *		// Use the classes 'AlignLeft', 'AlignCenter', 'AlignRight', 'AlignJustify'
 *		config.justifyClasses = [ 'AlignLeft', 'AlignCenter', 'AlignRight', 'AlignJustify' ];
 *
 * @cfg {Array} [justifyClasses=null]
 * @member CKEDITOR.config
 */

/***/ }),
/* 129 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('lineheight', '{LANGUAGE_CODE}', {
    title: '{LINE-HEIGHT}'
});

/***/ }),
/* 130 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('lineheight', 'en', {
    title: 'Line Height'
});

/***/ }),
/* 131 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('lineheight', 'es', {
    title: 'Altura de Línea'
});

/***/ }),
/* 132 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('lineheight', 'fr', {
    title: 'Hauteur de Ligne'
});

/***/ }),
/* 133 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('lineheight', 'ja', {
    title: '行の高さ'
});

/***/ }),
/* 134 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

(function () {
  function addCombo(editor, comboName, styleType, lang, entries, defaultLabel, styleDefinition, order) {
    var config = editor.config,
        style = new CKEDITOR.style(styleDefinition);
    var names = entries.split(';'),
        values = [];
    var styles = {};
    for (var i = 0; i < names.length; i++) {
      var parts = names[i];
      if (parts) {
        parts = parts.split('/');
        var vars = {},
            name = names[i] = parts[0];
        vars[styleType] = values[i] = parts[1] || name;
        styles[name] = new CKEDITOR.style(styleDefinition, vars);
        styles[name]._.definition.name = name;
      } else names.splice(i--, 1);
    }
    editor.ui.addRichCombo(comboName, {
      label: editor.lang.lineheight.title,
      title: editor.lang.lineheight.title,
      toolbar: 'styles,' + order,
      allowedContent: style,
      requiredContent: style,
      panel: {
        css: [CKEDITOR.skin.getPath('editor')].concat(config.contentsCss),
        multiSelect: false,
        attributes: { 'aria-label': editor.lang.lineheight.title }
      },
      init: function init() {
        this.startGroup(editor.lang.lineheight.title);
        for (var i = 0; i < names.length; i++) {
          var name = names[i];
          this.add(name, styles[name].buildPreview(), name);
        }
      },
      onClick: function onClick(value) {
        editor.focus();
        editor.fire('saveSnapshot');
        var style = styles[value];
        editor[this.getValue() == value ? 'removeStyle' : 'applyStyle'](style);
        editor.fire('saveSnapshot');
      },
      onRender: function onRender() {
        editor.on('selectionChange', function (ev) {
          var currentValue = this.getValue();
          var elementPath = ev.data.path,
              elements = elementPath.elements;
          for (var i = 0, element; i < elements.length; i++) {
            element = elements[i];
            for (var value in styles) {
              if (styles[value].checkElementMatch(element, true, editor)) {
                if (value != currentValue) this.setValue(value);
                return;
              }
            }
          }
          this.setValue('', defaultLabel);
        }, this);
      },
      refresh: function refresh() {
        if (!editor.activeFilter.check(style)) this.setState(CKEDITOR.TRISTATE_DISABLED);
      }
    });
  }
  CKEDITOR.plugins.add('lineheight', {
    requires: 'richcombo',
    lang: 'en,fr,es',
    init: function init(editor) {
      var config = editor.config;
      addCombo(editor, 'lineheight', 'size', editor.lang.lineheight.title, config.line_height, editor.lang.lineheight.title, config.lineHeight_style, 40);
    }
  });
})();
CKEDITOR.config.line_height = '0.5;0.6;0.7;0.8;0.9;1;1.1;1.2;1.3;1.4;1.5;1.6;1.7;1.8;1.9;2;2.1;2.2;2.3;2.4;2.5;2.6;2.7;2.8;2.9;3;4;5;6;7;8;9;10';
CKEDITOR.config.lineHeight_style = {
  element: 'span',
  styles: {
    "display": "inline-block",
    "line-height": "#(size)"
  },
  overrides: [{
    element: 'line-height', attributes: { 'size': null }
  }]
};

/***/ }),
/* 135 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

/*
 Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
 For licensing, see LICENSE.md or http://ckeditor.com/license
*/
CKEDITOR.dialog.add("anchor", function (c) {
    function d(a, b) {
        return a.createFakeElement(a.document.createElement("a", {
            attributes: b
        }), "cke_anchor", "anchor");
    }
    return {
        title: c.lang.link.anchor.title,
        minWidth: 300,
        minHeight: 60,
        onOk: function onOk() {
            var a = CKEDITOR.tools.trim(this.getValueOf("info", "txtName")),
                a = {
                id: a,
                name: a,
                "data-cke-saved-name": a
            };
            if (this._.selectedElement) this._.selectedElement.data("cke-realelement") ? (a = d(c, a), a.replace(this._.selectedElement), CKEDITOR.env.ie && c.getSelection().selectElement(a)) : this._.selectedElement.setAttributes(a);else {
                var b = c.getSelection(),
                    b = b && b.getRanges()[0];
                b.collapsed ? (a = d(c, a), b.insertNode(a)) : (CKEDITOR.env.ie && 9 > CKEDITOR.env.version && (a["class"] = "cke_anchor"), a = new CKEDITOR.style({
                    element: "a",
                    attributes: a
                }), a.type = CKEDITOR.STYLE_INLINE, c.applyStyle(a));
            }
        },
        onHide: function onHide() {
            delete this._.selectedElement;
        },
        onShow: function onShow() {
            var a = c.getSelection(),
                b = a.getSelectedElement(),
                d = b && b.data("cke-realelement"),
                e = d ? CKEDITOR.plugins.link.tryRestoreFakeAnchor(c, b) : CKEDITOR.plugins.link.getSelectedLink(c);
            e && (this._.selectedElement = e, this.setValueOf("info", "txtName", e.data("cke-saved-name") || ""), !d && a.selectElement(e), b && (this._.selectedElement = b));
            this.getContentElement("info", "txtName").focus();
        },
        contents: [{
            id: "info",
            label: c.lang.link.anchor.title,
            accessKey: "I",
            elements: [{
                type: "text",
                id: "txtName",
                label: c.lang.link.anchor.name,
                required: !0,
                validate: function validate() {
                    return !this.getValue() ? (alert(c.lang.link.anchor.errorName), !1) : !0;
                }
            }]
        }]
    };
});

/***/ }),
/* 136 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

/*
 Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
 For licensing, see LICENSE.md or http://ckeditor.com/license
*/
(function () {
    CKEDITOR.dialog.add("link", function (g) {
        var l = CKEDITOR.plugins.link,
            m = function m() {
            var a = this.getDialog(),
                b = a.getContentElement("target", "popupFeatures"),
                a = a.getContentElement("target", "linkTargetName"),
                k = this.getValue();
            if (b && a) switch (b = b.getElement(), b.hide(), a.setValue(""), k) {
                case "frame":
                    a.setLabel(g.lang.link.targetFrameName);
                    a.getElement().show();
                    break;
                case "popup":
                    b.show();
                    a.setLabel(g.lang.link.targetPopupName);
                    a.getElement().show();
                    break;
                default:
                    a.setValue(k), a.getElement().hide();
            }
        },
            f = function f(a) {
            a.target && this.setValue(a.target[this.id] || "");
        },
            h = function h(a) {
            a.advanced && this.setValue(a.advanced[this.id] || "");
        },
            i = function i(a) {
            a.target || (a.target = {});
            a.target[this.id] = this.getValue() || "";
        },
            j = function j(a) {
            a.advanced || (a.advanced = {});
            a.advanced[this.id] = this.getValue() || "";
        },
            c = g.lang.common,
            b = g.lang.link,
            d;
        return {
            title: b.title,
            minWidth: 200,
            minHeight: 85,
            contents: [{
                id: "info",
                label: b.info,
                title: b.info,
                elements: [{
                    id: "linkType",
                    type: "select",
                    label: b.type,
                    "default": "url",
                    items: [[b.toUrl, "url"], [b.toAnchor, "anchor"], [b.toEmail, "email"]],
                    onChange: function onChange() {
                        var a = this.getDialog(),
                            b = ["urlOptions", "anchorOptions", "emailOptions"],
                            k = this.getValue(),
                            e = a.definition.getContents("upload"),
                            e = e && e.hidden;
                        "url" == k ? (g.config.linkShowTargetTab && a.showPage("target"), e || a.showPage("upload")) : (a.hidePage("target"), e || a.hidePage("upload"));
                        for (e = 0; e < b.length; e++) {
                            var c = a.getContentElement("info", b[e]);
                            c && (c = c.getElement().getParent().getParent(), b[e] == k + "Options" ? c.show() : c.hide());
                        }
                        a.layout();
                    },
                    setup: function setup(a) {
                        this.setValue(a.type || "url");
                    },
                    commit: function commit(a) {
                        a.type = this.getValue();
                    }
                }, {
                    type: "vbox",
                    id: "urlOptions",
                    children: [{
                        type: "hbox",
                        children: [{
                            type: "text",
                            id: "url",
                            required: !0,
                            onLoad: function onLoad() {
                                this.allowOnChange = !0;
                            },
                            onKeyUp: function onKeyUp() {
                                this.allowOnChange = !1;
                                var a = this.getDialog().getContentElement("info", "protocol"),
                                    b = this.getValue(),
                                    k = /^((javascript:)|[#\/\.\?])/i,
                                    c = /^(http|https|ftp|news):\/\/(?=.)/i.exec(b);
                                c ? (this.setValue(b.substr(c[0].length)), a.setValue(c[0].toLowerCase())) : k.test(b) && a.setValue("");
                                this.allowOnChange = !0;
                            },
                            onChange: function onChange() {
                                if (this.allowOnChange) this.onKeyUp();
                            },
                            validate: function validate() {
                                var a = this.getDialog();
                                return a.getContentElement("info", "linkType") && "url" != a.getValueOf("info", "linkType") ? !0 : !g.config.linkJavaScriptLinksAllowed && /javascript\:/.test(this.getValue()) ? (alert(c.invalidValue), !1) : this.getDialog().fakeObj ? !0 : CKEDITOR.dialog.validate.notEmpty(b.noUrl).apply(this);
                            },
                            setup: function setup(a) {
                                this.allowOnChange = !1;
                                a.url && this.setValue(a.url.url);
                                this.allowOnChange = !0;
                            },
                            commit: function commit(a) {
                                this.onChange();
                                a.url || (a.url = {});
                                a.url.url = this.getValue();
                                this.allowOnChange = !1;
                            }
                        }],
                        setup: function setup() {
                            this.getDialog().getContentElement("info", "linkType") || this.getElement().show();
                        }
                    }, {
                        type: "button",
                        id: "browse",
                        hidden: "true",
                        filebrowser: "info:url",
                        label: c.browseServer
                    }]
                }]
            }, {
                id: "target",
                elements: [{
                    type: "hbox",
                    widths: ["50%", "50%"],
                    children: [{
                        type: "checkbox",
                        id: "linkTargetType",
                        label: c.target,
                        items: [[c.targetNew, "_blank"]],
                        onChange: m,
                        setup: function setup(a) {
                            a.target && this.setValue(a.target.type || "notSet");
                            m.call(this);
                        },
                        commit: function commit(a) {
                            a.target || (a.target = {});
                            a.target.type = this.getValue();
                        }
                    }]
                }]
            }],
            onShow: function onShow() {
                var a = this.getParentEditor(),
                    b = a.getSelection(),
                    c = null;
                (c = l.getSelectedLink(a)) && c.hasAttribute("href") ? b.getSelectedElement() || b.selectElement(c) : c = null;
                a = l.parseLinkAttributes(a, c);
                this._.selectedElement = c;
                this.setupContent(a);
            },
            onOk: function onOk() {
                var a = {};
                this.commitContent(a);
                var b = g.getSelection(),
                    c = l.getLinkAttributes(g, a);
                if (this._.selectedElement) {
                    var e = this._.selectedElement,
                        d = e.data("cke-saved-href"),
                        f = e.getHtml();
                    e.setAttributes(c.set);
                    e.removeAttributes(c.removed);
                    if (d == f || "email" == a.type && -1 != f.indexOf("@")) e.setHtml("email" == a.type ? a.email.address : c.set["data-cke-saved-href"]), b.selectElement(e);
                    delete this._.selectedElement;
                } else b = b.getRanges()[0], b.collapsed && (a = new CKEDITOR.dom.text("email" == a.type ? a.email.address : c.set["data-cke-saved-href"], g.document), b.insertNode(a), b.selectNodeContents(a)), c = new CKEDITOR.style({
                    element: "a",
                    attributes: c.set
                }), c.type = CKEDITOR.STYLE_INLINE, c.applyToRange(b, g), b.select();
            },
            onLoad: function onLoad() {
                g.config.linkShowAdvancedTab || this.hidePage("advanced");
                g.config.linkShowTargetTab || this.hidePage("target");
            },
            onFocus: function onFocus() {
                var a = this.getContentElement("info", "linkType");
                a && "url" == a.getValue() && (a = this.getContentElement("info", "url"), a.select());
            }
        };
    });
})();

/***/ }),
/* 137 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

/**
 * @license Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or http://ckeditor.com/license
 */

CKEDITOR.plugins.add('panelbutton', {
  requires: 'button',
  onLoad: function onLoad() {
    function clickFn(editor) {
      var _ = this._;

      if (_.state == CKEDITOR.TRISTATE_DISABLED) return;

      this.createPanel(editor);

      if (_.on) {
        _.panel.hide();
        return;
      }

      _.panel.showBlock(this._.id, this.document.getById(this._.id), 4);
    }

    /**
     * @class
     * @extends CKEDITOR.ui.button
     * @todo class and methods
     */
    CKEDITOR.ui.panelButton = CKEDITOR.tools.createClass({
      base: CKEDITOR.ui.button,

      /**
       * Creates a panelButton class instance.
       *
       * @constructor
       */
      $: function $(definition) {
        // We don't want the panel definition in this object.
        var panelDefinition = definition.panel || {};
        delete definition.panel;

        this.base(definition);

        this.document = panelDefinition.parent && panelDefinition.parent.getDocument() || CKEDITOR.document;

        panelDefinition.block = {
          attributes: panelDefinition.attributes
        };
        panelDefinition.toolbarRelated = true;

        this.hasArrow = true;

        this.click = clickFn;

        this._ = {
          panelDefinition: panelDefinition
        };
      },

      statics: {
        handler: {
          create: function create(definition) {
            return new CKEDITOR.ui.panelButton(definition);
          }
        }
      },

      proto: {
        createPanel: function createPanel(editor) {

          var _ = this._;

          if (_.panel) return;

          var panelDefinition = this._.panelDefinition,
              panelBlockDefinition = this._.panelDefinition.block,
              panelParentElement = panelDefinition.parent || CKEDITOR.document.getBody(),
              panel = this._.panel = new CKEDITOR.ui.floatPanel(editor, panelParentElement, panelDefinition),
              block = panel.addBlock(_.id, panelBlockDefinition),
              me = this;

          panel.onShow = function () {
            if (me.className) this.element.addClass(me.className + '_panel');

            me.setState(CKEDITOR.TRISTATE_ON);

            _.on = 1;

            me.editorFocus && editor.focus();

            if (me.onOpen) me.onOpen();
          };

          panel.onHide = function (preventOnClose) {
            if (me.className) this.element.removeClass(me.className + '_panel');

            me.setState(me.modes && me.modes[editor.mode] ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED);

            _.on = 0;

            if (!preventOnClose && me.onClose) me.onClose();
          };

          panel.onEscape = function () {
            panel.hide(1);
            me.document.getById(_.id).focus();
          };

          if (this.onBlock) this.onBlock(panel, block);

          block.onHide = function () {
            _.on = 0;
            me.setState(CKEDITOR.TRISTATE_OFF);
          };
        }
      }
    });
  },
  beforeInit: function beforeInit(editor) {
    editor.ui.addHandler(CKEDITOR.UI_PANELBUTTON, CKEDITOR.ui.panelButton.handler);
  }
});

/**
 * Button UI element.
 *
 * @readonly
 * @property {String} [='panelbutton']
 * @member CKEDITOR
 */
CKEDITOR.UI_PANELBUTTON = 'panelbutton';

/***/ }),
/* 138 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('variable', '{LANGUAGE_CODE}', {
    title: '{LINE-HEIGHT}'
});

/***/ }),
/* 139 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('variable', 'bg', {
    title: 'Insert variable',
    search: 'Search'
});

/***/ }),
/* 140 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('variable', 'en', {
    title: 'Insert variable',
    search: 'Search'
});

/***/ }),
/* 141 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('variable', 'es', {
    title: 'Insertar variable',
    search: 'Buscar'
});

/***/ }),
/* 142 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('variable', 'fr', {
    title: 'Insert variable',
    search: 'Search'
});

/***/ }),
/* 143 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('variable', 'it', {
    title: 'Insert variable',
    search: 'Search'
});

/***/ }),
/* 144 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('variable', 'ja', {
    title: '変数を挿入',
    search: '探す'
});

/***/ }),
/* 145 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('variable', 'ro', {
    title: 'Insert variable',
    search: 'Search'
});

/***/ }),
/* 146 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('variable', 'th', {
    title: 'Add contact field',
    search: 'Search'
});

/***/ }),
/* 147 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.setLang('variable', 'vn', {
    title: 'Insert variable',
    search: 'Search'
});

/***/ }),
/* 148 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

CKEDITOR.plugins.add('variable', {
  init: function init(editor) {
    var command = editor.addCommand('jcContactFields', new CKEDITOR.dialogCommand('jcContactFields'));
    command.modes = { wysiwyg: 1, source: 0 };
    command.canUndo = true;

    editor.ui.addButton('ContactFields', {
      label: '{...}',
      className: 'cke_format',
      command: 'jcContactFields'
    });

    CKEDITOR.dialog.add('jcContactFields', function (editor) {
      return {
        title: editor.lang.variable.title,
        minWidth: 400,
        minHeight: 150,
        onLoad: function onLoad() {
          var _this = this;

          var onChoice = function onChoice(evt) {
            var target = void 0;

            if (evt.data) {
              target = evt.data.getTarget();
            } else {
              target = new CKEDITOR.dom.element(evt);
            }

            editor.insertHtml(target.$.dataset.html);
          };

          var search = function search(evt) {
            var target = void 0;

            if (evt.data) {
              target = evt.data.getTarget();
            } else {
              target = new CKEDITOR.dom.element(evt);
            }

            var value = target.$.value.toLowerCase();
            var container = _this.getContentElement('jc-contact-fields', 'jc-contact-fields-container').getElement();
            var fields = container.$.querySelectorAll('.cke_dialog_ui_button');

            fields.forEach(function (field) {
              if (value.length > 1) {
                var text = field.textContent.toLowerCase();

                if (text.match(new RegExp(value, 'g'))) {
                  if (!field.classList.contains("active")) {
                    field.classList.add("active");
                  }
                } else {
                  if (field.classList.contains("active")) {
                    field.classList.remove("active");
                  }
                }
              } else {
                if (!field.classList.contains("active")) {
                  field.classList.add("active");
                }
              }
            });
          };

          var onClick = CKEDITOR.tools.addFunction(onChoice);
          var onChangeSearch = CKEDITOR.tools.addFunction(search);
          var ckeditorVariables = window.justclick.ckeditorConfig !== undefined ? window.justclick.ckeditorConfig.variables : [];

          var html = ['<div class="jc-contact-fields">' + '<input class="cke_dialog_ui_input_text" type="text"' + ('placeholder="' + editor.lang.variable.search + '" ') + ('onchange="CKEDITOR.tools.callFunction(' + onChangeSearch + ', this)"') + ('onkeyup="CKEDITOR.tools.callFunction(' + onChangeSearch + ', this)">') + '<div class="jc-contact-fields__list">'];

          ckeditorVariables.map(function (field) {
            html.push('<a class="cke_dialog_ui_button active" ' + 'href="javascript: void(0);" ' + ('onclick="CKEDITOR.tools.callFunction(' + onClick + ', this); return false;" ') + ('data-html="' + field.key + '">') + ('' + field.title) + '</a>');
          });

          html.push('</div></div>');

          this.getContentElement('jc-contact-fields', 'jc-contact-fields-container').getElement().setHtml(html.join(''));
        },
        buttons: [CKEDITOR.dialog.cancelButton],
        contents: [{
          id: 'jc-contact-fields',
          elements: [{
            type: 'hbox',
            align: 'top',
            widths: ['320px', '90px'],
            children: [{
              type: 'html',
              id: 'jc-contact-fields-container',
              html: ''
            }]
          }]
        }]
      };
    });
  }
});

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* injects from baggage-loader */

/* globals CKEDITOR, Editor, _, err */
/* jshint browser: true */


var moduleWysiwyg = angular.module('wysiwyg.initializer', ['services.layoutEditor.insertSpace']);

moduleWysiwyg.service('Text', ['$timeout', '$injector', 'ns', 'insertSpace', 'blockEditDialog', '$rootScope', '$filter', function ($timeout, $injector, ns, insertSpace, blockEditDialog, $rootScope, $filter) {
  var Y = void 0;

  var wysiwyg = {
    params: {
      customConfig: document.baseURI + '/components/ckeditor/ckeditor_config.js',
      enterMode: 2,
      format_tags: 'h1;h2;h3;h4;h5;h6;p;div;small',
      format_small: {
        element: 'h6',
        name: 'Small',
        attributes: {
          'class': 'small'
        }
      },
      format_div: {
        element: 'div',
        name: 'Обычный'
      }
    },
    blocks: {},
    findTextBlocks: function findTextBlocks() {
      var layoutEditor = $injector.get('layoutEditor');

      this.blocks = layoutEditor.layout.all([ns.blockTextClass, ns.blockHeadline1Class, ns.blockHeadline2Class, ns.blockHeadline3Class].join(','));
    },
    init: function init(y) {

      Y = y;
      this.findTextBlocks();

      if (!window.CKEDITOR_BASEPATH) {
        window.CKEDITOR_BASEPATH = document.baseURI + '/components/ckeditor/';
      }

      CKEDITOR.config.allowedContent = true;
      CKEDITOR.basePath = document.baseURI + '/components/ckeditor/';
      CKEDITOR.config.language = $rootScope.currentUser.lang;
      CKEDITOR.config.skin = 'moono,' + document.baseURI + '/components/ckeditor/contents.css';
      CKEDITOR.config.removePlugins = 'language, tabletools, liststyle, contextmenu, dragdrop, basket, image, magicline, link';
      CKEDITOR.config.extraPlugins = 'fontweight,customlink,fontfamily,letterspacing,lineheight,alignment,colortext,format,fontsize,blockquote,confighelper,variable,blocksettings';
      CKEDITOR.config.placeholder = $filter('translate')('widget.text.placeholder');
      CKEDITOR.config.OpenInNewWindow = $filter('translate')('widget.text.OpenInNewWindow');
      CKEDITOR.config.forcePasteAsPlainText = true;

      var fonts = window.Editor.Instrumentations.fonts.concat(window.Editor.Instrumentations.defaultFonts);
      fonts = _.map(fonts, function (f) {
        return f.family;
      });

      CKEDITOR.config.font_names = fonts.join(';');
      CKEDITOR.config.toolbar = [{
        name: 'str',
        items: ['fontweight', 'Italic', 'Underline', 'Strike', 'customlink', 'alignment', 'ColorText', 'FontFamily', 'Format', 'FontSize', 'letterspacing', 'lineheight', 'Blockquote', 'BulletedList', 'NumberedList']
      }];

      if (Editor.mode === 'email.page.editor') {
        CKEDITOR.config.toolbar[0].items.push('ContactFields');
      }
      CKEDITOR.config.toolbar[0].items.push('blocksettings');

      this.inlineVisualEditorInit();
    },
    editBlockInit: function editBlockInit(block) {
      block.set('contentEditable', true);
      block.set('id', block._yuid);

      if (!CKEDITOR.instances[block._yuid]) {
        CKEDITOR.disableAutoInline = true;
        CKEDITOR.inline(block._yuid, this.params);
      }
    },
    _onChangeText: function _onChangeText(event) {
      if (blockEditDialog.currentBlock.widget) {
        blockEditDialog.currentBlock.widget.content = event.editor.getData();
      }
    },
    setData: function setData(node, contentHtml) {
      var widgetWrapper = node.one(ns.widgetWrapperClass);

      if (CKEDITOR.instances[widgetWrapper._yuid]) {
        CKEDITOR.instances[widgetWrapper._yuid].setData(contentHtml);
      } else {
        console.error('CKEDITOR instance ' + widgetWrapper._yuid + ': Not found!');
        widgetWrapper.setHTML(contentHtml);
      }
    },
    inlineVisualEditorInit: function inlineVisualEditorInit() {
      var self = this;

      this.blocks.each(function (block) {
        block = block.one(ns.widgetWrapperClass);
        if (!block) {
          err('widget wrapper not found');
        }
        if (block) {
          self.editBlockInit(block);
        }
      });

      _.each(CKEDITOR.instances, function (index, name) {
        CKEDITOR.instances[name].on('change', self._onChangeText, self);
      });
    },
    destroy: function destroy() {
      if (!this.blocks.each) {
        return false;
      }

      this.blocks.each(function (block) {
        block = block.one(ns.widgetWrapperClass);
        if (!block) {
          err('widget wrapper not found');
        }
        if (block) {
          block.set('contentEditable', false);
        }
      });

      _.each(CKEDITOR.instances, function (index, name) {
        CKEDITOR.instances[name].destroy();
      });
    },
    setEvents: function setEvents() {}
  };
  return wysiwyg;
}]);

/***/ }),
/* 150 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

angular.module("siter.io").controller("EditLessonTemplateController", ["$scope", "$rootScope", "$modalInstance", "Lesson", "Translit", "FileUploader", "Restangular", "$state", "$cookies", "template", "$http", "mainTemplate", function ($scope, $rootScope, $modalInstance, Lesson, Translit, FileUploader, Restangular, $state, $cookies, template, $http, mainTemplate) {

  $scope.landing = {};
  $scope.site = template;
  $scope.mainTemplate = mainTemplate;
  $scope.site.tags = _.map($scope.site.tags.split(","), function (tag, index) {
    return { text: tag, id: index };
  });
  $scope.site.colors = _.map($scope.site.colors, function (tag, index) {
    return { text: tag, id: index };
  });

  $scope.transliterate = function (text, entorus) {
    if (entorus === null) {
      entorus = false;
    }
    Translit.one(text, entorus);
  };

  $scope.transliterate_3 = function (text, entorus) {
    if (entorus === null) {
      entorus = false;
    }
    Translit.three(text, entorus);
  };

  Restangular.all('/lms_page_templates/tags').getList().then(function (items) {
    $scope.items = _.map(items, function (item, index) {
      return {
        text: item,
        id: index
      };
    });
  });

  $scope.loadTags = function (query) {
    return Restangular.all("/lms_page_templates/tags?q=" + query).getList();
  };

  $scope.clone = function () {
    $scope.cloning = true;
    Lesson.clone(template.id).then(function (data) {
      $scope.cloning = false;
      $scope.close();
      $rootScope.$broadcast("lesson_form:created", data, template);
    });
  };

  $scope.webPreviewUploader = new FileUploader({
    url: Restangular.configuration.baseUrl + ("/lms_pages/" + template.id),
    autoUpload: false,
    method: "PUT",
    alias: "preview",
    headers: {
      'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
    }
  });

  $scope.webPreviewUploader.onAfterAddingFile = function (item) {
    var ref = item.file.type;
    var types = ["image/jpeg", "image/png"];
    if (types.indexOf(ref) < 0) {
      alert("The file must be png or jpg");
      return false;
    }
  };

  $scope.webPreviewUploader.onSuccessItem = function (fileItem, response, status, headers) {
    template.preview = response.preview.preview;
    $scope.webPreviewUploader.clearQueue();
  };

  $scope.webPreviewUploader.onErrorItem = function (fileItem, response, status, headers) {
    console.error({ fileItem: fileItem, response: response, status: status, headers: headers });
  };

  $scope.mobilePreviewUploader = new FileUploader({
    url: Restangular.configuration.baseUrl + ("/lms_pages/" + template.id),
    autoUpload: false,
    method: "PUT",
    alias: "mobile_preview",
    headers: {
      'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
    }
  });

  $scope.mobilePreviewUploader.onAfterAddingFile = function (item) {
    var ref = item.file.type;
    var types = ["image/jpeg", "image/png"];
    if (types.indexOf(ref) < 0) {
      alert("The file must be png or jpg");
      return false;
    }
  };

  $scope.mobilePreviewUploader.onSuccessItem = function (fileItem, response, status, headers) {
    template.mobile_preview = response.mobile_preview;
    $scope.mobilePreviewUploader.clearQueue();
  };

  $scope.mobilePreviewUploader.onErrorItem = function (fileItem, response, status, headers) {
    console.error({ fileItem: fileItem, response: response, status: status, headers: headers });
  };

  $scope.cancel = function () {
    $modalInstance.dismiss("cancel");
  };

  $scope.close = function () {
    $modalInstance.dismiss("close");
  };

  $scope.saving = false;
  $scope.saveTemplate = function (lesson, editTemplateLesson) {
    if (editTemplateLesson.$invalid) {
      return false;
    }
    $scope.saving = true;
    lesson = angular.copy(lesson);
    lesson.is_template = true;
    lesson.tags = _.map(lesson.tags, function (tag) {
      return tag.text;
    });
    lesson.tags = lesson.tags.join(",");
    lesson.colors = _.map(lesson.colors, function (tag) {
      return tag.text;
    });

    Lesson.update(lesson).then(function (new_site) {
      $scope.saving = false;
      $scope.webPreviewUploader.uploadAll();
      $scope.mobilePreviewUploader.uploadAll();
      $rootScope.$broadcast("lesson_form:updated");
      $scope.close();
    }, function (errors) {
      $scope.errors = errors.data.errors;
      $scope.saving = false;
    });
  };
}]);

/***/ }),
/* 151 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

angular.module("siter.io").controller("NewLessonTemplateController", ["$scope", "$rootScope", "$modalInstance", "Lesson", "Translit", "FileUploader", "Restangular", "$state", "$cookies", function ($scope, $rootScope, $modalInstance, Lesson, Translit, FileUploader, Restangular, $state, $cookies) {
  $scope.landing = {};

  $scope.transliterate = function (text, entorus) {
    if (entorus === null) {
      entorus = false;
    }

    Translit.one(text, entorus);
  };

  $scope.transliterate_3 = function (text, entorus) {
    if (entorus === null) {
      entorus = false;
    }

    Translit.three(text, entorus);
  };

  Restangular.all('/lms_page_templates/tags').getList().then(function (items) {
    $scope.items = _.map(items, function (item, index) {
      return { text: item, id: index };
    });
  });

  $scope.loadTags = function (query) {
    return Restangular.all("/lms_page_templates/tags?q=" + query).getList();
  };

  $scope.webPreviewUploader = new FileUploader({
    url: Restangular.configuration.baseUrl + ("/lms_pages/" + $state.params.siteId),
    autoUpload: false,
    method: "PUT",
    alias: "preview",
    headers: {
      'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
    }
  });

  $scope.webPreviewUploader.onAfterAddingFile = function (item) {
    var ref = item.file.type;
    var types = ["image/jpeg", "image/png"];
    if (types.indexOf(ref) < 0) {
      alert("The file must be png or jpg");
      return false;
    }
  };

  $scope.webPreviewUploader.onSuccessItem = function (fileItem, response, status, headers) {
    $scope.webPreviewUploader.clearQueue();
    $scope.new_site.preview = response.preview.preview;
  };

  $scope.webPreviewUploader.onErrorItem = function (fileItem, response, status, headers) {
    console.error({ fileItem: fileItem, response: response, status: status, headers: headers });
  };

  $scope.mobilePreviewUploader = new FileUploader({
    url: Restangular.configuration.baseUrl + ("/lms_pages/" + $state.params.siteId),
    autoUpload: false,
    method: "PUT",
    alias: "mobile_preview",
    headers: {
      'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
    }
  });

  $scope.mobilePreviewUploader.onAfterAddingFile = function (item) {
    var ref = item.file.type;
    var types = ["image/jpeg", "image/png"];
    if (types.indexOf(ref) < 0) {
      alert("The file must be png or jpg");
      return false;
    }
  };

  $scope.mobilePreviewUploader.onSuccessItem = function (fileItem, response, status, headers) {
    $scope.mobilePreviewUploader.clearQueue();
    $scope.new_site.mobile_preview = response.mobile_preview;
  };

  $scope.mobilePreviewUploader.onErrorItem = function (fileItem, response, status, headers) {};

  var setUploadUrls = function setUploadUrls(siteId) {
    $scope.mobilePreviewUploader.queue.forEach(function (item) {
      return item.url = Restangular.configuration.baseUrl + ("/lms_pages/" + siteId);
    });
    $scope.webPreviewUploader.queue.forEach(function (item) {
      return item.url = Restangular.configuration.baseUrl + ("/lms_pages/" + siteId);
    });
  };

  $scope.cancel = function () {
    $modalInstance.dismiss("cancel");
  };

  $scope.close = function () {
    $modalInstance.dismiss("close");
  };

  $scope.creating = false;
  $scope.site.disabled = true;
  $scope.createTemplate = function (lesson, newTemplateLesson) {
    if (newTemplateLesson.$invalid) {
      return false;
    }
    $scope.creating = true;
    lesson.is_template = true;
    lesson.tags = _.map(lesson.tags, function (tag) {
      return tag.text;
    });
    lesson.tags = lesson.tags.join(",");
    lesson.description = 'Blank template by admin';
    lesson.colors = _.map(lesson.colors, function (tag) {
      return tag.text;
    });

    Lesson.create(lesson).then(function (new_site) {
      $scope.new_site = new_site;
      $scope.creating = false;
      setUploadUrls($scope.new_site.id);
      $scope.mobilePreviewUploader.uploadAll();
      $scope.webPreviewUploader.uploadAll();
      $rootScope.$broadcast("lesson_form:created", $scope.new_site);
      $scope.close();
    }, function (errors) {
      $scope.errors = errors.data.errors;
      $scope.creating = false;
    });
  };
}]);

/***/ }),
/* 152 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

angular.module('siter.io').controller('NewLessonSectionModal', ["$scope", "$state", "$rootScope", "$modalInstance", "Restangular", "$stateParams", "Section", "$window", "FileUploader", "allLessonSections", function ($scope, $state, $rootScope, $modalInstance, Restangular, $stateParams, Section, $window, FileUploader, allLessonSections) {
  var setUploadUrls;

  $scope.close = function () {
    $modalInstance.dismiss("close");
  };

  $scope.loadTags = function (query) {
    return Restangular.all("/sections/tags?q=" + query + "&for_email=true").getList();
  };

  $scope.loadColorTags = function (query) {
    return Restangular.all("/sections/color_tags?q=" + query + "&for_email=true").getList();
  };

  $scope.section = { disabled: true };
  $scope.sectionPreviewUploader = new FileUploader({
    url: Restangular.configuration.baseUrl + ("/lms_page_templates/" + $state.params.siteId),
    autoUpload: false,
    method: "PUT",
    alias: "preview",
    headers: {
      'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
    }
  });

  $scope.sectionPreviewUploader.onAfterAddingFile = function (item) {
    var ref = item.file.type;
    var types = ["image/jpeg", "image/png"];
    if (types.indexOf(ref) < 0) {
      alert("The file must be png or jpg");
      return false;
    }
  };

  $scope.sectionPreviewUploader.onSuccessItem = function (fileItem, response, status, headers) {
    $scope.sectionPreviewUploader.clearQueue();
  };

  $scope.sectionPreviewUploader.onErrorItem = function (fileItem, response, status, headers) {
    console.error({ fileItem: fileItem, response: response, status: status, headers: headers });
  };

  setUploadUrls = function setUploadUrls(sectionId) {
    $scope.sectionPreviewUploader.queue.forEach(function (item) {
      return item.url = Restangular.configuration.baseUrl + ("/sections/" + sectionId);
    });
  };

  $scope.create = function (createSectionForm, section) {
    if (createSectionForm.$invalid) {
      return false;
    }
    $scope.creating = true;
    section.tags = _.map(section.tags, function (tag) {
      return tag.name;
    });
    section.tags = section.tags.join(",");
    section.colors = _.map(section.colors, function (tag) {
      return tag.text;
    });
    section.for_lms_page = true;
    Section.createPublic(section).then(function (sectionData) {
      setUploadUrls(sectionData.id);
      $scope.sectionPreviewUploader.uploadAll();
      $scope.close();
      $scope.creating = false;
      allLessonSections.push(sectionData);
    }, function () {
      return $scope.creating = false;
    });
  };
}]);

/***/ }),
/* 153 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

angular.module('siter.io').controller('Lessons', ["$scope", "Restangular", "$modal", "$stateParams", "$state", 'Lesson', "$rootScope", function ($scope, Restangular, $modal, $stateParams, $state, Lesson, $rootScope) {

  $scope.state = $state;

  var _getLessonSuccess = function _getLessonSuccess(siteData) {
    if (siteData.style_attributes) {
      siteData.style_attributes.maxWidth = parseInt(siteData.style_attributes.maxWidth);
    }
    return $rootScope.site = siteData;
  };

  var _getLessonFail = function _getLessonFail(response) {
    return $state.go("404");
  };

  Lesson.get().then(_getLessonSuccess, _getLessonFail);

  return angular.element("body").on("keypress", "span[contenteditable]", function (e) {
    return e.which !== 13;
  });
}]);

/***/ }),
/* 154 */
/***/ (function(module, exports) {


/* injects from baggage-loader */

angular.module('siter.io').factory('LmsPage', ["Restangular", "$rootScope", "$stateParams", "$state", "$modal", "$injector", function (Restangular, $rootScope, $stateParams, $state, $modal, $injector) {
  return {
    _currentSite: Restangular.one('lms_pages', $stateParams.lessonId),
    get: function get(id) {
      if (id) {
        return Restangular.one('lms_pages', id).get();
      } else {
        return Restangular.one('lms_pages', $stateParams.lessonId).get();
      }
    },
    getList: function getList() {
      return Restangular.all('lms_pages').getList();
    },
    update: function update(site) {
      return Restangular.all('lms_pages').one(site.id).customPUT(site);
    },
    updateByRoute: function updateByRoute(site) {
      return Restangular.all('lms_pages').one($stateParams.lessonId).customPUT(site);
    },
    remove: function remove(id) {
      return Restangular.one('lms_pages', id).remove();
    },
    create: function create(site) {
      return Restangular.all('lms_pages').post(site);
    },
    saveIndex: function saveIndex(changes) {
      return Restangular.one('lms_pages', $stateParams.lessonId).all('assets/save').post({
        changes: changes,
        path: $rootScope.currentFile.full_path
      });
    },
    transfer: function transfer(data) {
      return Restangular.one('lms_pages', $stateParams.lessonId).all("transfer").post(data);
    },
    share: function share(site) {
      return Restangular.one('lms_pages', $stateParams.lessonId).all("share").post(site);
    },
    setTemplate: function setTemplate(template_id) {
      return Restangular.all("lms_pages").one($state.params.lessonId).customPUT({
        template_id: template_id
      });
    },
    addSite: function addSite() {
      return $state.go("root.new_site");
    },
    clearFonts: function clearFonts() {
      return Restangular.all("lms_pages").one($state.params.lessonId).all("clear_fonts").post();
    },
    createTemplate: function createTemplate(templateParams) {
      return Restangular.all("lms_pages").one($state.params.lessonId).all("templates").post(templateParams);
    },
    publish: function publish() {
      return Restangular.all("lms_pages").one($state.params.lessonId).all("build").post();
    },
    clone: function clone(site_id) {
      return Restangular.all("lms_pages").one(site_id).all("clone").post();
    }
  };
}]);

/***/ }),
/* 155 */
/***/ (function(module, exports) {

angular.module('siter.io').controller('PreviewCtrl', [
  "$scope", "$rootScope", "Auth", "$state", "User", "$filter", "$sce", "Lesson", function($scope, $rootScope, Auth, $state, User, $filter, $sce, Lesson) {
    var getPreviewParts, isLmsPreview, setGradient;
    $rootScope.openPreview = function(jcSiteId) {
      var frameUrl, previewParts;
      angular.element('body').addClass('modal-open');
      frameUrl = "/sites/constructor/preview/jc_site_id/" + jcSiteId + "/fromConstructor/true";
      previewParts = getPreviewParts();
      return $scope.preview = {
        active: true,
        siteName: $rootScope.site.name,
        frameUrl: frameUrl,
        header: previewParts.header,
        footer: previewParts.footer
      };
    };
    $scope.closePreview = function() {
      angular.element('body').removeClass('modal-open');
      return $scope.preview.active = false;
    };
    $scope.renderHtml = function(html) {
      return $sce.trustAsHtml(html);
    };
    $scope.initContainer = function() {
      var $contentContainer, isImageExist;
      if (isLmsPreview()) {
        $contentContainer = $(".preview__content");
        $contentContainer.css($rootScope.currentPage.style_attributes);
        $contentContainer.find('.preview__frame').addClass('e__lesson__frame');
        isImageExist = $rootScope.currentPage.background_attributes && $rootScope.currentPage.background_attributes.image_attributes && $rootScope.currentPage.background_attributes.image_attributes.source_url;
        if (isImageExist) {
          $contentContainer.css({
            backgroundImage: "url('" + $rootScope.currentPage.background_attributes.image_attributes.source_url + "')"
          });
        }
        if ($rootScope.currentPage.background_attributes && $rootScope.currentPage.background_attributes.gradient) {
          setGradient($rootScope.currentPage.background_attributes);
        }
        return true;
      }
    };
    setGradient = function(background_attributes) {
      var color_start, color_stop, gradient_css;
      color_start = background_attributes.color_start;
      color_stop = background_attributes.color_stop;
      gradient_css = "background-image:-moz-linear-gradient(top, " + color_start + ", " + color_stop + "); background-image:-webkit-linear-gradient(top, " + color_start + ", " + color_stop + "); background-image:-o-linear-gradient(top, " + color_start + ", " + color_stop + "); background-image:-ms-linear-gradient(top, " + color_start + ", " + color_stop + ");, background-image:linear-gradient(top, " + color_start + ", " + color_stop + "); filter: progid:DXImageTransform.Microsoft.gradient(startColorStr='" + color_start + "', endColorstr='" + color_stop + "');";
      if ($("style#" + $rootScope.currentPage.id + "_preview").length > 0) {
        return $("style#" + $rootScope.currentPage.id + "_preview").html(".preview__content.e__lesson:before { " + gradient_css + " }");
      } else {
        return $('body').append("<style id='" + $rootScope.currentPage.id + "_preview'>.preview__content.e__lesson:before { " + gradient_css + " }</style>");
      }
    };
    getPreviewParts = function() {
      var parts;
      parts = {
        header: '',
        footer: ''
      };
      if (isLmsPreview()) {
        parts.header = window.justclick.lms.header;
        parts.footer = window.justclick.lms.footer;
        Lesson.getLmsStylesheets().then(function(response) {
          return angular.element('#preview_custom_styles').html(response);
        });
      }
      return parts;
    };
    isLmsPreview = function() {
      return Editor.mode === 'lesson.page.editor' && !!window.justclick.lms;
    };
    return window.iFrameUploadDone = function(iFrameNode) {
      var $iFrameDocument, $parentDocument, customStyleNodes, iFrameDocument;
      iFrameDocument = iFrameNode.contentWindow.document;
      iFrameNode.style.height = iFrameDocument.body.scrollHeight + 'px';
      if (isLmsPreview()) {
        $iFrameDocument = $(iFrameDocument);
        $parentDocument = $(parent.document);
        customStyleNodes = $parentDocument.find('#preview_custom_styles').children();
        return _.each(customStyleNodes, function(styleNode) {
          $(styleNode).clone().appendTo($iFrameDocument.find('head'));
          return $iFrameDocument.find('body').addClass('e__lesson');
        });
      }
    };
  }
]);


/***/ }),
/* 156 */
/***/ (function(module, exports) {

angular.module('siter.io').controller('TutorialCtrl', [
  "$scope", "$rootScope", "Auth", "$state", "User", "$filter", function($scope, $rootScope, Auth, $state, User, $filter) {
    var init, resetActive, stateIsMixer, stateIsSiteEditor, tutorialIsNotPassed, tutorialMixerIsNotPassed;
    stateIsMixer = false;
    stateIsSiteEditor = false;
    if ((typeof Editor !== "undefined" && Editor !== null) && (window.Editor != null)) {
      stateIsMixer = window.Editor.mode === 'site.page.mixer' || (window.Editor.mode === 'site.page.editor' && window.Editor.option === 'site.page.mixer');
      stateIsSiteEditor = window.Editor.mode === 'site.page.editor' && window.Editor.option !== 'site.page.mixer';
    }
    init = function() {
      var i, len, video, videos;
      if (stateIsMixer) {
        videos = [
          {
            url: ($filter('translate')('editor.tutorialMixer.video')) + "?autoplay=1&rel=0",
            active: false
          }
        ];
      } else {
        videos = [
          {
            url: ($filter('translate')('editor.tutorial.video1')) + "?autoplay=1&rel=0",
            active: false
          }, {
            url: ($filter('translate')('editor.tutorial.video2')) + "?autoplay=1&rel=0",
            active: false
          }, {
            url: ($filter('translate')('editor.tutorial.video3')) + "?autoplay=1&rel=0",
            active: false
          }
        ];
      }
      $scope.videos = [];
      for (i = 0, len = videos.length; i < len; i++) {
        video = videos[i];
        if (video.url.indexOf("http") > -1) {
          $scope.videos.push(video);
        }
      }
      if ($scope.videos.length > 0) {
        return $scope.videos[0].active = true;
      }
    };
    init();
    $rootScope.openVideoTutorial = function() {
      if (stateIsMixer || stateIsSiteEditor) {
        angular.element('body').addClass('modal-open');
      }
      return $scope.tutorial = {
        active: true
      };
    };
    resetActive = function() {
      var i, len, ref, results, video;
      ref = $scope.videos;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        video = ref[i];
        results.push(video.active = false);
      }
      return results;
    };
    $scope.nextStep = function() {
      var activeVideo, index;
      activeVideo = _.filter($scope.videos, {
        active: true
      })[0];
      index = $scope.videos.indexOf(activeVideo);
      index++;
      if ($scope.videos[index]) {
        resetActive();
        return $scope.videos[index].active = true;
      } else {
        resetActive();
        return $scope.videos[0].active = true;
      }
    };
    $scope.showStep = function(step) {
      resetActive();
      return $scope.videos[step].active = true;
    };
    $scope.closeTutorial = function() {
      var params;
      angular.element('body').removeClass('modal-open');
      $scope.tutorial.active = false;
      if (stateIsMixer) {
        params = {
          tutorial_mixer_passed: true,
          id: $rootScope.currentUser.id
        };
      } else {
        params = {
          tutorial_passed: true,
          id: $rootScope.currentUser.id
        };
      }
      return User.save(params);
    };
    if ($rootScope.currentUser != null) {
      tutorialIsNotPassed = !$rootScope.currentUser.tutorial_passed && stateIsSiteEditor;
      tutorialMixerIsNotPassed = !$rootScope.currentUser.tutorial_mixer_passed && stateIsMixer;
      if ($scope.videos.length > 0 && (tutorialIsNotPassed || tutorialMixerIsNotPassed)) {
        return $rootScope.openVideoTutorial();
      }
    }
  }
]);


/***/ }),
/* 157 */
/***/ (function(module, exports) {

angular.module('siter.io').directive('access', [
  "$timeout", "$rootScope", function($timeout, $rootScope) {
    return {
      restrict: 'A',
      prioriry: 100000,
      scope: false,
      link: function() {},
      compile: function(element, attr, linker) {
        var accessDenied, accessElement, attributes, i, user;
        accessDenied = true;
        accessElement = attr.accessElement;
        user = window.justclick.currentUser;
        attributes = attr.access.split(' ');
        for (i in attributes) {
          if (user.role === attributes[i]) {
            accessDenied = false;
          }
        }
        if (accessDenied) {
          if (accessElement) {
            element.css('display', 'none');
          }
          $timeout(function() {
            return $("[access='" + attr.access + "']").remove();
          });
        }
      }
    };
  }
]);


/***/ }),
/* 158 */
/***/ (function(module, exports) {

angular.module('siter.io').directive('strAutoFocus', [
  "$timeout", function($timeout) {
    return {
      restrict: 'A',
      link: function(scope, element) {
        return $timeout(function() {
          return element[0].focus();
        });
      }
    };
  }
]);


/***/ }),
/* 159 */
/***/ (function(module, exports) {

angular.module("siter.io").directive("errSrc", [
  "$window", function($window) {
    return {
      restrict: "A",
      link: function(scope, element, attrs) {
        attrs.$observe('ngSrc', function(value) {
          if (!value && attrs.errSrc) {
            attrs.$set('src', attrs.errSrc);
          }
        });
        element.bind('error', function() {
          if (attrs.src !== attrs.errSrc) {
            attrs.$set('src', attrs.errSrc);
          }
        });
      }
    };
  }
]);


/***/ }),
/* 160 */
/***/ (function(module, exports) {

angular.module('siter.io').directive('iframeOnload', [
  function() {
    return {
      scope: {
        callBack: '&iframeOnload'
      },
      link: function(scope, element, attrs) {
        element.on('load', function() {
          return scope.callBack();
        });
      }
    };
  }
]);


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

angular.module("siter.io").directive("imageonload", function() {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      element.addClass('image-load');
      element.bind('load', function() {
        element.addClass('image-load_loaded');
      });
    }
  };
});


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

angular.module("siter.io").directive("perfectScrollbar", [
  "$parse", "$window", function($parse, $window) {
    return {
      restrict: 'EA',
      transclude: true,
      template: '<div><div ng-transclude></div></div>',
      replace: true,
      link: function($scope, $elem, $attr) {
        var _onscroll, i, jqWindow, l, opt, options, psOptions, update;
        psOptions = ['wheelSpeed', 'wheelPropagation', 'minScrollbarLength', 'useBothWheelAxes', 'useKeyboard', 'suppressScrollX', 'suppressScrollY', 'scrollXMarginOffset', 'scrollYMarginOffset', 'includePadding'];
        jqWindow = angular.element($window);
        options = {};
        _onscroll = function(e) {
          var scrollLoadDistance;
          scrollLoadDistance = parseInt($attr.scrollLoadDistance);
          if ($elem.scrollTop() === 0) {

          } else if ($elem.scrollTop() > ($elem.prop('scrollHeight') - $elem.height() - scrollLoadDistance)) {
            return !JSON.parse($attr.scrollDisabled) && $scope.$apply($attr.whenScrollDown);
          }
        };
        $elem.unbind("scroll", _onscroll);
        $elem.scroll(_onscroll);
        update = function() {
          $scope.$evalAsync(function() {
            $elem.perfectScrollbar('update');
          });
          if (!$scope.$$phase) {
            $scope.$apply();
          }
        };
        i = 0;
        l = psOptions.length;
        while (i < l) {
          opt = psOptions[i];
          if ($attr[opt] !== void 0) {
            options[opt] = $parse($attr[opt])();
          }
          i++;
        }
        $scope.$evalAsync(function() {
          $elem.perfectScrollbar(options);
        });
        $elem.bind('mouseenter', update);
        if ($attr.refreshOnChange) {
          $scope.$watchCollection($attr.refreshOnChange, function() {
            update();
          });
        }
        if ($attr.refreshOnResize) {
          jqWindow.on('resize', update);
        }
        $elem.bind('$destroy', function() {
          jqWindow.off('resize', update);
          $elem.perfectScrollbar('destroy');
        });
      }
    };
  }
]);


/***/ }),
/* 163 */
/***/ (function(module, exports) {

angular.module("siter.io").directive("resize", [
  "$timeout", "$window", function($timeout, $window) {
    return {
      restrict: "A",
      scope: true,
      link: function(scope, element, attrs) {
        return $timeout(function() {
          scope.type = attrs.resize;
          if (attrs.resizeDependence) {
            scope.dependence = attrs.resizeDependence.split(",");
          }
          if (attrs.resizeAttr) {
            scope.attr = attrs.resizeAttr;
          } else {
            scope.attr = scope.type;
          }
          if (attrs.resizeMargin) {
            scope.margin = attrs.resizeMargin;
          } else {
            scope.margin = 0;
          }
          scope.initializeWindowSize = function() {
            var dependencesSize, i, inner;
            if (scope.type === 'width') {
              if ($window.innerWidth > 980 && $window.innerWidth < 1120) {
                inner = $window.innerWidth;
              }
              if ($window.innerWidth > 1120) {
                inner = 1120;
              }
              if ($window.innerWidth < 980) {
                inner = 980;
              }
            }
            if (scope.type === 'height') {
              inner = $window.innerHeight;
            }
            i = 0;
            dependencesSize = 0;
            if (scope.dependence) {
              if (scope.type === 'width') {
                while (i < scope.dependence.length) {
                  dependencesSize += angular.element(scope.dependence[i]).outerWidth(true);
                  i++;
                }
              }
              if (scope.type === 'height') {
                while (i < scope.dependence.length) {
                  dependencesSize += angular.element(scope.dependence[i]).outerHeight(true);
                  i++;
                }
              }
            }
            scope.elSize = inner - dependencesSize - scope.margin;
            angular.element(element).css(scope.attr, scope.elSize);
          };
          scope.initializeWindowSize();
          return angular.element($window).bind("resize", function() {
            scope.initializeWindowSize();
            if (!scope.$$phase) {
              return scope.$apply();
            }
          });
        });
      }
    };
  }
]);


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

angular.module("siter.io").directive("scrollFix", [
  "$window", function($window) {
    return {
      restrict: "A",
      link: function(scope, element, attrs) {
        var el, inner, outer, scrollWidth, w1, w2, windowWidth;
        el = $(element);
        inner = document.createElement("p");
        inner.style.width = "100%";
        inner.style.height = "200px";
        outer = document.createElement("div");
        outer.style.position = "absolute";
        outer.style.top = "0px";
        outer.style.left = "0px";
        outer.style.visibility = "hidden";
        outer.style.width = "200px";
        outer.style.height = "150px";
        outer.style.overflow = "hidden";
        outer.appendChild(inner);
        document.body.appendChild(outer);
        w1 = inner.offsetWidth;
        outer.style.overflow = "scroll";
        w2 = inner.offsetWidth;
        if (w1 === w2) {
          w2 = outer.clientWidth;
        }
        document.body.removeChild(outer);
        scrollWidth = w1 - w2;
        windowWidth = window.innerWidth - scrollWidth;
        el.css({
          'width': windowWidth
        });
        $(window).resize(function() {
          el.css({
            'width': windowWidth = window.innerWidth - scrollWidth
          });
        });
      }
    };
  }
]);


/***/ }),
/* 165 */
/***/ (function(module, exports) {

angular.module("siter.io").directive("strSelect", [
  "$window", "$timeout", "$compile", function($window, $timeout, $compile) {
    return {
      restrict: "A",
      require: "?ngModel",
      scope: true,
      link: function(scope, element, attrs, ngModel) {
        var backdropEditor, el, placeholder, replace, selectBackdrop;
        if (attrs.selectReplace === "true" || attrs.selectReplace === "false") {
          attrs.selectReplace = JSON.parse(attrs.selectReplace);
        } else {
          attrs.selectReplace = true;
        }
        replace = attrs.selectReplace;
        backdropEditor = attrs.selectEditor || false;
        el = $(element);
        placeholder = el.find('.select__placeholder');
        selectBackdrop = 'select-backdrop';
        scope.optionCheck = function(event, value) {
          ngModel.$setViewValue(value);
          ngModel.$render();
          el.find('.dropdown__option').removeClass('option_active');
          if (replace) {
            placeholder.html($(event.target).text());
          }
          $(event.target).addClass('option_active');
          scope.closeSelect();
        };
        scope.initSelect = function() {
          el.addClass('select_active');
          if (backdropEditor === 'true') {
            $(element).after($compile('<div class="' + selectBackdrop + '" ng-click="closeSelect()"></div>')(scope.$new()));
          } else {
            $('body').append($compile('<div class="' + selectBackdrop + '" ng-click="closeSelect()"></div>')(scope.$new()));
          }
        };
        scope.closeSelect = function() {
          if (attrs.asDropdown) {
            el.find(".option_active").removeClass("option_active");
          }
          el.removeClass('select_active');
          $('.' + selectBackdrop).remove();
        };
        return placeholder.on('click', function() {
          if (!$('.' + selectBackdrop)[0]) {
            scope.initSelect();
            $(document).keyup(function(e) {
              if (e.keyCode === 27) {
                scope.closeSelect();
              }
            });
            if (attrs.selectBg === 'true') {
              $('.' + selectBackdrop).addClass('modal-backdrop in');
            }
            return;
          } else {
            scope.closeSelect();
            return;
          }
        });
      }
    };
  }
]);


/***/ }),
/* 166 */
/***/ (function(module, exports) {

angular.module("siter.io").directive("submitOn", function() {
  return {
    link: function(scope, elm, attrs) {
      return scope.$on(attrs.submitOn, function() {
        return setTimeout(function() {
          return elm.trigger("submit");
        });
      });
    }
  };
});


/***/ }),
/* 167 */
/***/ (function(module, exports) {

var moduleTabsModule;

moduleTabsModule = angular.module('siter.io');

moduleTabsModule.directive("ngTabs", [
  "$timeout", function($timeout) {
    return {
      scope: true,
      restrict: 'EAC',
      controller: [
        "$scope", function($scope) {
          $scope.tabs = {
            index: 0,
            count: 0
          };
          this.headIndex = 0;
          this.bodyIndex = 0;
          this.getTabHeadIndex = function() {
            return $scope.tabs.count = ++this.headIndex;
          };
          this.getTabBodyIndex = function() {
            return ++this.bodyIndex;
          };
        }
      ]
    };
  }
]);

moduleTabsModule.directive("ngTabHead", [
  "$timeout", function($timeout) {
    return {
      scope: false,
      restrict: 'EAC',
      require: '^ngTabs',
      link: function(scope, element, attributes, controller) {
        var active, index, value;
        index = controller.getTabHeadIndex();
        value = attributes.ngTabHead;
        active = /[-*\/%^=!<>&|]/.test(value) ? scope.$eval(value) : !!value;
        scope.tabs.index = scope.tabs.index || (active ? index : null);
        element.bind('click', function() {
          scope.tabs.index = index;
          scope.$$phase || scope.$apply();
        });
        scope.$watch('tabs.index', function() {
          element.toggleClass('link_active', scope.tabs.index === index);
        });
      }
    };
  }
]);

moduleTabsModule.directive("ngTabBody", [
  "$timeout", function($timeout) {
    return {
      scope: false,
      restrict: 'EAC',
      require: '^ngTabs',
      link: function(scope, element, attributes, controller) {
        var index;
        index = controller.getTabBodyIndex();
        scope.$watch('tabs.index', function() {
          element.toggleClass(attributes.ngTabBody + ' ng-show', scope.tabs.index === index);
        });
      }
    };
  }
]);


/***/ }),
/* 168 */
/***/ (function(module, exports) {

angular.module("siter.io").directive('tooltips', [
  '$window', '$compile', '$interpolate', function($window, $compile, $interpolate) {
    var CSS_PREFIX, INTERPOLATE_END_SYM, INTERPOLATE_START_SYM, TOOLTIP_LARGE_MARGIN, TOOLTIP_MEDIUM_MARGIN, TOOLTIP_SMALL_MARGIN;
    TOOLTIP_SMALL_MARGIN = 8;
    TOOLTIP_MEDIUM_MARGIN = 9;
    TOOLTIP_LARGE_MARGIN = 10;
    CSS_PREFIX = '_720kb-tooltip-';
    INTERPOLATE_START_SYM = $interpolate.startSymbol();
    INTERPOLATE_END_SYM = $interpolate.endSymbol();
    return {
      'restrict': 'A',
      'scope': {},
      'link': function($scope, element, attr) {
        var body, className, closeButtonContent, content, delay, hasCloseButton, height, hideTriggers, html, htmlTemplate, initialized, lazyMode, offsetLeft, offsetTop, onMouseEnterAndMouseOver, onMouseLeaveAndMouseOut, onResize, originSide, showTriggers, side, size, speed, theTooltip, theTooltipHeight, theTooltipMargin, theTooltipWidth, thisElement, title, tryPosition, width;
        initialized = false;
        thisElement = angular.element(element[0]);
        body = angular.element($window.document.getElementsByTagName('body')[0]);
        theTooltip = void 0;
        theTooltipHeight = void 0;
        theTooltipWidth = void 0;
        theTooltipMargin = void 0;
        height = void 0;
        width = void 0;
        offsetTop = void 0;
        offsetLeft = void 0;
        title = attr.tooltipTitle || attr.title || '';
        content = attr.tooltipContent || '';
        html = attr.tooltipHtml || '';
        showTriggers = attr.tooltipShowTrigger || 'mouseover';
        hideTriggers = attr.tooltipHideTrigger || 'mouseleave';
        originSide = attr.tooltipSide || 'top';
        side = originSide;
        size = attr.tooltipSize || 'medium';
        tryPosition = typeof attr.tooltipTry !== 'undefined' && attr.tooltipTry !== null ? $scope.$eval(attr.tooltipTry) : true;
        className = attr.tooltipClass || '';
        speed = (attr.tooltipSpeed || 'medium').toLowerCase();
        delay = attr.tooltipDelay || 0;
        lazyMode = typeof attr.tooltipLazy !== 'undefined' && attr.tooltipLazy !== null ? $scope.$eval(attr.tooltipLazy) : true;
        hasCloseButton = typeof attr.tooltipCloseButton !== 'undefined' && attr.tooltipCloseButton !== null;
        closeButtonContent = attr.tooltipCloseButton || '';
        htmlTemplate = '<div class="_720kb-tooltip ' + CSS_PREFIX + size + '">';
        onMouseEnterAndMouseOver = function() {
          if (!lazyMode || !initialized) {
            initialized = true;
            $scope.initTooltip(side);
          }
          if (tryPosition) {
            $scope.tooltipTryPosition();
          }
          $scope.showTooltip();
        };
        onMouseLeaveAndMouseOut = function() {
          $scope.hideTooltip();
        };
        onResize = function() {
          $scope.hideTooltip();
          $scope.initTooltip(originSide);
        };
        if (hasCloseButton) {
          htmlTemplate = htmlTemplate + '<span class="' + CSS_PREFIX + 'close-button" ng-click="hideTooltip()"> ' + closeButtonContent + ' </span>';
        }
        htmlTemplate = htmlTemplate + '<div class="' + CSS_PREFIX + 'title"> ' + INTERPOLATE_START_SYM + 'title' + INTERPOLATE_END_SYM + '</div>' + INTERPOLATE_START_SYM + 'content' + INTERPOLATE_END_SYM + html + ' <span class="' + CSS_PREFIX + 'caret"></span>' + '</div>';
        $scope.title = title;
        $scope.content = content;
        $scope.html = html;
        $scope.parseSpeed = function() {
          switch (speed) {
            case 'fast':
              speed = 100;
              break;
            case 'medium':
              speed = 450;
              break;
            case 'slow':
              speed = 800;
              break;
            default:
              speed = Number(speed);
          }
        };
        theTooltip = $compile(htmlTemplate)($scope);
        theTooltip.addClass(className);
        if (attr.tooltipScroll === 'true') {
          thisElement.after(theTooltip);
        } else {
          body.append(theTooltip);
        }
        $scope.isTooltipEmpty = function() {
          if (!$scope.title && !$scope.content && !$scope.html) {
            return true;
          }
        };
        $scope.initTooltip = function(tooltipSide) {
          if (!$scope.isTooltipEmpty()) {
            theTooltip.css('visibility', '');
            height = thisElement[0].offsetHeight;
            width = thisElement[0].offsetWidth;
            if (attr.tooltipScroll === 'true') {
              offsetTop = thisElement.position().top;
              offsetLeft = thisElement.position().left;
            } else {
              offsetTop = $scope.getRootOffsetTop(thisElement[0], 0);
              offsetLeft = $scope.getRootOffsetLeft(thisElement[0], 0);
            }
            theTooltipHeight = theTooltip[0].offsetHeight;
            theTooltipWidth = theTooltip[0].offsetWidth;
            $scope.tooltipPositioning(tooltipSide);
          } else {
            theTooltip.css('visibility', 'hidden');
          }
        };
        $scope.getRootOffsetTop = function(elem, val) {
          if (elem.offsetParent === null) {
            return val + elem.offsetTop;
          }
          return $scope.getRootOffsetTop(elem.offsetParent, val + elem.offsetTop - elem.scrollTop);
        };
        $scope.getRootOffsetLeft = function(elem, val) {
          if (elem.offsetParent === null) {
            return val + elem.offsetLeft;
          }
          return $scope.getRootOffsetLeft(elem.offsetParent, val + elem.offsetLeft - elem.scrollLeft);
        };
        $scope.bindShowTriggers = function() {
          thisElement.bind(showTriggers, onMouseEnterAndMouseOver);
        };
        $scope.bindHideTriggers = function() {
          thisElement.bind(hideTriggers, onMouseLeaveAndMouseOut);
        };
        $scope.clearTriggers = function() {
          thisElement.unbind(showTriggers, onMouseEnterAndMouseOver);
          thisElement.unbind(hideTriggers, onMouseLeaveAndMouseOut);
        };
        $scope.bindShowTriggers();
        $scope.showTooltip = function() {
          theTooltip.addClass(CSS_PREFIX + 'open');
          if (delay) {
            theTooltip.css('transition-delay', delay + 'ms');
          }
          $scope.clearTriggers();
          $scope.bindHideTriggers();
        };
        $scope.hideTooltip = function() {
          theTooltip.removeClass(CSS_PREFIX + 'open');
          $scope.clearTriggers();
          $scope.bindShowTriggers();
        };
        $scope.removePosition = function() {
          theTooltip.removeClass(CSS_PREFIX + 'left').removeClass(CSS_PREFIX + 'right').removeClass(CSS_PREFIX + 'top').removeClass(CSS_PREFIX + 'bottom ');
        };
        $scope.tooltipPositioning = function(tooltipSide) {
          var leftValue, topValue;
          $scope.removePosition();
          topValue = void 0;
          leftValue = void 0;
          if (size === 'small') {
            theTooltipMargin = TOOLTIP_SMALL_MARGIN;
          } else if (size === 'medium') {
            theTooltipMargin = TOOLTIP_MEDIUM_MARGIN;
          } else if (size === 'large') {
            theTooltipMargin = TOOLTIP_LARGE_MARGIN;
          }
          if (tooltipSide === 'left') {
            topValue = offsetTop + height / 2 - (theTooltipHeight / 2);
            leftValue = offsetLeft - (theTooltipWidth + theTooltipMargin);
            theTooltip.css('top', topValue + 'px');
            theTooltip.css('left', leftValue + 'px');
            theTooltip.addClass(CSS_PREFIX + 'left');
          }
          if (tooltipSide === 'right') {
            topValue = offsetTop + height / 2 - (theTooltipHeight / 2);
            leftValue = offsetLeft + width + theTooltipMargin;
            theTooltip.css('top', topValue + 'px');
            theTooltip.css('left', leftValue + 'px');
            theTooltip.addClass(CSS_PREFIX + 'right');
          }
          if (tooltipSide === 'top') {
            topValue = offsetTop - theTooltipMargin - theTooltipHeight;
            leftValue = offsetLeft + width / 2 - (theTooltipWidth / 2);
            theTooltip.css('top', topValue + 'px');
            theTooltip.css('left', leftValue + 'px');
            theTooltip.addClass(CSS_PREFIX + 'top');
          }
          if (tooltipSide === 'bottom') {
            topValue = offsetTop + height + theTooltipMargin;
            leftValue = offsetLeft + width / 2 - (theTooltipWidth / 2);
            theTooltip.css('top', topValue + 'px');
            theTooltip.css('left', leftValue + 'px');
            theTooltip.addClass(CSS_PREFIX + 'bottom');
          }
        };
        $scope.tooltipTryPosition = function() {
          var bestPosition, bottomOffset, elmHeight, elmOffsetBottom, elmOffsetLeft, elmOffsetRight, elmOffsetTop, elmWidth, leftOffset, offsets, posix, rightOffset, theTooltipH, theTooltipW, topOffset, winHeight, winWidth, worstOffset;
          theTooltipH = theTooltip[0].offsetHeight;
          theTooltipW = theTooltip[0].offsetWidth;
          topOffset = theTooltip[0].offsetTop;
          leftOffset = theTooltip[0].offsetLeft;
          winWidth = $window.outerWidth;
          winHeight = $window.outerHeight;
          rightOffset = winWidth - (theTooltipW + leftOffset);
          bottomOffset = winHeight - (theTooltipH + topOffset);
          elmHeight = thisElement[0].offsetHeight;
          elmWidth = thisElement[0].offsetWidth;
          elmOffsetLeft = thisElement[0].offsetLeft;
          elmOffsetTop = thisElement[0].offsetTop;
          elmOffsetRight = winWidth - (elmOffsetLeft + elmWidth);
          elmOffsetBottom = winHeight - (elmHeight + elmOffsetTop);
          offsets = {
            'left': leftOffset,
            'top': topOffset,
            'bottom': bottomOffset,
            'right': rightOffset
          };
          posix = {
            'left': elmOffsetLeft,
            'right': elmOffsetRight,
            'top': elmOffsetTop,
            'bottom': elmOffsetBottom
          };
          bestPosition = Object.keys(posix).reduce(function(best, key) {
            if (posix[best] > posix[key]) {
              return best;
            } else {
              return key;
            }
          });
          worstOffset = Object.keys(offsets).reduce(function(worst, key) {
            if (offsets[worst] < offsets[key]) {
              return worst;
            } else {
              return key;
            }
          });
          if (originSide !== bestPosition && offsets[worstOffset] < 20 && !attr.tooltipSide) {
            side = bestPosition;
            $scope.tooltipPositioning(side);
            $scope.initTooltip(bestPosition);
          } else {
            side = attr.tooltipSide;
            $scope.tooltipPositioning(side);
            $scope.tooltipPositioning(side);
            $scope.initTooltip(side);
          }
        };
        angular.element($window).bind('resize', onResize);
        $scope.$on('$destroy', function() {
          angular.element($window).unbind('resize', onResize);
          $scope.clearTriggers();
          theTooltip.remove();
        });
        if (attr.tooltipTitle) {
          attr.$observe('tooltipTitle', function(val) {
            $scope.title = val;
            $scope.initTooltip(side);
          });
        }
        if (attr.title) {
          attr.$observe('title', function(val) {
            $scope.title = val;
            $scope.initTooltip(side);
          });
        }
        if (attr.tooltipContent) {
          attr.$observe('tooltipContent', function(val) {
            $scope.content = val;
            $scope.initTooltip(side);
          });
        }
        if (attr.tooltipHtml) {
          attr.$observe('tooltipHtml', function(val) {
            $scope.html = val;
            $scope.initTooltip(side);
          });
        }
      }
    };
  }
]);


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

angular.module('ngLocale', [], [
  '$provide', function($provide) {
    var PLURAL_CATEGORY;
    PLURAL_CATEGORY = {
      ZERO: 'zero',
      ONE: 'one',
      TWO: 'two',
      FEW: 'few',
      MANY: 'many',
      OTHER: 'other'
    };
    $provide.value('$locale', {
      'DATETIME_FORMATS': {
        'AMPMS': ['до полудня', 'после полудня'],
        'DAY': ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'],
        'MONTH': ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'],
        'SHORTDAY': ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
        'SHORTMONTH': ['янв.', 'февр.', 'марта', 'апр.', 'мая', 'июня', 'июля', 'авг.', 'сент.', 'окт.', 'нояб.', 'дек.'],
        'fullDate': 'EEEE, d MMMM y \'г\'.',
        'longDate': 'd MMMM y \'г\'.',
        'medium': 'dd.MM.yyyy H:mm:ss',
        'mediumDate': 'dd.MM.yyyy',
        'mediumTime': 'H:mm:ss',
        'short': 'dd.MM.yy H:mm',
        'shortDate': 'dd.MM.yy',
        'shortTime': 'H:mm'
      },
      'NUMBER_FORMATS': {
        'CURRENCY_SYM': 'руб.',
        'DECIMAL_SEP': ',',
        'GROUP_SEP': ' ',
        'PATTERNS': [
          {
            'gSize': 3,
            'lgSize': 3,
            'macFrac': 0,
            'maxFrac': 3,
            'minFrac': 0,
            'minInt': 1,
            'negPre': '-',
            'negSuf': '',
            'posPre': '',
            'posSuf': ''
          }, {
            'gSize': 3,
            'lgSize': 3,
            'macFrac': 0,
            'maxFrac': 2,
            'minFrac': 2,
            'minInt': 1,
            'negPre': '-',
            'negSuf': ' ¤',
            'posPre': '',
            'posSuf': ' ¤'
          }
        ]
      },
      'id': 'ru-ru',
      'pluralCat': function(n) {
        if (n % 10 === 1 && n % 100 !== 11) {
          return PLURAL_CATEGORY.ONE;
        }
        if (n === (n | 0) && n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 12 || n % 100 > 14)) {
          return PLURAL_CATEGORY.FEW;
        }
        if (n % 10 === 0 || n === (n | 0) && n % 10 >= 5 && n % 10 <= 9 || n === (n | 0) && n % 100 >= 11 && n % 100 <= 14) {
          return PLURAL_CATEGORY.MANY;
        }
        return PLURAL_CATEGORY.OTHER;
      }
    });
  }
]);


/***/ }),
/* 170 */
/***/ (function(module, exports) {

var legacySupport;

legacySupport = angular.version.major === 1 && angular.version.minor === 0;


/**
 * RangeSlider, allows user to define a range of values using a slider
 * Touch friendly.
 * @directive
 */

angular.module('siter.io').directive('rangeSlider', [
  '$document', '$filter', '$log', function($document, $filter, $log) {
    var actions, client, defaults, eventNamespace, isNumber, moveEvent, offEvent, onEvent, outEvent, overEvent, restrict, scopeOptions;
    eventNamespace = '.rangeSlider';
    defaults = {
      disabled: false,
      orientation: 'horizontal',
      step: 0,
      decimalPlaces: 0,
      showValues: true,
      preventEqualMinMax: false,
      attachHandleValues: false
    };
    actions = window.navigator.pointerEnabled ? {
      start: 'pointerdown',
      move: 'pointermove',
      end: 'pointerup',
      over: 'pointerdown',
      out: 'mouseout'
    } : window.navigator.msPointerEnabled ? {
      start: 'MSPointerDown',
      move: 'MSPointerMove',
      end: 'MSPointerUp',
      over: 'MSPointerDown',
      out: 'mouseout'
    } : {
      start: 'mousedown touchstart',
      move: 'mousemove touchmove',
      end: 'mouseup touchend',
      over: 'mouseover touchstart',
      out: 'mouseout'
    };
    onEvent = actions.start + eventNamespace;
    moveEvent = actions.move + eventNamespace;
    offEvent = actions.end + eventNamespace;
    overEvent = actions.over + eventNamespace;
    outEvent = actions.out + eventNamespace;
    client = function(f) {
      var e;
      try {
        return [f.clientX || f.originalEvent.clientX || f.originalEvent.touches[0].clientX, f.clientY || f.originalEvent.clientY || f.originalEvent.touches[0].clientY];
      } catch (error) {
        e = error;
        return ['x', 'y'];
      }
    };
    restrict = function(value) {
      if (value < 0) {
        return 0;
      } else if (value > 100) {
        return 100;
      } else {
        return value;
      }
    };
    isNumber = function(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    };
    scopeOptions = {
      disabled: '=?',
      min: '=',
      max: '=',
      modelMin: '=?',
      modelMax: '=?',
      onHandleDown: '&',
      onHandleUp: '&',
      orientation: '@',
      step: '@',
      decimalPlaces: '@',
      filter: '@',
      filterOptions: '@',
      showValues: '@',
      pinHandle: '@',
      preventEqualMinMax: '@',
      attachHandleValues: '@',
      getterSetter: '@'
    };
    if (legacySupport) {
      scopeOptions.disabled = '=';
      scopeOptions.modelMin = '=';
      scopeOptions.modelMax = '=';
    }
    return {
      restrict: 'A',
      replace: true,
      template: ['<div class="ngrs-range-slider">', '<div class="ngrs-runner">', '<div class="ngrs-handle ngrs-handle-min"><i></i></div>', '<div class="ngrs-handle ngrs-handle-max"><i></i></div>', '<div class="ngrs-join"></div>', '</div>', '<div class="ngrs-value-runner">', '</div>', '</div>'].join(''),
      scope: scopeOptions,
      link: function(scope, element, attrs, controller) {

        /**
         *  FIND ELEMENTS
         */
        var $slider, allowedRange, down, handleMove, handles, join, modelMax, modelMin, orientation, pos, posOpp, range, setDisabledStatus, setMinMax, setModelMinMax, setPinHandle, throwError, throwWarning, values;
        $slider = angular.element(element);
        handles = [element.find('.ngrs-handle-min'), element.find('.ngrs-handle-max')];
        values = [element.find('.ngrs-value-min'), element.find('.ngrs-value-max')];
        join = element.find('.ngrs-join');
        pos = 'left';
        posOpp = 'right';
        orientation = 0;
        allowedRange = [0, 0];
        range = 0;
        down = false;
        modelMin = function(newValue) {
          if (scope.getterSetter) {
            if (arguments.length) {
              return scope.modelMin(newValue);
            } else {
              return scope.modelMin();
            }
          } else {
            if (arguments.length) {
              return scope.modelMin = newValue;
            } else {
              return scope.modelMin;
            }
          }
        };
        modelMax = function(newValue) {
          if (scope.getterSetter) {
            if (arguments.length) {
              return scope.modelMax(newValue);
            } else {
              return scope.modelMax();
            }
          } else {
            if (arguments.length) {
              return scope.modelMax = newValue;
            } else {
              return scope.modelMax;
            }
          }
        };

        /**
         * HANDLE CHANGES
         */
        setPinHandle = function(status) {
          if (status === 'min') {
            angular.element(handles[0]).css('display', 'none');
            angular.element(handles[1]).css('display', 'block');
          } else if (status === 'max') {
            angular.element(handles[0]).css('display', 'block');
            angular.element(handles[1]).css('display', 'none');
          } else {
            angular.element(handles[0]).css('display', 'block');
            angular.element(handles[1]).css('display', 'block');
          }
        };
        setDisabledStatus = function(status) {
          if (status) {
            $slider.addClass('ngrs-disabled');
          } else {
            $slider.removeClass('ngrs-disabled');
          }
        };
        setMinMax = function() {
          if (scope.min > scope.max) {
            throwError('min must be less than or equal to max');
          }
          if (angular.isDefined(scope.min) && angular.isDefined(scope.max)) {
            if (!isNumber(scope.min)) {
              throwError('min must be a number');
            }
            if (!isNumber(scope.max)) {
              throwError('max must be a number');
            }
            range = scope.max - scope.min;
            allowedRange = [scope.min, scope.max];
            setModelMinMax();
          }
        };
        setModelMinMax = function() {
          var filterName, filterOptions, filterTokens, handle1pos, handle2pos, modelMaxOptions, modelMinOptions, value1pos, value2pos;
          if (modelMin() > modelMax()) {
            throwWarning('modelMin must be less than or equal to modelMax');
            modelMin(modelMax());
          }
          if ((angular.isDefined(modelMin()) || scope.pinHandle === 'min') && (angular.isDefined(modelMax()) || scope.pinHandle === 'max')) {
            if (!isNumber(modelMin())) {
              if (scope.pinHandle !== 'min') {
                throwWarning('modelMin must be a number');
              }
              modelMin(scope.min);
            }
            if (!isNumber(modelMax())) {
              if (scope.pinHandle !== 'max') {
                throwWarning('modelMax must be a number');
              }
              modelMax(scope.min);
            }
            handle1pos = restrict((modelMin() - scope.min) / range * 100);
            handle2pos = restrict((modelMax() - scope.min) / range * 100);
            value1pos = void 0;
            value2pos = void 0;
            if (scope.attachHandleValues) {
              value1pos = handle1pos;
              value2pos = handle2pos;
            }
            modelMin(Math.max(scope.min, modelMin()));
            modelMax(Math.min(scope.max, modelMax()));
            if (scope.filter && scope.filterOptions) {
              scope.filteredModelMin = $filter(scope.filter)(modelMin(), scope.filterOptions);
              scope.filteredModelMax = $filter(scope.filter)(modelMax(), scope.filterOptions);
            } else if (scope.filter) {
              filterTokens = scope.filter.split(':');
              filterName = scope.filter.split(':')[0];
              filterOptions = filterTokens.slice().slice(1);
              modelMinOptions = void 0;
              modelMaxOptions = void 0;
              filterOptions = filterOptions.map(function(arg) {
                if (isNumber(arg)) {
                  return +arg;
                } else if (arg[0] === '"' && arg[arg.length - 1] === '"' || arg[0] === '\'' && arg[arg.length - 1] === '\'') {
                  return arg.slice(1, -1);
                }
              });
              modelMinOptions = filterOptions.slice();
              modelMaxOptions = filterOptions.slice();
              modelMinOptions.unshift(modelMin());
              modelMaxOptions.unshift(modelMax());
              scope.filteredModelMin = $filter(filterName).apply(null, modelMinOptions);
              scope.filteredModelMax = $filter(filterName).apply(null, modelMaxOptions);
            } else {
              scope.filteredModelMin = modelMin();
              scope.filteredModelMax = modelMax();
            }
            if (scope.min === scope.max && modelMin() === modelMax()) {
              angular.element(handles[0]).css(pos, '0%');
              angular.element(handles[1]).css(pos, '100%');
              if (scope.attachHandleValues) {
                angular.element(values[0]).css(pos, '0%');
                angular.element(values[1]).css(pos, '100%');
              }
              angular.element(join).css(pos, '0%').css(posOpp, '0%');
            } else {
              angular.element(handles[0]).css(pos, handle1pos + '%');
              angular.element(handles[1]).css(pos, handle2pos + '%');
              if (scope.attachHandleValues) {
                angular.element(values[0]).css(pos, value1pos + '%');
                angular.element(values[1]).css(pos, value2pos + '%');
                angular.element(values[1]).css(posOpp, 'auto');
              }
              angular.element(join).css(pos, handle1pos + '%').css(posOpp, 100 - handle2pos + '%');
              if (handle1pos > 95) {
                angular.element(handles[0]).css('z-index', 3);
              }
            }
          }
        };
        handleMove = function(index) {
          var $handle;
          $handle = handles[index];
          $handle.bind(onEvent + 'X', function(event) {
            var handleDownClass, modelValue, originalClick, originalPosition, previousClick, previousProposal;
            handleDownClass = (index === 0 ? 'ngrs-handle-min' : 'ngrs-handle-max') + '-down';
            modelValue = (index === 0 ? modelMin() : modelMax()) - scope.min;
            originalPosition = modelValue / range * 100;
            originalClick = client(event);
            previousClick = originalClick;
            previousProposal = false;
            if (angular.isFunction(scope.onHandleDown)) {
              scope.onHandleDown();
            }
            if (!scope.disabled) {
              down = true;
              $handle.addClass('ngrs-down');
              $slider.addClass('ngrs-focus ' + handleDownClass);
              angular.element('body').addClass('ngrs-touching');
              $document.bind(moveEvent, function(e) {
                var currentClick, movement, other, otherModelPosition, per, proposal;
                e.preventDefault();
                currentClick = client(e);
                movement = void 0;
                proposal = void 0;
                other = void 0;
                per = scope.step / range * 100;
                otherModelPosition = ((index === 0 ? modelMax() : modelMin()) - scope.min) / range * 100;
                if (currentClick[0] === 'x') {
                  return;
                }
                currentClick[0] -= originalClick[0];
                currentClick[1] -= originalClick[1];
                movement = [previousClick[0] !== currentClick[0], previousClick[1] !== currentClick[1]];
                proposal = originalPosition + currentClick[orientation] * 100 / (orientation ? $slider.height() : $slider.width());
                proposal = restrict(proposal);
                if (scope.preventEqualMinMax) {
                  if (per === 0) {
                    per = 1 / range * 100;
                  }
                  if (index === 0) {
                    otherModelPosition = otherModelPosition - per;
                  } else if (index === 1) {
                    otherModelPosition = otherModelPosition + per;
                  }
                }
                if (index === 0) {
                  proposal = proposal > otherModelPosition ? otherModelPosition : proposal;
                } else if (index === 1) {
                  proposal = proposal < otherModelPosition ? otherModelPosition : proposal;
                }
                if (scope.step > 0) {
                  if (proposal < 100 && proposal > 0) {
                    proposal = Math.round(proposal / per) * per;
                  }
                }
                if (proposal > 95 && index === 0) {
                  $handle.css('z-index', 3);
                } else {
                  $handle.css('z-index', '');
                }
                if (movement[orientation] && proposal !== previousProposal) {
                  if (index === 0) {
                    modelMin(parseFloat(parseFloat(proposal * range / 100 + scope.min).toFixed(scope.decimalPlaces)));
                  } else if (index === 1) {
                    modelMax(parseFloat(parseFloat(proposal * range / 100 + scope.min).toFixed(scope.decimalPlaces)));
                  }
                  scope.$apply();
                  previousProposal = proposal;
                }
                previousClick = currentClick;
              }).bind(offEvent, function() {
                if (angular.isFunction(scope.onHandleUp)) {
                  scope.onHandleUp();
                }
                $document.off(moveEvent);
                $document.off(offEvent);
                angular.element('body').removeClass('ngrs-touching');
                down = false;
                $handle.removeClass('ngrs-down');
                $handle.removeClass('ngrs-over');
                $slider.removeClass('ngrs-focus ' + handleDownClass);
              });
            }
          }).on(overEvent, function() {
            $handle.addClass('ngrs-over');
          }).on(outEvent, function() {
            if (!down) {
              $handle.removeClass('ngrs-over');
            }
          });
        };
        throwError = function(message) {
          scope.disabled = true;
          throw new Error('RangeSlider: ' + message);
        };
        throwWarning = function(message) {
          $log.warn(message);
        };
        scope.filteredModelMin = modelMin();
        scope.filteredModelMax = modelMax();

        /**
         *  FALL BACK TO DEFAULTS FOR SOME ATTRIBUTES
         */
        attrs.$observe('disabled', function(val) {
          if (!angular.isDefined(val)) {
            scope.disabled = defaults.disabled;
          }
          scope.$watch('disabled', setDisabledStatus);
        });
        attrs.$observe('orientation', function(val) {
          var classNames, i, l, useClass;
          if (!angular.isDefined(val)) {
            scope.orientation = defaults.orientation;
          }
          classNames = scope.orientation.split(' ');
          useClass = void 0;
          i = 0;
          l = classNames.length;
          while (i < l) {
            classNames[i] = 'ngrs-' + classNames[i];
            i++;
          }
          useClass = classNames.join(' ');
          $slider.addClass(useClass);
          if (scope.orientation === 'vertical' || scope.orientation === 'vertical left' || scope.orientation === 'vertical right') {
            pos = 'top';
            posOpp = 'bottom';
            orientation = 1;
          }
        });
        attrs.$observe('step', function(val) {
          if (!angular.isDefined(val)) {
            scope.step = defaults.step;
          }
        });
        attrs.$observe('decimalPlaces', function(val) {
          if (!angular.isDefined(val)) {
            scope.decimalPlaces = defaults.decimalPlaces;
          }
        });
        attrs.$observe('showValues', function(val) {
          if (!angular.isDefined(val)) {
            scope.showValues = defaults.showValues;
          } else {
            if (val === 'false') {
              scope.showValues = false;
            } else {
              scope.showValues = true;
            }
          }
        });
        attrs.$observe('pinHandle', function(val) {
          if (!angular.isDefined(val)) {
            scope.pinHandle = null;
          } else {
            if (val === 'min' || val === 'max') {
              scope.pinHandle = val;
            } else {
              scope.pinHandle = null;
            }
          }
          scope.$watch('pinHandle', setPinHandle);
        });
        attrs.$observe('preventEqualMinMax', function(val) {
          if (!angular.isDefined(val)) {
            scope.preventEqualMinMax = defaults.preventEqualMinMax;
          } else {
            if (val === 'false') {
              scope.preventEqualMinMax = false;
            } else {
              scope.preventEqualMinMax = true;
            }
          }
        });
        attrs.$observe('attachHandleValues', function(val) {
          if (!angular.isDefined(val)) {
            scope.attachHandleValues = defaults.attachHandleValues;
          } else {
            if (val === 'true' || val === '') {
              scope.attachHandleValues = true;
              element.find('.ngrs-value-runner').addClass('ngrs-attached-handles');
            } else {
              scope.attachHandleValues = false;
            }
          }
        });
        scope.$watch('min', setMinMax);
        scope.$watch('max', setMinMax);
        scope.$watch((function() {
          return modelMin();
        }), setModelMinMax);
        scope.$watch((function() {
          return modelMax();
        }), setModelMinMax);

        /**
         * DESTROY
         */
        scope.$on('$destroy', function() {
          var i, l;
          $slider.off(eventNamespace);
          angular.element('body').off(eventNamespace);
          $document.off(eventNamespace);
          i = 0;
          l = handles.length;
          while (i < l) {
            handles[i].off(eventNamespace);
            handles[i].off(eventNamespace + 'X');
            i++;
          }
        });

        /**
         * INIT
         */
        handleMove(0);
        handleMove(1);
      }
    };
  }
]);

window.requestAnimFrame = (function() {
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function(callback) {
    window.setTimeout(callback, 1000 / 60);
  };
})();


/***/ }),
/* 171 */
/***/ (function(module, exports) {

angular.module('siter.io').factory('TplCache', [
  "$templateCache", "$http", function($templateCache, $http) {
    var cache;
    cache = {
      get: function(url) {
        return $http.get(url).success(function(data, status, headers, config) {
          return $templateCache.put(url, data);
        });
      }
    };
    return cache;
  }
]);


/***/ }),
/* 172 */
/***/ (function(module, exports) {

angular.module("siter.io").factory('errorsInterceptor', [
  '$q', "$injector", function($q, $injector) {
    var response;
    response = {
      responseError: function(rejection) {
        var $modalStack, Billing, Notification;
        if (rejection.status === 423) {
          Billing = $injector.get("Billing");
          $modalStack = $injector.get("$modalStack");
          $modalStack.dismissAll();
          Billing.constraints();
        }
        if (rejection.status === 500) {
          Notification = $injector.get("Notification");
          Notification.error({
            message: 'Неизвестная ошибка на сервере (500)'
          });
        }
        return $q.reject(rejection);
      }
    };
    return response;
  }
]);


/***/ }),
/* 173 */
/***/ (function(module, exports) {

angular.module('siter.io').factory('Intercom', [
  "$templateCache", "$http", "$timeout", "$translate", function($templateCache, $http, $timeout, $translate) {
    var intercom;
    intercom = {
      init: function(url) {
        if (!justclick.intercomFields) {
          return false;
        }
        if (!justclick.intercomFields.helpChatIsGranted) {
          return false;
        }
        window.intercomSettings = {
          app_id: justclick.intercomFields.app_id,
          name: justclick.intercomFields.name,
          email: justclick.intercomFields.email,
          user_id: justclick.intercomFields.user_id,
          author_id: justclick.intercomFields.author_id,
          author_name: justclick.intercomFields.author_name,
          author_email: justclick.intercomFields.author_email,
          author_registration: justclick.intercomFields.author_registration,
          tariff: justclick.intercomFields.tariff,
          top: justclick.intercomFields.author_email,
          hide_default_launcher: true,
          custom_launcher_selector: '#custom-intercom-container',
          language_override: $translate.use()
        };
        (function() {
          var d, i, ic, l, w;
          w = window;
          ic = w.Intercom;
          l = function() {
            var s, x;
            s = d.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = 'https://widget.intercom.io/widget/' + justclick.intercomFields.app_id;
            x = d.getElementsByTagName('script')[0];
            x.parentNode.insertBefore(s, x);
          };
          if (typeof ic === 'function') {
            ic('reattach_activator');
            ic('update', intercomSettings);
          } else {
            d = document;
            i = function() {
              i.c(arguments);
            };
            i.q = [];
            i.c = function(args) {
              i.q.push(args);
            };
            w.Intercom = i;
            if (w.attachEvent) {
              w.attachEvent('onload', l);
            } else {
              w.addEventListener('load', l, false);
            }
          }
        })();
        window.Intercom('onShow', function() {
          $timeout(function() {
            $(".intercom-gradient").hide();
            return $(".intercom-messenger-frame").css({
              left: 20,
              right: "auto"
            });
          });
          return $(".intercom-launcher").addClass('intercom-launcher-active');
        });
        window.Intercom('onHide', function() {
          return $(".intercom-launcher").removeClass('intercom-launcher-active');
        });
      }
    };
    return intercom;
  }
]);


/***/ }),
/* 174 */
/***/ (function(module, exports) {

angular.module('siter.io').factory('Modal', [
  "$modal", "$rootScope", function($modal, $rootScope) {
    var modals;
    modals = {
      createLink: function(parentId, widget) {
        var modalInstance;
        if (parentId == null) {
          parentId = false;
        }
        return modalInstance = $modal.open({
          windowTemplateUrl: "./common/templates/window.jade",
          templateUrl: "./editor/modules_settings/navigationfields/link.create.modal.jade",
          size: "md",
          controller: "LinkCreateModal",
          resolve: {
            parentId: function() {
              return parentId;
            },
            widget: function() {
              return widget;
            }
          }
        });
      },
      editLink: function(link, data) {
        var modalInstance;
        return modalInstance = $modal.open({
          windowTemplateUrl: "./common/templates/window.jade",
          templateUrl: "./editor/modules_settings/navigationfields/link.update.modal.jade",
          size: "md",
          controller: "LinkUpdateModal",
          resolve: {
            link: function() {
              return link;
            },
            widget: function() {
              return data;
            }
          }
        });
      },
      newTemplate: function() {
        var modalInstance;
        return modalInstance = $modal.open({
          windowTemplateUrl: "./common/templates/window.jade",
          templateUrl: "./site/new_template.jade",
          controller: "NewTemplateController",
          size: "lg"
        });
      },
      editTemplate: function(template, mainTemplate) {
        var modalInstance;
        modalInstance = $modal.open({
          windowTemplateUrl: "./common/templates/window.jade",
          templateUrl: "./site/edit_template.jade",
          controller: "EditTemplateController",
          size: "lg",
          resolve: {
            template: function() {
              return template;
            },
            mainTemplate: function() {
              return mainTemplate;
            }
          }
        });
        return modalInstance.result.then(function() {
          return log("");
        }, function() {
          if (Array.isArray(template.tags)) {
            template.tags = _.map(template.tags, function(tag) {
              return tag.text;
            });
            template.tags = template.tags.join(",");
            return template.colors = _.map(template.colors, function(tag, index) {
              return tag.text;
            });
          }
        });
      },
      newEmailTemplate: function() {
        var modalInstance;
        return modalInstance = $modal.open({
          windowTemplateUrl: "./common/templates/window.jade",
          templateUrl: "./email/new_email.jade",
          controller: "NewEmailTemplateController",
          size: "lg"
        });
      },
      editEmailTemplate: function(template, mainTemplate) {
        var modalInstance;
        modalInstance = $modal.open({
          windowTemplateUrl: "./common/templates/window.jade",
          templateUrl: "./email/edit_email.jade",
          controller: "EditEmailTemplateController",
          size: "lg",
          resolve: {
            template: function() {
              return template;
            },
            mainTemplate: function() {
              return mainTemplate;
            }
          }
        });
        return modalInstance.result.then(function() {
          return log("");
        }, function() {
          if (Array.isArray(template.tags)) {
            template.tags = _.map(template.tags, function(tag) {
              return tag.text;
            });
            template.tags = template.tags.join(",");
            return template.colors = _.map(template.colors, function(tag, index) {
              return tag.text;
            });
          }
        });
      },
      newWebFormTemplate: function() {
        var modalInstance;
        return modalInstance = $modal.open({
          windowTemplateUrl: "./common/templates/window.jade",
          templateUrl: "./webform/new_webform.jade",
          controller: "NewWebFormTemplateController",
          size: "lg"
        });
      },
      editWebFormTemplate: function(template, mainTemplate) {
        var modalInstance;
        modalInstance = $modal.open({
          windowTemplateUrl: "./common/templates/window.jade",
          templateUrl: "./webform/edit_webform.jade",
          controller: "EditWebFormTemplateController",
          size: "lg",
          resolve: {
            template: function() {
              return template;
            },
            mainTemplate: function() {
              return mainTemplate;
            }
          }
        });
        return modalInstance.result.then(function() {
          return log("");
        }, function() {
          if (Array.isArray(template.tags)) {
            template.tags = _.map(template.tags, function(tag) {
              return tag.text;
            });
            template.tags = template.tags.join(",");
            return template.colors = _.map(template.colors, function(tag, index) {
              return tag.text;
            });
          }
        });
      },
      newLessonTemplate: function() {
        var modalInstance;
        return modalInstance = $modal.open({
          windowTemplateUrl: "./common/templates/window.jade",
          templateUrl: "./lesson/newLesson.jade",
          controller: "NewLessonTemplateController",
          size: "lg"
        });
      },
      editLessonTemplate: function(template, mainTemplate) {
        var modalInstance;
        modalInstance = $modal.open({
          windowTemplateUrl: "./common/templates/window.jade",
          templateUrl: "./lesson/editLesson.jade",
          controller: "EditLessonTemplateController",
          size: "lg",
          resolve: {
            template: function() {
              return template;
            },
            mainTemplate: function() {
              return mainTemplate;
            }
          }
        });
        return modalInstance.result.then(function() {
          return log("");
        }, function() {
          if (Array.isArray(template.tags)) {
            template.tags = _.map(template.tags, function(tag) {
              return tag.text;
            });
            template.tags = template.tags.join(",");
            return template.colors = _.map(template.colors, function(tag, index) {
              return tag.text;
            });
          }
        });
      },
      newLessonSectionModal: function(allLessonSections) {
        var modalInstance;
        return modalInstance = $modal.open({
          windowTemplateUrl: "./common/templates/window.jade",
          templateUrl: "./lesson/newLessonSection.jade",
          size: "md",
          controller: "NewLessonSectionModal",
          resolve: {
            allLessonSections: function() {
              return allLessonSections;
            }
          }
        });
      },
      siteSettings: function(link, data) {
        var modalInstance;
        return modalInstance = $modal.open({
          windowTemplateUrl: "./common/templates/window.jade",
          templateUrl: "./site/site_settings/site_settings.jade",
          windowClass: "site-settings__modal",
          size: "md",
          controller: "SiteSettingsModal"
        });
      },
      favoriteSettings: function() {
        var modalInstance;
        return modalInstance = $modal.open({
          windowTemplateUrl: "./common/templates/window.jade",
          templateUrl: "./site/favorite/favorite.jade",
          windowClass: "site-settings__modal",
          size: "md",
          controller: "SiteSettingsModal"
        });
      },
      favoriteSectionSettings: function(section) {
        var modalInstance;
        return modalInstance = $modal.open({
          windowTemplateUrl: "./common/templates/window.jade",
          templateUrl: "./editor/section_settings/create_favorite.jade",
          windowClass: "site-settings__modal",
          size: "md",
          controller: "CreateFavoriteSectionModal",
          resolve: {
            section: function() {
              return section;
            }
          }
        });
      },
      createSectionModal: function(allSections) {
        var modalInstance;
        return modalInstance = $modal.open({
          windowTemplateUrl: "./common/templates/window.jade",
          templateUrl: "./editor/section_settings/create.jade",
          size: "md",
          controller: "CreateSectionModal",
          resolve: {
            allSections: function() {
              return allSections;
            }
          }
        });
      },
      editSectionModal: function(section) {
        var modalInstance;
        modalInstance = $modal.open({
          windowTemplateUrl: "./common/templates/window.jade",
          templateUrl: "./editor/section_settings/edit.jade",
          size: "md",
          controller: "EditSectionModal",
          resolve: {
            section: function() {
              return section;
            }
          }
        });
        return modalInstance.result.then(function() {
          return log("");
        }, function() {
          if (Array.isArray(section.tags)) {
            section.tags = _.map(section.tags, function(tag) {
              return tag.text;
            });
            section.tags = section.tags.join(",");
            return section.colors = _.map(section.colors, function(tag, index) {
              return tag.text;
            });
          }
        });
      },
      createEmailSectionModal: function(allEmailSections) {
        var modalInstance;
        return modalInstance = $modal.open({
          windowTemplateUrl: "./common/templates/window.jade",
          templateUrl: "./editor/email_section_settings/create.jade",
          size: "md",
          controller: "CreateEmailSectionModal",
          resolve: {
            allEmailSections: function() {
              return allEmailSections;
            }
          }
        });
      },
      editEmailSectionModal: function(section) {
        var modalInstance;
        modalInstance = $modal.open({
          windowTemplateUrl: "./common/templates/window.jade",
          templateUrl: "./editor/email_section_settings/edit.jade",
          size: "md",
          controller: "EditEmailSectionModal",
          resolve: {
            section: function() {
              return section;
            }
          }
        });
        return modalInstance.result.then(function() {
          return log("");
        }, function() {
          if (Array.isArray(section.tags)) {
            section.tags = _.map(section.tags, function(tag) {
              return tag.text;
            });
            section.tags = section.tags.join(",");
            return section.colors = _.map(section.colors, function(tag, index) {
              return tag.text;
            });
          }
        });
      },
      newImage: function() {
        var modalInstance;
        return modalInstance = $modal.open({
          windowTemplateUrl: "./common/templates/window.jade",
          templateUrl: "./dashboard/images/new_image.jade",
          size: "md",
          controller: "NewImageCtrl"
        });
      },
      editImage: function(image) {
        var modalInstance;
        modalInstance = $modal.open({
          windowTemplateUrl: "./common/templates/window.jade",
          templateUrl: "./dashboard/images/edit_image.jade",
          size: "md",
          controller: "EditImageCtrl",
          resolve: {
            image: function() {
              return image;
            }
          }
        });
        return modalInstance.result.then(function() {}, function() {
          if (Array.isArray(image.tag) && image.tag.length > 0) {
            return image.tag = image.tag[0].text;
          }
        });
      }
    };
    return modals;
  }
]);


/***/ }),
/* 175 */
/***/ (function(module, exports) {

angular.module("siter.io").factory('State', [
  "$state", "$rootScope", "Auth", function($state, $rootScope, Auth) {
    var router;
    router = {
      goToEditor: function(siteId, pageId, reload) {
        if (reload == null) {
          reload = false;
        }
        return $state.go("site.page.editor", {
          siteId: siteId,
          pageId: pageId
        }, {
          reload: reload
        });
      },
      goToTemplatesNew: function() {
        return $state.go("root.new_site");
      },
      viewSite: function() {
        var url;
        url = "/sites/constructor/preview/jc_site_id/" + ($rootScope.currentSite.jc_site_id || $rootScope.currentSite.slug);
        window.open(url, '_blank');
      },
      goToNotFound: function() {
        return $state.go("404");
      },
      goToDashboard: function() {
        return $state.go("admin.dashboard.templates");
      },
      login: function() {
        return Auth.isReadyLogged().then(function() {
          return router.goToDashboard();
        })["catch"](function() {
          return router.goToNotFound();
        });
      }
    };
    return router;
  }
]);


/***/ }),
/* 176 */
/***/ (function(module, exports) {

angular.module('siter.io').factory('Translit', [
  "$state", function($state) {
    var transliterate;
    transliterate = {
      one: function(text, engToRus) {
        var eng, rus, x;
        rus = 'щ   ш  ч  ц  ю  я  ё  ж  ъ  ы  э  а б в г д е з и й к л м н о п р с т у ф х ь'.split(RegExp(' +', 'g'));
        eng = 'shh sh ch cz yu ya yo zh sh y e a b v g d e z i j k l m n o p r s t u f x '.split(RegExp(' +', 'g'));
        x = void 0;
        if (typeof text !== 'undefined') {
          x = 0;
          while (x < rus.length) {
            text = text.split(engToRus ? eng[x] : rus[x]).join(engToRus ? rus[x] : eng[x]);
            text = text.split(engToRus ? eng[x].toUpperCase() : rus[x].toUpperCase()).join(engToRus ? rus[x].toUpperCase() : eng[x].toUpperCase());
            x++;
          }
          return text.toLowerCase().replace(RegExp(' ', 'g'), '_').replace(/-/g, '_').replace(/[^a-z_A-ZА-Яа-я0-9\s]/g, '');
        }
      },
      two: function(text, engToRus) {
        var eng, rus, x;
        rus = 'щ   ш  ч  ц  ю  я  ё  ж  ъ  ы  э  а б в г д е з и й к л м н о п р с т у ф х ь'.split(RegExp(' +', 'g'));
        eng = 'shh sh ch cz yu ya yo zh sh y e a b v g d e z i j k l m n o p r s t u f x '.split(RegExp(' +', 'g'));
        x = void 0;
        if (typeof text !== 'undefined') {
          x = 0;
          while (x < rus.length) {
            text = text.split(engToRus ? eng[x] : rus[x]).join(engToRus ? rus[x] : eng[x]);
            text = text.split(engToRus ? eng[x].toUpperCase() : rus[x].toUpperCase()).join(engToRus ? rus[x].toUpperCase() : eng[x].toUpperCase());
            x++;
          }
          return text.toLowerCase().replace(RegExp(' ', 'g'), '-').replace(/_/g, '_');
        }
      },
      three: function(text, engToRus) {
        var eng, rus, x;
        rus = 'щ   ш  ч  ц  ю  я  ё  ж  ъ  ы  э  а б в г д е з и й к л м н о п р с т у ф х ь'.split(RegExp(' +', 'g'));
        eng = 'shh sh ch cz yu ya yo zh sh y e a b v g d e z i j k l m n o p r s t u f x '.split(RegExp(' +', 'g'));
        x = void 0;
        if (typeof text !== 'undefined') {
          x = 0;
          while (x < rus.length) {
            text = text.split(engToRus ? eng[x] : rus[x]).join(engToRus ? rus[x] : eng[x]);
            text = text.split(engToRus ? eng[x].toUpperCase() : rus[x].toUpperCase()).join(engToRus ? rus[x].toUpperCase() : eng[x].toUpperCase());
            x++;
          }
          return text.toLowerCase().replace(RegExp(' ', 'g'), '-').replace(/_/g, '-').replace(/[^a-z_A-ZА-Яа-я0-9\s]/g, '');
        }
      }
    };
    return transliterate;
  }
]);


/***/ }),
/* 177 */
/***/ (function(module, exports) {

angular.module("siter.io").factory('translitService', [
  "$timeout", function($timeout) {
    var arren, arrru, translit;
    arrru = new Array('Я', 'я', 'Ю', 'ю', 'Ч', 'ч', 'Ш', 'ш', 'Щ', 'щ', 'Ж', 'ж', 'А', 'а', 'Б', 'б', 'В', 'в', 'Г', 'г', 'Д', 'д', 'Е', 'е', 'Ё', 'ё', 'З', 'з', 'И', 'и', 'Й', 'й', 'К', 'к', 'Л', 'л', 'М', 'м', 'Н', 'н', 'О', 'о', 'П', 'п', 'Р', 'р', 'С', 'с', 'Т', 'т', 'У', 'у', 'Ф', 'ф', 'Х', 'х', 'Ц', 'ц', 'Ы', 'ы', 'Ь', 'ь', 'Ъ', 'ъ', 'Э', 'э', ' ');
    arren = new Array('Ya', 'ya', 'Yu', 'yu', 'Ch', 'ch', 'Sh', 'sh', 'Sh', 'sh', 'Zh', 'zh', 'A', 'a', 'B', 'b', 'V', 'v', 'G', 'g', 'D', 'd', 'E', 'e', 'E', 'e', 'Z', 'z', 'I', 'i', 'J', 'j', 'K', 'k', 'L', 'l', 'M', 'm', 'N', 'n', 'O', 'o', 'P', 'p', 'R', 'r', 'S', 's', 'T', 't', 'U', 'u', 'F', 'f', 'H', 'h', 'C', 'c', 'Y', 'y', '', '', '', '', 'E', 'e', '_');
    translit = {
      cyrillToLatin: function(text, space) {
        var i, reg;
        if (space == null) {
          space = "_";
        }
        i = 0;
        arren[arren.length - 1] = space;
        while (i < arrru.length) {
          reg = new RegExp(arrru[i], 'g');
          if (text) {
            text = text.replace(reg, arren[i]);
          }
          i++;
        }
        return text;
      }
    };
    return translit;
  }
]);


/***/ }),
/* 178 */
/***/ (function(module, exports) {

angular.module("siter.io").controller("Dashboard", [
  "$scope", "$rootScope", "$state", "$timeout", "Site", "Modal", "Template", "$location", "Section", "Widget", "Notification", "Email", function($scope, $rootScope, $state, $timeout, Site, Modal, Template, $location, Section, Widget, Notification, Email) {
    var listener, listener0, listener2, listener3, listener4, refreshEmailTags, refreshTags;
    $scope.state = $state;
    if (window.justclick.currentUser.role === "client") {
      $location.path('/404');
    }
    $scope.currentState = $state.current.name;
    $scope.tagobject = {
      tagName: ""
    };
    $scope.scrollDisabled = false;
    $scope.addSite = Site.addSite;
    $rootScope.site = {};
    $scope.getHomePagePath = function(pages) {
      var homePage;
      if (pages.length === 0) {
        return false;
      }
      homePage = _.filter(pages, {
        home: true
      });
      return homePage[0].path;
    };
    $rootScope.refreshTemplates = function() {
      $scope.sitesLoading = true;
      return Template.getAll().then(function(sites) {
        $scope.sites = sites;
        $scope.sitesCount = sites.length;
        return $scope.sitesLoading = false;
      });
    };
    $scope.emails = [];
    $rootScope.refreshEmailTemplates = function() {
      $scope.emailsLoading = true;
      return Template.getEmailTemplates().then(function(emails) {
        $scope.emails = emails;
        $scope.emailsCount = emails.length;
        return $scope.emailsLoading = false;
      });
    };
    $scope.sectionsLoading = true;
    Section.getSections().then(function(sections) {
      $scope.sections = sections.sections;
      return $scope.sectionsLoading = false;
    });
    refreshTags = function() {
      return Template.getUserCategories().then(function(tags) {
        return $scope.templatesTags = tags;
      });
    };
    refreshTags();
    $scope.treeOptions = {
      dropped: function(e) {
        $timeout(function() {
          return Template.sortCategories($scope.templatesTags).then(function(tags) {
            return $scope.templatesTags = tags;
          });
        });
      }
    };
    refreshEmailTags = function() {
      return Template.getEmailUserCategories().then(function(tags) {
        return $scope.emailTemplatesTags = tags;
      });
    };
    refreshEmailTags();
    $scope.treeEmailOptions = {
      dropped: function(e) {
        $timeout(function() {
          return Template.sortEmailCategories($scope.emailTemplatesTags).then(function(tags) {
            return $scope.emailTemplatesTags = tags;
          });
        });
      }
    };
    $scope.emailSectionsLoading = true;
    Section.getSections(true).then(function(sections) {
      $scope.emailSections = sections.sections;
      return $scope.emailSectionsLoading = false;
    });
    $scope.imagesLoading = true;
    $scope.getImages = function() {
      return Widget.getImages().then(function(images) {
        $scope.imagesData = images;
        return $scope.imagesLoading = false;
      });
    };
    $scope.getImages();
    $scope.searchImages = function(tag) {
      return Widget.getImagesByTag(tag, "").then(function(data) {
        return $scope.imagesData = data;
      });
    };
    Widget.getImagesTags().then(function(data) {
      return $scope.imagesTags = data;
    });
    $scope.saveImage = function(image) {
      return Widget.updateImage(image);
    };
    $scope.getNextImages = function() {
      var lastId;
      if ($scope.imagesData.pagination.itemCount <= $scope.imagesData.images.length) {
        return false;
      }
      $scope.scrollDisabled = true;
      lastId = $scope.imagesData.images[$scope.imagesData.images.length - 1].id;
      Widget.getImagesByTag($scope.tagobject.tagName, lastId).then(function(imagesData) {
        $scope.imagesData.images = $scope.imagesData.images.concat(imagesData.images);
        if (imagesData.images.length > 0) {
          return $scope.scrollDisabled = false;
        } else {
          return $scope.scrollDisabled = true;
        }
      });
    };
    $scope.propertyName = 'name';
    $scope.reverse = true;
    $scope.sortBy = function(propertyName) {
      $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
      return $scope.propertyName = propertyName;
    };
    $scope.remove = function(collection, site) {
      var findedSite, index;
      findedSite = _.filter(collection, {
        id: site.id
      });
      index = collection.indexOf(findedSite[0]);
      return $rootScope.alertDialog({
        title: "Deleting a template",
        text: "Are you sure you want to delete this template?",
        accept_text: "Yes",
        cancel_text: "Cancel",
        accept: function() {
          return Site.remove(site.id).then(function() {
            collection.splice(index, 1);
            return refreshTags();
          });
        }
      });
    };
    $scope.removeEmailTemplate = function(collection, site) {
      var findedSite, index;
      findedSite = _.filter(collection, {
        id: site.id
      });
      index = collection.indexOf(findedSite[0]);
      return $rootScope.alertDialog({
        title: "Deleting a message template",
        text: "Are you sure you want to delete this message template?",
        accept_text: "Yes",
        cancel_text: "Cancel",
        accept: function() {
          return Email.remove(site.id).then(function() {
            return collection.splice(index, 1);
          });
        }
      });
    };
    $scope.removeImage = function(collection, image) {
      var findedImage, index;
      findedImage = _.filter(collection, {
        id: image.id
      });
      index = collection.indexOf(findedImage[0]);
      return $rootScope.alertDialog({
        title: "Deleting image",
        text: "Are you sure you want to delete this image?",
        accept_text: "Yes",
        cancel_text: "Cancel",
        accept: function() {
          return Widget.remove(image).then(function() {
            collection.splice(index, 1);
            return Notification.success({
              message: 'Image successfully deleted'
            });
          });
        }
      });
    };
    $scope.removeSection = function(section, collection) {
      var findedSection, index;
      findedSection = _.filter(collection, {
        id: section.id
      });
      index = collection.indexOf(findedSection[0]);
      return $rootScope.alertDialog({
        title: "Deleting a section",
        text: "Are you sure you want to delete this section?",
        accept_text: "Yes",
        cancel_text: "Cancel",
        accept: function() {
          return Section.removePublic(section.id).then(function() {
            return collection.splice(index, 1);
          });
        }
      });
    };
    $scope.saveTemplate = function(template) {
      return Site.update(template);
    };
    $scope.saveEmailTemplate = function(template) {
      return Email.update(template);
    };
    $scope.saveSection = function(section) {
      return Section.savePublic(section);
    };
    listener0 = $rootScope.$on("site:updated", function(e, newsite, template) {
      if (template == null) {
        template = false;
      }
      return refreshTags();
    });
    listener = $rootScope.$on("site:created", function(e, newsite, template) {
      if (template == null) {
        template = false;
      }
      if (template) {
        template.childs.push(newsite);
      } else {
        $scope.sites.push(newsite);
      }
      return refreshTags();
    });
    listener2 = $rootScope.$on("image:created", function(e, newimage) {
      return $scope.imagesData.images.push(newimage);
    });
    listener3 = $rootScope.$on("email:created", function(e, newemail, template) {
      if (template == null) {
        template = false;
      }
      if (template) {
        template.childs.push(newemail);
      } else {
        $scope.emails.push(newemail);
      }
      return refreshEmailTags();
    });
    listener4 = $rootScope.$on("email:updated", function(e, newsite, template) {
      if (template == null) {
        template = false;
      }
      return refreshEmailTags();
    });
    $rootScope.refreshTemplates();
    $rootScope.refreshEmailTemplates();
    $scope.$on("$destroy", function() {
      listener0();
      listener();
      listener2();
      listener3();
      return listener4();
    });
    $scope.createSectionModal = Modal.createSectionModal;
    $scope.editSectionModal = Modal.editSectionModal;
    $scope.createEmailSectionModal = Modal.createEmailSectionModal;
    $scope.editEmailSectionModal = Modal.editEmailSectionModal;
    $scope.newTemplate = Modal.newTemplate;
    $scope.editTemplate = Modal.editTemplate;
    $scope.newEmailTemplate = Modal.newEmailTemplate;
    $scope.editEmailTemplate = Modal.editEmailTemplate;
    $scope.editImage = Modal.editImage;
    return $scope.newImage = Modal.newImage;
  }
]);


/***/ }),
/* 179 */
/***/ (function(module, exports) {

angular.module("siter.io").controller("DashboardWebForms", [
  "$scope", "$rootScope", "$state", "$timeout", "Site", "Modal", "Template", "$location", "Section", "Widget", "Notification", "WebForm", function($scope, $rootScope, $state, $timeout, Site, Modal, Template, $location, Section, Widget, Notification, WebForm) {
    var listener3, listener4, refreshWebFormTags;
    if (window.justclick.currentUser.role === "client") {
      $location.path('/404');
    }
    $rootScope.site = {};
    $scope.state = $state;
    $scope.currentState = $state.current.name;
    $scope.tagobject = {
      tagName: ""
    };
    $scope.scrollDisabled = false;
    $scope.webForms = [];
    $scope.getHomePagePath = function(pages) {
      var homePage;
      if (pages.length === 0) {
        return false;
      }
      homePage = _.filter(pages, {
        home: true
      });
      return homePage[0].path;
    };
    $rootScope.refreshWebFormTemplates = function() {
      $scope.webFormsLoading = true;
      return Template.getWebFormTemplates().then(function(webForms) {
        $scope.webForms = webForms;
        $scope.webFormsCount = webForms.length;
        return $scope.webFormsLoading = false;
      });
    };
    refreshWebFormTags = function() {
      return Template.getWebFormUserCategories().then(function(tags) {
        return $scope.webFormTemplatesTags = tags;
      });
    };
    $scope.treeWebFormOptions = {
      dropped: function(e) {
        $timeout(function() {
          return Template.sortWebFormCategories($scope.webFormTemplatesTags).then(function(tags) {
            return $scope.webFormTemplatesTags = tags;
          });
        });
      }
    };
    $scope.webFormSectionsLoading = true;
    $scope.removeWebFormTemplate = function(collection, form) {
      var findedForm, index;
      findedForm = _.filter(collection, {
        id: form.id
      });
      index = collection.indexOf(findedForm[0]);
      return $rootScope.alertDialog({
        title: "Deleting a form template",
        text: "Are you sure you want to delete this form template?",
        accept_text: "Yes",
        cancel_text: "Cancel",
        accept: function() {
          return WebForm.remove(form.id).then(function() {
            return collection.splice(index, 1);
          });
        }
      });
    };
    $scope.saveWebFormTemplate = function(template) {
      return WebForm.update(template);
    };
    listener3 = $rootScope.$on("web_form:created", function(e, newWebForm, template) {
      if (template == null) {
        template = false;
      }
      if (template) {
        template.childs.push(newWebForm);
      } else {
        $scope.webForms.push(newWebForm);
      }
      return refreshWebFormTags();
    });
    listener4 = $rootScope.$on("web_form:updated", function(e, newWebForm, template) {
      if (template == null) {
        template = false;
      }
      return refreshWebFormTags();
    });
    refreshWebFormTags();
    $rootScope.refreshWebFormTemplates();
    $scope.$on("$destroy", function() {
      listener3();
      return listener4();
    });
    $scope.newWebFormTemplate = Modal.newWebFormTemplate;
    return $scope.editWebFormTemplate = Modal.editWebFormTemplate;
  }
]);


/***/ }),
/* 180 */
/***/ (function(module, exports) {

var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

angular.module("siter.io").controller("EditImageCtrl", [
  "$scope", "$rootScope", "$modalInstance", "Widget", "Translit", "FileUploader", "Restangular", "$state", "$cookies", "image", "$timeout", function($scope, $rootScope, $modalInstance, Widget, Translit, FileUploader, Restangular, $state, $cookies, image, $timeout) {
    $scope.loadImagesTags = function(query) {
      return Restangular.all('/images/tags').getList();
    };
    $scope.edit_image = image;
    $scope.edit_image.tag = [
      {
        text: $scope.edit_image.tag
      }
    ];
    $scope.landing = {};
    $scope.cancel = function() {
      return $modalInstance.dismiss("cancel");
    };
    $scope.imageUploader = new FileUploader({
      url: Restangular.configuration.baseUrl + "/images/" + image.id,
      autoUpload: false,
      method: "PUT",
      alias: "image_attributes[source]",
      headers: {
        'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
      }
    });
    $scope.imageUploader.onAfterAddingFile = function(item) {
      var ref, types;
      types = ["image/jpeg", "image/png"];
      if (ref = item.file.type, indexOf.call(types, ref) < 0) {
        alert("The file must be png or jpg");
        return false;
      }
    };
    $scope.imageUploader.onSuccessItem = function(fileItem, response, status, headers) {
      $scope.imageUploader.clearQueue();
      image.image_attributes = response.image_attributes;
    };
    $scope.imageUploader.onErrorItem = function(fileItem, response, status, headers) {};
    $scope.updating = false;
    $scope.updateImage = function(image, newTemplateForm) {
      if (newTemplateForm.$invalid) {
        return false;
      }
      $scope.updating = true;
      return $timeout(function() {
        if (Array.isArray(image.tag) && image.tag.length > 0) {
          image.tag = image.tag[0].text;
        }
        return Widget.updateImage(image).then(function(edit_image) {
          $scope.edit_image = edit_image;
          $scope.updating = false;
          $scope.imageUploader.uploadAll();
          return $scope.close();
        }, function(errors) {
          $scope.errors = errors.data.errors;
          return $scope.updating = false;
        });
      });
    };
    return $scope.close = function() {
      return $modalInstance.dismiss("close");
    };
  }
]);


/***/ }),
/* 181 */
/***/ (function(module, exports) {

var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

angular.module("siter.io").controller("NewImageCtrl", [
  "$scope", "$rootScope", "$modalInstance", "Widget", "Translit", "FileUploader", "Restangular", "$state", "$cookies", "$q", "$filter", function($scope, $rootScope, $modalInstance, Widget, Translit, FileUploader, Restangular, $state, $cookies, $q, $filter) {
    var bulletsTag, setUploadUrls;
    bulletsTag = $filter('translate')('widget.tags.bullets');
    Restangular.all('/images/tags').getList().then(function(tags) {
      if (tags.indexOf(bulletsTag) === -1) {
        tags.push(bulletsTag);
      }
      return $scope.imagesTags = tags;
    });
    $scope.loadImagesTags = function(query) {
      var deferred;
      deferred = $q.defer();
      deferred.resolve($filter('filter')($scope.imagesTags, query));
      return deferred.promise;
    };
    $scope.new_image = {
      disabled: true
    };
    $scope.landing = {};
    $scope.cancel = function() {
      return $modalInstance.dismiss("cancel");
    };
    $scope.imageUploader = new FileUploader({
      url: "",
      autoUpload: false,
      method: "PUT",
      alias: "image_attributes[source]",
      headers: {
        'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
      }
    });
    $scope.imageUploader.onAfterAddingFile = function(item) {
      var ref, types;
      types = ["image/jpeg", "image/png", "image/svg+xml"];
      if (ref = item.file.type, indexOf.call(types, ref) < 0) {
        alert("The file must be png or jpg");
        return false;
      }
    };
    $scope.imageUploader.onSuccessItem = function(fileItem, response, status, headers) {
      $scope.imageUploader.clearQueue();
      $scope.new_image.image_attributes = response.image_attributes;
    };
    $scope.imageUploader.onErrorItem = function(fileItem, response, status, headers) {};
    setUploadUrls = function(imageId) {
      return $scope.imageUploader.queue.forEach(function(item) {
        return item.url = Restangular.configuration.baseUrl + ("/images/" + imageId);
      });
    };
    $scope.creating = false;
    $scope.createImage = function(image, newTemplateForm) {
      if (newTemplateForm.$invalid) {
        return false;
      }
      $scope.creating = true;
      image = angular.copy(image);
      image.tag = image.tag[0].text;
      return Widget.createImage(image).then(function(new_image) {
        $scope.new_image = new_image;
        $scope.creating = false;
        setUploadUrls($scope.new_image.id);
        $scope.imageUploader.uploadAll();
        $rootScope.$broadcast("image:created", $scope.new_image);
        return $scope.close();
      }, function(errors) {
        $scope.errors = errors.data.errors;
        return $scope.creating = false;
      });
    };
    return $scope.close = function() {
      return $modalInstance.dismiss("close");
    };
  }
]);


/***/ }),
/* 182 */
/***/ (function(module, exports) {

var moduleAlert;

moduleAlert = angular.module('alert.controller', []);

moduleAlert.controller("alertEditDialogCtrl", [
  "$scope", "$rootScope", "$timeout", "editorDragPanel", function($scope, $rootScope, $timeout, editorDragPanel) {
    var bindExec, bindHotKeys;
    $scope.alertEditDialogShow = false;
    bindExec = function(e) {
      if (e.keyCode === 27) {
        $scope.cancel();
      }
      return $scope.$apply();
    };
    bindHotKeys = function() {
      return $(document).bind("keyup", bindExec);
    };
    $rootScope.alertDialog = function(params) {
      $scope.alertEditDialogShow = true;
      $scope.params = params;
      bindHotKeys();
    };
    $scope.accept = function() {
      $scope.params.accept();
      $scope.alertEditDialogShow = false;
      $(document).unbind("keyup", bindExec);
    };
    return $scope.cancel = function() {
      if ($scope.params.cancel) {
        $scope.params.cancel();
      }
      $scope.alertEditDialogShow = false;
      $(document).unbind("keyup", bindExec);
    };
  }
]);


/***/ }),
/* 183 */
/***/ (function(module, exports) {

var moduleEmail;

moduleEmail = angular.module('api.email', []);

moduleEmail.factory('Email', [
  "Restangular", "$rootScope", "$stateParams", "$state", "$modal", "$injector", function(Restangular, $rootScope, $stateParams, $state, $modal, $injector) {
    var site;
    site = {
      _currentSite: Restangular.one('emails', $stateParams.emailId),
      get: function(id) {
        if (id) {
          return Restangular.one('emails', id).get();
        } else {
          return Restangular.one('emails', $stateParams.emailId).get();
        }
      },
      getList: function() {
        return Restangular.all('emails').getList();
      },
      update: function(site) {
        return Restangular.all('emails').one(site.id).customPUT(site);
      },
      updateByRoute: function(site) {
        return Restangular.all('emails').one($stateParams.emailId).customPUT(site);
      },
      remove: function(id) {
        return Restangular.one('emails', id).remove();
      },
      create: function(site) {
        return Restangular.all('emails').post(site);
      },
      saveIndex: function(changes) {
        return Restangular.one('emails', $stateParams.emailId).all('assets/save').post({
          changes: changes,
          path: $rootScope.currentFile.full_path
        });
      },
      transfer: function(data) {
        return Restangular.one('emails', $stateParams.emailId).all("transfer").post(data);
      },
      share: function(site) {
        return Restangular.one('emails', $stateParams.emailId).all("share").post(site);
      },
      setTemplate: function(template_id) {
        return Restangular.all("emails").one($state.params.emailId).customPUT({
          template_id: template_id
        });
      },
      createTemplate: function(templateParams) {
        return Restangular.all("emails").one($state.params.emailId).all("templates").post(templateParams);
      },
      addSite: function() {
        return $state.go("root.new_site");
      },
      publish: function() {
        return Restangular.all("emails").one($state.params.emailId).all("build").post();
      },
      clone: function(site_id) {
        return Restangular.all("emails").one(site_id).all("clone").post();
      },
      goToSite: function(siteSlug) {
        var newstate;
        if ($stateParams.emailId) {
          if (!$state.includes("public.templates") && !$state.includes("email.page.editor")) {
            newstate = _.extend($state.params, {
              emailId: siteSlug
            });
            return $state.transitionTo($state.current, newstate, {
              reload: true
            });
          } else {
            return $state.go('root.site.requests.bystatus', {
              emailId: siteSlug,
              status: "inbox"
            });
          }
        } else {
          return $state.go('root.site.requests.bystatus', {
            emailId: siteSlug,
            status: "inbox"
          });
        }
      }
    };
    return site;
  }
]);


/***/ }),
/* 184 */
/***/ (function(module, exports) {

var moduleFont;

moduleFont = angular.module('api.font', []);

moduleFont.factory('Font', [
  "$timeout", "Restangular", "$http", function($timeout, Restangular, $http) {
    var font;
    font = {
      getAll: function() {
        return Restangular.one("fonts").get();
      },
      connectFonts: function(fonts) {
        return _.each(fonts, this.connectFont);
      },
      defaultEmailFonts: [
        {
          id: "id1",
          family: "Arial, Helvetica, sans-serif",
          variants: ["regular", "bold", "lighter"],
          subsets: ["latin", "latin-ext", "cyrillic", "cyrillic-ext"]
        }, {
          id: "id2",
          family: "Arial Black, Gadget, sans-serif",
          variants: ["regular", "bold", "lighter"],
          subsets: ["latin", "latin-ext", "cyrillic", "cyrillic-ext"]
        }, {
          id: "id3",
          family: "Georgia, serif",
          variants: ["regular", "bold", "lighter"],
          subsets: ["latin", "latin-ext", "cyrillic", "cyrillic-ext"]
        }, {
          id: "id4",
          family: "MS Sans Serif, Geneva, sans-serif",
          variants: ["regular", "bold", "lighter"],
          subsets: ["latin", "latin-ext", "cyrillic", "cyrillic-ext"]
        }, {
          id: "id5",
          family: "MS Serif, New York, sans-serif",
          variants: ["regular", "bold", "lighter"],
          subsets: ["latin", "latin-ext", "cyrillic", "cyrillic-ext"]
        }, {
          id: "id6",
          family: "Tahoma, Geneva, sans-serif",
          variants: ["regular", "bold", "lighter"],
          subsets: ["latin", "latin-ext", "cyrillic", "cyrillic-ext"]
        }, {
          id: "id7",
          family: "Times New Roman, Times, serif",
          variants: ["regular", "bold", "lighter"],
          subsets: ["latin", "latin-ext", "cyrillic", "cyrillic-ext"]
        }, {
          id: "id8",
          family: "Trebuchet MS, Helvetica, sans-serif",
          variants: ["regular", "bold", "lighter"],
          subsets: ["latin", "latin-ext", "cyrillic", "cyrillic-ext"]
        }, {
          id: "id9",
          family: "Verdana, Geneva, sans-serif",
          variants: ["regular", "bold", "lighter"],
          subsets: ["latin", "latin-ext", "cyrillic", "cyrillic-ext"]
        }
      ],
      defaultLessonFonts: [
        {
          id: "id1",
          family: "Montserrat",
          variants: ["100", "100italic", "300", "300italic", "regular", "italic", "700", "700italic", "900", "900italic"],
          subsets: ["latin-ext", "vietnamese", "cyrillic-ext", "latin", "cyrillic"]
        }
      ],
      connectFont: function(font) {
        var subsets, variants;
        subsets = font.subsets.join(",");
        variants = font.variants.join(",");
        return WebFont.load({
          google: {
            families: [font.family + ":" + variants + ":" + subsets]
          }
        });
      },
      defaults: []
    };
    return font;
  }
]);


/***/ }),
/* 185 */
/***/ (function(module, exports) {

var modulePage;

modulePage = angular.module('api.page', []);

modulePage.factory('Page', [
  "$timeout", "ns", "$injector", "$state", "Restangular", "$http", "$templateCache", "$rootScope", "Template", function($timeout, ns, $injector, $state, Restangular, $http, $templateCache, $rootScope, Template) {
    var page;
    page = {
      create: function(page) {
        return Restangular.all("sites").one($state.params.siteId).all("pages").post(page);
      },
      update: function(page) {
        var id;
        if (Editor.mode === "email.page.editor") {
          id = $state.params.emailId;
        } else if (Editor.mode === "form.page.editor") {
          id = $state.params.formId;
        } else if (Editor.mode === "lesson.page.editor") {
          id = $state.params.lessonId;
        } else {
          id = $state.params.siteId;
        }
        return Restangular.all("sites").one(id).all("pages").one(page.id).customPUT(page);
      },
      "delete": function(page) {
        return Restangular.all("sites").one($state.params.siteId).all("pages").one(page.id).customDELETE();
      },
      getAll: function() {
        return Restangular.all("sites").one($state.params.siteId).all("pages").getList();
      },
      sort: function(pages) {
        var pagesIds;
        pagesIds = [];
        _.each(pages, function(page) {
          return pagesIds.push(page.id);
        });
        return Restangular.all("sites").one($state.params.siteId).all("pages").all("sort").post({
          pages: pagesIds
        });
      },
      clone: function(pageId) {
        return Restangular.all("sites").one($state.params.siteId).all("pages").one(pageId).all("clone").post();
      },
      remove_background: function(pageId) {
        var id;
        if (Editor.mode === "email.page.editor") {
          id = $state.params.emailId;
        } else if (Editor.mode === "form.page.editor") {
          id = $state.params.formId;
        } else if (Editor.mode === "lesson.page.editor") {
          id = $state.params.lessonId;
        } else {
          id = $state.params.siteId;
        }
        return Restangular.all("sites").one(id).all("pages").one(pageId).all("remove_background_image").post();
      },
      remove_networking_image: function(pageId) {
        return Restangular.all("sites").one($state.params.siteId).all("pages").one(pageId).all("remove_networking_image").post();
      }
    };
    return page;
  }
]);


/***/ }),
/* 186 */
/***/ (function(module, exports) {

var moduleSection;

moduleSection = angular.module('api.sectionemail', []);

moduleSection.factory('SectionEmail', [
  "$timeout", "ns", "$injector", "$state", "Restangular", "$http", "$templateCache", "$rootScope", function($timeout, ns, $injector, $state, Restangular, $http, $templateCache, $rootScope) {
    return {
      createPublic: function(params) {
        return Restangular.all("sections").post(params);
      },
      savePublic: function(section) {
        var id;
        id = section.id + "";
        return Restangular.all("sections").one(id).customPUT(section);
      },
      createItem: function(section, params, isPublic) {
        var id;
        if (isPublic == null) {
          isPublic = false;
        }
        id = section.id + "";
        if (isPublic) {
          return Restangular.all("sections").one(id).customPUT(params);
        } else {
          return Restangular.all("emails").one($state.params.emailId).all("pages").one($state.params.pageId).all("sections").one(id).customPUT(params);
        }
      },
      destoyItem: function(section, imageId) {
        var id;
        id = section.id;
        return Restangular.all("sections").one(id).all("images").one(imageId).customDELETE();
      },
      create: function(id, type) {
        return Restangular.all("emails").one($state.params.emailId).all("pages").one($state.params.pageId).all("sections").post({
          section_id: id,
          section_type: type
        });
      },
      clone: function(id, type) {
        return Restangular.all("emails").one($state.params.emailId).all("pages").one($state.params.pageId).all("sections/clone").post({
          section_id: id,
          section_type: type
        });
      },
      save: function(layout) {
        var id, isPublic, section;
        section = layout.section;
        this.beforeSave(layout);
        section.structure = this.generateJSON(layout.one(ns.wrapperClass));
        id = layout.section.id + "";
        isPublic = section.is_template;
        if (isPublic) {
          return this.savePublic(section);
        } else {
          return Restangular.all("emails").one($state.params.emailId).all("pages").one($state.params.pageId).all("sections").one(id).customPUT(section);
        }
      },
      saveAllSectionsAndPublish: function(sections) {
        return Restangular.all("emails").one($state.params.emailId).all("pages").one($state.params.pageId).all("sections").all("batch_update").customPUT({
          sections: sections
        });
      },
      getBuildStatus: function() {
        return Restangular.all("emails").one($state.params.emailId).one("build_status").get();
      },
      saveAllSectionsAndPublishPreview: function(sections) {
        return Restangular.all("emails").one($state.params.emailId).all("pages").one($state.params.pageId).all("sections").all("save_preview").customPUT({
          sections: sections
        });
      },
      saveSettings: function(section) {
        var id;
        section = angular.copy(section);
        delete section.structure;
        delete section.background_attributes.images_attributes;
        if (section.is_template) {
          return this.savePublic(section);
        } else {
          id = section.id + "";
          return Restangular.all("emails").one($state.params.emailId).all("pages").one($state.params.pageId).all("sections").one(id).customPUT(section);
        }
      },
      remove: function(id) {
        return Restangular.all("emails").one($state.params.emailId).all("pages").one($state.params.pageId).all("sections").one(id).customPUT({
          removed: true
        });
      },
      removePublic: function(id) {
        return Restangular.all("sections").one(id).customDELETE();
      },
      restore: function(id) {
        return Restangular.all("emails").one($state.params.emailId).all("pages").one($state.params.pageId).all("sections").one(id).customPUT({
          removed: false
        });
      },
      removeBg: function(section) {
        section = angular.copy(section);
        section.remove_background = true;
        if (section.is_template) {
          return Restangular.all("sections").one(section.id).customPUT(section);
        } else {
          return Restangular.all("emails").one($state.params.emailId).all("pages").one($state.params.pageId).all("sections").one(section.id).customPUT(section);
        }
      },
      sort: function(sectionsIds) {
        return Restangular.all("emails").one($state.params.emailId).all("pages").one($state.params.pageId).all("sections").all("sort").post({
          sections: sectionsIds
        });
      },
      get: function(id) {
        return Restangular.all("emails").one(id).get();
      },
      getHTML: function(section) {
        return Restangular.all("emails").one($state.params.emailId).all("pages").one($state.params.pageId).all("sections").one(section.id + ".html").get();
      },
      getPublicSectionHTML: function(id) {
        return Restangular.all("sections").one(id + ".html").get();
      },
      getPublicSectionStylesheet: function() {
        var id;
        id = $state.params.sectionId;
        return Restangular.all("sections").one(id + ".css").get();
      },
      getCollection: function(category, colors) {
        return Restangular.one("sections").get({
          tag: category,
          for_email: true,
          "color[]": colors
        });
      },
      getCategories: function(email_id) {
        return Restangular.all("sections").all("tags").getList({
          email_id: email_id
        });
      },
      getSections: function() {
        return Restangular.all("sections").one("all").get();
      },
      beforeSave: function(layout) {
        return this.setTextContents(layout);
      },
      setTextContents: function(layout) {
        var Y;
        Y = $rootScope.Y;
        return layout.all([ns.blockTextClass, ns.blockHeadline1Class, ns.blockHeadline2Class, ns.blockHeadline3Class].join(',')).each(function(block) {
          var content;
          content = block.one(ns.widgetWrapperClass).getHTML();
          Object.keys(block.widget).forEach(function(k) {
            k === '' && delete block.widget[k];
          });
          if (!block.widget) {
            return block.widget = {
              content: ""
            };
          } else {
            return block.widget.content = content;
          }
        });
      },
      generateJSON: function(block) {
        var blocksBuilder, result, rows, self, widgets;
        blocksBuilder = $injector.get("blocksBuilder");
        result = {};
        self = this;
        if (!block) {
          err("Can't recognize block");
        }
        if (block.hasClass(ns.rowClass.substr(1))) {
          result.cols = [];
          block.get("children").filter(ns.colClass).each(function(block) {
            return result.cols.push(self.generateJSON(block));
          });
        } else if (block.hasClass(ns.colClass.substr(1)) || block.hasClass(ns.wrapperClass.substr(1))) {
          if (block.test("[class*='str-col-']")) {
            result.size = blocksBuilder.getColSize(block);
          }
          widgets = [];
          rows = [];
          block.get("children").each((function(block) {
            if (block.test(ns.rowClass)) {
              0 !== widgets.length && (rows.push({
                cols: [
                  {
                    size: result.size,
                    widgets: $rootScope.Y.clone(widgets, true)
                  }
                ]
              }), widgets = []);
              return rows.push(self.generateJSON(block));
            } else if (block.test(ns.blockClass)) {
              block = block.widget;
              if (!block) {
                err("Block has not json");
              }
              return widgets.push(block);
            }
          }));
          if (0 === rows.length) {
            result.widgets = widgets;
          } else {
            0 !== widgets.length && !result.size && err("Col size is invalid: ", result.size);
            if (result.size && widgets.length) {
              rows.push({
                cols: [
                  {
                    size: result.size,
                    widgets: $rootScope.Y.clone(widgets, true)
                  }
                ]
              });
            }
            result.rows = rows;
          }
        }
        if (result.rows && 0 === result.rows.length || result.cols && 0 === result.cols.length) {
          delete result.rows;
          delete result.cols;
          result.widgets = [];
          block.get("children").filter(ns.blockClass).each(function(block) {
            return result.widgets.push(block.widget);
          });
        }
        return result;
      }
    };
  }
]);


/***/ }),
/* 187 */
/***/ (function(module, exports) {

var moduleSection;

moduleSection = angular.module('api.sectionwebform', []);

moduleSection.factory('SectionWebForm', [
  "$timeout", "ns", "$injector", "$state", "Restangular", "$http", "$templateCache", "$rootScope", function($timeout, ns, $injector, $state, Restangular, $http, $templateCache, $rootScope) {
    return {
      createPublic: function(params) {
        return Restangular.all("sections").post(params);
      },
      savePublic: function(section) {
        var id;
        id = section.id + "";
        return Restangular.all("sections").one(id).customPUT(section);
      },
      createItem: function(section, params, isPublic) {
        var id;
        if (isPublic == null) {
          isPublic = false;
        }
        id = section.id + "";
        if (isPublic) {
          return Restangular.all("sections").one(id).customPUT(params);
        } else {
          return Restangular.all("web_forms").one($state.params.formId).all("pages").one($state.params.pageId).all("sections").one(id).customPUT(params);
        }
      },
      destoyItem: function(section, imageId) {
        var id;
        id = section.id;
        return Restangular.all("sections").one(id).all("images").one(imageId).customDELETE();
      },
      create: function(id, type) {
        return Restangular.all("web_forms").one($state.params.formId).all("pages").one($state.params.pageId).all("sections").post({
          section_id: id,
          section_type: type
        });
      },
      clone: function(id, type) {
        return Restangular.all("web_forms").one($state.params.formId).all("pages").one($state.params.pageId).all("sections/clone").post({
          section_id: id,
          section_type: type
        });
      },
      save: function(layout) {
        var id, isPublic, section;
        section = layout.section;
        this.beforeSave(layout);
        section.structure = this.generateJSON(layout.one(ns.wrapperClass));
        id = layout.section.id + "";
        isPublic = section.is_template;
        if (isPublic) {
          return this.savePublic(section);
        } else {
          return Restangular.all("web_forms").one($state.params.formId).all("pages").one($state.params.pageId).all("sections").one(id).customPUT(section);
        }
      },
      saveAllSectionsAndPublish: function(sections) {
        return Restangular.all("web_forms").one($state.params.formId).all("pages").one($state.params.pageId).all("sections").all("batch_update").customPUT({
          sections: sections
        });
      },
      getBuildStatus: function() {
        return Restangular.all("web_forms").one($state.params.formId).one("build_status").get();
      },
      saveAllSectionsAndPublishPreview: function(sections) {
        return Restangular.all("web_forms").one($state.params.formId).all("pages").one($state.params.pageId).all("sections").all("save_preview").customPUT({
          sections: sections
        });
      },
      saveSettings: function(section) {
        var id;
        section = angular.copy(section);
        delete section.structure;
        delete section.background_attributes.images_attributes;
        if (section.is_template) {
          return this.savePublic(section);
        } else {
          id = section.id + "";
          return Restangular.all("web_forms").one($state.params.formId).all("pages").one($state.params.pageId).all("sections").one(id).customPUT(section);
        }
      },
      remove: function(id) {
        return Restangular.all("web_forms").one($state.params.formId).all("pages").one($state.params.pageId).all("sections").one(id).customPUT({
          removed: true
        });
      },
      removePublic: function(id) {
        return Restangular.all("sections").one(id).customDELETE();
      },
      restore: function(id) {
        return Restangular.all("web_forms").one($state.params.formId).all("pages").one($state.params.pageId).all("sections").one(id).customPUT({
          removed: false
        });
      },
      removeBg: function(section) {
        section = angular.copy(section);
        section.remove_background = true;
        if (section.is_template) {
          return Restangular.all("sections").one(section.id).customPUT(section);
        } else {
          return Restangular.all("web_forms").one($state.params.formId).all("pages").one($state.params.pageId).all("sections").one(section.id).customPUT(section);
        }
      },
      sort: function(sectionsIds) {
        return Restangular.all("web_forms").one($state.params.formId).all("pages").one($state.params.pageId).all("sections").all("sort").post({
          sections: sectionsIds
        });
      },
      get: function(id) {
        return Restangular.all("web_forms").one(id).get();
      },
      getHTML: function(id) {
        return Restangular.all("web_forms").one($state.params.formId).all("pages").one($state.params.pageId).all("sections").one(id + ".html").get();
      },
      getPublicSectionHTML: function(id) {
        return Restangular.all("sections").one(id + ".html").get();
      },
      getPublicSectionStylesheet: function() {
        var id;
        id = $state.params.sectionId;
        return Restangular.all("sections").one(id + ".css").get();
      },
      getCollection: function(category, colors) {
        return Restangular.one("sections").get({
          tag: category,
          "color[]": colors
        });
      },
      getCategories: function(email_id) {
        return Restangular.all("sections").all("tags").getList({
          email_id: email_id
        });
      },
      getSections: function() {
        return Restangular.all("sections").one("all").get();
      },
      getHtmlCodeOfForm: function(id) {
        return Restangular.all("web_forms").one(id).one("source.html").get();
      },
      getStylesheetsOfForm: function(id) {
        return Restangular.all("web_forms").one(id).one("source.css").get();
      },
      beforeSave: function(layout) {
        return this.setTextContents(layout);
      },
      setTextContents: function(layout) {
        var Y;
        Y = $rootScope.Y;
        return layout.all([ns.blockTextClass, ns.blockHeadline1Class, ns.blockHeadline2Class, ns.blockHeadline3Class].join(',')).each(function(block) {
          var content;
          content = block.one(ns.widgetWrapperClass).getHTML();
          Object.keys(block.widget).forEach(function(k) {
            k === '' && delete block.widget[k];
          });
          if (!block.widget) {
            return block.widget = {
              content: ""
            };
          } else {
            return block.widget.content = content;
          }
        });
      },
      generateJSON: function(block) {
        var blocksBuilder, result, rows, self, widgets;
        blocksBuilder = $injector.get("blocksBuilder");
        result = {};
        self = this;
        if (!block) {
          err("Can't recognize block");
        }
        if (block.hasClass(ns.rowClass.substr(1))) {
          result.cols = [];
          block.get("children").filter(ns.colClass).each(function(block) {
            return result.cols.push(self.generateJSON(block));
          });
        } else if (block.hasClass(ns.colClass.substr(1)) || block.hasClass(ns.wrapperClass.substr(1))) {
          if (block.test("[class*='str-col-']")) {
            result.size = blocksBuilder.getColSize(block);
          }
          widgets = [];
          rows = [];
          block.get("children").each((function(block) {
            if (block.test(ns.rowClass)) {
              0 !== widgets.length && (rows.push({
                cols: [
                  {
                    size: result.size,
                    widgets: $rootScope.Y.clone(widgets, true)
                  }
                ]
              }), widgets = []);
              return rows.push(self.generateJSON(block));
            } else if (block.test(ns.blockClass)) {
              block = block.widget;
              if (!block) {
                err("Block has not json");
              }
              return widgets.push(block);
            }
          }));
          if (0 === rows.length) {
            result.widgets = widgets;
          } else {
            0 !== widgets.length && !result.size && err("Col size is invalid: ", result.size);
            if (result.size && widgets.length) {
              rows.push({
                cols: [
                  {
                    size: result.size,
                    widgets: $rootScope.Y.clone(widgets, true)
                  }
                ]
              });
            }
            result.rows = rows;
          }
        }
        if (result.rows && 0 === result.rows.length || result.cols && 0 === result.cols.length) {
          delete result.rows;
          delete result.cols;
          result.widgets = [];
          block.get("children").filter(ns.blockClass).each(function(block) {
            return result.widgets.push(block.widget);
          });
        }
        return result;
      }
    };
  }
]);


/***/ }),
/* 188 */
/***/ (function(module, exports) {

var moduleWebForm;

moduleWebForm = angular.module('api.webform', []);

moduleWebForm.factory('WebForm', [
  "Restangular", "$rootScope", "$stateParams", "$state", "$modal", "$injector", function(Restangular, $rootScope, $stateParams, $state, $modal, $injector) {
    var site;
    site = {
      _currentSite: Restangular.one('web_forms', $stateParams.formId),
      get: function(id) {
        if (id) {
          return Restangular.one('web_forms', id).get();
        } else {
          return Restangular.one('web_forms', $stateParams.formId).get();
        }
      },
      getList: function() {
        return Restangular.all('web_forms').getList();
      },
      update: function(site) {
        return Restangular.all('web_forms').one(site.id).customPUT(site);
      },
      updateByRoute: function(site) {
        return Restangular.all('web_forms').one($stateParams.formId).customPUT(site);
      },
      remove: function(id) {
        return Restangular.one('web_forms', id).remove();
      },
      create: function(site) {
        return Restangular.all('web_forms').post(site);
      },
      saveIndex: function(changes) {
        return Restangular.one('web_forms', $stateParams.formId).all('assets/save').post({
          changes: changes,
          path: $rootScope.currentFile.full_path
        });
      },
      transfer: function(data) {
        return Restangular.one('web_forms', $stateParams.formId).all("transfer").post(data);
      },
      share: function(site) {
        return Restangular.one('web_forms', $stateParams.formId).all("share").post(site);
      },
      setTemplate: function(template_id) {
        return Restangular.all("web_forms").one($state.params.formId).customPUT({
          template_id: template_id
        });
      },
      createTemplate: function(templateParams) {
        return Restangular.all("web_forms").one($state.params.formId).all("templates").post(templateParams);
      },
      addSite: function() {
        return $state.go("root.new_site");
      },
      publish: function() {
        return Restangular.all("web_forms").one($state.params.formId).all("build").post();
      },
      clone: function(site_id) {
        return Restangular.all("web_forms").one(site_id).all("clone").post();
      },
      goToSite: function(siteSlug) {
        var newstate;
        if ($stateParams.formId) {
          if (!$state.includes("public.templates") && !$state.includes("form.page.editor")) {
            newstate = _.extend($state.params, {
              formId: siteSlug
            });
            return $state.transitionTo($state.current, newstate, {
              reload: true
            });
          } else {
            return $state.go('root.site.requests.bystatus', {
              formId: siteSlug,
              status: "inbox"
            });
          }
        } else {
          return $state.go('root.site.requests.bystatus', {
            formId: siteSlug,
            status: "inbox"
          });
        }
      }
    };
    return site;
  }
]);


/***/ }),
/* 189 */
/***/ (function(module, exports) {

var apiWidgets;

apiWidgets = angular.module('api.widget', []);

apiWidgets.service('Widget', [
  "$state", "Restangular", "$rootScope", function($state, Restangular, $rootScope) {
    var _widgets, widgets;
    if ($state.includes("email.page.editor")) {
      _widgets = "email_widgets";
    } else {
      _widgets = "widgets";
    }
    widgets = {
      getAll: function() {
        return Restangular.one("widgets").get();
      },
      get: function(type) {
        return Restangular.all("widgets").one(type).get();
      },
      createImage: function(image) {
        return Restangular.all("images").post(image);
      },
      updateImage: function(image) {
        return Restangular.all("images").one(image.id).customPUT(image);
      },
      create: function(sectionId, widgetType, sectionIsTemplate) {
        return Restangular.all("sections").one(sectionId).all(_widgets).post({
          type: widgetType
        });
      },
      updateForm: function(sectionId, widget) {
        widget.form_fields_attributes = _.map(widget.form_fields_attributes, function(o) {
          return _.omit(o, 'optionsAdded');
        });
        return Restangular.all("sections").one(sectionId).all(_widgets).one(widget.id).customPUT(widget);
      },
      update: function(sectionId, widget) {
        return Restangular.all("sections").one(sectionId).all(_widgets).one(widget.id).customPUT(widget);
      },
      updateForMixer: function(sectionId, widget) {
        return Restangular.all("sections").one(sectionId).all("widgets").one(widget.id).all("update_for_mixer").customPUT(widget);
      },
      clone: function(sectionId, widgetId) {
        return Restangular.all("sections").one(sectionId).all(_widgets).one(widgetId).all("clone").post();
      },
      getYoutubeHtml: function(sectionId, url) {
        return Restangular.all("sections").one(sectionId).all(_widgets).all("video").one("new").get({
          video_url: url
        });
      },
      createItem: function(sectionId, widgetId, params) {
        return Restangular.all("sections").one(sectionId).all(_widgets).one(widgetId).customPUT(params);
      },
      getWidget: function(sectionId, widgetId) {
        return Restangular.all("sections").one(sectionId).all(_widgets).one(widgetId).get();
      },
      sortFormFields: function(formId, fieldsIds) {
        return Restangular.all("/forms/" + formId + "/fields/sort").post({
          fields: fieldsIds
        });
      },
      sortSubscribeFormFields: function(formId, fieldsIds) {
        return Restangular.all("/subscribe_forms/" + formId + "/fields/sort").post({
          fields: fieldsIds
        });
      },
      sortProductItems: function(productId, productItemsIds) {
        return Restangular.all("/products/" + productId + "/product_items/sort").post({
          product_items: productItemsIds
        });
      },
      destroyProductItem: function(productId, productItemId) {
        return Restangular.all("/products/" + productId + "/product_items/" + productItemId).customDELETE();
      },
      createProductItemRow: function(productId, productItemId, params) {
        return Restangular.all("/products/" + productId + "/product_items/" + productItemId).customPUT(params);
      },
      getVideoHtml: function(sectionId, url) {
        return Restangular.all("sections").one(sectionId).all(_widgets).all("video").one("new").get({
          video_url: url
        });
      },
      getImagesByTag: function(tag, page) {
        return Restangular.one("images").get({
          tag: tag,
          page: page
        });
      },
      getImages: function(page) {
        return Restangular.one("images").get({
          page: page
        });
      },
      getImagesTags: function() {
        return Restangular.one("images/tags").getList();
      },
      remove: function(image) {
        return Restangular.one("images/" + image.id).customDELETE();
      }
    };
    return widgets;
  }
]);


/***/ }),
/* 190 */
/***/ (function(module, exports) {

var moduleEditorDirectives;

moduleEditorDirectives = angular.module('directives.htmlcompiler', []);

moduleEditorDirectives.directive('ngHtmlCompile', [
  "$compile", "$timeout", function($compile, $timeout) {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        scope.$watchCollection(attrs.ngHtmlCompile, function(newValue, oldValue) {
          element.html(newValue);
          $compile(element.contents())(scope);
        });
      }
    };
  }
]);


/***/ }),
/* 191 */
/***/ (function(module, exports) {

var moduleDirectives;

moduleDirectives = angular.module('editor.directives', ["directives.htmlcompiler"]);


/***/ }),
/* 192 */
/***/ (function(module, exports) {

var moduleEditor,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

moduleEditor = angular.module('editorEmail.controller', ['api.widget', 'factory.editorLibrary']);

moduleEditor.controller("EditorEmailCtrl", [
  "$scope", "$rootScope", "$state", "$timeout", "editorNavSections", "layoutEditor", "Widget", "insertBlockMenu", "Template", "ns", "Email", "editorDragPanel", "SectionEmail", "$modal", "State", "blockOverlays", "Font", "TimeMachine", "Notification", "$filter", "Parallax", "WidgetsSortHelper", "EditorLibrary", "ButtonActionsManager", "ImageInit", function($scope, $rootScope, $state, $timeout, editorNavSections, layoutEditor, Widget, insertBlockMenu, Template, ns, Email, editorDragPanel, SectionEmail, $modal, State, blockOverlays, Font, TimeMachine, Notification, $filter, Parallax, WidgetsSortHelper, EditorLibrary, ButtonActionsManager, ImageInit) {
    var Editor, addAdditionalFonts, afterInstrumentsInitialized, currentPage, destroyGetStyles, destroyWidgetsFinished, loadStyles, loadStylesOfPublicSection, loadStylesOfTemplate, parseHTML, preventForm, preventFormsSubmit, removeAutoPlay, setBgStyles, setGradient, setTemplateHTML, startEditPublicSection, stylesCallback, unbindPreventForm, widgetsForEmail;
    stylesCallback = void 0;
    $scope.templateIsReady = false;
    $rootScope.filter = $filter;
    $rootScope.justclick = window.justclick;
    loadStylesOfTemplate = function(sectionId) {
      if (sectionId == null) {
        sectionId = false;
      }
      return Template.getStylesheet().then(function(response) {
        angular.element("#tplStyles").text(response);
        if (stylesCallback) {
          stylesCallback();
          return stylesCallback = void 0;
        }
      });
    };
    loadStylesOfPublicSection = function() {
      return SectionEmail.getPublicSectionStylesheet().then(function(response) {
        return angular.element("#tplStyles").text(response);
      });
    };
    loadStyles = function(sectionId) {
      if (sectionId == null) {
        sectionId = false;
      }
      if ($state.includes("editor.section")) {
        return loadStylesOfPublicSection();
      } else {
        return loadStylesOfTemplate(sectionId);
      }
    };
    destroyGetStyles = $rootScope.$on("get:styles", function(data, sectionId, cb) {
      if (cb) {
        stylesCallback = cb;
      }
      return loadStyles(sectionId);
    });
    addAdditionalFonts = function() {
      if (Editor.mode === "editor.section") {
        Editor.Instrumentations.fonts = $rootScope.sections.fonts_attributes;
      }
      if (Editor.mode === "email.page.editor") {
        Editor.Instrumentations.fonts = Font.defaultEmailFonts;
      }
      return $rootScope.$broadcast("fontNames:loaded");
    };
    startEditPublicSection = function() {
      var layout;
      if (Editor.mode === "editor.section") {
        layout = $rootScope.Y.one(ns.sectionClass);
        return editorDragPanel._onClickEditSection({
          target: layout
        });
      }
    };
    removeAutoPlay = function(htmlData) {
      if (!htmlData) {
        return "";
      }
      return htmlData.replace(new RegExp("autoplay=1", 'g'), "");
    };
    preventForm = function(e) {
      return e.preventDefault();
    };
    preventFormsSubmit = function() {
      return angular.element("body").on("submit", "form", preventForm);
    };
    unbindPreventForm = function() {
      return angular.element("body").off("submit", "form", preventForm);
    };
    parseHTML = function(selector, htmlString) {
      var codeHTML, contentSectionsHTML, jContent;
      contentSectionsHTML = "";
      codeHTML = "<div class='str-bw_code-html-overlay'><img class='str-bw_code-html-overlay-icon' src='/constructor/editor/assets/images/code-overlay-icon.svg' /><div class='str-bw_code-html-overlay-text'>" + ($filter('translate')('widget.code.text')) + "</div></div>";
      jContent = $('<div/>').html(htmlString).contents();
      jContent.find(".str-bw_code-html").html(codeHTML);
      if (selector !== "section" && jContent.find(selector)[0]) {
        return jContent.find(selector)[0].outerHTML;
      }
      if (selector === "section") {
        jContent.find("section").each(function(index, section) {
          return contentSectionsHTML += section.outerHTML;
        });
        return contentSectionsHTML;
      }
    };
    setTemplateHTML = function(htmlData) {
      var contentSectionsHTML;
      if (Editor.mode === "editor.section") {
        $("#tpl-wrapper").html(htmlData);
        return false;
      }
      htmlData = "<div>" + htmlData + "</div>";
      contentSectionsHTML = parseHTML("section", htmlData);
      $(contentSectionsHTML).insertAfter(".str-drop-backdrop");
      return EditorLibrary.removeVisibilityDelay();
    };
    afterInstrumentsInitialized = function() {
      preventFormsSubmit();
      return Template.loadHTML().then(function(htmlData) {
        var e;
        htmlData = removeAutoPlay(htmlData);
        try {
          setTemplateHTML(htmlData);
        } catch (error) {
          e = error;
          log(e);
        }
        layoutEditor.initializer($rootScope.Y);
        return Template.loadJSON().then(function(data) {
          $rootScope.contentSections = _.filter(data, {
            section_type: "default"
          });
          $rootScope.sections = data;
          layoutEditor.setTemplateJSON(data);
          editorDragPanel.initSectionsPanels($rootScope.Y, Editor.mode);
          blockOverlays.init($rootScope.Y);
          addAdditionalFonts();
          $rootScope.toggleCommonSections();
          layoutEditor.sectionInitializers($rootScope.Y);
          $rootScope.initWidgets();
          $timeout(function() {
            return $scope.templateIsReady = true;
          }, 1000);
          return $timeout(function() {
            return startEditPublicSection();
          });
        });
      }, function() {
        return $rootScope.alertDialog({
          title: $filter("translate")("alert.editor.error"),
          text: $filter("translate")("alert.editor.errorDescription"),
          accept_text: "OK",
          accept: function() {
            var ref;
            if ((ref = window.justclick.currentUser.role) === "admin" || ref === "superadmin") {
              return document.location.href = "/sites/constructor/admin/#/admin/dashboard/templates";
            } else {
              return document.location.href = window.justclick.back_uri;
            }
          }
        });
      });
    };
    Editor = {};
    Editor = {
      initializer: function() {
        if (Editor.mode === "email.page.editor") {
          Email.get($state.params.emailId).then(function(siteData) {
            $rootScope.currentSite = siteData;
            $rootScope.currentPage = currentPage(siteData);
            $rootScope.Y.one("#tpl-wrapper").section = $rootScope.currentPage;
            setBgStyles();
            loadStyles();
            return $rootScope.$on('section:created', function(event, sectionNode) {
              return $rootScope.initSectionWidgets(sectionNode);
            });
          }, function() {
            return $state.go("404");
          });
        }
        if (Editor.mode === "editor.section") {
          loadStyles();
        }
        return Editor.Instrumentations.initializer(afterInstrumentsInitialized);
      },
      mode: $state.current.name,
      getSections: function() {
        var sections;
        sections = [];
        $rootScope.Y.all(ns.sectionClass).each(function(s) {
          var previousSection;
          previousSection = layoutEditor.getRootScopeParameter('previousSection', s.section.id);
          if (!s.section.removed && (previousSection != null) && !_.isEqual(previousSection, s.section)) {
            s.section = previousSection;
          }
          return sections.push(s.section);
        });
        return sections;
      },
      destroy: function() {
        return layoutEditor.destroy();
      }
    };
    widgetsForEmail = ["image", "text", "headline_h1", "headline_h2", "headline_h3", "button", "spacer", "line", "list", "code"];
    Editor.Instrumentations = {
      initializer: function(cb) {
        var self, widgetsTypesSortMap;
        self = this;
        widgetsTypesSortMap = ['headline_h1', 'headline_h2', 'headline_h3', 'text', 'spacer', 'subscribe_form', 'image', 'video', 'button', 'list', 'timer', 'navigation', 'link', 'review', 'card', 'product', 'slider', 'gallery', 'table', 'line', 'map', 'social', 'facebook_comment', 'code'];
        return Widget.getAll().then(function(widgetsData) {
          _.each(widgetsData.widgets, function(widget) {
            var ref;
            if (ref = widget.type, indexOf.call(widgetsForEmail, ref) >= 0) {
              return self.widgetList.push(widget);
            }
          });
          self.widgetList = WidgetsSortHelper.sortWidgetsByTypesSortMap(self.widgetList, widgetsTypesSortMap);
          return $timeout(function() {
            return cb();
          });
        });
      },
      defaultFonts: Font.defaults,
      widgetList: []
    };
    $rootScope.Editor = Editor;
    window.Editor = Editor;
    setGradient = function(background_attributes) {
      var color_start, color_stop, gradient_css;
      color_start = background_attributes.color_start;
      color_stop = background_attributes.color_stop;
      gradient_css = "background-image:-moz-linear-gradient(top, " + color_start + ", " + color_stop + "); background-image:-webkit-linear-gradient(top, " + color_start + ", " + color_stop + "); background-image:-o-linear-gradient(top, " + color_start + ", " + color_stop + "); background-image:-ms-linear-gradient(top, " + color_start + ", " + color_stop + ");, background-image:linear-gradient(top, " + color_start + ", " + color_stop + "); filter: progid:DXImageTransform.Microsoft.gradient(startColorStr='" + color_start + "', endColorstr='" + color_stop + "');";
      if ($("style#" + $rootScope.currentPage.id).length > 0) {
        return $("style#" + $rootScope.currentPage.id).html("#tpl-wrapper:before { " + gradient_css + " }");
      } else {
        return $('body').append("<style id='" + $rootScope.currentPage.id + "'>#tpl-wrapper:before { " + gradient_css + " }</style>");
      }
    };
    setBgStyles = function() {
      var bodyElement, imageExist;
      bodyElement = $("#tpl-wrapper");
      bodyElement.css($rootScope.currentPage.style_attributes);
      imageExist = $rootScope.currentPage.background_attributes && $rootScope.currentPage.background_attributes.image_attributes && $rootScope.currentPage.background_attributes.image_attributes.source_url;
      if (imageExist) {
        bodyElement.css({
          backgroundImage: "url('" + $rootScope.currentPage.background_attributes.image_attributes.source_url + "')"
        });
      }
      if ($rootScope.currentPage.background_attributes && $rootScope.currentPage.background_attributes.gradient) {
        setGradient($rootScope.currentPage.background_attributes);
      }
      Parallax.initSection($rootScope.Y.one("#tpl-wrapper"));
    };
    currentPage = function(site) {
      var pageId, parentPagesResult;
      currentPage = void 0;
      pageId = $state.params.pageId;
      parentPagesResult = _.filter(site.pages, {
        path: $state.params.pageId
      })[0];
      if (parentPagesResult) {
        currentPage = parentPagesResult;
      }
      site.pages.forEach(function(page) {
        return page.pages.forEach(function(pageChild) {
          if (pageChild.path === pageId) {
            return currentPage = pageChild;
          }
        });
      });
      return currentPage;
    };
    destroyWidgetsFinished = $scope.$on("widgetsFinished", function(newData) {
      return insertBlockMenu.initDD();
    });
    $scope.$on("$destroy", function() {
      unbindPreventForm();
      destroyGetStyles();
      destroyWidgetsFinished();
      Editor.destroy();
      TimeMachine.destroy();
      $rootScope.widgetIsEditing = false;
      return $scope.templateIsReady = false;
    });
    if (!$rootScope.Y) {
      YUI().use('node', 'event-valuechange', 'anim', 'dd', 'dd-proxy', 'dd-constrain', 'dd-drop', 'dd-scroll', "dd-delegate", "event-hover", "resize", "resize-plugin", "overlay", function(y) {
        $rootScope.Y = y;
        return Editor.initializer();
      });
    } else {
      Editor.initializer();
    }
    $rootScope.toggleCommonSections = function(sections) {
      var footers, headers;
      sections = Editor.getSections();
      headers = _.filter(sections, {
        section_type: "header"
      });
      footers = _.filter(sections, {
        section_type: "footer"
      });
      $scope.showFooter = false;
      $scope.showHeader = false;
      if (!$scope.$$phase) {
        return $scope.$apply();
      }
    };
    $scope.viewSite = State.viewSite;
    $scope.saveSection = editorDragPanel.cancelSection;
    $rootScope.openEditorNavPanel = function() {
      $(".etsw-header__title").text($filter('translate')('editor.addElementButton'));
      return $scope.editorNavOpen = true;
    };
    $scope.openEditorNav = function() {
      $rootScope.editorNavTab("sections");
      return $rootScope.openEditorNavPanel();
    };
    $scope.panelRight = true;
    $scope.togglePanelPosition = function() {
      return $scope.panelRight = !$scope.panelRight;
    };
    $rootScope.initWidgets = function() {
      return $rootScope.Y.all(".str-section").each(function(sectionNode) {
        return $rootScope.initSectionWidgets(sectionNode);
      });
    };
    $rootScope.initSectionWidgets = function(sectionNode) {
      return sectionNode.all(".str-block").each(function(block) {
        if (block.widget && block.widget.type === 'image') {
          ImageInit.updateOptions(block.widget);
        }
        if (block.widget && block.widget.type === 'link') {
          ButtonActionsManager.updateOptions(block.widget);
        }
        if (block.widget && block.widget.type === 'button') {
          ButtonActionsManager.updateOptions(block.widget);
        }
        if (block.widget && block.widget.type === 'card') {
          ButtonActionsManager.updateOptions(block.widget);
        }
        if (block.widget && block.widget.type === 'product') {
          block.widget.product_items_attributes.map(function(subWidget, id) {
            if (subWidget.item_type === 'button') {
              return ButtonActionsManager.updateOptions(block.widget.product_items_attributes[id]);
            }
          });
        }
        return layoutEditor.updateSectionEtag(sectionNode.section);
      });
    };
    $rootScope.undo = function() {
      return $timeout(function() {
        return TimeMachine.undo();
      });
    };
    $rootScope.redo = function() {
      return $timeout(function() {
        return TimeMachine.redo();
      });
    };
    $rootScope.savePreview = function() {
      var sections;
      $scope.loading = true;
      layoutEditor.sortSections();
      sections = Editor.getSections();
      return SectionEmail.saveAllSectionsAndPublishPreview(sections).then(function(response) {
        if (response.status && (response.data != null) && (response.data.preview_email_id != null)) {
          $scope.loading = false;
          return $rootScope.openPreview(response.data.preview_email_id);
        }
      }, function() {
        $scope.loading = false;
        return Notification.error({
          message: $filter('translate')('site.error')
        });
      });
    };
    $scope.publishSite = function() {
      return $timeout(function() {
        var sections;
        $scope.publishing = true;
        layoutEditor.sortSections();
        sections = Editor.getSections();
        return SectionEmail.saveAllSectionsAndPublish(sections).then(function(sectionsData) {
          EditorLibrary.showBuildStatus(SectionEmail, $scope, null, 3000, 3000, 3);
          TimeMachine.clear();
          layoutEditor.setTemplateJSON(sectionsData);
          return $timeout(function() {
            $scope.publishing = false;
            return Notification.success({
              message: $filter('translate')('email.saved')
            });
          }, 300);
        }, function() {
          $scope.publishing = false;
          return Notification.error({
            message: $filter('translate')('site.error')
          });
        });
      }, 300);
    };
    $scope.sectionSave = function() {
      $scope.sectionSaving = true;
      layoutEditor.publicSectionSave().then(function() {
        return $scope.sectionSaving = false;
      });
    };
    return $scope.exit = function() {
      return $rootScope.alertDialog({
        title: $filter("translate")("alert.editor.exitTitle"),
        text: $filter("translate")("alert.editor.exitDescription"),
        accept_text: $filter("translate")("alert.confirm"),
        cancel_text: $filter("translate")("alert.cancel"),
        accept: function() {
          var ref;
          if ((ref = window.justclick.currentUser.role) === "admin" || ref === "superadmin") {
            return $state.go("admin.dashboard.templates");
          } else {
            return document.location.href = window.justclick.back_uri;
          }
        }
      });
    };
  }
]);


/***/ }),
/* 193 */
/***/ (function(module, exports) {

var moduleEditor,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

moduleEditor = angular.module('editorForm.controller', ['api.widget', 'factory.editorLibrary']);

moduleEditor.controller("EditorFormCtrl", [
  "$scope", "$rootScope", "$state", "$timeout", "editorNavSections", "layoutEditor", "Widget", "insertBlockMenu", "Template", "ns", "WebForm", "editorDragPanel", "SectionWebForm", "$modal", "State", "blockOverlays", "Font", "TimeMachine", "Notification", "$filter", "Parallax", "SubscribeFormManager", "ImageInit", "ButtonActionsManager", "WidgetsSortHelper", "EditorLibrary", function($scope, $rootScope, $state, $timeout, editorNavSections, layoutEditor, Widget, insertBlockMenu, Template, ns, WebForm, editorDragPanel, SectionWebForm, $modal, State, blockOverlays, Font, TimeMachine, Notification, $filter, Parallax, SubscribeFormManager, ImageInit, ButtonActionsManager, WidgetsSortHelper, EditorLibrary) {
    var Editor, addAdditionalFonts, afterInstrumentsInitialized, currentPage, destroyGetStyles, destroyWidgetsFinished, loadStyles, loadStylesOfPublicSection, loadStylesOfTemplate, parseHTML, preventForm, preventFormsSubmit, removeAutoPlay, setGradient, setTemplateHTML, startEditPublicSection, stylesCallback, unbindPreventForm, widgetsForForm;
    stylesCallback = void 0;
    $scope.templateIsReady = false;
    $rootScope.filter = $filter;
    $rootScope.justclick = window.justclick;
    loadStylesOfTemplate = function(sectionId) {
      if (sectionId == null) {
        sectionId = false;
      }
      return Template.getStylesheet().then(function(response) {
        angular.element("#tplStyles").text(response);
        if (stylesCallback) {
          stylesCallback();
          return stylesCallback = void 0;
        }
      });
    };
    loadStylesOfPublicSection = function() {
      return SectionWebForm.getPublicSectionStylesheet().then(function(response) {
        return angular.element("#tplStyles").text(response);
      });
    };
    loadStyles = function(sectionId) {
      if (sectionId == null) {
        sectionId = false;
      }
      if ($state.includes("editor.section")) {
        return loadStylesOfPublicSection();
      } else {
        return loadStylesOfTemplate(sectionId);
      }
    };
    destroyGetStyles = $rootScope.$on("get:styles", function(data, sectionId, cb) {
      if (cb) {
        stylesCallback = cb;
      }
      return loadStyles(sectionId);
    });
    addAdditionalFonts = function() {
      if (Editor.mode === "editor.section") {
        Editor.Instrumentations.fonts = $rootScope.sections.fonts_attributes;
      }
      if (Editor.mode === "form.page.editor") {
        Editor.Instrumentations.fonts = $rootScope.site.fonts_attributes;
      }
      return $rootScope.$broadcast("fontNames:loaded");
    };
    startEditPublicSection = function() {
      var layout;
      layout = $rootScope.Y.one(ns.sectionClass);
      return editorDragPanel._onClickEditSection({
        target: layout
      });
    };
    removeAutoPlay = function(htmlData) {
      if (!htmlData) {
        return "";
      }
      return htmlData.replace(new RegExp("autoplay=1", 'g'), "");
    };
    preventForm = function(e) {
      return e.preventDefault();
    };
    preventFormsSubmit = function() {
      return angular.element("body").on("submit", "form", preventForm);
    };
    unbindPreventForm = function() {
      return angular.element("body").off("submit", "form", preventForm);
    };
    parseHTML = function(selector, htmlString) {
      var codeHTML, contentSectionsHTML, jContent;
      contentSectionsHTML = "";
      codeHTML = "<div class='str-bw_code-html-overlay'><img class='str-bw_code-html-overlay-icon' src='/constructor/editor/assets/images/code-overlay-icon.svg' /><div class='str-bw_code-html-overlay-text'>" + ($filter('translate')('widget.code.text')) + "</div></div>";
      jContent = $('<div/>').html(htmlString).contents();
      jContent.find(".str-bw_code-html").html(codeHTML);
      if (selector !== "section" && jContent.find(selector)[0]) {
        return jContent.find(selector)[0].outerHTML;
      }
      if (selector === "section") {
        jContent.find("section").each(function(index, section) {
          return contentSectionsHTML += section.outerHTML;
        });
        return contentSectionsHTML;
      }
    };
    setTemplateHTML = function(htmlData) {
      var contentSectionsHTML, footerHTML, headerHTML;
      if (Editor.mode === "editor.section") {
        $("#tpl-wrapper").html(htmlData);
        return false;
      }
      htmlData = "<div>" + htmlData + "</div>";
      contentSectionsHTML = parseHTML("section", htmlData);
      headerHTML = parseHTML("header", htmlData);
      footerHTML = parseHTML("footer", htmlData);
      $(headerHTML).insertBefore(".str-drop-backdrop");
      $(footerHTML).insertAfter(".str-drop-backdrop");
      $(contentSectionsHTML).insertAfter(".str-drop-backdrop");
      return EditorLibrary.removeVisibilityDelay();
    };
    afterInstrumentsInitialized = function() {
      preventFormsSubmit();
      return Template.loadHTML().then(function(htmlData) {
        var e;
        htmlData = removeAutoPlay(htmlData);
        try {
          setTemplateHTML(htmlData);
        } catch (error) {
          e = error;
          log(e);
        }
        layoutEditor.initializer($rootScope.Y);
        return Template.loadJSON().then(function(data) {
          $rootScope.contentSections = _.filter(data, {
            section_type: "default"
          });
          $rootScope.sections = data;
          layoutEditor.setTemplateJSON(data);
          editorDragPanel.initSectionsPanels($rootScope.Y, Editor.mode);
          blockOverlays.init($rootScope.Y);
          addAdditionalFonts();
          $rootScope.toggleCommonSections();
          layoutEditor.sectionInitializers($rootScope.Y);
          $rootScope.initWidgets();
          $timeout(function() {
            return $scope.templateIsReady = true;
          }, 1000);
          return $timeout(function() {
            return startEditPublicSection();
          });
        });
      }, function() {
        return $rootScope.alertDialog({
          title: $filter("translate")("alert.editor.error"),
          text: $filter("translate")("alert.editor.errorDescription"),
          accept_text: "OK",
          accept: function() {
            var ref;
            if ((ref = window.justclick.currentUser.role) === "admin" || ref === "superadmin") {
              return document.location.href = "/sites/constructor/admin/#/admin/dashboard/templates";
            } else {
              return document.location.href = window.justclick.back_uri;
            }
          }
        });
      });
    };
    Editor = {};
    Editor = {
      initializer: function() {
        if (Editor.mode === "form.page.editor") {
          WebForm.get($state.params.formId).then(function(siteData) {
            $rootScope.currentSite = siteData;
            $rootScope.currentPage = currentPage(siteData);
            $rootScope.Y.one("#tpl-wrapper").section = $rootScope.currentPage;
            return loadStyles();
          }, function() {
            return $state.go("404");
          });
        }
        if (Editor.mode === "editor.section") {
          loadStyles();
        }
        return Editor.Instrumentations.initializer(afterInstrumentsInitialized);
      },
      mode: $state.current.name,
      getSections: function() {
        var sections;
        sections = [];
        $rootScope.Y.all(ns.sectionClass).each(function(s) {
          var previousSection;
          previousSection = layoutEditor.getRootScopeParameter('previousSection', s.section.id);
          if (!s.section.removed && (previousSection != null) && !_.isEqual(previousSection, s.section)) {
            s.section = previousSection;
          }
          return sections.push(s.section);
        });
        return sections;
      },
      destroy: function() {
        return layoutEditor.destroy();
      }
    };
    widgetsForForm = ["subscribe_form", "text", "headline_h1", "headline_h2", "headline_h3", "list", "spacer", "image", "social", "code"];
    Editor.Instrumentations = {
      initializer: function(cb) {
        var self, widgetsTypesSortMap;
        self = this;
        widgetsTypesSortMap = ['headline_h1', 'headline_h2', 'headline_h3', 'text', 'spacer', 'subscribe_form', 'image', 'video', 'button', 'list', 'timer', 'navigation', 'link', 'review', 'card', 'product', 'slider', 'gallery', 'table', 'line', 'map', 'social', 'facebook_comment', 'code'];
        return Widget.getAll().then(function(widgetsData) {
          _.each(widgetsData.widgets, function(widget) {
            var ref;
            if (ref = widget.type, indexOf.call(widgetsForForm, ref) >= 0) {
              return self.widgetList.push(widget);
            }
          });
          self.widgetList = WidgetsSortHelper.sortWidgetsByTypesSortMap(self.widgetList, widgetsTypesSortMap);
          return $timeout(function() {
            return cb();
          });
        });
      },
      defaultFonts: Font.defaults,
      widgetList: []
    };
    $rootScope.Editor = Editor;
    window.Editor = Editor;
    setGradient = function(background_attributes) {
      var color_start, color_stop, gradient_css;
      color_start = background_attributes.color_start;
      color_stop = background_attributes.color_stop;
      gradient_css = "background-image:-moz-linear-gradient(top, " + color_start + ", " + color_stop + "); background-image:-webkit-linear-gradient(top, " + color_start + ", " + color_stop + "); background-image:-o-linear-gradient(top, " + color_start + ", " + color_stop + "); background-image:-ms-linear-gradient(top, " + color_start + ", " + color_stop + ");, background-image:linear-gradient(top, " + color_start + ", " + color_stop + "); filter: progid:DXImageTransform.Microsoft.gradient(startColorStr='" + color_start + "', endColorstr='" + color_stop + "');";
      if ($("style#" + $rootScope.currentPage.id).length > 0) {
        return $("style#" + $rootScope.currentPage.id).html("#tpl-wrapper:before { " + gradient_css + " }");
      } else {
        return $('body').append("<style id='" + $rootScope.currentPage.id + "'>#tpl-wrapper:before { " + gradient_css + " }</style>");
      }
    };
    currentPage = function(site) {
      var pageId, parentPagesResult;
      currentPage = void 0;
      pageId = $state.params.pageId;
      parentPagesResult = _.filter(site.pages, {
        path: $state.params.pageId
      })[0];
      if (parentPagesResult) {
        currentPage = parentPagesResult;
      }
      site.pages.forEach(function(page) {
        return page.pages.forEach(function(pageChild) {
          if (pageChild.path === pageId) {
            return currentPage = pageChild;
          }
        });
      });
      return currentPage;
    };
    destroyWidgetsFinished = $scope.$on("widgetsFinished", function(newData) {
      return insertBlockMenu.initDD();
    });
    $scope.$on("$destroy", function() {
      unbindPreventForm();
      destroyGetStyles();
      destroyWidgetsFinished();
      Editor.destroy();
      TimeMachine.destroy();
      $rootScope.widgetIsEditing = false;
      return $scope.templateIsReady = false;
    });
    if (!$rootScope.Y) {
      YUI().use('node', 'event-valuechange', 'anim', 'dd', 'dd-proxy', 'dd-constrain', 'dd-drop', 'dd-scroll', "dd-delegate", "event-hover", "resize", "resize-plugin", "overlay", function(y) {
        $rootScope.Y = y;
        return Editor.initializer();
      });
    } else {
      Editor.initializer();
    }
    $rootScope.toggleCommonSections = function(sections) {
      var footers, headers;
      sections = Editor.getSections();
      headers = _.filter(sections, {
        section_type: "header"
      });
      footers = _.filter(sections, {
        section_type: "footer"
      });
      $scope.showFooter = !footers.length;
      $scope.showHeader = !headers.length;
      if (!$scope.$$phase) {
        return $scope.$apply();
      }
    };
    $scope.viewSite = State.viewSite;
    $scope.saveSection = editorDragPanel.cancelSection;
    $rootScope.openEditorNavPanel = function() {
      $(".etsw-header__title").text($filter('translate')('editor.addElementButton'));
      return $scope.editorNavOpen = true;
    };
    $scope.openEditorNav = function() {
      $rootScope.editorNavTab("sections");
      return $rootScope.openEditorNavPanel();
    };
    $scope.panelRight = true;
    $scope.togglePanelPosition = function() {
      return $scope.panelRight = !$scope.panelRight;
    };
    $rootScope.initWidgets = function() {
      return $rootScope.Y.all(".str-section").each(function(sectionNode) {
        sectionNode.all(".str-block").each(function(block) {
          if (block.widget && block.widget.type === 'subscribe_form') {
            SubscribeFormManager.updateOptions(block.widget);
          }
          if (block.widget && block.widget.type === 'image') {
            ImageInit.updateOptions(block.widget);
          }
          if (block.widget && block.widget.type === 'link') {
            return ButtonActionsManager.updateOptions(block.widget);
          }
        });
        return layoutEditor.updateSectionEtag(sectionNode.section);
      });
    };
    $rootScope.undo = function() {
      return $timeout(function() {
        return TimeMachine.undo();
      });
    };
    $rootScope.redo = function() {
      return $timeout(function() {
        return TimeMachine.redo();
      });
    };
    $rootScope.savePreview = function() {
      var sections;
      $scope.loading = true;
      sections = Editor.getSections();
      return SectionWebForm.saveAllSectionsAndPublishPreview(sections).then(function(response) {
        if (response.status && (response.data != null) && (response.data.preview_web_form_id != null)) {
          $scope.loading = false;
          return $rootScope.openPreview(response.data.preview_web_form_id);
        }
      }, function() {
        $scope.loading = false;
        return Notification.error({
          message: $filter('translate')('site.error')
        });
      });
    };
    $scope.publishSite = function() {
      return $timeout(function() {
        var sections;
        $scope.publishing = true;
        sections = Editor.getSections();
        return SectionWebForm.saveAllSectionsAndPublish(sections).then(function(sectionsData) {
          EditorLibrary.showBuildStatus(SectionWebForm, $scope, 'publishSite', 3000, 3000, 3);
          TimeMachine.clear();
          layoutEditor.setTemplateJSON(sectionsData);
          return $timeout(function() {
            $scope.publishing = false;
            return Notification.success({
              message: $filter('translate')('form.SuccessfullySaved')
            });
          });
        }, function() {
          $scope.publishing = false;
          return Notification.error({
            message: $filter('translate')('site.error')
          });
        });
      }, 300);
    };
    $scope.publishForm = function() {
      return $timeout(function() {
        var sections;
        $scope.publishing = true;
        sections = Editor.getSections();
        return SectionWebForm.saveAllSectionsAndPublish(sections).then(function(sectionsData) {
          EditorLibrary.showBuildStatus(SectionWebForm, $scope, 'publishForm', 3000, 3000, 3);
          TimeMachine.clear();
          layoutEditor.setTemplateJSON(sectionsData);
          $timeout(function() {
            $scope.publishing = false;
            return Notification.success({
              message: $filter('translate')('form.SuccessfullySaved')
            });
          });
          return $modal.open({
            windowTemplateUrl: "./common/templates/window.jade",
            templateUrl: "./webform/html_of_form.jade",
            windowClass: "site-settings__modal",
            size: "md",
            controller: "HtmlOfFormController"
          });
        }, function() {
          $scope.publishing = false;
          return Notification.error({
            message: $filter('translate')('site.error')
          });
        });
      }, 300);
    };
    $scope.sectionSave = function() {
      $scope.sectionSaving = true;
      layoutEditor.publicSectionSave().then(function() {
        return $scope.sectionSaving = false;
      });
    };
    return $scope.exit = function() {
      return $rootScope.alertDialog({
        title: $filter("translate")("alert.editor.exitTitle"),
        text: $filter("translate")("alert.editor.exitDescription"),
        accept_text: $filter("translate")("alert.confirm"),
        cancel_text: $filter("translate")("alert.cancel"),
        accept: function() {
          var ref;
          if ((ref = window.justclick.currentUser.role) === "admin" || ref === "superadmin") {
            return $state.go("admin.dashboard.templates");
          } else {
            return document.location.href = window.justclick.back_uri;
          }
        }
      });
    };
  }
]);


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var moduleEditorPanel;

moduleEditorPanel = angular.module('editorPanel.controller', ["api.widget", "services.layoutEditor.sectionDragDrop"]);

moduleEditorPanel.controller("EditorPanelCtrl", [
  "$scope", "$state", "$timeout", "ns", "$injector", "Section", "Site", "$cookies", "$rootScope", "Restangular", "Modal", "Template", "$sce", "State", "Page", "$filter", function($scope, $state, $timeout, ns, $injector, Section, Site, $cookies, $rootScope, Restangular, Modal, Template, $sce, State, Page, $filter) {
    $scope.currentEditorTab = "";
    $scope.currentNavEditorTab = "";
    $scope.sectionsCollection = [];
    $scope.widthType = "px";
    $scope.siteSettings = Modal.siteSettings;
    $scope.favoriteSettings = Modal.favoriteSettings;
    $scope.togglePagesSettings = function() {
      $scope.popoverOpen = !$scope.popoverOpen;
    };
    $scope.closePagesSettings = function() {
      $scope.popoverOpen = false;
    };
    $scope.pagesPopoverOpen = function() {
      $("[ng-click='togglePagesSettings()']").scope().togglePagesSettings();
    };
    $scope.concatFonts = function() {
      if (Editor.Instrumentations.fonts) {
        return Editor.Instrumentations.fonts.concat(Editor.Instrumentations.defaultFonts);
      }
    };
    $scope.state = $state;
    $scope.saveSite = function(site, siteSettingsForm) {
      if (siteSettingsForm.$invalid) {
        return false;
      }
      site = angular.copy(site);
      $scope.savingSite = true;
      return Site.update(site).then(function() {
        $scope.savingSite = false;
        applyStyleToTemplate(site);
      }, function() {
        return $scope.savingSite = false;
      });
    };
    $scope.newsPages = function() {
      if ($rootScope.site) {
        return _.filter($rootScope.site.pages, {
          type: "news"
        });
      }
    };
    $scope.shopPages = function() {
      if ($rootScope.site) {
        return _.filter($rootScope.site.pages, {
          type: "shop"
        });
      }
    };
    return $scope.getPageNameById = function(id) {
      var pages;
      pages = _.filter($rootScope.site.pages, {
        id: id
      });
      if (!id || pages.length === 0) {
        return "";
      }
      return pages[0].name;
    };
  }
]);


/***/ }),
/* 195 */
/***/ (function(module, exports) {

var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

angular.module('siter.io').controller('CreateEmailSectionModal', [
  "$scope", "$state", "$rootScope", "$modalInstance", "Restangular", "$stateParams", "Section", "$window", "FileUploader", "allEmailSections", function($scope, $state, $rootScope, $modalInstance, Restangular, $stateParams, Section, $window, FileUploader, allEmailSections) {
    var setUploadUrls;
    $scope.close = function() {
      return $modalInstance.dismiss("close");
    };
    $scope.loadTags = function(query) {
      return Restangular.all("/sections/tags?q=" + query + "&for_email=true").getList();
    };
    $scope.loadColorTags = function(query) {
      return Restangular.all("/sections/color_tags?q=" + query + "&for_email=true").getList();
    };
    $scope.section = {
      disabled: true
    };
    $scope.sectionPreviewUploader = new FileUploader({
      url: Restangular.configuration.baseUrl + ("/emails/" + $state.params.siteId),
      autoUpload: false,
      method: "PUT",
      alias: "preview",
      headers: {
        'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
      }
    });
    $scope.sectionPreviewUploader.onAfterAddingFile = function(item) {
      var ref, types;
      types = ["image/jpeg", "image/png"];
      if (ref = item.file.type, indexOf.call(types, ref) < 0) {
        alert("The file must be png or jpg");
        return false;
      }
    };
    $scope.sectionPreviewUploader.onSuccessItem = function(fileItem, response, status, headers) {
      $scope.sectionPreviewUploader.clearQueue();
    };
    $scope.sectionPreviewUploader.onErrorItem = function(fileItem, response, status, headers) {};
    setUploadUrls = function(sectionId) {
      return $scope.sectionPreviewUploader.queue.forEach(function(item) {
        return item.url = Restangular.configuration.baseUrl + ("/sections/" + sectionId);
      });
    };
    return $scope.create = function(createSectionForm, section) {
      if (createSectionForm.$invalid) {
        return false;
      }
      $scope.creating = true;
      section.tags = _.map(section.tags, function(tag) {
        return tag.name;
      });
      section.tags = section.tags.join(",");
      section.colors = _.map(section.colors, function(tag) {
        return tag.text;
      });
      section.for_email = true;
      return Section.createPublic(section).then(function(sectionData) {
        setUploadUrls(sectionData.id);
        $scope.sectionPreviewUploader.uploadAll();
        $scope.close();
        $scope.creating = false;
        return allEmailSections.push(sectionData);
      }, function() {
        return $scope.creating = false;
      });
    };
  }
]);


/***/ }),
/* 196 */
/***/ (function(module, exports) {

var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

angular.module('siter.io').controller('EditEmailSectionModal', [
  "$scope", "$state", "$rootScope", "$modalInstance", "Restangular", "$stateParams", "Section", "$window", "section", "FileUploader", function($scope, $state, $rootScope, $modalInstance, Restangular, $stateParams, Section, $window, section, FileUploader) {
    $scope.section = angular.copy(section);
    $scope.section.tags = _.map($scope.section.tags.split(","), function(tag, index) {
      return {
        name: tag,
        id: index
      };
    });
    $scope.section.colors = _.map($scope.section.colors, function(tag, index) {
      return {
        text: tag,
        id: index
      };
    });
    $scope.close = function() {
      return $modalInstance.dismiss("close");
    };
    $scope.loadTags = function(query) {
      return Restangular.all("/sections/tags?q=" + query).getList();
    };
    $scope.loadColorTags = function(query) {
      return Restangular.all("/sections/color_tags?q=" + query).getList();
    };
    $scope.sectionPreviewUploader = new FileUploader({
      url: Restangular.configuration.baseUrl + ("/sections/" + section.id),
      autoUpload: false,
      method: "PUT",
      alias: "preview",
      headers: {
        'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
      }
    });
    $scope.sectionPreviewUploader.onAfterAddingFile = function(item) {
      var ref, types;
      types = ["image/jpeg", "image/png"];
      if (ref = item.file.type, indexOf.call(types, ref) < 0) {
        alert("The file must be png or jpg");
        return false;
      }
    };
    $scope.sectionPreviewUploader.onSuccessItem = function(fileItem, response, status, headers) {
      section.preview_url = response.preview_url;
      $scope.sectionPreviewUploader.clearQueue();
    };
    $scope.sectionPreviewUploader.onErrorItem = function(fileItem, response, status, headers) {};
    return $scope.save = function(editSectionForm) {
      if (editSectionForm.$invalid) {
        return false;
      }
      $scope.updating = true;
      $scope.section.tags = _.map($scope.section.tags, function(tag) {
        return tag.text;
      });
      $scope.section.tags = $scope.section.tags.join(",");
      $scope.section.colors = _.map($scope.section.colors, function(tag) {
        return tag.text;
      });
      return Section.savePublic($scope.section).then(function(sectionData) {
        section.colors = sectionData.colors;
        section.tags = sectionData.tags;
        section.title = sectionData.title;
        section.disabled = sectionData.disabled;
        section.custom_preview_url_enabled = sectionData.custom_preview_url_enabled;
        section.custom_preview_url = sectionData.custom_preview_url;
        $scope.sectionPreviewUploader.uploadAll();
        $scope.close();
        return $scope.updating = false;
      }, function() {
        return $scope.updating = false;
      });
    };
  }
]);


/***/ }),
/* 197 */
/***/ (function(module, exports) {

var moduleAlert,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

moduleAlert = angular.module('create.email.controller', []);

moduleAlert.controller('CreateEmailModal', [
  "$scope", "$state", "$rootScope", "$modalInstance", "Restangular", "$stateParams", "Email", "$window", "FileUploader", function($scope, $state, $rootScope, $modalInstance, Restangular, $stateParams, Email, $window, FileUploader) {
    var setUploadUrls;
    $scope.close = function() {
      return $modalInstance.dismiss("close");
    };
    $scope.loadTags = function(query) {
      return Restangular.all('/emails/tags').getList();
    };
    setUploadUrls = function(emailId) {
      $scope.mobilePreviewUploader.queue.forEach(function(item) {
        return item.url = Restangular.configuration.baseUrl + ("/emails/" + emailId);
      });
      return $scope.webPreviewUploader.queue.forEach(function(item) {
        return item.url = Restangular.configuration.baseUrl + ("/emails/" + emailId);
      });
    };
    $scope.webPreviewUploader = new FileUploader({
      url: "",
      autoUpload: false,
      method: "PUT",
      alias: "preview",
      headers: {
        'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
      }
    });
    $scope.webPreviewUploader.onAfterAddingFile = function(item) {
      var ref, types;
      types = ["image/jpeg", "image/png"];
      if (ref = item.file.type, indexOf.call(types, ref) < 0) {
        alert("The file must be png or jpg");
        return false;
      }
    };
    $scope.webPreviewUploader.onSuccessItem = function(fileItem, response, status, headers) {
      $scope.webPreviewUploader.clearQueue();
      $scope.new_email.preview = response.preview;
    };
    $scope.webPreviewUploader.onErrorItem = function(fileItem, response, status, headers) {};
    $scope.mobilePreviewUploader = new FileUploader({
      url: "",
      autoUpload: false,
      method: "PUT",
      alias: "mobile_preview",
      headers: {
        'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
      }
    });
    $scope.mobilePreviewUploader.onAfterAddingFile = function(item) {
      var ref, types;
      types = ["image/jpeg", "image/png"];
      if (ref = item.file.type, indexOf.call(types, ref) < 0) {
        alert("The file must be png or jpg");
        return false;
      }
    };
    $scope.mobilePreviewUploader.onSuccessItem = function(fileItem, response, status, headers) {
      $scope.mobilePreviewUploader.clearQueue();
      $scope.new_email.mobile_preview = response.mobile_preview;
    };
    $scope.mobilePreviewUploader.onErrorItem = function(fileItem, response, status, headers) {};
    return $scope.create = function(createSectionForm, email) {
      if (createSectionForm.$invalid) {
        return false;
      }
      $scope.creating = true;
      email.tags = _.map(email.tags, function(tag) {
        return tag.text;
      });
      email.tags = email.tags.join(",");
      email.colors = _.map(email.colors, function(tag) {
        return tag.text;
      });
      email.is_template = true;
      return Email.createPublic(email).then(function(emailData) {
        $scope.new_email = emailData;
        $scope.creating = false;
        setUploadUrls(emailData.id);
        $scope.mobilePreviewUploader.uploadAll();
        $scope.webPreviewUploader.uploadAll();
        $rootScope.$broadcast("email:created", $scope.new_email);
        return $scope.close();
      }, function() {
        return $scope.creating = false;
      });
    };
  }
]);


/***/ }),
/* 198 */
/***/ (function(module, exports) {

var moduleAlert,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

moduleAlert = angular.module('edit.email.controller', []);

moduleAlert.controller('EditEmailModal', [
  "$scope", "$state", "$rootScope", "$modalInstance", "Restangular", "$stateParams", "Email", "$window", "email", "FileUploader", function($scope, $state, $rootScope, $modalInstance, Restangular, $stateParams, Email, $window, email, FileUploader) {
    $scope.email = angular.copy(email);
    $scope.email.tags = _.map($scope.email.tags.split(","), function(tag, index) {
      return {
        text: tag,
        id: index
      };
    });
    $scope.email.colors = _.map($scope.email.colors, function(tag, index) {
      return {
        text: tag,
        id: index
      };
    });
    $scope.close = function() {
      return $modalInstance.dismiss("close");
    };
    $scope.loadTags = function(query) {
      return Restangular.all("/emails/tags?q=" + query).getList();
    };
    $scope.loadColorTags = function(query) {
      return Restangular.all("/emails/color_tags?q=" + query).getList();
    };
    $scope.webPreviewUploader = new FileUploader({
      url: Restangular.configuration.baseUrl + ("/emails/" + email.id),
      autoUpload: false,
      method: "PUT",
      alias: "preview",
      headers: {
        'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
      }
    });
    $scope.webPreviewUploader.onAfterAddingFile = function(item) {
      var ref, types;
      types = ["image/jpeg", "image/png"];
      if (ref = item.file.type, indexOf.call(types, ref) < 0) {
        alert("The file must be png or jpg");
        return false;
      }
    };
    $scope.webPreviewUploader.onSuccessItem = function(fileItem, response, status, headers) {
      email.preview = response.preview;
      $scope.webPreviewUploader.clearQueue();
    };
    $scope.webPreviewUploader.onErrorItem = function(fileItem, response, status, headers) {};
    $scope.mobilePreviewUploader = new FileUploader({
      url: Restangular.configuration.baseUrl + ("/emails/" + email.id),
      autoUpload: false,
      method: "PUT",
      alias: "mobile_preview",
      headers: {
        'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
      }
    });
    $scope.mobilePreviewUploader.onAfterAddingFile = function(item) {
      var ref, types;
      types = ["image/jpeg", "image/png"];
      if (ref = item.file.type, indexOf.call(types, ref) < 0) {
        alert("The file must be png or jpg");
        return false;
      }
    };
    $scope.mobilePreviewUploader.onSuccessItem = function(fileItem, response, status, headers) {
      email.mobile_preview = response.mobile_preview;
      $scope.mobilePreviewUploader.clearQueue();
    };
    $scope.mobilePreviewUploader.onErrorItem = function(fileItem, response, status, headers) {};
    return $scope.save = function(editEmailForm) {
      if (editEmailForm.$invalid) {
        return false;
      }
      $scope.updating = true;
      $scope.email.tags = _.map($scope.email.tags, function(tag) {
        return tag.text;
      });
      $scope.email.tags = $scope.email.tags.join(",");
      $scope.email.colors = _.map($scope.email.colors, function(tag) {
        return tag.text;
      });
      return Email.savePublic($scope.email).then(function(emailData) {
        email.colors = emailData.colors;
        email.tags = emailData.tags;
        email.title = emailData.title;
        email.disabled = emailData.disabled;
        $scope.mobilePreviewUploader.uploadAll();
        $scope.webPreviewUploader.uploadAll();
        $scope.close();
        return $scope.updating = false;
      }, function() {
        return $scope.updating = false;
      });
    };
  }
]);


/***/ }),
/* 199 */
/***/ (function(module, exports) {

var addFontModuleSettings,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

addFontModuleSettings = angular.module('editor.fontSettings.controller', ["services"]);

addFontModuleSettings.controller("fontSettingsCtrl", [
  "$scope", "$rootScope", "$state", "Font", "Site", "LmsPage", "Section", "$timeout", "layoutEditor", function($scope, $rootScope, $state, Font, Site, LmsPage, Section, $timeout, layoutEditor) {
    var GFontsSuccess, addFontToEditor, clearFontsInEditorView, destroyFontsNames, destroySectionFonts, fontSettingsToArray, reBuildCKEFontList, removeFont, removeFontFromEditor, removeFontStylesCKE, updateFonts, updateFontsSuccess;
    if (!$rootScope.site_fonts && $rootScope.site) {
      $rootScope.site_fonts = {
        id: $rootScope.site.id,
        default_font: $rootScope.site.default_font,
        h_font: $rootScope.site.h_font
      };
    }
    String.prototype.replaceAll = function(search, replacement) {
      var target;
      target = this;
      return target.replace(new RegExp(search, 'g'), replacement);
    };
    $scope.fontSettings = {};
    destroyFontsNames = $rootScope.$on("fontNames:loaded", function() {
      return Font.connectFonts(Editor.Instrumentations.fonts);
    });
    destroySectionFonts = $rootScope.$on("sectionFonts:loaded", function(e, fonts) {
      return Font.connectFonts(fonts);
    });
    $scope.$on("$destroy", function() {
      destroyFontsNames();
      return destroySectionFonts();
    });
    reBuildCKEFontList = function() {
      return _.each(CKEDITOR.instances, function(instance, id) {
        return instance.ui.instances.FontFamily.buildList();
      });
    };
    removeFontStylesCKE = function(font) {
      return _.each(CKEDITOR.instances, function(instance, id) {
        return angular.element("#" + id).find("span").each(function(index, span) {
          var fontFamily, spanFamily;
          spanFamily = $(span).css("font-family").toLowerCase().replaceAll("'", "");
          fontFamily = font.family.toLowerCase();
          if (spanFamily === fontFamily) {
            return $(span).css("font-family", "");
          }
        });
      });
    };
    $scope.searchFonts = function(value) {
      var result;
      result = [];
      _.each($scope.GFonts, function(font) {
        var family, index;
        family = font.family.toLowerCase();
        index = family.indexOf(value.toLowerCase());
        if (index > -1) {
          return result.push(font);
        }
      });
      return result;
    };
    $scope.setFont = function(font, model, label, attr) {
      Font.connectFont(font);
      return $scope[attr] = font;
    };
    $scope.GFonts = [];
    $scope.destroyFonts = function() {
      return $scope.GFonts = [];
    };
    GFontsSuccess = function(gFonts) {
      var result;
      result = [];
      $scope.GFonts = _.each(gFonts.items, function(item) {
        if (indexOf.call(item.subsets, "cyrillic") >= 0) {
          return result.push(item);
        }
      });
      $scope.GFonts = _.union(result, $scope.GFonts);
      return $scope.fontsLoading = false;
    };
    $scope.getGoogleFonts = function() {
      if ($scope.GFonts.length > 0) {
        return false;
      }
      $scope.fontsLoading = true;
      return Font.getAll().then(GFontsSuccess);
    };
    $scope.$on("destroy", function() {
      log("destroy");
      return $scope.GFonts = [];
    });
    fontSettingsToArray = function(type) {
      var key, result;
      result = [];
      for (key in $scope.fontSettings[type]) {
        if ($scope.fontSettings[type][key]) {
          result.push(key);
        }
      }
      return result;
    };
    $scope.connectFont = function(font) {
      Font.connectFont(font);
      return $scope.fontName = "";
    };
    addFontToEditor = function(font) {
      var Editor;
      $rootScope.Editor.Instrumentations.fonts.push(font);
      reBuildCKEFontList();
      Editor = $rootScope.Editor;
      $scope.selectedFont = {};
      return $scope.fontSettings = {};
    };
    updateFontsSuccess = function(fontData) {
      var font;
      font = fontData.fonts_attributes[fontData.fonts_attributes.length - 1];
      Font.connectFont(font);
      addFontToEditor(font);
      return $scope.adding = false;
    };
    updateFonts = function(font) {
      var data;
      $scope.adding = true;
      if (Editor.mode === "site.page.editor") {
        Site.updateByRoute({
          fonts_attributes: [font]
        }).then(updateFontsSuccess);
      }
      if (Editor.mode === "lesson.page.editor") {
        LmsPage.updateByRoute({
          fonts_attributes: [font]
        }).then(updateFontsSuccess);
      }
      if (Editor.mode === "editor.section") {
        data = {
          fonts_attributes: [font],
          id: $state.params.sectionId
        };
        return Section.savePublic(data).then(updateFontsSuccess);
      }
    };
    $scope.addFont = function(selectedFont) {
      var font, fontExist;
      font = {};
      $scope.selectedFont = selectedFont;
      font.family = selectedFont.family;
      font.variants = fontSettingsToArray("variants");
      font.subsets = fontSettingsToArray("subsets");
      fontExist = _.filter($rootScope.Editor.Instrumentations.fonts, {
        family: selectedFont.family
      });
      if (fontExist.length === 0) {
        return updateFonts(font);
      }
    };
    $scope.customAddFont = function(selectedFont, attr, variants_attr) {
      var font, fontExist;
      font = {};
      $scope[attr] = selectedFont;
      font.family = selectedFont.family;
      font["variants"] = fontSettingsToArray(variants_attr);
      font.subsets = fontSettingsToArray("subsets");
      fontExist = _.filter($rootScope.Editor.Instrumentations.fonts, {
        family: selectedFont.family
      });
      if (fontExist.length === 0) {
        return updateFonts(font);
      }
    };
    clearFontsInEditorView = function(default_font, default_h) {
      $('#tpl-wrapper *').filter(function() {
        if ($(this).attr("style")) {
          if ($(this).attr('style').indexOf('font-family') > -1) {
            $(this).css({
              fontFamily: ""
            });
          }
        }
        if ($(this).prop("tagName") === "FONT") {
          return $(this).removeAttr("face");
        }
      });
      return layoutEditor.setFontToJsonWidgets($rootScope.Y, {
        "default": default_font,
        h: default_h
      });
    };
    $scope.setHFont = function(selectedFont) {
      selectedFont = angular.copy(selectedFont);
      $scope.customAddFont(selectedFont, 'selectedHFont', "h_variants");
      $rootScope.site_fonts.h_font = selectedFont;
      $("#fontStyles").html($("#fontStyles").html() + ("h1,h2,h3,h4,h5,h6 {font-family: " + selectedFont.family + "}"));
      clearFontsInEditorView($rootScope.site_fonts.default_font.family, $rootScope.site_fonts.h_font.family);
      return $rootScope.defaultFontSetted = true;
    };
    $scope.setDefaultFont = function(selectedFont) {
      selectedFont = angular.copy(selectedFont);
      $scope.customAddFont(selectedFont, 'selectedDefaultFont', "default_variants");
      $rootScope.site_fonts.default_font = selectedFont;
      $("#fontStyles").html($("#fontStyles").html() + (".str-wrapper {font-family: " + selectedFont.family + "} .str-wrapper .strwf_button {font-family: " + selectedFont.family + "}"));
      clearFontsInEditorView($rootScope.site_fonts.default_font.family, $rootScope.site_fonts.h_font.family);
      $rootScope.defaultFontSetted = true;
    };
    removeFontFromEditor = function(font) {
      var Editor, find, index;
      find = _.filter($rootScope.Editor.Instrumentations.fonts, {
        family: font.family
      });
      index = $rootScope.Editor.Instrumentations.fonts.indexOf(find[0]);
      if (index > -1) {
        $rootScope.Editor.Instrumentations.fonts.splice(index, 1);
      }
      Editor = $rootScope.Editor;
      reBuildCKEFontList();
      return removeFontStylesCKE(font);
    };
    $scope.removeHFont = function(font) {
      font = angular.copy(font);
      if (font) {
        font.family = "";
        font.variants = [];
        font.subsets = [];
      }
      $rootScope.site_fonts.h_font = {};
      $rootScope.defaultFontSetted = true;
      $("#fontStyles").html($("#fontStyles").html() + "h1,h2,h3,h4,h5,h6 {font-family: Open Sans}");
      clearFontsInEditorView($rootScope.site_fonts.default_font.family, $rootScope.site_fonts.h_font.family);
    };
    $scope.removeDefaultFont = function(font) {
      font = angular.copy(font);
      if (font) {
        font.family = "";
        font.variants = [];
        font.subsets = [];
      }
      $rootScope.site_fonts.default_font = {};
      $rootScope.defaultFontSetted = true;
      $("#fontStyles").html($("#fontStyles").html() + ".str-wrapper {font-family: Open Sans} .strwf_button {font-family: Open Sans}");
      clearFontsInEditorView($rootScope.site_fonts.default_font.family, $rootScope.site_fonts.h_font.family);
    };
    removeFont = function(font) {
      var data;
      font._destroy = true;
      font = angular.copy(font);
      if (Editor.mode === "site.page.editor") {
        Site.updateByRoute({
          fonts_attributes: [font]
        }).then(function() {
          return removeFontFromEditor(font);
        });
      }
      if (Editor.mode === "lesson.page.editor") {
        LmsPage.updateByRoute({
          fonts_attributes: [font]
        }).then(function() {
          return removeFontFromEditor(font);
        });
      }
      if (Editor.mode === "editor.section") {
        data = {
          fonts_attributes: [font],
          id: $state.params.sectionId
        };
        return Section.savePublic(data).then(function() {
          return removeFontFromEditor(font);
        });
      }
    };
    return $scope.removeFont = function(font) {
      if ($rootScope.site_fonts.default_font && font.family === $rootScope.site_fonts.default_font.family) {
        $scope.removeDefaultFont(font);
      } else if ($rootScope.site_fonts.h_font && font.family === $rootScope.site_fonts.h_font.family) {
        $scope.removeHFont(font);
      }
      return removeFont(font);
    };
  }
]);


/***/ }),
/* 200 */
/***/ (function(module, exports) {

angular.module("editor", ["api", "services", "modulesSettings", "editor.controller", "editorEmail.controller", "editorForm.controller", "editorLesson.controller", "editorPanel.controller", "editorNavigation.controller", "editorNavigationSections.controller", "pagesSettings.controller", "editor.modulesSettings.controller", "editor.fontSettings.controller", "alert.controller", "create.email.controller", "edit.email.controller", "create.section.controller", "create_favorite.section.controller", "edit.link.controller", "create.link.controller", "update.link.controller"]);


/***/ }),
/* 201 */
/***/ (function(module, exports) {

var alignDirectiveModule;

alignDirectiveModule = angular.module('align.setting', []);

alignDirectiveModule.directive("aligmentSetting", [
  "$window", "$timeout", "$compile", "$templateCache", function($window, $timeout, $compile, $templateCache) {
    return {
      restrict: "A",
      scope: {
        data: "=ngModel"
      },
      templateUrl: settingFolder + "/alignment/template.jade",
      link: function(scope, element, attrs, ngModel) {
        var listener;
        if (!scope.data) {
          scope.data = "left";
        }
        scope.textAlign = scope.data;
        listener = scope.$watch("textAlign", function(newVal) {
          return scope.data = newVal;
        });
        return scope.$on("$destroy", function() {
          return listener();
        });
      }
    };
  }
]);


/***/ }),
/* 202 */
/***/ (function(module, exports) {

var bgFieldsDirective;

bgFieldsDirective = angular.module('bgfields.setting', []);

bgFieldsDirective.directive("bgFieldsSetting", [
  "$window", "$timeout", "$compile", "$templateCache", "ns", "translitService", "Widget", "blockEditDialog", "Section", "Email", function($window, $timeout, $compile, $templateCache, ns, translitService, Widget, blockEditDialog, Section, Email) {
    return {
      restrict: "A",
      scope: {
        data: "=ngModel"
      },
      templateUrl: settingFolder + "/bgfields/template.jade",
      link: function(scope, element, attrs, ngModel) {
        var getNotDestroyedFieldRnd, id, listener1, sectionElement;
        id = attrs.sectionId;
        sectionElement = angular.element("[data-section-id=" + id + "]").find(ns.widgetWrapperClass);
        scope.section = angular.copy(scope.data);
        scope.refresh = true;
        scope.from_email = attrs.fromEmail;
        getNotDestroyedFieldRnd = function() {
          var fields;
          fields = [];
          _.each(scope.section.background_attributes.images_attributes, function(field, index) {
            if (!field._destroy) {
              return fields.push(index);
            }
          });
          if (fields.length > 0) {
            return fields[fields.length - 1];
          } else {
            return 0;
          }
        };
        scope.currentField = getNotDestroyedFieldRnd();
        scope.fieldsLength = function(fields) {
          var destroyed;
          destroyed = _.filter(fields, {
            _destroy: true
          });
          return fields.length - destroyed.length;
        };
        scope.setCurrentImage = function($index) {
          scope.currentField = $index;
          scope.refresh = false;
          return $timeout(function() {
            return scope.refresh = true;
          });
        };
        scope.add = function() {
          var length, sectionId;
          sectionId = id;
          scope.section.background_attributes.images_attributes.push({
            source_url: ""
          });
          length = scope.section.background_attributes.images_attributes.length - 1;
          return scope.setCurrentImage(length);
        };
        scope.remove = function() {
          var imageId;
          imageId = scope.section.background_attributes.images_attributes[scope.currentField].id;
          if (imageId) {
            if (scope.from_email) {
              return Email.destoyItem(scope.section, imageId).then(function() {
                scope.data.background_attributes.images_attributes.splice(scope.currentField, 1);
                return scope.setCurrentImage(getNotDestroyedFieldRnd());
              });
            } else {
              return Section.destoyItem(scope.section, imageId).then(function() {
                scope.data.background_attributes.images_attributes.splice(scope.currentField, 1);
                return scope.setCurrentImage(getNotDestroyedFieldRnd());
              });
            }
          } else {
            return scope.data.background_attributes.images_attributes.splice(scope.currentField, 1);
          }
        };
        listener1 = scope.$watch("section.background_attributes.images_attributes", function(newVal, oldVal) {
          return scope.data.background_attributes.images_attributes = newVal;
        }, true);
        return scope.$on("$destroy", function() {
          return listener1();
        });
      }
    };
  }
]);


/***/ }),
/* 203 */
/***/ (function(module, exports) {

var borderDirectiveModule;

borderDirectiveModule = angular.module('border.setting', []);

borderDirectiveModule.directive("borderSetting", [
  "$window", "$timeout", "$compile", "$templateCache", "translitService", "editorDragPanel", function($window, $timeout, $compile, $templateCache, translitService, editorDragPanel) {
    return {
      restrict: "A",
      scope: {
        data: "=ngModel",
        afterChange: '&'
      },
      templateUrl: settingFolder + "/border/template.jade",
      link: function(scope, element, attrs, ngModel) {
        var borderSplit, listener;
        scope.borderStyle = [
          {
            style: "solid",
            name: "Solid",
            title: "modulesSettings.borderStyle1"
          }, {
            style: "dotted",
            name: "Dotted",
            title: "modulesSettings.borderStyle2"
          }, {
            style: "dashed",
            name: "Dashed",
            title: "modulesSettings.borderStyle3"
          }, {
            style: "double",
            name: "Double",
            title: "modulesSettings.borderStyle4"
          }, {
            style: "groove",
            name: "Groove",
            title: "modulesSettings.borderStyle5"
          }, {
            style: "ridge",
            name: "Ridge",
            title: "modulesSettings.borderStyle6"
          }, {
            style: "inset",
            name: "Inset",
            title: "modulesSettings.borderStyle7"
          }, {
            style: "outset",
            name: "Outset",
            title: "modulesSettings.borderStyle8"
          }
        ];
        if (!scope.data) {
          scope.data = "0px solid rgba(255, 255, 255, 1)";
        }
        borderSplit = scope.data.split(" ", 2);
        scope.border = {
          width: parseInt(borderSplit[0]),
          style: borderSplit[1],
          color: scope.data.split(" ").slice(2).join(" ")
        };
        listener = scope.$watch("border", function(newVal, oldVal) {
          scope.data = newVal.width + " " + newVal.style + " " + newVal.color;
          if (scope.afterChange) {
            return scope.afterChange();
          }
        }, true);
        return scope.$on("$destroy", function() {
          return listener();
        });
      }
    };
  }
]);


/***/ }),
/* 204 */
/***/ (function(module, exports) {

var cardSettingModule;

cardSettingModule = angular.module('card.setting', []);

cardSettingModule.directive("cardSetting", [
  "$window", "$timeout", "$compile", "$templateCache", "ns", "$rootScope", function($window, $timeout, $compile, $templateCache, ns, $rootScope) {
    return {
      restrict: "A",
      scope: {
        data: "=ngModel"
      },
      link: function(scope, element, attrs, ngModel) {
        var button, desc, descWrapper, imageDefaultCap, imageSizeWrapper, imageWrapper, listener, price, setButton, setDesc, setImage, setPrice, setSiterWidget, setTitle, title, widgetEl, wrapper;
        widgetEl = angular.element("[data-block-id='" + attrs.widgetId + "']");
        widgetEl.find("a").attr("href", "#");
        wrapper = widgetEl.find(".strwcrd");
        imageSizeWrapper = widgetEl.find(".strwcrd__image-size");
        imageWrapper = widgetEl.find(".strwcrd__image-wrapper");
        imageDefaultCap = widgetEl.find(".default-cap");
        title = widgetEl.find(".strwcrd__title");
        price = widgetEl.find(".strwcrd__price");
        descWrapper = widgetEl.find(".strwcrd__desc-wrapper");
        desc = widgetEl.find(".strwcrd__desc");
        button = widgetEl.find(".strwcrd__button");
        widgetEl.find(".strwcrd-link__nodecoration").attr("href", "javascript: void(0)");
        widgetEl.find(".strwcrd-link__nodecoration").removeAttr("target");
        setSiterWidget = function(newval) {
          return wrapper.css(newval.wrapper_style);
        };
        setImage = function(newval) {
          var image, imageTag;
          if (!newval.show_image) {
            imageSizeWrapper.css('display', 'none');
          } else {
            imageSizeWrapper.css('display', 'block');
          }
          if (newval.image_attributes.source_url) {
            if (imageDefaultCap.length) {
              imageDefaultCap.remove();
              if (newval.image_attributes.stretch) {
                imageTag = "<div class='strwcrd__image strwcrd__image_cover' style='background-image: url(" + newval.image_attributes.source_url + ")'></div>";
              } else {
                imageTag = "<img class='strwcrd__image' src='" + newval.image_attributes.source_url + "' alt='" + newval.title + "'>";
              }
              imageWrapper.prepend("" + imageTag);
              image = imageSizeWrapper.find(".strwcrd__image");
            } else {
              image = imageSizeWrapper.find(".strwcrd__image");
              if (newval.image_attributes.stretch) {
                image.attr('style', "background-image: url(" + newval.image_attributes.source_url + ")");
              } else {
                image.attr('src', newval.image_attributes.source_url);
              }
            }
            if (newval.image_attributes.stretch) {
              image = widgetEl.find(".strwcrd__image");
              image.remove();
              imageWrapper.prepend("<div class='strwcrd__image strwcrd__image_cover' style='background-image: url(" + newval.image_attributes.source_url + ")'></div>");
            } else {
              image = widgetEl.find(".strwcrd__image");
              image.remove();
              imageWrapper.prepend("<img class='strwcrd__image' src='" + newval.image_attributes.source_url + "' alt='" + newval.title + "'>");
            }
          } else {
            if (newval.image_attributes.stretch) {
              imageDefaultCap.css({
                'width': '100%'
              });
            } else {
              imageDefaultCap.css({
                'width': ''
              });
            }
          }
          imageSizeWrapper.css({
            'height': newval.image_wrapper_height
          });
          scope.data.image_style.backgroundPosition = "center";
          scope.data.image_style.height = newval.image_wrapper_height;
          return imageWrapper.css(newval.image_style);
        };
        setTitle = function(newval) {
          var templateTitle;
          if (!newval.show_title) {
            title.css('display', 'none');
          } else {
            if (title) {
              title.css('display', 'block');
            } else {
              templateTitle = "<span class='strwcrd__title' style='font-size: " + newval.title_style.fontSize + "; color: " + newval.title_style.color + "; margin: " + newval.title_style.margin + "'>" + newval.title + "</span>";
              if (imageSizeWrapper) {
                imageSizeWrapper.after(templateTitle);
              } else {
                wrapper.prepend(templateTitle);
              }
              title = widgetEl.find(".strwcrd__title");
            }
          }
          return title.css(newval.title_style);
        };
        setPrice = function(newval) {
          var templatePrice;
          if (!newval.show_price) {
            price.css('display', 'none');
          } else {
            if (price) {
              price.css('display', 'block');
            } else {
              templatePrice = "<span class='strwcrd__price' style='font-size: " + newval.price_style.fontSize + "; color: " + newval.price_style.color + "; margin: " + newval.price_margin + "'>" + newval.price + "</span>";
              if (title) {
                title.after(templatePrice);
              } else if (imageSizeWrapper) {
                imageSizeWrapper.after(templatePrice);
              } else {
                wrapper.prepend(templatePrice);
              }
              price = widgetEl.find(".strwcrd__price");
            }
          }
          return price.css(newval.price_style);
        };
        setDesc = function(newval) {
          var templateDesc;
          if (!newval.show_description) {
            desc.css('display', 'none');
          } else {
            if (desc) {
              desc.css('display', 'block');
            } else {
              templateDesc = "<div class='strwcrd__desc-wrapper' style='height: " + newval.description_wrapper_height + ";'><span class='strwcrd__desc' style='font-size: " + newval.description_style.fontSize + "; color: " + newval.description_style.color + "; margin: " + newval.description_style.margin + "'>" + newval.description + "</span></div>";
              if (title) {
                title.after(templateDesc);
              } else if (imageSizeWrapper) {
                imageSizeWrapper.after(templateDesc);
              } else if (price) {
                price.after(templateDesc);
              } else {
                wrapper.prepend(templateDesc);
              }
              descWrapper = widgetEl.find(".strwcrd__desc-wrapper");
              desc = widgetEl.find(".strwcrd__desc");
            }
          }
          descWrapper.css({
            'height': newval.description_wrapper_height
          });
          return desc.css(newval.description_style);
        };
        setButton = function(newval) {
          var templateButton;
          if (!newval.show_button) {
            button.css('display', 'none');
          } else {
            if (button) {
              button.css('display', 'inline-block');
            } else {
              templateButton = "<a class='strwcrd__button' href='" + newval.button_attributes.link_href + "' style='background-color: " + newval.button_attributes.style_attributes.backgroundColor + "; border: " + newval.button_attributes.style_attributes.border + "; border-radius: " + newval.button_attributes.style_attributes.borderRadius + "; padding: " + newval.button_attributes.style_attributes.padding + "; font-size: " + newval.button_attributes.style_attributes.fontSize + "; color: " + newval.button_attributes.style_attributes.color + "; margin: " + newval.button_attributes.margin + "'>" + newval.button_attributes.value + "</a>";
              if (title) {
                title.after(templateButton);
              } else if (imageSizeWrapper) {
                imageSizeWrapper.after(templateButton);
              } else if (price) {
                price.after(templateButton);
              } else if (desc) {
                desc.after(templateButton);
              } else {
                wrapper.prepend(templateButton);
              }
              button = widgetEl.find(".strwcrd__button");
            }
          }
          button.css(newval.button_attributes.style_attributes);
          if (newval.button_attributes.target_blank) {
            button.attr("target", "_blank");
          }
          if (newval.button_attributes.click_action === 'open_link') {
            return button.attr('href', newval.button_attributes.link_href);
          } else {
            return button.addClass('link-anchor').attr('href', "#" + newval.button_attributes.scroll_section_id);
          }
        };
        listener = scope.$watch("data", function(newval, oldval) {
          if (newval === oldval) {
            return false;
          }
          setSiterWidget(newval);
          setTitle(newval);
          setImage(newval);
          setPrice(newval);
          setDesc(newval);
          setButton(newval);
        }, true);
        return scope.$on("$destroy", function() {
          return listener();
        });
      }
    };
  }
]);


/***/ }),
/* 205 */
/***/ (function(module, exports) {

angular.module("colorpicker.setting", ["minicolors", "color.setting"]);


/***/ }),
/* 206 */
/***/ (function(module, exports) {

var colorsDirectiveModule;

colorsDirectiveModule = angular.module('colors.setting', []);

colorsDirectiveModule.directive("colorsSetting", [
  "$window", "$timeout", "$compile", "$templateCache", function($window, $timeout, $compile, $templateCache) {
    return {
      restrict: "A",
      scope: {
        data: "=ngModel",
        afterChange: '&'
      },
      templateUrl: settingFolder + "/colors/template.jade",
      link: function(scope, element, attrs, ngModel) {
        scope.colors = [
          {
            color: "rgba(74, 144, 226, 1)"
          }, {
            color: "rgba(27, 165, 66, 1)"
          }, {
            color: "rgba(208, 2, 27, 1)"
          }, {
            color: "rgba(144, 19, 254, 1)"
          }, {
            color: "rgba(189, 1, 175, 1)"
          }, {
            color: "rgba(248, 231, 28, 1)"
          }, {
            color: "rgba(0, 0, 0, 1)"
          }, {
            color: "rgba(155, 155, 155, 1)"
          }, {
            color: "rgba(255, 255, 255, 1)"
          }, {
            color: "rgba(245, 166, 35, 1)"
          }
        ];
        return scope.setColor = function(color) {
          var attributesForSet, c, i, len, ref, ref1;
          if ((ref = color.color) === "rgba(248, 231, 28, 1)" || ref === "rgba(255, 255, 255, 1)") {
            scope.data.color = "rgba(0, 0, 0, 1)";
          } else {
            scope.data.color = "rgba(255, 255, 255, 1)";
          }
          if (attrs.setAttributes) {
            attributesForSet = attrs.setAttributes.split(" ");
            _.each(attributesForSet, function(attribute) {
              return scope.data[attribute] = color.color;
            });
          }
          ref1 = scope.colors;
          for (i = 0, len = ref1.length; i < len; i++) {
            c = ref1[i];
            c.active = false;
          }
          return color.active = true;
        };
      }
    };
  }
]);


/***/ }),
/* 207 */
/***/ (function(module, exports) {

var formDirective;

formDirective = angular.module('form.setting', []);

formDirective.directive("formSetting", [
  "$window", "$timeout", "$compile", "$templateCache", "ns", "translitService", "$rootScope", "$filter", function($window, $timeout, $compile, $templateCache, ns, translitService, $rootScope, $filter) {
    return {
      restrict: "A",
      scope: {
        data: "=ngModel"
      },
      link: function(scope, element, attrs, ngModel) {
        var changeFormTimeout, changeFormType, changeFrameHeight, changeUtm, generateUrl, getProductsArray, id, listeners, oldCategories, orderFields, productChoosed, renderFrameForm, resizeFrameForm, rgba2hex, setSelectedFirstProduct, setSelectedOldProducts, widgetElWrapper;
        id = attrs.widgetId;
        widgetElWrapper = angular.element("[data-block-id=" + id + "]").find(ns.widgetWrapperClass);
        scope.data.disable_form_settings = window.justclick.disableFormSettings;
        scope.data.override_form_action = window.justclick.overrideFormAction;
        scope.accordion = {
          show_form: false,
          show_parent_button: false,
          show_button: false,
          show_action: false
        };
        orderFields = [
          {
            id: "fxc1",
            title: $filter('translate')('widget.form.orderField1'),
            name: "show_kupon",
            exist: false
          }, {
            id: "fxc2",
            title: $filter('translate')('widget.form.orderField2'),
            name: "surname",
            exist: false
          }, {
            id: "fxc3",
            title: $filter('translate')('widget.form.orderField3'),
            name: "otchestvo",
            exist: false
          }, {
            id: "fxc4",
            title: $filter('translate')('widget.form.orderField4'),
            name: "phone",
            exist: false
          }, {
            id: "fxc5",
            title: $filter('translate')('widget.form.orderField5'),
            name: "country",
            exist: false
          }, {
            id: "fxc6",
            title: $filter('translate')('widget.form.orderField6'),
            name: "region",
            exist: false
          }, {
            id: "fxc7",
            title: $filter('translate')('widget.form.orderField7'),
            name: "city",
            exist: false
          }, {
            id: "fxc8",
            title: $filter('translate')('widget.form.orderField8'),
            name: "address",
            exist: false
          }, {
            id: "fxc9",
            title: $filter('translate')('widget.form.orderField9'),
            name: "postal",
            exist: false
          }, {
            id: "fxc10",
            title: $filter('translate')('widget.form.orderField10'),
            name: "comment",
            exist: false
          }, {
            id: "fxc11",
            title: $filter('translate')('widget.form.orderField11'),
            name: "offerta",
            exist: false
          }
        ];
        if (scope.data.frame_settings.order_fields.length === 0) {
          scope.data.frame_settings.order_fields = orderFields;
        }
        rgba2hex = function(rgba) {
          var hexResult, opacity, rgb, rgbaStringArray;
          rgbaStringArray = rgba.match(/[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s]?([\d.]+)[\s+]?/g);
          if (rgbaStringArray === null) {
            return [rgba, 1];
          } else {
            rgb = rgbaStringArray[0].split(', ');
            opacity = rgb[3];
            hexResult = rgb && rgb.length === 4 ? '#' + ('0' + parseInt(rgb[0], 10).toString(16)).slice(-2) + ('0' + parseInt(rgb[1], 10).toString(16)).slice(-2) + ('0' + parseInt(rgb[2], 10).toString(16)).slice(-2) : '';
            return [hexResult.replace("#", ""), opacity];
          }
        };
        resizeFrameForm = function(count) {
          if (widgetElWrapper.find("iframe")[0]) {
            scope.data.frame_settings.frame_height = widgetElWrapper.find("iframe")[0].contentWindow.document.body.offsetHeight;
            return widgetElWrapper.find(".frame-form").css("height", scope.data.frame_settings.frame_height);
          }
        };
        getProductsArray = function(goods) {
          var productsArr;
          productsArr = [];
          _.each(goods, function(good) {
            if (good.hasOwnProperty("name") && good.selected) {
              productsArr.push(good.name);
            }
            if (good.hasOwnProperty("goods") && good.goods.length > 0) {
              return productsArr = productsArr.concat(getProductsArray(good.goods));
            }
          });
          return productsArr;
        };
        generateUrl = function() {
          var color, field, fieldsArr, fieldsString, i, len, offertField, productsString, ref, url, width;
          productsString = getProductsArray(scope.data.frame_settings.products).join(":");
          fieldsArr = [];
          ref = scope.data.frame_settings.order_fields;
          for (i = 0, len = ref.length; i < len; i++) {
            field = ref[i];
            if (field.exist) {
              fieldsArr.push(field.name);
            }
          }
          fieldsString = fieldsArr.join(",");
          if (scope.data.frame_settings.frame_form_color) {
            color = rgba2hex(scope.data.frame_settings.frame_form_color);
          }
          url = document.location.origin + "/order_form/?goods=" + productsString + "&required=" + fieldsString + "&btn_css=" + scope.data.frame_settings.frame_button_size + " " + scope.data.frame_settings.frame_button_color + "&button=" + scope.data.frame_settings.frame_button_value + "&font=" + (parseInt(scope.data.frame_settings.font_size)) + "&tag=" + scope.data.frame_settings.tag + "&kupon=" + scope.data.frame_settings.kupon;
          if (scope.data.frame_settings.button_type === "custom") {
            url += "&image=" + scope.data.image_attributes.source_url;
          }
          if (scope.data.frame_settings.frame_form_color) {
            url += "&color=" + color[0];
          }
          offertField = _.filter(scope.data.frame_settings.order_fields, {
            name: "offerta"
          })[0];
          if (offertField.exist) {
            url += "&offerta=" + scope.data.frame_settings.offert_url;
          }
          if (scope.data.frame_settings.utm) {
            if (scope.data.frame_settings.utm.ad_utm_medium === "other") {
              url += "&utm[utm_medium]=" + scope.data.frame_settings.utm.ad_other_utm_medium;
            } else if (scope.data.frame_settings.utm.ad_utm_medium) {
              url += "&utm[utm_medium]=" + scope.data.frame_settings.utm.ad_utm_medium;
            }
            if (scope.data.frame_settings.utm.ad_utm_source) {
              url += "&utm[utm_source]=" + scope.data.frame_settings.utm.ad_utm_source;
            }
            if (scope.data.frame_settings.utm.ad_utm_campaign) {
              url += "&utm[utm_campaign]=" + scope.data.frame_settings.utm.ad_utm_campaign;
            }
            if (scope.data.frame_settings.utm.ad_utm_content) {
              url += "&utm[utm_content]=" + scope.data.frame_settings.utm.ad_utm_content;
            }
            if (scope.data.frame_settings.utm.ad_utm_term) {
              url += "&utm[utm_term]=" + scope.data.frame_settings.utm.ad_utm_term;
            }
          }
          width = widgetElWrapper.find("iframe").width() || widgetElWrapper.parents(".str-col").width();
          url += "&width=" + (width - 70) + "&btn_width=" + (width - 70);
          scope.data.frame_settings.frame_url = url;
          if (offertField.exist) {
            return url + ("&__parent=" + document.location.origin + "/shops/bills/formcode/");
          } else {
            return url;
          }
        };
        productChoosed = function() {
          var category, group, i, index, j, len, len1, ref, ref1, selectedArray;
          selectedArray = [];
          ref = scope.data.frame_settings.products;
          for (i = 0, len = ref.length; i < len; i++) {
            category = ref[i];
            ref1 = category.goods;
            for (index = j = 0, len1 = ref1.length; j < len1; index = ++j) {
              group = ref1[index];
              if (group.selected) {
                selectedArray.push(group);
              }
            }
          }
          return selectedArray.length > 0;
        };
        renderFrameForm = function(newVal, oldVal) {
          var frameUrl;
          if (newVal == null) {
            newVal = false;
          }
          if (oldVal == null) {
            oldVal = false;
          }
          if (scope.data.form_type === "subscription") {
            return false;
          }
          if (newVal && oldVal) {
            if (newVal === oldVal) {
              return false;
            }
          }
          frameUrl = generateUrl();
          widgetElWrapper.find("iframe").unbind("load");
          widgetElWrapper.find("iframe").on("load", function() {
            if (scope.data.frame_settings.autoheight) {
              return resizeFrameForm();
            }
          });
          if (widgetElWrapper.find("iframe").length === 0) {
            return widgetElWrapper.html("<div class='frame-form' style='height: " + scope.data.frame_settings.frame_height + "px'><iframe style='width: 100%;height:100%;' src='" + frameUrl + "'></iframe><div class='frame-form__overlay'></div>");
          } else {
            return widgetElWrapper.find("iframe").attr("src", frameUrl);
          }
        };
        scope.renderFrameForm = renderFrameForm;
        changeFormTimeout = function() {
          $timeout.cancel(scope.renderFormTimeout);
          return scope.renderFormTimeout = $timeout(function() {
            return renderFrameForm();
          }, 1000);
        };
        changeFormType = function(newType) {
          var formhtml;
          formhtml = "<div class='strwf__form strwf__form-wrapper-" + id + "'><form id='" + id + "'></form></div>";
          if (newType === "subscription") {
            widgetElWrapper.html(formhtml);
          }
          return renderFrameForm();
        };
        setSelectedFirstProduct = function(products) {
          var category, good, i, index, len, results;
          results = [];
          for (index = i = 0, len = products.length; i < len; index = ++i) {
            category = products[index];
            if (index === 0) {
              if (category.hasOwnProperty("goods")) {
                results.push((function() {
                  var j, len1, ref, results1;
                  ref = category.goods;
                  results1 = [];
                  for (index = j = 0, len1 = ref.length; j < len1; index = ++j) {
                    good = ref[index];
                    good.selected = true;
                    if (good.hasOwnProperty("goods") && good.goods.length) {
                      results1.push(setSelectedFirstProduct(good.goods));
                    } else {
                      results1.push(void 0);
                    }
                  }
                  return results1;
                })());
              } else {
                results.push(category.selected = true);
              }
            } else {
              results.push(void 0);
            }
          }
          return results;
        };
        setSelectedOldProducts = function(oldCategories, goods) {
          var good, i, index, len, oldCategory, results;
          results = [];
          for (index = i = 0, len = goods.length; i < len; index = ++i) {
            good = goods[index];
            results.push((function() {
              var j, len1, results1;
              results1 = [];
              for (j = 0, len1 = oldCategories.length; j < len1; j++) {
                oldCategory = oldCategories[j];
                if (oldCategory.title === good.title && oldCategory.selected) {
                  good.selected = true;
                }
                if (oldCategory.goods && oldCategory.goods.length > 0 && good.goods && good.goods.length > 0) {
                  results1.push(setSelectedOldProducts(oldCategory.goods, good.goods));
                } else {
                  results1.push(void 0);
                }
              }
              return results1;
            })());
          }
          return results;
        };
        if (scope.data.frame_settings.products && scope.data.frame_settings.products.length === 0) {
          scope.data.frame_settings.products = angular.copy(window.justclick.groups);
          setSelectedFirstProduct(scope.data.frame_settings.products);
        } else {
          oldCategories = angular.copy(scope.data.frame_settings.products);
          scope.data.frame_settings.products = angular.copy(window.justclick.groups);
          setSelectedOldProducts(oldCategories, scope.data.frame_settings.products);
        }
        changeFrameHeight = function(newVal) {
          return widgetElWrapper.find(".frame-form").css("height", newVal);
        };
        changeUtm = function() {
          return scope.data.frame_settings.frame_url = generateUrl();
        };
        listeners = [];
        listeners.push(scope.$watch("data.form_type", changeFormType));
        listeners.push(scope.$watch("data.frame_settings.products", renderFrameForm, true));
        listeners.push(scope.$watch("data.frame_settings.order_fields", renderFrameForm, true));
        listeners.push(scope.$watch("data.frame_settings.frame_button_color", renderFrameForm, true));
        listeners.push(scope.$watch("data.frame_settings.frame_button_value", changeFormTimeout, true));
        listeners.push(scope.$watch("data.frame_settings.frame_button_size", renderFrameForm, true));
        listeners.push(scope.$watch("data.image_attributes", renderFrameForm, true));
        listeners.push(scope.$watch("data.frame_settings.button_type", renderFrameForm, true));
        listeners.push(scope.$watch("data.frame_settings.frame_form_color", changeFormTimeout, true));
        listeners.push(scope.$watch("data.frame_settings.font_size", changeFormTimeout, true));
        listeners.push(scope.$watch("data.frame_settings.frame_height", changeFrameHeight, true));
        listeners.push(scope.$watch("data.frame_settings.utm", changeUtm, true));
        listeners.push(scope.$watch("data.frame_settings.autoheight", resizeFrameForm, true));
        listeners.push(scope.$watch("data.frame_settings.offert_url", renderFrameForm, true));
        return scope.$on("$destroy", function() {
          return _.each(listeners, function(listener) {
            return listener();
          });
        });
      }
    };
  }
]);


/***/ }),
/* 208 */
/***/ (function(module, exports) {

var formFieldsDirective,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

formFieldsDirective = angular.module('formfields.setting', []);

formFieldsDirective.filter('toArray', [
  "$timeout", function($timeout) {
    return function(obj) {
      var result;
      result = [];
      _.each(obj, function(val, hash) {
        return result.push({
          name: val,
          value: hash
        });
      });
      return result;
    };
  }
]);

formFieldsDirective.directive("formFieldsSetting", [
  "$window", "$timeout", "$compile", "$templateCache", "ns", "translitService", "ContentEditable", "Widget", "blockEditDialog", "$rootScope", "$filter", function($window, $timeout, $compile, $templateCache, ns, translitService, ContentEditable, Widget, blockEditDialog, $rootScope, $filter) {
    return {
      restrict: "A",
      scope: {
        data: "=ngModel"
      },
      templateUrl: settingFolder + "/formfields/template.jade",
      link: function(scope, element, attrs, ngModel) {
        var addAdditionalFields, changeFormType, emptyDesc, emptyName, fieldChanged, fieldExist, formInputsHtmlRender, generateCheckboxInput, generateEmailInput, generateNumberInput, generatePhoneInput, generateRadioInput, generateSelectInput, generateTextInput, generateTextareaInput, generateUrlInput, getExistFieldsLength, getNotDestroyedFieldRnd, id, index, listeners, modalTransform, offertField, removeDeletedAdditionalFields, setButtonStyles, setFormFieldsStyles, setFormStyles, setLabelsStyles, setParentButtonStyles, setSelectedFirstGroup, setSelectedOldGroups, trimNbsp, widgetElWrapper;
        id = attrs.widgetId;
        widgetElWrapper = angular.element("[data-block-id=" + id + "]").find(ns.widgetWrapperClass);
        setSelectedFirstGroup = function() {
          var category, group, i, index, j, len, len1, ref, ref1;
          ref = scope.data.categories;
          for (i = 0, len = ref.length; i < len; i++) {
            category = ref[i];
            ref1 = category.groups;
            for (index = j = 0, len1 = ref1.length; j < len1; index = ++j) {
              group = ref1[index];
              if (index === 0) {
                group.selected = true;
                return false;
              }
            }
          }
        };
        setSelectedOldGroups = function(type) {
          var group, i, len, oc, ocgroup, oldCategories, oldcategory, ref, results;
          oldCategories = angular.copy(scope.data[type]);
          scope.data[type] = angular.copy(window.justclick.formCategories);
          ref = scope.data[type];
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            oldcategory = ref[i];
            results.push((function() {
              var j, len1, ref1, results1;
              ref1 = oldcategory.groups;
              results1 = [];
              for (j = 0, len1 = ref1.length; j < len1; j++) {
                group = ref1[j];
                results1.push((function() {
                  var k, len2, results2;
                  results2 = [];
                  for (k = 0, len2 = oldCategories.length; k < len2; k++) {
                    oc = oldCategories[k];
                    results2.push((function() {
                      var l, len3, ref2, results3;
                      ref2 = oc.groups;
                      results3 = [];
                      for (l = 0, len3 = ref2.length; l < len3; l++) {
                        ocgroup = ref2[l];
                        if (group.name === ocgroup.name && ocgroup.selected) {
                          results3.push(group.selected = true);
                        } else {
                          results3.push(void 0);
                        }
                      }
                      return results3;
                    })());
                  }
                  return results2;
                })());
              }
              return results1;
            })());
          }
          return results;
        };
        offertField = _.filter(scope.data.form_fields_attributes, {
          offert: true
        })[0];
        index = scope.data.form_fields_attributes.indexOf(offertField);
        if (index > -1) {
          scope.data.form_fields_attributes[index].value = $filter('translate')('widget.form.offertText1');
          scope.data.form_fields_attributes[index].title = $filter('translate')('widget.form.offertText1');
        }
        if (scope.data.categories && scope.data.categories.length === 0) {
          scope.data.categories = angular.copy(window.justclick.formCategories);
          setSelectedFirstGroup();
        } else {
          setSelectedOldGroups("categories");
        }
        if (scope.data.ex_categories.length === 0) {
          scope.data.ex_categories = angular.copy(window.justclick.formCategories);
        } else {
          setSelectedOldGroups("ex_categories");
        }
        scope.form = angular.copy(scope.data);
        getNotDestroyedFieldRnd = function() {
          var fields;
          fields = [];
          _.each(scope.form.form_fields_attributes, function(field, index) {
            if (!field._destroy) {
              return fields.push(index);
            }
          });
          if (fields.length > 0) {
            return fields[fields.length - 1];
          } else {
            return 0;
          }
        };
        scope.currentField = getNotDestroyedFieldRnd();
        scope.setCurrentField = function(index) {
          return scope.currentField = index;
        };
        scope.treeOptions = {
          dropped: function(e) {
            var fieldsIds;
            fieldsIds = [];
            _.each(scope.form.form_fields_attributes, function(field) {
              if (field.id) {
                return fieldsIds.push(field.id);
              }
            });
            return Widget.sortFormFields(attrs.widgetId, fieldsIds);
          }
        };
        scope.inputTypes = [
          {
            field_type: "text",
            name: "Text",
            title: $filter('translate')('widget.form.fieldType1')
          }, {
            field_type: "number",
            name: "Number",
            title: $filter('translate')('widget.form.fieldType2')
          }, {
            field_type: "tel",
            name: "Phone",
            title: $filter('translate')('widget.form.fieldType3')
          }, {
            field_type: "email",
            name: "Email",
            title: $filter('translate')('widget.form.fieldType4')
          }, {
            field_type: "url",
            name: "Url",
            title: $filter('translate')('widget.form.fieldType5')
          }, {
            field_type: "textarea",
            name: "Text Area",
            title: $filter('translate')('widget.form.fieldType6')
          }, {
            field_type: "select",
            name: "Select",
            title: $filter('translate')('widget.form.fieldType7')
          }, {
            field_type: "checkbox",
            name: "Checkbox",
            title: $filter('translate')('widget.form.fieldType8')
          }, {
            field_type: "radio",
            name: "Radio",
            title: $filter('translate')('widget.form.fieldType9')
          }
        ];
        fieldExist = function(field_) {
          var field, i, len, ref;
          ref = scope.form.form_fields_attributes;
          for (i = 0, len = ref.length; i < len; i++) {
            field = ref[i];
            if (field_.name === field.name) {
              return true;
            }
          }
          return false;
        };
        removeDeletedAdditionalFields = function() {
          var defaultFields, field, formclone, i, len, needForDestroy, needUpdate, notDefaultFields, ref, ref1, sectionId;
          defaultFields = ["lead_name", "lead_email", "lead_phone", "lead_middle_name", "lead_last_name", "lead_city", "lead_offert"];
          formclone = angular.copy(scope.form);
          needUpdate = 0;
          ref = formclone.form_fields_attributes;
          for (i = 0, len = ref.length; i < len; i++) {
            field = ref[i];
            notDefaultFields = (ref1 = field.name, indexOf.call(defaultFields, ref1) < 0);
            if (notDefaultFields) {
              needForDestroy = (_.filter(window.justclick.additionalFields, {
                name: field.name,
                title: field.title
              })).length === 0;
              if (needForDestroy) {
                needUpdate++;
                field._destroy = true;
              }
            }
          }
          if (needUpdate > 0) {
            sectionId = blockEditDialog.getSectionId({
              id: formclone.id
            });
            return Widget.update(sectionId, formclone).then(function(data) {
              return scope.form.form_fields_attributes = data.form_fields_attributes;
            });
          } else {
            return {
              then: function(cb) {
                return cb();
              }
            };
          }
        };
        addAdditionalFields = function() {
          return removeDeletedAdditionalFields().then(function() {
            var fieldsForAddingCount, sectionId;
            if (window.justclick.additionalFields) {
              fieldsForAddingCount = 0;
              _.each(window.justclick.additionalFields, function(field) {
                if (!fieldExist(field)) {
                  fieldsForAddingCount++;
                  return scope.form.form_fields_attributes.push(field);
                }
              });
              if (fieldsForAddingCount > 0) {
                sectionId = blockEditDialog.getSectionId({
                  id: scope.form.id
                });
                return Widget.update(sectionId, scope.form).then(function(data) {
                  return scope.form.form_fields_attributes = data.form_fields_attributes;
                });
              }
            }
          });
        };
        addAdditionalFields();
        scope.add = function() {
          var length;
          scope.form.form_fields_attributes.push({
            field_type: "text"
          });
          length = scope.form.form_fields_attributes.length;
          scope.currentField = length - 1;
          return scope.setTitleAsType("text");
        };
        scope.fieldsLength = function(fields) {
          var destroyed;
          destroyed = _.filter(fields, {
            _destroy: true
          });
          return fields.length - destroyed.length;
        };
        scope.remove = function() {
          scope.form.form_fields_attributes[scope.currentField]._destroy = true;
          return scope.currentField = getNotDestroyedFieldRnd();
        };
        fieldChanged = function(newVal, oldVal, fieldType) {
          var field, i, len;
          for (index = i = 0, len = newVal.length; i < len; index = ++i) {
            field = newVal[index];
            if (oldVal[index] && field[fieldType] !== oldVal[index][fieldType]) {
              return true;
            }
          }
          return false;
        };
        trimNbsp = function(fields) {
          var field, i, len;
          for (i = 0, len = fields.length; i < len; i++) {
            field = fields[i];
            field.title = field.title.replace(/&nbsp;/gi, '');
          }
          return fields;
        };
        listeners = [];
        changeFormType = function(newType, oldType) {
          if (newType === "subscription") {
            formInputsHtmlRender(scope.form.form_fields_attributes);
            return setFormStyles(scope.data.form_style);
          }
        };
        listeners.push(scope.$watch("data.form_type", changeFormType));
        listeners.push(scope.$watch("form", function(newVal) {
          if (!ngModel) {
            return false;
          }
          return ngModel.$setViewValue(newVal);
        }));
        listeners.push(scope.$watch("data.button", function(newVal) {
          return setButtonStyles(newVal);
        }, true));
        listeners.push(scope.$watch("data.parent_button", function(newVal) {
          return setParentButtonStyles(newVal);
        }, true));
        listeners.push(scope.$watch("data.form_style", function(newVal) {
          return setFormStyles(newVal);
        }, true));
        listeners.push(scope.$watch("data.form_fields_style_attributes", function(newVal) {
          return setFormFieldsStyles(newVal);
        }, true));
        listeners.push(scope.$watch("data.labels_style_attributes", function(newVal) {
          return setLabelsStyles(newVal);
        }, true));
        listeners.push(scope.$watch("data.as_modal", function(newVal) {
          return modalTransform(newVal);
        }));
        listeners.push(scope.$watch("data.form_design", function(newVal, oldVal) {
          scope.form.form_design = newVal;
          return formInputsHtmlRender(scope.form.form_fields_attributes);
        }));
        listeners.push(scope.$watch("data.labels", function(newVal, oldVal) {
          scope.form.labels = newVal;
          return formInputsHtmlRender(scope.form.form_fields_attributes);
        }));
        listeners.push(scope.$watch("form.form_fields_attributes", function(newVal, oldVal) {
          var needForChange;
          scope.data.form_fields_attributes = trimNbsp(newVal);
          needForChange = fieldChanged(newVal, oldVal, "placeholder") || fieldChanged(newVal, oldVal, "options_raw") || fieldChanged(newVal, oldVal, "exist") || fieldChanged(newVal, oldVal, "hidden");
          if (scope.fieldsLength(newVal) !== scope.fieldsLength(oldVal) || needForChange) {
            return formInputsHtmlRender(newVal);
          }
        }, true));
        scope.$on("$destroy", function() {
          return _.each(listeners, function(listener) {
            return listener();
          });
        });
        scope.setTitleAsType = function(type) {
          var finded;
          finded = _.filter(scope.inputTypes, {
            field_type: type
          });
          scope.form.form_fields_attributes[scope.currentField].title = finded[0].title;
          return scope.form.form_fields_attributes[scope.currentField].placeholder = finded[0].title;
        };
        emptyName = function(variable) {
          return variable || "No name";
        };
        emptyDesc = function(variable) {
          return variable || "";
        };
        generateUrlInput = function(field) {
          var required, translit;
          translit = translitService.cyrillToLatin(emptyName(field.placeholder));
          required = field.required ? "required=''" : "";
          return "<input readonly='' " + required + " type='url' name='" + translit + "' class='strwf__input' placeholder='" + (emptyName(field.placeholder)) + "'>";
        };
        generateEmailInput = function(field) {
          var required, translit;
          translit = translitService.cyrillToLatin(emptyName(field.placeholder));
          required = field.required ? "required=''" : "";
          return "<input readonly='' " + required + " type='email' name='" + translit + "' class='strwf__input' placeholder='" + (emptyName(field.placeholder)) + "'>";
        };
        generateTextInput = function(field) {
          var required, translit;
          translit = translitService.cyrillToLatin(emptyName(field.placeholder));
          required = field.required ? "required=''" : "";
          return "<input readonly='' " + required + " type='text' name='" + translit + "' class='strwf__input' placeholder='" + (emptyName(field.placeholder)) + "'>";
        };
        generateNumberInput = function(field) {
          var required, translit;
          translit = translitService.cyrillToLatin(emptyName(field.placeholder));
          required = field.required ? "required=''" : "";
          return "<input readonly='' " + required + " type='number' name='" + translit + "' class='strwf__input' placeholder='" + (emptyName(field.placeholder)) + "'>";
        };
        generatePhoneInput = function(field) {
          var required, translit;
          translit = translitService.cyrillToLatin(emptyName(field.placeholder));
          required = field.required ? "required=''" : "";
          return "<input readonly='' " + required + " type='tel' name='" + translit + "' class='strwf__input' placeholder='" + (emptyName(field.placeholder)) + "'>";
        };
        generateTextareaInput = function(field) {
          var required, translit;
          translit = translitService.cyrillToLatin(emptyName(field.placeholder));
          required = field.required ? "required=''" : "";
          return "<textarea readonly='' " + required + " class='strwf__input strwf__input_textarea' name='" + translit + "' placeholder='" + (emptyName(field.placeholder)) + "'></textarea>";
        };
        generateSelectInput = function(field) {
          var options, optionsHtml, required, translit;
          translit = translitService.cyrillToLatin(emptyName(field.placeholder));
          required = field.required ? "required=''" : "";
          if (field.options_raw) {
            options = field.options_raw.split("\n");
            optionsHtml = "";
            _.each(options, function(option) {
              var selected;
              if (option === field.value) {
                selected = "selected=''";
              } else {
                selected = "";
              }
              return optionsHtml += "<option value='" + option + "' " + selected + ">" + option + "</option>";
            });
          }
          return "<select " + required + " class='strwf__input' name='" + translit + "'>" + optionsHtml + "</select>";
        };
        generateCheckboxInput = function(field, index) {
          var optionsHtml, selected, translit;
          translit = translitService.cyrillToLatin(emptyName(field.placeholder));
          if (field.title === field.value) {
            selected = "checked=''";
          } else {
            selected = "";
          }
          optionsHtml = "<div class='strwf__radio-wrapper'><input class='strwf__radio' value='" + field.title + "' id='strwf-1-" + field.id + "' type='checkbox' name='entity[{{field.name}}]' " + selected + "><label contenteditable='false' data-access='form_fields_attributes." + index + ".title' class='strwf__radio-label' for='strwf-1-" + field.id + "'>" + field.title + "</label></div>";
          if (field.offert) {
            optionsHtml = "<div class='strwf__radio-wrapper'><input class='strwf__radio' value='" + field.title + "' id='strwf-1-" + field.id + "' type='checkbox' checked='true' name='entity[{{field.name}}]' " + selected + "><label class='strwf__radio-label' for='strwf-1-" + field.id + "'>" + ($filter('translate')('widget.form.offertText')) + "</label></div>";
          }
          return optionsHtml;
        };
        generateRadioInput = function(field) {
          var options, optionsHtml, translit;
          translit = translitService.cyrillToLatin(emptyName(field.placeholder));
          options = field.options_raw.split("\n");
          optionsHtml = "";
          _.each(options, function(option, index) {
            var selected;
            if (option === field.value) {
              selected = "checked=''";
            } else {
              selected = "";
            }
            return optionsHtml += "<div class='strwf__radio-wrapper'><input class='strwf__radio' value='" + option + "' id='strwfr-" + field.name + "-" + index + "-1' type='radio' name='entity[" + field.name + "]' " + selected + "><label class='strwf__radio-label' for='strwfr-" + field.name + "-" + index + "-1'>" + option + "</label></div>";
          });
          return optionsHtml;
        };
        setButtonStyles = function(newVal) {
          var style;
          scope.form.button = newVal;
          widgetElWrapper.find(ns.widgetFormButtonWrapperClass).css("text-align", newVal.style["textAlign"]);
          if (newVal.style.textAlign) {
            style = angular.copy(newVal.style);
            delete style.textAlign;
          }
          return widgetElWrapper.find(".strwf_form-button").css(style);
        };
        setParentButtonStyles = function(newVal) {
          var style;
          scope.form.parent_button = newVal;
          widgetElWrapper.find(ns.widgetFormParentButtonWrapperClass).css("text-align", newVal.style["textAlign"]);
          if (newVal.style.textAlign) {
            style = angular.copy(newVal.style);
            delete style.textAlign;
          }
          return widgetElWrapper.find(".strwf__parent-button").css(style);
        };
        setFormFieldsStyles = function(newVal) {
          scope.form.form_fields_style_attributes = newVal;
          return widgetElWrapper.find(".strwf__input").css(newVal);
        };
        setLabelsStyles = function(newVal) {
          scope.form.labels_style_attributes = newVal;
          return widgetElWrapper.find(".strwf__label").css(newVal);
        };
        setFormStyles = function(newVal) {
          return widgetElWrapper.find("form").css(newVal);
        };
        modalTransform = function(newVal) {
          var button, form;
          form = widgetElWrapper.find(".strwf__form");
          button = "<div class='" + (ns.widgetFormParentButtonWrapperClass.substr(1)) + "'><label type='submit' contenteditable='false' data-access='parent_button.value' class='strwf_button strwf__parent-button'>" + scope.form.parent_button.value + "</label></div>";
          widgetElWrapper.find("" + ns.widgetFormParentButtonWrapperClass).remove();
          if (newVal) {
            form.hide();
            widgetElWrapper.prepend(button);
            setParentButtonStyles(scope.form.parent_button);
            return ContentEditable.bind(false, true, id);
          } else {
            widgetElWrapper.find(".subscribe-form__modal-title").remove();
            return form.show();
          }
        };
        getExistFieldsLength = function(fields) {
          return (_.filter(fields, {
            exist: false
          })).length;
        };
        return formInputsHtmlRender = function(fields) {
          var button, buttonLabel, fieldsWithLabelBlock, fieldsWithOptions, inlineClasses, output;
          if (scope.data.form_type === "order") {
            return false;
          }
          output = "";
          fieldsWithLabelBlock = ["checkbox", "radio"];
          fieldsWithOptions = ["checkbox", "radio", "select"];
          inlineClasses = "";
          buttonLabel = "";
          _.each(fields, function(field, index) {
            var displayBlock, existFieldsLength, ref, ref1;
            if (!field.options_created && (ref = field.field_type, indexOf.call(fieldsWithOptions, ref) >= 0) && !field.options_raw) {
              field.options_raw = "Вариант 1\nВариант 2\nВариант 3";
              field.options_created = true;
            }
            if (!field._destroy && field.exist && !field.hidden) {
              if (scope.form.form_design === "horizontal") {
                existFieldsLength = getExistFieldsLength(fields);
                inlineClasses = "strwf__input-inline strwf__input-wrapper_" + (scope.fieldsLength(fields) + 1 - existFieldsLength);
              }
              displayBlock = (ref1 = field.field_type, indexOf.call(fieldsWithLabelBlock, ref1) >= 0) ? "strwf__label_block" : "";
              output += "<div class='strwf__input-wrapper " + inlineClasses + "'>";
              if (scope.form.labels && !field.offert) {
                output += "<label class='strwf__label " + displayBlock + "' contenteditable='false' data-access='form_fields_attributes." + index + ".title'>" + (emptyDesc(field.title)) + "</label>";
                buttonLabel = scope.form.form_design === 'horizontal' ? "<div class='strwf__label'>​</div>" : "";
              }
              switch (field.field_type) {
                case "text":
                  output += generateTextInput(field);
                  break;
                case "number":
                  output += generateNumberInput(field);
                  break;
                case "textarea":
                  output += generateTextareaInput(field);
                  break;
                case "select":
                  output += generateSelectInput(field);
                  break;
                case "checkbox":
                  output += generateCheckboxInput(field, index);
                  break;
                case "radio":
                  output += generateRadioInput(field);
                  break;
                case "tel":
                  output += generatePhoneInput(field);
                  break;
                case "email":
                  output += generateEmailInput(field);
                  break;
                case "url":
                  output += generateUrlInput(field);
              }
              return output += "<span id='" + field.nameEn + "' class='error-text'></span></div>";
            }
          });
          button = "<div class='strwf__button-wrapper strwf__form-button__wrapper " + inlineClasses + "'>" + buttonLabel + "<label type='submit' class='strwf_button strwf_form-button' contenteditable='false' data-access='button.value'>" + scope.form.button.value + "</label></div>";
          widgetElWrapper.find("form").html('');
          widgetElWrapper.find("form").append(output);
          widgetElWrapper.find("form").append(button);
          setButtonStyles(scope.data.button);
          setFormFieldsStyles(scope.data.form_fields_style_attributes);
          setLabelsStyles(scope.data.labels_style_attributes);
          return ContentEditable.bind(false, true, id);
        };
      }
    };
  }
]);


/***/ }),
/* 209 */
/***/ (function(module, exports) {

var galleryFieldsDirective;

galleryFieldsDirective = angular.module('galleryfields.setting', []);

galleryFieldsDirective.directive("galleryFieldsSetting", [
  "$window", "$timeout", "$compile", "$templateCache", "ns", "translitService", "Widget", "blockEditDialog", "Restangular", function($window, $timeout, $compile, $templateCache, ns, translitService, Widget, blockEditDialog, Restangular) {
    return {
      restrict: "A",
      scope: {
        data: "=ngModel"
      },
      templateUrl: settingFolder + "/galleryfields/template.jade",
      link: function(scope, element, attrs, ngModel) {
        var getNotDestroyedFieldRnd, id, listener1, listener2, removeCurrentImage, renderPhotos, sectionId, trimNbsp, widgetElWrapper;
        id = attrs.widgetId;
        widgetElWrapper = angular.element("[data-block-id=" + id + "]").find(ns.widgetWrapperClass);
        scope.gallery = angular.copy(scope.data);
        sectionId = blockEditDialog.getSectionId({
          id: id
        });
        widgetElWrapper.find("a").click(function(e) {
          return e.preventDefault();
        });
        getNotDestroyedFieldRnd = function() {
          var fields;
          fields = [];
          _.each(scope.gallery.photos_attributes, function(field, index) {
            if (!field._destroy) {
              return fields.push(index);
            }
          });
          if (fields.length > 0) {
            return fields[fields.length - 1];
          } else {
            return 0;
          }
        };
        scope.currentField = getNotDestroyedFieldRnd();
        trimNbsp = function(fields) {
          var field, i, len;
          for (i = 0, len = fields.length; i < len; i++) {
            field = fields[i];
            field.caption = field.caption.replace(/&nbsp;/gi, '');
          }
          return fields;
        };
        scope.fieldsLength = function(fields) {
          var destroyed;
          destroyed = _.filter(fields, {
            _destroy: true
          });
          return fields.length - destroyed.length;
        };
        scope.setCurrentImage = function($index) {
          return scope.currentField = $index;
        };
        scope.add = function() {
          var params;
          sectionId = blockEditDialog.getSectionId({
            id: id
          });
          params = {
            photos_attributes: [
              {
                remote_file_url: Restangular.configuration.baseUrl + "/assets/widgets/gallery/img4.jpg"
              }
            ]
          };
          return Widget.createItem(sectionId, id, params).then(function(data) {
            var length, newImage, newImageHTML;
            newImage = data.photos_attributes[data.photos_attributes.length - 1];
            scope.gallery.photos_attributes.push(newImage);
            length = scope.gallery.photos_attributes.length;
            newImageHTML = "<li data-lightbox-id='" + newImage.id + "'> <a href='javascript:void(0)'> <div class='background-image-holder fadeIn' style='background: url(" + newImage.file_url + ");'> <img alt='image' class='background-image' src='" + newImage.file_url + "' style='display: none;'> </div> </a> </li>";
            widgetElWrapper.find("ul").append(newImageHTML);
            return scope.setCurrentImage(length - 1);
          });
        };
        removeCurrentImage = function() {
          var imageId, index;
          imageId = scope.gallery.photos_attributes[scope.currentField].id;
          return index = $("[data-lightbox-id='" + imageId + "']").remove();
        };
        scope.remove = function() {
          scope.gallery.photos_attributes[scope.currentField]._destroy = true;
          removeCurrentImage();
          return scope.setCurrentImage(getNotDestroyedFieldRnd());
        };
        listener1 = scope.$watch("gallery.photos_attributes", function(newVal, oldVal) {
          return scope.data.photos_attributes = trimNbsp(newVal);
        }, true);
        listener2 = scope.$watch("data", function(newVal, oldVal) {
          return renderPhotos(newVal);
        }, true);
        scope.$on("$destroy", function() {
          listener1();
          return listener2();
        });
        return renderPhotos = function(newVal) {
          return _.each(newVal.photos_attributes, function(photo) {
            return $("[data-lightbox-id='" + photo.id + "']").find(".background-image-holder").css("background", "url('" + photo.file_url + "')");
          });
        };
      }
    };
  }
]);


/***/ }),
/* 210 */
/***/ (function(module, exports) {

var gradientDirectiveModule;

gradientDirectiveModule = angular.module('gradient.setting', []);

gradientDirectiveModule.directive("gradientSetting", [
  "$window", "$timeout", "$compile", "$templateCache", function($window, $timeout, $compile, $templateCache) {
    return {
      restrict: "A",
      scope: {
        data: "=ngModel",
        afterChange: '&'
      },
      templateUrl: settingFolder + "/gradient/template.jade",
      link: function(scope, element, attrs, ngModel) {
        var backgroundImage, calcAlphaHex, colors, fromColor, generateBackgroundStyle, hex2rgba, listener0, listener1, listener2, listener3, rgba2hex, toColor;
        calcAlphaHex = function(opacity) {
          var alpha, hex;
          if (opacity === 1) {
            '';
          }
          alpha = Math.floor(opacity * 255);
          hex = alpha.toString(16);
          if (alpha < 16) {
            hex = '0' + hex;
          }
          return hex;
        };
        rgba2hex = function(rgba) {
          var hexResult, opacity, rgb, rgbaStringArray;
          rgbaStringArray = rgba.match(/[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s]?([\d.]+)[\s+]?/g);
          if (rgbaStringArray === null) {
            return rgba;
          } else {
            rgb = rgbaStringArray[0].split(', ');
            opacity = parseFloat(rgb[3]);
            hexResult = rgb && rgb.length === 4 ? '#' + ('0' + parseInt(rgb[0], 10).toString(16)).slice(-2) + ('0' + parseInt(rgb[1], 10).toString(16)).slice(-2) + ('0' + parseInt(rgb[2], 10).toString(16)).slice(-2) : '';
            return hexResult + calcAlphaHex(opacity);
          }
        };
        hex2rgba = function(hex) {
          var alpha, blue, green, red;
          hex = hex.replace('#', '');
          red = parseInt(hex.substring(0, 2), 16);
          green = parseInt(hex.substring(2, 4), 16);
          blue = parseInt(hex.substring(4, 6), 16);
          alpha = parseInt(hex.substring(6, 8), 16);
          if (alpha) {
            alpha = Math.floor(alpha / 255 * 100);
          } else {
            alpha = 100;
          }
          return 'rgba(' + red + ', ' + green + ', ' + blue + ', ' + alpha / 100 + ')';
        };
        generateBackgroundStyle = function(colorStart, colorStop) {
          colorStart = rgba2hex(colorStart);
          colorStop = rgba2hex(colorStop);
          return scope.data.backgroundImage = "-webkit-linear-gradient(" + scope.direction + ", " + colorStart + " 0%, " + colorStop + " 100%)";
        };
        scope.gsettings = {};
        scope.timestamp = new Date().getTime();
        if (scope.data.backgroundImage && scope.data.backgroundImage !== "none") {
          backgroundImage = scope.data.backgroundImage;
          if (backgroundImage.match(/-webkit-gradient/)) {
            fromColor = backgroundImage.match(/from\((.*)\),/)[1];
            toColor = backgroundImage.match(/to\((.*)\)\)/)[1];
            scope.positionStart = backgroundImage.split(", ")[1];
            scope.positionStop = backgroundImage.split(", ")[2];
            if (scope.positionStart === "left top" && scope.positionStop === "right top") {
              scope.direction = "left";
            } else {
              scope.direction = "top";
            }
          } else {
            colors = backgroundImage.match(/(\w+),\s(\#.*)\s0%,\s(\#.*)\s100%/);
            scope.direction = colors[1];
            fromColor = hex2rgba(colors[2]);
            toColor = hex2rgba(colors[3]);
          }
          console.log('colors: ', backgroundImage, fromColor, toColor, scope.direction);
          if (scope.direction === "top") {
            scope.position = "vertical";
          } else {
            scope.position = "horizontal";
          }
          scope.gsettings.colorStart = fromColor;
          scope.gsettings.colorStop = toColor;
          scope.data.backgroundImage = generateBackgroundStyle(scope.gsettings.colorStart, scope.gsettings.colorStop);
        }
        listener0 = scope.$watch("position", function(newVal, oldVal) {
          if (newVal === oldVal) {
            return false;
          }
          if (newVal === "horizontal") {
            scope.direction = 'left';
          } else {
            scope.direction = 'top';
          }
          return scope.data.backgroundImage = generateBackgroundStyle(scope.gsettings.colorStart, scope.gsettings.colorStop);
        });
        listener1 = scope.$watch("gsettings.colorStart", function(newVal, oldVal) {
          if (newVal === oldVal) {
            return false;
          }
          return scope.data.backgroundImage = generateBackgroundStyle(scope.gsettings.colorStart, scope.gsettings.colorStop);
        });
        listener2 = scope.$watch("gsettings.colorStop", function(newVal, oldVal) {
          if (newVal === oldVal) {
            return false;
          }
          return scope.data.backgroundImage = generateBackgroundStyle(scope.gsettings.colorStart, scope.gsettings.colorStop);
        });
        listener3 = scope.$watch("isGradient", function(newVal, oldVal) {
          if (newVal === oldVal) {
            return false;
          }
          if (newVal && (!scope.data.backgroundImage || scope.data.backgroundImage === "none")) {
            scope.gsettings.colorStart = "#c83636";
            scope.gsettings.colorStop = "#4cd132";
            return scope.data.backgroundImage = generateBackgroundStyle(scope.gsettings.colorStart, scope.gsettings.colorStop);
          } else {
            return scope.data.backgroundImage = "none";
          }
        });
        scope.isGradient = scope.data.backgroundImage && scope.data.backgroundImage !== "none";
        return scope.$on("$destroy", function() {
          listener0();
          listener1();
          listener2();
          return listener3();
        });
      }
    };
  }
]);


/***/ }),
/* 211 */
/***/ (function(module, exports) {

var radiusDirectiveModule;

radiusDirectiveModule = angular.module('height.setting', []);

radiusDirectiveModule.directive("heightSetting", [
  "$window", "$timeout", "$compile", "$templateCache", function($window, $timeout, $compile, $templateCache) {
    return {
      restrict: "A",
      scope: {
        data: "=ngModel",
        afterChange: '&'
      },
      templateUrl: settingFolder + "/height/template.jade",
      link: function(scope, element, attrs, ngModel) {
        var listener, listener2;
        if (!scope.data) {
          scope.data = 0;
        }
        scope.options = {
          min: 0,
          max: 100
        };
        if (attrs.heightMin && attrs.heightMax) {
          scope.options.min = parseInt(attrs.heightMin);
          scope.options.max = parseInt(attrs.heightMax);
        }
        listener2 = scope.$watch("data", function(newVal) {
          return scope.heightValue = parseInt(newVal);
        });
        listener = scope.$watch("heightValue", function(newVal) {
          return scope.data = newVal;
        });
        return scope.$on("$destroy", function() {
          listener();
          return listener2();
        });
      }
    };
  }
]);


/***/ }),
/* 212 */
/***/ (function(module, exports) {

var hoverDirectiveModule;

hoverDirectiveModule = angular.module('hover.setting', []);

hoverDirectiveModule.directive("hoverSetting", [
  "$window", "$timeout", "$compile", "$templateCache", function($window, $timeout, $compile, $templateCache) {
    return {
      restrict: "A",
      scope: {
        data: "=ngModel"
      },
      templateUrl: settingFolder + "/hover/template.jade",
      link: function(scope, element, attrs, ngModel) {
        var change, dasherize, widgetId;
        scope.accessKey = attrs.accessKey;
        widgetId = scope.data.id;
        scope.buttonType = attrs.buttonType;
        dasherize = function(str) {
          return str.replace(/([A-Z])/g, '-$1').replace(/[-_\s]+/g, '-').toLowerCase();
        };
        change = function(newVal) {
          var css, hover_style, hover_style1, hover_style2;
          css = "";
          switch (scope.data.type) {
            case "button":
              scope.data.button_attributes.hover_style_attributes.backgroundImage = "none";
              hover_style = _.map(newVal.button_attributes.hover_style_attributes, function(value, key) {
                return (dasherize(key)) + ":" + value + " !important";
              });
              css += ".str-bw_" + widgetId + " .strwf_button:hover { " + (hover_style.join("; ")) + "}";
              break;
            case "product":
              scope.data.hover_style_attributes.backgroundImage = "none";
              hover_style = _.map(newVal.hover_style_attributes, function(value, key) {
                return (dasherize(key)) + ":" + value + " !important";
              });
              css += ".str-bw_" + widgetId + " .strwcrd__button:hover { " + (hover_style.join("; ")) + "}";
              break;
            case "card":
              scope.data.button_attributes.hover_style_attributes.backgroundImage = "none";
              hover_style = _.map(newVal.button_attributes.hover_style_attributes, function(value, key) {
                return (dasherize(key)) + ":" + value + " !important";
              });
              css += ".str-bw_" + widgetId + " .strwcrd__button:hover { " + (hover_style.join("; ")) + "}";
              break;
            case "form":
            case "subscribe_form":
              scope.data.parent_button.hover_style.backgroundImage = "none";
              scope.data.button.hover_style.backgroundImage = "none";
              hover_style1 = _.map(newVal.parent_button.hover_style, function(value, key) {
                return (dasherize(key)) + ":" + value + " !important";
              });
              hover_style2 = _.map(newVal.button.hover_style, function(value, key) {
                return (dasherize(key)) + ":" + value + " !important";
              });
              css += ".str-bw_" + widgetId + " .strwf__parent-button:hover { " + (hover_style1.join("; ")) + "}";
              css += "form[id='" + widgetId + "'] .strwf_form-button:hover { " + (hover_style2.join("; ")) + "}";
          }
          scope.data = newVal;
          if ($("#hover_" + widgetId).length === 0) {
            return $(".editor").append("<style id='hover_" + widgetId + "'>" + css + "</style>");
          } else {
            return $("#hover_" + widgetId).html(css);
          }
        };
        return scope.$watch("data", change, true);
      }
    };
  }
]);


/***/ }),
/* 213 */
/***/ (function(module, exports) {

var settingImageModule;

settingImageModule = angular.module('image.setting', []);

settingImageModule.directive("imageSetting", [
  "$window", "$timeout", "$compile", "$templateCache", "ns", function($window, $timeout, $compile, $templateCache, ns) {
    return {
      restrict: "A",
      scope: {
        data: "=ngModel"
      },
      link: function(scope, element, attrs, ngModel) {
        var imageDefaultCap, listener, onImageRender, proccessImageEditing, setImage, setStretch, setStyles, setVisibility, widgetEl;
        widgetEl = angular.element("[data-block-id='" + attrs.widgetId + "']");
        imageDefaultCap = widgetEl.find(".default-cap_image");
        scope.accordion = {
          show_style: false
        };
        widgetEl.find("a").click(function(event) {
          return event.preventDefault();
        });
        onImageRender = function() {};
        setImage = function(newval) {
          if (newval.image_attributes.source_url) {
            if (imageDefaultCap.length) {
              widgetEl.find(".strwimage").html("<img alt='" + newval.title + "' class='strwimage__image' src='" + newval.image_attributes.source_url + "' /><div class='strwimage__title' contenteditable='false' data-access='title'>" + newval.title + "</div>");
            } else {
              widgetEl.find(".strwimage__image").attr("src", newval.image_attributes.source_url);
            }
            widgetEl.find(".strwimage__image").unbind("load");
            return widgetEl.find(".strwimage__image").bind("load", onImageRender);
          }
        };
        setStretch = function(newval) {
          var image;
          image = widgetEl.find(".strwimage__image");
          if (newval.image_attributes.stretch) {
            return image.css({
              "width": "100%"
            });
          } else {
            return image.css({
              "width": "auto"
            });
          }
        };
        setVisibility = function(newval) {
          if (newval.show_title) {
            return widgetEl.find(".strwimage__title").show();
          } else {
            return widgetEl.find(".strwimage__title").hide();
          }
        };
        setStyles = function(newval) {
          return widgetEl.find("img").css("border-radius", newval.style_attributes.borderRadius);
        };
        proccessImageEditing = function(newval) {
          setImage(newval);
          setStretch(newval);
          setVisibility(newval);
          return setStyles(newval);
        };
        listener = scope.$watch("data", function(newval, oldval) {
          return proccessImageEditing(newval);
        }, true);
        return scope.$on("$destroy", function() {
          return listener();
        });
      }
    };
  }
]);


/***/ }),
/* 214 */
/***/ (function(module, exports) {

var settingLink;

settingLink = angular.module('name.setting', []);

settingLink.directive("linkSetting", [
  "$window", "$timeout", "$compile", "$templateCache", "ns", "ContentEditable", function($window, $timeout, $compile, $templateCache, ns, ContentEditable) {
    return {
      restrict: "A",
      scope: {
        data: "=ngModel"
      },
      link: function(scope, element, attrs, ngModel) {
        var id, listener, setLinkHtml, widgetElWrapper;
        id = scope.data.id;
        widgetElWrapper = angular.element("[data-block-id=" + id + "]").find(ns.widgetWrapperClass);
        setLinkHtml = function(newVal) {
          if (newVal.link_type === "default") {
            if (widgetElWrapper.find(".strwf_button_default").length === 0) {
              scope.data.style_attributes.textAlign = "center";
              scope.data.style_attributes.backgroundColor = "rgba(255, 255, 255, 0)";
              scope.data.button_attributes.style_attributes.padding = "10px 10px 10px 10px";
              scope.data.button_attributes.style_attributes.backgroundColor = "rgba(255, 255, 255, 0)";
              scope.data.button_attributes.style_attributes.color = "#4A90E2";
              scope.data.button_attributes.style_attributes.borderRadius = "0px";
              widgetElWrapper.find(".strwf_button").eq(0).replaceWith("<a href='#' contenteditable='false' spellcheck='false' data-access='button_attributes.value' class='strwf_button strwf_button_default link-anchor'>" + newVal.button_attributes.value + "</a>");
            }
            widgetElWrapper.find(".strwf_button").eq(0).css(newVal.button_attributes.style_attributes);
          } else {
            if (widgetElWrapper.find(".strwf_button_full").length === 0) {
              scope.data.style_attributes.backgroundColor = "rgba(0, 0, 0, 0.7)";
              scope.data.button_attributes.style_attributes.padding = "13px 20px 13px 20px";
              scope.data.button_attributes.style_attributes.backgroundColor = "rgba(255, 255, 255, 1)";
              scope.data.button_attributes.style_attributes.color = "rgba(0, 0, 0, 1)";
              scope.data.button_attributes.style_attributes.borderRadius = "20px";
              widgetElWrapper.find(".strwf_button").eq(0).replaceWith("<a class='strwf_button strwf_button_full link-anchor' href='#' > <div class='str-link__content'> <span class='str-link__text' contenteditable='false' spellcheck='false' data-access='text'>" + newVal.text + "</span> <button class='str-link__button' contenteditable='false' data-access='button_attributes.value' spellcheck='false'>" + newVal.button_attributes.value + "</button> </div> </a>");
            }
            widgetElWrapper.find(".strwf_button_full").css({
              backgroundImage: "url(" + newVal.image_attributes.source_url + ")"
            });
            widgetElWrapper.find(".str-link__text").css(newVal.text_style);
            widgetElWrapper.find(".str-link__button").css(newVal.button_attributes.style_attributes);
          }
          return ContentEditable.bind(false, true, id);
        };
        listener = scope.$watch("data", function(newVal) {
          return setLinkHtml(newVal);
        }, true);
        return scope.$on("$destroy", function() {
          return listener();
        });
      }
    };
  }
]);


/***/ }),
/* 215 */
/***/ (function(module, exports) {

var listFieldsDirective;

listFieldsDirective = angular.module('listfields.setting', []);

listFieldsDirective.directive("listFieldsSetting", [
  "$window", "$timeout", "$compile", "$templateCache", "ns", "translitService", "Widget", "blockEditDialog", "ContentEditable", function($window, $timeout, $compile, $templateCache, ns, translitService, Widget, blockEditDialog, ContentEditable) {
    return {
      restrict: "A",
      scope: {
        data: "=ngModel",
        afterRowCreate: "&afterRowCreate"
      },
      templateUrl: settingFolder + "/listfields/template.jade",
      link: function(scope, element, attrs, ngModel) {
        var afterCreate, afterProductItemRowCreate, getNotDestroyedFieldRnd, id, listener1, listener2, removeCurrentImage, sectionId, sortItems, trimNbsp, widgetElWrapper;
        id = attrs.widgetId;
        widgetElWrapper = angular.element("[data-block-id=" + id + "]").find(ns.widgetWrapperClass);
        scope.list = angular.copy(scope.data);
        sectionId = blockEditDialog.getSectionId({
          id: id
        });
        widgetElWrapper.find("a").click(function(e) {
          return e.preventDefault();
        });
        getNotDestroyedFieldRnd = function() {
          var fields;
          fields = [];
          _.each(scope.list.rows_attributes, function(field, index) {
            if (!field._destroy) {
              return fields.push(index);
            }
          });
          if (fields.length > 0) {
            return fields[fields.length - 1];
          } else {
            return 0;
          }
        };
        scope.currentField = getNotDestroyedFieldRnd();
        sortItems = function() {
          var i, index, len, product_items_ids, ref, results, row;
          product_items_ids = [];
          ref = scope.list.rows_attributes;
          results = [];
          for (index = i = 0, len = ref.length; i < len; index = ++i) {
            row = ref[index];
            results.push(row.position = index);
          }
          return results;
        };
        trimNbsp = function(fields) {
          var field, i, len;
          for (i = 0, len = fields.length; i < len; i++) {
            field = fields[i];
            field.caption = field.caption.replace(/&nbsp;/gi, '');
          }
          return fields;
        };
        scope.fieldsLength = function(fields) {
          var destroyed;
          destroyed = _.filter(fields, {
            _destroy: true
          });
          return fields.length - destroyed.length;
        };
        scope.setCurrentImage = function($index) {
          return scope.currentField = $index;
        };
        afterCreate = function(data) {
          var length, newRow, newRowHTML;
          newRow = data.rows_attributes[data.rows_attributes.length - 1];
          scope.list.rows_attributes.push(newRow);
          length = scope.list.rows_attributes.length;
          newRowHTML = "<li data-item-id='" + newRow.id + "' style='background-image: url(" + scope.data.image_attributes.source_url + ")'><span class='strbw_list-item__caption' contenteditable='false' data-access='rows_attributes." + (length - 1) + ".caption'>" + newRow.caption + "</span></li>";
          widgetElWrapper.find(".strbw_list").append(newRowHTML);
          scope.setCurrentImage(length - 1);
          ContentEditable.bind(false, true, id);
          return sortItems();
        };
        afterProductItemRowCreate = function(data) {
          var newRow;
          newRow = data.rows_attributes[data.rows_attributes.length - 1];
          scope.list.rows_attributes.push(newRow);
          scope.afterRowCreate();
        };
        scope.add = function() {
          var params;
          sectionId = blockEditDialog.getSectionId({
            id: id
          });
          params = {
            rows_attributes: [
              {
                is_temp: true
              }
            ]
          };
          if (attrs.fromProduct) {
            return Widget.createProductItemRow(attrs.productId, attrs.productItemId, params).then(afterProductItemRowCreate);
          } else {
            return Widget.createItem(sectionId, id, params).then(afterCreate);
          }
        };
        removeCurrentImage = function() {
          var imageId, index;
          imageId = scope.list.rows_attributes[scope.currentField].id;
          return index = $("[data-item-id='" + imageId + "']").remove();
        };
        scope.remove = function() {
          scope.list.rows_attributes[scope.currentField]._destroy = true;
          removeCurrentImage();
          scope.setCurrentImage(getNotDestroyedFieldRnd());
          return sortItems();
        };
        listener1 = scope.$watch("list.rows_attributes", function(newVal, oldVal) {
          return scope.data.rows_attributes = trimNbsp(newVal);
        }, true);
        listener2 = scope.$watch("data", function(newVal, oldVal) {}, true);
        return scope.$on("$destroy", function() {
          listener1();
          return listener2();
        });
      }
    };
  }
]);


/***/ }),
/* 216 */
/***/ (function(module, exports) {

angular.module('modulesSettings', ['review.setting', 'product.setting', 'align.setting', 'valign.setting', 'form.setting', 'subscribeForm.setting', 'formfields.setting', 'subscribeFormfields.setting', 'sliderfields.setting', 'border.setting', 'colorpicker.setting', 'padding.setting', 'margin.setting', 'shadow.setting', 'radius.setting', 'height.setting', 'width.setting', 'size.setting', 'image.setting', 'uploader.setting', 'modalWysiwyg.setting', 'sizeSelect.setting', 'card.setting', 'name.setting', 'galleryfields.setting', 'navigationfields.setting', 'map.setting', 'bgfields.setting', 'socialfields.setting', 'news.setting', 'buttonActions.setting', 'colors.setting', 'timer.setting', 'slidersize.setting', 'gradient.setting', 'listfields.setting', 'photolibrary.setting', 'photolibrary.controller', 'tablefields.setting', 'sitebg.setting', 'hover.setting', 'iconSelector.setting', 'facebookComment.setting']);


/***/ }),
/* 217 */
/***/ (function(module, exports) {

var settingMapModule;

settingMapModule = angular.module('map.setting', []);

settingMapModule.directive("mapSetting", [
  "$window", "$timeout", "$compile", "$templateCache", "ns", "MapInit", function($window, $timeout, $compile, $templateCache, ns, MapInit) {
    return {
      restrict: "A",
      templateUrl: settingFolder + "/map/template.jade",
      scope: {
        data: "=ngModel"
      },
      link: function(scope, element, attrs, ngModel) {
        var bounds, fitToMarkers, geocoder, googleSearchGeo, infowindow, listener1, listener2, listener3, map, mapProvider, marker, providersSearchMethods, updatePinText, widgetEl, yandexSearchGeo;
        widgetEl = angular.element("[data-block-id='" + attrs.widgetId + "']");
        mapProvider = scope.data.provider;
        map = void 0;
        marker = void 0;
        geocoder = void 0;
        infowindow = void 0;
        bounds = void 0;
        listener1 = scope.$watch("data.style_attributes.height", function(newVal, oldVal) {
          var mapWrapper;
          mapWrapper = widgetEl.find(".str-map__wrapper");
          return mapWrapper.css("height", newVal);
        });
        listener2 = scope.$watch("data.provider", function(newVal, oldVal) {
          var result;
          if (newVal === oldVal) {
            result = widgetEl[0][newVal + "Map"];
          } else {
            result = MapInit.initMap(0, widgetEl.find(".strw__map"), scope.data);
          }
          if (newVal === "google") {
            map = result.map_instance;
            marker = result.marker;
            geocoder = result.geocoder;
            infowindow = result.infowindow;
            map.addListener('zoom_changed', function() {
              return scope.data.zoom = map.getZoom();
            });
            google.maps.event.addListener(marker, 'dragend', function(event) {
              scope.data.lat = event.latLng.lat();
              return scope.data.lon = event.latLng.lng();
            });
          }
          if (newVal === "yandex") {
            map = result.map_instance;
            marker = result.marker;
            map.events.add('boundschange', function(e) {
              var newZoom, oldZoom;
              newZoom = e.get('newZoom');
              oldZoom = e.get('oldZoom');
              if (newZoom !== oldZoom) {
                return scope.data.zoom = newZoom;
              }
            });
            return marker.events.add('dragend', function(e) {
              scope.data.lat = marker.geometry.getCoordinates()[0];
              return scope.data.lon = marker.geometry.getCoordinates()[1];
            });
          }
        });
        listener3 = scope.$watch("data.pin_text", function(newVal, oldVal) {
          return updatePinText();
        });
        scope.$on("destroy", function() {
          listener1();
          listener2();
          return listener3();
        });
        updatePinText = function() {
          if (scope.data.provider === "google" && infowindow) {
            infowindow.setContent(scope.data.pin_text);
          }
          if (scope.data.provider === "yandex") {
            return marker.properties.set('balloonContent', scope.data.pin_text);
          }
        };
        scope.searchGeo = function() {
          var currentProvider;
          currentProvider = scope.data.provider;
          return providersSearchMethods[currentProvider]();
        };
        fitToMarkers = function(markers) {
          var extendPoint1, extendPoint2, index, latlng;
          bounds = new google.maps.LatLngBounds;
          for (index in markers) {
            latlng = markers[index].getPosition();
            bounds.extend(latlng);
          }
          if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
            extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.01, bounds.getNorthEast().lng() + 0.01);
            extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.01, bounds.getNorthEast().lng() - 0.01);
            bounds.extend(extendPoint1);
            bounds.extend(extendPoint2);
          }
          map.fitBounds(bounds);
        };
        googleSearchGeo = function() {
          var address;
          address = scope.data.address;
          return geocoder.geocode({
            'address': address
          }, function(results, status) {
            var location;
            if (status === google.maps.GeocoderStatus.OK) {
              location = results[0].geometry.location;
              marker.setPosition(location);
              fitToMarkers([marker]);
              scope.data.lat = location.lat();
              return scope.data.lon = location.lng();
            }
          });
        };
        yandexSearchGeo = function() {
          var myGeocoder;
          myGeocoder = ymaps.geocode(scope.data.address);
          myGeocoder.then(function(res) {
            var coords;
            coords = res.geoObjects.get(0).geometry.getCoordinates();
            map.setCenter(coords);
            bounds = res.geoObjects.get(0).properties.get('boundedBy');
            map.setBounds(bounds);
            marker.geometry.setCoordinates(coords);
            scope.data.lat = coords[0];
            return scope.data.lon = coords[1];
          });
        };
        return providersSearchMethods = {
          google: googleSearchGeo,
          yandex: yandexSearchGeo
        };
      }
    };
  }
]);


/***/ }),
/* 218 */
/***/ (function(module, exports) {

var modalSettingsModule;

modalSettingsModule = angular.module('modalWysiwyg.setting', []);

modalSettingsModule.directive("modalWysiwygSetting", [
  "$window", "$timeout", "$compile", "$templateCache", "$filter", function($window, $timeout, $compile, $templateCache, $filter) {
    return {
      restrict: "A",
      scope: {
        data: "=ngModel"
      },
      link: function(scope, element, attrs, ngModel) {
        var editBlockInit, modalContentId, params;
        params = {
          customConfig: "/components/ckeditor/ckeditor_config.js",
          enterMode: 2,
          format_tags: "h1;h2;h3;h4;h5;h6;p;div;small",
          format_small: {
            element: "h6",
            name: "Small",
            attributes: {
              "class": "small"
            }
          },
          format_div: {
            element: "div",
            name: "Обычный"
          }
        };
        modalContentId = 'str-modal-content';
        editBlockInit = function() {
          if (!CKEDITOR.instances[modalContentId]) {
            CKEDITOR.disableAutoInline = true;
            return CKEDITOR.inline("str-modal-content", params);
          }
        };
        return angular.element(element).click(function() {
          vex.defaultOptions.className = 'vex-theme-os';
          return vex.open({
            contentClassName: "vex-button__modal",
            afterOpen: function($vexContent) {
              $vexContent.append("<div id='" + modalContentId + "' style='padding-bottom:20px' contenteditable='true'>" + scope.data + "</div><button class='button button_green button_modal-save button__close-modal'>" + ($filter('translate')('widget.button.action3.modalButton')) + "</button>");
              $(".button__close-modal").click(function() {
                return vex.close();
              });
              return $timeout(function() {
                return editBlockInit();
              });
            },
            afterClose: function($vexContent) {
              scope.data = $vexContent.find("#" + modalContentId).html();
              if (!scope.$$phase) {
                scope.$apply();
              }
              CKEDITOR.instances[modalContentId].destroy();
            }
          });
        });
      }
    };
  }
]);


/***/ }),
/* 219 */
/***/ (function(module, exports) {

var newsDirective;

newsDirective = angular.module('news.setting', []);

newsDirective.directive("newsSetting", [
  "$window", "$timeout", "$compile", "$templateCache", "ns", "$rootScope", "$state", function($window, $timeout, $compile, $templateCache, ns, $rootScope, $state) {
    return {
      restrict: "A",
      scope: {
        data: "=ngModel"
      },
      link: function(scope, element, attrs, ngModel) {
        var listener, render, widgetEl;
        widgetEl = angular.element("[data-block-id='" + attrs.widgetId + "']");
        render = function(newsPage, widget) {
          var allHtml, title, titleHtml;
          allHtml = "";
          if (newsPage.length === 0) {
            allHtml = "<div style='text-align:center;'> <svg width='58' viewBox='0 0 58 58' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'> <defs> <g id='icon'> <circle cx='4.002' cy='28' r='4.001'/> <path d='M6.023 20.004c3.309 0 6 2.691 6 6.004h4.002c0-5.516-4.488-10.008-10.002-10.008v4.004zm-.027-8.004c7.719 0 14.002 6.285 14.002 14.008h4.002c0-9.93-8.076-18.008-18.004-18.008v4zm0-8c12.133 0 22.004 9.871 22.004 22.008h4c0-14.344-11.663-26.008-26.004-26.008v4z' /> </g> </defs> <use x='10' y='10' style='fill: #e6e9ef; color: #e6e9ef' xlink:href='#icon' /> </svg> </div>";
          } else {
            newsPage = angular.copy(newsPage[0]);
            newsPage.pages = newsPage.pages.slice(0, widget.max_news);
            title = newsPage.name;
            titleHtml = "<h2 class='strw-news__title'>" + title + "</h2>";
            if (widget.show_title) {
              allHtml += titleHtml;
            }
            _.each(newsPage.pages, function(post) {
              var dateAndAuthorHtml, dividerHtml, innerHtml, postHtml;
              dividerHtml = "&nbsp; &nbsp;|&nbsp;&nbsp;&nbsp; ";
              if (widget.show_author && widget.show_published_at) {
                innerHtml = "Автор: " + post.author + " " + dividerHtml + "Дата: " + post.published_at;
              } else if (widget.show_author) {
                innerHtml = "Автор: " + post.author;
              } else if (widget.show_published_at) {
                innerHtml = "Дата: " + post.published_at;
              } else {
                innerHtml = "";
              }
              dateAndAuthorHtml = "<h6 class='small' style='padding: 10px 20px 10px 0px;'> <span style='font-weight:regular;'> <span style='font-family:open sans;'> <span style='color:rgba(114, 114, 114, 1);'> " + innerHtml + " </span> </span> </span> </h6>";
              postHtml = "<article class='strw-news__post'> <h5> <span style='font-weight:600;'> <span style='font-family:open sans;'> <a class='strw-news__post-link' href='/" + $state.params.siteId + "/" + post.path + "/editor'> " + post.name + " </a> </span> </span> </h5> " + dateAndAuthorHtml + " <span style='font-weight:regular;display:block;'> <span style='font-family:open sans;'> <span style='line-height:2;'> " + post.short_text + " </span> </span> </span> <a href='/" + $state.params.siteId + "/" + post.path + "/editor' class='strw-news__read-button'>ЧИТАТЬ ДАЛЬШЕ</a> </article>";
              return allHtml += postHtml;
            });
          }
          return widgetEl.find(ns.widgetWrapperClass).html(allHtml);
        };
        listener = scope.$watch("data", function(newVal) {
          var newsPage;
          newsPage = _.filter($rootScope.site.pages, {
            id: newVal.news_id
          });
          return render(newsPage, newVal);
        }, true);
        return scope.$on("$destroy", function() {
          return listener();
        });
      }
    };
  }
]);


/***/ }),
/* 220 */
/***/ (function(module, exports) {

var paddingDirectiveModule;

paddingDirectiveModule = angular.module('padding.setting', []);

paddingDirectiveModule.directive("paddingSetting", [
  "$window", "$timeout", "$compile", "$templateCache", function($window, $timeout, $compile, $templateCache) {
    return {
      restrict: "A",
      scope: {
        data: "=ngModel",
        afterChange: '&'
      },
      templateUrl: settingFolder + "/padding/template.jade",
      link: function(scope, element, attrs, ngModel) {
        var listener, paddingSplit;
        if (!scope.data && attrs.ngModel === "widget.style_attributes.mobilePadding") {
          scope.data = "10px 10px 10px 10px";
        } else if (!scope.data) {
          scope.data = "0px 0px 0px 0px";
        }
        paddingSplit = scope.data.split(" ");
        scope.padding = {
          top: parseInt(paddingSplit[0]),
          right: parseInt(paddingSplit[1]),
          bottom: parseInt(paddingSplit[2]),
          left: parseInt(paddingSplit[3])
        };
        listener = scope.$watchCollection("padding", function(newVal) {
          return scope.data = newVal.top + "px " + newVal.right + "px " + newVal.bottom + "px " + newVal.left + "px";
        });
        return scope.$on("$destroy", function() {
          return listener();
        });
      }
    };
  }
]);


/***/ }),
/* 221 */
/***/ (function(module, exports) {

var radiusDirectiveModule,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

radiusDirectiveModule = angular.module('radius.setting', []);

radiusDirectiveModule.directive("borderRadiusSetting", [
  "$window", "$timeout", "$compile", "$templateCache", function($window, $timeout, $compile, $templateCache) {
    return {
      restrict: "A",
      scope: {
        data: "=ngModel",
        afterChange: '&'
      },
      templateUrl: settingFolder + "/radius/template.jade",
      link: function(scope, element, attrs, ngModel) {
        var listener1, listener2;
        if (!scope.data) {
          scope.data = "0px";
        }
        scope.radiusType = indexOf.call(scope.data.split(""), "%") >= 0 ? "%" : "px";
        scope.radiusValue = parseInt(scope.data);
        listener1 = scope.$watch("radiusValue", function(newVal) {
          scope.data = "" + newVal + scope.radiusType;
          if (scope.afterChange) {
            return scope.afterChange();
          }
        });
        listener2 = scope.$watch("radiusType", function(newVal) {
          scope.data = "" + scope.radiusValue + newVal;
          if (scope.afterChange) {
            return scope.afterChange();
          }
        });
        return scope.$on("$destroy", function() {
          listener1();
          return listener2();
        });
      }
    };
  }
]);


/***/ }),
/* 222 */
/***/ (function(module, exports) {

var reviewFieldsDirective;

reviewFieldsDirective = angular.module('review.setting', []);

reviewFieldsDirective.filter('toArray', [
  "$timeout", function($timeout) {
    return function(obj) {
      var result;
      result = [];
      _.each(obj, function(val, hash) {
        return result.push({
          name: val,
          value: hash
        });
      });
      return result;
    };
  }
]);

reviewFieldsDirective.directive("reviewsFieldsSetting", [
  "$window", "$timeout", "$compile", "$templateCache", "ns", "translitService", "ContentEditable", "Widget", "blockEditDialog", "Slider", "$rootScope", "Restangular", function($window, $timeout, $compile, $templateCache, ns, translitService, ContentEditable, Widget, blockEditDialog, Slider, $rootScope, Restangular) {
    return {
      restrict: "A",
      scope: {
        data: "=ngModel"
      },
      templateUrl: settingFolder + "/reviewfields/template.jade",
      link: function(scope, element, attrs, ngModel) {
        var _onChangeSliderSettings, _onSlideChangeStart, availableFieldIndex, changeMediaType, changeType, getNotDestroyedFieldRnd, id, listener1, listener2, newSwiperThumbs, reInitSlider, removeCurrentSlide, renderPhotos, renderTexts, sectionId, setCols, setSlidesStyles, slideWithListFields, sliderElement, trimNbsp, widgetElWrapper;
        id = attrs.widgetId;
        widgetElWrapper = angular.element("[data-block-id=" + id + "]").find(ns.widgetWrapperClass);
        scope.review = angular.copy(scope.data);
        sectionId = blockEditDialog.getSectionId({
          id: id
        });
        slideWithListFields = false;
        sliderElement = widgetElWrapper.find('.strw-slider')[0].swiper;
        scope.Editor = angular.copy(window.Editor);
        if (widgetElWrapper.find('.gallery-thumbs')[0]) {
          newSwiperThumbs = widgetElWrapper.find('.gallery-thumbs')[0].swiper;
        }
        scope.fieldsLength = function(fields) {
          var destroyed;
          destroyed = _.filter(fields, {
            _destroy: true
          });
          return fields.length - destroyed.length;
        };
        getNotDestroyedFieldRnd = function() {
          var fields;
          fields = [];
          _.each(scope.review.photos_attributes, function(field, index) {
            if (!field._destroy) {
              return fields.push(index);
            }
          });
          if (fields.length > 0) {
            return fields[fields.length - 1];
          } else {
            return 0;
          }
        };
        trimNbsp = function(fields) {
          var field, i, len;
          for (i = 0, len = fields.length; i < len; i++) {
            field = fields[i];
            field.text = field.text.replace(/&nbsp;/gi, '');
            field.name = field.name.replace(/&nbsp;/gi, '');
            field.vocation = field.vocation.replace(/&nbsp;/gi, '');
          }
          return fields;
        };
        scope.currentField = getNotDestroyedFieldRnd();
        availableFieldIndex = function(slider) {
          var i, index, len, photo, ref, slide, sliderId;
          slide = widgetElWrapper.find(".swiper-slide-active");
          sliderId = $(slide).data("slide-id");
          ref = scope.review.photos_attributes;
          for (index = i = 0, len = ref.length; i < len; index = ++i) {
            photo = ref[index];
            if (photo.id === sliderId) {
              return index;
            }
          }
        };
        _onSlideChangeStart = function(slider) {
          if (!slideWithListFields) {
            return $timeout(function() {
              return scope.currentField = availableFieldIndex(slider);
            });
          }
        };
        reInitSlider = function(slider) {
          var sliders;
          sliders = Slider.initSlider(0, slider, _onSlideChangeStart);
          sliderElement = sliders[0];
          return newSwiperThumbs = sliders[1];
        };
        reInitSlider(widgetElWrapper.find("." + ns.sliderClass));
        scope.setCurrentSlide = function($index) {
          var index, slideId;
          scope.currentField = $index;
          slideId = scope.review.photos_attributes[scope.currentField].id;
          index = $("[data-slide-id='" + slideId + "']").index();
          slideWithListFields = true;
          sliderElement.slideTo(index);
          return slideWithListFields = false;
        };
        scope.add = function() {
          var params;
          sectionId = blockEditDialog.getSectionId({
            id: id
          });
          params = {
            photos_attributes: [
              {
                remote_file_url: Restangular.configuration.baseUrl + "/assets/widgets/review/img1.jpg"
              }
            ]
          };
          return Widget.createItem(sectionId, id, params).then(function(data) {
            var length, newSlide, newSlideHTML;
            newSlide = data.photos_attributes[data.photos_attributes.length - 1];
            scope.review.photos_attributes.push(newSlide);
            length = scope.review.photos_attributes.length;
            newSlideHTML = "<div class='swiper-slide strw-review__item strw-review__item-col' data-slide-id='" + newSlide.id + "'> <div class='strw-review__image-wrapper'> <img class='strw-review__image' src='" + newSlide.file_url + "' alt='{{photo.text}}'> </div> <div class='strw-review__video' style='height: " + newSlide.video_height + "px'> <iframe width='100%' height='100%' src='' frameborder='0' allowfullscreen=''></iframe> </div> <div class='strw-review__content-wrapper'> <p class='strw-review__text' contenteditable='false' data-access='photos_attributes." + (length - 1) + ".text'>" + newSlide.text + "</p> <p class='strw-review__name' contenteditable='false' data-access='photos_attributes." + (length - 1) + ".name'>" + newSlide.name + "</p> <p class='strw-review__vocation' contenteditable='false' data-access='photos_attributes." + (length - 1) + ".vocation'>" + newSlide.vocation + "</p> </div> </div>";
            if (!scope.data.show_image) {
              $("[data-slide-id='" + newSlide.id + "']").find(".strw-review__image-wrapper").hide();
            }
            if (scope.data.slider) {
              sliderElement.appendSlide(newSlideHTML);
              scope.setCurrentSlide(length - 1, newSlide);
              setSlidesStyles(scope.data.reviews_style);
            } else {
              widgetElWrapper.find(".strw-review__wrapper").append(newSlideHTML);
            }
            blockEditDialog._onVideoChange(newSlide, scope.review, "[data-slide-id='" + newSlide.id + "'] .strw-review__video");
            return ContentEditable.bind(false, true, id);
          });
        };
        removeCurrentSlide = function() {
          var index, slideId;
          slideId = scope.review.photos_attributes[scope.currentField].id;
          index = $("[data-slide-id='" + slideId + "']").index();
          $("[data-slide-id='" + slideId + "']").remove();
          return sliderElement.removeSlide(index);
        };
        scope.remove = function() {
          scope.review.photos_attributes[scope.currentField]._destroy = true;
          removeCurrentSlide();
          scope.currentField = getNotDestroyedFieldRnd();
          if (scope.data.slider) {
            return scope.setCurrentSlide(getNotDestroyedFieldRnd());
          }
        };
        changeType = function(newVal, oldVal) {
          var sliderEl;
          if (newVal.slider === oldVal.slider) {
            return false;
          }
          sliderEl = widgetElWrapper.find("." + ns.sliderClass);
          if (newVal.slider) {
            sliderEl.addClass("swiper-container");
            sliderEl.find(".strw-review__wrapper").addClass("swiper-wrapper");
            sliderEl.find(".swiper-pagination").show();
            sliderEl.find(".swiper-button-prev").show();
            sliderEl.find(".swiper-button-next").show();
            return reInitSlider(sliderEl);
          } else {
            $(sliderEl)[0].swiper.destroy(true, true);
            delete $(sliderEl)[0].swiper;
            sliderEl.find(".swiper-pagination").hide();
            sliderEl.find(".swiper-button-prev").hide();
            sliderEl.find(".swiper-button-next").hide();
            sliderEl.removeClass("swiper-container");
            sliderEl.find(".strw-review__wrapper").removeClass("swiper-wrapper");
          }
        };
        setCols = function(newVal, oldVal) {
          if (newVal === oldVal) {
            return false;
          }
          if (!scope.data.slider) {
            return widgetElWrapper.find(".strw-review__item").addClass("strw-review__item-col");
          } else {
            return widgetElWrapper.find(".strw-review__item").removeClass("strw-review__item-col");
          }
        };
        listener1 = scope.$watch("review.photos_attributes", function(newVal, oldVal) {
          return scope.data.photos_attributes = trimNbsp(newVal);
        }, true);
        listener2 = scope.$watch("data", function(newVal, oldVal) {
          changeMediaType(newVal);
          renderTexts(newVal);
          renderPhotos(newVal);
          _onChangeSliderSettings(newVal, oldVal);
          changeType(newVal, oldVal);
          return setCols(newVal, oldVal);
        }, true);
        scope.$on("$destroy", function() {
          listener1();
          return listener2();
        });
        _onChangeSliderSettings = function(newVal, oldVal) {
          var settings, widgetSlider;
          if (!angular.equals(newVal.settings, oldVal.settings)) {
            widgetSlider = widgetElWrapper.find("." + ns.sliderClass);
            settings = angular.copy(newVal.settings);
            widgetSlider.data("slider-settings", settings);
            reInitSlider(widgetElWrapper.find("." + ns.sliderClass));
          }
          if (!angular.equals(newVal.reviews_style, oldVal.reviews_style)) {
            setSlidesStyles(newVal.reviews_style);
          }
          return widgetElWrapper.find("[data-slide-id='" + newVal.photos_attributes[scope.currentField].id + "'] .strw-review__video").css("height", newVal.photos_attributes[scope.currentField].video_height);
        };
        setSlidesStyles = function(newVal) {
          var widgetSlider;
          widgetSlider = widgetElWrapper.find("." + ns.sliderClass);
          return widgetSlider.find(".strw-review__item").css(newVal);
        };
        changeMediaType = function(newVal) {
          if (newVal.show_image) {
            widgetElWrapper.find(".strw-review__image-wrapper").css("display", "inline-block");
            widgetElWrapper.find(".strw-review__video").show();
            return newVal.photos_attributes.forEach(function(photo) {
              if (photo.media_type === "image") {
                widgetElWrapper.find("[data-slide-id='" + photo.id + "'] .strw-review__image-wrapper").css("display", "inline-block");
                widgetElWrapper.find("[data-slide-id='" + photo.id + "'] .strw-review__video").hide();
              }
              if (photo.media_type === "video") {
                widgetElWrapper.find("[data-slide-id='" + photo.id + "'] .strw-review__image-wrapper").hide();
                return widgetElWrapper.find("[data-slide-id='" + photo.id + "'] .strw-review__video").show();
              }
            });
          } else {
            widgetElWrapper.find(".strw-review__image-wrapper").hide();
            return widgetElWrapper.find(".strw-review__video").hide();
          }
        };
        renderPhotos = function(newVal) {
          return _.each(newVal.photos_attributes, function(photo) {
            return $("[data-slide-id='" + photo.id + "']").find(".strw-review__image").attr("src", photo.file_url);
          });
        };
        return renderTexts = function(newVal) {
          var image, name, text, video, vocation;
          text = widgetElWrapper.find(".strw-review__text");
          name = widgetElWrapper.find(".strw-review__name");
          vocation = widgetElWrapper.find(".strw-review__vocation");
          image = widgetElWrapper.find(".strw-review__image-wrapper");
          video = widgetElWrapper.find(".strw-review__video");
          if (newVal.show_text) {
            text.show();
          } else {
            text.hide();
          }
          if (newVal.show_name) {
            name.show();
          } else {
            name.hide();
          }
          if (newVal.show_vocation) {
            vocation.show();
          } else {
            vocation.hide();
          }
          if (newVal.full_width_image) {
            image.css({
              width: "100%"
            });
          } else {
            image.css({
              width: "auto"
            });
          }
          text.css(newVal.text_style);
          name.css(newVal.name_style);
          vocation.css(newVal.vocation_style);
          return image.find("img").css(newVal.photos_style);
        };
      }
    };
  }
]);


/***/ }),
/* 223 */
/***/ (function(module, exports) {

var siteBgSettingsDirective;

siteBgSettingsDirective = angular.module('sitebg.setting', []);

siteBgSettingsDirective.directive("siteBgSettings", [
  "$window", "$timeout", "$compile", "$templateCache", "ns", "translitService", "ContentEditable", "Widget", "blockEditDialog", "$rootScope", "Parallax", "Page", "$translate", "$filter", function($window, $timeout, $compile, $templateCache, ns, translitService, ContentEditable, Widget, blockEditDialog, $rootScope, Parallax, Page, $translate, $filter) {
    return {
      restrict: "A",
      scope: {
        data: "=ngModel"
      },
      templateUrl: settingFolder + "/siteBgSettings/template.jade",
      link: function(scope, element, attrs, ngModel) {
        var bodyElement, listener, listener2, removeGradient, renderImageBg, renderStyleBg, setGradient, setSectionBgCover, setSectionBgFixed, setSectionBgNoEffect, setSectionBgNoOption, setSectionBgParallax, setSectionBgRepeat;
        bodyElement = $("#tpl-wrapper");
        scope.reloadUploader = true;
        renderStyleBg = function(newVal) {
          return bodyElement.css(newVal);
        };
        scope.removePageBackground = function() {
          scope.reloadUploader = false;
          return Page.remove_background($rootScope.currentPage.id).then(function() {
            scope.data.background_attributes.image_attributes = null;
            renderImageBg(scope.data.background_attributes);
            return scope.reloadUploader = true;
          });
        };
        renderImageBg = function(newVal) {
          if (newVal.image_attributes && newVal.image_attributes.source_url) {
            bodyElement.css({
              backgroundImage: "url('" + newVal.image_attributes.source_url + "')"
            });
          } else {
            bodyElement.css({
              backgroundImage: ""
            });
          }
          if (newVal.gradient) {
            setGradient(newVal);
          } else {
            removeGradient();
          }
          if (newVal.parallax) {
            scope.data.style_attributes.backgroundPosition = "center 0px";
            return Parallax.initSection($rootScope.Y.one("#tpl-wrapper"));
          } else {
            scope.data.style_attributes.backgroundPosition = "";
            return Parallax.destroy($rootScope.Y.one("#tpl-wrapper"));
          }
        };
        listener = scope.$watch("data.style_attributes", function(newVal) {
          return renderStyleBg(newVal);
        }, true);
        listener2 = scope.$watch("data.background_attributes", function(newVal) {
          return renderImageBg(newVal);
        }, true);
        removeGradient = function(background_attributes) {
          if ($("style#" + $rootScope.currentPage.id).length > 0) {
            return $("style#" + $rootScope.currentPage.id).html("#tpl-wrapper:before { background-image:none; }");
          } else {
            return $('body').append("<style id='" + $rootScope.currentPage.id + "'>#tpl-wrapper:before { background-image:none; }</style>");
          }
        };
        setGradient = function(background_attributes) {
          var color_start, color_stop, gradient_css;
          color_start = background_attributes.color_start;
          color_stop = background_attributes.color_stop;
          gradient_css = "background-image:-moz-linear-gradient(top, " + color_start + ", " + color_stop + "); background-image:-webkit-linear-gradient(top, " + color_start + ", " + color_stop + "); background-image:-o-linear-gradient(top, " + color_start + ", " + color_stop + "); background-image:-ms-linear-gradient(top, " + color_start + ", " + color_stop + ");, background-image:linear-gradient(top, " + color_start + ", " + color_stop + "); filter: progid:DXImageTransform.Microsoft.gradient(startColorStr='" + color_start + "', endColorstr='" + color_stop + "');";
          if ($("style#" + $rootScope.currentPage.id).length > 0) {
            return $("style#" + $rootScope.currentPage.id).html("#tpl-wrapper:before { " + gradient_css + " }");
          } else {
            return $('body').append("<style id='" + $rootScope.currentPage.id + "'>#tpl-wrapper:before { " + gradient_css + " }</style>");
          }
        };
        setSectionBgFixed = function(page) {
          page.style_attributes.backgroundAttachment = "fixed";
          return page.background_attributes.parallax = false;
        };
        setSectionBgParallax = function(page) {
          page.style_attributes.backgroundAttachment = "inherit";
          return page.background_attributes.parallax = true;
        };
        setSectionBgNoEffect = function(page) {
          page.background_attributes.parallax = false;
          return page.style_attributes.backgroundAttachment = "inherit";
        };
        setSectionBgRepeat = function(page) {
          page.style_attributes.backgroundRepeat = "repeat";
          return page.style_attributes.backgroundSize = "initial";
        };
        setSectionBgCover = function(page) {
          page.style_attributes.backgroundRepeat = "no-repeat";
          return page.style_attributes.backgroundSize = "cover";
        };
        setSectionBgNoOption = function(page) {
          page.style_attributes.backgroundRepeat = "no-repeat";
          return page.style_attributes.backgroundSize = "initial";
        };
        scope.bgOptions = [
          {
            name: "none",
            name_ru: $filter('translate')('editor.panel.blockSettings.section.background1.size1')
          }, {
            name: "repeat",
            name_ru: $filter('translate')('editor.panel.blockSettings.section.background1.size2')
          }, {
            name: "cover",
            name_ru: $filter('translate')('editor.panel.blockSettings.section.background1.size3')
          }
        ];
        scope.contentEffects = [
          {
            name: "none",
            name_ru: $filter('translate')("editor.panel.blockSettings.section.effect1")
          }, {
            name: "top",
            name_ru: $filter('translate')("editor.panel.blockSettings.section.effect2")
          }, {
            name: "left",
            name_ru: $filter('translate')("editor.panel.blockSettings.section.effect3")
          }, {
            name: "right",
            name_ru: $filter('translate')("editor.panel.blockSettings.section.effect4")
          }, {
            name: "bottom",
            name_ru: $filter('translate')("editor.panel.blockSettings.section.effect5")
          }, {
            name: "fade",
            name_ru: $filter('translate')("editor.panel.blockSettings.section.effect6")
          }, {
            name: "zoom",
            name_ru: $filter('translate')("editor.panel.blockSettings.section.effect7")
          }
        ];
        scope.getNameContentType = function(type) {
          switch (type) {
            case "none":
              return scope.contentEffects[0].name_ru;
            case "top":
              return scope.contentEffects[1].name_ru;
            case "left":
              return scope.contentEffects[2].name_ru;
            case "right":
              return scope.contentEffects[3].name_ru;
            case "bottom":
              return scope.contentEffects[4].name_ru;
            case "fade":
              return scope.contentEffects[5].name_ru;
            case "zoom":
              return scope.contentEffects[6].name_ru;
          }
        };
        scope.setBgOption = function(name, page) {
          switch (name) {
            case "none":
              setSectionBgNoOption(page);
              break;
            case "repeat":
              setSectionBgRepeat(page);
              break;
            case "cover":
              setSectionBgCover(page);
          }
        };
        scope.bgEffects = [
          {
            name: "none",
            name_ru: $filter('translate')("editor.panel.blockSettings.section.background1.backgroundEffect1")
          }, {
            name: "fixed",
            name_ru: $filter('translate')("editor.panel.blockSettings.section.background1.backgroundEffect2")
          }, {
            name: "parallax",
            name_ru: $filter('translate')("editor.panel.blockSettings.section.background1.backgroundEffect3")
          }
        ];
        scope.setBgEffect = function(name, section) {
          switch (name) {
            case "none":
              setSectionBgNoEffect(section);
              break;
            case "fixed":
              setSectionBgFixed(section);
              break;
            case "parallax":
              setSectionBgParallax(section);
          }
        };
        return scope.$on("$destroy", function() {
          return listener();
        });
      }
    };
  }
]);


/***/ }),
/* 224 */
/***/ (function(module, exports) {

var sizeDirectiveModule;

sizeDirectiveModule = angular.module('size.setting', []);

sizeDirectiveModule.directive("sizeSetting", [
  "$window", "$timeout", "$compile", "$templateCache", function($window, $timeout, $compile, $templateCache) {
    return {
      restrict: "A",
      scope: {
        data: "=ngModel"
      },
      templateUrl: settingFolder + "/size/template.jade",
      link: function(scope, element, attrs, ngModel) {
        var listener;
        if (angular.isDefined(scope.data)) {
          scope.size = parseInt(scope.data);
        }
        listener = scope.$watch("size", function(newVal) {
          return scope.data = newVal + "px";
        });
        return scope.$on("$destroy", function() {
          return listener();
        });
      }
    };
  }
]);


/***/ }),
/* 225 */
/***/ (function(module, exports) {

var sizeSelectDirectiveModule,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

sizeSelectDirectiveModule = angular.module('sizeSelect.setting', []);

sizeSelectDirectiveModule.directive("sizeSelectSetting", [
  "$window", "$timeout", "$compile", "$templateCache", function($window, $timeout, $compile, $templateCache) {
    return {
      restrict: "A",
      scope: {
        data: "=ngModel",
        sizeBlur: '&'
      },
      templateUrl: settingFolder + "/sizeSelect/template.jade",
      link: function(scope, element, attrs, ngModel) {
        var isInt, listener1, listener2;
        isInt = function(n) {
          return Number(n) === n && n % 1 === 0;
        };
        if (!scope.data) {
          scope.data = "0px";
        }
        if (isInt(scope.data)) {
          scope.data = scope.data + "px";
        }
        scope.sizeType = indexOf.call(scope.data.split(""), "%") >= 0 ? "%" : "px";
        scope.sizeValue = parseInt(scope.data);
        listener1 = scope.$watch("sizeValue", function(newVal) {
          return scope.data = "" + newVal + scope.sizeType;
        });
        listener2 = scope.$watch("sizeType", function(newVal, oldVal) {
          scope.data = "" + scope.sizeValue + newVal;
          if (newVal !== oldVal && scope.sizeBlur) {
            return scope.sizeBlur();
          }
        });
        return scope.$on("$destroy", function() {
          listener1();
          return listener2();
        });
      }
    };
  }
]);


/***/ }),
/* 226 */
/***/ (function(module, exports) {

var sliderSizeModule,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

sliderSizeModule = angular.module('slidersize.setting', []);

sliderSizeModule.directive("slidersizeSetting", [
  "$window", "$timeout", "$compile", "$templateCache", function($window, $timeout, $compile, $templateCache) {
    return {
      restrict: "A",
      scope: {
        data: "=ngModel"
      },
      templateUrl: settingFolder + "/sliderSize/template.jade",
      link: function(scope, element, attrs, ngModel) {
        var listener1, listener2;
        if (!scope.data) {
          scope.data = "0px";
        }
        scope.radiusType = indexOf.call(scope.data.split(""), "%") >= 0 ? "%" : "px";
        scope.radiusValue = parseInt(scope.data);
        listener1 = scope.$watch("radiusValue", function(newVal) {
          return scope.data = "" + newVal + scope.radiusType;
        });
        listener2 = scope.$watch("radiusType", function(newVal) {
          return scope.data = "" + scope.radiusValue + newVal;
        });
        return scope.$on("$destroy", function() {
          listener1();
          return listener2();
        });
      }
    };
  }
]);


/***/ }),
/* 227 */
/***/ (function(module, exports) {

var sliderFieldsDirective;

sliderFieldsDirective = angular.module('sliderfields.setting', []);

sliderFieldsDirective.filter('toArray', [
  "$timeout", function($timeout) {
    return function(obj) {
      var result;
      result = [];
      _.each(obj, function(val, hash) {
        return result.push({
          name: val,
          value: hash
        });
      });
      return result;
    };
  }
]);

sliderFieldsDirective.directive("sliderFieldsSetting", [
  "$window", "$timeout", "$compile", "$templateCache", "ns", "translitService", "ContentEditable", "Widget", "blockEditDialog", "Slider", "Restangular", function($window, $timeout, $compile, $templateCache, ns, translitService, ContentEditable, Widget, blockEditDialog, Slider, Restangular) {
    return {
      restrict: "A",
      scope: {
        data: "=ngModel"
      },
      templateUrl: settingFolder + "/sliderfields/template.jade",
      link: function(scope, element, attrs, ngModel) {
        var _onChangeSliderSettings, _onSlideChangeStart, availableFieldIndex, getNotDestroyedFieldRnd, id, listener1, listener2, newSwiperThumbs, reInitSlider, removeCurrentSlide, renderCaption, renderPhotos, sectionId, setSlidesStyles, slideWithListFields, sliderElement, thumbsSliderRender, trimNbsp, widgetElWrapper;
        id = attrs.widgetId;
        widgetElWrapper = angular.element("[data-block-id=" + id + "]").find(ns.widgetWrapperClass);
        scope.slider = angular.copy(scope.data);
        slideWithListFields = false;
        sliderElement = widgetElWrapper.find('.strw-slider')[0].swiper;
        sectionId = blockEditDialog.getSectionId({
          id: id
        });
        if (widgetElWrapper.find('.gallery-thumbs')[0]) {
          newSwiperThumbs = widgetElWrapper.find('.gallery-thumbs')[0].swiper;
        }
        getNotDestroyedFieldRnd = function() {
          var fields;
          fields = [];
          _.each(scope.slider.photos_attributes, function(field, index) {
            if (!field._destroy) {
              return fields.push(index);
            }
          });
          if (fields.length > 0) {
            return fields[fields.length - 1];
          } else {
            return 0;
          }
        };
        trimNbsp = function(fields) {
          var field, i, len;
          for (i = 0, len = fields.length; i < len; i++) {
            field = fields[i];
            field.caption = field.caption.replace(/&nbsp;/gi, '');
          }
          return fields;
        };
        scope.currentField = getNotDestroyedFieldRnd();
        availableFieldIndex = function(slider) {
          var i, index, len, photo, ref, slide, sliderId;
          slide = widgetElWrapper.find(".swiper-slide-active");
          sliderId = $(slide).data("slide-id");
          ref = scope.slider.photos_attributes;
          for (index = i = 0, len = ref.length; i < len; index = ++i) {
            photo = ref[index];
            if (photo.id === sliderId) {
              return index;
            }
          }
        };
        _onSlideChangeStart = function(slider) {
          if (!slideWithListFields) {
            return $timeout(function() {
              return scope.currentField = availableFieldIndex(slider);
            });
          }
        };
        reInitSlider = function(slider) {
          var sliders;
          sliders = Slider.initSlider(0, slider, _onSlideChangeStart);
          sliderElement = sliders[0];
          return newSwiperThumbs = sliders[1];
        };
        reInitSlider(widgetElWrapper.find("." + ns.sliderClass));
        scope.setCurrentSlide = function($index) {
          var index, slideId;
          scope.currentField = $index;
          slideId = scope.slider.photos_attributes[scope.currentField].id;
          index = $("[data-slide-id='" + slideId + "']").index();
          slideWithListFields = true;
          sliderElement.slideTo(index);
          return slideWithListFields = false;
        };
        scope.add = function() {
          var params;
          sectionId = blockEditDialog.getSectionId({
            id: id
          });
          params = {
            photos_attributes: [
              {
                remote_file_url: Restangular.configuration.baseUrl + "/assets/widgets/slider/img3.jpg"
              }
            ]
          };
          return Widget.createItem(sectionId, id, params).then(function(data) {
            var length, newSlide, newSlideHTML, newSlideThumbHTML;
            newSlide = data.photos_attributes[data.photos_attributes.length - 1];
            scope.slider.photos_attributes.push(newSlide);
            length = scope.slider.photos_attributes.length;
            newSlideHTML = "<div class='swiper-slide strw-slider__item' data-slide-id='" + newSlide.id + "'> <div class='strw-slider__image-wrapper'> <div class='strw-slider__image strw-slider__image_cover' style='background-image: url(" + newSlide.file_url + ")'></div> </div> <p class='strw-slider__caption' contenteditable='false' data-access='photos_attributes." + (length - 1) + ".caption'>" + newSlide.caption + "</p> </div>";
            newSlideThumbHTML = "<div class='swiper-slide strw-slider__item' data-slide-id='" + newSlide.id + "'> <div class='strw-slider__image-wrapper'> <div class='strw-slider__image strw-slider__image_cover strw-slider__image_cover-thumb' style='background-image: url(" + newSlide.file_url + ")'></div> </div> </div>";
            sliderElement.appendSlide(newSlideHTML);
            if (newSwiperThumbs) {
              newSwiperThumbs.appendSlide(newSlideThumbHTML);
            }
            scope.setCurrentSlide(length - 1, newSlide);
            setSlidesStyles(scope.data.slides_style);
            return ContentEditable.bind(false, true, id);
          });
        };
        scope.fieldsLength = function(fields) {
          var destroyed;
          destroyed = _.filter(fields, {
            _destroy: true
          });
          return fields.length - destroyed.length;
        };
        removeCurrentSlide = function() {
          var index, slideId;
          slideId = scope.slider.photos_attributes[scope.currentField].id;
          index = $("[data-slide-id='" + slideId + "']").index();
          sliderElement.removeSlide(index);
          if (newSwiperThumbs) {
            return newSwiperThumbs.removeSlide(index);
          }
        };
        scope.remove = function() {
          scope.slider.photos_attributes[scope.currentField]._destroy = true;
          removeCurrentSlide();
          return scope.setCurrentSlide(getNotDestroyedFieldRnd());
        };
        listener1 = scope.$watch("slider.photos_attributes", function(newVal, oldVal) {
          return scope.data.photos_attributes = trimNbsp(newVal);
        }, true);
        listener2 = scope.$watch("data", function(newVal, oldVal) {
          renderCaption(newVal);
          renderPhotos(newVal);
          return _onChangeSliderSettings(newVal, oldVal);
        }, true);
        scope.$on("$destroy", function() {
          listener1();
          return listener2();
        });
        _onChangeSliderSettings = function(newVal, oldVal) {
          var settings, widgetSlider;
          if (!angular.equals(newVal.settings, oldVal.settings)) {
            thumbsSliderRender(newVal.settings);
            widgetSlider = widgetElWrapper.find("." + ns.sliderClass);
            settings = angular.copy(newVal.settings);
            widgetSlider.data("slider-settings", settings);
            reInitSlider(widgetElWrapper.find("." + ns.sliderClass));
          }
          if (!angular.equals(newVal.slides_style, oldVal.slides_style)) {
            return setSlidesStyles(newVal.slides_style);
          }
        };
        thumbsSliderRender = function(newVal) {
          var newSliderThumbsHTML;
          if (newVal.thumbs) {
            if (!widgetElWrapper.find(".gallery-thumbs").length) {
              newSliderThumbsHTML = widgetElWrapper.find("." + ns.sliderClass).clone();
              newSliderThumbsHTML.removeClass("strw-slider").removeAttr("data-slider-settings").addClass("gallery-thumbs");
              newSliderThumbsHTML.find(".strw-slider__image").addClass("strw-slider__image_cover-thumb").css("height", "auto");
              newSliderThumbsHTML.find(".swiper-slide").removeAttr("style");
              newSliderThumbsHTML.find(".swiper-button-prev").remove();
              newSliderThumbsHTML.find(".swiper-button-next").remove();
              newSliderThumbsHTML.find(".swiper-pagination").remove();
              newSliderThumbsHTML.find(".strw-slider__caption").remove();
              return widgetElWrapper.find("." + ns.sliderClass).after(newSliderThumbsHTML);
            }
          } else {
            widgetElWrapper.find(".gallery-thumbs").remove();
          }
        };
        setSlidesStyles = function(newVal) {
          var widgetSlider;
          widgetSlider = widgetElWrapper.find("." + ns.sliderClass);
          return widgetSlider.find("." + ns.sliderSlideClass).css(newVal);
        };
        renderPhotos = function(newVal) {
          return _.each(newVal.photos_attributes, function(photo) {
            return $("[data-slide-id='" + photo.id + "']").find(".strw-slider__image_cover").css("background-image", "url('" + photo.file_url + "')");
          });
        };
        return renderCaption = function(newVal) {
          var caption, pagination;
          pagination = widgetElWrapper.find(".swiper-pagination");
          caption = widgetElWrapper.find(".strw-slider__caption");
          if (newVal.show_caption) {
            caption.show();
            pagination.addClass("swiper__with-caption");
          } else {
            pagination.removeClass("swiper__with-caption");
            caption.hide();
          }
          return caption.css(newVal.caption_style);
        };
      }
    };
  }
]);


/***/ }),
/* 228 */
/***/ (function(module, exports) {

var socialFieldsSettingDirective;

socialFieldsSettingDirective = angular.module('socialfields.setting', []);

socialFieldsSettingDirective.filter('toArray', [
  "$timeout", function($timeout) {
    return function(obj) {
      var result;
      result = [];
      _.each(obj, function(val, hash) {
        return result.push({
          name: val,
          value: hash
        });
      });
      return result;
    };
  }
]);

socialFieldsSettingDirective.directive("socialFieldsSetting", [
  "$window", "$timeout", "$compile", "$templateCache", "ns", "translitService", "ContentEditable", function($window, $timeout, $compile, $templateCache, ns, translitService, ContentEditable) {
    return {
      restrict: "A",
      scope: {
        data: "=ngModel"
      },
      templateUrl: settingFolder + "/socialfields/template.jade",
      link: function(scope, element, attrs, ngModel) {
        var id, listener, renderIcons, widgetElWrapper;
        id = attrs.widgetId;
        widgetElWrapper = angular.element("[data-block-id=" + id + "]").find(ns.widgetWrapperClass);
        scope.social = angular.copy(scope.data);
        listener = scope.$watch("data", function(newVal) {
          return renderIcons(newVal);
        }, true);
        scope.$on("$destroy", function() {
          return listener();
        });
        return renderIcons = function(newVal) {
          var iconsHtml, widgetSocialWrapper;
          widgetSocialWrapper = widgetElWrapper.find(".strw__social-wrapper");
          iconsHtml = "";
          _.each(newVal.icons_attributes, function(icon) {
            var color, iconHtml;
            if (icon.enabled) {
              color = newVal.color_type === "custom" ? newVal.style_attributes.color : icon.style_attributes.color;
              iconHtml = "<a href='javascript:void(0)' class='strw__social-link' style='color: " + color + ";'><span class='strw__social-icon'>" + icon.content + "</span></a>";
              return iconsHtml += iconHtml;
            }
          });
          widgetSocialWrapper.html(iconsHtml);
          return widgetSocialWrapper.find(".strw__social-link").css({
            margin: newVal.icons_margin
          });
        };
      }
    };
  }
]);


/***/ }),
/* 229 */
/***/ (function(module, exports) {

var tableFieldsDirective;

tableFieldsDirective = angular.module('tablefields.setting', []);

tableFieldsDirective.directive("tableFieldsSetting", [
  "$window", "$timeout", "$compile", "$templateCache", "ns", "translitService", "Widget", "blockEditDialog", "ContentEditable", function($window, $timeout, $compile, $templateCache, ns, translitService, Widget, blockEditDialog, ContentEditable) {
    return {
      restrict: "A",
      scope: {
        data: "=ngModel"
      },
      templateUrl: settingFolder + "/tablefields/template.jade",
      link: function(scope, element, attrs, ngModel) {
        var changeDesign, generateTRHead, generateTRbody, generateTable, getNotDestroyedFieldRnd, id, listener1, listener2, listener3, listener4, listener5, listener6, listener7, sectionId, widgetElWrapper;
        id = attrs.widgetId;
        widgetElWrapper = angular.element("[data-block-id=" + id + "]").find(ns.widgetWrapperClass);
        scope.table = angular.copy(scope.data);
        sectionId = blockEditDialog.getSectionId({
          id: id
        });
        widgetElWrapper.find("a").click(function(e) {
          return e.preventDefault();
        });
        getNotDestroyedFieldRnd = function() {
          var fields;
          fields = [];
          _.each(scope.table.items_attributes, function(field, index) {
            if (!field._destroy) {
              return fields.push(index);
            }
          });
          if (fields.length > 0) {
            return fields[fields.length - 1];
          } else {
            return 0;
          }
        };
        scope.currentField = getNotDestroyedFieldRnd();
        scope.fieldsLength = function(fields) {
          var destroyed;
          destroyed = _.filter(fields, {
            _destroy: true
          });
          return fields.length - destroyed.length;
        };
        scope.setCurrentImage = function($index) {
          return scope.currentField = $index;
        };
        generateTRHead = function() {
          var HTML, buttonHTML, descriptionHTML, extraHTML, priceHTML;
          if (scope.data.show_description) {
            descriptionHTML = "<td itemprop='description'><div contenteditable='false' spellcheck='false' data-access='description_title'>" + scope.data.description_title + "</div></td>";
          }
          if (scope.data.show_extra) {
            extraHTML = "<td><div contenteditable='false' spellcheck='false' data-access='extra_title'>" + scope.data.extra_title + "</div></td>";
          }
          if (scope.data.show_price) {
            priceHTML = "<td itemprop='offers' itemscope='' itemtype='http://schema.org/Offer'> <div contenteditable='false' spellcheck='false' data-access='price_title'>" + scope.data.price_title + " <meta itemprop='price' content='" + scope.data.price_title + "'> </div></td>";
          }
          if (scope.data.show_button) {
            buttonHTML = "<td></td>";
          }
          HTML = "<tr itemscope='' itemtype='http://schema.org/Product'> <td itemprop='name'><div contenteditable='false' spellcheck='false' data-access='name_title'>" + scope.data.name_title + "</div></td> " + (descriptionHTML || "") + " " + (extraHTML || "") + " " + (priceHTML || "") + " " + (buttonHTML || "") + " </tr>";
          return HTML;
        };
        generateTRbody = function(newRow, index) {
          var HTML, buttonHTML, descriptionHTML, extraHTML, priceHTML;
          if (scope.data.show_description) {
            descriptionHTML = "<td itemprop='description'><div contenteditable='false' spellcheck='false' data-access='items_attributes." + index + ".description'>" + newRow.description + "</div></td>";
          }
          if (scope.data.show_extra) {
            extraHTML = "<td><div contenteditable='false' spellcheck='false' data-access='items_attributes." + index + ".extra'>" + newRow.extra + "</div></td>";
          }
          if (scope.data.show_price) {
            priceHTML = "<td itemprop='offers' itemscope='' itemtype='http://schema.org/Offer'> <div contenteditable='false' spellcheck='false' data-access='items_attributes." + index + ".price'>" + newRow.price + " <meta itemprop='price' content='" + newRow.price + "'> </div></td>";
          }
          if (scope.data.show_button) {
            buttonHTML = "<td class='ul-w-price-item-button'><a role='button' href='javascript: void(0)' contenteditable='false' spellcheck='false' data-access='items_attributes." + index + ".caption'>" + newRow.caption + "</a></td>";
          }
          HTML = "<tr data-item-id='" + newRow.id + "' itemscope='' itemtype='http://schema.org/Product'> <td itemprop='name'><div contenteditable='false' spellcheck='false' data-access='items_attributes." + index + ".name'>" + newRow.name + "</div></td> " + (descriptionHTML || "") + " " + (extraHTML || "") + " " + (priceHTML || "") + " " + (buttonHTML || "") + " </tr>";
          return HTML;
        };
        scope.add = function() {
          var params;
          sectionId = blockEditDialog.getSectionId({
            id: id
          });
          params = {
            items_attributes: [
              {
                is_temp: true
              }
            ]
          };
          return Widget.createItem(sectionId, id, params).then(function(data) {
            var HTML, length, newRow;
            newRow = data.items_attributes[data.items_attributes.length - 1];
            scope.table.items_attributes.push(newRow);
            length = scope.table.items_attributes.length;
            HTML = generateTRbody(newRow, length - 1);
            widgetElWrapper.find(".str-bw_table-body").append(HTML);
            scope.setCurrentImage(length - 1);
            return ContentEditable.bind(false, true, id);
          });
        };
        changeDesign = function(design) {
          widgetElWrapper.find("table").removeClass("str-bw_table-design-1");
          widgetElWrapper.find("table").removeClass("str-bw_table-design-2");
          return widgetElWrapper.find("table").addClass("str-bw_table-design-" + design);
        };
        scope.remove = function() {
          scope.table.items_attributes[scope.currentField]._destroy = true;
          widgetElWrapper.find("[data-item-id='" + scope.table.items_attributes[scope.currentField].id + "']").remove();
          return scope.setCurrentImage(getNotDestroyedFieldRnd());
        };
        generateTable = function() {
          var HTML, headHTML;
          HTML = "";
          _.each(scope.table.items_attributes, function(row, index) {
            return HTML += generateTRbody(row, index);
          });
          headHTML = generateTRHead();
          widgetElWrapper.find("thead").html(headHTML);
          widgetElWrapper.find("tbody").html(HTML);
          return ContentEditable.bind(false, true, id);
        };
        listener1 = scope.$watch("data", function(newVal, oldVal) {}, true);
        listener2 = scope.$watch("table.items_attributes", function(newVal, oldVal) {
          return scope.data.items_attributes = newVal;
        }, true);
        listener3 = scope.$watch("data.design", function(newVal, oldVal) {
          return changeDesign(newVal);
        }, true);
        listener4 = scope.$watch("data.table_style", function(newVal, oldVal) {
          return widgetElWrapper.find("table").css(newVal);
        }, true);
        listener5 = scope.$watch("data.show_description", function(newVal, oldVal) {
          if (newVal === oldVal) {
            return false;
          }
          generateTable();
        }, true);
        listener6 = scope.$watch("data.show_extra", function(newVal, oldVal) {
          if (newVal === oldVal) {
            return false;
          }
          generateTable();
        }, true);
        listener7 = scope.$watch("data.show_button", function(newVal, oldVal) {
          if (newVal === oldVal) {
            return false;
          }
          generateTable();
        }, true);
        return scope.$on("$destroy", function() {
          listener1();
          listener2();
          listener3();
          listener4();
        });
      }
    };
  }
]);


/***/ }),
/* 230 */
/***/ (function(module, exports) {

var alignDirectiveModule;

alignDirectiveModule = angular.module('valign.setting', []);

alignDirectiveModule.directive("valigmentSetting", [
  "$window", "$timeout", "$compile", "$templateCache", function($window, $timeout, $compile, $templateCache) {
    return {
      restrict: "A",
      scope: {
        data: "=ngModel"
      },
      templateUrl: settingFolder + "/valignment/template.jade",
      link: function(scope, element, attrs, ngModel) {
        var listener;
        if (!scope.data) {
          scope.data = "middle";
        }
        scope.verticalAlign = scope.data;
        listener = scope.$watch("verticalAlign", function(newVal) {
          return scope.data = newVal;
        });
        return scope.$on("$destroy", function() {
          return listener();
        });
      }
    };
  }
]);


/***/ }),
/* 231 */
/***/ (function(module, exports) {

var radiusDirectiveModule,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

radiusDirectiveModule = angular.module('width.setting', []);

radiusDirectiveModule.directive("widthSetting", [
  "$window", "$timeout", "$compile", "$templateCache", function($window, $timeout, $compile, $templateCache) {
    return {
      restrict: "A",
      scope: {
        data: "=ngModel"
      },
      templateUrl: settingFolder + "/width/template.jade",
      link: function(scope, element, attrs, ngModel) {
        var listener1, listener2;
        if (!scope.data) {
          scope.data = '100%';
        }
        scope.widthType = indexOf.call(scope.data.split(""), "px") >= 0 ? "px" : "%";
        scope.widthValue = parseInt(scope.data);
        listener1 = scope.$watch("widthValue", function(newVal) {
          return scope.data = "" + newVal + scope.widthType;
        });
        listener2 = scope.$watch("widthType", function(newVal) {
          return scope.data = "" + scope.widthValue + newVal;
        });
        return scope.$on("$destroy", function() {
          listener1();
          return listener2();
        });
      }
    };
  }
]);


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var modulePageSettings;

modulePageSettings = angular.module('pagesSettings.controller', []);

modulePageSettings.controller("PagesSettingsCtrl", [
  "$scope", "$state", "$timeout", "Page", "Modal", "$rootScope", "editorDragPanel", function($scope, $state, $timeout, Page, Modal, $rootScope, editorDragPanel) {
    var removeFromList;
    $scope.currentPageName = $state.params.pageId;
    $scope.createPage = Modal.createPage;
    $scope.editPage = Modal.editPage;
    $scope.treeOptions = {
      dropped: function(e) {
        _.each($rootScope.site.pages, function(node) {
          var list;
          node.has_parent = false;
          node.parent_id = null;
          list = _.filter(node.pages, {
            id: e.source.nodeScope.$modelValue.id
          });
          if (list.length > 0) {
            list[0].parent_id = node.id;
            return list[0].has_parent = true;
          }
        });
        return Page.update(e.source.nodeScope.$modelValue).then(function() {
          return Page.sort(e.dest.nodesScope.$modelValue);
        });
      }
    };
    $scope.goToPage = function(page) {
      if (!page.path) {
        return false;
      }
      return $state.go("site.page.editor", {
        pageId: page.path
      });
    };
    removeFromList = function(page) {
      var homePage;
      _.each($rootScope.site.pages, function(aPage, index) {
        if (aPage && aPage.id === page.id) {
          $rootScope.site.pages.splice(index, 1);
        }
        if (aPage && aPage.pages) {
          return _.each(aPage.pages, function(subpage, aIndex) {
            if (subpage && subpage.id === page.id) {
              return $rootScope.site.pages[index].pages.splice(aIndex, 1);
            }
          });
        }
      });
      homePage = _.filter($rootScope.site.pages, {
        home: true
      })[0];
      if (page.path === $state.params.pageId) {
        return $state.go("site.page.editor", {
          siteId: $state.params.siteId,
          pageId: homePage.path
        });
      }
    };
    return $scope.deletePage = function(page) {
      return $rootScope.alertDialog({
        title: "Удаление страницы",
        text: "Вы действительно хотите удалить страницу?",
        accept_text: "Да",
        cancel_text: "Отмена",
        accept: function() {
          $scope.deletingPage = true;
          return Page["delete"](page).then(function() {
            $scope.deletingPage = false;
            return removeFromList(page);
          }, function() {
            return $scope.deletingPage = false;
          });
        }
      });
    };
  }
]);


/***/ }),
/* 233 */
/***/ (function(module, exports) {

var moduleBgSlideShow;

moduleBgSlideShow = angular.module('bgSlideShow.initializer', []);

moduleBgSlideShow.service('bgSlideShow', [
  "$timeout", "$injector", "ns", function($timeout, $injector, ns) {
    'use strict';
    var Y, bgSlideShow;
    Y = void 0;
    bgSlideShow = {
      init: function(y) {
        Y = y;
        return this.initSections();
      },
      findSections: function() {
        return Y.all(ns.sectionClass);
      },
      initSection: function($section, newStyles) {
        var jSection, jSectionSlider, sliderHtml, slidesHtml, styles;
        if (newStyles == null) {
          newStyles = false;
        }
        jSection = $($section._node);
        if ($section.section.background_attributes.images_attributes.length === 1) {
          jSection.css({
            backgroundImage: "url(" + $section.section.background_attributes.images_attributes[0].source_url + ")"
          });
        } else if ($section.section.background_attributes.images_attributes.length > 1) {
          slidesHtml = "";
          _.each($section.section.background_attributes.images_attributes, function(image) {
            if (!image._destroy) {
              return slidesHtml += "<div class='swiper-slide strw-slider__item' data-slide-id='" + image.id + "'> <div class='strw-slider__image-wrapper'> <div class='strw-slider__image strw-slider__image_section' style='background-image: url(" + image.source_url + ")'></div> </div> </div>";
            }
          });
          sliderHtml = "<div class='swiper-container strw-slider strw-slider__section'><div class='swiper-wrapper'>" + slidesHtml + "</div></div>";
          jSection.prepend(sliderHtml);
          jSectionSlider = jSection.find(".strw-slider");
          if (newStyles) {
            styles = angular.copy(newStyles);
          } else {
            styles = angular.copy($section.section.style_attributes);
          }
          delete styles.padding;
          delete styles.backgroundImage;
          jSectionSlider.find(".strw-slider__image").css(styles);
          $timeout(function() {
            var newSwiperTop;
            return newSwiperTop = new Swiper($(jSectionSlider), {
              autoplay: 5000,
              loop: true,
              effect: "fade"
            });
          });
        }
      },
      destroy: function(section) {
        section.all(".strw-slider__section").remove();
      },
      initSections: function() {
        var self;
        self = this;
        return this.findSections().each(function(section) {
          return self.initSection(section);
        });
      }
    };
    return bgSlideShow;
  }
]);


/***/ }),
/* 234 */
/***/ (function(module, exports) {

var moduleContentAnimate;

moduleContentAnimate = angular.module('contentAnimate.initializer', []);

moduleContentAnimate.service('ContentAnimate', [
  "$timeout", "$injector", "ns", function($timeout, $injector, ns) {
    'use strict';
    var Y, contentAnimate;
    Y = void 0;
    contentAnimate = {
      init: function(y) {
        Y = y;
        return this.initSections();
      },
      findSections: function() {
        return Y.all(ns.sectionClass);
      },
      checkIfInView: function(section) {
        var $animationWidgets, $window, jSection, windowBottomPosition, windowHeight, windowTopPosition;
        $window = $(window);
        windowHeight = $window.height();
        windowTopPosition = $window.scrollTop();
        windowBottomPosition = windowTopPosition + windowHeight;
        jSection = $(section._node);
        $animationWidgets = jSection.find('.str-block');
        $.each($animationWidgets, function() {
          var $widget, elementBottomPosition, elementHeight, elementTopPosition;
          $widget = $(this);
          elementHeight = $widget.outerHeight();
          elementTopPosition = Math.max(0, $widget.offset().top);
          elementBottomPosition = elementTopPosition + elementHeight;
          if (elementBottomPosition >= windowTopPosition && elementTopPosition <= windowBottomPosition) {
            $widget.addClass('str-widget__in-view');
          } else {
            $widget.removeClass('str-widget__in-view');
          }
        });
      },
      initSection: function($section) {
        var $sectionAnimationType, animateNeed, sectionId, self;
        self = this;
        animateNeed = $section.section.animate_content_type !== "none";
        sectionId = $section.section.id;
        $(window).unbind("scroll.contentAnimate." + sectionId);
        if (animateNeed) {
          $sectionAnimationType = $section.section.animate_content_type;
          $section.all(".str-block").addClass("str-widget__in-view_" + $sectionAnimationType);
          $(window).on("scroll.contentAnimate." + sectionId, function() {
            self.checkIfInView($section);
          });
        }
        $(window).trigger('scroll');
      },
      destroy: function(section) {
        var id;
        id = section.section.id;
        $(window).unbind("scroll.contentAnimate." + id);
        return $(section._node).find(".str-block").removeClass(function(index, css) {
          return (css.match(/(^|\s)str-widget__in-view_\S+/g) || []).join(' ');
        });
      },
      initSections: function() {
        return this.findSections().each(this.initSection, this);
      }
    };
    return contentAnimate;
  }
]);


/***/ }),
/* 235 */
/***/ (function(module, exports) {

var moduleParallax;

moduleParallax = angular.module('parallax.initializer', []);

moduleParallax.service('Parallax', [
  "$timeout", "$injector", "ns", function($timeout, $injector, ns) {
    'use strict';
    var Y, parallax;
    Y = void 0;
    parallax = {
      init: function(y) {
        Y = y;
        return this.initSections();
      },
      findSections: function() {
        return Y.all(ns.sectionClass);
      },
      initSection: function(element) {
        var jElement, parallaxNeed, sectionId, sectionJson, speed;
        jElement = $(element._node);
        sectionJson = element.section;
        sectionId = sectionJson.id;
        parallaxNeed = sectionJson.background_attributes.parallax;
        speed = sectionJson.background_attributes.parallax_speed;
        if (!parallaxNeed) {
          return false;
        }
        $(window).unbind("scroll.parallax." + sectionId);
        return $(window).bind("scroll.parallax." + sectionId, function() {
          var coords, k, scrollTop, scrollTopBg, sectionTop, yPos;
          sectionTop = jElement.offset().top - $(window).height();
          scrollTop = $(window).scrollTop();
          scrollTopBg = jElement.offset().top - scrollTop;
          if (scrollTop > sectionTop) {
            k = 10 - (speed - 1) / 10;
            yPos = -(scrollTopBg / k);
            coords = 'center ' + yPos + 'px';
            return jElement.css({
              backgroundPosition: coords
            });
          } else {
            return jElement.css({
              backgroundPosition: ""
            });
          }
        });
      },
      destroy: function(section) {
        var id;
        id = section.section.id;
        $(window).unbind("scroll.parallax." + id);
        return section.setStyles({
          backgroundPosition: ""
        });
      },
      initSections: function() {
        return this.findSections().each(this.initSection);
      }
    };
    return parallax;
  }
]);


/***/ }),
/* 236 */
/***/ (function(module, exports) {

var moduleAlert,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

moduleAlert = angular.module('create.section.controller', []);

moduleAlert.controller('CreateSectionModal', [
  "$scope", "$state", "$rootScope", "$modalInstance", "Restangular", "$stateParams", "Section", "$window", "allSections", "FileUploader", function($scope, $state, $rootScope, $modalInstance, Restangular, $stateParams, Section, $window, allSections, FileUploader) {
    var setUploadUrls;
    $scope.close = function() {
      return $modalInstance.dismiss("close");
    };
    $scope.loadTags = function(query) {
      return Restangular.all("/sections/tags?q=" + query).getList();
    };
    $scope.loadColorTags = function(query) {
      return Restangular.all("/sections/color_tags?q=" + query).getList();
    };
    $scope.section = {
      disabled: true
    };
    $scope.sectionPreviewUploader = new FileUploader({
      url: Restangular.configuration.baseUrl + ("/sites/" + $state.params.siteId),
      autoUpload: false,
      method: "PUT",
      alias: "preview",
      headers: {
        'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
      }
    });
    $scope.sectionPreviewUploader.onAfterAddingFile = function(item) {
      var ref, types;
      types = ["image/jpeg", "image/png"];
      if (ref = item.file.type, indexOf.call(types, ref) < 0) {
        alert("The file must be png or jpg");
        return false;
      }
    };
    $scope.sectionPreviewUploader.onSuccessItem = function(fileItem, response, status, headers) {
      $scope.sectionPreviewUploader.clearQueue();
    };
    $scope.sectionPreviewUploader.onErrorItem = function(fileItem, response, status, headers) {};
    setUploadUrls = function(sectionId) {
      return $scope.sectionPreviewUploader.queue.forEach(function(item) {
        return item.url = Restangular.configuration.baseUrl + ("/sections/" + sectionId);
      });
    };
    return $scope.create = function(createSectionForm, section) {
      if (createSectionForm.$invalid) {
        return false;
      }
      $scope.creating = true;
      section.tags = _.map(section.tags, function(tag) {
        return tag.name;
      });
      section.tags = section.tags.join(",");
      section.colors = _.map(section.colors, function(tag) {
        return tag.text;
      });
      return Section.createPublic(section).then(function(sectionData) {
        setUploadUrls(sectionData.id);
        $scope.sectionPreviewUploader.uploadAll();
        $scope.close();
        $scope.creating = false;
        return allSections.push(sectionData);
      }, function() {
        return $scope.creating = false;
      });
    };
  }
]);


/***/ }),
/* 237 */
/***/ (function(module, exports) {

var moduleAlert,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

moduleAlert = angular.module('edit.link.controller', []);

moduleAlert.controller('EditSectionModal', [
  "$scope", "$state", "$rootScope", "$modalInstance", "Restangular", "$stateParams", "Section", "$window", "section", "FileUploader", function($scope, $state, $rootScope, $modalInstance, Restangular, $stateParams, Section, $window, section, FileUploader) {
    $scope.section = angular.copy(section);
    $scope.section.tags = _.map($scope.section.tags.split(","), function(tag, index) {
      return {
        name: tag,
        id: index
      };
    });
    $scope.section.colors = _.map($scope.section.colors, function(tag, index) {
      return {
        text: tag,
        id: index
      };
    });
    $scope.close = function() {
      return $modalInstance.dismiss("close");
    };
    $scope.loadTags = function(query) {
      return Restangular.all("/sections/tags?q=" + query).getList();
    };
    $scope.loadColorTags = function(query) {
      return Restangular.all("/sections/color_tags?q=" + query).getList();
    };
    $scope.sectionPreviewUploader = new FileUploader({
      url: Restangular.configuration.baseUrl + ("/sections/" + section.id),
      autoUpload: false,
      method: "PUT",
      alias: "preview",
      headers: {
        'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
      }
    });
    $scope.sectionPreviewUploader.onAfterAddingFile = function(item) {
      var ref, types;
      types = ["image/jpeg", "image/png"];
      if (ref = item.file.type, indexOf.call(types, ref) < 0) {
        alert("The file must be png or jpg");
        return false;
      }
    };
    $scope.sectionPreviewUploader.onSuccessItem = function(fileItem, response, status, headers) {
      section.preview_url = response.preview_url;
      $scope.sectionPreviewUploader.clearQueue();
    };
    $scope.sectionPreviewUploader.onErrorItem = function(fileItem, response, status, headers) {};
    return $scope.save = function(editSectionForm) {
      if (editSectionForm.$invalid) {
        return false;
      }
      $scope.updating = true;
      $scope.section.tags = _.map($scope.section.tags, function(tag) {
        return tag.name;
      });
      $scope.section.tags = $scope.section.tags.join(",");
      $scope.section.colors = _.map($scope.section.colors, function(tag) {
        return tag.text;
      });
      return Section.savePublic($scope.section).then(function(sectionData) {
        section.colors = sectionData.colors;
        section.tags = sectionData.tags;
        section.title = sectionData.title;
        section.disabled = sectionData.disabled;
        section.custom_preview_url_enabled = sectionData.custom_preview_url_enabled;
        section.custom_preview_url = sectionData.custom_preview_url;
        $scope.sectionPreviewUploader.uploadAll();
        $scope.close();
        return $scope.updating = false;
      }, function() {
        return $scope.updating = false;
      });
    };
  }
]);


/***/ }),
/* 238 */
/***/ (function(module, exports) {

var EditorNamespace;

EditorNamespace = angular.module('services.editorNamespace', []);

EditorNamespace.factory('ns', [
  "$timeout", "$state", function($timeout, $state) {
    var namespace;
    namespace = {
      blockClass: ".str-block",
      blockDropOverlay: ".str-dropoverlay",
      blockOverlay: ".widget-overlay",
      blockTextClass: ".str-bw_text",
      blockHeadline1Class: ".str-bw_headline_h1",
      blockHeadline2Class: ".str-bw_headline_h2",
      blockHeadline3Class: ".str-bw_headline_h3",
      blockMenuClass: ".et-block-list",
      blockMenuClassShow: "etbl__show",
      blockSettingsEditing: ".block__settings-editing",
      blockSettingsEditing_noshadow: "block__settings-editing_noshadow",
      blockLoader: '<div class="cubes-block__loader"> <div class="csl-cube cube1"></div> <div class="csl-cube cube2"></div> <div class="csl-cube cube3"></div> <div class="csl-cube cube4"></div> </div>',
      sectionLoader: '<div class="cubes-section__loader"> <div class="csl-cube csl-cube_section cube1"></div> <div class="csl-cube csl-cube_section cube2"></div> <div class="csl-cube csl-cube_section cube3"></div> <div class="csl-cube csl-cube_section cube4"></div> </div>',
      colClass: ".str-col",
      dropBackdropClass: ".str-drop-backdrop",
      dropHeaderClass: ".e-header__area",
      dropFooterClass: ".e-footer__area",
      dropBackdropDragoverClass: ".str-drop-backdrop-dragover",
      dragBlockToRowDistance: 10,
      dragBlockToColInColDistance: 10,
      dragPanelClass: ".et__drag-panel-wrapper",
      dragPanelTable: ".et__drag-panel-table",
      dragPanelWidgetClass: ".et__drag-panel-wrapper_widget",
      dragPanelSectionClass: ".et__drag-panel-wrapper_section",
      dragPanelRemoveButton: ".etdp__button_remove",
      dragOverLineWidth: 2,
      editBlockButtonClass: ".etdp__button",
      floatingClass: "str-floating",
      sliderClass: "strw-slider",
      sliderSlideClass: "strw-slider__image_cover",
      helperClass: "str-helper",
      insertPointClass: "str-insert-point",
      insertSpaceClassHelper: "etbl__link",
      insertSpaceClass: "str-insert-space",
      insertSpaceNode: "<div class='str-insert-space'></div>",
      spacerClass: "str-bw_spacer",
      spacerContentClass: "str-bw_spacer-content",
      spacerWrapperClass: "yui3-resize-handles-wrapper",
      shiftTop: function() {
        return 0;
      },
      tplContainer: "#tpl-wrapper",
      menuBlockClass: ".etbl-block",
      maxColumns: 12,
      modulesSettingsModal: "modules_settings-modal",
      resizerClass: "str-helper__resizer",
      resizerLineClass: "str-helper--resizer__line",
      rowClass: ".str-row",
      sectionClass: ".str-section",
      settingsWindowClass: ".et-settings-panel",
      sectionDraggingClass: "str-section_dragging",
      widgetWrapperClass: ".widget-wrapper",
      widgetLineContentClass: ".str-bw_line-content",
      widgetFormButtonWrapperClass: ".strwf__form-button__wrapper",
      widgetFormParentButtonWrapperClass: ".strwf__parent-button__wrapper",
      widgetLineClass: ".strwf__line-wrapper",
      widgetButtonClass: ".strwf_button",
      widgetButtonTwoClass: ".strwf_button-two",
      widgetVideoClass: ".strwvideo",
      wrapperClass: ".str-wrapper"
    };
    return namespace;
  }
]);


/***/ }),
/* 239 */
/***/ (function(module, exports) {

var moduleAnim;

moduleAnim = angular.module('services.animations', []);

moduleAnim.factory('Animation', [
  "$timeout", function($timeout) {
    var animations;
    animations = {
      prepareSlideDown: function(node) {
        return $(node._node).slideUp(0);
      },
      slideUp: function(node) {
        return $(node._node).slideUp(200);
      },
      slideDown: function(node) {
        return $(node._node).slideDown(200);
      },
      scrollTo: function(node) {
        $('html,body').animate({
          scrollTop: node.offset().top - 32
        }, 500);
      }
    };
    return animations;
  }
]);


/***/ }),
/* 240 */
/***/ (function(module, exports) {

var moduleBlockOverlays;

moduleBlockOverlays = angular.module('services.layoutEditor.blockDragScroll', ["services.editorNamespace"]);

moduleBlockOverlays.factory('blockDragScroll', [
  "$timeout", "$injector", "ns", "$interval", function($timeout, $injector, ns, $interval) {
    var $window, Y, blockDragScroll;
    Y = void 0;
    $window = $(window);
    blockDragScroll = {
      init: function(y) {
        Y = y;
        return this.calculate_dimensions();
      },
      calculate_dimensions: function() {
        this.window_height = $window.height();
        return this.window_width = $window.width();
      },
      capitalize: function(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
      },
      clearInterval: function(interval) {
        return $interval.cancel(interval);
      },
      scroll: function(t) {
        var e, i, margin, pageY, processScroll, scrollArea, stopArea, windowHeight;
        e = this;
        $window = $(window);
        windowHeight = $(window).height();
        stopArea = 50;
        scrollArea = 70;
        i = 1;
        margin = 5;
        processScroll = false;
        pageY = angular.copy(t.target.mouseXY[1]);
        pageY = pageY - $window.scrollTop();
        if (pageY <= scrollArea) {
          processScroll = true;
          e.stopScroll();
          e.intTopHandler = setInterval(function() {
            $window.scrollTop($window.scrollTop() - margin);
            return $window.scrollTop() === stopArea && clearInterval(e.intTopHandler);
          }, i);
        } else if (windowHeight - scrollArea <= pageY) {
          processScroll = true;
          e.stopScroll();
          e.intBottomHandler = setInterval(function() {
            $window.scrollTop($window.scrollTop() + margin);
            return $window.scrollTop() === stopArea && clearInterval(e.intBottomHandler);
          }, i);
        } else {
          windowHeight - scrollArea >= pageY && (processScroll = false);
        }
        if (!processScroll) {
          clearInterval(e.intTopHandler);
          return clearInterval(e.intBottomHandler);
        }
      },
      stopScroll: function() {
        var self;
        self = this;
        clearInterval(self.intTopHandler);
        clearInterval(self.intBottomHandler);
      }
    };
    return blockDragScroll;
  }
]);


/***/ }),
/* 241 */
/***/ (function(module, exports) {

var moduleBlockOverlays,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

moduleBlockOverlays = angular.module('services.layoutEditor.blockOverlays', ["services.editorNamespace"]);

moduleBlockOverlays.factory('blockOverlays', [
  "$timeout", "$injector", "ns", "blocksBuilder", function($timeout, $injector, ns, blocksBuilder) {
    var Y, blockOverlay;
    Y = void 0;
    blockOverlay = {
      init: function(y) {
        Y = y;
        return this.addOverlaysToBlocks();
      },
      overlayingWidgets: ["video"],
      addOverlaysToBlocks: function() {
        var blocks, self;
        self = this;
        blocks = Y.all(ns.blockClass);
        return blocks.each(function(block) {
          var inList, newOverlay, overlayExists, ref;
          newOverlay = Y.DOM.create("<div class='" + (ns.blockOverlay.substr(1)) + "'></div>");
          inList = block.widget && (ref = block.widget.type, indexOf.call(self.overlayingWidgets, ref) >= 0);
          overlayExists = $(block._node).find(ns.blockOverlay).length;
          if (!overlayExists && inList) {
            return $(block._node).find(ns.widgetWrapperClass).append(newOverlay);
          }
        });
      },
      destroyOverlays: function() {
        return Y.all(ns.blockOverlay).remove();
      }
    };
    return blockOverlay;
  }
]);


/***/ }),
/* 242 */
/***/ (function(module, exports) {

var moduleblocksBuilder;

moduleblocksBuilder = angular.module('services.layoutEditor.blocksBuilder', ["services.editorNamespace"]);

moduleblocksBuilder.factory('blocksBuilder', [
  "$timeout", "ns", "$injector", "Section", "Slider", "TimeMachine", "FrameForm", function($timeout, ns, $injector, Section, Slider, TimeMachine, FrameForm) {
    var Y, blocksBuilder;
    Y = void 0;
    blocksBuilder = {
      resizers: null,
      init: function(y) {
        return Y = y;
      },
      destroy: function() {
        return this.destroyResizers();
      },
      isBlock: function(el) {
        if (el && angular.isDefined(el.hasClass)) {
          return el.hasClass(ns.blockClass.substr(1)) || el.hasClass(ns.blockDropOverlay.substr(1));
        } else {
          return false;
        }
      },
      isSection: function(el) {
        if (angular.isDefined(el.hasClass)) {
          return el.hasClass(ns.sectionClass.substr(1));
        } else {
          return false;
        }
      },
      isColumn: function(el) {
        if (angular.isDefined(el.hasClass)) {
          return el.hasClass(ns.colClass.substr(1));
        } else {
          return false;
        }
      },
      isRow: function(el) {
        if (angular.isDefined(el.hasClass)) {
          return el.hasClass(ns.rowClass.substr(1));
        } else {
          return false;
        }
      },
      getColSize: function(element) {
        var colSize;
        if (this.isColumn(element) || this.isBlock(element)) {
          colSize = parseInt((element.get('className').match(RegExp('(?:\\s|^)str-col-(\\d+?)(?:\\s|$)')) || ['', ''])[1], 10);
          if (!isNaN(colSize)) {
            return colSize;
          } else {
            return false;
          }
        } else {
          return false;
        }
      },
      sumColumnsSize: function(columns) {
        var numberColsSum, parent;
        parent = this;
        numberColsSum = 0;
        if (angular.isDefined(columns.each)) {
          columns.each(function(col, i) {
            var colSize;
            colSize = parent.getColSize(col);
            return numberColsSum += colSize;
          });
        }
        return numberColsSum;
      },
      updateColSize: function(col, newval) {
        if (this.isColumn(col) || this.isBlock(col)) {
          col.removeClass("str-col-" + this.getColSize(col));
          col.addClass("str-col-" + newval);
        }
        if (this.isBlock(col)) {
          return col.widget.float_size = newval;
        }
      },
      removeEmptySections: function() {
        var layoutEditor;
        layoutEditor = $injector.get("layoutEditor");
        return Y.all(ns.sectionClass).each(function(section, i) {
          var exists, sectionId;
          exists = Y.one(section).one(ns.rowClass);
          if (!exists) {
            sectionId = section.section.id;
            Section.remove(sectionId);
            section.remove();
            return layoutEditor.cancelEditingLayout();
          }
        });
      },
      removeEmptyRows: function() {
        return Y.all(ns.rowClass).each(function(row, i) {
          var exists;
          exists = row.one(ns.colClass);
          if (!exists) {
            return row.remove();
          }
        });
      },
      removeEmptyColumns: function() {
        return Y.all(ns.colClass).each(function(col, i) {
          var exists;
          exists = Y.one(col).one(ns.blockClass);
          if (!exists) {
            return col.remove();
          }
        });
      },
      removeUnnecessaryRows: function() {
        var layout, layoutEditor;
        layoutEditor = $injector.get("layoutEditor");
        layout = layoutEditor.layout;
        layout.all(ns.rowClass).each(function(row) {
          var countCols, inheritCol, widgets;
          inheritCol = row.ancestor(ns.colClass);
          if (inheritCol) {
            countCols = Y.one(row).all(ns.colClass).size();
            if (countCols === 1) {
              widgets = Y.one(row).one(ns.colClass).all(ns.blockClass);
              return row.insert(widgets, "before");
            }
          }
        });
      },
      createSection: function(content, sectionType) {
        var clearFix, newSection;
        if (sectionType == null) {
          sectionType = "section";
        }
        if (sectionType === "default") {
          sectionType = "section";
        }
        clearFix = Y.Node.create("<div/>").addClass("clearfix");
        newSection = Y.Node.create('<' + sectionType + ' class="' + ns.sectionClass.replace(".", "") + '"><div class="' + ns.wrapperClass.substr(1) + '">' + content + '</div></' + sectionType + '>');
        newSection.append(clearFix);
        newSection.section = {
          section_type: sectionType
        };
        return newSection;
      },
      createRow: function(content) {
        var clearFix, newRow;
        clearFix = Y.Node.create("<div/>").addClass("clearfix");
        newRow = Y.Node.create('<div class="row ' + ns.rowClass.replace(".", "") + '"></div>').setContent(content);
        newRow.append(clearFix);
        return newRow;
      },
      createColumn: function(size, content) {
        size = content.widget && content.widget.min_size || 1;
        return Y.Node.create('<div class="' + ns.colClass.substr(1) + ' str-col-' + size + '"></div>').setContent(content);
      },
      createBlock: function(content, type) {
        return Y.Node.create("<div class='" + (ns.blockClass.substr(1)) + " str-bw_" + type + "'><div class='widget-wrapper'>" + content + "</div></div>");
      },
      insertColumn: function(direction, dragContent, dropTarget, widget) {
        var colTarget, insertDirection, newColumn, parentCol, size;
        if (dragContent.ancestor) {
          parentCol = dragContent.ancestor(ns.colClass);
          if (parentCol) {
            size = this.getColSize(parentCol);
          } else {
            size = widget.min_size;
          }
        }
        newColumn = this.createColumn(size, dragContent);
        colTarget = dropTarget.ancestor(ns.colClass);
        insertDirection = direction === "right" ? "after" : "before";
        return colTarget.insert(newColumn, insertDirection);
      },
      insertRow: function(direction, dragContent, dropTarget) {
        var insertDirection, newRow, targetParentRow;
        targetParentRow = dropTarget.ancestor(ns.rowClass) || dropTarget;
        newRow = this.createRow(this.createColumn(ns.maxColumns, dragContent));
        insertDirection = direction === "bottom" ? "after" : "before";
        return targetParentRow.insert(newRow, insertDirection);
      },
      insertRowIntoColumn: function(direction, dragContent, dropTarget) {
        var colWithDragContent, insertDirection, newRow;
        colWithDragContent = this.createColumn(ns.maxColumns, dragContent);
        newRow = this.createRow(colWithDragContent);
        insertDirection = direction === "left" ? "after" : "before";
        dropTarget.insert(newRow, "after");
        return colWithDragContent.insert(this.createColumn(ns.maxColumns, dropTarget), insertDirection);
      },
      insertBlock: function(direction, dragNode, targetNode) {
        var blockDragDrop, insertDirection, parentCol, size;
        if (targetNode.float) {
          parentCol = targetNode.ancestor(ns.colClass);
          size = Math.floor(6);
          dragNode.addClass(ns.floatingClass + "-" + targetNode.float + " str-col-" + size);
        } else {
          blockDragDrop = $injector.get("blockDragDrop");
          if (blockDragDrop.dragNode) {
            blockDragDrop.removeFloating();
          }
        }
        insertDirection = direction === "bottom" ? "after" : "before";
        return targetNode.insert(dragNode, insertDirection);
      },
      initResizers: function() {
        var layoutEditor, parent;
        parent = this;
        layoutEditor = $injector.get("layoutEditor");
        this.destroyResizers();
        layoutEditor.layout.all(ns.colClass).each(function(col) {
          return parent.insertIfLastCol(col);
        });
        this.resizers = new Y.DD.Delegate({
          container: ns.tplContainer,
          nodes: "." + ns.helperClass,
          invalid: "." + ns.floatingClass + "-left ." + ns.helperClass + ", ." + ns.floatingClass + "-right ." + ns.helperClass,
          dragConfig: {
            groups: Y.all("." + ns.resizerClass),
            move: false
          }
        });
        this.resizers.on("drag:mouseDown", this._onResizerDDMousedown, this);
        this.resizers.on("drag:start", this._onResizerDragStart, this);
        this.resizers.on("drag:drag", this._onResizerDragDrag, this);
        this.resizers.on("drag:end", this._onResizerDragEnd, this);
        return this.initFloatResizers();
      },
      sizeAloneFloatingBlocks: function(col) {
        var blockDragDrop, blocks, floatingBlocks, self;
        self = this;
        blocks = col.all(ns.blockClass);
        blockDragDrop = $injector.get("blockDragDrop");
        floatingBlocks = 0;
        blocks.each(function(block) {
          if (self.isFloating(block)) {
            return floatingBlocks++;
          }
        });
        if (blocks.size() === floatingBlocks) {
          return blocks.each(function(block) {
            return blockDragDrop.removeFloating(block);
          });
        }
      },
      setupSizeColumnsInRow: function(row, dragNode) {
        var columns, insertedCol, maxCols, parent, sumColSize;
        if (dragNode) {
          insertedCol = dragNode.ancestor(ns.colClass);
        }
        maxCols = ns.maxColumns;
        parent = this;
        columns = Y.one(row).all("> " + ns.colClass);
        sumColSize = parent.sumColumnsSize(columns);
        columns.each(function(col, i) {
          var colSize;
          parent.sizeAloneFloatingBlocks(col);
          colSize = parent.getColSize(col);
          if (dragNode && columns.size() > 1) {
            if (col._yuid !== insertedCol._yuid) {
              if (sumColSize < maxCols) {
                parent.updateColSize(col, colSize + 1);
                sumColSize++;
              }
              if (sumColSize > maxCols && colSize > parent.getMinColSize(col)) {
                parent.updateColSize(col, colSize - 1);
                return sumColSize--;
              }
            }
          } else {
            if (sumColSize < maxCols) {
              parent.updateColSize(col, colSize + 1);
              sumColSize++;
            }
            if (sumColSize > maxCols && colSize > parent.getMinColSize(col)) {
              parent.updateColSize(col, colSize - 1);
              return sumColSize--;
            }
          }
        });
        if ((sumColSize !== 0) && (sumColSize < maxCols) || (sumColSize > maxCols)) {
          return this.setupSizeColumnsInRow(row, dragNode);
        }
      },
      setupSizeColumns: function(row, dragNode) {
        var layout, layoutEditor, parent;
        if (dragNode == null) {
          dragNode = false;
        }
        layoutEditor = $injector.get("layoutEditor");
        layout = layoutEditor.layout;
        parent = this;
        return layout.all(ns.rowClass).each(function(row) {
          return parent.setupSizeColumnsInRow(row, dragNode);
        });
      },
      _onResizerDragStart: function(e) {
        var posX, sizeG, targetNode;
        targetNode = e.target.get('node');
        posX = e.target.nodeXY[0];
        sizeG = 12;
        Y.one('html').addClass('str-resizing-col');
        this.targetNode = targetNode;
        this.leftCol = targetNode.ancestor(ns.colClass);
        this.rightCol = this.leftCol.next();
        this.leftOriginalSize = this.getColSize(this.leftCol);
        this.rightOriginalSize = this.getColSize(this.rightCol);
        this.oldSizes = [this.leftOriginalSize, this.rightOriginalSize];
        this.originalResizerPos = this.xToCol(posX + sizeG);
        this.leftCol.addClass('str-resizing str-resizing-left');
        return this.rightCol.addClass('str-resizing str-resizing-right');
      },
      _onResizerDragDrag: function(e) {
        var currentResizePoint, diff, k, maxLeftSize, maxRightSize, minLeftSize, minRightSize, mouseX, newColSizeLeft, newColSizeRight, stopsCount;
        currentResizePoint = void 0;
        mouseX = e.target.mouseXY[0];
        diff = this.gridSteps[1] - this.gridSteps[0];
        k = 0;
        stopsCount = this.gridSteps.length;
        while (k < stopsCount) {
          currentResizePoint = this.gridSteps[k];
          if (mouseX < this.gridSteps[0] - diff) {
            newColSizeLeft = this.getMinColSize(this.leftCol);
            newColSizeRight = this.rightOriginalSize + this.leftOriginalSize - newColSizeLeft;
            this.updateColSize(this.leftCol, newColSizeLeft);
            this.updateColSize(this.rightCol, newColSizeRight);
          } else if (mouseX > this.gridSteps[this.gridSteps.length - 1] + diff) {
            newColSizeRight = this.getMinColSize(this.rightCol);
            newColSizeLeft = this.leftOriginalSize + this.rightOriginalSize - newColSizeRight;
            this.updateColSize(this.leftCol, newColSizeLeft);
            this.updateColSize(this.rightCol, newColSizeRight);
          } else if (mouseX > currentResizePoint - (diff / 2) && mouseX < currentResizePoint + diff / 2) {
            newColSizeRight = k - this.originalResizerPos;
            newColSizeLeft = this.leftOriginalSize + newColSizeRight;
            newColSizeRight = this.rightOriginalSize - newColSizeRight;
            minLeftSize = this.getMinColSize(this.leftCol);
            minRightSize = this.getMinColSize(this.rightCol);
            maxLeftSize = this.getMaxColSize(this.leftCol);
            maxRightSize = this.getMaxColSize(this.rightCol);
            if (newColSizeLeft < minLeftSize || newColSizeLeft > maxLeftSize || newColSizeRight < minRightSize || newColSizeRight > maxRightSize) {
              break;
            }
            if (newColSizeLeft === this.getColSize(this.leftCol)) {
              break;
            }
            newColSizeLeft = Math.min(Math.max(1, newColSizeLeft), ns.maxColumns);
            newColSizeRight = Math.min(Math.max(1, newColSizeRight), ns.maxColumns);
            this.updateColSize(this.leftCol, newColSizeLeft);
            this.updateColSize(this.rightCol, newColSizeRight);
            break;
          }
          k++;
        }
        Slider.updateSliders();
        FrameForm.updateFrameForms();
      },
      colResizeCapture: function() {
        var newSizes, widget;
        newSizes = [this.getColSize(this.leftCol), this.getColSize(this.rightCol)];
        widget = this.targetNode.ancestor(ns.colClass).one(ns.blockClass).widget;
        return TimeMachine.capture("resizeCol", {
          widgetId: widget.id,
          oldSizes: this.oldSizes,
          newSizes: newSizes
        });
      },
      _onResizerDragEnd: function() {
        var allCols, layoutEditor;
        layoutEditor = $injector.get("layoutEditor");
        allCols = Y.all(ns.colClass);
        allCols.removeClass("str-resizing-left");
        allCols.removeClass("str-resizing-right");
        allCols.removeClass("str-resizing");
        this.colResizeCapture();
        Y.one('html').removeClass('str-resizing-col');
        return layoutEditor.save();
      },
      getAvailableColSize: function(row, dragCol, fromDragOver, clone) {
        var self, size;
        if (fromDragOver == null) {
          fromDragOver = false;
        }
        if (clone == null) {
          clone = false;
        }
        self = this;
        size = 0;
        row.all("> " + ns.colClass + ":not(.str-col-from)").each(function(col) {
          return size += self.getMinColSize(col);
        });
        if (dragCol && dragCol.ancestor(ns.rowClass) === row && !clone) {
          if (dragCol.all("> " + ns.blockClass).size() > 1 + fromDragOver) {
            size += this.getMinColSize(dragCol);
          }
        }
        if (dragCol && dragCol.ancestor(ns.colClass) && dragCol.ancestor(ns.colClass).ancestor(ns.colClass)) {
          return this.getColSize(dragCol.ancestor(ns.colClass).ancestor(ns.colClass)) - size;
        } else {
          return ns.maxColumns - size;
        }
      },
      getMinColSize: function(col) {
        var sizes;
        sizes = [];
        col.all(ns.blockClass).each(function(block) {
          if (block.widget && block.widget.min_size) {
            return sizes.push(Math.max(block.widget.min_size));
          }
        });
        return Math.max.apply(Math, sizes);
      },
      getMaxColSize: function() {
        return ns.maxColumns;
      },
      xToCol: function(origResizerPos) {
        var diff, i, stopVal;
        diff = (this.gridSteps[1] - this.gridSteps[0]) / 2;
        if (origResizerPos < this.gridSteps[0]) {
          return 0;
        }
        if (origResizerPos > this.gridSteps[this.gridSteps.length]) {
          return ns.maxColumns - 1;
        }
        i = 0;
        while (i < this.gridSteps.length) {
          stopVal = this.gridSteps[i];
          if (origResizerPos > stopVal - diff && origResizerPos < stopVal + diff) {
            return i;
          }
          i++;
        }
      },
      _onResizerDDMousedown: function(e) {
        var col;
        col = e.target.get('node').ancestor(ns.colClass, true);
        return this.calcColResizeStops(col);
      },
      calcColResizeStops: function(col) {
        var colSize, paddingLeftSection, posXsection, ratio, results, section, widthSection;
        section = col.ancestor(ns.rowClass);
        widthSection = parseInt(section.getStyle('width'), 10);
        paddingLeftSection = parseInt(section.getStyle("paddingLeft"), 10);
        colSize = 1;
        ratio = widthSection / ns.maxColumns;
        posXsection = section.getXY()[0];
        this.gridSteps = [];
        results = [];
        while (colSize < ns.maxColumns - 1) {
          this.gridSteps.push(posXsection + paddingLeftSection + Math.round(ratio * (colSize + 1)));
          results.push(colSize++);
        }
        return results;
      },
      destroyResizers: function() {
        var layoutEditor;
        if (this.resizers && this.resizers !== null) {
          this.resizers.destroy();
        }
        if (this.floatResizers && this.floatResizers !== null) {
          this.floatResizers.destroy();
        }
        layoutEditor = $injector.get("layoutEditor");
        if (layoutEditor.layout) {
          return layoutEditor.layout.all("." + ns.helperClass).remove();
        }
      },
      insertIfLastCol: function(element) {
        var lastColIndex, lastInRow, thisIndex;
        lastColIndex = element.ancestor(ns.rowClass).all("> " + ns.colClass).size() - 1;
        thisIndex = $(element._node).index();
        lastInRow = thisIndex === lastColIndex;
        if (this.getColSize(element) < ns.maxColumns && !lastInRow) {
          return this.appendResizerTo(element);
        }
      },
      appendResizerTo: function(element) {
        return element.appendChild("<div class='" + ns.helperClass + "'><div class='" + ns.resizerClass + "'><div class='" + ns.resizerLineClass + "'></div></div></div>");
      },
      _onFloatResizerDragStart: function(e) {
        var parentCol;
        parentCol = e.target.get("node").ancestor(ns.colClass);
        this.currentWidth = this.getColSize(e.target.get("node").ancestor(ns.blockClass));
        this.minWidth = 1;
        this.maxWidth = 12;
        return this.floatGridsteps = parseInt(parentCol.get("region").width / this.maxWidth, 10);
      },
      _onFloatResizerDragDrag: function(e) {
        var block, newSize;
        block = e.target.get('node').ancestor(ns.blockClass);
        newSize = Math.floor((e.target.mouseXY[0] - e.target.startXY[0]) / this.floatGridsteps);
        if (this.isFloatRight(block)) {
          newSize *= -1;
        }
        newSize += this.currentWidth;
        if (newSize > 0 && newSize < 13) {
          return this.updateColSize(block, newSize);
        }
      },
      _onFloatResizerDragEnd: function(e) {
        var block, blockDragDrop, blockSize;
        blockDragDrop = $injector.get("blockDragDrop");
        block = e.target.get('node').ancestor(ns.blockClass);
        blockSize = this.getColSize(block);
        if (blockSize === ns.maxColumns) {
          return blockDragDrop.removeFloating(block);
        }
      },
      isFloatRight: function(block) {
        return block.hasClass(ns.floatingClass + "-right");
      },
      isFloating: function(block) {
        if (block) {
          return block.hasClass(ns.floatingClass + "-right") || block.hasClass(ns.floatingClass + "-left");
        }
      },
      initFloatResizers: function() {
        var layoutEditor, parent;
        parent = this;
        layoutEditor = $injector.get("layoutEditor");
        layoutEditor.layout.all("." + ns.floatingClass + "-left").each(function(block) {
          return parent.appendResizerTo(block);
        });
        layoutEditor.layout.all("." + ns.floatingClass + "-right").each(function(block) {
          return parent.appendResizerTo(block);
        });
        this.floatResizers = new Y.DD.Delegate({
          container: ns.tplContainer,
          nodes: "." + ns.floatingClass + "-left ." + ns.helperClass + ", ." + ns.floatingClass + "-right ." + ns.helperClass,
          invalid: "." + ns.colClass + " ." + ns.helperClass,
          dragConfig: {
            move: false
          }
        });
        this.floatResizers.on("drag:start", this._onFloatResizerDragStart, this);
        this.floatResizers.on("drag:drag", this._onFloatResizerDragDrag, this);
        return this.floatResizers.on("drag:end", this._onFloatResizerDragEnd, this);
      }
    };
    return blocksBuilder;
  }
]);


/***/ }),
/* 243 */
/***/ (function(module, exports) {

var moduleInsertSpace,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

moduleInsertSpace = angular.module('services.layoutEditor.insertSpace', ["services.editorNamespace"]);

moduleInsertSpace.factory('insertSpace', [
  "$timeout", "ns", "$injector", function($timeout, ns, $injector) {
    var Y, insertSpace;
    Y = void 0;
    insertSpace = {
      availableForDropFloating: ["text"],
      availableForDragFloating: ["image"],
      isTextBlock: function(block) {
        if (block) {
          return block.hasClass(ns.blockTextClass.substr(1)) || block.hasClass(ns.blockHeadline1Class.substr(1)) || block.hasClass(ns.blockHeadline2Class.substr(1)) || block.hasClass(ns.blockHeadline3Class.substr(1));
        }
      },
      firstOrLastBlockInColumn: function(element, ip) {
        var blocksBuilder, firstBlock, firstCol, isSection, lastBlock;
        blocksBuilder = $injector.get("blocksBuilder");
        isSection = blocksBuilder.isSection($(element._node));
        lastBlock = $(element._node).is($(element._node).parent(ns.colClass).find(ns.blockClass).last());
        firstCol = $(element._node).parents(ns.colClass).index() === 0;
        firstBlock = $(element._node).index() === 0;
        return !isSection && firstCol && (firstBlock || lastBlock && ip.regionEdge === "bottom");
      },
      addInsertSpace: function() {
        var markerExist;
        markerExist = Y.one("." + ns.insertSpaceClass);
        if (!markerExist) {
          this.insertSpaceNode = Y.Node.create('<div/>').addClass(ns.insertSpaceClass).appendTo(ns.tplContainer);
        }
      },
      removeInsertSpace: function() {},
      firstBlock: function(element) {
        var dropTargetIndex, lastBlockIndex;
        lastBlockIndex = element.ancestor(ns.colClass).all(ns.blockClass).size() - 1;
        dropTargetIndex = $(element._node).index();
        return 0 === dropTargetIndex;
      },
      lastBlock: function(element, event) {
        var dragElementFromThisCol, dropTargetIndex, isSelf, lastBlockIndex;
        if (event == null) {
          event = false;
        }
        isSelf = element.getStyle("visibility") === "hidden";
        dragElementFromThisCol = element.ancestor(ns.colClass) === this.dragNode.ancestor(ns.colClass);
        if (event === "drag:drag" && dragElementFromThisCol) {
          lastBlockIndex = element.ancestor(ns.colClass).all(ns.blockClass).size() - 2;
        } else {
          lastBlockIndex = element.ancestor(ns.colClass).all(ns.blockClass).size() - 1;
        }
        dropTargetIndex = $(element._node).index();
        return lastBlockIndex === dropTargetIndex;
      },
      dragShowInsertSpace: function() {
        if (!this.insertSpaceNode.hasClass("str-im_active")) {
          return this.insertSpaceNode.addClass('str-im_active');
        }
      },
      centerSelf: function() {
        var inCenter, nodeWidth;
        nodeWidth = parseInt(this.dropNode.getStyle("width"));
        inCenter = this.nearestEdge.distance > (nodeWidth / 2 * 0.4);
        if (inCenter && this.nearestEdge.isSelf) {
          return this.nearestEdge.direction = "center";
        }
      },
      getSizeCol: function() {
        var parentCol;
        parentCol = this.dropNode.ancestor(ns.colClass)._node;
        return {
          width: parentCol.clientWidth,
          height: parentCol.clientHeight
        };
      },
      getColPosition: function() {
        return this.dropNode.ancestor(ns.colClass).getXY();
      },
      inCenterOfBlock: function() {
        return this.insertSpaceNode.setStyles({
          width: this.dropNode.getStyle("width"),
          height: this.dropNode.getStyle("height")
        });
      },
      inTopOfBlock: function() {
        var firstBlock, lastBlock;
        firstBlock = this.firstBlock(this.dropNode);
        lastBlock = this.lastBlock(this.dropNode, "drag:drag");
        if (firstBlock && !this.distanceForBlock) {
          return insertSpace.alignInsertSpaceRowOrSection(this.nearestEdge, "row");
        } else {
          return this.insertSpaceNode.setStyles({
            height: ns.dragOverLineWidth,
            width: this.colSize.width
          });
        }
      },
      inLeftOfBlock: function() {
        var dropNodeXY;
        if (this.distanceForBlock) {
          dropNodeXY = this.dropNode.getXY();
          this.insertSpaceNode.setXY(dropNodeXY);
          return this.insertSpaceNode.setStyles({
            width: ns.dragOverLineWidth,
            height: this.dropNode._node.clientHeight
          });
        } else {
          this.insertSpaceNode.setStyles({
            width: ns.dragOverLineWidth,
            height: this.colSize.height
          });
          return this.insertSpaceNode.setXY(this.getColPosition());
        }
      },
      inRightOfBlock: function() {
        var dropNodeXY;
        if (this.distanceForBlock) {
          this.insertSpaceNode.setStyles({
            width: ns.dragOverLineWidth,
            height: this.dropNode._node.clientHeight
          });
          dropNodeXY = this.dropNode.getXY();
          return this.insertSpaceNode.setXY([this.getColPosition()[0] + this.colSize.width, dropNodeXY[1]]);
        } else {
          this.insertSpaceNode.setStyles({
            width: ns.dragOverLineWidth,
            height: this.colSize.height
          });
          return this.insertSpaceNode.setXY([this.getColPosition()[0] + this.colSize.width, this.getColPosition()[1]]);
        }
      },
      inBottomOfBlock: function() {
        var dropNodeXY, firstBlock, lastBlock;
        firstBlock = this.firstBlock(this.dropNode);
        lastBlock = this.lastBlock(this.dropNode, "drag:drag");
        dropNodeXY = this.dropNode.getXY();
        if (lastBlock && !this.distanceForBlock) {
          return insertSpace.alignInsertSpaceRowOrSection(this.nearestEdge, "row");
        } else {
          this.colSize.height = this.dropNode._node.clientHeight;
          this.insertSpaceNode.setStyles({
            height: ns.dragOverLineWidth,
            width: this.colSize.width
          });
          return this.insertSpaceNode.setXY([dropNodeXY[0], dropNodeXY[1] + this.colSize.height]);
        }
      },
      enableForInsert: function(fromDragOver) {
        var availableSpace, blocksBuilder, dragCol, min_size;
        blocksBuilder = $injector.get("blocksBuilder");
        dragCol = false;
        if (this.dragNode) {
          dragCol = this.dragNode.ancestor(ns.colClass);
        }
        availableSpace = blocksBuilder.getAvailableColSize(this.dropNode.ancestor(ns.rowClass), dragCol, fromDragOver);
        min_size = 1;
        if (this.dragNode && $(this.dragNode._node).scope() && $(this.dragNode._node).scope().block) {
          min_size = $(this.dragNode._node).scope().block.min_size;
        } else {
          min_size = this.dragNode.widget.min_size;
        }
        return (availableSpace - min_size) >= 0;
      },
      beFloating: function() {
        var availableCoords, height, noderegion, quadx, quady, width, xy;
        noderegion = this.nearestEdge.region;
        width = noderegion.width / 2;
        quadx = this.nearestEdge.quad.x;
        quady = this.nearestEdge.quad.y;
        xy = this.dropNode.getXY();
        availableCoords = 60;
        if (noderegion && noderegion.height !== 0) {
          height = width * (noderegion.height / noderegion.width);
        } else {
          height = width * 0.5623;
        }
        if (this.nearestEdge.distance > availableCoords && !this.nearestEdge.isSelf) {
          if (quady === "top") {
            if (quadx === "left") {
              this.insertSpaceNode.setStyles({
                left: xy[0]
              });
              this.dropNode.float = "left";
            }
            if (quadx === "right") {
              this.insertSpaceNode.setStyles({
                left: xy[0] + width
              });
              this.dropNode.float = "right";
            }
            if (quadx === "right" || quadx === "left") {
              this.insertSpaceNode.setStyles({
                top: this.dropNode.getXY()[1] - ns.shiftTop(),
                height: height,
                width: width
              });
            }
          }
        } else {
          this.dropNode.float = void 0;
        }
      },
      regionMarkerSwitcher: function() {
        var dragBlockType, ref;
        switch (this.nearestEdge.direction) {
          case "center":
            this.inCenterOfBlock();
            break;
          case "top":
            this.inTopOfBlock();
            break;
          case "left":
            this.inLeftOfBlock();
            break;
          case "right":
            this.inRightOfBlock();
            break;
          case "bottom":
            this.inBottomOfBlock();
        }
        dragBlockType = this.dragNode.widget && this.dragNode.widget.type || $(this.dragNode._node).scope().block.type;
        if (this.dropNode.widget && (ref = this.dropNode.widget.type, indexOf.call(this.availableForDropFloating, ref) >= 0) && indexOf.call(this.availableForDragFloating, dragBlockType) >= 0) {
          return this.beFloating();
        }
      },
      alignInsertSpaceBlock: function(nearestEdge, dragNode) {
        var dropNodeXY;
        this.dragNode = dragNode;
        this.nearestEdge = nearestEdge;
        this.dropNode = nearestEdge.node;
        this.dragShowInsertSpace();
        this.colSize = this.getSizeCol();
        this.centerSelf();
        dropNodeXY = this.dropNode.getXY();
        this.insertSpaceNode.setXY(dropNodeXY);
        this.distanceForBlock = this.nearestEdge.distance > ns.dragBlockToRowDistance;
        return this.regionMarkerSwitcher();
      },
      alignInsertSpaceRowOrSection: function(region, type) {
        var dropNodeXY, dropTarget, elementHeight, elementWidth, lineHeight, node, tagName;
        this.insertSpaceNode.setStyles({
          width: 0,
          height: 0
        });
        if (!this.insertSpaceNode.hasClass("str-im_active")) {
          this.insertSpaceNode.addClass('str-im_active');
        }
        dropTarget = region.node;
        tagName = dropTarget.get('tagName').toLowerCase();
        lineHeight = ns.dragOverLineWidth;
        if (type === "row") {
          node = region.node.hasClass("str-row") ? region.node : region.node.ancestor(ns.rowClass);
        }
        if (type === "section") {
          lineHeight += 4;
          if (region.quad.y === "top" && tagName === "header") {
            return false;
          }
          if (region.quad.y === "bottom" && tagName === "footer") {
            return false;
          }
          node = region.node.hasClass("str-section") ? region.node : region.node.ancestor(ns.sectionClass);
        }
        dropNodeXY = node.getXY();
        elementWidth = node._node.clientWidth;
        elementHeight = node._node.clientHeight;
        this.insertSpaceNode.setXY(dropNodeXY);
        switch (region.quad.y) {
          case "top":
            return this.insertSpaceNode.setStyles({
              height: lineHeight,
              width: elementWidth
            });
          case "bottom":
            this.insertSpaceNode.setStyles({
              height: lineHeight,
              width: elementWidth
            });
            return this.insertSpaceNode.setXY([dropNodeXY[0], dropNodeXY[1] + elementHeight]);
        }
      },
      positionCorrect: function(ip, element) {
        var elementPosition, left, position, top;
        position = ip.getXY();
        elementPosition = ip.regionNode.getXY();
        top = position[1] + 10;
        left = position[0] + 26;
        if (this.firstOrLastBlockInColumn(element, ip)) {
          left -= 26;
        }
        if (elementPosition[0] < 26) {
          left -= 26;
        }
        return [left, top];
      },
      show: function(insertPoint) {
        var elementWidth, pointPosition;
        pointPosition = this.positionCorrect(insertPoint, insertPoint.regionNode);
        elementWidth = insertPoint.regionNode._node.clientWidth;
        this.insertSpaceNode.toggleClass('str-im_active');
        this.insertSpaceNode.setXY(pointPosition);
        this.insertSpaceNode.setStyle("width", elementWidth);
      },
      hideFull: function() {
        this.insertSpaceNode.removeClass('str-im_active');
        this.insertSpaceNode.setStyles({
          height: 0,
          width: 0
        });
        return this.insertSpaceNode.setXY([0, 0]);
      },
      hide: function() {
        this.insertSpaceNode.removeClass('str-im_active');
        this.insertSpaceNode.setStyle("height", ns.dragOverLineWidth);
        return this.insertSpaceNode.setXY([0, 0]);
      },
      destroy: function() {
        return this.insertSpaceNode.remove();
      },
      init: function(y) {
        Y = y;
        return this.addInsertSpace();
      }
    };
    return insertSpace;
  }
]);


/***/ }),
/* 244 */
/***/ (function(module, exports) {

var moduleTutorials;

moduleTutorials = angular.module("services.tutorials", []);

moduleTutorials.factory('Tutorials', [
  "$timeout", "ns", "$injector", "$rootScope", "$cookies", function($timeout, ns, $injector, $rootScope, $cookies) {
    var tutorials;
    tutorials = {
      _sectionDropTutorial: function() {
        if (this.sectionDestroyTimeOut) {
          $timeout.cancel(this.sectionDestroyTimeOut);
        }
        $rootScope.sectionDropTutorial = true;
        $rootScope.$apply();
        return this.sectionDestroyTimeOut = $timeout(function() {
          return $rootScope.sectionDropTutorial = false;
        }, 8000);
      }
    };
    return tutorials;
  }
]);


/***/ }),
/* 245 */
/***/ (function(module, exports) {

angular.module('services', ["services.editorNavSections", "services.layoutEditor", "services.animations", "services.tutorials"]);


/***/ }),
/* 246 */
/***/ (function(module, exports) {

var moduleSlider;

moduleSlider = angular.module('form.initializer', []);

moduleSlider.service('FrameForm', [
  "$timeout", "$injector", "ns", function($timeout, $injector, ns) {
    'use strict';
    var Y, form;
    Y = void 0;
    form = {
      init: function(y) {
        Y = y;
      },
      updateQueryStringParameter: function(uri, key, value) {
        var re, separator;
        re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
        separator = uri.indexOf('?') !== -1 ? '&' : '?';
        if (uri.match(re)) {
          return uri.replace(re, '$1' + key + '=' + value + '$2');
        } else {
          return uri + separator + key + '=' + value;
        }
      },
      productChoosed: function(products) {
        var category, group, i, index, j, len, len1, ref, selectedArray;
        selectedArray = [];
        for (i = 0, len = products.length; i < len; i++) {
          category = products[i];
          ref = category.goods;
          for (index = j = 0, len1 = ref.length; j < len1; index = ++j) {
            group = ref[index];
            if (group.selected) {
              selectedArray.push(group);
            }
          }
        }
        return selectedArray.length > 0;
      },
      setSelectedFirstProduct: function(products) {
        var category, group, i, index, j, len, len1, ref;
        for (i = 0, len = products.length; i < len; i++) {
          category = products[i];
          ref = category.goods;
          for (index = j = 0, len1 = ref.length; j < len1; index = ++j) {
            group = ref[index];
            if (index === 0) {
              group.selected = true;
              return false;
            }
          }
        }
      },
      getPath: function(href) {
        var l;
        l = document.createElement("a");
        l.href = href;
        return href.replace(l.origin, "");
      },
      getProductsString: function(products) {
        var category, i, j, len, len1, product, productsArr, productsString, ref;
        productsArr = [];
        for (i = 0, len = products.length; i < len; i++) {
          category = products[i];
          ref = category.goods;
          for (j = 0, len1 = ref.length; j < len1; j++) {
            product = ref[j];
            if (product.selected) {
              productsArr.push(product.name);
            }
          }
        }
        productsString = productsArr.join(":");
        return productsString;
      },
      updateFrameForms: function(layout) {
        var parent;
        if (layout == null) {
          layout = Y;
        }
        parent = this;
        if (this.updateTimeout) {
          $timeout.cancel(this.updateTimeout);
        }
        this.updateTimeout = $timeout(function() {
          return layout.all(".frame-form").each(function(frameFormWrapper) {
            var frame, frameWidth, newUrl, productChoosed, products;
            frame = $(frameFormWrapper._node).find("iframe");
            newUrl = frameFormWrapper.ancestor(".str-bw_form").widget.frame_settings.frame_url;
            productChoosed = parent.productChoosed(frameFormWrapper.ancestor(".str-bw_form").widget.frame_settings.products);
            if (!productChoosed) {
              frameFormWrapper.ancestor(".str-bw_form").widget.frame_settings.products = angular.copy(window.justclick.groups);
              parent.setSelectedFirstProduct(frameFormWrapper.ancestor(".str-bw_form").widget.frame_settings.products);
              products = parent.getProductsString(frameFormWrapper.ancestor(".str-bw_form").widget.frame_settings.products);
              newUrl = parent.updateQueryStringParameter(newUrl, "goods", products);
              newUrl = parent.getPath(newUrl);
            }
            frameWidth = frame.width();
            newUrl = parent.updateQueryStringParameter(newUrl, "width", frameWidth - 70);
            newUrl = parent.updateQueryStringParameter(newUrl, "btn_width", frameWidth - 70);
            frameFormWrapper.ancestor(".str-bw_form").widget.frame_settings.frame_url = newUrl;
            frame.attr("src", newUrl);
            frame.unbind("load");
            return frame.on("load", function() {
              frameFormWrapper.ancestor(".str-bw_form").widget.frame_settings.frame_height = frame[0].contentWindow.document.body.offsetHeight;
              return frame.parents(".frame-form").css("height", frameFormWrapper.ancestor(".str-bw_form").widget.frame_settings.frame_height);
            });
          });
        }, 500);
      },
      destroy: function() {}
    };
    return form;
  }
]);


/***/ }),
/* 247 */
/***/ (function(module, exports) {

var moduleMap;

moduleMap = angular.module('map.initializer', []);

moduleMap.service('MapInit', [
  "$timeout", "$injector", "ns", function($timeout, $injector, ns) {
    'use strict';
    var Y, mapinit;
    Y = void 0;
    mapinit = {
      init: function(y) {
        Y = y;
        return this.initMaps();
      },
      resizers: [],
      findMaps: function() {
        var layoutEditor;
        layoutEditor = $injector.get("layoutEditor");
        return this.maps = $(".strw__map");
      },
      initGoogleMap: function(options) {
        var geocoder, infowindow, map, marker, myLatLng;
        myLatLng = {
          lat: options.lat,
          lng: options.lon
        };
        geocoder = new google.maps.Geocoder();
        map = new google.maps.Map(document.getElementById('str-map-' + options.id), {
          center: myLatLng,
          scrollwheel: false,
          zoom: options.zoom,
          streetViewControl: false,
          mapTypeControl: false
        });
        marker = new google.maps.Marker({
          position: myLatLng,
          map: map,
          draggable: true
        });
        infowindow = new google.maps.InfoWindow({
          content: options.pin_text
        });
        marker.addListener('click', function() {
          return infowindow.open(map, marker);
        });
        map.setCenter(myLatLng);
        map.setZoom(options.zoom);
        marker.setPosition(myLatLng);
        return {
          map_instance: map,
          geocoder: geocoder,
          marker: marker,
          infowindow: infowindow
        };
      },
      initYandexMap: function(options) {
        var map, marker, myLatLng, removeList;
        myLatLng = [options.lat, options.lon];
        map = new ymaps.Map('str-map-' + options.id, {
          center: myLatLng,
          zoom: options.zoom
        });
        removeList = ['typeSelector', 'searchControl', 'rulerControl', 'fullscreenControl', 'trafficControl', 'geolocationControl'];
        _.each(removeList, function(removeItem) {
          return map.controls.remove(removeItem);
        });
        marker = new ymaps.Placemark(myLatLng, {
          balloonContent: options.pin_text
        }, {
          draggable: true
        });
        map.setZoom(options.zoom);
        map.geoObjects.add(marker);
        return {
          map_instance: map,
          marker: marker
        };
      },
      initMap: function(index, mapEl, options_a) {
        var el, options;
        if (options_a == null) {
          options_a = false;
        }
        if (!options_a) {
          options = $(mapEl).data("map-options");
        } else {
          options = options_a;
        }
        el = $(mapEl).parents(ns.blockClass)[0];
        if (options.provider === "google") {
          el.googleMap = mapinit.initGoogleMap(options);
        }
        if (options.provider === "yandex") {
          el.yandexMap = mapinit.initYandexMap(options);
        }
        return el[options.provider + "Map"];
      },
      initMaps: function() {
        this.findMaps();
        return this.maps.each(this.initMap);
      },
      destroy: function() {}
    };
    return mapinit;
  }
]);


/***/ }),
/* 248 */
/***/ (function(module, exports) {

var moduleSpacer;

moduleSpacer = angular.module('spacer.initializer', []);

moduleSpacer.service('Spacer', [
  "$timeout", "$injector", "ns", function($timeout, $injector, ns) {
    'use strict';
    var Y, spacer;
    Y = void 0;
    spacer = {
      init: function(y) {
        Y = y;
        return this.initResize();
      },
      resizers: [],
      findSpacers: function() {
        var layoutEditor;
        layoutEditor = $injector.get("layoutEditor");
        return this.spacers = layoutEditor.layout.all("." + ns.spacerClass);
      },
      initResize: function() {
        var self;
        self = this;
        this.findSpacers();
        return this.spacers.each(function(spacer) {
          var resizer;
          if (!spacer.one("." + ns.spacerContentClass)) {
            spacer.one(ns.widgetWrapperClass).append("<div class='" + ns.spacerContentClass + "'></div>");
          }
          resizer = new Y.Resize({
            node: spacer,
            handles: "b",
            proxy: true
          });
          self.setEvents(resizer);
          return self.resizers.push(resizer);
        });
      },
      setEvents: function(spacer) {
        spacer.on("resize:start", this._resizeStart, this);
        spacer.on("resize:resize", this._updateAspectRatio, this);
        return spacer.after("resize:end", this._resizeEnd, this);
      },
      addRuler: function() {
        var height;
        if (!this.target.one(".str-ruler")) {
          height = this.target.getStyle("height");
          return this.target.one(ns.widgetWrapperClass).append("<div class='str-ruler'>" + height + "</div>");
        }
      },
      removeRuler: function() {
        return this.target.one(".str-ruler").remove();
      },
      _resizeStart: function(event) {
        this.target = event.target.get("node");
        return this.addRuler();
      },
      _resizeEnd: function(event) {
        var layoutEditor;
        layoutEditor = $injector.get("layoutEditor");
        this.target.setStyles({
          width: null
        });
        layoutEditor.save();
        Y.all("." + ns.spacerWrapperClass).remove();
        this.removeRuler();
        return this.initResize();
      },
      _updateAspectRatio: function(event) {
        var height, info, spacerContent;
        info = event.info;
        spacerContent = this.target.one("." + ns.spacerContentClass);
        height = this.target.getStyle("height");
        this.target.one(".str-ruler").setHTML(height);
        this._setPadding(spacerContent, height);
        return this.target.widget.padding = parseInt(height);
      },
      _setPadding: function(el, padding) {
        if (el) {
          return el.setStyle("paddingBottom", parseInt(padding) + "px");
        }
      },
      destroy: function() {
        _.each(this.resizers, function(resizer) {
          resizer.destroy();
          return Y.all("." + ns.spacerWrapperClass).remove();
        });
      }
    };
    return spacer;
  }
]);


/***/ }),
/* 249 */
/***/ (function(module, exports) {

CKEDITOR.editorConfig = function(config) {
  config.toolbarGroups = [];
  config.format_tags = 'p;h1;h2;h3;h4;h5;h6';
  config.removeDialogTabs = 'image:advanced;link:advanced';
};


/***/ }),
/* 250 */
/***/ (function(module, exports) {

CKEDITOR.lang['bg'] = {
  'editor': 'Текстов редактор за форматиран текст',
  'editorPanel': 'Панел на текстовия редактор',
  'common': {
    'editorHelp': 'натиснете ALT 0 за помощ',
    'browseServer': 'Избор от сървъра',
    'url': 'URL',
    'protocol': 'Протокол',
    'upload': 'Качване',
    'uploadSubmit': 'Изпращане към сървъра',
    'image': 'Снимка',
    'flash': 'Флаш',
    'form': 'Форма',
    'checkbox': 'Поле за избор',
    'radio': 'Радио бутон',
    'textField': 'Текстово поле',
    'textarea': 'Текстова зона',
    'hiddenField': 'Скрито поле',
    'button': 'Бутон',
    'select': 'Поле за избор',
    'imageButton': 'Бутон за снимка',
    'notSet': '<не е избрано>',
    'id': 'ID',
    'name': 'Име',
    'langDir': 'Посока на езика',
    'langDirLtr': 'Ляво на дясно (ЛнД)',
    'langDirRtl': 'Дясно на ляво (ДнЛ)',
    'langCode': 'Код на езика',
    'longDescr': 'Уеб адрес за дълго описание',
    'cssClass': 'Класове за CSS',
    'advisoryTitle': 'Препоръчително заглавие',
    'cssStyle': 'Стил',
    'ok': 'ОК',
    'cancel': 'Отказ',
    'close': 'Затвори',
    'preview': 'Преглед',
    'resize': 'Влачете за да оразмерите',
    'generalTab': 'Общи',
    'advancedTab': 'Разширено',
    'validateNumberFailed': 'Тази стойност не е число',
    'confirmNewPage': 'Всички незапазени промени ще бъдат изгубени. Сигурни ли сте, че желаете да заредите нова страница?',
    'confirmCancel': 'Някои от опциите са променени. Сигурни ли сте, че желаете да затворите прозореца?',
    'options': 'Опции',
    'target': 'Цел',
    'targetNew': 'Нов прозорец (_blank)',
    'targetTop': 'Горна позиция (_top)',
    'targetSelf': 'Текущия прозорец (_self)',
    'targetParent': 'Основен прозорец (_parent)',
    'langDirLTR': 'Ляво на дясно (ЛнД)',
    'langDirRTL': 'Дясно на ляво (ДнЛ)',
    'styles': 'Стил',
    'cssClasses': 'Класове за CSS',
    'width': 'Ширина',
    'height': 'Височина',
    'align': 'Подравняване',
    'alignLeft': 'Ляво',
    'alignRight': 'Дясно',
    'alignCenter': 'Център',
    'alignJustify': 'Двустранно подравняване',
    'alignTop': 'Горе',
    'alignMiddle': 'По средата',
    'alignBottom': 'Долу',
    'alignNone': 'Без подравняване',
    'invalidValue': 'Невалидна стойност.',
    'invalidHeight': 'Височината трябва да е число.',
    'invalidWidth': 'Ширина требе да е число.',
    'invalidCssLength': 'Стойността на полето "%1" трябва да бъде положително число с или без валидна CSS измервателна единица (px, %, in, cm, mm, em, ex, pt, или pc).',
    'invalidHtmlLength': 'Стойността на полето "%1" трябва да бъде положително число с или без валидна HTML измервателна единица (px или %).',
    'invalidInlineStyle': 'Стойността на стилa трябва да съдържат една или повече двойки във формат "name : value", разделени с двоеточие.',
    'cssLengthTooltip': 'Въведете числена стойност в пиксели или друга валидна CSS единица (px, %, in, cm, mm, em, ex, pt, или pc).',
    'unavailable': '%1<span class="cke_accessibility">, недостъпно</span>',
    'keyboard': {
      '8': 'Backspace',
      '13': 'Enter',
      '16': 'Shift',
      '17': 'Ctrl',
      '18': 'Alt',
      '32': 'Space',
      '35': 'End',
      '36': 'Home',
      '46': 'Delete',
      '224': 'Command'
    },
    'keyboardShortcut': 'Keyboard shortcut'
  },
  'about': {
    'copy': 'Copyright &copy; $1. All rights reserved.',
    'dlgTitle': 'Относно CKEditor',
    'help': 'Проверете $1 за помощ.',
    'moreInfo': 'За лицензионна информация моля посетете сайта ни:',
    'title': 'Относно CKEditor',
    'userGuide': 'CKEditor User\'s Guide'
  },
  'basicstyles': {
    'bold': 'Удебелен',
    'italic': 'Наклонен',
    'strike': 'Зачертан текст',
    'subscript': 'Индексиран текст',
    'superscript': 'Суперскрипт',
    'underline': 'Подчертан'
  },
  'blockquote': {
    'toolbar': 'Блок за цитат'
  },
  'notification': {
    'closed': 'Notification closed.'
  },
  'button': {
    'selectedLabel': '%1 (Избрано)'
  },
  'toolbar': {
    'toolbarCollapse': 'Свиване на лентата с инструменти',
    'toolbarExpand': 'Разширяване на лентата с инструменти',
    'toolbarGroups': {
      'document': 'Документ',
      'clipboard': 'Клипборд/Отмяна',
      'editing': 'Промяна',
      'forms': 'Форми',
      'basicstyles': 'Базови стилове',
      'paragraph': 'Параграф',
      'links': 'Връзки',
      'insert': 'Вмъкване',
      'styles': 'Стилове',
      'colors': 'Цветове',
      'tools': 'Инструменти'
    },
    'toolbars': 'Ленти с инструменти'
  },
  'clipboard': {
    'copy': 'Копирай',
    'copyError': 'Настройките за сигурност на вашия бразуър не разрешават на редактора да изпълни запаметяването. За целта използвайте клавиатурата (Ctrl/Cmd+C).',
    'cut': 'Отрежи',
    'cutError': 'Настройките за сигурност на Вашия браузър не позволяват на редактора автоматично да изъплни действията за отрязване. Моля ползвайте клавиатурните команди за целта (ctrl+x).',
    'paste': 'Вмъкни',
    'pasteNotification': 'Your browser doesn\'t allow you to paste this way. Press %1 to paste.'
  },
  'contextmenu': {
    'options': 'Опции на контекстното меню'
  },
  'elementspath': {
    'eleLabel': 'Път за елементите',
    'eleTitle': '%1 елемент'
  },
  'format': {
    'label': 'Формат',
    'panelTitle': 'Формат',
    'tag_address': 'Адрес',
    'tag_div': 'Параграф (DIV)',
    'tag_h1': 'Заглавие 1',
    'tag_h2': 'Заглавие 2',
    'tag_h3': 'Заглавие 3',
    'tag_h4': 'Заглавие 4',
    'tag_h5': 'Заглавие 5',
    'tag_h6': 'Заглавие 6',
    'tag_p': 'Нормален',
    'tag_pre': 'Форматиран'
  },
  'horizontalrule': {
    'toolbar': 'Вмъкване на хоризонтална линия'
  },
  'image': {
    'alt': 'Алтернативен текст',
    'border': 'Рамка',
    'btnUpload': 'Изпрати я на сървъра',
    'button2Img': 'Do you want to transform the selected image button on a simple image?',
    'hSpace': 'Хоризонтален отстъп',
    'img2Button': 'Do you want to transform the selected image on a image button?',
    'infoTab': 'Инфо за снимка',
    'linkTab': 'Връзка',
    'lockRatio': 'Заключване на съотношението',
    'menu': 'Настройки за снимка',
    'resetSize': 'Нулиране на размер',
    'title': 'Настройки за снимка',
    'titleButton': 'Настойки за бутон за снимка',
    'upload': 'Качване',
    'urlMissing': 'Image source URL is missing.',
    'vSpace': 'Вертикален отстъп',
    'validateBorder': 'Border must be a whole number.',
    'validateHSpace': 'HSpace must be a whole number.',
    'validateVSpace': 'VSpace must be a whole number.'
  },
  'indent': {
    'indent': 'Увеличаване на отстъпа',
    'outdent': 'Намаляване на отстъпа'
  },
  'fakeobjects': {
    'anchor': 'Кука',
    'flash': 'Флаш анимация',
    'hiddenfield': 'Скрито поле',
    'iframe': 'IFrame',
    'unknown': 'Неизвестен обект'
  },
  'link': {
    'acccessKey': 'Ключ за достъп',
    'advanced': 'Разширено',
    'advisoryContentType': 'Препоръчителен тип на съдържанието',
    'advisoryTitle': 'Препоръчително заглавие',
    'anchor': {
      'toolbar': 'Котва',
      'menu': 'Промяна на котва',
      'title': 'Настройки на котва',
      'name': 'Име на котва',
      'errorName': 'Моля въведете име на котвата',
      'remove': 'Премахване на котва'
    },
    'anchorId': 'По ID на елемент',
    'anchorName': 'По име на котва',
    'charset': 'Тип на свързания ресурс',
    'cssClasses': 'Класове за CSS',
    'download': 'Force Download',
    'displayText': 'Display Text',
    'emailAddress': 'E-mail aдрес',
    'emailBody': 'Съдържание',
    'emailSubject': 'Тема',
    'id': 'ID',
    'info': 'Инфо за връзката',
    'langCode': 'Код за езика',
    'langDir': 'Посока на езика',
    'langDirLTR': 'Ляво на Дясно (ЛнД)',
    'langDirRTL': 'Дясно на Ляво (ДнЛ)',
    'menu': 'Промяна на връзка',
    'name': 'Име',
    'noAnchors': '(Няма котви в текущия документ)',
    'noEmail': 'Моля въведете e-mail aдрес',
    'noUrl': 'Моля въведете URL адреса',
    'other': '<друго>',
    'popupDependent': 'Зависимост (Netscape)',
    'popupFeatures': 'Функции на изкачащ прозорец',
    'popupFullScreen': 'Цял екран (IE)',
    'popupLeft': 'Лява позиция',
    'popupLocationBar': 'Лента с локацията',
    'popupMenuBar': 'Лента за меню',
    'popupResizable': 'Оразмеряем',
    'popupScrollBars': 'Скролери',
    'popupStatusBar': 'Статусна лента',
    'popupToolbar': 'Лента с инструменти',
    'popupTop': 'Горна позиция',
    'rel': 'Връзка',
    'selectAnchor': 'Изберете котва',
    'styles': 'Стил',
    'tabIndex': 'Ред на достъп',
    'target': 'Цел',
    'targetFrame': '<frame>',
    'targetFrameName': 'Име на целевият прозорец',
    'targetPopup': '<изкачащ прозорец>',
    'targetPopupName': 'Име на изкачащ прозорец',
    'title': 'Връзка',
    'toAnchor': 'Връзка към котва в текста',
    'toEmail': 'E-mail',
    'toUrl': 'Уеб адрес',
    'toolbar': 'Връзка',
    'type': 'Тип на връзката',
    'unlink': 'Премахни връзката',
    'upload': 'Качване'
  },
  'list': {
    'bulletedlist': 'Вмъкване/Премахване на точков списък',
    'numberedlist': 'Вмъкване/Премахване на номериран списък'
  },
  'magicline': {
    'title': 'Вмъкнете параграф тук'
  },
  'maximize': {
    'maximize': 'Максимизиране',
    'minimize': 'Минимизиране'
  },
  'pastetext': {
    'button': 'Вмъкни като чист текст',
    'pasteNotification': 'Your browser does not allow you to paste plain text this way. Press %1 to paste.'
  },
  'pastefromword': {
    'confirmCleanup': 'The text you want to paste seems to be copied from Word. Do you want to clean it before pasting?',
    'error': 'It was not possible to clean up the pasted data due to an internal error',
    'title': 'Вмъкни от MS Word',
    'toolbar': 'Вмъкни от MS Word'
  },
  'removeformat': {
    'toolbar': 'Премахване на форматирането'
  },
  'sourcearea': {
    'toolbar': 'Изходен код'
  },
  'specialchar': {
    'options': 'Опции за специален знак',
    'title': 'Избор на специален знак',
    'toolbar': 'Вмъкване на специален знак'
  },
  'scayt': {
    'btn_about': 'About SCAYT',
    'btn_dictionaries': 'Речници',
    'btn_disable': 'Disable SCAYT',
    'btn_enable': 'Enable SCAYT',
    'btn_langs': 'Languages',
    'btn_options': 'Options',
    'text_title': 'Spell Check As You Type'
  },
  'stylescombo': {
    'label': 'Стилове',
    'panelTitle': 'Стилове за форматиране',
    'panelTitle1': 'Блокови стилове',
    'panelTitle2': 'Вътрешни стилове',
    'panelTitle3': 'Обектни стилове'
  },
  'table': {
    'border': 'Размер на рамката',
    'caption': 'Заглавие',
    'cell': {
      'menu': 'Клетка',
      'insertBefore': 'Вмъкване на клетка преди',
      'insertAfter': 'Вмъкване на клетка след',
      'deleteCell': 'Изтриване на клетки',
      'merge': 'Сливане на клетки',
      'mergeRight': 'Сливане в дясно',
      'mergeDown': 'Merge Down',
      'splitHorizontal': 'Split Cell Horizontally',
      'splitVertical': 'Split Cell Vertically',
      'title': 'Настройки на клетката',
      'cellType': 'Тип на клетката',
      'rowSpan': 'Rows Span',
      'colSpan': 'Columns Span',
      'wordWrap': 'Авто. пренос',
      'hAlign': 'Хоризонтално подравняване',
      'vAlign': 'Вертикално подравняване',
      'alignBaseline': 'Базова линия',
      'bgColor': 'Фон',
      'borderColor': 'Цвят на рамката',
      'data': 'Данни',
      'header': 'Хедър',
      'yes': 'Да',
      'no': 'Не',
      'invalidWidth': 'Cell width must be a number.',
      'invalidHeight': 'Cell height must be a number.',
      'invalidRowSpan': 'Rows span must be a whole number.',
      'invalidColSpan': 'Columns span must be a whole number.',
      'chooseColor': 'Изберете'
    },
    'cellPad': 'Отделяне на клетките',
    'cellSpace': 'Разтояние между клетките',
    'column': {
      'menu': 'Колона',
      'insertBefore': 'Вмъкване на колона преди',
      'insertAfter': 'Вмъкване на колона след',
      'deleteColumn': 'Изтриване на колони'
    },
    'columns': 'Колони',
    'deleteTable': 'Изтриване на таблица',
    'headers': 'Хедъри',
    'headersBoth': 'Заедно',
    'headersColumn': 'Първа колона',
    'headersNone': 'Няма',
    'headersRow': 'Първи ред',
    'invalidBorder': 'Размерът на рамката трябва да е число.',
    'invalidCellPadding': 'Отстоянието на клетките трябва да е позитивно число.',
    'invalidCellSpacing': 'Интервала в клетките трябва да е позитивно число.',
    'invalidCols': 'Броят колони трябва да е по-голям от 0.',
    'invalidHeight': 'Височината на таблицата трябва да е число.',
    'invalidRows': 'Броят редове трябва да е по-голям от 0.',
    'invalidWidth': 'Ширината на таблицата трябва да е число.',
    'menu': 'Настройки на таблицата',
    'row': {
      'menu': 'Ред',
      'insertBefore': 'Вмъкване на ред преди',
      'insertAfter': 'Вмъкване на ред след',
      'deleteRow': 'Изтриване на редове'
    },
    'rows': 'Редове',
    'summary': 'Обща информация',
    'title': 'Настройки на таблицата',
    'toolbar': 'Таблица',
    'widthPc': 'процент',
    'widthPx': 'пиксела',
    'widthUnit': 'единица за ширина'
  },
  'undo': {
    'redo': 'Връщане на предишен статус',
    'undo': 'Възтанови'
  },
  'wsc': {
    'btnIgnore': 'Игнорирай',
    'btnIgnoreAll': 'Игнорирай всичко',
    'btnReplace': 'Препокриване',
    'btnReplaceAll': 'Препокрий всичко',
    'btnUndo': 'Възтанови',
    'changeTo': 'Промени на',
    'errorLoading': 'Error loading application service host: %s.',
    'ieSpellDownload': 'Spell checker not installed. Do you want to download it now?',
    'manyChanges': 'Spell check complete: %1 words changed',
    'noChanges': 'Spell check complete: No words changed',
    'noMispell': 'Spell check complete: No misspellings found',
    'noSuggestions': '- Няма препоръчани -',
    'notAvailable': 'Съжаляваме, но услугата не е достъпна за момента',
    'notInDic': 'Не е в речника',
    'oneChange': 'Spell check complete: One word changed',
    'progress': 'Проверява се правописа...',
    'title': 'Проверка на правопис',
    'toolbar': 'Проверка на правопис'
  }
};


/***/ }),
/* 251 */
/***/ (function(module, exports) {


/*
Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
For licensing, see LICENSE.md or http://ckeditor.com/license
 */
CKEDITOR.lang['en-au'] = {
  'wsc': {
    'btnIgnore': 'Ignore',
    'btnIgnoreAll': 'Ignore All',
    'btnReplace': 'Replace',
    'btnReplaceAll': 'Replace All',
    'btnUndo': 'Undo',
    'changeTo': 'Change to',
    'errorLoading': 'Error loading application service host: %s.',
    'ieSpellDownload': 'Spell checker not installed. Do you want to download it now?',
    'manyChanges': 'Spell check complete: %1 words changed',
    'noChanges': 'Spell check complete: No words changed',
    'noMispell': 'Spell check complete: No misspellings found',
    'noSuggestions': '- No suggestions -',
    'notAvailable': 'Sorry, but service is unavailable now.',
    'notInDic': 'Not in dictionary',
    'oneChange': 'Spell check complete: One word changed',
    'progress': 'Spell check in progress...',
    'title': 'Spell Checker',
    'toolbar': 'Check Spelling'
  },
  'undo': {
    'redo': 'Redo',
    'undo': 'Undo'
  },
  'toolbar': {
    'toolbarCollapse': 'Collapse Toolbar',
    'toolbarExpand': 'Expand Toolbar',
    'toolbarGroups': {
      'document': 'Document',
      'clipboard': 'Clipboard/Undo',
      'editing': 'Editing',
      'forms': 'Forms',
      'basicstyles': 'Basic Styles',
      'paragraph': 'Paragraph',
      'links': 'Links',
      'insert': 'Insert',
      'styles': 'Styles',
      'colors': 'Colors',
      'tools': 'Tools'
    },
    'toolbars': 'Editor toolbars'
  },
  'table': {
    'border': 'Border size',
    'caption': 'Caption',
    'cell': {
      'menu': 'Cell',
      'insertBefore': 'Insert Cell Before',
      'insertAfter': 'Insert Cell After',
      'deleteCell': 'Delete Cells',
      'merge': 'Merge Cells',
      'mergeRight': 'Merge Right',
      'mergeDown': 'Merge Down',
      'splitHorizontal': 'Split Cell Horizontally',
      'splitVertical': 'Split Cell Vertically',
      'title': 'Cell Properties',
      'cellType': 'Cell Type',
      'rowSpan': 'Rows Span',
      'colSpan': 'Columns Span',
      'wordWrap': 'Word Wrap',
      'hAlign': 'Horizontal Alignment',
      'vAlign': 'Vertical Alignment',
      'alignBaseline': 'Baseline',
      'bgColor': 'Background Color',
      'borderColor': 'Border Color',
      'data': 'Data',
      'header': 'Header',
      'yes': 'Yes',
      'no': 'No',
      'invalidWidth': 'Cell width must be a number.',
      'invalidHeight': 'Cell height must be a number.',
      'invalidRowSpan': 'Rows span must be a whole number.',
      'invalidColSpan': 'Columns span must be a whole number.',
      'chooseColor': 'Choose'
    },
    'cellPad': 'Cell padding',
    'cellSpace': 'Cell spacing',
    'column': {
      'menu': 'Column',
      'insertBefore': 'Insert Column Before',
      'insertAfter': 'Insert Column After',
      'deleteColumn': 'Delete Columns'
    },
    'columns': 'Columns',
    'deleteTable': 'Delete Table',
    'headers': 'Headers',
    'headersBoth': 'Both',
    'headersColumn': 'First column',
    'headersNone': 'None',
    'headersRow': 'First Row',
    'invalidBorder': 'Border size must be a number.',
    'invalidCellPadding': 'Cell padding must be a number.',
    'invalidCellSpacing': 'Cell spacing must be a number.',
    'invalidCols': 'Number of columns must be a number greater than 0.',
    'invalidHeight': 'Table height must be a number.',
    'invalidRows': 'Number of rows must be a number greater than 0.',
    'invalidWidth': 'Table width must be a number.',
    'menu': 'Table Properties',
    'row': {
      'menu': 'Row',
      'insertBefore': 'Insert Row Before',
      'insertAfter': 'Insert Row After',
      'deleteRow': 'Delete Rows'
    },
    'rows': 'Rows',
    'summary': 'Summary',
    'title': 'Table Properties',
    'toolbar': 'Table',
    'widthPc': 'percent',
    'widthPx': 'pixels',
    'widthUnit': 'width unit'
  },
  'stylescombo': {
    'label': 'Styles',
    'panelTitle': 'Formatting Styles',
    'panelTitle1': 'Block Styles',
    'panelTitle2': 'Inline Styles',
    'panelTitle3': 'Object Styles'
  },
  'specialchar': {
    'options': 'Special Character Options',
    'title': 'Select Special Character',
    'toolbar': 'Insert Special Character'
  },
  'sourcearea': {
    'toolbar': 'Source'
  },
  'scayt': {
    'btn_about': 'About SCAYT',
    'btn_dictionaries': 'Dictionaries',
    'btn_disable': 'Disable SCAYT',
    'btn_enable': 'Enable SCAYT',
    'btn_langs': 'Languages',
    'btn_options': 'Options',
    'text_title': 'Spell Check As You Type'
  },
  'removeformat': {
    'toolbar': 'Remove Format'
  },
  'pastetext': {
    'button': 'Paste as plain text',
    'title': 'Paste as Plain Text'
  },
  'pastefromword': {
    'confirmCleanup': 'The text you want to paste seems to be copied from Word. Do you want to clean it before pasting?',
    'error': 'It was not possible to clean up the pasted data due to an internal error',
    'title': 'Paste from Word',
    'toolbar': 'Paste from Word'
  },
  'maximize': {
    'maximize': 'Maximize',
    'minimize': 'Minimize'
  },
  'magicline': {
    'title': 'Insert paragraph here'
  },
  'list': {
    'bulletedlist': 'Insert/Remove Bulleted List',
    'numberedlist': 'Insert/Remove Numbered List'
  },
  'link': {
    'acccessKey': 'Access Key',
    'advanced': 'Advanced',
    'advisoryContentType': 'Advisory Content Type',
    'advisoryTitle': 'Advisory Title',
    'anchor': {
      'toolbar': 'Anchor',
      'menu': 'Edit Anchor',
      'title': 'Anchor Properties',
      'name': 'Anchor Name',
      'errorName': 'Please type the anchor name',
      'remove': 'Remove Anchor'
    },
    'anchorId': 'By Element Id',
    'anchorName': 'By Anchor Name',
    'charset': 'Linked Resource Charset',
    'cssClasses': 'Stylesheet Classes',
    'emailAddress': 'E-Mail Address',
    'emailBody': 'Message Body',
    'emailSubject': 'Message Subject',
    'id': 'Id',
    'info': 'Link Info',
    'langCode': 'Language Code',
    'langDir': 'Language Direction',
    'langDirLTR': 'Left to Right (LTR)',
    'langDirRTL': 'Right to Left (RTL)',
    'menu': 'Edit Link',
    'name': 'Name',
    'noAnchors': '(No anchors available in the document)',
    'noEmail': 'Please type the e-mail address',
    'noUrl': 'Please type the link URL',
    'other': '<other>',
    'popupDependent': 'Dependent (Netscape)',
    'popupFeatures': 'Popup Window Features',
    'popupFullScreen': 'Full Screen (IE)',
    'popupLeft': 'Left Position',
    'popupLocationBar': 'Location Bar',
    'popupMenuBar': 'Menu Bar',
    'popupResizable': 'Resizable',
    'popupScrollBars': 'Scroll Bars',
    'popupStatusBar': 'Status Bar',
    'popupToolbar': 'Toolbar',
    'popupTop': 'Top Position',
    'rel': 'Relationship',
    'selectAnchor': 'Select an Anchor',
    'styles': 'Style',
    'tabIndex': 'Tab Index',
    'target': 'Target',
    'targetFrame': '<frame>',
    'targetFrameName': 'Target Frame Name',
    'targetPopup': '<popup window>',
    'targetPopupName': 'Popup Window Name',
    'title': 'Link',
    'toAnchor': 'Link to anchor in the text',
    'toEmail': 'E-mail',
    'toUrl': 'URL',
    'toolbar': 'Link',
    'type': 'Link Type',
    'unlink': 'Unlink',
    'upload': 'Upload'
  },
  'indent': {
    'indent': 'Increase Indent',
    'outdent': 'Decrease Indent'
  },
  'image': {
    'alertUrl': 'Please type the image URL',
    'alt': 'Alternative Text',
    'border': 'Border',
    'btnUpload': 'Send it to the Server',
    'button2Img': 'Do you want to transform the selected image button on a simple image?',
    'hSpace': 'HSpace',
    'img2Button': 'Do you want to transform the selected image on a image button?',
    'infoTab': 'Image Info',
    'linkTab': 'Link',
    'lockRatio': 'Lock Ratio',
    'menu': 'Image Properties',
    'resetSize': 'Reset Size',
    'title': 'Image Properties',
    'titleButton': 'Image Button Properties',
    'upload': 'Upload',
    'urlMissing': 'Image source URL is missing.',
    'vSpace': 'VSpace',
    'validateBorder': 'Border must be a whole number.',
    'validateHSpace': 'HSpace must be a whole number.',
    'validateVSpace': 'VSpace must be a whole number.'
  },
  'horizontalrule': {
    'toolbar': 'Insert Horizontal Line'
  },
  'format': {
    'label': 'Format',
    'panelTitle': 'Paragraph Format',
    'tag_address': 'Address',
    'tag_div': 'Normal (DIV)',
    'tag_h1': 'Heading 1',
    'tag_h2': 'Heading 2',
    'tag_h3': 'Heading 3',
    'tag_h4': 'Heading 4',
    'tag_h5': 'Heading 5',
    'tag_h6': 'Heading 6',
    'tag_p': 'Normal',
    'tag_pre': 'Formatted'
  },
  'fakeobjects': {
    'anchor': 'Anchor',
    'flash': 'Flash Animation',
    'hiddenfield': 'Hidden Field',
    'iframe': 'IFrame',
    'unknown': 'Unknown Object'
  },
  'elementspath': {
    'eleLabel': 'Elements path',
    'eleTitle': '%1 element'
  },
  'contextmenu': {
    'options': 'Context Menu Options'
  },
  'clipboard': {
    'copy': 'Copy',
    'copyError': 'Your browser security settings don\'t permit the editor to automatically execute copying operations. Please use the keyboard for that (Ctrl/Cmd+C).',
    'cut': 'Cut',
    'cutError': 'Your browser security settings don\'t permit the editor to automatically execute cutting operations. Please use the keyboard for that (Ctrl/Cmd+X).',
    'paste': 'Paste',
    'pasteArea': 'Paste Area',
    'pasteMsg': 'Please paste inside the following box using the keyboard (<strong>Ctrl/Cmd+V</strong>) and hit OK',
    'securityMsg': 'Because of your browser security settings, the editor is not able to access your clipboard data directly. You are required to paste it again in this window.',
    'title': 'Paste'
  },
  'button': {
    'selectedLabel': '%1 (Selected)'
  },
  'blockquote': {
    'toolbar': 'Block Quote'
  },
  'basicstyles': {
    'bold': 'Bold',
    'italic': 'Italic',
    'strike': 'Strike Through',
    'subscript': 'Subscript',
    'superscript': 'Superscript',
    'underline': 'Underline'
  },
  'about': {
    'copy': 'Copyright &copy; $1. All rights reserved.',
    'dlgTitle': 'About CKEditor',
    'help': 'Check $1 for help.',
    'moreInfo': 'For licensing information please visit our web site:',
    'title': 'About CKEditor',
    'userGuide': 'CKEditor User\'s Guide'
  },
  'editor': 'Rich Text Editor',
  'editorPanel': 'Rich Text Editor panel',
  'common': {
    'editorHelp': 'Press ALT 0 for help',
    'browseServer': 'Browse Server',
    'url': 'URL',
    'protocol': 'Protocol',
    'upload': 'Upload',
    'uploadSubmit': 'Send it to the Server',
    'image': 'Image',
    'flash': 'Flash',
    'form': 'Form',
    'checkbox': 'Checkbox',
    'radio': 'Radio Button',
    'textField': 'Text Field',
    'textarea': 'Textarea',
    'hiddenField': 'Hidden Field',
    'button': 'Button',
    'select': 'Selection Field',
    'imageButton': 'Image Button',
    'notSet': '<not set>',
    'id': 'Id',
    'name': 'Name',
    'langDir': 'Language Direction',
    'langDirLtr': 'Left to Right (LTR)',
    'langDirRtl': 'Right to Left (RTL)',
    'langCode': 'Language Code',
    'longDescr': 'Long Description URL',
    'cssClass': 'Stylesheet Classes',
    'advisoryTitle': 'Advisory Title',
    'cssStyle': 'Style',
    'ok': 'OK',
    'cancel': 'Cancel',
    'close': 'Close',
    'preview': 'Preview',
    'resize': 'Resize',
    'generalTab': 'General',
    'advancedTab': 'Advanced',
    'validateNumberFailed': 'This value is not a number.',
    'confirmNewPage': 'Any unsaved changes to this content will be lost. Are you sure you want to load new page?',
    'confirmCancel': 'You have changed some options. Are you sure you want to close the dialog window?',
    'options': 'Options',
    'target': 'Target',
    'targetNew': 'New Window (_blank)',
    'targetTop': 'Topmost Window (_top)',
    'targetSelf': 'Same Window (_self)',
    'targetParent': 'Parent Window (_parent)',
    'langDirLTR': 'Left to Right (LTR)',
    'langDirRTL': 'Right to Left (RTL)',
    'styles': 'Style',
    'cssClasses': 'Stylesheet Classes',
    'width': 'Width',
    'height': 'Height',
    'align': 'Align',
    'alignLeft': 'Left',
    'alignRight': 'Right',
    'alignCenter': 'Centre',
    'alignJustify': 'Justify',
    'alignTop': 'Top',
    'alignMiddle': 'Middle',
    'alignBottom': 'Bottom',
    'alignNone': 'None',
    'invalidValue': 'Invalid value.',
    'invalidHeight': 'Height must be a number.',
    'invalidWidth': 'Width must be a number.',
    'invalidCssLength': 'Value specified for the "%1" field must be a positive number with or without a valid CSS measurement unit (px, %, in, cm, mm, em, ex, pt, or pc).',
    'invalidHtmlLength': 'Value specified for the "%1" field must be a positive number with or without a valid HTML measurement unit (px or %).',
    'invalidInlineStyle': 'Value specified for the inline style must consist of one or more tuples with the format of "name : value", separated by semi-colons.',
    'cssLengthTooltip': 'Enter a number for a value in pixels or a number with a valid CSS unit (px, %, in, cm, mm, em, ex, pt, or pc).',
    'unavailable': '%1<span class="cke_accessibility">, unavailable</span>'
  }
};


/***/ }),
/* 252 */
/***/ (function(module, exports) {


/*
Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
For licensing, see LICENSE.md or http://ckeditor.com/license
 */
CKEDITOR.lang['en'] = {
  'wsc': {
    'btnIgnore': 'Ignore',
    'btnIgnoreAll': 'Ignore All',
    'btnReplace': 'Replace',
    'btnReplaceAll': 'Replace All',
    'btnUndo': 'Undo',
    'changeTo': 'Change to',
    'errorLoading': 'Error loading application service host: %s.',
    'ieSpellDownload': 'Spell checker not installed. Do you want to download it now?',
    'manyChanges': 'Spell check complete: %1 words changed',
    'noChanges': 'Spell check complete: No words changed',
    'noMispell': 'Spell check complete: No misspellings found',
    'noSuggestions': '- No suggestions -',
    'notAvailable': 'Sorry, but service is unavailable now.',
    'notInDic': 'Not in dictionary',
    'oneChange': 'Spell check complete: One word changed',
    'progress': 'Spell check in progress...',
    'title': 'Spell Checker',
    'toolbar': 'Check Spelling'
  },
  'undo': {
    'redo': 'Redo',
    'undo': 'Undo'
  },
  'toolbar': {
    'toolbarCollapse': 'Collapse Toolbar',
    'toolbarExpand': 'Expand Toolbar',
    'toolbarGroups': {
      'document': 'Document',
      'clipboard': 'Clipboard/Undo',
      'editing': 'Editing',
      'forms': 'Forms',
      'basicstyles': 'Basic Styles',
      'paragraph': 'Paragraph',
      'links': 'Links',
      'insert': 'Insert',
      'styles': 'Styles',
      'colors': 'Colors',
      'tools': 'Tools'
    },
    'toolbars': 'Editor toolbars'
  },
  'table': {
    'border': 'Border size',
    'caption': 'Caption',
    'cell': {
      'menu': 'Cell',
      'insertBefore': 'Insert Cell Before',
      'insertAfter': 'Insert Cell After',
      'deleteCell': 'Delete Cells',
      'merge': 'Merge Cells',
      'mergeRight': 'Merge Right',
      'mergeDown': 'Merge Down',
      'splitHorizontal': 'Split Cell Horizontally',
      'splitVertical': 'Split Cell Vertically',
      'title': 'Cell Properties',
      'cellType': 'Cell Type',
      'rowSpan': 'Rows Span',
      'colSpan': 'Columns Span',
      'wordWrap': 'Word Wrap',
      'hAlign': 'Horizontal Alignment',
      'vAlign': 'Vertical Alignment',
      'alignBaseline': 'Baseline',
      'bgColor': 'Background Color',
      'borderColor': 'Border Color',
      'data': 'Data',
      'header': 'Header',
      'yes': 'Yes',
      'no': 'No',
      'invalidWidth': 'Cell width must be a number.',
      'invalidHeight': 'Cell height must be a number.',
      'invalidRowSpan': 'Rows span must be a whole number.',
      'invalidColSpan': 'Columns span must be a whole number.',
      'chooseColor': 'Choose'
    },
    'cellPad': 'Cell padding',
    'cellSpace': 'Cell spacing',
    'column': {
      'menu': 'Column',
      'insertBefore': 'Insert Column Before',
      'insertAfter': 'Insert Column After',
      'deleteColumn': 'Delete Columns'
    },
    'columns': 'Columns',
    'deleteTable': 'Delete Table',
    'headers': 'Headers',
    'headersBoth': 'Both',
    'headersColumn': 'First column',
    'headersNone': 'None',
    'headersRow': 'First Row',
    'invalidBorder': 'Border size must be a number.',
    'invalidCellPadding': 'Cell padding must be a positive number.',
    'invalidCellSpacing': 'Cell spacing must be a positive number.',
    'invalidCols': 'Number of columns must be a number greater than 0.',
    'invalidHeight': 'Table height must be a number.',
    'invalidRows': 'Number of rows must be a number greater than 0.',
    'invalidWidth': 'Table width must be a number.',
    'menu': 'Table Properties',
    'row': {
      'menu': 'Row',
      'insertBefore': 'Insert Row Before',
      'insertAfter': 'Insert Row After',
      'deleteRow': 'Delete Rows'
    },
    'rows': 'Rows',
    'summary': 'Summary',
    'title': 'Table Properties',
    'toolbar': 'Table',
    'widthPc': 'percent',
    'widthPx': 'pixels',
    'widthUnit': 'width unit'
  },
  'stylescombo': {
    'label': 'Styles',
    'panelTitle': 'Formatting Styles',
    'panelTitle1': 'Block Styles',
    'panelTitle2': 'Inline Styles',
    'panelTitle3': 'Object Styles'
  },
  'specialchar': {
    'options': 'Special Character Options',
    'title': 'Select Special Character',
    'toolbar': 'Insert Special Character'
  },
  'sourcearea': {
    'toolbar': 'Source'
  },
  'scayt': {
    'btn_about': 'About SCAYT',
    'btn_dictionaries': 'Dictionaries',
    'btn_disable': 'Disable SCAYT',
    'btn_enable': 'Enable SCAYT',
    'btn_langs': 'Languages',
    'btn_options': 'Options',
    'text_title': 'Spell Check As You Type'
  },
  'removeformat': {
    'toolbar': 'Remove Format'
  },
  'pastetext': {
    'button': 'Paste as plain text',
    'title': 'Paste as Plain Text'
  },
  'pastefromword': {
    'confirmCleanup': 'The text you want to paste seems to be copied from Word. Do you want to clean it before pasting?',
    'error': 'It was not possible to clean up the pasted data due to an internal error',
    'title': 'Paste from Word',
    'toolbar': 'Paste from Word'
  },
  'maximize': {
    'maximize': 'Maximize',
    'minimize': 'Minimize'
  },
  'magicline': {
    'title': 'Insert paragraph here'
  },
  'list': {
    'bulletedlist': 'Insert/Remove Bulleted List',
    'numberedlist': 'Insert/Remove Numbered List'
  },
  'link': {
    'acccessKey': 'Access Key',
    'advanced': 'Advanced',
    'advisoryContentType': 'Advisory Content Type',
    'advisoryTitle': 'Advisory Title',
    'anchor': {
      'toolbar': 'Anchor',
      'menu': 'Edit Anchor',
      'title': 'Anchor Properties',
      'name': 'Anchor Name',
      'errorName': 'Please type the anchor name',
      'remove': 'Remove Anchor'
    },
    'anchorId': 'By Element Id',
    'anchorName': 'By Anchor Name',
    'charset': 'Linked Resource Charset',
    'cssClasses': 'Stylesheet Classes',
    'emailAddress': 'E-Mail Address',
    'emailBody': 'Message Body',
    'emailSubject': 'Message Subject',
    'id': 'Id',
    'info': 'Link Info',
    'langCode': 'Language Code',
    'langDir': 'Language Direction',
    'langDirLTR': 'Left to Right (LTR)',
    'langDirRTL': 'Right to Left (RTL)',
    'menu': 'Edit Link',
    'name': 'Name',
    'noAnchors': '(No anchors available in the document)',
    'noEmail': 'Please type the e-mail address',
    'noUrl': 'Please type the link URL',
    'other': '<other>',
    'popupDependent': 'Dependent (Netscape)',
    'popupFeatures': 'Popup Window Features',
    'popupFullScreen': 'Full Screen (IE)',
    'popupLeft': 'Left Position',
    'popupLocationBar': 'Location Bar',
    'popupMenuBar': 'Menu Bar',
    'popupResizable': 'Resizable',
    'popupScrollBars': 'Scroll Bars',
    'popupStatusBar': 'Status Bar',
    'popupToolbar': 'Toolbar',
    'popupTop': 'Top Position',
    'rel': 'Relationship',
    'selectAnchor': 'Select an Anchor',
    'styles': 'Style',
    'tabIndex': 'Tab Index',
    'target': 'Target',
    'targetFrame': '<frame>',
    'targetFrameName': 'Target Frame Name',
    'targetPopup': '<popup window>',
    'targetPopupName': 'Popup Window Name',
    'title': 'Link',
    'toAnchor': 'Link to anchor in the text',
    'toEmail': 'E-mail',
    'toUrl': 'URL',
    'toolbar': 'Link',
    'type': 'Link Type',
    'unlink': 'Unlink',
    'upload': 'Upload'
  },
  'indent': {
    'indent': 'Increase Indent',
    'outdent': 'Decrease Indent'
  },
  'image': {
    'alertUrl': 'Please type the image URL',
    'alt': 'Alternative Text',
    'border': 'Border',
    'btnUpload': 'Send it to the Server',
    'button2Img': 'Do you want to transform the selected image button on a simple image?',
    'hSpace': 'HSpace',
    'img2Button': 'Do you want to transform the selected image on a image button?',
    'infoTab': 'Image Info',
    'linkTab': 'Link',
    'lockRatio': 'Lock Ratio',
    'menu': 'Image Properties',
    'resetSize': 'Reset Size',
    'title': 'Image Properties',
    'titleButton': 'Image Button Properties',
    'upload': 'Upload',
    'urlMissing': 'Image source URL is missing.',
    'vSpace': 'VSpace',
    'validateBorder': 'Border must be a whole number.',
    'validateHSpace': 'HSpace must be a whole number.',
    'validateVSpace': 'VSpace must be a whole number.'
  },
  'horizontalrule': {
    'toolbar': 'Insert Horizontal Line'
  },
  'format': {
    'label': 'Format',
    'panelTitle': 'Paragraph Format',
    'tag_address': 'Address',
    'tag_div': 'Normal (DIV)',
    'tag_h1': 'Heading 1',
    'tag_h2': 'Heading 2',
    'tag_h3': 'Heading 3',
    'tag_h4': 'Heading 4',
    'tag_h5': 'Heading 5',
    'tag_h6': 'Heading 6',
    'tag_p': 'Normal',
    'tag_pre': 'Formatted'
  },
  'fakeobjects': {
    'anchor': 'Anchor',
    'flash': 'Flash Animation',
    'hiddenfield': 'Hidden Field',
    'iframe': 'IFrame',
    'unknown': 'Unknown Object'
  },
  'elementspath': {
    'eleLabel': 'Elements path',
    'eleTitle': '%1 element'
  },
  'contextmenu': {
    'options': 'Context Menu Options'
  },
  'clipboard': {
    'copy': 'Copy',
    'copyError': 'Your browser security settings don\'t permit the editor to automatically execute copying operations. Please use the keyboard for that (Ctrl/Cmd+C).',
    'cut': 'Cut',
    'cutError': 'Your browser security settings don\'t permit the editor to automatically execute cutting operations. Please use the keyboard for that (Ctrl/Cmd+X).',
    'paste': 'Paste',
    'pasteArea': 'Paste Area',
    'pasteMsg': 'Please paste inside the following box using the keyboard (<strong>Ctrl/Cmd+V</strong>) and hit OK',
    'securityMsg': 'Because of your browser security settings, the editor is not able to access your clipboard data directly. You are required to paste it again in this window.',
    'title': 'Paste'
  },
  'button': {
    'selectedLabel': '%1 (Selected)'
  },
  'blockquote': {
    'toolbar': 'Block Quote'
  },
  'basicstyles': {
    'bold': 'Bold',
    'italic': 'Italic',
    'strike': 'Strikethrough',
    'subscript': 'Subscript',
    'superscript': 'Superscript',
    'underline': 'Underline'
  },
  'about': {
    'copy': 'Copyright &copy; $1. All rights reserved.',
    'dlgTitle': 'About CKEditor',
    'help': 'Check $1 for help.',
    'moreInfo': 'For licensing information please visit our web site:',
    'title': 'About CKEditor',
    'userGuide': 'CKEditor User\'s Guide'
  },
  'editor': 'Rich Text Editor',
  'editorPanel': 'Rich Text Editor panel',
  'common': {
    'editorHelp': 'Press ALT 0 for help',
    'browseServer': 'Browse Server',
    'url': 'URL',
    'protocol': 'Protocol',
    'upload': 'Upload',
    'uploadSubmit': 'Send it to the Server',
    'image': 'Image',
    'flash': 'Flash',
    'form': 'Form',
    'checkbox': 'Checkbox',
    'radio': 'Radio Button',
    'textField': 'Text Field',
    'textarea': 'Textarea',
    'hiddenField': 'Hidden Field',
    'button': 'Button',
    'select': 'Selection Field',
    'imageButton': 'Image Button',
    'notSet': '<not set>',
    'id': 'Id',
    'name': 'Name',
    'langDir': 'Language Direction',
    'langDirLtr': 'Left to Right (LTR)',
    'langDirRtl': 'Right to Left (RTL)',
    'langCode': 'Language Code',
    'longDescr': 'Long Description URL',
    'cssClass': 'Stylesheet Classes',
    'advisoryTitle': 'Advisory Title',
    'cssStyle': 'Style',
    'ok': 'OK',
    'cancel': 'Cancel',
    'close': 'Close',
    'preview': 'Preview',
    'resize': 'Resize',
    'generalTab': 'General',
    'advancedTab': 'Advanced',
    'validateNumberFailed': 'This value is not a number.',
    'confirmNewPage': 'Any unsaved changes to this content will be lost. Are you sure you want to load new page?',
    'confirmCancel': 'You have changed some options. Are you sure you want to close the dialog window?',
    'options': 'Options',
    'target': 'Target',
    'targetNew': 'New Window (_blank)',
    'targetTop': 'Topmost Window (_top)',
    'targetSelf': 'Same Window (_self)',
    'targetParent': 'Parent Window (_parent)',
    'langDirLTR': 'Left to Right (LTR)',
    'langDirRTL': 'Right to Left (RTL)',
    'styles': 'Style',
    'cssClasses': 'Stylesheet Classes',
    'width': 'Width',
    'height': 'Height',
    'align': 'Alignment',
    'alignLeft': 'Left',
    'alignRight': 'Right',
    'alignCenter': 'Center',
    'alignJustify': 'Justify',
    'alignTop': 'Top',
    'alignMiddle': 'Middle',
    'alignBottom': 'Bottom',
    'alignNone': 'None',
    'invalidValue': 'Invalid value.',
    'invalidHeight': 'Height must be a number.',
    'invalidWidth': 'Width must be a number.',
    'invalidCssLength': 'Value specified for the "%1" field must be a positive number with or without a valid CSS measurement unit (px, %, in, cm, mm, em, ex, pt, or pc).',
    'invalidHtmlLength': 'Value specified for the "%1" field must be a positive number with or without a valid HTML measurement unit (px or %).',
    'invalidInlineStyle': 'Value specified for the inline style must consist of one or more tuples with the format of "name : value", separated by semi-colons.',
    'cssLengthTooltip': 'Enter a number for a value in pixels or a number with a valid CSS unit (px, %, in, cm, mm, em, ex, pt, or pc).',
    'unavailable': '%1<span class="cke_accessibility">, unavailable</span>'
  }
};


/***/ }),
/* 253 */
/***/ (function(module, exports) {

CKEDITOR.lang['es'] = {
  'editor': 'Editor de texto enriquecido',
  'editorPanel': 'Panel del Editor de Texto Enriquecido',
  'common': {
    'editorHelp': 'Pulse ALT 0 para ayuda',
    'browseServer': 'Ver Servidor',
    'url': 'URL',
    'protocol': 'Protocolo',
    'upload': 'Cargar',
    'uploadSubmit': 'Enviar al Servidor',
    'image': 'Imagen',
    'flash': 'Flash',
    'form': 'Formulario',
    'checkbox': 'Casilla de Verificación',
    'radio': 'Botones de Radio',
    'textField': 'Campo de Texto',
    'textarea': 'Area de Texto',
    'hiddenField': 'Campo Oculto',
    'button': 'Botón',
    'select': 'Campo de Selección',
    'imageButton': 'Botón Imagen',
    'notSet': '<No definido>',
    'id': 'Id',
    'name': 'Nombre',
    'langDir': 'Orientación',
    'langDirLtr': 'Izquierda a Derecha (LTR)',
    'langDirRtl': 'Derecha a Izquierda (RTL)',
    'langCode': 'Cód. de idioma',
    'longDescr': 'Descripción larga URL',
    'cssClass': 'Clases de hojas de estilo',
    'advisoryTitle': 'Título',
    'cssStyle': 'Estilo',
    'ok': 'Aceptar',
    'cancel': 'Cancelar',
    'close': 'Cerrar',
    'preview': 'Previsualización',
    'resize': 'Arrastre para redimensionar',
    'generalTab': 'General',
    'advancedTab': 'Avanzado',
    'validateNumberFailed': 'El valor no es un número.',
    'confirmNewPage': 'Cualquier cambio que no se haya guardado se perderá.\u000d\n¿Está seguro de querer crear una nueva página?',
    'confirmCancel': 'Algunas de las opciones se han cambiado.\u000d\n¿Está seguro de querer cerrar el diálogo?',
    'options': 'Opciones',
    'target': 'Destino',
    'targetNew': 'Nueva ventana (_blank)',
    'targetTop': 'Ventana principal (_top)',
    'targetSelf': 'Misma ventana (_self)',
    'targetParent': 'Ventana padre (_parent)',
    'langDirLTR': 'Izquierda a derecha (LTR)',
    'langDirRTL': 'Derecha a izquierda (RTL)',
    'styles': 'Estilos',
    'cssClasses': 'Clase de la hoja de estilos',
    'width': 'Anchura',
    'height': 'Altura',
    'align': 'Alineación',
    'alignLeft': 'Izquierda',
    'alignRight': 'Derecha',
    'alignCenter': 'Centrado',
    'alignJustify': 'Justificado',
    'alignTop': 'Tope',
    'alignMiddle': 'Centro',
    'alignBottom': 'Pie',
    'alignNone': 'Ninguno',
    'invalidValue': 'Valor no válido',
    'invalidHeight': 'Altura debe ser un número.',
    'invalidWidth': 'Anchura debe ser un número.',
    'invalidCssLength': 'El valor especificado para el campo "%1" debe ser un número positivo, incluyendo optionalmente una unidad de medida CSS válida (px, %, in, cm, mm, em, ex, pt, o pc).',
    'invalidHtmlLength': 'El valor especificado para el campo "%1" debe ser un número positivo, incluyendo optionalmente una unidad de medida HTML válida (px o %).',
    'invalidInlineStyle': 'El valor especificado para el estilo debe consistir en uno o más pares con el formato "nombre: valor", separados por punto y coma.',
    'cssLengthTooltip': 'Introduca un número para el valor en pixels o un número con una unidad de medida CSS válida (px, %, in, cm, mm, em, ex, pt, o pc).',
    'unavailable': '%1<span class="cke_accessibility">, no disponible</span>',
    'keyboard': {
      '8': 'Retroceso',
      '13': 'Ingresar',
      '16': 'Mayús.',
      '17': 'Ctrl',
      '18': 'Alt',
      '32': 'Space',
      '35': 'Fin',
      '36': 'Inicio',
      '46': 'Suprimir',
      '224': 'Command'
    },
    'keyboardShortcut': 'Keyboard shortcut'
  },
  'about': {
    'copy': 'Copyright &copy; $1. Todos los derechos reservados.',
    'dlgTitle': 'Acerca de CKEditor',
    'help': 'Lea la  $1 para resolver sus dudas.',
    'moreInfo': 'Para información de licencia, por favor visite nuestro sitio web:',
    'title': 'Acerca de CKEditor',
    'userGuide': 'Guía de usuario de CKEditor'
  },
  'basicstyles': {
    'bold': 'Negrita',
    'italic': 'Cursiva',
    'strike': 'Tachado',
    'subscript': 'Subíndice',
    'superscript': 'Superíndice',
    'underline': 'Subrayado'
  },
  'blockquote': {
    'toolbar': 'Cita'
  },
  'notification': {
    'closed': 'Notificación cerrada.'
  },
  'button': {
    'selectedLabel': '%1 (Seleccionado)'
  },
  'toolbar': {
    'toolbarCollapse': 'Contraer barra de herramientas',
    'toolbarExpand': 'Expandir barra de herramientas',
    'toolbarGroups': {
      'document': 'Documento',
      'clipboard': 'Portapapeles/Deshacer',
      'editing': 'Edición',
      'forms': 'Formularios',
      'basicstyles': 'Estilos básicos',
      'paragraph': 'Párrafo',
      'links': 'Enlaces',
      'insert': 'Insertar',
      'styles': 'Estilos',
      'colors': 'Colores',
      'tools': 'Herramientas'
    },
    'toolbars': 'Barras de herramientas del editor'
  },
  'clipboard': {
    'copy': 'Copiar',
    'copyError': 'La configuración de seguridad de este navegador no permite la ejecución automática de operaciones de copiado.\u000d\nPor favor use el teclado (Ctrl/Cmd+C).',
    'cut': 'Cortar',
    'cutError': 'La configuración de seguridad de este navegador no permite la ejecución automática de operaciones de cortado.\u000d\nPor favor use el teclado (Ctrl/Cmd+X).',
    'paste': 'Pegar',
    'pasteNotification': 'Your browser doesn\'t allow you to paste this way. Press %1 to paste.'
  },
  'contextmenu': {
    'options': 'Opciones del menú contextual'
  },
  'elementspath': {
    'eleLabel': 'Ruta de los elementos',
    'eleTitle': '%1 elemento'
  },
  'format': {
    'label': 'Formato',
    'panelTitle': 'Formato',
    'tag_address': 'Dirección',
    'tag_div': 'Normal (DIV)',
    'tag_h1': 'Encabezado 1',
    'tag_h2': 'Encabezado 2',
    'tag_h3': 'Encabezado 3',
    'tag_h4': 'Encabezado 4',
    'tag_h5': 'Encabezado 5',
    'tag_h6': 'Encabezado 6',
    'tag_p': 'Normal',
    'tag_pre': 'Con formato'
  },
  'horizontalrule': {
    'toolbar': 'Insertar Línea Horizontal'
  },
  'image': {
    'alt': 'Texto Alternativo',
    'border': 'Borde',
    'btnUpload': 'Enviar al Servidor',
    'button2Img': '¿Desea convertir el botón de imagen en una simple imagen?',
    'hSpace': 'Esp.Horiz',
    'img2Button': '¿Desea convertir la imagen en un botón de imagen?',
    'infoTab': 'Información de Imagen',
    'linkTab': 'Vínculo',
    'lockRatio': 'Proporcional',
    'menu': 'Propiedades de Imagen',
    'resetSize': 'Tamaño Original',
    'title': 'Propiedades de Imagen',
    'titleButton': 'Propiedades de Botón de Imagen',
    'upload': 'Cargar',
    'urlMissing': 'Debe indicar la URL de la imagen.',
    'vSpace': 'Esp.Vert',
    'validateBorder': 'El borde debe ser un número.',
    'validateHSpace': 'El espaciado horizontal debe ser un número.',
    'validateVSpace': 'El espaciado vertical debe ser un número.'
  },
  'indent': {
    'indent': 'Aumentar Sangría',
    'outdent': 'Disminuir Sangría'
  },
  'fakeobjects': {
    'anchor': 'Ancla',
    'flash': 'Animación flash',
    'hiddenfield': 'Campo oculto',
    'iframe': 'IFrame',
    'unknown': 'Objeto desconocido'
  },
  'link': {
    'acccessKey': 'Tecla de Acceso',
    'advanced': 'Avanzado',
    'advisoryContentType': 'Tipo de Contenido',
    'advisoryTitle': 'Título',
    'anchor': {
      'toolbar': 'Referencia',
      'menu': 'Propiedades de Referencia',
      'title': 'Propiedades de Referencia',
      'name': 'Nombre de la Referencia',
      'errorName': 'Por favor, complete el nombre de la Referencia',
      'remove': 'Quitar Referencia'
    },
    'anchorId': 'Por ID de elemento',
    'anchorName': 'Por Nombre de Referencia',
    'charset': 'Fuente de caracteres vinculado',
    'cssClasses': 'Clases de hojas de estilo',
    'download': 'Force Download',
    'displayText': 'Display Text',
    'emailAddress': 'Dirección de E-Mail',
    'emailBody': 'Cuerpo del Mensaje',
    'emailSubject': 'Título del Mensaje',
    'id': 'Id',
    'info': 'Información de Vínculo',
    'langCode': 'Código idioma',
    'langDir': 'Orientación',
    'langDirLTR': 'Izquierda a Derecha (LTR)',
    'langDirRTL': 'Derecha a Izquierda (RTL)',
    'menu': 'Editar Vínculo',
    'name': 'Nombre',
    'noAnchors': '(No hay referencias disponibles en el documento)',
    'noEmail': 'Por favor escriba la dirección de e-mail',
    'noUrl': 'Por favor escriba el vínculo URL',
    'other': '<otro>',
    'popupDependent': 'Dependiente (Netscape)',
    'popupFeatures': 'Características de Ventana Emergente',
    'popupFullScreen': 'Pantalla Completa (IE)',
    'popupLeft': 'Posición Izquierda',
    'popupLocationBar': 'Barra de ubicación',
    'popupMenuBar': 'Barra de Menú',
    'popupResizable': 'Redimensionable',
    'popupScrollBars': 'Barras de desplazamiento',
    'popupStatusBar': 'Barra de Estado',
    'popupToolbar': 'Barra de Herramientas',
    'popupTop': 'Posición Derecha',
    'rel': 'Relación',
    'selectAnchor': 'Seleccionar una referencia',
    'styles': 'Estilo',
    'tabIndex': 'Indice de tabulación',
    'target': 'Destino',
    'targetFrame': '<marco>',
    'targetFrameName': 'Nombre del Marco Destino',
    'targetPopup': '<ventana emergente>',
    'targetPopupName': 'Nombre de Ventana Emergente',
    'title': 'Vínculo',
    'toAnchor': 'Referencia en esta página',
    'toEmail': 'E-Mail',
    'toUrl': 'URL',
    'toolbar': 'Insertar/Editar Vínculo',
    'type': 'Tipo de vínculo',
    'unlink': 'Eliminar Vínculo',
    'upload': 'Cargar'
  },
  'list': {
    'bulletedlist': 'Viñetas',
    'numberedlist': 'Numeración'
  },
  'magicline': {
    'title': 'Insertar párrafo aquí'
  },
  'maximize': {
    'maximize': 'Maximizar',
    'minimize': 'Minimizar'
  },
  'pastetext': {
    'button': 'Pegar como Texto Plano',
    'pasteNotification': 'Your browser does not allow you to paste plain text this way. Press %1 to paste.'
  },
  'pastefromword': {
    'confirmCleanup': 'El texto que desea parece provenir de Word.\u000d\n¿Desea depurarlo antes de pegarlo?',
    'error': 'No ha sido posible limpiar los datos debido a un error interno',
    'title': 'Pegar desde Word',
    'toolbar': 'Pegar desde Word'
  },
  'removeformat': {
    'toolbar': 'Eliminar Formato'
  },
  'sourcearea': {
    'toolbar': 'Fuente HTML'
  },
  'specialchar': {
    'options': 'Opciones de caracteres especiales',
    'title': 'Seleccione un caracter especial',
    'toolbar': 'Insertar Caracter Especial'
  },
  'scayt': {
    'btn_about': 'Acerca de Corrector',
    'btn_dictionaries': 'Diccionarios',
    'btn_disable': 'Desactivar Corrector',
    'btn_enable': 'Activar Corrector',
    'btn_langs': 'Idiomas',
    'btn_options': 'Opciones',
    'text_title': 'Comprobar Ortografía Mientras Escribe'
  },
  'stylescombo': {
    'label': 'Estilo',
    'panelTitle': 'Estilos para formatear',
    'panelTitle1': 'Estilos de párrafo',
    'panelTitle2': 'Estilos de carácter',
    'panelTitle3': 'Estilos de objeto'
  },
  'table': {
    'border': 'Tamaño de Borde',
    'caption': 'Título',
    'cell': {
      'menu': 'Celda',
      'insertBefore': 'Insertar celda a la izquierda',
      'insertAfter': 'Insertar celda a la derecha',
      'deleteCell': 'Eliminar Celdas',
      'merge': 'Combinar Celdas',
      'mergeRight': 'Combinar a la derecha',
      'mergeDown': 'Combinar hacia abajo',
      'splitHorizontal': 'Dividir la celda horizontalmente',
      'splitVertical': 'Dividir la celda verticalmente',
      'title': 'Propiedades de celda',
      'cellType': 'Tipo de Celda',
      'rowSpan': 'Expandir filas',
      'colSpan': 'Expandir columnas',
      'wordWrap': 'Ajustar al contenido',
      'hAlign': 'Alineación Horizontal',
      'vAlign': 'Alineación Vertical',
      'alignBaseline': 'Linea de base',
      'bgColor': 'Color de fondo',
      'borderColor': 'Color de borde',
      'data': 'Datos',
      'header': 'Encabezado',
      'yes': 'Sí',
      'no': 'No',
      'invalidWidth': 'La anchura de celda debe ser un número.',
      'invalidHeight': 'La altura de celda debe ser un número.',
      'invalidRowSpan': 'La expansión de filas debe ser un número entero.',
      'invalidColSpan': 'La expansión de columnas debe ser un número entero.',
      'chooseColor': 'Elegir'
    },
    'cellPad': 'Esp. interior',
    'cellSpace': 'Esp. e/celdas',
    'column': {
      'menu': 'Columna',
      'insertBefore': 'Insertar columna a la izquierda',
      'insertAfter': 'Insertar columna a la derecha',
      'deleteColumn': 'Eliminar Columnas'
    },
    'columns': 'Columnas',
    'deleteTable': 'Eliminar Tabla',
    'headers': 'Encabezados',
    'headersBoth': 'Ambas',
    'headersColumn': 'Primera columna',
    'headersNone': 'Ninguno',
    'headersRow': 'Primera fila',
    'invalidBorder': 'El tamaño del borde debe ser un número.',
    'invalidCellPadding': 'El espaciado interior debe ser un número.',
    'invalidCellSpacing': 'El espaciado entre celdas debe ser un número.',
    'invalidCols': 'El número de columnas debe ser un número mayor que 0.',
    'invalidHeight': 'La altura de tabla debe ser un número.',
    'invalidRows': 'El número de filas debe ser un número mayor que 0.',
    'invalidWidth': 'La anchura de tabla debe ser un número.',
    'menu': 'Propiedades de Tabla',
    'row': {
      'menu': 'Fila',
      'insertBefore': 'Insertar fila en la parte superior',
      'insertAfter': 'Insertar fila en la parte inferior',
      'deleteRow': 'Eliminar Filas'
    },
    'rows': 'Filas',
    'summary': 'Síntesis',
    'title': 'Propiedades de Tabla',
    'toolbar': 'Tabla',
    'widthPc': 'porcentaje',
    'widthPx': 'pixeles',
    'widthUnit': 'unidad de la anchura'
  },
  'undo': {
    'redo': 'Rehacer',
    'undo': 'Deshacer'
  },
  'wsc': {
    'btnIgnore': 'Ignorar',
    'btnIgnoreAll': 'Ignorar Todo',
    'btnReplace': 'Reemplazar',
    'btnReplaceAll': 'Reemplazar Todo',
    'btnUndo': 'Deshacer',
    'changeTo': 'Cambiar a',
    'errorLoading': 'Error cargando la aplicación del servidor: %s.',
    'ieSpellDownload': 'Módulo de Control de Ortografía no instalado.\u000d\n¿Desea descargarlo ahora?',
    'manyChanges': 'Control finalizado: se ha cambiado %1 palabras',
    'noChanges': 'Control finalizado: no se ha cambiado ninguna palabra',
    'noMispell': 'Control finalizado: no se encontraron errores',
    'noSuggestions': '- No hay sugerencias -',
    'notAvailable': 'Lo sentimos pero el servicio no está disponible.',
    'notInDic': 'No se encuentra en el Diccionario',
    'oneChange': 'Control finalizado: se ha cambiado una palabra',
    'progress': 'Control de Ortografía en progreso...',
    'title': 'Comprobar ortografía',
    'toolbar': 'Ortografía'
  }
};


/***/ }),
/* 254 */
/***/ (function(module, exports) {

CKEDITOR.lang['it'] = {
  'editor': 'Rich Text Editor',
  'editorPanel': 'Pannello Rich Text Editor',
  'common': {
    'editorHelp': 'Premi ALT 0 per aiuto',
    'browseServer': 'Cerca sul server',
    'url': 'URL',
    'protocol': 'Protocollo',
    'upload': 'Carica',
    'uploadSubmit': 'Invia al server',
    'image': 'Immagine',
    'flash': 'Oggetto Flash',
    'form': 'Modulo',
    'checkbox': 'Checkbox',
    'radio': 'Radio Button',
    'textField': 'Campo di testo',
    'textarea': 'Area di testo',
    'hiddenField': 'Campo nascosto',
    'button': 'Bottone',
    'select': 'Menu di selezione',
    'imageButton': 'Bottone immagine',
    'notSet': '<non impostato>',
    'id': 'Id',
    'name': 'Nome',
    'langDir': 'Direzione scrittura',
    'langDirLtr': 'Da Sinistra a Destra (LTR)',
    'langDirRtl': 'Da Destra a Sinistra (RTL)',
    'langCode': 'Codice Lingua',
    'longDescr': 'URL descrizione estesa',
    'cssClass': 'Nome classe CSS',
    'advisoryTitle': 'Titolo',
    'cssStyle': 'Stile',
    'ok': 'OK',
    'cancel': 'Annulla',
    'close': 'Chiudi',
    'preview': 'Anteprima',
    'resize': 'Trascina per ridimensionare',
    'generalTab': 'Generale',
    'advancedTab': 'Avanzate',
    'validateNumberFailed': 'Il valore inserito non è un numero.',
    'confirmNewPage': 'Ogni modifica non salvata sarà persa. Sei sicuro di voler caricare una nuova pagina?',
    'confirmCancel': 'Alcune delle opzioni sono state cambiate. Sei sicuro di voler chiudere la finestra di dialogo?',
    'options': 'Opzioni',
    'target': 'Destinazione',
    'targetNew': 'Nuova finestra (_blank)',
    'targetTop': 'Finestra in primo piano (_top)',
    'targetSelf': 'Stessa finestra (_self)',
    'targetParent': 'Finestra Padre (_parent)',
    'langDirLTR': 'Da sinistra a destra (LTR)',
    'langDirRTL': 'Da destra a sinistra (RTL)',
    'styles': 'Stile',
    'cssClasses': 'Classi di stile',
    'width': 'Larghezza',
    'height': 'Altezza',
    'align': 'Allineamento',
    'alignLeft': 'Sinistra',
    'alignRight': 'Destra',
    'alignCenter': 'Centrato',
    'alignJustify': 'Giustifica',
    'alignTop': 'In Alto',
    'alignMiddle': 'Centrato',
    'alignBottom': 'In Basso',
    'alignNone': 'Nessuno',
    'invalidValue': 'Valore non valido.',
    'invalidHeight': 'L\'altezza dev\'essere un numero',
    'invalidWidth': 'La Larghezza dev\'essere un numero',
    'invalidCssLength': 'Il valore indicato per il campo "%1" deve essere un numero positivo con o senza indicazione di una valida unità di misura per le classi CSS (px, %, in, cm, mm, em, ex, pt, o pc).',
    'invalidHtmlLength': 'Il valore indicato per il campo "%1" deve essere un numero positivo con o senza indicazione di una valida unità di misura per le pagine HTML (px o %).',
    'invalidInlineStyle': 'Il valore specificato per lo stile inline deve consistere in una o più tuple con il formato di "name : value", separati da semicolonne.',
    'cssLengthTooltip': 'Inserisci un numero per il valore in pixel oppure un numero con una valida unità CSS (px, %, in, cm, mm, ex, pt, o pc).',
    'unavailable': '%1<span class="cke_accessibility">, non disponibile</span>',
    'keyboard': {
      '8': 'Backspace',
      '13': 'Invio',
      '16': 'Maiusc',
      '17': 'Ctrl',
      '18': 'Alt',
      '32': 'Spazio',
      '35': 'Fine',
      '36': 'Inizio',
      '46': 'Canc',
      '224': 'Comando'
    },
    'keyboardShortcut': 'Scorciatoia da tastiera'
  },
  'about': {
    'copy': 'Copyright &copy; $1. Tutti i diritti riservati.',
    'dlgTitle': 'Riguardo CKEditor',
    'help': 'Vedi $1 per l\'aiuto.',
    'moreInfo': 'Per le informazioni sulla licenza si prega di visitare il nostro sito:',
    'title': 'Riguardo CKEditor',
    'userGuide': 'Guida Utente CKEditor'
  },
  'basicstyles': {
    'bold': 'Grassetto',
    'italic': 'Corsivo',
    'strike': 'Barrato',
    'subscript': 'Pedice',
    'superscript': 'Apice',
    'underline': 'Sottolineato'
  },
  'blockquote': {
    'toolbar': 'Citazione'
  },
  'notification': {
    'closed': 'Notifica chiusa.'
  },
  'button': {
    'selectedLabel': '%1 (selezionato)'
  },
  'toolbar': {
    'toolbarCollapse': 'Minimizza Toolbar',
    'toolbarExpand': 'Espandi Toolbar',
    'toolbarGroups': {
      'document': 'Documento',
      'clipboard': 'Copia negli appunti/Annulla',
      'editing': 'Modifica',
      'forms': 'Form',
      'basicstyles': 'Stili di base',
      'paragraph': 'Paragrafo',
      'links': 'Link',
      'insert': 'Inserisci',
      'styles': 'Stili',
      'colors': 'Colori',
      'tools': 'Strumenti'
    },
    'toolbars': 'Editor toolbar'
  },
  'clipboard': {
    'copy': 'Copia',
    'copyError': 'Le impostazioni di sicurezza del browser non permettono di copiare automaticamente il testo. Usa la tastiera (Ctrl/Cmd+C).',
    'cut': 'Taglia',
    'cutError': 'Le impostazioni di sicurezza del browser non permettono di tagliare automaticamente il testo. Usa la tastiera (Ctrl/Cmd+X).',
    'paste': 'Incolla',
    'pasteNotification': 'Il browser non permette di incollare in questo modo. Premere %1 per incollare.'
  },
  'contextmenu': {
    'options': 'Opzioni del menù contestuale'
  },
  'elementspath': {
    'eleLabel': 'Percorso degli elementi',
    'eleTitle': '%1 elemento'
  },
  'format': {
    'label': 'Formato',
    'panelTitle': 'Formato',
    'tag_address': 'Indirizzo',
    'tag_div': 'Paragrafo (DIV)',
    'tag_h1': 'Titolo 1',
    'tag_h2': 'Titolo 2',
    'tag_h3': 'Titolo 3',
    'tag_h4': 'Titolo 4',
    'tag_h5': 'Titolo 5',
    'tag_h6': 'Titolo 6',
    'tag_p': 'Normale',
    'tag_pre': 'Formattato'
  },
  'horizontalrule': {
    'toolbar': 'Inserisci riga orizzontale'
  },
  'image': {
    'alt': 'Testo alternativo',
    'border': 'Bordo',
    'btnUpload': 'Invia al server',
    'button2Img': 'Vuoi trasformare il bottone immagine selezionato in un\'immagine semplice?',
    'hSpace': 'HSpace',
    'img2Button': 'Vuoi trasferomare l\'immagine selezionata in un bottone immagine?',
    'infoTab': 'Informazioni immagine',
    'linkTab': 'Collegamento',
    'lockRatio': 'Blocca rapporto',
    'menu': 'Proprietà immagine',
    'resetSize': 'Reimposta dimensione',
    'title': 'Proprietà immagine',
    'titleButton': 'Proprietà bottone immagine',
    'upload': 'Carica',
    'urlMissing': 'Manca l\'URL dell\'immagine.',
    'vSpace': 'VSpace',
    'validateBorder': 'Il campo Bordo deve essere un numero intero.',
    'validateHSpace': 'Il campo HSpace deve essere un numero intero.',
    'validateVSpace': 'Il campo VSpace deve essere un numero intero.'
  },
  'indent': {
    'indent': 'Aumenta rientro',
    'outdent': 'Riduci rientro'
  },
  'fakeobjects': {
    'anchor': 'Ancora',
    'flash': 'Animazione Flash',
    'hiddenfield': 'Campo Nascosto',
    'iframe': 'IFrame',
    'unknown': 'Oggetto sconosciuto'
  },
  'link': {
    'acccessKey': 'Scorciatoia da tastiera',
    'advanced': 'Avanzate',
    'advisoryContentType': 'Tipo della risorsa collegata',
    'advisoryTitle': 'Titolo',
    'anchor': {
      'toolbar': 'Inserisci/Modifica Ancora',
      'menu': 'Proprietà ancora',
      'title': 'Proprietà ancora',
      'name': 'Nome ancora',
      'errorName': 'Inserici il nome dell\'ancora',
      'remove': 'Rimuovi l\'ancora'
    },
    'anchorId': 'Per id elemento',
    'anchorName': 'Per Nome',
    'charset': 'Set di caretteri della risorsa collegata',
    'cssClasses': 'Nome classe CSS',
    'download': 'Forza scaricamento',
    'displayText': 'Mostra testo',
    'emailAddress': 'Indirizzo E-Mail',
    'emailBody': 'Corpo del messaggio',
    'emailSubject': 'Oggetto del messaggio',
    'id': 'Id',
    'info': 'Informazioni collegamento',
    'langCode': 'Direzione scrittura',
    'langDir': 'Direzione scrittura',
    'langDirLTR': 'Da Sinistra a Destra (LTR)',
    'langDirRTL': 'Da Destra a Sinistra (RTL)',
    'menu': 'Modifica collegamento',
    'name': 'Nome',
    'noAnchors': '(Nessuna ancora disponibile nel documento)',
    'noEmail': 'Devi inserire un\'indirizzo e-mail',
    'noUrl': 'Devi inserire l\'URL del collegamento',
    'other': '<altro>',
    'popupDependent': 'Dipendente (Netscape)',
    'popupFeatures': 'Caratteristiche finestra popup',
    'popupFullScreen': 'A tutto schermo (IE)',
    'popupLeft': 'Posizione da sinistra',
    'popupLocationBar': 'Barra degli indirizzi',
    'popupMenuBar': 'Barra del menu',
    'popupResizable': 'Ridimensionabile',
    'popupScrollBars': 'Barre di scorrimento',
    'popupStatusBar': 'Barra di stato',
    'popupToolbar': 'Barra degli strumenti',
    'popupTop': 'Posizione dall\'alto',
    'rel': 'Relazioni',
    'selectAnchor': 'Scegli Ancora',
    'styles': 'Stile',
    'tabIndex': 'Ordine di tabulazione',
    'target': 'Destinazione',
    'targetFrame': '<riquadro>',
    'targetFrameName': 'Nome del riquadro di destinazione',
    'targetPopup': '<finestra popup>',
    'targetPopupName': 'Nome finestra popup',
    'title': 'Collegamento',
    'toAnchor': 'Ancora nel testo',
    'toEmail': 'E-Mail',
    'toUrl': 'URL',
    'toolbar': 'Collegamento',
    'type': 'Tipo di Collegamento',
    'unlink': 'Elimina collegamento',
    'upload': 'Carica'
  },
  'list': {
    'bulletedlist': 'Inserisci/Rimuovi Elenco Puntato',
    'numberedlist': 'Inserisci/Rimuovi Elenco Numerato'
  },
  'magicline': {
    'title': 'Inserisci paragrafo qui'
  },
  'maximize': {
    'maximize': 'Massimizza',
    'minimize': 'Minimizza'
  },
  'pastetext': {
    'button': 'Incolla come testo semplice',
    'pasteNotification': 'Il browser non permette di incollare il testo semplice in questo modo. Premere %1 per incollare.'
  },
  'pastefromword': {
    'confirmCleanup': 'Il testo da incollare sembra provenire da Word. Desideri pulirlo prima di incollare?',
    'error': 'Non è stato possibile eliminare il testo incollato a causa di un errore interno.',
    'title': 'Incolla da Word',
    'toolbar': 'Incolla da Word'
  },
  'removeformat': {
    'toolbar': 'Elimina formattazione'
  },
  'sourcearea': {
    'toolbar': 'Sorgente'
  },
  'specialchar': {
    'options': 'Opzioni carattere speciale',
    'title': 'Seleziona carattere speciale',
    'toolbar': 'Inserisci carattere speciale'
  },
  'scayt': {
    'btn_about': 'About COMS',
    'btn_dictionaries': 'Dizionari',
    'btn_disable': 'Disabilita COMS',
    'btn_enable': 'Abilita COMS',
    'btn_langs': 'Lingue',
    'btn_options': 'Opzioni',
    'text_title': 'Controllo Ortografico Mentre Scrivi'
  },
  'stylescombo': {
    'label': 'Stili',
    'panelTitle': 'Stili di formattazione',
    'panelTitle1': 'Stili per blocchi',
    'panelTitle2': 'Stili in linea',
    'panelTitle3': 'Stili per oggetti'
  },
  'table': {
    'border': 'Dimensione bordo',
    'caption': 'Intestazione',
    'cell': {
      'menu': 'Cella',
      'insertBefore': 'Inserisci Cella Prima',
      'insertAfter': 'Inserisci Cella Dopo',
      'deleteCell': 'Elimina celle',
      'merge': 'Unisce celle',
      'mergeRight': 'Unisci a Destra',
      'mergeDown': 'Unisci in Basso',
      'splitHorizontal': 'Dividi Cella Orizzontalmente',
      'splitVertical': 'Dividi Cella Verticalmente',
      'title': 'Proprietà della cella',
      'cellType': 'Tipo di cella',
      'rowSpan': 'Su più righe',
      'colSpan': 'Su più colonne',
      'wordWrap': 'Ritorno a capo',
      'hAlign': 'Allineamento orizzontale',
      'vAlign': 'Allineamento verticale',
      'alignBaseline': 'Linea Base',
      'bgColor': 'Colore di Sfondo',
      'borderColor': 'Colore del Bordo',
      'data': 'Dati',
      'header': 'Intestazione',
      'yes': 'Si',
      'no': 'No',
      'invalidWidth': 'La larghezza della cella dev\'essere un numero.',
      'invalidHeight': 'L\'altezza della cella dev\'essere un numero.',
      'invalidRowSpan': 'Il numero di righe dev\'essere un numero intero.',
      'invalidColSpan': 'Il numero di colonne dev\'essere un numero intero.',
      'chooseColor': 'Scegli'
    },
    'cellPad': 'Padding celle',
    'cellSpace': 'Spaziatura celle',
    'column': {
      'menu': 'Colonna',
      'insertBefore': 'Inserisci Colonna Prima',
      'insertAfter': 'Inserisci Colonna Dopo',
      'deleteColumn': 'Elimina colonne'
    },
    'columns': 'Colonne',
    'deleteTable': 'Cancella Tabella',
    'headers': 'Intestazione',
    'headersBoth': 'Entrambe',
    'headersColumn': 'Prima Colonna',
    'headersNone': 'Nessuna',
    'headersRow': 'Prima Riga',
    'invalidBorder': 'La dimensione del bordo dev\'essere un numero.',
    'invalidCellPadding': 'Il paging delle celle dev\'essere un numero',
    'invalidCellSpacing': 'La spaziatura tra le celle dev\'essere un numero.',
    'invalidCols': 'Il numero di colonne dev\'essere un numero maggiore di 0.',
    'invalidHeight': 'L\'altezza della tabella dev\'essere un numero.',
    'invalidRows': 'Il numero di righe dev\'essere un numero maggiore di 0.',
    'invalidWidth': 'La larghezza della tabella dev\'essere un numero.',
    'menu': 'Proprietà tabella',
    'row': {
      'menu': 'Riga',
      'insertBefore': 'Inserisci Riga Prima',
      'insertAfter': 'Inserisci Riga Dopo',
      'deleteRow': 'Elimina righe'
    },
    'rows': 'Righe',
    'summary': 'Indice',
    'title': 'Proprietà tabella',
    'toolbar': 'Tabella',
    'widthPc': 'percento',
    'widthPx': 'pixel',
    'widthUnit': 'unità larghezza'
  },
  'undo': {
    'redo': 'Ripristina',
    'undo': 'Annulla'
  },
  'wsc': {
    'btnIgnore': 'Ignora',
    'btnIgnoreAll': 'Ignora tutto',
    'btnReplace': 'Cambia',
    'btnReplaceAll': 'Cambia tutto',
    'btnUndo': 'Annulla',
    'changeTo': 'Cambia in',
    'errorLoading': 'Errore nel caricamento dell\'host col servizio applicativo: %s.',
    'ieSpellDownload': 'Contollo ortografico non installato. Lo vuoi scaricare ora?',
    'manyChanges': 'Controllo ortografico completato: %1 parole cambiate',
    'noChanges': 'Controllo ortografico completato: nessuna parola cambiata',
    'noMispell': 'Controllo ortografico completato: nessun errore trovato',
    'noSuggestions': '- Nessun suggerimento -',
    'notAvailable': 'Il servizio non è momentaneamente disponibile.',
    'notInDic': 'Non nel dizionario',
    'oneChange': 'Controllo ortografico completato: 1 parola cambiata',
    'progress': 'Controllo ortografico in corso',
    'title': 'Controllo ortografico',
    'toolbar': 'Correttore ortografico'
  }
};


/***/ }),
/* 255 */
/***/ (function(module, exports) {


/*
Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
For licensing, see LICENSE.md or http://ckeditor.com/license
 */
CKEDITOR.lang['ja'] = {
  "about": {
    "copy": "Copyright © $1。全著作権所有。",
    "dlgTitle": "CKEditorについて",
    "help": "ヘルプが必要な場合は $1 を確認してください。",
    "moreInfo": "ライセンス情報については、当社のWebサイトをご覧ください。",
    "title": "CKEditorについて",
    "userGuide": "CKEditorユーザーガイド"
  },
  "basicstyles": {
    "bold": "大胆な",
    "italic": "イタリック",
    "strike": "取り消し線",
    "subscript": "添字",
    "superscript": "上付き文字",
    "underline": "下線を引く"
  },
  "blockquote": {
    "toolbar": "ブロック見積もり"
  },
  "button": {
    "selectedLabel": "%1（選択済み）"
  },
  "clipboard": {
    "copy": "コピー",
    "copyError": "ブラウザのセキュリティ設定では、エディタがコピー操作を自動的に実行することは許可されていません。そのためにキーボードを使用してください（Ctrl / Cmd + C）。",
    "cut": "切る",
    "cutError": "ブラウザのセキュリティ設定では、エディタが自動的にカット操作を実行することは許可されていません。そのためにキーボードを使用してください（Ctrl / Cmd + X）。",
    "paste": "ペースト",
    "pasteArea": "貼り付け領域",
    "pasteMsg": "キーボード（<strong>Ctrl / Cmd + V</strong>）を使用して次のボックス内に貼り付け、[OK]をクリックしてください",
    "securityMsg": "ブラウザのセキュリティ設定により、エディタはクリップボードのデータに直接アクセスできません。このウィンドウにもう一度貼り付ける必要があります。",
    "title": "ペースト"
  },
  "common": {
    "advancedTab": "高度",
    "advisoryTitle": "アドバイザリータイトル",
    "align": "配置",
    "alignBottom": "下",
    "alignCenter": "センター",
    "alignJustify": "正当化する",
    "alignLeft": "左",
    "alignMiddle": "中間",
    "alignNone": "なし",
    "alignRight": "正しい",
    "alignTop": "上",
    "browseServer": "サーバーの参照",
    "button": "ボタン",
    "cancel": "キャンセル",
    "checkbox": "チェックボックス",
    "close": "閉じる",
    "confirmCancel": "いくつかのオプションを変更しました。ダイアログウィンドウを閉じてもよろしいですか？",
    "confirmNewPage": "このコンテンツへの保存されていない変更はすべて失われます。新しいページをロードしてもよろしいですか？",
    "cssClass": "スタイルシートクラス",
    "cssClasses": "スタイルシートクラス",
    "cssLengthTooltip": "値の数値をピクセル単位で入力するか、有効なCSS単位（px、%、in、cm、mm、em、ex、pt、またはpc）を使用して数値を入力します。",
    "cssStyle": "スタイル",
    "editorHelp": "ヘルプが必要な場合はAlt0を押してください",
    "flash": "閃光",
    "form": "形",
    "generalTab": "一般",
    "height": "高さ",
    "hiddenField": "隠しフィールド",
    "id": "Id",
    "image": "画像",
    "imageButton": "画像ボタン",
    "invalidCssLength": "「%1」フィールドに指定する値は、有効なCSS測定単位（px、%、in、cm、mm、em、ex、pt、またはpc）がある場合とない場合の正の数である必要があります。",
    "invalidHeight": "高さは数値でなければなりません。",
    "invalidHtmlLength": "「%1」フィールドに指定する値は、有効なHTML測定単位（pxまたは%）の有無にかかわらず正の数である必要があります。",
    "invalidInlineStyle": "インラインスタイルに指定する値は、セミコロンで区切られた「name：value」の形式の1つ以上のタプルで構成されている必要があります。",
    "invalidValue": "値が無効です。",
    "invalidWidth": "幅は数値でなければなりません。",
    "langCode": "言語コード",
    "langDir": "言語の方向性",
    "langDirLTR": "左から右（LTR）",
    "langDirLtr": "左から右（LTR）",
    "langDirRTL": "右から左（RTL）",
    "langDirRtl": "右から左（RTL）",
    "longDescr": "長い説明のURL",
    "name": "名前",
    "notSet": "<示されていない>",
    "ok": "OK",
    "options": "オプション",
    "preview": "プレビュー",
    "protocol": "プロトコル",
    "radio": "ラジオボタン",
    "resize": "サイズ変更",
    "select": "選択フィールド",
    "styles": "スタイル",
    "target": "目標",
    "targetNew": "新しいウィンドウ（_blank）",
    "targetParent": "親ウィンドウ（_parent）",
    "targetSelf": "同じウィンドウ（_self）",
    "targetTop": "最上部のウィンドウ（_top）",
    "textField": "テキストフィールド",
    "textarea": "Textarea",
    "unavailable": "%1 <span class=\"cke_accessibility\">、利用できません</span>",
    "upload": "アップロード",
    "uploadSubmit": "サーバーに送信します",
    "url": "URL",
    "validateNumberFailed": "この値は数値ではありません。",
    "width": "幅"
  },
  "contextmenu": {
    "options": "コンテキストメニューオプション"
  },
  "editor": "リッチテキストエディタ",
  "editorPanel": "リッチテキストエディタパネル",
  "elementspath": {
    "eleLabel": "要素パス",
    "eleTitle": "%1要素"
  },
  "fakeobjects": {
    "anchor": "アンカー",
    "flash": "フラッシュアニメーション",
    "hiddenfield": "隠しフィールド",
    "iframe": "IFrame",
    "unknown": "不明なオブジェクト"
  },
  "format": {
    "label": "フォーマット",
    "panelTitle": "段落形式",
    "tag_address": "住所",
    "tag_div": "通常（DIV）",
    "tag_h1": "見出し1",
    "tag_h2": "見出し2",
    "tag_h3": "見出し3",
    "tag_h4": "見出し4",
    "tag_h5": "見出し5",
    "tag_h6": "見出し6",
    "tag_p": "正常",
    "tag_pre": "フォーマット済み"
  },
  "horizontalrule": {
    "toolbar": "水平線を挿入"
  },
  "image": {
    "alertUrl": "画像のURLを入力してください",
    "alt": "代替テキスト",
    "border": "境界",
    "btnUpload": "サーバーに送信します",
    "button2Img": "選択した画像ボタンを単純な画像に変換しますか？",
    "hSpace": "HSpace",
    "img2Button": "選択した画像を画像ボタンで変換しますか？",
    "infoTab": "画像情報",
    "linkTab": "リンク",
    "lockRatio": "ロック比",
    "menu": "画像のプロパティ",
    "resetSize": "サイズをリセット",
    "title": "画像のプロパティ",
    "titleButton": "画像ボタンのプロパティ",
    "upload": "アップロード",
    "urlMissing": "画像のソースURLがありません。",
    "vSpace": "VSpace",
    "validateBorder": "境界線は整数でなければなりません。",
    "validateHSpace": "HSpaceは整数でなければなりません。",
    "validateVSpace": "VSpaceは整数でなければなりません。"
  },
  "indent": {
    "indent": "インデントを増やします",
    "outdent": "インデントを減らす"
  },
  "link": {
    "acccessKey": "アクセスキー",
    "advanced": "高度",
    "advisoryContentType": "アドバイザリコンテンツタイプ",
    "advisoryTitle": "アドバイザリータイトル",
    "anchor": {
      "errorName": "アンカー名を入力してください",
      "menu": "アンカーを編集する",
      "name": "アンカー名",
      "remove": "アンカーを削除します",
      "title": "アンカープロパティ",
      "toolbar": "アンカー"
    },
    "anchorId": "要素ID別",
    "anchorName": "アンカー名別",
    "charset": "リンクされたリソース文字セット",
    "cssClasses": "スタイルシートクラス",
    "emailAddress": "電子メールアドレス",
    "emailBody": "メッセージ本文",
    "emailSubject": "メッセージの件名",
    "id": "Id",
    "info": "リンク情報",
    "langCode": "言語コード",
    "langDir": "言語の方向性",
    "langDirLTR": "左から右（LTR）",
    "langDirRTL": "右から左（RTL）",
    "menu": "リンクを編集",
    "name": "名前",
    "noAnchors": "（ドキュメントで使用可能なアンカーはありません）",
    "noEmail": "メールアドレスを入力してください",
    "noUrl": "リンクURLを入力してください",
    "other": "<その他>",
    "popupDependent": "依存（Netscape）",
    "popupFeatures": "ポップアップウィンドウの機能",
    "popupFullScreen": "フルスクリーン（IE）",
    "popupLeft": "左位置",
    "popupLocationBar": "ロケーションバー",
    "popupMenuBar": "メニューバー",
    "popupResizable": "サイズ変更可能",
    "popupScrollBars": "スクロールバー",
    "popupStatusBar": "ステータスバー",
    "popupToolbar": "ツールバー",
    "popupTop": "トップポジション",
    "rel": "関係",
    "selectAnchor": "アンカーを選択します",
    "styles": "スタイル",
    "tabIndex": "タブインデックス",
    "target": "目標",
    "targetFrame": "<frame>",
    "targetFrameName": "ターゲットフレーム名",
    "targetPopup": "<ポップアップウィンドウ>",
    "targetPopupName": "ポップアップウィンドウ名",
    "title": "リンク",
    "toAnchor": "テキスト内のアンカーへのリンク",
    "toEmail": "Eメール",
    "toUrl": "URL",
    "toolbar": "リンク",
    "type": "リンクタイプ",
    "unlink": "リンク解除",
    "upload": "アップロード"
  },
  "list": {
    "bulletedlist": "箇条書きの挿入/削除",
    "numberedlist": "番号付きリストの挿入/削除"
  },
  "magicline": {
    "title": "ここに段落を挿入"
  },
  "maximize": {
    "maximize": "最大化",
    "minimize": "最小化"
  },
  "pastefromword": {
    "confirmCleanup": "貼り付けたいテキストはWordからコピーされたようです。貼り付ける前に掃除しますか？",
    "error": "内部エラーのため、貼り付けたデータをクリーンアップできませんでした",
    "title": "Wordから貼り付け",
    "toolbar": "Wordから貼り付け"
  },
  "pastetext": {
    "button": "プレーンテキストとして貼り付けます",
    "title": "プレーンテキストとして貼り付け"
  },
  "removeformat": {
    "toolbar": "フォーマットを削除"
  },
  "scayt": {
    "btn_about": "SCAYTについて",
    "btn_dictionaries": "辞書",
    "btn_disable": "SCAYTを無効にする",
    "btn_enable": "SCAYTを有効にする",
    "btn_langs": "言語",
    "btn_options": "オプション",
    "text_title": "入力時のスペルチェック"
  },
  "sourcearea": {
    "toolbar": "ソース"
  },
  "specialchar": {
    "options": "特殊文字オプション",
    "title": "特殊文字を選択",
    "toolbar": "特殊文字を挿入"
  },
  "stylescombo": {
    "label": "スタイル",
    "panelTitle": "書式設定スタイル",
    "panelTitle1": "ブロックスタイル",
    "panelTitle2": "インラインスタイル",
    "panelTitle3": "オブジェクトスタイル"
  },
  "table": {
    "border": "ボーダーサイズ",
    "caption": "キャプション",
    "cell": {
      "alignBaseline": "ベースライン",
      "bgColor": "背景色",
      "borderColor": "ボーダの色",
      "cellType": "セルタイプ",
      "chooseColor": "選択",
      "colSpan": "列スパン",
      "data": "データ",
      "deleteCell": "セルを削除する",
      "hAlign": "水平方向の配置",
      "header": "ヘッダ",
      "insertAfter": "後にセルを挿入",
      "insertBefore": "前にセルを挿入",
      "invalidColSpan": "列のスパンは整数でなければなりません。",
      "invalidHeight": "セルの高さは数値でなければなりません。",
      "invalidRowSpan": "行スパンは整数でなければなりません。",
      "invalidWidth": "セル幅は数値でなければなりません。",
      "menu": "細胞",
      "merge": "セルを結合します",
      "mergeDown": "マージダウン",
      "mergeRight": "マージ権",
      "no": "番号",
      "rowSpan": "行スパン",
      "splitHorizontal": "セルを水平方向に分割",
      "splitVertical": "セルを垂直に分割",
      "title": "セルのプロパティ",
      "vAlign": "垂直方向の配置",
      "wordWrap": "ワードラップ",
      "yes": "はい"
    },
    "cellPad": "セルパディング",
    "cellSpace": "セル間隔",
    "column": {
      "deleteColumn": "列を削除する",
      "insertAfter": "後に列を挿入",
      "insertBefore": "前に列を挿入",
      "menu": "カラム"
    },
    "columns": "列",
    "deleteTable": "テーブルを削除する",
    "headers": "ヘッダー",
    "headersBoth": "両方とも",
    "headersColumn": "最初の列",
    "headersNone": "なし",
    "headersRow": "最初の行",
    "invalidBorder": "境界線のサイズは数値である必要があります。",
    "invalidCellPadding": "セルのパディングは正の数である必要があります。",
    "invalidCellSpacing": "セル間隔は正の数でなければなりません。",
    "invalidCols": "列の数は0より大きい数でなければなりません。",
    "invalidHeight": "テーブルの高さは数値でなければなりません。",
    "invalidRows": "行数は0より大きい数でなければなりません。",
    "invalidWidth": "テーブル幅は数値でなければなりません。",
    "menu": "テーブルのプロパティ",
    "row": {
      "deleteRow": "行を削除する",
      "insertAfter": "後に行を挿入",
      "insertBefore": "前に行を挿入",
      "menu": "行"
    },
    "rows": "行",
    "summary": "概要",
    "title": "テーブルのプロパティ",
    "toolbar": "テーブル",
    "widthPc": "パーセント",
    "widthPx": "ピクセル",
    "widthUnit": "幅の単位"
  },
  "toolbar": {
    "toolbarCollapse": "ツールバーを折りたたむ",
    "toolbarExpand": "ツールバーを展開",
    "toolbarGroups": {
      "basicstyles": "基本的なスタイル",
      "clipboard": "クリップボード/元に戻す",
      "colors": "色",
      "document": "資料",
      "editing": "編集",
      "forms": "フォーム",
      "insert": "インサート",
      "links": "リンク",
      "paragraph": "段落",
      "styles": "スタイル",
      "tools": "ツール"
    },
    "toolbars": "エディターツールバー"
  },
  "undo": {
    "redo": "やり直し",
    "undo": "元に戻す"
  },
  "wsc": {
    "btnIgnore": "無視する",
    "btnIgnoreAll": "全無視",
    "btnReplace": "交換",
    "btnReplaceAll": "すべて置換",
    "btnUndo": "元に戻す",
    "changeTo": "への変更",
    "errorLoading": "アプリケーションサービスホストの読み込み中にエラーが発生しました：%s。",
    "ieSpellDownload": "スペルチェッカーがインストールされていません。今すぐダウンロードしますか？",
    "manyChanges": "スペルチェックが完了しました：%1語が変更されました",
    "noChanges": "スペルチェックが完了しました：単語は変更されていません",
    "noMispell": "スペルチェックが完了しました：スペルミスは見つかりませんでした",
    "noSuggestions": "-提案なし-",
    "notAvailable": "申し訳ありませんが、サービスは現在ご利用いただけません。",
    "notInDic": "辞書にない",
    "oneChange": "スペルチェックが完了しました：1つの単語が変更されました",
    "progress": "スペルチェックが進行中です...",
    "title": "スペルチェッカー",
    "toolbar": "スペルチェックする"
  }
};


/***/ }),
/* 256 */
/***/ (function(module, exports) {

CKEDITOR.lang['ro'] = {
  'editor': 'Rich Text Editor',
  'editorPanel': 'Rich Text Editor panel',
  'common': {
    'editorHelp': 'Apasă ALT 0 pentru ajutor',
    'browseServer': 'Răsfoieşte server',
    'url': 'URL',
    'protocol': 'Protocol',
    'upload': 'Încarcă',
    'uploadSubmit': 'Trimite la server',
    'image': 'Imagine',
    'flash': 'Flash',
    'form': 'Formular (Form)',
    'checkbox': 'Bifă (Checkbox)',
    'radio': 'Buton radio (RadioButton)',
    'textField': 'Câmp text (TextField)',
    'textarea': 'Suprafaţă text (Textarea)',
    'hiddenField': 'Câmp ascuns (HiddenField)',
    'button': 'Buton',
    'select': 'Câmp selecţie (SelectionField)',
    'imageButton': 'Buton imagine (ImageButton)',
    'notSet': '<nesetat>',
    'id': 'Id',
    'name': 'Nume',
    'langDir': 'Direcţia cuvintelor',
    'langDirLtr': 'stânga-dreapta (LTR)',
    'langDirRtl': 'dreapta-stânga (RTL)',
    'langCode': 'Codul limbii',
    'longDescr': 'Descrierea lungă URL',
    'cssClass': 'Clasele cu stilul paginii (CSS)',
    'advisoryTitle': 'Titlul consultativ',
    'cssStyle': 'Stil',
    'ok': 'OK',
    'cancel': 'Anulare',
    'close': 'Închide',
    'preview': 'Previzualizare',
    'resize': 'Trage pentru a redimensiona',
    'generalTab': 'General',
    'advancedTab': 'Avansat',
    'validateNumberFailed': 'Această valoare nu este un număr.',
    'confirmNewPage': 'Orice modificări nesalvate ale acestui conținut, vor fi pierdute. Sigur doriți încărcarea unei noi pagini?',
    'confirmCancel': 'Câteva opțiuni au fost schimbate. Sigur doriți să închideți dialogul?',
    'options': 'Opțiuni',
    'target': 'Țintă',
    'targetNew': 'Fereastră nouă (_blank)',
    'targetTop': 'Topmost Window (_top)',
    'targetSelf': 'În aceeași fereastră (_self)',
    'targetParent': 'Parent Window (_parent)',
    'langDirLTR': 'Stânga spre Dreapta (LTR)',
    'langDirRTL': 'Dreapta spre Stânga (RTL)',
    'styles': 'Stil',
    'cssClasses': 'Stylesheet Classes',
    'width': 'Lăţime',
    'height': 'Înălţime',
    'align': 'Aliniere',
    'alignLeft': 'Mărește Bara',
    'alignRight': 'Dreapta',
    'alignCenter': 'Centru',
    'alignJustify': 'Aliniere în bloc (Block Justify)',
    'alignTop': 'Sus',
    'alignMiddle': 'Mijloc',
    'alignBottom': 'Jos',
    'alignNone': 'None',
    'invalidValue': 'Valoare invalidă',
    'invalidHeight': 'Înălțimea trebuie să fie un număr.',
    'invalidWidth': 'Lățimea trebuie să fie un număr.',
    'invalidCssLength': 'Valoarea specificată pentru câmpul "%1" trebuie să fie un număr pozitiv cu sau fără o unitate de măsură CSS (px, %, in, cm, mm, em, ex, pt, sau pc).',
    'invalidHtmlLength': 'Valoarea specificată pentru câmpul "%1" trebuie să fie un număr pozitiv cu sau fără o unitate de măsură HTML (px sau %).',
    'invalidInlineStyle': 'Valoarea specificată pentru stil trebuie să conțină una sau mai multe construcții de tipul "name : value", separate prin punct și virgulă.',
    'cssLengthTooltip': 'Introduceți un număr în pixeli sau un număr cu o unitate de măsură CSS (px, %, in, cm, mm, em, ex, pt, sau pc).',
    'unavailable': '%1<span class="cke_accessibility">, nu este disponibil</span>',
    'keyboard': {
      '8': 'Backspace',
      '13': 'Enter',
      '16': 'Shift',
      '17': 'Ctrl',
      '18': 'Alt',
      '32': 'Space',
      '35': 'End',
      '36': 'Home',
      '46': 'Delete',
      '224': 'Command'
    },
    'keyboardShortcut': 'Keyboard shortcut'
  },
  'about': {
    'copy': 'Copyright &copy; $1. Toate drepturile rezervate.',
    'dlgTitle': 'Despre CKEeditor',
    'help': 'Citește  $1 pentru ajutor.',
    'moreInfo': 'Pentru informații despre licență, vă rugăm vizitați web site-ul nostru:',
    'title': 'Despre CKEditor',
    'userGuide': 'CKEditor Ghid Utilizator'
  },
  'basicstyles': {
    'bold': 'Îngroşat (bold)',
    'italic': 'Înclinat (italic)',
    'strike': 'Tăiat (strike through)',
    'subscript': 'Indice (subscript)',
    'superscript': 'Putere (superscript)',
    'underline': 'Subliniat (underline)'
  },
  'blockquote': {
    'toolbar': 'Citat'
  },
  'notification': {
    'closed': 'Notification closed.'
  },
  'button': {
    'selectedLabel': '%1 (Selectat)'
  },
  'toolbar': {
    'toolbarCollapse': 'Micșorează Bara',
    'toolbarExpand': 'Mărește Bara',
    'toolbarGroups': {
      'document': 'Document',
      'clipboard': 'Clipboard/Undo',
      'editing': 'Editing',
      'forms': 'Forms',
      'basicstyles': 'Basic Styles',
      'paragraph': 'Paragraph',
      'links': 'Links',
      'insert': 'Insert',
      'styles': 'Styles',
      'colors': 'Colors',
      'tools': 'Tools'
    },
    'toolbars': 'Editează bara de unelte'
  },
  'clipboard': {
    'copy': 'Copiază',
    'copyError': 'Setările de securitate ale navigatorului (browser) pe care îl folosiţi nu permit editorului să execute automat operaţiunea de copiere. Vă rugăm folosiţi tastatura (Ctrl/Cmd+C).',
    'cut': 'Taie',
    'cutError': 'Setările de securitate ale navigatorului (browser) pe care îl folosiţi nu permit editorului să execute automat operaţiunea de tăiere. Vă rugăm folosiţi tastatura (Ctrl/Cmd+X).',
    'paste': 'Adaugă',
    'pasteNotification': 'Your browser doesn\'t allow you to paste this way. Press %1 to paste.'
  },
  'contextmenu': {
    'options': 'Opțiuni Meniu Contextual'
  },
  'elementspath': {
    'eleLabel': 'Calea elementelor',
    'eleTitle': '%1 element'
  },
  'format': {
    'label': 'Formatare',
    'panelTitle': 'Formatare',
    'tag_address': 'Adresă',
    'tag_div': 'Normal (DIV)',
    'tag_h1': 'Heading 1',
    'tag_h2': 'Heading 2',
    'tag_h3': 'Heading 3',
    'tag_h4': 'Heading 4',
    'tag_h5': 'Heading 5',
    'tag_h6': 'Heading 6',
    'tag_p': 'Normal',
    'tag_pre': 'Formatat'
  },
  'horizontalrule': {
    'toolbar': 'Inserează linie orizontală'
  },
  'image': {
    'alt': 'Text alternativ',
    'border': 'Margine',
    'btnUpload': 'Trimite la server',
    'button2Img': 'Do you want to transform the selected image button on a simple image?',
    'hSpace': 'HSpace',
    'img2Button': 'Do you want to transform the selected image on a image button?',
    'infoTab': 'Informaţii despre imagine',
    'linkTab': 'Link (Legătură web)',
    'lockRatio': 'Păstrează proporţiile',
    'menu': 'Proprietăţile imaginii',
    'resetSize': 'Resetează mărimea',
    'title': 'Proprietăţile imaginii',
    'titleButton': 'Proprietăţi buton imagine (Image Button)',
    'upload': 'Încarcă',
    'urlMissing': 'Sursa URL a imaginii lipsește.',
    'vSpace': 'VSpace',
    'validateBorder': 'Bordura trebuie să fie un număr întreg.',
    'validateHSpace': 'Hspace trebuie să fie un număr întreg.',
    'validateVSpace': 'Vspace trebuie să fie un număr întreg.'
  },
  'indent': {
    'indent': 'Creşte indentarea',
    'outdent': 'Scade indentarea'
  },
  'fakeobjects': {
    'anchor': 'Inserează/Editează ancoră',
    'flash': 'Flash Animation',
    'hiddenfield': 'Câmp ascuns (HiddenField)',
    'iframe': 'IFrame',
    'unknown': 'Unknown Object'
  },
  'link': {
    'acccessKey': 'Tasta de acces',
    'advanced': 'Avansat',
    'advisoryContentType': 'Tipul consultativ al titlului',
    'advisoryTitle': 'Titlul consultativ',
    'anchor': {
      'toolbar': 'Inserează/Editează ancoră',
      'menu': 'Proprietăţi ancoră',
      'title': 'Proprietăţi ancoră',
      'name': 'Numele ancorei',
      'errorName': 'Vă rugăm scrieţi numele ancorei',
      'remove': 'Elimină ancora'
    },
    'anchorId': 'după Id-ul elementului',
    'anchorName': 'după numele ancorei',
    'charset': 'Setul de caractere al resursei legate',
    'cssClasses': 'Clasele cu stilul paginii (CSS)',
    'download': 'Force Download',
    'displayText': 'Display Text',
    'emailAddress': 'Adresă de e-mail',
    'emailBody': 'Opțiuni Meniu Contextual',
    'emailSubject': 'Subiectul mesajului',
    'id': 'Id',
    'info': 'Informaţii despre link (Legătură web)',
    'langCode': 'Direcţia cuvintelor',
    'langDir': 'Direcţia cuvintelor',
    'langDirLTR': 'stânga-dreapta (LTR)',
    'langDirRTL': 'dreapta-stânga (RTL)',
    'menu': 'Editează Link',
    'name': 'Nume',
    'noAnchors': '(Nicio ancoră disponibilă în document)',
    'noEmail': 'Vă rugăm să scrieţi adresa de e-mail',
    'noUrl': 'Vă rugăm să scrieţi URL-ul',
    'other': '<alt>',
    'popupDependent': 'Dependent (Netscape)',
    'popupFeatures': 'Proprietăţile ferestrei popup',
    'popupFullScreen': 'Tot ecranul (Full Screen)(IE)',
    'popupLeft': 'Poziţia la stânga',
    'popupLocationBar': 'Bara de locaţie',
    'popupMenuBar': 'Bara de meniu',
    'popupResizable': 'Redimensionabil',
    'popupScrollBars': 'Bare de derulare',
    'popupStatusBar': 'Bara de status',
    'popupToolbar': 'Bara de opţiuni',
    'popupTop': 'Poziţia la dreapta',
    'rel': 'Relație',
    'selectAnchor': 'Selectaţi o ancoră',
    'styles': 'Stil',
    'tabIndex': 'Indexul tabului',
    'target': 'Ţintă (Target)',
    'targetFrame': '<frame>',
    'targetFrameName': 'Numele frameului ţintă',
    'targetPopup': '<fereastra popup>',
    'targetPopupName': 'Numele ferestrei popup',
    'title': 'Link (Legătură web)',
    'toAnchor': 'Ancoră în această pagină',
    'toEmail': 'E-Mail',
    'toUrl': 'URL',
    'toolbar': 'Inserează/Editează link (legătură web)',
    'type': 'Tipul link-ului (al legăturii web)',
    'unlink': 'Înlătură link (legătură web)',
    'upload': 'Încarcă'
  },
  'list': {
    'bulletedlist': 'Inserează / Elimină Listă cu puncte',
    'numberedlist': 'Inserează / Elimină Listă numerotată'
  },
  'magicline': {
    'title': 'Insert paragraph here'
  },
  'maximize': {
    'maximize': 'Mărește',
    'minimize': 'Micșorează'
  },
  'pastetext': {
    'button': 'Adaugă ca text simplu (Plain Text)',
    'pasteNotification': 'Your browser does not allow you to paste plain text this way. Press %1 to paste.'
  },
  'pastefromword': {
    'confirmCleanup': 'Textul pe care doriți să-l lipiți este din Word. Doriți curățarea textului înante de a-l adăuga?',
    'error': 'Nu a fost posibilă curățarea datelor adăugate datorită unei erori interne',
    'title': 'Adaugă din Word',
    'toolbar': 'Adaugă din Word'
  },
  'removeformat': {
    'toolbar': 'Înlătură formatarea'
  },
  'sourcearea': {
    'toolbar': 'Sursa'
  },
  'specialchar': {
    'options': 'Opțiuni caractere speciale',
    'title': 'Selectează caracter special',
    'toolbar': 'Inserează caracter special'
  },
  'scayt': {
    'btn_about': 'About SCAYT',
    'btn_dictionaries': 'Dictionaries',
    'btn_disable': 'Disable SCAYT',
    'btn_enable': 'Enable SCAYT',
    'btn_langs': 'Languages',
    'btn_options': 'Options',
    'text_title': 'Spell Check As You Type'
  },
  'stylescombo': {
    'label': 'Stil',
    'panelTitle': 'Formatarea stilurilor',
    'panelTitle1': 'Block Styles',
    'panelTitle2': 'Inline Styles',
    'panelTitle3': 'Object Styles'
  },
  'table': {
    'border': 'Mărimea marginii',
    'caption': 'Titlu (Caption)',
    'cell': {
      'menu': 'Celulă',
      'insertBefore': 'Inserează celulă înainte',
      'insertAfter': 'Inserează celulă după',
      'deleteCell': 'Şterge celule',
      'merge': 'Uneşte celule',
      'mergeRight': 'Uneşte la dreapta',
      'mergeDown': 'Uneşte jos',
      'splitHorizontal': 'Împarte celula pe orizontală',
      'splitVertical': 'Împarte celula pe verticală',
      'title': 'Proprietăți celulă',
      'cellType': 'Tipul celulei',
      'rowSpan': 'Rows Span',
      'colSpan': 'Columns Span',
      'wordWrap': 'Word Wrap',
      'hAlign': 'Aliniament orizontal',
      'vAlign': 'Aliniament vertical',
      'alignBaseline': 'Baseline',
      'bgColor': 'Culoare fundal',
      'borderColor': 'Culoare bordură',
      'data': 'Data',
      'header': 'Antet',
      'yes': 'Da',
      'no': 'Nu',
      'invalidWidth': 'Lățimea celulei trebuie să fie un număr.',
      'invalidHeight': 'Înălțimea celulei trebuie să fie un număr.',
      'invalidRowSpan': 'Rows span must be a whole number.',
      'invalidColSpan': 'Columns span must be a whole number.',
      'chooseColor': 'Alege'
    },
    'cellPad': 'Spaţiu în cadrul celulei',
    'cellSpace': 'Spaţiu între celule',
    'column': {
      'menu': 'Coloană',
      'insertBefore': 'Inserează coloană înainte',
      'insertAfter': 'Inserează coloană după',
      'deleteColumn': 'Şterge celule'
    },
    'columns': 'Coloane',
    'deleteTable': 'Şterge tabel',
    'headers': 'Antente',
    'headersBoth': 'Ambele',
    'headersColumn': 'Prima coloană',
    'headersNone': 'Nimic',
    'headersRow': 'Primul rând',
    'invalidBorder': 'Dimensiunea bordurii trebuie să aibe un număr.',
    'invalidCellPadding': 'Spațierea celulei trebuie sa fie un număr pozitiv',
    'invalidCellSpacing': 'Spațierea celului trebuie să fie un număr pozitiv.',
    'invalidCols': 'Numărul coloanelor trebuie să fie mai mare decât 0.',
    'invalidHeight': 'Inaltimea celulei trebuie sa fie un numar.',
    'invalidRows': 'Numărul rândurilor trebuie să fie mai mare decât 0.',
    'invalidWidth': 'Lățimea tabelului trebuie să fie un număr.',
    'menu': 'Proprietăţile tabelului',
    'row': {
      'menu': 'Rând',
      'insertBefore': 'Inserează rând înainte',
      'insertAfter': 'Inserează rând după',
      'deleteRow': 'Şterge rânduri'
    },
    'rows': 'Rânduri',
    'summary': 'Rezumat',
    'title': 'Proprietăţile tabelului',
    'toolbar': 'Tabel',
    'widthPc': 'procente',
    'widthPx': 'pixeli',
    'widthUnit': 'unitate lățime'
  },
  'undo': {
    'redo': 'Starea ulterioară (redo)',
    'undo': 'Starea anterioară (undo)'
  },
  'wsc': {
    'btnIgnore': 'Ignoră',
    'btnIgnoreAll': 'Ignoră toate',
    'btnReplace': 'Înlocuieşte',
    'btnReplaceAll': 'Înlocuieşte tot',
    'btnUndo': 'Starea anterioară (undo)',
    'changeTo': 'Schimbă în',
    'errorLoading': 'Eroare în lansarea aplicației service host %s.',
    'ieSpellDownload': 'Unealta pentru verificat textul (Spell checker) neinstalată. Doriţi să o descărcaţi acum?',
    'manyChanges': 'Verificarea textului terminată: 1% cuvinte modificate',
    'noChanges': 'Verificarea textului terminată: Niciun cuvânt modificat',
    'noMispell': 'Verificarea textului terminată: Nicio greşeală găsită',
    'noSuggestions': '- Fără sugestii -',
    'notAvailable': 'Scuzați, dar serviciul nu este disponibil momentan.',
    'notInDic': 'Nu e în dicţionar',
    'oneChange': 'Verificarea textului terminată: Un cuvânt modificat',
    'progress': 'Verificarea textului în desfăşurare...',
    'title': 'Spell Checker',
    'toolbar': 'Verifică scrierea textului'
  }
};


/***/ }),
/* 257 */
/***/ (function(module, exports) {


/*
Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
For licensing, see LICENSE.md or http://ckeditor.com/license
 */
CKEDITOR.lang['ru'] = {
  'wsc': {
    'btnIgnore': 'Пропустить',
    'btnIgnoreAll': 'Пропустить всё',
    'btnReplace': 'Заменить',
    'btnReplaceAll': 'Заменить всё',
    'btnUndo': 'Отменить',
    'changeTo': 'Изменить на',
    'errorLoading': 'Произошла ошибка при подключении к серверу проверки орфографии: %s.',
    'ieSpellDownload': 'Модуль проверки орфографии не установлен. Хотите скачать его?',
    'manyChanges': 'Проверка орфографии завершена. Изменено слов: %1',
    'noChanges': 'Проверка орфографии завершена. Не изменено ни одного слова',
    'noMispell': 'Проверка орфографии завершена. Ошибок не найдено',
    'noSuggestions': '- Варианты отсутствуют -',
    'notAvailable': 'Извините, но в данный момент сервис недоступен.',
    'notInDic': 'Отсутствует в словаре',
    'oneChange': 'Проверка орфографии завершена. Изменено одно слово',
    'progress': 'Орфография проверяется...',
    'title': 'Проверка орфографии',
    'toolbar': 'Проверить орфографию'
  },
  'undo': {
    'redo': 'Повторить',
    'undo': 'Отменить'
  },
  'toolbar': {
    'toolbarCollapse': 'Свернуть панель инструментов',
    'toolbarExpand': 'Развернуть панель инструментов',
    'toolbarGroups': {
      'document': 'Документ',
      'clipboard': 'Буфер обмена / Отмена действий',
      'editing': 'Корректировка',
      'forms': 'Формы',
      'basicstyles': 'Простые стили',
      'paragraph': 'Абзац',
      'links': 'Ссылки',
      'insert': 'Вставка',
      'styles': 'Стили',
      'colors': 'Цвета',
      'tools': 'Инструменты'
    },
    'toolbars': 'Панели инструментов редактора'
  },
  'table': {
    'border': 'Размер границ',
    'caption': 'Заголовок',
    'cell': {
      'menu': 'Ячейка',
      'insertBefore': 'Вставить ячейку слева',
      'insertAfter': 'Вставить ячейку справа',
      'deleteCell': 'Удалить ячейки',
      'merge': 'Объединить ячейки',
      'mergeRight': 'Объединить с правой',
      'mergeDown': 'Объединить с нижней',
      'splitHorizontal': 'Разделить ячейку по горизонтали',
      'splitVertical': 'Разделить ячейку по вертикали',
      'title': 'Свойства ячейки',
      'cellType': 'Тип ячейки',
      'rowSpan': 'Объединяет строк',
      'colSpan': 'Объединяет колонок',
      'wordWrap': 'Перенос по словам',
      'hAlign': 'Горизонтальное выравнивание',
      'vAlign': 'Вертикальное выравнивание',
      'alignBaseline': 'По базовой линии',
      'bgColor': 'Цвет фона',
      'borderColor': 'Цвет границ',
      'data': 'Данные',
      'header': 'Заголовок',
      'yes': 'Да',
      'no': 'Нет',
      'invalidWidth': 'Ширина ячейки должна быть числом.',
      'invalidHeight': 'Высота ячейки должна быть числом.',
      'invalidRowSpan': 'Количество объединяемых строк должно быть задано числом.',
      'invalidColSpan': 'Количество объединяемых колонок должно быть задано числом.',
      'chooseColor': 'Выберите'
    },
    'cellPad': 'Внутренний отступ ячеек',
    'cellSpace': 'Внешний отступ ячеек',
    'column': {
      'menu': 'Колонка',
      'insertBefore': 'Вставить колонку слева',
      'insertAfter': 'Вставить колонку справа',
      'deleteColumn': 'Удалить колонки'
    },
    'columns': 'Колонки',
    'deleteTable': 'Удалить таблицу',
    'headers': 'Заголовки',
    'headersBoth': 'Сверху и слева',
    'headersColumn': 'Левая колонка',
    'headersNone': 'Без заголовков',
    'headersRow': 'Верхняя строка',
    'invalidBorder': 'Размер границ должен быть числом.',
    'invalidCellPadding': 'Внутренний отступ ячеек (cellpadding) должен быть числом.',
    'invalidCellSpacing': 'Внешний отступ ячеек (cellspacing) должен быть числом.',
    'invalidCols': 'Количество столбцов должно быть больше 0.',
    'invalidHeight': 'Высота таблицы должна быть числом.',
    'invalidRows': 'Количество строк должно быть больше 0.',
    'invalidWidth': 'Ширина таблицы должна быть числом.',
    'menu': 'Свойства таблицы',
    'row': {
      'menu': 'Строка',
      'insertBefore': 'Вставить строку сверху',
      'insertAfter': 'Вставить строку снизу',
      'deleteRow': 'Удалить строки'
    },
    'rows': 'Строки',
    'summary': 'Итоги',
    'title': 'Свойства таблицы',
    'toolbar': 'Таблица',
    'widthPc': 'процентов',
    'widthPx': 'пикселей',
    'widthUnit': 'единица измерения'
  },
  'stylescombo': {
    'label': 'Стили',
    'panelTitle': 'Стили форматирования',
    'panelTitle1': 'Стили блока',
    'panelTitle2': 'Стили элемента',
    'panelTitle3': 'Стили объекта'
  },
  'specialchar': {
    'options': 'Выбор специального символа',
    'title': 'Выберите специальный символ',
    'toolbar': 'Вставить специальный символ'
  },
  'sourcearea': {
    'toolbar': 'Источник'
  },
  'scayt': {
    'btn_about': 'О SCAYT',
    'btn_dictionaries': 'Словари',
    'btn_disable': 'Отключить SCAYT',
    'btn_enable': 'Включить SCAYT',
    'btn_langs': 'Языки',
    'btn_options': 'Настройки',
    'text_title': 'Проверка орфографии по мере ввода (SCAYT)'
  },
  'removeformat': {
    'toolbar': 'Убрать форматирование'
  },
  'pastetext': {
    'button': 'Вставить только текст',
    'title': 'Вставить только текст'
  },
  'pastefromword': {
    'confirmCleanup': 'Текст, который вы желаете вставить, по всей видимости, был скопирован из Word. Следует ли очистить его перед вставкой?',
    'error': 'Невозможно очистить вставленные данные из-за внутренней ошибки',
    'title': 'Вставить из Word',
    'toolbar': 'Вставить из Word'
  },
  'maximize': {
    'maximize': 'Развернуть',
    'minimize': 'Свернуть'
  },
  'magicline': {
    'title': 'Вставить здесь параграф'
  },
  'list': {
    'bulletedlist': 'Вставить / удалить маркированный список',
    'numberedlist': 'Вставить / удалить нумерованный список'
  },
  'link': {
    'acccessKey': 'Клавиша доступа',
    'advanced': 'Дополнительно',
    'advisoryContentType': 'Тип содержимого',
    'advisoryTitle': 'Заголовок',
    'anchor': {
      'toolbar': 'Вставить / редактировать якорь',
      'menu': 'Изменить якорь',
      'title': 'Свойства якоря',
      'name': 'Имя якоря',
      'errorName': 'Пожалуйста, введите имя якоря',
      'remove': 'Удалить якорь'
    },
    'anchorId': 'По идентификатору',
    'anchorName': 'По имени',
    'charset': 'Кодировка ресурса',
    'cssClasses': 'Классы CSS',
    'emailAddress': 'Email адрес',
    'emailBody': 'Текст сообщения',
    'emailSubject': 'Тема сообщения',
    'id': 'Идентификатор',
    'info': 'Информация о ссылке',
    'langCode': 'Код языка',
    'langDir': 'Направление текста',
    'langDirLTR': 'Слева направо (LTR)',
    'langDirRTL': 'Справа налево (RTL)',
    'menu': 'Редактировать ссылку',
    'name': 'Имя',
    'noAnchors': '(В документе нет ни одного якоря)',
    'noEmail': 'Пожалуйста, введите email адрес',
    'noUrl': 'Пожалуйста, введите ссылку',
    'other': '<другой>',
    'popupDependent': 'Зависимое (Netscape)',
    'popupFeatures': 'Параметры всплывающего окна',
    'popupFullScreen': 'Полноэкранное (IE)',
    'popupLeft': 'Отступ слева',
    'popupLocationBar': 'Панель адреса',
    'popupMenuBar': 'Панель меню',
    'popupResizable': 'Изменяемый размер',
    'popupScrollBars': 'Полосы прокрутки',
    'popupStatusBar': 'Строка состояния',
    'popupToolbar': 'Панель инструментов',
    'popupTop': 'Отступ сверху',
    'rel': 'Отношение',
    'selectAnchor': 'Выберите якорь',
    'styles': 'Стиль',
    'tabIndex': 'Последовательность перехода',
    'target': 'Цель',
    'targetFrame': '<фрейм>',
    'targetFrameName': 'Имя целевого фрейма',
    'targetPopup': '<всплывающее окно>',
    'targetPopupName': 'Имя всплывающего окна',
    'title': 'Ссылка',
    'toAnchor': 'Ссылка на якорь в тексте',
    'toEmail': 'Email',
    'toUrl': 'Ссылка',
    'toolbar': 'Вставить/Редактировать ссылку',
    'type': 'Тип ссылки',
    'unlink': 'Убрать ссылку',
    'upload': 'Загрузка'
  },
  'indent': {
    'indent': 'Увеличить отступ',
    'outdent': 'Уменьшить отступ'
  },
  'image': {
    'alertUrl': 'Пожалуйста, введите ссылку на изображение',
    'alt': 'Альтернативный текст',
    'border': 'Граница',
    'btnUpload': 'Загрузить на сервер',
    'button2Img': 'Вы желаете преобразовать это изображение-кнопку в обычное изображение?',
    'hSpace': 'Гориз. отступ',
    'img2Button': 'Вы желаете преобразовать это обычное изображение в изображение-кнопку?',
    'infoTab': 'Данные об изображении',
    'linkTab': 'Ссылка',
    'lockRatio': 'Сохранять пропорции',
    'menu': 'Свойства изображения',
    'resetSize': 'Вернуть обычные размеры',
    'title': 'Свойства изображения',
    'titleButton': 'Свойства изображения-кнопки',
    'upload': 'Загрузить',
    'urlMissing': 'Не указана ссылка на изображение.',
    'vSpace': 'Вертик. отступ',
    'validateBorder': 'Размер границ должен быть задан числом.',
    'validateHSpace': 'Горизонтальный отступ должен быть задан числом.',
    'validateVSpace': 'Вертикальный отступ должен быть задан числом.'
  },
  'horizontalrule': {
    'toolbar': 'Вставить горизонтальную линию'
  },
  'format': {
    'label': 'Форматирование',
    'panelTitle': 'Форматирование',
    'tag_address': 'Адрес',
    'tag_div': 'Обычное (div)',
    'tag_h1': 'Заголовок 1',
    'tag_h2': 'Заголовок 2',
    'tag_h3': 'Заголовок 3',
    'tag_h4': 'Заголовок 4',
    'tag_h5': 'Заголовок 5',
    'tag_h6': 'Заголовок 6',
    'tag_p': 'Параграф',
    'tag_pre': 'Моноширинное'
  },
  'fakeobjects': {
    'anchor': 'Якорь',
    'flash': 'Flash анимация',
    'hiddenfield': 'Скрытое поле',
    'iframe': 'iFrame',
    'unknown': 'Неизвестный объект'
  },
  'elementspath': {
    'eleLabel': 'Путь элементов',
    'eleTitle': 'Элемент %1'
  },
  'contextmenu': {
    'options': 'Параметры контекстного меню'
  },
  'clipboard': {
    'copy': 'Копировать',
    'copyError': 'Настройки безопасности вашего браузера не разрешают редактору выполнять операции по копированию текста. Пожалуйста, используйте для этого клавиатуру (Ctrl/Cmd+C).',
    'cut': 'Вырезать',
    'cutError': 'Настройки безопасности вашего браузера не разрешают редактору выполнять операции по вырезке текста. Пожалуйста, используйте для этого клавиатуру (Ctrl/Cmd+X).',
    'paste': 'Вставить',
    'pasteArea': 'Зона для вставки',
    'pasteMsg': 'Пожалуйста, вставьте текст в зону ниже, используя клавиатуру (<strong>Ctrl/Cmd+V</strong>) и нажмите кнопку "OK".',
    'securityMsg': 'Настройки безопасности вашего браузера не разрешают редактору напрямую обращаться к буферу обмена. Вы должны вставить текст снова в это окно.',
    'title': 'Вставить'
  },
  'button': {
    'selectedLabel': '%1 (Выбрано)'
  },
  'blockquote': {
    'toolbar': 'Цитата'
  },
  'basicstyles': {
    'bold': 'Полужирный',
    'italic': 'Курсив',
    'strike': 'Зачеркнутый',
    'subscript': 'Подстрочный индекс',
    'superscript': 'Надстрочный индекс',
    'underline': 'Подчеркнутый'
  },
  'about': {
    'copy': 'Copyright &copy; $1. Все права защищены.',
    'dlgTitle': 'О CKEditor',
    'help': '$1 содержит подробную справку по использованию.',
    'moreInfo': 'Для получения информации о лицензии, пожалуйста, перейдите на наш сайт:',
    'title': 'О CKEditor',
    'userGuide': 'Руководство пользователя CKEditor'
  },
  'editor': 'Визуальный текстовый редактор',
  'editorPanel': 'Визуальный редактор текста',
  'common': {
    'editorHelp': 'Нажмите ALT-0 для открытия справки',
    'browseServer': 'Выбор на сервере',
    'url': 'Ссылка',
    'protocol': 'Протокол',
    'upload': 'Загрузка файла',
    'uploadSubmit': 'Загрузить на сервер',
    'image': 'Изображение',
    'flash': 'Flash',
    'form': 'Форма',
    'checkbox': 'Чекбокс',
    'radio': 'Радиокнопка',
    'textField': 'Текстовое поле',
    'textarea': 'Многострочное текстовое поле',
    'hiddenField': 'Скрытое поле',
    'button': 'Кнопка',
    'select': 'Выпадающий список',
    'imageButton': 'Кнопка-изображение',
    'notSet': '<не указано>',
    'id': 'Идентификатор',
    'name': 'Имя',
    'langDir': 'Направление текста',
    'langDirLtr': 'Слева направо (LTR)',
    'langDirRtl': 'Справа налево (RTL)',
    'langCode': 'Код языка',
    'longDescr': 'Длинное описание ссылки',
    'cssClass': 'Класс CSS',
    'advisoryTitle': 'Заголовок',
    'cssStyle': 'Стиль',
    'ok': 'ОК',
    'cancel': 'Отмена',
    'close': 'Закрыть',
    'preview': 'Предпросмотр',
    'resize': 'Перетащите для изменения размера',
    'generalTab': 'Основное',
    'advancedTab': 'Дополнительно',
    'validateNumberFailed': 'Это значение не является числом.',
    'confirmNewPage': 'Несохранённые изменения будут потеряны! Вы действительно желаете перейти на другую страницу?',
    'confirmCancel': 'Некоторые параметры были изменены. Вы уверены, что желаете закрыть без сохранения?',
    'options': 'Параметры',
    'target': 'Цель',
    'targetNew': 'Новое окно (_blank)',
    'targetTop': 'Главное окно (_top)',
    'targetSelf': 'Текущее окно (_self)',
    'targetParent': 'Родительское окно (_parent)',
    'langDirLTR': 'Слева направо (LTR)',
    'langDirRTL': 'Справа налево (RTL)',
    'styles': 'Стиль',
    'cssClasses': 'CSS классы',
    'width': 'Ширина',
    'height': 'Высота',
    'align': 'Выравнивание',
    'alignLeft': 'По левому краю',
    'alignRight': 'По правому краю',
    'alignCenter': 'По центру',
    'alignJustify': 'По ширине',
    'alignTop': 'Поверху',
    'alignMiddle': 'Посередине',
    'alignBottom': 'Понизу',
    'alignNone': 'Нет',
    'invalidValue': 'Недопустимое значение.',
    'invalidHeight': 'Высота задается числом.',
    'invalidWidth': 'Ширина задается числом.',
    'invalidCssLength': 'Значение, указанное в поле "%1", должно быть положительным целым числом. Допускается указание единиц меры CSS (px, %, in, cm, mm, em, ex, pt или pc).',
    'invalidHtmlLength': 'Значение, указанное в поле "%1", должно быть положительным целым числом. Допускается указание единиц меры HTML (px или %).',
    'invalidInlineStyle': 'Значение, указанное для стиля элемента, должно состоять из одной или нескольких пар данных в формате "параметр : значение", разделённых точкой с запятой.',
    'cssLengthTooltip': 'Введите значение в пикселях, либо число с корректной единицей меры CSS (px, %, in, cm, mm, em, ex, pt или pc).',
    'unavailable': '%1<span class="cke_accessibility">, недоступно</span>'
  }
};


/***/ }),
/* 258 */
/***/ (function(module, exports) {

CKEDITOR.lang['th'] = {
  'editor': 'Rich Text Editor',
  'editorPanel': 'Rich Text Editor panel',
  'common': {
    'editorHelp': 'กด ALT 0 หากต้องการความช่วยเหลือ',
    'browseServer': 'เปิดหน้าต่างจัดการไฟล์อัพโหลด',
    'url': 'ที่อยู่อ้างอิง URL',
    'protocol': 'โปรโตคอล',
    'upload': 'อัพโหลดไฟล์',
    'uploadSubmit': 'อัพโหลดไฟล์ไปเก็บไว้ที่เครื่องแม่ข่าย (เซิร์ฟเวอร์)',
    'image': 'รูปภาพ',
    'flash': 'ไฟล์ Flash',
    'form': 'แบบฟอร์ม',
    'checkbox': 'เช็คบ๊อก',
    'radio': 'เรดิโอบัตตอน',
    'textField': 'เท็กซ์ฟิลด์',
    'textarea': 'เท็กซ์แอเรีย',
    'hiddenField': 'ฮิดเดนฟิลด์',
    'button': 'ปุ่ม',
    'select': 'แถบตัวเลือก',
    'imageButton': 'ปุ่มแบบรูปภาพ',
    'notSet': '<ไม่ระบุ>',
    'id': 'ไอดี',
    'name': 'ชื่อ',
    'langDir': 'การเขียน-อ่านภาษา',
    'langDirLtr': 'จากซ้ายไปขวา (LTR)',
    'langDirRtl': 'จากขวามาซ้าย (RTL)',
    'langCode': 'รหัสภาษา',
    'longDescr': 'คำอธิบายประกอบ URL',
    'cssClass': 'คลาสของไฟล์กำหนดลักษณะการแสดงผล',
    'advisoryTitle': 'คำเกริ่นนำ',
    'cssStyle': 'ลักษณะการแสดงผล',
    'ok': 'ตกลง',
    'cancel': 'ยกเลิก',
    'close': 'ปิด',
    'preview': 'ดูหน้าเอกสารตัวอย่าง',
    'resize': 'ปรับขนาด',
    'generalTab': 'ทั่วไป',
    'advancedTab': 'ขั้นสูง',
    'validateNumberFailed': 'ค่านี้ไม่ใช่ตัวเลข',
    'confirmNewPage': 'การเปลี่ยนแปลงใดๆ ในเนื้อหานี้ ที่ไม่ได้ถูกบันทึกไว้ จะสูญหายทั้งหมด คุณแน่ใจว่าจะเรียกหน้าใหม่?',
    'confirmCancel': 'ตัวเลือกบางตัวมีการเปลี่ยนแปลง คุณแน่ใจว่าจะปิดกล่องโต้ตอบนี้?',
    'options': 'ตัวเลือก',
    'target': 'การเปิดหน้าลิงค์',
    'targetNew': 'หน้าต่างใหม่ (_blank)',
    'targetTop': 'Topmost Window (_top)',
    'targetSelf': 'หน้าต่างเดียวกัน (_self)',
    'targetParent': 'Parent Window (_parent)',
    'langDirLTR': 'จากซ้ายไปขวา (LTR)',
    'langDirRTL': 'จากขวามาซ้าย (RTL)',
    'styles': 'ลักษณะการแสดงผล',
    'cssClasses': 'คลาสของไฟล์กำหนดลักษณะการแสดงผล',
    'width': 'ความกว้าง',
    'height': 'ความสูง',
    'align': 'การจัดวาง',
    'alignLeft': 'ชิดซ้าย',
    'alignRight': 'ชิดขวา',
    'alignCenter': 'กึ่งกลาง',
    'alignJustify': 'நியாயப்படுத்தவும்',
    'alignTop': 'บนสุด',
    'alignMiddle': 'กึ่งกลางแนวตั้ง',
    'alignBottom': 'ชิดด้านล่าง',
    'alignNone': 'None',
    'invalidValue': 'ค่าไม่ถูกต้อง',
    'invalidHeight': 'ความสูงต้องเป็นตัวเลข',
    'invalidWidth': 'ความกว้างต้องเป็นตัวเลข',
    'invalidCssLength': 'Value specified for the "%1" field must be a positive number with or without a valid CSS measurement unit (px, %, in, cm, mm, em, ex, pt, or pc).',
    'invalidHtmlLength': 'Value specified for the "%1" field must be a positive number with or without a valid HTML measurement unit (px or %).',
    'invalidInlineStyle': 'Value specified for the inline style must consist of one or more tuples with the format of "name : value", separated by semi-colons.',
    'cssLengthTooltip': 'Enter a number for a value in pixels or a number with a valid CSS unit (px, %, in, cm, mm, em, ex, pt, or pc).',
    'unavailable': '%1<span class="cke_accessibility">, unavailable</span>',
    'keyboard': {
      '8': 'Backspace',
      '13': 'Enter',
      '16': 'Shift',
      '17': 'Ctrl',
      '18': 'Alt',
      '32': 'Space',
      '35': 'End',
      '36': 'Home',
      '46': 'Delete',
      '224': 'Command'
    },
    'keyboardShortcut': 'Keyboard shortcut'
  },
  'about': {
    'copy': 'Copyright &copy; $1. All rights reserved.',
    'dlgTitle': 'About CKEditor',
    'help': 'Check $1 for help.',
    'moreInfo': 'For licensing information please visit our web site:',
    'title': 'About CKEditor',
    'userGuide': 'CKEditor User\'s Guide'
  },
  'basicstyles': {
    'bold': 'ตัวหนา',
    'italic': 'ตัวเอียง',
    'strike': 'ตัวขีดเส้นทับ',
    'subscript': 'ตัวห้อย',
    'superscript': 'ตัวยก',
    'underline': 'ตัวขีดเส้นใต้'
  },
  'blockquote': {
    'toolbar': 'Block Quote'
  },
  'notification': {
    'closed': 'Notification closed.'
  },
  'button': {
    'selectedLabel': '%1 (Selected)'
  },
  'toolbar': {
    'toolbarCollapse': 'ซ่อนแถบเครื่องมือ',
    'toolbarExpand': 'เปิดแถบเครื่องมือ',
    'toolbarGroups': {
      'document': 'Document',
      'clipboard': 'Clipboard/Undo',
      'editing': 'Editing',
      'forms': 'Forms',
      'basicstyles': 'Basic Styles',
      'paragraph': 'Paragraph',
      'links': 'Links',
      'insert': 'Insert',
      'styles': 'Styles',
      'colors': 'Colors',
      'tools': 'Tools'
    },
    'toolbars': 'แถบเครื่องมือช่วยพิมพ์ข้อความ'
  },
  'clipboard': {
    'copy': 'สำเนา',
    'copyError': 'ไม่สามารถสำเนาข้อความที่เลือกไว้ได้เนื่องจากการกำหนดค่าระดับความปลอดภัย. กรุณาใช้ปุ่มลัดเพื่อวางข้อความแทน (กดปุ่ม Ctrl/Cmd และตัว C พร้อมกัน).',
    'cut': 'ตัด',
    'cutError': 'ไม่สามารถตัดข้อความที่เลือกไว้ได้เนื่องจากการกำหนดค่าระดับความปลอดภัย. กรุณาใช้ปุ่มลัดเพื่อวางข้อความแทน (กดปุ่ม Ctrl/Cmd และตัว X พร้อมกัน).',
    'paste': 'วาง',
    'pasteNotification': 'Your browser doesn\'t allow you to paste this way. Press %1 to paste.'
  },
  'contextmenu': {
    'options': 'Context Menu Options'
  },
  'elementspath': {
    'eleLabel': 'Elements path',
    'eleTitle': '%1 element'
  },
  'format': {
    'label': 'รูปแบบ',
    'panelTitle': 'รูปแบบ',
    'tag_address': 'Address',
    'tag_div': 'Paragraph (DIV)',
    'tag_h1': 'Heading 1',
    'tag_h2': 'Heading 2',
    'tag_h3': 'Heading 3',
    'tag_h4': 'Heading 4',
    'tag_h5': 'Heading 5',
    'tag_h6': 'Heading 6',
    'tag_p': 'Normal',
    'tag_pre': 'Formatted'
  },
  'horizontalrule': {
    'toolbar': 'แทรกเส้นคั่นบรรทัด'
  },
  'image': {
    'alt': 'คำประกอบรูปภาพ',
    'border': 'ขนาดขอบรูป',
    'btnUpload': 'อัพโหลดไฟล์ไปเก็บไว้ที่เครื่องแม่ข่าย (เซิร์ฟเวอร์)',
    'button2Img': 'Do you want to transform the selected image button on a simple image?',
    'hSpace': 'ระยะแนวนอน',
    'img2Button': 'Do you want to transform the selected image on a image button?',
    'infoTab': 'ข้อมูลของรูปภาพ',
    'linkTab': 'ลิ้งค์',
    'lockRatio': 'กำหนดอัตราส่วน กว้าง-สูง แบบคงที่',
    'menu': 'คุณสมบัติของ รูปภาพ',
    'resetSize': 'กำหนดรูปเท่าขนาดจริง',
    'title': 'คุณสมบัติของ รูปภาพ',
    'titleButton': 'คุณสมบัติของ ปุ่มแบบรูปภาพ',
    'upload': 'อัพโหลดไฟล์',
    'urlMissing': 'Image source URL is missing.',
    'vSpace': 'ระยะแนวตั้ง',
    'validateBorder': 'Border must be a whole number.',
    'validateHSpace': 'HSpace must be a whole number.',
    'validateVSpace': 'VSpace must be a whole number.'
  },
  'indent': {
    'indent': 'เพิ่มระยะย่อหน้า',
    'outdent': 'ลดระยะย่อหน้า'
  },
  'fakeobjects': {
    'anchor': 'แทรก/แก้ไข Anchor',
    'flash': 'ภาพอนิเมชั่นแฟลช',
    'hiddenfield': 'ฮิดเดนฟิลด์',
    'iframe': 'IFrame',
    'unknown': 'วัตถุไม่ทราบชนิด'
  },
  'link': {
    'acccessKey': 'แอคเซส คีย์',
    'advanced': 'ขั้นสูง',
    'advisoryContentType': 'ชนิดของคำเกริ่นนำ',
    'advisoryTitle': 'คำเกริ่นนำ',
    'anchor': {
      'toolbar': 'แทรก/แก้ไข Anchor',
      'menu': 'รายละเอียด Anchor',
      'title': 'รายละเอียด Anchor',
      'name': 'ชื่อ Anchor',
      'errorName': 'กรุณาระบุชื่อของ Anchor',
      'remove': 'Remove Anchor'
    },
    'anchorId': 'ไอดี',
    'anchorName': 'ชื่อ',
    'charset': 'ลิงค์เชื่อมโยงไปยังชุดตัวอักษร',
    'cssClasses': 'คลาสของไฟล์กำหนดลักษณะการแสดงผล',
    'download': 'Force Download',
    'displayText': 'Display Text',
    'emailAddress': 'อีเมล์ (E-Mail)',
    'emailBody': 'ข้อความ',
    'emailSubject': 'หัวเรื่อง',
    'id': 'ไอดี',
    'info': 'รายละเอียด',
    'langCode': 'การเขียน-อ่านภาษา',
    'langDir': 'การเขียน-อ่านภาษา',
    'langDirLTR': 'จากซ้ายไปขวา (LTR)',
    'langDirRTL': 'จากขวามาซ้าย (RTL)',
    'menu': 'แก้ไข ลิงค์',
    'name': 'ชื่อ',
    'noAnchors': '(ยังไม่มีจุดเชื่อมโยงภายในหน้าเอกสารนี้)',
    'noEmail': 'กรุณาระบุอีเมล์ (E-mail)',
    'noUrl': 'กรุณาระบุที่อยู่อ้างอิงออนไลน์ (URL)',
    'other': '<อื่น ๆ>',
    'popupDependent': 'แสดงเต็มหน้าจอ (Netscape)',
    'popupFeatures': 'คุณสมบัติของหน้าจอเล็ก (Pop-up)',
    'popupFullScreen': 'แสดงเต็มหน้าจอ (IE5.5++ เท่านั้น)',
    'popupLeft': 'พิกัดซ้าย (Left Position)',
    'popupLocationBar': 'แสดงที่อยู่ของไฟล์',
    'popupMenuBar': 'แสดงแถบเมนู',
    'popupResizable': 'สามารถปรับขนาดได้',
    'popupScrollBars': 'แสดงแถบเลื่อน',
    'popupStatusBar': 'แสดงแถบสถานะ',
    'popupToolbar': 'แสดงแถบเครื่องมือ',
    'popupTop': 'พิกัดบน (Top Position)',
    'rel': 'ความสัมพันธ์',
    'selectAnchor': 'ระบุข้อมูลของจุดเชื่อมโยง (Anchor)',
    'styles': 'ลักษณะการแสดงผล',
    'tabIndex': 'ลำดับของ แท็บ',
    'target': 'การเปิดหน้าลิงค์',
    'targetFrame': '<เปิดในเฟรม>',
    'targetFrameName': 'ชื่อทาร์เก็ตเฟรม',
    'targetPopup': '<เปิดหน้าจอเล็ก (Pop-up)>',
    'targetPopupName': 'ระบุชื่อหน้าจอเล็ก (Pop-up)',
    'title': 'ลิงค์เชื่อมโยงเว็บ อีเมล์ รูปภาพ หรือไฟล์อื่นๆ',
    'toAnchor': 'จุดเชื่อมโยง (Anchor)',
    'toEmail': 'ส่งอีเมล์ (E-Mail)',
    'toUrl': 'ที่อยู่อ้างอิง URL',
    'toolbar': 'แทรก/แก้ไข ลิงค์',
    'type': 'ประเภทของลิงค์',
    'unlink': 'ลบ ลิงค์',
    'upload': 'อัพโหลดไฟล์'
  },
  'list': {
    'bulletedlist': 'ลำดับรายการแบบสัญลักษณ์',
    'numberedlist': 'ลำดับรายการแบบตัวเลข'
  },
  'magicline': {
    'title': 'Insert paragraph here'
  },
  'maximize': {
    'maximize': 'ขยายใหญ่',
    'minimize': 'ย่อขนาด'
  },
  'pastetext': {
    'button': 'วางแบบตัวอักษรธรรมดา',
    'pasteNotification': 'Your browser does not allow you to paste plain text this way. Press %1 to paste.'
  },
  'pastefromword': {
    'confirmCleanup': 'ข้อความที่คุณต้องการวางลงไปเป็นข้อความที่คัดลอกมาจากโปรแกรมไมโครซอฟท์เวิร์ด คุณต้องการล้างค่าข้อความดังกล่าวก่อนวางลงไปหรือไม่?',
    'error': 'ไม่สามารถล้างข้อมูลที่ต้องการวางได้เนื่องจากเกิดข้อผิดพลาดภายในระบบ',
    'title': 'วางสำเนาจากตัวอักษรเวิร์ด',
    'toolbar': 'วางสำเนาจากตัวอักษรเวิร์ด'
  },
  'removeformat': {
    'toolbar': 'ล้างรูปแบบ'
  },
  'sourcearea': {
    'toolbar': 'ดูรหัส HTML'
  },
  'specialchar': {
    'options': 'Special Character Options',
    'title': 'แทรกตัวอักษรพิเศษ',
    'toolbar': 'แทรกตัวอักษรพิเศษ'
  },
  'scayt': {
    'btn_about': 'About SCAYT',
    'btn_dictionaries': 'Dictionaries',
    'btn_disable': 'Disable SCAYT',
    'btn_enable': 'Enable SCAYT',
    'btn_langs': 'Languages',
    'btn_options': 'Options',
    'text_title': 'Spell Check As You Type'
  },
  'stylescombo': {
    'label': 'ลักษณะ',
    'panelTitle': 'Formatting Styles',
    'panelTitle1': 'Block Styles',
    'panelTitle2': 'Inline Styles',
    'panelTitle3': 'Object Styles'
  },
  'table': {
    'border': 'ขนาดเส้นขอบ',
    'caption': 'หัวเรื่องของตาราง',
    'cell': {
      'menu': 'ช่องตาราง',
      'insertBefore': 'Insert Cell Before',
      'insertAfter': 'Insert Cell After',
      'deleteCell': 'ลบช่อง',
      'merge': 'ผสานช่อง',
      'mergeRight': 'Merge Right',
      'mergeDown': 'Merge Down',
      'splitHorizontal': 'Split Cell Horizontally',
      'splitVertical': 'Split Cell Vertically',
      'title': 'Cell Properties',
      'cellType': 'Cell Type',
      'rowSpan': 'Rows Span',
      'colSpan': 'Columns Span',
      'wordWrap': 'Word Wrap',
      'hAlign': 'Horizontal Alignment',
      'vAlign': 'Vertical Alignment',
      'alignBaseline': 'Baseline',
      'bgColor': 'Background Color',
      'borderColor': 'Border Color',
      'data': 'Data',
      'header': 'Header',
      'yes': 'Yes',
      'no': 'No',
      'invalidWidth': 'Cell width must be a number.',
      'invalidHeight': 'Cell height must be a number.',
      'invalidRowSpan': 'Rows span must be a whole number.',
      'invalidColSpan': 'Columns span must be a whole number.',
      'chooseColor': 'Choose'
    },
    'cellPad': 'ระยะแนวตั้ง',
    'cellSpace': 'ระยะแนวนอนน',
    'column': {
      'menu': 'คอลัมน์',
      'insertBefore': 'Insert Column Before',
      'insertAfter': 'Insert Column After',
      'deleteColumn': 'ลบสดมน์'
    },
    'columns': 'สดมน์',
    'deleteTable': 'ลบตาราง',
    'headers': 'ส่วนหัว',
    'headersBoth': 'ทั้งสองอย่าง',
    'headersColumn': 'คอลัมน์แรก',
    'headersNone': 'None',
    'headersRow': 'แถวแรก',
    'invalidBorder': 'ขนาดเส้นกรอบต้องเป็นจำนวนตัวเลข',
    'invalidCellPadding': 'ช่องว่างภายในเซลล์ต้องเลขจำนวนบวก',
    'invalidCellSpacing': 'ช่องว่างภายในเซลล์ต้องเป็นเลขจำนวนบวก',
    'invalidCols': 'จำนวนคอลัมน์ต้องเป็นจำนวนมากกว่า 0',
    'invalidHeight': 'ส่วนสูงของตารางต้องเป็นตัวเลข',
    'invalidRows': 'จำนวนของแถวต้องเป็นจำนวนมากกว่า 0',
    'invalidWidth': 'ความกว้างตารางต้องเป็นตัวเลข',
    'menu': 'คุณสมบัติของ ตาราง',
    'row': {
      'menu': 'แถว',
      'insertBefore': 'Insert Row Before',
      'insertAfter': 'Insert Row After',
      'deleteRow': 'ลบแถว'
    },
    'rows': 'แถว',
    'summary': 'สรุปความ',
    'title': 'คุณสมบัติของ ตาราง',
    'toolbar': 'ตาราง',
    'widthPc': 'เปอร์เซ็น',
    'widthPx': 'จุดสี',
    'widthUnit': 'หน่วยความกว้าง'
  },
  'undo': {
    'redo': 'ทำซ้ำคำสั่ง',
    'undo': 'ยกเลิกคำสั่ง'
  },
  'wsc': {
    'btnIgnore': 'ยกเว้น',
    'btnIgnoreAll': 'ยกเว้นทั้งหมด',
    'btnReplace': 'แทนที่',
    'btnReplaceAll': 'แทนที่ทั้งหมด',
    'btnUndo': 'ยกเลิก',
    'changeTo': 'แก้ไขเป็น',
    'errorLoading': 'Error loading application service host: %s.',
    'ieSpellDownload': 'ไม่ได้ติดตั้งระบบตรวจสอบคำสะกด. ต้องการติดตั้งไหมครับ?',
    'manyChanges': 'ตรวจสอบคำสะกดเสร็จสิ้น:: แก้ไข %1 คำ',
    'noChanges': 'ตรวจสอบคำสะกดเสร็จสิ้น: ไม่มีการแก้คำใดๆ',
    'noMispell': 'ตรวจสอบคำสะกดเสร็จสิ้น: ไม่พบคำสะกดผิด',
    'noSuggestions': '- ไม่มีคำแนะนำใดๆ -',
    'notAvailable': 'Sorry, but service is unavailable now.',
    'notInDic': 'ไม่พบในดิกชันนารี',
    'oneChange': 'ตรวจสอบคำสะกดเสร็จสิ้น: แก้ไข1คำ',
    'progress': 'กำลังตรวจสอบคำสะกด...',
    'title': 'Spell Checker',
    'toolbar': 'ตรวจการสะกดคำ'
  }
};


/***/ }),
/* 259 */
/***/ (function(module, exports) {

CKEDITOR.lang['vn'] = {
  'editor': 'Bộ soạn thảo văn bản có định dạng',
  'editorPanel': 'Bảng điều khiển Rich Text Editor',
  'common': {
    'editorHelp': 'Nhấn ALT + 0 để được giúp đỡ',
    'browseServer': 'Duyệt máy chủ',
    'url': 'URL',
    'protocol': 'Giao thức',
    'upload': 'Tải lên',
    'uploadSubmit': 'Tải lên máy chủ',
    'image': 'Hình ảnh',
    'flash': 'Flash',
    'form': 'Biểu mẫu',
    'checkbox': 'Nút kiểm',
    'radio': 'Nút chọn',
    'textField': 'Trường văn bản',
    'textarea': 'Vùng văn bản',
    'hiddenField': 'Trường ẩn',
    'button': 'Nút',
    'select': 'Ô chọn',
    'imageButton': 'Nút hình ảnh',
    'notSet': '<không thiết lập>',
    'id': 'Định danh',
    'name': 'Tên',
    'langDir': 'Hướng ngôn ngữ',
    'langDirLtr': 'Trái sang phải (LTR)',
    'langDirRtl': 'Phải sang trái (RTL)',
    'langCode': 'Mã ngôn ngữ',
    'longDescr': 'Mô tả URL',
    'cssClass': 'Lớp Stylesheet',
    'advisoryTitle': 'Nhan đề hướng dẫn',
    'cssStyle': 'Kiểu ',
    'ok': 'Đồng ý',
    'cancel': 'Bỏ qua',
    'close': 'Đóng',
    'preview': 'Xem trước',
    'resize': 'Kéo rê để thay đổi kích cỡ',
    'generalTab': 'Tab chung',
    'advancedTab': 'Tab mở rộng',
    'validateNumberFailed': 'Giá trị này không phải là số.',
    'confirmNewPage': 'Mọi thay đổi không được lưu lại, nội dung này sẽ bị mất. Bạn có chắc chắn muốn tải một trang mới?',
    'confirmCancel': 'Một vài tùy chọn đã bị thay đổi. Bạn có chắc chắn muốn đóng hộp thoại?',
    'options': 'Tùy chọn',
    'target': 'Đích đến',
    'targetNew': 'Cửa sổ mới (_blank)',
    'targetTop': 'Cửa sổ trên cùng (_top)',
    'targetSelf': 'Tại trang (_self)',
    'targetParent': 'Cửa sổ cha (_parent)',
    'langDirLTR': 'Trái sang phải (LTR)',
    'langDirRTL': 'Phải sang trái (RTL)',
    'styles': 'Kiểu',
    'cssClasses': 'Lớp CSS',
    'width': 'Chiều rộng',
    'height': 'Chiều cao',
    'align': 'Vị trí',
    'alignLeft': 'Trái',
    'alignRight': 'Phải',
    'alignCenter': 'Giữa',
    'alignJustify': 'Sắp chữ',
    'alignTop': 'Trên',
    'alignMiddle': 'Giữa',
    'alignBottom': 'Dưới',
    'alignNone': 'Không',
    'invalidValue': 'Giá trị không hợp lệ.',
    'invalidHeight': 'Chiều cao phải là số nguyên.',
    'invalidWidth': 'Chiều rộng phải là số nguyên.',
    'invalidCssLength': 'Giá trị quy định cho trường "%1" phải là một số dương có hoặc không có một đơn vị đo CSS hợp lệ (px, %, in, cm, mm, em, ex, pt, hoặc pc).',
    'invalidHtmlLength': 'Giá trị quy định cho trường "%1" phải là một số dương có hoặc không có một đơn vị đo HTML hợp lệ (px hoặc %).',
    'invalidInlineStyle': 'Giá trị quy định cho kiểu nội tuyến phải bao gồm một hoặc nhiều dữ liệu với định dạng "tên:giá trị", cách nhau bằng dấu chấm phẩy.',
    'cssLengthTooltip': 'Nhập một giá trị theo pixel hoặc một số với một đơn vị CSS hợp lệ (px, %, in, cm, mm, em, ex, pt, hoặc pc).',
    'unavailable': '%1<span class="cke_accessibility">, không có</span>',
    'keyboard': {
      '8': 'Phím Backspace',
      '13': 'Enter',
      '16': 'Shift',
      '17': 'Ctrl',
      '18': 'Alt',
      '32': 'Space',
      '35': 'End',
      '36': 'Home',
      '46': 'Xóa',
      '224': 'Command'
    },
    'keyboardShortcut': 'Keyboard shortcut'
  },
  'about': {
    'copy': 'Bản quyền &copy; $1. Giữ toàn quyền.',
    'dlgTitle': 'Thông tin về CKEditor',
    'help': 'Kiểm tra $1 để được giúp đỡ.',
    'moreInfo': 'Vui lòng ghé thăm trang web của chúng tôi để có thông tin về giấy phép:',
    'title': 'Thông tin về CKEditor',
    'userGuide': 'Hướng dẫn sử dụng CKEditor'
  },
  'basicstyles': {
    'bold': 'Đậm',
    'italic': 'Nghiêng',
    'strike': 'Gạch xuyên ngang',
    'subscript': 'Chỉ số dưới',
    'superscript': 'Chỉ số trên',
    'underline': 'Gạch chân'
  },
  'blockquote': {
    'toolbar': 'Khối trích dẫn'
  },
  'notification': {
    'closed': 'Notification closed.'
  },
  'button': {
    'selectedLabel': '%1 (Đã chọn)'
  },
  'toolbar': {
    'toolbarCollapse': 'Thu gọn thanh công cụ',
    'toolbarExpand': 'Mở rộng thnah công cụ',
    'toolbarGroups': {
      'document': 'Tài liệu',
      'clipboard': 'Clipboard/Undo',
      'editing': 'Chỉnh sửa',
      'forms': 'Bảng biểu',
      'basicstyles': 'Kiểu cơ bản',
      'paragraph': 'Đoạn',
      'links': 'Liên kết',
      'insert': 'Chèn',
      'styles': 'Kiểu',
      'colors': 'Màu sắc',
      'tools': 'Công cụ'
    },
    'toolbars': 'Thanh công cụ'
  },
  'clipboard': {
    'copy': 'Sao chép',
    'copyError': 'Các thiết lập bảo mật của trình duyệt không cho phép trình biên tập tự động thực thi lệnh sao chép. Hãy sử dụng bàn phím cho lệnh này (Ctrl/Cmd+C).',
    'cut': 'Cắt',
    'cutError': 'Các thiết lập bảo mật của trình duyệt không cho phép trình biên tập tự động thực thi lệnh cắt. Hãy sử dụng bàn phím cho lệnh này (Ctrl/Cmd+X).',
    'paste': 'Dán',
    'pasteNotification': 'Your browser doesn\'t allow you to paste this way. Press %1 to paste.'
  },
  'contextmenu': {
    'options': 'Tùy chọn menu bổ xung'
  },
  'elementspath': {
    'eleLabel': 'Nhãn thành phần',
    'eleTitle': '%1 thành phần'
  },
  'format': {
    'label': 'Định dạng',
    'panelTitle': 'Định dạng',
    'tag_address': 'Address',
    'tag_div': 'Bình thường (DIV)',
    'tag_h1': 'Heading 1',
    'tag_h2': 'Heading 2',
    'tag_h3': 'Heading 3',
    'tag_h4': 'Heading 4',
    'tag_h5': 'Heading 5',
    'tag_h6': 'Heading 6',
    'tag_p': 'Bình thường (P)',
    'tag_pre': 'Đã thiết lập'
  },
  'horizontalrule': {
    'toolbar': 'Chèn đường phân cách ngang'
  },
  'image': {
    'alt': 'Chú thích ảnh',
    'border': 'Đường viền',
    'btnUpload': 'Tải lên máy chủ',
    'button2Img': 'Bạn có muốn chuyển nút bấm bằng ảnh được chọn thành ảnh?',
    'hSpace': 'Khoảng đệm ngang',
    'img2Button': 'Bạn có muốn chuyển đổi ảnh được chọn thành nút bấm bằng ảnh?',
    'infoTab': 'Thông tin của ảnh',
    'linkTab': 'Tab liên kết',
    'lockRatio': 'Giữ nguyên tỷ lệ',
    'menu': 'Thuộc tính của ảnh',
    'resetSize': 'Kích thước gốc',
    'title': 'Thuộc tính của ảnh',
    'titleButton': 'Thuộc tính nút của ảnh',
    'upload': 'Tải lên',
    'urlMissing': 'Thiếu đường dẫn hình ảnh',
    'vSpace': 'Khoảng đệm dọc',
    'validateBorder': 'Chiều rộng của đường viền phải là một số nguyên dương',
    'validateHSpace': 'Khoảng đệm ngang phải là một số nguyên dương',
    'validateVSpace': 'Khoảng đệm dọc phải là một số nguyên dương'
  },
  'indent': {
    'indent': 'Dịch vào trong',
    'outdent': 'Dịch ra ngoài'
  },
  'fakeobjects': {
    'anchor': 'Điểm neo',
    'flash': 'Flash',
    'hiddenfield': 'Trường ẩn',
    'iframe': 'IFrame',
    'unknown': 'Đối tượng không rõ ràng'
  },
  'link': {
    'acccessKey': 'Phím hỗ trợ truy cập',
    'advanced': 'Mở rộng',
    'advisoryContentType': 'Nội dung hướng dẫn',
    'advisoryTitle': 'Nhan đề hướng dẫn',
    'anchor': {
      'toolbar': 'Chèn/Sửa điểm neo',
      'menu': 'Thuộc tính điểm neo',
      'title': 'Thuộc tính điểm neo',
      'name': 'Tên của điểm neo',
      'errorName': 'Hãy nhập vào tên của điểm neo',
      'remove': 'Xóa neo'
    },
    'anchorId': 'Theo định danh thành phần',
    'anchorName': 'Theo tên điểm neo',
    'charset': 'Bảng mã của tài nguyên được liên kết đến',
    'cssClasses': 'Lớp Stylesheet',
    'download': 'Force Download',
    'displayText': 'Display Text',
    'emailAddress': 'Thư điện tử',
    'emailBody': 'Nội dung thông điệp',
    'emailSubject': 'Tiêu đề thông điệp',
    'id': 'Định danh',
    'info': 'Thông tin liên kết',
    'langCode': 'Mã ngôn ngữ',
    'langDir': 'Hướng ngôn ngữ',
    'langDirLTR': 'Trái sang phải (LTR)',
    'langDirRTL': 'Phải sang trái (RTL)',
    'menu': 'Sửa liên kết',
    'name': 'Tên',
    'noAnchors': '(Không có điểm neo nào trong tài liệu)',
    'noEmail': 'Hãy đưa vào địa chỉ thư điện tử',
    'noUrl': 'Hãy đưa vào đường dẫn liên kết (URL)',
    'other': '<khác>',
    'popupDependent': 'Phụ thuộc (Netscape)',
    'popupFeatures': 'Đặc điểm của cửa sổ Popup',
    'popupFullScreen': 'Toàn màn hình (IE)',
    'popupLeft': 'Vị trí bên trái',
    'popupLocationBar': 'Thanh vị trí',
    'popupMenuBar': 'Thanh Menu',
    'popupResizable': 'Có thể thay đổi kích cỡ',
    'popupScrollBars': 'Thanh cuộn',
    'popupStatusBar': 'Thanh trạng thái',
    'popupToolbar': 'Thanh công cụ',
    'popupTop': 'Vị trí phía trên',
    'rel': 'Quan hệ',
    'selectAnchor': 'Chọn một điểm neo',
    'styles': 'Kiểu (style)',
    'tabIndex': 'Chỉ số của Tab',
    'target': 'Đích',
    'targetFrame': '<khung>',
    'targetFrameName': 'Tên khung đích',
    'targetPopup': '<cửa sổ popup>',
    'targetPopupName': 'Tên cửa sổ Popup',
    'title': 'Liên kết',
    'toAnchor': 'Neo trong trang này',
    'toEmail': 'Thư điện tử',
    'toUrl': 'URL',
    'toolbar': 'Chèn/Sửa liên kết',
    'type': 'Kiểu liên kết',
    'unlink': 'Xoá liên kết',
    'upload': 'Tải lên'
  },
  'list': {
    'bulletedlist': 'Chèn/Xoá Danh sách không thứ tự',
    'numberedlist': 'Chèn/Xoá Danh sách có thứ tự'
  },
  'magicline': {
    'title': 'Chèn đoạn vào đây'
  },
  'maximize': {
    'maximize': 'Phóng to tối đa',
    'minimize': 'Thu nhỏ'
  },
  'pastetext': {
    'button': 'Dán theo định dạng văn bản thuần',
    'pasteNotification': 'Your browser does not allow you to paste plain text this way. Press %1 to paste.'
  },
  'pastefromword': {
    'confirmCleanup': 'Văn bản bạn muốn dán có kèm định dạng của Word. Bạn có muốn loại bỏ định dạng Word trước khi dán?',
    'error': 'Không thể để làm sạch các dữ liệu dán do một lỗi nội bộ',
    'title': 'Dán với định dạng Word',
    'toolbar': 'Dán với định dạng Word'
  },
  'removeformat': {
    'toolbar': 'Xoá định dạng'
  },
  'sourcearea': {
    'toolbar': 'Mã HTML'
  },
  'specialchar': {
    'options': 'Tùy chọn các ký tự đặc biệt',
    'title': 'Hãy chọn ký tự đặc biệt',
    'toolbar': 'Chèn ký tự đặc biệt'
  },
  'scayt': {
    'btn_about': 'Thông tin về SCAYT',
    'btn_dictionaries': 'Từ điển',
    'btn_disable': 'Tắt SCAYT',
    'btn_enable': 'Bật SCAYT',
    'btn_langs': 'Ngôn ngữ',
    'btn_options': 'Tùy chọn',
    'text_title': 'Kiểm tra chính tả ngay khi gõ chữ (SCAYT)'
  },
  'stylescombo': {
    'label': 'Kiểu',
    'panelTitle': 'Phong cách định dạng',
    'panelTitle1': 'Kiểu khối',
    'panelTitle2': 'Kiểu trực tiếp',
    'panelTitle3': 'Kiểu đối tượng'
  },
  'table': {
    'border': 'Kích thước đường viền',
    'caption': 'Đầu đề',
    'cell': {
      'menu': 'Ô',
      'insertBefore': 'Chèn ô Phía trước',
      'insertAfter': 'Chèn ô Phía sau',
      'deleteCell': 'Xoá ô',
      'merge': 'Kết hợp ô',
      'mergeRight': 'Kết hợp sang phải',
      'mergeDown': 'Kết hợp xuống dưới',
      'splitHorizontal': 'Phân tách ô theo chiều ngang',
      'splitVertical': 'Phân tách ô theo chiều dọc',
      'title': 'Thuộc tính của ô',
      'cellType': 'Kiểu của ô',
      'rowSpan': 'Kết hợp hàng',
      'colSpan': 'Kết hợp cột',
      'wordWrap': 'Chữ liền hàng',
      'hAlign': 'Canh lề ngang',
      'vAlign': 'Canh lề dọc',
      'alignBaseline': 'Đường cơ sở',
      'bgColor': 'Màu nền',
      'borderColor': 'Màu viền',
      'data': 'Dữ liệu',
      'header': 'Đầu đề',
      'yes': 'Có',
      'no': 'Không',
      'invalidWidth': 'Chiều rộng của ô phải là một số nguyên.',
      'invalidHeight': 'Chiều cao của ô phải là một số nguyên.',
      'invalidRowSpan': 'Số hàng kết hợp phải là một số nguyên.',
      'invalidColSpan': 'Số cột kết hợp phải là một số nguyên.',
      'chooseColor': 'Chọn màu'
    },
    'cellPad': 'Khoảng đệm giữ ô và nội dung',
    'cellSpace': 'Khoảng cách giữa các ô',
    'column': {
      'menu': 'Cột',
      'insertBefore': 'Chèn cột phía trước',
      'insertAfter': 'Chèn cột phía sau',
      'deleteColumn': 'Xoá cột'
    },
    'columns': 'Số cột',
    'deleteTable': 'Xóa bảng',
    'headers': 'Đầu đề',
    'headersBoth': 'Cả hai',
    'headersColumn': 'Cột đầu tiên',
    'headersNone': 'Không có',
    'headersRow': 'Hàng đầu tiên',
    'invalidBorder': 'Kích cỡ của đường biên phải là một số nguyên.',
    'invalidCellPadding': 'Khoảng đệm giữa ô và nội dung phải là một số nguyên.',
    'invalidCellSpacing': 'Khoảng cách giữa các ô phải là một số nguyên.',
    'invalidCols': 'Số lượng cột phải là một số lớn hơn 0.',
    'invalidHeight': 'Chiều cao của bảng phải là một số nguyên.',
    'invalidRows': 'Số lượng hàng phải là một số lớn hơn 0.',
    'invalidWidth': 'Chiều rộng của bảng phải là một số nguyên.',
    'menu': 'Thuộc tính bảng',
    'row': {
      'menu': 'Hàng',
      'insertBefore': 'Chèn hàng phía trước',
      'insertAfter': 'Chèn hàng phía sau',
      'deleteRow': 'Xoá hàng'
    },
    'rows': 'Số hàng',
    'summary': 'Tóm lược',
    'title': 'Thuộc tính bảng',
    'toolbar': 'Bảng',
    'widthPc': 'Phần trăm (%)',
    'widthPx': 'Điểm ảnh (px)',
    'widthUnit': 'Đơn vị'
  },
  'undo': {
    'redo': 'Làm lại thao tác',
    'undo': 'Khôi phục thao tác'
  },
  'wsc': {
    'btnIgnore': 'Bỏ qua',
    'btnIgnoreAll': 'Bỏ qua tất cả',
    'btnReplace': 'Thay thế',
    'btnReplaceAll': 'Thay thế tất cả',
    'btnUndo': 'Phục hồi lại',
    'changeTo': 'Chuyển thành',
    'errorLoading': 'Lỗi khi đang nạp dịch vụ ứng dụng: %s.',
    'ieSpellDownload': 'Chức năng kiểm tra chính tả chưa được cài đặt. Bạn có muốn tải về ngay bây giờ?',
    'manyChanges': 'Hoàn tất kiểm tra chính tả: %1 từ đã được thay đổi',
    'noChanges': 'Hoàn tất kiểm tra chính tả: Không có từ nào được thay đổi',
    'noMispell': 'Hoàn tất kiểm tra chính tả: Không có lỗi chính tả',
    'noSuggestions': '- Không đưa ra gợi ý về từ -',
    'notAvailable': 'Xin lỗi, dịch vụ này hiện tại không có.',
    'notInDic': 'Không có trong từ điển',
    'oneChange': 'Hoàn tất kiểm tra chính tả: Một từ đã được thay đổi',
    'progress': 'Đang tiến hành kiểm tra chính tả...',
    'title': 'Kiểm tra chính tả',
    'toolbar': 'Kiểm tra chính tả'
  }
};


/***/ }),
/* 260 */
/***/ (function(module, exports) {


/**
 * Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or http://ckeditor.com/license
 */
CKEDITOR.stylesSet.add('default', [
  {
    name: 'Italic Title',
    element: 'h2',
    styles: {
      'font-style': 'italic'
    }
  }, {
    name: 'Subtitle',
    element: 'h3',
    styles: {
      'color': '#aaa',
      'font-style': 'italic'
    }
  }, {
    name: 'Special Container',
    element: 'div',
    styles: {
      padding: '5px 10px',
      background: '#eee',
      border: '1px solid #ccc'
    }
  }, {
    name: 'Marker',
    element: 'span',
    attributes: {
      'class': 'marker'
    }
  }, {
    name: 'Big',
    element: 'big'
  }, {
    name: 'Small',
    element: 'small'
  }, {
    name: 'Typewriter',
    element: 'tt'
  }, {
    name: 'Computer Code',
    element: 'code'
  }, {
    name: 'Keyboard Phrase',
    element: 'kbd'
  }, {
    name: 'Sample Text',
    element: 'samp'
  }, {
    name: 'Variable',
    element: 'var'
  }, {
    name: 'Deleted Text',
    element: 'del'
  }, {
    name: 'Inserted Text',
    element: 'ins'
  }, {
    name: 'Cited Work',
    element: 'cite'
  }, {
    name: 'Inline Quotation',
    element: 'q'
  }, {
    name: 'Language: RTL',
    element: 'span',
    attributes: {
      'dir': 'rtl'
    }
  }, {
    name: 'Language: LTR',
    element: 'span',
    attributes: {
      'dir': 'ltr'
    }
  }, {
    name: 'Styled image (left)',
    element: 'img',
    attributes: {
      'class': 'left'
    }
  }, {
    name: 'Styled image (right)',
    element: 'img',
    attributes: {
      'class': 'right'
    }
  }, {
    name: 'Compact table',
    element: 'table',
    attributes: {
      cellpadding: '5',
      cellspacing: '0',
      border: '1',
      bordercolor: '#ccc'
    },
    styles: {
      'border-collapse': 'collapse'
    }
  }, {
    name: 'Borderless Table',
    element: 'table',
    styles: {
      'border-style': 'hidden',
      'background-color': '#E6E6FA'
    }
  }, {
    name: 'Square Bulleted List',
    element: 'ul',
    styles: {
      'list-style-type': 'square'
    }
  }
]);


/***/ }),
/* 261 */
/***/ (function(module, exports) {

var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

angular.module("siter.io").controller("EditEmailTemplateController", [
  "$scope", "$rootScope", "$modalInstance", "Email", "Translit", "FileUploader", "Restangular", "$state", "$cookies", "template", "$http", "mainTemplate", function($scope, $rootScope, $modalInstance, Email, Translit, FileUploader, Restangular, $state, $cookies, template, $http, mainTemplate) {
    $scope.site = template;
    $scope.mainTemplate = mainTemplate;
    $scope.site.tags = _.map($scope.site.tags.split(","), function(tag, index) {
      return {
        text: tag,
        id: index
      };
    });
    $scope.site.colors = _.map($scope.site.colors, function(tag, index) {
      return {
        text: tag,
        id: index
      };
    });
    $scope.transliterate = function(text, entorus) {
      if (entorus == null) {
        entorus = false;
      }
      return Translit.one(text, entorus);
    };
    $scope.transliterate_3 = function(text, entorus) {
      if (entorus == null) {
        entorus = false;
      }
      return Translit.three(text, entorus);
    };
    Restangular.all('/email_templates/tags').getList().then(function(items) {
      return $scope.items = _.map(items, function(item, index) {
        return {
          text: item,
          id: index
        };
      });
    });
    $scope.loadTags = function(query) {
      return Restangular.all('/email_templates/tags').getList();
    };
    $scope.loadColorTags = function(query) {
      return Restangular.all("/email_templates/color_tags?q=" + query).getList();
    };
    $scope.landing = {};
    $scope.cancel = function() {
      return $modalInstance.dismiss("cancel");
    };
    $scope.clone = function() {
      $scope.cloning = true;
      return Email.clone(template.id).then(function(data) {
        $scope.cloning = false;
        $scope.close();
        return $rootScope.$broadcast("site:created", data, template);
      });
    };
    $scope.webPreviewUploader = new FileUploader({
      url: Restangular.configuration.baseUrl + ("/emails/" + template.id),
      autoUpload: false,
      method: "PUT",
      alias: "preview",
      headers: {
        'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
      }
    });
    $scope.webPreviewUploader.onAfterAddingFile = function(item) {
      var ref, types;
      types = ["image/jpeg", "image/png"];
      if (ref = item.file.type, indexOf.call(types, ref) < 0) {
        alert("The file must be png or jpg");
        return false;
      }
    };
    $scope.webPreviewUploader.onSuccessItem = function(fileItem, response, status, headers) {
      template.preview = response.preview;
      $scope.webPreviewUploader.clearQueue();
    };
    $scope.webPreviewUploader.onErrorItem = function(fileItem, response, status, headers) {};
    $scope.mobilePreviewUploader = new FileUploader({
      url: Restangular.configuration.baseUrl + ("/emails/" + template.id),
      autoUpload: false,
      method: "PUT",
      alias: "mobile_preview",
      headers: {
        'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
      }
    });
    $scope.mobilePreviewUploader.onAfterAddingFile = function(item) {
      var ref, types;
      types = ["image/jpeg", "image/png"];
      if (ref = item.file.type, indexOf.call(types, ref) < 0) {
        alert("The file must be png or jpg");
        return false;
      }
    };
    $scope.mobilePreviewUploader.onSuccessItem = function(fileItem, response, status, headers) {
      template.mobile_preview = response.mobile_preview;
      $scope.mobilePreviewUploader.clearQueue();
    };
    $scope.mobilePreviewUploader.onErrorItem = function(fileItem, response, status, headers) {};
    $scope.saving = false;
    $scope.saveTemplate = function(land, editTemplateForm) {
      if (editTemplateForm.$invalid) {
        return false;
      }
      $scope.saving = true;
      land = angular.copy(land);
      land.is_template = true;
      land.tags = _.map(land.tags, function(tag) {
        return tag.text;
      });
      land.tags = land.tags.join(",");
      land.colors = _.map(land.colors, function(tag) {
        return tag.text;
      });
      return Email.update(land).then(function(new_site) {
        $scope.saving = false;
        $scope.mobilePreviewUploader.uploadAll();
        $scope.webPreviewUploader.uploadAll();
        $scope.close();
        return $rootScope.$broadcast("email:updated");
      }, function(errors) {
        $scope.errors = errors.data.errors;
        return $scope.saving = false;
      });
    };
    return $scope.close = function() {
      return $modalInstance.dismiss("close");
    };
  }
]);


/***/ }),
/* 262 */
/***/ (function(module, exports) {

var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

angular.module("siter.io").controller("NewEmailTemplateController", [
  "$scope", "$rootScope", "$modalInstance", "Email", "Translit", "FileUploader", "Restangular", "$state", "$cookies", function($scope, $rootScope, $modalInstance, Email, Translit, FileUploader, Restangular, $state, $cookies) {
    var setUploadUrls;
    $scope.transliterate = function(text, entorus) {
      if (entorus == null) {
        entorus = false;
      }
      return Translit.one(text, entorus);
    };
    $scope.transliterate_3 = function(text, entorus) {
      if (entorus == null) {
        entorus = false;
      }
      return Translit.three(text, entorus);
    };
    Restangular.all('/email_templates/tags').getList().then(function(items) {
      return $scope.items = _.map(items, function(item, index) {
        return {
          text: item,
          id: index
        };
      });
    });
    $scope.loadTags = function(query) {
      return Restangular.all("/email_templates/tags?q=" + query).getList();
    };
    $scope.loadColorTags = function(query) {
      return Restangular.all("/email_templates/color_tags?q=" + query).getList();
    };
    $scope.landing = {};
    $scope.cancel = function() {
      return $modalInstance.dismiss("cancel");
    };
    $scope.webPreviewUploader = new FileUploader({
      url: Restangular.configuration.baseUrl + ("/emails/" + $state.params.siteId),
      autoUpload: false,
      method: "PUT",
      alias: "preview",
      headers: {
        'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
      }
    });
    $scope.webPreviewUploader.onAfterAddingFile = function(item) {
      var ref, types;
      types = ["image/jpeg", "image/png"];
      if (ref = item.file.type, indexOf.call(types, ref) < 0) {
        alert("The file must be png or jpg");
        return false;
      }
    };
    $scope.webPreviewUploader.onSuccessItem = function(fileItem, response, status, headers) {
      $scope.webPreviewUploader.clearQueue();
      $scope.new_site.preview = response.preview;
    };
    $scope.webPreviewUploader.onErrorItem = function(fileItem, response, status, headers) {};
    $scope.mobilePreviewUploader = new FileUploader({
      url: Restangular.configuration.baseUrl + ("/emails/" + $state.params.siteId),
      autoUpload: false,
      method: "PUT",
      alias: "mobile_preview",
      headers: {
        'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
      }
    });
    $scope.mobilePreviewUploader.onAfterAddingFile = function(item) {
      var ref, types;
      types = ["image/jpeg", "image/png"];
      if (ref = item.file.type, indexOf.call(types, ref) < 0) {
        alert("The file must be png or jpg");
        return false;
      }
    };
    $scope.mobilePreviewUploader.onSuccessItem = function(fileItem, response, status, headers) {
      $scope.mobilePreviewUploader.clearQueue();
      $scope.new_site.mobile_preview = response.mobile_preview;
    };
    $scope.mobilePreviewUploader.onErrorItem = function(fileItem, response, status, headers) {};
    setUploadUrls = function(siteId) {
      $scope.mobilePreviewUploader.queue.forEach(function(item) {
        return item.url = Restangular.configuration.baseUrl + ("/emails/" + siteId);
      });
      return $scope.webPreviewUploader.queue.forEach(function(item) {
        return item.url = Restangular.configuration.baseUrl + ("/emails/" + siteId);
      });
    };
    $scope.creating = false;
    $scope.createTemplate = function(land, newTemplateForm) {
      if (newTemplateForm.$invalid) {
        return false;
      }
      $scope.creating = true;
      land.is_template = true;
      land.tags = _.map(land.tags, function(tag) {
        return tag.text;
      });
      land.tags = land.tags.join(",");
      land.colors = _.map(land.colors, function(tag) {
        return tag.text;
      });
      return Email.create(land).then(function(new_site) {
        $scope.new_site = new_site;
        $scope.creating = false;
        setUploadUrls($scope.new_site.id);
        $scope.mobilePreviewUploader.uploadAll();
        $scope.webPreviewUploader.uploadAll();
        $rootScope.$broadcast("email:created", $scope.new_site);
        return $scope.close();
      }, function(errors) {
        $scope.errors = errors.data.errors;
        return $scope.creating = false;
      });
    };
    return $scope.close = function() {
      return $modalInstance.dismiss("close");
    };
  }
]);


/***/ }),
/* 263 */
/***/ (function(module, exports) {

angular.module('siter.io').factory('User', [
  "Restangular", "$stateParams", "$rootScope", "$state", "$cookies", function(Restangular, $stateParams, $rootScope, $state, $cookies) {
    var user;
    user = {
      removeCollaborator: function(collaborator) {
        return Restangular.all("sites").all($stateParams.siteId).all("collaborators").one(collaborator.id).customDELETE();
      },
      me: function() {
        return Restangular.all("users").one("me.json").get();
      },
      save: function(user) {
        return Restangular.all("users").one(user.id).customPUT(user);
      },
      forgotPassword: function(email) {
        return Restangular.all("users").one("password").post(email);
      }
    };
    return user;
  }
]);


/***/ }),
/* 264 */
/***/ (function(module, exports) {

angular.module('siter.io').factory('Auth', [
  "Restangular", "$rootScope", "$stateParams", "$state", "$cookies", "User", "$q", "Site", "$translate", function(Restangular, $rootScope, $stateParams, $state, $cookies, User, $q, Site, $translate) {
    var _ready, auth;
    _ready = $q.defer();
    auth = {
      isReadyLogged: function() {
        var def;
        def = $q.defer();
        _ready.promise.then(function() {
          if (window.justclick.currentUser) {
            def.resolve();
          } else {
            def.reject();
          }
        });
        return def.promise;
      },
      setAuthHeaders: function() {
        return Restangular.setDefaultHeaders({
          "X-AUTH-TOKEN": window.justclick.currentUser.authentication_token
        });
      },
      check: function() {
        this.setAuthHeaders();
        return User.me().then(this.checkSuccess, this.checkFail);
      },
      setCurrentUser: function(data) {
        $rootScope.currentUser = data;
        return window.justclick.currentUser = data;
      },
      checkSuccess: function(dataMe) {
        _ready.resolve();
        auth.setCurrentUser(dataMe);
        $translate.use(dataMe.lang).then(function() {
          return $rootScope.$broadcast("translations:loaded");
        });
        Restangular.setDefaultHeaders({
          "X-AUTH-TOKEN": dataMe.authentication_token
        });
        $cookies.put("auth_token", dataMe.authentication_token);
        return $rootScope.$broadcast("current:user");
      },
      checkFail: function() {
        _ready.resolve();
        if (!$state.current.auth) {
          return false;
        }
        return $state.go("public.home");
      },
      projects: function(toSetup) {
        if (toSetup == null) {
          toSetup = false;
        }
        return $state.go("admin.dashboard.templates");
      },
      auth: function(credentials) {
        return Restangular.all("users").all("login.json").post(credentials);
      },
      register: function(credentials) {
        return Restangular.all("users.json").post(credentials);
      },
      logout: function() {
        return document.location.href = window.justclick.back_uri;
      }
    };
    return auth;
  }
]);


/***/ }),
/* 265 */
/***/ (function(module, exports) {

var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

angular.module("siter.io").controller("EditTemplateController", [
  "$scope", "$rootScope", "$modalInstance", "Site", "Translit", "FileUploader", "Restangular", "$state", "$cookies", "template", "$http", "mainTemplate", function($scope, $rootScope, $modalInstance, Site, Translit, FileUploader, Restangular, $state, $cookies, template, $http, mainTemplate) {
    $scope.site = template;
    $scope.mainTemplate = mainTemplate;
    $scope.site.tags = _.map($scope.site.tags.split(","), function(tag, index) {
      return {
        text: tag,
        id: index
      };
    });
    $scope.site.colors = _.map($scope.site.colors, function(tag, index) {
      return {
        text: tag,
        id: index
      };
    });
    $scope.transliterate = function(text, entorus) {
      if (entorus == null) {
        entorus = false;
      }
      return Translit.one(text, entorus);
    };
    $scope.transliterate_3 = function(text, entorus) {
      if (entorus == null) {
        entorus = false;
      }
      return Translit.three(text, entorus);
    };
    Restangular.all('/templates/tags').getList().then(function(items) {
      return $scope.items = _.map(items, function(item, index) {
        return {
          text: item,
          id: index
        };
      });
    });
    $scope.loadTags = function(query) {
      return Restangular.all('/templates/tags').getList();
    };
    $scope.loadColorTags = function(query) {
      return Restangular.all("/templates/color_tags?q=" + query).getList();
    };
    $scope.landing = {};
    $scope.cancel = function() {
      return $modalInstance.dismiss("cancel");
    };
    $scope.clone = function() {
      $scope.cloning = true;
      return Site.clone(template.id).then(function(data) {
        $scope.cloning = false;
        $scope.close();
        return $rootScope.$broadcast("site:created", data, template);
      });
    };
    $scope.webPreviewUploader = new FileUploader({
      url: Restangular.configuration.baseUrl + ("/sites/" + template.id),
      autoUpload: false,
      method: "PUT",
      alias: "preview",
      headers: {
        'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
      }
    });
    $scope.webPreviewUploader.onAfterAddingFile = function(item) {
      var ref, types;
      types = ["image/jpeg", "image/png"];
      if (ref = item.file.type, indexOf.call(types, ref) < 0) {
        alert("The file must be png or jpg");
        return false;
      }
    };
    $scope.webPreviewUploader.onSuccessItem = function(fileItem, response, status, headers) {
      template.preview = response.preview;
      $scope.webPreviewUploader.clearQueue();
    };
    $scope.webPreviewUploader.onErrorItem = function(fileItem, response, status, headers) {};
    $scope.mobilePreviewUploader = new FileUploader({
      url: Restangular.configuration.baseUrl + ("/sites/" + template.id),
      autoUpload: false,
      method: "PUT",
      alias: "mobile_preview",
      headers: {
        'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
      }
    });
    $scope.mobilePreviewUploader.onAfterAddingFile = function(item) {
      var ref, types;
      types = ["image/jpeg", "image/png"];
      if (ref = item.file.type, indexOf.call(types, ref) < 0) {
        alert("The file must be png or jpg");
        return false;
      }
    };
    $scope.mobilePreviewUploader.onSuccessItem = function(fileItem, response, status, headers) {
      template.mobile_preview = response.mobile_preview;
      $scope.mobilePreviewUploader.clearQueue();
    };
    $scope.mobilePreviewUploader.onErrorItem = function(fileItem, response, status, headers) {};
    $scope.saving = false;
    $scope.saveTemplate = function(land, editTemplateForm) {
      if (editTemplateForm.$invalid) {
        return false;
      }
      $scope.saving = true;
      land = angular.copy(land);
      land.is_template = true;
      land.tags = _.map(land.tags, function(tag) {
        return tag.text;
      });
      land.tags = land.tags.join(",");
      land.colors = _.map(land.colors, function(tag) {
        return tag.text;
      });
      return Site.update(land).then(function(new_site) {
        template.slug = new_site.slug;
        template.subdomain = new_site.subdomain;
        $scope.saving = false;
        $scope.mobilePreviewUploader.uploadAll();
        $scope.webPreviewUploader.uploadAll();
        $scope.close();
        return $rootScope.$broadcast("site:updated");
      }, function(errors) {
        $scope.errors = errors.data.errors;
        return $scope.saving = false;
      });
    };
    return $scope.close = function() {
      return $modalInstance.dismiss("close");
    };
  }
]);


/***/ }),
/* 266 */
/***/ (function(module, exports) {

angular.module('siter.io').controller('Emails', [
  "$scope", "Restangular", "$modal", "$stateParams", "$state", 'Email', "$rootScope", function($scope, Restangular, $modal, $stateParams, $state, Email, $rootScope) {
    var _getEmailFail, _getEmailSuccess;
    $scope.state = $state;
    _getEmailSuccess = function(siteData) {
      if (siteData.style_attributes) {
        siteData.style_attributes.maxWidth = parseInt(siteData.style_attributes.maxWidth);
      }
      return $rootScope.site = siteData;
    };
    _getEmailFail = function(response) {
      return $state.go("404");
    };
    Email.get().then(_getEmailSuccess, _getEmailFail);
    return angular.element("body").on("keypress", "span[contenteditable]", function(e) {
      return e.which !== 13;
    });
  }
]);


/***/ }),
/* 267 */
/***/ (function(module, exports) {

angular.module('siter.io').controller('Forms', [
  "$scope", "Restangular", "$modal", "$stateParams", "$state", 'WebForm', "$rootScope", function($scope, Restangular, $modal, $stateParams, $state, WebForm, $rootScope) {
    var _getWebFormFail, _getWebFormSuccess;
    $scope.state = $state;
    _getWebFormSuccess = function(siteData) {
      if (siteData.style_attributes) {
        siteData.style_attributes.maxWidth = parseInt(siteData.style_attributes.maxWidth);
      }
      return $rootScope.site = siteData;
    };
    _getWebFormFail = function(response) {
      return $state.go("404");
    };
    WebForm.get().then(_getWebFormSuccess, _getWebFormFail);
    return angular.element("body").on("keypress", "span[contenteditable]", function(e) {
      return e.which !== 13;
    });
  }
]);


/***/ }),
/* 268 */
/***/ (function(module, exports) {

var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

angular.module("siter.io").controller("NewTemplateController", [
  "$scope", "$rootScope", "$modalInstance", "Site", "Translit", "FileUploader", "Restangular", "$state", "$cookies", function($scope, $rootScope, $modalInstance, Site, Translit, FileUploader, Restangular, $state, $cookies) {
    var setUploadUrls;
    $scope.site = {
      disabled: true
    };
    $scope.transliterate = function(text, entorus) {
      if (entorus == null) {
        entorus = false;
      }
      return Translit.one(text, entorus);
    };
    $scope.transliterate_3 = function(text, entorus) {
      if (entorus == null) {
        entorus = false;
      }
      return Translit.three(text, entorus);
    };
    Restangular.all('/templates/tags').getList().then(function(items) {
      return $scope.items = _.map(items, function(item, index) {
        return {
          text: item,
          id: index
        };
      });
    });
    $scope.loadTags = function(query) {
      return Restangular.all("/templates/tags?q=" + query).getList();
    };
    $scope.loadColorTags = function(query) {
      return Restangular.all("/templates/color_tags?q=" + query).getList();
    };
    $scope.landing = {};
    $scope.cancel = function() {
      return $modalInstance.dismiss("cancel");
    };
    $scope.webPreviewUploader = new FileUploader({
      url: Restangular.configuration.baseUrl + ("/sites/" + $state.params.siteId),
      autoUpload: false,
      method: "PUT",
      alias: "preview",
      headers: {
        'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
      }
    });
    $scope.webPreviewUploader.onAfterAddingFile = function(item) {
      var ref, types;
      types = ["image/jpeg", "image/png"];
      if (ref = item.file.type, indexOf.call(types, ref) < 0) {
        alert("The file must be png or jpg");
        return false;
      }
    };
    $scope.webPreviewUploader.onSuccessItem = function(fileItem, response, status, headers) {
      $scope.webPreviewUploader.clearQueue();
      $scope.new_site.preview = response.preview;
    };
    $scope.webPreviewUploader.onErrorItem = function(fileItem, response, status, headers) {};
    $scope.mobilePreviewUploader = new FileUploader({
      url: Restangular.configuration.baseUrl + ("/sites/" + $state.params.siteId),
      autoUpload: false,
      method: "PUT",
      alias: "mobile_preview",
      headers: {
        'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
      }
    });
    $scope.mobilePreviewUploader.onAfterAddingFile = function(item) {
      var ref, types;
      types = ["image/jpeg", "image/png"];
      if (ref = item.file.type, indexOf.call(types, ref) < 0) {
        alert("The file must be png or jpg");
        return false;
      }
    };
    $scope.mobilePreviewUploader.onSuccessItem = function(fileItem, response, status, headers) {
      $scope.mobilePreviewUploader.clearQueue();
      $scope.new_site.mobile_preview = response.mobile_preview;
    };
    $scope.mobilePreviewUploader.onErrorItem = function(fileItem, response, status, headers) {};
    setUploadUrls = function(siteId) {
      $scope.mobilePreviewUploader.queue.forEach(function(item) {
        return item.url = Restangular.configuration.baseUrl + ("/sites/" + siteId);
      });
      return $scope.webPreviewUploader.queue.forEach(function(item) {
        return item.url = Restangular.configuration.baseUrl + ("/sites/" + siteId);
      });
    };
    $scope.creating = false;
    $scope.createTemplate = function(land, newTemplateForm) {
      if (newTemplateForm.$invalid) {
        return false;
      }
      $scope.creating = true;
      land.is_template = true;
      land.tags = _.map(land.tags, function(tag) {
        return tag.text;
      });
      land.tags = land.tags.join(",");
      land.colors = _.map(land.colors, function(tag) {
        return tag.text;
      });
      return Site.create(land).then(function(new_site) {
        $scope.new_site = new_site;
        $scope.creating = false;
        setUploadUrls($scope.new_site.id);
        $scope.mobilePreviewUploader.uploadAll();
        $scope.webPreviewUploader.uploadAll();
        $rootScope.$broadcast("site:created", $scope.new_site);
        return $scope.close();
      }, function(errors) {
        $scope.errors = errors.data.errors;
        return $scope.creating = false;
      });
    };
    return $scope.close = function() {
      return $modalInstance.dismiss("close");
    };
  }
]);


/***/ }),
/* 269 */
/***/ (function(module, exports) {

angular.module('siter.io').factory('Templates', [
  "Restangular", "$rootScope", "$stateParams", "$state", function(Restangular, $rootScope, $stateParams, $state) {
    'use strict';
    var templates;
    templates = {
      getAll: function(category) {
        return Restangular.one("templates.json").get({
          tag: category
        });
      },
      get: function() {
        return Restangular.all("templates").one($state.params.templateSlug + ".json").get();
      },
      getOne: function() {
        return Restangular.all("templates").one($state.params.templateId + ".json").get();
      },
      set: function(template_id) {
        return Restangular.all("sites").one($state.params.siteId).all("site_templates.json").post({
          template_id: template_id
        });
      },
      getUserCategories: function() {
        return Restangular.all("templates").all("tags?user_tags=1").getList();
      },
      sortCategories: function(tags) {
        return Restangular.all("templates").all("tags_sort").post({
          tags: tags
        });
      }
    };
    return templates;
  }
]);


/***/ }),
/* 270 */
/***/ (function(module, exports) {

angular.module('siter.io').controller('Sites', [
  "$scope", "Restangular", "$modal", "$stateParams", "$state", 'Site', "$rootScope", function($scope, Restangular, $modal, $stateParams, $state, Site, $rootScope) {
    var _getSiteFail, _getSiteSuccess;
    $scope.state = $state;
    _getSiteSuccess = function(siteData) {
      if (siteData.style_attributes) {
        siteData.style_attributes.maxWidth = parseInt(siteData.style_attributes.maxWidth);
      }
      return $rootScope.site = siteData;
    };
    _getSiteFail = function(response) {
      return $state.go("404");
    };
    Site.get().then(_getSiteSuccess, _getSiteFail);
    return angular.element("body").on("keypress", "span[contenteditable]", function(e) {
      return e.which !== 13;
    });
  }
]);


/***/ }),
/* 271 */
/***/ (function(module, exports) {

angular.module('siter.io').factory('Site', [
  "Restangular", "$rootScope", "$stateParams", "$state", "$modal", "$injector", function(Restangular, $rootScope, $stateParams, $state, $modal, $injector) {
    var site;
    site = {
      _currentSite: Restangular.one('sites', $stateParams.siteId),
      get: function(id) {
        if (id) {
          return Restangular.one('sites', id).get();
        } else {
          return Restangular.one('sites', $stateParams.siteId).get();
        }
      },
      getList: function() {
        return Restangular.all('sites').getList();
      },
      update: function(site) {
        return Restangular.all('sites').one(site.id).customPUT(site);
      },
      updateByRoute: function(site) {
        return Restangular.all('sites').one($stateParams.siteId).customPUT(site);
      },
      remove: function(id) {
        return Restangular.one('sites', id).remove();
      },
      create: function(site) {
        return Restangular.all('sites').post(site);
      },
      saveIndex: function(changes) {
        return Restangular.one('sites', $stateParams.siteId).all('assets/save').post({
          changes: changes,
          path: $rootScope.currentFile.full_path
        });
      },
      transfer: function(data) {
        return Restangular.one('sites', $stateParams.siteId).all("transfer").post(data);
      },
      share: function(site) {
        return Restangular.one('sites', $stateParams.siteId).all("share").post(site);
      },
      setTemplate: function(template_id) {
        return Restangular.all("sites").one($state.params.siteId).customPUT({
          template_id: template_id
        });
      },
      addSite: function() {
        return $state.go("root.new_site");
      },
      clearFonts: function() {
        return Restangular.all("sites").one($state.params.siteId).all("clear_fonts").post();
      },
      createTemplate: function(templateParams) {
        return Restangular.all("sites").one($state.params.siteId).all("templates").post(templateParams);
      },
      publish: function() {
        return Restangular.all("sites").one($state.params.siteId).all("build").post();
      },
      clone: function(site_id) {
        return Restangular.all("sites").one(site_id).all("clone").post();
      }
    };
    return site;
  }
]);


/***/ }),
/* 272 */
/***/ (function(module, exports) {

var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

angular.module('siter.io').controller('SiteSettingsModal', [
  "$scope", "$state", "$rootScope", "$modalInstance", "$cookies", "Restangular", "FileUploader", "Site", "$modalStack", "Page", "Notification", "$filter", "Email", "WebForm", "Lesson", function($scope, $state, $rootScope, $modalInstance, $cookies, Restangular, FileUploader, Site, $modalStack, Page, Notification, $filter, Email, WebForm, Lesson) {
    var applyStyleToTemplate, previewUploadUrl, ref, tagsToString, updatePreviews;
    if (window.Editor.mode === "site.page.editor") {
      $scope.currentSettings = 'fonts';
    } else {
      $scope.currentSettings = 'bg';
    }
    $scope.site.tags = [];
    $scope.isSuperAdminRole = (ref = $rootScope.currentUser.role) === "superadmin";
    if ($scope.isSuperAdminRole) {
      Restangular.all('/templates/tags').getList().then(function(items) {
        return $scope.items = _.map(items, function(item, index) {
          return {
            text: item,
            id: index
          };
        });
      });
    }
    $scope.loadTags = function(query) {
      return Restangular.all("/templates/tags?q=" + query).getList();
    };
    tagsToString = function(tags) {
      tags = _.map(tags, function(tag) {
        return tag.text;
      });
      return tags.join(",");
    };
    applyStyleToTemplate = function(site) {
      return $rootScope.$broadcast("get:styles");
    };
    updatePreviews = function() {
      var d;
      d = new Date();
      $(".etn__preview-favicon__image").each(function() {
        var oldattr;
        oldattr = $(this).attr("ng-src");
        if (oldattr) {
          return $(this).attr("src", (oldattr + "?") + d.getTime());
        }
      });
      return $(".etn__preview-image").each(function() {
        var oldattr;
        oldattr = $(this).attr("ng-src");
        if (oldattr) {
          return $(this).attr("src", (oldattr + "?") + d.getTime());
        }
      });
    };
    $scope.faviconUploader = new FileUploader({
      url: Restangular.configuration.baseUrl + ("/sites/" + $state.params.siteId),
      autoUpload: true,
      method: "PUT",
      alias: "favicon",
      headers: {
        'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
      }
    });
    $scope.faviconUploader.onAfterAddingFile = function(item) {
      var ref1, types;
      types = ["image/jpeg", "image/png"];
      if (ref1 = item.file.type, indexOf.call(types, ref1) < 0) {
        alert("The file must be png or jpg");
        return false;
      }
    };
    $scope.faviconUploader.onSuccessItem = function(fileItem, response, status, headers) {
      $scope.faviconUploader.clearQueue();
      $rootScope.site.favicon = response.favicon;
      updatePreviews();
    };
    $scope.faviconUploader.onErrorItem = function(fileItem, response, status, headers) {};
    if (Editor.mode === "email.page.editor") {
      previewUploadUrl = "/emails/" + $state.params.emailId;
    } else if (Editor.mode === "form.page.editor") {
      previewUploadUrl = "/web_forms/" + $state.params.formId;
    } else if (Editor.mode === "lesson.page.editor") {
      previewUploadUrl = "/lms_pages/" + $state.params.lessonId;
    } else {
      previewUploadUrl = "/sites/" + $state.params.siteId;
    }
    $scope.webPreviewUploader = new FileUploader({
      url: Restangular.configuration.baseUrl + previewUploadUrl,
      autoUpload: true,
      method: "PUT",
      alias: "preview",
      headers: {
        'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
      }
    });
    $scope.webPreviewUploader.onAfterAddingFile = function(item) {
      var ref1, types;
      types = ["image/jpeg", "image/png"];
      if (ref1 = item.file.type, indexOf.call(types, ref1) < 0) {
        alert("The file must be png or jpg");
        return false;
      }
    };
    $scope.webPreviewUploader.onSuccessItem = function(fileItem, response, status, headers) {
      $scope.webPreviewUploader.clearQueue();
      $rootScope.site.preview.thumb = response.preview.preview.thumb.url;
      updatePreviews();
    };
    $scope.webPreviewUploader.onErrorItem = function(fileItem, response, status, headers) {};
    $scope.mobilePreviewUploader = new FileUploader({
      url: Restangular.configuration.baseUrl + previewUploadUrl,
      autoUpload: true,
      method: "PUT",
      alias: "mobile_preview",
      headers: {
        'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
      }
    });
    $scope.networkingUploader = new FileUploader({
      url: Restangular.configuration.baseUrl + ("/sites/" + $state.params.siteId + "/pages/" + $scope.currentPage.id),
      autoUpload: true,
      method: "PUT",
      alias: "networking_image",
      headers: {
        'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
      }
    });
    updatePreviews = function() {
      var d;
      d = new Date();
      return $("#networkingImage").each(function() {
        var oldattr;
        oldattr = $(this).attr("ng-src");
        if (oldattr) {
          return $(this).attr("src", (oldattr + "?") + d.getTime());
        }
      });
    };
    $scope.networkingUploader.onAfterAddingFile = function(item) {
      var ref1, types;
      types = ["image/jpeg", "image/png"];
      if (ref1 = item.file.type, indexOf.call(types, ref1) < 0) {
        alert("The file must be png or jpg");
        return false;
      }
    };
    $scope.networkingUploader.onSuccessItem = function(fileItem, response, status, headers) {
      $scope.networkingUploader.clearQueue();
      $scope.currentPage.networking_image = response.networking_image;
      updatePreviews();
    };
    $scope.networkingUploader.onErrorItem = function(fileItem, response, status, headers) {};
    $scope.removeNetworkingImage = function() {
      return Page.remove_networking_image($scope.currentPage.id).then(function(response) {
        return $scope.currentPage.networking_image = response.networking_image;
      });
    };
    $scope.mobilePreviewUploader.onAfterAddingFile = function(item) {
      var ref1, types;
      types = ["image/jpeg", "image/png"];
      if (ref1 = item.file.type, indexOf.call(types, ref1) < 0) {
        alert("The file must be png or jpg");
        return false;
      }
    };
    $scope.mobilePreviewUploader.onSuccessItem = function(fileItem, response, status, headers) {
      $scope.mobilePreviewUploader.clearQueue();
      $rootScope.site.mobile_preview.thumb = response.mobile_preview.mobile_preview.thumb.url;
      updatePreviews();
    };
    $scope.mobilePreviewUploader.onErrorItem = function(fileItem, response, status, headers) {};
    $scope.saveSite = function(site, siteSettingsForm, fromFavorite) {
      var object, ref1;
      if (fromFavorite == null) {
        fromFavorite = false;
      }
      if (siteSettingsForm.$invalid) {
        return false;
      }
      if (Editor.mode === "email.page.editor") {
        object = Email;
      } else if (Editor.mode === "form.page.editor") {
        object = WebForm;
        site.is_template = true;
      } else if (Editor.mode === "lesson.page.editor") {
        object = Lesson;
      } else {
        object = Site;
      }
      site = angular.copy(site);
      $scope.savingSite = true;
      if (fromFavorite && ((ref1 = $rootScope.currentUser.role) === "admin")) {
        site.disabled = true;
        site.tags = $filter('translate')('dashboard.myTemplates');
      }
      return object.update(site).then(function() {
        $scope.savingSite = false;
        applyStyleToTemplate(site);
        $scope.close();
      }, function() {
        return $scope.savingSite = false;
      });
    };
    $scope.createTemplate = function(site, siteSettingsForm, needRedirect) {
      var object, templateParams;
      if (needRedirect == null) {
        needRedirect = false;
      }
      if (siteSettingsForm.$invalid) {
        return false;
      }
      $scope.savingSite = true;
      if (Editor.mode === "email.page.editor") {
        object = Email;
      } else if (Editor.mode === "form.page.editor") {
        object = WebForm;
      } else if (Editor.mode === "lesson.page.editor") {
        object = Lesson;
      } else {
        object = Site;
      }
      templateParams = {
        name: site.name,
        description: site.description,
        preview: site.preview,
        mobile_preview: site.mobile_preview,
        is_manual_preview: site.is_manual_preview,
        tags: tagsToString(site.tags)
      };
      return object.createTemplate(templateParams).then(function(response) {
        var messageParts, redirectUrl;
        $scope.savingSite = false;
        $scope.close();
        if (response.status) {
          if (needRedirect) {
            if (object === Email) {
              redirectUrl = '/sites/constructor/email_template/edit/' + window.justclick.contentType + '#/emails/' + response.slug + '/home/editor';
            } else if (object === Lesson) {
              redirectUrl = '/sites/constructor/lesson_template/edit#/lms_pages/' + response.slug + '/home/editor';
            } else {
              redirectUrl = '/sites/constructor/template/edit#/sites/' + response.slug + '/home/editor';
            }
            window.location.href = redirectUrl;
          }
          messageParts = [$filter('translate')('template.template'), site.name, $filter('translate')('template.createSuccessful')];
          Notification.success({
            message: messageParts.join(' ')
          });
        } else {
          Notification.error({
            message: $filter('translate')('site.error')
          });
        }
      }, function() {
        return $scope.savingSite = false;
      });
    };
    $scope.favoriteSaveSettings = function(site, siteSettingsForm, needRedirect) {
      if (needRedirect == null) {
        needRedirect = false;
      }
      if (site.is_template) {
        return $scope.saveSite(site, siteSettingsForm, true);
      } else {
        return $scope.createTemplate(site, siteSettingsForm, needRedirect);
      }
    };
    $scope.saveHomePage = function(page, pageSettingsForm) {
      if (pageSettingsForm.$invalid) {
        return false;
      }
      $scope.savingPage = true;
      return Page.update(page).then(function(newPageData) {
        page.background_attributes = newPageData.background_attributes;
        $scope.savingPage = false;
        return $scope.close();
      }, function() {
        return $scope.savingPage = false;
      });
    };
    $scope.getDesktopPreview = function() {
      if ($rootScope.site.preview.thumb != null) {
        return $rootScope.site.preview.thumb;
      } else {
        return $rootScope.site.preview.preview.thumb.url;
      }
    };
    $scope.getMobilePreview = function() {
      if ($rootScope.site.mobile_preview.thumb != null) {
        return $rootScope.site.mobile_preview.thumb;
      } else {
        return $rootScope.site.mobile_preview.mobile_preview.thumb.url;
      }
    };
    $scope.closeAll = function() {
      return $modalStack.dismissAll('cancel');
    };
    return $scope.close = function() {
      return $modalInstance.dismiss("close");
    };
  }
]);


/***/ }),
/* 273 */
/***/ (function(module, exports) {

var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

angular.module("siter.io").controller("EditWebFormTemplateController", [
  "$scope", "$rootScope", "$modalInstance", "WebForm", "Translit", "FileUploader", "Restangular", "$state", "$cookies", "template", "$http", "mainTemplate", function($scope, $rootScope, $modalInstance, WebForm, Translit, FileUploader, Restangular, $state, $cookies, template, $http, mainTemplate) {
    $scope.landing = {};
    $scope.site = template;
    $scope.mainTemplate = mainTemplate;
    $scope.site.tags = _.map($scope.site.tags.split(","), function(tag, index) {
      return {
        text: tag,
        id: index
      };
    });
    $scope.site.colors = _.map($scope.site.colors, function(tag, index) {
      return {
        text: tag,
        id: index
      };
    });
    $scope.transliterate = function(text, entorus) {
      if (entorus == null) {
        entorus = false;
      }
      return Translit.one(text, entorus);
    };
    $scope.transliterate_3 = function(text, entorus) {
      if (entorus == null) {
        entorus = false;
      }
      return Translit.three(text, entorus);
    };
    Restangular.all('/web_forms/tags').getList().then(function(items) {
      return $scope.items = _.map(items, function(item, index) {
        return {
          text: item,
          id: index
        };
      });
    });
    $scope.loadTags = function(query) {
      return Restangular.all("/web_forms/tags?q=" + query).getList();
    };
    $scope.clone = function() {
      $scope.cloning = true;
      return WebForm.clone(template.id).then(function(data) {
        $scope.cloning = false;
        $scope.close();
        return $rootScope.$broadcast("web_form:created", data, template);
      });
    };
    $scope.webPreviewUploader = new FileUploader({
      url: Restangular.configuration.baseUrl + ("/web_forms/" + template.id),
      autoUpload: false,
      method: "PUT",
      alias: "preview",
      headers: {
        'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
      }
    });
    $scope.webPreviewUploader.onAfterAddingFile = function(item) {
      var ref, types;
      types = ["image/jpeg", "image/png"];
      if (ref = item.file.type, indexOf.call(types, ref) < 0) {
        alert("The file must be png or jpg");
        return false;
      }
    };
    $scope.webPreviewUploader.onSuccessItem = function(fileItem, response, status, headers) {
      template.preview = response.preview.preview;
      $scope.webPreviewUploader.clearQueue();
    };
    $scope.webPreviewUploader.onErrorItem = function(fileItem, response, status, headers) {};
    $scope.cancel = function() {
      return $modalInstance.dismiss("cancel");
    };
    $scope.close = function() {
      return $modalInstance.dismiss("close");
    };
    $scope.saving = false;
    return $scope.saveTemplate = function(form, editTemplateForm) {
      if (editTemplateForm.$invalid) {
        return false;
      }
      $scope.saving = true;
      form = angular.copy(form);
      form.is_template = true;
      form.tags = _.map(form.tags, function(tag) {
        return tag.text;
      });
      form.tags = form.tags.join(",");
      form.colors = _.map(form.colors, function(tag) {
        return tag.text;
      });
      return WebForm.update(form).then(function(new_site) {
        $scope.saving = false;
        $scope.webPreviewUploader.uploadAll();
        $rootScope.$broadcast("web_form:updated");
        return $scope.close();
      }, function(errors) {
        $scope.errors = errors.data.errors;
        return $scope.saving = false;
      });
    };
  }
]);


/***/ }),
/* 274 */
/***/ (function(module, exports) {

angular.module("siter.io").controller("HtmlOfFormController", [
  "$scope", "$rootScope", "$modalInstance", "SectionWebForm", "Translit", "$state", "$timeout", function($scope, $rootScope, $modalInstance, SectionWebForm, Translit, $state, $timeout) {
    var containerId, focusText;
    focusText = function($element) {
      return $element.focus(function() {
        $element.select();
        return $element.mouseup(function() {
          $element.unbind("mouseup");
          return false;
        });
      });
    };
    containerId = 'form-' + $rootScope.currentSite.id;
    $scope.htmlLoader = '<script id="' + containerId + '" type="text/javascript" src="' + $rootScope.justclick.apiURL + '/web_forms/' + $rootScope.currentSite.id + '/form_loader.js?cid=' + containerId + '"></script>';
    $scope.currentTab = 'htmlLoader';
    $scope.showExamples = false;
    $timeout(function() {
      return focusText($('#loader_of_form'));
    }, 300);
    return SectionWebForm.getHtmlCodeOfForm($rootScope.currentSite.id).then(function(htmlCode) {
      return SectionWebForm.getStylesheetsOfForm($rootScope.currentSite.id).then(function(stylesheets) {
        var cssCode, jsCode;
        cssCode = '<style type="text/css">' + stylesheets + '</style>';
        jsCode = '<script type="text/javascript" charset="UTF-8" src="' + $rootScope.originHost + '/constructor/editor/scripts/common-forms.js' + '"></script>';
        $scope.htmlData = cssCode + htmlCode + jsCode;
        return focusText($('#html_of_form'));
      }, function() {
        return $modalInstance.dismiss("close");
      }, 300);
    }, function() {
      return $modalInstance.dismiss("close");
    }, 300);
  }
]);


/***/ }),
/* 275 */
/***/ (function(module, exports) {

var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

angular.module("siter.io").controller("NewWebFormTemplateController", [
  "$scope", "$rootScope", "$modalInstance", "WebForm", "Translit", "FileUploader", "Restangular", "$state", "$cookies", function($scope, $rootScope, $modalInstance, WebForm, Translit, FileUploader, Restangular, $state, $cookies) {
    var setUploadUrls;
    $scope.landing = {};
    $scope.transliterate = function(text, entorus) {
      if (entorus == null) {
        entorus = false;
      }
      return Translit.one(text, entorus);
    };
    $scope.transliterate_3 = function(text, entorus) {
      if (entorus == null) {
        entorus = false;
      }
      return Translit.three(text, entorus);
    };
    Restangular.all('/web_forms/tags').getList().then(function(items) {
      return $scope.items = _.map(items, function(item, index) {
        return {
          text: item,
          id: index
        };
      });
    });
    $scope.loadTags = function(query) {
      return Restangular.all("/web_forms/tags?q=" + query).getList();
    };
    $scope.webPreviewUploader = new FileUploader({
      url: Restangular.configuration.baseUrl + ("/web_forms/" + $state.params.siteId),
      autoUpload: false,
      method: "PUT",
      alias: "preview",
      headers: {
        'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
      }
    });
    $scope.webPreviewUploader.onAfterAddingFile = function(item) {
      var ref, types;
      types = ["image/jpeg", "image/png"];
      if (ref = item.file.type, indexOf.call(types, ref) < 0) {
        alert("The file must be png or jpg");
        return false;
      }
    };
    $scope.webPreviewUploader.onSuccessItem = function(fileItem, response, status, headers) {
      $scope.webPreviewUploader.clearQueue();
      $scope.new_site.preview = response.preview.preview;
    };
    $scope.webPreviewUploader.onErrorItem = function(fileItem, response, status, headers) {};
    setUploadUrls = function(siteId) {
      return $scope.webPreviewUploader.queue.forEach(function(item) {
        return item.url = Restangular.configuration.baseUrl + ("/web_forms/" + siteId);
      });
    };
    $scope.cancel = function() {
      return $modalInstance.dismiss("cancel");
    };
    $scope.close = function() {
      return $modalInstance.dismiss("close");
    };
    $scope.creating = false;
    $scope.site.disabled = true;
    $scope.site.type = 'Order';
    return $scope.createTemplate = function(form, newTemplateForm) {
      if (newTemplateForm.$invalid) {
        return false;
      }
      $scope.creating = true;
      form.is_template = true;
      form.tags = _.map(form.tags, function(tag) {
        return tag.text;
      });
      form.tags = form.tags.join(",");
      form.description = 'Blank template by admin';
      form.colors = _.map(form.colors, function(tag) {
        return tag.text;
      });
      return WebForm.create(form).then(function(new_site) {
        $scope.new_site = new_site;
        $scope.creating = false;
        setUploadUrls($scope.new_site.id);
        $scope.webPreviewUploader.uploadAll();
        $rootScope.$broadcast("web_form:created", $scope.new_site);
        return $scope.close();
      }, function(errors) {
        $scope.errors = errors.data.errors;
        return $scope.creating = false;
      });
    };
  }
]);


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "/**\n * angular-growl - v0.4.0 - 2013-11-19\n * https://github.com/marcorinck/angular-growl\n * Copyright (c) 2013 Marco Rinck; Licensed MIT\n */\n\n.growl{position:fixed;top:10px;right:10px;float:right;width:250px}.growl-item.ng-enter,.growl-item.ng-leave{-webkit-transition:.5s linear all;-moz-transition:.5s linear all;-o-transition:.5s linear all;transition:.5s linear all}.growl-item.ng-enter,.growl-item.ng-leave.ng-leave-active{opacity:0}.growl-item.ng-leave,.growl-item.ng-enter.ng-enter-active{opacity:1}", "", {"version":3,"sources":["/./node_modules/angular-growl-siter/build/angular-growl.min.css"],"names":[],"mappings":"AAAA;;;;GAIG;;AAEH,OAAO,eAAe,SAAS,WAAW,YAAY,WAAW,CAAC,0CAA0C,kCAAkC,+BAA+B,6BAA6B,yBAAyB,CAAC,0DAA0D,SAAS,CAAC,0DAA0D,SAAS,CAAC","file":"angular-growl.min.css","sourcesContent":["/**\n * angular-growl - v0.4.0 - 2013-11-19\n * https://github.com/marcorinck/angular-growl\n * Copyright (c) 2013 Marco Rinck; Licensed MIT\n */\n\n.growl{position:fixed;top:10px;right:10px;float:right;width:250px}.growl-item.ng-enter,.growl-item.ng-leave{-webkit-transition:.5s linear all;-moz-transition:.5s linear all;-o-transition:.5s linear all;transition:.5s linear all}.growl-item.ng-enter,.growl-item.ng-leave.ng-leave-active{opacity:0}.growl-item.ng-leave,.growl-item.ng-enter.ng-enter-active{opacity:1}"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "/**\n * Treeview styles\n *\n * @private\n * @package ivh.treeview\n * @copyright 2014 iVantage Health Analytics, Inc.\n */\nul.ivh-treeview li.ivh-treeview-node-collapsed ul.ivh-treeview {\n  display: none;\n}\nul.ivh-treeview .ivh-treeview-twistie-leaf,\nul.ivh-treeview .ivh-treeview-twistie-collapsed {\n  display: none;\n}\nul.ivh-treeview .ivh-treeview-node-collapsed .ivh-treeview-twistie-collapsed {\n  display: inline;\n}\nul.ivh-treeview .ivh-treeview-node-collapsed .ivh-treeview-twistie-expanded {\n  display: none;\n}\nul.ivh-treeview li.ivh-treeview-node-leaf .ivh-treeview-twistie-leaf {\n  display: inline;\n}\nul.ivh-treeview li.ivh-treeview-node-leaf .ivh-treeview-twistie-expanded,\nul.ivh-treeview li.ivh-treeview-node-leaf .ivh-treeview-twistie-collapsed {\n  display: none;\n}\n", "", {"version":3,"sources":["/./node_modules/angular-ivh-treeview/dist/ivh-treeview.css"],"names":[],"mappings":"AAAA;;;;;;GAMG;AACH;EACE,cAAc;CACf;AACD;;EAEE,cAAc;CACf;AACD;EACE,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,gBAAgB;CACjB;AACD;;EAEE,cAAc;CACf","file":"ivh-treeview.css","sourcesContent":["/**\n * Treeview styles\n *\n * @private\n * @package ivh.treeview\n * @copyright 2014 iVantage Health Analytics, Inc.\n */\nul.ivh-treeview li.ivh-treeview-node-collapsed ul.ivh-treeview {\n  display: none;\n}\nul.ivh-treeview .ivh-treeview-twistie-leaf,\nul.ivh-treeview .ivh-treeview-twistie-collapsed {\n  display: none;\n}\nul.ivh-treeview .ivh-treeview-node-collapsed .ivh-treeview-twistie-collapsed {\n  display: inline;\n}\nul.ivh-treeview .ivh-treeview-node-collapsed .ivh-treeview-twistie-expanded {\n  display: none;\n}\nul.ivh-treeview li.ivh-treeview-node-leaf .ivh-treeview-twistie-leaf {\n  display: inline;\n}\nul.ivh-treeview li.ivh-treeview-node-leaf .ivh-treeview-twistie-expanded,\nul.ivh-treeview li.ivh-treeview-node-leaf .ivh-treeview-twistie-collapsed {\n  display: none;\n}\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "/**\n * angular-ui-notification - Angular.js service providing simple notifications using Bootstrap 3 styles with css transitions for animating\n * @author Alex_Crack\n * @version v0.0.14\n * @link https://github.com/alexcrack/angular-ui-notification\n * @license MIT\n */\n.ui-notification{position:fixed;z-index:9999;width:300px;cursor:pointer;-webkit-transition:all ease .5s;-o-transition:all ease .5s;transition:all ease .5s;color:#fff;background:#337ab7;box-shadow:5px 5px 10px rgba(0,0,0,.3)}.ui-notification.killed{-webkit-transition:opacity ease 1s;-o-transition:opacity ease 1s;transition:opacity ease 1s;opacity:0}.ui-notification>h3{font-size:14px;font-weight:700;display:block;margin:10px 10px 0;padding:0 0 5px;text-align:left;border-bottom:1px solid rgba(255,255,255,.3)}.ui-notification a{color:#fff}.ui-notification a:hover{text-decoration:underline}.ui-notification>.message{margin:10px}.ui-notification.warning{color:#fff;background:#f0ad4e}.ui-notification.error{color:#fff;background:#d9534f}.ui-notification.success{color:#fff;background:#5cb85c}.ui-notification.info{color:#fff;background:#5bc0de}.ui-notification:hover{opacity:.7}", "", {"version":3,"sources":["/./node_modules/angular-ui-notification/dist/angular-ui-notification.min.css"],"names":[],"mappings":"AAAA;;;;;;GAMG;AACH,iBAAiB,eAAe,aAAa,YAAY,eAAe,gCAAgC,2BAA2B,wBAAwB,WAAW,mBAAmB,sCAAsC,CAAC,wBAAwB,mCAAmC,8BAA8B,2BAA2B,SAAS,CAAC,oBAAoB,eAAe,gBAAgB,cAAc,mBAAmB,gBAAgB,gBAAgB,4CAA4C,CAAC,mBAAmB,UAAU,CAAC,yBAAyB,yBAAyB,CAAC,0BAA0B,WAAW,CAAC,yBAAyB,WAAW,kBAAkB,CAAC,uBAAuB,WAAW,kBAAkB,CAAC,yBAAyB,WAAW,kBAAkB,CAAC,sBAAsB,WAAW,kBAAkB,CAAC,uBAAuB,UAAU,CAAC","file":"angular-ui-notification.min.css","sourcesContent":["/**\n * angular-ui-notification - Angular.js service providing simple notifications using Bootstrap 3 styles with css transitions for animating\n * @author Alex_Crack\n * @version v0.0.14\n * @link https://github.com/alexcrack/angular-ui-notification\n * @license MIT\n */\n.ui-notification{position:fixed;z-index:9999;width:300px;cursor:pointer;-webkit-transition:all ease .5s;-o-transition:all ease .5s;transition:all ease .5s;color:#fff;background:#337ab7;box-shadow:5px 5px 10px rgba(0,0,0,.3)}.ui-notification.killed{-webkit-transition:opacity ease 1s;-o-transition:opacity ease 1s;transition:opacity ease 1s;opacity:0}.ui-notification>h3{font-size:14px;font-weight:700;display:block;margin:10px 10px 0;padding:0 0 5px;text-align:left;border-bottom:1px solid rgba(255,255,255,.3)}.ui-notification a{color:#fff}.ui-notification a:hover{text-decoration:underline}.ui-notification>.message{margin:10px}.ui-notification.warning{color:#fff;background:#f0ad4e}.ui-notification.error{color:#fff;background:#d9534f}.ui-notification.success{color:#fff;background:#5cb85c}.ui-notification.info{color:#fff;background:#5bc0de}.ui-notification:hover{opacity:.7}"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "/* Get the bourbon mixin from http://bourbon.io */\n/* Reset */\n.flip-clock-wrapper * {\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    -ms-box-sizing: border-box;\n    -o-box-sizing: border-box;\n    box-sizing: border-box;\n    -webkit-backface-visibility: hidden;\n    -moz-backface-visibility: hidden;\n    -ms-backface-visibility: hidden;\n    -o-backface-visibility: hidden;\n    backface-visibility: hidden;\n}\n\n.flip-clock-wrapper a {\n  cursor: pointer;\n  text-decoration: none;\n  color: #ccc; }\n\n.flip-clock-wrapper a:hover {\n  color: #fff; }\n\n.flip-clock-wrapper ul {\n  list-style: none; }\n\n.flip-clock-wrapper.clearfix:before,\n.flip-clock-wrapper.clearfix:after {\n  content: \" \";\n  display: table; }\n\n.flip-clock-wrapper.clearfix:after {\n  clear: both; }\n\n.flip-clock-wrapper.clearfix {\n  *zoom: 1; }\n\n/* Main */\n.flip-clock-wrapper {\n  font: normal 11px \"Helvetica Neue\", Helvetica, sans-serif;\n  -webkit-user-select: none; }\n\n.flip-clock-meridium {\n  background: none !important;\n  box-shadow: 0 0 0 !important;\n  font-size: 36px !important; }\n\n.flip-clock-meridium a { color: #313333; }\n\n.flip-clock-wrapper {\n  text-align: center;\n  position: relative;\n  width: 100%;\n  margin: 1em;\n}\n\n.flip-clock-wrapper:before,\n.flip-clock-wrapper:after {\n    content: \" \"; /* 1 */\n    display: table; /* 2 */\n}\n.flip-clock-wrapper:after {\n    clear: both;\n}\n\n/* Skeleton */\n.flip-clock-wrapper ul {\n  position: relative;\n  float: left;\n  margin: 5px;\n  width: 60px;\n  height: 90px;\n  font-size: 80px;\n  font-weight: bold;\n  line-height: 87px;\n  border-radius: 6px;\n  background: #000;\n}\n\n.flip-clock-wrapper ul li {\n  z-index: 1;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  line-height: 87px;\n  text-decoration: none !important;\n}\n\n.flip-clock-wrapper ul li:first-child {\n  z-index: 2; }\n\n.flip-clock-wrapper ul li a {\n  display: block;\n  height: 100%;\n  -webkit-perspective: 200px;\n  -moz-perspective: 200px;\n  perspective: 200px;\n  margin: 0 !important;\n  overflow: visible !important;\n  cursor: default !important; }\n\n.flip-clock-wrapper ul li a div {\n  z-index: 1;\n  position: absolute;\n  left: 0;\n  width: 100%;\n  height: 50%;\n  font-size: 80px;\n  overflow: hidden; \n  outline: 1px solid transparent; }\n\n.flip-clock-wrapper ul li a div .shadow {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  z-index: 2; }\n\n.flip-clock-wrapper ul li a div.up {\n  -webkit-transform-origin: 50% 100%;\n  -moz-transform-origin: 50% 100%;\n  -ms-transform-origin: 50% 100%;\n  -o-transform-origin: 50% 100%;\n  transform-origin: 50% 100%;\n  top: 0; }\n\n.flip-clock-wrapper ul li a div.up:after {\n  content: \"\";\n  position: absolute;\n  top: 44px;\n  left: 0;\n  z-index: 5;\n  width: 100%;\n  height: 3px;\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.4); }\n\n.flip-clock-wrapper ul li a div.down {\n  -webkit-transform-origin: 50% 0;\n  -moz-transform-origin: 50% 0;\n  -ms-transform-origin: 50% 0;\n  -o-transform-origin: 50% 0;\n  transform-origin: 50% 0;\n  bottom: 0;\n  border-bottom-left-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n\n.flip-clock-wrapper ul li a div div.inn {\n  position: absolute;\n  left: 0;\n  z-index: 1;\n  width: 100%;\n  height: 200%;\n  color: #ccc;\n  text-shadow: 0 1px 2px #000;\n  text-align: center;\n  background-color: #333;\n  border-radius: 6px;\n  font-size: 70px; }\n\n.flip-clock-wrapper ul li a div.up div.inn {\n  top: 0; }\n\n.flip-clock-wrapper ul li a div.down div.inn {\n  bottom: 0; }\n\n/* PLAY */\n.flip-clock-wrapper ul.play li.flip-clock-before {\n  z-index: 3; }\n\n.flip-clock-wrapper .flip {   box-shadow: 0 2px 5px rgba(0, 0, 0, 0.7); }\n\n.flip-clock-wrapper ul.play li.flip-clock-active {\n  -webkit-animation: asd 0.01s 0.49s linear both;\n  -moz-animation: asd 0.01s 0.49s linear both;\n  animation: asd 0.01s 0.49s linear both;\n  z-index: 5; }\n\n.flip-clock-divider {\n  float: left;\n  display: inline-block;\n  position: relative;\n  width: 20px;\n  height: 100px; }\n\n.flip-clock-divider:first-child {\n  width: 0; }\n\n.flip-clock-dot {\n  display: block;\n  background: #323434;\n  width: 10px;\n  height: 10px;\n  position: absolute;\n  border-radius: 50%;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\n  left: 5px; }\n\n.flip-clock-divider .flip-clock-label {\n  position: absolute;\n  top: -1.5em;\n  right: -86px;\n  color: black;\n  text-shadow: none; }\n\n.flip-clock-divider.minutes .flip-clock-label {\n  right: -88px; }\n\n.flip-clock-divider.seconds .flip-clock-label {\n  right: -91px; }\n\n.flip-clock-dot.top {\n  top: 30px; }\n\n.flip-clock-dot.bottom {\n  bottom: 30px; }\n\n@-webkit-keyframes asd {\n  0% {\n    z-index: 2; }\n\n  100% {\n    z-index: 4; } }\n\n@-moz-keyframes asd {\n  0% {\n    z-index: 2; }\n\n  100% {\n    z-index: 4; } }\n\n@-o-keyframes asd {\n  0% {\n    z-index: 2; }\n\n  100% {\n    z-index: 4; } }\n\n@keyframes asd {\n  0% {\n    z-index: 2; }\n\n  100% {\n    z-index: 4; } }\n\n.flip-clock-wrapper ul.play li.flip-clock-active .down {\n  z-index: 2;\n  -webkit-animation: turn 0.5s 0.5s linear both;\n  -moz-animation: turn 0.5s 0.5s linear both;\n  animation: turn 0.5s 0.5s linear both; }\n\n@-webkit-keyframes turn {\n  0% {\n    -webkit-transform: rotateX(90deg); }\n\n  100% {\n    -webkit-transform: rotateX(0deg); } }\n\n@-moz-keyframes turn {\n  0% {\n    -moz-transform: rotateX(90deg); }\n\n  100% {\n    -moz-transform: rotateX(0deg); } }\n\n@-o-keyframes turn {\n  0% {\n    -o-transform: rotateX(90deg); }\n\n  100% {\n    -o-transform: rotateX(0deg); } }\n\n@keyframes turn {\n  0% {\n    transform: rotateX(90deg); }\n\n  100% {\n    transform: rotateX(0deg); } }\n\n.flip-clock-wrapper ul.play li.flip-clock-before .up {\n  z-index: 2;\n  -webkit-animation: turn2 0.5s linear both;\n  -moz-animation: turn2 0.5s linear both;\n  animation: turn2 0.5s linear both; }\n\n@-webkit-keyframes turn2 {\n  0% {\n    -webkit-transform: rotateX(0deg); }\n\n  100% {\n    -webkit-transform: rotateX(-90deg); } }\n\n@-moz-keyframes turn2 {\n  0% {\n    -moz-transform: rotateX(0deg); }\n\n  100% {\n    -moz-transform: rotateX(-90deg); } }\n\n@-o-keyframes turn2 {\n  0% {\n    -o-transform: rotateX(0deg); }\n\n  100% {\n    -o-transform: rotateX(-90deg); } }\n\n@keyframes turn2 {\n  0% {\n    transform: rotateX(0deg); }\n\n  100% {\n    transform: rotateX(-90deg); } }\n\n.flip-clock-wrapper ul li.flip-clock-active {\n  z-index: 3; }\n\n/* SHADOW */\n.flip-clock-wrapper ul.play li.flip-clock-before .up .shadow {\n  background: -moz-linear-gradient(top, rgba(0, 0, 0, 0.1) 0%, black 100%);\n  background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, rgba(0, 0, 0, 0.1)), color-stop(100%, black));\n  background: linear, top, rgba(0, 0, 0, 0.1) 0%, black 100%;\n  background: -o-linear-gradient(top, rgba(0, 0, 0, 0.1) 0%, black 100%);\n  background: -ms-linear-gradient(top, rgba(0, 0, 0, 0.1) 0%, black 100%);\n  background: linear, to bottom, rgba(0, 0, 0, 0.1) 0%, black 100%;\n  -webkit-animation: show 0.5s linear both;\n  -moz-animation: show 0.5s linear both;\n  animation: show 0.5s linear both; }\n\n.flip-clock-wrapper ul.play li.flip-clock-active .up .shadow {\n  background: -moz-linear-gradient(top, rgba(0, 0, 0, 0.1) 0%, black 100%);\n  background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, rgba(0, 0, 0, 0.1)), color-stop(100%, black));\n  background: linear, top, rgba(0, 0, 0, 0.1) 0%, black 100%;\n  background: -o-linear-gradient(top, rgba(0, 0, 0, 0.1) 0%, black 100%);\n  background: -ms-linear-gradient(top, rgba(0, 0, 0, 0.1) 0%, black 100%);\n  background: linear, to bottom, rgba(0, 0, 0, 0.1) 0%, black 100%;\n  -webkit-animation: hide 0.5s 0.3s linear both;\n  -moz-animation: hide 0.5s 0.3s linear both;\n  animation: hide 0.5s 0.3s linear both; }\n\n/*DOWN*/\n.flip-clock-wrapper ul.play li.flip-clock-before .down .shadow {\n  background: -moz-linear-gradient(top, black 0%, rgba(0, 0, 0, 0.1) 100%);\n  background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, black), color-stop(100%, rgba(0, 0, 0, 0.1)));\n  background: linear, top, black 0%, rgba(0, 0, 0, 0.1) 100%;\n  background: -o-linear-gradient(top, black 0%, rgba(0, 0, 0, 0.1) 100%);\n  background: -ms-linear-gradient(top, black 0%, rgba(0, 0, 0, 0.1) 100%);\n  background: linear, to bottom, black 0%, rgba(0, 0, 0, 0.1) 100%;\n  -webkit-animation: show 0.5s linear both;\n  -moz-animation: show 0.5s linear both;\n  animation: show 0.5s linear both; }\n\n.flip-clock-wrapper ul.play li.flip-clock-active .down .shadow {\n  background: -moz-linear-gradient(top, black 0%, rgba(0, 0, 0, 0.1) 100%);\n  background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, black), color-stop(100%, rgba(0, 0, 0, 0.1)));\n  background: linear, top, black 0%, rgba(0, 0, 0, 0.1) 100%;\n  background: -o-linear-gradient(top, black 0%, rgba(0, 0, 0, 0.1) 100%);\n  background: -ms-linear-gradient(top, black 0%, rgba(0, 0, 0, 0.1) 100%);\n  background: linear, to bottom, black 0%, rgba(0, 0, 0, 0.1) 100%;\n  -webkit-animation: hide 0.5s 0.3s linear both;\n  -moz-animation: hide 0.5s 0.3s linear both;\n  animation: hide 0.5s 0.2s linear both; }\n\n@-webkit-keyframes show {\n  0% {\n    opacity: 0; }\n\n  100% {\n    opacity: 1; } }\n\n@-moz-keyframes show {\n  0% {\n    opacity: 0; }\n\n  100% {\n    opacity: 1; } }\n\n@-o-keyframes show {\n  0% {\n    opacity: 0; }\n\n  100% {\n    opacity: 1; } }\n\n@keyframes show {\n  0% {\n    opacity: 0; }\n\n  100% {\n    opacity: 1; } }\n\n@-webkit-keyframes hide {\n  0% {\n    opacity: 1; }\n\n  100% {\n    opacity: 0; } }\n\n@-moz-keyframes hide {\n  0% {\n    opacity: 1; }\n\n  100% {\n    opacity: 0; } }\n\n@-o-keyframes hide {\n  0% {\n    opacity: 1; }\n\n  100% {\n    opacity: 0; } }\n\n@keyframes hide {\n  0% {\n    opacity: 1; }\n\n  100% {\n    opacity: 0; } }\n", "", {"version":3,"sources":["/./node_modules/flipclock/compiled/flipclock.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD,WAAW;AACX;IACI,+BAA+B;IAC/B,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;IACvB,oCAAoC;IACpC,iCAAiC;IACjC,gCAAgC;IAChC,+BAA+B;IAC/B,4BAA4B;CAC/B;;AAED;EACE,gBAAgB;EAChB,sBAAsB;EACtB,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,iBAAiB,EAAE;;AAErB;;EAEE,aAAa;EACb,eAAe,EAAE;;AAEnB;EACE,YAAY,EAAE;;AAEhB;GACE,QAAS,EAAE;;AAEb,UAAU;AACV;EACE,0DAA0D;EAC1D,0BAA0B,EAAE;;AAE9B;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B,EAAE;;AAE/B,yBAAyB,eAAe,EAAE;;AAE1C;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,YAAY;CACb;;AAED;;IAEI,aAAa,CAAC,OAAO;IACrB,eAAe,CAAC,OAAO;CAC1B;AACD;IACI,YAAY;CACf;;AAED,cAAc;AACd;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;CAClB;;AAED;EACE,WAAW;EACX,mBAAmB;EACnB,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iCAAiC;CAClC;;AAED;EACE,WAAW,EAAE;;AAEf;EACE,eAAe;EACf,aAAa;EACb,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;EAC7B,2BAA2B,EAAE;;AAE/B;EACE,WAAW;EACX,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B,EAAE;;AAEnC;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,WAAW,EAAE;;AAEf;EACE,mCAAmC;EACnC,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;EAC3B,OAAO,EAAE;;AAEX;EACE,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,qCAAqC,EAAE;;AAEzC;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,UAAU;EACV,+BAA+B;EAC/B,gCAAgC;CACjC;;AAED;EACE,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB,EAAE;;AAEpB;EACE,OAAO,EAAE;;AAEX;EACE,UAAU,EAAE;;AAEd,UAAU;AACV;EACE,WAAW,EAAE;;AAEf,8BAA8B,yCAAyC,EAAE;;AAEzE;EACE,+CAA+C;EAC/C,4CAA4C;EAC5C,uCAAuC;EACvC,WAAW,EAAE;;AAEf;EACE,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,cAAc,EAAE;;AAElB;EACE,SAAS,EAAE;;AAEb;EACE,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uCAAuC;EACvC,UAAU,EAAE;;AAEd;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,kBAAkB,EAAE;;AAEtB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,UAAU,EAAE;;AAEd;EACE,aAAa,EAAE;;AAEjB;EACE;IACE,WAAW,EAAE;;EAEf;IACE,WAAW,EAAE,EAAE;;AAEnB;EACE;IACE,WAAW,EAAE;;EAEf;IACE,WAAW,EAAE,EAAE;;AAEnB;EACE;IACE,WAAW,EAAE;;EAEf;IACE,WAAW,EAAE,EAAE;;AAEnB;EACE;IACE,WAAW,EAAE;;EAEf;IACE,WAAW,EAAE,EAAE;;AAEnB;EACE,WAAW;EACX,8CAA8C;EAC9C,2CAA2C;EAC3C,sCAAsC,EAAE;;AAE1C;EACE;IACE,kCAAkC,EAAE;;EAEtC;IACE,iCAAiC,EAAE,EAAE;;AAEzC;EACE;IACE,+BAA+B,EAAE;;EAEnC;IACE,8BAA8B,EAAE,EAAE;;AAEtC;EACE;IACE,6BAA6B,EAAE;;EAEjC;IACE,4BAA4B,EAAE,EAAE;;AAEpC;EACE;IACE,0BAA0B,EAAE;;EAE9B;IACE,yBAAyB,EAAE,EAAE;;AAEjC;EACE,WAAW;EACX,0CAA0C;EAC1C,uCAAuC;EACvC,kCAAkC,EAAE;;AAEtC;EACE;IACE,iCAAiC,EAAE;;EAErC;IACE,mCAAmC,EAAE,EAAE;;AAE3C;EACE;IACE,8BAA8B,EAAE;;EAElC;IACE,gCAAgC,EAAE,EAAE;;AAExC;EACE;IACE,4BAA4B,EAAE;;EAEhC;IACE,8BAA8B,EAAE,EAAE;;AAEtC;EACE;IACE,yBAAyB,EAAE;;EAE7B;IACE,2BAA2B,EAAE,EAAE;;AAEnC;EACE,WAAW,EAAE;;AAEf,YAAY;AACZ;EACE,yEAAyE;EACzE,yHAAyH;EACzH,2DAA2D;EAC3D,uEAAuE;EACvE,wEAAwE;EACxE,iEAAiE;EACjE,yCAAyC;EACzC,sCAAsC;EACtC,iCAAiC,EAAE;;AAErC;EACE,yEAAyE;EACzE,yHAAyH;EACzH,2DAA2D;EAC3D,uEAAuE;EACvE,wEAAwE;EACxE,iEAAiE;EACjE,8CAA8C;EAC9C,2CAA2C;EAC3C,sCAAsC,EAAE;;AAE1C,QAAQ;AACR;EACE,yEAAyE;EACzE,yHAAyH;EACzH,2DAA2D;EAC3D,uEAAuE;EACvE,wEAAwE;EACxE,iEAAiE;EACjE,yCAAyC;EACzC,sCAAsC;EACtC,iCAAiC,EAAE;;AAErC;EACE,yEAAyE;EACzE,yHAAyH;EACzH,2DAA2D;EAC3D,uEAAuE;EACvE,wEAAwE;EACxE,iEAAiE;EACjE,8CAA8C;EAC9C,2CAA2C;EAC3C,sCAAsC,EAAE;;AAE1C;EACE;IACE,WAAW,EAAE;;EAEf;IACE,WAAW,EAAE,EAAE;;AAEnB;EACE;IACE,WAAW,EAAE;;EAEf;IACE,WAAW,EAAE,EAAE;;AAEnB;EACE;IACE,WAAW,EAAE;;EAEf;IACE,WAAW,EAAE,EAAE;;AAEnB;EACE;IACE,WAAW,EAAE;;EAEf;IACE,WAAW,EAAE,EAAE;;AAEnB;EACE;IACE,WAAW,EAAE;;EAEf;IACE,WAAW,EAAE,EAAE;;AAEnB;EACE;IACE,WAAW,EAAE;;EAEf;IACE,WAAW,EAAE,EAAE;;AAEnB;EACE;IACE,WAAW,EAAE;;EAEf;IACE,WAAW,EAAE,EAAE;;AAEnB;EACE;IACE,WAAW,EAAE;;EAEf;IACE,WAAW,EAAE,EAAE","file":"flipclock.css","sourcesContent":["/* Get the bourbon mixin from http://bourbon.io */\n/* Reset */\n.flip-clock-wrapper * {\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    -ms-box-sizing: border-box;\n    -o-box-sizing: border-box;\n    box-sizing: border-box;\n    -webkit-backface-visibility: hidden;\n    -moz-backface-visibility: hidden;\n    -ms-backface-visibility: hidden;\n    -o-backface-visibility: hidden;\n    backface-visibility: hidden;\n}\n\n.flip-clock-wrapper a {\n  cursor: pointer;\n  text-decoration: none;\n  color: #ccc; }\n\n.flip-clock-wrapper a:hover {\n  color: #fff; }\n\n.flip-clock-wrapper ul {\n  list-style: none; }\n\n.flip-clock-wrapper.clearfix:before,\n.flip-clock-wrapper.clearfix:after {\n  content: \" \";\n  display: table; }\n\n.flip-clock-wrapper.clearfix:after {\n  clear: both; }\n\n.flip-clock-wrapper.clearfix {\n  *zoom: 1; }\n\n/* Main */\n.flip-clock-wrapper {\n  font: normal 11px \"Helvetica Neue\", Helvetica, sans-serif;\n  -webkit-user-select: none; }\n\n.flip-clock-meridium {\n  background: none !important;\n  box-shadow: 0 0 0 !important;\n  font-size: 36px !important; }\n\n.flip-clock-meridium a { color: #313333; }\n\n.flip-clock-wrapper {\n  text-align: center;\n  position: relative;\n  width: 100%;\n  margin: 1em;\n}\n\n.flip-clock-wrapper:before,\n.flip-clock-wrapper:after {\n    content: \" \"; /* 1 */\n    display: table; /* 2 */\n}\n.flip-clock-wrapper:after {\n    clear: both;\n}\n\n/* Skeleton */\n.flip-clock-wrapper ul {\n  position: relative;\n  float: left;\n  margin: 5px;\n  width: 60px;\n  height: 90px;\n  font-size: 80px;\n  font-weight: bold;\n  line-height: 87px;\n  border-radius: 6px;\n  background: #000;\n}\n\n.flip-clock-wrapper ul li {\n  z-index: 1;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  line-height: 87px;\n  text-decoration: none !important;\n}\n\n.flip-clock-wrapper ul li:first-child {\n  z-index: 2; }\n\n.flip-clock-wrapper ul li a {\n  display: block;\n  height: 100%;\n  -webkit-perspective: 200px;\n  -moz-perspective: 200px;\n  perspective: 200px;\n  margin: 0 !important;\n  overflow: visible !important;\n  cursor: default !important; }\n\n.flip-clock-wrapper ul li a div {\n  z-index: 1;\n  position: absolute;\n  left: 0;\n  width: 100%;\n  height: 50%;\n  font-size: 80px;\n  overflow: hidden; \n  outline: 1px solid transparent; }\n\n.flip-clock-wrapper ul li a div .shadow {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  z-index: 2; }\n\n.flip-clock-wrapper ul li a div.up {\n  -webkit-transform-origin: 50% 100%;\n  -moz-transform-origin: 50% 100%;\n  -ms-transform-origin: 50% 100%;\n  -o-transform-origin: 50% 100%;\n  transform-origin: 50% 100%;\n  top: 0; }\n\n.flip-clock-wrapper ul li a div.up:after {\n  content: \"\";\n  position: absolute;\n  top: 44px;\n  left: 0;\n  z-index: 5;\n  width: 100%;\n  height: 3px;\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.4); }\n\n.flip-clock-wrapper ul li a div.down {\n  -webkit-transform-origin: 50% 0;\n  -moz-transform-origin: 50% 0;\n  -ms-transform-origin: 50% 0;\n  -o-transform-origin: 50% 0;\n  transform-origin: 50% 0;\n  bottom: 0;\n  border-bottom-left-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n\n.flip-clock-wrapper ul li a div div.inn {\n  position: absolute;\n  left: 0;\n  z-index: 1;\n  width: 100%;\n  height: 200%;\n  color: #ccc;\n  text-shadow: 0 1px 2px #000;\n  text-align: center;\n  background-color: #333;\n  border-radius: 6px;\n  font-size: 70px; }\n\n.flip-clock-wrapper ul li a div.up div.inn {\n  top: 0; }\n\n.flip-clock-wrapper ul li a div.down div.inn {\n  bottom: 0; }\n\n/* PLAY */\n.flip-clock-wrapper ul.play li.flip-clock-before {\n  z-index: 3; }\n\n.flip-clock-wrapper .flip {   box-shadow: 0 2px 5px rgba(0, 0, 0, 0.7); }\n\n.flip-clock-wrapper ul.play li.flip-clock-active {\n  -webkit-animation: asd 0.01s 0.49s linear both;\n  -moz-animation: asd 0.01s 0.49s linear both;\n  animation: asd 0.01s 0.49s linear both;\n  z-index: 5; }\n\n.flip-clock-divider {\n  float: left;\n  display: inline-block;\n  position: relative;\n  width: 20px;\n  height: 100px; }\n\n.flip-clock-divider:first-child {\n  width: 0; }\n\n.flip-clock-dot {\n  display: block;\n  background: #323434;\n  width: 10px;\n  height: 10px;\n  position: absolute;\n  border-radius: 50%;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\n  left: 5px; }\n\n.flip-clock-divider .flip-clock-label {\n  position: absolute;\n  top: -1.5em;\n  right: -86px;\n  color: black;\n  text-shadow: none; }\n\n.flip-clock-divider.minutes .flip-clock-label {\n  right: -88px; }\n\n.flip-clock-divider.seconds .flip-clock-label {\n  right: -91px; }\n\n.flip-clock-dot.top {\n  top: 30px; }\n\n.flip-clock-dot.bottom {\n  bottom: 30px; }\n\n@-webkit-keyframes asd {\n  0% {\n    z-index: 2; }\n\n  100% {\n    z-index: 4; } }\n\n@-moz-keyframes asd {\n  0% {\n    z-index: 2; }\n\n  100% {\n    z-index: 4; } }\n\n@-o-keyframes asd {\n  0% {\n    z-index: 2; }\n\n  100% {\n    z-index: 4; } }\n\n@keyframes asd {\n  0% {\n    z-index: 2; }\n\n  100% {\n    z-index: 4; } }\n\n.flip-clock-wrapper ul.play li.flip-clock-active .down {\n  z-index: 2;\n  -webkit-animation: turn 0.5s 0.5s linear both;\n  -moz-animation: turn 0.5s 0.5s linear both;\n  animation: turn 0.5s 0.5s linear both; }\n\n@-webkit-keyframes turn {\n  0% {\n    -webkit-transform: rotateX(90deg); }\n\n  100% {\n    -webkit-transform: rotateX(0deg); } }\n\n@-moz-keyframes turn {\n  0% {\n    -moz-transform: rotateX(90deg); }\n\n  100% {\n    -moz-transform: rotateX(0deg); } }\n\n@-o-keyframes turn {\n  0% {\n    -o-transform: rotateX(90deg); }\n\n  100% {\n    -o-transform: rotateX(0deg); } }\n\n@keyframes turn {\n  0% {\n    transform: rotateX(90deg); }\n\n  100% {\n    transform: rotateX(0deg); } }\n\n.flip-clock-wrapper ul.play li.flip-clock-before .up {\n  z-index: 2;\n  -webkit-animation: turn2 0.5s linear both;\n  -moz-animation: turn2 0.5s linear both;\n  animation: turn2 0.5s linear both; }\n\n@-webkit-keyframes turn2 {\n  0% {\n    -webkit-transform: rotateX(0deg); }\n\n  100% {\n    -webkit-transform: rotateX(-90deg); } }\n\n@-moz-keyframes turn2 {\n  0% {\n    -moz-transform: rotateX(0deg); }\n\n  100% {\n    -moz-transform: rotateX(-90deg); } }\n\n@-o-keyframes turn2 {\n  0% {\n    -o-transform: rotateX(0deg); }\n\n  100% {\n    -o-transform: rotateX(-90deg); } }\n\n@keyframes turn2 {\n  0% {\n    transform: rotateX(0deg); }\n\n  100% {\n    transform: rotateX(-90deg); } }\n\n.flip-clock-wrapper ul li.flip-clock-active {\n  z-index: 3; }\n\n/* SHADOW */\n.flip-clock-wrapper ul.play li.flip-clock-before .up .shadow {\n  background: -moz-linear-gradient(top, rgba(0, 0, 0, 0.1) 0%, black 100%);\n  background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, rgba(0, 0, 0, 0.1)), color-stop(100%, black));\n  background: linear, top, rgba(0, 0, 0, 0.1) 0%, black 100%;\n  background: -o-linear-gradient(top, rgba(0, 0, 0, 0.1) 0%, black 100%);\n  background: -ms-linear-gradient(top, rgba(0, 0, 0, 0.1) 0%, black 100%);\n  background: linear, to bottom, rgba(0, 0, 0, 0.1) 0%, black 100%;\n  -webkit-animation: show 0.5s linear both;\n  -moz-animation: show 0.5s linear both;\n  animation: show 0.5s linear both; }\n\n.flip-clock-wrapper ul.play li.flip-clock-active .up .shadow {\n  background: -moz-linear-gradient(top, rgba(0, 0, 0, 0.1) 0%, black 100%);\n  background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, rgba(0, 0, 0, 0.1)), color-stop(100%, black));\n  background: linear, top, rgba(0, 0, 0, 0.1) 0%, black 100%;\n  background: -o-linear-gradient(top, rgba(0, 0, 0, 0.1) 0%, black 100%);\n  background: -ms-linear-gradient(top, rgba(0, 0, 0, 0.1) 0%, black 100%);\n  background: linear, to bottom, rgba(0, 0, 0, 0.1) 0%, black 100%;\n  -webkit-animation: hide 0.5s 0.3s linear both;\n  -moz-animation: hide 0.5s 0.3s linear both;\n  animation: hide 0.5s 0.3s linear both; }\n\n/*DOWN*/\n.flip-clock-wrapper ul.play li.flip-clock-before .down .shadow {\n  background: -moz-linear-gradient(top, black 0%, rgba(0, 0, 0, 0.1) 100%);\n  background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, black), color-stop(100%, rgba(0, 0, 0, 0.1)));\n  background: linear, top, black 0%, rgba(0, 0, 0, 0.1) 100%;\n  background: -o-linear-gradient(top, black 0%, rgba(0, 0, 0, 0.1) 100%);\n  background: -ms-linear-gradient(top, black 0%, rgba(0, 0, 0, 0.1) 100%);\n  background: linear, to bottom, black 0%, rgba(0, 0, 0, 0.1) 100%;\n  -webkit-animation: show 0.5s linear both;\n  -moz-animation: show 0.5s linear both;\n  animation: show 0.5s linear both; }\n\n.flip-clock-wrapper ul.play li.flip-clock-active .down .shadow {\n  background: -moz-linear-gradient(top, black 0%, rgba(0, 0, 0, 0.1) 100%);\n  background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, black), color-stop(100%, rgba(0, 0, 0, 0.1)));\n  background: linear, top, black 0%, rgba(0, 0, 0, 0.1) 100%;\n  background: -o-linear-gradient(top, black 0%, rgba(0, 0, 0, 0.1) 100%);\n  background: -ms-linear-gradient(top, black 0%, rgba(0, 0, 0, 0.1) 100%);\n  background: linear, to bottom, black 0%, rgba(0, 0, 0, 0.1) 100%;\n  -webkit-animation: hide 0.5s 0.3s linear both;\n  -moz-animation: hide 0.5s 0.3s linear both;\n  animation: hide 0.5s 0.2s linear both; }\n\n@-webkit-keyframes show {\n  0% {\n    opacity: 0; }\n\n  100% {\n    opacity: 1; } }\n\n@-moz-keyframes show {\n  0% {\n    opacity: 0; }\n\n  100% {\n    opacity: 1; } }\n\n@-o-keyframes show {\n  0% {\n    opacity: 0; }\n\n  100% {\n    opacity: 1; } }\n\n@keyframes show {\n  0% {\n    opacity: 0; }\n\n  100% {\n    opacity: 1; } }\n\n@-webkit-keyframes hide {\n  0% {\n    opacity: 1; }\n\n  100% {\n    opacity: 0; } }\n\n@-moz-keyframes hide {\n  0% {\n    opacity: 1; }\n\n  100% {\n    opacity: 0; } }\n\n@-o-keyframes hide {\n  0% {\n    opacity: 1; }\n\n  100% {\n    opacity: 0; } }\n\n@keyframes hide {\n  0% {\n    opacity: 1; }\n\n  100% {\n    opacity: 0; } }\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "tags-input {\n  display: block;\n}\ntags-input *, tags-input *:before, tags-input *:after {\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\ntags-input .host {\n  position: relative;\n  margin-top: 5px;\n  margin-bottom: 5px;\n  height: 100%;\n}\ntags-input .host:active {\n  outline: none;\n}\n\ntags-input .tags {\n  -moz-appearance: textfield;\n  -webkit-appearance: textfield;\n  padding: 1px;\n  overflow: hidden;\n  word-wrap: break-word;\n  cursor: text;\n  background-color: #fff;\n  border: 1px solid darkgray;\n  box-shadow: 1px 1px 1px 0 lightgray inset;\n  height: 100%;\n}\ntags-input .tags.focused {\n  outline: none;\n  -webkit-box-shadow: 0 0 3px 1px rgba(5, 139, 242, 0.6);\n  -moz-box-shadow: 0 0 3px 1px rgba(5, 139, 242, 0.6);\n  box-shadow: 0 0 3px 1px rgba(5, 139, 242, 0.6);\n}\ntags-input .tags .tag-list {\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n}\ntags-input .tags .tag-item {\n  margin: 2px;\n  padding: 0 5px;\n  display: inline-block;\n  float: left;\n  font: 14px \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  height: 26px;\n  line-height: 25px;\n  border: 1px solid #acacac;\n  border-radius: 3px;\n  background: -webkit-linear-gradient(top, #f0f9ff 0%, #cbebff 47%, #a1dbff 100%);\n  background: linear-gradient(to bottom, #f0f9ff 0%, #cbebff 47%, #a1dbff 100%);\n}\ntags-input .tags .tag-item.selected {\n  background: -webkit-linear-gradient(top, #febbbb 0%, #fe9090 45%, #ff5c5c 100%);\n  background: linear-gradient(to bottom, #febbbb 0%, #fe9090 45%, #ff5c5c 100%);\n}\ntags-input .tags .tag-item .remove-button {\n  margin: 0 0 0 5px;\n  padding: 0;\n  border: none;\n  background: none;\n  cursor: pointer;\n  vertical-align: middle;\n  font: bold 16px Arial, sans-serif;\n  color: #585858;\n}\ntags-input .tags .tag-item .remove-button:active {\n  color: #ff0000;\n}\ntags-input .tags .input {\n  border: 0;\n  outline: none;\n  margin: 2px;\n  padding: 0;\n  padding-left: 5px;\n  float: left;\n  height: 26px;\n  font: 14px \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\ntags-input .tags .input.invalid-tag {\n  color: #ff0000;\n}\ntags-input .tags .input::-ms-clear {\n  display: none;\n}\ntags-input.ng-invalid .tags {\n  -webkit-box-shadow: 0 0 3px 1px rgba(255, 0, 0, 0.6);\n  -moz-box-shadow: 0 0 3px 1px rgba(255, 0, 0, 0.6);\n  box-shadow: 0 0 3px 1px rgba(255, 0, 0, 0.6);\n}\ntags-input[disabled] .host:focus {\n  outline: none;\n}\ntags-input[disabled] .tags {\n  background-color: #eee;\n  cursor: default;\n}\ntags-input[disabled] .tags .tag-item {\n  opacity: 0.65;\n  background: -webkit-linear-gradient(top, #f0f9ff 0%, rgba(203, 235, 255, 0.75) 47%, rgba(161, 219, 255, 0.62) 100%);\n  background: linear-gradient(to bottom, #f0f9ff 0%, rgba(203, 235, 255, 0.75) 47%, rgba(161, 219, 255, 0.62) 100%);\n}\ntags-input[disabled] .tags .tag-item .remove-button {\n  cursor: default;\n}\ntags-input[disabled] .tags .tag-item .remove-button:active {\n  color: #585858;\n}\ntags-input[disabled] .tags .input {\n  background-color: #eee;\n  cursor: default;\n}\n\ntags-input .autocomplete {\n  margin-top: 5px;\n  position: absolute;\n  padding: 5px 0;\n  z-index: 999;\n  width: 100%;\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n  -moz-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n}\ntags-input .autocomplete .suggestion-list {\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n  max-height: 280px;\n  overflow-y: auto;\n  position: relative;\n}\ntags-input .autocomplete .suggestion-item {\n  padding: 5px 10px;\n  cursor: pointer;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font: 16px \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  color: #000;\n  background-color: #fff;\n}\ntags-input .autocomplete .suggestion-item.selected {\n  color: #fff;\n  background-color: #0097cf;\n}\ntags-input .autocomplete .suggestion-item.selected em {\n  color: #fff;\n  background-color: #0097cf;\n}\ntags-input .autocomplete .suggestion-item em {\n  font: normal bold 16px \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  color: #000;\n  background-color: #fff;\n}\n\n/*# sourceMappingURL=ng-tags-input.css.map */\n", "", {"version":3,"sources":["/./node_modules/ng-tags-input/build/ng-tags-input.css"],"names":[],"mappings":"AAAA;EACE,eAAe;CAChB;AACD;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,uBAAuB;CACxB;AACD;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;CACd;AACD;EACE,cAAc;CACf;;AAED;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,0CAA0C;EAC1C,aAAa;CACd;AACD;EACE,cAAc;EACd,uDAAuD;EACvD,oDAAoD;EACpD,+CAA+C;CAChD;AACD;EACE,UAAU;EACV,WAAW;EACX,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,0DAA0D;EAC1D,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,gFAAgF;EAChF,8EAA8E;CAC/E;AACD;EACE,gFAAgF;EAChF,8EAA8E;CAC/E;AACD;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;CAChB;AACD;EACE,eAAe;CAChB;AACD;EACE,UAAU;EACV,cAAc;EACd,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,0DAA0D;CAC3D;AACD;EACE,eAAe;CAChB;AACD;EACE,cAAc;CACf;AACD;EACE,qDAAqD;EACrD,kDAAkD;EAClD,6CAA6C;CAC9C;AACD;EACE,cAAc;CACf;AACD;EACE,uBAAuB;EACvB,gBAAgB;CACjB;AACD;EACE,cAAc;EACd,oHAAoH;EACpH,kHAAkH;CACnH;AACD;EACE,gBAAgB;CACjB;AACD;EACE,eAAe;CAChB;AACD;EACE,uBAAuB;EACvB,gBAAgB;CACjB;;AAED;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,qCAAqC;EACrC,kDAAkD;EAClD,+CAA+C;EAC/C,0CAA0C;CAC3C;AACD;EACE,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;CACpB;AACD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,wBAAwB;EACxB,0DAA0D;EAC1D,YAAY;EACZ,uBAAuB;CACxB;AACD;EACE,YAAY;EACZ,0BAA0B;CAC3B;AACD;EACE,YAAY;EACZ,0BAA0B;CAC3B;AACD;EACE,sEAAsE;EACtE,YAAY;EACZ,uBAAuB;CACxB;;AAED,6CAA6C","file":"ng-tags-input.css","sourcesContent":["tags-input {\n  display: block;\n}\ntags-input *, tags-input *:before, tags-input *:after {\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\ntags-input .host {\n  position: relative;\n  margin-top: 5px;\n  margin-bottom: 5px;\n  height: 100%;\n}\ntags-input .host:active {\n  outline: none;\n}\n\ntags-input .tags {\n  -moz-appearance: textfield;\n  -webkit-appearance: textfield;\n  padding: 1px;\n  overflow: hidden;\n  word-wrap: break-word;\n  cursor: text;\n  background-color: #fff;\n  border: 1px solid darkgray;\n  box-shadow: 1px 1px 1px 0 lightgray inset;\n  height: 100%;\n}\ntags-input .tags.focused {\n  outline: none;\n  -webkit-box-shadow: 0 0 3px 1px rgba(5, 139, 242, 0.6);\n  -moz-box-shadow: 0 0 3px 1px rgba(5, 139, 242, 0.6);\n  box-shadow: 0 0 3px 1px rgba(5, 139, 242, 0.6);\n}\ntags-input .tags .tag-list {\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n}\ntags-input .tags .tag-item {\n  margin: 2px;\n  padding: 0 5px;\n  display: inline-block;\n  float: left;\n  font: 14px \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  height: 26px;\n  line-height: 25px;\n  border: 1px solid #acacac;\n  border-radius: 3px;\n  background: -webkit-linear-gradient(top, #f0f9ff 0%, #cbebff 47%, #a1dbff 100%);\n  background: linear-gradient(to bottom, #f0f9ff 0%, #cbebff 47%, #a1dbff 100%);\n}\ntags-input .tags .tag-item.selected {\n  background: -webkit-linear-gradient(top, #febbbb 0%, #fe9090 45%, #ff5c5c 100%);\n  background: linear-gradient(to bottom, #febbbb 0%, #fe9090 45%, #ff5c5c 100%);\n}\ntags-input .tags .tag-item .remove-button {\n  margin: 0 0 0 5px;\n  padding: 0;\n  border: none;\n  background: none;\n  cursor: pointer;\n  vertical-align: middle;\n  font: bold 16px Arial, sans-serif;\n  color: #585858;\n}\ntags-input .tags .tag-item .remove-button:active {\n  color: #ff0000;\n}\ntags-input .tags .input {\n  border: 0;\n  outline: none;\n  margin: 2px;\n  padding: 0;\n  padding-left: 5px;\n  float: left;\n  height: 26px;\n  font: 14px \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\ntags-input .tags .input.invalid-tag {\n  color: #ff0000;\n}\ntags-input .tags .input::-ms-clear {\n  display: none;\n}\ntags-input.ng-invalid .tags {\n  -webkit-box-shadow: 0 0 3px 1px rgba(255, 0, 0, 0.6);\n  -moz-box-shadow: 0 0 3px 1px rgba(255, 0, 0, 0.6);\n  box-shadow: 0 0 3px 1px rgba(255, 0, 0, 0.6);\n}\ntags-input[disabled] .host:focus {\n  outline: none;\n}\ntags-input[disabled] .tags {\n  background-color: #eee;\n  cursor: default;\n}\ntags-input[disabled] .tags .tag-item {\n  opacity: 0.65;\n  background: -webkit-linear-gradient(top, #f0f9ff 0%, rgba(203, 235, 255, 0.75) 47%, rgba(161, 219, 255, 0.62) 100%);\n  background: linear-gradient(to bottom, #f0f9ff 0%, rgba(203, 235, 255, 0.75) 47%, rgba(161, 219, 255, 0.62) 100%);\n}\ntags-input[disabled] .tags .tag-item .remove-button {\n  cursor: default;\n}\ntags-input[disabled] .tags .tag-item .remove-button:active {\n  color: #585858;\n}\ntags-input[disabled] .tags .input {\n  background-color: #eee;\n  cursor: default;\n}\n\ntags-input .autocomplete {\n  margin-top: 5px;\n  position: absolute;\n  padding: 5px 0;\n  z-index: 999;\n  width: 100%;\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n  -moz-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n}\ntags-input .autocomplete .suggestion-list {\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n  max-height: 280px;\n  overflow-y: auto;\n  position: relative;\n}\ntags-input .autocomplete .suggestion-item {\n  padding: 5px 10px;\n  cursor: pointer;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font: 16px \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  color: #000;\n  background-color: #fff;\n}\ntags-input .autocomplete .suggestion-item.selected {\n  color: #fff;\n  background-color: #0097cf;\n}\ntags-input .autocomplete .suggestion-item.selected em {\n  color: #fff;\n  background-color: #0097cf;\n}\ntags-input .autocomplete .suggestion-item em {\n  font: normal bold 16px \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  color: #000;\n  background-color: #fff;\n}\n\n/*# sourceMappingURL=ng-tags-input.css.map */\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "/* perfect-scrollbar v0.6.10 */\n.ps-container {\n  -ms-touch-action: none;\n  touch-action: none;\n  overflow: hidden !important;\n  -ms-overflow-style: none; }\n  @supports (-ms-overflow-style: none) {\n    .ps-container {\n      overflow: auto !important; } }\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    .ps-container {\n      overflow: auto !important; } }\n  .ps-container.ps-active-x > .ps-scrollbar-x-rail,\n  .ps-container.ps-active-y > .ps-scrollbar-y-rail {\n    display: block;\n    background-color: transparent; }\n  .ps-container.ps-in-scrolling {\n    pointer-events: none; }\n    .ps-container.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail {\n      background-color: #eee;\n      opacity: 0.9; }\n      .ps-container.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail > .ps-scrollbar-x {\n        background-color: #999; }\n    .ps-container.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail {\n      background-color: #eee;\n      opacity: 0.9; }\n      .ps-container.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail > .ps-scrollbar-y {\n        background-color: #999; }\n  .ps-container > .ps-scrollbar-x-rail {\n    display: none;\n    position: absolute;\n    /* please don't change 'position' */\n    -webkit-border-radius: 4px;\n    -moz-border-radius: 4px;\n    border-radius: 4px;\n    opacity: 0;\n    -webkit-transition: background-color .2s linear, opacity .2s linear;\n    -moz-transition: background-color .2s linear, opacity .2s linear;\n    -o-transition: background-color .2s linear, opacity .2s linear;\n    transition: background-color .2s linear, opacity .2s linear;\n    bottom: 3px;\n    /* there must be 'bottom' for ps-scrollbar-x-rail */\n    height: 8px; }\n    .ps-container > .ps-scrollbar-x-rail > .ps-scrollbar-x {\n      position: absolute;\n      /* please don't change 'position' */\n      background-color: #aaa;\n      -webkit-border-radius: 4px;\n      -moz-border-radius: 4px;\n      border-radius: 4px;\n      -webkit-transition: background-color .2s linear;\n      -moz-transition: background-color .2s linear;\n      -o-transition: background-color .2s linear;\n      transition: background-color .2s linear;\n      bottom: 0;\n      /* there must be 'bottom' for ps-scrollbar-x */\n      height: 8px; }\n  .ps-container > .ps-scrollbar-y-rail {\n    display: none;\n    position: absolute;\n    /* please don't change 'position' */\n    -webkit-border-radius: 4px;\n    -moz-border-radius: 4px;\n    border-radius: 4px;\n    opacity: 0;\n    -webkit-transition: background-color .2s linear, opacity .2s linear;\n    -moz-transition: background-color .2s linear, opacity .2s linear;\n    -o-transition: background-color .2s linear, opacity .2s linear;\n    transition: background-color .2s linear, opacity .2s linear;\n    right: 3px;\n    /* there must be 'right' for ps-scrollbar-y-rail */\n    width: 8px; }\n    .ps-container > .ps-scrollbar-y-rail > .ps-scrollbar-y {\n      position: absolute;\n      /* please don't change 'position' */\n      background-color: #aaa;\n      -webkit-border-radius: 4px;\n      -moz-border-radius: 4px;\n      border-radius: 4px;\n      -webkit-transition: background-color .2s linear;\n      -moz-transition: background-color .2s linear;\n      -o-transition: background-color .2s linear;\n      transition: background-color .2s linear;\n      right: 0;\n      /* there must be 'right' for ps-scrollbar-y */\n      width: 8px; }\n  .ps-container:hover.ps-in-scrolling {\n    pointer-events: none; }\n    .ps-container:hover.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail {\n      background-color: #eee;\n      opacity: 0.9; }\n      .ps-container:hover.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail > .ps-scrollbar-x {\n        background-color: #999; }\n    .ps-container:hover.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail {\n      background-color: #eee;\n      opacity: 0.9; }\n      .ps-container:hover.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail > .ps-scrollbar-y {\n        background-color: #999; }\n  .ps-container:hover > .ps-scrollbar-x-rail,\n  .ps-container:hover > .ps-scrollbar-y-rail {\n    opacity: 0.6; }\n  .ps-container:hover > .ps-scrollbar-x-rail:hover {\n    background-color: #eee;\n    opacity: 0.9; }\n    .ps-container:hover > .ps-scrollbar-x-rail:hover > .ps-scrollbar-x {\n      background-color: #999; }\n  .ps-container:hover > .ps-scrollbar-y-rail:hover {\n    background-color: #eee;\n    opacity: 0.9; }\n    .ps-container:hover > .ps-scrollbar-y-rail:hover > .ps-scrollbar-y {\n      background-color: #999; }\n", "", {"version":3,"sources":["/./node_modules/perfect-scrollbar/dist/css/perfect-scrollbar.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;EAC5B,yBAAyB,EAAE;EAC3B;IACE;MACE,0BAA0B,EAAE,EAAE;EAClC;IACE;MACE,0BAA0B,EAAE,EAAE;EAClC;;IAEE,eAAe;IACf,8BAA8B,EAAE;EAClC;IACE,qBAAqB,EAAE;IACvB;MACE,uBAAuB;MACvB,aAAa,EAAE;MACf;QACE,uBAAuB,EAAE;IAC7B;MACE,uBAAuB;MACvB,aAAa,EAAE;MACf;QACE,uBAAuB,EAAE;EAC/B;IACE,cAAc;IACd,mBAAmB;IACnB,oCAAoC;IACpC,2BAA2B;IAC3B,wBAAwB;IACxB,mBAAmB;IACnB,WAAW;IACX,oEAAoE;IACpE,iEAAiE;IACjE,+DAA+D;IAC/D,4DAA4D;IAC5D,YAAY;IACZ,oDAAoD;IACpD,YAAY,EAAE;IACd;MACE,mBAAmB;MACnB,oCAAoC;MACpC,uBAAuB;MACvB,2BAA2B;MAC3B,wBAAwB;MACxB,mBAAmB;MACnB,gDAAgD;MAChD,6CAA6C;MAC7C,2CAA2C;MAC3C,wCAAwC;MACxC,UAAU;MACV,+CAA+C;MAC/C,YAAY,EAAE;EAClB;IACE,cAAc;IACd,mBAAmB;IACnB,oCAAoC;IACpC,2BAA2B;IAC3B,wBAAwB;IACxB,mBAAmB;IACnB,WAAW;IACX,oEAAoE;IACpE,iEAAiE;IACjE,+DAA+D;IAC/D,4DAA4D;IAC5D,WAAW;IACX,mDAAmD;IACnD,WAAW,EAAE;IACb;MACE,mBAAmB;MACnB,oCAAoC;MACpC,uBAAuB;MACvB,2BAA2B;MAC3B,wBAAwB;MACxB,mBAAmB;MACnB,gDAAgD;MAChD,6CAA6C;MAC7C,2CAA2C;MAC3C,wCAAwC;MACxC,SAAS;MACT,8CAA8C;MAC9C,WAAW,EAAE;EACjB;IACE,qBAAqB,EAAE;IACvB;MACE,uBAAuB;MACvB,aAAa,EAAE;MACf;QACE,uBAAuB,EAAE;IAC7B;MACE,uBAAuB;MACvB,aAAa,EAAE;MACf;QACE,uBAAuB,EAAE;EAC/B;;IAEE,aAAa,EAAE;EACjB;IACE,uBAAuB;IACvB,aAAa,EAAE;IACf;MACE,uBAAuB,EAAE;EAC7B;IACE,uBAAuB;IACvB,aAAa,EAAE;IACf;MACE,uBAAuB,EAAE","file":"perfect-scrollbar.css","sourcesContent":["/* perfect-scrollbar v0.6.10 */\n.ps-container {\n  -ms-touch-action: none;\n  touch-action: none;\n  overflow: hidden !important;\n  -ms-overflow-style: none; }\n  @supports (-ms-overflow-style: none) {\n    .ps-container {\n      overflow: auto !important; } }\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    .ps-container {\n      overflow: auto !important; } }\n  .ps-container.ps-active-x > .ps-scrollbar-x-rail,\n  .ps-container.ps-active-y > .ps-scrollbar-y-rail {\n    display: block;\n    background-color: transparent; }\n  .ps-container.ps-in-scrolling {\n    pointer-events: none; }\n    .ps-container.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail {\n      background-color: #eee;\n      opacity: 0.9; }\n      .ps-container.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail > .ps-scrollbar-x {\n        background-color: #999; }\n    .ps-container.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail {\n      background-color: #eee;\n      opacity: 0.9; }\n      .ps-container.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail > .ps-scrollbar-y {\n        background-color: #999; }\n  .ps-container > .ps-scrollbar-x-rail {\n    display: none;\n    position: absolute;\n    /* please don't change 'position' */\n    -webkit-border-radius: 4px;\n    -moz-border-radius: 4px;\n    border-radius: 4px;\n    opacity: 0;\n    -webkit-transition: background-color .2s linear, opacity .2s linear;\n    -moz-transition: background-color .2s linear, opacity .2s linear;\n    -o-transition: background-color .2s linear, opacity .2s linear;\n    transition: background-color .2s linear, opacity .2s linear;\n    bottom: 3px;\n    /* there must be 'bottom' for ps-scrollbar-x-rail */\n    height: 8px; }\n    .ps-container > .ps-scrollbar-x-rail > .ps-scrollbar-x {\n      position: absolute;\n      /* please don't change 'position' */\n      background-color: #aaa;\n      -webkit-border-radius: 4px;\n      -moz-border-radius: 4px;\n      border-radius: 4px;\n      -webkit-transition: background-color .2s linear;\n      -moz-transition: background-color .2s linear;\n      -o-transition: background-color .2s linear;\n      transition: background-color .2s linear;\n      bottom: 0;\n      /* there must be 'bottom' for ps-scrollbar-x */\n      height: 8px; }\n  .ps-container > .ps-scrollbar-y-rail {\n    display: none;\n    position: absolute;\n    /* please don't change 'position' */\n    -webkit-border-radius: 4px;\n    -moz-border-radius: 4px;\n    border-radius: 4px;\n    opacity: 0;\n    -webkit-transition: background-color .2s linear, opacity .2s linear;\n    -moz-transition: background-color .2s linear, opacity .2s linear;\n    -o-transition: background-color .2s linear, opacity .2s linear;\n    transition: background-color .2s linear, opacity .2s linear;\n    right: 3px;\n    /* there must be 'right' for ps-scrollbar-y-rail */\n    width: 8px; }\n    .ps-container > .ps-scrollbar-y-rail > .ps-scrollbar-y {\n      position: absolute;\n      /* please don't change 'position' */\n      background-color: #aaa;\n      -webkit-border-radius: 4px;\n      -moz-border-radius: 4px;\n      border-radius: 4px;\n      -webkit-transition: background-color .2s linear;\n      -moz-transition: background-color .2s linear;\n      -o-transition: background-color .2s linear;\n      transition: background-color .2s linear;\n      right: 0;\n      /* there must be 'right' for ps-scrollbar-y */\n      width: 8px; }\n  .ps-container:hover.ps-in-scrolling {\n    pointer-events: none; }\n    .ps-container:hover.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail {\n      background-color: #eee;\n      opacity: 0.9; }\n      .ps-container:hover.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail > .ps-scrollbar-x {\n        background-color: #999; }\n    .ps-container:hover.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail {\n      background-color: #eee;\n      opacity: 0.9; }\n      .ps-container:hover.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail > .ps-scrollbar-y {\n        background-color: #999; }\n  .ps-container:hover > .ps-scrollbar-x-rail,\n  .ps-container:hover > .ps-scrollbar-y-rail {\n    opacity: 0.6; }\n  .ps-container:hover > .ps-scrollbar-x-rail:hover {\n    background-color: #eee;\n    opacity: 0.9; }\n    .ps-container:hover > .ps-scrollbar-x-rail:hover > .ps-scrollbar-x {\n      background-color: #999; }\n  .ps-container:hover > .ps-scrollbar-y-rail:hover {\n    background-color: #eee;\n    opacity: 0.9; }\n    .ps-container:hover > .ps-scrollbar-y-rail:hover > .ps-scrollbar-y {\n      background-color: #999; }\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["$"] = __webpack_require__(426);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 284 */
/***/ (function(module, exports) {

/*
	Base.js, version 1.1a
	Copyright 2006-2010, Dean Edwards
	License: http://www.opensource.org/licenses/mit-license.php
*/

var Base = function() {
	// dummy
};

Base.extend = function(_instance, _static) { // subclass
	
	"use strict";
	
	var extend = Base.prototype.extend;
	
	// build the prototype
	Base._prototyping = true;
	
	var proto = new this();
	
	extend.call(proto, _instance);
	
	proto.base = function() {
	// call this method from any other method to invoke that method's ancestor
	};

	delete Base._prototyping;
	
	// create the wrapper for the constructor function
	//var constructor = proto.constructor.valueOf(); //-dean
	var constructor = proto.constructor;
	var klass = proto.constructor = function() {
		if (!Base._prototyping) {
			if (this._constructing || this.constructor == klass) { // instantiation
				this._constructing = true;
				constructor.apply(this, arguments);
				delete this._constructing;
			} else if (arguments[0] !== null) { // casting
				return (arguments[0].extend || extend).call(arguments[0], proto);
			}
		}
	};
	
	// build the class interface
	klass.ancestor = this;
	klass.extend = this.extend;
	klass.forEach = this.forEach;
	klass.implement = this.implement;
	klass.prototype = proto;
	klass.toString = this.toString;
	klass.valueOf = function(type) {
		//return (type == "object") ? klass : constructor; //-dean
		return (type == "object") ? klass : constructor.valueOf();
	};
	extend.call(klass, _static);
	// class initialisation
	if (typeof klass.init == "function") klass.init();
	return klass;
};

Base.prototype = {	
	extend: function(source, value) {
		if (arguments.length > 1) { // extending with a name/value pair
			var ancestor = this[source];
			if (ancestor && (typeof value == "function") && // overriding a method?
				// the valueOf() comparison is to avoid circular references
				(!ancestor.valueOf || ancestor.valueOf() != value.valueOf()) &&
				/\bbase\b/.test(value)) {
				// get the underlying method
				var method = value.valueOf();
				// override
				value = function() {
					var previous = this.base || Base.prototype.base;
					this.base = ancestor;
					var returnValue = method.apply(this, arguments);
					this.base = previous;
					return returnValue;
				};
				// point to the underlying method
				value.valueOf = function(type) {
					return (type == "object") ? value : method;
				};
				value.toString = Base.toString;
			}
			this[source] = value;
		} else if (source) { // extending with an object literal
			var extend = Base.prototype.extend;
			// if this object has a customised extend method then use it
			if (!Base._prototyping && typeof this != "function") {
				extend = this.extend || extend;
			}
			var proto = {toSource: null};
			// do the "toString" and other methods manually
			var hidden = ["constructor", "toString", "valueOf"];
			// if we are prototyping then include the constructor
			var i = Base._prototyping ? 0 : 1;
			while (key = hidden[i++]) {
				if (source[key] != proto[key]) {
					extend.call(this, key, source[key]);

				}
			}
			// copy each of the source object's properties to this object
			for (var key in source) {
				if (!proto[key]) extend.call(this, key, source[key]);
			}
		}
		return this;
	}
};

// initialise
Base = Base.extend({
	constructor: function() {
		this.extend(arguments[0]);
	}
}, {
	ancestor: Object,
	version: "1.1",
	
	forEach: function(object, block, context) {
		for (var key in object) {
			if (this.prototype[key] === undefined) {
				block.call(context, object[key], key, object);
			}
		}
	},
		
	implement: function() {
		for (var i = 0; i < arguments.length; i++) {
			if (typeof arguments[i] == "function") {
				// if it's a function, call it
				arguments[i](this.prototype);
			} else {
				// add the interface using the extend method
				this.prototype.extend(arguments[i]);
			}
		}
		return this;
	},
	
	toString: function() {
		return String(this.valueOf());
	}
});
/*jshint smarttabs:true */

var FlipClock;
	
/**
 * FlipClock.js
 *
 * @author     Justin Kimbrell
 * @copyright  2013 - Objective HTML, LLC
 * @licesnse   http://www.opensource.org/licenses/mit-license.php
 */
	
(function($) {
	
	"use strict";
	
	/**
	 * FlipFlock Helper
	 *
	 * @param  object  A jQuery object or CSS select
	 * @param  int     An integer used to start the clock (no. seconds)
	 * @param  object  An object of properties to override the default	
	 */
	 
	FlipClock = function(obj, digit, options) {
		if(digit instanceof Object && digit instanceof Date === false) {
			options = digit;
			digit = 0;
		}

		return new FlipClock.Factory(obj, digit, options);
	};

	/**
	 * The global FlipClock.Lang object
	 */

	FlipClock.Lang = {};
	
	/**
	 * The Base FlipClock class is used to extend all other FlipFlock
	 * classes. It handles the callbacks and the basic setters/getters
	 *	
	 * @param 	object  An object of the default properties
	 * @param 	object  An object of properties to override the default	
	 */

	FlipClock.Base = Base.extend({
		
		/**
		 * Build Date
		 */
		 
		buildDate: '2014-12-12',
		
		/**
		 * Version
		 */
		 
		version: '0.7.7',
		
		/**
		 * Sets the default options
		 *
		 * @param	object 	The default options
		 * @param	object 	The override options
		 */
		 
		constructor: function(_default, options) {
			if(typeof _default !== "object") {
				_default = {};
			}
			if(typeof options !== "object") {
				options = {};
			}
			this.setOptions($.extend(true, {}, _default, options));
		},
		
		/**
		 * Delegates the callback to the defined method
		 *
		 * @param	object 	The default options
		 * @param	object 	The override options
		 */
		 
		callback: function(method) {
		 	if(typeof method === "function") {
				var args = [];
								
				for(var x = 1; x <= arguments.length; x++) {
					if(arguments[x]) {
						args.push(arguments[x]);
					}
				}
				
				method.apply(this, args);
			}
		},
		 
		/**
		 * Log a string into the console if it exists
		 *
		 * @param 	string 	The name of the option
		 * @return	mixed
		 */		
		 
		log: function(str) {
			if(window.console && console.log) {
				console.log(str);
			}
		},
		 
		/**
		 * Get an single option value. Returns false if option does not exist
		 *
		 * @param 	string 	The name of the option
		 * @return	mixed
		 */		
		 
		getOption: function(index) {
			if(this[index]) {
				return this[index];
			}
			return false;
		},
		
		/**
		 * Get all options
		 *
		 * @return	bool
		 */		
		 
		getOptions: function() {
			return this;
		},
		
		/**
		 * Set a single option value
		 *
		 * @param 	string 	The name of the option
		 * @param 	mixed 	The value of the option
		 */		
		 
		setOption: function(index, value) {
			this[index] = value;
		},
		
		/**
		 * Set a multiple options by passing a JSON object
		 *
		 * @param 	object 	The object with the options
		 * @param 	mixed 	The value of the option
		 */		
		
		setOptions: function(options) {
			for(var key in options) {
	  			if(typeof options[key] !== "undefined") {
		  			this.setOption(key, options[key]);
		  		}
		  	}
		}
		
	});
	
}(jQuery));

/*jshint smarttabs:true */

/**
 * FlipClock.js
 *
 * @author     Justin Kimbrell
 * @copyright  2013 - Objective HTML, LLC
 * @licesnse   http://www.opensource.org/licenses/mit-license.php
 */
	
(function($) {
	
	"use strict";
	
	/**
	 * The FlipClock Face class is the base class in which to extend
	 * all other FlockClock.Face classes.
	 *
	 * @param 	object  The parent FlipClock.Factory object
	 * @param 	object  An object of properties to override the default	
	 */
	 
	FlipClock.Face = FlipClock.Base.extend({
		
		/**
		 * Sets whether or not the clock should start upon instantiation
		 */
		 
		autoStart: true,

		/**
		 * An array of jQuery objects used for the dividers (the colons)
		 */
		 
		dividers: [],

		/**
		 * An array of FlipClock.List objects
		 */		
		 
		factory: false,
		
		/**
		 * An array of FlipClock.List objects
		 */		
		 
		lists: [],

		/**
		 * Constructor
		 *
		 * @param 	object  The parent FlipClock.Factory object
		 * @param 	object  An object of properties to override the default	
		 */
		 
		constructor: function(factory, options) {
			this.dividers = [];
			this.lists = [];
			this.base(options);
			this.factory = factory;
		},
		
		/**
		 * Build the clock face
		 */
		 
		build: function() {
			if(this.autoStart) {
				this.start();
			}
		},
		
		/**
		 * Creates a jQuery object used for the digit divider
		 *
		 * @param	mixed 	The divider label text
		 * @param	mixed	Set true to exclude the dots in the divider. 
		 *					If not set, is false.
		 */
		 
		createDivider: function(label, css, excludeDots) {
			if(typeof css == "boolean" || !css) {
				excludeDots = css;
				css = label;
			}

			var dots = [
				'<span class="'+this.factory.classes.dot+' top"></span>',
				'<span class="'+this.factory.classes.dot+' bottom"></span>'
			].join('');

			if(excludeDots) {
				dots = '';	
			}

			label = this.factory.localize(label);

			var html = [
				'<span class="'+this.factory.classes.divider+' '+(css ? css : '').toLowerCase()+'">',
					'<span class="'+this.factory.classes.label+'">'+(label ? label : '')+'</span>',
					dots,
				'</span>'
			];	
			
			var $html = $(html.join(''));

			this.dividers.push($html);

			return $html;
		},
		
		/**
		 * Creates a FlipClock.List object and appends it to the DOM
		 *
		 * @param	mixed 	The digit to select in the list
		 * @param	object  An object to override the default properties
		 */
		 
		createList: function(digit, options) {
			if(typeof digit === "object") {
				options = digit;
				digit = 0;
			}

			var obj = new FlipClock.List(this.factory, digit, options);
		
			this.lists.push(obj);

			return obj;
		},
		
		/**
		 * Triggers when the clock is reset
		 */

		reset: function() {
			this.factory.time = new FlipClock.Time(
				this.factory, 
				this.factory.original ? Math.round(this.factory.original) : 0,
				{
					minimumDigits: this.factory.minimumDigits
				}
			);

			this.flip(this.factory.original, false);
		},

		/**
		 * Append a newly created list to the clock
		 */

		appendDigitToClock: function(obj) {
			obj.$el.append(false);
		},

		/**
		 * Add a digit to the clock face
		 */
		 
		addDigit: function(digit) {
			var obj = this.createList(digit, {
				classes: {
					active: this.factory.classes.active,
					before: this.factory.classes.before,
					flip: this.factory.classes.flip
				}
			});

			this.appendDigitToClock(obj);
		},
		
		/**
		 * Triggers when the clock is started
		 */
		 
		start: function() {},
		
		/**
		 * Triggers when the time on the clock stops
		 */
		 
		stop: function() {},
		
		/**
		 * Auto increments/decrements the value of the clock face
		 */
		 
		autoIncrement: function() {
			if(!this.factory.countdown) {
				this.increment();
			}
			else {
				this.decrement();
			}
		},

		/**
		 * Increments the value of the clock face
		 */
		 
		increment: function() {
			this.factory.time.addSecond();
		},

		/**
		 * Decrements the value of the clock face
		 */

		decrement: function() {
			if(this.factory.time.getTimeSeconds() == 0) {
	        	this.factory.stop()
			}
			else {
				this.factory.time.subSecond();
			}
		},
			
		/**
		 * Triggers when the numbers on the clock flip
		 */
		 
		flip: function(time, doNotAddPlayClass) {
			var t = this;

			$.each(time, function(i, digit) {
				var list = t.lists[i];

				if(list) {
					if(!doNotAddPlayClass && digit != list.digit) {
						list.play();	
					}

					list.select(digit);
				}	
				else {
					t.addDigit(digit);
				}
			});
		}
					
	});
	
}(jQuery));

/*jshint smarttabs:true */

/**
 * FlipClock.js
 *
 * @author     Justin Kimbrell
 * @copyright  2013 - Objective HTML, LLC
 * @licesnse   http://www.opensource.org/licenses/mit-license.php
 */
	
(function($) {
	
	"use strict";
	
	/**
	 * The FlipClock Factory class is used to build the clock and manage
	 * all the public methods.
	 *
	 * @param 	object  A jQuery object or CSS selector used to fetch
	 				    the wrapping DOM nodes
	 * @param 	mixed   This is the digit used to set the clock. If an 
	 				    object is passed, 0 will be used.	
	 * @param 	object  An object of properties to override the default	
	 */
	 	
	FlipClock.Factory = FlipClock.Base.extend({
		
		/**
		 * The clock's animation rate.
		 * 
		 * Note, currently this property doesn't do anything.
		 * This property is here to be used in the future to
		 * programmaticaly set the clock's animation speed
		 */		

		animationRate: 1000,

		/**
		 * Auto start the clock on page load (True|False)
		 */	
		 
		autoStart: true,
		
		/**
		 * The callback methods
		 */		
		 
		callbacks: {
			destroy: false,
			create: false,
			init: false,
			interval: false,
			start: false,
			stop: false,
			reset: false
		},
		
		/**
		 * The CSS classes
		 */		
		 
		classes: {
			active: 'flip-clock-active',
			before: 'flip-clock-before',
			divider: 'flip-clock-divider',
			dot: 'flip-clock-dot',
			label: 'flip-clock-label',
			flip: 'flip',
			play: 'play',
			wrapper: 'flip-clock-wrapper'
		},
		
		/**
		 * The name of the clock face class in use
		 */	
		 
		clockFace: 'HourlyCounter',
		 
		/**
		 * The name of the clock face class in use
		 */	
		 
		countdown: false,
		 
		/**
		 * The name of the default clock face class to use if the defined
		 * clockFace variable is not a valid FlipClock.Face object
		 */	
		 
		defaultClockFace: 'HourlyCounter',
		 
		/**
		 * The default language
		 */	
		 
		defaultLanguage: 'english',
		 
		/**
		 * The jQuery object
		 */		
		 
		$el: false,

		/**
		 * The FlipClock.Face object
		 */	
		 
		face: true,
		 
		/**
		 * The language object after it has been loaded
		 */	
		 
		lang: false,
		 
		/**
		 * The language being used to display labels (string)
		 */	
		 
		language: 'english',
		 
		/**
		 * The minimum digits the clock must have
		 */		

		minimumDigits: 0,

		/**
		 * The original starting value of the clock. Used for the reset method.
		 */		
		 
		original: false,
		
		/**
		 * Is the clock running? (True|False)
		 */		
		 
		running: false,
		
		/**
		 * The FlipClock.Time object
		 */		
		 
		time: false,
		
		/**
		 * The FlipClock.Timer object
		 */		
		 
		timer: false,
		
		/**
		 * The jQuery object (depcrecated)
		 */		
		 
		$wrapper: false,
		
		/**
		 * Constructor
		 *
		 * @param   object  The wrapping jQuery object
		 * @param	object  Number of seconds used to start the clock
		 * @param	object 	An object override options
		 */
		 
		constructor: function(obj, digit, options) {

			if(!options) {
				options = {};
			}

			this.lists = [];
			this.running = false;
			this.base(options);	

			this.$el = $(obj).addClass(this.classes.wrapper);

			// Depcrated support of the $wrapper property.
			this.$wrapper = this.$el;

			this.original = (digit instanceof Date) ? digit : (digit ? Math.round(digit) : 0);

			this.time = new FlipClock.Time(this, this.original, {
				minimumDigits: this.minimumDigits,
				animationRate: this.animationRate 
			});

			this.timer = new FlipClock.Timer(this, options);

			this.loadLanguage(this.language);
			
			this.loadClockFace(this.clockFace, options);

			if(this.autoStart) {
				this.start();
			}

		},
		
		/**
		 * Load the FlipClock.Face object
		 *
		 * @param	object  The name of the FlickClock.Face class
		 * @param	object 	An object override options
		 */
		 
		loadClockFace: function(name, options) {	
			var face, suffix = 'Face', hasStopped = false;
			
			name = name.ucfirst()+suffix;

			if(this.face.stop) {
				this.stop();
				hasStopped = true;
			}

			this.$el.html('');

			this.time.minimumDigits = this.minimumDigits;
			
			if(FlipClock[name]) {
				face = new FlipClock[name](this, options);
			}
			else {
				face = new FlipClock[this.defaultClockFace+suffix](this, options);
			}
			
			face.build();

			this.face = face

			if(hasStopped) {
				this.start();
			}
			
			return this.face;
		},
				
		/**
		 * Load the FlipClock.Lang object
		 *
		 * @param	object  The name of the language to load
		 */
		 
		loadLanguage: function(name) {	
			var lang;
			
			if(FlipClock.Lang[name.ucfirst()]) {
				lang = FlipClock.Lang[name.ucfirst()];
			}
			else if(FlipClock.Lang[name]) {
				lang = FlipClock.Lang[name];
			}
			else {
				lang = FlipClock.Lang[this.defaultLanguage];
			}
			
			return this.lang = lang;
		},
					
		/**
		 * Localize strings into various languages
		 *
		 * @param	string  The index of the localized string
		 * @param	object  Optionally pass a lang object
		 */

		localize: function(index, obj) {
			var lang = this.lang;

			if(!index) {
				return null;
			}

			var lindex = index.toLowerCase();

			if(typeof obj == "object") {
				lang = obj;
			}

			if(lang && lang[lindex]) {
				return lang[lindex];
			}

			return index;
		},
		 

		/**
		 * Starts the clock
		 */
		 
		start: function(callback) {
			var t = this;

			if(!t.running && (!t.countdown || t.countdown && t.time.time > 0)) {
				t.face.start(t.time);
				t.timer.start(function() {
					t.flip();
					
					if(typeof callback === "function") {
						callback();
					}	
				});
			}
			else {
				t.log('Trying to start timer when countdown already at 0');
			}
		},
		
		/**
		 * Stops the clock
		 */
		 
		stop: function(callback) {
			this.face.stop();
			this.timer.stop(callback);
			
			for(var x in this.lists) {
				if (this.lists.hasOwnProperty(x)) {
					this.lists[x].stop();
				}
			}	
		},
		
		/**
		 * Reset the clock
		 */
		 
		reset: function(callback) {
			this.timer.reset(callback);
			this.face.reset();
		},
		
		/**
		 * Sets the clock time
		 */
		 
		setTime: function(time) {
			this.time.time = time;
			this.flip(true);		
		},
		
		/**
		 * Get the clock time
		 *
		 * @return  object  Returns a FlipClock.Time object
		 */
		 
		getTime: function(time) {
			return this.time;		
		},
		
		/**
		 * Changes the increment of time to up or down (add/sub)
		 */
		 
		setCountdown: function(value) {
			var running = this.running;
			
			this.countdown = value ? true : false;
				
			if(running) {
				this.stop();
				this.start();
			}
		},
		
		/**
		 * Flip the digits on the clock
		 *
		 * @param  array  An array of digits	 
		 */
		flip: function(doNotAddPlayClass) {	
			this.face.flip(false, doNotAddPlayClass);
		}
		
	});
		
}(jQuery));

/*jshint smarttabs:true */

/**
 * FlipClock.js
 *
 * @author     Justin Kimbrell
 * @copyright  2013 - Objective HTML, LLC
 * @licesnse   http://www.opensource.org/licenses/mit-license.php
 */
	
(function($) {
	
	"use strict";
	
	/**
	 * The FlipClock List class is used to build the list used to create 
	 * the card flip effect. This object fascilates selecting the correct
	 * node by passing a specific digit.
	 *
	 * @param 	object  A FlipClock.Factory object
	 * @param 	mixed   This is the digit used to set the clock. If an 
	 *				    object is passed, 0 will be used.	
	 * @param 	object  An object of properties to override the default	
	 */
	 	
	FlipClock.List = FlipClock.Base.extend({
		
		/**
		 * The digit (0-9)
		 */		
		 
		digit: 0,
		
		/**
		 * The CSS classes
		 */		
		 
		classes: {
			active: 'flip-clock-active',
			before: 'flip-clock-before',
			flip: 'flip'	
		},
				
		/**
		 * The parent FlipClock.Factory object
		 */		
		 
		factory: false,
		
		/**
		 * The jQuery object
		 */		
		 
		$el: false,

		/**
		 * The jQuery object (deprecated)
		 */		
		 
		$obj: false,
		
		/**
		 * The items in the list
		 */		
		 
		items: [],
		
		/**
		 * The last digit
		 */		
		 
		lastDigit: 0,
			
		/**
		 * Constructor
		 *
		 * @param  object  A FlipClock.Factory object
		 * @param  int     An integer use to select the correct digit
		 * @param  object  An object to override the default properties	 
		 */
		 
		constructor: function(factory, digit, options) {
			this.factory = factory;
			this.digit = digit;
			this.lastDigit = digit;
			this.$el = this.createList();
			
			// Depcrated support of the $obj property.
			this.$obj = this.$el;

			if(digit > 0) {
				this.select(digit);
			}

			this.factory.$el.append(this.$el);
		},
		
		/**
		 * Select the digit in the list
		 *
		 * @param  int  A digit 0-9	 
		 */
		 
		select: function(digit) {
			if(typeof digit === "undefined") {
				digit = this.digit;
			}
			else {
				this.digit = digit;
			}

			if(this.digit != this.lastDigit) {
				var $delete = this.$el.find('.'+this.classes.before).removeClass(this.classes.before);

				this.$el.find('.'+this.classes.active).removeClass(this.classes.active)
													  .addClass(this.classes.before);

				this.appendListItem(this.classes.active, this.digit);

				$delete.remove();

				this.lastDigit = this.digit;
			}	
		},
		
		/**
		 * Adds the play class to the DOM object
		 */
		 		
		play: function() {
			this.$el.addClass(this.factory.classes.play);
		},
		
		/**
		 * Removes the play class to the DOM object 
		 */
		 
		stop: function() {
			var t = this;

			setTimeout(function() {
				t.$el.removeClass(t.factory.classes.play);
			}, this.factory.timer.interval);
		},
		
		/**
		 * Creates the list item HTML and returns as a string 
		 */
		 
		createListItem: function(css, value) {
			return [
				'<li class="'+(css ? css : '')+'">',
					'<a href="#">',
						'<div class="up">',
							'<div class="shadow"></div>',
							'<div class="inn">'+(value ? value : '')+'</div>',
						'</div>',
						'<div class="down">',
							'<div class="shadow"></div>',
							'<div class="inn">'+(value ? value : '')+'</div>',
						'</div>',
					'</a>',
				'</li>'
			].join('');
		},

		/**
		 * Append the list item to the parent DOM node 
		 */

		appendListItem: function(css, value) {
			var html = this.createListItem(css, value);

			this.$el.append(html);
		},

		/**
		 * Create the list of digits and appends it to the DOM object 
		 */
		 
		createList: function() {

			var lastDigit = this.getPrevDigit() ? this.getPrevDigit() : this.digit;

			var html = $([
				'<ul class="'+this.classes.flip+' '+(this.factory.running ? this.factory.classes.play : '')+'">',
					this.createListItem(this.classes.before, lastDigit),
					this.createListItem(this.classes.active, this.digit),
				'</ul>'
			].join(''));
					
			return html;
		},

		getNextDigit: function() {
			return this.digit == 9 ? 0 : this.digit + 1;
		},

		getPrevDigit: function() {
			return this.digit == 0 ? 9 : this.digit - 1;
		}

	});
	
	
}(jQuery));

/*jshint smarttabs:true */

/**
 * FlipClock.js
 *
 * @author     Justin Kimbrell
 * @copyright  2013 - Objective HTML, LLC
 * @licesnse   http://www.opensource.org/licenses/mit-license.php
 */
	
(function($) {
	
	"use strict";
	
	/**
	 * Capitalize the first letter in a string
	 *
	 * @return string
	 */
	 
	String.prototype.ucfirst = function() {
		return this.substr(0, 1).toUpperCase() + this.substr(1);
	};
	
	/**
	 * jQuery helper method
	 *
	 * @param  int     An integer used to start the clock (no. seconds)
	 * @param  object  An object of properties to override the default	
	 */
	 
	$.fn.FlipClock = function(digit, options) {	
		return new FlipClock($(this), digit, options);
	};
	
	/**
	 * jQuery helper method
	 *
	 * @param  int     An integer used to start the clock (no. seconds)
	 * @param  object  An object of properties to override the default	
	 */
	 
	$.fn.flipClock = function(digit, options) {
		return $.fn.FlipClock(digit, options);
	};
	
}(jQuery));

/*jshint smarttabs:true */

/**
 * FlipClock.js
 *
 * @author     Justin Kimbrell
 * @copyright  2013 - Objective HTML, LLC
 * @licesnse   http://www.opensource.org/licenses/mit-license.php
 */
	
(function($) {
	
	"use strict";
			
	/**
	 * The FlipClock Time class is used to manage all the time 
	 * calculations.
	 *
	 * @param 	object  A FlipClock.Factory object
	 * @param 	mixed   This is the digit used to set the clock. If an 
	 *				    object is passed, 0 will be used.	
	 * @param 	object  An object of properties to override the default	
	 */
	 	
	FlipClock.Time = FlipClock.Base.extend({
		
		/**
		 * The time (in seconds) or a date object
		 */		
		 
		time: 0,
		
		/**
		 * The parent FlipClock.Factory object
		 */		
		 
		factory: false,
		
		/**
		 * The minimum number of digits the clock face must have
		 */		
		 
		minimumDigits: 0,

		/**
		 * Constructor
		 *
		 * @param  object  A FlipClock.Factory object
		 * @param  int     An integer use to select the correct digit
		 * @param  object  An object to override the default properties	 
		 */
		 
		constructor: function(factory, time, options) {
			if(typeof options != "object") {
				options = {};
			}

			if(!options.minimumDigits) {
				options.minimumDigits = factory.minimumDigits;
			}

			this.base(options);
			this.factory = factory;

			if(time) {
				this.time = time;
			}
		},

		/**
		 * Convert a string or integer to an array of digits
		 *
		 * @param   mixed  String or Integer of digits	 
		 * @return  array  An array of digits 
		 */
		 
		convertDigitsToArray: function(str) {
			var data = [];
			
			str = str.toString();
			
			for(var x = 0;x < str.length; x++) {
				if(str[x].match(/^\d*$/g)) {
					data.push(str[x]);	
				}
			}
			
			return data;
		},
		
		/**
		 * Get a specific digit from the time integer
		 *
		 * @param   int    The specific digit to select from the time	 
		 * @return  mixed  Returns FALSE if no digit is found, otherwise
		 *				   the method returns the defined digit	 
		 */
		 
		digit: function(i) {
			var timeStr = this.toString();
			var length  = timeStr.length;
			
			if(timeStr[length - i])	 {
				return timeStr[length - i];
			}
			
			return false;
		},

		/**
		 * Formats any array of digits into a valid array of digits
		 *
		 * @param   mixed  An array of digits	 
		 * @return  array  An array of digits 
		 */
		 
		digitize: function(obj) {
			var data = [];

			$.each(obj, function(i, value) {
				value = value.toString();
				
				if(value.length == 1) {
					value = '0'+value;
				}
				
				for(var x = 0; x < value.length; x++) {
					data.push(value.charAt(x));
				}				
			});

			if(data.length > this.minimumDigits) {
				this.minimumDigits = data.length;
			}
			
			if(this.minimumDigits > data.length) {
				for(var x = data.length; x < this.minimumDigits; x++) {
					data.unshift('0');
				}
			}

			return data;
		},
		
		/**
		 * Gets a new Date object for the current time
		 *
		 * @return  array  Returns a Date object
		 */

		getDateObject: function() {
			if(this.time instanceof Date) {
				return this.time;
			}

			return new Date((new Date()).getTime() + this.getTimeSeconds() * 1000);
		},
		
		/**
		 * Gets a digitized daily counter
		 *
		 * @return  object  Returns a digitized object
		 */

		getDayCounter: function(includeSeconds) {
			var digits = [
				this.getDays(),
				this.getHours(true),
				this.getMinutes(true)
			];

			if(includeSeconds) {
				digits.push(this.getSeconds(true));
			}

			return this.digitize(digits);
		},

		/**
		 * Gets number of days
		 *
		 * @param   bool  Should perform a modulus? If not sent, then no.
		 * @return  int   Retuns a floored integer
		 */
		 
		getDays: function(mod) {
			var days = this.getTimeSeconds() / 60 / 60 / 24;
			
			if(mod) {
				days = days % 7;
			}
			
			return Math.floor(days);
		},
		
		/**
		 * Gets an hourly breakdown
		 *
		 * @return  object  Returns a digitized object
		 */
		 
		getHourCounter: function() {
			var obj = this.digitize([
				this.getHours(),
				this.getMinutes(true),
				this.getSeconds(true)
			]);
			
			return obj;
		},
		
		/**
		 * Gets an hourly breakdown
		 *
		 * @return  object  Returns a digitized object
		 */
		 
		getHourly: function() {
			return this.getHourCounter();
		},
		
		/**
		 * Gets number of hours
		 *
		 * @param   bool  Should perform a modulus? If not sent, then no.
		 * @return  int   Retuns a floored integer
		 */
		 
		getHours: function(mod) {
			var hours = this.getTimeSeconds() / 60 / 60;
			
			if(mod) {
				hours = hours % 24;	
			}
			
			return Math.floor(hours);
		},
		
		/**
		 * Gets the twenty-four hour time
		 *
		 * @return  object  returns a digitized object
		 */
		 
		getMilitaryTime: function(date, showSeconds) {
			if(typeof showSeconds === "undefined") {
				showSeconds = true;
			}

			if(!date) {
				date = this.getDateObject();
			}

			var data  = [
				date.getHours(),
				date.getMinutes()			
			];

			if(showSeconds === true) {
				data.push(date.getSeconds());
			}

			return this.digitize(data);
		},
				
		/**
		 * Gets number of minutes
		 *
		 * @param   bool  Should perform a modulus? If not sent, then no.
		 * @return  int   Retuns a floored integer
		 */
		 
		getMinutes: function(mod) {
			var minutes = this.getTimeSeconds() / 60;
			
			if(mod) {
				minutes = minutes % 60;
			}
			
			return Math.floor(minutes);
		},
		
		/**
		 * Gets a minute breakdown
		 */
		 
		getMinuteCounter: function() {
			var obj = this.digitize([
				this.getMinutes(),
				this.getSeconds(true)
			]);

			return obj;
		},
		
		/**
		 * Gets time count in seconds regardless of if targetting date or not.
		 *
		 * @return  int   Returns a floored integer
		 */
		 
		getTimeSeconds: function(date) {
			if(!date) {
				date = new Date();
			}

			if (this.time instanceof Date) {
				if (this.factory.countdown) {
					return Math.max(this.time.getTime()/1000 - date.getTime()/1000,0);
				} else {
					return date.getTime()/1000 - this.time.getTime()/1000 ;
				}
			} else {
				return this.time;
			}
		},
		
		/**
		 * Gets the current twelve hour time
		 *
		 * @return  object  Returns a digitized object
		 */
		 
		getTime: function(date, showSeconds) {
			if(typeof showSeconds === "undefined") {
				showSeconds = true;
			}

			if(!date) {
				date = this.getDateObject();
			}

			console.log(date);

			
			var hours = date.getHours();
			var merid = hours > 12 ? 'PM' : 'AM';
			var data   = [
				hours > 12 ? hours - 12 : (hours === 0 ? 12 : hours),
				date.getMinutes()			
			];

			if(showSeconds === true) {
				data.push(date.getSeconds());
			}

			return this.digitize(data);
		},
		
		/**
		 * Gets number of seconds
		 *
		 * @param   bool  Should perform a modulus? If not sent, then no.
		 * @return  int   Retuns a ceiled integer
		 */
		 
		getSeconds: function(mod) {
			var seconds = this.getTimeSeconds();
			
			if(mod) {
				if(seconds == 60) {
					seconds = 0;
				}
				else {
					seconds = seconds % 60;
				}
			}
			
			return Math.ceil(seconds);
		},

		/**
		 * Gets number of weeks
		 *
		 * @param   bool  Should perform a modulus? If not sent, then no.
		 * @return  int   Retuns a floored integer
		 */
		 
		getWeeks: function(mod) {
			var weeks = this.getTimeSeconds() / 60 / 60 / 24 / 7;
			
			if(mod) {
				weeks = weeks % 52;
			}
			
			return Math.floor(weeks);
		},
		
		/**
		 * Removes a specific number of leading zeros from the array.
		 * This method prevents you from removing too many digits, even
		 * if you try.
		 *
		 * @param   int    Total number of digits to remove 
		 * @return  array  An array of digits 
		 */
		 
		removeLeadingZeros: function(totalDigits, digits) {
			var total    = 0;
			var newArray = [];
			
			$.each(digits, function(i, digit) {
				if(i < totalDigits) {
					total += parseInt(digits[i], 10);
				}
				else {
					newArray.push(digits[i]);
				}
			});
			
			if(total === 0) {
				return newArray;
			}
			
			return digits;
		},

		/**
		 * Adds X second to the current time
		 */

		addSeconds: function(x) {
			if(this.time instanceof Date) {
				this.time.setSeconds(this.time.getSeconds() + x);
			}
			else {
				this.time += x;
			}
		},

		/**
		 * Adds 1 second to the current time
		 */

		addSecond: function() {
			this.addSeconds(1);
		},

		/**
		 * Substracts X seconds from the current time
		 */

		subSeconds: function(x) {
			if(this.time instanceof Date) {
				this.time.setSeconds(this.time.getSeconds() - x);
			}
			else {
				this.time -= x;
			}
		},

		/**
		 * Substracts 1 second from the current time
		 */

		subSecond: function() {
			this.subSeconds(1);
		},
		
		/**
		 * Converts the object to a human readable string
		 */
		 
		toString: function() {
			return this.getTimeSeconds().toString();
		}
		
		/*
		getYears: function() {
			return Math.floor(this.time / 60 / 60 / 24 / 7 / 52);
		},
		
		getDecades: function() {
			return Math.floor(this.getWeeks() / 10);
		}*/
	});
	
}(jQuery));

/*jshint smarttabs:true */

/**
 * FlipClock.js
 *
 * @author     Justin Kimbrell
 * @copyright  2013 - Objective HTML, LLC
 * @licesnse   http://www.opensource.org/licenses/mit-license.php
 */
	
(function($) {
	
	"use strict";
	
	/**
	 * The FlipClock.Timer object managers the JS timers
	 *
	 * @param	object  The parent FlipClock.Factory object
	 * @param	object  Override the default options
	 */
	
	FlipClock.Timer = FlipClock.Base.extend({
		
		/**
		 * Callbacks
		 */		
		 
		callbacks: {
			destroy: false,
			create: false,
			init: false,
			interval: false,
			start: false,
			stop: false,
			reset: false
		},
		
		/**
		 * FlipClock timer count (how many intervals have passed)
		 */		
		 
		count: 0,
		
		/**
		 * The parent FlipClock.Factory object
		 */		
		 
		factory: false,
		
		/**
		 * Timer interval (1 second by default)
		 */		
		 
		interval: 1000,

		/**
		 * The rate of the animation in milliseconds (not currently in use)
		 */		
		 
		animationRate: 1000,
				
		/**
		 * Constructor
		 *
		 * @return	void
		 */		
		 
		constructor: function(factory, options) {
			this.base(options);
			this.factory = factory;
			this.callback(this.callbacks.init);	
			this.callback(this.callbacks.create);
		},
		
		/**
		 * This method gets the elapsed the time as an interger
		 *
		 * @return	void
		 */		
		 
		getElapsed: function() {
			return this.count * this.interval;
		},
		
		/**
		 * This method gets the elapsed the time as a Date object
		 *
		 * @return	void
		 */		
		 
		getElapsedTime: function() {
			return new Date(this.time + this.getElapsed());
		},
		
		/**
		 * This method is resets the timer
		 *
		 * @param 	callback  This method resets the timer back to 0
		 * @return	void
		 */		
		 
		reset: function(callback) {
			clearInterval(this.timer);
			this.count = 0;
			this._setInterval(callback);			
			this.callback(this.callbacks.reset);
		},
		
		/**
		 * This method is starts the timer
		 *
		 * @param 	callback  A function that is called once the timer is destroyed
		 * @return	void
		 */		
		 
		start: function(callback) {		
			this.factory.running = true;
			this._createTimer(callback);
			this.callback(this.callbacks.start);
		},
		
		/**
		 * This method is stops the timer
		 *
		 * @param 	callback  A function that is called once the timer is destroyed
		 * @return	void
		 */		
		 
		stop: function(callback) {
			this.factory.running = false;
			this._clearInterval(callback);
			this.callback(this.callbacks.stop);
			this.callback(callback);
		},
		
		/**
		 * Clear the timer interval
		 *
		 * @return	void
		 */		
		 
		_clearInterval: function() {
			clearInterval(this.timer);
		},
		
		/**
		 * Create the timer object
		 *
		 * @param 	callback  A function that is called once the timer is created
		 * @return	void
		 */		
		 
		_createTimer: function(callback) {
			this._setInterval(callback);		
		},
		
		/**
		 * Destroy the timer object
		 *
		 * @param 	callback  A function that is called once the timer is destroyed
		 * @return	void
		 */		
		 	
		_destroyTimer: function(callback) {
			this._clearInterval();			
			this.timer = false;
			this.callback(callback);
			this.callback(this.callbacks.destroy);
		},
		
		/**
		 * This method is called each time the timer interval is ran
		 *
		 * @param 	callback  A function that is called once the timer is destroyed
		 * @return	void
		 */		
		 
		_interval: function(callback) {
			this.callback(this.callbacks.interval);
			this.callback(callback);
			this.count++;
		},
		
		/**
		 * This sets the timer interval
		 *
		 * @param 	callback  A function that is called once the timer is destroyed
		 * @return	void
		 */		
		 
		_setInterval: function(callback) {
			var t = this;
	
			t._interval(callback);

			t.timer = setInterval(function() {		
				t._interval(callback);
			}, this.interval);
		}
			
	});
	
}(jQuery));

(function($) {
	
	/**
	 * Twenty-Four Hour Clock Face
	 *
	 * This class will generate a twenty-four our clock for FlipClock.js
	 *
	 * @param  object  The parent FlipClock.Factory object
	 * @param  object  An object of properties to override the default	
	 */
	 
	FlipClock.TwentyFourHourClockFace = FlipClock.Face.extend({

		/**
		 * Constructor
		 *
		 * @param  object  The parent FlipClock.Factory object
		 * @param  object  An object of properties to override the default	
		 */
		 
		constructor: function(factory, options) {
			this.base(factory, options);
		},

		/**
		 * Build the clock face
		 *
		 * @param  object  Pass the time that should be used to display on the clock.	
		 */
		 
		build: function(time) {
			var t        = this;
			var children = this.factory.$el.find('ul');

			if(!this.factory.time.time) {
				this.factory.original = new Date();

				this.factory.time = new FlipClock.Time(this.factory, this.factory.original);
			}

			var time = time ? time : this.factory.time.getMilitaryTime(false, this.showSeconds);

			if(time.length > children.length) {
				$.each(time, function(i, digit) {
					t.createList(digit);
				});
			}
			
			this.createDivider();
			this.createDivider();

			$(this.dividers[0]).insertBefore(this.lists[this.lists.length - 2].$el);
			$(this.dividers[1]).insertBefore(this.lists[this.lists.length - 4].$el);
			
			this.base();
		},
		
		/**
		 * Flip the clock face
		 */
		 
		flip: function(time, doNotAddPlayClass) {
			this.autoIncrement();
			
			time = time ? time : this.factory.time.getMilitaryTime(false, this.showSeconds);
			
			this.base(time, doNotAddPlayClass);	
		}
				
	});
	
}(jQuery));
(function($) {
		
	/**
	 * Counter Clock Face
	 *
	 * This class will generate a generice flip counter. The timer has been
	 * disabled. clock.increment() and clock.decrement() have been added.
	 *
	 * @param  object  The parent FlipClock.Factory object
	 * @param  object  An object of properties to override the default	
	 */
	 
	FlipClock.CounterFace = FlipClock.Face.extend({
		
		/**
		 * Tells the counter clock face if it should auto-increment
		 */

		shouldAutoIncrement: false,

		/**
		 * Constructor
		 *
		 * @param  object  The parent FlipClock.Factory object
		 * @param  object  An object of properties to override the default	
		 */
		 
		constructor: function(factory, options) {

			if(typeof options != "object") {
				options = {};
			}

			factory.autoStart = options.autoStart ? true : false;

			if(options.autoStart) {
				this.shouldAutoIncrement = true;
			}

			factory.increment = function() {
				factory.countdown = false;
				factory.setTime(factory.getTime().getTimeSeconds() + 1);
			};

			factory.decrement = function() {
				factory.countdown = true;
				var time = factory.getTime().getTimeSeconds();
				if(time > 0) {
					factory.setTime(time - 1);
				}
			};

			factory.setValue = function(digits) {
				factory.setTime(digits);
			};

			factory.setCounter = function(digits) {
				factory.setTime(digits);
			};

			this.base(factory, options);
		},

		/**
		 * Build the clock face	
		 */
		 
		build: function() {
			var t        = this;
			var children = this.factory.$el.find('ul');
			var time 	 = this.factory.getTime().digitize([this.factory.getTime().time]);

			if(time.length > children.length) {
				$.each(time, function(i, digit) {
					var list = t.createList(digit);

					list.select(digit);
				});
			
			}

			$.each(this.lists, function(i, list) {
				list.play();
			});

			this.base();
		},
		
		/**
		 * Flip the clock face
		 */
		 
		flip: function(time, doNotAddPlayClass) {			
			if(this.shouldAutoIncrement) {
				this.autoIncrement();
			}

			if(!time) {		
				time = this.factory.getTime().digitize([this.factory.getTime().time]);
			}

			this.base(time, doNotAddPlayClass);
		},

		/**
		 * Reset the clock face
		 */

		reset: function() {
			this.factory.time = new FlipClock.Time(
				this.factory, 
				this.factory.original ? Math.round(this.factory.original) : 0
			);

			this.flip();
		}
	});
	
}(jQuery));
(function($) {

	/**
	 * Daily Counter Clock Face
	 *
	 * This class will generate a daily counter for FlipClock.js. A
	 * daily counter will track days, hours, minutes, and seconds. If
	 * the number of available digits is exceeded in the count, a new
	 * digit will be created.
	 *
	 * @param  object  The parent FlipClock.Factory object
	 * @param  object  An object of properties to override the default
	 */

	FlipClock.DailyCounterFace = FlipClock.Face.extend({

		showSeconds: true,

		/**
		 * Constructor
		 *
		 * @param  object  The parent FlipClock.Factory object
		 * @param  object  An object of properties to override the default
		 */

		constructor: function(factory, options) {
			this.base(factory, options);
		},

		/**
		 * Build the clock face
		 */

		build: function(time) {
			var t = this;
			var children = this.factory.$el.find('ul');
			var offset = 0;

			time = time ? time : this.factory.time.getDayCounter(this.showSeconds);

			if(time.length > children.length) {
				$.each(time, function(i, digit) {
					t.createList(digit);
				});
			}

			if(this.showSeconds) {
				$(this.createDivider('Seconds')).insertBefore(this.lists[this.lists.length - 2].$el);
			}
			else
			{
				offset = 2;
			}

			$(this.createDivider('Minutes')).insertBefore(this.lists[this.lists.length - 4 + offset].$el);
			$(this.createDivider('Hours')).insertBefore(this.lists[this.lists.length - 6 + offset].$el);
			$(this.createDivider('Days', true)).insertBefore(this.lists[0].$el);

			this.base();
		},

		/**
		 * Flip the clock face
		 */

		flip: function(time, doNotAddPlayClass) {
			if(!time) {
				time = this.factory.time.getDayCounter(this.showSeconds);
			}

			this.autoIncrement();

			this.base(time, doNotAddPlayClass);
		}

	});

}(jQuery));
(function($) {
			
	/**
	 * Hourly Counter Clock Face
	 *
	 * This class will generate an hourly counter for FlipClock.js. An
	 * hour counter will track hours, minutes, and seconds. If number of
	 * available digits is exceeded in the count, a new digit will be 
	 * created.
	 *
	 * @param  object  The parent FlipClock.Factory object
	 * @param  object  An object of properties to override the default	
	 */
	 
	FlipClock.HourlyCounterFace = FlipClock.Face.extend({
			
		// clearExcessDigits: true,

		/**
		 * Constructor
		 *
		 * @param  object  The parent FlipClock.Factory object
		 * @param  object  An object of properties to override the default	
		 */
		 
		constructor: function(factory, options) {
			this.base(factory, options);
		},
		
		/**
		 * Build the clock face
		 */
		
		build: function(excludeHours, time) {
			var t = this;
			var children = this.factory.$el.find('ul');
			
			time = time ? time : this.factory.time.getHourCounter();
			
			if(time.length > children.length) {
				$.each(time, function(i, digit) {
					t.createList(digit);
				});
			}
			
			$(this.createDivider('Seconds')).insertBefore(this.lists[this.lists.length - 2].$el);
			$(this.createDivider('Minutes')).insertBefore(this.lists[this.lists.length - 4].$el);
			
			if(!excludeHours) {
				$(this.createDivider('Hours', true)).insertBefore(this.lists[0].$el);
			}
			
			this.base();
		},
		
		/**
		 * Flip the clock face
		 */
		 
		flip: function(time, doNotAddPlayClass) {
			if(!time) {
				time = this.factory.time.getHourCounter();
			}	

			this.autoIncrement();
		
			this.base(time, doNotAddPlayClass);
		},

		/**
		 * Append a newly created list to the clock
		 */

		appendDigitToClock: function(obj) {
			this.base(obj);

			this.dividers[0].insertAfter(this.dividers[0].next());
		}
		
	});
	
}(jQuery));
(function($) {
		
	/**
	 * Minute Counter Clock Face
	 *
	 * This class will generate a minute counter for FlipClock.js. A
	 * minute counter will track minutes and seconds. If an hour is 
	 * reached, the counter will reset back to 0. (4 digits max)
	 *
	 * @param  object  The parent FlipClock.Factory object
	 * @param  object  An object of properties to override the default	
	 */
	 
	FlipClock.MinuteCounterFace = FlipClock.HourlyCounterFace.extend({

		clearExcessDigits: false,

		/**
		 * Constructor
		 *
		 * @param  object  The parent FlipClock.Factory object
		 * @param  object  An object of properties to override the default	
		 */
		 
		constructor: function(factory, options) {
			this.base(factory, options);
		},
		
		/**
		 * Build the clock face	
		 */
		 
		build: function() {
			this.base(true, this.factory.time.getMinuteCounter());
		},
		
		/**
		 * Flip the clock face
		 */
		 
		flip: function(time, doNotAddPlayClass) {
			if(!time) {
				time = this.factory.time.getMinuteCounter();
			}

			this.base(time, doNotAddPlayClass);
		}

	});
	
}(jQuery));
(function($) {
		
	/**
	 * Twelve Hour Clock Face
	 *
	 * This class will generate a twelve hour clock for FlipClock.js
	 *
	 * @param  object  The parent FlipClock.Factory object
	 * @param  object  An object of properties to override the default	
	 */
	 
	FlipClock.TwelveHourClockFace = FlipClock.TwentyFourHourClockFace.extend({
		
		/**
		 * The meridium jQuery DOM object
		 */
		 
		meridium: false,
		
		/**
		 * The meridium text as string for easy access
		 */
		 
		meridiumText: 'AM',
					
		/**
		 * Build the clock face
		 *
		 * @param  object  Pass the time that should be used to display on the clock.	
		 */
		 
		build: function() {
			var t = this;

			var time = this.factory.time.getTime(false, this.showSeconds);

			this.base(time);			
			this.meridiumText = this.getMeridium();			
			this.meridium = $([
				'<ul class="flip-clock-meridium">',
					'<li>',
						'<a href="#">'+this.meridiumText+'</a>',
					'</li>',
				'</ul>'
			].join(''));
						
			this.meridium.insertAfter(this.lists[this.lists.length-1].$el);
		},
		
		/**
		 * Flip the clock face
		 */
		 
		flip: function(time, doNotAddPlayClass) {			
			if(this.meridiumText != this.getMeridium()) {
				this.meridiumText = this.getMeridium();
				this.meridium.find('a').html(this.meridiumText);	
			}
			this.base(this.factory.time.getTime(false, this.showSeconds), doNotAddPlayClass);	
		},
		
		/**
		 * Get the current meridium
		 *
		 * @return  string  Returns the meridium (AM|PM)
		 */
		 
		getMeridium: function() {
			return new Date().getHours() >= 12 ? 'PM' : 'AM';
		},
		
		/**
		 * Is it currently in the post-medirium?
		 *
		 * @return  bool  Returns true or false
		 */
		 
		isPM: function() {
			return this.getMeridium() == 'PM' ? true : false;
		},

		/**
		 * Is it currently before the post-medirium?
		 *
		 * @return  bool  Returns true or false
		 */
		 
		isAM: function() {
			return this.getMeridium() == 'AM' ? true : false;
		}
				
	});
	
}(jQuery));
(function($) {

    /**
     * FlipClock Arabic Language Pack
     *
     * This class will be used to translate tokens into the Arabic language.
     *
     */

    FlipClock.Lang.Arabic = {

      'years'   : 'سنوات',
      'months'  : 'شهور',
      'days'    : 'أيام',
      'hours'   : 'ساعات',
      'minutes' : 'دقائق',
      'seconds' : 'ثواني'

    };

    /* Create various aliases for convenience */

    FlipClock.Lang['ar']      = FlipClock.Lang.Arabic;
    FlipClock.Lang['ar-ar']   = FlipClock.Lang.Arabic;
    FlipClock.Lang['arabic']  = FlipClock.Lang.Arabic;

}(jQuery));
(function($) {
		
	/**
	 * FlipClock Danish Language Pack
	 *
	 * This class will used to translate tokens into the Danish language.
	 *	
	 */
	 
	FlipClock.Lang.Danish = {
		
		'years'   : 'År',
		'months'  : 'Måneder',
		'days'    : 'Dage',
		'hours'   : 'Timer',
		'minutes' : 'Minutter',
		'seconds' : 'Sekunder'	

	};
	
	/* Create various aliases for convenience */

	FlipClock.Lang['da']     = FlipClock.Lang.Danish;
	FlipClock.Lang['da-dk']  = FlipClock.Lang.Danish;
	FlipClock.Lang['danish'] = FlipClock.Lang.Danish;

}(jQuery));
(function($) {
		
	/**
	 * FlipClock German Language Pack
	 *
	 * This class will used to translate tokens into the German language.
	 *	
	 */
	 
	FlipClock.Lang.German = {
		
		'years'   : 'Jahre',
		'months'  : 'Monate',
		'days'    : 'Tage',
		'hours'   : 'Stunden',
		'minutes' : 'Minuten',
		'seconds' : 'Sekunden'	
 
	};
	
	/* Create various aliases for convenience */
 
	FlipClock.Lang['de']     = FlipClock.Lang.German;
	FlipClock.Lang['de-de']  = FlipClock.Lang.German;
	FlipClock.Lang['german'] = FlipClock.Lang.German;
 
}(jQuery));
(function($) {
		
	/**
	 * FlipClock English Language Pack
	 *
	 * This class will used to translate tokens into the English language.
	 *	
	 */
	 
	FlipClock.Lang.English = {
		
		'years'   : 'Years',
		'months'  : 'Months',
		'days'    : 'Days',
		'hours'   : 'Hours',
		'minutes' : 'Minutes',
		'seconds' : 'Seconds'	

	};
	
	/* Create various aliases for convenience */

	FlipClock.Lang['en']      = FlipClock.Lang.English;
	FlipClock.Lang['en-us']   = FlipClock.Lang.English;
	FlipClock.Lang['english'] = FlipClock.Lang.English;

}(jQuery));
(function($) {

	/**
	 * FlipClock Spanish Language Pack
	 *
	 * This class will used to translate tokens into the Spanish language.
	 *
	 */

	FlipClock.Lang.Spanish = {

		'years'   : 'Años',
		'months'  : 'Meses',
		'days'    : 'Días',
		'hours'   : 'Horas',
		'minutes' : 'Minutos',
		'seconds' : 'Segundos'

	};

	/* Create various aliases for convenience */

	FlipClock.Lang['es']      = FlipClock.Lang.Spanish;
	FlipClock.Lang['es-es']   = FlipClock.Lang.Spanish;
	FlipClock.Lang['spanish'] = FlipClock.Lang.Spanish;

}(jQuery));
(function($) {
		
	/**
	 * FlipClock Finnish Language Pack
	 *
	 * This class will used to translate tokens into the Finnish language.
	 *	
	 */
	 
	FlipClock.Lang.Finnish = {
		
		'years'   : 'Vuotta',
		'months'  : 'Kuukautta',
		'days'    : 'Päivää',
		'hours'   : 'Tuntia',
		'minutes' : 'Minuuttia',
		'seconds' : 'Sekuntia'	

	};
	
	/* Create various aliases for convenience */

	FlipClock.Lang['fi']      = FlipClock.Lang.Finnish;
	FlipClock.Lang['fi-fi']   = FlipClock.Lang.Finnish;
	FlipClock.Lang['finnish'] = FlipClock.Lang.Finnish;

}(jQuery));

(function($) {

  /**
   * FlipClock Canadian French Language Pack
   *
   * This class will used to translate tokens into the Canadian French language.
   *
   */

  FlipClock.Lang.French = {

    'years'   : 'Ans',
    'months'  : 'Mois',
    'days'    : 'Jours',
    'hours'   : 'Heures',
    'minutes' : 'Minutes',
    'seconds' : 'Secondes'

  };

  /* Create various aliases for convenience */

  FlipClock.Lang['fr']      = FlipClock.Lang.French;
  FlipClock.Lang['fr-ca']   = FlipClock.Lang.French;
  FlipClock.Lang['french']  = FlipClock.Lang.French;

}(jQuery));

(function($) {
		
	/**
	 * FlipClock Italian Language Pack
	 *
	 * This class will used to translate tokens into the Italian language.
	 *	
	 */
	 
	FlipClock.Lang.Italian = {
		
		'years'   : 'Anni',
		'months'  : 'Mesi',
		'days'    : 'Giorni',
		'hours'   : 'Ore',
		'minutes' : 'Minuti',
		'seconds' : 'Secondi'	

	};
	
	/* Create various aliases for convenience */

	FlipClock.Lang['it']      = FlipClock.Lang.Italian;
	FlipClock.Lang['it-it']   = FlipClock.Lang.Italian;
	FlipClock.Lang['italian'] = FlipClock.Lang.Italian;
	
}(jQuery));

(function($) {

  /**
   * FlipClock Latvian Language Pack
   *
   * This class will used to translate tokens into the Latvian language.
   *
   */

  FlipClock.Lang.Latvian = {

    'years'   : 'Gadi',
    'months'  : 'Mēneši',
    'days'    : 'Dienas',
    'hours'   : 'Stundas',
    'minutes' : 'Minūtes',
    'seconds' : 'Sekundes'

  };

  /* Create various aliases for convenience */

  FlipClock.Lang['lv']      = FlipClock.Lang.Latvian;
  FlipClock.Lang['lv-lv']   = FlipClock.Lang.Latvian;
  FlipClock.Lang['latvian'] = FlipClock.Lang.Latvian;

}(jQuery));
(function($) {

    /**
     * FlipClock Dutch Language Pack
     *
     * This class will used to translate tokens into the Dutch language.
     */

    FlipClock.Lang.Dutch = {

        'years'   : 'Jaren',
        'months'  : 'Maanden',
        'days'    : 'Dagen',
        'hours'   : 'Uren',
        'minutes' : 'Minuten',
        'seconds' : 'Seconden'

    };

    /* Create various aliases for convenience */

    FlipClock.Lang['nl']      = FlipClock.Lang.Dutch;
    FlipClock.Lang['nl-be']   = FlipClock.Lang.Dutch;
    FlipClock.Lang['dutch']   = FlipClock.Lang.Dutch;

}(jQuery));

(function($) {

	/**
	 * FlipClock Norwegian-Bokmål Language Pack
	 *
	 * This class will used to translate tokens into the Norwegian language.
	 *	
	 */

	FlipClock.Lang.Norwegian = {

		'years'   : 'År',
		'months'  : 'Måneder',
		'days'    : 'Dager',
		'hours'   : 'Timer',
		'minutes' : 'Minutter',
		'seconds' : 'Sekunder'	

	};

	/* Create various aliases for convenience */

	FlipClock.Lang['no']      = FlipClock.Lang.Norwegian;
	FlipClock.Lang['nb']      = FlipClock.Lang.Norwegian;
	FlipClock.Lang['no-nb']   = FlipClock.Lang.Norwegian;
	FlipClock.Lang['norwegian'] = FlipClock.Lang.Norwegian;

}(jQuery));

(function($) {

	/**
	 * FlipClock Portuguese Language Pack
	 *
	 * This class will used to translate tokens into the Portuguese language.
	 *
	 */

	FlipClock.Lang.Portuguese = {

		'years'   : 'Anos',
		'months'  : 'Meses',
		'days'    : 'Dias',
		'hours'   : 'Horas',
		'minutes' : 'Minutos',
		'seconds' : 'Segundos'

	};

	/* Create various aliases for convenience */

	FlipClock.Lang['pt']         = FlipClock.Lang.Portuguese;
	FlipClock.Lang['pt-br']      = FlipClock.Lang.Portuguese;
	FlipClock.Lang['portuguese'] = FlipClock.Lang.Portuguese;

}(jQuery));
(function($) {

  /**
   * FlipClock Russian Language Pack
   *
   * This class will used to translate tokens into the Russian language.
   *
   */

  FlipClock.Lang.Russian = {

    'years'   : 'лет',
    'months'  : 'месяцев',
    'days'    : 'дней',
    'hours'   : 'часов',
    'minutes' : 'минут',
    'seconds' : 'секунд'

  };

  /* Create various aliases for convenience */

  FlipClock.Lang['ru']      = FlipClock.Lang.Russian;
  FlipClock.Lang['ru-ru']   = FlipClock.Lang.Russian;
  FlipClock.Lang['russian']  = FlipClock.Lang.Russian;

}(jQuery));
(function($) {
		
	/**
	 * FlipClock Swedish Language Pack
	 *
	 * This class will used to translate tokens into the Swedish language.
	 *	
	 */
	 
	FlipClock.Lang.Swedish = {
		
		'years'   : 'År',
		'months'  : 'Månader',
		'days'    : 'Dagar',
		'hours'   : 'Timmar',
		'minutes' : 'Minuter',
		'seconds' : 'Sekunder'	

	};
	
	/* Create various aliases for convenience */

	FlipClock.Lang['sv']      = FlipClock.Lang.Swedish;
	FlipClock.Lang['sv-se']   = FlipClock.Lang.Swedish;
	FlipClock.Lang['swedish'] = FlipClock.Lang.Swedish;

}(jQuery));

(function($) {
		
	/**
	 * FlipClock Chinese Language Pack
	 *
	 * This class will used to translate tokens into the Chinese language.
	 *	
	 */
	 
	FlipClock.Lang.Chinese = {
		
		'years'   : '年',
		'months'  : '月',
		'days'    : '日',
		'hours'   : '时',
		'minutes' : '分',
		'seconds' : '秒'

	};
	
	/* Create various aliases for convenience */

	FlipClock.Lang['zh']      = FlipClock.Lang.Chinese;
	FlipClock.Lang['zh-cn']   = FlipClock.Lang.Chinese;
	FlipClock.Lang['chinese'] = FlipClock.Lang.Chinese;

}(jQuery));

/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports = "<div class=\"not-found\"><h4 class=\"not-found__h\">404: Page not found</h4><a class=\"not-found__a\" href=\"javascript:history.back()\" target=\"_self\">Go back</a></div>";

/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports = "<div class=\"busyloader\"><div class=\"loadercircle modal-loader\"></div></div>";

/***/ }),
/* 287 */
/***/ (function(module, exports) {

module.exports = "<div class=\"busyloader\"><div class=\"loadercircle\"></div></div>";

/***/ }),
/* 288 */
/***/ (function(module, exports) {

module.exports = "<div class=\"scroll-fix\" scroll-fix=\"\"><ng-include src=\"'./common/templates/navbar.jade'\"></ng-include><div class=\"animate-wrapper\"><ui-view class=\"animate\"></ui-view><div class=\"clearfix\"></div></div><ng-include src=\"'./common/templates/tutorial.jade'\"></ng-include><ng-include src=\"'./common/templates/preview.jade'\"></ng-include></div>";

/***/ }),
/* 289 */
/***/ (function(module, exports) {

module.exports = "<div class=\"header-wrapper\"><header class=\"header wrapper wrapper_inside\"><div class=\"section header__large-padding\"><div class=\"col span_7_of_12\"><a class=\"logo logo_large\" ui-sref=\"admin.dashboard.templates\" title=\"SiterIO\"><div class=\"logo-svg\"><div class=\"logo-svg\"><img ng-src=\"/media/content/admin/siter_logo.svg\" width=\"300\" height=\"100\"/></div></div></a></div><div class=\"col span_5_of_12 ta-right\"><nav class=\"header__nav inline-wrapper\"><a class=\"link link_menu header--nav__link link_home\" ng-click=\"logout()\" title=\"Exit\">Exit</a></nav></div></div></header></div>";

/***/ }),
/* 290 */
/***/ (function(module, exports) {

module.exports = "<div ng-controller=\"PreviewCtrl\"><div class=\"preview\" ng-if=\"preview.active\"><div class=\"preview__bg\"></div><div class=\"preview__wrapper\"><a class=\"close-preview link_brand avatar_extra-middle\" ng-click=\"closePreview()\" title=\"{{'tutorial.closeTitle' | translate}}\"><svg class=\"icon-close\" title=\"{{'tutorial.closeTitle' | translate}}\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" style=\"width: 16px;margin-top: 6px;\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a><div class=\"preview__container\"><div class=\"preview__content e__lesson\" ng-init=\"initContainer()\"><span class=\"preview__title\">{{'editor.preview.title' | translate}}</span><div id=\"preview_custom_styles\"></div><div class=\"preview_custom_header e__lesson__header\" ng-bind-html=\"renderHtml(preview.header)\"></div><div class=\"preview_custom_content e__lesson__content\" ng-show=\"Editor.mode == 'lesson.page.editor'\" style=\"padding-bottom: 0;\"><div class=\"container\"><div class=\"e__lesson__content__title\">{{preview.siteName}}</div></div></div><div class=\"preview__frame inline-middle\"><iframe width=\"100%\" ng-src=\"{{preview.frameUrl}}\" frameborder=\"0\" allowfullscreen=\"\" scrolling=\"no\" onload=\"if (typeof window.iFrameUploadDone !== 'undefined') { window.iFrameUploadDone(this); }\"></iframe></div><div class=\"preview_custom_footer e__lesson__footer\" ng-bind-html=\"renderHtml(preview.footer)\"></div></div></div></div></div></div>";

/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports = "<ng-include src=\"'./common/templates/_nav.jade'\"></ng-include><div class=\"animate-wrapper\" resize=\"height\" resize-dependence=\".header_home\" resize-margin=\"1\" resize-attr=\"min-height\"><ui-view class=\"animate\"></ui-view></div><ng-include src=\"'./common/templates/_footer.jade'\"></ng-include>";

/***/ }),
/* 292 */
/***/ (function(module, exports) {

module.exports = "<div ng-controller=\"TutorialCtrl\"><div class=\"tutorial\" ng-if=\"tutorial.active &amp;&amp; templateIsReady\"><div class=\"tutorial__bg\"></div><div class=\"tutorial__wrapper\"><a class=\"close-tutorial link_brand avatar_extra-middle\" ng-click=\"closeTutorial()\" title=\"{{'tutorial.closeTitle' | translate}}\"><svg class=\"icon-close\" title=\"{{'tutorial.closeTitle' | translate}}\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" style=\"width: 14px;margin-top: 6px;\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a><div class=\"tutorial__steps\"><div class=\"tutorial__step tutorial__step_1\" ng-if=\"video.active\" ng-repeat=\"video in videos\"><div class=\"tutorial__content\"><span class=\"tutorial__title\">{{'editor.tutorial.view1.title' | translate}}</span><span class=\"tutorial__text\"></span><div class=\"tutorial__image inline-middle\"><iframe width=\"100%\" height=\"100%\" ng-src=\"{{video.url}}\" frameborder=\"0\" allowfullscreen=\"\"></iframe></div></div></div></div><div class=\"tutorial__pagination\"><a class=\"tutorial__point\" ng-click=\"showStep($index)\" ng-class=\"{'tutorial__point_active': video.active}\" ng-repeat=\"video in videos\"></a></div><a class=\"button button_tutorial button_blue\" ng-click=\"nextStep()\" ng-if=\"Editor.mode === 'site.page.editor' &amp;&amp; Editor.option !== 'site.page.mixer'\">{{'editor.tutorial.nextButton' | translate}} &#8196;<svg class=\"inline-wrapper\" width=\"10\" height=\"7\" viewBox=\"0 0 10 7\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9.599 3.705l-2.722-2.722v2.217h-6.658v1.004h6.658v2.223l2.722-2.722z\" fill=\"#fff\"></path></svg></a><a class=\"button button_tutorial button_blue\" ng-click=\"closeTutorial()\" ng-if=\"Editor.mode === 'site.page.editor' &amp;&amp; Editor.option === 'site.page.mixer'\">{{'editor.tutorial.ok' | translate}}</a><span class=\"link link_undeline link_gray page-invite__skip_margin\" ng-click=\"closeTutorial()\" ng-if=\"Editor.mode === 'site.page.editor' &amp;&amp; Editor.option !== 'site.page.mixer'\">{{'editor.tutorial.skipLink' | translate}}</span></div></div></div>";

/***/ }),
/* 293 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal\" ng-click=\"close($event)\" ng-style=\"{'z-index': 1050 + index*10, display: 'block'}\" role=\"dialog\" tabindex=\"-1\"><div class=\"modal-dialog\" ng-class=\"{'modal-dialog_sm': size == 'sm', 'modal-dialog_lg': size == 'lg', 'modal-dialog_md': size == 'md'}\"><div class=\"modal-content\" ng-class=\"modalclass\" ng-transclude=\"\"></div></div></div>";

/***/ }),
/* 294 */
/***/ (function(module, exports) {

module.exports = "<div class=\"wrapper wrapper_inside header-menu\"><div class=\"section\"><nav class=\"header-menu__nav\"><a class=\"link header-menu__link header-menu__link_dashboard group-title\" ui-sref=\"admin.dashboard.templates\" ui-sref-active=\"link_active\">Pages</a><a class=\"link header-menu__link header-menu__link_dashboard group-title\" ui-sref=\"admin.dashboard.sections\" ui-sref-active=\"link_active\">Sections</a><a class=\"link header-menu__link header-menu__link_dashboard group-title\" ui-sref=\"admin.dashboard.lessons\" ui-sref-active=\"link_active\">Lms</a><a class=\"link header-menu__link header-menu__link_dashboard group-title\" ui-sref=\"admin.dashboard.lessonSections\" ui-sref-active=\"link_active\">Lms sections</a><a class=\"link header-menu__link header-menu__link_dashboard group-title\" ui-sref=\"admin.dashboard.emails\" ui-sref-active=\"link_active\">Messages</a><a class=\"link header-menu__link header-menu__link_dashboard group-title\" ui-sref=\"admin.dashboard.emailSections\" ui-sref-active=\"link_active\">Messages sections</a><a class=\"link header-menu__link header-menu__link_dashboard group-title\" ui-sref=\"admin.dashboard.webForms\" ui-sref-active=\"link_active\">Web forms</a><a class=\"link header-menu__link header-menu__link_dashboard group-title\" ui-sref=\"admin.dashboard.images\" ui-sref-active=\"link_active\">Images</a></nav></div></div><div class=\"animate-wrapper line-border\"><ui-view></ui-view></div><div class=\"et-alert-window modal-content animate-show animate-show_opacity\" ng-controller=\"alertEditDialogCtrl\" ng-show=\"alertEditDialogShow\" tabindex=\"3\"><div class=\"modal__remove-content ta-center\" ng-if=\"alertEditDialogShow\"><div class=\"middle-title\">{{params.title}}</div><p class=\"modal__remove-text\">{{params.text}}</p><button class=\"button button_margin button_red button_extra-small button_modal\" str-auto-focus=\"\" ng-click=\"accept()\">{{params.accept_text}}</button><button class=\"button button_margin button_grayish-blue button_extra-small button_modal\" ng-click=\"cancel()\">{{params.cancel_text}}</button></div><div class=\"modal-backdrop modal-backdrop_editor\"></div></div>";

/***/ }),
/* 295 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"><div class=\"middle-title ta-center\">Editing image</div></div><form class=\"modal-body\" ng-submit=\"updateImage(edit_image, updateImageForm)\" novalidate=\"\" name=\"updateImageForm\"><div class=\"input-wrapper-group\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Tag</label><tags-input ng-model=\"edit_image.tag\" min-length=\"0\" max-tags=\"1\" replace-spaces-with-dashes=\"false\" allow-leftover-text=\"true\"><auto-complete source=\"loadImagesTags($query)\" load-on-empty=\"true\" load-on-focus=\"true\"></auto-complete></tags-input></div></div><div class=\"input-wrapper-group\"><div class=\"etn__preview etn__image ta-left\"><div class=\"label-input\">Preview</div><input class=\"ng-hide\" id=\"etn__image\" type=\"file\" nv-file-select=\"\" uploader=\"imageUploader\"/><span class=\"file-name\">{{imageUploader.queue[0].file.name}}</span><label for=\"etn__image\"><div class=\"etn__preview-upload etn__preview-upload_web ms-input_border {{'favorite.upload_web_hint' | translate}}\"><img class=\"etn__preview-image\" ng-src=\"{{edit_image.image_attributes.source_url}}\" err-src=\"/constructor/editor/assets/images/image-error.svg\"/><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': imageUploader.progress + '%' }\" ng-show=\"imageUploader.progress\"></div></div></label></div></div><div class=\"modal-footer ta-center\"><button class=\"button button_margin button_green button_extra-small button_modal\" type=\"submit\" ng-disabled=\"updating\">Save image</button><button class=\"button button_margin button_grayish-blue button_extra-small button_modal\" ng-click=\"close($event)\">Cancel</button></div></form>";

/***/ }),
/* 296 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"><div class=\"middle-title ta-center\">New image</div></div><form class=\"modal-body\" ng-submit=\"createImage(image, newImageForm)\" novalidate=\"\" name=\"newImageForm\"><div class=\"input-wrapper-group\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Tag</label><tags-input ng-model=\"image.tag\" min-length=\"0\" max-tags=\"1\" replace-spaces-with-dashes=\"false\" allow-leftover-text=\"true\"><auto-complete source=\"loadImagesTags($query)\" load-on-empty=\"true\" load-on-focus=\"true\"></auto-complete></tags-input></div></div><div class=\"input-wrapper-group\"><div class=\"etn__preview etn__image ta-left\"><div class=\"label-input\">Preview</div><input class=\"ng-hide\" id=\"etn__image\" type=\"file\" nv-file-select=\"\" uploader=\"imageUploader\"/><span class=\"file-name\">{{imageUploader.queue[0].file.name}}</span><label for=\"etn__image\"><div class=\"etn__preview-upload etn__preview-upload_web ms-input_border {{'favorite.upload_web_hint' | translate}}\"><img class=\"etn__preview-image\" ng-src=\"{{image.image_attributes.source_url}}\" err-src=\"/constructor/editor/assets/images/image-error.svg\"/><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': imageUploader.progress + '%' }\" ng-show=\"imageUploader.progress\"></div></div></label></div></div><div class=\"modal-footer ta-center\"><button class=\"button button_margin button_green button_extra-small button_modal\" type=\"submit\" ng-disabled=\"creating || imageUploader.queue.length == 0\" noloader=\"\">Add image</button><button class=\"button button_margin button_grayish-blue button_extra-small button_modal\" ng-click=\"close($event)\">Cancel</button></div></form>";

/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports = "<div class=\"wrapper wrapper_inside\"><div class=\"section\"><div class=\"dashboard\"><a class=\"button button_mb button_add button_green button_middle header-menu__button header-menu__button_dashboard\" title=\"+ section\" ng-click=\"newLessonSectionModal(lessonSections)\">Add</a><span class=\"group-title\" ng-if=\"sites &amp;&amp; !sitesCount\">You have no sections yet</span><div class=\"dashboard__items\"><div class=\"dashboard__loader ta-center\"><img width=\"20\" src=\"/constructor/editor/assets/images/loader.gif\" ng-show=\"sectionsLoading\"/></div><table class=\"standart-view table table-hover table-bordered table_middle\" ng-hide=\"sectionsLoading\"><thead><tr><td><a class=\"link_brand\" href=\"javascript: void(0)\" ng-click=\"sortBy('title')\">Name<span>&nbsp;&#8593;&#8595;</span></a></td><td id=\"clicks\">Type</td><td id=\"leads\"><a class=\"link_brand\" href=\"javascript: void(0)\" ng-click=\"sortBy('tags')\">Tags<span>&nbsp;&#8593;&#8595;</span></a></td><td width=\"80px\"></td><td width=\"80px\"></td><td width=\"80px\"></td><td width=\"80px\"></td></tr></thead><tbody><tr class=\"acordeon-tit\" id=\"content-id-2025567\" ng-repeat=\"section in lessonSections | orderBy:propertyName:reverse\"><td class=\"text_nowrap\">{{section.title}}</td><td class=\"text_nowrap stats-clicks\">{{section.section_type}}</td><td class=\"text_nowrap stats-leads\">{{section.tags}}</td><td><label class=\"switch switch_dashboard\" for=\"exist_section_{{$index}}\"><input class=\"switch-input\" type=\"checkbox\" id=\"exist_section_{{$index}}\" ng-model=\"section.disabled\" ng-change=\"saveSection(section)\" ng-true-value=\"false\" ng-false-value=\"true\"/><span class=\"switch-label\" data-on=\"\" data-off=\"\"></span><span class=\"switch-handle\"></span></label></td><td><a class=\"link_brand avatar_extra-middle\" ng-click=\"editSectionModal(section)\"><div class=\"dashboard__collab-count\"><img ng-src=\"/constructor/editor/assets/images/gear.svg\" width=\"22px\" height=\"22px\"/></div></a></td><td><a class=\"link_brand dashboard__collab dashboard__collab_avatar link fr\" ui-sref=\"editor.section({sectionId: section.id})\"><div class=\"dashboard__collab-count avatar_extra-middle\"><svg class=\"inline-wrapper\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon__fill\" d=\"M14.25 7.5c-.414 0-.75.336-.75.75v6.25h-12v-12h6.25c.414 0 .75-.336.75-.75s-.335-.75-.75-.75h-6.75c-.552 0-1 .448-1 1v13c0 .552.448 1 1 1h13c.552 0 1-.448 1-1v-6.75c0-.414-.336-.75-.75-.75zm1.576-5.175l-2.152-2.152c-.117-.117-.27-.174-.424-.174-.154 0-.307.057-.424.175l-8.326 8.325v3h3l8.325-8.325c.117-.118.175-.271.175-.424 0-.154-.057-.307-.174-.425zm-8.825 7.675h-1v-1l7.25-7.25 1 1-7.25 7.25z\"></path></svg></div></a></td><td><a class=\"link_brand avatar_extra-middle\" ng-click=\"removeSection(section, lessonSections)\"><svg class=\"icon-close\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" style=\"width: 14px;margin-top: 6px;\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a></td></tr></tbody></table></div></div></div></div>";

/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports = "<div class=\"wrapper wrapper_inside\"><div class=\"section\"><div class=\"dashboard\"><a class=\"button button_mb button_add button_green button_middle header-menu__button header-menu__button_dashboard\" title=\"+ New template\" ng-click=\"newLessonTemplate()\">Add</a><div class=\"dashboard__items\"><div class=\"dashboard-templates__tags\" ui-tree=\"treeLessonOptions\" data-max-depth=\"1\"><div class=\"dashboard-templates__tags-title\">Template tags</div><div class=\"etn__pages-tree\" id=\"tree-root\"><ol ui-tree-nodes=\"\" ng-model=\"LessonTemplatesTags\"><li class=\"etn__pages-tree__item\" ng-repeat=\"tag in LessonTemplatesTags track by $index\" collapsed=\"false\" ui-tree-node=\"\" ng-include=\"'./dashboard/templates_tags_renderer.jade'\"></li></ol></div></div><div class=\"dashboard__loader ta-center\"><img width=\"20\" src=\"/constructor/editor/assets/images/loader.gif\" ng-show=\"LessonsLoading\"/></div><table class=\"standart-view table table-hover table-bordered table_middle\" ng-hide=\"LessonsLoading\"><thead><tr><td></td><td><a class=\"link_brand\" href=\"javascript: void(0)\" ng-click=\"sortBy('name')\">Name<span>&nbsp;&#8593;&#8595;</span></a></td><td id=\"clicks\">Subdomain</td><td>Type</td><td id=\"leads\">Tags</td><td id=\"conv2\">Last update</td><td ng-show=\"currentUser.role == 'superadmin'\"></td><td></td><td></td><td></td></tr></thead><tbody ng-repeat=\"lesson in Lessons | orderBy:propertyName:reverse\"><tr class=\"acordeon-tit\"><td ng-click=\"showChilds = !showChilds\"><div class=\"arrow-site-child arrow-site-child_down\" style=\"position: relative;top: auto;right: auto;\" ng-class=\"{'arrow-site-child_up': showChilds}\" ng-show=\"lesson.childs.length\"></div></td><td class=\"text_nowrap\">{{lesson.name}}</td><td class=\"text_nowrap\">{{lesson.url}}</td><td class=\"text_nowrap\">{{lesson.type}}</td><td class=\"text_nowrap stats-leads\">{{lesson.tags}}</td><td class=\"text_nowrap stats-conv2\">{{lesson.updated_at*1000 | date: \"yyyy-MM-dd\"}}</td><td ng-show=\"currentUser.role == 'superadmin'\"><label class=\"switch switch_dashboard\" for=\"exist_{{$index}}\"><input class=\"switch-input\" type=\"checkbox\" id=\"exist_{{$index}}\" ng-model=\"lesson.disabled\" ng-change=\"saveLessonTemplate(lesson)\" ng-true-value=\"false\" ng-false-value=\"true\"/><span class=\"switch-label\" data-on=\"\" data-off=\"\"></span><span class=\"switch-handle\"></span></label></td><td><div ng-hide=\"currentUser.role == 'admin' &amp;&amp; !lesson.disabled\"><a class=\"link_brand avatar_extra-middle\" ng-click=\"editLessonTemplate(lesson, true)\"><div class=\"dashboard__collab-count\"><img ng-src=\"/constructor/editor/assets/images/gear.svg\" width=\"22px\" height=\"22px\"/></div></a></div></td><td><div ng-hide=\"currentUser.role == 'admin' &amp;&amp; !lesson.disabled\"><a class=\"link_brand dashboard__collab dashboard__collab_avatar link fr\" ui-sref=\"lesson.page.editor({lessonId: lesson.slug, pageId: getHomePagePath(lesson.pages)})\"><div class=\"dashboard__collab-count avatar_extra-middle\"><svg class=\"inline-wrapper\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon__fill\" d=\"M14.25 7.5c-.414 0-.75.336-.75.75v6.25h-12v-12h6.25c.414 0 .75-.336.75-.75s-.335-.75-.75-.75h-6.75c-.552 0-1 .448-1 1v13c0 .552.448 1 1 1h13c.552 0 1-.448 1-1v-6.75c0-.414-.336-.75-.75-.75zm1.576-5.175l-2.152-2.152c-.117-.117-.27-.174-.424-.174-.154 0-.307.057-.424.175l-8.326 8.325v3h3l8.325-8.325c.117-.118.175-.271.175-.424 0-.154-.057-.307-.174-.425zm-8.825 7.675h-1v-1l7.25-7.25 1 1-7.25 7.25z\"></path></svg></div></a></div></td><td><div ng-hide=\"currentUser.role == 'admin' &amp;&amp; !lesson.disabled\"><a class=\"link_brand avatar_extra-middle\" ng-click=\"removeLessonTemplate(Lessons, lesson)\"><svg class=\"icon-close\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" style=\"width: 14px;margin-top: 6px;\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a></div></td><tr class=\"acordeon-tit\" ng-repeat=\"child in lesson.childs track by $index\" ng-show=\"showChilds\"><td><div class=\"template-color\" style=\"background-color: {{child.color}};\"></div></td><td class=\"text_nowrap\">{{child.name}}</td><td class=\"text_nowrap\">{{child.url}}</td><td class=\"text_nowrap\">{{child.type}}</td><td class=\"text_nowrap stats-leads\">{{child.pages.length}}</td><td class=\"text_nowrap stats-conv2\">{{child.updated_at*1000 | date: \"yyyy-MM-dd\"}}</td><td ng-show=\"currentUser.role == 'superadmin'\"><label class=\"switch switch_dashboard\" for=\"exist_{{$parent.$index}}_{{$index}}\"><input class=\"switch-input\" type=\"checkbox\" id=\"exist_{{$parent.$index}}_{{$index}}\" ng-model=\"child.disabled\" ng-change=\"saveLessonTemplate(child)\" ng-true-value=\"false\" ng-false-value=\"true\"/><span class=\"switch-label\" data-on=\"\" data-off=\"\"></span><span class=\"switch-handle\"></span></label></td><td><div ng-hide=\"currentUser.role == 'admin' &amp;&amp; !lesson.disabled\"><a class=\"link_brand avatar_extra-middle\" ng-click=\"editLessonTemplate(child, false)\"><div class=\"dashboard__collab-count\"><img ng-src=\"/constructor/editor/assets/images/gear.svg\" width=\"22px\" height=\"22px\"/></div></a></div></td><td><div ng-hide=\"currentUser.role == 'admin' &amp;&amp; !lesson.disabled\"><a class=\"link_brand dashboard__collab dashboard__collab_avatar link fr\" ui-sref=\"lesson.page.editor({lessonId: child.slug, pageId: getHomePagePath(child.pages)})\"><div class=\"dashboard__collab-count avatar_extra-middle\"><svg class=\"inline-wrapper\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon__fill\" d=\"M14.25 7.5c-.414 0-.75.336-.75.75v6.25h-12v-12h6.25c.414 0 .75-.336.75-.75s-.335-.75-.75-.75h-6.75c-.552 0-1 .448-1 1v13c0 .552.448 1 1 1h13c.552 0 1-.448 1-1v-6.75c0-.414-.336-.75-.75-.75zm1.576-5.175l-2.152-2.152c-.117-.117-.27-.174-.424-.174-.154 0-.307.057-.424.175l-8.326 8.325v3h3l8.325-8.325c.117-.118.175-.271.175-.424 0-.154-.057-.307-.174-.425zm-8.825 7.675h-1v-1l7.25-7.25 1 1-7.25 7.25z\"></path></svg></div></a></div></td><td><div ng-hide=\"currentUser.role == 'admin' &amp;&amp; !lesson.disabled\"><a class=\"link_brand avatar_extra-middle\" ng-click=\"removeLessonTemplate(lesson.childs, child)\"><svg class=\"icon-close\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" style=\"width: 14px;margin-top: 6px;\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a></div></td></tr></tr></tbody></table></div><div class=\"group-title\" ng-if=\"Lessons &amp;&amp; !LessonsCount\" style=\"text-align:center;\">No form templates available</div></div></div></div>";

/***/ }),
/* 299 */
/***/ (function(module, exports) {

module.exports = "<div class=\"wrapper wrapper_inside\"><div class=\"section\"><div class=\"dashboard\"><a class=\"button button_mb button_add button_green button_middle header-menu__button header-menu__button_dashboard\" title=\"+ New template\" ng-click=\"newTemplate()\">Add</a><span class=\"group-title\" ng-if=\"sites &amp;&amp; !sitesCount\">No templates available</span><div class=\"dashboard__items\"><div class=\"dashboard-templates__tags\" ui-tree=\"treeOptions\" data-max-depth=\"1\"><div class=\"dashboard-templates__tags-title\">Template tags</div><div class=\"etn__pages-tree\" id=\"tree-root\"><ol ui-tree-nodes=\"\" ng-model=\"templatesTags\"><li class=\"etn__pages-tree__item\" ng-repeat=\"tag in templatesTags track by $index\" collapsed=\"true\" ui-tree-node=\"\" ng-include=\"'./dashboard/templates_tags_renderer.jade'\"></li></ol></div></div><div class=\"dashboard__loader ta-center\"><img width=\"20\" src=\"/constructor/editor/assets/images/loader.gif\" ng-show=\"sitesLoading\"/></div><table class=\"standart-view table table-hover table-bordered table_middle\" ng-hide=\"sitesLoading\"><thead><tr><td></td><td><a class=\"link_brand\" href=\"javascript: void(0)\" ng-click=\"sortBy('name')\">Name<span>&nbsp;&#8593;&#8595;</span></a></td><td id=\"clicks\">Subdomain</td><td id=\"leads\">Tags</td><td id=\"conv2\">Last update</td><td ng-show=\"currentUser.role == 'superadmin'\"></td><td></td><td></td><td></td></tr></thead><tbody ng-repeat=\"site in sites | orderBy:propertyName:reverse\"><tr class=\"acordeon-tit\" id=\"content-id-2025567\"><td ng-click=\"showChilds = !showChilds\"><div class=\"arrow-site-child arrow-site-child_down\" style=\"position: relative; top: auto; right: auto;\" ng-class=\"{'arrow-site-child_up': showChilds}\" ng-show=\"site.childs.length\"></div></td><td class=\"text_nowrap\"><a class=\"link_brand va-top blue\" href=\"{{site.url}}\" target=\"_blank\">{{site.name}}</a></td><td class=\"text_nowrap stats-clicks\"><a class=\"link_brand va-top blue\" href=\"{{site.url}}\" target=\"_blank\">{{site.url}}</a></td><td class=\"text_nowrap stats-leads\">{{site.tags}}</td><td class=\"text_nowrap stats-conv2\">{{site.updated_at*1000 | date: \"yyyy-MM-dd\"}}</td><td ng-show=\"currentUser.role == 'superadmin'\"><label class=\"switch switch_dashboard\" for=\"exist_{{$index}}\"><input class=\"switch-input\" type=\"checkbox\" id=\"exist_{{$index}}\" ng-model=\"site.disabled\" ng-change=\"saveTemplate(site)\" ng-true-value=\"false\" ng-false-value=\"true\"/><span class=\"switch-label\" data-on=\"\" data-off=\"\"></span><span class=\"switch-handle\"></span></label></td><td><div ng-hide=\"currentUser.role == 'admin' &amp;&amp; !site.disabled\"><a class=\"link_brand avatar_extra-middle\" ng-click=\"editTemplate(site, true)\"><div class=\"dashboard__collab-count\"><img ng-src=\"/constructor/editor/assets/images/gear.svg\" width=\"22px\" height=\"22px\"/></div></a></div></td><td><div ng-hide=\"currentUser.role == 'admin' &amp;&amp; !site.disabled\"><a class=\"link_brand dashboard__collab dashboard__collab_avatar link fr\" ui-sref=\"site.page.editor({siteId: site.slug, pageId: getHomePagePath(site.pages)})\"><div class=\"dashboard__collab-count avatar_extra-middle\"><svg class=\"inline-wrapper\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon__fill\" d=\"M14.25 7.5c-.414 0-.75.336-.75.75v6.25h-12v-12h6.25c.414 0 .75-.336.75-.75s-.335-.75-.75-.75h-6.75c-.552 0-1 .448-1 1v13c0 .552.448 1 1 1h13c.552 0 1-.448 1-1v-6.75c0-.414-.336-.75-.75-.75zm1.576-5.175l-2.152-2.152c-.117-.117-.27-.174-.424-.174-.154 0-.307.057-.424.175l-8.326 8.325v3h3l8.325-8.325c.117-.118.175-.271.175-.424 0-.154-.057-.307-.174-.425zm-8.825 7.675h-1v-1l7.25-7.25 1 1-7.25 7.25z\"></path></svg></div></a></div></td><td><div ng-hide=\"currentUser.role == 'admin' &amp;&amp; !site.disabled\"><a class=\"link_brand avatar_extra-middle\" ng-click=\"remove(sites, site)\"><svg class=\"icon-close\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" style=\"width: 14px;margin-top: 6px;\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a></div></td><tr class=\"acordeon-tit\" id=\"content-id-2025567\" ng-repeat=\"child in site.childs track by $index\" ng-show=\"showChilds\"><td><div class=\"template-color\" style=\"background-color: {{child.color}};\"></div></td><td class=\"text_nowrap\"><a class=\"link_brand va-top blue\" href=\"{{child.url}}\" target=\"_blank\">{{child.name}}</a></td><td class=\"text_nowrap stats-clicks\"><a class=\"link_brand va-top blue\" href=\"{{child.url}}\" target=\"_blank\">{{child.url}}</a></td><td class=\"text_nowrap stats-leads\">{{child.tags}}</td><td class=\"text_nowrap stats-conv2\">{{child.updated_at*1000 | date: \"yyyy-MM-dd\"}}</td><td ng-show=\"currentUser.role == 'superadmin'\"><label class=\"switch switch_dashboard\" for=\"exist_{{$parent.$index}}_{{$index}}\"><input class=\"switch-input\" type=\"checkbox\" id=\"exist_{{$parent.$index}}_{{$index}}\" ng-model=\"child.disabled\" ng-change=\"saveTemplate(child)\" ng-true-value=\"false\" ng-false-value=\"true\"/><span class=\"switch-label\" data-on=\"\" data-off=\"\"></span><span class=\"switch-handle\"></span></label></td><td><div ng-hide=\"currentUser.role == 'admin' &amp;&amp; !site.disabled\"><a class=\"link_brand avatar_extra-middle\" ng-click=\"editTemplate(child, false)\"><div class=\"dashboard__collab-count\"><img ng-src=\"/constructor/editor/assets/images/gear.svg\" width=\"22px\" height=\"22px\"/></div></a></div></td><td><div ng-hide=\"currentUser.role == 'admin' &amp;&amp; !site.disabled\"><a class=\"link_brand dashboard__collab dashboard__collab_avatar link fr\" ui-sref=\"site.page.editor({siteId: child.slug, pageId: getHomePagePath(child.pages)})\"><div class=\"dashboard__collab-count avatar_extra-middle\"><svg class=\"inline-wrapper\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon__fill\" d=\"M14.25 7.5c-.414 0-.75.336-.75.75v6.25h-12v-12h6.25c.414 0 .75-.336.75-.75s-.335-.75-.75-.75h-6.75c-.552 0-1 .448-1 1v13c0 .552.448 1 1 1h13c.552 0 1-.448 1-1v-6.75c0-.414-.336-.75-.75-.75zm1.576-5.175l-2.152-2.152c-.117-.117-.27-.174-.424-.174-.154 0-.307.057-.424.175l-8.326 8.325v3h3l8.325-8.325c.117-.118.175-.271.175-.424 0-.154-.057-.307-.174-.425zm-8.825 7.675h-1v-1l7.25-7.25 1 1-7.25 7.25z\"></path></svg></div></a></div></td><td><div ng-hide=\"currentUser.role == 'admin' &amp;&amp; !site.disabled\"><a class=\"link_brand avatar_extra-middle\" ng-click=\"remove(site.childs, child)\"><svg class=\"icon-close\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" style=\"width: 14px;margin-top: 6px;\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a></div></td></tr></tr></tbody></table></div></div></div></div>";

/***/ }),
/* 300 */
/***/ (function(module, exports) {

module.exports = "<div class=\"wrapper wrapper_inside\"><div class=\"section\"><div class=\"dashboard\"><a class=\"button button_mb button_add button_green button_middle header-menu__button header-menu__button_dashboard\" title=\"+ section\" ng-click=\"createSectionModal(sections)\">Add</a><span class=\"group-title\" ng-if=\"sites &amp;&amp; !sitesCount\">You have no sections yet</span><div class=\"dashboard__items\"><div class=\"dashboard__loader ta-center\"><img width=\"20\" src=\"/constructor/editor/assets/images/loader.gif\" ng-show=\"sectionsLoading\"/></div><table class=\"standart-view table table-hover table-bordered table_middle\" ng-hide=\"sectionsLoading\"><thead><tr><td><a class=\"link_brand\" href=\"javascript: void(0)\" ng-click=\"sortBy('title')\">Name<span>&nbsp;&#8593;&#8595;</span></a></td><td id=\"clicks\">Type</td><td id=\"leads\"><a class=\"link_brand\" href=\"javascript: void(0)\" ng-click=\"sortBy('tags')\">Tags<span>&nbsp;&#8593;&#8595;</span></a></td><td width=\"80px\" ng-show=\"currentUser.role == 'superadmin'\"></td><td width=\"80px\"></td><td width=\"80px\"></td><td width=\"80px\"></td></tr></thead><tbody><tr class=\"acordeon-tit\" id=\"content-id-2025567\" ng-repeat=\"section in sections | orderBy:propertyName:reverse\"><td class=\"text_nowrap\">{{section.title}}</td><td class=\"text_nowrap stats-clicks\">{{section.section_type}}</td><td class=\"text_nowrap stats-leads\">{{section.tags}}</td><td ng-show=\"currentUser.role == 'superadmin'\"><label class=\"switch switch_dashboard\" for=\"exist_section_{{$index}}\"><input class=\"switch-input\" type=\"checkbox\" id=\"exist_section_{{$index}}\" ng-model=\"section.disabled\" ng-change=\"saveSection(section)\" ng-true-value=\"false\" ng-false-value=\"true\"/><span class=\"switch-label\" data-on=\"\" data-off=\"\"></span><span class=\"switch-handle\"></span></label></td><td><div ng-hide=\"currentUser.role == 'admin' &amp;&amp; !section.disabled\"><a class=\"link_brand avatar_extra-middle\" ng-click=\"editSectionModal(section)\"><div class=\"dashboard__collab-count\"><img ng-src=\"/constructor/editor/assets/images/gear.svg\" width=\"22px\" height=\"22px\"/></div></a></div></td><td><div ng-hide=\"currentUser.role == 'admin' &amp;&amp; !section.disabled\"><a class=\"link_brand dashboard__collab dashboard__collab_avatar link fr\" ui-sref=\"editor.section({sectionId: section.id})\"><div class=\"dashboard__collab-count avatar_extra-middle\"><svg class=\"inline-wrapper\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon__fill\" d=\"M14.25 7.5c-.414 0-.75.336-.75.75v6.25h-12v-12h6.25c.414 0 .75-.336.75-.75s-.335-.75-.75-.75h-6.75c-.552 0-1 .448-1 1v13c0 .552.448 1 1 1h13c.552 0 1-.448 1-1v-6.75c0-.414-.336-.75-.75-.75zm1.576-5.175l-2.152-2.152c-.117-.117-.27-.174-.424-.174-.154 0-.307.057-.424.175l-8.326 8.325v3h3l8.325-8.325c.117-.118.175-.271.175-.424 0-.154-.057-.307-.174-.425zm-8.825 7.675h-1v-1l7.25-7.25 1 1-7.25 7.25z\"></path></svg></div></a></div></td><td><div ng-hide=\"currentUser.role == 'admin' &amp;&amp; !section.disabled\"><a class=\"link_brand avatar_extra-middle\" ng-click=\"removeSection(section, sections)\"><svg class=\"icon-close\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" style=\"width: 14px;margin-top: 6px;\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a></div></td></tr></tbody></table></div></div></div></div>";

/***/ }),
/* 301 */
/***/ (function(module, exports) {

module.exports = "<div class=\"wrapper wrapper_inside\"><div class=\"section\"><div class=\"dashboard\"><a class=\"button button_mb button_add button_green button_middle header-menu__button header-menu__button_dashboard\" title=\"+ image\" ng-click=\"newImage()\">Add</a><div class=\"input-wrapper ta-left\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.selectedTag\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{selectedTag || 'All'}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{tag}}\" ng-repeat=\"tag in imagesTags\" ng-click=\"optionCheck($event, tag); searchImages(tag);\">{{tag}}</li><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"All\" ng-click=\"getImages(); optionCheck($event, undefined);\">All</li></ul></div></perfect-scrollbar></div></div></div><span class=\"group-title\" ng-if=\"sites &amp;&amp; !sitesCount\">No images available</span><div class=\"dashboard__items\"><div class=\"dashboard__loader ta-center\"><img width=\"20\" src=\"/constructor/editor/assets/images/loader.gif\" ng-show=\"imagesLoading\"/></div><perfect-scrollbar class=\"dashboard-images__wrapper scroller\" refresh-on-change=\"images\" scroll-disabled=\"{{scrollDisabled}}\" scroll-load-distance=\"200\" wheel-propagation=\"true\" when-scroll-down=\"getNextImages()\"><table class=\"standart-view table table-hover table-bordered table_middle\" ng-hide=\"imagesLoading\"><thead><tr><td>View</td><td id=\"leads\">Tags</td><td width=\"80px\" ng-show=\"currentUser.role == 'superadmin'\"></td><td width=\"80px\"></td><td width=\"40px\"></td></tr></thead><tbody><tr class=\"acordeon-tit\" id=\"content-id-2025567\" ng-repeat=\"image in imagesData.images | orderBy:propertyName:reverse\"><td class=\"text_nowrap\"><div class=\"dashboard__image-item\" style=\"background-image: url('{{image.image_attributes.source_url}}');\"></div></td><td class=\"text_nowrap stats-leads\">{{image.tag[0].text || image.tag}}</td><td ng-show=\"currentUser.role == 'superadmin'\"><label class=\"switch switch_dashboard\" for=\"exist_image_{{$index}}\"><input class=\"switch-input\" type=\"checkbox\" id=\"exist_image_{{$index}}\" ng-model=\"image.disabled\" ng-change=\"saveImage(image)\" ng-true-value=\"false\" ng-false-value=\"true\"/><span class=\"switch-label\" data-on=\"\" data-off=\"\"></span><span class=\"switch-handle\"></span></label></td><td><div ng-hide=\"currentUser.role == 'admin' &amp;&amp; !site.disabled\"><a class=\"link_brand avatar_extra-middle\" ng-click=\"editImage(image)\"><div class=\"dashboard__collab-count\"><img ng-src=\"/constructor/editor/assets/images/gear.svg\" width=\"22px\" height=\"22px\"/></div></a></div></td><td><div ng-hide=\"currentUser.role == 'admin' &amp;&amp; !site.disabled\"><a class=\"link_brand avatar_extra-middle\" ng-click=\"removeImage(imagesData.images, image)\" ng-if=\"!image.section_id\"><svg class=\"icon-close\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" style=\"width: 14px;margin-top: 6px;\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a></div></td></tr></tbody></table></perfect-scrollbar></div></div></div></div><div class=\"et-alert-window modal-content animate-show animate-show_opacity\" ng-controller=\"alertEditDialogCtrl\" ng-show=\"alertEditDialogShow\" tabindex=\"3\"><div class=\"modal__remove-content ta-center\" ng-if=\"alertEditDialogShow\"><div class=\"middle-title\">{{params.title}}</div><p class=\"modal__remove-text\">{{params.text}}</p><button class=\"button button_margin button_red button_extra-small button_modal\" str-auto-focus=\"\" ng-click=\"accept()\">{{params.accept_text}}</button><button class=\"button button_margin button_grayish-blue button_extra-small button_modal\" ng-click=\"cancel()\">{{params.cancel_text}}</button></div><div class=\"modal-backdrop modal-backdrop_editor\"></div></div>";

/***/ }),
/* 302 */
/***/ (function(module, exports) {

module.exports = "<div class=\"wrapper wrapper_inside\"><div class=\"section\"><div class=\"dashboard\"><a class=\"button button_mb button_add button_green button_middle header-menu__button header-menu__button_dashboard\" title=\"+ message\" ng-click=\"newEmailTemplate()\">Add</a><span class=\"group-title\" ng-if=\"sites &amp;&amp; !sitesCount\">No messages templates available</span><div class=\"dashboard__items\"><div class=\"dashboard-templates__tags\" ui-tree=\"treeEmailOptions\" data-max-depth=\"1\"><div class=\"dashboard-templates__tags-title\">Template tags</div><div class=\"etn__pages-tree\" id=\"tree-root\"><ol ui-tree-nodes=\"\" ng-model=\"emailTemplatesTags\"><li class=\"etn__pages-tree__item\" ng-repeat=\"tag in emailTemplatesTags track by $index\" collapsed=\"true\" ui-tree-node=\"\" ng-include=\"'./dashboard/templates_tags_renderer.jade'\"></li></ol></div></div><div class=\"dashboard__loader ta-center\"><img width=\"20\" src=\"/constructor/editor/assets/images/loader.gif\" ng-show=\"emailsLoading\"/></div><table class=\"standart-view table table-hover table-bordered table_middle\" ng-hide=\"emailsLoading\"><thead><tr><td></td><td><a class=\"link_brand\" href=\"javascript: void(0)\" ng-click=\"sortBy('name')\">Name<span>&nbsp;&#8593;&#8595;</span></a></td><td id=\"clicks\">Subdomain</td><td id=\"leads\">Tags</td><td id=\"conv2\">Last update</td><td ng-show=\"currentUser.role == 'superadmin'\"></td><td></td><td></td><td></td></tr></thead><tbody ng-repeat=\"site in emails | orderBy:propertyName:reverse\"><tr class=\"acordeon-tit\" id=\"content-id-2025567\"><td ng-click=\"showChilds = !showChilds\"><div class=\"arrow-site-child arrow-site-child_down\" style=\"position: relative;top: auto;right: auto;\" ng-class=\"{'arrow-site-child_up': showChilds}\" ng-show=\"site.childs.length\"></div></td><td class=\"text_nowrap\"><a class=\"link_brand va-top blue\" href=\"{{site.url}}\" target=\"_blank\">{{site.name}}</a></td><td class=\"text_nowrap stats-clicks\"><a class=\"link_brand va-top blue\" href=\"{{site.url}}\" target=\"_blank\">{{site.url}}</a></td><td class=\"text_nowrap stats-leads\">{{site.tags}}</td><td class=\"text_nowrap stats-conv2\">{{site.updated_at*1000 | date: \"yyyy-MM-dd\"}}</td><td ng-show=\"currentUser.role == 'superadmin'\"><label class=\"switch switch_dashboard\" for=\"exist_{{$index}}\"><input class=\"switch-input\" type=\"checkbox\" id=\"exist_{{$index}}\" ng-model=\"site.disabled\" ng-change=\"saveEmailTemplate(site)\" ng-true-value=\"false\" ng-false-value=\"true\"/><span class=\"switch-label\" data-on=\"\" data-off=\"\"></span><span class=\"switch-handle\"></span></label></td><td><div ng-hide=\"currentUser.role == 'admin' &amp;&amp; !site.disabled\"><a class=\"link_brand avatar_extra-middle\" ng-click=\"editEmailTemplate(site, true)\"><div class=\"dashboard__collab-count\"><img ng-src=\"/constructor/editor/assets/images/gear.svg\" width=\"22px\" height=\"22px\"/></div></a></div></td><td><div ng-hide=\"currentUser.role == 'admin' &amp;&amp; !site.disabled\"><a class=\"link_brand dashboard__collab dashboard__collab_avatar link fr\" ui-sref=\"email.page.editor({emailId: site.slug, pageId: getHomePagePath(site.pages)})\"><div class=\"dashboard__collab-count avatar_extra-middle\"><svg class=\"inline-wrapper\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon__fill\" d=\"M14.25 7.5c-.414 0-.75.336-.75.75v6.25h-12v-12h6.25c.414 0 .75-.336.75-.75s-.335-.75-.75-.75h-6.75c-.552 0-1 .448-1 1v13c0 .552.448 1 1 1h13c.552 0 1-.448 1-1v-6.75c0-.414-.336-.75-.75-.75zm1.576-5.175l-2.152-2.152c-.117-.117-.27-.174-.424-.174-.154 0-.307.057-.424.175l-8.326 8.325v3h3l8.325-8.325c.117-.118.175-.271.175-.424 0-.154-.057-.307-.174-.425zm-8.825 7.675h-1v-1l7.25-7.25 1 1-7.25 7.25z\"></path></svg></div></a></div></td><td><div ng-hide=\"currentUser.role == 'admin' &amp;&amp; !site.disabled\"><a class=\"link_brand avatar_extra-middle\" ng-click=\"removeEmailTemplate(emails, site)\"><svg class=\"icon-close\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" style=\"width: 14px;margin-top: 6px;\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a></div></td><tr class=\"acordeon-tit\" id=\"content-id-2025567\" ng-repeat=\"child in site.childs track by $index\" ng-show=\"showChilds\"><td><div class=\"template-color\" style=\"background-color: {{child.color}};\"></div></td><td class=\"text_nowrap\"><a class=\"link_brand va-top blue\" href=\"{{child.url}}\" target=\"_blank\">{{child.name}}</a></td><td class=\"text_nowrap stats-clicks\"><a class=\"link_brand va-top blue\" href=\"{{child.url}}\" target=\"_blank\">{{child.url}}</a></td><td class=\"text_nowrap stats-leads\">{{child.pages.length}}</td><td class=\"text_nowrap stats-conv2\">{{child.updated_at*1000 | date: \"yyyy-MM-dd\"}}</td><td ng-show=\"currentUser.role == 'superadmin'\"><label class=\"switch switch_dashboard\" for=\"exist_{{$parent.$index}}_{{$index}}\"><input class=\"switch-input\" type=\"checkbox\" id=\"exist_{{$parent.$index}}_{{$index}}\" ng-model=\"child.disabled\" ng-change=\"saveEmailTemplate(child)\" ng-true-value=\"false\" ng-false-value=\"true\"/><span class=\"switch-label\" data-on=\"\" data-off=\"\"></span><span class=\"switch-handle\"></span></label></td><td><div ng-hide=\"currentUser.role == 'admin' &amp;&amp; !site.disabled\"><a class=\"link_brand avatar_extra-middle\" ng-click=\"editEmailTemplate(child, false)\"><div class=\"dashboard__collab-count\"><img ng-src=\"/constructor/editor/assets/images/gear.svg\" width=\"22px\" height=\"22px\"/></div></a></div></td><td><div ng-hide=\"currentUser.role == 'admin' &amp;&amp; !site.disabled\"><a class=\"link_brand dashboard__collab dashboard__collab_avatar link fr\" ui-sref=\"email.page.editor({emailId: child.slug, pageId: getHomePagePath(child.pages)})\"><div class=\"dashboard__collab-count avatar_extra-middle\"><svg class=\"inline-wrapper\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon__fill\" d=\"M14.25 7.5c-.414 0-.75.336-.75.75v6.25h-12v-12h6.25c.414 0 .75-.336.75-.75s-.335-.75-.75-.75h-6.75c-.552 0-1 .448-1 1v13c0 .552.448 1 1 1h13c.552 0 1-.448 1-1v-6.75c0-.414-.336-.75-.75-.75zm1.576-5.175l-2.152-2.152c-.117-.117-.27-.174-.424-.174-.154 0-.307.057-.424.175l-8.326 8.325v3h3l8.325-8.325c.117-.118.175-.271.175-.424 0-.154-.057-.307-.174-.425zm-8.825 7.675h-1v-1l7.25-7.25 1 1-7.25 7.25z\"></path></svg></div></a></div></td><td><div ng-hide=\"currentUser.role == 'admin' &amp;&amp; !site.disabled\"><a class=\"link_brand avatar_extra-middle\" ng-click=\"removeEmailTemplate(site.childs, child)\"><svg class=\"icon-close\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" style=\"width: 14px;margin-top: 6px;\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a></div></td></tr></tr></tbody></table></div></div></div></div>";

/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports = "<div class=\"wrapper wrapper_inside\"><div class=\"section\"><div class=\"dashboard\"><a class=\"button button_mb button_add button_green button_middle header-menu__button header-menu__button_dashboard\" title=\"+ section\" ng-click=\"createEmailSectionModal(emailSections)\">Add</a><span class=\"group-title\" ng-if=\"sites &amp;&amp; !sitesCount\">You have no sections yet</span><div class=\"dashboard__items\"><div class=\"dashboard__loader ta-center\"><img width=\"20\" src=\"/constructor/editor/assets/images/loader.gif\" ng-show=\"sectionsLoading\"/></div><table class=\"standart-view table table-hover table-bordered table_middle\" ng-hide=\"sectionsLoading\"><thead><tr><td><a class=\"link_brand\" href=\"javascript: void(0)\" ng-click=\"sortBy('title')\">Name<span>&nbsp;&#8593;&#8595;</span></a></td><td id=\"clicks\">Type</td><td id=\"leads\"><a class=\"link_brand\" href=\"javascript: void(0)\" ng-click=\"sortBy('tags')\">Tags<span>&nbsp;&#8593;&#8595;</span></a></td><td width=\"80px\"></td><td width=\"80px\"></td><td width=\"80px\"></td><td width=\"80px\"></td></tr></thead><tbody><tr class=\"acordeon-tit\" id=\"content-id-2025567\" ng-repeat=\"section in emailSections | orderBy:propertyName:reverse\"><td class=\"text_nowrap\">{{section.title}}</td><td class=\"text_nowrap stats-clicks\">{{section.section_type}}</td><td class=\"text_nowrap stats-leads\">{{section.tags}}</td><td><label class=\"switch switch_dashboard\" for=\"exist_section_{{$index}}\"><input class=\"switch-input\" type=\"checkbox\" id=\"exist_section_{{$index}}\" ng-model=\"section.disabled\" ng-change=\"saveSection(section)\" ng-true-value=\"false\" ng-false-value=\"true\"/><span class=\"switch-label\" data-on=\"\" data-off=\"\"></span><span class=\"switch-handle\"></span></label></td><td><a class=\"link_brand avatar_extra-middle\" ng-click=\"editSectionModal(section)\"><div class=\"dashboard__collab-count\"><img ng-src=\"/constructor/editor/assets/images/gear.svg\" width=\"22px\" height=\"22px\"/></div></a></td><td><a class=\"link_brand dashboard__collab dashboard__collab_avatar link fr\" ui-sref=\"editor.section({sectionId: section.id})\"><div class=\"dashboard__collab-count avatar_extra-middle\"><svg class=\"inline-wrapper\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon__fill\" d=\"M14.25 7.5c-.414 0-.75.336-.75.75v6.25h-12v-12h6.25c.414 0 .75-.336.75-.75s-.335-.75-.75-.75h-6.75c-.552 0-1 .448-1 1v13c0 .552.448 1 1 1h13c.552 0 1-.448 1-1v-6.75c0-.414-.336-.75-.75-.75zm1.576-5.175l-2.152-2.152c-.117-.117-.27-.174-.424-.174-.154 0-.307.057-.424.175l-8.326 8.325v3h3l8.325-8.325c.117-.118.175-.271.175-.424 0-.154-.057-.307-.174-.425zm-8.825 7.675h-1v-1l7.25-7.25 1 1-7.25 7.25z\"></path></svg></div></a></td><td><a class=\"link_brand avatar_extra-middle\" ng-click=\"removeSection(section, emailSections)\"><svg class=\"icon-close\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" style=\"width: 14px;margin-top: 6px;\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a></td></tr></tbody></table></div></div></div></div>";

/***/ }),
/* 304 */
/***/ (function(module, exports) {

module.exports = "";

/***/ }),
/* 305 */
/***/ (function(module, exports) {

module.exports = "<li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{match.model}}\">{{match.model}}</li>";

/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports = "<div class=\"tree-node-content-child\"></div><div class=\"tree-node tree-node-content\" ui-tree-handle=\"\"><div class=\"tree__icon-move tree__icon-move_tags\"><svg class=\"icon__fill icon__stroke icon__inline\" width=\"12\" height=\"12\" viewbox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6.148 1.003l-.005-.003h-5.143v9h9v-9h-3.857zm13 0l-.005-.003h-5.143v9h9v-9h-3.857zm-13 13l-.005-.003h-5.143v9h9v-9h-3.857zm13 0l-.005-.003h-5.143v9h9v-9h-3.857z\"></path></svg></div><a class=\"link tree__link\">{{tag}}</a></div>";

/***/ }),
/* 307 */
/***/ (function(module, exports) {

module.exports = "<div class=\"wrapper wrapper_inside\"><div class=\"section\"><div class=\"dashboard\"><a class=\"button button_mb button_add button_green button_middle header-menu__button header-menu__button_dashboard\" title=\"+ form\" ng-click=\"newWebFormTemplate()\">Add</a><div class=\"dashboard__items\"><div class=\"dashboard-templates__tags\" ui-tree=\"treeWebFormOptions\" data-max-depth=\"1\"><div class=\"dashboard-templates__tags-title\">Template tags</div><div class=\"etn__pages-tree\" id=\"tree-root\"><ol ui-tree-nodes=\"\" ng-model=\"webFormTemplatesTags\"><li class=\"etn__pages-tree__item\" ng-repeat=\"tag in webFormTemplatesTags track by $index\" collapsed=\"false\" ui-tree-node=\"\" ng-include=\"'./dashboard/templates_tags_renderer.jade'\"></li></ol></div></div><div class=\"dashboard__loader ta-center\"><img width=\"20\" src=\"/constructor/editor/assets/images/loader.gif\" ng-show=\"webFormsLoading\"/></div><table class=\"standart-view table table-hover table-bordered table_middle\" ng-hide=\"webFormsLoading\"><thead><tr><td></td><td><a class=\"link_brand\" href=\"javascript: void(0)\" ng-click=\"sortBy('name')\">Name<span>&nbsp;&#8593;&#8595;</span></a></td><td id=\"clicks\">Subdomain</td><td>Type</td><td id=\"leads\">Tags</td><td id=\"conv2\">Last update</td><td ng-show=\"currentUser.role == 'superadmin'\"></td><td></td><td></td><td></td></tr></thead><tbody ng-repeat=\"form in webForms track by $index | orderBy:propertyName:reverse\"><tr class=\"acordeon-tit\" id=\"content-id-2025567\"><td ng-click=\"showChilds = !showChilds\"><div class=\"arrow-site-child arrow-site-child_down\" style=\"position: relative;top: auto;right: auto;\" ng-class=\"{'arrow-site-child_up': showChilds}\" ng-show=\"form.childs.length\"></div></td><td class=\"text_nowrap\">{{form.name}}</td><td class=\"text_nowrap\">{{form.url}}</td><td class=\"text_nowrap\">{{form.type}}</td><td class=\"text_nowrap stats-leads\">{{form.tags}}</td><td class=\"text_nowrap stats-conv2\">{{form.updated_at*1000 | date: \"yyyy-MM-dd\"}}</td><td ng-show=\"currentUser.role == 'superadmin'\"><label class=\"switch switch_dashboard\" for=\"exist_{{$index}}\"><input class=\"switch-input\" type=\"checkbox\" id=\"exist_{{$index}}\" ng-model=\"form.disabled\" ng-change=\"saveWebFormTemplate(form)\" ng-true-value=\"false\" ng-false-value=\"true\"/><span class=\"switch-label\" data-on=\"\" data-off=\"\"></span><span class=\"switch-handle\"></span></label></td><td><div ng-hide=\"currentUser.role == 'admin' &amp;&amp; !form.disabled\"><a class=\"link_brand avatar_extra-middle\" ng-click=\"editWebFormTemplate(form, true)\"><div class=\"dashboard__collab-count\"><img ng-src=\"/constructor/editor/assets/images/gear.svg\" width=\"22px\" height=\"22px\"/></div></a></div></td><td><div ng-hide=\"currentUser.role == 'admin' &amp;&amp; !form.disabled\"><a class=\"link_brand dashboard__collab dashboard__collab_avatar link fr\" ui-sref=\"form.page.editor({formId: form.slug, pageId: getHomePagePath(form.pages)})\"><div class=\"dashboard__collab-count avatar_extra-middle\"><svg class=\"inline-wrapper\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon__fill\" d=\"M14.25 7.5c-.414 0-.75.336-.75.75v6.25h-12v-12h6.25c.414 0 .75-.336.75-.75s-.335-.75-.75-.75h-6.75c-.552 0-1 .448-1 1v13c0 .552.448 1 1 1h13c.552 0 1-.448 1-1v-6.75c0-.414-.336-.75-.75-.75zm1.576-5.175l-2.152-2.152c-.117-.117-.27-.174-.424-.174-.154 0-.307.057-.424.175l-8.326 8.325v3h3l8.325-8.325c.117-.118.175-.271.175-.424 0-.154-.057-.307-.174-.425zm-8.825 7.675h-1v-1l7.25-7.25 1 1-7.25 7.25z\"></path></svg></div></a></div></td><td><div ng-hide=\"currentUser.role == 'admin' &amp;&amp; !form.disabled\"><a class=\"link_brand avatar_extra-middle\" ng-click=\"removeWebFormTemplate(webForms, form)\"><svg class=\"icon-close\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" style=\"width: 14px;margin-top: 6px;\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a></div></td><tr class=\"acordeon-tit\" id=\"content-id-2025567\" ng-repeat=\"child in form.childs track by $index\" ng-show=\"showChilds\"><td><div class=\"template-color\" style=\"background-color: {{child.color}};\"></div></td><td class=\"text_nowrap\">{{child.name}}</td><td class=\"text_nowrap\">{{child.url}}</td><td class=\"text_nowrap\">{{child.type}}</td><td class=\"text_nowrap stats-leads\">{{child.pages.length}}</td><td class=\"text_nowrap stats-conv2\">{{child.updated_at*1000 | date: \"yyyy-MM-dd\"}}</td><td ng-show=\"currentUser.role == 'superadmin'\"><label class=\"switch switch_dashboard\" for=\"exist_{{$parent.$index}}_{{$index}}\"><input class=\"switch-input\" type=\"checkbox\" id=\"exist_{{$parent.$index}}_{{$index}}\" ng-model=\"child.disabled\" ng-change=\"saveWebFormTemplate(child)\" ng-true-value=\"false\" ng-false-value=\"true\"/><span class=\"switch-label\" data-on=\"\" data-off=\"\"></span><span class=\"switch-handle\"></span></label></td><td><div ng-hide=\"currentUser.role == 'admin' &amp;&amp; !form.disabled\"><a class=\"link_brand avatar_extra-middle\" ng-click=\"editWebFormTemplate(child, false)\"><div class=\"dashboard__collab-count\"><img ng-src=\"/constructor/editor/assets/images/gear.svg\" width=\"22px\" height=\"22px\"/></div></a></div></td><td><div ng-hide=\"currentUser.role == 'admin' &amp;&amp; !form.disabled\"><a class=\"link_brand dashboard__collab dashboard__collab_avatar link fr\" ui-sref=\"form.page.editor({formId: child.slug, pageId: getHomePagePath(child.pages)})\"><div class=\"dashboard__collab-count avatar_extra-middle\"><svg class=\"inline-wrapper\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon__fill\" d=\"M14.25 7.5c-.414 0-.75.336-.75.75v6.25h-12v-12h6.25c.414 0 .75-.336.75-.75s-.335-.75-.75-.75h-6.75c-.552 0-1 .448-1 1v13c0 .552.448 1 1 1h13c.552 0 1-.448 1-1v-6.75c0-.414-.336-.75-.75-.75zm1.576-5.175l-2.152-2.152c-.117-.117-.27-.174-.424-.174-.154 0-.307.057-.424.175l-8.326 8.325v3h3l8.325-8.325c.117-.118.175-.271.175-.424 0-.154-.057-.307-.174-.425zm-8.825 7.675h-1v-1l7.25-7.25 1 1-7.25 7.25z\"></path></svg></div></a></div></td><td><div ng-hide=\"currentUser.role == 'admin' &amp;&amp; !form.disabled\"><a class=\"link_brand avatar_extra-middle\" ng-click=\"removeWebFormTemplate(form.childs, child)\"><svg class=\"icon-close\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" style=\"width: 14px;margin-top: 6px;\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a></div></td></tr></tr></tbody></table></div><div class=\"group-title\" ng-if=\"webForms &amp;&amp; !webFormsCount\" style=\"text-align:center;\">No form templates available</div></div></div></div>";

/***/ }),
/* 308 */
/***/ (function(module, exports) {

module.exports = "<div class=\"animate-wrapper\" ng-show=\"currentUser.id\"><div class=\"editor-loader\" ng-class=\"{'loaded': templateIsReady &amp;&amp; !publishing &amp;&amp; !loading}\"><div id=\"loader-wrapper\"><div id=\"loader\"></div><div class=\"loader__text\"><span ng-if=\"!templateIsReady\">{{'editor.loader.loading' | translate}}</span><span ng-if=\"publishing\">{{'editor.loader.saving' | translate}}</span><span ng-if=\"loading\">{{'editor.loader.loading' | translate}}</span></div></div></div><div class=\"editor\"><div class=\"e__tools-overlay\" ng-click=\"editorNavOpen = false; checkIntBlocks()\" ng-show=\"editorNavOpen\"></div><div class=\"e__tools str-slide-right str-slide-right_nowidth\" ng-show=\"editorNavOpen || editorNavOpenWidget\"><div class=\"et-nav\" ng-controller=\"EditorNavigationCtrl\"><div class=\"tutorial__section-drop str-scale-fade-fast\" ng-show=\"sectionDropTutorial\"><img class=\"tutorial__section-drop__icon\" src=\"/constructor/editor/assets/images/section-drop.svg\"/><div class=\"tutorial__section-drop__desc\">{{'editor.panel.sections.tutorial' | translate}}</div></div><div class=\"animate-show etn__list\" resize=\"height\" ng-class=\"{'etn__list_left': !panelRight}\"><div class=\"etn__tab-header\"><div class=\"etsw-header\"><span class=\"etsw-header__title\"></span><a class=\"link_brand\" ng-click=\"togglePanelPosition()\"><img class=\"icon-exchange\" src=\"/constructor/editor/assets/images/exchange.svg\"/></a><a class=\"etsw-header__close fr\" ng-click=\"closeEditorNav()\"><svg class=\"icon-close\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a></div></div><perfect-scrollbar class=\"scroller animate-show etn__tab-container\" id=\"mini-sections\" resize=\"height\" resize-dependence=\".etn__tab-header\" ng-class=\"{'str-shake-it': shakeIt}\"><div ng-controller=\"EditorNavigationSections\"><div class=\"etn-sections\" ng-show=\"currentNavEditorTab == 'sections'\"><ng-include src=\"'./editor/editor_nav/sections/sections.jade'\"></ng-include></div></div><div class=\"etn-settings\" ng-show=\"currentNavEditorTab == 'blockSettings'\"><ng-include src=\"'./editor/editor_nav/blocksettings.jade'\"></ng-include></div></perfect-scrollbar></div></div></div><div class=\"et-block-list et-block-list_window str-scale-fade-fast\" tabindex=\"3\" ng-show=\"widgetMenuShow\" ng-class=\"{'etbl__show': widgetMenuShow}\"><perfect-scrollbar class=\"scroller etbl__blocks etbl__blocks_window\"><div class=\"etbl-group\"><div class=\"etbl-block new-str-block\" ng-repeat=\"block in Editor.Instrumentations.widgetList\" on-finish-render=\"widgets\"><div class=\"etbl-block__icon-wrapper\"><div class=\"widget-block-icon\" style=\"background-image: url('assets/images/editor/icon-{{block.type}}.svg');\"></div></div><span class=\"etbl-block__title\">{{block.name}}</span></div></div></perfect-scrollbar></div><div class=\"etn__buttons\" ng-controller=\"EditorPanelCtrl\" ng-class=\"{'etn__buttons_disabled': editorNavOpenWidget || editorNavOpenWidgetText || editorNavOpen}\"><div class=\"etn__buttons-panel\"><button class=\"etn__panel-button\" ng-click=\"exit()\" ng-disabled=\"!templateIsReady || publishing || loading\"><svg class=\"icon__inline\" width=\"21\" height=\"25\" viewbox=\"0 0 23 25\" xmlns=\"http://www.w3.org/2000/svg\" style=\"height: 100%;\"><g stroke=\"#D95360\" fill=\"none\"><path d=\"M14 20.737v3.263h-13v-23h13v4.381\"></path><path d=\"M22 13h-17\"></path><path d=\"M10 8l-5 5 5 5\"></path></g></svg></button><button class=\"etn__panel-button etn__panel-button_gear\" ng-click=\"siteSettings()\" ng-if=\"Editor.mode == 'site.page.editor'  &amp;&amp; !Editor.option\"><svg width=\"24\" height=\"24\" viewbox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" style=\"height: 100%;\"><path d=\"M20.254 13.5h3.246v-3h-3.247c-.209-.867-.551-2.181-1.003-2.922l2.296-2.295-2.829-2.829-2.297 2.296c-.74-.452-2.053-.793-2.92-1.002v-3.248h-3v3.248c-.867.209-2.181.55-2.921 1.002l-2.297-2.296-2.829 2.829 2.297 2.296c-.452.74-.794 2.054-1.004 2.921h-3.246v3h3.246c.21.867.552 2.181 1.004 2.921l-2.297 2.297 2.829 2.828 2.296-2.297c.741.453 2.055.795 2.922 1.005v3.246h3v-3.246c.867-.21 2.181-.552 2.92-1.004l2.298 2.296 2.828-2.828-2.296-2.297c.452-.74.794-2.054 1.004-2.921zm-3.754-1.5c0 2.486-2.015 4.5-4.5 4.5s-4.5-2.014-4.5-4.5c0-2.485 2.015-4.5 4.5-4.5s4.5 2.015 4.5 4.5z\" stroke=\"#979797\" fill=\"none\"></path></svg></button><a class=\"etn__panel-button ta-center\" ng-if=\"Editor.mode == 'site.page.editor' &amp;&amp; intBlocksExists &amp;&amp; !Editor.option\" ui-sref=\"site.page.mixer\"><svg width=\"24\" height=\"22\" viewbox=\"0 0 24 22\" xmlns=\"http://www.w3.org/2000/svg\" style=\"height: 100%;\"><path d=\"M5.5 18v2h-5.5v-2h5.5zm5.5-2c.271 0 .505.099.703.297.198.198.297.432.297.703v4c0 .271-.099.505-.297.703-.198.198-.432.297-.703.297h-4c-.271 0-.505-.099-.703-.297-.198-.198-.297-.432-.297-.703v-4c0-.271.099-.505.297-.703.198-.198.432-.297.703-.297h4zm2.5-6v2h-13.5v-2h13.5zm-10-8v2h-3.5v-2h3.5zm20.5 16v2h-11.5v-2h11.5zm-15-18c.271 0 .505.099.703.297.198.198.297.432.297.703v4c0 .271-.099.505-.297.703-.198.198-.432.297-.703.297h-4c-.271 0-.505-.099-.703-.297-.198-.198-.297-.432-.297-.703v-4c0-.271.099-.505.297-.703.198-.198.432-.297.703-.297h4zm10 8c.271 0 .505.099.703.297.198.198.297.432.297.703v4c0 .271-.099.505-.297.703-.198.198-.432.297-.703.297h-4c-.271 0-.505-.099-.703-.297-.198-.198-.297-.432-.297-.703v-4c0-.271.099-.505.297-.703.198-.198.432-.297.703-.297h4zm5 2v2h-3.5v-2h3.5zm0-8v2h-13.5v-2h13.5z\" fill=\"#979797\"></path></svg></a><a class=\"etn__panel-button ta-center\" ng-if=\"Editor.mode == 'site.page.editor'\" ng-click=\"savePreview()\" ng-disabled=\"!templateIsReady\"><svg class=\"svg-block icon__inline\" width=\"30\" viewbox=\"0 0 24 14\" xmlns=\"http://www.w3.org/2000/svg\" style=\"height: 100%;\"><g stroke=\"#5BBD83\" fill=\"none\"><path d=\"M23.5 7s-5.148 6.5-11.5 6.5-11.5-6.5-11.5-6.5 5.148-6.5 11.5-6.5 11.5 6.5 11.5 6.5z\"></path><path d=\"M16 7c0 2.21-1.791 4-4 4s-4-1.79-4-4 1.791-4 4-4 4 1.79 4 4z\"></path></g></svg></a><a class=\"etn__panel-button ta-center\" ng-if=\"Editor.mode == 'site.page.editor' &amp;&amp; !Editor.option\" ng-click=\"favoriteSettings()\" ng-disabled=\"!templateIsReady\"><svg class=\"svg-block icon__inline\" xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 53.867 53.867\" enable-background=\"new 0 0 53.867 53.867\" style=\"height: 100%;width: 24px;\" ng-class=\"{'favorite__active': site.is_template}\"><path d=\"M26.934 1.318l8.322 16.864 18.611 2.705-13.467 13.126 3.179 18.536-16.645-8.751-16.646 8.751 3.179-18.536-13.467-13.126 18.611-2.705z\" stroke=\"#979797\" stroke-width=\"2\" fill=\"none\"></path></svg></a><a class=\"etn__panel-button ta-center\" ng-if=\"Editor.mode == 'site.page.editor' &amp;&amp; !Editor.option\" ng-click=\"undo()\" ng-disabled=\"!templateIsReady || !undoActive\"><svg class=\"svg-block icon__inline\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30.02 33.17\" enable-background=\"new 0 0 53.867 53.867\" style=\"height: 100%;width: 24px;\"><path d=\"M13.52,30.48h3a10.8,10.8,0,0,0,0-21.59H4.61l3.82,3.84a1.34,1.34,0,0,1-1.9,1.9L.6,8.67A1.34,1.34,0,0,1,0,7.55v0a1.39,1.39,0,0,1,.39-1L6.53.4a1.34,1.34,0,1,1,1.9,1.89L4.54,6.21h12a13.48,13.48,0,0,1,0,27h-3a1.35,1.35,0,0,1,0-2.69Z\" stroke=\"#979797\" fill=\"none\"></path></svg></a><a class=\"etn__panel-button ta-center\" ng-if=\"Editor.mode == 'site.page.editor' &amp;&amp; !Editor.option\" ng-click=\"redo()\" ng-disabled=\"!templateIsReady || !redoActive\"><svg class=\"svg-block icon__inline\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30.02 33.17\" enable-background=\"new 0 0 53.867 53.867\" style=\"height: 100%;width: 24px;\"><path d=\"M16.49,30.48h-3a10.8,10.8,0,0,1,0-21.59H25.4l-3.82,3.84a1.35,1.35,0,0,0,1.91,1.9l5.93-6A1.34,1.34,0,0,0,30,7.55v0a1.36,1.36,0,0,0-.4-1L23.49.4a1.34,1.34,0,0,0-1.91,1.89l3.9,3.92h-12a13.48,13.48,0,0,0,0,27h3a1.35,1.35,0,1,0,0-2.69Z\" stroke=\"#979797\" fill=\"none\"></path></svg></a><button class=\"etn__panel-button etn__panel-button_build etn__panel-button_green\" ng-if=\"Editor.mode == 'site.page.editor'\" ng-click=\"publishSite()\" ng-disabled=\"publishing || loading || isSaveDisabled\"><span ng-if=\"publishing\">{{'editor.bottomPanel.saving' | translate}}</span><span ng-if=\"!publishing\">{{'editor.bottomPanel.save' | translate}}</span><img width=\"20\" style=\"margin-left:10px;\" src=\"/constructor/editor/assets/images/loader_white.svg\" title=\"{{editor.bottomPanel.saving | translate}}\" ng-show=\"buildIsNotFinish\"/></button><button class=\"etn__panel-button etn__panel-button_build etn__panel-button_green\" ng-if=\"Editor.mode == 'editor.section'\" ng-click=\"sectionSave()\" ng-disabled=\"sectionSaving\"><span ng-if=\"sectionSaving\">{{'editor.bottomPanel.saving' | translate}}</span><span ng-if=\"!sectionSaving\">{{'editor.bottomPanel.save2' | translate}}</span></button></div><div id=\"custom-intercom-container\" ng-show=\"justclick.intercomFields.helpChatIsGranted\"><div class=\"intercom-launcher\" data-reactroot=\"\"><div class=\"intercom-launcher-open-icon\"></div><div class=\"intercom-launcher-close-icon\"></div></div></div></div><button class=\"button button_green button_middle header-menu__button button_add-element\" ng-click=\"openEditorNav()\" ng-show=\"!Editor.option\">+ {{'editor.addElementButton' | translate}}</button><div class=\"et-alert-window modal-content animate-show animate-show_opacity\" ng-controller=\"alertEditDialogCtrl\" ng-show=\"alertEditDialogShow\" tabindex=\"3\"><div class=\"modal__remove-content ta-center\" ng-if=\"alertEditDialogShow\"><div class=\"middle-title\">{{params.title}}</div><p class=\"modal__remove-text\">{{params.text}}</p><button class=\"button button_margin button_red button_extra-small button_modal\" str-auto-focus=\"\" ng-click=\"accept()\">{{params.accept_text}}</button><button class=\"button button_margin button_grayish-blue button_extra-small button_modal\" ng-click=\"cancel()\" ng-show=\"params.cancel_text.length\">{{params.cancel_text}}</button></div><div class=\"modal-backdrop modal-backdrop_editor\"></div></div><div class=\"e__page\" resize=\"height\" resize-attr=\"min-height\"><style id=\"tplStyles\"></style><style id=\"fontStyles\"></style><div class=\"e-header__area ng-hide\" ng-show=\"showHeader &amp;&amp; Editor.mode == 'site.page.editor' &amp;&amp; !Editor.option\" ng-click=\"editorNavTab('sections','Шапка', true)\"><span class=\"e__area-name\">{{'editor.headerPlaceholder.title' | translate}}</span><span class=\"e__area-description\">{{'editor.headerPlaceholder' | translate}}</span></div><div class=\"tpl-wrapper\" id=\"tpl-wrapper\" ng-class=\"{'e__section-editor__wrapper':Editor.mode == 'editor.section'}\"><div class=\"str-drop-backdrop str-drop-backdrop_animate inline-middle\" ng-class=\"{'no-sections': !contentSections.length}\" ng-hide=\"contentSections.length || isCollectionPage\" ng-if=\"Editor.mode == 'site.page.editor'\" data-section-id=\"drop-backdrop\"><div class=\"sdb__description\"><div class=\"sdb__icon widget-block-icon\" style=\"background-image: url('assets/images/editor/icon-text-color.svg');\"></div><div class=\"sdb__icon widget-block-icon\" style=\"background-image: url('assets/images/editor/icon-image-color.svg');\"></div><div class=\"sdb__icon widget-block-icon\" style=\"background-image: url('assets/images/editor/icon-video-color.svg');\"></div><div class=\"sdb__description-text\">{{'editor.contentPlaceHolder' | translate}}</div></div></div></div><div class=\"e-footer__area ng-hide\" ng-show=\"showFooter &amp;&amp; Editor.mode == 'site.page.editor' &amp;&amp; !Editor.option\" ng-click=\"editorNavTab('sections','Подвал', true)\"><span class=\"e__area-name\">{{'editor.footerPlaceholder.title' | translate}}</span><span class=\"e__area-description\">{{'editor.footerPlaceholder' | translate}}</span></div><div class=\"disable-overlay\" ng-show=\"widgetIsEditing\" ng-click=\"editSection();checkIntBlocks();\"></div></div></div><ng-include src=\"'./common/templates/tutorial.jade'\" ng-if=\"currentUser\"></ng-include><ng-include src=\"'./common/templates/preview.jade'\" ng-if=\"currentUser\"></ng-include></div>";

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports = "<div class=\"animate-wrapper\"><div class=\"editor-loader\" ng-class=\"{'loaded': templateIsReady &amp;&amp; !publishing &amp;&amp; !loading}\"><div id=\"loader-wrapper\"><div id=\"loader\"></div><div class=\"loader__text\"><span ng-if=\"!templateIsReady\">{{'editor.loader.loading' | translate}}</span><span ng-if=\"publishing\">{{'editor.loader.saving' | translate}}</span><span ng-if=\"loading\">{{'editor.loader.loading' | translate}}</span></div></div></div><div class=\"editor\"><div class=\"e__tools-overlay\" ng-click=\"editorNavOpen = false\" ng-show=\"editorNavOpen\"></div><div class=\"e__tools str-slide-right str-slide-right_nowidth\" ng-show=\"editorNavOpen || editorNavOpenWidget\"><div class=\"et-nav\" ng-controller=\"EditorNavigationCtrl\"><div class=\"tutorial__section-drop str-scale-fade-fast\" ng-show=\"sectionDropTutorial\"><img class=\"tutorial__section-drop__icon\" src=\"/constructor/editor/assets/images/section-drop.svg\"/><div class=\"tutorial__section-drop__desc\">{{'editor.panel.sections.tutorial' | translate}}</div></div><div class=\"animate-show etn__list\" resize=\"height\" ng-class=\"{'etn__list_left': !panelRight}\"><div class=\"etn__tab-header\"><div class=\"etsw-header\"><span class=\"etsw-header__title\"></span><a class=\"link_brand\" ng-click=\"togglePanelPosition()\"><img class=\"icon-exchange\" src=\"/constructor/editor/assets/images/exchange.svg\"/></a><a class=\"etsw-header__close fr\" ng-click=\"closeEditorNav()\"><svg class=\"icon-close\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a></div></div><perfect-scrollbar class=\"scroller animate-show etn__tab-container\" id=\"mini-sections\" resize=\"height\" resize-dependence=\".etn__tab-header\" ng-class=\"{'str-shake-it': shakeIt}\"><div ng-controller=\"EditorNavigationSections\"><div class=\"etn-sections\" ng-show=\"currentNavEditorTab == 'sections'\"><ng-include src=\"'./editor/editor_nav/sections/sections.jade'\"></ng-include></div></div><div class=\"etn-settings\" ng-show=\"currentNavEditorTab == 'blockSettings'\"><ng-include src=\"'./editor/editor_nav/blocksettings.jade'\"></ng-include></div></perfect-scrollbar></div></div></div><div class=\"et-block-list et-block-list_window str-scale-fade-fast\" tabindex=\"3\" ng-show=\"widgetMenuShow\" ng-class=\"{'etbl__show': widgetMenuShow}\"><perfect-scrollbar class=\"scroller etbl__blocks etbl__blocks_window\"><div class=\"etbl-group\"><div class=\"etbl-block new-str-block\" ng-repeat=\"block in Editor.Instrumentations.widgetList\" on-finish-render=\"widgets\"><div class=\"etbl-block__icon-wrapper\"><div class=\"widget-block-icon\" style=\"background-image: url('assets/images/editor/icon-{{block.type}}.svg');\"></div></div><span class=\"etbl-block__title\">{{block.name}}</span></div></div></perfect-scrollbar></div><div class=\"etn__buttons\" ng-controller=\"EditorPanelCtrl\" ng-class=\"{'etn__buttons_disabled': editorNavOpenWidget || editorNavOpenWidgetText || editorNavOpen}\"><div class=\"etn__buttons-panel\"><button class=\"etn__panel-button\" ng-click=\"exit()\" ng-disabled=\"!templateIsReady || publishing\"><svg class=\"icon__inline\" width=\"21\" height=\"25\" viewbox=\"0 0 23 25\" xmlns=\"http://www.w3.org/2000/svg\" style=\"height: 100%;\"><g stroke=\"#D95360\" fill=\"none\"><path d=\"M14 20.737v3.263h-13v-23h13v4.381\"></path><path d=\"M22 13h-17\"></path><path d=\"M10 8l-5 5 5 5\"></path></g></svg></button><button class=\"etn__panel-button etn__panel-button_gear\" ng-click=\"siteSettings()\" ng-if=\"Editor.mode == 'email.page.editor'\"><svg width=\"24\" height=\"24\" viewbox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" style=\"height: 100%;\"><path d=\"M20.254 13.5h3.246v-3h-3.247c-.209-.867-.551-2.181-1.003-2.922l2.296-2.295-2.829-2.829-2.297 2.296c-.74-.452-2.053-.793-2.92-1.002v-3.248h-3v3.248c-.867.209-2.181.55-2.921 1.002l-2.297-2.296-2.829 2.829 2.297 2.296c-.452.74-.794 2.054-1.004 2.921h-3.246v3h3.246c.21.867.552 2.181 1.004 2.921l-2.297 2.297 2.829 2.828 2.296-2.297c.741.453 2.055.795 2.922 1.005v3.246h3v-3.246c.867-.21 2.181-.552 2.92-1.004l2.298 2.296 2.828-2.828-2.296-2.297c.452-.74.794-2.054 1.004-2.921zm-3.754-1.5c0 2.486-2.015 4.5-4.5 4.5s-4.5-2.014-4.5-4.5c0-2.485 2.015-4.5 4.5-4.5s4.5 2.015 4.5 4.5z\" stroke=\"#979797\" fill=\"none\"></path></svg></button><a class=\"etn__panel-button ta-center\" ng-if=\"Editor.mode == 'email.page.editor'\" ng-click=\"savePreview()\" ng-disabled=\"!templateIsReady\"><svg class=\"svg-block icon__inline\" width=\"30\" viewbox=\"0 0 24 14\" xmlns=\"http://www.w3.org/2000/svg\" style=\"height: 100%;\"><g stroke=\"#5BBD83\" fill=\"none\"><path d=\"M23.5 7s-5.148 6.5-11.5 6.5-11.5-6.5-11.5-6.5 5.148-6.5 11.5-6.5 11.5 6.5 11.5 6.5z\"></path><path d=\"M16 7c0 2.21-1.791 4-4 4s-4-1.79-4-4 1.791-4 4-4 4 1.79 4 4z\"></path></g></svg></a><a class=\"etn__panel-button ta-center\" ng-if=\"Editor.mode == 'email.page.editor'\" ng-click=\"favoriteSettings()\" ng-disabled=\"!templateIsReady\"><svg class=\"svg-block icon__inline\" xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 53.867 53.867\" enable-background=\"new 0 0 53.867 53.867\" style=\"height: 100%;width: 24px;\" ng-class=\"{'favorite__active': site.is_template}\"><path d=\"M26.934 1.318l8.322 16.864 18.611 2.705-13.467 13.126 3.179 18.536-16.645-8.751-16.646 8.751 3.179-18.536-13.467-13.126 18.611-2.705z\" stroke=\"#979797\" stroke-width=\"2\" fill=\"none\"></path></svg></a><a class=\"etn__panel-button ta-center\" ng-if=\"Editor.mode == 'email.page.editor' &amp;&amp; !Editor.option\" ng-click=\"undo()\" ng-disabled=\"!templateIsReady || !undoActive\"><svg class=\"svg-block icon__inline\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30.02 33.17\" enable-background=\"new 0 0 53.867 53.867\" style=\"height: 100%;width: 24px;\"><path d=\"M13.52,30.48h3a10.8,10.8,0,0,0,0-21.59H4.61l3.82,3.84a1.34,1.34,0,0,1-1.9,1.9L.6,8.67A1.34,1.34,0,0,1,0,7.55v0a1.39,1.39,0,0,1,.39-1L6.53.4a1.34,1.34,0,1,1,1.9,1.89L4.54,6.21h12a13.48,13.48,0,0,1,0,27h-3a1.35,1.35,0,0,1,0-2.69Z\" stroke=\"#979797\" fill=\"none\"></path></svg></a><a class=\"etn__panel-button ta-center\" ng-if=\"Editor.mode == 'email.page.editor' &amp;&amp; !Editor.option\" ng-click=\"redo()\" ng-disabled=\"!templateIsReady || !redoActive\"><svg class=\"svg-block icon__inline\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30.02 33.17\" enable-background=\"new 0 0 53.867 53.867\" style=\"height: 100%;width: 24px;\"><path d=\"M16.49,30.48h-3a10.8,10.8,0,0,1,0-21.59H25.4l-3.82,3.84a1.35,1.35,0,0,0,1.91,1.9l5.93-6A1.34,1.34,0,0,0,30,7.55v0a1.36,1.36,0,0,0-.4-1L23.49.4a1.34,1.34,0,0,0-1.91,1.89l3.9,3.92h-12a13.48,13.48,0,0,0,0,27h3a1.35,1.35,0,1,0,0-2.69Z\" stroke=\"#979797\" fill=\"none\"></path></svg></a><button class=\"etn__panel-button etn__panel-button_build etn__panel-button_green\" ng-if=\"Editor.mode == 'email.page.editor'\" ng-click=\"publishSite()\" ng-disabled=\"publishing\"><span ng-if=\"publishing\">{{'editor.bottomPanel.saving' | translate}}</span><span ng-if=\"!publishing\">{{'editor.bottomPanel.saveEmail' | translate}}</span><img width=\"20\" style=\"margin-left:10px;\" src=\"/constructor/editor/assets/images/loader_white.svg\" title=\"{{editor.bottomPanel.saving | translate}}\" ng-show=\"buildIsNotFinish\"/></button><button class=\"etn__panel-button etn__panel-button_build etn__panel-button_green\" ng-if=\"Editor.mode == 'editor.section'\" ng-click=\"sectionSave()\" ng-disabled=\"sectionSaving\"><span ng-if=\"sectionSaving\">{{'editor.bottomPanel.saving' | translate}}</span><span ng-if=\"!sectionSaving\">{{'editor.bottomPanel.save2' | translate}}</span></button></div><div id=\"custom-intercom-container\" ng-show=\"justclick.intercomFields.helpChatIsGranted\"><div class=\"intercom-launcher\" data-reactroot=\"\"><div class=\"intercom-launcher-open-icon\"></div><div class=\"intercom-launcher-close-icon\"></div></div></div></div><button class=\"button button_green button_middle header-menu__button button_add-element\" ng-click=\"openEditorNav()\">+ {{'editor.addElementButton' | translate}}</button><div class=\"et-alert-window modal-content animate-show animate-show_opacity\" ng-controller=\"alertEditDialogCtrl\" ng-show=\"alertEditDialogShow\" tabindex=\"3\"><div class=\"modal__remove-content ta-center\" ng-if=\"alertEditDialogShow\"><div class=\"middle-title\">{{params.title}}</div><p class=\"modal__remove-text\">{{params.text}}</p><button class=\"button button_margin button_red button_extra-small button_modal\" str-auto-focus=\"\" ng-click=\"accept()\">{{params.accept_text}}</button><button class=\"button button_margin button_grayish-blue button_extra-small button_modal\" ng-click=\"cancel()\" ng-show=\"params.cancel_text.length\">{{params.cancel_text}}</button></div><div class=\"modal-backdrop modal-backdrop_editor\"></div></div><div class=\"e__page\" resize=\"height\" resize-attr=\"min-height\"><style id=\"tplStyles\"></style><div class=\"e-header__area ng-hide\" ng-show=\"showHeader &amp;&amp; Editor.mode == 'email.page.editor'\" ng-click=\"editorNavTab('sections','Шапка', true)\"><span class=\"e__area-name\">{{'editor.headerPlaceholder.title' | translate}}</span><span class=\"e__area-description\">{{'editor.headerPlaceholder' | translate}}</span></div><div class=\"tpl-wrapper\" id=\"tpl-wrapper\" ng-class=\"{'e__section-editor__wrapper':Editor.mode == 'editor.section'}\"><div class=\"str-drop-backdrop str-drop-backdrop_animate inline-middle\" ng-class=\"{'no-sections': !contentSections.length}\" ng-hide=\"contentSections.length || isCollectionPage\" ng-if=\"Editor.mode == 'email.page.editor'\" data-section-id=\"drop-backdrop\"><div class=\"sdb__description\"><div class=\"sdb__icon widget-block-icon\" style=\"background-image: url('assets/images/editor/icon-text-color.svg');\"></div><div class=\"sdb__icon widget-block-icon\" style=\"background-image: url('assets/images/editor/icon-image-color.svg');\"></div><div class=\"sdb__icon widget-block-icon\" style=\"background-image: url('assets/images/editor/icon-video-color.svg');\"></div><div class=\"sdb__description-text\">{{'editor.contentPlaceHolder' | translate}}</div></div></div></div><div class=\"e-footer__area ng-hide\" ng-show=\"showFooter &amp;&amp; Editor.mode == 'email.page.editor'\" ng-click=\"editorNavTab('sections','Подвал', true)\"><span class=\"e__area-name\">{{'editor.footerPlaceholder.title' | translate}}</span><span class=\"e__area-description\">{{'editor.footerPlaceholder' | translate}}</span></div><div class=\"disable-overlay\" ng-show=\"widgetIsEditing\" ng-click=\"editSection()\"></div></div></div><ng-include src=\"'./common/templates/tutorial.jade'\" ng-if=\"currentUser\"></ng-include><ng-include src=\"'./common/templates/preview.jade'\" ng-if=\"currentUser\"></ng-include></div>";

/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports = "<div class=\"animate-wrapper\"><div class=\"editor-loader\" ng-class=\"{'loaded': templateIsReady &amp;&amp; !publishing &amp;&amp; !loading}\"><div id=\"loader-wrapper\"><div id=\"loader\"></div><div class=\"loader__text\"><span ng-if=\"!templateIsReady\">{{'editor.loader.loading' | translate}}</span><span ng-if=\"publishing\">{{'editor.loader.saving' | translate}}</span><span ng-if=\"loading\">{{'editor.loader.loading' | translate}}</span></div></div></div><div class=\"editor\"><div class=\"e__tools-overlay\" ng-click=\"editorNavOpen = false\" ng-show=\"editorNavOpen\"></div><div class=\"e__tools str-slide-right str-slide-right_nowidth\" ng-show=\"editorNavOpen || editorNavOpenWidget\"><div class=\"et-nav\" ng-controller=\"EditorNavigationCtrl\"><div class=\"tutorial__section-drop str-scale-fade-fast\" ng-show=\"sectionDropTutorial\"><img class=\"tutorial__section-drop__icon\" src=\"/constructor/editor/assets/images/section-drop.svg\"/><div class=\"tutorial__section-drop__desc\">{{'editor.panel.sections.tutorial' | translate}}</div></div><div class=\"animate-show etn__list\" resize=\"height\" ng-class=\"{'etn__list_left': !panelRight}\"><div class=\"etn__tab-header\"><div class=\"etsw-header\"><span class=\"etsw-header__title\"></span><a class=\"link_brand\" ng-click=\"togglePanelPosition()\"><img class=\"icon-exchange\" src=\"/constructor/editor/assets/images/exchange.svg\"/></a><a class=\"etsw-header__close fr\" ng-click=\"closeEditorNav()\"><svg class=\"icon-close\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a></div></div><perfect-scrollbar class=\"scroller animate-show etn__tab-container\" id=\"mini-sections\" resize=\"height\" resize-dependence=\".etn__tab-header\" ng-class=\"{'str-shake-it': shakeIt}\"><div ng-controller=\"EditorNavigationSections\"><div class=\"etn-sections\" ng-show=\"currentNavEditorTab == 'sections'\"><ng-include src=\"'./editor/editor_nav/sections/sections.jade'\"></ng-include></div></div><div class=\"etn-settings\" ng-show=\"currentNavEditorTab == 'blockSettings'\"><ng-include src=\"'./editor/editor_nav/blocksettings.jade'\"></ng-include></div></perfect-scrollbar></div></div></div><div class=\"et-block-list et-block-list_window str-scale-fade-fast\" tabindex=\"3\" ng-show=\"widgetMenuShow\" ng-class=\"{'etbl__show': widgetMenuShow}\"><perfect-scrollbar class=\"scroller etbl__blocks etbl__blocks_window\"><div class=\"etbl-group\"><div class=\"etbl-block new-str-block\" ng-repeat=\"block in Editor.Instrumentations.widgetList\" on-finish-render=\"widgets\"><div class=\"etbl-block__icon-wrapper\"><div class=\"widget-block-icon\" style=\"background-image: url('assets/images/editor/icon-{{block.type}}.svg');\"></div></div><span class=\"etbl-block__title\">{{block.name}}</span></div></div></perfect-scrollbar></div><div class=\"etn__buttons\" ng-controller=\"EditorPanelCtrl\" ng-class=\"{'etn__buttons_disabled': editorNavOpenWidget || editorNavOpenWidgetText || editorNavOpen}\"><div class=\"etn__buttons-panel\"><button class=\"etn__panel-button\" ng-click=\"exit()\" ng-disabled=\"!templateIsReady || publishing || loading\"><svg class=\"icon__inline\" width=\"21\" height=\"25\" viewbox=\"0 0 23 25\" xmlns=\"http://www.w3.org/2000/svg\" style=\"height: 100%;\"><g stroke=\"#D95360\" fill=\"none\"><path d=\"M14 20.737v3.263h-13v-23h13v4.381\"></path><path d=\"M22 13h-17\"></path><path d=\"M10 8l-5 5 5 5\"></path></g></svg></button><!-- todo: Вернуть кнопку для превью после исправления всех багов--><!--a.etn__panel-button.ta-center(ng-if=\"Editor.mode == 'form.page.editor'\", ng-click=\"savePreview()\", ng-disabled=\"!templateIsReady\")--><!--  svg.svg-block.icon__inline(width='30', viewbox='0 0 24 14', xmlns='http://www.w3.org/2000/svg', style=\"height: 100%;\")--><!--    g(stroke='#5BBD83', fill='none')--><!--      path(d='M23.5 7s-5.148 6.5-11.5 6.5-11.5-6.5-11.5-6.5 5.148-6.5 11.5-6.5 11.5 6.5 11.5 6.5z')--><!--      path(d='M16 7c0 2.21-1.791 4-4 4s-4-1.79-4-4 1.791-4 4-4 4 1.79 4 4z')--><a class=\"etn__panel-button ta-center\" ng-if=\"Editor.mode == 'form.page.editor'\" ng-click=\"favoriteSettings()\" ng-disabled=\"!templateIsReady\"><svg class=\"svg-block icon__inline\" xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 53.867 53.867\" enable-background=\"new 0 0 53.867 53.867\" style=\"height: 100%;width: 24px;\" ng-class=\"{'favorite__active': site.is_template}\"><path d=\"M26.934 1.318l8.322 16.864 18.611 2.705-13.467 13.126 3.179 18.536-16.645-8.751-16.646 8.751 3.179-18.536-13.467-13.126 18.611-2.705z\" stroke=\"#979797\" stroke-width=\"2\" fill=\"none\"></path></svg></a><a class=\"etn__panel-button ta-center\" ng-if=\"Editor.mode == 'form.page.editor' &amp;&amp; !Editor.option\" ng-click=\"undo()\" ng-disabled=\"!templateIsReady || !undoActive\"><svg class=\"svg-block icon__inline\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30.02 33.17\" enable-background=\"new 0 0 53.867 53.867\" style=\"height: 100%;width: 24px;\"><path d=\"M13.52,30.48h3a10.8,10.8,0,0,0,0-21.59H4.61l3.82,3.84a1.34,1.34,0,0,1-1.9,1.9L.6,8.67A1.34,1.34,0,0,1,0,7.55v0a1.39,1.39,0,0,1,.39-1L6.53.4a1.34,1.34,0,1,1,1.9,1.89L4.54,6.21h12a13.48,13.48,0,0,1,0,27h-3a1.35,1.35,0,0,1,0-2.69Z\" stroke=\"#979797\" fill=\"none\"></path></svg></a><a class=\"etn__panel-button ta-center\" ng-if=\"Editor.mode == 'form.page.editor' &amp;&amp; !Editor.option\" ng-click=\"redo()\" ng-disabled=\"!templateIsReady || !redoActive\"><svg class=\"svg-block icon__inline\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30.02 33.17\" enable-background=\"new 0 0 53.867 53.867\" style=\"height: 100%;width: 24px;\"><path d=\"M16.49,30.48h-3a10.8,10.8,0,0,1,0-21.59H25.4l-3.82,3.84a1.35,1.35,0,0,0,1.91,1.9l5.93-6A1.34,1.34,0,0,0,30,7.55v0a1.36,1.36,0,0,0-.4-1L23.49.4a1.34,1.34,0,0,0-1.91,1.89l3.9,3.92h-12a13.48,13.48,0,0,0,0,27h3a1.35,1.35,0,1,0,0-2.69Z\" stroke=\"#979797\" fill=\"none\"></path></svg></a><button class=\"etn__panel-button etn__panel-button_build etn__panel-button_green\" ng-if=\"Editor.mode == 'form.page.editor'\" ng-click=\"publishSite()\" ng-disabled=\"publishing || loading\" ng-hide=\"!site.is_template\"><span ng-if=\"publishing\">{{'editor.bottomPanel.saving' | translate}}</span><span ng-if=\"!publishing\">{{'editor.bottomPanel.save2' | translate}}</span><img width=\"20\" style=\"margin-left:10px;\" src=\"/constructor/editor/assets/images/loader_white.svg\" title=\"{{editor.bottomPanel.saving | translate}}\" ng-show=\"buildIsNotFinish &amp;&amp; buildingType == 'publishSite'\"/></button><button class=\"etn__panel-button etn__panel-button_build etn__panel-button_blue\" ng-if=\"Editor.mode == 'form.page.editor' &amp;&amp; !justclick.needSaveForm\" ng-click=\"publishForm()\"><span>{{'form.Publish' | translate}}</span><img width=\"20\" style=\"margin-left:10px;\" src=\"/constructor/editor/assets/images/loader_white.svg\" title=\"{{editor.bottomPanel.saving | translate}}\" ng-show=\"buildIsNotFinish &amp;&amp; buildingType == 'publishForm'\"/></button><button class=\"etn__panel-button etn__panel-button_build etn__panel-button_green\" ng-if=\"Editor.mode == 'form.page.editor' &amp;&amp; justclick.needSaveForm\" ng-click=\"publishForm()\"><span>{{'form.SaveAndPublish' | translate}}</span><img width=\"20\" style=\"margin-left:10px;\" src=\"/constructor/editor/assets/images/loader_white.svg\" title=\"{{editor.bottomPanel.saving | translate}}\" ng-show=\"buildIsNotFinish &amp;&amp; buildingType == 'publishForm'\"/></button></div><div id=\"custom-intercom-container\" ng-show=\"justclick.intercomFields.helpChatIsGranted\"><div class=\"intercom-launcher\" data-reactroot=\"\"><div class=\"intercom-launcher-open-icon\"></div><div class=\"intercom-launcher-close-icon\"></div></div></div></div><button class=\"button button_green button_middle header-menu__button button_add-element\" ng-click=\"openEditorNav()\">+ {{'editor.addElementButton' | translate}}</button><div class=\"et-alert-window modal-content animate-show animate-show_opacity\" ng-controller=\"alertEditDialogCtrl\" ng-show=\"alertEditDialogShow\" tabindex=\"3\"><div class=\"modal__remove-content ta-center\" ng-if=\"alertEditDialogShow\"><div class=\"middle-title\">{{params.title}}</div><p class=\"modal__remove-text\">{{params.text}}</p><button class=\"button button_margin button_red button_extra-small button_modal\" str-auto-focus=\"\" ng-click=\"accept()\">{{params.accept_text}}</button><button class=\"button button_margin button_grayish-blue button_extra-small button_modal\" ng-click=\"cancel()\" ng-show=\"params.cancel_text.length\">{{params.cancel_text}}</button></div><div class=\"modal-backdrop modal-backdrop_editor\"></div></div><div class=\"e__page\" resize=\"height\" resize-attr=\"min-height\"><style id=\"tplStyles\"></style><div class=\"tpl-wrapper\" id=\"tpl-wrapper\" ng-class=\"{'e__section-editor__wrapper':Editor.mode == 'editor.section'}\"><div class=\"str-drop-backdrop str-drop-backdrop_animate inline-middle\" ng-class=\"{'no-sections': !contentSections.length}\" ng-hide=\"contentSections.length || isCollectionPage\" data-section-id=\"drop-backdrop\" style=\"height:0;\"></div></div><div class=\"disable-overlay\" ng-show=\"widgetIsEditing\" ng-click=\"editSection()\"></div></div></div><ng-include src=\"'./common/templates/tutorial.jade'\" ng-if=\"currentUser\"></ng-include><ng-include src=\"'./common/templates/preview.jade'\" ng-if=\"currentUser\"></ng-include></div>";

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports = "<ui-view></ui-view>";

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports = "<div class=\"animate-wrapper\"><div class=\"editor-loader\" ng-class=\"{'loaded': templateIsReady &amp;&amp; !publishing &amp;&amp; !loading}\"><div id=\"loader-wrapper\"><div id=\"loader\"></div><div class=\"loader__text\"><span ng-if=\"!templateIsReady\">{{'editor.loader.loading' | translate}}</span><span ng-if=\"publishing\">{{'editor.loader.saving' | translate}}</span><span ng-if=\"loading\">{{'editor.loader.loading' | translate}}</span></div></div></div><div class=\"editor\"><div class=\"e__tools-overlay\" ng-click=\"editorNavOpen = false; checkInteractiveBlocks()\" ng-show=\"editorNavOpen\"></div><div class=\"e__tools str-slide-right str-slide-right_nowidth\" ng-show=\"editorNavOpen || editorNavOpenWidget\"><div class=\"et-nav\" ng-controller=\"EditorNavigationCtrl\"><div class=\"tutorial__section-drop str-scale-fade-fast\" ng-show=\"sectionDropTutorial\"><img class=\"tutorial__section-drop__icon\" src=\"/constructor/editor/assets/images/section-drop.svg\"/><div class=\"tutorial__section-drop__desc\">{{'editor.panel.sections.tutorial' | translate}}</div></div><div class=\"animate-show etn__list\" resize=\"height\" ng-class=\"{'etn__list_left': !panelRight}\"><div class=\"etn__tab-header\"><div class=\"etsw-header\"><span class=\"etsw-header__title\"></span><a class=\"link_brand\" ng-click=\"togglePanelPosition()\"><img class=\"icon-exchange\" src=\"/constructor/editor/assets/images/exchange.svg\"/></a><a class=\"etsw-header__close fr\" ng-click=\"closeEditorNav()\"><svg class=\"icon-close\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a></div></div><perfect-scrollbar class=\"scroller animate-show etn__tab-container\" id=\"mini-sections\" resize=\"height\" resize-dependence=\".etn__tab-header\" ng-class=\"{'str-shake-it': shakeIt}\"><div ng-controller=\"EditorNavigationSections\"><div class=\"etn-sections\" ng-show=\"currentNavEditorTab == 'sections'\"><ng-include src=\"'./editor/editor_nav/sections/sections.jade'\"></ng-include></div></div><div class=\"etn-settings\" ng-show=\"currentNavEditorTab == 'blockSettings'\"><ng-include src=\"'./editor/editor_nav/blocksettings.jade'\"></ng-include></div></perfect-scrollbar></div></div></div><div class=\"et-block-list et-block-list_window str-scale-fade-fast\" tabindex=\"3\" ng-show=\"widgetMenuShow\" ng-class=\"{'etbl__show': widgetMenuShow}\"><perfect-scrollbar class=\"scroller etbl__blocks etbl__blocks_window\"><div class=\"etbl-group\"><div class=\"etbl-block new-str-block\" ng-repeat=\"block in Editor.Instrumentations.widgetList\" on-finish-render=\"widgets\"><div class=\"etbl-block__icon-wrapper\"><div class=\"widget-block-icon\" style=\"background-image: url('assets/images/editor/icon-{{block.type}}.svg');\"></div></div><span class=\"etbl-block__title\">{{block.name}}</span></div></div></perfect-scrollbar></div><div class=\"etn__buttons\" ng-controller=\"EditorPanelCtrl\" ng-class=\"{'etn__buttons_disabled': editorNavOpenWidget || editorNavOpenWidgetText || editorNavOpen}\"><div class=\"etn__buttons-panel\"><button class=\"etn__panel-button\" ng-click=\"exit()\" ng-disabled=\"!templateIsReady || publishing || loading\"><svg class=\"icon__inline\" width=\"21\" height=\"25\" viewbox=\"0 0 23 25\" xmlns=\"http://www.w3.org/2000/svg\" style=\"height: 100%;\"><g stroke=\"#D95360\" fill=\"none\"><path d=\"M14 20.737v3.263h-13v-23h13v4.381\"></path><path d=\"M22 13h-17\"></path><path d=\"M10 8l-5 5 5 5\"></path></g></svg></button><button class=\"etn__panel-button etn__panel-button_gear\" ng-click=\"siteSettings()\" ng-if=\"Editor.mode == 'lesson.page.editor' &amp;&amp; !Editor.option\"><svg width=\"24\" height=\"24\" viewbox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" style=\"height: 100%;\"><path d=\"M20.254 13.5h3.246v-3h-3.247c-.209-.867-.551-2.181-1.003-2.922l2.296-2.295-2.829-2.829-2.297 2.296c-.74-.452-2.053-.793-2.92-1.002v-3.248h-3v3.248c-.867.209-2.181.55-2.921 1.002l-2.297-2.296-2.829 2.829 2.297 2.296c-.452.74-.794 2.054-1.004 2.921h-3.246v3h3.246c.21.867.552 2.181 1.004 2.921l-2.297 2.297 2.829 2.828 2.296-2.297c.741.453 2.055.795 2.922 1.005v3.246h3v-3.246c.867-.21 2.181-.552 2.92-1.004l2.298 2.296 2.828-2.828-2.296-2.297c.452-.74.794-2.054 1.004-2.921zm-3.754-1.5c0 2.486-2.015 4.5-4.5 4.5s-4.5-2.014-4.5-4.5c0-2.485 2.015-4.5 4.5-4.5s4.5 2.015 4.5 4.5z\" stroke=\"#979797\" fill=\"none\"></path></svg></button><a class=\"etn__panel-button ta-center\" ng-if=\"Editor.mode == 'lesson.page.editor' &amp;&amp; intBlocksExists &amp;&amp; !Editor.option\" ui-sref=\"lesson.page.mixer\"><svg width=\"24\" height=\"22\" viewbox=\"0 0 24 22\" xmlns=\"http://www.w3.org/2000/svg\" style=\"height: 100%;\"><path d=\"M5.5 18v2h-5.5v-2h5.5zm5.5-2c.271 0 .505.099.703.297.198.198.297.432.297.703v4c0 .271-.099.505-.297.703-.198.198-.432.297-.703.297h-4c-.271 0-.505-.099-.703-.297-.198-.198-.297-.432-.297-.703v-4c0-.271.099-.505.297-.703.198-.198.432-.297.703-.297h4zm2.5-6v2h-13.5v-2h13.5zm-10-8v2h-3.5v-2h3.5zm20.5 16v2h-11.5v-2h11.5zm-15-18c.271 0 .505.099.703.297.198.198.297.432.297.703v4c0 .271-.099.505-.297.703-.198.198-.432.297-.703.297h-4c-.271 0-.505-.099-.703-.297-.198-.198-.297-.432-.297-.703v-4c0-.271.099-.505.297-.703.198-.198.432-.297.703-.297h4zm10 8c.271 0 .505.099.703.297.198.198.297.432.297.703v4c0 .271-.099.505-.297.703-.198.198-.432.297-.703.297h-4c-.271 0-.505-.099-.703-.297-.198-.198-.297-.432-.297-.703v-4c0-.271.099-.505.297-.703.198-.198.432-.297.703-.297h4zm5 2v2h-3.5v-2h3.5zm0-8v2h-13.5v-2h13.5z\" fill=\"#979797\"></path></svg></a><a class=\"etn__panel-button ta-center\" ng-click=\"savePreview()\" ng-disabled=\"!templateIsReady\"><svg class=\"svg-block icon__inline\" width=\"30\" viewbox=\"0 0 24 14\" xmlns=\"http://www.w3.org/2000/svg\" style=\"height: 100%;\"><g stroke=\"#5BBD83\" fill=\"none\"><path d=\"M23.5 7s-5.148 6.5-11.5 6.5-11.5-6.5-11.5-6.5 5.148-6.5 11.5-6.5 11.5 6.5 11.5 6.5z\"></path><path d=\"M16 7c0 2.21-1.791 4-4 4s-4-1.79-4-4 1.791-4 4-4 4 1.79 4 4z\"></path></g></svg></a><a class=\"etn__panel-button ta-center\" ng-if=\"Editor.mode == 'lesson.page.editor' &amp;&amp; !Editor.option\" ng-click=\"favoriteSettings()\" ng-disabled=\"!templateIsReady\"><svg class=\"svg-block icon__inline\" xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 53.867 53.867\" enable-background=\"new 0 0 53.867 53.867\" style=\"height: 100%;width: 24px;\" ng-class=\"{'favorite__active': site.is_template}\"><path d=\"M26.934 1.318l8.322 16.864 18.611 2.705-13.467 13.126 3.179 18.536-16.645-8.751-16.646 8.751 3.179-18.536-13.467-13.126 18.611-2.705z\" stroke=\"#979797\" stroke-width=\"2\" fill=\"none\"></path></svg></a><a class=\"etn__panel-button ta-center\" ng-if=\"Editor.mode == 'lesson.page.editor' &amp;&amp; !Editor.option\" ng-click=\"undo()\" ng-disabled=\"!templateIsReady || !undoActive\"><svg class=\"svg-block icon__inline\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30.02 33.17\" enable-background=\"new 0 0 53.867 53.867\" style=\"height: 100%;width: 24px;\"><path d=\"M13.52,30.48h3a10.8,10.8,0,0,0,0-21.59H4.61l3.82,3.84a1.34,1.34,0,0,1-1.9,1.9L.6,8.67A1.34,1.34,0,0,1,0,7.55v0a1.39,1.39,0,0,1,.39-1L6.53.4a1.34,1.34,0,1,1,1.9,1.89L4.54,6.21h12a13.48,13.48,0,0,1,0,27h-3a1.35,1.35,0,0,1,0-2.69Z\" stroke=\"#979797\" fill=\"none\"></path></svg></a><a class=\"etn__panel-button ta-center\" ng-if=\"Editor.mode == 'lesson.page.editor' &amp;&amp; !Editor.option\" ng-click=\"redo()\" ng-disabled=\"!templateIsReady || !redoActive\"><svg class=\"svg-block icon__inline\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30.02 33.17\" enable-background=\"new 0 0 53.867 53.867\" style=\"height: 100%;width: 24px;\"><path d=\"M16.49,30.48h-3a10.8,10.8,0,0,1,0-21.59H25.4l-3.82,3.84a1.35,1.35,0,0,0,1.91,1.9l5.93-6A1.34,1.34,0,0,0,30,7.55v0a1.36,1.36,0,0,0-.4-1L23.49.4a1.34,1.34,0,0,0-1.91,1.89l3.9,3.92h-12a13.48,13.48,0,0,0,0,27h3a1.35,1.35,0,1,0,0-2.69Z\" stroke=\"#979797\" fill=\"none\"></path></svg></a><button class=\"etn__panel-button etn__panel-button_build etn__panel-button_green\" ng-click=\"publishSite()\" ng-disabled=\"publishing || loading\"><span ng-if=\"publishing\">{{'editor.bottomPanel.saving' | translate}}</span><span ng-if=\"!publishing\">{{'editor.bottomPanel.save2' | translate}}</span><img width=\"20\" style=\"margin-left:10px;\" src=\"/constructor/editor/assets/images/loader_white.svg\" title=\"{{editor.bottomPanel.saving | translate}}\" ng-show=\"buildIsNotFinish\"/></button></div><div id=\"custom-intercom-container\" ng-show=\"justclick.intercomFields.helpChatIsGranted\"><div class=\"intercom-launcher\" data-reactroot=\"\"><div class=\"intercom-launcher-open-icon\"></div><div class=\"intercom-launcher-close-icon\"></div></div></div></div><button class=\"button button_green button_middle header-menu__button button_add-element\" ng-click=\"openEditorNav()\">+ {{'editor.addElementButton' | translate}}</button><div class=\"et-alert-window modal-content animate-show animate-show_opacity\" ng-controller=\"alertEditDialogCtrl\" ng-show=\"alertEditDialogShow\" tabindex=\"3\"><div class=\"modal__remove-content ta-center\" ng-if=\"alertEditDialogShow\"><div class=\"middle-title\">{{params.title}}</div><p class=\"modal__remove-text\">{{params.text}}</p><button class=\"button button_margin button_red button_extra-small button_modal\" str-auto-focus=\"\" ng-click=\"accept()\">{{params.accept_text}}</button><button class=\"button button_margin button_grayish-blue button_extra-small button_modal\" ng-click=\"cancel()\" ng-show=\"params.cancel_text.length\">{{params.cancel_text}}</button></div><div class=\"modal-backdrop modal-backdrop_editor\"></div></div><div class=\"e__lesson e__page\" resize=\"height\" resize-attr=\"min-height\"><div id=\"tpl-wrapper\"><style id=\"tplStyles\"></style><div id=\"lmsStyles\"></div><div class=\"e-header__area\" ng-hide=\"true\"></div><div class=\"e-footer__area\" ng-hide=\"true\"></div><div class=\"e__lesson__header\"></div><div class=\"e__lesson__content\"><div class=\"container\"><div class=\"e__lesson__content__title\">{{site.name}}</div><div class=\"tpl-wrapper\" ng-class=\"{'e__section-editor__wrapper':Editor.mode == 'editor.section'}\"><div class=\"str-drop-backdrop str-drop-backdrop_animate inline-middle\" ng-class=\"{'no-sections': !contentSections.length}\" ng-hide=\"contentSections.length || isCollectionPage\" ng-if=\"Editor.mode == 'lesson.page.editor'\" data-section-id=\"drop-backdrop\"><div class=\"sdb__description\"><div class=\"sdb__icon widget-block-icon\" style=\"background-image: url('assets/images/editor/icon-text-color.svg');\"></div><div class=\"sdb__icon widget-block-icon\" style=\"background-image: url('assets/images/editor/icon-image-color.svg');\"></div><div class=\"sdb__icon widget-block-icon\" style=\"background-image: url('assets/images/editor/icon-video-color.svg');\"></div><div class=\"sdb__description-text\">{{'editor.contentPlaceHolder' | translate}}</div></div></div></div></div></div></div><div class=\"e__lesson__footer\"></div><div class=\"disable-overlay\" ng-show=\"widgetIsEditing\" ng-click=\"editSection(); checkInteractiveBlocks();\"></div></div></div><ng-include src=\"'./common/templates/tutorial.jade'\" ng-if=\"currentUser\"></ng-include><ng-include src=\"'./common/templates/preview.jade'\" ng-if=\"currentUser\"></ng-include></div>";

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports = "<div class=\"et-settings-panel\" ng-controller=\"blockEditDialogCtrl\" tabindex=\"3\"><div class=\"et-sw-wrapper\" ng-tabs=\"\" ng-if=\"settings.body\"><div class=\"etsw-body\" ng-html-compile=\"settings.body\" ng-class=\"{'str-shake-it': shakeIt}\"></div></div></div>";

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports = "<div class=\"etn__site-settings-desc\" ng-init=\"getGoogleFonts()\"><div class=\"link etn__description etn__description_inline etn__back-link\" ng-click=\"editorNavTab('templateSettings'); destroyFonts()\">&#8592; назад</div><div class=\"etn__title etn__title_inline\">Шрифты</div><div class=\"etn__description\">В этом разделе можно подключить<br> шрифты в редактор вашего сайта</div></div><div class=\"etn-loader__wrapper\" ng-show=\"fontsLoading\"><img class=\"etn__templates-loader\" src=\"/constructor/editor/assets/images/loader.gif\" ng-if=\"fontsLoading\"/></div><div class=\"et-settings-panel\" tabindex=\"3\" ng-show=\"!fontsLoading\"><div class=\"etnr-item__fonts\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Поиск по шрифтам</label><input class=\"input input_extra-small button_border\" autocomplete=\"off\" ng-model=\"fontName\" placeholder=\"Поиск\" type=\"text\" typeahead=\"font.family for font in searchFonts($viewValue)\" typeahead-min-length=\"3\" typeahead-template-url=\"./editor/font_settings/fonts-typeahead-match.jade\" typeahead-on-select=\"setFont($item, $model, $label)\"/></div><div class=\"input-wrapper ta-left\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.selectedFont\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{selectedFont.family || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" data-ng-repeat=\"font in GFonts\" ng-click=\"optionCheck($event, font); connectFont(font);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper ta-left\" ng-show=\"selectedFont.family\"><span ng-style=\"{'font-family': selectedFont.family, 'font-size': 16}\" contenteditable=\"\">Example</span></div><div class=\"input-wrapper ta-left\" ng-show=\"selectedFont.variants.length\"><label class=\"label-input\">Выберите стиль шрифта</label><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\" ng-repeat=\"variant in selectedFont.variants\"><input class=\"checkbox\" type=\"checkbox\" ng-attr-id=\"{{variant}}\" ng-model=\"fontSettings.variants[variant]\"/><label class=\"checkbox-label-wrapper\" ng-attr-for=\"{{variant}}\" title=\"Variant\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{variant}}</span></label></div></div><div class=\"input-wrapper ta-left\" ng-show=\"selectedFont.subsets.length\"><label class=\"label-input\">Выберите локализацию</label><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\" ng-repeat=\"subset in selectedFont.subsets\"><input class=\"checkbox\" type=\"checkbox\" ng-attr-id=\"{{subset}}\" ng-model=\"fontSettings.subsets[subset]\"/><label class=\"checkbox-label-wrapper\" ng-attr-for=\"{{subset}}\" title=\"Subset\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{subset}}</span></label></div></div><div class=\"ta-left input-wrapper\"><button class=\"button button_green button_middle header-menu__button\" ng-click=\"addFont(selectedFont)\" ng-disabled=\"adding || !selectedFont.family\" noloader=\"\">Добавить шрифт</button></div><div class=\"input-wrapper ta-left\" ng-if=\"site.fonts_attributes.length\"><label class=\"label-input\">Добавленные шрифты</label><ul class=\"objects-list\"><li class=\"objects-list__item\" ng-repeat=\"font in site.fonts_attributes\"><div class=\"objects-list__item-info fl\"><span ng-style=\"{'font-family': font.family}\">{{font.family}}</span><div class=\"objects-list__item-info__subtext\"><span ng-repeat=\"variant in font.variants\">{{variant}}<span ng-if=\"!$last\">,&nbsp;</span></span><span ng-if=\"font.subsets.length\">|</span><span ng-repeat=\"subset in font.subsets\">{{subset}}<span ng-if=\"!$last\">,&nbsp;</span></span></div></div><div class=\"ms__button-remove font-remove fr\" ng-show=\"!font._destroy\"><a class=\"etn__image-remove icon-trash icon-trash_black inline-wrapper\" ng-click=\"removeFont(font)\"></a></div></li></ul></div></div></div>";

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports = "<div class=\"etn__site-settings-desc etn__site-settings-desc_etnr\"><div class=\"link etn__description etn__description_inline etn__back-link\" ng-click=\"editorNavTab('templateSettings')\">&#8592; назад</div><div class=\"etn__title etn__title_inline\">Вставка HTML кода</div><div class=\"etn__description\">В данном разделе вы можете вставить HTML-код в тег HEAD для всех страниц сайта.</div></div><form class=\"input-wrapper ta-left\" name=\"siteHtmlHeadForm\" ng-submit=\"saveSite(site, siteHtmlHeadForm)\"><label class=\"label-input\" for=\"html\">HTML-код для вставки в тег HEAD</label><textarea class=\"textarea ms-checkbox_margin textarea textarea_extra-small button_border\" id=\"html\" ng-model=\"site.head_html\" name=\"headHtml\" placeholder=\"Вставьте код\" type=\"text\"></textarea><button class=\"button button_green button_extra-small\" ng-disabled=\"savingSite\" type=\"submit\">Сохранить</button></form>";

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports = "<div class=\"etn__site-settings-desc\"><div class=\"link etn__description etn__description_inline etn__back-link\" ng-click=\"editorNavTab('templateSettings')\">&#8592; назад</div><div class=\"etn__title etn__title_inline\">Страницы сайта</div><div class=\"etn__description\">В этом разделе можно настроить<br> страницы вашего сайта</div></div><div class=\"input-wrapper ta-left pages__settings\" ng-controller=\"PagesSettingsCtrl\"><div class=\"etn__site-settings-desc\"><div class=\"etn__title\">Страницы<button class=\"add-page__button\" ng-click=\"createPage('static')\"><img class=\"add-page__button-icon\" src=\"/constructor/editor/assets/images/add.svg\"/></button></div></div><div ui-tree=\"treeOptions\" data-max-depth=\"2\"><div class=\"etn__pages-tree\" id=\"tree-root\"><ol ui-tree-nodes=\"\" ng-model=\"site.pages\"><li class=\"etn__pages-tree__item\" ng-repeat=\"page in site.pages\" ui-tree-node=\"\" ng-include=\"'./site/page/tree_renderer.jade'\"></li></ol></div></div></div>";

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports = "<div class=\"etn__site-settings__sections\"><div class=\"etn__elements-menu\"><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': elementsCurrentTab == 'widgets'}\" ng-click=\"openTab('widgets')\" ng-show=\"Editor.mode === 'form.page.editor'\" style=\"margin-right:0;\">{{'editor.widgets' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': elementsCurrentTab == 'widgets'}\" ng-click=\"openTab('widgets')\" ng-show=\"Editor.mode !== 'form.page.editor'\">{{'editor.widgets' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': elementsCurrentTab == 'sections'}\" ng-click=\"openTab('sections')\" ng-show=\"Editor.mode !== 'form.page.editor' &amp;&amp; Editor.mode !== 'editor.email'\">{{'editor.sections' | translate}}</a></div><div ng-show=\"elementsCurrentTab == 'widgets'\"><div class=\"et-block-list str-scale-fade-fast\" tabindex=\"3\" ng-show=\"layoutIsEditing\"><div class=\"etbl__blocks\"><div class=\"etbl-group\"><div class=\"etbl-block new-str-block\" ng-repeat=\"block in Editor.Instrumentations.widgetList\" on-finish-render=\"widgets\" ng-if=\"block.type != 'form'\"><div class=\"etbl-block__icon-wrapper\"><div class=\"widget-block-icon\" style=\"background-image: url('assets/images/editor/icon-{{block.type}}.svg');\"></div></div><span class=\"etbl-block__title\">{{block.name}}</span></div></div></div></div><div class=\"et-block-list str-scale-fade-fast et-block-list_text\" tabindex=\"3\" ng-show=\"!layoutIsEditing\">{{'editor.section.tutorial' | translate}}</div></div><div ng-show=\"elementsCurrentTab == 'sections'\"><div class=\"ms ms-tab-pane\" ng-repeat=\"category in categories\"><span class=\"ms__title ms__title_sections\" title=\"{{category.name}}\" ng-click=\"editorAccordion($event); getSectionsByCategory(category)\">{{category.name}}</span><div class=\"ms__section\"><div class=\"etn-loader__wrapper\"><img class=\"etn__templates-loader\" src=\"/constructor/editor/assets/images/loader.gif\" ng-if=\"category.sectionsLoading\"/></div><p ng-if=\"category.sections.length == 0\">{{'editor.NoSections' | translate}}</p><div class=\"etnr-item\" ng-repeat=\"item in category.sections\"><a class=\"label-info label-info_left label-info_middle link_white\" ui-sref=\"editor.section({sectionId: item.id})\" access=\"admin superadmin\" access-element=\"true\">Изменить</a><div class=\"label-info label-info_right label-info_small link_white\" ng-if=\"!item.is_own_section\" access=\"admin superadmin\" access-element=\"true\" ng-click=\"removeSection($index, item, category.sections)\" ng-hide=\"item.id == state.params.sectionId\"><div class=\"inline-wrapper icon-trash\"></div></div><div class=\"label-info label-info_right label-info_small link_white\" ng-if=\"item.is_own_section\" ng-click=\"removeSection($index, item, category.sections)\" ng-hide=\"item.id == state.params.sectionId\"><div class=\"inline-wrapper icon-trash\"></div></div><div class=\"etnr-item__link\" ng-class=\"{'etnr-item__link_no_image': !item.preview_url}\"><img class=\"etnr-item__image\" ng-src=\"{{item.preview_url}}\" alt=\"{{item.title}}\" imageonload=\"\"/><div class=\"etnr-item__caption-wrapper inline-middle\"><span class=\"etnr-item__caption inline-wrapper\">{{item.title}}</span></div></div></div></div></div></div></div>";

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"><div class=\"middle-title ta-center\">New section</div></div><form name=\"createSectionForm\" novalidate=\"\" ng-submit=\"create(createSectionForm, section)\"><div class=\"modal-body\"><div class=\"ms\"><div class=\"ms__content ms-text\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Name</label><input class=\"input input_extra-small ms-input_border\" type=\"text\" name=\"title\" required=\"\" ng-class=\"{'error':createSectionForm.title.$invalid &amp;&amp; createSectionForm.$submitted}\" str-auto-focus=\"\" placeholder=\"Section Name\" ng-model=\"section.title\"/></div></div><div class=\"ms__content ms-text\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Tags</label><tags-input ng-model=\"section.tags\" min-length=\"{{currentUser.lang === 'ja' ? 1 : 3}}\" load-on-empty=\"true\" load-on-focus=\"true\" replace-spaces-with-dashes=\"false\" allow-leftover-text=\"true\" display-property=\"name\"><auto-complete source=\"loadTags($query)\" load-on-empty=\"true\" load-on-focus=\"true\"></auto-complete></tags-input></div></div><div class=\"ms__content ms-text\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Color tags for template</label><tags-input ng-model=\"section.colors\" min-length=\"{{currentUser.lang === 'ja' ? 1 : 3}}\" load-on-empty=\"true\" load-on-focus=\"true\" replace-spaces-with-dashes=\"false\"><auto-complete source=\"loadColorTags($query)\" load-on-empty=\"true\" load-on-focus=\"true\"></auto-complete></tags-input></div></div><div class=\"etn__preview etn__preview_web ta-left\" ng-if=\"!section.custom_preview_url_enabled\"><div class=\"label-input\">Image section</div><input class=\"ng-hide\" id=\"etn__preview_web\" type=\"file\" nv-file-select=\"\" uploader=\"sectionPreviewUploader\"/><span class=\"file-name\">{{sectionPreviewUploader.queue[0].file.name}}</span><label for=\"etn__preview_web\"><div class=\"etn__preview-upload etn__preview-upload_web ms-input_border {{'favorite.upload_web_hint' | translate}}\"><img class=\"etn__preview-image\" ng-src=\"{{site.preview.thumb}}\" err-src=\"/constructor/editor/assets/images/image-error.svg\"/><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': sectionPreviewUploader.progress + '%' }\" ng-show=\"sectionPreviewUploader.progress\"></div></div></label></div><div class=\"input-wrapper ta-left\"><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"disablesite\" type=\"checkbox\" ng-model=\"section.custom_preview_url_enabled\"/><label class=\"checkbox-label-wrapper\" title=\"\" for=\"disablesite\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Specify a variable with a link to the image</span></label></div></div><div class=\"input-wrapper\" ng-if=\"section.custom_preview_url_enabled\"><label class=\"label-input\">Web preview variable</label><input class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.name.length}\" ng-model=\"section.custom_preview_url\" placeholder=\"Variable\" type=\"text\"/></div></div><div class=\"input-wrapper ta-left\"><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"disablesite\" type=\"checkbox\" ng-model=\"section.disabled\"/><label class=\"checkbox-label-wrapper\" title=\"Hide template\" for=\"disablesite\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Hide section</span></label></div></div></div><div class=\"modal-footer ta-center\"><button class=\"button button_margin button_green button_extra-small button_modal\" ng-disabled=\"creating\">Add section</button><button class=\"button button_margin button_grayish-blue button_extra-small button_modal\" ng-click=\"close($event)\">Cancel</button></div></form>";

/***/ }),
/* 319 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"><div class=\"middle-title ta-center\">Editing a section</div></div><form name=\"editSectionForm\" novalidate=\"\" ng-submit=\"save(editSectionForm)\"><div class=\"modal-body\"><div class=\"ms\"><div class=\"ms__content ms-text\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Name</label><input class=\"input input_extra-small ms-input_border\" type=\"text\" name=\"title\" required=\"\" ng-class=\"{'error':editSectionForm.title.$invalid &amp;&amp; editSectionForm.$submitted}\" str-auto-focus=\"\" placeholder=\"Section Name\" ng-model=\"section.title\"/></div></div><div class=\"ms__content ms-text\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Tags</label><tags-input ng-model=\"section.tags\" min-length=\"{{currentUser.lang === 'ja' ? 1 : 3}}\" load-on-empty=\"true\" load-on-focus=\"true\" replace-spaces-with-dashes=\"false\" allow-leftover-text=\"true\" display-property=\"name\"><auto-complete source=\"loadTags($query)\" load-on-empty=\"true\" load-on-focus=\"true\"></auto-complete></tags-input></div></div><div class=\"ms__content ms-text\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Color tags for template</label><tags-input ng-model=\"section.colors\" min-length=\"{{currentUser.lang === 'ja' ? 1 : 3}}\" load-on-empty=\"true\" load-on-focus=\"true\" replace-spaces-with-dashes=\"false\" allow-leftover-text=\"true\"><auto-complete source=\"loadColorTags($query)\" load-on-empty=\"true\" load-on-focus=\"true\"></auto-complete></tags-input></div></div><div class=\"etn__preview etn__preview_web ta-left\" ng-if=\"!section.custom_preview_url_enabled\"><div class=\"label-input\">Image section</div><input class=\"ng-hide\" id=\"etn__preview_web\" type=\"file\" nv-file-select=\"\" uploader=\"sectionPreviewUploader\"/><span class=\"file-name\">{{sectionPreviewUploader.queue[0].file.name}}</span><label for=\"etn__preview_web\"><div class=\"etn__preview-upload etn__preview-upload_web etn__preview-upload_section ms-input_border {{'favorite.upload_web_hint' | translate}}\"><img class=\"etn__preview-image\" ng-src=\"{{section.preview_url}}\" err-src=\"/constructor/editor/assets/images/image-error.svg\"/><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': sectionPreviewUploader.progress + '%' }\" ng-show=\"sectionPreviewUploader.progress\"></div></div></label></div><div class=\"input-wrapper ta-left\"><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"disablesite\" type=\"checkbox\" ng-model=\"section.custom_preview_url_enabled\"/><label class=\"checkbox-label-wrapper\" title=\"\" for=\"disablesite\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Specify a variable with a link to the image</span></label></div></div><div class=\"input-wrapper\" ng-if=\"section.custom_preview_url_enabled\"><label class=\"label-input\">Web preview variable</label><input class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.name.length}\" ng-model=\"section.custom_preview_url\" placeholder=\"Variable\" type=\"text\"/></div></div><div class=\"input-wrapper ta-left\"><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"disablesite\" type=\"checkbox\" ng-model=\"section.disabled\"/><label class=\"checkbox-label-wrapper\" title=\"Hide template\" for=\"disablesite\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Hide section</span></label></div></div></div><div class=\"modal-footer ta-center\"><button class=\"button button_margin button_green button_extra-small button_modal\" ng-disabled=\"updating\">Save</button><button class=\"button button_margin button_grayish-blue button_extra-small button_modal\" ng-click=\"close($event)\">Cancel</button></div></form>";

/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"><div class=\"middle-title ta-center\">New message</div></div><form name=\"createEmailForm\" novalidate=\"\" ng-submit=\"create(createEmailForm, email)\"><div class=\"modal-body\"><div class=\"ms\"><div class=\"ms__content ms-text\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Name</label><input class=\"input input_extra-small ms-input_border\" type=\"text\" name=\"title\" required=\"\" ng-class=\"{'error':createEmailForm.title.$invalid &amp;&amp; createEmailForm.$submitted}\" str-auto-focus=\"\" placeholder=\"Email Name\" ng-model=\"email.title\"/></div></div><div class=\"ms__content ms-text\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Tags</label><tags-input ng-model=\"email.tags\" min-length=\"{{currentUser.lang === 'ja' ? 1 : 3}}\" load-on-empty=\"true\" load-on-focus=\"true\" replace-spaces-with-dashes=\"false\" allow-leftover-text=\"true\"><auto-complete source=\"loadTags($query)\"></auto-complete></tags-input></div></div></div><div class=\"input-wrapper-group\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Description *</label><textarea class=\"textarea textarea_extra-small ms-input_border input\" placeholder=\"Description\" ng-model=\"email.description\" name=\"description\"></textarea></div></div><div class=\"input-wrapper-group\"><div class=\"etn__preview etn__preview_web ta-left\"><div class=\"label-input\">Web Preview</div><input class=\"ng-hide\" id=\"etn__preview_web\" type=\"file\" nv-file-select=\"\" uploader=\"webPreviewUploader\"/><span class=\"file-name\">{{webPreviewUploader.queue[0].file.name}}</span><label for=\"etn__preview_web\"><div class=\"etn__preview-upload etn__preview-upload_web ms-input_border {{'favorite.upload_web_hint' | translate}}\"><img class=\"etn__preview-image\" ng-src=\"{{email.preview.thumb}}\" err-src=\"/constructor/editor/assets/images/image-error.svg\"/><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': webPreviewUploader.progress + '%' }\" ng-show=\"webPreviewUploader.progress\"></div></div></label></div><div class=\"etn__preview etn__preview_mobile ta-left\"><div class=\"input-wrapper\"><div class=\"label-input\">Mobile Preview</div><input class=\"ng-hide\" id=\"etn__preview_mobile\" type=\"file\" nv-file-select=\"\" uploader=\"mobilePreviewUploader\"/><span class=\"file-name\">{{mobilePreviewUploader.queue[0].file.name}}</span><label for=\"etn__preview_mobile\"><div class=\"etn__preview-upload etn__preview-upload_mobile ms-input_border\"><img class=\"etn__preview-image\" ng-src=\"{{email.mobile_preview.thumb}}\" err-src=\"/constructor/editor/assets/images/image-error.svg\"/><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': mobilePreviewUploader.progress + '%' }\" ng-show=\"mobilePreviewUploader.progress\"></div></div></label></div></div></div></div><div class=\"modal-footer ta-center\"><button class=\"button button_margin button_green button_extra-small button_modal\" ng-disabled=\"creating\">Save</button><button class=\"button button_margin button_grayish-blue button_extra-small button_modal\" ng-click=\"close($event)\">Cancel</button></div></form>";

/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"><div class=\"middle-title ta-center\">Editing message</div></div><form name=\"editEmailForm\" novalidate=\"\" ng-submit=\"save(editEmailForm)\"><div class=\"modal-body\"><div class=\"ms\"><div class=\"ms__content ms-text\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Name</label><input class=\"input input_extra-small ms-input_border\" type=\"text\" name=\"title\" required=\"\" ng-class=\"{'error':editEmailForm.title.$invalid &amp;&amp; editEmailForm.$submitted}\" str-auto-focus=\"\" placeholder=\"Section Name\" ng-model=\"email.title\"/></div></div><div class=\"ms__content ms-text\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Tags</label><tags-input ng-model=\"email.tags\" min-length=\"{{currentUser.lang === 'ja' ? 1 : 3}}\" load-on-empty=\"true\" load-on-focus=\"true\" replace-spaces-with-dashes=\"false\" allow-leftover-text=\"true\"><auto-complete source=\"loadTags($query)\" load-on-empty=\"true\" load-on-focus=\"true\"></auto-complete></tags-input></div></div></div><div class=\"input-wrapper-group\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Description *</label><textarea class=\"textarea textarea_extra-small ms-input_border input\" placeholder=\"Description\" ng-model=\"email.description\" name=\"description\"></textarea></div></div><div class=\"input-wrapper-group\"><div class=\"etn__preview etn__preview_web ta-left\"><div class=\"label-input\">Web Preview</div><input class=\"ng-hide\" id=\"etn__preview_web\" type=\"file\" nv-file-select=\"\" uploader=\"webPreviewUploader\"/><span class=\"file-name\">{{webPreviewUploader.queue[0].file.name}}</span><label for=\"etn__preview_web\"><div class=\"etn__preview-upload etn__preview-upload_web ms-input_border {{'favorite.upload_web_hint' | translate}}\"><img class=\"etn__preview-image\" ng-src=\"{{email.preview.thumb}}\" err-src=\"/constructor/editor/assets/images/image-error.svg\"/><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': webPreviewUploader.progress + '%' }\" ng-show=\"webPreviewUploader.progress\"></div></div></label></div><div class=\"etn__preview etn__preview_mobile ta-left\"><div class=\"input-wrapper\"><div class=\"label-input\">Mobile Preview</div><input class=\"ng-hide\" id=\"etn__preview_mobile\" type=\"file\" nv-file-select=\"\" uploader=\"mobilePreviewUploader\"/><span class=\"file-name\">{{mobilePreviewUploader.queue[0].file.name}}</span><label for=\"etn__preview_mobile\"><div class=\"etn__preview-upload etn__preview-upload_mobile ms-input_border\"><img class=\"etn__preview-image\" ng-src=\"{{email.mobile_preview.thumb}}\" err-src=\"/constructor/editor/assets/images/image-error.svg\"/><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': mobilePreviewUploader.progress + '%' }\" ng-show=\"mobilePreviewUploader.progress\"></div></div></label></div></div></div></div><div class=\"modal-footer ta-center\"><button class=\"button button_margin button_green button_extra-small button_modal\" ng-disabled=\"updating\">Save</button><button class=\"button button_margin button_grayish-blue button_extra-small button_modal\" ng-click=\"close($event)\">Cancel</button></div></form>";

/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports = "<li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{match.model.family}}\">{{match.model.family}}</li>";

/***/ }),
/* 323 */
/***/ (function(module, exports) {

module.exports = "<div class=\"dropdown-menu dropdown-menu__collaborator\" ng-show=\"isOpen() &amp;&amp; !moveInProgress\" ng-style=\"{top: position().top+'px', left: position().left+'px'}\" style=\"display: block;\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown__option dropdown__option_white\" ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index)\" role=\"option\" id=\"{{::match.id}}\"><div typeahead-match=\"\" index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div></div></perfect-scrollbar></div>";

/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports = "<div class=\"input input_nano input_align\"><a class=\"link link_align\" ng-class=\"{'link_align_active': textAlign == 'left'}\" ng-click=\"textAlign = 'left'\"><svg width=\"24px\" height=\"13px\" viewBox=\"0 0 24 13\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"icon__fill\"><rect x=\"0\" y=\"0\" width=\"24\" height=\"1\"></rect><rect x=\"0\" y=\"4\" width=\"16\" height=\"1\"></rect><rect x=\"0\" y=\"8\" width=\"24\" height=\"1\"></rect><rect x=\"0\" y=\"12\" width=\"16\" height=\"1\"></rect></g></svg></a><a class=\"link link_align\" ng-class=\"{'link_align_active': textAlign == 'center'}\" ng-click=\"textAlign = 'center'\"><svg width=\"24px\" height=\"13px\" viewBox=\"0 0 24 13\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"icon__fill\"><rect x=\"0\" y=\"0\" width=\"24\" height=\"1\"></rect><rect x=\"4\" y=\"4\" width=\"16\" height=\"1\"></rect><rect x=\"0\" y=\"8\" width=\"24\" height=\"1\"></rect><rect x=\"4\" y=\"12\" width=\"16\" height=\"1\"></rect></g></svg></a><a class=\"link link_align\" ng-class=\"{'link_align_active': textAlign == 'right'}\" ng-click=\"textAlign = 'right'\"><svg width=\"24px\" height=\"13px\" viewBox=\"0 0 24 13\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"icon__fill\"><rect x=\"0\" y=\"0\" width=\"24\" height=\"1\"></rect><rect x=\"8\" y=\"4\" width=\"16\" height=\"1\"></rect><rect x=\"0\" y=\"8\" width=\"24\" height=\"1\"></rect><rect x=\"8\" y=\"12\" width=\"16\" height=\"1\"></rect></g></svg></a></div>";

/***/ }),
/* 325 */
/***/ (function(module, exports) {

module.exports = "<span class=\"ms__caption\">{{'editor.panel.blockSettings.section.background1.imagesLabel' | translate}}</span><div class=\"ms-fields-control\"><a class=\"link group-title fields-control fields-control_add fl\" title=\"Добавить картинку\" ng-click=\"add()\"><svg class=\"icon__fields-control\" viewBox=\"0 0 17 17\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"icon__fill\"><rect x=\"0\" y=\"8\" width=\"17\" height=\"1\"></rect><rect x=\"8\" y=\"0\" width=\"1\" height=\"17\"></rect></g></svg></a><a class=\"link group-title fields-control fields-control_remove fl\" title=\"Удалить картинку\" ng-click=\"remove()\"><svg class=\"icon__fields-control\" viewBox=\"0 0 17 17\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"icon__fill\"><rect x=\"0\" y=\"8\" width=\"17\" height=\"1\"></rect></g></svg></a></div><ul class=\"ms-fields-list\"><li class=\"ms-fields-list__item\" ng-show=\"!fieldsLength(section.background_attributes.images_attributes)\"><a class=\"link ms-fields-list__item-link\" title=\"Нет слайдов\">{{'editor.panel.blockSettings.section.background1.emptyLabel' | translate}}</a></li><li class=\"ms-fields-list__item\" ng-repeat=\"field in section.background_attributes.images_attributes track by $index\" ng-show=\"!field._destroy\"><a class=\"link ms-fields-list__item-link\" ng-click=\"setCurrentImage($index)\" ng-class=\"{'active': currentField == $index}\">{{'widget.review.reviewLabel' | translate}} {{($index+1)}}</a></li></ul><div class=\"ms-fields-setup ms-fields-setup_bg\" ng-show=\"fieldsLength(section.background_attributes.images_attributes)\"><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'editor.panel.blockSettings.section.background1' | translate}}</div><div class=\"ms__input-wrapper\" uploader-setting=\"\" ng-if=\"refresh\" uploader-image-id=\"{{section.background_attributes.images_attributes[currentField].id || 'none'}}\" ng-model=\"section.background_attributes.images_attributes[currentField]\" background-id=\"{{section.background_attributes.id}}\" section-id=\"{{section.id}}\"></div></div><div class=\"ms__content ms-text\" photo-library=\"\" ng-model=\"section\" access-key=\"background_attributes.images_attributes.{{currentField}}\" current-key=\"source_url\" remote-key=\"remote_source_url\"></div><div class=\"ms__content\" ng-if=\"section.background_attributes.images_attributes[currentField].source_url\"><div class=\"ms__caption ms__caption_top\">{{'editor.section.previewLabel' | translate}}</div><img class=\"ms__content-image\" ng-src=\"{{section.background_attributes.images_attributes[currentField].source_url}}\"/></div></div>";

/***/ }),
/* 326 */
/***/ (function(module, exports) {

module.exports = "<div class=\"ms__caption\">{{'modulesSettings.borderLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_small\"><select class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\" ng-options=\"type.style as type.title | translate for type in borderStyle\" ng-model=\"border.style\"></select><label class=\"label ms__label\">{{'modulesSettings.borderStyleLabel' | translate}}</label></div><div class=\"ms__input ms__input_range\"><div size-setting=\"\" ng-model=\"border.width\" ng-if=\"border.width !== undefined\"></div><label class=\"label ms__label\">{{'modulesSettings.borderSizeLabel' | translate}}</label></div><div class=\"ms__input ms__input_color\"><div color-setting=\"\" ng-model=\"border.color\" ng-if=\"border.color !== undefined\"></div><label class=\"label ms__label\">{{'modulesSettings.borderColorLabel' | translate}}</label></div></div>";

/***/ }),
/* 327 */
/***/ (function(module, exports) {

module.exports = "<div class=\"ms ms-tab-pane\"><div class=\"ms__section ms__section_active\"><div class=\"ms__content ms-radio\" ng-show=\"Editor.mode !== 'email.page.editor'\"><div class=\"ms__caption ms__caption_top\">{{'widget.button.tab1.title' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__form-radio-1\" type=\"radio\" value=\"open_link\" name=\"ms-target-action_button1{{button_property}}\" ng-model=\"widget[button_property].click_action\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-1\" title=\"{{'widget.button.action1' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.button.action1' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\" ng-show=\"Editor.mode !== 'email.page.editor'\"><input class=\"radio\" id=\"ms__form-radio-2{{button_property}}\" type=\"radio\" value=\"scroll_to_section\" name=\"ms-target-action1_button1\" ng-model=\"widget[button_property].click_action\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-2\" title=\"{{'widget.button.action2' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.button.action2' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\" ng-show=\"Editor.mode !== 'email.page.editor'\"><input class=\"radio\" id=\"ms__form-radio-3{{button_property}}\" type=\"radio\" value=\"as_modal\" name=\"ms-target-action_button1{{button_property}}\" ng-model=\"widget[button_property].click_action\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-3\" title=\"{{'widget.button.action3' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.button.action3' | translate}}</span></label></div></div></div><div class=\"ms__content ms-text\"><div ng-show=\"widget[button_property].click_action == 'open_link'\"><div class=\"ms__caption\">URL</div><div class=\"ms__content\"><div class=\"ms__input-wrapper\"><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__form-radio-url-type-2\" type=\"radio\" value=\"blank\" name=\"ms-target-href-action_button1{{button_property}}\" ng-model=\"widget[button_property].link_href_target\" ng-change=\"$root.validateLink(widget[button_property],'link_href')\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-url-type-2\" title=\"{{'widget.button.action1.url.type2' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.button.action1.url.type2' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\" ng-show=\"Editor.mode !== 'email.page.editor'\"><input class=\"radio\" id=\"ms__form-radio-url-type-1\" type=\"radio\" value=\"none\" name=\"ms-target-href-action_button1{{button_property}}\" ng-model=\"widget[button_property].link_href_target\" ng-change=\"$root.validateLink(widget[button_property],'link_href')\"/><label class=\"radio-label-wrapper label-input\" for=\"ms__form-radio-url-type-1\" title=\"{{'widget.button.action1.url.type2' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.button.action1.url.type1' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\" ng-if=\"$root.enableNextPageOption\"><input class=\"radio\" id=\"ms__form-radio-url-type-3\" type=\"radio\" value=\"next\" name=\"ms-target-href-action_button1{{button_property}}\" ng-model=\"widget[button_property].link_href_target\" ng-change=\"$root.validateLink(widget[button_property], 'link_href')\"/><label class=\"radio-label-wrapper label-input\" for=\"ms__form-radio-url-type-3\" title=\"{{'widget.button.action1.url.nextPage' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.button.action1.url.nextPage' | translate}}</span></label></div></div></div><div class=\"ms__input-wrapper\" ng-show=\"widget[button_property].link_href_target !== 'next'\"><div class=\"ms__input ms__input_large\"><input class=\"input input_extra-small ms-input_border\" id=\"etn__imageWidgetInput\" type=\"text\" placeholder=\"https://\" ng-model=\"widget[button_property].link_href\" ng-blur=\"$root.validateLink(widget[button_property], 'link_href')\"/></div><div class=\"checkbox-wrapper ms-checkbox\" ng-show=\"Editor.mode !== 'email.page.editor'\"><input class=\"checkbox\" id=\"ms__form-checkbox-1\" type=\"checkbox\" ng-model=\"widget[button_property].target_blank\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-1\" title=\"Open in New Window\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.button.action1.blankLabel' | translate}}</span></label></div></div></div><div class=\"ms__content\" ng-show=\"widget[button_property].click_action == 'scroll_to_section'\"><div class=\"ms__caption\">{{'widget.button.action2.sectionLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><select class=\"input input_extra-small ms-input_border select__placeholder select__placeholder_small text-overflow\" ng-options=\"section.id as section.title for section in Editor.getSections()\" ng-model=\"widget[button_property].scroll_section_id\"></select></div></div></div><div class=\"ms__content\" ng-show=\"widget[button_property].click_action == 'as_modal'\"><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><button class=\"button button_green button_middle header-menu__button\" modal-wysiwyg-setting=\"\" ng-model=\"widget[button_property].modal_content\">{{'widget.button.action3.button' | translate}}</button></div></div></div><div class=\"ms__content ms-radio\" ng-if=\"widget.type == 'card'\"><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__full-clickable\" type=\"checkbox\" checked=\"\" ng-model=\"widget.card_full_clickable\"/><label class=\"checkbox-label-wrapper\" for=\"ms__full-clickable\" title=\"Клик по карточке\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.card.tab5' | translate}}</span></label></div></div></div></div></div>";

/***/ }),
/* 328 */
/***/ (function(module, exports) {

module.exports = "<div ng-mousedown=\"checkOpacity()\"><div class=\"input-color-wrapper\"><div class=\"input input_nano input_color ms-input_border\" minicolors=\"{{options}}\" ng-model=\"colorValue\"></div></div></div>";

/***/ }),
/* 329 */
/***/ (function(module, exports) {

module.exports = "<div class=\"colors-wrapper\"><div class=\"color-item\" ng-repeat=\"color in colors\" ng-click=\"setColor(color)\" ng-style=\"{'background-color':color.color}\" ng-class=\"{'color-item_active': color.active}\"></div></div>";

/***/ }),
/* 330 */
/***/ (function(module, exports) {

module.exports = "<span class=\"ms__caption\">{{'widget.form.fieldsLabel' | translate}}</span><div class=\"ms-fields-control\"></div><div ui-tree=\"treeOptions\" data-max-depth=\"1\" data-drag-delay=\"200\"><div id=\"tree-root\"><ol class=\"ms-fields-list\" ui-tree-nodes=\"\" ng-model=\"form.form_fields_attributes\"><li class=\"ms-fields-list__item\" ng-show=\"!fieldsLength(form.form_fields_attributes)\"><a class=\"link ms-fields-list__item-link\" title=\"{{'widget.form.noFieldsLabel' | translate}}\">{{'widget.form.noFieldsLabel' | translate}}</a></li><li class=\"ms-fields-list__item\" ng-repeat=\"field in form.form_fields_attributes\" ng-show=\"!field._destroy\" ui-tree-node=\"\" ng-include=\"'./editor/modules_settings/formfields/tree_renderer.jade'\"></li></ol></div></div><div class=\"ms-fields-setup\" ng-show=\"fieldsLength(form.form_fields_attributes)\"><div class=\"ms__content ms-select\"><div class=\"ms__caption\">{{'widget.form.fieldTypeLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><select class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\" ng-options=\"type.field_type as type.title for type in inputTypes\" ng-change=\"setTitleAsType(form.form_fields_attributes[currentField].field_type)\" ng-model=\"form.form_fields_attributes[currentField].field_type\" disabled=\"\"></select></div></div></div><div class=\"ms__content ms-textarea\" ng-hide=\"form.form_fields_attributes[currentField].field_type == 'select' || form.form_fields_attributes[currentField].field_type == 'radio' || form.form_fields_attributes[currentField].field_type == 'checkbox'\"><div class=\"ms__caption\">Описание</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><textarea class=\"textarea textarea_extra-small ms-input_border\" ng-model=\"form.form_fields_attributes[currentField].placeholder\">Описание</textarea></div></div></div><div class=\"ms__content ms-textarea\"><div class=\"ms__caption\">{{'widget.form.default' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><textarea class=\"textarea textarea_extra-small ms-input_border\" ng-model=\"form.form_fields_attributes[currentField].value\"></textarea></div></div></div><div class=\"ms__content\" ng-if=\"form.form_fields_attributes[currentField].offert\"><div class=\"ms__caption\">{{'widget.form.offertUrl' | translate}}</div><div class=\"ms__content\"><div class=\"ms__input-wrapper\"><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__form-radio-url-type-2\" type=\"radio\" value=\"blank\" name=\"ms-target-href-action_offert\" ng-model=\"form.form_fields_attributes[currentField].link_href_target\" ng-change=\"$root.validateLink(form.form_fields_attributes[currentField], 'offert_url')\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-url-type-2\" title=\"{{'widget.button.action1.url.type2' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.button.action1.url.type2' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__form-radio-url-type-1\" type=\"radio\" value=\"none\" name=\"ms-target-href-action_offert\" ng-model=\"form.form_fields_attributes[currentField].link_href_target\" ng-change=\"$root.validateLink(form.form_fields_attributes[currentField], 'offert_url')\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-url-type-1\" title=\"{{'widget.button.action1.url.type2' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.button.action1.url.type1' | translate}}</span></label></div></div></div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_extra-small ms-input_border\" id=\"etn__imageWidgetInput\" type=\"text\" placeholder=\"http://\" ng-model=\"form.form_fields_attributes[currentField].offert_url\" ng-blur=\"$root.validateLink(form.form_fields_attributes[currentField], 'offert_url')\"/></div><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__form-checkbox-1\" type=\"checkbox\" ng-model=\"form.form_fields_attributes[currentField].offert_target_blank\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-1\" title=\"Open in New Window\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.button.action1.blankLabel' | translate}}</span></label></div></div></div><div class=\"ms__content ms-textarea\" ng-if=\"form.form_fields_attributes[currentField].field_type == 'select' || form.form_fields_attributes[currentField].field_type == 'radio'\"><div class=\"ms__caption\">Options</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><textarea class=\"textarea textarea_extra-small ms-input_border\" placeholder=\"\" ng-model=\"form.form_fields_attributes[currentField].options_raw\" ng-disabled=\"form.form_fields_attributes[currentField].field_type == 'select' || form.form_fields_attributes[currentField].field_type == 'radio'\">Опции выбора</textarea></div></div></div><div class=\"ms__content ms-textarea\"><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__form-checkbox-1\" type=\"checkbox\" checked=\"\" ng-disabled=\"form.form_fields_attributes[currentField].offert\" ng-model=\"form.form_fields_attributes[currentField].required\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-1\" title=\"Mark a message\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.form.fieldRequiredLabel' | translate}}</span></label></div><div class=\"checkbox-wrapper ms-checkbox\" ng-hide=\"form.form_fields_attributes[currentField].offert\"><input class=\"checkbox\" id=\"ms__form-checkbox-1-hidden\" type=\"checkbox\" checked=\"\" ng-model=\"form.form_fields_attributes[currentField].hidden\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-1-hidden\" title=\"Mark a message\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.form.fieldHiddenLabel' | translate}}</span></label></div></div></div>";

/***/ }),
/* 331 */
/***/ (function(module, exports) {

module.exports = "<div class=\"tree-node\" ui-tree-handle=\"\"><div class=\"tree__icon-move tree__icon-move_fields\"><svg class=\"svg-block\" width=\"12\" height=\"12\" viewbox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"icon-block__fill\"><rect width=\"4.8\" height=\"4.8\" rx=\"1\"></rect><rect y=\"7.2\" width=\"4.8\" height=\"4.8\" rx=\"1\"></rect><rect x=\"7.2\" width=\"4.8\" height=\"4.8\" rx=\"1\"></rect><rect x=\"7.2\" y=\"7.2\" width=\"4.8\" height=\"4.8\" rx=\"1\"></rect></g></svg></div><a class=\"link ms-fields-list__item-link\" title=\"{{field.title}}\" ng-click=\"setCurrentField($index)\" ng-class=\"{'active': $parent.$parent.$parent.currentField == $index}\">{{field.title || \"No name\"}}</a><label class=\"switch\" for=\"exist_{{field.id}}\"><input class=\"switch-input\" type=\"checkbox\" id=\"exist_{{field.id}}\" ng-model=\"field.exist\"/><span class=\"switch-label\" data-on=\"\" data-off=\"\"></span><span class=\"switch-handle\"></span></label></div>";

/***/ }),
/* 332 */
/***/ (function(module, exports) {

module.exports = "<span class=\"ms__caption\">{{'widget.gallery.imagesLabel' | translate}}</span><div class=\"ms-fields-control\"><a class=\"link group-title fields-control fields-control_add fl\" title=\"Добавить картинку\" ng-click=\"add()\"><svg class=\"icon__fields-control\" viewBox=\"0 0 17 17\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"icon__fill\"><rect x=\"0\" y=\"8\" width=\"17\" height=\"1\"></rect><rect x=\"8\" y=\"0\" width=\"1\" height=\"17\"></rect></g></svg></a><a class=\"link group-title fields-control fields-control_remove fl\" title=\"Удалить картинку\" ng-click=\"remove()\"><svg class=\"icon__fields-control\" viewBox=\"0 0 17 17\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"icon__fill\"><rect x=\"0\" y=\"8\" width=\"17\" height=\"1\"></rect></g></svg></a></div><ul class=\"ms-fields-list\"><li class=\"ms-fields-list__item\" ng-show=\"!fieldsLength(gallery.photos_attributes)\"><a class=\"link ms-fields-list__item-link\" title=\"Нет слайдов\">{{'editor.panel.blockSettings.section.background1.emptyLabel' | translate}}</a></li><li class=\"ms-fields-list__item\" ng-repeat=\"field in gallery.photos_attributes\" ng-show=\"!field._destroy\"><a class=\"link ms-fields-list__item-link\" title=\"{{field.caption}}\" ng-click=\"setCurrentImage($index)\" ng-class=\"{'active': currentField == $index}\">{{field.caption || 'widget.review.reviewLabel' | translate}}</a></li></ul><div class=\"ms-fields-setup\" ng-show=\"fieldsLength(gallery.photos_attributes)\"><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.gallery.imageLabel' | translate}}</div><div class=\"ms__input-wrapper\" uploader-setting=\"\" uploader-photo-id=\"{{gallery.photos_attributes[currentField].id}}\" ng-model=\"gallery.photos_attributes[currentField].file_url\" widget-id=\"{{gallery.id}}\"></div></div><div class=\"ms__content ms-text\" photo-library=\"\" ng-model=\"gallery\" access-key=\"photos_attributes.{{currentField}}\" current-key=\"file_url\" remote-key=\"remote_file_url\"></div><div class=\"ms__content ms-textarea\"><div class=\"ms__caption\">{{'widget.gallery.descriptionLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><textarea class=\"textarea textarea_extra-small ms-input_border\" ng-model=\"gallery.photos_attributes[currentField].caption\">{{'widget.gallery.descriptionLabel' | translate}}</textarea></div></div></div><div class=\"ms__content\"><div class=\"ms__caption ms__caption_top\">{{'widget.gallery.previewLabel' | translate}}</div><img class=\"ms__content-image\" ng-src=\"{{gallery.photos_attributes[currentField].file_url}}\"/></div></div>";

/***/ }),
/* 333 */
/***/ (function(module, exports) {

module.exports = "<div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__form-checkbox-gradient-bg\" type=\"checkbox\" ng-model=\"isGradient\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-gradient-bg\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'editor.panel.blockSettings.section.gradientLabel' | translate}}</span></label></div><div class=\"ms__content ms-color\" ng-show=\"isGradient\"><div class=\"ms__caption\">{{'modulesSettings.button.gradientType' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__form-gadient-{{timestamp}}-1\" type=\"radio\" value=\"horizontal\" name=\"ms-target-action_button1-{{timestamp}}\" ng-model=\"position\"/><label class=\"radio-label-wrapper\" for=\"ms__form-gadient-{{timestamp}}-1\" title=\"\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'modulesSettings.button.gradientType1' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__form-gadient-{{timestamp}}-2\" type=\"radio\" value=\"vertical\" name=\"ms-target-action1_button1-{{timestamp}}\" ng-model=\"position\"/><label class=\"radio-label-wrapper\" for=\"ms__form-gadient-{{timestamp}}-2\" title=\"\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'modulesSettings.button.gradientType2' | translate}}</span></label></div></div></div><div class=\"ms__content ms-color\" ng-show=\"isGradient\"><div class=\"ms__caption\">{{'editor.panel.blockSettings.section.gradientStart' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"gsettings.colorStart\" ng-if=\"gsettings.colorStart\"></div></div></div><div class=\"ms__content ms-color\" ng-show=\"isGradient\"><div class=\"ms__caption\">{{'editor.panel.blockSettings.section.gradientEnd' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"gsettings.colorStop\" ng-if=\"gsettings.colorStop\"></div></div></div>";

/***/ }),
/* 334 */
/***/ (function(module, exports) {

module.exports = "<div class=\"ms__input ms__input_slider-range\"><div class=\"ms__range-slider\" range-slider=\"\" on-handle-up=\"afterChange()\" min=\"options.min\" max=\"options.max\" model-max=\"heightValue\" pin-handle=\"min\"></div></div><div class=\"ms__input ms__input_range\"><input class=\"input input_nano ms-input_border\" type=\"number\" min=\"0\" ng-model=\"heightValue\"/></div>";

/***/ }),
/* 335 */
/***/ (function(module, exports) {

module.exports = "<div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}</div><div class=\"ms__input-wrapper\" ng-if=\"data.type == 'button'\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"data.button_attributes.hover_style_attributes.backgroundColor\"></div></div><div class=\"ms__input-wrapper\" ng-if=\"data.type == 'product'\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"data.hover_style_attributes.backgroundColor\"></div></div><div class=\"ms__input-wrapper\" ng-if=\"data.type == 'card'\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"data.button_attributes.hover_style_attributes.backgroundColor\"></div></div><div class=\"ms__input-wrapper\" ng-if=\"data.type == 'form' || data.type == 'subscribe_form'\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"data.parent_button.hover_style.backgroundColor\" ng-if=\"buttonType == 'parent_button'\"></div><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"data.button.hover_style.backgroundColor\" ng-if=\"!buttonType\"></div></div></div>";

/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports = "<div class=\"icon-selector\"><input class=\"icon-selector__input input input_extra-small ms-input_border\" type=\"text\" placeholder=\"\" ng-model=\"data\"/><div class=\"icon-selector__panel\"><input class=\"icon-selector__search input input_extra-small ms-input_border\" type=\"text\" placeholder=\"Search\" ng-model=\"search\"/><div class=\"icon-selector__icons\"><div class=\"icon-selector__icons__item\" ng-repeat=\"icon in icons\" ng-if=\"filterIcon(icon.title)\" ng-class=\"{'active': icon.cssClass === data}\" ng-click=\"setCurrentIcon($index)\" title=\"{{icon.title}}\"><i ng-class=\"icon.cssClass\"></i></div></div></div></div>";

/***/ }),
/* 337 */
/***/ (function(module, exports) {

module.exports = "";

/***/ }),
/* 338 */
/***/ (function(module, exports) {

module.exports = "<span class=\"ms__caption\">{{'widget.list.rowsLabel' | translate}}</span><div class=\"ms-fields-control\"><a class=\"link group-title fields-control fields-control_add fl\" title=\"Добавить строку\" ng-click=\"add()\"><svg class=\"icon__fields-control\" viewBox=\"0 0 17 17\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"icon__fill\"><rect x=\"0\" y=\"8\" width=\"17\" height=\"1\"></rect><rect x=\"8\" y=\"0\" width=\"1\" height=\"17\"></rect></g></svg></a><a class=\"link group-title fields-control fields-control_remove fl\" title=\"Удалить строку\" ng-click=\"remove()\"><svg class=\"icon__fields-control\" viewBox=\"0 0 17 17\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"icon__fill\"><rect x=\"0\" y=\"8\" width=\"17\" height=\"1\"></rect></g></svg></a></div><ul class=\"ms-fields-list\"><li class=\"ms-fields-list__item\" ng-show=\"!fieldsLength(list.rows_attributes)\"><a class=\"link ms-fields-list__item-link\" title=\"\">{{'widget.list.emptyLabel' | translate}}</a></li><li class=\"ms-fields-list__item\" ng-repeat=\"field in list.rows_attributes\" ng-show=\"!field._destroy\"><a class=\"link ms-fields-list__item-link\" title=\"{{field.caption}}\" ng-click=\"setCurrentImage($index)\" ng-class=\"{'active': currentField == $index}\">{{field.caption || 'widget.list.rowLabel' | translate}}</a></li></ul>";

/***/ }),
/* 339 */
/***/ (function(module, exports) {

module.exports = "<span class=\"ms__title ms__title_active\" ng-click=\"editorAccordion($event)\">{{'widget.map.tab1' | translate}}</span><div class=\"ms__section ms__section_active\"><div class=\"ms__content ms-radio\"><div class=\"ms__caption ms__caption_top\">{{'widget.map.serviceLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__provider-radio-1\" type=\"radio\" value=\"google\" name=\"ms-target-action\" ng-model=\"data.provider\" checked=\"checked\"/><label class=\"radio-label-wrapper\" for=\"ms__provider-radio-1\" title=\"\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.map.service1' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__provider-radio-2\" type=\"radio\" value=\"yandex\" name=\"ms-target-action\" ng-model=\"data.provider\"/><label class=\"radio-label-wrapper\" for=\"ms__provider-radio-2\" title=\"\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.map.service2' | translate}}</span></label></div></div></div><div class=\"ms__content ms-radio\"><div class=\"ms__caption ms__caption_top\">{{'widget.map.placeLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input_size-width\"><form novalidate=\"\" ng-submit=\"searchGeo()\"><input class=\"input input_nano ms-input_border\" type=\"text\" name=\"searchField\" value=\"{{'widget.map.placeInput' | translate}}\" ng-model=\"data.address\" ng-blur=\"searchGeo()\"/></form></div></div></div><div class=\"ms__content ms-radio\"><div class=\"ms__caption ms__caption_top\">{{'widget.map.pinTextLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input_size-width\"><input class=\"input input_nano ms-input_border\" type=\"text\" value=\"Адрес или место\" ng-model=\"data.pin_text\"/></div></div></div></div>";

/***/ }),
/* 340 */
/***/ (function(module, exports) {

module.exports = "<div class=\"input_padding ms-input_border\"><div class=\"ms-padding__panel\"></div><div class=\"ms-padding__top\"><svg class=\"icon-padding-h\" width=\"9px\" height=\"24px\" viewBox=\"0 0 9 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"icon__fill\"><rect x=\"4\" y=\"0\" width=\"1\" height=\"24\"></rect><rect x=\"0\" y=\"0\" width=\"9\" height=\"1\"></rect><rect x=\"0\" y=\"23\" width=\"9\" height=\"1\"></rect></g></svg><input class=\"input_padding-input\" type=\"number\" min=\"0\" ng-model=\"margin.top\" ng-blur=\"afterChange()\" placeholder=\"auto\"/></div><div class=\"ms-padding__right\"><svg class=\"icon-padding-v\" width=\"63px\" height=\"9px\" viewBox=\"0 0 63 9\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"icon__fill\"><rect x=\"1\" y=\"4\" width=\"61\" height=\"1\"></rect><rect x=\"0\" y=\"0\" width=\"1\" height=\"9\"></rect><rect x=\"62\" y=\"0\" width=\"1\" height=\"9\"></rect></g></svg><input class=\"input_padding-input\" type=\"number\" min=\"0\" ng-model=\"margin.right\" ng-blur=\"afterChange()\" placeholder=\"auto\"/></div><div class=\"ms-padding__bottom\"><svg class=\"icon-padding-h\" width=\"9px\" height=\"24px\" viewBox=\"0 0 9 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"icon__fill\"><rect x=\"4\" y=\"0\" width=\"1\" height=\"24\"></rect><rect x=\"0\" y=\"0\" width=\"9\" height=\"1\"></rect><rect x=\"0\" y=\"23\" width=\"9\" height=\"1\"></rect></g></svg><input class=\"input_padding-input\" type=\"number\" min=\"0\" ng-model=\"margin.bottom\" ng-blur=\"afterChange()\" placeholder=\"auto\"/></div><div class=\"ms-padding__left\"><svg class=\"icon-padding-v\" width=\"63px\" height=\"9px\" viewBox=\"0 0 63 9\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"icon__fill\"><rect x=\"1\" y=\"4\" width=\"61\" height=\"1\"></rect><rect x=\"0\" y=\"0\" width=\"1\" height=\"9\"></rect><rect x=\"62\" y=\"0\" width=\"1\" height=\"9\"></rect></g></svg><input class=\"input_padding-input\" type=\"number\" min=\"0\" ng-model=\"margin.left\" ng-blur=\"afterChange()\" placeholder=\"auto\"/></div></div>";

/***/ }),
/* 341 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"><div class=\"middle-title ta-center\">{{'widget.navigation.createLink.title' | translate}}</div></div><form class=\"modal-body\" name=\"newLink\" novalidate=\"\" ng-submit=\"create(newlink, newLink)\"><div class=\"input-wrapper\"><label class=\"label-title\">{{'widget.navigation.createLink.nameLabel' | translate}}</label><input class=\"input input_extra-small button_border\" ng-model=\"newlink.name\" str-auto-focus=\"\" placeholder=\"{{'widget.navigation.createLink.nameLabel' | translate}}\" required=\"\" name=\"name\" type=\"text\" ng-class=\"{'error': newLink.$submitted &amp;&amp; newLink.name.$invalid}\"/><div class=\"error-message error-message_formsetting\"><svg class=\"icon-danger\" version=\"1.1\" viewbox=\"0 0 28.937 28.937\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-danger__path\" d=\"M28.859,26.124L14.957,2.245c-0.101-0.173-0.287-0.279-0.489-0.279c-0.198,0-0.383,0.106-0.481,0.279L0.079,26.124 c-0.102,0.175-0.106,0.389-0.006,0.565c0.103,0.174,0.287,0.282,0.488,0.282h27.814c0.201,0,0.389-0.108,0.488-0.282 c0.047-0.088,0.074-0.186,0.074-0.281C28.938,26.309,28.911,26.211,28.859,26.124z M16.369,10.441l-0.462,9.493h-2.389 l-0.461-9.493H16.369z M14.711,24.794h-0.042c-1.089,0-1.843-0.817-1.843-1.907c0-1.131,0.774-1.907,1.885-1.907 s1.846,0.775,1.867,1.907C16.579,23.977,15.844,24.794,14.711,24.794z\"></path></svg></div></div><div><div class=\"ms__section ms__section_navigation-settings ms__section_active ms__section_page-settings\"><div class=\"ms__content ms-radio\"><div class=\"ms__caption ms__caption_top\">{{'widget.navigation.createLink.actionLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__form-radio-1\" type=\"radio\" value=\"open_link\" name=\"ms-target-action\" ng-model=\"newlink.click_action\" checked=\"checked\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-1\" title=\"\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.navigation.createLink.action1' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__form-radio-2\" type=\"radio\" value=\"scroll_to_section\" name=\"ms-target-action\" ng-model=\"newlink.click_action\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-2\" title=\"\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.navigation.createLink.action2' | translate}}</span></label></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__content\" ng-show=\"newlink.click_action == 'open_link'\"><div class=\"ms__caption\">URL</div><div class=\"ms__content\"><div class=\"ms__input-wrapper\"><div class=\"radio-wrapper ms-radio\" ng-show=\"Editor.mode !== 'editor.email'\"><input class=\"radio\" id=\"ms__form-radio-url-type-2\" type=\"radio\" value=\"blank\" name=\"ms-target-action1_button1\" ng-model=\"newlink.link_href_target\" ng-change=\"validateLink(newlink,'url')\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-url-type-2\" title=\"{{'widget.button.action1.url.type2' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.button.action1.url.type2' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__form-radio-url-type-1\" type=\"radio\" value=\"none\" name=\"ms-target-action_button1\" ng-model=\"newlink.link_href_target\" ng-change=\"validateLink(newlink,'url')\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-url-type-1\" title=\"{{'widget.button.action1.url.type2' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.button.action1.url.type1' | translate}}</span></label></div></div></div><div class=\"ms__input-wrapper\"><div><input class=\"input__url button_border input-navigation_url\" ng-model=\"newlink.url\" placeholder=\"{{'widget.button.action1.urlLabel' | translate}}\" name=\"url\" type=\"text\" ng-class=\"{'error': newLink.$submitted &amp;&amp; newLink.url.$invalid}\" ng-blur=\"validateLink(newlink,'url')\"/><div class=\"error-message error-message_formsetting\"><svg class=\"icon-danger\" version=\"1.1\" viewbox=\"0 0 28.937 28.937\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-danger__path\" d=\"M28.859,26.124L14.957,2.245c-0.101-0.173-0.287-0.279-0.489-0.279c-0.198,0-0.383,0.106-0.481,0.279L0.079,26.124 c-0.102,0.175-0.106,0.389-0.006,0.565c0.103,0.174,0.287,0.282,0.488,0.282h27.814c0.201,0,0.389-0.108,0.488-0.282 c0.047-0.088,0.074-0.186,0.074-0.281C28.938,26.309,28.911,26.211,28.859,26.124z M16.369,10.441l-0.462,9.493h-2.389 l-0.461-9.493H16.369z M14.711,24.794h-0.042c-1.089,0-1.843-0.817-1.843-1.907c0-1.131,0.774-1.907,1.885-1.907 s1.846,0.775,1.867,1.907C16.579,23.977,15.844,24.794,14.711,24.794z\"></path></svg></div></div><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__form-checkbox-1\" type=\"checkbox\" ng-model=\"newlink.target_blank\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-1\" title=\"Open in New Window\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.navigation.createLink.targetBlank' | translate}}</span></label></div></div></div><div class=\"ms__content\" ng-show=\"newlink.click_action == 'scroll_to_section'\"><div class=\"ms__caption\">{{'widget.navigation.createLink.sectionLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><select class=\"input input_extra-small ms-input_border select__placeholder select__placeholder_small text-overflow\" ng-options=\"section.id as section.title for section in Editor.getSections()\" ng-model=\"newlink.scroll_section_id\"></select></div></div></div></div></div></div><div class=\"modal-footer ta-center\"><button class=\"button button_margin button_green button_extra-small button_modal\" ng-disabled=\"creating\" type=\"submit\">{{'widget.navigation.createButton' | translate}}</button><button class=\"button button_margin button_grayish-blue button_extra-small button_modal\" ng-click=\"close($event)\" type=\"button\">{{'widget.navigation.cancelButton' | translate}}</button></div></form>";

/***/ }),
/* 342 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"><div class=\"middle-title ta-center\">{{'widget.navigation.updateLink.title' | translate}}</div></div><form class=\"modal-body\" name=\"linkForm\" novalidate=\"\" ng-submit=\"save(editlink, linkForm)\"><div class=\"input-wrapper\"><label class=\"label-title\">{{'widget.navigation.createLink.nameLabel' | translate}}</label><input class=\"input input_extra-small button_border\" ng-model=\"editlink.name\" str-auto-focus=\"\" placeholder=\"{{'widget.navigation.createLink.nameLabel' | translate}}\" required=\"\" name=\"name\" type=\"text\" ng-class=\"{'error': linkForm.$submitted &amp;&amp; linkForm.name.$invalid}\"/><div class=\"error-message error-message_formsetting\"><svg class=\"icon-danger\" version=\"1.1\" viewbox=\"0 0 28.937 28.937\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-danger__path\" d=\"M28.859,26.124L14.957,2.245c-0.101-0.173-0.287-0.279-0.489-0.279c-0.198,0-0.383,0.106-0.481,0.279L0.079,26.124 c-0.102,0.175-0.106,0.389-0.006,0.565c0.103,0.174,0.287,0.282,0.488,0.282h27.814c0.201,0,0.389-0.108,0.488-0.282 c0.047-0.088,0.074-0.186,0.074-0.281C28.938,26.309,28.911,26.211,28.859,26.124z M16.369,10.441l-0.462,9.493h-2.389 l-0.461-9.493H16.369z M14.711,24.794h-0.042c-1.089,0-1.843-0.817-1.843-1.907c0-1.131,0.774-1.907,1.885-1.907 s1.846,0.775,1.867,1.907C16.579,23.977,15.844,24.794,14.711,24.794z\"></path></svg></div></div><div><div class=\"ms__section ms__section_navigation-settings ms__section_active ms__section_page-settings\"><div class=\"ms__content ms-radio\"><div class=\"ms__caption ms__caption_top\">{{'widget.navigation.createLink.actionLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__form-radio-1\" type=\"radio\" value=\"open_link\" name=\"ms-target-action\" ng-model=\"editlink.click_action\" checked=\"checked\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-1\" title=\"Открытие ссылки\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.navigation.createLink.action1' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__form-radio-2\" type=\"radio\" value=\"scroll_to_section\" name=\"ms-target-action\" ng-model=\"editlink.click_action\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-2\" title=\"Перемещение к секции\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.navigation.createLink.action2' | translate}}</span></label></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__content\" ng-if=\"editlink.click_action == 'open_link'\"><div class=\"ms__caption\">URL</div><div class=\"ms__content\"><div class=\"ms__input-wrapper\"><div class=\"radio-wrapper ms-radio\" ng-show=\"Editor.mode !== 'editor.email'\"><input class=\"radio\" id=\"ms__form-radio-url-type-2\" type=\"radio\" value=\"blank\" name=\"ms-target-action1_button1\" ng-model=\"editlink.link_href_target\" ng-change=\"validateLink(editlink,'url')\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-url-type-2\" title=\"{{'widget.button.action1.url.type2' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.button.action1.url.type2' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__form-radio-url-type-1\" type=\"radio\" value=\"none\" name=\"ms-target-action_button1\" ng-model=\"editlink.link_href_target\" ng-change=\"validateLink(editlink,'url')\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-url-type-1\" title=\"{{'widget.button.action1.url.type2' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.button.action1.url.type1' | translate}}</span></label></div></div></div><div class=\"ms__input-wrapper\"><div><input class=\"input__url button_border input-navigation_url\" ng-model=\"editlink.url\" placeholder=\"{{'widget.button.action1.urlLabel' | translate}}\" name=\"url\" type=\"text\" ng-class=\"{'error': linkForm.$submitted &amp;&amp; linkForm.url.$invalid}\" ng-blur=\"validateLink(editlink,'url')\"/><div class=\"error-message error-message_formsetting\"><svg class=\"icon-danger\" version=\"1.1\" viewbox=\"0 0 28.937 28.937\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-danger__path\" d=\"M28.859,26.124L14.957,2.245c-0.101-0.173-0.287-0.279-0.489-0.279c-0.198,0-0.383,0.106-0.481,0.279L0.079,26.124 c-0.102,0.175-0.106,0.389-0.006,0.565c0.103,0.174,0.287,0.282,0.488,0.282h27.814c0.201,0,0.389-0.108,0.488-0.282 c0.047-0.088,0.074-0.186,0.074-0.281C28.938,26.309,28.911,26.211,28.859,26.124z M16.369,10.441l-0.462,9.493h-2.389 l-0.461-9.493H16.369z M14.711,24.794h-0.042c-1.089,0-1.843-0.817-1.843-1.907c0-1.131,0.774-1.907,1.885-1.907 s1.846,0.775,1.867,1.907C16.579,23.977,15.844,24.794,14.711,24.794z\"></path></svg></div></div><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__form-checkbox-1\" type=\"checkbox\" ng-model=\"editlink.target_blank\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-1\" title=\"Open in New Window\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.navigation.createLink.targetBlank' | translate}}</span></label></div></div></div><div class=\"ms__content\" ng-show=\"editlink.click_action == 'scroll_to_section'\"><div class=\"ms__caption\">{{'widget.navigation.createLink.sectionLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><select class=\"input input_extra-small ms-input_border select__placeholder select__placeholder_small text-overflow\" ng-options=\"section.id as section.title for section in Editor.getSections() \" ng-model=\"editlink.scroll_section_id\"></select></div></div></div></div></div></div><div class=\"modal-footer ta-center\"><button class=\"button button_margin button_green button_extra-small button_modal\" ng-disabled=\"saving\" type=\"submit\">{{'widget.navigation.saveButton' | translate}}</button><button class=\"button button_margin button_red button_extra-small button_modal\" ng-disabled=\"deleting\" ng-if=\"linksLength() &gt; 1\" ng-click=\"deleteLink()\" type=\"button\">{{'widget.navigation.deleteButton' | translate}}</button><button class=\"button button_margin button_grayish-blue button_extra-small button_modal\" ng-click=\"close($event)\" type=\"button\">{{'widget.navigation.cancelButton' | translate}}</button></div></form>";

/***/ }),
/* 343 */
/***/ (function(module, exports) {

module.exports = "<span class=\"ms__title ms__title_active\" ng-click=\"editorAccordion($event)\">{{'widget.navigation.linkSettings' | translate}}</span><div class=\"ms__section ms__section_navigation ms__section_active\"><div class=\"ta-left pages__settings\"><div class=\"etn__site-settings-desc\"><div class=\"etn__title\">{{'widget.navigation.linksLabel' | translate}}<button class=\"add-page__button\" ng-click=\"createLink(false, data)\"><img class=\"add-page__button-icon\" src=\"/constructor/editor/assets/images/add.svg\"/></button></div></div><div class=\"etn__pages-tree\" id=\"tree-root\" ui-tree=\"treeOptions\" data-max-depth=\"2\"><ol ui-tree-nodes=\"\" ng-model=\"data.links_attributes\"><li class=\"etn__pages-tree__item\" ng-repeat=\"link in data.links_attributes\" ng-if=\"!link._destroy\" ui-tree-node=\"\" ng-include=\"'./editor/modules_settings/navigationfields/tree_renderer.jade'\"></li></ol></div></div></div>";

/***/ }),
/* 344 */
/***/ (function(module, exports) {

module.exports = "<div class=\"tree-node tree-node-content\" ui-tree-handle=\"\"><div class=\"tree__icon-move\"><svg class=\"svg-block\" width=\"12\" height=\"12\" viewbox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"icon-block__fill\"><rect width=\"4.8\" height=\"4.8\" rx=\"1\"></rect><rect y=\"7.2\" width=\"4.8\" height=\"4.8\" rx=\"1\"></rect><rect x=\"7.2\" width=\"4.8\" height=\"4.8\" rx=\"1\"></rect><rect x=\"7.2\" y=\"7.2\" width=\"4.8\" height=\"4.8\" rx=\"1\"></rect></g></svg></div><img class=\"tree__icon-file\" src=\"/constructor/editor/assets/images/editor/icon-link-only.svg\" ng-show=\"!link.links_attributes || link.links_attributes.length == 0\"/><img class=\"tree__icon-file\" src=\"/constructor/editor/assets/images/icon-folder.svg\" ng-show=\"link.links_attributes.length &gt; 0\"/><a class=\"link tree__link\" data-nodrag=\"\">{{link.name}}</a><div class=\"tree__collapse-icon fr\" ng-if=\"link.links_attributes.length\" ng-click=\"toggle()\" data-nodrag=\"\" ng-class=\"{'tree__collapse-icon__collapsed': collapsed}\"></div><div class=\"ms__button-remove fr\" data-nodrag=\"\"><a class=\"etn__image-remove icon-page__settings inline-wrapper\" ng-click=\"editLink(link, data)\"></a></div><button class=\"fr add-page__button_small\" ng-if=\"!link.parent_id\" data-nodrag=\"\"><img class=\"add-page__button-icon\" src=\"/constructor/editor/assets/images/add.svg\" ng-click=\"createLink(link.id, data)\"/></button><a class=\"tree__icon-remove etn__image-remove icon-trash icon-trash_black inline-wrapper\" ng-click=\"deleteLink(link)\" ng-if=\"linksLength(data) &gt; 1\" data-nodrag=\"\"></a></div><ol ui-tree-nodes=\"\" ng-model=\"link.links_attributes\" ng-show=\"!collapsed\"><li class=\"etn__pages-tree__item tree__child\" ng-repeat=\"link in link.links_attributes\" ng-if=\"!link._destroy\" ui-tree-node=\"\" ng-include=\"'./editor/modules_settings/navigationfields/tree_renderer.jade'\"></li></ol>";

/***/ }),
/* 345 */
/***/ (function(module, exports) {

module.exports = "<div class=\"input_padding ms-input_border\"><div class=\"ms-padding__panel\"></div><div class=\"ms-padding__top\"><svg class=\"icon-padding-h\" width=\"9px\" height=\"24px\" viewBox=\"0 0 9 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"icon__fill\"><rect x=\"4\" y=\"0\" width=\"1\" height=\"24\"></rect><rect x=\"0\" y=\"0\" width=\"9\" height=\"1\"></rect><rect x=\"0\" y=\"23\" width=\"9\" height=\"1\"></rect></g></svg><input class=\"input_padding-input\" type=\"number\" min=\"0\" ng-model=\"padding.top\" ng-blur=\"afterChange()\"/></div><div class=\"ms-padding__right\"><svg class=\"icon-padding-v\" width=\"63px\" height=\"9px\" viewBox=\"0 0 63 9\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"icon__fill\"><rect x=\"1\" y=\"4\" width=\"61\" height=\"1\"></rect><rect x=\"0\" y=\"0\" width=\"1\" height=\"9\"></rect><rect x=\"62\" y=\"0\" width=\"1\" height=\"9\"></rect></g></svg><input class=\"input_padding-input\" type=\"number\" min=\"0\" ng-model=\"padding.right\" ng-blur=\"afterChange()\"/></div><div class=\"ms-padding__bottom\"><svg class=\"icon-padding-h\" width=\"9px\" height=\"24px\" viewBox=\"0 0 9 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"icon__fill\"><rect x=\"4\" y=\"0\" width=\"1\" height=\"24\"></rect><rect x=\"0\" y=\"0\" width=\"9\" height=\"1\"></rect><rect x=\"0\" y=\"23\" width=\"9\" height=\"1\"></rect></g></svg><input class=\"input_padding-input\" type=\"number\" min=\"0\" ng-model=\"padding.bottom\" ng-blur=\"afterChange()\"/></div><div class=\"ms-padding__left\"><svg class=\"icon-padding-v\" width=\"63px\" height=\"9px\" viewBox=\"0 0 63 9\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"icon__fill\"><rect x=\"1\" y=\"4\" width=\"61\" height=\"1\"></rect><rect x=\"0\" y=\"0\" width=\"1\" height=\"9\"></rect><rect x=\"62\" y=\"0\" width=\"1\" height=\"9\"></rect></g></svg><input class=\"input_padding-input\" type=\"number\" min=\"0\" ng-model=\"padding.left\" ng-blur=\"afterChange()\"/></div></div>";

/***/ }),
/* 346 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"><div class=\"middle-title ta-center\">{{'modulesSettings.libraryTitle' | translate}}</div></div><nav class=\"header-menu__nav header-menu__nav_page-settings\"><a class=\"link header-menu__link header-menu__link_page-settings group-title\" ng-class=\"{'link_active': photolibrary.currentSettings == 'forsite'}\" ng-click=\"photolibrary.currentSettings = 'forsite'; getImagesByTag(widget.tag)\" ng-if=\"widget.tag\">{{'modulesSettings.libraryTab1' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title\" ng-class=\"{'link_active': photolibrary.currentSettings == 'categories'}\" ng-click=\"photolibrary.currentSettings = 'categories'; getImagesByTag(selectedCategory)\" ng-hide=\"getWidgetTagName(widget) == ('widget.tags.bullets'|translate)\">{{'modulesSettings.libraryTab2' | translate}}</a></nav><div class=\"modal-body\"><div class=\"site__settings-view\"><div class=\"input-wrapper ta-left\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.selectedCategory\" select-editor=\"true\" ng-show=\"photolibrary.currentSettings == 'categories'\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{selectedCategory || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{category}}\" ng-repeat=\"category in tags\" ng-click=\"optionCheck($event, category); getImagesByTag(category);\" ng-hide=\"category == ('widget.tags.bullets'|translate)\">{{category}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"library-images ta-center\"><img width=\"20\" src=\"/constructor/editor/assets/images/loader.gif\" ng-show=\"imagesLoading\"/><span class=\"ng-hide\" ng-show=\"!imagesData.images.length &amp;&amp; !imagesLoading\">{{'modulesSettings.libraryNotFound' | translate}}</span><perfect-scrollbar class=\"library-images__wrapper scroller\" refresh-on-change=\"imagesData.images\" scroll-disabled=\"{{scrollDisabled}}\" scroll-load-distance=\"200\" wheel-propagation=\"true\" when-scroll-down=\"getNextImages()\" ng-show=\"!imagesLoading\"><a class=\"library-images__item\" style=\"background-image:url({{image.image_attributes.source_url}});\" ng-repeat=\"image in imagesData.images\" ng-click=\"chooseImage(image)\"></a></perfect-scrollbar></div></div></div>";

/***/ }),
/* 347 */
/***/ (function(module, exports) {

module.exports = "<button class=\"button button_small button_green\" ng-click=\"photoLibraryModal()\" type=\"button\">{{'modulesSettings.chooseFromLibrary' | translate}}</button>";

/***/ }),
/* 348 */
/***/ (function(module, exports) {

module.exports = "<div class=\"ms ms-tab-pane\" ng-show=\"$parent.editCurrentTab == 'blockDesign'\"><div class=\"ms__section ms__section_active ms__section_visible\"><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"data.wrapper_style.backgroundColor\"></div></div></div><div class=\"ms__content\"><div ui-tree=\"treeOptions\" data-max-depth=\"1\" data-drag-delay=\"200\"><div id=\"tree-root\"><span class=\"ms__caption\">{{'widget.product.elementsLabel' | translate}}</span><div class=\"ms-fields-control ms-fields-control_product\"><a class=\"link group-title fields-control fields-control_add fl\" ng-show=\"addingField\"><img width=\"20\" src=\"/assets/images/loader.gif\"/></a><a class=\"link group-title fields-control fields-control_add fl\" title=\"Добавить поле\" ng-click=\"add()\" ng-hide=\"addingField\"><svg class=\"icon__fields-control\" viewBox=\"0 0 17 17\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"icon__fill\"><rect x=\"0\" y=\"8\" width=\"17\" height=\"1\"></rect><rect x=\"8\" y=\"0\" width=\"1\" height=\"17\"></rect></g></svg></a><a class=\"link group-title fields-control fields-control_remove fl\" title=\"Удалить поле\" ng-click=\"remove()\"><svg class=\"icon__fields-control\" viewBox=\"0 0 17 17\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"icon__fill\"><rect x=\"0\" y=\"8\" width=\"17\" height=\"1\"></rect></g></svg></a></div><ol class=\"ms-fields-list\" ui-tree-nodes=\"\" ng-model=\"product.product_items_attributes\"><li class=\"ms-fields-list__item\" ng-if=\"!fieldsLength(product.product_items_attributes)\"><a class=\"link ms-fields-list__item-link\" title=\"Нет полей\">{{'widget.product.emptyElementsLabel' | translate}}</a></li><li class=\"ms-fields-list__item\" ng-repeat=\"item in product.product_items_attributes\" ng-if=\"!item._destroy\" ui-tree-node=\"\" ng-include=\"'./editor/modules_settings/productfields/tree_renderer.jade'\"></li></ol></div></div></div><div class=\"ms-fields-setup\" ng-show=\"fieldsLength(product.product_items_attributes)\"><div class=\"ms__content ms-select\"><div class=\"ms__caption\">{{'widget.product.typeLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><select class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\" ng-options=\"type.item_type as type.title | translate for type in productTypes\" ng-model=\"product.product_items_attributes[currentField].item_type\" ng-change=\"renderProduct()\"></select></div></div></div><div ng-if=\"product.product_items_attributes[currentField].item_type == 'image'\"><div class=\"ms__content ms-text\"><span>{{'widget.product.imageSettingsLabel' | translate}}</span></div><div class=\"ms__content ms-text\"><div class=\"ms-fields-setup\" ng-show=\"fieldsLength(product.product_items_attributes)\"><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.slider.imageLabel' | translate}}</div><div class=\"ms__input-wrapper\" uploader-setting=\"\" uploader-product-item-id=\"{{product.product_items_attributes[currentField].id}}\" ng-model=\"product.product_items_attributes[currentField].file_url\" widget-id=\"{{product.id}}\" upload-success=\"renderProduct()\" image-attr=\"file\"></div></div><div class=\"ms__content ms-text\" photo-library=\"\" ng-model=\"product\" access-key=\"product_items_attributes.{{currentField}}\" current-key=\"file_url\" remote-key=\"remote_file_url\" after-change=\"renderProduct()\"></div></div></div><p>&nbsp;</p><div class=\"ms__content ms-border\" border-setting=\"\" ng-model=\"product.product_items_attributes[currentField].image_style_attributes.border\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-align\"><div class=\"ms__caption\">{{'modulesSettings.textAlignLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" aligment-setting=\"\" ng-model=\"product.product_items_attributes[currentField].image_style_attributes.textAlign\"></div></div></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.height' | translate}}</div><div class=\"ms__input-wrapper\" slidersize-setting=\"\" ng-model=\"product.product_items_attributes[currentField].image_wrapper_height\"></div></div><hr class=\"ms__separator\"/><p>&nbsp;</p><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"product.product_items_attributes[currentField].image_style_attributes.padding\"></div></div></div></div><div ng-if=\"product.product_items_attributes[currentField].item_type == 'text'\"><div class=\"ms__content ms-text\"><span>{{'widget.product.textSettingsLabel' | translate}}</span></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'modulesSettings.textLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_slider-range\"><div color-setting=\"\" ng-model=\"product.product_items_attributes[currentField].text_style_attributes.color\"></div><label class=\"label ms__label\">{{'modulesSettings.colorLabel' | translate}}</label></div><div class=\"ms__input ms__input_range\" size-setting=\"\" ng-model=\"product.product_items_attributes[currentField].text_style_attributes.fontSize\"></div></div></div><div class=\"ms__content ms-align\"><div class=\"ms__caption\">{{'modulesSettings.textAlignLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" aligment-setting=\"\" ng-model=\"product.product_items_attributes[currentField].text_style_attributes.textAlign\"></div></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.fontLabel' | translate}}</div><div class=\"input-wrapper inline-wrapper ms__input_half ms__input_half-margin\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.product.product_items_attributes[currentField].text_style_attributes.fontFamily\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{$parent.$parent.product.product_items_attributes[currentField].text_style_attributes.fontFamily || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in Editor.Instrumentations.fonts\" ng-click=\"optionCheck($event, font.family);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper inline-wrapper ms__input_half\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.product.product_items_attributes[currentField].text_style_attributes.fontWeight\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.title_style.fontWeight || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{weight}}\" ng-repeat=\"weight in ['normal', 'bold', 'bolder', 'lighter']\" ng-click=\"optionCheck($event, weight);\">{{weight}}</li></ul></div></perfect-scrollbar></div></div><label class=\"label ms__label\">{{'modulesSettings.fontWeightLabel' | translate}}</label></div></div><div class=\"ms__content\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__text-1\" type=\"checkbox\" ng-model=\"product.product_items_attributes[currentField].text_style_attributes.textDecoration\" ng-true-value=\"'line-through'\" ng-false-value=\"'none'\"/><label class=\"checkbox-label-wrapper\" for=\"ms__text-1\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.product.textType1' | translate}}</span></label></div></div><div class=\"ms__content\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__text-2\" type=\"checkbox\" ng-model=\"product.product_items_attributes[currentField].text_style_attributes.textDecoration\" ng-true-value=\"'underline'\" ng-false-value=\"'none'\"/><label class=\"checkbox-label-wrapper\" for=\"ms__text-2\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.product.textType2' | translate}}</span></label></div></div><div class=\"ms__content\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__text-2\" type=\"checkbox\" ng-model=\"product.product_items_attributes[currentField].text_style_attributes.fontStyle\" ng-true-value=\"'italic'\" ng-false-value=\"'normal'\"/><label class=\"checkbox-label-wrapper\" for=\"ms__text-2\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.product.textType3' | translate}}</span></label></div></div><hr class=\"ms__separator\"/><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.marginLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"product.product_items_attributes[currentField].text_style_attributes.margin\"></div></div></div></div><div ng-if=\"product.product_items_attributes[currentField].item_type == 'button'\"><div class=\"ms__content ms-text\"><span>{{'widget.product.buttonSettingsLabel' | translate}}</span></div><div class=\"header-menu__nav\"><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': $parent.$parent.currentDesignTab == 'card_button_settings'}\" ng-click=\"$parent.$parent.setDesignTab('card_button_settings')\" ng-init=\"$parent.$parent.setDesignTab('card_button_settings')\">{{'widget.product.tab1' | translate}}</a><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': $parent.$parent.currentDesignTab == 'card_button_text_settings'}\" ng-click=\"$parent.$parent.setDesignTab('card_button_text_settings')\">{{'widget.product.tab2' | translate}}</a><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': $parent.$parent.currentDesignTab == 'card_button_padding_settings'}\" ng-click=\"$parent.$parent.setDesignTab('card_button_padding_settings')\">{{'widget.product.tab3' | translate}}</a><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': $parent.$parent.currentDesignTab == 'card_button_click_settings'}\" ng-click=\"$parent.$parent.setDesignTab('card_button_click_settings')\">{{'widget.product.tab4' | translate}}</a></div><p>&nbsp;</p><div ng-show=\"$parent.$parent.currentDesignTab == 'card_button_settings'\"><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"product.product_items_attributes[currentField].button_attributes.style_attributes.backgroundColor\"></div></div></div><div class=\"ms__content ms-color\" gradient-setting=\"\" ng-model=\"product.product_items_attributes[currentField].button_attributes.style_attributes\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-border\" border-setting=\"\" ng-model=\"product.product_items_attributes[currentField].button_attributes.style_attributes.border\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.borderRadiusLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" ng-model=\"product.product_items_attributes[currentField].button_attributes.style_attributes.borderRadius\"></div></div></div><div ng-show=\"$parent.$parent.currentDesignTab == 'card_button_text_settings'\"><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'modulesSettings.textLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_slider-range\"><div color-setting=\"\" ng-model=\"product.product_items_attributes[currentField].button_attributes.style_attributes.color\"></div><label class=\"label ms__label\">{{'modulesSettings.colorLabel' | translate}}</label></div><div class=\"ms__input ms__input_range\" size-setting=\"\" ng-model=\"product.product_items_attributes[currentField].button_attributes.style_attributes.fontSize\"></div></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.fontLabel' | translate}}</div><div class=\"input-wrapper inline-wrapper ms__input_half ms__input_half-margin\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.product.product_items_attributes[currentField].button_attributes.style_attributes.fontFamily\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{$parent.$parent.product.product_items_attributes[currentField].button_attributes.style_attributes.fontFamily || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in Editor.Instrumentations.fonts\" ng-click=\"optionCheck($event, font.family);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper inline-wrapper ms__input_half\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.product.product_items_attributes[currentField].button_attributes.style_attributes.fontWeight\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{$parent.$parent.product.product_items_attributes[currentField].button_attributes.style_attributes.fontWeight || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{weight}}\" ng-repeat=\"weight in ['normal', 'bold', 'bolder', 'lighter']\" ng-click=\"optionCheck($event, weight);\">{{weight}}</li></ul></div></perfect-scrollbar></div></div><label class=\"label ms__label\">{{'modulesSettings.fontWeightLabel' | translate}}</label></div></div></div><div ng-show=\"$parent.$parent.currentDesignTab == 'card_button_padding_settings'\"><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"product.product_items_attributes[currentField].button_attributes.style_attributes.padding\"></div></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.marginLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"product.product_items_attributes[currentField].button_attributes.style_attributes.margin\"></div></div></div></div><div ng-show=\"$parent.$parent.currentDesignTab == 'card_button_click_settings'\"><div class=\"product-button__settings\" button-actions=\"\" ng-model=\"product.product_items_attributes[currentField]\" button-property=\"button_attributes\" form-property=\"button_form_attributes\"></div></div></div><div ng-if=\"product.product_items_attributes[currentField].item_type == 'list'\"><div class=\"ms__content ms-text\" list-fields-setting=\"\" ng-model=\"product.product_items_attributes[currentField]\" widget-id=\"{{product.id}}\" from-product=\"true\" product-id=\"{{product.id}}\" product-item-id=\"{{product.product_items_attributes[currentField].id}}\" after-row-create=\"renderProduct()\"></div><div class=\"header-menu__nav\" ng-init=\"$parent.$parent.setDesignTab('card_additional_tab1')\"><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': $parent.$parent.currentDesignTab == 'card_additional_tab1'}\" ng-click=\"$parent.$parent.setDesignTab('card_additional_tab1')\">{{'widget.product.tab1' | translate}}</a><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': $parent.$parent.currentDesignTab == 'card_additional_tab2'}\" ng-click=\"$parent.$parent.setDesignTab('card_additional_tab2')\">{{'widget.product.tab2' | translate}}</a><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': $parent.$parent.currentDesignTab == 'card_additional_tab3'}\" ng-click=\"$parent.$parent.setDesignTab('card_additional_tab3')\">{{'widget.product.tab3' | translate}}</a></div><p>&nbsp;</p><div ng-show=\"$parent.$parent.currentDesignTab == 'card_additional_tab1'\"><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.image.imageLabel' | translate}}</div><div class=\"ms__input-wrapper\" uploader-setting=\"\" uploader-product-item-id-row=\"{{product.product_items_attributes[currentField].id}}\" ng-model=\"product.product_items_attributes[currentField].bullet_url\" widget-id=\"{{product.id}}\" upload-success=\"renderProduct()\" image-attr=\"bullet\"></div></div><div class=\"ms__content ms-text\" photo-library=\"\" ng-model=\"product\" access-key=\"product_items_attributes.{{currentField}}\" current-key=\"bullet_url\" remote-key=\"remote_bullet_url\" after-change=\"renderProduct()\"></div></div><div ng-show=\"$parent.$parent.currentDesignTab == 'card_additional_tab2'\"><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'modulesSettings.textLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_slider-range\"><div color-setting=\"\" ng-model=\"product.product_items_attributes[currentField].caption_style_attributes.color\"></div><label class=\"label ms__label\">{{'modulesSettings.colorLabel' | translate}}</label></div><div class=\"ms__input ms__input_range\" size-setting=\"\" ng-model=\"product.product_items_attributes[currentField].caption_style_attributes.fontSize\"></div></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.fontLabel' | translate}}</div><div class=\"input-wrapper inline-wrapper ms__input_half ms__input_half-margin\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.product.product_items_attributes[currentField].caption_style_attributes.fontFamily\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{$parent.$parent.product.product_items_attributes[currentField].caption_style_attributes.fontFamily || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in Editor.Instrumentations.fonts\" ng-click=\"optionCheck($event, font.family);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper inline-wrapper ms__input_half\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.product.product_items_attributes[currentField].caption_style_attributes.fontWeight\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{$parent.$parent.product.product_items_attributes[currentField].caption_style_attributes.fontWeight || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{weight}}\" ng-repeat=\"weight in ['normal', 'bold', 'bolder', 'lighter']\" ng-click=\"optionCheck($event, weight);\">{{weight}}</li></ul></div></perfect-scrollbar></div></div><label class=\"label ms__label\">{{'modulesSettings.fontWeightLabel' | translate}}</label></div></div></div><div ng-show=\"$parent.$parent.currentDesignTab == 'card_additional_tab3'\"><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"product.product_items_attributes[currentField].caption_style_attributes.padding\"></div></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.marginLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"product.product_items_attributes[currentField].caption_style_attributes.padding\"></div></div></div></div></div></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"$parent.editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"accordion = {show_hover_settings: !accordion.show_hover_settings}\" ng-class=\"{'ms__title_active': accordion.show_hover_settings}\">{{'widget.form.hoverText3' | translate}}</span><div class=\"ms__section\" ng-class=\"{'ms__section_active': accordion.show_hover_settings}\" hover-setting=\"\" ng-model=\"$parent.widget\" access-key=\"hover_style\"></div></div>";

/***/ }),
/* 349 */
/***/ (function(module, exports) {

module.exports = "<div class=\"tree-node\" ui-tree-handle=\"\"><div class=\"tree__icon-move tree__icon-move_fields\"><svg class=\"svg-block\" width=\"12\" height=\"12\" viewbox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"icon-block__fill\"><rect width=\"4.8\" height=\"4.8\" rx=\"1\"></rect><rect y=\"7.2\" width=\"4.8\" height=\"4.8\" rx=\"1\"></rect><rect x=\"7.2\" width=\"4.8\" height=\"4.8\" rx=\"1\"></rect><rect x=\"7.2\" y=\"7.2\" width=\"4.8\" height=\"4.8\" rx=\"1\"></rect></g></svg></div><a class=\"link ms-fields-list__item-link\" title=\"{{item.item_type}}\" ng-click=\"setCurrentField($index)\" ng-class=\"{'active': $parent.$parent.$parent.currentField == $index}\"><span ng-if=\"item.item_type == 'image'\">{{'widget.product.elementType1' | translate}}</span><span ng-if=\"item.item_type == 'text'\">{{'widget.product.elementType2' | translate}}</span><span ng-if=\"item.item_type == 'button'\">{{'widget.product.elementType3' | translate}}</span><span ng-if=\"item.item_type == 'list'\">{{'widget.product.elementType4' | translate}}</span></a></div>";

/***/ }),
/* 350 */
/***/ (function(module, exports) {

module.exports = "<div class=\"ms__input ms__input_slider-range\"><div class=\"ms__range-slider\" range-slider=\"\" min=\"0\" max=\"100\" model-max=\"radiusValue\" pin-handle=\"min\"></div></div><div class=\"ms__input ms__input_range\"><div class=\"select input-range-wrapper\" str-select=\"\" select-editor=\"true\" ng-model=\"$parent.radiusType\" select-replace=\"false\"><input class=\"input input_nano input_range ms-input_border\" type=\"number\" min=\"0\" ng-model=\"$parent.radiusValue\"/><div class=\"ms__range\"><a class=\"link link_range-one select__placeholder select__placeholder_ms\">{{radiusType}}</a></div><div class=\"select__dropdown ms-input_border select__dropdown_ms\"><div class=\"dropdown-group\"><ul><li class=\"dropdown__option dropdown__ms-option option_active\" title=\"px\" ng-click=\"optionCheck($event, 'px')\">px</li><li class=\"dropdown__option dropdown__ms-option\" title=\"%\" ng-click=\"optionCheck($event, '%')\">%</li></ul></div></div></div></div>";

/***/ }),
/* 351 */
/***/ (function(module, exports) {

module.exports = "<div class=\"ms ms-tab-pane\" ng-show=\"$parent.editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-class=\"{'ms__title_active': accordion.show_review_additional}\"><div class=\"ms__title-name\" ng-click=\"accordion = {show_review_additional: !accordion.show_review_additional}\">{{'widget.review.additional' | translate}}</div></span><div class=\"ms__section ms__section_active\" ng-class=\"{'ms__section_active': accordion.show_review_additional}\" ng-show=\"accordion.show_review_additional\"><div class=\"ms__content\"><span class=\"ms__caption\">{{'widget.review.reviewsLabel' | translate}}</span><div class=\"ms-fields-control\"><a class=\"link group-title fields-control fields-control_add fl\" title=\"Добавить отзыв\" ng-click=\"add()\"><svg class=\"icon__fields-control\" viewBox=\"0 0 17 17\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"icon__fill\"><rect x=\"0\" y=\"8\" width=\"17\" height=\"1\"></rect><rect x=\"8\" y=\"0\" width=\"1\" height=\"17\"></rect></g></svg></a><a class=\"link group-title fields-control fields-control_remove fl\" title=\"Удалить отзыв\" ng-click=\"remove()\"><svg class=\"icon__fields-control\" viewBox=\"0 0 17 17\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"icon__fill\"><rect x=\"0\" y=\"8\" width=\"17\" height=\"1\"></rect></g></svg></a></div><ul class=\"ms-fields-list\"><li class=\"ms-fields-list__item\" ng-show=\"!fieldsLength(review.photos_attributes)\"><a class=\"link ms-fields-list__item-link\" title=\"{{'widget.review.emptyLabel' | translate}}\" ng-click=\"add()\">{{'widget.review.emptyLabel' | translate}}</a></li><li class=\"ms-fields-list__item\" ng-repeat=\"field in review.photos_attributes\" ng-show=\"!field._destroy\"><a class=\"link ms-fields-list__item-link\" title=\"{{field.caption}}\" ng-click=\"setCurrentSlide($index)\" ng-class=\"{'active': currentField == $index}\">{{field.caption || \"Slide \"+($index+1)}}</a></li></ul></div></div><div class=\"ms__section ms__section_nopadding\" ng-class=\"{'ms__section_active': accordion.show_review_additional}\" ng-show=\"accordion.show_review_additional\"><div class=\"ms__content\"><div class=\"checkbox-wrapper_list-title\"><div class=\"ms__caption\">{{'widget.review.elementsLabel' | translate}}:</div></div><div class=\"checkbox-wrapper_list-item\"><input class=\"checkbox\" id=\"ms__review1-4\" type=\"checkbox\" ng-model=\"$parent.widget.show_image\"/><label class=\"checkbox-label-wrapper\" for=\"ms__review4\" ng-click=\"accordion.show_image_settings = true\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.review.element1' | translate}}</span></label><svg class=\"card-settings__icon\" width=\"16\" height=\"16\" viewbox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" ng-click=\"accordion.show_image_settings = true\"><path d=\"M20.254 13.5h3.246v-3h-3.247c-.209-.867-.551-2.181-1.003-2.922l2.296-2.295-2.829-2.829-2.297 2.296c-.74-.452-2.053-.793-2.92-1.002v-3.248h-3v3.248c-.867.209-2.181.55-2.921 1.002l-2.297-2.296-2.829 2.829 2.297 2.296c-.452.74-.794 2.054-1.004 2.921h-3.246v3h3.246c.21.867.552 2.181 1.004 2.921l-2.297 2.297 2.829 2.828 2.296-2.297c.741.453 2.055.795 2.922 1.005v3.246h3v-3.246c.867-.21 2.181-.552 2.92-1.004l2.298 2.296 2.828-2.828-2.296-2.297c.452-.74.794-2.054 1.004-2.921zm-3.754-1.5c0 2.486-2.015 4.5-4.5 4.5s-4.5-2.014-4.5-4.5c0-2.485 2.015-4.5 4.5-4.5s4.5 2.015 4.5 4.5z\" stroke=\"#4c4c4c\" fill=\"none\"></path></svg></div><div class=\"checkbox-wrapper_list-item\"><input class=\"checkbox\" id=\"ms__review1-1\" type=\"checkbox\" ng-model=\"$parent.widget.show_text\"/><label class=\"checkbox-label-wrapper\" for=\"ms__review1\" ng-click=\"accordion.show_text_settings = true\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.review.element2' | translate}}</span></label><svg class=\"card-settings__icon\" width=\"16\" height=\"16\" viewbox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" ng-click=\"accordion.show_text_settings = true\"><path d=\"M20.254 13.5h3.246v-3h-3.247c-.209-.867-.551-2.181-1.003-2.922l2.296-2.295-2.829-2.829-2.297 2.296c-.74-.452-2.053-.793-2.92-1.002v-3.248h-3v3.248c-.867.209-2.181.55-2.921 1.002l-2.297-2.296-2.829 2.829 2.297 2.296c-.452.74-.794 2.054-1.004 2.921h-3.246v3h3.246c.21.867.552 2.181 1.004 2.921l-2.297 2.297 2.829 2.828 2.296-2.297c.741.453 2.055.795 2.922 1.005v3.246h3v-3.246c.867-.21 2.181-.552 2.92-1.004l2.298 2.296 2.828-2.828-2.296-2.297c.452-.74.794-2.054 1.004-2.921zm-3.754-1.5c0 2.486-2.015 4.5-4.5 4.5s-4.5-2.014-4.5-4.5c0-2.485 2.015-4.5 4.5-4.5s4.5 2.015 4.5 4.5z\" stroke=\"#4c4c4c\" fill=\"none\"></path></svg></div><div class=\"checkbox-wrapper_list-item\"><input class=\"checkbox\" id=\"ms__review1-2\" type=\"checkbox\" ng-model=\"$parent.widget.show_name\"/><label class=\"checkbox-label-wrapper\" for=\"ms__review2\" ng-click=\"accordion.show_name_settings = true\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.review.element3' | translate}}</span></label><svg class=\"card-settings__icon\" width=\"16\" height=\"16\" viewbox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" ng-click=\"accordion.show_name_settings = true\"><path d=\"M20.254 13.5h3.246v-3h-3.247c-.209-.867-.551-2.181-1.003-2.922l2.296-2.295-2.829-2.829-2.297 2.296c-.74-.452-2.053-.793-2.92-1.002v-3.248h-3v3.248c-.867.209-2.181.55-2.921 1.002l-2.297-2.296-2.829 2.829 2.297 2.296c-.452.74-.794 2.054-1.004 2.921h-3.246v3h3.246c.21.867.552 2.181 1.004 2.921l-2.297 2.297 2.829 2.828 2.296-2.297c.741.453 2.055.795 2.922 1.005v3.246h3v-3.246c.867-.21 2.181-.552 2.92-1.004l2.298 2.296 2.828-2.828-2.296-2.297c.452-.74.794-2.054 1.004-2.921zm-3.754-1.5c0 2.486-2.015 4.5-4.5 4.5s-4.5-2.014-4.5-4.5c0-2.485 2.015-4.5 4.5-4.5s4.5 2.015 4.5 4.5z\" stroke=\"#4c4c4c\" fill=\"none\"></path></svg></div><div class=\"checkbox-wrapper_list-item\"><input class=\"checkbox\" id=\"ms__review1-3\" type=\"checkbox\" ng-model=\"$parent.widget.show_vocation\"/><label class=\"checkbox-label-wrapper\" for=\"ms__review3\" ng-click=\"accordion.show_vocation_settings = true\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.review.element4' | translate}}</span></label><svg class=\"card-settings__icon\" width=\"16\" height=\"16\" viewbox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" ng-click=\"accordion.show_vocation_settings = true\"><path d=\"M20.254 13.5h3.246v-3h-3.247c-.209-.867-.551-2.181-1.003-2.922l2.296-2.295-2.829-2.829-2.297 2.296c-.74-.452-2.053-.793-2.92-1.002v-3.248h-3v3.248c-.867.209-2.181.55-2.921 1.002l-2.297-2.296-2.829 2.829 2.297 2.296c-.452.74-.794 2.054-1.004 2.921h-3.246v3h3.246c.21.867.552 2.181 1.004 2.921l-2.297 2.297 2.829 2.828 2.296-2.297c.741.453 2.055.795 2.922 1.005v3.246h3v-3.246c.867-.21 2.181-.552 2.92-1.004l2.298 2.296 2.828-2.828-2.296-2.297c.452-.74.794-2.054 1.004-2.921zm-3.754-1.5c0 2.486-2.015 4.5-4.5 4.5s-4.5-2.014-4.5-4.5c0-2.485 2.015-4.5 4.5-4.5s4.5 2.015 4.5 4.5z\" stroke=\"#4c4c4c\" fill=\"none\"></path></svg></div><div class=\"checkbox-wrapper_list-item\"><input class=\"checkbox\" id=\"ms__review1-5\" type=\"checkbox\" checked=\"\" disabled=\"\"/><label class=\"checkbox-label-wrapper\" for=\"ms__review5\" ng-click=\"accordion.show_reviews_settings = true\"><div class=\"checkbox-label checkbox-label_small button_border fl\" style=\"opacity: 0.5;\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.review.element5' | translate}}</span></label><svg class=\"card-settings__icon\" width=\"16\" height=\"16\" viewbox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" ng-click=\"accordion.show_reviews_settings = true\"><path d=\"M20.254 13.5h3.246v-3h-3.247c-.209-.867-.551-2.181-1.003-2.922l2.296-2.295-2.829-2.829-2.297 2.296c-.74-.452-2.053-.793-2.92-1.002v-3.248h-3v3.248c-.867.209-2.181.55-2.921 1.002l-2.297-2.296-2.829 2.829 2.297 2.296c-.452.74-.794 2.054-1.004 2.921h-3.246v3h3.246c.21.867.552 2.181 1.004 2.921l-2.297 2.297 2.829 2.828 2.296-2.297c.741.453 2.055.795 2.922 1.005v3.246h3v-3.246c.867-.21 2.181-.552 2.92-1.004l2.298 2.296 2.828-2.828-2.296-2.297c.452-.74.794-2.054 1.004-2.921zm-3.754-1.5c0 2.486-2.015 4.5-4.5 4.5s-4.5-2.014-4.5-4.5c0-2.485 2.015-4.5 4.5-4.5s4.5 2.015 4.5 4.5z\" stroke=\"#4c4c4c\" fill=\"none\"></path></svg></div></div></div></div><div class=\"ms ms-tab-pane ms-tab-pane_modal\" ng-show=\"$parent.editCurrentTab == 'blockDesign'\" ng-class=\"{'ms-tab-pane_modal-open': accordion.show_image_settings}\"><div class=\"ms__section ms__section_active ms__section_navigation-settings\"><div class=\"ms__content ms-text\"><span>{{'widget.review.element1' | translate}}</span><a class=\"etsw-header__close fr\" ng-click=\"accordion.show_image_settings = false\"><svg class=\"icon-close\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a></div><div class=\"ms__content ms-radio\"><div class=\"ms__caption ms__caption_top\">{{'widget.product.typeLabel' | translate}}:</div><div class=\"ms__input-wrapper\"><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__review-media-type-1\" type=\"radio\" value=\"image\" name=\"review-media-type\" ng-model=\"review.photos_attributes[currentField].media_type\"/><label class=\"radio-label-wrapper\" for=\"ms__review-media-type-1\" title=\"\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'editor.panel.blockSettings.section.background1' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__review-media-type-2\" type=\"radio\" value=\"video\" name=\"review-media-type\" ng-model=\"review.photos_attributes[currentField].media_type\"/><label class=\"radio-label-wrapper\" for=\"ms__review-media-type-2\" title=\"\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'editor.panel.blockSettings.section.background2' | translate}}</span></label></div></div></div><div class=\"ms__content ms-radio\" ng-show=\"widget.slider\"><div class=\"ms__caption ms__caption_top\">{{'widget.review.optionsLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__autoplay\" type=\"checkbox\" checked=\"\" ng-true-value=\"3000\" ng-false-value=\"0\" ng-model=\"widget.settings.autoplay\"/><label class=\"checkbox-label-wrapper\" for=\"ms__autoplay\" title=\"Автопереход\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.review.autoslideLabel' | translate}}</span></label></div></div></div><div class=\"ms__content ms-text\" ng-show=\"review.photos_attributes[currentField].media_type == 'image'\"><div class=\"ms-fields-setup\" ng-show=\"fieldsLength(review.photos_attributes)\"><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.slider.imageLabel' | translate}}</div><div class=\"ms__input-wrapper\" uploader-setting=\"\" uploader-photo-id=\"{{review.photos_attributes[currentField].id}}\" ng-model=\"review.photos_attributes[currentField].file_url\" widget-id=\"{{review.id}}\" ng-if=\"review.id\"></div></div><div class=\"ms__content ms-text\" photo-library=\"\" ng-model=\"review\" access-key=\"photos_attributes.{{currentField}}\" current-key=\"file_url\" remote-key=\"remote_file_url\"></div><div class=\"ms__content\"></div></div><div class=\"ms__content ms-border\" border-setting=\"\" ng-model=\"$parent.widget.photos_style.border\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.borderRadiusLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" ng-model=\"$parent.widget.photos_style.borderRadius\"></div></div><div class=\"ms__content\"><div class=\"checkbox-wrapper\"><input class=\"checkbox\" id=\"ms__image-full\" type=\"checkbox\" ng-model=\"$parent.widget.full_width_image\"/><label class=\"checkbox-label-wrapper\" for=\"ms__image-full\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.review.element1View' | translate}}</span></label></div></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'widget.review.element1Size' | translate}}</div><div class=\"ms__input-wrapper\" slidersize-setting=\"\" ng-model=\"$parent.widget.photos_style.width\"></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"$parent.widget.photos_style.margin\"></div></div></div></div><div class=\"ms__content ms-text\" ng-show=\"review.photos_attributes[currentField].media_type == 'video'\"><div class=\"ms__caption\">{{'widget.video.urlLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_extra-small ms-input_border\" id=\"etn__imageWidgetInput\" type=\"text\" placeholder=\"http://\" ng-model=\"review.photos_attributes[currentField].video_url\"/></div><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__form-checkbox-autoplay\" type=\"checkbox\" checked=\"\" ng-model=\"review.photos_attributes[currentField].autoplay\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-autoplay\" title=\"Mark a message\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text label-text_small\">{{'widget.video.autoplay' | translate}}</span></label></div><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__form-checkbox-hide_info\" type=\"checkbox\" checked=\"\" ng-model=\"review.photos_attributes[currentField].hide_info\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-hide_info\" title=\"Mark a message\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text label-text_small\">{{'widget.video.hide_info' | translate}} (youtube)</span></label></div><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__form-checkbox-hide_elements\" type=\"checkbox\" checked=\"\" ng-model=\"review.photos_attributes[currentField].hide_elements\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-hide_elements\" title=\"Mark a message\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text label-text_small\">{{'widget.video.hide_elements' | translate}} (youtube)</span></label></div><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__form-checkbox-hide_related\" type=\"checkbox\" checked=\"\" ng-model=\"review.photos_attributes[currentField].hide_related\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-hide_related\" title=\"Mark a message\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text label-text_small\">{{'widget.video.hide_related' | translate}} (youtube)</span></label></div><div class=\"checkbox-wrapper ms-checkbox\"><div class=\"ms__caption\">{{'modulesSettings.height' | translate}}</div><div class=\"ms__input-wrapper\" height-setting=\"\" ng-model=\"review.photos_attributes[currentField].video_height\" height-min=\"0\" height-max=\"1000\"></div></div></div></div></div></div><div class=\"ms ms-tab-pane ms-tab-pane_modal\" ng-show=\"$parent.editCurrentTab == 'blockDesign'\" ng-class=\"{'ms-tab-pane_modal-open': accordion.show_reviews_settings}\"><div class=\"ms__section ms__section_active ms__section_navigation-settings\"><div class=\"ms__content ms-text\"><span>{{'editor.panel.blockSettings.section.backgroundLabel' | translate}}</span><a class=\"etsw-header__close fr\" ng-click=\"accordion.show_reviews_settings = false\"><svg class=\"icon-close\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a></div><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"$parent.widget.reviews_style.backgroundColor\"></div></div></div><div class=\"ms__content ms-border\" border-setting=\"\" ng-model=\"$parent.widget.reviews_style.border\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.borderRadiusLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" ng-model=\"$parent.widget.reviews_style.borderRadius\"></div></div></div></div><div class=\"ms ms-tab-pane ms-tab-pane_modal\" ng-show=\"$parent.editCurrentTab == 'blockDesign'\" ng-class=\"{'ms-tab-pane_modal-open': accordion.show_text_settings}\"><div class=\"ms__section ms__section_active ms__section_navigation-settings\"><div class=\"ms__content ms-text\"><span>{{'widget.review.element2' | translate}}</span><a class=\"etsw-header__close fr\" ng-click=\"accordion.show_text_settings = false\"><svg class=\"icon-close\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'modulesSettings.textLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_slider-range\"><div color-setting=\"\" ng-model=\"$parent.widget.text_style.color\"></div><label class=\"label ms__label\">{{'modulesSettings.colorLabel' | translate}}</label></div><div class=\"ms__input ms__input_range\" size-setting=\"\" ng-model=\"$parent.widget.text_style.fontSize\"></div></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.fontLabel' | translate}}</div><div class=\"input-wrapper inline-wrapper ms__input_half ms__input_half-margin\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.$parent.widget.text_style.fontFamily\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{$parent.$parent.widget.text_style.fontFamily || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in Editor.Instrumentations.fonts\" ng-click=\"optionCheck($event, font.family);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper inline-wrapper ms__input_half\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.$parent.widget.text_style.fontWeight\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.text_style.fontWeight || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{weight}}\" ng-repeat=\"weight in ['normal', 'bold', 'bolder', 'lighter']\" ng-click=\"optionCheck($event, weight);\">{{weight}}</li></ul></div></perfect-scrollbar></div></div><label class=\"label ms__label\">{{'modulesSettings.fontWeightLabel' | translate}}</label></div></div><div class=\"ms__content ms-align\"><div class=\"ms__caption\">{{'modulesSettings.textAlignLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" aligment-setting=\"\" ng-model=\"$parent.widget.text_style.textAlign\"></div></div></div><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"$parent.widget.text_style.backgroundColor\"></div></div></div><div class=\"ms__content ms-border\" border-setting=\"\" ng-model=\"$parent.widget.text_style.border\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.borderRadiusLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" ng-model=\"$parent.widget.text_style.borderRadius\"></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"$parent.widget.text_style.padding\"></div></div></div></div></div><div class=\"ms ms-tab-pane ms-tab-pane_modal\" ng-show=\"$parent.editCurrentTab == 'blockDesign'\" ng-class=\"{'ms-tab-pane_modal-open': accordion.show_name_settings}\"><div class=\"ms__section ms__section_active ms__section_navigation-settings\"><div class=\"ms__content ms-text\"><span>{{'widget.review.element3' | translate}}</span><a class=\"etsw-header__close fr\" ng-click=\"accordion.show_name_settings = false\"><svg class=\"icon-close\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'modulesSettings.textLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_slider-range\"><div color-setting=\"\" ng-model=\"$parent.widget.name_style.color\"></div><label class=\"label ms__label\">{{'modulesSettings.colorLabel' | translate}}</label></div><div class=\"ms__input ms__input_range\" size-setting=\"\" ng-model=\"$parent.widget.name_style.fontSize\"></div></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.fontLabel' | translate}}</div><div class=\"input-wrapper inline-wrapper ms__input_half ms__input_half-margin\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.name_style.fontFamily\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{$parent.$parent.widget.name_style.fontFamily || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in Editor.Instrumentations.fonts\" ng-click=\"optionCheck($event, font.family);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper inline-wrapper ms__input_half\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.name_style.fontWeight\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.name_style.fontWeight || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{weight}}\" ng-repeat=\"weight in ['normal', 'bold', 'bolder', 'lighter']\" ng-click=\"optionCheck($event, weight);\">{{weight}}</li></ul></div></perfect-scrollbar></div></div><label class=\"label ms__label\">{{'modulesSettings.fontWeightLabel' | translate}}</label></div></div><div class=\"ms__content ms-align\"><div class=\"ms__caption\">{{'modulesSettings.textAlignLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" aligment-setting=\"\" ng-model=\"$parent.widget.name_style.textAlign\"></div></div></div><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"$parent.widget.name_style.backgroundColor\"></div></div></div><div class=\"ms__content ms-border\" border-setting=\"\" ng-model=\"$parent.widget.name_style.border\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.borderRadiusLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" ng-model=\"$parent.widget.name_style.borderRadius\"></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"$parent.widget.name_style.padding\"></div></div></div></div></div><div class=\"ms ms-tab-pane ms-tab-pane_modal\" ng-show=\"$parent.editCurrentTab == 'blockDesign'\" ng-class=\"{'ms-tab-pane_modal-open': accordion.show_vocation_settings}\"><div class=\"ms__section ms__section_active ms__section_navigation-settings\"><div class=\"ms__content ms-text\"><span>{{'widget.review.element4' | translate}}</span><a class=\"etsw-header__close fr\" ng-click=\"accordion.show_vocation_settings = false\"><svg class=\"icon-close\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'modulesSettings.textLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_slider-range\"><div color-setting=\"\" ng-model=\"$parent.widget.vocation_style.color\"></div><label class=\"label ms__label\">{{'modulesSettings.colorLabel' | translate}}</label></div><div class=\"ms__input ms__input_range\" size-setting=\"\" ng-model=\"$parent.widget.vocation_style.fontSize\"></div></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.fontLabel' | translate}}</div><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.vocation_style.fontFamily\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{$parent.$parent.widget.vocation_style.fontFamily || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in Editor.Instrumentations.fonts\" ng-click=\"optionCheck($event, font.family);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.fontWeightLabel' | translate}}</div><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.vocation_style.fontWeight\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.vocation_style.fontWeight || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{weight}}\" ng-repeat=\"weight in ['normal', 'bold', 'bolder', 'lighter']\" ng-click=\"optionCheck($event, weight);\">{{weight}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"ms__content ms-align\"><div class=\"ms__caption\">{{'modulesSettings.textAlignLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" aligment-setting=\"\" ng-model=\"$parent.widget.vocation_style.textAlign\"></div></div></div><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"$parent.widget.vocation_style.backgroundColor\"></div></div></div><div class=\"ms__content ms-border\" border-setting=\"\" ng-model=\"$parent.widget.vocation_style.border\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.borderRadiusLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" ng-model=\"$parent.widget.vocation_style.borderRadius\"></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"$parent.widget.vocation_style.padding\"></div></div></div></div></div>";

/***/ }),
/* 352 */
/***/ (function(module, exports) {

module.exports = "<div class=\"ms__content\"><div class=\"ms__caption\">{{\"modulesSettings.Offset\" | translate}}</div><div class=\"input-wrapper inline-wrapper ms__input_half\"><div class=\"ms__input ms__input_large\"><input class=\"input input_inline input_extra-small ms-input_border\" type=\"number\" placeholder=\"\" ng-style=\"{'width': '60px'}\" ng-model=\"shadow.offsetX\"/><span>&nbsp; px</span></div></div><div class=\"input-wrapper inline-wrapper ms__input_half\"><div class=\"ms__input ms__input_large\"><input class=\"input input_inline input_extra-small ms-input_border\" type=\"number\" placeholder=\"\" ng-style=\"{'width': '60px'}\" ng-model=\"shadow.offsetY\"/><span>&nbsp; px</span></div></div></div><div class=\"ms__content\"><div class=\"input-wrapper inline-wrapper ms__input_half\"><div class=\"ms__content\"><div class=\"ms__caption\">{{\"modulesSettings.Blur\" | translate}}</div><div class=\"ms__input ms__input_large\"><input class=\"input input_inline input_extra-small ms-input_border\" type=\"number\" min=\"0\" placeholder=\"\" ng-style=\"{'width': '60px'}\" ng-model=\"shadow.blur\"/><span>&nbsp; px</span></div></div></div><div class=\"input-wrapper inline-wrapper ms__input_half\"><div class=\"ms__content\"><div class=\"ms__caption\">{{\"modulesSettings.Spread\" | translate}}</div><div class=\"ms__input ms__input_large\"><input class=\"input input_inline input_extra-small ms-input_border\" type=\"number\" placeholder=\"\" ng-style=\"{'width': '60px'}\" ng-model=\"shadow.spread\"/><span>&nbsp; px</span></div></div></div></div><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{\"modulesSettings.ShadowColor\" | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"shadow.color\"></div></div></div>";

/***/ }),
/* 353 */
/***/ (function(module, exports) {

module.exports = "<div class=\"ms__content ms-text ms__content_bg__image\"><div class=\"ms__caption\">{{'widget.image.imageLabel' | translate}}</div><div class=\"ms__input-wrapper\" uploader-setting=\"\" ng-if=\"reloadUploader\" ng-model=\"data.background_attributes.image_attributes.source_url\" site-bg=\"true\"></div></div><a class=\"inline-wrapper\" ng-click=\"removePageBackground()\" style=\"margin-left: 10px;\" ng-if=\"data.background_attributes.image_attributes.source_url\"><svg class=\"icon-close\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" style=\"width: 14px;margin-top: 6px;\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a><div class=\"ms__content ms-text\" photo-library=\"\" ng-model=\"data\" access-key=\"background_attributes.image_attributes\" current-key=\"source_url\" remote-key=\"remote_source_url\"></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'editor.panel.blockSettings.section.background1.sizeLabel' | translate}}</div><div class=\"input-wrapper ta-left\"><div class=\"select\" str-select=\"\" ng-model=\"sectionBgOption\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\"><span ng-if=\"data.style_attributes.backgroundRepeat !== 'repeat' &amp;&amp; data.style_attributes.backgroundSize !== 'cover'\">{{'editor.panel.blockSettings.section.background1.size1' | translate}}</span><span ng-if=\"data.style_attributes.backgroundRepeat == 'repeat'\">{{'editor.panel.blockSettings.section.background1.size2' | translate}}</span><span ng-if=\"data.style_attributes.backgroundSize == 'cover'\">{{'editor.panel.blockSettings.section.background1.size3' | translate}}</span></span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{bgOption.name_ru}}\" ng-repeat=\"bgOption in bgOptions\" ng-click=\"optionCheck($event, bgOption.name); setBgOption(bgOption.name, data)\">{{bgOption.name_ru}}</li></ul></div></perfect-scrollbar></div></div></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'editor.panel.blockSettings.section.background1.backgroundEffectLabel' | translate}}</div><div class=\"input-wrapper ta-left\"><div class=\"select\" str-select=\"\" ng-model=\"sectionBgEffect\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\"><span ng-if=\"!data.background_attributes.parallax &amp;&amp; data.style_attributes.backgroundAttachment !== 'fixed'\">{{'editor.panel.blockSettings.section.background1.backgroundEffect1' | translate}}</span><span ng-if=\"data.style_attributes.backgroundAttachment == 'fixed'\">{{'editor.panel.blockSettings.section.background1.backgroundEffect2' | translate}}</span><span ng-if=\"data.background_attributes.parallax\">{{'editor.panel.blockSettings.section.background1.backgroundEffect3' | translate}}</span></span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{bgEffect.name_ru}}\" ng-repeat=\"bgEffect in bgEffects\" ng-click=\"optionCheck($event, bgEffect.name); setBgEffect(bgEffect.name, data)\">{{bgEffect.name_ru}}</li></ul></div></perfect-scrollbar></div></div></div></div><div class=\"ms__content\" ng-if=\"data.background_attributes.parallax\"><div class=\"ms__caption\">{{'editor.panel.blockSettings.section.background1.backgroundEffect3SpeedLabel' | translate}}</div><div height-setting=\"\" ng-model=\"data.background_attributes.parallax_speed\"></div></div><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"data.style_attributes.backgroundColor\" color-bg=\"{{sectionColorBG}}\"></div></div></div><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__form-checkbox-gradient-site\" type=\"checkbox\" ng-model=\"data.background_attributes.gradient\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-gradient-site\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'editor.panel.blockSettings.section.gradientLabel' | translate}}</span></label></div><div class=\"ms__content ms-color\" ng-if=\"data.background_attributes.gradient\"><div class=\"ms__caption\">{{'editor.panel.blockSettings.section.gradientStart' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"data.background_attributes.color_start\"></div></div></div><div class=\"ms__content ms-color\" ng-if=\"data.background_attributes.gradient\"><div class=\"ms__caption\">{{'editor.panel.blockSettings.section.gradientEnd' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"data.background_attributes.color_stop\"></div></div></div>";

/***/ }),
/* 354 */
/***/ (function(module, exports) {

module.exports = "<div class=\"input-range-wrapper\"><input class=\"input input_nano input_range ms-input_border\" type=\"number\" min=\"0\" ng-model=\"size\"/><div class=\"ms__range\"><a class=\"link link_range\" ng-click=\"size = size+1;\"><svg class=\"icon-ms__range\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"1 0.3 11.3 6.4\"><polygon class=\"icon__fill\" points=\"12.3,6 11.6,6.7 6.7,1.7 1.7,6.7 1,6 5.9,1 6.7,0.3 7.4,1 \"></polygon></svg></a><a class=\"link link_range\" ng-click=\"size &gt; 0 &amp;&amp; (size = size-1);\"><svg class=\"icon-ms__range\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"1 0.3 11.3 6.4\"><polygon class=\"icon__fill\" points=\"1,1 1.7,0.3 6.7,5.3 11.6,0.3 12.3,1 7.4,6 6.6,6.7 5.9,6 \"></polygon></svg></a></div></div>";

/***/ }),
/* 355 */
/***/ (function(module, exports) {

module.exports = "<div class=\"select input-range-wrapper\" str-select=\"\" select-editor=\"true\" ng-model=\"$parent.sizeType\" select-replace=\"false\"><input class=\"input input_nano input_range ms-input_border\" type=\"number\" min=\"0\" ng-blur=\"sizeBlur()\" ng-model=\"$parent.sizeValue\"/><div class=\"ms__range\"><a class=\"link link_range-one select__placeholder select__placeholder_ms\">{{sizeType}}</a></div><div class=\"select__dropdown ms-input_border select__dropdown_ms\"><div class=\"dropdown-group\"><ul><li class=\"dropdown__option dropdown__ms-option\" title=\"px\" ng-click=\"optionCheck($event, 'px')\">px</li><li class=\"dropdown__option dropdown__ms-option option_active\" title=\"%\" ng-click=\"optionCheck($event, '%')\">%</li></ul></div></div></div>";

/***/ }),
/* 356 */
/***/ (function(module, exports) {

module.exports = "<div class=\"ms__input ms__input_slider-range\"><div class=\"ms__range-slider\" range-slider=\"\" min=\"0\" max=\"1000\" model-max=\"radiusValue\" pin-handle=\"min\"></div></div><div class=\"ms__input ms__input_range\"><div class=\"select input-range-wrapper\" str-select=\"\" select-editor=\"true\" ng-model=\"$parent.radiusType\" select-replace=\"false\"><input class=\"input input_nano input_range ms-input_border\" type=\"number\" min=\"0\" ng-model=\"$parent.radiusValue\"/><div class=\"ms__range\"><a class=\"link link_range-one select__placeholder select__placeholder_ms\">{{radiusType}}</a></div><div class=\"select__dropdown ms-input_border select__dropdown_ms\"><div class=\"dropdown-group\"><ul><li class=\"dropdown__option dropdown__ms-option option_active\" title=\"px\" ng-click=\"optionCheck($event, 'px')\">px</li><li class=\"dropdown__option dropdown__ms-option\" title=\"%\" ng-click=\"optionCheck($event, '%')\">%</li></ul></div></div></div></div>";

/***/ }),
/* 357 */
/***/ (function(module, exports) {

module.exports = "<span class=\"ms__caption\">{{'widget.slider.slidesLabel' | translate}}</span><div class=\"ms-fields-control\"><a class=\"link group-title fields-control fields-control_add fl\" title=\"Добавить слайд\" ng-click=\"add()\"><svg class=\"icon__fields-control\" viewBox=\"0 0 17 17\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"icon__fill\"><rect x=\"0\" y=\"8\" width=\"17\" height=\"1\"></rect><rect x=\"8\" y=\"0\" width=\"1\" height=\"17\"></rect></g></svg></a><a class=\"link group-title fields-control fields-control_remove fl\" title=\"Удалить слайд\" ng-click=\"remove()\"><svg class=\"icon__fields-control\" viewBox=\"0 0 17 17\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"icon__fill\"><rect x=\"0\" y=\"8\" width=\"17\" height=\"1\"></rect></g></svg></a></div><ul class=\"ms-fields-list\"><li class=\"ms-fields-list__item\" ng-show=\"!fieldsLength(slider.photos_attributes)\"><a class=\"link ms-fields-list__item-link\" title=\"Нет слайдов\">{{'widget.slider.emptyLabel' | translate}}</a></li><li class=\"ms-fields-list__item\" ng-repeat=\"field in slider.photos_attributes\" ng-show=\"!field._destroy\"><a class=\"link ms-fields-list__item-link\" title=\"{{field.caption}}\" ng-click=\"setCurrentSlide($index)\" ng-class=\"{'active': currentField == $index}\">{{field.caption || 'widget.review.reviewLabel' | translate}}</a></li></ul><div class=\"ms-fields-setup\" ng-show=\"fieldsLength(slider.photos_attributes)\"><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.slider.imageLabel' | translate}}</div><div class=\"ms__input-wrapper\" uploader-setting=\"\" uploader-photo-id=\"{{slider.photos_attributes[currentField].id}}\" ng-model=\"slider.photos_attributes[currentField].file_url\" widget-id=\"{{slider.id}}\"></div></div><div class=\"ms__content ms-text\" photo-library=\"\" ng-model=\"slider\" access-key=\"photos_attributes.{{currentField}}\" current-key=\"file_url\" remote-key=\"remote_file_url\"></div><div class=\"ms__content\"></div></div>";

/***/ }),
/* 358 */
/***/ (function(module, exports) {

module.exports = "<div class=\"ms ms-tab-pane\"><div class=\"ms__section_nopadding\"><div class=\"ms__content\"><div class=\"checkbox-wrapper_list-title\"><div class=\"ms__caption\">{{'widget.social.title' | translate}}:</div></div><div class=\"checkbox-wrapper_list-item\" ng-repeat=\"icon in data.icons_attributes\"><input class=\"checkbox\" type=\"checkbox\" ng-model=\"icon.enabled\" id=\"card{{icon.name}}-1\"/><label class=\"checkbox-label-wrapper\" for=\"card{{icon.name}}\" ng-click=\"$parent.$parent.accordion.show_icon[$index] = true; $parent.currentIcon = $index;\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{icon.name}}</span></label><svg class=\"card-settings__icon\" width=\"16\" height=\"16\" viewbox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" ng-click=\"$parent.$parent.accordion.show_icon[$index] = true; $parent.currentIcon = $index;\"><path d=\"M20.254 13.5h3.246v-3h-3.247c-.209-.867-.551-2.181-1.003-2.922l2.296-2.295-2.829-2.829-2.297 2.296c-.74-.452-2.053-.793-2.92-1.002v-3.248h-3v3.248c-.867.209-2.181.55-2.921 1.002l-2.297-2.296-2.829 2.829 2.297 2.296c-.452.74-.794 2.054-1.004 2.921h-3.246v3h3.246c.21.867.552 2.181 1.004 2.921l-2.297 2.297 2.829 2.828 2.296-2.297c.741.453 2.055.795 2.922 1.005v3.246h3v-3.246c.867-.21 2.181-.552 2.92-1.004l2.298 2.296 2.828-2.828-2.296-2.297c.452-.74.794-2.054 1.004-2.921zm-3.754-1.5c0 2.486-2.015 4.5-4.5 4.5s-4.5-2.014-4.5-4.5c0-2.485 2.015-4.5 4.5-4.5s4.5 2.015 4.5 4.5z\" stroke=\"#4c4c4c\" fill=\"none\"></path></svg></div></div></div></div><div class=\"ms ms-tab-pane ms-tab-pane_modal\" ng-class=\"{'ms-tab-pane_modal-open': $parent.accordion.show_icon[currentIcon]}\"><div class=\"ms__section ms__section_active\"><div class=\"ms__content ms-text\"><span>{{data.icons_attributes[currentIcon].name}}</span><a class=\"etsw-header__close fr\" ng-click=\"$parent.accordion.show_icon[currentIcon] = false\"><svg class=\"icon-close\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">URL</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_extra-small ms-input_border\" id=\"etn__imageWidgetInput\" type=\"text\" placeholder=\"http://\" ng-model=\"data.icons_attributes[currentIcon].url\" ng-blur=\"$root.validateLink(data.icons_attributes[currentIcon],'url')\"/></div><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__form-checkbox-blank-1\" type=\"checkbox\" ng-model=\"data.icons_attributes[currentIcon].target_blank\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-blank-1\" title=\"Открыть в новом окне\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.button.action1.blankLabel' | translate}}</span></label></div></div></div></div></div>";

/***/ }),
/* 359 */
/***/ (function(module, exports) {

module.exports = "<div class=\"input-color-wrapper\"><div class=\"input input_nano input_color ms-input_border\" minicolors=\"{opacity: true}\" ng-model=\"widget.modules_settings.style.borderColor\"></div></div>";

/***/ }),
/* 360 */
/***/ (function(module, exports) {

module.exports = "<span class=\"ms__caption\">{{'widget.form.fieldsLabel' | translate}}</span><div class=\"ms-fields-control\"></div><div ui-tree=\"treeOptions\" data-max-depth=\"1\" data-drag-delay=\"200\"><div id=\"tree-root\"><ol class=\"ms-fields-list\" ui-tree-nodes=\"\" ng-model=\"form.form_fields_attributes\"><li class=\"ms-fields-list__item\" ng-if=\"!fieldsLength(form.form_fields_attributes)\"><a class=\"link ms-fields-list__item-link\" title=\"{{'widget.form.noFieldsLabel' | translate}}\">{{'widget.form.noFieldsLabel' | translate}}</a></li><li class=\"ms-fields-list__item\" ng-repeat=\"field in form.form_fields_attributes\" ng-if=\"field.show &amp;&amp; !field._destroy\" ui-tree-node=\"\" ng-include=\"'./editor/modules_settings/subscribeFormfields/tree_renderer.jade'\"></li></ol></div></div><div class=\"ms-fields-setup\" ng-show=\"fieldsLength(form.form_fields_attributes)\"><!-- Тип поля--><!--.ms__content.ms-select--><!--  .ms__caption {{'widget.form.fieldTypeLabel' | translate}}--><!--  .ms__input-wrapper--><!--    .ms__input.ms__input_large--><!--      select.input.input_nano.ms-input_border.select__placeholder.select__placeholder_small.text-overflow(ng-options=\"type.field_type as type.title for type in inputTypes\", ng-change=\"setTitleAsType(form.form_fields_attributes[currentField].field_type)\", ng-model=\"form.form_fields_attributes[currentField].field_type\", disabled=\"\")--><div ng-show=\"form.form_fields_attributes[currentField].name == 'orderData[bill_hide_shipping_address]'\"><div class=\"ms__content\"><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__form-checkbox-checked2\" type=\"checkbox\" checked=\"\" ng-model=\"form.form_fields_attributes[currentField].checked\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-checked2\" title=\"checked\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.form.Checked' | translate}}</span></label></div></div><div class=\"ms__content ms-textarea\"><div class=\"ms__caption\">{{'widget.form.fieldDescriptionLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><textarea class=\"textarea textarea_extra-small ms-input_border\" ng-model=\"form.form_fields_attributes[currentField].placeholder\">{{'widget.form.fieldDescriptionLabel' | translate}}</textarea></div></div></div></div><div ng-show=\"!form.form_fields_attributes[currentField].controlling &amp;&amp; form.form_fields_attributes[currentField].name != 'stripe'\"><!-- Описание поля--><div class=\"ms__content ms-textarea\" ng-hide=\"form.form_fields_attributes[currentField].field_type == 'select' || form.form_fields_attributes[currentField].field_type == 'radio' || form.form_fields_attributes[currentField].field_type == 'checkbox'\"><div class=\"ms__caption\">{{'widget.form.fieldDescriptionLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><textarea class=\"textarea textarea_extra-small ms-input_border\" ng-model=\"form.form_fields_attributes[currentField].placeholder\">{{'widget.form.fieldDescriptionLabel' | translate}}</textarea></div></div></div><!-- Значение поля по умолчанию--><div class=\"ms__content ms-textarea\" ng-if=\"!form.form_fields_attributes[currentField].offert &amp;&amp; form.form_fields_attributes[currentField].name != 'lead_name' &amp;&amp; form.form_fields_attributes[currentField].name != 'lead_email' &amp;&amp; form.form_fields_attributes[currentField].name != 'lead_phone' &amp;&amp; form.form_fields_attributes[currentField].name != 'lead_middle_name' &amp;&amp; form.form_fields_attributes[currentField].name != 'lead_last_name' &amp;&amp; form.form_fields_attributes[currentField].name != 'orderData[bill_kupon]' &amp;&amp; form.form_fields_attributes[currentField].name != 'orderData[bill_billing_address]'\"><div class=\"ms__caption\">{{'widget.form.default' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><textarea class=\"textarea textarea_extra-small ms-input_border\" ng-model=\"form.form_fields_attributes[currentField].value\"></textarea></div></div></div><div class=\"ms__content\" ng-if=\"form.form_fields_attributes[currentField].field_type == 'checkbox'\"><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__form-checkbox-checked\" type=\"checkbox\" checked=\"\" ng-model=\"form.form_fields_attributes[currentField].checked\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-checked\" title=\"checked\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.form.Checked' | translate}}</span></label></div></div><!-- Поле для настройки оферты--><div class=\"ms__content\" ng-if=\"form.form_fields_attributes[currentField].offert\"><div class=\"ms__caption\">{{'widget.form.textLabel' | translate}}</div><div class=\"ms__content\"><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_extra-small ms-input_border\" type=\"text\" placeholder=\"\" ng-model=\"form.form_fields_attributes[currentField].offert_text\"/></div></div></div><div class=\"ms__caption\">{{'widget.form.linkTextLabel' | translate}}</div><div class=\"ms__content\"><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_extra-small ms-input_border\" type=\"text\" placeholder=\"\" ng-model=\"form.form_fields_attributes[currentField].offert_url_text\"/></div></div></div><div class=\"ms__caption\">{{'widget.form.linkLabel' | translate}}</div><div class=\"ms__content\"><div class=\"ms__input-wrapper\"><div class=\"radio-wrapper ms-radio radio-wrapper_inline\"><input class=\"radio\" id=\"ms__form-radio-url-type-2\" type=\"radio\" value=\"blank\" name=\"ms-target-href-action_offert\" ng-model=\"form.form_fields_attributes[currentField].link_href_target\" ng-change=\"$root.validateLink(form.form_fields_attributes[currentField], 'offert_url')\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-url-type-2\" title=\"{{'widget.button.action1.url.type2' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.button.action1.url.type2' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio radio-wrapper_inline\"><input class=\"radio\" id=\"ms__form-radio-url-type-1\" type=\"radio\" value=\"none\" name=\"ms-target-href-action_offert\" ng-model=\"form.form_fields_attributes[currentField].link_href_target\" ng-change=\"$root.validateLink(form.form_fields_attributes[currentField], 'offert_url')\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-url-type-1\" title=\"{{'widget.button.action1.url.type2' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.button.action1.url.type1' | translate}}</span></label></div></div></div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_extra-small ms-input_border\" type=\"text\" placeholder=\"http://\" ng-model=\"form.form_fields_attributes[currentField].offert_url\" ng-blur=\"$root.validateLink(form.form_fields_attributes[currentField], 'offert_url')\"/></div><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__form-checkbox-1\" type=\"checkbox\" ng-model=\"form.form_fields_attributes[currentField].offert_target_blank\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-1\" title=\"Open in New Window\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.button.action1.blankLabel' | translate}}</span></label></div></div></div><!-- Выводим опции радио кнопок и селекта--><div class=\"ms__content ms-textarea\" ng-if=\"form.form_fields_attributes[currentField].field_type == 'select' || form.form_fields_attributes[currentField].field_type == 'radio'\"><div class=\"ms__caption\">Options</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><textarea class=\"textarea textarea_extra-small ms-input_border\" placeholder=\"\" ng-model=\"form.form_fields_attributes[currentField].options_raw\" ng-disabled=\"form.form_fields_attributes[currentField].field_type == 'select' || form.form_fields_attributes[currentField].field_type == 'radio'\">Опции выбора</textarea></div></div></div><div class=\"ms__content ms-textarea\" ng-if=\"form.form_fields_attributes[currentField].field_type == 'tel'\"><!-- Проверка телефона--><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__form-checkbox-1-phone\" type=\"checkbox\" checked=\"\" ng-model=\"form.form_fields_attributes[currentField].validation\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-1-phone\" title=\"Mark a message\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.form.fieldValidationLabel' | translate}}</span></label></div></div><div class=\"ms__content ms-textarea\" ng-if=\"!form.form_fields_attributes[currentField].offert &amp;&amp; form.form_fields_attributes[currentField].name != 'orderData[bill_kupon]'\"><!-- Обязательное поле--><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__form-checkbox-1-required\" type=\"checkbox\" checked=\"\" ng-disabled=\"form.form_fields_attributes[currentField].offert\" ng-model=\"form.form_fields_attributes[currentField].required\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-1-required\" title=\"Mark a message\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.form.fieldRequiredLabel' | translate}}</span></label></div><!-- Скрыть поле, если заполнено--><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__form-checkbox-1-hidden_if_filled\" type=\"checkbox\" checked=\"\" ng-model=\"form.form_fields_attributes[currentField].hidden_if_filled\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-1-hidden_if_filled\" title=\"Mark a message\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.form.hiddenIfFilled' | translate}}</span></label></div><!-- Скрытое поле--><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__form-checkbox-1-hidden\" type=\"checkbox\" checked=\"\" ng-model=\"form.form_fields_attributes[currentField].hidden\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-1-hidden\" title=\"Mark a message\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.form.fieldHiddenLabel' | translate}}</span></label></div></div></div></div>";

/***/ }),
/* 361 */
/***/ (function(module, exports) {

module.exports = "<div class=\"tree-node\" ui-tree-handle=\"\"><div class=\"tree__icon-move tree__icon-move_fields\"><svg class=\"svg-block\" width=\"12\" height=\"12\" viewbox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"icon-block__fill\"><rect width=\"4.8\" height=\"4.8\" rx=\"1\"></rect><rect y=\"7.2\" width=\"4.8\" height=\"4.8\" rx=\"1\"></rect><rect x=\"7.2\" width=\"4.8\" height=\"4.8\" rx=\"1\"></rect><rect x=\"7.2\" y=\"7.2\" width=\"4.8\" height=\"4.8\" rx=\"1\"></rect></g></svg></div><a class=\"link ms-fields-list__item-link\" title=\"{{field.title}}\" ng-click=\"setCurrentField($index)\" ng-class=\"{'active': $parent.$parent.$parent.currentField == $index}\">{{field.title || \"No name\"}}</a><label class=\"switch\" for=\"exist_{{field.id}}\"><input class=\"switch-input\" type=\"checkbox\" id=\"exist_{{field.id}}\" ng-model=\"field.exist\" ng-disabled=\"field.disable\"/><span class=\"switch-label\" data-on=\"\" data-off=\"\" ng-disabled=\"field.disable\"></span><span class=\"switch-handle\"></span></label></div>";

/***/ }),
/* 362 */
/***/ (function(module, exports) {

module.exports = "<span class=\"ms__caption\">{{'widget.table.rowsLabel' | translate}}</span><div class=\"ms-fields-control\"><a class=\"link group-title fields-control fields-control_add fl\" ng-click=\"add()\"><svg class=\"icon__fields-control\" viewBox=\"0 0 17 17\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"icon__fill\"><rect x=\"0\" y=\"8\" width=\"17\" height=\"1\"></rect><rect x=\"8\" y=\"0\" width=\"1\" height=\"17\"></rect></g></svg></a><a class=\"link group-title fields-control fields-control_remove fl\" ng-click=\"remove()\"><svg class=\"icon__fields-control\" viewBox=\"0 0 17 17\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"icon__fill\"><rect x=\"0\" y=\"8\" width=\"17\" height=\"1\"></rect></g></svg></a></div><ul class=\"ms-fields-list\"><li class=\"ms-fields-list__item\" ng-show=\"!fieldsLength(table.items_attributes)\"><a class=\"link ms-fields-list__item-link\" title=\"Нет строк\" ng-click=\"add()\">Нет строк</a></li><li class=\"ms-fields-list__item\" ng-repeat=\"field in table.items_attributes\" ng-show=\"!field._destroy\"><a class=\"link ms-fields-list__item-link\" title=\"{{field.name}}\" ng-click=\"setCurrentImage($index)\" ng-class=\"{'active': currentField == $index}\">{{field.name || 'widget.table.rowLabel' | translate}}</a></li></ul><div class=\"ms-fields-setup\" ng-show=\"fieldsLength(table.items_attributes)\"><div class=\"ms__content ms-input\"><div class=\"ms__caption\">{{'widget.table.url' | translate}}</div><div class=\"ms__content\"><div class=\"ms__input-wrapper\"><div class=\"radio-wrapper ms-radio\" ng-show=\"Editor.mode !== 'editor.email'\"><input class=\"radio\" id=\"ms__form-radio-url-type-2\" type=\"radio\" value=\"blank\" name=\"ms-target-action1_button1\" ng-model=\"table.items_attributes[currentField].link_href_target\" ng-change=\"$root.validateLink(table.items_attributes[currentField],'href')\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-url-type-2\" title=\"{{'widget.button.action1.url.type2' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.button.action1.url.type2' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__form-radio-url-type-1\" type=\"radio\" value=\"none\" name=\"ms-target-action_button1\" ng-model=\"table.items_attributes[currentField].link_href_target\" ng-change=\"$root.validateLink(table.items_attributes[currentField],'href')\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-url-type-1\" title=\"{{'widget.button.action1.url.type2' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.button.action1.url.type1' | translate}}</span></label></div></div></div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" ng-model=\"table.items_attributes[currentField].href\" placeholder=\"http://\" ng-blur=\"$root.validateLink(table.items_attributes[currentField],'href')\"/></div></div></div><div class=\"ms__content\"><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__target\" type=\"checkbox\" checked=\"\" ng-model=\"table.items_attributes[currentField].target\"/><label class=\"checkbox-label-wrapper\" for=\"ms__target\" title=\"Mark a message\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.table.targetblank' | translate}}</span></label></div></div></div>";

/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports = "<div class=\"input-color-wrapper\"><div class=\"ms__color-wrapper\"><div class=\"input input_nano input_color ms-input_border\" minicolors=\"{opacity: true}\" ng-model=\"widget.modules_settings.style.color\"></div></div></div><label class=\"label ms__label\">Цвет</label>";

/***/ }),
/* 364 */
/***/ (function(module, exports) {

module.exports = "";

/***/ }),
/* 365 */
/***/ (function(module, exports) {

module.exports = "<input class=\"ng-hide input input_extra-small ms-input_border\" id=\"etn__imageWidgetInput\" type=\"text\" placeholder=\"http://\" ng-model=\"url\"/><label class=\"button button_add button_extra-small-upload text-overflow\" for=\"etn__imageWidget-{{timestamp}}\"><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': uploader.progress + '%' }\" ng-class=\"{'progress-line__hide': !uploader.progress}\">{{'modulesSettings.uploadingButton' | translate}}</div><span ng-if=\"backgroundId &amp;&amp; url.source_url\">{{url.source_url}}</span><span ng-if=\"sectionAttrVideoCover &amp;&amp; url.background_attributes.video_cover_url\">{{url.background_attributes.video_cover_url}}</span><span ng-if=\"!backgroundId &amp;&amp; !sectionAttrVideoCover &amp;&amp; url\">{{url}}</span><span ng-if=\"!backgroundId &amp;&amp; !sectionAttrVideoCover &amp;&amp; !url || backgroundId &amp;&amp; !url.source_url || sectionAttrVideoCover &amp;&amp; !url.background_attributes.video_cover_url\">{{'modulesSettings.uploadButton' | translate}}</span></label><input class=\"input__file-upload ng-hide\" type=\"file\" nv-file-select=\"\" id=\"etn__imageWidget-{{timestamp}}\" ng-if=\"uploader\" uploader=\"uploader\"/>";

/***/ }),
/* 366 */
/***/ (function(module, exports) {

module.exports = "<div class=\"input input_nano input_align\"><a class=\"link link_align\" ng-class=\"{'link_align_active': verticalAlign == 'top'}\" ng-click=\"verticalAlign = 'top'\"><svg width=\"16px\" height=\"13px\" viewBox=\"0 0 16 13\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon__fill\" d=\"M0 0h16v1h-16zM0 4h16v1h-16z\"></path></svg></a><a class=\"link link_align\" ng-class=\"{'link_align_active': verticalAlign == 'middle'}\" ng-click=\"verticalAlign = 'middle'\"><svg width=\"16px\" height=\"13px\" viewBox=\"0 0 16 13\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon__fill\" d=\"M0 4h16v1h-16zM0 8h16v1h-16z\"></path></svg></a><a class=\"link link_align\" ng-class=\"{'link_align_active': verticalAlign == 'bottom'}\" ng-click=\"verticalAlign = 'bottom'\"><svg width=\"16px\" height=\"13px\" viewBox=\"0 0 16 13\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon__fill\" d=\"M0 8h16v1h-16zM0 12h16v1h-16z\"></path></svg></a></div>";

/***/ }),
/* 367 */
/***/ (function(module, exports) {

module.exports = "<div class=\"ms__input ms__input_slider-range\"><div class=\"ms__range-slider\" range-slider=\"\" min=\"0\" max=\"1000\" model-max=\"widthValue\" pin-handle=\"min\"></div></div><div class=\"ms__input ms__input_range\"><div class=\"select input-range-wrapper\" str-select=\"\" select-editor=\"true\" ng-model=\"$parent.widthType\" select-replace=\"false\"><input class=\"input input_nano input_range ms-input_border\" type=\"number\" min=\"0\" ng-model=\"$parent.widthValue\"/><div class=\"ms__range\"><a class=\"link link_range-one select__placeholder select__placeholder_ms\">{{widthType}}</a></div><div class=\"select__dropdown ms-input_border select__dropdown_ms\"><div class=\"dropdown-group\"><ul><li class=\"dropdown__option dropdown__ms-option option_active\" title=\"%\" ng-click=\"optionCheck($event, '%')\">%</li><li class=\"dropdown__option dropdown__ms-option\" title=\"px\" ng-click=\"optionCheck($event, 'px')\">px</li></ul></div></div></div></div>";

/***/ }),
/* 368 */
/***/ (function(module, exports) {

module.exports = "<ui-view></ui-view>";

/***/ }),
/* 369 */
/***/ (function(module, exports) {

module.exports = "<div class=\"ms image ms-tab-pane\" ng-if=\"section.section_type == 'header'\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{'editor.panel.blockSettings.section.fixTitle' | translate}}</span><div class=\"ms__section\"><div class=\"ms__content ms-text\"><div class=\"etn__description\">{{'editor.panel.blockSettings.section.fixDescriptionLabel' | translate}}</div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption ms__caption_top\">{{'editor.panel.blockSettings.section.fixTypeLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__section-fix__type-0\" type=\"radio\" ng-change=\"saveSection(section)\" name=\"fixed_type\" value=\"none\" ng-model=\"section.fixed_type\"/><label class=\"radio-label-wrapper\" for=\"ms__section-fix__type-0\" title=\"Без фиксации\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'editor.panel.blockSettings.section.fixType1' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__section-fix__type-1\" type=\"radio\" ng-change=\"saveSection(section)\" name=\"fixed_type\" value=\"default\" ng-model=\"section.fixed_type\"/><label class=\"radio-label-wrapper\" for=\"ms__section-fix__type-1\" title=\"Обычный\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'editor.panel.blockSettings.section.fixType2' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__section-fix__type-2\" type=\"radio\" ng-change=\"saveSection(section)\" name=\"fixed_type\" value=\"after_scroll\" ng-model=\"section.fixed_type\"/><label class=\"radio-label-wrapper\" for=\"ms__section-fix__type-2\" title=\"После скролла\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'editor.panel.blockSettings.section.fixType3' | translate}}</span></label></div></div></div></div></div><div class=\"ms image ms-tab-pane\"><span class=\"ms__title ms__title_active\" ng-click=\"editorAccordion($event)\">{{'editor.panel.blockSettings.section.titleLabel' | translate}}</span><div class=\"ms__section ms__section_active\"><div class=\"ms__content ms-radio\"><div class=\"ms__caption ms__caption_top\">{{'editor.panel.blockSettings.section.sizeLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_size-width\"><div size-select-setting=\"\" size-blur=\"saveSection(section)\" ng-model=\"section.wrapper_style_attributes.maxWidth\"></div><label class=\"label ms__label\">{{'editor.panel.blockSettings.section.widthLabel' | translate}}</label></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption ms__caption_top\">{{'editor.panel.blockSettings.section.backgroundLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__section-background__type-1\" type=\"radio\" ng-change=\"saveSection(section)\" value=\"image\" name=\"ms-target-action\" ng-model=\"section.background_attributes.type\" checked=\"checked\"/><label class=\"radio-label-wrapper\" for=\"ms__section-background__type-1\" title=\"Изображение\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'editor.panel.blockSettings.section.background1' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__section-background__type-3\" type=\"radio\" ng-change=\"saveSection(section)\" value=\"video\" name=\"ms-target-action\" ng-model=\"section.background_attributes.type\"/><label class=\"radio-label-wrapper\" for=\"ms__section-background__type-3\" title=\"Видео\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'editor.panel.blockSettings.section.background2' | translate}}</span></label></div></div></div><div class=\"ms__content ms-text\" ng-if=\"section.background_attributes.type == 'image'\"><div class=\"ms__content\" bg-fields-setting=\"\" ng-model=\"section\" section-id=\"{{section.id}}\"></div></div><div class=\"ms__content ms-text\" ng-if=\"section.background_attributes.type == 'image'\"><div class=\"ms__caption\">{{'editor.panel.blockSettings.section.background1.sizeLabel' | translate}}</div><div class=\"input-wrapper ta-left\"><div class=\"select\" str-select=\"\" ng-model=\"sectionBgOption\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\"><span ng-if=\"section.style_attributes.backgroundRepeat !== 'repeat' &amp;&amp; section.style_attributes.backgroundSize !== 'cover' &amp;&amp; section.style_attributes.backgroundSize !== 'contain'\">{{'editor.panel.blockSettings.section.background1.size1' | translate}}</span><span ng-if=\"section.style_attributes.backgroundRepeat == 'repeat'\">{{'editor.panel.blockSettings.section.background1.size2' | translate}}</span><span ng-if=\"section.style_attributes.backgroundSize == 'cover'\">{{'editor.panel.blockSettings.section.background1.size3' | translate}}</span><span ng-if=\"section.style_attributes.backgroundSize == 'contain'\">{{'editor.panel.blockSettings.section.background1.size4' | translate}}</span></span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{bgOption.name_ru}}\" ng-repeat=\"bgOption in bgOptions\" ng-click=\"optionCheck($event, bgOption.name); setBgOption(bgOption.name, section)\">{{bgOption.name_ru}}</li></ul></div></perfect-scrollbar></div></div></div></div><div ng-if=\"section.background_attributes.type == 'image' &amp;&amp; section.background_attributes.images_attributes.length == 1\"><div class=\"ms__caption\">{{'editor.panel.blockSettings.section.background1.backgroundEffectLabel' | translate}}</div><div class=\"input-wrapper ta-left\"><div class=\"select\" str-select=\"\" ng-model=\"sectionBgEffect\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\"><span ng-if=\"!section.background_attributes.parallax &amp;&amp; section.style_attributes.backgroundAttachment !== 'fixed'\">{{'editor.panel.blockSettings.section.background1.backgroundEffect1' | translate}}</span><span ng-if=\"section.style_attributes.backgroundAttachment == 'fixed'\">{{'editor.panel.blockSettings.section.background1.backgroundEffect2' | translate}}</span><span ng-if=\"section.background_attributes.parallax\">{{'editor.panel.blockSettings.section.background1.backgroundEffect3' | translate}}</span></span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{bgEffect.name_ru}}\" ng-repeat=\"bgEffect in bgEffects\" ng-click=\"optionCheck($event, bgEffect.name); setBgEffect(bgEffect.name, section)\">{{bgEffect.name_ru}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"ms__content\" ng-if=\"section.background_attributes.parallax\"><div class=\"ms__caption\">{{'editor.panel.blockSettings.section.background1.backgroundEffect3SpeedLabel' | translate}}</div><div height-setting=\"\" after-change=\"saveSection(section)\" ng-model=\"section.background_attributes.parallax_speed\"></div></div></div><div class=\"video__settings\" ng-if=\"section.background_attributes.type == 'video'\"><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'editor.panel.blockSettings.section.background2' | translate}}</div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'editor.panel.blockSettings.section.background2.urlLabel1' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_extra-small ms-input_border\" type=\"text\" placeholder=\"mp4\" ng-model=\"section.background_attributes.video_mp4_url\"/></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'editor.panel.blockSettings.section.background2.urlLabel2' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_extra-small ms-input_border\" type=\"text\" placeholder=\"webm\" ng-model=\"section.background_attributes.video_webm_url\"/></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'editor.panel.blockSettings.section.background2.coverLabel' | translate}}</div><div class=\"ms__input-wrapper inline-wrapper\" uploader-setting=\"\" ng-model=\"section\" section-id=\"{{section.id}}\" uploader-setting-section-video-cover=\"true\"></div><span class=\"settings__help-icon\" tooltip-content=\"{{'editor.panel.blockSettings.section.background2.coverInfo' | translate}}\" tooltips=\"\" tooltip-side=\"left\">?</span></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'editor.panel.blockSettings.section.effectLabel' | translate}}</div><div class=\"input-wrapper ta-left\"><div class=\"select\" str-select=\"\" ng-model=\"section.animate_content_type\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{getNameContentType(section.animate_content_type) || section.animate_content_type == 'none' &&  'editor.panel.blockSettings.section.effect1' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{type}}\" ng-repeat=\"type in contentEffects\" ng-click=\"optionCheck($event, type.name); saveSection(section);\">{{type.name_ru}}</li></ul></div></perfect-scrollbar></div></div></div></div><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" after-change=\"saveSection(section)\" ng-model=\"section.style_attributes.backgroundColor\" color-bg=\"{{sectionColorBG}}\"></div></div></div><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__form-checkbox-gradient\" type=\"checkbox\" ng-change=\"saveSection(section)\" ng-model=\"section.background_attributes.gradient\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-gradient\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'editor.panel.blockSettings.section.gradientLabel' | translate}}</span></label></div><div class=\"ms__content ms-color\" ng-if=\"section.background_attributes.gradient\"><div class=\"ms__caption\">{{'editor.panel.blockSettings.section.gradientStart' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" after-change=\"saveSection(section)\" ng-model=\"section.background_attributes.color_start\"></div></div></div><div class=\"ms__content ms-color\" ng-if=\"section.background_attributes.gradient\"><div class=\"ms__caption\">{{'editor.panel.blockSettings.section.gradientEnd' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" after-change=\"saveSection(section)\" ng-model=\"section.background_attributes.color_stop\"></div></div></div><div class=\"ms__content ms-border\" border-setting=\"\" after-change=\"saveSection(section)\" ng-model=\"section.style_attributes.border\" widget-id=\"{{section.id}}\"></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.borderRadiusLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" after-change=\"saveSection(section)\" ng-model=\"section.style_attributes.borderRadius\"></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'widget.form.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" after-change=\"saveSection(section)\" ng-blur=\"save()\" ng-model=\"section.style_attributes.padding\"></div></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{\"widget.form.marginLabelPerPercent\" | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" margin-setting=\"\" after-change=\"saveSection(section)\" ng-blur=\"save()\" ng-model=\"section.style_attributes.margin\"></div></div></div></div></div><div class=\"ms ms-tab-pane\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{\"modulesSettings.shadowLabel\" | translate}}</span><div class=\"ms__section\"><div shadow-setting=\"\" after-change=\"saveSection(section)\" ng-model=\"section.style_attributes.boxShadow\"></div></div></div><div class=\"ms image ms-tab-pane\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{'editor.panel.tab5' | translate}}</span><div class=\"ms__section\"><div class=\"ms__content ms-text\" ng-hide=\"Editor.option == 'site.page.mixer' || Editor.option == 'lesson.page.mixer'\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__interactive\" type=\"checkbox\" ng-change=\"saveSection(section)\" ng-model=\"section.interactive\"/><label class=\"checkbox-label-wrapper\" for=\"ms__interactive\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'blockSettings.interactive' | translate}} &nbsp;</span><a class=\"checkbox-link\" href=\"{{'editor.settings.interactive_tutorial_link' | translate}}\" target=\"_blank\" title=\"{{'editor.tutorial.title' | translate}}\">(?)</a></label></div></div><div class=\"ms__content ms-text\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__visibility_delay\" type=\"checkbox\" ng-change=\"saveSection(section)\" ng-model=\"section.visibility_delay_enable\" ng-init=\"section.visibility_delay ? false : section.visibility_delay = 60\"/><label class=\"checkbox-label-wrapper\" for=\"ms__visibility_delay\" title=\"visibility delay\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'section.ShowDelayedWidget' | translate}}</span></label></div><div ng-show=\"section.visibility_delay_enable\"><input class=\"input input_nano input_inline ms-input_border\" type=\"number\" min=\"0\" ng-change=\"saveSection(section); $root.validateNumber(section, 'visibility_delay');\" ng-model=\"section.visibility_delay\" ng-style=\"{'width': '60px'}\" ng-show=\"section.visibility_delay_enable\"/><span>&nbsp; {{'widget.second' | translate}}</span></div></div></div></div><div class=\"ms image ms-tab-pane\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{'blockSettings.htmlcss' | translate}}</span><div class=\"ms__section\"><div class=\"ms__content ms-text\"><div class=\"ms__caption ms__caption_top\">{{'blockSettings.class' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><tags-input ng-model=\"section.additional_classes\" min-length=\"0\" max-tags=\"10\" ,=\",\" allowed-tags-pattern=\"^[A-Z|a-z|0-9|+_-]+$\"></tags-input></div></div></div></div></div><div class=\"ms image ms-tab-pane\" ng-tab-body=\"\" access=\"admin superadmin\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">Настройки (админ)</span><div class=\"ms__section\"><div class=\"ms__content ms-text\"><div class=\"ms__caption\">Изображение секции</div><div class=\"ms__input-wrapper\" uploader-setting=\"\" uploader-setting-section-preview=\"true\" ng-model=\"section.preview_url\" section-id=\"{{section.id}}\"></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">Имя секции</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_extra-small ms-input_border\" type=\"text\" ng-blur=\"saveSection(section)\" placeholder=\"Section Name\" ng-model=\"section.title\"/></div></div></div><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Теги</label><tags-input ng-model=\"section.tags\" min-length=\"{{currentUser.lang === 'ja' ? 1 : 3}}\" load-on-empty=\"true\" load-on-focus=\"true\" on-tag-added=\"saveSection(section)\" on-tag-removed=\"saveSection(section)\" replace-spaces-with-dashes=\"false\" allow-leftover-text=\"true\"></tags-input></div><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Color tags for template</label><tags-input ng-model=\"section.colors\" min-length=\"{{currentUser.lang === 'ja' ? 1 : 3}}\" load-on-empty=\"true\" load-on-focus=\"true\" on-tag-added=\"saveSection(section)\" on-tag-removed=\"saveSection(section)\" replace-spaces-with-dashes=\"false\" allow-leftover-text=\"true\"></tags-input></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">Тип секции</div><div class=\"input-wrapper ta-left\"><div class=\"select\" str-select=\"\" ng-model=\"section.section_type\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{section.section_type || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{type}}\" ng-repeat=\"type in ['default','header', 'footer']\" ng-click=\"optionCheck($event, type); saveSection(section)\">{{type}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"ms__caption\">&nbsp;</div><div class=\"ms__caption\">&nbsp;</div></div><div class=\"ms__content ms-text\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__lock-widgets\" type=\"checkbox\" ng-change=\"saveSection(section)\" ng-model=\"section.lock_widgets\"/><label class=\"checkbox-label-wrapper\" for=\"ms__lock-widgets\" title=\"Lock widgets\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Заблокировать виджеты</span></label></div></div><div class=\"ms__content ms-text\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__min-Height100\" type=\"checkbox\" ng-change=\"saveSection(section)\" ng-model=\"section.style_attributes.minHeight\" ng-true-value=\"'100vh'\" ng-false-value=\"'inherit'\"/><label class=\"checkbox-label-wrapper\" for=\"ms__min-Height100\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Высота в длинну экрана</span></label></div></div></div></div><div class=\"ms image ms-tab-pane\" ng-tab-body=\"\" access=\"admin superadmin\" ng-if=\"Editor.mode !== 'site.page.editor'\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">Шрифты</span><div class=\"ms__section\"><div class=\"et-settings-panel\" ng-controller=\"fontSettingsCtrl\" tabindex=\"3\"><div class=\"etnr-item__fonts\" ng-init=\"getGoogleFonts()\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Подключение шрифтов</label><input class=\"input input_extra-small button_border\" autocomplete=\"off\" ng-model=\"fontName\" placeholder=\"Поиск\" type=\"text\" typeahead=\"font.family for font in searchFonts($viewValue)\" typeahead-min-length=\"3\" typeahead-template-url=\"./editor/font_settings/fonts-typeahead-match.jade\" typeahead-on-select=\"setFont($item, $model, $label)\"/></div><div class=\"input-wrapper ta-left\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.selectedFont\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{selectedFont.family || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in GFonts\" ng-click=\"optionCheck($event, font); connectFont(font);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper ta-left\" ng-show=\"selectedFont.family\"><span ng-style=\"{'font-family': selectedFont.family, 'font-size': 16}\" contenteditable=\"\">Example</span></div><div class=\"input-wrapper ta-left\" ng-show=\"selectedFont.variants.length\"><label class=\"label-input\">Выберите стиль шрифта</label><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\" ng-repeat=\"variant in selectedFont.variants\"><input class=\"checkbox\" type=\"checkbox\" ng-attr-id=\"{{variant}}\" ng-model=\"fontSettings.variants[variant]\"/><label class=\"checkbox-label-wrapper\" ng-attr-for=\"{{variant}}\" title=\"Variant\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{variant}}</span></label></div></div><div class=\"input-wrapper ta-left\" ng-show=\"selectedFont.subsets.length\"><label class=\"label-input\">Выберите локализацию</label><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\" ng-repeat=\"subset in selectedFont.subsets\"><input class=\"checkbox\" type=\"checkbox\" ng-attr-id=\"{{subset}}\" ng-model=\"fontSettings.subsets[subset]\"/><label class=\"checkbox-label-wrapper\" ng-attr-for=\"{{subset}}\" title=\"Subset\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{subset}}</span></label></div></div><div class=\"ta-left input-wrapper\"><button class=\"button button_green button_middle header-menu__button\" ng-click=\"addFont(selectedFont)\" ng-disabled=\"adding || !selectedFont.family\" noloader=\"\">Добавить шрифт</button></div><div class=\"input-wrapper ta-left\" ng-if=\"sections.fonts_attributes.length\"><label class=\"label-input\">Добавленные шрифты</label><ul class=\"font-list\"><li class=\"objects-list__item\" ng-repeat=\"font in sections.fonts_attributes\"><div class=\"objects-list__item-info fl\"><span ng-style=\"{'font-family': font.family}\">{{font.family}}</span><div class=\"objects-list__item-info__subtext\"><span ng-repeat=\"variant in font.variants\">{{variant}}<span ng-if=\"!$last\">,&nbsp;</span></span><span ng-if=\"font.subsets.length\">|</span><span ng-repeat=\"subset in font.subsets\">{{subset}}<span ng-if=\"!$last\">,&nbsp;</span></span></div></div><div class=\"ms__button-remove font-remove fr\" ng-show=\"!font._destroy\"><a class=\"etn__image-remove icon-trash icon-trash_black inline-wrapper\" ng-click=\"removeFont(font)\"></a></div></li></ul></div></div></div></div></div>";

/***/ }),
/* 370 */
/***/ (function(module, exports) {

module.exports = "<div class=\"ms image ms-tab-pane\"><span class=\"ms__title ms__title_active\" ng-click=\"editorAccordion($event)\">{{'editor.siteSettings.emailTitle' | translate}}</span><div class=\"ms__section ms__section_active\"><div class=\"ms__content ms-radio\"><div class=\"ms__caption ms__caption_top\">{{'editor.panel.blockSettings.section.sizeLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_size-width\"><div size-select-setting=\"\" size-blur=\"saveSection(section)\" ng-model=\"section.wrapper_style_attributes.maxWidth\"></div><label class=\"label ms__label\">{{'editor.panel.blockSettings.section.widthLabel' | translate}}</label></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption ms__caption_top\">{{'editor.panel.blockSettings.section.backgroundLabel' | translate}}</div><div class=\"ms__content\"><div class=\"ms-fields-setup ms-fields-setup_bg\"><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'editor.panel.blockSettings.section.background1' | translate}}</div><div class=\"ms__input-wrapper\" uploader-setting=\"\" uploader-image-id=\"{{section.background_attributes.images_attributes[0].id || 'none'}}\" ng-model=\"section.background_attributes.images_attributes[0]\" background-id=\"{{section.background_attributes.id}}\" section-id=\"{{section.id}}\" from-email=\"true\" ng-if=\"refreshUploader\" upload-success=\"refreshUploaderFunc()\"></div></div><div class=\"ms__content\" ng-if=\"section.background_attributes.images_attributes[0].source_url\"><div class=\"ms__caption ms__caption_top\">{{'editor.section.previewLabel' | translate}}</div><img class=\"ms__content-image\" ng-src=\"{{section.background_attributes.images_attributes[0].source_url}}\"/></div><a class=\"link\" ng-click=\"removeEmailBg(section, section.background_attributes.images_attributes[0].id)\" ng-if=\"section.background_attributes.images_attributes[0]\">{{'widget.navigation.deleteButton' | translate}}</a></div></div><div class=\"ms__caption\">{{'editor.panel.blockSettings.section.background1.sizeLabel' | translate}}</div><div class=\"input-wrapper ta-left\"><div class=\"select\" str-select=\"\" ng-model=\"sectionBgOption\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\"><span ng-if=\"section.style_attributes.backgroundRepeat !== 'repeat' &amp;&amp; section.style_attributes.backgroundSize !== 'cover' &amp;&amp; section.style_attributes.backgroundSize !== 'contain'\">{{'editor.panel.blockSettings.section.background1.size1' | translate}}</span><span ng-if=\"section.style_attributes.backgroundRepeat == 'repeat'\">{{'editor.panel.blockSettings.section.background1.size2' | translate}}</span><span ng-if=\"section.style_attributes.backgroundSize == 'cover'\">{{'editor.panel.blockSettings.section.background1.size3' | translate}}</span><span ng-if=\"section.style_attributes.backgroundSize == 'contain'\">{{'editor.panel.blockSettings.section.background1.size4' | translate}}</span></span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{bgOption.name_ru}}\" ng-repeat=\"bgOption in bgOptions\" ng-click=\"optionCheck($event, bgOption.name); setBgOption(bgOption.name, section)\">{{bgOption.name_ru}}</li></ul></div></perfect-scrollbar></div></div></div></div><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" after-change=\"saveSection(section)\" ng-model=\"section.style_attributes.backgroundColor\" color-bg=\"{{sectionColorBG}}\"></div></div></div><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}} 2</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" after-change=\"saveSection(section)\" ng-model=\"section.wrapper_style_attributes.backgroundColor\" color-bg=\"{{sectionColorBG}}\"></div></div></div><div class=\"ms__content ms-border\" border-setting=\"\" after-change=\"saveSection(section)\" ng-model=\"section.style_attributes.border\"></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.borderRadiusLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" after-change=\"saveSection(section)\" ng-model=\"section.style_attributes.borderRadius\"></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'widget.form.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" after-change=\"saveSection(section)\" ng-blur=\"save()\" ng-model=\"section.style_attributes.padding\"></div></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{\"widget.form.marginLabelPerPercent\" | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" margin-setting=\"\" after-change=\"saveSection(section)\" ng-blur=\"save()\" ng-model=\"section.style_attributes.margin\"></div></div></div></div></div><div class=\"ms ms-tab-pane\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{\"modulesSettings.shadowLabel\" | translate}}</span><div class=\"ms__section\"><div shadow-setting=\"\" after-change=\"saveSection(section)\" ng-model=\"section.style_attributes.boxShadow\"></div></div></div><div class=\"ms image ms-tab-pane\" ng-tab-body=\"\" access=\"admin\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">Настройки (админ)</span><div class=\"ms__section\"><div class=\"ms__content ms-text\"><div class=\"ms__caption\">Изображение шаблона емэйла</div><div class=\"ms__input-wrapper\" uploader-setting=\"\" uploader-setting-email-preview=\"true\" ng-model=\"section.preview_url\" section-id=\"{{section.id}}\"></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">Имя е-мэйла</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_extra-small ms-input_border\" type=\"text\" ng-blur=\"saveSection(section)\" placeholder=\"Email Name\" ng-model=\"section.title\"/></div></div></div><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Теги</label><tags-input ng-model=\"section.tags\" min-length=\"{{currentUser.lang === 'ja' ? 1 : 3}}\" load-on-empty=\"true\" load-on-focus=\"true\" on-tag-added=\"saveSection(section)\" on-tag-removed=\"saveSection(section)\"></tags-input></div><div class=\"ms__content ms-text\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__lock-widgets\" type=\"checkbox\" ng-change=\"saveSection(section)\" ng-model=\"section.lock_widgets\"/><label class=\"checkbox-label-wrapper\" for=\"ms__lock-widgets\" title=\"Lock widgets\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Заблокировать виджеты</span></label></div></div></div></div>";

/***/ }),
/* 371 */
/***/ (function(module, exports) {

module.exports = "<div class=\"ms__section ms__section_active\"><div class=\"ms__content ms-radio\"><div class=\"ms__caption ms__caption_top\">{{'editor.panel.blockSettings.section.sizeLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_size-width\"><div size-select-setting=\"\" size-blur=\"saveSection(section)\" ng-model=\"section.wrapper_style_attributes.maxWidth\"></div><label class=\"label ms__label\">{{'editor.panel.blockSettings.section.widthLabel' | translate}}</label></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption ms__caption_top\">{{'editor.panel.blockSettings.section.backgroundLabel' | translate}}</div><div class=\"ms__content\"><div class=\"ms-fields-setup ms-fields-setup_bg\"><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'editor.panel.blockSettings.section.background1' | translate}}</div><div class=\"ms__input-wrapper\" uploader-setting=\"\" uploader-image-id=\"{{section.background_attributes.images_attributes[0].id || 'none'}}\" ng-model=\"section.background_attributes.images_attributes[0]\" background-id=\"{{section.background_attributes.id}}\" section-id=\"{{section.id}}\" from-email=\"true\" ng-if=\"refreshUploader\" upload-success=\"refreshUploaderFunc()\"></div></div><div class=\"ms__content\" ng-if=\"section.background_attributes.images_attributes[0].source_url\"><div class=\"ms__caption ms__caption_top\">{{'editor.section.previewLabel' | translate}}</div><img class=\"ms__content-image\" ng-src=\"{{section.background_attributes.images_attributes[0].source_url}}\"/></div><a class=\"link\" ng-click=\"removeEmailBg(section, section.background_attributes.images_attributes[0].id)\" ng-if=\"section.background_attributes.images_attributes[0]\">{{'widget.navigation.deleteButton' | translate}}</a></div></div><div class=\"ms__caption\">{{'editor.panel.blockSettings.section.background1.sizeLabel' | translate}}</div><div class=\"input-wrapper ta-left\"><div class=\"select\" str-select=\"\" ng-model=\"sectionBgOption\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\"><span ng-if=\"section.style_attributes.backgroundRepeat !== 'repeat' &amp;&amp; section.style_attributes.backgroundSize !== 'cover' &amp;&amp; section.style_attributes.backgroundSize !== 'contain'\">{{'editor.panel.blockSettings.section.background1.size1' | translate}}</span><span ng-if=\"section.style_attributes.backgroundRepeat == 'repeat'\">{{'editor.panel.blockSettings.section.background1.size2' | translate}}</span><span ng-if=\"section.style_attributes.backgroundSize == 'cover'\">{{'editor.panel.blockSettings.section.background1.size3' | translate}}</span><span ng-if=\"section.style_attributes.backgroundSize == 'contain'\">{{'editor.panel.blockSettings.section.background1.size4' | translate}}</span></span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{bgOption.name_ru}}\" ng-repeat=\"bgOption in bgOptions\" ng-click=\"optionCheck($event, bgOption.name); setBgOption(bgOption.name, section)\">{{bgOption.name_ru}}</li></ul></div></perfect-scrollbar></div></div></div></div><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" after-change=\"saveSection(section)\" ng-model=\"section.style_attributes.backgroundColor\" color-bg=\"{{sectionColorBG}}\"></div></div></div><div class=\"ms__content ms-border\" border-setting=\"\" after-change=\"saveSection(section)\" ng-model=\"section.style_attributes.border\"></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.borderRadiusLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" after-change=\"saveSection(section)\" ng-model=\"section.style_attributes.borderRadius\"></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'widget.form.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" after-change=\"saveSection(section)\" ng-blur=\"save()\" ng-model=\"section.style_attributes.padding\"></div></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{\"widget.form.marginLabelPerPercent\" | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" margin-setting=\"\" after-change=\"saveSection(section)\" ng-blur=\"save()\" ng-model=\"section.style_attributes.margin\"></div></div></div></div><div class=\"ms ms-tab-pane\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{\"modulesSettings.shadowLabel\" | translate}}</span><div class=\"ms__section\"><div shadow-setting=\"\" after-change=\"saveSection(section)\" ng-model=\"section.style_attributes.boxShadow\"></div></div></div>";

/***/ }),
/* 372 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"><div class=\"middle-title ta-center\">New section</div></div><form name=\"createSectionForm\" novalidate=\"\" ng-submit=\"create(createSectionForm, section)\"><div class=\"modal-body\"><div class=\"ms\"><div class=\"ms__content ms-text\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Name</label><input class=\"input input_extra-small ms-input_border\" type=\"text\" name=\"title\" required=\"\" ng-class=\"{'error':createSectionForm.title.$invalid &amp;&amp; createSectionForm.$submitted}\" str-auto-focus=\"\" placeholder=\"Section Name\" ng-model=\"section.title\"/></div></div><div class=\"ms__content ms-text\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Tags</label><tags-input ng-model=\"section.tags\" min-length=\"{{currentUser.lang === 'ja' ? 1 : 3}}\" load-on-empty=\"true\" load-on-focus=\"true\" replace-spaces-with-dashes=\"false\" allow-leftover-text=\"true\" display-property=\"name\"><auto-complete source=\"loadTags($query)\" load-on-empty=\"true\" load-on-focus=\"true\"></auto-complete></tags-input></div></div><div class=\"ms__content ms-text\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Color tags for template</label><tags-input ng-model=\"section.colors\" min-length=\"{{currentUser.lang === 'ja' ? 1 : 3}}\" load-on-empty=\"true\" load-on-focus=\"true\" replace-spaces-with-dashes=\"false\" allow-leftover-text=\"true\"><auto-complete source=\"loadColorTags($query)\" load-on-empty=\"true\" load-on-focus=\"true\"></auto-complete></tags-input></div></div><div class=\"etn__preview etn__preview_web ta-left\" ng-if=\"!section.custom_preview_url_enabled\"><div class=\"label-input\">Image section</div><input class=\"ng-hide\" id=\"etn__preview_web\" type=\"file\" nv-file-select=\"\" uploader=\"sectionPreviewUploader\"/><span class=\"file-name\">{{sectionPreviewUploader.queue[0].file.name}}</span><label for=\"etn__preview_web\"><div class=\"etn__preview-upload etn__preview-upload_web ms-input_border {{'favorite.upload_web_hint' | translate}}\"><img class=\"etn__preview-image\" ng-src=\"{{site.preview.thumb}}\" err-src=\"/constructor/editor/assets/images/image-error.svg\"/><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': sectionPreviewUploader.progress + '%' }\" ng-show=\"sectionPreviewUploader.progress\"></div></div></label></div><div class=\"input-wrapper ta-left\"><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"disablesite\" type=\"checkbox\" ng-model=\"section.custom_preview_url_enabled\"/><label class=\"checkbox-label-wrapper\" title=\"\" for=\"disablesite\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Specify a variable with a link to the image</span></label></div></div><div class=\"input-wrapper\" ng-if=\"section.custom_preview_url_enabled\"><label class=\"label-input\">Web preview variable</label><input class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.name.length}\" ng-model=\"section.custom_preview_url\" placeholder=\"Variable\" type=\"text\"/></div></div><div class=\"input-wrapper ta-left\" ng-show=\"currentUser.role == 'superadmin'\"><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"disablesite\" type=\"checkbox\" ng-model=\"section.disabled\"/><label class=\"checkbox-label-wrapper\" title=\"Hide template\" for=\"disablesite\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Hide section</span></label></div></div></div><div class=\"modal-footer ta-center\"><button class=\"button button_margin button_green button_extra-small button_modal\" ng-disabled=\"creating\">Add section</button><button class=\"button button_margin button_grayish-blue button_extra-small button_modal\" ng-click=\"close($event)\">Cancel</button></div></form>";

/***/ }),
/* 373 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"><div class=\"middle-title ta-center\">{{'favorite.SaveSectionAsTemplate' | translate}}</div></div><form name=\"editSectionForm\" novalidate=\"\" ng-submit=\"save(editSectionForm)\"><div class=\"modal-body\"><div class=\"ms\"><div class=\"ms__content ms-text\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">{{'favorite.label3' | translate}}</label><input class=\"input input_extra-small ms-input_border\" type=\"text\" name=\"title\" required=\"\" ng-class=\"{'error':editSectionForm.title.$invalid &amp;&amp; editSectionForm.$submitted}\" str-auto-focus=\"\" placeholder=\"Section Name\" ng-model=\"section.title\"/></div></div><div class=\"etn__preview etn__preview_web ta-left\"><div class=\"label-input\">{{'favorite.upload_self_preview_images' | translate}}</div><input class=\"ng-hide\" id=\"etn__preview_web\" type=\"file\" nv-file-select=\"\" uploader=\"sectionFavoriteUploader\"/><span class=\"file-name\" style=\"display: block; margin-bottom: 5px;\">{{sectionFavoriteUploader.queue[0].file.name}}</span><label for=\"etn__preview_web\"><div class=\"etn__preview-upload etn__preview-upload_web etn__preview-upload_section ms-input_border {{'favorite.upload_web_hint' | translate}}\" style=\"padding:10px;\"><img class=\"etn__preview-image\" ng-src=\"{{previewUrl}}\" err-src=\"/constructor/editor/assets/images/image-error.svg\"/><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': sectionFavoriteUploader.progress + '%' }\" ng-show=\"sectionFavoriteUploader.progress\"></div></div></label></div></div></div><div class=\"modal-footer ta-center\"><button class=\"button button_margin button_green button_extra-small button_modal\" ng-disabled=\"updating\">Save</button><button class=\"button button_margin button_grayish-blue button_extra-small button_modal\" ng-click=\"close($event)\">Cancel</button></div></form>";

/***/ }),
/* 374 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"><div class=\"middle-title ta-center\">Editing a section</div></div><form name=\"editSectionForm\" novalidate=\"\" ng-submit=\"save(editSectionForm)\"><div class=\"modal-body\"><div class=\"ms\"><div class=\"ms__content ms-text\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Name</label><input class=\"input input_extra-small ms-input_border\" type=\"text\" name=\"title\" required=\"\" ng-class=\"{'error':editSectionForm.title.$invalid &amp;&amp; editSectionForm.$submitted}\" str-auto-focus=\"\" placeholder=\"Section Name\" ng-model=\"section.title\"/></div></div><div class=\"ms__content ms-text\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Tags</label><tags-input ng-model=\"section.tags\" min-length=\"{{currentUser.lang === 'ja' ? 1 : 3}}\" load-on-empty=\"true\" load-on-focus=\"true\" replace-spaces-with-dashes=\"false\" allow-leftover-text=\"true\" display-property=\"name\"><auto-complete source=\"loadTags($query)\" load-on-empty=\"true\" load-on-focus=\"true\"></auto-complete></tags-input></div></div><div class=\"ms__content ms-text\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Color tags for template</label><tags-input ng-model=\"section.colors\" min-length=\"{{currentUser.lang === 'ja' ? 1 : 3}}\" load-on-empty=\"true\" load-on-focus=\"true\" replace-spaces-with-dashes=\"false\" allow-leftover-text=\"true\"><auto-complete source=\"loadColorTags($query)\" load-on-empty=\"true\" load-on-focus=\"true\"></auto-complete></tags-input></div></div><div class=\"etn__preview etn__preview_web ta-left\" ng-if=\"!section.custom_preview_url_enabled\"><div class=\"label-input\">Image section</div><input class=\"ng-hide\" id=\"etn__preview_web\" type=\"file\" nv-file-select=\"\" uploader=\"sectionPreviewUploader\"/><span class=\"file-name\">{{sectionPreviewUploader.queue[0].file.name}}</span><label for=\"etn__preview_web\"><div class=\"etn__preview-upload etn__preview-upload_web etn__preview-upload_section ms-input_border {{'favorite.upload_web_hint' | translate}}\"><img class=\"etn__preview-image\" ng-src=\"{{section.preview_url}}\" err-src=\"/constructor/editor/assets/images/image-error.svg\"/><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': sectionPreviewUploader.progress + '%' }\" ng-show=\"sectionPreviewUploader.progress\"></div></div></label></div><div class=\"input-wrapper ta-left\"><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"disablesite\" type=\"checkbox\" ng-model=\"section.custom_preview_url_enabled\"/><label class=\"checkbox-label-wrapper\" title=\"\" for=\"disablesite\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Specify a variable with a link to the image</span></label></div></div><div class=\"input-wrapper\" ng-if=\"section.custom_preview_url_enabled\"><label class=\"label-input\">Web preview variable</label><input class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.name.length}\" ng-model=\"section.custom_preview_url\" placeholder=\"Variable\" type=\"text\"/></div></div><div class=\"input-wrapper ta-left\" ng-show=\"currentUser.role == 'superadmin'\"><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"disablesite\" type=\"checkbox\" ng-model=\"section.disabled\"/><label class=\"checkbox-label-wrapper\" title=\"Hide template\" for=\"disablesite\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Hide section</span></label></div></div></div><div class=\"modal-footer ta-center\"><button class=\"button button_margin button_green button_extra-small button_modal\" ng-disabled=\"updating\">Save</button><button class=\"button button_margin button_grayish-blue button_extra-small button_modal\" ng-click=\"close($event)\">Cancel</button></div></form>";

/***/ }),
/* 375 */
/***/ (function(module, exports) {

module.exports = "<div class=\"etn__elements-menu\"><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockDesign'}\" ng-click=\"openTab('blockDesign')\" ng-init=\"openTab('blockDesign')\">{{'editor.panel.tab1' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockSettings'}\" ng-click=\"openTab('blockSettings')\">{{'editor.panel.tab2' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockVisibility'}\" ng-click=\"openTab('blockVisibility')\">{{'editor.panel.tab5' | translate}}</a></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockSettings'\"><div class=\"ms__section ms__section_active ms__section_visible\"><div class=\"ms__content ms-text\"><div class=\"ms__input-wrapper\" ng-show=\"widget.button_type == 'two'\" ng-init=\"currentButtonClickSettings = 'button_attributes'\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.currentButtonClickSettings\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\"><span ng-if=\"currentButtonClickSettings == 'button_attributes'\">{{'modulesSettings.button.1Label' | translate}}</span><span ng-if=\"currentButtonClickSettings == 'button_two_attributes'\">{{'modulesSettings.button.2Label' | translate}}</span><span ng-if=\"currentButtonClickSettings !== 'button_two_attributes' &amp;&amp; currentButtonClickSettings !== 'button_attributes'\">{{'editor.selectDefaultOption' | translate}}</span></span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{'modulesSettings.button.1Label' | translate}}\" ng-click=\"optionCheck($event, &quot;button_attributes&quot;);\">{{'modulesSettings.button.1Label' | translate}}</li><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{'modulesSettings.button.2Label' | translate}}\" ng-click=\"optionCheck($event, &quot;button_two_attributes&quot;);\">{{'modulesSettings.button.2Label' | translate}}</li></ul></div></perfect-scrollbar></div></div></div></div></div></div><div button-actions=\"\" ng-model=\"widget\" ng-show=\"editCurrentTab == 'blockSettings' &amp;&amp; currentButtonClickSettings == 'button_attributes'\" button-property=\"button_attributes\" form-property=\"button_form_attributes\"></div><div button-actions=\"\" ng-model=\"widget\" ng-show=\"editCurrentTab == 'blockSettings' &amp;&amp; currentButtonClickSettings == 'button_two_attributes'\" button-property=\"button_two_attributes\" form-property=\"button_two_form_attributes\"></div><!-- blockDesign--><div class=\"ms ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"accordion = {show_fast_settings: !accordion.show_fast_settings}\" ng-class=\"{'ms__title_active': accordion.show_fast_settings}\">{{'editor.panel.tab3' | translate}}</span><div class=\"ms__section\" ng-class=\"{'ms__section_active': accordion.show_fast_settings}\"><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}:</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"widget.style_attributes.backgroundColor\"></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'modulesSettings.button.buttonStyle' | translate}}:</div><div class=\"input-wrapper\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.button_type\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\"><span ng-if=\"widget.button_type == 'one'\">{{'modulesSettings.button.buttonStyle1' | translate}}</span><span ng-if=\"widget.button_type == 'two'\">{{'modulesSettings.button.buttonStyle2' | translate}}</span><span ng-if=\"widget.button_type !== 'two' &amp;&amp; widget.button_type !== 'one'\">{{'editor.selectDefaultOption' | translate}}</span></span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{'modulesSettings.button.buttonStyle1' | translate}}\" ng-click=\"optionCheck($event, &quot;one&quot;);\">{{'modulesSettings.button.buttonStyle1' | translate}}</li><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{'modulesSettings.button.buttonStyle2' | translate}}\" ng-click=\"optionCheck($event, &quot;two&quot;);\">{{'modulesSettings.button.buttonStyle2' | translate}}</li></ul></div></perfect-scrollbar></div></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\" ng-show=\"widget.button_type == 'two'\">{{'modulesSettings.button.chooseColor' | translate}}</div><div class=\"ms__caption\" ng-show=\"widget.button_type == 'one'\">{{'widget.card.element5color' | translate}}</div><div class=\"ms__input-wrapper\" colors-setting=\"\" set-attributes=\"backgroundColor\" ng-model=\"widget.button_attributes.style_attributes\"></div></div><div class=\"ms__content ms-text\" ng-show=\"widget.button_type == 'two'\"><div class=\"ms__caption\">{{'modulesSettings.button.chooseColor2' | translate}}:</div><div class=\"ms__input-wrapper\" colors-setting=\"\" set-attributes=\"backgroundColor\" ng-model=\"widget.button_two_attributes.style_attributes\"></div></div><div class=\"ms__content ms-align\"><div class=\"ms__caption\">{{'modulesSettings.textAlignLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" aligment-setting=\"\" ng-model=\"widget.style_attributes.textAlign\"></div></div></div><div class=\"ms__content ms-radio\"><div class=\"ms__caption ms__caption_top\">{{'modulesSettings.buttonSize' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__size1\" type=\"radio\" name=\"ms-target-action\" ng-checked=\"widget.button_attributes.style_attributes.padding == '11px 48px 11px 48px'\" ng-click=\"setButtonSize(widget.button_attributes.style_attributes, widget.button_two_attributes.style_attributes, 'small')\"/><label class=\"radio-label-wrapper\" for=\"ms__size1\" title=\"Маленький\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'modulesSettings.buttonSize1' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__size2\" type=\"radio\" name=\"ms-target-action\" ng-checked=\"widget.button_attributes.style_attributes.padding == '17px 58px 17px 58px'\" ng-click=\"setButtonSize(widget.button_attributes.style_attributes, widget.button_two_attributes.style_attributes, 'medium')\"/><label class=\"radio-label-wrapper\" for=\"ms__size2\" title=\"Средний\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'modulesSettings.buttonSize2' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__size3\" type=\"radio\" name=\"ms-target-action\" ng-checked=\"widget.button_attributes.style_attributes.padding == '21px 67px 21px 67px'\" ng-click=\"setButtonSize(widget.button_attributes.style_attributes, widget.button_two_attributes.style_attributes, 'big')\"/><label class=\"radio-label-wrapper\" for=\"ms__size3\" title=\"Большой\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'modulesSettings.buttonSize3' | translate}}</span></label></div></div></div><div class=\"ms__content\" themes-setting=\"\" ng-model=\"widget\" widget-id=\"{{widget.id}}\"></div></div></div><!-- blockDesign--><div class=\"ms ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"accordion = {show_additional_settings: !accordion.show_additional_settings};\" ng-class=\"{'ms__title_active': accordion.show_additional_settings}\">{{'widget.navigation.additionalLabel' | translate}}</span><div class=\"ms__section ms__section_visible\" ng-class=\"{'ms__section_active': accordion.show_additional_settings}\"><div class=\"ms__content ms-text\"><div class=\"ms__input-wrapper\" ng-show=\"widget.button_type == 'two'\" ng-init=\"currentButtonSettings = 'button_attributes'\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.currentButtonSettings\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\"><span ng-if=\"currentButtonSettings == 'button_attributes'\">{{'modulesSettings.button.1Label' | translate}}</span><span ng-if=\"currentButtonSettings == 'button_two_attributes'\">{{'modulesSettings.button.2Label' | translate}}</span><span ng-if=\"currentButtonSettings !== 'button_two_attributes' &amp;&amp; currentButtonSettings !== 'button_attributes'\">{{'editor.selectDefaultOption' | translate}}</span></span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{'modulesSettings.button.1Label' | translate}}\" ng-click=\"optionCheck($event, &quot;button_attributes&quot;);\">{{'modulesSettings.button.1Label' | translate}}</li><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{'modulesSettings.button.2Label' | translate}}\" ng-click=\"optionCheck($event, &quot;button_two_attributes&quot;);\">{{'modulesSettings.button.2Label' | translate}}</li></ul></div></perfect-scrollbar></div></div></div></div><div class=\"header-menu__nav\"><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': currentDesignTab == 'button'}\" ng-click=\"setDesignTab('button')\" ng-init=\"setDesignTab('button')\">{{'widget.card.buttonSettingsTab1' | translate}}</a><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': currentDesignTab == 'text'}\" ng-click=\"setDesignTab('text')\">{{'widget.card.buttonSettingsTab2' | translate}}</a><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': currentDesignTab == 'paddings'}\" ng-click=\"setDesignTab('paddings')\">{{'widget.card.buttonSettingsTab3' | translate}}</a></div><p>&nbsp;</p><div ng-if=\"currentButtonSettings == 'button_attributes'\"><div ng-if=\"currentDesignTab == 'button'\"><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.button.colorLabel' | translate}}:</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"widget.button_attributes.style_attributes.backgroundColor\"></div></div></div><div class=\"ms__content ms-color\" gradient-setting=\"\" ng-model=\"widget.button_attributes.style_attributes\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-border\" border-setting=\"\" ng-model=\"widget.button_attributes.style_attributes.border\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.borderRadiusLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" ng-model=\"widget.button_attributes.style_attributes.borderRadius\"></div></div></div><div ng-if=\"currentDesignTab == 'text'\"><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'modulesSettings.textColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_slider-range\"><div color-setting=\"\" ng-model=\"widget.button_attributes.style_attributes.color\"></div><label class=\"label ms__label\">{{'modulesSettings.colorLabel' | translate}}</label></div><div class=\"ms__input ms__input_range\" size-setting=\"\" ng-model=\"widget.button_attributes.style_attributes.fontSize\"></div></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.fontLabel' | translate}}</div><div class=\"input-wrapper inline-wrapper ms__input_half ms__input_half-margin\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.button_attributes.style_attributes.fontFamily\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.button_attributes.style_attributes.fontFamily || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in Editor.Instrumentations.fonts\" ng-click=\"optionCheck($event, font.family);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper inline-wrapper ms__input_half\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.button_attributes.style_attributes.fontWeight\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.button_attributes.style_attributes.fontWeight || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{weight}}\" ng-repeat=\"weight in ['normal', 'bold', 'bolder', 'lighter']\" ng-click=\"optionCheck($event, weight);\">{{weight}}</li></ul></div></perfect-scrollbar></div></div><label class=\"label ms__label\">{{'modulesSettings.fontWeightLabel' | translate}}</label></div></div><div class=\"ms__content\" ng-hide=\"Editor.option == 'site.page.mixer' || Editor.option == 'lesson.page.mixer' || Editor.mode == 'email.page.editor'\"><div class=\"ms__caption\">{{'modulesSettings.icon' | translate}}</div><div icon-selector-setting=\"\" ng-model=\"widget.button_attributes.icon\"></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.additionalText' | translate}}</div><div class=\"ms__input ms__input_large\"><input class=\"input input_extra-small ms-input_border\" type=\"text\" placeholder=\"\" ng-model=\"widget.button_attributes.additional_text.title\"/></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'modulesSettings.textColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_slider-range\"><div color-setting=\"\" ng-model=\"widget.button_attributes.additional_text.color\"></div><label class=\"label ms__label\">{{'modulesSettings.colorLabel' | translate}}</label></div><div class=\"ms__input ms__input_range\" size-setting=\"\" ng-model=\"widget.button_attributes.additional_text.fontSize\"></div></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.fontLabel' | translate}}</div><div class=\"input-wrapper inline-wrapper ms__input_half ms__input_half-margin\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.button_attributes.additional_text.fontFamily\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.button_attributes.additional_text.fontFamily || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in Editor.Instrumentations.fonts\" ng-click=\"optionCheck($event, font.family);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper inline-wrapper ms__input_half\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.button_attributes.additional_text.fontWeight\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.button_attributes.additional_text.fontWeight || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{weight}}\" ng-repeat=\"weight in ['normal', 'bold', 'bolder', 'lighter']\" ng-click=\"optionCheck($event, weight);\">{{weight}}</li></ul></div></perfect-scrollbar></div></div><label class=\"label ms__label\">{{'modulesSettings.fontWeightLabel' | translate}}</label></div></div></div><div ng-if=\"currentDesignTab == 'paddings'\"><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.button_attributes.style_attributes.padding\"></div></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.marginLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.button_attributes.style_attributes.margin\"></div></div></div></div></div><div ng-if=\"currentButtonSettings == 'button_two_attributes'\"><div ng-if=\"currentDesignTab == 'button'\"><div class=\"ms__content ms-color\"><div class=\"ms__caption\">Цвет кнопки:</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"widget.button_two_attributes.style_attributes.backgroundColor\"></div></div></div><div class=\"ms__content ms-color\" gradient-setting=\"\" ng-model=\"widget.button_two_attributes.style_attributes\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-border\" border-setting=\"\" ng-model=\"widget.button_two_attributes.style_attributes.border\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.borderRadiusLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" ng-model=\"widget.button_two_attributes.style_attributes.borderRadius\"></div></div></div><div ng-if=\"currentDesignTab == 'text'\"><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'modulesSettings.textColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_slider-range\"><div color-setting=\"\" ng-model=\"widget.button_two_attributes.style_attributes.color\"></div><label class=\"label ms__label\">{{'modulesSettings.colorLabel' | translate}}</label></div><div class=\"ms__input ms__input_range\" size-setting=\"\" ng-model=\"widget.button_two_attributes.style_attributes.fontSize\"></div></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.fontLabel' | translate}}</div><div class=\"input-wrapper inline-wrapper ms__input_half ms__input_half-margin\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.button_two_attributes.style_attributes.fontFamily\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.button_two_attributes.style_attributes.fontFamily || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in Editor.Instrumentations.fonts\" ng-click=\"optionCheck($event, font.family);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper inline-wrapper ms__input_half\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.button_two_attributes.style_attributes.fontWeight\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.button_two_attributes.style_attributes.fontWeight || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{weight}}\" ng-repeat=\"weight in ['normal', 'bold', 'bolder', 'lighter']\" ng-click=\"optionCheck($event, weight);\">{{weight}}</li></ul></div></perfect-scrollbar></div></div><label class=\"label ms__label\">{{'modulesSettings.fontWeightLabel' | translate}}</label></div></div><div class=\"ms__content\" ng-hide=\"Editor.option == 'site.page.mixer' || Editor.option == 'lesson.page.mixer' || Editor.mode == 'email.page.editor'\"><div class=\"ms__caption\">{{'modulesSettings.icon' | translate}}</div><div icon-selector-setting=\"\" ng-model=\"widget.button_two_attributes.icon\"></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.additionalText' | translate}}</div><div class=\"ms__input ms__input_large\"><input class=\"input input_extra-small ms-input_border\" type=\"text\" placeholder=\"\" ng-model=\"widget.button_two_attributes.additional_text.title\"/></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'modulesSettings.textColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_slider-range\"><div color-setting=\"\" ng-model=\"widget.button_two_attributes.additional_text.color\"></div><label class=\"label ms__label\">{{'modulesSettings.colorLabel' | translate}}</label></div><div class=\"ms__input ms__input_range\" size-setting=\"\" ng-model=\"widget.button_two_attributes.additional_text.fontSize\"></div></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.fontLabel' | translate}}</div><div class=\"input-wrapper inline-wrapper ms__input_half ms__input_half-margin\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.button_two_attributes.additional_text.fontFamily\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.button_two_attributes.additional_text.fontFamily || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in Editor.Instrumentations.fonts\" ng-click=\"optionCheck($event, font.family);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper inline-wrapper ms__input_half\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.button_two_attributes.additional_text.fontWeight\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.button_two_attributes.additional_text.fontWeight || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{weight}}\" ng-repeat=\"weight in ['normal', 'bold', 'bolder', 'lighter']\" ng-click=\"optionCheck($event, weight);\">{{weight}}</li></ul></div></perfect-scrollbar></div></div><label class=\"label ms__label\">{{'modulesSettings.fontWeightLabel' | translate}}</label></div></div></div><div ng-if=\"currentDesignTab == 'paddings'\"><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.button_two_attributes.style_attributes.padding\"></div></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.marginLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.button_two_attributes.style_attributes.margin\"></div></div></div></div></div></div></div><!-- blockDesign--><div class=\"ms ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"accordion = {show_hover_settings: !accordion.show_hover_settings}\" ng-class=\"{'ms__title_active': accordion.show_hover_settings}\">{{'modulesSettings.hoverLabel' | translate}}</span><div class=\"ms__section\" ng-class=\"{'ms__section_active': accordion.show_hover_settings}\" hover-setting=\"\" ng-model=\"widget\" access-key=\"hover_style_attributes\"></div></div><!-- blockDesign--><div class=\"ms image ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{'blockSettings.htmlcss' | translate}}</span><div class=\"ms__section\"><div class=\"ms__content ms-text\"><div class=\"ms__caption ms__caption_top\">{{'blockSettings.class' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><tags-input ng-model=\"widget.additional_classes\" min-length=\"0\" max-tags=\"10\" ,=\",\" allowed-tags-pattern=\"^[A-Z|a-z|0-9|+_-]+$\"></tags-input></div></div></div></div></div><!-- blockVisibility--><div class=\"ms ms-tab-pane\" ng-if=\"editCurrentTab == 'blockVisibility'\"><div class=\"ms__section ms__section_active ms__section_visible\"><div class=\"ms__content ms-text\" ng-hide=\"Editor.option == 'site.page.mixer' || Editor.option == 'lesson.page.mixer' || Editor.mode == 'email.page.editor'\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__interactive\" type=\"checkbox\" ng-model=\"widget.interactive\"/><label class=\"checkbox-label-wrapper\" for=\"ms__interactive\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'blockSettings.interactive' | translate}} &nbsp;</span><a class=\"checkbox-link\" href=\"{{'editor.settings.interactive_tutorial_link' | translate}}\" target=\"_blank\" title=\"{{'editor.tutorial.title' | translate}}\">(?)</a></label></div></div><div class=\"ms__content ms-text\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__visibility_delay\" type=\"checkbox\" ng-model=\"widget.visibility_delay_enable\" ng-init=\"widget.visibility_delay ? false : widget.visibility_delay = 60\"/><label class=\"checkbox-label-wrapper\" for=\"ms__visibility_delay\" title=\"visibility delay\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.ShowDelayedWidget' | translate}}</span></label></div><div ng-show=\"widget.visibility_delay_enable\"><input class=\"input input_nano input_inline ms-input_border\" ng-change=\"$root.validateNumber(widget, 'visibility_delay')\" type=\"number\" min=\"0\" ng-style=\"{'width': '60px'}\" ng-model=\"widget.visibility_delay\"/><span>&nbsp; {{'widget.second' | translate}}</span></div></div></div></div>";

/***/ }),
/* 376 */
/***/ (function(module, exports) {

module.exports = "<div card-setting=\"\" ng-model=\"widget\" widget-id=\"{{widget.id}}\"><div class=\"etn__elements-menu\"><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockDesign'}\" ng-click=\"openTab('blockDesign')\" ng-init=\"openTab('blockDesign')\">{{'editor.panel.tab1' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockSettings'}\" ng-click=\"openTab('blockSettings')\">{{'editor.panel.tab2' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockVisibility'}\" ng-click=\"openTab('blockVisibility')\">{{'editor.panel.tab5' | translate}}</a></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockDesign'\" ng-init=\"accordion.show_fast_settings = true\"><span class=\"ms__title\" ng-click=\"accordion = {show_fast_settings: !accordion.show_fast_settings}\" ng-class=\"{'ms__title_active': accordion.show_fast_settings}\">{{'editor.panel.tab3' | translate}}</span><div class=\"ms__section_nopadding\" ng-show=\"accordion.show_fast_settings\"><div class=\"ms__content\"><div class=\"checkbox-wrapper_list-title\"><div class=\"ms__caption\">{{'widget.card.elementsLabel' | translate}}:</div></div><div class=\"checkbox-wrapper_list-item\"><input class=\"checkbox\" id=\"ms__card1-1\" type=\"checkbox\" ng-model=\"widget.show_image\"/><label class=\"checkbox-label-wrapper\" for=\"ms__card1\" ng-click=\"accordion.show_image_settings = true; setDesignTab('image')\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.card.element1' | translate}}</span></label><svg class=\"card-settings__icon\" width=\"16\" height=\"16\" viewbox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" ng-click=\"accordion.show_image_settings = true; setDesignTab('image')\"><path d=\"M20.254 13.5h3.246v-3h-3.247c-.209-.867-.551-2.181-1.003-2.922l2.296-2.295-2.829-2.829-2.297 2.296c-.74-.452-2.053-.793-2.92-1.002v-3.248h-3v3.248c-.867.209-2.181.55-2.921 1.002l-2.297-2.296-2.829 2.829 2.297 2.296c-.452.74-.794 2.054-1.004 2.921h-3.246v3h3.246c.21.867.552 2.181 1.004 2.921l-2.297 2.297 2.829 2.828 2.296-2.297c.741.453 2.055.795 2.922 1.005v3.246h3v-3.246c.867-.21 2.181-.552 2.92-1.004l2.298 2.296 2.828-2.828-2.296-2.297c.452-.74.794-2.054 1.004-2.921zm-3.754-1.5c0 2.486-2.015 4.5-4.5 4.5s-4.5-2.014-4.5-4.5c0-2.485 2.015-4.5 4.5-4.5s4.5 2.015 4.5 4.5z\" stroke=\"#4c4c4c\" fill=\"none\"></path></svg></div><div class=\"checkbox-wrapper_list-item\"><input class=\"checkbox\" id=\"ms__card1-2\" type=\"checkbox\" ng-model=\"widget.show_title\"/><label class=\"checkbox-label-wrapper\" for=\"ms__card2\" ng-click=\"accordion.show_title_settings = true\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.card.element2' | translate}}</span></label><svg class=\"card-settings__icon\" width=\"16\" height=\"16\" viewbox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" ng-click=\"accordion.show_title_settings = true\"><path d=\"M20.254 13.5h3.246v-3h-3.247c-.209-.867-.551-2.181-1.003-2.922l2.296-2.295-2.829-2.829-2.297 2.296c-.74-.452-2.053-.793-2.92-1.002v-3.248h-3v3.248c-.867.209-2.181.55-2.921 1.002l-2.297-2.296-2.829 2.829 2.297 2.296c-.452.74-.794 2.054-1.004 2.921h-3.246v3h3.246c.21.867.552 2.181 1.004 2.921l-2.297 2.297 2.829 2.828 2.296-2.297c.741.453 2.055.795 2.922 1.005v3.246h3v-3.246c.867-.21 2.181-.552 2.92-1.004l2.298 2.296 2.828-2.828-2.296-2.297c.452-.74.794-2.054 1.004-2.921zm-3.754-1.5c0 2.486-2.015 4.5-4.5 4.5s-4.5-2.014-4.5-4.5c0-2.485 2.015-4.5 4.5-4.5s4.5 2.015 4.5 4.5z\" stroke=\"#4c4c4c\" fill=\"none\"></path></svg></div><div class=\"checkbox-wrapper_list-item\"><input class=\"checkbox\" id=\"ms__card1-3\" type=\"checkbox\" ng-model=\"widget.show_price\"/><label class=\"checkbox-label-wrapper\" for=\"ms__card3\" ng-click=\"accordion.show_price_settings = true\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.card.element3' | translate}}</span></label><svg class=\"card-settings__icon\" width=\"16\" height=\"16\" viewbox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" ng-click=\"accordion.show_price_settings = true\"><path d=\"M20.254 13.5h3.246v-3h-3.247c-.209-.867-.551-2.181-1.003-2.922l2.296-2.295-2.829-2.829-2.297 2.296c-.74-.452-2.053-.793-2.92-1.002v-3.248h-3v3.248c-.867.209-2.181.55-2.921 1.002l-2.297-2.296-2.829 2.829 2.297 2.296c-.452.74-.794 2.054-1.004 2.921h-3.246v3h3.246c.21.867.552 2.181 1.004 2.921l-2.297 2.297 2.829 2.828 2.296-2.297c.741.453 2.055.795 2.922 1.005v3.246h3v-3.246c.867-.21 2.181-.552 2.92-1.004l2.298 2.296 2.828-2.828-2.296-2.297c.452-.74.794-2.054 1.004-2.921zm-3.754-1.5c0 2.486-2.015 4.5-4.5 4.5s-4.5-2.014-4.5-4.5c0-2.485 2.015-4.5 4.5-4.5s4.5 2.015 4.5 4.5z\" stroke=\"#4c4c4c\" fill=\"none\"></path></svg></div><div class=\"checkbox-wrapper_list-item\"><input class=\"checkbox\" id=\"ms__card1-4\" type=\"checkbox\" ng-model=\"widget.show_description\"/><label class=\"checkbox-label-wrapper\" for=\"ms__card4\" ng-click=\"accordion.show_description_settings = true\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.card.element4' | translate}}</span></label><svg class=\"card-settings__icon\" width=\"16\" height=\"16\" viewbox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" ng-click=\"accordion.show_description_settings = true\"><path d=\"M20.254 13.5h3.246v-3h-3.247c-.209-.867-.551-2.181-1.003-2.922l2.296-2.295-2.829-2.829-2.297 2.296c-.74-.452-2.053-.793-2.92-1.002v-3.248h-3v3.248c-.867.209-2.181.55-2.921 1.002l-2.297-2.296-2.829 2.829 2.297 2.296c-.452.74-.794 2.054-1.004 2.921h-3.246v3h3.246c.21.867.552 2.181 1.004 2.921l-2.297 2.297 2.829 2.828 2.296-2.297c.741.453 2.055.795 2.922 1.005v3.246h3v-3.246c.867-.21 2.181-.552 2.92-1.004l2.298 2.296 2.828-2.828-2.296-2.297c.452-.74.794-2.054 1.004-2.921zm-3.754-1.5c0 2.486-2.015 4.5-4.5 4.5s-4.5-2.014-4.5-4.5c0-2.485 2.015-4.5 4.5-4.5s4.5 2.015 4.5 4.5z\" stroke=\"#4c4c4c\" fill=\"none\"></path></svg></div><div class=\"checkbox-wrapper_list-item\"><input class=\"checkbox\" id=\"ms__card1-5\" type=\"checkbox\" ng-model=\"widget.show_button\"/><label class=\"checkbox-label-wrapper\" for=\"ms__card5\" ng-click=\"accordion.show_button_settings = true; setDesignTab('card_button_settings')\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.card.element5' | translate}}</span></label><svg class=\"card-settings__icon\" width=\"16\" height=\"16\" viewbox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" ng-click=\"accordion.show_button_settings = true; setDesignTab('card_button_settings')\"><path d=\"M20.254 13.5h3.246v-3h-3.247c-.209-.867-.551-2.181-1.003-2.922l2.296-2.295-2.829-2.829-2.297 2.296c-.74-.452-2.053-.793-2.92-1.002v-3.248h-3v3.248c-.867.209-2.181.55-2.921 1.002l-2.297-2.296-2.829 2.829 2.297 2.296c-.452.74-.794 2.054-1.004 2.921h-3.246v3h3.246c.21.867.552 2.181 1.004 2.921l-2.297 2.297 2.829 2.828 2.296-2.297c.741.453 2.055.795 2.922 1.005v3.246h3v-3.246c.867-.21 2.181-.552 2.92-1.004l2.298 2.296 2.828-2.828-2.296-2.297c.452-.74.794-2.054 1.004-2.921zm-3.754-1.5c0 2.486-2.015 4.5-4.5 4.5s-4.5-2.014-4.5-4.5c0-2.485 2.015-4.5 4.5-4.5s4.5 2.015 4.5 4.5z\" stroke=\"#4c4c4c\" fill=\"none\"></path></svg></div></div></div><div class=\"ms__section\" ng-show=\"widget.show_button\" ng-class=\"{'ms__section_active': accordion.show_fast_settings}\"><div class=\"ms__caption\">{{'widget.card.element5color' | translate}}:</div><div class=\"ms__content ms-text\" colors-setting=\"\" set-attributes=\"backgroundColor\" ng-model=\"widget.button_attributes.style_attributes\"></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-class=\"{'ms__title_active': accordion.show_card_additional}\"><div class=\"ms__title-name\" ng-click=\"accordion = {show_card_additional: !accordion.show_card_additional}\">{{'widget.card.additionalLabel' | translate}}</div></span><div class=\"ms__section\" ng-class=\"{'ms__section_active': accordion.show_card_additional}\" ng-if=\"accordion.show_card_additional\"><div class=\"header-menu__nav\" ng-init=\"setDesignTab('card_additional_tab1')\"><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': currentDesignTab == 'card_additional_tab1'}\" ng-click=\"setDesignTab('card_additional_tab1')\">{{'widget.card.element5tab1' | translate}}</a><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': currentDesignTab == 'card_additional_tab2'}\" ng-click=\"setDesignTab('card_additional_tab2')\">{{'widget.card.element5tab2' | translate}}</a></div><p>&nbsp;</p><div ng-show=\"currentDesignTab == 'card_additional_tab1'\"><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"widget.wrapper_style.backgroundColor\"></div></div></div><div class=\"ms__content ms-border\" border-setting=\"\" ng-model=\"widget.wrapper_style.border\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.borderRadiusLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" ng-model=\"widget.wrapper_style.borderRadius\"></div></div></div><div ng-show=\"currentDesignTab == 'card_additional_tab2'\"><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.wrapper_style.padding\"></div></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.marginLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.wrapper_style.margin\"></div></div></div></div></div></div><div class=\"ms ms-tab-pane ms-tab-pane_modal\" ng-show=\"editCurrentTab == 'blockDesign'\" ng-class=\"{'ms-tab-pane_modal-open': accordion.show_image_settings}\"><div class=\"ms__section ms__section_active\"><div class=\"ms__content ms-text\"><span>{{'widget.card.imageSettingsLabel' | translate}}</span><a class=\"etsw-header__close fr\" ng-click=\"accordion.show_image_settings = false\"><svg class=\"icon-close\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a></div><div class=\"header-menu__nav\"><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': currentDesignTab == 'image'}\" ng-click=\"setDesignTab('image')\">{{'widget.card.imageSettingsTab1' | translate}}</a><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': currentDesignTab == 'borders'}\" ng-click=\"setDesignTab('borders')\">{{'widget.card.imageSettingsTab2' | translate}}</a><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': currentDesignTab == 'paddings'}\" ng-click=\"setDesignTab('paddings')\">{{'widget.card.imageSettingsTab3' | translate}}</a></div><div ng-show=\"currentDesignTab == 'image'\"><p>&nbsp;</p><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.card.imageSettingsUpload' | translate}}:</div><div class=\"ms__input-wrapper\" uploader-setting=\"\" ng-model=\"widget.image_attributes.source_url\" widget-id=\"{{widget.id}}\"></div></div><div class=\"ms__content ms-text\" photo-library=\"\" ng-model=\"widget\" access-key=\"image_attributes\" current-key=\"source_url\" remote-key=\"remote_source_url\"></div><div class=\"ms__content ms-text\"><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input-large\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__form-checkbox-10\" type=\"checkbox\" checked=\"\" ng-model=\"widget.image_attributes.stretch\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-10\" title=\"Mark a message\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.image.stratch' | translate}}</span></label></div></div></div></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.height' | translate}}</div><div class=\"ms__input-wrapper\" slidersize-setting=\"\" ng-model=\"widget.image_wrapper_height\"></div></div></div><div ng-show=\"currentDesignTab == 'borders'\"><p>&nbsp;</p><div class=\"ms__content ms-border\" border-setting=\"\" ng-model=\"widget.image_style.border\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.borderRadiusLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" ng-model=\"widget.image_style.borderRadius\"></div></div></div><div ng-show=\"currentDesignTab == 'paddings'\"><p>&nbsp;</p><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.image_style.padding\"></div></div></div></div></div></div><div class=\"ms ms-tab-pane ms-tab-pane_modal\" ng-show=\"editCurrentTab == 'blockDesign'\" ng-class=\"{'ms-tab-pane_modal-open': accordion.show_title_settings}\"><div class=\"ms__section ms__section_active ms__section_visible\"><div class=\"ms__content ms-text\"><span>{{'widget.card.titleSettingsLabel' | translate}}</span><a class=\"etsw-header__close fr\" ng-click=\"accordion.show_title_settings = false\"><svg class=\"icon-close\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'modulesSettings.textLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_slider-range\"><div color-setting=\"\" ng-model=\"widget.title_style.color\"></div><label class=\"label ms__label\">{{'modulesSettings.colorLabel' | translate}}</label></div><div class=\"ms__input ms__input_range\" size-setting=\"\" ng-model=\"widget.title_style.fontSize\"></div></div></div><div class=\"ms__content ms-align\"><div class=\"ms__caption\">{{'modulesSettings.textAlignLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" aligment-setting=\"\" ng-model=\"widget.title_style.textAlign\"></div></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.fontLabel' | translate}}</div><div class=\"input-wrapper inline-wrapper ms__input_half ms__input_half-margin\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.title_style.fontFamily\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.title_style.fontFamily || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in Editor.Instrumentations.fonts\" ng-click=\"optionCheck($event, font.family);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper inline-wrapper ms__input_half\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.title_style.fontWeight\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.title_style.fontWeight || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{weight}}\" ng-repeat=\"weight in ['normal', 'bold', 'bolder', 'lighter']\" ng-click=\"optionCheck($event, weight);\">{{weight}}</li></ul></div></perfect-scrollbar></div></div><label class=\"label ms__label\">{{'modulesSettings.fontWeightLabel' | translate}}</label></div></div><hr class=\"ms__separator\"/><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.marginLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.title_style.margin\"></div></div></div></div></div><div class=\"ms ms-tab-pane ms-tab-pane_modal\" ng-show=\"editCurrentTab == 'blockDesign'\" ng-class=\"{'ms-tab-pane_modal-open': accordion.show_price_settings}\"><div class=\"ms__section ms__section_active ms__section_visible\"><div class=\"ms__content ms-text\"><span>{{'widget.card.subtitleSettingsLabel' | translate}}</span><a class=\"etsw-header__close fr\" ng-click=\"accordion.show_price_settings = false\"><svg class=\"icon-close\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'modulesSettings.textLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_slider-range\"><div color-setting=\"\" ng-model=\"widget.price_style.color\"></div><label class=\"label ms__label\">{{'modulesSettings.colorLabel' | translate}}</label></div><div class=\"ms__input ms__input_range\" size-setting=\"\" ng-model=\"widget.price_style.fontSize\"></div></div></div><div class=\"ms__content ms-align\"><div class=\"ms__caption\">{{'modulesSettings.textAlignLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" aligment-setting=\"\" ng-model=\"widget.price_style.textAlign\"></div></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.fontLabel' | translate}}</div><div class=\"input-wrapper inline-wrapper ms__input_half ms__input_half-margin\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.price_style.fontFamily\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.price_style.fontFamily || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in Editor.Instrumentations.fonts\" ng-click=\"optionCheck($event, font.family);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper inline-wrapper ms__input_half\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.price_style.fontWeight\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.price_style.fontWeight || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{weight}}\" ng-repeat=\"weight in ['normal', 'bold', 'bolder', 'lighter']\" ng-click=\"optionCheck($event, weight);\">{{weight}}</li></ul></div></perfect-scrollbar></div></div><label class=\"label ms__label\">{{'modulesSettings.fontWeightLabel' | translate}}</label></div></div><hr class=\"ms__separator\"/><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.marginLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.price_style.margin\"></div></div></div></div></div><div class=\"ms ms-tab-pane ms-tab-pane_modal\" ng-show=\"editCurrentTab == 'blockDesign'\" ng-class=\"{'ms-tab-pane_modal-open': accordion.show_description_settings}\"><div class=\"ms__section ms__section_active ms__section_visible\"><div class=\"ms__content ms-text\"><span>{{'widget.card.descriptionSettingsLabel' | translate}}</span><a class=\"etsw-header__close fr\" ng-click=\"accordion.show_description_settings = false\"><svg class=\"icon-close\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.card.styleLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_slider-range\"><div color-setting=\"\" ng-model=\"widget.description_style.color\"></div><label class=\"label ms__label\">{{'modulesSettings.colorLabel' | translate}}</label></div><div class=\"ms__input ms__input_range\" size-setting=\"\" ng-model=\"widget.description_style.fontSize\"></div></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.fontLabel' | translate}}</div><div class=\"input-wrapper inline-wrapper ms__input_half ms__input_half-margin\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.description_style.fontFamily\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.description_style.fontFamily || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in Editor.Instrumentations.fonts\" ng-click=\"optionCheck($event, font.family);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper inline-wrapper ms__input_half\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.description_style.fontWeight\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.description_style.fontWeight || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{weight}}\" ng-repeat=\"weight in ['normal', 'bold', 'bolder', 'lighter']\" ng-click=\"optionCheck($event, weight);\">{{weight}}</li></ul></div></perfect-scrollbar></div></div><label class=\"label ms__label\">{{'modulesSettings.fontWeightLabel' | translate}}</label></div></div><div class=\"ms__content ms-align\"><div class=\"ms__caption\">{{'modulesSettings.textAlignLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" aligment-setting=\"\" ng-model=\"widget.description_style.textAlign\"></div></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.marginLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.description_style.margin\"></div></div></div></div></div><div class=\"ms ms-tab-pane ms-tab-pane_modal\" ng-show=\"editCurrentTab == 'blockDesign'\" ng-class=\"{'ms-tab-pane_modal-open': accordion.show_button_settings}\"><div class=\"ms__section ms__section_active ms__section_navigation-settings\"><div class=\"ms__content ms-text\"><span>{{'widget.card.buttonSettingsLabel' | translate}}</span><a class=\"etsw-header__close fr\" ng-click=\"accordion.show_button_settings = false\"><svg class=\"icon-close\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a></div><div class=\"header-menu__nav\"><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': currentDesignTab == 'card_button_settings'}\" ng-click=\"setDesignTab('card_button_settings')\" ng-init=\"setDesignTab('card_button_settings')\">{{'widget.card.buttonSettingsTab1' | translate}}</a><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': currentDesignTab == 'card_button_text_settings'}\" ng-click=\"setDesignTab('card_button_text_settings')\">{{'widget.card.buttonSettingsTab2' | translate}}</a><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': currentDesignTab == 'card_button_padding_settings'}\" ng-click=\"setDesignTab('card_button_padding_settings')\">{{'widget.card.buttonSettingsTab3' | translate}}</a></div><p>&nbsp;</p><div ng-show=\"currentDesignTab == 'card_button_settings'\"><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"widget.button_attributes.style_attributes.backgroundColor\"></div></div></div><div class=\"ms__content ms-color\" gradient-setting=\"\" ng-model=\"widget.button_attributes.style_attributes\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-border\" border-setting=\"\" ng-model=\"widget.button_attributes.style_attributes.border\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.borderRadiusLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" ng-model=\"widget.button_attributes.style_attributes.borderRadius\"></div></div></div><div ng-show=\"currentDesignTab == 'card_button_text_settings'\"><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'modulesSettings.textLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_slider-range\"><div color-setting=\"\" ng-model=\"widget.button_attributes.style_attributes.color\"></div><label class=\"label ms__label\">{{'modulesSettings.colorLabel' | translate}}</label></div><div class=\"ms__input ms__input_range\" size-setting=\"\" ng-model=\"widget.button_attributes.style_attributes.fontSize\"></div></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.fontLabel' | translate}}</div><div class=\"input-wrapper inline-wrapper ms__input_half ms__input_half-margin\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.button_attributes.style_attributes.fontFamily\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.button_attributes.style_attributes.fontFamily || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in Editor.Instrumentations.fonts\" ng-click=\"optionCheck($event, font.family);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper inline-wrapper ms__input_half\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.button_attributes.style_attributes.fontWeight\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.button_attributes.style_attributes.fontWeight || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{weight}}\" ng-repeat=\"weight in ['normal', 'bold', 'bolder', 'lighter']\" ng-click=\"optionCheck($event, weight);\">{{weight}}</li></ul></div></perfect-scrollbar></div></div><label class=\"label ms__label\">{{'modulesSettings.fontWeightLabel' | translate}}</label></div></div></div><div ng-show=\"currentDesignTab == 'card_button_padding_settings'\"><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.button_attributes.style_attributes.padding\"></div></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.marginLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.button_attributes.style_attributes.margin\"></div></div></div></div></div></div><div button-actions=\"\" ng-model=\"widget\" ng-show=\"editCurrentTab == 'blockSettings'\" button-property=\"button_attributes\" form-property=\"button_form_attributes\"></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"accordion = {show_hover_settings: !accordion.show_hover_settings}\" ng-class=\"{'ms__title_active': accordion.show_hover_settings}\">{{'widget.form.hoverText3' | translate}}</span><div class=\"ms__section\" ng-class=\"{'ms__section_active': accordion.show_hover_settings}\" hover-setting=\"\" ng-model=\"widget\" access-key=\"hover_style_attributes\"></div></div><div class=\"ms image ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{'blockSettings.htmlcss' | translate}}</span><div class=\"ms__section\"><div class=\"ms__content ms-text\"><div class=\"ms__caption ms__caption_top\">{{'blockSettings.class' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><tags-input ng-model=\"widget.additional_classes\" min-length=\"0\" max-tags=\"10\" ,=\",\" allowed-tags-pattern=\"^[A-Z|a-z|0-9|+_-]+$\"></tags-input></div></div></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockVisibility'\"><div class=\"ms__section ms__section_active ms__section_visible\"><div class=\"ms__content ms-text\" ng-hide=\"Editor.option == 'site.page.mixer' || Editor.option == 'lesson.page.mixer'\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__interactive\" type=\"checkbox\" ng-model=\"widget.interactive\"/><label class=\"checkbox-label-wrapper\" for=\"ms__interactive\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'blockSettings.interactive' | translate}} &nbsp;</span><a class=\"checkbox-link\" href=\"{{'editor.settings.interactive_tutorial_link' | translate}}\" target=\"_blank\" title=\"{{'editor.tutorial.title' | translate}}\">(?)</a></label></div></div><div class=\"ms__content ms-text\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__visibility_delay\" type=\"checkbox\" ng-model=\"widget.visibility_delay_enable\" ng-init=\"widget.visibility_delay ? false : widget.visibility_delay = 60\"/><label class=\"checkbox-label-wrapper\" for=\"ms__visibility_delay\" title=\"visibility delay\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.ShowDelayedWidget' | translate}}</span></label></div><div ng-show=\"widget.visibility_delay_enable\"><input class=\"input input_nano input_inline ms-input_border\" ng-change=\"$root.validateNumber(widget, 'visibility_delay')\" type=\"number\" min=\"0\" ng-style=\"{'width': '60px'}\" ng-model=\"widget.visibility_delay\"/><span>&nbsp; {{'widget.second' | translate}}</span></div></div></div></div></div>";

/***/ }),
/* 377 */
/***/ (function(module, exports) {

module.exports = "<div class=\"etn__elements-menu\"><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockSettings'}\" ng-click=\"openTab('blockSettings')\" ng-init=\"openTab('blockSettings')\">{{'editor.panel.tab2' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockVisibility'}\" ng-click=\"openTab('blockVisibility')\">{{'editor.panel.tab5' | translate}}</a></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockSettings'\"><div class=\"ms__section ms__section_active\"><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.code.title' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><textarea class=\"textarea__content textarea_extra-small textarea ms-input_border\" placeholder=\"{{'widget.code.title' | translate}}\" ng-model=\"widget.content\" style=\"height: 300px; resize:vertical;\"></textarea></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption ms__caption_top\">{{'blockSettings.class' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><tags-input ng-model=\"widget.additional_classes\" min-length=\"0\" max-tags=\"10\" ,=\",\" allowed-tags-pattern=\"^[A-Z|a-z|0-9|+_-]+$\"></tags-input></div></div></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockVisibility'\"><div class=\"ms__section ms__section_active ms__section_visible\"><div class=\"ms__content ms-text\" ng-hide=\"Editor.option == 'site.page.mixer' || Editor.option == 'lesson.page.mixer'\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__interactive\" type=\"checkbox\" ng-model=\"widget.interactive\"/><label class=\"checkbox-label-wrapper\" for=\"ms__interactive\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'blockSettings.interactive' | translate}} &nbsp;</span><a class=\"checkbox-link\" href=\"{{'editor.settings.interactive_tutorial_link' | translate}}\" target=\"_blank\" title=\"{{'editor.tutorial.title' | translate}}\">(?)</a></label></div></div><div class=\"ms__content ms-text\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__visibility_delay\" type=\"checkbox\" ng-model=\"widget.visibility_delay_enable\" ng-init=\"widget.visibility_delay ? false : widget.visibility_delay = 60\"/><label class=\"checkbox-label-wrapper\" for=\"ms__visibility_delay\" title=\"visibility delay\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.ShowDelayedWidget' | translate}}</span></label></div><div ng-show=\"widget.visibility_delay_enable\"><input class=\"input input_nano input_inline ms-input_border\" ng-change=\"$root.validateNumber(widget, 'visibility_delay')\" type=\"number\" min=\"0\" ng-style=\"{'width': '60px'}\" ng-model=\"widget.visibility_delay\"/><span>&nbsp; {{'widget.second' | translate}}</span></div></div></div></div>";

/***/ }),
/* 378 */
/***/ (function(module, exports) {

module.exports = "<div facebook-comment-setting=\"\" ng-model=\"widget\" widget-id=\"{{widget.id}}\"><div class=\"etn__elements-menu\"><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockSettings'}\" ng-click=\"openTab('blockSettings')\" ng-init=\"openTab('blockSettings')\">{{'editor.panel.tab2' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockDesign'}\" ng-click=\"openTab('blockDesign')\">{{'editor.panel.tab1' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockVisibility'}\" ng-click=\"openTab('blockVisibility')\">{{'editor.panel.tab5' | translate}}</a></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockSettings'\"><div class=\"ms__section ms__section_active ms__section_visible\"><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.comments.urlToCommentOn' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" ng-model=\"widget.href\" placeholder=\"https://your-site.com\" ng-blur=\"$root.validateLink(widget, 'href')\"/></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.comments.pluginWidth' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" ng-model=\"widget.width\"/></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.comments.numberOfComments' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" ng-change=\"$root.validateNumber(widget, 'num_posts')\" type=\"number\" min=\"1\" ng-model=\"widget.num_posts\"/></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.comments.sortComments' | translate}}</div><div class=\"input-wrapper\"><div class=\"select\" str-select=\"\" ng-model=\"widget.order_by\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\"><span ng-if=\"widget.order_by == 'social'\">{{'widget.comments.top' | translate}}</span><span ng-if=\"widget.order_by == 'reverse_time'\">{{'widget.comments.newest' | translate}}</span><span ng-if=\"widget.order_by == 'time'\">{{'widget.comments.oldest' | translate}}</span></span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"\" ng-click=\"optionCheck($event, &quot;social&quot;);\">{{'widget.comments.top' | translate}}</li><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"\" ng-click=\"optionCheck($event, &quot;reverse_time&quot;);\">{{'widget.comments.newest' | translate}}</li><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"\" ng-click=\"optionCheck($event, &quot;time&quot;);\">{{'widget.comments.oldest' | translate}}</li></ul></div></perfect-scrollbar></div></div></div></div><div class=\"ms__content ms-text\" ng-hide=\"Editor.option == 'site.page.mixer' || Editor.option == 'lesson.page.mixer' || Editor.mode == 'form.page.editor'\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__load_facebook_SDK\" type=\"checkbox\" ng-model=\"widget.load_facebook_SDK\"/><label class=\"checkbox-label-wrapper\" for=\"ms__load_facebook_SDK\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.comments.loadFacebookSDK' | translate}} &nbsp;</span><a class=\"checkbox-link\" href=\"{{'editor.settings.facebook.load_sdk' | translate}}\" target=\"_blank\" title=\"{{'editor.tutorial.title' | translate}}\">(?)</a></label></div></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockDesign'\"><div class=\"ms__section ms__section_active ms__section_visible\"><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.comments.colorScheme' | translate}}</div><div class=\"input-wrapper\"><div class=\"select\" str-select=\"\" ng-model=\"widget.color_scheme\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\"><span ng-if=\"widget.color_scheme == 'light'\">{{'widget.comments.light' | translate}}</span><span ng-if=\"widget.color_scheme == 'dark'\">{{'widget.comments.dark' | translate}}</span></span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"Не выбран\" ng-click=\"optionCheck($event, &quot;light&quot;);\">{{'widget.comments.light' | translate}}</li><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"Полоска\" ng-click=\"optionCheck($event, &quot;dark&quot;);\">{{'widget.comments.dark' | translate}}</li></ul></div></perfect-scrollbar></div></div></div></div><hr class=\"ms__separator\"/><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"widget.style_attributes.backgroundColor\"></div></div></div><div class=\"ms__content ms-border\" border-setting=\"\" ng-model=\"widget.style_attributes.border\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.borderRadiusLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" ng-model=\"widget.style_attributes.borderRadius\"></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.style_attributes.padding\"></div></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.marginLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.style_attributes.margin\"></div></div></div></div></div><div class=\"ms image ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{'blockSettings.htmlcss' | translate}}</span><div class=\"ms__section\"><div class=\"ms__content ms-text\"><div class=\"ms__caption ms__caption_top\">{{'blockSettings.class' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><tags-input ng-model=\"widget.additional_classes\" min-length=\"0\" max-tags=\"10\" ,=\",\" allowed-tags-pattern=\"^[A-Z|a-z|0-9|+_-]+$\"></tags-input></div></div></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockVisibility'\"><div class=\"ms__section ms__section_active ms__section_visible\"><div class=\"ms__content ms-text\" ng-hide=\"Editor.option == 'site.page.mixer' || Editor.option == 'lesson.page.mixer' || Editor.mode == 'form.page.editor'\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__interactive\" type=\"checkbox\" ng-model=\"widget.interactive\"/><label class=\"checkbox-label-wrapper\" for=\"ms__interactive\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'blockSettings.interactive' | translate}} &nbsp;</span><a class=\"checkbox-link\" href=\"{{'editor.settings.interactive_tutorial_link' | translate}}\" target=\"_blank\" title=\"{{'editor.tutorial.title' | translate}}\">(?)</a></label></div></div><div class=\"ms__content ms-text\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__visibility_delay\" type=\"checkbox\" ng-model=\"widget.visibility_delay_enable\" ng-init=\"widget.visibility_delay ? false : widget.visibility_delay = 60\"/><label class=\"checkbox-label-wrapper\" for=\"ms__visibility_delay\" title=\"visibility delay\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.ShowDelayedWidget' | translate}}</span></label></div><div ng-show=\"widget.visibility_delay_enable\"><input class=\"input input_nano input_inline ms-input_border\" ng-change=\"$root.validateNumber(widget, 'visibility_delay')\" type=\"number\" min=\"0\" ng-style=\"{'width': '60px'}\" ng-model=\"widget.visibility_delay\"/><span>&nbsp; {{'widget.second' | translate}}</span></div></div></div></div></div>";

/***/ }),
/* 379 */
/***/ (function(module, exports) {

module.exports = "<div form-setting=\"\" ng-model=\"widget\" widget-id=\"{{widget.id}}\"><div class=\"etn__elements-menu\"><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockDesign'}\" ng-click=\"openTab('blockDesign')\" ng-init=\"openTab('blockDesign')\">{{'editor.panel.tab1' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockSettings'}\" ng-click=\"openTab('blockSettings')\">{{'editor.panel.tab2' | translate}}</a><div class=\"ms ms-tab-pane ms-tab-pane_modal-open\" ng-show=\"editCurrentTab == 'blockSettings'\"><div class=\"ms__section ms__section_active\"><div class=\"ms__content ms-text ta-left\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__interactive\" type=\"checkbox\" ng-model=\"widget.interactive\"/><label class=\"checkbox-label-wrapper\" for=\"ms__interactive\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'blockSettings.interactive' | translate}} &nbsp;</span><a class=\"checkbox-link\" href=\"{{'editor.settings.interactive_tutorial_link' | translate}}\" target=\"_blank\" title=\"{{'editor.tutorial.title' | translate}}\">(?)</a></label></div></div></div></div><div class=\"ms__section ms__section_active ta-left\" ng-show=\"!widget.disable_form_settings\"><div class=\"ms__content ms-radio\"><div class=\"ms__caption ms__caption_top\">{{'widget.form.formType' | translate}}:</div><div class=\"ms__input-wrapper\"><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__form-type\" type=\"radio\" value=\"subscription\" name=\"form_type\" ng-model=\"widget.form_type\"/><label class=\"radio-label-wrapper\" for=\"ms__form-type\" title=\"{{'widget.form.formType1' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.form.formType1' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__form-type-2\" type=\"radio\" value=\"order\" name=\"form_type\" ng-model=\"widget.form_type\"/><label class=\"radio-label-wrapper\" for=\"ms__form-type-2\" title=\"{{'widget.form.formType2' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.form.formType2' | translate}}</span></label></div></div></div></div></div><div ng-show=\"widget.form_type == 'order'\"><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"accordion = {show_form_constructor: !accordion.show_form_constructor}\" ng-class=\"{'ms__title_active': accordion.show_form_constructor}\">{{'widget.form.constructorLabel' | translate}}</span><div class=\"ms__section\" ng-class=\"{'ms__section_active': accordion.show_form_constructor}\"><div ui-tree=\"treeOptions\" data-max-depth=\"1\" data-drag-delay=\"200\" data-nodrag=\"\"><div id=\"tree-root\"><ol class=\"ms-fields-list\" ui-tree-nodes=\"\" ng-model=\"widget.frame_settings.order_fields\"><li class=\"ms-fields-list__item\" ng-show=\"!widget.frame_settings.order_fields.length\"><a class=\"link ms-fields-list__item-link\" title=\"Нет полей\">{{'widget.form.noFieldsLabel' | translate}}</a></li><li class=\"ms-fields-list__item\" ng-repeat=\"field in widget.frame_settings.order_fields\" ng-show=\"!field._destroy\" ui-tree-node=\"\" ng-include=\"'./editor/modules_settings/formfields/tree_renderer.jade'\"></li></ol></div></div><div class=\"ms__content ms-input\" ng-show=\"offertFieldEnabled(widget.frame_settings.order_fields)\"><div class=\"ms__caption\">{{'widget.form.offertUrl' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" ng-model=\"widget.frame_settings.offert_url\" ng-blur=\"validateLink(widget.frame_settings,'offert_url')\" placeholder=\"{{'widget.form.offertUrl' | translate}}\"/></div></div></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"accordion = {show_design_settings: !accordion.show_design_settings};\" ng-class=\"{'ms__title_active': accordion.show_design_settings}\">{{'widget.form.designLabel' | translate}}</span><div class=\"ms__section ms__section_visible\" ng-class=\"{'ms__section_active': accordion.show_design_settings}\"><div class=\"header-menu__nav\"><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': currentDesignTab == 'button'}\" ng-click=\"setDesignTab('button')\" ng-init=\"setDesignTab('button')\">{{'widget.form.designTab1' | translate}}</a><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': currentDesignTab == 'form'}\" ng-click=\"setDesignTab('form')\">{{'widget.form.designTab2' | translate}}</a></div><div ng-show=\"currentDesignTab == 'button'\"><p>&nbsp;</p><div class=\"ms__content ms-color\"><div class=\"ms__input-wrapper\"><div class=\"radio-wrapper ms-radio radio-wrapper_inline\"><input class=\"radio\" id=\"ms__frame-form-radio-1-color\" type=\"radio\" value=\"examples\" name=\"button-frame-form-color{{widget.id}}\" ng-model=\"widget.frame_settings.button_type\" checked=\"checked\"/><label class=\"radio-label-wrapper\" for=\"ms__frame-form-radio-1-color\" title=\"{{'widget.form.action1' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.form.colorExamples' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio radio-wrapper_inline\"><input class=\"radio\" id=\"ms__frame-form-radio-2-color\" type=\"radio\" value=\"custom\" name=\"button-frame-form-color{{widget.id}}\" ng-model=\"widget.frame_settings.button_type\"/><label class=\"radio-label-wrapper\" for=\"ms__frame-form-radio-2-color\" title=\"{{'widget.form.action2' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'editor.section.imageLabel' | translate}}</span></label></div></div></div><div class=\"ms__content ms-text\" ng-show=\"widget.frame_settings.button_type == 'examples'\"><div class=\"colors-wrapper\"><div class=\"color-item\" ng-repeat=\"color in jcButtonColors\" ng-click=\"setFrameButtonColor(color, widget)\" ng-style=\"{'background-color': color.color}\" ng-class=\"{'color-item_active': color.active}\"></div></div></div><div class=\"ms__content ms-color\" ng-show=\"widget.frame_settings.button_type == 'custom'\"><p>&nbsp;</p><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.card.imageSettingsUpload' | translate}}:</div><div class=\"ms__input-wrapper\" uploader-setting=\"\" ng-model=\"widget.image_attributes.source_url\" widget-id=\"{{widget.id}}\"></div></div><div class=\"ms__content ms-text\" photo-library=\"\" ng-model=\"widget\" access-key=\"image_attributes\" current-key=\"source_url\" remote-key=\"remote_source_url\"></div></div><hr class=\"ms__separator\" ng-show=\"widget.frame_settings.button_type == 'examples'\"/><div class=\"ms__content ms-color\" ng-show=\"widget.frame_settings.button_type == 'examples'\"><div class=\"ms__caption\">{{'widget.form.buttonSize' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"radio-wrapper ms-radio radio-wrapper_inline\"><input class=\"radio\" id=\"ms__frame-form-buttonsize-radio-1\" type=\"radio\" value=\"big\" name=\"button-frame-buttonsize{{widget.id}}\" ng-model=\"widget.frame_settings.frame_button_size\" checked=\"checked\"/><label class=\"radio-label-wrapper\" for=\"ms__frame-form-buttonsize-radio-1\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.form.buttonSize1' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio radio-wrapper_inline\"><input class=\"radio\" id=\"ms__frame-form-buttonsize-radio-2\" type=\"radio\" value=\"small\" name=\"button-frame-buttonsize{{widget.id}}\" ng-model=\"widget.frame_settings.frame_button_size\"/><label class=\"radio-label-wrapper\" for=\"ms__frame-form-buttonsize-radio-2\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.form.buttonSize2' | translate}}</span></label></div></div></div><div class=\"ms__content ms-input\" ng-show=\"widget.frame_settings.button_type == 'examples'\"><div class=\"ms__caption\">{{'widget.form.buttonText' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" ng-model=\"widget.frame_settings.frame_button_value\" placeholder=\"Текст кнопки\"/></div></div></div></div><div ng-show=\"currentDesignTab == 'form'\"><p>&nbsp;</p><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" from-form=\"true\" disable-opacity=\"true\" ng-model=\"widget.frame_settings.frame_form_color\"></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.form.fontSize' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input\" size-setting=\"\" ng-model=\"widget.frame_settings.font_size\"></div></div></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'widget.form.formHeight' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__form-checkbox-frame-autoheight-1\" type=\"checkbox\" checked=\"\" ng-model=\"widget.frame_settings.autoheight\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-frame-autoheight-1\" title=\"Mark a message\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.form.auto' | translate}}</span></label></div></div><div class=\"ms__input-wrapper\" height-setting=\"\" ng-hide=\"widget.frame_settings.autoheight\" ng-model=\"widget.frame_settings.frame_height\" height-min=\"0\" height-max=\"1000\"></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.marginLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.style_attributes.padding\"></div></div></div></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockSettings'\"><span class=\"ms__title\" ng-click=\"accordion.show_additional = !accordion.show_additional\" ng-class=\"{'ms__title_active': accordion.show_additional}\">{{'widget.form.actionLabel' | translate}}</span><div class=\"ms__section\" ng-if=\"accordion.show_additional\" ng-class=\"{'ms__section_active': accordion.show_additional}\"><div class=\"ms__content ms-radio\"><div class=\"ms__caption ms__caption_top\">{{'widget.form.addProducts' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" ng-model=\"myQuery\" placeholder=\"{{'widget.form.productsSearch' | translate}}\"/></div></div><div class=\"ms__input-wrapper\" ivh-treeview=\"widget.frame_settings.products\" ivh-treeview-id-attribute=\"'id'\" ivh-treeview-label-attribute=\"'title'\" ivh-treeview-children-attribute=\"'goods'\" ivh-treeview-filter=\"myQuery\" ivh-treeview-selected-attribute=\"'selected'\" ng-if=\"widget.frame_settings.products.length &lt; 100 || myQuery.length &gt; 3\"></div></div><div class=\"ms__content ms-radio\"><div class=\"ms__input-wrapper\"><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__form-checkbox-frameform-blank-1\" type=\"checkbox\" checked=\"\" ng-model=\"widget.frame_settings.target_blank\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-frameform-blank-1\" title=\"Mark a message\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.form.payPage' | translate}}</span></label></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.form.tagLabel' | translate}}:</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" ng-model=\"widget.frame_settings.tag\"/></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.form.coupon' | translate}}:</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" ng-model=\"widget.frame_settings.kupon\"/></div></div></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockSettings'\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{'widget.form.utmsLabel' | translate}}</span><div class=\"ms__section ms__section_navigation-settings\"><div class=\"ms__caption\">{{'widget.form.channel' | translate}}:</div><div class=\"ms__content ms-text\"><select class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\" ng-options=\"channel.name as channel.title for channel in ad_channels\" ng-model=\"widget.frame_settings.utm.ad_utm_medium\"></select></div><div class=\"ms__content ms-text\" ng-if=\"widget.frame_settings.utm.ad_utm_medium == 'other'\"><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" ng-model=\"widget.frame_settings.utm.ad_other_utm_medium\"/></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.form.source' | translate}}:</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" ng-model=\"widget.frame_settings.utm.ad_utm_source\"/></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.form.campaign' | translate}}:</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" ng-model=\"widget.frame_settings.utm.ad_utm_campaign\"/></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.form.content' | translate}}:</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" ng-model=\"widget.frame_settings.utm.ad_utm_content\"/></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.form.term' | translate}}:</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" ng-model=\"widget.frame_settings.utm.ad_utm_term\"/></div></div></div></div></div></div><div ng-show=\"widget.form_type == 'subscription'\"><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"accordion = {show_fast_settings: !accordion.show_fast_settings}\" ng-class=\"{'ms__title_active': accordion.show_fast_settings}\">{{'editor.panel.tab3' | translate}}</span><div class=\"ms__section\" ng-class=\"{'ms__section_active': accordion.show_fast_settings}\"><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.form.nameLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" value=\"Send\" ng-model=\"widget.title\"/></div></div></div><div class=\"ms__content ms-radio\"><div class=\"ms__caption ms__caption_top\">{{'widget.form.viewLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__form-radio-design-1\" type=\"radio\" value=\"vertical\" name=\"form-radio-design\" ng-model=\"widget.form_design\" checked=\"checked\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-design-1\" title=\"Вертикальный\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.form.view1' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__form-radio-design-2\" type=\"radio\" value=\"horizontal\" name=\"form-radio-design\" ng-model=\"widget.form_design\" checked=\"checked\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-design-2\" title=\"Горизонтальный\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.form.view2' | translate}}</span></label></div><div class=\"checkbox-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"ms__form-checkbox-1\" type=\"checkbox\" checked=\"\" ng-model=\"widget.as_modal\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-1\" title=\"Mark a message\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.form.modal' | translate}}</span></label></div><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" type=\"checkbox\" ng-model=\"widget.labels\"/><label class=\"checkbox-label-wrapper\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.form.labels' | translate}}</span></label></div></div></div><div class=\"ms__content ms-input\"><div class=\"ms__caption\">{{'widget.form.tagLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" ng-model=\"widget.tag\" placeholder=\"{{'widget.form.tagLabel' | translate}}\"/></div></div></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"accordion = {show_form_constructor: !accordion.show_form_constructor}\" ng-class=\"{'ms__title_active': accordion.show_form_constructor}\">{{'widget.form.constructorLabel' | translate}}</span><div class=\"ms__section\" ng-class=\"{'ms__section_active': accordion.show_form_constructor}\"><div class=\"ms__content\" form-fields-setting=\"\" ng-model=\"widget\" widget-id=\"{{widget.id}}\"></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"accordion = {show_design_settings: !accordion.show_design_settings};\" ng-class=\"{'ms__title_active': accordion.show_design_settings}\">{{'widget.form.designLabel' | translate}}</span><div class=\"ms__section ms__section_visible\" ng-class=\"{'ms__section_active': accordion.show_design_settings}\"><div class=\"header-menu__nav\"><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': currentDesignTab == 'button'}\" ng-click=\"setDesignTab('button')\" ng-init=\"setDesignTab('button')\">{{'widget.form.designTab1' | translate}}</a><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': currentDesignTab == 'form'}\" ng-click=\"setDesignTab('form')\">{{'widget.form.designTab2' | translate}}</a><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': currentDesignTab == 'fields'}\" ng-click=\"setDesignTab('fields')\">{{'widget.form.designTab3' | translate}}</a><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': currentDesignTab == 'labels'}\" ng-click=\"setDesignTab('labels')\" ng-show=\"widget.labels\">{{'widget.form.designTab4' | translate}}</a></div><div ng-show=\"currentDesignTab == 'button'\"><p>&nbsp;</p><div class=\"ms__content ms-color\"><div class=\"ms__input-wrapper\" ng-init=\"colorType = 'examples'\"><div class=\"radio-wrapper ms-radio radio-wrapper_inline\"><input class=\"radio\" id=\"ms__form-radio-1-color\" type=\"radio\" value=\"examples\" name=\"button-form-color{{widget[form_property].id}}\" ng-model=\"colorType\" checked=\"checked\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-1-color\" title=\"{{'widget.form.action1' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.form.colorExamples' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio radio-wrapper_inline\"><input class=\"radio\" id=\"ms__form-radio-2-color\" type=\"radio\" value=\"custom\" name=\"button-form-color{{widget[form_property].id}}\" ng-model=\"colorType\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-2-color\" title=\"{{'widget.form.action2' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.form.mycolor' | translate}}</span></label></div></div></div><div class=\"ms__content ms-text\" colors-setting=\"\" set-attributes=\"backgroundColor\" ng-model=\"widget.button.style\" ng-show=\"colorType == 'examples'\"></div><div class=\"ms__content ms-color\" ng-show=\"colorType == 'custom'\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"widget.button.style.backgroundColor\"></div></div></div><div class=\"ms__content ms-color\" gradient-setting=\"\" ng-model=\"widget.button.style\" widget-id=\"{{widget.id}}\" ng-show=\"colorType == 'custom'\"></div><div class=\"ms__content ms-border\" border-setting=\"\" ng-model=\"widget.button.style.border\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.borderRadiusLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" ng-model=\"widget.button.style.borderRadius\"></div></div><hr class=\"ms__separator\"/><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'modulesSettings.textLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_slider-range\"><div color-setting=\"\" ng-model=\"widget.button.style.color\"></div><label class=\"label ms__label\">{{'modulesSettings.colorLabel' | translate}}</label></div><div class=\"ms__input ms__input_range\" size-setting=\"\" ng-model=\"widget.button.style.fontSize\"></div></div></div><div class=\"ms__content ms__content_nomargin\"><div class=\"ms__caption\">{{'modulesSettings.fontLabel' | translate}}</div><div class=\"input-wrapper inline-wrapper ms__input_half ms__input_half-margin\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.button.style.fontFamily\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{$parent.$parent.widget.button.style.fontFamily || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in Editor.Instrumentations.fonts\" ng-click=\"optionCheck($event, font.family);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper inline-wrapper ms__input_half\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.button.style.fontWeight\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{$parent.$parent.widget.button.style.fontWeight || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{weight}}\" ng-repeat=\"weight in ['normal', 'bold', 'bolder', 'lighter']\" ng-click=\"optionCheck($event, weight);\">{{weight}}</li></ul></div></perfect-scrollbar></div></div><label class=\"label ms__label\">{{'modulesSettings.fontWeightLabel' | translate}}</label></div></div><hr class=\"ms__separator\"/><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.button.style.padding\"></div></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.marginLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.button.style.margin\"></div></div></div></div><div ng-show=\"currentDesignTab == 'form'\"><p>&nbsp;</p><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"widget.form_style.backgroundColor\"></div></div></div><div class=\"ms__content ms-border\" border-setting=\"\" ng-model=\"widget.form_style.border\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.borderRadiusLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" ng-model=\"widget.form_style.borderRadius\"></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.form_style.padding\"></div></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.marginLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.style_attributes.padding\"></div></div></div></div><div ng-show=\"currentDesignTab == 'fields'\"><p>&nbsp;</p><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"widget.form_fields_style_attributes.backgroundColor\"></div></div></div><div class=\"ms__content ms-align\"><div class=\"ms__caption\">{{'widget.form.textAlign' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" aligment-setting=\"\" ng-model=\"widget.form_fields_style_attributes.textAlign\"></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.form.fontSize' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input\" size-setting=\"\" ng-model=\"widget.form_fields_style_attributes.fontSize\"></div></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.fontLabel' | translate}}</div><div class=\"input-wrapper inline-wrapper ms__input_half__fields ms__input_half-margin_fields\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.form_fields_style_attributes.fontFamily\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{$parent.$parent.widget.button.style.fontFamily || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in Editor.Instrumentations.fonts\" ng-click=\"optionCheck($event, font.family);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper inline-wrapper ms__input_half__fields\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.form_fields_style_attributes.fontWeight\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{$parent.$parent.widget.button.style.fontWeight || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{weight}}\" ng-repeat=\"weight in ['normal', 'bold', 'bolder', 'lighter']\" ng-click=\"optionCheck($event, weight);\">{{weight}}</li></ul></div></perfect-scrollbar></div></div><label class=\"label ms__label\">{{'modulesSettings.fontWeightLabel' | translate}}</label></div><div class=\"ms__input ms__input_color\"><div color-setting=\"\" ng-model=\"widget.form_fields_style_attributes.color\"></div><label class=\"ms__label\">{{'modulesSettings.colorLabel' | translate}}</label></div></div><div class=\"ms__content ms-border\" border-setting=\"\" ng-model=\"widget.form_fields_style_attributes.border\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.borderRadiusLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" ng-model=\"widget.form_fields_style_attributes.borderRadius\"></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.form_fields_style_attributes.padding\"></div></div></div></div><div ng-show=\"currentDesignTab == 'labels'\"><p>&nbsp;</p><div class=\"ms__content ms-align\"><div class=\"ms__caption\">{{'widget.form.textAlign' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" aligment-setting=\"\" ng-model=\"widget.labels_style_attributes.textAlign\"></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.form.fontSize' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input\" size-setting=\"\" ng-model=\"widget.labels_style_attributes.fontSize\"></div></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.fontLabel' | translate}}</div><div class=\"input-wrapper inline-wrapper ms__input_half__fields ms__input_half-margin_fields\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.labels_style_attributes.fontFamily\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{$parent.$parent.widget.button.style.fontFamily || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in Editor.Instrumentations.fonts\" ng-click=\"optionCheck($event, font.family);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper inline-wrapper ms__input_half__fields\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.labels_style_attributes.fontWeight\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{$parent.$parent.widget.button.style.fontWeight || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{weight}}\" ng-repeat=\"weight in ['normal', 'bold', 'bolder', 'lighter']\" ng-click=\"optionCheck($event, weight);\">{{weight}}</li></ul></div></perfect-scrollbar></div></div><label class=\"label ms__label\">{{'modulesSettings.fontWeightLabel' | translate}}</label></div><div class=\"ms__input ms__input_color\"><div color-setting=\"\" ng-model=\"widget.labels_style_attributes.color\"></div><label class=\"ms__label\">{{'modulesSettings.colorLabel' | translate}}</label></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.labels_style_attributes.padding\"></div></div></div></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockSettings' &amp;&amp; !widget.disable_form_settings\"><span class=\"ms__title\" ng-click=\"accordion.show_additional = !accordion.show_additional\" ng-class=\"{'ms__title_active': accordion.show_additional}\">{{'widget.form.afterActionLabel' | translate}}</span><div class=\"ms__section\" ng-if=\"accordion.show_additional\" ng-class=\"{'ms__section_active': accordion.show_additional}\"><div class=\"ms__content ms-radio\"><div class=\"ms__caption ms__caption_top\">{{'widget.form.addGroup' | translate}}</div><div class=\"ms__input-wrapper\" ivh-treeview=\"widget.categories\" ivh-treeview-id-attribute=\"'id'\" ivh-treeview-label-attribute=\"'title'\" ivh-treeview-children-attribute=\"'groups'\" ivh-treeview-selected-attribute=\"'selected'\"></div></div><div class=\"ms__content ms-radio\"><div class=\"ms__caption ms__caption_top\">{{'widget.form.exGroup' | translate}}</div><div class=\"ms__input-wrapper\" ivh-treeview=\"widget.ex_categories\" ivh-treeview-id-attribute=\"'id'\" ivh-treeview-label-attribute=\"'title'\" ivh-treeview-children-attribute=\"'groups'\" ivh-treeview-selected-attribute=\"'selected'\"></div></div><div class=\"ms__content ms-radio\"><div class=\"ms__caption ms__caption_top\">{{'widget.form.actionLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__form-radio-1\" type=\"radio\" value=\"show_message\" name=\"ms-target-action\" ng-model=\"widget.submit_action\" checked=\"checked\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-1\" title=\"Показать сообщение благодарности\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.form.action1' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__form-radio-2\" type=\"radio\" value=\"open_link\" name=\"ms-target-action\" ng-model=\"widget.submit_action\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-2\" title=\"Открыть ссылку\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.form.action2' | translate}}</span></label></div></div></div><div class=\"ms__content ms-textarea\" ng-show=\"widget.submit_action == 'show_message'\"><div class=\"ms__caption\">{{'widget.form.messageLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><textarea class=\"textarea__content textarea_extra-small textarea ms-input_border\" placeholder=\"Введите сюда ваше сообщение\" ng-model=\"widget.success_message\"></textarea></div><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__form-checkbox-1\" type=\"checkbox\" checked=\"\" ng-model=\"widget.with_share\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-1\" title=\"Mark a message\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.form.addSocial' | translate}}</span></label></div></div></div><div class=\"ms__content ms-text\" ng-show=\"widget.submit_action == 'open_link'\"><div class=\"ms__caption\">{{'widget.form.urlLabel' | translate}}</div><div class=\"ms__content\"><div class=\"ms__input-wrapper\"><div class=\"radio-wrapper ms-radio\" ng-show=\"Editor.mode !== 'editor.email'\"><input class=\"radio\" id=\"ms__form-radio-url-type-2\" type=\"radio\" value=\"blank\" name=\"ms-target-action1_button1\" ng-model=\"widget.link_href_target\" ng-change=\"validateLink(widget,'redirect_url')\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-url-type-2\" title=\"{{'widget.button.action1.url.type2' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.button.action1.url.type2' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__form-radio-url-type-1\" type=\"radio\" value=\"none\" name=\"ms-target-action_button1\" ng-model=\"widget.link_href_target\" ng-change=\"validateLink(widget,'redirect_url')\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-url-type-1\" title=\"{{'widget.button.action1.url.type2' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.button.action1.url.type1' | translate}}</span></label></div></div></div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" ng-blur=\"validateLink(widget,'redirect_url')\" placeholder=\"http://your-site.com\" ng-model=\"widget.redirect_url\"/></div></div></div><div class=\"ms__content ms-text\"><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__form-subscribe-1\" type=\"checkbox\" checked=\"\" ng-model=\"widget.subscribe\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-subscribe-1\" title=\"Mark a message\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.form.subscribeLabel' | translate}}</span></label></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.form.urlLabel2' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" ng-blur=\"validateLink(widget, 'after_activate_url')\" placeholder=\"http://your-site.com\" ng-model=\"widget.after_activate_url\"/></div></div></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockSettings' &amp;&amp; !widget.disable_form_settings\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{'widget.form.utmsLabel' | translate}}</span><div class=\"ms__section ms__section_navigation-settings\"><div class=\"ms__caption\">{{'widget.form.channel' | translate}}:</div><div class=\"ms__content ms-text\"><select class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\" ng-options=\"channel.name as channel.title for channel in ad_channels\" ng-init=\"add_ad_channels()\" ng-model=\"widget.ad_utm_medium\"></select></div><div class=\"ms__content ms-text\" ng-if=\"widget.ad_utm_medium == 'other'\"><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" ng-model=\"widget.ad_other_utm_medium\"/></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.form.source' | translate}}:</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" ng-model=\"widget.ad_utm_source\"/></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.form.campaign' | translate}}:</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" ng-model=\"widget.ad_utm_campaign\"/></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.form.content' | translate}}:</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" ng-model=\"widget.ad_utm_content\"/></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.form.term' | translate}}:</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" ng-model=\"widget.ad_utm_term\"/></div></div></div></div></div><div class=\"ms ms-tab-pane\" ng-if=\"widget.as_modal\"><span class=\"ms__title\" ng-click=\"accordion.show_parent_button = !accordion.show_parent_button\" ng-class=\"{'ms__title_active': accordion. show_parent_button}\">{{'widget.form.tab7' | translate}}</span><div class=\"ms__section\" ng-if=\"accordion.show_parent_button\" ng-class=\"{'ms__section_active': accordion.show_parent_button}\"><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.form.textLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_slider-range\"><div color-setting=\"\" ng-model=\"widget.parent_button.style.color\"></div><label class=\"label ms__label\">{{'widget.form.colorLabel' | translate}}</label></div><div class=\"ms__input ms__input_range\" size-setting=\"\" ng-model=\"widget.parent_button.style.fontSize\"></div></div></div><div class=\"ms__content ms-align\"><div class=\"ms__caption\">{{'widget.form.positionLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" aligment-setting=\"\" ng-model=\"widget.parent_button.style.textAlign\"></div></div></div><hr class=\"ms__separator\"/><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'widget.form.colorBgLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"widget.parent_button.style.backgroundColor\"></div></div></div><div class=\"ms__content ms-border\" border-setting=\"\" ng-model=\"widget.parent_button.style.border\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'widget.form.borderLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" ng-model=\"widget.parent_button.style.borderRadius\"></div></div><div class=\"ms__content ms-size\"><div class=\"ms__caption\">{{'widget.form.buttonWidth' | translate}}</div><div class=\"ms__input-wrapper\"><div><div size-select-setting=\"\" ng-model=\"widget.parent_button.style.width\"></div><label class=\"label ms__label\">{{'widget.form.width' | translate}}</label></div></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'widget.form.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.parent_button.style.padding\"></div></div></div></div></div></div></div><div class=\"ms ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign' &amp;&amp; widget.form_type == 'subscription'\"><span class=\"ms__title\" ng-click=\"accordion = {show_hover_settings_2: !accordion.show_hover_settings_2}\" ng-class=\"{'ms__title_active': accordion.show_hover_settings_2}\">{{'widget.form.hoverText1' | translate}}</span><div class=\"ms__section\" ng-class=\"{'ms__section_active': accordion.show_hover_settings_2}\" hover-setting=\"\" ng-model=\"widget\" access-key=\"hover_style\"></div></div><div class=\"ms ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign' &amp;&amp; widget.as_modal &amp;&amp; widget.form_type == 'subscription'\"><span class=\"ms__title\" ng-click=\"accordion = {show_hover_settings: !accordion.show_hover_settings}\" ng-class=\"{'ms__title_active': accordion.show_hover_settings}\">{{'widget.form.hoverText2' | translate}}</span><div class=\"ms__section\" ng-class=\"{'ms__section_active': accordion.show_hover_settings}\" hover-setting=\"\" ng-model=\"widget\" access-key=\"hover_style\" button-type=\"parent_button\"></div></div><div class=\"ms image ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{'blockSettings.htmlcss' | translate}}</span><div class=\"ms__section\"><div class=\"ms__content ms-text\"><div class=\"ms__caption ms__caption_top\">{{'blockSettings.class' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><tags-input ng-model=\"widget.additional_classes\" min-length=\"0\" max-tags=\"10\" allowed-tags-pattern=\"^[A-Z|a-z|0-9|+_-]+$\"></tags-input></div></div></div></div></div>";

/***/ }),
/* 380 */
/***/ (function(module, exports) {

module.exports = "<div class=\"etn__elements-menu\"><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockSettings'}\" ng-click=\"openTab('blockSettings')\" ng-init=\"openTab('blockSettings')\">{{'editor.panel.tab2' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockVisibility'}\" ng-click=\"openTab('blockVisibility')\">{{'editor.panel.tab5' | translate}}</a></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockSettings'\"><div class=\"ms__section ms__section_active\"><div class=\"ms__content\" gallery-fields-setting=\"\" ng-model=\"widget\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-text\"><div class=\"ms__caption ms__caption_top\">{{'blockSettings.class' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><tags-input ng-model=\"widget.additional_classes\" min-length=\"0\" max-tags=\"10\" ,=\",\" allowed-tags-pattern=\"^[A-Z|a-z|0-9|+_-]+$\"></tags-input></div></div></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockVisibility'\"><div class=\"ms__section ms__section_active ms__section_visible\"><div class=\"ms__content ms-text\" ng-hide=\"Editor.option == 'site.page.mixer' || Editor.option == 'lesson.page.mixer'\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__interactive\" type=\"checkbox\" ng-model=\"widget.interactive\"/><label class=\"checkbox-label-wrapper\" for=\"ms__interactive\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'blockSettings.interactive' | translate}} &nbsp;</span><a class=\"checkbox-link\" href=\"{{'editor.settings.interactive_tutorial_link' | translate}}\" target=\"_blank\" title=\"{{'editor.tutorial.title' | translate}}\">(?)</a></label></div></div><div class=\"ms__content ms-text\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__visibility_delay\" type=\"checkbox\" ng-model=\"widget.visibility_delay_enable\" ng-init=\"widget.visibility_delay ? false : widget.visibility_delay = 60\"/><label class=\"checkbox-label-wrapper\" for=\"ms__visibility_delay\" title=\"visibility delay\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.ShowDelayedWidget' | translate}}</span></label></div><div ng-show=\"widget.visibility_delay_enable\"><input class=\"input input_nano input_inline ms-input_border\" ng-change=\"$root.validateNumber(widget, 'visibility_delay')\" type=\"number\" min=\"0\" ng-style=\"{'width': '60px'}\" ng-model=\"widget.visibility_delay\"/><span>&nbsp; {{'widget.second' | translate}}</span></div></div></div></div>";

/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports = "<div class=\"etn__elements-menu\"><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockDesign'}\" ng-click=\"openTab('blockDesign')\" ng-init=\"openTab('blockDesign')\">{{'editor.panel.tab1' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockVisibility'}\" ng-click=\"openTab('blockVisibility')\">{{'editor.panel.tab5' | translate}}</a></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockDesign'\"><div class=\"ms__section ms__section_active\"><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"widget.style_attributes.backgroundColor\"></div></div></div><div class=\"ms__content ms-border\" border-setting=\"\" ng-model=\"widget.style_attributes.border\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.borderRadiusLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" ng-model=\"widget.style_attributes.borderRadius\"></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.style_attributes.padding\"></div></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.mobilePaddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.style_attributes.mobilePadding\"></div></div></div></div></div><div class=\"ms image ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{'blockSettings.htmlcss' | translate}}</span><div class=\"ms__section\"><div class=\"ms__content ms-text\"><div class=\"ms__caption ms__caption_top\">{{'blockSettings.class' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><tags-input ng-model=\"widget.additional_classes\" min-length=\"0\" max-tags=\"10\" ,=\",\" allowed-tags-pattern=\"^[A-Z|a-z|0-9|+_-]+$\"></tags-input></div></div></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockVisibility'\"><div class=\"ms__section ms__section_active ms__section_visible\"><div class=\"ms__content ms-text\" ng-hide=\"Editor.option == 'site.page.mixer' || Editor.option == 'lesson.page.mixer' || Editor.mode == 'email.page.editor' || Editor.mode == 'form.page.editor'\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__interactive\" type=\"checkbox\" ng-model=\"widget.interactive\"/><label class=\"checkbox-label-wrapper\" for=\"ms__interactive\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'blockSettings.interactive' | translate}} &nbsp;</span><a class=\"checkbox-link\" href=\"{{'editor.settings.interactive_tutorial_link' | translate}}\" target=\"_blank\" title=\"{{'editor.tutorial.title' | translate}}\">(?)</a></label></div></div><div class=\"ms__content ms-text\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__visibility_delay\" type=\"checkbox\" ng-model=\"widget.visibility_delay_enable\" ng-init=\"widget.visibility_delay ? false : widget.visibility_delay = 60\"/><label class=\"checkbox-label-wrapper\" for=\"ms__visibility_delay\" title=\"visibility delay\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.ShowDelayedWidget' | translate}}</span></label></div><div ng-show=\"widget.visibility_delay_enable\"><input class=\"input input_nano input_inline ms-input_border\" ng-change=\"$root.validateNumber(widget, 'visibility_delay')\" type=\"number\" min=\"0\" ng-style=\"{'width': '60px'}\" ng-model=\"widget.visibility_delay\"/><span>&nbsp; {{'widget.second' | translate}}</span></div></div></div></div>";

/***/ }),
/* 382 */
/***/ (function(module, exports) {

module.exports = "<div class=\"etn__elements-menu\"><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockDesign'}\" ng-click=\"openTab('blockDesign')\" ng-init=\"openTab('blockDesign')\">{{'editor.panel.tab1' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockVisibility'}\" ng-click=\"openTab('blockVisibility')\">{{'editor.panel.tab5' | translate}}</a></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockDesign'\"><div class=\"ms__section ms__section_active\"><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"widget.style_attributes.backgroundColor\"></div></div></div><div class=\"ms__content ms-border\" border-setting=\"\" ng-model=\"widget.style_attributes.border\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.borderRadiusLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" ng-model=\"widget.style_attributes.borderRadius\"></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.style_attributes.padding\"></div></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.mobilePaddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.style_attributes.mobilePadding\"></div></div></div></div></div><div class=\"ms image ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{'blockSettings.htmlcss' | translate}}</span><div class=\"ms__section\"><div class=\"ms__content ms-text\"><div class=\"ms__caption ms__caption_top\">{{'blockSettings.class' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><tags-input ng-model=\"widget.additional_classes\" min-length=\"0\" max-tags=\"10\" ,=\",\" allowed-tags-pattern=\"^[A-Z|a-z|0-9|+_-]+$\"></tags-input></div></div></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockVisibility'\"><div class=\"ms__section ms__section_active ms__section_visible\"><div class=\"ms__content ms-text\" ng-hide=\"Editor.option == 'site.page.mixer' || Editor.option == 'lesson.page.mixer' || Editor.mode == 'email.page.editor' || Editor.mode == 'form.page.editor'\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__interactive\" type=\"checkbox\" ng-model=\"widget.interactive\"/><label class=\"checkbox-label-wrapper\" for=\"ms__interactive\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'blockSettings.interactive' | translate}} &nbsp;</span><a class=\"checkbox-link\" href=\"{{'editor.settings.interactive_tutorial_link' | translate}}\" target=\"_blank\" title=\"{{'editor.tutorial.title' | translate}}\">(?)</a></label></div></div><div class=\"ms__content ms-text\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__visibility_delay\" type=\"checkbox\" ng-model=\"widget.visibility_delay_enable\" ng-init=\"widget.visibility_delay ? false : widget.visibility_delay = 60\"/><label class=\"checkbox-label-wrapper\" for=\"ms__visibility_delay\" title=\"visibility delay\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.ShowDelayedWidget' | translate}}</span></label></div><div ng-show=\"widget.visibility_delay_enable\"><input class=\"input input_nano input_inline ms-input_border\" ng-change=\"$root.validateNumber(widget, 'visibility_delay')\" type=\"number\" min=\"0\" ng-style=\"{'width': '60px'}\" ng-model=\"widget.visibility_delay\"/><span>&nbsp; {{'widget.second' | translate}}</span></div></div></div></div>";

/***/ }),
/* 383 */
/***/ (function(module, exports) {

module.exports = "<div class=\"etn__elements-menu\"><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockDesign'}\" ng-click=\"openTab('blockDesign')\" ng-init=\"openTab('blockDesign')\">{{'editor.panel.tab1' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockVisibility'}\" ng-click=\"openTab('blockVisibility')\">{{'editor.panel.tab5' | translate}}</a></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockDesign'\"><div class=\"ms__section ms__section_active\"><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"widget.style_attributes.backgroundColor\"></div></div></div><div class=\"ms__content ms-border\" border-setting=\"\" ng-model=\"widget.style_attributes.border\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.borderRadiusLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" ng-model=\"widget.style_attributes.borderRadius\"></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.style_attributes.padding\"></div></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.mobilePaddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.style_attributes.mobilePadding\"></div></div></div></div></div><div class=\"ms image ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{'blockSettings.htmlcss' | translate}}</span><div class=\"ms__section\"><div class=\"ms__content ms-text\"><div class=\"ms__caption ms__caption_top\">{{'blockSettings.class' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><tags-input ng-model=\"widget.additional_classes\" min-length=\"0\" max-tags=\"10\" ,=\",\" allowed-tags-pattern=\"^[A-Z|a-z|0-9|+_-]+$\"></tags-input></div></div></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockVisibility'\"><div class=\"ms__section ms__section_active ms__section_visible\"><div class=\"ms__content ms-text\" ng-hide=\"Editor.option == 'site.page.mixer' || Editor.option == 'lesson.page.mixer' || Editor.mode == 'email.page.editor' || Editor.mode == 'form.page.editor'\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__interactive\" type=\"checkbox\" ng-model=\"widget.interactive\"/><label class=\"checkbox-label-wrapper\" for=\"ms__interactive\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'blockSettings.interactive' | translate}} &nbsp;</span><a class=\"checkbox-link\" href=\"{{'editor.settings.interactive_tutorial_link' | translate}}\" target=\"_blank\" title=\"{{'editor.tutorial.title' | translate}}\">(?)</a></label></div></div><div class=\"ms__content ms-text\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__visibility_delay\" type=\"checkbox\" ng-model=\"widget.visibility_delay_enable\" ng-init=\"widget.visibility_delay ? false : widget.visibility_delay = 60\"/><label class=\"checkbox-label-wrapper\" for=\"ms__visibility_delay\" title=\"visibility delay\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.ShowDelayedWidget' | translate}}</span></label></div><div ng-show=\"widget.visibility_delay_enable\"><input class=\"input input_nano input_inline ms-input_border\" ng-change=\"$root.validateNumber(widget, 'visibility_delay')\" type=\"number\" min=\"0\" ng-style=\"{'width': '60px'}\" ng-model=\"widget.visibility_delay\"/><span>&nbsp; {{'widget.second' | translate}}</span></div></div></div></div>";

/***/ }),
/* 384 */
/***/ (function(module, exports) {

module.exports = "<div class=\"etn__elements-menu\"><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockSettings'}\" ng-click=\"openTab('blockSettings')\" ng-init=\"openTab('blockSettings')\">{{'editor.panel.tab2' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockDesign'}\" ng-click=\"openTab('blockDesign')\">{{'editor.panel.tab1' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockVisibility'}\" ng-click=\"openTab('blockVisibility')\">{{'editor.panel.tab5' | translate}}</a></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockSettings'\"><div class=\"ms__section ms__section_active\" image-setting=\"\" ng-model=\"widget\" widget-id=\"{{widget.id}}\"><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.image.imageLabel' | translate}}</div><div class=\"ms__input-wrapper\" uploader-setting=\"\" ng-model=\"widget.image_attributes.source_url\" widget-id=\"{{widget.id}}\"></div></div><div class=\"ms__content ms-text\" photo-library=\"\" ng-model=\"widget\" access-key=\"image_attributes\" current-key=\"source_url\" remote-key=\"remote_source_url\"></div><div class=\"ms__content\"><div class=\"ms__input-wrapper\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__form-checkbox-1\" type=\"checkbox\" checked=\"\" ng-model=\"widget.image_attributes.stretch\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-1\" title=\"Mark a message\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.image.stratch' | translate}}</span></label></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.image.title' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" placeholder=\"{{'widget.image.title' | translate}}\" ng-model=\"widget.title\"/></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__input-wrapper\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__form-checkbox-desc\" type=\"checkbox\" checked=\"\" ng-model=\"widget.show_title\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-desc\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.image.showDescription' | translate}}</span></label></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.image.description' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" placeholder=\"{{'widget.image.description' | translate}}\" ng-model=\"widget.alt\"/></div></div></div><hr class=\"ms__separator\"/><div class=\"ms__content ms-radio\"><div class=\"ms__caption ms__caption_top\">{{'widget.image.action' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__form-radio-1\" type=\"radio\" value=\"nothing\" name=\"ms-target-action\" ng-model=\"widget.image_attributes.img_action\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-1\" title=\"{{'widget.image.action1' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.image.action1' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\" ng-show=\"Editor.mode !== 'email.page.editor'\"><input class=\"radio\" id=\"ms__form-radio-2\" type=\"radio\" value=\"popup\" name=\"ms-target-action\" ng-model=\"widget.image_attributes.img_action\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-2\" title=\"{{'widget.image.action2' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.image.action2' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\" ng-show=\"Editor.mode !== 'email.page.editor'\"><input class=\"radio\" id=\"ms__form-radio-3\" type=\"radio\" value=\"scroll_to_section\" name=\"ms-target-action\" ng-model=\"widget.image_attributes.img_action\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-3\" title=\"{{'widget.image.action3' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.image.action3' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__form-radio-4\" type=\"radio\" value=\"link\" name=\"ms-target-action\" ng-model=\"widget.image_attributes.img_action\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-4\" title=\"{{'widget.image.action4' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.image.action4' | translate}}</span></label></div></div></div><div class=\"ms__content\" ng-show=\"widget.image_attributes.img_action == 'scroll_to_section'\"><div class=\"ms__caption\">{{'widget.button.action2.sectionLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><select class=\"input input_extra-small ms-input_border select__placeholder select__placeholder_small text-overflow\" ng-options=\"section.id as section.title for section in Editor.getSections()\" ng-model=\"widget.image_attributes.scroll_section_id\"></select></div></div></div><div class=\"ms__content ms-text\" ng-show=\"widget.image_attributes.img_action == 'link'\"><div class=\"ms__caption\">URL</div><div class=\"ms__content\"><div class=\"ms__input-wrapper\"><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__form-radio-url-type-2\" type=\"radio\" value=\"blank\" name=\"ms-target-action1_button1\" ng-model=\"widget.image_attributes.link_href_target\" ng-change=\"$root.validateLink(widget.image_attributes,'link_href')\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-url-type-2\" title=\"{{'widget.button.action1.url.type2' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.button.action1.url.type2' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\" ng-show=\"Editor.mode !== 'email.page.editor'\"><input class=\"radio\" id=\"ms__form-radio-url-type-1\" type=\"radio\" value=\"none\" name=\"ms-target-action1_button1\" ng-model=\"widget.image_attributes.link_href_target\" ng-change=\"$root.validateLink(widget.image_attributes,'link_href')\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-url-type-1\" title=\"{{'widget.button.action1.url.type2' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.button.action1.url.type1' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\" ng-if=\"$root.enableNextPageOption\"><input class=\"radio\" id=\"ms__form-radio-url-type-3\" type=\"radio\" value=\"next\" name=\"ms-target-action1_button1\" ng-model=\"widget.image_attributes.link_href_target\" ng-change=\"$root.validateLink(widget.image_attributes,'link_href')\"/><label class=\"radio-label-wrapper label-input\" for=\"ms__form-radio-url-type-3\" title=\"{{'widget.button.action1.url.nextPage' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.button.action1.url.nextPage' | translate}}</span></label></div></div></div><div class=\"ms__input-wrapper\" ng-show=\"widget.image_attributes.link_href_target !== 'next'\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" placeholder=\"http://your-site.com\" ng-model=\"widget.image_attributes.link_href\" ng-blur=\"$root.validateLink(widget.image_attributes,'link_href')\"/></div><div class=\"checkbox-wrapper ms-checkbox\" ng-show=\"Editor.mode !== 'email.page.editor'\"><input class=\"checkbox\" id=\"ms__form-checkbox-1\" type=\"checkbox\" ng-model=\"widget.image_attributes.target_blank\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-1\" title=\"Open in New Window\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.image.action4Blank' | translate}}</span></label></div></div></div><div class=\"ms__content ms-text\" access=\"admin superadmin\" access-element=\"true\"><div class=\"ms__caption\">{{'widget.form.tagLabel' | translate}}*</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" placeholder=\"tag\" ng-model=\"widget.tag\"/></div></div></div><div class=\"ms__content ms-text\" access=\"admin superadmin\" access-element=\"true\"><button class=\"button button_small button_green\" ng-click=\"addImageToLibrary(widget)\" ng-disabled=\"addingToLibrary || !widget.tag\" noloader=\"\">{{'widget.image.addToLibrary' | translate}}</button></div><div class=\"ms__content ms-text\" ng-hide=\"Editor.option == 'site.page.mixer' || Editor.option == 'lesson.page.mixer' || Editor.mode == 'email.page.editor' || Editor.mode == 'form.page.editor'\" access=\"admin superadmin\" access-element=\"true\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__lazyload\" type=\"checkbox\" ng-model=\"widget.lazyload\"/><label class=\"checkbox-label-wrapper\" for=\"ms__lazyload\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">LazyLoading</span></label></div></div></div></div><div class=\"ms image ms-tab-pane\" ng-show=\"editCurrentTab == 'blockDesign'\"><div class=\"ms__section ms__section_active\"><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"widget.style_attributes.backgroundColor\"></div></div></div><div class=\"ms__content ms-align\"><div class=\"ms__caption\">{{'modulesSettings.textAlignLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" aligment-setting=\"\" ng-model=\"widget.style_attributes.textAlign\"></div></div></div><div class=\"ms__content ms-border\" border-setting=\"\" ng-model=\"widget.style_attributes.border\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.borderRadiusLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" ng-model=\"widget.style_attributes.borderRadius\"></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.style_attributes.padding\"></div></div></div></div></div><div class=\"ms image ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{'blockSettings.htmlcss' | translate}}</span><div class=\"ms__section\"><div class=\"ms__content ms-text\"><div class=\"ms__caption ms__caption_top\">{{'blockSettings.class' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><tags-input ng-model=\"widget.additional_classes\" min-length=\"0\" max-tags=\"10\" ,=\",\" allowed-tags-pattern=\"^[A-Z|a-z|0-9|+_-]+$\"></tags-input></div></div></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockVisibility'\"><div class=\"ms__section ms__section_active ms__section_visible\"><div class=\"ms__content ms-text\" ng-hide=\"Editor.option == 'site.page.mixer' || Editor.option == 'lesson.page.mixer' || Editor.mode == 'email.page.editor' || Editor.mode == 'form.page.editor'\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__interactive\" type=\"checkbox\" ng-model=\"widget.interactive\"/><label class=\"checkbox-label-wrapper\" for=\"ms__interactive\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'blockSettings.interactive' | translate}} &nbsp;</span><a class=\"checkbox-link\" href=\"{{'editor.settings.interactive_tutorial_link' | translate}}\" target=\"_blank\" title=\"{{'editor.tutorial.title' | translate}}\">(?)</a></label></div></div><div class=\"ms__content ms-text\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__visibility_delay\" type=\"checkbox\" ng-model=\"widget.visibility_delay_enable\" ng-init=\"widget.visibility_delay ? false : widget.visibility_delay = 60\"/><label class=\"checkbox-label-wrapper\" for=\"ms__visibility_delay\" title=\"visibility delay\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.ShowDelayedWidget' | translate}}</span></label></div><div ng-show=\"widget.visibility_delay_enable\"><input class=\"input input_nano input_inline ms-input_border\" ng-change=\"$root.validateNumber(widget, 'visibility_delay')\" type=\"number\" min=\"0\" ng-style=\"{'width': '60px'}\" ng-model=\"widget.visibility_delay\"/><span>&nbsp; {{'widget.second' | translate}}</span></div></div></div></div>";

/***/ }),
/* 385 */
/***/ (function(module, exports) {

module.exports = "<div class=\"etn__elements-menu\"><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockSettings'}\" ng-click=\"openTab('blockSettings')\" ng-init=\"openTab('blockSettings')\">{{'editor.panel.tab2' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockDesign'}\" ng-click=\"openTab('blockDesign')\">{{'editor.panel.tab1' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockVisibility'}\" ng-click=\"openTab('blockVisibility')\">{{'editor.panel.tab5' | translate}}</a></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockSettings'\"><span class=\"ms__title ms__title_active\" ng-click=\"editorAccordion($event)\">{{'widget.line.tab1' | translate}}</span><div class=\"ms__section ms__section_active\"><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"widget['background_color']\" widget-id=\"{{widget.id}}\"></div></div></div><div class=\"ms__content ms-size\"><div class=\"ms__caption\">{{'modulesSettings.sizes' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_middle\"><div size-select-setting=\"\" ng-model=\"widget.height\"></div><label class=\"label ms__label\">{{'modulesSettings.height' | translate}}</label></div><div class=\"ms__input ms__input_middle\"><div size-select-setting=\"\" ng-model=\"widget.width\"></div><label class=\"label ms__label\">{{'modulesSettings.width' | translate}}</label></div></div></div><div class=\"ms__content ms-align\"><div class=\"ms__caption\">{{'modulesSettings.textAlignLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__ipnut ms__input_large\" aligment-setting=\"\" ng-model=\"widget.style_attributes.textAlign\"></div></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.marginLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.style_attributes.padding\"></div></div></div></div></div><div class=\"ms image ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{'blockSettings.htmlcss' | translate}}</span><div class=\"ms__section\"><div class=\"ms__content ms-text\"><div class=\"ms__caption ms__caption_top\">{{'blockSettings.class' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><tags-input ng-model=\"widget.additional_classes\" min-length=\"0\" max-tags=\"10\" ,=\",\" allowed-tags-pattern=\"^[A-Z|a-z|0-9|+_-]+$\"></tags-input></div></div></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockVisibility'\"><div class=\"ms__section ms__section_active ms__section_visible\"><div class=\"ms__content ms-text\" ng-hide=\"Editor.option == 'site.page.mixer' || Editor.option == 'lesson.page.mixer' || Editor.mode == 'email.page.editor'\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__interactive\" type=\"checkbox\" ng-model=\"widget.interactive\"/><label class=\"checkbox-label-wrapper\" for=\"ms__interactive\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'blockSettings.interactive' | translate}} &nbsp;</span><a class=\"checkbox-link\" href=\"{{'editor.settings.interactive_tutorial_link' | translate}}\" target=\"_blank\" title=\"{{'editor.tutorial.title' | translate}}\">(?)</a></label></div></div><div class=\"ms__content ms-text\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__visibility_delay\" type=\"checkbox\" ng-model=\"widget.visibility_delay_enable\" ng-init=\"widget.visibility_delay ? false : widget.visibility_delay = 60\"/><label class=\"checkbox-label-wrapper\" for=\"ms__visibility_delay\" title=\"visibility delay\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.ShowDelayedWidget' | translate}}</span></label></div><div ng-show=\"widget.visibility_delay_enable\"><input class=\"input input_nano input_inline ms-input_border\" ng-change=\"$root.validateNumber(widget, 'visibility_delay')\" type=\"number\" min=\"0\" ng-style=\"{'width': '60px'}\" ng-model=\"widget.visibility_delay\"/><span>&nbsp; {{'widget.second' | translate}}</span></div></div></div></div>";

/***/ }),
/* 386 */
/***/ (function(module, exports) {

module.exports = "<div class=\"etn__elements-menu\"><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockDesign'}\" ng-click=\"openTab('blockDesign')\">{{'editor.panel.tab1' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockSettings'}\" ng-click=\"openTab('blockSettings')\">{{'editor.panel.tab2' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockVisibility'}\" ng-click=\"openTab('blockVisibility')\">{{'editor.panel.tab5' | translate}}</a></div><div button-actions=\"\" ng-model=\"widget\" ng-show=\"editCurrentTab == 'blockSettings'\" button-property=\"button_attributes\" form-property=\"button_form_attributes\"></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockDesign'\" link-setting=\"\" ng-model=\"widget\"><span class=\"ms__title\" ng-click=\"accordion = {show_fast_settings: !accordion.show_fast_settings}\" ng-class=\"{'ms__title_active': accordion.show_fast_settings}\">{{'editor.panel.tab3' | translate}}</span><div class=\"ms__section ms__section_visible\" ng-class=\"{'ms__section_active': accordion.show_fast_settings}\"><div class=\"header-menu__nav\"><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': currentDesignTab == 'text'}\" ng-click=\"setDesignTab('text')\" ng-init=\"setDesignTab('text')\">{{'modulesSettings.textLabel' | translate}}</a><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': currentDesignTab == 'paddings'}\" ng-click=\"setDesignTab('paddings')\">{{'widget.list.tab3' | translate}}</a></div><div>&nbsp;</div><div ng-show=\"currentDesignTab == 'text'\"><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.fontLabel' | translate}}</div><div class=\"input-wrapper inline-wrapper ms__input_half ms__input_half-margin\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.button_attributes.style_attributes.fontFamily\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.button_attributes.style_attributes.fontFamily || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in Editor.Instrumentations.fonts\" ng-click=\"optionCheck($event, font.family);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper inline-wrapper ms__input_half\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.button_attributes.style_attributes.fontWeight\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.button_attributes.style_attributes.fontWeight || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{weight}}\" ng-repeat=\"weight in ['normal', 'bold', 'bolder', 'lighter']\" ng-click=\"optionCheck($event, weight);\">{{weight}}</li></ul></div></perfect-scrollbar></div></div><label class=\"label ms__label\">{{'modulesSettings.fontWeightLabel' | translate}}</label></div></div><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"widget.button_attributes.style_attributes.backgroundColor\"></div></div></div><div class=\"ms__content ms-border\" border-setting=\"\" ng-model=\"widget.button_attributes.style_attributes.border\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.borderRadiusLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" ng-model=\"widget.button_attributes.style_attributes.borderRadius\"></div></div></div><div ng-show=\"currentDesignTab == 'paddings'\"><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.button_attributes.style_attributes.padding\"></div></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.marginLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.button_attributes.style_attributes.margin\"></div></div></div></div></div></div><div class=\"ms image ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{'blockSettings.htmlcss' | translate}}</span><div class=\"ms__section\"><div class=\"ms__content ms-text\"><div class=\"ms__caption ms__caption_top\">{{'blockSettings.class' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><tags-input ng-model=\"widget.additional_classes\" min-length=\"0\" max-tags=\"10\" ,=\",\" allowed-tags-pattern=\"^[A-Z|a-z|0-9|+_-]+$\"></tags-input></div></div></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockVisibility'\"><div class=\"ms__section ms__section_active ms__section_visible\"><div class=\"ms__content ms-text\" ng-hide=\"Editor.option == 'site.page.mixer' || Editor.option == 'lesson.page.mixer' || Editor.mode == 'email.page.editor'\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__interactive\" type=\"checkbox\" ng-model=\"widget.interactive\"/><label class=\"checkbox-label-wrapper\" for=\"ms__interactive\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'blockSettings.interactive' | translate}} &nbsp;</span><a class=\"checkbox-link\" href=\"{{'editor.settings.interactive_tutorial_link' | translate}}\" target=\"_blank\" title=\"{{'editor.tutorial.title' | translate}}\">(?)</a></label></div></div><div class=\"ms__content ms-text\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__visibility_delay\" type=\"checkbox\" ng-model=\"widget.visibility_delay_enable\" ng-init=\"widget.visibility_delay ? false : widget.visibility_delay = 60\"/><label class=\"checkbox-label-wrapper\" for=\"ms__visibility_delay\" title=\"visibility delay\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.ShowDelayedWidget' | translate}}</span></label></div><div ng-show=\"widget.visibility_delay_enable\"><input class=\"input input_nano input_inline ms-input_border\" ng-change=\"$root.validateNumber(widget, 'visibility_delay')\" type=\"number\" min=\"0\" ng-style=\"{'width': '60px'}\" ng-model=\"widget.visibility_delay\"/><span>&nbsp; {{'widget.second' | translate}}</span></div></div></div></div>";

/***/ }),
/* 387 */
/***/ (function(module, exports) {

module.exports = "<div class=\"etn__elements-menu\"><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockSettings'}\" ng-click=\"openTab('blockSettings')\" ng-init=\"openTab('blockSettings')\">{{'editor.panel.tab2' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockDesign'}\" ng-click=\"openTab('blockDesign')\">{{'editor.panel.tab1' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockVisibility'}\" ng-click=\"openTab('blockVisibility')\">{{'editor.panel.tab5' | translate}}</a></div><div class=\"ms ms-tab-pane\" ng-if=\"editCurrentTab == 'blockSettings'\"><span class=\"ms__title ms__title_active\">{{'widget.list.title' | translate}}</span><div class=\"ms__section ms__section_active\"><div class=\"ms__content ms-text\" list-fields-setting=\"\" ng-model=\"widget\" widget-id=\"{{widget.id}}\"></div></div></div><div class=\"ms ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title ms__title_active\" ng-click=\"editorAccordion($event)\">{{\"editor.panel.tab3\" | translate}}</span><div class=\"ms__section ms__section_active ms__section_visible\"><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"widget.caption_style.backgroundColor\"></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'modulesSettings.button.buttonStyle' | translate}}:</div><div class=\"input-wrapper\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.theme\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\"><span ng-if=\"widget.theme == 'strip'\">{{'modulesSettings.strip' | translate}}</span><span ng-if=\"widget.theme == 'frame'\">{{'modulesSettings.frame' | translate}}</span><span ng-if=\"widget.theme !== 'strip' &amp;&amp; widget.theme !== 'frame'\">{{'modulesSettings.notSelected' | translate}}</span></span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"Не выбран\" ng-click=\"optionCheck($event, &quot;none&quot;);\">{{'modulesSettings.notSelected' | translate}}</li><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"Полоска\" ng-click=\"optionCheck($event, &quot;strip&quot;);\">{{'modulesSettings.strip' | translate}}</li><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"Рамка\" ng-click=\"optionCheck($event, &quot;frame&quot;);\">{{'modulesSettings.frame' | translate}}</li></ul></div></perfect-scrollbar></div></div></div></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.borderRadiusLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" ng-model=\"widget.caption_style.borderRadius\"></div></div></div></div><div class=\"ms ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{'widget.list.additional' | translate}}</span><div class=\"ms__section ms__section_visible\"><div class=\"header-menu__nav\" ng-init=\"setDesignTab('card_additional_tab2')\"><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': currentDesignTab == 'card_additional_tab2'}\" ng-click=\"setDesignTab('card_additional_tab2')\">{{'widget.list.tab2' | translate}}</a><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': currentDesignTab == 'card_additional_tab1'}\" ng-click=\"setDesignTab('card_additional_tab1')\">{{'modulesSettings.icon' | translate}}</a><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': currentDesignTab == 'card_additional_tab3'}\" ng-click=\"setDesignTab('card_additional_tab3')\">{{'widget.list.tab3' | translate}}</a></div><p>&nbsp;</p><!-- Изображение--><div ng-if=\"currentDesignTab == 'card_additional_tab1'\"><div class=\"ms__content\" ng-hide=\"Editor.option == 'site.page.mixer' || Editor.option == 'lesson.page.mixer' || Editor.mode == 'email.page.editor'\"><div class=\"ms__caption\">{{'modulesSettings.icon' | translate}}</div><div icon-selector-setting=\"\" ng-model=\"widget.icon.cssClass\"></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.image.imageLabel' | translate}}</div><div class=\"ms__input-wrapper\" uploader-setting=\"\" ng-model=\"widget.image_attributes.source_url\" widget-id=\"{{widget.id}}\"></div></div><div class=\"ms__content ms-text\" photo-library=\"\" ng-model=\"widget\" access-key=\"image_attributes\" current-key=\"source_url\" remote-key=\"remote_source_url\"></div><div class=\"ms__content ms-color\" ng-hide=\"Editor.option == 'site.page.mixer' || Editor.option == 'lesson.page.mixer' || Editor.mode == 'email.page.editor'\"><div class=\"ms__caption\">{{'modulesSettings.iconColor' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"widget.icon.color\"></div></div></div><div class=\"ms__content ms-color\" ng-hide=\"Editor.option == 'site.page.mixer' || Editor.option == 'lesson.page.mixer' || Editor.mode == 'email.page.editor'\"><div class=\"ms__caption\">{{'modulesSettings.fillColor' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"widget.icon.backgroundColor\"></div></div></div></div><!-- Text--><div ng-if=\"currentDesignTab == 'card_additional_tab2'\"><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'modulesSettings.textLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_slider-range\"><div color-setting=\"\" ng-model=\"widget.caption_style.color\"></div><label class=\"label ms__label\">{{'modulesSettings.colorLabel' | translate}}</label></div><div class=\"ms__input ms__input_range\" size-setting=\"\" ng-model=\"widget.caption_style.fontSize\"></div></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.fontLabel' | translate}}</div><div class=\"input-wrapper inline-wrapper ms__input_half ms__input_half-margin\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.caption_style.fontFamily\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.caption_style.fontFamily || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in Editor.Instrumentations.fonts\" ng-click=\"optionCheck($event, font.family);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper inline-wrapper ms__input_half\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.caption_style.fontWeight\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.caption_style.fontWeight || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{weight}}\" ng-repeat=\"weight in ['normal', 'bold', 'bolder', 'lighter']\" ng-click=\"optionCheck($event, weight);\">{{weight}}</li></ul></div></perfect-scrollbar></div></div><label class=\"label ms__label\">{{'modulesSettings.fontWeightLabel' | translate}}</label></div></div></div><!-- Отступы--><div ng-if=\"currentDesignTab == 'card_additional_tab3'\"><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.caption_style.padding\"></div></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.marginLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.style_attributes.padding\"></div></div></div></div></div></div><div class=\"ms ms-tab-pane\" ng-if=\"widget.theme == 'strip'\" ng-show=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{'modulesSettings.stripeStyle' | translate}}</span><div class=\"ms__section\"><div class=\"ms__content ms-border\" border-setting=\"\" ng-model=\"widget.caption_style.border\" widget-id=\"{{widget.id}}\"></div></div></div><div class=\"ms ms-tab-pane\" ng-if=\"widget.theme == 'frame'\" ng-show=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{'modulesSettings.frameStyle' | translate}}</span><div class=\"ms__section\"><div class=\"ms__content ms-border\" border-setting=\"\" ng-model=\"widget.caption_style.border\" widget-id=\"{{widget.id}}\"></div></div></div><!-- blockDesign html / css--><div class=\"ms image ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{'blockSettings.htmlcss' | translate}}</span><div class=\"ms__section\"><div class=\"ms__content ms-text\"><div class=\"ms__caption ms__caption_top\">{{'blockSettings.class' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><tags-input ng-model=\"widget.additional_classes\" min-length=\"0\" max-tags=\"10\" ,=\",\" allowed-tags-pattern=\"^[A-Z|a-z|0-9|+_-]+$\"></tags-input></div></div></div></div></div><!-- blockVisibility--><div class=\"ms ms-tab-pane\" ng-if=\"editCurrentTab == 'blockVisibility'\"><div class=\"ms__section ms__section_active ms__section_visible\"><div class=\"ms__content ms-text\" ng-hide=\"Editor.option == 'site.page.mixer' || Editor.option == 'lesson.page.mixer' || Editor.mode == 'email.page.editor' || Editor.mode == 'form.page.editor'\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__interactive\" type=\"checkbox\" ng-model=\"widget.interactive\"/><label class=\"checkbox-label-wrapper\" for=\"ms__interactive\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'blockSettings.interactive' | translate}} &nbsp;</span><a class=\"checkbox-link\" href=\"{{'editor.settings.interactive_tutorial_link' | translate}}\" target=\"_blank\" title=\"{{'editor.tutorial.title' | translate}}\">(?)</a></label></div></div><div class=\"ms__content ms-text\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__visibility_delay\" type=\"checkbox\" ng-model=\"widget.visibility_delay_enable\" ng-init=\"widget.visibility_delay ? false : widget.visibility_delay = 60\"/><label class=\"checkbox-label-wrapper\" for=\"ms__visibility_delay\" title=\"visibility delay\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.ShowDelayedWidget' | translate}}</span></label></div><div ng-show=\"widget.visibility_delay_enable\"><input class=\"input input_nano input_inline ms-input_border\" ng-change=\"$root.validateNumber(widget, 'visibility_delay')\" type=\"number\" min=\"0\" ng-style=\"{'width': '60px'}\" ng-model=\"widget.visibility_delay\"/><span>&nbsp; {{'widget.second' | translate}}</span></div></div></div></div>";

/***/ }),
/* 388 */
/***/ (function(module, exports) {

module.exports = "<div class=\"etn__elements-menu\"><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockSettings'}\" ng-click=\"openTab('blockSettings')\" ng-init=\"openTab('blockSettings')\">{{'editor.panel.tab2' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockDesign'}\" ng-click=\"openTab('blockDesign')\">{{'editor.panel.tab1' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockVisibility'}\" ng-click=\"openTab('blockVisibility')\">{{'editor.panel.tab5' | translate}}</a></div><div class=\"ms ms-tab-pane\" map-setting=\"\" ng-model=\"widget\" widget-id=\"{{widget.id}}\" ng-show=\"editCurrentTab == 'blockSettings'\"></div><div class=\"ms ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign'\"><div class=\"ms__section ms__section_active\"><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.height' | translate}}</div><div class=\"ms__input-wrapper\" slidersize-setting=\"\" ng-model=\"widget.style_attributes.height\"></div></div><div class=\"ms__content ms-border\" border-setting=\"\" ng-model=\"widget.style_attributes.border\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.borderRadiusLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" ng-model=\"widget.style_attributes.borderRadius\"></div></div><div class=\"ms__content\">&nbsp;</div><div class=\"ms__content\">&nbsp;</div></div></div><div class=\"ms image ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{'blockSettings.htmlcss' | translate}}</span><div class=\"ms__section\"><div class=\"ms__content ms-text\"><div class=\"ms__caption ms__caption_top\">{{'blockSettings.class' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><tags-input ng-model=\"widget.additional_classes\" min-length=\"0\" max-tags=\"10\" ,=\",\" allowed-tags-pattern=\"^[A-Z|a-z|0-9|+_-]+$\"></tags-input></div></div></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockVisibility'\"><div class=\"ms__section ms__section_active ms__section_visible\"><div class=\"ms__content ms-text\" ng-hide=\"Editor.option == 'site.page.mixer' || Editor.option == 'lesson.page.mixer'\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__interactive\" type=\"checkbox\" ng-model=\"widget.interactive\"/><label class=\"checkbox-label-wrapper\" for=\"ms__interactive\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'blockSettings.interactive' | translate}} &nbsp;</span><a class=\"checkbox-link\" href=\"{{'editor.settings.interactive_tutorial_link' | translate}}\" target=\"_blank\" title=\"{{'editor.tutorial.title' | translate}}\">(?)</a></label></div></div><div class=\"ms__content ms-text\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__visibility_delay\" type=\"checkbox\" ng-model=\"widget.visibility_delay_enable\" ng-init=\"widget.visibility_delay ? false : widget.visibility_delay = 60\"/><label class=\"checkbox-label-wrapper\" for=\"ms__visibility_delay\" title=\"visibility delay\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.ShowDelayedWidget' | translate}}</span></label></div><div ng-show=\"widget.visibility_delay_enable\"><input class=\"input input_nano input_inline ms-input_border\" ng-change=\"$root.validateNumber(widget, 'visibility_delay')\" type=\"number\" min=\"0\" ng-style=\"{'width': '60px'}\" ng-model=\"widget.visibility_delay\"/><span>&nbsp; {{'widget.second' | translate}}</span></div></div></div></div>";

/***/ }),
/* 389 */
/***/ (function(module, exports) {

module.exports = "<div class=\"etn__elements-menu\"><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockDesign'}\" ng-click=\"openTab('blockDesign')\" ng-init=\"openTab('blockDesign')\">{{'editor.panel.tab1' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockSettings'}\" ng-click=\"openTab('blockSettings')\">{{'editor.panel.tab2' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockVisibility'}\" ng-click=\"openTab('blockVisibility')\">{{'editor.panel.tab5' | translate}}</a></div><div class=\"ms ms-tab-pane\" navigation-fields-setting=\"\" ng-model=\"widget\" widget-id=\"{{widget.id}}\" ng-show=\"editCurrentTab == 'blockSettings'\"></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"accordion = {show_fast_settings: !accordion.show_fast_settings}\" ng-class=\"{'ms__title_active': accordion.show_fast_settings}\">{{'widget.navigation.additionalLabel' | translate}}</span><div class=\"ms__section ms__section_visible\" ng-class=\"{'ms__section_active': accordion.show_fast_settings}\"><div class=\"header-menu__nav\" ng-init=\"setDesignTab('card_additional_tab1')\"><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': currentDesignTab == 'card_additional_tab1'}\" ng-click=\"setDesignTab('card_additional_tab1')\">{{'widget.navigation.tab1' | translate}}</a><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': currentDesignTab == 'card_additional_tab2'}\" ng-click=\"setDesignTab('card_additional_tab2')\">{{'widget.navigation.tab2' | translate}}</a><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': currentDesignTab == 'card_additional_tab3'}\" ng-click=\"setDesignTab('card_additional_tab3')\">{{'widget.navigation.tab3' | translate}}</a></div><p>&nbsp;</p><div ng-show=\"currentDesignTab == 'card_additional_tab1'\"><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"widget.style_attributes.backgroundColor\"></div></div></div><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'widget.navigation.linksColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"widget.link_style.backgroundColor\"></div></div></div><div class=\"ms__content ms-align\"><div class=\"ms__caption\">{{'modulesSettings.textAlignLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" aligment-setting=\"\" ng-model=\"widget.style_attributes.textAlign\"></div></div></div><div class=\"ms__content ms-border\" border-setting=\"\" ng-model=\"widget.link_style.border\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.borderRadiusLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" ng-model=\"widget.style_attributes.borderRadius\"></div></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.borderRadiusLabel2' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" ng-model=\"widget.link_style.borderRadius\"></div></div></div><div ng-show=\"currentDesignTab == 'card_additional_tab2'\"><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'modulesSettings.textLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_slider-range\"><div color-setting=\"\" ng-model=\"widget.link_style.color\"></div><label class=\"label ms__label\">{{'modulesSettings.colorLabel' | translate}}</label></div><div class=\"ms__input ms__input_range\" size-setting=\"\" ng-model=\"widget.link_style.fontSize\"></div></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.fontLabel' | translate}}</div><div class=\"input-wrapper inline-wrapper ms__input_half ms__input_half-margin\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.style_attributes.fontFamily\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.style_attributes.fontFamily || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in Editor.Instrumentations.fonts\" ng-click=\"optionCheck($event, font.family);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper inline-wrapper ms__input_half\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.style_attributes.fontWeight\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.style_attributes.fontWeight || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{weight}}\" ng-repeat=\"weight in ['normal', 'bold', 'bolder', 'lighter']\" ng-click=\"optionCheck($event, weight);\">{{weight}}</li></ul></div></perfect-scrollbar></div></div><label class=\"label ms__label\">{{'modulesSettings.fontWeightLabel' | translate}}</label></div></div></div><div ng-show=\"currentDesignTab == 'card_additional_tab3'\"><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.link_style.padding\"></div></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.marginLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.link_style.margin\"></div></div></div></div></div></div><div class=\"ms image ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{'blockSettings.htmlcss' | translate}}</span><div class=\"ms__section\"><div class=\"ms__content ms-text\"><div class=\"ms__caption ms__caption_top\">{{'blockSettings.class' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><tags-input ng-model=\"widget.additional_classes\" min-length=\"0\" max-tags=\"10\" ,=\",\" allowed-tags-pattern=\"^[A-Z|a-z|0-9|+_-]+$\"></tags-input></div></div></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockVisibility'\"><div class=\"ms__section ms__section_active ms__section_visible\"><div class=\"ms__content ms-text\" ng-hide=\"Editor.option == 'site.page.mixer' || Editor.option == 'lesson.page.mixer'\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__interactive\" type=\"checkbox\" ng-model=\"widget.interactive\"/><label class=\"checkbox-label-wrapper\" for=\"ms__interactive\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'blockSettings.interactive' | translate}} &nbsp;</span><a class=\"checkbox-link\" href=\"{{'editor.settings.interactive_tutorial_link' | translate}}\" target=\"_blank\" title=\"{{'editor.tutorial.title' | translate}}\">(?)</a></label></div></div><div class=\"ms__content ms-text\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__visibility_delay\" type=\"checkbox\" ng-model=\"widget.visibility_delay_enable\" ng-init=\"widget.visibility_delay ? false : widget.visibility_delay = 60\"/><label class=\"checkbox-label-wrapper\" for=\"ms__visibility_delay\" title=\"visibility delay\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.ShowDelayedWidget' | translate}}</span></label></div><div ng-show=\"widget.visibility_delay_enable\"><input class=\"input input_nano input_inline ms-input_border\" ng-change=\"$root.validateNumber(widget, 'visibility_delay')\" type=\"number\" min=\"0\" ng-style=\"{'width': '60px'}\" ng-model=\"widget.visibility_delay\"/><span>&nbsp; {{'widget.second' | translate}}</span></div></div></div></div>";

/***/ }),
/* 390 */
/***/ (function(module, exports) {

module.exports = "<div class=\"etn__elements-menu\"><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockDesign'}\" ng-click=\"openTab('blockDesign')\" ng-init=\"openTab('blockDesign')\">{{'editor.panel.tab1' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockVisibility'}\" ng-click=\"openTab('blockVisibility')\">{{'editor.panel.tab5' | translate}}</a></div><div product-fields-setting=\"\" ng-model=\"widget\" widget-id=\"{{widget.id}}\"></div><div class=\"ms image ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{'blockSettings.htmlcss' | translate}}</span><div class=\"ms__section\"><div class=\"ms__content ms-text\"><div class=\"ms__caption ms__caption_top\">{{'blockSettings.class' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><tags-input ng-model=\"widget.additional_classes\" min-length=\"0\" max-tags=\"10\" ,=\",\" allowed-tags-pattern=\"^[A-Z|a-z|0-9|+_-]+$\"></tags-input></div></div></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockVisibility'\"><div class=\"ms__section ms__section_active ms__section_visible\"><div class=\"ms__content ms-text\" ng-hide=\"Editor.option == 'site.page.mixer' || Editor.option == 'lesson.page.mixer'\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__interactive\" type=\"checkbox\" ng-model=\"widget.interactive\"/><label class=\"checkbox-label-wrapper\" for=\"ms__interactive\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'blockSettings.interactive' | translate}} &nbsp;</span><a class=\"checkbox-link\" href=\"{{'editor.settings.interactive_tutorial_link' | translate}}\" target=\"_blank\" title=\"{{'editor.tutorial.title' | translate}}\">(?)</a></label></div></div><div class=\"ms__content ms-text\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__visibility_delay\" type=\"checkbox\" ng-model=\"widget.visibility_delay_enable\" ng-init=\"widget.visibility_delay ? false : widget.visibility_delay = 60\"/><label class=\"checkbox-label-wrapper\" for=\"ms__visibility_delay\" title=\"visibility delay\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.ShowDelayedWidget' | translate}}</span></label></div><div ng-show=\"widget.visibility_delay_enable\"><input class=\"input input_nano input_inline ms-input_border\" ng-change=\"$root.validateNumber(widget, 'visibility_delay')\" type=\"number\" min=\"0\" ng-style=\"{'width': '60px'}\" ng-model=\"widget.visibility_delay\"/><span>&nbsp; {{'widget.second' | translate}}</span></div></div></div></div>";

/***/ }),
/* 391 */
/***/ (function(module, exports) {

module.exports = "<div class=\"etn__elements-menu\"><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockDesign'}\" ng-click=\"openTab('blockDesign')\" ng-init=\"openTab('blockDesign')\">{{'editor.panel.tab1' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockVisibility'}\" ng-click=\"openTab('blockVisibility')\">{{'editor.panel.tab5' | translate}}</a></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"accordion = {show_fast_settings: !accordion.show_fast_settings}\" ng-class=\"{'ms__title_active': accordion.show_fast_settings}\">{{'editor.panel.tab3' | translate}}</span><div class=\"ms__section\" ng-class=\"{'ms__section_active': accordion.show_fast_settings}\"><div class=\"ms__content ms-radio\"><div class=\"ms__caption ms__caption_top\">{{'widget.review.viewLabel' | translate}}:</div><div class=\"ms__input-wrapper\"><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__review-radio-design-1\" type=\"radio\" ng-value=\"false\" name=\"review-radio-design\" ng-model=\"widget.slider\"/><label class=\"radio-label-wrapper\" for=\"ms__review-radio-design-1\" title=\"Обычный\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.review.view1' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__review-radio-design-2\" type=\"radio\" ng-value=\"true\" name=\"review-radio-design\" ng-model=\"widget.slider\"/><label class=\"radio-label-wrapper\" for=\"ms__review-radio-design-2\" title=\"Слайдер\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.review.view2' | translate}}</span></label></div></div></div><div class=\"ms__content ms-radio\" ng-show=\"widget.slider\"><div class=\"ms__caption ms__caption_top\">{{'widget.review.optionsLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__autoplay\" type=\"checkbox\" checked=\"\" ng-true-value=\"3000\" ng-false-value=\"0\" ng-model=\"widget.settings.autoplay\"/><label class=\"checkbox-label-wrapper\" for=\"ms__autoplay\" title=\"Автопереход\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.review.autoslideLabel' | translate}}</span></label></div></div></div></div></div><div reviews-fields-setting=\"\" ng-model=\"widget\" widget-id=\"{{widget.id}}\" ng-if=\"widget\"></div><div class=\"ms image ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{'blockSettings.htmlcss' | translate}}</span><div class=\"ms__section\"><div class=\"ms__content ms-text\"><div class=\"ms__caption ms__caption_top\">{{'blockSettings.class' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><tags-input ng-model=\"widget.additional_classes\" min-length=\"0\" max-tags=\"10\" ,=\",\" allowed-tags-pattern=\"^[A-Z|a-z|0-9|+_-]+$\"></tags-input></div></div></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockVisibility'\"><div class=\"ms__section ms__section_active ms__section_visible\"><div class=\"ms__content ms-text\" ng-hide=\"Editor.option == 'site.page.mixer' || Editor.option == 'lesson.page.mixer'\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__interactive\" type=\"checkbox\" ng-model=\"widget.interactive\"/><label class=\"checkbox-label-wrapper\" for=\"ms__interactive\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'blockSettings.interactive' | translate}} &nbsp;</span><a class=\"checkbox-link\" href=\"{{'editor.settings.interactive_tutorial_link' | translate}}\" target=\"_blank\" title=\"{{'editor.tutorial.title' | translate}}\">(?)</a></label></div></div><div class=\"ms__content ms-text\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__visibility_delay\" type=\"checkbox\" ng-model=\"widget.visibility_delay_enable\" ng-init=\"widget.visibility_delay ? false : widget.visibility_delay = 60\"/><label class=\"checkbox-label-wrapper\" for=\"ms__visibility_delay\" title=\"visibility delay\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.ShowDelayedWidget' | translate}}</span></label></div><div ng-show=\"widget.visibility_delay_enable\"><input class=\"input input_nano input_inline ms-input_border\" ng-change=\"$root.validateNumber(widget, 'visibility_delay')\" type=\"number\" min=\"0\" ng-style=\"{'width': '60px'}\" ng-model=\"widget.visibility_delay\"/><span>&nbsp; {{'widget.second' | translate}}</span></div></div></div></div>";

/***/ }),
/* 392 */
/***/ (function(module, exports) {

module.exports = "<div class=\"etn__elements-menu\"><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockDesign'}\" ng-click=\"openTab('blockDesign')\" ng-init=\"openTab('blockDesign')\">{{'editor.panel.tab1' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockVisibility'}\" ng-click=\"openTab('blockVisibility')\">{{'editor.panel.tab5' | translate}}</a></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"accordion = {show_fast_settings: !accordion.show_fast_settings}\" ng-class=\"{'ms__title_active': accordion.show_fast_settings}\">{{'editor.panel.tab3' | translate}}</span><div class=\"ms__section\" ng-class=\"{'ms__section_active': accordion.show_fast_settings}\"><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.size' | translate}}</div><div class=\"ms__input-wrapper\" slidersize-setting=\"\" ng-model=\"widget.slides_style.height\"></div></div><div class=\"ms__content ms-radio\"><div class=\"ms__caption ms__caption_top\">{{'widget.slider.optionsLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__autoplay\" type=\"checkbox\" checked=\"\" ng-true-value=\"3000\" ng-false-value=\"0\" ng-model=\"widget.settings.autoplay\"/><label class=\"checkbox-label-wrapper\" for=\"ms__autoplay\" title=\"{{'widget.slider.option1' | translate}}\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.slider.option1' | translate}}</span></label></div></div><div class=\"ms__input-wrapper\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__thumbs\" type=\"checkbox\" checked=\"\" ng-model=\"widget.settings.thumbs\"/><label class=\"checkbox-label-wrapper\" for=\"ms__thumbs\" title=\"{{'widget.slider.option2' | translate}}\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.slider.option2' | translate}}</span></label></div></div></div><div class=\"ms__content ms-radio\"><div class=\"ms__caption ms__caption_top\">{{'widget.slider.transitionEffectLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__slider-radio-effect-1\" type=\"radio\" value=\"slide\" name=\"ms-target-action\" ng-model=\"widget.settings.effect\" checked=\"checked\"/><label class=\"radio-label-wrapper\" for=\"ms__slider-radio-effect-1\" title=\"{{'widget.slider.transitionEffect1' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.slider.transitionEffect1' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__slider-radio-effect-2\" type=\"radio\" value=\"fade\" name=\"ms-target-action\" ng-model=\"widget.settings.effect\"/><label class=\"radio-label-wrapper\" for=\"ms__slider-radio-effect-2\" title=\"{{'widget.slider.transitionEffect2' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.slider.transitionEffect2' | translate}}</span></label></div></div></div></div></div><div class=\"ms ms-tab-pane\"><span class=\"ms__title\" ng-class=\"{'ms__title_active': accordion.show_slider_additional}\"><div class=\"ms__title-name\" ng-click=\"accordion.show_fast_settings = false; accordion.show_slider_additional = !accordion.show_slider_additional\">{{'widget.slider.constructor' | translate}}</div></span><div class=\"ms__section ms__section_visible\" ng-class=\"{'ms__section_active': accordion.show_slider_additional}\"><div class=\"ms__content\" slider-fields-setting=\"\" ng-model=\"widget\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-text\"><div class=\"ms__input-wrapper\"><input class=\"checkbox\" id=\"ms__form-showcaption\" type=\"checkbox\" checked=\"\" ng-model=\"widget.show_caption\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-showcaption\" title=\"Отображать описание\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\"> {{'widget.slider.tab2' | translate}}</span></label></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'modulesSettings.colorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_slider-range\"><div color-setting=\"\" ng-model=\"widget.caption_style.color\"></div><label class=\"label ms__label\">{{'modulesSettings.colorLabel' | translate}}</label></div><div class=\"ms__input ms__input_range\" size-setting=\"\" ng-model=\"widget.caption_style.fontSize\"></div></div></div><div class=\"ms__content ms-align\"><div class=\"ms__caption\">{{'modulesSettings.textAlignLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" aligment-setting=\"\" ng-model=\"widget.caption_style.textAlign\"></div></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.fontLabel' | translate}}</div><div class=\"input-wrapper inline-wrapper ms__input_half ms__input_half-margin\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.caption_style.fontFamily\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.caption_style.fontFamily || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in Editor.Instrumentations.fonts\" ng-click=\"optionCheck($event, font.family);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper inline-wrapper ms__input_half\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.caption_style.fontWeight\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.caption_style.fontWeight || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{weight}}\" ng-repeat=\"weight in ['normal', 'bold', 'bolder', 'lighter']\" ng-click=\"optionCheck($event, weight);\">{{weight}}</li></ul></div></perfect-scrollbar></div></div><label class=\"label ms__label\">{{'modulesSettings.fontWeightLabel' | translate}}</label></div></div></div></div><div class=\"ms image ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{'blockSettings.htmlcss' | translate}}</span><div class=\"ms__section\"><div class=\"ms__content ms-text\"><div class=\"ms__caption ms__caption_top\">{{'blockSettings.class' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><tags-input ng-model=\"widget.additional_classes\" min-length=\"0\" max-tags=\"10\" ,=\",\" allowed-tags-pattern=\"^[A-Z|a-z|0-9|+_-]+$\"></tags-input></div></div></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockVisibility'\"><div class=\"ms__section ms__section_active ms__section_visible\"><div class=\"ms__content ms-text\" ng-hide=\"Editor.option == 'site.page.mixer' || Editor.option == 'lesson.page.mixer'\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__interactive\" type=\"checkbox\" ng-model=\"widget.interactive\"/><label class=\"checkbox-label-wrapper\" for=\"ms__interactive\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'blockSettings.interactive' | translate}} &nbsp;</span><a class=\"checkbox-link\" href=\"{{'editor.settings.interactive_tutorial_link' | translate}}\" target=\"_blank\" title=\"{{'editor.tutorial.title' | translate}}\">(?)</a></label></div></div><div class=\"ms__content ms-text\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__visibility_delay\" type=\"checkbox\" ng-model=\"widget.visibility_delay_enable\" ng-init=\"widget.visibility_delay ? false : widget.visibility_delay = 60\"/><label class=\"checkbox-label-wrapper\" for=\"ms__visibility_delay\" title=\"visibility delay\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.ShowDelayedWidget' | translate}}</span></label></div><div ng-show=\"widget.visibility_delay_enable\"><input class=\"input input_nano input_inline ms-input_border\" ng-change=\"$root.validateNumber(widget, 'visibility_delay')\" type=\"number\" min=\"0\" ng-style=\"{'width': '60px'}\" ng-model=\"widget.visibility_delay\"/><span>&nbsp; {{'widget.second' | translate}}</span></div></div></div></div>";

/***/ }),
/* 393 */
/***/ (function(module, exports) {

module.exports = "<div class=\"etn__elements-menu\"><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockDesign'}\" ng-click=\"openTab('blockDesign')\" ng-init=\"openTab('blockDesign')\">{{'editor.panel.tab1' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockSettings'}\" ng-click=\"openTab('blockSettings')\">{{'editor.panel.tab2' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockVisibility'}\" ng-click=\"openTab('blockVisibility')\">{{'editor.panel.tab5' | translate}}</a></div><div class=\"ms\" social-fields-setting=\"\" ng-model=\"widget\" widget-id=\"{{widget.id}}\" ng-show=\"editCurrentTab == 'blockSettings'\"></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockDesign'\"><div class=\"ms__section ms__section_active\"><div class=\"ms__content\"><div class=\"ms__caption\">{{'widget.social.iconsPackLabel' | translate}}</div><div class=\"select\" str-select=\"\" ng-model=\"widget.style_attributes.fontFamily\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.style_attributes.fontFamily || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{pack}}\" ng-repeat=\"pack in ['social-icon-pack-1', 'social-icon-pack-2']\" ng-click=\"optionCheck($event, pack);\">{{pack}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"ms__content ms-radio\"><div class=\"ms__caption ms__caption_top\">{{'modulesSettings.iconsColor' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__form-radio-1\" type=\"radio\" value=\"default\" name=\"ms-target-action\" ng-model=\"widget.color_type\" checked=\"\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-1\" title=\"{{'widget.social.color1' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.social.color1' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__form-radio-2\" type=\"radio\" value=\"custom\" name=\"ms-target-action\" ng-model=\"widget.color_type\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-2\" title=\"{{'widget.social.color2' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.social.color2' | translate}}</span></label></div></div></div><div class=\"ms__content ms-color\" ng-if=\"widget.color_type == 'custom'\"><div class=\"ms__caption\">{{'modulesSettings.colorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"widget.style_attributes.color\"></div></div></div><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"widget.style_attributes.backgroundColor\"></div></div></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'widget.social.iconsSizeLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" ng-model=\"widget.style_attributes.fontSize\"></div></div><div class=\"ms__content ms-align\"><div class=\"ms__caption\">{{'modulesSettings.textAlignLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" aligment-setting=\"\" ng-model=\"widget.style_attributes.textAlign\"></div></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.marginLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.icons_margin\"></div></div></div></div></div><div class=\"ms image ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{'blockSettings.htmlcss' | translate}}</span><div class=\"ms__section\"><div class=\"ms__content ms-text\"><div class=\"ms__caption ms__caption_top\">{{'blockSettings.class' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><tags-input ng-model=\"widget.additional_classes\" min-length=\"0\" max-tags=\"10\" ,=\",\" allowed-tags-pattern=\"^[A-Z|a-z|0-9|+_-]+$\"></tags-input></div></div></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockVisibility'\"><div class=\"ms__section ms__section_active ms__section_visible\"><div class=\"ms__content ms-text\" ng-hide=\"Editor.option == 'site.page.mixer' || Editor.option == 'lesson.page.mixer' || Editor.mode == 'form.page.editor'\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__interactive\" type=\"checkbox\" ng-model=\"widget.interactive\"/><label class=\"checkbox-label-wrapper\" for=\"ms__interactive\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'blockSettings.interactive' | translate}} &nbsp;</span><a class=\"checkbox-link\" href=\"{{'editor.settings.interactive_tutorial_link' | translate}}\" target=\"_blank\" title=\"{{'editor.tutorial.title' | translate}}\">(?)</a></label></div></div><div class=\"ms__content ms-text\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__visibility_delay\" type=\"checkbox\" ng-model=\"widget.visibility_delay_enable\" ng-init=\"widget.visibility_delay ? false : widget.visibility_delay = 60\"/><label class=\"checkbox-label-wrapper\" for=\"ms__visibility_delay\" title=\"visibility delay\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.ShowDelayedWidget' | translate}}</span></label></div><div ng-show=\"widget.visibility_delay_enable\"><input class=\"input input_nano input_inline ms-input_border\" ng-change=\"$root.validateNumber(widget, 'visibility_delay')\" type=\"number\" min=\"0\" ng-style=\"{'width': '60px'}\" ng-model=\"widget.visibility_delay\"/><span>&nbsp; {{'widget.second' | translate}}</span></div></div></div></div>";

/***/ }),
/* 394 */
/***/ (function(module, exports) {

module.exports = "<div subscribe-form-setting=\"\" ng-model=\"widget\" widget-id=\"{{widget.id}}\"><div class=\"etn__elements-menu\"><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockDesign'}\" ng-click=\"openTab('blockDesign')\">{{'editor.panel.tab1' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockSettings'}\" ng-click=\"openTab('blockSettings')\" ng-init=\"openTab('blockDesign')\" ng-hide=\"widget.disable_form_settings\">{{'editor.panel.tab2' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockVisibility'}\" ng-click=\"openTab('blockVisibility')\">{{'editor.panel.tab5' | translate}}</a></div><!-- blockDesign--><div class=\"ms ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"accordion = {show_subscribe_fast_settings: !accordion.show_subscribe_fast_settings}\" ng-class=\"{'ms__title_active': accordion.show_subscribe_fast_settings}\">{{'editor.panel.tab3' | translate}}</span><div class=\"ms__section\" ng-if=\"accordion.show_subscribe_fast_settings\" ng-class=\"{'ms__section_active': accordion.show_subscribe_fast_settings}\"><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.form.nameLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" value=\"Send\" ng-model=\"widget.title\"/></div></div></div><div class=\"ms__content ms-radio\"><div class=\"ms__caption ms__caption_top\">{{'widget.form.viewLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__form-radio-design-1\" type=\"radio\" value=\"vertical\" name=\"form-radio-design\" ng-model=\"widget.form_design\" checked=\"checked\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-design-1\" title=\"{{'widget.form.vertical' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.form.view1' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\" ng-show=\"!widget.product_selected\"><input class=\"radio\" id=\"ms__form-radio-design-2\" type=\"radio\" value=\"horizontal\" name=\"form-radio-design\" ng-model=\"widget.form_design\" checked=\"checked\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-design-2\" title=\"{{'widget.form.horizontal' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.form.view2' | translate}}</span></label></div><div class=\"checkbox-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"ms__form-checkbox-1\" type=\"checkbox\" checked=\"\" ng-model=\"widget.as_modal\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-1\" title=\"Mark a message\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.form.modal' | translate}}</span></label></div><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" type=\"checkbox\" ng-model=\"widget.labels\"/><label class=\"checkbox-label-wrapper\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.form.labels' | translate}}</span></label></div></div></div><div class=\"ms__content ms-input\"><div class=\"ms__caption\">{{'widget.form.tagLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" ng-model=\"widget.tag\" placeholder=\"{{'widget.form.tagLabel' | translate}}\"/></div></div></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"accordion = {show_form_constructor: !accordion.show_form_constructor}\" ng-class=\"{'ms__title_active': accordion.show_form_constructor}\">{{'widget.form.constructorLabel' | translate}}</span><div class=\"ms__section\" ng-show=\"accordion.show_form_constructor\" ng-class=\"{'ms__section_active': accordion.show_form_constructor}\"><div class=\"ms__content\" subscribe-form-fields-setting=\"\" ng-model=\"widget\" widget-id=\"{{widget.id}}\"></div></div></div><div class=\"ms ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"accordion = {show_design_settings: !accordion.show_design_settings};\" ng-class=\"{'ms__title_active': accordion.show_design_settings}\">{{'widget.form.designLabel' | translate}}</span><div class=\"ms__section ms__section_visible\" ng-if=\"accordion.show_design_settings\" ng-class=\"{'ms__section_active': accordion.show_design_settings}\"><div class=\"header-menu__nav\" ng-init=\"setDesignTab('form')\"><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': currentDesignTab == 'form'}\" ng-click=\"setDesignTab('form')\">{{'widget.form.designTab2' | translate}}</a><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': currentDesignTab == 'button'}\" ng-click=\"setDesignTab('button')\">{{'widget.form.designTab1' | translate}}</a><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': currentDesignTab == 'fields'}\" ng-click=\"setDesignTab('fields')\">{{'widget.form.designTab3' | translate}}</a><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': currentDesignTab == 'labels'}\" ng-click=\"setDesignTab('labels')\">{{'widget.form.designTab4' | translate}}</a></div><div ng-if=\"currentDesignTab == 'button'\"><p>&nbsp;</p><div class=\"ms__content ms-color\"><div class=\"ms__input-wrapper\" ng-init=\"colorType = 'examples'\"><div class=\"radio-wrapper ms-radio radio-wrapper_inline\"><input class=\"radio\" id=\"ms__form-radio-1-color\" type=\"radio\" value=\"examples\" name=\"button-form-color{{widget[form_property].id}}\" ng-model=\"colorType\" checked=\"checked\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-1-color\" title=\"{{'widget.form.action1' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.form.colorExamples' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio radio-wrapper_inline\"><input class=\"radio\" id=\"ms__form-radio-2-color\" type=\"radio\" value=\"custom\" name=\"button-form-color{{widget[form_property].id}}\" ng-model=\"colorType\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-2-color\" title=\"{{'widget.form.action2' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.form.mycolor' | translate}}</span></label></div></div></div><div class=\"ms__content ms-text\" colors-setting=\"\" set-attributes=\"backgroundColor\" ng-model=\"widget.button.style\" ng-show=\"colorType == 'examples'\"></div><div class=\"ms__content ms-color\" ng-show=\"colorType == 'custom'\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"widget.button.style.backgroundColor\"></div></div></div><div class=\"ms__content ms-color\" gradient-setting=\"\" ng-model=\"widget.button.style\" widget-id=\"{{widget.id}}\" ng-show=\"colorType == 'custom'\"></div><div class=\"ms__content ms-border\" border-setting=\"\" ng-model=\"widget.button.style.border\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.borderRadiusLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" ng-model=\"widget.button.style.borderRadius\"></div></div><hr class=\"ms__separator\"/><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'modulesSettings.textLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_slider-range\"><div color-setting=\"\" ng-model=\"widget.button.style.color\"></div><label class=\"label ms__label\">{{'modulesSettings.colorLabel' | translate}}</label></div><div class=\"ms__input ms__input_range\" size-setting=\"\" ng-model=\"widget.button.style.fontSize\"></div></div></div><div class=\"ms__content ms__content_nomargin\"><div class=\"ms__caption\">{{'modulesSettings.fontLabel' | translate}}</div><div class=\"input-wrapper inline-wrapper ms__input_half ms__input_half-margin\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.button.style.fontFamily\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{$parent.$parent.widget.button.style.fontFamily || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in Editor.Instrumentations.fonts\" ng-click=\"optionCheck($event, font.family);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper inline-wrapper ms__input_half\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.button.style.fontWeight\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{$parent.$parent.widget.button.style.fontWeight || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{weight}}\" ng-repeat=\"weight in ['normal', 'bold', 'bolder', 'lighter']\" ng-click=\"optionCheck($event, weight);\">{{weight}}</li></ul></div></perfect-scrollbar></div></div><label class=\"label ms__label\">{{'modulesSettings.fontWeightLabel' | translate}}</label></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.icon' | translate}}</div><div icon-selector-setting=\"\" ng-model=\"widget.button.icon\"></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.additionalText' | translate}}</div><div class=\"ms__input ms__input_large\"><input class=\"input input_extra-small ms-input_border\" type=\"text\" placeholder=\"\" ng-model=\"widget.button.additional_text.title\"/></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'modulesSettings.textColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_slider-range\"><div color-setting=\"\" ng-model=\"widget.button.additional_text.color\"></div><label class=\"label ms__label\">{{'modulesSettings.colorLabel' | translate}}</label></div><div class=\"ms__input ms__input_range\" size-setting=\"\" ng-model=\"widget.button.additional_text.fontSize\"></div></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.fontLabel' | translate}}</div><div class=\"input-wrapper inline-wrapper ms__input_half ms__input_half-margin\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.button.additional_text.fontFamily\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.button.additional_text.fontFamily || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in Editor.Instrumentations.fonts\" ng-click=\"optionCheck($event, font.family);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper inline-wrapper ms__input_half\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.button.additional_text.fontWeight\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.button.additional_text.fontWeight || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{weight}}\" ng-repeat=\"weight in ['normal', 'bold', 'bolder', 'lighter']\" ng-click=\"optionCheck($event, weight);\">{{weight}}</li></ul></div></perfect-scrollbar></div></div><label class=\"label ms__label\">{{'modulesSettings.fontWeightLabel' | translate}}</label></div></div><hr class=\"ms__separator\"/><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.button.style.padding\"></div></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.marginLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.button.style.margin\"></div></div></div></div><div ng-if=\"currentDesignTab == 'form'\"><p>&nbsp;</p><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"widget.form_style.backgroundColor\"></div></div></div><div class=\"ms__content ms-border\" border-setting=\"\" ng-model=\"widget.form_style.border\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.borderRadiusLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" ng-model=\"widget.form_style.borderRadius\"></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.form_style.padding\"></div></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.marginLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.style_attributes.padding\"></div></div></div></div><div ng-if=\"currentDesignTab == 'fields'\"><p>&nbsp;</p><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"widget.form_fields_style_attributes.backgroundColor\"></div></div></div><div class=\"ms__content ms-align\"><div class=\"ms__caption\">{{'widget.form.textAlign' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" aligment-setting=\"\" ng-model=\"widget.form_fields_style_attributes.textAlign\"></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.form.fontSize' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input\" size-setting=\"\" ng-model=\"widget.form_fields_style_attributes.fontSize\"></div></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.fontLabel' | translate}}</div><div class=\"input-wrapper inline-wrapper ms__input_half__fields ms__input_half-margin_fields\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.form_fields_style_attributes.fontFamily\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{$parent.$parent.widget.button.style.fontFamily || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in Editor.Instrumentations.fonts\" ng-click=\"optionCheck($event, font.family);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper inline-wrapper ms__input_half__fields\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.form_fields_style_attributes.fontWeight\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{$parent.$parent.widget.button.style.fontWeight || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{weight}}\" ng-repeat=\"weight in ['normal', 'bold', 'bolder', 'lighter']\" ng-click=\"optionCheck($event, weight);\">{{weight}}</li></ul></div></perfect-scrollbar></div></div><label class=\"label ms__label\">{{'modulesSettings.fontWeightLabel' | translate}}</label></div><div class=\"ms__input ms__input_color\"><div color-setting=\"\" ng-model=\"widget.form_fields_style_attributes.color\"></div><label class=\"ms__label\">{{'modulesSettings.colorLabel' | translate}}</label></div></div><div class=\"ms__content ms-border\" border-setting=\"\" ng-model=\"widget.form_fields_style_attributes.border\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.borderRadiusLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" ng-model=\"widget.form_fields_style_attributes.borderRadius\"></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.form_fields_style_attributes.padding\"></div></div></div></div><div ng-if=\"currentDesignTab == 'labels'\"><p>&nbsp;</p><div class=\"ms__content ms-align\"><div class=\"ms__caption\">{{'widget.form.textAlign' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" aligment-setting=\"\" ng-model=\"widget.labels_style_attributes.textAlign\"></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.form.fontSize' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input\" size-setting=\"\" ng-model=\"widget.labels_style_attributes.fontSize\"></div></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.fontLabel' | translate}}</div><div class=\"input-wrapper inline-wrapper ms__input_half__fields ms__input_half-margin_fields\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.labels_style_attributes.fontFamily\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{$parent.$parent.widget.button.style.fontFamily || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in Editor.Instrumentations.fonts\" ng-click=\"optionCheck($event, font.family);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper inline-wrapper ms__input_half__fields\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.labels_style_attributes.fontWeight\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{$parent.$parent.widget.button.style.fontWeight || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{weight}}\" ng-repeat=\"weight in ['normal', 'bold', 'bolder', 'lighter']\" ng-click=\"optionCheck($event, weight);\">{{weight}}</li></ul></div></perfect-scrollbar></div></div><label class=\"label ms__label\">{{'modulesSettings.fontWeightLabel' | translate}}</label></div><div class=\"ms__input ms__input_color\"><div color-setting=\"\" ng-model=\"widget.labels_style_attributes.color\"></div><label class=\"ms__label\">{{'modulesSettings.colorLabel' | translate}}</label></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.fontLinkLabel' | translate}}</div><div class=\"input-wrapper inline-wrapper ms__input_half__fields ms__input_half-margin_fields\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.form_link_style_attributes.fontFamily\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{$parent.$parent.widget.button.style.fontFamily || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in Editor.Instrumentations.fonts\" ng-click=\"optionCheck($event, font.family);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper inline-wrapper ms__input_half__fields\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.form_link_style_attributes.fontWeight\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{$parent.$parent.widget.button.style.fontWeight || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{weight}}\" ng-repeat=\"weight in ['normal', 'bold', 'bolder', 'lighter']\" ng-click=\"optionCheck($event, weight);\">{{weight}}</li></ul></div></perfect-scrollbar></div></div><label class=\"label ms__label\">{{'modulesSettings.fontWeightLabel' | translate}}</label></div><div class=\"ms__input ms__input_color\"><div color-setting=\"\" ng-model=\"widget.form_link_style_attributes.color\"></div><label class=\"ms__label\">{{'modulesSettings.colorLabel' | translate}}</label></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.labels_style_attributes.padding\"></div></div></div></div></div></div><!-- Блок Действия после заполнения формы--><div class=\"ms ms-tab-pane\" ng-if=\"editCurrentTab == 'blockSettings' &amp;&amp; !widget.disable_form_settings\"><!-- Добавит в группы--><span class=\"ms__title\" ng-click=\"accordion.show_subscribe_add_categories = !accordion.show_subscribe_add_categories\" ng-class=\"{'ms__title_active': accordion.show_subscribe_add_categories, 'ms__title_error': $root.error &amp;&amp; $root.error['subscribe_form.categories']}\">{{'widget.form.addGroup' | translate}}</span><div class=\"ms__section ms__section_visible\" ng-if=\"accordion.show_subscribe_add_categories\" ng-class=\"{'ms__section_active': accordion.show_subscribe_add_categories}\"><div class=\"ms__content ms-radio\"><div class=\"ms__input-wrapper\" ng-class=\"{'ms__input-wrapper_error': $root.error &amp;&amp; $root.error['subscribe_form.categories']}\"><div ivh-treeview=\"widget.categories\" ivh-treeview-id-attribute=\"'id'\" ivh-treeview-label-attribute=\"'title'\" ivh-treeview-children-attribute=\"'groups'\" ivh-treeview-selected-attribute=\"'selected'\"></div><div class=\"ms__input-error\" ng-click=\"$root.error['subscribe_form.categories'] = false\" ng-if=\"$root.error &amp;&amp; $root.error['subscribe_form.categories']\">{{ $root.error['subscribe_form.categories'] }}</div></div></div></div><span class=\"ms__title\" ng-click=\"accordion.show_subscribe_actions = !accordion.show_subscribe_actions\" ng-class=\"{'ms__title_active': accordion.show_subscribe_actions}\">{{'widget.form.actionLabel' | translate}}</span><div class=\"ms__section\" ng-if=\"accordion.show_subscribe_actions\" ng-class=\"{'ms__section_active': accordion.show_subscribe_actions}\"><!-- Отправлять письмо активации--><div class=\"ms__content ms-text\" ng-show=\"widget.single_opt_in\"><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__form-send-activation-email\" type=\"checkbox\" checked=\"\" ng-model=\"widget.activation\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-send-activation-email\" title=\"{{'widget.form.sendActivateEmail' | translate}}\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.form.sendActivateEmail' | translate}}</span></label></div></div><!-- Подписывать на рассылки--><div class=\"ms__content ms-text\" ng-show=\"!widget.single_opt_in\"><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__form-subscribe-1\" type=\"checkbox\" checked=\"\" ng-model=\"widget.subscribe\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-subscribe-1\" title=\"Mark a message\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.form.subscribeLabel' | translate}}</span></label></div></div><!-- URL ПОСЛЕ АКТИВАЦИИ--><div class=\"ms__content ms-text\" ng-show=\"(widget.subscribe &amp;&amp; !widget.single_opt_in) || (widget.activation &amp;&amp; widget.single_opt_in)\"><div class=\"ms__caption\" title=\"{{'widget.form.urlToRedirectAfterConfirmingEmail' | translate}}\">{{'widget.form.urlLabel2' | translate}}<span title=\"{{'widget.form.urlToRedirectAfterConfirmingEmail' | translate}}\" style=\"cursor:help;\">&nbsp;(?)</span></div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" style=\"font-size:12px;\" placeholder=\"{{widget.after_activate_url_placeholder}}\" ng-model=\"widget.after_activate_url\"/></div></div></div><!-- Действия--><div class=\"ms__content ms-radio\"><div class=\"ms__input-wrapper\"><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__form-radio-1\" type=\"radio\" value=\"show_message\" name=\"ms-target-action\" ng-model=\"widget.submit_action\" ng-change=\"widget.handleRadioClick(false)\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-1\" title=\"{{'widget.form.showThankMessage' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.form.action1' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__form-radio-2\" type=\"radio\" value=\"open_link\" name=\"ms-target-action\" ng-model=\"widget.submit_action\" ng-change=\"widget.handleRadioClick(false)\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-2\" title=\"{{'widget.form.openLink' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.form.action2' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"ms__form-radio-3\" type=\"radio\" value=\"make_order\" name=\"ms-target-action\" ng-model=\"widget.submit_action\" ng-change=\"widget.handleRadioClick(true)\"/><label class=\"radio-label-wrapper\" for=\"ms__form-radio-3\" title=\"{{'widget.form.orderProduct' | translate}}\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.form.orderProduct' | translate}}</span></label></div></div></div><!-- Показать сообщение--><div class=\"ms__content ms-textarea\" ng-show=\"widget.submit_action == 'show_message'\"><div class=\"ms__caption\">{{'widget.form.messageLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><textarea class=\"textarea__content textarea_extra-small textarea ms-input_border\" placeholder=\"{{'widget.form.enterYourMessage' | translate}}\" ng-model=\"widget.success_message\"></textarea></div><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__form-show_message-1\" type=\"checkbox\" checked=\"\" ng-model=\"widget.with_share\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-show_message-1\" title=\"Mark a message\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.form.addSocial' | translate}}</span></label></div></div></div><!-- Открыть ссылку--><div class=\"ms__content ms-text\" ng-show=\"widget.submit_action == 'open_link'\"><div class=\"ms__caption\" title=\"{{'widget.form.urlToRedirectAfterSubmitForm' | translate}}\">{{'widget.form.urlLabel' | translate}}<span title=\"{{'widget.form.urlToRedirectAfterSubmitForm' | translate}}\" style=\"cursor:help;\">&nbsp;(?)</span></div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" style=\"font-size:12px;\" placeholder=\"{{widget.redirect_url_placeholder}}\" ng-model=\"widget.redirect_url\"/></div></div></div><!-- Оформить заказ на продукт--><div class=\"ms__content ms-text\" ng-if=\"widget.submit_action == 'make_order'\"><div class=\"ms__caption\">{{'widget.form.addProducts' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" ng-model=\"myQuery\" ng-model-options=\"{debounce: 150}\" placeholder=\"{{'widget.form.productsSearch' | translate}}\"/></div></div><div class=\"ms__input-wrapper\" ivh-treeview=\"widget.frame_settings.products\" ivh-treeview-id-attribute=\"'id'\" ivh-treeview-label-attribute=\"'title'\" ivh-treeview-children-attribute=\"'goods'\" ivh-treeview-filter=\"myQuery\" ivh-treeview-selected-attribute=\"'selected'\"></div></div><div class=\"ms__content ms-text\" ng-show=\"widget.submit_action == 'make_order'\"><div class=\"ms__caption\">{{'widget.form.tagLabel' | translate}}:</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" ng-model=\"widget.frame_settings.tag\"/></div></div></div><div class=\"ms__content ms-text\" ng-show=\"widget.submit_action == 'make_order'\"><div class=\"ms__caption\">{{'widget.form.coupon' | translate}}:</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" ng-model=\"widget.frame_settings.kupon\"/></div></div></div></div><!-- Удалить из групп--><span class=\"ms__title\" ng-click=\"accordion.show_subscribe_add_ex_categories = !accordion.show_subscribe_add_ex_categories\" ng-class=\"{'ms__title_active': accordion.show_subscribe_add_ex_categories}\">{{'widget.form.exGroup' | translate}}</span><div class=\"ms__section\" ng-if=\"accordion.show_subscribe_add_ex_categories\" ng-class=\"{'ms__section_active': accordion.show_subscribe_add_ex_categories}\"><div class=\"ms__content ms-radio\"><div class=\"ms__input-wrapper\" ivh-treeview=\"widget.ex_categories\" ivh-treeview-id-attribute=\"'id'\" ivh-treeview-label-attribute=\"'title'\" ivh-treeview-children-attribute=\"'groups'\" ivh-treeview-selected-attribute=\"'selected'\"></div></div></div></div><div class=\"ms ms-tab-pane\" ng-if=\"editCurrentTab == 'blockSettings' &amp;&amp; !widget.disable_form_settings\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{'widget.form.utmsLabel' | translate}}</span><div class=\"ms__section ms__section_navigation-settings\"><div class=\"ms__caption\">{{'widget.form.channel' | translate}}:</div><div class=\"ms__content ms-text\"><select class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\" ng-options=\"channel.name as channel.title for channel in ad_channels\" ng-init=\"add_ad_channels()\" ng-model=\"widget.ad_utm_medium\"></select></div><div class=\"ms__content ms-text\" ng-if=\"widget.ad_utm_medium == 'other'\"><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" ng-model=\"widget.ad_other_utm_medium\"/></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.form.source' | translate}}:</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" ng-model=\"widget.ad_utm_source\"/></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.form.campaign' | translate}}:</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" ng-model=\"widget.ad_utm_campaign\"/></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.form.content' | translate}}:</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" ng-model=\"widget.ad_utm_content\"/></div></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.form.term' | translate}}:</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" ng-model=\"widget.ad_utm_term\"/></div></div></div></div></div><!-- as_modal--><div class=\"ms ms-tab-pane\" ng-if=\"widget.as_modal\"><span class=\"ms__title\" ng-click=\"accordion.show_parent_button = !accordion.show_parent_button\" ng-class=\"{'ms__title_active': accordion. show_parent_button}\">{{'widget.form.tab7' | translate}}</span><div class=\"ms__section\" ng-if=\"accordion.show_parent_button\" ng-class=\"{'ms__section_active': accordion.show_parent_button}\"><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.fontLabel' | translate}}</div><div class=\"input-wrapper inline-wrapper ms__input_half ms__input_half-margin\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.parent_button.style.fontFamily\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.parent_button.style.fontFamily || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in Editor.Instrumentations.fonts\" ng-click=\"optionCheck($event, font.family);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper inline-wrapper ms__input_half\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.parent_button.style.fontWeight\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.parent_button.style.fontWeight || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{weight}}\" ng-repeat=\"weight in ['normal', 'bold', 'bolder', 'lighter']\" ng-click=\"optionCheck($event, weight);\">{{weight}}</li></ul></div></perfect-scrollbar></div></div><label class=\"label ms__label\">{{'modulesSettings.fontWeightLabel' | translate}}</label></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.form.textLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_slider-range\"><div color-setting=\"\" ng-model=\"widget.parent_button.style.color\"></div><label class=\"label ms__label\">{{'widget.form.colorLabel' | translate}}</label></div><div class=\"ms__input ms__input_range\" size-setting=\"\" ng-model=\"widget.parent_button.style.fontSize\"></div></div></div><div class=\"ms__content ms-align\"><div class=\"ms__caption\">{{'widget.form.positionLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" aligment-setting=\"\" ng-model=\"widget.parent_button.style.textAlign\"></div></div></div><hr class=\"ms__separator\"/><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'widget.form.colorBgLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"widget.parent_button.style.backgroundColor\"></div></div></div><div class=\"ms__content ms-border\" border-setting=\"\" ng-model=\"widget.parent_button.style.border\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'widget.form.borderLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" ng-model=\"widget.parent_button.style.borderRadius\"></div></div><div class=\"ms__content ms-size\"><div class=\"ms__caption\">{{'widget.form.buttonWidth' | translate}}</div><div class=\"ms__input-wrapper\"><div><div size-select-setting=\"\" ng-model=\"widget.parent_button.style.width\"></div><label class=\"label ms__label\">{{'widget.form.width' | translate}}</label></div></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'widget.form.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.parent_button.style.padding\"></div></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.icon' | translate}}</div><div icon-selector-setting=\"\" ng-model=\"widget.parent_button.icon\"></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.additionalText' | translate}}</div><div class=\"ms__input ms__input_large\"><input class=\"input input_extra-small ms-input_border\" type=\"text\" placeholder=\"\" ng-model=\"widget.parent_button.additional_text.title\"/></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'modulesSettings.textColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_slider-range\"><div color-setting=\"\" ng-model=\"widget.parent_button.additional_text.color\"></div><label class=\"label ms__label\">{{'modulesSettings.colorLabel' | translate}}</label></div><div class=\"ms__input ms__input_range\" size-setting=\"\" ng-model=\"widget.parent_button.additional_text.fontSize\"></div></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.fontLabel' | translate}}</div><div class=\"input-wrapper inline-wrapper ms__input_half ms__input_half-margin\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.parent_button.additional_text.fontFamily\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.parent_button.additional_text.fontFamily || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in Editor.Instrumentations.fonts\" ng-click=\"optionCheck($event, font.family);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper inline-wrapper ms__input_half\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.parent_button.additional_text.fontWeight\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.parent_button.additional_text.fontWeight || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{weight}}\" ng-repeat=\"weight in ['normal', 'bold', 'bolder', 'lighter']\" ng-click=\"optionCheck($event, weight);\">{{weight}}</li></ul></div></perfect-scrollbar></div></div><label class=\"label ms__label\">{{'modulesSettings.fontWeightLabel' | translate}}</label></div></div></div><span class=\"ms__title\" ng-click=\"accordion.show_modal_settings = !accordion.show_modal_settings\" ng-class=\"{'ms__title_active': accordion. show_modal_settings}\">{{'widget.form.tab8' | translate}}</span><div class=\"ms__section\" ng-if=\"accordion.show_modal_settings\" ng-class=\"{'ms__section_active': accordion.show_modal_settings}\"><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.modalTitleText' | translate}}</div><div class=\"ms__input ms__input_large\"><input class=\"input input_extra-small ms-input_border\" type=\"text\" placeholder=\"\" ng-model=\"widget.modal_settings.title\"/></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'modulesSettings.fontLabel' | translate}}</div><div class=\"input-wrapper inline-wrapper ms__input_half ms__input_half-margin\"><div class=\"select\" str-select=\"\" ng-model=\"widget.modal_settings.style.fontFamily\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.modal_settings.style.fontFamily || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in Editor.Instrumentations.fonts\" ng-click=\"optionCheck($event, font.family);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper inline-wrapper ms__input_half\"><div class=\"select\" str-select=\"\" ng-model=\"widget.modal_settings.style.fontWeight\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\">{{widget.modal_settings.style.fontWeight || 'editor.selectDefaultOption' | translate}}</span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{weight}}\" ng-repeat=\"weight in ['normal', 'bold', 'bolder', 'lighter']\" ng-click=\"optionCheck($event, weight);\">{{weight}}</li></ul></div></perfect-scrollbar></div></div><label class=\"label ms__label\">{{'modulesSettings.fontWeightLabel' | translate}}</label></div></div><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.form.textLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_slider-range\"><div color-setting=\"\" ng-model=\"widget.modal_settings.style.color\"></div><label class=\"label ms__label\">{{'widget.form.colorLabel' | translate}}</label></div><div class=\"ms__input ms__input_range\" size-setting=\"\" ng-model=\"widget.modal_settings.style.fontSize\"></div></div></div><div class=\"ms__content ms-align\"><div class=\"ms__caption\">{{'widget.form.positionLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" aligment-setting=\"\" ng-model=\"widget.modal_settings.style.textAlign\"></div></div></div><div class=\"ms__content ms-size\"><div class=\"ms__caption\">{{'widget.form.modalWidth' | translate}}</div><div class=\"ms__input-wrapper\"><div><div size-select-setting=\"\" ng-model=\"widget.modal_settings.style.width\"></div><label class=\"label ms__label\">{{'widget.form.width' | translate}}</label></div></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'widget.form.modalPaddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.modal_settings.style.padding\"></div></div></div></div></div><!-- blockVisibility--><div class=\"ms ms-tab-pane\" ng-if=\"editCurrentTab == 'blockVisibility'\"><div class=\"ms__section ms__section_active ms__section_visible\"><div class=\"ms__content ms-text\" ng-hide=\"Editor.option == 'site.page.mixer' || Editor.option == 'lesson.page.mixer' || Editor.mode == 'form.page.editor'\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__interactive\" type=\"checkbox\" ng-model=\"widget.interactive\"/><label class=\"checkbox-label-wrapper\" for=\"ms__interactive\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'blockSettings.interactive' | translate}} &nbsp;</span><a class=\"checkbox-link\" href=\"{{'editor.settings.interactive_tutorial_link' | translate}}\" target=\"_blank\" title=\"{{'editor.tutorial.title' | translate}}\">(?)</a></label></div></div><div class=\"ms__content ms-text\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__visibility_delay\" type=\"checkbox\" ng-model=\"widget.visibility_delay_enable\" ng-init=\"widget.visibility_delay ? false : widget.visibility_delay = 60\"/><label class=\"checkbox-label-wrapper\" for=\"ms__visibility_delay\" title=\"visibility delay\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.ShowDelayedWidget' | translate}}</span></label></div><div ng-show=\"widget.visibility_delay_enable\"><input class=\"input input_nano input_inline ms-input_border\" ng-change=\"$root.validateNumber(widget, 'visibility_delay')\" type=\"number\" min=\"0\" ng-style=\"{'width': '60px'}\" ng-model=\"widget.visibility_delay\"/><span>&nbsp; {{'widget.second' | translate}}</span></div></div></div></div></div><div class=\"ms ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"accordion = {show_hover_settings_2: !accordion.show_hover_settings_2}\" ng-class=\"{'ms__title_active': accordion.show_hover_settings_2}\">{{'widget.form.hoverText1' | translate}}</span><div class=\"ms__section\" ng-class=\"{'ms__section_active': accordion.show_hover_settings_2}\" hover-setting=\"\" ng-model=\"widget\" access-key=\"hover_style\"></div></div><div class=\"ms ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign' &amp;&amp; widget.as_modal\"><span class=\"ms__title\" ng-click=\"accordion = {show_hover_settings: !accordion.show_hover_settings}\" ng-class=\"{'ms__title_active': accordion.show_hover_settings}\">{{'widget.form.hoverText2' | translate}}</span><div class=\"ms__section\" ng-class=\"{'ms__section_active': accordion.show_hover_settings}\" hover-setting=\"\" ng-model=\"widget\" access-key=\"hover_style\" button-type=\"parent_button\"></div></div><div class=\"ms image ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{'blockSettings.htmlcss' | translate}}</span><div class=\"ms__section\"><div class=\"ms__content ms-text\"><div class=\"ms__caption ms__caption_top\">{{'blockSettings.class' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><tags-input ng-model=\"widget.additional_classes\" min-length=\"0\" max-tags=\"10\" allowed-tags-pattern=\"^[A-Z|a-z|0-9|+_-]+$\"></tags-input></div></div></div></div></div>";

/***/ }),
/* 395 */
/***/ (function(module, exports) {

module.exports = "<div class=\"etn__elements-menu\"><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockDesign'}\" ng-click=\"openTab('blockDesign')\" ng-init=\"openTab('blockDesign')\">{{'editor.panel.tab1' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockVisibility'}\" ng-click=\"openTab('blockVisibility')\">{{'editor.panel.tab5' | translate}}</a></div><div class=\"ms ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign'\"><div class=\"ms__section ms__section_visible ms__section_active\"><div class=\"ms__content\"><div class=\"ms__caption\">{{'widget.table.designsLabel' | translate}}:</div><div class=\"ms__input-wrapper\"><div class=\"widget__themes-wrapper ta-center\"><div class=\"widget__theme-item widget__theme-item_table\" style=\"background-image: url('{{'widget.table.theme_image_1' | translate}}');\" ng-class=\"{'widget__theme-item_active': widget.design == 1}\" ng-click=\"widget.design = 1\"></div><div class=\"widget__theme-item widget__theme-item_table\" style=\"background-image: url('{{'widget.table.theme_image_2' | translate}}');\" ng-class=\"{'widget__theme-item_active': widget.design == 2}\" ng-click=\"widget.design = 2\"></div></div></div></div><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'widget.table.linesColor' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"widget.table_style.borderColor\"></div></div></div><div class=\"ms__content\" table-fields-setting=\"\" ng-model=\"widget\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'widget.table.colsLable' | translate}}</div><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__show_desc\" type=\"checkbox\" checked=\"\" ng-model=\"widget.show_description\"/><label class=\"checkbox-label-wrapper\" for=\"ms__show_desc\" title=\"Mark a message\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.table.description' | translate}}</span></label></div><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__showadditional\" type=\"checkbox\" checked=\"\" ng-model=\"widget.show_extra\"/><label class=\"checkbox-label-wrapper\" for=\"ms__showadditional\" title=\"Mark a message\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.table.additional' | translate}}</span></label></div><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__showbutton\" type=\"checkbox\" checked=\"\" ng-model=\"widget.show_button\"/><label class=\"checkbox-label-wrapper\" for=\"ms__showbutton\" title=\"Mark a message\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.table.button' | translate}}</span></label></div></div></div></div><div class=\"ms image ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{'blockSettings.htmlcss' | translate}}</span><div class=\"ms__section\"><div class=\"ms__content ms-text\"><div class=\"ms__caption ms__caption_top\">{{'blockSettings.class' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><tags-input ng-model=\"widget.additional_classes\" min-length=\"0\" max-tags=\"10\" ,=\",\" allowed-tags-pattern=\"^[A-Z|a-z|0-9|+_-]+$\"></tags-input></div></div></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockVisibility'\"><div class=\"ms__section ms__section_active ms__section_visible\"><div class=\"ms__content ms-text\" ng-hide=\"Editor.option == 'site.page.mixer' || Editor.option == 'lesson.page.mixer'\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__interactive\" type=\"checkbox\" ng-model=\"widget.interactive\"/><label class=\"checkbox-label-wrapper\" for=\"ms__interactive\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'blockSettings.interactive' | translate}} &nbsp;</span><a class=\"checkbox-link\" href=\"{{'editor.settings.interactive_tutorial_link' | translate}}\" target=\"_blank\" title=\"{{'editor.tutorial.title' | translate}}\">(?)</a></label></div></div><div class=\"ms__content ms-text\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__visibility_delay\" type=\"checkbox\" ng-model=\"widget.visibility_delay_enable\" ng-init=\"widget.visibility_delay ? false : widget.visibility_delay = 60\"/><label class=\"checkbox-label-wrapper\" for=\"ms__visibility_delay\" title=\"visibility delay\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.ShowDelayedWidget' | translate}}</span></label></div><div ng-show=\"widget.visibility_delay_enable\"><input class=\"input input_nano input_inline ms-input_border\" ng-change=\"$root.validateNumber(widget, 'visibility_delay')\" type=\"number\" min=\"0\" ng-style=\"{'width': '60px'}\" ng-model=\"widget.visibility_delay\"/><span>&nbsp; {{'widget.second' | translate}}</span></div></div></div></div>";

/***/ }),
/* 396 */
/***/ (function(module, exports) {

module.exports = "<div class=\"etn__elements-menu\"><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockDesign'}\" ng-click=\"openTab('blockDesign')\" ng-init=\"openTab('blockDesign')\">{{'editor.panel.tab1' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockVisibility'}\" ng-click=\"openTab('blockVisibility')\">{{'editor.panel.tab5' | translate}}</a></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockDesign'\"><div class=\"ms__section ms__section_active\"><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"widget.style_attributes.backgroundColor\"></div></div></div><div class=\"ms__content ms-border\" border-setting=\"\" ng-model=\"widget.style_attributes.border\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.borderRadiusLabel' | translate}}</div><div class=\"ms__input-wrapper\" border-radius-setting=\"\" ng-model=\"widget.style_attributes.borderRadius\"></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.paddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.style_attributes.padding\"></div></div></div><div class=\"ms__content ms-padding\"><div class=\"ms__caption\">{{'modulesSettings.mobilePaddingLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" padding-setting=\"\" ng-model=\"widget.style_attributes.mobilePadding\"></div></div></div></div></div><div class=\"ms image ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{'blockSettings.htmlcss' | translate}}</span><div class=\"ms__section\"><div class=\"ms__content ms-text\"><div class=\"ms__caption ms__caption_top\">{{'blockSettings.class' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><tags-input ng-model=\"widget.additional_classes\" min-length=\"0\" max-tags=\"10\" ,=\",\" allowed-tags-pattern=\"^[A-Z|a-z|0-9|+_-]+$\"></tags-input></div></div></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockVisibility'\"><div class=\"ms__section ms__section_active ms__section_visible\"><div class=\"ms__content ms-text\" ng-hide=\"Editor.option == 'site.page.mixer' || Editor.option == 'lesson.page.mixer' || Editor.mode == 'email.page.editor' || Editor.mode == 'form.page.editor'\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__interactive\" type=\"checkbox\" ng-model=\"widget.interactive\"/><label class=\"checkbox-label-wrapper\" for=\"ms__interactive\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'blockSettings.interactive' | translate}} &nbsp;</span><a class=\"checkbox-link\" href=\"{{'editor.settings.interactive_tutorial_link' | translate}}\" target=\"_blank\" title=\"{{'editor.tutorial.title' | translate}}\">(?)</a></label></div></div><div class=\"ms__content ms-text\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__visibility_delay\" type=\"checkbox\" ng-model=\"widget.visibility_delay_enable\" ng-init=\"widget.visibility_delay ? false : widget.visibility_delay = 60\"/><label class=\"checkbox-label-wrapper\" for=\"ms__visibility_delay\" title=\"visibility delay\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.ShowDelayedWidget' | translate}}</span></label></div><div ng-show=\"widget.visibility_delay_enable\"><input class=\"input input_nano input_inline ms-input_border\" ng-change=\"$root.validateNumber(widget, 'visibility_delay')\" type=\"number\" min=\"0\" ng-style=\"{'width': '60px'}\" ng-model=\"widget.visibility_delay\"/><span>&nbsp; {{'widget.second' | translate}}</span></div></div></div></div>";

/***/ }),
/* 397 */
/***/ (function(module, exports) {

module.exports = "<div class=\"etn__elements-menu\"><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockDesign'}\" ng-click=\"openTab('blockDesign')\" ng-init=\"openTab('blockDesign')\">{{'editor.panel.tab1' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockVisibility'}\" ng-click=\"openTab('blockVisibility')\">{{'editor.panel.tab5' | translate}}</a></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockDesign'\" ng-init=\"accordion.show_fast_settings = true\"><span class=\"ms__title\" ng-click=\"accordion = {show_fast_settings: !accordion.show_fast_settings}\" ng-class=\"{'ms__title_active': accordion.show_fast_settings}\">{{'editor.panel.tab3' | translate}}</span><div class=\"ms__section ms__section_visible\" ng-class=\"{'ms__section_active': accordion.show_fast_settings}\"><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.timer.styleLabel' | translate}}:</div><div class=\"input-wrapper\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.widget.theme\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\"><span ng-if=\"widget.theme == 0\">{{'widget.timer.style1' | translate}}</span><span ng-if=\"widget.theme == 1\">{{'widget.timer.style2' | translate}}</span><span ng-if=\"widget.theme == 2\">{{'widget.timer.style3' | translate}}</span><span ng-if=\"widget.theme !== 0 &amp;&amp; widget.theme !== 1 &amp;&amp; widget.theme !== 2\">{{'editor.selectDefaultOption' | translate}}</span></span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"Темный\" ng-click=\"optionCheck($event, 0);\">{{'widget.timer.style1' | translate}}</li><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"Светлый\" ng-click=\"optionCheck($event, 1);\">{{'widget.timer.style2' | translate}}</li><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"Прозрачный\" ng-click=\"optionCheck($event, 2);\">{{'widget.timer.style3' | translate}}</li></ul></div></perfect-scrollbar></div></div></div></div><div class=\"ms__content ms-radio\" timer-setting=\"\" ng-model=\"widget\"></div></div><div class=\"ms__section_nopadding\" ng-show=\"accordion.show_fast_settings\"><div class=\"ms__content\"><div class=\"checkbox-wrapper_list-title\"><div class=\"ms__caption\">{{'widget.timer.hideElementsLabel' | translate}}:</div></div><div class=\"checkbox-wrapper_list-item\"><input class=\"checkbox\" id=\"ms__timer-show1\" type=\"checkbox\" ng-model=\"widget.show_days\"/><label class=\"checkbox-label-wrapper\" for=\"ms__timer-show1\" ng-click=\"accordion.show_image_settings = true; setDesignTab('image')\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.timer.days' | translate}}</span></label></div><div class=\"checkbox-wrapper_list-item\"><input class=\"checkbox\" id=\"ms__timer-show4\" type=\"checkbox\" ng-model=\"widget.show_seconds\"/><label class=\"checkbox-label-wrapper\" for=\"ms__timer-show4\" ng-click=\"accordion.show_image_settings = true; setDesignTab('image')\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.timer.seconds' | translate}}</span></label></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-class=\"{'ms__title_active': accordion.show_card_additional}\"><div class=\"ms__title-name\" ng-click=\"accordion = {show_card_additional: !accordion.show_card_additional}\">{{'widget.timer.additionalSettigs' | translate}}</div></span><div class=\"ms__section\" ng-class=\"{'ms__section_active': accordion.show_card_additional}\" ng-if=\"accordion.show_card_additional\"><div class=\"header-menu__nav\" ng-init=\"setDesignTab('timer_additional_tab1')\"><a class=\"link header-menu__link group-title header-menu__link_widget-settings\" ng-class=\"{'link_active': currentDesignTab == 'timer_additional_tab1'}\" ng-click=\"setDesignTab('timer_additional_tab1')\">{{'widget.list.tab2' | translate}}</a></div><p>&nbsp;</p><div ng-show=\"currentDesignTab == 'timer_additional_tab1'\"><div class=\"ms__content ms-radio\"><div class=\"ms__caption ms__caption_top\">{{'widget.timer.labelsStyleLabel' | translate}}:</div><div class=\"ms__input-wrapper\"><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"timer-type-1\" type=\"radio\" value=\"18px\" name=\"timerlabels-design\" ng-model=\"widget.style_attributes.fontSize\"/><label class=\"radio-label-wrapper\" for=\"timer-type-1\" title=\"Большие\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.timer.labelsStyle1' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"timer-type-2\" type=\"radio\" value=\"16px\" name=\"timerlabels-design\" ng-model=\"widget.style_attributes.fontSize\"/><label class=\"radio-label-wrapper\" for=\"timer-type-2\" title=\"Средние\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.timer.labelsStyle2' | translate}}</span></label></div><div class=\"radio-wrapper ms-radio\"><input class=\"radio\" id=\"timer-type-3\" type=\"radio\" value=\"14px\" name=\"timerlabels-design\" ng-model=\"widget.style_attributes.fontSize\"/><label class=\"radio-label-wrapper\" for=\"timer-type-3\" title=\"Маленькие\"><div class=\"radio-label radio-label_small fl\"></div><span class=\"label-text\">{{'widget.timer.labelsStyle3' | translate}}</span></label></div></div></div><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.colorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"widget.style_attributes.color\"></div></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'widget.timer.days' | translate}}:</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" ng-model=\"widget.days_label\"/></div></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'widget.timer.hours' | translate}}:</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" ng-model=\"widget.hours_label\"/></div></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'widget.timer.minutes' | translate}}:</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" ng-model=\"widget.minutes_label\"/></div></div></div><div class=\"ms__content\"><div class=\"ms__caption\">{{'widget.timer.seconds' | translate}}:</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_nano ms-input_border\" type=\"text\" ng-model=\"widget.seconds_label\"/></div></div></div></div></div></div></div><div class=\"ms image ms-tab-pane\" ng-if=\"editCurrentTab == 'blockDesign'\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{'blockSettings.htmlcss' | translate}}</span><div class=\"ms__section\"><div class=\"ms__content ms-text\"><div class=\"ms__caption ms__caption_top\">{{'blockSettings.class' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><tags-input ng-model=\"widget.additional_classes\" min-length=\"0\" max-tags=\"10\" ,=\",\" allowed-tags-pattern=\"^[A-Z|a-z|0-9|+_-]+$\"></tags-input></div></div></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockVisibility'\"><div class=\"ms__section ms__section_active ms__section_visible\"><div class=\"ms__content ms-text\" ng-hide=\"Editor.option == 'site.page.mixer' || Editor.option == 'lesson.page.mixer'\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__interactive\" type=\"checkbox\" ng-model=\"widget.interactive\"/><label class=\"checkbox-label-wrapper\" for=\"ms__interactive\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'blockSettings.interactive' | translate}} &nbsp;</span><a class=\"checkbox-link\" href=\"{{'editor.settings.interactive_tutorial_link' | translate}}\" target=\"_blank\" title=\"{{'editor.tutorial.title' | translate}}\">(?)</a></label></div></div><div class=\"ms__content ms-text\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__visibility_delay\" type=\"checkbox\" ng-model=\"widget.visibility_delay_enable\" ng-init=\"widget.visibility_delay ? false : widget.visibility_delay = 60\"/><label class=\"checkbox-label-wrapper\" for=\"ms__visibility_delay\" title=\"visibility delay\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.ShowDelayedWidget' | translate}}</span></label></div><div ng-show=\"widget.visibility_delay_enable\"><input class=\"input input_nano input_inline ms-input_border\" ng-change=\"$root.validateNumber(widget, 'visibility_delay')\" type=\"number\" min=\"0\" ng-style=\"{'width': '60px'}\" ng-model=\"widget.visibility_delay\"/><span>&nbsp; {{'widget.second' | translate}}</span></div></div></div></div>";

/***/ }),
/* 398 */
/***/ (function(module, exports) {

module.exports = "<div class=\"etn__elements-menu\"><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockSettings'}\" ng-click=\"openTab('blockSettings')\" ng-init=\"openTab('blockSettings')\">{{'editor.panel.tab2' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title header-menu__link-elements\" ng-class=\"{'link_active': editCurrentTab == 'blockVisibility'}\" ng-click=\"openTab('blockVisibility')\">{{'editor.panel.tab5' | translate}}</a></div><div class=\"ms ms-tab-pane\" ng-if=\"editCurrentTab == 'blockSettings'\"><span class=\"ms__title\" ng-click=\"accordion.show_video_additional = false; accordion.show_fast_settings = !accordion.show_fast_settings\" ng-class=\"{'ms__title_active': accordion.show_fast_settings}\">{{'editor.panel.tab3' | translate}}</span><div class=\"ms__section\" ng-class=\"{'ms__section_active': accordion.show_fast_settings}\"><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'widget.video.urlLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><input class=\"input input_extra-small ms-input_border\" type=\"text\" placeholder=\"http://\" ng-model=\"widget.video_url\"/></div><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__form-checkbox-autoplay\" type=\"checkbox\" checked=\"\" ng-model=\"widget.autoplay\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-autoplay\" title=\"Mark a message\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text label-text_small\">{{'widget.video.autoplay' | translate}}</span></label></div><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__form-checkbox-hide_info\" type=\"checkbox\" checked=\"\" ng-model=\"widget.hide_info\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-hide_info\" title=\"Mark a message\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text label-text_small\">{{'widget.video.hide_info' | translate}} (youtube)</span></label></div><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__form-checkbox-hide_elements\" type=\"checkbox\" checked=\"\" ng-model=\"widget.hide_elements\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-hide_elements\" title=\"Mark a message\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text label-text_small\">{{'widget.video.hide_elements' | translate}} (youtube)</span></label></div><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__form-checkbox-hide_related\" type=\"checkbox\" checked=\"\" ng-model=\"widget.hide_related\"/><label class=\"checkbox-label-wrapper\" for=\"ms__form-checkbox-hide_related\" title=\"Mark a message\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text label-text_small\">{{'widget.video.hide_related' | translate}} <br>(youtube)</span></label></div><div class=\"checkbox-wrapper ms-checkbox\"><input class=\"checkbox\" id=\"ms__usebutton-checkbox-1\" type=\"checkbox\" checked=\"\" ng-model=\"widget.use_button\"/><label class=\"checkbox-label-wrapper\" for=\"ms__usebutton-checkbox-1\" title=\"Отображать изображение\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text label-text_small\">{{'widget.video.tab2' | translate}}</span></label></div></div></div><div class=\"ms__content ms-text\" ng-show=\"widget.use_button\"><div class=\"ms__caption\">{{'widget.card.element5color' | translate}}</div><div class=\"ms__input-wrapper\" colors-setting=\"\" set-attributes=\"color borderColor\" ng-model=\"widget.button_attributes.style_attributes\"></div></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"widget.use_button\"><span class=\"ms__title\" ng-class=\"{'ms__title_active': accordion.show_video_additional}\"><div class=\"ms__title-name\" ng-click=\"accordion.show_fast_settings = false; accordion.show_video_additional = !accordion.show_video_additional\">{{'widget.list.additional' | translate}}</div></span><div class=\"ms__section\" ng-class=\"{'ms__section_active': accordion.show_video_additional}\"><div class=\"ms__content ms-text\"><div class=\"ms__caption\">{{'modulesSettings.iconColor' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_slider-range\"><div color-setting=\"\" ng-model=\"widget.button_attributes.style_attributes.color\"></div><label class=\"label ms__label\">{{'modulesSettings.colorLabel' | translate}}</label></div><div class=\"ms__input ms__input_range\" size-setting=\"\" ng-model=\"widget.button_attributes.style_attributes.fontSize\"></div></div></div><div class=\"ms__content ms-color\"><div class=\"ms__caption\">{{'modulesSettings.backgroundColorLabel' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\" color-setting=\"\" ng-model=\"widget.button_attributes.style_attributes.backgroundColor\"></div></div></div><div class=\"ms__content ms-border\" border-setting=\"\" ng-model=\"widget.button_attributes.style_attributes.border\" widget-id=\"{{widget.id}}\"></div><div class=\"ms__content ms-radius\"><div class=\"ms__caption\">{{'modulesSettings.buttonSize' | translate}}:</div><div class=\"ms__input-wrapper\" slidersize-setting=\"\" ng-model=\"widget.button_attributes.style_attributes.width\"></div></div></div></div><div class=\"ms image ms-tab-pane\" ng-if=\"editCurrentTab == 'blockSettings'\"><span class=\"ms__title\" ng-click=\"editorAccordion($event)\">{{'blockSettings.htmlcss' | translate}}</span><div class=\"ms__section\"><div class=\"ms__content ms-text\"><div class=\"ms__caption ms__caption_top\">{{'blockSettings.class' | translate}}</div><div class=\"ms__input-wrapper\"><div class=\"ms__input ms__input_large\"><tags-input ng-model=\"widget.additional_classes\" min-length=\"0\" max-tags=\"10\" ,=\",\" allowed-tags-pattern=\"^[A-Z|a-z|0-9|+_-]+$\"></tags-input></div></div></div></div></div><div class=\"ms ms-tab-pane\" ng-show=\"editCurrentTab == 'blockVisibility'\"><div class=\"ms__section ms__section_active ms__section_visible\"><div class=\"ms__content ms-text\" ng-hide=\"Editor.option == 'site.page.mixer' || Editor.option == 'lesson.page.mixer'\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__interactive\" type=\"checkbox\" ng-model=\"widget.interactive\"/><label class=\"checkbox-label-wrapper\" for=\"ms__interactive\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'blockSettings.interactive' | translate}} &nbsp;</span><a class=\"checkbox-link\" href=\"{{'editor.settings.interactive_tutorial_link' | translate}}\" target=\"_blank\" title=\"{{'editor.tutorial.title' | translate}}\">(?)</a></label></div></div><div class=\"ms__content ms-text\"><div class=\"checkbox-wrapper ms-checkbox_margin\"><input class=\"checkbox\" id=\"ms__visibility_delay\" type=\"checkbox\" ng-model=\"widget.visibility_delay_enable\" ng-init=\"widget.visibility_delay ? false : widget.visibility_delay = 60\"/><label class=\"checkbox-label-wrapper\" for=\"ms__visibility_delay\" title=\"visibility delay\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'widget.ShowDelayedWidget' | translate}}</span></label></div><div ng-show=\"widget.visibility_delay_enable\"><input class=\"input input_nano input_inline ms-input_border\" ng-change=\"$root.validateNumber(widget, 'visibility_delay')\" type=\"number\" min=\"0\" ng-style=\"{'width': '60px'}\" ng-model=\"widget.visibility_delay\"/><span>&nbsp; {{'widget.second' | translate}}</span></div></div></div></div>";

/***/ }),
/* 399 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"><div class=\"middle-title ta-center\">Editing message template</div></div><form class=\"modal-body\" ng-submit=\"saveTemplate(site, editTemplateForm)\" novalidate=\"\" name=\"editTemplateForm\"><div class=\"input-wrapper\"><label class=\"label-input\">Name</label><input class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.name.length}\" ng-model=\"site.name\" placeholder=\"Enter project name\" required=\"\" type=\"text\"/><div class=\"error-message error-message_newlanding\" tooltip-title=\"{{errors.name[0]}} {{errors.name[1]}}\" tooltips=\"\"><svg class=\"icon-danger\" version=\"1.1\" viewbox=\"0 0 28.937 28.937\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-danger__path\" d=\"M28.859,26.124L14.957,2.245c-0.101-0.173-0.287-0.279-0.489-0.279c-0.198,0-0.383,0.106-0.481,0.279L0.079,26.124 c-0.102,0.175-0.106,0.389-0.006,0.565c0.103,0.174,0.287,0.282,0.488,0.282h27.814c0.201,0,0.389-0.108,0.488-0.282 c0.047-0.088,0.074-0.186,0.074-0.281C28.938,26.309,28.911,26.211,28.859,26.124z M16.369,10.441l-0.462,9.493h-2.389 l-0.461-9.493H16.369z M14.711,24.794h-0.042c-1.089,0-1.843-0.817-1.843-1.907c0-1.131,0.774-1.907,1.885-1.907 s1.846,0.775,1.867,1.907C16.579,23.977,15.844,24.794,14.711,24.794z\"></path></svg></div></div><div class=\"input-wrapper\"><label class=\"label-input\">Subdomain</label><input class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.subdomain.length}\" ng-model=\"site.subdomain\" placeholder=\"Subdomain\" required=\"\" type=\"text\"/><div class=\"error-message error-message_newlanding\" tooltip-title=\"{{errors.subdomain[0]}} {{errors.subdomain[1]}}\" tooltips=\"\"><svg class=\"icon-danger\" version=\"1.1\" viewbox=\"0 0 28.937 28.937\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-danger__path\" d=\"M28.859,26.124L14.957,2.245c-0.101-0.173-0.287-0.279-0.489-0.279c-0.198,0-0.383,0.106-0.481,0.279L0.079,26.124 c-0.102,0.175-0.106,0.389-0.006,0.565c0.103,0.174,0.287,0.282,0.488,0.282h27.814c0.201,0,0.389-0.108,0.488-0.282 c0.047-0.088,0.074-0.186,0.074-0.281C28.938,26.309,28.911,26.211,28.859,26.124z M16.369,10.441l-0.462,9.493h-2.389 l-0.461-9.493H16.369z M14.711,24.794h-0.042c-1.089,0-1.843-0.817-1.843-1.907c0-1.131,0.774-1.907,1.885-1.907 s1.846,0.775,1.867,1.907C16.579,23.977,15.844,24.794,14.711,24.794z\"></path></svg></div></div><div class=\"input-wrapper-group\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Tags</label><tags-input ng-model=\"site.tags\" min-length=\"{{currentUser.lang === 'ja' ? 1 : 3}}\"><auto-complete source=\"loadTags($query)\" load-on-empty=\"true\" load-on-focus=\"true\"></auto-complete></tags-input></div><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Template color</label><div class=\"input-color-wrapper\"><div class=\"input input_nano input_color ms-input_border\" minicolors=\"{opacity: true}\" ng-model=\"site.color\"></div></div></div><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Color tags for sections</label><tags-input ng-model=\"site.colors\" min-length=\"{{currentUser.lang === 'ja' ? 1 : 3}}\" load-on-empty=\"true\" load-on-focus=\"true\"><auto-complete source=\"loadColorTags($query)\" load-on-empty=\"true\" load-on-focus=\"true\"></auto-complete></tags-input></div><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Description *</label><textarea class=\"textarea textarea_extra-small ms-input_border input\" placeholder=\"Description\" ng-model=\"site.description\" name=\"description\"></textarea></div></div><div class=\"input-wrapper-group\"><div class=\"etn__preview etn__preview_web ta-left\" ng-if=\"!site.custom_preview_url_enabled\"><div class=\"label-input\">Web Preview</div><input class=\"ng-hide\" id=\"etn__preview_web\" type=\"file\" nv-file-select=\"\" uploader=\"webPreviewUploader\"/><span class=\"file-name\">{{webPreviewUploader.queue[0].file.name}}</span><label for=\"etn__preview_web\"><div class=\"etn__preview-upload etn__preview-upload_web ms-input_border {{'favorite.upload_web_hint' | translate}}\"><img class=\"etn__preview-image\" ng-src=\"{{site.preview.thumb}}\" err-src=\"/editor/assets/images/image-error.svg\"/><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': webPreviewUploader.progress + '%' }\" ng-show=\"webPreviewUploader.progress\"></div></div></label></div><div class=\"input-wrapper ta-left\"><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"disablesite\" type=\"checkbox\" ng-model=\"site.custom_preview_url_enabled\"/><label class=\"checkbox-label-wrapper\" title=\"\" for=\"disablesite\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Specify a variable with a link to the image</span></label></div></div><div class=\"input-wrapper\" ng-if=\"site.custom_preview_url_enabled\"><label class=\"label-input\">Web preview variable</label><input class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.name.length}\" ng-model=\"site.custom_preview_url\" placeholder=\"Variable\" type=\"text\"/></div><div class=\"etn__preview etn__preview_mobile ta-left\" ng-if=\"!site.custom_mobile_preview_url_enabled\"><div class=\"input-wrapper\"><div class=\"label-input\">Mobile Preview</div><input class=\"ng-hide\" id=\"etn__preview_mobile\" type=\"file\" nv-file-select=\"\" uploader=\"mobilePreviewUploader\"/><span class=\"file-name\">{{mobilePreviewUploader.queue[0].file.name}}</span><label for=\"etn__preview_mobile\"><div class=\"etn__preview-upload etn__preview-upload_mobile ms-input_border\"><img class=\"etn__preview-image\" ng-src=\"{{site.mobile_preview.thumb}}\" err-src=\"/editor/assets/images/image-error.svg\"/><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': mobilePreviewUploader.progress + '%' }\" ng-show=\"mobilePreviewUploader.progress\"></div></div></label></div></div><div class=\"input-wrapper ta-left\"><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"disablesite\" type=\"checkbox\" ng-model=\"site.custom_mobile_preview_url_enabled\"/><label class=\"checkbox-label-wrapper\" title=\"\" for=\"disablesite\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Specify a variable with a link to the image</span></label></div></div><div class=\"input-wrapper\" ng-if=\"site.custom_mobile_preview_url_enabled\"><label class=\"label-input\">Preview variable for smartphones</label><input class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.name.length}\" ng-model=\"site.custom_mobile_preview_url\" placeholder=\"Variable\" type=\"text\"/></div></div><div class=\"input-wrapper ta-left\"><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"disablesite\" type=\"checkbox\" ng-model=\"site.disabled\"/><label class=\"checkbox-label-wrapper\" title=\"Hide template\" for=\"disablesite\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Hide from user template</span></label></div></div><div class=\"input-wrapper\"><button class=\"button button_green button_extra-small button_modal\" type=\"button\" ng-click=\"clone()\" ng-disabled=\"cloning\" ng-show=\"mainTemplate\">Create a new variant</button></div><div class=\"modal-footer ta-center\"><button class=\"button button_margin button_green button_extra-small button_modal\" type=\"submit\" ng-disabled=\"saving\">Save template</button><button class=\"button button_margin button_grayish-blue button_extra-small button_modal\" ng-click=\"close($event)\">Cancel</button></div></form>";

/***/ }),
/* 400 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"><div class=\"middle-title ta-center\">New messages</div></div><form class=\"modal-body\" ng-submit=\"createTemplate(site, newTemplateForm)\" novalidate=\"\" name=\"newTemplateForm\"><div class=\"input-wrapper\"><label class=\"label-input\">Name</label><input class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.name.length}\" ng-model=\"site.name\" placeholder=\"Enter project name\" required=\"\" type=\"text\"/><div class=\"error-message error-message_newlanding\" tooltip-title=\"{{errors.name[0]}} {{errors.name[1]}}\" tooltips=\"\"><svg class=\"icon-danger\" version=\"1.1\" viewbox=\"0 0 28.937 28.937\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-danger__path\" d=\"M28.859,26.124L14.957,2.245c-0.101-0.173-0.287-0.279-0.489-0.279c-0.198,0-0.383,0.106-0.481,0.279L0.079,26.124 c-0.102,0.175-0.106,0.389-0.006,0.565c0.103,0.174,0.287,0.282,0.488,0.282h27.814c0.201,0,0.389-0.108,0.488-0.282 c0.047-0.088,0.074-0.186,0.074-0.281C28.938,26.309,28.911,26.211,28.859,26.124z M16.369,10.441l-0.462,9.493h-2.389 l-0.461-9.493H16.369z M14.711,24.794h-0.042c-1.089,0-1.843-0.817-1.843-1.907c0-1.131,0.774-1.907,1.885-1.907 s1.846,0.775,1.867,1.907C16.579,23.977,15.844,24.794,14.711,24.794z\"></path></svg></div></div><div class=\"input-wrapper\"><label class=\"label-input\">Subdomain</label><div class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.subdomain.length}\"><span contenteditable=\"true\" ng-init=\"site.subdomain = 'example'\" ng-model=\"site.subdomain\">example</span></div><div class=\"error-message error-message_newlanding\" tooltip-title=\"{{errors.subdomain[0]}} {{errors.subdomain[1]}}\" tooltips=\"\"><svg class=\"icon-danger\" version=\"1.1\" viewbox=\"0 0 28.937 28.937\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-danger__path\" d=\"M28.859,26.124L14.957,2.245c-0.101-0.173-0.287-0.279-0.489-0.279c-0.198,0-0.383,0.106-0.481,0.279L0.079,26.124 c-0.102,0.175-0.106,0.389-0.006,0.565c0.103,0.174,0.287,0.282,0.488,0.282h27.814c0.201,0,0.389-0.108,0.488-0.282 c0.047-0.088,0.074-0.186,0.074-0.281C28.938,26.309,28.911,26.211,28.859,26.124z M16.369,10.441l-0.462,9.493h-2.389 l-0.461-9.493H16.369z M14.711,24.794h-0.042c-1.089,0-1.843-0.817-1.843-1.907c0-1.131,0.774-1.907,1.885-1.907 s1.846,0.775,1.867,1.907C16.579,23.977,15.844,24.794,14.711,24.794z\"></path></svg></div></div><div class=\"input-wrapper-group\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Tags</label><tags-input ng-model=\"site.tags\" min-length=\"{{currentUser.lang === 'ja' ? 1 : 3}}\"><auto-complete source=\"loadTags($query)\" load-on-empty=\"true\" load-on-focus=\"true\"></auto-complete></tags-input></div><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Template color</label><div class=\"input-color-wrapper\"><div class=\"input input_nano input_color ms-input_border\" minicolors=\"{opacity: true}\" ng-model=\"site.color\"></div></div></div><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Color tags for sections</label><tags-input ng-model=\"site.colors\" min-length=\"{{currentUser.lang === 'ja' ? 1 : 3}}\" load-on-empty=\"true\" load-on-focus=\"true\"><auto-complete source=\"loadColorTags($query)\" load-on-empty=\"true\" load-on-focus=\"true\"></auto-complete></tags-input></div><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Description *</label><textarea class=\"textarea textarea_extra-small ms-input_border input\" placeholder=\"Description\" ng-model=\"site.description\" name=\"description\"></textarea></div></div><div class=\"input-wrapper-group\"><div class=\"etn__preview etn__preview_web ta-left\" ng-if=\"!site.custom_preview_url_enabled\"><div class=\"label-input\">Web Preview</div><input class=\"ng-hide\" id=\"etn__preview_web\" type=\"file\" nv-file-select=\"\" uploader=\"webPreviewUploader\"/><span class=\"file-name\">{{webPreviewUploader.queue[0].file.name}}</span><label for=\"etn__preview_web\"><div class=\"etn__preview-upload etn__preview-upload_web ms-input_border {{'favorite.upload_web_hint' | translate}}\"><img class=\"etn__preview-image\" ng-src=\"{{site.preview.thumb}}\" err-src=\"/editor/assets/images/image-error.svg\"/><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': webPreviewUploader.progress + '%' }\" ng-show=\"webPreviewUploader.progress\"></div></div></label></div><div class=\"input-wrapper ta-left\"><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"disablesite\" type=\"checkbox\" ng-model=\"site.custom_preview_url_enabled\"/><label class=\"checkbox-label-wrapper\" title=\"\" for=\"disablesite\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Specify a variable with a link to the image</span></label></div></div><div class=\"input-wrapper\" ng-if=\"site.custom_preview_url_enabled\"><label class=\"label-input\">Web preview variable</label><input class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.name.length}\" ng-model=\"site.custom_preview_url\" placeholder=\"Variable\" type=\"text\"/></div><div class=\"etn__preview etn__preview_mobile ta-left\" ng-if=\"!site.custom_mobile_preview_url_enabled\"><div class=\"input-wrapper\"><div class=\"label-input\">Mobile Preview</div><input class=\"ng-hide\" id=\"etn__preview_mobile\" type=\"file\" nv-file-select=\"\" uploader=\"mobilePreviewUploader\"/><span class=\"file-name\">{{mobilePreviewUploader.queue[0].file.name}}</span><label for=\"etn__preview_mobile\"><div class=\"etn__preview-upload etn__preview-upload_mobile ms-input_border\"><img class=\"etn__preview-image\" ng-src=\"{{site.mobile_preview.thumb}}\" err-src=\"/editor/assets/images/image-error.svg\"/><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': mobilePreviewUploader.progress + '%' }\" ng-show=\"mobilePreviewUploader.progress\"></div></div></label></div></div><div class=\"input-wrapper ta-left\"><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"disablesite\" type=\"checkbox\" ng-model=\"site.custom_mobile_preview_url_enabled\"/><label class=\"checkbox-label-wrapper\" title=\"\" for=\"disablesite\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Specify a variable with a link to the image</span></label></div></div><div class=\"input-wrapper\" ng-if=\"site.custom_mobile_preview_url_enabled\"><label class=\"label-input\">Preview variable for smartphones</label><input class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.name.length}\" ng-model=\"site.custom_mobile_preview_url\" placeholder=\"Variable\" type=\"text\"/></div></div><div class=\"input-wrapper ta-left\"><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"disablesite\" type=\"checkbox\" ng-model=\"site.disabled\"/><label class=\"checkbox-label-wrapper\" title=\"Hide template\" for=\"disablesite\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Hide from user template</span></label></div></div><div class=\"modal-footer ta-center\"><button class=\"button button_margin button_green button_extra-small button_modal\" type=\"submit\" ng-disabled=\"creating\">Add template</button><button class=\"button button_margin button_grayish-blue button_extra-small button_modal\" ng-click=\"close($event)\">Cancel</button></div></form>";

/***/ }),
/* 401 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"><div class=\"middle-title ta-center\">Editing a lesson template</div></div><form class=\"modal-body\" ng-submit=\"saveTemplate(site, editTemplateLesson)\" novalidate=\"\" name=\"editTemplateLesson\"><div class=\"input-wrapper\"><label class=\"label-input\">Name</label><input class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.name.length}\" ng-model=\"site.name\" placeholder=\"Enter project name\" required=\"\" type=\"text\"/><div class=\"error-message error-message_newlanding\" tooltip-title=\"{{errors.name[0]}} {{errors.name[1]}}\" tooltips=\"\"><svg class=\"icon-danger\" version=\"1.1\" viewbox=\"0 0 28.937 28.937\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-danger__path\" d=\"M28.859,26.124L14.957,2.245c-0.101-0.173-0.287-0.279-0.489-0.279c-0.198,0-0.383,0.106-0.481,0.279L0.079,26.124 c-0.102,0.175-0.106,0.389-0.006,0.565c0.103,0.174,0.287,0.282,0.488,0.282h27.814c0.201,0,0.389-0.108,0.488-0.282 c0.047-0.088,0.074-0.186,0.074-0.281C28.938,26.309,28.911,26.211,28.859,26.124z M16.369,10.441l-0.462,9.493h-2.389 l-0.461-9.493H16.369z M14.711,24.794h-0.042c-1.089,0-1.843-0.817-1.843-1.907c0-1.131,0.774-1.907,1.885-1.907 s1.846,0.775,1.867,1.907C16.579,23.977,15.844,24.794,14.711,24.794z\"></path></svg></div></div><div class=\"input-wrapper\"><label class=\"label-input\">Subdomain</label><input class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.subdomain.length}\" ng-model=\"site.subdomain\" placeholder=\"Subdomain\" required=\"\" type=\"text\"/><div class=\"error-message error-message_newlanding\" tooltip-title=\"{{errors.subdomain[0]}} {{errors.subdomain[1]}}\" tooltips=\"\"><svg class=\"icon-danger\" version=\"1.1\" viewbox=\"0 0 28.937 28.937\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-danger__path\" d=\"M28.859,26.124L14.957,2.245c-0.101-0.173-0.287-0.279-0.489-0.279c-0.198,0-0.383,0.106-0.481,0.279L0.079,26.124 c-0.102,0.175-0.106,0.389-0.006,0.565c0.103,0.174,0.287,0.282,0.488,0.282h27.814c0.201,0,0.389-0.108,0.488-0.282 c0.047-0.088,0.074-0.186,0.074-0.281C28.938,26.309,28.911,26.211,28.859,26.124z M16.369,10.441l-0.462,9.493h-2.389 l-0.461-9.493H16.369z M14.711,24.794h-0.042c-1.089,0-1.843-0.817-1.843-1.907c0-1.131,0.774-1.907,1.885-1.907 s1.846,0.775,1.867,1.907C16.579,23.977,15.844,24.794,14.711,24.794z\"></path></svg></div></div><div class=\"input-wrapper-group\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Tags</label><tags-input ng-model=\"site.tags\" min-length=\"{{currentUser.lang === 'ja' ? 1 : 3}}\"><auto-complete source=\"loadTags($query)\" load-on-empty=\"true\" load-on-focus=\"true\"></auto-complete></tags-input></div></div><div class=\"input-wrapper-group\"><div class=\"etn__preview etn__preview_web ta-left\" ng-if=\"!site.custom_preview_url_enabled\"><div class=\"label-input\">Web Preview</div><input class=\"ng-hide\" id=\"etn__preview_web\" type=\"file\" nv-file-select=\"\" uploader=\"webPreviewUploader\"/><span class=\"file-name\">{{webPreviewUploader.queue[0].file.name}}</span><label for=\"etn__preview_web\"><div class=\"etn__preview-upload etn__preview-upload_web ms-input_border {{'favorite.upload_web_hint' | translate}}\"><img class=\"etn__preview-image\" ng-src=\"{{site.preview.thumb}}\" err-src=\"/constructor/editor/assets/images/image-error.svg\"/><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': webPreviewUploader.progress + '%' }\" ng-show=\"webPreviewUploader.progress\"></div></div></label></div><div class=\"input-wrapper ta-left\"><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"disablesite\" type=\"checkbox\" ng-model=\"site.custom_preview_url_enabled\"/><label class=\"checkbox-label-wrapper\" title=\"\" for=\"disablesite\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Specify a variable with a link to the image</span></label></div></div><div class=\"input-wrapper\" ng-if=\"site.custom_preview_url_enabled\"><label class=\"label-input\">Web preview variable</label><input class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.name.length}\" ng-model=\"site.custom_preview_url\" placeholder=\"Variable\" type=\"text\"/></div><div class=\"etn__preview etn__preview_mobile ta-left\" ng-if=\"!site.custom_mobile_preview_url_enabled\"><div class=\"input-wrapper\"><div class=\"label-input\">Mobile Preview</div><input class=\"ng-hide\" id=\"etn__preview_mobile\" type=\"file\" nv-file-select=\"\" uploader=\"mobilePreviewUploader\"/><span class=\"file-name\">{{mobilePreviewUploader.queue[0].file.name}}</span><label for=\"etn__preview_mobile\"><div class=\"etn__preview-upload etn__preview-upload_mobile ms-input_border\"><img class=\"etn__preview-image\" ng-src=\"{{site.mobile_preview.thumb}}\" err-src=\"/constructor/editor/assets/images/image-error.svg\"/><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': mobilePreviewUploader.progress + '%' }\" ng-show=\"mobilePreviewUploader.progress\"></div></div></label></div></div><div class=\"input-wrapper ta-left\"><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"disablesite\" type=\"checkbox\" ng-model=\"site.custom_mobile_preview_url_enabled\"/><label class=\"checkbox-label-wrapper\" title=\"\" for=\"disablesite\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Specify a variable with a link to the image</span></label></div></div><div class=\"input-wrapper\" ng-if=\"site.custom_mobile_preview_url_enabled\"><label class=\"label-input\">Preview variable for smartphones</label><input class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.name.length}\" ng-model=\"site.custom_mobile_preview_url\" placeholder=\"Variable\" type=\"text\"/></div></div><div class=\"input-wrapper ta-left\"><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"disablesite\" type=\"checkbox\" ng-model=\"site.disabled\"/><label class=\"checkbox-label-wrapper\" title=\"Hide template\" for=\"disablesite\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Hide from user template</span></label></div></div><div class=\"input-wrapper\"><button class=\"button button_green button_extra-small button_modal\" type=\"button\" ng-click=\"clone()\" ng-disabled=\"cloning\" ng-show=\"mainTemplate\">Create a new variant</button></div><div class=\"modal-footer ta-center\"><button class=\"button button_margin button_green button_extra-small button_modal\" type=\"submit\" ng-disabled=\"saving\">Save template</button><button class=\"button button_margin button_grayish-blue button_extra-small button_modal\" ng-click=\"close($event)\">Cancel</button></div></form>";

/***/ }),
/* 402 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"><div class=\"middle-title ta-center\">New lesson</div></div><form class=\"modal-body\" ng-submit=\"createTemplate(site, newTemplateLesson)\" novalidate=\"\" name=\"newTemplateLesson\"><div class=\"input-wrapper\"><label class=\"label-input\">Name</label><input class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.name.length}\" ng-model=\"site.name\" placeholder=\"Enter project name\" required=\"\" type=\"text\"/><div class=\"error-message error-message_newlanding\" tooltip-title=\"{{errors.name[0]}} {{errors.name[1]}}\" tooltips=\"\"><svg class=\"icon-danger\" version=\"1.1\" viewbox=\"0 0 28.937 28.937\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-danger__path\" d=\"M28.859,26.124L14.957,2.245c-0.101-0.173-0.287-0.279-0.489-0.279c-0.198,0-0.383,0.106-0.481,0.279L0.079,26.124 c-0.102,0.175-0.106,0.389-0.006,0.565c0.103,0.174,0.287,0.282,0.488,0.282h27.814c0.201,0,0.389-0.108,0.488-0.282 c0.047-0.088,0.074-0.186,0.074-0.281C28.938,26.309,28.911,26.211,28.859,26.124z M16.369,10.441l-0.462,9.493h-2.389 l-0.461-9.493H16.369z M14.711,24.794h-0.042c-1.089,0-1.843-0.817-1.843-1.907c0-1.131,0.774-1.907,1.885-1.907 s1.846,0.775,1.867,1.907C16.579,23.977,15.844,24.794,14.711,24.794z\"></path></svg></div></div><div class=\"input-wrapper\"><label class=\"label-input\">Subdomain</label><div class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.subdomain.length}\"><span contenteditable=\"true\" ng-init=\"site.subdomain = 'example'\" ng-model=\"site.subdomain\">example</span></div><div class=\"error-message error-message_newlanding\" tooltip-title=\"{{errors.subdomain[0]}} {{errors.subdomain[1]}}\" tooltips=\"\"><svg class=\"icon-danger\" version=\"1.1\" viewbox=\"0 0 28.937 28.937\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-danger__path\" d=\"M28.859,26.124L14.957,2.245c-0.101-0.173-0.287-0.279-0.489-0.279c-0.198,0-0.383,0.106-0.481,0.279L0.079,26.124 c-0.102,0.175-0.106,0.389-0.006,0.565c0.103,0.174,0.287,0.282,0.488,0.282h27.814c0.201,0,0.389-0.108,0.488-0.282 c0.047-0.088,0.074-0.186,0.074-0.281C28.938,26.309,28.911,26.211,28.859,26.124z M16.369,10.441l-0.462,9.493h-2.389 l-0.461-9.493H16.369z M14.711,24.794h-0.042c-1.089,0-1.843-0.817-1.843-1.907c0-1.131,0.774-1.907,1.885-1.907 s1.846,0.775,1.867,1.907C16.579,23.977,15.844,24.794,14.711,24.794z\"></path></svg></div></div><div class=\"input-wrapper-group\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Tags</label><tags-input ng-model=\"site.tags\" min-length=\"{{currentUser.lang === 'ja' ? 1 : 3}}\" replace-spaces-with-dashes=\"false\"><auto-complete source=\"loadTags($query)\" load-on-empty=\"true\" load-on-focus=\"true\"></auto-complete></tags-input></div></div><div class=\"input-wrapper-group\"><div class=\"etn__preview etn__preview_web ta-left\" ng-if=\"!site.custom_preview_url_enabled\"><div class=\"label-input\">Web Preview</div><input class=\"ng-hide\" id=\"etn__preview_web\" type=\"file\" nv-file-select=\"\" uploader=\"webPreviewUploader\"/><span class=\"file-name\">{{webPreviewUploader.queue[0].file.name}}</span><label for=\"etn__preview_web\"><div class=\"etn__preview-upload etn__preview-upload_web ms-input_border {{'favorite.upload_web_hint' | translate}}\"><img class=\"etn__preview-image\" ng-src=\"{{site.preview.thumb}}\" err-src=\"/constructor/editor/assets/images/image-error.svg\"/><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': webPreviewUploader.progress + '%' }\" ng-show=\"webPreviewUploader.progress\"></div></div></label></div><div class=\"input-wrapper ta-left\"><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"disablesite\" type=\"checkbox\" ng-model=\"site.custom_preview_url_enabled\"/><label class=\"checkbox-label-wrapper\" title=\"\" for=\"disablesite\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Specify a variable with a link to the image</span></label></div></div><div class=\"input-wrapper\" ng-if=\"site.custom_preview_url_enabled\"><label class=\"label-input\">Web preview variable</label><input class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.name.length}\" ng-model=\"site.custom_preview_url\" placeholder=\"Variable\" type=\"text\"/></div><div class=\"etn__preview etn__preview_mobile ta-left\" ng-if=\"!site.custom_mobile_preview_url_enabled\"><div class=\"input-wrapper\"><div class=\"label-input\">Mobile Preview</div><input class=\"ng-hide\" id=\"etn__preview_mobile\" type=\"file\" nv-file-select=\"\" uploader=\"mobilePreviewUploader\"/><span class=\"file-name\">{{mobilePreviewUploader.queue[0].file.name}}</span><label for=\"etn__preview_mobile\"><div class=\"etn__preview-upload etn__preview-upload_mobile ms-input_border\"><img class=\"etn__preview-image\" ng-src=\"{{site.mobile_preview.thumb}}\" err-src=\"/constructor/editor/assets/images/image-error.svg\"/><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': mobilePreviewUploader.progress + '%' }\" ng-show=\"mobilePreviewUploader.progress\"></div></div></label></div></div><div class=\"input-wrapper ta-left\"><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"disablesite\" type=\"checkbox\" ng-model=\"site.custom_mobile_preview_url_enabled\"/><label class=\"checkbox-label-wrapper\" title=\"\" for=\"disablesite\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Specify a variable with a link to the image</span></label></div></div><div class=\"input-wrapper\" ng-if=\"site.custom_mobile_preview_url_enabled\"><label class=\"label-input\">Preview variable for smartphones</label><input class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.name.length}\" ng-model=\"site.custom_mobile_preview_url\" placeholder=\"Variable\" type=\"text\"/></div></div><div class=\"input-wrapper ta-left\"><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"disablesite\" type=\"checkbox\" ng-model=\"site.disabled\"/><label class=\"checkbox-label-wrapper\" title=\"Hide template\" for=\"disablesite\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Hide from user template</span></label></div></div><div class=\"modal-footer ta-center\"><button class=\"button button_margin button_green button_extra-small button_modal\" type=\"submit\" ng-disabled=\"creating\">Add template</button><button class=\"button button_margin button_grayish-blue button_extra-small button_modal\" ng-click=\"close($event)\">Cancel</button></div></form>";

/***/ }),
/* 403 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"><div class=\"middle-title ta-center\">New section</div></div><form name=\"createSectionForm\" novalidate=\"\" ng-submit=\"create(createSectionForm, section)\"><div class=\"modal-body\"><div class=\"ms\"><div class=\"ms__content ms-text\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Name</label><input class=\"input input_extra-small ms-input_border\" type=\"text\" name=\"title\" required=\"\" ng-class=\"{'error':createSectionForm.title.$invalid &amp;&amp; createSectionForm.$submitted}\" str-auto-focus=\"\" placeholder=\"Section Name\" ng-model=\"section.title\"/></div></div><div class=\"ms__content ms-text\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Tags</label><tags-input ng-model=\"section.tags\" min-length=\"{{currentUser.lang === 'ja' ? 1 : 3}}\" load-on-empty=\"true\" load-on-focus=\"true\" replace-spaces-with-dashes=\"false\" allow-leftover-text=\"true\" display-property=\"name\"><auto-complete source=\"loadTags($query)\" load-on-empty=\"true\" load-on-focus=\"true\"></auto-complete></tags-input></div></div><div class=\"ms__content ms-text\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Color tags for template</label><tags-input ng-model=\"section.colors\" min-length=\"{{currentUser.lang === 'ja' ? 1 : 3}}\" load-on-empty=\"true\" load-on-focus=\"true\" replace-spaces-with-dashes=\"false\"><auto-complete source=\"loadColorTags($query)\" load-on-empty=\"true\" load-on-focus=\"true\"></auto-complete></tags-input></div></div><div class=\"etn__preview etn__preview_web ta-left\" ng-if=\"!section.custom_preview_url_enabled\"><div class=\"label-input\">Image section</div><input class=\"ng-hide\" id=\"etn__preview_web\" type=\"file\" nv-file-select=\"\" uploader=\"sectionPreviewUploader\"/><span class=\"file-name\">{{sectionPreviewUploader.queue[0].file.name}}</span><label for=\"etn__preview_web\"><div class=\"etn__preview-upload etn__preview-upload_web ms-input_border {{'favorite.upload_web_hint' | translate}}\"><img class=\"etn__preview-image\" ng-src=\"{{site.preview.thumb}}\" err-src=\"/constructor/editor/assets/images/image-error.svg\"/><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': sectionPreviewUploader.progress + '%' }\" ng-show=\"sectionPreviewUploader.progress\"></div></div></label></div><div class=\"input-wrapper ta-left\"><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"disablesite\" type=\"checkbox\" ng-model=\"section.custom_preview_url_enabled\"/><label class=\"checkbox-label-wrapper\" title=\"\" for=\"disablesite\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Specify a variable with a link to the image</span></label></div></div><div class=\"input-wrapper\" ng-if=\"section.custom_preview_url_enabled\"><label class=\"label-input\">Web preview variable</label><input class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.name.length}\" ng-model=\"section.custom_preview_url\" placeholder=\"Variable\" type=\"text\"/></div></div><div class=\"input-wrapper ta-left\"><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"disablesite\" type=\"checkbox\" ng-model=\"section.disabled\"/><label class=\"checkbox-label-wrapper\" title=\"Hide template\" for=\"disablesite\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Hide section</span></label></div></div></div><div class=\"modal-footer ta-center\"><button class=\"button button_margin button_green button_extra-small button_modal\" ng-disabled=\"creating\">Add section</button><button class=\"button button_margin button_grayish-blue button_extra-small button_modal\" ng-click=\"close($event)\">Cancel</button></div></form>";

/***/ }),
/* 404 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"><div class=\"middle-title ta-center\">Editing a template</div></div><form class=\"modal-body\" ng-submit=\"saveTemplate(site, editTemplateForm)\" novalidate=\"\" name=\"editTemplateForm\"><div class=\"input-wrapper\"><label class=\"label-input\">Name</label><input class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.name.length}\" ng-model=\"site.name\" placeholder=\"Enter project name\" required=\"\" type=\"text\"/><div class=\"error-message error-message_newlanding\" tooltip-title=\"{{errors.name[0]}} {{errors.name[1]}}\" tooltips=\"\"><svg class=\"icon-danger\" version=\"1.1\" viewbox=\"0 0 28.937 28.937\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-danger__path\" d=\"M28.859,26.124L14.957,2.245c-0.101-0.173-0.287-0.279-0.489-0.279c-0.198,0-0.383,0.106-0.481,0.279L0.079,26.124 c-0.102,0.175-0.106,0.389-0.006,0.565c0.103,0.174,0.287,0.282,0.488,0.282h27.814c0.201,0,0.389-0.108,0.488-0.282 c0.047-0.088,0.074-0.186,0.074-0.281C28.938,26.309,28.911,26.211,28.859,26.124z M16.369,10.441l-0.462,9.493h-2.389 l-0.461-9.493H16.369z M14.711,24.794h-0.042c-1.089,0-1.843-0.817-1.843-1.907c0-1.131,0.774-1.907,1.885-1.907 s1.846,0.775,1.867,1.907C16.579,23.977,15.844,24.794,14.711,24.794z\"></path></svg></div></div><div class=\"input-wrapper\"><label class=\"label-input\">Subdomain</label><input class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.subdomain.length}\" ng-model=\"site.subdomain\" placeholder=\"Subdomain\" required=\"\" type=\"text\"/><div class=\"error-message error-message_newlanding\" tooltip-title=\"{{errors.subdomain[0]}} {{errors.subdomain[1]}}\" tooltips=\"\"><svg class=\"icon-danger\" version=\"1.1\" viewbox=\"0 0 28.937 28.937\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-danger__path\" d=\"M28.859,26.124L14.957,2.245c-0.101-0.173-0.287-0.279-0.489-0.279c-0.198,0-0.383,0.106-0.481,0.279L0.079,26.124 c-0.102,0.175-0.106,0.389-0.006,0.565c0.103,0.174,0.287,0.282,0.488,0.282h27.814c0.201,0,0.389-0.108,0.488-0.282 c0.047-0.088,0.074-0.186,0.074-0.281C28.938,26.309,28.911,26.211,28.859,26.124z M16.369,10.441l-0.462,9.493h-2.389 l-0.461-9.493H16.369z M14.711,24.794h-0.042c-1.089,0-1.843-0.817-1.843-1.907c0-1.131,0.774-1.907,1.885-1.907 s1.846,0.775,1.867,1.907C16.579,23.977,15.844,24.794,14.711,24.794z\"></path></svg></div></div><div class=\"input-wrapper-group\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Tags</label><tags-input ng-model=\"site.tags\" min-length=\"{{currentUser.lang === 'ja' ? 1 : 3}}\" replace-spaces-with-dashes=\"false\" allow-leftover-text=\"true\"><auto-complete source=\"loadTags($query)\" load-on-empty=\"true\" load-on-focus=\"true\"></auto-complete></tags-input></div><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Template color</label><div class=\"input-color-wrapper\"><div class=\"input input_nano input_color ms-input_border\" minicolors=\"{opacity: true}\" ng-model=\"site.color\"></div></div></div><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Color tags for sections</label><tags-input ng-model=\"site.colors\" min-length=\"{{currentUser.lang === 'ja' ? 1 : 3}}\" load-on-empty=\"true\" load-on-focus=\"true\" replace-spaces-with-dashes=\"false\" allow-leftover-text=\"true\"><auto-complete source=\"loadColorTags($query)\" load-on-empty=\"true\" load-on-focus=\"true\"></auto-complete></tags-input></div><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Description *</label><textarea class=\"textarea textarea_extra-small ms-input_border input\" placeholder=\"Description\" ng-model=\"site.description\" name=\"description\"></textarea></div></div><div class=\"input-wrapper-group\"><div class=\"etn__preview etn__preview_web ta-left\" ng-if=\"!site.custom_preview_url_enabled\"><div class=\"label-input\">Web Preview</div><input class=\"ng-hide\" id=\"etn__preview_web\" type=\"file\" nv-file-select=\"\" uploader=\"webPreviewUploader\"/><span class=\"file-name\">{{webPreviewUploader.queue[0].file.name}}</span><label for=\"etn__preview_web\"><div class=\"etn__preview-upload etn__preview-upload_web ms-input_border {{'favorite.upload_web_hint' | translate}}\"><img class=\"etn__preview-image\" ng-src=\"{{site.preview.thumb}}\" err-src=\"/constructor/editor/assets/images/image-error.svg\"/><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': webPreviewUploader.progress + '%' }\" ng-show=\"webPreviewUploader.progress\"></div></div></label></div><div class=\"input-wrapper ta-left\"><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"disablesite\" type=\"checkbox\" ng-model=\"site.custom_preview_url_enabled\"/><label class=\"checkbox-label-wrapper\" title=\"\" for=\"disablesite\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Specify a variable with a link to the image</span></label></div></div><div class=\"input-wrapper\" ng-if=\"site.custom_preview_url_enabled\"><label class=\"label-input\">Web preview variable</label><input class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.name.length}\" ng-model=\"site.custom_preview_url\" placeholder=\"Variable\" type=\"text\"/></div><div class=\"etn__preview etn__preview_mobile ta-left\" ng-if=\"!site.custom_mobile_preview_url_enabled\"><div class=\"input-wrapper\"><div class=\"label-input\">Mobile Preview</div><input class=\"ng-hide\" id=\"etn__preview_mobile\" type=\"file\" nv-file-select=\"\" uploader=\"mobilePreviewUploader\"/><span class=\"file-name\">{{mobilePreviewUploader.queue[0].file.name}}</span><label for=\"etn__preview_mobile\"><div class=\"etn__preview-upload etn__preview-upload_mobile ms-input_border\"><img class=\"etn__preview-image\" ng-src=\"{{site.mobile_preview.thumb}}\" err-src=\"/constructor/editor/assets/images/image-error.svg\"/><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': mobilePreviewUploader.progress + '%' }\" ng-show=\"mobilePreviewUploader.progress\"></div></div></label></div></div><div class=\"input-wrapper ta-left\"><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"disablesite\" type=\"checkbox\" ng-model=\"site.custom_mobile_preview_url_enabled\"/><label class=\"checkbox-label-wrapper\" title=\"\" for=\"disablesite\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Specify a variable with a link to the image</span></label></div></div><div class=\"input-wrapper\" ng-if=\"site.custom_mobile_preview_url_enabled\"><label class=\"label-input\">Preview variable for smartphones</label><input class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.name.length}\" ng-model=\"site.custom_mobile_preview_url\" placeholder=\"Variable\" type=\"text\"/></div></div><div class=\"input-wrapper ta-left\" ng-show=\"currentUser.role == 'superadmin'\"><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"disablesite\" type=\"checkbox\" ng-model=\"site.disabled\"/><label class=\"checkbox-label-wrapper\" title=\"Hide template\" for=\"disablesite\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Hide from user template</span></label></div></div><div class=\"input-wrapper\"><button class=\"button button_green button_extra-small button_modal\" type=\"button\" ng-click=\"clone()\" ng-disabled=\"cloning\" ng-show=\"mainTemplate\">Create a new variant</button></div><div class=\"modal-footer ta-center\"><button class=\"button button_margin button_green button_extra-small button_modal\" type=\"submit\" ng-disabled=\"saving\">Save template</button><button class=\"button button_margin button_grayish-blue button_extra-small button_modal\" ng-click=\"close($event)\">Cancel</button></div></form>";

/***/ }),
/* 405 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"><div class=\"middle-title ta-center\">{{'favorite.label1' | translate}}</div></div><div class=\"modal-body\"><form ng-if=\"Editor.mode == 'form.page.editor'\" ng-submit=\"saveSite(site, siteSettingsForm, true)\" novalidate=\"\" name=\"siteSettingsForm\"><div class=\"input-wrapper\"><div class=\"input-wrapper-group\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">{{'favorite.label3' | translate}}</label><input class=\"input_extra-small ms-input_border input\" placeholder=\"{{'favorite.label3' | translate}}\" ng-model=\"site.name\" name=\"name\"/></div><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\" ng-show=\"Editor.mode == 'form.page.editor'\"><input class=\"checkbox\" id=\"is_form_manual_preview\" type=\"checkbox\" ng-model=\"site.is_manual_preview\" name=\"is_manual_preview\"/><label class=\"checkbox-label-wrapper\" for=\"is_form_manual_preview\" title=\"{{'favorite.upload_self_preview_images' | translate}}\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'favorite.upload_self_preview_images' | translate}}</span></label></div><div class=\"etn__preview etn__preview_web ta-left\" ng-show=\"site.is_manual_preview\"><div class=\"label-input\">{{'editor.panel.blockSettings.section.background2.coverLabel' | translate}}</div><input class=\"ng-hide\" id=\"etn__form_preview_web\" type=\"file\" nv-file-select=\"\" uploader=\"webPreviewUploader\"/><label for=\"etn__form_preview_web\"><div class=\"etn__preview-upload etn__preview-upload_web ms-input_border {{'favorite.upload_web_hint' | translate}}\"><img class=\"etn__preview-image\" ng-src=\"{{getDesktopPreview()}}\" err-src=\"/constructor/editor/assets/images/image-error.svg\"/><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': webPreviewUploader.progress + '%' }\" ng-show=\"webPreviewUploader.progress\"></div></div></label></div></div></div><div class=\"ta-left input-wrapper\"><button class=\"button button_green button_extra-small\" type=\"submit\" ng-disabled=\"savingSite\">{{'favorite.label7' | translate}}</button></div></form><form ng-if=\"Editor.mode != 'form.page.editor'\" ng-submit=\"favoriteSaveSettings(site, siteSettingsForm)\" novalidate=\"\" name=\"siteSettingsForm\"><div class=\"input-wrapper\"><div class=\"input-wrapper-group\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">{{'favorite.label3' | translate}}</label><input class=\"input_extra-small ms-input_border input\" placeholder=\"{{'favorite.label3' | translate}}\" ng-model=\"site.name\" name=\"name\"/></div><div class=\"input-wrapper ta-left\"><label class=\"label-input\">{{'favorite.label4' | translate}}</label><textarea class=\"textarea textarea_extra-small ms-input_border input\" placeholder=\"{{'favorite.label4' | translate}}\" ng-model=\"site.description\" name=\"description\"></textarea></div><div class=\"input-wrapper ta-left\" ng-show=\"isSuperAdminRole\"><label class=\"label-input\">{{'editor.siteSettings.tags' | translate}}</label><tags-input ng-model=\"site.tags\" min-length=\"{{currentUser.lang === 'ja' ? 1 : 3}}\" display-property=\"text\" replace-spaces-with-dashes=\"false\" allow-leftover-text=\"true\"><auto-complete source=\"loadTags($query)\" load-on-empty=\"true\" load-on-focus=\"true\"></auto-complete></tags-input></div><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"is_manual_preview\" type=\"checkbox\" ng-model=\"site.is_manual_preview\" name=\"is_manual_preview\"/><label class=\"checkbox-label-wrapper\" for=\"is_manual_preview\" title=\"{{'favorite.upload_self_preview_images' | translate}}\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'favorite.upload_self_preview_images' | translate}}</span></label></div><div class=\"etn__preview etn__preview_web ta-left\" ng-show=\"site.is_manual_preview\"><div class=\"label-input\">{{'favorite.label5' | translate}}</div><input class=\"ng-hide\" id=\"etn__preview_web\" type=\"file\" nv-file-select=\"\" uploader=\"webPreviewUploader\"/><label for=\"etn__preview_web\"><div class=\"etn__preview-upload etn__preview-upload_web ms-input_border {{'favorite.upload_web_hint' | translate}}\"><img class=\"etn__preview-image\" ng-src=\"{{getDesktopPreview()}}\" err-src=\"/constructor/editor/assets/images/image-error.svg\"/><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': webPreviewUploader.progress + '%' }\" ng-show=\"webPreviewUploader.progress\"></div></div></label></div><div class=\"etn__preview etn__preview_mobile ta-left\" ng-show=\"site.is_manual_preview\"><div class=\"input-wrapper\"><div class=\"label-input\">{{'favorite.label6' | translate}}</div><input class=\"ng-hide\" id=\"etn__preview_mobile\" type=\"file\" nv-file-select=\"\" uploader=\"mobilePreviewUploader\"/><label for=\"etn__preview_mobile\"><div class=\"etn__preview-upload etn__preview-upload_mobile ms-input_border\"><img class=\"etn__preview-image\" ng-src=\"{{getMobilePreview()}}\" err-src=\"/constructor/editor/assets/images/image-error.svg\"/><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': mobilePreviewUploader.progress + '%' }\" ng-show=\"mobilePreviewUploader.progress\"></div></div></label></div></div></div></div><div class=\"ta-left input-wrapper\"><button class=\"button button_green button_extra-small\" type=\"submit\" ng-disabled=\"savingSite\">{{'favorite.label7' | translate}}</button><button class=\"button button_green button_extra-small\" type=\"button\" ng-disabled=\"savingSite\" ng-hide=\"site.is_template\" ng-click=\"favoriteSaveSettings(site, siteSettingsForm, true)\" ng-style=\"{'margin-left': '10px'}\">{{'favorite.label8' | translate}}</button></div></form></div>";

/***/ }),
/* 406 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"><div class=\"middle-title ta-center\">New template</div></div><form class=\"modal-body\" ng-submit=\"createTemplate(site, newTemplateForm)\" novalidate=\"\" name=\"newTemplateForm\"><div class=\"input-wrapper\"><label class=\"label-input\">Name</label><input class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.name.length}\" ng-model=\"site.name\" placeholder=\"Enter project name\" required=\"\" type=\"text\"/><div class=\"error-message error-message_newlanding\" tooltip-title=\"{{errors.name[0]}} {{errors.name[1]}}\" tooltips=\"\"><svg class=\"icon-danger\" version=\"1.1\" viewbox=\"0 0 28.937 28.937\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-danger__path\" d=\"M28.859,26.124L14.957,2.245c-0.101-0.173-0.287-0.279-0.489-0.279c-0.198,0-0.383,0.106-0.481,0.279L0.079,26.124 c-0.102,0.175-0.106,0.389-0.006,0.565c0.103,0.174,0.287,0.282,0.488,0.282h27.814c0.201,0,0.389-0.108,0.488-0.282 c0.047-0.088,0.074-0.186,0.074-0.281C28.938,26.309,28.911,26.211,28.859,26.124z M16.369,10.441l-0.462,9.493h-2.389 l-0.461-9.493H16.369z M14.711,24.794h-0.042c-1.089,0-1.843-0.817-1.843-1.907c0-1.131,0.774-1.907,1.885-1.907 s1.846,0.775,1.867,1.907C16.579,23.977,15.844,24.794,14.711,24.794z\"></path></svg></div></div><div class=\"input-wrapper\"><label class=\"label-input\">Subdomain</label><div class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.subdomain.length}\"><span contenteditable=\"true\" ng-init=\"site.subdomain = 'example'\" ng-model=\"site.subdomain\">example</span></div><div class=\"error-message error-message_newlanding\" tooltip-title=\"{{errors.subdomain[0]}} {{errors.subdomain[1]}}\" tooltips=\"\"><svg class=\"icon-danger\" version=\"1.1\" viewbox=\"0 0 28.937 28.937\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-danger__path\" d=\"M28.859,26.124L14.957,2.245c-0.101-0.173-0.287-0.279-0.489-0.279c-0.198,0-0.383,0.106-0.481,0.279L0.079,26.124 c-0.102,0.175-0.106,0.389-0.006,0.565c0.103,0.174,0.287,0.282,0.488,0.282h27.814c0.201,0,0.389-0.108,0.488-0.282 c0.047-0.088,0.074-0.186,0.074-0.281C28.938,26.309,28.911,26.211,28.859,26.124z M16.369,10.441l-0.462,9.493h-2.389 l-0.461-9.493H16.369z M14.711,24.794h-0.042c-1.089,0-1.843-0.817-1.843-1.907c0-1.131,0.774-1.907,1.885-1.907 s1.846,0.775,1.867,1.907C16.579,23.977,15.844,24.794,14.711,24.794z\"></path></svg></div></div><div class=\"input-wrapper-group\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Tags</label><tags-input ng-model=\"site.tags\" min-length=\"{{currentUser.lang === 'ja' ? 1 : 3}}\" replace-spaces-with-dashes=\"false\" allow-leftover-text=\"true\"><auto-complete source=\"loadTags($query)\" load-on-empty=\"true\" load-on-focus=\"true\"></auto-complete></tags-input></div><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Template color</label><div class=\"input-color-wrapper\"><div class=\"input input_nano input_color ms-input_border\" minicolors=\"{opacity: true}\" ng-model=\"site.color\"></div></div></div><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Color tags for sections</label><tags-input ng-model=\"site.colors\" min-length=\"{{currentUser.lang === 'ja' ? 1 : 3}}\" load-on-empty=\"true\" load-on-focus=\"true\" replace-spaces-with-dashes=\"false\" allow-leftover-text=\"true\"><auto-complete source=\"loadColorTags($query)\" load-on-empty=\"true\" load-on-focus=\"true\"></auto-complete></tags-input></div><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Description *</label><textarea class=\"textarea textarea_extra-small ms-input_border input\" placeholder=\"Description\" ng-model=\"site.description\" name=\"description\"></textarea></div></div><div class=\"input-wrapper-group\"><div class=\"etn__preview etn__preview_web ta-left\" ng-if=\"!site.custom_preview_url_enabled\"><div class=\"label-input\">Web Preview</div><input class=\"ng-hide\" id=\"etn__preview_web\" type=\"file\" nv-file-select=\"\" uploader=\"webPreviewUploader\"/><span class=\"file-name\">{{webPreviewUploader.queue[0].file.name}}</span><label for=\"etn__preview_web\"><div class=\"etn__preview-upload etn__preview-upload_web ms-input_border {{'favorite.upload_web_hint' | translate}}\"><img class=\"etn__preview-image\" ng-src=\"{{site.preview.thumb}}\" err-src=\"/constructor/editor/assets/images/image-error.svg\"/><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': webPreviewUploader.progress + '%' }\" ng-show=\"webPreviewUploader.progress\"></div></div></label></div><div class=\"input-wrapper ta-left\"><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"disablesite\" type=\"checkbox\" ng-model=\"site.custom_preview_url_enabled\"/><label class=\"checkbox-label-wrapper\" title=\"\" for=\"disablesite\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Specify a variable with a link to the image</span></label></div></div><div class=\"input-wrapper\" ng-if=\"site.custom_preview_url_enabled\"><label class=\"label-input\">Web preview variable</label><input class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.name.length}\" ng-model=\"site.custom_preview_url\" placeholder=\"Variable\" type=\"text\"/></div><div class=\"etn__preview etn__preview_mobile ta-left\" ng-if=\"!site.custom_mobile_preview_url_enabled\"><div class=\"input-wrapper\"><div class=\"label-input\">Mobile Preview</div><input class=\"ng-hide\" id=\"etn__preview_mobile\" type=\"file\" nv-file-select=\"\" uploader=\"mobilePreviewUploader\"/><span class=\"file-name\">{{mobilePreviewUploader.queue[0].file.name}}</span><label for=\"etn__preview_mobile\"><div class=\"etn__preview-upload etn__preview-upload_mobile ms-input_border\"><img class=\"etn__preview-image\" ng-src=\"{{site.mobile_preview.thumb}}\" err-src=\"/constructor/editor/assets/images/image-error.svg\"/><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': mobilePreviewUploader.progress + '%' }\" ng-show=\"mobilePreviewUploader.progress\"></div></div></label></div></div><div class=\"input-wrapper ta-left\"><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"disablesite\" type=\"checkbox\" ng-model=\"site.custom_mobile_preview_url_enabled\"/><label class=\"checkbox-label-wrapper\" title=\"\" for=\"disablesite\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Specify a variable with a link to the image</span></label></div></div><div class=\"input-wrapper\" ng-if=\"site.custom_mobile_preview_url_enabled\"><label class=\"label-input\">Preview variable for smartphones</label><input class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.name.length}\" ng-model=\"site.custom_mobile_preview_url\" placeholder=\"Variable\" type=\"text\"/></div></div><div class=\"input-wrapper ta-left\" ng-show=\"currentUser.role == 'superadmin'\"><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"disablesite\" type=\"checkbox\" ng-model=\"site.disabled\"/><label class=\"checkbox-label-wrapper\" title=\"Hide template\" for=\"disablesite\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Hide from user template</span></label></div></div><div class=\"modal-footer ta-center\"><button class=\"button button_margin button_green button_extra-small button_modal\" type=\"submit\" ng-disabled=\"creating\">Add template</button><button class=\"button button_margin button_grayish-blue button_extra-small button_modal\" ng-click=\"close($event)\">Cancel</button></div></form>";

/***/ }),
/* 407 */
/***/ (function(module, exports) {

module.exports = "<div class=\"tree-node tree-node-content\" ui-tree-handle=\"\" ng-class=\"{'tree-node-content_active': state.params.pageId == page.path}\"><div class=\"tree__icon-move\"><svg class=\"svg-block\" width=\"12\" height=\"12\" viewbox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"icon-block__fill\"><rect width=\"4.8\" height=\"4.8\" rx=\"1\"></rect><rect y=\"7.2\" width=\"4.8\" height=\"4.8\" rx=\"1\"></rect><rect x=\"7.2\" width=\"4.8\" height=\"4.8\" rx=\"1\"></rect><rect x=\"7.2\" y=\"7.2\" width=\"4.8\" height=\"4.8\" rx=\"1\"></rect></g></svg></div><img class=\"tree__icon-file\" ng-class=\"{'home__there': page.home}\" src=\"/constructor/editor/assets/images/icon-file.svg\" ng-show=\"page.type == 'static' &amp;&amp; page.pages.length == 0\"/><img class=\"tree__icon-file tree__icon-pages\" ng-class=\"{'home__there': page.home}\" src=\"/constructor/editor/assets/images/icon-news-pages.svg\" ng-show=\"page.type == 'news'\"/><img class=\"tree__icon-file\" ng-class=\"{'home__there': page.home}\" src=\"/constructor/editor/assets/images/icon-file.svg\" ng-show=\"page.type == 'news/post'\"/><img class=\"tree__icon-file\" ng-class=\"{'home__there': page.home}\" src=\"/constructor/editor/assets/images/icon-folder.svg\" ng-show=\"page.type == 'static' &amp;&amp; page.pages.length &gt; 0\"/><img class=\"tree__icon-file\" ng-class=\"{'home__there': page.home}\" src=\"/constructor/editor/assets/images/editor/icon-link-only.svg\" ng-show=\"page.type == 'link'\"/><img class=\"tree__icon-file is__home\" src=\"/constructor/editor/assets/images/home.svg\" ng-if=\"page.home\"/><a class=\"link tree__link\" ng-click=\"goToPage(page)\" data-nodrag=\"\">{{page.name}}</a><div class=\"tree__collapse-icon fr\" ng-if=\"page.pages.length\" ng-click=\"toggle()\" data-nodrag=\"\" ng-class=\"{'tree__collapse-icon__collapsed': collapsed}\"></div><div class=\"ms__button-remove fr\" data-nodrag=\"\"><a class=\"etn__image-remove icon-page__settings inline-wrapper\" ng-click=\"editPage(page)\"></a></div><button class=\"fr add-page__button_small\" ng-click=\"createPage('static', page.id)\" ng-if=\"!page.parent_id &amp;&amp; page.type == 'static'\" data-nodrag=\"\"><img class=\"add-page__button-icon\" src=\"/constructor/editor/assets/images/add.svg\"/></button><button class=\"fr add-page__button_small\" ng-click=\"createPage('news/post', page.id)\" ng-if=\"!page.parent_id &amp;&amp; page.type == 'news'\" data-nodrag=\"\"><img class=\"add-page__button-icon\" src=\"/constructor/editor/assets/images/add.svg\"/></button><a class=\"tree__icon-remove etn__image-remove icon-trash icon-trash_black inline-wrapper\" ng-click=\"deletePage(page)\" ng-if=\"!page.home\" data-nodrag=\"\"></a></div><ol ui-tree-nodes=\"\" ng-model=\"page.pages\" ng-show=\"!collapsed\"><li class=\"etn__pages-tree__item tree__child\" ng-repeat=\"page in page.pages\" ui-tree-node=\"\" ng-include=\"'./site/page/tree_renderer.jade'\"></li></ol>";

/***/ }),
/* 408 */
/***/ (function(module, exports) {

module.exports = "<div class=\"animate-wrapper line-border\"><ui-view class=\"animate\"></ui-view></div>";

/***/ }),
/* 409 */
/***/ (function(module, exports) {

module.exports = "<form ng-submit=\"saveSite(site, siteSettingsForm)\" novalidate=\"\" name=\"siteSettingsForm\"><div class=\"input-wrapper-group\"><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"mobile\" type=\"checkbox\" ng-model=\"site.mobile\" name=\"mobile\"/><label class=\"checkbox-label-wrapper\" for=\"mobile\" title=\"Mark a message\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'editor.siteSettings.tabs.item7.mobileLabel' | translate}}</span></label></div></div><div class=\"ta-left input-wrapper\"><button class=\"button button_green button_extra-small\" type=\"submit\" ng-disabled=\"savingSite\">{{'editor.siteSettings.tabs.save' | translate}}</button></div></form>";

/***/ }),
/* 410 */
/***/ (function(module, exports) {

module.exports = "<form ng-submit=\"saveSite(site, siteSettingsForm)\" novalidate=\"\" name=\"siteSettingsForm\"><div class=\"input-wrapper-group\" access=\"admin superadmin\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Теги</label><textarea class=\"textarea textarea_extra-small ms-input_border input\" placeholder=\"Tag\" ng-model=\"site.tags\" name=\"tags\"></textarea></div><div class=\"input-wrapper ta-left\" ng-if=\"site.is_template\"><label class=\"label-input\">Описание *</label><textarea class=\"textarea textarea_extra-small ms-input_border input\" placeholder=\"Описание\" ng-model=\"site.description\" name=\"description\"></textarea></div></div><div class=\"ta-left input-wrapper\"><button class=\"button button_green button_middle header-menu__button\" type=\"submit\" ng-disabled=\"savingSite\">Сохранить</button></div></form><div class=\"input-wrapper-group\" access=\"admin superadmin\"><div class=\"etn__preview etn__preview_web ta-left\"><div class=\"label-input\">Web Preview</div><input class=\"ng-hide\" id=\"etn__preview_web\" type=\"file\" nv-file-select=\"\" uploader=\"webPreviewUploader\"/><label for=\"etn__preview_web\"><div class=\"etn__preview-upload etn__preview-upload_web ms-input_border\"><img class=\"etn__preview-image\" ng-src=\"{{site.preview.thumb}}\" err-src=\"/constructor/editor/assets/images/image-error.svg\"/><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': webPreviewUploader.progress + '%' }\" ng-show=\"webPreviewUploader.progress\"></div></div></label></div><div class=\"etn__preview etn__preview_mobile ta-left\"><div class=\"input-wrapper\"><div class=\"label-input\">Mobile Preview</div><input class=\"ng-hide\" id=\"etn__preview_mobile\" type=\"file\" nv-file-select=\"\" uploader=\"mobilePreviewUploader\"/><label for=\"etn__preview_mobile\"><div class=\"etn__preview-upload etn__preview-upload_mobile ms-input_border\"><img class=\"etn__preview-image\" ng-src=\"{{site.mobile_preview.thumb}}\" err-src=\"/constructor/editor/assets/images/image-error.svg\"/><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': mobilePreviewUploader.progress + '%' }\" ng-show=\"mobilePreviewUploader.progress\"></div></div></label></div></div></div>";

/***/ }),
/* 411 */
/***/ (function(module, exports) {

module.exports = "<form class=\"ta-left\" name=\"siteSeoSettings\" ng-submit=\"saveHomePage(currentPage, siteSeoSettings)\"><div class=\"site-settings__bg-wrapper\" site-bg-settings=\"\" ng-model=\"currentPage\"></div><button class=\"button button_green button_extra-small\" ng-disabled=\"savingPage\" type=\"submit\">{{'editor.siteSettings.tabs.item4.saveButton' | translate}}</button></form>";

/***/ }),
/* 412 */
/***/ (function(module, exports) {

module.exports = "<div class=\"etn__site-settings-desc etn__site-settings-desc_etnr\"><div class=\"etn__description\">{{'editor.siteSettings.tabs.item1.description' | translate}}</div></div><div class=\"et-settings-panel\" ng-if=\"site.paid || isCompanyUser\"><div class=\"ta-center\"><div class=\"input-wrapper\"><div class=\"inline-wrapper\"><img class=\"etn__preview-favicon__image\" ng-src=\"{{site.favicon.favicon.v114.url}}\"/></div><input class=\"ng-hide\" id=\"etn__preview_favicon\" type=\"file\" nv-file-select=\"\" uploader=\"faviconUploader\"/><div class=\"etn__preview_favicon-desc\"><label class=\"button button_blue etn__preview_favicon-button\" for=\"etn__preview_favicon\" ng-disabled=\"faviconUploader.progress &gt; 0\"><span ng-if=\"!faviconUploader.progress\">{{'editor.siteSettings.tabs.item1.uploadButton'}}</span><span ng-if=\"faviconUploader.progress &gt; 0\">{{'editor.siteSettings.tabs.item1.uploadingButton'}}</span></label><span class=\"etn__preview_favicon-desc__text\">{{'editor.siteSettings.tabs.item1.info' | translate}}</span></div></div></div></div><div class=\"et-browser__tab\" ng-if=\"!site.paid &amp;&amp; !isCompanyUser\">{{'editor.siteSettings.tabs.item1.notpaidLabel' | translate}}<a class=\"button button_green button_large button_premium\" ui-sref=\"root.site.settings.billing({siteId: site.id})\" ng-click=\"closeAll()\">{{'editor.siteSettings.tabs.item1.notpaidButton' | translate}}</a></div>";

/***/ }),
/* 413 */
/***/ (function(module, exports) {

module.exports = "<div class=\"etn__description etn__description_site\" ng-init=\"getGoogleFonts()\">{{'editor.siteSettings.tabs.item2.description' | translate}}</div><div class=\"etn-loader__wrapper\" ng-show=\"fontsLoading\"><img class=\"etn__templates-loader\" src=\"/constructor/editor/assets/images/loader.gif\" ng-if=\"fontsLoading\" style=\"margin-bottom: 20px;margin-top: 20px;\"/></div><div class=\"et-settings-panel\" tabindex=\"3\" ng-show=\"!fontsLoading\"><div class=\"etnr-item__fonts\" ng-if=\"Editor.mode != 'lesson.page.editor'\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">{{'editor.siteSettings.tabs.item2.fontsTitles' | translate}}</label></div><div ng-show=\"!site_fonts.h_font.family\"><div class=\"input-wrapper ta-left\"><input class=\"input input_extra-small button_border\" autocomplete=\"off\" ng-model=\"fontHName\" placeholder=\"{{'editor.siteSettings.tabs.item2.searchInput' | translate}}\" type=\"text\" typeahead=\"font.family for font in searchFonts($viewValue)\" typeahead-min-length=\"3\" typeahead-template-url=\"./editor/font_settings/fonts-typeahead-match.jade\" typeahead-on-select=\"setFont($item, $model, $label, 'selectedHFont')\"/></div><div class=\"input-wrapper ta-left\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.selectedHFont\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\"><span ng-if=\"selectedHFont.family\">{{selectedHFont.family}}</span><span ng-if=\"!selectedHFont.family\">{{'editor.selectDefaultOption' | translate}}</span></span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in GFonts\" ng-click=\"optionCheck($event, font); connectFont(font);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper ta-left\" ng-show=\"selectedHFont.family\"><span ng-style=\"{'font-family': selectedHFont.family, 'font-size': 16}\" contenteditable=\"\">Example</span></div><div class=\"input-wrapper ta-left\" ng-show=\"selectedHFont.variants.length\"><label class=\"label-input\">{{'editor.siteSettings.tabs.item2.fontStyleLabel' | translate}}</label><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\" ng-repeat=\"variant in selectedHFont.variants\"><input class=\"checkbox\" type=\"checkbox\" ng-attr-id=\"{{variant}}\" ng-model=\"fontSettings.h_variants[variant]\"/><label class=\"checkbox-label-wrapper\" ng-attr-for=\"{{variant}}\" title=\"Variant\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{variant}}</span></label></div></div><div class=\"input-wrapper ta-left\" ng-show=\"selectedHFont.subsets.length\"><label class=\"label-input\">{{'editor.siteSettings.tabs.item2.fontLocaleLabel' | translate}}</label><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\" ng-repeat=\"subset in selectedHFont.subsets\"><input class=\"checkbox\" type=\"checkbox\" ng-attr-id=\"{{subset}}\" ng-model=\"fontSettings.subsets[subset]\"/><label class=\"checkbox-label-wrapper\" ng-attr-for=\"{{subset}}\" title=\"Subset\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{subset}}</span></label></div></div><div class=\"ta-left input-wrapper\"><button class=\"button button_green button_middle header-menu__button\" ng-click=\"setHFont(selectedHFont)\" ng-disabled=\"adding || !selectedHFont.family\" noloader=\"\">{{'editor.siteSettings.tabs.item2.fontsApply' | translate}}</button><img class=\"etn__templates-loader\" src=\"/constructor/editor/assets/images/loader.gif\" ng-if=\"adding\" style=\"margin-left: 20px;\"/></div></div><div ng-show=\"site_fonts.h_font.family\"><div class=\"input-wrapper ta-left\"><ul class=\"objects-list\"><li class=\"objects-list__item\"><div class=\"objects-list__item-info fl\"><span ng-style=\"{'font-family': site_fonts.h_font.family}\">{{site_fonts.h_font.family}}</span><div class=\"objects-list__item-info__subtext\"><span ng-repeat=\"variant in site_fonts.h_font.variants\">{{variant}}<span ng-if=\"!$last\">,&nbsp;</span></span><span ng-if=\"site_fonts.h_font.subsets.length\">|</span><span ng-repeat=\"subset in site_fonts.h_font.subsets\">{{subset}}<span ng-if=\"!$last\">,&nbsp;</span></span></div></div><div class=\"ms__button-remove font-remove fr\"><a class=\"inline-wrapper\" ng-click=\"removeHFont(selectedHFont)\"><svg class=\"icon-close\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" style=\"width: 14px;margin-top: 6px;\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a></div></li></ul></div></div></div><div class=\"etnr-item__fonts\" ng-if=\"Editor.mode != 'lesson.page.editor'\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">{{'editor.siteSettings.tabs.item2.fontsDefault' | translate}}</label></div><div ng-if=\"!site_fonts.default_font.family\"><div class=\"input-wrapper ta-left\"><input class=\"input input_extra-small button_border\" autocomplete=\"off\" ng-model=\"fontDefaultName\" placeholder=\"{{'editor.siteSettings.tabs.item2.searchInput' | translate}}\" type=\"text\" typeahead=\"font.family for font in searchFonts($viewValue)\" typeahead-min-length=\"3\" typeahead-template-url=\"./editor/font_settings/fonts-typeahead-match.jade\" typeahead-on-select=\"setFont($item, $model, $label, 'selectedDefaultFont')\"/></div><div class=\"input-wrapper ta-left\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.selectedDefaultFont\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\"><span ng-if=\"selectedDefaultFont.family\">{{selectedDefaultFont.family}}</span><span ng-if=\"!selectedDefaultFont.family\">{{'editor.selectDefaultOption' | translate}}</span></span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in GFonts\" ng-click=\"optionCheck($event, font); connectFont(font);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper ta-left\" ng-show=\"selectedDefaultFont.family\"><span ng-style=\"{'font-family': selectedDefaultFont.family, 'font-size': 16}\" contenteditable=\"\">Example</span></div><div class=\"input-wrapper ta-left\" ng-show=\"selectedDefaultFont.variants.length\"><label class=\"label-input\">{{'editor.siteSettings.tabs.item2.fontStyleLabel' | translate}}</label><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\" ng-repeat=\"variant in selectedDefaultFont.variants\"><input class=\"checkbox\" type=\"checkbox\" ng-attr-id=\"{{variant}}-df\" ng-model=\"fontSettings.default_variants[variant]\"/><label class=\"checkbox-label-wrapper\" ng-attr-for=\"{{variant}}-df\" title=\"Variant\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{variant}}</span></label></div></div><div class=\"input-wrapper ta-left\" ng-show=\"selectedDefaultFont.subsets.length\"><label class=\"label-input\">{{'editor.siteSettings.tabs.item2.fontLocaleLabel' | translate}}</label><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\" ng-repeat=\"subset in selectedDefaultFont.subsets\"><input class=\"checkbox\" type=\"checkbox\" ng-attr-id=\"{{subset}}\" ng-model=\"fontSettings.subsets[subset]\"/><label class=\"checkbox-label-wrapper\" ng-attr-for=\"{{subset}}\" title=\"Subset\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{subset}}</span></label></div></div><div class=\"ta-left input-wrapper\"><button class=\"button button_green button_middle header-menu__button\" ng-click=\"setDefaultFont(selectedDefaultFont)\" ng-disabled=\"adding || !selectedDefaultFont.family\" noloader=\"\">{{'editor.siteSettings.tabs.item2.fontsApply' | translate}}</button><img class=\"etn__templates-loader\" src=\"/constructor/editor/assets/images/loader.gif\" ng-if=\"adding\" style=\"margin-left: 20px;\"/></div></div><div ng-show=\"site_fonts.default_font.family\"><div class=\"input-wrapper ta-left\"><ul class=\"objects-list\"><li class=\"objects-list__item\"><div class=\"objects-list__item-info fl\"><span ng-style=\"{'font-family': site_fonts.default_font.family}\">{{site_fonts.default_font.family}}</span><div class=\"objects-list__item-info__subtext\"><span ng-repeat=\"variant in site_fonts.default_font.variants\">{{variant}}<span ng-if=\"!$last\">,&nbsp;</span></span><span ng-if=\"site_fonts.default_font.subsets.length\">|</span><span ng-repeat=\"subset in site_fonts.default_font.subsets\">{{subset}}<span ng-if=\"!$last\">,&nbsp;</span></span></div></div><div class=\"ms__button-remove font-remove fr\"><a class=\"inline-wrapper\" ng-click=\"removeDefaultFont(selectedDefaultFont)\"><svg class=\"icon-close\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" style=\"width: 14px;margin-top: 6px;\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a></div></li></ul></div></div></div><div class=\"etnr-item__fonts\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">{{'editor.siteSettings.tabs.item2.searchLabel' | translate}}</label><input class=\"input input_extra-small button_border\" autocomplete=\"off\" ng-model=\"fontName\" placeholder=\"{{'editor.siteSettings.tabs.item2.searchInput' | translate}}\" type=\"text\" typeahead=\"font.family for font in searchFonts($viewValue)\" typeahead-min-length=\"3\" typeahead-template-url=\"./editor/font_settings/fonts-typeahead-match.jade\" typeahead-on-select=\"setFont($item, $model, 'selectedFont')\"/></div><div class=\"input-wrapper ta-left\"><div class=\"select\" str-select=\"\" ng-model=\"$parent.selectedFont\" select-editor=\"true\"><span class=\"input input_nano ms-input_border select__placeholder select__placeholder_small text-overflow\"><span ng-if=\"selectedFont.family\">{{selectedFont.family}}</span><span ng-if=\"!selectedFont.family\">{{'editor.selectDefaultOption' | translate}}</span></span><div class=\"select__dropdown ms-input_border select__dropdown_large-ms\"><perfect-scrollbar class=\"scrollbar\" resize=\"height\" resize-attr=\"max-height\" resize-margin=\"198\" wheel-propagation=\"true\"><div class=\"dropdown-group\"><ul><li class=\"input_nano dropdown__option dropdown__option_large-ms text-overflow\" title=\"{{font.family}}\" ng-repeat=\"font in GFonts\" ng-click=\"optionCheck($event, font); connectFont(font);\">{{font.family}}</li></ul></div></perfect-scrollbar></div></div></div><div class=\"input-wrapper ta-left\" ng-show=\"selectedFont.family\"><span ng-style=\"{'font-family': selectedFont.family, 'font-size': 16}\" contenteditable=\"\">Example</span></div><div class=\"input-wrapper ta-left\" ng-show=\"selectedFont.variants.length\"><label class=\"label-input\">{{'editor.siteSettings.tabs.item2.fontStyleLabel' | translate}}</label><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\" ng-repeat=\"variant in selectedFont.variants\"><input class=\"checkbox\" type=\"checkbox\" ng-attr-id=\"{{variant}}\" ng-model=\"fontSettings.variants[variant]\"/><label class=\"checkbox-label-wrapper\" ng-attr-for=\"{{variant}}\" title=\"Variant\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{variant}}</span></label></div></div><div class=\"input-wrapper ta-left\" ng-show=\"selectedFont.subsets.length\"><label class=\"label-input\">{{'editor.siteSettings.tabs.item2.fontLocaleLabel' | translate}}</label><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\" ng-repeat=\"subset in selectedFont.subsets\"><input class=\"checkbox\" type=\"checkbox\" ng-attr-id=\"{{subset}}\" ng-model=\"fontSettings.subsets[subset]\"/><label class=\"checkbox-label-wrapper\" ng-attr-for=\"{{subset}}\" title=\"Subset\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{subset}}</span></label></div></div><div class=\"ta-left input-wrapper\"><button class=\"button button_green button_middle header-menu__button\" ng-click=\"addFont(selectedFont)\" ng-disabled=\"adding || !selectedFont.family\" noloader=\"\">{{'editor.siteSettings.tabs.item2.addFontButton' | translate}}</button><img class=\"etn__templates-loader\" src=\"/constructor/editor/assets/images/loader.gif\" ng-if=\"adding\" style=\"margin-left: 20px;\"/></div><div class=\"input-wrapper ta-left\" ng-if=\"site.fonts_attributes.length\"><label class=\"label-input\">{{'editor.siteSettings.tabs.item2.fontsListLabel' | translate}}</label><ul class=\"objects-list\"><li class=\"objects-list__item\" ng-repeat=\"font in site.fonts_attributes\"><div class=\"objects-list__item-info fl\"><span ng-style=\"{'font-family': font.family}\">{{font.family}}</span><div class=\"objects-list__item-info__subtext\"><span ng-repeat=\"variant in font.variants\">{{variant}}<span ng-if=\"!$last\">,&nbsp;</span></span><span ng-if=\"font.subsets.length\">|</span><span ng-repeat=\"subset in font.subsets\">{{subset}}<span ng-if=\"!$last\">,&nbsp;</span></span></div></div><div class=\"ms__button-remove font-remove fr\" ng-show=\"!font._destroy\"><a class=\"inline-wrapper\" ng-click=\"removeFont(font)\"><svg class=\"icon-close\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" style=\"width: 14px;margin-top: 6px;\"><path class=\"icon-close__fill\" d=\"M23.5.5l-23 23m23 0l-23-23\" stroke=\"#000\" fill=\"none\"></path></svg></a></div></li></ul></div><p class=\"input-wrapper\">&nbsp;</p></div></div>";

/***/ }),
/* 414 */
/***/ (function(module, exports) {

module.exports = "<div class=\"etn__site-settings-desc etn__site-settings-desc_etnr\"><div class=\"etn__description etn__description_site\">{{'editor.siteSettings.tabs.item4.description' | translate}}</div></div><form class=\"ta-left\" name=\"siteHtmlHeadForm\" ng-submit=\"saveSite(site, siteHtmlHeadForm)\"><label class=\"label-input\" for=\"html\">{{'editor.siteSettings.tabs.item4.label' | translate}}</label><textarea class=\"textarea ms-checkbox_margin textarea textarea_extra-small button_border\" id=\"html\" ng-model=\"site.head_html\" name=\"headHtml\" placeholder=\"{{'editor.siteSettings.tabs.item4.input' | translate}}\" type=\"text\"></textarea><button class=\"button button_green button_extra-small\" ng-disabled=\"savingSite\" type=\"submit\">{{'editor.siteSettings.tabs.item4.saveButton' | translate}}</button></form>";

/***/ }),
/* 415 */
/***/ (function(module, exports) {

module.exports = "<form ng-submit=\"saveSite(site, siteSettingsForm)\" novalidate=\"\" name=\"siteSettingsForm\"><div class=\"input-wrapper-group\"><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"image-compression\" type=\"checkbox\" ng-model=\"site.need_image_compression\" name=\"need_image_compression\"/><label class=\"checkbox-label-wrapper\" for=\"image-compression\" title=\"{{'editor.siteSettings.tabs.item3.title' | translate}}\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">{{'editor.siteSettings.CompressImagesWhenLoading' | translate}}</span></label></div></div><div class=\"ta-left input-wrapper\"><button class=\"button button_green button_extra-small\" type=\"submit\" ng-disabled=\"savingSite\">{{'editor.siteSettings.tabs.save' | translate}}</button></div></form>";

/***/ }),
/* 416 */
/***/ (function(module, exports) {

module.exports = "<form class=\"ta-left\" name=\"siteSeoSettings\" ng-submit=\"saveHomePage(currentPage, siteSeoSettings)\"><div class=\"input-wrapper\"><label class=\"label-input\">{{'editor.createpage.tabs.item3.titleLabel' | translate}}</label><input class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.seo_title.length}\" ng-model=\"currentPage.seo_title\" placeholder=\"{{&quot;editor.createpage.tabs.item3.titleInput&quot; | translate}}\" type=\"text\"/><div class=\"error-message error-message_formsetting\" tooltip-title=\"{{errors.seo_title[0]}} {{errors.seo_title[1]}}\" tooltips=\"\" tooltip-side=\"top\"><svg class=\"icon-danger\" version=\"1.1\" viewbox=\"0 0 28.937 28.937\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-danger__path\" d=\"M28.859,26.124L14.957,2.245c-0.101-0.173-0.287-0.279-0.489-0.279c-0.198,0-0.383,0.106-0.481,0.279L0.079,26.124 c-0.102,0.175-0.106,0.389-0.006,0.565c0.103,0.174,0.287,0.282,0.488,0.282h27.814c0.201,0,0.389-0.108,0.488-0.282 c0.047-0.088,0.074-0.186,0.074-0.281C28.938,26.309,28.911,26.211,28.859,26.124z M16.369,10.441l-0.462,9.493h-2.389 l-0.461-9.493H16.369z M14.711,24.794h-0.042c-1.089,0-1.843-0.817-1.843-1.907c0-1.131,0.774-1.907,1.885-1.907 s1.846,0.775,1.867,1.907C16.579,23.977,15.844,24.794,14.711,24.794z\"></path></svg></div></div><div class=\"input-wrapper\"><label class=\"label-input\">{{'editor.createpage.tabs.item3.descriptionLabel' | translate}}</label><textarea class=\"textarea textarea textarea_extra-small button_border\" ng-class=\"{'error': errors.seo_description.length}\" ng-model=\"currentPage.seo_description\" placeholder=\"{{'editor.createpage.tabs.item3.descriptionInput' | translate}}\" type=\"text\"></textarea><div class=\"error-message error-message_formsetting\" tooltip-title=\"{{errors.seo_description[0]}} {{errors.seo_description[1]}}\" tooltips=\"\" tooltip-side=\"top\"><svg class=\"icon-danger\" version=\"1.1\" viewbox=\"0 0 28.937 28.937\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-danger__path\" d=\"M28.859,26.124L14.957,2.245c-0.101-0.173-0.287-0.279-0.489-0.279c-0.198,0-0.383,0.106-0.481,0.279L0.079,26.124 c-0.102,0.175-0.106,0.389-0.006,0.565c0.103,0.174,0.287,0.282,0.488,0.282h27.814c0.201,0,0.389-0.108,0.488-0.282 c0.047-0.088,0.074-0.186,0.074-0.281C28.938,26.309,28.911,26.211,28.859,26.124z M16.369,10.441l-0.462,9.493h-2.389 l-0.461-9.493H16.369z M14.711,24.794h-0.042c-1.089,0-1.843-0.817-1.843-1.907c0-1.131,0.774-1.907,1.885-1.907 s1.846,0.775,1.867,1.907C16.579,23.977,15.844,24.794,14.711,24.794z\"></path></svg></div></div><div class=\"input-wrapper\"><label class=\"label-input\">{{'editor.createpage.tabs.item3.keywordsLabel' | translate}}</label><textarea class=\"textarea textarea textarea_extra-small button_border\" ng-class=\"{'error': errors.seo_keywords.length}\" ng-model=\"currentPage.seo_keywords\" placeholder=\"{{'editor.createpage.tabs.item3.keywordsInput' | translate}}\" type=\"text\"></textarea><div class=\"error-message error-message_formsetting\" tooltip-title=\"{{errors.seo_keywords[0]}} {{errors.seo_keywords[1]}}\" tooltips=\"\" tooltip-side=\"top\"><svg class=\"icon-danger\" version=\"1.1\" viewbox=\"0 0 28.937 28.937\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-danger__path\" d=\"M28.859,26.124L14.957,2.245c-0.101-0.173-0.287-0.279-0.489-0.279c-0.198,0-0.383,0.106-0.481,0.279L0.079,26.124 c-0.102,0.175-0.106,0.389-0.006,0.565c0.103,0.174,0.287,0.282,0.488,0.282h27.814c0.201,0,0.389-0.108,0.488-0.282 c0.047-0.088,0.074-0.186,0.074-0.281C28.938,26.309,28.911,26.211,28.859,26.124z M16.369,10.441l-0.462,9.493h-2.389 l-0.461-9.493H16.369z M14.711,24.794h-0.042c-1.089,0-1.843-0.817-1.843-1.907c0-1.131,0.774-1.907,1.885-1.907 s1.846,0.775,1.867,1.907C16.579,23.977,15.844,24.794,14.711,24.794z\"></path></svg></div></div><button class=\"button button_green button_extra-small\" ng-disabled=\"savingPage\" type=\"submit\">{{'editor.siteSettings.tabs.item4.saveButton' | translate}}</button></form>";

/***/ }),
/* 417 */
/***/ (function(module, exports) {

module.exports = "<form class=\"ta-left\" name=\"page\" novalidate=\"\" ng-submit=\"saveHomePage(currentPage, page)\"><div class=\"input-wrapper\"><label class=\"label-input\" for=\"name\">{{'editor.siteSettings.tabs.item6.name' | translate}}</label><input class=\"input input_extra-small button_border\" id=\"name\" ng-class=\"{'error': errors.sw_name.length}\" ng-model=\"currentPage.sw_name\" placeholder=\"{{'editor.createpage.tabs.item3.titleInput' | translate}}\" type=\"text\"/><div class=\"error-message error-message_formsetting\" tooltip-title=\"{{errors.sw_name[0]}} {{errors.sw_name[1]}}\" tooltips=\"\" tooltip-side=\"top\"><svg class=\"icon-danger\" version=\"1.1\" viewbox=\"0 0 28.937 28.937\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-danger__path\" d=\"M28.859,26.124L14.957,2.245c-0.101-0.173-0.287-0.279-0.489-0.279c-0.198,0-0.383,0.106-0.481,0.279L0.079,26.124 c-0.102,0.175-0.106,0.389-0.006,0.565c0.103,0.174,0.287,0.282,0.488,0.282h27.814c0.201,0,0.389-0.108,0.488-0.282 c0.047-0.088,0.074-0.186,0.074-0.281C28.938,26.309,28.911,26.211,28.859,26.124z M16.369,10.441l-0.462,9.493h-2.389 l-0.461-9.493H16.369z M14.711,24.794h-0.042c-1.089,0-1.843-0.817-1.843-1.907c0-1.131,0.774-1.907,1.885-1.907 s1.846,0.775,1.867,1.907C16.579,23.977,15.844,24.794,14.711,24.794z\"></path></svg></div></div><div class=\"input-wrapper\"><label class=\"label-input\" for=\"title\">{{'editor.siteSettings.tabs.item6.title' | translate}}</label><input class=\"input input_extra-small button_border\" id=\"title\" ng-class=\"{'error': errors.sw_title.length}\" ng-model=\"currentPage.sw_title\" placeholder=\"{{'editor.createpage.tabs.item3.titleInput' | translate}}\" type=\"text\"/><div class=\"error-message error-message_formsetting\" tooltip-title=\"{{errors.sw_title[0]}} {{errors.sw_title[1]}}\" tooltips=\"\" tooltip-side=\"top\"><svg class=\"icon-danger\" version=\"1.1\" viewbox=\"0 0 28.937 28.937\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-danger__path\" d=\"M28.859,26.124L14.957,2.245c-0.101-0.173-0.287-0.279-0.489-0.279c-0.198,0-0.383,0.106-0.481,0.279L0.079,26.124 c-0.102,0.175-0.106,0.389-0.006,0.565c0.103,0.174,0.287,0.282,0.488,0.282h27.814c0.201,0,0.389-0.108,0.488-0.282 c0.047-0.088,0.074-0.186,0.074-0.281C28.938,26.309,28.911,26.211,28.859,26.124z M16.369,10.441l-0.462,9.493h-2.389 l-0.461-9.493H16.369z M14.711,24.794h-0.042c-1.089,0-1.843-0.817-1.843-1.907c0-1.131,0.774-1.907,1.885-1.907 s1.846,0.775,1.867,1.907C16.579,23.977,15.844,24.794,14.711,24.794z\"></path></svg></div></div><div class=\"input-wrapper\"><label class=\"label-input\" for=\"description\">{{'editor.siteSettings.tabs.item6.description' | translate}}</label><textarea class=\"textarea textarea textarea_extra-small button_border\" id=\"description\" ng-class=\"{'error': errors.sw_description.length}\" ng-model=\"currentPage.sw_description\" placeholder=\"{{'editor.createpage.tabs.item3.descriptionInput' | translate}}\" type=\"text\"></textarea><div class=\"error-message error-message_formsetting\" tooltip-title=\"{{errors.sw_description[0]}} {{errors.sw_description[1]}}\" tooltips=\"\" tooltip-side=\"top\"><svg class=\"icon-danger\" version=\"1.1\" viewbox=\"0 0 28.937 28.937\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-danger__path\" d=\"M28.859,26.124L14.957,2.245c-0.101-0.173-0.287-0.279-0.489-0.279c-0.198,0-0.383,0.106-0.481,0.279L0.079,26.124 c-0.102,0.175-0.106,0.389-0.006,0.565c0.103,0.174,0.287,0.282,0.488,0.282h27.814c0.201,0,0.389-0.108,0.488-0.282 c0.047-0.088,0.074-0.186,0.074-0.281C28.938,26.309,28.911,26.211,28.859,26.124z M16.369,10.441l-0.462,9.493h-2.389 l-0.461-9.493H16.369z M14.711,24.794h-0.042c-1.089,0-1.843-0.817-1.843-1.907c0-1.131,0.774-1.907,1.885-1.907 s1.846,0.775,1.867,1.907C16.579,23.977,15.844,24.794,14.711,24.794z\"></path></svg></div></div><div class=\"input-wrapper\"><label class=\"label-input\" for=\"keywords\">{{'editor.siteSettings.tabs.item6.keywords' | translate}}</label><textarea class=\"textarea textarea textarea_extra-small button_border\" id=\"keywords\" ng-class=\"{'error': errors.sw_keywords.length}\" ng-model=\"currentPage.sw_keywords\" placeholder=\"{{'editor.createpage.tabs.item3.keywordsInput' | translate}}\" type=\"text\"></textarea><div class=\"error-message error-message_formsetting\" tooltip-title=\"{{errors.sw_keywords[0]}} {{errors.sw_keywords[1]}}\" tooltips=\"\" tooltip-side=\"top\"><svg class=\"icon-danger\" version=\"1.1\" viewbox=\"0 0 28.937 28.937\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-danger__path\" d=\"M28.859,26.124L14.957,2.245c-0.101-0.173-0.287-0.279-0.489-0.279c-0.198,0-0.383,0.106-0.481,0.279L0.079,26.124 c-0.102,0.175-0.106,0.389-0.006,0.565c0.103,0.174,0.287,0.282,0.488,0.282h27.814c0.201,0,0.389-0.108,0.488-0.282 c0.047-0.088,0.074-0.186,0.074-0.281C28.938,26.309,28.911,26.211,28.859,26.124z M16.369,10.441l-0.462,9.493h-2.389 l-0.461-9.493H16.369z M14.711,24.794h-0.042c-1.089,0-1.843-0.817-1.843-1.907c0-1.131,0.774-1.907,1.885-1.907 s1.846,0.775,1.867,1.907C16.579,23.977,15.844,24.794,14.711,24.794z\"></path></svg></div></div><div class=\"input-wrapper\"><label class=\"label-input\">{{'editor.siteSettings.tabs.item6.photo' | translate}}</label><div class=\"etn__preview etn__preview_mobile ta-left\"><div class=\"input-wrapper\"><input class=\"ng-hide\" id=\"etn__social\" type=\"file\" nv-file-select=\"\" uploader=\"networkingUploader\"/><label for=\"etn__social\"><div class=\"etn__preview-upload etn__preview-upload_networking ms-input_border\"><img class=\"etn__preview-image\" id=\"networkingImage\" ng-src=\"{{currentPage.networking_image.thumb_normal}}\" err-src=\"/constructor/editor/assets/images/image-error.svg\"/><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': networkingUploader.progress + '%' }\" ng-show=\"networkingUploader.progress\"></div></div></label></div></div><a class=\"link\" ng-click=\"removeNetworkingImage()\" ng-if=\"currentPage.networking_image.thumb_normal\">{{'socialsettings.removeLabel' | translate}}</a></div><button class=\"button button_green button_extra-small\" ng-disabled=\"savingPage\" type=\"submit\">{{'editor.siteSettings.tabs.item4.saveButton' | translate}}</button></form>";

/***/ }),
/* 418 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"><div class=\"middle-title ta-center\"><span ng-if=\"Editor.mode == 'site.page.editor' || Editor.mode == 'lesson.page.editor'\">{{'editor.siteSettings.title' | translate}}</span><span ng-if=\"Editor.mode == 'email.page.editor'\">{{'editor.siteSettings.emailTitle' | translate}}</span></div></div><nav class=\"header-menu__nav header-menu__nav_page-settings\"><a class=\"link header-menu__link header-menu__link_page-settings group-title\" ng-class=\"{'link_active': currentSettings == 'fonts'}\" ng-show=\"Editor.mode == 'site.page.editor' || Editor.mode == 'lesson.page.editor'\" ng-click=\"currentSettings = 'fonts'\">{{'editor.siteSettings.tabs.item2' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title\" ng-class=\"{'link_active': currentSettings == 'bg'}\" ng-click=\"currentSettings = 'bg'\">{{'editor.siteSettings.tabs.item5' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title\" ng-class=\"{'link_active': currentSettings == 'image'}\" ng-click=\"currentSettings = 'image'\">{{'editor.siteSettings.tabs.item3' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title\" ng-class=\"{'link_active': currentSettings == 'html'}\" ng-show=\"Editor.mode == 'site.page.editor' || Editor.mode == 'lesson.page.editor'\" ng-click=\"currentSettings = 'html'\">{{'editor.siteSettings.tabs.item4' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title\" ng-class=\"{'link_active': currentSettings == 'seoSettings'}\" ng-show=\"Editor.mode == 'site.page.editor' || Editor.mode == 'lesson.page.editor'\" ng-click=\"currentSettings = 'seoSettings'\">{{'editor.createpage.tabs.item3' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title\" ng-class=\"{'link_active': currentSettings == 'swSettings'}\" ng-show=\"Editor.mode == 'site.page.editor' || Editor.mode == 'lesson.page.editor'\" ng-click=\"currentSettings = 'swSettings'\">{{'editor.siteSettings.tabs.item6' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title\" access=\"admin\" ng-show=\"Editor.mode == 'site.page.editor' || Editor.mode == 'lesson.page.editor'\" ng-class=\"{'link_active': currentSettings == 'admin'}\" ng-click=\"currentSettings = 'admin'\">{{'editor.siteSettings.tabs.item7' | translate}}</a></nav><div class=\"modal-body\"><div class=\"site__settings-view\" ng-if=\"currentSettings == 'fonts' &amp;&amp; (Editor.mode == 'site.page.editor' || Editor.mode == 'lesson.page.editor')\"><div class=\"etn-settings\" ng-controller=\"fontSettingsCtrl\"><ng-include src=\"'./site/site_settings/settings_views/fontsettings.jade'\"></ng-include></div></div><div class=\"site__settings-view\" ng-if=\"currentSettings == 'bg'\"><ng-include src=\"'./site/site_settings/settings_views/bg.jade'\"></ng-include></div><div class=\"site__settings-view\" ng-if=\"currentSettings == 'image'\"><ng-include src=\"'./site/site_settings/settings_views/imagesettings.jade'\"></ng-include></div><div class=\"site__settings-view\" ng-if=\"Editor.mode == 'site.page.editor' || Editor.mode == 'lesson.page.editor'\" ng-show=\"currentSettings == 'html'\"><ng-include src=\"'./site/site_settings/settings_views/htmlcode.jade'\"></ng-include></div><div class=\"site__settings-view\" ng-if=\"Editor.mode == 'site.page.editor' || Editor.mode == 'lesson.page.editor'\" ng-show=\"currentSettings == 'seoSettings'\"><ng-include src=\"'./site/site_settings/settings_views/seosettings.jade'\"></ng-include></div><div class=\"site__settings-view\" ng-if=\"Editor.mode == 'site.page.editor' || Editor.mode == 'lesson.page.editor'\" ng-show=\"currentSettings == 'swSettings'\"><ng-include src=\"'./site/site_settings/settings_views/swsettings.jade'\"></ng-include></div><div class=\"site__settings-view\" ng-show=\"currentSettings == 'admin'\" access=\"admin superadmin\"><ng-include src=\"'./site/site_settings/settings_views/adminsettings.jade'\"></ng-include></div></div>";

/***/ }),
/* 419 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"><div class=\"middle-title ta-center\">Editing a form</div></div><form class=\"modal-body\" ng-submit=\"saveTemplate(site, editTemplateForm)\" novalidate=\"\" name=\"editTemplateForm\"><div class=\"input-wrapper\"><label class=\"label-input\">Name</label><input class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.name.length}\" ng-model=\"site.name\" placeholder=\"Enter project name\" required=\"\" type=\"text\"/><div class=\"error-message error-message_newlanding\" tooltip-title=\"{{errors.name[0]}} {{errors.name[1]}}\" tooltips=\"\"><svg class=\"icon-danger\" version=\"1.1\" viewbox=\"0 0 28.937 28.937\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-danger__path\" d=\"M28.859,26.124L14.957,2.245c-0.101-0.173-0.287-0.279-0.489-0.279c-0.198,0-0.383,0.106-0.481,0.279L0.079,26.124 c-0.102,0.175-0.106,0.389-0.006,0.565c0.103,0.174,0.287,0.282,0.488,0.282h27.814c0.201,0,0.389-0.108,0.488-0.282 c0.047-0.088,0.074-0.186,0.074-0.281C28.938,26.309,28.911,26.211,28.859,26.124z M16.369,10.441l-0.462,9.493h-2.389 l-0.461-9.493H16.369z M14.711,24.794h-0.042c-1.089,0-1.843-0.817-1.843-1.907c0-1.131,0.774-1.907,1.885-1.907 s1.846,0.775,1.867,1.907C16.579,23.977,15.844,24.794,14.711,24.794z\"></path></svg></div></div><div class=\"input-wrapper\"><label class=\"label-input\">Subdomain</label><input class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.subdomain.length}\" ng-model=\"site.subdomain\" placeholder=\"Subdomain\" required=\"\" type=\"text\"/><div class=\"error-message error-message_newlanding\" tooltip-title=\"{{errors.subdomain[0]}} {{errors.subdomain[1]}}\" tooltips=\"\"><svg class=\"icon-danger\" version=\"1.1\" viewbox=\"0 0 28.937 28.937\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-danger__path\" d=\"M28.859,26.124L14.957,2.245c-0.101-0.173-0.287-0.279-0.489-0.279c-0.198,0-0.383,0.106-0.481,0.279L0.079,26.124 c-0.102,0.175-0.106,0.389-0.006,0.565c0.103,0.174,0.287,0.282,0.488,0.282h27.814c0.201,0,0.389-0.108,0.488-0.282 c0.047-0.088,0.074-0.186,0.074-0.281C28.938,26.309,28.911,26.211,28.859,26.124z M16.369,10.441l-0.462,9.493h-2.389 l-0.461-9.493H16.369z M14.711,24.794h-0.042c-1.089,0-1.843-0.817-1.843-1.907c0-1.131,0.774-1.907,1.885-1.907 s1.846,0.775,1.867,1.907C16.579,23.977,15.844,24.794,14.711,24.794z\"></path></svg></div></div><div class=\"input-wrapper\"><label class=\"label-input\">Type</label><div class=\"radio-wrapper ms-radio radio-wrapper_inline\"><input class=\"radio\" id=\"ms__webform-order-type-radio\" type=\"radio\" name=\"webform-type-radio\" value=\"Order\" ng-model=\"site.type\"/><label class=\"radio-label-wrapper\" for=\"ms__webform-order-type-radio\" title=\"Order form\"><span class=\"radio-label radio-label_small fl\"></span><span class=\"label-text\">Order form</span></label></div><div class=\"radio-wrapper ms-radio radio-wrapper_inline\"><input class=\"radio\" id=\"ms__webform-subscribe-type-radio\" type=\"radio\" name=\"webform-type-radio\" value=\"Subscribe\" ng-model=\"site.type\"/><label class=\"radio-label-wrapper\" for=\"ms__webform-subscribe-type-radio\" title=\"Subscribe form\"><span class=\"radio-label radio-label_small fl\"></span><span class=\"label-text\">Subscribe form</span></label></div></div><div class=\"input-wrapper-group\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Tags</label><tags-input ng-model=\"site.tags\"><auto-complete source=\"loadTags($query)\" min-length=\"{{currentUser.lang === 'ja' ? 1 : 3}}\" load-on-empty=\"true\" load-on-focus=\"true\"></auto-complete></tags-input></div></div><div class=\"input-wrapper-group\"><div class=\"etn__preview etn__preview_web ta-left\"><div class=\"label-input\">Web Preview</div><input class=\"ng-hide\" id=\"etn__preview_web\" type=\"file\" nv-file-select=\"\" uploader=\"webPreviewUploader\"/><span class=\"file-name\">{{webPreviewUploader.queue[0].file.name}}</span><label for=\"etn__preview_web\"><div class=\"etn__preview-upload etn__preview-upload_web ms-input_border {{'favorite.upload_web_hint' | translate}}\"><img class=\"etn__preview-image\" ng-src=\"{{site.preview.preview.thumb.url}}\" err-src=\"/constructor/editor/assets/images/image-error.svg\"/><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': webPreviewUploader.progress + '%' }\" ng-show=\"webPreviewUploader.progress\"></div></div></label></div></div><div class=\"input-wrapper ta-left\"><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"disablesite\" type=\"checkbox\" ng-model=\"site.disabled\"/><label class=\"checkbox-label-wrapper\" title=\"Hide template\" for=\"disablesite\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Hide from user template</span></label></div></div><div class=\"input-wrapper\"><button class=\"button button_green button_extra-small button_modal\" type=\"button\" ng-click=\"clone()\" ng-disabled=\"cloning\" ng-show=\"mainTemplate\">Create a new variant</button></div><div class=\"modal-footer ta-center\"><button class=\"button button_margin button_green button_extra-small button_modal\" type=\"submit\" ng-disabled=\"saving\">Save template</button><button class=\"button button_margin button_grayish-blue button_extra-small button_modal\" ng-click=\"close($event)\">Cancel</button></div></form>";

/***/ }),
/* 420 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"><div class=\"middle-title ta-center\">{{'form.Publish' | translate}}</div></div><nav class=\"header-menu__nav header-menu__nav_page-settings ta-center\"><a class=\"link header-menu__link header-menu__link_page-settings group-title\" ng-class=\"{'link_active': currentTab == 'htmlLoader'}\" ng-click=\"currentTab = 'htmlLoader'\">{{'form.JavascriptCode' | translate}}</a><a class=\"link header-menu__link header-menu__link_page-settings group-title\" ng-class=\"{'link_active': currentTab == 'htmlData'}\" ng-click=\"currentTab = 'htmlData'\">{{'form.HtmlCode' | translate}}</a></nav><div class=\"modal-body\"><div class=\"input-wrapper web-form-info\" ng-show=\"currentTab == 'htmlLoader'\"><div class=\"web-form-info__block\"><label class=\"label-input\" style=\"text-align: center; margin-bottom: 10px;\" for=\"loader_of_form\">{{'form.CopyCodeAndPaste' | translate}}</label></div><div class=\"web-form-info__block\">{{'form.ToAddMultipleFormsToOnePage' | translate}} &nbsp;<a class=\"web-form-info__link-dashed\" href=\"javascript: void(0)\" ng-click=\"showExamples = !showExamples\">{{'form.ShowExamples' | translate}}</a></div><pre class=\"web-form-info__block web-form-info__example\" ng-if=\"showExamples\"><div>{{'form.example.label' | translate}} 1 «...050»</div><div>&lt;script id=&quot;form-111&quot; type=&quot;text/javascript&quot; src=&quot;https://.../web_forms/...050/form_loader.js?cid=form-111&quot;&gt;&lt;/script&gt;</div><br/><div>{{'form.example.label' | translate}} 2 «...050»</div><div>&lt;script id=&quot;form-222&quot; type=&quot;text/javascript&quot; src=&quot;https://.../web_forms/...050/form_loader.js?cid=form-222&quot;&gt;&lt;/script&gt;</div></pre><textarea class=\"textarea textarea_extra-small ms-input_border input\" id=\"loader_of_form\" placeholder=\"{{'modulesSettings.uploadingButton' | translate}}\" readonly=\"readonly\" rows=\"20\" style=\"height:initial;\">{{ htmlLoader }}</textarea></div><div class=\"input-wrapper\" ng-show=\"currentTab == 'htmlData'\"><label class=\"label-input\" style=\"text-align: center; margin-bottom: 10px; font-weight: 300;\" for=\"html_of_form\">{{'form.CopyCodeAndPaste' | translate}}</label><textarea class=\"textarea textarea_extra-small ms-input_border input\" id=\"html_of_form\" placeholder=\"{{'modulesSettings.uploadingButton' | translate}}\" readonly=\"readonly\" rows=\"20\" style=\"height:initial;\">{{ htmlData }}</textarea></div></div>";

/***/ }),
/* 421 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"><div class=\"middle-title ta-center\">New form</div></div><form class=\"modal-body\" ng-submit=\"createTemplate(site, newTemplateForm)\" novalidate=\"\" name=\"newTemplateForm\"><div class=\"input-wrapper\"><label class=\"label-input\">Name</label><input class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.name.length}\" ng-model=\"site.name\" placeholder=\"Enter project name\" required=\"\" type=\"text\"/><div class=\"error-message error-message_newlanding\" tooltip-title=\"{{errors.name[0]}} {{errors.name[1]}}\" tooltips=\"\"><svg class=\"icon-danger\" version=\"1.1\" viewbox=\"0 0 28.937 28.937\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-danger__path\" d=\"M28.859,26.124L14.957,2.245c-0.101-0.173-0.287-0.279-0.489-0.279c-0.198,0-0.383,0.106-0.481,0.279L0.079,26.124 c-0.102,0.175-0.106,0.389-0.006,0.565c0.103,0.174,0.287,0.282,0.488,0.282h27.814c0.201,0,0.389-0.108,0.488-0.282 c0.047-0.088,0.074-0.186,0.074-0.281C28.938,26.309,28.911,26.211,28.859,26.124z M16.369,10.441l-0.462,9.493h-2.389 l-0.461-9.493H16.369z M14.711,24.794h-0.042c-1.089,0-1.843-0.817-1.843-1.907c0-1.131,0.774-1.907,1.885-1.907 s1.846,0.775,1.867,1.907C16.579,23.977,15.844,24.794,14.711,24.794z\"></path></svg></div></div><div class=\"input-wrapper\"><label class=\"label-input\">Subdomain</label><div class=\"input input_extra-small button_border\" ng-class=\"{'error': errors.subdomain.length}\"><span contenteditable=\"true\" ng-init=\"site.subdomain = 'example'\" ng-model=\"site.subdomain\">example</span></div><div class=\"error-message error-message_newlanding\" tooltip-title=\"{{errors.subdomain[0]}} {{errors.subdomain[1]}}\" tooltips=\"\"><svg class=\"icon-danger\" version=\"1.1\" viewbox=\"0 0 28.937 28.937\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"icon-danger__path\" d=\"M28.859,26.124L14.957,2.245c-0.101-0.173-0.287-0.279-0.489-0.279c-0.198,0-0.383,0.106-0.481,0.279L0.079,26.124 c-0.102,0.175-0.106,0.389-0.006,0.565c0.103,0.174,0.287,0.282,0.488,0.282h27.814c0.201,0,0.389-0.108,0.488-0.282 c0.047-0.088,0.074-0.186,0.074-0.281C28.938,26.309,28.911,26.211,28.859,26.124z M16.369,10.441l-0.462,9.493h-2.389 l-0.461-9.493H16.369z M14.711,24.794h-0.042c-1.089,0-1.843-0.817-1.843-1.907c0-1.131,0.774-1.907,1.885-1.907 s1.846,0.775,1.867,1.907C16.579,23.977,15.844,24.794,14.711,24.794z\"></path></svg></div></div><div class=\"input-wrapper\"><label class=\"label-input\">Type</label><div class=\"radio-wrapper ms-radio radio-wrapper_inline\"><input class=\"radio\" id=\"ms__webform-order-type-radio\" type=\"radio\" name=\"webform-type-radio\" value=\"Order\" ng-model=\"site.type\"/><label class=\"radio-label-wrapper\" for=\"ms__webform-order-type-radio\" title=\"Order form\"><span class=\"radio-label radio-label_small fl\"></span><span class=\"label-text\">Order form</span></label></div><div class=\"radio-wrapper ms-radio radio-wrapper_inline\"><input class=\"radio\" id=\"ms__webform-subscribe-type-radio\" type=\"radio\" name=\"webform-type-radio\" value=\"Subscribe\" ng-model=\"site.type\"/><label class=\"radio-label-wrapper\" for=\"ms__webform-subscribe-type-radio\" title=\"Subscribe form\"><span class=\"radio-label radio-label_small fl\"></span><span class=\"label-text\">Subscribe form</span></label></div></div><div class=\"input-wrapper-group\"><div class=\"input-wrapper ta-left\"><label class=\"label-input\">Tags</label><tags-input ng-model=\"site.tags\" min-length=\"{{currentUser.lang === 'ja' ? 1 : 3}}\" replace-spaces-with-dashes=\"false\"><auto-complete source=\"loadTags($query)\" load-on-empty=\"true\" load-on-focus=\"true\"></auto-complete></tags-input></div></div><div class=\"input-wrapper-group\"><div class=\"etn__preview etn__preview_web ta-left\"><div class=\"label-input\">Web Preview</div><input class=\"ng-hide\" id=\"etn__preview_web\" type=\"file\" nv-file-select=\"\" uploader=\"webPreviewUploader\"/><span class=\"file-name\">{{webPreviewUploader.queue[0].file.name}}</span><label for=\"etn__preview_web\"><div class=\"etn__preview-upload etn__preview-upload_web ms-input_border {{'favorite.upload_web_hint' | translate}}\"><img class=\"etn__preview-image\" ng-src=\"{{site.preview.thumb.url}}\" err-src=\"/constructor/editor/assets/images/image-error.svg\"/><div class=\"progress-line progress-line_small\" ng-style=\"{ 'width': webPreviewUploader.progress + '%' }\" ng-show=\"webPreviewUploader.progress\"></div></div></label></div></div><div class=\"input-wrapper ta-left\"><div class=\"checkbox-wrapper input-wrapper ms-checkbox ta-left\"><input class=\"checkbox\" id=\"disablesite\" type=\"checkbox\" ng-model=\"site.disabled\"/><label class=\"checkbox-label-wrapper\" title=\"Hide template\" for=\"disablesite\"><div class=\"checkbox-label checkbox-label_small button_border fl\"><svg class=\"icon-check\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\"><rect class=\"icon-check__rect\" x=\"2.4\" y=\"3.4\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)\" width=\"10\" height=\"2\"></rect><rect class=\"icon-check__rect\" x=\"0.2\" y=\"4.8\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)\" width=\"6\" height=\"2\"></rect></svg></div><span class=\"label-text\">Hide from user template</span></label></div></div><div class=\"modal-footer ta-center\"><button class=\"button button_margin button_green button_extra-small button_modal\" type=\"submit\" ng-disabled=\"creating\">Add template</button><button class=\"button button_margin button_grayish-blue button_extra-small button_modal\" ng-click=\"close($event)\">Cancel</button></div></form>";

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var DateFormatter;!function(){"use strict";var e,t,a,r,n,o;n=864e5,o=3600,e=function(e,t){return"string"==typeof e&&"string"==typeof t&&e.toLowerCase()===t.toLowerCase()},t=function(e,a,r){var n=r||"0",o=e.toString();return o.length<a?t(n+o,a):o},a=function(e){var t,r;for(e=e||{},t=1;t<arguments.length;t++)if(r=arguments[t])for(var n in r)r.hasOwnProperty(n)&&("object"==typeof r[n]?a(e[n],r[n]):e[n]=r[n]);return e},r={dateSettings:{days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],daysShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],monthsShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],meridiem:["AM","PM"],ordinal:function(e){var t=e%10,a={1:"st",2:"nd",3:"rd"};return 1!==Math.floor(e%100/10)&&a[t]?a[t]:"th"}},separators:/[ \-+\/\.T:@]/g,validParts:/[dDjlNSwzWFmMntLoYyaABgGhHisueTIOPZcrU]/g,intParts:/[djwNzmnyYhHgGis]/g,tzParts:/\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,tzClip:/[^-+\dA-Z]/g},DateFormatter=function(e){var t=this,n=a(r,e);t.dateSettings=n.dateSettings,t.separators=n.separators,t.validParts=n.validParts,t.intParts=n.intParts,t.tzParts=n.tzParts,t.tzClip=n.tzClip},DateFormatter.prototype={constructor:DateFormatter,parseDate:function(t,a){var r,n,o,i,s,d,u,l,f,c,m=this,h=!1,g=!1,p=m.dateSettings,y={date:null,year:null,month:null,day:null,hour:0,min:0,sec:0};if(!t)return void 0;if(t instanceof Date)return t;if("number"==typeof t)return new Date(t);if("U"===a)return o=parseInt(t),o?new Date(1e3*o):t;if("string"!=typeof t)return"";if(r=a.match(m.validParts),!r||0===r.length)throw new Error("Invalid date format definition.");for(n=t.replace(m.separators,"\x00").split("\x00"),o=0;o<n.length;o++)switch(i=n[o],s=parseInt(i),r[o]){case"y":case"Y":f=i.length,2===f?y.year=parseInt((70>s?"20":"19")+i):4===f&&(y.year=s),h=!0;break;case"m":case"n":case"M":case"F":isNaN(i)?(d=p.monthsShort.indexOf(i),d>-1&&(y.month=d+1),d=p.months.indexOf(i),d>-1&&(y.month=d+1)):s>=1&&12>=s&&(y.month=s),h=!0;break;case"d":case"j":s>=1&&31>=s&&(y.day=s),h=!0;break;case"g":case"h":u=r.indexOf("a")>-1?r.indexOf("a"):r.indexOf("A")>-1?r.indexOf("A"):-1,c=n[u],u>-1?(l=e(c,p.meridiem[0])?0:e(c,p.meridiem[1])?12:-1,s>=1&&12>=s&&l>-1?y.hour=s+l-1:s>=0&&23>=s&&(y.hour=s)):s>=0&&23>=s&&(y.hour=s),g=!0;break;case"G":case"H":s>=0&&23>=s&&(y.hour=s),g=!0;break;case"i":s>=0&&59>=s&&(y.min=s),g=!0;break;case"s":s>=0&&59>=s&&(y.sec=s),g=!0}if(h===!0&&y.year&&y.month&&y.day)y.date=new Date(y.year,y.month-1,y.day,y.hour,y.min,y.sec,0);else{if(g!==!0)return!1;y.date=new Date(0,0,0,y.hour,y.min,y.sec,0)}return y.date},guessDate:function(e,t){if("string"!=typeof e)return e;var a,r,n,o,i=this,s=e.replace(i.separators,"\x00").split("\x00"),d=/^[djmn]/g,u=t.match(i.validParts),l=new Date,f=0;if(!d.test(u[0]))return e;for(r=0;r<s.length;r++){switch(f=2,n=s[r],o=parseInt(n.substr(0,2)),r){case 0:"m"===u[0]||"n"===u[0]?l.setMonth(o-1):l.setDate(o);break;case 1:"m"===u[0]||"n"===u[0]?l.setDate(o):l.setMonth(o-1);break;case 2:a=l.getFullYear(),n.length<4?(l.setFullYear(parseInt(a.toString().substr(0,4-n.length)+n)),f=n.length):(l.setFullYear=parseInt(n.substr(0,4)),f=4);break;case 3:l.setHours(o);break;case 4:l.setMinutes(o);break;case 5:l.setSeconds(o)}n.substr(f).length>0&&s.splice(r+1,0,n.substr(f))}return l},parseFormat:function(e,a){var r,i=this,s=i.dateSettings,d=/\\?(.?)/gi,u=function(e,t){return r[e]?r[e]():t};return r={d:function(){return t(r.j(),2)},D:function(){return s.daysShort[r.w()]},j:function(){return a.getDate()},l:function(){return s.days[r.w()]},N:function(){return r.w()||7},w:function(){return a.getDay()},z:function(){var e=new Date(r.Y(),r.n()-1,r.j()),t=new Date(r.Y(),0,1);return Math.round((e-t)/n)},W:function(){var e=new Date(r.Y(),r.n()-1,r.j()-r.N()+3),a=new Date(e.getFullYear(),0,4);return t(1+Math.round((e-a)/n/7),2)},F:function(){return s.months[a.getMonth()]},m:function(){return t(r.n(),2)},M:function(){return s.monthsShort[a.getMonth()]},n:function(){return a.getMonth()+1},t:function(){return new Date(r.Y(),r.n(),0).getDate()},L:function(){var e=r.Y();return e%4===0&&e%100!==0||e%400===0?1:0},o:function(){var e=r.n(),t=r.W(),a=r.Y();return a+(12===e&&9>t?1:1===e&&t>9?-1:0)},Y:function(){return a.getFullYear()},y:function(){return r.Y().toString().slice(-2)},a:function(){return r.A().toLowerCase()},A:function(){var e=r.G()<12?0:1;return s.meridiem[e]},B:function(){var e=a.getUTCHours()*o,r=60*a.getUTCMinutes(),n=a.getUTCSeconds();return t(Math.floor((e+r+n+o)/86.4)%1e3,3)},g:function(){return r.G()%12||12},G:function(){return a.getHours()},h:function(){return t(r.g(),2)},H:function(){return t(r.G(),2)},i:function(){return t(a.getMinutes(),2)},s:function(){return t(a.getSeconds(),2)},u:function(){return t(1e3*a.getMilliseconds(),6)},e:function(){var e=/\((.*)\)/.exec(String(a))[1];return e||"Coordinated Universal Time"},T:function(){var e=(String(a).match(i.tzParts)||[""]).pop().replace(i.tzClip,"");return e||"UTC"},I:function(){var e=new Date(r.Y(),0),t=Date.UTC(r.Y(),0),a=new Date(r.Y(),6),n=Date.UTC(r.Y(),6);return e-t!==a-n?1:0},O:function(){var e=a.getTimezoneOffset(),r=Math.abs(e);return(e>0?"-":"+")+t(100*Math.floor(r/60)+r%60,4)},P:function(){var e=r.O();return e.substr(0,3)+":"+e.substr(3,2)},Z:function(){return 60*-a.getTimezoneOffset()},c:function(){return"Y-m-d\\TH:i:sP".replace(d,u)},r:function(){return"D, d M Y H:i:s O".replace(d,u)},U:function(){return a.getTime()/1e3||0}},u(e,e)},formatDate:function(e,t){var a,r,n,o,i,s=this,d="";if("string"==typeof e&&(e=s.parseDate(e,t),e===!1))return!1;if(e instanceof Date){for(n=t.length,a=0;n>a;a++)i=t.charAt(a),"S"!==i&&(o=s.parseFormat(i,e),a!==n-1&&s.intParts.test(i)&&"S"===t.charAt(a+1)&&(r=parseInt(o),o+=s.dateSettings.ordinal(r)),d+=o);return d}return""}}}(),function(e){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0),__webpack_require__(423)], __WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?module.exports=e:e(jQuery)}(function(e){"use strict";function t(e,t,a){this.date=e,this.desc=t,this.style=a}var a={i18n:{ar:{months:["كانون الثاني","شباط","آذار","نيسان","مايو","حزيران","تموز","آب","أيلول","تشرين الأول","تشرين الثاني","كانون الأول"],dayOfWeekShort:["ن","ث","ع","خ","ج","س","ح"],dayOfWeek:["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت","الأحد"]},ro:{months:["Ianuarie","Februarie","Martie","Aprilie","Mai","Iunie","Iulie","August","Septembrie","Octombrie","Noiembrie","Decembrie"],dayOfWeekShort:["Du","Lu","Ma","Mi","Jo","Vi","Sâ"],dayOfWeek:["Duminică","Luni","Marţi","Miercuri","Joi","Vineri","Sâmbătă"]},id:{months:["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"],dayOfWeekShort:["Min","Sen","Sel","Rab","Kam","Jum","Sab"],dayOfWeek:["Minggu","Senin","Selasa","Rabu","Kamis","Jumat","Sabtu"]},is:{months:["Janúar","Febrúar","Mars","Apríl","Maí","Júní","Júlí","Ágúst","September","Október","Nóvember","Desember"],dayOfWeekShort:["Sun","Mán","Þrið","Mið","Fim","Fös","Lau"],dayOfWeek:["Sunnudagur","Mánudagur","Þriðjudagur","Miðvikudagur","Fimmtudagur","Föstudagur","Laugardagur"]},bg:{months:["Януари","Февруари","Март","Април","Май","Юни","Юли","Август","Септември","Октомври","Ноември","Декември"],dayOfWeekShort:["Нд","Пн","Вт","Ср","Чт","Пт","Сб"],dayOfWeek:["Неделя","Понеделник","Вторник","Сряда","Четвъртък","Петък","Събота"]},fa:{months:["فروردین","اردیبهشت","خرداد","تیر","مرداد","شهریور","مهر","آبان","آذر","دی","بهمن","اسفند"],dayOfWeekShort:["یکشنبه","دوشنبه","سه شنبه","چهارشنبه","پنجشنبه","جمعه","شنبه"],dayOfWeek:["یک‌شنبه","دوشنبه","سه‌شنبه","چهارشنبه","پنج‌شنبه","جمعه","شنبه","یک‌شنبه"]},ru:{months:["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"],dayOfWeekShort:["Вс","Пн","Вт","Ср","Чт","Пт","Сб"],dayOfWeek:["Воскресенье","Понедельник","Вторник","Среда","Четверг","Пятница","Суббота"]},uk:{months:["Січень","Лютий","Березень","Квітень","Травень","Червень","Липень","Серпень","Вересень","Жовтень","Листопад","Грудень"],dayOfWeekShort:["Ндл","Пнд","Втр","Срд","Чтв","Птн","Сбт"],dayOfWeek:["Неділя","Понеділок","Вівторок","Середа","Четвер","П'ятниця","Субота"]},en:{months:["January","February","March","April","May","June","July","August","September","October","November","December"],dayOfWeekShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],dayOfWeek:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},el:{months:["Ιανουάριος","Φεβρουάριος","Μάρτιος","Απρίλιος","Μάιος","Ιούνιος","Ιούλιος","Αύγουστος","Σεπτέμβριος","Οκτώβριος","Νοέμβριος","Δεκέμβριος"],dayOfWeekShort:["Κυρ","Δευ","Τρι","Τετ","Πεμ","Παρ","Σαβ"],dayOfWeek:["Κυριακή","Δευτέρα","Τρίτη","Τετάρτη","Πέμπτη","Παρασκευή","Σάββατο"]},de:{months:["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"],dayOfWeekShort:["So","Mo","Di","Mi","Do","Fr","Sa"],dayOfWeek:["Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag"]},nl:{months:["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"],dayOfWeekShort:["zo","ma","di","wo","do","vr","za"],dayOfWeek:["zondag","maandag","dinsdag","woensdag","donderdag","vrijdag","zaterdag"]},tr:{months:["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"],dayOfWeekShort:["Paz","Pts","Sal","Çar","Per","Cum","Cts"],dayOfWeek:["Pazar","Pazartesi","Salı","Çarşamba","Perşembe","Cuma","Cumartesi"]},fr:{months:["Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"],dayOfWeekShort:["Dim","Lun","Mar","Mer","Jeu","Ven","Sam"],dayOfWeek:["dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi"]},es:{months:["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],dayOfWeekShort:["Dom","Lun","Mar","Mié","Jue","Vie","Sáb"],dayOfWeek:["Domingo","Lunes","Martes","Miércoles","Jueves","Viernes","Sábado"]},th:{months:["มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน","กรกฎาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม"],dayOfWeekShort:["อา.","จ.","อ.","พ.","พฤ.","ศ.","ส."],dayOfWeek:["อาทิตย์","จันทร์","อังคาร","พุธ","พฤหัส","ศุกร์","เสาร์","อาทิตย์"]},pl:{months:["styczeń","luty","marzec","kwiecień","maj","czerwiec","lipiec","sierpień","wrzesień","październik","listopad","grudzień"],dayOfWeekShort:["nd","pn","wt","śr","cz","pt","sb"],dayOfWeek:["niedziela","poniedziałek","wtorek","środa","czwartek","piątek","sobota"]},pt:{months:["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],dayOfWeekShort:["Dom","Seg","Ter","Qua","Qui","Sex","Sab"],dayOfWeek:["Domingo","Segunda","Terça","Quarta","Quinta","Sexta","Sábado"]},ch:{months:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],dayOfWeekShort:["日","一","二","三","四","五","六"]},se:{months:["Januari","Februari","Mars","April","Maj","Juni","Juli","Augusti","September","Oktober","November","December"],dayOfWeekShort:["Sön","Mån","Tis","Ons","Tor","Fre","Lör"]},kr:{months:["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"],dayOfWeekShort:["일","월","화","수","목","금","토"],dayOfWeek:["일요일","월요일","화요일","수요일","목요일","금요일","토요일"]},it:{months:["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"],dayOfWeekShort:["Dom","Lun","Mar","Mer","Gio","Ven","Sab"],dayOfWeek:["Domenica","Lunedì","Martedì","Mercoledì","Giovedì","Venerdì","Sabato"]},da:{months:["January","Februar","Marts","April","Maj","Juni","July","August","September","Oktober","November","December"],dayOfWeekShort:["Søn","Man","Tir","Ons","Tor","Fre","Lør"],dayOfWeek:["søndag","mandag","tirsdag","onsdag","torsdag","fredag","lørdag"]},no:{months:["Januar","Februar","Mars","April","Mai","Juni","Juli","August","September","Oktober","November","Desember"],dayOfWeekShort:["Søn","Man","Tir","Ons","Tor","Fre","Lør"],dayOfWeek:["Søndag","Mandag","Tirsdag","Onsdag","Torsdag","Fredag","Lørdag"]},ja:{months:["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],dayOfWeekShort:["日","月","火","水","木","金","土"],dayOfWeek:["日曜","月曜","火曜","水曜","木曜","金曜","土曜"]},vi:{months:["Tháng 1","Tháng 2","Tháng 3","Tháng 4","Tháng 5","Tháng 6","Tháng 7","Tháng 8","Tháng 9","Tháng 10","Tháng 11","Tháng 12"],dayOfWeekShort:["CN","T2","T3","T4","T5","T6","T7"],dayOfWeek:["Chủ nhật","Thứ hai","Thứ ba","Thứ tư","Thứ năm","Thứ sáu","Thứ bảy"]},sl:{months:["Januar","Februar","Marec","April","Maj","Junij","Julij","Avgust","September","Oktober","November","December"],dayOfWeekShort:["Ned","Pon","Tor","Sre","Čet","Pet","Sob"],dayOfWeek:["Nedelja","Ponedeljek","Torek","Sreda","Četrtek","Petek","Sobota"]},cs:{months:["Leden","Únor","Březen","Duben","Květen","Červen","Červenec","Srpen","Září","Říjen","Listopad","Prosinec"],dayOfWeekShort:["Ne","Po","Út","St","Čt","Pá","So"]},hu:{months:["Január","Február","Március","Április","Május","Június","Július","Augusztus","Szeptember","Október","November","December"],dayOfWeekShort:["Va","Hé","Ke","Sze","Cs","Pé","Szo"],dayOfWeek:["vasárnap","hétfő","kedd","szerda","csütörtök","péntek","szombat"]},az:{months:["Yanvar","Fevral","Mart","Aprel","May","Iyun","Iyul","Avqust","Sentyabr","Oktyabr","Noyabr","Dekabr"],dayOfWeekShort:["B","Be","Ça","Ç","Ca","C","Ş"],dayOfWeek:["Bazar","Bazar ertəsi","Çərşənbə axşamı","Çərşənbə","Cümə axşamı","Cümə","Şənbə"]},bs:{months:["Januar","Februar","Mart","April","Maj","Jun","Jul","Avgust","Septembar","Oktobar","Novembar","Decembar"],dayOfWeekShort:["Ned","Pon","Uto","Sri","Čet","Pet","Sub"],dayOfWeek:["Nedjelja","Ponedjeljak","Utorak","Srijeda","Četvrtak","Petak","Subota"]},ca:{months:["Gener","Febrer","Març","Abril","Maig","Juny","Juliol","Agost","Setembre","Octubre","Novembre","Desembre"],dayOfWeekShort:["Dg","Dl","Dt","Dc","Dj","Dv","Ds"],dayOfWeek:["Diumenge","Dilluns","Dimarts","Dimecres","Dijous","Divendres","Dissabte"]},"en-GB":{months:["January","February","March","April","May","June","July","August","September","October","November","December"],dayOfWeekShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],dayOfWeek:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},et:{months:["Jaanuar","Veebruar","Märts","Aprill","Mai","Juuni","Juuli","August","September","Oktoober","November","Detsember"],dayOfWeekShort:["P","E","T","K","N","R","L"],dayOfWeek:["Pühapäev","Esmaspäev","Teisipäev","Kolmapäev","Neljapäev","Reede","Laupäev"]},eu:{months:["Urtarrila","Otsaila","Martxoa","Apirila","Maiatza","Ekaina","Uztaila","Abuztua","Iraila","Urria","Azaroa","Abendua"],dayOfWeekShort:["Ig.","Al.","Ar.","Az.","Og.","Or.","La."],dayOfWeek:["Igandea","Astelehena","Asteartea","Asteazkena","Osteguna","Ostirala","Larunbata"]},fi:{months:["Tammikuu","Helmikuu","Maaliskuu","Huhtikuu","Toukokuu","Kesäkuu","Heinäkuu","Elokuu","Syyskuu","Lokakuu","Marraskuu","Joulukuu"],dayOfWeekShort:["Su","Ma","Ti","Ke","To","Pe","La"],dayOfWeek:["sunnuntai","maanantai","tiistai","keskiviikko","torstai","perjantai","lauantai"]},gl:{months:["Xan","Feb","Maz","Abr","Mai","Xun","Xul","Ago","Set","Out","Nov","Dec"],dayOfWeekShort:["Dom","Lun","Mar","Mer","Xov","Ven","Sab"],dayOfWeek:["Domingo","Luns","Martes","Mércores","Xoves","Venres","Sábado"]},hr:{months:["Siječanj","Veljača","Ožujak","Travanj","Svibanj","Lipanj","Srpanj","Kolovoz","Rujan","Listopad","Studeni","Prosinac"],dayOfWeekShort:["Ned","Pon","Uto","Sri","Čet","Pet","Sub"],dayOfWeek:["Nedjelja","Ponedjeljak","Utorak","Srijeda","Četvrtak","Petak","Subota"]},ko:{months:["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"],dayOfWeekShort:["일","월","화","수","목","금","토"],dayOfWeek:["일요일","월요일","화요일","수요일","목요일","금요일","토요일"]},lt:{months:["Sausio","Vasario","Kovo","Balandžio","Gegužės","Birželio","Liepos","Rugpjūčio","Rugsėjo","Spalio","Lapkričio","Gruodžio"],dayOfWeekShort:["Sek","Pir","Ant","Tre","Ket","Pen","Šeš"],dayOfWeek:["Sekmadienis","Pirmadienis","Antradienis","Trečiadienis","Ketvirtadienis","Penktadienis","Šeštadienis"]},lv:{months:["Janvāris","Februāris","Marts","Aprīlis ","Maijs","Jūnijs","Jūlijs","Augusts","Septembris","Oktobris","Novembris","Decembris"],dayOfWeekShort:["Sv","Pr","Ot","Tr","Ct","Pk","St"],dayOfWeek:["Svētdiena","Pirmdiena","Otrdiena","Trešdiena","Ceturtdiena","Piektdiena","Sestdiena"]},mk:{months:["јануари","февруари","март","април","мај","јуни","јули","август","септември","октомври","ноември","декември"],dayOfWeekShort:["нед","пон","вто","сре","чет","пет","саб"],dayOfWeek:["Недела","Понеделник","Вторник","Среда","Четврток","Петок","Сабота"]},mn:{months:["1-р сар","2-р сар","3-р сар","4-р сар","5-р сар","6-р сар","7-р сар","8-р сар","9-р сар","10-р сар","11-р сар","12-р сар"],dayOfWeekShort:["Дав","Мяг","Лха","Пүр","Бсн","Бям","Ням"],dayOfWeek:["Даваа","Мягмар","Лхагва","Пүрэв","Баасан","Бямба","Ням"]},"pt-BR":{months:["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],dayOfWeekShort:["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"],dayOfWeek:["Domingo","Segunda","Terça","Quarta","Quinta","Sexta","Sábado"]},sk:{months:["Január","Február","Marec","Apríl","Máj","Jún","Júl","August","September","Október","November","December"],dayOfWeekShort:["Ne","Po","Ut","St","Št","Pi","So"],dayOfWeek:["Nedeľa","Pondelok","Utorok","Streda","Štvrtok","Piatok","Sobota"]},sq:{months:["Janar","Shkurt","Mars","Prill","Maj","Qershor","Korrik","Gusht","Shtator","Tetor","Nëntor","Dhjetor"],dayOfWeekShort:["Die","Hën","Mar","Mër","Enj","Pre","Shtu"],dayOfWeek:["E Diel","E Hënë","E Martē","E Mërkurë","E Enjte","E Premte","E Shtunë"]},"sr-YU":{months:["Januar","Februar","Mart","April","Maj","Jun","Jul","Avgust","Septembar","Oktobar","Novembar","Decembar"],dayOfWeekShort:["Ned","Pon","Uto","Sre","čet","Pet","Sub"],dayOfWeek:["Nedelja","Ponedeljak","Utorak","Sreda","Četvrtak","Petak","Subota"]},sr:{months:["јануар","фебруар","март","април","мај","јун","јул","август","септембар","октобар","новембар","децембар"],dayOfWeekShort:["нед","пон","уто","сре","чет","пет","суб"],dayOfWeek:["Недеља","Понедељак","Уторак","Среда","Четвртак","Петак","Субота"]},sv:{months:["Januari","Februari","Mars","April","Maj","Juni","Juli","Augusti","September","Oktober","November","December"],dayOfWeekShort:["Sön","Mån","Tis","Ons","Tor","Fre","Lör"],dayOfWeek:["Söndag","Måndag","Tisdag","Onsdag","Torsdag","Fredag","Lördag"]},"zh-TW":{months:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],dayOfWeekShort:["日","一","二","三","四","五","六"],dayOfWeek:["星期日","星期一","星期二","星期三","星期四","星期五","星期六"]},zh:{months:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],dayOfWeekShort:["日","一","二","三","四","五","六"],dayOfWeek:["星期日","星期一","星期二","星期三","星期四","星期五","星期六"]},he:{months:["ינואר","פברואר","מרץ","אפריל","מאי","יוני","יולי","אוגוסט","ספטמבר","אוקטובר","נובמבר","דצמבר"],dayOfWeekShort:["א'","ב'","ג'","ד'","ה'","ו'","שבת"],dayOfWeek:["ראשון","שני","שלישי","רביעי","חמישי","שישי","שבת","ראשון"]},hy:{months:["Հունվար","Փետրվար","Մարտ","Ապրիլ","Մայիս","Հունիս","Հուլիս","Օգոստոս","Սեպտեմբեր","Հոկտեմբեր","Նոյեմբեր","Դեկտեմբեր"],dayOfWeekShort:["Կի","Երկ","Երք","Չոր","Հնգ","Ուրբ","Շբթ"],dayOfWeek:["Կիրակի","Երկուշաբթի","Երեքշաբթի","Չորեքշաբթի","Հինգշաբթի","Ուրբաթ","Շաբաթ"]},kg:{months:["Үчтүн айы","Бирдин айы","Жалган Куран","Чын Куран","Бугу","Кулжа","Теке","Баш Оона","Аяк Оона","Тогуздун айы","Жетинин айы","Бештин айы"],dayOfWeekShort:["Жек","Дүй","Шей","Шар","Бей","Жум","Ише"],dayOfWeek:["Жекшемб","Дүйшөмб","Шейшемб","Шаршемб","Бейшемби","Жума","Ишенб"]},rm:{months:["Schaner","Favrer","Mars","Avrigl","Matg","Zercladur","Fanadur","Avust","Settember","October","November","December"],dayOfWeekShort:["Du","Gli","Ma","Me","Gie","Ve","So"],dayOfWeek:["Dumengia","Glindesdi","Mardi","Mesemna","Gievgia","Venderdi","Sonda"]},ka:{months:["იანვარი","თებერვალი","მარტი","აპრილი","მაისი","ივნისი","ივლისი","აგვისტო","სექტემბერი","ოქტომბერი","ნოემბერი","დეკემბერი"],dayOfWeekShort:["კვ","ორშ","სამშ","ოთხ","ხუთ","პარ","შაბ"],dayOfWeek:["კვირა","ორშაბათი","სამშაბათი","ოთხშაბათი","ხუთშაბათი","პარასკევი","შაბათი"]}},value:"",rtl:!1,format:"Y/m/d H:i",formatTime:"H:i",formatDate:"Y/m/d",startDate:!1,step:60,monthChangeSpinner:!0,closeOnDateSelect:!1,closeOnTimeSelect:!0,closeOnWithoutClick:!0,closeOnInputClick:!0,timepicker:!0,datepicker:!0,weeks:!1,defaultTime:!1,defaultDate:!1,minDate:!1,maxDate:!1,minTime:!1,maxTime:!1,disabledMinTime:!1,disabledMaxTime:!1,allowTimes:[],opened:!1,initTime:!0,inline:!1,theme:"",onSelectDate:function(){},onSelectTime:function(){},onChangeMonth:function(){},onGetWeekOfYear:function(){},onChangeYear:function(){},onChangeDateTime:function(){},onShow:function(){},onClose:function(){},onGenerate:function(){},withoutCopyright:!0,inverseButton:!1,hours12:!1,next:"xdsoft_next",prev:"xdsoft_prev",dayOfWeekStart:0,parentID:"body",timeHeightInTimePicker:25,timepickerScrollbar:!0,todayButton:!0,prevButton:!0,nextButton:!0,defaultSelect:!0,scrollMonth:!0,scrollTime:!0,scrollInput:!0,lazyInit:!1,mask:!1,validateOnBlur:!0,allowBlank:!0,yearStart:1950,yearEnd:2050,monthStart:0,monthEnd:11,style:"",id:"",fixed:!1,roundTime:"round",className:"",weekends:[],highlightedDates:[],highlightedPeriods:[],allowDates:[],allowDateRe:null,disabledDates:[],disabledWeekDays:[],yearOffset:0,beforeShowDay:null,enterLikeTab:!0,showApplyButton:!1},r=null,n="en",o="en",i={meridiem:["AM","PM"]},s=function(){var t=a.i18n[o],n={days:t.dayOfWeek,daysShort:t.dayOfWeekShort,months:t.months,monthsShort:e.map(t.months,function(e){return e.substring(0,3)})};r=new DateFormatter({dateSettings:e.extend({},i,n)})};e.datetimepicker={setLocale:function(e){var t=a.i18n[e]?e:n;o!=t&&(o=t,s())},setDateFormatter:function(e){r=e},RFC_2822:"D, d M Y H:i:s O",ATOM:"Y-m-dTH:i:sP",ISO_8601:"Y-m-dTH:i:sO",RFC_822:"D, d M y H:i:s O",RFC_850:"l, d-M-y H:i:s T",RFC_1036:"D, d M y H:i:s O",RFC_1123:"D, d M Y H:i:s O",RSS:"D, d M Y H:i:s O",W3C:"Y-m-dTH:i:sP"},s(),window.getComputedStyle||(window.getComputedStyle=function(e){return this.el=e,this.getPropertyValue=function(t){var a=/(\-([a-z]){1})/g;return"float"===t&&(t="styleFloat"),a.test(t)&&(t=t.replace(a,function(e,t,a){return a.toUpperCase()})),e.currentStyle[t]||null},this}),Array.prototype.indexOf||(Array.prototype.indexOf=function(e,t){var a,r;for(a=t||0,r=this.length;r>a;a+=1)if(this[a]===e)return a;return-1}),Date.prototype.countDaysInMonth=function(){return new Date(this.getFullYear(),this.getMonth()+1,0).getDate()},e.fn.xdsoftScroller=function(t){return this.each(function(){var a,r,n,o,i,s=e(this),d=function(e){var t,a={x:0,y:0};return"touchstart"===e.type||"touchmove"===e.type||"touchend"===e.type||"touchcancel"===e.type?(t=e.originalEvent.touches[0]||e.originalEvent.changedTouches[0],a.x=t.clientX,a.y=t.clientY):("mousedown"===e.type||"mouseup"===e.type||"mousemove"===e.type||"mouseover"===e.type||"mouseout"===e.type||"mouseenter"===e.type||"mouseleave"===e.type)&&(a.x=e.clientX,a.y=e.clientY),a},u=100,l=!1,f=0,c=0,m=0,h=!1,g=0,p=function(){};return"hide"===t?void s.find(".xdsoft_scrollbar").hide():(e(this).hasClass("xdsoft_scroller_box")||(a=s.children().eq(0),r=s[0].clientHeight,n=a[0].offsetHeight,o=e('<div class="xdsoft_scrollbar"></div>'),i=e('<div class="xdsoft_scroller"></div>'),o.append(i),s.addClass("xdsoft_scroller_box").append(o),p=function(e){var t=d(e).y-f+g;0>t&&(t=0),t+i[0].offsetHeight>m&&(t=m-i[0].offsetHeight),s.trigger("scroll_element.xdsoft_scroller",[u?t/u:0])},i.on("touchstart.xdsoft_scroller mousedown.xdsoft_scroller",function(a){r||s.trigger("resize_scroll.xdsoft_scroller",[t]),f=d(a).y,g=parseInt(i.css("margin-top"),10),m=o[0].offsetHeight,"mousedown"===a.type||"touchstart"===a.type?(document&&e(document.body).addClass("xdsoft_noselect"),e([document.body,window]).on("touchend mouseup.xdsoft_scroller",function n(){e([document.body,window]).off("touchend mouseup.xdsoft_scroller",n).off("mousemove.xdsoft_scroller",p).removeClass("xdsoft_noselect")}),e(document.body).on("mousemove.xdsoft_scroller",p)):(h=!0,a.stopPropagation(),a.preventDefault())}).on("touchmove",function(e){h&&(e.preventDefault(),p(e))}).on("touchend touchcancel",function(){h=!1,g=0}),s.on("scroll_element.xdsoft_scroller",function(e,t){r||s.trigger("resize_scroll.xdsoft_scroller",[t,!0]),t=t>1?1:0>t||isNaN(t)?0:t,i.css("margin-top",u*t),setTimeout(function(){a.css("marginTop",-parseInt((a[0].offsetHeight-r)*t,10))},10)}).on("resize_scroll.xdsoft_scroller",function(e,t,d){var l,f;r=s[0].clientHeight,n=a[0].offsetHeight,l=r/n,f=l*o[0].offsetHeight,l>1?i.hide():(i.show(),i.css("height",parseInt(f>10?f:10,10)),u=o[0].offsetHeight-i[0].offsetHeight,d!==!0&&s.trigger("scroll_element.xdsoft_scroller",[t||Math.abs(parseInt(a.css("marginTop"),10))/(n-r)]))}),s.on("mousewheel",function(e){var t=Math.abs(parseInt(a.css("marginTop"),10));return t-=20*e.deltaY,0>t&&(t=0),s.trigger("scroll_element.xdsoft_scroller",[t/(n-r)]),e.stopPropagation(),!1}),s.on("touchstart",function(e){l=d(e),c=Math.abs(parseInt(a.css("marginTop"),10))}),s.on("touchmove",function(e){if(l){e.preventDefault();var t=d(e);s.trigger("scroll_element.xdsoft_scroller",[(c-(t.y-l.y))/(n-r)])}}),s.on("touchend touchcancel",function(){l=!1,c=0})),void s.trigger("resize_scroll.xdsoft_scroller",[t]))})},e.fn.datetimepicker=function(n,i){var s,d,u=this,l=48,f=57,c=96,m=105,h=17,g=46,p=13,y=27,v=8,b=37,D=38,k=39,x=40,T=9,S=116,w=65,O=67,M=86,_=90,W=89,F=!1,C=e.isPlainObject(n)||!n?e.extend(!0,{},a,n):e.extend(!0,{},a),P=0,A=function(e){e.on("open.xdsoft focusin.xdsoft mousedown.xdsoft touchstart",function t(){e.is(":disabled")||e.data("xdsoft_datetimepicker")||(clearTimeout(P),P=setTimeout(function(){e.data("xdsoft_datetimepicker")||s(e),e.off("open.xdsoft focusin.xdsoft mousedown.xdsoft touchstart",t).trigger("open.xdsoft")},100))})};return s=function(a){function i(){var e,t=!1;return C.startDate?t=j.strToDate(C.startDate):(t=C.value||(a&&a.val&&a.val()?a.val():""),t?t=j.strToDateTime(t):C.defaultDate&&(t=j.strToDateTime(C.defaultDate),C.defaultTime&&(e=j.strtotime(C.defaultTime),t.setHours(e.getHours()),t.setMinutes(e.getMinutes())))),t&&j.isValidDate(t)?J.data("changed",!0):t="",t||0}function s(t){var r=function(e,t){var a=e.replace(/([\[\]\/\{\}\(\)\-\.\+]{1})/g,"\\$1").replace(/_/g,"{digit+}").replace(/([0-9]{1})/g,"{digit$1}").replace(/\{digit([0-9]{1})\}/g,"[0-$1_]{1}").replace(/\{digit[\+]\}/g,"[0-9_]{1}");return new RegExp(a).test(t)},n=function(e){try{if(document.selection&&document.selection.createRange){var t=document.selection.createRange();return t.getBookmark().charCodeAt(2)-2}if(e.setSelectionRange)return e.selectionStart}catch(a){return 0}},o=function(e,t){if(e="string"==typeof e||e instanceof String?document.getElementById(e):e,!e)return!1;if(e.createTextRange){var a=e.createTextRange();return a.collapse(!0),a.moveEnd("character",t),a.moveStart("character",t),a.select(),!0}return e.setSelectionRange?(e.setSelectionRange(t,t),!0):!1};t.mask&&a.off("keydown.xdsoft"),t.mask===!0&&(t.mask="undefined"!=typeof moment?t.format.replace(/Y{4}/g,"9999").replace(/Y{2}/g,"99").replace(/M{2}/g,"19").replace(/D{2}/g,"39").replace(/H{2}/g,"29").replace(/m{2}/g,"59").replace(/s{2}/g,"59"):t.format.replace(/Y/g,"9999").replace(/F/g,"9999").replace(/m/g,"19").replace(/d/g,"39").replace(/H/g,"29").replace(/i/g,"59").replace(/s/g,"59")),"string"===e.type(t.mask)&&(r(t.mask,a.val())||(a.val(t.mask.replace(/[0-9]/g,"_")),o(a[0],0)),a.on("keydown.xdsoft",function(i){var s,d,u=this.value,C=i.which;if(C>=l&&f>=C||C>=c&&m>=C||C===v||C===g){for(s=n(this),d=C!==v&&C!==g?String.fromCharCode(C>=c&&m>=C?C-l:C):"_",C!==v&&C!==g||!s||(s-=1,d="_");/[^0-9_]/.test(t.mask.substr(s,1))&&s<t.mask.length&&s>0;)s+=C===v||C===g?-1:1;if(u=u.substr(0,s)+d+u.substr(s+1),""===e.trim(u))u=t.mask.replace(/[0-9]/g,"_");else if(s===t.mask.length)return i.preventDefault(),!1;for(s+=C===v||C===g?0:1;/[^0-9_]/.test(t.mask.substr(s,1))&&s<t.mask.length&&s>0;)s+=C===v||C===g?-1:1;r(t.mask,u)?(this.value=u,o(this,s)):""===e.trim(u)?this.value=t.mask.replace(/[0-9]/g,"_"):a.trigger("error_input.xdsoft")}else if(-1!==[w,O,M,_,W].indexOf(C)&&F||-1!==[y,D,x,b,k,S,h,T,p].indexOf(C))return!0;return i.preventDefault(),!1}))}var d,u,P,A,Y,j,H,J=e('<div class="xdsoft_datetimepicker xdsoft_noselect"></div>'),z=e('<div class="xdsoft_copyright"><a target="_blank" href="http://xdsoft.net/jqplugins/datetimepicker/">xdsoft.net</a></div>'),I=e('<div class="xdsoft_datepicker active"></div>'),N=e('<div class="xdsoft_mounthpicker"><button type="button" class="xdsoft_prev"></button><button type="button" class="xdsoft_today_button"></button><div class="xdsoft_label xdsoft_month"><span></span><i></i></div><div class="xdsoft_label xdsoft_year"><span></span><i></i></div><button type="button" class="xdsoft_next"></button></div>'),L=e('<div class="xdsoft_calendar"></div>'),E=e('<div class="xdsoft_timepicker active"><button type="button" class="xdsoft_prev"></button><div class="xdsoft_time_box"></div><button type="button" class="xdsoft_next"></button></div>'),R=E.find(".xdsoft_time_box").eq(0),B=e('<div class="xdsoft_time_variant"></div>'),V=e('<button type="button" class="xdsoft_save_selected blue-gradient-button">Save Selected</button>'),G=e('<div class="xdsoft_select xdsoft_monthselect"><div></div></div>'),U=e('<div class="xdsoft_select xdsoft_yearselect"><div></div></div>'),q=!1,X=0;C.id&&J.attr("id",C.id),C.style&&J.attr("style",C.style),C.weeks&&J.addClass("xdsoft_showweeks"),C.rtl&&J.addClass("xdsoft_rtl"),J.addClass("xdsoft_"+C.theme),J.addClass(C.className),N.find(".xdsoft_month span").after(G),N.find(".xdsoft_year span").after(U),N.find(".xdsoft_month,.xdsoft_year").on("touchstart mousedown.xdsoft",function(t){var a,r,n=e(this).find(".xdsoft_select").eq(0),o=0,i=0,s=n.is(":visible");for(N.find(".xdsoft_select").hide(),j.currentTime&&(o=j.currentTime[e(this).hasClass("xdsoft_month")?"getMonth":"getFullYear"]()),n[s?"hide":"show"](),a=n.find("div.xdsoft_option"),r=0;r<a.length&&a.eq(r).data("value")!==o;r+=1)i+=a[0].offsetHeight;return n.xdsoftScroller(i/(n.children()[0].offsetHeight-n[0].clientHeight)),t.stopPropagation(),!1}),N.find(".xdsoft_select").xdsoftScroller().on("touchstart mousedown.xdsoft",function(e){e.stopPropagation(),e.preventDefault()}).on("touchstart mousedown.xdsoft",".xdsoft_option",function(){(void 0===j.currentTime||null===j.currentTime)&&(j.currentTime=j.now());var t=j.currentTime.getFullYear();j&&j.currentTime&&j.currentTime[e(this).parent().parent().hasClass("xdsoft_monthselect")?"setMonth":"setFullYear"](e(this).data("value")),e(this).parent().parent().hide(),J.trigger("xchange.xdsoft"),C.onChangeMonth&&e.isFunction(C.onChangeMonth)&&C.onChangeMonth.call(J,j.currentTime,J.data("input")),t!==j.currentTime.getFullYear()&&e.isFunction(C.onChangeYear)&&C.onChangeYear.call(J,j.currentTime,J.data("input"))}),J.getValue=function(){return j.getCurrentTime()},J.setOptions=function(n){var o={};C=e.extend(!0,{},C,n),n.allowTimes&&e.isArray(n.allowTimes)&&n.allowTimes.length&&(C.allowTimes=e.extend(!0,[],n.allowTimes)),n.weekends&&e.isArray(n.weekends)&&n.weekends.length&&(C.weekends=e.extend(!0,[],n.weekends)),n.allowDates&&e.isArray(n.allowDates)&&n.allowDates.length&&(C.allowDates=e.extend(!0,[],n.allowDates)),n.allowDateRe&&"[object String]"===Object.prototype.toString.call(n.allowDateRe)&&(C.allowDateRe=new RegExp(n.allowDateRe)),n.highlightedDates&&e.isArray(n.highlightedDates)&&n.highlightedDates.length&&(e.each(n.highlightedDates,function(a,n){var i,s=e.map(n.split(","),e.trim),d=new t(r.parseDate(s[0],C.formatDate),s[1],s[2]),u=r.formatDate(d.date,C.formatDate);void 0!==o[u]?(i=o[u].desc,i&&i.length&&d.desc&&d.desc.length&&(o[u].desc=i+"\n"+d.desc)):o[u]=d}),C.highlightedDates=e.extend(!0,[],o)),n.highlightedPeriods&&e.isArray(n.highlightedPeriods)&&n.highlightedPeriods.length&&(o=e.extend(!0,[],C.highlightedDates),
e.each(n.highlightedPeriods,function(a,n){var i,s,d,u,l,f,c;if(e.isArray(n))i=n[0],s=n[1],d=n[2],c=n[3];else{var m=e.map(n.split(","),e.trim);i=r.parseDate(m[0],C.formatDate),s=r.parseDate(m[1],C.formatDate),d=m[2],c=m[3]}for(;s>=i;)u=new t(i,d,c),l=r.formatDate(i,C.formatDate),i.setDate(i.getDate()+1),void 0!==o[l]?(f=o[l].desc,f&&f.length&&u.desc&&u.desc.length&&(o[l].desc=f+"\n"+u.desc)):o[l]=u}),C.highlightedDates=e.extend(!0,[],o)),n.disabledDates&&e.isArray(n.disabledDates)&&n.disabledDates.length&&(C.disabledDates=e.extend(!0,[],n.disabledDates)),n.disabledWeekDays&&e.isArray(n.disabledWeekDays)&&n.disabledWeekDays.length&&(C.disabledWeekDays=e.extend(!0,[],n.disabledWeekDays)),!C.open&&!C.opened||C.inline||a.trigger("open.xdsoft"),C.inline&&(q=!0,J.addClass("xdsoft_inline"),a.after(J).hide()),C.inverseButton&&(C.next="xdsoft_prev",C.prev="xdsoft_next"),C.datepicker?I.addClass("active"):I.removeClass("active"),C.timepicker?E.addClass("active"):E.removeClass("active"),C.value&&(j.setCurrentTime(C.value),a&&a.val&&a.val(j.str)),C.dayOfWeekStart=isNaN(C.dayOfWeekStart)?0:parseInt(C.dayOfWeekStart,10)%7,C.timepickerScrollbar||R.xdsoftScroller("hide"),C.minDate&&/^[\+\-](.*)$/.test(C.minDate)&&(C.minDate=r.formatDate(j.strToDateTime(C.minDate),C.formatDate)),C.maxDate&&/^[\+\-](.*)$/.test(C.maxDate)&&(C.maxDate=r.formatDate(j.strToDateTime(C.maxDate),C.formatDate)),V.toggle(C.showApplyButton),N.find(".xdsoft_today_button").css("visibility",C.todayButton?"visible":"hidden"),N.find("."+C.prev).css("visibility",C.prevButton?"visible":"hidden"),N.find("."+C.next).css("visibility",C.nextButton?"visible":"hidden"),s(C),C.validateOnBlur&&a.off("blur.xdsoft").on("blur.xdsoft",function(){if(C.allowBlank&&(!e.trim(e(this).val()).length||"string"==typeof C.mask&&e.trim(e(this).val())===C.mask.replace(/[0-9]/g,"_")))e(this).val(null),J.data("xdsoft_datetime").empty();else{var t=r.parseDate(e(this).val(),C.format);if(t)e(this).val(r.formatDate(t,C.format));else{var a=+[e(this).val()[0],e(this).val()[1]].join(""),n=+[e(this).val()[2],e(this).val()[3]].join("");e(this).val(!C.datepicker&&C.timepicker&&a>=0&&24>a&&n>=0&&60>n?[a,n].map(function(e){return e>9?e:"0"+e}).join(":"):r.formatDate(j.now(),C.format))}J.data("xdsoft_datetime").setCurrentTime(e(this).val())}J.trigger("changedatetime.xdsoft"),J.trigger("close.xdsoft")}),C.dayOfWeekStartPrev=0===C.dayOfWeekStart?6:C.dayOfWeekStart-1,J.trigger("xchange.xdsoft").trigger("afterOpen.xdsoft")},J.data("options",C).on("touchstart mousedown.xdsoft",function(e){return e.stopPropagation(),e.preventDefault(),U.hide(),G.hide(),!1}),R.append(B),R.xdsoftScroller(),J.on("afterOpen.xdsoft",function(){R.xdsoftScroller()}),J.append(I).append(E),C.withoutCopyright!==!0&&J.append(z),I.append(N).append(L).append(V),e(C.parentID).append(J),d=function(){var t=this;t.now=function(e){var a,r,n=new Date;return!e&&C.defaultDate&&(a=t.strToDateTime(C.defaultDate),n.setFullYear(a.getFullYear()),n.setMonth(a.getMonth()),n.setDate(a.getDate())),C.yearOffset&&n.setFullYear(n.getFullYear()+C.yearOffset),!e&&C.defaultTime&&(r=t.strtotime(C.defaultTime),n.setHours(r.getHours()),n.setMinutes(r.getMinutes())),n},t.isValidDate=function(e){return"[object Date]"!==Object.prototype.toString.call(e)?!1:!isNaN(e.getTime())},t.setCurrentTime=function(e,a){t.currentTime="string"==typeof e?t.strToDateTime(e):t.isValidDate(e)?e:e||a||!C.allowBlank?t.now():null,J.trigger("xchange.xdsoft")},t.empty=function(){t.currentTime=null},t.getCurrentTime=function(){return t.currentTime},t.nextMonth=function(){(void 0===t.currentTime||null===t.currentTime)&&(t.currentTime=t.now());var a,r=t.currentTime.getMonth()+1;return 12===r&&(t.currentTime.setFullYear(t.currentTime.getFullYear()+1),r=0),a=t.currentTime.getFullYear(),t.currentTime.setDate(Math.min(new Date(t.currentTime.getFullYear(),r+1,0).getDate(),t.currentTime.getDate())),t.currentTime.setMonth(r),C.onChangeMonth&&e.isFunction(C.onChangeMonth)&&C.onChangeMonth.call(J,j.currentTime,J.data("input")),a!==t.currentTime.getFullYear()&&e.isFunction(C.onChangeYear)&&C.onChangeYear.call(J,j.currentTime,J.data("input")),J.trigger("xchange.xdsoft"),r},t.prevMonth=function(){(void 0===t.currentTime||null===t.currentTime)&&(t.currentTime=t.now());var a=t.currentTime.getMonth()-1;return-1===a&&(t.currentTime.setFullYear(t.currentTime.getFullYear()-1),a=11),t.currentTime.setDate(Math.min(new Date(t.currentTime.getFullYear(),a+1,0).getDate(),t.currentTime.getDate())),t.currentTime.setMonth(a),C.onChangeMonth&&e.isFunction(C.onChangeMonth)&&C.onChangeMonth.call(J,j.currentTime,J.data("input")),J.trigger("xchange.xdsoft"),a},t.getWeekOfYear=function(t){if(C.onGetWeekOfYear&&e.isFunction(C.onGetWeekOfYear)){var a=C.onGetWeekOfYear.call(J,t);if("undefined"!=typeof a)return a}var r=new Date(t.getFullYear(),0,1);return 4!=r.getDay()&&r.setMonth(0,1+(4-r.getDay()+7)%7),Math.ceil(((t-r)/864e5+r.getDay()+1)/7)},t.strToDateTime=function(e){var a,n,o=[];return e&&e instanceof Date&&t.isValidDate(e)?e:(o=/^(\+|\-)(.*)$/.exec(e),o&&(o[2]=r.parseDate(o[2],C.formatDate)),o&&o[2]?(a=o[2].getTime()-6e4*o[2].getTimezoneOffset(),n=new Date(t.now(!0).getTime()+parseInt(o[1]+"1",10)*a)):n=e?r.parseDate(e,C.format):t.now(),t.isValidDate(n)||(n=t.now()),n)},t.strToDate=function(e){if(e&&e instanceof Date&&t.isValidDate(e))return e;var a=e?r.parseDate(e,C.formatDate):t.now(!0);return t.isValidDate(a)||(a=t.now(!0)),a},t.strtotime=function(e){if(e&&e instanceof Date&&t.isValidDate(e))return e;var a=e?r.parseDate(e,C.formatTime):t.now(!0);return t.isValidDate(a)||(a=t.now(!0)),a},t.str=function(){return r.formatDate(t.currentTime,C.format)},t.currentTime=this.now()},j=new d,V.on("touchend click",function(e){e.preventDefault(),J.data("changed",!0),j.setCurrentTime(i()),a.val(j.str()),J.trigger("close.xdsoft")}),N.find(".xdsoft_today_button").on("touchend mousedown.xdsoft",function(){J.data("changed",!0),j.setCurrentTime(0,!0),J.trigger("afterOpen.xdsoft")}).on("dblclick.xdsoft",function(){var e,t,r=j.getCurrentTime();r=new Date(r.getFullYear(),r.getMonth(),r.getDate()),e=j.strToDate(C.minDate),e=new Date(e.getFullYear(),e.getMonth(),e.getDate()),e>r||(t=j.strToDate(C.maxDate),t=new Date(t.getFullYear(),t.getMonth(),t.getDate()),r>t||(a.val(j.str()),a.trigger("change"),J.trigger("close.xdsoft")))}),N.find(".xdsoft_prev,.xdsoft_next").on("touchend mousedown.xdsoft",function(){var t=e(this),a=0,r=!1;!function n(e){t.hasClass(C.next)?j.nextMonth():t.hasClass(C.prev)&&j.prevMonth(),C.monthChangeSpinner&&(r||(a=setTimeout(n,e||100)))}(500),e([document.body,window]).on("touchend mouseup.xdsoft",function o(){clearTimeout(a),r=!0,e([document.body,window]).off("touchend mouseup.xdsoft",o)})}),E.find(".xdsoft_prev,.xdsoft_next").on("touchend mousedown.xdsoft",function(){var t=e(this),a=0,r=!1,n=110;!function o(e){var i=R[0].clientHeight,s=B[0].offsetHeight,d=Math.abs(parseInt(B.css("marginTop"),10));t.hasClass(C.next)&&s-i-C.timeHeightInTimePicker>=d?B.css("marginTop","-"+(d+C.timeHeightInTimePicker)+"px"):t.hasClass(C.prev)&&d-C.timeHeightInTimePicker>=0&&B.css("marginTop","-"+(d-C.timeHeightInTimePicker)+"px"),R.trigger("scroll_element.xdsoft_scroller",[Math.abs(parseInt(B[0].style.marginTop,10)/(s-i))]),n=n>10?10:n-10,r||(a=setTimeout(o,e||n))}(500),e([document.body,window]).on("touchend mouseup.xdsoft",function i(){clearTimeout(a),r=!0,e([document.body,window]).off("touchend mouseup.xdsoft",i)})}),u=0,J.on("xchange.xdsoft",function(t){clearTimeout(u),u=setTimeout(function(){if(void 0===j.currentTime||null===j.currentTime){if(C.allowBlank)return;j.currentTime=j.now()}for(var t,i,s,d,u,l,f,c,m,h,g="",p=new Date(j.currentTime.getFullYear(),j.currentTime.getMonth(),1,12,0,0),y=0,v=j.now(),b=!1,D=!1,k=[],x=!0,T="",S="";p.getDay()!==C.dayOfWeekStart;)p.setDate(p.getDate()-1);for(g+="<table><thead><tr>",C.weeks&&(g+="<th></th>"),t=0;7>t;t+=1)g+="<th>"+C.i18n[o].dayOfWeekShort[(t+C.dayOfWeekStart)%7]+"</th>";for(g+="</tr></thead>",g+="<tbody>",C.maxDate!==!1&&(b=j.strToDate(C.maxDate),b=new Date(b.getFullYear(),b.getMonth(),b.getDate(),23,59,59,999)),C.minDate!==!1&&(D=j.strToDate(C.minDate),D=new Date(D.getFullYear(),D.getMonth(),D.getDate()));y<j.currentTime.countDaysInMonth()||p.getDay()!==C.dayOfWeekStart||j.currentTime.getMonth()===p.getMonth();)k=[],y+=1,s=p.getDay(),d=p.getDate(),u=p.getFullYear(),l=p.getMonth(),f=j.getWeekOfYear(p),h="",k.push("xdsoft_date"),c=C.beforeShowDay&&e.isFunction(C.beforeShowDay.call)?C.beforeShowDay.call(J,p):null,C.allowDateRe&&"[object RegExp]"===Object.prototype.toString.call(C.allowDateRe)?C.allowDateRe.test(r.formatDate(p,C.formatDate))||k.push("xdsoft_disabled"):C.allowDates&&C.allowDates.length>0?-1===C.allowDates.indexOf(r.formatDate(p,C.formatDate))&&k.push("xdsoft_disabled"):b!==!1&&p>b||D!==!1&&D>p||c&&c[0]===!1?k.push("xdsoft_disabled"):-1!==C.disabledDates.indexOf(r.formatDate(p,C.formatDate))?k.push("xdsoft_disabled"):-1!==C.disabledWeekDays.indexOf(s)?k.push("xdsoft_disabled"):a.is("[readonly]")&&k.push("xdsoft_disabled"),c&&""!==c[1]&&k.push(c[1]),j.currentTime.getMonth()!==l&&k.push("xdsoft_other_month"),(C.defaultSelect||J.data("changed"))&&r.formatDate(j.currentTime,C.formatDate)===r.formatDate(p,C.formatDate)&&k.push("xdsoft_current"),r.formatDate(v,C.formatDate)===r.formatDate(p,C.formatDate)&&k.push("xdsoft_today"),(0===p.getDay()||6===p.getDay()||-1!==C.weekends.indexOf(r.formatDate(p,C.formatDate)))&&k.push("xdsoft_weekend"),void 0!==C.highlightedDates[r.formatDate(p,C.formatDate)]&&(i=C.highlightedDates[r.formatDate(p,C.formatDate)],k.push(void 0===i.style?"xdsoft_highlighted_default":i.style),h=void 0===i.desc?"":i.desc),C.beforeShowDay&&e.isFunction(C.beforeShowDay)&&k.push(C.beforeShowDay(p)),x&&(g+="<tr>",x=!1,C.weeks&&(g+="<th>"+f+"</th>")),g+='<td data-date="'+d+'" data-month="'+l+'" data-year="'+u+'" class="xdsoft_date xdsoft_day_of_week'+p.getDay()+" "+k.join(" ")+'" title="'+h+'"><div>'+d+"</div></td>",p.getDay()===C.dayOfWeekStartPrev&&(g+="</tr>",x=!0),p.setDate(d+1);if(g+="</tbody></table>",L.html(g),N.find(".xdsoft_label span").eq(0).text(C.i18n[o].months[j.currentTime.getMonth()]),N.find(".xdsoft_label span").eq(1).text(j.currentTime.getFullYear()),T="",S="",l="",m=function(t,n){var o,i,s=j.now(),d=C.allowTimes&&e.isArray(C.allowTimes)&&C.allowTimes.length;s.setHours(t),t=parseInt(s.getHours(),10),s.setMinutes(n),n=parseInt(s.getMinutes(),10),o=new Date(j.currentTime),o.setHours(t),o.setMinutes(n),k=[],C.minDateTime!==!1&&C.minDateTime>o||C.maxTime!==!1&&j.strtotime(C.maxTime).getTime()<s.getTime()||C.minTime!==!1&&j.strtotime(C.minTime).getTime()>s.getTime()?k.push("xdsoft_disabled"):C.minDateTime!==!1&&C.minDateTime>o||C.disabledMinTime!==!1&&s.getTime()>j.strtotime(C.disabledMinTime).getTime()&&C.disabledMaxTime!==!1&&s.getTime()<j.strtotime(C.disabledMaxTime).getTime()?k.push("xdsoft_disabled"):a.is("[readonly]")&&k.push("xdsoft_disabled"),i=new Date(j.currentTime),i.setHours(parseInt(j.currentTime.getHours(),10)),d||i.setMinutes(Math[C.roundTime](j.currentTime.getMinutes()/C.step)*C.step),(C.initTime||C.defaultSelect||J.data("changed"))&&i.getHours()===parseInt(t,10)&&(!d&&C.step>59||i.getMinutes()===parseInt(n,10))&&(C.defaultSelect||J.data("changed")?k.push("xdsoft_current"):C.initTime&&k.push("xdsoft_init_time")),parseInt(v.getHours(),10)===parseInt(t,10)&&parseInt(v.getMinutes(),10)===parseInt(n,10)&&k.push("xdsoft_today"),T+='<div class="xdsoft_time '+k.join(" ")+'" data-hour="'+t+'" data-minute="'+n+'">'+r.formatDate(s,C.formatTime)+"</div>"},C.allowTimes&&e.isArray(C.allowTimes)&&C.allowTimes.length)for(y=0;y<C.allowTimes.length;y+=1)S=j.strtotime(C.allowTimes[y]).getHours(),l=j.strtotime(C.allowTimes[y]).getMinutes(),m(S,l);else for(y=0,t=0;y<(C.hours12?12:24);y+=1)for(t=0;60>t;t+=C.step)S=(10>y?"0":"")+y,l=(10>t?"0":"")+t,m(S,l);for(B.html(T),n="",y=0,y=parseInt(C.yearStart,10)+C.yearOffset;y<=parseInt(C.yearEnd,10)+C.yearOffset;y+=1)n+='<div class="xdsoft_option '+(j.currentTime.getFullYear()===y?"xdsoft_current":"")+'" data-value="'+y+'">'+y+"</div>";for(U.children().eq(0).html(n),y=parseInt(C.monthStart,10),n="";y<=parseInt(C.monthEnd,10);y+=1)n+='<div class="xdsoft_option '+(j.currentTime.getMonth()===y?"xdsoft_current":"")+'" data-value="'+y+'">'+C.i18n[o].months[y]+"</div>";G.children().eq(0).html(n),e(J).trigger("generate.xdsoft")},10),t.stopPropagation()}).on("afterOpen.xdsoft",function(){if(C.timepicker){var e,t,a,r;B.find(".xdsoft_current").length?e=".xdsoft_current":B.find(".xdsoft_init_time").length&&(e=".xdsoft_init_time"),e?(t=R[0].clientHeight,a=B[0].offsetHeight,r=B.find(e).index()*C.timeHeightInTimePicker+1,r>a-t&&(r=a-t),R.trigger("scroll_element.xdsoft_scroller",[parseInt(r,10)/(a-t)])):R.trigger("scroll_element.xdsoft_scroller",[0])}}),P=0,L.on("touchend click.xdsoft","td",function(t){t.stopPropagation(),P+=1;var r=e(this),n=j.currentTime;return(void 0===n||null===n)&&(j.currentTime=j.now(),n=j.currentTime),r.hasClass("xdsoft_disabled")?!1:(n.setDate(1),n.setFullYear(r.data("year")),n.setMonth(r.data("month")),n.setDate(r.data("date")),J.trigger("select.xdsoft",[n]),a.val(j.str()),C.onSelectDate&&e.isFunction(C.onSelectDate)&&C.onSelectDate.call(J,j.currentTime,J.data("input"),t),J.data("changed",!0),J.trigger("xchange.xdsoft"),J.trigger("changedatetime.xdsoft"),(P>1||C.closeOnDateSelect===!0||C.closeOnDateSelect===!1&&!C.timepicker)&&!C.inline&&J.trigger("close.xdsoft"),void setTimeout(function(){P=0},200))}),B.on("touchend click.xdsoft","div",function(t){t.stopPropagation();var a=e(this),r=j.currentTime;return(void 0===r||null===r)&&(j.currentTime=j.now(),r=j.currentTime),a.hasClass("xdsoft_disabled")?!1:(r.setHours(a.data("hour")),r.setMinutes(a.data("minute")),J.trigger("select.xdsoft",[r]),J.data("input").val(j.str()),C.onSelectTime&&e.isFunction(C.onSelectTime)&&C.onSelectTime.call(J,j.currentTime,J.data("input"),t),J.data("changed",!0),J.trigger("xchange.xdsoft"),J.trigger("changedatetime.xdsoft"),void(C.inline!==!0&&C.closeOnTimeSelect===!0&&J.trigger("close.xdsoft")))}),I.on("mousewheel.xdsoft",function(e){return C.scrollMonth?(e.deltaY<0?j.nextMonth():j.prevMonth(),!1):!0}),a.on("mousewheel.xdsoft",function(e){return C.scrollInput?!C.datepicker&&C.timepicker?(A=B.find(".xdsoft_current").length?B.find(".xdsoft_current").eq(0).index():0,A+e.deltaY>=0&&A+e.deltaY<B.children().length&&(A+=e.deltaY),B.children().eq(A).length&&B.children().eq(A).trigger("mousedown"),!1):C.datepicker&&!C.timepicker?(I.trigger(e,[e.deltaY,e.deltaX,e.deltaY]),a.val&&a.val(j.str()),J.trigger("changedatetime.xdsoft"),!1):void 0:!0}),J.on("changedatetime.xdsoft",function(t){if(C.onChangeDateTime&&e.isFunction(C.onChangeDateTime)){var a=J.data("input");C.onChangeDateTime.call(J,j.currentTime,a,t),delete C.value,a.trigger("change")}}).on("generate.xdsoft",function(){C.onGenerate&&e.isFunction(C.onGenerate)&&C.onGenerate.call(J,j.currentTime,J.data("input")),q&&(J.trigger("afterOpen.xdsoft"),q=!1)}).on("click.xdsoft",function(e){e.stopPropagation()}),A=0,H=function(e,t){do if(e=e.parentNode,t(e)===!1)break;while("HTML"!==e.nodeName)},Y=function(){var t,a,r,n,o,i,s,d,u,l,f,c,m;if(d=J.data("input"),t=d.offset(),a=d[0],l="top",r=t.top+a.offsetHeight-1,n=t.left,o="absolute",u=e(window).width(),c=e(window).height(),m=e(window).scrollTop(),document.documentElement.clientWidth-t.left<I.parent().outerWidth(!0)){var h=I.parent().outerWidth(!0)-a.offsetWidth;n-=h}"rtl"===d.parent().css("direction")&&(n-=J.outerWidth()-d.outerWidth()),C.fixed?(r-=m,n-=e(window).scrollLeft(),o="fixed"):(s=!1,H(a,function(e){return"fixed"===window.getComputedStyle(e).getPropertyValue("position")?(s=!0,!1):void 0}),s?(o="fixed",r+J.outerHeight()>c+m?(l="bottom",r=c+m-t.top):r-=m):r+a.offsetHeight>c+m&&(r=t.top-a.offsetHeight+1),0>r&&(r=0),n+a.offsetWidth>u&&(n=u-a.offsetWidth)),i=J[0],H(i,function(e){var t;return t=window.getComputedStyle(e).getPropertyValue("position"),"relative"===t&&u>=e.offsetWidth?(n-=(u-e.offsetWidth)/2,!1):void 0}),f={position:o,left:n,top:"",bottom:""},f[l]=r,J.css(f)},J.on("open.xdsoft",function(t){var a=!0;C.onShow&&e.isFunction(C.onShow)&&(a=C.onShow.call(J,j.currentTime,J.data("input"),t)),a!==!1&&(J.show(),Y(),e(window).off("resize.xdsoft",Y).on("resize.xdsoft",Y),C.closeOnWithoutClick&&e([document.body,window]).on("touchstart mousedown.xdsoft",function r(){J.trigger("close.xdsoft"),e([document.body,window]).off("touchstart mousedown.xdsoft",r)}))}).on("close.xdsoft",function(t){var a=!0;N.find(".xdsoft_month,.xdsoft_year").find(".xdsoft_select").hide(),C.onClose&&e.isFunction(C.onClose)&&(a=C.onClose.call(J,j.currentTime,J.data("input"),t)),a===!1||C.opened||C.inline||J.hide(),t.stopPropagation()}).on("toggle.xdsoft",function(){J.trigger(J.is(":visible")?"close.xdsoft":"open.xdsoft")}).data("input",a),X=0,J.data("xdsoft_datetime",j),J.setOptions(C),j.setCurrentTime(i()),a.data("xdsoft_datetimepicker",J).on("open.xdsoft focusin.xdsoft mousedown.xdsoft touchstart",function(){a.is(":disabled")||a.data("xdsoft_datetimepicker").is(":visible")&&C.closeOnInputClick||(clearTimeout(X),X=setTimeout(function(){a.is(":disabled")||(q=!0,j.setCurrentTime(i(),!0),C.mask&&s(C),J.trigger("open.xdsoft"))},100))}).on("keydown.xdsoft",function(t){var a,r=t.which;return-1!==[p].indexOf(r)&&C.enterLikeTab?(a=e("input:visible,textarea:visible,button:visible,a:visible"),J.trigger("close.xdsoft"),a.eq(a.index(this)+1).focus(),!1):-1!==[T].indexOf(r)?(J.trigger("close.xdsoft"),!0):void 0}).on("blur.xdsoft",function(){J.trigger("close.xdsoft")})},d=function(t){var a=t.data("xdsoft_datetimepicker");a&&(a.data("xdsoft_datetime",null),a.remove(),t.data("xdsoft_datetimepicker",null).off(".xdsoft"),e(window).off("resize.xdsoft"),e([window,document.body]).off("mousedown.xdsoft touchstart"),t.unmousewheel&&t.unmousewheel())},e(document).off("keydown.xdsoftctrl keyup.xdsoftctrl").on("keydown.xdsoftctrl",function(e){e.keyCode===h&&(F=!0)}).on("keyup.xdsoftctrl",function(e){e.keyCode===h&&(F=!1)}),this.each(function(){var t,a=e(this).data("xdsoft_datetimepicker");if(a){if("string"===e.type(n))switch(n){case"show":e(this).select().focus(),a.trigger("open.xdsoft");break;case"hide":a.trigger("close.xdsoft");break;case"toggle":a.trigger("toggle.xdsoft");break;case"destroy":d(e(this));break;case"reset":this.value=this.defaultValue,this.value&&a.data("xdsoft_datetime").isValidDate(r.parseDate(this.value,C.format))||a.data("changed",!1),a.data("xdsoft_datetime").setCurrentTime(this.value);break;case"validate":t=a.data("input"),t.trigger("blur.xdsoft");break;default:a[n]&&e.isFunction(a[n])&&(u=a[n](i))}else a.setOptions(n);return 0}"string"!==e.type(n)&&(!C.lazyInit||C.open||C.inline?s(e(this)):A(e(this)))}),u},e.fn.datetimepicker.defaults=a}),function(e){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?module.exports=e:e(jQuery)}(function(e){function t(t){var i=t||window.event,s=d.call(arguments,1),u=0,f=0,c=0,m=0,h=0,g=0;if(t=e.event.fix(i),t.type="mousewheel","detail"in i&&(c=-1*i.detail),"wheelDelta"in i&&(c=i.wheelDelta),"wheelDeltaY"in i&&(c=i.wheelDeltaY),"wheelDeltaX"in i&&(f=-1*i.wheelDeltaX),"axis"in i&&i.axis===i.HORIZONTAL_AXIS&&(f=-1*c,c=0),u=0===c?f:c,"deltaY"in i&&(c=-1*i.deltaY,u=c),"deltaX"in i&&(f=i.deltaX,0===c&&(u=-1*f)),0!==c||0!==f){if(1===i.deltaMode){var p=e.data(this,"mousewheel-line-height");u*=p,c*=p,f*=p}else if(2===i.deltaMode){var y=e.data(this,"mousewheel-page-height");u*=y,c*=y,f*=y}if(m=Math.max(Math.abs(c),Math.abs(f)),(!o||o>m)&&(o=m,r(i,m)&&(o/=40)),r(i,m)&&(u/=40,f/=40,c/=40),u=Math[u>=1?"floor":"ceil"](u/o),f=Math[f>=1?"floor":"ceil"](f/o),c=Math[c>=1?"floor":"ceil"](c/o),l.settings.normalizeOffset&&this.getBoundingClientRect){var v=this.getBoundingClientRect();h=t.clientX-v.left,g=t.clientY-v.top}return t.deltaX=f,t.deltaY=c,t.deltaFactor=o,t.offsetX=h,t.offsetY=g,t.deltaMode=0,s.unshift(t,u,f,c),n&&clearTimeout(n),n=setTimeout(a,200),(e.event.dispatch||e.event.handle).apply(this,s)}}function a(){o=null}function r(e,t){return l.settings.adjustOldDeltas&&"mousewheel"===e.type&&t%120===0}var n,o,i=["wheel","mousewheel","DOMMouseScroll","MozMousePixelScroll"],s="onwheel"in document||document.documentMode>=9?["wheel"]:["mousewheel","DomMouseScroll","MozMousePixelScroll"],d=Array.prototype.slice;if(e.event.fixHooks)for(var u=i.length;u;)e.event.fixHooks[i[--u]]=e.event.mouseHooks;var l=e.event.special.mousewheel={version:"3.1.12",setup:function(){if(this.addEventListener)for(var a=s.length;a;)this.addEventListener(s[--a],t,!1);else this.onmousewheel=t;e.data(this,"mousewheel-line-height",l.getLineHeight(this)),e.data(this,"mousewheel-page-height",l.getPageHeight(this))},teardown:function(){if(this.removeEventListener)for(var a=s.length;a;)this.removeEventListener(s[--a],t,!1);else this.onmousewheel=null;e.removeData(this,"mousewheel-line-height"),e.removeData(this,"mousewheel-page-height")},getLineHeight:function(t){var a=e(t),r=a["offsetParent"in e.fn?"offsetParent":"parent"]();return r.length||(r=e("body")),parseInt(r.css("fontSize"),10)||parseInt(a.css("fontSize"),10)||16},getPageHeight:function(t){return e(t).height()},settings:{adjustOldDeltas:!0,normalizeOffset:!0}};e.fn.extend({mousewheel:function(e){return e?this.bind("mousewheel",e):this.trigger("mousewheel")},unmousewheel:function(e){return this.unbind("mousewheel",e)}})});

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery Mousewheel 3.1.13
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 */

(function (factory) {
    if ( true ) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        // Node/CommonJS style for Browserify
        module.exports = factory;
    } else {
        // Browser globals
        factory(jQuery);
    }
}(function ($) {

    var toFix  = ['wheel', 'mousewheel', 'DOMMouseScroll', 'MozMousePixelScroll'],
        toBind = ( 'onwheel' in document || document.documentMode >= 9 ) ?
                    ['wheel'] : ['mousewheel', 'DomMouseScroll', 'MozMousePixelScroll'],
        slice  = Array.prototype.slice,
        nullLowestDeltaTimeout, lowestDelta;

    if ( $.event.fixHooks ) {
        for ( var i = toFix.length; i; ) {
            $.event.fixHooks[ toFix[--i] ] = $.event.mouseHooks;
        }
    }

    var special = $.event.special.mousewheel = {
        version: '3.1.12',

        setup: function() {
            if ( this.addEventListener ) {
                for ( var i = toBind.length; i; ) {
                    this.addEventListener( toBind[--i], handler, false );
                }
            } else {
                this.onmousewheel = handler;
            }
            // Store the line height and page height for this particular element
            $.data(this, 'mousewheel-line-height', special.getLineHeight(this));
            $.data(this, 'mousewheel-page-height', special.getPageHeight(this));
        },

        teardown: function() {
            if ( this.removeEventListener ) {
                for ( var i = toBind.length; i; ) {
                    this.removeEventListener( toBind[--i], handler, false );
                }
            } else {
                this.onmousewheel = null;
            }
            // Clean up the data we added to the element
            $.removeData(this, 'mousewheel-line-height');
            $.removeData(this, 'mousewheel-page-height');
        },

        getLineHeight: function(elem) {
            var $elem = $(elem),
                $parent = $elem['offsetParent' in $.fn ? 'offsetParent' : 'parent']();
            if (!$parent.length) {
                $parent = $('body');
            }
            return parseInt($parent.css('fontSize'), 10) || parseInt($elem.css('fontSize'), 10) || 16;
        },

        getPageHeight: function(elem) {
            return $(elem).height();
        },

        settings: {
            adjustOldDeltas: true, // see shouldAdjustOldDeltas() below
            normalizeOffset: true  // calls getBoundingClientRect for each event
        }
    };

    $.fn.extend({
        mousewheel: function(fn) {
            return fn ? this.bind('mousewheel', fn) : this.trigger('mousewheel');
        },

        unmousewheel: function(fn) {
            return this.unbind('mousewheel', fn);
        }
    });


    function handler(event) {
        var orgEvent   = event || window.event,
            args       = slice.call(arguments, 1),
            delta      = 0,
            deltaX     = 0,
            deltaY     = 0,
            absDelta   = 0,
            offsetX    = 0,
            offsetY    = 0;
        event = $.event.fix(orgEvent);
        event.type = 'mousewheel';

        // Old school scrollwheel delta
        if ( 'detail'      in orgEvent ) { deltaY = orgEvent.detail * -1;      }
        if ( 'wheelDelta'  in orgEvent ) { deltaY = orgEvent.wheelDelta;       }
        if ( 'wheelDeltaY' in orgEvent ) { deltaY = orgEvent.wheelDeltaY;      }
        if ( 'wheelDeltaX' in orgEvent ) { deltaX = orgEvent.wheelDeltaX * -1; }

        // Firefox < 17 horizontal scrolling related to DOMMouseScroll event
        if ( 'axis' in orgEvent && orgEvent.axis === orgEvent.HORIZONTAL_AXIS ) {
            deltaX = deltaY * -1;
            deltaY = 0;
        }

        // Set delta to be deltaY or deltaX if deltaY is 0 for backwards compatabilitiy
        delta = deltaY === 0 ? deltaX : deltaY;

        // New school wheel delta (wheel event)
        if ( 'deltaY' in orgEvent ) {
            deltaY = orgEvent.deltaY * -1;
            delta  = deltaY;
        }
        if ( 'deltaX' in orgEvent ) {
            deltaX = orgEvent.deltaX;
            if ( deltaY === 0 ) { delta  = deltaX * -1; }
        }

        // No change actually happened, no reason to go any further
        if ( deltaY === 0 && deltaX === 0 ) { return; }

        // Need to convert lines and pages to pixels if we aren't already in pixels
        // There are three delta modes:
        //   * deltaMode 0 is by pixels, nothing to do
        //   * deltaMode 1 is by lines
        //   * deltaMode 2 is by pages
        if ( orgEvent.deltaMode === 1 ) {
            var lineHeight = $.data(this, 'mousewheel-line-height');
            delta  *= lineHeight;
            deltaY *= lineHeight;
            deltaX *= lineHeight;
        } else if ( orgEvent.deltaMode === 2 ) {
            var pageHeight = $.data(this, 'mousewheel-page-height');
            delta  *= pageHeight;
            deltaY *= pageHeight;
            deltaX *= pageHeight;
        }

        // Store lowest absolute delta to normalize the delta values
        absDelta = Math.max( Math.abs(deltaY), Math.abs(deltaX) );

        if ( !lowestDelta || absDelta < lowestDelta ) {
            lowestDelta = absDelta;

            // Adjust older deltas if necessary
            if ( shouldAdjustOldDeltas(orgEvent, absDelta) ) {
                lowestDelta /= 40;
            }
        }

        // Adjust older deltas if necessary
        if ( shouldAdjustOldDeltas(orgEvent, absDelta) ) {
            // Divide all the things by 40!
            delta  /= 40;
            deltaX /= 40;
            deltaY /= 40;
        }

        // Get a whole, normalized value for the deltas
        delta  = Math[ delta  >= 1 ? 'floor' : 'ceil' ](delta  / lowestDelta);
        deltaX = Math[ deltaX >= 1 ? 'floor' : 'ceil' ](deltaX / lowestDelta);
        deltaY = Math[ deltaY >= 1 ? 'floor' : 'ceil' ](deltaY / lowestDelta);

        // Normalise offsetX and offsetY properties
        if ( special.settings.normalizeOffset && this.getBoundingClientRect ) {
            var boundingRect = this.getBoundingClientRect();
            offsetX = event.clientX - boundingRect.left;
            offsetY = event.clientY - boundingRect.top;
        }

        // Add information to the event object
        event.deltaX = deltaX;
        event.deltaY = deltaY;
        event.deltaFactor = lowestDelta;
        event.offsetX = offsetX;
        event.offsetY = offsetY;
        // Go ahead and set deltaMode to 0 since we converted to pixels
        // Although this is a little odd since we overwrite the deltaX/Y
        // properties with normalized deltas.
        event.deltaMode = 0;

        // Add event and delta to the front of the arguments
        args.unshift(event, delta, deltaX, deltaY);

        // Clearout lowestDelta after sometime to better
        // handle multiple device types that give different
        // a different lowestDelta
        // Ex: trackpad = 3 and mouse wheel = 120
        if (nullLowestDeltaTimeout) { clearTimeout(nullLowestDeltaTimeout); }
        nullLowestDeltaTimeout = setTimeout(nullLowestDelta, 200);

        return ($.event.dispatch || $.event.handle).apply(this, args);
    }

    function nullLowestDelta() {
        lowestDelta = null;
    }

    function shouldAdjustOldDeltas(orgEvent, absDelta) {
        // If this is an older event and the delta is divisable by 120,
        // then we are assuming that the browser is treating this as an
        // older mouse wheel event and that we should divide the deltas
        // by 40 to try and get a more usable deltaFactor.
        // Side note, this actually impacts the reported scroll distance
        // in older browsers and can cause scrolling to be slower than native.
        // Turn this off by setting $.event.special.mousewheel.settings.adjustOldDeltas to false.
        return special.settings.adjustOldDeltas && orgEvent.type === 'mousewheel' && absDelta % 120 === 0;
    }

}));


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;( function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(0) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
} ( function( $ ) {

$.ui = $.ui || {};

return $.ui.version = "1.12.1";

} ) );


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery UI Widget 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Widget
//>>group: Core
//>>description: Provides a factory for creating stateful widgets with a common API.
//>>docs: http://api.jqueryui.com/jQuery.widget/
//>>demos: http://jqueryui.com/widget/

( function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(0), __webpack_require__(424) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}( function( $ ) {

var widgetUuid = 0;
var widgetSlice = Array.prototype.slice;

$.cleanData = ( function( orig ) {
	return function( elems ) {
		var events, elem, i;
		for ( i = 0; ( elem = elems[ i ] ) != null; i++ ) {
			try {

				// Only trigger remove when necessary to save time
				events = $._data( elem, "events" );
				if ( events && events.remove ) {
					$( elem ).triggerHandler( "remove" );
				}

			// Http://bugs.jquery.com/ticket/8235
			} catch ( e ) {}
		}
		orig( elems );
	};
} )( $.cleanData );

$.widget = function( name, base, prototype ) {
	var existingConstructor, constructor, basePrototype;

	// ProxiedPrototype allows the provided prototype to remain unmodified
	// so that it can be used as a mixin for multiple widgets (#8876)
	var proxiedPrototype = {};

	var namespace = name.split( "." )[ 0 ];
	name = name.split( "." )[ 1 ];
	var fullName = namespace + "-" + name;

	if ( !prototype ) {
		prototype = base;
		base = $.Widget;
	}

	if ( $.isArray( prototype ) ) {
		prototype = $.extend.apply( null, [ {} ].concat( prototype ) );
	}

	// Create selector for plugin
	$.expr[ ":" ][ fullName.toLowerCase() ] = function( elem ) {
		return !!$.data( elem, fullName );
	};

	$[ namespace ] = $[ namespace ] || {};
	existingConstructor = $[ namespace ][ name ];
	constructor = $[ namespace ][ name ] = function( options, element ) {

		// Allow instantiation without "new" keyword
		if ( !this._createWidget ) {
			return new constructor( options, element );
		}

		// Allow instantiation without initializing for simple inheritance
		// must use "new" keyword (the code above always passes args)
		if ( arguments.length ) {
			this._createWidget( options, element );
		}
	};

	// Extend with the existing constructor to carry over any static properties
	$.extend( constructor, existingConstructor, {
		version: prototype.version,

		// Copy the object used to create the prototype in case we need to
		// redefine the widget later
		_proto: $.extend( {}, prototype ),

		// Track widgets that inherit from this widget in case this widget is
		// redefined after a widget inherits from it
		_childConstructors: []
	} );

	basePrototype = new base();

	// We need to make the options hash a property directly on the new instance
	// otherwise we'll modify the options hash on the prototype that we're
	// inheriting from
	basePrototype.options = $.widget.extend( {}, basePrototype.options );
	$.each( prototype, function( prop, value ) {
		if ( !$.isFunction( value ) ) {
			proxiedPrototype[ prop ] = value;
			return;
		}
		proxiedPrototype[ prop ] = ( function() {
			function _super() {
				return base.prototype[ prop ].apply( this, arguments );
			}

			function _superApply( args ) {
				return base.prototype[ prop ].apply( this, args );
			}

			return function() {
				var __super = this._super;
				var __superApply = this._superApply;
				var returnValue;

				this._super = _super;
				this._superApply = _superApply;

				returnValue = value.apply( this, arguments );

				this._super = __super;
				this._superApply = __superApply;

				return returnValue;
			};
		} )();
	} );
	constructor.prototype = $.widget.extend( basePrototype, {

		// TODO: remove support for widgetEventPrefix
		// always use the name + a colon as the prefix, e.g., draggable:start
		// don't prefix for widgets that aren't DOM-based
		widgetEventPrefix: existingConstructor ? ( basePrototype.widgetEventPrefix || name ) : name
	}, proxiedPrototype, {
		constructor: constructor,
		namespace: namespace,
		widgetName: name,
		widgetFullName: fullName
	} );

	// If this widget is being redefined then we need to find all widgets that
	// are inheriting from it and redefine all of them so that they inherit from
	// the new version of this widget. We're essentially trying to replace one
	// level in the prototype chain.
	if ( existingConstructor ) {
		$.each( existingConstructor._childConstructors, function( i, child ) {
			var childPrototype = child.prototype;

			// Redefine the child widget using the same prototype that was
			// originally used, but inherit from the new version of the base
			$.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor,
				child._proto );
		} );

		// Remove the list of existing child constructors from the old constructor
		// so the old child constructors can be garbage collected
		delete existingConstructor._childConstructors;
	} else {
		base._childConstructors.push( constructor );
	}

	$.widget.bridge( name, constructor );

	return constructor;
};

$.widget.extend = function( target ) {
	var input = widgetSlice.call( arguments, 1 );
	var inputIndex = 0;
	var inputLength = input.length;
	var key;
	var value;

	for ( ; inputIndex < inputLength; inputIndex++ ) {
		for ( key in input[ inputIndex ] ) {
			value = input[ inputIndex ][ key ];
			if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {

				// Clone objects
				if ( $.isPlainObject( value ) ) {
					target[ key ] = $.isPlainObject( target[ key ] ) ?
						$.widget.extend( {}, target[ key ], value ) :

						// Don't extend strings, arrays, etc. with objects
						$.widget.extend( {}, value );

				// Copy everything else by reference
				} else {
					target[ key ] = value;
				}
			}
		}
	}
	return target;
};

$.widget.bridge = function( name, object ) {
	var fullName = object.prototype.widgetFullName || name;
	$.fn[ name ] = function( options ) {
		var isMethodCall = typeof options === "string";
		var args = widgetSlice.call( arguments, 1 );
		var returnValue = this;

		if ( isMethodCall ) {

			// If this is an empty collection, we need to have the instance method
			// return undefined instead of the jQuery instance
			if ( !this.length && options === "instance" ) {
				returnValue = undefined;
			} else {
				this.each( function() {
					var methodValue;
					var instance = $.data( this, fullName );

					if ( options === "instance" ) {
						returnValue = instance;
						return false;
					}

					if ( !instance ) {
						return $.error( "cannot call methods on " + name +
							" prior to initialization; " +
							"attempted to call method '" + options + "'" );
					}

					if ( !$.isFunction( instance[ options ] ) || options.charAt( 0 ) === "_" ) {
						return $.error( "no such method '" + options + "' for " + name +
							" widget instance" );
					}

					methodValue = instance[ options ].apply( instance, args );

					if ( methodValue !== instance && methodValue !== undefined ) {
						returnValue = methodValue && methodValue.jquery ?
							returnValue.pushStack( methodValue.get() ) :
							methodValue;
						return false;
					}
				} );
			}
		} else {

			// Allow multiple hashes to be passed on init
			if ( args.length ) {
				options = $.widget.extend.apply( null, [ options ].concat( args ) );
			}

			this.each( function() {
				var instance = $.data( this, fullName );
				if ( instance ) {
					instance.option( options || {} );
					if ( instance._init ) {
						instance._init();
					}
				} else {
					$.data( this, fullName, new object( options, this ) );
				}
			} );
		}

		return returnValue;
	};
};

$.Widget = function( /* options, element */ ) {};
$.Widget._childConstructors = [];

$.Widget.prototype = {
	widgetName: "widget",
	widgetEventPrefix: "",
	defaultElement: "<div>",

	options: {
		classes: {},
		disabled: false,

		// Callbacks
		create: null
	},

	_createWidget: function( options, element ) {
		element = $( element || this.defaultElement || this )[ 0 ];
		this.element = $( element );
		this.uuid = widgetUuid++;
		this.eventNamespace = "." + this.widgetName + this.uuid;

		this.bindings = $();
		this.hoverable = $();
		this.focusable = $();
		this.classesElementLookup = {};

		if ( element !== this ) {
			$.data( element, this.widgetFullName, this );
			this._on( true, this.element, {
				remove: function( event ) {
					if ( event.target === element ) {
						this.destroy();
					}
				}
			} );
			this.document = $( element.style ?

				// Element within the document
				element.ownerDocument :

				// Element is window or document
				element.document || element );
			this.window = $( this.document[ 0 ].defaultView || this.document[ 0 ].parentWindow );
		}

		this.options = $.widget.extend( {},
			this.options,
			this._getCreateOptions(),
			options );

		this._create();

		if ( this.options.disabled ) {
			this._setOptionDisabled( this.options.disabled );
		}

		this._trigger( "create", null, this._getCreateEventData() );
		this._init();
	},

	_getCreateOptions: function() {
		return {};
	},

	_getCreateEventData: $.noop,

	_create: $.noop,

	_init: $.noop,

	destroy: function() {
		var that = this;

		this._destroy();
		$.each( this.classesElementLookup, function( key, value ) {
			that._removeClass( value, key );
		} );

		// We can probably remove the unbind calls in 2.0
		// all event bindings should go through this._on()
		this.element
			.off( this.eventNamespace )
			.removeData( this.widgetFullName );
		this.widget()
			.off( this.eventNamespace )
			.removeAttr( "aria-disabled" );

		// Clean up events and states
		this.bindings.off( this.eventNamespace );
	},

	_destroy: $.noop,

	widget: function() {
		return this.element;
	},

	option: function( key, value ) {
		var options = key;
		var parts;
		var curOption;
		var i;

		if ( arguments.length === 0 ) {

			// Don't return a reference to the internal hash
			return $.widget.extend( {}, this.options );
		}

		if ( typeof key === "string" ) {

			// Handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
			options = {};
			parts = key.split( "." );
			key = parts.shift();
			if ( parts.length ) {
				curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
				for ( i = 0; i < parts.length - 1; i++ ) {
					curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
					curOption = curOption[ parts[ i ] ];
				}
				key = parts.pop();
				if ( arguments.length === 1 ) {
					return curOption[ key ] === undefined ? null : curOption[ key ];
				}
				curOption[ key ] = value;
			} else {
				if ( arguments.length === 1 ) {
					return this.options[ key ] === undefined ? null : this.options[ key ];
				}
				options[ key ] = value;
			}
		}

		this._setOptions( options );

		return this;
	},

	_setOptions: function( options ) {
		var key;

		for ( key in options ) {
			this._setOption( key, options[ key ] );
		}

		return this;
	},

	_setOption: function( key, value ) {
		if ( key === "classes" ) {
			this._setOptionClasses( value );
		}

		this.options[ key ] = value;

		if ( key === "disabled" ) {
			this._setOptionDisabled( value );
		}

		return this;
	},

	_setOptionClasses: function( value ) {
		var classKey, elements, currentElements;

		for ( classKey in value ) {
			currentElements = this.classesElementLookup[ classKey ];
			if ( value[ classKey ] === this.options.classes[ classKey ] ||
					!currentElements ||
					!currentElements.length ) {
				continue;
			}

			// We are doing this to create a new jQuery object because the _removeClass() call
			// on the next line is going to destroy the reference to the current elements being
			// tracked. We need to save a copy of this collection so that we can add the new classes
			// below.
			elements = $( currentElements.get() );
			this._removeClass( currentElements, classKey );

			// We don't use _addClass() here, because that uses this.options.classes
			// for generating the string of classes. We want to use the value passed in from
			// _setOption(), this is the new value of the classes option which was passed to
			// _setOption(). We pass this value directly to _classes().
			elements.addClass( this._classes( {
				element: elements,
				keys: classKey,
				classes: value,
				add: true
			} ) );
		}
	},

	_setOptionDisabled: function( value ) {
		this._toggleClass( this.widget(), this.widgetFullName + "-disabled", null, !!value );

		// If the widget is becoming disabled, then nothing is interactive
		if ( value ) {
			this._removeClass( this.hoverable, null, "ui-state-hover" );
			this._removeClass( this.focusable, null, "ui-state-focus" );
		}
	},

	enable: function() {
		return this._setOptions( { disabled: false } );
	},

	disable: function() {
		return this._setOptions( { disabled: true } );
	},

	_classes: function( options ) {
		var full = [];
		var that = this;

		options = $.extend( {
			element: this.element,
			classes: this.options.classes || {}
		}, options );

		function processClassString( classes, checkOption ) {
			var current, i;
			for ( i = 0; i < classes.length; i++ ) {
				current = that.classesElementLookup[ classes[ i ] ] || $();
				if ( options.add ) {
					current = $( $.unique( current.get().concat( options.element.get() ) ) );
				} else {
					current = $( current.not( options.element ).get() );
				}
				that.classesElementLookup[ classes[ i ] ] = current;
				full.push( classes[ i ] );
				if ( checkOption && options.classes[ classes[ i ] ] ) {
					full.push( options.classes[ classes[ i ] ] );
				}
			}
		}

		this._on( options.element, {
			"remove": "_untrackClassesElement"
		} );

		if ( options.keys ) {
			processClassString( options.keys.match( /\S+/g ) || [], true );
		}
		if ( options.extra ) {
			processClassString( options.extra.match( /\S+/g ) || [] );
		}

		return full.join( " " );
	},

	_untrackClassesElement: function( event ) {
		var that = this;
		$.each( that.classesElementLookup, function( key, value ) {
			if ( $.inArray( event.target, value ) !== -1 ) {
				that.classesElementLookup[ key ] = $( value.not( event.target ).get() );
			}
		} );
	},

	_removeClass: function( element, keys, extra ) {
		return this._toggleClass( element, keys, extra, false );
	},

	_addClass: function( element, keys, extra ) {
		return this._toggleClass( element, keys, extra, true );
	},

	_toggleClass: function( element, keys, extra, add ) {
		add = ( typeof add === "boolean" ) ? add : extra;
		var shift = ( typeof element === "string" || element === null ),
			options = {
				extra: shift ? keys : extra,
				keys: shift ? element : keys,
				element: shift ? this.element : element,
				add: add
			};
		options.element.toggleClass( this._classes( options ), add );
		return this;
	},

	_on: function( suppressDisabledCheck, element, handlers ) {
		var delegateElement;
		var instance = this;

		// No suppressDisabledCheck flag, shuffle arguments
		if ( typeof suppressDisabledCheck !== "boolean" ) {
			handlers = element;
			element = suppressDisabledCheck;
			suppressDisabledCheck = false;
		}

		// No element argument, shuffle and use this.element
		if ( !handlers ) {
			handlers = element;
			element = this.element;
			delegateElement = this.widget();
		} else {
			element = delegateElement = $( element );
			this.bindings = this.bindings.add( element );
		}

		$.each( handlers, function( event, handler ) {
			function handlerProxy() {

				// Allow widgets to customize the disabled handling
				// - disabled as an array instead of boolean
				// - disabled class as method for disabling individual parts
				if ( !suppressDisabledCheck &&
						( instance.options.disabled === true ||
						$( this ).hasClass( "ui-state-disabled" ) ) ) {
					return;
				}
				return ( typeof handler === "string" ? instance[ handler ] : handler )
					.apply( instance, arguments );
			}

			// Copy the guid so direct unbinding works
			if ( typeof handler !== "string" ) {
				handlerProxy.guid = handler.guid =
					handler.guid || handlerProxy.guid || $.guid++;
			}

			var match = event.match( /^([\w:-]*)\s*(.*)$/ );
			var eventName = match[ 1 ] + instance.eventNamespace;
			var selector = match[ 2 ];

			if ( selector ) {
				delegateElement.on( eventName, selector, handlerProxy );
			} else {
				element.on( eventName, handlerProxy );
			}
		} );
	},

	_off: function( element, eventName ) {
		eventName = ( eventName || "" ).split( " " ).join( this.eventNamespace + " " ) +
			this.eventNamespace;
		element.off( eventName ).off( eventName );

		// Clear the stack to avoid memory leaks (#10056)
		this.bindings = $( this.bindings.not( element ).get() );
		this.focusable = $( this.focusable.not( element ).get() );
		this.hoverable = $( this.hoverable.not( element ).get() );
	},

	_delay: function( handler, delay ) {
		function handlerProxy() {
			return ( typeof handler === "string" ? instance[ handler ] : handler )
				.apply( instance, arguments );
		}
		var instance = this;
		return setTimeout( handlerProxy, delay || 0 );
	},

	_hoverable: function( element ) {
		this.hoverable = this.hoverable.add( element );
		this._on( element, {
			mouseenter: function( event ) {
				this._addClass( $( event.currentTarget ), null, "ui-state-hover" );
			},
			mouseleave: function( event ) {
				this._removeClass( $( event.currentTarget ), null, "ui-state-hover" );
			}
		} );
	},

	_focusable: function( element ) {
		this.focusable = this.focusable.add( element );
		this._on( element, {
			focusin: function( event ) {
				this._addClass( $( event.currentTarget ), null, "ui-state-focus" );
			},
			focusout: function( event ) {
				this._removeClass( $( event.currentTarget ), null, "ui-state-focus" );
			}
		} );
	},

	_trigger: function( type, event, data ) {
		var prop, orig;
		var callback = this.options[ type ];

		data = data || {};
		event = $.Event( event );
		event.type = ( type === this.widgetEventPrefix ?
			type :
			this.widgetEventPrefix + type ).toLowerCase();

		// The original event may come from any element
		// so we need to reset the target on the new event
		event.target = this.element[ 0 ];

		// Copy original event properties over to the new event
		orig = event.originalEvent;
		if ( orig ) {
			for ( prop in orig ) {
				if ( !( prop in event ) ) {
					event[ prop ] = orig[ prop ];
				}
			}
		}

		this.element.trigger( event, data );
		return !( $.isFunction( callback ) &&
			callback.apply( this.element[ 0 ], [ event ].concat( data ) ) === false ||
			event.isDefaultPrevented() );
	}
};

$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
	$.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
		if ( typeof options === "string" ) {
			options = { effect: options };
		}

		var hasOptions;
		var effectName = !options ?
			method :
			options === true || typeof options === "number" ?
				defaultEffect :
				options.effect || defaultEffect;

		options = options || {};
		if ( typeof options === "number" ) {
			options = { duration: options };
		}

		hasOptions = !$.isEmptyObject( options );
		options.complete = callback;

		if ( options.delay ) {
			element.delay( options.delay );
		}

		if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
			element[ method ]( options );
		} else if ( effectName !== method && element[ effectName ] ) {
			element[ effectName ]( options.duration, options.easing, callback );
		} else {
			element.queue( function( next ) {
				$( this )[ method ]();
				if ( callback ) {
					callback.call( element[ 0 ] );
				}
				next();
			} );
		}
	};
} );

return $.widget;

} ) );


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v2.2.4
 * http://jquery.com/
 *
 * Includes Sizzle.js
 * http://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-05-20T17:23Z
 */

(function( global, factory ) {

	if ( typeof module === "object" && typeof module.exports === "object" ) {
		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Support: Firefox 18+
// Can't be in strict mode, several libs including ASP.NET trace
// the stack via arguments.caller.callee and Firefox dies if
// you try to trace through "use strict" call chains. (#13335)
//"use strict";
var arr = [];

var document = window.document;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var support = {};



var
	version = "2.2.4",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android<4.1
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([\da-z])/gi,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// Start with an empty selector
	selector: "",

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {
		return num != null ?

			// Return just the one element from the set
			( num < 0 ? this[ num + this.length ] : this[ num ] ) :

			// Return all the elements in a clean array
			slice.call( this );
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;
		ret.context = this.context;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = jQuery.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && jQuery.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isFunction: function( obj ) {
		return jQuery.type( obj ) === "function";
	},

	isArray: Array.isArray,

	isWindow: function( obj ) {
		return obj != null && obj === obj.window;
	},

	isNumeric: function( obj ) {

		// parseFloat NaNs numeric-cast false positives (null|true|false|"")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		// adding 1 corrects loss of precision from parseFloat (#15100)
		var realStringObj = obj && obj.toString();
		return !jQuery.isArray( obj ) && ( realStringObj - parseFloat( realStringObj ) + 1 ) >= 0;
	},

	isPlainObject: function( obj ) {
		var key;

		// Not plain objects:
		// - Any object or value whose internal [[Class]] property is not "[object Object]"
		// - DOM nodes
		// - window
		if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
			return false;
		}

		// Not own constructor property must be Object
		if ( obj.constructor &&
				!hasOwn.call( obj, "constructor" ) &&
				!hasOwn.call( obj.constructor.prototype || {}, "isPrototypeOf" ) ) {
			return false;
		}

		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own
		for ( key in obj ) {}

		return key === undefined || hasOwn.call( obj, key );
	},

	isEmptyObject: function( obj ) {
		var name;
		for ( name in obj ) {
			return false;
		}
		return true;
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}

		// Support: Android<4.0, iOS<6 (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		var script,
			indirect = eval;

		code = jQuery.trim( code );

		if ( code ) {

			// If the code includes a valid, prologue position
			// strict mode pragma, execute code by injecting a
			// script tag into the document.
			if ( code.indexOf( "use strict" ) === 1 ) {
				script = document.createElement( "script" );
				script.text = code;
				document.head.appendChild( script ).parentNode.removeChild( script );
			} else {

				// Otherwise, avoid the DOM node creation, insertion
				// and removal by using an indirect global eval

				indirect( code );
			}
		}
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE9-11+
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	nodeName: function( elem, name ) {
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android<4.1
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: Date.now,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

// JSHint would error on this code due to the Symbol not being defined in ES5.
// Defining this global in .jshintrc would create a danger of using the global
// unguarded in another place, it seems safer to just disable JSHint for these
// three lines.
/* jshint ignore: start */
if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}
/* jshint ignore: end */

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: iOS 8.2 (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.2.1
 * http://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2015-10-17
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// General-purpose constants
	MAX_NEGATIVE = 1 << 31,

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// http://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,
	rescape = /'|\\/g,

	// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	};

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, nidselect, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rescape, "\\$&" );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					nidselect = ridentifier.test( nid ) ? "#" + nid : "[id='" + nid + "']";
					while ( i-- ) {
						groups[i] = nidselect + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created div and expects a boolean result
 */
function assert( fn ) {
	var div = document.createElement("div");

	try {
		return !!fn( div );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( div.parentNode ) {
			div.parentNode.removeChild( div );
		}
		// release memory in IE
		div = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			( ~b.sourceIndex || MAX_NEGATIVE ) -
			( ~a.sourceIndex || MAX_NEGATIVE );

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, parent,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( (parent = document.defaultView) && parent.top !== parent ) {
		// Support: IE 11
		if ( parent.addEventListener ) {
			parent.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( parent.attachEvent ) {
			parent.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( div ) {
		div.className = "i";
		return !div.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( div ) {
		div.appendChild( document.createComment("") );
		return !div.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( div ) {
		docElem.appendChild( div ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID find and filter
	if ( support.getById ) {
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var m = context.getElementById( id );
				return m ? [ m ] : [];
			}
		};
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
	} else {
		// Support: IE6/7
		// getElementById is not reliable as a find shortcut
		delete Expr.find["ID"];

		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See http://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( div ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// http://bugs.jquery.com/ticket/12359
			docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( div.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !div.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibing-combinator selector` fails
			if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( div ) {
			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			div.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( div.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":enabled").length ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			div.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( div ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( div, "div" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( div, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": function( elem ) {
			return elem.disabled === false;
		},

		"disabled": function( elem ) {
			return elem.disabled === true;
		},

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		checkNonElements = base && dir === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( (oldCache = uniqueCache[ dir ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ dir ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				support.getById && context.nodeType === 9 && documentIsHTML &&
				Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( div1 ) {
	// Should return 1, but returns 4 (following)
	return div1.compareDocumentPosition( document.createElement("div") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( div ) {
	div.innerHTML = "<a href='#'></a>";
	return div.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( div ) {
	div.innerHTML = "<input/>";
	div.firstChild.setAttribute( "value", "" );
	return div.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( div ) {
	return div.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;



var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = ( /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/ );



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			/* jshint -W018 */
			return !!qualifier.call( elem, i, elem ) !== not;
		} );

	}

	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );

	}

	if ( typeof qualifier === "string" ) {
		if ( risSimple.test( qualifier ) ) {
			return jQuery.filter( qualifier, elements, not );
		}

		qualifier = jQuery.filter( qualifier, elements );
	}

	return jQuery.grep( elements, function( elem ) {
		return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
	} );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	return elems.length === 1 && elem.nodeType === 1 ?
		jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
		jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i,
			len = this.length,
			ret = [],
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		// Needed because $( selector, context ) becomes $( context ).find( selector )
		ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
		ret.selector = this.selector ? this.selector + " " + selector : selector;
		return ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					// Support: Blackberry 4.6
					// gEBID returns nodes no longer in the document (#6963)
					if ( elem && elem.parentNode ) {

						// Inject the element directly into the jQuery object
						this.length = 1;
						this[ 0 ] = elem;
					}

					this.context = document;
					this.selector = selector;
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this.context = this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		if ( selector.selector !== undefined ) {
			this.selector = selector.selector;
			this.context = selector.context;
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
				jQuery( selectors, context || this.context ) :
				0;

		for ( ; i < l; i++ ) {
			for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

				// Always skip document fragments
				if ( cur.nodeType < 11 && ( pos ?
					pos.index( cur ) > -1 :

					// Don't pass non-elements to Sizzle
					cur.nodeType === 1 &&
						jQuery.find.matchesSelector( cur, selectors ) ) ) {

					matched.push( cur );
					break;
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		return elem.contentDocument || jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnotwhite = ( /\S+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( jQuery.isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, listener list, final state
				[ "resolve", "done", jQuery.Callbacks( "once memory" ), "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ), "rejected" ],
				[ "notify", "progress", jQuery.Callbacks( "memory" ) ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				then: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;
					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {
							var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];

							// deferred[ done | fail | progress ] for forwarding actions to newDefer
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this === promise ? newDefer.promise() : this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Keep pipe for back-compat
		promise.pipe = promise.then;

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 3 ];

			// promise[ done | fail | progress ] = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add( function() {

					// state = [ resolved | rejected ]
					state = stateString;

				// [ reject_list | resolve_list ].disable; progress_list.lock
				}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
			}

			// deferred[ resolve | reject | notify ]
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? promise : this, arguments );
				return this;
			};
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( subordinate /* , ..., subordinateN */ ) {
		var i = 0,
			resolveValues = slice.call( arguments ),
			length = resolveValues.length,

			// the count of uncompleted subordinates
			remaining = length !== 1 ||
				( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,

			// the master Deferred.
			// If resolveValues consist of only a single Deferred, just use that.
			deferred = remaining === 1 ? subordinate : jQuery.Deferred(),

			// Update function for both resolve and progress values
			updateFunc = function( i, contexts, values ) {
				return function( value ) {
					contexts[ i ] = this;
					values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( values === progressValues ) {
						deferred.notifyWith( contexts, values );
					} else if ( !( --remaining ) ) {
						deferred.resolveWith( contexts, values );
					}
				};
			},

			progressValues, progressContexts, resolveContexts;

		// Add listeners to Deferred subordinates; treat others as resolved
		if ( length > 1 ) {
			progressValues = new Array( length );
			progressContexts = new Array( length );
			resolveContexts = new Array( length );
			for ( ; i < length; i++ ) {
				if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
					resolveValues[ i ].promise()
						.progress( updateFunc( i, progressContexts, progressValues ) )
						.done( updateFunc( i, resolveContexts, resolveValues ) )
						.fail( deferred.reject );
				} else {
					--remaining;
				}
			}
		}

		// If we're not waiting on anything, resolve the master
		if ( !remaining ) {
			deferred.resolveWith( resolveContexts, resolveValues );
		}

		return deferred.promise();
	}
} );


// The deferred used on DOM ready
var readyList;

jQuery.fn.ready = function( fn ) {

	// Add the callback
	jQuery.ready.promise().done( fn );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Hold (or release) the ready event
	holdReady: function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	},

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );

		// Trigger any bound ready events
		if ( jQuery.fn.triggerHandler ) {
			jQuery( document ).triggerHandler( "ready" );
			jQuery( document ).off( "ready" );
		}
	}
} );

/**
 * The ready event handler and self cleanup method
 */
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

jQuery.ready.promise = function( obj ) {
	if ( !readyList ) {

		readyList = jQuery.Deferred();

		// Catch cases where $(document).ready() is called
		// after the browser event has already occurred.
		// Support: IE9-10 only
		// Older IE sometimes signals "interactive" too soon
		if ( document.readyState === "complete" ||
			( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

			// Handle it asynchronously to allow scripts the opportunity to delay ready
			window.setTimeout( jQuery.ready );

		} else {

			// Use the handy event callback
			document.addEventListener( "DOMContentLoaded", completed );

			// A fallback to window.onload, that will always work
			window.addEventListener( "load", completed );
		}
	}
	return readyList.promise( obj );
};

// Kick off the DOM ready check even if the user does not
jQuery.ready.promise();




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	return chainable ?
		elems :

		// Gets
		bulk ?
			fn.call( elems ) :
			len ? fn( elems[ 0 ], key ) : emptyGet;
};
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	/* jshint -W018 */
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	register: function( owner, initial ) {
		var value = initial || {};

		// If it is a node unlikely to be stringify-ed or looped over
		// use plain assignment
		if ( owner.nodeType ) {
			owner[ this.expando ] = value;

		// Otherwise secure it in a non-enumerable, non-writable property
		// configurability must be true to allow the property to be
		// deleted with the delete operator
		} else {
			Object.defineProperty( owner, this.expando, {
				value: value,
				writable: true,
				configurable: true
			} );
		}
		return owner[ this.expando ];
	},
	cache: function( owner ) {

		// We can accept data for non-element nodes in modern browsers,
		// but we should not, see #8335.
		// Always return an empty object.
		if ( !acceptData( owner ) ) {
			return {};
		}

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		if ( typeof data === "string" ) {
			cache[ data ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ prop ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :
			owner[ this.expando ] && owner[ this.expando ][ key ];
	},
	access: function( owner, key, value ) {
		var stored;

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			stored = this.get( owner, key );

			return stored !== undefined ?
				stored : this.get( owner, jQuery.camelCase( key ) );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i, name, camel,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key === undefined ) {
			this.register( owner );

		} else {

			// Support array or space separated string of keys
			if ( jQuery.isArray( key ) ) {

				// If "name" is an array of keys...
				// When data is initially created, via ("key", "val") signature,
				// keys will be converted to camelCase.
				// Since there is no way to tell _how_ a key was added, remove
				// both plain key and camelCase key. #12786
				// This will only penalize the array argument path.
				name = key.concat( key.map( jQuery.camelCase ) );
			} else {
				camel = jQuery.camelCase( key );

				// Try the string as a key before any manipulation
				if ( key in cache ) {
					name = [ key, camel ];
				} else {

					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					name = camel;
					name = name in cache ?
						[ name ] : ( name.match( rnotwhite ) || [] );
				}
			}

			i = name.length;

			while ( i-- ) {
				delete cache[ name[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <= 35-45+
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://code.google.com/p/chromium/issues/detail?id=378607
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = data === "true" ? true :
					data === "false" ? false :
					data === "null" ? null :

					// Only convert to a number if it doesn't change the string
					+data + "" === data ? +data :
					rbrace.test( data ) ? jQuery.parseJSON( data ) :
					data;
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE11+
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data, camelKey;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// with the key as-is
				data = dataUser.get( elem, key ) ||

					// Try to find dashed key if it exists (gh-2779)
					// This is for 2.2.x only
					dataUser.get( elem, key.replace( rmultiDash, "-$&" ).toLowerCase() );

				if ( data !== undefined ) {
					return data;
				}

				camelKey = jQuery.camelCase( key );

				// Attempt to get data from the cache
				// with the key camelized
				data = dataUser.get( elem, camelKey );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, camelKey, undefined );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			camelKey = jQuery.camelCase( key );
			this.each( function() {

				// First, attempt to store a copy or reference of any
				// data that might've been store with a camelCased key.
				var data = dataUser.get( this, camelKey );

				// For HTML5 data-* attribute interop, we have to
				// store property names with dashes in a camelCase form.
				// This might not apply to all properties...*
				dataUser.set( this, camelKey, value );

				// *... In the case of properties that might _actually_
				// have dashes, we need to also store a copy of that
				// unchanged property.
				if ( key.indexOf( "-" ) > -1 && data !== undefined ) {
					dataUser.set( this, key, value );
				}
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || jQuery.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHidden = function( elem, el ) {

		// isHidden might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;
		return jQuery.css( elem, "display" ) === "none" ||
			!jQuery.contains( elem.ownerDocument, elem );
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted,
		scale = 1,
		maxIterations = 20,
		currentValue = tween ?
			function() { return tween.cur(); } :
			function() { return jQuery.css( elem, prop, "" ); },
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		do {

			// If previous iteration zeroed out, double until we get *something*.
			// Use string for doubling so we don't accidentally see scale as unchanged below
			scale = scale || ".5";

			// Adjust and apply
			initialInUnit = initialInUnit / scale;
			jQuery.style( elem, prop, initialInUnit + unit );

		// Update scale, tolerating zero or NaN from tween.cur()
		// Break the loop if scale is unchanged or perfect, or if we've just had enough.
		} while (
			scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
		);
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([\w:-]+)/ );

var rscriptType = ( /^$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE9
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE9
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE9-11+
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret = typeof context.getElementsByTagName !== "undefined" ?
			context.getElementsByTagName( tag || "*" ) :
			typeof context.querySelectorAll !== "undefined" ?
				context.querySelectorAll( tag || "*" ) :
			[];

	return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
		jQuery.merge( [ context ], ret ) :
		ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( jQuery.type( elem ) === "object" ) {

				// Support: Android<4.1, PhantomJS<2
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android<4.1, PhantomJS<2
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0-4.3, Safari<=5.1
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Safari<=5.1, Android<4.2
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE<=11+
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();


var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE9
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( event ) {

		// Make a writable jQuery.Event from the native event object
		event = jQuery.event.fix( event );

		var i, j, ret, matched, handleObj,
			handlerQueue = [],
			args = slice.call( arguments ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;
		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, matches, sel, handleObj,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Support (at least): Chrome, IE9
		// Find delegate handlers
		// Black-hole SVG <use> instance trees (#13180)
		//
		// Support: Firefox<=42+
		// Avoid non-left-click in FF but don't block IE radio events (#3861, gh-2343)
		if ( delegateCount && cur.nodeType &&
			( event.type !== "click" || isNaN( event.button ) || event.button < 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && ( cur.disabled !== true || event.type !== "click" ) ) {
					matches = [];
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matches[ sel ] === undefined ) {
							matches[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matches[ sel ] ) {
							matches.push( handleObj );
						}
					}
					if ( matches.length ) {
						handlerQueue.push( { elem: cur, handlers: matches } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: this, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	// Includes some event props shared by KeyEvent and MouseEvent
	props: ( "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase " +
		"metaKey relatedTarget shiftKey target timeStamp view which" ).split( " " ),

	fixHooks: {},

	keyHooks: {
		props: "char charCode key keyCode".split( " " ),
		filter: function( event, original ) {

			// Add which for key events
			if ( event.which == null ) {
				event.which = original.charCode != null ? original.charCode : original.keyCode;
			}

			return event;
		}
	},

	mouseHooks: {
		props: ( "button buttons clientX clientY offsetX offsetY pageX pageY " +
			"screenX screenY toElement" ).split( " " ),
		filter: function( event, original ) {
			var eventDoc, doc, body,
				button = original.button;

			// Calculate pageX/Y if missing and clientX/Y available
			if ( event.pageX == null && original.clientX != null ) {
				eventDoc = event.target.ownerDocument || document;
				doc = eventDoc.documentElement;
				body = eventDoc.body;

				event.pageX = original.clientX +
					( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) -
					( doc && doc.clientLeft || body && body.clientLeft || 0 );
				event.pageY = original.clientY +
					( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) -
					( doc && doc.clientTop  || body && body.clientTop  || 0 );
			}

			// Add which for click: 1 === left; 2 === middle; 3 === right
			// Note: button is not normalized, so don't use it
			if ( !event.which && button !== undefined ) {
				event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
			}

			return event;
		}
	},

	fix: function( event ) {
		if ( event[ jQuery.expando ] ) {
			return event;
		}

		// Create a writable copy of the event object and normalize some properties
		var i, prop, copy,
			type = event.type,
			originalEvent = event,
			fixHook = this.fixHooks[ type ];

		if ( !fixHook ) {
			this.fixHooks[ type ] = fixHook =
				rmouseEvent.test( type ) ? this.mouseHooks :
				rkeyEvent.test( type ) ? this.keyHooks :
				{};
		}
		copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;

		event = new jQuery.Event( originalEvent );

		i = copy.length;
		while ( i-- ) {
			prop = copy[ i ];
			event[ prop ] = originalEvent[ prop ];
		}

		// Support: Cordova 2.5 (WebKit) (#13255)
		// All events should have a target; Cordova deviceready doesn't
		if ( !event.target ) {
			event.target = document;
		}

		// Support: Safari 6.0+, Chrome<28
		// Target should not be a text node (#504, #13143)
		if ( event.target.nodeType === 3 ) {
			event.target = event.target.parentNode;
		}

		return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return jQuery.nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android<4.0
				src.returnValue === false ?
			returnTrue :
			returnFalse;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://code.google.com/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {
	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,

	// Support: IE 10-11, Edge 10240+
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Manipulating tables requires a tbody
function manipulationTarget( elem, content ) {
	return jQuery.nodeName( elem, "table" ) &&
		jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?

		elem.getElementsByTagName( "tbody" )[ 0 ] ||
			elem.appendChild( elem.ownerDocument.createElement( "tbody" ) ) :
		elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );

	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		isFunction = jQuery.isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( isFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( isFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android<4.1, PhantomJS<2
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <= 35-45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <= 35-45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {

	// Keep domManip exposed until 3.0 (gh-2225)
	domManip: domManip,

	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: QtWebKit
			// .get() because push.apply(_, arraylike) throws
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );


var iframe,
	elemdisplay = {

		// Support: Firefox
		// We have to pre-define these values for FF (#10227)
		HTML: "block",
		BODY: "block"
	};

/**
 * Retrieve the actual display of a element
 * @param {String} name nodeName of the element
 * @param {Object} doc Document object
 */

// Called only from within defaultDisplay
function actualDisplay( name, doc ) {
	var elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),

		display = jQuery.css( elem[ 0 ], "display" );

	// We don't have any data stored on the element,
	// so use "detach" method as fast way to get rid of the element
	elem.detach();

	return display;
}

/**
 * Try to determine the default display value of an element
 * @param {String} nodeName
 */
function defaultDisplay( nodeName ) {
	var doc = document,
		display = elemdisplay[ nodeName ];

	if ( !display ) {
		display = actualDisplay( nodeName, doc );

		// If the simple way fails, read from inside an iframe
		if ( display === "none" || !display ) {

			// Use the already-created iframe if possible
			iframe = ( iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" ) )
				.appendTo( doc.documentElement );

			// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
			doc = iframe[ 0 ].contentDocument;

			// Support: IE
			doc.write();
			doc.close();

			display = actualDisplay( nodeName, doc );
			iframe.detach();
		}

		// Store the correct default display
		elemdisplay[ nodeName ] = display;
	}

	return display;
}
var rmargin = ( /^margin/ );

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var documentElement = document.documentElement;



( function() {
	var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE9-11+
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
		"padding:0;margin-top:1px;position:absolute";
	container.appendChild( div );

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {
		div.style.cssText =

			// Support: Firefox<29, Android 2.3
			// Vendor-prefix box-sizing
			"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;" +
			"position:relative;display:block;" +
			"margin:auto;border:1px;padding:1px;" +
			"top:1%;width:50%";
		div.innerHTML = "";
		documentElement.appendChild( container );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";
		reliableMarginLeftVal = divStyle.marginLeft === "2px";
		boxSizingReliableVal = divStyle.width === "4px";

		// Support: Android 4.0 - 4.3 only
		// Some styles come back with percentage values, even though they shouldn't
		div.style.marginRight = "50%";
		pixelMarginRightVal = divStyle.marginRight === "4px";

		documentElement.removeChild( container );
	}

	jQuery.extend( support, {
		pixelPosition: function() {

			// This test is executed only once but we still do memoizing
			// since we can use the boxSizingReliable pre-computing.
			// No need to check if the test was already performed, though.
			computeStyleTests();
			return pixelPositionVal;
		},
		boxSizingReliable: function() {
			if ( boxSizingReliableVal == null ) {
				computeStyleTests();
			}
			return boxSizingReliableVal;
		},
		pixelMarginRight: function() {

			// Support: Android 4.0-4.3
			// We're checking for boxSizingReliableVal here instead of pixelMarginRightVal
			// since that compresses better and they're computed together anyway.
			if ( boxSizingReliableVal == null ) {
				computeStyleTests();
			}
			return pixelMarginRightVal;
		},
		reliableMarginLeft: function() {

			// Support: IE <=8 only, Android 4.0 - 4.3 only, Firefox <=3 - 37
			if ( boxSizingReliableVal == null ) {
				computeStyleTests();
			}
			return reliableMarginLeftVal;
		},
		reliableMarginRight: function() {

			// Support: Android 2.3
			// Check if div with explicit width and no margin-right incorrectly
			// gets computed margin-right based on width of container. (#3333)
			// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
			// This support function is only executed once so no memoizing is needed.
			var ret,
				marginDiv = div.appendChild( document.createElement( "div" ) );

			// Reset CSS: box-sizing; display; margin; border; padding
			marginDiv.style.cssText = div.style.cssText =

				// Support: Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:content-box;box-sizing:content-box;" +
				"display:block;margin:0;border:0;padding:0";
			marginDiv.style.marginRight = marginDiv.style.width = "0";
			div.style.width = "1px";
			documentElement.appendChild( container );

			ret = !parseFloat( window.getComputedStyle( marginDiv ).marginRight );

			documentElement.removeChild( container );
			div.removeChild( marginDiv );

			return ret;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		style = elem.style;

	computed = computed || getStyles( elem );
	ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined;

	// Support: Opera 12.1x only
	// Fall back to style even without computed
	// computed is undefined for elems on document fragments
	if ( ( ret === "" || ret === undefined ) && !jQuery.contains( elem.ownerDocument, elem ) ) {
		ret = jQuery.style( elem, name );
	}

	// Support: IE9
	// getPropertyValue is only needed for .css('filter') (#12537)
	if ( computed ) {

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// http://dev.w3.org/csswg/cssom/#resolved-values
		if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE9-11+
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,

	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "O", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i = extra === ( isBorderBox ? "border" : "content" ) ?

		// If we already have the right measurement, avoid augmentation
		4 :

		// Otherwise initialize for horizontal or vertical properties
		name === "width" ? 1 : 0,

		val = 0;

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {

			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// At this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {

			// At this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// At this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with offset property, which is equivalent to the border-box value
	var valueIsBorderBox = true,
		val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
		styles = getStyles( elem ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// Some non-html elements return undefined for offsetWidth, so check for null/undefined
	// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
	// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
	if ( val <= 0 || val == null ) {

		// Fall back to computed then uncomputed css if necessary
		val = curCSS( elem, name, styles );
		if ( val < 0 || val == null ) {
			val = elem.style[ name ];
		}

		// Computed unit is not pixels. Stop here and return.
		if ( rnumnonpx.test( val ) ) {
			return val;
		}

		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = isBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ name ] );

		// Normalize "", auto, and prepare for extra
		val = parseFloat( val ) || 0;
	}

	// Use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

function showHide( elements, show ) {
	var display, elem, hidden,
		values = [],
		index = 0,
		length = elements.length;

	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		values[ index ] = dataPriv.get( elem, "olddisplay" );
		display = elem.style.display;
		if ( show ) {

			// Reset the inline display of this element to learn if it is
			// being hidden by cascaded rules or not
			if ( !values[ index ] && display === "none" ) {
				elem.style.display = "";
			}

			// Set elements which have been overridden with display: none
			// in a stylesheet to whatever the default browser style is
			// for such an element
			if ( elem.style.display === "" && isHidden( elem ) ) {
				values[ index ] = dataPriv.access(
					elem,
					"olddisplay",
					defaultDisplay( elem.nodeName )
				);
			}
		} else {
			hidden = isHidden( elem );

			if ( display !== "none" || !hidden ) {
				dataPriv.set(
					elem,
					"olddisplay",
					hidden ? display : jQuery.css( elem, "display" )
				);
			}
		}
	}

	// Set the display of most of the elements in a second loop
	// to avoid the constant reflow
	for ( index = 0; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}
		if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
			elem.style.display = show ? values[ index ] || "" : "none";
		}
	}

	return elements;
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		"float": "cssFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			style = elem.style;

		name = jQuery.cssProps[ origName ] ||
			( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// Support: IE9-11+
			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				style[ name ] = value;
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = jQuery.camelCase( name );

		// Make sure that we're working with the right name
		name = jQuery.cssProps[ origName ] ||
			( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}
		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
					elem.offsetWidth === 0 ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						} ) :
						getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = extra && getStyles( elem ),
				subtract = extra && augmentWidthOrHeight(
					elem,
					name,
					extra,
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				);

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ name ] = value;
				value = jQuery.css( elem, name );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// Support: Android 2.3
jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
	function( elem, computed ) {
		if ( computed ) {
			return swap( elem, { "display": "inline-block" },
				curCSS, [ elem, "marginRight" ] );
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( jQuery.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	},
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHidden( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE9
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back Compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, timerId,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4 ; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	/* jshint validthis: true */
	var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHidden( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Handle queue: false promises
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Height/width overflow pass
	if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {

		// Make sure that nothing sneaks out
		// Record all 3 overflow attributes because IE9-10 do not
		// change the overflow attribute when overflowX and
		// overflowY are set to the same value
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Set display property to inline-block for height/width
		// animations on inline elements that are having width/height animated
		display = jQuery.css( elem, "display" );

		// Test default display if display is currently "none"
		checkDisplay = display === "none" ?
			dataPriv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;

		if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
			style.display = "inline-block";
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// show/hide pass
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.exec( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// If there is dataShow left over from a stopped hide or show
				// and we are going to proceed with show, we should pretend to be hidden
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );

		// Any non-fx value stops us from restoring the original display value
		} else {
			display = undefined;
		}
	}

	if ( !jQuery.isEmptyObject( orig ) ) {
		if ( dataShow ) {
			if ( "hidden" in dataShow ) {
				hidden = dataShow.hidden;
			}
		} else {
			dataShow = dataPriv.access( elem, "fxshow", {} );
		}

		// Store state if its toggle - enables .stop().toggle() to "reverse"
		if ( toggle ) {
			dataShow.hidden = !hidden;
		}
		if ( hidden ) {
			jQuery( elem ).show();
		} else {
			anim.done( function() {
				jQuery( elem ).hide();
			} );
		}
		anim.done( function() {
			var prop;

			dataPriv.remove( elem, "fxshow" );
			for ( prop in orig ) {
				jQuery.style( elem, prop, orig[ prop ] );
			}
		} );
		for ( prop in orig ) {
			tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );

			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = tween.start;
				if ( hidden ) {
					tween.end = tween.start;
					tween.start = prop === "width" || prop === "height" ? 1 : 0;
				}
			}
		}

	// If this is a noop like .hide().hide(), restore an overwritten display value
	} else if ( ( display === "none" ? defaultDisplay( elem.nodeName ) : display ) === "inline" ) {
		style.display = display;
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( jQuery.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length ; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			if ( percent < 1 && length ) {
				return remaining;
			} else {
				deferred.resolveWith( elem, [ animation ] );
				return false;
			}
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length ; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( jQuery.isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					jQuery.proxy( result.stop, result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	// attach callbacks from options
	return animation.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );
}

jQuery.Animation = jQuery.extend( Animation, {
	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnotwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length ; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ?
		opt.duration : opt.duration in jQuery.fx.speeds ?
			jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHidden ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Checks the timer has not already been removed
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	if ( timer() ) {
		jQuery.fx.start();
	} else {
		jQuery.timers.pop();
	}
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( !timerId ) {
		timerId = window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
	}
};

jQuery.fx.stop = function() {
	window.clearInterval( timerId );

	timerId = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// http://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: iOS<=5.1, Android<=4.2+
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE<=11+
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: Android<=2.3
	// Options inside disabled selects are incorrectly marked as disabled
	select.disabled = true;
	support.optDisabled = !opt.disabled;

	// Support: IE<=11+
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// All attributes are lowercase
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			name = name.toLowerCase();
			hooks = jQuery.attrHooks[ name ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					jQuery.nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name, propName,
			i = 0,
			attrNames = value && value.match( rnotwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				propName = jQuery.propFix[ name ] || name;

				// Boolean attributes get special treatment (#10870)
				if ( jQuery.expr.match.bool.test( name ) ) {

					// Set corresponding property to false
					elem[ propName ] = false;
				}

				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};
jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle;
		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ name ];
			attrHandle[ name ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				name.toLowerCase() :
				null;
			attrHandle[ name ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				return tabindex ?
					parseInt( tabindex, 10 ) :
					rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) && elem.href ?
							0 :
							-1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {
			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {
			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




var rclass = /[\t\r\n\f]/g;

function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnotwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 &&
					( " " + curValue + " " ).replace( rclass, " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = jQuery.trim( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnotwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 &&
					( " " + curValue + " " ).replace( rclass, " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = jQuery.trim( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( type === "string" ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = value.match( rnotwhite ) || [];

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + getClass( elem ) + " " ).replace( rclass, " " )
					.indexOf( className ) > -1
			) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g,
	rspaces = /[\x20\t\r\n\f]+/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				return typeof ret === "string" ?

					// Handle most common string cases
					ret.replace( rreturn, "" ) :

					// Handle cases where value is null/undef or number
					ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( jQuery.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE10-11+
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					jQuery.trim( jQuery.text( elem ) ).replace( rspaces, " " );
			}
		},
		select: {
			get: function( elem ) {
				var value, option,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one" || index < 0,
					values = one ? null : [],
					max = one ? index + 1 : options.length,
					i = index < 0 ?
						max :
						one ? index : 0;

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							( support.optDisabled ?
								!option.disabled : option.getAttribute( "disabled" ) === null ) &&
							( !option.parentNode.disabled ||
								!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];
					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( jQuery.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					elem[ type ]();
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


jQuery.each( ( "blur focus focusin focusout load resize scroll unload click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup error contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




support.focusin = "onfocusin" in window;


// Support: Firefox
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome, Safari
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://code.google.com/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = jQuery.now();

var rquery = ( /\?/ );



// Support: Android 2.3
// Workaround failure to string-cast null input
jQuery.parseJSON = function( data ) {
	return JSON.parse( data + "" );
};


// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE9
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rhash = /#.*$/,
	rts = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];

		if ( jQuery.isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

		// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",
		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": jQuery.parseJSON,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// The jqXHR state
			state = 0,

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( state === 2 ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return state === 2 ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					var lname = name.toLowerCase();
					if ( !state ) {
						name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( !state ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( state < 2 ) {
							for ( code in map ) {

								// Lazy-add the new callback in a way that preserves old ones
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						} else {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR ).complete = completeDeferred.add;
		jqXHR.success = jqXHR.done;
		jqXHR.error = jqXHR.fail;

		// Remove hash character (#7531: and string promotion)
		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" ).replace( rhash, "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE8-11+
			// IE throws exception if url is malformed, e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE8-11+
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( state === 2 ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		cacheURL = s.url;

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add anti-cache in url if needed
			if ( s.cache === false ) {
				s.url = rts.test( cacheURL ) ?

					// If there is already a '_' parameter, set its value
					cacheURL.replace( rts, "$1_=" + nonce++ ) :

					// Otherwise add one to the end
					cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
			}
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		for ( i in { success: 1, error: 1, complete: 1 } ) {
			jqXHR[ i ]( s[ i ] );
		}

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( state === 2 ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				state = 1;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Propagate exception as error if not done
				if ( state < 2 ) {
					done( -1, e );

				// Simply rethrow otherwise
				} else {
					throw e;
				}
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Called once
			if ( state === 2 ) {
				return;
			}

			// State is "done" now
			state = 2;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapAll( html.call( this, i ) );
			} );
		}

		if ( this[ 0 ] ) {

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function() {
		return this.parent().each( function() {
			if ( !jQuery.nodeName( this, "body" ) ) {
				jQuery( this ).replaceWith( this.childNodes );
			}
		} ).end();
	}
} );


jQuery.expr.filters.hidden = function( elem ) {
	return !jQuery.expr.filters.visible( elem );
};
jQuery.expr.filters.visible = function( elem ) {

	// Support: Opera <= 12.12
	// Opera reports offsetWidths and offsetHeights less than zero on some elements
	// Use OR instead of AND as the element is not visible if either is true
	// See tickets #10406 and #13132
	return elem.offsetWidth > 0 || elem.offsetHeight > 0 || elem.getClientRects().length > 0;
};




var r20 = /%20/g,
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( jQuery.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, value ) {

			// If value is a function, invoke it and return its value
			value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
			s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
		};

	// Set traditional to true for jQuery <= 1.3.2 behavior.
	if ( traditional === undefined ) {
		traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" ).replace( r20, "+" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			return val == null ?
				null :
				jQuery.isArray( val ) ?
					jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} ) :
					{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE9
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE9
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = callback( "error" );

				// Support: IE9
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( !data || typeof data !== "string" ) {
		return null;
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}
	context = context || document;

	var parsed = rsingleTag.exec( data ),
		scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


// Keep a copy of the old load method
var _load = jQuery.fn.load;

/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	if ( typeof url !== "string" && _load ) {
		return _load.apply( this, arguments );
	}

	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = jQuery.trim( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.filters.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




/**
 * Gets a window from an element
 */
function getWindow( elem ) {
	return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
}

jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {
	offset: function( options ) {
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var docElem, win,
			elem = this[ 0 ],
			box = { top: 0, left: 0 },
			doc = elem && elem.ownerDocument;

		if ( !doc ) {
			return;
		}

		docElem = doc.documentElement;

		// Make sure it's not a disconnected DOM node
		if ( !jQuery.contains( docElem, elem ) ) {
			return box;
		}

		box = elem.getBoundingClientRect();
		win = getWindow( doc );
		return {
			top: box.top + win.pageYOffset - docElem.clientTop,
			left: box.left + win.pageXOffset - docElem.clientLeft
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
		// because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume getBoundingClientRect is there when computed position is fixed
			offset = elem.getBoundingClientRect();

		} else {

			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
			parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {
			var win = getWindow( elem );

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari<7-8+, Chrome<37-44+
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://code.google.com/p/chromium/issues/detail?id=229280
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {

					// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
					// isn't a whole lot we can do. See pull request at this URL for discussion:
					// https://github.com/jquery/jquery/pull/764
					return elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable, null );
		};
	} );
} );


jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},
	size: function() {
		return this.length;
	}
} );

jQuery.fn.andSelf = jQuery.fn.addBack;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}



var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}

return jQuery;
}));


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lightbox v2.9.0
 * by Lokesh Dhakar
 *
 * More info:
 * http://lokeshdhakar.com/projects/lightbox2/
 *
 * Copyright 2007, 2015 Lokesh Dhakar
 * Released under the MIT license
 * https://github.com/lokesh/lightbox2/blob/master/LICENSE
 */

// Uses Node, AMD or browser globals to create a module.
(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory(require('jquery'));
    } else {
        // Browser globals (root is window)
        root.lightbox = factory(root.jQuery);
    }
}(this, function ($) {

  function Lightbox(options) {
    this.album = [];
    this.currentImageIndex = void 0;
    this.init();

    // options
    this.options = $.extend({}, this.constructor.defaults);
    this.option(options);
  }

  // Descriptions of all options available on the demo site:
  // http://lokeshdhakar.com/projects/lightbox2/index.html#options
  Lightbox.defaults = {
    albumLabel: 'Image %1 of %2',
    alwaysShowNavOnTouchDevices: false,
    fadeDuration: 600,
    fitImagesInViewport: true,
    imageFadeDuration: 600,
    // maxWidth: 800,
    // maxHeight: 600,
    positionFromTop: 50,
    resizeDuration: 700,
    showImageNumberLabel: true,
    wrapAround: false,
    disableScrolling: false,
    /*
    Sanitize Title
    If the caption data is trusted, for example you are hardcoding it in, then leave this to false.
    This will free you to add html tags, such as links, in the caption.

    If the caption data is user submitted or from some other untrusted source, then set this to true
    to prevent xss and other injection attacks.
     */
    sanitizeTitle: false
  };

  Lightbox.prototype.option = function(options) {
    $.extend(this.options, options);
  };

  Lightbox.prototype.imageCountLabel = function(currentImageNum, totalImages) {
    return this.options.albumLabel.replace(/%1/g, currentImageNum).replace(/%2/g, totalImages);
  };

  Lightbox.prototype.init = function() {
    var self = this;
    // Both enable and build methods require the body tag to be in the DOM.
    $(document).ready(function() {
      self.enable();
      self.build();
    });
  };

  // Loop through anchors and areamaps looking for either data-lightbox attributes or rel attributes
  // that contain 'lightbox'. When these are clicked, start lightbox.
  Lightbox.prototype.enable = function() {
    var self = this;
    $('body').on('click', 'a[rel^=lightbox], area[rel^=lightbox], a[data-lightbox], area[data-lightbox]', function(event) {
      self.start($(event.currentTarget));
      return false;
    });
  };

  // Build html for the lightbox and the overlay.
  // Attach event handlers to the new DOM elements. click click click
  Lightbox.prototype.build = function() {
    var self = this;
    $('<div id="lightboxOverlay" class="lightboxOverlay"></div><div id="lightbox" class="lightbox"><div class="lb-outerContainer"><div class="lb-container"><img class="lb-image" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" /><div class="lb-nav"><a class="lb-prev" href="" ></a><a class="lb-next" href="" ></a></div><div class="lb-loader"><a class="lb-cancel"></a></div></div></div><div class="lb-dataContainer"><div class="lb-data"><div class="lb-details"><span class="lb-caption"></span><span class="lb-number"></span></div><div class="lb-closeContainer"><a class="lb-close"></a></div></div></div></div>').appendTo($('body'));

    // Cache jQuery objects
    this.$lightbox       = $('#lightbox');
    this.$overlay        = $('#lightboxOverlay');
    this.$outerContainer = this.$lightbox.find('.lb-outerContainer');
    this.$container      = this.$lightbox.find('.lb-container');
    this.$image          = this.$lightbox.find('.lb-image');
    this.$nav            = this.$lightbox.find('.lb-nav');

    // Store css values for future lookup
    this.containerPadding = {
      top: parseInt(this.$container.css('padding-top'), 10),
      right: parseInt(this.$container.css('padding-right'), 10),
      bottom: parseInt(this.$container.css('padding-bottom'), 10),
      left: parseInt(this.$container.css('padding-left'), 10)
    };

    this.imageBorderWidth = {
      top: parseInt(this.$image.css('border-top-width'), 10),
      right: parseInt(this.$image.css('border-right-width'), 10),
      bottom: parseInt(this.$image.css('border-bottom-width'), 10),
      left: parseInt(this.$image.css('border-left-width'), 10)
    };

    // Attach event handlers to the newly minted DOM elements
    this.$overlay.hide().on('click', function() {
      self.end();
      return false;
    });

    this.$lightbox.hide().on('click', function(event) {
      if ($(event.target).attr('id') === 'lightbox') {
        self.end();
      }
      return false;
    });

    this.$outerContainer.on('click', function(event) {
      if ($(event.target).attr('id') === 'lightbox') {
        self.end();
      }
      return false;
    });

    this.$lightbox.find('.lb-prev').on('click', function() {
      if (self.currentImageIndex === 0) {
        self.changeImage(self.album.length - 1);
      } else {
        self.changeImage(self.currentImageIndex - 1);
      }
      return false;
    });

    this.$lightbox.find('.lb-next').on('click', function() {
      if (self.currentImageIndex === self.album.length - 1) {
        self.changeImage(0);
      } else {
        self.changeImage(self.currentImageIndex + 1);
      }
      return false;
    });

    /*
      Show context menu for image on right-click

      There is a div containing the navigation that spans the entire image and lives above of it. If
      you right-click, you are right clicking this div and not the image. This prevents users from
      saving the image or using other context menu actions with the image.

      To fix this, when we detect the right mouse button is pressed down, but not yet clicked, we
      set pointer-events to none on the nav div. This is so that the upcoming right-click event on
      the next mouseup will bubble down to the image. Once the right-click/contextmenu event occurs
      we set the pointer events back to auto for the nav div so it can capture hover and left-click
      events as usual.
     */
    this.$nav.on('mousedown', function(event) {
      if (event.which === 3) {
        self.$nav.css('pointer-events', 'none');

        self.$lightbox.one('contextmenu', function() {
          setTimeout(function() {
              this.$nav.css('pointer-events', 'auto');
          }.bind(self), 0);
        });
      }
    });


    this.$lightbox.find('.lb-loader, .lb-close').on('click', function() {
      self.end();
      return false;
    });
  };

  // Show overlay and lightbox. If the image is part of a set, add siblings to album array.
  Lightbox.prototype.start = function($link) {
    var self    = this;
    var $window = $(window);

    $window.on('resize', $.proxy(this.sizeOverlay, this));

    $('select, object, embed').css({
      visibility: 'hidden'
    });

    this.sizeOverlay();

    this.album = [];
    var imageNumber = 0;

    function addToAlbum($link) {
      self.album.push({
        link: $link.attr('href'),
        title: $link.attr('data-title') || $link.attr('title')
      });
    }

    // Support both data-lightbox attribute and rel attribute implementations
    var dataLightboxValue = $link.attr('data-lightbox');
    var $links;

    if (dataLightboxValue) {
      $links = $($link.prop('tagName') + '[data-lightbox="' + dataLightboxValue + '"]');
      for (var i = 0; i < $links.length; i = ++i) {
        addToAlbum($($links[i]));
        if ($links[i] === $link[0]) {
          imageNumber = i;
        }
      }
    } else {
      if ($link.attr('rel') === 'lightbox') {
        // If image is not part of a set
        addToAlbum($link);
      } else {
        // If image is part of a set
        $links = $($link.prop('tagName') + '[rel="' + $link.attr('rel') + '"]');
        for (var j = 0; j < $links.length; j = ++j) {
          addToAlbum($($links[j]));
          if ($links[j] === $link[0]) {
            imageNumber = j;
          }
        }
      }
    }

    // Position Lightbox
    var top  = $window.scrollTop() + this.options.positionFromTop;
    var left = $window.scrollLeft();
    this.$lightbox.css({
      top: top + 'px',
      left: left + 'px'
    }).fadeIn(this.options.fadeDuration);

    // Disable scrolling of the page while open
    if (this.options.disableScrolling) {
      $('body').addClass('lb-disable-scrolling');
    }

    this.changeImage(imageNumber);
  };

  // Hide most UI elements in preparation for the animated resizing of the lightbox.
  Lightbox.prototype.changeImage = function(imageNumber) {
    var self = this;

    this.disableKeyboardNav();
    var $image = this.$lightbox.find('.lb-image');

    this.$overlay.fadeIn(this.options.fadeDuration);

    $('.lb-loader').fadeIn('slow');
    this.$lightbox.find('.lb-image, .lb-nav, .lb-prev, .lb-next, .lb-dataContainer, .lb-numbers, .lb-caption').hide();

    this.$outerContainer.addClass('animating');

    // When image to show is preloaded, we send the width and height to sizeContainer()
    var preloader = new Image();
    preloader.onload = function() {
      var $preloader;
      var imageHeight;
      var imageWidth;
      var maxImageHeight;
      var maxImageWidth;
      var windowHeight;
      var windowWidth;

      $image.attr('src', self.album[imageNumber].link);

      $preloader = $(preloader);

      $image.width(preloader.width);
      $image.height(preloader.height);

      if (self.options.fitImagesInViewport) {
        // Fit image inside the viewport.
        // Take into account the border around the image and an additional 10px gutter on each side.

        windowWidth    = $(window).width();
        windowHeight   = $(window).height();
        maxImageWidth  = windowWidth - self.containerPadding.left - self.containerPadding.right - self.imageBorderWidth.left - self.imageBorderWidth.right - 20;
        maxImageHeight = windowHeight - self.containerPadding.top - self.containerPadding.bottom - self.imageBorderWidth.top - self.imageBorderWidth.bottom - 120;

        // Check if image size is larger then maxWidth|maxHeight in settings
        if (self.options.maxWidth && self.options.maxWidth < maxImageWidth) {
          maxImageWidth = self.options.maxWidth;
        }
        if (self.options.maxHeight && self.options.maxHeight < maxImageWidth) {
          maxImageHeight = self.options.maxHeight;
        }

        // Is there a fitting issue?
        if ((preloader.width > maxImageWidth) || (preloader.height > maxImageHeight)) {
          if ((preloader.width / maxImageWidth) > (preloader.height / maxImageHeight)) {
            imageWidth  = maxImageWidth;
            imageHeight = parseInt(preloader.height / (preloader.width / imageWidth), 10);
            $image.width(imageWidth);
            $image.height(imageHeight);
          } else {
            imageHeight = maxImageHeight;
            imageWidth = parseInt(preloader.width / (preloader.height / imageHeight), 10);
            $image.width(imageWidth);
            $image.height(imageHeight);
          }
        }
      }
      self.sizeContainer($image.width(), $image.height());
    };

    preloader.src          = this.album[imageNumber].link;
    this.currentImageIndex = imageNumber;
  };

  // Stretch overlay to fit the viewport
  Lightbox.prototype.sizeOverlay = function() {
    this.$overlay
      .width($(document).width())
      .height($(document).height());
  };

  // Animate the size of the lightbox to fit the image we are showing
  Lightbox.prototype.sizeContainer = function(imageWidth, imageHeight) {
    var self = this;

    var oldWidth  = this.$outerContainer.outerWidth();
    var oldHeight = this.$outerContainer.outerHeight();
    var newWidth  = imageWidth + this.containerPadding.left + this.containerPadding.right + this.imageBorderWidth.left + this.imageBorderWidth.right;
    var newHeight = imageHeight + this.containerPadding.top + this.containerPadding.bottom + this.imageBorderWidth.top + this.imageBorderWidth.bottom;

    function postResize() {
      self.$lightbox.find('.lb-dataContainer').width(newWidth);
      self.$lightbox.find('.lb-prevLink').height(newHeight);
      self.$lightbox.find('.lb-nextLink').height(newHeight);
      self.showImage();
    }

    if (oldWidth !== newWidth || oldHeight !== newHeight) {
      this.$outerContainer.animate({
        width: newWidth,
        height: newHeight
      }, this.options.resizeDuration, 'swing', function() {
        postResize();
      });
    } else {
      postResize();
    }
  };

  // Display the image and its details and begin preload neighboring images.
  Lightbox.prototype.showImage = function() {
    this.$lightbox.find('.lb-loader').stop(true).hide();
    this.$lightbox.find('.lb-image').fadeIn(this.options.imageFadeDuration);

    this.updateNav();
    this.updateDetails();
    this.preloadNeighboringImages();
    this.enableKeyboardNav();
  };

  // Display previous and next navigation if appropriate.
  Lightbox.prototype.updateNav = function() {
    // Check to see if the browser supports touch events. If so, we take the conservative approach
    // and assume that mouse hover events are not supported and always show prev/next navigation
    // arrows in image sets.
    var alwaysShowNav = false;
    try {
      document.createEvent('TouchEvent');
      alwaysShowNav = (this.options.alwaysShowNavOnTouchDevices) ? true : false;
    } catch (e) {}

    this.$lightbox.find('.lb-nav').show();

    if (this.album.length > 1) {
      if (this.options.wrapAround) {
        if (alwaysShowNav) {
          this.$lightbox.find('.lb-prev, .lb-next').css('opacity', '1');
        }
        this.$lightbox.find('.lb-prev, .lb-next').show();
      } else {
        if (this.currentImageIndex > 0) {
          this.$lightbox.find('.lb-prev').show();
          if (alwaysShowNav) {
            this.$lightbox.find('.lb-prev').css('opacity', '1');
          }
        }
        if (this.currentImageIndex < this.album.length - 1) {
          this.$lightbox.find('.lb-next').show();
          if (alwaysShowNav) {
            this.$lightbox.find('.lb-next').css('opacity', '1');
          }
        }
      }
    }
  };

  // Display caption, image number, and closing button.
  Lightbox.prototype.updateDetails = function() {
    var self = this;

    // Enable anchor clicks in the injected caption html.
    // Thanks Nate Wright for the fix. @https://github.com/NateWr
    if (typeof this.album[this.currentImageIndex].title !== 'undefined' &&
      this.album[this.currentImageIndex].title !== '') {
      var $caption = this.$lightbox.find('.lb-caption');
      if (this.options.sanitizeTitle) {
        $caption.text(this.album[this.currentImageIndex].title);
      } else {
        $caption.html(this.album[this.currentImageIndex].title);
      }
      $caption.fadeIn('fast')
        .find('a').on('click', function(event) {
          if ($(this).attr('target') !== undefined) {
            window.open($(this).attr('href'), $(this).attr('target'));
          } else {
            location.href = $(this).attr('href');
          }
        });
    }

    if (this.album.length > 1 && this.options.showImageNumberLabel) {
      var labelText = this.imageCountLabel(this.currentImageIndex + 1, this.album.length);
      this.$lightbox.find('.lb-number').text(labelText).fadeIn('fast');
    } else {
      this.$lightbox.find('.lb-number').hide();
    }

    this.$outerContainer.removeClass('animating');

    this.$lightbox.find('.lb-dataContainer').fadeIn(this.options.resizeDuration, function() {
      return self.sizeOverlay();
    });
  };

  // Preload previous and next images in set.
  Lightbox.prototype.preloadNeighboringImages = function() {
    if (this.album.length > this.currentImageIndex + 1) {
      var preloadNext = new Image();
      preloadNext.src = this.album[this.currentImageIndex + 1].link;
    }
    if (this.currentImageIndex > 0) {
      var preloadPrev = new Image();
      preloadPrev.src = this.album[this.currentImageIndex - 1].link;
    }
  };

  Lightbox.prototype.enableKeyboardNav = function() {
    $(document).on('keyup.keyboard', $.proxy(this.keyboardAction, this));
  };

  Lightbox.prototype.disableKeyboardNav = function() {
    $(document).off('.keyboard');
  };

  Lightbox.prototype.keyboardAction = function(event) {
    var KEYCODE_ESC        = 27;
    var KEYCODE_LEFTARROW  = 37;
    var KEYCODE_RIGHTARROW = 39;

    var keycode = event.keyCode;
    var key     = String.fromCharCode(keycode).toLowerCase();
    if (keycode === KEYCODE_ESC || key.match(/x|o|c/)) {
      this.end();
    } else if (key === 'p' || keycode === KEYCODE_LEFTARROW) {
      if (this.currentImageIndex !== 0) {
        this.changeImage(this.currentImageIndex - 1);
      } else if (this.options.wrapAround && this.album.length > 1) {
        this.changeImage(this.album.length - 1);
      }
    } else if (key === 'n' || keycode === KEYCODE_RIGHTARROW) {
      if (this.currentImageIndex !== this.album.length - 1) {
        this.changeImage(this.currentImageIndex + 1);
      } else if (this.options.wrapAround && this.album.length > 1) {
        this.changeImage(0);
      }
    }
  };

  // Closing time. :-(
  Lightbox.prototype.end = function() {
    this.disableKeyboardNav();
    $(window).off('resize', this.sizeOverlay);
    this.$lightbox.fadeOut(this.options.fadeDuration);
    this.$overlay.fadeOut(this.options.fadeDuration);
    $('select, object, embed').css({
      visibility: 'visible'
    });
    if (this.options.disableScrolling) {
      $('body').removeClass('lb-disable-scrolling');
    }
  };

  return new Lightbox();
}));


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3), __webpack_require__(5)(module)))

/***/ }),
/* 429 */
/***/ (function(module, exports) {

/* ng-infinite-scroll - v1.3.0 - 2016-06-30 */
angular.module('infinite-scroll', []).value('THROTTLE_MILLISECONDS', null).directive('infiniteScroll', [
  '$rootScope', '$window', '$interval', 'THROTTLE_MILLISECONDS', function($rootScope, $window, $interval, THROTTLE_MILLISECONDS) {
    return {
      scope: {
        infiniteScroll: '&',
        infiniteScrollContainer: '=',
        infiniteScrollDistance: '=',
        infiniteScrollDisabled: '=',
        infiniteScrollUseDocumentBottom: '=',
        infiniteScrollListenForEvent: '@'
      },
      link: function(scope, elem, attrs) {
        var changeContainer, checkInterval, checkWhenEnabled, container, handleInfiniteScrollContainer, handleInfiniteScrollDisabled, handleInfiniteScrollDistance, handleInfiniteScrollUseDocumentBottom, handler, height, immediateCheck, offsetTop, pageYOffset, scrollDistance, scrollEnabled, throttle, unregisterEventListener, useDocumentBottom, windowElement;
        windowElement = angular.element($window);
        scrollDistance = null;
        scrollEnabled = null;
        checkWhenEnabled = null;
        container = null;
        immediateCheck = true;
        useDocumentBottom = false;
        unregisterEventListener = null;
        checkInterval = false;
        height = function(elem) {
          elem = elem[0] || elem;
          if (isNaN(elem.offsetHeight)) {
            return elem.document.documentElement.clientHeight;
          } else {
            return elem.offsetHeight;
          }
        };
        offsetTop = function(elem) {
          if (!elem[0].getBoundingClientRect || elem.css('none')) {
            return;
          }
          return elem[0].getBoundingClientRect().top + pageYOffset(elem);
        };
        pageYOffset = function(elem) {
          elem = elem[0] || elem;
          if (isNaN(window.pageYOffset)) {
            return elem.document.documentElement.scrollTop;
          } else {
            return elem.ownerDocument.defaultView.pageYOffset;
          }
        };
        handler = function() {
          var containerBottom, containerTopOffset, elementBottom, remaining, shouldScroll;
          if (container === windowElement) {
            containerBottom = height(container) + pageYOffset(container[0].document.documentElement);
            elementBottom = offsetTop(elem) + height(elem);
          } else {
            containerBottom = height(container);
            containerTopOffset = 0;
            if (offsetTop(container) !== void 0) {
              containerTopOffset = offsetTop(container);
            }
            elementBottom = offsetTop(elem) - containerTopOffset + height(elem);
          }
          if (useDocumentBottom) {
            elementBottom = height((elem[0].ownerDocument || elem[0].document).documentElement);
          }
          remaining = elementBottom - containerBottom;
          shouldScroll = remaining <= height(container) * scrollDistance + 1;
          if (shouldScroll) {
            checkWhenEnabled = true;
            if (scrollEnabled) {
              if (scope.$$phase || $rootScope.$$phase) {
                return scope.infiniteScroll();
              } else {
                return scope.$apply(scope.infiniteScroll);
              }
            }
          } else {
            if (checkInterval) {
              $interval.cancel(checkInterval);
            }
            return checkWhenEnabled = false;
          }
        };
        throttle = function(func, wait) {
          var later, previous, timeout;
          timeout = null;
          previous = 0;
          later = function() {
            previous = new Date().getTime();
            $interval.cancel(timeout);
            timeout = null;
            return func.call();
          };
          return function() {
            var now, remaining;
            now = new Date().getTime();
            remaining = wait - (now - previous);
            if (remaining <= 0) {
              $interval.cancel(timeout);
              timeout = null;
              previous = now;
              return func.call();
            } else {
              if (!timeout) {
                return timeout = $interval(later, remaining, 1);
              }
            }
          };
        };
        if (THROTTLE_MILLISECONDS != null) {
          handler = throttle(handler, THROTTLE_MILLISECONDS);
        }
        scope.$on('$destroy', function() {
          container.unbind('scroll', handler);
          if (unregisterEventListener != null) {
            unregisterEventListener();
            unregisterEventListener = null;
          }
          if (checkInterval) {
            return $interval.cancel(checkInterval);
          }
        });
        handleInfiniteScrollDistance = function(v) {
          return scrollDistance = parseFloat(v) || 0;
        };
        scope.$watch('infiniteScrollDistance', handleInfiniteScrollDistance);
        handleInfiniteScrollDistance(scope.infiniteScrollDistance);
        handleInfiniteScrollDisabled = function(v) {
          scrollEnabled = !v;
          if (scrollEnabled && checkWhenEnabled) {
            checkWhenEnabled = false;
            return handler();
          }
        };
        scope.$watch('infiniteScrollDisabled', handleInfiniteScrollDisabled);
        handleInfiniteScrollDisabled(scope.infiniteScrollDisabled);
        handleInfiniteScrollUseDocumentBottom = function(v) {
          return useDocumentBottom = v;
        };
        scope.$watch('infiniteScrollUseDocumentBottom', handleInfiniteScrollUseDocumentBottom);
        handleInfiniteScrollUseDocumentBottom(scope.infiniteScrollUseDocumentBottom);
        changeContainer = function(newContainer) {
          if (container != null) {
            container.unbind('scroll', handler);
          }
          container = newContainer;
          if (newContainer != null) {
            return container.bind('scroll', handler);
          }
        };
        changeContainer(windowElement);
        if (scope.infiniteScrollListenForEvent) {
          unregisterEventListener = $rootScope.$on(scope.infiniteScrollListenForEvent, handler);
        }
        handleInfiniteScrollContainer = function(newContainer) {
          if ((newContainer == null) || newContainer.length === 0) {
            return;
          }
          if (newContainer.nodeType && newContainer.nodeType === 1) {
            newContainer = angular.element(newContainer);
          } else if (typeof newContainer.append === 'function') {
            newContainer = angular.element(newContainer[newContainer.length - 1]);
          } else if (typeof newContainer === 'string') {
            newContainer = angular.element(document.querySelector(newContainer));
          }
          if (newContainer != null) {
            return changeContainer(newContainer);
          } else {
            throw new Error("invalid infinite-scroll-container attribute.");
          }
        };
        scope.$watch('infiniteScrollContainer', handleInfiniteScrollContainer);
        handleInfiniteScrollContainer(scope.infiniteScrollContainer || []);
        if (attrs.infiniteScrollParent != null) {
          changeContainer(angular.element(elem.parent()));
        }
        if (attrs.infiniteScrollImmediateCheck != null) {
          immediateCheck = scope.$eval(attrs.infiniteScrollImmediateCheck);
        }
        return checkInterval = $interval((function() {
          if (immediateCheck) {
            handler();
          }
          return $interval.cancel(checkInterval);
        }));
      }
    };
  }
]);

if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports) {
  module.exports = 'infinite-scroll';
}


/***/ }),
/* 430 */
/***/ (function(module, exports) {

/*! ngTagsInput v3.2.0 License: MIT */!function(){"use strict";var a={backspace:8,tab:9,enter:13,escape:27,space:32,up:38,down:40,left:37,right:39,"delete":46,comma:188},b=9007199254740991,c=["text","email","url"],d=angular.module("ngTagsInput",[]);d.directive("tagsInput",["$timeout","$document","$window","$q","tagsInputConfig","tiUtil",function(d,e,f,g,h,i){function j(a,b,c,d){var e,f,h,j,k={};return e=function(b){return i.safeToString(b[a.displayProperty])},f=function(b,c){b[a.displayProperty]=c},h=function(b){var d=e(b),f=d&&d.length>=a.minLength&&d.length<=a.maxLength&&a.allowedTagsPattern.test(d)&&!i.findInObjectArray(k.items,b,a.keyProperty||a.displayProperty);return g.when(f&&c({$tag:b})).then(i.promisifyValue)},j=function(a){return g.when(d({$tag:a})).then(i.promisifyValue)},k.items=[],k.addText=function(a){var b={};return f(b,a),k.add(b)},k.add=function(c){var d=e(c);return a.replaceSpacesWithDashes&&(d=i.replaceSpacesWithDashes(d)),f(c,d),h(c).then(function(){k.items.push(c),b.trigger("tag-added",{$tag:c})})["catch"](function(){d&&b.trigger("invalid-tag",{$tag:c})})},k.remove=function(a){var c=k.items[a];return j(c).then(function(){return k.items.splice(a,1),k.clearSelection(),b.trigger("tag-removed",{$tag:c}),c})},k.select=function(a){0>a?a=k.items.length-1:a>=k.items.length&&(a=0),k.index=a,k.selected=k.items[a]},k.selectPrior=function(){k.select(--k.index)},k.selectNext=function(){k.select(++k.index)},k.removeSelected=function(){return k.remove(k.index)},k.clearSelection=function(){k.selected=null,k.index=-1},k.getItems=function(){return a.useStrings?k.items.map(e):k.items},k.clearSelection(),k}function k(a){return-1!==c.indexOf(a)}return{restrict:"E",require:"ngModel",scope:{tags:"=ngModel",text:"=?",templateScope:"=?",tagClass:"&",onTagAdding:"&",onTagAdded:"&",onInvalidTag:"&",onTagRemoving:"&",onTagRemoved:"&",onTagClicked:"&"},replace:!1,transclude:!0,templateUrl:"ngTagsInput/tags-input.html",controller:["$scope","$attrs","$element",function(a,c,d){a.events=i.simplePubSub(),h.load("tagsInput",a,c,{template:[String,"ngTagsInput/tag-item.html"],type:[String,"text",k],placeholder:[String,"Add a tag"],tabindex:[Number,null],removeTagSymbol:[String,String.fromCharCode(215)],replaceSpacesWithDashes:[Boolean,!0],minLength:[Number,3],maxLength:[Number,b],addOnEnter:[Boolean,!0],addOnSpace:[Boolean,!1],addOnComma:[Boolean,!0],addOnBlur:[Boolean,!0],addOnPaste:[Boolean,!1],pasteSplitPattern:[RegExp,/,/],allowedTagsPattern:[RegExp,/.+/],enableEditingLastTag:[Boolean,!1],minTags:[Number,0],maxTags:[Number,b],displayProperty:[String,"text"],keyProperty:[String,""],allowLeftoverText:[Boolean,!1],addFromAutocompleteOnly:[Boolean,!1],spellcheck:[Boolean,!0],useStrings:[Boolean,!1]}),a.tagList=new j(a.options,a.events,i.handleUndefinedResult(a.onTagAdding,!0),i.handleUndefinedResult(a.onTagRemoving,!0)),this.registerAutocomplete=function(){d.find("input");return{addTag:function(b){return a.tagList.add(b)},getTags:function(){return a.tagList.items},getCurrentTagText:function(){return a.newTag.text()},getOptions:function(){return a.options},getTemplateScope:function(){return a.templateScope},on:function(b,c){return a.events.on(b,c,!0),this}}},this.registerTagItem=function(){return{getOptions:function(){return a.options},removeTag:function(b){a.disabled||a.tagList.remove(b)}}}}],link:function(b,c,g,h){var j,k,l=[a.enter,a.comma,a.space,a.backspace,a["delete"],a.left,a.right],m=b.tagList,n=b.events,o=b.options,p=c.find("input"),q=["minTags","maxTags","allowLeftoverText"];j=function(){h.$setValidity("maxTags",m.items.length<=o.maxTags),h.$setValidity("minTags",m.items.length>=o.minTags),h.$setValidity("leftoverText",b.hasFocus||o.allowLeftoverText?!0:!b.newTag.text())},k=function(){d(function(){p[0].focus()})},h.$isEmpty=function(a){return!a||!a.length},b.newTag={text:function(a){return angular.isDefined(a)?(b.text=a,void n.trigger("input-change",a)):b.text||""},invalid:null},b.track=function(a){return a[o.keyProperty||o.displayProperty]},b.getTagClass=function(a,c){var d=a===m.selected;return[b.tagClass({$tag:a,$index:c,$selected:d}),{selected:d}]},b.$watch("tags",function(a){if(a){if(m.items=i.makeObjectArray(a,o.displayProperty),o.useStrings)return;b.tags=m.items}else m.items=[]}),b.$watch("tags.length",function(){j(),h.$validate()}),g.$observe("disabled",function(a){b.disabled=a}),b.eventHandlers={input:{keydown:function(a){n.trigger("input-keydown",a)},focus:function(){b.hasFocus||(b.hasFocus=!0,n.trigger("input-focus"))},blur:function(){d(function(){var a=e.prop("activeElement"),d=a===p[0],f=c[0].contains(a);(d||!f)&&(b.hasFocus=!1,n.trigger("input-blur"))})},paste:function(a){a.getTextData=function(){var b=a.clipboardData||a.originalEvent&&a.originalEvent.clipboardData;return b?b.getData("text/plain"):f.clipboardData.getData("Text")},n.trigger("input-paste",a)}},host:{click:function(){b.disabled||k()}},tag:{click:function(a){n.trigger("tag-clicked",{$tag:a})}}},n.on("tag-added",b.onTagAdded).on("invalid-tag",b.onInvalidTag).on("tag-removed",b.onTagRemoved).on("tag-clicked",b.onTagClicked).on("tag-added",function(){b.newTag.text("")}).on("tag-added tag-removed",function(){b.tags=m.getItems(),h.$setDirty(),k()}).on("invalid-tag",function(){b.newTag.invalid=!0}).on("option-change",function(a){-1!==q.indexOf(a.name)&&j()}).on("input-change",function(){m.clearSelection(),b.newTag.invalid=null}).on("input-focus",function(){c.triggerHandler("focus"),h.$setValidity("leftoverText",!0)}).on("input-blur",function(){o.addOnBlur&&!o.addFromAutocompleteOnly&&m.addText(b.newTag.text()),c.triggerHandler("blur"),j()}).on("input-keydown",function(c){var d,e,f,g,h=c.keyCode,j={};i.isModifierOn(c)||-1===l.indexOf(h)||(j[a.enter]=o.addOnEnter,j[a.comma]=o.addOnComma,j[a.space]=o.addOnSpace,d=!o.addFromAutocompleteOnly&&j[h],e=(h===a.backspace||h===a["delete"])&&m.selected,g=h===a.backspace&&0===b.newTag.text().length&&o.enableEditingLastTag,f=(h===a.backspace||h===a.left||h===a.right)&&0===b.newTag.text().length&&!o.enableEditingLastTag,d?m.addText(b.newTag.text()):g?(m.selectPrior(),m.removeSelected().then(function(a){a&&b.newTag.text(a[o.displayProperty])})):e?m.removeSelected():f&&(h===a.left||h===a.backspace?m.selectPrior():h===a.right&&m.selectNext()),(d||f||e||g)&&c.preventDefault())}).on("input-paste",function(a){if(o.addOnPaste){var b=a.getTextData(),c=b.split(o.pasteSplitPattern);c.length>1&&(c.forEach(function(a){m.addText(a)}),a.preventDefault())}})}}}]),d.directive("tiTagItem",["tiUtil",function(a){return{restrict:"E",require:"^tagsInput",template:'<ng-include src="$$template"></ng-include>',scope:{$scope:"=scope",data:"="},link:function(b,c,d,e){var f=e.registerTagItem(),g=f.getOptions();b.$$template=g.template,b.$$removeTagSymbol=g.removeTagSymbol,b.$getDisplayText=function(){return a.safeToString(b.data[g.displayProperty])},b.$removeTag=function(){f.removeTag(b.$index)},b.$watch("$parent.$index",function(a){b.$index=a})}}}]),d.directive("autoComplete",["$document","$timeout","$sce","$q","tagsInputConfig","tiUtil",function(b,c,d,e,f,g){function h(a,b,c){var d,f,h,i={};return h=function(){return b.tagsInput.keyProperty||b.tagsInput.displayProperty},d=function(a,c){return a.filter(function(a){return!g.findInObjectArray(c,a,h(),function(a,c){return b.tagsInput.replaceSpacesWithDashes&&(a=g.replaceSpacesWithDashes(a),c=g.replaceSpacesWithDashes(c)),g.defaultComparer(a,c)})})},i.reset=function(){f=null,i.items=[],i.visible=!1,i.index=-1,i.selected=null,i.query=null},i.show=function(){b.selectFirstMatch?i.select(0):i.selected=null,i.visible=!0},i.load=g.debounce(function(c,j){i.query=c;var k=e.when(a({$query:c}));f=k,k.then(function(a){k===f&&(a=g.makeObjectArray(a.data||a,h()),a=d(a,j),i.items=a.slice(0,b.maxResultsToShow),i.items.length>0?i.show():i.reset())})},b.debounceDelay),i.selectNext=function(){i.select(++i.index)},i.selectPrior=function(){i.select(--i.index)},i.select=function(a){0>a?a=i.items.length-1:a>=i.items.length&&(a=0),i.index=a,i.selected=i.items[a],c.trigger("suggestion-selected",a)},i.reset(),i}function i(a,b){var c=a.find("li").eq(b),d=c.parent(),e=c.prop("offsetTop"),f=c.prop("offsetHeight"),g=d.prop("clientHeight"),h=d.prop("scrollTop");h>e?d.prop("scrollTop",e):e+f>g+h&&d.prop("scrollTop",e+f-g)}return{restrict:"E",require:"^tagsInput",scope:{source:"&",matchClass:"&"},templateUrl:"ngTagsInput/auto-complete.html",controller:["$scope","$element","$attrs",function(a,b,c){a.events=g.simplePubSub(),f.load("autoComplete",a,c,{template:[String,"ngTagsInput/auto-complete-match.html"],debounceDelay:[Number,100],minLength:[Number,3],highlightMatchedText:[Boolean,!0],maxResultsToShow:[Number,10],loadOnDownArrow:[Boolean,!1],loadOnEmpty:[Boolean,!1],loadOnFocus:[Boolean,!1],selectFirstMatch:[Boolean,!0],displayProperty:[String,""]}),a.suggestionList=new h(a.source,a.options,a.events),this.registerAutocompleteMatch=function(){return{getOptions:function(){return a.options},getQuery:function(){return a.suggestionList.query}}}}],link:function(b,c,d,e){var f,h=[a.enter,a.tab,a.escape,a.up,a.down],j=b.suggestionList,k=e.registerAutocomplete(),l=b.options,m=b.events;l.tagsInput=k.getOptions(),f=function(a){return a&&a.length>=l.minLength||!a&&l.loadOnEmpty},b.templateScope=k.getTemplateScope(),b.addSuggestionByIndex=function(a){j.select(a),b.addSuggestion()},b.addSuggestion=function(){var a=!1;return j.selected&&(k.addTag(angular.copy(j.selected)),j.reset(),a=!0),a},b.track=function(a){return a[l.tagsInput.keyProperty||l.tagsInput.displayProperty]},b.getSuggestionClass=function(a,c){var d=a===j.selected;return[b.matchClass({$match:a,$index:c,$selected:d}),{selected:d}]},k.on("tag-added tag-removed invalid-tag input-blur",function(){j.reset()}).on("input-change",function(a){f(a)?j.load(a,k.getTags()):j.reset()}).on("input-focus",function(){var a=k.getCurrentTagText();l.loadOnFocus&&f(a)&&j.load(a,k.getTags())}).on("input-keydown",function(c){var d=c.keyCode,e=!1;if(!g.isModifierOn(c)&&-1!==h.indexOf(d))return j.visible?d===a.down?(j.selectNext(),e=!0):d===a.up?(j.selectPrior(),e=!0):d===a.escape?(j.reset(),e=!0):(d===a.enter||d===a.tab)&&(e=b.addSuggestion()):d===a.down&&b.options.loadOnDownArrow&&(j.load(k.getCurrentTagText(),k.getTags()),e=!0),e?(c.preventDefault(),c.stopImmediatePropagation(),!1):void 0}),m.on("suggestion-selected",function(a){i(c,a)})}}}]),d.directive("tiAutocompleteMatch",["$sce","tiUtil",function(a,b){return{restrict:"E",require:"^autoComplete",template:'<ng-include src="$$template"></ng-include>',scope:{$scope:"=scope",data:"="},link:function(c,d,e,f){var g=f.registerAutocompleteMatch(),h=g.getOptions();c.$$template=h.template,c.$index=c.$parent.$index,c.$highlight=function(c){return h.highlightMatchedText&&(c=b.safeHighlight(c,g.getQuery())),a.trustAsHtml(c)},c.$getDisplayText=function(){return b.safeToString(c.data[h.displayProperty||h.tagsInput.displayProperty])}}}}]),d.directive("tiTranscludeAppend",function(){return function(a,b,c,d,e){e(function(a){b.append(a)})}}),d.directive("tiAutosize",["tagsInputConfig",function(a){return{restrict:"A",require:"ngModel",link:function(b,c,d,e){var f,g,h=a.getTextAutosizeThreshold();f=angular.element('<span class="input"></span>'),f.css("display","none").css("visibility","hidden").css("width","auto").css("white-space","pre"),c.parent().append(f),g=function(a){var b,e=a;return angular.isString(e)&&0===e.length&&(e=d.placeholder),e&&(f.text(e),f.css("display",""),b=f.prop("offsetWidth"),f.css("display","none")),c.css("width",b?b+h+"px":""),a},e.$parsers.unshift(g),e.$formatters.unshift(g),d.$observe("placeholder",function(a){e.$modelValue||g(a)})}}}]),d.directive("tiBindAttrs",function(){return function(a,b,c){a.$watch(c.tiBindAttrs,function(a){angular.forEach(a,function(a,b){c.$set(b,a)})},!0)}}),d.provider("tagsInputConfig",function(){var a={},b={},c=3;this.setDefaults=function(b,c){return a[b]=c,this},this.setActiveInterpolation=function(a,c){return b[a]=c,this},this.setTextAutosizeThreshold=function(a){return c=a,this},this.$get=["$interpolate",function(d){var e={};return e[String]=function(a){return a},e[Number]=function(a){return parseInt(a,10)},e[Boolean]=function(a){return"true"===a.toLowerCase()},e[RegExp]=function(a){return new RegExp(a)},{load:function(c,f,g,h){var i=function(){return!0};f.options={},angular.forEach(h,function(h,j){var k,l,m,n,o,p;k=h[0],l=h[1],m=h[2]||i,n=e[k],o=function(){var b=a[c]&&a[c][j];return angular.isDefined(b)?b:l},p=function(a){f.options[j]=a&&m(a)?n(a):o()},b[c]&&b[c][j]?g.$observe(j,function(a){p(a),f.events.trigger("option-change",{name:j,newValue:a})}):p(g[j]&&d(g[j])(f.$parent))})},getTextAutosizeThreshold:function(){return c}}}]}),d.factory("tiUtil",["$timeout","$q",function(a,b){var c={};return c.debounce=function(b,c){var d;return function(){var e=arguments;a.cancel(d),d=a(function(){b.apply(null,e)},c)}},c.makeObjectArray=function(a,b){if(!angular.isArray(a)||0===a.length||angular.isObject(a[0]))return a;var c=[];return a.forEach(function(a){var d={};d[b]=a,c.push(d)}),c},c.findInObjectArray=function(a,b,d,e){var f=null;return e=e||c.defaultComparer,a.some(function(a){return e(a[d],b[d])?(f=a,!0):void 0}),f},c.defaultComparer=function(a,b){return c.safeToString(a).toLowerCase()===c.safeToString(b).toLowerCase()},c.safeHighlight=function(a,b){function d(a){return a.replace(/([.?*+^$[\]\\(){}|-])/g,"\\$1")}if(a=c.encodeHTML(a),b=c.encodeHTML(b),!b)return a;var e=new RegExp("&[^;]+;|"+d(b),"gi");return a.replace(e,function(a){return a.toLowerCase()===b.toLowerCase()?"<em>"+a+"</em>":a})},c.safeToString=function(a){return angular.isUndefined(a)||null==a?"":a.toString().trim()},c.encodeHTML=function(a){return c.safeToString(a).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;")},c.handleUndefinedResult=function(a,b){return function(){var c=a.apply(null,arguments);return angular.isUndefined(c)?b:c}},c.replaceSpacesWithDashes=function(a){return c.safeToString(a).replace(/\s/g,"-")},c.isModifierOn=function(a){return a.shiftKey||a.ctrlKey||a.altKey||a.metaKey},c.promisifyValue=function(a){return a=angular.isUndefined(a)?!0:a,b[a?"when":"reject"]()},c.simplePubSub=function(){var a={};return{on:function(b,c,d){return b.split(" ").forEach(function(b){a[b]||(a[b]=[]);var e=d?[].unshift:[].push;e.call(a[b],c)}),this},trigger:function(b,d){var e=a[b]||[];return e.every(function(a){return c.handleUndefinedResult(a,!0)(d)}),this}}},c}]),d.run(["$templateCache",function(a){a.put("ngTagsInput/tags-input.html",'<div class="host" tabindex="-1" ng-click="eventHandlers.host.click()" ti-transclude-append><div class="tags" ng-class="{focused: hasFocus}"><ul class="tag-list"><li class="tag-item" ng-repeat="tag in tagList.items track by track(tag)" ng-class="getTagClass(tag, $index)" ng-click="eventHandlers.tag.click(tag)"><ti-tag-item scope="templateScope" data="::tag"></ti-tag-item></li></ul><input class="input" autocomplete="off" ng-model="newTag.text" ng-model-options="{getterSetter: true}" ng-keydown="eventHandlers.input.keydown($event)" ng-focus="eventHandlers.input.focus($event)" ng-blur="eventHandlers.input.blur($event)" ng-paste="eventHandlers.input.paste($event)" ng-trim="false" ng-class="{\'invalid-tag\': newTag.invalid}" ng-disabled="disabled" ti-bind-attrs="{type: options.type, placeholder: options.placeholder, tabindex: options.tabindex, spellcheck: options.spellcheck}" ti-autosize></div></div>'),a.put("ngTagsInput/tag-item.html",'<span ng-bind="$getDisplayText()"></span> <a class="remove-button" ng-click="$removeTag()" ng-bind="::$$removeTagSymbol"></a>'),a.put("ngTagsInput/auto-complete.html",'<div class="autocomplete" ng-if="suggestionList.visible"><ul class="suggestion-list"><li class="suggestion-item" ng-repeat="item in suggestionList.items track by track(item)" ng-class="getSuggestionClass(item, $index)" ng-click="addSuggestionByIndex($index)" ng-mouseenter="suggestionList.select($index)"><ti-autocomplete-match scope="templateScope" data="::item"></ti-autocomplete-match></li></ul></div>'),a.put("ngTagsInput/auto-complete-match.html",'<span ng-bind-html="$highlight($getDisplayText())"></span>')}])}();

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

var require;var require;var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* perfect-scrollbar v0.6.10 */
(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

var ps = require('../main')
  , psInstances = require('../plugin/instances');

function mountJQuery(jQuery) {
  jQuery.fn.perfectScrollbar = function (settingOrCommand) {
    return this.each(function () {
      if (typeof settingOrCommand === 'object' ||
          typeof settingOrCommand === 'undefined') {
        // If it's an object or none, initialize.
        var settings = settingOrCommand;

        if (!psInstances.get(this)) {
          ps.initialize(this, settings);
        }
      } else {
        // Unless, it may be a command.
        var command = settingOrCommand;

        if (command === 'update') {
          ps.update(this);
        } else if (command === 'destroy') {
          ps.destroy(this);
        }
      }

      return jQuery(this);
    });
  };
}

if (true) {
  // AMD. Register as an anonymous module.
  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mountJQuery),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else {
  var jq = window.jQuery ? window.jQuery : window.$;
  if (typeof jq !== 'undefined') {
    mountJQuery(jq);
  }
}

module.exports = mountJQuery;

},{"../main":7,"../plugin/instances":18}],2:[function(require,module,exports){
'use strict';

function oldAdd(element, className) {
  var classes = element.className.split(' ');
  if (classes.indexOf(className) < 0) {
    classes.push(className);
  }
  element.className = classes.join(' ');
}

function oldRemove(element, className) {
  var classes = element.className.split(' ');
  var idx = classes.indexOf(className);
  if (idx >= 0) {
    classes.splice(idx, 1);
  }
  element.className = classes.join(' ');
}

exports.add = function (element, className) {
  if (element.classList) {
    element.classList.add(className);
  } else {
    oldAdd(element, className);
  }
};

exports.remove = function (element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else {
    oldRemove(element, className);
  }
};

exports.list = function (element) {
  if (element.classList) {
    return Array.prototype.slice.apply(element.classList);
  } else {
    return element.className.split(' ');
  }
};

},{}],3:[function(require,module,exports){
'use strict';

var DOM = {};

DOM.e = function (tagName, className) {
  var element = document.createElement(tagName);
  element.className = className;
  return element;
};

DOM.appendTo = function (child, parent) {
  parent.appendChild(child);
  return child;
};

function cssGet(element, styleName) {
  return window.getComputedStyle(element)[styleName];
}

function cssSet(element, styleName, styleValue) {
  if (typeof styleValue === 'number') {
    styleValue = styleValue.toString() + 'px';
  }
  element.style[styleName] = styleValue;
  return element;
}

function cssMultiSet(element, obj) {
  for (var key in obj) {
    var val = obj[key];
    if (typeof val === 'number') {
      val = val.toString() + 'px';
    }
    element.style[key] = val;
  }
  return element;
}

DOM.css = function (element, styleNameOrObject, styleValue) {
  if (typeof styleNameOrObject === 'object') {
    // multiple set with object
    return cssMultiSet(element, styleNameOrObject);
  } else {
    if (typeof styleValue === 'undefined') {
      return cssGet(element, styleNameOrObject);
    } else {
      return cssSet(element, styleNameOrObject, styleValue);
    }
  }
};

DOM.matches = function (element, query) {
  if (typeof element.matches !== 'undefined') {
    return element.matches(query);
  } else {
    if (typeof element.matchesSelector !== 'undefined') {
      return element.matchesSelector(query);
    } else if (typeof element.webkitMatchesSelector !== 'undefined') {
      return element.webkitMatchesSelector(query);
    } else if (typeof element.mozMatchesSelector !== 'undefined') {
      return element.mozMatchesSelector(query);
    } else if (typeof element.msMatchesSelector !== 'undefined') {
      return element.msMatchesSelector(query);
    }
  }
};

DOM.remove = function (element) {
  if (typeof element.remove !== 'undefined') {
    element.remove();
  } else {
    if (element.parentNode) {
      element.parentNode.removeChild(element);
    }
  }
};

DOM.queryChildren = function (element, selector) {
  return Array.prototype.filter.call(element.childNodes, function (child) {
    return DOM.matches(child, selector);
  });
};

module.exports = DOM;

},{}],4:[function(require,module,exports){
'use strict';

var EventElement = function (element) {
  this.element = element;
  this.events = {};
};

EventElement.prototype.bind = function (eventName, handler) {
  if (typeof this.events[eventName] === 'undefined') {
    this.events[eventName] = [];
  }
  this.events[eventName].push(handler);
  this.element.addEventListener(eventName, handler, false);
};

EventElement.prototype.unbind = function (eventName, handler) {
  var isHandlerProvided = (typeof handler !== 'undefined');
  this.events[eventName] = this.events[eventName].filter(function (hdlr) {
    if (isHandlerProvided && hdlr !== handler) {
      return true;
    }
    this.element.removeEventListener(eventName, hdlr, false);
    return false;
  }, this);
};

EventElement.prototype.unbindAll = function () {
  for (var name in this.events) {
    this.unbind(name);
  }
};

var EventManager = function () {
  this.eventElements = [];
};

EventManager.prototype.eventElement = function (element) {
  var ee = this.eventElements.filter(function (eventElement) {
    return eventElement.element === element;
  })[0];
  if (typeof ee === 'undefined') {
    ee = new EventElement(element);
    this.eventElements.push(ee);
  }
  return ee;
};

EventManager.prototype.bind = function (element, eventName, handler) {
  this.eventElement(element).bind(eventName, handler);
};

EventManager.prototype.unbind = function (element, eventName, handler) {
  this.eventElement(element).unbind(eventName, handler);
};

EventManager.prototype.unbindAll = function () {
  for (var i = 0; i < this.eventElements.length; i++) {
    this.eventElements[i].unbindAll();
  }
};

EventManager.prototype.once = function (element, eventName, handler) {
  var ee = this.eventElement(element);
  var onceHandler = function (e) {
    ee.unbind(eventName, onceHandler);
    handler(e);
  };
  ee.bind(eventName, onceHandler);
};

module.exports = EventManager;

},{}],5:[function(require,module,exports){
'use strict';

module.exports = (function () {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
               .toString(16)
               .substring(1);
  }
  return function () {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
           s4() + '-' + s4() + s4() + s4();
  };
})();

},{}],6:[function(require,module,exports){
'use strict';

var cls = require('./class')
  , d = require('./dom');

exports.toInt = function (x) {
  return parseInt(x, 10) || 0;
};

exports.clone = function (obj) {
  if (obj === null) {
    return null;
  } else if (typeof obj === 'object') {
    var result = {};
    for (var key in obj) {
      result[key] = this.clone(obj[key]);
    }
    return result;
  } else {
    return obj;
  }
};

exports.extend = function (original, source) {
  var result = this.clone(original);
  for (var key in source) {
    result[key] = this.clone(source[key]);
  }
  return result;
};

exports.isEditable = function (el) {
  return d.matches(el, "input,[contenteditable]") ||
         d.matches(el, "select,[contenteditable]") ||
         d.matches(el, "textarea,[contenteditable]") ||
         d.matches(el, "button,[contenteditable]");
};

exports.removePsClasses = function (element) {
  var clsList = cls.list(element);
  for (var i = 0; i < clsList.length; i++) {
    var className = clsList[i];
    if (className.indexOf('ps-') === 0) {
      cls.remove(element, className);
    }
  }
};

exports.outerWidth = function (element) {
  return this.toInt(d.css(element, 'width')) +
         this.toInt(d.css(element, 'paddingLeft')) +
         this.toInt(d.css(element, 'paddingRight')) +
         this.toInt(d.css(element, 'borderLeftWidth')) +
         this.toInt(d.css(element, 'borderRightWidth'));
};

exports.startScrolling = function (element, axis) {
  cls.add(element, 'ps-in-scrolling');
  if (typeof axis !== 'undefined') {
    cls.add(element, 'ps-' + axis);
  } else {
    cls.add(element, 'ps-x');
    cls.add(element, 'ps-y');
  }
};

exports.stopScrolling = function (element, axis) {
  cls.remove(element, 'ps-in-scrolling');
  if (typeof axis !== 'undefined') {
    cls.remove(element, 'ps-' + axis);
  } else {
    cls.remove(element, 'ps-x');
    cls.remove(element, 'ps-y');
  }
};

exports.env = {
  isWebKit: 'WebkitAppearance' in document.documentElement.style,
  supportsTouch: (('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch),
  supportsIePointer: window.navigator.msMaxTouchPoints !== null
};

},{"./class":2,"./dom":3}],7:[function(require,module,exports){
'use strict';

var destroy = require('./plugin/destroy')
  , initialize = require('./plugin/initialize')
  , update = require('./plugin/update');

module.exports = {
  initialize: initialize,
  update: update,
  destroy: destroy
};

},{"./plugin/destroy":9,"./plugin/initialize":17,"./plugin/update":21}],8:[function(require,module,exports){
'use strict';

module.exports = {
  maxScrollbarLength: null,
  minScrollbarLength: null,
  scrollXMarginOffset: 0,
  scrollYMarginOffset: 0,
  stopPropagationOnClick: true,
  suppressScrollX: false,
  suppressScrollY: false,
  swipePropagation: true,
  useBothWheelAxes: false,
  useKeyboard: true,
  useSelectionScroll: false,
  wheelPropagation: false,
  wheelSpeed: 1,
  theme: 'default'
};

},{}],9:[function(require,module,exports){
'use strict';

var d = require('../lib/dom')
  , h = require('../lib/helper')
  , instances = require('./instances');

module.exports = function (element) {
  var i = instances.get(element);

  if (!i) {
    return;
  }

  i.event.unbindAll();
  d.remove(i.scrollbarX);
  d.remove(i.scrollbarY);
  d.remove(i.scrollbarXRail);
  d.remove(i.scrollbarYRail);
  h.removePsClasses(element);

  instances.remove(element);
};

},{"../lib/dom":3,"../lib/helper":6,"./instances":18}],10:[function(require,module,exports){
'use strict';

var h = require('../../lib/helper')
  , instances = require('../instances')
  , updateGeometry = require('../update-geometry')
  , updateScroll = require('../update-scroll');

function bindClickRailHandler(element, i) {
  function pageOffset(el) {
    return el.getBoundingClientRect();
  }
  var stopPropagation = window.Event.prototype.stopPropagation.bind;

  if (i.settings.stopPropagationOnClick) {
    i.event.bind(i.scrollbarY, 'click', stopPropagation);
  }
  i.event.bind(i.scrollbarYRail, 'click', function (e) {
    var halfOfScrollbarLength = h.toInt(i.scrollbarYHeight / 2);
    var positionTop = i.railYRatio * (e.pageY - window.pageYOffset - pageOffset(i.scrollbarYRail).top - halfOfScrollbarLength);
    var maxPositionTop = i.railYRatio * (i.railYHeight - i.scrollbarYHeight);
    var positionRatio = positionTop / maxPositionTop;

    if (positionRatio < 0) {
      positionRatio = 0;
    } else if (positionRatio > 1) {
      positionRatio = 1;
    }

    updateScroll(element, 'top', (i.contentHeight - i.containerHeight) * positionRatio);
    updateGeometry(element);

    e.stopPropagation();
  });

  if (i.settings.stopPropagationOnClick) {
    i.event.bind(i.scrollbarX, 'click', stopPropagation);
  }
  i.event.bind(i.scrollbarXRail, 'click', function (e) {
    var halfOfScrollbarLength = h.toInt(i.scrollbarXWidth / 2);
    var positionLeft = i.railXRatio * (e.pageX - window.pageXOffset - pageOffset(i.scrollbarXRail).left - halfOfScrollbarLength);
    var maxPositionLeft = i.railXRatio * (i.railXWidth - i.scrollbarXWidth);
    var positionRatio = positionLeft / maxPositionLeft;

    if (positionRatio < 0) {
      positionRatio = 0;
    } else if (positionRatio > 1) {
      positionRatio = 1;
    }

    updateScroll(element, 'left', ((i.contentWidth - i.containerWidth) * positionRatio) - i.negativeScrollAdjustment);
    updateGeometry(element);

    e.stopPropagation();
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindClickRailHandler(element, i);
};

},{"../../lib/helper":6,"../instances":18,"../update-geometry":19,"../update-scroll":20}],11:[function(require,module,exports){
'use strict';

var d = require('../../lib/dom')
  , h = require('../../lib/helper')
  , instances = require('../instances')
  , updateGeometry = require('../update-geometry')
  , updateScroll = require('../update-scroll');

function bindMouseScrollXHandler(element, i) {
  var currentLeft = null;
  var currentPageX = null;

  function updateScrollLeft(deltaX) {
    var newLeft = currentLeft + (deltaX * i.railXRatio);
    var maxLeft = Math.max(0, i.scrollbarXRail.getBoundingClientRect().left) + (i.railXRatio * (i.railXWidth - i.scrollbarXWidth));

    if (newLeft < 0) {
      i.scrollbarXLeft = 0;
    } else if (newLeft > maxLeft) {
      i.scrollbarXLeft = maxLeft;
    } else {
      i.scrollbarXLeft = newLeft;
    }

    var scrollLeft = h.toInt(i.scrollbarXLeft * (i.contentWidth - i.containerWidth) / (i.containerWidth - (i.railXRatio * i.scrollbarXWidth))) - i.negativeScrollAdjustment;
    updateScroll(element, 'left', scrollLeft);
  }

  var mouseMoveHandler = function (e) {
    updateScrollLeft(e.pageX - currentPageX);
    updateGeometry(element);
    e.stopPropagation();
    e.preventDefault();
  };

  var mouseUpHandler = function () {
    h.stopScrolling(element, 'x');
    i.event.unbind(i.ownerDocument, 'mousemove', mouseMoveHandler);
  };

  i.event.bind(i.scrollbarX, 'mousedown', function (e) {
    currentPageX = e.pageX;
    currentLeft = h.toInt(d.css(i.scrollbarX, 'left')) * i.railXRatio;
    h.startScrolling(element, 'x');

    i.event.bind(i.ownerDocument, 'mousemove', mouseMoveHandler);
    i.event.once(i.ownerDocument, 'mouseup', mouseUpHandler);

    e.stopPropagation();
    e.preventDefault();
  });
}

function bindMouseScrollYHandler(element, i) {
  var currentTop = null;
  var currentPageY = null;

  function updateScrollTop(deltaY) {
    var newTop = currentTop + (deltaY * i.railYRatio);
    var maxTop = Math.max(0, i.scrollbarYRail.getBoundingClientRect().top) + (i.railYRatio * (i.railYHeight - i.scrollbarYHeight));

    if (newTop < 0) {
      i.scrollbarYTop = 0;
    } else if (newTop > maxTop) {
      i.scrollbarYTop = maxTop;
    } else {
      i.scrollbarYTop = newTop;
    }

    var scrollTop = h.toInt(i.scrollbarYTop * (i.contentHeight - i.containerHeight) / (i.containerHeight - (i.railYRatio * i.scrollbarYHeight)));
    updateScroll(element, 'top', scrollTop);
  }

  var mouseMoveHandler = function (e) {
    updateScrollTop(e.pageY - currentPageY);
    updateGeometry(element);
    e.stopPropagation();
    e.preventDefault();
  };

  var mouseUpHandler = function () {
    h.stopScrolling(element, 'y');
    i.event.unbind(i.ownerDocument, 'mousemove', mouseMoveHandler);
  };

  i.event.bind(i.scrollbarY, 'mousedown', function (e) {
    currentPageY = e.pageY;
    currentTop = h.toInt(d.css(i.scrollbarY, 'top')) * i.railYRatio;
    h.startScrolling(element, 'y');

    i.event.bind(i.ownerDocument, 'mousemove', mouseMoveHandler);
    i.event.once(i.ownerDocument, 'mouseup', mouseUpHandler);

    e.stopPropagation();
    e.preventDefault();
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindMouseScrollXHandler(element, i);
  bindMouseScrollYHandler(element, i);
};

},{"../../lib/dom":3,"../../lib/helper":6,"../instances":18,"../update-geometry":19,"../update-scroll":20}],12:[function(require,module,exports){
'use strict';

var h = require('../../lib/helper')
  , d = require('../../lib/dom')
  , instances = require('../instances')
  , updateGeometry = require('../update-geometry')
  , updateScroll = require('../update-scroll');

function bindKeyboardHandler(element, i) {
  var hovered = false;
  i.event.bind(element, 'mouseenter', function () {
    hovered = true;
  });
  i.event.bind(element, 'mouseleave', function () {
    hovered = false;
  });

  var shouldPrevent = false;
  function shouldPreventDefault(deltaX, deltaY) {
    var scrollTop = element.scrollTop;
    if (deltaX === 0) {
      if (!i.scrollbarYActive) {
        return false;
      }
      if ((scrollTop === 0 && deltaY > 0) || (scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0)) {
        return !i.settings.wheelPropagation;
      }
    }

    var scrollLeft = element.scrollLeft;
    if (deltaY === 0) {
      if (!i.scrollbarXActive) {
        return false;
      }
      if ((scrollLeft === 0 && deltaX < 0) || (scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0)) {
        return !i.settings.wheelPropagation;
      }
    }
    return true;
  }

  i.event.bind(i.ownerDocument, 'keydown', function (e) {
    if (e.isDefaultPrevented && e.isDefaultPrevented()) {
      return;
    }

    var focused = d.matches(i.scrollbarX, ':focus') ||
                  d.matches(i.scrollbarY, ':focus');

    if (!hovered && !focused) {
      return;
    }

    var activeElement = document.activeElement ? document.activeElement : i.ownerDocument.activeElement;
    if (activeElement) {
      // go deeper if element is a webcomponent
      while (activeElement.shadowRoot) {
        activeElement = activeElement.shadowRoot.activeElement;
      }
      if (h.isEditable(activeElement)) {
        return;
      }
    }

    var deltaX = 0;
    var deltaY = 0;

    switch (e.which) {
    case 37: // left
      deltaX = -30;
      break;
    case 38: // up
      deltaY = 30;
      break;
    case 39: // right
      deltaX = 30;
      break;
    case 40: // down
      deltaY = -30;
      break;
    case 33: // page up
      deltaY = 90;
      break;
    case 32: // space bar
      if (e.shiftKey) {
        deltaY = 90;
      } else {
        deltaY = -90;
      }
      break;
    case 34: // page down
      deltaY = -90;
      break;
    case 35: // end
      if (e.ctrlKey) {
        deltaY = -i.contentHeight;
      } else {
        deltaY = -i.containerHeight;
      }
      break;
    case 36: // home
      if (e.ctrlKey) {
        deltaY = element.scrollTop;
      } else {
        deltaY = i.containerHeight;
      }
      break;
    default:
      return;
    }

    updateScroll(element, 'top', element.scrollTop - deltaY);
    updateScroll(element, 'left', element.scrollLeft + deltaX);
    updateGeometry(element);

    shouldPrevent = shouldPreventDefault(deltaX, deltaY);
    if (shouldPrevent) {
      e.preventDefault();
    }
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindKeyboardHandler(element, i);
};

},{"../../lib/dom":3,"../../lib/helper":6,"../instances":18,"../update-geometry":19,"../update-scroll":20}],13:[function(require,module,exports){
'use strict';

var instances = require('../instances')
  , updateGeometry = require('../update-geometry')
  , updateScroll = require('../update-scroll');

function bindMouseWheelHandler(element, i) {
  var shouldPrevent = false;

  function shouldPreventDefault(deltaX, deltaY) {
    var scrollTop = element.scrollTop;
    if (deltaX === 0) {
      if (!i.scrollbarYActive) {
        return false;
      }
      if ((scrollTop === 0 && deltaY > 0) || (scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0)) {
        return !i.settings.wheelPropagation;
      }
    }

    var scrollLeft = element.scrollLeft;
    if (deltaY === 0) {
      if (!i.scrollbarXActive) {
        return false;
      }
      if ((scrollLeft === 0 && deltaX < 0) || (scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0)) {
        return !i.settings.wheelPropagation;
      }
    }
    return true;
  }

  function getDeltaFromEvent(e) {
    var deltaX = e.deltaX;
    var deltaY = -1 * e.deltaY;

    if (typeof deltaX === "undefined" || typeof deltaY === "undefined") {
      // OS X Safari
      deltaX = -1 * e.wheelDeltaX / 6;
      deltaY = e.wheelDeltaY / 6;
    }

    if (e.deltaMode && e.deltaMode === 1) {
      // Firefox in deltaMode 1: Line scrolling
      deltaX *= 10;
      deltaY *= 10;
    }

    if (deltaX !== deltaX && deltaY !== deltaY/* NaN checks */) {
      // IE in some mouse drivers
      deltaX = 0;
      deltaY = e.wheelDelta;
    }

    return [deltaX, deltaY];
  }

  function shouldBeConsumedByTextarea(deltaX, deltaY) {
    var hoveredTextarea = element.querySelector('textarea:hover');
    if (hoveredTextarea) {
      var maxScrollTop = hoveredTextarea.scrollHeight - hoveredTextarea.clientHeight;
      if (maxScrollTop > 0) {
        if (!(hoveredTextarea.scrollTop === 0 && deltaY > 0) &&
            !(hoveredTextarea.scrollTop === maxScrollTop && deltaY < 0)) {
          return true;
        }
      }
      var maxScrollLeft = hoveredTextarea.scrollLeft - hoveredTextarea.clientWidth;
      if (maxScrollLeft > 0) {
        if (!(hoveredTextarea.scrollLeft === 0 && deltaX < 0) &&
            !(hoveredTextarea.scrollLeft === maxScrollLeft && deltaX > 0)) {
          return true;
        }
      }
    }
    return false;
  }

  function mousewheelHandler(e) {
    var delta = getDeltaFromEvent(e);

    var deltaX = delta[0];
    var deltaY = delta[1];

    if (shouldBeConsumedByTextarea(deltaX, deltaY)) {
      return;
    }

    shouldPrevent = false;
    if (!i.settings.useBothWheelAxes) {
      // deltaX will only be used for horizontal scrolling and deltaY will
      // only be used for vertical scrolling - this is the default
      updateScroll(element, 'top', element.scrollTop - (deltaY * i.settings.wheelSpeed));
      updateScroll(element, 'left', element.scrollLeft + (deltaX * i.settings.wheelSpeed));
    } else if (i.scrollbarYActive && !i.scrollbarXActive) {
      // only vertical scrollbar is active and useBothWheelAxes option is
      // active, so let's scroll vertical bar using both mouse wheel axes
      if (deltaY) {
        updateScroll(element, 'top', element.scrollTop - (deltaY * i.settings.wheelSpeed));
      } else {
        updateScroll(element, 'top', element.scrollTop + (deltaX * i.settings.wheelSpeed));
      }
      shouldPrevent = true;
    } else if (i.scrollbarXActive && !i.scrollbarYActive) {
      // useBothWheelAxes and only horizontal bar is active, so use both
      // wheel axes for horizontal bar
      if (deltaX) {
        updateScroll(element, 'left', element.scrollLeft + (deltaX * i.settings.wheelSpeed));
      } else {
        updateScroll(element, 'left', element.scrollLeft - (deltaY * i.settings.wheelSpeed));
      }
      shouldPrevent = true;
    }

    updateGeometry(element);

    shouldPrevent = (shouldPrevent || shouldPreventDefault(deltaX, deltaY));
    if (shouldPrevent) {
      e.stopPropagation();
      e.preventDefault();
    }
  }

  if (typeof window.onwheel !== "undefined") {
    i.event.bind(element, 'wheel', mousewheelHandler);
  } else if (typeof window.onmousewheel !== "undefined") {
    i.event.bind(element, 'mousewheel', mousewheelHandler);
  }
}

module.exports = function (element) {
  var i = instances.get(element);
  bindMouseWheelHandler(element, i);
};

},{"../instances":18,"../update-geometry":19,"../update-scroll":20}],14:[function(require,module,exports){
'use strict';

var instances = require('../instances')
  , updateGeometry = require('../update-geometry');

function bindNativeScrollHandler(element, i) {
  i.event.bind(element, 'scroll', function () {
    updateGeometry(element);
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindNativeScrollHandler(element, i);
};

},{"../instances":18,"../update-geometry":19}],15:[function(require,module,exports){
'use strict';

var h = require('../../lib/helper')
  , instances = require('../instances')
  , updateGeometry = require('../update-geometry')
  , updateScroll = require('../update-scroll');

function bindSelectionHandler(element, i) {
  function getRangeNode() {
    var selection = window.getSelection ? window.getSelection() :
                    document.getSelection ? document.getSelection() : '';
    if (selection.toString().length === 0) {
      return null;
    } else {
      return selection.getRangeAt(0).commonAncestorContainer;
    }
  }

  var scrollingLoop = null;
  var scrollDiff = {top: 0, left: 0};
  function startScrolling() {
    if (!scrollingLoop) {
      scrollingLoop = setInterval(function () {
        if (!instances.get(element)) {
          clearInterval(scrollingLoop);
          return;
        }

        updateScroll(element, 'top', element.scrollTop + scrollDiff.top);
        updateScroll(element, 'left', element.scrollLeft + scrollDiff.left);
        updateGeometry(element);
      }, 50); // every .1 sec
    }
  }
  function stopScrolling() {
    if (scrollingLoop) {
      clearInterval(scrollingLoop);
      scrollingLoop = null;
    }
    h.stopScrolling(element);
  }

  var isSelected = false;
  i.event.bind(i.ownerDocument, 'selectionchange', function () {
    if (element.contains(getRangeNode())) {
      isSelected = true;
    } else {
      isSelected = false;
      stopScrolling();
    }
  });
  i.event.bind(window, 'mouseup', function () {
    if (isSelected) {
      isSelected = false;
      stopScrolling();
    }
  });

  i.event.bind(window, 'mousemove', function (e) {
    if (isSelected) {
      var mousePosition = {x: e.pageX, y: e.pageY};
      var containerGeometry = {
        left: element.offsetLeft,
        right: element.offsetLeft + element.offsetWidth,
        top: element.offsetTop,
        bottom: element.offsetTop + element.offsetHeight
      };

      if (mousePosition.x < containerGeometry.left + 3) {
        scrollDiff.left = -5;
        h.startScrolling(element, 'x');
      } else if (mousePosition.x > containerGeometry.right - 3) {
        scrollDiff.left = 5;
        h.startScrolling(element, 'x');
      } else {
        scrollDiff.left = 0;
      }

      if (mousePosition.y < containerGeometry.top + 3) {
        if (containerGeometry.top + 3 - mousePosition.y < 5) {
          scrollDiff.top = -5;
        } else {
          scrollDiff.top = -20;
        }
        h.startScrolling(element, 'y');
      } else if (mousePosition.y > containerGeometry.bottom - 3) {
        if (mousePosition.y - containerGeometry.bottom + 3 < 5) {
          scrollDiff.top = 5;
        } else {
          scrollDiff.top = 20;
        }
        h.startScrolling(element, 'y');
      } else {
        scrollDiff.top = 0;
      }

      if (scrollDiff.top === 0 && scrollDiff.left === 0) {
        stopScrolling();
      } else {
        startScrolling();
      }
    }
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindSelectionHandler(element, i);
};

},{"../../lib/helper":6,"../instances":18,"../update-geometry":19,"../update-scroll":20}],16:[function(require,module,exports){
'use strict';

var instances = require('../instances')
  , updateGeometry = require('../update-geometry')
  , updateScroll = require('../update-scroll');

function bindTouchHandler(element, i, supportsTouch, supportsIePointer) {
  function shouldPreventDefault(deltaX, deltaY) {
    var scrollTop = element.scrollTop;
    var scrollLeft = element.scrollLeft;
    var magnitudeX = Math.abs(deltaX);
    var magnitudeY = Math.abs(deltaY);

    if (magnitudeY > magnitudeX) {
      // user is perhaps trying to swipe up/down the page

      if (((deltaY < 0) && (scrollTop === i.contentHeight - i.containerHeight)) ||
          ((deltaY > 0) && (scrollTop === 0))) {
        return !i.settings.swipePropagation;
      }
    } else if (magnitudeX > magnitudeY) {
      // user is perhaps trying to swipe left/right across the page

      if (((deltaX < 0) && (scrollLeft === i.contentWidth - i.containerWidth)) ||
          ((deltaX > 0) && (scrollLeft === 0))) {
        return !i.settings.swipePropagation;
      }
    }

    return true;
  }

  function applyTouchMove(differenceX, differenceY) {
    updateScroll(element, 'top', element.scrollTop - differenceY);
    updateScroll(element, 'left', element.scrollLeft - differenceX);

    updateGeometry(element);
  }

  var startOffset = {};
  var startTime = 0;
  var speed = {};
  var easingLoop = null;
  var inGlobalTouch = false;
  var inLocalTouch = false;

  function globalTouchStart() {
    inGlobalTouch = true;
  }
  function globalTouchEnd() {
    inGlobalTouch = false;
  }

  function getTouch(e) {
    if (e.targetTouches) {
      return e.targetTouches[0];
    } else {
      // Maybe IE pointer
      return e;
    }
  }
  function shouldHandle(e) {
    if (e.targetTouches && e.targetTouches.length === 1) {
      return true;
    }
    if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== e.MSPOINTER_TYPE_MOUSE) {
      return true;
    }
    return false;
  }
  function touchStart(e) {
    if (shouldHandle(e)) {
      inLocalTouch = true;

      var touch = getTouch(e);

      startOffset.pageX = touch.pageX;
      startOffset.pageY = touch.pageY;

      startTime = (new Date()).getTime();

      if (easingLoop !== null) {
        clearInterval(easingLoop);
      }

      e.stopPropagation();
    }
  }
  function touchMove(e) {
    if (!inGlobalTouch && inLocalTouch && shouldHandle(e)) {
      var touch = getTouch(e);

      var currentOffset = {pageX: touch.pageX, pageY: touch.pageY};

      var differenceX = currentOffset.pageX - startOffset.pageX;
      var differenceY = currentOffset.pageY - startOffset.pageY;

      applyTouchMove(differenceX, differenceY);
      startOffset = currentOffset;

      var currentTime = (new Date()).getTime();

      var timeGap = currentTime - startTime;
      if (timeGap > 0) {
        speed.x = differenceX / timeGap;
        speed.y = differenceY / timeGap;
        startTime = currentTime;
      }

      if (shouldPreventDefault(differenceX, differenceY)) {
        e.stopPropagation();
        e.preventDefault();
      }
    }
  }
  function touchEnd() {
    if (!inGlobalTouch && inLocalTouch) {
      inLocalTouch = false;

      clearInterval(easingLoop);
      easingLoop = setInterval(function () {
        if (!instances.get(element)) {
          clearInterval(easingLoop);
          return;
        }

        if (Math.abs(speed.x) < 0.01 && Math.abs(speed.y) < 0.01) {
          clearInterval(easingLoop);
          return;
        }

        applyTouchMove(speed.x * 30, speed.y * 30);

        speed.x *= 0.8;
        speed.y *= 0.8;
      }, 10);
    }
  }

  if (supportsTouch) {
    i.event.bind(window, 'touchstart', globalTouchStart);
    i.event.bind(window, 'touchend', globalTouchEnd);
    i.event.bind(element, 'touchstart', touchStart);
    i.event.bind(element, 'touchmove', touchMove);
    i.event.bind(element, 'touchend', touchEnd);
  }

  if (supportsIePointer) {
    if (window.PointerEvent) {
      i.event.bind(window, 'pointerdown', globalTouchStart);
      i.event.bind(window, 'pointerup', globalTouchEnd);
      i.event.bind(element, 'pointerdown', touchStart);
      i.event.bind(element, 'pointermove', touchMove);
      i.event.bind(element, 'pointerup', touchEnd);
    } else if (window.MSPointerEvent) {
      i.event.bind(window, 'MSPointerDown', globalTouchStart);
      i.event.bind(window, 'MSPointerUp', globalTouchEnd);
      i.event.bind(element, 'MSPointerDown', touchStart);
      i.event.bind(element, 'MSPointerMove', touchMove);
      i.event.bind(element, 'MSPointerUp', touchEnd);
    }
  }
}

module.exports = function (element, supportsTouch, supportsIePointer) {
  var i = instances.get(element);
  bindTouchHandler(element, i, supportsTouch, supportsIePointer);
};

},{"../instances":18,"../update-geometry":19,"../update-scroll":20}],17:[function(require,module,exports){
'use strict';

var cls = require('../lib/class')
  , h = require('../lib/helper')
  , instances = require('./instances')
  , updateGeometry = require('./update-geometry');

// Handlers
var clickRailHandler = require('./handler/click-rail')
  , dragScrollbarHandler = require('./handler/drag-scrollbar')
  , keyboardHandler = require('./handler/keyboard')
  , mouseWheelHandler = require('./handler/mouse-wheel')
  , nativeScrollHandler = require('./handler/native-scroll')
  , selectionHandler = require('./handler/selection')
  , touchHandler = require('./handler/touch');

module.exports = function (element, userSettings) {
  userSettings = typeof userSettings === 'object' ? userSettings : {};

  cls.add(element, 'ps-container');

  // Create a plugin instance.
  var i = instances.add(element);

  i.settings = h.extend(i.settings, userSettings);
  cls.add(element, 'ps-theme-' + i.settings.theme);

  clickRailHandler(element);
  dragScrollbarHandler(element);
  mouseWheelHandler(element);
  nativeScrollHandler(element);

  if (i.settings.useSelectionScroll) {
    selectionHandler(element);
  }

  if (h.env.supportsTouch || h.env.supportsIePointer) {
    touchHandler(element, h.env.supportsTouch, h.env.supportsIePointer);
  }
  if (i.settings.useKeyboard) {
    keyboardHandler(element);
  }

  updateGeometry(element);
};

},{"../lib/class":2,"../lib/helper":6,"./handler/click-rail":10,"./handler/drag-scrollbar":11,"./handler/keyboard":12,"./handler/mouse-wheel":13,"./handler/native-scroll":14,"./handler/selection":15,"./handler/touch":16,"./instances":18,"./update-geometry":19}],18:[function(require,module,exports){
'use strict';

var cls = require('../lib/class')
  , d = require('../lib/dom')
  , defaultSettings = require('./default-setting')
  , EventManager = require('../lib/event-manager')
  , guid = require('../lib/guid')
  , h = require('../lib/helper');

var instances = {};

function Instance(element) {
  var i = this;

  i.settings = h.clone(defaultSettings);
  i.containerWidth = null;
  i.containerHeight = null;
  i.contentWidth = null;
  i.contentHeight = null;

  i.isRtl = d.css(element, 'direction') === "rtl";
  i.isNegativeScroll = (function () {
    var originalScrollLeft = element.scrollLeft;
    var result = null;
    element.scrollLeft = -1;
    result = element.scrollLeft < 0;
    element.scrollLeft = originalScrollLeft;
    return result;
  })();
  i.negativeScrollAdjustment = i.isNegativeScroll ? element.scrollWidth - element.clientWidth : 0;
  i.event = new EventManager();
  i.ownerDocument = element.ownerDocument || document;

  function focus() {
    cls.add(element, 'ps-focus');
  }

  function blur() {
    cls.remove(element, 'ps-focus');
  }

  i.scrollbarXRail = d.appendTo(d.e('div', 'ps-scrollbar-x-rail'), element);
  i.scrollbarX = d.appendTo(d.e('div', 'ps-scrollbar-x'), i.scrollbarXRail);
  i.scrollbarX.setAttribute('tabindex', 0);
  i.event.bind(i.scrollbarX, 'focus', focus);
  i.event.bind(i.scrollbarX, 'blur', blur);
  i.scrollbarXActive = null;
  i.scrollbarXWidth = null;
  i.scrollbarXLeft = null;
  i.scrollbarXBottom = h.toInt(d.css(i.scrollbarXRail, 'bottom'));
  i.isScrollbarXUsingBottom = i.scrollbarXBottom === i.scrollbarXBottom; // !isNaN
  i.scrollbarXTop = i.isScrollbarXUsingBottom ? null : h.toInt(d.css(i.scrollbarXRail, 'top'));
  i.railBorderXWidth = h.toInt(d.css(i.scrollbarXRail, 'borderLeftWidth')) + h.toInt(d.css(i.scrollbarXRail, 'borderRightWidth'));
  // Set rail to display:block to calculate margins
  d.css(i.scrollbarXRail, 'display', 'block');
  i.railXMarginWidth = h.toInt(d.css(i.scrollbarXRail, 'marginLeft')) + h.toInt(d.css(i.scrollbarXRail, 'marginRight'));
  d.css(i.scrollbarXRail, 'display', '');
  i.railXWidth = null;
  i.railXRatio = null;

  i.scrollbarYRail = d.appendTo(d.e('div', 'ps-scrollbar-y-rail'), element);
  i.scrollbarY = d.appendTo(d.e('div', 'ps-scrollbar-y'), i.scrollbarYRail);
  i.scrollbarY.setAttribute('tabindex', 0);
  i.event.bind(i.scrollbarY, 'focus', focus);
  i.event.bind(i.scrollbarY, 'blur', blur);
  i.scrollbarYActive = null;
  i.scrollbarYHeight = null;
  i.scrollbarYTop = null;
  i.scrollbarYRight = h.toInt(d.css(i.scrollbarYRail, 'right'));
  i.isScrollbarYUsingRight = i.scrollbarYRight === i.scrollbarYRight; // !isNaN
  i.scrollbarYLeft = i.isScrollbarYUsingRight ? null : h.toInt(d.css(i.scrollbarYRail, 'left'));
  i.scrollbarYOuterWidth = i.isRtl ? h.outerWidth(i.scrollbarY) : null;
  i.railBorderYWidth = h.toInt(d.css(i.scrollbarYRail, 'borderTopWidth')) + h.toInt(d.css(i.scrollbarYRail, 'borderBottomWidth'));
  d.css(i.scrollbarYRail, 'display', 'block');
  i.railYMarginHeight = h.toInt(d.css(i.scrollbarYRail, 'marginTop')) + h.toInt(d.css(i.scrollbarYRail, 'marginBottom'));
  d.css(i.scrollbarYRail, 'display', '');
  i.railYHeight = null;
  i.railYRatio = null;
}

function getId(element) {
  if (typeof element.dataset === 'undefined') {
    return element.getAttribute('data-ps-id');
  } else {
    return element.dataset.psId;
  }
}

function setId(element, id) {
  if (typeof element.dataset === 'undefined') {
    element.setAttribute('data-ps-id', id);
  } else {
    element.dataset.psId = id;
  }
}

function removeId(element) {
  if (typeof element.dataset === 'undefined') {
    element.removeAttribute('data-ps-id');
  } else {
    delete element.dataset.psId;
  }
}

exports.add = function (element) {
  var newId = guid();
  setId(element, newId);
  instances[newId] = new Instance(element);
  return instances[newId];
};

exports.remove = function (element) {
  delete instances[getId(element)];
  removeId(element);
};

exports.get = function (element) {
  return instances[getId(element)];
};

},{"../lib/class":2,"../lib/dom":3,"../lib/event-manager":4,"../lib/guid":5,"../lib/helper":6,"./default-setting":8}],19:[function(require,module,exports){
'use strict';

var cls = require('../lib/class')
  , d = require('../lib/dom')
  , h = require('../lib/helper')
  , instances = require('./instances')
  , updateScroll = require('./update-scroll');

function getThumbSize(i, thumbSize) {
  if (i.settings.minScrollbarLength) {
    thumbSize = Math.max(thumbSize, i.settings.minScrollbarLength);
  }
  if (i.settings.maxScrollbarLength) {
    thumbSize = Math.min(thumbSize, i.settings.maxScrollbarLength);
  }
  return thumbSize;
}

function updateCss(element, i) {
  var xRailOffset = {width: i.railXWidth};
  if (i.isRtl) {
    xRailOffset.left = i.negativeScrollAdjustment + element.scrollLeft + i.containerWidth - i.contentWidth;
  } else {
    xRailOffset.left = element.scrollLeft;
  }
  if (i.isScrollbarXUsingBottom) {
    xRailOffset.bottom = i.scrollbarXBottom - element.scrollTop;
  } else {
    xRailOffset.top = i.scrollbarXTop + element.scrollTop;
  }
  d.css(i.scrollbarXRail, xRailOffset);

  var yRailOffset = {top: element.scrollTop, height: i.railYHeight};
  if (i.isScrollbarYUsingRight) {
    if (i.isRtl) {
      yRailOffset.right = i.contentWidth - (i.negativeScrollAdjustment + element.scrollLeft) - i.scrollbarYRight - i.scrollbarYOuterWidth;
    } else {
      yRailOffset.right = i.scrollbarYRight - element.scrollLeft;
    }
  } else {
    if (i.isRtl) {
      yRailOffset.left = i.negativeScrollAdjustment + element.scrollLeft + i.containerWidth * 2 - i.contentWidth - i.scrollbarYLeft - i.scrollbarYOuterWidth;
    } else {
      yRailOffset.left = i.scrollbarYLeft + element.scrollLeft;
    }
  }
  d.css(i.scrollbarYRail, yRailOffset);

  d.css(i.scrollbarX, {left: i.scrollbarXLeft, width: i.scrollbarXWidth - i.railBorderXWidth});
  d.css(i.scrollbarY, {top: i.scrollbarYTop, height: i.scrollbarYHeight - i.railBorderYWidth});
}

module.exports = function (element) {
  var i = instances.get(element);

  i.containerWidth = element.clientWidth;
  i.containerHeight = element.clientHeight;
  i.contentWidth = element.scrollWidth;
  i.contentHeight = element.scrollHeight;

  var existingRails;
  if (!element.contains(i.scrollbarXRail)) {
    existingRails = d.queryChildren(element, '.ps-scrollbar-x-rail');
    if (existingRails.length > 0) {
      existingRails.forEach(function (rail) {
        d.remove(rail);
      });
    }
    d.appendTo(i.scrollbarXRail, element);
  }
  if (!element.contains(i.scrollbarYRail)) {
    existingRails = d.queryChildren(element, '.ps-scrollbar-y-rail');
    if (existingRails.length > 0) {
      existingRails.forEach(function (rail) {
        d.remove(rail);
      });
    }
    d.appendTo(i.scrollbarYRail, element);
  }

  if (!i.settings.suppressScrollX && i.containerWidth + i.settings.scrollXMarginOffset < i.contentWidth) {
    i.scrollbarXActive = true;
    i.railXWidth = i.containerWidth - i.railXMarginWidth;
    i.railXRatio = i.containerWidth / i.railXWidth;
    i.scrollbarXWidth = getThumbSize(i, h.toInt(i.railXWidth * i.containerWidth / i.contentWidth));
    i.scrollbarXLeft = h.toInt((i.negativeScrollAdjustment + element.scrollLeft) * (i.railXWidth - i.scrollbarXWidth) / (i.contentWidth - i.containerWidth));
  } else {
    i.scrollbarXActive = false;
  }

  if (!i.settings.suppressScrollY && i.containerHeight + i.settings.scrollYMarginOffset < i.contentHeight) {
    i.scrollbarYActive = true;
    i.railYHeight = i.containerHeight - i.railYMarginHeight;
    i.railYRatio = i.containerHeight / i.railYHeight;
    i.scrollbarYHeight = getThumbSize(i, h.toInt(i.railYHeight * i.containerHeight / i.contentHeight));
    i.scrollbarYTop = h.toInt(element.scrollTop * (i.railYHeight - i.scrollbarYHeight) / (i.contentHeight - i.containerHeight));
  } else {
    i.scrollbarYActive = false;
  }

  if (i.scrollbarXLeft >= i.railXWidth - i.scrollbarXWidth) {
    i.scrollbarXLeft = i.railXWidth - i.scrollbarXWidth;
  }
  if (i.scrollbarYTop >= i.railYHeight - i.scrollbarYHeight) {
    i.scrollbarYTop = i.railYHeight - i.scrollbarYHeight;
  }

  updateCss(element, i);

  if (i.scrollbarXActive) {
    cls.add(element, 'ps-active-x');
  } else {
    cls.remove(element, 'ps-active-x');
    i.scrollbarXWidth = 0;
    i.scrollbarXLeft = 0;
    updateScroll(element, 'left', 0);
  }
  if (i.scrollbarYActive) {
    cls.add(element, 'ps-active-y');
  } else {
    cls.remove(element, 'ps-active-y');
    i.scrollbarYHeight = 0;
    i.scrollbarYTop = 0;
    updateScroll(element, 'top', 0);
  }
};

},{"../lib/class":2,"../lib/dom":3,"../lib/helper":6,"./instances":18,"./update-scroll":20}],20:[function(require,module,exports){
'use strict';

var instances = require('./instances');

var upEvent = document.createEvent('Event')
  , downEvent = document.createEvent('Event')
  , leftEvent = document.createEvent('Event')
  , rightEvent = document.createEvent('Event')
  , yEvent = document.createEvent('Event')
  , xEvent = document.createEvent('Event')
  , xStartEvent = document.createEvent('Event')
  , xEndEvent = document.createEvent('Event')
  , yStartEvent = document.createEvent('Event')
  , yEndEvent = document.createEvent('Event')
  , lastTop
  , lastLeft;

upEvent.initEvent('ps-scroll-up', true, true);
downEvent.initEvent('ps-scroll-down', true, true);
leftEvent.initEvent('ps-scroll-left', true, true);
rightEvent.initEvent('ps-scroll-right', true, true);
yEvent.initEvent('ps-scroll-y', true, true);
xEvent.initEvent('ps-scroll-x', true, true);
xStartEvent.initEvent('ps-x-reach-start', true, true);
xEndEvent.initEvent('ps-x-reach-end', true, true);
yStartEvent.initEvent('ps-y-reach-start', true, true);
yEndEvent.initEvent('ps-y-reach-end', true, true);

module.exports = function (element, axis, value) {
  if (typeof element === 'undefined') {
    throw 'You must provide an element to the update-scroll function';
  }

  if (typeof axis === 'undefined') {
    throw 'You must provide an axis to the update-scroll function';
  }

  if (typeof value === 'undefined') {
    throw 'You must provide a value to the update-scroll function';
  }

  if (axis === 'top' && value <= 0) {
    element.scrollTop = value = 0; // don't allow negative scroll
    element.dispatchEvent(yStartEvent);
  }

  if (axis === 'left' && value <= 0) {
    element.scrollLeft = value = 0; // don't allow negative scroll
    element.dispatchEvent(xStartEvent);
  }

  var i = instances.get(element);

  if (axis === 'top' && value >= i.contentHeight - i.containerHeight) {
    element.scrollTop = value = i.contentHeight - i.containerHeight; // don't allow scroll past container
    element.dispatchEvent(yEndEvent);
  }

  if (axis === 'left' && value >= i.contentWidth - i.containerWidth) {
    element.scrollLeft = value = i.contentWidth - i.containerWidth; // don't allow scroll past container
    element.dispatchEvent(xEndEvent);
  }

  if (!lastTop) {
    lastTop = element.scrollTop;
  }

  if (!lastLeft) {
    lastLeft = element.scrollLeft;
  }

  if (axis === 'top' && value < lastTop) {
    element.dispatchEvent(upEvent);
  }

  if (axis === 'top' && value > lastTop) {
    element.dispatchEvent(downEvent);
  }

  if (axis === 'left' && value < lastLeft) {
    element.dispatchEvent(leftEvent);
  }

  if (axis === 'left' && value > lastLeft) {
    element.dispatchEvent(rightEvent);
  }

  if (axis === 'top') {
    element.scrollTop = lastTop = value;
    element.dispatchEvent(yEvent);
  }

  if (axis === 'left') {
    element.scrollLeft = lastLeft = value;
    element.dispatchEvent(xEvent);
  }

};

},{"./instances":18}],21:[function(require,module,exports){
'use strict';

var d = require('../lib/dom')
  , h = require('../lib/helper')
  , instances = require('./instances')
  , updateGeometry = require('./update-geometry')
  , updateScroll = require('./update-scroll');

module.exports = function (element) {
  var i = instances.get(element);

  if (!i) {
    return;
  }

  // Recalcuate negative scrollLeft adjustment
  i.negativeScrollAdjustment = i.isNegativeScroll ? element.scrollWidth - element.clientWidth : 0;

  // Recalculate rail margins
  d.css(i.scrollbarXRail, 'display', 'block');
  d.css(i.scrollbarYRail, 'display', 'block');
  i.railXMarginWidth = h.toInt(d.css(i.scrollbarXRail, 'marginLeft')) + h.toInt(d.css(i.scrollbarXRail, 'marginRight'));
  i.railYMarginHeight = h.toInt(d.css(i.scrollbarYRail, 'marginTop')) + h.toInt(d.css(i.scrollbarYRail, 'marginBottom'));

  // Hide scrollbars not to affect scrollWidth and scrollHeight
  d.css(i.scrollbarXRail, 'display', 'none');
  d.css(i.scrollbarYRail, 'display', 'none');

  updateGeometry(element);

  // Update top/left scroll to trigger events
  updateScroll(element, 'top', element.scrollTop);
  updateScroll(element, 'left', element.scrollLeft);

  d.css(i.scrollbarXRail, 'display', '');
  d.css(i.scrollbarYRail, 'display', '');
};

},{"../lib/dom":3,"../lib/helper":6,"./instances":18,"./update-geometry":19,"./update-scroll":20}]},{},[1]);


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var require;var require;var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* perfect-scrollbar v0.6.10 */
(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

var ps = require('../main');

if (true) {
  // AMD
  !(__WEBPACK_AMD_DEFINE_FACTORY__ = (ps),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else {
  // Add to a global object.
  window.PerfectScrollbar = ps;
  if (typeof window.Ps === 'undefined') {
    window.Ps = ps;
  }
}

},{"../main":7}],2:[function(require,module,exports){
'use strict';

function oldAdd(element, className) {
  var classes = element.className.split(' ');
  if (classes.indexOf(className) < 0) {
    classes.push(className);
  }
  element.className = classes.join(' ');
}

function oldRemove(element, className) {
  var classes = element.className.split(' ');
  var idx = classes.indexOf(className);
  if (idx >= 0) {
    classes.splice(idx, 1);
  }
  element.className = classes.join(' ');
}

exports.add = function (element, className) {
  if (element.classList) {
    element.classList.add(className);
  } else {
    oldAdd(element, className);
  }
};

exports.remove = function (element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else {
    oldRemove(element, className);
  }
};

exports.list = function (element) {
  if (element.classList) {
    return Array.prototype.slice.apply(element.classList);
  } else {
    return element.className.split(' ');
  }
};

},{}],3:[function(require,module,exports){
'use strict';

var DOM = {};

DOM.e = function (tagName, className) {
  var element = document.createElement(tagName);
  element.className = className;
  return element;
};

DOM.appendTo = function (child, parent) {
  parent.appendChild(child);
  return child;
};

function cssGet(element, styleName) {
  return window.getComputedStyle(element)[styleName];
}

function cssSet(element, styleName, styleValue) {
  if (typeof styleValue === 'number') {
    styleValue = styleValue.toString() + 'px';
  }
  element.style[styleName] = styleValue;
  return element;
}

function cssMultiSet(element, obj) {
  for (var key in obj) {
    var val = obj[key];
    if (typeof val === 'number') {
      val = val.toString() + 'px';
    }
    element.style[key] = val;
  }
  return element;
}

DOM.css = function (element, styleNameOrObject, styleValue) {
  if (typeof styleNameOrObject === 'object') {
    // multiple set with object
    return cssMultiSet(element, styleNameOrObject);
  } else {
    if (typeof styleValue === 'undefined') {
      return cssGet(element, styleNameOrObject);
    } else {
      return cssSet(element, styleNameOrObject, styleValue);
    }
  }
};

DOM.matches = function (element, query) {
  if (typeof element.matches !== 'undefined') {
    return element.matches(query);
  } else {
    if (typeof element.matchesSelector !== 'undefined') {
      return element.matchesSelector(query);
    } else if (typeof element.webkitMatchesSelector !== 'undefined') {
      return element.webkitMatchesSelector(query);
    } else if (typeof element.mozMatchesSelector !== 'undefined') {
      return element.mozMatchesSelector(query);
    } else if (typeof element.msMatchesSelector !== 'undefined') {
      return element.msMatchesSelector(query);
    }
  }
};

DOM.remove = function (element) {
  if (typeof element.remove !== 'undefined') {
    element.remove();
  } else {
    if (element.parentNode) {
      element.parentNode.removeChild(element);
    }
  }
};

DOM.queryChildren = function (element, selector) {
  return Array.prototype.filter.call(element.childNodes, function (child) {
    return DOM.matches(child, selector);
  });
};

module.exports = DOM;

},{}],4:[function(require,module,exports){
'use strict';

var EventElement = function (element) {
  this.element = element;
  this.events = {};
};

EventElement.prototype.bind = function (eventName, handler) {
  if (typeof this.events[eventName] === 'undefined') {
    this.events[eventName] = [];
  }
  this.events[eventName].push(handler);
  this.element.addEventListener(eventName, handler, false);
};

EventElement.prototype.unbind = function (eventName, handler) {
  var isHandlerProvided = (typeof handler !== 'undefined');
  this.events[eventName] = this.events[eventName].filter(function (hdlr) {
    if (isHandlerProvided && hdlr !== handler) {
      return true;
    }
    this.element.removeEventListener(eventName, hdlr, false);
    return false;
  }, this);
};

EventElement.prototype.unbindAll = function () {
  for (var name in this.events) {
    this.unbind(name);
  }
};

var EventManager = function () {
  this.eventElements = [];
};

EventManager.prototype.eventElement = function (element) {
  var ee = this.eventElements.filter(function (eventElement) {
    return eventElement.element === element;
  })[0];
  if (typeof ee === 'undefined') {
    ee = new EventElement(element);
    this.eventElements.push(ee);
  }
  return ee;
};

EventManager.prototype.bind = function (element, eventName, handler) {
  this.eventElement(element).bind(eventName, handler);
};

EventManager.prototype.unbind = function (element, eventName, handler) {
  this.eventElement(element).unbind(eventName, handler);
};

EventManager.prototype.unbindAll = function () {
  for (var i = 0; i < this.eventElements.length; i++) {
    this.eventElements[i].unbindAll();
  }
};

EventManager.prototype.once = function (element, eventName, handler) {
  var ee = this.eventElement(element);
  var onceHandler = function (e) {
    ee.unbind(eventName, onceHandler);
    handler(e);
  };
  ee.bind(eventName, onceHandler);
};

module.exports = EventManager;

},{}],5:[function(require,module,exports){
'use strict';

module.exports = (function () {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
               .toString(16)
               .substring(1);
  }
  return function () {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
           s4() + '-' + s4() + s4() + s4();
  };
})();

},{}],6:[function(require,module,exports){
'use strict';

var cls = require('./class')
  , d = require('./dom');

exports.toInt = function (x) {
  return parseInt(x, 10) || 0;
};

exports.clone = function (obj) {
  if (obj === null) {
    return null;
  } else if (typeof obj === 'object') {
    var result = {};
    for (var key in obj) {
      result[key] = this.clone(obj[key]);
    }
    return result;
  } else {
    return obj;
  }
};

exports.extend = function (original, source) {
  var result = this.clone(original);
  for (var key in source) {
    result[key] = this.clone(source[key]);
  }
  return result;
};

exports.isEditable = function (el) {
  return d.matches(el, "input,[contenteditable]") ||
         d.matches(el, "select,[contenteditable]") ||
         d.matches(el, "textarea,[contenteditable]") ||
         d.matches(el, "button,[contenteditable]");
};

exports.removePsClasses = function (element) {
  var clsList = cls.list(element);
  for (var i = 0; i < clsList.length; i++) {
    var className = clsList[i];
    if (className.indexOf('ps-') === 0) {
      cls.remove(element, className);
    }
  }
};

exports.outerWidth = function (element) {
  return this.toInt(d.css(element, 'width')) +
         this.toInt(d.css(element, 'paddingLeft')) +
         this.toInt(d.css(element, 'paddingRight')) +
         this.toInt(d.css(element, 'borderLeftWidth')) +
         this.toInt(d.css(element, 'borderRightWidth'));
};

exports.startScrolling = function (element, axis) {
  cls.add(element, 'ps-in-scrolling');
  if (typeof axis !== 'undefined') {
    cls.add(element, 'ps-' + axis);
  } else {
    cls.add(element, 'ps-x');
    cls.add(element, 'ps-y');
  }
};

exports.stopScrolling = function (element, axis) {
  cls.remove(element, 'ps-in-scrolling');
  if (typeof axis !== 'undefined') {
    cls.remove(element, 'ps-' + axis);
  } else {
    cls.remove(element, 'ps-x');
    cls.remove(element, 'ps-y');
  }
};

exports.env = {
  isWebKit: 'WebkitAppearance' in document.documentElement.style,
  supportsTouch: (('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch),
  supportsIePointer: window.navigator.msMaxTouchPoints !== null
};

},{"./class":2,"./dom":3}],7:[function(require,module,exports){
'use strict';

var destroy = require('./plugin/destroy')
  , initialize = require('./plugin/initialize')
  , update = require('./plugin/update');

module.exports = {
  initialize: initialize,
  update: update,
  destroy: destroy
};

},{"./plugin/destroy":9,"./plugin/initialize":17,"./plugin/update":21}],8:[function(require,module,exports){
'use strict';

module.exports = {
  maxScrollbarLength: null,
  minScrollbarLength: null,
  scrollXMarginOffset: 0,
  scrollYMarginOffset: 0,
  stopPropagationOnClick: true,
  suppressScrollX: false,
  suppressScrollY: false,
  swipePropagation: true,
  useBothWheelAxes: false,
  useKeyboard: true,
  useSelectionScroll: false,
  wheelPropagation: false,
  wheelSpeed: 1,
  theme: 'default'
};

},{}],9:[function(require,module,exports){
'use strict';

var d = require('../lib/dom')
  , h = require('../lib/helper')
  , instances = require('./instances');

module.exports = function (element) {
  var i = instances.get(element);

  if (!i) {
    return;
  }

  i.event.unbindAll();
  d.remove(i.scrollbarX);
  d.remove(i.scrollbarY);
  d.remove(i.scrollbarXRail);
  d.remove(i.scrollbarYRail);
  h.removePsClasses(element);

  instances.remove(element);
};

},{"../lib/dom":3,"../lib/helper":6,"./instances":18}],10:[function(require,module,exports){
'use strict';

var h = require('../../lib/helper')
  , instances = require('../instances')
  , updateGeometry = require('../update-geometry')
  , updateScroll = require('../update-scroll');

function bindClickRailHandler(element, i) {
  function pageOffset(el) {
    return el.getBoundingClientRect();
  }
  var stopPropagation = window.Event.prototype.stopPropagation.bind;

  if (i.settings.stopPropagationOnClick) {
    i.event.bind(i.scrollbarY, 'click', stopPropagation);
  }
  i.event.bind(i.scrollbarYRail, 'click', function (e) {
    var halfOfScrollbarLength = h.toInt(i.scrollbarYHeight / 2);
    var positionTop = i.railYRatio * (e.pageY - window.pageYOffset - pageOffset(i.scrollbarYRail).top - halfOfScrollbarLength);
    var maxPositionTop = i.railYRatio * (i.railYHeight - i.scrollbarYHeight);
    var positionRatio = positionTop / maxPositionTop;

    if (positionRatio < 0) {
      positionRatio = 0;
    } else if (positionRatio > 1) {
      positionRatio = 1;
    }

    updateScroll(element, 'top', (i.contentHeight - i.containerHeight) * positionRatio);
    updateGeometry(element);

    e.stopPropagation();
  });

  if (i.settings.stopPropagationOnClick) {
    i.event.bind(i.scrollbarX, 'click', stopPropagation);
  }
  i.event.bind(i.scrollbarXRail, 'click', function (e) {
    var halfOfScrollbarLength = h.toInt(i.scrollbarXWidth / 2);
    var positionLeft = i.railXRatio * (e.pageX - window.pageXOffset - pageOffset(i.scrollbarXRail).left - halfOfScrollbarLength);
    var maxPositionLeft = i.railXRatio * (i.railXWidth - i.scrollbarXWidth);
    var positionRatio = positionLeft / maxPositionLeft;

    if (positionRatio < 0) {
      positionRatio = 0;
    } else if (positionRatio > 1) {
      positionRatio = 1;
    }

    updateScroll(element, 'left', ((i.contentWidth - i.containerWidth) * positionRatio) - i.negativeScrollAdjustment);
    updateGeometry(element);

    e.stopPropagation();
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindClickRailHandler(element, i);
};

},{"../../lib/helper":6,"../instances":18,"../update-geometry":19,"../update-scroll":20}],11:[function(require,module,exports){
'use strict';

var d = require('../../lib/dom')
  , h = require('../../lib/helper')
  , instances = require('../instances')
  , updateGeometry = require('../update-geometry')
  , updateScroll = require('../update-scroll');

function bindMouseScrollXHandler(element, i) {
  var currentLeft = null;
  var currentPageX = null;

  function updateScrollLeft(deltaX) {
    var newLeft = currentLeft + (deltaX * i.railXRatio);
    var maxLeft = Math.max(0, i.scrollbarXRail.getBoundingClientRect().left) + (i.railXRatio * (i.railXWidth - i.scrollbarXWidth));

    if (newLeft < 0) {
      i.scrollbarXLeft = 0;
    } else if (newLeft > maxLeft) {
      i.scrollbarXLeft = maxLeft;
    } else {
      i.scrollbarXLeft = newLeft;
    }

    var scrollLeft = h.toInt(i.scrollbarXLeft * (i.contentWidth - i.containerWidth) / (i.containerWidth - (i.railXRatio * i.scrollbarXWidth))) - i.negativeScrollAdjustment;
    updateScroll(element, 'left', scrollLeft);
  }

  var mouseMoveHandler = function (e) {
    updateScrollLeft(e.pageX - currentPageX);
    updateGeometry(element);
    e.stopPropagation();
    e.preventDefault();
  };

  var mouseUpHandler = function () {
    h.stopScrolling(element, 'x');
    i.event.unbind(i.ownerDocument, 'mousemove', mouseMoveHandler);
  };

  i.event.bind(i.scrollbarX, 'mousedown', function (e) {
    currentPageX = e.pageX;
    currentLeft = h.toInt(d.css(i.scrollbarX, 'left')) * i.railXRatio;
    h.startScrolling(element, 'x');

    i.event.bind(i.ownerDocument, 'mousemove', mouseMoveHandler);
    i.event.once(i.ownerDocument, 'mouseup', mouseUpHandler);

    e.stopPropagation();
    e.preventDefault();
  });
}

function bindMouseScrollYHandler(element, i) {
  var currentTop = null;
  var currentPageY = null;

  function updateScrollTop(deltaY) {
    var newTop = currentTop + (deltaY * i.railYRatio);
    var maxTop = Math.max(0, i.scrollbarYRail.getBoundingClientRect().top) + (i.railYRatio * (i.railYHeight - i.scrollbarYHeight));

    if (newTop < 0) {
      i.scrollbarYTop = 0;
    } else if (newTop > maxTop) {
      i.scrollbarYTop = maxTop;
    } else {
      i.scrollbarYTop = newTop;
    }

    var scrollTop = h.toInt(i.scrollbarYTop * (i.contentHeight - i.containerHeight) / (i.containerHeight - (i.railYRatio * i.scrollbarYHeight)));
    updateScroll(element, 'top', scrollTop);
  }

  var mouseMoveHandler = function (e) {
    updateScrollTop(e.pageY - currentPageY);
    updateGeometry(element);
    e.stopPropagation();
    e.preventDefault();
  };

  var mouseUpHandler = function () {
    h.stopScrolling(element, 'y');
    i.event.unbind(i.ownerDocument, 'mousemove', mouseMoveHandler);
  };

  i.event.bind(i.scrollbarY, 'mousedown', function (e) {
    currentPageY = e.pageY;
    currentTop = h.toInt(d.css(i.scrollbarY, 'top')) * i.railYRatio;
    h.startScrolling(element, 'y');

    i.event.bind(i.ownerDocument, 'mousemove', mouseMoveHandler);
    i.event.once(i.ownerDocument, 'mouseup', mouseUpHandler);

    e.stopPropagation();
    e.preventDefault();
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindMouseScrollXHandler(element, i);
  bindMouseScrollYHandler(element, i);
};

},{"../../lib/dom":3,"../../lib/helper":6,"../instances":18,"../update-geometry":19,"../update-scroll":20}],12:[function(require,module,exports){
'use strict';

var h = require('../../lib/helper')
  , d = require('../../lib/dom')
  , instances = require('../instances')
  , updateGeometry = require('../update-geometry')
  , updateScroll = require('../update-scroll');

function bindKeyboardHandler(element, i) {
  var hovered = false;
  i.event.bind(element, 'mouseenter', function () {
    hovered = true;
  });
  i.event.bind(element, 'mouseleave', function () {
    hovered = false;
  });

  var shouldPrevent = false;
  function shouldPreventDefault(deltaX, deltaY) {
    var scrollTop = element.scrollTop;
    if (deltaX === 0) {
      if (!i.scrollbarYActive) {
        return false;
      }
      if ((scrollTop === 0 && deltaY > 0) || (scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0)) {
        return !i.settings.wheelPropagation;
      }
    }

    var scrollLeft = element.scrollLeft;
    if (deltaY === 0) {
      if (!i.scrollbarXActive) {
        return false;
      }
      if ((scrollLeft === 0 && deltaX < 0) || (scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0)) {
        return !i.settings.wheelPropagation;
      }
    }
    return true;
  }

  i.event.bind(i.ownerDocument, 'keydown', function (e) {
    if (e.isDefaultPrevented && e.isDefaultPrevented()) {
      return;
    }

    var focused = d.matches(i.scrollbarX, ':focus') ||
                  d.matches(i.scrollbarY, ':focus');

    if (!hovered && !focused) {
      return;
    }

    var activeElement = document.activeElement ? document.activeElement : i.ownerDocument.activeElement;
    if (activeElement) {
      // go deeper if element is a webcomponent
      while (activeElement.shadowRoot) {
        activeElement = activeElement.shadowRoot.activeElement;
      }
      if (h.isEditable(activeElement)) {
        return;
      }
    }

    var deltaX = 0;
    var deltaY = 0;

    switch (e.which) {
    case 37: // left
      deltaX = -30;
      break;
    case 38: // up
      deltaY = 30;
      break;
    case 39: // right
      deltaX = 30;
      break;
    case 40: // down
      deltaY = -30;
      break;
    case 33: // page up
      deltaY = 90;
      break;
    case 32: // space bar
      if (e.shiftKey) {
        deltaY = 90;
      } else {
        deltaY = -90;
      }
      break;
    case 34: // page down
      deltaY = -90;
      break;
    case 35: // end
      if (e.ctrlKey) {
        deltaY = -i.contentHeight;
      } else {
        deltaY = -i.containerHeight;
      }
      break;
    case 36: // home
      if (e.ctrlKey) {
        deltaY = element.scrollTop;
      } else {
        deltaY = i.containerHeight;
      }
      break;
    default:
      return;
    }

    updateScroll(element, 'top', element.scrollTop - deltaY);
    updateScroll(element, 'left', element.scrollLeft + deltaX);
    updateGeometry(element);

    shouldPrevent = shouldPreventDefault(deltaX, deltaY);
    if (shouldPrevent) {
      e.preventDefault();
    }
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindKeyboardHandler(element, i);
};

},{"../../lib/dom":3,"../../lib/helper":6,"../instances":18,"../update-geometry":19,"../update-scroll":20}],13:[function(require,module,exports){
'use strict';

var instances = require('../instances')
  , updateGeometry = require('../update-geometry')
  , updateScroll = require('../update-scroll');

function bindMouseWheelHandler(element, i) {
  var shouldPrevent = false;

  function shouldPreventDefault(deltaX, deltaY) {
    var scrollTop = element.scrollTop;
    if (deltaX === 0) {
      if (!i.scrollbarYActive) {
        return false;
      }
      if ((scrollTop === 0 && deltaY > 0) || (scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0)) {
        return !i.settings.wheelPropagation;
      }
    }

    var scrollLeft = element.scrollLeft;
    if (deltaY === 0) {
      if (!i.scrollbarXActive) {
        return false;
      }
      if ((scrollLeft === 0 && deltaX < 0) || (scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0)) {
        return !i.settings.wheelPropagation;
      }
    }
    return true;
  }

  function getDeltaFromEvent(e) {
    var deltaX = e.deltaX;
    var deltaY = -1 * e.deltaY;

    if (typeof deltaX === "undefined" || typeof deltaY === "undefined") {
      // OS X Safari
      deltaX = -1 * e.wheelDeltaX / 6;
      deltaY = e.wheelDeltaY / 6;
    }

    if (e.deltaMode && e.deltaMode === 1) {
      // Firefox in deltaMode 1: Line scrolling
      deltaX *= 10;
      deltaY *= 10;
    }

    if (deltaX !== deltaX && deltaY !== deltaY/* NaN checks */) {
      // IE in some mouse drivers
      deltaX = 0;
      deltaY = e.wheelDelta;
    }

    return [deltaX, deltaY];
  }

  function shouldBeConsumedByTextarea(deltaX, deltaY) {
    var hoveredTextarea = element.querySelector('textarea:hover');
    if (hoveredTextarea) {
      var maxScrollTop = hoveredTextarea.scrollHeight - hoveredTextarea.clientHeight;
      if (maxScrollTop > 0) {
        if (!(hoveredTextarea.scrollTop === 0 && deltaY > 0) &&
            !(hoveredTextarea.scrollTop === maxScrollTop && deltaY < 0)) {
          return true;
        }
      }
      var maxScrollLeft = hoveredTextarea.scrollLeft - hoveredTextarea.clientWidth;
      if (maxScrollLeft > 0) {
        if (!(hoveredTextarea.scrollLeft === 0 && deltaX < 0) &&
            !(hoveredTextarea.scrollLeft === maxScrollLeft && deltaX > 0)) {
          return true;
        }
      }
    }
    return false;
  }

  function mousewheelHandler(e) {
    var delta = getDeltaFromEvent(e);

    var deltaX = delta[0];
    var deltaY = delta[1];

    if (shouldBeConsumedByTextarea(deltaX, deltaY)) {
      return;
    }

    shouldPrevent = false;
    if (!i.settings.useBothWheelAxes) {
      // deltaX will only be used for horizontal scrolling and deltaY will
      // only be used for vertical scrolling - this is the default
      updateScroll(element, 'top', element.scrollTop - (deltaY * i.settings.wheelSpeed));
      updateScroll(element, 'left', element.scrollLeft + (deltaX * i.settings.wheelSpeed));
    } else if (i.scrollbarYActive && !i.scrollbarXActive) {
      // only vertical scrollbar is active and useBothWheelAxes option is
      // active, so let's scroll vertical bar using both mouse wheel axes
      if (deltaY) {
        updateScroll(element, 'top', element.scrollTop - (deltaY * i.settings.wheelSpeed));
      } else {
        updateScroll(element, 'top', element.scrollTop + (deltaX * i.settings.wheelSpeed));
      }
      shouldPrevent = true;
    } else if (i.scrollbarXActive && !i.scrollbarYActive) {
      // useBothWheelAxes and only horizontal bar is active, so use both
      // wheel axes for horizontal bar
      if (deltaX) {
        updateScroll(element, 'left', element.scrollLeft + (deltaX * i.settings.wheelSpeed));
      } else {
        updateScroll(element, 'left', element.scrollLeft - (deltaY * i.settings.wheelSpeed));
      }
      shouldPrevent = true;
    }

    updateGeometry(element);

    shouldPrevent = (shouldPrevent || shouldPreventDefault(deltaX, deltaY));
    if (shouldPrevent) {
      e.stopPropagation();
      e.preventDefault();
    }
  }

  if (typeof window.onwheel !== "undefined") {
    i.event.bind(element, 'wheel', mousewheelHandler);
  } else if (typeof window.onmousewheel !== "undefined") {
    i.event.bind(element, 'mousewheel', mousewheelHandler);
  }
}

module.exports = function (element) {
  var i = instances.get(element);
  bindMouseWheelHandler(element, i);
};

},{"../instances":18,"../update-geometry":19,"../update-scroll":20}],14:[function(require,module,exports){
'use strict';

var instances = require('../instances')
  , updateGeometry = require('../update-geometry');

function bindNativeScrollHandler(element, i) {
  i.event.bind(element, 'scroll', function () {
    updateGeometry(element);
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindNativeScrollHandler(element, i);
};

},{"../instances":18,"../update-geometry":19}],15:[function(require,module,exports){
'use strict';

var h = require('../../lib/helper')
  , instances = require('../instances')
  , updateGeometry = require('../update-geometry')
  , updateScroll = require('../update-scroll');

function bindSelectionHandler(element, i) {
  function getRangeNode() {
    var selection = window.getSelection ? window.getSelection() :
                    document.getSelection ? document.getSelection() : '';
    if (selection.toString().length === 0) {
      return null;
    } else {
      return selection.getRangeAt(0).commonAncestorContainer;
    }
  }

  var scrollingLoop = null;
  var scrollDiff = {top: 0, left: 0};
  function startScrolling() {
    if (!scrollingLoop) {
      scrollingLoop = setInterval(function () {
        if (!instances.get(element)) {
          clearInterval(scrollingLoop);
          return;
        }

        updateScroll(element, 'top', element.scrollTop + scrollDiff.top);
        updateScroll(element, 'left', element.scrollLeft + scrollDiff.left);
        updateGeometry(element);
      }, 50); // every .1 sec
    }
  }
  function stopScrolling() {
    if (scrollingLoop) {
      clearInterval(scrollingLoop);
      scrollingLoop = null;
    }
    h.stopScrolling(element);
  }

  var isSelected = false;
  i.event.bind(i.ownerDocument, 'selectionchange', function () {
    if (element.contains(getRangeNode())) {
      isSelected = true;
    } else {
      isSelected = false;
      stopScrolling();
    }
  });
  i.event.bind(window, 'mouseup', function () {
    if (isSelected) {
      isSelected = false;
      stopScrolling();
    }
  });

  i.event.bind(window, 'mousemove', function (e) {
    if (isSelected) {
      var mousePosition = {x: e.pageX, y: e.pageY};
      var containerGeometry = {
        left: element.offsetLeft,
        right: element.offsetLeft + element.offsetWidth,
        top: element.offsetTop,
        bottom: element.offsetTop + element.offsetHeight
      };

      if (mousePosition.x < containerGeometry.left + 3) {
        scrollDiff.left = -5;
        h.startScrolling(element, 'x');
      } else if (mousePosition.x > containerGeometry.right - 3) {
        scrollDiff.left = 5;
        h.startScrolling(element, 'x');
      } else {
        scrollDiff.left = 0;
      }

      if (mousePosition.y < containerGeometry.top + 3) {
        if (containerGeometry.top + 3 - mousePosition.y < 5) {
          scrollDiff.top = -5;
        } else {
          scrollDiff.top = -20;
        }
        h.startScrolling(element, 'y');
      } else if (mousePosition.y > containerGeometry.bottom - 3) {
        if (mousePosition.y - containerGeometry.bottom + 3 < 5) {
          scrollDiff.top = 5;
        } else {
          scrollDiff.top = 20;
        }
        h.startScrolling(element, 'y');
      } else {
        scrollDiff.top = 0;
      }

      if (scrollDiff.top === 0 && scrollDiff.left === 0) {
        stopScrolling();
      } else {
        startScrolling();
      }
    }
  });
}

module.exports = function (element) {
  var i = instances.get(element);
  bindSelectionHandler(element, i);
};

},{"../../lib/helper":6,"../instances":18,"../update-geometry":19,"../update-scroll":20}],16:[function(require,module,exports){
'use strict';

var instances = require('../instances')
  , updateGeometry = require('../update-geometry')
  , updateScroll = require('../update-scroll');

function bindTouchHandler(element, i, supportsTouch, supportsIePointer) {
  function shouldPreventDefault(deltaX, deltaY) {
    var scrollTop = element.scrollTop;
    var scrollLeft = element.scrollLeft;
    var magnitudeX = Math.abs(deltaX);
    var magnitudeY = Math.abs(deltaY);

    if (magnitudeY > magnitudeX) {
      // user is perhaps trying to swipe up/down the page

      if (((deltaY < 0) && (scrollTop === i.contentHeight - i.containerHeight)) ||
          ((deltaY > 0) && (scrollTop === 0))) {
        return !i.settings.swipePropagation;
      }
    } else if (magnitudeX > magnitudeY) {
      // user is perhaps trying to swipe left/right across the page

      if (((deltaX < 0) && (scrollLeft === i.contentWidth - i.containerWidth)) ||
          ((deltaX > 0) && (scrollLeft === 0))) {
        return !i.settings.swipePropagation;
      }
    }

    return true;
  }

  function applyTouchMove(differenceX, differenceY) {
    updateScroll(element, 'top', element.scrollTop - differenceY);
    updateScroll(element, 'left', element.scrollLeft - differenceX);

    updateGeometry(element);
  }

  var startOffset = {};
  var startTime = 0;
  var speed = {};
  var easingLoop = null;
  var inGlobalTouch = false;
  var inLocalTouch = false;

  function globalTouchStart() {
    inGlobalTouch = true;
  }
  function globalTouchEnd() {
    inGlobalTouch = false;
  }

  function getTouch(e) {
    if (e.targetTouches) {
      return e.targetTouches[0];
    } else {
      // Maybe IE pointer
      return e;
    }
  }
  function shouldHandle(e) {
    if (e.targetTouches && e.targetTouches.length === 1) {
      return true;
    }
    if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== e.MSPOINTER_TYPE_MOUSE) {
      return true;
    }
    return false;
  }
  function touchStart(e) {
    if (shouldHandle(e)) {
      inLocalTouch = true;

      var touch = getTouch(e);

      startOffset.pageX = touch.pageX;
      startOffset.pageY = touch.pageY;

      startTime = (new Date()).getTime();

      if (easingLoop !== null) {
        clearInterval(easingLoop);
      }

      e.stopPropagation();
    }
  }
  function touchMove(e) {
    if (!inGlobalTouch && inLocalTouch && shouldHandle(e)) {
      var touch = getTouch(e);

      var currentOffset = {pageX: touch.pageX, pageY: touch.pageY};

      var differenceX = currentOffset.pageX - startOffset.pageX;
      var differenceY = currentOffset.pageY - startOffset.pageY;

      applyTouchMove(differenceX, differenceY);
      startOffset = currentOffset;

      var currentTime = (new Date()).getTime();

      var timeGap = currentTime - startTime;
      if (timeGap > 0) {
        speed.x = differenceX / timeGap;
        speed.y = differenceY / timeGap;
        startTime = currentTime;
      }

      if (shouldPreventDefault(differenceX, differenceY)) {
        e.stopPropagation();
        e.preventDefault();
      }
    }
  }
  function touchEnd() {
    if (!inGlobalTouch && inLocalTouch) {
      inLocalTouch = false;

      clearInterval(easingLoop);
      easingLoop = setInterval(function () {
        if (!instances.get(element)) {
          clearInterval(easingLoop);
          return;
        }

        if (Math.abs(speed.x) < 0.01 && Math.abs(speed.y) < 0.01) {
          clearInterval(easingLoop);
          return;
        }

        applyTouchMove(speed.x * 30, speed.y * 30);

        speed.x *= 0.8;
        speed.y *= 0.8;
      }, 10);
    }
  }

  if (supportsTouch) {
    i.event.bind(window, 'touchstart', globalTouchStart);
    i.event.bind(window, 'touchend', globalTouchEnd);
    i.event.bind(element, 'touchstart', touchStart);
    i.event.bind(element, 'touchmove', touchMove);
    i.event.bind(element, 'touchend', touchEnd);
  }

  if (supportsIePointer) {
    if (window.PointerEvent) {
      i.event.bind(window, 'pointerdown', globalTouchStart);
      i.event.bind(window, 'pointerup', globalTouchEnd);
      i.event.bind(element, 'pointerdown', touchStart);
      i.event.bind(element, 'pointermove', touchMove);
      i.event.bind(element, 'pointerup', touchEnd);
    } else if (window.MSPointerEvent) {
      i.event.bind(window, 'MSPointerDown', globalTouchStart);
      i.event.bind(window, 'MSPointerUp', globalTouchEnd);
      i.event.bind(element, 'MSPointerDown', touchStart);
      i.event.bind(element, 'MSPointerMove', touchMove);
      i.event.bind(element, 'MSPointerUp', touchEnd);
    }
  }
}

module.exports = function (element, supportsTouch, supportsIePointer) {
  var i = instances.get(element);
  bindTouchHandler(element, i, supportsTouch, supportsIePointer);
};

},{"../instances":18,"../update-geometry":19,"../update-scroll":20}],17:[function(require,module,exports){
'use strict';

var cls = require('../lib/class')
  , h = require('../lib/helper')
  , instances = require('./instances')
  , updateGeometry = require('./update-geometry');

// Handlers
var clickRailHandler = require('./handler/click-rail')
  , dragScrollbarHandler = require('./handler/drag-scrollbar')
  , keyboardHandler = require('./handler/keyboard')
  , mouseWheelHandler = require('./handler/mouse-wheel')
  , nativeScrollHandler = require('./handler/native-scroll')
  , selectionHandler = require('./handler/selection')
  , touchHandler = require('./handler/touch');

module.exports = function (element, userSettings) {
  userSettings = typeof userSettings === 'object' ? userSettings : {};

  cls.add(element, 'ps-container');

  // Create a plugin instance.
  var i = instances.add(element);

  i.settings = h.extend(i.settings, userSettings);
  cls.add(element, 'ps-theme-' + i.settings.theme);

  clickRailHandler(element);
  dragScrollbarHandler(element);
  mouseWheelHandler(element);
  nativeScrollHandler(element);

  if (i.settings.useSelectionScroll) {
    selectionHandler(element);
  }

  if (h.env.supportsTouch || h.env.supportsIePointer) {
    touchHandler(element, h.env.supportsTouch, h.env.supportsIePointer);
  }
  if (i.settings.useKeyboard) {
    keyboardHandler(element);
  }

  updateGeometry(element);
};

},{"../lib/class":2,"../lib/helper":6,"./handler/click-rail":10,"./handler/drag-scrollbar":11,"./handler/keyboard":12,"./handler/mouse-wheel":13,"./handler/native-scroll":14,"./handler/selection":15,"./handler/touch":16,"./instances":18,"./update-geometry":19}],18:[function(require,module,exports){
'use strict';

var cls = require('../lib/class')
  , d = require('../lib/dom')
  , defaultSettings = require('./default-setting')
  , EventManager = require('../lib/event-manager')
  , guid = require('../lib/guid')
  , h = require('../lib/helper');

var instances = {};

function Instance(element) {
  var i = this;

  i.settings = h.clone(defaultSettings);
  i.containerWidth = null;
  i.containerHeight = null;
  i.contentWidth = null;
  i.contentHeight = null;

  i.isRtl = d.css(element, 'direction') === "rtl";
  i.isNegativeScroll = (function () {
    var originalScrollLeft = element.scrollLeft;
    var result = null;
    element.scrollLeft = -1;
    result = element.scrollLeft < 0;
    element.scrollLeft = originalScrollLeft;
    return result;
  })();
  i.negativeScrollAdjustment = i.isNegativeScroll ? element.scrollWidth - element.clientWidth : 0;
  i.event = new EventManager();
  i.ownerDocument = element.ownerDocument || document;

  function focus() {
    cls.add(element, 'ps-focus');
  }

  function blur() {
    cls.remove(element, 'ps-focus');
  }

  i.scrollbarXRail = d.appendTo(d.e('div', 'ps-scrollbar-x-rail'), element);
  i.scrollbarX = d.appendTo(d.e('div', 'ps-scrollbar-x'), i.scrollbarXRail);
  i.scrollbarX.setAttribute('tabindex', 0);
  i.event.bind(i.scrollbarX, 'focus', focus);
  i.event.bind(i.scrollbarX, 'blur', blur);
  i.scrollbarXActive = null;
  i.scrollbarXWidth = null;
  i.scrollbarXLeft = null;
  i.scrollbarXBottom = h.toInt(d.css(i.scrollbarXRail, 'bottom'));
  i.isScrollbarXUsingBottom = i.scrollbarXBottom === i.scrollbarXBottom; // !isNaN
  i.scrollbarXTop = i.isScrollbarXUsingBottom ? null : h.toInt(d.css(i.scrollbarXRail, 'top'));
  i.railBorderXWidth = h.toInt(d.css(i.scrollbarXRail, 'borderLeftWidth')) + h.toInt(d.css(i.scrollbarXRail, 'borderRightWidth'));
  // Set rail to display:block to calculate margins
  d.css(i.scrollbarXRail, 'display', 'block');
  i.railXMarginWidth = h.toInt(d.css(i.scrollbarXRail, 'marginLeft')) + h.toInt(d.css(i.scrollbarXRail, 'marginRight'));
  d.css(i.scrollbarXRail, 'display', '');
  i.railXWidth = null;
  i.railXRatio = null;

  i.scrollbarYRail = d.appendTo(d.e('div', 'ps-scrollbar-y-rail'), element);
  i.scrollbarY = d.appendTo(d.e('div', 'ps-scrollbar-y'), i.scrollbarYRail);
  i.scrollbarY.setAttribute('tabindex', 0);
  i.event.bind(i.scrollbarY, 'focus', focus);
  i.event.bind(i.scrollbarY, 'blur', blur);
  i.scrollbarYActive = null;
  i.scrollbarYHeight = null;
  i.scrollbarYTop = null;
  i.scrollbarYRight = h.toInt(d.css(i.scrollbarYRail, 'right'));
  i.isScrollbarYUsingRight = i.scrollbarYRight === i.scrollbarYRight; // !isNaN
  i.scrollbarYLeft = i.isScrollbarYUsingRight ? null : h.toInt(d.css(i.scrollbarYRail, 'left'));
  i.scrollbarYOuterWidth = i.isRtl ? h.outerWidth(i.scrollbarY) : null;
  i.railBorderYWidth = h.toInt(d.css(i.scrollbarYRail, 'borderTopWidth')) + h.toInt(d.css(i.scrollbarYRail, 'borderBottomWidth'));
  d.css(i.scrollbarYRail, 'display', 'block');
  i.railYMarginHeight = h.toInt(d.css(i.scrollbarYRail, 'marginTop')) + h.toInt(d.css(i.scrollbarYRail, 'marginBottom'));
  d.css(i.scrollbarYRail, 'display', '');
  i.railYHeight = null;
  i.railYRatio = null;
}

function getId(element) {
  if (typeof element.dataset === 'undefined') {
    return element.getAttribute('data-ps-id');
  } else {
    return element.dataset.psId;
  }
}

function setId(element, id) {
  if (typeof element.dataset === 'undefined') {
    element.setAttribute('data-ps-id', id);
  } else {
    element.dataset.psId = id;
  }
}

function removeId(element) {
  if (typeof element.dataset === 'undefined') {
    element.removeAttribute('data-ps-id');
  } else {
    delete element.dataset.psId;
  }
}

exports.add = function (element) {
  var newId = guid();
  setId(element, newId);
  instances[newId] = new Instance(element);
  return instances[newId];
};

exports.remove = function (element) {
  delete instances[getId(element)];
  removeId(element);
};

exports.get = function (element) {
  return instances[getId(element)];
};

},{"../lib/class":2,"../lib/dom":3,"../lib/event-manager":4,"../lib/guid":5,"../lib/helper":6,"./default-setting":8}],19:[function(require,module,exports){
'use strict';

var cls = require('../lib/class')
  , d = require('../lib/dom')
  , h = require('../lib/helper')
  , instances = require('./instances')
  , updateScroll = require('./update-scroll');

function getThumbSize(i, thumbSize) {
  if (i.settings.minScrollbarLength) {
    thumbSize = Math.max(thumbSize, i.settings.minScrollbarLength);
  }
  if (i.settings.maxScrollbarLength) {
    thumbSize = Math.min(thumbSize, i.settings.maxScrollbarLength);
  }
  return thumbSize;
}

function updateCss(element, i) {
  var xRailOffset = {width: i.railXWidth};
  if (i.isRtl) {
    xRailOffset.left = i.negativeScrollAdjustment + element.scrollLeft + i.containerWidth - i.contentWidth;
  } else {
    xRailOffset.left = element.scrollLeft;
  }
  if (i.isScrollbarXUsingBottom) {
    xRailOffset.bottom = i.scrollbarXBottom - element.scrollTop;
  } else {
    xRailOffset.top = i.scrollbarXTop + element.scrollTop;
  }
  d.css(i.scrollbarXRail, xRailOffset);

  var yRailOffset = {top: element.scrollTop, height: i.railYHeight};
  if (i.isScrollbarYUsingRight) {
    if (i.isRtl) {
      yRailOffset.right = i.contentWidth - (i.negativeScrollAdjustment + element.scrollLeft) - i.scrollbarYRight - i.scrollbarYOuterWidth;
    } else {
      yRailOffset.right = i.scrollbarYRight - element.scrollLeft;
    }
  } else {
    if (i.isRtl) {
      yRailOffset.left = i.negativeScrollAdjustment + element.scrollLeft + i.containerWidth * 2 - i.contentWidth - i.scrollbarYLeft - i.scrollbarYOuterWidth;
    } else {
      yRailOffset.left = i.scrollbarYLeft + element.scrollLeft;
    }
  }
  d.css(i.scrollbarYRail, yRailOffset);

  d.css(i.scrollbarX, {left: i.scrollbarXLeft, width: i.scrollbarXWidth - i.railBorderXWidth});
  d.css(i.scrollbarY, {top: i.scrollbarYTop, height: i.scrollbarYHeight - i.railBorderYWidth});
}

module.exports = function (element) {
  var i = instances.get(element);

  i.containerWidth = element.clientWidth;
  i.containerHeight = element.clientHeight;
  i.contentWidth = element.scrollWidth;
  i.contentHeight = element.scrollHeight;

  var existingRails;
  if (!element.contains(i.scrollbarXRail)) {
    existingRails = d.queryChildren(element, '.ps-scrollbar-x-rail');
    if (existingRails.length > 0) {
      existingRails.forEach(function (rail) {
        d.remove(rail);
      });
    }
    d.appendTo(i.scrollbarXRail, element);
  }
  if (!element.contains(i.scrollbarYRail)) {
    existingRails = d.queryChildren(element, '.ps-scrollbar-y-rail');
    if (existingRails.length > 0) {
      existingRails.forEach(function (rail) {
        d.remove(rail);
      });
    }
    d.appendTo(i.scrollbarYRail, element);
  }

  if (!i.settings.suppressScrollX && i.containerWidth + i.settings.scrollXMarginOffset < i.contentWidth) {
    i.scrollbarXActive = true;
    i.railXWidth = i.containerWidth - i.railXMarginWidth;
    i.railXRatio = i.containerWidth / i.railXWidth;
    i.scrollbarXWidth = getThumbSize(i, h.toInt(i.railXWidth * i.containerWidth / i.contentWidth));
    i.scrollbarXLeft = h.toInt((i.negativeScrollAdjustment + element.scrollLeft) * (i.railXWidth - i.scrollbarXWidth) / (i.contentWidth - i.containerWidth));
  } else {
    i.scrollbarXActive = false;
  }

  if (!i.settings.suppressScrollY && i.containerHeight + i.settings.scrollYMarginOffset < i.contentHeight) {
    i.scrollbarYActive = true;
    i.railYHeight = i.containerHeight - i.railYMarginHeight;
    i.railYRatio = i.containerHeight / i.railYHeight;
    i.scrollbarYHeight = getThumbSize(i, h.toInt(i.railYHeight * i.containerHeight / i.contentHeight));
    i.scrollbarYTop = h.toInt(element.scrollTop * (i.railYHeight - i.scrollbarYHeight) / (i.contentHeight - i.containerHeight));
  } else {
    i.scrollbarYActive = false;
  }

  if (i.scrollbarXLeft >= i.railXWidth - i.scrollbarXWidth) {
    i.scrollbarXLeft = i.railXWidth - i.scrollbarXWidth;
  }
  if (i.scrollbarYTop >= i.railYHeight - i.scrollbarYHeight) {
    i.scrollbarYTop = i.railYHeight - i.scrollbarYHeight;
  }

  updateCss(element, i);

  if (i.scrollbarXActive) {
    cls.add(element, 'ps-active-x');
  } else {
    cls.remove(element, 'ps-active-x');
    i.scrollbarXWidth = 0;
    i.scrollbarXLeft = 0;
    updateScroll(element, 'left', 0);
  }
  if (i.scrollbarYActive) {
    cls.add(element, 'ps-active-y');
  } else {
    cls.remove(element, 'ps-active-y');
    i.scrollbarYHeight = 0;
    i.scrollbarYTop = 0;
    updateScroll(element, 'top', 0);
  }
};

},{"../lib/class":2,"../lib/dom":3,"../lib/helper":6,"./instances":18,"./update-scroll":20}],20:[function(require,module,exports){
'use strict';

var instances = require('./instances');

var upEvent = document.createEvent('Event')
  , downEvent = document.createEvent('Event')
  , leftEvent = document.createEvent('Event')
  , rightEvent = document.createEvent('Event')
  , yEvent = document.createEvent('Event')
  , xEvent = document.createEvent('Event')
  , xStartEvent = document.createEvent('Event')
  , xEndEvent = document.createEvent('Event')
  , yStartEvent = document.createEvent('Event')
  , yEndEvent = document.createEvent('Event')
  , lastTop
  , lastLeft;

upEvent.initEvent('ps-scroll-up', true, true);
downEvent.initEvent('ps-scroll-down', true, true);
leftEvent.initEvent('ps-scroll-left', true, true);
rightEvent.initEvent('ps-scroll-right', true, true);
yEvent.initEvent('ps-scroll-y', true, true);
xEvent.initEvent('ps-scroll-x', true, true);
xStartEvent.initEvent('ps-x-reach-start', true, true);
xEndEvent.initEvent('ps-x-reach-end', true, true);
yStartEvent.initEvent('ps-y-reach-start', true, true);
yEndEvent.initEvent('ps-y-reach-end', true, true);

module.exports = function (element, axis, value) {
  if (typeof element === 'undefined') {
    throw 'You must provide an element to the update-scroll function';
  }

  if (typeof axis === 'undefined') {
    throw 'You must provide an axis to the update-scroll function';
  }

  if (typeof value === 'undefined') {
    throw 'You must provide a value to the update-scroll function';
  }

  if (axis === 'top' && value <= 0) {
    element.scrollTop = value = 0; // don't allow negative scroll
    element.dispatchEvent(yStartEvent);
  }

  if (axis === 'left' && value <= 0) {
    element.scrollLeft = value = 0; // don't allow negative scroll
    element.dispatchEvent(xStartEvent);
  }

  var i = instances.get(element);

  if (axis === 'top' && value >= i.contentHeight - i.containerHeight) {
    element.scrollTop = value = i.contentHeight - i.containerHeight; // don't allow scroll past container
    element.dispatchEvent(yEndEvent);
  }

  if (axis === 'left' && value >= i.contentWidth - i.containerWidth) {
    element.scrollLeft = value = i.contentWidth - i.containerWidth; // don't allow scroll past container
    element.dispatchEvent(xEndEvent);
  }

  if (!lastTop) {
    lastTop = element.scrollTop;
  }

  if (!lastLeft) {
    lastLeft = element.scrollLeft;
  }

  if (axis === 'top' && value < lastTop) {
    element.dispatchEvent(upEvent);
  }

  if (axis === 'top' && value > lastTop) {
    element.dispatchEvent(downEvent);
  }

  if (axis === 'left' && value < lastLeft) {
    element.dispatchEvent(leftEvent);
  }

  if (axis === 'left' && value > lastLeft) {
    element.dispatchEvent(rightEvent);
  }

  if (axis === 'top') {
    element.scrollTop = lastTop = value;
    element.dispatchEvent(yEvent);
  }

  if (axis === 'left') {
    element.scrollLeft = lastLeft = value;
    element.dispatchEvent(xEvent);
  }

};

},{"./instances":18}],21:[function(require,module,exports){
'use strict';

var d = require('../lib/dom')
  , h = require('../lib/helper')
  , instances = require('./instances')
  , updateGeometry = require('./update-geometry')
  , updateScroll = require('./update-scroll');

module.exports = function (element) {
  var i = instances.get(element);

  if (!i) {
    return;
  }

  // Recalcuate negative scrollLeft adjustment
  i.negativeScrollAdjustment = i.isNegativeScroll ? element.scrollWidth - element.clientWidth : 0;

  // Recalculate rail margins
  d.css(i.scrollbarXRail, 'display', 'block');
  d.css(i.scrollbarYRail, 'display', 'block');
  i.railXMarginWidth = h.toInt(d.css(i.scrollbarXRail, 'marginLeft')) + h.toInt(d.css(i.scrollbarXRail, 'marginRight'));
  i.railYMarginHeight = h.toInt(d.css(i.scrollbarYRail, 'marginTop')) + h.toInt(d.css(i.scrollbarYRail, 'marginBottom'));

  // Hide scrollbars not to affect scrollWidth and scrollHeight
  d.css(i.scrollbarXRail, 'display', 'none');
  d.css(i.scrollbarYRail, 'display', 'none');

  updateGeometry(element);

  // Update top/left scroll to trigger events
  updateScroll(element, 'top', element.scrollTop);
  updateScroll(element, 'left', element.scrollLeft);

  d.css(i.scrollbarXRail, 'display', '');
  d.css(i.scrollbarYRail, 'display', '');
};

},{"../lib/dom":3,"../lib/helper":6,"./instances":18,"./update-geometry":19,"./update-scroll":20}]},{},[1]);


/***/ }),
/* 433 */
/***/ (function(module, exports) {

/*! responsive-nav.js 1.0.39
 * https://github.com/viljamis/responsive-nav.js
 * http://responsive-nav.com
 *
 * Copyright (c) 2015 @viljamis
 * Available under the MIT license
 */

/* global Event */
(function (document, window, index) {
  // Index is used to keep multiple navs on the same page namespaced

  "use strict";

  var responsiveNav = function (el, options) {

    var computed = !!window.getComputedStyle;
    
    /**
     * getComputedStyle polyfill for old browsers
     */
    if (!computed) {
      window.getComputedStyle = function(el) {
        this.el = el;
        this.getPropertyValue = function(prop) {
          var re = /(\-([a-z]){1})/g;
          if (prop === "float") {
            prop = "styleFloat";
          }
          if (re.test(prop)) {
            prop = prop.replace(re, function () {
              return arguments[2].toUpperCase();
            });
          }
          return el.currentStyle[prop] ? el.currentStyle[prop] : null;
        };
        return this;
      };
    }
    /* exported addEvent, removeEvent, getChildren, setAttributes, addClass, removeClass, forEach */
    
    /**
     * Add Event
     * fn arg can be an object or a function, thanks to handleEvent
     * read more at: http://www.thecssninja.com/javascript/handleevent
     *
     * @param  {element}  element
     * @param  {event}    event
     * @param  {Function} fn
     * @param  {boolean}  bubbling
     */
    var addEvent = function (el, evt, fn, bubble) {
        if ("addEventListener" in el) {
          // BBOS6 doesn't support handleEvent, catch and polyfill
          try {
            el.addEventListener(evt, fn, bubble);
          } catch (e) {
            if (typeof fn === "object" && fn.handleEvent) {
              el.addEventListener(evt, function (e) {
                // Bind fn as this and set first arg as event object
                fn.handleEvent.call(fn, e);
              }, bubble);
            } else {
              throw e;
            }
          }
        } else if ("attachEvent" in el) {
          // check if the callback is an object and contains handleEvent
          if (typeof fn === "object" && fn.handleEvent) {
            el.attachEvent("on" + evt, function () {
              // Bind fn as this
              fn.handleEvent.call(fn);
            });
          } else {
            el.attachEvent("on" + evt, fn);
          }
        }
      },
    
      /**
       * Remove Event
       *
       * @param  {element}  element
       * @param  {event}    event
       * @param  {Function} fn
       * @param  {boolean}  bubbling
       */
      removeEvent = function (el, evt, fn, bubble) {
        if ("removeEventListener" in el) {
          try {
            el.removeEventListener(evt, fn, bubble);
          } catch (e) {
            if (typeof fn === "object" && fn.handleEvent) {
              el.removeEventListener(evt, function (e) {
                fn.handleEvent.call(fn, e);
              }, bubble);
            } else {
              throw e;
            }
          }
        } else if ("detachEvent" in el) {
          if (typeof fn === "object" && fn.handleEvent) {
            el.detachEvent("on" + evt, function () {
              fn.handleEvent.call(fn);
            });
          } else {
            el.detachEvent("on" + evt, fn);
          }
        }
      },
    
      /**
       * Get the children of any element
       *
       * @param  {element}
       * @return {array} Returns matching elements in an array
       */
      getChildren = function (e) {
        if (e.children.length < 1) {
          throw new Error("The Nav container has no containing elements");
        }
        // Store all children in array
        var children = [];
        // Loop through children and store in array if child != TextNode
        for (var i = 0; i < e.children.length; i++) {
          if (e.children[i].nodeType === 1) {
            children.push(e.children[i]);
          }
        }
        return children;
      },
    
      /**
       * Sets multiple attributes at once
       *
       * @param {element} element
       * @param {attrs}   attrs
       */
      setAttributes = function (el, attrs) {
        for (var key in attrs) {
          el.setAttribute(key, attrs[key]);
        }
      },
    
      /**
       * Adds a class to any element
       *
       * @param {element} element
       * @param {string}  class
       */
      addClass = function (el, cls) {
        if (el.className.indexOf(cls) !== 0) {
          el.className += " " + cls;
          el.className = el.className.replace(/(^\s*)|(\s*$)/g,"");
        }
      },
    
      /**
       * Remove a class from any element
       *
       * @param  {element} element
       * @param  {string}  class
       */
      removeClass = function (el, cls) {
        var reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
        el.className = el.className.replace(reg, " ").replace(/(^\s*)|(\s*$)/g,"");
      },
    
      /**
       * forEach method that passes back the stuff we need
       *
       * @param  {array}    array
       * @param  {Function} callback
       * @param  {scope}    scope
       */
      forEach = function (array, callback, scope) {
        for (var i = 0; i < array.length; i++) {
          callback.call(scope, i, array[i]);
        }
      };

    var nav,
      opts,
      navToggle,
      styleElement = document.createElement("style"),
      htmlEl = document.documentElement,
      hasAnimFinished,
      isMobile,
      navOpen;

    var ResponsiveNav = function (el, options) {
        var i;

        /**
         * Default options
         * @type {Object}
         */
        this.options = {
          animate: true,                    // Boolean: Use CSS3 transitions, true or false
          transition: 284,                  // Integer: Speed of the transition, in milliseconds
          label: "Menu",                    // String: Label for the navigation toggle
          insert: "before",                 // String: Insert the toggle before or after the navigation
          customToggle: "",                 // Selector: Specify the ID of a custom toggle
          closeOnNavClick: false,           // Boolean: Close the navigation when one of the links are clicked
          openPos: "relative",              // String: Position of the opened nav, relative or static
          navClass: "nav-collapse",         // String: Default CSS class. If changed, you need to edit the CSS too!
          navActiveClass: "js-nav-active",  // String: Class that is added to <html> element when nav is active
          jsClass: "js",                    // String: 'JS enabled' class which is added to <html> element
          init: function(){},               // Function: Init callback
          open: function(){},               // Function: Open callback
          close: function(){}               // Function: Close callback
        };

        // User defined options
        for (i in options) {
          this.options[i] = options[i];
        }

        // Adds "js" class for <html>
        addClass(htmlEl, this.options.jsClass);

        // Wrapper
        this.wrapperEl = el.replace("#", "");

        // Try selecting ID first
        if (document.getElementById(this.wrapperEl)) {
          this.wrapper = document.getElementById(this.wrapperEl);

        // If element with an ID doesn't exist, use querySelector
        } else if (document.querySelector(this.wrapperEl)) {
          this.wrapper = document.querySelector(this.wrapperEl);

        // If element doesn't exists, stop here.
        } else {
          throw new Error("The nav element you are trying to select doesn't exist");
        }

        // Inner wrapper
        this.wrapper.inner = getChildren(this.wrapper);

        // For minification
        opts = this.options;
        nav = this.wrapper;

        // Init
        this._init(this);
      };

    ResponsiveNav.prototype = {

      /**
       * Unattaches events and removes any classes that were added
       */
      destroy: function () {
        this._removeStyles();
        removeClass(nav, "closed");
        removeClass(nav, "opened");
        removeClass(nav, opts.navClass);
        removeClass(nav, opts.navClass + "-" + this.index);
        removeClass(htmlEl, opts.navActiveClass);
        nav.removeAttribute("style");
        nav.removeAttribute("aria-hidden");

        removeEvent(window, "resize", this, false);
        removeEvent(window, "focus", this, false);
        removeEvent(document.body, "touchmove", this, false);
        removeEvent(navToggle, "touchstart", this, false);
        removeEvent(navToggle, "touchend", this, false);
        removeEvent(navToggle, "mouseup", this, false);
        removeEvent(navToggle, "keyup", this, false);
        removeEvent(navToggle, "click", this, false);

        if (!opts.customToggle) {
          navToggle.parentNode.removeChild(navToggle);
        } else {
          navToggle.removeAttribute("aria-hidden");
        }
      },

      /**
       * Toggles the navigation open/close
       */
      toggle: function () {
        if (hasAnimFinished === true) {
          if (!navOpen) {
            this.open();
          } else {
            this.close();
          }
        }
      },

      /**
       * Opens the navigation
       */
      open: function () {
        if (!navOpen) {
          removeClass(nav, "closed");
          addClass(nav, "opened");
          addClass(htmlEl, opts.navActiveClass);
          addClass(navToggle, "active");
          nav.style.position = opts.openPos;
          setAttributes(nav, {"aria-hidden": "false"});
          navOpen = true;
          opts.open();
        }
      },

      /**
       * Closes the navigation
       */
      close: function () {
        if (navOpen) {
          addClass(nav, "closed");
          removeClass(nav, "opened");
          removeClass(htmlEl, opts.navActiveClass);
          removeClass(navToggle, "active");
          setAttributes(nav, {"aria-hidden": "true"});

          // If animations are enabled, wait until they finish
          if (opts.animate) {
            hasAnimFinished = false;
            setTimeout(function () {
              nav.style.position = "absolute";
              hasAnimFinished = true;
            }, opts.transition + 10);

          // Animations aren't enabled, we can do these immediately
          } else {
            nav.style.position = "absolute";
          }

          navOpen = false;
          opts.close();
        }
      },

      /**
       * Resize is called on window resize and orientation change.
       * It initializes the CSS styles and height calculations.
       */
      resize: function () {

        // Resize watches navigation toggle's display state
        if (window.getComputedStyle(navToggle, null).getPropertyValue("display") !== "none") {

          isMobile = true;
          setAttributes(navToggle, {"aria-hidden": "false"});

          // If the navigation is hidden
          if (nav.className.match(/(^|\s)closed(\s|$)/)) {
            setAttributes(nav, {"aria-hidden": "true"});
            nav.style.position = "absolute";
          }

          this._createStyles();
          this._calcHeight();
        } else {

          isMobile = false;
          setAttributes(navToggle, {"aria-hidden": "true"});
          setAttributes(nav, {"aria-hidden": "false"});
          nav.style.position = opts.openPos;
          this._removeStyles();
        }
      },

      /**
       * Takes care of all even handling
       *
       * @param  {event} event
       * @return {type} returns the type of event that should be used
       */
      handleEvent: function (e) {
        var evt = e || window.event;

        switch (evt.type) {
        case "touchstart":
          this._onTouchStart(evt);
          break;
        case "touchmove":
          this._onTouchMove(evt);
          break;
        case "touchend":
        case "mouseup":
          this._onTouchEnd(evt);
          break;
        case "click":
          this._preventDefault(evt);
          break;
        case "keyup":
          this._onKeyUp(evt);
          break;
        case "focus":
        case "resize":
          this.resize(evt);
          break;
        }
      },

      /**
       * Initializes the widget
       */
      _init: function () {
        this.index = index++;

        addClass(nav, opts.navClass);
        addClass(nav, opts.navClass + "-" + this.index);
        addClass(nav, "closed");
        hasAnimFinished = true;
        navOpen = false;

        this._closeOnNavClick();
        this._createToggle();
        this._transitions();
        this.resize();

        /**
         * On IE8 the resize event triggers too early for some reason
         * so it's called here again on init to make sure all the
         * calculated styles are correct.
         */
        var self = this;
        setTimeout(function () {
          self.resize();
        }, 20);

        addEvent(window, "resize", this, false);
        addEvent(window, "focus", this, false);
        addEvent(document.body, "touchmove", this, false);
        addEvent(navToggle, "touchstart", this, false);
        addEvent(navToggle, "touchend", this, false);
        addEvent(navToggle, "mouseup", this, false);
        addEvent(navToggle, "keyup", this, false);
        addEvent(navToggle, "click", this, false);

        /**
         * Init callback here
         */
        opts.init();
      },

      /**
       * Creates Styles to the <head>
       */
      _createStyles: function () {
        if (!styleElement.parentNode) {
          styleElement.type = "text/css";
          document.getElementsByTagName("head")[0].appendChild(styleElement);
        }
      },

      /**
       * Removes styles from the <head>
       */
      _removeStyles: function () {
        if (styleElement.parentNode) {
          styleElement.parentNode.removeChild(styleElement);
        }
      },

      /**
       * Creates Navigation Toggle
       */
      _createToggle: function () {

        // If there's no toggle, let's create one
        if (!opts.customToggle) {
          var toggle = document.createElement("a");
          toggle.innerHTML = opts.label;
          setAttributes(toggle, {
            "href": "#",
            "class": "nav-toggle"
          });

          // Determine where to insert the toggle
          if (opts.insert === "after") {
            nav.parentNode.insertBefore(toggle, nav.nextSibling);
          } else {
            nav.parentNode.insertBefore(toggle, nav);
          }

          navToggle = toggle;

        // There is a toggle already, let's use that one
        } else {
          var toggleEl = opts.customToggle.replace("#", "");

          if (document.getElementById(toggleEl)) {
            navToggle = document.getElementById(toggleEl);
          } else if (document.querySelector(toggleEl)) {
            navToggle = document.querySelector(toggleEl);
          } else {
            throw new Error("The custom nav toggle you are trying to select doesn't exist");
          }
        }
      },

      /**
       * Closes the navigation when a link inside is clicked.
       */
      _closeOnNavClick: function () {
        if (opts.closeOnNavClick) {
          var links = nav.getElementsByTagName("a"),
            self = this;
          forEach(links, function (i, el) {
            addEvent(links[i], "click", function () {
              if (isMobile) {
                self.toggle();
              }
            }, false);
          });
        }
      },

      /**
       * Prevents the default functionality.
       *
       * @param  {event} event
       */
      _preventDefault: function(e) {
        if (e.preventDefault) {
          if (e.stopImmediatePropagation) {
            e.stopImmediatePropagation();
          }
          e.preventDefault();
          e.stopPropagation();
          return false;

        // This is strictly for old IE
        } else {
          e.returnValue = false;
        }
      },

      /**
       * On touch start we get the location of the touch.
       *
       * @param  {event} event
       */
      _onTouchStart: function (e) {
        if (!Event.prototype.stopImmediatePropagation) {
          this._preventDefault(e);
        }
        this.startX = e.touches[0].clientX;
        this.startY = e.touches[0].clientY;
        this.touchHasMoved = false;

        /**
         * Remove mouseup event completely here to avoid
         * double triggering the event.
         */
        removeEvent(navToggle, "mouseup", this, false);
      },

      /**
       * Check if the user is scrolling instead of tapping.
       *
       * @param  {event} event
       */
      _onTouchMove: function (e) {
        if (Math.abs(e.touches[0].clientX - this.startX) > 10 ||
        Math.abs(e.touches[0].clientY - this.startY) > 10) {
          this.touchHasMoved = true;
        }
      },

      /**
       * On touch end toggle the navigation.
       *
       * @param  {event} event
       */
      _onTouchEnd: function (e) {
        this._preventDefault(e);
        if (!isMobile) {
          return;
        }

        // If the user isn't scrolling
        if (!this.touchHasMoved) {

          // If the event type is touch
          if (e.type === "touchend") {
            this.toggle();
            return;

          // Event type was click, not touch
          } else {
            var evt = e || window.event;

            // If it isn't a right click, do toggling
            if (!(evt.which === 3 || evt.button === 2)) {
              this.toggle();
            }
          }
        }
      },

      /**
       * For keyboard accessibility, toggle the navigation on Enter
       * keypress too.
       *
       * @param  {event} event
       */
      _onKeyUp: function (e) {
        var evt = e || window.event;
        if (evt.keyCode === 13) {
          this.toggle();
        }
      },

      /**
       * Adds the needed CSS transitions if animations are enabled
       */
      _transitions: function () {
        if (opts.animate) {
          var objStyle = nav.style,
            transition = "max-height " + opts.transition + "ms";

          objStyle.WebkitTransition =
          objStyle.MozTransition =
          objStyle.OTransition =
          objStyle.transition = transition;
        }
      },

      /**
       * Calculates the height of the navigation and then creates
       * styles which are later added to the page <head>
       */
      _calcHeight: function () {
        var savedHeight = 0;
        for (var i = 0; i < nav.inner.length; i++) {
          savedHeight += nav.inner[i].offsetHeight;
        }

        var innerStyles = "." + opts.jsClass + " ." + opts.navClass + "-" + this.index + ".opened{max-height:" + savedHeight + "px !important} ." + opts.jsClass + " ." + opts.navClass + "-" + this.index + ".opened.dropdown-active {max-height:9999px !important}";

        if (styleElement.styleSheet) {
          styleElement.styleSheet.cssText = innerStyles;
        } else {
          styleElement.innerHTML = innerStyles;
        }

        innerStyles = "";
      }

    };

    /**
     * Return new Responsive Nav
     */
    return new ResponsiveNav(el, options);

  };

  if (typeof module !== "undefined" && module.exports) {
    module.exports = responsiveNav;
  } else {
    window.responsiveNav = responsiveNav;
  }

}(document, window, 0));

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Restful Resources service for AngularJS apps
 * @version v1.6.1 - 2017-01-06 * @link https://github.com/mgonto/restangular
 * @author Martin Gontovnikas <martin@gon.to>
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */(function(root, factory) {
  /* global define, require */
  // https://github.com/umdjs/umd/blob/master/templates/returnExports.js
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(435), __webpack_require__(4)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof module === 'object' && module.exports) {
    module.exports = factory(require('lodash'), require('angular'));
  } else {
    // No global export, Restangular will register itself as Angular.js module
    factory(root._, root.angular);
  }
}(this, function(_, angular) {

  var restangular = angular.module('restangular', []);

  restangular.provider('Restangular', function() {
    // Configuration
    var Configurer = {};
    Configurer.init = function(object, config) {
      object.configuration = config;

      /**
       * Those are HTTP safe methods for which there is no need to pass any data with the request.
       */
      var safeMethods = ['get', 'head', 'options', 'trace', 'getlist'];
      config.isSafe = function(operation) {
        return _.includes(safeMethods, operation.toLowerCase());
      };

      var absolutePattern = /^https?:\/\//i;
      config.isAbsoluteUrl = function(string) {
        return _.isUndefined(config.absoluteUrl) || _.isNull(config.absoluteUrl) ?
          string && absolutePattern.test(string) :
          config.absoluteUrl;
      };

      config.absoluteUrl = _.isUndefined(config.absoluteUrl) ? true : config.absoluteUrl;
      object.setSelfLinkAbsoluteUrl = function(value) {
        config.absoluteUrl = value;
      };
      /**
       * This is the BaseURL to be used with Restangular
       */
      config.baseUrl = _.isUndefined(config.baseUrl) ? '' : config.baseUrl;
      object.setBaseUrl = function(newBaseUrl) {
        config.baseUrl = /\/$/.test(newBaseUrl) ?
          newBaseUrl.substring(0, newBaseUrl.length - 1) :
          newBaseUrl;
        return this;
      };

      /**
       * Sets the extra fields to keep from the parents
       */
      config.extraFields = config.extraFields || [];
      object.setExtraFields = function(newExtraFields) {
        config.extraFields = newExtraFields;
        return this;
      };

      /**
       * Some default $http parameter to be used in EVERY call
       **/
      config.defaultHttpFields = config.defaultHttpFields || {};
      object.setDefaultHttpFields = function(values) {
        config.defaultHttpFields = values;
        return this;
      };

      /**
       * Always return plain data, no restangularized object
       **/
      config.plainByDefault = config.plainByDefault || false;
      object.setPlainByDefault = function(value) {
        config.plainByDefault = value === true ? true : false;
        return this;
      };

      config.withHttpValues = function(httpLocalConfig, obj) {
        return _.defaults(obj, httpLocalConfig, config.defaultHttpFields);
      };

      config.encodeIds = _.isUndefined(config.encodeIds) ? true : config.encodeIds;
      object.setEncodeIds = function(encode) {
        config.encodeIds = encode;
      };

      config.defaultRequestParams = config.defaultRequestParams || {
        get: {},
        post: {},
        put: {},
        remove: {},
        common: {}
      };

      object.setDefaultRequestParams = function(param1, param2) {
        var methods = [],
          params = param2 || param1;
        if (!_.isUndefined(param2)) {
          if (_.isArray(param1)) {
            methods = param1;
          } else {
            methods.push(param1);
          }
        } else {
          methods.push('common');
        }

        _.each(methods, function(method) {
          config.defaultRequestParams[method] = params;
        });
        return this;
      };

      object.requestParams = config.defaultRequestParams;

      config.defaultHeaders = config.defaultHeaders || {};
      object.setDefaultHeaders = function(headers) {
        config.defaultHeaders = headers;
        object.defaultHeaders = config.defaultHeaders;
        return this;
      };

      object.defaultHeaders = config.defaultHeaders;

      /**
       * Method overriders will set which methods are sent via POST with an X-HTTP-Method-Override
       **/
      config.methodOverriders = config.methodOverriders || [];
      object.setMethodOverriders = function(values) {
        var overriders = _.extend([], values);
        if (config.isOverridenMethod('delete', overriders)) {
          overriders.push('remove');
        }
        config.methodOverriders = overriders;
        return this;
      };

      config.jsonp = _.isUndefined(config.jsonp) ? false : config.jsonp;
      object.setJsonp = function(active) {
        config.jsonp = active;
      };

      config.isOverridenMethod = function(method, values) {
        var search = values || config.methodOverriders;
        return !_.isUndefined(_.find(search, function(one) {
          return one.toLowerCase() === method.toLowerCase();
        }));
      };

      /**
       * Sets the URL creator type. For now, only Path is created. In the future we'll have queryParams
       **/
      config.urlCreator = config.urlCreator || 'path';
      object.setUrlCreator = function(name) {
        if (!_.has(config.urlCreatorFactory, name)) {
          throw new Error('URL Path selected isn\'t valid');
        }

        config.urlCreator = name;
        return this;
      };

      /**
       * You can set the restangular fields here. The 3 required fields for Restangular are:
       *
       * id: Id of the element
       * route: name of the route of this element
       * parentResource: the reference to the parent resource
       *
       *  All of this fields except for id, are handled (and created) by Restangular. By default,
       *  the field values will be id, route and parentResource respectively
       */
      config.restangularFields = config.restangularFields || {
        id: 'id',
        route: 'route',
        parentResource: 'parentResource',
        restangularCollection: 'restangularCollection',
        cannonicalId: '__cannonicalId',
        etag: 'restangularEtag',
        selfLink: 'href',
        get: 'get',
        getList: 'getList',
        put: 'put',
        post: 'post',
        remove: 'remove',
        head: 'head',
        trace: 'trace',
        options: 'options',
        patch: 'patch',
        getRestangularUrl: 'getRestangularUrl',
        getRequestedUrl: 'getRequestedUrl',
        putElement: 'putElement',
        addRestangularMethod: 'addRestangularMethod',
        getParentList: 'getParentList',
        clone: 'clone',
        ids: 'ids',
        httpConfig: '_$httpConfig',
        reqParams: 'reqParams',
        one: 'one',
        all: 'all',
        several: 'several',
        oneUrl: 'oneUrl',
        allUrl: 'allUrl',
        customPUT: 'customPUT',
        customPATCH: 'customPATCH',
        customPOST: 'customPOST',
        customDELETE: 'customDELETE',
        customGET: 'customGET',
        customGETLIST: 'customGETLIST',
        customOperation: 'customOperation',
        doPUT: 'doPUT',
        doPATCH: 'doPATCH',
        doPOST: 'doPOST',
        doDELETE: 'doDELETE',
        doGET: 'doGET',
        doGETLIST: 'doGETLIST',
        fromServer: 'fromServer',
        withConfig: 'withConfig',
        withHttpConfig: 'withHttpConfig',
        singleOne: 'singleOne',
        plain: 'plain',
        save: 'save',
        restangularized: 'restangularized'
      };
      object.setRestangularFields = function(resFields) {
        config.restangularFields =
          _.extend(config.restangularFields, resFields);
        return this;
      };

      config.isRestangularized = function(obj) {
        return !!obj[config.restangularFields.restangularized];
      };

      config.setFieldToElem = function(field, elem, value) {
        var properties = field.split('.');
        var idValue = elem;
        _.each(_.initial(properties), function(prop) {
          idValue[prop] = {};
          idValue = idValue[prop];
        });
        idValue[_.last(properties)] = value;
        return this;
      };

      config.getFieldFromElem = function(field, elem) {
        var properties = field.split('.');
        var idValue = elem;
        _.each(properties, function(prop) {
          if (idValue) {
            idValue = idValue[prop];
          }
        });
        return angular.copy(idValue);
      };

      config.setIdToElem = function(elem, id /*, route */ ) {
        config.setFieldToElem(config.restangularFields.id, elem, id);
        return this;
      };

      config.getIdFromElem = function(elem) {
        return config.getFieldFromElem(config.restangularFields.id, elem);
      };

      config.isValidId = function(elemId) {
        return '' !== elemId && !_.isUndefined(elemId) && !_.isNull(elemId);
      };

      config.setUrlToElem = function(elem, url /*, route */ ) {
        config.setFieldToElem(config.restangularFields.selfLink, elem, url);
        return this;
      };

      config.getUrlFromElem = function(elem) {
        return config.getFieldFromElem(config.restangularFields.selfLink, elem);
      };

      config.useCannonicalId = _.isUndefined(config.useCannonicalId) ? false : config.useCannonicalId;
      object.setUseCannonicalId = function(value) {
        config.useCannonicalId = value;
        return this;
      };

      config.getCannonicalIdFromElem = function(elem) {
        var cannonicalId = elem[config.restangularFields.cannonicalId];
        var actualId = config.isValidId(cannonicalId) ? cannonicalId : config.getIdFromElem(elem);
        return actualId;
      };

      /**
       * Sets the Response parser. This is used in case your response isn't directly the data.
       * For example if you have a response like {meta: {'meta'}, data: {name: 'Gonto'}}
       * you can extract this data which is the one that needs wrapping
       *
       * The ResponseExtractor is a function that receives the response and the method executed.
       */

      config.responseInterceptors = config.responseInterceptors || [];

      config.defaultResponseInterceptor = function(data /*, operation, what, url, response, deferred */ ) {
        return data;
      };

      config.responseExtractor = function(data, operation, what, url, response, deferred) {
        var interceptors = angular.copy(config.responseInterceptors);
        interceptors.push(config.defaultResponseInterceptor);
        var theData = data;
        _.each(interceptors, function(interceptor) {
          theData = interceptor(theData, operation,
            what, url, response, deferred);
        });
        return theData;
      };

      object.addResponseInterceptor = function(extractor) {
        config.responseInterceptors.push(extractor);
        return this;
      };

      config.errorInterceptors = config.errorInterceptors || [];
      object.addErrorInterceptor = function(interceptor) {
        config.errorInterceptors.push(interceptor);
        return this;
      };

      object.setResponseInterceptor = object.addResponseInterceptor;
      object.setResponseExtractor = object.addResponseInterceptor;
      object.setErrorInterceptor = object.addErrorInterceptor;

      /**
       * Response interceptor is called just before resolving promises.
       */


      /**
       * Request interceptor is called before sending an object to the server.
       */
      config.requestInterceptors = config.requestInterceptors || [];

      config.defaultInterceptor = function(element, operation, path, url, headers, params, httpConfig) {
        return {
          element: element,
          headers: headers,
          params: params,
          httpConfig: httpConfig
        };
      };

      config.fullRequestInterceptor = function(element, operation, path, url, headers, params, httpConfig) {
        var interceptors = angular.copy(config.requestInterceptors);
        var defaultRequest = config.defaultInterceptor(element, operation, path, url, headers, params, httpConfig);
        return _.reduce(interceptors, function(request, interceptor) {
          return _.extend(request, interceptor(request.element, operation,
            path, url, request.headers, request.params, request.httpConfig));
        }, defaultRequest);
      };

      object.addRequestInterceptor = function(interceptor) {
        config.requestInterceptors.push(function(elem, operation, path, url, headers, params, httpConfig) {
          return {
            headers: headers,
            params: params,
            element: interceptor(elem, operation, path, url),
            httpConfig: httpConfig
          };
        });
        return this;
      };

      object.setRequestInterceptor = object.addRequestInterceptor;

      object.addFullRequestInterceptor = function(interceptor) {
        config.requestInterceptors.push(interceptor);
        return this;
      };

      object.setFullRequestInterceptor = object.addFullRequestInterceptor;

      config.onBeforeElemRestangularized = config.onBeforeElemRestangularized || function(elem) {
        return elem;
      };
      object.setOnBeforeElemRestangularized = function(post) {
        config.onBeforeElemRestangularized = post;
        return this;
      };

      object.setRestangularizePromiseInterceptor = function(interceptor) {
        config.restangularizePromiseInterceptor = interceptor;
        return this;
      };

      /**
       * This method is called after an element has been "Restangularized".
       *
       * It receives the element, a boolean indicating if it's an element or a collection
       * and the name of the model
       *
       */
      config.onElemRestangularized = config.onElemRestangularized || function(elem) {
        return elem;
      };
      object.setOnElemRestangularized = function(post) {
        config.onElemRestangularized = post;
        return this;
      };

      config.shouldSaveParent = config.shouldSaveParent || function() {
        return true;
      };
      object.setParentless = function(values) {
        if (_.isArray(values)) {
          config.shouldSaveParent = function(route) {
            return !_.includes(values, route);
          };
        } else if (_.isBoolean(values)) {
          config.shouldSaveParent = function() {
            return !values;
          };
        }
        return this;
      };

      /**
       * This lets you set a suffix to every request.
       *
       * For example, if your api requires that for JSon requests you do /users/123.json, you can set that
       * in here.
       *
       *
       * By default, the suffix is null
       */
      config.suffix = _.isUndefined(config.suffix) ? null : config.suffix;
      object.setRequestSuffix = function(newSuffix) {
        config.suffix = newSuffix;
        return this;
      };

      /**
       * Add element transformers for certain routes.
       */
      config.transformers = config.transformers || {};
      config.matchTransformers = config.matchTransformers || [];
      object.addElementTransformer = function(type, secondArg, thirdArg) {
        var isCollection = null;
        var transformer = null;
        if (arguments.length === 2) {
          transformer = secondArg;
        } else {
          transformer = thirdArg;
          isCollection = secondArg;
        }

        var transformerFn = function(coll, elem) {
          if (_.isNull(isCollection) || (coll === isCollection)) {
            return transformer(elem);
          }
          return elem;
        };

        if (_.isRegExp(type)) {
          config.matchTransformers.push({
            regexp: type,
            transformer: transformerFn
          });
        } else {
          if (!config.transformers[type]) {
            config.transformers[type] = [];
          }
          config.transformers[type].push(transformerFn);
        }

        return object;
      };

      object.extendCollection = function(route, fn) {
        return object.addElementTransformer(route, true, fn);
      };

      object.extendModel = function(route, fn) {
        return object.addElementTransformer(route, false, fn);
      };

      config.transformElem = function(elem, isCollection, route, Restangular, force) {
        if (!force && !config.transformLocalElements && !elem[config.restangularFields.fromServer]) {
          return elem;
        }

        var changedElem = elem;

        var matchTransformers = config.matchTransformers;
        if (matchTransformers) {
          _.each(matchTransformers, function(transformer) {
            if (transformer.regexp.test(route)) {
              changedElem = transformer.transformer(isCollection, changedElem);
            }
          });
        }

        var typeTransformers = config.transformers[route];
        if (typeTransformers) {
          _.each(typeTransformers, function(transformer) {
            changedElem = transformer(isCollection, changedElem);
          });
        }
        return config.onElemRestangularized(changedElem, isCollection, route, Restangular);
      };

      config.transformLocalElements = _.isUndefined(config.transformLocalElements) ?
        false :
        config.transformLocalElements;

      object.setTransformOnlyServerElements = function(active) {
        config.transformLocalElements = !active;
      };

      config.fullResponse = _.isUndefined(config.fullResponse) ? false : config.fullResponse;
      object.setFullResponse = function(full) {
        config.fullResponse = full;
        return this;
      };


      //Internal values and functions
      config.urlCreatorFactory = {};

      /**
       * Base URL Creator. Base prototype for everything related to it
       **/

      var BaseCreator = function() {};

      BaseCreator.prototype.setConfig = function(config) {
        this.config = config;
        return this;
      };

      BaseCreator.prototype.parentsArray = function(current) {
        var parents = [];
        while (current) {
          parents.push(current);
          current = current[this.config.restangularFields.parentResource];
        }
        return parents.reverse();
      };

      function RestangularResource(config, $http, url, configurer) {
        var resource = {};
        _.each(_.keys(configurer), function(key) {
          var value = configurer[key];

          // Add default parameters
          value.params = _.extend({}, value.params, config.defaultRequestParams[value.method.toLowerCase()]);
          // We don't want the ? if no params are there
          if (_.isEmpty(value.params)) {
            delete value.params;
          }

          if (config.isSafe(value.method)) {

            resource[key] = function() {
              return $http(_.extend(value, {
                url: url
              }));
            };

          } else {

            resource[key] = function(data) {
              return $http(_.extend(value, {
                url: url,
                data: data
              }));
            };

          }
        });

        return resource;
      }

      BaseCreator.prototype.resource = function(current, $http, localHttpConfig, callHeaders, callParams, what, etag, operation) {

        var params = _.defaults(callParams || {}, this.config.defaultRequestParams.common);
        var headers = _.defaults(callHeaders || {}, this.config.defaultHeaders);

        if (etag) {
          if (!config.isSafe(operation)) {
            headers['If-Match'] = etag;
          } else {
            headers['If-None-Match'] = etag;
          }
        }

        var url = this.base(current);

        if (what || what === 0) {
          var add = '';
          if (!/\/$/.test(url)) {
            add += '/';
          }
          add += what;
          url += add;
        }

        if (this.config.suffix &&
          url.indexOf(this.config.suffix, url.length - this.config.suffix.length) === -1 &&
          !this.config.getUrlFromElem(current)) {
          url += this.config.suffix;
        }

        current[this.config.restangularFields.httpConfig] = undefined;

        return RestangularResource(this.config, $http, url, {
          getList: this.config.withHttpValues(localHttpConfig, {
            method: 'GET',
            params: params,
            headers: headers
          }),

          get: this.config.withHttpValues(localHttpConfig, {
            method: 'GET',
            params: params,
            headers: headers
          }),

          jsonp: this.config.withHttpValues(localHttpConfig, {
            method: 'jsonp',
            params: params,
            headers: headers
          }),

          put: this.config.withHttpValues(localHttpConfig, {
            method: 'PUT',
            params: params,
            headers: headers
          }),

          post: this.config.withHttpValues(localHttpConfig, {
            method: 'POST',
            params: params,
            headers: headers
          }),

          remove: this.config.withHttpValues(localHttpConfig, {
            method: 'DELETE',
            params: params,
            headers: headers
          }),

          head: this.config.withHttpValues(localHttpConfig, {
            method: 'HEAD',
            params: params,
            headers: headers
          }),

          trace: this.config.withHttpValues(localHttpConfig, {
            method: 'TRACE',
            params: params,
            headers: headers
          }),

          options: this.config.withHttpValues(localHttpConfig, {
            method: 'OPTIONS',
            params: params,
            headers: headers
          }),

          patch: this.config.withHttpValues(localHttpConfig, {
            method: 'PATCH',
            params: params,
            headers: headers
          })
        });
      };

      /**
       * This is the Path URL creator. It uses Path to show Hierarchy in the Rest API.
       * This means that if you have an Account that then has a set of Buildings, a URL to a building
       * would be /accounts/123/buildings/456
       **/
      var Path = function() {};

      Path.prototype = new BaseCreator();

      Path.prototype.normalizeUrl = function(url) {
        var parts = /((?:http[s]?:)?\/\/)?(.*)?/.exec(url);
        parts[2] = parts[2].replace(/[\\\/]+/g, '/');
        return (typeof parts[1] !== 'undefined') ? parts[1] + parts[2] : parts[2];
      };

      Path.prototype.base = function(current) {
        var __this = this;
        return _.reduce(this.parentsArray(current), function(acum, elem) {
          var elemUrl;
          var elemSelfLink = __this.config.getUrlFromElem(elem);
          if (elemSelfLink) {
            if (__this.config.isAbsoluteUrl(elemSelfLink)) {
              return elemSelfLink;
            } else {
              elemUrl = elemSelfLink;
            }
          } else {
            elemUrl = elem[__this.config.restangularFields.route];

            if (elem[__this.config.restangularFields.restangularCollection]) {
              var ids = elem[__this.config.restangularFields.ids];
              if (ids) {
                elemUrl += '/' + ids.join(',');
              }
            } else {
              var elemId;
              if (__this.config.useCannonicalId) {
                elemId = __this.config.getCannonicalIdFromElem(elem);
              } else {
                elemId = __this.config.getIdFromElem(elem);
              }

              if (config.isValidId(elemId) && !elem.singleOne) {
                elemUrl += '/' + (__this.config.encodeIds ? encodeURIComponent(elemId) : elemId);
              }
            }
          }
          acum = acum.replace(/\/$/, '') + '/' + elemUrl;
          return __this.normalizeUrl(acum);

        }, this.config.baseUrl);
      };



      Path.prototype.fetchUrl = function(current, what) {
        var baseUrl = this.base(current);
        if (what) {
          baseUrl += '/' + what;
        }
        return baseUrl;
      };

      Path.prototype.fetchRequestedUrl = function(current, what) {
        var url = this.fetchUrl(current, what);
        var params = current[config.restangularFields.reqParams];

        // From here on and until the end of fetchRequestedUrl,
        // the code has been kindly borrowed from angular.js
        // The reason for such code bloating is coherence:
        //   If the user were to use this for cache management, the
        //   serialization of parameters would need to be identical
        //   to the one done by angular for cache keys to match.
        function sortedKeys(obj) {
          var keys = [];
          for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
              keys.push(key);
            }
          }
          return keys.sort();
        }

        function forEachSorted(obj, iterator, context) {
          var keys = sortedKeys(obj);
          for (var i = 0; i < keys.length; i++) {
            iterator.call(context, obj[keys[i]], keys[i]);
          }
          return keys;
        }

        function encodeUriQuery(val, pctEncodeSpaces) {
          return encodeURIComponent(val).
          replace(/%40/gi, '@').
          replace(/%3A/gi, ':').
          replace(/%24/g, '$').
          replace(/%2C/gi, ',').
          replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
        }

        if (!params) {
          return url + (this.config.suffix || '');
        }

        var parts = [];
        forEachSorted(params, function(value, key) {
          if (value === null || value === undefined) {
            return;
          }
          if (!angular.isArray(value)) {
            value = [value];
          }

          angular.forEach(value, function(v) {
            if (angular.isObject(v)) {
              v = angular.toJson(v);
            }
            parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(v));
          });
        });

        return url + (this.config.suffix || '') + ((url.indexOf('?') === -1) ? '?' : '&') + parts.join('&');
      };

      config.urlCreatorFactory.path = Path;
    };

    var globalConfiguration = {};

    Configurer.init(this, globalConfiguration);



    this.$get = ['$http', '$q', function($http, $q) {

      function createServiceForConfiguration(config) {
        var service = {};

        var urlHandler = new config.urlCreatorFactory[config.urlCreator]();
        urlHandler.setConfig(config);

        function restangularizeBase(parent, elem, route, reqParams, fromServer) {
          elem[config.restangularFields.route] = route;
          elem[config.restangularFields.getRestangularUrl] = _.bind(urlHandler.fetchUrl, urlHandler, elem);
          elem[config.restangularFields.getRequestedUrl] = _.bind(urlHandler.fetchRequestedUrl, urlHandler, elem);
          elem[config.restangularFields.addRestangularMethod] = _.bind(addRestangularMethodFunction, elem);
          elem[config.restangularFields.clone] = _.bind(copyRestangularizedElement, elem, elem);
          elem[config.restangularFields.reqParams] = _.isEmpty(reqParams) ? null : reqParams;
          elem[config.restangularFields.withHttpConfig] = _.bind(withHttpConfig, elem);
          elem[config.restangularFields.plain] = _.bind(stripRestangular, elem, elem);

          // Tag element as restangularized
          elem[config.restangularFields.restangularized] = true;

          // RequestLess connection
          elem[config.restangularFields.one] = _.bind(one, elem, elem);
          elem[config.restangularFields.all] = _.bind(all, elem, elem);
          elem[config.restangularFields.several] = _.bind(several, elem, elem);
          elem[config.restangularFields.oneUrl] = _.bind(oneUrl, elem, elem);
          elem[config.restangularFields.allUrl] = _.bind(allUrl, elem, elem);

          elem[config.restangularFields.fromServer] = !!fromServer;

          if (parent && config.shouldSaveParent(route)) {
            var parentId = config.getIdFromElem(parent);
            var parentUrl = config.getUrlFromElem(parent);

            var restangularFieldsForParent = _.union(
              _.values(_.pick(config.restangularFields, ['route', 'singleOne', 'parentResource'])),
              config.extraFields
            );
            var parentResource = _.pick(parent, restangularFieldsForParent);

            if (config.isValidId(parentId)) {
              config.setIdToElem(parentResource, parentId, route);
            }
            if (config.isValidId(parentUrl)) {
              config.setUrlToElem(parentResource, parentUrl, route);
            }

            elem[config.restangularFields.parentResource] = parentResource;
          } else {
            elem[config.restangularFields.parentResource] = null;
          }
          return elem;
        }

        function one(parent, route, id, singleOne) {
          var error;
          if (_.isNumber(route) || _.isNumber(parent)) {
            error = 'You\'re creating a Restangular entity with the number ';
            error += 'instead of the route or the parent. For example, you can\'t call .one(12).';
            throw new Error(error);
          }
          if (_.isUndefined(route)) {
            error = 'You\'re creating a Restangular entity either without the path. ';
            error += 'For example you can\'t call .one(). Please check if your arguments are valid.';
            throw new Error(error);
          }
          var elem = {};
          config.setIdToElem(elem, id, route);
          config.setFieldToElem(config.restangularFields.singleOne, elem, singleOne);
          return restangularizeElem(parent, elem, route, false);
        }


        function all(parent, route) {
          return restangularizeCollection(parent, [], route, false);
        }

        function several(parent, route /*, ids */ ) {
          var collection = [];
          collection[config.restangularFields.ids] = Array.prototype.splice.call(arguments, 2);
          return restangularizeCollection(parent, collection, route, false);
        }

        function oneUrl(parent, route, url) {
          if (!route) {
            throw new Error('Route is mandatory when creating new Restangular objects.');
          }
          var elem = {};
          config.setUrlToElem(elem, url, route);
          return restangularizeElem(parent, elem, route, false);
        }


        function allUrl(parent, route, url) {
          if (!route) {
            throw new Error('Route is mandatory when creating new Restangular objects.');
          }
          var elem = {};
          config.setUrlToElem(elem, url, route);
          return restangularizeCollection(parent, elem, route, false);
        }
        // Promises
        function restangularizePromise(promise, isCollection, valueToFill) {
          promise.call = _.bind(promiseCall, promise);
          promise.get = _.bind(promiseGet, promise);
          promise[config.restangularFields.restangularCollection] = isCollection;
          if (isCollection) {
            promise.push = _.bind(promiseCall, promise, 'push');
          }
          promise.$object = valueToFill;
          if (config.restangularizePromiseInterceptor) {
            config.restangularizePromiseInterceptor(promise);
          }
          return promise;
        }

        function promiseCall(method) {
          var deferred = $q.defer();
          var callArgs = arguments;
          var filledValue = {};
          this.then(function(val) {
            var params = Array.prototype.slice.call(callArgs, 1);
            var func = val[method];
            func.apply(val, params);
            filledValue = val;
            deferred.resolve(val);
          });
          return restangularizePromise(deferred.promise, this[config.restangularFields.restangularCollection], filledValue);
        }

        function promiseGet(what) {
          var deferred = $q.defer();
          var filledValue = {};
          this.then(function(val) {
            filledValue = val[what];
            deferred.resolve(filledValue);
          });
          return restangularizePromise(deferred.promise, this[config.restangularFields.restangularCollection], filledValue);
        }

        function resolvePromise(deferred, response, data, filledValue) {
          _.extend(filledValue, data);

          // Trigger the full response interceptor.
          if (config.fullResponse) {
            return deferred.resolve(_.extend(response, {
              data: data
            }));
          } else {
            deferred.resolve(data);
          }
        }


        // Elements
        function stripRestangular(elem) {
          if (_.isArray(elem)) {
            var array = [];
            _.each(elem, function(value) {
              array.push(config.isRestangularized(value) ? stripRestangular(value) : value);
            });
            return array;
          } else {
            return _.omit(elem, _.values(_.omit(config.restangularFields, 'id')));
          }
        }

        function addCustomOperation(elem) {
          elem[config.restangularFields.customOperation] = _.bind(customFunction, elem);
          var requestMethods = {
            get: customFunction,
            delete: customFunction
          };
          _.each(['put', 'patch', 'post'], function(name) {
            requestMethods[name] = function(operation, elem, path, params, headers) {
              return _.bind(customFunction, this)(operation, path, params, headers, elem);
            };
          });
          _.each(requestMethods, function(requestFunc, name) {
            var callOperation = name === 'delete' ? 'remove' : name;
            _.each(['do', 'custom'], function(alias) {
              elem[alias + name.toUpperCase()] = _.bind(requestFunc, elem, callOperation);
            });
          });
          elem[config.restangularFields.customGETLIST] = _.bind(fetchFunction, elem);
          elem[config.restangularFields.doGETLIST] = elem[config.restangularFields.customGETLIST];
        }

        function copyRestangularizedElement(element) {
          var copiedElement = angular.copy(element);

          // check if we're dealing with a collection (i.e. an array)
          // and restangularize the element using the proper restangularizer,
          // element / collection
          if (_.isArray(element)) {
            return restangularizeCollection(
              element[config.restangularFields.parentResource],
              copiedElement,
              element[config.restangularFields.route],
              element[config.restangularFields.fromServer],
              element[config.restangularFields.reqParams]
            );
          }

          // not a collection, restangularize it as an element
          return restangularizeElem(
            element[config.restangularFields.parentResource],
            copiedElement,
            element[config.restangularFields.route],
            element[config.restangularFields.fromServer],
            element[config.restangularFields.restangularCollection],
            element[config.restangularFields.reqParams]
          );
        }

        function restangularizeElem(parent, element, route, fromServer, collection, reqParams) {
          var elem = config.onBeforeElemRestangularized(element, false, route);

          var localElem = restangularizeBase(parent, elem, route, reqParams, fromServer);

          if (config.useCannonicalId) {
            localElem[config.restangularFields.cannonicalId] = config.getIdFromElem(localElem);
          }

          if (collection) {
            localElem[config.restangularFields.getParentList] = function() {
              return collection;
            };
          }

          localElem[config.restangularFields.restangularCollection] = false;
          localElem[config.restangularFields.get] = _.bind(getFunction, localElem);
          localElem[config.restangularFields.getList] = _.bind(fetchFunction, localElem);
          localElem[config.restangularFields.put] = _.bind(putFunction, localElem);
          localElem[config.restangularFields.post] = _.bind(postFunction, localElem);
          localElem[config.restangularFields.remove] = _.bind(deleteFunction, localElem);
          localElem[config.restangularFields.head] = _.bind(headFunction, localElem);
          localElem[config.restangularFields.trace] = _.bind(traceFunction, localElem);
          localElem[config.restangularFields.options] = _.bind(optionsFunction, localElem);
          localElem[config.restangularFields.patch] = _.bind(patchFunction, localElem);
          localElem[config.restangularFields.save] = _.bind(save, localElem);

          addCustomOperation(localElem);
          return config.transformElem(localElem, false, route, service, true);
        }

        function restangularizeCollection(parent, element, route, fromServer, reqParams) {
          var elem = config.onBeforeElemRestangularized(element, true, route);

          var localElem = restangularizeBase(parent, elem, route, reqParams, fromServer);
          localElem[config.restangularFields.restangularCollection] = true;
          localElem[config.restangularFields.post] = _.bind(postFunction, localElem, null);
          localElem[config.restangularFields.remove] = _.bind(deleteFunction, localElem);
          localElem[config.restangularFields.head] = _.bind(headFunction, localElem);
          localElem[config.restangularFields.trace] = _.bind(traceFunction, localElem);
          localElem[config.restangularFields.putElement] = _.bind(putElementFunction, localElem);
          localElem[config.restangularFields.options] = _.bind(optionsFunction, localElem);
          localElem[config.restangularFields.patch] = _.bind(patchFunction, localElem);
          localElem[config.restangularFields.get] = _.bind(getById, localElem);
          localElem[config.restangularFields.getList] = _.bind(fetchFunction, localElem, null);

          addCustomOperation(localElem);
          return config.transformElem(localElem, true, route, service, true);
        }

        function restangularizeCollectionAndElements(parent, element, route, fromServer) {
          var collection = restangularizeCollection(parent, element, route, fromServer);
          _.each(collection, function(elem) {
            if (elem) {
              restangularizeElem(parent, elem, route, fromServer);
            }
          });
          return collection;
        }

        function getById(id, reqParams, headers) {
          return this.customGET(id.toString(), reqParams, headers);
        }

        function putElementFunction(idx, params, headers) {
          var __this = this;
          var elemToPut = this[idx];
          var deferred = $q.defer();
          var filledArray = [];
          filledArray = config.transformElem(filledArray, true, elemToPut[config.restangularFields.route], service);
          elemToPut.put(params, headers).then(function(serverElem) {
            var newArray = copyRestangularizedElement(__this);
            newArray[idx] = serverElem;
            filledArray = newArray;
            deferred.resolve(newArray);
          }, function(response) {
            deferred.reject(response);
          });

          return restangularizePromise(deferred.promise, true, filledArray);
        }

        function parseResponse(resData, operation, route, fetchUrl, response, deferred) {
          var data = config.responseExtractor(resData, operation, route, fetchUrl, response, deferred);
          var etag = response.headers('ETag');
          if (data && etag) {
            data[config.restangularFields.etag] = etag;
          }
          return data;
        }


        function fetchFunction(what, reqParams, headers) {
          var __this = this;
          var deferred = $q.defer();
          var operation = 'getList';
          var url = urlHandler.fetchUrl(this, what);
          var whatFetched = what || __this[config.restangularFields.route];

          var request = config.fullRequestInterceptor(null, operation,
            whatFetched, url, headers || {}, reqParams || {}, this[config.restangularFields.httpConfig] || {});

          var filledArray = [];
          filledArray = config.transformElem(filledArray, true, whatFetched, service);

          var method = 'getList';

          if (config.jsonp) {
            method = 'jsonp';
          }

          var okCallback = function(response) {
            var resData = response.data;
            var fullParams = response.config.params;
            var data = parseResponse(resData, operation, whatFetched, url, response, deferred);

            // support empty response for getList() calls (some APIs respond with 204 and empty body)
            if (_.isUndefined(data) || '' === data) {
              data = [];
            }
            if (!_.isArray(data)) {
              throw new Error('Response for getList SHOULD be an array and not an object or something else');
            }

            if (true === config.plainByDefault) {
              return resolvePromise(deferred, response, data, filledArray);
            }

            var processedData = _.map(data, function(elem) {
              if (!__this[config.restangularFields.restangularCollection]) {
                return restangularizeElem(__this, elem, what, true, data);
              } else {
                return restangularizeElem(__this[config.restangularFields.parentResource],
                  elem, __this[config.restangularFields.route], true, data);
              }
            });

            processedData = _.extend(data, processedData);

            if (!__this[config.restangularFields.restangularCollection]) {
              resolvePromise(
                deferred,
                response,
                restangularizeCollection(
                  __this,
                  processedData,
                  what,
                  true,
                  fullParams
                ),
                filledArray
              );
            } else {
              resolvePromise(
                deferred,
                response,
                restangularizeCollection(
                  __this[config.restangularFields.parentResource],
                  processedData,
                  __this[config.restangularFields.route],
                  true,
                  fullParams
                ),
                filledArray
              );
            }
          };

          urlHandler.resource(this, $http, request.httpConfig, request.headers, request.params, what,
            this[config.restangularFields.etag], operation)[method]().then(okCallback, function error(response) {
            if (response.status === 304 && __this[config.restangularFields.restangularCollection]) {
              resolvePromise(deferred, response, __this, filledArray);
            } else if (_.every(config.errorInterceptors, function(cb) {
                return cb(response, deferred, okCallback) !== false;
              })) {
              // triggered if no callback returns false
              deferred.reject(response);
            }
          });

          return restangularizePromise(deferred.promise, true, filledArray);
        }

        function withHttpConfig(httpConfig) {
          this[config.restangularFields.httpConfig] = httpConfig;
          return this;
        }

        function save(params, headers) {
          if (this[config.restangularFields.fromServer]) {
            return this[config.restangularFields.put](params, headers);
          } else {
            return _.bind(elemFunction, this)('post', undefined, params, undefined, headers);
          }
        }

        function elemFunction(operation, what, params, obj, headers) {
          var __this = this;
          var deferred = $q.defer();
          var resParams = params || {};
          var route = what || this[config.restangularFields.route];
          var fetchUrl = urlHandler.fetchUrl(this, what);

          var callObj = obj || this;
          // fallback to etag on restangular object (since for custom methods we probably don't explicitly specify the etag field)
          var etag = callObj[config.restangularFields.etag] || (operation !== 'post' ? this[config.restangularFields.etag] : null);

          if (_.isObject(callObj) && config.isRestangularized(callObj)) {
            callObj = stripRestangular(callObj);
          }
          var request = config.fullRequestInterceptor(callObj, operation, route, fetchUrl,
            headers || {}, resParams || {}, this[config.restangularFields.httpConfig] || {});

          var filledObject = {};
          filledObject = config.transformElem(filledObject, false, route, service);

          var okCallback = function(response) {
            var resData = response.data;
            var fullParams = response.config.params;
            var elem = parseResponse(resData, operation, route, fetchUrl, response, deferred);

            // accept 0 as response
            if (elem !== null && elem !== undefined && elem !== '') {
              var data;

              if (true === config.plainByDefault) {
                return resolvePromise(deferred, response, elem, filledObject);
              }

              if (operation === 'post' && !__this[config.restangularFields.restangularCollection]) {
                data = restangularizeElem(
                  __this[config.restangularFields.parentResource],
                  elem,
                  route,
                  true,
                  null,
                  fullParams
                );
                resolvePromise(deferred, response, data, filledObject);
              } else {
                data = restangularizeElem(
                  __this[config.restangularFields.parentResource],
                  elem,
                  __this[config.restangularFields.route],
                  true,
                  null,
                  fullParams
                );

                data[config.restangularFields.singleOne] = __this[config.restangularFields.singleOne];
                resolvePromise(deferred, response, data, filledObject);
              }

            } else {
              resolvePromise(deferred, response, undefined, filledObject);
            }
          };

          var errorCallback = function(response) {
            if (response.status === 304 && config.isSafe(operation)) {
              resolvePromise(deferred, response, __this, filledObject);
            } else if (_.every(config.errorInterceptors, function(cb) {
                return cb(response, deferred, okCallback) !== false;
              })) {
              // triggered if no callback returns false
              deferred.reject(response);
            }
          };
          // Overriding HTTP Method
          var callOperation = operation;
          var callHeaders = _.extend({}, request.headers);
          var isOverrideOperation = config.isOverridenMethod(operation);
          if (isOverrideOperation) {
            callOperation = 'post';
            callHeaders = _.extend(callHeaders, {
              'X-HTTP-Method-Override': operation === 'remove' ? 'DELETE' : operation.toUpperCase()
            });
          } else if (config.jsonp && callOperation === 'get') {
            callOperation = 'jsonp';
          }

          if (config.isSafe(operation)) {
            if (isOverrideOperation) {
              urlHandler.resource(this, $http, request.httpConfig, callHeaders, request.params,
                what, etag, callOperation)[callOperation]({}).then(okCallback, errorCallback);
            } else {
              urlHandler.resource(this, $http, request.httpConfig, callHeaders, request.params,
                what, etag, callOperation)[callOperation]().then(okCallback, errorCallback);
            }
          } else {
            urlHandler.resource(this, $http, request.httpConfig, callHeaders, request.params,
              what, etag, callOperation)[callOperation](request.element).then(okCallback, errorCallback);
          }

          return restangularizePromise(deferred.promise, false, filledObject);
        }

        function getFunction(params, headers) {
          return _.bind(elemFunction, this)('get', undefined, params, undefined, headers);
        }

        function deleteFunction(params, headers) {
          return _.bind(elemFunction, this)('remove', undefined, params, undefined, headers);
        }

        function putFunction(params, headers) {
          return _.bind(elemFunction, this)('put', undefined, params, undefined, headers);
        }

        function postFunction(what, elem, params, headers) {
          return _.bind(elemFunction, this)('post', what, params, elem, headers);
        }

        function headFunction(params, headers) {
          return _.bind(elemFunction, this)('head', undefined, params, undefined, headers);
        }

        function traceFunction(params, headers) {
          return _.bind(elemFunction, this)('trace', undefined, params, undefined, headers);
        }

        function optionsFunction(params, headers) {
          return _.bind(elemFunction, this)('options', undefined, params, undefined, headers);
        }

        function patchFunction(elem, params, headers) {
          return _.bind(elemFunction, this)('patch', undefined, params, elem, headers);
        }

        function customFunction(operation, path, params, headers, elem) {
          return _.bind(elemFunction, this)(operation, path, params, elem, headers);
        }

        function addRestangularMethodFunction(name, operation, path, defaultParams, defaultHeaders, defaultElem) {
          var bindedFunction;
          if (operation === 'getList') {
            bindedFunction = _.bind(fetchFunction, this, path);
          } else {
            bindedFunction = _.bind(customFunction, this, operation, path);
          }

          var createdFunction = function(params, headers, elem) {
            var callParams = _.defaults({
              params: params,
              headers: headers,
              elem: elem
            }, {
              params: defaultParams,
              headers: defaultHeaders,
              elem: defaultElem
            });
            return bindedFunction(callParams.params, callParams.headers, callParams.elem);
          };

          if (config.isSafe(operation)) {
            this[name] = createdFunction;
          } else {
            this[name] = function(elem, params, headers) {
              return createdFunction(params, headers, elem);
            };
          }
        }

        function withConfigurationFunction(configurer) {
          var newConfig = angular.copy(_.omit(config, 'configuration'));
          Configurer.init(newConfig, newConfig);
          configurer(newConfig);
          return createServiceForConfiguration(newConfig);
        }

        function toService(route, parent) {
          var knownCollectionMethods = _.values(config.restangularFields);
          var serv = {};
          var collection = (parent || service).all(route);
          serv.one = _.bind(one, (parent || service), parent, route);
          serv.post = _.bind(collection.post, collection);
          serv.getList = _.bind(collection.getList, collection);
          serv.withHttpConfig = _.bind(collection.withHttpConfig, collection);
          serv.get = _.bind(collection.get, collection);

          for (var prop in collection) {
            if (collection.hasOwnProperty(prop) && _.isFunction(collection[prop]) && !_.includes(knownCollectionMethods, prop)) {
              serv[prop] = _.bind(collection[prop], collection);
            }
          }

          return serv;
        }


        Configurer.init(service, config);

        service.copy = _.bind(copyRestangularizedElement, service);

        service.service = _.bind(toService, service);

        service.withConfig = _.bind(withConfigurationFunction, service);

        service.one = _.bind(one, service, null);

        service.all = _.bind(all, service, null);

        service.several = _.bind(several, service, null);

        service.oneUrl = _.bind(oneUrl, service, null);

        service.allUrl = _.bind(allUrl, service, null);

        service.stripRestangular = _.bind(stripRestangular, service);

        service.restangularizeElement = _.bind(restangularizeElem, service);

        service.restangularizeCollection = _.bind(restangularizeCollectionAndElements, service);

        return service;
      }

      return createServiceForConfiguration(globalConfiguration);
    }];
  });
  return restangular.name;
}));


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.4';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      reLeadingDot = /^\./,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * Adds the key-value `pair` to `map`.
   *
   * @private
   * @param {Object} map The map to modify.
   * @param {Array} pair The key-value pair to add.
   * @returns {Object} Returns `map`.
   */
  function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
  }

  /**
   * Adds `value` to `set`.
   *
   * @private
   * @param {Object} set The set to modify.
   * @param {*} value The value to add.
   * @returns {Object} Returns `set`.
   */
  function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
  }

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, baseClone, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = object[key],
          srcValue = source[key],
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `map`.
     *
     * @private
     * @param {Object} map The map to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned map.
     */
    function cloneMap(map, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
      return arrayReduce(array, addMapEntry, new map.constructor);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of `set`.
     *
     * @private
     * @param {Object} set The set to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned set.
     */
    function cloneSet(set, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
      return arrayReduce(array, addSetEntry, new set.constructor);
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, cloneFunc, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return cloneMap(object, isDeep, cloneFunc);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return cloneSet(object, isDeep, cloneFunc);

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length &&
        (typeof value == 'number' || reIsUint.test(value)) &&
        (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (reLeadingDot.test(string)) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            result = wait - timeSinceLastCall;

        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(args) {
      args.push(undefined, customDefaultsAssignIn);
      return apply(assignInWith, undefined, args);
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3), __webpack_require__(5)(module)))

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(276);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js?sourceMap!../../postcss-loader/index.js!./angular-growl.min.css", function() {
			var newContent = require("!!../../css-loader/index.js?sourceMap!../../postcss-loader/index.js!./angular-growl.min.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(277);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js?sourceMap!../../postcss-loader/index.js!./ivh-treeview.css", function() {
			var newContent = require("!!../../css-loader/index.js?sourceMap!../../postcss-loader/index.js!./ivh-treeview.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(278);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js?sourceMap!../../postcss-loader/index.js!./angular-ui-notification.min.css", function() {
			var newContent = require("!!../../css-loader/index.js?sourceMap!../../postcss-loader/index.js!./angular-ui-notification.min.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(279);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js?sourceMap!../../postcss-loader/index.js!./flipclock.css", function() {
			var newContent = require("!!../../css-loader/index.js?sourceMap!../../postcss-loader/index.js!./flipclock.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(280);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js?sourceMap!../../postcss-loader/index.js!./ng-tags-input.css", function() {
			var newContent = require("!!../../css-loader/index.js?sourceMap!../../postcss-loader/index.js!./ng-tags-input.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(281);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js?sourceMap!../../../postcss-loader/index.js!./perfect-scrollbar.css", function() {
			var newContent = require("!!../../../css-loader/index.js?sourceMap!../../../postcss-loader/index.js!./perfect-scrollbar.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Swiper 3.2.0
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * 
 * http://www.idangero.us/swiper/
 * 
 * Copyright 2015, Vladimir Kharlampidi
 * The iDangero.us
 * http://www.idangero.us/
 * 
 * Licensed under MIT
 * 
 * Released on: November 7, 2015
 */
(function () {
    'use strict';
    var $;
    /*===========================
    Swiper
    ===========================*/
    var Swiper = function (container, params) {
        if (!(this instanceof Swiper)) return new Swiper(container, params);

        var defaults = {
            direction: 'horizontal',
            touchEventsTarget: 'container',
            initialSlide: 0,
            speed: 300,
            // autoplay
            autoplay: false,
            autoplayDisableOnInteraction: true,
            // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
            iOSEdgeSwipeDetection: false,
            iOSEdgeSwipeThreshold: 20,
            // Free mode
            freeMode: false,
            freeModeMomentum: true,
            freeModeMomentumRatio: 1,
            freeModeMomentumBounce: true,
            freeModeMomentumBounceRatio: 1,
            freeModeSticky: false,
            freeModeMinimumVelocity: 0.02,
            // Set wrapper width
            setWrapperSize: false,
            // Virtual Translate
            virtualTranslate: false,
            // Effects
            effect: 'slide', // 'slide' or 'fade' or 'cube' or 'coverflow'
            coverflow: {
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows : true
            },
            cube: {
                slideShadows: true,
                shadow: true,
                shadowOffset: 20,
                shadowScale: 0.94
            },
            fade: {
                crossFade: false
            },
            // Parallax
            parallax: false,
            // Scrollbar
            scrollbar: null,
            scrollbarHide: true,
            scrollbarDraggable: false,
            scrollbarSnapOnRelease: false,
            // Keyboard Mousewheel
            keyboardControl: false,
            mousewheelControl: false,
            mousewheelReleaseOnEdges: false,
            mousewheelInvert: false,
            mousewheelForceToAxis: false,
            mousewheelSensitivity: 1,
            // Hash Navigation
            hashnav: false,
            // Breakpoints
            breakpoints: undefined,
            // Slides grid
            spaceBetween: 0,
            slidesPerView: 1,
            slidesPerColumn: 1,
            slidesPerColumnFill: 'column',
            slidesPerGroup: 1,
            centeredSlides: false,
            slidesOffsetBefore: 0, // in px
            slidesOffsetAfter: 0, // in px
            // Round length
            roundLengths: false,
            // Touches
            touchRatio: 1,
            touchAngle: 45,
            simulateTouch: true,
            shortSwipes: true,
            longSwipes: true,
            longSwipesRatio: 0.5,
            longSwipesMs: 300,
            followFinger: true,
            onlyExternal: false,
            threshold: 0,
            touchMoveStopPropagation: true,
            // Pagination
            pagination: null,
            paginationElement: 'span',
            paginationClickable: false,
            paginationHide: false,
            paginationBulletRender: null,
            // Resistance
            resistance: true,
            resistanceRatio: 0.85,
            // Next/prev buttons
            nextButton: null,
            prevButton: null,
            // Progress
            watchSlidesProgress: false,
            watchSlidesVisibility: false,
            // Cursor
            grabCursor: false,
            // Clicks
            preventClicks: true,
            preventClicksPropagation: true,
            slideToClickedSlide: false,
            // Lazy Loading
            lazyLoading: false,
            lazyLoadingInPrevNext: false,
            lazyLoadingOnTransitionStart: false,
            // Images
            preloadImages: true,
            updateOnImagesReady: true,
            // loop
            loop: false,
            loopAdditionalSlides: 0,
            loopedSlides: null,
            // Control
            control: undefined,
            controlInverse: false,
            controlBy: 'slide', //or 'container'
            // Swiping/no swiping
            allowSwipeToPrev: true,
            allowSwipeToNext: true,
            swipeHandler: null, //'.swipe-handler',
            noSwiping: true,
            noSwipingClass: 'swiper-no-swiping',
            // NS
            slideClass: 'swiper-slide',
            slideActiveClass: 'swiper-slide-active',
            slideVisibleClass: 'swiper-slide-visible',
            slideDuplicateClass: 'swiper-slide-duplicate',
            slideNextClass: 'swiper-slide-next',
            slidePrevClass: 'swiper-slide-prev',
            wrapperClass: 'swiper-wrapper',
            bulletClass: 'swiper-pagination-bullet',
            bulletActiveClass: 'swiper-pagination-bullet-active',
            buttonDisabledClass: 'swiper-button-disabled',
            paginationHiddenClass: 'swiper-pagination-hidden',
            // Observer
            observer: false,
            observeParents: false,
            // Accessibility
            a11y: false,
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            // Callbacks
            runCallbacksOnInit: true
            /*
            Callbacks:
            onInit: function (swiper)
            onDestroy: function (swiper)
            onClick: function (swiper, e)
            onTap: function (swiper, e)
            onDoubleTap: function (swiper, e)
            onSliderMove: function (swiper, e)
            onSlideChangeStart: function (swiper)
            onSlideChangeEnd: function (swiper)
            onTransitionStart: function (swiper)
            onTransitionEnd: function (swiper)
            onImagesReady: function (swiper)
            onProgress: function (swiper, progress)
            onTouchStart: function (swiper, e)
            onTouchMove: function (swiper, e)
            onTouchMoveOpposite: function (swiper, e)
            onTouchEnd: function (swiper, e)
            onReachBeginning: function (swiper)
            onReachEnd: function (swiper)
            onSetTransition: function (swiper, duration)
            onSetTranslate: function (swiper, translate)
            onAutoplayStart: function (swiper)
            onAutoplayStop: function (swiper),
            onLazyImageLoad: function (swiper, slide, image)
            onLazyImageReady: function (swiper, slide, image)
            */
        
        };
        var initialVirtualTranslate = params && params.virtualTranslate;
        
        params = params || {};
        var originalParams = {};
        for (var param in params) {
            if (typeof params[param] === 'object') {
                originalParams[param] = {};
                for (var deepParam in params[param]) {
                    originalParams[param][deepParam] = params[param][deepParam];
                }
            }
            else {
                originalParams[param] = params[param];
            }
        }
        for (var def in defaults) {
            if (typeof params[def] === 'undefined') {
                params[def] = defaults[def];
            }
            else if (typeof params[def] === 'object') {
                for (var deepDef in defaults[def]) {
                    if (typeof params[def][deepDef] === 'undefined') {
                        params[def][deepDef] = defaults[def][deepDef];
                    }
                }
            }
        }
        
        // Swiper
        var s = this;
        
        // Params
        s.params = params;
        s.originalParams = originalParams;
        
        // Classname
        s.classNames = [];
        /*=========================
          Dom Library and plugins
          ===========================*/
        if (typeof $ !== 'undefined' && typeof Dom7 !== 'undefined'){
            $ = Dom7;
        }
        if (typeof $ === 'undefined') {
            if (typeof Dom7 === 'undefined') {
                $ = window.Dom7 || window.Zepto || window.jQuery;
            }
            else {
                $ = Dom7;
            }
            if (!$) return;
        }
        // Export it to Swiper instance
        s.$ = $;
        
        /*=========================
          Breakpoints
          ===========================*/
        s.currentBreakpoint = undefined;
        s.getActiveBreakpoint = function () {
            //Get breakpoint for window width
            if (!s.params.breakpoints) return false;
            var breakpoint = false;
            for ( var point in s.params.breakpoints ) {
                if (s.params.breakpoints.hasOwnProperty(point)) {
                    if (point >= $(window).width() && !breakpoint) {
                        breakpoint = point;
                    }
                }
            }
            return breakpoint || 'max';
        };
        s.setBreakpoint = function () {
            //Set breakpoint for window width and update parameters
            var breakpoint = s.getActiveBreakpoint();
            if (breakpoint && s.currentBreakpoint !== breakpoint) {
                var breakPointsParams = breakpoint in s.params.breakpoints ? s.params.breakpoints[breakpoint] : s.originalParams;
                for ( var param in breakPointsParams ) {
                    s.params[param] = breakPointsParams[param];
                }
                s.currentBreakpoint = breakpoint;
            }
        };
        // Set breakpoint on load
        if (s.params.breakpoints) {
            s.setBreakpoint();
        }
        
        /*=========================
          Preparation - Define Container, Wrapper and Pagination
          ===========================*/
        s.container = $(container);
        if (s.container.length === 0) return;
        if (s.container.length > 1) {
            s.container.each(function () {
                new Swiper(this, params);
            });
            return;
        }
        
        // Save instance in container HTML Element and in data
        s.container[0].swiper = s;
        s.container.data('swiper', s);
        
        s.classNames.push('swiper-container-' + s.params.direction);
        
        if (s.params.freeMode) {
            s.classNames.push('swiper-container-free-mode');
        }
        if (!s.support.flexbox) {
            s.classNames.push('swiper-container-no-flexbox');
            s.params.slidesPerColumn = 1;
        }
        // Enable slides progress when required
        if (s.params.parallax || s.params.watchSlidesVisibility) {
            s.params.watchSlidesProgress = true;
        }
        // Coverflow / 3D
        if (['cube', 'coverflow'].indexOf(s.params.effect) >= 0) {
            if (s.support.transforms3d) {
                s.params.watchSlidesProgress = true;
                s.classNames.push('swiper-container-3d');
            }
            else {
                s.params.effect = 'slide';
            }
        }
        if (s.params.effect !== 'slide') {
            s.classNames.push('swiper-container-' + s.params.effect);
        }
        if (s.params.effect === 'cube') {
            s.params.resistanceRatio = 0;
            s.params.slidesPerView = 1;
            s.params.slidesPerColumn = 1;
            s.params.slidesPerGroup = 1;
            s.params.centeredSlides = false;
            s.params.spaceBetween = 0;
            s.params.virtualTranslate = true;
            s.params.setWrapperSize = false;
        }
        if (s.params.effect === 'fade') {
            s.params.slidesPerView = 1;
            s.params.slidesPerColumn = 1;
            s.params.slidesPerGroup = 1;
            s.params.watchSlidesProgress = true;
            s.params.spaceBetween = 0;
            if (typeof initialVirtualTranslate === 'undefined') {
                s.params.virtualTranslate = true;
            }
        }
        
        // Grab Cursor
        if (s.params.grabCursor && s.support.touch) {
            s.params.grabCursor = false;
        }
        
        // Wrapper
        s.wrapper = s.container.children('.' + s.params.wrapperClass);
        
        // Pagination
        if (s.params.pagination) {
            s.paginationContainer = $(s.params.pagination);
            if (s.params.paginationClickable) {
                s.paginationContainer.addClass('swiper-pagination-clickable');
            }
        }
        
        // Is Horizontal
        function isH() {
            return s.params.direction === 'horizontal';
        }
        
        // RTL
        s.rtl = isH() && (s.container[0].dir.toLowerCase() === 'rtl' || s.container.css('direction') === 'rtl');
        if (s.rtl) {
            s.classNames.push('swiper-container-rtl');
        }
        
        // Wrong RTL support
        if (s.rtl) {
            s.wrongRTL = s.wrapper.css('display') === '-webkit-box';
        }
        
        // Columns
        if (s.params.slidesPerColumn > 1) {
            s.classNames.push('swiper-container-multirow');
        }
        
        // Check for Android
        if (s.device.android) {
            s.classNames.push('swiper-container-android');
        }
        
        // Add classes
        s.container.addClass(s.classNames.join(' '));
        
        // Translate
        s.translate = 0;
        
        // Progress
        s.progress = 0;
        
        // Velocity
        s.velocity = 0;
        
        /*=========================
          Locks, unlocks
          ===========================*/
        s.lockSwipeToNext = function () {
            s.params.allowSwipeToNext = false;
        };
        s.lockSwipeToPrev = function () {
            s.params.allowSwipeToPrev = false;
        };
        s.lockSwipes = function () {
            s.params.allowSwipeToNext = s.params.allowSwipeToPrev = false;
        };
        s.unlockSwipeToNext = function () {
            s.params.allowSwipeToNext = true;
        };
        s.unlockSwipeToPrev = function () {
            s.params.allowSwipeToPrev = true;
        };
        s.unlockSwipes = function () {
            s.params.allowSwipeToNext = s.params.allowSwipeToPrev = true;
        };
        
        /*=========================
          Round helper
          ===========================*/
        function round(a) {
            return Math.floor(a);
        }
        /*=========================
          Set grab cursor
          ===========================*/
        if (s.params.grabCursor) {
            s.container[0].style.cursor = 'move';
            s.container[0].style.cursor = '-webkit-grab';
            s.container[0].style.cursor = '-moz-grab';
            s.container[0].style.cursor = 'grab';
        }
        /*=========================
          Update on Images Ready
          ===========================*/
        s.imagesToLoad = [];
        s.imagesLoaded = 0;
        
        s.loadImage = function (imgElement, src, srcset, checkForComplete, callback) {
            var image;
            function onReady () {
                if (callback) callback();
            }
            if (!imgElement.complete || !checkForComplete) {
                if (src) {
                    image = new window.Image();
                    image.onload = onReady;
                    image.onerror = onReady;
                    if (srcset) {
                        image.srcset = srcset;
                    }
                    if (src) {
                        image.src = src;
                    }
                } else {
                    onReady();
                }
        
            } else {//image already loaded...
                onReady();
            }
        };
        s.preloadImages = function () {
            s.imagesToLoad = s.container.find('img');
            function _onReady() {
                if (typeof s === 'undefined' || s === null) return;
                if (s.imagesLoaded !== undefined) s.imagesLoaded++;
                if (s.imagesLoaded === s.imagesToLoad.length) {
                    if (s.params.updateOnImagesReady) s.update();
                    s.emit('onImagesReady', s);
                }
            }
            for (var i = 0; i < s.imagesToLoad.length; i++) {
                s.loadImage(s.imagesToLoad[i], (s.imagesToLoad[i].currentSrc || s.imagesToLoad[i].getAttribute('src')), (s.imagesToLoad[i].srcset || s.imagesToLoad[i].getAttribute('srcset')), true, _onReady);
            }
        };
        
        /*=========================
          Autoplay
          ===========================*/
        s.autoplayTimeoutId = undefined;
        s.autoplaying = false;
        s.autoplayPaused = false;
        function autoplay() {
            s.autoplayTimeoutId = setTimeout(function () {
                if (s.params.loop) {
                    s.fixLoop();
                    s._slideNext();
                }
                else {
                    if (!s.isEnd) {
                        s._slideNext();
                    }
                    else {
                        if (!params.autoplayStopOnLast) {
                            s._slideTo(0);
                        }
                        else {
                            s.stopAutoplay();
                        }
                    }
                }
            }, s.params.autoplay);
        }
        s.startAutoplay = function () {
            if (typeof s.autoplayTimeoutId !== 'undefined') return false;
            if (!s.params.autoplay) return false;
            if (s.autoplaying) return false;
            s.autoplaying = true;
            s.emit('onAutoplayStart', s);
            autoplay();
        };
        s.stopAutoplay = function (internal) {
            if (!s.autoplayTimeoutId) return;
            if (s.autoplayTimeoutId) clearTimeout(s.autoplayTimeoutId);
            s.autoplaying = false;
            s.autoplayTimeoutId = undefined;
            s.emit('onAutoplayStop', s);
        };
        s.pauseAutoplay = function (speed) {
            if (s.autoplayPaused) return;
            if (s.autoplayTimeoutId) clearTimeout(s.autoplayTimeoutId);
            s.autoplayPaused = true;
            if (speed === 0) {
                s.autoplayPaused = false;
                autoplay();
            }
            else {
                s.wrapper.transitionEnd(function () {
                    if (!s) return;
                    s.autoplayPaused = false;
                    if (!s.autoplaying) {
                        s.stopAutoplay();
                    }
                    else {
                        autoplay();
                    }
                });
            }
        };
        /*=========================
          Min/Max Translate
          ===========================*/
        s.minTranslate = function () {
            return (-s.snapGrid[0]);
        };
        s.maxTranslate = function () {
            return (-s.snapGrid[s.snapGrid.length - 1]);
        };
        /*=========================
          Slider/slides sizes
          ===========================*/
        s.updateContainerSize = function () {
            var width, height;
            if (typeof s.params.width !== 'undefined') {
                width = s.params.width;
            }
            else {
                width = s.container[0].clientWidth;
            }
            if (typeof s.params.height !== 'undefined') {
                height = s.params.height;
            }
            else {
                height = s.container[0].clientHeight;
            }
            if (width === 0 && isH() || height === 0 && !isH()) {
                return;
            }
        
            //Subtract paddings
            width = width - parseInt(s.container.css('padding-left'), 10) - parseInt(s.container.css('padding-right'), 10);
            height = height - parseInt(s.container.css('padding-top'), 10) - parseInt(s.container.css('padding-bottom'), 10);
        
            // Store values
            s.width = width;
            s.height = height;
            s.size = isH() ? s.width : s.height;
        };
        
        s.updateSlidesSize = function () {
            s.slides = s.wrapper.children('.' + s.params.slideClass);
            s.snapGrid = [];
            s.slidesGrid = [];
            s.slidesSizesGrid = [];
        
            var spaceBetween = s.params.spaceBetween,
                slidePosition = -s.params.slidesOffsetBefore,
                i,
                prevSlideSize = 0,
                index = 0;
            if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
                spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * s.size;
            }
        
            s.virtualSize = -spaceBetween;
            // reset margins
            if (s.rtl) s.slides.css({marginLeft: '', marginTop: ''});
            else s.slides.css({marginRight: '', marginBottom: ''});
        
            var slidesNumberEvenToRows;
            if (s.params.slidesPerColumn > 1) {
                if (Math.floor(s.slides.length / s.params.slidesPerColumn) === s.slides.length / s.params.slidesPerColumn) {
                    slidesNumberEvenToRows = s.slides.length;
                }
                else {
                    slidesNumberEvenToRows = Math.ceil(s.slides.length / s.params.slidesPerColumn) * s.params.slidesPerColumn;
                }
                if (s.params.slidesPerView !== 'auto' && s.params.slidesPerColumnFill === 'row') {
                    slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, s.params.slidesPerView * s.params.slidesPerColumn);
                }
            }
        
            // Calc slides
            var slideSize;
            var slidesPerColumn = s.params.slidesPerColumn;
            var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
            var numFullColumns = slidesPerRow - (s.params.slidesPerColumn * slidesPerRow - s.slides.length);
            for (i = 0; i < s.slides.length; i++) {
                slideSize = 0;
                var slide = s.slides.eq(i);
                if (s.params.slidesPerColumn > 1) {
                    // Set slides order
                    var newSlideOrderIndex;
                    var column, row;
                    if (s.params.slidesPerColumnFill === 'column') {
                        column = Math.floor(i / slidesPerColumn);
                        row = i - column * slidesPerColumn;
                        if (column > numFullColumns || (column === numFullColumns && row === slidesPerColumn-1)) {
                            if (++row >= slidesPerColumn) {
                                row = 0;
                                column++;
                            }
                        }
                        newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
                        slide
                            .css({
                                '-webkit-box-ordinal-group': newSlideOrderIndex,
                                '-moz-box-ordinal-group': newSlideOrderIndex,
                                '-ms-flex-order': newSlideOrderIndex,
                                '-webkit-order': newSlideOrderIndex,
                                'order': newSlideOrderIndex
                            });
                    }
                    else {
                        row = Math.floor(i / slidesPerRow);
                        column = i - row * slidesPerRow;
                    }
                    slide
                        .css({
                            'margin-top': (row !== 0 && s.params.spaceBetween) && (s.params.spaceBetween + 'px')
                        })
                        .attr('data-swiper-column', column)
                        .attr('data-swiper-row', row);
        
                }
                if (slide.css('display') === 'none') continue;
                if (s.params.slidesPerView === 'auto') {
                    slideSize = isH() ? slide.outerWidth(true) : slide.outerHeight(true);
                    if (s.params.roundLengths) slideSize = round(slideSize);
                }
                else {
                    slideSize = (s.size - (s.params.slidesPerView - 1) * spaceBetween) / s.params.slidesPerView;
                    if (s.params.roundLengths) slideSize = round(slideSize);
        
                    if (isH()) {
                        s.slides[i].style.width = slideSize + 'px';
                    }
                    else {
                        s.slides[i].style.height = slideSize + 'px';
                    }
                }
                s.slides[i].swiperSlideSize = slideSize;
                s.slidesSizesGrid.push(slideSize);
        
        
                if (s.params.centeredSlides) {
                    slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
                    if (i === 0) slidePosition = slidePosition - s.size / 2 - spaceBetween;
                    if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
                    if ((index) % s.params.slidesPerGroup === 0) s.snapGrid.push(slidePosition);
                    s.slidesGrid.push(slidePosition);
                }
                else {
                    if ((index) % s.params.slidesPerGroup === 0) s.snapGrid.push(slidePosition);
                    s.slidesGrid.push(slidePosition);
                    slidePosition = slidePosition + slideSize + spaceBetween;
                }
        
                s.virtualSize += slideSize + spaceBetween;
        
                prevSlideSize = slideSize;
        
                index ++;
            }
            s.virtualSize = Math.max(s.virtualSize, s.size) + s.params.slidesOffsetAfter;
            var newSlidesGrid;
        
            if (
                s.rtl && s.wrongRTL && (s.params.effect === 'slide' || s.params.effect === 'coverflow')) {
                s.wrapper.css({width: s.virtualSize + s.params.spaceBetween + 'px'});
            }
            if (!s.support.flexbox || s.params.setWrapperSize) {
                if (isH()) s.wrapper.css({width: s.virtualSize + s.params.spaceBetween + 'px'});
                else s.wrapper.css({height: s.virtualSize + s.params.spaceBetween + 'px'});
            }
        
            if (s.params.slidesPerColumn > 1) {
                s.virtualSize = (slideSize + s.params.spaceBetween) * slidesNumberEvenToRows;
                s.virtualSize = Math.ceil(s.virtualSize / s.params.slidesPerColumn) - s.params.spaceBetween;
                s.wrapper.css({width: s.virtualSize + s.params.spaceBetween + 'px'});
                if (s.params.centeredSlides) {
                    newSlidesGrid = [];
                    for (i = 0; i < s.snapGrid.length; i++) {
                        if (s.snapGrid[i] < s.virtualSize + s.snapGrid[0]) newSlidesGrid.push(s.snapGrid[i]);
                    }
                    s.snapGrid = newSlidesGrid;
                }
            }
        
            // Remove last grid elements depending on width
            if (!s.params.centeredSlides) {
                newSlidesGrid = [];
                for (i = 0; i < s.snapGrid.length; i++) {
                    if (s.snapGrid[i] <= s.virtualSize - s.size) {
                        newSlidesGrid.push(s.snapGrid[i]);
                    }
                }
                s.snapGrid = newSlidesGrid;
                if (Math.floor(s.virtualSize - s.size) > Math.floor(s.snapGrid[s.snapGrid.length - 1])) {
                    s.snapGrid.push(s.virtualSize - s.size);
                }
            }
            if (s.snapGrid.length === 0) s.snapGrid = [0];
        
            if (s.params.spaceBetween !== 0) {
                if (isH()) {
                    if (s.rtl) s.slides.css({marginLeft: spaceBetween + 'px'});
                    else s.slides.css({marginRight: spaceBetween + 'px'});
                }
                else s.slides.css({marginBottom: spaceBetween + 'px'});
            }
            if (s.params.watchSlidesProgress) {
                s.updateSlidesOffset();
            }
        };
        s.updateSlidesOffset = function () {
            for (var i = 0; i < s.slides.length; i++) {
                s.slides[i].swiperSlideOffset = isH() ? s.slides[i].offsetLeft : s.slides[i].offsetTop;
            }
        };
        
        /*=========================
          Slider/slides progress
          ===========================*/
        s.updateSlidesProgress = function (translate) {
            if (typeof translate === 'undefined') {
                translate = s.translate || 0;
            }
            if (s.slides.length === 0) return;
            if (typeof s.slides[0].swiperSlideOffset === 'undefined') s.updateSlidesOffset();
        
            var offsetCenter = -translate;
            if (s.rtl) offsetCenter = translate;
        
            // Visible Slides
            s.slides.removeClass(s.params.slideVisibleClass);
            for (var i = 0; i < s.slides.length; i++) {
                var slide = s.slides[i];
                var slideProgress = (offsetCenter - slide.swiperSlideOffset) / (slide.swiperSlideSize + s.params.spaceBetween);
                if (s.params.watchSlidesVisibility) {
                    var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
                    var slideAfter = slideBefore + s.slidesSizesGrid[i];
                    var isVisible =
                        (slideBefore >= 0 && slideBefore < s.size) ||
                        (slideAfter > 0 && slideAfter <= s.size) ||
                        (slideBefore <= 0 && slideAfter >= s.size);
                    if (isVisible) {
                        s.slides.eq(i).addClass(s.params.slideVisibleClass);
                    }
                }
                slide.progress = s.rtl ? -slideProgress : slideProgress;
            }
        };
        s.updateProgress = function (translate) {
            if (typeof translate === 'undefined') {
                translate = s.translate || 0;
            }
            var translatesDiff = s.maxTranslate() - s.minTranslate();
            if (translatesDiff === 0) {
                s.progress = 0;
                s.isBeginning = s.isEnd = true;
            }
            else {
                s.progress = (translate - s.minTranslate()) / (translatesDiff);
                s.isBeginning = s.progress <= 0;
                s.isEnd = s.progress >= 1;
            }
            if (s.isBeginning) s.emit('onReachBeginning', s);
            if (s.isEnd) s.emit('onReachEnd', s);
        
            if (s.params.watchSlidesProgress) s.updateSlidesProgress(translate);
            s.emit('onProgress', s, s.progress);
        };
        s.updateActiveIndex = function () {
            var translate = s.rtl ? s.translate : -s.translate;
            var newActiveIndex, i, snapIndex;
            for (i = 0; i < s.slidesGrid.length; i ++) {
                if (typeof s.slidesGrid[i + 1] !== 'undefined') {
                    if (translate >= s.slidesGrid[i] && translate < s.slidesGrid[i + 1] - (s.slidesGrid[i + 1] - s.slidesGrid[i]) / 2) {
                        newActiveIndex = i;
                    }
                    else if (translate >= s.slidesGrid[i] && translate < s.slidesGrid[i + 1]) {
                        newActiveIndex = i + 1;
                    }
                }
                else {
                    if (translate >= s.slidesGrid[i]) {
                        newActiveIndex = i;
                    }
                }
            }
            // Normalize slideIndex
            if (newActiveIndex < 0 || typeof newActiveIndex === 'undefined') newActiveIndex = 0;
            // for (i = 0; i < s.slidesGrid.length; i++) {
                // if (- translate >= s.slidesGrid[i]) {
                    // newActiveIndex = i;
                // }
            // }
            snapIndex = Math.floor(newActiveIndex / s.params.slidesPerGroup);
            if (snapIndex >= s.snapGrid.length) snapIndex = s.snapGrid.length - 1;
        
            if (newActiveIndex === s.activeIndex) {
                return;
            }
            s.snapIndex = snapIndex;
            s.previousIndex = s.activeIndex;
            s.activeIndex = newActiveIndex;
            s.updateClasses();
        };
        
        /*=========================
          Classes
          ===========================*/
        s.updateClasses = function () {
            s.slides.removeClass(s.params.slideActiveClass + ' ' + s.params.slideNextClass + ' ' + s.params.slidePrevClass);
            var activeSlide = s.slides.eq(s.activeIndex);
            // Active classes
            activeSlide.addClass(s.params.slideActiveClass);
            activeSlide.next('.' + s.params.slideClass).addClass(s.params.slideNextClass);
            activeSlide.prev('.' + s.params.slideClass).addClass(s.params.slidePrevClass);
        
            // Pagination
            if (s.bullets && s.bullets.length > 0) {
                s.bullets.removeClass(s.params.bulletActiveClass);
                var bulletIndex;
                if (s.params.loop) {
                    bulletIndex = Math.ceil(s.activeIndex - s.loopedSlides)/s.params.slidesPerGroup;
                    if (bulletIndex > s.slides.length - 1 - s.loopedSlides * 2) {
                        bulletIndex = bulletIndex - (s.slides.length - s.loopedSlides * 2);
                    }
                    if (bulletIndex > s.bullets.length - 1) bulletIndex = bulletIndex - s.bullets.length;
                }
                else {
                    if (typeof s.snapIndex !== 'undefined') {
                        bulletIndex = s.snapIndex;
                    }
                    else {
                        bulletIndex = s.activeIndex || 0;
                    }
                }
                if (s.paginationContainer.length > 1) {
                    s.bullets.each(function () {
                        if ($(this).index() === bulletIndex) $(this).addClass(s.params.bulletActiveClass);
                    });
                }
                else {
                    s.bullets.eq(bulletIndex).addClass(s.params.bulletActiveClass);
                }
            }
        
            // Next/active buttons
            if (!s.params.loop) {
                if (s.params.prevButton) {
                    if (s.isBeginning) {
                        $(s.params.prevButton).addClass(s.params.buttonDisabledClass);
                        if (s.params.a11y && s.a11y) s.a11y.disable($(s.params.prevButton));
                    }
                    else {
                        $(s.params.prevButton).removeClass(s.params.buttonDisabledClass);
                        if (s.params.a11y && s.a11y) s.a11y.enable($(s.params.prevButton));
                    }
                }
                if (s.params.nextButton) {
                    if (s.isEnd) {
                        $(s.params.nextButton).addClass(s.params.buttonDisabledClass);
                        if (s.params.a11y && s.a11y) s.a11y.disable($(s.params.nextButton));
                    }
                    else {
                        $(s.params.nextButton).removeClass(s.params.buttonDisabledClass);
                        if (s.params.a11y && s.a11y) s.a11y.enable($(s.params.nextButton));
                    }
                }
            }
        };
        
        /*=========================
          Pagination
          ===========================*/
        s.updatePagination = function () {
            if (!s.params.pagination) return;
            if (s.paginationContainer && s.paginationContainer.length > 0) {
                var bulletsHTML = '';
                var numberOfBullets = s.params.loop ? Math.ceil((s.slides.length - s.loopedSlides * 2) / s.params.slidesPerGroup) : s.snapGrid.length;
                for (var i = 0; i < numberOfBullets; i++) {
                    if (s.params.paginationBulletRender) {
                        bulletsHTML += s.params.paginationBulletRender(i, s.params.bulletClass);
                    }
                    else {
                        bulletsHTML += '<' + s.params.paginationElement+' class="' + s.params.bulletClass + '"></' + s.params.paginationElement + '>';
                    }
                }
                s.paginationContainer.html(bulletsHTML);
                s.bullets = s.paginationContainer.find('.' + s.params.bulletClass);
                if (s.params.paginationClickable && s.params.a11y && s.a11y) {
                    s.a11y.initPagination();
                }
            }
        };
        /*=========================
          Common update method
          ===========================*/
        s.update = function (updateTranslate) {
            s.updateContainerSize();
            s.updateSlidesSize();
            s.updateProgress();
            s.updatePagination();
            s.updateClasses();
            if (s.params.scrollbar && s.scrollbar) {
                s.scrollbar.set();
            }
            function forceSetTranslate() {
                newTranslate = Math.min(Math.max(s.translate, s.maxTranslate()), s.minTranslate());
                s.setWrapperTranslate(newTranslate);
                s.updateActiveIndex();
                s.updateClasses();
            }
            if (updateTranslate) {
                var translated, newTranslate;
                if (s.controller && s.controller.spline) {
                    s.controller.spline = undefined;
                }
                if (s.params.freeMode) {
                    forceSetTranslate();
                }
                else {
                    if ((s.params.slidesPerView === 'auto' || s.params.slidesPerView > 1) && s.isEnd && !s.params.centeredSlides) {
                        translated = s.slideTo(s.slides.length - 1, 0, false, true);
                    }
                    else {
                        translated = s.slideTo(s.activeIndex, 0, false, true);
                    }
                    if (!translated) {
                        forceSetTranslate();
                    }
                }
        
            }
        };
        
        /*=========================
          Resize Handler
          ===========================*/
        s.onResize = function (forceUpdatePagination) {
            //Breakpoints
            if (s.params.breakpoints) {
                s.setBreakpoint();
            }
        
            // Disable locks on resize
            var allowSwipeToPrev = s.params.allowSwipeToPrev;
            var allowSwipeToNext = s.params.allowSwipeToNext;
            s.params.allowSwipeToPrev = s.params.allowSwipeToNext = true;
        
            s.updateContainerSize();
            s.updateSlidesSize();
            if (s.params.slidesPerView === 'auto' || s.params.freeMode || forceUpdatePagination) s.updatePagination();
            if (s.params.scrollbar && s.scrollbar) {
                s.scrollbar.set();
            }
            if (s.controller && s.controller.spline) {
                s.controller.spline = undefined;
            }
            if (s.params.freeMode) {
                var newTranslate = Math.min(Math.max(s.translate, s.maxTranslate()), s.minTranslate());
                s.setWrapperTranslate(newTranslate);
                s.updateActiveIndex();
                s.updateClasses();
            }
            else {
                s.updateClasses();
                if ((s.params.slidesPerView === 'auto' || s.params.slidesPerView > 1) && s.isEnd && !s.params.centeredSlides) {
                    s.slideTo(s.slides.length - 1, 0, false, true);
                }
                else {
                    s.slideTo(s.activeIndex, 0, false, true);
                }
            }
            // Return locks after resize
            s.params.allowSwipeToPrev = allowSwipeToPrev;
            s.params.allowSwipeToNext = allowSwipeToNext;
        };
        
        /*=========================
          Events
          ===========================*/
        
        //Define Touch Events
        var desktopEvents = ['mousedown', 'mousemove', 'mouseup'];
        if (window.navigator.pointerEnabled) desktopEvents = ['pointerdown', 'pointermove', 'pointerup'];
        else if (window.navigator.msPointerEnabled) desktopEvents = ['MSPointerDown', 'MSPointerMove', 'MSPointerUp'];
        s.touchEvents = {
            start : s.support.touch || !s.params.simulateTouch  ? 'touchstart' : desktopEvents[0],
            move : s.support.touch || !s.params.simulateTouch ? 'touchmove' : desktopEvents[1],
            end : s.support.touch || !s.params.simulateTouch ? 'touchend' : desktopEvents[2]
        };
        
        
        // WP8 Touch Events Fix
        if (window.navigator.pointerEnabled || window.navigator.msPointerEnabled) {
            (s.params.touchEventsTarget === 'container' ? s.container : s.wrapper).addClass('swiper-wp8-' + s.params.direction);
        }
        
        // Attach/detach events
        s.initEvents = function (detach) {
            var actionDom = detach ? 'off' : 'on';
            var action = detach ? 'removeEventListener' : 'addEventListener';
            var touchEventsTarget = s.params.touchEventsTarget === 'container' ? s.container[0] : s.wrapper[0];
            var target = s.support.touch ? touchEventsTarget : document;
        
            var moveCapture = s.params.nested ? true : false;
        
            //Touch Events
            if (s.browser.ie) {
                touchEventsTarget[action](s.touchEvents.start, s.onTouchStart, false);
                target[action](s.touchEvents.move, s.onTouchMove, moveCapture);
                target[action](s.touchEvents.end, s.onTouchEnd, false);
            }
            else {
                if (s.support.touch) {
                    touchEventsTarget[action](s.touchEvents.start, s.onTouchStart, false);
                    touchEventsTarget[action](s.touchEvents.move, s.onTouchMove, moveCapture);
                    touchEventsTarget[action](s.touchEvents.end, s.onTouchEnd, false);
                }
                if (params.simulateTouch && !s.device.ios && !s.device.android) {
                    touchEventsTarget[action]('mousedown', s.onTouchStart, false);
                    document[action]('mousemove', s.onTouchMove, moveCapture);
                    document[action]('mouseup', s.onTouchEnd, false);
                }
            }
            window[action]('resize', s.onResize);
        
            // Next, Prev, Index
            if (s.params.nextButton) {
                $(s.params.nextButton)[actionDom]('click', s.onClickNext);
                if (s.params.a11y && s.a11y) $(s.params.nextButton)[actionDom]('keydown', s.a11y.onEnterKey);
            }
            if (s.params.prevButton) {
                $(s.params.prevButton)[actionDom]('click', s.onClickPrev);
                if (s.params.a11y && s.a11y) $(s.params.prevButton)[actionDom]('keydown', s.a11y.onEnterKey);
            }
            if (s.params.pagination && s.params.paginationClickable) {
                $(s.paginationContainer)[actionDom]('click', '.' + s.params.bulletClass, s.onClickIndex);
                if (s.params.a11y && s.a11y) $(s.paginationContainer)[actionDom]('keydown', '.' + s.params.bulletClass, s.a11y.onEnterKey);
            }
        
            // Prevent Links Clicks
            if (s.params.preventClicks || s.params.preventClicksPropagation) touchEventsTarget[action]('click', s.preventClicks, true);
        };
        s.attachEvents = function (detach) {
            s.initEvents();
        };
        s.detachEvents = function () {
            s.initEvents(true);
        };
        
        /*=========================
          Handle Clicks
          ===========================*/
        // Prevent Clicks
        s.allowClick = true;
        s.preventClicks = function (e) {
            if (!s.allowClick) {
                if (s.params.preventClicks) e.preventDefault();
                if (s.params.preventClicksPropagation && s.animating) {
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                }
            }
        };
        // Clicks
        s.onClickNext = function (e) {
            e.preventDefault();
            if (s.isEnd && !s.params.loop) return;
            s.slideNext();
        };
        s.onClickPrev = function (e) {
            e.preventDefault();
            if (s.isBeginning && !s.params.loop) return;
            s.slidePrev();
        };
        s.onClickIndex = function (e) {
            e.preventDefault();
            var index = $(this).index() * s.params.slidesPerGroup;
            if (s.params.loop) index = index + s.loopedSlides;
            s.slideTo(index);
        };
        
        /*=========================
          Handle Touches
          ===========================*/
        function findElementInEvent(e, selector) {
            var el = $(e.target);
            if (!el.is(selector)) {
                if (typeof selector === 'string') {
                    el = el.parents(selector);
                }
                else if (selector.nodeType) {
                    var found;
                    el.parents().each(function (index, _el) {
                        if (_el === selector) found = selector;
                    });
                    if (!found) return undefined;
                    else return selector;
                }
            }
            if (el.length === 0) {
                return undefined;
            }
            return el[0];
        }
        s.updateClickedSlide = function (e) {
            var slide = findElementInEvent(e, '.' + s.params.slideClass);
            var slideFound = false;
            if (slide) {
                for (var i = 0; i < s.slides.length; i++) {
                    if (s.slides[i] === slide) slideFound = true;
                }
            }
        
            if (slide && slideFound) {
                s.clickedSlide = slide;
                s.clickedIndex = $(slide).index();
            }
            else {
                s.clickedSlide = undefined;
                s.clickedIndex = undefined;
                return;
            }
            if (s.params.slideToClickedSlide && s.clickedIndex !== undefined && s.clickedIndex !== s.activeIndex) {
                var slideToIndex = s.clickedIndex,
                    realIndex,
                    duplicatedSlides;
                if (s.params.loop) {
                    if (s.animating) return;
                    realIndex = $(s.clickedSlide).attr('data-swiper-slide-index');
                    if (s.params.centeredSlides) {
                        if ((slideToIndex < s.loopedSlides - s.params.slidesPerView/2) || (slideToIndex > s.slides.length - s.loopedSlides + s.params.slidesPerView/2)) {
                            s.fixLoop();
                            slideToIndex = s.wrapper.children('.' + s.params.slideClass + '[data-swiper-slide-index="' + realIndex + '"]:not(.swiper-slide-duplicate)').eq(0).index();
                            setTimeout(function () {
                                s.slideTo(slideToIndex);
                            }, 0);
                        }
                        else {
                            s.slideTo(slideToIndex);
                        }
                    }
                    else {
                        if (slideToIndex > s.slides.length - s.params.slidesPerView) {
                            s.fixLoop();
                            slideToIndex = s.wrapper.children('.' + s.params.slideClass + '[data-swiper-slide-index="' + realIndex + '"]:not(.swiper-slide-duplicate)').eq(0).index();
                            setTimeout(function () {
                                s.slideTo(slideToIndex);
                            }, 0);
                        }
                        else {
                            s.slideTo(slideToIndex);
                        }
                    }
                }
                else {
                    s.slideTo(slideToIndex);
                }
            }
        };
        
        var isTouched,
            isMoved,
            allowTouchCallbacks,
            touchStartTime,
            isScrolling,
            currentTranslate,
            startTranslate,
            allowThresholdMove,
            // Form elements to match
            formElements = 'input, select, textarea, button',
            // Last click time
            lastClickTime = Date.now(), clickTimeout,
            //Velocities
            velocities = [],
            allowMomentumBounce;
        
        // Animating Flag
        s.animating = false;
        
        // Touches information
        s.touches = {
            startX: 0,
            startY: 0,
            currentX: 0,
            currentY: 0,
            diff: 0
        };
        
        // Touch handlers
        var isTouchEvent, startMoving;
        s.onTouchStart = function (e) {
            if (e.originalEvent) e = e.originalEvent;
            isTouchEvent = e.type === 'touchstart';
            if (!isTouchEvent && 'which' in e && e.which === 3) return;
            if (s.params.noSwiping && findElementInEvent(e, '.' + s.params.noSwipingClass)) {
                s.allowClick = true;
                return;
            }
            if (s.params.swipeHandler) {
                if (!findElementInEvent(e, s.params.swipeHandler)) return;
            }
        
            var startX = s.touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
            var startY = s.touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
        
            // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore
            if(s.device.ios && s.params.iOSEdgeSwipeDetection && startX <= s.params.iOSEdgeSwipeThreshold) {
                return;
            }
        
            isTouched = true;
            isMoved = false;
            allowTouchCallbacks = true;
            isScrolling = undefined;
            startMoving = undefined;
            s.touches.startX = startX;
            s.touches.startY = startY;
            touchStartTime = Date.now();
            s.allowClick = true;
            s.updateContainerSize();
            s.swipeDirection = undefined;
            if (s.params.threshold > 0) allowThresholdMove = false;
            if (e.type !== 'touchstart') {
                var preventDefault = true;
                if ($(e.target).is(formElements)) preventDefault = false;
                if (document.activeElement && $(document.activeElement).is(formElements)) {
                    document.activeElement.blur();
                }
                if (preventDefault) {
                    e.preventDefault();
                }
            }
            s.emit('onTouchStart', s, e);
        };
        
        s.onTouchMove = function (e) {
            if (e.originalEvent) e = e.originalEvent;
            if (isTouchEvent && e.type === 'mousemove') return;
            if (e.preventedByNestedSwiper) return;
            if (s.params.onlyExternal) {
                // isMoved = true;
                s.allowClick = false;
                if (isTouched) {
                    s.touches.startX = s.touches.currentX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
                    s.touches.startY = s.touches.currentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
                    touchStartTime = Date.now();
                }
                return;
            }
            if (isTouchEvent && document.activeElement) {
                if (e.target === document.activeElement && $(e.target).is(formElements)) {
                    isMoved = true;
                    s.allowClick = false;
                    return;
                }
            }
            if (allowTouchCallbacks) {
                s.emit('onTouchMove', s, e);
            }
            if (e.targetTouches && e.targetTouches.length > 1) return;
        
            s.touches.currentX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
            s.touches.currentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
        
            if (typeof isScrolling === 'undefined') {
                var touchAngle = Math.atan2(Math.abs(s.touches.currentY - s.touches.startY), Math.abs(s.touches.currentX - s.touches.startX)) * 180 / Math.PI;
                isScrolling = isH() ? touchAngle > s.params.touchAngle : (90 - touchAngle > s.params.touchAngle);
            }
            if (isScrolling) {
                s.emit('onTouchMoveOpposite', s, e);
            }
            if (typeof startMoving === 'undefined' && s.browser.ieTouch) {
                if (s.touches.currentX !== s.touches.startX || s.touches.currentY !== s.touches.startY) {
                    startMoving = true;
                }
            }
            if (!isTouched) return;
            if (isScrolling)  {
                isTouched = false;
                return;
            }
            if (!startMoving && s.browser.ieTouch) {
                return;
            }
            s.allowClick = false;
            s.emit('onSliderMove', s, e);
            e.preventDefault();
            if (s.params.touchMoveStopPropagation && !s.params.nested) {
                e.stopPropagation();
            }
        
            if (!isMoved) {
                if (params.loop) {
                    s.fixLoop();
                }
                startTranslate = s.getWrapperTranslate();
                s.setWrapperTransition(0);
                if (s.animating) {
                    s.wrapper.trigger('webkitTransitionEnd transitionend oTransitionEnd MSTransitionEnd msTransitionEnd');
                }
                if (s.params.autoplay && s.autoplaying) {
                    if (s.params.autoplayDisableOnInteraction) {
                        s.stopAutoplay();
                    }
                    else {
                        s.pauseAutoplay();
                    }
                }
                allowMomentumBounce = false;
                //Grab Cursor
                if (s.params.grabCursor) {
                    s.container[0].style.cursor = 'move';
                    s.container[0].style.cursor = '-webkit-grabbing';
                    s.container[0].style.cursor = '-moz-grabbin';
                    s.container[0].style.cursor = 'grabbing';
                }
            }
            isMoved = true;
        
            var diff = s.touches.diff = isH() ? s.touches.currentX - s.touches.startX : s.touches.currentY - s.touches.startY;
        
            diff = diff * s.params.touchRatio;
            if (s.rtl) diff = -diff;
        
            s.swipeDirection = diff > 0 ? 'prev' : 'next';
            currentTranslate = diff + startTranslate;
        
            var disableParentSwiper = true;
            if ((diff > 0 && currentTranslate > s.minTranslate())) {
                disableParentSwiper = false;
                if (s.params.resistance) currentTranslate = s.minTranslate() - 1 + Math.pow(-s.minTranslate() + startTranslate + diff, s.params.resistanceRatio);
            }
            else if (diff < 0 && currentTranslate < s.maxTranslate()) {
                disableParentSwiper = false;
                if (s.params.resistance) currentTranslate = s.maxTranslate() + 1 - Math.pow(s.maxTranslate() - startTranslate - diff, s.params.resistanceRatio);
            }
        
            if (disableParentSwiper) {
                e.preventedByNestedSwiper = true;
            }
        
            // Directions locks
            if (!s.params.allowSwipeToNext && s.swipeDirection === 'next' && currentTranslate < startTranslate) {
                currentTranslate = startTranslate;
            }
            if (!s.params.allowSwipeToPrev && s.swipeDirection === 'prev' && currentTranslate > startTranslate) {
                currentTranslate = startTranslate;
            }
        
            if (!s.params.followFinger) return;
        
            // Threshold
            if (s.params.threshold > 0) {
                if (Math.abs(diff) > s.params.threshold || allowThresholdMove) {
                    if (!allowThresholdMove) {
                        allowThresholdMove = true;
                        s.touches.startX = s.touches.currentX;
                        s.touches.startY = s.touches.currentY;
                        currentTranslate = startTranslate;
                        s.touches.diff = isH() ? s.touches.currentX - s.touches.startX : s.touches.currentY - s.touches.startY;
                        return;
                    }
                }
                else {
                    currentTranslate = startTranslate;
                    return;
                }
            }
            // Update active index in free mode
            if (s.params.freeMode || s.params.watchSlidesProgress) {
                s.updateActiveIndex();
            }
            if (s.params.freeMode) {
                //Velocity
                if (velocities.length === 0) {
                    velocities.push({
                        position: s.touches[isH() ? 'startX' : 'startY'],
                        time: touchStartTime
                    });
                }
                velocities.push({
                    position: s.touches[isH() ? 'currentX' : 'currentY'],
                    time: (new window.Date()).getTime()
                });
            }
            // Update progress
            s.updateProgress(currentTranslate);
            // Update translate
            s.setWrapperTranslate(currentTranslate);
        };
        s.onTouchEnd = function (e) {
            if (e.originalEvent) e = e.originalEvent;
            if (allowTouchCallbacks) {
                s.emit('onTouchEnd', s, e);
            }
            allowTouchCallbacks = false;
            if (!isTouched) return;
            //Return Grab Cursor
            if (s.params.grabCursor && isMoved && isTouched) {
                s.container[0].style.cursor = 'move';
                s.container[0].style.cursor = '-webkit-grab';
                s.container[0].style.cursor = '-moz-grab';
                s.container[0].style.cursor = 'grab';
            }
        
            // Time diff
            var touchEndTime = Date.now();
            var timeDiff = touchEndTime - touchStartTime;
        
            // Tap, doubleTap, Click
            if (s.allowClick) {
                s.updateClickedSlide(e);
                s.emit('onTap', s, e);
                if (timeDiff < 300 && (touchEndTime - lastClickTime) > 300) {
                    if (clickTimeout) clearTimeout(clickTimeout);
                    clickTimeout = setTimeout(function () {
                        if (!s) return;
                        if (s.params.paginationHide && s.paginationContainer.length > 0 && !$(e.target).hasClass(s.params.bulletClass)) {
                            s.paginationContainer.toggleClass(s.params.paginationHiddenClass);
                        }
                        s.emit('onClick', s, e);
                    }, 300);
        
                }
                if (timeDiff < 300 && (touchEndTime - lastClickTime) < 300) {
                    if (clickTimeout) clearTimeout(clickTimeout);
                    s.emit('onDoubleTap', s, e);
                }
            }
        
            lastClickTime = Date.now();
            setTimeout(function () {
                if (s) s.allowClick = true;
            }, 0);
        
            if (!isTouched || !isMoved || !s.swipeDirection || s.touches.diff === 0 || currentTranslate === startTranslate) {
                isTouched = isMoved = false;
                return;
            }
            isTouched = isMoved = false;
        
            var currentPos;
            if (s.params.followFinger) {
                currentPos = s.rtl ? s.translate : -s.translate;
            }
            else {
                currentPos = -currentTranslate;
            }
            if (s.params.freeMode) {
                if (currentPos < -s.minTranslate()) {
                    s.slideTo(s.activeIndex);
                    return;
                }
                else if (currentPos > -s.maxTranslate()) {
                    if (s.slides.length < s.snapGrid.length) {
                        s.slideTo(s.snapGrid.length - 1);
                    }
                    else {
                        s.slideTo(s.slides.length - 1);
                    }
                    return;
                }
        
                if (s.params.freeModeMomentum) {
                    if (velocities.length > 1) {
                        var lastMoveEvent = velocities.pop(), velocityEvent = velocities.pop();
        
                        var distance = lastMoveEvent.position - velocityEvent.position;
                        var time = lastMoveEvent.time - velocityEvent.time;
                        s.velocity = distance / time;
                        s.velocity = s.velocity / 2;
                        if (Math.abs(s.velocity) < s.params.freeModeMinimumVelocity) {
                            s.velocity = 0;
                        }
                        // this implies that the user stopped moving a finger then released.
                        // There would be no events with distance zero, so the last event is stale.
                        if (time > 150 || (new window.Date().getTime() - lastMoveEvent.time) > 300) {
                            s.velocity = 0;
                        }
                    } else {
                        s.velocity = 0;
                    }
        
                    velocities.length = 0;
                    var momentumDuration = 1000 * s.params.freeModeMomentumRatio;
                    var momentumDistance = s.velocity * momentumDuration;
        
                    var newPosition = s.translate + momentumDistance;
                    if (s.rtl) newPosition = - newPosition;
                    var doBounce = false;
                    var afterBouncePosition;
                    var bounceAmount = Math.abs(s.velocity) * 20 * s.params.freeModeMomentumBounceRatio;
                    if (newPosition < s.maxTranslate()) {
                        if (s.params.freeModeMomentumBounce) {
                            if (newPosition + s.maxTranslate() < -bounceAmount) {
                                newPosition = s.maxTranslate() - bounceAmount;
                            }
                            afterBouncePosition = s.maxTranslate();
                            doBounce = true;
                            allowMomentumBounce = true;
                        }
                        else {
                            newPosition = s.maxTranslate();
                        }
                    }
                    else if (newPosition > s.minTranslate()) {
                        if (s.params.freeModeMomentumBounce) {
                            if (newPosition - s.minTranslate() > bounceAmount) {
                                newPosition = s.minTranslate() + bounceAmount;
                            }
                            afterBouncePosition = s.minTranslate();
                            doBounce = true;
                            allowMomentumBounce = true;
                        }
                        else {
                            newPosition = s.minTranslate();
                        }
                    }
                    else if (s.params.freeModeSticky) {
                        var j = 0,
                            nextSlide;
                        for (j = 0; j < s.snapGrid.length; j += 1) {
                            if (s.snapGrid[j] > -newPosition) {
                                nextSlide = j;
                                break;
                            }
        
                        }
                        if (Math.abs(s.snapGrid[nextSlide] - newPosition) < Math.abs(s.snapGrid[nextSlide - 1] - newPosition) || s.swipeDirection === 'next') {
                            newPosition = s.snapGrid[nextSlide];
                        } else {
                            newPosition = s.snapGrid[nextSlide - 1];
                        }
                        if (!s.rtl) newPosition = - newPosition;
                    }
                    //Fix duration
                    if (s.velocity !== 0) {
                        if (s.rtl) {
                            momentumDuration = Math.abs((-newPosition - s.translate) / s.velocity);
                        }
                        else {
                            momentumDuration = Math.abs((newPosition - s.translate) / s.velocity);
                        }
                    }
                    else if (s.params.freeModeSticky) {
                        s.slideReset();
                        return;
                    }
        
                    if (s.params.freeModeMomentumBounce && doBounce) {
                        s.updateProgress(afterBouncePosition);
                        s.setWrapperTransition(momentumDuration);
                        s.setWrapperTranslate(newPosition);
                        s.onTransitionStart();
                        s.animating = true;
                        s.wrapper.transitionEnd(function () {
                            if (!s || !allowMomentumBounce) return;
                            s.emit('onMomentumBounce', s);
        
                            s.setWrapperTransition(s.params.speed);
                            s.setWrapperTranslate(afterBouncePosition);
                            s.wrapper.transitionEnd(function () {
                                if (!s) return;
                                s.onTransitionEnd();
                            });
                        });
                    } else if (s.velocity) {
                        s.updateProgress(newPosition);
                        s.setWrapperTransition(momentumDuration);
                        s.setWrapperTranslate(newPosition);
                        s.onTransitionStart();
                        if (!s.animating) {
                            s.animating = true;
                            s.wrapper.transitionEnd(function () {
                                if (!s) return;
                                s.onTransitionEnd();
                            });
                        }
        
                    } else {
                        s.updateProgress(newPosition);
                    }
        
                    s.updateActiveIndex();
                }
                if (!s.params.freeModeMomentum || timeDiff >= s.params.longSwipesMs) {
                    s.updateProgress();
                    s.updateActiveIndex();
                }
                return;
            }
        
            // Find current slide
            var i, stopIndex = 0, groupSize = s.slidesSizesGrid[0];
            for (i = 0; i < s.slidesGrid.length; i += s.params.slidesPerGroup) {
                if (typeof s.slidesGrid[i + s.params.slidesPerGroup] !== 'undefined') {
                    if (currentPos >= s.slidesGrid[i] && currentPos < s.slidesGrid[i + s.params.slidesPerGroup]) {
                        stopIndex = i;
                        groupSize = s.slidesGrid[i + s.params.slidesPerGroup] - s.slidesGrid[i];
                    }
                }
                else {
                    if (currentPos >= s.slidesGrid[i]) {
                        stopIndex = i;
                        groupSize = s.slidesGrid[s.slidesGrid.length - 1] - s.slidesGrid[s.slidesGrid.length - 2];
                    }
                }
            }
        
            // Find current slide size
            var ratio = (currentPos - s.slidesGrid[stopIndex]) / groupSize;
        
            if (timeDiff > s.params.longSwipesMs) {
                // Long touches
                if (!s.params.longSwipes) {
                    s.slideTo(s.activeIndex);
                    return;
                }
                if (s.swipeDirection === 'next') {
                    if (ratio >= s.params.longSwipesRatio) s.slideTo(stopIndex + s.params.slidesPerGroup);
                    else s.slideTo(stopIndex);
        
                }
                if (s.swipeDirection === 'prev') {
                    if (ratio > (1 - s.params.longSwipesRatio)) s.slideTo(stopIndex + s.params.slidesPerGroup);
                    else s.slideTo(stopIndex);
                }
            }
            else {
                // Short swipes
                if (!s.params.shortSwipes) {
                    s.slideTo(s.activeIndex);
                    return;
                }
                if (s.swipeDirection === 'next') {
                    s.slideTo(stopIndex + s.params.slidesPerGroup);
        
                }
                if (s.swipeDirection === 'prev') {
                    s.slideTo(stopIndex);
                }
            }
        };
        /*=========================
          Transitions
          ===========================*/
        s._slideTo = function (slideIndex, speed) {
            return s.slideTo(slideIndex, speed, true, true);
        };
        s.slideTo = function (slideIndex, speed, runCallbacks, internal) {
            if (typeof runCallbacks === 'undefined') runCallbacks = true;
            if (typeof slideIndex === 'undefined') slideIndex = 0;
            if (slideIndex < 0) slideIndex = 0;
            s.snapIndex = Math.floor(slideIndex / s.params.slidesPerGroup);
            if (s.snapIndex >= s.snapGrid.length) s.snapIndex = s.snapGrid.length - 1;
        
            var translate = - s.snapGrid[s.snapIndex];
        
            // Stop autoplay
            if (s.params.autoplay && s.autoplaying) {
                if (internal || !s.params.autoplayDisableOnInteraction) {
                    s.pauseAutoplay(speed);
                }
                else {
                    s.stopAutoplay();
                }
            }
            // Update progress
            s.updateProgress(translate);
        
            // Normalize slideIndex
            for (var i = 0; i < s.slidesGrid.length; i++) {
                if (- Math.floor(translate * 100) >= Math.floor(s.slidesGrid[i] * 100)) {
                    slideIndex = i;
                }
            }
        
            // Directions locks
            if (!s.params.allowSwipeToNext && translate < s.translate && translate < s.minTranslate()) {
                return false;
            }
            if (!s.params.allowSwipeToPrev && translate > s.translate && translate > s.maxTranslate()) {
                if ((s.activeIndex || 0) !== slideIndex ) return false;
            }
        
            // Update Index
            if (typeof speed === 'undefined') speed = s.params.speed;
            s.previousIndex = s.activeIndex || 0;
            s.activeIndex = slideIndex;
        
            if (translate === s.translate) {
                s.updateClasses();
                return false;
            }
            s.updateClasses();
            s.onTransitionStart(runCallbacks);
            var translateX = isH() ? translate : 0, translateY = isH() ? 0 : translate;
            if (speed === 0) {
                s.setWrapperTransition(0);
                s.setWrapperTranslate(translate);
                s.onTransitionEnd(runCallbacks);
            }
            else {
                s.setWrapperTransition(speed);
                s.setWrapperTranslate(translate);
                if (!s.animating) {
                    s.animating = true;
                    s.wrapper.transitionEnd(function () {
                        if (!s) return;
                        s.onTransitionEnd(runCallbacks);
                    });
                }
        
            }
        
            return true;
        };
        
        s.onTransitionStart = function (runCallbacks) {
            if (typeof runCallbacks === 'undefined') runCallbacks = true;
            if (s.lazy) s.lazy.onTransitionStart();
            if (runCallbacks) {
                s.emit('onTransitionStart', s);
                if (s.activeIndex !== s.previousIndex) {
                    s.emit('onSlideChangeStart', s);
                    if (s.activeIndex > s.previousIndex) {
                        s.emit('onSlideNextStart', s);
                    }
                    else {
                        s.emit('onSlidePrevStart', s);
                    }
                }
        
            }
        };
        s.onTransitionEnd = function (runCallbacks) {
            s.animating = false;
            s.setWrapperTransition(0);
            if (typeof runCallbacks === 'undefined') runCallbacks = true;
            if (s.lazy) s.lazy.onTransitionEnd();
            if (runCallbacks) {
                s.emit('onTransitionEnd', s);
                if (s.activeIndex !== s.previousIndex) {
                    s.emit('onSlideChangeEnd', s);
                    if (s.activeIndex > s.previousIndex) {
                        s.emit('onSlideNextEnd', s);
                    }
                    else {
                        s.emit('onSlidePrevEnd', s);
                    }
                }
            }
            if (s.params.hashnav && s.hashnav) {
                s.hashnav.setHash();
            }
        
        };
        s.slideNext = function (runCallbacks, speed, internal) {
            if (s.params.loop) {
                if (s.animating) return false;
                s.fixLoop();
                var clientLeft = s.container[0].clientLeft;
                return s.slideTo(s.activeIndex + s.params.slidesPerGroup, speed, runCallbacks, internal);
            }
            else return s.slideTo(s.activeIndex + s.params.slidesPerGroup, speed, runCallbacks, internal);
        };
        s._slideNext = function (speed) {
            return s.slideNext(true, speed, true);
        };
        s.slidePrev = function (runCallbacks, speed, internal) {
            if (s.params.loop) {
                if (s.animating) return false;
                s.fixLoop();
                var clientLeft = s.container[0].clientLeft;
                return s.slideTo(s.activeIndex - 1, speed, runCallbacks, internal);
            }
            else return s.slideTo(s.activeIndex - 1, speed, runCallbacks, internal);
        };
        s._slidePrev = function (speed) {
            return s.slidePrev(true, speed, true);
        };
        s.slideReset = function (runCallbacks, speed, internal) {
            return s.slideTo(s.activeIndex, speed, runCallbacks);
        };
        
        /*=========================
          Translate/transition helpers
          ===========================*/
        s.setWrapperTransition = function (duration, byController) {
            s.wrapper.transition(duration);
            if (s.params.effect !== 'slide' && s.effects[s.params.effect]) {
                s.effects[s.params.effect].setTransition(duration);
            }
            if (s.params.parallax && s.parallax) {
                s.parallax.setTransition(duration);
            }
            if (s.params.scrollbar && s.scrollbar) {
                s.scrollbar.setTransition(duration);
            }
            if (s.params.control && s.controller) {
                s.controller.setTransition(duration, byController);
            }
            s.emit('onSetTransition', s, duration);
        };
        s.setWrapperTranslate = function (translate, updateActiveIndex, byController) {
            var x = 0, y = 0, z = 0;
            if (isH()) {
                x = s.rtl ? -translate : translate;
            }
            else {
                y = translate;
            }
        
            if (s.params.roundLengths) {
                x = round(x);
                y = round(y);
            }
        
            if (!s.params.virtualTranslate) {
                if (s.support.transforms3d) s.wrapper.transform('translate3d(' + x + 'px, ' + y + 'px, ' + z + 'px)');
                else s.wrapper.transform('translate(' + x + 'px, ' + y + 'px)');
            }
        
            s.translate = isH() ? x : y;
        
            if (updateActiveIndex) s.updateActiveIndex();
            if (s.params.effect !== 'slide' && s.effects[s.params.effect]) {
                s.effects[s.params.effect].setTranslate(s.translate);
            }
            if (s.params.parallax && s.parallax) {
                s.parallax.setTranslate(s.translate);
            }
            if (s.params.scrollbar && s.scrollbar) {
                s.scrollbar.setTranslate(s.translate);
            }
            if (s.params.control && s.controller) {
                s.controller.setTranslate(s.translate, byController);
            }
            s.emit('onSetTranslate', s, s.translate);
        };
        
        s.getTranslate = function (el, axis) {
            var matrix, curTransform, curStyle, transformMatrix;
        
            // automatic axis detection
            if (typeof axis === 'undefined') {
                axis = 'x';
            }
        
            if (s.params.virtualTranslate) {
                return s.rtl ? -s.translate : s.translate;
            }
        
            curStyle = window.getComputedStyle(el, null);
            if (window.WebKitCSSMatrix) {
                curTransform = curStyle.transform || curStyle.webkitTransform;
                if (curTransform.split(',').length > 6) {
                    curTransform = curTransform.split(', ').map(function(a){
                        return a.replace(',','.');
                    }).join(', ');
                }
                // Some old versions of Webkit choke when 'none' is passed; pass
                // empty string instead in this case
                transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
            }
            else {
                transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform  || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
                matrix = transformMatrix.toString().split(',');
            }
        
            if (axis === 'x') {
                //Latest Chrome and webkits Fix
                if (window.WebKitCSSMatrix)
                    curTransform = transformMatrix.m41;
                //Crazy IE10 Matrix
                else if (matrix.length === 16)
                    curTransform = parseFloat(matrix[12]);
                //Normal Browsers
                else
                    curTransform = parseFloat(matrix[4]);
            }
            if (axis === 'y') {
                //Latest Chrome and webkits Fix
                if (window.WebKitCSSMatrix)
                    curTransform = transformMatrix.m42;
                //Crazy IE10 Matrix
                else if (matrix.length === 16)
                    curTransform = parseFloat(matrix[13]);
                //Normal Browsers
                else
                    curTransform = parseFloat(matrix[5]);
            }
            if (s.rtl && curTransform) curTransform = -curTransform;
            return curTransform || 0;
        };
        s.getWrapperTranslate = function (axis) {
            if (typeof axis === 'undefined') {
                axis = isH() ? 'x' : 'y';
            }
            return s.getTranslate(s.wrapper[0], axis);
        };
        
        /*=========================
          Observer
          ===========================*/
        s.observers = [];
        function initObserver(target, options) {
            options = options || {};
            // create an observer instance
            var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
            var observer = new ObserverFunc(function (mutations) {
                mutations.forEach(function (mutation) {
                    s.onResize(true);
                    s.emit('onObserverUpdate', s, mutation);
                });
            });
        
            observer.observe(target, {
                attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
                childList: typeof options.childList === 'undefined' ? true : options.childList,
                characterData: typeof options.characterData === 'undefined' ? true : options.characterData
            });
        
            s.observers.push(observer);
        }
        s.initObservers = function () {
            if (s.params.observeParents) {
                var containerParents = s.container.parents();
                for (var i = 0; i < containerParents.length; i++) {
                    initObserver(containerParents[i]);
                }
            }
        
            // Observe container
            initObserver(s.container[0], {childList: false});
        
            // Observe wrapper
            initObserver(s.wrapper[0], {attributes: false});
        };
        s.disconnectObservers = function () {
            for (var i = 0; i < s.observers.length; i++) {
                s.observers[i].disconnect();
            }
            s.observers = [];
        };
        /*=========================
          Loop
          ===========================*/
        // Create looped slides
        s.createLoop = function () {
            // Remove duplicated slides
            s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass).remove();
        
            var slides = s.wrapper.children('.' + s.params.slideClass);
        
            if(s.params.slidesPerView === 'auto' && !s.params.loopedSlides) s.params.loopedSlides = slides.length;
        
            s.loopedSlides = parseInt(s.params.loopedSlides || s.params.slidesPerView, 10);
            s.loopedSlides = s.loopedSlides + s.params.loopAdditionalSlides;
            if (s.loopedSlides > slides.length) {
                s.loopedSlides = slides.length;
            }
        
            var prependSlides = [], appendSlides = [], i;
            slides.each(function (index, el) {
                var slide = $(this);
                if (index < s.loopedSlides) appendSlides.push(el);
                if (index < slides.length && index >= slides.length - s.loopedSlides) prependSlides.push(el);
                slide.attr('data-swiper-slide-index', index);
            });
            for (i = 0; i < appendSlides.length; i++) {
                s.wrapper.append($(appendSlides[i].cloneNode(true)).addClass(s.params.slideDuplicateClass));
            }
            for (i = prependSlides.length - 1; i >= 0; i--) {
                s.wrapper.prepend($(prependSlides[i].cloneNode(true)).addClass(s.params.slideDuplicateClass));
            }
        };
        s.destroyLoop = function () {
            s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass).remove();
            s.slides.removeAttr('data-swiper-slide-index');
        };
        s.fixLoop = function () {
            var newIndex;
            //Fix For Negative Oversliding
            if (s.activeIndex < s.loopedSlides) {
                newIndex = s.slides.length - s.loopedSlides * 3 + s.activeIndex;
                newIndex = newIndex + s.loopedSlides;
                s.slideTo(newIndex, 0, false, true);
            }
            //Fix For Positive Oversliding
            else if ((s.params.slidesPerView === 'auto' && s.activeIndex >= s.loopedSlides * 2) || (s.activeIndex > s.slides.length - s.params.slidesPerView * 2)) {
                newIndex = -s.slides.length + s.activeIndex + s.loopedSlides;
                newIndex = newIndex + s.loopedSlides;
                s.slideTo(newIndex, 0, false, true);
            }
        };
        /*=========================
          Append/Prepend/Remove Slides
          ===========================*/
        s.appendSlide = function (slides) {
            if (s.params.loop) {
                s.destroyLoop();
            }
            if (typeof slides === 'object' && slides.length) {
                for (var i = 0; i < slides.length; i++) {
                    if (slides[i]) s.wrapper.append(slides[i]);
                }
            }
            else {
                s.wrapper.append(slides);
            }
            if (s.params.loop) {
                s.createLoop();
            }
            if (!(s.params.observer && s.support.observer)) {
                s.update(true);
            }
        };
        s.prependSlide = function (slides) {
            if (s.params.loop) {
                s.destroyLoop();
            }
            var newActiveIndex = s.activeIndex + 1;
            if (typeof slides === 'object' && slides.length) {
                for (var i = 0; i < slides.length; i++) {
                    if (slides[i]) s.wrapper.prepend(slides[i]);
                }
                newActiveIndex = s.activeIndex + slides.length;
            }
            else {
                s.wrapper.prepend(slides);
            }
            if (s.params.loop) {
                s.createLoop();
            }
            if (!(s.params.observer && s.support.observer)) {
                s.update(true);
            }
            s.slideTo(newActiveIndex, 0, false);
        };
        s.removeSlide = function (slidesIndexes) {
            if (s.params.loop) {
                s.destroyLoop();
                s.slides = s.wrapper.children('.' + s.params.slideClass);
            }
            var newActiveIndex = s.activeIndex,
                indexToRemove;
            if (typeof slidesIndexes === 'object' && slidesIndexes.length) {
                for (var i = 0; i < slidesIndexes.length; i++) {
                    indexToRemove = slidesIndexes[i];
                    if (s.slides[indexToRemove]) s.slides.eq(indexToRemove).remove();
                    if (indexToRemove < newActiveIndex) newActiveIndex--;
                }
                newActiveIndex = Math.max(newActiveIndex, 0);
            }
            else {
                indexToRemove = slidesIndexes;
                if (s.slides[indexToRemove]) s.slides.eq(indexToRemove).remove();
                if (indexToRemove < newActiveIndex) newActiveIndex--;
                newActiveIndex = Math.max(newActiveIndex, 0);
            }
        
            if (s.params.loop) {
                s.createLoop();
            }
        
            if (!(s.params.observer && s.support.observer)) {
                s.update(true);
            }
            if (s.params.loop) {
                s.slideTo(newActiveIndex + s.loopedSlides, 0, false);
            }
            else {
                s.slideTo(newActiveIndex, 0, false);
            }
        
        };
        s.removeAllSlides = function () {
            var slidesIndexes = [];
            for (var i = 0; i < s.slides.length; i++) {
                slidesIndexes.push(i);
            }
            s.removeSlide(slidesIndexes);
        };
        

        /*=========================
          Effects
          ===========================*/
        s.effects = {
            fade: {
                setTranslate: function () {
                    for (var i = 0; i < s.slides.length; i++) {
                        var slide = s.slides.eq(i);
                        var offset = slide[0].swiperSlideOffset;
                        var tx = -offset;
                        if (!s.params.virtualTranslate) tx = tx - s.translate;
                        var ty = 0;
                        if (!isH()) {
                            ty = tx;
                            tx = 0;
                        }
                        var slideOpacity = s.params.fade.crossFade ?
                                Math.max(1 - Math.abs(slide[0].progress), 0) :
                                1 + Math.min(Math.max(slide[0].progress, -1), 0);
                        slide
                            .css({
                                opacity: slideOpacity
                            })
                            .transform('translate3d(' + tx + 'px, ' + ty + 'px, 0px)');
        
                    }
        
                },
                setTransition: function (duration) {
                    s.slides.transition(duration);
                    if (s.params.virtualTranslate && duration !== 0) {
                        var eventTriggered = false;
                        s.slides.transitionEnd(function () {
                            if (eventTriggered) return;
                            if (!s) return;
                            eventTriggered = true;
                            s.animating = false;
                            var triggerEvents = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'];
                            for (var i = 0; i < triggerEvents.length; i++) {
                                s.wrapper.trigger(triggerEvents[i]);
                            }
                        });
                    }
                }
            },
            cube: {
                setTranslate: function () {
                    var wrapperRotate = 0, cubeShadow;
                    if (s.params.cube.shadow) {
                        if (isH()) {
                            cubeShadow = s.wrapper.find('.swiper-cube-shadow');
                            if (cubeShadow.length === 0) {
                                cubeShadow = $('<div class="swiper-cube-shadow"></div>');
                                s.wrapper.append(cubeShadow);
                            }
                            cubeShadow.css({height: s.width + 'px'});
                        }
                        else {
                            cubeShadow = s.container.find('.swiper-cube-shadow');
                            if (cubeShadow.length === 0) {
                                cubeShadow = $('<div class="swiper-cube-shadow"></div>');
                                s.container.append(cubeShadow);
                            }
                        }
                    }
                    for (var i = 0; i < s.slides.length; i++) {
                        var slide = s.slides.eq(i);
                        var slideAngle = i * 90;
                        var round = Math.floor(slideAngle / 360);
                        if (s.rtl) {
                            slideAngle = -slideAngle;
                            round = Math.floor(-slideAngle / 360);
                        }
                        var progress = Math.max(Math.min(slide[0].progress, 1), -1);
                        var tx = 0, ty = 0, tz = 0;
                        if (i % 4 === 0) {
                            tx = - round * 4 * s.size;
                            tz = 0;
                        }
                        else if ((i - 1) % 4 === 0) {
                            tx = 0;
                            tz = - round * 4 * s.size;
                        }
                        else if ((i - 2) % 4 === 0) {
                            tx = s.size + round * 4 * s.size;
                            tz = s.size;
                        }
                        else if ((i - 3) % 4 === 0) {
                            tx = - s.size;
                            tz = 3 * s.size + s.size * 4 * round;
                        }
                        if (s.rtl) {
                            tx = -tx;
                        }
        
                        if (!isH()) {
                            ty = tx;
                            tx = 0;
                        }
        
                        var transform = 'rotateX(' + (isH() ? 0 : -slideAngle) + 'deg) rotateY(' + (isH() ? slideAngle : 0) + 'deg) translate3d(' + tx + 'px, ' + ty + 'px, ' + tz + 'px)';
                        if (progress <= 1 && progress > -1) {
                            wrapperRotate = i * 90 + progress * 90;
                            if (s.rtl) wrapperRotate = -i * 90 - progress * 90;
                        }
                        slide.transform(transform);
                        if (s.params.cube.slideShadows) {
                            //Set shadows
                            var shadowBefore = isH() ? slide.find('.swiper-slide-shadow-left') : slide.find('.swiper-slide-shadow-top');
                            var shadowAfter = isH() ? slide.find('.swiper-slide-shadow-right') : slide.find('.swiper-slide-shadow-bottom');
                            if (shadowBefore.length === 0) {
                                shadowBefore = $('<div class="swiper-slide-shadow-' + (isH() ? 'left' : 'top') + '"></div>');
                                slide.append(shadowBefore);
                            }
                            if (shadowAfter.length === 0) {
                                shadowAfter = $('<div class="swiper-slide-shadow-' + (isH() ? 'right' : 'bottom') + '"></div>');
                                slide.append(shadowAfter);
                            }
                            var shadowOpacity = slide[0].progress;
                            if (shadowBefore.length) shadowBefore[0].style.opacity = -slide[0].progress;
                            if (shadowAfter.length) shadowAfter[0].style.opacity = slide[0].progress;
                        }
                    }
                    s.wrapper.css({
                        '-webkit-transform-origin': '50% 50% -' + (s.size / 2) + 'px',
                        '-moz-transform-origin': '50% 50% -' + (s.size / 2) + 'px',
                        '-ms-transform-origin': '50% 50% -' + (s.size / 2) + 'px',
                        'transform-origin': '50% 50% -' + (s.size / 2) + 'px'
                    });
        
                    if (s.params.cube.shadow) {
                        if (isH()) {
                            cubeShadow.transform('translate3d(0px, ' + (s.width / 2 + s.params.cube.shadowOffset) + 'px, ' + (-s.width / 2) + 'px) rotateX(90deg) rotateZ(0deg) scale(' + (s.params.cube.shadowScale) + ')');
                        }
                        else {
                            var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                            var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                            var scale1 = s.params.cube.shadowScale,
                                scale2 = s.params.cube.shadowScale / multiplier,
                                offset = s.params.cube.shadowOffset;
                            cubeShadow.transform('scale3d(' + scale1 + ', 1, ' + scale2 + ') translate3d(0px, ' + (s.height / 2 + offset) + 'px, ' + (-s.height / 2 / scale2) + 'px) rotateX(-90deg)');
                        }
                    }
                    var zFactor = (s.isSafari || s.isUiWebView) ? (-s.size / 2) : 0;
                    s.wrapper.transform('translate3d(0px,0,' + zFactor + 'px) rotateX(' + (isH() ? 0 : wrapperRotate) + 'deg) rotateY(' + (isH() ? -wrapperRotate : 0) + 'deg)');
                },
                setTransition: function (duration) {
                    s.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
                    if (s.params.cube.shadow && !isH()) {
                        s.container.find('.swiper-cube-shadow').transition(duration);
                    }
                }
            },
            coverflow: {
                setTranslate: function () {
                    var transform = s.translate;
                    var center = isH() ? -transform + s.width / 2 : -transform + s.height / 2;
                    var rotate = isH() ? s.params.coverflow.rotate: -s.params.coverflow.rotate;
                    var translate = s.params.coverflow.depth;
                    //Each slide offset from center
                    for (var i = 0, length = s.slides.length; i < length; i++) {
                        var slide = s.slides.eq(i);
                        var slideSize = s.slidesSizesGrid[i];
                        var slideOffset = slide[0].swiperSlideOffset;
                        var offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * s.params.coverflow.modifier;
        
                        var rotateY = isH() ? rotate * offsetMultiplier : 0;
                        var rotateX = isH() ? 0 : rotate * offsetMultiplier;
                        // var rotateZ = 0
                        var translateZ = -translate * Math.abs(offsetMultiplier);
        
                        var translateY = isH() ? 0 : s.params.coverflow.stretch * (offsetMultiplier);
                        var translateX = isH() ? s.params.coverflow.stretch * (offsetMultiplier) : 0;
        
                        //Fix for ultra small values
                        if (Math.abs(translateX) < 0.001) translateX = 0;
                        if (Math.abs(translateY) < 0.001) translateY = 0;
                        if (Math.abs(translateZ) < 0.001) translateZ = 0;
                        if (Math.abs(rotateY) < 0.001) rotateY = 0;
                        if (Math.abs(rotateX) < 0.001) rotateX = 0;
        
                        var slideTransform = 'translate3d(' + translateX + 'px,' + translateY + 'px,' + translateZ + 'px)  rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)';
        
                        slide.transform(slideTransform);
                        slide[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
                        if (s.params.coverflow.slideShadows) {
                            //Set shadows
                            var shadowBefore = isH() ? slide.find('.swiper-slide-shadow-left') : slide.find('.swiper-slide-shadow-top');
                            var shadowAfter = isH() ? slide.find('.swiper-slide-shadow-right') : slide.find('.swiper-slide-shadow-bottom');
                            if (shadowBefore.length === 0) {
                                shadowBefore = $('<div class="swiper-slide-shadow-' + (isH() ? 'left' : 'top') + '"></div>');
                                slide.append(shadowBefore);
                            }
                            if (shadowAfter.length === 0) {
                                shadowAfter = $('<div class="swiper-slide-shadow-' + (isH() ? 'right' : 'bottom') + '"></div>');
                                slide.append(shadowAfter);
                            }
                            if (shadowBefore.length) shadowBefore[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                            if (shadowAfter.length) shadowAfter[0].style.opacity = (-offsetMultiplier) > 0 ? -offsetMultiplier : 0;
                        }
                    }
        
                    //Set correct perspective for IE10
                    if (s.browser.ie) {
                        var ws = s.wrapper[0].style;
                        ws.perspectiveOrigin = center + 'px 50%';
                    }
                },
                setTransition: function (duration) {
                    s.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
                }
            }
        };

        /*=========================
          Images Lazy Loading
          ===========================*/
        s.lazy = {
            initialImageLoaded: false,
            loadImageInSlide: function (index, loadInDuplicate) {
                if (typeof index === 'undefined') return;
                if (typeof loadInDuplicate === 'undefined') loadInDuplicate = true;
                if (s.slides.length === 0) return;
        
                var slide = s.slides.eq(index);
                var img = slide.find('.swiper-lazy:not(.swiper-lazy-loaded):not(.swiper-lazy-loading)');
                if (slide.hasClass('swiper-lazy') && !slide.hasClass('swiper-lazy-loaded') && !slide.hasClass('swiper-lazy-loading')) {
                    img = img.add(slide[0]);
                }
                if (img.length === 0) return;
        
                img.each(function () {
                    var _img = $(this);
                    _img.addClass('swiper-lazy-loading');
                    var background = _img.attr('data-background');
                    var src = _img.attr('data-src'),
                        srcset = _img.attr('data-srcset');
                    s.loadImage(_img[0], (src || background), srcset, false, function () {
                        if (background) {
                            _img.css('background-image', 'url(' + background + ')');
                            _img.removeAttr('data-background');
                        }
                        else {
                            if (srcset) {
                                _img.attr('srcset', srcset);
                                _img.removeAttr('data-srcset');
                            }
                            if (src) {
                                _img.attr('src', src);
                                _img.removeAttr('data-src');
                            }
        
                        }
        
                        _img.addClass('swiper-lazy-loaded').removeClass('swiper-lazy-loading');
                        slide.find('.swiper-lazy-preloader, .preloader').remove();
                        if (s.params.loop && loadInDuplicate) {
                            var slideOriginalIndex = slide.attr('data-swiper-slide-index');
                            if (slide.hasClass(s.params.slideDuplicateClass)) {
                                var originalSlide = s.wrapper.children('[data-swiper-slide-index="' + slideOriginalIndex + '"]:not(.' + s.params.slideDuplicateClass + ')');
                                s.lazy.loadImageInSlide(originalSlide.index(), false);
                            }
                            else {
                                var duplicatedSlide = s.wrapper.children('.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + slideOriginalIndex + '"]');
                                s.lazy.loadImageInSlide(duplicatedSlide.index(), false);
                            }
                        }
                        s.emit('onLazyImageReady', s, slide[0], _img[0]);
                    });
        
                    s.emit('onLazyImageLoad', s, slide[0], _img[0]);
                });
        
            },
            load: function () {
                var i;
                if (s.params.watchSlidesVisibility) {
                    s.wrapper.children('.' + s.params.slideVisibleClass).each(function () {
                        s.lazy.loadImageInSlide($(this).index());
                    });
                }
                else {
                    if (s.params.slidesPerView > 1) {
                        for (i = s.activeIndex; i < s.activeIndex + s.params.slidesPerView ; i++) {
                            if (s.slides[i]) s.lazy.loadImageInSlide(i);
                        }
                    }
                    else {
                        s.lazy.loadImageInSlide(s.activeIndex);
                    }
                }
                if (s.params.lazyLoadingInPrevNext) {
                    if (s.params.slidesPerView > 1) {
                        // Next Slides
                        for (i = s.activeIndex + s.params.slidesPerView; i < s.activeIndex + s.params.slidesPerView + s.params.slidesPerView; i++) {
                            if (s.slides[i]) s.lazy.loadImageInSlide(i);
                        }
                        // Prev Slides
                        for (i = s.activeIndex - s.params.slidesPerView; i < s.activeIndex ; i++) {
                            if (s.slides[i]) s.lazy.loadImageInSlide(i);
                        }
                    }
                    else {
                        var nextSlide = s.wrapper.children('.' + s.params.slideNextClass);
                        if (nextSlide.length > 0) s.lazy.loadImageInSlide(nextSlide.index());
        
                        var prevSlide = s.wrapper.children('.' + s.params.slidePrevClass);
                        if (prevSlide.length > 0) s.lazy.loadImageInSlide(prevSlide.index());
                    }
                }
            },
            onTransitionStart: function () {
                if (s.params.lazyLoading) {
                    if (s.params.lazyLoadingOnTransitionStart || (!s.params.lazyLoadingOnTransitionStart && !s.lazy.initialImageLoaded)) {
                        s.lazy.load();
                    }
                }
            },
            onTransitionEnd: function () {
                if (s.params.lazyLoading && !s.params.lazyLoadingOnTransitionStart) {
                    s.lazy.load();
                }
            }
        };
        

        /*=========================
          Scrollbar
          ===========================*/
        s.scrollbar = {
            isTouched: false,
            setDragPosition: function (e) {
                var sb = s.scrollbar;
                var x = 0, y = 0;
                var translate;
                var pointerPosition = isH() ?
                    ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageX : e.pageX || e.clientX) :
                    ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageY : e.pageY || e.clientY) ;
                var position = (pointerPosition) - sb.track.offset()[isH() ? 'left' : 'top'] - sb.dragSize / 2;
                var positionMin = -s.minTranslate() * sb.moveDivider;
                var positionMax = -s.maxTranslate() * sb.moveDivider;
                if (position < positionMin) {
                    position = positionMin;
                }
                else if (position > positionMax) {
                    position = positionMax;
                }
                position = -position / sb.moveDivider;
                s.updateProgress(position);
                s.setWrapperTranslate(position, true);
            },
            dragStart: function (e) {
                var sb = s.scrollbar;
                sb.isTouched = true;
                e.preventDefault();
                e.stopPropagation();
        
                sb.setDragPosition(e);
                clearTimeout(sb.dragTimeout);
        
                sb.track.transition(0);
                if (s.params.scrollbarHide) {
                    sb.track.css('opacity', 1);
                }
                s.wrapper.transition(100);
                sb.drag.transition(100);
                s.emit('onScrollbarDragStart', s);
            },
            dragMove: function (e) {
                var sb = s.scrollbar;
                if (!sb.isTouched) return;
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
                sb.setDragPosition(e);
                s.wrapper.transition(0);
                sb.track.transition(0);
                sb.drag.transition(0);
                s.emit('onScrollbarDragMove', s);
            },
            dragEnd: function (e) {
                var sb = s.scrollbar;
                if (!sb.isTouched) return;
                sb.isTouched = false;
                if (s.params.scrollbarHide) {
                    clearTimeout(sb.dragTimeout);
                    sb.dragTimeout = setTimeout(function () {
                        sb.track.css('opacity', 0);
                        sb.track.transition(400);
                    }, 1000);
        
                }
                s.emit('onScrollbarDragEnd', s);
                if (s.params.scrollbarSnapOnRelease) {
                    s.slideReset();
                }
            },
            enableDraggable: function () {
                var sb = s.scrollbar;
                var target = s.support.touch ? sb.track : document;
                $(sb.track).on(s.touchEvents.start, sb.dragStart);
                $(target).on(s.touchEvents.move, sb.dragMove);
                $(target).on(s.touchEvents.end, sb.dragEnd);
            },
            disableDraggable: function () {
                var sb = s.scrollbar;
                var target = s.support.touch ? sb.track : document;
                $(sb.track).off(s.touchEvents.start, sb.dragStart);
                $(target).off(s.touchEvents.move, sb.dragMove);
                $(target).off(s.touchEvents.end, sb.dragEnd);
            },
            set: function () {
                if (!s.params.scrollbar) return;
                var sb = s.scrollbar;
                sb.track = $(s.params.scrollbar);
                sb.drag = sb.track.find('.swiper-scrollbar-drag');
                if (sb.drag.length === 0) {
                    sb.drag = $('<div class="swiper-scrollbar-drag"></div>');
                    sb.track.append(sb.drag);
                }
                sb.drag[0].style.width = '';
                sb.drag[0].style.height = '';
                sb.trackSize = isH() ? sb.track[0].offsetWidth : sb.track[0].offsetHeight;
        
                sb.divider = s.size / s.virtualSize;
                sb.moveDivider = sb.divider * (sb.trackSize / s.size);
                sb.dragSize = sb.trackSize * sb.divider;
        
                if (isH()) {
                    sb.drag[0].style.width = sb.dragSize + 'px';
                }
                else {
                    sb.drag[0].style.height = sb.dragSize + 'px';
                }
        
                if (sb.divider >= 1) {
                    sb.track[0].style.display = 'none';
                }
                else {
                    sb.track[0].style.display = '';
                }
                if (s.params.scrollbarHide) {
                    sb.track[0].style.opacity = 0;
                }
            },
            setTranslate: function () {
                if (!s.params.scrollbar) return;
                var diff;
                var sb = s.scrollbar;
                var translate = s.translate || 0;
                var newPos;
        
                var newSize = sb.dragSize;
                newPos = (sb.trackSize - sb.dragSize) * s.progress;
                if (s.rtl && isH()) {
                    newPos = -newPos;
                    if (newPos > 0) {
                        newSize = sb.dragSize - newPos;
                        newPos = 0;
                    }
                    else if (-newPos + sb.dragSize > sb.trackSize) {
                        newSize = sb.trackSize + newPos;
                    }
                }
                else {
                    if (newPos < 0) {
                        newSize = sb.dragSize + newPos;
                        newPos = 0;
                    }
                    else if (newPos + sb.dragSize > sb.trackSize) {
                        newSize = sb.trackSize - newPos;
                    }
                }
                if (isH()) {
                    if (s.support.transforms3d) {
                        sb.drag.transform('translate3d(' + (newPos) + 'px, 0, 0)');
                    }
                    else {
                        sb.drag.transform('translateX(' + (newPos) + 'px)');
                    }
                    sb.drag[0].style.width = newSize + 'px';
                }
                else {
                    if (s.support.transforms3d) {
                        sb.drag.transform('translate3d(0px, ' + (newPos) + 'px, 0)');
                    }
                    else {
                        sb.drag.transform('translateY(' + (newPos) + 'px)');
                    }
                    sb.drag[0].style.height = newSize + 'px';
                }
                if (s.params.scrollbarHide) {
                    clearTimeout(sb.timeout);
                    sb.track[0].style.opacity = 1;
                    sb.timeout = setTimeout(function () {
                        sb.track[0].style.opacity = 0;
                        sb.track.transition(400);
                    }, 1000);
                }
            },
            setTransition: function (duration) {
                if (!s.params.scrollbar) return;
                s.scrollbar.drag.transition(duration);
            }
        };

        /*=========================
          Controller
          ===========================*/
        s.controller = {
            LinearSpline: function (x, y) {
                this.x = x;
                this.y = y;
                this.lastIndex = x.length - 1;
                // Given an x value (x2), return the expected y2 value:
                // (x1,y1) is the known point before given value,
                // (x3,y3) is the known point after given value.
                var i1, i3;
                var l = this.x.length;
        
                this.interpolate = function (x2) {
                    if (!x2) return 0;
        
                    // Get the indexes of x1 and x3 (the array indexes before and after given x2):
                    i3 = binarySearch(this.x, x2);
                    i1 = i3 - 1;
        
                    // We have our indexes i1 & i3, so we can calculate already:
                    // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
                    return ((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) / (this.x[i3] - this.x[i1]) + this.y[i1];
                };
        
                var binarySearch = (function() {
                    var maxIndex, minIndex, guess;
                    return function(array, val) {
                        minIndex = -1;
                        maxIndex = array.length;
                        while (maxIndex - minIndex > 1)
                            if (array[guess = maxIndex + minIndex >> 1] <= val) {
                                minIndex = guess;
                            } else {
                                maxIndex = guess;
                            }
                        return maxIndex;
                    };
                })();
            },
            //xxx: for now i will just save one spline function to to
            getInterpolateFunction: function(c){
                if(!s.controller.spline) s.controller.spline = s.params.loop ?
                    new s.controller.LinearSpline(s.slidesGrid, c.slidesGrid) :
                    new s.controller.LinearSpline(s.snapGrid, c.snapGrid);
            },
            setTranslate: function (translate, byController) {
               var controlled = s.params.control;
               var multiplier, controlledTranslate;
               function setControlledTranslate(c) {
                    // this will create an Interpolate function based on the snapGrids
                    // x is the Grid of the scrolled scroller and y will be the controlled scroller
                    // it makes sense to create this only once and recall it for the interpolation
                    // the function does a lot of value caching for performance
                    translate = c.rtl && c.params.direction === 'horizontal' ? -s.translate : s.translate;
                    if (s.params.controlBy === 'slide') {
                        s.controller.getInterpolateFunction(c);
                        // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                        // but it did not work out
                        controlledTranslate = -s.controller.spline.interpolate(-translate);
                    }
        
                    if(!controlledTranslate || s.params.controlBy === 'container'){
                        multiplier = (c.maxTranslate() - c.minTranslate()) / (s.maxTranslate() - s.minTranslate());
                        controlledTranslate = (translate - s.minTranslate()) * multiplier + c.minTranslate();
                    }
        
                    if (s.params.controlInverse) {
                        controlledTranslate = c.maxTranslate() - controlledTranslate;
                    }
                    c.updateProgress(controlledTranslate);
                    c.setWrapperTranslate(controlledTranslate, false, s);
                    c.updateActiveIndex();
               }
               if (s.isArray(controlled)) {
                   for (var i = 0; i < controlled.length; i++) {
                       if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
                           setControlledTranslate(controlled[i]);
                       }
                   }
               }
               else if (controlled instanceof Swiper && byController !== controlled) {
        
                   setControlledTranslate(controlled);
               }
            },
            setTransition: function (duration, byController) {
                var controlled = s.params.control;
                var i;
                function setControlledTransition(c) {
                    c.setWrapperTransition(duration, s);
                    if (duration !== 0) {
                        c.onTransitionStart();
                        c.wrapper.transitionEnd(function(){
                            if (!controlled) return;
                            if (c.params.loop && s.params.controlBy === 'slide') {
                                c.fixLoop();
                            }
                            c.onTransitionEnd();
        
                        });
                    }
                }
                if (s.isArray(controlled)) {
                    for (i = 0; i < controlled.length; i++) {
                        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
                            setControlledTransition(controlled[i]);
                        }
                    }
                }
                else if (controlled instanceof Swiper && byController !== controlled) {
                    setControlledTransition(controlled);
                }
            }
        };

        /*=========================
          Hash Navigation
          ===========================*/
        s.hashnav = {
            init: function () {
                if (!s.params.hashnav) return;
                s.hashnav.initialized = true;
                var hash = document.location.hash.replace('#', '');
                if (!hash) return;
                var speed = 0;
                for (var i = 0, length = s.slides.length; i < length; i++) {
                    var slide = s.slides.eq(i);
                    var slideHash = slide.attr('data-hash');
                    if (slideHash === hash && !slide.hasClass(s.params.slideDuplicateClass)) {
                        var index = slide.index();
                        s.slideTo(index, speed, s.params.runCallbacksOnInit, true);
                    }
                }
            },
            setHash: function () {
                if (!s.hashnav.initialized || !s.params.hashnav) return;
                document.location.hash = s.slides.eq(s.activeIndex).attr('data-hash') || '';
            }
        };

        /*=========================
          Keyboard Control
          ===========================*/
        function handleKeyboard(e) {
            if (e.originalEvent) e = e.originalEvent; //jquery fix
            var kc = e.keyCode || e.charCode;
            // Directions locks
            if (!s.params.allowSwipeToNext && (isH() && kc === 39 || !isH() && kc === 40)) {
                return false;
            }
            if (!s.params.allowSwipeToPrev && (isH() && kc === 37 || !isH() && kc === 38)) {
                return false;
            }
            if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
                return;
            }
            if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) {
                return;
            }
            if (kc === 37 || kc === 39 || kc === 38 || kc === 40) {
                var inView = false;
                //Check that swiper should be inside of visible area of window
                if (s.container.parents('.swiper-slide').length > 0 && s.container.parents('.swiper-slide-active').length === 0) {
                    return;
                }
                var windowScroll = {
                    left: window.pageXOffset,
                    top: window.pageYOffset
                };
                var windowWidth = window.innerWidth;
                var windowHeight = window.innerHeight;
                var swiperOffset = s.container.offset();
                if (s.rtl) swiperOffset.left = swiperOffset.left - s.container[0].scrollLeft;
                var swiperCoord = [
                    [swiperOffset.left, swiperOffset.top],
                    [swiperOffset.left + s.width, swiperOffset.top],
                    [swiperOffset.left, swiperOffset.top + s.height],
                    [swiperOffset.left + s.width, swiperOffset.top + s.height]
                ];
                for (var i = 0; i < swiperCoord.length; i++) {
                    var point = swiperCoord[i];
                    if (
                        point[0] >= windowScroll.left && point[0] <= windowScroll.left + windowWidth &&
                        point[1] >= windowScroll.top && point[1] <= windowScroll.top + windowHeight
                    ) {
                        inView = true;
                    }
        
                }
                if (!inView) return;
            }
            if (isH()) {
                if (kc === 37 || kc === 39) {
                    if (e.preventDefault) e.preventDefault();
                    else e.returnValue = false;
                }
                if ((kc === 39 && !s.rtl) || (kc === 37 && s.rtl)) s.slideNext();
                if ((kc === 37 && !s.rtl) || (kc === 39 && s.rtl)) s.slidePrev();
            }
            else {
                if (kc === 38 || kc === 40) {
                    if (e.preventDefault) e.preventDefault();
                    else e.returnValue = false;
                }
                if (kc === 40) s.slideNext();
                if (kc === 38) s.slidePrev();
            }
        }
        s.disableKeyboardControl = function () {
            $(document).off('keydown', handleKeyboard);
        };
        s.enableKeyboardControl = function () {
            $(document).on('keydown', handleKeyboard);
        };
        

        /*=========================
          Mousewheel Control
          ===========================*/
        s.mousewheel = {
            event: false,
            lastScrollTime: (new window.Date()).getTime()
        };
        if (s.params.mousewheelControl) {
            try {
                new window.WheelEvent('wheel');
                s.mousewheel.event = 'wheel';
            } catch (e) {}
        
            if (!s.mousewheel.event && document.onmousewheel !== undefined) {
                s.mousewheel.event = 'mousewheel';
            }
            if (!s.mousewheel.event) {
                s.mousewheel.event = 'DOMMouseScroll';
            }
        }
        function handleMousewheel(e) {
            if (e.originalEvent) e = e.originalEvent; //jquery fix
            var we = s.mousewheel.event;
            var delta = 0;
            //Opera & IE
            if (e.detail) delta = -e.detail;
            //WebKits
            else if (we === 'mousewheel') {
                if (s.params.mousewheelForceToAxis) {
                    if (isH()) {
                        if (Math.abs(e.wheelDeltaX) > Math.abs(e.wheelDeltaY)) delta = e.wheelDeltaX;
                        else return;
                    }
                    else {
                        if (Math.abs(e.wheelDeltaY) > Math.abs(e.wheelDeltaX)) delta = e.wheelDeltaY;
                        else return;
                    }
                }
                else {
                    delta = e.wheelDelta;
                }
            }
            //Old FireFox
            else if (we === 'DOMMouseScroll') delta = -e.detail;
            //New FireFox
            else if (we === 'wheel') {
                if (s.params.mousewheelForceToAxis) {
                    if (isH()) {
                        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) delta = -e.deltaX;
                        else return;
                    }
                    else {
                        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) delta = -e.deltaY;
                        else return;
                    }
                }
                else {
                    delta = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? - e.deltaX : - e.deltaY;
                }
            }
            if (delta === 0) return;
        
            if (s.params.mousewheelInvert) delta = -delta;
        
            if (!s.params.freeMode) {
                if ((new window.Date()).getTime() - s.mousewheel.lastScrollTime > 60) {
                    if (delta < 0) {
                        if ((!s.isEnd || s.params.loop) && !s.animating) s.slideNext();
                        else if (s.params.mousewheelReleaseOnEdges) return true;
                    }
                    else {
                        if ((!s.isBeginning || s.params.loop) && !s.animating) s.slidePrev();
                        else if (s.params.mousewheelReleaseOnEdges) return true;
                    }
                }
                s.mousewheel.lastScrollTime = (new window.Date()).getTime();
        
            }
            else {
                //Freemode or scrollContainer:
                var position = s.getWrapperTranslate() + delta * s.params.mousewheelSensitivity;
                var wasBeginning = s.isBeginning,
                    wasEnd = s.isEnd;
        
                if (position >= s.minTranslate()) position = s.minTranslate();
                if (position <= s.maxTranslate()) position = s.maxTranslate();
        
                s.setWrapperTransition(0);
                s.setWrapperTranslate(position);
                s.updateProgress();
                s.updateActiveIndex();
        
                if (!wasBeginning && s.isBeginning || !wasEnd && s.isEnd) {
                    s.updateClasses();
                }
        
                if (s.params.freeModeSticky) {
                    clearTimeout(s.mousewheel.timeout);
                    s.mousewheel.timeout = setTimeout(function () {
                        s.slideReset();
                    }, 300);
                }
        
                // Return page scroll on edge positions
                if (position === 0 || position === s.maxTranslate()) return;
            }
            if (s.params.autoplay) s.stopAutoplay();
        
            if (e.preventDefault) e.preventDefault();
            else e.returnValue = false;
            return false;
        }
        s.disableMousewheelControl = function () {
            if (!s.mousewheel.event) return false;
            s.container.off(s.mousewheel.event, handleMousewheel);
            return true;
        };
        
        s.enableMousewheelControl = function () {
            if (!s.mousewheel.event) return false;
            s.container.on(s.mousewheel.event, handleMousewheel);
            return true;
        };

        /*=========================
          Parallax
          ===========================*/
        function setParallaxTransform(el, progress) {
            el = $(el);
            var p, pX, pY;
        
            p = el.attr('data-swiper-parallax') || '0';
            pX = el.attr('data-swiper-parallax-x');
            pY = el.attr('data-swiper-parallax-y');
            if (pX || pY) {
                pX = pX || '0';
                pY = pY || '0';
            }
            else {
                if (isH()) {
                    pX = p;
                    pY = '0';
                }
                else {
                    pY = p;
                    pX = '0';
                }
            }
            if ((pX).indexOf('%') >= 0) {
                pX = parseInt(pX, 10) * progress + '%';
            }
            else {
                pX = pX * progress + 'px' ;
            }
            if ((pY).indexOf('%') >= 0) {
                pY = parseInt(pY, 10) * progress + '%';
            }
            else {
                pY = pY * progress + 'px' ;
            }
            el.transform('translate3d(' + pX + ', ' + pY + ',0px)');
        }
        s.parallax = {
            setTranslate: function () {
                s.container.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function(){
                    setParallaxTransform(this, s.progress);
        
                });
                s.slides.each(function () {
                    var slide = $(this);
                    slide.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function () {
                        var progress = Math.min(Math.max(slide[0].progress, -1), 1);
                        setParallaxTransform(this, progress);
                    });
                });
            },
            setTransition: function (duration) {
                if (typeof duration === 'undefined') duration = s.params.speed;
                s.container.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function(){
                    var el = $(this);
                    var parallaxDuration = parseInt(el.attr('data-swiper-parallax-duration'), 10) || duration;
                    if (duration === 0) parallaxDuration = 0;
                    el.transition(parallaxDuration);
                });
            }
        };
        

        /*=========================
          Plugins API. Collect all and init all plugins
          ===========================*/
        s._plugins = [];
        for (var plugin in s.plugins) {
            var p = s.plugins[plugin](s, s.params[plugin]);
            if (p) s._plugins.push(p);
        }
        // Method to call all plugins event/method
        s.callPlugins = function (eventName) {
            for (var i = 0; i < s._plugins.length; i++) {
                if (eventName in s._plugins[i]) {
                    s._plugins[i][eventName](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
                }
            }
        };

        /*=========================
          Events/Callbacks/Plugins Emitter
          ===========================*/
        function normalizeEventName (eventName) {
            if (eventName.indexOf('on') !== 0) {
                if (eventName[0] !== eventName[0].toUpperCase()) {
                    eventName = 'on' + eventName[0].toUpperCase() + eventName.substring(1);
                }
                else {
                    eventName = 'on' + eventName;
                }
            }
            return eventName;
        }
        s.emitterEventListeners = {
        
        };
        s.emit = function (eventName) {
            // Trigger callbacks
            if (s.params[eventName]) {
                s.params[eventName](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
            }
            var i;
            // Trigger events
            if (s.emitterEventListeners[eventName]) {
                for (i = 0; i < s.emitterEventListeners[eventName].length; i++) {
                    s.emitterEventListeners[eventName][i](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
                }
            }
            // Trigger plugins
            if (s.callPlugins) s.callPlugins(eventName, arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
        };
        s.on = function (eventName, handler) {
            eventName = normalizeEventName(eventName);
            if (!s.emitterEventListeners[eventName]) s.emitterEventListeners[eventName] = [];
            s.emitterEventListeners[eventName].push(handler);
            return s;
        };
        s.off = function (eventName, handler) {
            var i;
            eventName = normalizeEventName(eventName);
            if (typeof handler === 'undefined') {
                // Remove all handlers for such event
                s.emitterEventListeners[eventName] = [];
                return s;
            }
            if (!s.emitterEventListeners[eventName] || s.emitterEventListeners[eventName].length === 0) return;
            for (i = 0; i < s.emitterEventListeners[eventName].length; i++) {
                if(s.emitterEventListeners[eventName][i] === handler) s.emitterEventListeners[eventName].splice(i, 1);
            }
            return s;
        };
        s.once = function (eventName, handler) {
            eventName = normalizeEventName(eventName);
            var _handler = function () {
                handler(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);
                s.off(eventName, _handler);
            };
            s.on(eventName, _handler);
            return s;
        };

        // Accessibility tools
        s.a11y = {
            makeFocusable: function ($el) {
                $el.attr('tabIndex', '0');
                return $el;
            },
            addRole: function ($el, role) {
                $el.attr('role', role);
                return $el;
            },
        
            addLabel: function ($el, label) {
                $el.attr('aria-label', label);
                return $el;
            },
        
            disable: function ($el) {
                $el.attr('aria-disabled', true);
                return $el;
            },
        
            enable: function ($el) {
                $el.attr('aria-disabled', false);
                return $el;
            },
        
            onEnterKey: function (event) {
                if (event.keyCode !== 13) return;
                if ($(event.target).is(s.params.nextButton)) {
                    s.onClickNext(event);
                    if (s.isEnd) {
                        s.a11y.notify(s.params.lastSlideMessage);
                    }
                    else {
                        s.a11y.notify(s.params.nextSlideMessage);
                    }
                }
                else if ($(event.target).is(s.params.prevButton)) {
                    s.onClickPrev(event);
                    if (s.isBeginning) {
                        s.a11y.notify(s.params.firstSlideMessage);
                    }
                    else {
                        s.a11y.notify(s.params.prevSlideMessage);
                    }
                }
                if ($(event.target).is('.' + s.params.bulletClass)) {
                    $(event.target)[0].click();
                }
            },
        
            liveRegion: $('<span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>'),
        
            notify: function (message) {
                var notification = s.a11y.liveRegion;
                if (notification.length === 0) return;
                notification.html('');
                notification.html(message);
            },
            init: function () {
                // Setup accessibility
                if (s.params.nextButton) {
                    var nextButton = $(s.params.nextButton);
                    s.a11y.makeFocusable(nextButton);
                    s.a11y.addRole(nextButton, 'button');
                    s.a11y.addLabel(nextButton, s.params.nextSlideMessage);
                }
                if (s.params.prevButton) {
                    var prevButton = $(s.params.prevButton);
                    s.a11y.makeFocusable(prevButton);
                    s.a11y.addRole(prevButton, 'button');
                    s.a11y.addLabel(prevButton, s.params.prevSlideMessage);
                }
        
                $(s.container).append(s.a11y.liveRegion);
            },
            initPagination: function () {
                if (s.params.pagination && s.params.paginationClickable && s.bullets && s.bullets.length) {
                    s.bullets.each(function () {
                        var bullet = $(this);
                        s.a11y.makeFocusable(bullet);
                        s.a11y.addRole(bullet, 'button');
                        s.a11y.addLabel(bullet, s.params.paginationBulletMessage.replace(/{{index}}/, bullet.index() + 1));
                    });
                }
            },
            destroy: function () {
                if (s.a11y.liveRegion && s.a11y.liveRegion.length > 0) s.a11y.liveRegion.remove();
            }
        };
        

        /*=========================
          Init/Destroy
          ===========================*/
        s.init = function () {
            if (s.params.loop) s.createLoop();
            s.updateContainerSize();
            s.updateSlidesSize();
            s.updatePagination();
            if (s.params.scrollbar && s.scrollbar) {
                s.scrollbar.set();
                if (s.params.scrollbarDraggable) {
                    s.scrollbar.enableDraggable();
                }
            }
            if (s.params.effect !== 'slide' && s.effects[s.params.effect]) {
                if (!s.params.loop) s.updateProgress();
                s.effects[s.params.effect].setTranslate();
            }
            if (s.params.loop) {
                s.slideTo(s.params.initialSlide + s.loopedSlides, 0, s.params.runCallbacksOnInit);
            }
            else {
                s.slideTo(s.params.initialSlide, 0, s.params.runCallbacksOnInit);
                if (s.params.initialSlide === 0) {
                    if (s.parallax && s.params.parallax) s.parallax.setTranslate();
                    if (s.lazy && s.params.lazyLoading) {
                        s.lazy.load();
                        s.lazy.initialImageLoaded = true;
                    }
                }
            }
            s.attachEvents();
            if (s.params.observer && s.support.observer) {
                s.initObservers();
            }
            if (s.params.preloadImages && !s.params.lazyLoading) {
                s.preloadImages();
            }
            if (s.params.autoplay) {
                s.startAutoplay();
            }
            if (s.params.keyboardControl) {
                if (s.enableKeyboardControl) s.enableKeyboardControl();
            }
            if (s.params.mousewheelControl) {
                if (s.enableMousewheelControl) s.enableMousewheelControl();
            }
            if (s.params.hashnav) {
                if (s.hashnav) s.hashnav.init();
            }
            if (s.params.a11y && s.a11y) s.a11y.init();
            s.emit('onInit', s);
        };
        
        // Cleanup dynamic styles
        s.cleanupStyles = function () {
            // Container
            s.container.removeClass(s.classNames.join(' ')).removeAttr('style');
        
            // Wrapper
            s.wrapper.removeAttr('style');
        
            // Slides
            if (s.slides && s.slides.length) {
                s.slides
                    .removeClass([
                      s.params.slideVisibleClass,
                      s.params.slideActiveClass,
                      s.params.slideNextClass,
                      s.params.slidePrevClass
                    ].join(' '))
                    .removeAttr('style')
                    .removeAttr('data-swiper-column')
                    .removeAttr('data-swiper-row');
            }
        
            // Pagination/Bullets
            if (s.paginationContainer && s.paginationContainer.length) {
                s.paginationContainer.removeClass(s.params.paginationHiddenClass);
            }
            if (s.bullets && s.bullets.length) {
                s.bullets.removeClass(s.params.bulletActiveClass);
            }
        
            // Buttons
            if (s.params.prevButton) $(s.params.prevButton).removeClass(s.params.buttonDisabledClass);
            if (s.params.nextButton) $(s.params.nextButton).removeClass(s.params.buttonDisabledClass);
        
            // Scrollbar
            if (s.params.scrollbar && s.scrollbar) {
                if (s.scrollbar.track && s.scrollbar.track.length) s.scrollbar.track.removeAttr('style');
                if (s.scrollbar.drag && s.scrollbar.drag.length) s.scrollbar.drag.removeAttr('style');
            }
        };
        
        // Destroy
        s.destroy = function (deleteInstance, cleanupStyles) {
            // Detach evebts
            s.detachEvents();
            // Stop autoplay
            s.stopAutoplay();
            // Disable draggable
            if (s.params.scrollbar && s.scrollbar) {
                if (s.params.scrollbarDraggable) {
                    s.scrollbar.disableDraggable();
                }
            }
            // Destroy loop
            if (s.params.loop) {
                s.destroyLoop();
            }
            // Cleanup styles
            if (cleanupStyles) {
                s.cleanupStyles();
            }
            // Disconnect observer
            s.disconnectObservers();
            // Disable keyboard/mousewheel
            if (s.params.keyboardControl) {
                if (s.disableKeyboardControl) s.disableKeyboardControl();
            }
            if (s.params.mousewheelControl) {
                if (s.disableMousewheelControl) s.disableMousewheelControl();
            }
            // Disable a11y
            if (s.params.a11y && s.a11y) s.a11y.destroy();
            // Destroy callback
            s.emit('onDestroy');
            // Delete instance
            if (deleteInstance !== false) s = null;
        };
        
        s.init();
        

    
        // Return swiper instance
        return s;
    };
    

    /*==================================================
        Prototype
    ====================================================*/
    Swiper.prototype = {
        isSafari: (function () {
            var ua = navigator.userAgent.toLowerCase();
            return (ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0);
        })(),
        isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent),
        isArray: function (arr) {
            return Object.prototype.toString.apply(arr) === '[object Array]';
        },
        /*==================================================
        Browser
        ====================================================*/
        browser: {
            ie: window.navigator.pointerEnabled || window.navigator.msPointerEnabled,
            ieTouch: (window.navigator.msPointerEnabled && window.navigator.msMaxTouchPoints > 1) || (window.navigator.pointerEnabled && window.navigator.maxTouchPoints > 1)
        },
        /*==================================================
        Devices
        ====================================================*/
        device: (function () {
            var ua = navigator.userAgent;
            var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
            var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
            var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
            var iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
            return {
                ios: ipad || iphone || ipod,
                android: android
            };
        })(),
        /*==================================================
        Feature Detection
        ====================================================*/
        support: {
            touch : (window.Modernizr && Modernizr.touch === true) || (function () {
                return !!(('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch);
            })(),
    
            transforms3d : (window.Modernizr && Modernizr.csstransforms3d === true) || (function () {
                var div = document.createElement('div').style;
                return ('webkitPerspective' in div || 'MozPerspective' in div || 'OPerspective' in div || 'MsPerspective' in div || 'perspective' in div);
            })(),
    
            flexbox: (function () {
                var div = document.createElement('div').style;
                var styles = ('alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient').split(' ');
                for (var i = 0; i < styles.length; i++) {
                    if (styles[i] in div) return true;
                }
            })(),
    
            observer: (function () {
                return ('MutationObserver' in window || 'WebkitMutationObserver' in window);
            })()
        },
        /*==================================================
        Plugins
        ====================================================*/
        plugins: {}
    };
    

    /*===========================
    Dom7 Library
    ===========================*/
    var Dom7 = (function () {
        var Dom7 = function (arr) {
            var _this = this, i = 0;
            // Create array-like object
            for (i = 0; i < arr.length; i++) {
                _this[i] = arr[i];
            }
            _this.length = arr.length;
            // Return collection with methods
            return this;
        };
        var $ = function (selector, context) {
            var arr = [], i = 0;
            if (selector && !context) {
                if (selector instanceof Dom7) {
                    return selector;
                }
            }
            if (selector) {
                // String
                if (typeof selector === 'string') {
                    var els, tempParent, html = selector.trim();
                    if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
                        var toCreate = 'div';
                        if (html.indexOf('<li') === 0) toCreate = 'ul';
                        if (html.indexOf('<tr') === 0) toCreate = 'tbody';
                        if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
                        if (html.indexOf('<tbody') === 0) toCreate = 'table';
                        if (html.indexOf('<option') === 0) toCreate = 'select';
                        tempParent = document.createElement(toCreate);
                        tempParent.innerHTML = selector;
                        for (i = 0; i < tempParent.childNodes.length; i++) {
                            arr.push(tempParent.childNodes[i]);
                        }
                    }
                    else {
                        if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
                            // Pure ID selector
                            els = [document.getElementById(selector.split('#')[1])];
                        }
                        else {
                            // Other selectors
                            els = (context || document).querySelectorAll(selector);
                        }
                        for (i = 0; i < els.length; i++) {
                            if (els[i]) arr.push(els[i]);
                        }
                    }
                }
                // Node/element
                else if (selector.nodeType || selector === window || selector === document) {
                    arr.push(selector);
                }
                //Array of elements or instance of Dom
                else if (selector.length > 0 && selector[0].nodeType) {
                    for (i = 0; i < selector.length; i++) {
                        arr.push(selector[i]);
                    }
                }
            }
            return new Dom7(arr);
        };
        Dom7.prototype = {
            // Classes and attriutes
            addClass: function (className) {
                if (typeof className === 'undefined') {
                    return this;
                }
                var classes = className.split(' ');
                for (var i = 0; i < classes.length; i++) {
                    for (var j = 0; j < this.length; j++) {
                        this[j].classList.add(classes[i]);
                    }
                }
                return this;
            },
            removeClass: function (className) {
                var classes = className.split(' ');
                for (var i = 0; i < classes.length; i++) {
                    for (var j = 0; j < this.length; j++) {
                        this[j].classList.remove(classes[i]);
                    }
                }
                return this;
            },
            hasClass: function (className) {
                if (!this[0]) return false;
                else return this[0].classList.contains(className);
            },
            toggleClass: function (className) {
                var classes = className.split(' ');
                for (var i = 0; i < classes.length; i++) {
                    for (var j = 0; j < this.length; j++) {
                        this[j].classList.toggle(classes[i]);
                    }
                }
                return this;
            },
            attr: function (attrs, value) {
                if (arguments.length === 1 && typeof attrs === 'string') {
                    // Get attr
                    if (this[0]) return this[0].getAttribute(attrs);
                    else return undefined;
                }
                else {
                    // Set attrs
                    for (var i = 0; i < this.length; i++) {
                        if (arguments.length === 2) {
                            // String
                            this[i].setAttribute(attrs, value);
                        }
                        else {
                            // Object
                            for (var attrName in attrs) {
                                this[i][attrName] = attrs[attrName];
                                this[i].setAttribute(attrName, attrs[attrName]);
                            }
                        }
                    }
                    return this;
                }
            },
            removeAttr: function (attr) {
                for (var i = 0; i < this.length; i++) {
                    this[i].removeAttribute(attr);
                }
                return this;
            },
            data: function (key, value) {
                if (typeof value === 'undefined') {
                    // Get value
                    if (this[0]) {
                        var dataKey = this[0].getAttribute('data-' + key);
                        if (dataKey) return dataKey;
                        else if (this[0].dom7ElementDataStorage && (key in this[0].dom7ElementDataStorage)) return this[0].dom7ElementDataStorage[key];
                        else return undefined;
                    }
                    else return undefined;
                }
                else {
                    // Set value
                    for (var i = 0; i < this.length; i++) {
                        var el = this[i];
                        if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
                        el.dom7ElementDataStorage[key] = value;
                    }
                    return this;
                }
            },
            // Transforms
            transform : function (transform) {
                for (var i = 0; i < this.length; i++) {
                    var elStyle = this[i].style;
                    elStyle.webkitTransform = elStyle.MsTransform = elStyle.msTransform = elStyle.MozTransform = elStyle.OTransform = elStyle.transform = transform;
                }
                return this;
            },
            transition: function (duration) {
                if (typeof duration !== 'string') {
                    duration = duration + 'ms';
                }
                for (var i = 0; i < this.length; i++) {
                    var elStyle = this[i].style;
                    elStyle.webkitTransitionDuration = elStyle.MsTransitionDuration = elStyle.msTransitionDuration = elStyle.MozTransitionDuration = elStyle.OTransitionDuration = elStyle.transitionDuration = duration;
                }
                return this;
            },
            //Events
            on: function (eventName, targetSelector, listener, capture) {
                function handleLiveEvent(e) {
                    var target = e.target;
                    if ($(target).is(targetSelector)) listener.call(target, e);
                    else {
                        var parents = $(target).parents();
                        for (var k = 0; k < parents.length; k++) {
                            if ($(parents[k]).is(targetSelector)) listener.call(parents[k], e);
                        }
                    }
                }
                var events = eventName.split(' ');
                var i, j;
                for (i = 0; i < this.length; i++) {
                    if (typeof targetSelector === 'function' || targetSelector === false) {
                        // Usual events
                        if (typeof targetSelector === 'function') {
                            listener = arguments[1];
                            capture = arguments[2] || false;
                        }
                        for (j = 0; j < events.length; j++) {
                            this[i].addEventListener(events[j], listener, capture);
                        }
                    }
                    else {
                        //Live events
                        for (j = 0; j < events.length; j++) {
                            if (!this[i].dom7LiveListeners) this[i].dom7LiveListeners = [];
                            this[i].dom7LiveListeners.push({listener: listener, liveListener: handleLiveEvent});
                            this[i].addEventListener(events[j], handleLiveEvent, capture);
                        }
                    }
                }
    
                return this;
            },
            off: function (eventName, targetSelector, listener, capture) {
                var events = eventName.split(' ');
                for (var i = 0; i < events.length; i++) {
                    for (var j = 0; j < this.length; j++) {
                        if (typeof targetSelector === 'function' || targetSelector === false) {
                            // Usual events
                            if (typeof targetSelector === 'function') {
                                listener = arguments[1];
                                capture = arguments[2] || false;
                            }
                            this[j].removeEventListener(events[i], listener, capture);
                        }
                        else {
                            // Live event
                            if (this[j].dom7LiveListeners) {
                                for (var k = 0; k < this[j].dom7LiveListeners.length; k++) {
                                    if (this[j].dom7LiveListeners[k].listener === listener) {
                                        this[j].removeEventListener(events[i], this[j].dom7LiveListeners[k].liveListener, capture);
                                    }
                                }
                            }
                        }
                    }
                }
                return this;
            },
            once: function (eventName, targetSelector, listener, capture) {
                var dom = this;
                if (typeof targetSelector === 'function') {
                    targetSelector = false;
                    listener = arguments[1];
                    capture = arguments[2];
                }
                function proxy(e) {
                    listener(e);
                    dom.off(eventName, targetSelector, proxy, capture);
                }
                dom.on(eventName, targetSelector, proxy, capture);
            },
            trigger: function (eventName, eventData) {
                for (var i = 0; i < this.length; i++) {
                    var evt;
                    try {
                        evt = new window.CustomEvent(eventName, {detail: eventData, bubbles: true, cancelable: true});
                    }
                    catch (e) {
                        evt = document.createEvent('Event');
                        evt.initEvent(eventName, true, true);
                        evt.detail = eventData;
                    }
                    this[i].dispatchEvent(evt);
                }
                return this;
            },
            transitionEnd: function (callback) {
                var events = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'],
                    i, j, dom = this;
                function fireCallBack(e) {
                    /*jshint validthis:true */
                    if (e.target !== this) return;
                    callback.call(this, e);
                    for (i = 0; i < events.length; i++) {
                        dom.off(events[i], fireCallBack);
                    }
                }
                if (callback) {
                    for (i = 0; i < events.length; i++) {
                        dom.on(events[i], fireCallBack);
                    }
                }
                return this;
            },
            // Sizing/Styles
            width: function () {
                if (this[0] === window) {
                    return window.innerWidth;
                }
                else {
                    if (this.length > 0) {
                        return parseFloat(this.css('width'));
                    }
                    else {
                        return null;
                    }
                }
            },
            outerWidth: function (includeMargins) {
                if (this.length > 0) {
                    if (includeMargins)
                        return this[0].offsetWidth + parseFloat(this.css('margin-right')) + parseFloat(this.css('margin-left'));
                    else
                        return this[0].offsetWidth;
                }
                else return null;
            },
            height: function () {
                if (this[0] === window) {
                    return window.innerHeight;
                }
                else {
                    if (this.length > 0) {
                        return parseFloat(this.css('height'));
                    }
                    else {
                        return null;
                    }
                }
            },
            outerHeight: function (includeMargins) {
                if (this.length > 0) {
                    if (includeMargins)
                        return this[0].offsetHeight + parseFloat(this.css('margin-top')) + parseFloat(this.css('margin-bottom'));
                    else
                        return this[0].offsetHeight;
                }
                else return null;
            },
            offset: function () {
                if (this.length > 0) {
                    var el = this[0];
                    var box = el.getBoundingClientRect();
                    var body = document.body;
                    var clientTop  = el.clientTop  || body.clientTop  || 0;
                    var clientLeft = el.clientLeft || body.clientLeft || 0;
                    var scrollTop  = window.pageYOffset || el.scrollTop;
                    var scrollLeft = window.pageXOffset || el.scrollLeft;
                    return {
                        top: box.top  + scrollTop  - clientTop,
                        left: box.left + scrollLeft - clientLeft
                    };
                }
                else {
                    return null;
                }
            },
            css: function (props, value) {
                var i;
                if (arguments.length === 1) {
                    if (typeof props === 'string') {
                        if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
                    }
                    else {
                        for (i = 0; i < this.length; i++) {
                            for (var prop in props) {
                                this[i].style[prop] = props[prop];
                            }
                        }
                        return this;
                    }
                }
                if (arguments.length === 2 && typeof props === 'string') {
                    for (i = 0; i < this.length; i++) {
                        this[i].style[props] = value;
                    }
                    return this;
                }
                return this;
            },
    
            //Dom manipulation
            each: function (callback) {
                for (var i = 0; i < this.length; i++) {
                    callback.call(this[i], i, this[i]);
                }
                return this;
            },
            html: function (html) {
                if (typeof html === 'undefined') {
                    return this[0] ? this[0].innerHTML : undefined;
                }
                else {
                    for (var i = 0; i < this.length; i++) {
                        this[i].innerHTML = html;
                    }
                    return this;
                }
            },
            is: function (selector) {
                if (!this[0]) return false;
                var compareWith, i;
                if (typeof selector === 'string') {
                    var el = this[0];
                    if (el === document) return selector === document;
                    if (el === window) return selector === window;
    
                    if (el.matches) return el.matches(selector);
                    else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
                    else if (el.mozMatchesSelector) return el.mozMatchesSelector(selector);
                    else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
                    else {
                        compareWith = $(selector);
                        for (i = 0; i < compareWith.length; i++) {
                            if (compareWith[i] === this[0]) return true;
                        }
                        return false;
                    }
                }
                else if (selector === document) return this[0] === document;
                else if (selector === window) return this[0] === window;
                else {
                    if (selector.nodeType || selector instanceof Dom7) {
                        compareWith = selector.nodeType ? [selector] : selector;
                        for (i = 0; i < compareWith.length; i++) {
                            if (compareWith[i] === this[0]) return true;
                        }
                        return false;
                    }
                    return false;
                }
    
            },
            index: function () {
                if (this[0]) {
                    var child = this[0];
                    var i = 0;
                    while ((child = child.previousSibling) !== null) {
                        if (child.nodeType === 1) i++;
                    }
                    return i;
                }
                else return undefined;
            },
            eq: function (index) {
                if (typeof index === 'undefined') return this;
                var length = this.length;
                var returnIndex;
                if (index > length - 1) {
                    return new Dom7([]);
                }
                if (index < 0) {
                    returnIndex = length + index;
                    if (returnIndex < 0) return new Dom7([]);
                    else return new Dom7([this[returnIndex]]);
                }
                return new Dom7([this[index]]);
            },
            append: function (newChild) {
                var i, j;
                for (i = 0; i < this.length; i++) {
                    if (typeof newChild === 'string') {
                        var tempDiv = document.createElement('div');
                        tempDiv.innerHTML = newChild;
                        while (tempDiv.firstChild) {
                            this[i].appendChild(tempDiv.firstChild);
                        }
                    }
                    else if (newChild instanceof Dom7) {
                        for (j = 0; j < newChild.length; j++) {
                            this[i].appendChild(newChild[j]);
                        }
                    }
                    else {
                        this[i].appendChild(newChild);
                    }
                }
                return this;
            },
            prepend: function (newChild) {
                var i, j;
                for (i = 0; i < this.length; i++) {
                    if (typeof newChild === 'string') {
                        var tempDiv = document.createElement('div');
                        tempDiv.innerHTML = newChild;
                        for (j = tempDiv.childNodes.length - 1; j >= 0; j--) {
                            this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
                        }
                        // this[i].insertAdjacentHTML('afterbegin', newChild);
                    }
                    else if (newChild instanceof Dom7) {
                        for (j = 0; j < newChild.length; j++) {
                            this[i].insertBefore(newChild[j], this[i].childNodes[0]);
                        }
                    }
                    else {
                        this[i].insertBefore(newChild, this[i].childNodes[0]);
                    }
                }
                return this;
            },
            insertBefore: function (selector) {
                var before = $(selector);
                for (var i = 0; i < this.length; i++) {
                    if (before.length === 1) {
                        before[0].parentNode.insertBefore(this[i], before[0]);
                    }
                    else if (before.length > 1) {
                        for (var j = 0; j < before.length; j++) {
                            before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
                        }
                    }
                }
            },
            insertAfter: function (selector) {
                var after = $(selector);
                for (var i = 0; i < this.length; i++) {
                    if (after.length === 1) {
                        after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
                    }
                    else if (after.length > 1) {
                        for (var j = 0; j < after.length; j++) {
                            after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
                        }
                    }
                }
            },
            next: function (selector) {
                if (this.length > 0) {
                    if (selector) {
                        if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) return new Dom7([this[0].nextElementSibling]);
                        else return new Dom7([]);
                    }
                    else {
                        if (this[0].nextElementSibling) return new Dom7([this[0].nextElementSibling]);
                        else return new Dom7([]);
                    }
                }
                else return new Dom7([]);
            },
            nextAll: function (selector) {
                var nextEls = [];
                var el = this[0];
                if (!el) return new Dom7([]);
                while (el.nextElementSibling) {
                    var next = el.nextElementSibling;
                    if (selector) {
                        if($(next).is(selector)) nextEls.push(next);
                    }
                    else nextEls.push(next);
                    el = next;
                }
                return new Dom7(nextEls);
            },
            prev: function (selector) {
                if (this.length > 0) {
                    if (selector) {
                        if (this[0].previousElementSibling && $(this[0].previousElementSibling).is(selector)) return new Dom7([this[0].previousElementSibling]);
                        else return new Dom7([]);
                    }
                    else {
                        if (this[0].previousElementSibling) return new Dom7([this[0].previousElementSibling]);
                        else return new Dom7([]);
                    }
                }
                else return new Dom7([]);
            },
            prevAll: function (selector) {
                var prevEls = [];
                var el = this[0];
                if (!el) return new Dom7([]);
                while (el.previousElementSibling) {
                    var prev = el.previousElementSibling;
                    if (selector) {
                        if($(prev).is(selector)) prevEls.push(prev);
                    }
                    else prevEls.push(prev);
                    el = prev;
                }
                return new Dom7(prevEls);
            },
            parent: function (selector) {
                var parents = [];
                for (var i = 0; i < this.length; i++) {
                    if (selector) {
                        if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
                    }
                    else {
                        parents.push(this[i].parentNode);
                    }
                }
                return $($.unique(parents));
            },
            parents: function (selector) {
                var parents = [];
                for (var i = 0; i < this.length; i++) {
                    var parent = this[i].parentNode;
                    while (parent) {
                        if (selector) {
                            if ($(parent).is(selector)) parents.push(parent);
                        }
                        else {
                            parents.push(parent);
                        }
                        parent = parent.parentNode;
                    }
                }
                return $($.unique(parents));
            },
            find : function (selector) {
                var foundElements = [];
                for (var i = 0; i < this.length; i++) {
                    var found = this[i].querySelectorAll(selector);
                    for (var j = 0; j < found.length; j++) {
                        foundElements.push(found[j]);
                    }
                }
                return new Dom7(foundElements);
            },
            children: function (selector) {
                var children = [];
                for (var i = 0; i < this.length; i++) {
                    var childNodes = this[i].childNodes;
    
                    for (var j = 0; j < childNodes.length; j++) {
                        if (!selector) {
                            if (childNodes[j].nodeType === 1) children.push(childNodes[j]);
                        }
                        else {
                            if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) children.push(childNodes[j]);
                        }
                    }
                }
                return new Dom7($.unique(children));
            },
            remove: function () {
                for (var i = 0; i < this.length; i++) {
                    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
                }
                return this;
            },
            add: function () {
                var dom = this;
                var i, j;
                for (i = 0; i < arguments.length; i++) {
                    var toAdd = $(arguments[i]);
                    for (j = 0; j < toAdd.length; j++) {
                        dom[dom.length] = toAdd[j];
                        dom.length++;
                    }
                }
                return dom;
            }
        };
        $.fn = Dom7.prototype;
        $.unique = function (arr) {
            var unique = [];
            for (var i = 0; i < arr.length; i++) {
                if (unique.indexOf(arr[i]) === -1) unique.push(arr[i]);
            }
            return unique;
        };
    
        return $;
    })();
    

    /*===========================
     Get Dom libraries
     ===========================*/
    var swiperDomPlugins = ['jQuery', 'Zepto', 'Dom7'];
    for (var i = 0; i < swiperDomPlugins.length; i++) {
    	if (window[swiperDomPlugins[i]]) {
    		addLibraryPlugin(window[swiperDomPlugins[i]]);
    	}
    }
    // Required DOM Plugins
    var domLib;
    if (typeof Dom7 === 'undefined') {
    	domLib = window.Dom7 || window.Zepto || window.jQuery;
    }
    else {
    	domLib = Dom7;
    }

    /*===========================
    Add .swiper plugin from Dom libraries
    ===========================*/
    function addLibraryPlugin(lib) {
        lib.fn.swiper = function (params) {
            var firstInstance;
            lib(this).each(function () {
                var s = new Swiper(this, params);
                if (!firstInstance) firstInstance = s;
            });
            return firstInstance;
        };
    }
    
    if (domLib) {
        if (!('transitionEnd' in domLib.fn)) {
            domLib.fn.transitionEnd = function (callback) {
                var events = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'],
                    i, j, dom = this;
                function fireCallBack(e) {
                    /*jshint validthis:true */
                    if (e.target !== this) return;
                    callback.call(this, e);
                    for (i = 0; i < events.length; i++) {
                        dom.off(events[i], fireCallBack);
                    }
                }
                if (callback) {
                    for (i = 0; i < events.length; i++) {
                        dom.on(events[i], fireCallBack);
                    }
                }
                return this;
            };
        }
        if (!('transform' in domLib.fn)) {
            domLib.fn.transform = function (transform) {
                for (var i = 0; i < this.length; i++) {
                    var elStyle = this[i].style;
                    elStyle.webkitTransform = elStyle.MsTransform = elStyle.msTransform = elStyle.MozTransform = elStyle.OTransform = elStyle.transform = transform;
                }
                return this;
            };
        }
        if (!('transition' in domLib.fn)) {
            domLib.fn.transition = function (duration) {
                if (typeof duration !== 'string') {
                    duration = duration + 'ms';
                }
                for (var i = 0; i < this.length; i++) {
                    var elStyle = this[i].style;
                    elStyle.webkitTransitionDuration = elStyle.MsTransitionDuration = elStyle.msTransitionDuration = elStyle.MozTransitionDuration = elStyle.OTransitionDuration = elStyle.transitionDuration = duration;
                }
                return this;
            };
        }
    }

    window.Swiper = Swiper;
})();
/*===========================
Swiper AMD Export
===========================*/
if (true)
{
    module.exports = window.Swiper;
}
else if (typeof define === 'function' && define.amd) {
    define([], function () {
        'use strict';
        return window.Swiper;
    });
}

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function() {
  var vexFactory;

  vexFactory = function($) {
    var animationEndSupport, vex;
    animationEndSupport = false;
    $(function() {
      var s;
      s = (document.body || document.documentElement).style;
      animationEndSupport = s.animation !== void 0 || s.WebkitAnimation !== void 0 || s.MozAnimation !== void 0 || s.MsAnimation !== void 0 || s.OAnimation !== void 0;
      return $(window).bind('keyup.vex', function(event) {
        if (event.keyCode === 27) {
          return vex.closeByEscape();
        }
      });
    });
    return vex = {
      globalID: 1,
      animationEndEvent: 'animationend webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend',
      baseClassNames: {
        vex: 'vex',
        content: 'vex-content',
        overlay: 'vex-overlay',
        close: 'vex-close',
        closing: 'vex-closing',
        open: 'vex-open'
      },
      defaultOptions: {
        content: '',
        showCloseButton: true,
        escapeButtonCloses: true,
        overlayClosesOnClick: true,
        appendLocation: 'body',
        className: '',
        css: {},
        overlayClassName: '',
        overlayCSS: {},
        contentClassName: '',
        contentCSS: {},
        closeClassName: '',
        closeCSS: {}
      },
      open: function(options) {
        options = $.extend({}, vex.defaultOptions, options);
        options.id = vex.globalID;
        vex.globalID += 1;
        options.$vex = $('<div>').addClass(vex.baseClassNames.vex).addClass(options.className).css(options.css).data({
          vex: options
        });
        options.$vexOverlay = $('<div>').addClass(vex.baseClassNames.overlay).addClass(options.overlayClassName).css(options.overlayCSS).data({
          vex: options
        });
        if (options.overlayClosesOnClick) {
          options.$vexOverlay.bind('click.vex', function(e) {
            if (e.target !== this) {
              return;
            }
            return vex.close($(this).data().vex.id);
          });
        }
        options.$vex.append(options.$vexOverlay);
        options.$vexContent = $('<div>').addClass(vex.baseClassNames.content).addClass(options.contentClassName).css(options.contentCSS).append(options.content).data({
          vex: options
        });
        options.$vex.append(options.$vexContent);
        if (options.showCloseButton) {
          options.$closeButton = $('<div>').addClass(vex.baseClassNames.close).addClass(options.closeClassName).css(options.closeCSS).data({
            vex: options
          }).bind('click.vex', function() {
            return vex.close($(this).data().vex.id);
          });
          options.$vexContent.append(options.$closeButton);
        }
        $(options.appendLocation).append(options.$vex);
        vex.setupBodyClassName(options.$vex);
        if (options.afterOpen) {
          options.afterOpen(options.$vexContent, options);
        }
        setTimeout((function() {
          return options.$vexContent.trigger('vexOpen', options);
        }), 0);
        return options.$vexContent;
      },
      getSelectorFromBaseClass: function(baseClass) {
        return "." + (baseClass.split(' ').join('.'));
      },
      getAllVexes: function() {
        return $("." + vex.baseClassNames.vex + ":not(\"." + vex.baseClassNames.closing + "\") " + (vex.getSelectorFromBaseClass(vex.baseClassNames.content)));
      },
      getVexByID: function(id) {
        return vex.getAllVexes().filter(function() {
          return $(this).data().vex.id === id;
        });
      },
      close: function(id) {
        var $lastVex;
        if (!id) {
          $lastVex = vex.getAllVexes().last();
          if (!$lastVex.length) {
            return false;
          }
          id = $lastVex.data().vex.id;
        }
        return vex.closeByID(id);
      },
      closeAll: function() {
        var ids;
        ids = vex.getAllVexes().map(function() {
          return $(this).data().vex.id;
        }).toArray();
        if (!(ids != null ? ids.length : void 0)) {
          return false;
        }
        $.each(ids.reverse(), function(index, id) {
          return vex.closeByID(id);
        });
        return true;
      },
      closeByID: function(id) {
        var $vex, $vexContent, beforeClose, close, hasAnimation, options;
        $vexContent = vex.getVexByID(id);
        if (!$vexContent.length) {
          return;
        }
        $vex = $vexContent.data().vex.$vex;
        options = $.extend({}, $vexContent.data().vex);
        beforeClose = function() {
          if (options.beforeClose) {
            return options.beforeClose($vexContent, options);
          }
        };
        close = function() {
          $vexContent.trigger('vexClose', options);
          $vex.remove();
          $('body').trigger('vexAfterClose', options);
          if (options.afterClose) {
            return options.afterClose($vexContent, options);
          }
        };
        hasAnimation = $vexContent.css('animationName') !== 'none' && $vexContent.css('animationDuration') !== '0s';
        if (animationEndSupport && hasAnimation) {
          if (beforeClose() !== false) {
            $vex.unbind(vex.animationEndEvent).bind(vex.animationEndEvent, function() {
              return close();
            }).addClass(vex.baseClassNames.closing);
          }
        } else {
          if (beforeClose() !== false) {
            close();
          }
        }
        return true;
      },
      closeByEscape: function() {
        var $lastVex, id, ids;
        ids = vex.getAllVexes().map(function() {
          return $(this).data().vex.id;
        }).toArray();
        if (!(ids != null ? ids.length : void 0)) {
          return false;
        }
        id = Math.max.apply(Math, ids);
        $lastVex = vex.getVexByID(id);
        if ($lastVex.data().vex.escapeButtonCloses !== true) {
          return false;
        }
        return vex.closeByID(id);
      },
      setupBodyClassName: function($vex) {
        return $('body').bind('vexOpen.vex', function() {
          return $('body').addClass(vex.baseClassNames.open);
        }).bind('vexAfterClose.vex', function() {
          if (!vex.getAllVexes().length) {
            return $('body').removeClass(vex.baseClassNames.open);
          }
        });
      },
      hideLoading: function() {
        return $('.vex-loading-spinner').remove();
      },
      showLoading: function() {
        vex.hideLoading();
        return $('body').append("<div class=\"vex-loading-spinner " + vex.defaultOptions.className + "\"></div>");
      }
    };
  };

  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (vexFactory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = vexFactory(require('jquery'));
  } else {
    window.vex = vexFactory(jQuery);
  }

}).call(this);


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./common/templates/404.jade": 285,
	"./common/templates/busy/modal.jade": 286,
	"./common/templates/busy/small.jade": 287,
	"./common/templates/layout.jade": 288,
	"./common/templates/navbar.jade": 289,
	"./common/templates/preview.jade": 290,
	"./common/templates/public-layout.jade": 291,
	"./common/templates/tutorial.jade": 292,
	"./common/templates/window.jade": 293,
	"./dashboard/dashboard.jade": 294,
	"./dashboard/images/edit_image.jade": 295,
	"./dashboard/images/new_image.jade": 296,
	"./dashboard/lessonSectionsList.jade": 297,
	"./dashboard/lessonsList.jade": 298,
	"./dashboard/list.jade": 299,
	"./dashboard/list2.jade": 300,
	"./dashboard/list3.jade": 301,
	"./dashboard/list4.jade": 302,
	"./dashboard/list5.jade": 303,
	"./dashboard/list6.jade": 304,
	"./dashboard/tag-typeahead-match.jade": 305,
	"./dashboard/templates_tags_renderer.jade": 306,
	"./dashboard/webFormsList.jade": 307,
	"./editor/editor.jade": 308,
	"./editor/editorEmail.jade": 309,
	"./editor/editorForm.jade": 310,
	"./editor/editorLayout.jade": 311,
	"./editor/editorLesson.jade": 312,
	"./editor/editor_nav/blocksettings.jade": 313,
	"./editor/editor_nav/fontsettings.jade": 314,
	"./editor/editor_nav/networkingsettings.jade": 315,
	"./editor/editor_nav/pagessettings.jade": 316,
	"./editor/editor_nav/sections/sections.jade": 317,
	"./editor/email_section_settings/create.jade": 318,
	"./editor/email_section_settings/edit.jade": 319,
	"./editor/email_settings/create.jade": 320,
	"./editor/email_settings/edit.jade": 321,
	"./editor/font_settings/fonts-typeahead-match.jade": 322,
	"./editor/font_settings/fonts-typeahead-popup.jade": 323,
	"./editor/modules_settings/alignment/template.jade": 324,
	"./editor/modules_settings/bgfields/template.jade": 325,
	"./editor/modules_settings/border/template.jade": 326,
	"./editor/modules_settings/buttonActions/template.jade": 327,
	"./editor/modules_settings/color/template.jade": 328,
	"./editor/modules_settings/colors/template.jade": 329,
	"./editor/modules_settings/formfields/template.jade": 330,
	"./editor/modules_settings/formfields/tree_renderer.jade": 331,
	"./editor/modules_settings/galleryfields/template.jade": 332,
	"./editor/modules_settings/gradient/template.jade": 333,
	"./editor/modules_settings/height/template.jade": 334,
	"./editor/modules_settings/hover/template.jade": 335,
	"./editor/modules_settings/icon/template.jade": 336,
	"./editor/modules_settings/link/template.jade": 337,
	"./editor/modules_settings/listfields/template.jade": 338,
	"./editor/modules_settings/map/template.jade": 339,
	"./editor/modules_settings/margin/template.jade": 340,
	"./editor/modules_settings/navigationfields/link.create.modal.jade": 341,
	"./editor/modules_settings/navigationfields/link.update.modal.jade": 342,
	"./editor/modules_settings/navigationfields/template.jade": 343,
	"./editor/modules_settings/navigationfields/tree_renderer.jade": 344,
	"./editor/modules_settings/padding/template.jade": 345,
	"./editor/modules_settings/photo-library/modal.jade": 346,
	"./editor/modules_settings/photo-library/template.jade": 347,
	"./editor/modules_settings/productfields/template.jade": 348,
	"./editor/modules_settings/productfields/tree_renderer.jade": 349,
	"./editor/modules_settings/radius/template.jade": 350,
	"./editor/modules_settings/reviewfields/template.jade": 351,
	"./editor/modules_settings/shadow/template.jade": 352,
	"./editor/modules_settings/siteBgSettings/template.jade": 353,
	"./editor/modules_settings/size/template.jade": 354,
	"./editor/modules_settings/sizeSelect/template.jade": 355,
	"./editor/modules_settings/sliderSize/template.jade": 356,
	"./editor/modules_settings/sliderfields/template.jade": 357,
	"./editor/modules_settings/socialfields/template.jade": 358,
	"./editor/modules_settings/strokecolor/template.jade": 359,
	"./editor/modules_settings/subscribeFormfields/template.jade": 360,
	"./editor/modules_settings/subscribeFormfields/tree_renderer.jade": 361,
	"./editor/modules_settings/tablefields/template.jade": 362,
	"./editor/modules_settings/textcolor/template.jade": 363,
	"./editor/modules_settings/timer/template.jade": 364,
	"./editor/modules_settings/uploader/template.jade": 365,
	"./editor/modules_settings/valignment/template.jade": 366,
	"./editor/modules_settings/width/template.jade": 367,
	"./editor/pageLayout.jade": 368,
	"./editor/section_settings/common/body.jade": 369,
	"./editor/section_settings/common/email-body.jade": 370,
	"./editor/section_settings/common/form-body.jade": 371,
	"./editor/section_settings/create.jade": 372,
	"./editor/section_settings/create_favorite.jade": 373,
	"./editor/section_settings/edit.jade": 374,
	"./editor/widget_settings/button/body.jade": 375,
	"./editor/widget_settings/card/body.jade": 376,
	"./editor/widget_settings/code/body.jade": 377,
	"./editor/widget_settings/facebook_comment/body.jade": 378,
	"./editor/widget_settings/form/body.jade": 379,
	"./editor/widget_settings/gallery/body.jade": 380,
	"./editor/widget_settings/headline_h1/body.jade": 381,
	"./editor/widget_settings/headline_h2/body.jade": 382,
	"./editor/widget_settings/headline_h3/body.jade": 383,
	"./editor/widget_settings/image/body.jade": 384,
	"./editor/widget_settings/line/body.jade": 385,
	"./editor/widget_settings/link/body.jade": 386,
	"./editor/widget_settings/list/body.jade": 387,
	"./editor/widget_settings/map/body.jade": 388,
	"./editor/widget_settings/navigation/body.jade": 389,
	"./editor/widget_settings/product/body.jade": 390,
	"./editor/widget_settings/review/body.jade": 391,
	"./editor/widget_settings/slider/body.jade": 392,
	"./editor/widget_settings/social/body.jade": 393,
	"./editor/widget_settings/subscribe_form/body.jade": 394,
	"./editor/widget_settings/table/body.jade": 395,
	"./editor/widget_settings/text/body.jade": 396,
	"./editor/widget_settings/timer/body.jade": 397,
	"./editor/widget_settings/video/body.jade": 398,
	"./email/edit_email.jade": 399,
	"./email/new_email.jade": 400,
	"./lesson/editLesson.jade": 401,
	"./lesson/newLesson.jade": 402,
	"./lesson/newLessonSection.jade": 403,
	"./site/edit_template.jade": 404,
	"./site/favorite/favorite.jade": 405,
	"./site/new_template.jade": 406,
	"./site/page/tree_renderer.jade": 407,
	"./site/site.jade": 408,
	"./site/site_settings/settings_views/additional.jade": 409,
	"./site/site_settings/settings_views/adminsettings.jade": 410,
	"./site/site_settings/settings_views/bg.jade": 411,
	"./site/site_settings/settings_views/faviconsettings.jade": 412,
	"./site/site_settings/settings_views/fontsettings.jade": 413,
	"./site/site_settings/settings_views/htmlcode.jade": 414,
	"./site/site_settings/settings_views/imagesettings.jade": 415,
	"./site/site_settings/settings_views/seosettings.jade": 416,
	"./site/site_settings/settings_views/swsettings.jade": 417,
	"./site/site_settings/site_settings.jade": 418,
	"./webform/edit_webform.jade": 419,
	"./webform/html_of_form.jade": 420,
	"./webform/new_webform.jade": 421
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 444;

/***/ }),
/* 445 */
/***/ (function(module, exports) {

/*
Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
For licensing, see LICENSE.md or http://ckeditor.com/license
*/
(function() {
    if (!window.CKEDITOR || !window.CKEDITOR.dom) window.CKEDITOR || (window.CKEDITOR = function() {
        var a = /(^|.*[\\\/])ckeditor\.js(?:\?.*|;.*)?$/i,
            e = {
                timestamp: "F0RF",
                version: "4.4.7 (Standard)",
                revision: "3a35b3d",
                rnd: Math.floor(900 * Math.random()) + 100,
                _: {
                    pending: [],
                    basePathSrcPattern: a
                },
                status: "unloaded",
                basePath: function() {
                    var c = window.CKEDITOR_BASEPATH || "";
                    if (!c)
                        for (var d = document.getElementsByTagName("script"), b = 0; b < d.length; b++) {
                            var f = d[b].src.match(a);
                            if (f) {
                                c = f[1];
                                break
                            }
                        } - 1 == c.indexOf(":/") &&
                            "//" != c.slice(0, 2) && (c = 0 === c.indexOf("/") ? location.href.match(/^.*?:\/\/[^\/]*/)[0] + c : location.href.match(/^[^\?]*\/(?:)/)[0] + c);
                    if (!c) throw 'The CKEditor installation path could not be automatically detected. Please set the global variable "CKEDITOR_BASEPATH" before creating editor instances.';
                    return c
                }(),
                getUrl: function(a) {
                    -1 == a.indexOf(":/") && 0 !== a.indexOf("/") && (a = this.basePath + a);
                    this.timestamp && ("/" != a.charAt(a.length - 1) && !/[&?]t=/.test(a)) && (a += (0 <= a.indexOf("?") ? "&" : "?") + "t=" + this.timestamp);
                    return a
                },
                domReady: function() {
                    function a() {
                        try {
                            document.addEventListener ? (document.removeEventListener("DOMContentLoaded", a, !1), d()) : document.attachEvent && "complete" === document.readyState && (document.detachEvent("onreadystatechange", a), d())
                        } catch (b) {}
                    }

                    function d() {
                        for (var a; a = b.shift();) a()
                    }
                    var b = [];
                    return function(d) {
                        function g() {
                            try {
                                document.documentElement.doScroll("left")
                            } catch (k) {
                                setTimeout(g, 1);
                                return
                            }
                            a()
                        }
                        b.push(d);
                        "complete" === document.readyState && setTimeout(a, 1);
                        if (1 == b.length)
                            if (document.addEventListener) document.addEventListener("DOMContentLoaded",
                                a, !1), window.addEventListener("load", a, !1);
                            else if (document.attachEvent) {
                            document.attachEvent("onreadystatechange", a);
                            window.attachEvent("onload", a);
                            d = !1;
                            try {
                                d = !window.frameElement
                            } catch (e) {}
                            document.documentElement.doScroll && d && g()
                        }
                    }
                }()
            }, b = window.CKEDITOR_GETURL;
        if (b) {
            var g = e.getUrl;
            e.getUrl = function(a) {
                return b.call(e, a) || g.call(e, a)
            }
        }
        return e
    }()), CKEDITOR.event || (CKEDITOR.event = function() {}, CKEDITOR.event.implementOn = function(a) {
            var e = CKEDITOR.event.prototype,
                b;
            for (b in e) a[b] == null && (a[b] = e[b])
        },
        CKEDITOR.event.prototype = function() {
            function a(a) {
                var c = e(this);
                return c[a] || (c[a] = new b(a))
            }
            var e = function(a) {
                a = a.getPrivate && a.getPrivate() || a._ || (a._ = {});
                return a.events || (a.events = {})
            }, b = function(a) {
                    this.name = a;
                    this.listeners = []
                };
            b.prototype = {
                getListenerIndex: function(a) {
                    for (var c = 0, d = this.listeners; c < d.length; c++)
                        if (d[c].fn == a) return c;
                    return -1
                }
            };
            return {
                define: function(b, c) {
                    var d = a.call(this, b);
                    CKEDITOR.tools.extend(d, c, true)
                },
                on: function(b, c, d, j, f) {
                    function h(a, k, f, h) {
                        a = {
                            name: b,
                            sender: this,
                            editor: a,
                            data: k,
                            listenerData: j,
                            stop: f,
                            cancel: h,
                            removeListener: e
                        };
                        return c.call(d, a) === false ? false : a.data
                    }

                    function e() {
                        n.removeListener(b, c)
                    }
                    var k = a.call(this, b);
                    if (k.getListenerIndex(c) < 0) {
                        k = k.listeners;
                        d || (d = this);
                        isNaN(f) && (f = 10);
                        var n = this;
                        h.fn = c;
                        h.priority = f;
                        for (var o = k.length - 1; o >= 0; o--)
                            if (k[o].priority <= f) {
                                k.splice(o + 1, 0, h);
                                return {
                                    removeListener: e
                                }
                            }
                        k.unshift(h)
                    }
                    return {
                        removeListener: e
                    }
                },
                once: function() {
                    var a = Array.prototype.slice.call(arguments),
                        c = a[1];
                    a[1] = function(a) {
                        a.removeListener();
                        return c.apply(this,
                            arguments)
                    };
                    return this.on.apply(this, a)
                },
                capture: function() {
                    CKEDITOR.event.useCapture = 1;
                    var a = this.on.apply(this, arguments);
                    CKEDITOR.event.useCapture = 0;
                    return a
                },
                fire: function() {
                    var a = 0,
                        c = function() {
                            a = 1
                        }, d = 0,
                        b = function() {
                            d = 1
                        };
                    return function(f, h, i) {
                        var k = e(this)[f],
                            f = a,
                            n = d;
                        a = d = 0;
                        if (k) {
                            var o = k.listeners;
                            if (o.length)
                                for (var o = o.slice(0), q, m = 0; m < o.length; m++) {
                                    if (k.errorProof) try {
                                        q = o[m].call(this, i, h, c, b)
                                    } catch (l) {} else q = o[m].call(this, i, h, c, b);
                                    q === false ? d = 1 : typeof q != "undefined" && (h = q);
                                    if (a || d) break
                                }
                        }
                        h =
                            d ? false : typeof h == "undefined" ? true : h;
                        a = f;
                        d = n;
                        return h
                    }
                }(),
                fireOnce: function(a, c, d) {
                    c = this.fire(a, c, d);
                    delete e(this)[a];
                    return c
                },
                removeListener: function(a, c) {
                    var d = e(this)[a];
                    if (d) {
                        var b = d.getListenerIndex(c);
                        b >= 0 && d.listeners.splice(b, 1)
                    }
                },
                removeAllListeners: function() {
                    var a = e(this),
                        c;
                    for (c in a) delete a[c]
                },
                hasListeners: function(a) {
                    return (a = e(this)[a]) && a.listeners.length > 0
                }
            }
        }()), CKEDITOR.editor || (CKEDITOR.editor = function() {
            CKEDITOR._.pending.push([this, arguments]);
            CKEDITOR.event.call(this)
        }, CKEDITOR.editor.prototype.fire =
        function(a, e) {
            a in {
                instanceReady: 1,
                loaded: 1
            } && (this[a] = true);
            return CKEDITOR.event.prototype.fire.call(this, a, e, this)
        }, CKEDITOR.editor.prototype.fireOnce = function(a, e) {
            a in {
                instanceReady: 1,
                loaded: 1
            } && (this[a] = true);
            return CKEDITOR.event.prototype.fireOnce.call(this, a, e, this)
        }, CKEDITOR.event.implementOn(CKEDITOR.editor.prototype)), CKEDITOR.env || (CKEDITOR.env = function() {
        var a = navigator.userAgent.toLowerCase(),
            e = {
                ie: a.indexOf("trident/") > -1,
                webkit: a.indexOf(" applewebkit/") > -1,
                air: a.indexOf(" adobeair/") > -1,
                mac: a.indexOf("macintosh") > -1,
                quirks: document.compatMode == "BackCompat" && (!document.documentMode || document.documentMode < 10),
                mobile: a.indexOf("mobile") > -1,
                iOS: /(ipad|iphone|ipod)/.test(a),
                isCustomDomain: function() {
                    if (!this.ie) return false;
                    var a = document.domain,
                        d = window.location.hostname;
                    return a != d && a != "[" + d + "]"
                },
                secure: location.protocol == "https:"
            };
        e.gecko = navigator.product == "Gecko" && !e.webkit && !e.ie;
        if (e.webkit) a.indexOf("chrome") > -1 ? e.chrome = true : e.safari = true;
        var b = 0;
        if (e.ie) {
            b = e.quirks || !document.documentMode ?
                parseFloat(a.match(/msie (\d+)/)[1]) : document.documentMode;
            e.ie9Compat = b == 9;
            e.ie8Compat = b == 8;
            e.ie7Compat = b == 7;
            e.ie6Compat = b < 7 || e.quirks
        }
        if (e.gecko) {
            var g = a.match(/rv:([\d\.]+)/);
            if (g) {
                g = g[1].split(".");
                b = g[0] * 1E4 + (g[1] || 0) * 100 + (g[2] || 0) * 1
            }
        }
        e.air && (b = parseFloat(a.match(/ adobeair\/(\d+)/)[1]));
        e.webkit && (b = parseFloat(a.match(/ applewebkit\/(\d+)/)[1]));
        e.version = b;
        e.isCompatible = e.iOS && b >= 534 || !e.mobile && (e.ie && b > 6 || e.gecko && b >= 2E4 || e.air && b >= 1 || e.webkit && b >= 522 || false);
        e.hidpi = window.devicePixelRatio >=
            2;
        e.needsBrFiller = e.gecko || e.webkit || e.ie && b > 10;
        e.needsNbspFiller = e.ie && b < 11;
        e.cssClass = "cke_browser_" + (e.ie ? "ie" : e.gecko ? "gecko" : e.webkit ? "webkit" : "unknown");
        if (e.quirks) e.cssClass = e.cssClass + " cke_browser_quirks";
        if (e.ie) e.cssClass = e.cssClass + (" cke_browser_ie" + (e.quirks ? "6 cke_browser_iequirks" : e.version));
        if (e.air) e.cssClass = e.cssClass + " cke_browser_air";
        if (e.iOS) e.cssClass = e.cssClass + " cke_browser_ios";
        if (e.hidpi) e.cssClass = e.cssClass + " cke_hidpi";
        return e
    }()), "unloaded" == CKEDITOR.status && function() {
        CKEDITOR.event.implementOn(CKEDITOR);
        CKEDITOR.loadFullCore = function() {
            if (CKEDITOR.status != "basic_ready") CKEDITOR.loadFullCore._load = 1;
            else {
                delete CKEDITOR.loadFullCore;
                var a = document.createElement("script");
                a.type = "text/javascript";
                a.src = CKEDITOR.basePath + "ckeditor.js";
                document.getElementsByTagName("head")[0].appendChild(a)
            }
        };
        CKEDITOR.loadFullCoreTimeout = 0;
        CKEDITOR.add = function(a) {
            (this._.pending || (this._.pending = [])).push(a)
        };
        (function() {
            CKEDITOR.domReady(function() {
                var a = CKEDITOR.loadFullCore,
                    e = CKEDITOR.loadFullCoreTimeout;
                if (a) {
                    CKEDITOR.status =
                        "basic_ready";
                    a && a._load ? a() : e && setTimeout(function() {
                        CKEDITOR.loadFullCore && CKEDITOR.loadFullCore()
                    }, e * 1E3)
                }
            })
        })();
        CKEDITOR.status = "basic_loaded"
    }(), CKEDITOR.dom = {},
    function() {
        var a = [],
            e = CKEDITOR.env.gecko ? "-moz-" : CKEDITOR.env.webkit ? "-webkit-" : CKEDITOR.env.ie ? "-ms-" : "",
            b = /&/g,
            g = />/g,
            c = /</g,
            d = /"/g,
            j = /&amp;/g,
            f = /&gt;/g,
            h = /&lt;/g,
            i = /&quot;/g;
        CKEDITOR.on("reset", function() {
            a = []
        });
        CKEDITOR.tools = {
            arrayCompare: function(a, c) {
                if (!a && !c) return true;
                if (!a || !c || a.length != c.length) return false;
                for (var d = 0; d <
                    a.length; d++)
                    if (a[d] != c[d]) return false;
                return true
            },
            clone: function(a) {
                var c;
                if (a && a instanceof Array) {
                    c = [];
                    for (var d = 0; d < a.length; d++) c[d] = CKEDITOR.tools.clone(a[d]);
                    return c
                }
                if (a === null || typeof a != "object" || a instanceof String || a instanceof Number || a instanceof Boolean || a instanceof Date || a instanceof RegExp || a.nodeType || a.window === a) return a;
                c = new a.constructor;
                for (d in a) c[d] = CKEDITOR.tools.clone(a[d]);
                return c
            },
            capitalize: function(a, c) {
                return a.charAt(0).toUpperCase() + (c ? a.slice(1) : a.slice(1).toLowerCase())
            },
            extend: function(a) {
                var c = arguments.length,
                    d, b;
                if (typeof(d = arguments[c - 1]) == "boolean") c--;
                else if (typeof(d = arguments[c - 2]) == "boolean") {
                    b = arguments[c - 1];
                    c = c - 2
                }
                for (var f = 1; f < c; f++) {
                    var g = arguments[f],
                        j;
                    for (j in g)
                        if (d === true || a[j] == null)
                            if (!b || j in b) a[j] = g[j]
                }
                return a
            },
            prototypedCopy: function(a) {
                var c = function() {};
                c.prototype = a;
                return new c
            },
            copy: function(a) {
                var c = {}, d;
                for (d in a) c[d] = a[d];
                return c
            },
            isArray: function(a) {
                return Object.prototype.toString.call(a) == "[object Array]"
            },
            isEmpty: function(a) {
                for (var c in a)
                    if (a.hasOwnProperty(c)) return false;
                return true
            },
            cssVendorPrefix: function(a, c, d) {
                if (d) return e + a + ":" + c + ";" + a + ":" + c;
                d = {};
                d[a] = c;
                d[e + a] = c;
                return d
            },
            cssStyleToDomStyle: function() {
                var a = document.createElement("div").style,
                    c = typeof a.cssFloat != "undefined" ? "cssFloat" : typeof a.styleFloat != "undefined" ? "styleFloat" : "float";
                return function(a) {
                    return a == "float" ? c : a.replace(/-./g, function(a) {
                        return a.substr(1).toUpperCase()
                    })
                }
            }(),
            buildStyleHtml: function(a) {
                for (var a = [].concat(a), c, d = [], b = 0; b < a.length; b++)
                    if (c = a[b]) /@import|[{}]/.test(c) ? d.push("<style>" +
                        c + "</style>") : d.push('<link type="text/css" rel=stylesheet href="' + c + '">');
                return d.join("")
            },
            htmlEncode: function(a) {
                return ("" + a).replace(b, "&amp;").replace(g, "&gt;").replace(c, "&lt;")
            },
            htmlDecode: function(a) {
                return a.replace(j, "&").replace(f, ">").replace(h, "<")
            },
            htmlEncodeAttr: function(a) {
                return a.replace(d, "&quot;").replace(c, "&lt;").replace(g, "&gt;")
            },
            htmlDecodeAttr: function(a) {
                return a.replace(i, '"').replace(h, "<").replace(f, ">")
            },
            getNextNumber: function() {
                var a = 0;
                return function() {
                    return ++a
                }
            }(),
            getNextId: function() {
                return "cke_" + this.getNextNumber()
            },
            override: function(a, c) {
                var d = c(a);
                d.prototype = a.prototype;
                return d
            },
            setTimeout: function(a, c, d, b, f) {
                f || (f = window);
                d || (d = f);
                return f.setTimeout(function() {
                    b ? a.apply(d, [].concat(b)) : a.apply(d)
                }, c || 0)
            },
            trim: function() {
                var a = /(?:^[ \t\n\r]+)|(?:[ \t\n\r]+$)/g;
                return function(c) {
                    return c.replace(a, "")
                }
            }(),
            ltrim: function() {
                var a = /^[ \t\n\r]+/g;
                return function(c) {
                    return c.replace(a, "")
                }
            }(),
            rtrim: function() {
                var a = /[ \t\n\r]+$/g;
                return function(c) {
                    return c.replace(a,
                        "")
                }
            }(),
            indexOf: function(a, c) {
                if (typeof c == "function")
                    for (var d = 0, b = a.length; d < b; d++) {
                        if (c(a[d])) return d
                    } else {
                        if (a.indexOf) return a.indexOf(c);
                        d = 0;
                        for (b = a.length; d < b; d++)
                            if (a[d] === c) return d
                    }
                return -1
            },
            search: function(a, c) {
                var d = CKEDITOR.tools.indexOf(a, c);
                return d >= 0 ? a[d] : null
            },
            bind: function(a, c) {
                return function() {
                    return a.apply(c, arguments)
                }
            },
            createClass: function(a) {
                var c = a.$,
                    d = a.base,
                    b = a.privates || a._,
                    f = a.proto,
                    a = a.statics;
                !c && (c = function() {
                    d && this.base.apply(this, arguments)
                });
                if (b) var g = c,
                c = function() {
                    var a =
                        this._ || (this._ = {}),
                        c;
                    for (c in b) {
                        var d = b[c];
                        a[c] = typeof d == "function" ? CKEDITOR.tools.bind(d, this) : d
                    }
                    g.apply(this, arguments)
                };
                if (d) {
                    c.prototype = this.prototypedCopy(d.prototype);
                    c.prototype.constructor = c;
                    c.base = d;
                    c.baseProto = d.prototype;
                    c.prototype.base = function() {
                        this.base = d.prototype.base;
                        d.apply(this, arguments);
                        this.base = arguments.callee
                    }
                }
                f && this.extend(c.prototype, f, true);
                a && this.extend(c, a, true);
                return c
            },
            addFunction: function(c, d) {
                return a.push(function() {
                    return c.apply(d || this, arguments)
                }) - 1
            },
            removeFunction: function(c) {
                a[c] = null
            },
            callFunction: function(c) {
                var d = a[c];
                return d && d.apply(window, Array.prototype.slice.call(arguments, 1))
            },
            cssLength: function() {
                var a = /^-?\d+\.?\d*px$/,
                    c;
                return function(d) {
                    c = CKEDITOR.tools.trim(d + "") + "px";
                    return a.test(c) ? c : d || ""
                }
            }(),
            convertToPx: function() {
                var a;
                return function(c) {
                    if (!a) {
                        a = CKEDITOR.dom.element.createFromHtml('<div style="position:absolute;left:-9999px;top:-9999px;margin:0px;padding:0px;border:0px;"></div>', CKEDITOR.document);
                        CKEDITOR.document.getBody().append(a)
                    }
                    if (!/%$/.test(c)) {
                        a.setStyle("width",
                            c);
                        return a.$.clientWidth
                    }
                    return c
                }
            }(),
            repeat: function(a, c) {
                return Array(c + 1).join(a)
            },
            tryThese: function() {
                for (var a, c = 0, d = arguments.length; c < d; c++) {
                    var b = arguments[c];
                    try {
                        a = b();
                        break
                    } catch (f) {}
                }
                return a
            },
            genKey: function() {
                return Array.prototype.slice.call(arguments).join("-")
            },
            defer: function(a) {
                return function() {
                    var c = arguments,
                        d = this;
                    window.setTimeout(function() {
                        a.apply(d, c)
                    }, 0)
                }
            },
            normalizeCssText: function(a, c) {
                var d = [],
                    b, f = CKEDITOR.tools.parseCssText(a, true, c);
                for (b in f) d.push(b + ":" + f[b]);
                d.sort();
                return d.length ? d.join(";") + ";" : ""
            },
            convertRgbToHex: function(a) {
                return a.replace(/(?:rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\))/gi, function(a, c, d, b) {
                    a = [c, d, b];
                    for (c = 0; c < 3; c++) a[c] = ("0" + parseInt(a[c], 10).toString(16)).slice(-2);
                    return "#" + a.join("")
                })
            },
            parseCssText: function(a, c, d) {
                var b = {};
                if (d) {
                    d = new CKEDITOR.dom.element("span");
                    d.setAttribute("style", a);
                    a = CKEDITOR.tools.convertRgbToHex(d.getAttribute("style") || "")
                }
                if (!a || a == ";") return b;
                a.replace(/&quot;/g, '"').replace(/\s*([^:;\s]+)\s*:\s*([^;]+)\s*(?=;|$)/g,
                    function(a, d, f) {
                        if (c) {
                            d = d.toLowerCase();
                            d == "font-family" && (f = f.toLowerCase().replace(/["']/g, "").replace(/\s*,\s*/g, ","));
                            f = CKEDITOR.tools.trim(f)
                        }
                        b[d] = f
                    });
                return b
            },
            writeCssText: function(a, c) {
                var d, b = [];
                for (d in a) b.push(d + ":" + a[d]);
                c && b.sort();
                return b.join("; ")
            },
            objectCompare: function(a, c, d) {
                var b;
                if (!a && !c) return true;
                if (!a || !c) return false;
                for (b in a)
                    if (a[b] != c[b]) return false;
                if (!d)
                    for (b in c)
                        if (a[b] != c[b]) return false;
                return true
            },
            objectKeys: function(a) {
                var c = [],
                    d;
                for (d in a) c.push(d);
                return c
            },
            convertArrayToObject: function(a, c) {
                var d = {};
                arguments.length == 1 && (c = true);
                for (var b = 0, f = a.length; b < f; ++b) d[a[b]] = c;
                return d
            },
            fixDomain: function() {
                for (var a;;) try {
                    a = window.parent.document.domain;
                    break
                } catch (c) {
                    a = a ? a.replace(/.+?(?:\.|$)/, "") : document.domain;
                    if (!a) break;
                    document.domain = a
                }
                return !!a
            },
            eventsBuffer: function(a, c) {
                function d() {
                    f = (new Date).getTime();
                    b = false;
                    c()
                }
                var b, f = 0;
                return {
                    input: function() {
                        if (!b) {
                            var c = (new Date).getTime() - f;
                            c < a ? b = setTimeout(d, a - c) : d()
                        }
                    },
                    reset: function() {
                        b && clearTimeout(b);
                        b = f = 0
                    }
                }
            },
            enableHtml5Elements: function(a, c) {
                for (var d = ["abbr", "article", "aside", "audio", "bdi", "canvas", "data", "datalist", "details", "figcaption", "figure", "footer", "header", "hgroup", "mark", "meter", "nav", "output", "progress", "section", "summary", "time", "video"], b = d.length, f; b--;) {
                    f = a.createElement(d[b]);
                    c && a.appendChild(f)
                }
            },
            checkIfAnyArrayItemMatches: function(a, c) {
                for (var d = 0, b = a.length; d < b; ++d)
                    if (a[d].match(c)) return true;
                return false
            },
            checkIfAnyObjectPropertyMatches: function(a, c) {
                for (var d in a)
                    if (d.match(c)) return true;
                return false
            },
            transparentImageData: "data:image/gif;base64,R0lGODlhAQABAPABAP///wAAACH5BAEKAAAALAAAAAABAAEAAAICRAEAOw=="
        }
    }(), CKEDITOR.dtd = function() {
        var a = CKEDITOR.tools.extend,
            e = function(a, c) {
                for (var d = CKEDITOR.tools.clone(a), b = 1; b < arguments.length; b++) {
                    var c = arguments[b],
                        f;
                    for (f in c) delete d[f]
                }
                return d
            }, b = {}, g = {}, c = {
                address: 1,
                article: 1,
                aside: 1,
                blockquote: 1,
                details: 1,
                div: 1,
                dl: 1,
                fieldset: 1,
                figure: 1,
                footer: 1,
                form: 1,
                h1: 1,
                h2: 1,
                h3: 1,
                h4: 1,
                h5: 1,
                h6: 1,
                header: 1,
                hgroup: 1,
                hr: 1,
                main: 1,
                menu: 1,
                nav: 1,
                ol: 1,
                p: 1,
                pre: 1,
                section: 1,
                table: 1,
                ul: 1
            }, d = {
                command: 1,
                link: 1,
                meta: 1,
                noscript: 1,
                script: 1,
                style: 1
            }, j = {}, f = {
                "#": 1
            }, h = {
                center: 1,
                dir: 1,
                noframes: 1
            };
        a(b, {
            a: 1,
            abbr: 1,
            area: 1,
            audio: 1,
            b: 1,
            bdi: 1,
            bdo: 1,
            br: 1,
            button: 1,
            canvas: 1,
            cite: 1,
            code: 1,
            command: 1,
            datalist: 1,
            del: 1,
            dfn: 1,
            em: 1,
            embed: 1,
            i: 1,
            iframe: 1,
            img: 1,
            input: 1,
            ins: 1,
            kbd: 1,
            keygen: 1,
            label: 1,
            map: 1,
            mark: 1,
            meter: 1,
            noscript: 1,
            object: 1,
            output: 1,
            progress: 1,
            q: 1,
            ruby: 1,
            s: 1,
            samp: 1,
            script: 1,
            select: 1,
            small: 1,
            span: 1,
            strong: 1,
            sub: 1,
            sup: 1,
            textarea: 1,
            time: 1,
            u: 1,
            "var": 1,
            video: 1,
            wbr: 1
        }, f, {
            acronym: 1,
            applet: 1,
            basefont: 1,
            big: 1,
            font: 1,
            isindex: 1,
            strike: 1,
            style: 1,
            tt: 1
        });
        a(g, c, b, h);
        e = {
            a: e(b, {
                a: 1,
                button: 1
            }),
            abbr: b,
            address: g,
            area: j,
            article: g,
            aside: g,
            audio: a({
                source: 1,
                track: 1
            }, g),
            b: b,
            base: j,
            bdi: b,
            bdo: b,
            blockquote: g,
            body: g,
            br: j,
            button: e(b, {
                a: 1,
                button: 1
            }),
            canvas: b,
            caption: g,
            cite: b,
            code: b,
            col: j,
            colgroup: {
                col: 1
            },
            command: j,
            datalist: a({
                option: 1
            }, b),
            dd: g,
            del: b,
            details: a({
                summary: 1
            }, g),
            dfn: b,
            div: g,
            dl: {
                dt: 1,
                dd: 1
            },
            dt: g,
            em: b,
            embed: j,
            fieldset: a({
                legend: 1
            }, g),
            figcaption: g,
            figure: a({
                figcaption: 1
            }, g),
            footer: g,
            form: g,
            h1: b,
            h2: b,
            h3: b,
            h4: b,
            h5: b,
            h6: b,
            head: a({
                title: 1,
                base: 1
            }, d),
            header: g,
            hgroup: {
                h1: 1,
                h2: 1,
                h3: 1,
                h4: 1,
                h5: 1,
                h6: 1
            },
            hr: j,
            html: a({
                head: 1,
                body: 1
            }, g, d),
            i: b,
            iframe: f,
            img: j,
            input: j,
            ins: b,
            kbd: b,
            keygen: j,
            label: b,
            legend: b,
            li: g,
            link: j,
            main: g,
            map: g,
            mark: b,
            menu: a({
                li: 1
            }, g),
            meta: j,
            meter: e(b, {
                meter: 1
            }),
            nav: g,
            noscript: a({
                link: 1,
                meta: 1,
                style: 1
            }, b),
            object: a({
                param: 1
            }, b),
            ol: {
                li: 1
            },
            optgroup: {
                option: 1
            },
            option: f,
            output: b,
            p: b,
            param: j,
            pre: b,
            progress: e(b, {
                progress: 1
            }),
            q: b,
            rp: b,
            rt: b,
            ruby: a({
                rp: 1,
                rt: 1
            }, b),
            s: b,
            samp: b,
            script: f,
            section: g,
            select: {
                optgroup: 1,
                option: 1
            },
            small: b,
            source: j,
            span: b,
            strong: b,
            style: f,
            sub: b,
            summary: b,
            sup: b,
            table: {
                caption: 1,
                colgroup: 1,
                thead: 1,
                tfoot: 1,
                tbody: 1,
                tr: 1
            },
            tbody: {
                tr: 1
            },
            td: g,
            textarea: f,
            tfoot: {
                tr: 1
            },
            th: g,
            thead: {
                tr: 1
            },
            time: e(b, {
                time: 1
            }),
            title: f,
            tr: {
                th: 1,
                td: 1
            },
            track: j,
            u: b,
            ul: {
                li: 1
            },
            "var": b,
            video: a({
                source: 1,
                track: 1
            }, g),
            wbr: j,
            acronym: b,
            applet: a({
                param: 1
            }, g),
            basefont: j,
            big: b,
            center: g,
            dialog: j,
            dir: {
                li: 1
            },
            font: b,
            isindex: j,
            noframes: g,
            strike: b,
            tt: b
        };
        a(e, {
            $block: a({
                    audio: 1,
                    dd: 1,
                    dt: 1,
                    figcaption: 1,
                    li: 1,
                    video: 1
                },
                c, h),
            $blockLimit: {
                article: 1,
                aside: 1,
                audio: 1,
                body: 1,
                caption: 1,
                details: 1,
                dir: 1,
                div: 1,
                dl: 1,
                fieldset: 1,
                figcaption: 1,
                figure: 1,
                footer: 1,
                form: 1,
                header: 1,
                hgroup: 1,
                main: 1,
                menu: 1,
                nav: 1,
                ol: 1,
                section: 1,
                table: 1,
                td: 1,
                th: 1,
                tr: 1,
                ul: 1,
                video: 1
            },
            $cdata: {
                script: 1,
                style: 1
            },
            $editable: {
                address: 1,
                article: 1,
                aside: 1,
                blockquote: 1,
                body: 1,
                details: 1,
                div: 1,
                fieldset: 1,
                figcaption: 1,
                footer: 1,
                form: 1,
                h1: 1,
                h2: 1,
                h3: 1,
                h4: 1,
                h5: 1,
                h6: 1,
                header: 1,
                hgroup: 1,
                main: 1,
                nav: 1,
                p: 1,
                pre: 1,
                section: 1
            },
            $empty: {
                area: 1,
                base: 1,
                basefont: 1,
                br: 1,
                col: 1,
                command: 1,
                dialog: 1,
                embed: 1,
                hr: 1,
                img: 1,
                input: 1,
                isindex: 1,
                keygen: 1,
                link: 1,
                meta: 1,
                param: 1,
                source: 1,
                track: 1,
                wbr: 1
            },
            $inline: b,
            $list: {
                dl: 1,
                ol: 1,
                ul: 1
            },
            $listItem: {
                dd: 1,
                dt: 1,
                li: 1
            },
            $nonBodyContent: a({
                body: 1,
                head: 1,
                html: 1
            }, e.head),
            $nonEditable: {
                applet: 1,
                audio: 1,
                button: 1,
                embed: 1,
                iframe: 1,
                map: 1,
                object: 1,
                option: 1,
                param: 1,
                script: 1,
                textarea: 1,
                video: 1
            },
            $object: {
                applet: 1,
                audio: 1,
                button: 1,
                hr: 1,
                iframe: 1,
                img: 1,
                input: 1,
                object: 1,
                select: 1,
                table: 1,
                textarea: 1,
                video: 1
            },
            $removeEmpty: {
                abbr: 1,
                acronym: 1,
                b: 1,
                bdi: 1,
                bdo: 1,
                big: 1,
                cite: 1,
                code: 1,
                del: 1,
                dfn: 1,
                em: 1,
                font: 1,
                i: 1,
                ins: 1,
                label: 1,
                kbd: 1,
                mark: 1,
                meter: 1,
                output: 1,
                q: 1,
                ruby: 1,
                s: 1,
                samp: 1,
                small: 1,
                span: 1,
                strike: 1,
                strong: 1,
                sub: 1,
                sup: 1,
                time: 1,
                tt: 1,
                u: 1,
                "var": 1
            },
            $tabIndex: {
                a: 1,
                area: 1,
                button: 1,
                input: 1,
                object: 1,
                select: 1,
                textarea: 1
            },
            $tableContent: {
                caption: 1,
                col: 1,
                colgroup: 1,
                tbody: 1,
                td: 1,
                tfoot: 1,
                th: 1,
                thead: 1,
                tr: 1
            },
            $transparent: {
                a: 1,
                audio: 1,
                canvas: 1,
                del: 1,
                ins: 1,
                map: 1,
                noscript: 1,
                object: 1,
                video: 1
            },
            $intermediate: {
                caption: 1,
                colgroup: 1,
                dd: 1,
                dt: 1,
                figcaption: 1,
                legend: 1,
                li: 1,
                optgroup: 1,
                option: 1,
                rp: 1,
                rt: 1,
                summary: 1,
                tbody: 1,
                td: 1,
                tfoot: 1,
                th: 1,
                thead: 1,
                tr: 1
            }
        });
        return e
    }(), CKEDITOR.dom.event = function(a) {
        this.$ = a
    }, CKEDITOR.dom.event.prototype = {
        getKey: function() {
            return this.$.keyCode || this.$.which
        },
        getKeystroke: function() {
            var a = this.getKey();
            if (this.$.ctrlKey || this.$.metaKey) a = a + CKEDITOR.CTRL;
            this.$.shiftKey && (a = a + CKEDITOR.SHIFT);
            this.$.altKey && (a = a + CKEDITOR.ALT);
            return a
        },
        preventDefault: function(a) {
            var e = this.$;
            e.preventDefault ? e.preventDefault() : e.returnValue = false;
            a && this.stopPropagation()
        },
        stopPropagation: function() {
            var a =
                this.$;
            a.stopPropagation ? a.stopPropagation() : a.cancelBubble = true
        },
        getTarget: function() {
            var a = this.$.target || this.$.srcElement;
            return a ? new CKEDITOR.dom.node(a) : null
        },
        getPhase: function() {
            return this.$.eventPhase || 2
        },
        getPageOffset: function() {
            var a = this.getTarget().getDocument().$;
            return {
                x: this.$.pageX || this.$.clientX + (a.documentElement.scrollLeft || a.body.scrollLeft),
                y: this.$.pageY || this.$.clientY + (a.documentElement.scrollTop || a.body.scrollTop)
            }
        }
    }, CKEDITOR.CTRL = 1114112, CKEDITOR.SHIFT = 2228224, CKEDITOR.ALT =
        4456448, CKEDITOR.EVENT_PHASE_CAPTURING = 1, CKEDITOR.EVENT_PHASE_AT_TARGET = 2, CKEDITOR.EVENT_PHASE_BUBBLING = 3, CKEDITOR.dom.domObject = function(a) {
            if (a) this.$ = a
    }, CKEDITOR.dom.domObject.prototype = function() {
        var a = function(a, b) {
            return function(g) {
                typeof CKEDITOR != "undefined" && a.fire(b, new CKEDITOR.dom.event(g))
            }
        };
        return {
            getPrivate: function() {
                var a;
                if (!(a = this.getCustomData("_"))) this.setCustomData("_", a = {});
                return a
            },
            on: function(e) {
                var b = this.getCustomData("_cke_nativeListeners");
                if (!b) {
                    b = {};
                    this.setCustomData("_cke_nativeListeners",
                        b)
                }
                if (!b[e]) {
                    b = b[e] = a(this, e);
                    this.$.addEventListener ? this.$.addEventListener(e, b, !! CKEDITOR.event.useCapture) : this.$.attachEvent && this.$.attachEvent("on" + e, b)
                }
                return CKEDITOR.event.prototype.on.apply(this, arguments)
            },
            removeListener: function(a) {
                CKEDITOR.event.prototype.removeListener.apply(this, arguments);
                if (!this.hasListeners(a)) {
                    var b = this.getCustomData("_cke_nativeListeners"),
                        g = b && b[a];
                    if (g) {
                        this.$.removeEventListener ? this.$.removeEventListener(a, g, false) : this.$.detachEvent && this.$.detachEvent("on" +
                            a, g);
                        delete b[a]
                    }
                }
            },
            removeAllListeners: function() {
                var a = this.getCustomData("_cke_nativeListeners"),
                    b;
                for (b in a) {
                    var g = a[b];
                    this.$.detachEvent ? this.$.detachEvent("on" + b, g) : this.$.removeEventListener && this.$.removeEventListener(b, g, false);
                    delete a[b]
                }
                CKEDITOR.event.prototype.removeAllListeners.call(this)
            }
        }
    }(),
    function(a) {
        var e = {};
        CKEDITOR.on("reset", function() {
            e = {}
        });
        a.equals = function(a) {
            try {
                return a && a.$ === this.$
            } catch (g) {
                return false
            }
        };
        a.setCustomData = function(a, g) {
            var c = this.getUniqueId();
            (e[c] ||
                (e[c] = {}))[a] = g;
            return this
        };
        a.getCustomData = function(a) {
            var g = this.$["data-cke-expando"];
            return (g = g && e[g]) && a in g ? g[a] : null
        };
        a.removeCustomData = function(a) {
            var g = this.$["data-cke-expando"],
                g = g && e[g],
                c, d;
            if (g) {
                c = g[a];
                d = a in g;
                delete g[a]
            }
            return d ? c : null
        };
        a.clearCustomData = function() {
            this.removeAllListeners();
            var a = this.$["data-cke-expando"];
            a && delete e[a]
        };
        a.getUniqueId = function() {
            return this.$["data-cke-expando"] || (this.$["data-cke-expando"] = CKEDITOR.tools.getNextNumber())
        };
        CKEDITOR.event.implementOn(a)
    }(CKEDITOR.dom.domObject.prototype),
    CKEDITOR.dom.node = function(a) {
        return a ? new CKEDITOR.dom[a.nodeType == CKEDITOR.NODE_DOCUMENT ? "document" : a.nodeType == CKEDITOR.NODE_ELEMENT ? "element" : a.nodeType == CKEDITOR.NODE_TEXT ? "text" : a.nodeType == CKEDITOR.NODE_COMMENT ? "comment" : a.nodeType == CKEDITOR.NODE_DOCUMENT_FRAGMENT ? "documentFragment" : "domObject"](a) : this
    }, CKEDITOR.dom.node.prototype = new CKEDITOR.dom.domObject, CKEDITOR.NODE_ELEMENT = 1, CKEDITOR.NODE_DOCUMENT = 9, CKEDITOR.NODE_TEXT = 3, CKEDITOR.NODE_COMMENT = 8, CKEDITOR.NODE_DOCUMENT_FRAGMENT = 11, CKEDITOR.POSITION_IDENTICAL =
        0, CKEDITOR.POSITION_DISCONNECTED = 1, CKEDITOR.POSITION_FOLLOWING = 2, CKEDITOR.POSITION_PRECEDING = 4, CKEDITOR.POSITION_IS_CONTAINED = 8, CKEDITOR.POSITION_CONTAINS = 16, CKEDITOR.tools.extend(CKEDITOR.dom.node.prototype, {
            appendTo: function(a, e) {
                a.append(this, e);
                return a
            },
            clone: function(a, e) {
                var b = this.$.cloneNode(a),
                    g = function(c) {
                        c["data-cke-expando"] && (c["data-cke-expando"] = false);
                        if (c.nodeType == CKEDITOR.NODE_ELEMENT) {
                            e || c.removeAttribute("id", false);
                            if (a)
                                for (var c = c.childNodes, d = 0; d < c.length; d++) g(c[d])
                        }
                    };
                g(b);
                return new CKEDITOR.dom.node(b)
            },
            hasPrevious: function() {
                return !!this.$.previousSibling
            },
            hasNext: function() {
                return !!this.$.nextSibling
            },
            insertAfter: function(a) {
                a.$.parentNode.insertBefore(this.$, a.$.nextSibling);
                return a
            },
            insertBefore: function(a) {
                a.$.parentNode.insertBefore(this.$, a.$);
                return a
            },
            insertBeforeMe: function(a) {
                this.$.parentNode.insertBefore(a.$, this.$);
                return a
            },
            getAddress: function(a) {
                for (var e = [], b = this.getDocument().$.documentElement, g = this.$; g && g != b;) {
                    var c = g.parentNode;
                    c && e.unshift(this.getIndex.call({
                            $: g
                        },
                        a));
                    g = c
                }
                return e
            },
            getDocument: function() {
                return new CKEDITOR.dom.document(this.$.ownerDocument || this.$.parentNode.ownerDocument)
            },
            getIndex: function(a) {
                function e(a, c) {
                    var b = c ? a.nextSibling : a.previousSibling;
                    return !b || b.nodeType != CKEDITOR.NODE_TEXT ? null : b.nodeValue ? b : e(b, c)
                }
                var b = this.$,
                    g = -1,
                    c;
                if (!this.$.parentNode || a && b.nodeType == CKEDITOR.NODE_TEXT && !b.nodeValue && !e(b) && !e(b, true)) return -1;
                do
                    if (!a || !(b != this.$ && b.nodeType == CKEDITOR.NODE_TEXT && (c || !b.nodeValue))) {
                        g++;
                        c = b.nodeType == CKEDITOR.NODE_TEXT
                    } while (b =
                    b.previousSibling);
                return g
            },
            getNextSourceNode: function(a, e, b) {
                if (b && !b.call) var g = b,
                b = function(a) {
                    return !a.equals(g)
                };
                var a = !a && this.getFirst && this.getFirst(),
                    c;
                if (!a) {
                    if (this.type == CKEDITOR.NODE_ELEMENT && b && b(this, true) === false) return null;
                    a = this.getNext()
                }
                for (; !a && (c = (c || this).getParent());) {
                    if (b && b(c, true) === false) return null;
                    a = c.getNext()
                }
                return !a || b && b(a) === false ? null : e && e != a.type ? a.getNextSourceNode(false, e, b) : a
            },
            getPreviousSourceNode: function(a, e, b) {
                if (b && !b.call) var g = b,
                b = function(a) {
                    return !a.equals(g)
                };
                var a = !a && this.getLast && this.getLast(),
                    c;
                if (!a) {
                    if (this.type == CKEDITOR.NODE_ELEMENT && b && b(this, true) === false) return null;
                    a = this.getPrevious()
                }
                for (; !a && (c = (c || this).getParent());) {
                    if (b && b(c, true) === false) return null;
                    a = c.getPrevious()
                }
                return !a || b && b(a) === false ? null : e && a.type != e ? a.getPreviousSourceNode(false, e, b) : a
            },
            getPrevious: function(a) {
                var e = this.$,
                    b;
                do b = (e = e.previousSibling) && e.nodeType != 10 && new CKEDITOR.dom.node(e); while (b && a && !a(b));
                return b
            },
            getNext: function(a) {
                var e = this.$,
                    b;
                do b = (e = e.nextSibling) &&
                    new CKEDITOR.dom.node(e); while (b && a && !a(b));
                return b
            },
            getParent: function(a) {
                var e = this.$.parentNode;
                return e && (e.nodeType == CKEDITOR.NODE_ELEMENT || a && e.nodeType == CKEDITOR.NODE_DOCUMENT_FRAGMENT) ? new CKEDITOR.dom.node(e) : null
            },
            getParents: function(a) {
                var e = this,
                    b = [];
                do b[a ? "push" : "unshift"](e); while (e = e.getParent());
                return b
            },
            getCommonAncestor: function(a) {
                if (a.equals(this)) return this;
                if (a.contains && a.contains(this)) return a;
                var e = this.contains ? this : this.getParent();
                do
                    if (e.contains(a)) return e; while (e =
                    e.getParent());
                return null
            },
            getPosition: function(a) {
                var e = this.$,
                    b = a.$;
                if (e.compareDocumentPosition) return e.compareDocumentPosition(b);
                if (e == b) return CKEDITOR.POSITION_IDENTICAL;
                if (this.type == CKEDITOR.NODE_ELEMENT && a.type == CKEDITOR.NODE_ELEMENT) {
                    if (e.contains) {
                        if (e.contains(b)) return CKEDITOR.POSITION_CONTAINS + CKEDITOR.POSITION_PRECEDING;
                        if (b.contains(e)) return CKEDITOR.POSITION_IS_CONTAINED + CKEDITOR.POSITION_FOLLOWING
                    }
                    if ("sourceIndex" in e) return e.sourceIndex < 0 || b.sourceIndex < 0 ? CKEDITOR.POSITION_DISCONNECTED :
                        e.sourceIndex < b.sourceIndex ? CKEDITOR.POSITION_PRECEDING : CKEDITOR.POSITION_FOLLOWING
                }
                for (var e = this.getAddress(), a = a.getAddress(), b = Math.min(e.length, a.length), g = 0; g <= b - 1; g++)
                    if (e[g] != a[g]) {
                        if (g < b) return e[g] < a[g] ? CKEDITOR.POSITION_PRECEDING : CKEDITOR.POSITION_FOLLOWING;
                        break
                    }
                return e.length < a.length ? CKEDITOR.POSITION_CONTAINS + CKEDITOR.POSITION_PRECEDING : CKEDITOR.POSITION_IS_CONTAINED + CKEDITOR.POSITION_FOLLOWING
            },
            getAscendant: function(a, e) {
                var b = this.$,
                    g, c;
                if (!e) b = b.parentNode;
                if (typeof a == "function") {
                    c =
                        true;
                    g = a
                } else {
                    c = false;
                    g = function(c) {
                        c = typeof c.nodeName == "string" ? c.nodeName.toLowerCase() : "";
                        return typeof a == "string" ? c == a : c in a
                    }
                }
                for (; b;) {
                    if (g(c ? new CKEDITOR.dom.node(b) : b)) return new CKEDITOR.dom.node(b);
                    try {
                        b = b.parentNode
                    } catch (d) {
                        b = null
                    }
                }
                return null
            },
            hasAscendant: function(a, e) {
                var b = this.$;
                if (!e) b = b.parentNode;
                for (; b;) {
                    if (b.nodeName && b.nodeName.toLowerCase() == a) return true;
                    b = b.parentNode
                }
                return false
            },
            move: function(a, e) {
                a.append(this.remove(), e)
            },
            remove: function(a) {
                var e = this.$,
                    b = e.parentNode;
                if (b) {
                    if (a)
                        for (; a = e.firstChild;) b.insertBefore(e.removeChild(a), e);
                    b.removeChild(e)
                }
                return this
            },
            replace: function(a) {
                this.insertBefore(a);
                a.remove()
            },
            trim: function() {
                this.ltrim();
                this.rtrim()
            },
            ltrim: function() {
                for (var a; this.getFirst && (a = this.getFirst());) {
                    if (a.type == CKEDITOR.NODE_TEXT) {
                        var e = CKEDITOR.tools.ltrim(a.getText()),
                            b = a.getLength();
                        if (e) {
                            if (e.length < b) {
                                a.split(b - e.length);
                                this.$.removeChild(this.$.firstChild)
                            }
                        } else {
                            a.remove();
                            continue
                        }
                    }
                    break
                }
            },
            rtrim: function() {
                for (var a; this.getLast && (a =
                    this.getLast());) {
                    if (a.type == CKEDITOR.NODE_TEXT) {
                        var e = CKEDITOR.tools.rtrim(a.getText()),
                            b = a.getLength();
                        if (e) {
                            if (e.length < b) {
                                a.split(e.length);
                                this.$.lastChild.parentNode.removeChild(this.$.lastChild)
                            }
                        } else {
                            a.remove();
                            continue
                        }
                    }
                    break
                }
                if (CKEDITOR.env.needsBrFiller)(a = this.$.lastChild) && (a.type == 1 && a.nodeName.toLowerCase() == "br") && a.parentNode.removeChild(a)
            },
            isReadOnly: function() {
                var a = this;
                this.type != CKEDITOR.NODE_ELEMENT && (a = this.getParent());
                if (a && typeof a.$.isContentEditable != "undefined") return !(a.$.isContentEditable ||
                    a.data("cke-editable"));
                for (; a;) {
                    if (a.data("cke-editable")) break;
                    if (a.getAttribute("contentEditable") == "false") return true;
                    if (a.getAttribute("contentEditable") == "true") break;
                    a = a.getParent()
                }
                return !a
            }
        }), CKEDITOR.dom.window = function(a) {
            CKEDITOR.dom.domObject.call(this, a)
    }, CKEDITOR.dom.window.prototype = new CKEDITOR.dom.domObject, CKEDITOR.tools.extend(CKEDITOR.dom.window.prototype, {
        focus: function() {
            this.$.focus()
        },
        getViewPaneSize: function() {
            var a = this.$.document,
                e = a.compatMode == "CSS1Compat";
            return {
                width: (e ?
                    a.documentElement.clientWidth : a.body.clientWidth) || 0,
                height: (e ? a.documentElement.clientHeight : a.body.clientHeight) || 0
            }
        },
        getScrollPosition: function() {
            var a = this.$;
            if ("pageXOffset" in a) return {
                x: a.pageXOffset || 0,
                y: a.pageYOffset || 0
            };
            a = a.document;
            return {
                x: a.documentElement.scrollLeft || a.body.scrollLeft || 0,
                y: a.documentElement.scrollTop || a.body.scrollTop || 0
            }
        },
        getFrame: function() {
            var a = this.$.frameElement;
            return a ? new CKEDITOR.dom.element.get(a) : null
        }
    }), CKEDITOR.dom.document = function(a) {
        CKEDITOR.dom.domObject.call(this,
            a)
    }, CKEDITOR.dom.document.prototype = new CKEDITOR.dom.domObject, CKEDITOR.tools.extend(CKEDITOR.dom.document.prototype, {
        type: CKEDITOR.NODE_DOCUMENT,
        appendStyleSheet: function(a) {
            if (this.$.createStyleSheet) this.$.createStyleSheet(a);
            else {
                var e = new CKEDITOR.dom.element("link");
                e.setAttributes({
                    rel: "stylesheet",
                    type: "text/css",
                    href: a
                });
                this.getHead().append(e)
            }
        },
        appendStyleText: function(a) {
            if (this.$.createStyleSheet) {
                var e = this.$.createStyleSheet("");
                e.cssText = a
            } else {
                var b = new CKEDITOR.dom.element("style",
                    this);
                b.append(new CKEDITOR.dom.text(a, this));
                this.getHead().append(b)
            }
            return e || b.$.sheet
        },
        createElement: function(a, e) {
            var b = new CKEDITOR.dom.element(a, this);
            if (e) {
                e.attributes && b.setAttributes(e.attributes);
                e.styles && b.setStyles(e.styles)
            }
            return b
        },
        createText: function(a) {
            return new CKEDITOR.dom.text(a, this)
        },
        focus: function() {
            this.getWindow().focus()
        },
        getActive: function() {
            var a;
            try {
                a = this.$.activeElement
            } catch (e) {
                return null
            }
            return new CKEDITOR.dom.element(a)
        },
        getById: function(a) {
            return (a = this.$.getElementById(a)) ?
                new CKEDITOR.dom.element(a) : null
        },
        getByAddress: function(a, e) {
            for (var b = this.$.documentElement, g = 0; b && g < a.length; g++) {
                var c = a[g];
                if (e)
                    for (var d = -1, j = 0; j < b.childNodes.length; j++) {
                        var f = b.childNodes[j];
                        if (!(e === true && f.nodeType == 3 && f.previousSibling && f.previousSibling.nodeType == 3)) {
                            d++;
                            if (d == c) {
                                b = f;
                                break
                            }
                        }
                    } else b = b.childNodes[c]
            }
            return b ? new CKEDITOR.dom.node(b) : null
        },
        getElementsByTag: function(a, e) {
            !(CKEDITOR.env.ie && document.documentMode <= 8) && e && (a = e + ":" + a);
            return new CKEDITOR.dom.nodeList(this.$.getElementsByTagName(a))
        },
        getHead: function() {
            var a = this.$.getElementsByTagName("head")[0];
            return a = a ? new CKEDITOR.dom.element(a) : this.getDocumentElement().append(new CKEDITOR.dom.element("head"), true)
        },
        getBody: function() {
            return new CKEDITOR.dom.element(this.$.body)
        },
        getDocumentElement: function() {
            return new CKEDITOR.dom.element(this.$.documentElement)
        },
        getWindow: function() {
            return new CKEDITOR.dom.window(this.$.parentWindow || this.$.defaultView)
        },
        write: function(a) {
            this.$.open("text/html", "replace");
            CKEDITOR.env.ie && (a = a.replace(/(?:^\s*<!DOCTYPE[^>]*?>)|^/i,
                '$&\n<script data-cke-temp="1">(' + CKEDITOR.tools.fixDomain + ")();<\/script>"));
            this.$.write(a);
            this.$.close()
        },
        find: function(a) {
            return new CKEDITOR.dom.nodeList(this.$.querySelectorAll(a))
        },
        findOne: function(a) {
            return (a = this.$.querySelector(a)) ? new CKEDITOR.dom.element(a) : null
        },
        _getHtml5ShivFrag: function() {
            var a = this.getCustomData("html5ShivFrag");
            if (!a) {
                a = this.$.createDocumentFragment();
                CKEDITOR.tools.enableHtml5Elements(a, true);
                this.setCustomData("html5ShivFrag", a)
            }
            return a
        }
    }), CKEDITOR.dom.nodeList =
        function(a) {
            this.$ = a
    }, CKEDITOR.dom.nodeList.prototype = {
        count: function() {
            return this.$.length
        },
        getItem: function(a) {
            if (a < 0 || a >= this.$.length) return null;
            return (a = this.$[a]) ? new CKEDITOR.dom.node(a) : null
        }
    }, CKEDITOR.dom.element = function(a, e) {
        typeof a == "string" && (a = (e ? e.$ : document).createElement(a));
        CKEDITOR.dom.domObject.call(this, a)
    }, CKEDITOR.dom.element.get = function(a) {
        return (a = typeof a == "string" ? document.getElementById(a) || document.getElementsByName(a)[0] : a) && (a.$ ? a : new CKEDITOR.dom.element(a))
    }, CKEDITOR.dom.element.prototype =
        new CKEDITOR.dom.node, CKEDITOR.dom.element.createFromHtml = function(a, e) {
            var b = new CKEDITOR.dom.element("div", e);
            b.setHtml(a);
            return b.getFirst().remove()
    }, CKEDITOR.dom.element.setMarker = function(a, e, b, g) {
        var c = e.getCustomData("list_marker_id") || e.setCustomData("list_marker_id", CKEDITOR.tools.getNextNumber()).getCustomData("list_marker_id"),
            d = e.getCustomData("list_marker_names") || e.setCustomData("list_marker_names", {}).getCustomData("list_marker_names");
        a[c] = e;
        d[b] = 1;
        return e.setCustomData(b, g)
    }, CKEDITOR.dom.element.clearAllMarkers =
        function(a) {
            for (var e in a) CKEDITOR.dom.element.clearMarkers(a, a[e], 1)
    }, CKEDITOR.dom.element.clearMarkers = function(a, e, b) {
        var g = e.getCustomData("list_marker_names"),
            c = e.getCustomData("list_marker_id"),
            d;
        for (d in g) e.removeCustomData(d);
        e.removeCustomData("list_marker_names");
        if (b) {
            e.removeCustomData("list_marker_id");
            delete a[c]
        }
    },
    function() {
        function a(a) {
            var d = true;
            if (!a.$.id) {
                a.$.id = "cke_tmp_" + CKEDITOR.tools.getNextNumber();
                d = false
            }
            return function() {
                d || a.removeAttribute("id")
            }
        }

        function e(a, d) {
            return "#" +
                a.$.id + " " + d.split(/,\s*/).join(", #" + a.$.id + " ")
        }

        function b(a) {
            for (var d = 0, b = 0, f = g[a].length; b < f; b++) d = d + (parseInt(this.getComputedStyle(g[a][b]) || 0, 10) || 0);
            return d
        }
        CKEDITOR.tools.extend(CKEDITOR.dom.element.prototype, {
            type: CKEDITOR.NODE_ELEMENT,
            addClass: function(a) {
                var d = this.$.className;
                d && (RegExp("(?:^|\\s)" + a + "(?:\\s|$)", "").test(d) || (d = d + (" " + a)));
                this.$.className = d || a;
                return this
            },
            removeClass: function(a) {
                var d = this.getAttribute("class");
                if (d) {
                    a = RegExp("(?:^|\\s+)" + a + "(?=\\s|$)", "i");
                    if (a.test(d))(d =
                        d.replace(a, "").replace(/^\s+/, "")) ? this.setAttribute("class", d) : this.removeAttribute("class")
                }
                return this
            },
            hasClass: function(a) {
                return RegExp("(?:^|\\s+)" + a + "(?=\\s|$)", "").test(this.getAttribute("class"))
            },
            append: function(a, d) {
                typeof a == "string" && (a = this.getDocument().createElement(a));
                d ? this.$.insertBefore(a.$, this.$.firstChild) : this.$.appendChild(a.$);
                return a
            },
            appendHtml: function(a) {
                if (this.$.childNodes.length) {
                    var d = new CKEDITOR.dom.element("div", this.getDocument());
                    d.setHtml(a);
                    d.moveChildren(this)
                } else this.setHtml(a)
            },
            appendText: function(a) {
                this.$.text != null ? this.$.text = this.$.text + a : this.append(new CKEDITOR.dom.text(a))
            },
            appendBogus: function(a) {
                if (a || CKEDITOR.env.needsBrFiller) {
                    for (a = this.getLast(); a && a.type == CKEDITOR.NODE_TEXT && !CKEDITOR.tools.rtrim(a.getText());) a = a.getPrevious();
                    if (!a || !a.is || !a.is("br")) {
                        a = this.getDocument().createElement("br");
                        CKEDITOR.env.gecko && a.setAttribute("type", "_moz");
                        this.append(a)
                    }
                }
            },
            breakParent: function(a) {
                var d = new CKEDITOR.dom.range(this.getDocument());
                d.setStartAfter(this);
                d.setEndAfter(a);
                a = d.extractContents();
                d.insertNode(this.remove());
                a.insertAfterNode(this)
            },
            contains: CKEDITOR.env.ie || CKEDITOR.env.webkit ? function(a) {
                var d = this.$;
                return a.type != CKEDITOR.NODE_ELEMENT ? d.contains(a.getParent().$) : d != a.$ && d.contains(a.$)
            } : function(a) {
                return !!(this.$.compareDocumentPosition(a.$) & 16)
            },
            focus: function() {
                function a() {
                    try {
                        this.$.focus()
                    } catch (c) {}
                }
                return function(d) {
                    d ? CKEDITOR.tools.setTimeout(a, 100, this) : a.call(this)
                }
            }(),
            getHtml: function() {
                var a = this.$.innerHTML;
                return CKEDITOR.env.ie ?
                    a.replace(/<\?[^>]*>/g, "") : a
            },
            getOuterHtml: function() {
                if (this.$.outerHTML) return this.$.outerHTML.replace(/<\?[^>]*>/, "");
                var a = this.$.ownerDocument.createElement("div");
                a.appendChild(this.$.cloneNode(true));
                return a.innerHTML
            },
            getClientRect: function() {
                var a = CKEDITOR.tools.extend({}, this.$.getBoundingClientRect());
                !a.width && (a.width = a.right - a.left);
                !a.height && (a.height = a.bottom - a.top);
                return a
            },
            setHtml: CKEDITOR.env.ie && CKEDITOR.env.version < 9 ? function(a) {
                try {
                    var d = this.$;
                    if (this.getParent()) return d.innerHTML =
                        a;
                    var b = this.getDocument()._getHtml5ShivFrag();
                    b.appendChild(d);
                    d.innerHTML = a;
                    b.removeChild(d);
                    return a
                } catch (f) {
                    this.$.innerHTML = "";
                    d = new CKEDITOR.dom.element("body", this.getDocument());
                    d.$.innerHTML = a;
                    for (d = d.getChildren(); d.count();) this.append(d.getItem(0));
                    return a
                }
            } : function(a) {
                return this.$.innerHTML = a
            },
            setText: function() {
                var a = document.createElement("p");
                a.innerHTML = "x";
                a = a.textContent;
                return function(d) {
                    this.$[a ? "textContent" : "innerText"] = d
                }
            }(),
            getAttribute: function() {
                var a = function(a) {
                    return this.$.getAttribute(a,
                        2)
                };
                return CKEDITOR.env.ie && (CKEDITOR.env.ie7Compat || CKEDITOR.env.quirks) ? function(a) {
                    switch (a) {
                        case "class":
                            a = "className";
                            break;
                        case "http-equiv":
                            a = "httpEquiv";
                            break;
                        case "name":
                            return this.$.name;
                        case "tabindex":
                            a = this.$.getAttribute(a, 2);
                            a !== 0 && this.$.tabIndex === 0 && (a = null);
                            return a;
                        case "checked":
                            a = this.$.attributes.getNamedItem(a);
                            return (a.specified ? a.nodeValue : this.$.checked) ? "checked" : null;
                        case "hspace":
                        case "value":
                            return this.$[a];
                        case "style":
                            return this.$.style.cssText;
                        case "contenteditable":
                        case "contentEditable":
                            return this.$.attributes.getNamedItem("contentEditable").specified ?
                                this.$.getAttribute("contentEditable") : null
                    }
                    return this.$.getAttribute(a, 2)
                } : a
            }(),
            getChildren: function() {
                return new CKEDITOR.dom.nodeList(this.$.childNodes)
            },
            getComputedStyle: CKEDITOR.env.ie ? function(a) {
                return this.$.currentStyle[CKEDITOR.tools.cssStyleToDomStyle(a)]
            } : function(a) {
                var d = this.getWindow().$.getComputedStyle(this.$, null);
                return d ? d.getPropertyValue(a) : ""
            },
            getDtd: function() {
                var a = CKEDITOR.dtd[this.getName()];
                this.getDtd = function() {
                    return a
                };
                return a
            },
            getElementsByTag: CKEDITOR.dom.document.prototype.getElementsByTag,
            getTabIndex: CKEDITOR.env.ie ? function() {
                var a = this.$.tabIndex;
                a === 0 && (!CKEDITOR.dtd.$tabIndex[this.getName()] && parseInt(this.getAttribute("tabindex"), 10) !== 0) && (a = -1);
                return a
            } : CKEDITOR.env.webkit ? function() {
                var a = this.$.tabIndex;
                if (a === void 0) {
                    a = parseInt(this.getAttribute("tabindex"), 10);
                    isNaN(a) && (a = -1)
                }
                return a
            } : function() {
                return this.$.tabIndex
            },
            getText: function() {
                return this.$.textContent || this.$.innerText || ""
            },
            getWindow: function() {
                return this.getDocument().getWindow()
            },
            getId: function() {
                return this.$.id ||
                    null
            },
            getNameAtt: function() {
                return this.$.name || null
            },
            getName: function() {
                var a = this.$.nodeName.toLowerCase();
                if (CKEDITOR.env.ie && document.documentMode <= 8) {
                    var d = this.$.scopeName;
                    d != "HTML" && (a = d.toLowerCase() + ":" + a)
                }
                this.getName = function() {
                    return a
                };
                return this.getName()
            },
            getValue: function() {
                return this.$.value
            },
            getFirst: function(a) {
                var d = this.$.firstChild;
                (d = d && new CKEDITOR.dom.node(d)) && (a && !a(d)) && (d = d.getNext(a));
                return d
            },
            getLast: function(a) {
                var d = this.$.lastChild;
                (d = d && new CKEDITOR.dom.node(d)) &&
                    (a && !a(d)) && (d = d.getPrevious(a));
                return d
            },
            getStyle: function(a) {
                return this.$.style[CKEDITOR.tools.cssStyleToDomStyle(a)]
            },
            is: function() {
                var a = this.getName();
                if (typeof arguments[0] == "object") return !!arguments[0][a];
                for (var d = 0; d < arguments.length; d++)
                    if (arguments[d] == a) return true;
                return false
            },
            isEditable: function(a) {
                var d = this.getName();
                if (this.isReadOnly() || this.getComputedStyle("display") == "none" || this.getComputedStyle("visibility") == "hidden" || CKEDITOR.dtd.$nonEditable[d] || CKEDITOR.dtd.$empty[d] ||
                    this.is("a") && (this.data("cke-saved-name") || this.hasAttribute("name")) && !this.getChildCount()) return false;
                if (a !== false) {
                    a = CKEDITOR.dtd[d] || CKEDITOR.dtd.span;
                    return !(!a || !a["#"])
                }
                return true
            },
            isIdentical: function(a) {
                var d = this.clone(0, 1),
                    a = a.clone(0, 1);
                d.removeAttributes(["_moz_dirty", "data-cke-expando", "data-cke-saved-href", "data-cke-saved-name"]);
                a.removeAttributes(["_moz_dirty", "data-cke-expando", "data-cke-saved-href", "data-cke-saved-name"]);
                if (d.$.isEqualNode) {
                    d.$.style.cssText = CKEDITOR.tools.normalizeCssText(d.$.style.cssText);
                    a.$.style.cssText = CKEDITOR.tools.normalizeCssText(a.$.style.cssText);
                    return d.$.isEqualNode(a.$)
                }
                d = d.getOuterHtml();
                a = a.getOuterHtml();
                if (CKEDITOR.env.ie && CKEDITOR.env.version < 9 && this.is("a")) {
                    var b = this.getParent();
                    if (b.type == CKEDITOR.NODE_ELEMENT) {
                        b = b.clone();
                        b.setHtml(d);
                        d = b.getHtml();
                        b.setHtml(a);
                        a = b.getHtml()
                    }
                }
                return d == a
            },
            isVisible: function() {
                var a = (this.$.offsetHeight || this.$.offsetWidth) && this.getComputedStyle("visibility") != "hidden",
                    d, b;
                if (a && CKEDITOR.env.webkit) {
                    d = this.getWindow();
                    if (!d.equals(CKEDITOR.document.getWindow()) &&
                        (b = d.$.frameElement)) a = (new CKEDITOR.dom.element(b)).isVisible()
                }
                return !!a
            },
            isEmptyInlineRemoveable: function() {
                if (!CKEDITOR.dtd.$removeEmpty[this.getName()]) return false;
                for (var a = this.getChildren(), d = 0, b = a.count(); d < b; d++) {
                    var f = a.getItem(d);
                    if (!(f.type == CKEDITOR.NODE_ELEMENT && f.data("cke-bookmark")) && (f.type == CKEDITOR.NODE_ELEMENT && !f.isEmptyInlineRemoveable() || f.type == CKEDITOR.NODE_TEXT && CKEDITOR.tools.trim(f.getText()))) return false
                }
                return true
            },
            hasAttributes: CKEDITOR.env.ie && (CKEDITOR.env.ie7Compat ||
                CKEDITOR.env.quirks) ? function() {
                for (var a = this.$.attributes, d = 0; d < a.length; d++) {
                    var b = a[d];
                    switch (b.nodeName) {
                        case "class":
                            if (this.getAttribute("class")) return true;
                        case "data-cke-expando":
                            continue;
                        default:
                            if (b.specified) return true
                    }
                }
                return false
            } : function() {
                var a = this.$.attributes,
                    d = a.length,
                    b = {
                        "data-cke-expando": 1,
                        _moz_dirty: 1
                    };
                return d > 0 && (d > 2 || !b[a[0].nodeName] || d == 2 && !b[a[1].nodeName])
            },
            hasAttribute: function() {
                function a(c) {
                    var b = this.$.attributes.getNamedItem(c);
                    if (this.getName() == "input") switch (c) {
                        case "class":
                            return this.$.className.length >
                                0;
                        case "checked":
                            return !!this.$.checked;
                        case "value":
                            c = this.getAttribute("type");
                            return c == "checkbox" || c == "radio" ? this.$.value != "on" : !! this.$.value
                    }
                    return !b ? false : b.specified
                }
                return CKEDITOR.env.ie ? CKEDITOR.env.version < 8 ? function(d) {
                    return d == "name" ? !! this.$.name : a.call(this, d)
                } : a : function(a) {
                    return !!this.$.attributes.getNamedItem(a)
                }
            }(),
            hide: function() {
                this.removeClass('cke_show')
                this.addClass('cke_hide')
            },
            moveChildren: function(a, d) {
                var b = this.$,
                    a = a.$;
                if (b != a) {
                    var f;
                    if (d)
                        for (; f = b.lastChild;) a.insertBefore(b.removeChild(f),
                            a.firstChild);
                    else
                        for (; f = b.firstChild;) a.appendChild(b.removeChild(f))
                }
            },
            mergeSiblings: function() {
                function a(c, b, f) {
                    if (b && b.type == CKEDITOR.NODE_ELEMENT) {
                        for (var g = []; b.data("cke-bookmark") || b.isEmptyInlineRemoveable();) {
                            g.push(b);
                            b = f ? b.getNext() : b.getPrevious();
                            if (!b || b.type != CKEDITOR.NODE_ELEMENT) return
                        }
                        if (c.isIdentical(b)) {
                            for (var e = f ? c.getLast() : c.getFirst(); g.length;) g.shift().move(c, !f);
                            b.moveChildren(c, !f);
                            b.remove();
                            e && e.type == CKEDITOR.NODE_ELEMENT && e.mergeSiblings()
                        }
                    }
                }
                return function(d) {
                    if (d ===
                        false || CKEDITOR.dtd.$removeEmpty[this.getName()] || this.is("a")) {
                        a(this, this.getNext(), true);
                        a(this, this.getPrevious())
                    }
                }
            }(),
            show: function() {
                this.removeClass('cke_hide')
                this.addClass('cke_show')
            },
            setAttribute: function() {
                var a = function(a, c) {
                    this.$.setAttribute(a, c);
                    return this
                };
                return CKEDITOR.env.ie && (CKEDITOR.env.ie7Compat || CKEDITOR.env.quirks) ? function(d, b) {
                    d == "class" ? this.$.className = b : d == "style" ? this.$.style.cssText = b : d == "tabindex" ? this.$.tabIndex = b : d == "checked" ? this.$.checked = b : d == "contenteditable" ? a.call(this,
                        "contentEditable", b) : a.apply(this, arguments);
                    return this
                } : CKEDITOR.env.ie8Compat && CKEDITOR.env.secure ? function(b, g) {
                    if (b == "src" && g.match(/^http:\/\//)) try {
                        a.apply(this, arguments)
                    } catch (f) {} else a.apply(this, arguments);
                    return this
                } : a
            }(),
            setAttributes: function(a) {
                for (var b in a) this.setAttribute(b, a[b]);
                return this
            },
            setValue: function(a) {
                this.$.value = a;
                return this
            },
            removeAttribute: function() {
                var a = function(a) {
                    this.$.removeAttribute(a)
                };
                return CKEDITOR.env.ie && (CKEDITOR.env.ie7Compat || CKEDITOR.env.quirks) ?
                    function(a) {
                        a == "class" ? a = "className" : a == "tabindex" ? a = "tabIndex" : a == "contenteditable" && (a = "contentEditable");
                        this.$.removeAttribute(a)
                } : a
            }(),
            removeAttributes: function(a) {
                if (CKEDITOR.tools.isArray(a))
                    for (var b = 0; b < a.length; b++) this.removeAttribute(a[b]);
                else
                    for (b in a) a.hasOwnProperty(b) && this.removeAttribute(b)
            },
            removeStyle: function(a) {
                var b = this.$.style;
                if (!b.removeProperty && (a == "border" || a == "margin" || a == "padding")) {
                    var g = ["top", "left", "right", "bottom"],
                        f;
                    a == "border" && (f = ["color", "style", "width"]);
                    for (var b = [], h = 0; h < g.length; h++)
                        if (f)
                            for (var e = 0; e < f.length; e++) b.push([a, g[h], f[e]].join("-"));
                        else b.push([a, g[h]].join("-"));
                    for (a = 0; a < b.length; a++) this.removeStyle(b[a])
                } else {
                    b.removeProperty ? b.removeProperty(a) : b.removeAttribute(CKEDITOR.tools.cssStyleToDomStyle(a));
                    this.$.style.cssText || this.removeAttribute("style")
                }
            },
            setStyle: function(a, b) {
                this.$.style[CKEDITOR.tools.cssStyleToDomStyle(a)] = b;
                return this
            },
            setStyles: function(a) {
                for (var b in a) this.setStyle(b, a[b]);
                return this
            },
            setOpacity: function(a) {
                if (CKEDITOR.env.ie &&
                    CKEDITOR.env.version < 9) {
                    a = Math.round(a * 100);
                    this.setStyle("filter", a >= 100 ? "" : "progid:DXImageTransform.Microsoft.Alpha(opacity=" + a + ")")
                } else this.setStyle("opacity", a)
            },
            unselectable: function() {
                this.setStyles(CKEDITOR.tools.cssVendorPrefix("user-select", "none"));
                if (CKEDITOR.env.ie) {
                    this.setAttribute("unselectable", "on");
                    for (var a, b = this.getElementsByTag("*"), g = 0, f = b.count(); g < f; g++) {
                        a = b.getItem(g);
                        a.setAttribute("unselectable", "on")
                    }
                }
            },
            getPositionedAncestor: function() {
                for (var a = this; a.getName() != "html";) {
                    if (a.getComputedStyle("position") !=
                        "static") return a;
                    a = a.getParent()
                }
                return null
            },
            getDocumentPosition: function(a) {
                var b = 0,
                    g = 0,
                    f = this.getDocument(),
                    h = f.getBody(),
                    e = CKEDITOR.env.quirks;
                if (document.documentElement.getBoundingClientRect) {
                    var k = this.$.getBoundingClientRect(),
                        n = f.$.documentElement,
                        o = n.clientTop || h.$.clientTop || 0,
                        q = n.clientLeft || h.$.clientLeft || 0,
                        m = true;
                    if (CKEDITOR.env.ie) {
                        m = f.getDocumentElement().contains(this);
                        f = f.getBody().contains(this);
                        m = e && f || !e && m
                    }
                    if (m) {
                        if (CKEDITOR.env.webkit) {
                            b = h.$.scrollLeft || n.scrollLeft;
                            g = h.$.scrollTop ||
                                n.scrollTop
                        } else {
                            g = e ? h.$ : n;
                            b = g.scrollLeft;
                            g = g.scrollTop
                        }
                        b = k.left + b - q;
                        g = k.top + g - o
                    }
                } else {
                    o = this;
                    for (q = null; o && !(o.getName() == "body" || o.getName() == "html");) {
                        b = b + (o.$.offsetLeft - o.$.scrollLeft);
                        g = g + (o.$.offsetTop - o.$.scrollTop);
                        if (!o.equals(this)) {
                            b = b + (o.$.clientLeft || 0);
                            g = g + (o.$.clientTop || 0)
                        }
                        for (; q && !q.equals(o);) {
                            b = b - q.$.scrollLeft;
                            g = g - q.$.scrollTop;
                            q = q.getParent()
                        }
                        q = o;
                        o = (k = o.$.offsetParent) ? new CKEDITOR.dom.element(k) : null
                    }
                } if (a) {
                    k = this.getWindow();
                    o = a.getWindow();
                    if (!k.equals(o) && k.$.frameElement) {
                        a =
                            (new CKEDITOR.dom.element(k.$.frameElement)).getDocumentPosition(a);
                        b = b + a.x;
                        g = g + a.y
                    }
                }
                if (!document.documentElement.getBoundingClientRect && CKEDITOR.env.gecko && !e) {
                    b = b + (this.$.clientLeft ? 1 : 0);
                    g = g + (this.$.clientTop ? 1 : 0)
                }
                return {
                    x: b,
                    y: g
                }
            },
            scrollIntoView: function(a) {
                var b = this.getParent();
                if (b) {
                    do {
                        (b.$.clientWidth && b.$.clientWidth < b.$.scrollWidth || b.$.clientHeight && b.$.clientHeight < b.$.scrollHeight) && !b.is("body") && this.scrollIntoParent(b, a, 1);
                        if (b.is("html")) {
                            var g = b.getWindow();
                            try {
                                var f = g.$.frameElement;
                                f && (b = new CKEDITOR.dom.element(f))
                            } catch (h) {}
                        }
                    } while (b = b.getParent())
                }
            },
            scrollIntoParent: function(a, b, g) {
                var f, h, e, k;

                function n(b, d) {
                    if (/body|html/.test(a.getName())) a.getWindow().$.scrollBy(b, d);
                    else {
                        a.$.scrollLeft = a.$.scrollLeft + b;
                        a.$.scrollTop = a.$.scrollTop + d
                    }
                }

                function o(a, b) {
                    var c = {
                        x: 0,
                        y: 0
                    };
                    if (!a.is(m ? "body" : "html")) {
                        var d = a.$.getBoundingClientRect();
                        c.x = d.left;
                        c.y = d.top
                    }
                    d = a.getWindow();
                    if (!d.equals(b)) {
                        d = o(CKEDITOR.dom.element.get(d.$.frameElement), b);
                        c.x = c.x + d.x;
                        c.y = c.y + d.y
                    }
                    return c
                }

                function q(a,
                    b) {
                    return parseInt(a.getComputedStyle("margin-" + b) || 0, 10) || 0
                }!a && (a = this.getWindow());
                e = a.getDocument();
                var m = e.$.compatMode == "BackCompat";
                a instanceof CKEDITOR.dom.window && (a = m ? e.getBody() : e.getDocumentElement());
                e = a.getWindow();
                h = o(this, e);
                var l = o(a, e),
                    p = this.$.offsetHeight;
                f = this.$.offsetWidth;
                var t = a.$.clientHeight,
                    s = a.$.clientWidth;
                e = h.x - q(this, "left") - l.x || 0;
                k = h.y - q(this, "top") - l.y || 0;
                f = h.x + f + q(this, "right") - (l.x + s) || 0;
                h = h.y + p + q(this, "bottom") - (l.y + t) || 0;
                if (k < 0 || h > 0) n(0, b === true ? k : b === false ?
                    h : k < 0 ? k : h);
                if (g && (e < 0 || f > 0)) n(e < 0 ? e : f, 0)
            },
            setState: function(a, b, g) {
                b = b || "cke";
                switch (a) {
                    case CKEDITOR.TRISTATE_ON:
                        this.addClass(b + "_on");
                        this.removeClass(b + "_off");
                        this.removeClass(b + "_disabled");
                        g && this.setAttribute("aria-pressed", true);
                        g && this.removeAttribute("aria-disabled");
                        break;
                    case CKEDITOR.TRISTATE_DISABLED:
                        this.addClass(b + "_disabled");
                        this.removeClass(b + "_off");
                        this.removeClass(b + "_on");
                        g && this.setAttribute("aria-disabled", true);
                        g && this.removeAttribute("aria-pressed");
                        break;
                    default:
                        this.addClass(b +
                            "_off");
                        this.removeClass(b + "_on");
                        this.removeClass(b + "_disabled");
                        g && this.removeAttribute("aria-pressed");
                        g && this.removeAttribute("aria-disabled")
                }
            },
            getFrameDocument: function() {
                var a = this.$;
                try {
                    a.contentWindow.document
                } catch (b) {
                    a.src = a.src
                }
                return a && new CKEDITOR.dom.document(a.contentWindow.document)
            },
            copyAttributes: function(a, b) {
                for (var g = this.$.attributes, b = b || {}, f = 0; f < g.length; f++) {
                    var h = g[f],
                        e = h.nodeName.toLowerCase(),
                        k;
                    if (!(e in b))
                        if (e == "checked" && (k = this.getAttribute(e))) a.setAttribute(e, k);
                        else if (!CKEDITOR.env.ie || this.hasAttribute(e)) {
                        k = this.getAttribute(e);
                        if (k === null) k = h.nodeValue;
                        a.setAttribute(e, k)
                    }
                }
                if (this.$.style.cssText !== "") a.$.style.cssText = this.$.style.cssText
            },
            renameNode: function(a) {
                if (this.getName() != a) {
                    var b = this.getDocument(),
                        a = new CKEDITOR.dom.element(a, b);
                    this.copyAttributes(a);
                    this.moveChildren(a);
                    this.getParent() && this.$.parentNode.replaceChild(a.$, this.$);
                    a.$["data-cke-expando"] = this.$["data-cke-expando"];
                    this.$ = a.$;
                    delete this.getName
                }
            },
            getChild: function() {
                function a(b,
                    c) {
                    var f = b.childNodes;
                    if (c >= 0 && c < f.length) return f[c]
                }
                return function(b) {
                    var g = this.$;
                    if (b.slice)
                        for (; b.length > 0 && g;) g = a(g, b.shift());
                    else g = a(g, b);
                    return g ? new CKEDITOR.dom.node(g) : null
                }
            }(),
            getChildCount: function() {
                return this.$.childNodes.length
            },
            disableContextMenu: function() {
                this.on("contextmenu", function(a) {
                    a.data.getTarget().hasClass("cke_enable_context_menu") || a.data.preventDefault()
                })
            },
            getDirection: function(a) {
                return a ? this.getComputedStyle("direction") || this.getDirection() || this.getParent() &&
                    this.getParent().getDirection(1) || this.getDocument().$.dir || "ltr" : this.getStyle("direction") || this.getAttribute("dir")
            },
            data: function(a, b) {
                a = "data-" + a;
                if (b === void 0) return this.getAttribute(a);
                b === false ? this.removeAttribute(a) : this.setAttribute(a, b);
                return null
            },
            getEditor: function() {
                var a = CKEDITOR.instances,
                    b, g;
                for (b in a) {
                    g = a[b];
                    if (g.element.equals(this) && g.elementMode != CKEDITOR.ELEMENT_MODE_APPENDTO) return g
                }
                return null
            },
            find: function(b) {
                var d = a(this),
                    b = new CKEDITOR.dom.nodeList(this.$.querySelectorAll(e(this,
                        b)));
                d();
                return b
            },
            findOne: function(b) {
                var d = a(this),
                    b = this.$.querySelector(e(this, b));
                d();
                return b ? new CKEDITOR.dom.element(b) : null
            },
            forEach: function(a, b, g) {
                if (!g && (!b || this.type == b)) var f = a(this);
                if (f !== false)
                    for (var g = this.getChildren(), h = 0; h < g.count(); h++) {
                        f = g.getItem(h);
                        f.type == CKEDITOR.NODE_ELEMENT ? f.forEach(a, b) : (!b || f.type == b) && a(f)
                    }
            }
        });
        var g = {
            width: ["border-left-width", "border-right-width", "padding-left", "padding-right"],
            height: ["border-top-width", "border-bottom-width", "padding-top", "padding-bottom"]
        };
        CKEDITOR.dom.element.prototype.setSize = function(a, d, g) {
            if (typeof d == "number") {
                if (g && (!CKEDITOR.env.ie || !CKEDITOR.env.quirks)) d = d - b.call(this, a);
                this.setStyle(a, d + "px")
            }
        };
        CKEDITOR.dom.element.prototype.getSize = function(a, d) {
            var g = Math.max(this.$["offset" + CKEDITOR.tools.capitalize(a)], this.$["client" + CKEDITOR.tools.capitalize(a)]) || 0;
            d && (g = g - b.call(this, a));
            return g
        }
    }(), CKEDITOR.dom.documentFragment = function(a) {
        a = a || CKEDITOR.document;
        this.$ = a.type == CKEDITOR.NODE_DOCUMENT ? a.$.createDocumentFragment() :
            a
    }, CKEDITOR.tools.extend(CKEDITOR.dom.documentFragment.prototype, CKEDITOR.dom.element.prototype, {
        type: CKEDITOR.NODE_DOCUMENT_FRAGMENT,
        insertAfterNode: function(a) {
            a = a.$;
            a.parentNode.insertBefore(this.$, a.nextSibling)
        }
    }, !0, {
        append: 1,
        appendBogus: 1,
        getFirst: 1,
        getLast: 1,
        getParent: 1,
        getNext: 1,
        getPrevious: 1,
        appendTo: 1,
        moveChildren: 1,
        insertBefore: 1,
        insertAfterNode: 1,
        replace: 1,
        trim: 1,
        type: 1,
        ltrim: 1,
        rtrim: 1,
        getDocument: 1,
        getChildCount: 1,
        getChild: 1,
        getChildren: 1
    }),
    function() {
        function a(a, b) {
            var c = this.range;
            if (this._.end) return null;
            if (!this._.start) {
                this._.start = 1;
                if (c.collapsed) {
                    this.end();
                    return null
                }
                c.optimize()
            }
            var d, f = c.startContainer;
            d = c.endContainer;
            var g = c.startOffset,
                k = c.endOffset,
                h, e = this.guard,
                j = this.type,
                i = a ? "getPreviousSourceNode" : "getNextSourceNode";
            if (!a && !this._.guardLTR) {
                var v = d.type == CKEDITOR.NODE_ELEMENT ? d : d.getParent(),
                    r = d.type == CKEDITOR.NODE_ELEMENT ? d.getChild(k) : d.getNext();
                this._.guardLTR = function(a, b) {
                    return (!b || !v.equals(a)) && (!r || !a.equals(r)) && (a.type != CKEDITOR.NODE_ELEMENT || !b || !a.equals(c.root))
                }
            }
            if (a && !this._.guardRTL) {
                var y = f.type == CKEDITOR.NODE_ELEMENT ? f : f.getParent(),
                    z = f.type == CKEDITOR.NODE_ELEMENT ? g ? f.getChild(g - 1) : null : f.getPrevious();
                this._.guardRTL = function(a, b) {
                    return (!b || !y.equals(a)) && (!z || !a.equals(z)) && (a.type != CKEDITOR.NODE_ELEMENT || !b || !a.equals(c.root))
                }
            }
            var B = a ? this._.guardRTL : this._.guardLTR;
            h = e ? function(a, b) {
                return B(a, b) === false ? false : e(a, b)
            } : B;
            if (this.current) d = this.current[i](false, j, h);
            else {
                if (a) d.type == CKEDITOR.NODE_ELEMENT && (d = k > 0 ? d.getChild(k -
                    1) : h(d, true) === false ? null : d.getPreviousSourceNode(true, j, h));
                else {
                    d = f;
                    if (d.type == CKEDITOR.NODE_ELEMENT && !(d = d.getChild(g))) d = h(f, true) === false ? null : f.getNextSourceNode(true, j, h)
                }
                d && h(d) === false && (d = null)
            }
            for (; d && !this._.end;) {
                this.current = d;
                if (!this.evaluator || this.evaluator(d) !== false) {
                    if (!b) return d
                } else if (b && this.evaluator) return false;
                d = d[i](false, j, h)
            }
            this.end();
            return this.current = null
        }

        function e(b) {
            for (var c, d = null; c = a.call(this, b);) d = c;
            return d
        }

        function b(a) {
            if (i(a)) return false;
            if (a.type ==
                CKEDITOR.NODE_TEXT) return true;
            if (a.type == CKEDITOR.NODE_ELEMENT) {
                if (a.is(CKEDITOR.dtd.$inline) || a.is("hr") || a.getAttribute("contenteditable") == "false") return true;
                var b;
                if (b = !CKEDITOR.env.needsBrFiller)
                    if (b = a.is(k)) a: {
                        b = 0;
                        for (var c = a.getChildCount(); b < c; ++b)
                            if (!i(a.getChild(b))) {
                                b = false;
                                break a
                            }
                        b = true
                    }
                    if (b) return true
            }
            return false
        }
        CKEDITOR.dom.walker = CKEDITOR.tools.createClass({
            $: function(a) {
                this.range = a;
                this._ = {}
            },
            proto: {
                end: function() {
                    this._.end = 1
                },
                next: function() {
                    return a.call(this)
                },
                previous: function() {
                    return a.call(this,
                        1)
                },
                checkForward: function() {
                    return a.call(this, 0, 1) !== false
                },
                checkBackward: function() {
                    return a.call(this, 1, 1) !== false
                },
                lastForward: function() {
                    return e.call(this)
                },
                lastBackward: function() {
                    return e.call(this, 1)
                },
                reset: function() {
                    delete this.current;
                    this._ = {}
                }
            }
        });
        var g = {
            block: 1,
            "list-item": 1,
            table: 1,
            "table-row-group": 1,
            "table-header-group": 1,
            "table-footer-group": 1,
            "table-row": 1,
            "table-column-group": 1,
            "table-column": 1,
            "table-cell": 1,
            "table-caption": 1
        }, c = {
                absolute: 1,
                fixed: 1
            };
        CKEDITOR.dom.element.prototype.isBlockBoundary =
            function(a) {
                return this.getComputedStyle("float") == "none" && !(this.getComputedStyle("position") in c) && g[this.getComputedStyle("display")] ? true : !! (this.is(CKEDITOR.dtd.$block) || a && this.is(a))
        };
        CKEDITOR.dom.walker.blockBoundary = function(a) {
            return function(b) {
                return !(b.type == CKEDITOR.NODE_ELEMENT && b.isBlockBoundary(a))
            }
        };
        CKEDITOR.dom.walker.listItemBoundary = function() {
            return this.blockBoundary({
                br: 1
            })
        };
        CKEDITOR.dom.walker.bookmark = function(a, b) {
            function c(a) {
                return a && a.getName && a.getName() == "span" &&
                    a.data("cke-bookmark")
            }
            return function(d) {
                var f, g;
                f = d && d.type != CKEDITOR.NODE_ELEMENT && (g = d.getParent()) && c(g);
                f = a ? f : f || c(d);
                return !!(b ^ f)
            }
        };
        CKEDITOR.dom.walker.whitespaces = function(a) {
            return function(b) {
                var c;
                b && b.type == CKEDITOR.NODE_TEXT && (c = !CKEDITOR.tools.trim(b.getText()) || CKEDITOR.env.webkit && b.getText() == "​");
                return !!(a ^ c)
            }
        };
        CKEDITOR.dom.walker.invisible = function(a) {
            var b = CKEDITOR.dom.walker.whitespaces(),
                c = CKEDITOR.env.webkit ? 1 : 0;
            return function(d) {
                if (b(d)) d = 1;
                else {
                    d.type == CKEDITOR.NODE_TEXT &&
                        (d = d.getParent());
                    d = d.$.offsetWidth <= c
                }
                return !!(a ^ d)
            }
        };
        CKEDITOR.dom.walker.nodeType = function(a, b) {
            return function(c) {
                return !!(b ^ c.type == a)
            }
        };
        CKEDITOR.dom.walker.bogus = function(a) {
            function b(a) {
                return !j(a) && !f(a)
            }
            return function(c) {
                var f = CKEDITOR.env.needsBrFiller ? c.is && c.is("br") : c.getText && d.test(c.getText());
                if (f) {
                    f = c.getParent();
                    c = c.getNext(b);
                    f = f.isBlockBoundary() && (!c || c.type == CKEDITOR.NODE_ELEMENT && c.isBlockBoundary())
                }
                return !!(a ^ f)
            }
        };
        CKEDITOR.dom.walker.temp = function(a) {
            return function(b) {
                b.type !=
                    CKEDITOR.NODE_ELEMENT && (b = b.getParent());
                b = b && b.hasAttribute("data-cke-temp");
                return !!(a ^ b)
            }
        };
        var d = /^[\t\r\n ]*(?:&nbsp;|\xa0)$/,
            j = CKEDITOR.dom.walker.whitespaces(),
            f = CKEDITOR.dom.walker.bookmark(),
            h = CKEDITOR.dom.walker.temp();
        CKEDITOR.dom.walker.ignored = function(a) {
            return function(b) {
                b = j(b) || f(b) || h(b);
                return !!(a ^ b)
            }
        };
        var i = CKEDITOR.dom.walker.ignored(),
            k = function(a) {
                var b = {}, c;
                for (c in a) CKEDITOR.dtd[c]["#"] && (b[c] = 1);
                return b
            }(CKEDITOR.dtd.$block);
        CKEDITOR.dom.walker.editable = function(a) {
            return function(c) {
                return !!(a ^
                    b(c))
            }
        };
        CKEDITOR.dom.element.prototype.getBogus = function() {
            var a = this;
            do a = a.getPreviousSourceNode(); while (f(a) || j(a) || a.type == CKEDITOR.NODE_ELEMENT && a.is(CKEDITOR.dtd.$inline) && !a.is(CKEDITOR.dtd.$empty));
            return a && (CKEDITOR.env.needsBrFiller ? a.is && a.is("br") : a.getText && d.test(a.getText())) ? a : false
        }
    }(), CKEDITOR.dom.range = function(a) {
        this.endOffset = this.endContainer = this.startOffset = this.startContainer = null;
        this.collapsed = true;
        var e = a instanceof CKEDITOR.dom.document;
        this.document = e ? a : a.getDocument();
        this.root = e ? a.getBody() : a
    },
    function() {
        function a() {
            var a = false,
                b = CKEDITOR.dom.walker.whitespaces(),
                c = CKEDITOR.dom.walker.bookmark(true),
                f = CKEDITOR.dom.walker.bogus();
            return function(g) {
                if (c(g) || b(g)) return true;
                if (f(g) && !a) return a = true;
                return g.type == CKEDITOR.NODE_TEXT && (g.hasAscendant("pre") || CKEDITOR.tools.trim(g.getText()).length) || g.type == CKEDITOR.NODE_ELEMENT && !g.is(d) ? false : true
            }
        }

        function e(a) {
            var b = CKEDITOR.dom.walker.whitespaces(),
                c = CKEDITOR.dom.walker.bookmark(1);
            return function(d) {
                return c(d) ||
                    b(d) ? true : !a && j(d) || d.type == CKEDITOR.NODE_ELEMENT && d.is(CKEDITOR.dtd.$removeEmpty)
            }
        }

        function b(a) {
            return function() {
                var b;
                return this[a ? "getPreviousNode" : "getNextNode"](function(a) {
                    !b && i(a) && (b = a);
                    return h(a) && !(j(a) && a.equals(b))
                })
            }
        }
        var g = function(a) {
            a.collapsed = a.startContainer && a.endContainer && a.startContainer.equals(a.endContainer) && a.startOffset == a.endOffset
        }, c = function(a, b, c, d) {
                a.optimizeBookmark();
                var f = a.startContainer,
                    g = a.endContainer,
                    h = a.startOffset,
                    e = a.endOffset,
                    j, i;
                if (g.type == CKEDITOR.NODE_TEXT) g =
                    g.split(e);
                else if (g.getChildCount() > 0)
                    if (e >= g.getChildCount()) {
                        g = g.append(a.document.createText(""));
                        i = true
                    } else g = g.getChild(e);
                if (f.type == CKEDITOR.NODE_TEXT) {
                    f.split(h);
                    f.equals(g) && (g = f.getNext())
                } else if (h)
                    if (h >= f.getChildCount()) {
                        f = f.append(a.document.createText(""));
                        j = true
                    } else f = f.getChild(h).getPrevious();
                    else {
                        f = f.append(a.document.createText(""), 1);
                        j = true
                    }
                var h = f.getParents(),
                    e = g.getParents(),
                    w, x, v;
                for (w = 0; w < h.length; w++) {
                    x = h[w];
                    v = e[w];
                    if (!x.equals(v)) break
                }
                for (var r = c, y, z, B, A = w; A < h.length; A++) {
                    y =
                        h[A];
                    r && !y.equals(f) && (z = r.append(y.clone()));
                    for (y = y.getNext(); y;) {
                        if (y.equals(e[A]) || y.equals(g)) break;
                        B = y.getNext();
                        if (b == 2) r.append(y.clone(true));
                        else {
                            y.remove();
                            b == 1 && r.append(y)
                        }
                        y = B
                    }
                    r && (r = z)
                }
                r = c;
                for (c = w; c < e.length; c++) {
                    y = e[c];
                    b > 0 && !y.equals(g) && (z = r.append(y.clone()));
                    if (!h[c] || y.$.parentNode != h[c].$.parentNode)
                        for (y = y.getPrevious(); y;) {
                            if (y.equals(h[c]) || y.equals(f)) break;
                            B = y.getPrevious();
                            if (b == 2) r.$.insertBefore(y.$.cloneNode(true), r.$.firstChild);
                            else {
                                y.remove();
                                b == 1 && r.$.insertBefore(y.$,
                                    r.$.firstChild)
                            }
                            y = B
                        }
                    r && (r = z)
                }
                if (b == 2) {
                    x = a.startContainer;
                    if (x.type == CKEDITOR.NODE_TEXT) {
                        x.$.data = x.$.data + x.$.nextSibling.data;
                        x.$.parentNode.removeChild(x.$.nextSibling)
                    }
                    a = a.endContainer;
                    if (a.type == CKEDITOR.NODE_TEXT && a.$.nextSibling) {
                        a.$.data = a.$.data + a.$.nextSibling.data;
                        a.$.parentNode.removeChild(a.$.nextSibling)
                    }
                } else {
                    if (x && v && (f.$.parentNode != x.$.parentNode || g.$.parentNode != v.$.parentNode)) {
                        b = v.getIndex();
                        j && v.$.parentNode == f.$.parentNode && b--;
                        if (d && x.type == CKEDITOR.NODE_ELEMENT) {
                            d = CKEDITOR.dom.element.createFromHtml('<span data-cke-bookmark="1" style="display:none">&nbsp;</span>',
                                a.document);
                            d.insertAfter(x);
                            x.mergeSiblings(false);
                            a.moveToBookmark({
                                startNode: d
                            })
                        } else a.setStart(v.getParent(), b)
                    }
                    a.collapse(true)
                }
                j && f.remove();
                i && g.$.parentNode && g.remove()
            }, d = {
                abbr: 1,
                acronym: 1,
                b: 1,
                bdo: 1,
                big: 1,
                cite: 1,
                code: 1,
                del: 1,
                dfn: 1,
                em: 1,
                font: 1,
                i: 1,
                ins: 1,
                label: 1,
                kbd: 1,
                q: 1,
                samp: 1,
                small: 1,
                span: 1,
                strike: 1,
                strong: 1,
                sub: 1,
                sup: 1,
                tt: 1,
                u: 1,
                "var": 1
            }, j = CKEDITOR.dom.walker.bogus(),
            f = /^[\t\r\n ]*(?:&nbsp;|\xa0)$/,
            h = CKEDITOR.dom.walker.editable(),
            i = CKEDITOR.dom.walker.ignored(true);
        CKEDITOR.dom.range.prototype = {
            clone: function() {
                var a = new CKEDITOR.dom.range(this.root);
                a._setStartContainer(this.startContainer);
                a.startOffset = this.startOffset;
                a._setEndContainer(this.endContainer);
                a.endOffset = this.endOffset;
                a.collapsed = this.collapsed;
                return a
            },
            collapse: function(a) {
                if (a) {
                    this._setEndContainer(this.startContainer);
                    this.endOffset = this.startOffset
                } else {
                    this._setStartContainer(this.endContainer);
                    this.startOffset = this.endOffset
                }
                this.collapsed = true
            },
            cloneContents: function() {
                var a = new CKEDITOR.dom.documentFragment(this.document);
                this.collapsed || c(this, 2, a);
                return a
            },
            deleteContents: function(a) {
                this.collapsed || c(this, 0, null, a)
            },
            extractContents: function(a) {
                var b = new CKEDITOR.dom.documentFragment(this.document);
                this.collapsed || c(this, 1, b, a);
                return b
            },
            createBookmark: function(a) {
                var b, c, d, f, g = this.collapsed;
                b = this.document.createElement("span");
                b.data("cke-bookmark", 1);
                b.setStyle("display", "none");
                b.setHtml("&nbsp;");
                if (a) {
                    d = "cke_bm_" + CKEDITOR.tools.getNextNumber();
                    b.setAttribute("id", d + (g ? "C" : "S"))
                }
                if (!g) {
                    c = b.clone();
                    c.setHtml("&nbsp;");
                    a && c.setAttribute("id", d + "E");
                    f = this.clone();
                    f.collapse();
                    f.insertNode(c)
                }
                f = this.clone();
                f.collapse(true);
                f.insertNode(b);
                if (c) {
                    this.setStartAfter(b);
                    this.setEndBefore(c)
                } else this.moveToPosition(b, CKEDITOR.POSITION_AFTER_END);
                return {
                    startNode: a ? d + (g ? "C" : "S") : b,
                    endNode: a ? d + "E" : c,
                    serializable: a,
                    collapsed: g
                }
            },
            createBookmark2: function() {
                function a(c) {
                    var d = c.container,
                        f = c.offset,
                        g;
                    g = d;
                    var h = f;
                    g = g.type != CKEDITOR.NODE_ELEMENT || h === 0 || h == g.getChildCount() ? 0 : g.getChild(h - 1).type == CKEDITOR.NODE_TEXT && g.getChild(h).type ==
                        CKEDITOR.NODE_TEXT;
                    if (g) {
                        d = d.getChild(f - 1);
                        f = d.getLength()
                    }
                    d.type == CKEDITOR.NODE_ELEMENT && f > 1 && (f = d.getChild(f - 1).getIndex(true) + 1);
                    if (d.type == CKEDITOR.NODE_TEXT) {
                        g = d;
                        for (h = 0;
                            (g = g.getPrevious()) && g.type == CKEDITOR.NODE_TEXT;) h = h + g.getLength();
                        g = h;
                        if (d.getText()) f = f + g;
                        else {
                            h = d.getPrevious(b);
                            if (g) {
                                f = g;
                                d = h ? h.getNext() : d.getParent().getFirst()
                            } else {
                                d = d.getParent();
                                f = h ? h.getIndex(true) + 1 : 0
                            }
                        }
                    }
                    c.container = d;
                    c.offset = f
                }
                var b = CKEDITOR.dom.walker.nodeType(CKEDITOR.NODE_TEXT, true);
                return function(b) {
                    var c = this.collapsed,
                        d = {
                            container: this.startContainer,
                            offset: this.startOffset
                        }, f = {
                            container: this.endContainer,
                            offset: this.endOffset
                        };
                    if (b) {
                        a(d);
                        c || a(f)
                    }
                    return {
                        start: d.container.getAddress(b),
                        end: c ? null : f.container.getAddress(b),
                        startOffset: d.offset,
                        endOffset: f.offset,
                        normalized: b,
                        collapsed: c,
                        is2: true
                    }
                }
            }(),
            moveToBookmark: function(a) {
                if (a.is2) {
                    var b = this.document.getByAddress(a.start, a.normalized),
                        c = a.startOffset,
                        d = a.end && this.document.getByAddress(a.end, a.normalized),
                        a = a.endOffset;
                    this.setStart(b, c);
                    d ? this.setEnd(d, a) :
                        this.collapse(true)
                } else {
                    b = (c = a.serializable) ? this.document.getById(a.startNode) : a.startNode;
                    a = c ? this.document.getById(a.endNode) : a.endNode;
                    this.setStartBefore(b);
                    b.remove();
                    if (a) {
                        this.setEndBefore(a);
                        a.remove()
                    } else this.collapse(true)
                }
            },
            getBoundaryNodes: function() {
                var a = this.startContainer,
                    b = this.endContainer,
                    c = this.startOffset,
                    d = this.endOffset,
                    f;
                if (a.type == CKEDITOR.NODE_ELEMENT) {
                    f = a.getChildCount();
                    if (f > c) a = a.getChild(c);
                    else if (f < 1) a = a.getPreviousSourceNode();
                    else {
                        for (a = a.$; a.lastChild;) a = a.lastChild;
                        a = new CKEDITOR.dom.node(a);
                        a = a.getNextSourceNode() || a
                    }
                }
                if (b.type == CKEDITOR.NODE_ELEMENT) {
                    f = b.getChildCount();
                    if (f > d) b = b.getChild(d).getPreviousSourceNode(true);
                    else if (f < 1) b = b.getPreviousSourceNode();
                    else {
                        for (b = b.$; b.lastChild;) b = b.lastChild;
                        b = new CKEDITOR.dom.node(b)
                    }
                }
                a.getPosition(b) & CKEDITOR.POSITION_FOLLOWING && (a = b);
                return {
                    startNode: a,
                    endNode: b
                }
            },
            getCommonAncestor: function(a, b) {
                var c = this.startContainer,
                    d = this.endContainer,
                    c = c.equals(d) ? a && c.type == CKEDITOR.NODE_ELEMENT && this.startOffset == this.endOffset -
                        1 ? c.getChild(this.startOffset) : c : c.getCommonAncestor(d);
                return b && !c.is ? c.getParent() : c
            },
            optimize: function() {
                var a = this.startContainer,
                    b = this.startOffset;
                a.type != CKEDITOR.NODE_ELEMENT && (b ? b >= a.getLength() && this.setStartAfter(a) : this.setStartBefore(a));
                a = this.endContainer;
                b = this.endOffset;
                a.type != CKEDITOR.NODE_ELEMENT && (b ? b >= a.getLength() && this.setEndAfter(a) : this.setEndBefore(a))
            },
            optimizeBookmark: function() {
                var a = this.startContainer,
                    b = this.endContainer;
                a.is && (a.is("span") && a.data("cke-bookmark")) &&
                    this.setStartAt(a, CKEDITOR.POSITION_BEFORE_START);
                b && (b.is && b.is("span") && b.data("cke-bookmark")) && this.setEndAt(b, CKEDITOR.POSITION_AFTER_END)
            },
            trim: function(a, b) {
                var c = this.startContainer,
                    d = this.startOffset,
                    f = this.collapsed;
                if ((!a || f) && c && c.type == CKEDITOR.NODE_TEXT) {
                    if (d)
                        if (d >= c.getLength()) {
                            d = c.getIndex() + 1;
                            c = c.getParent()
                        } else {
                            var g = c.split(d),
                                d = c.getIndex() + 1,
                                c = c.getParent();
                            if (this.startContainer.equals(this.endContainer)) this.setEnd(g, this.endOffset - this.startOffset);
                            else if (c.equals(this.endContainer)) this.endOffset =
                                this.endOffset + 1
                        } else {
                            d = c.getIndex();
                            c = c.getParent()
                        }
                    this.setStart(c, d);
                    if (f) {
                        this.collapse(true);
                        return
                    }
                }
                c = this.endContainer;
                d = this.endOffset;
                if (!b && !f && c && c.type == CKEDITOR.NODE_TEXT) {
                    if (d) {
                        d >= c.getLength() || c.split(d);
                        d = c.getIndex() + 1
                    } else d = c.getIndex();
                    c = c.getParent();
                    this.setEnd(c, d)
                }
            },
            enlarge: function(a, b) {
                function c(a) {
                    return a && a.type == CKEDITOR.NODE_ELEMENT && a.hasAttribute("contenteditable") ? null : a
                }
                var d = RegExp(/[^\s\ufeff]/);
                switch (a) {
                    case CKEDITOR.ENLARGE_INLINE:
                        var f = 1;
                    case CKEDITOR.ENLARGE_ELEMENT:
                        if (this.collapsed) break;
                        var g = this.getCommonAncestor(),
                            h = this.root,
                            e, j, i, w, x, v = false,
                            r, y;
                        r = this.startContainer;
                        var z = this.startOffset;
                        if (r.type == CKEDITOR.NODE_TEXT) {
                            if (z) {
                                r = !CKEDITOR.tools.trim(r.substring(0, z)).length && r;
                                v = !! r
                            }
                            if (r && !(w = r.getPrevious())) i = r.getParent()
                        } else {
                            z && (w = r.getChild(z - 1) || r.getLast());
                            w || (i = r)
                        }
                        for (i = c(i); i || w;) {
                            if (i && !w) {
                                !x && i.equals(g) && (x = true);
                                if (f ? i.isBlockBoundary() : !h.contains(i)) break;
                                if (!v || i.getComputedStyle("display") != "inline") {
                                    v = false;
                                    x ? e = i : this.setStartBefore(i)
                                }
                                w = i.getPrevious()
                            }
                            for (; w;) {
                                r =
                                    false;
                                if (w.type == CKEDITOR.NODE_COMMENT) w = w.getPrevious();
                                else {
                                    if (w.type == CKEDITOR.NODE_TEXT) {
                                        y = w.getText();
                                        d.test(y) && (w = null);
                                        r = /[\s\ufeff]$/.test(y)
                                    } else if ((w.$.offsetWidth > (CKEDITOR.env.webkit ? 1 : 0) || b && w.is("br")) && !w.data("cke-bookmark"))
                                        if (v && CKEDITOR.dtd.$removeEmpty[w.getName()]) {
                                            y = w.getText();
                                            if (d.test(y)) w = null;
                                            else
                                                for (var z = w.$.getElementsByTagName("*"), B = 0, A; A = z[B++];)
                                                    if (!CKEDITOR.dtd.$removeEmpty[A.nodeName.toLowerCase()]) {
                                                        w = null;
                                                        break
                                                    } w && (r = !! y.length)
                                        } else w = null;
                                    r && (v ? x ? e = i : i && this.setStartBefore(i) :
                                        v = true);
                                    if (w) {
                                        r = w.getPrevious();
                                        if (!i && !r) {
                                            i = w;
                                            w = null;
                                            break
                                        }
                                        w = r
                                    } else i = null
                                }
                            }
                            i && (i = c(i.getParent()))
                        }
                        r = this.endContainer;
                        z = this.endOffset;
                        i = w = null;
                        x = v = false;
                        var G = function(a, b) {
                            var c = new CKEDITOR.dom.range(h);
                            c.setStart(a, b);
                            c.setEndAt(h, CKEDITOR.POSITION_BEFORE_END);
                            var c = new CKEDITOR.dom.walker(c),
                                f;
                            for (c.guard = function(a) {
                                return !(a.type == CKEDITOR.NODE_ELEMENT && a.isBlockBoundary())
                            }; f = c.next();) {
                                if (f.type != CKEDITOR.NODE_TEXT) return false;
                                y = f != a ? f.getText() : f.substring(b);
                                if (d.test(y)) return false
                            }
                            return true
                        };
                        if (r.type == CKEDITOR.NODE_TEXT)
                            if (CKEDITOR.tools.trim(r.substring(z)).length) v = true;
                            else {
                                v = !r.getLength();
                                if (z == r.getLength()) {
                                    if (!(w = r.getNext())) i = r.getParent()
                                } else G(r, z) && (i = r.getParent())
                            } else(w = r.getChild(z)) || (i = r);
                        for (; i || w;) {
                            if (i && !w) {
                                !x && i.equals(g) && (x = true);
                                if (f ? i.isBlockBoundary() : !h.contains(i)) break;
                                if (!v || i.getComputedStyle("display") != "inline") {
                                    v = false;
                                    x ? j = i : i && this.setEndAfter(i)
                                }
                                w = i.getNext()
                            }
                            for (; w;) {
                                r = false;
                                if (w.type == CKEDITOR.NODE_TEXT) {
                                    y = w.getText();
                                    G(w, 0) || (w = null);
                                    r = /^[\s\ufeff]/.test(y)
                                } else if (w.type ==
                                    CKEDITOR.NODE_ELEMENT) {
                                    if ((w.$.offsetWidth > 0 || b && w.is("br")) && !w.data("cke-bookmark"))
                                        if (v && CKEDITOR.dtd.$removeEmpty[w.getName()]) {
                                            y = w.getText();
                                            if (d.test(y)) w = null;
                                            else {
                                                z = w.$.getElementsByTagName("*");
                                                for (B = 0; A = z[B++];)
                                                    if (!CKEDITOR.dtd.$removeEmpty[A.nodeName.toLowerCase()]) {
                                                        w = null;
                                                        break
                                                    }
                                            }
                                            w && (r = !! y.length)
                                        } else w = null
                                } else r = 1;
                                r && v && (x ? j = i : this.setEndAfter(i));
                                if (w) {
                                    r = w.getNext();
                                    if (!i && !r) {
                                        i = w;
                                        w = null;
                                        break
                                    }
                                    w = r
                                } else i = null
                            }
                            i && (i = c(i.getParent()))
                        }
                        if (e && j) {
                            g = e.contains(j) ? j : e;
                            this.setStartBefore(g);
                            this.setEndAfter(g)
                        }
                        break;
                    case CKEDITOR.ENLARGE_BLOCK_CONTENTS:
                    case CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS:
                        i = new CKEDITOR.dom.range(this.root);
                        h = this.root;
                        i.setStartAt(h, CKEDITOR.POSITION_AFTER_START);
                        i.setEnd(this.startContainer, this.startOffset);
                        i = new CKEDITOR.dom.walker(i);
                        var D, J, C = CKEDITOR.dom.walker.blockBoundary(a == CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS ? {
                                br: 1
                            } : null),
                            F = null,
                            E = function(a) {
                                if (a.type == CKEDITOR.NODE_ELEMENT && a.getAttribute("contenteditable") == "false")
                                    if (F) {
                                        if (F.equals(a)) {
                                            F = null;
                                            return
                                        }
                                    } else F =
                                        a;
                                    else if (F) return;
                                var b = C(a);
                                b || (D = a);
                                return b
                            }, f = function(a) {
                                var b = E(a);
                                !b && (a.is && a.is("br")) && (J = a);
                                return b
                            };
                        i.guard = E;
                        i = i.lastBackward();
                        D = D || h;
                        this.setStartAt(D, !D.is("br") && (!i && this.checkStartOfBlock() || i && D.contains(i)) ? CKEDITOR.POSITION_AFTER_START : CKEDITOR.POSITION_AFTER_END);
                        if (a == CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS) {
                            i = this.clone();
                            i = new CKEDITOR.dom.walker(i);
                            var I = CKEDITOR.dom.walker.whitespaces(),
                                L = CKEDITOR.dom.walker.bookmark();
                            i.evaluator = function(a) {
                                return !I(a) && !L(a)
                            };
                            if ((i = i.previous()) &&
                                i.type == CKEDITOR.NODE_ELEMENT && i.is("br")) break
                        }
                        i = this.clone();
                        i.collapse();
                        i.setEndAt(h, CKEDITOR.POSITION_BEFORE_END);
                        i = new CKEDITOR.dom.walker(i);
                        i.guard = a == CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS ? f : E;
                        D = F = J = null;
                        i = i.lastForward();
                        D = D || h;
                        this.setEndAt(D, !i && this.checkEndOfBlock() || i && D.contains(i) ? CKEDITOR.POSITION_BEFORE_END : CKEDITOR.POSITION_BEFORE_START);
                        J && this.setEndAfter(J)
                }
            },
            shrink: function(a, b, c) {
                if (!this.collapsed) {
                    var a = a || CKEDITOR.SHRINK_TEXT,
                        d = this.clone(),
                        f = this.startContainer,
                        g = this.endContainer,
                        h = this.startOffset,
                        e = this.endOffset,
                        i = 1,
                        j = 1;
                    if (f && f.type == CKEDITOR.NODE_TEXT)
                        if (h)
                            if (h >= f.getLength()) d.setStartAfter(f);
                            else {
                                d.setStartBefore(f);
                                i = 0
                            } else d.setStartBefore(f);
                    if (g && g.type == CKEDITOR.NODE_TEXT)
                        if (e)
                            if (e >= g.getLength()) d.setEndAfter(g);
                            else {
                                d.setEndAfter(g);
                                j = 0
                            } else d.setEndBefore(g);
                    var d = new CKEDITOR.dom.walker(d),
                        w = CKEDITOR.dom.walker.bookmark();
                    d.evaluator = function(b) {
                        return b.type == (a == CKEDITOR.SHRINK_ELEMENT ? CKEDITOR.NODE_ELEMENT : CKEDITOR.NODE_TEXT)
                    };
                    var x;
                    d.guard = function(b, d) {
                        if (w(b)) return true;
                        if (a == CKEDITOR.SHRINK_ELEMENT && b.type == CKEDITOR.NODE_TEXT || d && b.equals(x) || c === false && b.type == CKEDITOR.NODE_ELEMENT && b.isBlockBoundary() || b.type == CKEDITOR.NODE_ELEMENT && b.hasAttribute("contenteditable")) return false;
                        !d && b.type == CKEDITOR.NODE_ELEMENT && (x = b);
                        return true
                    };
                    if (i)(f = d[a == CKEDITOR.SHRINK_ELEMENT ? "lastForward" : "next"]()) && this.setStartAt(f, b ? CKEDITOR.POSITION_AFTER_START : CKEDITOR.POSITION_BEFORE_START);
                    if (j) {
                        d.reset();
                        (d = d[a == CKEDITOR.SHRINK_ELEMENT ? "lastBackward" : "previous"]()) && this.setEndAt(d,
                            b ? CKEDITOR.POSITION_BEFORE_END : CKEDITOR.POSITION_AFTER_END)
                    }
                    return !(!i && !j)
                }
            },
            insertNode: function(a) {
                this.optimizeBookmark();
                this.trim(false, true);
                var b = this.startContainer,
                    c = b.getChild(this.startOffset);
                c ? a.insertBefore(c) : b.append(a);
                a.getParent() && a.getParent().equals(this.endContainer) && this.endOffset++;
                this.setStartBefore(a)
            },
            moveToPosition: function(a, b) {
                this.setStartAt(a, b);
                this.collapse(true)
            },
            moveToRange: function(a) {
                this.setStart(a.startContainer, a.startOffset);
                this.setEnd(a.endContainer,
                    a.endOffset)
            },
            selectNodeContents: function(a) {
                this.setStart(a, 0);
                this.setEnd(a, a.type == CKEDITOR.NODE_TEXT ? a.getLength() : a.getChildCount())
            },
            setStart: function(a, b) {
                if (a.type == CKEDITOR.NODE_ELEMENT && CKEDITOR.dtd.$empty[a.getName()]) {
                    b = a.getIndex();
                    a = a.getParent()
                }
                this._setStartContainer(a);
                this.startOffset = b;
                if (!this.endContainer) {
                    this._setEndContainer(a);
                    this.endOffset = b
                }
                g(this)
            },
            setEnd: function(a, b) {
                if (a.type == CKEDITOR.NODE_ELEMENT && CKEDITOR.dtd.$empty[a.getName()]) {
                    b = a.getIndex() + 1;
                    a = a.getParent()
                }
                this._setEndContainer(a);
                this.endOffset = b;
                if (!this.startContainer) {
                    this._setStartContainer(a);
                    this.startOffset = b
                }
                g(this)
            },
            setStartAfter: function(a) {
                this.setStart(a.getParent(), a.getIndex() + 1)
            },
            setStartBefore: function(a) {
                this.setStart(a.getParent(), a.getIndex())
            },
            setEndAfter: function(a) {
                this.setEnd(a.getParent(), a.getIndex() + 1)
            },
            setEndBefore: function(a) {
                this.setEnd(a.getParent(), a.getIndex())
            },
            setStartAt: function(a, b) {
                switch (b) {
                    case CKEDITOR.POSITION_AFTER_START:
                        this.setStart(a, 0);
                        break;
                    case CKEDITOR.POSITION_BEFORE_END:
                        a.type ==
                            CKEDITOR.NODE_TEXT ? this.setStart(a, a.getLength()) : this.setStart(a, a.getChildCount());
                        break;
                    case CKEDITOR.POSITION_BEFORE_START:
                        this.setStartBefore(a);
                        break;
                    case CKEDITOR.POSITION_AFTER_END:
                        this.setStartAfter(a)
                }
                g(this)
            },
            setEndAt: function(a, b) {
                switch (b) {
                    case CKEDITOR.POSITION_AFTER_START:
                        this.setEnd(a, 0);
                        break;
                    case CKEDITOR.POSITION_BEFORE_END:
                        a.type == CKEDITOR.NODE_TEXT ? this.setEnd(a, a.getLength()) : this.setEnd(a, a.getChildCount());
                        break;
                    case CKEDITOR.POSITION_BEFORE_START:
                        this.setEndBefore(a);
                        break;
                    case CKEDITOR.POSITION_AFTER_END:
                        this.setEndAfter(a)
                }
                g(this)
            },
            fixBlock: function(a, b) {
                var c = this.createBookmark(),
                    d = this.document.createElement(b);
                this.collapse(a);
                this.enlarge(CKEDITOR.ENLARGE_BLOCK_CONTENTS);
                this.extractContents().appendTo(d);
                d.trim();
                d.appendBogus();
                this.insertNode(d);
                this.moveToBookmark(c);
                return d
            },
            splitBlock: function(a) {
                var b = new CKEDITOR.dom.elementPath(this.startContainer, this.root),
                    c = new CKEDITOR.dom.elementPath(this.endContainer, this.root),
                    d = b.block,
                    f = c.block,
                    g = null;
                if (!b.blockLimit.equals(c.blockLimit)) return null;
                if (a != "br") {
                    if (!d) {
                        d = this.fixBlock(true, a);
                        f = (new CKEDITOR.dom.elementPath(this.endContainer, this.root)).block
                    }
                    f || (f = this.fixBlock(false, a))
                }
                a = d && this.checkStartOfBlock();
                b = f && this.checkEndOfBlock();
                this.deleteContents();
                if (d && d.equals(f))
                    if (b) {
                        g = new CKEDITOR.dom.elementPath(this.startContainer, this.root);
                        this.moveToPosition(f, CKEDITOR.POSITION_AFTER_END);
                        f = null
                    } else if (a) {
                    g = new CKEDITOR.dom.elementPath(this.startContainer, this.root);
                    this.moveToPosition(d, CKEDITOR.POSITION_BEFORE_START);
                    d = null
                } else {
                    f =
                        this.splitElement(d);
                    d.is("ul", "ol") || d.appendBogus()
                }
                return {
                    previousBlock: d,
                    nextBlock: f,
                    wasStartOfBlock: a,
                    wasEndOfBlock: b,
                    elementPath: g
                }
            },
            splitElement: function(a) {
                if (!this.collapsed) return null;
                this.setEndAt(a, CKEDITOR.POSITION_BEFORE_END);
                var b = this.extractContents(),
                    c = a.clone(false);
                b.appendTo(c);
                c.insertAfter(a);
                this.moveToPosition(a, CKEDITOR.POSITION_AFTER_END);
                return c
            },
            removeEmptyBlocksAtEnd: function() {
                function a(d) {
                    return function(a) {
                        return b(a) || (c(a) || a.type == CKEDITOR.NODE_ELEMENT && a.isEmptyInlineRemoveable()) ||
                            d.is("table") && a.is("caption") ? false : true
                    }
                }
                var b = CKEDITOR.dom.walker.whitespaces(),
                    c = CKEDITOR.dom.walker.bookmark(false);
                return function(b) {
                    for (var c = this.createBookmark(), d = this[b ? "endPath" : "startPath"](), f = d.block || d.blockLimit, g; f && !f.equals(d.root) && !f.getFirst(a(f));) {
                        g = f.getParent();
                        this[b ? "setEndAt" : "setStartAt"](f, CKEDITOR.POSITION_AFTER_END);
                        f.remove(1);
                        f = g
                    }
                    this.moveToBookmark(c)
                }
            }(),
            startPath: function() {
                return new CKEDITOR.dom.elementPath(this.startContainer, this.root)
            },
            endPath: function() {
                return new CKEDITOR.dom.elementPath(this.endContainer,
                    this.root)
            },
            checkBoundaryOfElement: function(a, b) {
                var c = b == CKEDITOR.START,
                    d = this.clone();
                d.collapse(c);
                d[c ? "setStartAt" : "setEndAt"](a, c ? CKEDITOR.POSITION_AFTER_START : CKEDITOR.POSITION_BEFORE_END);
                d = new CKEDITOR.dom.walker(d);
                d.evaluator = e(c);
                return d[c ? "checkBackward" : "checkForward"]()
            },
            checkStartOfBlock: function() {
                var b = this.startContainer,
                    c = this.startOffset;
                if (CKEDITOR.env.ie && c && b.type == CKEDITOR.NODE_TEXT) {
                    b = CKEDITOR.tools.ltrim(b.substring(0, c));
                    f.test(b) && this.trim(0, 1)
                }
                this.trim();
                b = new CKEDITOR.dom.elementPath(this.startContainer,
                    this.root);
                c = this.clone();
                c.collapse(true);
                c.setStartAt(b.block || b.blockLimit, CKEDITOR.POSITION_AFTER_START);
                b = new CKEDITOR.dom.walker(c);
                b.evaluator = a();
                return b.checkBackward()
            },
            checkEndOfBlock: function() {
                var b = this.endContainer,
                    c = this.endOffset;
                if (CKEDITOR.env.ie && b.type == CKEDITOR.NODE_TEXT) {
                    b = CKEDITOR.tools.rtrim(b.substring(c));
                    f.test(b) && this.trim(1, 0)
                }
                this.trim();
                b = new CKEDITOR.dom.elementPath(this.endContainer, this.root);
                c = this.clone();
                c.collapse(false);
                c.setEndAt(b.block || b.blockLimit, CKEDITOR.POSITION_BEFORE_END);
                b = new CKEDITOR.dom.walker(c);
                b.evaluator = a();
                return b.checkForward()
            },
            getPreviousNode: function(a, b, c) {
                var d = this.clone();
                d.collapse(1);
                d.setStartAt(c || this.root, CKEDITOR.POSITION_AFTER_START);
                c = new CKEDITOR.dom.walker(d);
                c.evaluator = a;
                c.guard = b;
                return c.previous()
            },
            getNextNode: function(a, b, c) {
                var d = this.clone();
                d.collapse();
                d.setEndAt(c || this.root, CKEDITOR.POSITION_BEFORE_END);
                c = new CKEDITOR.dom.walker(d);
                c.evaluator = a;
                c.guard = b;
                return c.next()
            },
            checkReadOnly: function() {
                function a(b, c) {
                    for (; b;) {
                        if (b.type ==
                            CKEDITOR.NODE_ELEMENT) {
                            if (b.getAttribute("contentEditable") == "false" && !b.data("cke-editable")) return 0;
                            if (b.is("html") || b.getAttribute("contentEditable") == "true" && (b.contains(c) || b.equals(c))) break
                        }
                        b = b.getParent()
                    }
                    return 1
                }
                return function() {
                    var b = this.startContainer,
                        c = this.endContainer;
                    return !(a(b, c) && a(c, b))
                }
            }(),
            moveToElementEditablePosition: function(a, b) {
                if (a.type == CKEDITOR.NODE_ELEMENT && !a.isEditable(false)) {
                    this.moveToPosition(a, b ? CKEDITOR.POSITION_AFTER_END : CKEDITOR.POSITION_BEFORE_START);
                    return true
                }
                for (var c =
                    0; a;) {
                    if (a.type == CKEDITOR.NODE_TEXT) {
                        b && this.endContainer && this.checkEndOfBlock() && f.test(a.getText()) ? this.moveToPosition(a, CKEDITOR.POSITION_BEFORE_START) : this.moveToPosition(a, b ? CKEDITOR.POSITION_AFTER_END : CKEDITOR.POSITION_BEFORE_START);
                        c = 1;
                        break
                    }
                    if (a.type == CKEDITOR.NODE_ELEMENT)
                        if (a.isEditable()) {
                            this.moveToPosition(a, b ? CKEDITOR.POSITION_BEFORE_END : CKEDITOR.POSITION_AFTER_START);
                            c = 1
                        } else if (b && a.is("br") && this.endContainer && this.checkEndOfBlock()) this.moveToPosition(a, CKEDITOR.POSITION_BEFORE_START);
                    else if (a.getAttribute("contenteditable") == "false" && a.is(CKEDITOR.dtd.$block)) {
                        this.setStartBefore(a);
                        this.setEndAfter(a);
                        return true
                    }
                    var d = a,
                        g = c,
                        h = void 0;
                    d.type == CKEDITOR.NODE_ELEMENT && d.isEditable(false) && (h = d[b ? "getLast" : "getFirst"](i));
                    !g && !h && (h = d[b ? "getPrevious" : "getNext"](i));
                    a = h
                }
                return !!c
            },
            moveToClosestEditablePosition: function(a, b) {
                var c = new CKEDITOR.dom.range(this.root),
                    d = 0,
                    f, g = [CKEDITOR.POSITION_AFTER_END, CKEDITOR.POSITION_BEFORE_START];
                c.moveToPosition(a, g[b ? 0 : 1]);
                if (a.is(CKEDITOR.dtd.$block)) {
                    if (f =
                        c[b ? "getNextEditableNode" : "getPreviousEditableNode"]()) {
                        d = 1;
                        if (f.type == CKEDITOR.NODE_ELEMENT && f.is(CKEDITOR.dtd.$block) && f.getAttribute("contenteditable") == "false") {
                            c.setStartAt(f, CKEDITOR.POSITION_BEFORE_START);
                            c.setEndAt(f, CKEDITOR.POSITION_AFTER_END)
                        } else c.moveToPosition(f, g[b ? 1 : 0])
                    }
                } else d = 1;
                d && this.moveToRange(c);
                return !!d
            },
            moveToElementEditStart: function(a) {
                return this.moveToElementEditablePosition(a)
            },
            moveToElementEditEnd: function(a) {
                return this.moveToElementEditablePosition(a, true)
            },
            getEnclosedNode: function() {
                var a =
                    this.clone();
                a.optimize();
                if (a.startContainer.type != CKEDITOR.NODE_ELEMENT || a.endContainer.type != CKEDITOR.NODE_ELEMENT) return null;
                var a = new CKEDITOR.dom.walker(a),
                    b = CKEDITOR.dom.walker.bookmark(false, true),
                    c = CKEDITOR.dom.walker.whitespaces(true);
                a.evaluator = function(a) {
                    return c(a) && b(a)
                };
                var d = a.next();
                a.reset();
                return d && d.equals(a.previous()) ? d : null
            },
            getTouchedStartNode: function() {
                var a = this.startContainer;
                return this.collapsed || a.type != CKEDITOR.NODE_ELEMENT ? a : a.getChild(this.startOffset) || a
            },
            getTouchedEndNode: function() {
                var a =
                    this.endContainer;
                return this.collapsed || a.type != CKEDITOR.NODE_ELEMENT ? a : a.getChild(this.endOffset - 1) || a
            },
            getNextEditableNode: b(),
            getPreviousEditableNode: b(1),
            scrollIntoView: function() {
                var a = new CKEDITOR.dom.element.createFromHtml("<span>&nbsp;</span>", this.document),
                    b, c, d, f = this.clone();
                f.optimize();
                if (d = f.startContainer.type == CKEDITOR.NODE_TEXT) {
                    c = f.startContainer.getText();
                    b = f.startContainer.split(f.startOffset);
                    a.insertAfter(f.startContainer)
                } else f.insertNode(a);
                a.scrollIntoView();
                if (d) {
                    f.startContainer.setText(c);
                    b.remove()
                }
                a.remove()
            },
            _setStartContainer: function(a) {
                this.startContainer = a
            },
            _setEndContainer: function(a) {
                this.endContainer = a
            }
        }
    }(), CKEDITOR.POSITION_AFTER_START = 1, CKEDITOR.POSITION_BEFORE_END = 2, CKEDITOR.POSITION_BEFORE_START = 3, CKEDITOR.POSITION_AFTER_END = 4, CKEDITOR.ENLARGE_ELEMENT = 1, CKEDITOR.ENLARGE_BLOCK_CONTENTS = 2, CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS = 3, CKEDITOR.ENLARGE_INLINE = 4, CKEDITOR.START = 1, CKEDITOR.END = 2, CKEDITOR.SHRINK_ELEMENT = 1, CKEDITOR.SHRINK_TEXT = 2, "use strict",
    function() {
        function a(a) {
            if (!(arguments.length <
                1)) {
                this.range = a;
                this.forceBrBreak = 0;
                this.enlargeBr = 1;
                this.enforceRealBlocks = 0;
                this._ || (this._ = {})
            }
        }

        function e(a) {
            var b = [];
            a.forEach(function(a) {
                if (a.getAttribute("contenteditable") == "true") {
                    b.push(a);
                    return false
                }
            }, CKEDITOR.NODE_ELEMENT, true);
            return b
        }

        function b(a, c, d, f) {
            a: {
                f == null && (f = e(d));
                for (var g; g = f.shift();)
                    if (g.getDtd().p) {
                        f = {
                            element: g,
                            remaining: f
                        };
                        break a
                    }
                f = null
            }
            if (!f) return 0;
            if ((g = CKEDITOR.filter.instances[f.element.data("cke-filter")]) && !g.check(c)) return b(a, c, d, f.remaining);
            c = new CKEDITOR.dom.range(f.element);
            c.selectNodeContents(f.element);
            c = c.createIterator();
            c.enlargeBr = a.enlargeBr;
            c.enforceRealBlocks = a.enforceRealBlocks;
            c.activeFilter = c.filter = g;
            a._.nestedEditable = {
                element: f.element,
                container: d,
                remaining: f.remaining,
                iterator: c
            };
            return 1
        }

        function g(a, b, c) {
            if (!b) return false;
            a = a.clone();
            a.collapse(!c);
            return a.checkBoundaryOfElement(b, c ? CKEDITOR.START : CKEDITOR.END)
        }
        var c = /^[\r\n\t ]+$/,
            d = CKEDITOR.dom.walker.bookmark(false, true),
            j = CKEDITOR.dom.walker.whitespaces(true),
            f = function(a) {
                return d(a) && j(a)
            },
            h = {
                dd: 1,
                dt: 1,
                li: 1
            };
        a.prototype = {
            getNextParagraph: function(a) {
                var e, j, o, q, m, a = a || "p";
                if (this._.nestedEditable) {
                    if (e = this._.nestedEditable.iterator.getNextParagraph(a)) {
                        this.activeFilter = this._.nestedEditable.iterator.activeFilter;
                        return e
                    }
                    this.activeFilter = this.filter;
                    if (b(this, a, this._.nestedEditable.container, this._.nestedEditable.remaining)) {
                        this.activeFilter = this._.nestedEditable.iterator.activeFilter;
                        return this._.nestedEditable.iterator.getNextParagraph(a)
                    }
                    this._.nestedEditable = null
                }
                if (!this.range.root.getDtd()[a]) return null;
                if (!this._.started) {
                    var l = this.range.clone();
                    j = l.startPath();
                    var p = l.endPath(),
                        t = !l.collapsed && g(l, j.block),
                        s = !l.collapsed && g(l, p.block, 1);
                    l.shrink(CKEDITOR.SHRINK_ELEMENT, true);
                    t && l.setStartAt(j.block, CKEDITOR.POSITION_BEFORE_END);
                    s && l.setEndAt(p.block, CKEDITOR.POSITION_AFTER_START);
                    j = l.endContainer.hasAscendant("pre", true) || l.startContainer.hasAscendant("pre", true);
                    l.enlarge(this.forceBrBreak && !j || !this.enlargeBr ? CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS : CKEDITOR.ENLARGE_BLOCK_CONTENTS);
                    if (!l.collapsed) {
                        j =
                            new CKEDITOR.dom.walker(l.clone());
                        p = CKEDITOR.dom.walker.bookmark(true, true);
                        j.evaluator = p;
                        this._.nextNode = j.next();
                        j = new CKEDITOR.dom.walker(l.clone());
                        j.evaluator = p;
                        j = j.previous();
                        this._.lastNode = j.getNextSourceNode(true, null, l.root);
                        if (this._.lastNode && this._.lastNode.type == CKEDITOR.NODE_TEXT && !CKEDITOR.tools.trim(this._.lastNode.getText()) && this._.lastNode.getParent().isBlockBoundary()) {
                            p = this.range.clone();
                            p.moveToPosition(this._.lastNode, CKEDITOR.POSITION_AFTER_END);
                            if (p.checkEndOfBlock()) {
                                p =
                                    new CKEDITOR.dom.elementPath(p.endContainer, p.root);
                                this._.lastNode = (p.block || p.blockLimit).getNextSourceNode(true)
                            }
                        }
                        if (!this._.lastNode || !l.root.contains(this._.lastNode)) {
                            this._.lastNode = this._.docEndMarker = l.document.createText("");
                            this._.lastNode.insertAfter(j)
                        }
                        l = null
                    }
                    this._.started = 1;
                    j = l
                }
                p = this._.nextNode;
                l = this._.lastNode;
                for (this._.nextNode = null; p;) {
                    var t = 0,
                        s = p.hasAscendant("pre"),
                        u = p.type != CKEDITOR.NODE_ELEMENT,
                        w = 0;
                    if (u) p.type == CKEDITOR.NODE_TEXT && c.test(p.getText()) && (u = 0);
                    else {
                        var x = p.getName();
                        if (CKEDITOR.dtd.$block[x] && p.getAttribute("contenteditable") == "false") {
                            e = p;
                            b(this, a, e);
                            break
                        } else if (p.isBlockBoundary(this.forceBrBreak && !s && {
                            br: 1
                        })) {
                            if (x == "br") u = 1;
                            else if (!j && !p.getChildCount() && x != "hr") {
                                e = p;
                                o = p.equals(l);
                                break
                            }
                            if (j) {
                                j.setEndAt(p, CKEDITOR.POSITION_BEFORE_START);
                                if (x != "br") this._.nextNode = p
                            }
                            t = 1
                        } else {
                            if (p.getFirst()) {
                                if (!j) {
                                    j = this.range.clone();
                                    j.setStartAt(p, CKEDITOR.POSITION_BEFORE_START)
                                }
                                p = p.getFirst();
                                continue
                            }
                            u = 1
                        }
                    } if (u && !j) {
                        j = this.range.clone();
                        j.setStartAt(p, CKEDITOR.POSITION_BEFORE_START)
                    }
                    o =
                        (!t || u) && p.equals(l);
                    if (j && !t)
                        for (; !p.getNext(f) && !o;) {
                            x = p.getParent();
                            if (x.isBlockBoundary(this.forceBrBreak && !s && {
                                br: 1
                            })) {
                                t = 1;
                                u = 0;
                                o || x.equals(l);
                                j.setEndAt(x, CKEDITOR.POSITION_BEFORE_END);
                                break
                            }
                            p = x;
                            u = 1;
                            o = p.equals(l);
                            w = 1
                        }
                    u && j.setEndAt(p, CKEDITOR.POSITION_AFTER_END);
                    p = this._getNextSourceNode(p, w, l);
                    if ((o = !p) || t && j) break
                }
                if (!e) {
                    if (!j) {
                        this._.docEndMarker && this._.docEndMarker.remove();
                        return this._.nextNode = null
                    }
                    e = new CKEDITOR.dom.elementPath(j.startContainer, j.root);
                    p = e.blockLimit;
                    t = {
                        div: 1,
                        th: 1,
                        td: 1
                    };
                    e = e.block;
                    if (!e && p && !this.enforceRealBlocks && t[p.getName()] && j.checkStartOfBlock() && j.checkEndOfBlock() && !p.equals(j.root)) e = p;
                    else if (!e || this.enforceRealBlocks && e.is(h)) {
                        e = this.range.document.createElement(a);
                        j.extractContents().appendTo(e);
                        e.trim();
                        j.insertNode(e);
                        q = m = true
                    } else if (e.getName() != "li") {
                        if (!j.checkStartOfBlock() || !j.checkEndOfBlock()) {
                            e = e.clone(false);
                            j.extractContents().appendTo(e);
                            e.trim();
                            m = j.splitBlock();
                            q = !m.wasStartOfBlock;
                            m = !m.wasEndOfBlock;
                            j.insertNode(e)
                        }
                    } else if (!o) this._.nextNode =
                        e.equals(l) ? null : this._getNextSourceNode(j.getBoundaryNodes().endNode, 1, l)
                }
                if (q)(q = e.getPrevious()) && q.type == CKEDITOR.NODE_ELEMENT && (q.getName() == "br" ? q.remove() : q.getLast() && q.getLast().$.nodeName.toLowerCase() == "br" && q.getLast().remove());
                if (m)(q = e.getLast()) && q.type == CKEDITOR.NODE_ELEMENT && q.getName() == "br" && (!CKEDITOR.env.needsBrFiller || q.getPrevious(d) || q.getNext(d)) && q.remove();
                if (!this._.nextNode) this._.nextNode = o || e.equals(l) || !l ? null : this._getNextSourceNode(e, 1, l);
                return e
            },
            _getNextSourceNode: function(a,
                b, c) {
                function f(a) {
                    return !(a.equals(c) || a.equals(g))
                }
                for (var g = this.range.root, a = a.getNextSourceNode(b, null, f); !d(a);) a = a.getNextSourceNode(b, null, f);
                return a
            }
        };
        CKEDITOR.dom.range.prototype.createIterator = function() {
            return new a(this)
        }
    }(), CKEDITOR.command = function(a, e) {
        this.uiItems = [];
        this.exec = function(b) {
            if (this.state == CKEDITOR.TRISTATE_DISABLED || !this.checkAllowed()) return false;
            this.editorFocus && a.focus();
            return this.fire("exec") === false ? true : e.exec.call(this, a, b) !== false
        };
        this.refresh = function(a,
            b) {
            if (!this.readOnly && a.readOnly) return true;
            if (this.context && !b.isContextFor(this.context)) {
                this.disable();
                return true
            }
            if (!this.checkAllowed(true)) {
                this.disable();
                return true
            }
            this.startDisabled || this.enable();
            this.modes && !this.modes[a.mode] && this.disable();
            return this.fire("refresh", {
                editor: a,
                path: b
            }) === false ? true : e.refresh && e.refresh.apply(this, arguments) !== false
        };
        var b;
        this.checkAllowed = function(g) {
            return !g && typeof b == "boolean" ? b : b = a.activeFilter.checkFeature(this)
        };
        CKEDITOR.tools.extend(this,
            e, {
                modes: {
                    wysiwyg: 1
                },
                editorFocus: 1,
                contextSensitive: !! e.context,
                state: CKEDITOR.TRISTATE_DISABLED
            });
        CKEDITOR.event.call(this)
    }, CKEDITOR.command.prototype = {
        enable: function() {
            this.state == CKEDITOR.TRISTATE_DISABLED && this.checkAllowed() && this.setState(!this.preserveState || typeof this.previousState == "undefined" ? CKEDITOR.TRISTATE_OFF : this.previousState)
        },
        disable: function() {
            this.setState(CKEDITOR.TRISTATE_DISABLED)
        },
        setState: function(a) {
            if (this.state == a || a != CKEDITOR.TRISTATE_DISABLED && !this.checkAllowed()) return false;
            this.previousState = this.state;
            this.state = a;
            this.fire("state");
            return true
        },
        toggleState: function() {
            this.state == CKEDITOR.TRISTATE_OFF ? this.setState(CKEDITOR.TRISTATE_ON) : this.state == CKEDITOR.TRISTATE_ON && this.setState(CKEDITOR.TRISTATE_OFF)
        }
    }, CKEDITOR.event.implementOn(CKEDITOR.command.prototype), CKEDITOR.ENTER_P = 1, CKEDITOR.ENTER_BR = 2, CKEDITOR.ENTER_DIV = 3, CKEDITOR.config = {
        customConfig: "config.js",
        autoUpdateElement: !0,
        language: "",
        defaultLanguage: "en",
        contentsLangDirection: "",
        enterMode: CKEDITOR.ENTER_P,
        forceEnterMode: !1,
        shiftEnterMode: CKEDITOR.ENTER_BR,
        docType: "<!DOCTYPE html>",
        bodyId: "",
        bodyClass: "",
        fullPage: !1,
        height: 200,
        extraPlugins: "",
        removePlugins: "",
        protectedSource: [],
        tabIndex: 0,
        width: "",
        baseFloatZIndex: 1E4,
        blockedKeystrokes: [CKEDITOR.CTRL + 66, CKEDITOR.CTRL + 73, CKEDITOR.CTRL + 85]
    },
    function() {
        function a(a, b, c, d, f) {
            var g, h, a = [];
            for (g in b) {
                h = b[g];
                h = typeof h == "boolean" ? {} : typeof h == "function" ? {
                    match: h
                } : G(h);
                if (g.charAt(0) != "$") h.elements = g;
                if (c) h.featureName = c.toLowerCase();
                var e = h;
                e.elements = j(e.elements,
                    /\s+/) || null;
                e.propertiesOnly = e.propertiesOnly || e.elements === true;
                var i = /\s*,\s*/,
                    p = void 0;
                for (p in F) {
                    e[p] = j(e[p], i) || null;
                    var m = e,
                        k = E[p],
                        x = j(e[E[p]], i),
                        s = e[p],
                        w = [],
                        l = true,
                        C = void 0;
                    x ? l = false : x = {};
                    for (C in s)
                        if (C.charAt(0) == "!") {
                            C = C.slice(1);
                            w.push(C);
                            x[C] = true;
                            l = false
                        }
                    for (; C = w.pop();) {
                        s[C] = s["!" + C];
                        delete s["!" + C]
                    }
                    m[k] = (l ? false : x) || null
                }
                e.match = e.match || null;
                d.push(h);
                a.push(h)
            }
            for (var b = f.elements, f = f.generic, n, c = 0, d = a.length; c < d; ++c) {
                g = G(a[c]);
                h = g.classes === true || g.styles === true || g.attributes ===
                    true;
                e = g;
                p = k = i = void 0;
                for (i in F) e[i] = t(e[i]);
                m = true;
                for (p in E) {
                    i = E[p];
                    k = e[i];
                    x = [];
                    s = void 0;
                    for (s in k) s.indexOf("*") > -1 ? x.push(RegExp("^" + s.replace(/\*/g, ".*") + "$")) : x.push(s);
                    k = x;
                    if (k.length) {
                        e[i] = k;
                        m = false
                    }
                }
                e.nothingRequired = m;
                e.noProperties = !(e.attributes || e.classes || e.styles);
                if (g.elements === true || g.elements === null) f[h ? "unshift" : "push"](g);
                else {
                    e = g.elements;
                    delete g.elements;
                    for (n in e)
                        if (b[n]) b[n][h ? "unshift" : "push"](g);
                        else b[n] = [g]
                }
            }
        }

        function e(a, c, d, g) {
            if (!a.match || a.match(c))
                if (g || f(a,
                    c)) {
                    if (!a.propertiesOnly) d.valid = true;
                    if (!d.allAttributes) d.allAttributes = b(a.attributes, c.attributes, d.validAttributes);
                    if (!d.allStyles) d.allStyles = b(a.styles, c.styles, d.validStyles);
                    if (!d.allClasses) {
                        a = a.classes;
                        c = c.classes;
                        g = d.validClasses;
                        if (a)
                            if (a === true) a = true;
                            else {
                                for (var h = 0, e = c.length, j; h < e; ++h) {
                                    j = c[h];
                                    g[j] || (g[j] = a(j))
                                }
                                a = false
                            } else a = false;
                        d.allClasses = a
                    }
                }
        }

        function b(a, b, c) {
            if (!a) return false;
            if (a === true) return true;
            for (var d in b) c[d] || (c[d] = a(d));
            return false
        }

        function g(a, b, d) {
            if (!a.match ||
                a.match(b)) {
                if (a.noProperties) return false;
                d.hadInvalidAttribute = c(a.attributes, b.attributes) || d.hadInvalidAttribute;
                d.hadInvalidStyle = c(a.styles, b.styles) || d.hadInvalidStyle;
                a = a.classes;
                b = b.classes;
                if (a) {
                    for (var f = false, g = a === true, h = b.length; h--;)
                        if (g || a(b[h])) {
                            b.splice(h, 1);
                            f = true
                        }
                    a = f
                } else a = false;
                d.hadInvalidClass = a || d.hadInvalidClass
            }
        }

        function c(a, b) {
            if (!a) return false;
            var c = false,
                d = a === true,
                f;
            for (f in b)
                if (d || a(f)) {
                    delete b[f];
                    c = true
                }
            return c
        }

        function d(a, b, c) {
            if (a.disabled || a.customConfig && !c || !b) return false;
            a._.cachedChecks = {};
            return true
        }

        function j(a, b) {
            if (!a) return false;
            if (a === true) return a;
            if (typeof a == "string") {
                a = D(a);
                return a == "*" ? true : CKEDITOR.tools.convertArrayToObject(a.split(b))
            }
            if (CKEDITOR.tools.isArray(a)) return a.length ? CKEDITOR.tools.convertArrayToObject(a) : false;
            var c = {}, d = 0,
                f;
            for (f in a) {
                c[f] = a[f];
                d++
            }
            return d ? c : false
        }

        function f(a, b) {
            if (a.nothingRequired) return true;
            var c, d, f, g;
            if (f = a.requiredClasses) {
                g = b.classes;
                for (c = 0; c < f.length; ++c) {
                    d = f[c];
                    if (typeof d == "string") {
                        if (CKEDITOR.tools.indexOf(g,
                            d) == -1) return false
                    } else if (!CKEDITOR.tools.checkIfAnyArrayItemMatches(g, d)) return false
                }
            }
            return h(b.styles, a.requiredStyles) && h(b.attributes, a.requiredAttributes)
        }

        function h(a, b) {
            if (!b) return true;
            for (var c = 0, d; c < b.length; ++c) {
                d = b[c];
                if (typeof d == "string") {
                    if (!(d in a)) return false
                } else if (!CKEDITOR.tools.checkIfAnyObjectPropertyMatches(a, d)) return false
            }
            return true
        }

        function i(a) {
            if (!a) return {};
            for (var a = a.split(/\s*,\s*/).sort(), b = {}; a.length;) b[a.shift()] = J;
            return b
        }

        function k(a) {
            for (var b, c, d,
                    f, g = {}, h = 1, a = D(a); b = a.match(I);) {
                if (c = b[2]) {
                    d = n(c, "styles");
                    f = n(c, "attrs");
                    c = n(c, "classes")
                } else d = f = c = null;
                g["$" + h++] = {
                    elements: b[1],
                    classes: c,
                    styles: d,
                    attributes: f
                };
                a = a.slice(b[0].length)
            }
            return g
        }

        function n(a, b) {
            var c = a.match(L[b]);
            return c ? D(c[1]) : null
        }

        function o(a) {
            var b = a.styleBackup = a.attributes.style,
                c = a.classBackup = a.attributes["class"];
            if (!a.styles) a.styles = CKEDITOR.tools.parseCssText(b || "", 1);
            if (!a.classes) a.classes = c ? c.split(/\s+/) : []
        }

        function q(a, b, c, d) {
            var f = 0,
                h;
            if (d.toHtml) b.name = b.name.replace(H,
                "$1");
            if (d.doCallbacks && a.elementCallbacks) {
                a: for (var j = a.elementCallbacks, i = 0, m = j.length, t; i < m; ++i)
                    if (t = j[i](b)) {
                        h = t;
                        break a
                    }
                if (h) return h
            }
            if (d.doTransform)
                if (h = a._.transformations[b.name]) {
                    o(b);
                    for (j = 0; j < h.length; ++j) x(a, b, h[j]);
                    l(b)
                }
            if (d.doFilter) {
                a: {
                    j = b.name;
                    i = a._;
                    a = i.allowedRules.elements[j];
                    h = i.allowedRules.generic;
                    j = i.disallowedRules.elements[j];
                    i = i.disallowedRules.generic;
                    m = d.skipRequired;
                    t = {
                        valid: false,
                        validAttributes: {},
                        validClasses: {},
                        validStyles: {},
                        allAttributes: false,
                        allClasses: false,
                        allStyles: false,
                        hadInvalidAttribute: false,
                        hadInvalidClass: false,
                        hadInvalidStyle: false
                    };
                    var k, s;
                    if (!a && !h) a = null;
                    else {
                        o(b);
                        if (j) {
                            k = 0;
                            for (s = j.length; k < s; ++k)
                                if (g(j[k], b, t) === false) {
                                    a = null;
                                    break a
                                }
                        }
                        if (i) {
                            k = 0;
                            for (s = i.length; k < s; ++k) g(i[k], b, t)
                        }
                        if (a) {
                            k = 0;
                            for (s = a.length; k < s; ++k) e(a[k], b, t, m)
                        }
                        if (h) {
                            k = 0;
                            for (s = h.length; k < s; ++k) e(h[k], b, t, m)
                        }
                        a = t
                    }
                }
                if (!a) {
                    c.push(b);
                    return A
                }
                if (!a.valid) {
                    c.push(b);
                    return A
                }
                s = a.validAttributes;
                var w = a.validStyles;
                h = a.validClasses;
                var j = b.attributes,
                    C = b.styles,
                    i = b.classes,
                    m = b.classBackup,
                    n = b.styleBackup,
                    v, F, r = [];
                t = [];
                var u = /^data-cke-/;
                k = false;
                delete j.style;
                delete j["class"];
                delete b.classBackup;
                delete b.styleBackup;
                if (!a.allAttributes)
                    for (v in j)
                        if (!s[v])
                            if (u.test(v)) {
                                if (v != (F = v.replace(/^data-cke-saved-/, "")) && !s[F]) {
                                    delete j[v];
                                    k = true
                                }
                            } else {
                                delete j[v];
                                k = true
                            }
                if (!a.allStyles || a.hadInvalidStyle) {
                    for (v in C) a.allStyles || w[v] ? r.push(v + ":" + C[v]) : k = true;
                    if (r.length) j.style = r.sort().join("; ")
                } else if (n) j.style = n;
                if (!a.allClasses || a.hadInvalidClass) {
                    for (v = 0; v < i.length; ++v)(a.allClasses ||
                        h[i[v]]) && t.push(i[v]);
                    t.length && (j["class"] = t.sort().join(" "));
                    m && t.length < m.split(/\s+/).length && (k = true)
                } else m && (j["class"] = m);
                k && (f = A);
                if (!d.skipFinalValidation && !p(b)) {
                    c.push(b);
                    return A
                }
            }
            if (d.toHtml) b.name = b.name.replace(Q, "cke:$1");
            return f
        }

        function m(a) {
            var b = [],
                c;
            for (c in a) c.indexOf("*") > -1 && b.push(c.replace(/\*/g, ".*"));
            return b.length ? RegExp("^(?:" + b.join("|") + ")$") : null
        }

        function l(a) {
            var b = a.attributes,
                c;
            delete b.style;
            delete b["class"];
            if (c = CKEDITOR.tools.writeCssText(a.styles, true)) b.style =
                c;
            a.classes.length && (b["class"] = a.classes.sort().join(" "))
        }

        function p(a) {
            switch (a.name) {
                case "a":
                    if (!a.children.length && !a.attributes.name) return false;
                    break;
                case "img":
                    if (!a.attributes.src) return false
            }
            return true
        }

        function t(a) {
            if (!a) return false;
            if (a === true) return true;
            var b = m(a);
            return function(c) {
                return c in a || b && c.match(b)
            }
        }

        function s() {
            return new CKEDITOR.htmlParser.element("br")
        }

        function u(a) {
            return a.type == CKEDITOR.NODE_ELEMENT && (a.name == "br" || B.$block[a.name])
        }

        function w(a, b, c) {
            var d = a.name;
            if (B.$empty[d] || !a.children.length)
                if (d == "hr" && b == "br") a.replaceWith(s());
                else {
                    a.parent && c.push({
                        check: "it",
                        el: a.parent
                    });
                    a.remove()
                } else if (B.$block[d] || d == "tr")
                if (b == "br") {
                    if (a.previous && !u(a.previous)) {
                        b = s();
                        b.insertBefore(a)
                    }
                    if (a.next && !u(a.next)) {
                        b = s();
                        b.insertAfter(a)
                    }
                    a.replaceWithChildren()
                } else {
                    var d = a.children,
                        f;
                    b: {
                        f = B[b];
                        for (var g = 0, h = d.length, e; g < h; ++g) {
                            e = d[g];
                            if (e.type == CKEDITOR.NODE_ELEMENT && !f[e.name]) {
                                f = false;
                                break b
                            }
                        }
                        f = true
                    }
                    if (f) {
                        a.name = b;
                        a.attributes = {};
                        c.push({
                            check: "parent-down",
                            el: a
                        })
                    } else {
                        f = a.parent;
                        for (var g = f.type == CKEDITOR.NODE_DOCUMENT_FRAGMENT || f.name == "body", j, i, h = d.length; h > 0;) {
                            e = d[--h];
                            if (g && (e.type == CKEDITOR.NODE_TEXT || e.type == CKEDITOR.NODE_ELEMENT && B.$inline[e.name])) {
                                if (!j) {
                                    j = new CKEDITOR.htmlParser.element(b);
                                    j.insertAfter(a);
                                    c.push({
                                        check: "parent-down",
                                        el: j
                                    })
                                }
                                j.add(e, 0)
                            } else {
                                j = null;
                                i = B[f.name] || B.span;
                                e.insertAfter(a);
                                f.type != CKEDITOR.NODE_DOCUMENT_FRAGMENT && (e.type == CKEDITOR.NODE_ELEMENT && !i[e.name]) && c.push({
                                    check: "el-up",
                                    el: e
                                })
                            }
                        }
                        a.remove()
                    }
                } else if (d == "style") a.remove();
            else {
                a.parent && c.push({
                    check: "it",
                    el: a.parent
                });
                a.replaceWithChildren()
            }
        }

        function x(a, b, c) {
            var d, f;
            for (d = 0; d < c.length; ++d) {
                f = c[d];
                if ((!f.check || a.check(f.check, false)) && (!f.left || f.left(b))) {
                    f.right(b, O);
                    break
                }
            }
        }

        function v(a, b) {
            var c = b.getDefinition(),
                d = c.attributes,
                f = c.styles,
                g, h, e, j;
            if (a.name != c.element) return false;
            for (g in d)
                if (g == "class") {
                    c = d[g].split(/\s+/);
                    for (e = a.classes.join("|"); j = c.pop();)
                        if (e.indexOf(j) == -1) return false
                } else if (a.attributes[g] != d[g]) return false;
            for (h in f)
                if (a.styles[h] !=
                    f[h]) return false;
            return true
        }

        function r(a, b) {
            var c, d;
            if (typeof a == "string") c = a;
            else if (a instanceof CKEDITOR.style) d = a;
            else {
                c = a[0];
                d = a[1]
            }
            return [{
                element: c,
                left: d,
                right: function(a, c) {
                    c.transform(a, b)
                }
            }]
        }

        function y(a) {
            return function(b) {
                return v(b, a)
            }
        }

        function z(a) {
            return function(b, c) {
                c[a](b)
            }
        }
        var B = CKEDITOR.dtd,
            A = 1,
            G = CKEDITOR.tools.copy,
            D = CKEDITOR.tools.trim,
            J = "cke-test",
            C = ["", "p", "br", "div"];
        CKEDITOR.FILTER_SKIP_TREE = 2;
        CKEDITOR.filter = function(a) {
            this.allowedContent = [];
            this.disallowedContent = [];
            this.elementCallbacks = null;
            this.disabled = false;
            this.editor = null;
            this.id = CKEDITOR.tools.getNextNumber();
            this._ = {
                allowedRules: {
                    elements: {},
                    generic: []
                },
                disallowedRules: {
                    elements: {},
                    generic: []
                },
                transformations: {},
                cachedTests: {}
            };
            CKEDITOR.filter.instances[this.id] = this;
            if (a instanceof CKEDITOR.editor) {
                a = this.editor = a;
                this.customConfig = true;
                var b = a.config.allowedContent;
                if (b === true) this.disabled = true;
                else {
                    if (!b) this.customConfig = false;
                    this.allow(b, "config", 1);
                    this.allow(a.config.extraAllowedContent, "extra",
                        1);
                    this.allow(C[a.enterMode] + " " + C[a.shiftEnterMode], "default", 1);
                    this.disallow(a.config.disallowedContent)
                }
            } else {
                this.customConfig = false;
                this.allow(a, "default", 1)
            }
        };
        CKEDITOR.filter.instances = {};
        CKEDITOR.filter.prototype = {
            allow: function(b, c, f) {
                if (!d(this, b, f)) return false;
                var g, h;
                if (typeof b == "string") b = k(b);
                else if (b instanceof CKEDITOR.style) {
                    if (b.toAllowedContentRules) return this.allow(b.toAllowedContentRules(this.editor), c, f);
                    g = b.getDefinition();
                    b = {};
                    f = g.attributes;
                    b[g.element] = g = {
                        styles: g.styles,
                        requiredStyles: g.styles && CKEDITOR.tools.objectKeys(g.styles)
                    };
                    if (f) {
                        f = G(f);
                        g.classes = f["class"] ? f["class"].split(/\s+/) : null;
                        g.requiredClasses = g.classes;
                        delete f["class"];
                        g.attributes = f;
                        g.requiredAttributes = f && CKEDITOR.tools.objectKeys(f)
                    }
                } else if (CKEDITOR.tools.isArray(b)) {
                    for (g = 0; g < b.length; ++g) h = this.allow(b[g], c, f);
                    return h
                }
                a(this, b, c, this.allowedContent, this._.allowedRules);
                return true
            },
            applyTo: function(a, b, c, d) {
                if (this.disabled) return false;
                var f = this,
                    g = [],
                    h = this.editor && this.editor.config.protectedSource,
                    e, j = false,
                    i = {
                        doFilter: !c,
                        doTransform: true,
                        doCallbacks: true,
                        toHtml: b
                    };
                a.forEach(function(a) {
                    if (a.type == CKEDITOR.NODE_ELEMENT) {
                        if (a.attributes["data-cke-filter"] == "off") return false;
                        if (!b || !(a.name == "span" && ~CKEDITOR.tools.objectKeys(a.attributes).join("|").indexOf("data-cke-"))) {
                            e = q(f, a, g, i);
                            if (e & A) j = true;
                            else if (e & 2) return false
                        }
                    } else if (a.type == CKEDITOR.NODE_COMMENT && a.value.match(/^\{cke_protected\}(?!\{C\})/)) {
                        var c;
                        a: {
                            var d = decodeURIComponent(a.value.replace(/^\{cke_protected\}/, ""));
                            c = [];
                            var p,
                                m, t;
                            if (h)
                                for (m = 0; m < h.length; ++m)
                                    if ((t = d.match(h[m])) && t[0].length == d.length) {
                                        c = true;
                                        break a
                                    }
                            d = CKEDITOR.htmlParser.fragment.fromHtml(d);
                            d.children.length == 1 && (p = d.children[0]).type == CKEDITOR.NODE_ELEMENT && q(f, p, c, i);
                            c = !c.length
                        }
                        c || g.push(a)
                    }
                }, null, true);
                g.length && (j = true);
                for (var m, a = [], d = C[d || (this.editor ? this.editor.enterMode : CKEDITOR.ENTER_P)], t; c = g.pop();) c.type == CKEDITOR.NODE_ELEMENT ? w(c, d, a) : c.remove();
                for (; m = a.pop();) {
                    c = m.el;
                    if (c.parent) {
                        t = B[c.parent.name] || B.span;
                        switch (m.check) {
                            case "it":
                                B.$removeEmpty[c.name] && !c.children.length ? w(c, d, a) : p(c) || w(c, d, a);
                                break;
                            case "el-up":
                                c.parent.type != CKEDITOR.NODE_DOCUMENT_FRAGMENT && !t[c.name] && w(c, d, a);
                                break;
                            case "parent-down":
                                c.parent.type != CKEDITOR.NODE_DOCUMENT_FRAGMENT && !t[c.name] && w(c.parent, d, a)
                        }
                    }
                }
                return j
            },
            checkFeature: function(a) {
                if (this.disabled || !a) return true;
                a.toFeature && (a = a.toFeature(this.editor));
                return !a.requiredContent || this.check(a.requiredContent)
            },
            disable: function() {
                this.disabled = true
            },
            disallow: function(b) {
                if (!d(this, b, true)) return false;
                typeof b ==
                    "string" && (b = k(b));
                a(this, b, null, this.disallowedContent, this._.disallowedRules);
                return true
            },
            addContentForms: function(a) {
                if (!this.disabled && a) {
                    var b, c, d = [],
                        f;
                    for (b = 0; b < a.length && !f; ++b) {
                        c = a[b];
                        if ((typeof c == "string" || c instanceof CKEDITOR.style) && this.check(c)) f = c
                    }
                    if (f) {
                        for (b = 0; b < a.length; ++b) d.push(r(a[b], f));
                        this.addTransformations(d)
                    }
                }
            },
            addElementCallback: function(a) {
                if (!this.elementCallbacks) this.elementCallbacks = [];
                this.elementCallbacks.push(a)
            },
            addFeature: function(a) {
                if (this.disabled || !a) return true;
                a.toFeature && (a = a.toFeature(this.editor));
                this.allow(a.allowedContent, a.name);
                this.addTransformations(a.contentTransformations);
                this.addContentForms(a.contentForms);
                return a.requiredContent && (this.customConfig || this.disallowedContent.length) ? this.check(a.requiredContent) : true
            },
            addTransformations: function(a) {
                var b, c;
                if (!this.disabled && a) {
                    var d = this._.transformations,
                        f;
                    for (f = 0; f < a.length; ++f) {
                        b = a[f];
                        var g = void 0,
                            h = void 0,
                            e = void 0,
                            j = void 0,
                            i = void 0,
                            p = void 0;
                        c = [];
                        for (h = 0; h < b.length; ++h) {
                            e = b[h];
                            if (typeof e ==
                                "string") {
                                e = e.split(/\s*:\s*/);
                                j = e[0];
                                i = null;
                                p = e[1]
                            } else {
                                j = e.check;
                                i = e.left;
                                p = e.right
                            } if (!g) {
                                g = e;
                                g = g.element ? g.element : j ? j.match(/^([a-z0-9]+)/i)[0] : g.left.getDefinition().element
                            }
                            i instanceof CKEDITOR.style && (i = y(i));
                            c.push({
                                check: j == g ? null : j,
                                left: i,
                                right: typeof p == "string" ? z(p) : p
                            })
                        }
                        b = g;
                        d[b] || (d[b] = []);
                        d[b].push(c)
                    }
                }
            },
            check: function(a, b, c) {
                if (this.disabled) return true;
                if (CKEDITOR.tools.isArray(a)) {
                    for (var d = a.length; d--;)
                        if (this.check(a[d], b, c)) return true;
                    return false
                }
                var f, g;
                if (typeof a == "string") {
                    g =
                        a + "<" + (b === false ? "0" : "1") + (c ? "1" : "0") + ">";
                    if (g in this._.cachedChecks) return this._.cachedChecks[g];
                    d = k(a).$1;
                    f = d.styles;
                    var h = d.classes;
                    d.name = d.elements;
                    d.classes = h = h ? h.split(/\s*,\s*/) : [];
                    d.styles = i(f);
                    d.attributes = i(d.attributes);
                    d.children = [];
                    h.length && (d.attributes["class"] = h.join(" "));
                    if (f) d.attributes.style = CKEDITOR.tools.writeCssText(d.styles);
                    f = d
                } else {
                    d = a.getDefinition();
                    f = d.styles;
                    h = d.attributes || {};
                    if (f) {
                        f = G(f);
                        h.style = CKEDITOR.tools.writeCssText(f, true)
                    } else f = {};
                    f = {
                        name: d.element,
                        attributes: h,
                        classes: h["class"] ? h["class"].split(/\s+/) : [],
                        styles: f,
                        children: []
                    }
                }
                var h = CKEDITOR.tools.clone(f),
                    e = [],
                    j;
                if (b !== false && (j = this._.transformations[f.name])) {
                    for (d = 0; d < j.length; ++d) x(this, f, j[d]);
                    l(f)
                }
                q(this, h, e, {
                    doFilter: true,
                    doTransform: b !== false,
                    skipRequired: !c,
                    skipFinalValidation: !c
                });
                b = e.length > 0 ? false : CKEDITOR.tools.objectCompare(f.attributes, h.attributes, true) ? true : false;
                typeof a == "string" && (this._.cachedChecks[g] = b);
                return b
            },
            getAllowedEnterMode: function() {
                var a = ["p", "div", "br"],
                    b = {
                        p: CKEDITOR.ENTER_P,
                        div: CKEDITOR.ENTER_DIV,
                        br: CKEDITOR.ENTER_BR
                    };
                return function(c, d) {
                    var f = a.slice(),
                        g;
                    if (this.check(C[c])) return c;
                    for (d || (f = f.reverse()); g = f.pop();)
                        if (this.check(g)) return b[g];
                    return CKEDITOR.ENTER_BR
                }
            }(),
            destroy: function() {
                delete CKEDITOR.filter.instances[this.id];
                delete this._;
                delete this.allowedContent;
                delete this.disallowedContent
            }
        };
        var F = {
            styles: 1,
            attributes: 1,
            classes: 1
        }, E = {
                styles: "requiredStyles",
                attributes: "requiredAttributes",
                classes: "requiredClasses"
            }, I = /^([a-z0-9\-*\s]+)((?:\s*\{[!\w\-,\s\*]+\}\s*|\s*\[[!\w\-,\s\*]+\]\s*|\s*\([!\w\-,\s\*]+\)\s*){0,3})(?:;\s*|$)/i,
            L = {
                styles: /{([^}]+)}/,
                attrs: /\[([^\]]+)\]/,
                classes: /\(([^\)]+)\)/
            }, H = /^cke:(object|embed|param)$/,
            Q = /^(object|embed|param)$/,
            O = CKEDITOR.filter.transformationsTools = {
                sizeToStyle: function(a) {
                    this.lengthToStyle(a, "width");
                    this.lengthToStyle(a, "height")
                },
                sizeToAttribute: function(a) {
                    this.lengthToAttribute(a, "width");
                    this.lengthToAttribute(a, "height")
                },
                lengthToStyle: function(a, b, c) {
                    c = c || b;
                    if (!(c in a.styles)) {
                        var d = a.attributes[b];
                        if (d) {
                            /^\d+$/.test(d) && (d = d + "px");
                            a.styles[c] = d
                        }
                    }
                    delete a.attributes[b]
                },
                lengthToAttribute: function(a, b, c) {
                    c = c || b;
                    if (!(c in a.attributes)) {
                        var d = a.styles[b],
                            f = d && d.match(/^(\d+)(?:\.\d*)?px$/);
                        f ? a.attributes[c] = f[1] : d == J && (a.attributes[c] = J)
                    }
                    delete a.styles[b]
                },
                alignmentToStyle: function(a) {
                    if (!("float" in a.styles)) {
                        var b = a.attributes.align;
                        if (b == "left" || b == "right") a.styles["float"] = b
                    }
                    delete a.attributes.align
                },
                alignmentToAttribute: function(a) {
                    if (!("align" in a.attributes)) {
                        var b = a.styles["float"];
                        if (b == "left" || b == "right") a.attributes.align = b
                    }
                    delete a.styles["float"]
                },
                matchesStyle: v,
                transform: function(a, b) {
                    if (typeof b == "string") a.name = b;
                    else {
                        var c = b.getDefinition(),
                            d = c.styles,
                            f = c.attributes,
                            g, h, e, j;
                        a.name = c.element;
                        for (g in f)
                            if (g == "class") {
                                c = a.classes.join("|");
                                for (e = f[g].split(/\s+/); j = e.pop();) c.indexOf(j) == -1 && a.classes.push(j)
                            } else a.attributes[g] = f[g];
                        for (h in d) a.styles[h] = d[h]
                    }
                }
            }
    }(),
    function() {
        CKEDITOR.focusManager = function(a) {
            if (a.focusManager) return a.focusManager;
            this.hasFocus = false;
            this.currentActive = null;
            this._ = {
                editor: a
            };
            return this
        };
        CKEDITOR.focusManager._ = {
            blurDelay: 200
        };
        CKEDITOR.focusManager.prototype = {
            focus: function(a) {
                this._.timer && clearTimeout(this._.timer);
                if (a) this.currentActive = a;
                if (!this.hasFocus && !this._.locked) {
                    (a = CKEDITOR.currentInstance) && a.focusManager.blur(1);
                    this.hasFocus = true;
                    (a = this._.editor.container) && a.addClass("cke_focus") && $(a.$.previousElementSibling).addClass("et__drag-panel-wrapper_editing-widget");
                    this._.editor.fire("focus")
                }
            },
            lock: function() {
                this._.locked = 1
            },
            unlock: function() {
                delete this._.locked
            },
            blur: function(a) {
                function e() {
                    if (this.hasFocus) {
                        this.hasFocus = false;
                        var a = this._.editor.container;
                        a && a.removeClass("cke_focus") && $(a.$.previousElementSibling).removeClass("et__drag-panel-wrapper_editing-widget");
                        this._.editor.fire("blur")
                    }
                }
                if (!this._.locked) {
                    this._.timer && clearTimeout(this._.timer);
                    var b = CKEDITOR.focusManager._.blurDelay;
                    a || !b ? e.call(this) : this._.timer = CKEDITOR.tools.setTimeout(function() {
                        delete this._.timer;
                        e.call(this)
                    }, b, this)
                }
            },
            add: function(a, e) {
                var b = a.getCustomData("focusmanager");
                if (!b || b != this) {
                    b && b.remove(a);
                    var b = "focus",
                        g = "blur";
                    if (e)
                        if (CKEDITOR.env.ie) {
                            b = "focusin";
                            g = "focusout"
                        } else CKEDITOR.event.useCapture = 1;
                    var c = {
                        blur: function() {
                            a.equals(this.currentActive) && this.blur()
                        },
                        focus: function() {
                            this.focus(a)
                        }
                    };
                    a.on(b, c.focus, this);
                    a.on(g, c.blur, this);
                    if (e) CKEDITOR.event.useCapture = 0;
                    a.setCustomData("focusmanager", this);
                    a.setCustomData("focusmanager_handlers", c)
                }
            },
            remove: function(a) {
                a.removeCustomData("focusmanager");
                var e = a.removeCustomData("focusmanager_handlers");
                a.removeListener("blur", e.blur);
                a.removeListener("focus", e.focus)
            }
        }
    }(), CKEDITOR.keystrokeHandler = function(a) {
        if (a.keystrokeHandler) return a.keystrokeHandler;
        this.keystrokes = {};
        this.blockedKeystrokes = {};
        this._ = {
            editor: a
        };
        return this
    },
    function() {
        var a,
            e = function(b) {
                var b = b.data,
                    c = b.getKeystroke(),
                    d = this.keystrokes[c],
                    e = this._.editor;
                a = e.fire("key", {
                    keyCode: c,
                    domEvent: b
                }) === false;
                if (!a) {
                    d && (a = e.execCommand(d, {
                        from: "keystrokeHandler"
                    }) !== false);
                    a || (a = !! this.blockedKeystrokes[c])
                }
                a && b.preventDefault(true);
                return !a
            }, b = function(b) {
                if (a) {
                    a = false;
                    b.data.preventDefault(true)
                }
            };
        CKEDITOR.keystrokeHandler.prototype = {
            attach: function(a) {
                a.on("keydown", e, this);
                if (CKEDITOR.env.gecko && CKEDITOR.env.mac) a.on("keypress", b, this)
            }
        }
    }(),
    function() {
        CKEDITOR.lang = {
            languages: {
                af: 1,
                ar: 1,
                bg: 1,
                bn: 1,
                bs: 1,
                ca: 1,
                cs: 1,
                cy: 1,
                da: 1,
                de: 1,
                el: 1,
                "en-au": 1,
                "en-ca": 1,
                "en-gb": 1,
                en: 1,
                eo: 1,
                es: 1,
                et: 1,
                eu: 1,
                fa: 1,
                fi: 1,
                fo: 1,
                "fr-ca": 1,
                fr: 1,
                gl: 1,
                gu: 1,
                he: 1,
                hi: 1,
                hr: 1,
                hu: 1,
                id: 1,
                is: 1,
                it: 1,
                ja: 1,
                ka: 1,
                km: 1,
                ko: 1,
                ku: 1,
                lt: 1,
                lv: 1,
                mk: 1,
                mn: 1,
                ms: 1,
                nb: 1,
                nl: 1,
                no: 1,
                pl: 1,
                "pt-br": 1,
                pt: 1,
                ro: 1,
                ru: 1,
                si: 1,
                sk: 1,
                sl: 1,
                sq: 1,
                "sr-latn": 1,
                sr: 1,
                sv: 1,
                th: 1,
                tr: 1,
                tt: 1,
                ug: 1,
                uk: 1,
                vi: 1,
                "zh-cn": 1,
                zh: 1
            },
            rtl: {
                ar: 1,
                fa: 1,
                he: 1,
                ku: 1,
                ug: 1,
                "en-za": 1
            },
            load: function(a, e, b) {
                if (!a || !CKEDITOR.lang.languages[a]) a = this.detect(e, a);
                var g = this,
                    e = function() {
                        g[a].dir =
                            g.rtl[a] ? "rtl" : "ltr";
                        b(a, g[a])
                    };
                this[a] ? e() : CKEDITOR.scriptLoader.load(CKEDITOR.getUrl("lang/" + a + ".js"), e, this)
            },
            detect: function(a, e) {
                var b = this.languages,
                    e = e || navigator.userLanguage || navigator.language || a,
                    g = e.toLowerCase().match(/([a-z]+)(?:-([a-z]+))?/),
                    c = g[1],
                    g = g[2];
                b[c + "-" + g] ? c = c + "-" + g : b[c] || (c = null);
                CKEDITOR.lang.detect = c ? function() {
                    return c
                } : function(a) {
                    return a
                };
                return c || a
            }
        }
    }(), CKEDITOR.scriptLoader = function() {
        var a = {}, e = {};
        return {
            load: function(b, g, c, d) {
                var j = typeof b == "string";
                j && (b = [b]);
                c || (c = CKEDITOR);
                var f = b.length,
                    h = [],
                    i = [],
                    k = function(a) {
                        g && (j ? g.call(c, a) : g.call(c, h, i))
                    };
                if (f === 0) k(true);
                else {
                    var n = function(a, b) {
                        (b ? h : i).push(a);
                        if (--f <= 0) {
                            d && CKEDITOR.document.getDocumentElement().removeStyle("cursor");
                            k(b)
                        }
                    }, o = function(b, c) {
                            a[b] = 1;
                            var d = e[b];
                            delete e[b];
                            for (var f = 0; f < d.length; f++) d[f](b, c)
                        }, q = function(b) {
                            if (a[b]) n(b, true);
                            else {
                                var c = e[b] || (e[b] = []);
                                c.push(n);
                                if (!(c.length > 1)) {
                                    var d = new CKEDITOR.dom.element("script");
                                    d.setAttributes({
                                        type: "text/javascript",
                                        src: b
                                    });
                                    if (g)
                                        if (CKEDITOR.env.ie &&
                                            CKEDITOR.env.version < 11) d.$.onreadystatechange = function() {
                                            if (d.$.readyState == "loaded" || d.$.readyState == "complete") {
                                                d.$.onreadystatechange = null;
                                                o(b, true)
                                            }
                                        };
                                        else {
                                            d.$.onload = function() {
                                                setTimeout(function() {
                                                    o(b, true)
                                                }, 0)
                                            };
                                            d.$.onerror = function() {
                                                o(b, false)
                                            }
                                        }
                                    d.appendTo(CKEDITOR.document.getHead())
                                }
                            }
                        };
                    d && CKEDITOR.document.getDocumentElement().setStyle("cursor", "wait");
                    for (var m = 0; m < f; m++) q(b[m])
                }
            },
            queue: function() {
                function a() {
                    var b;
                    (b = g[0]) && this.load(b.scriptUrl, b.callback, CKEDITOR, 0)
                }
                var g = [];
                return function(c,
                    d) {
                    var e = this;
                    g.push({
                        scriptUrl: c,
                        callback: function() {
                            d && d.apply(this, arguments);
                            g.shift();
                            a.call(e)
                        }
                    });
                    g.length == 1 && a.call(this)
                }
            }()
        }
    }(), CKEDITOR.resourceManager = function(a, e) {
        this.basePath = a;
        this.fileName = e;
        this.registered = {};
        this.loaded = {};
        this.externals = {};
        this._ = {
            waitingList: {}
        }
    }, CKEDITOR.resourceManager.prototype = {
        add: function(a, e) {
            if (this.registered[a]) throw '[CKEDITOR.resourceManager.add] The resource name "' + a + '" is already registered.';
            var b = this.registered[a] = e || {};
            b.name = a;
            b.path = this.getPath(a);
            CKEDITOR.fire(a + CKEDITOR.tools.capitalize(this.fileName) + "Ready", b);
            return this.get(a)
        },
        get: function(a) {
            return this.registered[a] || null
        },
        getPath: function(a) {
            var e = this.externals[a];
            return CKEDITOR.getUrl(e && e.dir || this.basePath + a + "/")
        },
        getFilePath: function(a) {
            var e = this.externals[a];
            return CKEDITOR.getUrl(this.getPath(a) + (e ? e.file : this.fileName + ".js"))
        },
        addExternal: function(a, e, b) {
            for (var a = a.split(","), g = 0; g < a.length; g++) {
                var c = a[g];
                b || (e = e.replace(/[^\/]+$/, function(a) {
                    b = a;
                    return ""
                }));
                this.externals[c] = {
                    dir: e,
                    file: b || this.fileName + ".js"
                }
            }
        },
        load: function(a, e, b) {
            CKEDITOR.tools.isArray(a) || (a = a ? [a] : []);
            for (var g = this.loaded, c = this.registered, d = [], j = {}, f = {}, h = 0; h < a.length; h++) {
                var i = a[h];
                if (i)
                    if (!g[i] && !c[i]) {
                        var k = this.getFilePath(i);
                        d.push(k);
                        k in j || (j[k] = []);
                        j[k].push(i)
                    } else f[i] = this.get(i)
            }
            CKEDITOR.scriptLoader.load(d, function(a, c) {
                if (c.length) throw '[CKEDITOR.resourceManager.load] Resource name "' + j[c[0]].join(",") + '" was not found at "' + c[0] + '".';
                for (var d = 0; d < a.length; d++)
                    for (var h = j[a[d]],
                            i = 0; i < h.length; i++) {
                        var p = h[i];
                        f[p] = this.get(p);
                        g[p] = 1
                    }
                e.call(b, f)
            }, this)
        }
    }, CKEDITOR.plugins = new CKEDITOR.resourceManager("plugins/", "plugin"), CKEDITOR.plugins.load = CKEDITOR.tools.override(CKEDITOR.plugins.load, function(a) {
        var e = {};
        return function(b, g, c) {
            var d = {}, j = function(b) {
                    a.call(this, b, function(a) {
                        CKEDITOR.tools.extend(d, a);
                        var b = [],
                            f;
                        for (f in a) {
                            var n = a[f],
                                o = n && n.requires;
                            if (!e[f]) {
                                if (n.icons)
                                    for (var q = n.icons.split(","), m = q.length; m--;) CKEDITOR.skin.addIcon(q[m], n.path + "icons/" + (CKEDITOR.env.hidpi &&
                                        n.hidpi ? "hidpi/" : "") + q[m] + ".png");
                                e[f] = 1
                            }
                            if (o) {
                                o.split && (o = o.split(","));
                                for (n = 0; n < o.length; n++) d[o[n]] || b.push(o[n])
                            }
                        }
                        if (b.length) j.call(this, b);
                        else {
                            for (f in d) {
                                n = d[f];
                                if (n.onLoad && !n.onLoad._called) {
                                    n.onLoad() === false && delete d[f];
                                    n.onLoad._called = 1
                                }
                            }
                            g && g.call(c || window, d)
                        }
                    }, this)
                };
            j.call(this, b)
        }
    }), CKEDITOR.plugins.setLang = function(a, e, b) {
        var g = this.get(a),
            a = g.langEntries || (g.langEntries = {}),
            g = g.lang || (g.lang = []);
        g.split && (g = g.split(","));
        CKEDITOR.tools.indexOf(g, e) == -1 && g.push(e);
        a[e] = b
    }, CKEDITOR.ui =
        function(a) {
            if (a.ui) return a.ui;
            this.items = {};
            this.instances = {};
            this.editor = a;
            this._ = {
                handlers: {}
            };
            return this
    }, CKEDITOR.ui.prototype = {
        add: function(a, e, b) {
            b.name = a.toLowerCase();
            var g = this.items[a] = {
                type: e,
                command: b.command || null,
                args: Array.prototype.slice.call(arguments, 2)
            };
            CKEDITOR.tools.extend(g, b)
        },
        get: function(a) {
            return this.instances[a]
        },
        create: function(a) {
            var e = this.items[a],
                b = e && this._.handlers[e.type],
                g = e && e.command && this.editor.getCommand(e.command),
                b = b && b.create.apply(this, e.args);
            this.instances[a] =
                b;
            g && g.uiItems.push(b);
            if (b && !b.type) b.type = e.type;
            return b
        },
        addHandler: function(a, e) {
            this._.handlers[a] = e
        },
        space: function(a) {
            return CKEDITOR.document.getById(this.spaceId(a))
        },
        spaceId: function(a) {
            return this.editor.id + "_" + a
        }
    }, CKEDITOR.event.implementOn(CKEDITOR.ui),
    function() {
        function a(a, d, f) {
            CKEDITOR.event.call(this);
            a = a && CKEDITOR.tools.clone(a);
            if (d !== void 0) {
                if (d instanceof CKEDITOR.dom.element) {
                    if (!f) throw Error("One of the element modes must be specified.");
                } else throw Error("Expect element of type CKEDITOR.dom.element.");
                if (CKEDITOR.env.ie && CKEDITOR.env.quirks && f == CKEDITOR.ELEMENT_MODE_INLINE) throw Error("Inline element mode is not supported on IE quirks.");
                if (!(f == CKEDITOR.ELEMENT_MODE_INLINE ? d.is(CKEDITOR.dtd.$editable) || d.is("textarea") : f == CKEDITOR.ELEMENT_MODE_REPLACE ? !d.is(CKEDITOR.dtd.$nonBodyContent) : 1)) throw Error('The specified element mode is not supported on element: "' + d.getName() + '".');
                this.element = d;
                this.elementMode = f;
                this.name = this.elementMode != CKEDITOR.ELEMENT_MODE_APPENDTO && (d.getId() || d.getNameAtt())
            } else this.elementMode =
                CKEDITOR.ELEMENT_MODE_NONE;
            this._ = {};
            this.commands = {};
            this.templates = {};
            this.name = this.name || e();
            this.id = CKEDITOR.tools.getNextId();
            this.status = "unloaded";
            this.config = CKEDITOR.tools.prototypedCopy(CKEDITOR.config);
            this.ui = new CKEDITOR.ui(this);
            this.focusManager = new CKEDITOR.focusManager(this);
            this.keystrokeHandler = new CKEDITOR.keystrokeHandler(this);
            this.on("readOnly", b);
            this.on("selectionChange", function(a) {
                c(this, a.data.path)
            });
            this.on("activeFilterChange", function() {
                c(this, this.elementPath(), true)
            });
            this.on("mode", b);
            this.on("instanceReady", function() {
                this.config.startupFocus && this.focus()
            });
            CKEDITOR.fire("instanceCreated", null, this);
            CKEDITOR.add(this);
            CKEDITOR.tools.setTimeout(function() {
                j(this, a)
            }, 0, this)
        }

        function e() {
            do var a = "editor" + ++o; while (CKEDITOR.instances[a]);
            return a
        }

        function b() {
            var a = this.commands,
                b;
            for (b in a) g(this, a[b])
        }

        function g(a, b) {
            b[b.startDisabled ? "disable" : a.readOnly && !b.readOnly ? "disable" : b.modes[a.mode] ? "enable" : "disable"]()
        }

        function c(a, b, c) {
            if (b) {
                var d, f, g = a.commands;
                for (f in g) {
                    d = g[f];
                    (c || d.contextSensitive) && d.refresh(a, b)
                }
            }
        }

        function d(a) {
            var b = a.config.customConfig;
            if (!b) return false;
            var b = CKEDITOR.getUrl(b),
                c = q[b] || (q[b] = {});
            if (c.fn) {
                c.fn.call(a, a.config);
                (CKEDITOR.getUrl(a.config.customConfig) == b || !d(a)) && a.fireOnce("customConfigLoaded")
            } else CKEDITOR.scriptLoader.queue(b, function() {
                c.fn = CKEDITOR.editorConfig ? CKEDITOR.editorConfig : function() {};
                d(a)
            });
            return true
        }

        function j(a, b) {
            a.on("customConfigLoaded", function() {
                if (b) {
                    if (b.on)
                        for (var c in b.on) a.on(c, b.on[c]);
                    CKEDITOR.tools.extend(a.config, b, true);
                    delete a.config.on
                }
                c = a.config;
                a.readOnly = !(!c.readOnly && !(a.elementMode == CKEDITOR.ELEMENT_MODE_INLINE ? a.element.is("textarea") ? a.element.hasAttribute("disabled") : a.element.isReadOnly() : a.elementMode == CKEDITOR.ELEMENT_MODE_REPLACE && a.element.hasAttribute("disabled")));
                a.blockless = a.elementMode == CKEDITOR.ELEMENT_MODE_INLINE ? !(a.element.is("textarea") || CKEDITOR.dtd[a.element.getName()].p) : false;
                a.tabIndex = c.tabIndex || a.element && a.element.getAttribute("tabindex") ||
                    0;
                a.activeEnterMode = a.enterMode = a.blockless ? CKEDITOR.ENTER_BR : c.enterMode;
                a.activeShiftEnterMode = a.shiftEnterMode = a.blockless ? CKEDITOR.ENTER_BR : c.shiftEnterMode;
                if (c.skin) CKEDITOR.skinName = c.skin;
                a.fireOnce("configLoaded");
                a.dataProcessor = new CKEDITOR.htmlDataProcessor(a);
                a.filter = a.activeFilter = new CKEDITOR.filter(a);
                f(a)
            });
            if (b && b.customConfig != null) a.config.customConfig = b.customConfig;
            d(a) || a.fireOnce("customConfigLoaded")
        }

        function f(a) {
            CKEDITOR.skin.loadPart("editor", function() {
                h(a)
            })
        }

        function h(a) {
            CKEDITOR.lang.load(a.config.language,
                a.config.defaultLanguage, function(b, c) {
                    var d = a.config.title;
                    a.langCode = b;
                    a.lang = CKEDITOR.tools.prototypedCopy(c);
                    a.title = typeof d == "string" || d === false ? d : [a.lang.editor, a.name].join(", ");
                    if (!a.config.contentsLangDirection) a.config.contentsLangDirection = a.elementMode == CKEDITOR.ELEMENT_MODE_INLINE ? a.element.getDirection(1) : a.lang.dir;
                    a.fire("langLoaded");
                    i(a)
                })
        }

        function i(a) {
            a.getStylesSet(function(b) {
                a.once("loaded", function() {
                    a.fire("stylesSet", {
                        styles: b
                    })
                }, null, null, 1);
                k(a)
            })
        }

        function k(a) {
            var b =
                a.config,
                c = b.plugins,
                d = b.extraPlugins,
                f = b.removePlugins;
            if (d) var g = RegExp("(?:^|,)(?:" + d.replace(/\s*,\s*/g, "|") + ")(?=,|$)", "g"),
            c = c.replace(g, ""), c = c + ("," + d);
            if (f) var h = RegExp("(?:^|,)(?:" + f.replace(/\s*,\s*/g, "|") + ")(?=,|$)", "g"),
            c = c.replace(h, "");
            CKEDITOR.env.air && (c = c + ",adobeair");
            CKEDITOR.plugins.load(c.split(","), function(c) {
                var d = [],
                    f = [],
                    g = [];
                a.plugins = c;
                for (var e in c) {
                    var j = c[e],
                        i = j.lang,
                        p = null,
                        t = j.requires,
                        k;
                    CKEDITOR.tools.isArray(t) && (t = t.join(","));
                    if (t && (k = t.match(h)))
                        for (; t = k.pop();) CKEDITOR.tools.setTimeout(function(a,
                            b) {
                            throw Error('Plugin "' + a.replace(",", "") + '" cannot be removed from the plugins list, because it\'s required by "' + b + '" plugin.');
                        }, 0, null, [t, e]);
                    if (i && !a.lang[e]) {
                        i.split && (i = i.split(","));
                        if (CKEDITOR.tools.indexOf(i, a.langCode) >= 0) p = a.langCode;
                        else {
                            p = a.langCode.replace(/-.*/, "");
                            p = p != a.langCode && CKEDITOR.tools.indexOf(i, p) >= 0 ? p : CKEDITOR.tools.indexOf(i, "en") >= 0 ? "en" : i[0]
                        } if (!j.langEntries || !j.langEntries[p]) g.push(CKEDITOR.getUrl(j.path + "lang/" + p + ".js"));
                        else {
                            a.lang[e] = j.langEntries[p];
                            p = null
                        }
                    }
                    f.push(p);
                    d.push(j)
                }
                CKEDITOR.scriptLoader.load(g, function() {
                    for (var c = ["beforeInit", "init", "afterInit"], g = 0; g < c.length; g++)
                        for (var h = 0; h < d.length; h++) {
                            var e = d[h];
                            g === 0 && (f[h] && e.lang && e.langEntries) && (a.lang[e.name] = e.langEntries[f[h]]);
                            if (e[c[g]]) e[c[g]](a)
                        }
                    a.fireOnce("pluginsLoaded");
                    b.keystrokes && a.setKeystroke(a.config.keystrokes);
                    for (h = 0; h < a.config.blockedKeystrokes.length; h++) a.keystrokeHandler.blockedKeystrokes[a.config.blockedKeystrokes[h]] = 1;
                    a.status = "loaded";
                    a.fireOnce("loaded");
                    CKEDITOR.fire("instanceLoaded",
                        null, a)
                })
            })
        }

        function n() {
            var a = this.element;
            if (a && this.elementMode != CKEDITOR.ELEMENT_MODE_APPENDTO) {
                var b = this.getData();
                this.config.htmlEncodeOutput && (b = CKEDITOR.tools.htmlEncode(b));
                a.is("textarea") ? a.setValue(b) : a.setHtml(b);
                return true
            }
            return false
        }
        a.prototype = CKEDITOR.editor.prototype;
        CKEDITOR.editor = a;
        var o = 0,
            q = {};
        CKEDITOR.tools.extend(CKEDITOR.editor.prototype, {
            addCommand: function(a, b) {
                b.name = a.toLowerCase();
                var c = new CKEDITOR.command(this, b);
                this.mode && g(this, c);
                return this.commands[a] = c
            },
            _attachToForm: function() {
                function a(d) {
                    b.updateElement();
                    b._.required && (!c.getValue() && b.fire("required") === false) && d.data.preventDefault()
                }
                var b = this,
                    c = b.element,
                    d = new CKEDITOR.dom.element(c.$.form);
                if (c.is("textarea") && d) {
                    d.on("submit", a);
                    if (d.$.submit && d.$.submit.call && d.$.submit.apply) d.$.submit = CKEDITOR.tools.override(d.$.submit, function(b) {
                        return function() {
                            a();
                            b.apply ? b.apply(this) : b()
                        }
                    });
                    b.on("destroy", function() {
                        d.removeListener("submit", a)
                    })
                }
            },
            destroy: function(a) {
                this.fire("beforeDestroy");
                !a && n.call(this);
                this.editable(null);
                this.filter.destroy();
                delete this.filter;
                delete this.activeFilter;
                this.status = "destroyed";
                this.fire("destroy");
                this.removeAllListeners();
                CKEDITOR.remove(this);
                CKEDITOR.fire("instanceDestroyed", null, this)
            },
            elementPath: function(a) {
                if (!a) {
                    a = this.getSelection();
                    if (!a) return null;
                    a = a.getStartElement()
                }
                return a ? new CKEDITOR.dom.elementPath(a, this.editable()) : null
            },
            createRange: function() {
                var a = this.editable();
                return a ? new CKEDITOR.dom.range(a) : null
            },
            execCommand: function(a,
                b) {
                var c = this.getCommand(a),
                    d = {
                        name: a,
                        commandData: b,
                        command: c
                    };
                if (c && c.state != CKEDITOR.TRISTATE_DISABLED && this.fire("beforeCommandExec", d) !== false) {
                    d.returnValue = c.exec(d.commandData);
                    if (!c.async && this.fire("afterCommandExec", d) !== false) return d.returnValue
                }
                return false
            },
            getCommand: function(a) {
                return this.commands[a]
            },
            getData: function(a) {
                !a && this.fire("beforeGetData");
                var b = this._.data;
                if (typeof b != "string") b = (b = this.element) && this.elementMode == CKEDITOR.ELEMENT_MODE_REPLACE ? b.is("textarea") ? b.getValue() :
                    b.getHtml() : "";
                b = {
                    dataValue: b
                };
                !a && this.fire("getData", b);
                return b.dataValue
            },
            getSnapshot: function() {
                var a = this.fire("getSnapshot");
                if (typeof a != "string") {
                    var b = this.element;
                    b && this.elementMode == CKEDITOR.ELEMENT_MODE_REPLACE && (a = b.is("textarea") ? b.getValue() : b.getHtml())
                }
                return a
            },
            loadSnapshot: function(a) {
                this.fire("loadSnapshot", a)
            },
            setData: function(a, b, c) {
                var d = true,
                    f = b;
                if (b && typeof b == "object") {
                    c = b.internal;
                    f = b.callback;
                    d = !b.noSnapshot
                }!c && d && this.fire("saveSnapshot");
                if (f || !c) this.once("dataReady",
                    function(a) {
                        !c && d && this.fire("saveSnapshot");
                        f && f.call(a.editor)
                    });
                a = {
                    dataValue: a
                };
                !c && this.fire("setData", a);
                this._.data = a.dataValue;
                !c && this.fire("afterSetData", a)
            },
            setReadOnly: function(a) {
                a = a == null || a;
                if (this.readOnly != a) {
                    this.readOnly = a;
                    this.keystrokeHandler.blockedKeystrokes[8] = +a;
                    this.editable().setReadOnly(a);
                    this.fire("readOnly")
                }
            },
            insertHtml: function(a, b) {
                this.fire("insertHtml", {
                    dataValue: a,
                    mode: b
                })
            },
            insertText: function(a) {
                this.fire("insertText", a)
            },
            insertElement: function(a) {
                this.fire("insertElement",
                    a)
            },
            focus: function() {
                this.fire("beforeFocus")
            },
            checkDirty: function() {
                return this.status == "ready" && this._.previousValue !== this.getSnapshot()
            },
            resetDirty: function() {
                this._.previousValue = this.getSnapshot()
            },
            updateElement: function() {
                return n.call(this)
            },
            setKeystroke: function() {
                for (var a = this.keystrokeHandler.keystrokes, b = CKEDITOR.tools.isArray(arguments[0]) ? arguments[0] : [
                        [].slice.call(arguments, 0)
                    ], c, d, f = b.length; f--;) {
                    c = b[f];
                    d = 0;
                    if (CKEDITOR.tools.isArray(c)) {
                        d = c[1];
                        c = c[0]
                    }
                    d ? a[c] = d : delete a[c]
                }
            },
            addFeature: function(a) {
                return this.filter.addFeature(a)
            },
            setActiveFilter: function(a) {
                if (!a) a = this.filter;
                if (this.activeFilter !== a) {
                    this.activeFilter = a;
                    this.fire("activeFilterChange");
                    a === this.filter ? this.setActiveEnterMode(null, null) : this.setActiveEnterMode(a.getAllowedEnterMode(this.enterMode), a.getAllowedEnterMode(this.shiftEnterMode, true))
                }
            },
            setActiveEnterMode: function(a, b) {
                a = a ? this.blockless ? CKEDITOR.ENTER_BR : a : this.enterMode;
                b = b ? this.blockless ? CKEDITOR.ENTER_BR : b : this.shiftEnterMode;
                if (this.activeEnterMode != a || this.activeShiftEnterMode != b) {
                    this.activeEnterMode =
                        a;
                    this.activeShiftEnterMode = b;
                    this.fire("activeEnterModeChange")
                }
            }
        })
    }(), CKEDITOR.ELEMENT_MODE_NONE = 0, CKEDITOR.ELEMENT_MODE_REPLACE = 1, CKEDITOR.ELEMENT_MODE_APPENDTO = 2, CKEDITOR.ELEMENT_MODE_INLINE = 3, CKEDITOR.htmlParser = function() {
        this._ = {
            htmlPartsRegex: /<(?:(?:\/([^>]+)>)|(?:!--([\S|\s]*?)--\>)|(?:([^\/\s>]+)((?:\s+[\w\-:.]+(?:\s*=\s*?(?:(?:"[^"]*")|(?:'[^']*')|[^\s"'\/>]+))?)*)[\S\s]*?(\/?)>))/g
        }
    },
    function() {
        var a = /([\w\-:.]+)(?:(?:\s*=\s*(?:(?:"([^"]*)")|(?:'([^']*)')|([^\s>]+)))|(?=\s|$))/g,
            e = {
                checked: 1,
                compact: 1,
                declare: 1,
                defer: 1,
                disabled: 1,
                ismap: 1,
                multiple: 1,
                nohref: 1,
                noresize: 1,
                noshade: 1,
                nowrap: 1,
                readonly: 1,
                selected: 1
            };
        CKEDITOR.htmlParser.prototype = {
            onTagOpen: function() {},
            onTagClose: function() {},
            onText: function() {},
            onCDATA: function() {},
            onComment: function() {},
            parse: function(b) {
                for (var g, c, d = 0, j; g = this._.htmlPartsRegex.exec(b);) {
                    c = g.index;
                    if (c > d) {
                        d = b.substring(d, c);
                        if (j) j.push(d);
                        else this.onText(d)
                    }
                    d = this._.htmlPartsRegex.lastIndex;
                    if (c = g[1]) {
                        c = c.toLowerCase();
                        if (j && CKEDITOR.dtd.$cdata[c]) {
                            this.onCDATA(j.join(""));
                            j = null
                        }
                        if (!j) {
                            this.onTagClose(c);
                            continue
                        }
                    }
                    if (j) j.push(g[0]);
                    else if (c = g[3]) {
                        c = c.toLowerCase();
                        if (!/="/.test(c)) {
                            var f = {}, h, i = g[4];
                            g = !! g[5];
                            if (i)
                                for (; h = a.exec(i);) {
                                    var k = h[1].toLowerCase();
                                    h = h[2] || h[3] || h[4] || "";
                                    f[k] = !h && e[k] ? k : CKEDITOR.tools.htmlDecodeAttr(h)
                                }
                            this.onTagOpen(c, f, g);
                            !j && CKEDITOR.dtd.$cdata[c] && (j = [])
                        }
                    } else if (c = g[2]) this.onComment(c)
                }
                if (b.length > d) this.onText(b.substring(d, b.length))
            }
        }
    }(), CKEDITOR.htmlParser.basicWriter = CKEDITOR.tools.createClass({
        $: function() {
            this._ = {
                output: []
            }
        },
        proto: {
            openTag: function(a) {
                this._.output.push("<", a)
            },
            openTagClose: function(a, e) {
                e ? this._.output.push(" />") : this._.output.push(">")
            },
            attribute: function(a, e) {
                typeof e == "string" && (e = CKEDITOR.tools.htmlEncodeAttr(e));
                this._.output.push(" ", a, '="', e, '"')
            },
            closeTag: function(a) {
                this._.output.push("</", a, ">")
            },
            text: function(a) {
                this._.output.push(a)
            },
            comment: function(a) {
                this._.output.push("<\!--", a, "--\>")
            },
            write: function(a) {
                this._.output.push(a)
            },
            reset: function() {
                this._.output = [];
                this._.indent = false
            },
            getHtml: function(a) {
                var e =
                    this._.output.join("");
                a && this.reset();
                return e
            }
        }
    }), "use strict",
    function() {
        CKEDITOR.htmlParser.node = function() {};
        CKEDITOR.htmlParser.node.prototype = {
            remove: function() {
                var a = this.parent.children,
                    e = CKEDITOR.tools.indexOf(a, this),
                    b = this.previous,
                    g = this.next;
                b && (b.next = g);
                g && (g.previous = b);
                a.splice(e, 1);
                this.parent = null
            },
            replaceWith: function(a) {
                var e = this.parent.children,
                    b = CKEDITOR.tools.indexOf(e, this),
                    g = a.previous = this.previous,
                    c = a.next = this.next;
                g && (g.next = a);
                c && (c.previous = a);
                e[b] = a;
                a.parent = this.parent;
                this.parent = null
            },
            insertAfter: function(a) {
                var e = a.parent.children,
                    b = CKEDITOR.tools.indexOf(e, a),
                    g = a.next;
                e.splice(b + 1, 0, this);
                this.next = a.next;
                this.previous = a;
                a.next = this;
                g && (g.previous = this);
                this.parent = a.parent
            },
            insertBefore: function(a) {
                var e = a.parent.children,
                    b = CKEDITOR.tools.indexOf(e, a);
                e.splice(b, 0, this);
                this.next = a;
                (this.previous = a.previous) && (a.previous.next = this);
                a.previous = this;
                this.parent = a.parent
            },
            getAscendant: function(a) {
                var e = typeof a == "function" ? a : typeof a == "string" ? function(b) {
                        return b.name ==
                            a
                    } : function(b) {
                        return b.name in a
                    }, b = this.parent;
                for (; b && b.type == CKEDITOR.NODE_ELEMENT;) {
                    if (e(b)) return b;
                    b = b.parent
                }
                return null
            },
            wrapWith: function(a) {
                this.replaceWith(a);
                a.add(this);
                return a
            },
            getIndex: function() {
                return CKEDITOR.tools.indexOf(this.parent.children, this)
            },
            getFilterContext: function(a) {
                return a || {}
            }
        }
    }(), "use strict", CKEDITOR.htmlParser.comment = function(a) {
        this.value = a;
        this._ = {
            isBlockLike: false
        }
    }, CKEDITOR.htmlParser.comment.prototype = CKEDITOR.tools.extend(new CKEDITOR.htmlParser.node, {
        type: CKEDITOR.NODE_COMMENT,
        filter: function(a, e) {
            var b = this.value;
            if (!(b = a.onComment(e, b, this))) {
                this.remove();
                return false
            }
            if (typeof b != "string") {
                this.replaceWith(b);
                return false
            }
            this.value = b;
            return true
        },
        writeHtml: function(a, e) {
            e && this.filter(e);
            a.comment(this.value)
        }
    }), "use strict",
    function() {
        CKEDITOR.htmlParser.text = function(a) {
            this.value = a;
            this._ = {
                isBlockLike: false
            }
        };
        CKEDITOR.htmlParser.text.prototype = CKEDITOR.tools.extend(new CKEDITOR.htmlParser.node, {
            type: CKEDITOR.NODE_TEXT,
            filter: function(a,
                e) {
                if (!(this.value = a.onText(e, this.value, this))) {
                    this.remove();
                    return false
                }
            },
            writeHtml: function(a, e) {
                e && this.filter(e);
                a.text(this.value)
            }
        })
    }(), "use strict",
    function() {
        CKEDITOR.htmlParser.cdata = function(a) {
            this.value = a
        };
        CKEDITOR.htmlParser.cdata.prototype = CKEDITOR.tools.extend(new CKEDITOR.htmlParser.node, {
            type: CKEDITOR.NODE_TEXT,
            filter: function() {},
            writeHtml: function(a) {
                a.write(this.value)
            }
        })
    }(), "use strict", CKEDITOR.htmlParser.fragment = function() {
        this.children = [];
        this.parent = null;
        this._ = {
            isBlockLike: true,
            hasInlineStarted: false
        }
    },
    function() {
        function a(a) {
            return a.attributes["data-cke-survive"] ? false : a.name == "a" && a.attributes.href || CKEDITOR.dtd.$removeEmpty[a.name]
        }
        var e = CKEDITOR.tools.extend({
            table: 1,
            ul: 1,
            ol: 1,
            dl: 1
        }, CKEDITOR.dtd.table, CKEDITOR.dtd.ul, CKEDITOR.dtd.ol, CKEDITOR.dtd.dl),
            b = {
                ol: 1,
                ul: 1
            }, g = CKEDITOR.tools.extend({}, {
                html: 1
            }, CKEDITOR.dtd.html, CKEDITOR.dtd.body, CKEDITOR.dtd.head, {
                style: 1,
                script: 1
            }),
            c = {
                ul: "li",
                ol: "li",
                dl: "dd",
                table: "tbody",
                tbody: "tr",
                thead: "tr",
                tfoot: "tr",
                tr: "td"
            };
        CKEDITOR.htmlParser.fragment.fromHtml =
            function(d, j, f) {
                function h(a) {
                    var b;
                    if (p.length > 0)
                        for (var c = 0; c < p.length; c++) {
                            var d = p[c],
                                f = d.name,
                                g = CKEDITOR.dtd[f],
                                h = s.name && CKEDITOR.dtd[s.name];
                            if ((!h || h[f]) && (!a || !g || g[a] || !CKEDITOR.dtd[a])) {
                                if (!b) {
                                    i();
                                    b = 1
                                }
                                d = d.clone();
                                d.parent = s;
                                s = d;
                                p.splice(c, 1);
                                c--
                            } else if (f == s.name) {
                                n(s, s.parent, 1);
                                c--
                            }
                        }
                }

                function i() {
                    for (; t.length;) n(t.shift(), s)
                }

                function k(a) {
                    if (a._.isBlockLike && a.name != "pre" && a.name != "textarea") {
                        var b = a.children.length,
                            c = a.children[b - 1],
                            d;
                        if (c && c.type == CKEDITOR.NODE_TEXT)(d = CKEDITOR.tools.rtrim(c.value)) ?
                            c.value = d : a.children.length = b - 1
                    }
                }

                function n(b, c, d) {
                    var c = c || s || l,
                        g = s;
                    if (b.previous === void 0) {
                        if (o(c, b)) {
                            s = c;
                            m.onTagOpen(f, {});
                            b.returnPoint = c = s
                        }
                        k(b);
                        (!a(b) || b.children.length) && c.add(b);
                        b.name == "pre" && (w = false);
                        b.name == "textarea" && (u = false)
                    }
                    if (b.returnPoint) {
                        s = b.returnPoint;
                        delete b.returnPoint
                    } else s = d ? c : g
                }

                function o(a, b) {
                    if ((a == l || a.name == "body") && f && (!a.name || CKEDITOR.dtd[a.name][f])) {
                        var c, d;
                        return (c = b.attributes && (d = b.attributes["data-cke-real-element-type"]) ? d : b.name) && c in CKEDITOR.dtd.$inline && !(c in CKEDITOR.dtd.head) && !b.isOrphan || b.type == CKEDITOR.NODE_TEXT
                    }
                }

                function q(a, b) {
                    return a in CKEDITOR.dtd.$listItem || a in CKEDITOR.dtd.$tableContent ? a == b || a == "dt" && b == "dd" || a == "dd" && b == "dt" : false
                }
                var m = new CKEDITOR.htmlParser,
                    l = j instanceof CKEDITOR.htmlParser.element ? j : typeof j == "string" ? new CKEDITOR.htmlParser.element(j) : new CKEDITOR.htmlParser.fragment,
                    p = [],
                    t = [],
                    s = l,
                    u = l.name == "textarea",
                    w = l.name == "pre";
                m.onTagOpen = function(c, d, f, j) {
                    d = new CKEDITOR.htmlParser.element(c, d);
                    if (d.isUnknown && f) d.isEmpty =
                        true;
                    d.isOptionalClose = j;
                    if (a(d)) p.push(d);
                    else {
                        if (c == "pre") w = true;
                        else {
                            if (c == "br" && w) {
                                s.add(new CKEDITOR.htmlParser.text("\n"));
                                return
                            }
                            c == "textarea" && (u = true)
                        } if (c == "br") t.push(d);
                        else {
                            for (;;) {
                                j = (f = s.name) ? CKEDITOR.dtd[f] || (s._.isBlockLike ? CKEDITOR.dtd.div : CKEDITOR.dtd.span) : g;
                                if (!d.isUnknown && !s.isUnknown && !j[c])
                                    if (s.isOptionalClose) m.onTagClose(f);
                                    else if (c in b && f in b) {
                                    f = s.children;
                                    (f = f[f.length - 1]) && f.name == "li" || n(f = new CKEDITOR.htmlParser.element("li"), s);
                                    !d.returnPoint && (d.returnPoint = s);
                                    s = f
                                } else if (c in CKEDITOR.dtd.$listItem && !q(c, f)) m.onTagOpen(c == "li" ? "ul" : "dl", {}, 0, 1);
                                else if (f in e && !q(c, f)) {
                                    !d.returnPoint && (d.returnPoint = s);
                                    s = s.parent
                                } else {
                                    f in CKEDITOR.dtd.$inline && p.unshift(s);
                                    if (s.parent) n(s, s.parent, 1);
                                    else {
                                        d.isOrphan = 1;
                                        break
                                    }
                                } else break
                            }
                            h(c);
                            i();
                            d.parent = s;
                            d.isEmpty ? n(d) : s = d
                        }
                    }
                };
                m.onTagClose = function(a) {
                    for (var b = p.length - 1; b >= 0; b--)
                        if (a == p[b].name) {
                            p.splice(b, 1);
                            return
                        }
                    for (var c = [], d = [], g = s; g != l && g.name != a;) {
                        g._.isBlockLike || d.unshift(g);
                        c.push(g);
                        g = g.returnPoint || g.parent
                    }
                    if (g !=
                        l) {
                        for (b = 0; b < c.length; b++) {
                            var h = c[b];
                            n(h, h.parent)
                        }
                        s = g;
                        g._.isBlockLike && i();
                        n(g, g.parent);
                        if (g == s) s = s.parent;
                        p = p.concat(d)
                    }
                    a == "body" && (f = false)
                };
                m.onText = function(a) {
                    if ((!s._.hasInlineStarted || t.length) && !w && !u) {
                        a = CKEDITOR.tools.ltrim(a);
                        if (a.length === 0) return
                    }
                    var b = s.name,
                        d = b ? CKEDITOR.dtd[b] || (s._.isBlockLike ? CKEDITOR.dtd.div : CKEDITOR.dtd.span) : g;
                    if (!u && !d["#"] && b in e) {
                        m.onTagOpen(c[b] || "");
                        m.onText(a)
                    } else {
                        i();
                        h();
                        !w && !u && (a = a.replace(/[\t\r\n ]{2,}|[\t\r\n]/g, " "));
                        a = new CKEDITOR.htmlParser.text(a);
                        if (o(s, a)) this.onTagOpen(f, {}, 0, 1);
                        s.add(a)
                    }
                };
                m.onCDATA = function(a) {
                    s.add(new CKEDITOR.htmlParser.cdata(a))
                };
                m.onComment = function(a) {
                    i();
                    h();
                    s.add(new CKEDITOR.htmlParser.comment(a))
                };
                m.parse(d);
                for (i(); s != l;) n(s, s.parent, 1);
                k(l);
                return l
        };
        CKEDITOR.htmlParser.fragment.prototype = {
            type: CKEDITOR.NODE_DOCUMENT_FRAGMENT,
            add: function(a, b) {
                isNaN(b) && (b = this.children.length);
                var c = b > 0 ? this.children[b - 1] : null;
                if (c) {
                    if (a._.isBlockLike && c.type == CKEDITOR.NODE_TEXT) {
                        c.value = CKEDITOR.tools.rtrim(c.value);
                        if (c.value.length ===
                            0) {
                            this.children.pop();
                            this.add(a);
                            return
                        }
                    }
                    c.next = a
                }
                a.previous = c;
                a.parent = this;
                this.children.splice(b, 0, a);
                if (!this._.hasInlineStarted) this._.hasInlineStarted = a.type == CKEDITOR.NODE_TEXT || a.type == CKEDITOR.NODE_ELEMENT && !a._.isBlockLike
            },
            filter: function(a, b) {
                b = this.getFilterContext(b);
                a.onRoot(b, this);
                this.filterChildren(a, false, b)
            },
            filterChildren: function(a, b, c) {
                if (this.childrenFilteredBy != a.id) {
                    c = this.getFilterContext(c);
                    if (b && !this.parent) a.onRoot(c, this);
                    this.childrenFilteredBy = a.id;
                    for (b = 0; b < this.children.length; b++) this.children[b].filter(a,
                        c) === false && b--
                }
            },
            writeHtml: function(a, b) {
                b && this.filter(b);
                this.writeChildrenHtml(a)
            },
            writeChildrenHtml: function(a, b, c) {
                var g = this.getFilterContext();
                if (c && !this.parent && b) b.onRoot(g, this);
                b && this.filterChildren(b, false, g);
                b = 0;
                c = this.children;
                for (g = c.length; b < g; b++) c[b].writeHtml(a)
            },
            forEach: function(a, b, c) {
                if (!c && (!b || this.type == b)) var g = a(this);
                if (g !== false)
                    for (var c = this.children, e = 0; e < c.length; e++) {
                        g = c[e];
                        g.type == CKEDITOR.NODE_ELEMENT ? g.forEach(a, b) : (!b || g.type == b) && a(g)
                    }
            },
            getFilterContext: function(a) {
                return a || {}
            }
        }
    }(), "use strict",
    function() {
        function a() {
            this.rules = []
        }

        function e(b, g, c, d) {
            var e, f;
            for (e in g) {
                (f = b[e]) || (f = b[e] = new a);
                f.add(g[e], c, d)
            }
        }
        CKEDITOR.htmlParser.filter = CKEDITOR.tools.createClass({
            $: function(b) {
                this.id = CKEDITOR.tools.getNextNumber();
                this.elementNameRules = new a;
                this.attributeNameRules = new a;
                this.elementsRules = {};
                this.attributesRules = {};
                this.textRules = new a;
                this.commentRules = new a;
                this.rootRules = new a;
                b && this.addRules(b, 10)
            },
            proto: {
                addRules: function(a, g) {
                    var c;
                    if (typeof g == "number") c =
                        g;
                    else if (g && "priority" in g) c = g.priority;
                    typeof c != "number" && (c = 10);
                    typeof g != "object" && (g = {});
                    a.elementNames && this.elementNameRules.addMany(a.elementNames, c, g);
                    a.attributeNames && this.attributeNameRules.addMany(a.attributeNames, c, g);
                    a.elements && e(this.elementsRules, a.elements, c, g);
                    a.attributes && e(this.attributesRules, a.attributes, c, g);
                    a.text && this.textRules.add(a.text, c, g);
                    a.comment && this.commentRules.add(a.comment, c, g);
                    a.root && this.rootRules.add(a.root, c, g)
                },
                applyTo: function(a) {
                    a.filter(this)
                },
                onElementName: function(a,
                    g) {
                    return this.elementNameRules.execOnName(a, g)
                },
                onAttributeName: function(a, g) {
                    return this.attributeNameRules.execOnName(a, g)
                },
                onText: function(a, g, c) {
                    return this.textRules.exec(a, g, c)
                },
                onComment: function(a, g, c) {
                    return this.commentRules.exec(a, g, c)
                },
                onRoot: function(a, g) {
                    return this.rootRules.exec(a, g)
                },
                onElement: function(a, g) {
                    for (var c = [this.elementsRules["^"], this.elementsRules[g.name], this.elementsRules.$], d, e = 0; e < 3; e++)
                        if (d = c[e]) {
                            d = d.exec(a, g, this);
                            if (d === false) return null;
                            if (d && d != g) return this.onNode(a,
                                d);
                            if (g.parent && !g.name) break
                        }
                    return g
                },
                onNode: function(a, g) {
                    var c = g.type;
                    return c == CKEDITOR.NODE_ELEMENT ? this.onElement(a, g) : c == CKEDITOR.NODE_TEXT ? new CKEDITOR.htmlParser.text(this.onText(a, g.value)) : c == CKEDITOR.NODE_COMMENT ? new CKEDITOR.htmlParser.comment(this.onComment(a, g.value)) : null
                },
                onAttribute: function(a, g, c, d) {
                    return (c = this.attributesRules[c]) ? c.exec(a, d, g, this) : d
                }
            }
        });
        CKEDITOR.htmlParser.filterRulesGroup = a;
        a.prototype = {
            add: function(a, g, c) {
                this.rules.splice(this.findIndex(g), 0, {
                    value: a,
                    priority: g,
                    options: c
                })
            },
            addMany: function(a, g, c) {
                for (var d = [this.findIndex(g), 0], e = 0, f = a.length; e < f; e++) d.push({
                    value: a[e],
                    priority: g,
                    options: c
                });
                this.rules.splice.apply(this.rules, d)
            },
            findIndex: function(a) {
                for (var g = this.rules, c = g.length - 1; c >= 0 && a < g[c].priority;) c--;
                return c + 1
            },
            exec: function(a, g) {
                var c = g instanceof CKEDITOR.htmlParser.node || g instanceof CKEDITOR.htmlParser.fragment,
                    d = Array.prototype.slice.call(arguments, 1),
                    e = this.rules,
                    f = e.length,
                    h, i, k, n;
                for (n = 0; n < f; n++) {
                    if (c) {
                        h = g.type;
                        i = g.name
                    }
                    k = e[n];
                    if (!(a.nonEditable && !k.options.applyToAll || a.nestedEditable && k.options.excludeNestedEditable)) {
                        k = k.value.apply(null, d);
                        if (k === false || c && k && (k.name != i || k.type != h)) return k;
                        k != null && (d[0] = g = k)
                    }
                }
                return g
            },
            execOnName: function(a, g) {
                for (var c = 0, d = this.rules, e = d.length, f; g && c < e; c++) {
                    f = d[c];
                    !(a.nonEditable && !f.options.applyToAll || a.nestedEditable && f.options.excludeNestedEditable) && (g = g.replace(f.value[0], f.value[1]))
                }
                return g
            }
        }
    }(),
    function() {
        function a(a, f) {
            function h(a) {
                return a || CKEDITOR.env.needsNbspFiller ? new CKEDITOR.htmlParser.text(" ") :
                    new CKEDITOR.htmlParser.element("br", {
                        "data-cke-bogus": 1
                    })
            }

            function e(a, c) {
                return function(f) {
                    if (f.type != CKEDITOR.NODE_DOCUMENT_FRAGMENT) {
                        var e = [],
                            j = b(f),
                            p, k;
                        if (j)
                            for (i(j, 1) && e.push(j); j;) {
                                if (d(j) && (p = g(j)) && i(p))
                                    if ((k = g(p)) && !d(k)) e.push(p);
                                    else {
                                        h(t).insertAfter(p);
                                        p.remove()
                                    }
                                j = j.previous
                            }
                        for (j = 0; j < e.length; j++) e[j].remove();
                        if (e = !a || (typeof c == "function" ? c(f) : c) !== false)
                            if (!t && !CKEDITOR.env.needsBrFiller && f.type == CKEDITOR.NODE_DOCUMENT_FRAGMENT) e = false;
                            else if (!t && !CKEDITOR.env.needsBrFiller && (document.documentMode >
                            7 || f.name in CKEDITOR.dtd.tr || f.name in CKEDITOR.dtd.$listItem)) e = false;
                        else {
                            e = b(f);
                            e = !e || f.name == "form" && e.name == "input"
                        }
                        e && f.add(h(a))
                    }
                }
            }

            function i(a, b) {
                if ((!t || CKEDITOR.env.needsBrFiller) && a.type == CKEDITOR.NODE_ELEMENT && a.name == "br" && !a.attributes["data-cke-eol"]) return true;
                var c;
                if (a.type == CKEDITOR.NODE_TEXT && (c = a.value.match(p))) {
                    if (c.index) {
                        (new CKEDITOR.htmlParser.text(a.value.substring(0, c.index))).insertBefore(a);
                        a.value = c[0]
                    }
                    if (!CKEDITOR.env.needsBrFiller && t && (!b || a.parent.name in x)) return true;
                    if (!t)
                        if ((c = a.previous) && c.name == "br" || !c || d(c)) return true
                }
                return false
            }
            var k = {
                elements: {}
            }, t = f == "html",
                x = CKEDITOR.tools.extend({}, w),
                C;
            for (C in x) "#" in s[C] || delete x[C];
            for (C in x) k.elements[C] = e(t, a.config.fillEmptyBlocks);
            k.root = e(t, false);
            k.elements.br = function(a) {
                return function(b) {
                    if (b.parent.type != CKEDITOR.NODE_DOCUMENT_FRAGMENT) {
                        var f = b.attributes;
                        if ("data-cke-bogus" in f || "data-cke-eol" in f) delete f["data-cke-bogus"];
                        else {
                            for (f = b.next; f && c(f);) f = f.next;
                            var e = g(b);
                            !f && d(b.parent) ? j(b.parent,
                                h(a)) : d(f) && (e && !d(e)) && h(a).insertBefore(f)
                        }
                    }
                }
            }(t);
            return k
        }

        function e(a, b) {
            return a != CKEDITOR.ENTER_BR && b !== false ? a == CKEDITOR.ENTER_DIV ? "div" : "p" : false
        }

        function b(a) {
            for (a = a.children[a.children.length - 1]; a && c(a);) a = a.previous;
            return a
        }

        function g(a) {
            for (a = a.previous; a && c(a);) a = a.previous;
            return a
        }

        function c(a) {
            return a.type == CKEDITOR.NODE_TEXT && !CKEDITOR.tools.trim(a.value) || a.type == CKEDITOR.NODE_ELEMENT && a.attributes["data-cke-bookmark"]
        }

        function d(a) {
            return a && (a.type == CKEDITOR.NODE_ELEMENT && a.name in
                w || a.type == CKEDITOR.NODE_DOCUMENT_FRAGMENT)
        }

        function j(a, b) {
            var c = a.children[a.children.length - 1];
            a.children.push(b);
            b.parent = a;
            if (c) {
                c.next = b;
                b.previous = c
            }
        }

        function f(a) {
            a = a.attributes;
            a.contenteditable != "false" && (a["data-cke-editable"] = a.contenteditable ? "true" : 1);
            a.contenteditable = "false"
        }

        function h(a) {
            a = a.attributes;
            switch (a["data-cke-editable"]) {
                case "true":
                    a.contenteditable = "true";
                    break;
                case "1":
                    delete a.contenteditable
            }
        }

        function i(a) {
            return a.replace(z, function(a, b, c) {
                return "<" + b + c.replace(B,
                    function(a, b) {
                        return A.test(b) && c.indexOf("data-cke-saved-" + b) == -1 ? " data-cke-saved-" + a + " data-cke-" + CKEDITOR.rnd + "-" + a : a
                    }) + ">"
            })
        }

        function k(a, b) {
            return a.replace(b, function(a, b, c) {
                a.indexOf("<textarea") === 0 && (a = b + q(c).replace(/</g, "&lt;").replace(/>/g, "&gt;") + "</textarea>");
                return "<cke:encoded>" + encodeURIComponent(a) + "</cke:encoded>"
            })
        }

        function n(a) {
            return a.replace(J, function(a, b) {
                return decodeURIComponent(b)
            })
        }

        function o(a) {
            return a.replace(/<\!--(?!{cke_protected})[\s\S]+?--\>/g, function(a) {
                return "<\!--" +
                    t + "{C}" + encodeURIComponent(a).replace(/--/g, "%2D%2D") + "--\>"
            })
        }

        function q(a) {
            return a.replace(/<\!--\{cke_protected\}\{C\}([\s\S]+?)--\>/g, function(a, b) {
                return decodeURIComponent(b)
            })
        }

        function m(a, b) {
            var c = b._.dataStore;
            return a.replace(/<\!--\{cke_protected\}([\s\S]+?)--\>/g, function(a, b) {
                return decodeURIComponent(b)
            }).replace(/\{cke_protected_(\d+)\}/g, function(a, b) {
                return c && c[b] || ""
            })
        }

        function l(a, b) {
            for (var c = [], d = b.config.protectedSource, f = b._.dataStore || (b._.dataStore = {
                        id: 1
                    }), g = /<\!--\{cke_temp(comment)?\}(\d*?)--\>/g,
                    d = [/<script[\s\S]*?<\/script>/gi, /<noscript[\s\S]*?<\/noscript>/gi, /<meta[\s\S]*?\/?>/gi].concat(d), a = a.replace(/<\!--[\s\S]*?--\>/g, function(a) {
                        return "<\!--{cke_tempcomment}" + (c.push(a) - 1) + "--\>"
                    }), h = 0; h < d.length; h++) a = a.replace(d[h], function(a) {
                a = a.replace(g, function(a, b, d) {
                    return c[d]
                });
                return /cke_temp(comment)?/.test(a) ? a : "<\!--{cke_temp}" + (c.push(a) - 1) + "--\>"
            });
            a = a.replace(g, function(a, b, d) {
                return "<\!--" + t + (b ? "{C}" : "") + encodeURIComponent(c[d]).replace(/--/g, "%2D%2D") + "--\>"
            });
            a = a.replace(/<\w+(?:\s+(?:(?:[^\s=>]+\s*=\s*(?:[^'"\s>]+|'[^']*'|"[^"]*"))|[^\s=>]+))+\s*>/g,
                function(a) {
                    return a.replace(/<\!--\{cke_protected\}([^>]*)--\>/g, function(a, b) {
                        f[f.id] = decodeURIComponent(b);
                        return "{cke_protected_" + f.id+++"}"
                    })
                });
            return a = a.replace(/<(title|iframe|textarea)([^>]*)>([\s\S]*?)<\/\1>/g, function(a, c, d, f) {
                return "<" + c + d + ">" + m(q(f), b) + "</" + c + ">"
            })
        }
        CKEDITOR.htmlDataProcessor = function(b) {
            var c, d, f = this;
            this.editor = b;
            this.dataFilter = c = new CKEDITOR.htmlParser.filter;
            this.htmlFilter = d = new CKEDITOR.htmlParser.filter;
            this.writer = new CKEDITOR.htmlParser.basicWriter;
            c.addRules(x);
            c.addRules(v, {
                applyToAll: true
            });
            c.addRules(a(b, "data"), {
                applyToAll: true
            });
            d.addRules(r);
            d.addRules(y, {
                applyToAll: true
            });
            d.addRules(a(b, "html"), {
                applyToAll: true
            });
            b.on("toHtml", function(a) {
                var a = a.data,
                    c = a.dataValue,
                    d, c = l(c, b),
                    c = k(c, D),
                    c = i(c),
                    c = k(c, G),
                    c = c.replace(C, "$1cke:$2"),
                    c = c.replace(E, "<cke:$1$2></cke:$1>"),
                    c = c.replace(/(<pre\b[^>]*>)(\r\n|\n)/g, "$1$2$2"),
                    c = c.replace(/([^a-z0-9<\-])(on\w{3,})(?!>)/gi, "$1data-cke-" + CKEDITOR.rnd + "-$2");
                d = a.context || b.editable().getName();
                var f;
                if (CKEDITOR.env.ie &&
                    CKEDITOR.env.version < 9 && d == "pre") {
                    d = "div";
                    c = "<pre>" + c + "</pre>";
                    f = 1
                }
                d = b.document.createElement(d);
                d.setHtml("a" + c);
                c = d.getHtml().substr(1);
                c = c.replace(RegExp("data-cke-" + CKEDITOR.rnd + "-", "ig"), "");
                f && (c = c.replace(/^<pre>|<\/pre>$/gi, ""));
                c = c.replace(F, "$1$2");
                c = n(c);
                c = q(c);
                d = a.fixForBody === false ? false : e(a.enterMode, b.config.autoParagraph);
                c = CKEDITOR.htmlParser.fragment.fromHtml(c, a.context, d);
                if (d) {
                    f = c;
                    if (!f.children.length && CKEDITOR.dtd[f.name][d]) {
                        d = new CKEDITOR.htmlParser.element(d);
                        f.add(d)
                    }
                }
                a.dataValue =
                    c
            }, null, null, 5);
            b.on("toHtml", function(a) {
                a.data.filter.applyTo(a.data.dataValue, true, a.data.dontFilter, a.data.enterMode) && b.fire("dataFiltered")
            }, null, null, 6);
            b.on("toHtml", function(a) {
                a.data.dataValue.filterChildren(f.dataFilter, true)
            }, null, null, 10);
            b.on("toHtml", function(a) {
                var a = a.data,
                    b = a.dataValue,
                    c = new CKEDITOR.htmlParser.basicWriter;
                b.writeChildrenHtml(c);
                b = c.getHtml(true);
                a.dataValue = o(b)
            }, null, null, 15);
            b.on("toDataFormat", function(a) {
                var c = a.data.dataValue;
                a.data.enterMode != CKEDITOR.ENTER_BR &&
                    (c = c.replace(/^<br *\/?>/i, ""));
                a.data.dataValue = CKEDITOR.htmlParser.fragment.fromHtml(c, a.data.context, e(a.data.enterMode, b.config.autoParagraph))
            }, null, null, 5);
            b.on("toDataFormat", function(a) {
                a.data.dataValue.filterChildren(f.htmlFilter, true)
            }, null, null, 10);
            b.on("toDataFormat", function(a) {
                a.data.filter.applyTo(a.data.dataValue, false, true)
            }, null, null, 11);
            b.on("toDataFormat", function(a) {
                var c = a.data.dataValue,
                    d = f.writer;
                d.reset();
                c.writeChildrenHtml(d);
                c = d.getHtml(true);
                c = q(c);
                c = m(c, b);
                a.data.dataValue =
                    c
            }, null, null, 15)
        };
        CKEDITOR.htmlDataProcessor.prototype = {
            toHtml: function(a, b, c, d) {
                var f = this.editor,
                    g, h, e;
                if (b && typeof b == "object") {
                    g = b.context;
                    c = b.fixForBody;
                    d = b.dontFilter;
                    h = b.filter;
                    e = b.enterMode
                } else g = b;
                !g && g !== null && (g = f.editable().getName());
                return f.fire("toHtml", {
                    dataValue: a,
                    context: g,
                    fixForBody: c,
                    dontFilter: d,
                    filter: h || f.filter,
                    enterMode: e || f.enterMode
                }).dataValue
            },
            toDataFormat: function(a, b) {
                var c, d, f;
                if (b) {
                    c = b.context;
                    d = b.filter;
                    f = b.enterMode
                }!c && c !== null && (c = this.editor.editable().getName());
                return this.editor.fire("toDataFormat", {
                    dataValue: a,
                    filter: d || this.editor.filter,
                    context: c,
                    enterMode: f || this.editor.enterMode
                }).dataValue
            }
        };
        var p = /(?:&nbsp;|\xa0)$/,
            t = "{cke_protected}",
            s = CKEDITOR.dtd,
            u = ["caption", "colgroup", "col", "thead", "tfoot", "tbody"],
            w = CKEDITOR.tools.extend({}, s.$blockLimit, s.$block),
            x = {
                elements: {
                    input: f,
                    textarea: f
                }
            }, v = {
                attributeNames: [
                    [/^on/, "data-cke-pa-on"],
                    [/^data-cke-expando$/, ""]
                ]
            }, r = {
                elements: {
                    embed: function(a) {
                        var b = a.parent;
                        if (b && b.name == "object") {
                            var c = b.attributes.width,
                                b = b.attributes.height;
                            if (c) a.attributes.width = c;
                            if (b) a.attributes.height = b
                        }
                    },
                    a: function(a) {
                        if (!a.children.length && !a.attributes.name && !a.attributes["data-cke-saved-name"]) return false
                    }
                }
            }, y = {
                elementNames: [
                    [/^cke:/, ""],
                    [/^\?xml:namespace$/, ""]
                ],
                attributeNames: [
                    [/^data-cke-(saved|pa)-/, ""],
                    [/^data-cke-.*/, ""],
                    ["hidefocus", ""]
                ],
                elements: {
                    $: function(a) {
                        var b = a.attributes;
                        if (b) {
                            if (b["data-cke-temp"]) return false;
                            for (var c = ["name", "href", "src"], d, f = 0; f < c.length; f++) {
                                d = "data-cke-saved-" + c[f];
                                d in b && delete b[c[f]]
                            }
                        }
                        return a
                    },
                    table: function(a) {
                        a.children.slice(0).sort(function(a, b) {
                            var c, d;
                            if (a.type == CKEDITOR.NODE_ELEMENT && b.type == a.type) {
                                c = CKEDITOR.tools.indexOf(u, a.name);
                                d = CKEDITOR.tools.indexOf(u, b.name)
                            }
                            if (!(c > -1 && d > -1 && c != d)) {
                                c = a.parent ? a.getIndex() : -1;
                                d = b.parent ? b.getIndex() : -1
                            }
                            return c > d ? 1 : -1
                        })
                    },
                    param: function(a) {
                        a.children = [];
                        a.isEmpty = true;
                        return a
                    },
                    span: function(a) {
                        a.attributes["class"] == "Apple-style-span" && delete a.name
                    },
                    html: function(a) {
                        delete a.attributes.contenteditable;
                        delete a.attributes["class"]
                    },
                    body: function(a) {
                        delete a.attributes.spellcheck;
                        delete a.attributes.contenteditable
                    },
                    style: function(a) {
                        var b = a.children[0];
                        if (b && b.value) b.value = CKEDITOR.tools.trim(b.value);
                        if (!a.attributes.type) a.attributes.type = "text/css"
                    },
                    title: function(a) {
                        var b = a.children[0];
                        !b && j(a, b = new CKEDITOR.htmlParser.text);
                        b.value = a.attributes["data-cke-title"] || ""
                    },
                    input: h,
                    textarea: h
                },
                attributes: {
                    "class": function(a) {
                        return CKEDITOR.tools.ltrim(a.replace(/(?:^|\s+)cke_[^\s]*/g, "")) || false
                    }
                }
            };
        if (CKEDITOR.env.ie) y.attributes.style = function(a) {
            return a.replace(/(^|;)([^\:]+)/g,
                function(a) {
                    return a.toLowerCase()
                })
        };
        var z = /<(a|area|img|input|source)\b([^>]*)>/gi,
            B = /([\w-]+)\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|(?:[^ "'>]+))/gi,
            A = /^(href|src|name)$/i,
            G = /(?:<style(?=[ >])[^>]*>[\s\S]*?<\/style>)|(?:<(:?link|meta|base)[^>]*>)/gi,
            D = /(<textarea(?=[ >])[^>]*>)([\s\S]*?)(?:<\/textarea>)/gi,
            J = /<cke:encoded>([^<]*)<\/cke:encoded>/gi,
            C = /(<\/?)((?:object|embed|param|html|body|head|title)[^>]*>)/gi,
            F = /(<\/?)cke:((?:html|body|head|title)[^>]*>)/gi,
            E = /<cke:(param|embed)([^>]*?)\/?>(?!\s*<\/cke:\1)/gi
    }(),
        "use strict", CKEDITOR.htmlParser.element = function(a, e) {
            this.name = a;
            this.attributes = e || {};
            this.children = [];
            var b = a || "",
                g = b.match(/^cke:(.*)/);
            g && (b = g[1]);
            b = !(!CKEDITOR.dtd.$nonBodyContent[b] && !CKEDITOR.dtd.$block[b] && !CKEDITOR.dtd.$listItem[b] && !CKEDITOR.dtd.$tableContent[b] && !(CKEDITOR.dtd.$nonEditable[b] || b == "br"));
            this.isEmpty = !! CKEDITOR.dtd.$empty[a];
            this.isUnknown = !CKEDITOR.dtd[a];
            this._ = {
                isBlockLike: b,
                hasInlineStarted: this.isEmpty || !b
            }
    }, CKEDITOR.htmlParser.cssStyle = function(a) {
        var e = {};
        ((a instanceof CKEDITOR.htmlParser.element ? a.attributes.style : a) || "").replace(/&quot;/g, '"').replace(/\s*([^ :;]+)\s*:\s*([^;]+)\s*(?=;|$)/g, function(a, g, c) {
            g == "font-family" && (c = c.replace(/["']/g, ""));
            e[g.toLowerCase()] = c
        });
        return {
            rules: e,
            populate: function(a) {
                var g = this.toString();
                if (g) a instanceof CKEDITOR.dom.element ? a.setAttribute("style", g) : a instanceof CKEDITOR.htmlParser.element ? a.attributes.style = g : a.style = g
            },
            toString: function() {
                var a = [],
                    g;
                for (g in e) e[g] && a.push(g, ":", e[g], ";");
                return a.join("")
            }
        }
    },
    function() {
        function a(a) {
            return function(b) {
                return b.type ==
                    CKEDITOR.NODE_ELEMENT && (typeof a == "string" ? b.name == a : b.name in a)
            }
        }
        var e = function(a, b) {
            a = a[0];
            b = b[0];
            return a < b ? -1 : a > b ? 1 : 0
        }, b = CKEDITOR.htmlParser.fragment.prototype;
        CKEDITOR.htmlParser.element.prototype = CKEDITOR.tools.extend(new CKEDITOR.htmlParser.node, {
            type: CKEDITOR.NODE_ELEMENT,
            add: b.add,
            clone: function() {
                return new CKEDITOR.htmlParser.element(this.name, this.attributes)
            },
            filter: function(a, b) {
                var d = this,
                    e, f, b = d.getFilterContext(b);
                if (b.off) return true;
                if (!d.parent) a.onRoot(b, d);
                for (;;) {
                    e = d.name;
                    if (!(f = a.onElementName(b, e))) {
                        this.remove();
                        return false
                    }
                    d.name = f;
                    if (!(d = a.onElement(b, d))) {
                        this.remove();
                        return false
                    }
                    if (d !== this) {
                        this.replaceWith(d);
                        return false
                    }
                    if (d.name == e) break;
                    if (d.type != CKEDITOR.NODE_ELEMENT) {
                        this.replaceWith(d);
                        return false
                    }
                    if (!d.name) {
                        this.replaceWithChildren();
                        return false
                    }
                }
                e = d.attributes;
                var h, i;
                for (h in e) {
                    i = h;
                    for (f = e[h];;)
                        if (i = a.onAttributeName(b, h))
                            if (i != h) {
                                delete e[h];
                                h = i
                            } else break;
                            else {
                                delete e[h];
                                break
                            }
                    i && ((f = a.onAttribute(b, d, i, f)) === false ? delete e[i] : e[i] = f)
                }
                d.isEmpty ||
                    this.filterChildren(a, false, b);
                return true
            },
            filterChildren: b.filterChildren,
            writeHtml: function(a, b) {
                b && this.filter(b);
                var d = this.name,
                    j = [],
                    f = this.attributes,
                    h, i;
                a.openTag(d, f);
                for (h in f) j.push([h, f[h]]);
                a.sortAttributes && j.sort(e);
                h = 0;
                for (i = j.length; h < i; h++) {
                    f = j[h];
                    a.attribute(f[0], f[1])
                }
                a.openTagClose(d, this.isEmpty);
                this.writeChildrenHtml(a);
                this.isEmpty || a.closeTag(d)
            },
            writeChildrenHtml: b.writeChildrenHtml,
            replaceWithChildren: function() {
                for (var a = this.children, b = a.length; b;) a[--b].insertAfter(this);
                this.remove()
            },
            forEach: b.forEach,
            getFirst: function(b) {
                if (!b) return this.children.length ? this.children[0] : null;
                typeof b != "function" && (b = a(b));
                for (var c = 0, d = this.children.length; c < d; ++c)
                    if (b(this.children[c])) return this.children[c];
                return null
            },
            getHtml: function() {
                var a = new CKEDITOR.htmlParser.basicWriter;
                this.writeChildrenHtml(a);
                return a.getHtml()
            },
            setHtml: function(a) {
                for (var a = this.children = CKEDITOR.htmlParser.fragment.fromHtml(a).children, b = 0, d = a.length; b < d; ++b) a[b].parent = this
            },
            getOuterHtml: function() {
                var a =
                    new CKEDITOR.htmlParser.basicWriter;
                this.writeHtml(a);
                return a.getHtml()
            },
            split: function(a) {
                for (var b = this.children.splice(a, this.children.length - a), d = this.clone(), e = 0; e < b.length; ++e) b[e].parent = d;
                d.children = b;
                if (b[0]) b[0].previous = null;
                if (a > 0) this.children[a - 1].next = null;
                this.parent.add(d, this.getIndex() + 1);
                return d
            },
            addClass: function(a) {
                if (!this.hasClass(a)) {
                    var b = this.attributes["class"] || "";
                    this.attributes["class"] = b + (b ? " " : "") + a
                }
            },
            removeClass: function(a) {
                var b = this.attributes["class"];
                if (b)(b =
                    CKEDITOR.tools.trim(b.replace(RegExp("(?:\\s+|^)" + a + "(?:\\s+|$)"), " "))) ? this.attributes["class"] = b : delete this.attributes["class"]
            },
            hasClass: function(a) {
                var b = this.attributes["class"];
                return !b ? false : RegExp("(?:^|\\s)" + a + "(?=\\s|$)").test(b)
            },
            getFilterContext: function(a) {
                var b = [];
                a || (a = {
                    off: false,
                    nonEditable: false,
                    nestedEditable: false
                });
                !a.off && this.attributes["data-cke-processor"] == "off" && b.push("off", true);
                !a.nonEditable && this.attributes.contenteditable == "false" ? b.push("nonEditable", true) : a.nonEditable &&
                    (!a.nestedEditable && this.attributes.contenteditable == "true") && b.push("nestedEditable", true);
                if (b.length)
                    for (var a = CKEDITOR.tools.copy(a), d = 0; d < b.length; d = d + 2) a[b[d]] = b[d + 1];
                return a
            }
        }, true)
    }(),
    function() {
        var a = {}, e = /{([^}]+)}/g,
            b = /([\\'])/g,
            g = /\n/g,
            c = /\r/g;
        CKEDITOR.template = function(d) {
            if (a[d]) this.output = a[d];
            else {
                var j = d.replace(b, "\\$1").replace(g, "\\n").replace(c, "\\r").replace(e, function(a, b) {
                    return "',data['" + b + "']==undefined?'{" + b + "}':data['" + b + "'],'"
                });
                this.output = a[d] = Function("data", "buffer",
                    "return buffer?buffer.push('" + j + "'):['" + j + "'].join('');")
            }
        }
    }(), delete CKEDITOR.loadFullCore, CKEDITOR.instances = {}, CKEDITOR.document = new CKEDITOR.dom.document(document), CKEDITOR.add = function(a) {
        CKEDITOR.instances[a.name] = a;
        a.on("focus", function() {
            if (CKEDITOR.currentInstance != a) {
                CKEDITOR.currentInstance = a;
                CKEDITOR.fire("currentInstance")
            }
        });
        a.on("blur", function() {
            if (CKEDITOR.currentInstance == a) {
                CKEDITOR.currentInstance = null;
                CKEDITOR.fire("currentInstance")
            }
        });
        CKEDITOR.fire("instance", null, a)
    }, CKEDITOR.remove =
        function(a) {
            delete CKEDITOR.instances[a.name]
    },
    function() {
        var a = {};
        CKEDITOR.addTemplate = function(e, b) {
            var g = a[e];
            if (g) return g;
            g = {
                name: e,
                source: b
            };
            CKEDITOR.fire("template", g);
            return a[e] = new CKEDITOR.template(g.source)
        };
        CKEDITOR.getTemplate = function(e) {
            return a[e]
        }
    }(),
    function() {
        var a = [];
        CKEDITOR.addCss = function(e) {
            a.push(e)
        };
        CKEDITOR.getCss = function() {
            return a.join("\n")
        }
    }(), CKEDITOR.on("instanceDestroyed", function() {
        CKEDITOR.tools.isEmpty(this.instances) && CKEDITOR.fire("reset")
    }), CKEDITOR.TRISTATE_ON =
        1, CKEDITOR.TRISTATE_OFF = 2, CKEDITOR.TRISTATE_DISABLED = 0,
    function() {
        CKEDITOR.inline = function(a, e) {
            if (!CKEDITOR.env.isCompatible) return null;
            a = CKEDITOR.dom.element.get(a);
            if (a.getEditor()) throw 'The editor instance "' + a.getEditor().name + '" is already attached to the provided element.';
            var b = new CKEDITOR.editor(e, a, CKEDITOR.ELEMENT_MODE_INLINE),
                g = a.is("textarea") ? a : null;
            if (g) {
                b.setData(g.getValue(), null, true);
                a = CKEDITOR.dom.element.createFromHtml('<div contenteditable="' + !! b.readOnly + '" class="cke_textarea_inline">' +
                    g.getValue() + "</div>", CKEDITOR.document);
                a.insertAfter(g);
                g.hide();
                g.$.form && b._attachToForm()
            } else b.setData(a.getHtml(), null, true);
            b.on("loaded", function() {
                b.fire("uiReady");
                b.editable(a);
                b.container = a;
                b.setData(b.getData(1));
                b.resetDirty();
                b.fire("contentDom");
                b.mode = "wysiwyg";
                b.fire("mode");
                b.status = "ready";
                b.fireOnce("instanceReady");
                CKEDITOR.fire("instanceReady", null, b)
            }, null, null, 1E4);
            b.on("destroy", function() {
                if (g) {
                    b.container.clearCustomData();
                    b.container.remove();
                    g.show()
                }
                b.element.clearCustomData();
                delete b.element
            });
            return b
        };
        CKEDITOR.inlineAll = function() {
            var a, e, b;
            for (b in CKEDITOR.dtd.$editable)
                for (var g = CKEDITOR.document.getElementsByTag(b), c = 0, d = g.count(); c < d; c++) {
                    a = g.getItem(c);
                    if (a.getAttribute("contenteditable") == "true") {
                        e = {
                            element: a,
                            config: {}
                        };
                        CKEDITOR.fire("inline", e) !== false && CKEDITOR.inline(a, e.config)
                    }
                }
        };
        CKEDITOR.domReady(function() {
            !CKEDITOR.disableAutoInline && CKEDITOR.inlineAll()
        })
    }(), CKEDITOR.replaceClass = "ckeditor",
    function() {
        function a(a, c, d, j) {
            if (!CKEDITOR.env.isCompatible) return null;
            a = CKEDITOR.dom.element.get(a);
            if (a.getEditor()) throw 'The editor instance "' + a.getEditor().name + '" is already attached to the provided element.';
            var f = new CKEDITOR.editor(c, a, j);
            if (j == CKEDITOR.ELEMENT_MODE_REPLACE) {
                a.setStyle("visibility", "hidden");
                f._.required = a.hasAttribute("required");
                a.removeAttribute("required")
            }
            d && f.setData(d, null, true);
            f.on("loaded", function() {
                b(f);
                j == CKEDITOR.ELEMENT_MODE_REPLACE && (f.config.autoUpdateElement && a.$.form) && f._attachToForm();
                f.setMode(f.config.startupMode, function() {
                    f.resetDirty();
                    f.status = "ready";
                    f.fireOnce("instanceReady");
                    CKEDITOR.fire("instanceReady", null, f)
                })
            });
            f.on("destroy", e);
            return f
        }

        function e() {
            var a = this.container,
                b = this.element;
            if (a) {
                a.clearCustomData();
                a.remove()
            }
            if (b) {
                b.clearCustomData();
                if (this.elementMode == CKEDITOR.ELEMENT_MODE_REPLACE) {
                    b.show();
                    this._.required && b.setAttribute("required", "required")
                }
                delete this.element
            }
        }

        function b(a) {
            var b = a.name,
                d = a.element,
                e = a.elementMode,
                f = a.fire("uiSpace", {
                    space: "top",
                    html: ""
                }).html,
                h = a.fire("uiSpace", {
                    space: "bottom",
                    html: ""
                }).html,
                i = new CKEDITOR.template('<{outerEl} id="cke_{name}" class="{id} cke cke_reset cke_chrome cke_editor_{name} cke_{langDir} ' + CKEDITOR.env.cssClass + '"  dir="{langDir}" lang="{langCode}" role="application"' + (a.title ? ' aria-labelledby="cke_{name}_arialbl"' : "") + ">" + (a.title ? '<span id="cke_{name}_arialbl" class="cke_voice_label">{voiceLabel}</span>' : "") + '<{outerEl} class="cke_inner cke_reset" role="presentation">{topHtml}<{outerEl} id="{contentId}" class="cke_contents cke_reset" role="presentation"></{outerEl}>{bottomHtml}</{outerEl}></{outerEl}>'),
                b = CKEDITOR.dom.element.createFromHtml(i.output({
                    id: a.id,
                    name: b,
                    langDir: a.lang.dir,
                    langCode: a.langCode,
                    voiceLabel: a.title,
                    topHtml: f ? '<span id="' + a.ui.spaceId("top") + '" class="cke_top cke_reset_all" role="presentation" style="height:auto">' + f + "</span>" : "",
                    contentId: a.ui.spaceId("contents"),
                    bottomHtml: h ? '<span id="' + a.ui.spaceId("bottom") + '" class="cke_bottom cke_reset_all" role="presentation">' + h + "</span>" : "",
                    outerEl: CKEDITOR.env.ie ? "span" : "div"
                }));
            if (e == CKEDITOR.ELEMENT_MODE_REPLACE) {
                d.hide();
                b.insertAfter(d)
            } else d.append(b);
            a.container = b;
            f && a.ui.space("top").unselectable();
            h && a.ui.space("bottom").unselectable();
            d = a.config.width;
            e = a.config.height;
            d && b.setStyle("width", CKEDITOR.tools.cssLength(d));
            e && a.ui.space("contents").setStyle("height", CKEDITOR.tools.cssLength(e));
            b.disableContextMenu();
            CKEDITOR.env.webkit && b.on("focus", function() {
                a.focus()
            });
            a.fireOnce("uiReady")
        }
        CKEDITOR.replace = function(b, c) {
            return a(b, c, null, CKEDITOR.ELEMENT_MODE_REPLACE)
        };
        CKEDITOR.appendTo = function(b, c, d) {
            return a(b, c, d, CKEDITOR.ELEMENT_MODE_APPENDTO)
        };
        CKEDITOR.replaceAll = function() {
            for (var a = document.getElementsByTagName("textarea"), b = 0; b < a.length; b++) {
                var d = null,
                    e = a[b];
                if (e.name || e.id) {
                    if (typeof arguments[0] == "string") {
                        if (!RegExp("(?:^|\\s)" + arguments[0] + "(?:$|\\s)").test(e.className)) continue
                    } else if (typeof arguments[0] == "function") {
                        d = {};
                        if (arguments[0](e, d) === false) continue
                    }
                    this.replace(e, d)
                }
            }
        };
        CKEDITOR.editor.prototype.addMode = function(a, b) {
            (this._.modes || (this._.modes = {}))[a] = b
        };
        CKEDITOR.editor.prototype.setMode = function(a, b) {
            var d = this,
                e =
                    this._.modes;
            if (!(a == d.mode || !e || !e[a])) {
                d.fire("beforeSetMode", a);
                if (d.mode) {
                    var f = d.checkDirty(),
                        e = d._.previousModeData,
                        h, i = 0;
                    d.fire("beforeModeUnload");
                    d.editable(0);
                    d._.previousMode = d.mode;
                    d._.previousModeData = h = d.getData(1);
                    if (d.mode == "source" && e == h) {
                        d.fire("lockSnapshot", {
                            forceUpdate: true
                        });
                        i = 1
                    }
                    d.ui.space("contents").setHtml("");
                    d.mode = ""
                } else d._.previousModeData = d.getData(1);
                this._.modes[a](function() {
                    d.mode = a;
                    f !== void 0 && !f && d.resetDirty();
                    i ? d.fire("unlockSnapshot") : a == "wysiwyg" && d.fire("saveSnapshot");
                    setTimeout(function() {
                        d.fire("mode");
                        b && b.call(d)
                    }, 0)
                })
            }
        };
        CKEDITOR.editor.prototype.resize = function(a, b, d, e) {
            var f = this.container,
                h = this.ui.space("contents"),
                i = CKEDITOR.env.webkit && this.document && this.document.getWindow().$.frameElement,
                e = e ? this.container.getFirst(function(a) {
                    return a.type == CKEDITOR.NODE_ELEMENT && a.hasClass("cke_inner")
                }) : f;
            e.setSize("width", a, true);
            i && (i.style.width = "1%");
            h.setStyle("height", Math.max(b - (d ? 0 : (e.$.offsetHeight || 0) - (h.$.clientHeight || 0)), 0) + "px");
            i && (i.style.width =
                "100%");
            this.fire("resize")
        };
        CKEDITOR.editor.prototype.getResizable = function(a) {
            return a ? this.ui.space("contents") : this.container
        };
        CKEDITOR.domReady(function() {
            CKEDITOR.replaceClass && CKEDITOR.replaceAll(CKEDITOR.replaceClass)
        })
    }(), CKEDITOR.config.startupMode = "wysiwyg",
    function() {
        function a(a) {
            var b = a.editor,
                c = a.data.path,
                d = c.blockLimit,
                f = a.data.selection,
                h = f.getRanges()[0],
                i;
            if (CKEDITOR.env.gecko || CKEDITOR.env.ie && CKEDITOR.env.needsBrFiller)
                if (f = e(f, c)) {
                    f.appendBogus();
                    i = CKEDITOR.env.ie
                }
            if (j(b, c.block,
                d) && h.collapsed && !h.getCommonAncestor().isReadOnly()) {
                c = h.clone();
                c.enlarge(CKEDITOR.ENLARGE_BLOCK_CONTENTS);
                d = new CKEDITOR.dom.walker(c);
                d.guard = function(a) {
                    return !g(a) || a.type == CKEDITOR.NODE_COMMENT || a.isReadOnly()
                };
                if (!d.checkForward() || c.checkStartOfBlock() && c.checkEndOfBlock()) {
                    b = h.fixBlock(true, b.activeEnterMode == CKEDITOR.ENTER_DIV ? "div" : "p");
                    if (!CKEDITOR.env.needsBrFiller)(b = b.getFirst(g)) && (b.type == CKEDITOR.NODE_TEXT && CKEDITOR.tools.trim(b.getText()).match(/^(?:&nbsp;|\xa0)$/)) && b.remove();
                    i = 1;
                    a.cancel()
                }
            }
            i && h.select()
        }

        function e(a, b) {
            if (a.isFake) return 0;
            var c = b.block || b.blockLimit,
                d = c && c.getLast(g);
            if (c && c.isBlockBoundary() && (!d || !(d.type == CKEDITOR.NODE_ELEMENT && d.isBlockBoundary())) && !c.is("pre") && !c.getBogus()) return c
        }

        function b(a) {
            var b = a.data.getTarget();
            if (b.is("input")) {
                b = b.getAttribute("type");
                (b == "submit" || b == "reset") && a.data.preventDefault()
            }
        }

        function g(a) {
            return o(a) && q(a)
        }

        function c(a, b) {
            return function(c) {
                var d = CKEDITOR.dom.element.get(c.data.$.toElement || c.data.$.fromElement ||
                    c.data.$.relatedTarget);
                (!d || !b.equals(d) && !b.contains(d)) && a.call(this, c)
            }
        }

        function d(a) {
            function b(a) {
                return function(b, d) {
                    d && (b.type == CKEDITOR.NODE_ELEMENT && b.is(f)) && (c = b);
                    if (!d && g(b) && (!a || !k(b))) return false
                }
            }
            var c, d = a.getRanges()[0],
                a = a.root,
                f = {
                    table: 1,
                    ul: 1,
                    ol: 1,
                    dl: 1
                };
            if (d.startPath().contains(f)) {
                var e = d.clone();
                e.collapse(1);
                e.setStartAt(a, CKEDITOR.POSITION_AFTER_START);
                a = new CKEDITOR.dom.walker(e);
                a.guard = b();
                a.checkBackward();
                if (c) {
                    e = d.clone();
                    e.collapse();
                    e.setEndAt(c, CKEDITOR.POSITION_AFTER_END);
                    a = new CKEDITOR.dom.walker(e);
                    a.guard = b(true);
                    c = false;
                    a.checkForward();
                    return c
                }
            }
            return null
        }

        function j(a, b, c) {
            return a.config.autoParagraph !== false && a.activeEnterMode != CKEDITOR.ENTER_BR && a.editable().equals(c) && !b || b && b.getAttribute("contenteditable") == "true"
        }

        function f(a) {
            a.editor.focus();
            a.editor.fire("saveSnapshot")
        }

        function h(a) {
            var b = a.editor;
            b.getSelection().scrollIntoView();
            setTimeout(function() {
                b.fire("saveSnapshot")
            }, 0)
        }

        function i(a, b, c) {
            for (var d = a.getCommonAncestor(b), b = a = c ? b : a;
                (a = a.getParent()) && !d.equals(a) && a.getChildCount() == 1;) b = a;
            b.remove()
        }
        CKEDITOR.editable = CKEDITOR.tools.createClass({
            base: CKEDITOR.dom.element,
            $: function(a, b) {
                this.base(b.$ || b);
                this.editor = a;
                this.status = "unloaded";
                this.hasFocus = false;
                this.setup()
            },
            proto: {
                focus: function() {
                    var a;
                    if (CKEDITOR.env.webkit && !this.hasFocus) {
                        a = this.editor._.previousActive || this.getDocument().getActive();
                        if (this.contains(a)) {
                            a.focus();
                            return
                        }
                    }
                    try {
                        this.$[CKEDITOR.env.ie && this.getDocument().equals(CKEDITOR.document) ? "setActive" : "focus"]()
                    } catch (b) {
                        if (!CKEDITOR.env.ie) throw b;
                    }
                    if (CKEDITOR.env.safari && !this.isInline()) {
                        a = CKEDITOR.document.getActive();
                        a.equals(this.getWindow().getFrame()) || this.getWindow().focus()
                    }
                },
                on: function(a, b) {
                    var d = Array.prototype.slice.call(arguments, 0);
                    if (CKEDITOR.env.ie && /^focus|blur$/.exec(a)) {
                        a = a == "focus" ? "focusin" : "focusout";
                        b = c(b, this);
                        d[0] = a;
                        d[1] = b
                    }
                    return CKEDITOR.dom.element.prototype.on.apply(this, d)
                },
                attachListener: function(a) {
                    !this._.listeners && (this._.listeners = []);
                    var b = Array.prototype.slice.call(arguments, 1),
                        b = a.on.apply(a, b);
                    this._.listeners.push(b);
                    return b
                },
                clearListeners: function() {
                    var a = this._.listeners;
                    try {
                        for (; a.length;) a.pop().removeListener()
                    } catch (b) {}
                },
                restoreAttrs: function() {
                    var a = this._.attrChanges,
                        b, c;
                    for (c in a)
                        if (a.hasOwnProperty(c)) {
                            b = a[c];
                            b !== null ? this.setAttribute(c, b) : this.removeAttribute(c)
                        }
                },
                attachClass: function(a) {
                    var b = this.getCustomData("classes");
                    if (!this.hasClass(a)) {
                        !b && (b = []);
                        b.push(a);
                        this.setCustomData("classes", b);
                        this.addClass(a)
                    }
                },
                changeAttr: function(a, b) {
                    var c = this.getAttribute(a);
                    if (b !== c) {
                        !this._.attrChanges &&
                            (this._.attrChanges = {});
                        a in this._.attrChanges || (this._.attrChanges[a] = c);
                        this.setAttribute(a, b)
                    }
                },
                insertHtml: function(a, b) {
                    f(this);
                    m(this, b || "html", a)
                },
                insertText: function(a) {
                    f(this);
                    var b = this.editor,
                        c = b.getSelection().getStartElement().hasAscendant("pre", true) ? CKEDITOR.ENTER_BR : b.activeEnterMode,
                        b = c == CKEDITOR.ENTER_BR,
                        d = CKEDITOR.tools,
                        a = d.htmlEncode(a.replace(/\r\n/g, "\n")),
                        a = a.replace(/\t/g, "&nbsp;&nbsp; &nbsp;"),
                        c = c == CKEDITOR.ENTER_P ? "p" : "div";
                    if (!b) {
                        var g = /\n{2}/g;
                        if (g.test(a)) var e = "<" + c +
                            ">",
                        h = "</" + c + ">", a = e + a.replace(g, function() {
                            return h + e
                        }) + h
                    }
                    a = a.replace(/\n/g, "<br>");
                    b || (a = a.replace(RegExp("<br>(?=</" + c + ">)"), function(a) {
                        return d.repeat(a, 2)
                    }));
                    a = a.replace(/^ | $/g, "&nbsp;");
                    a = a.replace(/(>|\s) /g, function(a, b) {
                        return b + "&nbsp;"
                    }).replace(/ (?=<)/g, "&nbsp;");
                    m(this, "text", a)
                },
                insertElement: function(a, b) {
                    b ? this.insertElementIntoRange(a, b) : this.insertElementIntoSelection(a)
                },
                insertElementIntoRange: function(a, b) {
                    var c = this.editor,
                        d = c.config.enterMode,
                        f = a.getName(),
                        g = CKEDITOR.dtd.$block[f];
                    if (b.checkReadOnly()) return false;
                    b.deleteContents(1);
                    b.startContainer.type == CKEDITOR.NODE_ELEMENT && b.startContainer.is({
                        tr: 1,
                        table: 1,
                        tbody: 1,
                        thead: 1,
                        tfoot: 1
                    }) && l(b);
                    var e, h;
                    if (g)
                        for (;
                            (e = b.getCommonAncestor(0, 1)) && (h = CKEDITOR.dtd[e.getName()]) && (!h || !h[f]);)
                            if (e.getName() in CKEDITOR.dtd.span) b.splitElement(e);
                            else if (b.checkStartOfBlock() && b.checkEndOfBlock()) {
                        b.setStartBefore(e);
                        b.collapse(true);
                        e.remove()
                    } else b.splitBlock(d == CKEDITOR.ENTER_DIV ? "div" : "p", c.editable());
                    b.insertNode(a);
                    return true
                },
                insertElementIntoSelection: function(a) {
                    f(this);
                    var b = this.editor,
                        c = b.activeEnterMode,
                        b = b.getSelection(),
                        d = b.getRanges()[0],
                        e = a.getName(),
                        e = CKEDITOR.dtd.$block[e];
                    if (this.insertElementIntoRange(a, d)) {
                        d.moveToPosition(a, CKEDITOR.POSITION_AFTER_END);
                        if (e)
                            if ((e = a.getNext(function(a) {
                                return g(a) && !k(a)
                            })) && e.type == CKEDITOR.NODE_ELEMENT && e.is(CKEDITOR.dtd.$block)) e.getDtd()["#"] ? d.moveToElementEditStart(e) : d.moveToElementEditEnd(a);
                            else if (!e && c != CKEDITOR.ENTER_BR) {
                            e = d.fixBlock(true, c == CKEDITOR.ENTER_DIV ?
                                "div" : "p");
                            d.moveToElementEditStart(e)
                        }
                    }
                    b.selectRanges([d]);
                    h(this)
                },
                setData: function(a, b) {
                    b || (a = this.editor.dataProcessor.toHtml(a));
                    this.setHtml(a);
                    this.fixInitialSelection();
                    if (this.status == "unloaded") this.status = "ready";
                    this.editor.fire("dataReady")
                },
                getData: function(a) {
                    var b = this.getHtml();
                    a || (b = this.editor.dataProcessor.toDataFormat(b));
                    return b
                },
                setReadOnly: function(a) {
                    this.setAttribute("contenteditable", !a)
                },
                detach: function() {
                    this.removeClass("cke_editable");
                    this.status = "detached";
                    var a = this.editor;
                    this._.detach();
                    delete a.document;
                    delete a.window
                },
                isInline: function() {
                    return this.getDocument().equals(CKEDITOR.document)
                },
                fixInitialSelection: function() {
                    function a() {
                        var b = c.getDocument().$,
                            d = b.getSelection(),
                            f;
                        if (d.anchorNode && d.anchorNode == c.$) f = true;
                        else if (CKEDITOR.env.webkit) {
                            var g = c.getDocument().getActive();
                            g && (g.equals(c) && !d.anchorNode) && (f = true)
                        }
                        if (f) {
                            f = new CKEDITOR.dom.range(c);
                            f.moveToElementEditStart(c);
                            b = b.createRange();
                            b.setStart(f.startContainer.$, f.startOffset);
                            b.collapse(true);
                            d.removeAllRanges();
                            d.addRange(b)
                        }
                    }

                    function b() {
                        var a = c.getDocument().$,
                            d = a.selection,
                            f = c.getDocument().getActive();
                        if (d.type == "None" && f.equals(c)) {
                            d = new CKEDITOR.dom.range(c);
                            a = a.body.createTextRange();
                            d.moveToElementEditStart(c);
                            d = d.startContainer;
                            d.type != CKEDITOR.NODE_ELEMENT && (d = d.getParent());
                            a.moveToElementText(d.$);
                            a.collapse(true);
                            a.select()
                        }
                    }
                    var c = this;
                    if (CKEDITOR.env.ie && (CKEDITOR.env.version < 9 || CKEDITOR.env.quirks)) {
                        if (this.hasFocus) {
                            this.focus();
                            b()
                        }
                    } else if (this.hasFocus) {
                        this.focus();
                        a()
                    } else this.once("focus", function() {
                        a()
                    }, null, null, -999)
                },
                setup: function() {
                    var a = this.editor;
                    this.attachListener(a, "beforeGetData", function() {
                        var b = this.getData();
                        this.is("textarea") || a.config.ignoreEmptyParagraph !== false && (b = b.replace(n, function(a, b) {
                            return b
                        }));
                        a.setData(b, null, 1)
                    }, this);
                    this.attachListener(a, "getSnapshot", function(a) {
                        a.data = this.getData(1)
                    }, this);
                    this.attachListener(a, "afterSetData", function() {
                        this.setData(a.getData(1))
                    }, this);
                    this.attachListener(a, "loadSnapshot", function(a) {
                        this.setData(a.data,
                            1)
                    }, this);
                    this.attachListener(a, "beforeFocus", function() {
                        var b = a.getSelection();
                        (b = b && b.getNative()) && b.type == "Control" || this.focus()
                    }, this);
                    this.attachListener(a, "insertHtml", function(a) {
                        this.insertHtml(a.data.dataValue, a.data.mode)
                    }, this);
                    this.attachListener(a, "insertElement", function(a) {
                        this.insertElement(a.data)
                    }, this);
                    this.attachListener(a, "insertText", function(a) {
                        this.insertText(a.data)
                    }, this);
                    this.setReadOnly(a.readOnly);
                    this.attachClass("cke_editable");
                    this.attachClass(a.elementMode == CKEDITOR.ELEMENT_MODE_INLINE ?
                        "cke_editable_inline" : a.elementMode == CKEDITOR.ELEMENT_MODE_REPLACE || a.elementMode == CKEDITOR.ELEMENT_MODE_APPENDTO ? "cke_editable_themed" : "");
                    this.attachClass("cke_contents_" + a.config.contentsLangDirection);
                    a.keystrokeHandler.blockedKeystrokes[8] = +a.readOnly;
                    a.keystrokeHandler.attach(this);
                    this.on("blur", function() {
                        this.hasFocus = false
                    }, null, null, -1);
                    this.on("focus", function() {
                        this.hasFocus = true
                    }, null, null, -1);
                    a.focusManager.add(this);
                    if (this.equals(CKEDITOR.document.getActive())) {
                        this.hasFocus = true;
                        a.once("contentDom", function() {
                            a.focusManager.focus(this)
                        }, this)
                    }
                    this.isInline() && this.changeAttr("tabindex", a.tabIndex);
                    if (!this.is("textarea")) {
                        a.document = this.getDocument();
                        a.window = this.getWindow();
                        var c = a.document;
                        this.changeAttr("spellcheck", !a.config.disableNativeSpellChecker);
                        var f = a.config.contentsLangDirection;
                        this.getDirection(1) != f && this.changeAttr("dir", f);
                        var e = CKEDITOR.getCss();
                        if (e) {
                            f = c.getHead();
                            if (!f.getCustomData("stylesheet")) {
                                e = c.appendStyleText(e);
                                e = new CKEDITOR.dom.element(e.ownerNode ||
                                    e.owningElement);
                                f.setCustomData("stylesheet", e);
                                e.data("cke-temp", 1)
                            }
                        }
                        f = c.getCustomData("stylesheet_ref") || 0;
                        c.setCustomData("stylesheet_ref", f + 1);
                        this.setCustomData("cke_includeReadonly", !a.config.disableReadonlyStyling);
                        this.attachListener(this, "click", function(a) {
                            var a = a.data,
                                b = (new CKEDITOR.dom.elementPath(a.getTarget(), this)).contains("a");
                            b && (a.$.button != 2 && b.isReadOnly()) && a.preventDefault()
                        });
                        var h = {
                            8: 1,
                            46: 1
                        };
                        this.attachListener(a, "key", function(b) {
                            if (a.readOnly) return true;
                            var c = b.data.domEvent.getKey(),
                                f;
                            if (c in h) {
                                var b = a.getSelection(),
                                    e, g = b.getRanges()[0],
                                    i = g.startPath(),
                                    j, k, t, c = c == 8;
                                if (CKEDITOR.env.ie && CKEDITOR.env.version < 11 && (e = b.getSelectedElement()) || (e = d(b))) {
                                    a.fire("saveSnapshot");
                                    g.moveToPosition(e, CKEDITOR.POSITION_BEFORE_START);
                                    e.remove();
                                    g.select();
                                    a.fire("saveSnapshot");
                                    f = 1
                                } else if (g.collapsed)
                                    if ((j = i.block) && (t = j[c ? "getPrevious" : "getNext"](o)) && t.type == CKEDITOR.NODE_ELEMENT && t.is("table") && g[c ? "checkStartOfBlock" : "checkEndOfBlock"]()) {
                                        a.fire("saveSnapshot");
                                        g[c ? "checkEndOfBlock" :
                                            "checkStartOfBlock"]() && j.remove();
                                        g["moveToElementEdit" + (c ? "End" : "Start")](t);
                                        g.select();
                                        a.fire("saveSnapshot");
                                        f = 1
                                    } else if (i.blockLimit && i.blockLimit.is("td") && (k = i.blockLimit.getAscendant("table")) && g.checkBoundaryOfElement(k, c ? CKEDITOR.START : CKEDITOR.END) && (t = k[c ? "getPrevious" : "getNext"](o))) {
                                    a.fire("saveSnapshot");
                                    g["moveToElementEdit" + (c ? "End" : "Start")](t);
                                    g.checkStartOfBlock() && g.checkEndOfBlock() ? t.remove() : g.select();
                                    a.fire("saveSnapshot");
                                    f = 1
                                } else if ((k = i.contains(["td", "th", "caption"])) &&
                                    g.checkBoundaryOfElement(k, c ? CKEDITOR.START : CKEDITOR.END)) f = 1
                            }
                            return !f
                        });
                        a.blockless && (CKEDITOR.env.ie && CKEDITOR.env.needsBrFiller) && this.attachListener(this, "keyup", function(b) {
                            if (b.data.getKeystroke() in h && !this.getFirst(g)) {
                                this.appendBogus();
                                b = a.createRange();
                                b.moveToPosition(this, CKEDITOR.POSITION_AFTER_START);
                                b.select()
                            }
                        });
                        this.attachListener(this, "dblclick", function(b) {
                            if (a.readOnly) return false;
                            b = {
                                element: b.data.getTarget()
                            };
                            a.fire("doubleclick", b)
                        });
                        CKEDITOR.env.ie && this.attachListener(this,
                            "click", b);
                        CKEDITOR.env.ie || this.attachListener(this, "mousedown", function(b) {
                            var c = b.data.getTarget();
                            if (c.is("img", "hr", "input", "textarea", "select") && !c.isReadOnly()) {
                                a.getSelection().selectElement(c);
                                c.is("input", "textarea", "select") && b.data.preventDefault()
                            }
                        });
                        CKEDITOR.env.gecko && this.attachListener(this, "mouseup", function(b) {
                            if (b.data.$.button == 2) {
                                b = b.data.getTarget();
                                if (!b.getOuterHtml().replace(n, "")) {
                                    var c = a.createRange();
                                    c.moveToElementEditStart(b);
                                    c.select(true)
                                }
                            }
                        });
                        if (CKEDITOR.env.webkit) {
                            this.attachListener(this,
                                "click", function(a) {
                                    a.data.getTarget().is("input", "select") && a.data.preventDefault()
                                });
                            this.attachListener(this, "mouseup", function(a) {
                                a.data.getTarget().is("input", "textarea") && a.data.preventDefault()
                            })
                        }
                        CKEDITOR.env.webkit && this.attachListener(a, "key", function(b) {
                            b = b.data.domEvent.getKey();
                            if (b in h) {
                                var c = b == 8,
                                    d = a.getSelection().getRanges()[0],
                                    b = d.startPath();
                                if (d.collapsed) {
                                    var f;
                                    a: {
                                        var g = b.block;
                                        if (g)
                                            if (d[c ? "checkStartOfBlock" : "checkEndOfBlock"]())
                                                if (!d.moveToClosestEditablePosition(g, !c) || !d.collapsed) f =
                                                    false;
                                                else {
                                                    if (d.startContainer.type == CKEDITOR.NODE_ELEMENT) {
                                                        var e = d.startContainer.getChild(d.startOffset - (c ? 1 : 0));
                                                        if (e && e.type == CKEDITOR.NODE_ELEMENT && e.is("hr")) {
                                                            a.fire("saveSnapshot");
                                                            e.remove();
                                                            f = true;
                                                            break a
                                                        }
                                                    }
                                                    if ((d = d.startPath().block) && (!d || !d.contains(g))) {
                                                        a.fire("saveSnapshot");
                                                        var j;
                                                        (j = (c ? d : g).getBogus()) && j.remove();
                                                        f = a.getSelection();
                                                        j = f.createBookmarks();
                                                        (c ? g : d).moveChildren(c ? d : g, false);
                                                        b.lastElement.mergeSiblings();
                                                        i(g, d, !c);
                                                        f.selectBookmarks(j);
                                                        f = true
                                                    }
                                                } else f = false;
                                                else f = false
                                    }
                                    if (!f) return
                                } else {
                                    c =
                                        d;
                                    f = b.block;
                                    j = c.endPath().block;
                                    if (!f || !j || f.equals(j)) b = false;
                                    else {
                                        a.fire("saveSnapshot");
                                        (g = f.getBogus()) && g.remove();
                                        c.deleteContents();
                                        if (j.getParent()) {
                                            j.moveChildren(f, false);
                                            b.lastElement.mergeSiblings();
                                            i(f, j, true)
                                        }
                                        c = a.getSelection().getRanges()[0];
                                        c.collapse(1);
                                        c.select();
                                        b = true
                                    } if (!b) return
                                }
                                a.getSelection().scrollIntoView();
                                a.fire("saveSnapshot");
                                return false
                            }
                        }, this, null, 100)
                    }
                }
            },
            _: {
                detach: function() {
                    this.editor.setData(this.editor.getData(), 0, 1);
                    this.clearListeners();
                    this.restoreAttrs();
                    var a;
                    if (a = this.removeCustomData("classes"))
                        for (; a.length;) this.removeClass(a.pop());
                    if (!this.is("textarea")) {
                        a = this.getDocument();
                        var b = a.getHead();
                        if (b.getCustomData("stylesheet")) {
                            var c = a.getCustomData("stylesheet_ref");
                            if (--c) a.setCustomData("stylesheet_ref", c);
                            else {
                                a.removeCustomData("stylesheet_ref");
                                b.removeCustomData("stylesheet").remove()
                            }
                        }
                    }
                    this.editor.fire("contentDomUnload");
                    delete this.editor
                }
            }
        });
        CKEDITOR.editor.prototype.editable = function(a) {
            var b = this._.editable;
            if (b && a) return 0;
            if (arguments.length) b =
                this._.editable = a ? a instanceof CKEDITOR.editable ? a : new CKEDITOR.editable(this, a) : (b && b.detach(), null);
            return b
        };
        var k = CKEDITOR.dom.walker.bogus(),
            n = /(^|<body\b[^>]*>)\s*<(p|div|address|h\d|center|pre)[^>]*>\s*(?:<br[^>]*>|&nbsp;|\u00A0|&#160;)?\s*(:?<\/\2>)?\s*(?=$|<\/body>)/gi,
            o = CKEDITOR.dom.walker.whitespaces(true),
            q = CKEDITOR.dom.walker.bookmark(false, true);
        CKEDITOR.on("instanceLoaded", function(b) {
            var c = b.editor;
            c.on("insertElement", function(a) {
                a = a.data;
                if (a.type == CKEDITOR.NODE_ELEMENT && (a.is("input") ||
                    a.is("textarea"))) {
                    a.getAttribute("contentEditable") != "false" && a.data("cke-editable", a.hasAttribute("contenteditable") ? "true" : "1");
                    a.setAttribute("contentEditable", false)
                }
            });
            c.on("selectionChange", function(b) {
                if (!c.readOnly) {
                    var d = c.getSelection();
                    if (d && !d.isLocked) {
                        d = c.checkDirty();
                        c.fire("lockSnapshot");
                        a(b);
                        c.fire("unlockSnapshot");
                        !d && c.resetDirty()
                    }
                }
            })
        });
        CKEDITOR.on("instanceCreated", function(a) {
            var b = a.editor;
            b.on("mode", function() {
                var a = b.editable();
                if (a && a.isInline()) {
                    var c = b.title;
                    a.changeAttr("role",
                        "textbox");
                    a.changeAttr("aria-label", c);
                    c && a.changeAttr("title", c);
                    var d = b.fire("ariaEditorHelpLabel", {}).label;
                    if (d)
                        if (c = this.ui.space(this.elementMode == CKEDITOR.ELEMENT_MODE_INLINE ? "top" : "contents")) {
                            var f = CKEDITOR.tools.getNextId(),
                                d = CKEDITOR.dom.element.createFromHtml('<span id="' + f + '" class="cke_voice_label">' + d + "</span>");
                            c.append(d);
                            a.changeAttr("aria-describedby", f)
                        }
                }
            })
        });
        CKEDITOR.addCss(".cke_editable{cursor:text}.cke_editable img,.cke_editable input,.cke_editable textarea{cursor:default}");
        var m = function() {
            function a(b) {
                return b.type == CKEDITOR.NODE_ELEMENT
            }

            function b(c, d) {
                var f, g, e, h, j = [],
                    k = d.range.startContainer;
                f = d.range.startPath();
                for (var k = i[k.getName()], m = 0, n = c.getChildren(), w = n.count(), s = -1, x = -1, l = 0, r = f.contains(i.$list); m < w; ++m) {
                    f = n.getItem(m);
                    if (a(f)) {
                        e = f.getName();
                        if (r && e in CKEDITOR.dtd.$list) j = j.concat(b(f, d));
                        else {
                            h = !! k[e];
                            if (e == "br" && f.data("cke-eol") && (!m || m == w - 1)) {
                                l = (g = m ? j[m - 1].node : n.getItem(m + 1)) && (!a(g) || !g.is("br"));
                                g = g && a(g) && i.$block[g.getName()]
                            }
                            s == -1 && !h && (s =
                                m);
                            h || (x = m);
                            j.push({
                                isElement: 1,
                                isLineBreak: l,
                                isBlock: f.isBlockBoundary(),
                                hasBlockSibling: g,
                                node: f,
                                name: e,
                                allowed: h
                            });
                            g = l = 0
                        }
                    } else j.push({
                        isElement: 0,
                        node: f,
                        allowed: 1
                    })
                }
                if (s > -1) j[s].firstNotAllowed = 1;
                if (x > -1) j[x].lastNotAllowed = 1;
                return j
            }

            function c(b, d) {
                var f = [],
                    g = b.getChildren(),
                    e = g.count(),
                    h, j = 0,
                    k = i[d],
                    m = !b.is(i.$inline) || b.is("br");
                for (m && f.push(" "); j < e; j++) {
                    h = g.getItem(j);
                    a(h) && !h.is(k) ? f = f.concat(c(h, d)) : f.push(h)
                }
                m && f.push(" ");
                return f
            }

            function d(b) {
                return b && a(b) && (b.is(i.$removeEmpty) ||
                    b.is("a") && !b.isBlockBoundary())
            }

            function f(b, c, d, g) {
                var e = b.clone(),
                    h, j;
                e.setEndAt(c, CKEDITOR.POSITION_BEFORE_END);
                if ((h = (new CKEDITOR.dom.walker(e)).next()) && a(h) && k[h.getName()] && (j = h.getPrevious()) && a(j) && !j.getParent().equals(b.startContainer) && d.contains(j) && g.contains(h) && h.isIdentical(j)) {
                    h.moveChildren(j);
                    h.remove();
                    f(b, c, d, g)
                }
            }

            function e(b, c) {
                function d(b, c) {
                    if (c.isBlock && c.isElement && !c.node.is("br") && a(b) && b.is("br")) {
                        b.remove();
                        return 1
                    }
                }
                var f = c.endContainer.getChild(c.endOffset),
                    g = c.endContainer.getChild(c.endOffset -
                        1);
                f && d(f, b[b.length - 1]);
                if (g && d(g, b[0])) {
                    c.setEnd(c.endContainer, c.endOffset - 1);
                    c.collapse()
                }
            }
            var i = CKEDITOR.dtd,
                k = {
                    p: 1,
                    div: 1,
                    h1: 1,
                    h2: 1,
                    h3: 1,
                    h4: 1,
                    h5: 1,
                    h6: 1,
                    ul: 1,
                    ol: 1,
                    li: 1,
                    pre: 1,
                    dl: 1,
                    blockquote: 1
                }, m = {
                    p: 1,
                    div: 1,
                    h1: 1,
                    h2: 1,
                    h3: 1,
                    h4: 1,
                    h5: 1,
                    h6: 1
                }, n = CKEDITOR.tools.extend({}, i.$inline);
            delete n.br;
            return function(k, l, r) {
                var q = k.editor,
                    o = q.getSelection().getRanges()[0],
                    C = false;
                if (l == "unfiltered_html") {
                    l = "html";
                    C = true
                }
                if (!o.checkReadOnly()) {
                    var F = (new CKEDITOR.dom.elementPath(o.startContainer, o.root)).blockLimit ||
                        o.root,
                        l = {
                            type: l,
                            dontFilter: C,
                            editable: k,
                            editor: q,
                            range: o,
                            blockLimit: F,
                            mergeCandidates: [],
                            zombies: []
                        }, q = l.range,
                        C = l.mergeCandidates,
                        E, I, L, H;
                    if (l.type == "text" && q.shrink(CKEDITOR.SHRINK_ELEMENT, true, false)) {
                        E = CKEDITOR.dom.element.createFromHtml("<span>&nbsp;</span>", q.document);
                        q.insertNode(E);
                        q.setStartAfter(E)
                    }
                    I = new CKEDITOR.dom.elementPath(q.startContainer);
                    l.endPath = L = new CKEDITOR.dom.elementPath(q.endContainer);
                    if (!q.collapsed) {
                        var F = L.block || L.blockLimit,
                            Q = q.getCommonAncestor();
                        F && (!F.equals(Q) && !F.contains(Q) && q.checkEndOfBlock()) && l.zombies.push(F);
                        q.deleteContents()
                    }
                    for (;
                        (H = a(q.startContainer) && q.startContainer.getChild(q.startOffset - 1)) && a(H) && H.isBlockBoundary() && I.contains(H);) q.moveToPosition(H, CKEDITOR.POSITION_BEFORE_END);
                    f(q, l.blockLimit, I, L);
                    if (E) {
                        q.setEndBefore(E);
                        q.collapse();
                        E.remove()
                    }
                    E = q.startPath();
                    if (F = E.contains(d, false, 1)) {
                        q.splitElement(F);
                        l.inlineStylesRoot = F;
                        l.inlineStylesPeak = E.lastElement
                    }
                    E = q.createBookmark();
                    (F = E.startNode.getPrevious(g)) && a(F) && d(F) && C.push(F);
                    (F = E.startNode.getNext(g)) && a(F) && d(F) && C.push(F);
                    for (F = E.startNode;
                        (F = F.getParent()) && d(F);) C.push(F);
                    q.moveToBookmark(E);
                    if (E = r) {
                        E = l.range;
                        if (l.type == "text" && l.inlineStylesRoot) {
                            H = l.inlineStylesPeak;
                            q = H.getDocument().createText("{cke-peak}");
                            for (C = l.inlineStylesRoot.getParent(); !H.equals(C);) {
                                q = q.appendTo(H.clone());
                                H = H.getParent()
                            }
                            r = q.getOuterHtml().split("{cke-peak}").join(r)
                        }
                        H = l.blockLimit.getName();
                        if (/^\s+|\s+$/.test(r) && "span" in CKEDITOR.dtd[H]) var O = '<span data-cke-marker="1">&nbsp;</span>',
                        r = O + r + O;
                        r = l.editor.dataProcessor.toHtml(r, {
                            context: null,
                            fixForBody: false,
                            dontFilter: l.dontFilter,
                            filter: l.editor.activeFilter,
                            enterMode: l.editor.activeEnterMode
                        });
                        H = E.document.createElement("body");
                        H.setHtml(r);
                        if (O) {
                            H.getFirst().remove();
                            H.getLast().remove()
                        }
                        if ((O = E.startPath().block) && !(O.getChildCount() == 1 && O.getBogus())) a: {
                            var M;
                            if (H.getChildCount() == 1 && a(M = H.getFirst()) && M.is(m)) {
                                O = M.getElementsByTag("*");
                                E = 0;
                                for (C = O.count(); E < C; E++) {
                                    q = O.getItem(E);
                                    if (!q.is(n)) break a
                                }
                                M.moveChildren(M.getParent(1));
                                M.remove()
                            }
                        }
                        l.dataWrapper = H;
                        E = r
                    }
                    if (E) {
                        M = l.range;
                        var O = M.document,
                            K, r = l.blockLimit;
                        E = 0;
                        var R;
                        H = [];
                        var N, T, C = q = 0,
                            P, V;
                        I = M.startContainer;
                        var F = l.endPath.elements[0],
                            W;
                        L = F.getPosition(I);
                        Q = !! F.getCommonAncestor(I) && L != CKEDITOR.POSITION_IDENTICAL && !(L & CKEDITOR.POSITION_CONTAINS + CKEDITOR.POSITION_IS_CONTAINED);
                        I = b(l.dataWrapper, l);
                        for (e(I, M); E < I.length; E++) {
                            L = I[E];
                            if (K = L.isLineBreak) {
                                K = M;
                                P = r;
                                var S = void 0,
                                    Y = void 0;
                                if (L.hasBlockSibling) K = 1;
                                else {
                                    S = K.startContainer.getAscendant(i.$block, 1);
                                    if (!S || !S.is({
                                        div: 1,
                                        p: 1
                                    })) K = 0;
                                    else {
                                        Y = S.getPosition(P);
                                        if (Y == CKEDITOR.POSITION_IDENTICAL || Y == CKEDITOR.POSITION_CONTAINS) K = 0;
                                        else {
                                            P = K.splitElement(S);
                                            K.moveToPosition(P, CKEDITOR.POSITION_AFTER_START);
                                            K = 1
                                        }
                                    }
                                }
                            }
                            if (K) C = E > 0;
                            else {
                                K = M.startPath();
                                if (!L.isBlock && j(l.editor, K.block, K.blockLimit) && (T = l.editor.activeEnterMode != CKEDITOR.ENTER_BR && l.editor.config.autoParagraph !== false ? l.editor.activeEnterMode == CKEDITOR.ENTER_DIV ? "div" : "p" : false)) {
                                    T = O.createElement(T);
                                    T.appendBogus();
                                    M.insertNode(T);
                                    CKEDITOR.env.needsBrFiller && (R = T.getBogus()) &&
                                        R.remove();
                                    M.moveToPosition(T, CKEDITOR.POSITION_BEFORE_END)
                                }
                                if ((K = M.startPath().block) && !K.equals(N)) {
                                    if (R = K.getBogus()) {
                                        R.remove();
                                        H.push(K)
                                    }
                                    N = K
                                }
                                L.firstNotAllowed && (q = 1);
                                if (q && L.isElement) {
                                    K = M.startContainer;
                                    for (P = null; K && !i[K.getName()][L.name];) {
                                        if (K.equals(r)) {
                                            K = null;
                                            break
                                        }
                                        P = K;
                                        K = K.getParent()
                                    }
                                    if (K) {
                                        if (P) {
                                            V = M.splitElement(P);
                                            l.zombies.push(V);
                                            l.zombies.push(P)
                                        }
                                    } else {
                                        P = r.getName();
                                        W = !E;
                                        K = E == I.length - 1;
                                        P = c(L.node, P);
                                        for (var S = [], Y = P.length, Z = 0, ba = void 0, X = 0, aa = -1; Z < Y; Z++) {
                                            ba = P[Z];
                                            if (ba == " ") {
                                                if (!X &&
                                                    (!W || Z)) {
                                                    S.push(new CKEDITOR.dom.text(" "));
                                                    aa = S.length
                                                }
                                                X = 1
                                            } else {
                                                S.push(ba);
                                                X = 0
                                            }
                                        }
                                        K && aa == S.length && S.pop();
                                        W = S
                                    }
                                }
                                if (W) {
                                    for (; K = W.pop();) M.insertNode(K);
                                    W = 0
                                } else M.insertNode(L.node); if (L.lastNotAllowed && E < I.length - 1) {
                                    (V = Q ? F : V) && M.setEndAt(V, CKEDITOR.POSITION_AFTER_START);
                                    q = 0
                                }
                                M.collapse()
                            }
                        }
                        l.dontMoveCaret = C;
                        l.bogusNeededBlocks = H
                    }
                    R = l.range;
                    var U;
                    V = l.bogusNeededBlocks;
                    for (W = R.createBookmark(); N = l.zombies.pop();)
                        if (N.getParent()) {
                            T = R.clone();
                            T.moveToElementEditStart(N);
                            T.removeEmptyBlocksAtEnd()
                        }
                    if (V)
                        for (; N =
                            V.pop();) CKEDITOR.env.needsBrFiller ? N.appendBogus() : N.append(R.document.createText(" "));
                    for (; N = l.mergeCandidates.pop();) N.mergeSiblings();
                    R.moveToBookmark(W);
                    if (!l.dontMoveCaret) {
                        for (N = a(R.startContainer) && R.startContainer.getChild(R.startOffset - 1); N && a(N) && !N.is(i.$empty);) {
                            if (N.isBlockBoundary()) R.moveToPosition(N, CKEDITOR.POSITION_BEFORE_END);
                            else {
                                if (d(N) && N.getHtml().match(/(\s|&nbsp;)$/g)) {
                                    U = null;
                                    break
                                }
                                U = R.clone();
                                U.moveToPosition(N, CKEDITOR.POSITION_BEFORE_END)
                            }
                            N = N.getLast(g)
                        }
                        U && R.moveToRange(U)
                    }
                    o.select();
                    h(k)
                }
            }
        }(),
            l = function() {
                function a(b) {
                    b = new CKEDITOR.dom.walker(b);
                    b.guard = function(a, b) {
                        if (b) return false;
                        if (a.type == CKEDITOR.NODE_ELEMENT) return a.is(CKEDITOR.dtd.$tableContent)
                    };
                    b.evaluator = function(a) {
                        return a.type == CKEDITOR.NODE_ELEMENT
                    };
                    return b
                }

                function b(a, c, d) {
                    c = a.getDocument().createElement(c);
                    a.append(c, d);
                    return c
                }

                function c(a) {
                    var b = a.count(),
                        d;
                    for (b; b-- > 0;) {
                        d = a.getItem(b);
                        if (!CKEDITOR.tools.trim(d.getHtml())) {
                            d.appendBogus();
                            CKEDITOR.env.ie && (CKEDITOR.env.version < 9 && d.getChildCount()) &&
                                d.getFirst().remove()
                        }
                    }
                }
                return function(d) {
                    var f = d.startContainer,
                        g = f.getAscendant("table", 1),
                        e = false;
                    c(g.getElementsByTag("td"));
                    c(g.getElementsByTag("th"));
                    g = d.clone();
                    g.setStart(f, 0);
                    g = a(g).lastBackward();
                    if (!g) {
                        g = d.clone();
                        g.setEndAt(f, CKEDITOR.POSITION_BEFORE_END);
                        g = a(g).lastForward();
                        e = true
                    }
                    g || (g = f);
                    if (g.is("table")) {
                        d.setStartAt(g, CKEDITOR.POSITION_BEFORE_START);
                        d.collapse(true);
                        g.remove()
                    } else {
                        g.is({
                            tbody: 1,
                            thead: 1,
                            tfoot: 1
                        }) && (g = b(g, "tr", e));
                        g.is("tr") && (g = b(g, g.getParent().is("thead") ? "th" :
                            "td", e));
                        (f = g.getBogus()) && f.remove();
                        d.moveToPosition(g, e ? CKEDITOR.POSITION_AFTER_START : CKEDITOR.POSITION_BEFORE_END)
                    }
                }
            }()
    }(),
    function() {
        function a() {
            var a = this._.fakeSelection,
                b;
            if (a) {
                b = this.getSelection(1);
                if (!b || !b.isHidden()) {
                    a.reset();
                    a = 0
                }
            }
            if (!a) {
                a = b || this.getSelection(1);
                if (!a || a.getType() == CKEDITOR.SELECTION_NONE) return
            }
            this.fire("selectionCheck", a);
            b = this.elementPath();
            if (!b.compare(this._.selectionPreviousPath)) {
                if (CKEDITOR.env.webkit) this._.previousActive = this.document.getActive();
                this._.selectionPreviousPath =
                    b;
                this.fire("selectionChange", {
                    selection: a,
                    path: b
                })
            }
        }

        function e() {
            m = true;
            if (!q) {
                b.call(this);
                q = CKEDITOR.tools.setTimeout(b, 200, this)
            }
        }

        function b() {
            q = null;
            if (m) {
                CKEDITOR.tools.setTimeout(a, 0, this);
                m = false
            }
        }

        function g(a) {
            return l(a) || a.type == CKEDITOR.NODE_ELEMENT && !a.is(CKEDITOR.dtd.$empty) ? true : false
        }

        function c(a) {
            function b(c, d) {
                return !c || c.type == CKEDITOR.NODE_TEXT ? false : a.clone()["moveToElementEdit" + (d ? "End" : "Start")](c)
            }
            if (!(a.root instanceof CKEDITOR.editable)) return false;
            var c = a.startContainer,
                d = a.getPreviousNode(g, null, c),
                f = a.getNextNode(g, null, c);
            return b(d) || b(f, 1) || !d && !f && !(c.type == CKEDITOR.NODE_ELEMENT && c.isBlockBoundary() && c.getBogus()) ? true : false
        }

        function d(a) {
            return a.getCustomData("cke-fillingChar")
        }

        function j(a, b) {
            var c = a && a.removeCustomData("cke-fillingChar");
            if (c) {
                if (b !== false) {
                    var d, g = a.getDocument().getSelection().getNative(),
                        e = g && g.type != "None" && g.getRangeAt(0);
                    if (c.getLength() > 1 && e && e.intersectsNode(c.$)) {
                        d = h(g);
                        e = g.focusNode == c.$ && g.focusOffset > 0;
                        g.anchorNode == c.$ && g.anchorOffset >
                            0 && d[0].offset--;
                        e && d[1].offset--
                    }
                }
                c.setText(f(c.getText()));
                d && i(a.getDocument().$, d)
            }
        }

        function f(a) {
            return a.replace(/\u200B( )?/g, function(a) {
                return a[1] ? " " : ""
            })
        }

        function h(a) {
            return [{
                node: a.anchorNode,
                offset: a.anchorOffset
            }, {
                node: a.focusNode,
                offset: a.focusOffset
            }]
        }

        function i(a, b) {
            var c = a.getSelection(),
                d = a.createRange();
            d.setStart(b[0].node, b[0].offset);
            d.collapse(true);
            c.removeAllRanges();
            c.addRange(d);
            c.extend(b[1].node, b[1].offset)
        }

        function k(a) {
            var b = CKEDITOR.dom.element.createFromHtml('<div data-cke-hidden-sel="1" data-cke-temp="1" style="' +
                (CKEDITOR.env.ie ? "display:none" : "position:fixed;top:0;left:-1000px") + '">&nbsp;</div>', a.document);
            a.fire("lockSnapshot");
            a.editable().append(b);
            var c = a.getSelection(1),
                d = a.createRange(),
                f = c.root.on("selectionchange", function(a) {
                    a.cancel()
                }, null, null, 0);
            d.setStartAt(b, CKEDITOR.POSITION_AFTER_START);
            d.setEndAt(b, CKEDITOR.POSITION_BEFORE_END);
            c.selectRanges([d]);
            f.removeListener();
            a.fire("unlockSnapshot");
            a._.hiddenSelectionContainer = b
        }

        function n(a) {
            var b = {
                37: 1,
                39: 1,
                8: 1,
                46: 1
            };
            return function(c) {
                var d =
                    c.data.getKeystroke();
                if (b[d]) {
                    var f = a.getSelection().getRanges(),
                        g = f[0];
                    if (f.length == 1 && g.collapsed)
                        if ((d = g[d < 38 ? "getPreviousEditableNode" : "getNextEditableNode"]()) && d.type == CKEDITOR.NODE_ELEMENT && d.getAttribute("contenteditable") == "false") {
                            a.getSelection().fake(d);
                            c.data.preventDefault();
                            c.cancel()
                        }
                }
            }
        }

        function o(a) {
            for (var b = 0; b < a.length; b++) {
                var c = a[b];
                c.getCommonAncestor().isReadOnly() && a.splice(b, 1);
                if (!c.collapsed) {
                    if (c.startContainer.isReadOnly())
                        for (var d = c.startContainer, f; d;) {
                            if ((f = d.type ==
                                CKEDITOR.NODE_ELEMENT) && d.is("body") || !d.isReadOnly()) break;
                            f && d.getAttribute("contentEditable") == "false" && c.setStartAfter(d);
                            d = d.getParent()
                        }
                    d = c.startContainer;
                    f = c.endContainer;
                    var g = c.startOffset,
                        e = c.endOffset,
                        h = c.clone();
                    d && d.type == CKEDITOR.NODE_TEXT && (g >= d.getLength() ? h.setStartAfter(d) : h.setStartBefore(d));
                    f && f.type == CKEDITOR.NODE_TEXT && (e ? h.setEndAfter(f) : h.setEndBefore(f));
                    d = new CKEDITOR.dom.walker(h);
                    d.evaluator = function(d) {
                        if (d.type == CKEDITOR.NODE_ELEMENT && d.isReadOnly()) {
                            var f = c.clone();
                            c.setEndBefore(d);
                            c.collapsed && a.splice(b--, 1);
                            if (!(d.getPosition(h.endContainer) & CKEDITOR.POSITION_CONTAINS)) {
                                f.setStartAfter(d);
                                f.collapsed || a.splice(b + 1, 0, f)
                            }
                            return true
                        }
                        return false
                    };
                    d.next()
                }
            }
            return a
        }
        var q, m, l = CKEDITOR.dom.walker.invisible(1),
            p = function() {
                function a(b) {
                    return function(a) {
                        var c = a.editor.createRange();
                        c.moveToClosestEditablePosition(a.selected, b) && a.editor.getSelection().selectRanges([c]);
                        return false
                    }
                }

                function b(a) {
                    return function(b) {
                        var c = b.editor,
                            d = c.createRange(),
                            f;
                        if (!(f =
                            d.moveToClosestEditablePosition(b.selected, a))) f = d.moveToClosestEditablePosition(b.selected, !a);
                        f && c.getSelection().selectRanges([d]);
                        c.fire("saveSnapshot");
                        b.selected.remove();
                        if (!f) {
                            d.moveToElementEditablePosition(c.editable());
                            c.getSelection().selectRanges([d])
                        }
                        c.fire("saveSnapshot");
                        return false
                    }
                }
                var c = a(),
                    d = a(1);
                return {
                    37: c,
                    38: c,
                    39: d,
                    40: d,
                    8: b(),
                    46: b(1)
                }
            }();
        CKEDITOR.on("instanceCreated", function(b) {
            function c() {
                var a = d.getSelection();
                a && a.removeAllRanges()
            }
            var d = b.editor;
            d.on("contentDom", function() {
                function b() {
                    p =
                        new CKEDITOR.dom.selection(d.getSelection());
                    p.lock()
                }

                function c() {
                    g.removeListener("mouseup", c);
                    k.removeListener("mouseup", c);
                    var a = CKEDITOR.document.$.selection,
                        b = a.createRange();
                    a.type != "None" && b.parentElement().ownerDocument == f.$ && b.select()
                }
                var f = d.document,
                    g = CKEDITOR.document,
                    h = d.editable(),
                    i = f.getBody(),
                    k = f.getDocumentElement(),
                    m = h.isInline(),
                    C, p;
                CKEDITOR.env.gecko && h.attachListener(h, "focus", function(a) {
                    a.removeListener();
                    if (C !== 0)
                        if ((a = d.getSelection().getNative()) && a.isCollapsed && a.anchorNode ==
                            h.$) {
                            a = d.createRange();
                            a.moveToElementEditStart(h);
                            a.select()
                        }
                }, null, null, -2);
                h.attachListener(h, CKEDITOR.env.webkit ? "DOMFocusIn" : "focus", function() {
                    C && CKEDITOR.env.webkit && (C = d._.previousActive && d._.previousActive.equals(f.getActive()));
                    d.unlockSelection(C);
                    C = 0
                }, null, null, -1);
                h.attachListener(h, "mousedown", function() {
                    C = 0
                });
                if (CKEDITOR.env.ie || m) {
                    t ? h.attachListener(h, "beforedeactivate", b, null, null, -1) : h.attachListener(d, "selectionCheck", b, null, null, -1);
                    h.attachListener(h, CKEDITOR.env.webkit ? "DOMFocusOut" :
                        "blur", function() {
                            d.lockSelection(p);
                            C = 1
                        }, null, null, -1);
                    h.attachListener(h, "mousedown", function() {
                        C = 0
                    })
                }
                if (CKEDITOR.env.ie && !m) {
                    var s;
                    h.attachListener(h, "mousedown", function(a) {
                        if (a.data.$.button == 2) {
                            a = d.document.getSelection();
                            if (!a || a.getType() == CKEDITOR.SELECTION_NONE) s = d.window.getScrollPosition()
                        }
                    });
                    h.attachListener(h, "mouseup", function(a) {
                        if (a.data.$.button == 2 && s) {
                            d.document.$.documentElement.scrollLeft = s.x;
                            d.document.$.documentElement.scrollTop = s.y
                        }
                        s = null
                    });
                    if (f.$.compatMode != "BackCompat") {
                        if (CKEDITOR.env.ie7Compat ||
                            CKEDITOR.env.ie6Compat) k.on("mousedown", function(a) {
                            function b(a) {
                                a = a.data.$;
                                if (d) {
                                    var c = i.$.createTextRange();
                                    try {
                                        c.moveToPoint(a.clientX, a.clientY)
                                    } catch (f) {}
                                    d.setEndPoint(e.compareEndPoints("StartToStart", c) < 0 ? "EndToEnd" : "StartToStart", c);
                                    d.select()
                                }
                            }

                            function c() {
                                k.removeListener("mousemove", b);
                                g.removeListener("mouseup", c);
                                k.removeListener("mouseup", c);
                                d.select()
                            }
                            a = a.data;
                            if (a.getTarget().is("html") && a.$.y < k.$.clientHeight && a.$.x < k.$.clientWidth) {
                                var d = i.$.createTextRange();
                                try {
                                    d.moveToPoint(a.$.clientX,
                                        a.$.clientY)
                                } catch (f) {}
                                var e = d.duplicate();
                                k.on("mousemove", b);
                                g.on("mouseup", c);
                                k.on("mouseup", c)
                            }
                        });
                        if (CKEDITOR.env.version > 7 && CKEDITOR.env.version < 11) k.on("mousedown", function(a) {
                            if (a.data.getTarget().is("html")) {
                                g.on("mouseup", c);
                                k.on("mouseup", c)
                            }
                        })
                    }
                }
                h.attachListener(h, "selectionchange", a, d);
                h.attachListener(h, "keyup", e, d);
                h.attachListener(h, CKEDITOR.env.webkit ? "DOMFocusIn" : "focus", function() {
                    d.forceNextSelectionCheck();
                    d.selectionChange(1)
                });
                if (m && (CKEDITOR.env.webkit || CKEDITOR.env.gecko)) {
                    var l;
                    h.attachListener(h, "mousedown", function() {
                        l = 1
                    });
                    h.attachListener(f.getDocumentElement(), "mouseup", function() {
                        l && e.call(d);
                        l = 0
                    })
                } else h.attachListener(CKEDITOR.env.ie ? h : f.getDocumentElement(), "mouseup", e, d);
                CKEDITOR.env.webkit && h.attachListener(f, "keydown", function(a) {
                    switch (a.data.getKey()) {
                        case 13:
                        case 33:
                        case 34:
                        case 35:
                        case 36:
                        case 37:
                        case 39:
                        case 8:
                        case 45:
                        case 46:
                            j(h)
                    }
                }, null, null, -1);
                h.attachListener(h, "keydown", n(d), null, null, -1)
            });
            d.on("setData", function() {
                d.unlockSelection();
                CKEDITOR.env.webkit &&
                    c()
            });
            d.on("contentDomUnload", function() {
                d.unlockSelection()
            });
            if (CKEDITOR.env.ie9Compat) d.on("beforeDestroy", c, null, null, 9);
            d.on("dataReady", function() {
                delete d._.fakeSelection;
                delete d._.hiddenSelectionContainer;
                d.selectionChange(1)
            });
            d.on("loadSnapshot", function() {
                var a = CKEDITOR.dom.walker.nodeType(CKEDITOR.NODE_ELEMENT),
                    b = d.editable().getLast(a);
                if (b && b.hasAttribute("data-cke-hidden-sel")) {
                    b.remove();
                    if (CKEDITOR.env.gecko)(a = d.editable().getFirst(a)) && (a.is("br") && a.getAttribute("_moz_editor_bogus_node")) &&
                        a.remove()
                }
            }, null, null, 100);
            d.on("key", function(a) {
                if (d.mode == "wysiwyg") {
                    var b = d.getSelection();
                    if (b.isFake) {
                        var c = p[a.data.keyCode];
                        if (c) return c({
                            editor: d,
                            selected: b.getSelectedElement(),
                            selection: b,
                            keyEvent: a
                        })
                    }
                }
            })
        });
        CKEDITOR.on("instanceReady", function(a) {
            function b() {
                var a = g.editable();
                if (a)
                    if (a = d(a)) {
                        var c = g.document.$.getSelection();
                        if (c.type != "None" && (c.anchorNode == a.$ || c.focusNode == a.$)) k = h(c);
                        e = a.getText();
                        a.setText(f(e))
                    }
            }

            function c() {
                var a = g.editable();
                if (a)
                    if (a = d(a)) {
                        a.setText(e);
                        if (k) {
                            i(g.document.$,
                                k);
                            k = null
                        }
                    }
            }
            var g = a.editor,
                e, k;
            if (CKEDITOR.env.webkit) {
                g.on("selectionChange", function() {
                    var a = g.editable(),
                        b = d(a);
                    b && (b.getCustomData("ready") ? j(a) : b.setCustomData("ready", 1))
                }, null, null, -1);
                g.on("beforeSetMode", function() {
                    j(g.editable())
                }, null, null, -1);
                g.on("beforeUndoImage", b);
                g.on("afterUndoImage", c);
                g.on("beforeGetData", b, null, null, 0);
                g.on("getData", c)
            }
        });
        CKEDITOR.editor.prototype.selectionChange = function(b) {
            (b ? a : e).call(this)
        };
        CKEDITOR.editor.prototype.getSelection = function(a) {
            if ((this._.savedSelection ||
                this._.fakeSelection) && !a) return this._.savedSelection || this._.fakeSelection;
            return (a = this.editable()) && this.mode == "wysiwyg" ? new CKEDITOR.dom.selection(a) : null
        };
        CKEDITOR.editor.prototype.lockSelection = function(a) {
            a = a || this.getSelection(1);
            if (a.getType() != CKEDITOR.SELECTION_NONE) {
                !a.isLocked && a.lock();
                this._.savedSelection = a;
                return true
            }
            return false
        };
        CKEDITOR.editor.prototype.unlockSelection = function(a) {
            var b = this._.savedSelection;
            if (b) {
                b.unlock(a);
                delete this._.savedSelection;
                return true
            }
            return false
        };
        CKEDITOR.editor.prototype.forceNextSelectionCheck = function() {
            delete this._.selectionPreviousPath
        };
        CKEDITOR.dom.document.prototype.getSelection = function() {
            return new CKEDITOR.dom.selection(this)
        };
        CKEDITOR.dom.range.prototype.select = function() {
            var a = this.root instanceof CKEDITOR.editable ? this.root.editor.getSelection() : new CKEDITOR.dom.selection(this.root);
            a.selectRanges([this]);
            return a
        };
        CKEDITOR.SELECTION_NONE = 1;
        CKEDITOR.SELECTION_TEXT = 2;
        CKEDITOR.SELECTION_ELEMENT = 3;
        var t = typeof window.getSelection !=
            "function",
            s = 1;
        CKEDITOR.dom.selection = function(a) {
            if (a instanceof CKEDITOR.dom.selection) var b = a,
            a = a.root;
            var c = a instanceof CKEDITOR.dom.element;
            this.rev = b ? b.rev : s++;
            this.document = a instanceof CKEDITOR.dom.document ? a : a.getDocument();
            this.root = c ? a : this.document.getBody();
            this.isLocked = 0;
            this._ = {
                cache: {}
            };
            if (b) {
                CKEDITOR.tools.extend(this._.cache, b._.cache);
                this.isFake = b.isFake;
                this.isLocked = b.isLocked;
                return this
            }
            var a = this.getNative(),
                d, f;
            if (a)
                if (a.getRangeAt) d = (f = a.rangeCount && a.getRangeAt(0)) &&
                    new CKEDITOR.dom.node(f.commonAncestorContainer);
                else {
                    try {
                        f = a.createRange()
                    } catch (g) {}
                    d = f && CKEDITOR.dom.element.get(f.item && f.item(0) || f.parentElement())
                }
            if (!d || !(d.type == CKEDITOR.NODE_ELEMENT || d.type == CKEDITOR.NODE_TEXT) || !this.root.equals(d) && !this.root.contains(d)) {
                this._.cache.type = CKEDITOR.SELECTION_NONE;
                this._.cache.startElement = null;
                this._.cache.selectedElement = null;
                this._.cache.selectedText = "";
                this._.cache.ranges = new CKEDITOR.dom.rangeList
            }
            return this
        };
        var u = {
            img: 1,
            hr: 1,
            li: 1,
            table: 1,
            tr: 1,
            td: 1,
            th: 1,
            embed: 1,
            object: 1,
            ol: 1,
            ul: 1,
            a: 1,
            input: 1,
            form: 1,
            select: 1,
            textarea: 1,
            button: 1,
            fieldset: 1,
            thead: 1,
            tfoot: 1
        };
        CKEDITOR.dom.selection.prototype = {
            getNative: function() {
                return this._.cache.nativeSel !== void 0 ? this._.cache.nativeSel : this._.cache.nativeSel = t ? this.document.$.selection : this.document.getWindow().$.getSelection()
            },
            getType: t ? function() {
                var a = this._.cache;
                if (a.type) return a.type;
                var b = CKEDITOR.SELECTION_NONE;
                try {
                    var c = this.getNative(),
                        d = c.type;
                    if (d == "Text") b = CKEDITOR.SELECTION_TEXT;
                    if (d == "Control") b =
                        CKEDITOR.SELECTION_ELEMENT;
                    if (c.createRange().parentElement()) b = CKEDITOR.SELECTION_TEXT
                } catch (f) {}
                return a.type = b
            } : function() {
                var a = this._.cache;
                if (a.type) return a.type;
                var b = CKEDITOR.SELECTION_TEXT,
                    c = this.getNative();
                if (!c || !c.rangeCount) b = CKEDITOR.SELECTION_NONE;
                else if (c.rangeCount == 1) {
                    var c = c.getRangeAt(0),
                        d = c.startContainer;
                    if (d == c.endContainer && d.nodeType == 1 && c.endOffset - c.startOffset == 1 && u[d.childNodes[c.startOffset].nodeName.toLowerCase()]) b = CKEDITOR.SELECTION_ELEMENT
                }
                return a.type = b
            },
            getRanges: function() {
                var a =
                    t ? function() {
                        function a(b) {
                            return (new CKEDITOR.dom.node(b)).getIndex()
                        }
                        var b = function(b, c) {
                            b = b.duplicate();
                            b.collapse(c);
                            var d = b.parentElement();
                            if (!d.hasChildNodes()) return {
                                container: d,
                                offset: 0
                            };
                            for (var f = d.children, g, e, h = b.duplicate(), j = 0, i = f.length - 1, k = -1, m, p; j <= i;) {
                                k = Math.floor((j + i) / 2);
                                g = f[k];
                                h.moveToElementText(g);
                                m = h.compareEndPoints("StartToStart", b);
                                if (m > 0) i = k - 1;
                                else if (m < 0) j = k + 1;
                                else return {
                                    container: d,
                                    offset: a(g)
                                }
                            }
                            if (k == -1 || k == f.length - 1 && m < 0) {
                                h.moveToElementText(d);
                                h.setEndPoint("StartToStart",
                                    b);
                                h = h.text.replace(/(\r\n|\r)/g, "\n").length;
                                f = d.childNodes;
                                if (!h) {
                                    g = f[f.length - 1];
                                    return g.nodeType != CKEDITOR.NODE_TEXT ? {
                                        container: d,
                                        offset: f.length
                                    } : {
                                        container: g,
                                        offset: g.nodeValue.length
                                    }
                                }
                                for (d = f.length; h > 0 && d > 0;) {
                                    e = f[--d];
                                    if (e.nodeType == CKEDITOR.NODE_TEXT) {
                                        p = e;
                                        h = h - e.nodeValue.length
                                    }
                                }
                                return {
                                    container: p,
                                    offset: -h
                                }
                            }
                            h.collapse(m > 0 ? true : false);
                            h.setEndPoint(m > 0 ? "StartToStart" : "EndToStart", b);
                            h = h.text.replace(/(\r\n|\r)/g, "\n").length;
                            if (!h) return {
                                container: d,
                                offset: a(g) + (m > 0 ? 0 : 1)
                            };
                            for (; h > 0;) try {
                                e =
                                    g[m > 0 ? "previousSibling" : "nextSibling"];
                                if (e.nodeType == CKEDITOR.NODE_TEXT) {
                                    h = h - e.nodeValue.length;
                                    p = e
                                }
                                g = e
                            } catch (t) {
                                return {
                                    container: d,
                                    offset: a(g)
                                }
                            }
                            return {
                                container: p,
                                offset: m > 0 ? -h : p.nodeValue.length + h
                            }
                        };
                        return function() {
                            var a = this.getNative(),
                                c = a && a.createRange(),
                                d = this.getType();
                            if (!a) return [];
                            if (d == CKEDITOR.SELECTION_TEXT) {
                                a = new CKEDITOR.dom.range(this.root);
                                d = b(c, true);
                                a.setStart(new CKEDITOR.dom.node(d.container), d.offset);
                                d = b(c);
                                a.setEnd(new CKEDITOR.dom.node(d.container), d.offset);
                                a.endContainer.getPosition(a.startContainer) &
                                    CKEDITOR.POSITION_PRECEDING && a.endOffset <= a.startContainer.getIndex() && a.collapse();
                                return [a]
                            }
                            if (d == CKEDITOR.SELECTION_ELEMENT) {
                                for (var d = [], f = 0; f < c.length; f++) {
                                    for (var g = c.item(f), e = g.parentNode, h = 0, a = new CKEDITOR.dom.range(this.root); h < e.childNodes.length && e.childNodes[h] != g; h++);
                                    a.setStart(new CKEDITOR.dom.node(e), h);
                                    a.setEnd(new CKEDITOR.dom.node(e), h + 1);
                                    d.push(a)
                                }
                                return d
                            }
                            return []
                        }
                    }() : function() {
                        var a = [],
                            b, c = this.getNative();
                        if (!c) return a;
                        for (var d = 0; d < c.rangeCount; d++) {
                            var f = c.getRangeAt(d);
                            b = new CKEDITOR.dom.range(this.root);
                            b.setStart(new CKEDITOR.dom.node(f.startContainer), f.startOffset);
                            b.setEnd(new CKEDITOR.dom.node(f.endContainer), f.endOffset);
                            a.push(b)
                        }
                        return a
                    };
                return function(b) {
                    var c = this._.cache,
                        d = c.ranges;
                    if (!d) c.ranges = d = new CKEDITOR.dom.rangeList(a.call(this));
                    return !b ? d : o(new CKEDITOR.dom.rangeList(d.slice()))
                }
            }(),
            getStartElement: function() {
                var a = this._.cache;
                if (a.startElement !== void 0) return a.startElement;
                var b;
                switch (this.getType()) {
                    case CKEDITOR.SELECTION_ELEMENT:
                        return this.getSelectedElement();
                    case CKEDITOR.SELECTION_TEXT:
                        var c = this.getRanges()[0];
                        if (c) {
                            if (c.collapsed) {
                                b = c.startContainer;
                                b.type != CKEDITOR.NODE_ELEMENT && (b = b.getParent())
                            } else {
                                for (c.optimize();;) {
                                    b = c.startContainer;
                                    if (c.startOffset == (b.getChildCount ? b.getChildCount() : b.getLength()) && !b.isBlockBoundary()) c.setStartAfter(b);
                                    else break
                                }
                                b = c.startContainer;
                                if (b.type != CKEDITOR.NODE_ELEMENT) return b.getParent();
                                b = b.getChild(c.startOffset);
                                if (!b || b.type != CKEDITOR.NODE_ELEMENT) b = c.startContainer;
                                else
                                    for (c = b.getFirst(); c && c.type ==
                                        CKEDITOR.NODE_ELEMENT;) {
                                        b = c;
                                        c = c.getFirst()
                                    }
                            }
                            b = b.$
                        }
                }
                return a.startElement = b ? new CKEDITOR.dom.element(b) : null
            },
            getSelectedElement: function() {
                var a = this._.cache;
                if (a.selectedElement !== void 0) return a.selectedElement;
                var b = this,
                    c = CKEDITOR.tools.tryThese(function() {
                        return b.getNative().createRange().item(0)
                    }, function() {
                        for (var a = b.getRanges()[0].clone(), c, d, f = 2; f && (!(c = a.getEnclosedNode()) || !(c.type == CKEDITOR.NODE_ELEMENT && u[c.getName()] && (d = c))); f--) a.shrink(CKEDITOR.SHRINK_ELEMENT);
                        return d && d.$
                    });
                return a.selectedElement =
                    c ? new CKEDITOR.dom.element(c) : null
            },
            getSelectedText: function() {
                var a = this._.cache;
                if (a.selectedText !== void 0) return a.selectedText;
                var b = this.getNative(),
                    b = t ? b.type == "Control" ? "" : b.createRange().text : b.toString();
                return a.selectedText = b
            },
            lock: function() {
                this.getRanges();
                this.getStartElement();
                this.getSelectedElement();
                this.getSelectedText();
                this._.cache.nativeSel = null;
                this.isLocked = 1
            },
            unlock: function(a) {
                if (this.isLocked) {
                    if (a) var b = this.getSelectedElement(),
                    c = !b && this.getRanges(), d = this.isFake;
                    this.isLocked =
                        0;
                    this.reset();
                    if (a)(a = b || c[0] && c[0].getCommonAncestor()) && a.getAscendant("body", 1) && (d ? this.fake(b) : b ? this.selectElement(b) : this.selectRanges(c))
                }
            },
            reset: function() {
                this._.cache = {};
                this.isFake = 0;
                var a = this.root.editor;
                if (a && a._.fakeSelection && this.rev == a._.fakeSelection.rev) {
                    delete a._.fakeSelection;
                    var b = a._.hiddenSelectionContainer;
                    if (b) {
                        var c = a.checkDirty();
                        a.fire("lockSnapshot");
                        b.remove();
                        a.fire("unlockSnapshot");
                        !c && a.resetDirty()
                    }
                    delete a._.hiddenSelectionContainer
                }
                this.rev = s++
            },
            selectElement: function(a) {
                var b =
                    new CKEDITOR.dom.range(this.root);
                b.setStartBefore(a);
                b.setEndAfter(a);
                this.selectRanges([b])
            },
            selectRanges: function(a) {
                var b = this.root.editor,
                    b = b && b._.hiddenSelectionContainer;
                this.reset();
                if (b)
                    for (var b = this.root, d, f = 0; f < a.length; ++f) {
                        d = a[f];
                        if (d.endContainer.equals(b)) d.endOffset = Math.min(d.endOffset, b.getChildCount())
                    }
                if (a.length)
                    if (this.isLocked) {
                        var g = CKEDITOR.document.getActive();
                        this.unlock();
                        this.selectRanges(a);
                        this.lock();
                        g && !g.equals(this.root) && g.focus()
                    } else {
                        var e;
                        a: {
                            var h, i;
                            if (a.length ==
                                1 && !(i = a[0]).collapsed && (e = i.getEnclosedNode()) && e.type == CKEDITOR.NODE_ELEMENT) {
                                i = i.clone();
                                i.shrink(CKEDITOR.SHRINK_ELEMENT, true);
                                if ((h = i.getEnclosedNode()) && h.type == CKEDITOR.NODE_ELEMENT) e = h;
                                if (e.getAttribute("contenteditable") == "false") break a
                            }
                            e = void 0
                        }
                        if (e) this.fake(e);
                        else {
                            if (t) {
                                i = CKEDITOR.dom.walker.whitespaces(true);
                                h = /\ufeff|\u00a0/;
                                b = {
                                    table: 1,
                                    tbody: 1,
                                    tr: 1
                                };
                                if (a.length > 1) {
                                    e = a[a.length - 1];
                                    a[0].setEnd(e.endContainer, e.endOffset)
                                }
                                e = a[0];
                                var a = e.collapsed,
                                    k, m, p;
                                if ((d = e.getEnclosedNode()) && d.type ==
                                    CKEDITOR.NODE_ELEMENT && d.getName() in u && (!d.is("a") || !d.getText())) try {
                                    p = d.$.createControlRange();
                                    p.addElement(d.$);
                                    p.select();
                                    return
                                } catch (C) {}
                                if (e.startContainer.type == CKEDITOR.NODE_ELEMENT && e.startContainer.getName() in b || e.endContainer.type == CKEDITOR.NODE_ELEMENT && e.endContainer.getName() in b) {
                                    e.shrink(CKEDITOR.NODE_ELEMENT, true);
                                    a = e.collapsed
                                }
                                p = e.createBookmark();
                                b = p.startNode;
                                if (!a) g = p.endNode;
                                p = e.document.$.body.createTextRange();
                                p.moveToElementText(b.$);
                                p.moveStart("character", 1);
                                if (g) {
                                    h =
                                        e.document.$.body.createTextRange();
                                    h.moveToElementText(g.$);
                                    p.setEndPoint("EndToEnd", h);
                                    p.moveEnd("character", -1)
                                } else {
                                    k = b.getNext(i);
                                    m = b.hasAscendant("pre");
                                    k = !(k && k.getText && k.getText().match(h)) && (m || !b.hasPrevious() || b.getPrevious().is && b.getPrevious().is("br"));
                                    m = e.document.createElement("span");
                                    m.setHtml("&#65279;");
                                    m.insertBefore(b);
                                    k && e.document.createText("﻿").insertBefore(b)
                                }
                                e.setStartBefore(b);
                                b.remove();
                                if (a) {
                                    if (k) {
                                        p.moveStart("character", -1);
                                        p.select();
                                        e.document.$.selection.clear()
                                    } else p.select();
                                    e.moveToPosition(m, CKEDITOR.POSITION_BEFORE_START);
                                    m.remove()
                                } else {
                                    e.setEndBefore(g);
                                    g.remove();
                                    p.select()
                                }
                            } else {
                                g = this.getNative();
                                if (!g) return;
                                this.removeAllRanges();
                                for (p = 0; p < a.length; p++) {
                                    if (p < a.length - 1) {
                                        k = a[p];
                                        m = a[p + 1];
                                        h = k.clone();
                                        h.setStart(k.endContainer, k.endOffset);
                                        h.setEnd(m.startContainer, m.startOffset);
                                        if (!h.collapsed) {
                                            h.shrink(CKEDITOR.NODE_ELEMENT, true);
                                            e = h.getCommonAncestor();
                                            h = h.getEnclosedNode();
                                            if (e.isReadOnly() || h && h.isReadOnly()) {
                                                m.setStart(k.startContainer, k.startOffset);
                                                a.splice(p--,
                                                    1);
                                                continue
                                            }
                                        }
                                    }
                                    e = a[p];
                                    m = this.document.$.createRange();
                                    if (e.collapsed && CKEDITOR.env.webkit && c(e)) {
                                        k = this.root;
                                        j(k, false);
                                        h = k.getDocument().createText("​");
                                        k.setCustomData("cke-fillingChar", h);
                                        e.insertNode(h);
                                        if ((k = h.getNext()) && !h.getPrevious() && k.type == CKEDITOR.NODE_ELEMENT && k.getName() == "br") {
                                            j(this.root);
                                            e.moveToPosition(k, CKEDITOR.POSITION_BEFORE_START)
                                        } else e.moveToPosition(h, CKEDITOR.POSITION_AFTER_END)
                                    }
                                    m.setStart(e.startContainer.$, e.startOffset);
                                    try {
                                        m.setEnd(e.endContainer.$, e.endOffset)
                                    } catch (n) {
                                        if (n.toString().indexOf("NS_ERROR_ILLEGAL_VALUE") >=
                                            0) {
                                            e.collapse(1);
                                            m.setEnd(e.endContainer.$, e.endOffset)
                                        } else throw n;
                                    }
                                    g.addRange(m)
                                }
                            }
                            this.reset();
                            this.root.fire("selectionchange")
                        }
                    }
            },
            fake: function(a) {
                var b = this.root.editor;
                this.reset();
                k(b);
                var c = this._.cache,
                    d = new CKEDITOR.dom.range(this.root);
                d.setStartBefore(a);
                d.setEndAfter(a);
                c.ranges = new CKEDITOR.dom.rangeList(d);
                c.selectedElement = c.startElement = a;
                c.type = CKEDITOR.SELECTION_ELEMENT;
                c.selectedText = c.nativeSel = null;
                this.isFake = 1;
                this.rev = s++;
                b._.fakeSelection = this;
                this.root.fire("selectionchange")
            },
            isHidden: function() {
                var a = this.getCommonAncestor();
                a && a.type == CKEDITOR.NODE_TEXT && (a = a.getParent());
                return !(!a || !a.data("cke-hidden-sel"))
            },
            createBookmarks: function(a) {
                a = this.getRanges().createBookmarks(a);
                this.isFake && (a.isFake = 1);
                return a
            },
            createBookmarks2: function(a) {
                a = this.getRanges().createBookmarks2(a);
                this.isFake && (a.isFake = 1);
                return a
            },
            selectBookmarks: function(a) {
                for (var b = [], c = 0; c < a.length; c++) {
                    var d = new CKEDITOR.dom.range(this.root);
                    d.moveToBookmark(a[c]);
                    b.push(d)
                }
                a.isFake ? this.fake(b[0].getEnclosedNode()) :
                    this.selectRanges(b);
                return this
            },
            getCommonAncestor: function() {
                var a = this.getRanges();
                return !a.length ? null : a[0].startContainer.getCommonAncestor(a[a.length - 1].endContainer)
            },
            scrollIntoView: function() {
                this.type != CKEDITOR.SELECTION_NONE && this.getRanges()[0].scrollIntoView()
            },
            removeAllRanges: function() {
                if (this.getType() != CKEDITOR.SELECTION_NONE) {
                    var a = this.getNative();
                    try {
                        a && a[t ? "empty" : "removeAllRanges"]()
                    } catch (b) {}
                    this.reset()
                }
            }
        }
    }(), "use strict", CKEDITOR.STYLE_BLOCK = 1, CKEDITOR.STYLE_INLINE = 2, CKEDITOR.STYLE_OBJECT =
        3,
    function() {
        function a(a, b) {
            for (var c, d; a = a.getParent();) {
                if (a.equals(b)) break;
                if (a.getAttribute("data-nostyle")) c = a;
                else if (!d) {
                    var f = a.getAttribute("contentEditable");
                    f == "false" ? c = a : f == "true" && (d = 1)
                }
            }
            return c
        }

        function e(b) {
            var c = b.document;
            if (b.collapsed) {
                c = p(this, c);
                b.insertNode(c);
                b.moveToPosition(c, CKEDITOR.POSITION_BEFORE_END)
            } else {
                var d = this.element,
                    f = this._.definition,
                    h, i = f.ignoreReadonly,
                    j = i || f.includeReadonly;
                j == null && (j = b.root.getCustomData("cke_includeReadonly"));
                var k = CKEDITOR.dtd[d];
                if (!k) {
                    h = true;
                    k = CKEDITOR.dtd.span
                }
                b.enlarge(CKEDITOR.ENLARGE_INLINE, 1);
                b.trim();
                var m = b.createBookmark(),
                    t = m.startNode,
                    n = m.endNode,
                    s = t,
                    l;
                if (!i) {
                    var o = b.getCommonAncestor(),
                        i = a(t, o),
                        o = a(n, o);
                    i && (s = i.getNextSourceNode(true));
                    o && (n = o)
                }
                for (s.getPosition(n) == CKEDITOR.POSITION_FOLLOWING && (s = 0); s;) {
                    i = false;
                    if (s.equals(n)) {
                        s = null;
                        i = true
                    } else {
                        var u = s.type == CKEDITOR.NODE_ELEMENT ? s.getName() : null,
                            o = u && s.getAttribute("contentEditable") == "false",
                            w = u && s.getAttribute("data-nostyle");
                        if (u && s.data("cke-bookmark")) {
                            s =
                                s.getNextSourceNode(true);
                            continue
                        }
                        if (o && j && CKEDITOR.dtd.$block[u])
                            for (var x = s, r = g(x), v = void 0, z = r.length, y = 0, x = z && new CKEDITOR.dom.range(x.getDocument()); y < z; ++y) {
                                var v = r[y],
                                    A = CKEDITOR.filter.instances[v.data("cke-filter")];
                                if (A ? A.check(this) : 1) {
                                    x.selectNodeContents(v);
                                    e.call(this, x)
                                }
                            }
                        r = u ? !k[u] || w ? 0 : o && !j ? 0 : (s.getPosition(n) | G) == G && (!f.childRule || f.childRule(s)) : 1;
                        if (r)
                            if ((r = s.getParent()) && ((r.getDtd() || CKEDITOR.dtd.span)[d] || h) && (!f.parentRule || f.parentRule(r))) {
                                if (!l && (!u || !CKEDITOR.dtd.$removeEmpty[u] ||
                                    (s.getPosition(n) | G) == G)) {
                                    l = b.clone();
                                    l.setStartBefore(s)
                                }
                                u = s.type;
                                if (u == CKEDITOR.NODE_TEXT || o || u == CKEDITOR.NODE_ELEMENT && !s.getChildCount()) {
                                    for (var u = s, aa;
                                        (i = !u.getNext(B)) && (aa = u.getParent(), k[aa.getName()]) && (aa.getPosition(t) | D) == D && (!f.childRule || f.childRule(aa));) u = aa;
                                    l.setEndAfter(u)
                                }
                            } else i = true;
                            else i = true;
                        s = s.getNextSourceNode(w || o)
                    } if (i && l && !l.collapsed) {
                        for (var i = p(this, c), o = i.hasAttributes(), w = l.getCommonAncestor(), u = {}, r = {}, v = {}, z = {}, U, $, ca; i && w;) {
                            if (w.getName() == d) {
                                for (U in f.attributes)
                                    if (!z[U] &&
                                        (ca = w.getAttribute($))) i.getAttribute(U) == ca ? r[U] = 1 : z[U] = 1;
                                for ($ in f.styles)
                                    if (!v[$] && (ca = w.getStyle($))) i.getStyle($) == ca ? u[$] = 1 : v[$] = 1
                            }
                            w = w.getParent()
                        }
                        for (U in r) i.removeAttribute(U);
                        for ($ in u) i.removeStyle($);
                        o && !i.hasAttributes() && (i = null);
                        if (i) {
                            l.extractContents().appendTo(i);
                            l.insertNode(i);
                            q.call(this, i);
                            i.mergeSiblings();
                            CKEDITOR.env.ie || i.$.normalize()
                        } else {
                            i = new CKEDITOR.dom.element("span");
                            l.extractContents().appendTo(i);
                            l.insertNode(i);
                            q.call(this, i);
                            i.remove(true)
                        }
                        l = null
                    }
                }
                b.moveToBookmark(m);
                b.shrink(CKEDITOR.SHRINK_TEXT);
                b.shrink(CKEDITOR.NODE_ELEMENT, true)
            }
        }

        function b(a) {
            function b() {
                for (var a = new CKEDITOR.dom.elementPath(d.getParent()), c = new CKEDITOR.dom.elementPath(j.getParent()), f = null, g = null, e = 0; e < a.elements.length; e++) {
                    var h = a.elements[e];
                    if (h == a.block || h == a.blockLimit) break;
                    k.checkElementRemovable(h, true) && (f = h)
                }
                for (e = 0; e < c.elements.length; e++) {
                    h = c.elements[e];
                    if (h == c.block || h == c.blockLimit) break;
                    k.checkElementRemovable(h, true) && (g = h)
                }
                g && j.breakParent(g);
                f && d.breakParent(f)
            }
            a.enlarge(CKEDITOR.ENLARGE_INLINE,
                1);
            var c = a.createBookmark(),
                d = c.startNode;
            if (a.collapsed) {
                for (var f = new CKEDITOR.dom.elementPath(d.getParent(), a.root), g, e = 0, h; e < f.elements.length && (h = f.elements[e]); e++) {
                    if (h == f.block || h == f.blockLimit) break;
                    if (this.checkElementRemovable(h)) {
                        var i;
                        if (a.collapsed && (a.checkBoundaryOfElement(h, CKEDITOR.END) || (i = a.checkBoundaryOfElement(h, CKEDITOR.START)))) {
                            g = h;
                            g.match = i ? "start" : "end"
                        } else {
                            h.mergeSiblings();
                            h.is(this.element) ? o.call(this, h) : m(h, u(this)[h.getName()])
                        }
                    }
                }
                if (g) {
                    h = d;
                    for (e = 0;; e++) {
                        i = f.elements[e];
                        if (i.equals(g)) break;
                        else if (i.match) continue;
                        else i = i.clone();
                        i.append(h);
                        h = i
                    }
                    h[g.match == "start" ? "insertBefore" : "insertAfter"](g)
                }
            } else {
                var j = c.endNode,
                    k = this;
                b();
                for (f = d; !f.equals(j);) {
                    g = f.getNextSourceNode();
                    if (f.type == CKEDITOR.NODE_ELEMENT && this.checkElementRemovable(f)) {
                        f.getName() == this.element ? o.call(this, f) : m(f, u(this)[f.getName()]);
                        if (g.type == CKEDITOR.NODE_ELEMENT && g.contains(d)) {
                            b();
                            g = d.getNext()
                        }
                    }
                    f = g
                }
            }
            a.moveToBookmark(c);
            a.shrink(CKEDITOR.NODE_ELEMENT, true)
        }

        function g(a) {
            var b = [];
            a.forEach(function(a) {
                if (a.getAttribute("contenteditable") ==
                    "true") {
                    b.push(a);
                    return false
                }
            }, CKEDITOR.NODE_ELEMENT, true);
            return b
        }

        function c(a) {
            var b = a.getEnclosedNode() || a.getCommonAncestor(false, true);
            (a = (new CKEDITOR.dom.elementPath(b, a.root)).contains(this.element, 1)) && !a.isReadOnly() && t(a, this)
        }

        function d(a) {
            var b = a.getCommonAncestor(true, true);
            if (a = (new CKEDITOR.dom.elementPath(b, a.root)).contains(this.element, 1)) {
                var b = this._.definition,
                    c = b.attributes;
                if (c)
                    for (var d in c) a.removeAttribute(d, c[d]);
                if (b.styles)
                    for (var f in b.styles) b.styles.hasOwnProperty(f) &&
                        a.removeStyle(f)
            }
        }

        function j(a) {
            var b = a.createBookmark(true),
                c = a.createIterator();
            c.enforceRealBlocks = true;
            if (this._.enterMode) c.enlargeBr = this._.enterMode != CKEDITOR.ENTER_BR;
            for (var d, f = a.document, g; d = c.getNextParagraph();)
                if (!d.isReadOnly() && (c.activeFilter ? c.activeFilter.check(this) : 1)) {
                    g = p(this, f, d);
                    h(d, g)
                }
            a.moveToBookmark(b)
        }

        function f(a) {
            var b = a.createBookmark(1),
                c = a.createIterator();
            c.enforceRealBlocks = true;
            c.enlargeBr = this._.enterMode != CKEDITOR.ENTER_BR;
            for (var d, f; d = c.getNextParagraph();)
                if (this.checkElementRemovable(d))
                    if (d.is("pre")) {
                        (f =
                            this._.enterMode == CKEDITOR.ENTER_BR ? null : a.document.createElement(this._.enterMode == CKEDITOR.ENTER_P ? "p" : "div")) && d.copyAttributes(f);
                        h(d, f)
                    } else o.call(this, d);
            a.moveToBookmark(b)
        }

        function h(a, b) {
            var c = !b;
            if (c) {
                b = a.getDocument().createElement("div");
                a.copyAttributes(b)
            }
            var d = b && b.is("pre"),
                f = a.is("pre"),
                g = !d && f;
            if (d && !f) {
                f = b;
                (g = a.getBogus()) && g.remove();
                g = a.getHtml();
                g = k(g, /(?:^[ \t\n\r]+)|(?:[ \t\n\r]+$)/g, "");
                g = g.replace(/[ \t\r\n]*(<br[^>]*>)[ \t\r\n]*/gi, "$1");
                g = g.replace(/([ \t\n\r]+|&nbsp;)/g,
                    " ");
                g = g.replace(/<br\b[^>]*>/gi, "\n");
                if (CKEDITOR.env.ie) {
                    var e = a.getDocument().createElement("div");
                    e.append(f);
                    f.$.outerHTML = "<pre>" + g + "</pre>";
                    f.copyAttributes(e.getFirst());
                    f = e.getFirst().remove()
                } else f.setHtml(g);
                b = f
            } else g ? b = n(c ? [a.getHtml()] : i(a), b) : a.moveChildren(b);
            b.replace(a);
            if (d) {
                var c = b,
                    h;
                if ((h = c.getPrevious(A)) && h.type == CKEDITOR.NODE_ELEMENT && h.is("pre")) {
                    d = k(h.getHtml(), /\n$/, "") + "\n\n" + k(c.getHtml(), /^\n/, "");
                    CKEDITOR.env.ie ? c.$.outerHTML = "<pre>" + d + "</pre>" : c.setHtml(d);
                    h.remove()
                }
            } else c &&
                l(b)
        }

        function i(a) {
            var b = [];
            k(a.getOuterHtml(), /(\S\s*)\n(?:\s|(<span[^>]+data-cke-bookmark.*?\/span>))*\n(?!$)/gi, function(a, b, c) {
                return b + "</pre>" + c + "<pre>"
            }).replace(/<pre\b.*?>([\s\S]*?)<\/pre>/gi, function(a, c) {
                b.push(c)
            });
            return b
        }

        function k(a, b, c) {
            var d = "",
                f = "",
                a = a.replace(/(^<span[^>]+data-cke-bookmark.*?\/span>)|(<span[^>]+data-cke-bookmark.*?\/span>$)/gi, function(a, b, c) {
                    b && (d = b);
                    c && (f = c);
                    return ""
                });
            return d + a.replace(b, c) + f
        }

        function n(a, b) {
            var c;
            a.length > 1 && (c = new CKEDITOR.dom.documentFragment(b.getDocument()));
            for (var d = 0; d < a.length; d++) {
                var f = a[d],
                    f = f.replace(/(\r\n|\r)/g, "\n"),
                    f = k(f, /^[ \t]*\n/, ""),
                    f = k(f, /\n$/, ""),
                    f = k(f, /^[ \t]+|[ \t]+$/g, function(a, b) {
                        return a.length == 1 ? "&nbsp;" : b ? " " + CKEDITOR.tools.repeat("&nbsp;", a.length - 1) : CKEDITOR.tools.repeat("&nbsp;", a.length - 1) + " "
                    }),
                    f = f.replace(/\n/g, "<br>"),
                    f = f.replace(/[ \t]{2,}/g, function(a) {
                        return CKEDITOR.tools.repeat("&nbsp;", a.length - 1) + " "
                    });
                if (c) {
                    var g = b.clone();
                    g.setHtml(f);
                    c.append(g)
                } else b.setHtml(f)
            }
            return c || b
        }

        function o(a, b) {
            var c = this._.definition,
                d = c.attributes,
                c = c.styles,
                f = u(this)[a.getName()],
                g = CKEDITOR.tools.isEmpty(d) && CKEDITOR.tools.isEmpty(c),
                e;
            for (e in d)
                if (!((e == "class" || this._.definition.fullMatch) && a.getAttribute(e) != w(e, d[e])) && !(b && e.slice(0, 5) == "data-")) {
                    g = a.hasAttribute(e);
                    a.removeAttribute(e)
                }
            for (var h in c)
                if (!(this._.definition.fullMatch && a.getStyle(h) != w(h, c[h], true))) {
                    g = g || !! a.getStyle(h);
                    a.removeStyle(h)
                }
            m(a, f, v[a.getName()]);
            g && (this._.definition.alwaysRemoveElement ? l(a, 1) : !CKEDITOR.dtd.$block[a.getName()] || this._.enterMode ==
                CKEDITOR.ENTER_BR && !a.hasAttributes() ? l(a) : a.renameNode(this._.enterMode == CKEDITOR.ENTER_P ? "p" : "div"))
        }

        function q(a) {
            for (var b = u(this), c = a.getElementsByTag(this.element), d, f = c.count(); --f >= 0;) {
                d = c.getItem(f);
                d.isReadOnly() || o.call(this, d, true)
            }
            for (var g in b)
                if (g != this.element) {
                    c = a.getElementsByTag(g);
                    for (f = c.count() - 1; f >= 0; f--) {
                        d = c.getItem(f);
                        d.isReadOnly() || m(d, b[g])
                    }
                }
        }

        function m(a, b, c) {
            if (b = b && b.attributes)
                for (var d = 0; d < b.length; d++) {
                    var f = b[d][0],
                        g;
                    if (g = a.getAttribute(f)) {
                        var e = b[d][1];
                        (e === null ||
                            e.test && e.test(g) || typeof e == "string" && g == e) && a.removeAttribute(f)
                    }
                }
            c || l(a)
        }

        function l(a, b) {
            if (!a.hasAttributes() || b)
                if (CKEDITOR.dtd.$block[a.getName()]) {
                    var c = a.getPrevious(A),
                        d = a.getNext(A);
                    c && (c.type == CKEDITOR.NODE_TEXT || !c.isBlockBoundary({
                        br: 1
                    })) && a.append("br", 1);
                    d && (d.type == CKEDITOR.NODE_TEXT || !d.isBlockBoundary({
                        br: 1
                    })) && a.append("br");
                    a.remove(true)
                } else {
                    c = a.getFirst();
                    d = a.getLast();
                    a.remove(true);
                    if (c) {
                        c.type == CKEDITOR.NODE_ELEMENT && c.mergeSiblings();
                        d && (!c.equals(d) && d.type == CKEDITOR.NODE_ELEMENT) &&
                            d.mergeSiblings()
                    }
                }
        }

        function p(a, b, c) {
            var d;
            d = a.element;
            d == "*" && (d = "span");
            d = new CKEDITOR.dom.element(d, b);
            c && c.copyAttributes(d);
            d = t(d, a);
            b.getCustomData("doc_processing_style") && d.hasAttribute("id") ? d.removeAttribute("id") : b.setCustomData("doc_processing_style", 1);
            return d
        }

        function t(a, b) {
            var c = b._.definition,
                d = c.attributes,
                c = CKEDITOR.style.getStyleText(c);
            if (d)
                for (var f in d) a.setAttribute(f, d[f]);
            c && a.setAttribute("style", c);
            return a
        }

        function s(a, b) {
            for (var c in a) a[c] = a[c].replace(z, function(a,
                c) {
                return b[c]
            })
        }

        function u(a) {
            if (a._.overrides) return a._.overrides;
            var b = a._.overrides = {}, c = a._.definition.overrides;
            if (c) {
                CKEDITOR.tools.isArray(c) || (c = [c]);
                for (var d = 0; d < c.length; d++) {
                    var f = c[d],
                        g, e;
                    if (typeof f == "string") g = f.toLowerCase();
                    else {
                        g = f.element ? f.element.toLowerCase() : a.element;
                        e = f.attributes
                    }
                    f = b[g] || (b[g] = {});
                    if (e) {
                        var f = f.attributes = f.attributes || [],
                            h;
                        for (h in e) f.push([h.toLowerCase(), e[h]])
                    }
                }
            }
            return b
        }

        function w(a, b, c) {
            var d = new CKEDITOR.dom.element("span");
            d[c ? "setStyle" : "setAttribute"](a,
                b);
            return d[c ? "getStyle" : "getAttribute"](a)
        }

        function x(a, b, c) {
            for (var d = a.document, f = a.getRanges(), b = b ? this.removeFromRange : this.applyToRange, g, e = f.createIterator(); g = e.getNextRange();) b.call(this, g, c);
            a.selectRanges(f);
            d.removeCustomData("doc_processing_style")
        }
        var v = {
            address: 1,
            div: 1,
            h1: 1,
            h2: 1,
            h3: 1,
            h4: 1,
            h5: 1,
            h6: 1,
            p: 1,
            pre: 1,
            section: 1,
            header: 1,
            footer: 1,
            nav: 1,
            article: 1,
            aside: 1,
            figure: 1,
            dialog: 1,
            hgroup: 1,
            time: 1,
            meter: 1,
            menu: 1,
            command: 1,
            keygen: 1,
            output: 1,
            progress: 1,
            details: 1,
            datagrid: 1,
            datalist: 1
        }, r = {
                a: 1,
                blockquote: 1,
                embed: 1,
                hr: 1,
                img: 1,
                li: 1,
                object: 1,
                ol: 1,
                table: 1,
                td: 1,
                tr: 1,
                th: 1,
                ul: 1,
                dl: 1,
                dt: 1,
                dd: 1,
                form: 1,
                audio: 1,
                video: 1
            }, y = /\s*(?:;\s*|$)/,
            z = /#\((.+?)\)/g,
            B = CKEDITOR.dom.walker.bookmark(0, 1),
            A = CKEDITOR.dom.walker.whitespaces(1);
        CKEDITOR.style = function(a, b) {
            if (typeof a.type == "string") return new CKEDITOR.style.customHandlers[a.type](a);
            var c = a.attributes;
            if (c && c.style) {
                a.styles = CKEDITOR.tools.extend({}, a.styles, CKEDITOR.tools.parseCssText(c.style));
                delete c.style
            }
            if (b) {
                a = CKEDITOR.tools.clone(a);
                s(a.attributes,
                    b);
                s(a.styles, b)
            }
            c = this.element = a.element ? typeof a.element == "string" ? a.element.toLowerCase() : a.element : "*";
            this.type = a.type || (v[c] ? CKEDITOR.STYLE_BLOCK : r[c] ? CKEDITOR.STYLE_OBJECT : CKEDITOR.STYLE_INLINE);
            if (typeof this.element == "object") this.type = CKEDITOR.STYLE_OBJECT;
            this._ = {
                definition: a
            }
        };
        CKEDITOR.style.prototype = {
            apply: function(a) {
                if (a instanceof CKEDITOR.dom.document) return x.call(this, a.getSelection());
                if (this.checkApplicable(a.elementPath(), a)) {
                    var b = this._.enterMode;
                    if (!b) this._.enterMode = a.activeEnterMode;
                    x.call(this, a.getSelection(), 0, a);
                    this._.enterMode = b
                }
            },
            remove: function(a) {
                if (a instanceof CKEDITOR.dom.document) return x.call(this, a.getSelection(), 1);
                if (this.checkApplicable(a.elementPath(), a)) {
                    var b = this._.enterMode;
                    if (!b) this._.enterMode = a.activeEnterMode;
                    x.call(this, a.getSelection(), 1, a);
                    this._.enterMode = b
                }
            },
            applyToRange: function(a) {
                this.applyToRange = this.type == CKEDITOR.STYLE_INLINE ? e : this.type == CKEDITOR.STYLE_BLOCK ? j : this.type == CKEDITOR.STYLE_OBJECT ? c : null;
                return this.applyToRange(a)
            },
            removeFromRange: function(a) {
                this.removeFromRange =
                    this.type == CKEDITOR.STYLE_INLINE ? b : this.type == CKEDITOR.STYLE_BLOCK ? f : this.type == CKEDITOR.STYLE_OBJECT ? d : null;
                return this.removeFromRange(a)
            },
            applyToObject: function(a) {
                t(a, this)
            },
            checkActive: function(a, b) {
                switch (this.type) {
                    case CKEDITOR.STYLE_BLOCK:
                        return this.checkElementRemovable(a.block || a.blockLimit, true, b);
                    case CKEDITOR.STYLE_OBJECT:
                    case CKEDITOR.STYLE_INLINE:
                        for (var c = a.elements, d = 0, f; d < c.length; d++) {
                            f = c[d];
                            if (!(this.type == CKEDITOR.STYLE_INLINE && (f == a.block || f == a.blockLimit))) {
                                if (this.type ==
                                    CKEDITOR.STYLE_OBJECT) {
                                    var g = f.getName();
                                    if (!(typeof this.element == "string" ? g == this.element : g in this.element)) continue
                                }
                                if (this.checkElementRemovable(f, true, b)) return true
                            }
                        }
                }
                return false
            },
            checkApplicable: function(a, b, c) {
                b && b instanceof CKEDITOR.filter && (c = b);
                if (c && !c.check(this)) return false;
                switch (this.type) {
                    case CKEDITOR.STYLE_OBJECT:
                        return !!a.contains(this.element);
                    case CKEDITOR.STYLE_BLOCK:
                        return !!a.blockLimit.getDtd()[this.element]
                }
                return true
            },
            checkElementMatch: function(a, b) {
                var c = this._.definition;
                if (!a || !c.ignoreReadonly && a.isReadOnly()) return false;
                var d = a.getName();
                if (typeof this.element == "string" ? d == this.element : d in this.element) {
                    if (!b && !a.hasAttributes()) return true;
                    if (d = c._AC) c = d;
                    else {
                        var d = {}, f = 0,
                            g = c.attributes;
                        if (g)
                            for (var e in g) {
                                f++;
                                d[e] = g[e]
                            }
                        if (e = CKEDITOR.style.getStyleText(c)) {
                            d.style || f++;
                            d.style = e
                        }
                        d._length = f;
                        c = c._AC = d
                    } if (c._length) {
                        for (var h in c)
                            if (h != "_length") {
                                f = a.getAttribute(h) || "";
                                if (h == "style") a: {
                                    d = c[h];
                                    typeof d == "string" && (d = CKEDITOR.tools.parseCssText(d));
                                    typeof f ==
                                        "string" && (f = CKEDITOR.tools.parseCssText(f, true));
                                    e = void 0;
                                    for (e in d)
                                        if (!(e in f && (f[e] == d[e] || d[e] == "inherit" || f[e] == "inherit"))) {
                                            d = false;
                                            break a
                                        }
                                    d = true
                                } else d = c[h] == f;
                                if (d) {
                                    if (!b) return true
                                } else if (b) return false
                            }
                        if (b) return true
                    } else return true
                }
                return false
            },
            checkElementRemovable: function(a, b, c) {
                if (this.checkElementMatch(a, b, c)) return true;
                if (b = u(this)[a.getName()]) {
                    var d;
                    if (!(b = b.attributes)) return true;
                    for (c = 0; c < b.length; c++) {
                        d = b[c][0];
                        if (d = a.getAttribute(d)) {
                            var f = b[c][1];
                            if (f === null) return true;
                            if (typeof f == "string") {
                                if (d == f) return true
                            } else if (f.test(d)) return true
                        }
                    }
                }
                return false
            },
            buildPreview: function(a) {
                var b = this._.definition,
                    c = [],
                    d = b.element;
                d == "bdo" && (d = "span");
                var c = ["<", d],
                    f = b.attributes;
                if (f)
                    for (var g in f) c.push(" ", g, '="', f[g], '"');
                (f = CKEDITOR.style.getStyleText(b)) && c.push(' style="', f, '"');
                c.push(">", a || b.name, "</", d, ">");
                return c.join("")
            },
            getDefinition: function() {
                return this._.definition
            }
        };
        CKEDITOR.style.getStyleText = function(a) {
            var b = a._ST;
            if (b) return b;
            var b = a.styles,
                c =
                    a.attributes && a.attributes.style || "",
                d = "";
            c.length && (c = c.replace(y, ";"));
            for (var f in b) {
                var g = b[f],
                    e = (f + ":" + g).replace(y, ";");
                g == "inherit" ? d = d + e : c = c + e
            }
            c.length && (c = CKEDITOR.tools.normalizeCssText(c, true));
            return a._ST = c + d
        };
        CKEDITOR.style.customHandlers = {};
        CKEDITOR.style.addCustomHandler = function(a) {
            var b = function(a) {
                this._ = {
                    definition: a
                };
                this.setup && this.setup(a)
            };
            b.prototype = CKEDITOR.tools.extend(CKEDITOR.tools.prototypedCopy(CKEDITOR.style.prototype), {
                assignedTo: CKEDITOR.STYLE_OBJECT
            }, a, true);
            return this.customHandlers[a.type] = b
        };
        var G = CKEDITOR.POSITION_PRECEDING | CKEDITOR.POSITION_IDENTICAL | CKEDITOR.POSITION_IS_CONTAINED,
            D = CKEDITOR.POSITION_FOLLOWING | CKEDITOR.POSITION_IDENTICAL | CKEDITOR.POSITION_IS_CONTAINED
    }(), CKEDITOR.styleCommand = function(a, e) {
        this.requiredContent = this.allowedContent = this.style = a;
        CKEDITOR.tools.extend(this, e, true)
    }, CKEDITOR.styleCommand.prototype.exec = function(a) {
        a.focus();
        this.state == CKEDITOR.TRISTATE_OFF ? a.applyStyle(this.style) : this.state == CKEDITOR.TRISTATE_ON &&
            a.removeStyle(this.style)
    }, CKEDITOR.stylesSet = new CKEDITOR.resourceManager("", "stylesSet"), CKEDITOR.addStylesSet = CKEDITOR.tools.bind(CKEDITOR.stylesSet.add, CKEDITOR.stylesSet), CKEDITOR.loadStylesSet = function(a, e, b) {
        CKEDITOR.stylesSet.addExternal(a, e, "");
        CKEDITOR.stylesSet.load(a, b)
    }, CKEDITOR.tools.extend(CKEDITOR.editor.prototype, {
        attachStyleStateChange: function(a, e) {
            var b = this._.styleStateChangeCallbacks;
            if (!b) {
                b = this._.styleStateChangeCallbacks = [];
                this.on("selectionChange", function(a) {
                    for (var c =
                        0; c < b.length; c++) {
                        var d = b[c],
                            e = d.style.checkActive(a.data.path, this) ? CKEDITOR.TRISTATE_ON : CKEDITOR.TRISTATE_OFF;
                        d.fn.call(this, e)
                    }
                })
            }
            b.push({
                style: a,
                fn: e
            })
        },
        applyStyle: function(a) {
            a.apply(this)
        },
        removeStyle: function(a) {
            a.remove(this)
        },
        getStylesSet: function(a) {
            if (this._.stylesDefinitions) a(this._.stylesDefinitions);
            else {
                var e = this,
                    b = e.config.stylesCombo_stylesSet || e.config.stylesSet;
                if (b === false) a(null);
                else if (b instanceof Array) {
                    e._.stylesDefinitions = b;
                    a(b)
                } else {
                    b || (b = "default");
                    var b = b.split(":"),
                        g = b[0];
                    CKEDITOR.stylesSet.addExternal(g, b[1] ? b.slice(1).join(":") : CKEDITOR.getUrl("styles.js"), "");
                    CKEDITOR.stylesSet.load(g, function(b) {
                        e._.stylesDefinitions = b[g];
                        a(e._.stylesDefinitions)
                    })
                }
            }
        }
    }), CKEDITOR.dom.comment = function(a, e) {
        typeof a == "string" && (a = (e ? e.$ : document).createComment(a));
        CKEDITOR.dom.domObject.call(this, a)
    }, CKEDITOR.dom.comment.prototype = new CKEDITOR.dom.node, CKEDITOR.tools.extend(CKEDITOR.dom.comment.prototype, {
        type: CKEDITOR.NODE_COMMENT,
        getOuterHtml: function() {
            return "<\!--" + this.$.nodeValue +
                "--\>"
        }
    }), "use strict",
    function() {
        var a = {}, e = {}, b;
        for (b in CKEDITOR.dtd.$blockLimit) b in CKEDITOR.dtd.$list || (a[b] = 1);
        for (b in CKEDITOR.dtd.$block) b in CKEDITOR.dtd.$blockLimit || b in CKEDITOR.dtd.$empty || (e[b] = 1);
        CKEDITOR.dom.elementPath = function(b, c) {
            var d = null,
                j = null,
                f = [],
                h = b,
                i, c = c || b.getDocument().getBody();
            do
                if (h.type == CKEDITOR.NODE_ELEMENT) {
                    f.push(h);
                    if (!this.lastElement) {
                        this.lastElement = h;
                        if (h.is(CKEDITOR.dtd.$object) || h.getAttribute("contenteditable") == "false") continue
                    }
                    if (h.equals(c)) break;
                    if (!j) {
                        i = h.getName();
                        h.getAttribute("contenteditable") == "true" ? j = h : !d && e[i] && (d = h);
                        if (a[i]) {
                            var k;
                            if (k = !d) {
                                if (i = i == "div") {
                                    a: {
                                        i = h.getChildren();
                                        k = 0;
                                        for (var n = i.count(); k < n; k++) {
                                            var o = i.getItem(k);
                                            if (o.type == CKEDITOR.NODE_ELEMENT && CKEDITOR.dtd.$block[o.getName()]) {
                                                i = true;
                                                break a
                                            }
                                        }
                                        i = false
                                    }
                                    i = !i
                                }
                                k = i
                            }
                            k ? d = h : j = h
                        }
                    }
                } while (h = h.getParent());
            j || (j = c);
            this.block = d;
            this.blockLimit = j;
            this.root = c;
            this.elements = f
        }
    }(), CKEDITOR.dom.elementPath.prototype = {
        compare: function(a) {
            var e = this.elements,
                a = a && a.elements;
            if (!a ||
                e.length != a.length) return false;
            for (var b = 0; b < e.length; b++)
                if (!e[b].equals(a[b])) return false;
            return true
        },
        contains: function(a, e, b) {
            var g;
            typeof a == "string" && (g = function(b) {
                return b.getName() == a
            });
            a instanceof CKEDITOR.dom.element ? g = function(b) {
                return b.equals(a)
            } : CKEDITOR.tools.isArray(a) ? g = function(b) {
                return CKEDITOR.tools.indexOf(a, b.getName()) > -1
            } : typeof a == "function" ? g = a : typeof a == "object" && (g = function(b) {
                return b.getName() in a
            });
            var c = this.elements,
                d = c.length;
            e && d--;
            if (b) {
                c = Array.prototype.slice.call(c,
                    0);
                c.reverse()
            }
            for (e = 0; e < d; e++)
                if (g(c[e])) return c[e];
            return null
        },
        isContextFor: function(a) {
            var e;
            if (a in CKEDITOR.dtd.$block) {
                e = this.contains(CKEDITOR.dtd.$intermediate) || this.root.equals(this.block) && this.block || this.blockLimit;
                return !!e.getDtd()[a]
            }
            return true
        },
        direction: function() {
            return (this.block || this.blockLimit || this.root).getDirection(1)
        }
    }, CKEDITOR.dom.text = function(a, e) {
        typeof a == "string" && (a = (e ? e.$ : document).createTextNode(a));
        this.$ = a
    }, CKEDITOR.dom.text.prototype = new CKEDITOR.dom.node,
    CKEDITOR.tools.extend(CKEDITOR.dom.text.prototype, {
        type: CKEDITOR.NODE_TEXT,
        getLength: function() {
            return this.$.nodeValue.length
        },
        getText: function() {
            return this.$.nodeValue
        },
        setText: function(a) {
            this.$.nodeValue = a
        },
        split: function(a) {
            var e = this.$.parentNode,
                b = e.childNodes.length,
                g = this.getLength(),
                c = this.getDocument(),
                d = new CKEDITOR.dom.text(this.$.splitText(a), c);
            if (e.childNodes.length == b)
                if (a >= g) {
                    d = c.createText("");
                    d.insertAfter(this)
                } else {
                    a = c.createText("");
                    a.insertAfter(d);
                    a.remove()
                }
            return d
        },
        substring: function(a,
            e) {
            return typeof e != "number" ? this.$.nodeValue.substr(a) : this.$.nodeValue.substring(a, e)
        }
    }),
    function() {
        function a(a, g, c) {
            var d = a.serializable,
                e = g[c ? "endContainer" : "startContainer"],
                f = c ? "endOffset" : "startOffset",
                h = d ? g.document.getById(a.startNode) : a.startNode,
                a = d ? g.document.getById(a.endNode) : a.endNode;
            if (e.equals(h.getPrevious())) {
                g.startOffset = g.startOffset - e.getLength() - a.getPrevious().getLength();
                e = a.getNext()
            } else if (e.equals(a.getPrevious())) {
                g.startOffset = g.startOffset - e.getLength();
                e = a.getNext()
            }
            e.equals(h.getParent()) &&
                g[f]++;
            e.equals(a.getParent()) && g[f]++;
            g[c ? "endContainer" : "startContainer"] = e;
            return g
        }
        CKEDITOR.dom.rangeList = function(a) {
            if (a instanceof CKEDITOR.dom.rangeList) return a;
            a ? a instanceof CKEDITOR.dom.range && (a = [a]) : a = [];
            return CKEDITOR.tools.extend(a, e)
        };
        var e = {
            createIterator: function() {
                var a = this,
                    g = CKEDITOR.dom.walker.bookmark(),
                    c = [],
                    d;
                return {
                    getNextRange: function(e) {
                        d = d === void 0 ? 0 : d + 1;
                        var f = a[d];
                        if (f && a.length > 1) {
                            if (!d)
                                for (var h = a.length - 1; h >= 0; h--) c.unshift(a[h].createBookmark(true));
                            if (e)
                                for (var i =
                                    0; a[d + i + 1];) {
                                    for (var k = f.document, e = 0, h = k.getById(c[i].endNode), k = k.getById(c[i + 1].startNode);;) {
                                        h = h.getNextSourceNode(false);
                                        if (k.equals(h)) e = 1;
                                        else if (g(h) || h.type == CKEDITOR.NODE_ELEMENT && h.isBlockBoundary()) continue;
                                        break
                                    }
                                    if (!e) break;
                                    i++
                                }
                            for (f.moveToBookmark(c.shift()); i--;) {
                                h = a[++d];
                                h.moveToBookmark(c.shift());
                                f.setEnd(h.endContainer, h.endOffset)
                            }
                        }
                        return f
                    }
                }
            },
            createBookmarks: function(b) {
                for (var g = [], c, d = 0; d < this.length; d++) {
                    g.push(c = this[d].createBookmark(b, true));
                    for (var e = d + 1; e < this.length; e++) {
                        this[e] =
                            a(c, this[e]);
                        this[e] = a(c, this[e], true)
                    }
                }
                return g
            },
            createBookmarks2: function(a) {
                for (var g = [], c = 0; c < this.length; c++) g.push(this[c].createBookmark2(a));
                return g
            },
            moveToBookmarks: function(a) {
                for (var g = 0; g < this.length; g++) this[g].moveToBookmark(a[g])
            }
        }
    }(),
    function() {
        function a() {
            return CKEDITOR.getUrl(CKEDITOR.skinName.split(",")[1] || "skins/" + CKEDITOR.skinName.split(",")[0] + "/")
        }

        function e(b) {
            var c = CKEDITOR.skin["ua_" + b],
                d = CKEDITOR.env;
            if (c)
                for (var c = c.split(",").sort(function(a, b) {
                        return a > b ? -1 : 1
                    }), f =
                        0, g; f < c.length; f++) {
                    g = c[f];
                    if (d.ie && (g.replace(/^ie/, "") == d.version || d.quirks && g == "iequirks")) g = "ie";
                    if (d[g]) {
                        b = b + ("_" + c[f]);
                        break
                    }
                }
            return CKEDITOR.getUrl(a() + b + ".css")
        }

        function b(a, b) {
            if (!d[a]) {
                CKEDITOR.document.appendStyleSheet(e(a));
                d[a] = 1
            }
            b && b()
        }

        function g(a) {
            var b = a.getById(j);
            if (!b) {
                b = a.getHead().append("style");
                b.setAttribute("id", j);
                b.setAttribute("type", "text/css")
            }
            return b
        }

        function c(a, b, c) {
            var d, f, g;
            if (CKEDITOR.env.webkit) {
                b = b.split("}").slice(0, -1);
                for (f = 0; f < b.length; f++) b[f] = b[f].split("{")
            }
            for (var e =
                0; e < a.length; e++)
                if (CKEDITOR.env.webkit)
                    for (f = 0; f < b.length; f++) {
                        g = b[f][1];
                        for (d = 0; d < c.length; d++) g = g.replace(c[d][0], c[d][1]);
                        a[e].$.sheet.addRule(b[f][0], g)
                    } else {
                        g = b;
                        for (d = 0; d < c.length; d++) g = g.replace(c[d][0], c[d][1]);
                        CKEDITOR.env.ie && CKEDITOR.env.version < 11 ? a[e].$.styleSheet.cssText = a[e].$.styleSheet.cssText + g : a[e].$.innerHTML = a[e].$.innerHTML + g
                    }
        }
        var d = {};
        CKEDITOR.skin = {
            path: a,
            loadPart: function(c, d) {
                CKEDITOR.skin.name != CKEDITOR.skinName.split(",")[0] ? CKEDITOR.scriptLoader.load(CKEDITOR.getUrl(a() +
                    "skin.js"), function() {
                    b(c, d)
                }) : b(c, d)
            },
            getPath: function(a) {
                return CKEDITOR.getUrl(e(a))
            },
            icons: {},
            addIcon: function(a, b, c, d) {
                a = a.toLowerCase();
                this.icons[a] || (this.icons[a] = {
                    path: b,
                    offset: c || 0,
                    bgsize: d || "16px"
                })
            },
            getIconStyle: function(a, b, c, d, f) {
                var g;
                if (a) {
                    a = a.toLowerCase();
                    b && (g = this.icons[a + "-rtl"]);
                    g || (g = this.icons[a])
                }
                a = c || g && g.path || "";
                d = d || g && g.offset;
                f = f || g && g.bgsize || "16px";
                return a && "background-image:url(" + CKEDITOR.getUrl(a) + ");background-position:0 " + d + "px;background-size:" + f + ";"
            }
        };
        CKEDITOR.tools.extend(CKEDITOR.editor.prototype, {
            getUiColor: function() {
                return this.uiColor
            },
            setUiColor: function(a) {
                var b = g(CKEDITOR.document);
                return (this.setUiColor = function(a) {
                    this.uiColor = a;
                    var d = CKEDITOR.skin.chameleon,
                        g = "",
                        e = "";
                    if (typeof d == "function") {
                        g = d(this, "editor");
                        e = d(this, "panel")
                    }
                    a = [
                        [h, a]
                    ];
                    c([b], g, a);
                    c(f, e, a)
                }).call(this, a)
            }
        });
        var j = "cke_ui_color",
            f = [],
            h = /\$color/g;
        CKEDITOR.on("instanceLoaded", function(a) {
            if (!CKEDITOR.env.ie || !CKEDITOR.env.quirks) {
                var b = a.editor,
                    a = function(a) {
                        a = (a.data[0] || a.data).element.getElementsByTag("iframe").getItem(0).getFrameDocument();
                        if (!a.getById("cke_ui_color")) {
                            a = g(a);
                            f.push(a);
                            var d = b.getUiColor();
                            d && c([a], CKEDITOR.skin.chameleon(b, "panel"), [
                                [h, d]
                            ])
                        }
                    };
                b.on("panelShow", a);
                b.on("menuShow", a);
                b.config.uiColor && b.setUiColor(b.config.uiColor)
            }
        })
    }(),
    function() {
        if (CKEDITOR.env.webkit) CKEDITOR.env.hc = false;
        else {
            var a = CKEDITOR.dom.element.createFromHtml('<div style="width:0;height:0;position:absolute;left:-10000px;border:1px solid;border-color:red blue"></div>', CKEDITOR.document);
            a.appendTo(CKEDITOR.document.getHead());
            try {
                var e = a.getComputedStyle("border-top-color"),
                    b = a.getComputedStyle("border-right-color");
                CKEDITOR.env.hc = !! (e && e == b)
            } catch (g) {
                CKEDITOR.env.hc = false
            }
            a.remove()
        } if (CKEDITOR.env.hc) CKEDITOR.env.cssClass = CKEDITOR.env.cssClass + " cke_hc";
        CKEDITOR.document.appendStyleText(".cke{visibility:hidden;}");
        CKEDITOR.status = "loaded";
        CKEDITOR.fireOnce("loaded");
        if (a = CKEDITOR._.pending) {
            delete CKEDITOR._.pending;
            for (e = 0; e < a.length; e++) {
                CKEDITOR.editor.prototype.constructor.apply(a[e][0], a[e][1]);
                CKEDITOR.add(a[e][0])
            }
        }
    }(), CKEDITOR.skin.name = "moono", CKEDITOR.skin.ua_editor =
        "ie,iequirks,ie7,ie8,gecko", CKEDITOR.skin.ua_dialog = "ie,iequirks,ie7,ie8", CKEDITOR.skin.chameleon = function() {
            var a = function() {
                return function(a, b) {
                    for (var d = a.match(/[^#]./g), e = 0; e < 3; e++) {
                        var f = d,
                            h = e,
                            i;
                        i = parseInt(d[e], 16);
                        i = ("0" + (b < 0 ? 0 | i * (1 + b) : 0 | i + (255 - i) * b).toString(16)).slice(-2);
                        f[h] = i
                    }
                    return "#" + d.join("")
                }
            }(),
                e = function() {
                    var a = new CKEDITOR.template("background:#{to};background-image:-webkit-gradient(linear,lefttop,leftbottom,from({from}),to({to}));background-image:-moz-linear-gradient(top,{from},{to});background-image:-webkit-linear-gradient(top,{from},{to});background-image:-o-linear-gradient(top,{from},{to});background-image:-ms-linear-gradient(top,{from},{to});background-image:linear-gradient(top,{from},{to});filter:progid:DXImageTransform.Microsoft.gradient(gradientType=0,startColorstr='{from}',endColorstr='{to}');");
                    return function(b, d) {
                        return a.output({
                            from: b,
                            to: d
                        })
                    }
                }(),
                b = {
                    editor: new CKEDITOR.template("{id}.cke_chrome [border-color:{defaultBorder};] {id} .cke_top [ {defaultGradient}border-bottom-color:{defaultBorder};] {id} .cke_bottom [{defaultGradient}border-top-color:{defaultBorder};] {id} .cke_resizer [border-right-color:{ckeResizer}] {id} .cke_dialog_title [{defaultGradient}border-bottom-color:{defaultBorder};] {id} .cke_dialog_footer [{defaultGradient}outline-color:{defaultBorder};border-top-color:{defaultBorder};] {id} .cke_dialog_tab [{lightGradient}border-color:{defaultBorder};] {id} .cke_dialog_tab:hover [{mediumGradient}] {id} .cke_dialog_contents [border-top-color:{defaultBorder};] {id} .cke_dialog_tab_selected, {id} .cke_dialog_tab_selected:hover [background:{dialogTabSelected};border-bottom-color:{dialogTabSelectedBorder};] {id} .cke_dialog_body [background:{dialogBody};border-color:{defaultBorder};] {id} .cke_toolgroup [{lightGradient}border-color:{defaultBorder};] {id} a.cke_button_off:hover, {id} a.cke_button_off:focus, {id} a.cke_button_off:active [{mediumGradient}] {id} .cke_button_on [{ckeButtonOn}] {id} .cke_toolbar_separator [background-color: {ckeToolbarSeparator};] {id} .cke_combo_button [border-color:{defaultBorder};{lightGradient}] {id} a.cke_combo_button:hover, {id} a.cke_combo_button:focus, {id} .cke_combo_on a.cke_combo_button [border-color:{defaultBorder};{mediumGradient}] {id} .cke_path_item [color:{elementsPathColor};] {id} a.cke_path_item:hover, {id} a.cke_path_item:focus, {id} a.cke_path_item:active [background-color:{elementsPathBg};] {id}.cke_panel [border-color:{defaultBorder};] "),
                    panel: new CKEDITOR.template(".cke_panel_grouptitle [{lightGradient}border-color:{defaultBorder};] .cke_menubutton_icon [background-color:{menubuttonIcon};] .cke_menubutton:hover .cke_menubutton_icon, .cke_menubutton:focus .cke_menubutton_icon, .cke_menubutton:active .cke_menubutton_icon [background-color:{menubuttonIconHover};] .cke_menuseparator [background-color:{menubuttonIcon};] a:hover.cke_colorbox, a:focus.cke_colorbox, a:active.cke_colorbox [border-color:{defaultBorder};] a:hover.cke_colorauto, a:hover.cke_colormore, a:focus.cke_colorauto, a:focus.cke_colormore, a:active.cke_colorauto, a:active.cke_colormore [background-color:{ckeColorauto};border-color:{defaultBorder};] ")
                };
            return function(g, c) {
                var d = g.uiColor,
                    d = {
                        id: "." + g.id,
                        defaultBorder: a(d, -0.1),
                        defaultGradient: e(a(d, 0.9), d),
                        lightGradient: e(a(d, 1), a(d, 0.7)),
                        mediumGradient: e(a(d, 0.8), a(d, 0.5)),
                        ckeButtonOn: e(a(d, 0.6), a(d, 0.7)),
                        ckeResizer: a(d, -0.4),
                        ckeToolbarSeparator: a(d, 0.5),
                        ckeColorauto: a(d, 0.8),
                        dialogBody: a(d, 0.7),
                        dialogTabSelected: e("#FFFFFF", "#FFFFFF"),
                        dialogTabSelectedBorder: "#FFF",
                        elementsPathColor: a(d, -0.6),
                        elementsPathBg: d,
                        menubuttonIcon: a(d, 0.5),
                        menubuttonIconHover: a(d, 0.3)
                    };
                return b[c].output(d).replace(/\[/g,
                    "{").replace(/\]/g, "}")
            }
    }(), CKEDITOR.plugins.add("dialogui", {
        onLoad: function() {
            var a = function(a) {
                this._ || (this._ = {});
                this._["default"] = this._.initValue = a["default"] || "";
                this._.required = a.required || false;
                for (var b = [this._], c = 1; c < arguments.length; c++) b.push(arguments[c]);
                b.push(true);
                CKEDITOR.tools.extend.apply(CKEDITOR.tools, b);
                return this._
            }, e = {
                    build: function(a, b, c) {
                        return new CKEDITOR.ui.dialog.textInput(a, b, c)
                    }
                }, b = {
                    build: function(a, b, c) {
                        return new CKEDITOR.ui.dialog[b.type](a, b, c)
                    }
                }, g = {
                    isChanged: function() {
                        return this.getValue() !=
                            this.getInitValue()
                    },
                    reset: function(a) {
                        this.setValue(this.getInitValue(), a)
                    },
                    setInitValue: function() {
                        this._.initValue = this.getValue()
                    },
                    resetInitValue: function() {
                        this._.initValue = this._["default"]
                    },
                    getInitValue: function() {
                        return this._.initValue
                    }
                }, c = CKEDITOR.tools.extend({}, CKEDITOR.ui.dialog.uiElement.prototype.eventProcessors, {
                    onChange: function(a, b) {
                        if (!this._.domOnChangeRegistered) {
                            a.on("load", function() {
                                this.getInputElement().on("change", function() {
                                    a.parts.dialog.isVisible() && this.fire("change", {
                                        value: this.getValue()
                                    })
                                }, this)
                            }, this);
                            this._.domOnChangeRegistered = true
                        }
                        this.on("change", b)
                    }
                }, true),
                d = /^on([A-Z]\w+)/,
                j = function(a) {
                    for (var b in a)(d.test(b) || b == "title" || b == "type") && delete a[b];
                    return a
                };
            CKEDITOR.tools.extend(CKEDITOR.ui.dialog, {
                labeledElement: function(b, c, d, g) {
                    if (!(arguments.length < 4)) {
                        var e = a.call(this, c);
                        e.labelId = CKEDITOR.tools.getNextId() + "_label";
                        this._.children = [];
                        var j = {
                            role: c.role || "presentation"
                        };
                        if (c.includeLabel) j["aria-labelledby"] = e.labelId;
                        CKEDITOR.ui.dialog.uiElement.call(this,
                            b, c, d, "div", null, j, function() {
                                var a = [],
                                    d = c.required ? " cke_required" : "";
                                if (c.labelLayout != "horizontal") a.push('<label class="cke_dialog_ui_labeled_label' + d + '" ', ' id="' + e.labelId + '"', e.inputId ? ' for="' + e.inputId + '"' : "", (c.labelStyle ? ' style="' + c.labelStyle + '"' : "") + ">", c.label, "</label>", '<div class="cke_dialog_ui_labeled_content"', c.controlStyle ? ' style="' + c.controlStyle + '"' : "", ' role="presentation">', g.call(this, b, c), "</div>");
                                else {
                                    d = {
                                        type: "hbox",
                                        widths: c.widths,
                                        padding: 0,
                                        children: [{
                                            type: "html",
                                            html: '<label class="cke_dialog_ui_labeled_label' +
                                                d + '" id="' + e.labelId + '" for="' + e.inputId + '"' + (c.labelStyle ? ' style="' + c.labelStyle + '"' : "") + ">" + CKEDITOR.tools.htmlEncode(c.label) + "</span>"
                                        }, {
                                            type: "html",
                                            html: '<span class="cke_dialog_ui_labeled_content"' + (c.controlStyle ? ' style="' + c.controlStyle + '"' : "") + ">" + g.call(this, b, c) + "</span>"
                                        }]
                                    };
                                    CKEDITOR.dialog._.uiElementBuilders.hbox.build(b, d, a)
                                }
                                return a.join("")
                            })
                    }
                },
                textInput: function(b, c, d) {
                    if (!(arguments.length < 3)) {
                        a.call(this, c);
                        var g = this._.inputId = CKEDITOR.tools.getNextId() + "_textInput",
                            e = {
                                "class": "cke_dialog_ui_input_" +
                                    c.type,
                                id: g,
                                type: c.type
                            };
                        if (c.validate) this.validate = c.validate;
                        if (c.maxLength) e.maxlength = c.maxLength;
                        if (c.size) e.size = c.size;
                        if (c.inputStyle) e.style = c.inputStyle;
                        var j = this,
                            q = false;
                        b.on("load", function() {
                            j.getInputElement().on("keydown", function(a) {
                                a.data.getKeystroke() == 13 && (q = true)
                            });
                            j.getInputElement().on("keyup", function(a) {
                                if (a.data.getKeystroke() == 13 && q) {
                                    b.getButton("ok") && setTimeout(function() {
                                        b.getButton("ok").click()
                                    }, 0);
                                    q = false
                                }
                            }, null, null, 1E3)
                        });
                        CKEDITOR.ui.dialog.labeledElement.call(this,
                            b, c, d, function() {
                                var a = ['<div class="cke_dialog_ui_input_', c.type, '" role="presentation"'];
                                c.width && a.push('style="width:' + c.width + '" ');
                                a.push("><input ");
                                e["aria-labelledby"] = this._.labelId;
                                this._.required && (e["aria-required"] = this._.required);
                                for (var b in e) a.push(b + '="' + e[b] + '" ');
                                a.push(" /></div>");
                                return a.join("")
                            })
                    }
                },
                textarea: function(b, c, d) {
                    if (!(arguments.length < 3)) {
                        a.call(this, c);
                        var g = this,
                            e = this._.inputId = CKEDITOR.tools.getNextId() + "_textarea",
                            j = {};
                        if (c.validate) this.validate = c.validate;
                        j.rows = c.rows || 5;
                        j.cols = c.cols || 20;
                        j["class"] = "cke_dialog_ui_input_textarea " + (c["class"] || "");
                        if (typeof c.inputStyle != "undefined") j.style = c.inputStyle;
                        if (c.dir) j.dir = c.dir;
                        CKEDITOR.ui.dialog.labeledElement.call(this, b, c, d, function() {
                            j["aria-labelledby"] = this._.labelId;
                            this._.required && (j["aria-required"] = this._.required);
                            var a = ['<div class="cke_dialog_ui_input_textarea" role="presentation"><textarea id="', e, '" '],
                                b;
                            for (b in j) a.push(b + '="' + CKEDITOR.tools.htmlEncode(j[b]) + '" ');
                            a.push(">", CKEDITOR.tools.htmlEncode(g._["default"]),
                                "</textarea></div>");
                            return a.join("")
                        })
                    }
                },
                checkbox: function(b, c, d) {
                    if (!(arguments.length < 3)) {
                        var g = a.call(this, c, {
                            "default": !! c["default"]
                        });
                        if (c.validate) this.validate = c.validate;
                        CKEDITOR.ui.dialog.uiElement.call(this, b, c, d, "span", null, null, function() {
                            var a = CKEDITOR.tools.extend({}, c, {
                                id: c.id ? c.id + "_checkbox" : CKEDITOR.tools.getNextId() + "_checkbox"
                            }, true),
                                d = [],
                                e = CKEDITOR.tools.getNextId() + "_label",
                                i = {
                                    "class": "cke_dialog_ui_checkbox_input",
                                    type: "checkbox",
                                    "aria-labelledby": e
                                };
                            j(a);
                            if (c["default"]) i.checked =
                                "checked";
                            if (typeof a.inputStyle != "undefined") a.style = a.inputStyle;
                            g.checkbox = new CKEDITOR.ui.dialog.uiElement(b, a, d, "input", null, i);
                            d.push(' <label id="', e, '" for="', i.id, '"' + (c.labelStyle ? ' style="' + c.labelStyle + '"' : "") + ">", CKEDITOR.tools.htmlEncode(c.label), "</label>");
                            return d.join("")
                        })
                    }
                },
                radio: function(b, c, d) {
                    if (!(arguments.length < 3)) {
                        a.call(this, c);
                        if (!this._["default"]) this._["default"] = this._.initValue = c.items[0][1];
                        if (c.validate) this.validate = c.valdiate;
                        var g = [],
                            e = this;
                        c.role = "radiogroup";
                        c.includeLabel = true;
                        CKEDITOR.ui.dialog.labeledElement.call(this, b, c, d, function() {
                            for (var a = [], d = [], i = (c.id ? c.id : CKEDITOR.tools.getNextId()) + "_radio", l = 0; l < c.items.length; l++) {
                                var p = c.items[l],
                                    t = p[2] !== void 0 ? p[2] : p[0],
                                    s = p[1] !== void 0 ? p[1] : p[0],
                                    u = CKEDITOR.tools.getNextId() + "_radio_input",
                                    w = u + "_label",
                                    u = CKEDITOR.tools.extend({}, c, {
                                        id: u,
                                        title: null,
                                        type: null
                                    }, true),
                                    t = CKEDITOR.tools.extend({}, u, {
                                        title: t
                                    }, true),
                                    x = {
                                        type: "radio",
                                        "class": "cke_dialog_ui_radio_input",
                                        name: i,
                                        value: s,
                                        "aria-labelledby": w
                                    }, v = [];
                                if (e._["default"] == s) x.checked = "checked";
                                j(u);
                                j(t);
                                if (typeof u.inputStyle != "undefined") u.style = u.inputStyle;
                                u.keyboardFocusable = true;
                                g.push(new CKEDITOR.ui.dialog.uiElement(b, u, v, "input", null, x));
                                v.push(" ");
                                new CKEDITOR.ui.dialog.uiElement(b, t, v, "label", null, {
                                    id: w,
                                    "for": x.id
                                }, p[0]);
                                a.push(v.join(""))
                            }
                            new CKEDITOR.ui.dialog.hbox(b, g, a, d);
                            return d.join("")
                        });
                        this._.children = g
                    }
                },
                button: function(b, c, d) {
                    if (arguments.length) {
                        typeof c == "function" && (c = c(b.getParentEditor()));
                        a.call(this, c, {
                            disabled: c.disabled ||
                                false
                        });
                        CKEDITOR.event.implementOn(this);
                        var g = this;
                        b.on("load", function() {
                            var a = this.getElement();
                            (function() {
                                a.on("click", function(a) {
                                    g.click();
                                    a.data.preventDefault()
                                });
                                a.on("keydown", function(a) {
                                    if (a.data.getKeystroke() in {
                                        32: 1
                                    }) {
                                        g.click();
                                        a.data.preventDefault()
                                    }
                                })
                            })();
                            a.unselectable()
                        }, this);
                        var e = CKEDITOR.tools.extend({}, c);
                        delete e.style;
                        var j = CKEDITOR.tools.getNextId() + "_label";
                        CKEDITOR.ui.dialog.uiElement.call(this, b, e, d, "a", null, {
                            style: c.style,
                            href: "javascript:void(0)",
                            title: c.label,
                            hidefocus: "true",
                            "class": c["class"],
                            role: "button",
                            "aria-labelledby": j
                        }, '<span id="' + j + '" class="cke_dialog_ui_button">' + CKEDITOR.tools.htmlEncode(c.label) + "</span>")
                    }
                },
                select: function(b, c, d) {
                    if (!(arguments.length < 3)) {
                        var g = a.call(this, c);
                        if (c.validate) this.validate = c.validate;
                        g.inputId = CKEDITOR.tools.getNextId() + "_select";
                        CKEDITOR.ui.dialog.labeledElement.call(this, b, c, d, function() {
                            var a = CKEDITOR.tools.extend({}, c, {
                                id: c.id ? c.id + "_select" : CKEDITOR.tools.getNextId() + "_select"
                            }, true),
                                d = [],
                                e = [],
                                i = {
                                    id: g.inputId,
                                    "class": "cke_dialog_ui_input_select",
                                    "aria-labelledby": this._.labelId
                                };
                            d.push('<div class="cke_dialog_ui_input_', c.type, '" role="presentation"');
                            c.width && d.push('style="width:' + c.width + '" ');
                            d.push(">");
                            if (c.size !== void 0) i.size = c.size;
                            if (c.multiple !== void 0) i.multiple = c.multiple;
                            j(a);
                            for (var l = 0, p; l < c.items.length && (p = c.items[l]); l++) e.push('<option value="', CKEDITOR.tools.htmlEncode(p[1] !== void 0 ? p[1] : p[0]).replace(/"/g, "&quot;"), '" /> ', CKEDITOR.tools.htmlEncode(p[0]));
                            if (typeof a.inputStyle != "undefined") a.style = a.inputStyle;
                            g.select =
                                new CKEDITOR.ui.dialog.uiElement(b, a, d, "select", null, i, e.join(""));
                            d.push("</div>");
                            return d.join("")
                        })
                    }
                },
                file: function(b, c, d) {
                    if (!(arguments.length < 3)) {
                        c["default"] === void 0 && (c["default"] = "");
                        var g = CKEDITOR.tools.extend(a.call(this, c), {
                            definition: c,
                            buttons: []
                        });
                        if (c.validate) this.validate = c.validate;
                        b.on("load", function() {
                            CKEDITOR.document.getById(g.frameId).getParent().addClass("cke_dialog_ui_input_file")
                        });
                        CKEDITOR.ui.dialog.labeledElement.call(this, b, c, d, function() {
                            g.frameId = CKEDITOR.tools.getNextId() +
                                "_fileInput";
                            var a = ['<iframe frameborder="0" allowtransparency="0" class="cke_dialog_ui_input_file" role="presentation" id="', g.frameId, '" title="', c.label, '" src="javascript:void('];
                            a.push(CKEDITOR.env.ie ? "(function(){" + encodeURIComponent("document.open();(" + CKEDITOR.tools.fixDomain + ")();document.close();") + "})()" : "0");
                            a.push(')"></iframe>');
                            return a.join("")
                        })
                    }
                },
                fileButton: function(b, c, d) {
                    var g = this;
                    if (!(arguments.length < 3)) {
                        a.call(this, c);
                        if (c.validate) this.validate = c.validate;
                        var e = CKEDITOR.tools.extend({},
                            c),
                            j = e.onClick;
                        e.className = (e.className ? e.className + " " : "") + "cke_dialog_ui_button";
                        e.onClick = function(a) {
                            var d = c["for"];
                            if (!j || j.call(this, a) !== false) {
                                b.getContentElement(d[0], d[1]).submit();
                                this.disable()
                            }
                        };
                        b.on("load", function() {
                            b.getContentElement(c["for"][0], c["for"][1])._.buttons.push(g)
                        });
                        CKEDITOR.ui.dialog.button.call(this, b, e, d)
                    }
                },
                html: function() {
                    var a = /^\s*<[\w:]+\s+([^>]*)?>/,
                        b = /^(\s*<[\w:]+(?:\s+[^>]*)?)((?:.|\r|\n)+)$/,
                        c = /\/$/;
                    return function(d, g, e) {
                        if (!(arguments.length < 3)) {
                            var j = [],
                                m = g.html;
                            m.charAt(0) != "<" && (m = "<span>" + m + "</span>");
                            var l = g.focus;
                            if (l) {
                                var p = this.focus;
                                this.focus = function() {
                                    (typeof l == "function" ? l : p).call(this);
                                    this.fire("focus")
                                };
                                if (g.isFocusable) this.isFocusable = this.isFocusable;
                                this.keyboardFocusable = true
                            }
                            CKEDITOR.ui.dialog.uiElement.call(this, d, g, j, "span", null, null, "");
                            j = j.join("").match(a);
                            m = m.match(b) || ["", "", ""];
                            if (c.test(m[1])) {
                                m[1] = m[1].slice(0, -1);
                                m[2] = "/" + m[2]
                            }
                            e.push([m[1], " ", j[1] || "", m[2]].join(""))
                        }
                    }
                }(),
                fieldset: function(a, b, c, d, g) {
                    var e = g.label;
                    this._ = {
                        children: b
                    };
                    CKEDITOR.ui.dialog.uiElement.call(this, a, g, d, "fieldset", null, null, function() {
                        var a = [];
                        e && a.push("<legend" + (g.labelStyle ? ' style="' + g.labelStyle + '"' : "") + ">" + e + "</legend>");
                        for (var b = 0; b < c.length; b++) a.push(c[b]);
                        return a.join("")
                    })
                }
            }, true);
            CKEDITOR.ui.dialog.html.prototype = new CKEDITOR.ui.dialog.uiElement;
            CKEDITOR.ui.dialog.labeledElement.prototype = CKEDITOR.tools.extend(new CKEDITOR.ui.dialog.uiElement, {
                setLabel: function(a) {
                    var b = CKEDITOR.document.getById(this._.labelId);
                    b.getChildCount() <
                        1 ? (new CKEDITOR.dom.text(a, CKEDITOR.document)).appendTo(b) : b.getChild(0).$.nodeValue = a;
                    return this
                },
                getLabel: function() {
                    var a = CKEDITOR.document.getById(this._.labelId);
                    return !a || a.getChildCount() < 1 ? "" : a.getChild(0).getText()
                },
                eventProcessors: c
            }, true);
            CKEDITOR.ui.dialog.button.prototype = CKEDITOR.tools.extend(new CKEDITOR.ui.dialog.uiElement, {
                click: function() {
                    return !this._.disabled ? this.fire("click", {
                        dialog: this._.dialog
                    }) : false
                },
                enable: function() {
                    this._.disabled = false;
                    var a = this.getElement();
                    a && a.removeClass("cke_disabled")
                },
                disable: function() {
                    this._.disabled = true;
                    this.getElement().addClass("cke_disabled")
                },
                isVisible: function() {
                    return this.getElement().getFirst().isVisible()
                },
                isEnabled: function() {
                    return !this._.disabled
                },
                eventProcessors: CKEDITOR.tools.extend({}, CKEDITOR.ui.dialog.uiElement.prototype.eventProcessors, {
                    onClick: function(a, b) {
                        this.on("click", function() {
                            b.apply(this, arguments)
                        })
                    }
                }, true),
                accessKeyUp: function() {
                    this.click()
                },
                accessKeyDown: function() {
                    this.focus()
                },
                keyboardFocusable: true
            }, true);
            CKEDITOR.ui.dialog.textInput.prototype =
                CKEDITOR.tools.extend(new CKEDITOR.ui.dialog.labeledElement, {
                    getInputElement: function() {
                        return CKEDITOR.document.getById(this._.inputId)
                    },
                    focus: function() {
                        var a = this.selectParentTab();
                        setTimeout(function() {
                            var b = a.getInputElement();
                            b && b.$.focus()
                        }, 0)
                    },
                    select: function() {
                        var a = this.selectParentTab();
                        setTimeout(function() {
                            var b = a.getInputElement();
                            if (b) {
                                b.$.focus();
                                b.$.select()
                            }
                        }, 0)
                    },
                    accessKeyUp: function() {
                        this.select()
                    },
                    setValue: function(a) {
                        !a && (a = "");
                        return CKEDITOR.ui.dialog.uiElement.prototype.setValue.apply(this,
                            arguments)
                    },
                    keyboardFocusable: true
                }, g, true);
            CKEDITOR.ui.dialog.textarea.prototype = new CKEDITOR.ui.dialog.textInput;
            CKEDITOR.ui.dialog.select.prototype = CKEDITOR.tools.extend(new CKEDITOR.ui.dialog.labeledElement, {
                getInputElement: function() {
                    return this._.select.getElement()
                },
                add: function(a, b, c) {
                    var d = new CKEDITOR.dom.element("option", this.getDialog().getParentEditor().document),
                        g = this.getInputElement().$;
                    d.$.text = a;
                    d.$.value = b === void 0 || b === null ? a : b;
                    c === void 0 || c === null ? CKEDITOR.env.ie ? g.add(d.$) : g.add(d.$,
                        null) : g.add(d.$, c);
                    return this
                },
                remove: function(a) {
                    this.getInputElement().$.remove(a);
                    return this
                },
                clear: function() {
                    for (var a = this.getInputElement().$; a.length > 0;) a.remove(0);
                    return this
                },
                keyboardFocusable: true
            }, g, true);
            CKEDITOR.ui.dialog.checkbox.prototype = CKEDITOR.tools.extend(new CKEDITOR.ui.dialog.uiElement, {
                getInputElement: function() {
                    return this._.checkbox.getElement()
                },
                setValue: function(a, b) {
                    this.getInputElement().$.checked = a;
                    !b && this.fire("change", {
                        value: a
                    })
                },
                getValue: function() {
                    return this.getInputElement().$.checked
                },
                accessKeyUp: function() {
                    this.setValue(!this.getValue())
                },
                eventProcessors: {
                    onChange: function(a, b) {
                        if (!CKEDITOR.env.ie || CKEDITOR.env.version > 8) return c.onChange.apply(this, arguments);
                        a.on("load", function() {
                            var a = this._.checkbox.getElement();
                            a.on("propertychange", function(b) {
                                b = b.data.$;
                                b.propertyName == "checked" && this.fire("change", {
                                    value: a.$.checked
                                })
                            }, this)
                        }, this);
                        this.on("change", b);
                        return null
                    }
                },
                keyboardFocusable: true
            }, g, true);
            CKEDITOR.ui.dialog.radio.prototype = CKEDITOR.tools.extend(new CKEDITOR.ui.dialog.uiElement, {
                setValue: function(a, b) {
                    for (var c = this._.children, d, g = 0; g < c.length && (d = c[g]); g++) d.getElement().$.checked = d.getValue() == a;
                    !b && this.fire("change", {
                        value: a
                    })
                },
                getValue: function() {
                    for (var a = this._.children, b = 0; b < a.length; b++)
                        if (a[b].getElement().$.checked) return a[b].getValue();
                    return null
                },
                accessKeyUp: function() {
                    var a = this._.children,
                        b;
                    for (b = 0; b < a.length; b++)
                        if (a[b].getElement().$.checked) {
                            a[b].getElement().focus();
                            return
                        }
                    a[0].getElement().focus()
                },
                eventProcessors: {
                    onChange: function(a, b) {
                        if (CKEDITOR.env.ie) {
                            a.on("load",
                                function() {
                                    for (var a = this._.children, b = this, c = 0; c < a.length; c++) a[c].getElement().on("propertychange", function(a) {
                                        a = a.data.$;
                                        a.propertyName == "checked" && this.$.checked && b.fire("change", {
                                            value: this.getAttribute("value")
                                        })
                                    })
                                }, this);
                            this.on("change", b)
                        } else return c.onChange.apply(this, arguments);
                        return null
                    }
                }
            }, g, true);
            CKEDITOR.ui.dialog.file.prototype = CKEDITOR.tools.extend(new CKEDITOR.ui.dialog.labeledElement, g, {
                getInputElement: function() {
                    var a = CKEDITOR.document.getById(this._.frameId).getFrameDocument();
                    return a.$.forms.length > 0 ? new CKEDITOR.dom.element(a.$.forms[0].elements[0]) : this.getElement()
                },
                submit: function() {
                    this.getInputElement().getParent().$.submit();
                    return this
                },
                getAction: function() {
                    return this.getInputElement().getParent().$.action
                },
                registerEvents: function(a) {
                    var b = /^on([A-Z]\w+)/,
                        c, d = function(a, b, c, d) {
                            a.on("formLoaded", function() {
                                a.getInputElement().on(c, d, a)
                            })
                        }, g;
                    for (g in a)
                        if (c = g.match(b)) this.eventProcessors[g] ? this.eventProcessors[g].call(this, this._.dialog, a[g]) : d(this, this._.dialog,
                            c[1].toLowerCase(), a[g]);
                    return this
                },
                reset: function() {
                    function a() {
                        c.$.open();
                        var f = "";
                        d.size && (f = d.size - (CKEDITOR.env.ie ? 7 : 0));
                        var t = b.frameId + "_input";
                        c.$.write(['<html dir="' + m + '" lang="' + l + '"><head><title></title></head><body style="margin: 0; overflow: hidden; background: transparent;">', '<form enctype="multipart/form-data" method="POST" dir="' + m + '" lang="' + l + '" action="', CKEDITOR.tools.htmlEncode(d.action), '"><label id="', b.labelId, '" for="', t, '" style="display:none">', CKEDITOR.tools.htmlEncode(d.label),
                            '</label><input style="width:100%" id="', t, '" aria-labelledby="', b.labelId, '" type="file" name="', CKEDITOR.tools.htmlEncode(d.id || "cke_upload"), '" size="', CKEDITOR.tools.htmlEncode(f > 0 ? f : ""), '" /></form></body></html><script>', CKEDITOR.env.ie ? "(" + CKEDITOR.tools.fixDomain + ")();" : "", "window.parent.CKEDITOR.tools.callFunction(" + e + ");", "window.onbeforeunload = function() {window.parent.CKEDITOR.tools.callFunction(" + j + ")}", "<\/script>"
                        ].join(""));
                        c.$.close();
                        for (f = 0; f < g.length; f++) g[f].enable()
                    }
                    var b =
                        this._,
                        c = CKEDITOR.document.getById(b.frameId).getFrameDocument(),
                        d = b.definition,
                        g = b.buttons,
                        e = this.formLoadedNumber,
                        j = this.formUnloadNumber,
                        m = b.dialog._.editor.lang.dir,
                        l = b.dialog._.editor.langCode;
                    if (!e) {
                        e = this.formLoadedNumber = CKEDITOR.tools.addFunction(function() {
                            this.fire("formLoaded")
                        }, this);
                        j = this.formUnloadNumber = CKEDITOR.tools.addFunction(function() {
                            this.getInputElement().clearCustomData()
                        }, this);
                        this.getDialog()._.editor.on("destroy", function() {
                            CKEDITOR.tools.removeFunction(e);
                            CKEDITOR.tools.removeFunction(j)
                        })
                    }
                    CKEDITOR.env.gecko ?
                        setTimeout(a, 500) : a()
                },
                getValue: function() {
                    return this.getInputElement().$.value || ""
                },
                setInitValue: function() {
                    this._.initValue = ""
                },
                eventProcessors: {
                    onChange: function(a, b) {
                        if (!this._.domOnChangeRegistered) {
                            this.on("formLoaded", function() {
                                this.getInputElement().on("change", function() {
                                    this.fire("change", {
                                        value: this.getValue()
                                    })
                                }, this)
                            }, this);
                            this._.domOnChangeRegistered = true
                        }
                        this.on("change", b)
                    }
                },
                keyboardFocusable: true
            }, true);
            CKEDITOR.ui.dialog.fileButton.prototype = new CKEDITOR.ui.dialog.button;
            CKEDITOR.ui.dialog.fieldset.prototype =
                CKEDITOR.tools.clone(CKEDITOR.ui.dialog.hbox.prototype);
            CKEDITOR.dialog.addUIElement("text", e);
            CKEDITOR.dialog.addUIElement("password", e);
            CKEDITOR.dialog.addUIElement("textarea", b);
            CKEDITOR.dialog.addUIElement("checkbox", b);
            CKEDITOR.dialog.addUIElement("radio", b);
            CKEDITOR.dialog.addUIElement("button", b);
            CKEDITOR.dialog.addUIElement("select", b);
            CKEDITOR.dialog.addUIElement("file", b);
            CKEDITOR.dialog.addUIElement("fileButton", b);
            CKEDITOR.dialog.addUIElement("html", b);
            CKEDITOR.dialog.addUIElement("fieldset", {
                build: function(a, b, c) {
                    for (var d = b.children, g, e = [], j = [], m = 0; m < d.length && (g = d[m]); m++) {
                        var l = [];
                        e.push(l);
                        j.push(CKEDITOR.dialog._.uiElementBuilders[g.type].build(a, g, l))
                    }
                    return new CKEDITOR.ui.dialog[b.type](a, j, e, c, b)
                }
            })
        }
    }), CKEDITOR.DIALOG_RESIZE_NONE = 0, CKEDITOR.DIALOG_RESIZE_WIDTH = 1, CKEDITOR.DIALOG_RESIZE_HEIGHT = 2, CKEDITOR.DIALOG_RESIZE_BOTH = 3,
    function() {
        function a() {
            for (var a = this._.tabIdList.length, b = CKEDITOR.tools.indexOf(this._.tabIdList, this._.currentTabId) + a, c = b - 1; c > b - a; c--)
                if (this._.tabs[this._.tabIdList[c %
                    a]][0].$.offsetHeight) return this._.tabIdList[c % a];
            return null
        }

        function e() {
            for (var a = this._.tabIdList.length, b = CKEDITOR.tools.indexOf(this._.tabIdList, this._.currentTabId), c = b + 1; c < b + a; c++)
                if (this._.tabs[this._.tabIdList[c % a]][0].$.offsetHeight) return this._.tabIdList[c % a];
            return null
        }

        function b(a, b) {
            for (var c = a.$.getElementsByTagName("input"), d = 0, f = c.length; d < f; d++) {
                var g = new CKEDITOR.dom.element(c[d]);
                if (g.getAttribute("type").toLowerCase() == "text")
                    if (b) {
                        g.setAttribute("value", g.getCustomData("fake_value") ||
                            "");
                        g.removeCustomData("fake_value")
                    } else {
                        g.setCustomData("fake_value", g.getAttribute("value"));
                        g.setAttribute("value", "")
                    }
            }
        }

        function g(a, b) {
            var c = this.getInputElement();
            c && (a ? c.removeAttribute("aria-invalid") : c.setAttribute("aria-invalid", true));
            a || (this.select ? this.select() : this.focus());
            b && alert(b);
            this.fire("validated", {
                valid: a,
                msg: b
            })
        }

        function c() {
            var a = this.getInputElement();
            a && a.removeAttribute("aria-invalid")
        }

        function d(a) {
            var a = CKEDITOR.dom.element.createFromHtml(CKEDITOR.addTemplate("dialog",
                l).output({
                id: CKEDITOR.tools.getNextNumber(),
                editorId: a.id,
                langDir: a.lang.dir,
                langCode: a.langCode,
                editorDialogClass: "cke_editor_" + a.name.replace(/\./g, "\\.") + "_dialog",
                closeTitle: a.lang.common.close,
                hidpi: CKEDITOR.env.hidpi ? "cke_hidpi" : ""
            })),
                b = a.getChild([0, 0, 0, 0, 0]),
                c = b.getChild(0),
                d = b.getChild(1);
            if (CKEDITOR.env.ie && !CKEDITOR.env.quirks) {
                var f = "javascript:void(function(){" + encodeURIComponent("document.open();(" + CKEDITOR.tools.fixDomain + ")();document.close();") + "}())";
                CKEDITOR.dom.element.createFromHtml('<iframe frameBorder="0" class="cke_iframe_shim" src="' +
                    f + '" tabIndex="-1"></iframe>').appendTo(b.getParent())
            }
            c.unselectable();
            d.unselectable();
            return {
                element: a,
                parts: {
                    dialog: a.getChild(0),
                    title: c,
                    close: d,
                    tabs: b.getChild(2),
                    contents: b.getChild([3, 0, 0, 0]),
                    footer: b.getChild([3, 0, 1, 0])
                }
            }
        }

        function j(a, b, c) {
            this.element = b;
            this.focusIndex = c;
            this.tabIndex = 0;
            this.isFocusable = function() {
                return !b.getAttribute("disabled") && b.isVisible()
            };
            this.focus = function() {
                a._.currentFocusIndex = this.focusIndex;
                this.element.focus()
            };
            b.on("keydown", function(a) {
                a.data.getKeystroke() in {
                    32: 1,
                    13: 1
                } && this.fire("click")
            });
            b.on("focus", function() {
                this.fire("mouseover")
            });
            b.on("blur", function() {
                this.fire("mouseout")
            })
        }

        function f(a) {
            function b() {
                a.layout()
            }
            var c = CKEDITOR.document.getWindow();
            c.on("resize", b);
            a.on("hide", function() {
                c.removeListener("resize", b)
            })
        }

        function h(a, b) {
            this._ = {
                dialog: a
            };
            CKEDITOR.tools.extend(this, b)
        }

        function i(a) {
            function b(c) {
                var j = a.getSize(),
                    i = CKEDITOR.document.getWindow().getViewPaneSize(),
                    k = c.data.$.screenX,
                    p = c.data.$.screenY,
                    s = k - d.x,
                    t = p - d.y;
                d = {
                    x: k,
                    y: p
                };
                f.x = f.x + s;
                f.y = f.y + t;
                a.move(f.x + h[3] < e ? -h[3] : f.x - h[1] > i.width - j.width - e ? i.width - j.width + (g.lang.dir == "rtl" ? 0 : h[1]) : f.x, f.y + h[0] < e ? -h[0] : f.y - h[2] > i.height - j.height - e ? i.height - j.height + h[2] : f.y, 1);
                c.data.preventDefault()
            }

            function c() {
                CKEDITOR.document.removeListener("mousemove", b);
                CKEDITOR.document.removeListener("mouseup", c);
                if (CKEDITOR.env.ie6Compat) {
                    var a = r.getChild(0).getFrameDocument();
                    a.removeListener("mousemove", b);
                    a.removeListener("mouseup", c)
                }
            }
            var d = null,
                f = null,
                g = a.getParentEditor(),
                e = g.config.dialog_magnetDistance,
                h = CKEDITOR.skin.margins || [0, 0, 0, 0];
            typeof e == "undefined" && (e = 20);
            a.parts.title.on("mousedown", function(g) {
                d = {
                    x: g.data.$.screenX,
                    y: g.data.$.screenY
                };
                CKEDITOR.document.on("mousemove", b);
                CKEDITOR.document.on("mouseup", c);
                f = a.getPosition();
                if (CKEDITOR.env.ie6Compat) {
                    var e = r.getChild(0).getFrameDocument();
                    e.on("mousemove", b);
                    e.on("mouseup", c)
                }
                g.data.preventDefault()
            }, a)
        }

        function k(a) {
            var b, c;

            function d(f) {
                var s = h.lang.dir == "rtl",
                    t = p.width,
                    m = p.height,
                    l = t + (f.data.$.screenX - b) * (s ? -1 : 1) * (a._.moved ? 1 : 2),
                    n =
                        m + (f.data.$.screenY - c) * (a._.moved ? 1 : 2),
                    u = a._.element.getFirst(),
                    u = s && u.getComputedStyle("right"),
                    q = a.getPosition();
                q.y + n > k.height && (n = k.height - q.y);
                if ((s ? u : q.x) + l > k.width) l = k.width - (s ? u : q.x);
                if (e == CKEDITOR.DIALOG_RESIZE_WIDTH || e == CKEDITOR.DIALOG_RESIZE_BOTH) t = Math.max(g.minWidth || 0, l - j);
                if (e == CKEDITOR.DIALOG_RESIZE_HEIGHT || e == CKEDITOR.DIALOG_RESIZE_BOTH) m = Math.max(g.minHeight || 0, n - i);
                a.resize(t, m);
                a._.moved || a.layout();
                f.data.preventDefault()
            }

            function f() {
                CKEDITOR.document.removeListener("mouseup",
                    f);
                CKEDITOR.document.removeListener("mousemove", d);
                if (s) {
                    s.remove();
                    s = null
                }
                if (CKEDITOR.env.ie6Compat) {
                    var a = r.getChild(0).getFrameDocument();
                    a.removeListener("mouseup", f);
                    a.removeListener("mousemove", d)
                }
            }
            var g = a.definition,
                e = g.resizable;
            if (e != CKEDITOR.DIALOG_RESIZE_NONE) {
                var h = a.getParentEditor(),
                    j, i, k, p, s, t = CKEDITOR.tools.addFunction(function(g) {
                        p = a.getSize();
                        var e = a.parts.contents;
                        if (e.$.getElementsByTagName("iframe").length) {
                            s = CKEDITOR.dom.element.createFromHtml('<div class="cke_dialog_resize_cover" style="height: 100%; position: absolute; width: 100%;"></div>');
                            e.append(s)
                        }
                        i = p.height - a.parts.contents.getSize("height", !(CKEDITOR.env.gecko || CKEDITOR.env.ie && CKEDITOR.env.quirks));
                        j = p.width - a.parts.contents.getSize("width", 1);
                        b = g.screenX;
                        c = g.screenY;
                        k = CKEDITOR.document.getWindow().getViewPaneSize();
                        CKEDITOR.document.on("mousemove", d);
                        CKEDITOR.document.on("mouseup", f);
                        if (CKEDITOR.env.ie6Compat) {
                            e = r.getChild(0).getFrameDocument();
                            e.on("mousemove", d);
                            e.on("mouseup", f)
                        }
                        g.preventDefault && g.preventDefault()
                    });
                a.on("load", function() {
                    var b = "";
                    e == CKEDITOR.DIALOG_RESIZE_WIDTH ?
                        b = " cke_resizer_horizontal" : e == CKEDITOR.DIALOG_RESIZE_HEIGHT && (b = " cke_resizer_vertical");
                    b = CKEDITOR.dom.element.createFromHtml('<div class="cke_resizer' + b + " cke_resizer_" + h.lang.dir + '" title="' + CKEDITOR.tools.htmlEncode(h.lang.common.resize) + '" onmousedown="CKEDITOR.tools.callFunction(' + t + ', event )">' + (h.lang.dir == "ltr" ? "◢" : "◣") + "</div>");
                    a.parts.footer.append(b, 1)
                });
                h.on("destroy", function() {
                    CKEDITOR.tools.removeFunction(t)
                })
            }
        }

        function n(a) {
            a.data.preventDefault(1)
        }

        function o(a) {
            var b = CKEDITOR.document.getWindow(),
                c = a.config,
                d = c.dialog_backgroundCoverColor || "white",
                f = c.dialog_backgroundCoverOpacity,
                g = c.baseFloatZIndex,
                c = CKEDITOR.tools.genKey(d, f, g),
                e = v[c];
            if (e) e.show();
            else {
                g = ['<div tabIndex="-1" style="position: ', CKEDITOR.env.ie6Compat ? "absolute" : "fixed", "; z-index: ", g, "; top: 0px; left: 0px; ", !CKEDITOR.env.ie6Compat ? "background-color: " + d : "", '" class="cke_dialog_background_cover">'];
                if (CKEDITOR.env.ie6Compat) {
                    d = "<html><body style=\\'background-color:" + d + ";\\'></body></html>";
                    g.push('<iframe hidefocus="true" frameborder="0" id="cke_dialog_background_iframe" src="javascript:');
                    g.push("void((function(){" + encodeURIComponent("document.open();(" + CKEDITOR.tools.fixDomain + ")();document.write( '" + d + "' );document.close();") + "})())");
                    g.push('" style="position:absolute;left:0;top:0;width:100%;height: 100%;filter: progid:DXImageTransform.Microsoft.Alpha(opacity=0)"></iframe>')
                }
                g.push("</div>");
                e = CKEDITOR.dom.element.createFromHtml(g.join(""));
                e.setOpacity(f !== void 0 ? f : 0.5);
                e.on("keydown", n);
                e.on("keypress", n);
                e.on("keyup", n);
                e.appendTo(CKEDITOR.document.getBody());
                v[c] = e
            }
            a.focusManager.add(e);
            r = e;
            var a = function() {
                var a = b.getViewPaneSize();
                e.setStyles({
                    width: a.width + "px",
                    height: a.height + "px"
                })
            }, h = function() {
                    var a = b.getScrollPosition(),
                        c = CKEDITOR.dialog._.currentTop;
                    e.setStyles({
                        left: a.x + "px",
                        top: a.y + "px"
                    });
                    if (c) {
                        do {
                            a = c.getPosition();
                            c.move(a.x, a.y)
                        } while (c = c._.parentDialog)
                    }
                };
            x = a;
            b.on("resize", a);
            a();
            (!CKEDITOR.env.mac || !CKEDITOR.env.webkit) && e.focus();
            if (CKEDITOR.env.ie6Compat) {
                var j = function() {
                    h();
                    arguments.callee.prevScrollHandler.apply(this, arguments)
                };
                b.$.setTimeout(function() {
                    j.prevScrollHandler =
                        window.onscroll || function() {};
                    window.onscroll = j
                }, 0);
                h()
            }
        }

        function q(a) {
            if (r) {
                a.focusManager.remove(r);
                a = CKEDITOR.document.getWindow();
                r.hide();
                a.removeListener("resize", x);
                CKEDITOR.env.ie6Compat && a.$.setTimeout(function() {
                    window.onscroll = window.onscroll && window.onscroll.prevScrollHandler || null
                }, 0);
                x = null
            }
        }
        var m = CKEDITOR.tools.cssLength,
            l = '<div class="cke_reset_all {editorId} {editorDialogClass} {hidpi}" dir="{langDir}" lang="{langCode}" role="dialog" aria-labelledby="cke_dialog_title_{id}"><table class="cke_dialog ' +
                CKEDITOR.env.cssClass + ' cke_{langDir}" style="position:absolute" role="presentation"><tr><td role="presentation"><div class="cke_dialog_body" role="presentation"><div id="cke_dialog_title_{id}" class="cke_dialog_title" role="presentation"></div><a id="cke_dialog_close_button_{id}" class="cke_dialog_close_button" href="javascript:void(0)" title="{closeTitle}" role="button"><span class="cke_label">X</span></a><div id="cke_dialog_tabs_{id}" class="cke_dialog_tabs" role="tablist"></div><table class="cke_dialog_contents" role="presentation"><tr><td id="cke_dialog_contents_{id}" class="cke_dialog_contents_body" role="presentation"></td></tr><tr><td id="cke_dialog_footer_{id}" class="cke_dialog_footer" role="presentation"></td></tr></table></div></td></tr></table></div>';
        CKEDITOR.dialog = function(b, f) {
            function h() {
                var a = v._.focusList;
                a.sort(function(a, b) {
                    return a.tabIndex != b.tabIndex ? b.tabIndex - a.tabIndex : a.focusIndex - b.focusIndex
                });
                for (var b = a.length, c = 0; c < b; c++) a[c].focusIndex = c
            }

            function j(a) {
                var b = v._.focusList,
                    a = a || 0;
                if (!(b.length < 1)) {
                    var c = v._.currentFocusIndex;
                    try {
                        b[c].getInputElement().$.blur()
                    } catch (d) {}
                    for (var f = c = (c + a + b.length) % b.length; a && !b[f].isFocusable();) {
                        f = (f + a + b.length) % b.length;
                        if (f == c) break
                    }
                    b[f].focus();
                    b[f].type == "text" && b[f].select()
                }
            }

            function s(c) {
                if (v ==
                    CKEDITOR.dialog._.currentTop) {
                    var d = c.data.getKeystroke(),
                        f = b.lang.dir == "rtl";
                    o = x = 0;
                    if (d == 9 || d == CKEDITOR.SHIFT + 9) {
                        d = d == CKEDITOR.SHIFT + 9;
                        if (v._.tabBarMode) {
                            d = d ? a.call(v) : e.call(v);
                            v.selectPage(d);
                            v._.tabs[d][0].focus()
                        } else j(d ? -1 : 1);
                        o = 1
                    } else if (d == CKEDITOR.ALT + 121 && !v._.tabBarMode && v.getPageCount() > 1) {
                        v._.tabBarMode = true;
                        v._.tabs[v._.currentTabId][0].focus();
                        o = 1
                    } else if ((d == 37 || d == 39) && v._.tabBarMode) {
                        d = d == (f ? 39 : 37) ? a.call(v) : e.call(v);
                        v.selectPage(d);
                        v._.tabs[d][0].focus();
                        o = 1
                    } else if ((d == 13 || d ==
                        32) && v._.tabBarMode) {
                        this.selectPage(this._.currentTabId);
                        this._.tabBarMode = false;
                        this._.currentFocusIndex = -1;
                        j(1);
                        o = 1
                    } else if (d == 13) {
                        d = c.data.getTarget();
                        if (!d.is("a", "button", "select", "textarea") && (!d.is("input") || d.$.type != "button")) {
                            (d = this.getButton("ok")) && CKEDITOR.tools.setTimeout(d.click, 0, d);
                            o = 1
                        }
                        x = 1
                    } else if (d == 27) {
                        (d = this.getButton("cancel")) ? CKEDITOR.tools.setTimeout(d.click, 0, d) : this.fire("cancel", {
                            hide: true
                        }).hide !== false && this.hide();
                        x = 1
                    } else return;
                    t(c)
                }
            }

            function t(a) {
                o ? a.data.preventDefault(1) :
                    x && a.data.stopPropagation()
            }
            var m = CKEDITOR.dialog._.dialogDefinitions[f],
                l = CKEDITOR.tools.clone(p),
                n = b.config.dialog_buttonsOrder || "OS",
                u = b.lang.dir,
                q = {}, o, x;
            (n == "OS" && CKEDITOR.env.mac || n == "rtl" && u == "ltr" || n == "ltr" && u == "rtl") && l.buttons.reverse();
            m = CKEDITOR.tools.extend(m(b), l);
            m = CKEDITOR.tools.clone(m);
            m = new w(this, m);
            l = d(b);
            this._ = {
                editor: b,
                element: l.element,
                name: f,
                contentSize: {
                    width: 0,
                    height: 0
                },
                size: {
                    width: 0,
                    height: 0
                },
                contents: {},
                buttons: {},
                accessKeyMap: {},
                tabs: {},
                tabIdList: [],
                currentTabId: null,
                currentTabIndex: null,
                pageCount: 0,
                lastTab: null,
                tabBarMode: false,
                focusList: [],
                currentFocusIndex: 0,
                hasFocus: false
            };
            this.parts = l.parts;
            CKEDITOR.tools.setTimeout(function() {
                b.fire("ariaWidget", this.parts.contents)
            }, 0, this);
            l = {
                position: CKEDITOR.env.ie6Compat ? "absolute" : "fixed",
                top: 0,
                visibility: "hidden"
            };
            l[u == "rtl" ? "right" : "left"] = 0;
            this.parts.dialog.setStyles(l);
            CKEDITOR.event.call(this);
            this.definition = m = CKEDITOR.fire("dialogDefinition", {
                name: f,
                definition: m
            }, b).definition;
            if (!("removeDialogTabs" in b._) &&
                b.config.removeDialogTabs) {
                l = b.config.removeDialogTabs.split(";");
                for (u = 0; u < l.length; u++) {
                    n = l[u].split(":");
                    if (n.length == 2) {
                        var r = n[0];
                        q[r] || (q[r] = []);
                        q[r].push(n[1])
                    }
                }
                b._.removeDialogTabs = q
            }
            if (b._.removeDialogTabs && (q = b._.removeDialogTabs[f]))
                for (u = 0; u < q.length; u++) m.removeContents(q[u]);
            if (m.onLoad) this.on("load", m.onLoad);
            if (m.onShow) this.on("show", m.onShow);
            if (m.onHide) this.on("hide", m.onHide);
            if (m.onOk) this.on("ok", function(a) {
                b.fire("saveSnapshot");
                setTimeout(function() {
                        b.fire("saveSnapshot")
                    },
                    0);
                if (m.onOk.call(this, a) === false) a.data.hide = false
            });
            if (m.onCancel) this.on("cancel", function(a) {
                if (m.onCancel.call(this, a) === false) a.data.hide = false
            });
            var v = this,
                z = function(a) {
                    var b = v._.contents,
                        c = false,
                        d;
                    for (d in b)
                        for (var f in b[d])
                            if (c = a.call(this, b[d][f])) return
                };
            this.on("ok", function(a) {
                z(function(b) {
                    if (b.validate) {
                        var c = b.validate(this),
                            d = typeof c == "string" || c === false;
                        if (d) {
                            a.data.hide = false;
                            a.stop()
                        }
                        g.call(b, !d, typeof c == "string" ? c : void 0);
                        return d
                    }
                })
            }, this, null, 0);
            this.on("cancel", function(a) {
                z(function(c) {
                    if (c.isChanged()) {
                        if (!b.config.dialog_noConfirmCancel && !confirm(b.lang.common.confirmCancel)) a.data.hide = false;
                        return true
                    }
                })
            }, this, null, 0);
            this.parts.close.on("click", function(a) {
                this.fire("cancel", {
                    hide: true
                }).hide !== false && this.hide();
                a.data.preventDefault()
            }, this);
            this.changeFocus = j;
            var y = this._.element;
            b.focusManager.add(y, 1);
            this.on("show", function() {
                y.on("keydown", s, this);
                if (CKEDITOR.env.gecko) y.on("keypress", t, this)
            });
            this.on("hide", function() {
                y.removeListener("keydown", s);
                CKEDITOR.env.gecko && y.removeListener("keypress", t);
                z(function(a) {
                    c.apply(a)
                })
            });
            this.on("iframeAdded", function(a) {
                (new CKEDITOR.dom.document(a.data.iframe.$.contentWindow.document)).on("keydown", s, this, null, 0)
            });
            this.on("show", function() {
                h();
                if (b.config.dialog_startupFocusTab && v._.pageCount > 1) {
                    v._.tabBarMode = true;
                    v._.tabs[v._.currentTabId][0].focus()
                } else if (!this._.hasFocus) {
                    this._.currentFocusIndex = -1;
                    if (m.onFocus) {
                        var a = m.onFocus.call(this);
                        a && a.focus()
                    } else j(1)
                }
            }, this, null, 4294967295);
            if (CKEDITOR.env.ie6Compat) this.on("load", function() {
                var a = this.getElement(),
                    b = a.getFirst();
                b.remove();
                b.appendTo(a)
            }, this);
            i(this);
            k(this);
            (new CKEDITOR.dom.text(m.title, CKEDITOR.document)).appendTo(this.parts.title);
            for (u = 0; u < m.contents.length; u++)(q = m.contents[u]) && this.addPage(q);
            this.parts.tabs.on("click", function(a) {
                var b = a.data.getTarget();
                if (b.hasClass("cke_dialog_tab")) {
                    b = b.$.id;
                    this.selectPage(b.substring(4, b.lastIndexOf("_")));
                    if (this._.tabBarMode) {
                        this._.tabBarMode = false;
                        this._.currentFocusIndex = -1;
                        j(1)
                    }
                    a.data.preventDefault()
                }
            }, this);
            u = [];
            q = CKEDITOR.dialog._.uiElementBuilders.hbox.build(this, {
                type: "hbox",
                className: "cke_dialog_footer_buttons",
                widths: [],
                children: m.buttons
            }, u).getChild();
            this.parts.footer.setHtml(u.join(""));
            for (u = 0; u < q.length; u++) this._.buttons[q[u].id] = q[u]
        };
        CKEDITOR.dialog.prototype = {
            destroy: function() {
                this.hide();
                this._.element.remove()
            },
            resize: function() {
                return function(a, b) {
                    if (!this._.contentSize || !(this._.contentSize.width == a && this._.contentSize.height == b)) {
                        CKEDITOR.dialog.fire("resize", {
                            dialog: this,
                            width: a,
                            height: b
                        }, this._.editor);
                        this.fire("resize", {
                                width: a,
                                height: b
                            },
                            this._.editor);
                        this.parts.contents.setStyles({
                            width: a + "px",
                            height: b + "px"
                        });
                        if (this._.editor.lang.dir == "rtl" && this._.position) this._.position.x = CKEDITOR.document.getWindow().getViewPaneSize().width - this._.contentSize.width - parseInt(this._.element.getFirst().getStyle("right"), 10);
                        this._.contentSize = {
                            width: a,
                            height: b
                        }
                    }
                }
            }(),
            getSize: function() {
                var a = this._.element.getFirst();
                return {
                    width: a.$.offsetWidth || 0,
                    height: a.$.offsetHeight || 0
                }
            },
            move: function(a, b, c) {
                var d = this._.element.getFirst(),
                    f = this._.editor.lang.dir ==
                        "rtl",
                    g = d.getComputedStyle("position") == "fixed";
                CKEDITOR.env.ie && d.setStyle("zoom", "100%");
                if (!g || !this._.position || !(this._.position.x == a && this._.position.y == b)) {
                    this._.position = {
                        x: a,
                        y: b
                    };
                    if (!g) {
                        g = CKEDITOR.document.getWindow().getScrollPosition();
                        a = a + g.x;
                        b = b + g.y
                    }
                    if (f) {
                        g = this.getSize();
                        a = CKEDITOR.document.getWindow().getViewPaneSize().width - g.width - a
                    }
                    b = {
                        top: (b > 0 ? b : 0) + "px"
                    };
                    b[f ? "right" : "left"] = (a > 0 ? a : 0) + "px";
                    d.setStyles(b);
                    c && (this._.moved = 1)
                }
            },
            getPosition: function() {
                return CKEDITOR.tools.extend({},
                    this._.position)
            },
            show: function() {
                var a = this._.element,
                    b = this.definition;
                !a.getParent() || !a.getParent().equals(CKEDITOR.document.getBody()) ? a.appendTo(CKEDITOR.document.getBody()) : a.setStyle("display", "block");
                this.resize(this._.contentSize && this._.contentSize.width || b.width || b.minWidth, this._.contentSize && this._.contentSize.height || b.height || b.minHeight);
                this.reset();
                this.selectPage(this.definition.contents[0].id);
                if (CKEDITOR.dialog._.currentZIndex === null) CKEDITOR.dialog._.currentZIndex = this._.editor.config.baseFloatZIndex;
                this._.element.getFirst().setStyle("z-index", CKEDITOR.dialog._.currentZIndex = CKEDITOR.dialog._.currentZIndex + 10);
                if (CKEDITOR.dialog._.currentTop === null) {
                    CKEDITOR.dialog._.currentTop = this;
                    this._.parentDialog = null;
                    o(this._.editor)
                } else {
                    this._.parentDialog = CKEDITOR.dialog._.currentTop;
                    this._.parentDialog.getElement().getFirst().$.style.zIndex -= Math.floor(this._.editor.config.baseFloatZIndex / 2);
                    CKEDITOR.dialog._.currentTop = this
                }
                a.on("keydown", z);
                a.on("keyup", B);
                this._.hasFocus = false;
                for (var c in b.contents)
                    if (b.contents[c]) {
                        var a =
                            b.contents[c],
                            d = this._.tabs[a.id],
                            g = a.requiredContent,
                            e = 0;
                        if (d) {
                            for (var h in this._.contents[a.id]) {
                                var j = this._.contents[a.id][h];
                                if (!(j.type == "hbox" || j.type == "vbox" || !j.getInputElement()))
                                    if (j.requiredContent && !this._.editor.activeFilter.check(j.requiredContent)) j.disable();
                                    else {
                                        j.enable();
                                        e++
                                    }
                            }!e || g && !this._.editor.activeFilter.check(g) ? d[0].addClass("cke_dialog_tab_disabled") : d[0].removeClass("cke_dialog_tab_disabled")
                        }
                    }
                CKEDITOR.tools.setTimeout(function() {
                    this.layout();
                    f(this);
                    this.parts.dialog.setStyle("visibility",
                        "");
                    this.fireOnce("load", {});
                    CKEDITOR.ui.fire("ready", this);
                    this.fire("show", {});
                    this._.editor.fire("dialogShow", this);
                    this._.parentDialog || this._.editor.focusManager.lock();
                    this.foreach(function(a) {
                        a.setInitValue && a.setInitValue()
                    })
                }, 100, this)
            },
            layout: function() {
                var a = this.parts.dialog,
                    b = this.getSize(),
                    c = CKEDITOR.document.getWindow().getViewPaneSize(),
                    d = (c.width - b.width) / 2,
                    f = (c.height - b.height) / 2;
                CKEDITOR.env.ie6Compat || (b.height + (f > 0 ? f : 0) > c.height || b.width + (d > 0 ? d : 0) > c.width ? a.setStyle("position",
                    "absolute") : a.setStyle("position", "fixed"));
                this.move(this._.moved ? this._.position.x : d, this._.moved ? this._.position.y : f)
            },
            foreach: function(a) {
                for (var b in this._.contents)
                    for (var c in this._.contents[b]) a.call(this, this._.contents[b][c]);
                return this
            },
            reset: function() {
                var a = function(a) {
                    a.reset && a.reset(1)
                };
                return function() {
                    this.foreach(a);
                    return this
                }
            }(),
            setupContent: function() {
                var a = arguments;
                this.foreach(function(b) {
                    b.setup && b.setup.apply(b, a)
                })
            },
            commitContent: function() {
                var a = arguments;
                this.foreach(function(b) {
                    CKEDITOR.env.ie &&
                        this._.currentFocusIndex == b.focusIndex && b.getInputElement().$.blur();
                    b.commit && b.commit.apply(b, a)
                })
            },
            hide: function() {
                if (this.parts.dialog.isVisible()) {
                    this.fire("hide", {});
                    this._.editor.fire("dialogHide", this);
                    this.selectPage(this._.tabIdList[0]);
                    var a = this._.element;
                    a.setStyle("display", "none");
                    this.parts.dialog.setStyle("visibility", "hidden");
                    for (G(this); CKEDITOR.dialog._.currentTop != this;) CKEDITOR.dialog._.currentTop.hide();
                    if (this._.parentDialog) {
                        var b = this._.parentDialog.getElement().getFirst();
                        b.setStyle("z-index", parseInt(b.$.style.zIndex, 10) + Math.floor(this._.editor.config.baseFloatZIndex / 2))
                    } else q(this._.editor); if (CKEDITOR.dialog._.currentTop = this._.parentDialog) CKEDITOR.dialog._.currentZIndex = CKEDITOR.dialog._.currentZIndex - 10;
                    else {
                        CKEDITOR.dialog._.currentZIndex = null;
                        a.removeListener("keydown", z);
                        a.removeListener("keyup", B);
                        var c = this._.editor;
                        c.focus();
                        setTimeout(function() {
                            c.focusManager.unlock();
                            CKEDITOR.env.iOS && c.window.focus()
                        }, 0)
                    }
                    delete this._.parentDialog;
                    this.foreach(function(a) {
                        a.resetInitValue &&
                            a.resetInitValue()
                    })
                }
            },
            addPage: function(a) {
                if (!a.requiredContent || this._.editor.filter.check(a.requiredContent)) {
                    for (var b = [], c = a.label ? ' title="' + CKEDITOR.tools.htmlEncode(a.label) + '"' : "", d = CKEDITOR.dialog._.uiElementBuilders.vbox.build(this, {
                            type: "vbox",
                            className: "cke_dialog_page_contents",
                            children: a.elements,
                            expand: !! a.expand,
                            padding: a.padding,
                            style: a.style || "width: 100%;"
                        }, b), f = this._.contents[a.id] = {}, g = d.getChild(), e = 0; d = g.shift();) {
                        !d.notAllowed && (d.type != "hbox" && d.type != "vbox") && e++;
                        f[d.id] =
                            d;
                        typeof d.getChild == "function" && g.push.apply(g, d.getChild())
                    }
                    if (!e) a.hidden = true;
                    b = CKEDITOR.dom.element.createFromHtml(b.join(""));
                    b.setAttribute("role", "tabpanel");
                    d = CKEDITOR.env;
                    f = "cke_" + a.id + "_" + CKEDITOR.tools.getNextNumber();
                    c = CKEDITOR.dom.element.createFromHtml(['<a class="cke_dialog_tab"', this._.pageCount > 0 ? " cke_last" : "cke_first", c, a.hidden ? ' style="display:none"' : "", ' id="', f, '"', d.gecko && !d.hc ? "" : ' href="javascript:void(0)"', ' tabIndex="-1" hidefocus="true" role="tab">', a.label, "</a>"].join(""));
                    b.setAttribute("aria-labelledby", f);
                    this._.tabs[a.id] = [c, b];
                    this._.tabIdList.push(a.id);
                    !a.hidden && this._.pageCount++;
                    this._.lastTab = c;
                    this.updateStyle();
                    b.setAttribute("name", a.id);
                    b.appendTo(this.parts.contents);
                    c.unselectable();
                    this.parts.tabs.append(c);
                    if (a.accessKey) {
                        A(this, this, "CTRL+" + a.accessKey, J, D);
                        this._.accessKeyMap["CTRL+" + a.accessKey] = a.id
                    }
                }
            },
            selectPage: function(a) {
                if (this._.currentTabId != a && !this._.tabs[a][0].hasClass("cke_dialog_tab_disabled") && this.fire("selectPage", {
                        page: a,
                        currentPage: this._.currentTabId
                    }) !==
                    false) {
                    for (var c in this._.tabs) {
                        var d = this._.tabs[c][0],
                            f = this._.tabs[c][1];
                        if (c != a) {
                            d.removeClass("cke_dialog_tab_selected");
                            f.hide()
                        }
                        f.setAttribute("aria-hidden", c != a)
                    }
                    var g = this._.tabs[a];
                    g[0].addClass("cke_dialog_tab_selected");
                    if (CKEDITOR.env.ie6Compat || CKEDITOR.env.ie7Compat) {
                        b(g[1]);
                        g[1].show();
                        setTimeout(function() {
                            b(g[1], 1)
                        }, 0)
                    } else g[1].show();
                    this._.currentTabId = a;
                    this._.currentTabIndex = CKEDITOR.tools.indexOf(this._.tabIdList, a)
                }
            },
            updateStyle: function() {
                this.parts.dialog[(this._.pageCount ===
                    1 ? "add" : "remove") + "Class"]("cke_single_page")
            },
            hidePage: function(b) {
                var c = this._.tabs[b] && this._.tabs[b][0];
                if (c && this._.pageCount != 1 && c.isVisible()) {
                    b == this._.currentTabId && this.selectPage(a.call(this));
                    c.hide();
                    this._.pageCount--;
                    this.updateStyle()
                }
            },
            showPage: function(a) {
                if (a = this._.tabs[a] && this._.tabs[a][0]) {
                    a.show();
                    this._.pageCount++;
                    this.updateStyle()
                }
            },
            getElement: function() {
                return this._.element
            },
            getName: function() {
                return this._.name
            },
            getContentElement: function(a, b) {
                var c = this._.contents[a];
                return c && c[b]
            },
            getValueOf: function(a, b) {
                return this.getContentElement(a, b).getValue()
            },
            setValueOf: function(a, b, c) {
                return this.getContentElement(a, b).setValue(c)
            },
            getButton: function(a) {
                return this._.buttons[a]
            },
            click: function(a) {
                return this._.buttons[a].click()
            },
            disableButton: function(a) {
                return this._.buttons[a].disable()
            },
            enableButton: function(a) {
                return this._.buttons[a].enable()
            },
            getPageCount: function() {
                return this._.pageCount
            },
            getParentEditor: function() {
                return this._.editor
            },
            getSelectedElement: function() {
                return this.getParentEditor().getSelection().getSelectedElement()
            },
            addFocusable: function(a, b) {
                if (typeof b == "undefined") {
                    b = this._.focusList.length;
                    this._.focusList.push(new j(this, a, b))
                } else {
                    this._.focusList.splice(b, 0, new j(this, a, b));
                    for (var c = b + 1; c < this._.focusList.length; c++) this._.focusList[c].focusIndex++
                }
            }
        };
        CKEDITOR.tools.extend(CKEDITOR.dialog, {
            add: function(a, b) {
                if (!this._.dialogDefinitions[a] || typeof b == "function") this._.dialogDefinitions[a] = b
            },
            exists: function(a) {
                return !!this._.dialogDefinitions[a]
            },
            getCurrent: function() {
                return CKEDITOR.dialog._.currentTop
            },
            isTabEnabled: function(a, b, c) {
                a = a.config.removeDialogTabs;
                return !(a && a.match(RegExp("(?:^|;)" + b + ":" + c + "(?:$|;)", "i")))
            },
            okButton: function() {
                var a = function(a, b) {
                    b = b || {};
                    return CKEDITOR.tools.extend({
                        id: "ok",
                        type: "button",
                        label: a.lang.common.ok,
                        "class": "cke_dialog_ui_button_ok",
                        onClick: function(a) {
                            a = a.data.dialog;
                            a.fire("ok", {
                                hide: true
                            }).hide !== false && a.hide()
                        }
                    }, b, true)
                };
                a.type = "button";
                a.override = function(b) {
                    return CKEDITOR.tools.extend(function(c) {
                        return a(c, b)
                    }, {
                        type: "button"
                    }, true)
                };
                return a
            }(),
            cancelButton: function() {
                var a = function(a, b) {
                    b = b || {};
                    return CKEDITOR.tools.extend({
                        id: "cancel",
                        type: "button",
                        label: a.lang.common.cancel,
                        "class": "cke_dialog_ui_button_cancel",
                        onClick: function(a) {
                            a = a.data.dialog;
                            a.fire("cancel", {
                                hide: true
                            }).hide !== false && a.hide()
                        }
                    }, b, true)
                };
                a.type = "button";
                a.override = function(b) {
                    return CKEDITOR.tools.extend(function(c) {
                        return a(c, b)
                    }, {
                        type: "button"
                    }, true)
                };
                return a
            }(),
            addUIElement: function(a, b) {
                this._.uiElementBuilders[a] = b
            }
        });
        CKEDITOR.dialog._ = {
            uiElementBuilders: {},
            dialogDefinitions: {},
            currentTop: null,
            currentZIndex: null
        };
        CKEDITOR.event.implementOn(CKEDITOR.dialog);
        CKEDITOR.event.implementOn(CKEDITOR.dialog.prototype);
        var p = {
            resizable: CKEDITOR.DIALOG_RESIZE_BOTH,
            minWidth: 600,
            minHeight: 400,
            buttons: [CKEDITOR.dialog.okButton, CKEDITOR.dialog.cancelButton]
        }, t = function(a, b, c) {
                for (var d = 0, f; f = a[d]; d++) {
                    if (f.id == b) return f;
                    if (c && f[c])
                        if (f = t(f[c], b, c)) return f
                }
                return null
            }, s = function(a, b, c, d, f) {
                if (c) {
                    for (var g = 0, e; e = a[g]; g++) {
                        if (e.id == c) {
                            a.splice(g, 0, b);
                            return b
                        }
                        if (d &&
                            e[d])
                            if (e = s(e[d], b, c, d, true)) return e
                    }
                    if (f) return null
                }
                a.push(b);
                return b
            }, u = function(a, b, c) {
                for (var d = 0, f; f = a[d]; d++) {
                    if (f.id == b) return a.splice(d, 1);
                    if (c && f[c])
                        if (f = u(f[c], b, c)) return f
                }
                return null
            }, w = function(a, b) {
                this.dialog = a;
                for (var c = b.contents, d = 0, f; f = c[d]; d++) c[d] = f && new h(a, f);
                CKEDITOR.tools.extend(this, b)
            };
        w.prototype = {
            getContents: function(a) {
                return t(this.contents, a)
            },
            getButton: function(a) {
                return t(this.buttons, a)
            },
            addContents: function(a, b) {
                return s(this.contents, a, b)
            },
            addButton: function(a,
                b) {
                return s(this.buttons, a, b)
            },
            removeContents: function(a) {
                u(this.contents, a)
            },
            removeButton: function(a) {
                u(this.buttons, a)
            }
        };
        h.prototype = {
            get: function(a) {
                return t(this.elements, a, "children")
            },
            add: function(a, b) {
                return s(this.elements, a, b, "children")
            },
            remove: function(a) {
                u(this.elements, a, "children")
            }
        };
        var x, v = {}, r, y = {}, z = function(a) {
                var b = a.data.$.ctrlKey || a.data.$.metaKey,
                    c = a.data.$.altKey,
                    d = a.data.$.shiftKey,
                    f = String.fromCharCode(a.data.$.keyCode);
                if ((b = y[(b ? "CTRL+" : "") + (c ? "ALT+" : "") + (d ? "SHIFT+" : "") +
                    f]) && b.length) {
                    b = b[b.length - 1];
                    b.keydown && b.keydown.call(b.uiElement, b.dialog, b.key);
                    a.data.preventDefault()
                }
            }, B = function(a) {
                var b = a.data.$.ctrlKey || a.data.$.metaKey,
                    c = a.data.$.altKey,
                    d = a.data.$.shiftKey,
                    f = String.fromCharCode(a.data.$.keyCode);
                if ((b = y[(b ? "CTRL+" : "") + (c ? "ALT+" : "") + (d ? "SHIFT+" : "") + f]) && b.length) {
                    b = b[b.length - 1];
                    if (b.keyup) {
                        b.keyup.call(b.uiElement, b.dialog, b.key);
                        a.data.preventDefault()
                    }
                }
            }, A = function(a, b, c, d, f) {
                (y[c] || (y[c] = [])).push({
                    uiElement: a,
                    dialog: b,
                    key: c,
                    keyup: f || a.accessKeyUp,
                    keydown: d || a.accessKeyDown
                })
            }, G = function(a) {
                for (var b in y) {
                    for (var c = y[b], d = c.length - 1; d >= 0; d--)(c[d].dialog == a || c[d].uiElement == a) && c.splice(d, 1);
                    c.length === 0 && delete y[b]
                }
            }, D = function(a, b) {
                a._.accessKeyMap[b] && a.selectPage(a._.accessKeyMap[b])
            }, J = function() {};
        (function() {
            CKEDITOR.ui.dialog = {
                uiElement: function(a, b, c, d, f, g, e) {
                    if (!(arguments.length < 4)) {
                        var h = (d.call ? d(b) : d) || "div",
                            j = ["<", h, " "],
                            i = (f && f.call ? f(b) : f) || {}, k = (g && g.call ? g(b) : g) || {}, p = (e && e.call ? e.call(this, a, b) : e) || "",
                            s = this.domId = k.id ||
                                CKEDITOR.tools.getNextId() + "_uiElement";
                        if (b.requiredContent && !a.getParentEditor().filter.check(b.requiredContent)) {
                            i.display = "none";
                            this.notAllowed = true
                        }
                        k.id = s;
                        var m = {};
                        b.type && (m["cke_dialog_ui_" + b.type] = 1);
                        b.className && (m[b.className] = 1);
                        if (b.disabled) m.cke_disabled = 1;
                        for (var t = k["class"] && k["class"].split ? k["class"].split(" ") : [], s = 0; s < t.length; s++) t[s] && (m[t[s]] = 1);
                        t = [];
                        for (s in m) t.push(s);
                        k["class"] = t.join(" ");
                        if (b.title) k.title = b.title;
                        m = (b.style || "").split(";");
                        if (b.align) {
                            t = b.align;
                            i["margin-left"] =
                                t == "left" ? 0 : "auto";
                            i["margin-right"] = t == "right" ? 0 : "auto"
                        }
                        for (s in i) m.push(s + ":" + i[s]);
                        b.hidden && m.push("display:none");
                        for (s = m.length - 1; s >= 0; s--) m[s] === "" && m.splice(s, 1);
                        if (m.length > 0) k.style = (k.style ? k.style + "; " : "") + m.join("; ");
                        for (s in k) j.push(s + '="' + CKEDITOR.tools.htmlEncode(k[s]) + '" ');
                        j.push(">", p, "</", h, ">");
                        c.push(j.join(""));
                        (this._ || (this._ = {})).dialog = a;
                        if (typeof b.isChanged == "boolean") this.isChanged = function() {
                            return b.isChanged
                        };
                        if (typeof b.isChanged == "function") this.isChanged = b.isChanged;
                        if (typeof b.setValue == "function") this.setValue = CKEDITOR.tools.override(this.setValue, function(a) {
                            return function(c) {
                                a.call(this, b.setValue.call(this, c))
                            }
                        });
                        if (typeof b.getValue == "function") this.getValue = CKEDITOR.tools.override(this.getValue, function(a) {
                            return function() {
                                return b.getValue.call(this, a.call(this))
                            }
                        });
                        CKEDITOR.event.implementOn(this);
                        this.registerEvents(b);
                        this.accessKeyUp && (this.accessKeyDown && b.accessKey) && A(this, a, "CTRL+" + b.accessKey);
                        var l = this;
                        a.on("load", function() {
                            var b = l.getInputElement();
                            if (b) {
                                var c = l.type in {
                                    checkbox: 1,
                                    ratio: 1
                                } && CKEDITOR.env.ie && CKEDITOR.env.version < 8 ? "cke_dialog_ui_focused" : "";
                                b.on("focus", function() {
                                    a._.tabBarMode = false;
                                    a._.hasFocus = true;
                                    l.fire("focus");
                                    c && this.addClass(c)
                                });
                                b.on("blur", function() {
                                    l.fire("blur");
                                    c && this.removeClass(c)
                                })
                            }
                        });
                        CKEDITOR.tools.extend(this, b);
                        if (this.keyboardFocusable) {
                            this.tabIndex = b.tabIndex || 0;
                            this.focusIndex = a._.focusList.push(this) - 1;
                            this.on("focus", function() {
                                a._.currentFocusIndex = l.focusIndex
                            })
                        }
                    }
                },
                hbox: function(a, b, c, d, f) {
                    if (!(arguments.length <
                        4)) {
                        this._ || (this._ = {});
                        var g = this._.children = b,
                            e = f && f.widths || null,
                            h = f && f.height || null,
                            j, i = {
                                role: "presentation"
                            };
                        f && f.align && (i.align = f.align);
                        CKEDITOR.ui.dialog.uiElement.call(this, a, f || {
                            type: "hbox"
                        }, d, "table", {}, i, function() {
                            var a = ['<tbody><tr class="cke_dialog_ui_hbox">'];
                            for (j = 0; j < c.length; j++) {
                                var b = "cke_dialog_ui_hbox_child",
                                    d = [];
                                j === 0 && (b = "cke_dialog_ui_hbox_first");
                                j == c.length - 1 && (b = "cke_dialog_ui_hbox_last");
                                a.push('<td class="', b, '" role="presentation" ');
                                e ? e[j] && d.push("width:" + m(e[j])) :
                                    d.push("width:" + Math.floor(100 / c.length) + "%");
                                h && d.push("height:" + m(h));
                                f && f.padding !== void 0 && d.push("padding:" + m(f.padding));
                                CKEDITOR.env.ie && (CKEDITOR.env.quirks && g[j].align) && d.push("text-align:" + g[j].align);
                                d.length > 0 && a.push('style="' + d.join("; ") + '" ');
                                a.push(">", c[j], "</td>")
                            }
                            a.push("</tr></tbody>");
                            return a.join("")
                        })
                    }
                },
                vbox: function(a, b, c, d, f) {
                    if (!(arguments.length < 3)) {
                        this._ || (this._ = {});
                        var g = this._.children = b,
                            e = f && f.width || null,
                            h = f && f.heights || null;
                        CKEDITOR.ui.dialog.uiElement.call(this,
                            a, f || {
                                type: "vbox"
                            }, d, "div", null, {
                                role: "presentation"
                            }, function() {
                                var b = ['<table role="presentation" cellspacing="0" border="0" '];
                                b.push('style="');
                                f && f.expand && b.push("height:100%;");
                                b.push("width:" + m(e || "100%"), ";");
                                CKEDITOR.env.webkit && b.push("float:none;");
                                b.push('"');
                                b.push('align="', CKEDITOR.tools.htmlEncode(f && f.align || (a.getParentEditor().lang.dir == "ltr" ? "left" : "right")), '" ');
                                b.push("><tbody>");
                                for (var d = 0; d < c.length; d++) {
                                    var j = [];
                                    b.push('<tr><td role="presentation" ');
                                    e && j.push("width:" +
                                        m(e || "100%"));
                                    h ? j.push("height:" + m(h[d])) : f && f.expand && j.push("height:" + Math.floor(100 / c.length) + "%");
                                    f && f.padding !== void 0 && j.push("padding:" + m(f.padding));
                                    CKEDITOR.env.ie && (CKEDITOR.env.quirks && g[d].align) && j.push("text-align:" + g[d].align);
                                    j.length > 0 && b.push('style="', j.join("; "), '" ');
                                    b.push(' class="cke_dialog_ui_vbox_child">', c[d], "</td></tr>")
                                }
                                b.push("</tbody></table>");
                                return b.join("")
                            })
                    }
                }
            }
        })();
        CKEDITOR.ui.dialog.uiElement.prototype = {
            getElement: function() {
                return CKEDITOR.document.getById(this.domId)
            },
            getInputElement: function() {
                return this.getElement()
            },
            getDialog: function() {
                return this._.dialog
            },
            setValue: function(a, b) {
                this.getInputElement().setValue(a);
                !b && this.fire("change", {
                    value: a
                });
                return this
            },
            getValue: function() {
                return this.getInputElement().getValue()
            },
            isChanged: function() {
                return false
            },
            selectParentTab: function() {
                for (var a = this.getInputElement();
                    (a = a.getParent()) && a.$.className.search("cke_dialog_page_contents") == -1;);
                if (!a) return this;
                a = a.getAttribute("name");
                this._.dialog._.currentTabId !=
                    a && this._.dialog.selectPage(a);
                return this
            },
            focus: function() {
                this.selectParentTab().getInputElement().focus();
                return this
            },
            registerEvents: function(a) {
                var b = /^on([A-Z]\w+)/,
                    c, d = function(a, b, c, d) {
                        b.on("load", function() {
                            a.getInputElement().on(c, d, a)
                        })
                    }, f;
                for (f in a)
                    if (c = f.match(b)) this.eventProcessors[f] ? this.eventProcessors[f].call(this, this._.dialog, a[f]) : d(this, this._.dialog, c[1].toLowerCase(), a[f]);
                return this
            },
            eventProcessors: {
                onLoad: function(a, b) {
                    a.on("load", b, this)
                },
                onShow: function(a, b) {
                    a.on("show",
                        b, this)
                },
                onHide: function(a, b) {
                    a.on("hide", b, this)
                }
            },
            accessKeyDown: function() {
                this.focus()
            },
            accessKeyUp: function() {},
            disable: function() {
                var a = this.getElement();
                this.getInputElement().setAttribute("disabled", "true");
                a.addClass("cke_disabled")
            },
            enable: function() {
                var a = this.getElement();
                this.getInputElement().removeAttribute("disabled");
                a.removeClass("cke_disabled")
            },
            isEnabled: function() {
                return !this.getElement().hasClass("cke_disabled")
            },
            isVisible: function() {
                return this.getInputElement().isVisible()
            },
            isFocusable: function() {
                return !this.isEnabled() || !this.isVisible() ? false : true
            }
        };
        CKEDITOR.ui.dialog.hbox.prototype = CKEDITOR.tools.extend(new CKEDITOR.ui.dialog.uiElement, {
            getChild: function(a) {
                if (arguments.length < 1) return this._.children.concat();
                a.splice || (a = [a]);
                return a.length < 2 ? this._.children[a[0]] : this._.children[a[0]] && this._.children[a[0]].getChild ? this._.children[a[0]].getChild(a.slice(1, a.length)) : null
            }
        }, true);
        CKEDITOR.ui.dialog.vbox.prototype = new CKEDITOR.ui.dialog.hbox;
        (function() {
            var a = {
                build: function(a, b, c) {
                    for (var d = b.children, f, g = [], e = [], h = 0; h < d.length && (f = d[h]); h++) {
                        var j = [];
                        g.push(j);
                        e.push(CKEDITOR.dialog._.uiElementBuilders[f.type].build(a, f, j))
                    }
                    return new CKEDITOR.ui.dialog[b.type](a, e, g, c, b)
                }
            };
            CKEDITOR.dialog.addUIElement("hbox", a);
            CKEDITOR.dialog.addUIElement("vbox", a)
        })();
        CKEDITOR.dialogCommand = function(a, b) {
            this.dialogName = a;
            CKEDITOR.tools.extend(this, b, true)
        };
        CKEDITOR.dialogCommand.prototype = {
            exec: function(a) {
                a.openDialog(this.dialogName)
            },
            canUndo: false,
            editorFocus: 1
        };
        (function() {
            var a = /^([a]|[^a])+$/,
                b = /^\d*$/,
                c = /^\d*(?:\.\d+)?$/,
                d = /^(((\d*(\.\d+))|(\d*))(px|\%)?)?$/,
                f = /^(((\d*(\.\d+))|(\d*))(px|em|ex|in|cm|mm|pt|pc|\%)?)?$/i,
                g = /^(\s*[\w-]+\s*:\s*[^:;]+(?:;|$))*$/;
            CKEDITOR.VALIDATE_OR = 1;
            CKEDITOR.VALIDATE_AND = 2;
            CKEDITOR.dialog.validate = {
                functions: function() {
                    var a = arguments;
                    return function() {
                        var b = this && this.getValue ? this.getValue() : a[0],
                            c, d = CKEDITOR.VALIDATE_AND,
                            f = [],
                            g;
                        for (g = 0; g < a.length; g++)
                            if (typeof a[g] == "function") f.push(a[g]);
                            else break;
                        if (g < a.length && typeof a[g] ==
                            "string") {
                            c = a[g];
                            g++
                        }
                        g < a.length && typeof a[g] == "number" && (d = a[g]);
                        var e = d == CKEDITOR.VALIDATE_AND ? true : false;
                        for (g = 0; g < f.length; g++) e = d == CKEDITOR.VALIDATE_AND ? e && f[g](b) : e || f[g](b);
                        return !e ? c : true
                    }
                },
                regex: function(a, b) {
                    return function(c) {
                        c = this && this.getValue ? this.getValue() : c;
                        return !a.test(c) ? b : true
                    }
                },
                notEmpty: function(b) {
                    return this.regex(a, b)
                },
                integer: function(a) {
                    return this.regex(b, a)
                },
                number: function(a) {
                    return this.regex(c, a)
                },
                cssLength: function(a) {
                    return this.functions(function(a) {
                            return f.test(CKEDITOR.tools.trim(a))
                        },
                        a)
                },
                htmlLength: function(a) {
                    return this.functions(function(a) {
                        return d.test(CKEDITOR.tools.trim(a))
                    }, a)
                },
                inlineStyle: function(a) {
                    return this.functions(function(a) {
                        return g.test(CKEDITOR.tools.trim(a))
                    }, a)
                },
                equals: function(a, b) {
                    return this.functions(function(b) {
                        return b == a
                    }, b)
                },
                notEqual: function(a, b) {
                    return this.functions(function(b) {
                        return b != a
                    }, b)
                }
            };
            CKEDITOR.on("instanceDestroyed", function(a) {
                if (CKEDITOR.tools.isEmpty(CKEDITOR.instances)) {
                    for (var b; b = CKEDITOR.dialog._.currentTop;) b.hide();
                    for (var c in v) v[c].remove();
                    v = {}
                }
                var a = a.editor._.storedDialogs,
                    d;
                for (d in a) a[d].destroy()
            })
        })();
        CKEDITOR.tools.extend(CKEDITOR.editor.prototype, {
            openDialog: function(a, b) {
                var c = null,
                    d = CKEDITOR.dialog._.dialogDefinitions[a];
                CKEDITOR.dialog._.currentTop === null && o(this);
                if (typeof d == "function") {
                    c = this._.storedDialogs || (this._.storedDialogs = {});
                    c = c[a] || (c[a] = new CKEDITOR.dialog(this, a));
                    b && b.call(c, c);
                    c.show()
                } else {
                    if (d == "failed") {
                        q(this);
                        throw Error('[CKEDITOR.dialog.openDialog] Dialog "' + a + '" failed when loading definition.');
                    }
                    typeof d == "string" && CKEDITOR.scriptLoader.load(CKEDITOR.getUrl(d), function() {
                        typeof CKEDITOR.dialog._.dialogDefinitions[a] != "function" && (CKEDITOR.dialog._.dialogDefinitions[a] = "failed");
                        this.openDialog(a, b)
                    }, this, 0, 1)
                }
                CKEDITOR.skin.loadPart("dialog");
                return c
            }
        })
    }(), CKEDITOR.plugins.add("dialog", {
        requires: "dialogui",
        init: function(a) {
            a.on("doubleclick", function(e) {
                e.data.dialog && a.openDialog(e.data.dialog)
            }, null, null, 999)
        }
    }),
    function() {
        CKEDITOR.plugins.add("a11yhelp", {
            requires: "dialog",
            availableLangs: {
                af: 1,
                ar: 1,
                bg: 1,
                ca: 1,
                cs: 1,
                cy: 1,
                da: 1,
                de: 1,
                el: 1,
                en: 1,
                "en-gb": 1,
                eo: 1,
                es: 1,
                et: 1,
                fa: 1,
                fi: 1,
                fr: 1,
                "fr-ca": 1,
                gl: 1,
                gu: 1,
                he: 1,
                hi: 1,
                hr: 1,
                hu: 1,
                id: 1,
                it: 1,
                ja: 1,
                km: 1,
                ko: 1,
                ku: 1,
                lt: 1,
                lv: 1,
                mk: 1,
                mn: 1,
                nb: 1,
                nl: 1,
                no: 1,
                pl: 1,
                pt: 1,
                "pt-br": 1,
                ro: 1,
                ru: 1,
                si: 1,
                sk: 1,
                sl: 1,
                sq: 1,
                sr: 1,
                "sr-latn": 1,
                sv: 1,
                th: 1,
                tr: 1,
                tt: 1,
                ug: 1,
                uk: 1,
                vi: 1,
                zh: 1,
                "zh-cn": 1
            },
            init: function(a) {
                var e = this;
                a.addCommand("a11yHelp", {
                    exec: function() {
                        var b = a.langCode,
                            b = e.availableLangs[b] ? b : e.availableLangs[b.replace(/-.*/, "")] ? b.replace(/-.*/, "") : "en";
                        CKEDITOR.scriptLoader.load(CKEDITOR.getUrl(e.path +
                            "dialogs/lang/" + b + ".js"), function() {
                            a.lang.a11yhelp = e.langEntries[b];
                            a.openDialog("a11yHelp")
                        })
                    },
                    modes: {
                        wysiwyg: 1,
                        source: 1
                    },
                    readOnly: 1,
                    canUndo: false
                });
                a.setKeystroke(CKEDITOR.ALT + 48, "a11yHelp");
                CKEDITOR.dialog.add("a11yHelp", this.path + "dialogs/a11yhelp.js");
                a.on("ariaEditorHelpLabel", function(b) {
                    b.data.label = a.lang.common.editorHelp
                })
            }
        })
    }(), CKEDITOR.plugins.add("about", {
        requires: "dialog",
        init: function(a) {
            var e = a.addCommand("about", new CKEDITOR.dialogCommand("about"));
            e.modes = {
                wysiwyg: 1,
                source: 1
            };
            e.canUndo = false;
            e.readOnly = 1;
            a.ui.addButton && a.ui.addButton("About", {
                label: a.lang.about.title,
                command: "about",
                toolbar: "about"
            });
            CKEDITOR.dialog.add("about", this.path + "dialogs/about.js")
        }
    }), CKEDITOR.plugins.add("basicstyles", {
        init: function(a) {
            var e = 0,
                b = function(b, c, d, i) {
                    if (i) {
                        var i = new CKEDITOR.style(i),
                            k = g[d];
                        k.unshift(i);
                        a.attachStyleStateChange(i, function(b) {
                            !a.readOnly && a.getCommand(d).setState(b)
                        });
                        a.addCommand(d, new CKEDITOR.styleCommand(i, {
                            contentForms: k
                        }));
                        a.ui.addButton && a.ui.addButton(b, {
                            label: c,
                            command: d,
                            toolbar: "basicstyles," + (e = e + 10)
                        })
                    }
                }, g = {
                    bold: ["strong", "b", ["span",
                        function(a) {
                            a = a.styles["font-weight"];
                            return a == "bold" || +a >= 700
                        }
                    ]],
                    italic: ["em", "i", ["span",
                        function(a) {
                            return a.styles["font-style"] == "italic"
                        }
                    ]],
                    underline: ["u", ["span",
                        function(a) {
                            return a.styles["text-decoration"] == "underline"
                        }
                    ]],
                    strike: ["s", "strike", ["span",
                        function(a) {
                            return a.styles["text-decoration"] == "line-through"
                        }
                    ]],
                    subscript: ["sub"],
                    superscript: ["sup"]
                }, c = a.config,
                d = a.lang.basicstyles;
            b("Bold", d.bold, "bold",
                c.coreStyles_bold);
            b("Italic", d.italic, "italic", c.coreStyles_italic);
            b("Underline", d.underline, "underline", c.coreStyles_underline);
            b("Strike", d.strike, "strike", c.coreStyles_strike);
            b("Subscript", d.subscript, "subscript", c.coreStyles_subscript);
            b("Superscript", d.superscript, "superscript", c.coreStyles_superscript);
            a.setKeystroke([
                [CKEDITOR.CTRL + 66, "bold"],
                [CKEDITOR.CTRL + 73, "italic"],
                [CKEDITOR.CTRL + 85, "underline"]
            ])
        }
    }), CKEDITOR.config.coreStyles_bold = {
        element: "strong",
        overrides: "b"
    }, CKEDITOR.config.coreStyles_italic = {
        element: 'span',
        attributes: { 'style': 'font-style: italic;' },
        overrides: 'em'
    }, CKEDITOR.config.coreStyles_underline = {
        element: "u"
    }, CKEDITOR.config.coreStyles_strike = {
        element: "s",
        overrides: "strike"
    }, CKEDITOR.config.coreStyles_subscript = {
        element: "sub"
    }, CKEDITOR.config.coreStyles_superscript = {
        element: "sup"
    },
    function() {
        var a = {
            exec: function(a) {
                var b = a.getCommand("blockquote").state,
                    g = a.getSelection(),
                    c = g && g.getRanges()[0];
                if (c) {
                    var d = g.createBookmarks();
                    if (CKEDITOR.env.ie) {
                        var j = d[0].startNode,
                            f = d[0].endNode,
                            h;
                        if (j && j.getParent().getName() == "blockquote")
                            for (h =
                                j; h = h.getNext();)
                                if (h.type == CKEDITOR.NODE_ELEMENT && h.isBlockBoundary()) {
                                    j.move(h, true);
                                    break
                                }
                        if (f && f.getParent().getName() == "blockquote")
                            for (h = f; h = h.getPrevious();)
                                if (h.type == CKEDITOR.NODE_ELEMENT && h.isBlockBoundary()) {
                                    f.move(h);
                                    break
                                }
                    }
                    var i = c.createIterator();
                    i.enlargeBr = a.config.enterMode != CKEDITOR.ENTER_BR;
                    if (b == CKEDITOR.TRISTATE_OFF) {
                        for (j = []; b = i.getNextParagraph();) j.push(b);
                        if (j.length < 1) {
                            b = a.document.createElement(a.config.enterMode == CKEDITOR.ENTER_P ? "p" : "div");
                            f = d.shift();
                            c.insertNode(b);
                            b.append(new CKEDITOR.dom.text("﻿", a.document));
                            c.moveToBookmark(f);
                            c.selectNodeContents(b);
                            c.collapse(true);
                            f = c.createBookmark();
                            j.push(b);
                            d.unshift(f)
                        }
                        h = j[0].getParent();
                        c = [];
                        for (f = 0; f < j.length; f++) {
                            b = j[f];
                            h = h.getCommonAncestor(b.getParent())
                        }
                        for (b = {
                            table: 1,
                            tbody: 1,
                            tr: 1,
                            ol: 1,
                            ul: 1
                        }; b[h.getName()];) h = h.getParent();
                        for (f = null; j.length > 0;) {
                            for (b = j.shift(); !b.getParent().equals(h);) b = b.getParent();
                            b.equals(f) || c.push(b);
                            f = b
                        }
                        for (; c.length > 0;) {
                            b = c.shift();
                            if (b.getName() == "blockquote") {
                                for (f = new CKEDITOR.dom.documentFragment(a.document); b.getFirst();) {
                                    f.append(b.getFirst().remove());
                                    j.push(f.getLast())
                                }
                                f.replace(b)
                            } else j.push(b)
                        }
                        c = a.document.createElement("blockquote");
                        for (c.insertBefore(j[0]); j.length > 0;) {
                            b = j.shift();
                            c.append(b)
                        }
                    } else if (b == CKEDITOR.TRISTATE_ON) {
                        f = [];
                        for (h = {}; b = i.getNextParagraph();) {
                            for (j = c = null; b.getParent();) {
                                if (b.getParent().getName() == "blockquote") {
                                    c = b.getParent();
                                    j = b;
                                    break
                                }
                                b = b.getParent()
                            }
                            if (c && j && !j.getCustomData("blockquote_moveout")) {
                                f.push(j);
                                CKEDITOR.dom.element.setMarker(h, j, "blockquote_moveout", true)
                            }
                        }
                        CKEDITOR.dom.element.clearAllMarkers(h);
                        b = [];
                        j = [];
                        for (h = {}; f.length > 0;) {
                            i = f.shift();
                            c = i.getParent();
                            if (i.getPrevious())
                                if (i.getNext()) {
                                    i.breakParent(i.getParent());
                                    j.push(i.getNext())
                                } else i.remove().insertAfter(c);
                                else i.remove().insertBefore(c);
                            if (!c.getCustomData("blockquote_processed")) {
                                j.push(c);
                                CKEDITOR.dom.element.setMarker(h, c, "blockquote_processed", true)
                            }
                            b.push(i)
                        }
                        CKEDITOR.dom.element.clearAllMarkers(h);
                        for (f = j.length - 1; f >= 0; f--) {
                            c = j[f];
                            a: {
                                h = c;
                                for (var i = 0, k = h.getChildCount(), n = void 0; i < k && (n = h.getChild(i)); i++)
                                    if (n.type == CKEDITOR.NODE_ELEMENT &&
                                        n.isBlockBoundary()) {
                                        h = false;
                                        break a
                                    }
                                h = true
                            }
                            h && c.remove()
                        }
                        if (a.config.enterMode == CKEDITOR.ENTER_BR)
                            for (c = true; b.length;) {
                                i = b.shift();
                                if (i.getName() == "div") {
                                    f = new CKEDITOR.dom.documentFragment(a.document);
                                    c && (i.getPrevious() && !(i.getPrevious().type == CKEDITOR.NODE_ELEMENT && i.getPrevious().isBlockBoundary())) && f.append(a.document.createElement("br"));
                                    for (c = i.getNext() && !(i.getNext().type == CKEDITOR.NODE_ELEMENT && i.getNext().isBlockBoundary()); i.getFirst();) i.getFirst().remove().appendTo(f);
                                    c && f.append(a.document.createElement("br"));
                                    f.replace(i);
                                    c = false
                                }
                            }
                    }
                    g.selectBookmarks(d);
                    a.focus()
                }
            },
            refresh: function(a, b) {
                this.setState(a.elementPath(b.block || b.blockLimit).contains("blockquote", 1) ? CKEDITOR.TRISTATE_ON : CKEDITOR.TRISTATE_OFF)
            },
            context: "blockquote",
            allowedContent: "blockquote",
            requiredContent: "blockquote"
        };
        CKEDITOR.plugins.add("blockquote", {
            init: function(e) {
                if (!e.blockless) {
                    e.addCommand("blockquote", a);
                    e.ui.addButton && e.ui.addButton("Blockquote", {
                        label: e.lang.blockquote.toolbar,
                        command: "blockquote",
                        toolbar: "blocks,10"
                    })
                }
            }
        })
    }(),
        "use strict",
    function() {
        function a(a) {
            function b() {
                var c = a.editable();
                c.on(y, function(a) {
                    (!CKEDITOR.env.ie || !x) && s(a)
                });
                CKEDITOR.env.ie && c.on("paste", function(b) {
                    if (!v) {
                        g();
                        b.data.preventDefault();
                        s(b);
                        o("paste") || a.openDialog("paste")
                    }
                });
                if (CKEDITOR.env.ie) {
                    c.on("contextmenu", e, null, null, 0);
                    c.on("beforepaste", function(a) {
                        a.data && (!a.data.$.ctrlKey && !a.data.$.shiftKey) && e()
                    }, null, null, 0)
                }
                c.on("beforecut", function() {
                    !x && m(a)
                });
                var d;
                c.attachListener(CKEDITOR.env.ie ? c : a.document.getDocumentElement(),
                    "mouseup", function() {
                        d = setTimeout(function() {
                            u()
                        }, 0)
                    });
                a.on("destroy", function() {
                    clearTimeout(d)
                });
                c.on("keyup", u)
            }

            function c(b) {
                return {
                    type: b,
                    canUndo: b == "cut",
                    startDisabled: true,
                    exec: function() {
                        this.type == "cut" && m();
                        var b;
                        var c = this.type;
                        if (CKEDITOR.env.ie) b = o(c);
                        else try {
                            b = a.document.$.execCommand(c, false, null)
                        } catch (d) {
                            b = false
                        }
                        b || alert(a.lang.clipboard[this.type + "Error"]);
                        return b
                    }
                }
            }

            function d() {
                return {
                    canUndo: false,
                    async: true,
                    exec: function(a, b) {
                        var c = function(b, c) {
                            b && q(b.type, b.dataValue, !! c);
                            a.fire("afterCommandExec", {
                                name: "paste",
                                command: d,
                                returnValue: !! b
                            })
                        }, d = this;
                        typeof b == "string" ? c({
                            type: "auto",
                            dataValue: b
                        }, 1) : a.getClipboardData(c)
                    }
                }
            }

            function g() {
                v = 1;
                setTimeout(function() {
                    v = 0
                }, 100)
            }

            function e() {
                x = 1;
                setTimeout(function() {
                    x = 0
                }, 10)
            }

            function o(b) {
                var c = a.document,
                    d = c.getBody(),
                    f = false,
                    g = function() {
                        f = true
                    };
                d.on(b, g);
                (CKEDITOR.env.version > 7 ? c.$ : c.$.selection.createRange()).execCommand(b);
                d.removeListener(b, g);
                return f
            }

            function q(b, c, d) {
                b = {
                    type: b
                };
                if (d && a.fire("beforePaste", b) === false || !c) return false;
                b.dataValue = c;
                return a.fire("paste", b)
            }

            function m() {
                if (CKEDITOR.env.ie && !CKEDITOR.env.quirks) {
                    var b = a.getSelection(),
                        c, d, f;
                    if (b.getType() == CKEDITOR.SELECTION_ELEMENT && (c = b.getSelectedElement())) {
                        d = b.getRanges()[0];
                        f = a.document.createText("");
                        f.insertBefore(c);
                        d.setStartBefore(f);
                        d.setEndAfter(c);
                        b.selectRanges([d]);
                        setTimeout(function() {
                            if (c.getParent()) {
                                f.remove();
                                b.selectElement(c)
                            }
                        }, 0)
                    }
                }
            }

            function l(b, c) {
                var d = a.document,
                    f = a.editable(),
                    g = function(a) {
                        a.cancel()
                    }, e;
                if (!d.getById("cke_pastebin")) {
                    var h =
                        a.getSelection(),
                        i = h.createBookmarks();
                    CKEDITOR.env.ie && h.root.fire("selectionchange");
                    var k = new CKEDITOR.dom.element((CKEDITOR.env.webkit || f.is("body")) && !CKEDITOR.env.ie ? "body" : "div", d);
                    k.setAttributes({
                        id: "cke_pastebin",
                        "data-cke-temp": "1"
                    });
                    var s = 0,
                        d = d.getWindow();
                    if (CKEDITOR.env.webkit) {
                        f.append(k);
                        k.addClass("cke_editable");
                        if (!f.is("body")) {
                            s = f.getComputedStyle("position") != "static" ? f : CKEDITOR.dom.element.get(f.$.offsetParent);
                            s = s.getDocumentPosition().y
                        }
                    } else f.getAscendant(CKEDITOR.env.ie ?
                        "body" : "html", 1).append(k);
                    k.setStyles({
                        position: "absolute",
                        top: d.getScrollPosition().y - s + 10 + "px",
                        width: "1px",
                        height: Math.max(1, d.getViewPaneSize().height - 20) + "px",
                        overflow: "hidden",
                        margin: 0,
                        padding: 0
                    });
                    CKEDITOR.env.safari && k.setStyles(CKEDITOR.tools.cssVendorPrefix("user-select", "text"));
                    if (s = k.getParent().isReadOnly()) {
                        k.setOpacity(0);
                        k.setAttribute("contenteditable", true)
                    } else k.setStyle(a.config.contentsLangDirection == "ltr" ? "left" : "right", "-1000px");
                    a.on("selectionChange", g, null, null, 0);
                    if (CKEDITOR.env.webkit ||
                        CKEDITOR.env.gecko) e = f.once("blur", g, null, null, -100);
                    s && k.focus();
                    s = new CKEDITOR.dom.range(k);
                    s.selectNodeContents(k);
                    var p = s.select();
                    CKEDITOR.env.ie && (e = f.once("blur", function() {
                        a.lockSelection(p)
                    }));
                    var m = CKEDITOR.document.getWindow().getScrollPosition().y;
                    setTimeout(function() {
                        if (CKEDITOR.env.webkit) CKEDITOR.document.getBody().$.scrollTop = m;
                        e && e.removeListener();
                        CKEDITOR.env.ie && f.focus();
                        h.selectBookmarks(i);
                        k.remove();
                        var b;
                        if (CKEDITOR.env.webkit && (b = k.getFirst()) && b.is && b.hasClass("Apple-style-span")) k =
                            b;
                        a.removeListener("selectionChange", g);
                        c(k.getHtml())
                    }, 0)
                }
            }

            function p() {
                if (CKEDITOR.env.ie) {
                    a.focus();
                    g();
                    var b = a.focusManager;
                    b.lock();
                    if (a.editable().fire(y) && !o("paste")) {
                        b.unlock();
                        return false
                    }
                    b.unlock()
                } else try {
                    if (a.editable().fire(y) && !a.document.$.execCommand("Paste", false, null)) throw 0;
                } catch (c) {
                    return false
                }
                return true
            }

            function t(b) {
                if (a.mode == "wysiwyg") switch (b.data.keyCode) {
                    case CKEDITOR.CTRL + 86:
                    case CKEDITOR.SHIFT + 45:
                        b = a.editable();
                        g();
                        !CKEDITOR.env.ie && b.fire("beforepaste");
                        break;
                    case CKEDITOR.CTRL + 88:
                    case CKEDITOR.SHIFT + 46:
                        a.fire("saveSnapshot");
                        setTimeout(function() {
                            a.fire("saveSnapshot")
                        }, 50)
                }
            }

            function s(b) {
                var c = {
                    type: "auto"
                }, d = a.fire("beforePaste", c);
                l(b, function(a) {
                    a = a.replace(/<span[^>]+data-cke-bookmark[^<]*?<\/span>/ig, "");
                    d && q(c.type, a, 0, 1)
                })
            }

            function u() {
                if (a.mode == "wysiwyg") {
                    var b = w("paste");
                    a.getCommand("cut").setState(w("cut"));
                    a.getCommand("copy").setState(w("copy"));
                    a.getCommand("paste").setState(b);
                    a.fire("pasteState", b)
                }
            }

            function w(b) {
                if (r && b in {
                    paste: 1,
                    cut: 1
                }) return CKEDITOR.TRISTATE_DISABLED;
                if (b == "paste") return CKEDITOR.TRISTATE_OFF;
                var b = a.getSelection(),
                    c = b.getRanges();
                return b.getType() == CKEDITOR.SELECTION_NONE || c.length == 1 && c[0].collapsed ? CKEDITOR.TRISTATE_DISABLED : CKEDITOR.TRISTATE_OFF
            }
            var x = 0,
                v = 0,
                r = 0,
                y = CKEDITOR.env.ie ? "beforepaste" : "paste";
            (function() {
                a.on("key", t);
                a.on("contentDom", b);
                a.on("selectionChange", function(a) {
                    r = a.data.selection.getRanges()[0].checkReadOnly();
                    u()
                });
                a.contextMenu && a.contextMenu.addListener(function(a, b) {
                    r = b.getRanges()[0].checkReadOnly();
                    return {
                        cut: w("cut"),
                        copy: w("copy"),
                        paste: w("paste")
                    }
                })
            })();
            (function() {
                function b(c, d, f, g, e) {
                    var h = a.lang.clipboard[d];
                    a.addCommand(d, f);
                    a.ui.addButton && a.ui.addButton(c, {
                        label: h,
                        command: d,
                        toolbar: "clipboard," + g
                    });
                    a.addMenuItems && a.addMenuItem(d, {
                        label: h,
                        command: d,
                        group: "clipboard",
                        order: e
                    })
                }
                b("Cut", "cut", c("cut"), 10, 1);
                b("Copy", "copy", c("copy"), 20, 4);
                b("Paste", "paste", d(), 30, 8)
            })();
            a.getClipboardData = function(b, c) {
                function d(a) {
                    a.removeListener();
                    a.cancel();
                    c(a.data)
                }

                function f(a) {
                    a.removeListener();
                    a.cancel();
                    i = true;
                    c({
                        type: h,
                        dataValue: a.data
                    })
                }

                function g() {
                    this.customTitle = b && b.title
                }
                var e = false,
                    h = "auto",
                    i = false;
                if (!c) {
                    c = b;
                    b = null
                }
                a.on("paste", d, null, null, 0);
                a.on("beforePaste", function(a) {
                    a.removeListener();
                    e = true;
                    h = a.data.type
                }, null, null, 1E3);
                if (p() === false) {
                    a.removeListener("paste", d);
                    if (e && a.fire("pasteDialog", g)) {
                        a.on("pasteDialogCommit", f);
                        a.on("dialogHide", function(a) {
                            a.removeListener();
                            a.data.removeListener("pasteDialogCommit", f);
                            setTimeout(function() {
                                i || c(null)
                            }, 10)
                        })
                    } else c(null)
                }
            }
        }

        function e(a) {
            if (CKEDITOR.env.webkit) {
                if (!a.match(/^[^<]*$/g) && !a.match(/^(<div><br( ?\/)?><\/div>|<div>[^<]*<\/div>)*$/gi)) return "html"
            } else if (CKEDITOR.env.ie) {
                if (!a.match(/^([^<]|<br( ?\/)?>)*$/gi) && !a.match(/^(<p>([^<]|<br( ?\/)?>)*<\/p>|(\r\n))*$/gi)) return "html"
            } else if (CKEDITOR.env.gecko) {
                if (!a.match(/^([^<]|<br( ?\/)?>)*$/gi)) return "html"
            } else return "html";
            return "htmlifiedtext"
        }

        function b(a, b) {
            function c(a) {
                return CKEDITOR.tools.repeat("</p><p>", ~~ (a / 2)) + (a % 2 == 1 ? "<br>" : "")
            }
            b = b.replace(/\s+/g,
                " ").replace(/> +</g, "><").replace(/<br ?\/>/gi, "<br>");
            b = b.replace(/<\/?[A-Z]+>/g, function(a) {
                return a.toLowerCase()
            });
            if (b.match(/^[^<]$/)) return b;
            if (CKEDITOR.env.webkit && b.indexOf("<div>") > -1) {
                b = b.replace(/^(<div>(<br>|)<\/div>)(?!$|(<div>(<br>|)<\/div>))/g, "<br>").replace(/^(<div>(<br>|)<\/div>){2}(?!$)/g, "<div></div>");
                b.match(/<div>(<br>|)<\/div>/) && (b = "<p>" + b.replace(/(<div>(<br>|)<\/div>)+/g, function(a) {
                    return c(a.split("</div><div>").length + 1)
                }) + "</p>");
                b = b.replace(/<\/div><div>/g, "<br>");
                b = b.replace(/<\/?div>/g, "")
            }
            if (CKEDITOR.env.gecko && a.enterMode != CKEDITOR.ENTER_BR) {
                CKEDITOR.env.gecko && (b = b.replace(/^<br><br>$/, "<br>"));
                b.indexOf("<br><br>") > -1 && (b = "<p>" + b.replace(/(<br>){2,}/g, function(a) {
                    return c(a.length / 4)
                }) + "</p>")
            }
            return d(a, b)
        }

        function g() {
            var a = new CKEDITOR.htmlParser.filter,
                b = {
                    blockquote: 1,
                    dl: 1,
                    fieldset: 1,
                    h1: 1,
                    h2: 1,
                    h3: 1,
                    h4: 1,
                    h5: 1,
                    h6: 1,
                    ol: 1,
                    p: 1,
                    table: 1,
                    ul: 1
                }, c = CKEDITOR.tools.extend({
                    br: 0
                }, CKEDITOR.dtd.$inline),
                d = {
                    p: 1,
                    br: 1,
                    "cke:br": 1
                }, g = CKEDITOR.dtd,
                e = CKEDITOR.tools.extend({
                    area: 1,
                    basefont: 1,
                    embed: 1,
                    iframe: 1,
                    map: 1,
                    object: 1,
                    param: 1
                }, CKEDITOR.dtd.$nonBodyContent, CKEDITOR.dtd.$cdata),
                o = function(a) {
                    delete a.name;
                    a.add(new CKEDITOR.htmlParser.text(" "))
                }, q = function(a) {
                    for (var b = a, c;
                        (b = b.next) && b.name && b.name.match(/^h\d$/);) {
                        c = new CKEDITOR.htmlParser.element("cke:br");
                        c.isEmpty = true;
                        for (a.add(c); c = b.children.shift();) a.add(c)
                    }
                };
            a.addRules({
                elements: {
                    h1: q,
                    h2: q,
                    h3: q,
                    h4: q,
                    h5: q,
                    h6: q,
                    img: function(a) {
                        var a = CKEDITOR.tools.trim(a.attributes.alt || ""),
                            b = " ";
                        a && !a.match(/(^http|\.(jpe?g|gif|png))/i) &&
                            (b = " [" + a + "] ");
                        return new CKEDITOR.htmlParser.text(b)
                    },
                    td: o,
                    th: o,
                    $: function(a) {
                        var j = a.name,
                            p;
                        if (e[j]) return false;
                        a.attributes = {};
                        if (j == "br") return a;
                        if (b[j]) a.name = "p";
                        else if (c[j]) delete a.name;
                        else if (g[j]) {
                            p = new CKEDITOR.htmlParser.element("cke:br");
                            p.isEmpty = true;
                            if (CKEDITOR.dtd.$empty[j]) return p;
                            a.add(p, 0);
                            p = p.clone();
                            p.isEmpty = true;
                            a.add(p);
                            delete a.name
                        }
                        d[a.name] || delete a.name;
                        return a
                    }
                }
            }, {
                applyToAll: true
            });
            return a
        }

        function c(a, b, c) {
            var b = new CKEDITOR.htmlParser.fragment.fromHtml(b),
                g = new CKEDITOR.htmlParser.basicWriter;
            b.writeHtml(g, c);
            var b = g.getHtml(),
                b = b.replace(/\s*(<\/?[a-z:]+ ?\/?>)\s*/g, "$1").replace(/(<cke:br \/>){2,}/g, "<cke:br />").replace(/(<cke:br \/>)(<\/?p>|<br \/>)/g, "$2").replace(/(<\/?p>|<br \/>)(<cke:br \/>)/g, "$1").replace(/<(cke:)?br( \/)?>/g, "<br>").replace(/<p><\/p>/g, ""),
                e = 0,
                b = b.replace(/<\/?p>/g, function(a) {
                    if (a == "<p>") {
                        if (++e > 1) return "</p><p>"
                    } else if (--e > 0) return "</p><p>";
                    return a
                }).replace(/<p><\/p>/g, "");
            return d(a, b)
        }

        function d(a, b) {
            a.enterMode ==
                CKEDITOR.ENTER_BR ? b = b.replace(/(<\/p><p>)+/g, function(a) {
                    return CKEDITOR.tools.repeat("<br>", a.length / 7 * 2)
                }).replace(/<\/?p>/g, "") : a.enterMode == CKEDITOR.ENTER_DIV && (b = b.replace(/<(\/)?p>/g, "<$1div>"));
            return b
        }
        CKEDITOR.plugins.add("clipboard", {
            requires: "dialog",
            init: function(d) {
                var f;
                a(d);
                CKEDITOR.dialog.add("paste", CKEDITOR.getUrl(this.path + "dialogs/paste.js"));
                d.on("paste", function(a) {
                        var b = a.data.dataValue,
                            c = CKEDITOR.dtd.$block;
                        if (b.indexOf("Apple-") > -1) {
                            b = b.replace(/<span class="Apple-converted-space">&nbsp;<\/span>/gi,
                                " ");
                            a.data.type != "html" && (b = b.replace(/<span class="Apple-tab-span"[^>]*>([^<]*)<\/span>/gi, function(a, b) {
                                return b.replace(/\t/g, "&nbsp;&nbsp; &nbsp;")
                            }));
                            if (b.indexOf('<br class="Apple-interchange-newline">') > -1) {
                                a.data.startsWithEOL = 1;
                                a.data.preSniffing = "html";
                                b = b.replace(/<br class="Apple-interchange-newline">/, "")
                            }
                            b = b.replace(/(<[^>]+) class="Apple-[^"]*"/gi, "$1")
                        }
                        if (b.match(/^<[^<]+cke_(editable|contents)/i)) {
                            var d, f, g = new CKEDITOR.dom.element("div");
                            for (g.setHtml(b); g.getChildCount() == 1 && (d =
                                g.getFirst()) && d.type == CKEDITOR.NODE_ELEMENT && (d.hasClass("cke_editable") || d.hasClass("cke_contents"));) g = f = d;
                            f && (b = f.getHtml().replace(/<br>$/i, ""))
                        }
                        CKEDITOR.env.ie ? b = b.replace(/^&nbsp;(?: |\r\n)?<(\w+)/g, function(b, d) {
                            if (d.toLowerCase() in c) {
                                a.data.preSniffing = "html";
                                return "<" + d
                            }
                            return b
                        }) : CKEDITOR.env.webkit ? b = b.replace(/<\/(\w+)><div><br><\/div>$/, function(b, d) {
                            if (d in c) {
                                a.data.endsWithEOL = 1;
                                return "</" + d + ">"
                            }
                            return b
                        }) : CKEDITOR.env.gecko && (b = b.replace(/(\s)<br>$/, "$1"));
                        a.data.dataValue = b
                    }, null,
                    null, 3);
                d.on("paste", function(a) {
                    var a = a.data,
                        i = a.type,
                        k = a.dataValue,
                        n, o = d.config.clipboard_defaultContentType || "html";
                    n = i == "html" || a.preSniffing == "html" ? "html" : e(k);
                    n == "htmlifiedtext" ? k = b(d.config, k) : i == "text" && n == "html" && (k = c(d.config, k, f || (f = g(d))));
                    a.startsWithEOL && (k = '<br data-cke-eol="1">' + k);
                    a.endsWithEOL && (k = k + '<br data-cke-eol="1">');
                    i == "auto" && (i = n == "html" || o == "html" ? "html" : "text");
                    a.type = i;
                    a.dataValue = k;
                    delete a.preSniffing;
                    delete a.startsWithEOL;
                    delete a.endsWithEOL
                }, null, null, 6);
                d.on("paste",
                    function(a) {
                        a = a.data;
                        d.insertHtml(a.dataValue, a.type);
                        setTimeout(function() {
                            d.fire("afterPaste")
                        }, 0)
                    }, null, null, 1E3);
                d.on("pasteDialog", function(a) {
                    setTimeout(function() {
                        d.openDialog("paste", a.data)
                    }, 0)
                })
            }
        })
    }(),
    function() {
        CKEDITOR.plugins.add("panel", {
            beforeInit: function(a) {
                a.ui.addHandler(CKEDITOR.UI_PANEL, CKEDITOR.ui.panel.handler)
            }
        });
        CKEDITOR.UI_PANEL = "panel";
        CKEDITOR.ui.panel = function(a, b) {
            b && CKEDITOR.tools.extend(this, b);
            CKEDITOR.tools.extend(this, {
                className: "",
                css: []
            });
            this.id = CKEDITOR.tools.getNextId();
            this.document = a;
            this.isFramed = this.forceIFrame || this.css.length;
            this._ = {
                blocks: {}
            }
        };
        CKEDITOR.ui.panel.handler = {
            create: function(a) {
                return new CKEDITOR.ui.panel(a)
            }
        };
        var a = CKEDITOR.addTemplate("panel", '<div lang="{langCode}" id="{id}" dir={dir} class="cke cke_reset_all {editorId} cke_panel cke_panel {cls} cke_{dir}" style="z-index:{z-index}" role="presentation">{frame}</div>'),
            e = CKEDITOR.addTemplate("panel-frame", '<iframe id="{id}" class="cke_panel_frame" role="presentation" frameborder="0" src="{src}"></iframe>'),
            b = CKEDITOR.addTemplate("panel-frame-inner", '<!DOCTYPE html><html class="cke_panel_container {env}" dir="{dir}" lang="{langCode}"><head>{css}</head><body class="cke_{dir}" style="margin:0;padding:0" onload="{onload}"></body></html>');
        CKEDITOR.ui.panel.prototype = {
            render: function(g, c) {
                this.getHolderElement = function() {
                    var a = this._.holder;
                    if (!a) {
                        if (this.isFramed) {
                            var a = this.document.getById(this.id + "_frame"),
                                c = a.getParent(),
                                a = a.getFrameDocument();
                            CKEDITOR.env.iOS && c.setStyles({
                                overflow: "scroll",
                                "-webkit-overflow-scrolling": "touch"
                            });
                            c = CKEDITOR.tools.addFunction(CKEDITOR.tools.bind(function() {
                                this.isLoaded = true;
                                if (this.onLoad) this.onLoad()
                            }, this));
                            a.write(b.output(CKEDITOR.tools.extend({
                                css: CKEDITOR.tools.buildStyleHtml(this.css),
                                onload: "window.parent.CKEDITOR.tools.callFunction(" + c + ");"
                            }, d)));
                            a.getWindow().$.CKEDITOR = CKEDITOR;
                            a.on("keydown", function(a) {
                                var b = a.data.getKeystroke(),
                                    c = this.document.getById(this.id).getAttribute("dir");
                                this._.onKeyDown && this._.onKeyDown(b) === false ? a.data.preventDefault() : (b == 27 || b == (c == "rtl" ? 39 :
                                    37)) && this.onEscape && this.onEscape(b) === false && a.data.preventDefault()
                            }, this);
                            a = a.getBody();
                            a.unselectable();
                            CKEDITOR.env.air && CKEDITOR.tools.callFunction(c)
                        } else a = this.document.getById(this.id);
                        this._.holder = a
                    }
                    return a
                };
                var d = {
                    editorId: g.id,
                    id: this.id,
                    langCode: g.langCode,
                    dir: g.lang.dir,
                    cls: this.className,
                    frame: "",
                    env: CKEDITOR.env.cssClass,
                    "z-index": g.config.baseFloatZIndex + 1
                };
                if (this.isFramed) {
                    var j = CKEDITOR.env.air ? "javascript:void(0)" : CKEDITOR.env.ie ? "javascript:void(function(){" + encodeURIComponent("document.open();(" +
                        CKEDITOR.tools.fixDomain + ")();document.close();") + "}())" : "";
                    d.frame = e.output({
                        id: this.id + "_frame",
                        src: j
                    })
                }
                j = a.output(d);
                c && c.push(j);
                return j
            },
            addBlock: function(a, b) {
                b = this._.blocks[a] = b instanceof CKEDITOR.ui.panel.block ? b : new CKEDITOR.ui.panel.block(this.getHolderElement(), b);
                this._.currentBlock || this.showBlock(a);
                return b
            },
            getBlock: function(a) {
                return this._.blocks[a]
            },
            showBlock: function(a) {
                var a = this._.blocks[a],
                    b = this._.currentBlock,
                    d = !this.forceIFrame || CKEDITOR.env.ie ? this._.holder : this.document.getById(this.id +
                        "_frame");
                b && b.hide();
                this._.currentBlock = a;
                CKEDITOR.fire("ariaWidget", d);
                a._.focusIndex = -1;
                this._.onKeyDown = a.onKeyDown && CKEDITOR.tools.bind(a.onKeyDown, a);
                a.show();
                return a
            },
            destroy: function() {
                this.element && this.element.remove()
            }
        };
        CKEDITOR.ui.panel.block = CKEDITOR.tools.createClass({
            $: function(a, b) {
                this.element = a.append(a.getDocument().createElement("div", {
                    attributes: {
                        tabindex: -1,
                        "class": "cke_panel_block"
                    },
                    styles: {
                        display: "none"
                    }
                }));
                b && CKEDITOR.tools.extend(this, b);
                this.element.setAttributes({
                    role: this.attributes.role ||
                        "presentation",
                    "aria-label": this.attributes["aria-label"],
                    title: this.attributes.title || this.attributes["aria-label"]
                });
                this.keys = {};
                this._.focusIndex = -1;
                this.element.disableContextMenu()
            },
            _: {
                markItem: function(a) {
                    if (a != -1) {
                        a = this.element.getElementsByTag("a").getItem(this._.focusIndex = a);
                        CKEDITOR.env.webkit && a.getDocument().getWindow().focus();
                        a.focus();
                        this.onMark && this.onMark(a)
                    }
                }
            },
            proto: {
                show: function() {
                    this.element.setStyle("display", "")
                },
                hide: function() {
                    (!this.onHide || this.onHide.call(this) !==
                        true) && this.element.setStyle("display", "none")
                },
                onKeyDown: function(a, b) {
                    var d = this.keys[a];
                    switch (d) {
                        case "next":
                            for (var e = this._.focusIndex, d = this.element.getElementsByTag("a"), f; f = d.getItem(++e);)
                                if (f.getAttribute("_cke_focus") && f.$.offsetWidth) {
                                    this._.focusIndex = e;
                                    f.focus();
                                    break
                                }
                            if (!f && !b) {
                                this._.focusIndex = -1;
                                return this.onKeyDown(a, 1)
                            }
                            return false;
                        case "prev":
                            e = this._.focusIndex;
                            for (d = this.element.getElementsByTag("a"); e > 0 && (f = d.getItem(--e));) {
                                if (f.getAttribute("_cke_focus") && f.$.offsetWidth) {
                                    this._.focusIndex =
                                        e;
                                    f.focus();
                                    break
                                }
                                f = null
                            }
                            if (!f && !b) {
                                this._.focusIndex = d.count();
                                return this.onKeyDown(a, 1)
                            }
                            return false;
                        case "click":
                        case "mouseup":
                            e = this._.focusIndex;
                            (f = e >= 0 && this.element.getElementsByTag("a").getItem(e)) && (f.$[d] ? f.$[d]() : f.$["on" + d]());
                            return false
                    }
                    return true
                }
            }
        })
    }(), CKEDITOR.plugins.add("floatpanel", {
        requires: "panel"
    }),
    function() {
        function a(a, g, c, d, j) {
            var j = CKEDITOR.tools.genKey(g.getUniqueId(), c.getUniqueId(), a.lang.dir, a.uiColor || "", d.css || "", j || ""),
                f = e[j];
            if (!f) {
                f = e[j] = new CKEDITOR.ui.panel(g,
                    d);
                f.element = c.append(CKEDITOR.dom.element.createFromHtml(f.render(a), g));
                f.element.setStyles({
                    display: "none",
                    position: "absolute"
                })
            }
            return f
        }
        var e = {};
        CKEDITOR.ui.floatPanel = CKEDITOR.tools.createClass({
            $: function(b, g, c, d) {
                function e() {
                    k.hide()
                }
                c.forceIFrame = 1;
                c.toolbarRelated && b.elementMode == CKEDITOR.ELEMENT_MODE_INLINE && (g = CKEDITOR.document.getById("cke_" + b.name));
                var f = g.getDocument(),
                    d = a(b, f, g, c, d || 0),
                    h = d.element,
                    i = h.getFirst(),
                    k = this;
                h.disableContextMenu();
                this.element = h;
                this._ = {
                    editor: b,
                    panel: d,
                    parentElement: g,
                    definition: c,
                    document: f,
                    iframe: i,
                    children: [],
                    dir: b.lang.dir
                };
                b.on("mode", e);
                b.on("resize", e);
                if (!CKEDITOR.env.iOS) f.getWindow().on("resize", e)
            },
            proto: {
                addBlock: function(a, g) {
                    return this._.panel.addBlock(a, g)
                },
                addListBlock: function(a, g) {
                    return this._.panel.addListBlock(a, g)
                },
                getBlock: function(a) {
                    return this._.panel.getBlock(a)
                },
                showBlock: function(a, g, c, d, e, f) {
                    var h = this._.panel,
                        i = h.showBlock(a);
                    this.allowBlur(false);
                    a = this._.editor.editable();
                    this._.returnFocus = a.hasFocus ? a : new CKEDITOR.dom.element(CKEDITOR.document.$.activeElement);
                    this._.hideTimeout = 0;
                    var k = this.element,
                        a = this._.iframe,
                        a = CKEDITOR.env.ie ? a : new CKEDITOR.dom.window(a.$.contentWindow),
                        n = k.getDocument(),
                        o = this._.parentElement.getPositionedAncestor(),
                        q = g.getDocumentPosition(n),
                        n = o ? o.getDocumentPosition(n) : {
                            x: 0,
                            y: 0
                        }, m = this._.dir == "rtl",
                        l = q.x + (d || 0) - n.x,
                        p = q.y + (e || 0) - n.y;
                    if (m && (c == 1 || c == 4)) l = l + g.$.offsetWidth;
                    else if (!m && (c == 2 || c == 3)) l = l + (g.$.offsetWidth - 1);
                    if (c == 3 || c == 4) p = p + (g.$.offsetHeight - 1);
                    this._.panel._.offsetParentId = g.getId();
                    k.setStyles({
                        top: p + "px",
                        left: 0,
                        display: ""
                    });
                    k.setOpacity(0);
                    k.getFirst().removeStyle("width");
                    this._.editor.focusManager.add(a);
                    if (!this._.blurSet) {
                        CKEDITOR.event.useCapture = true;
                        a.on("blur", function(a) {
                            function b() {
                                delete this._.returnFocus;
                                this.hide()
                            }
                            if (this.allowBlur() && a.data.getPhase() == CKEDITOR.EVENT_PHASE_AT_TARGET && this.visible && !this._.activeChild)
                                if (CKEDITOR.env.iOS) {
                                    if (!this._.hideTimeout) this._.hideTimeout = CKEDITOR.tools.setTimeout(b, 0, this)
                                } else b.call(this)
                        }, this);
                        a.on("focus", function() {
                            this._.focused = true;
                            this.hideChild();
                            this.allowBlur(true)
                        }, this);
                        if (CKEDITOR.env.iOS) {
                            a.on("touchstart", function() {
                                clearTimeout(this._.hideTimeout)
                            }, this);
                            a.on("touchend", function() {
                                this._.hideTimeout = 0;
                                this.focus()
                            }, this)
                        }
                        CKEDITOR.event.useCapture = false;
                        this._.blurSet = 1
                    }
                    h.onEscape = CKEDITOR.tools.bind(function(a) {
                        if (this.onEscape && this.onEscape(a) === false) return false
                    }, this);
                    CKEDITOR.tools.setTimeout(function() {
                        var a = CKEDITOR.tools.bind(function() {
                            k.removeStyle("width");
                            if (i.autoSize) {
                                var a = i.element.getDocument(),
                                    a = (CKEDITOR.env.webkit ?
                                        i.element : a.getBody()).$.scrollWidth;
                                CKEDITOR.env.ie && (CKEDITOR.env.quirks && a > 0) && (a = a + ((k.$.offsetWidth || 0) - (k.$.clientWidth || 0) + 3));
                                k.setStyle("width", a + 10 + "px");
                                a = i.element.$.scrollHeight;
                                CKEDITOR.env.ie && (CKEDITOR.env.quirks && a > 0) && (a = a + ((k.$.offsetHeight || 0) - (k.$.clientHeight || 0) + 3));
                                k.setStyle("height", a + "px");
                                h._.currentBlock.element.setStyle("display", "none").removeStyle("display")
                            } else k.removeStyle("height");
                            m && (l = l - k.$.offsetWidth);
                            k.setStyle("left", l + "px");
                            var b = h.element.getWindow(),
                                a = k.$.getBoundingClientRect(),
                                b = b.getViewPaneSize(),
                                c = a.width || a.right - a.left,
                                d = a.height || a.bottom - a.top,
                                g = m ? a.right : b.width - a.left,
                                e = m ? b.width - a.right : a.left;
                            m ? g < c && (l = e > c ? l + c : b.width > c ? l - a.left : l - a.right + b.width) : g < c && (l = e > c ? l - c : b.width > c ? l - a.right + b.width : l - a.left);
                            c = a.top;
                            b.height - a.top < d && (p = c > d ? p - d : b.height > d ? p - a.bottom + b.height : p - a.top);
                            if (CKEDITOR.env.ie) {
                                b = a = new CKEDITOR.dom.element(k.$.offsetParent);
                                b.getName() == "html" && (b = b.getDocument().getBody());
                                b.getComputedStyle("direction") == "rtl" &&
                                    (l = CKEDITOR.env.ie8Compat ? l - k.getDocument().getDocumentElement().$.scrollLeft * 2 : l - (a.$.scrollWidth - a.$.clientWidth))
                            }
                            var a = k.getFirst(),
                                j;
                            (j = a.getCustomData("activePanel")) && j.onHide && j.onHide.call(this, 1);
                            a.setCustomData("activePanel", this);
                            k.setStyles({
                                top: p + "px",
                                left: l + "px"
                            });
                            k.setOpacity(1);
                            f && f()
                        }, this);
                        h.isLoaded ? a() : h.onLoad = a;
                        CKEDITOR.tools.setTimeout(function() {
                            var a = CKEDITOR.env.webkit && CKEDITOR.document.getWindow().getScrollPosition().y;
                            this.focus();
                            i.element.focus();
                            if (CKEDITOR.env.webkit) CKEDITOR.document.getBody().$.scrollTop =
                                a;
                            this.allowBlur(true);
                            this._.editor.fire("panelShow", this)
                        }, 0, this)
                    }, CKEDITOR.env.air ? 200 : 0, this);
                    this.visible = 1;
                    this.onShow && this.onShow.call(this)
                },
                focus: function() {
                    if (CKEDITOR.env.webkit) {
                        var a = CKEDITOR.document.getActive();
                        a && !a.equals(this._.iframe) && a.$.blur()
                    }(this._.lastFocused || this._.iframe.getFrameDocument().getWindow()).focus()
                },
                blur: function() {
                    var a = this._.iframe.getFrameDocument().getActive();
                    a && a.is("a") && (this._.lastFocused = a)
                },
                hide: function(a) {
                    if (this.visible && (!this.onHide || this.onHide.call(this) !==
                        true)) {
                        this.hideChild();
                        CKEDITOR.env.gecko && this._.iframe.getFrameDocument().$.activeElement.blur();
                        this.element.setStyle("display", "none");
                        this.visible = 0;
                        this.element.getFirst().removeCustomData("activePanel");
                        if (a = a && this._.returnFocus) {
                            CKEDITOR.env.webkit && a.type && a.getWindow().$.focus();
                            a.focus()
                        }
                        delete this._.lastFocused;
                        this._.editor.fire("panelHide", this)
                    }
                },
                allowBlur: function(a) {
                    var g = this._.panel;
                    if (a !== void 0) g.allowBlur = a;
                    return g.allowBlur
                },
                showAsChild: function(a, g, c, d, e, f) {
                    if (!(this._.activeChild ==
                        a && a._.panel._.offsetParentId == c.getId())) {
                        this.hideChild();
                        a.onHide = CKEDITOR.tools.bind(function() {
                            CKEDITOR.tools.setTimeout(function() {
                                this._.focused || this.hide()
                            }, 0, this)
                        }, this);
                        this._.activeChild = a;
                        this._.focused = false;
                        a.showBlock(g, c, d, e, f);
                        this.blur();
                        (CKEDITOR.env.ie7Compat || CKEDITOR.env.ie6Compat) && setTimeout(function() {
                            a.element.getChild(0).$.style.cssText += ""
                        }, 100)
                    }
                },
                hideChild: function(a) {
                    var g = this._.activeChild;
                    if (g) {
                        delete g.onHide;
                        delete this._.activeChild;
                        g.hide();
                        a && this.focus()
                    }
                }
            }
        });
        CKEDITOR.on("instanceDestroyed", function() {
            var a = CKEDITOR.tools.isEmpty(CKEDITOR.instances),
                g;
            for (g in e) {
                var c = e[g];
                a ? c.destroy() : c.element.hide()
            }
            a && (e = {})
        })
    }(), CKEDITOR.plugins.add("menu", {
        requires: "floatpanel",
        beforeInit: function(a) {
            for (var e = a.config.menu_groups.split(","), b = a._.menuGroups = {}, g = a._.menuItems = {}, c = 0; c < e.length; c++) b[e[c]] = c + 1;
            a.addMenuGroup = function(a, c) {
                b[a] = c || 100
            };
            a.addMenuItem = function(a, c) {
                b[c.group] && (g[a] = new CKEDITOR.menuItem(this, a, c))
            };
            a.addMenuItems = function(a) {
                for (var b in a) this.addMenuItem(b,
                    a[b])
            };
            a.getMenuItem = function(a) {
                return g[a]
            };
            a.removeMenuItem = function(a) {
                delete g[a]
            }
        }
    }),
    function() {
        function a(a) {
            a.sort(function(a, b) {
                return a.group < b.group ? -1 : a.group > b.group ? 1 : a.order < b.order ? -1 : a.order > b.order ? 1 : 0
            })
        }
        var e = '<span class="cke_menuitem"><a id="{id}" class="cke_menubutton cke_menubutton__{name} cke_menubutton_{state} {cls}" href="{href}" title="{title}" tabindex="-1"_cke_focus=1 hidefocus="true" role="{role}" aria-haspopup="{hasPopup}" aria-disabled="{disabled}" {ariaChecked}';
        CKEDITOR.env.gecko &&
            CKEDITOR.env.mac && (e = e + ' onkeypress="return false;"');
        CKEDITOR.env.gecko && (e = e + ' onblur="this.style.cssText = this.style.cssText;"');
        var e = e + (' onmouseover="CKEDITOR.tools.callFunction({hoverFn},{index});" onmouseout="CKEDITOR.tools.callFunction({moveOutFn},{index});" ' + (CKEDITOR.env.ie ? 'onclick="return false;" onmouseup' : "onclick") + '="CKEDITOR.tools.callFunction({clickFn},{index}); return false;">'),
            b = CKEDITOR.addTemplate("menuItem", e + '<span class="cke_menubutton_inner"><span class="cke_menubutton_icon"><span class="cke_button_icon cke_button__{iconName}_icon" style="{iconStyle}"></span></span><span class="cke_menubutton_label">{label}</span>{arrowHtml}</span></a></span>'),
            g = CKEDITOR.addTemplate("menuArrow", '<span class="cke_menuarrow"><span>{label}</span></span>');
        CKEDITOR.menu = CKEDITOR.tools.createClass({
            $: function(a, b) {
                b = this._.definition = b || {};
                this.id = CKEDITOR.tools.getNextId();
                this.editor = a;
                this.items = [];
                this._.listeners = [];
                this._.level = b.level || 1;
                var g = CKEDITOR.tools.extend({}, b.panel, {
                    css: [CKEDITOR.skin.getPath("editor")],
                    level: this._.level - 1,
                    block: {}
                }),
                    f = g.block.attributes = g.attributes || {};
                !f.role && (f.role = "menu");
                this._.panelDefinition = g
            },
            _: {
                onShow: function() {
                    var a =
                        this.editor.getSelection(),
                        b = a && a.getStartElement(),
                        g = this.editor.elementPath(),
                        f = this._.listeners;
                    this.removeAll();
                    for (var e = 0; e < f.length; e++) {
                        var i = f[e](b, a, g);
                        if (i)
                            for (var k in i) {
                                var n = this.editor.getMenuItem(k);
                                if (n && (!n.command || this.editor.getCommand(n.command).state)) {
                                    n.state = i[k];
                                    this.add(n)
                                }
                            }
                    }
                },
                onClick: function(a) {
                    this.hide();
                    if (a.onClick) a.onClick();
                    else a.command && this.editor.execCommand(a.command)
                },
                onEscape: function(a) {
                    var b = this.parent;
                    b ? b._.panel.hideChild(1) : a == 27 && this.hide(1);
                    return false
                },
                onHide: function() {
                    this.onHide && this.onHide()
                },
                showSubMenu: function(a) {
                    var b = this._.subMenu,
                        g = this.items[a];
                    if (g = g.getItems && g.getItems()) {
                        if (b) b.removeAll();
                        else {
                            b = this._.subMenu = new CKEDITOR.menu(this.editor, CKEDITOR.tools.extend({}, this._.definition, {
                                level: this._.level + 1
                            }, true));
                            b.parent = this;
                            b._.onClick = CKEDITOR.tools.bind(this._.onClick, this)
                        }
                        for (var f in g) {
                            var e = this.editor.getMenuItem(f);
                            if (e) {
                                e.state = g[f];
                                b.add(e)
                            }
                        }
                        var i = this._.panel.getBlock(this.id).element.getDocument().getById(this.id +
                            ("" + a));
                        setTimeout(function() {
                            b.show(i, 2)
                        }, 0)
                    } else this._.panel.hideChild(1)
                }
            },
            proto: {
                add: function(a) {
                    if (!a.order) a.order = this.items.length;
                    this.items.push(a)
                },
                removeAll: function() {
                    this.items = []
                },
                show: function(b, d, g, f) {
                    if (!this.parent) {
                        this._.onShow();
                        if (!this.items.length) return
                    }
                    var d = d || (this.editor.lang.dir == "rtl" ? 2 : 1),
                        e = this.items,
                        i = this.editor,
                        k = this._.panel,
                        n = this._.element;
                    if (!k) {
                        k = this._.panel = new CKEDITOR.ui.floatPanel(this.editor, CKEDITOR.document.getBody(), this._.panelDefinition, this._.level);
                        k.onEscape = CKEDITOR.tools.bind(function(a) {
                            if (this._.onEscape(a) === false) return false
                        }, this);
                        k.onShow = function() {
                            k._.panel.getHolderElement().getParent().addClass("cke cke_reset_all")
                        };
                        k.onHide = CKEDITOR.tools.bind(function() {
                            this._.onHide && this._.onHide()
                        }, this);
                        n = k.addBlock(this.id, this._.panelDefinition.block);
                        n.autoSize = true;
                        var o = n.keys;
                        o[40] = "next";
                        o[9] = "next";
                        o[38] = "prev";
                        o[CKEDITOR.SHIFT + 9] = "prev";
                        o[i.lang.dir == "rtl" ? 37 : 39] = CKEDITOR.env.ie ? "mouseup" : "click";
                        o[32] = CKEDITOR.env.ie ? "mouseup" :
                            "click";
                        CKEDITOR.env.ie && (o[13] = "mouseup");
                        n = this._.element = n.element;
                        o = n.getDocument();
                        o.getBody().setStyle("overflow", "hidden");
                        o.getElementsByTag("html").getItem(0).setStyle("overflow", "hidden");
                        this._.itemOverFn = CKEDITOR.tools.addFunction(function(a) {
                            clearTimeout(this._.showSubTimeout);
                            this._.showSubTimeout = CKEDITOR.tools.setTimeout(this._.showSubMenu, i.config.menu_subMenuDelay || 400, this, [a])
                        }, this);
                        this._.itemOutFn = CKEDITOR.tools.addFunction(function() {
                            clearTimeout(this._.showSubTimeout)
                        }, this);
                        this._.itemClickFn = CKEDITOR.tools.addFunction(function(a) {
                            var b = this.items[a];
                            if (b.state == CKEDITOR.TRISTATE_DISABLED) this.hide(1);
                            else if (b.getItems) this._.showSubMenu(a);
                            else this._.onClick(b)
                        }, this)
                    }
                    a(e);
                    for (var o = i.elementPath(), o = ['<div class="cke_menu' + (o && o.direction() != i.lang.dir ? " cke_mixed_dir_content" : "") + '" role="presentation">'], q = e.length, m = q && e[0].group, l = 0; l < q; l++) {
                        var p = e[l];
                        if (m != p.group) {
                            o.push('<div class="cke_menuseparator" role="separator"></div>');
                            m = p.group
                        }
                        p.render(this, l, o)
                    }
                    o.push("</div>");
                    n.setHtml(o.join(""));
                    CKEDITOR.ui.fire("ready", this);
                    this.parent ? this.parent._.panel.showAsChild(k, this.id, b, d, g, f) : k.showBlock(this.id, b, d, g, f);
                    i.fire("menuShow", [k])
                },
                addListener: function(a) {
                    this._.listeners.push(a)
                },
                hide: function(a) {
                    this._.onHide && this._.onHide();
                    this._.panel && this._.panel.hide(a)
                }
            }
        });
        CKEDITOR.menuItem = CKEDITOR.tools.createClass({
            $: function(a, b, g) {
                CKEDITOR.tools.extend(this, g, {
                    order: 0,
                    className: "cke_menubutton__" + b
                });
                this.group = a._.menuGroups[this.group];
                this.editor = a;
                this.name =
                    b
            },
            proto: {
                render: function(a, d, e) {
                    var f = a.id + ("" + d),
                        h = typeof this.state == "undefined" ? CKEDITOR.TRISTATE_OFF : this.state,
                        i = "",
                        k = h == CKEDITOR.TRISTATE_ON ? "on" : h == CKEDITOR.TRISTATE_DISABLED ? "disabled" : "off";
                    this.role in {
                        menuitemcheckbox: 1,
                        menuitemradio: 1
                    } && (i = ' aria-checked="' + (h == CKEDITOR.TRISTATE_ON ? "true" : "false") + '"');
                    var n = this.getItems,
                        o = "&#" + (this.editor.lang.dir == "rtl" ? "9668" : "9658") + ";",
                        q = this.name;
                    if (this.icon && !/\./.test(this.icon)) q = this.icon;
                    a = {
                        id: f,
                        name: this.name,
                        iconName: q,
                        label: this.label,
                        cls: this.className || "",
                        state: k,
                        hasPopup: n ? "true" : "false",
                        disabled: h == CKEDITOR.TRISTATE_DISABLED,
                        title: this.label,
                        href: "javascript:void('" + (this.label || "").replace("'") + "')",
                        hoverFn: a._.itemOverFn,
                        moveOutFn: a._.itemOutFn,
                        clickFn: a._.itemClickFn,
                        index: d,
                        iconStyle: CKEDITOR.skin.getIconStyle(q, this.editor.lang.dir == "rtl", q == this.icon ? null : this.icon, this.iconOffset),
                        arrowHtml: n ? g.output({
                            label: o
                        }) : "",
                        role: this.role ? this.role : "menuitem",
                        ariaChecked: i
                    };
                    b.output(a, e)
                }
            }
        })
    }(), CKEDITOR.config.menu_groups = "clipboard,form,tablecell,tablecellproperties,tablerow,tablecolumn,table,anchor,link,image,flash,checkbox,radio,textfield,hiddenfield,imagebutton,button,select,textarea,div",
    CKEDITOR.plugins.add("contextmenu", {
        requires: "menu",
        onLoad: function() {
            CKEDITOR.plugins.contextMenu = CKEDITOR.tools.createClass({
                base: CKEDITOR.menu,
                $: function(a) {
                    this.base.call(this, a, {
                        panel: {
                            className: "cke_menu_panel",
                            attributes: {
                                "aria-label": a.lang.contextmenu.options
                            }
                        }
                    })
                },
                proto: {
                    addTarget: function(a, e) {
                        a.on("contextmenu", function(a) {
                            var a = a.data,
                                d = CKEDITOR.env.webkit ? b : CKEDITOR.env.mac ? a.$.metaKey : a.$.ctrlKey;
                            if (!e || !d) {
                                a.preventDefault();
                                if (CKEDITOR.env.mac && CKEDITOR.env.webkit) {
                                    var d = this.editor,
                                        g = (new CKEDITOR.dom.elementPath(a.getTarget(), d.editable())).contains(function(a) {
                                            return a.hasAttribute("contenteditable")
                                        }, true);
                                    g && g.getAttribute("contenteditable") == "false" && d.getSelection().fake(g)
                                }
                                var g = a.getTarget().getDocument(),
                                    f = a.getTarget().getDocument().getDocumentElement(),
                                    d = !g.equals(CKEDITOR.document),
                                    g = g.getWindow().getScrollPosition(),
                                    h = d ? a.$.clientX : a.$.pageX || g.x + a.$.clientX,
                                    i = d ? a.$.clientY : a.$.pageY || g.y + a.$.clientY;
                                CKEDITOR.tools.setTimeout(function() {
                                        this.open(f, null, h, i)
                                    }, CKEDITOR.env.ie ?
                                    200 : 0, this)
                            }
                        }, this);
                        if (CKEDITOR.env.webkit) {
                            var b, g = function() {
                                    b = 0
                                };
                            a.on("keydown", function(a) {
                                b = CKEDITOR.env.mac ? a.data.$.metaKey : a.data.$.ctrlKey
                            });
                            a.on("keyup", g);
                            a.on("contextmenu", g)
                        }
                    },
                    open: function(a, e, b, g) {
                        this.editor.focus();
                        a = a || CKEDITOR.document.getDocumentElement();
                        this.editor.selectionChange(1);
                        this.show(a, e, b, g)
                    }
                }
            })
        },
        beforeInit: function(a) {
            var e = a.contextMenu = new CKEDITOR.plugins.contextMenu(a);
            a.on("contentDom", function() {
                e.addTarget(a.editable(), a.config.browserContextMenuOnCtrl !==
                    false)
            });
            a.addCommand("contextMenu", {
                exec: function() {
                    a.contextMenu.open(a.document.getBody())
                }
            });
            a.setKeystroke(CKEDITOR.SHIFT + 121, "contextMenu");
            a.setKeystroke(CKEDITOR.CTRL + CKEDITOR.SHIFT + 121, "contextMenu")
        }
    }),
    function() {
        var a;

        function e(d, g) {
            function f(a) {
                a = n.list[a];
                if (a.equals(d.editable()) || a.getAttribute("contenteditable") == "true") {
                    var b = d.createRange();
                    b.selectNodeContents(a);
                    b.select()
                } else d.getSelection().selectElement(a);
                d.focus()
            }

            function e() {
                k && k.setHtml(b);
                delete n.list
            }
            var i = d.ui.spaceId("path"),
                k, n = d._.elementsPath,
                o = n.idBase;
            g.html = g.html + ('<span id="' + i + '_label" class="cke_voice_label">' + d.lang.elementspath.eleLabel + '</span><span id="' + i + '" class="cke_path" role="group" aria-labelledby="' + i + '_label">' + b + "</span>");
            d.on("uiReady", function() {
                var a = d.ui.space("path");
                a && d.focusManager.add(a, 1)
            });
            n.onClick = f;
            var q = CKEDITOR.tools.addFunction(f),
                m = CKEDITOR.tools.addFunction(function(a, b) {
                    var c = n.idBase,
                        g, b = new CKEDITOR.dom.event(b);
                    g = d.lang.dir == "rtl";
                    switch (b.getKeystroke()) {
                        case g ? 39:
                            37 :
                        case 9:
                            (g =
                                CKEDITOR.document.getById(c + (a + 1))) || (g = CKEDITOR.document.getById(c + "0"));
                            g.focus();
                            return false;
                        case g ? 37:
                            39 :
                        case CKEDITOR.SHIFT + 9:
                            (g = CKEDITOR.document.getById(c + (a - 1))) || (g = CKEDITOR.document.getById(c + (n.list.length - 1)));
                            g.focus();
                            return false;
                        case 27:
                            d.focus();
                            return false;
                        case 13:
                        case 32:
                            f(a);
                            return false
                    }
                    return true
                });
            d.on("selectionChange", function() {
                for (var a = [], f = n.list = [], g = [], e = n.filters, h = true, j = d.elementPath().elements, x, v = j.length; v--;) {
                    var r = j[v],
                        y = 0;
                    x = r.data("cke-display-name") ? r.data("cke-display-name") :
                        r.data("cke-real-element-type") ? r.data("cke-real-element-type") : r.getName();
                    h = r.hasAttribute("contenteditable") ? r.getAttribute("contenteditable") == "true" : h;
                    !h && !r.hasAttribute("contenteditable") && (y = 1);
                    for (var z = 0; z < e.length; z++) {
                        var B = e[z](r, x);
                        if (B === false) {
                            y = 1;
                            break
                        }
                        x = B || x
                    }
                    if (!y) {
                        f.unshift(r);
                        g.unshift(x)
                    }
                }
                f = f.length;
                for (e = 0; e < f; e++) {
                    x = g[e];
                    h = d.lang.elementspath.eleTitle.replace(/%1/, x);
                    x = c.output({
                        id: o + e,
                        label: h,
                        text: x,
                        jsTitle: "javascript:void('" + x + "')",
                        index: e,
                        keyDownFn: m,
                        clickFn: q
                    });
                    a.unshift(x)
                }
                k ||
                    (k = CKEDITOR.document.getById(i));
                g = k;
                g.setHtml(a.join("") + b);
                d.fire("elementsPathUpdate", {
                    space: g
                })
            });
            d.on("readOnly", e);
            d.on("contentDomUnload", e);
            d.addCommand("elementsPathFocus", a);
            d.setKeystroke(CKEDITOR.ALT + 122, "elementsPathFocus")
        }
        a = {
            editorFocus: false,
            readOnly: 1,
            exec: function(a) {
                (a = CKEDITOR.document.getById(a._.elementsPath.idBase + "0")) && a.focus(CKEDITOR.env.ie || CKEDITOR.env.air)
            }
        };
        var b = '<span class="cke_path_empty">&nbsp;</span>',
            g = "";
        CKEDITOR.env.gecko && CKEDITOR.env.mac && (g = g + ' onkeypress="return false;"');
        CKEDITOR.env.gecko && (g = g + ' onblur="this.style.cssText = this.style.cssText;"');
        var c = CKEDITOR.addTemplate("pathItem", '<a id="{id}" href="{jsTitle}" tabindex="-1" class="cke_path_item" title="{label}"' + g + ' hidefocus="true"  onkeydown="return CKEDITOR.tools.callFunction({keyDownFn},{index}, event );" onclick="CKEDITOR.tools.callFunction({clickFn},{index}); return false;" role="button" aria-label="{label}">{text}</a>');
        CKEDITOR.plugins.add("elementspath", {
            init: function(a) {
                a._.elementsPath = {
                    idBase: "cke_elementspath_" +
                        CKEDITOR.tools.getNextNumber() + "_",
                    filters: []
                };
                a.on("uiSpace", function(b) {
                    b.data.space == "bottom" && e(a, b.data)
                })
            }
        })
    }(),
    function() {
        function a(a, c) {
            var d, j;
            c.on("refresh", function(a) {
                var c = [e],
                    d;
                for (d in a.data.states) c.push(a.data.states[d]);
                this.setState(CKEDITOR.tools.search(c, b) ? b : e)
            }, c, null, 100);
            c.on("exec", function(b) {
                d = a.getSelection();
                j = d.createBookmarks(1);
                if (!b.data) b.data = {};
                b.data.done = false
            }, c, null, 0);
            c.on("exec", function() {
                a.forceNextSelectionCheck();
                d.selectBookmarks(j)
            }, c, null, 100)
        }
        var e =
            CKEDITOR.TRISTATE_DISABLED,
            b = CKEDITOR.TRISTATE_OFF;
        CKEDITOR.plugins.add("indent", {
            init: function(b) {
                var c = CKEDITOR.plugins.indent.genericDefinition;
                a(b, b.addCommand("indent", new c(true)));
                a(b, b.addCommand("outdent", new c));
                if (b.ui.addButton) {
                    b.ui.addButton("Indent", {
                        label: b.lang.indent.indent,
                        command: "indent",
                        directional: true,
                        toolbar: "indent,20"
                    });
                    b.ui.addButton("Outdent", {
                        label: b.lang.indent.outdent,
                        command: "outdent",
                        directional: true,
                        toolbar: "indent,10"
                    })
                }
                b.on("dirChanged", function(a) {
                    var c = b.createRange(),
                        f = a.data.node;
                    c.setStartBefore(f);
                    c.setEndAfter(f);
                    for (var e = new CKEDITOR.dom.walker(c), i; i = e.next();)
                        if (i.type == CKEDITOR.NODE_ELEMENT)
                            if (!i.equals(f) && i.getDirection()) {
                                c.setStartAfter(i);
                                e = new CKEDITOR.dom.walker(c)
                            } else {
                                var k = b.config.indentClasses;
                                if (k)
                                    for (var n = a.data.dir == "ltr" ? ["_rtl", ""] : ["", "_rtl"], o = 0; o < k.length; o++)
                                        if (i.hasClass(k[o] + n[0])) {
                                            i.removeClass(k[o] + n[0]);
                                            i.addClass(k[o] + n[1])
                                        }
                                k = i.getStyle("margin-right");
                                n = i.getStyle("margin-left");
                                k ? i.setStyle("margin-left", k) : i.removeStyle("margin-left");
                                n ? i.setStyle("margin-right", n) : i.removeStyle("margin-right")
                            }
                })
            }
        });
        CKEDITOR.plugins.indent = {
            genericDefinition: function(a) {
                this.isIndent = !! a;
                this.startDisabled = !this.isIndent
            },
            specificDefinition: function(a, b, d) {
                this.name = b;
                this.editor = a;
                this.jobs = {};
                this.enterBr = a.config.enterMode == CKEDITOR.ENTER_BR;
                this.isIndent = !! d;
                this.relatedGlobal = d ? "indent" : "outdent";
                this.indentKey = d ? 9 : CKEDITOR.SHIFT + 9;
                this.database = {}
            },
            registerCommands: function(a, b) {
                a.on("pluginsLoaded", function() {
                    for (var a in b)(function(a,
                        b) {
                        var c = a.getCommand(b.relatedGlobal),
                            d;
                        for (d in b.jobs) {
                            c.on("exec", function(c) {
                                if (!c.data.done) {
                                    a.fire("lockSnapshot");
                                    if (b.execJob(a, d)) c.data.done = true;
                                    a.fire("unlockSnapshot");
                                    CKEDITOR.dom.element.clearAllMarkers(b.database)
                                }
                            }, this, null, d);
                            c.on("refresh", function(c) {
                                if (!c.data.states) c.data.states = {};
                                c.data.states[b.name + "@" + d] = b.refreshJob(a, d, c.data.path)
                            }, this, null, d)
                        }
                        a.addFeature(b)
                    })(this, b[a])
                })
            }
        };
        CKEDITOR.plugins.indent.genericDefinition.prototype = {
            context: "p",
            exec: function() {}
        };
        CKEDITOR.plugins.indent.specificDefinition.prototype = {
            execJob: function(a, b) {
                var d = this.jobs[b];
                if (d.state != e) return d.exec.call(this, a)
            },
            refreshJob: function(a, b, d) {
                b = this.jobs[b];
                b.state = a.activeFilter.checkFeature(this) ? b.refresh.call(this, a, d) : e;
                return b.state
            },
            getContext: function(a) {
                return a.contains(this.context)
            }
        }
    }(),
    function() {
        function a(a) {
            function c(e) {
                for (var h = q.startContainer, m = q.endContainer; h && !h.getParent().equals(e);) h = h.getParent();
                for (; m && !m.getParent().equals(e);) m = m.getParent();
                if (!h || !m) return false;
                for (var l = h, h = [], o = false; !o;) {
                    l.equals(m) &&
                        (o = true);
                    h.push(l);
                    l = l.getNext()
                }
                if (h.length < 1) return false;
                l = e.getParents(true);
                for (m = 0; m < l.length; m++)
                    if (l[m].getName && j[l[m].getName()]) {
                        e = l[m];
                        break
                    }
                for (var l = d.isIndent ? 1 : -1, m = h[0], h = h[h.length - 1], o = CKEDITOR.plugins.list.listToArray(e, g), x = o[h.getCustomData("listarray_index")].indent, m = m.getCustomData("listarray_index"); m <= h.getCustomData("listarray_index"); m++) {
                    o[m].indent = o[m].indent + l;
                    if (l > 0) {
                        var v = o[m].parent;
                        o[m].parent = new CKEDITOR.dom.element(v.getName(), v.getDocument())
                    }
                }
                for (m = h.getCustomData("listarray_index") +
                    1; m < o.length && o[m].indent > x; m++) o[m].indent = o[m].indent + l;
                h = CKEDITOR.plugins.list.arrayToList(o, g, null, a.config.enterMode, e.getDirection());
                if (!d.isIndent) {
                    var r;
                    if ((r = e.getParent()) && r.is("li"))
                        for (var l = h.listNode.getChildren(), y = [], z, m = l.count() - 1; m >= 0; m--)(z = l.getItem(m)) && (z.is && z.is("li")) && y.push(z)
                }
                h && h.listNode.replace(e);
                if (y && y.length)
                    for (m = 0; m < y.length; m++) {
                        for (z = e = y[m];
                            (z = z.getNext()) && z.is && z.getName() in j;) {
                            CKEDITOR.env.needsNbspFiller && !e.getFirst(b) && e.append(q.document.createText(" "));
                            e.append(z)
                        }
                        e.insertAfter(r)
                    }
                h && a.fire("contentDomInvalidated");
                return true
            }
            for (var d = this, g = this.database, j = this.context, o = a.getSelection(), o = (o && o.getRanges()).createIterator(), q; q = o.getNextRange();) {
                for (var m = q.getCommonAncestor(); m && !(m.type == CKEDITOR.NODE_ELEMENT && j[m.getName()]);) m = m.getParent();
                m || (m = q.startPath().contains(j)) && q.setEndAt(m, CKEDITOR.POSITION_BEFORE_END);
                if (!m) {
                    var l = q.getEnclosedNode();
                    if (l && l.type == CKEDITOR.NODE_ELEMENT && l.getName() in j) {
                        q.setStartAt(l, CKEDITOR.POSITION_AFTER_START);
                        q.setEndAt(l, CKEDITOR.POSITION_BEFORE_END);
                        m = l
                    }
                }
                if (m && q.startContainer.type == CKEDITOR.NODE_ELEMENT && q.startContainer.getName() in j) {
                    l = new CKEDITOR.dom.walker(q);
                    l.evaluator = e;
                    q.startContainer = l.next()
                }
                if (m && q.endContainer.type == CKEDITOR.NODE_ELEMENT && q.endContainer.getName() in j) {
                    l = new CKEDITOR.dom.walker(q);
                    l.evaluator = e;
                    q.endContainer = l.previous()
                }
                if (m) return c(m)
            }
            return 0
        }

        function e(a) {
            return a.type == CKEDITOR.NODE_ELEMENT && a.is("li")
        }

        function b(a) {
            return g(a) && c(a)
        }
        var g = CKEDITOR.dom.walker.whitespaces(true),
            c = CKEDITOR.dom.walker.bookmark(false, true),
            d = CKEDITOR.TRISTATE_DISABLED,
            j = CKEDITOR.TRISTATE_OFF;
        CKEDITOR.plugins.add("indentlist", {
            requires: "indent",
            init: function(b) {
                function c(b) {
                    e.specificDefinition.apply(this, arguments);
                    this.requiredContent = ["ul", "ol"];
                    b.on("key", function(a) {
                        if (b.mode == "wysiwyg" && a.data.keyCode == this.indentKey) {
                            var c = this.getContext(b.elementPath());
                            if (c && (!this.isIndent || !CKEDITOR.plugins.indentList.firstItemInPath(this.context, b.elementPath(), c))) {
                                b.execCommand(this.relatedGlobal);
                                a.cancel()
                            }
                        }
                    }, this);
                    this.jobs[this.isIndent ? 10 : 30] = {
                        refresh: this.isIndent ? function(a, b) {
                            var c = this.getContext(b),
                                f = CKEDITOR.plugins.indentList.firstItemInPath(this.context, b, c);
                            return !c || !this.isIndent || f ? d : j
                        } : function(a, b) {
                            return !this.getContext(b) || this.isIndent ? d : j
                        },
                        exec: CKEDITOR.tools.bind(a, this)
                    }
                }
                var e = CKEDITOR.plugins.indent;
                e.registerCommands(b, {
                    indentlist: new c(b, "indentlist", true),
                    outdentlist: new c(b, "outdentlist")
                });
                CKEDITOR.tools.extend(c.prototype, e.specificDefinition.prototype, {
                    context: {
                        ol: 1,
                        ul: 1
                    }
                })
            }
        });
        CKEDITOR.plugins.indentList = {};
        CKEDITOR.plugins.indentList.firstItemInPath = function(a, b, c) {
            var d = b.contains(e);
            c || (c = b.contains(a));
            return c && d && d.equals(c.getFirst(e))
        }
    }(),
    function() {
        function a(a, b, c) {
            function d(c) {
                if ((j = i[c ? "getFirst" : "getLast"]()) && (!j.is || !j.isBlockBoundary()) && (k = b.root[c ? "getPrevious" : "getNext"](CKEDITOR.dom.walker.invisible(true))) && (!k.is || !k.isBlockBoundary({
                    br: 1
                }))) a.document.createElement("br")[c ? "insertBefore" : "insertAfter"](j)
            }
            for (var f = CKEDITOR.plugins.list.listToArray(b.root,
                c), e = [], g = 0; g < b.contents.length; g++) {
                var h = b.contents[g];
                if ((h = h.getAscendant("li", true)) && !h.getCustomData("list_item_processed")) {
                    e.push(h);
                    CKEDITOR.dom.element.setMarker(c, h, "list_item_processed", true)
                }
            }
            h = null;
            for (g = 0; g < e.length; g++) {
                h = e[g].getCustomData("listarray_index");
                f[h].indent = -1
            }
            for (g = h + 1; g < f.length; g++)
                if (f[g].indent > f[g - 1].indent + 1) {
                    e = f[g - 1].indent + 1 - f[g].indent;
                    for (h = f[g].indent; f[g] && f[g].indent >= h;) {
                        f[g].indent = f[g].indent + e;
                        g++
                    }
                    g--
                }
            var i = CKEDITOR.plugins.list.arrayToList(f, c, null,
                a.config.enterMode, b.root.getAttribute("dir")).listNode,
                j, k;
            d(true);
            d();
            i.replace(b.root);
            a.fire("contentDomInvalidated")
        }

        function e(a, b) {
            this.name = a;
            this.context = this.type = b;
            this.allowedContent = b + " li";
            this.requiredContent = b
        }

        function b(a, b, c, d) {
            for (var f, g; f = a[d ? "getLast" : "getFirst"](q);) {
                (g = f.getDirection(1)) !== b.getDirection(1) && f.setAttribute("dir", g);
                f.remove();
                c ? f[d ? "insertBefore" : "insertAfter"](c) : b.append(f, d)
            }
        }

        function g(a) {
            function c(d) {
                var f = a[d ? "getPrevious" : "getNext"](k);
                if (f && f.type ==
                    CKEDITOR.NODE_ELEMENT && f.is(a.getName())) {
                    b(a, f, null, !d);
                    a.remove();
                    a = f
                }
            }
            c();
            c(1)
        }

        function c(a) {
            return a.type == CKEDITOR.NODE_ELEMENT && (a.getName() in CKEDITOR.dtd.$block || a.getName() in CKEDITOR.dtd.$listItem) && CKEDITOR.dtd[a.getName()]["#"]
        }

        function d(a, c, d) {
            a.fire("saveSnapshot");
            d.enlarge(CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS);
            var f = d.extractContents();
            c.trim(false, true);
            var e = c.createBookmark(),
                h = new CKEDITOR.dom.elementPath(c.startContainer),
                i = h.block,
                h = h.lastElement.getAscendant("li", 1) || i,
                q = new CKEDITOR.dom.elementPath(d.startContainer),
                o = q.contains(CKEDITOR.dtd.$listItem),
                q = q.contains(CKEDITOR.dtd.$list);
            if (i)(i = i.getBogus()) && i.remove();
            else if (q)(i = q.getPrevious(k)) && n(i) && i.remove();
            (i = f.getLast()) && (i.type == CKEDITOR.NODE_ELEMENT && i.is("br")) && i.remove();
            (i = c.startContainer.getChild(c.startOffset)) ? f.insertBefore(i) : c.startContainer.append(f);
            if (o)
                if (f = j(o))
                    if (h.contains(o)) {
                        b(f, o.getParent(), o);
                        f.remove()
                    } else h.append(f);
            for (; d.checkStartOfBlock() && d.checkEndOfBlock();) {
                q = d.startPath();
                f = q.block;
                if (!f) break;
                if (f.is("li")) {
                    h =
                        f.getParent();
                    f.equals(h.getLast(k)) && f.equals(h.getFirst(k)) && (f = h)
                }
                d.moveToPosition(f, CKEDITOR.POSITION_BEFORE_START);
                f.remove()
            }
            d = d.clone();
            f = a.editable();
            d.setEndAt(f, CKEDITOR.POSITION_BEFORE_END);
            d = new CKEDITOR.dom.walker(d);
            d.evaluator = function(a) {
                return k(a) && !n(a)
            };
            (d = d.next()) && (d.type == CKEDITOR.NODE_ELEMENT && d.getName() in CKEDITOR.dtd.$list) && g(d);
            c.moveToBookmark(e);
            c.select();
            a.fire("saveSnapshot")
        }

        function j(a) {
            return (a = a.getLast(k)) && a.type == CKEDITOR.NODE_ELEMENT && a.getName() in f ? a :
                null
        }
        var f = {
            ol: 1,
            ul: 1
        }, h = CKEDITOR.dom.walker.whitespaces(),
            i = CKEDITOR.dom.walker.bookmark(),
            k = function(a) {
                return !(h(a) || i(a))
            }, n = CKEDITOR.dom.walker.bogus();
        CKEDITOR.plugins.list = {
            listToArray: function(a, b, c, d, g) {
                if (!f[a.getName()]) return [];
                d || (d = 0);
                c || (c = []);
                for (var e = 0, h = a.getChildCount(); e < h; e++) {
                    var i = a.getChild(e);
                    i.type == CKEDITOR.NODE_ELEMENT && i.getName() in CKEDITOR.dtd.$list && CKEDITOR.plugins.list.listToArray(i, b, c, d + 1);
                    if (i.$.nodeName.toLowerCase() == "li") {
                        var j = {
                            parent: a,
                            indent: d,
                            element: i,
                            contents: []
                        };
                        if (g) j.grandparent = g;
                        else {
                            j.grandparent = a.getParent();
                            if (j.grandparent && j.grandparent.$.nodeName.toLowerCase() == "li") j.grandparent = j.grandparent.getParent()
                        }
                        b && CKEDITOR.dom.element.setMarker(b, i, "listarray_index", c.length);
                        c.push(j);
                        for (var k = 0, n = i.getChildCount(), q; k < n; k++) {
                            q = i.getChild(k);
                            q.type == CKEDITOR.NODE_ELEMENT && f[q.getName()] ? CKEDITOR.plugins.list.listToArray(q, b, c, d + 1, j.grandparent) : j.contents.push(q)
                        }
                    }
                }
                return c
            },
            arrayToList: function(a, b, c, d, g) {
                c || (c = 0);
                if (!a || a.length < c + 1) return null;
                for (var e, h = a[c].parent.getDocument(), j = new CKEDITOR.dom.documentFragment(h), n = null, q = c, o = Math.max(a[c].indent, 0), z = null, B, A, G = d == CKEDITOR.ENTER_P ? "p" : "div";;) {
                    var D = a[q];
                    e = D.grandparent;
                    B = D.element.getDirection(1);
                    if (D.indent == o) {
                        if (!n || a[q].parent.getName() != n.getName()) {
                            n = a[q].parent.clone(false, 1);
                            g && n.setAttribute("dir", g);
                            j.append(n)
                        }
                        z = n.append(D.element.clone(0, 1));
                        B != n.getDirection(1) && z.setAttribute("dir", B);
                        for (e = 0; e < D.contents.length; e++) z.append(D.contents[e].clone(1, 1));
                        q++
                    } else if (D.indent ==
                        Math.max(o, 0) + 1) {
                        D = a[q - 1].element.getDirection(1);
                        q = CKEDITOR.plugins.list.arrayToList(a, null, q, d, D != B ? B : null);
                        !z.getChildCount() && (CKEDITOR.env.needsNbspFiller && h.$.documentMode <= 7) && z.append(h.createText(" "));
                        z.append(q.listNode);
                        q = q.nextIndex
                    } else if (D.indent == -1 && !c && e) {
                        if (f[e.getName()]) {
                            z = D.element.clone(false, true);
                            B != e.getDirection(1) && z.setAttribute("dir", B)
                        } else z = new CKEDITOR.dom.documentFragment(h);
                        var n = e.getDirection(1) != B,
                            J = D.element,
                            C = J.getAttribute("class"),
                            F = J.getAttribute("style"),
                            E = z.type == CKEDITOR.NODE_DOCUMENT_FRAGMENT && (d != CKEDITOR.ENTER_BR || n || F || C),
                            I, L = D.contents.length,
                            H;
                        for (e = 0; e < L; e++) {
                            I = D.contents[e];
                            if (i(I) && L > 1) E ? H = I.clone(1, 1) : z.append(I.clone(1, 1));
                            else if (I.type == CKEDITOR.NODE_ELEMENT && I.isBlockBoundary()) {
                                n && !I.getDirection() && I.setAttribute("dir", B);
                                A = I;
                                var Q = J.getAttribute("style");
                                Q && A.setAttribute("style", Q.replace(/([^;])$/, "$1;") + (A.getAttribute("style") || ""));
                                C && I.addClass(C);
                                A = null;
                                if (H) {
                                    z.append(H);
                                    H = null
                                }
                                z.append(I.clone(1, 1))
                            } else if (E) {
                                if (!A) {
                                    A =
                                        h.createElement(G);
                                    z.append(A);
                                    n && A.setAttribute("dir", B)
                                }
                                F && A.setAttribute("style", F);
                                C && A.setAttribute("class", C);
                                if (H) {
                                    A.append(H);
                                    H = null
                                }
                                A.append(I.clone(1, 1))
                            } else z.append(I.clone(1, 1))
                        }
                        if (H) {
                            (A || z).append(H);
                            H = null
                        }
                        if (z.type == CKEDITOR.NODE_DOCUMENT_FRAGMENT && q != a.length - 1) {
                            if (CKEDITOR.env.needsBrFiller)(B = z.getLast()) && (B.type == CKEDITOR.NODE_ELEMENT && B.is("br")) && B.remove();
                            B = z.getLast(k);
                            (!B || !(B.type == CKEDITOR.NODE_ELEMENT && B.is(CKEDITOR.dtd.$block))) && z.append(h.createElement("br"))
                        }
                        B = z.$.nodeName.toLowerCase();
                        (B == "div" || B == "p") && z.appendBogus();
                        j.append(z);
                        n = null;
                        q++
                    } else return null;
                    A = null;
                    if (a.length <= q || Math.max(a[q].indent, 0) < o) break
                }
                if (b)
                    for (a = j.getFirst(); a;) {
                        if (a.type == CKEDITOR.NODE_ELEMENT) {
                            CKEDITOR.dom.element.clearMarkers(b, a);
                            if (a.getName() in CKEDITOR.dtd.$listItem) {
                                c = a;
                                h = g = d = void 0;
                                if (d = c.getDirection()) {
                                    for (g = c.getParent(); g && !(h = g.getDirection());) g = g.getParent();
                                    d == h && c.removeAttribute("dir")
                                }
                            }
                        }
                        a = a.getNextSourceNode()
                    }
                return {
                    listNode: j,
                    nextIndex: q
                }
            }
        };
        var o = /^h[1-6]$/,
            q = CKEDITOR.dom.walker.nodeType(CKEDITOR.NODE_ELEMENT);
        e.prototype = {
            exec: function(b) {
                this.refresh(b, b.elementPath());
                var c = b.config,
                    d = b.getSelection(),
                    e = d && d.getRanges();
                if (this.state == CKEDITOR.TRISTATE_OFF) {
                    var h = b.editable();
                    if (h.getFirst(k)) {
                        var i = e.length == 1 && e[0];
                        (c = i && i.getEnclosedNode()) && (c.is && this.type == c.getName()) && this.setState(CKEDITOR.TRISTATE_ON)
                    } else {
                        c.enterMode == CKEDITOR.ENTER_BR ? h.appendBogus() : e[0].fixBlock(1, c.enterMode == CKEDITOR.ENTER_P ? "p" : "div");
                        d.selectRanges(e)
                    }
                }
                for (var c = d.createBookmarks(true), h = [], j = {}, e = e.createIterator(),
                        n = 0;
                    (i = e.getNextRange()) && ++n;) {
                    var q = i.getBoundaryNodes(),
                        r = q.startNode,
                        y = q.endNode;
                    r.type == CKEDITOR.NODE_ELEMENT && r.getName() == "td" && i.setStartAt(q.startNode, CKEDITOR.POSITION_AFTER_START);
                    y.type == CKEDITOR.NODE_ELEMENT && y.getName() == "td" && i.setEndAt(q.endNode, CKEDITOR.POSITION_BEFORE_END);
                    i = i.createIterator();
                    for (i.forceBrBreak = this.state == CKEDITOR.TRISTATE_OFF; q = i.getNextParagraph();)
                        if (!q.getCustomData("list_block")) {
                            CKEDITOR.dom.element.setMarker(j, q, "list_block", 1);
                            for (var z = b.elementPath(q),
                                    r = z.elements, y = 0, z = z.blockLimit, B, A = r.length - 1; A >= 0 && (B = r[A]); A--)
                                if (f[B.getName()] && z.contains(B)) {
                                    z.removeCustomData("list_group_object_" + n);
                                    if (r = B.getCustomData("list_group_object")) r.contents.push(q);
                                    else {
                                        r = {
                                            root: B,
                                            contents: [q]
                                        };
                                        h.push(r);
                                        CKEDITOR.dom.element.setMarker(j, B, "list_group_object", r)
                                    }
                                    y = 1;
                                    break
                                }
                            if (!y) {
                                y = z;
                                if (y.getCustomData("list_group_object_" + n)) y.getCustomData("list_group_object_" + n).contents.push(q);
                                else {
                                    r = {
                                        root: y,
                                        contents: [q]
                                    };
                                    CKEDITOR.dom.element.setMarker(j, y, "list_group_object_" +
                                        n, r);
                                    h.push(r)
                                }
                            }
                        }
                }
                for (B = []; h.length > 0;) {
                    r = h.shift();
                    if (this.state == CKEDITOR.TRISTATE_OFF)
                        if (f[r.root.getName()]) {
                            e = b;
                            n = r;
                            r = j;
                            i = B;
                            y = CKEDITOR.plugins.list.listToArray(n.root, r);
                            z = [];
                            for (q = 0; q < n.contents.length; q++) {
                                A = n.contents[q];
                                if ((A = A.getAscendant("li", true)) && !A.getCustomData("list_item_processed")) {
                                    z.push(A);
                                    CKEDITOR.dom.element.setMarker(r, A, "list_item_processed", true)
                                }
                            }
                            for (var A = n.root.getDocument(), G = void 0, D = void 0, q = 0; q < z.length; q++) {
                                var J = z[q].getCustomData("listarray_index"),
                                    G = y[J].parent;
                                if (!G.is(this.type)) {
                                    D = A.createElement(this.type);
                                    G.copyAttributes(D, {
                                        start: 1,
                                        type: 1
                                    });
                                    D.removeStyle("list-style-type");
                                    y[J].parent = D
                                }
                            }
                            r = CKEDITOR.plugins.list.arrayToList(y, r, null, e.config.enterMode);
                            y = void 0;
                            z = r.listNode.getChildCount();
                            for (q = 0; q < z && (y = r.listNode.getChild(q)); q++) y.getName() == this.type && i.push(y);
                            r.listNode.replace(n.root);
                            e.fire("contentDomInvalidated")
                        } else {
                            y = b;
                            q = r;
                            i = B;
                            z = q.contents;
                            e = q.root.getDocument();
                            n = [];
                            if (z.length == 1 && z[0].equals(q.root)) {
                                r = e.createElement("div");
                                z[0].moveChildren &&
                                    z[0].moveChildren(r);
                                z[0].append(r);
                                z[0] = r
                            }
                            q = q.contents[0].getParent();
                            for (A = 0; A < z.length; A++) q = q.getCommonAncestor(z[A].getParent());
                            G = y.config.useComputedState;
                            y = r = void 0;
                            G = G === void 0 || G;
                            for (A = 0; A < z.length; A++)
                                for (D = z[A]; J = D.getParent();) {
                                    if (J.equals(q)) {
                                        n.push(D);
                                        !y && D.getDirection() && (y = 1);
                                        D = D.getDirection(G);
                                        r !== null && (r = r && r != D ? null : D);
                                        break
                                    }
                                    D = J
                                }
                            if (!(n.length < 1)) {
                                z = n[n.length - 1].getNext();
                                A = e.createElement(this.type);
                                i.push(A);
                                for (G = i = void 0; n.length;) {
                                    i = n.shift();
                                    G = e.createElement("li");
                                    if (i.is("pre") ||
                                        o.test(i.getName()) || i.getAttribute("contenteditable") == "false") i.appendTo(G);
                                    else {
                                        i.copyAttributes(G);
                                        if (r && i.getDirection()) {
                                            G.removeStyle("direction");
                                            G.removeAttribute("dir")
                                        }
                                        i.moveChildren(G);
                                        i.remove()
                                    }
                                    G.appendTo(A)
                                }
                                r && y && A.setAttribute("dir", r);
                                z ? A.insertBefore(z) : A.appendTo(q)
                            }
                        } else this.state == CKEDITOR.TRISTATE_ON && f[r.root.getName()] && a.call(this, b, r, j)
                }
                for (A = 0; A < B.length; A++) g(B[A]);
                CKEDITOR.dom.element.clearAllMarkers(j);
                d.selectBookmarks(c);
                b.focus()
            },
            refresh: function(a, b) {
                var c = b.contains(f,
                    1),
                    d = b.blockLimit || b.root;
                c && d.contains(c) ? this.setState(c.is(this.type) ? CKEDITOR.TRISTATE_ON : CKEDITOR.TRISTATE_OFF) : this.setState(CKEDITOR.TRISTATE_OFF)
            }
        };
        CKEDITOR.plugins.add("list", {
            requires: "indentlist",
            init: function(a) {
                if (!a.blockless) {
                    a.addCommand("numberedlist", new e("numberedlist", "ol"));
                    a.addCommand("bulletedlist", new e("bulletedlist", "ul"));
                    if (a.ui.addButton) {
                        a.ui.addButton("NumberedList", {
                            label: a.lang.list.numberedlist,
                            command: "numberedlist",
                            directional: true,
                            toolbar: "list,10"
                        });
                        a.ui.addButton("BulletedList", {
                            label: a.lang.list.bulletedlist,
                            command: "bulletedlist",
                            directional: true,
                            toolbar: "list,20"
                        })
                    }
                    a.on("key", function(b) {
                        var e = b.data.domEvent.getKey(),
                            g;
                        if (a.mode == "wysiwyg" && e in {
                            8: 1,
                            46: 1
                        }) {
                            var h = a.getSelection().getRanges()[0],
                                i = h && h.startPath();
                            if (h && h.collapsed) {
                                var q = e == 8,
                                    o = a.editable(),
                                    v = new CKEDITOR.dom.walker(h.clone());
                                v.evaluator = function(a) {
                                    return k(a) && !n(a)
                                };
                                v.guard = function(a, b) {
                                    return !(b && a.type == CKEDITOR.NODE_ELEMENT && a.is("table"))
                                };
                                e = h.clone();
                                if (q) {
                                    var r;
                                    if ((r = i.contains(f)) && h.checkBoundaryOfElement(r,
                                        CKEDITOR.START) && (r = r.getParent()) && r.is("li") && (r = j(r))) {
                                        g = r;
                                        r = r.getPrevious(k);
                                        e.moveToPosition(r && n(r) ? r : g, CKEDITOR.POSITION_BEFORE_START)
                                    } else {
                                        v.range.setStartAt(o, CKEDITOR.POSITION_AFTER_START);
                                        v.range.setEnd(h.startContainer, h.startOffset);
                                        if ((r = v.previous()) && r.type == CKEDITOR.NODE_ELEMENT && (r.getName() in f || r.is("li"))) {
                                            if (!r.is("li")) {
                                                v.range.selectNodeContents(r);
                                                v.reset();
                                                v.evaluator = c;
                                                r = v.previous()
                                            }
                                            g = r;
                                            e.moveToElementEditEnd(g)
                                        }
                                    } if (g) {
                                        d(a, e, h);
                                        b.cancel()
                                    } else if ((e = i.contains(f)) && h.checkBoundaryOfElement(e,
                                        CKEDITOR.START)) {
                                        g = e.getFirst(k);
                                        if (h.checkBoundaryOfElement(g, CKEDITOR.START)) {
                                            r = e.getPrevious(k);
                                            if (j(g)) {
                                                if (r) {
                                                    h.moveToElementEditEnd(r);
                                                    h.select()
                                                }
                                            } else a.execCommand("outdent");
                                            b.cancel()
                                        }
                                    }
                                } else if (g = i.contains("li")) {
                                    v.range.setEndAt(o, CKEDITOR.POSITION_BEFORE_END);
                                    g = (i = g.getLast(k)) && c(i) ? i : g;
                                    o = 0;
                                    if ((r = v.next()) && r.type == CKEDITOR.NODE_ELEMENT && r.getName() in f && r.equals(i)) {
                                        o = 1;
                                        r = v.next()
                                    } else h.checkBoundaryOfElement(g, CKEDITOR.END) && (o = 1); if (o && r) {
                                        h = h.clone();
                                        h.moveToElementEditStart(r);
                                        d(a,
                                            e, h);
                                        b.cancel()
                                    }
                                } else {
                                    v.range.setEndAt(o, CKEDITOR.POSITION_BEFORE_END);
                                    if ((r = v.next()) && r.type == CKEDITOR.NODE_ELEMENT && r.is(f)) {
                                        r = r.getFirst(k);
                                        if (i.block && h.checkStartOfBlock() && h.checkEndOfBlock()) {
                                            i.block.remove();
                                            h.moveToElementEditStart(r);
                                            h.select()
                                        } else if (j(r)) {
                                            h.moveToElementEditStart(r);
                                            h.select()
                                        } else {
                                            h = h.clone();
                                            h.moveToElementEditStart(r);
                                            d(a, e, h)
                                        }
                                        b.cancel()
                                    }
                                }
                                setTimeout(function() {
                                    a.selectionChange(1)
                                })
                            }
                        }
                    })
                }
            }
        })
    }(),
    function() {
        function a(a, b, c) {
            c = a.config.forceEnterMode || c;
            if (a.mode == "wysiwyg") {
                if (!b) b =
                    a.activeEnterMode;
                if (!a.elementPath().isContextFor("p")) {
                    b = CKEDITOR.ENTER_BR;
                    c = 1
                }
                a.fire("saveSnapshot");
                b == CKEDITOR.ENTER_BR ? j(a, b, null, c) : f(a, b, null, c);
                a.fire("saveSnapshot")
            }
        }

        function e(a) {
            for (var a = a.getSelection().getRanges(true), b = a.length - 1; b > 0; b--) a[b].deleteContents();
            return a[0]
        }

        function b(a) {
            var b = a.startContainer.getAscendant(function(a) {
                return a.type == CKEDITOR.NODE_ELEMENT && a.getAttribute("contenteditable") == "true"
            }, true);
            if (a.root.equals(b)) return a;
            b = new CKEDITOR.dom.range(b);
            b.moveToRange(a);
            return b
        }
        CKEDITOR.plugins.add("enterkey", {
            init: function(b) {
                b.addCommand("enter", {
                    modes: {
                        wysiwyg: 1
                    },
                    editorFocus: false,
                    exec: function(b) {
                        a(b)
                    }
                });
                b.addCommand("shiftEnter", {
                    modes: {
                        wysiwyg: 1
                    },
                    editorFocus: false,
                    exec: function(b) {
                        a(b, b.activeShiftEnterMode, 1)
                    }
                });
                b.setKeystroke([
                    [13, "enter"],
                    [CKEDITOR.SHIFT + 13, "shiftEnter"]
                ])
            }
        });
        var g = CKEDITOR.dom.walker.whitespaces(),
            c = CKEDITOR.dom.walker.bookmark();
        CKEDITOR.plugins.enterkey = {
            enterBlock: function(a, d, f, o) {
                if (f = f || e(a)) {
                    var f = b(f),
                        q = f.document,
                        m = f.checkStartOfBlock(),
                        l = f.checkEndOfBlock(),
                        p = a.elementPath(f.startContainer),
                        t = p.block,
                        s = d == CKEDITOR.ENTER_DIV ? "div" : "p",
                        u;
                    if (m && l) {
                        if (t && (t.is("li") || t.getParent().is("li"))) {
                            t.is("li") || (t = t.getParent());
                            f = t.getParent();
                            u = f.getParent();
                            var o = !t.hasPrevious(),
                                w = !t.hasNext(),
                                s = a.getSelection(),
                                x = s.createBookmarks(),
                                m = t.getDirection(1),
                                l = t.getAttribute("class"),
                                v = t.getAttribute("style"),
                                r = u.getDirection(1) != m,
                                a = a.enterMode != CKEDITOR.ENTER_BR || r || v || l;
                            if (u.is("li"))
                                if (o || w) t[o ? "insertBefore" : "insertAfter"](u);
                                else t.breakParent(u);
                                else {
                                    if (a) {
                                        if (p.block.is("li")) {
                                            u = q.createElement(d == CKEDITOR.ENTER_P ? "p" : "div");
                                            r && u.setAttribute("dir", m);
                                            v && u.setAttribute("style", v);
                                            l && u.setAttribute("class", l);
                                            t.moveChildren(u)
                                        } else u = p.block; if (o || w) u[o ? "insertBefore" : "insertAfter"](f);
                                        else {
                                            t.breakParent(f);
                                            u.insertAfter(f)
                                        }
                                    } else {
                                        t.appendBogus(true);
                                        if (o || w)
                                            for (; q = t[o ? "getFirst" : "getLast"]();) q[o ? "insertBefore" : "insertAfter"](f);
                                        else
                                            for (t.breakParent(f); q = t.getLast();) q.insertAfter(f)
                                    }
                                    t.remove()
                                }
                            s.selectBookmarks(x);
                            return
                        }
                        if (t && t.getParent().is("blockquote")) {
                            t.breakParent(t.getParent());
                            t.getPrevious().getFirst(CKEDITOR.dom.walker.invisible(1)) || t.getPrevious().remove();
                            t.getNext().getFirst(CKEDITOR.dom.walker.invisible(1)) || t.getNext().remove();
                            f.moveToElementEditStart(t);
                            f.select();
                            return
                        }
                    } else if (t && t.is("pre") && !l) {
                        j(a, d, f, o);
                        return
                    }
                    if (m = f.splitBlock(s)) {
                        d = m.previousBlock;
                        t = m.nextBlock;
                        p = m.wasStartOfBlock;
                        a = m.wasEndOfBlock;
                        if (t) {
                            x = t.getParent();
                            if (x.is("li")) {
                                t.breakParent(x);
                                t.move(t.getNext(), 1)
                            }
                        } else if (d && (x = d.getParent()) && x.is("li")) {
                            d.breakParent(x);
                            x = d.getNext();
                            f.moveToElementEditStart(x);
                            d.move(d.getPrevious())
                        }
                        if (!p && !a) {
                            if (t.is("li")) {
                                u = f.clone();
                                u.selectNodeContents(t);
                                u = new CKEDITOR.dom.walker(u);
                                u.evaluator = function(a) {
                                    return !(c(a) || g(a) || a.type == CKEDITOR.NODE_ELEMENT && a.getName() in CKEDITOR.dtd.$inline && !(a.getName() in CKEDITOR.dtd.$empty))
                                };
                                (x = u.next()) && (x.type == CKEDITOR.NODE_ELEMENT && x.is("ul", "ol")) && (CKEDITOR.env.needsBrFiller ? q.createElement("br") : q.createText(" ")).insertBefore(x)
                            }
                            t && f.moveToElementEditStart(t)
                        } else {
                            if (d) {
                                if (d.is("li") || !h.test(d.getName()) && !d.is("pre")) u =
                                    d.clone()
                            } else t && (u = t.clone()); if (u) o && !u.is("li") && u.renameNode(s);
                            else if (x && x.is("li")) u = x;
                            else {
                                u = q.createElement(s);
                                d && (w = d.getDirection()) && u.setAttribute("dir", w)
                            } if (q = m.elementPath) {
                                o = 0;
                                for (s = q.elements.length; o < s; o++) {
                                    x = q.elements[o];
                                    if (x.equals(q.block) || x.equals(q.blockLimit)) break;
                                    if (CKEDITOR.dtd.$removeEmpty[x.getName()]) {
                                        x = x.clone();
                                        u.moveChildren(x);
                                        u.append(x)
                                    }
                                }
                            }
                            u.appendBogus();
                            u.getParent() || f.insertNode(u);
                            u.is("li") && u.removeAttribute("value");
                            if (CKEDITOR.env.ie && p && (!a || !d.getChildCount())) {
                                f.moveToElementEditStart(a ?
                                    d : u);
                                f.select()
                            }
                            f.moveToElementEditStart(p && !a ? t : u)
                        }
                        f.select();
                        f.scrollIntoView()
                    }
                }
            },
            enterBr: function(a, b, c, d) {
                if (c = c || e(a)) {
                    var g = c.document,
                        j = c.checkEndOfBlock(),
                        l = new CKEDITOR.dom.elementPath(a.getSelection().getStartElement()),
                        p = l.block,
                        t = p && l.block.getName();
                    if (!d && t == "li") f(a, b, c, d);
                    else {
                        if (!d && j && h.test(t))
                            if (j = p.getDirection()) {
                                g = g.createElement("div");
                                g.setAttribute("dir", j);
                                g.insertAfter(p);
                                c.setStart(g, 0)
                            } else {
                                g.createElement("br").insertAfter(p);
                                CKEDITOR.env.gecko && g.createText("").insertAfter(p);
                                c.setStartAt(p.getNext(), CKEDITOR.env.ie ? CKEDITOR.POSITION_BEFORE_START : CKEDITOR.POSITION_AFTER_START)
                            } else {
                                a = t == "pre" && CKEDITOR.env.ie && CKEDITOR.env.version < 8 ? g.createText("\r") : g.createElement("br");
                                c.deleteContents();
                                c.insertNode(a);
                                if (CKEDITOR.env.needsBrFiller) {
                                    g.createText("﻿").insertAfter(a);
                                    j && (p || l.blockLimit).appendBogus();
                                    a.getNext().$.nodeValue = "";
                                    c.setStartAt(a.getNext(), CKEDITOR.POSITION_AFTER_START)
                                } else c.setStartAt(a, CKEDITOR.POSITION_AFTER_END)
                            }
                        c.collapse(true);
                        c.select();
                        c.scrollIntoView()
                    }
                }
            }
        };
        var d = CKEDITOR.plugins.enterkey,
            j = d.enterBr,
            f = d.enterBlock,
            h = /^h[1-6]$/
    }(),
    function() {
        function a(a, b) {
            var g = {}, c = [],
                d = {
                    nbsp: " ",
                    shy: "­",
                    gt: ">",
                    lt: "<",
                    amp: "&",
                    apos: "'",
                    quot: '"'
                }, a = a.replace(/\b(nbsp|shy|gt|lt|amp|apos|quot)(?:,|$)/g, function(a, f) {
                    var e = b ? "&" + f + ";" : d[f];
                    g[e] = b ? d[f] : "&" + f + ";";
                    c.push(e);
                    return ""
                });
            if (!b && a) {
                var a = a.split(","),
                    j = document.createElement("div"),
                    f;
                j.innerHTML = "&" + a.join(";&") + ";";
                f = j.innerHTML;
                j = null;
                for (j = 0; j < f.length; j++) {
                    var h = f.charAt(j);
                    g[h] = "&" + a[j] + ";";
                    c.push(h)
                }
            }
            g.regex =
                c.join(b ? "|" : "");
            return g
        }
        CKEDITOR.plugins.add("entities", {
            afterInit: function(e) {
                function b(a) {
                    return h[a]
                }

                function g(a) {
                    return c.entities_processNumerical == "force" || !j[a] ? "&#" + a.charCodeAt(0) + ";" : j[a]
                }
                var c = e.config;
                if (e = (e = e.dataProcessor) && e.htmlFilter) {
                    var d = [];
                    c.basicEntities !== false && d.push("nbsp,gt,lt,amp");
                    if (c.entities) {
                        d.length && d.push("quot,iexcl,cent,pound,curren,yen,brvbar,sect,uml,copy,ordf,laquo,not,shy,reg,macr,deg,plusmn,sup2,sup3,acute,micro,para,middot,cedil,sup1,ordm,raquo,frac14,frac12,frac34,iquest,times,divide,fnof,bull,hellip,prime,Prime,oline,frasl,weierp,image,real,trade,alefsym,larr,uarr,rarr,darr,harr,crarr,lArr,uArr,rArr,dArr,hArr,forall,part,exist,empty,nabla,isin,notin,ni,prod,sum,minus,lowast,radic,prop,infin,ang,and,or,cap,cup,int,there4,sim,cong,asymp,ne,equiv,le,ge,sub,sup,nsub,sube,supe,oplus,otimes,perp,sdot,lceil,rceil,lfloor,rfloor,lang,rang,loz,spades,clubs,hearts,diams,circ,tilde,ensp,emsp,thinsp,zwnj,zwj,lrm,rlm,ndash,mdash,lsquo,rsquo,sbquo,ldquo,rdquo,bdquo,dagger,Dagger,permil,lsaquo,rsaquo,euro");
                        c.entities_latin && d.push("Agrave,Aacute,Acirc,Atilde,Auml,Aring,AElig,Ccedil,Egrave,Eacute,Ecirc,Euml,Igrave,Iacute,Icirc,Iuml,ETH,Ntilde,Ograve,Oacute,Ocirc,Otilde,Ouml,Oslash,Ugrave,Uacute,Ucirc,Uuml,Yacute,THORN,szlig,agrave,aacute,acirc,atilde,auml,aring,aelig,ccedil,egrave,eacute,ecirc,euml,igrave,iacute,icirc,iuml,eth,ntilde,ograve,oacute,ocirc,otilde,ouml,oslash,ugrave,uacute,ucirc,uuml,yacute,thorn,yuml,OElig,oelig,Scaron,scaron,Yuml");
                        c.entities_greek && d.push("Alpha,Beta,Gamma,Delta,Epsilon,Zeta,Eta,Theta,Iota,Kappa,Lambda,Mu,Nu,Xi,Omicron,Pi,Rho,Sigma,Tau,Upsilon,Phi,Chi,Psi,Omega,alpha,beta,gamma,delta,epsilon,zeta,eta,theta,iota,kappa,lambda,mu,nu,xi,omicron,pi,rho,sigmaf,sigma,tau,upsilon,phi,chi,psi,omega,thetasym,upsih,piv");
                        c.entities_additional && d.push(c.entities_additional)
                    }
                    var j = a(d.join(",")),
                        f = j.regex ? "[" + j.regex + "]" : "a^";
                    delete j.regex;
                    c.entities && c.entities_processNumerical && (f = "[^ -~]|" + f);
                    var f = RegExp(f, "g"),
                        h = a("nbsp,gt,lt,amp,shy", true),
                        i = RegExp(h.regex, "g");
                    e.addRules({
                        text: function(a) {
                            return a.replace(i, b).replace(f, g)
                        }
                    }, {
                        applyToAll: true,
                        excludeNestedEditable: true
                    })
                }
            }
        })
    }(), CKEDITOR.config.basicEntities = !0, CKEDITOR.config.entities = !0, CKEDITOR.config.entities_latin = !0, CKEDITOR.config.entities_greek = !0, CKEDITOR.config.entities_additional =
        "#39", CKEDITOR.plugins.add("popup"), CKEDITOR.tools.extend(CKEDITOR.editor.prototype, {
            popup: function(a, e, b, g) {
                e = e || "80%";
                b = b || "70%";
                typeof e == "string" && (e.length > 1 && e.substr(e.length - 1, 1) == "%") && (e = parseInt(window.screen.width * parseInt(e, 10) / 100, 10));
                typeof b == "string" && (b.length > 1 && b.substr(b.length - 1, 1) == "%") && (b = parseInt(window.screen.height * parseInt(b, 10) / 100, 10));
                e < 640 && (e = 640);
                b < 420 && (b = 420);
                var c = parseInt((window.screen.height - b) / 2, 10),
                    d = parseInt((window.screen.width - e) / 2, 10),
                    g = (g || "location=no,menubar=no,toolbar=no,dependent=yes,minimizable=no,modal=yes,alwaysRaised=yes,resizable=yes,scrollbars=yes") +
                        ",width=" + e + ",height=" + b + ",top=" + c + ",left=" + d,
                    j = window.open("", null, g, true);
                if (!j) return false;
                try {
                    if (navigator.userAgent.toLowerCase().indexOf(" chrome/") == -1) {
                        j.moveTo(d, c);
                        j.resizeTo(e, b)
                    }
                    j.focus();
                    j.location.href = a
                } catch (f) {
                    window.open(a, null, g, true)
                }
                return true
            }
        }),
    function() {
        function a(a, b) {
            var c = [];
            if (b)
                for (var d in b) c.push(d + "=" + encodeURIComponent(b[d]));
            else return a;
            return a + (a.indexOf("?") != -1 ? "&" : "?") + c.join("&")
        }

        function e(a) {
            a = a + "";
            return a.charAt(0).toUpperCase() + a.substr(1)
        }

        function b() {
            var b =
                this.getDialog(),
                c = b.getParentEditor();
            c._.filebrowserSe = this;
            var d = c.config["filebrowser" + e(b.getName()) + "WindowWidth"] || c.config.filebrowserWindowWidth || "80%",
                b = c.config["filebrowser" + e(b.getName()) + "WindowHeight"] || c.config.filebrowserWindowHeight || "70%",
                f = this.filebrowser.params || {};
            f.CKEditor = c.name;
            f.CKEditorFuncNum = c._.filebrowserFn;
            if (!f.langCode) f.langCode = c.langCode;
            f = a(this.filebrowser.url, f);
            c.popup(f, d, b, c.config.filebrowserWindowFeatures || c.config.fileBrowserWindowFeatures)
        }

        function g() {
            var a =
                this.getDialog();
            a.getParentEditor()._.filebrowserSe = this;
            return !a.getContentElement(this["for"][0], this["for"][1]).getInputElement().$.value || !a.getContentElement(this["for"][0], this["for"][1]).getAction() ? false : true
        }

        function c(b, c, d) {
            var f = d.params || {};
            f.CKEditor = b.name;
            f.CKEditorFuncNum = b._.filebrowserFn;
            if (!f.langCode) f.langCode = b.langCode;
            c.action = a(d.url, f);
            c.filebrowser = d
        }

        function d(a, f, j, n) {
            if (n && n.length)
                for (var o, q = n.length; q--;) {
                    o = n[q];
                    (o.type == "hbox" || o.type == "vbox" || o.type == "fieldset") &&
                        d(a, f, j, o.children);
                    if (o.filebrowser) {
                        if (typeof o.filebrowser == "string") o.filebrowser = {
                            action: o.type == "fileButton" ? "QuickUpload" : "Browse",
                            target: o.filebrowser
                        };
                        if (o.filebrowser.action == "Browse") {
                            var m = o.filebrowser.url;
                            if (m === void 0) {
                                m = a.config["filebrowser" + e(f) + "BrowseUrl"];
                                if (m === void 0) m = a.config.filebrowserBrowseUrl
                            }
                            if (m) {
                                o.onClick = b;
                                o.filebrowser.url = m;
                                o.hidden = false
                            }
                        } else if (o.filebrowser.action == "QuickUpload" && o["for"]) {
                            m = o.filebrowser.url;
                            if (m === void 0) {
                                m = a.config["filebrowser" + e(f) + "UploadUrl"];
                                if (m === void 0) m = a.config.filebrowserUploadUrl
                            }
                            if (m) {
                                var l = o.onClick;
                                o.onClick = function(a) {
                                    var b = a.sender;
                                    return l && l.call(b, a) === false ? false : g.call(b, a)
                                };
                                o.filebrowser.url = m;
                                o.hidden = false;
                                c(a, j.getContents(o["for"][0]).get(o["for"][1]), o.filebrowser)
                            }
                        }
                    }
                }
        }

        function j(a, b, c) {
            if (c.indexOf(";") !== -1) {
                for (var c = c.split(";"), d = 0; d < c.length; d++)
                    if (j(a, b, c[d])) return true;
                return false
            }
            return (a = a.getContents(b).get(c).filebrowser) && a.url
        }

        function f(a, b) {
            var c = this._.filebrowserSe.getDialog(),
                d = this._.filebrowserSe["for"],
                f = this._.filebrowserSe.filebrowser.onSelect;
            d && c.getContentElement(d[0], d[1]).reset();
            if (!(typeof b == "function" && b.call(this._.filebrowserSe) === false) && !(f && f.call(this._.filebrowserSe, a, b) === false)) {
                typeof b == "string" && b && alert(b);
                if (a) {
                    d = this._.filebrowserSe;
                    c = d.getDialog();
                    if (d = d.filebrowser.target || null) {
                        d = d.split(":");
                        if (f = c.getContentElement(d[0], d[1])) {
                            f.setValue(a);
                            c.selectPage(d[0])
                        }
                    }
                }
            }
        }
        CKEDITOR.plugins.add("filebrowser", {
            requires: "popup",
            init: function(a) {
                a._.filebrowserFn = CKEDITOR.tools.addFunction(f,
                    a);
                a.on("destroy", function() {
                    CKEDITOR.tools.removeFunction(this._.filebrowserFn)
                })
            }
        });
        CKEDITOR.on("dialogDefinition", function(a) {
            if (a.editor.plugins.filebrowser)
                for (var b = a.data.definition, c, f = 0; f < b.contents.length; ++f)
                    if (c = b.contents[f]) {
                        d(a.editor, a.data.name, b, c.elements);
                        if (c.hidden && c.filebrowser) c.hidden = !j(b, c.id, c.filebrowser)
                    }
        })
    }(),
    function() {
        function a(a) {
            var c = a.config,
                d = a.fire("uiSpace", {
                    space: "top",
                    html: ""
                }).html,
                j = function() {
                    function d(a, c, f) {
                        h.setStyle(c, b(f));
                        h.setStyle("position",
                            a)
                    }

                    function f(a) {
                        var b = k.getDocumentPosition();
                        switch (a) {
                            case "top":
                                d("absolute", "top", b.y - s - x);
                                break;
                            case "pin":
                                d("fixed", "top", r);
                                break;
                            case "bottom":
                                d("absolute", "top", b.y + (p.height || p.bottom - p.top) + x)
                        }
                        i = a
                    }
                    var i, k, l, p, t, s, u, w = c.floatSpaceDockedOffsetX || 0,
                        x = c.floatSpaceDockedOffsetY || 0,
                        v = c.floatSpacePinnedOffsetX || 0,
                        r = c.floatSpacePinnedOffsetY || 0;
                    return function(c) {
                        if (k = a.editable()) {
                            c && c.name == "focus" && h.show();
                            h.removeStyle("left");
                            h.removeStyle("right");
                            l = h.getClientRect();
                            p = k.getClientRect();
                            t = e.getViewPaneSize();
                            s = l.height;
                            u = "pageXOffset" in e.$ ? e.$.pageXOffset : CKEDITOR.document.$.documentElement.scrollLeft;
                            if (i) {
                                s + x <= p.top ? f("top") : s + x > t.height - p.bottom ? f("pin") : f("bottom");
                                var c = t.width / 2,
                                    c = p.left > 0 && p.right < t.width && p.width > l.width ? a.config.contentsLangDirection == "rtl" ? "right" : "left" : c - p.left > p.right - c ? "left" : "right",
                                    d;
                                if (l.width > t.width) {
                                    c = "left";
                                    d = 0
                                } else {
                                    d = c == "left" ? p.left > 0 ? p.left : 0 : p.right < t.width ? t.width - p.right : 0;
                                    if (d + l.width > t.width) {
                                        c = c == "left" ? "right" : "left";
                                        d = 0
                                    }
                                }
                                h.setStyle(c,
                                    b((i == "pin" ? v : w) + d + (i == "pin" ? 0 : c == "left" ? u : -u)))
                            } else {
                                i = "pin";
                                f("pin");
                                j(c)
                            }
                        }
                    }
                }();
            if (d) {
                var f = new CKEDITOR.template('<div id="cke_{name}" class="cke {id} cke_reset_all cke_chrome cke_editor_{name} cke_float cke_{langDir} ' + CKEDITOR.env.cssClass + '" dir="{langDir}" title="' + (CKEDITOR.env.gecko ? " " : "") + '" lang="{langCode}" role="application" style="{style}"' + (a.title ? ' aria-labelledby="cke_{name}_arialbl"' : " ") + ">" + (a.title ? '<span id="cke_{name}_arialbl" class="cke_voice_label">{voiceLabel}</span>' :
                    " ") + '<div class="cke_inner"><div id="{topId}" class="cke_top" role="presentation">{content}</div></div></div>'),
                    h = CKEDITOR.document.getBody().append(CKEDITOR.dom.element.createFromHtml(f.output({
                        content: d,
                        id: a.id,
                        langDir: a.lang.dir,
                        langCode: a.langCode,
                        name: a.name,
                        // style: "display:none;z-index:" + (c.baseFloatZIndex - 1),
                        topId: a.ui.spaceId("top"),
                        voiceLabel: a.title
                    }))),
                    i = CKEDITOR.tools.eventsBuffer(500, j),
                    k = CKEDITOR.tools.eventsBuffer(100, j);
                h.unselectable();
                h.on("mousedown", function(a) {
                    a = a.data;
                    a.getTarget().hasAscendant("a",
                        1) || a.preventDefault()
                });
                a.on("focus", function(b) {
                    j(b);
                    a.on("change", i.input);
                    e.on("scroll", k.input);
                    e.on("resize", k.input)
                });
                a.on("blur", function() {
                    h.hide();
                    a.removeListener("change", i.input);
                    e.removeListener("scroll", k.input);
                    e.removeListener("resize", k.input)
                });
                a.on("destroy", function() {
                    e.removeListener("scroll", k.input);
                    e.removeListener("resize", k.input);
                    h.clearCustomData();
                    h.remove()
                });
                a.focusManager.hasFocus && h.show();
                a.focusManager.add(h, 1)
            }
        }
        var e = CKEDITOR.document.getWindow(),
            b = CKEDITOR.tools.cssLength;
        CKEDITOR.plugins.add("floatingspace", {
            init: function(b) {
                b.on("loaded", function() {
                    a(this)
                }, null, null, 20)
            }
        })
    }(), CKEDITOR.plugins.add("listblock", {
        requires: "panel",
        onLoad: function() {
            var a = CKEDITOR.addTemplate("panel-list", '<ul role="presentation" class="cke_panel_list">{items}</ul>'),
                e = CKEDITOR.addTemplate("panel-list-item", '<li id="{id}" class="cke_panel_listItem" role=presentation><a class="cke_panel_listItem_link" id="{id}_option" _cke_focus=1 hidefocus=true title="{title}" href="javascript:void(\'{val}\')"  {onclick}="CKEDITOR.tools.callFunction({clickFn},\'{val}\'); return false;" role="option">{text}</a></li>'),
                b = CKEDITOR.addTemplate("panel-list-group", '<h1 id="{id}" class="cke_panel_grouptitle" role="presentation" >{label}</h1>'),
                g = /\'/g;
            CKEDITOR.ui.panel.prototype.addListBlock = function(a, b) {
                return this.addBlock(a, new CKEDITOR.ui.listBlock(this.getHolderElement(), b))
            };
            CKEDITOR.ui.listBlock = CKEDITOR.tools.createClass({
                base: CKEDITOR.ui.panel.block,
                $: function(a, b) {
                    var b = b || {}, e = b.attributes || (b.attributes = {});
                    (this.multiSelect = !! b.multiSelect) && (e["aria-multiselectable"] = true);
                    !e.role && (e.role = "listbox");
                    this.base.apply(this, arguments);
                    this.element.setAttribute("role", e.role);
                    e = this.keys;
                    e[40] = "next";
                    e[9] = "next";
                    e[38] = "prev";
                    e[CKEDITOR.SHIFT + 9] = "prev";
                    e[32] = CKEDITOR.env.ie ? "mouseup" : "click";
                    CKEDITOR.env.ie && (e[13] = "mouseup");
                    this._.pendingHtml = [];
                    this._.pendingList = [];
                    this._.items = {};
                    this._.groups = {}
                },
                _: {
                    close: function() {
                        if (this._.started) {
                            var b = a.output({
                                items: this._.pendingList.join("")
                            });
                            this._.pendingList = [];
                            this._.pendingHtml.push(b);
                            delete this._.started
                        }
                    },
                    getClick: function() {
                        if (!this._.click) this._.click =
                            CKEDITOR.tools.addFunction(function(a) {
                                var b = this.toggle(a);
                                if (this.onClick) this.onClick(a, b)
                            }, this);
                        return this._.click
                    }
                },
                proto: {
                    add: function(a, b, j) {
                        var f = CKEDITOR.tools.getNextId();
                        if (!this._.started) {
                            this._.started = 1;
                            this._.size = this._.size || 0
                        }
                        this._.items[a] = f;
                        var h;
                        h = CKEDITOR.tools.htmlEncodeAttr(a).replace(g, "\\'");
                        a = {
                            id: f,
                            val: h,
                            onclick: CKEDITOR.env.ie ? 'onclick="return false;" onmouseup' : "onclick",
                            clickFn: this._.getClick(),
                            title: CKEDITOR.tools.htmlEncodeAttr(j || a),
                            text: b || a
                        };
                        this._.pendingList.push(e.output(a))
                    },
                    startGroup: function(a) {
                        this._.close();
                        var d = CKEDITOR.tools.getNextId();
                        this._.groups[a] = d;
                        this._.pendingHtml.push(b.output({
                            id: d,
                            label: a
                        }))
                    },
                    commit: function() {
                        this._.close();
                        this.element.appendHtml(this._.pendingHtml.join(""));
                        delete this._.size;
                        this._.pendingHtml = []
                    },
                    toggle: function(a) {
                        var b = this.isMarked(a);
                        b ? this.unmark(a) : this.mark(a);
                        return !b
                    },
                    hideGroup: function(a) {
                        var b = (a = this.element.getDocument().getById(this._.groups[a])) && a.getNext();
                        if (a) {
                            a.setStyle("display", "none");
                            b && b.getName() == "ul" &&
                                b.setStyle("display", "none")
                        }
                    },
                    hideItem: function(a) {
                        this.element.getDocument().getById(this._.items[a]).setStyle("display", "none")
                    },
                    showAll: function() {
                        var a = this._.items,
                            b = this._.groups,
                            e = this.element.getDocument(),
                            f;
                        for (f in a) e.getById(a[f]).setStyle("display", "");
                        for (var g in b) {
                            a = e.getById(b[g]);
                            f = a.getNext();
                            a.setStyle("display", "");
                            f && f.getName() == "ul" && f.setStyle("display", "")
                        }
                    },
                    /**
                     * Проверим и вернем существующий ключ шрифта.
                     * Для того чтобы не было ошибки сделаем выбор первого шрифта, если текущий не найден в общем списке
                     * @param fonts
                     * @param key
                     * @returns {*}
                     */
                    getExistingFontKey: function(fonts, key) {

                      if (!!fonts[key] === false) {
                        return Object.keys(fonts)[0];
                      }

                      return key;
                    },
                    mark: function(a) {
                        this.multiSelect || this.unmarkAll();

                        var key = this.getExistingFontKey(this._.items, a);
                        var a = this._.items[key];
                        var b = this.element.getDocument().getById(a);

                        b.addClass("cke_selected");
                        this.element.getDocument().getById(a + "_option").setAttribute("aria-selected", true);
                        this.onMark && this.onMark(b)
                    },
                    unmark: function(a) {
                        var b = this.element.getDocument(),
                            a = this._.items[a],
                            e = b.getById(a);
                        e.removeClass("cke_selected");
                        b.getById(a + "_option").removeAttribute("aria-selected");
                        this.onUnmark && this.onUnmark(e)
                    },
                    unmarkAll: function() {
                        var a = this._.items,
                            b = this.element.getDocument(),
                            e;
                        for (e in a) {
                            var f = a[e];
                            b.getById(f).removeClass("cke_selected");
                            b.getById(f + "_option").removeAttribute("aria-selected")
                        }
                        this.onUnmark &&
                            this.onUnmark()
                    },
                    isMarked: function(a) {
                        return this.element.getDocument().getById(this._.items[a]).hasClass("cke_selected")
                    },
                    focus: function(a) {
                        this._.focusIndex = -1;
                        var b = this.element.getElementsByTag("a"),
                            e, f = -1;
                        if (a) {
                          var a = this.getExistingFontKey(this._.items, a);
                          for (e = this.element.getDocument().getById(this._.items[a]).getFirst(); a = b.getItem(++f);) {
                              if (a.equals(e)) {
                                  this._.focusIndex = f;
                                  break
                              }
                          }
                        } else {
                          this.element.focus();
                        }
                        e && setTimeout(function() {
                            e.focus()
                        }, 0)
                    }
                }
            })
        }
    }),
    function() {
        var a = '<a id="{id}" class="cke_button cke_button__{name} cke_button_{state} {cls}"' +
            (CKEDITOR.env.gecko && !CKEDITOR.env.hc ? "" : " href=\"javascript:void('{titleJs}')\"") + ' title="{title}" tabindex="-1" hidefocus="true" role="button" aria-labelledby="{id}_label" aria-haspopup="{hasArrow}" aria-disabled="{ariaDisabled}"';
        CKEDITOR.env.gecko && CKEDITOR.env.mac && (a = a + ' onkeypress="return false;"');
        CKEDITOR.env.gecko && (a = a + ' onblur="this.style.cssText = this.style.cssText;"');
        var a = a + (' onkeydown="return CKEDITOR.tools.callFunction({keydownFn},event);" onfocus="return CKEDITOR.tools.callFunction({focusFn},event);" ' +
            (CKEDITOR.env.ie ? 'onclick="return false;" onmouseup' : "onclick") + '="CKEDITOR.tools.callFunction({clickFn},this);return false;"><span class="cke_button_icon cke_button__{iconName}_icon" style="{style}"'),
            a = a + '></span><span id="{id}_label" class="cke_button_label cke_button__{name}_label" aria-hidden="false">{label}</span>{arrowHtml}</a>',
            e = CKEDITOR.addTemplate("buttonArrow", '<span class="cke_button_arrow">' + (CKEDITOR.env.hc ? "&#9660;" : "") + "</span>"),
            b = CKEDITOR.addTemplate("button", a);
        CKEDITOR.plugins.add("button", {
            beforeInit: function(a) {
                a.ui.addHandler(CKEDITOR.UI_BUTTON, CKEDITOR.ui.button.handler)
            }
        });
        CKEDITOR.UI_BUTTON = "button";
        CKEDITOR.ui.button = function(a) {
            CKEDITOR.tools.extend(this, a, {
                title: a.label,
                click: a.click || function(b) {
                    b.execCommand(a.command)
                }
            });
            this._ = {}
        };
        CKEDITOR.ui.button.handler = {
            create: function(a) {
                return new CKEDITOR.ui.button(a)
            }
        };
        CKEDITOR.ui.button.prototype = {
            render: function(a, c) {
                function d() {
                    var b = a.mode;
                    if (b) {
                        b = this.modes[b] ? l[b] !== void 0 ? l[b] : CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED;
                        b = a.readOnly && !this.readOnly ? CKEDITOR.TRISTATE_DISABLED : b;
                        this.setState(b);
                        this.refresh && this.refresh()
                    }
                }
                var j = CKEDITOR.env,
                    f = this._.id = CKEDITOR.tools.getNextId(),
                    h = "",
                    i = this.command,
                    k;
                this._.editor = a;
                var n = {
                    id: f,
                    button: this,
                    editor: a,
                    focus: function() {
                        CKEDITOR.document.getById(f).focus()
                    },
                    execute: function() {
                        this.button.click(a)
                    },
                    attach: function(a) {
                        this.button.attach(a)
                    }
                }, o = CKEDITOR.tools.addFunction(function(a) {
                        if (n.onkey) {
                            a = new CKEDITOR.dom.event(a);
                            return n.onkey(n, a.getKeystroke()) !== false
                        }
                    }),
                    q =
                        CKEDITOR.tools.addFunction(function(a) {
                            var b;
                            n.onfocus && (b = n.onfocus(n, new CKEDITOR.dom.event(a)) !== false);
                            return b
                        }),
                    m = 0;
                n.clickFn = k = CKEDITOR.tools.addFunction(function() {
                    if (m) {
                        a.unlockSelection(1);
                        m = 0
                    }
                    n.execute();
                    j.iOS && a.focus()
                });
                if (this.modes) {
                    var l = {};
                    a.on("beforeModeUnload", function() {
                        if (a.mode && this._.state != CKEDITOR.TRISTATE_DISABLED) l[a.mode] = this._.state
                    }, this);
                    a.on("activeFilterChange", d, this);
                    a.on("mode", d, this);
                    !this.readOnly && a.on("readOnly", d, this)
                } else if (i)
                    if (i = a.getCommand(i)) {
                        i.on("state",
                            function() {
                                this.setState(i.state)
                            }, this);
                        h = h + (i.state == CKEDITOR.TRISTATE_ON ? "on" : i.state == CKEDITOR.TRISTATE_DISABLED ? "disabled" : "off")
                    }
                if (this.directional) a.on("contentDirChanged", function(b) {
                    var c = CKEDITOR.document.getById(this._.id),
                        d = c.getFirst(),
                        b = b.data;
                    b != a.lang.dir ? c.addClass("cke_" + b) : c.removeClass("cke_ltr").removeClass("cke_rtl");
                    d.setAttribute("style", CKEDITOR.skin.getIconStyle(t, b == "rtl", this.icon, this.iconOffset))
                }, this);
                i || (h = h + "off");
                var p = this.name || this.command,
                    t = p;
                if (this.icon && !/\./.test(this.icon)) {
                    t = this.icon;
                    this.icon = null
                }
                h = {
                    id: f,
                    name: p,
                    iconName: t,
                    label: this.label,
                    cls: this.className || "",
                    state: h,
                    ariaDisabled: h == "disabled" ? "true" : "false",
                    title: this.title,
                    titleJs: j.gecko && !j.hc ? "" : (this.title || "").replace("'", ""),
                    hasArrow: this.hasArrow ? "true" : "false",
                    keydownFn: o,
                    focusFn: q,
                    clickFn: k,
                    style: CKEDITOR.skin.getIconStyle(t, a.lang.dir == "rtl", this.icon, this.iconOffset),
                    arrowHtml: this.hasArrow ? e.output() : ""
                };
                b.output(h, c);
                if (this.onRender) this.onRender();
                return n
            },
            setState: function(a) {
                if (this._.state ==
                    a) return false;
                this._.state = a;
                var b = CKEDITOR.document.getById(this._.id);
                if (b) {
                    b.setState(a, "cke_button");
                    a == CKEDITOR.TRISTATE_DISABLED ? b.setAttribute("aria-disabled", true) : b.removeAttribute("aria-disabled");
                    if (this.hasArrow) {
                        a = a == CKEDITOR.TRISTATE_ON ? this._.editor.lang.button.selectedLabel.replace(/%1/g, this.label) : this.label;
                        CKEDITOR.document.getById(this._.id + "_label").setText(a)
                    } else a == CKEDITOR.TRISTATE_ON ? b.setAttribute("aria-pressed", true) : b.removeAttribute("aria-pressed");
                    return true
                }
                return false
            },
            getState: function() {
                return this._.state
            },
            toFeature: function(a) {
                if (this._.feature) return this._.feature;
                var b = this;
                !this.allowedContent && (!this.requiredContent && this.command) && (b = a.getCommand(this.command) || b);
                return this._.feature = b
            }
        };
        CKEDITOR.ui.prototype.addButton = function(a, b) {
            this.add(a, CKEDITOR.UI_BUTTON, b)
        }
    }(), CKEDITOR.plugins.add("richcombo", {
        requires: "floatpanel,listblock,button",
        beforeInit: function(a) {
            a.ui.addHandler(CKEDITOR.UI_RICHCOMBO, CKEDITOR.ui.richCombo.handler)
        }
    }),
    function() {
        var a =
            '<a id="{id}" class="cke_combo cke_button cke_combo__{name} {cls}" role="presentation" title="{title}" tabindex="-1"' + (CKEDITOR.env.gecko && !CKEDITOR.env.hc ? "" : " href=\"javascript:void('{titleJs}')\"") + ' hidefocus="true" role="button" aria-labelledby="{id}_label" aria-haspopup="true"';
        CKEDITOR.env.gecko && CKEDITOR.env.mac && (a = a + ' onkeypress="return false;"');
        CKEDITOR.env.gecko && (a = a + ' onblur="this.style.cssText = this.style.cssText;"');
        var a = a + (' onkeydown="return CKEDITOR.tools.callFunction({keydownFn},event,this);" onfocus="return CKEDITOR.tools.callFunction({focusFn},event);" ' + (CKEDITOR.env.ie ? 'onclick="return false;" onmouseup' : "onclick") + '="CKEDITOR.tools.callFunction({clickFn},this);return false;"><span class="cke_button_icon cke_button__{name}_icon"></span><span class="cke_combo_open"><span class="cke_combo_arrow">' + (CKEDITOR.env.hc ? "&#9660;" : CKEDITOR.env.air ? "&nbsp;" : "") + "</span></span></a>"),
            e = CKEDITOR.addTemplate("combo", a);
        CKEDITOR.UI_RICHCOMBO = "richcombo";
        CKEDITOR.ui.richCombo = CKEDITOR.tools.createClass({
            $: function(a) {
                CKEDITOR.tools.extend(this, a, {
                    canGroup: false,
                    title: a.label,
                    modes: {
                        wysiwyg: 1
                    },
                    editorFocus: 1
                });
                a = this.panel || {};
                delete this.panel;
                this.id = CKEDITOR.tools.getNextNumber();
                this.document = a.parent && a.parent.getDocument() || CKEDITOR.document;
                a.className = "cke_combopanel";
                a.block = {
                    multiSelect: a.multiSelect,
                    attributes: a.attributes
                };
                a.toolbarRelated = true;
                this._ = {
                    panelDefinition: a,
                    items: {}
                }
            },
            proto: {
                renderHtml: function(a) {
                    var e = [];
                    this.render(a, e);
                    return e.join("")
                },
                render: function(a, g) {
                    function c() {
                        if (this.getState() != CKEDITOR.TRISTATE_ON) {
                            var c = this.modes[a.mode] ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED;
                            if (a.readOnly && !this.readOnly) c = CKEDITOR.TRISTATE_DISABLED;
                            this.setState(c);
                            this.setValue("");
                            c != CKEDITOR.TRISTATE_DISABLED && this.refresh && this.refresh()
                        }
                    }
                    var d = CKEDITOR.env,
                        j = "cke_" + this.id,
                        f = CKEDITOR.tools.addFunction(function(c) {
                                if (o) {
                                    a.unlockSelection(1);
                                    o = 0
                                }
                                i.execute(c)
                            },
                            this),
                        h = this,
                        i = {
                            id: j,
                            combo: this,
                            focus: function() {
                                CKEDITOR.document.getById(j).getChild(1).focus()
                            },
                            execute: function(c) {
                                var d = h._;
                                if (d.state != CKEDITOR.TRISTATE_DISABLED) {
                                    h.createPanel(a);
                                    if (d.on) d.panel.hide();
                                    else {
                                        h.commit();
                                        var f = h.getValue();
                                        f ? d.list.mark(f) : d.list.unmarkAll();
                                        d.panel.showBlock(h.id, new CKEDITOR.dom.element(c), 4)
                                    }
                                }
                            },
                            clickFn: f
                        };
                    a.on("activeFilterChange", c, this);
                    a.on("mode", c, this);
                    a.on("selectionChange", c, this);
                    !this.readOnly && a.on("readOnly", c, this);
                    var k = CKEDITOR.tools.addFunction(function(c,
                        d) {
                        var c = new CKEDITOR.dom.event(c),
                            e = c.getKeystroke();
                        if (e == 40) a.once("panelShow", function(a) {
                            a.data._.panel._.currentBlock.onKeyDown(40)
                        });
                        switch (e) {
                            case 13:
                            case 32:
                            case 40:
                                CKEDITOR.tools.callFunction(f, d);
                                break;
                            default:
                                i.onkey(i, e)
                        }
                        c.preventDefault()
                    }),
                        n = CKEDITOR.tools.addFunction(function() {
                            i.onfocus && i.onfocus()
                        }),
                        o = 0;
                    i.keyDownFn = k;
                    d = {
                        id: j,
                        name: this.name || this.command,
                        label: this.label,
                        title: this.title,
                        cls: this.className || "",
                        titleJs: d.gecko && !d.hc ? "" : (this.title || "").replace("'", ""),
                        keydownFn: k,
                        focusFn: n,
                        clickFn: f
                    };
                    e.output(d, g);
                    if (this.onRender) this.onRender();
                    return i
                },
                createPanel: function(a) {
                    if (!this._.panel) {
                        var e = this._.panelDefinition,
                            c = this._.panelDefinition.block,
                            d = e.parent || CKEDITOR.document.getBody(),
                            j = "cke_combopanel__" + this.name,
                            f = new CKEDITOR.ui.floatPanel(a, d, e),
                            h = f.addListBlock(this.id, c),
                            i = this;
                        f.onShow = function() {
                            this.element.addClass(j);
                            i.setState(CKEDITOR.TRISTATE_ON);
                            i._.on = 1;
                            i.editorFocus && !a.focusManager.hasFocus && a.focus();
                            if (i.onOpen) i.onOpen();
                            a.once("panelShow",
                                function() {
                                    h.focus(!h.multiSelect && i.getValue())
                                })
                        };
                        f.onHide = function(c) {
                            this.element.removeClass(j);
                            i.setState(i.modes && i.modes[a.mode] ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED);
                            i._.on = 0;
                            if (!c && i.onClose) i.onClose()
                        };
                        f.onEscape = function() {
                            f.hide(1)
                        };
                        h.onClick = function(a, b) {
                            i.onClick && i.onClick.call(i, a, b);
                            f.hide()
                        };
                        this._.panel = f;
                        this._.list = h;
                        f.getBlock(this.id).onHide = function() {
                            i._.on = 0;
                            i.setState(CKEDITOR.TRISTATE_OFF)
                        };
                        this.init && this.init()
                    }
                },
                setValue: function(a, e) {
                    this._.value = a;
                    var c =
                        this.document.getById("cke_" + this.id + "_text");
                    if (c) {
                        if (!a && !e) {
                            e = this.label;
                            c.addClass("cke_combo_inlinelabel")
                        } else c.removeClass("cke_combo_inlinelabel");
                        c.setText(typeof e != "undefined" ? e : a)
                    }
                },
                getValue: function() {
                    return this._.value || ""
                },
                unmarkAll: function() {
                    this._.list.unmarkAll()
                },
                mark: function(a) {
                    this._.list.mark(a)
                },
                hideItem: function(a) {
                    this._.list.hideItem(a)
                },
                hideGroup: function(a) {
                    this._.list.hideGroup(a)
                },
                showAll: function() {
                    this._.list.showAll()
                },
                add: function(a, e, c) {
                    this._.items[a] = c || a;
                    this._.list.add(a, e, c)
                },
                startGroup: function(a) {
                    this._.list.startGroup(a)
                },
                commit: function() {
                    if (!this._.committed) {
                        this._.list.commit();
                        this._.committed = 1;
                        CKEDITOR.ui.fire("ready", this)
                    }
                    this._.committed = 1
                },
                setState: function(a) {
                    if (this._.state != a) {
                        var e = this.document.getById("cke_" + this.id);
                        e.setState(a, "cke_combo");
                        a == CKEDITOR.TRISTATE_DISABLED ? e.setAttribute("aria-disabled", true) : e.removeAttribute("aria-disabled");
                        this._.state = a
                    }
                },
                getState: function() {
                    return this._.state
                },
                enable: function() {
                    this._.state ==
                        CKEDITOR.TRISTATE_DISABLED && this.setState(this._.lastState)
                },
                disable: function() {
                    if (this._.state != CKEDITOR.TRISTATE_DISABLED) {
                        this._.lastState = this._.state;
                        this.setState(CKEDITOR.TRISTATE_DISABLED)
                    }
                }
            },
            statics: {
                handler: {
                    create: function(a) {
                        return new CKEDITOR.ui.richCombo(a)
                    }
                }
            }
        });
        CKEDITOR.ui.prototype.addRichCombo = function(a, e) {
            this.add(a, CKEDITOR.UI_RICHCOMBO, e)
        }
    }(), CKEDITOR.plugins.add("format", {
        requires: "richcombo",
        init: function(a) {
            if (!a.blockless) {
                for (var e = a.config, b = a.lang.format, g = e.format_tags.split(";"),
                        c = {}, d = 0, j = [], f = 0; f < g.length; f++) {
                    var h = g[f],
                        i = new CKEDITOR.style(e["format_" + h]);
                    if (!a.filter.customConfig || a.filter.check(i)) {
                        d++;
                        c[h] = i;
                        c[h]._.enterMode = a.config.enterMode;
                        j.push(i)
                    }
                }
                d !== 0 && a.ui.addRichCombo("Format", {
                    label: b.label,
                    title: b.panelTitle,
                    toolbar: "styles,20",
                    allowedContent: j,
                    panel: {
                        css: [CKEDITOR.skin.getPath("editor")].concat(e.contentsCss),
                        multiSelect: false,
                        attributes: {
                            "aria-label": b.panelTitle
                        }
                    },
                    init: function() {
                        this.startGroup(b.panelTitle);
                        for (var a in c) {
                            var d = b["tag_" + a];
                            this.add(a,
                                c[a].buildPreview(d), d)
                        }
                    },
                    onClick: function(b) {
                        a.focus();
                        a.fire("saveSnapshot");
                        var b = c[b],
                            d = a.elementPath();
                        a[b.checkActive(d, a) ? "removeStyle" : "applyStyle"](b);
                        setTimeout(function() {
                            a.fire("saveSnapshot")
                        }, 0)
                    },
                    onRender: function() {
                        a.on("selectionChange", function(b) {
                            var d = this.getValue(),
                                b = b.data.path;
                            this.refresh();
                            for (var f in c)
                                if (c[f].checkActive(b, a)) {
                                    f != d && this.setValue(f, a.lang.format["tag_" + f]);
                                    return
                                }
                            this.setValue("")
                        }, this)
                    },
                    onOpen: function() {
                        this.showAll();
                        for (var b in c) a.activeFilter.check(c[b]) ||
                            this.hideItem(b)
                    },
                    refresh: function() {
                        var b = a.elementPath();
                        if (b) {
                            if (b.isContextFor("p"))
                                for (var d in c)
                                    if (a.activeFilter.check(c[d])) return;
                            this.setState(CKEDITOR.TRISTATE_DISABLED)
                        }
                    }
                })
            }
        }
    }), CKEDITOR.config.format_tags = "p;h1;h2;h3;h4;h5;h6;pre;address;div", CKEDITOR.config.format_p = {
        element: "p"
    }, CKEDITOR.config.format_div = {
        element: "div"
    },CKEDITOR.config.format_blockquote = {
        element: "blockquote"
    }, CKEDITOR.config.format_pre = {
        element: "pre"
    }, CKEDITOR.config.format_address = {
        element: "address"
    }, CKEDITOR.config.format_h1 = {
        element: "h1"
    }, CKEDITOR.config.format_h2 = {
        element: "h2"
    },
    CKEDITOR.config.format_h3 = {
        element: "h3"
    }, CKEDITOR.config.format_h4 = {
        element: "h4"
    }, CKEDITOR.config.format_h5 = {
        element: "h5"
    }, CKEDITOR.config.format_h6 = {
        element: "h6"
    },
    function() {
        var a = {
            canUndo: false,
            exec: function(a) {
                var b = a.document.createElement("hr");
                a.insertElement(b)
            },
            allowedContent: "hr",
            requiredContent: "hr"
        };
        CKEDITOR.plugins.add("horizontalrule", {
            init: function(e) {
                if (!e.blockless) {
                    e.addCommand("horizontalrule", a);
                    e.ui.addButton && e.ui.addButton("HorizontalRule", {
                        label: e.lang.horizontalrule.toolbar,
                        command: "horizontalrule",
                        toolbar: "insert,40"
                    })
                }
            }
        })
    }(), CKEDITOR.plugins.add("htmlwriter", {
        init: function(a) {
            var e = new CKEDITOR.htmlWriter;
            e.forceSimpleAmpersand = a.config.forceSimpleAmpersand;
            e.indentationChars = a.config.dataIndentationChars || "\t";
            a.dataProcessor.writer = e
        }
    }), CKEDITOR.htmlWriter = CKEDITOR.tools.createClass({
        base: CKEDITOR.htmlParser.basicWriter,
        $: function() {
            this.base();
            this.indentationChars = "\t";
            this.selfClosingEnd = " />";
            this.lineBreakChars = "\n";
            this.sortAttributes = 1;
            this._.indent = 0;
            this._.indentation =
                "";
            this._.inPre = 0;
            this._.rules = {};
            var a = CKEDITOR.dtd,
                e;
            for (e in CKEDITOR.tools.extend({}, a.$nonBodyContent, a.$block, a.$listItem, a.$tableContent)) this.setRules(e, {
                indent: !a[e]["#"],
                breakBeforeOpen: 1,
                breakBeforeClose: !a[e]["#"],
                breakAfterClose: 1,
                needsSpace: e in a.$block && !(e in {
                    li: 1,
                    dt: 1,
                    dd: 1
                })
            });
            this.setRules("br", {
                breakAfterOpen: 1
            });
            this.setRules("title", {
                indent: 0,
                breakAfterOpen: 0
            });
            this.setRules("style", {
                indent: 0,
                breakBeforeClose: 1
            });
            this.setRules("pre", {
                breakAfterOpen: 1,
                indent: 0
            })
        },
        proto: {
            openTag: function(a) {
                var e =
                    this._.rules[a];
                this._.afterCloser && (e && e.needsSpace && this._.needsSpace) && this._.output.push("\n");
                if (this._.indent) this.indentation();
                else if (e && e.breakBeforeOpen) {
                    this.lineBreak();
                    this.indentation()
                }
                this._.output.push("<", a);
                this._.afterCloser = 0
            },
            openTagClose: function(a, e) {
                var b = this._.rules[a];
                if (e) {
                    this._.output.push(this.selfClosingEnd);
                    if (b && b.breakAfterClose) this._.needsSpace = b.needsSpace
                } else {
                    this._.output.push(">");
                    if (b && b.indent) this._.indentation = this._.indentation + this.indentationChars
                }
                b &&
                    b.breakAfterOpen && this.lineBreak();
                a == "pre" && (this._.inPre = 1)
            },
            attribute: function(a, e) {
                if (typeof e == "string") {
                    this.forceSimpleAmpersand && (e = e.replace(/&amp;/g, "&"));
                    e = CKEDITOR.tools.htmlEncodeAttr(e)
                }
                this._.output.push(" ", a, '="', e, '"')
            },
            closeTag: function(a) {
                var e = this._.rules[a];
                if (e && e.indent) this._.indentation = this._.indentation.substr(this.indentationChars.length);
                if (this._.indent) this.indentation();
                else if (e && e.breakBeforeClose) {
                    this.lineBreak();
                    this.indentation()
                }
                this._.output.push("</", a, ">");
                a == "pre" && (this._.inPre = 0);
                if (e && e.breakAfterClose) {
                    this.lineBreak();
                    this._.needsSpace = e.needsSpace
                }
                this._.afterCloser = 1
            },
            text: function(a) {
                if (this._.indent) {
                    this.indentation();
                    !this._.inPre && (a = CKEDITOR.tools.ltrim(a))
                }
                this._.output.push(a)
            },
            comment: function(a) {
                this._.indent && this.indentation();
                this._.output.push("<\!--", a, "--\>")
            },
            lineBreak: function() {
                !this._.inPre && this._.output.length > 0 && this._.output.push(this.lineBreakChars);
                this._.indent = 1
            },
            indentation: function() {
                !this._.inPre && this._.indentation &&
                    this._.output.push(this._.indentation);
                this._.indent = 0
            },
            reset: function() {
                this._.output = [];
                this._.indent = 0;
                this._.indentation = "";
                this._.afterCloser = 0;
                this._.inPre = 0
            },
            setRules: function(a, e) {
                var b = this._.rules[a];
                b ? CKEDITOR.tools.extend(b, e, true) : this._.rules[a] = e
            }
        }
    }),
    function() {
        function a(a, e) {
            e || (e = a.getSelection().getSelectedElement());
            if (e && e.is("img") && !e.data("cke-realelement") && !e.isReadOnly()) return e
        }

        function e(a) {
            var e = a.getStyle("float");
            if (e == "inherit" || e == "none") e = 0;
            e || (e = a.getAttribute("align"));
            return e
        }
        CKEDITOR.plugins.add("image", {
            requires: "dialog",
            init: function(b) {
                if (!b.plugins.image2) {
                    CKEDITOR.dialog.add("image", this.path + "dialogs/image.js");
                    var e = "img[alt,!src]{border-style,border-width,float,height,margin,margin-bottom,margin-left,margin-right,margin-top,width}";
                    CKEDITOR.dialog.isTabEnabled(b, "image", "advanced") && (e = "img[alt,dir,id,lang,longdesc,!src,title]{*}(*)");
                    b.addCommand("image", new CKEDITOR.dialogCommand("image", {
                        allowedContent: e,
                        requiredContent: "img[alt,src]",
                        contentTransformations: [
                            ["img{width}: sizeToStyle",
                                "img[width]: sizeToAttribute"
                            ],
                            ["img{float}: alignmentToStyle", "img[align]: alignmentToAttribute"]
                        ]
                    }));
                    b.ui.addButton && b.ui.addButton("Image", {
                        label: b.lang.common.image,
                        command: "image",
                        toolbar: "insert,10"
                    });
                    b.on("doubleclick", function(a) {
                        var b = a.data.element;
                        if (b.is("img") && !b.data("cke-realelement") && !b.isReadOnly()) a.data.dialog = "image"
                    });
                    b.addMenuItems && b.addMenuItems({
                        image: {
                            label: b.lang.image.menu,
                            command: "image",
                            group: "image"
                        }
                    });
                    b.contextMenu && b.contextMenu.addListener(function(c) {
                        if (a(b, c)) return {
                            image: CKEDITOR.TRISTATE_OFF
                        }
                    })
                }
            },
            afterInit: function(b) {
                function g(c) {
                    var d = b.getCommand("justify" + c);
                    if (d) {
                        if (c == "left" || c == "right") d.on("exec", function(d) {
                            var f = a(b),
                                g;
                            if (f) {
                                g = e(f);
                                if (g == c) {
                                    f.removeStyle("float");
                                    c == e(f) && f.removeAttribute("align")
                                } else f.setStyle("float", c);
                                d.cancel()
                            }
                        });
                        d.on("refresh", function(d) {
                            var f = a(b);
                            if (f) {
                                f = e(f);
                                this.setState(f == c ? CKEDITOR.TRISTATE_ON : c == "right" || c == "left" ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED);
                                d.cancel()
                            }
                        })
                    }
                }
                if (!b.plugins.image2) {
                    g("left");
                    g("right");
                    g("center");
                    g("block")
                }
            }
        })
    }(),
    CKEDITOR.config.image_removeLinkByEmptyURL = !0,
    function() {
        function a(a, b) {
            var c = g.exec(a),
                e = g.exec(b);
            if (c) {
                if (!c[2] && e[2] == "px") return e[1];
                if (c[2] == "px" && !e[2]) return e[1] + "px"
            }
            return b
        }
        var e = CKEDITOR.htmlParser.cssStyle,
            b = CKEDITOR.tools.cssLength,
            g = /^((?:\d*(?:\.\d+))|(?:\d+))(.*)?$/i,
            c = {
                elements: {
                    $: function(b) {
                        var c = b.attributes;
                        if ((c = (c = (c = c && c["data-cke-realelement"]) && new CKEDITOR.htmlParser.fragment.fromHtml(decodeURIComponent(c))) && c.children[0]) && b.attributes["data-cke-resizable"]) {
                            var f =
                                (new e(b)).rules,
                                b = c.attributes,
                                g = f.width,
                                f = f.height;
                            g && (b.width = a(b.width, g));
                            f && (b.height = a(b.height, f))
                        }
                        return c
                    }
                }
            };
        CKEDITOR.plugins.add("fakeobjects", {
            init: function(a) {
                a.filter.allow("img[!data-cke-realelement,src,alt,title](*){*}", "fakeobjects")
            },
            afterInit: function(a) {
                (a = (a = a.dataProcessor) && a.htmlFilter) && a.addRules(c, {
                    applyToAll: true
                })
            }
        });
        CKEDITOR.editor.prototype.createFakeElement = function(a, c, f, g) {
            var i = this.lang.fakeobjects,
                i = i[f] || i.unknown,
                c = {
                    "class": c,
                    "data-cke-realelement": encodeURIComponent(a.getOuterHtml()),
                    "data-cke-real-node-type": a.type,
                    alt: i,
                    title: i,
                    align: a.getAttribute("align") || ""
                };
            if (!CKEDITOR.env.hc) c.src = CKEDITOR.tools.transparentImageData;
            f && (c["data-cke-real-element-type"] = f);
            if (g) {
                c["data-cke-resizable"] = g;
                f = new e;
                g = a.getAttribute("width");
                a = a.getAttribute("height");
                g && (f.rules.width = b(g));
                a && (f.rules.height = b(a));
                f.populate(c)
            }
            return this.document.createElement("img", {
                attributes: c
            })
        };
        CKEDITOR.editor.prototype.createFakeParserElement = function(a, c, f, g) {
            var i = this.lang.fakeobjects,
                i = i[f] ||
                    i.unknown,
                k;
            k = new CKEDITOR.htmlParser.basicWriter;
            a.writeHtml(k);
            k = k.getHtml();
            c = {
                "class": c,
                "data-cke-realelement": encodeURIComponent(k),
                "data-cke-real-node-type": a.type,
                alt: i,
                title: i,
                align: a.attributes.align || ""
            };
            if (!CKEDITOR.env.hc) c.src = CKEDITOR.tools.transparentImageData;
            f && (c["data-cke-real-element-type"] = f);
            if (g) {
                c["data-cke-resizable"] = g;
                g = a.attributes;
                a = new e;
                f = g.width;
                g = g.height;
                f !== void 0 && (a.rules.width = b(f));
                g !== void 0 && (a.rules.height = b(g));
                a.populate(c)
            }
            return new CKEDITOR.htmlParser.element("img",
                c)
        };
        CKEDITOR.editor.prototype.restoreRealElement = function(b) {
            if (b.data("cke-real-node-type") != CKEDITOR.NODE_ELEMENT) return null;
            var c = CKEDITOR.dom.element.createFromHtml(decodeURIComponent(b.data("cke-realelement")), this.document);
            if (b.data("cke-resizable")) {
                var f = b.getStyle("width"),
                    b = b.getStyle("height");
                f && c.setAttribute("width", a(c.getAttribute("width"), f));
                b && c.setAttribute("height", a(c.getAttribute("height"), b))
            }
            return c
        }
    }(), "use strict",
    function() {
        function a(a) {
            return a.replace(/'/g, "\\$&")
        }

        function e(a) {
            for (var b, c = a.length, d = [], f = 0; f < c; f++) {
                b = a.charCodeAt(f);
                d.push(b)
            }
            return "String.fromCharCode(" + d.join(",") + ")"
        }

        function b(b, c) {
            var d = b.plugins.link,
                f = d.compiledProtectionFunction.params,
                e, g;
            g = [d.compiledProtectionFunction.name, "("];
            for (var h = 0; h < f.length; h++) {
                d = f[h].toLowerCase();
                e = c[d];
                h > 0 && g.push(",");
                g.push("'", e ? a(encodeURIComponent(c[d])) : "", "'")
            }
            g.push(")");
            return g.join("")
        }

        function g(a) {
            var a = a.config.emailProtection || "",
                b;
            if (a && a != "encode") {
                b = {};
                a.replace(/^([^(]+)\(([^)]+)\)$/,
                    function(a, c, d) {
                        b.name = c;
                        b.params = [];
                        d.replace(/[^,\s]+/g, function(a) {
                            b.params.push(a)
                        })
                    })
            }
            return b
        }
        CKEDITOR.plugins.add("link", {
            requires: "dialog,fakeobjects",
            onLoad: function() {
                function a(b) {
                    return c.replace(/%1/g, b == "rtl" ? "right" : "left").replace(/%2/g, "cke_contents_" + b)
                }
                var b = "background:url(" + CKEDITOR.getUrl(this.path + "images" + (CKEDITOR.env.hidpi ? "/hidpi" : "") + "/anchor.png") + ") no-repeat %1 center;border:1px dotted #00f;background-size:16px;",
                    c = ".%2 a.cke_anchor,.%2 a.cke_anchor_empty,.cke_editable.%2 a[name],.cke_editable.%2 a[data-cke-saved-name]{" +
                        b + "padding-%1:18px;cursor:auto;}.%2 img.cke_anchor{" + b + "width:16px;min-height:15px;height:1.15em;vertical-align:text-bottom;}";
                CKEDITOR.addCss(a("ltr") + a("rtl"))
            },
            init: function(a) {
                var b = "a[!href]";
                CKEDITOR.dialog.isTabEnabled(a, "link", "advanced") && (b = b.replace("]", ",accesskey,charset,dir,id,lang,name,rel,tabindex,title,type]{*}(*)"));
                CKEDITOR.dialog.isTabEnabled(a, "link", "target") && (b = b.replace("]", ",target,onclick]"));
                a.addCommand("link", new CKEDITOR.dialogCommand("link", {
                    allowedContent: b,
                    requiredContent: "a[href]"
                }));
                a.addCommand("anchor", new CKEDITOR.dialogCommand("anchor", {
                    allowedContent: "a[!name,id]",
                    requiredContent: "a[name]"
                }));
                a.addCommand("unlink", new CKEDITOR.unlinkCommand);
                a.addCommand("removeAnchor", new CKEDITOR.removeAnchorCommand);
                a.setKeystroke(CKEDITOR.CTRL + 76, "link");
                if (a.ui.addButton) {
                    a.ui.addButton("Link", {
                        label: a.lang.link.toolbar,
                        command: "link",
                        toolbar: "links,10"
                    });
                    a.ui.addButton("Unlink", {
                        label: a.lang.link.unlink,
                        command: "unlink",
                        toolbar: "links,20"
                    });
                    a.ui.addButton("Anchor", {
                        label: a.lang.link.anchor.toolbar,
                        command: "anchor",
                        toolbar: "links,30"
                    })
                }
                CKEDITOR.dialog.add("link", "plugins/link/dialogs/link.js");
                CKEDITOR.dialog.add("anchor", this.path + "dialogs/anchor.js");
                a.on("doubleclick", function(b) {
                    var c = CKEDITOR.plugins.link.getSelectedLink(a) || b.data.element;
                    if (!c.isReadOnly())
                        if (c.is("a")) {
                            b.data.dialog = c.getAttribute("name") && (!c.getAttribute("href") || !c.getChildCount()) ? "anchor" : "link";
                            b.data.link = c
                        } else if (CKEDITOR.plugins.link.tryRestoreFakeAnchor(a, c)) b.data.dialog = "anchor"
                }, null, null, 0);
                a.on("doubleclick",
                    function(b) {
                        b.data.dialog in {
                            link: 1,
                            anchor: 1
                        } && b.data.link && a.getSelection().selectElement(b.data.link)
                    }, null, null, 20);
                a.addMenuItems && a.addMenuItems({
                    anchor: {
                        label: a.lang.link.anchor.menu,
                        command: "anchor",
                        group: "anchor",
                        order: 1
                    },
                    removeAnchor: {
                        label: a.lang.link.anchor.remove,
                        command: "removeAnchor",
                        group: "anchor",
                        order: 5
                    },
                    link: {
                        label: a.lang.link.menu,
                        command: "link",
                        group: "link",
                        order: 1
                    },
                    unlink: {
                        label: a.lang.link.unlink,
                        command: "unlink",
                        group: "link",
                        order: 5
                    }
                });
                a.contextMenu && a.contextMenu.addListener(function(b) {
                    if (!b ||
                        b.isReadOnly()) return null;
                    b = CKEDITOR.plugins.link.tryRestoreFakeAnchor(a, b);
                    if (!b && !(b = CKEDITOR.plugins.link.getSelectedLink(a))) return null;
                    var c = {};
                    b.getAttribute("href") && b.getChildCount() && (c = {
                        link: CKEDITOR.TRISTATE_OFF,
                        unlink: CKEDITOR.TRISTATE_OFF
                    });
                    if (b && b.hasAttribute("name")) c.anchor = c.removeAnchor = CKEDITOR.TRISTATE_OFF;
                    return c
                });
                this.compiledProtectionFunction = g(a)
            },
            afterInit: function(a) {
                a.dataProcessor.dataFilter.addRules({
                    elements: {
                        a: function(b) {
                            return !b.attributes.name ? null : !b.children.length ?
                                a.createFakeParserElement(b, "cke_anchor", "anchor") : null
                        }
                    }
                });
                var b = a._.elementsPath && a._.elementsPath.filters;
                b && b.push(function(b, c) {
                    if (c == "a" && (CKEDITOR.plugins.link.tryRestoreFakeAnchor(a, b) || b.getAttribute("name") && (!b.getAttribute("href") || !b.getChildCount()))) return "anchor"
                })
            }
        });
        var c = /^javascript:/,
            d = /^mailto:([^?]+)(?:\?(.+))?$/,
            j = /subject=([^;?:@&=$,\/]*)/,
            f = /body=([^;?:@&=$,\/]*)/,
            h = /^#(.*)$/,
            i = /^((?:http|https|ftp|news):\/\/)?(.*)$/,
            k = /^(_(?:self|top|parent|blank))$/,
            n = /^javascript:void\(location\.href='mailto:'\+String\.fromCharCode\(([^)]+)\)(?:\+'(.*)')?\)$/,
            o = /^javascript:([^(]+)\(([^)]+)\)$/,
            q = /\s*window.open\(\s*this\.href\s*,\s*(?:'([^']*)'|null)\s*,\s*'([^']*)'\s*\)\s*;\s*return\s*false;*\s*/,
            m = /(?:^|,)([^=]+)=(\d+|yes|no)/gi,
            l = {
                id: "advId",
                dir: "advLangDir",
                accessKey: "advAccessKey",
                name: "advName",
                lang: "advLangCode",
                tabindex: "advTabIndex",
                title: "advTitle",
                type: "advContentType",
                "class": "advCSSClasses",
                charset: "advCharset",
                style: "advStyles",
                rel: "advRel"
            };
        CKEDITOR.plugins.link = {
            getSelectedLink: function(a) {
                var b = a.getSelection(),
                    c = b.getSelectedElement();
                if (c && c.is("a")) return c;
                if (b = b.getRanges()[0]) {
                    b.shrink(CKEDITOR.SHRINK_TEXT);
                    return a.elementPath(b.getCommonAncestor()).contains("a", 1)
                }
                return null
            },
            getEditorAnchors: function(a) {
                for (var b = a.editable(), c = b.isInline() && !a.plugins.divarea ? a.document : b, b = c.getElementsByTag("a"), c = c.getElementsByTag("img"), d = [], f = 0, e; e = b.getItem(f++);)
                    if (e.data("cke-saved-name") || e.hasAttribute("name")) d.push({
                        name: e.data("cke-saved-name") || e.getAttribute("name"),
                        id: e.getAttribute("id")
                    });
                for (f = 0; e = c.getItem(f++);)(e =
                    this.tryRestoreFakeAnchor(a, e)) && d.push({
                    name: e.getAttribute("name"),
                    id: e.getAttribute("id")
                });
                return d
            },
            fakeAnchor: true,
            tryRestoreFakeAnchor: function(a, b) {
                if (b && b.data("cke-real-element-type") && b.data("cke-real-element-type") == "anchor") {
                    var c = a.restoreRealElement(b);
                    if (c.data("cke-saved-name")) return c
                }
            },
            parseLinkAttributes: function(a, b) {
                var e = b && (b.getAttribute("href")) || b.data("cke-saved-href") || "",
                    // g = a.plugins.link.compiledProtectionFunction,
                    w = a.config.emailProtection,
                    x, v = {};
                e.match(c) && (w == "encode" ?
                    e = e.replace(n, function(a, b, c) {
                        return "mailto:" + String.fromCharCode.apply(String, b.split(",")) + (c && c.replace(/\\'/g, "'"))
                    }) : w && e.replace(o, function(a, b, c) {
                        if (b == g.name) {
                            v.type = "email";
                            for (var a = v.email = {}, b = /(^')|('$)/g, c = c.match(/[^,\s]+/g), d = c.length, f, e, h = 0; h < d; h++) {
                                f = decodeURIComponent;
                                e = c[h].replace(b, "").replace(/\\'/g, "'");
                                e = f(e);
                                f = g.params[h].toLowerCase();
                                a[f] = e
                            }
                            a.address = [a.name, a.domain].join("@")
                        }
                    }));
                if (!v.type)
                    if (w = e.match(h)) {
                        v.type = "anchor";
                        v.anchor = {};
                        v.anchor.name = v.anchor.id = w[1]
                    } else if (w =
                    e.match(d)) {
                    x = e.match(j);
                    e = e.match(f);
                    v.type = "email";
                    var r = v.email = {};
                    r.address = w[1];
                    x && (r.subject = decodeURIComponent(x[1]));
                    e && (r.body = decodeURIComponent(e[1]))
                } else if (e && (x = e.match(i))) {
                    v.type = "url";
                    v.url = {};
                    v.url.url = x[2]
                    var parseLinkToMail = x[2].indexOf("@");
                    if(parseLinkToMail >= 0) {
                        v.url.protocol = "mailto:";
                    } else {
                        v.url.protocol = x[1];
                    }
                }
                if (b) {
                    if (e = b.getAttribute("target")) v.target = {
                        type: e.match(k) ? e : "frame",
                        name: e
                    };
                    else if (e = (e = b.data("cke-pa-onclick") || b.getAttribute("onclick")) && e.match(q))
                        for (v.target = {
                            type: "popup",
                            name: e[1]
                        }; w = m.exec(e[2]);)(w[2] == "yes" || w[2] == "1") && !(w[1] in {
                            height: 1,
                            width: 1,
                            top: 1,
                            left: 1
                        }) ? v.target[w[1]] = true : isFinite(w[2]) && (v.target[w[1]] = w[2]);
                    var e = {}, y;
                    for (y in l)(w = b.getAttribute(y)) && (e[l[y]] = w);
                    if (y = b.data("cke-saved-name") || e.advName) e.advName = y;
                    if (!CKEDITOR.tools.isEmpty(e)) v.advanced = e
                }
                return v
            },
            getLinkAttributes: function(c, d) {
                var f = c.config.emailProtection || "",
                    g = {};
                switch (d.type) {
                    case "url":
                        var f = d.url && d.url.protocol !== void 0 ? d.url.protocol : "http://",
                            h = d.url && CKEDITOR.tools.trim(d.url.url) || "";

                        // если задана переменная вида {$activationLink}, то при её замене подставится и протокол
                        if (h.match(/^{\$.+}$/)) {
                            f = '';
                        }

                        g["data-cke-saved-href"] = h.indexOf("/") === 0 ? h : f + h;
                        break;
                    case "anchor":
                        f = d.anchor && d.anchor.id;
                        g["data-cke-saved-href"] = "#" + (d.anchor && d.anchor.name || f || "");
                        break;
                    case "email":
                        var i = d.email,
                            h = i.address;
                        switch (f) {
                            case "":
                            case "encode":
                                var j = encodeURIComponent(i.subject || ""),
                                    k = encodeURIComponent(i.body || ""),
                                    i = [];
                                j && i.push("subject=" + j);
                                k && i.push("body=" + k);
                                i = i.length ? "?" + i.join("&") : "";
                                if (f == "encode") {
                                    f = ["javascript:void(location.href='mailto:'+", e(h)];
                                    i && f.push("+'", a(i), "'");
                                    f.push(")")
                                } else f = ["mailto:", h, i];
                                break;
                            default:
                                f = h.split("@", 2);
                                i.name = f[0];
                                i.domain = f[1];
                                f = ["javascript:", b(c, i)]
                        }
                        g["data-cke-saved-href"] = f.join("")
                }
                if (d.target)
                    if (d.target.type == "popup") {
                        for (var f = ["window.open(this.href, '", d.target.name || "", "', '"], m = ["resizable", "status", "location", "toolbar", "menubar", "fullscreen", "scrollbars", "dependent"], h = m.length, j = function(a) {
                                d.target[a] && m.push(a + "=" + d.target[a])
                            }, i = 0; i < h; i++) m[i] = m[i] + (d.target[m[i]] ? "=yes" : "=no");
                        j("width");
                        j("left");
                        j("height");
                        j("top");
                        f.push(m.join(","), "'); return false;");
                        g["data-cke-pa-onclick"] = f.join("")
                    } else if (d.target.type !=
                    "notSet" && d.target.name) g.target = d.target.name;
                if (d.advanced) {
                    for (var q in l)(f = d.advanced[l[q]]) && (g[q] = f);
                    if (g.name) g["data-cke-saved-name"] = g.name
                }
                if (g["data-cke-saved-href"]) g.href = g["data-cke-saved-href"];
                q = CKEDITOR.tools.extend({
                    target: 1,
                    onclick: 1,
                    "data-cke-pa-onclick": 1,
                    "data-cke-saved-name": 1
                }, l);
                for (var n in g) delete q[n];
                return {
                    set: g,
                    removed: CKEDITOR.tools.objectKeys(q)
                }
            }
        };
        CKEDITOR.unlinkCommand = function() {};
        CKEDITOR.unlinkCommand.prototype = {
            exec: function(a) {
                var b = new CKEDITOR.style({
                    element: "a",
                    type: CKEDITOR.STYLE_INLINE,
                    alwaysRemoveElement: 1
                });
                a.removeStyle(b)
            },
            refresh: function(a, b) {
                var c = b.lastElement && b.lastElement.getAscendant("a", true);
                c && c.getName() == "a" && c.getAttribute("href") && c.getChildCount() ? this.setState(CKEDITOR.TRISTATE_OFF) : this.setState(CKEDITOR.TRISTATE_DISABLED)
            },
            contextSensitive: 1,
            startDisabled: 1,
            requiredContent: "a[href]"
        };
        CKEDITOR.removeAnchorCommand = function() {};
        CKEDITOR.removeAnchorCommand.prototype = {
            exec: function(a) {
                var b = a.getSelection(),
                    c = b.createBookmarks(),
                    d;
                if (b &&
                    (d = b.getSelectedElement()) && (!d.getChildCount() ? CKEDITOR.plugins.link.tryRestoreFakeAnchor(a, d) : d.is("a"))) d.remove(1);
                else if (d = CKEDITOR.plugins.link.getSelectedLink(a))
                    if (d.hasAttribute("href")) {
                        d.removeAttributes({
                            name: 1,
                            "data-cke-saved-name": 1
                        });
                        d.removeClass("cke_anchor")
                    } else d.remove(1);
                b.selectBookmarks(c)
            },
            requiredContent: "a[name]"
        };
        CKEDITOR.tools.extend(CKEDITOR.config, {
            linkShowAdvancedTab: true,
            linkShowTargetTab: true
        })
    }(), "use strict",
    function() {
        function a(a, b, c) {
            return k(b) && k(c) && c.equals(b.getNext(function(a) {
                return !(Y(a) ||
                    Z(a) || n(a))
            }))
        }

        function e(a) {
            this.upper = a[0];
            this.lower = a[1];
            this.set.apply(this, a.slice(2))
        }

        function b(a) {
            var b = a.element;
            if (b && k(b))
                if ((b = b.getAscendant(a.triggers, true)) && a.editable.contains(b)) {
                    var c = d(b);
                    if (c.getAttribute("contenteditable") == "true") return b;
                    if (c.is(a.triggers)) return c
                }
            return null
        }

        function g(a, b, c) {
            u(a, b);
            u(a, c);
            a = b.size.bottom;
            c = c.size.top;
            return a && c ? 0 | (a + c) / 2 : a || c
        }

        function c(a, b, c) {
            return b = b[c ? "getPrevious" : "getNext"](function(b) {
                return b && b.type == CKEDITOR.NODE_TEXT && !Y(b) ||
                    k(b) && !n(b) && !i(a, b)
            })
        }

        function d(a, b) {
            if (a.data("cke-editable")) return null;
            for (b || (a = a.getParent()); a;) {
                if (a.data("cke-editable")) break;
                if (a.hasAttribute("contenteditable")) return a;
                a = a.getParent()
            }
            return null
        }

        function j(a) {
            var b = a.doc,
                c = z('<span contenteditable="false" style="' + P + "position:absolute;border-top:1px dashed " + a.boxColor + '"></span>', b),
                d = CKEDITOR.getUrl(this.path + "images/" + (B.hidpi ? "hidpi/" : "") + "icon" + (a.rtl ? "-rtl" : "") + ".png");
            r(c, {
                attach: function() {
                    this.wrap.getParent() || this.wrap.appendTo(a.editable,
                        true);
                    return this
                },
                lineChildren: [r(z('<span title="' + a.editor.lang.magicline.title + '" contenteditable="false">&#8629;</span>', b), {
                    base: P + "height:17px;width:17px;" + (a.rtl ? "left" : "right") + ":17px;background:url(" + d + ") center no-repeat " + a.boxColor + ";cursor:pointer;" + (B.hc ? "font-size: 15px;line-height:14px;border:1px solid #fff;text-align:center;" : "") + (B.hidpi ? "background-size: 9px 10px;" : ""),
                    looks: ["top:-8px;" + CKEDITOR.tools.cssVendorPrefix("border-radius", "2px", 1), "top:-17px;" + CKEDITOR.tools.cssVendorPrefix("border-radius",
                        "2px 2px 0px 0px", 1), "top:-1px;" + CKEDITOR.tools.cssVendorPrefix("border-radius", "0px 0px 2px 2px", 1)]
                }), r(z(W, b), {
                    base: V + "left:0px;border-left-color:" + a.boxColor + ";",
                    looks: ["border-width:8px 0 8px 8px;top:-8px", "border-width:8px 0 0 8px;top:-8px", "border-width:0 0 8px 8px;top:0px"]
                }), r(z(W, b), {
                    base: V + "right:0px;border-right-color:" + a.boxColor + ";",
                    looks: ["border-width:8px 8px 8px 0;top:-8px", "border-width:8px 8px 0 0;top:-8px", "border-width:0 8px 8px 0;top:0px"]
                })],
                detach: function() {
                    this.wrap.getParent() &&
                        this.wrap.remove();
                    return this
                },
                mouseNear: function() {
                    u(a, this);
                    var b = a.holdDistance,
                        c = this.size;
                    return c && a.mouse.y > c.top - b && a.mouse.y < c.bottom + b && a.mouse.x > c.left - b && a.mouse.x < c.right + b ? true : false
                },
                place: function() {
                    var b = a.view,
                        c = a.editable,
                        d = a.trigger,
                        f = d.upper,
                        e = d.lower,
                        g = f || e,
                        h = g.getParent(),
                        i = {};
                    this.trigger = d;
                    f && u(a, f, true);
                    e && u(a, e, true);
                    u(a, h, true);
                    a.inInlineMode && w(a, true);
                    if (h.equals(c)) {
                        i.left = b.scroll.x;
                        i.right = -b.scroll.x;
                        i.width = ""
                    } else {
                        i.left = g.size.left - g.size.margin.left + b.scroll.x -
                            (a.inInlineMode ? b.editable.left + b.editable.border.left : 0);
                        i.width = g.size.outerWidth + g.size.margin.left + g.size.margin.right + b.scroll.x;
                        i.right = ""
                    } if (f && e) i.top = f.size.margin.bottom === e.size.margin.top ? 0 | f.size.bottom + f.size.margin.bottom / 2 : f.size.margin.bottom < e.size.margin.top ? f.size.bottom + f.size.margin.bottom : f.size.bottom + f.size.margin.bottom - e.size.margin.top;
                    else if (f) {
                        if (!e) i.top = f.size.bottom + f.size.margin.bottom
                    } else i.top = e.size.top - e.size.margin.top; if (d.is(L) || i.top > b.scroll.y - 15 && i.top <
                        b.scroll.y + 5) {
                        i.top = a.inInlineMode ? 0 : b.scroll.y;
                        this.look(L)
                    } else if (d.is(H) || i.top > b.pane.bottom - 5 && i.top < b.pane.bottom + 15) {
                        i.top = a.inInlineMode ? b.editable.height + b.editable.padding.top + b.editable.padding.bottom : b.pane.bottom - 1;
                        this.look(H)
                    } else {
                        if (a.inInlineMode) i.top = i.top - (b.editable.top + b.editable.border.top);
                        this.look(Q)
                    } if (a.inInlineMode) {
                        i.top--;
                        i.top = i.top + b.editable.scroll.top;
                        i.left = i.left + b.editable.scroll.left
                    }
                    for (var j in i) i[j] = CKEDITOR.tools.cssLength(i[j]);
                    this.setStyles(i)
                },
                look: function(a) {
                    if (this.oldLook !=
                        a) {
                        for (var b = this.lineChildren.length, c; b--;)(c = this.lineChildren[b]).setAttribute("style", c.base + c.looks[0 | a / 2]);
                        this.oldLook = a
                    }
                },
                wrap: new y("span", a.doc)
            });
            for (b = c.lineChildren.length; b--;) c.lineChildren[b].appendTo(c);
            c.look(Q);
            c.appendTo(c.wrap);
            c.unselectable();
            c.lineChildren[0].on("mouseup", function(b) {
                c.detach();
                f(a, function(b) {
                    var c = a.line.trigger;
                    b[c.is(J) ? "insertBefore" : "insertAfter"](c.is(J) ? c.lower : c.upper)
                }, true);
                a.editor.focus();
                !B.ie && a.enterMode != CKEDITOR.ENTER_BR && a.hotNode.scrollIntoView();
                b.data.preventDefault(true)
            });
            c.on("mousedown", function(a) {
                a.data.preventDefault(true)
            });
            a.line = c
        }

        function f(a, b, c) {
            var f = new CKEDITOR.dom.range(a.doc),
                e = a.editor,
                g;
            if (B.ie && a.enterMode == CKEDITOR.ENTER_BR) g = a.doc.createText(O);
            else {
                g = (g = d(a.element, true)) && g.data("cke-enter-mode") || a.enterMode;
                g = new y(D[g], a.doc);
                g.is("br") || a.doc.createText(O).appendTo(g)
            }
            c && e.fire("saveSnapshot");
            b(g);
            f.moveToPosition(g, CKEDITOR.POSITION_AFTER_START);
            e.getSelection().selectRanges([f]);
            a.hotNode = g;
            c && e.fire("saveSnapshot")
        }

        function h(a, e) {
            return {
                canUndo: true,
                modes: {
                    wysiwyg: 1
                },
                exec: function() {
                    function g(b) {
                        var c = B.ie && B.version < 9 ? " " : O,
                            d = a.hotNode && a.hotNode.getText() == c && a.element.equals(a.hotNode) && a.lastCmdDirection === !! e;
                        f(a, function(c) {
                            d && a.hotNode && a.hotNode.remove();
                            c[e ? "insertAfter" : "insertBefore"](b);
                            c.setAttributes({
                                "data-cke-magicline-hot": 1,
                                "data-cke-magicline-dir": !! e
                            });
                            a.lastCmdDirection = !! e
                        });
                        !B.ie && a.enterMode != CKEDITOR.ENTER_BR && a.hotNode.scrollIntoView();
                        a.line.detach()
                    }
                    return function(f) {
                        var f = f.getSelection().getStartElement(),
                            h, f = f.getAscendant(N, 1);
                        if (!m(a, f) && f && !f.equals(a.editable) && !f.contains(a.editable)) {
                            if ((h = d(f)) && h.getAttribute("contenteditable") == "false") f = h;
                            a.element = f;
                            h = c(a, f, !e);
                            var i;
                            if (k(h) && h.is(a.triggers) && h.is(R) && (!c(a, h, !e) || (i = c(a, h, !e)) && k(i) && i.is(a.triggers))) g(h);
                            else {
                                i = b(a, f);
                                if (k(i))
                                    if (c(a, i, !e))(f = c(a, i, !e)) && (k(f) && f.is(a.triggers)) && g(i);
                                    else g(i)
                            }
                        }
                    }
                }()
            }
        }

        function i(a, b) {
            if (!b || !(b.type == CKEDITOR.NODE_ELEMENT && b.$)) return false;
            var c = a.line;
            return c.wrap.equals(b) || c.wrap.contains(b)
        }

        function k(a) {
            return a &&
                a.type == CKEDITOR.NODE_ELEMENT && a.$
        }

        function n(a) {
            if (!k(a)) return false;
            var b;
            if (!(b = o(a)))
                if (k(a)) {
                    b = {
                        left: 1,
                        right: 1,
                        center: 1
                    };
                    b = !(!b[a.getComputedStyle("float")] && !b[a.getAttribute("align")])
                } else b = false;
            return b
        }

        function o(a) {
            return !!{
                absolute: 1,
                fixed: 1
            }[a.getComputedStyle("position")]
        }

        function q(a, b) {
            return k(b) ? b.is(a.triggers) : null
        }

        function m(a, b) {
            if (!b) return false;
            for (var c = b.getParents(1), d = c.length; d--;)
                for (var f = a.tabuList.length; f--;)
                    if (c[d].hasAttribute(a.tabuList[f])) return true;
            return false
        }

        function l(a, b, c) {
            b = b[c ? "getLast" : "getFirst"](function(b) {
                return a.isRelevant(b) && !b.is(K)
            });
            if (!b) return false;
            u(a, b);
            return c ? b.size.top > a.mouse.y : b.size.bottom < a.mouse.y
        }

        function p(a) {
            var b = a.editable,
                c = a.mouse,
                d = a.view,
                f = a.triggerOffset;
            w(a);
            var g = c.y > (a.inInlineMode ? d.editable.top + d.editable.height / 2 : Math.min(d.editable.height, d.pane.height) / 2),
                b = b[g ? "getLast" : "getFirst"](function(a) {
                    return !(Y(a) || Z(a))
                });
            if (!b) return null;
            i(a, b) && (b = a.line.wrap[g ? "getPrevious" : "getNext"](function(a) {
                return !(Y(a) ||
                    Z(a))
            }));
            if (!k(b) || n(b) || !q(a, b)) return null;
            u(a, b);
            if (!g && b.size.top >= 0 && c.y > 0 && c.y < b.size.top + f) {
                a = a.inInlineMode || d.scroll.y === 0 ? L : Q;
                return new e([null, b, J, E, a])
            }
            if (g && b.size.bottom <= d.pane.height && c.y > b.size.bottom - f && c.y < d.pane.height) {
                a = a.inInlineMode || b.size.bottom > d.pane.height - f && b.size.bottom < d.pane.height ? H : Q;
                return new e([b, null, C, E, a])
            }
            return null
        }

        function t(a) {
            var d = a.mouse,
                f = a.view,
                g = a.triggerOffset,
                h = b(a);
            if (!h) return null;
            u(a, h);
            var g = Math.min(g, 0 | h.size.outerHeight / 2),
                i = [],
                j, m;
            if (d.y >
                h.size.top - 1 && d.y < h.size.top + g) m = false;
            else if (d.y > h.size.bottom - g && d.y < h.size.bottom + 1) m = true;
            else return null; if (n(h) || l(a, h, m) || h.getParent().is(M)) return null;
            var p = c(a, h, !m);
            if (p) {
                if (p && p.type == CKEDITOR.NODE_TEXT) return null;
                if (k(p)) {
                    if (n(p) || !q(a, p) || p.getParent().is(M)) return null;
                    i = [p, h][m ? "reverse" : "concat"]().concat([F, E])
                }
            } else {
                if (h.equals(a.editable[m ? "getLast" : "getFirst"](a.isRelevant))) {
                    w(a);
                    m && d.y > h.size.bottom - g && d.y < f.pane.height && h.size.bottom > f.pane.height - g && h.size.bottom < f.pane.height ?
                        j = H : d.y > 0 && d.y < h.size.top + g && (j = L)
                } else j = Q;
                i = [null, h][m ? "reverse" : "concat"]().concat([m ? C : J, E, j, h.equals(a.editable[m ? "getLast" : "getFirst"](a.isRelevant)) ? m ? H : L : Q])
            }
            return 0 in i ? new e(i) : null
        }

        function s(a, b, c, d) {
            for (var f = function() {
                var c = B.ie ? b.$.currentStyle : a.win.$.getComputedStyle(b.$, "");
                return B.ie ? function(a) {
                    return c[CKEDITOR.tools.cssStyleToDomStyle(a)]
                } : function(a) {
                    return c.getPropertyValue(a)
                }
            }(), e = b.getDocumentPosition(), g = {}, h = {}, i = {}, j = {}, k = X.length; k--;) {
                g[X[k]] = parseInt(f("border-" +
                    X[k] + "-width"), 10) || 0;
                i[X[k]] = parseInt(f("padding-" + X[k]), 10) || 0;
                h[X[k]] = parseInt(f("margin-" + X[k]), 10) || 0
            }(!c || d) && x(a, d);
            j.top = e.y - (c ? 0 : a.view.scroll.y);
            j.left = e.x - (c ? 0 : a.view.scroll.x);
            j.outerWidth = b.$.offsetWidth;
            j.outerHeight = b.$.offsetHeight;
            j.height = j.outerHeight - (i.top + i.bottom + g.top + g.bottom);
            j.width = j.outerWidth - (i.left + i.right + g.left + g.right);
            j.bottom = j.top + j.outerHeight;
            j.right = j.left + j.outerWidth;
            if (a.inInlineMode) j.scroll = {
                top: b.$.scrollTop,
                left: b.$.scrollLeft
            };
            return r({
                border: g,
                padding: i,
                margin: h,
                ignoreScroll: c
            }, j, true)
        }

        function u(a, b, c) {
            if (!k(b)) return b.size = null;
            if (b.size) {
                if (b.size.ignoreScroll == c && b.size.date > new Date - T) return null
            } else b.size = {};
            return r(b.size, s(a, b, c), {
                date: +new Date
            }, true)
        }

        function w(a, b) {
            a.view.editable = s(a, a.editable, b, true)
        }

        function x(a, b) {
            if (!a.view) a.view = {};
            var c = a.view;
            if (b || !(c && c.date > new Date - T)) {
                var d = a.win,
                    c = d.getScrollPosition(),
                    d = d.getViewPaneSize();
                r(a.view, {
                    scroll: {
                        x: c.x,
                        y: c.y,
                        width: a.doc.$.documentElement.scrollWidth - d.width,
                        height: a.doc.$.documentElement.scrollHeight -
                            d.height
                    },
                    pane: {
                        width: d.width,
                        height: d.height,
                        bottom: d.height + c.y
                    },
                    date: +new Date
                }, true)
            }
        }

        function v(a, b, c, d) {
            for (var f = d, g = d, h = 0, i = false, j = false, k = a.view.pane.height, m = a.mouse; m.y + h < k && m.y - h > 0;) {
                i || (i = b(f, d));
                j || (j = b(g, d));
                !i && m.y - h > 0 && (f = c(a, {
                    x: m.x,
                    y: m.y - h
                }));
                !j && m.y + h < k && (g = c(a, {
                    x: m.x,
                    y: m.y + h
                }));
                if (i && j) break;
                h = h + 2
            }
            return new e([f, g, null, null])
        }
        CKEDITOR.plugins.add("magicline", {
            init: function(a) {
                var d = a.config,
                    g = d.magicline_triggerOffset || 30,
                    l = {
                        editor: a,
                        enterMode: d.enterMode,
                        triggerOffset: g,
                        holdDistance: 0 |
                            g * (d.magicline_holdDistance || 0.5),
                        boxColor: d.magicline_color || "#ff0000",
                        rtl: d.contentsLangDirection == "rtl",
                        tabuList: ["data-cke-hidden-sel"].concat(d.magicline_tabuList || []),
                        triggers: d.magicline_everywhere ? N : {
                            table: 1,
                            hr: 1,
                            div: 1,
                            ul: 1,
                            ol: 1,
                            dl: 1,
                            form: 1,
                            blockquote: 1
                        }
                    }, q, u, v;
                l.isRelevant = function(a) {
                    return k(a) && !i(l, a) && !n(a)
                };
                a.on("contentDom", function() {
                    var g = a.editable(),
                        k = a.document,
                        n = a.window;
                    r(l, {
                        editable: g,
                        inInlineMode: g.isInline(),
                        doc: k,
                        win: n,
                        hotNode: null
                    }, true);
                    l.boundary = l.inInlineMode ? l.editable :
                        l.doc.getDocumentElement();
                    if (!g.is(G.$inline)) {
                        l.inInlineMode && !o(g) && g.setStyles({
                            position: "relative",
                            top: null,
                            left: null
                        });
                        j.call(this, l);
                        x(l);
                        g.attachListener(a, "beforeUndoImage", function() {
                            l.line.detach()
                        });
                        g.attachListener(a, "beforeGetData", function() {
                            if (l.line.wrap.getParent()) {
                                l.line.detach();
                                a.once("getData", function() {
                                    l.line.attach()
                                }, null, null, 1E3)
                            }
                        }, null, null, 0);
                        g.attachListener(l.inInlineMode ? k : k.getWindow().getFrame(), "mouseout", function(b) {
                            if (a.mode == "wysiwyg")
                                if (l.inInlineMode) {
                                    var c =
                                        b.data.$.clientX,
                                        b = b.data.$.clientY;
                                    x(l);
                                    w(l, true);
                                    var d = l.view.editable,
                                        f = l.view.scroll;
                                    if (!(c > d.left - f.x && c < d.right - f.x) || !(b > d.top - f.y && b < d.bottom - f.y)) {
                                        clearTimeout(v);
                                        v = null;
                                        l.line.detach()
                                    }
                                } else {
                                    clearTimeout(v);
                                    v = null;
                                    l.line.detach()
                                }
                        });
                        g.attachListener(g, "keyup", function() {
                            l.hiddenMode = 0
                        });
                        g.attachListener(g, "keydown", function(b) {
                            if (a.mode == "wysiwyg") switch (b.data.getKeystroke()) {
                                case 2228240:
                                case 16:
                                    l.hiddenMode = 1;
                                    l.line.detach()
                            }
                        });
                        g.attachListener(l.inInlineMode ? g : k, "mousemove", function(b) {
                            u =
                                true;
                            if (!(a.mode != "wysiwyg" || a.readOnly || v)) {
                                var c = {
                                    x: b.data.$.clientX,
                                    y: b.data.$.clientY
                                };
                                v = setTimeout(function() {
                                    l.mouse = c;
                                    v = l.trigger = null;
                                    x(l);
                                    if (u && !l.hiddenMode && a.focusManager.hasFocus && !l.line.mouseNear() && (l.element = S(l, true))) {
                                        if ((l.trigger = p(l) || t(l) || ba(l)) && !m(l, l.trigger.upper || l.trigger.lower)) l.line.attach().place();
                                        else {
                                            l.trigger = null;
                                            l.line.detach()
                                        }
                                        u = false
                                    }
                                }, 30)
                            }
                        });
                        g.attachListener(n, "scroll", function() {
                            if (a.mode == "wysiwyg") {
                                l.line.detach();
                                if (B.webkit) {
                                    l.hiddenMode = 1;
                                    clearTimeout(q);
                                    q = setTimeout(function() {
                                        if (!l.mouseDown) l.hiddenMode = 0
                                    }, 50)
                                }
                            }
                        });
                        g.attachListener(A ? k : n, "mousedown", function() {
                            if (a.mode == "wysiwyg") {
                                l.line.detach();
                                l.hiddenMode = 1;
                                l.mouseDown = 1
                            }
                        });
                        g.attachListener(A ? k : n, "mouseup", function() {
                            l.hiddenMode = 0;
                            l.mouseDown = 0
                        });
                        a.addCommand("accessPreviousSpace", h(l));
                        a.addCommand("accessNextSpace", h(l, true));
                        a.setKeystroke([
                            [d.magicline_keystrokePrevious, "accessPreviousSpace"],
                            [d.magicline_keystrokeNext, "accessNextSpace"]
                        ]);
                        a.on("loadSnapshot", function() {
                            var b, c, d, f;
                            for (f in {
                                p: 1,
                                br: 1,
                                div: 1
                            }) {
                                b = a.document.getElementsByTag(f);
                                for (d = b.count(); d--;)
                                    if ((c = b.getItem(d)).data("cke-magicline-hot")) {
                                        l.hotNode = c;
                                        l.lastCmdDirection = c.data("cke-magicline-dir") === "true" ? true : false;
                                        return
                                    }
                            }
                        });
                        this.backdoor = {
                            accessFocusSpace: f,
                            boxTrigger: e,
                            isLine: i,
                            getAscendantTrigger: b,
                            getNonEmptyNeighbour: c,
                            getSize: s,
                            that: l,
                            triggerEdge: t,
                            triggerEditable: p,
                            triggerExpand: ba
                        }
                    }
                }, this)
            }
        });
        var r = CKEDITOR.tools.extend,
            y = CKEDITOR.dom.element,
            z = y.createFromHtml,
            B = CKEDITOR.env,
            A = CKEDITOR.env.ie && CKEDITOR.env.version <
                9,
            G = CKEDITOR.dtd,
            D = {}, J = 128,
            C = 64,
            F = 32,
            E = 16,
            I = 8,
            L = 4,
            H = 2,
            Q = 1,
            O = " ",
            M = G.$listItem,
            K = G.$tableContent,
            R = r({}, G.$nonEditable, G.$empty),
            N = G.$block,
            T = 100,
            P = "width:0px;height:0px;padding:0px;margin:0px;display:block;z-index:9999;color:#fff;position:absolute;font-size: 0px;line-height:0px;",
            V = P + "border-color:transparent;display:block;border-style:solid;",
            W = "<span>" + O + "</span>";
        D[CKEDITOR.ENTER_BR] = "br";
        D[CKEDITOR.ENTER_P] = "p";
        D[CKEDITOR.ENTER_DIV] = "div";
        e.prototype = {
            set: function(a, b, c) {
                this.properties = a + b +
                    (c || Q);
                return this
            },
            is: function(a) {
                return (this.properties & a) == a
            }
        };
        var S = function() {
            function a(b, c) {
                var d = b.$.elementFromPoint(c.x, c.y);
                return d && d.nodeType ? new CKEDITOR.dom.element(d) : null
            }
            return function(b, c, d) {
                if (!b.mouse) return null;
                var f = b.doc,
                    e = b.line.wrap,
                    d = d || b.mouse,
                    g = a(f, d);
                if (c && i(b, g)) {
                    e.hide();
                    g = a(f, d);
                    e.show()
                }
                return !g || !(g.type == CKEDITOR.NODE_ELEMENT && g.$) || B.ie && B.version < 9 && !b.boundary.equals(g) && !b.boundary.contains(g) ? null : g
            }
        }(),
            Y = CKEDITOR.dom.walker.whitespaces(),
            Z = CKEDITOR.dom.walker.nodeType(CKEDITOR.NODE_COMMENT),
            ba = function() {
                function b(d) {
                    var f = d.element,
                        e, h, i;
                    if (!k(f) || f.contains(d.editable) || f.isReadOnly()) return null;
                    i = v(d, function(a, b) {
                        return !b.equals(a)
                    }, function(a, b) {
                        return S(a, true, b)
                    }, f);
                    e = i.upper;
                    h = i.lower;
                    if (a(d, e, h)) return i.set(F, I);
                    if (e && f.contains(e))
                        for (; !e.getParent().equals(f);) e = e.getParent();
                    else e = f.getFirst(function(a) {
                        return c(d, a)
                    }); if (h && f.contains(h))
                        for (; !h.getParent().equals(f);) h = h.getParent();
                    else h = f.getLast(function(a) {
                        return c(d, a)
                    }); if (!e || !h) return null;
                    u(d, e);
                    u(d, h);
                    if (!(d.mouse.y >
                        e.size.top && d.mouse.y < h.size.bottom)) return null;
                    for (var f = Number.MAX_VALUE, j, m, l, q; h && !h.equals(e);) {
                        if (!(m = e.getNext(d.isRelevant))) break;
                        j = Math.abs(g(d, e, m) - d.mouse.y);
                        if (j < f) {
                            f = j;
                            l = e;
                            q = m
                        }
                        e = m;
                        u(d, e)
                    }
                    if (!l || !q || !(d.mouse.y > l.size.top && d.mouse.y < q.size.bottom)) return null;
                    i.upper = l;
                    i.lower = q;
                    return i.set(F, I)
                }

                function c(a, b) {
                    return !(b && b.type == CKEDITOR.NODE_TEXT || Z(b) || n(b) || i(a, b) || b.type == CKEDITOR.NODE_ELEMENT && b.$ && b.is("br"))
                }
                return function(c) {
                    var d = b(c),
                        f;
                    if (f = d) {
                        f = d.upper;
                        var e = d.lower;
                        f = !f || !e || n(e) || n(f) || e.equals(f) || f.equals(e) || e.contains(f) || f.contains(e) ? false : q(c, f) && q(c, e) && a(c, f, e) ? true : false
                    }
                    return f ? d : null
                }
            }(),
            X = ["top", "left", "right", "bottom"]
    }(), CKEDITOR.config.magicline_keystrokePrevious = CKEDITOR.CTRL + CKEDITOR.SHIFT + 51, CKEDITOR.config.magicline_keystrokeNext = CKEDITOR.CTRL + CKEDITOR.SHIFT + 52,
    function() {
        function a(a) {
            if (!a || a.type != CKEDITOR.NODE_ELEMENT || a.getName() != "form") return [];
            for (var b = [], c = ["style", "className"], e = 0; e < c.length; e++) {
                var g = a.$.elements.namedItem(c[e]);
                if (g) {
                    g = new CKEDITOR.dom.element(g);
                    b.push([g, g.nextSibling]);
                    g.remove()
                }
            }
            return b
        }

        function e(a, b) {
            if (a && !(a.type != CKEDITOR.NODE_ELEMENT || a.getName() != "form") && b.length > 0)
                for (var c = b.length - 1; c >= 0; c--) {
                    var e = b[c][0],
                        g = b[c][1];
                    g ? e.insertBefore(g) : e.appendTo(a)
                }
        }

        function b(b, c) {
            var f = a(b),
                g = {}, i = b.$;
            if (!c) {
                g["class"] = i.className || "";
                i.className = ""
            }
            g.inline = i.style.cssText || "";
            if (!c) i.style.cssText = "position: static; overflow: visible";
            e(f);
            return g
        }

        function g(b, c) {
            var f = a(b),
                g = b.$;
            if ("class" in c) g.className =
                c["class"];
            if ("inline" in c) g.style.cssText = c.inline;
            e(f)
        }

        function c(a) {
            if (!a.editable().isInline()) {
                var b = CKEDITOR.instances,
                    c;
                for (c in b) {
                    var e = b[c];
                    if (e.mode == "wysiwyg" && !e.readOnly) {
                        e = e.document.getBody();
                        e.setAttribute("contentEditable", false);
                        e.setAttribute("contentEditable", true)
                    }
                }
                if (a.editable().hasFocus) {
                    a.toolbox.focus();
                    a.focus()
                }
            }
        }
        CKEDITOR.plugins.add("maximize", {
            init: function(a) {
                function e() {
                    var b = i.getViewPaneSize();
                    a.resize(b.width, b.height, null, true)
                }
                if (a.elementMode != CKEDITOR.ELEMENT_MODE_INLINE) {
                    var f =
                        a.lang,
                        h = CKEDITOR.document,
                        i = h.getWindow(),
                        k, n, o, q = CKEDITOR.TRISTATE_OFF;
                    a.addCommand("maximize", {
                        modes: {
                            wysiwyg: !CKEDITOR.env.iOS,
                            source: !CKEDITOR.env.iOS
                        },
                        readOnly: 1,
                        editorFocus: false,
                        exec: function() {
                            var m = a.container.getFirst(function(a) {
                                return a.type == CKEDITOR.NODE_ELEMENT && a.hasClass("cke_inner")
                            }),
                                l = a.ui.space("contents");
                            if (a.mode == "wysiwyg") {
                                var p = a.getSelection();
                                k = p && p.getRanges();
                                n = i.getScrollPosition()
                            } else {
                                var t = a.editable().$;
                                k = !CKEDITOR.env.ie && [t.selectionStart, t.selectionEnd];
                                n = [t.scrollLeft,
                                    t.scrollTop
                                ]
                            } if (this.state == CKEDITOR.TRISTATE_OFF) {
                                i.on("resize", e);
                                o = i.getScrollPosition();
                                for (p = a.container; p = p.getParent();) {
                                    p.setCustomData("maximize_saved_styles", b(p));
                                    p.setStyle("z-index", a.config.baseFloatZIndex - 5)
                                }
                                l.setCustomData("maximize_saved_styles", b(l, true));
                                m.setCustomData("maximize_saved_styles", b(m, true));
                                l = {
                                    overflow: CKEDITOR.env.webkit ? "" : "hidden",
                                    width: 0,
                                    height: 0
                                };
                                h.getDocumentElement().setStyles(l);
                                !CKEDITOR.env.gecko && h.getDocumentElement().setStyle("position", "fixed");
                                (!CKEDITOR.env.gecko || !CKEDITOR.env.quirks) && h.getBody().setStyles(l);
                                CKEDITOR.env.ie ? setTimeout(function() {
                                    i.$.scrollTo(0, 0)
                                }, 0) : i.$.scrollTo(0, 0);
                                m.setStyle("position", CKEDITOR.env.gecko && CKEDITOR.env.quirks ? "fixed" : "absolute");
                                m.$.offsetLeft;
                                m.setStyles({
                                    "z-index": a.config.baseFloatZIndex - 5,
                                    left: "0px",
                                    top: "0px"
                                });
                                m.addClass("cke_maximized");
                                e();
                                l = m.getDocumentPosition();
                                m.setStyles({
                                    left: -1 * l.x + "px",
                                    top: -1 * l.y + "px"
                                });
                                CKEDITOR.env.gecko && c(a)
                            } else if (this.state == CKEDITOR.TRISTATE_ON) {
                                i.removeListener("resize", e);
                                l = [l,
                                    m
                                ];
                                for (p = 0; p < l.length; p++) {
                                    g(l[p], l[p].getCustomData("maximize_saved_styles"));
                                    l[p].removeCustomData("maximize_saved_styles")
                                }
                                for (p = a.container; p = p.getParent();) {
                                    g(p, p.getCustomData("maximize_saved_styles"));
                                    p.removeCustomData("maximize_saved_styles")
                                }
                                CKEDITOR.env.ie ? setTimeout(function() {
                                    i.$.scrollTo(o.x, o.y)
                                }, 0) : i.$.scrollTo(o.x, o.y);
                                m.removeClass("cke_maximized");
                                if (CKEDITOR.env.webkit) {
                                    m.setStyle("display", "inline");
                                    setTimeout(function() {
                                        m.setStyle("display", "block")
                                    }, 0)
                                }
                                a.fire("resize")
                            }
                            this.toggleState();
                            if (p = this.uiItems[0]) {
                                l = this.state == CKEDITOR.TRISTATE_OFF ? f.maximize.maximize : f.maximize.minimize;
                                p = CKEDITOR.document.getById(p._.id);
                                p.getChild(1).setHtml(l);
                                p.setAttribute("title", l);
                                p.setAttribute("href", 'javascript:void("' + l + '");')
                            }
                            if (a.mode == "wysiwyg")
                                if (k) {
                                    CKEDITOR.env.gecko && c(a);
                                    a.getSelection().selectRanges(k);
                                    (t = a.getSelection().getStartElement()) && t.scrollIntoView(true)
                                } else i.$.scrollTo(n.x, n.y);
                                else {
                                    if (k) {
                                        t.selectionStart = k[0];
                                        t.selectionEnd = k[1]
                                    }
                                    t.scrollLeft = n[0];
                                    t.scrollTop = n[1]
                                }
                            k =
                                n = null;
                            q = this.state;
                            a.fire("maximize", this.state)
                        },
                        canUndo: false
                    });
                    a.ui.addButton && a.ui.addButton("Maximize", {
                        label: f.maximize.maximize,
                        command: "maximize",
                        toolbar: "tools,10"
                    });
                    a.on("mode", function() {
                        var b = a.getCommand("maximize");
                        b.setState(b.state == CKEDITOR.TRISTATE_DISABLED ? CKEDITOR.TRISTATE_DISABLED : q)
                    }, null, null, 100)
                }
            }
        })
    }(),
    function() {
        function a(a, e, c) {
            var d = CKEDITOR.cleanWord;
            if (d) c();
            else {
                a = CKEDITOR.getUrl(a.config.pasteFromWordCleanupFile || e + "filter/default.js");
                CKEDITOR.scriptLoader.load(a,
                    c, null, true)
            }
            return !d
        }

        function e(a) {
            a.data.type = "html"
        }
        CKEDITOR.plugins.add("pastefromword", {
            requires: "clipboard",
            init: function(b) {
                var g = 0,
                    c = this.path;
                b.addCommand("pastefromword", {
                    canUndo: false,
                    async: true,
                    exec: function(a) {
                        var b = this;
                        g = 1;
                        a.once("beforePaste", e);
                        a.getClipboardData({
                            title: a.lang.pastefromword.title
                        }, function(c) {
                            c && a.fire("paste", {
                                type: "html",
                                dataValue: c.dataValue
                            });
                            a.fire("afterCommandExec", {
                                name: "pastefromword",
                                command: b,
                                returnValue: !! c
                            })
                        })
                    }
                });
                b.ui.addButton && b.ui.addButton("PasteFromWord", {
                    label: b.lang.pastefromword.toolbar,
                    command: "pastefromword",
                    toolbar: "clipboard,50"
                });
                b.on("pasteState", function(a) {
                    b.getCommand("pastefromword").setState(a.data)
                });
                b.on("paste", function(d) {
                    var e = d.data,
                        f = e.dataValue;
                    if (f && (g || /(class=\"?Mso|style=\"[^\"]*\bmso\-|w:WordDocument)/.test(f))) {
                        var h = a(b, c, function() {
                            if (h) b.fire("paste", e);
                            else if (!b.config.pasteFromWordPromptCleanup || g || confirm(b.lang.pastefromword.confirmCleanup)) e.dataValue = CKEDITOR.cleanWord(f, b);
                            g = 0
                        });
                        h && d.cancel()
                    }
                }, null, null, 3)
            }
        })
    }(),
    function() {
        var a = {
            canUndo: false,
            async: true,
            exec: function(e) {
                e.getClipboardData({
                    title: e.lang.pastetext.title
                }, function(b) {
                    b && e.fire("paste", {
                        type: "text",
                        dataValue: b.dataValue
                    });
                    e.fire("afterCommandExec", {
                        name: "pastetext",
                        command: a,
                        returnValue: !! b
                    })
                })
            }
        };
        CKEDITOR.plugins.add("pastetext", {
            requires: "clipboard",
            init: function(e) {
                e.addCommand("pastetext", a);
                e.ui.addButton && e.ui.addButton("PasteText", {
                    label: e.lang.pastetext.button,
                    command: "pastetext",
                    toolbar: "clipboard,40"
                });
                if (e.config.forcePasteAsPlainText) e.on("beforePaste",
                    function(a) {
                        if (a.data.type != "html") a.data.type = "text"
                    });
                e.on("pasteState", function(a) {
                    e.getCommand("pastetext").setState(a.data)
                })
            }
        })
    }(), CKEDITOR.plugins.add("removeformat", {
        init: function(a) {
            a.addCommand("removeFormat", CKEDITOR.plugins.removeformat.commands.removeformat);
            a.ui.addButton && a.ui.addButton("RemoveFormat", {
                label: a.lang.removeformat.toolbar,
                command: "removeFormat",
                toolbar: "cleanup,10"
            })
        }
    }), CKEDITOR.plugins.removeformat = {
        commands: {
            removeformat: {
                exec: function(a) {
                    for (var e = a._.removeFormatRegex ||
                        (a._.removeFormatRegex = RegExp("^(?:" + a.config.removeFormatTags.replace(/,/g, "|") + ")$", "i")), b = a._.removeAttributes || (a._.removeAttributes = a.config.removeFormatAttributes.split(",")), g = CKEDITOR.plugins.removeformat.filter, c = a.getSelection().getRanges(), d = c.createIterator(), j = function(a) {
                                return a.type == CKEDITOR.NODE_ELEMENT
                            }, f; f = d.getNextRange();) {
                        f.collapsed || f.enlarge(CKEDITOR.ENLARGE_ELEMENT);
                        var h = f.createBookmark(),
                            i = h.startNode,
                            k = h.endNode,
                            n = function(b) {
                                for (var c = a.elementPath(b), d = c.elements,
                                        f = 1, h; h = d[f]; f++) {
                                    if (h.equals(c.block) || h.equals(c.blockLimit)) break;
                                    e.test(h.getName()) && g(a, h) && b.breakParent(h)
                                }
                            };
                        n(i);
                        if (k) {
                            n(k);
                            for (i = i.getNextSourceNode(true, CKEDITOR.NODE_ELEMENT); i;) {
                                if (i.equals(k)) break;
                                if (i.isReadOnly()) {
                                    if (i.getPosition(k) & CKEDITOR.POSITION_CONTAINS) break;
                                    i = i.getNext(j)
                                } else {
                                    n = i.getNextSourceNode(false, CKEDITOR.NODE_ELEMENT);
                                    if (!(i.getName() == "img" && i.data("cke-realelement")) && g(a, i))
                                        if (e.test(i.getName())) i.remove(1);
                                        else {
                                            i.removeAttributes(b);
                                            a.fire("removeFormatCleanup",
                                                i)
                                        }
                                    i = n
                                }
                            }
                        }
                        f.moveToBookmark(h)
                    }
                    a.forceNextSelectionCheck();
                    a.getSelection().selectRanges(c)
                }
            }
        },
        filter: function(a, e) {
            for (var b = a._.removeFormatFilters || [], g = 0; g < b.length; g++)
                if (b[g](e) === false) return false;
            return true
        }
    }, CKEDITOR.editor.prototype.addRemoveFormatFilter = function(a) {
        if (!this._.removeFormatFilters) this._.removeFormatFilters = [];
        this._.removeFormatFilters.push(a)
    }, CKEDITOR.config.removeFormatTags = "b,big,cite,code,del,dfn,em,font,i,ins,kbd,q,s,samp,small,span,strike,strong,sub,sup,tt,u,var",
    CKEDITOR.config.removeFormatAttributes = "class,style,lang,width,height,align,hspace,valign", CKEDITOR.plugins.add("resize", {
        init: function(a) {
            var e, b, g, c;

            function d(d) {
                var h = e,
                    j = b,
                    k = h + (d.data.$.screenX - g) * (i == "rtl" ? -1 : 1),
                    d = j + (d.data.$.screenY - c);
                n && (h = Math.max(f.resize_minWidth, Math.min(k, f.resize_maxWidth)));
                o && (j = Math.max(f.resize_minHeight, Math.min(d, f.resize_maxHeight)));
                a.resize(n ? h : null, j)
            }

            function j() {
                CKEDITOR.document.removeListener("mousemove", d);
                CKEDITOR.document.removeListener("mouseup", j);
                if (a.document) {
                    a.document.removeListener("mousemove", d);
                    a.document.removeListener("mouseup", j)
                }
            }
            var f = a.config,
                h = a.ui.spaceId("resizer"),
                i = a.element ? a.element.getDirection(1) : "ltr";
            !f.resize_dir && (f.resize_dir = "vertical");
            f.resize_maxWidth === void 0 && (f.resize_maxWidth = 3E3);
            f.resize_maxHeight === void 0 && (f.resize_maxHeight = 3E3);
            f.resize_minWidth === void 0 && (f.resize_minWidth = 750);
            f.resize_minHeight === void 0 && (f.resize_minHeight = 250);
            if (f.resize_enabled !== false) {
                var k = null,
                    n = (f.resize_dir == "both" || f.resize_dir ==
                        "horizontal") && f.resize_minWidth != f.resize_maxWidth,
                    o = (f.resize_dir == "both" || f.resize_dir == "vertical") && f.resize_minHeight != f.resize_maxHeight,
                    q = CKEDITOR.tools.addFunction(function(h) {
                        k || (k = a.getResizable());
                        e = k.$.offsetWidth || 0;
                        b = k.$.offsetHeight || 0;
                        g = h.screenX;
                        c = h.screenY;
                        f.resize_minWidth > e && (f.resize_minWidth = e);
                        f.resize_minHeight > b && (f.resize_minHeight = b);
                        CKEDITOR.document.on("mousemove", d);
                        CKEDITOR.document.on("mouseup", j);
                        if (a.document) {
                            a.document.on("mousemove", d);
                            a.document.on("mouseup",
                                j)
                        }
                        h.preventDefault && h.preventDefault()
                    });
                a.on("destroy", function() {
                    CKEDITOR.tools.removeFunction(q)
                });
                a.on("uiSpace", function(b) {
                    if (b.data.space == "bottom") {
                        var c = "";
                        n && !o && (c = " cke_resizer_horizontal");
                        !n && o && (c = " cke_resizer_vertical");
                        var d = '<span id="' + h + '" class="cke_resizer' + c + " cke_resizer_" + i + '" title="' + CKEDITOR.tools.htmlEncode(a.lang.common.resize) + '" onmousedown="CKEDITOR.tools.callFunction(' + q + ', event)">' + (i == "ltr" ? "◢" : "◣") + "</span>";
                        i == "ltr" && c == "ltr" ? b.data.html = b.data.html + d : b.data.html =
                            d + b.data.html
                    }
                }, a, null, 100);
                a.on("maximize", function(b) {
                    a.ui.space("resizer")[b.data == CKEDITOR.TRISTATE_ON ? "hide" : "show"]()
                })
            }
        }
    }), CKEDITOR.plugins.add("menubutton", {
        requires: "button,menu",
        onLoad: function() {
            var a = function(a) {
                var b = this._,
                    g = b.menu;
                if (b.state !== CKEDITOR.TRISTATE_DISABLED)
                    if (b.on && g) g.hide();
                    else {
                        b.previousState = b.state;
                        if (!g) {
                            g = b.menu = new CKEDITOR.menu(a, {
                                panel: {
                                    className: "cke_menu_panel",
                                    attributes: {
                                        "aria-label": a.lang.common.options
                                    }
                                }
                            });
                            g.onHide = CKEDITOR.tools.bind(function() {
                                var c =
                                    this.command ? a.getCommand(this.command).modes : this.modes;
                                this.setState(!c || c[a.mode] ? b.previousState : CKEDITOR.TRISTATE_DISABLED);
                                b.on = 0
                            }, this);
                            this.onMenu && g.addListener(this.onMenu)
                        }
                        this.setState(CKEDITOR.TRISTATE_ON);
                        b.on = 1;
                        setTimeout(function() {
                            g.show(CKEDITOR.document.getById(b.id), 4)
                        }, 0)
                    }
            };
            CKEDITOR.ui.menuButton = CKEDITOR.tools.createClass({
                base: CKEDITOR.ui.button,
                $: function(e) {
                    delete e.panel;
                    this.base(e);
                    this.hasArrow = true;
                    this.click = a
                },
                statics: {
                    handler: {
                        create: function(a) {
                            return new CKEDITOR.ui.menuButton(a)
                        }
                    }
                }
            })
        },
        beforeInit: function(a) {
            a.ui.addHandler(CKEDITOR.UI_MENUBUTTON, CKEDITOR.ui.menuButton.handler)
        }
    }), CKEDITOR.UI_MENUBUTTON = "menubutton", "use strict", CKEDITOR.plugins.add("scayt", {
        requires: "menubutton,dialog",
        tabToOpen: null,
        dialogName: "scaytDialog",
        init: function(a) {
            var e = this,
                b = CKEDITOR.plugins.scayt;
            this.bindEvents(a);
            this.parseConfig(a);
            this.addRule(a);
            CKEDITOR.dialog.add(this.dialogName, CKEDITOR.getUrl(this.path + "dialogs/options.js"));
            this.addMenuItems(a);
            var g = a.lang.scayt,
                c = CKEDITOR.env;
            a.ui.add("Scayt",
                CKEDITOR.UI_MENUBUTTON, {
                    label: g.text_title,
                    title: a.plugins.wsc ? a.lang.wsc.title : g.text_title,
                    modes: {
                        wysiwyg: !(c.ie && (c.version < 8 || c.quirks))
                    },
                    toolbar: "spellchecker,20",
                    refresh: function() {
                        var c = a.ui.instances.Scayt.getState();
                        a.scayt && (c = b.state[a.name] ? CKEDITOR.TRISTATE_ON : CKEDITOR.TRISTATE_OFF);
                        a.fire("scaytButtonState", c)
                    },
                    onRender: function() {
                        var b = this;
                        a.on("scaytButtonState", function(a) {
                            typeof a.data !== void 0 && b.setState(a.data)
                        })
                    },
                    onMenu: function() {
                        var c = a.scayt;
                        a.getMenuItem("scaytToggle").label =
                            a.lang.scayt[c && b.state[a.name] ? "btn_disable" : "btn_enable"];
                        c = {
                            scaytToggle: CKEDITOR.TRISTATE_OFF,
                            scaytOptions: c ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED,
                            scaytLangs: c ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED,
                            scaytDict: c ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED,
                            scaytAbout: c ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED,
                            WSC: a.plugins.wsc ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED
                        };
                        a.config.scayt_uiTabs[0] || delete c.scaytOptions;
                        a.config.scayt_uiTabs[1] || delete c.scaytLangs;
                        a.config.scayt_uiTabs[2] || delete c.scaytDict;
                        return c
                    }
                });
            if (a.contextMenu && a.addMenuItems) {
                a.contextMenu.addListener(function() {
                    var b = a.scayt,
                        c;
                    if (b) {
                        var f = b.getSelectionNode();
                        if (f = f ? f.getAttribute(b.getNodeAttribute()) : f) {
                            c = e.menuGenerator(a, f, e);
                            b.showBanner("." + a.contextMenu._.definition.panel.className.split(" ").join(" ."))
                        }
                    }
                    return c
                });
                a.contextMenu._.onHide = CKEDITOR.tools.override(a.contextMenu._.onHide, function(b) {
                    return function() {
                        var c = a.scayt;
                        c && c.hideBanner();
                        return b.apply(this)
                    }
                })
            }
        },
        addMenuItems: function(a) {
            var e = this,
                b = CKEDITOR.plugins.scayt;
            a.addMenuGroup("scaytButton");
            var g = a.config.scayt_contextMenuItemsOrder.split("|");
            if (g && g.length)
                for (var c = 0; c < g.length; c++) a.addMenuGroup("scayt_" + g[c], c - 10);
            g = {
                scaytToggle: {
                    label: a.lang.scayt.btn_enable,
                    group: "scaytButton",
                    onClick: function() {
                        var c = a.scayt;
                        b.state[a.name] = !b.state[a.name];
                        b.state[a.name] === true ? c || b.createScayt(a) : c && b.destroy(a)
                    }
                },
                scaytAbout: {
                    label: a.lang.scayt.btn_about,
                    group: "scaytButton",
                    onClick: function() {
                        a.scayt.tabToOpen =
                            "about";
                        a.lockSelection();
                        a.openDialog(e.dialogName)
                    }
                },
                scaytOptions: {
                    label: a.lang.scayt.btn_options,
                    group: "scaytButton",
                    onClick: function() {
                        a.scayt.tabToOpen = "options";
                        a.lockSelection();
                        a.openDialog(e.dialogName)
                    }
                },
                scaytLangs: {
                    label: a.lang.scayt.btn_langs,
                    group: "scaytButton",
                    onClick: function() {
                        a.scayt.tabToOpen = "langs";
                        a.lockSelection();
                        a.openDialog(e.dialogName)
                    }
                },
                scaytDict: {
                    label: a.lang.scayt.btn_dictionaries,
                    group: "scaytButton",
                    onClick: function() {
                        a.scayt.tabToOpen = "dictionaries";
                        a.lockSelection();
                        a.openDialog(e.dialogName)
                    }
                }
            };
            if (a.plugins.wsc) g.WSC = {
                label: a.lang.wsc.toolbar,
                group: "scaytButton",
                onClick: function() {
                    var b = CKEDITOR.plugins.scayt,
                        c = a.scayt,
                        f = a.elementMode == CKEDITOR.ELEMENT_MODE_INLINE ? a.container.getText() : a.document.getBody().getText();
                    if (f = f.replace(/\s/g, "")) {
                        c && (b.state[a.name] && c.setMarkupPaused) && c.setMarkupPaused(true);
                        a.lockSelection();
                        a.execCommand("checkspell")
                    } else alert("Nothing to check!")
                }
            };
            a.addMenuItems(g)
        },
        bindEvents: function(a) {
            function e() {
                var b = a.scayt;
                if (b) {
                    b.removeMarkupInSelectionNode();
                    b.fire("startSpellCheck")
                }
            }
            var b = CKEDITOR.plugins.scayt,
                g = a.elementMode == CKEDITOR.ELEMENT_MODE_INLINE;
            CKEDITOR.on("dialogDefinition", function(a) {
                if (a.data.name === "scaytDialog") a.data.definition.dialog.on("cancel", function() {
                    return false
                }, this, null, -1)
            });
            var c = function() {
                a.scayt && b.destroy(a)
            }, d = function() {
                    b.state[a.name] && !a.readOnly && b.createScayt(a)
                }, j = function() {
                    var b = a.editable();
                    b.attachListener(b, "focus", function() {
                        var b = CKEDITOR.plugins.scayt && CKEDITOR.plugins.scayt.state[a.name] && a.scayt,
                            c, d;
                        if ((g || b) && a._.savedSelection)
                            for (var b = a._.savedSelection.getSelectedElement(), b = !b && a._.savedSelection.getRanges(), f = 0; f < b.length; f++) {
                                d = b[f];
                                c = d.startContainer.getText().length;
                                (c < d.startOffset || c < d.endOffset) && a.unlockSelection(false)
                            }
                    }, this, null, -10)
                }, f = function() {
                    if (g) {
                        a.on("blur", c);
                        a.on("focus", d);
                        a.focusManager.hasFocus && d()
                    } else d();
                    j()
                };
            a.on("contentDom", f);
            a.on("beforeCommandExec", function(c) {
                var d;
                if (c.data.name in b.options.disablingCommandExec && a.mode == "wysiwyg") {
                    if (d = a.scayt) {
                        b.destroy(a);
                        a.fire("scaytButtonState", CKEDITOR.TRISTATE_DISABLED)
                    }
                } else if (c.data.name === "bold" || c.data.name === "italic" || c.data.name === "underline" || c.data.name === "strike" || c.data.name === "subscript" || c.data.name === "superscript")
                    if (d = a.scayt) {
                        d.removeMarkupInSelectionNode();
                        setTimeout(function() {
                            d.fire("startSpellCheck")
                        }, 0)
                    }
            });
            a.on("beforeSetMode", function(c) {
                if (c.data == "source") {
                    if (c = a.scayt) {
                        b.destroy(a);
                        a.fire("scaytButtonState", CKEDITOR.TRISTATE_DISABLED)
                    }
                    if (a.document) {
                        a.document.getBody().removeAttribute("_jquid");
                        a.document.getBody().removeAttribute("dir")
                    }
                }
            });
            a.on("afterCommandExec", function(b) {
                var c;
                if (a.mode == "wysiwyg" && (b.data.name == "undo" || b.data.name == "redo"))(c = a.scayt) && setTimeout(function() {
                    c.fire("startSpellCheck")
                }, 250)
            });
            a.on("readOnly", function(c) {
                var d;
                if (c) {
                    d = a.scayt;
                    if (c.editor.readOnly === true) d && d.fire("removeMarkupInDocument", {});
                    else if (d) d.fire("startSpellCheck");
                    else if (c.editor.mode == "wysiwyg" && b.state[c.editor.name] === true) {
                        b.createScayt(a);
                        c.editor.fire("scaytButtonState", CKEDITOR.TRISTATE_ON)
                    }
                }
            });
            a.on("beforeDestroy", c);
            a.on("setData", function() {
                c();
                a.elementMode == CKEDITOR.ELEMENT_MODE_INLINE && f()
            }, this, null, 50);
            a.on("insertElement", function() {
                CKEDITOR.env.ie ? setTimeout(function() {
                    e()
                }, 50) : e()
            }, this, null, 50);
            a.on("insertHtml", function() {
                e()
            }, this, null, 50);
            a.on("insertText", function() {
                e()
            }, this, null, 50);
            a.on("scaytDialogShown", function(b) {
                b.data.selectPage(a.scayt.tabToOpen)
            })
        },
        parseConfig: function(a) {
            var e = CKEDITOR.plugins.scayt;
            e.replaceOldOptionsNames(a.config);
            if (typeof a.config.scayt_autoStartup !==
                "boolean") a.config.scayt_autoStartup = false;
            e.state[a.name] = a.config.scayt_autoStartup;
            if (!a.config.scayt_contextCommands) a.config.scayt_contextCommands = "ignore|ignoreall|add";
            if (!a.config.scayt_contextMenuItemsOrder) a.config.scayt_contextMenuItemsOrder = "suggest|moresuggest|control";
            if (!a.config.scayt_sLang) a.config.scayt_sLang = "en_US";
            if (a.config.scayt_maxSuggestions === void 0 || typeof a.config.scayt_maxSuggestions != "number" || a.config.scayt_maxSuggestions < 0) a.config.scayt_maxSuggestions = 5;
            if (a.config.scayt_customDictionaryIds ===
                void 0 || typeof a.config.scayt_customDictionaryIds !== "string") a.config.scayt_customDictionaryIds = "";
            if (a.config.scayt_userDictionaryName === void 0 || typeof a.config.scayt_userDictionaryName !== "string") a.config.scayt_userDictionaryName = null;
            if (typeof a.config.scayt_uiTabs === "string" && a.config.scayt_uiTabs.split(",").length === 3) {
                var b = [],
                    g = [];
                a.config.scayt_uiTabs = a.config.scayt_uiTabs.split(",");
                CKEDITOR.tools.search(a.config.scayt_uiTabs, function(a) {
                    if (Number(a) === 1 || Number(a) === 0) {
                        g.push(true);
                        b.push(Number(a))
                    } else g.push(false)
                });
                a.config.scayt_uiTabs = CKEDITOR.tools.search(g, false) === null ? b : [1, 1, 1]
            } else a.config.scayt_uiTabs = [1, 1, 1]; if (typeof a.config.scayt_serviceProtocol != "string") a.config.scayt_serviceProtocol = null;
            if (typeof a.config.scayt_serviceHost != "string") a.config.scayt_serviceHost = null;
            if (typeof a.config.scayt_servicePort != "string") a.config.scayt_servicePort = null;
            if (typeof a.config.scayt_servicePath != "string") a.config.scayt_servicePath = null;
            if (!a.config.scayt_moreSuggestions) a.config.scayt_moreSuggestions = "on";
            if (typeof a.config.scayt_customerId !==
                "string") a.config.scayt_customerId = "1:WvF0D4-UtPqN1-43nkD4-NKvUm2-daQqk3-LmNiI-z7Ysb4-mwry24-T8YrS3-Q2tpq2";
            if (typeof a.config.scayt_srcUrl !== "string") {
                e = document.location.protocol;
                e = e.search(/https?:/) != -1 ? e : "http:";
                a.config.scayt_srcUrl = e + "//svc.webspellchecker.net/spellcheck31/lf/scayt3/ckscayt/ckscayt.js"
            }
            if (typeof CKEDITOR.config.scayt_handleCheckDirty !== "boolean") CKEDITOR.config.scayt_handleCheckDirty = true;
            if (typeof CKEDITOR.config.scayt_handleUndoRedo !== "boolean") CKEDITOR.config.scayt_handleUndoRedo =
                true;
            if (a.config.scayt_disableOptionsStorage) {
                var e = CKEDITOR.tools.isArray(a.config.scayt_disableOptionsStorage) ? a.config.scayt_disableOptionsStorage : typeof a.config.scayt_disableOptionsStorage === "string" ? [a.config.scayt_disableOptionsStorage] : void 0,
                    c = ["all", "options", "lang", "ignore-all-caps-words", "ignore-domain-names", "ignore-words-with-mixed-cases", "ignore-words-with-numbers"],
                    d = ["lang", "ignore-all-caps-words", "ignore-domain-names", "ignore-words-with-mixed-cases", "ignore-words-with-numbers"],
                    j = CKEDITOR.tools.search,
                    f = CKEDITOR.tools.indexOf;
                a.config.scayt_disableOptionsStorage = function(a) {
                    for (var b = [], e = 0; e < a.length; e++) {
                        var g = a[e],
                            o = !! j(a, "options");
                        if (!j(c, g) || o && j(d, function(a) {
                            if (a === "lang") return false
                        })) return;
                        j(d, g) && d.splice(f(d, g), 1);
                        if (g === "all" || o && j(a, "lang")) return [];
                        g === "options" && (d = ["lang"])
                    }
                    return b = b.concat(d)
                }(e)
            }
        },
        addRule: function(a) {
            var e = a.dataProcessor,
                b = e && e.htmlFilter,
                g = a._.elementsPath && a._.elementsPath.filters,
                e = e && e.dataFilter,
                c = a.addRemoveFormatFilter,
                d = function(b) {
                    var c =
                        CKEDITOR.plugins.scayt;
                    if (a.scayt && b.hasAttribute(c.options.data_attribute_name)) return false
                }, j = function(b) {
                    var c = CKEDITOR.plugins.scayt,
                        d = true;
                    a.scayt && b.hasAttribute(c.options.data_attribute_name) && (d = false);
                    return d
                };
            g && g.push(d);
            e && e.addRules({
                elements: {
                    span: function(b) {
                        var c = CKEDITOR.plugins.scayt;
                        if (c && c.state[a.name] && b.classes && CKEDITOR.tools.search(b.classes, c.options.misspelled_word_class))
                            if (b.classes && b.parent.type === CKEDITOR.NODE_DOCUMENT_FRAGMENT) {
                                delete b.attributes.style;
                                delete b.name
                            } else delete b.classes[CKEDITOR.tools.indexOf(b.classes,
                                c.options.misspelled_word_class)];
                        return b
                    }
                }
            });
            b && b.addRules({
                elements: {
                    span: function(b) {
                        var c = CKEDITOR.plugins.scayt;
                        if (c && c.state[a.name] && b.hasClass(c.options.misspelled_word_class) && b.attributes[c.options.data_attribute_name]) {
                            b.removeClass(c.options.misspelled_word_class);
                            delete b.attributes[c.options.data_attribute_name];
                            delete b.name
                        }
                        return b
                    }
                }
            });
            c && c.call(a, j)
        },
        scaytMenuDefinition: function(a) {
            var e = this,
                a = a.scayt;
            return {
                scayt_ignore: {
                    label: a.getLocal("btn_ignore"),
                    group: "scayt_control",
                    order: 1,
                    exec: function(a) {
                        a.scayt.ignoreWord()
                    }
                },
                scayt_ignoreall: {
                    label: a.getLocal("btn_ignoreAll"),
                    group: "scayt_control",
                    order: 2,
                    exec: function(a) {
                        a.scayt.ignoreAllWords()
                    }
                },
                scayt_add: {
                    label: a.getLocal("btn_addWord"),
                    group: "scayt_control",
                    order: 3,
                    exec: function(a) {
                        var e = a.scayt;
                        setTimeout(function() {
                            e.addWordToUserDictionary()
                        }, 10)
                    }
                },
                option: {
                    label: a.getLocal("btn_options"),
                    group: "scayt_control",
                    order: 4,
                    exec: function(a) {
                        a.scayt.tabToOpen = "options";
                        a.lockSelection();
                        a.openDialog(e.dialogName)
                    },
                    verification: function(a) {
                        return a.config.scayt_uiTabs[0] ==
                            1 ? true : false
                    }
                },
                language: {
                    label: a.getLocal("btn_langs"),
                    group: "scayt_control",
                    order: 5,
                    exec: function(a) {
                        a.scayt.tabToOpen = "langs";
                        a.lockSelection();
                        a.openDialog(e.dialogName)
                    },
                    verification: function(a) {
                        return a.config.scayt_uiTabs[1] == 1 ? true : false
                    }
                },
                dictionary: {
                    label: a.getLocal("btn_dictionaries"),
                    group: "scayt_control",
                    order: 6,
                    exec: function(a) {
                        a.scayt.tabToOpen = "dictionaries";
                        a.lockSelection();
                        a.openDialog(e.dialogName)
                    },
                    verification: function(a) {
                        return a.config.scayt_uiTabs[2] == 1 ? true : false
                    }
                },
                about: {
                    label: a.getLocal("btn_about"),
                    group: "scayt_control",
                    order: 7,
                    exec: function(a) {
                        a.scayt.tabToOpen = "about";
                        a.lockSelection();
                        a.openDialog(e.dialogName)
                    }
                }
            }
        },
        buildSuggestionMenuItems: function(a, e) {
            var b = {}, g = {}, c = a.scayt;
            if (e.length > 0 && e[0] !== "no_any_suggestions")
                for (var d = 0; d < e.length; d++) {
                    var j = "scayt_suggest_" + CKEDITOR.plugins.scayt.suggestions[d].replace(" ", "_");
                    a.addCommand(j, this.createCommand(CKEDITOR.plugins.scayt.suggestions[d]));
                    if (d < a.config.scayt_maxSuggestions) {
                        a.addMenuItem(j, {
                            label: e[d],
                            command: j,
                            group: "scayt_suggest",
                            order: d + 1
                        });
                        b[j] = CKEDITOR.TRISTATE_OFF
                    } else {
                        a.addMenuItem(j, {
                            label: e[d],
                            command: j,
                            group: "scayt_moresuggest",
                            order: d + 1
                        });
                        g[j] = CKEDITOR.TRISTATE_OFF;
                        if (a.config.scayt_moreSuggestions === "on") {
                            a.addMenuItem("scayt_moresuggest", {
                                label: c.getLocal("btn_moreSuggestions"),
                                group: "scayt_moresuggest",
                                order: 10,
                                getItems: function() {
                                    return g
                                }
                            });
                            b.scayt_moresuggest = CKEDITOR.TRISTATE_OFF
                        }
                    }
                } else {
                    b.no_scayt_suggest = CKEDITOR.TRISTATE_DISABLED;
                    a.addCommand("no_scayt_suggest", {
                        exec: function() {}
                    });
                    a.addMenuItem("no_scayt_suggest", {
                        label: c.getLocal("btn_noSuggestions") || "no_scayt_suggest",
                        command: "no_scayt_suggest",
                        group: "scayt_suggest",
                        order: 0
                    })
                }
            return b
        },
        menuGenerator: function(a, e) {
            var b = a.scayt,
                g = this.scaytMenuDefinition(a),
                c = {}, d = a.config.scayt_contextCommands.split("|");
            b.fire("getSuggestionsList", {
                lang: b.getLang(),
                word: e
            });
            c = this.buildSuggestionMenuItems(a, CKEDITOR.plugins.scayt.suggestions);
            if (a.config.scayt_contextCommands == "off") return c;
            for (var j in g)
                if (!(CKEDITOR.tools.indexOf(d, j.replace("scayt_", "")) == -1 && a.config.scayt_contextCommands !=
                    "all")) {
                    c[j] = CKEDITOR.TRISTATE_OFF;
                    typeof g[j].verification === "function" && !g[j].verification(a) && delete c[j];
                    a.addCommand(j, {
                        exec: g[j].exec
                    });
                    a.addMenuItem(j, {
                        label: a.lang.scayt[g[j].label] || g[j].label,
                        command: j,
                        group: g[j].group,
                        order: g[j].order
                    })
                }
            return c
        },
        createCommand: function(a) {
            return {
                exec: function(e) {
                    e.scayt.replaceSelectionNode({
                        word: a
                    })
                }
            }
        }
    }), CKEDITOR.plugins.scayt = {
        state: {},
        suggestions: [],
        loadingHelper: {
            loadOrder: []
        },
        isLoading: !1,
        options: {
            disablingCommandExec: {
                source: !0,
                newpage: !0,
                templates: !0
            },
            data_attribute_name: "data-scayt-word",
            misspelled_word_class: "scayt-misspell-word"
        },
        backCompatibilityMap: {
            scayt_service_protocol: "scayt_serviceProtocol",
            scayt_service_host: "scayt_serviceHost",
            scayt_service_port: "scayt_servicePort",
            scayt_service_path: "scayt_servicePath",
            scayt_customerid: "scayt_customerId"
        },
        replaceOldOptionsNames: function(a) {
            for (var e in a)
                if (e in this.backCompatibilityMap) {
                    a[this.backCompatibilityMap[e]] = a[e];
                    delete a[e]
                }
        },
        createScayt: function(a) {
            var e = this;
            this.loadScaytLibrary(a,
                function(a) {
                    var g = {
                        lang: a.config.scayt_sLang,
                        container: a.editable().$.nodeName == "BODY" ? a.document.getWindow().$.frameElement : a.editable().$,
                        customDictionary: a.config.scayt_customDictionaryIds,
                        userDictionaryName: a.config.scayt_userDictionaryName,
                        localization: a.langCode,
                        customer_id: a.config.scayt_customerId,
                        debug: a.config.scayt_debug,
                        data_attribute_name: e.options.data_attribute_name,
                        misspelled_word_class: e.options.misspelled_word_class,
                        "options-to-restore": a.config.scayt_disableOptionsStorage,
                        focused: a.editable().hasFocus,
                        ignoreElementsRegex: a.config.scayt_elementsToIgnore
                    };
                    if (a.config.scayt_serviceProtocol) g.service_protocol = a.config.scayt_serviceProtocol;
                    if (a.config.scayt_serviceHost) g.service_host = a.config.scayt_serviceHost;
                    if (a.config.scayt_servicePort) g.service_port = a.config.scayt_servicePort;
                    if (a.config.scayt_servicePath) g.service_path = a.config.scayt_servicePath;
                    g = new SCAYT.CKSCAYT(g, function() {}, function() {});
                    g.subscribe("suggestionListSend", function(a) {
                        for (var b = {}, e = [], f = 0; f < a.suggestionList.length; f++)
                            if (!b["word_" +
                                a.suggestionList[f]]) {
                                b["word_" + a.suggestionList[f]] = a.suggestionList[f];
                                e.push(a.suggestionList[f])
                            }
                        CKEDITOR.plugins.scayt.suggestions = e
                    });
                    a.scayt = g;
                    a.fire("scaytButtonState", a.readOnly ? CKEDITOR.TRISTATE_DISABLED : CKEDITOR.TRISTATE_ON)
                })
        },
        destroy: function(a) {
            a.scayt && a.scayt.destroy();
            delete a.scayt;
            a.fire("scaytButtonState", CKEDITOR.TRISTATE_OFF)
        },
        loadScaytLibrary: function(a, e) {
            var b = this;
            if (typeof window.SCAYT === "undefined" || typeof window.SCAYT.CKSCAYT !== "function") {
                this.loadingHelper[a.name] = e;
                this.loadingHelper.loadOrder.push(a.name);
                CKEDITOR.scriptLoader.load(a.config.scayt_srcUrl, function() {
                    var a;
                    CKEDITOR.fireOnce("scaytReady");
                    for (var c = 0; c < b.loadingHelper.loadOrder.length; c++) {
                        a = b.loadingHelper.loadOrder[c];
                        if (typeof b.loadingHelper[a] === "function") b.loadingHelper[a](CKEDITOR.instances[a]);
                        delete b.loadingHelper[a]
                    }
                    b.loadingHelper.loadOrder = []
                })
            } else if (window.SCAYT && typeof window.SCAYT.CKSCAYT === "function") {
                CKEDITOR.fireOnce("scaytReady");
                a.scayt || typeof e === "function" && e(a)
            }
        }
    }, CKEDITOR.on("scaytReady",
        function() {
            if (CKEDITOR.config.scayt_handleCheckDirty === true) {
                var a = CKEDITOR.editor.prototype;
                a.checkDirty = CKEDITOR.tools.override(a.checkDirty, function(a) {
                    return function() {
                        var e = null,
                            c = this.scayt;
                        if (!CKEDITOR.plugins.scayt || !CKEDITOR.plugins.scayt.state[this.name] || !this.scayt) e = a.call(this);
                        else if (e = this.status == "ready") var d = c.removeMarkupFromString(this.getSnapshot()),
                        c = c.removeMarkupFromString(this._.previousValue), e = e && c !== d;
                        return e
                    }
                });
                a.resetDirty = CKEDITOR.tools.override(a.resetDirty, function(a) {
                    return function() {
                        var e =
                            this.scayt;
                        !CKEDITOR.plugins.scayt || !CKEDITOR.plugins.scayt.state[this.name] || !this.scayt ? a.call(this) : this._.previousValue = e.removeMarkupFromString(this.getSnapshot())
                    }
                })
            }
            if (CKEDITOR.config.scayt_handleUndoRedo === true) {
                var a = CKEDITOR.plugins.undo.Image.prototype,
                    e = typeof a.equalsContent == "function" ? "equalsContent" : "equals";
                a[e] = CKEDITOR.tools.override(a[e], function(a) {
                    return function(e) {
                        var c = e.editor.scayt,
                            d = this.contents,
                            j = e.contents,
                            f = null;
                        if (CKEDITOR.plugins.scayt && CKEDITOR.plugins.scayt.state[e.editor.name] &&
                            e.editor.scayt) {
                            this.contents = c.removeMarkupFromString(d) || "";
                            e.contents = c.removeMarkupFromString(j) || ""
                        }
                        f = a.apply(this, arguments);
                        this.contents = d;
                        e.contents = j;
                        return f
                    }
                })
            }
        }),
    function() {
        var a = {
            preserveState: true,
            editorFocus: false,
            readOnly: 1,
            exec: function(a) {
                this.toggleState();
                this.refresh(a)
            },
            refresh: function(a) {
                if (a.document) {
                    var b = this.state == CKEDITOR.TRISTATE_ON ? "attachClass" : "removeClass";
                    a.editable()[b]("cke_show_borders")
                }
            }
        };
        CKEDITOR.plugins.add("showborders", {
            modes: {
                wysiwyg: 1
            },
            onLoad: function() {
                var a;
                a = (CKEDITOR.env.ie6Compat ? [".%1 table.%2,", ".%1 table.%2 td, .%1 table.%2 th", "{", "border : #d3d3d3 1px dotted", "}"] : [".%1 table.%2,", ".%1 table.%2 > tr > td, .%1 table.%2 > tr > th,", ".%1 table.%2 > tbody > tr > td, .%1 table.%2 > tbody > tr > th,", ".%1 table.%2 > thead > tr > td, .%1 table.%2 > thead > tr > th,", ".%1 table.%2 > tfoot > tr > td, .%1 table.%2 > tfoot > tr > th", "{", "border : #d3d3d3 1px dotted", "}"]).join("").replace(/%2/g, "cke_show_border").replace(/%1/g, "cke_show_borders ");
                CKEDITOR.addCss(a)
            },
            init: function(e) {
                var b = e.addCommand("showborders", a);
                b.canUndo = false;
                e.config.startupShowBorders !== false && b.setState(CKEDITOR.TRISTATE_ON);
                e.on("mode", function() {
                    b.state != CKEDITOR.TRISTATE_DISABLED && b.refresh(e)
                }, null, null, 100);
                e.on("contentDom", function() {
                    b.state != CKEDITOR.TRISTATE_DISABLED && b.refresh(e)
                });
                e.on("removeFormatCleanup", function(a) {
                    a = a.data;
                    e.getCommand("showborders").state == CKEDITOR.TRISTATE_ON && (a.is("table") && (!a.hasAttribute("border") || parseInt(a.getAttribute("border"), 10) <= 0)) &&
                        a.addClass("cke_show_border")
                })
            },
            afterInit: function(a) {
                var b = a.dataProcessor,
                    a = b && b.dataFilter,
                    b = b && b.htmlFilter;
                a && a.addRules({
                    elements: {
                        table: function(a) {
                            var a = a.attributes,
                                b = a["class"],
                                d = parseInt(a.border, 10);
                            if ((!d || d <= 0) && (!b || b.indexOf("cke_show_border") == -1)) a["class"] = (b || "") + " cke_show_border"
                        }
                    }
                });
                b && b.addRules({
                    elements: {
                        table: function(a) {
                            var a = a.attributes,
                                b = a["class"];
                            b && (a["class"] = b.replace("cke_show_border", "").replace(/\s{2}/, " ").replace(/^\s+|\s+$/, ""))
                        }
                    }
                })
            }
        });
        CKEDITOR.on("dialogDefinition",
            function(a) {
                var b = a.data.name;
                if (b == "table" || b == "tableProperties") {
                    a = a.data.definition;
                    b = a.getContents("info").get("txtBorder");
                    b.commit = CKEDITOR.tools.override(b.commit, function(a) {
                        return function(b, d) {
                            a.apply(this, arguments);
                            var e = parseInt(this.getValue(), 10);
                            d[!e || e <= 0 ? "addClass" : "removeClass"]("cke_show_border")
                        }
                    });
                    if (a = (a = a.getContents("advanced")) && a.get("advCSSClasses")) {
                        a.setup = CKEDITOR.tools.override(a.setup, function(a) {
                            return function() {
                                a.apply(this, arguments);
                                this.setValue(this.getValue().replace(/cke_show_border/,
                                    ""))
                            }
                        });
                        a.commit = CKEDITOR.tools.override(a.commit, function(a) {
                            return function(b, d) {
                                a.apply(this, arguments);
                                parseInt(d.getAttribute("border"), 10) || d.addClass("cke_show_border")
                            }
                        })
                    }
                }
            })
    }(),
    function() {
        CKEDITOR.plugins.add("sourcearea", {
            init: function(e) {
                function b() {
                    var a = c && this.equals(CKEDITOR.document.getActive());
                    this.hide();
                    this.setStyle("height", this.getParent().$.clientHeight + "px");
                    this.setStyle("width", this.getParent().$.clientWidth + "px");
                    this.show();
                    a && this.focus()
                }
                if (e.elementMode != CKEDITOR.ELEMENT_MODE_INLINE) {
                    var g =
                        CKEDITOR.plugins.sourcearea;
                    e.addMode("source", function(c) {
                        var g = e.ui.space("contents").getDocument().createElement("textarea");
                        g.setStyles(CKEDITOR.tools.extend({
                            width: CKEDITOR.env.ie7Compat ? "99%" : "100%",
                            height: "100%",
                            resize: "none",
                            outline: "none",
                            "text-align": "left"
                        }, CKEDITOR.tools.cssVendorPrefix("tab-size", e.config.sourceAreaTabSize || 4)));
                        g.setAttribute("dir", "ltr");
                        g.addClass("cke_source cke_reset cke_enable_context_menu");
                        e.ui.space("contents").append(g);
                        g = e.editable(new a(e, g));
                        g.setData(e.getData(1));
                        if (CKEDITOR.env.ie) {
                            g.attachListener(e, "resize", b, g);
                            g.attachListener(CKEDITOR.document.getWindow(), "resize", b, g);
                            CKEDITOR.tools.setTimeout(b, 0, g)
                        }
                        e.fire("ariaWidget", this);
                        c()
                    });
                    e.addCommand("source", g.commands.source);
                    e.ui.addButton && e.ui.addButton("Source", {
                        label: e.lang.sourcearea.toolbar,
                        command: "source",
                        toolbar: "mode,10"
                    });
                    e.on("mode", function() {
                        e.getCommand("source").setState(e.mode == "source" ? CKEDITOR.TRISTATE_ON : CKEDITOR.TRISTATE_OFF)
                    });
                    var c = CKEDITOR.env.ie && CKEDITOR.env.version == 9
                }
            }
        });
        var a =
            CKEDITOR.tools.createClass({
                base: CKEDITOR.editable,
                proto: {
                    setData: function(a) {
                        this.setValue(a);
                        this.status = "ready";
                        this.editor.fire("dataReady")
                    },
                    getData: function() {
                        return this.getValue()
                    },
                    insertHtml: function() {},
                    insertElement: function() {},
                    insertText: function() {},
                    setReadOnly: function(a) {
                        this[(a ? "set" : "remove") + "Attribute"]("readOnly", "readonly")
                    },
                    detach: function() {
                        a.baseProto.detach.call(this);
                        this.clearCustomData();
                        this.remove()
                    }
                }
            })
    }(), CKEDITOR.plugins.sourcearea = {
        commands: {
            source: {
                modes: {
                    wysiwyg: 1,
                    source: 1
                },
                editorFocus: !1,
                readOnly: 1,
                exec: function(a) {
                    a.mode == "wysiwyg" && a.fire("saveSnapshot");
                    a.getCommand("source").setState(CKEDITOR.TRISTATE_DISABLED);
                    a.setMode(a.mode == "source" ? "wysiwyg" : "source")
                },
                canUndo: !1
            }
        }
    }, CKEDITOR.plugins.add("specialchar", {
        availableLangs: {
            af: 1,
            ar: 1,
            bg: 1,
            ca: 1,
            cs: 1,
            cy: 1,
            da: 1,
            de: 1,
            el: 1,
            en: 1,
            "en-gb": 1,
            eo: 1,
            es: 1,
            et: 1,
            fa: 1,
            fi: 1,
            fr: 1,
            "fr-ca": 1,
            gl: 1,
            he: 1,
            hr: 1,
            hu: 1,
            id: 1,
            it: 1,
            ja: 1,
            km: 1,
            ku: 1,
            lt: 1,
            lv: 1,
            nb: 1,
            nl: 1,
            no: 1,
            pl: 1,
            pt: 1,
            "pt-br": 1,
            ru: 1,
            si: 1,
            sk: 1,
            sl: 1,
            sq: 1,
            sv: 1,
            th: 1,
            tr: 1,
            tt: 1,
            ug: 1,
            uk: 1,
            vi: 1,
            zh: 1,
            "zh-cn": 1
        },
        requires: "dialog",
        init: function(a) {
            var e = this;
            CKEDITOR.dialog.add("specialchar", this.path + "dialogs/specialchar.js");
            a.addCommand("specialchar", {
                exec: function() {
                    var b = a.langCode,
                        b = e.availableLangs[b] ? b : e.availableLangs[b.replace(/-.*/, "")] ? b.replace(/-.*/, "") : "en";
                    CKEDITOR.scriptLoader.load(CKEDITOR.getUrl(e.path + "dialogs/lang/" + b + ".js"), function() {
                        CKEDITOR.tools.extend(a.lang.specialchar, e.langEntries[b]);
                        a.openDialog("specialchar")
                    })
                },
                modes: {
                    wysiwyg: 1
                },
                canUndo: false
            });
            a.ui.addButton && a.ui.addButton("SpecialChar", {
                label: a.lang.specialchar.toolbar,
                command: "specialchar",
                toolbar: "insert,50"
            })
        }
    }), CKEDITOR.config.specialChars = "! &quot; # $ % &amp; ' ( ) * + - . / 0 1 2 3 4 5 6 7 8 9 : ; &lt; = &gt; ? @ A B C D E F G H I J K L M N O P Q R S T U V W X Y Z [ ] ^ _ ` a b c d e f g h i j k l m n o p q r s t u v w x y z { | } ~ &euro; &lsquo; &rsquo; &ldquo; &rdquo; &ndash; &mdash; &iexcl; &cent; &pound; &curren; &yen; &brvbar; &sect; &uml; &copy; &ordf; &laquo; &not; &reg; &macr; &deg; &sup2; &sup3; &acute; &micro; &para; &middot; &cedil; &sup1; &ordm; &raquo; &frac14; &frac12; &frac34; &iquest; &Agrave; &Aacute; &Acirc; &Atilde; &Auml; &Aring; &AElig; &Ccedil; &Egrave; &Eacute; &Ecirc; &Euml; &Igrave; &Iacute; &Icirc; &Iuml; &ETH; &Ntilde; &Ograve; &Oacute; &Ocirc; &Otilde; &Ouml; &times; &Oslash; &Ugrave; &Uacute; &Ucirc; &Uuml; &Yacute; &THORN; &szlig; &agrave; &aacute; &acirc; &atilde; &auml; &aring; &aelig; &ccedil; &egrave; &eacute; &ecirc; &euml; &igrave; &iacute; &icirc; &iuml; &eth; &ntilde; &ograve; &oacute; &ocirc; &otilde; &ouml; &divide; &oslash; &ugrave; &uacute; &ucirc; &uuml; &yacute; &thorn; &yuml; &OElig; &oelig; &#372; &#374 &#373 &#375; &sbquo; &#8219; &bdquo; &hellip; &trade; &#9658; &bull; &rarr; &rArr; &hArr; &diams; &asymp;".split(" "),
    function() {
        CKEDITOR.plugins.add("stylescombo", {
            requires: "richcombo",
            init: function(a) {
                var e = a.config,
                    b = a.lang.stylescombo,
                    g = {}, c = [],
                    d = [];
                a.on("stylesSet", function(b) {
                    if (b = b.data.styles) {
                        for (var f, h, i, k = 0, n = b.length; k < n; k++) {
                            f = b[k];
                            if (!(a.blockless && f.element in CKEDITOR.dtd.$block)) {
                                h = f.name;
                                f = new CKEDITOR.style(f);
                                if (!a.filter.customConfig || a.filter.check(f)) {
                                    f._name = h;
                                    f._.enterMode = e.enterMode;
                                    f._.type = i = f.assignedTo || f.type;
                                    f._.weight = k + (i == CKEDITOR.STYLE_OBJECT ? 1 : i == CKEDITOR.STYLE_BLOCK ? 2 : 3) * 1E3;
                                    g[h] = f;
                                    c.push(f);
                                    d.push(f)
                                }
                            }
                        }
                        c.sort(function(a, b) {
                            return a._.weight - b._.weight
                        })
                    }
                });
                a.ui.addRichCombo("Styles", {
                    label: b.label,
                    title: b.panelTitle,
                    toolbar: "styles,10",
                    allowedContent: d,
                    panel: {
                        multiSelect: true,
                        attributes: {
                            "aria-label": b.panelTitle
                        }
                    },
                    init: function() {
                        var a, d, e, g, k, n;
                        k = 0;
                        for (n = c.length; k < n; k++) {
                            a = c[k];
                            d = a._name;
                            g = a._.type;
                            if (g != e) {
                                this.startGroup(b["panelTitle" + g]);
                                e = g
                            }
                            this.add(d, a.type == CKEDITOR.STYLE_OBJECT ? d : a.buildPreview(),
                                d)
                        }
                        this.commit()
                    },
                    onClick: function(b) {
                        a.focus();
                        a.fire("saveSnapshot");
                        var b = g[b],
                            c = a.elementPath();
                        a[b.checkActive(c, a) ? "removeStyle" : "applyStyle"](b);
                        a.fire("saveSnapshot")
                    },
                    onRender: function() {
                        a.on("selectionChange", function(b) {
                            for (var c = this.getValue(), b = b.data.path.elements, d = 0, e = b.length, k; d < e; d++) {
                                k = b[d];
                                for (var n in g)
                                    if (g[n].checkElementRemovable(k, true, a)) {
                                        n != c && this.setValue(n);
                                        return
                                    }
                            }
                            this.setValue("")
                        }, this)
                    },
                    onOpen: function() {
                        var c = a.getSelection().getSelectedElement(),
                            c = a.elementPath(c),
                            d = [0, 0, 0, 0];
                        this.showAll();
                        this.unmarkAll();
                        for (var e in g) {
                            var i = g[e],
                                k = i._.type;
                            i.checkApplicable(c, a, a.activeFilter) ? d[k]++ : this.hideItem(e);
                            i.checkActive(c, a) && this.mark(e)
                        }
                        d[CKEDITOR.STYLE_BLOCK] || this.hideGroup(b["panelTitle" + CKEDITOR.STYLE_BLOCK]);
                        d[CKEDITOR.STYLE_INLINE] || this.hideGroup(b["panelTitle" + CKEDITOR.STYLE_INLINE]);
                        d[CKEDITOR.STYLE_OBJECT] || this.hideGroup(b["panelTitle" + CKEDITOR.STYLE_OBJECT])
                    },
                    refresh: function() {
                        var b = a.elementPath();
                        if (b) {
                            for (var c in g)
                                if (g[c].checkApplicable(b,
                                    a, a.activeFilter)) return;
                            this.setState(CKEDITOR.TRISTATE_DISABLED)
                        }
                    },
                    reset: function() {
                        g = {};
                        c = []
                    }
                })
            }
        })
    }(),
    function() {
        function a(a) {
            return {
                editorFocus: false,
                canUndo: false,
                modes: {
                    wysiwyg: 1
                },
                exec: function(b) {
                    if (b.editable().hasFocus) {
                        var e = b.getSelection(),
                            f;
                        if (f = (new CKEDITOR.dom.elementPath(e.getCommonAncestor(), e.root)).contains({
                            td: 1,
                            th: 1
                        }, 1)) {
                            var e = b.createRange(),
                                g = CKEDITOR.tools.tryThese(function() {
                                    var b = f.getParent().$.cells[f.$.cellIndex + (a ? -1 : 1)];
                                    b.parentNode.parentNode;
                                    return b
                                }, function() {
                                    var b =
                                        f.getParent(),
                                        b = b.getAscendant("table").$.rows[b.$.rowIndex + (a ? -1 : 1)];
                                    return b.cells[a ? b.cells.length - 1 : 0]
                                });
                            if (!g && !a) {
                                for (var i = f.getAscendant("table").$, g = f.getParent().$.cells, i = new CKEDITOR.dom.element(i.insertRow(-1), b.document), k = 0, n = g.length; k < n; k++) i.append((new CKEDITOR.dom.element(g[k], b.document)).clone(false, false)).appendBogus();
                                e.moveToElementEditStart(i)
                            } else if (g) {
                                g = new CKEDITOR.dom.element(g);
                                e.moveToElementEditStart(g);
                                (!e.checkStartOfBlock() || !e.checkEndOfBlock()) && e.selectNodeContents(g)
                            } else return true;
                            e.select(true);
                            return true
                        }
                    }
                    return false
                }
            }
        }
        var e = {
            editorFocus: false,
            modes: {
                wysiwyg: 1,
                source: 1
            }
        }, b = {
                exec: function(a) {
                    a.container.focusNext(true, a.tabIndex)
                }
            }, g = {
                exec: function(a) {
                    a.container.focusPrevious(true, a.tabIndex)
                }
            };
        CKEDITOR.plugins.add("tab", {
            init: function(c) {
                for (var d = c.config.enableTabKeyTools !== false, j = c.config.tabSpaces || 0, f = ""; j--;) f = f + " ";
                if (f) c.on("key", function(a) {
                    if (a.data.keyCode == 9) {
                        c.insertText(f);
                        a.cancel()
                    }
                });
                if (d) c.on("key", function(a) {
                    (a.data.keyCode == 9 && c.execCommand("selectNextCell") ||
                        a.data.keyCode == CKEDITOR.SHIFT + 9 && c.execCommand("selectPreviousCell")) && a.cancel()
                });
                c.addCommand("blur", CKEDITOR.tools.extend(b, e));
                c.addCommand("blurBack", CKEDITOR.tools.extend(g, e));
                c.addCommand("selectNextCell", a());
                c.addCommand("selectPreviousCell", a(true))
            }
        })
    }(), CKEDITOR.dom.element.prototype.focusNext = function(a, e) {
        var b = e === void 0 ? this.getTabIndex() : e,
            g, c, d, j, f, h;
        if (b <= 0)
            for (f = this.getNextSourceNode(a, CKEDITOR.NODE_ELEMENT); f;) {
                if (f.isVisible() && f.getTabIndex() === 0) {
                    d = f;
                    break
                }
                f = f.getNextSourceNode(false,
                    CKEDITOR.NODE_ELEMENT)
            } else
                for (f = this.getDocument().getBody().getFirst(); f = f.getNextSourceNode(false, CKEDITOR.NODE_ELEMENT);) {
                    if (!g)
                        if (!c && f.equals(this)) {
                            c = true;
                            if (a) {
                                if (!(f = f.getNextSourceNode(true, CKEDITOR.NODE_ELEMENT))) break;
                                g = 1
                            }
                        } else c && !this.contains(f) && (g = 1);
                    if (f.isVisible() && !((h = f.getTabIndex()) < 0)) {
                        if (g && h == b) {
                            d = f;
                            break
                        }
                        if (h > b && (!d || !j || h < j)) {
                            d = f;
                            j = h
                        } else if (!d && h === 0) {
                            d = f;
                            j = h
                        }
                    }
                }
        d && d.focus()
    }, CKEDITOR.dom.element.prototype.focusPrevious = function(a, e) {
        for (var b = e === void 0 ? this.getTabIndex() :
            e, g, c, d, j = 0, f, h = this.getDocument().getBody().getLast(); h = h.getPreviousSourceNode(false, CKEDITOR.NODE_ELEMENT);) {
            if (!g)
                if (!c && h.equals(this)) {
                    c = true;
                    if (a) {
                        if (!(h = h.getPreviousSourceNode(true, CKEDITOR.NODE_ELEMENT))) break;
                        g = 1
                    }
                } else c && !this.contains(h) && (g = 1);
            if (h.isVisible() && !((f = h.getTabIndex()) < 0))
                if (b <= 0) {
                    if (g && f === 0) {
                        d = h;
                        break
                    }
                    if (f > j) {
                        d = h;
                        j = f
                    }
                } else {
                    if (g && f == b) {
                        d = h;
                        break
                    }
                    if (f < b && (!d || f > j)) {
                        d = h;
                        j = f
                    }
                }
        }
        d && d.focus()
    }, CKEDITOR.plugins.add("table", {
        requires: "dialog",
        init: function(a) {
            function e(a) {
                return CKEDITOR.tools.extend(a || {}, {
                    contextSensitive: 1,
                    refresh: function(a, b) {
                        this.setState(b.contains("table", 1) ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED)
                    }
                })
            }
            if (!a.blockless) {
                var b = a.lang.table;
                a.addCommand("table", new CKEDITOR.dialogCommand("table", {
                    context: "table",
                    allowedContent: "table{width,height}[align,border,cellpadding,cellspacing,summary];caption tbody thead tfoot;th td tr[scope];" + (a.plugins.dialogadvtab ? "table" + a.plugins.dialogadvtab.allowedContent() : ""),
                    requiredContent: "table",
                    contentTransformations: [
                        ["table{width}: sizeToStyle",
                            "table[width]: sizeToAttribute"
                        ]
                    ]
                }));
                a.addCommand("tableProperties", new CKEDITOR.dialogCommand("tableProperties", e()));
                a.addCommand("tableDelete", e({
                    exec: function(a) {
                        var b = a.elementPath().contains("table", 1);
                        if (b) {
                            var d = b.getParent(),
                                e = a.editable();
                            d.getChildCount() == 1 && (!d.is("td", "th") && !d.equals(e)) && (b = d);
                            a = a.createRange();
                            a.moveToPosition(b, CKEDITOR.POSITION_BEFORE_START);
                            b.remove();
                            a.select()
                        }
                    }
                }));
                a.ui.addButton && a.ui.addButton("Table", {
                    label: b.toolbar,
                    command: "table",
                    toolbar: "insert,30"
                });
                CKEDITOR.dialog.add("table", this.path + "dialogs/table.js");
                CKEDITOR.dialog.add("tableProperties", this.path + "dialogs/table.js");
                a.addMenuItems && a.addMenuItems({
                    table: {
                        label: b.menu,
                        command: "tableProperties",
                        group: "table",
                        order: 5
                    },
                    tabledelete: {
                        label: b.deleteTable,
                        command: "tableDelete",
                        group: "table",
                        order: 1
                    }
                });
                a.on("doubleclick", function(a) {
                    if (a.data.element.is("table")) a.data.dialog = "tableProperties"
                });
                a.contextMenu && a.contextMenu.addListener(function() {
                    return {
                        tabledelete: CKEDITOR.TRISTATE_OFF,
                        table: CKEDITOR.TRISTATE_OFF
                    }
                })
            }
        }
    }),
    function() {
        function a(a) {
            function b(a) {
                if (!(c.length > 0) && a.type == CKEDITOR.NODE_ELEMENT && o.test(a.getName()) && !a.getCustomData("selected_cell")) {
                    CKEDITOR.dom.element.setMarker(d, a, "selected_cell", true);
                    c.push(a)
                }
            }
            for (var a = a.getRanges(), c = [], d = {}, f = 0; f < a.length; f++) {
                var e = a[f];
                if (e.collapsed) {
                    e = e.getCommonAncestor();
                    (e = e.getAscendant("td", true) || e.getAscendant("th", true)) && c.push(e)
                } else {
                    var e = new CKEDITOR.dom.walker(e),
                        g;
                    for (e.guard = b; g = e.next();)
                        if (g.type != CKEDITOR.NODE_ELEMENT || !g.is(CKEDITOR.dtd.table))
                            if ((g =
                                g.getAscendant("td", true) || g.getAscendant("th", true)) && !g.getCustomData("selected_cell")) {
                                CKEDITOR.dom.element.setMarker(d, g, "selected_cell", true);
                                c.push(g)
                            }
                }
            }
            CKEDITOR.dom.element.clearAllMarkers(d);
            return c
        }

        function e(b, c) {
            for (var d = a(b), f = d[0], e = f.getAscendant("table"), f = f.getDocument(), g = d[0].getParent(), h = g.$.rowIndex, d = d[d.length - 1], i = d.getParent().$.rowIndex + d.$.rowSpan - 1, d = new CKEDITOR.dom.element(e.$.rows[i]), h = c ? h : i, g = c ? g : d, d = CKEDITOR.tools.buildTableMap(e), e = d[h], h = c ? d[h - 1] : d[h + 1], d = d[0].length,
                    f = f.createElement("tr"), i = 0; e[i] && i < d; i++) {
                var j;
                if (e[i].rowSpan > 1 && h && e[i] == h[i]) {
                    j = e[i];
                    j.rowSpan = j.rowSpan + 1
                } else {
                    j = (new CKEDITOR.dom.element(e[i])).clone();
                    j.removeAttribute("rowSpan");
                    j.appendBogus();
                    f.append(j);
                    j = j.$
                }
                i = i + (j.colSpan - 1)
            }
            c ? f.insertBefore(g) : f.insertAfter(g)
        }

        function b(c) {
            if (c instanceof CKEDITOR.dom.selection) {
                for (var d = a(c), f = d[0].getAscendant("table"), e = CKEDITOR.tools.buildTableMap(f), c = d[0].getParent().$.rowIndex, d = d[d.length - 1], g = d.getParent().$.rowIndex + d.$.rowSpan - 1, d = [],
                        h = c; h <= g; h++) {
                    for (var i = e[h], j = new CKEDITOR.dom.element(f.$.rows[h]), k = 0; k < i.length; k++) {
                        var n = new CKEDITOR.dom.element(i[k]),
                            o = n.getParent().$.rowIndex;
                        if (n.$.rowSpan == 1) n.remove();
                        else {
                            n.$.rowSpan = n.$.rowSpan - 1;
                            if (o == h) {
                                o = e[h + 1];
                                o[k - 1] ? n.insertAfter(new CKEDITOR.dom.element(o[k - 1])) : (new CKEDITOR.dom.element(f.$.rows[h + 1])).append(n, 1)
                            }
                        }
                        k = k + (n.$.colSpan - 1)
                    }
                    d.push(j)
                }
                e = f.$.rows;
                f = new CKEDITOR.dom.element(e[g + 1] || (c > 0 ? e[c - 1] : null) || f.$.parentNode);
                for (h = d.length; h >= 0; h--) b(d[h]);
                return f
            }
            if (c instanceof CKEDITOR.dom.element) {
                f = c.getAscendant("table");
                f.$.rows.length == 1 ? f.remove() : c.remove()
            }
            return null
        }

        function g(a, b) {
            for (var c = b ? Infinity : 0, d = 0; d < a.length; d++) {
                var f;
                f = a[d];
                for (var e = b, g = f.getParent().$.cells, h = 0, i = 0; i < g.length; i++) {
                    var j = g[i],
                        h = h + (e ? 1 : j.colSpan);
                    if (j == f.$) break
                }
                f = h - 1;
                if (b ? f < c : f > c) c = f
            }
            return c
        }

        function c(b, c) {
            for (var d = a(b), f = d[0].getAscendant("table"), e = g(d, 1), d = g(d), e = c ? e : d, h = CKEDITOR.tools.buildTableMap(f), f = [], d = [], i = h.length, j = 0; j < i; j++) {
                f.push(h[j][e]);
                d.push(c ? h[j][e - 1] : h[j][e +
                    1
                ])
            }
            for (j = 0; j < i; j++)
                if (f[j]) {
                    if (f[j].colSpan > 1 && d[j] == f[j]) {
                        e = f[j];
                        e.colSpan = e.colSpan + 1
                    } else {
                        e = (new CKEDITOR.dom.element(f[j])).clone();
                        e.removeAttribute("colSpan");
                        e.appendBogus();
                        e[c ? "insertBefore" : "insertAfter"].call(e, new CKEDITOR.dom.element(f[j]));
                        e = e.$
                    }
                    j = j + (e.rowSpan - 1)
                }
        }

        function d(a, b) {
            var c = a.getStartElement();
            if (c = c.getAscendant("td", 1) || c.getAscendant("th", 1)) {
                var d = c.clone();
                d.appendBogus();
                b ? d.insertBefore(c) : d.insertAfter(c)
            }
        }

        function j(b) {
            if (b instanceof CKEDITOR.dom.selection) {
                var b =
                    a(b),
                    c = b[0] && b[0].getAscendant("table"),
                    d;
                a: {
                    var e = 0;
                    d = b.length - 1;
                    for (var g = {}, h, i; h = b[e++];) CKEDITOR.dom.element.setMarker(g, h, "delete_cell", true);
                    for (e = 0; h = b[e++];)
                        if ((i = h.getPrevious()) && !i.getCustomData("delete_cell") || (i = h.getNext()) && !i.getCustomData("delete_cell")) {
                            CKEDITOR.dom.element.clearAllMarkers(g);
                            d = i;
                            break a
                        }
                    CKEDITOR.dom.element.clearAllMarkers(g);
                    i = b[0].getParent();
                    if (i = i.getPrevious()) d = i.getLast();
                    else {
                        i = b[d].getParent();
                        d = (i = i.getNext()) ? i.getChild(0) : null
                    }
                }
                for (i = b.length - 1; i >=
                    0; i--) j(b[i]);
                d ? f(d, true) : c && c.remove()
            } else if (b instanceof CKEDITOR.dom.element) {
                c = b.getParent();
                c.getChildCount() == 1 ? c.remove() : b.remove()
            }
        }

        function f(a, b) {
            var c = a.getDocument(),
                d = CKEDITOR.document;
            if (CKEDITOR.env.ie && CKEDITOR.env.version == 10) {
                d.focus();
                c.focus()
            }
            c = new CKEDITOR.dom.range(c);
            if (!c["moveToElementEdit" + (b ? "End" : "Start")](a)) {
                c.selectNodeContents(a);
                c.collapse(b ? false : true)
            }
            c.select(true)
        }

        function h(a, b, c) {
            a = a[b];
            if (typeof c == "undefined") return a;
            for (b = 0; a && b < a.length; b++) {
                if (c.is &&
                    a[b] == c.$) return b;
                if (b == c) return new CKEDITOR.dom.element(a[b])
            }
            return c.is ? -1 : null
        }

        function i(b, c, d) {
            var f = a(b),
                e;
            if ((c ? f.length != 1 : f.length < 2) || (e = b.getCommonAncestor()) && e.type == CKEDITOR.NODE_ELEMENT && e.is("table")) return false;
            var g, b = f[0];
            e = b.getAscendant("table");
            var i = CKEDITOR.tools.buildTableMap(e),
                j = i.length,
                k = i[0].length,
                n = b.getParent().$.rowIndex,
                o = h(i, n, b);
            if (c) {
                var y;
                try {
                    var z = parseInt(b.getAttribute("rowspan"), 10) || 1;
                    g = parseInt(b.getAttribute("colspan"), 10) || 1;
                    y = i[c == "up" ? n - z : c == "down" ?
                        n + z : n][c == "left" ? o - g : c == "right" ? o + g : o]
                } catch (B) {
                    return false
                }
                if (!y || b.$ == y) return false;
                f[c == "up" || c == "left" ? "unshift" : "push"](new CKEDITOR.dom.element(y))
            }
            for (var c = b.getDocument(), A = n, z = y = 0, G = !d && new CKEDITOR.dom.documentFragment(c), D = 0, c = 0; c < f.length; c++) {
                g = f[c];
                var J = g.getParent(),
                    C = g.getFirst(),
                    F = g.$.colSpan,
                    E = g.$.rowSpan,
                    J = J.$.rowIndex,
                    I = h(i, J, g),
                    D = D + F * E,
                    z = Math.max(z, I - o + F);
                y = Math.max(y, J - n + E);
                if (!d) {
                    F = g;
                    (E = F.getBogus()) && E.remove();
                    F.trim();
                    if (g.getChildren().count()) {
                        if (J != A && C && (!C.isBlockBoundary || !C.isBlockBoundary({
                            br: 1
                        })))(A = G.getLast(CKEDITOR.dom.walker.whitespaces(true))) && (!A.is || !A.is("br")) && G.append("br");
                        g.moveChildren(G)
                    }
                    c ? g.remove() : g.setHtml("")
                }
                A = J
            }
            if (d) return y * z == D;
            G.moveChildren(b);
            b.appendBogus();
            z >= k ? b.removeAttribute("rowSpan") : b.$.rowSpan = y;
            y >= j ? b.removeAttribute("colSpan") : b.$.colSpan = z;
            d = new CKEDITOR.dom.nodeList(e.$.rows);
            f = d.count();
            for (c = f - 1; c >= 0; c--) {
                e = d.getItem(c);
                if (!e.$.cells.length) {
                    e.remove();
                    f++
                }
            }
            return b
        }

        function k(b, c) {
            var d = a(b);
            if (d.length > 1) return false;
            if (c) return true;
            var d = d[0],
                f = d.getParent(),
                e = f.getAscendant("table"),
                g = CKEDITOR.tools.buildTableMap(e),
                i = f.$.rowIndex,
                j = h(g, i, d),
                k = d.$.rowSpan,
                n;
            if (k > 1) {
                n = Math.ceil(k / 2);
                for (var k = Math.floor(k / 2), f = i + n, e = new CKEDITOR.dom.element(e.$.rows[f]), g = h(g, f), o, f = d.clone(), i = 0; i < g.length; i++) {
                    o = g[i];
                    if (o.parentNode == e.$ && i > j) {
                        f.insertBefore(new CKEDITOR.dom.element(o));
                        break
                    } else o = null
                }
                o || e.append(f)
            } else {
                k = n = 1;
                e = f.clone();
                e.insertAfter(f);
                e.append(f = d.clone());
                o = h(g, i);
                for (j = 0; j < o.length; j++) o[j].rowSpan++
            }
            f.appendBogus();
            d.$.rowSpan = n;
            f.$.rowSpan = k;
            n == 1 && d.removeAttribute("rowSpan");
            k == 1 && f.removeAttribute("rowSpan");
            return f
        }

        function n(b, c) {
            var d = a(b);
            if (d.length > 1) return false;
            if (c) return true;
            var d = d[0],
                f = d.getParent(),
                e = f.getAscendant("table"),
                e = CKEDITOR.tools.buildTableMap(e),
                g = h(e, f.$.rowIndex, d),
                i = d.$.colSpan;
            if (i > 1) {
                f = Math.ceil(i / 2);
                i = Math.floor(i / 2)
            } else {
                for (var i = f = 1, j = [], k = 0; k < e.length; k++) {
                    var n = e[k];
                    j.push(n[g]);
                    n[g].rowSpan > 1 && (k = k + (n[g].rowSpan - 1))
                }
                for (e = 0; e < j.length; e++) j[e].colSpan++
            }
            e = d.clone();
            e.insertAfter(d);
            e.appendBogus();
            d.$.colSpan = f;
            e.$.colSpan = i;
            f == 1 && d.removeAttribute("colSpan");
            i == 1 && e.removeAttribute("colSpan");
            return e
        }
        var o = /^(?:td|th)$/;
        CKEDITOR.plugins.tabletools = {
            requires: "table,dialog,contextmenu",
            init: function(g) {
                function h(a) {
                    return CKEDITOR.tools.extend(a || {}, {
                        contextSensitive: 1,
                        refresh: function(a, b) {
                            this.setState(b.contains({
                                td: 1,
                                th: 1
                            }, 1) ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED)
                        }
                    })
                }

                function l(a, b) {
                    var c = g.addCommand(a, b);
                    g.addFeature(c)
                }
                var o = g.lang.table;
                l("cellProperties", new CKEDITOR.dialogCommand("cellProperties", h({
                    allowedContent: "td th{width,height,border-color,background-color,white-space,vertical-align,text-align}[colspan,rowspan]",
                    requiredContent: "table"
                })));
                CKEDITOR.dialog.add("cellProperties", this.path + "dialogs/tableCell.js");
                l("rowDelete", h({
                    requiredContent: "table",
                    exec: function(a) {
                        a = a.getSelection();
                        f(b(a))
                    }
                }));
                l("rowInsertBefore", h({
                    requiredContent: "table",
                    exec: function(a) {
                        a = a.getSelection();
                        e(a, true)
                    }
                }));
                l("rowInsertAfter", h({
                    requiredContent: "table",
                    exec: function(a) {
                        a = a.getSelection();
                        e(a)
                    }
                }));
                l("columnDelete", h({
                    requiredContent: "table",
                    exec: function(b) {
                        for (var b = b.getSelection(), b = a(b), c = b[0], d = b[b.length - 1], b = c.getAscendant("table"), e = CKEDITOR.tools.buildTableMap(b), g, h, i = [], j = 0, k = e.length; j < k; j++)
                            for (var m = 0, l = e[j].length; m < l; m++) {
                                e[j][m] == c.$ && (g = m);
                                e[j][m] == d.$ && (h = m)
                            }
                        for (j = g; j <= h; j++)
                            for (m = 0; m < e.length; m++) {
                                d = e[m];
                                c = new CKEDITOR.dom.element(b.$.rows[m]);
                                d = new CKEDITOR.dom.element(d[j]);
                                if (d.$) {
                                    d.$.colSpan == 1 ? d.remove() : d.$.colSpan = d.$.colSpan -
                                        1;
                                    m = m + (d.$.rowSpan - 1);
                                    c.$.cells.length || i.push(c)
                                }
                            }
                        h = b.$.rows[0] && b.$.rows[0].cells;
                        g = new CKEDITOR.dom.element(h[g] || (g ? h[g - 1] : b.$.parentNode));
                        i.length == k && b.remove();
                        g && f(g, true)
                    }
                }));
                l("columnInsertBefore", h({
                    requiredContent: "table",
                    exec: function(a) {
                        a = a.getSelection();
                        c(a, true)
                    }
                }));
                l("columnInsertAfter", h({
                    requiredContent: "table",
                    exec: function(a) {
                        a = a.getSelection();
                        c(a)
                    }
                }));
                l("cellDelete", h({
                    requiredContent: "table",
                    exec: function(a) {
                        a = a.getSelection();
                        j(a)
                    }
                }));
                l("cellMerge", h({
                    allowedContent: "td[colspan,rowspan]",
                    requiredContent: "td[colspan,rowspan]",
                    exec: function(a) {
                        f(i(a.getSelection()), true)
                    }
                }));
                l("cellMergeRight", h({
                    allowedContent: "td[colspan]",
                    requiredContent: "td[colspan]",
                    exec: function(a) {
                        f(i(a.getSelection(), "right"), true)
                    }
                }));
                l("cellMergeDown", h({
                    allowedContent: "td[rowspan]",
                    requiredContent: "td[rowspan]",
                    exec: function(a) {
                        f(i(a.getSelection(), "down"), true)
                    }
                }));
                l("cellVerticalSplit", h({
                    allowedContent: "td[rowspan]",
                    requiredContent: "td[rowspan]",
                    exec: function(a) {
                        f(k(a.getSelection()))
                    }
                }));
                l("cellHorizontalSplit",
                    h({
                        allowedContent: "td[colspan]",
                        requiredContent: "td[colspan]",
                        exec: function(a) {
                            f(n(a.getSelection()))
                        }
                    }));
                l("cellInsertBefore", h({
                    requiredContent: "table",
                    exec: function(a) {
                        a = a.getSelection();
                        d(a, true)
                    }
                }));
                l("cellInsertAfter", h({
                    requiredContent: "table",
                    exec: function(a) {
                        a = a.getSelection();
                        d(a)
                    }
                }));
                g.addMenuItems && g.addMenuItems({
                    tablecell: {
                        label: o.cell.menu,
                        group: "tablecell",
                        order: 1,
                        getItems: function() {
                            var b = g.getSelection(),
                                c = a(b);
                            return {
                                tablecell_insertBefore: CKEDITOR.TRISTATE_OFF,
                                tablecell_insertAfter: CKEDITOR.TRISTATE_OFF,
                                tablecell_delete: CKEDITOR.TRISTATE_OFF,
                                tablecell_merge: i(b, null, true) ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED,
                                tablecell_merge_right: i(b, "right", true) ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED,
                                tablecell_merge_down: i(b, "down", true) ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED,
                                tablecell_split_vertical: k(b, true) ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED,
                                tablecell_split_horizontal: n(b, true) ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED,
                                tablecell_properties: c.length > 0 ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED
                            }
                        }
                    },
                    tablecell_insertBefore: {
                        label: o.cell.insertBefore,
                        group: "tablecell",
                        command: "cellInsertBefore",
                        order: 5
                    },
                    tablecell_insertAfter: {
                        label: o.cell.insertAfter,
                        group: "tablecell",
                        command: "cellInsertAfter",
                        order: 10
                    },
                    tablecell_delete: {
                        label: o.cell.deleteCell,
                        group: "tablecell",
                        command: "cellDelete",
                        order: 15
                    },
                    tablecell_merge: {
                        label: o.cell.merge,
                        group: "tablecell",
                        command: "cellMerge",
                        order: 16
                    },
                    tablecell_merge_right: {
                        label: o.cell.mergeRight,
                        group: "tablecell",
                        command: "cellMergeRight",
                        order: 17
                    },
                    tablecell_merge_down: {
                        label: o.cell.mergeDown,
                        group: "tablecell",
                        command: "cellMergeDown",
                        order: 18
                    },
                    tablecell_split_horizontal: {
                        label: o.cell.splitHorizontal,
                        group: "tablecell",
                        command: "cellHorizontalSplit",
                        order: 19
                    },
                    tablecell_split_vertical: {
                        label: o.cell.splitVertical,
                        group: "tablecell",
                        command: "cellVerticalSplit",
                        order: 20
                    },
                    tablecell_properties: {
                        label: o.cell.title,
                        group: "tablecellproperties",
                        command: "cellProperties",
                        order: 21
                    },
                    tablerow: {
                        label: o.row.menu,
                        group: "tablerow",
                        order: 1,
                        getItems: function() {
                            return {
                                tablerow_insertBefore: CKEDITOR.TRISTATE_OFF,
                                tablerow_insertAfter: CKEDITOR.TRISTATE_OFF,
                                tablerow_delete: CKEDITOR.TRISTATE_OFF
                            }
                        }
                    },
                    tablerow_insertBefore: {
                        label: o.row.insertBefore,
                        group: "tablerow",
                        command: "rowInsertBefore",
                        order: 5
                    },
                    tablerow_insertAfter: {
                        label: o.row.insertAfter,
                        group: "tablerow",
                        command: "rowInsertAfter",
                        order: 10
                    },
                    tablerow_delete: {
                        label: o.row.deleteRow,
                        group: "tablerow",
                        command: "rowDelete",
                        order: 15
                    },
                    tablecolumn: {
                        label: o.column.menu,
                        group: "tablecolumn",
                        order: 1,
                        getItems: function() {
                            return {
                                tablecolumn_insertBefore: CKEDITOR.TRISTATE_OFF,
                                tablecolumn_insertAfter: CKEDITOR.TRISTATE_OFF,
                                tablecolumn_delete: CKEDITOR.TRISTATE_OFF
                            }
                        }
                    },
                    tablecolumn_insertBefore: {
                        label: o.column.insertBefore,
                        group: "tablecolumn",
                        command: "columnInsertBefore",
                        order: 5
                    },
                    tablecolumn_insertAfter: {
                        label: o.column.insertAfter,
                        group: "tablecolumn",
                        command: "columnInsertAfter",
                        order: 10
                    },
                    tablecolumn_delete: {
                        label: o.column.deleteColumn,
                        group: "tablecolumn",
                        command: "columnDelete",
                        order: 15
                    }
                });
                g.contextMenu && g.contextMenu.addListener(function(a, b, c) {
                    return (a = c.contains({
                            td: 1,
                            th: 1
                        },
                        1)) && !a.isReadOnly() ? {
                        tablecell: CKEDITOR.TRISTATE_OFF,
                        tablerow: CKEDITOR.TRISTATE_OFF,
                        tablecolumn: CKEDITOR.TRISTATE_OFF
                    } : null
                })
            },
            getSelectedCells: a
        };
        CKEDITOR.plugins.add("tabletools", CKEDITOR.plugins.tabletools)
    }(), CKEDITOR.tools.buildTableMap = function(a) {
        for (var a = a.$.rows, e = -1, b = [], g = 0; g < a.length; g++) {
            e++;
            !b[e] && (b[e] = []);
            for (var c = -1, d = 0; d < a[g].cells.length; d++) {
                var j = a[g].cells[d];
                for (c++; b[e][c];) c++;
                for (var f = isNaN(j.colSpan) ? 1 : j.colSpan, j = isNaN(j.rowSpan) ? 1 : j.rowSpan, h = 0; h < j; h++) {
                    b[e + h] || (b[e +
                        h] = []);
                    for (var i = 0; i < f; i++) b[e + h][c + i] = a[g].cells[d]
                }
                c = c + (f - 1)
            }
        }
        return b
    },
    function() {
        function a(a) {
            function b() {
                for (var d = g(), h = CKEDITOR.tools.clone(a.config.toolbarGroups) || e(a), i = 0; i < h.length; i++) {
                    var k = h[i];
                    if (k != "/") {
                        typeof k == "string" && (k = h[i] = {
                            name: k
                        });
                        var l, p = k.groups;
                        if (p)
                            for (var t = 0; t < p.length; t++) {
                                l = p[t];
                                (l = d[l]) && f(k, l)
                            }(l = d[k.name]) && f(k, l)
                    }
                }
                return h
            }

            function g() {
                var b = {}, d, f, e;
                for (d in a.ui.items) {
                    f = a.ui.items[d];
                    e = f.toolbar || "others";
                    e = e.split(",");
                    f = e[0];
                    e = parseInt(e[1] || -1, 10);
                    b[f] ||
                        (b[f] = []);
                    b[f].push({
                        name: d,
                        order: e
                    })
                }
                for (f in b) b[f] = b[f].sort(function(a, b) {
                    return a.order == b.order ? 0 : b.order < 0 ? -1 : a.order < 0 ? 1 : a.order < b.order ? -1 : 1
                });
                return b
            }

            function f(b, d) {
                if (d.length) {
                    b.items ? b.items.push(a.ui.create("-")) : b.items = [];
                    for (var f; f = d.shift();) {
                        f = typeof f == "string" ? f : f.name;
                        if (!i || CKEDITOR.tools.indexOf(i, f) == -1)(f = a.ui.create(f)) && a.addFeature(f) && b.items.push(f)
                    }
                }
            }

            function h(a) {
                var b = [],
                    c, d, e;
                for (c = 0; c < a.length; ++c) {
                    d = a[c];
                    e = {};
                    if (d == "/") b.push(d);
                    else if (CKEDITOR.tools.isArray(d)) {
                        f(e,
                            CKEDITOR.tools.clone(d));
                        b.push(e)
                    } else if (d.items) {
                        f(e, CKEDITOR.tools.clone(d.items));
                        e.name = d.name;
                        b.push(e)
                    }
                }
                return b
            }
            var i = a.config.removeButtons,
                i = i && i.split(","),
                k = a.config.toolbar;
            typeof k == "string" && (k = a.config["toolbar_" + k]);
            return a.toolbar = k ? h(k) : b()
        }

        function e(a) {
            return a._.toolbarGroups || (a._.toolbarGroups = [{
                name: "document",
                groups: ["mode", "document", "doctools"]
            }, {
                name: "clipboard",
                groups: ["clipboard", "undo"]
            }, {
                name: "editing",
                groups: ["find", "selection", "spellchecker"]
            }, {
                name: "forms"
            }, "/", {
                name: "basicstyles",
                groups: ["basicstyles", "cleanup"]
            }, {
                name: "paragraph",
                groups: ["list", "indent", "blocks", "align", "bidi"]
            }, {
                name: "links"
            }, {
                name: "insert"
            }, "/", {
                name: "styles"
            }, {
                name: "colors"
            }, {
                name: "tools"
            }, {
                name: "others"
            }, {
                name: "about"
            }])
        }
        var b = function() {
            this.toolbars = [];
            this.focusCommandExecuted = false
        };
        b.prototype.focus = function() {
            for (var a = 0, b; b = this.toolbars[a++];)
                for (var e = 0, f; f = b.items[e++];)
                    if (f.focus) {
                        f.focus();
                        return
                    }
        };
        var g = {
            modes: {
                wysiwyg: 1,
                source: 1
            },
            readOnly: 1,
            exec: function(a) {
                if (a.toolbox) {
                    a.toolbox.focusCommandExecuted =
                        true;
                    CKEDITOR.env.ie || CKEDITOR.env.air ? setTimeout(function() {
                        a.toolbox.focus()
                    }, 100) : a.toolbox.focus()
                }
            }
        };
        CKEDITOR.plugins.add("toolbar", {
            requires: "button",
            init: function(c) {
                var d, e = function(a, b) {
                        var g, k = c.lang.dir == "rtl",
                            n = c.config.toolbarGroupCycling,
                            o = k ? 37 : 39,
                            k = k ? 39 : 37,
                            n = n === void 0 || n;
                        switch (b) {
                            case 9:
                            case CKEDITOR.SHIFT + 9:
                                for (; !g || !g.items.length;) {
                                    g = b == 9 ? (g ? g.next : a.toolbar.next) || c.toolbox.toolbars[0] : (g ? g.previous : a.toolbar.previous) || c.toolbox.toolbars[c.toolbox.toolbars.length - 1];
                                    if (g.items.length)
                                        for (a =
                                            g.items[d ? g.items.length - 1 : 0]; a && !a.focus;)(a = d ? a.previous : a.next) || (g = 0)
                                }
                                a && a.focus();
                                return false;
                            case o:
                                g = a;
                                do {
                                    g = g.next;
                                    !g && n && (g = a.toolbar.items[0])
                                } while (g && !g.focus);
                                g ? g.focus() : e(a, 9);
                                return false;
                            case 40:
                                if (a.button && a.button.hasArrow) {
                                    c.once("panelShow", function(a) {
                                        a.data._.panel._.currentBlock.onKeyDown(40)
                                    });
                                    a.execute()
                                } else e(a, b == 40 ? o : k);
                                return false;
                            case k:
                            case 38:
                                g = a;
                                do {
                                    g = g.previous;
                                    !g && n && (g = a.toolbar.items[a.toolbar.items.length - 1])
                                } while (g && !g.focus);
                                if (g) g.focus();
                                else {
                                    d = 1;
                                    e(a,
                                        CKEDITOR.SHIFT + 9);
                                    d = 0
                                }
                                return false;
                            case 27:
                                c.focus();
                                return false;
                            case 13:
                            case 32:
                                a.execute();
                                return false
                        }
                        return true
                    };
                c.on("uiSpace", function(d) {
                    if (d.data.space == c.config.toolbarLocation) {
                        d.removeListener();
                        c.toolbox = new b;
                        var g = CKEDITOR.tools.getNextId(),
                            i = ['<span id="', g, '" class="cke_voice_label">', c.lang.toolbar.toolbars, "</span>", '<span id="' + c.ui.spaceId("toolbox") + '" class="cke_toolbox" role="group" aria-labelledby="', g, '" onmousedown="return false;">'],
                            g = c.config.toolbarStartupExpanded !==
                                false,
                            k, n;
                        c.config.toolbarCanCollapse && c.elementMode != CKEDITOR.ELEMENT_MODE_INLINE && i.push('<span class="cke_toolbox_main"' + (g ? ">" : ' style="display:none">'));
                        for (var o = c.toolbox.toolbars, q = a(c), m = 0; m < q.length; m++) {
                            var l, p = 0,
                                t, s = q[m],
                                u;
                            if (s) {
                                if (k) {
                                    i.push("</span>");
                                    n = k = 0
                                }
                                if (s === "/") i.push('<span class="cke_toolbar_break"></span>');
                                else {
                                    u = s.items || s;
                                    for (var w = 0; w < u.length; w++) {
                                        var x = u[w],
                                            v;
                                        if (x)
                                            if (x.type == CKEDITOR.UI_SEPARATOR) n = k && x;
                                            else {
                                                v = x.canGroup !== false;
                                                if (!p) {
                                                    l = CKEDITOR.tools.getNextId();
                                                    p = {
                                                        id: l,
                                                        items: []
                                                    };
                                                    t = s.name && (c.lang.toolbar.toolbarGroups[s.name] || s.name);
                                                    i.push('<span id="', l, '" class="cke_toolbar"', t ? ' aria-labelledby="' + l + '_label"' : "", ' role="toolbar">');
                                                    t && i.push('<span id="', l, '_label" class="cke_voice_label">', t, "</span>");
                                                    i.push('<span class="cke_toolbar_start"></span>');
                                                    var r = o.push(p) - 1;
                                                    if (r > 0) {
                                                        p.previous = o[r - 1];
                                                        p.previous.next = p
                                                    }
                                                }
                                                if (v) {
                                                    if (!k) {
                                                        i.push('<span class="cke_toolgroup" role="presentation">');
                                                        k = 1
                                                    }
                                                } else if (k) {
                                                    i.push("</span>");
                                                    k = 0
                                                }
                                                l = function(a) {
                                                    a = a.render(c, i);
                                                    r = p.items.push(a) -
                                                        1;
                                                    if (r > 0) {
                                                        a.previous = p.items[r - 1];
                                                        a.previous.next = a
                                                    }
                                                    a.toolbar = p;
                                                    a.onkey = e;
                                                    a.onfocus = function() {
                                                        c.toolbox.focusCommandExecuted || c.focus()
                                                    }
                                                };
                                                if (n) {
                                                    l(n);
                                                    n = 0
                                                }
                                                l(x)
                                            }
                                    }
                                    if (k) {
                                        i.push("</span>");
                                        n = k = 0
                                    }
                                    p && i.push('<span class="cke_toolbar_end"></span></span>')
                                }
                            }
                        }
                        c.config.toolbarCanCollapse && i.push("</span>");
                        if (c.config.toolbarCanCollapse && c.elementMode != CKEDITOR.ELEMENT_MODE_INLINE) {
                            var y = CKEDITOR.tools.addFunction(function() {
                                c.execCommand("toolbarCollapse")
                            });
                            c.on("destroy", function() {
                                CKEDITOR.tools.removeFunction(y)
                            });
                            c.addCommand("toolbarCollapse", {
                                readOnly: 1,
                                exec: function(a) {
                                    var b = a.ui.space("toolbar_collapser"),
                                        c = b.getPrevious(),
                                        d = a.ui.space("contents"),
                                        f = c.getParent(),
                                        e = parseInt(d.$.style.height, 10),
                                        g = f.$.offsetHeight,
                                        h = b.hasClass("cke_toolbox_collapser_min");
                                    if (h) {
                                        c.show();
                                        b.removeClass("cke_toolbox_collapser_min");
                                        b.setAttribute("title", a.lang.toolbar.toolbarCollapse)
                                    } else {
                                        c.hide();
                                        b.addClass("cke_toolbox_collapser_min");
                                        b.setAttribute("title", a.lang.toolbar.toolbarExpand)
                                    }
                                    b.getFirst().setText(h ? "▲" : "◀");
                                    d.setStyle("height", e - (f.$.offsetHeight - g) + "px");
                                    a.fire("resize")
                                },
                                modes: {
                                    wysiwyg: 1,
                                    source: 1
                                }
                            });
                            c.setKeystroke(CKEDITOR.ALT + (CKEDITOR.env.ie || CKEDITOR.env.webkit ? 189 : 109), "toolbarCollapse");
                            i.push('<a title="' + (g ? c.lang.toolbar.toolbarCollapse : c.lang.toolbar.toolbarExpand) + '" id="' + c.ui.spaceId("toolbar_collapser") + '" tabIndex="-1" class="cke_toolbox_collapser');
                            g || i.push(" cke_toolbox_collapser_min");
                            i.push('" onclick="CKEDITOR.tools.callFunction(' + y + ')">', '<span class="cke_arrow">&#9650;</span>',
                                "</a>")
                        }
                        i.push("</span>");
                        d.data.html = d.data.html + i.join("")
                    }
                });
                c.on("destroy", function() {
                    if (this.toolbox) {
                        var a, b = 0,
                            c, d, e;
                        for (a = this.toolbox.toolbars; b < a.length; b++) {
                            d = a[b].items;
                            for (c = 0; c < d.length; c++) {
                                e = d[c];
                                e.clickFn && CKEDITOR.tools.removeFunction(e.clickFn);
                                e.keyDownFn && CKEDITOR.tools.removeFunction(e.keyDownFn)
                            }
                        }
                    }
                });
                c.on("uiReady", function() {
                    var a = c.ui.space("toolbox");
                    a && c.focusManager.add(a, 1)
                });
                c.addCommand("toolbarFocus", g);
                c.setKeystroke(CKEDITOR.ALT + 121, "toolbarFocus");
                c.ui.add("-", CKEDITOR.UI_SEPARATOR, {});
                c.ui.addHandler(CKEDITOR.UI_SEPARATOR, {
                    create: function() {
                        return {
                            render: function(a, b) {
                                b.push('<span class="cke_toolbar_separator" role="separator"></span>');
                                return {}
                            }
                        }
                    }
                })
            }
        });
        CKEDITOR.ui.prototype.addToolbarGroup = function(a, b, g) {
            var f = e(this.editor),
                h = b === 0,
                i = {
                    name: a
                };
            if (g) {
                if (g = CKEDITOR.tools.search(f, function(a) {
                    return a.name == g
                })) {
                    !g.groups && (g.groups = []);
                    if (b) {
                        b = CKEDITOR.tools.indexOf(g.groups, b);
                        if (b >= 0) {
                            g.groups.splice(b + 1, 0, a);
                            return
                        }
                    }
                    h ? g.groups.splice(0, 0, a) : g.groups.push(a);
                    return
                }
                b = null
            }
            b &&
                (b = CKEDITOR.tools.indexOf(f, function(a) {
                return a.name == b
            }));
            h ? f.splice(0, 0, a) : typeof b == "number" ? f.splice(b + 1, 0, i) : f.push(a)
        }
    }(), CKEDITOR.UI_SEPARATOR = "separator", CKEDITOR.config.toolbarLocation = "top", "use strict",
    function() {
        var a = [CKEDITOR.CTRL + 90, CKEDITOR.CTRL + 89, CKEDITOR.CTRL + CKEDITOR.SHIFT + 90],
            e = {
                8: 1,
                46: 1
            };
        CKEDITOR.plugins.add("undo", {
            init: function(c) {
                function e(a) {
                    j.enabled && a.data.command.canUndo !== false && j.save()
                }

                function g() {
                    j.enabled = c.readOnly ? false : c.mode == "wysiwyg";
                    j.onChange()
                }
                var j =
                    c.undoManager = new b(c),
                    n = j.editingHandler = new d(j),
                    o = c.addCommand("undo", {
                        exec: function() {
                            if (j.undo()) {
                                c.selectionChange();
                                this.fire("afterUndo")
                            }
                        },
                        startDisabled: true,
                        canUndo: false
                    }),
                    q = c.addCommand("redo", {
                        exec: function() {
                            if (j.redo()) {
                                c.selectionChange();
                                this.fire("afterRedo")
                            }
                        },
                        startDisabled: true,
                        canUndo: false
                    });
                c.setKeystroke([
                    [a[0], "undo"],
                    [a[1], "redo"],
                    [a[2], "redo"]
                ]);
                j.onChange = function() {
                    o.setState(j.undoable() ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED);
                    q.setState(j.redoable() ? CKEDITOR.TRISTATE_OFF :
                        CKEDITOR.TRISTATE_DISABLED)
                };
                c.on("beforeCommandExec", e);
                c.on("afterCommandExec", e);
                c.on("saveSnapshot", function(a) {
                    j.save(a.data && a.data.contentOnly)
                });
                c.on("contentDom", n.attachListeners, n);
                c.on("instanceReady", function() {
                    c.fire("saveSnapshot")
                });
                c.on("beforeModeUnload", function() {
                    c.mode == "wysiwyg" && j.save(true)
                });
                c.on("mode", g);
                c.on("readOnly", g);
                if (c.ui.addButton) {
                    c.ui.addButton("Undo", {
                        label: c.lang.undo.undo,
                        command: "undo",
                        toolbar: "undo,10"
                    });
                    c.ui.addButton("Redo", {
                        label: c.lang.undo.redo,
                        command: "redo",
                        toolbar: "undo,20"
                    })
                }
                c.resetUndo = function() {
                    j.reset();
                    c.fire("saveSnapshot")
                };
                c.on("updateSnapshot", function() {
                    j.currentImage && j.update()
                });
                c.on("lockSnapshot", function(a) {
                    a = a.data;
                    j.lock(a && a.dontUpdate, a && a.forceUpdate)
                });
                c.on("unlockSnapshot", j.unlock, j)
            }
        });
        CKEDITOR.plugins.undo = {};
        var b = CKEDITOR.plugins.undo.UndoManager = function(a) {
            this.strokesRecorded = [0, 0];
            this.locked = null;
            this.previousKeyGroup = -1;
            this.limit = a.config.undoStackSize || 20;
            this.strokesLimit = 25;
            this.editor = a;
            this.reset()
        };
        b.prototype = {
            type: function(a, c) {
                var d = b.getKeyGroup(a),
                    e = this.strokesRecorded[d] + 1,
                    c = c || e >= this.strokesLimit;
                if (!this.typing) {
                    this.hasUndo = this.typing = true;
                    this.hasRedo = false;
                    this.onChange()
                }
                if (c) {
                    e = 0;
                    this.editor.fire("saveSnapshot")
                } else this.editor.fire("change");
                this.strokesRecorded[d] = e;
                this.previousKeyGroup = d
            },
            keyGroupChanged: function(a) {
                return b.getKeyGroup(a) != this.previousKeyGroup
            },
            reset: function() {
                this.snapshots = [];
                this.index = -1;
                this.currentImage = null;
                this.hasRedo = this.hasUndo = false;
                this.locked = null;
                this.resetType()
            },
            resetType: function() {
                this.strokesRecorded = [0, 0];
                this.typing = false;
                this.previousKeyGroup = -1
            },
            refreshState: function() {
                this.hasUndo = !! this.getNextImage(true);
                this.hasRedo = !! this.getNextImage(false);
                this.resetType();
                this.onChange()
            },
            save: function(a, b, c) {
                var d = this.editor;
                if (this.locked || d.status != "ready" || d.mode != "wysiwyg") return false;
                var e = d.editable();
                if (!e || e.status != "ready") return false;
                e = this.snapshots;
                b || (b = new g(d));
                if (b.contents === false) return false;
                if (this.currentImage)
                    if (b.equalsContent(this.currentImage)) {
                        if (a ||
                            b.equalsSelection(this.currentImage)) return false
                    } else c !== false && d.fire("change");
                e.splice(this.index + 1, e.length - this.index - 1);
                e.length == this.limit && e.shift();
                this.index = e.push(b) - 1;
                this.currentImage = b;
                c !== false && this.refreshState();
                return true
            },
            restoreImage: function(a) {
                var b = this.editor,
                    c;
                if (a.bookmarks) {
                    b.focus();
                    c = b.getSelection()
                }
                this.locked = {
                    level: 999
                };
                this.editor.loadSnapshot(a.contents);
                if (a.bookmarks) c.selectBookmarks(a.bookmarks);
                else if (CKEDITOR.env.ie) {
                    c = this.editor.document.getBody().$.createTextRange();
                    c.collapse(true);
                    c.select()
                }
                this.locked = null;
                this.index = a.index;
                this.currentImage = this.snapshots[this.index];
                this.update();
                this.refreshState();
                b.fire("change")
            },
            getNextImage: function(a) {
                var b = this.snapshots,
                    c = this.currentImage,
                    d;
                if (c)
                    if (a)
                        for (d = this.index - 1; d >= 0; d--) {
                            a = b[d];
                            if (!c.equalsContent(a)) {
                                a.index = d;
                                return a
                            }
                        } else
                            for (d = this.index + 1; d < b.length; d++) {
                                a = b[d];
                                if (!c.equalsContent(a)) {
                                    a.index = d;
                                    return a
                                }
                            }
                    return null
            },
            redoable: function() {
                return this.enabled && this.hasRedo
            },
            undoable: function() {
                return this.enabled &&
                    this.hasUndo
            },
            undo: function() {
                if (this.undoable()) {
                    this.save(true);
                    var a = this.getNextImage(true);
                    if (a) return this.restoreImage(a), true
                }
                return false
            },
            redo: function() {
                if (this.redoable()) {
                    this.save(true);
                    if (this.redoable()) {
                        var a = this.getNextImage(false);
                        if (a) return this.restoreImage(a), true
                    }
                }
                return false
            },
            update: function(a) {
                if (!this.locked) {
                    a || (a = new g(this.editor));
                    for (var b = this.index, c = this.snapshots; b > 0 && this.currentImage.equalsContent(c[b - 1]);) b = b - 1;
                    c.splice(b, this.index - b + 1, a);
                    this.index = b;
                    this.currentImage =
                        a
                }
            },
            updateSelection: function(a) {
                if (!this.snapshots.length) return false;
                var b = this.snapshots,
                    c = b[b.length - 1];
                if (c.equalsContent(a) && !c.equalsSelection(a)) {
                    this.currentImage = b[b.length - 1] = a;
                    return true
                }
                return false
            },
            lock: function(a, b) {
                if (this.locked) this.locked.level++;
                else if (a) this.locked = {
                    level: 1
                };
                else {
                    var c = null;
                    if (b) c = true;
                    else {
                        var d = new g(this.editor, true);
                        this.currentImage && this.currentImage.equalsContent(d) && (c = d)
                    }
                    this.locked = {
                        update: c,
                        level: 1
                    }
                }
            },
            unlock: function() {
                if (this.locked && !--this.locked.level) {
                    var a =
                        this.locked.update;
                    this.locked = null;
                    if (a === true) this.update();
                    else if (a) {
                        var b = new g(this.editor, true);
                        a.equalsContent(b) || this.update()
                    }
                }
            }
        };
        b.navigationKeyCodes = {
            37: 1,
            38: 1,
            39: 1,
            40: 1,
            36: 1,
            35: 1,
            33: 1,
            34: 1
        };
        b.keyGroups = {
            PRINTABLE: 0,
            FUNCTIONAL: 1
        };
        b.isNavigationKey = function(a) {
            return !!b.navigationKeyCodes[a]
        };
        b.getKeyGroup = function(a) {
            var c = b.keyGroups;
            return e[a] ? c.FUNCTIONAL : c.PRINTABLE
        };
        b.getOppositeKeyGroup = function(a) {
            var c = b.keyGroups;
            return a == c.FUNCTIONAL ? c.PRINTABLE : c.FUNCTIONAL
        };
        b.ieFunctionalKeysBug =
            function(a) {
                return CKEDITOR.env.ie && b.getKeyGroup(a) == b.keyGroups.FUNCTIONAL
        };
        var g = CKEDITOR.plugins.undo.Image = function(a, b) {
            this.editor = a;
            a.fire("beforeUndoImage");
            var c = a.getSnapshot();
            CKEDITOR.env.ie && c && (c = c.replace(/\s+data-cke-expando=".*?"/g, ""));
            this.contents = c;
            if (!b) this.bookmarks = (c = c && a.getSelection()) && c.createBookmarks2(true);
            a.fire("afterUndoImage")
        }, c = /\b(?:href|src|name)="[^"]*?"/gi;
        g.prototype = {
            equalsContent: function(a) {
                var b = this.contents,
                    a = a.contents;
                if (CKEDITOR.env.ie && (CKEDITOR.env.ie7Compat ||
                    CKEDITOR.env.quirks)) {
                    b = b.replace(c, "");
                    a = a.replace(c, "")
                }
                return b != a ? false : true
            },
            equalsSelection: function(a) {
                var b = this.bookmarks,
                    a = a.bookmarks;
                if (b || a) {
                    if (!b || !a || b.length != a.length) return false;
                    for (var c = 0; c < b.length; c++) {
                        var d = b[c],
                            e = a[c];
                        if (d.startOffset != e.startOffset || d.endOffset != e.endOffset || !CKEDITOR.tools.arrayCompare(d.start, e.start) || !CKEDITOR.tools.arrayCompare(d.end, e.end)) return false
                    }
                }
                return true
            }
        };
        var d = CKEDITOR.plugins.undo.NativeEditingHandler = function(a) {
            this.undoManager = a;
            this.ignoreInputEvent =
                false;
            this.keyEventsStack = new j;
            this.lastKeydownImage = null
        };
        d.prototype = {
            onKeydown: function(c) {
                var d = c.data.getKey();
                if (d !== 229)
                    if (CKEDITOR.tools.indexOf(a, c.data.getKeystroke()) > -1) c.data.preventDefault();
                    else {
                        this.keyEventsStack.cleanUp(c);
                        c = this.undoManager;
                        this.keyEventsStack.getLast(d) || this.keyEventsStack.push(d);
                        this.lastKeydownImage = new g(c.editor);
                        if (b.isNavigationKey(d) || this.undoManager.keyGroupChanged(d))
                            if (c.strokesRecorded[0] || c.strokesRecorded[1]) {
                                c.save(false, this.lastKeydownImage,
                                    false);
                                c.resetType()
                            }
                    }
            },
            onInput: function() {
                if (this.ignoreInputEvent) this.ignoreInputEvent = false;
                else {
                    var a = this.keyEventsStack.getLast();
                    a || (a = this.keyEventsStack.push(0));
                    this.keyEventsStack.increment(a.keyCode);
                    if (this.keyEventsStack.getTotalInputs() >= this.undoManager.strokesLimit) {
                        this.undoManager.type(a.keyCode, true);
                        this.keyEventsStack.resetInputs()
                    }
                }
            },
            onKeyup: function(a) {
                var c = this.undoManager,
                    a = a.data.getKey(),
                    d = this.keyEventsStack.getTotalInputs();
                this.keyEventsStack.remove(a);
                if (!b.ieFunctionalKeysBug(a) || !this.lastKeydownImage || !this.lastKeydownImage.equalsContent(new g(c.editor, true)))
                    if (d > 0) c.type(a);
                    else if (b.isNavigationKey(a)) this.onNavigationKey(true)
            },
            onNavigationKey: function(a) {
                var b = this.undoManager;
                (a || !b.save(true, null, false)) && b.updateSelection(new g(b.editor));
                b.resetType()
            },
            ignoreInputEventListener: function() {
                this.ignoreInputEvent = true
            },
            attachListeners: function() {
                var a = this.undoManager.editor,
                    c = a.editable(),
                    d = this;
                c.attachListener(c, "keydown", function(a) {
                        d.onKeydown(a);
                        if (b.ieFunctionalKeysBug(a.data.getKey())) d.onInput()
                    },
                    null, null, 999);
                c.attachListener(c, CKEDITOR.env.ie ? "keypress" : "input", d.onInput, d, null, 999);
                c.attachListener(c, "keyup", d.onKeyup, d, null, 999);
                c.attachListener(c, "paste", d.ignoreInputEventListener, d, null, 999);
                c.attachListener(c, "drop", d.ignoreInputEventListener, d, null, 999);
                c.attachListener(c.isInline() ? c : a.document.getDocumentElement(), "click", function() {
                    d.onNavigationKey()
                }, null, null, 999);
                c.attachListener(this.undoManager.editor, "blur", function() {
                    d.keyEventsStack.remove(9)
                }, null, null, 999)
            }
        };
        var j = CKEDITOR.plugins.undo.KeyEventsStack =
            function() {
                this.stack = []
        };
        j.prototype = {
            push: function(a) {
                return this.stack[this.stack.push({
                    keyCode: a,
                    inputs: 0
                }) - 1]
            },
            getLastIndex: function(a) {
                if (typeof a != "number") return this.stack.length - 1;
                for (var b = this.stack.length; b--;)
                    if (this.stack[b].keyCode == a) return b;
                return -1
            },
            getLast: function(a) {
                a = this.getLastIndex(a);
                return a != -1 ? this.stack[a] : null
            },
            increment: function(a) {
                this.getLast(a).inputs++
            },
            remove: function(a) {
                a = this.getLastIndex(a);
                a != -1 && this.stack.splice(a, 1)
            },
            resetInputs: function(a) {
                if (typeof a ==
                    "number") this.getLast(a).inputs = 0;
                else
                    for (a = this.stack.length; a--;) this.stack[a].inputs = 0
            },
            getTotalInputs: function() {
                for (var a = this.stack.length, b = 0; a--;) b = b + this.stack[a].inputs;
                return b
            },
            cleanUp: function(a) {
                a = a.data.$;
                !a.ctrlKey && !a.metaKey && this.remove(17);
                a.shiftKey || this.remove(16);
                a.altKey || this.remove(18)
            }
        }
    }(), CKEDITOR.plugins.add("wsc", {
        requires: "dialog",
        parseApi: function(a) {
            a.config.wsc_onFinish = typeof a.config.wsc_onFinish === "function" ? a.config.wsc_onFinish : function() {};
            a.config.wsc_onClose =
                typeof a.config.wsc_onClose === "function" ? a.config.wsc_onClose : function() {}
        },
        parseConfig: function(a) {
            a.config.wsc_customerId = a.config.wsc_customerId || CKEDITOR.config.wsc_customerId || "1:ua3xw1-2XyGJ3-GWruD3-6OFNT1-oXcuB1-nR6Bp4-hgQHc-EcYng3-sdRXG3-NOfFk";
            a.config.wsc_customDictionaryIds = a.config.wsc_customDictionaryIds || CKEDITOR.config.wsc_customDictionaryIds || "";
            a.config.wsc_userDictionaryName = a.config.wsc_userDictionaryName || CKEDITOR.config.wsc_userDictionaryName || "";
            a.config.wsc_customLoaderScript =
                a.config.wsc_customLoaderScript || CKEDITOR.config.wsc_customLoaderScript;
            CKEDITOR.config.wsc_cmd = a.config.wsc_cmd || CKEDITOR.config.wsc_cmd || "spell";
            CKEDITOR.config.wsc_version = "v4.3.0-26-g5bcf855";
            CKEDITOR.config.wsc_removeGlobalVariable = true
        },
        init: function(a) {
            var e = CKEDITOR.env;
            this.parseConfig(a);
            this.parseApi(a);
            a.addCommand("checkspell", new CKEDITOR.dialogCommand("checkspell")).modes = {
                wysiwyg: !CKEDITOR.env.opera && !CKEDITOR.env.air && document.domain == window.location.hostname && !(e.ie && (e.version <
                    8 || e.quirks))
            };
            typeof a.plugins.scayt == "undefined" && a.ui.addButton && a.ui.addButton("SpellChecker", {
                label: a.lang.wsc.toolbar,
                click: function(a) {
                    var e = a.elementMode == CKEDITOR.ELEMENT_MODE_INLINE ? a.container.getText() : a.document.getBody().getText();
                    (e = e.replace(/\s/g, "")) ? a.execCommand("checkspell") : alert("Nothing to check!")
                },
                toolbar: "spellchecker,10"
            });
            CKEDITOR.dialog.add("checkspell", this.path + (CKEDITOR.env.ie && CKEDITOR.env.version <= 7 ? "dialogs/wsc_ie.js" : window.postMessage ? "dialogs/wsc.js" : "dialogs/wsc_ie.js"))
        }
    }),
    function() {
        function a(a) {
            var b = this.editor,
                g = a.document,
                f = g.body,
                h = g.getElementById("cke_actscrpt");
            h && h.parentNode.removeChild(h);
            (h = g.getElementById("cke_shimscrpt")) && h.parentNode.removeChild(h);
            (h = g.getElementById("cke_basetagscrpt")) && h.parentNode.removeChild(h);
            f.contentEditable = true;
            if (CKEDITOR.env.ie) {
                f.hideFocus = true;
                f.disabled = true;
                f.removeAttribute("disabled")
            }
            delete this._.isLoadingData;
            this.$ = f;
            g = new CKEDITOR.dom.document(g);
            this.setup();
            this.fixInitialSelection();
            if (CKEDITOR.env.ie) {
                g.getDocumentElement().addClass(g.$.compatMode);
                b.config.enterMode != CKEDITOR.ENTER_P && this.attachListener(g, "selectionchange", function() {
                    var a = g.getBody(),
                        c = b.getSelection(),
                        e = c && c.getRanges()[0];
                    e && (a.getHtml().match(/^<p>(?:&nbsp;|<br>)<\/p>$/i) && e.startContainer.equals(a)) && setTimeout(function() {
                        e = b.getSelection().getRanges()[0];
                        if (!e.startContainer.equals("body")) {
                            a.getFirst().remove(1);
                            e.moveToElementEditEnd(a);
                            e.select()
                        }
                    }, 0)
                })
            }
            if (CKEDITOR.env.webkit || CKEDITOR.env.ie && CKEDITOR.env.version > 10) g.getDocumentElement().on("mousedown", function(a) {
                a.data.getTarget().is("html") &&
                    setTimeout(function() {
                        b.editable().focus()
                    })
            });
            e(b);
            try {
                b.document.$.execCommand("2D-position", false, true)
            } catch (i) {}(CKEDITOR.env.gecko || CKEDITOR.env.ie && b.document.$.compatMode == "CSS1Compat") && this.attachListener(this, "keydown", function(a) {
                var c = a.data.getKeystroke();
                if (c == 33 || c == 34)
                    if (CKEDITOR.env.ie) setTimeout(function() {
                        b.getSelection().scrollIntoView()
                    }, 0);
                    else if (b.window.$.innerHeight > this.$.offsetHeight) {
                    var e = b.createRange();
                    e[c == 33 ? "moveToElementEditStart" : "moveToElementEditEnd"](this);
                    e.select();
                    a.data.preventDefault()
                }
            });
            CKEDITOR.env.ie && this.attachListener(g, "blur", function() {
                try {
                    g.$.selection.empty()
                } catch (a) {}
            });
            CKEDITOR.env.iOS && this.attachListener(g, "touchend", function() {
                a.focus()
            });
            f = b.document.getElementsByTag("title").getItem(0);
            f.data("cke-title", f.getText());
            if (CKEDITOR.env.ie) b.document.$.title = this._.docTitle;
            CKEDITOR.tools.setTimeout(function() {
                if (this.status == "unloaded") this.status = "ready";
                b.fire("contentDom");
                if (this._.isPendingFocus) {
                    b.focus();
                    this._.isPendingFocus =
                        false
                }
                setTimeout(function() {
                    b.fire("dataReady")
                }, 0);
                CKEDITOR.env.ie && setTimeout(function() {
                    if (b.document) {
                        var a = b.document.$.body;
                        a.runtimeStyle.marginBottom = "0px";
                        a.runtimeStyle.marginBottom = ""
                    }
                }, 1E3)
            }, 0, this)
        }

        function e(a) {
            function b() {
                var d;
                a.editable().attachListener(a, "selectionChange", function() {
                    var b = a.getSelection().getSelectedElement();
                    if (b) {
                        if (d) {
                            d.detachEvent("onresizestart", e);
                            d = null
                        }
                        b.$.attachEvent("onresizestart", e);
                        d = b.$
                    }
                })
            }

            function e(a) {
                a.returnValue = false
            }
            if (CKEDITOR.env.gecko) try {
                var f =
                    a.document.$;
                f.execCommand("enableObjectResizing", false, !a.config.disableObjectResizing);
                f.execCommand("enableInlineTableEditing", false, !a.config.disableNativeTableHandles)
            } catch (g) {} else CKEDITOR.env.ie && (CKEDITOR.env.version < 11 && a.config.disableObjectResizing) && b(a)
        }

        function b() {
            var a = [];
            if (CKEDITOR.document.$.documentMode >= 8) {
                a.push("html.CSS1Compat [contenteditable=false]{min-height:0 !important}");
                var b = [],
                    e;
                for (e in CKEDITOR.dtd.$removeEmpty) b.push("html.CSS1Compat " + e + "[contenteditable=false]");
                a.push(b.join(",") + "{display:inline-block}")
            } else if (CKEDITOR.env.gecko) {
                a.push("html{height:100% !important}");
                a.push("img:-moz-broken{-moz-force-broken-image-icon:1;min-width:24px;min-height:24px}")
            }
            a.push("html{cursor:text;*cursor:auto}");
            a.push("img,input,textarea{cursor:default}");
            return a.join("\n")
        }
        CKEDITOR.plugins.add("wysiwygarea", {
            init: function(a) {
                a.config.fullPage && a.addFeature({
                    allowedContent: "html head title; style [media,type]; body (*)[id]; meta link [*]",
                    requiredContent: "body"
                });
                a.addMode("wysiwyg",
                    function(b) {
                        function e(f) {
                            f && f.removeListener();
                            a.editable(new g(a, h.$.contentWindow.document.body));
                            a.setData(a.getData(1), b)
                        }
                        var f = "document.open();" + (CKEDITOR.env.ie ? "(" + CKEDITOR.tools.fixDomain + ")();" : "") + "document.close();",
                            f = CKEDITOR.env.air ? "javascript:void(0)" : CKEDITOR.env.ie ? "javascript:void(function(){" + encodeURIComponent(f) + "}())" : "",
                            h = CKEDITOR.dom.element.createFromHtml('<iframe src="' + f + '" frameBorder="0"></iframe>');
                        h.setStyles({
                            width: "100%",
                            height: "100%"
                        });
                        h.addClass("cke_wysiwyg_frame cke_reset");
                        var i = a.ui.space("contents");
                        i.append(h);
                        if (f = CKEDITOR.env.ie || CKEDITOR.env.gecko) h.on("load", e);
                        var k = a.title,
                            n = a.fire("ariaEditorHelpLabel", {}).label;
                        if (k) {
                            CKEDITOR.env.ie && n && (k = k + (", " + n));
                            h.setAttribute("title", k)
                        }
                        if (n) {
                            var k = CKEDITOR.tools.getNextId(),
                                o = CKEDITOR.dom.element.createFromHtml('<span id="' + k + '" class="cke_voice_label">' + n + "</span>");
                            i.append(o, 1);
                            h.setAttribute("aria-describedby", k)
                        }
                        a.on("beforeModeUnload", function(a) {
                            a.removeListener();
                            o && o.remove()
                        });
                        h.setAttributes({
                            tabIndex: a.tabIndex,
                            allowTransparency: "true"
                        });
                        !f && e();
                        if (CKEDITOR.env.webkit) {
                            f = function() {
                                i.setStyle("width", "100%");
                                h.hide();
                                h.setSize("width", i.getSize("width"));
                                i.removeStyle("width");
                                h.show()
                            };
                            h.setCustomData("onResize", f);
                            CKEDITOR.document.getWindow().on("resize", f)
                        }
                        a.fire("ariaWidget", h)
                    })
            }
        });
        CKEDITOR.editor.prototype.addContentsCss = function(a) {
            var b = this.config,
                e = b.contentsCss;
            if (!CKEDITOR.tools.isArray(e)) b.contentsCss = e ? [e] : [];
            b.contentsCss.push(a)
        };
        var g = CKEDITOR.tools.createClass({
            $: function() {
                this.base.apply(this,
                    arguments);
                this._.frameLoadedHandler = CKEDITOR.tools.addFunction(function(b) {
                    CKEDITOR.tools.setTimeout(a, 0, this, b)
                }, this);
                this._.docTitle = this.getWindow().getFrame().getAttribute("title")
            },
            base: CKEDITOR.editable,
            proto: {
                setData: function(a, d) {
                    var e = this.editor;
                    if (d) {
                        this.setHtml(a);
                        this.fixInitialSelection();
                        e.fire("dataReady")
                    } else {
                        this._.isLoadingData = true;
                        e._.dataStore = {
                            id: 1
                        };
                        var f = e.config,
                            g = f.fullPage,
                            i = f.docType,
                            k = CKEDITOR.tools.buildStyleHtml(b()).replace(/<style>/, '<style data-cke-temp="1">');
                        g || (k = k + CKEDITOR.tools.buildStyleHtml(e.config.contentsCss));
                        var n = f.baseHref ? '<base href="' + f.baseHref + '" data-cke-temp="1" />' : "";
                        g && (a = a.replace(/<!DOCTYPE[^>]*>/i, function(a) {
                            e.docType = i = a;
                            return ""
                        }).replace(/<\?xml\s[^\?]*\?>/i, function(a) {
                            e.xmlDeclaration = a;
                            return ""
                        }));
                        a = e.dataProcessor.toHtml(a);
                        if (g) {
                            /<body[\s|>]/.test(a) || (a = "<body>" + a);
                            /<html[\s|>]/.test(a) || (a = "<html>" + a + "</html>");
                            /<head[\s|>]/.test(a) ? /<title[\s|>]/.test(a) || (a = a.replace(/<head[^>]*>/, "$&<title></title>")) : a = a.replace(/<html[^>]*>/,
                                "$&<head><title></title></head>");
                            n && (a = a.replace(/<head[^>]*?>/, "$&" + n));
                            a = a.replace(/<\/head\s*>/, k + "$&");
                            a = i + a
                        } else a = f.docType + '<html dir="' + f.contentsLangDirection + '" lang="' + (f.contentsLanguage || e.langCode) + '"><head><title>' + this._.docTitle + "</title>" + n + k + "</head><body" + (f.bodyId ? ' id="' + f.bodyId + '"' : "") + (f.bodyClass ? ' class="' + f.bodyClass + '"' : "") + ">" + a + "</body></html>"; if (CKEDITOR.env.gecko) {
                            a = a.replace(/<body/, '<body contenteditable="true" ');
                            CKEDITOR.env.version < 2E4 && (a = a.replace(/<body[^>]*>/,
                                "$&<\!-- cke-content-start --\>"))
                        }
                        f = '<script id="cke_actscrpt" type="text/javascript"' + (CKEDITOR.env.ie ? ' defer="defer" ' : "") + ">var wasLoaded=0;function onload(){if(!wasLoaded)window.parent.CKEDITOR.tools.callFunction(" + this._.frameLoadedHandler + ",window);wasLoaded=1;}" + (CKEDITOR.env.ie ? "onload();" : 'document.addEventListener("DOMContentLoaded", onload, false );') + "<\/script>";
                        CKEDITOR.env.ie && CKEDITOR.env.version < 9 && (f = f + '<script id="cke_shimscrpt">window.parent.CKEDITOR.tools.enableHtml5Elements(document)<\/script>');
                        n && (CKEDITOR.env.ie && CKEDITOR.env.version < 10) && (f = f + '<script id="cke_basetagscrpt">var baseTag = document.querySelector( "base" );baseTag.href = baseTag.href;<\/script>');
                        a = a.replace(/(?=\s*<\/(:?head)>)/, f);
                        this.clearCustomData();
                        this.clearListeners();
                        e.fire("contentDomUnload");
                        var o = this.getDocument();
                        try {
                            o.write(a)
                        } catch (q) {
                            setTimeout(function() {
                                o.write(a)
                            }, 0)
                        }
                    }
                },
                getData: function(a) {
                    if (a) return this.getHtml();
                    var a = this.editor,
                        b = a.config,
                        e = b.fullPage,
                        f = e && a.docType,
                        g = e && a.xmlDeclaration,
                        i = this.getDocument(),
                        e = e ? i.getDocumentElement().getOuterHtml() : i.getBody().getHtml();
                    CKEDITOR.env.gecko && b.enterMode != CKEDITOR.ENTER_BR && (e = e.replace(/<br>(?=\s*(:?$|<\/body>))/, ""));
                    e = a.dataProcessor.toDataFormat(e);
                    g && (e = g + "\n" + e);
                    f && (e = f + "\n" + e);
                    return e
                },
                focus: function() {
                    this._.isLoadingData ? this._.isPendingFocus = true : g.baseProto.focus.call(this)
                },
                detach: function() {
                    var a = this.editor,
                        b = a.document,
                        a = a.window.getFrame();
                    g.baseProto.detach.call(this);
                    this.clearCustomData();
                    b.getDocumentElement().clearCustomData();
                    a.clearCustomData();
                    CKEDITOR.tools.removeFunction(this._.frameLoadedHandler);
                    (b = a.removeCustomData("onResize")) && b.removeListener();
                    a.remove()
                }
            }
        })
    }(), CKEDITOR.config.disableObjectResizing = !1, CKEDITOR.config.disableNativeTableHandles = !0, CKEDITOR.config.disableNativeSpellChecker = !0, CKEDITOR.config.contentsCss = CKEDITOR.getUrl("contents.css"), CKEDITOR.config.plugins = "dialogui,dialog,a11yhelp,about,basicstyles,blockquote,clipboard,panel,floatpanel,menu,contextmenu,elementspath,indent,indentlist,list,enterkey,entities,popup,filebrowser,floatingspace,listblock,button,richcombo,format,horizontalrule,htmlwriter,image,fakeobjects,link,magicline,maximize,pastefromword,pastetext,removeformat,resize,menubutton,scayt,showborders,sourcearea,specialchar,stylescombo,tab,table,tabletools,toolbar,undo,wsc,wysiwygarea",
    CKEDITOR.config.skin = "moono",
    function() {
        var a = function(a, b) {
            for (var g = CKEDITOR.getUrl("plugins/" + b), a = a.split(","), c = 0; c < a.length; c++) CKEDITOR.skin.icons[a[c]] = {
                path: g,
                offset: -a[++c],
                bgsize: a[++c]
            }
        };
        // CKEDITOR.env.hidpi ? a("about,0,,bold,24,,italic,48,,strike,72,,subscript,96,,superscript,120,,underline,144,,bidiltr,168,,bidirtl,192,,blockquote,216,,copy-rtl,240,,copy,264,,cut-rtl,288,,cut,312,,paste-rtl,336,,paste,360,,codesnippet,384,,bgcolor,408,,textcolor,432,,creatediv,456,,docprops-rtl,480,,docprops,504,,find-rtl,528,,find,552,,replace,576,,flash,600,,button,624,,checkbox,648,,form,672,,hiddenfield,696,,imagebutton,720,,radio,744,,select-rtl,768,,select,792,,textarea-rtl,816,,textarea,840,,textfield-rtl,864,,textfield,888,,horizontalrule,912,,iframe,936,,image,960,,indent-rtl,984,,indent,1008,,outdent-rtl,1032,,outdent,1056,,justifyblock,1080,,justifycenter,1104,,justifyleft,1128,,justifyright,1152,,language,1176,,anchor-rtl,1200,,anchor,1224,,link,1248,,unlink,1272,,bulletedlist-rtl,1296,,bulletedlist,1320,,numberedlist-rtl,1344,,numberedlist,1368,,mathjax,1392,,maximize,1416,,newpage-rtl,1440,,newpage,1464,,pagebreak-rtl,1488,,pagebreak,1512,,pastefromword-rtl,1536,,pastefromword,1560,,pastetext-rtl,1584,,pastetext,1608,,placeholder,1632,,preview-rtl,1656,,preview,1680,,print,1704,,removeformat,1728,,save,1752,,scayt,1776,,selectall,1800,,showblocks-rtl,1824,,showblocks,1848,,smiley,1872,,source-rtl,1896,,source,1920,,sourcedialog-rtl,1944,,sourcedialog,1968,,specialchar,1992,,table,2016,,templates-rtl,2040,,templates,2064,,uicolor,2088,,redo-rtl,2112,,redo,2136,,undo-rtl,2160,,undo,2184,,simplebox,4416,auto,spellchecker,2232,",
        //     "icons_hidpi.png") : a("about,0,auto,bold,24,auto,italic,48,auto,strike,72,auto,subscript,96,auto,superscript,120,auto,underline,144,auto,bidiltr,168,auto,bidirtl,192,auto,blockquote,216,auto,copy-rtl,240,auto,copy,264,auto,cut-rtl,288,auto,cut,312,auto,paste-rtl,336,auto,paste,360,auto,codesnippet,384,auto,bgcolor,408,auto,textcolor,432,auto,creatediv,456,auto,docprops-rtl,480,auto,docprops,504,auto,find-rtl,528,auto,find,552,auto,replace,576,auto,flash,600,auto,button,624,auto,checkbox,648,auto,form,672,auto,hiddenfield,696,auto,imagebutton,720,auto,radio,744,auto,select-rtl,768,auto,select,792,auto,textarea-rtl,816,auto,textarea,840,auto,textfield-rtl,864,auto,textfield,888,auto,horizontalrule,912,auto,iframe,936,auto,image,960,auto,indent-rtl,984,auto,indent,1008,auto,outdent-rtl,1032,auto,outdent,1056,auto,justifyblock,1080,auto,justifycenter,1104,auto,justifyleft,1128,auto,justifyright,1152,auto,language,1176,auto,anchor-rtl,1200,auto,anchor,1224,auto,link,1248,auto,unlink,1272,auto,bulletedlist-rtl,1296,auto,bulletedlist,1320,auto,numberedlist-rtl,1344,auto,numberedlist,1368,auto,mathjax,1392,auto,maximize,1416,auto,newpage-rtl,1440,auto,newpage,1464,auto,pagebreak-rtl,1488,auto,pagebreak,1512,auto,pastefromword-rtl,1536,auto,pastefromword,1560,auto,pastetext-rtl,1584,auto,pastetext,1608,auto,placeholder,1632,auto,preview-rtl,1656,auto,preview,1680,auto,print,1704,auto,removeformat,1728,auto,save,1752,auto,scayt,1776,auto,selectall,1800,auto,showblocks-rtl,1824,auto,showblocks,1848,auto,smiley,1872,auto,source-rtl,1896,auto,source,1920,auto,sourcedialog-rtl,1944,auto,sourcedialog,1968,auto,specialchar,1992,auto,table,2016,auto,templates-rtl,2040,auto,templates,2064,auto,uicolor,2088,auto,redo-rtl,2112,auto,redo,2136,auto,undo-rtl,2160,auto,undo,2184,auto,simplebox,2208,auto,spellchecker,2232,auto",
        //     "icons.png")
    }()
})();


/*
 Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
 For licensing, see LICENSE.md or http://ckeditor.com/license
*/
(function(a) {
    CKEDITOR.config.jqueryOverrideVal = "undefined" == typeof CKEDITOR.config.jqueryOverrideVal ? !0 : CKEDITOR.config.jqueryOverrideVal;
    "undefined" != typeof a && (a.extend(a.fn, {
        ckeditorGet: function() {
            var a = this.eq(0).data("ckeditorInstance");
            if (!a) throw "CKEditor is not initialized yet, use ckeditor() with a callback.";
            return a
        },
        ckeditor: function(g, d) {
            if (!CKEDITOR.env.isCompatible) throw Error("The environment is incompatible.");
            if (!a.isFunction(g)) var k = d,
                d = g,
                g = k;
            var i = [],
                d = d || {};
            this.each(function() {
                var b =
                    a(this),
                    c = b.data("ckeditorInstance"),
                    f = b.data("_ckeditorInstanceLock"),
                    h = this,
                    j = new a.Deferred;
                i.push(j.promise());
                if (c && !f) g && g.apply(c, [this]), j.resolve();
                else if (f) c.once("instanceReady", function() {
                    setTimeout(function() {
                        c.element ? (c.element.$ == h && g && g.apply(c, [h]), j.resolve()) : setTimeout(arguments.callee, 100)
                    }, 0)
                }, null, null, 9999);
                else {
                    if (d.autoUpdateElement || "undefined" == typeof d.autoUpdateElement && CKEDITOR.config.autoUpdateElement) d.autoUpdateElementJquery = !0;
                    d.autoUpdateElement = !1;
                    b.data("_ckeditorInstanceLock", !0);
                    c = a(this).is("textarea") ? CKEDITOR.replace(h, d) : CKEDITOR.inline(h, d);
                    b.data("ckeditorInstance", c);
                    c.on("instanceReady", function(d) {
                        var e = d.editor;
                        setTimeout(function() {
                            if (e.element) {
                                d.removeListener();
                                e.on("dataReady", function() {
                                    b.trigger("dataReady.ckeditor", [e])
                                });
                                e.on("setData", function(a) {
                                    b.trigger("setData.ckeditor", [e, a.data])
                                });
                                e.on("getData", function(a) {
                                    b.trigger("getData.ckeditor", [e, a.data])
                                }, 999);
                                e.on("destroy", function() {
                                    b.trigger("destroy.ckeditor", [e])
                                });
                                e.on("save", function() {
                                    a(h.form).submit();
                                    return !1
                                }, null, null, 20);
                                if (e.config.autoUpdateElementJquery && b.is("textarea") && a(h.form).length) {
                                    var c = function() {
                                        b.ckeditor(function() {
                                            e.updateElement()
                                        })
                                    };
                                    a(h.form).submit(c);
                                    a(h.form).bind("form-pre-serialize", c);
                                    b.bind("destroy.ckeditor", function() {
                                        a(h.form).unbind("submit", c);
                                        a(h.form).unbind("form-pre-serialize", c)
                                    })
                                }
                                e.on("destroy", function() {
                                    b.removeData("ckeditorInstance")
                                });
                                b.removeData("_ckeditorInstanceLock");
                                b.trigger("instanceReady.ckeditor", [e]);
                                g && g.apply(e, [h]);
                                j.resolve()
                            } else setTimeout(arguments.callee,
                                100)
                        }, 0)
                    }, null, null, 9999)
                }
            });
            var f = new a.Deferred;
            this.promise = f.promise();
            a.when.apply(this, i).then(function() {
                f.resolve()
            });
            this.editor = this.eq(0).data("ckeditorInstance");
            return this
        }
    }), CKEDITOR.config.jqueryOverrideVal && (a.fn.val = CKEDITOR.tools.override(a.fn.val, function(g) {
        return function(d) {
            if (arguments.length) {
                var k = this,
                    i = [],
                    f = this.each(function() {
                        var b = a(this),
                            c = b.data("ckeditorInstance");
                        if (b.is("textarea") && c) {
                            var f = new a.Deferred;
                            c.setData(d, function() {
                                f.resolve()
                            });
                            i.push(f.promise());
                            return !0
                        }
                        return g.call(b, d)
                    });
                if (i.length) {
                    var b = new a.Deferred;
                    a.when.apply(this, i).done(function() {
                        b.resolveWith(k)
                    });
                    return b.promise()
                }
                return f
            }
            var f = a(this).eq(0),
                c = f.data("ckeditorInstance");
            return f.is("textarea") && c ? c.getData() : g.call(f)
        }
    })))
})(window.jQuery);


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(7);
module.exports = __webpack_require__(6);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.43cd7c74fa3bc3664332.js